(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea63f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea63f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kI8SP", function(module, exports) {

$parcel$export(module.exports, "register", () => $f13ecebb1f16f955$export$6503ec6e8aabbaf, (v) => $f13ecebb1f16f955$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $f13ecebb1f16f955$export$f7ad0328861e2f03, (v) => $f13ecebb1f16f955$export$f7ad0328861e2f03 = v);
var $f13ecebb1f16f955$export$6503ec6e8aabbaf;
var $f13ecebb1f16f955$export$f7ad0328861e2f03;
"use strict";
var $f13ecebb1f16f955$var$mapping = new Map();
function $f13ecebb1f16f955$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$f13ecebb1f16f955$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $f13ecebb1f16f955$var$resolve(id) {
    var resolved = $f13ecebb1f16f955$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$f13ecebb1f16f955$export$6503ec6e8aabbaf = $f13ecebb1f16f955$var$register;
$f13ecebb1f16f955$export$f7ad0328861e2f03 = $f13ecebb1f16f955$var$resolve;

});

parcelRegister("hIarR", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", () => $ce4ea6902f7a0721$export$bdfd709ae4826697, (v) => $ce4ea6902f7a0721$export$bdfd709ae4826697 = v);
var $ce4ea6902f7a0721$export$bdfd709ae4826697;
var $ce4ea6902f7a0721$export$c9e73fbda7da57b6;
var $ce4ea6902f7a0721$export$5a759dc7a1cfb72a;
"use strict";
var $ce4ea6902f7a0721$var$bundleURL = {};
function $ce4ea6902f7a0721$var$getBundleURLCached(id) {
    var value = $ce4ea6902f7a0721$var$bundleURL[id];
    if (!value) {
        value = $ce4ea6902f7a0721$var$getBundleURL();
        $ce4ea6902f7a0721$var$bundleURL[id] = value;
    }
    return value;
}
function $ce4ea6902f7a0721$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $ce4ea6902f7a0721$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $ce4ea6902f7a0721$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $ce4ea6902f7a0721$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$ce4ea6902f7a0721$export$bdfd709ae4826697 = $ce4ea6902f7a0721$var$getBundleURLCached;
$ce4ea6902f7a0721$export$c9e73fbda7da57b6 = $ce4ea6902f7a0721$var$getBaseURL;
$ce4ea6902f7a0721$export$5a759dc7a1cfb72a = $ce4ea6902f7a0721$var$getOrigin;

});

parcelRegister("89wqa", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $5ef850295e0236ca$export$ffb0004e005737fa, (v) => $5ef850295e0236ca$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $5ef850295e0236ca$export$34b9dba7ce09269b, (v) => $5ef850295e0236ca$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $5ef850295e0236ca$export$25062201e9e25d76, (v) => $5ef850295e0236ca$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5ef850295e0236ca$export$ffb0004e005737fa;
var $5ef850295e0236ca$export$34b9dba7ce09269b;
var $5ef850295e0236ca$export$25062201e9e25d76;
"use strict";

var $8NFma = parcelRequire("8NFma");
var $5ef850295e0236ca$var$k = Symbol.for("react.element"), $5ef850295e0236ca$var$l = Symbol.for("react.fragment"), $5ef850295e0236ca$var$m = Object.prototype.hasOwnProperty, $5ef850295e0236ca$var$n = $8NFma.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $5ef850295e0236ca$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $5ef850295e0236ca$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$5ef850295e0236ca$var$m.call(a, b) && !$5ef850295e0236ca$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $5ef850295e0236ca$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $5ef850295e0236ca$var$n.current
    };
}
$5ef850295e0236ca$export$ffb0004e005737fa = $5ef850295e0236ca$var$l;
$5ef850295e0236ca$export$34b9dba7ce09269b = $5ef850295e0236ca$var$q;
$5ef850295e0236ca$export$25062201e9e25d76 = $5ef850295e0236ca$var$q;

});
parcelRegister("8NFma", function(module, exports) {
"use strict";

module.exports = (parcelRequire("j1rj6"));

});
parcelRegister("j1rj6", function(module, exports) {

$parcel$export(module.exports, "Children", () => $dd934af551f44020$export$dca3b0875bd9a954, (v) => $dd934af551f44020$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $dd934af551f44020$export$16fa2f45be04daa8, (v) => $dd934af551f44020$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $dd934af551f44020$export$ffb0004e005737fa, (v) => $dd934af551f44020$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $dd934af551f44020$export$e2c29f18771995cb, (v) => $dd934af551f44020$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $dd934af551f44020$export$221d75b3f55bb0bd, (v) => $dd934af551f44020$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $dd934af551f44020$export$5f8d39834fd61797, (v) => $dd934af551f44020$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $dd934af551f44020$export$74bf444e3cd11ea5, (v) => $dd934af551f44020$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $dd934af551f44020$export$ae55be85d98224ed, (v) => $dd934af551f44020$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $dd934af551f44020$export$3ba232387fd5d6dd, (v) => $dd934af551f44020$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $dd934af551f44020$export$e530037191fcd5d7, (v) => $dd934af551f44020$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $dd934af551f44020$export$fd42f52fd3ae1109, (v) => $dd934af551f44020$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $dd934af551f44020$export$c8a8987d4410bf2d, (v) => $dd934af551f44020$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $dd934af551f44020$export$d38cd72104c1f0e9, (v) => $dd934af551f44020$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $dd934af551f44020$export$7d1e3a5e95ceca43, (v) => $dd934af551f44020$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $dd934af551f44020$export$257a8862b851cb5b, (v) => $dd934af551f44020$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $dd934af551f44020$export$a8257692ac88316c, (v) => $dd934af551f44020$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $dd934af551f44020$export$488013bae63b21da, (v) => $dd934af551f44020$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $dd934af551f44020$export$7c73462e0d25e514, (v) => $dd934af551f44020$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $dd934af551f44020$export$7568632d0d33d16d, (v) => $dd934af551f44020$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $dd934af551f44020$export$88948ce120ea2619, (v) => $dd934af551f44020$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $dd934af551f44020$export$35808ee640e87ca7, (v) => $dd934af551f44020$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $dd934af551f44020$export$fae74005e78b1a27, (v) => $dd934af551f44020$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $dd934af551f44020$export$dc8fbce3eb94dc1e, (v) => $dd934af551f44020$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $dd934af551f44020$export$6a7bc4e911dc01cf, (v) => $dd934af551f44020$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $dd934af551f44020$export$6d9c69b0de29b591, (v) => $dd934af551f44020$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $dd934af551f44020$export$f680877a34711e37, (v) => $dd934af551f44020$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $dd934af551f44020$export$d5a552a76deda3c2, (v) => $dd934af551f44020$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $dd934af551f44020$export$aaabe4eda9ed9969, (v) => $dd934af551f44020$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $dd934af551f44020$export$e5c5a5f917a5871c, (v) => $dd934af551f44020$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $dd934af551f44020$export$1538c33de8887b59, (v) => $dd934af551f44020$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $dd934af551f44020$export$13e3392192263954, (v) => $dd934af551f44020$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $dd934af551f44020$export$b8f5890fc79d6aca, (v) => $dd934af551f44020$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $dd934af551f44020$export$60241385465d0a34, (v) => $dd934af551f44020$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $dd934af551f44020$export$306c0aa65ff9ec16, (v) => $dd934af551f44020$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $dd934af551f44020$export$7b286972b8d8ccbf, (v) => $dd934af551f44020$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $dd934af551f44020$export$83d89fbfd8236492, (v) => $dd934af551f44020$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dd934af551f44020$export$dca3b0875bd9a954;
var $dd934af551f44020$export$16fa2f45be04daa8;
var $dd934af551f44020$export$ffb0004e005737fa;
var $dd934af551f44020$export$e2c29f18771995cb;
var $dd934af551f44020$export$221d75b3f55bb0bd;
var $dd934af551f44020$export$5f8d39834fd61797;
var $dd934af551f44020$export$74bf444e3cd11ea5;
var $dd934af551f44020$export$ae55be85d98224ed;
var $dd934af551f44020$export$3ba232387fd5d6dd;
var $dd934af551f44020$export$e530037191fcd5d7;
var $dd934af551f44020$export$fd42f52fd3ae1109;
var $dd934af551f44020$export$c8a8987d4410bf2d;
var $dd934af551f44020$export$d38cd72104c1f0e9;
var $dd934af551f44020$export$7d1e3a5e95ceca43;
var $dd934af551f44020$export$257a8862b851cb5b;
var $dd934af551f44020$export$a8257692ac88316c;
var $dd934af551f44020$export$488013bae63b21da;
var $dd934af551f44020$export$7c73462e0d25e514;
var $dd934af551f44020$export$7568632d0d33d16d;
var $dd934af551f44020$export$88948ce120ea2619;
var $dd934af551f44020$export$35808ee640e87ca7;
var $dd934af551f44020$export$fae74005e78b1a27;
var $dd934af551f44020$export$dc8fbce3eb94dc1e;
var $dd934af551f44020$export$6a7bc4e911dc01cf;
var $dd934af551f44020$export$6d9c69b0de29b591;
var $dd934af551f44020$export$f680877a34711e37;
var $dd934af551f44020$export$d5a552a76deda3c2;
var $dd934af551f44020$export$aaabe4eda9ed9969;
var $dd934af551f44020$export$e5c5a5f917a5871c;
var $dd934af551f44020$export$1538c33de8887b59;
var $dd934af551f44020$export$13e3392192263954;
var $dd934af551f44020$export$b8f5890fc79d6aca;
var $dd934af551f44020$export$60241385465d0a34;
var $dd934af551f44020$export$306c0aa65ff9ec16;
var $dd934af551f44020$export$7b286972b8d8ccbf;
var $dd934af551f44020$export$83d89fbfd8236492;
"use strict";
var $dd934af551f44020$var$l = Symbol.for("react.element"), $dd934af551f44020$var$n = Symbol.for("react.portal"), $dd934af551f44020$var$p = Symbol.for("react.fragment"), $dd934af551f44020$var$q = Symbol.for("react.strict_mode"), $dd934af551f44020$var$r = Symbol.for("react.profiler"), $dd934af551f44020$var$t = Symbol.for("react.provider"), $dd934af551f44020$var$u = Symbol.for("react.context"), $dd934af551f44020$var$v = Symbol.for("react.forward_ref"), $dd934af551f44020$var$w = Symbol.for("react.suspense"), $dd934af551f44020$var$x = Symbol.for("react.memo"), $dd934af551f44020$var$y = Symbol.for("react.lazy"), $dd934af551f44020$var$z = Symbol.iterator;
function $dd934af551f44020$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $dd934af551f44020$var$z && a[$dd934af551f44020$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $dd934af551f44020$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $dd934af551f44020$var$C = Object.assign, $dd934af551f44020$var$D = {};
function $dd934af551f44020$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $dd934af551f44020$var$D;
    this.updater = e || $dd934af551f44020$var$B;
}
$dd934af551f44020$var$E.prototype.isReactComponent = {};
$dd934af551f44020$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$dd934af551f44020$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $dd934af551f44020$var$F() {}
$dd934af551f44020$var$F.prototype = $dd934af551f44020$var$E.prototype;
function $dd934af551f44020$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $dd934af551f44020$var$D;
    this.updater = e || $dd934af551f44020$var$B;
}
var $dd934af551f44020$var$H = $dd934af551f44020$var$G.prototype = new $dd934af551f44020$var$F;
$dd934af551f44020$var$H.constructor = $dd934af551f44020$var$G;
$dd934af551f44020$var$C($dd934af551f44020$var$H, $dd934af551f44020$var$E.prototype);
$dd934af551f44020$var$H.isPureReactComponent = !0;
var $dd934af551f44020$var$I = Array.isArray, $dd934af551f44020$var$J = Object.prototype.hasOwnProperty, $dd934af551f44020$var$K = {
    current: null
}, $dd934af551f44020$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $dd934af551f44020$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$dd934af551f44020$var$J.call(b, d) && !$dd934af551f44020$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $dd934af551f44020$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $dd934af551f44020$var$K.current
    };
}
function $dd934af551f44020$var$N(a, b) {
    return {
        $$typeof: $dd934af551f44020$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $dd934af551f44020$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $dd934af551f44020$var$l;
}
function $dd934af551f44020$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $dd934af551f44020$var$P = /\/+/g;
function $dd934af551f44020$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $dd934af551f44020$var$escape("" + a.key) : b.toString(36);
}
function $dd934af551f44020$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $dd934af551f44020$var$l:
                case $dd934af551f44020$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $dd934af551f44020$var$Q(h, 0) : d, $dd934af551f44020$var$I(c) ? (e = "", null != a && (e = a.replace($dd934af551f44020$var$P, "$&/") + "/"), $dd934af551f44020$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($dd934af551f44020$var$O(c) && (c = $dd934af551f44020$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($dd934af551f44020$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($dd934af551f44020$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $dd934af551f44020$var$Q(k, g);
        h += $dd934af551f44020$var$R(k, b, e, f, c);
    }
    else if (f = $dd934af551f44020$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $dd934af551f44020$var$Q(k, g++), h += $dd934af551f44020$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $dd934af551f44020$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $dd934af551f44020$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $dd934af551f44020$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $dd934af551f44020$var$U = {
    current: null
}, $dd934af551f44020$var$V = {
    transition: null
}, $dd934af551f44020$var$W = {
    ReactCurrentDispatcher: $dd934af551f44020$var$U,
    ReactCurrentBatchConfig: $dd934af551f44020$var$V,
    ReactCurrentOwner: $dd934af551f44020$var$K
};
function $dd934af551f44020$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$dd934af551f44020$export$dca3b0875bd9a954 = {
    map: $dd934af551f44020$var$S,
    forEach: function(a, b, e) {
        $dd934af551f44020$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $dd934af551f44020$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $dd934af551f44020$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$dd934af551f44020$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$dd934af551f44020$export$16fa2f45be04daa8 = $dd934af551f44020$var$E;
$dd934af551f44020$export$ffb0004e005737fa = $dd934af551f44020$var$p;
$dd934af551f44020$export$e2c29f18771995cb = $dd934af551f44020$var$r;
$dd934af551f44020$export$221d75b3f55bb0bd = $dd934af551f44020$var$G;
$dd934af551f44020$export$5f8d39834fd61797 = $dd934af551f44020$var$q;
$dd934af551f44020$export$74bf444e3cd11ea5 = $dd934af551f44020$var$w;
$dd934af551f44020$export$ae55be85d98224ed = $dd934af551f44020$var$W;
$dd934af551f44020$export$3ba232387fd5d6dd = $dd934af551f44020$var$X;
$dd934af551f44020$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $dd934af551f44020$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $dd934af551f44020$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$dd934af551f44020$var$J.call(b, f) && !$dd934af551f44020$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $dd934af551f44020$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$dd934af551f44020$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $dd934af551f44020$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $dd934af551f44020$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$dd934af551f44020$export$c8a8987d4410bf2d = $dd934af551f44020$var$M;
$dd934af551f44020$export$d38cd72104c1f0e9 = function(a) {
    var b = $dd934af551f44020$var$M.bind(null, a);
    b.type = a;
    return b;
};
$dd934af551f44020$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$dd934af551f44020$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $dd934af551f44020$var$v,
        render: a
    };
};
$dd934af551f44020$export$a8257692ac88316c = $dd934af551f44020$var$O;
$dd934af551f44020$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $dd934af551f44020$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $dd934af551f44020$var$T
    };
};
$dd934af551f44020$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $dd934af551f44020$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$dd934af551f44020$export$7568632d0d33d16d = function(a) {
    var b = $dd934af551f44020$var$V.transition;
    $dd934af551f44020$var$V.transition = {};
    try {
        a();
    } finally{
        $dd934af551f44020$var$V.transition = b;
    }
};
$dd934af551f44020$export$88948ce120ea2619 = $dd934af551f44020$var$X;
$dd934af551f44020$export$35808ee640e87ca7 = function(a, b) {
    return $dd934af551f44020$var$U.current.useCallback(a, b);
};
$dd934af551f44020$export$fae74005e78b1a27 = function(a) {
    return $dd934af551f44020$var$U.current.useContext(a);
};
$dd934af551f44020$export$dc8fbce3eb94dc1e = function() {};
$dd934af551f44020$export$6a7bc4e911dc01cf = function(a) {
    return $dd934af551f44020$var$U.current.useDeferredValue(a);
};
$dd934af551f44020$export$6d9c69b0de29b591 = function(a, b) {
    return $dd934af551f44020$var$U.current.useEffect(a, b);
};
$dd934af551f44020$export$f680877a34711e37 = function() {
    return $dd934af551f44020$var$U.current.useId();
};
$dd934af551f44020$export$d5a552a76deda3c2 = function(a, b, e) {
    return $dd934af551f44020$var$U.current.useImperativeHandle(a, b, e);
};
$dd934af551f44020$export$aaabe4eda9ed9969 = function(a, b) {
    return $dd934af551f44020$var$U.current.useInsertionEffect(a, b);
};
$dd934af551f44020$export$e5c5a5f917a5871c = function(a, b) {
    return $dd934af551f44020$var$U.current.useLayoutEffect(a, b);
};
$dd934af551f44020$export$1538c33de8887b59 = function(a, b) {
    return $dd934af551f44020$var$U.current.useMemo(a, b);
};
$dd934af551f44020$export$13e3392192263954 = function(a, b, e) {
    return $dd934af551f44020$var$U.current.useReducer(a, b, e);
};
$dd934af551f44020$export$b8f5890fc79d6aca = function(a) {
    return $dd934af551f44020$var$U.current.useRef(a);
};
$dd934af551f44020$export$60241385465d0a34 = function(a) {
    return $dd934af551f44020$var$U.current.useState(a);
};
$dd934af551f44020$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $dd934af551f44020$var$U.current.useSyncExternalStore(a, b, e);
};
$dd934af551f44020$export$7b286972b8d8ccbf = function() {
    return $dd934af551f44020$var$U.current.useTransition();
};
$dd934af551f44020$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("6T1J1", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $503937b663c395c4$export$882461b6382ed46c, (v) => $503937b663c395c4$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $503937b663c395c4$export$757ceba2d55c277e, (v) => $503937b663c395c4$export$757ceba2d55c277e = v);
var $503937b663c395c4$export$882461b6382ed46c;
var $503937b663c395c4$export$757ceba2d55c277e;
"use strict";

var $2pmb0 = parcelRequire("2pmb0");
var $503937b663c395c4$var$i;
$503937b663c395c4$export$882461b6382ed46c = $2pmb0.createRoot;
$503937b663c395c4$export$757ceba2d55c277e = $2pmb0.hydrateRoot;

});
parcelRegister("2pmb0", function(module, exports) {
"use strict";
function $1c0f1e610963dfb8$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($1c0f1e610963dfb8$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$1c0f1e610963dfb8$var$checkDCE();

module.exports = (parcelRequire("23wBm"));

});
parcelRegister("23wBm", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $17f526922e4a857c$export$ae55be85d98224ed, (v) => $17f526922e4a857c$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $17f526922e4a857c$export$d39a5bbd09211389, (v) => $17f526922e4a857c$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $17f526922e4a857c$export$882461b6382ed46c, (v) => $17f526922e4a857c$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $17f526922e4a857c$export$466bfc07425424d5, (v) => $17f526922e4a857c$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $17f526922e4a857c$export$cd75ccfd720a3cd4, (v) => $17f526922e4a857c$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $17f526922e4a857c$export$fa8d919ba61d84db, (v) => $17f526922e4a857c$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $17f526922e4a857c$export$757ceba2d55c277e, (v) => $17f526922e4a857c$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $17f526922e4a857c$export$b3890eb0ae9dca99, (v) => $17f526922e4a857c$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $17f526922e4a857c$export$502457920280e6be, (v) => $17f526922e4a857c$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $17f526922e4a857c$export$c78a37762a8d58e1, (v) => $17f526922e4a857c$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $17f526922e4a857c$export$dc54d992c10e8a18, (v) => $17f526922e4a857c$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $17f526922e4a857c$export$83d89fbfd8236492, (v) => $17f526922e4a857c$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $17f526922e4a857c$export$ae55be85d98224ed;
var $17f526922e4a857c$export$d39a5bbd09211389;
var $17f526922e4a857c$export$882461b6382ed46c;
var $17f526922e4a857c$export$466bfc07425424d5;
var $17f526922e4a857c$export$cd75ccfd720a3cd4;
var $17f526922e4a857c$export$fa8d919ba61d84db;
var $17f526922e4a857c$export$757ceba2d55c277e;
var $17f526922e4a857c$export$b3890eb0ae9dca99;
var $17f526922e4a857c$export$502457920280e6be;
var $17f526922e4a857c$export$c78a37762a8d58e1;
var $17f526922e4a857c$export$dc54d992c10e8a18;
var $17f526922e4a857c$export$83d89fbfd8236492;
"use strict";

var $8NFma = parcelRequire("8NFma");

var $clk2u = parcelRequire("clk2u");
function $17f526922e4a857c$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $17f526922e4a857c$var$da = new Set, $17f526922e4a857c$var$ea = {};
function $17f526922e4a857c$var$fa(a, b) {
    $17f526922e4a857c$var$ha(a, b);
    $17f526922e4a857c$var$ha(a + "Capture", b);
}
function $17f526922e4a857c$var$ha(a, b) {
    $17f526922e4a857c$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$17f526922e4a857c$var$da.add(b[a]);
}
var $17f526922e4a857c$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $17f526922e4a857c$var$ja = Object.prototype.hasOwnProperty, $17f526922e4a857c$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $17f526922e4a857c$var$la = {}, $17f526922e4a857c$var$ma = {};
function $17f526922e4a857c$var$oa(a) {
    if ($17f526922e4a857c$var$ja.call($17f526922e4a857c$var$ma, a)) return !0;
    if ($17f526922e4a857c$var$ja.call($17f526922e4a857c$var$la, a)) return !1;
    if ($17f526922e4a857c$var$ka.test(a)) return $17f526922e4a857c$var$ma[a] = !0;
    $17f526922e4a857c$var$la[a] = !0;
    return !1;
}
function $17f526922e4a857c$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $17f526922e4a857c$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $17f526922e4a857c$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $17f526922e4a857c$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $17f526922e4a857c$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $17f526922e4a857c$var$z[b] = new $17f526922e4a857c$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $17f526922e4a857c$var$ra = /[\-:]([a-z])/g;
function $17f526922e4a857c$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($17f526922e4a857c$var$ra, $17f526922e4a857c$var$sa);
    $17f526922e4a857c$var$z[b] = new $17f526922e4a857c$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($17f526922e4a857c$var$ra, $17f526922e4a857c$var$sa);
    $17f526922e4a857c$var$z[b] = new $17f526922e4a857c$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($17f526922e4a857c$var$ra, $17f526922e4a857c$var$sa);
    $17f526922e4a857c$var$z[b] = new $17f526922e4a857c$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$17f526922e4a857c$var$z.xlinkHref = new $17f526922e4a857c$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $17f526922e4a857c$var$ta(a, b, c, d) {
    var e = $17f526922e4a857c$var$z.hasOwnProperty(b) ? $17f526922e4a857c$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $17f526922e4a857c$var$qa(b, c, e, d) && (c = null), d || null === e ? $17f526922e4a857c$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $17f526922e4a857c$var$ua = $8NFma.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $17f526922e4a857c$var$va = Symbol.for("react.element"), $17f526922e4a857c$var$wa = Symbol.for("react.portal"), $17f526922e4a857c$var$ya = Symbol.for("react.fragment"), $17f526922e4a857c$var$za = Symbol.for("react.strict_mode"), $17f526922e4a857c$var$Aa = Symbol.for("react.profiler"), $17f526922e4a857c$var$Ba = Symbol.for("react.provider"), $17f526922e4a857c$var$Ca = Symbol.for("react.context"), $17f526922e4a857c$var$Da = Symbol.for("react.forward_ref"), $17f526922e4a857c$var$Ea = Symbol.for("react.suspense"), $17f526922e4a857c$var$Fa = Symbol.for("react.suspense_list"), $17f526922e4a857c$var$Ga = Symbol.for("react.memo"), $17f526922e4a857c$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $17f526922e4a857c$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $17f526922e4a857c$var$Ja = Symbol.iterator;
function $17f526922e4a857c$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $17f526922e4a857c$var$Ja && a[$17f526922e4a857c$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $17f526922e4a857c$var$A = Object.assign, $17f526922e4a857c$var$La;
function $17f526922e4a857c$var$Ma(a) {
    if (void 0 === $17f526922e4a857c$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $17f526922e4a857c$var$La = b && b[1] || "";
    }
    return "\n" + $17f526922e4a857c$var$La + a;
}
var $17f526922e4a857c$var$Na = !1;
function $17f526922e4a857c$var$Oa(a, b) {
    if (!a || $17f526922e4a857c$var$Na) return "";
    $17f526922e4a857c$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $17f526922e4a857c$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $17f526922e4a857c$var$Ma(a) : "";
}
function $17f526922e4a857c$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $17f526922e4a857c$var$Ma(a.type);
        case 16:
            return $17f526922e4a857c$var$Ma("Lazy");
        case 13:
            return $17f526922e4a857c$var$Ma("Suspense");
        case 19:
            return $17f526922e4a857c$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $17f526922e4a857c$var$Oa(a.type, !1), a;
        case 11:
            return a = $17f526922e4a857c$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $17f526922e4a857c$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $17f526922e4a857c$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $17f526922e4a857c$var$ya:
            return "Fragment";
        case $17f526922e4a857c$var$wa:
            return "Portal";
        case $17f526922e4a857c$var$Aa:
            return "Profiler";
        case $17f526922e4a857c$var$za:
            return "StrictMode";
        case $17f526922e4a857c$var$Ea:
            return "Suspense";
        case $17f526922e4a857c$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $17f526922e4a857c$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $17f526922e4a857c$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $17f526922e4a857c$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $17f526922e4a857c$var$Ga:
            return b = a.displayName || null, null !== b ? b : $17f526922e4a857c$var$Qa(a.type) || "Memo";
        case $17f526922e4a857c$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $17f526922e4a857c$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $17f526922e4a857c$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $17f526922e4a857c$var$Qa(b);
        case 8:
            return b === $17f526922e4a857c$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $17f526922e4a857c$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $17f526922e4a857c$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $17f526922e4a857c$var$Ua(a) {
    var b = $17f526922e4a857c$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $17f526922e4a857c$var$Va(a) {
    a._valueTracker || (a._valueTracker = $17f526922e4a857c$var$Ua(a));
}
function $17f526922e4a857c$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $17f526922e4a857c$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $17f526922e4a857c$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $17f526922e4a857c$var$Ya(a, b) {
    var c = b.checked;
    return $17f526922e4a857c$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $17f526922e4a857c$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $17f526922e4a857c$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $17f526922e4a857c$var$ab(a, b) {
    b = b.checked;
    null != b && $17f526922e4a857c$var$ta(a, "checked", b, !1);
}
function $17f526922e4a857c$var$bb(a, b) {
    $17f526922e4a857c$var$ab(a, b);
    var c = $17f526922e4a857c$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $17f526922e4a857c$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $17f526922e4a857c$var$cb(a, b.type, $17f526922e4a857c$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $17f526922e4a857c$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $17f526922e4a857c$var$cb(a, b, c) {
    if ("number" !== b || $17f526922e4a857c$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $17f526922e4a857c$var$eb = Array.isArray;
function $17f526922e4a857c$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $17f526922e4a857c$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $17f526922e4a857c$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($17f526922e4a857c$var$p(91));
    return $17f526922e4a857c$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $17f526922e4a857c$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($17f526922e4a857c$var$p(92));
            if ($17f526922e4a857c$var$eb(c)) {
                if (1 < c.length) throw Error($17f526922e4a857c$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $17f526922e4a857c$var$Sa(c)
    };
}
function $17f526922e4a857c$var$ib(a, b) {
    var c = $17f526922e4a857c$var$Sa(b.value), d = $17f526922e4a857c$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $17f526922e4a857c$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $17f526922e4a857c$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $17f526922e4a857c$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $17f526922e4a857c$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $17f526922e4a857c$var$mb, $17f526922e4a857c$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $17f526922e4a857c$var$mb = $17f526922e4a857c$var$mb || document.createElement("div");
        $17f526922e4a857c$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $17f526922e4a857c$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $17f526922e4a857c$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $17f526922e4a857c$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $17f526922e4a857c$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($17f526922e4a857c$var$pb).forEach(function(a) {
    $17f526922e4a857c$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $17f526922e4a857c$var$pb[b] = $17f526922e4a857c$var$pb[a];
    });
});
function $17f526922e4a857c$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $17f526922e4a857c$var$pb.hasOwnProperty(a) && $17f526922e4a857c$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $17f526922e4a857c$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $17f526922e4a857c$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $17f526922e4a857c$var$tb = $17f526922e4a857c$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $17f526922e4a857c$var$ub(a, b) {
    if (b) {
        if ($17f526922e4a857c$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($17f526922e4a857c$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($17f526922e4a857c$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($17f526922e4a857c$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($17f526922e4a857c$var$p(62));
    }
}
function $17f526922e4a857c$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $17f526922e4a857c$var$wb = null;
function $17f526922e4a857c$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $17f526922e4a857c$var$yb = null, $17f526922e4a857c$var$zb = null, $17f526922e4a857c$var$Ab = null;
function $17f526922e4a857c$var$Bb(a) {
    if (a = $17f526922e4a857c$var$Cb(a)) {
        if ("function" !== typeof $17f526922e4a857c$var$yb) throw Error($17f526922e4a857c$var$p(280));
        var b = a.stateNode;
        b && (b = $17f526922e4a857c$var$Db(b), $17f526922e4a857c$var$yb(a.stateNode, a.type, b));
    }
}
function $17f526922e4a857c$var$Eb(a) {
    $17f526922e4a857c$var$zb ? $17f526922e4a857c$var$Ab ? $17f526922e4a857c$var$Ab.push(a) : $17f526922e4a857c$var$Ab = [
        a
    ] : $17f526922e4a857c$var$zb = a;
}
function $17f526922e4a857c$var$Fb() {
    if ($17f526922e4a857c$var$zb) {
        var a = $17f526922e4a857c$var$zb, b = $17f526922e4a857c$var$Ab;
        $17f526922e4a857c$var$Ab = $17f526922e4a857c$var$zb = null;
        $17f526922e4a857c$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$17f526922e4a857c$var$Bb(b[a]);
    }
}
function $17f526922e4a857c$var$Gb(a, b) {
    return a(b);
}
function $17f526922e4a857c$var$Hb() {}
var $17f526922e4a857c$var$Ib = !1;
function $17f526922e4a857c$var$Jb(a, b, c) {
    if ($17f526922e4a857c$var$Ib) return a(b, c);
    $17f526922e4a857c$var$Ib = !0;
    try {
        return $17f526922e4a857c$var$Gb(a, b, c);
    } finally{
        if ($17f526922e4a857c$var$Ib = !1, null !== $17f526922e4a857c$var$zb || null !== $17f526922e4a857c$var$Ab) $17f526922e4a857c$var$Hb(), $17f526922e4a857c$var$Fb();
    }
}
function $17f526922e4a857c$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $17f526922e4a857c$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($17f526922e4a857c$var$p(231, b, typeof c));
    return c;
}
var $17f526922e4a857c$var$Lb = !1;
if ($17f526922e4a857c$var$ia) try {
    var $17f526922e4a857c$var$Mb = {};
    Object.defineProperty($17f526922e4a857c$var$Mb, "passive", {
        get: function() {
            $17f526922e4a857c$var$Lb = !0;
        }
    });
    window.addEventListener("test", $17f526922e4a857c$var$Mb, $17f526922e4a857c$var$Mb);
    window.removeEventListener("test", $17f526922e4a857c$var$Mb, $17f526922e4a857c$var$Mb);
} catch (a) {
    $17f526922e4a857c$var$Lb = !1;
}
function $17f526922e4a857c$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $17f526922e4a857c$var$Ob = !1, $17f526922e4a857c$var$Pb = null, $17f526922e4a857c$var$Qb = !1, $17f526922e4a857c$var$Rb = null, $17f526922e4a857c$var$Sb = {
    onError: function(a) {
        $17f526922e4a857c$var$Ob = !0;
        $17f526922e4a857c$var$Pb = a;
    }
};
function $17f526922e4a857c$var$Tb(a, b, c, d, e, f, g, h, k) {
    $17f526922e4a857c$var$Ob = !1;
    $17f526922e4a857c$var$Pb = null;
    $17f526922e4a857c$var$Nb.apply($17f526922e4a857c$var$Sb, arguments);
}
function $17f526922e4a857c$var$Ub(a, b, c, d, e, f, g, h, k) {
    $17f526922e4a857c$var$Tb.apply(this, arguments);
    if ($17f526922e4a857c$var$Ob) {
        if ($17f526922e4a857c$var$Ob) {
            var l = $17f526922e4a857c$var$Pb;
            $17f526922e4a857c$var$Ob = !1;
            $17f526922e4a857c$var$Pb = null;
        } else throw Error($17f526922e4a857c$var$p(198));
        $17f526922e4a857c$var$Qb || ($17f526922e4a857c$var$Qb = !0, $17f526922e4a857c$var$Rb = l);
    }
}
function $17f526922e4a857c$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $17f526922e4a857c$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $17f526922e4a857c$var$Xb(a) {
    if ($17f526922e4a857c$var$Vb(a) !== a) throw Error($17f526922e4a857c$var$p(188));
}
function $17f526922e4a857c$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $17f526922e4a857c$var$Vb(a);
        if (null === b) throw Error($17f526922e4a857c$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $17f526922e4a857c$var$Xb(e), a;
                if (f === d) return $17f526922e4a857c$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($17f526922e4a857c$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($17f526922e4a857c$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($17f526922e4a857c$var$p(190));
    }
    if (3 !== c.tag) throw Error($17f526922e4a857c$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $17f526922e4a857c$var$Zb(a) {
    a = $17f526922e4a857c$var$Yb(a);
    return null !== a ? $17f526922e4a857c$var$$b(a) : null;
}
function $17f526922e4a857c$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $17f526922e4a857c$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $17f526922e4a857c$var$ac = $clk2u.unstable_scheduleCallback, $17f526922e4a857c$var$bc = $clk2u.unstable_cancelCallback, $17f526922e4a857c$var$cc = $clk2u.unstable_shouldYield, $17f526922e4a857c$var$dc = $clk2u.unstable_requestPaint, $17f526922e4a857c$var$B = $clk2u.unstable_now, $17f526922e4a857c$var$ec = $clk2u.unstable_getCurrentPriorityLevel, $17f526922e4a857c$var$fc = $clk2u.unstable_ImmediatePriority, $17f526922e4a857c$var$gc = $clk2u.unstable_UserBlockingPriority, $17f526922e4a857c$var$hc = $clk2u.unstable_NormalPriority, $17f526922e4a857c$var$ic = $clk2u.unstable_LowPriority, $17f526922e4a857c$var$jc = $clk2u.unstable_IdlePriority, $17f526922e4a857c$var$kc = null, $17f526922e4a857c$var$lc = null;
function $17f526922e4a857c$var$mc(a) {
    if ($17f526922e4a857c$var$lc && "function" === typeof $17f526922e4a857c$var$lc.onCommitFiberRoot) try {
        $17f526922e4a857c$var$lc.onCommitFiberRoot($17f526922e4a857c$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $17f526922e4a857c$var$oc = Math.clz32 ? Math.clz32 : $17f526922e4a857c$var$nc, $17f526922e4a857c$var$pc = Math.log, $17f526922e4a857c$var$qc = Math.LN2;
function $17f526922e4a857c$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($17f526922e4a857c$var$pc(a) / $17f526922e4a857c$var$qc | 0) | 0;
}
var $17f526922e4a857c$var$rc = 64, $17f526922e4a857c$var$sc = 4194304;
function $17f526922e4a857c$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $17f526922e4a857c$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $17f526922e4a857c$var$tc(h) : (f &= g, 0 !== f && (d = $17f526922e4a857c$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $17f526922e4a857c$var$tc(g) : 0 !== f && (d = $17f526922e4a857c$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $17f526922e4a857c$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $17f526922e4a857c$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $17f526922e4a857c$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $17f526922e4a857c$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $17f526922e4a857c$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $17f526922e4a857c$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $17f526922e4a857c$var$yc() {
    var a = $17f526922e4a857c$var$rc;
    $17f526922e4a857c$var$rc <<= 1;
    0 === ($17f526922e4a857c$var$rc & 4194240) && ($17f526922e4a857c$var$rc = 64);
    return a;
}
function $17f526922e4a857c$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $17f526922e4a857c$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $17f526922e4a857c$var$oc(b);
    a[b] = c;
}
function $17f526922e4a857c$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $17f526922e4a857c$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $17f526922e4a857c$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $17f526922e4a857c$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $17f526922e4a857c$var$C = 0;
function $17f526922e4a857c$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $17f526922e4a857c$var$Ec, $17f526922e4a857c$var$Fc, $17f526922e4a857c$var$Gc, $17f526922e4a857c$var$Hc, $17f526922e4a857c$var$Ic, $17f526922e4a857c$var$Jc = !1, $17f526922e4a857c$var$Kc = [], $17f526922e4a857c$var$Lc = null, $17f526922e4a857c$var$Mc = null, $17f526922e4a857c$var$Nc = null, $17f526922e4a857c$var$Oc = new Map, $17f526922e4a857c$var$Pc = new Map, $17f526922e4a857c$var$Qc = [], $17f526922e4a857c$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $17f526922e4a857c$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $17f526922e4a857c$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $17f526922e4a857c$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $17f526922e4a857c$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $17f526922e4a857c$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $17f526922e4a857c$var$Pc.delete(b.pointerId);
    }
}
function $17f526922e4a857c$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $17f526922e4a857c$var$Cb(b), null !== b && $17f526922e4a857c$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $17f526922e4a857c$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $17f526922e4a857c$var$Lc = $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $17f526922e4a857c$var$Mc = $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $17f526922e4a857c$var$Nc = $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $17f526922e4a857c$var$Oc.set(f, $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $17f526922e4a857c$var$Pc.set(f, $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $17f526922e4a857c$var$Vc(a) {
    var b = $17f526922e4a857c$var$Wc(a.target);
    if (null !== b) {
        var c = $17f526922e4a857c$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $17f526922e4a857c$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $17f526922e4a857c$var$Ic(a.priority, function() {
                        $17f526922e4a857c$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $17f526922e4a857c$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $17f526922e4a857c$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $17f526922e4a857c$var$wb = d;
            c.target.dispatchEvent(d);
            $17f526922e4a857c$var$wb = null;
        } else return b = $17f526922e4a857c$var$Cb(c), null !== b && $17f526922e4a857c$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $17f526922e4a857c$var$Zc(a, b, c) {
    $17f526922e4a857c$var$Xc(a) && c.delete(b);
}
function $17f526922e4a857c$var$$c() {
    $17f526922e4a857c$var$Jc = !1;
    null !== $17f526922e4a857c$var$Lc && $17f526922e4a857c$var$Xc($17f526922e4a857c$var$Lc) && ($17f526922e4a857c$var$Lc = null);
    null !== $17f526922e4a857c$var$Mc && $17f526922e4a857c$var$Xc($17f526922e4a857c$var$Mc) && ($17f526922e4a857c$var$Mc = null);
    null !== $17f526922e4a857c$var$Nc && $17f526922e4a857c$var$Xc($17f526922e4a857c$var$Nc) && ($17f526922e4a857c$var$Nc = null);
    $17f526922e4a857c$var$Oc.forEach($17f526922e4a857c$var$Zc);
    $17f526922e4a857c$var$Pc.forEach($17f526922e4a857c$var$Zc);
}
function $17f526922e4a857c$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $17f526922e4a857c$var$Jc || ($17f526922e4a857c$var$Jc = !0, $clk2u.unstable_scheduleCallback($clk2u.unstable_NormalPriority, $17f526922e4a857c$var$$c)));
}
function $17f526922e4a857c$var$bd(a) {
    function b(b) {
        return $17f526922e4a857c$var$ad(b, a);
    }
    if (0 < $17f526922e4a857c$var$Kc.length) {
        $17f526922e4a857c$var$ad($17f526922e4a857c$var$Kc[0], a);
        for(var c = 1; c < $17f526922e4a857c$var$Kc.length; c++){
            var d = $17f526922e4a857c$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $17f526922e4a857c$var$Lc && $17f526922e4a857c$var$ad($17f526922e4a857c$var$Lc, a);
    null !== $17f526922e4a857c$var$Mc && $17f526922e4a857c$var$ad($17f526922e4a857c$var$Mc, a);
    null !== $17f526922e4a857c$var$Nc && $17f526922e4a857c$var$ad($17f526922e4a857c$var$Nc, a);
    $17f526922e4a857c$var$Oc.forEach(b);
    $17f526922e4a857c$var$Pc.forEach(b);
    for(c = 0; c < $17f526922e4a857c$var$Qc.length; c++)d = $17f526922e4a857c$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $17f526922e4a857c$var$Qc.length && (c = $17f526922e4a857c$var$Qc[0], null === c.blockedOn);)$17f526922e4a857c$var$Vc(c), null === c.blockedOn && $17f526922e4a857c$var$Qc.shift();
}
var $17f526922e4a857c$var$cd = $17f526922e4a857c$var$ua.ReactCurrentBatchConfig, $17f526922e4a857c$var$dd = !0;
function $17f526922e4a857c$var$ed(a, b, c, d) {
    var e = $17f526922e4a857c$var$C, f = $17f526922e4a857c$var$cd.transition;
    $17f526922e4a857c$var$cd.transition = null;
    try {
        $17f526922e4a857c$var$C = 1, $17f526922e4a857c$var$fd(a, b, c, d);
    } finally{
        $17f526922e4a857c$var$C = e, $17f526922e4a857c$var$cd.transition = f;
    }
}
function $17f526922e4a857c$var$gd(a, b, c, d) {
    var e = $17f526922e4a857c$var$C, f = $17f526922e4a857c$var$cd.transition;
    $17f526922e4a857c$var$cd.transition = null;
    try {
        $17f526922e4a857c$var$C = 4, $17f526922e4a857c$var$fd(a, b, c, d);
    } finally{
        $17f526922e4a857c$var$C = e, $17f526922e4a857c$var$cd.transition = f;
    }
}
function $17f526922e4a857c$var$fd(a, b, c, d) {
    if ($17f526922e4a857c$var$dd) {
        var e = $17f526922e4a857c$var$Yc(a, b, c, d);
        if (null === e) $17f526922e4a857c$var$hd(a, b, d, $17f526922e4a857c$var$id, c), $17f526922e4a857c$var$Sc(a, d);
        else if ($17f526922e4a857c$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($17f526922e4a857c$var$Sc(a, d), b & 4 && -1 < $17f526922e4a857c$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $17f526922e4a857c$var$Cb(e);
                null !== f && $17f526922e4a857c$var$Ec(f);
                f = $17f526922e4a857c$var$Yc(a, b, c, d);
                null === f && $17f526922e4a857c$var$hd(a, b, d, $17f526922e4a857c$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $17f526922e4a857c$var$hd(a, b, d, null, c);
    }
}
var $17f526922e4a857c$var$id = null;
function $17f526922e4a857c$var$Yc(a, b, c, d) {
    $17f526922e4a857c$var$id = null;
    a = $17f526922e4a857c$var$xb(d);
    a = $17f526922e4a857c$var$Wc(a);
    if (null !== a) {
        if (b = $17f526922e4a857c$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $17f526922e4a857c$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $17f526922e4a857c$var$id = a;
    return null;
}
function $17f526922e4a857c$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($17f526922e4a857c$var$ec()){
                case $17f526922e4a857c$var$fc:
                    return 1;
                case $17f526922e4a857c$var$gc:
                    return 4;
                case $17f526922e4a857c$var$hc:
                case $17f526922e4a857c$var$ic:
                    return 16;
                case $17f526922e4a857c$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $17f526922e4a857c$var$kd = null, $17f526922e4a857c$var$ld = null, $17f526922e4a857c$var$md = null;
function $17f526922e4a857c$var$nd() {
    if ($17f526922e4a857c$var$md) return $17f526922e4a857c$var$md;
    var a, b = $17f526922e4a857c$var$ld, c = b.length, d, e = "value" in $17f526922e4a857c$var$kd ? $17f526922e4a857c$var$kd.value : $17f526922e4a857c$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $17f526922e4a857c$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $17f526922e4a857c$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $17f526922e4a857c$var$pd() {
    return !0;
}
function $17f526922e4a857c$var$qd() {
    return !1;
}
function $17f526922e4a857c$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $17f526922e4a857c$var$pd : $17f526922e4a857c$var$qd;
        this.isPropagationStopped = $17f526922e4a857c$var$qd;
        return this;
    }
    $17f526922e4a857c$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $17f526922e4a857c$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $17f526922e4a857c$var$pd);
        },
        persist: function() {},
        isPersistent: $17f526922e4a857c$var$pd
    });
    return b;
}
var $17f526922e4a857c$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $17f526922e4a857c$var$td = $17f526922e4a857c$var$rd($17f526922e4a857c$var$sd), $17f526922e4a857c$var$ud = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    view: 0,
    detail: 0
}), $17f526922e4a857c$var$vd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$ud), $17f526922e4a857c$var$wd, $17f526922e4a857c$var$xd, $17f526922e4a857c$var$yd, $17f526922e4a857c$var$Ad = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $17f526922e4a857c$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $17f526922e4a857c$var$yd && ($17f526922e4a857c$var$yd && "mousemove" === a.type ? ($17f526922e4a857c$var$wd = a.screenX - $17f526922e4a857c$var$yd.screenX, $17f526922e4a857c$var$xd = a.screenY - $17f526922e4a857c$var$yd.screenY) : $17f526922e4a857c$var$xd = $17f526922e4a857c$var$wd = 0, $17f526922e4a857c$var$yd = a);
        return $17f526922e4a857c$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $17f526922e4a857c$var$xd;
    }
}), $17f526922e4a857c$var$Bd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Ad), $17f526922e4a857c$var$Cd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$Ad, {
    dataTransfer: 0
}), $17f526922e4a857c$var$Dd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Cd), $17f526922e4a857c$var$Ed = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$ud, {
    relatedTarget: 0
}), $17f526922e4a857c$var$Fd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Ed), $17f526922e4a857c$var$Gd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $17f526922e4a857c$var$Hd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Gd), $17f526922e4a857c$var$Id = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $17f526922e4a857c$var$Jd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Id), $17f526922e4a857c$var$Kd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    data: 0
}), $17f526922e4a857c$var$Ld = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Kd), $17f526922e4a857c$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $17f526922e4a857c$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $17f526922e4a857c$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $17f526922e4a857c$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $17f526922e4a857c$var$Od[a]) ? !!b[a] : !1;
}
function $17f526922e4a857c$var$zd() {
    return $17f526922e4a857c$var$Pd;
}
var $17f526922e4a857c$var$Qd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $17f526922e4a857c$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $17f526922e4a857c$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $17f526922e4a857c$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $17f526922e4a857c$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $17f526922e4a857c$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $17f526922e4a857c$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $17f526922e4a857c$var$Rd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Qd), $17f526922e4a857c$var$Sd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $17f526922e4a857c$var$Td = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Sd), $17f526922e4a857c$var$Ud = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $17f526922e4a857c$var$zd
}), $17f526922e4a857c$var$Vd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Ud), $17f526922e4a857c$var$Wd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $17f526922e4a857c$var$Xd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Wd), $17f526922e4a857c$var$Yd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $17f526922e4a857c$var$Zd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Yd), $17f526922e4a857c$var$$d = [
    9,
    13,
    27,
    32
], $17f526922e4a857c$var$ae = $17f526922e4a857c$var$ia && "CompositionEvent" in window, $17f526922e4a857c$var$be = null;
$17f526922e4a857c$var$ia && "documentMode" in document && ($17f526922e4a857c$var$be = document.documentMode);
var $17f526922e4a857c$var$ce = $17f526922e4a857c$var$ia && "TextEvent" in window && !$17f526922e4a857c$var$be, $17f526922e4a857c$var$de = $17f526922e4a857c$var$ia && (!$17f526922e4a857c$var$ae || $17f526922e4a857c$var$be && 8 < $17f526922e4a857c$var$be && 11 >= $17f526922e4a857c$var$be), $17f526922e4a857c$var$ee = String.fromCharCode(32), $17f526922e4a857c$var$fe = !1;
function $17f526922e4a857c$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $17f526922e4a857c$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $17f526922e4a857c$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $17f526922e4a857c$var$ie = !1;
function $17f526922e4a857c$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $17f526922e4a857c$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $17f526922e4a857c$var$fe = !0;
            return $17f526922e4a857c$var$ee;
        case "textInput":
            return a = b.data, a === $17f526922e4a857c$var$ee && $17f526922e4a857c$var$fe ? null : a;
        default:
            return null;
    }
}
function $17f526922e4a857c$var$ke(a, b) {
    if ($17f526922e4a857c$var$ie) return "compositionend" === a || !$17f526922e4a857c$var$ae && $17f526922e4a857c$var$ge(a, b) ? (a = $17f526922e4a857c$var$nd(), $17f526922e4a857c$var$md = $17f526922e4a857c$var$ld = $17f526922e4a857c$var$kd = null, $17f526922e4a857c$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $17f526922e4a857c$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $17f526922e4a857c$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $17f526922e4a857c$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$17f526922e4a857c$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $17f526922e4a857c$var$ne(a, b, c, d) {
    $17f526922e4a857c$var$Eb(d);
    b = $17f526922e4a857c$var$oe(b, "onChange");
    0 < b.length && (c = new $17f526922e4a857c$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $17f526922e4a857c$var$pe = null, $17f526922e4a857c$var$qe = null;
function $17f526922e4a857c$var$re(a) {
    $17f526922e4a857c$var$se(a, 0);
}
function $17f526922e4a857c$var$te(a) {
    var b = $17f526922e4a857c$var$ue(a);
    if ($17f526922e4a857c$var$Wa(b)) return a;
}
function $17f526922e4a857c$var$ve(a, b) {
    if ("change" === a) return b;
}
var $17f526922e4a857c$var$we = !1;
if ($17f526922e4a857c$var$ia) {
    var $17f526922e4a857c$var$xe;
    if ($17f526922e4a857c$var$ia) {
        var $17f526922e4a857c$var$ye = "oninput" in document;
        if (!$17f526922e4a857c$var$ye) {
            var $17f526922e4a857c$var$ze = document.createElement("div");
            $17f526922e4a857c$var$ze.setAttribute("oninput", "return;");
            $17f526922e4a857c$var$ye = "function" === typeof $17f526922e4a857c$var$ze.oninput;
        }
        $17f526922e4a857c$var$xe = $17f526922e4a857c$var$ye;
    } else $17f526922e4a857c$var$xe = !1;
    $17f526922e4a857c$var$we = $17f526922e4a857c$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $17f526922e4a857c$var$Ae() {
    $17f526922e4a857c$var$pe && ($17f526922e4a857c$var$pe.detachEvent("onpropertychange", $17f526922e4a857c$var$Be), $17f526922e4a857c$var$qe = $17f526922e4a857c$var$pe = null);
}
function $17f526922e4a857c$var$Be(a) {
    if ("value" === a.propertyName && $17f526922e4a857c$var$te($17f526922e4a857c$var$qe)) {
        var b = [];
        $17f526922e4a857c$var$ne(b, $17f526922e4a857c$var$qe, a, $17f526922e4a857c$var$xb(a));
        $17f526922e4a857c$var$Jb($17f526922e4a857c$var$re, b);
    }
}
function $17f526922e4a857c$var$Ce(a, b, c) {
    "focusin" === a ? ($17f526922e4a857c$var$Ae(), $17f526922e4a857c$var$pe = b, $17f526922e4a857c$var$qe = c, $17f526922e4a857c$var$pe.attachEvent("onpropertychange", $17f526922e4a857c$var$Be)) : "focusout" === a && $17f526922e4a857c$var$Ae();
}
function $17f526922e4a857c$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $17f526922e4a857c$var$te($17f526922e4a857c$var$qe);
}
function $17f526922e4a857c$var$Ee(a, b) {
    if ("click" === a) return $17f526922e4a857c$var$te(b);
}
function $17f526922e4a857c$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $17f526922e4a857c$var$te(b);
}
function $17f526922e4a857c$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $17f526922e4a857c$var$He = "function" === typeof Object.is ? Object.is : $17f526922e4a857c$var$Ge;
function $17f526922e4a857c$var$Ie(a, b) {
    if ($17f526922e4a857c$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$17f526922e4a857c$var$ja.call(b, e) || !$17f526922e4a857c$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $17f526922e4a857c$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $17f526922e4a857c$var$Ke(a, b) {
    var c = $17f526922e4a857c$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $17f526922e4a857c$var$Je(c);
    }
}
function $17f526922e4a857c$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $17f526922e4a857c$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $17f526922e4a857c$var$Me() {
    for(var a = window, b = $17f526922e4a857c$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $17f526922e4a857c$var$Xa(a.document);
    }
    return b;
}
function $17f526922e4a857c$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $17f526922e4a857c$var$Oe(a) {
    var b = $17f526922e4a857c$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $17f526922e4a857c$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $17f526922e4a857c$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $17f526922e4a857c$var$Ke(c, f);
                var g = $17f526922e4a857c$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $17f526922e4a857c$var$Pe = $17f526922e4a857c$var$ia && "documentMode" in document && 11 >= document.documentMode, $17f526922e4a857c$var$Qe = null, $17f526922e4a857c$var$Re = null, $17f526922e4a857c$var$Se = null, $17f526922e4a857c$var$Te = !1;
function $17f526922e4a857c$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $17f526922e4a857c$var$Te || null == $17f526922e4a857c$var$Qe || $17f526922e4a857c$var$Qe !== $17f526922e4a857c$var$Xa(d) || (d = $17f526922e4a857c$var$Qe, "selectionStart" in d && $17f526922e4a857c$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $17f526922e4a857c$var$Se && $17f526922e4a857c$var$Ie($17f526922e4a857c$var$Se, d) || ($17f526922e4a857c$var$Se = d, d = $17f526922e4a857c$var$oe($17f526922e4a857c$var$Re, "onSelect"), 0 < d.length && (b = new $17f526922e4a857c$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $17f526922e4a857c$var$Qe)));
}
function $17f526922e4a857c$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $17f526922e4a857c$var$We = {
    animationend: $17f526922e4a857c$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $17f526922e4a857c$var$Ve("Animation", "AnimationIteration"),
    animationstart: $17f526922e4a857c$var$Ve("Animation", "AnimationStart"),
    transitionend: $17f526922e4a857c$var$Ve("Transition", "TransitionEnd")
}, $17f526922e4a857c$var$Xe = {}, $17f526922e4a857c$var$Ye = {};
$17f526922e4a857c$var$ia && ($17f526922e4a857c$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $17f526922e4a857c$var$We.animationend.animation, delete $17f526922e4a857c$var$We.animationiteration.animation, delete $17f526922e4a857c$var$We.animationstart.animation), "TransitionEvent" in window || delete $17f526922e4a857c$var$We.transitionend.transition);
function $17f526922e4a857c$var$Ze(a) {
    if ($17f526922e4a857c$var$Xe[a]) return $17f526922e4a857c$var$Xe[a];
    if (!$17f526922e4a857c$var$We[a]) return a;
    var b = $17f526922e4a857c$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $17f526922e4a857c$var$Ye) return $17f526922e4a857c$var$Xe[a] = b[c];
    return a;
}
var $17f526922e4a857c$var$$e = $17f526922e4a857c$var$Ze("animationend"), $17f526922e4a857c$var$af = $17f526922e4a857c$var$Ze("animationiteration"), $17f526922e4a857c$var$bf = $17f526922e4a857c$var$Ze("animationstart"), $17f526922e4a857c$var$cf = $17f526922e4a857c$var$Ze("transitionend"), $17f526922e4a857c$var$df = new Map, $17f526922e4a857c$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $17f526922e4a857c$var$ff(a, b) {
    $17f526922e4a857c$var$df.set(a, b);
    $17f526922e4a857c$var$fa(b, [
        a
    ]);
}
for(var $17f526922e4a857c$var$gf = 0; $17f526922e4a857c$var$gf < $17f526922e4a857c$var$ef.length; $17f526922e4a857c$var$gf++){
    var $17f526922e4a857c$var$hf = $17f526922e4a857c$var$ef[$17f526922e4a857c$var$gf], $17f526922e4a857c$var$jf = $17f526922e4a857c$var$hf.toLowerCase(), $17f526922e4a857c$var$kf = $17f526922e4a857c$var$hf[0].toUpperCase() + $17f526922e4a857c$var$hf.slice(1);
    $17f526922e4a857c$var$ff($17f526922e4a857c$var$jf, "on" + $17f526922e4a857c$var$kf);
}
$17f526922e4a857c$var$ff($17f526922e4a857c$var$$e, "onAnimationEnd");
$17f526922e4a857c$var$ff($17f526922e4a857c$var$af, "onAnimationIteration");
$17f526922e4a857c$var$ff($17f526922e4a857c$var$bf, "onAnimationStart");
$17f526922e4a857c$var$ff("dblclick", "onDoubleClick");
$17f526922e4a857c$var$ff("focusin", "onFocus");
$17f526922e4a857c$var$ff("focusout", "onBlur");
$17f526922e4a857c$var$ff($17f526922e4a857c$var$cf, "onTransitionEnd");
$17f526922e4a857c$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$17f526922e4a857c$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$17f526922e4a857c$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$17f526922e4a857c$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$17f526922e4a857c$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$17f526922e4a857c$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$17f526922e4a857c$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$17f526922e4a857c$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$17f526922e4a857c$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$17f526922e4a857c$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $17f526922e4a857c$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $17f526922e4a857c$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($17f526922e4a857c$var$lf));
function $17f526922e4a857c$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $17f526922e4a857c$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $17f526922e4a857c$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $17f526922e4a857c$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $17f526922e4a857c$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($17f526922e4a857c$var$Qb) throw a = $17f526922e4a857c$var$Rb, $17f526922e4a857c$var$Qb = !1, $17f526922e4a857c$var$Rb = null, a;
}
function $17f526922e4a857c$var$D(a, b) {
    var c = b[$17f526922e4a857c$var$of];
    void 0 === c && (c = b[$17f526922e4a857c$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($17f526922e4a857c$var$pf(b, a, 2, !1), c.add(d));
}
function $17f526922e4a857c$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $17f526922e4a857c$var$pf(c, a, d, b);
}
var $17f526922e4a857c$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $17f526922e4a857c$var$sf(a) {
    if (!a[$17f526922e4a857c$var$rf]) {
        a[$17f526922e4a857c$var$rf] = !0;
        $17f526922e4a857c$var$da.forEach(function(b) {
            "selectionchange" !== b && ($17f526922e4a857c$var$mf.has(b) || $17f526922e4a857c$var$qf(b, !1, a), $17f526922e4a857c$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$17f526922e4a857c$var$rf] || (b[$17f526922e4a857c$var$rf] = !0, $17f526922e4a857c$var$qf("selectionchange", !1, b));
    }
}
function $17f526922e4a857c$var$pf(a, b, c, d) {
    switch($17f526922e4a857c$var$jd(b)){
        case 1:
            var e = $17f526922e4a857c$var$ed;
            break;
        case 4:
            e = $17f526922e4a857c$var$gd;
            break;
        default:
            e = $17f526922e4a857c$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$17f526922e4a857c$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $17f526922e4a857c$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $17f526922e4a857c$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $17f526922e4a857c$var$Jb(function() {
        var d = f, e = $17f526922e4a857c$var$xb(c), g = [];
        a: {
            var h = $17f526922e4a857c$var$df.get(a);
            if (void 0 !== h) {
                var k = $17f526922e4a857c$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $17f526922e4a857c$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $17f526922e4a857c$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $17f526922e4a857c$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $17f526922e4a857c$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $17f526922e4a857c$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $17f526922e4a857c$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $17f526922e4a857c$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $17f526922e4a857c$var$Vd;
                        break;
                    case $17f526922e4a857c$var$$e:
                    case $17f526922e4a857c$var$af:
                    case $17f526922e4a857c$var$bf:
                        k = $17f526922e4a857c$var$Hd;
                        break;
                    case $17f526922e4a857c$var$cf:
                        k = $17f526922e4a857c$var$Xd;
                        break;
                    case "scroll":
                        k = $17f526922e4a857c$var$vd;
                        break;
                    case "wheel":
                        k = $17f526922e4a857c$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $17f526922e4a857c$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $17f526922e4a857c$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $17f526922e4a857c$var$Kb(w, x), null != F && t.push($17f526922e4a857c$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $17f526922e4a857c$var$wb && (n = c.relatedTarget || c.fromElement) && ($17f526922e4a857c$var$Wc(n) || n[$17f526922e4a857c$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $17f526922e4a857c$var$Wc(n) : null, null !== n && (J = $17f526922e4a857c$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $17f526922e4a857c$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $17f526922e4a857c$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $17f526922e4a857c$var$ue(k);
                        u = null == n ? h : $17f526922e4a857c$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $17f526922e4a857c$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $17f526922e4a857c$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $17f526922e4a857c$var$vf(F))u++;
                            for(; 0 < w - u;)t = $17f526922e4a857c$var$vf(t), w--;
                            for(; 0 < u - w;)x = $17f526922e4a857c$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $17f526922e4a857c$var$vf(t);
                                x = $17f526922e4a857c$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $17f526922e4a857c$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $17f526922e4a857c$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $17f526922e4a857c$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $17f526922e4a857c$var$ve;
                else if ($17f526922e4a857c$var$me(h)) {
                    if ($17f526922e4a857c$var$we) na = $17f526922e4a857c$var$Fe;
                    else {
                        na = $17f526922e4a857c$var$De;
                        var xa = $17f526922e4a857c$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $17f526922e4a857c$var$Ee);
                if (na && (na = na(a, d))) {
                    $17f526922e4a857c$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $17f526922e4a857c$var$cb(h, "number", h.value);
            }
            xa = d ? $17f526922e4a857c$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($17f526922e4a857c$var$me(xa) || "true" === xa.contentEditable) $17f526922e4a857c$var$Qe = xa, $17f526922e4a857c$var$Re = d, $17f526922e4a857c$var$Se = null;
                    break;
                case "focusout":
                    $17f526922e4a857c$var$Se = $17f526922e4a857c$var$Re = $17f526922e4a857c$var$Qe = null;
                    break;
                case "mousedown":
                    $17f526922e4a857c$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $17f526922e4a857c$var$Te = !1;
                    $17f526922e4a857c$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($17f526922e4a857c$var$Pe) break;
                case "keydown":
                case "keyup":
                    $17f526922e4a857c$var$Ue(g, c, e);
            }
            var $a;
            if ($17f526922e4a857c$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $17f526922e4a857c$var$ie ? $17f526922e4a857c$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($17f526922e4a857c$var$de && "ko" !== c.locale && ($17f526922e4a857c$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $17f526922e4a857c$var$ie && ($a = $17f526922e4a857c$var$nd()) : ($17f526922e4a857c$var$kd = e, $17f526922e4a857c$var$ld = "value" in $17f526922e4a857c$var$kd ? $17f526922e4a857c$var$kd.value : $17f526922e4a857c$var$kd.textContent, $17f526922e4a857c$var$ie = !0)), xa = $17f526922e4a857c$var$oe(d, ba), 0 < xa.length && (ba = new $17f526922e4a857c$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $17f526922e4a857c$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $17f526922e4a857c$var$ce ? $17f526922e4a857c$var$je(a, c) : $17f526922e4a857c$var$ke(a, c)) d = $17f526922e4a857c$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $17f526922e4a857c$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $17f526922e4a857c$var$se(g, b);
    });
}
function $17f526922e4a857c$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $17f526922e4a857c$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $17f526922e4a857c$var$Kb(a, c), null != f && d.unshift($17f526922e4a857c$var$tf(a, f, e)), f = $17f526922e4a857c$var$Kb(a, b), null != f && d.push($17f526922e4a857c$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $17f526922e4a857c$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $17f526922e4a857c$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $17f526922e4a857c$var$Kb(c, f), null != k && g.unshift($17f526922e4a857c$var$tf(c, k, h))) : e || (k = $17f526922e4a857c$var$Kb(c, f), null != k && g.push($17f526922e4a857c$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $17f526922e4a857c$var$xf = /\r\n?/g, $17f526922e4a857c$var$yf = /\u0000|\uFFFD/g;
function $17f526922e4a857c$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($17f526922e4a857c$var$xf, "\n").replace($17f526922e4a857c$var$yf, "");
}
function $17f526922e4a857c$var$Af(a, b, c) {
    b = $17f526922e4a857c$var$zf(b);
    if ($17f526922e4a857c$var$zf(a) !== b && c) throw Error($17f526922e4a857c$var$p(425));
}
function $17f526922e4a857c$var$Bf() {}
var $17f526922e4a857c$var$Cf = null, $17f526922e4a857c$var$Df = null;
function $17f526922e4a857c$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $17f526922e4a857c$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $17f526922e4a857c$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $17f526922e4a857c$var$Hf = "function" === typeof Promise ? Promise : void 0, $17f526922e4a857c$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $17f526922e4a857c$var$Hf ? function(a) {
    return $17f526922e4a857c$var$Hf.resolve(null).then(a).catch($17f526922e4a857c$var$If);
} : $17f526922e4a857c$var$Ff;
function $17f526922e4a857c$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $17f526922e4a857c$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $17f526922e4a857c$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $17f526922e4a857c$var$bd(b);
}
function $17f526922e4a857c$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $17f526922e4a857c$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $17f526922e4a857c$var$Nf = Math.random().toString(36).slice(2), $17f526922e4a857c$var$Of = "__reactFiber$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$Pf = "__reactProps$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$uf = "__reactContainer$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$of = "__reactEvents$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$Qf = "__reactListeners$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$Rf = "__reactHandles$" + $17f526922e4a857c$var$Nf;
function $17f526922e4a857c$var$Wc(a) {
    var b = a[$17f526922e4a857c$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$17f526922e4a857c$var$uf] || c[$17f526922e4a857c$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $17f526922e4a857c$var$Mf(a); null !== a;){
                if (c = a[$17f526922e4a857c$var$Of]) return c;
                a = $17f526922e4a857c$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $17f526922e4a857c$var$Cb(a) {
    a = a[$17f526922e4a857c$var$Of] || a[$17f526922e4a857c$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $17f526922e4a857c$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($17f526922e4a857c$var$p(33));
}
function $17f526922e4a857c$var$Db(a) {
    return a[$17f526922e4a857c$var$Pf] || null;
}
var $17f526922e4a857c$var$Sf = [], $17f526922e4a857c$var$Tf = -1;
function $17f526922e4a857c$var$Uf(a) {
    return {
        current: a
    };
}
function $17f526922e4a857c$var$E(a) {
    0 > $17f526922e4a857c$var$Tf || (a.current = $17f526922e4a857c$var$Sf[$17f526922e4a857c$var$Tf], $17f526922e4a857c$var$Sf[$17f526922e4a857c$var$Tf] = null, $17f526922e4a857c$var$Tf--);
}
function $17f526922e4a857c$var$G(a, b) {
    $17f526922e4a857c$var$Tf++;
    $17f526922e4a857c$var$Sf[$17f526922e4a857c$var$Tf] = a.current;
    a.current = b;
}
var $17f526922e4a857c$var$Vf = {}, $17f526922e4a857c$var$H = $17f526922e4a857c$var$Uf($17f526922e4a857c$var$Vf), $17f526922e4a857c$var$Wf = $17f526922e4a857c$var$Uf(!1), $17f526922e4a857c$var$Xf = $17f526922e4a857c$var$Vf;
function $17f526922e4a857c$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $17f526922e4a857c$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $17f526922e4a857c$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $17f526922e4a857c$var$$f() {
    $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf);
    $17f526922e4a857c$var$E($17f526922e4a857c$var$H);
}
function $17f526922e4a857c$var$ag(a, b, c) {
    if ($17f526922e4a857c$var$H.current !== $17f526922e4a857c$var$Vf) throw Error($17f526922e4a857c$var$p(168));
    $17f526922e4a857c$var$G($17f526922e4a857c$var$H, b);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$Wf, c);
}
function $17f526922e4a857c$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($17f526922e4a857c$var$p(108, $17f526922e4a857c$var$Ra(a) || "Unknown", e));
    return $17f526922e4a857c$var$A({}, c, d);
}
function $17f526922e4a857c$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $17f526922e4a857c$var$Vf;
    $17f526922e4a857c$var$Xf = $17f526922e4a857c$var$H.current;
    $17f526922e4a857c$var$G($17f526922e4a857c$var$H, a);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$Wf, $17f526922e4a857c$var$Wf.current);
    return !0;
}
function $17f526922e4a857c$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($17f526922e4a857c$var$p(169));
    c ? (a = $17f526922e4a857c$var$bg(a, b, $17f526922e4a857c$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf), $17f526922e4a857c$var$E($17f526922e4a857c$var$H), $17f526922e4a857c$var$G($17f526922e4a857c$var$H, a)) : $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$Wf, c);
}
var $17f526922e4a857c$var$eg = null, $17f526922e4a857c$var$fg = !1, $17f526922e4a857c$var$gg = !1;
function $17f526922e4a857c$var$hg(a) {
    null === $17f526922e4a857c$var$eg ? $17f526922e4a857c$var$eg = [
        a
    ] : $17f526922e4a857c$var$eg.push(a);
}
function $17f526922e4a857c$var$ig(a) {
    $17f526922e4a857c$var$fg = !0;
    $17f526922e4a857c$var$hg(a);
}
function $17f526922e4a857c$var$jg() {
    if (!$17f526922e4a857c$var$gg && null !== $17f526922e4a857c$var$eg) {
        $17f526922e4a857c$var$gg = !0;
        var a = 0, b = $17f526922e4a857c$var$C;
        try {
            var c = $17f526922e4a857c$var$eg;
            for($17f526922e4a857c$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $17f526922e4a857c$var$eg = null;
            $17f526922e4a857c$var$fg = !1;
        } catch (e) {
            throw null !== $17f526922e4a857c$var$eg && ($17f526922e4a857c$var$eg = $17f526922e4a857c$var$eg.slice(a + 1)), $17f526922e4a857c$var$ac($17f526922e4a857c$var$fc, $17f526922e4a857c$var$jg), e;
        } finally{
            $17f526922e4a857c$var$C = b, $17f526922e4a857c$var$gg = !1;
        }
    }
    return null;
}
var $17f526922e4a857c$var$kg = [], $17f526922e4a857c$var$lg = 0, $17f526922e4a857c$var$mg = null, $17f526922e4a857c$var$ng = 0, $17f526922e4a857c$var$og = [], $17f526922e4a857c$var$pg = 0, $17f526922e4a857c$var$qg = null, $17f526922e4a857c$var$rg = 1, $17f526922e4a857c$var$sg = "";
function $17f526922e4a857c$var$tg(a, b) {
    $17f526922e4a857c$var$kg[$17f526922e4a857c$var$lg++] = $17f526922e4a857c$var$ng;
    $17f526922e4a857c$var$kg[$17f526922e4a857c$var$lg++] = $17f526922e4a857c$var$mg;
    $17f526922e4a857c$var$mg = a;
    $17f526922e4a857c$var$ng = b;
}
function $17f526922e4a857c$var$ug(a, b, c) {
    $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$rg;
    $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$sg;
    $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$qg;
    $17f526922e4a857c$var$qg = a;
    var d = $17f526922e4a857c$var$rg;
    a = $17f526922e4a857c$var$sg;
    var e = 32 - $17f526922e4a857c$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $17f526922e4a857c$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $17f526922e4a857c$var$rg = 1 << 32 - $17f526922e4a857c$var$oc(b) + e | c << e | d;
        $17f526922e4a857c$var$sg = f + a;
    } else $17f526922e4a857c$var$rg = 1 << f | c << e | d, $17f526922e4a857c$var$sg = a;
}
function $17f526922e4a857c$var$vg(a) {
    null !== a.return && ($17f526922e4a857c$var$tg(a, 1), $17f526922e4a857c$var$ug(a, 1, 0));
}
function $17f526922e4a857c$var$wg(a) {
    for(; a === $17f526922e4a857c$var$mg;)$17f526922e4a857c$var$mg = $17f526922e4a857c$var$kg[--$17f526922e4a857c$var$lg], $17f526922e4a857c$var$kg[$17f526922e4a857c$var$lg] = null, $17f526922e4a857c$var$ng = $17f526922e4a857c$var$kg[--$17f526922e4a857c$var$lg], $17f526922e4a857c$var$kg[$17f526922e4a857c$var$lg] = null;
    for(; a === $17f526922e4a857c$var$qg;)$17f526922e4a857c$var$qg = $17f526922e4a857c$var$og[--$17f526922e4a857c$var$pg], $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg] = null, $17f526922e4a857c$var$sg = $17f526922e4a857c$var$og[--$17f526922e4a857c$var$pg], $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg] = null, $17f526922e4a857c$var$rg = $17f526922e4a857c$var$og[--$17f526922e4a857c$var$pg], $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg] = null;
}
var $17f526922e4a857c$var$xg = null, $17f526922e4a857c$var$yg = null, $17f526922e4a857c$var$I = !1, $17f526922e4a857c$var$zg = null;
function $17f526922e4a857c$var$Ag(a, b) {
    var c = $17f526922e4a857c$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $17f526922e4a857c$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $17f526922e4a857c$var$xg = a, $17f526922e4a857c$var$yg = $17f526922e4a857c$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $17f526922e4a857c$var$xg = a, $17f526922e4a857c$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $17f526922e4a857c$var$qg ? {
                id: $17f526922e4a857c$var$rg,
                overflow: $17f526922e4a857c$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $17f526922e4a857c$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $17f526922e4a857c$var$xg = a, $17f526922e4a857c$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $17f526922e4a857c$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $17f526922e4a857c$var$Eg(a) {
    if ($17f526922e4a857c$var$I) {
        var b = $17f526922e4a857c$var$yg;
        if (b) {
            var c = b;
            if (!$17f526922e4a857c$var$Cg(a, b)) {
                if ($17f526922e4a857c$var$Dg(a)) throw Error($17f526922e4a857c$var$p(418));
                b = $17f526922e4a857c$var$Lf(c.nextSibling);
                var d = $17f526922e4a857c$var$xg;
                b && $17f526922e4a857c$var$Cg(a, b) ? $17f526922e4a857c$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $17f526922e4a857c$var$I = !1, $17f526922e4a857c$var$xg = a);
            }
        } else {
            if ($17f526922e4a857c$var$Dg(a)) throw Error($17f526922e4a857c$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $17f526922e4a857c$var$I = !1;
            $17f526922e4a857c$var$xg = a;
        }
    }
}
function $17f526922e4a857c$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $17f526922e4a857c$var$xg = a;
}
function $17f526922e4a857c$var$Gg(a) {
    if (a !== $17f526922e4a857c$var$xg) return !1;
    if (!$17f526922e4a857c$var$I) return $17f526922e4a857c$var$Fg(a), $17f526922e4a857c$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$17f526922e4a857c$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $17f526922e4a857c$var$yg)) {
        if ($17f526922e4a857c$var$Dg(a)) throw $17f526922e4a857c$var$Hg(), Error($17f526922e4a857c$var$p(418));
        for(; b;)$17f526922e4a857c$var$Ag(a, b), b = $17f526922e4a857c$var$Lf(b.nextSibling);
    }
    $17f526922e4a857c$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($17f526922e4a857c$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $17f526922e4a857c$var$yg = $17f526922e4a857c$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $17f526922e4a857c$var$yg = null;
        }
    } else $17f526922e4a857c$var$yg = $17f526922e4a857c$var$xg ? $17f526922e4a857c$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $17f526922e4a857c$var$Hg() {
    for(var a = $17f526922e4a857c$var$yg; a;)a = $17f526922e4a857c$var$Lf(a.nextSibling);
}
function $17f526922e4a857c$var$Ig() {
    $17f526922e4a857c$var$yg = $17f526922e4a857c$var$xg = null;
    $17f526922e4a857c$var$I = !1;
}
function $17f526922e4a857c$var$Jg(a) {
    null === $17f526922e4a857c$var$zg ? $17f526922e4a857c$var$zg = [
        a
    ] : $17f526922e4a857c$var$zg.push(a);
}
var $17f526922e4a857c$var$Kg = $17f526922e4a857c$var$ua.ReactCurrentBatchConfig;
function $17f526922e4a857c$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($17f526922e4a857c$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($17f526922e4a857c$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($17f526922e4a857c$var$p(284));
        if (!c._owner) throw Error($17f526922e4a857c$var$p(290, a));
    }
    return a;
}
function $17f526922e4a857c$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($17f526922e4a857c$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $17f526922e4a857c$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $17f526922e4a857c$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $17f526922e4a857c$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $17f526922e4a857c$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $17f526922e4a857c$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $17f526922e4a857c$var$Ha && $17f526922e4a857c$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $17f526922e4a857c$var$Lg(a, b, c), d.return = a, d;
        d = $17f526922e4a857c$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $17f526922e4a857c$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $17f526922e4a857c$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $17f526922e4a857c$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $17f526922e4a857c$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $17f526922e4a857c$var$va:
                    return c = $17f526922e4a857c$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $17f526922e4a857c$var$Lg(a, null, b), c.return = a, c;
                case $17f526922e4a857c$var$wa:
                    return b = $17f526922e4a857c$var$Sg(b, a.mode, c), b.return = a, b;
                case $17f526922e4a857c$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($17f526922e4a857c$var$eb(b) || $17f526922e4a857c$var$Ka(b)) return b = $17f526922e4a857c$var$Tg(b, a.mode, c, null), b.return = a, b;
            $17f526922e4a857c$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $17f526922e4a857c$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $17f526922e4a857c$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $17f526922e4a857c$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($17f526922e4a857c$var$eb(c) || $17f526922e4a857c$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $17f526922e4a857c$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $17f526922e4a857c$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $17f526922e4a857c$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $17f526922e4a857c$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($17f526922e4a857c$var$eb(d) || $17f526922e4a857c$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $17f526922e4a857c$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $17f526922e4a857c$var$Ka(h);
        if ("function" !== typeof l) throw Error($17f526922e4a857c$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($17f526922e4a857c$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $17f526922e4a857c$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $17f526922e4a857c$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $17f526922e4a857c$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $17f526922e4a857c$var$Ha && $17f526922e4a857c$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $17f526922e4a857c$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $17f526922e4a857c$var$ya ? (d = $17f526922e4a857c$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $17f526922e4a857c$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $17f526922e4a857c$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $17f526922e4a857c$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $17f526922e4a857c$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $17f526922e4a857c$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($17f526922e4a857c$var$eb(f)) return n(a, d, f, h);
            if ($17f526922e4a857c$var$Ka(f)) return t(a, d, f, h);
            $17f526922e4a857c$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $17f526922e4a857c$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $17f526922e4a857c$var$Ug = $17f526922e4a857c$var$Og(!0), $17f526922e4a857c$var$Vg = $17f526922e4a857c$var$Og(!1), $17f526922e4a857c$var$Wg = $17f526922e4a857c$var$Uf(null), $17f526922e4a857c$var$Xg = null, $17f526922e4a857c$var$Yg = null, $17f526922e4a857c$var$Zg = null;
function $17f526922e4a857c$var$$g() {
    $17f526922e4a857c$var$Zg = $17f526922e4a857c$var$Yg = $17f526922e4a857c$var$Xg = null;
}
function $17f526922e4a857c$var$ah(a) {
    var b = $17f526922e4a857c$var$Wg.current;
    $17f526922e4a857c$var$E($17f526922e4a857c$var$Wg);
    a._currentValue = b;
}
function $17f526922e4a857c$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $17f526922e4a857c$var$ch(a, b) {
    $17f526922e4a857c$var$Xg = a;
    $17f526922e4a857c$var$Zg = $17f526922e4a857c$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($17f526922e4a857c$var$dh = !0), a.firstContext = null);
}
function $17f526922e4a857c$var$eh(a) {
    var b = a._currentValue;
    if ($17f526922e4a857c$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $17f526922e4a857c$var$Yg) {
            if (null === $17f526922e4a857c$var$Xg) throw Error($17f526922e4a857c$var$p(308));
            $17f526922e4a857c$var$Yg = a;
            $17f526922e4a857c$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $17f526922e4a857c$var$Yg = $17f526922e4a857c$var$Yg.next = a;
    }
    return b;
}
var $17f526922e4a857c$var$fh = null;
function $17f526922e4a857c$var$gh(a) {
    null === $17f526922e4a857c$var$fh ? $17f526922e4a857c$var$fh = [
        a
    ] : $17f526922e4a857c$var$fh.push(a);
}
function $17f526922e4a857c$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $17f526922e4a857c$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $17f526922e4a857c$var$ih(a, d);
}
function $17f526922e4a857c$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $17f526922e4a857c$var$jh = !1;
function $17f526922e4a857c$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $17f526922e4a857c$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $17f526922e4a857c$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $17f526922e4a857c$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($17f526922e4a857c$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $17f526922e4a857c$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $17f526922e4a857c$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $17f526922e4a857c$var$ih(a, c);
}
function $17f526922e4a857c$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $17f526922e4a857c$var$Cc(a, c);
    }
}
function $17f526922e4a857c$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $17f526922e4a857c$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $17f526922e4a857c$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $17f526922e4a857c$var$A({}, q, r);
                            break a;
                        case 2:
                            $17f526922e4a857c$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $17f526922e4a857c$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $17f526922e4a857c$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($17f526922e4a857c$var$p(191, e));
            e.call(d);
        }
    }
}
var $17f526922e4a857c$var$th = {}, $17f526922e4a857c$var$uh = $17f526922e4a857c$var$Uf($17f526922e4a857c$var$th), $17f526922e4a857c$var$vh = $17f526922e4a857c$var$Uf($17f526922e4a857c$var$th), $17f526922e4a857c$var$wh = $17f526922e4a857c$var$Uf($17f526922e4a857c$var$th);
function $17f526922e4a857c$var$xh(a) {
    if (a === $17f526922e4a857c$var$th) throw Error($17f526922e4a857c$var$p(174));
    return a;
}
function $17f526922e4a857c$var$yh(a, b) {
    $17f526922e4a857c$var$G($17f526922e4a857c$var$wh, b);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$vh, a);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$uh, $17f526922e4a857c$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $17f526922e4a857c$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $17f526922e4a857c$var$lb(b, a);
    }
    $17f526922e4a857c$var$E($17f526922e4a857c$var$uh);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$uh, b);
}
function $17f526922e4a857c$var$zh() {
    $17f526922e4a857c$var$E($17f526922e4a857c$var$uh);
    $17f526922e4a857c$var$E($17f526922e4a857c$var$vh);
    $17f526922e4a857c$var$E($17f526922e4a857c$var$wh);
}
function $17f526922e4a857c$var$Ah(a) {
    $17f526922e4a857c$var$xh($17f526922e4a857c$var$wh.current);
    var b = $17f526922e4a857c$var$xh($17f526922e4a857c$var$uh.current);
    var c = $17f526922e4a857c$var$lb(b, a.type);
    b !== c && ($17f526922e4a857c$var$G($17f526922e4a857c$var$vh, a), $17f526922e4a857c$var$G($17f526922e4a857c$var$uh, c));
}
function $17f526922e4a857c$var$Bh(a) {
    $17f526922e4a857c$var$vh.current === a && ($17f526922e4a857c$var$E($17f526922e4a857c$var$uh), $17f526922e4a857c$var$E($17f526922e4a857c$var$vh));
}
var $17f526922e4a857c$var$L = $17f526922e4a857c$var$Uf(0);
function $17f526922e4a857c$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $17f526922e4a857c$var$Dh = [];
function $17f526922e4a857c$var$Eh() {
    for(var a = 0; a < $17f526922e4a857c$var$Dh.length; a++)$17f526922e4a857c$var$Dh[a]._workInProgressVersionPrimary = null;
    $17f526922e4a857c$var$Dh.length = 0;
}
var $17f526922e4a857c$var$Fh = $17f526922e4a857c$var$ua.ReactCurrentDispatcher, $17f526922e4a857c$var$Gh = $17f526922e4a857c$var$ua.ReactCurrentBatchConfig, $17f526922e4a857c$var$Hh = 0, $17f526922e4a857c$var$M = null, $17f526922e4a857c$var$N = null, $17f526922e4a857c$var$O = null, $17f526922e4a857c$var$Ih = !1, $17f526922e4a857c$var$Jh = !1, $17f526922e4a857c$var$Kh = 0, $17f526922e4a857c$var$Lh = 0;
function $17f526922e4a857c$var$P() {
    throw Error($17f526922e4a857c$var$p(321));
}
function $17f526922e4a857c$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$17f526922e4a857c$var$He(a[c], b[c])) return !1;
    return !0;
}
function $17f526922e4a857c$var$Nh(a, b, c, d, e, f) {
    $17f526922e4a857c$var$Hh = f;
    $17f526922e4a857c$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $17f526922e4a857c$var$Fh.current = null === a || null === a.memoizedState ? $17f526922e4a857c$var$Oh : $17f526922e4a857c$var$Ph;
    a = c(d, e);
    if ($17f526922e4a857c$var$Jh) {
        f = 0;
        do {
            $17f526922e4a857c$var$Jh = !1;
            $17f526922e4a857c$var$Kh = 0;
            if (25 <= f) throw Error($17f526922e4a857c$var$p(301));
            f += 1;
            $17f526922e4a857c$var$O = $17f526922e4a857c$var$N = null;
            b.updateQueue = null;
            $17f526922e4a857c$var$Fh.current = $17f526922e4a857c$var$Qh;
            a = c(d, e);
        }while ($17f526922e4a857c$var$Jh);
    }
    $17f526922e4a857c$var$Fh.current = $17f526922e4a857c$var$Rh;
    b = null !== $17f526922e4a857c$var$N && null !== $17f526922e4a857c$var$N.next;
    $17f526922e4a857c$var$Hh = 0;
    $17f526922e4a857c$var$O = $17f526922e4a857c$var$N = $17f526922e4a857c$var$M = null;
    $17f526922e4a857c$var$Ih = !1;
    if (b) throw Error($17f526922e4a857c$var$p(300));
    return a;
}
function $17f526922e4a857c$var$Sh() {
    var a = 0 !== $17f526922e4a857c$var$Kh;
    $17f526922e4a857c$var$Kh = 0;
    return a;
}
function $17f526922e4a857c$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $17f526922e4a857c$var$O ? $17f526922e4a857c$var$M.memoizedState = $17f526922e4a857c$var$O = a : $17f526922e4a857c$var$O = $17f526922e4a857c$var$O.next = a;
    return $17f526922e4a857c$var$O;
}
function $17f526922e4a857c$var$Uh() {
    if (null === $17f526922e4a857c$var$N) {
        var a = $17f526922e4a857c$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $17f526922e4a857c$var$N.next;
    var b = null === $17f526922e4a857c$var$O ? $17f526922e4a857c$var$M.memoizedState : $17f526922e4a857c$var$O.next;
    if (null !== b) $17f526922e4a857c$var$O = b, $17f526922e4a857c$var$N = a;
    else {
        if (null === a) throw Error($17f526922e4a857c$var$p(310));
        $17f526922e4a857c$var$N = a;
        a = {
            memoizedState: $17f526922e4a857c$var$N.memoizedState,
            baseState: $17f526922e4a857c$var$N.baseState,
            baseQueue: $17f526922e4a857c$var$N.baseQueue,
            queue: $17f526922e4a857c$var$N.queue,
            next: null
        };
        null === $17f526922e4a857c$var$O ? $17f526922e4a857c$var$M.memoizedState = $17f526922e4a857c$var$O = a : $17f526922e4a857c$var$O = $17f526922e4a857c$var$O.next = a;
    }
    return $17f526922e4a857c$var$O;
}
function $17f526922e4a857c$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $17f526922e4a857c$var$Wh(a) {
    var b = $17f526922e4a857c$var$Uh(), c = b.queue;
    if (null === c) throw Error($17f526922e4a857c$var$p(311));
    c.lastRenderedReducer = a;
    var d = $17f526922e4a857c$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($17f526922e4a857c$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $17f526922e4a857c$var$M.lanes |= m;
                $17f526922e4a857c$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $17f526922e4a857c$var$He(d, b.memoizedState) || ($17f526922e4a857c$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $17f526922e4a857c$var$M.lanes |= f, $17f526922e4a857c$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $17f526922e4a857c$var$Xh(a) {
    var b = $17f526922e4a857c$var$Uh(), c = b.queue;
    if (null === c) throw Error($17f526922e4a857c$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $17f526922e4a857c$var$He(f, b.memoizedState) || ($17f526922e4a857c$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $17f526922e4a857c$var$Yh() {}
function $17f526922e4a857c$var$Zh(a, b) {
    var c = $17f526922e4a857c$var$M, d = $17f526922e4a857c$var$Uh(), e = b(), f = !$17f526922e4a857c$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $17f526922e4a857c$var$dh = !0);
    d = d.queue;
    $17f526922e4a857c$var$$h($17f526922e4a857c$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $17f526922e4a857c$var$O && $17f526922e4a857c$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $17f526922e4a857c$var$bi(9, $17f526922e4a857c$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $17f526922e4a857c$var$Q) throw Error($17f526922e4a857c$var$p(349));
        0 !== ($17f526922e4a857c$var$Hh & 30) || $17f526922e4a857c$var$di(c, b, e);
    }
    return e;
}
function $17f526922e4a857c$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $17f526922e4a857c$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $17f526922e4a857c$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $17f526922e4a857c$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $17f526922e4a857c$var$ei(b) && $17f526922e4a857c$var$fi(a);
}
function $17f526922e4a857c$var$ai(a, b, c) {
    return c(function() {
        $17f526922e4a857c$var$ei(b) && $17f526922e4a857c$var$fi(a);
    });
}
function $17f526922e4a857c$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$17f526922e4a857c$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $17f526922e4a857c$var$fi(a) {
    var b = $17f526922e4a857c$var$ih(a, 1);
    null !== b && $17f526922e4a857c$var$gi(b, a, 1, -1);
}
function $17f526922e4a857c$var$hi(a) {
    var b = $17f526922e4a857c$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $17f526922e4a857c$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $17f526922e4a857c$var$ii.bind(null, $17f526922e4a857c$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $17f526922e4a857c$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $17f526922e4a857c$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $17f526922e4a857c$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $17f526922e4a857c$var$ji() {
    return $17f526922e4a857c$var$Uh().memoizedState;
}
function $17f526922e4a857c$var$ki(a, b, c, d) {
    var e = $17f526922e4a857c$var$Th();
    $17f526922e4a857c$var$M.flags |= a;
    e.memoizedState = $17f526922e4a857c$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $17f526922e4a857c$var$li(a, b, c, d) {
    var e = $17f526922e4a857c$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $17f526922e4a857c$var$N) {
        var g = $17f526922e4a857c$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $17f526922e4a857c$var$Mh(d, g.deps)) {
            e.memoizedState = $17f526922e4a857c$var$bi(b, c, f, d);
            return;
        }
    }
    $17f526922e4a857c$var$M.flags |= a;
    e.memoizedState = $17f526922e4a857c$var$bi(1 | b, c, f, d);
}
function $17f526922e4a857c$var$mi(a, b) {
    return $17f526922e4a857c$var$ki(8390656, 8, a, b);
}
function $17f526922e4a857c$var$$h(a, b) {
    return $17f526922e4a857c$var$li(2048, 8, a, b);
}
function $17f526922e4a857c$var$ni(a, b) {
    return $17f526922e4a857c$var$li(4, 2, a, b);
}
function $17f526922e4a857c$var$oi(a, b) {
    return $17f526922e4a857c$var$li(4, 4, a, b);
}
function $17f526922e4a857c$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $17f526922e4a857c$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $17f526922e4a857c$var$li(4, 4, $17f526922e4a857c$var$pi.bind(null, b, a), c);
}
function $17f526922e4a857c$var$ri() {}
function $17f526922e4a857c$var$si(a, b) {
    var c = $17f526922e4a857c$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $17f526922e4a857c$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $17f526922e4a857c$var$ti(a, b) {
    var c = $17f526922e4a857c$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $17f526922e4a857c$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $17f526922e4a857c$var$ui(a, b, c) {
    if (0 === ($17f526922e4a857c$var$Hh & 21)) return a.baseState && (a.baseState = !1, $17f526922e4a857c$var$dh = !0), a.memoizedState = c;
    $17f526922e4a857c$var$He(c, b) || (c = $17f526922e4a857c$var$yc(), $17f526922e4a857c$var$M.lanes |= c, $17f526922e4a857c$var$rh |= c, a.baseState = !0);
    return b;
}
function $17f526922e4a857c$var$vi(a, b) {
    var c = $17f526922e4a857c$var$C;
    $17f526922e4a857c$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $17f526922e4a857c$var$Gh.transition;
    $17f526922e4a857c$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $17f526922e4a857c$var$C = c, $17f526922e4a857c$var$Gh.transition = d;
    }
}
function $17f526922e4a857c$var$wi() {
    return $17f526922e4a857c$var$Uh().memoizedState;
}
function $17f526922e4a857c$var$xi(a, b, c) {
    var d = $17f526922e4a857c$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($17f526922e4a857c$var$zi(a)) $17f526922e4a857c$var$Ai(b, c);
    else if (c = $17f526922e4a857c$var$hh(a, b, c, d), null !== c) {
        var e = $17f526922e4a857c$var$R();
        $17f526922e4a857c$var$gi(c, a, d, e);
        $17f526922e4a857c$var$Bi(c, b, d);
    }
}
function $17f526922e4a857c$var$ii(a, b, c) {
    var d = $17f526922e4a857c$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($17f526922e4a857c$var$zi(a)) $17f526922e4a857c$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($17f526922e4a857c$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $17f526922e4a857c$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $17f526922e4a857c$var$hh(a, b, e, d);
        null !== c && (e = $17f526922e4a857c$var$R(), $17f526922e4a857c$var$gi(c, a, d, e), $17f526922e4a857c$var$Bi(c, b, d));
    }
}
function $17f526922e4a857c$var$zi(a) {
    var b = a.alternate;
    return a === $17f526922e4a857c$var$M || null !== b && b === $17f526922e4a857c$var$M;
}
function $17f526922e4a857c$var$Ai(a, b) {
    $17f526922e4a857c$var$Jh = $17f526922e4a857c$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $17f526922e4a857c$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $17f526922e4a857c$var$Cc(a, c);
    }
}
var $17f526922e4a857c$var$Rh = {
    readContext: $17f526922e4a857c$var$eh,
    useCallback: $17f526922e4a857c$var$P,
    useContext: $17f526922e4a857c$var$P,
    useEffect: $17f526922e4a857c$var$P,
    useImperativeHandle: $17f526922e4a857c$var$P,
    useInsertionEffect: $17f526922e4a857c$var$P,
    useLayoutEffect: $17f526922e4a857c$var$P,
    useMemo: $17f526922e4a857c$var$P,
    useReducer: $17f526922e4a857c$var$P,
    useRef: $17f526922e4a857c$var$P,
    useState: $17f526922e4a857c$var$P,
    useDebugValue: $17f526922e4a857c$var$P,
    useDeferredValue: $17f526922e4a857c$var$P,
    useTransition: $17f526922e4a857c$var$P,
    useMutableSource: $17f526922e4a857c$var$P,
    useSyncExternalStore: $17f526922e4a857c$var$P,
    useId: $17f526922e4a857c$var$P,
    unstable_isNewReconciler: !1
}, $17f526922e4a857c$var$Oh = {
    readContext: $17f526922e4a857c$var$eh,
    useCallback: function(a, b) {
        $17f526922e4a857c$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $17f526922e4a857c$var$eh,
    useEffect: $17f526922e4a857c$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $17f526922e4a857c$var$ki(4194308, 4, $17f526922e4a857c$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $17f526922e4a857c$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $17f526922e4a857c$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $17f526922e4a857c$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $17f526922e4a857c$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $17f526922e4a857c$var$xi.bind(null, $17f526922e4a857c$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $17f526922e4a857c$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $17f526922e4a857c$var$hi,
    useDebugValue: $17f526922e4a857c$var$ri,
    useDeferredValue: function(a) {
        return $17f526922e4a857c$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $17f526922e4a857c$var$hi(!1), b = a[0];
        a = $17f526922e4a857c$var$vi.bind(null, a[1]);
        $17f526922e4a857c$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $17f526922e4a857c$var$M, e = $17f526922e4a857c$var$Th();
        if ($17f526922e4a857c$var$I) {
            if (void 0 === c) throw Error($17f526922e4a857c$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $17f526922e4a857c$var$Q) throw Error($17f526922e4a857c$var$p(349));
            0 !== ($17f526922e4a857c$var$Hh & 30) || $17f526922e4a857c$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $17f526922e4a857c$var$mi($17f526922e4a857c$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $17f526922e4a857c$var$bi(9, $17f526922e4a857c$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $17f526922e4a857c$var$Th(), b = $17f526922e4a857c$var$Q.identifierPrefix;
        if ($17f526922e4a857c$var$I) {
            var c = $17f526922e4a857c$var$sg;
            var d = $17f526922e4a857c$var$rg;
            c = (d & ~(1 << 32 - $17f526922e4a857c$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $17f526922e4a857c$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $17f526922e4a857c$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $17f526922e4a857c$var$Ph = {
    readContext: $17f526922e4a857c$var$eh,
    useCallback: $17f526922e4a857c$var$si,
    useContext: $17f526922e4a857c$var$eh,
    useEffect: $17f526922e4a857c$var$$h,
    useImperativeHandle: $17f526922e4a857c$var$qi,
    useInsertionEffect: $17f526922e4a857c$var$ni,
    useLayoutEffect: $17f526922e4a857c$var$oi,
    useMemo: $17f526922e4a857c$var$ti,
    useReducer: $17f526922e4a857c$var$Wh,
    useRef: $17f526922e4a857c$var$ji,
    useState: function() {
        return $17f526922e4a857c$var$Wh($17f526922e4a857c$var$Vh);
    },
    useDebugValue: $17f526922e4a857c$var$ri,
    useDeferredValue: function(a) {
        var b = $17f526922e4a857c$var$Uh();
        return $17f526922e4a857c$var$ui(b, $17f526922e4a857c$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $17f526922e4a857c$var$Wh($17f526922e4a857c$var$Vh)[0], b = $17f526922e4a857c$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $17f526922e4a857c$var$Yh,
    useSyncExternalStore: $17f526922e4a857c$var$Zh,
    useId: $17f526922e4a857c$var$wi,
    unstable_isNewReconciler: !1
}, $17f526922e4a857c$var$Qh = {
    readContext: $17f526922e4a857c$var$eh,
    useCallback: $17f526922e4a857c$var$si,
    useContext: $17f526922e4a857c$var$eh,
    useEffect: $17f526922e4a857c$var$$h,
    useImperativeHandle: $17f526922e4a857c$var$qi,
    useInsertionEffect: $17f526922e4a857c$var$ni,
    useLayoutEffect: $17f526922e4a857c$var$oi,
    useMemo: $17f526922e4a857c$var$ti,
    useReducer: $17f526922e4a857c$var$Xh,
    useRef: $17f526922e4a857c$var$ji,
    useState: function() {
        return $17f526922e4a857c$var$Xh($17f526922e4a857c$var$Vh);
    },
    useDebugValue: $17f526922e4a857c$var$ri,
    useDeferredValue: function(a) {
        var b = $17f526922e4a857c$var$Uh();
        return null === $17f526922e4a857c$var$N ? b.memoizedState = a : $17f526922e4a857c$var$ui(b, $17f526922e4a857c$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $17f526922e4a857c$var$Xh($17f526922e4a857c$var$Vh)[0], b = $17f526922e4a857c$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $17f526922e4a857c$var$Yh,
    useSyncExternalStore: $17f526922e4a857c$var$Zh,
    useId: $17f526922e4a857c$var$wi,
    unstable_isNewReconciler: !1
};
function $17f526922e4a857c$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $17f526922e4a857c$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $17f526922e4a857c$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $17f526922e4a857c$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $17f526922e4a857c$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $17f526922e4a857c$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $17f526922e4a857c$var$R(), e = $17f526922e4a857c$var$yi(a), f = $17f526922e4a857c$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $17f526922e4a857c$var$nh(a, f, e);
        null !== b && ($17f526922e4a857c$var$gi(b, a, e, d), $17f526922e4a857c$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $17f526922e4a857c$var$R(), e = $17f526922e4a857c$var$yi(a), f = $17f526922e4a857c$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $17f526922e4a857c$var$nh(a, f, e);
        null !== b && ($17f526922e4a857c$var$gi(b, a, e, d), $17f526922e4a857c$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $17f526922e4a857c$var$R(), d = $17f526922e4a857c$var$yi(a), e = $17f526922e4a857c$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $17f526922e4a857c$var$nh(a, e, d);
        null !== b && ($17f526922e4a857c$var$gi(b, a, d, c), $17f526922e4a857c$var$oh(b, a, d));
    }
};
function $17f526922e4a857c$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$17f526922e4a857c$var$Ie(c, d) || !$17f526922e4a857c$var$Ie(e, f) : !0;
}
function $17f526922e4a857c$var$Gi(a, b, c) {
    var d = !1, e = $17f526922e4a857c$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $17f526922e4a857c$var$eh(f) : (e = $17f526922e4a857c$var$Zf(b) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $17f526922e4a857c$var$Yf(a, e) : $17f526922e4a857c$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $17f526922e4a857c$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $17f526922e4a857c$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $17f526922e4a857c$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $17f526922e4a857c$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $17f526922e4a857c$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $17f526922e4a857c$var$eh(f) : (f = $17f526922e4a857c$var$Zf(b) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current, e.context = $17f526922e4a857c$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($17f526922e4a857c$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $17f526922e4a857c$var$Ei.enqueueReplaceState(e, e.state, null), $17f526922e4a857c$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $17f526922e4a857c$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $17f526922e4a857c$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $17f526922e4a857c$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $17f526922e4a857c$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $17f526922e4a857c$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $17f526922e4a857c$var$Ni(a, b, c) {
    c = $17f526922e4a857c$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $17f526922e4a857c$var$Oi || ($17f526922e4a857c$var$Oi = !0, $17f526922e4a857c$var$Pi = d);
        $17f526922e4a857c$var$Li(a, b);
    };
    return c;
}
function $17f526922e4a857c$var$Qi(a, b, c) {
    c = $17f526922e4a857c$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $17f526922e4a857c$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $17f526922e4a857c$var$Li(a, b);
        "function" !== typeof d && (null === $17f526922e4a857c$var$Ri ? $17f526922e4a857c$var$Ri = new Set([
            this
        ]) : $17f526922e4a857c$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $17f526922e4a857c$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $17f526922e4a857c$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $17f526922e4a857c$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $17f526922e4a857c$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $17f526922e4a857c$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $17f526922e4a857c$var$mh(-1, 1), b.tag = 2, $17f526922e4a857c$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $17f526922e4a857c$var$Wi = $17f526922e4a857c$var$ua.ReactCurrentOwner, $17f526922e4a857c$var$dh = !1;
function $17f526922e4a857c$var$Xi(a, b, c, d) {
    b.child = null === a ? $17f526922e4a857c$var$Vg(b, null, c, d) : $17f526922e4a857c$var$Ug(b, a.child, c, d);
}
function $17f526922e4a857c$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $17f526922e4a857c$var$ch(b, e);
    d = $17f526922e4a857c$var$Nh(a, b, c, d, f, e);
    c = $17f526922e4a857c$var$Sh();
    if (null !== a && !$17f526922e4a857c$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $17f526922e4a857c$var$Zi(a, b, e);
    $17f526922e4a857c$var$I && c && $17f526922e4a857c$var$vg(b);
    b.flags |= 1;
    $17f526922e4a857c$var$Xi(a, b, d, e);
    return b.child;
}
function $17f526922e4a857c$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$17f526922e4a857c$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $17f526922e4a857c$var$bj(a, b, f, d, e);
        a = $17f526922e4a857c$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $17f526922e4a857c$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $17f526922e4a857c$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $17f526922e4a857c$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $17f526922e4a857c$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($17f526922e4a857c$var$Ie(f, d) && a.ref === b.ref) {
            if ($17f526922e4a857c$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($17f526922e4a857c$var$dh = !0);
            else return b.lanes = a.lanes, $17f526922e4a857c$var$Zi(a, b, e);
        }
    }
    return $17f526922e4a857c$var$cj(a, b, c, d, e);
}
function $17f526922e4a857c$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $17f526922e4a857c$var$G($17f526922e4a857c$var$ej, $17f526922e4a857c$var$fj), $17f526922e4a857c$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $17f526922e4a857c$var$G($17f526922e4a857c$var$ej, $17f526922e4a857c$var$fj), $17f526922e4a857c$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $17f526922e4a857c$var$G($17f526922e4a857c$var$ej, $17f526922e4a857c$var$fj);
            $17f526922e4a857c$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $17f526922e4a857c$var$G($17f526922e4a857c$var$ej, $17f526922e4a857c$var$fj), $17f526922e4a857c$var$fj |= d;
    $17f526922e4a857c$var$Xi(a, b, e, c);
    return b.child;
}
function $17f526922e4a857c$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $17f526922e4a857c$var$cj(a, b, c, d, e) {
    var f = $17f526922e4a857c$var$Zf(c) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current;
    f = $17f526922e4a857c$var$Yf(b, f);
    $17f526922e4a857c$var$ch(b, e);
    c = $17f526922e4a857c$var$Nh(a, b, c, d, f, e);
    d = $17f526922e4a857c$var$Sh();
    if (null !== a && !$17f526922e4a857c$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $17f526922e4a857c$var$Zi(a, b, e);
    $17f526922e4a857c$var$I && d && $17f526922e4a857c$var$vg(b);
    b.flags |= 1;
    $17f526922e4a857c$var$Xi(a, b, c, e);
    return b.child;
}
function $17f526922e4a857c$var$hj(a, b, c, d, e) {
    if ($17f526922e4a857c$var$Zf(c)) {
        var f = !0;
        $17f526922e4a857c$var$cg(b);
    } else f = !1;
    $17f526922e4a857c$var$ch(b, e);
    if (null === b.stateNode) $17f526922e4a857c$var$ij(a, b), $17f526922e4a857c$var$Gi(b, c, d), $17f526922e4a857c$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $17f526922e4a857c$var$eh(l) : (l = $17f526922e4a857c$var$Zf(c) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current, l = $17f526922e4a857c$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $17f526922e4a857c$var$Hi(b, g, d, l);
        $17f526922e4a857c$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $17f526922e4a857c$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $17f526922e4a857c$var$Wf.current || $17f526922e4a857c$var$jh ? ("function" === typeof m && ($17f526922e4a857c$var$Di(b, c, m, d), k = b.memoizedState), (h = $17f526922e4a857c$var$jh || $17f526922e4a857c$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $17f526922e4a857c$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $17f526922e4a857c$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $17f526922e4a857c$var$eh(k) : (k = $17f526922e4a857c$var$Zf(c) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current, k = $17f526922e4a857c$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $17f526922e4a857c$var$Hi(b, g, d, k);
        $17f526922e4a857c$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $17f526922e4a857c$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $17f526922e4a857c$var$Wf.current || $17f526922e4a857c$var$jh ? ("function" === typeof y && ($17f526922e4a857c$var$Di(b, c, y, d), n = b.memoizedState), (l = $17f526922e4a857c$var$jh || $17f526922e4a857c$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $17f526922e4a857c$var$jj(a, b, c, d, f, e);
}
function $17f526922e4a857c$var$jj(a, b, c, d, e, f) {
    $17f526922e4a857c$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $17f526922e4a857c$var$dg(b, c, !1), $17f526922e4a857c$var$Zi(a, b, f);
    d = b.stateNode;
    $17f526922e4a857c$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $17f526922e4a857c$var$Ug(b, a.child, null, f), b.child = $17f526922e4a857c$var$Ug(b, null, h, f)) : $17f526922e4a857c$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $17f526922e4a857c$var$dg(b, c, !0);
    return b.child;
}
function $17f526922e4a857c$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $17f526922e4a857c$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $17f526922e4a857c$var$ag(a, b.context, !1);
    $17f526922e4a857c$var$yh(a, b.containerInfo);
}
function $17f526922e4a857c$var$lj(a, b, c, d, e) {
    $17f526922e4a857c$var$Ig();
    $17f526922e4a857c$var$Jg(e);
    b.flags |= 256;
    $17f526922e4a857c$var$Xi(a, b, c, d);
    return b.child;
}
var $17f526922e4a857c$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $17f526922e4a857c$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $17f526922e4a857c$var$oj(a, b, c) {
    var d = b.pendingProps, e = $17f526922e4a857c$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $17f526922e4a857c$var$G($17f526922e4a857c$var$L, e & 1);
    if (null === a) {
        $17f526922e4a857c$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $17f526922e4a857c$var$pj(g, d, 0, null), a = $17f526922e4a857c$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $17f526922e4a857c$var$nj(c), b.memoizedState = $17f526922e4a857c$var$mj, a) : $17f526922e4a857c$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $17f526922e4a857c$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $17f526922e4a857c$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $17f526922e4a857c$var$Pg(h, f) : (f = $17f526922e4a857c$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $17f526922e4a857c$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $17f526922e4a857c$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $17f526922e4a857c$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $17f526922e4a857c$var$qj(a, b) {
    b = $17f526922e4a857c$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $17f526922e4a857c$var$sj(a, b, c, d) {
    null !== d && $17f526922e4a857c$var$Jg(d);
    $17f526922e4a857c$var$Ug(b, a.child, null, c);
    a = $17f526922e4a857c$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $17f526922e4a857c$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $17f526922e4a857c$var$Ki(Error($17f526922e4a857c$var$p(422))), $17f526922e4a857c$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $17f526922e4a857c$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $17f526922e4a857c$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $17f526922e4a857c$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $17f526922e4a857c$var$nj(g);
        b.memoizedState = $17f526922e4a857c$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $17f526922e4a857c$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($17f526922e4a857c$var$p(419));
        d = $17f526922e4a857c$var$Ki(f, d, void 0);
        return $17f526922e4a857c$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($17f526922e4a857c$var$dh || h) {
        d = $17f526922e4a857c$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $17f526922e4a857c$var$ih(a, e), $17f526922e4a857c$var$gi(d, a, e, -1));
        }
        $17f526922e4a857c$var$tj();
        d = $17f526922e4a857c$var$Ki(Error($17f526922e4a857c$var$p(421)));
        return $17f526922e4a857c$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $17f526922e4a857c$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $17f526922e4a857c$var$yg = $17f526922e4a857c$var$Lf(e.nextSibling);
    $17f526922e4a857c$var$xg = b;
    $17f526922e4a857c$var$I = !0;
    $17f526922e4a857c$var$zg = null;
    null !== a && ($17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$rg, $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$sg, $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$qg, $17f526922e4a857c$var$rg = a.id, $17f526922e4a857c$var$sg = a.overflow, $17f526922e4a857c$var$qg = b);
    b = $17f526922e4a857c$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $17f526922e4a857c$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $17f526922e4a857c$var$bh(a.return, b, c);
}
function $17f526922e4a857c$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $17f526922e4a857c$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $17f526922e4a857c$var$Xi(a, b, d.children, c);
    d = $17f526922e4a857c$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $17f526922e4a857c$var$vj(a, c, b);
            else if (19 === a.tag) $17f526922e4a857c$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $17f526922e4a857c$var$G($17f526922e4a857c$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $17f526922e4a857c$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $17f526922e4a857c$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $17f526922e4a857c$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $17f526922e4a857c$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $17f526922e4a857c$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $17f526922e4a857c$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $17f526922e4a857c$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $17f526922e4a857c$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($17f526922e4a857c$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $17f526922e4a857c$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $17f526922e4a857c$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $17f526922e4a857c$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $17f526922e4a857c$var$kj(b);
            $17f526922e4a857c$var$Ig();
            break;
        case 5:
            $17f526922e4a857c$var$Ah(b);
            break;
        case 1:
            $17f526922e4a857c$var$Zf(b.type) && $17f526922e4a857c$var$cg(b);
            break;
        case 4:
            $17f526922e4a857c$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $17f526922e4a857c$var$G($17f526922e4a857c$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $17f526922e4a857c$var$G($17f526922e4a857c$var$L, $17f526922e4a857c$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $17f526922e4a857c$var$oj(a, b, c);
                $17f526922e4a857c$var$G($17f526922e4a857c$var$L, $17f526922e4a857c$var$L.current & 1);
                a = $17f526922e4a857c$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $17f526922e4a857c$var$G($17f526922e4a857c$var$L, $17f526922e4a857c$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $17f526922e4a857c$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $17f526922e4a857c$var$G($17f526922e4a857c$var$L, $17f526922e4a857c$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $17f526922e4a857c$var$dj(a, b, c);
    }
    return $17f526922e4a857c$var$Zi(a, b, c);
}
var $17f526922e4a857c$var$zj, $17f526922e4a857c$var$Aj, $17f526922e4a857c$var$Bj, $17f526922e4a857c$var$Cj;
$17f526922e4a857c$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$17f526922e4a857c$var$Aj = function() {};
$17f526922e4a857c$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $17f526922e4a857c$var$xh($17f526922e4a857c$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $17f526922e4a857c$var$Ya(a, e);
                d = $17f526922e4a857c$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $17f526922e4a857c$var$A({}, e, {
                    value: void 0
                });
                d = $17f526922e4a857c$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $17f526922e4a857c$var$gb(a, e);
                d = $17f526922e4a857c$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $17f526922e4a857c$var$Bf);
        }
        $17f526922e4a857c$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($17f526922e4a857c$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($17f526922e4a857c$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $17f526922e4a857c$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$17f526922e4a857c$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $17f526922e4a857c$var$Dj(a, b) {
    if (!$17f526922e4a857c$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $17f526922e4a857c$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $17f526922e4a857c$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $17f526922e4a857c$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $17f526922e4a857c$var$S(b), null;
        case 1:
            return $17f526922e4a857c$var$Zf(b.type) && $17f526922e4a857c$var$$f(), $17f526922e4a857c$var$S(b), null;
        case 3:
            d = b.stateNode;
            $17f526922e4a857c$var$zh();
            $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf);
            $17f526922e4a857c$var$E($17f526922e4a857c$var$H);
            $17f526922e4a857c$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $17f526922e4a857c$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $17f526922e4a857c$var$zg && ($17f526922e4a857c$var$Fj($17f526922e4a857c$var$zg), $17f526922e4a857c$var$zg = null));
            $17f526922e4a857c$var$Aj(a, b);
            $17f526922e4a857c$var$S(b);
            return null;
        case 5:
            $17f526922e4a857c$var$Bh(b);
            var e = $17f526922e4a857c$var$xh($17f526922e4a857c$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $17f526922e4a857c$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($17f526922e4a857c$var$p(166));
                    $17f526922e4a857c$var$S(b);
                    return null;
                }
                a = $17f526922e4a857c$var$xh($17f526922e4a857c$var$uh.current);
                if ($17f526922e4a857c$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$17f526922e4a857c$var$Of] = b;
                    d[$17f526922e4a857c$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $17f526922e4a857c$var$D("cancel", d);
                            $17f526922e4a857c$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $17f526922e4a857c$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $17f526922e4a857c$var$lf.length; e++)$17f526922e4a857c$var$D($17f526922e4a857c$var$lf[e], d);
                            break;
                        case "source":
                            $17f526922e4a857c$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $17f526922e4a857c$var$D("error", d);
                            $17f526922e4a857c$var$D("load", d);
                            break;
                        case "details":
                            $17f526922e4a857c$var$D("toggle", d);
                            break;
                        case "input":
                            $17f526922e4a857c$var$Za(d, f);
                            $17f526922e4a857c$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $17f526922e4a857c$var$D("invalid", d);
                            break;
                        case "textarea":
                            $17f526922e4a857c$var$hb(d, f), $17f526922e4a857c$var$D("invalid", d);
                    }
                    $17f526922e4a857c$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $17f526922e4a857c$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $17f526922e4a857c$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $17f526922e4a857c$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $17f526922e4a857c$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $17f526922e4a857c$var$Va(d);
                            $17f526922e4a857c$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $17f526922e4a857c$var$Va(d);
                            $17f526922e4a857c$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $17f526922e4a857c$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $17f526922e4a857c$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$17f526922e4a857c$var$Of] = b;
                    a[$17f526922e4a857c$var$Pf] = d;
                    $17f526922e4a857c$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $17f526922e4a857c$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $17f526922e4a857c$var$D("cancel", a);
                                $17f526922e4a857c$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $17f526922e4a857c$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $17f526922e4a857c$var$lf.length; e++)$17f526922e4a857c$var$D($17f526922e4a857c$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $17f526922e4a857c$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $17f526922e4a857c$var$D("error", a);
                                $17f526922e4a857c$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $17f526922e4a857c$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $17f526922e4a857c$var$Za(a, d);
                                e = $17f526922e4a857c$var$Ya(a, d);
                                $17f526922e4a857c$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $17f526922e4a857c$var$A({}, d, {
                                    value: void 0
                                });
                                $17f526922e4a857c$var$D("invalid", a);
                                break;
                            case "textarea":
                                $17f526922e4a857c$var$hb(a, d);
                                e = $17f526922e4a857c$var$gb(a, d);
                                $17f526922e4a857c$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $17f526922e4a857c$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $17f526922e4a857c$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $17f526922e4a857c$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $17f526922e4a857c$var$ob(a, k) : "number" === typeof k && $17f526922e4a857c$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($17f526922e4a857c$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $17f526922e4a857c$var$D("scroll", a) : null != k && $17f526922e4a857c$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $17f526922e4a857c$var$Va(a);
                                $17f526922e4a857c$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $17f526922e4a857c$var$Va(a);
                                $17f526922e4a857c$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $17f526922e4a857c$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $17f526922e4a857c$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $17f526922e4a857c$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $17f526922e4a857c$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $17f526922e4a857c$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $17f526922e4a857c$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($17f526922e4a857c$var$p(166));
                c = $17f526922e4a857c$var$xh($17f526922e4a857c$var$wh.current);
                $17f526922e4a857c$var$xh($17f526922e4a857c$var$uh.current);
                if ($17f526922e4a857c$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$17f526922e4a857c$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $17f526922e4a857c$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $17f526922e4a857c$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $17f526922e4a857c$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$17f526922e4a857c$var$Of] = b, b.stateNode = d;
            }
            $17f526922e4a857c$var$S(b);
            return null;
        case 13:
            $17f526922e4a857c$var$E($17f526922e4a857c$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($17f526922e4a857c$var$I && null !== $17f526922e4a857c$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $17f526922e4a857c$var$Hg(), $17f526922e4a857c$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $17f526922e4a857c$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($17f526922e4a857c$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($17f526922e4a857c$var$p(317));
                        f[$17f526922e4a857c$var$Of] = b;
                    } else $17f526922e4a857c$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $17f526922e4a857c$var$S(b);
                    f = !1;
                } else null !== $17f526922e4a857c$var$zg && ($17f526922e4a857c$var$Fj($17f526922e4a857c$var$zg), $17f526922e4a857c$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($17f526922e4a857c$var$L.current & 1) ? 0 === $17f526922e4a857c$var$T && ($17f526922e4a857c$var$T = 3) : $17f526922e4a857c$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $17f526922e4a857c$var$S(b);
            return null;
        case 4:
            return $17f526922e4a857c$var$zh(), $17f526922e4a857c$var$Aj(a, b), null === a && $17f526922e4a857c$var$sf(b.stateNode.containerInfo), $17f526922e4a857c$var$S(b), null;
        case 10:
            return $17f526922e4a857c$var$ah(b.type._context), $17f526922e4a857c$var$S(b), null;
        case 17:
            return $17f526922e4a857c$var$Zf(b.type) && $17f526922e4a857c$var$$f(), $17f526922e4a857c$var$S(b), null;
        case 19:
            $17f526922e4a857c$var$E($17f526922e4a857c$var$L);
            f = b.memoizedState;
            if (null === f) return $17f526922e4a857c$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $17f526922e4a857c$var$Dj(f, !1);
                else {
                    if (0 !== $17f526922e4a857c$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $17f526922e4a857c$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $17f526922e4a857c$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $17f526922e4a857c$var$G($17f526922e4a857c$var$L, $17f526922e4a857c$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $17f526922e4a857c$var$B() > $17f526922e4a857c$var$Gj && (b.flags |= 128, d = !0, $17f526922e4a857c$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $17f526922e4a857c$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $17f526922e4a857c$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$17f526922e4a857c$var$I) return $17f526922e4a857c$var$S(b), null;
                    } else 2 * $17f526922e4a857c$var$B() - f.renderingStartTime > $17f526922e4a857c$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $17f526922e4a857c$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $17f526922e4a857c$var$B(), b.sibling = null, c = $17f526922e4a857c$var$L.current, $17f526922e4a857c$var$G($17f526922e4a857c$var$L, d ? c & 1 | 2 : c & 1), b;
            $17f526922e4a857c$var$S(b);
            return null;
        case 22:
        case 23:
            return $17f526922e4a857c$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($17f526922e4a857c$var$fj & 1073741824) && ($17f526922e4a857c$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $17f526922e4a857c$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($17f526922e4a857c$var$p(156, b.tag));
}
function $17f526922e4a857c$var$Ij(a, b) {
    $17f526922e4a857c$var$wg(b);
    switch(b.tag){
        case 1:
            return $17f526922e4a857c$var$Zf(b.type) && $17f526922e4a857c$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $17f526922e4a857c$var$zh(), $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf), $17f526922e4a857c$var$E($17f526922e4a857c$var$H), $17f526922e4a857c$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $17f526922e4a857c$var$Bh(b), null;
        case 13:
            $17f526922e4a857c$var$E($17f526922e4a857c$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($17f526922e4a857c$var$p(340));
                $17f526922e4a857c$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $17f526922e4a857c$var$E($17f526922e4a857c$var$L), null;
        case 4:
            return $17f526922e4a857c$var$zh(), null;
        case 10:
            return $17f526922e4a857c$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $17f526922e4a857c$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $17f526922e4a857c$var$Jj = !1, $17f526922e4a857c$var$U = !1, $17f526922e4a857c$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $17f526922e4a857c$var$V = null;
function $17f526922e4a857c$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $17f526922e4a857c$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $17f526922e4a857c$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $17f526922e4a857c$var$W(a, b, d);
    }
}
var $17f526922e4a857c$var$Nj = !1;
function $17f526922e4a857c$var$Oj(a, b) {
    $17f526922e4a857c$var$Cf = $17f526922e4a857c$var$dd;
    a = $17f526922e4a857c$var$Me();
    if ($17f526922e4a857c$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $17f526922e4a857c$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $17f526922e4a857c$var$dd = !1;
    for($17f526922e4a857c$var$V = b; null !== $17f526922e4a857c$var$V;)if (b = $17f526922e4a857c$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $17f526922e4a857c$var$V = a;
    else for(; null !== $17f526922e4a857c$var$V;){
        b = $17f526922e4a857c$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $17f526922e4a857c$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($17f526922e4a857c$var$p(163));
            }
        } catch (F) {
            $17f526922e4a857c$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $17f526922e4a857c$var$V = a;
            break;
        }
        $17f526922e4a857c$var$V = b.return;
    }
    n = $17f526922e4a857c$var$Nj;
    $17f526922e4a857c$var$Nj = !1;
    return n;
}
function $17f526922e4a857c$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $17f526922e4a857c$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $17f526922e4a857c$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $17f526922e4a857c$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $17f526922e4a857c$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $17f526922e4a857c$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$17f526922e4a857c$var$Of], delete b[$17f526922e4a857c$var$Pf], delete b[$17f526922e4a857c$var$of], delete b[$17f526922e4a857c$var$Qf], delete b[$17f526922e4a857c$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $17f526922e4a857c$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $17f526922e4a857c$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $17f526922e4a857c$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $17f526922e4a857c$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $17f526922e4a857c$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($17f526922e4a857c$var$Vj(a, b, c), a = a.sibling; null !== a;)$17f526922e4a857c$var$Vj(a, b, c), a = a.sibling;
}
function $17f526922e4a857c$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($17f526922e4a857c$var$Wj(a, b, c), a = a.sibling; null !== a;)$17f526922e4a857c$var$Wj(a, b, c), a = a.sibling;
}
var $17f526922e4a857c$var$X = null, $17f526922e4a857c$var$Xj = !1;
function $17f526922e4a857c$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$17f526922e4a857c$var$Zj(a, b, c), c = c.sibling;
}
function $17f526922e4a857c$var$Zj(a, b, c) {
    if ($17f526922e4a857c$var$lc && "function" === typeof $17f526922e4a857c$var$lc.onCommitFiberUnmount) try {
        $17f526922e4a857c$var$lc.onCommitFiberUnmount($17f526922e4a857c$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $17f526922e4a857c$var$U || $17f526922e4a857c$var$Lj(c, b);
        case 6:
            var d = $17f526922e4a857c$var$X, e = $17f526922e4a857c$var$Xj;
            $17f526922e4a857c$var$X = null;
            $17f526922e4a857c$var$Yj(a, b, c);
            $17f526922e4a857c$var$X = d;
            $17f526922e4a857c$var$Xj = e;
            null !== $17f526922e4a857c$var$X && ($17f526922e4a857c$var$Xj ? (a = $17f526922e4a857c$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $17f526922e4a857c$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $17f526922e4a857c$var$X && ($17f526922e4a857c$var$Xj ? (a = $17f526922e4a857c$var$X, c = c.stateNode, 8 === a.nodeType ? $17f526922e4a857c$var$Kf(a.parentNode, c) : 1 === a.nodeType && $17f526922e4a857c$var$Kf(a, c), $17f526922e4a857c$var$bd(a)) : $17f526922e4a857c$var$Kf($17f526922e4a857c$var$X, c.stateNode));
            break;
        case 4:
            d = $17f526922e4a857c$var$X;
            e = $17f526922e4a857c$var$Xj;
            $17f526922e4a857c$var$X = c.stateNode.containerInfo;
            $17f526922e4a857c$var$Xj = !0;
            $17f526922e4a857c$var$Yj(a, b, c);
            $17f526922e4a857c$var$X = d;
            $17f526922e4a857c$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$17f526922e4a857c$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $17f526922e4a857c$var$Mj(c, b, g) : 0 !== (f & 4) && $17f526922e4a857c$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $17f526922e4a857c$var$Yj(a, b, c);
            break;
        case 1:
            if (!$17f526922e4a857c$var$U && ($17f526922e4a857c$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $17f526922e4a857c$var$W(c, b, h);
            }
            $17f526922e4a857c$var$Yj(a, b, c);
            break;
        case 21:
            $17f526922e4a857c$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($17f526922e4a857c$var$U = (d = $17f526922e4a857c$var$U) || null !== c.memoizedState, $17f526922e4a857c$var$Yj(a, b, c), $17f526922e4a857c$var$U = d) : $17f526922e4a857c$var$Yj(a, b, c);
            break;
        default:
            $17f526922e4a857c$var$Yj(a, b, c);
    }
}
function $17f526922e4a857c$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $17f526922e4a857c$var$Kj);
        b.forEach(function(b) {
            var d = $17f526922e4a857c$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $17f526922e4a857c$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $17f526922e4a857c$var$X = h.stateNode;
                        $17f526922e4a857c$var$Xj = !1;
                        break a;
                    case 3:
                        $17f526922e4a857c$var$X = h.stateNode.containerInfo;
                        $17f526922e4a857c$var$Xj = !0;
                        break a;
                    case 4:
                        $17f526922e4a857c$var$X = h.stateNode.containerInfo;
                        $17f526922e4a857c$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $17f526922e4a857c$var$X) throw Error($17f526922e4a857c$var$p(160));
            $17f526922e4a857c$var$Zj(f, g, e);
            $17f526922e4a857c$var$X = null;
            $17f526922e4a857c$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $17f526922e4a857c$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$17f526922e4a857c$var$dk(b, a), b = b.sibling;
}
function $17f526922e4a857c$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            if (d & 4) {
                try {
                    $17f526922e4a857c$var$Pj(3, a, a.return), $17f526922e4a857c$var$Qj(3, a);
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
                try {
                    $17f526922e4a857c$var$Pj(5, a, a.return);
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            d & 512 && null !== c && $17f526922e4a857c$var$Lj(c, c.return);
            break;
        case 5:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            d & 512 && null !== c && $17f526922e4a857c$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $17f526922e4a857c$var$ob(e, "");
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $17f526922e4a857c$var$ab(e, f);
                    $17f526922e4a857c$var$vb(h, g);
                    var l = $17f526922e4a857c$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $17f526922e4a857c$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $17f526922e4a857c$var$nb(e, q) : "children" === m ? $17f526922e4a857c$var$ob(e, q) : $17f526922e4a857c$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $17f526922e4a857c$var$bb(e, f);
                            break;
                        case "textarea":
                            $17f526922e4a857c$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $17f526922e4a857c$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $17f526922e4a857c$var$fb(e, !!f.multiple, f.defaultValue, !0) : $17f526922e4a857c$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$17f526922e4a857c$var$Pf] = f;
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($17f526922e4a857c$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $17f526922e4a857c$var$bd(b.containerInfo);
            } catch (t) {
                $17f526922e4a857c$var$W(a, a.return, t);
            }
            break;
        case 4:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            break;
        case 13:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($17f526922e4a857c$var$fk = $17f526922e4a857c$var$B()));
            d & 4 && $17f526922e4a857c$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($17f526922e4a857c$var$U = (l = $17f526922e4a857c$var$U) || m, $17f526922e4a857c$var$ck(b, a), $17f526922e4a857c$var$U = l) : $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($17f526922e4a857c$var$V = a, m = a.child; null !== m;){
                    for(q = $17f526922e4a857c$var$V = m; null !== $17f526922e4a857c$var$V;){
                        r = $17f526922e4a857c$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $17f526922e4a857c$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $17f526922e4a857c$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $17f526922e4a857c$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $17f526922e4a857c$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $17f526922e4a857c$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $17f526922e4a857c$var$V = y) : $17f526922e4a857c$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $17f526922e4a857c$var$rb("display", g));
                            } catch (t) {
                                $17f526922e4a857c$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $17f526922e4a857c$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            d & 4 && $17f526922e4a857c$var$ak(a);
            break;
        case 21:
            break;
        default:
            $17f526922e4a857c$var$ck(b, a), $17f526922e4a857c$var$ek(a);
    }
}
function $17f526922e4a857c$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($17f526922e4a857c$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($17f526922e4a857c$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($17f526922e4a857c$var$ob(e, ""), d.flags &= -33);
                    var f = $17f526922e4a857c$var$Uj(a);
                    $17f526922e4a857c$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $17f526922e4a857c$var$Uj(a);
                    $17f526922e4a857c$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($17f526922e4a857c$var$p(161));
            }
        } catch (k) {
            $17f526922e4a857c$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $17f526922e4a857c$var$hk(a, b, c) {
    $17f526922e4a857c$var$V = a;
    $17f526922e4a857c$var$ik(a, b, c);
}
function $17f526922e4a857c$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $17f526922e4a857c$var$V;){
        var e = $17f526922e4a857c$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $17f526922e4a857c$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $17f526922e4a857c$var$U;
                h = $17f526922e4a857c$var$Jj;
                var l = $17f526922e4a857c$var$U;
                $17f526922e4a857c$var$Jj = g;
                if (($17f526922e4a857c$var$U = k) && !l) for($17f526922e4a857c$var$V = e; null !== $17f526922e4a857c$var$V;)g = $17f526922e4a857c$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $17f526922e4a857c$var$jk(e) : null !== k ? (k.return = g, $17f526922e4a857c$var$V = k) : $17f526922e4a857c$var$jk(e);
                for(; null !== f;)$17f526922e4a857c$var$V = f, $17f526922e4a857c$var$ik(f, b, c), f = f.sibling;
                $17f526922e4a857c$var$V = e;
                $17f526922e4a857c$var$Jj = h;
                $17f526922e4a857c$var$U = l;
            }
            $17f526922e4a857c$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $17f526922e4a857c$var$V = f) : $17f526922e4a857c$var$kk(a, b, c);
    }
}
function $17f526922e4a857c$var$kk(a) {
    for(; null !== $17f526922e4a857c$var$V;){
        var b = $17f526922e4a857c$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $17f526922e4a857c$var$U || $17f526922e4a857c$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$17f526922e4a857c$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $17f526922e4a857c$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $17f526922e4a857c$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $17f526922e4a857c$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $17f526922e4a857c$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($17f526922e4a857c$var$p(163));
                }
                $17f526922e4a857c$var$U || b.flags & 512 && $17f526922e4a857c$var$Rj(b);
            } catch (r) {
                $17f526922e4a857c$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $17f526922e4a857c$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $17f526922e4a857c$var$V = c;
            break;
        }
        $17f526922e4a857c$var$V = b.return;
    }
}
function $17f526922e4a857c$var$gk(a) {
    for(; null !== $17f526922e4a857c$var$V;){
        var b = $17f526922e4a857c$var$V;
        if (b === a) {
            $17f526922e4a857c$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $17f526922e4a857c$var$V = c;
            break;
        }
        $17f526922e4a857c$var$V = b.return;
    }
}
function $17f526922e4a857c$var$jk(a) {
    for(; null !== $17f526922e4a857c$var$V;){
        var b = $17f526922e4a857c$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $17f526922e4a857c$var$Qj(4, b);
                    } catch (k) {
                        $17f526922e4a857c$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $17f526922e4a857c$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $17f526922e4a857c$var$Rj(b);
                    } catch (k) {
                        $17f526922e4a857c$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $17f526922e4a857c$var$Rj(b);
                    } catch (k) {
                        $17f526922e4a857c$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $17f526922e4a857c$var$W(b, b.return, k);
        }
        if (b === a) {
            $17f526922e4a857c$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $17f526922e4a857c$var$V = h;
            break;
        }
        $17f526922e4a857c$var$V = b.return;
    }
}
var $17f526922e4a857c$var$lk = Math.ceil, $17f526922e4a857c$var$mk = $17f526922e4a857c$var$ua.ReactCurrentDispatcher, $17f526922e4a857c$var$nk = $17f526922e4a857c$var$ua.ReactCurrentOwner, $17f526922e4a857c$var$ok = $17f526922e4a857c$var$ua.ReactCurrentBatchConfig, $17f526922e4a857c$var$K = 0, $17f526922e4a857c$var$Q = null, $17f526922e4a857c$var$Y = null, $17f526922e4a857c$var$Z = 0, $17f526922e4a857c$var$fj = 0, $17f526922e4a857c$var$ej = $17f526922e4a857c$var$Uf(0), $17f526922e4a857c$var$T = 0, $17f526922e4a857c$var$pk = null, $17f526922e4a857c$var$rh = 0, $17f526922e4a857c$var$qk = 0, $17f526922e4a857c$var$rk = 0, $17f526922e4a857c$var$sk = null, $17f526922e4a857c$var$tk = null, $17f526922e4a857c$var$fk = 0, $17f526922e4a857c$var$Gj = Infinity, $17f526922e4a857c$var$uk = null, $17f526922e4a857c$var$Oi = !1, $17f526922e4a857c$var$Pi = null, $17f526922e4a857c$var$Ri = null, $17f526922e4a857c$var$vk = !1, $17f526922e4a857c$var$wk = null, $17f526922e4a857c$var$xk = 0, $17f526922e4a857c$var$yk = 0, $17f526922e4a857c$var$zk = null, $17f526922e4a857c$var$Ak = -1, $17f526922e4a857c$var$Bk = 0;
function $17f526922e4a857c$var$R() {
    return 0 !== ($17f526922e4a857c$var$K & 6) ? $17f526922e4a857c$var$B() : -1 !== $17f526922e4a857c$var$Ak ? $17f526922e4a857c$var$Ak : $17f526922e4a857c$var$Ak = $17f526922e4a857c$var$B();
}
function $17f526922e4a857c$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($17f526922e4a857c$var$K & 2) && 0 !== $17f526922e4a857c$var$Z) return $17f526922e4a857c$var$Z & -$17f526922e4a857c$var$Z;
    if (null !== $17f526922e4a857c$var$Kg.transition) return 0 === $17f526922e4a857c$var$Bk && ($17f526922e4a857c$var$Bk = $17f526922e4a857c$var$yc()), $17f526922e4a857c$var$Bk;
    a = $17f526922e4a857c$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $17f526922e4a857c$var$jd(a.type);
    return a;
}
function $17f526922e4a857c$var$gi(a, b, c, d) {
    if (50 < $17f526922e4a857c$var$yk) throw $17f526922e4a857c$var$yk = 0, $17f526922e4a857c$var$zk = null, Error($17f526922e4a857c$var$p(185));
    $17f526922e4a857c$var$Ac(a, c, d);
    if (0 === ($17f526922e4a857c$var$K & 2) || a !== $17f526922e4a857c$var$Q) a === $17f526922e4a857c$var$Q && (0 === ($17f526922e4a857c$var$K & 2) && ($17f526922e4a857c$var$qk |= c), 4 === $17f526922e4a857c$var$T && $17f526922e4a857c$var$Ck(a, $17f526922e4a857c$var$Z)), $17f526922e4a857c$var$Dk(a, d), 1 === c && 0 === $17f526922e4a857c$var$K && 0 === (b.mode & 1) && ($17f526922e4a857c$var$Gj = $17f526922e4a857c$var$B() + 500, $17f526922e4a857c$var$fg && $17f526922e4a857c$var$jg());
}
function $17f526922e4a857c$var$Dk(a, b) {
    var c = a.callbackNode;
    $17f526922e4a857c$var$wc(a, b);
    var d = $17f526922e4a857c$var$uc(a, a === $17f526922e4a857c$var$Q ? $17f526922e4a857c$var$Z : 0);
    if (0 === d) null !== c && $17f526922e4a857c$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $17f526922e4a857c$var$bc(c);
        if (1 === b) 0 === a.tag ? $17f526922e4a857c$var$ig($17f526922e4a857c$var$Ek.bind(null, a)) : $17f526922e4a857c$var$hg($17f526922e4a857c$var$Ek.bind(null, a)), $17f526922e4a857c$var$Jf(function() {
            0 === ($17f526922e4a857c$var$K & 6) && $17f526922e4a857c$var$jg();
        }), c = null;
        else {
            switch($17f526922e4a857c$var$Dc(d)){
                case 1:
                    c = $17f526922e4a857c$var$fc;
                    break;
                case 4:
                    c = $17f526922e4a857c$var$gc;
                    break;
                case 16:
                    c = $17f526922e4a857c$var$hc;
                    break;
                case 536870912:
                    c = $17f526922e4a857c$var$jc;
                    break;
                default:
                    c = $17f526922e4a857c$var$hc;
            }
            c = $17f526922e4a857c$var$Fk(c, $17f526922e4a857c$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $17f526922e4a857c$var$Gk(a, b) {
    $17f526922e4a857c$var$Ak = -1;
    $17f526922e4a857c$var$Bk = 0;
    if (0 !== ($17f526922e4a857c$var$K & 6)) throw Error($17f526922e4a857c$var$p(327));
    var c = a.callbackNode;
    if ($17f526922e4a857c$var$Hk() && a.callbackNode !== c) return null;
    var d = $17f526922e4a857c$var$uc(a, a === $17f526922e4a857c$var$Q ? $17f526922e4a857c$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $17f526922e4a857c$var$Ik(a, d);
    else {
        b = d;
        var e = $17f526922e4a857c$var$K;
        $17f526922e4a857c$var$K |= 2;
        var f = $17f526922e4a857c$var$Jk();
        if ($17f526922e4a857c$var$Q !== a || $17f526922e4a857c$var$Z !== b) $17f526922e4a857c$var$uk = null, $17f526922e4a857c$var$Gj = $17f526922e4a857c$var$B() + 500, $17f526922e4a857c$var$Kk(a, b);
        for(;;)try {
            $17f526922e4a857c$var$Lk();
            break;
        } catch (h) {
            $17f526922e4a857c$var$Mk(a, h);
        }
        $17f526922e4a857c$var$$g();
        $17f526922e4a857c$var$mk.current = f;
        $17f526922e4a857c$var$K = e;
        null !== $17f526922e4a857c$var$Y ? b = 0 : ($17f526922e4a857c$var$Q = null, $17f526922e4a857c$var$Z = 0, b = $17f526922e4a857c$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $17f526922e4a857c$var$xc(a), 0 !== e && (d = e, b = $17f526922e4a857c$var$Nk(a, e)));
        if (1 === b) throw c = $17f526922e4a857c$var$pk, $17f526922e4a857c$var$Kk(a, 0), $17f526922e4a857c$var$Ck(a, d), $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B()), c;
        if (6 === b) $17f526922e4a857c$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$17f526922e4a857c$var$Ok(e) && (b = $17f526922e4a857c$var$Ik(a, d), 2 === b && (f = $17f526922e4a857c$var$xc(a), 0 !== f && (d = f, b = $17f526922e4a857c$var$Nk(a, f))), 1 === b)) throw c = $17f526922e4a857c$var$pk, $17f526922e4a857c$var$Kk(a, 0), $17f526922e4a857c$var$Ck(a, d), $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($17f526922e4a857c$var$p(345));
                case 2:
                    $17f526922e4a857c$var$Pk(a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk);
                    break;
                case 3:
                    $17f526922e4a857c$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $17f526922e4a857c$var$fk + 500 - $17f526922e4a857c$var$B(), 10 < b)) {
                        if (0 !== $17f526922e4a857c$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $17f526922e4a857c$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $17f526922e4a857c$var$Ff($17f526922e4a857c$var$Pk.bind(null, a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk), b);
                        break;
                    }
                    $17f526922e4a857c$var$Pk(a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk);
                    break;
                case 4:
                    $17f526922e4a857c$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $17f526922e4a857c$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $17f526922e4a857c$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $17f526922e4a857c$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $17f526922e4a857c$var$Ff($17f526922e4a857c$var$Pk.bind(null, a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk), d);
                        break;
                    }
                    $17f526922e4a857c$var$Pk(a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk);
                    break;
                case 5:
                    $17f526922e4a857c$var$Pk(a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk);
                    break;
                default:
                    throw Error($17f526922e4a857c$var$p(329));
            }
        }
    }
    $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B());
    return a.callbackNode === c ? $17f526922e4a857c$var$Gk.bind(null, a) : null;
}
function $17f526922e4a857c$var$Nk(a, b) {
    var c = $17f526922e4a857c$var$sk;
    a.current.memoizedState.isDehydrated && ($17f526922e4a857c$var$Kk(a, b).flags |= 256);
    a = $17f526922e4a857c$var$Ik(a, b);
    2 !== a && (b = $17f526922e4a857c$var$tk, $17f526922e4a857c$var$tk = c, null !== b && $17f526922e4a857c$var$Fj(b));
    return a;
}
function $17f526922e4a857c$var$Fj(a) {
    null === $17f526922e4a857c$var$tk ? $17f526922e4a857c$var$tk = a : $17f526922e4a857c$var$tk.push.apply($17f526922e4a857c$var$tk, a);
}
function $17f526922e4a857c$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$17f526922e4a857c$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $17f526922e4a857c$var$Ck(a, b) {
    b &= ~$17f526922e4a857c$var$rk;
    b &= ~$17f526922e4a857c$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $17f526922e4a857c$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $17f526922e4a857c$var$Ek(a) {
    if (0 !== ($17f526922e4a857c$var$K & 6)) throw Error($17f526922e4a857c$var$p(327));
    $17f526922e4a857c$var$Hk();
    var b = $17f526922e4a857c$var$uc(a, 0);
    if (0 === (b & 1)) return $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B()), null;
    var c = $17f526922e4a857c$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $17f526922e4a857c$var$xc(a);
        0 !== d && (b = d, c = $17f526922e4a857c$var$Nk(a, d));
    }
    if (1 === c) throw c = $17f526922e4a857c$var$pk, $17f526922e4a857c$var$Kk(a, 0), $17f526922e4a857c$var$Ck(a, b), $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B()), c;
    if (6 === c) throw Error($17f526922e4a857c$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $17f526922e4a857c$var$Pk(a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk);
    $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B());
    return null;
}
function $17f526922e4a857c$var$Qk(a, b) {
    var c = $17f526922e4a857c$var$K;
    $17f526922e4a857c$var$K |= 1;
    try {
        return a(b);
    } finally{
        $17f526922e4a857c$var$K = c, 0 === $17f526922e4a857c$var$K && ($17f526922e4a857c$var$Gj = $17f526922e4a857c$var$B() + 500, $17f526922e4a857c$var$fg && $17f526922e4a857c$var$jg());
    }
}
function $17f526922e4a857c$var$Rk(a) {
    null !== $17f526922e4a857c$var$wk && 0 === $17f526922e4a857c$var$wk.tag && 0 === ($17f526922e4a857c$var$K & 6) && $17f526922e4a857c$var$Hk();
    var b = $17f526922e4a857c$var$K;
    $17f526922e4a857c$var$K |= 1;
    var c = $17f526922e4a857c$var$ok.transition, d = $17f526922e4a857c$var$C;
    try {
        if ($17f526922e4a857c$var$ok.transition = null, $17f526922e4a857c$var$C = 1, a) return a();
    } finally{
        $17f526922e4a857c$var$C = d, $17f526922e4a857c$var$ok.transition = c, $17f526922e4a857c$var$K = b, 0 === ($17f526922e4a857c$var$K & 6) && $17f526922e4a857c$var$jg();
    }
}
function $17f526922e4a857c$var$Hj() {
    $17f526922e4a857c$var$fj = $17f526922e4a857c$var$ej.current;
    $17f526922e4a857c$var$E($17f526922e4a857c$var$ej);
}
function $17f526922e4a857c$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $17f526922e4a857c$var$Gf(c));
    if (null !== $17f526922e4a857c$var$Y) for(c = $17f526922e4a857c$var$Y.return; null !== c;){
        var d = c;
        $17f526922e4a857c$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $17f526922e4a857c$var$$f();
                break;
            case 3:
                $17f526922e4a857c$var$zh();
                $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf);
                $17f526922e4a857c$var$E($17f526922e4a857c$var$H);
                $17f526922e4a857c$var$Eh();
                break;
            case 5:
                $17f526922e4a857c$var$Bh(d);
                break;
            case 4:
                $17f526922e4a857c$var$zh();
                break;
            case 13:
                $17f526922e4a857c$var$E($17f526922e4a857c$var$L);
                break;
            case 19:
                $17f526922e4a857c$var$E($17f526922e4a857c$var$L);
                break;
            case 10:
                $17f526922e4a857c$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $17f526922e4a857c$var$Hj();
        }
        c = c.return;
    }
    $17f526922e4a857c$var$Q = a;
    $17f526922e4a857c$var$Y = a = $17f526922e4a857c$var$Pg(a.current, null);
    $17f526922e4a857c$var$Z = $17f526922e4a857c$var$fj = b;
    $17f526922e4a857c$var$T = 0;
    $17f526922e4a857c$var$pk = null;
    $17f526922e4a857c$var$rk = $17f526922e4a857c$var$qk = $17f526922e4a857c$var$rh = 0;
    $17f526922e4a857c$var$tk = $17f526922e4a857c$var$sk = null;
    if (null !== $17f526922e4a857c$var$fh) {
        for(b = 0; b < $17f526922e4a857c$var$fh.length; b++)if (c = $17f526922e4a857c$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $17f526922e4a857c$var$fh = null;
    }
    return a;
}
function $17f526922e4a857c$var$Mk(a, b) {
    do {
        var c = $17f526922e4a857c$var$Y;
        try {
            $17f526922e4a857c$var$$g();
            $17f526922e4a857c$var$Fh.current = $17f526922e4a857c$var$Rh;
            if ($17f526922e4a857c$var$Ih) {
                for(var d = $17f526922e4a857c$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $17f526922e4a857c$var$Ih = !1;
            }
            $17f526922e4a857c$var$Hh = 0;
            $17f526922e4a857c$var$O = $17f526922e4a857c$var$N = $17f526922e4a857c$var$M = null;
            $17f526922e4a857c$var$Jh = !1;
            $17f526922e4a857c$var$Kh = 0;
            $17f526922e4a857c$var$nk.current = null;
            if (null === c || null === c.return) {
                $17f526922e4a857c$var$T = 1;
                $17f526922e4a857c$var$pk = b;
                $17f526922e4a857c$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $17f526922e4a857c$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $17f526922e4a857c$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $17f526922e4a857c$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $17f526922e4a857c$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $17f526922e4a857c$var$Si(f, l, b);
                            $17f526922e4a857c$var$tj();
                            break a;
                        }
                        k = Error($17f526922e4a857c$var$p(426));
                    }
                } else if ($17f526922e4a857c$var$I && h.mode & 1) {
                    var J = $17f526922e4a857c$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $17f526922e4a857c$var$Vi(J, g, h, f, b);
                        $17f526922e4a857c$var$Jg($17f526922e4a857c$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $17f526922e4a857c$var$Ji(k, h);
                4 !== $17f526922e4a857c$var$T && ($17f526922e4a857c$var$T = 2);
                null === $17f526922e4a857c$var$sk ? $17f526922e4a857c$var$sk = [
                    f
                ] : $17f526922e4a857c$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $17f526922e4a857c$var$Ni(f, k, b);
                            $17f526922e4a857c$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $17f526922e4a857c$var$Ri || !$17f526922e4a857c$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $17f526922e4a857c$var$Qi(f, h, b);
                                $17f526922e4a857c$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $17f526922e4a857c$var$Sk(c);
        } catch (na) {
            b = na;
            $17f526922e4a857c$var$Y === c && null !== c && ($17f526922e4a857c$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $17f526922e4a857c$var$Jk() {
    var a = $17f526922e4a857c$var$mk.current;
    $17f526922e4a857c$var$mk.current = $17f526922e4a857c$var$Rh;
    return null === a ? $17f526922e4a857c$var$Rh : a;
}
function $17f526922e4a857c$var$tj() {
    if (0 === $17f526922e4a857c$var$T || 3 === $17f526922e4a857c$var$T || 2 === $17f526922e4a857c$var$T) $17f526922e4a857c$var$T = 4;
    null === $17f526922e4a857c$var$Q || 0 === ($17f526922e4a857c$var$rh & 268435455) && 0 === ($17f526922e4a857c$var$qk & 268435455) || $17f526922e4a857c$var$Ck($17f526922e4a857c$var$Q, $17f526922e4a857c$var$Z);
}
function $17f526922e4a857c$var$Ik(a, b) {
    var c = $17f526922e4a857c$var$K;
    $17f526922e4a857c$var$K |= 2;
    var d = $17f526922e4a857c$var$Jk();
    if ($17f526922e4a857c$var$Q !== a || $17f526922e4a857c$var$Z !== b) $17f526922e4a857c$var$uk = null, $17f526922e4a857c$var$Kk(a, b);
    for(;;)try {
        $17f526922e4a857c$var$Tk();
        break;
    } catch (e) {
        $17f526922e4a857c$var$Mk(a, e);
    }
    $17f526922e4a857c$var$$g();
    $17f526922e4a857c$var$K = c;
    $17f526922e4a857c$var$mk.current = d;
    if (null !== $17f526922e4a857c$var$Y) throw Error($17f526922e4a857c$var$p(261));
    $17f526922e4a857c$var$Q = null;
    $17f526922e4a857c$var$Z = 0;
    return $17f526922e4a857c$var$T;
}
function $17f526922e4a857c$var$Tk() {
    for(; null !== $17f526922e4a857c$var$Y;)$17f526922e4a857c$var$Uk($17f526922e4a857c$var$Y);
}
function $17f526922e4a857c$var$Lk() {
    for(; null !== $17f526922e4a857c$var$Y && !$17f526922e4a857c$var$cc();)$17f526922e4a857c$var$Uk($17f526922e4a857c$var$Y);
}
function $17f526922e4a857c$var$Uk(a) {
    var b = $17f526922e4a857c$var$Vk(a.alternate, a, $17f526922e4a857c$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $17f526922e4a857c$var$Sk(a) : $17f526922e4a857c$var$Y = b;
    $17f526922e4a857c$var$nk.current = null;
}
function $17f526922e4a857c$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $17f526922e4a857c$var$Ej(c, b, $17f526922e4a857c$var$fj), null !== c) {
                $17f526922e4a857c$var$Y = c;
                return;
            }
        } else {
            c = $17f526922e4a857c$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $17f526922e4a857c$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $17f526922e4a857c$var$T = 6;
                $17f526922e4a857c$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $17f526922e4a857c$var$Y = b;
            return;
        }
        $17f526922e4a857c$var$Y = b = a;
    }while (null !== b);
    0 === $17f526922e4a857c$var$T && ($17f526922e4a857c$var$T = 5);
}
function $17f526922e4a857c$var$Pk(a, b, c) {
    var d = $17f526922e4a857c$var$C, e = $17f526922e4a857c$var$ok.transition;
    try {
        $17f526922e4a857c$var$ok.transition = null, $17f526922e4a857c$var$C = 1, $17f526922e4a857c$var$Wk(a, b, c, d);
    } finally{
        $17f526922e4a857c$var$ok.transition = e, $17f526922e4a857c$var$C = d;
    }
    return null;
}
function $17f526922e4a857c$var$Wk(a, b, c, d) {
    do $17f526922e4a857c$var$Hk();
    while (null !== $17f526922e4a857c$var$wk);
    if (0 !== ($17f526922e4a857c$var$K & 6)) throw Error($17f526922e4a857c$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($17f526922e4a857c$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $17f526922e4a857c$var$Bc(a, f);
    a === $17f526922e4a857c$var$Q && ($17f526922e4a857c$var$Y = $17f526922e4a857c$var$Q = null, $17f526922e4a857c$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $17f526922e4a857c$var$vk || ($17f526922e4a857c$var$vk = !0, $17f526922e4a857c$var$Fk($17f526922e4a857c$var$hc, function() {
        $17f526922e4a857c$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $17f526922e4a857c$var$ok.transition;
        $17f526922e4a857c$var$ok.transition = null;
        var g = $17f526922e4a857c$var$C;
        $17f526922e4a857c$var$C = 1;
        var h = $17f526922e4a857c$var$K;
        $17f526922e4a857c$var$K |= 4;
        $17f526922e4a857c$var$nk.current = null;
        $17f526922e4a857c$var$Oj(a, c);
        $17f526922e4a857c$var$dk(c, a);
        $17f526922e4a857c$var$Oe($17f526922e4a857c$var$Df);
        $17f526922e4a857c$var$dd = !!$17f526922e4a857c$var$Cf;
        $17f526922e4a857c$var$Df = $17f526922e4a857c$var$Cf = null;
        a.current = c;
        $17f526922e4a857c$var$hk(c, a, e);
        $17f526922e4a857c$var$dc();
        $17f526922e4a857c$var$K = h;
        $17f526922e4a857c$var$C = g;
        $17f526922e4a857c$var$ok.transition = f;
    } else a.current = c;
    $17f526922e4a857c$var$vk && ($17f526922e4a857c$var$vk = !1, $17f526922e4a857c$var$wk = a, $17f526922e4a857c$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($17f526922e4a857c$var$Ri = null);
    $17f526922e4a857c$var$mc(c.stateNode, d);
    $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($17f526922e4a857c$var$Oi) throw $17f526922e4a857c$var$Oi = !1, a = $17f526922e4a857c$var$Pi, $17f526922e4a857c$var$Pi = null, a;
    0 !== ($17f526922e4a857c$var$xk & 1) && 0 !== a.tag && $17f526922e4a857c$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $17f526922e4a857c$var$zk ? $17f526922e4a857c$var$yk++ : ($17f526922e4a857c$var$yk = 0, $17f526922e4a857c$var$zk = a) : $17f526922e4a857c$var$yk = 0;
    $17f526922e4a857c$var$jg();
    return null;
}
function $17f526922e4a857c$var$Hk() {
    if (null !== $17f526922e4a857c$var$wk) {
        var a = $17f526922e4a857c$var$Dc($17f526922e4a857c$var$xk), b = $17f526922e4a857c$var$ok.transition, c = $17f526922e4a857c$var$C;
        try {
            $17f526922e4a857c$var$ok.transition = null;
            $17f526922e4a857c$var$C = 16 > a ? 16 : a;
            if (null === $17f526922e4a857c$var$wk) var d = !1;
            else {
                a = $17f526922e4a857c$var$wk;
                $17f526922e4a857c$var$wk = null;
                $17f526922e4a857c$var$xk = 0;
                if (0 !== ($17f526922e4a857c$var$K & 6)) throw Error($17f526922e4a857c$var$p(331));
                var e = $17f526922e4a857c$var$K;
                $17f526922e4a857c$var$K |= 4;
                for($17f526922e4a857c$var$V = a.current; null !== $17f526922e4a857c$var$V;){
                    var f = $17f526922e4a857c$var$V, g = f.child;
                    if (0 !== ($17f526922e4a857c$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($17f526922e4a857c$var$V = l; null !== $17f526922e4a857c$var$V;){
                                    var m = $17f526922e4a857c$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $17f526922e4a857c$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $17f526922e4a857c$var$V = q;
                                    else for(; null !== $17f526922e4a857c$var$V;){
                                        m = $17f526922e4a857c$var$V;
                                        var r = m.sibling, y = m.return;
                                        $17f526922e4a857c$var$Sj(m);
                                        if (m === l) {
                                            $17f526922e4a857c$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $17f526922e4a857c$var$V = r;
                                            break;
                                        }
                                        $17f526922e4a857c$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $17f526922e4a857c$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $17f526922e4a857c$var$V = g;
                    else b: for(; null !== $17f526922e4a857c$var$V;){
                        f = $17f526922e4a857c$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $17f526922e4a857c$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $17f526922e4a857c$var$V = x;
                            break b;
                        }
                        $17f526922e4a857c$var$V = f.return;
                    }
                }
                var w = a.current;
                for($17f526922e4a857c$var$V = w; null !== $17f526922e4a857c$var$V;){
                    g = $17f526922e4a857c$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $17f526922e4a857c$var$V = u;
                    else b: for(g = w; null !== $17f526922e4a857c$var$V;){
                        h = $17f526922e4a857c$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $17f526922e4a857c$var$Qj(9, h);
                            }
                        } catch (na) {
                            $17f526922e4a857c$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $17f526922e4a857c$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $17f526922e4a857c$var$V = F;
                            break b;
                        }
                        $17f526922e4a857c$var$V = h.return;
                    }
                }
                $17f526922e4a857c$var$K = e;
                $17f526922e4a857c$var$jg();
                if ($17f526922e4a857c$var$lc && "function" === typeof $17f526922e4a857c$var$lc.onPostCommitFiberRoot) try {
                    $17f526922e4a857c$var$lc.onPostCommitFiberRoot($17f526922e4a857c$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $17f526922e4a857c$var$C = c, $17f526922e4a857c$var$ok.transition = b;
        }
    }
    return !1;
}
function $17f526922e4a857c$var$Xk(a, b, c) {
    b = $17f526922e4a857c$var$Ji(c, b);
    b = $17f526922e4a857c$var$Ni(a, b, 1);
    a = $17f526922e4a857c$var$nh(a, b, 1);
    b = $17f526922e4a857c$var$R();
    null !== a && ($17f526922e4a857c$var$Ac(a, 1, b), $17f526922e4a857c$var$Dk(a, b));
}
function $17f526922e4a857c$var$W(a, b, c) {
    if (3 === a.tag) $17f526922e4a857c$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $17f526922e4a857c$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $17f526922e4a857c$var$Ri || !$17f526922e4a857c$var$Ri.has(d))) {
                a = $17f526922e4a857c$var$Ji(c, a);
                a = $17f526922e4a857c$var$Qi(b, a, 1);
                b = $17f526922e4a857c$var$nh(b, a, 1);
                a = $17f526922e4a857c$var$R();
                null !== b && ($17f526922e4a857c$var$Ac(b, 1, a), $17f526922e4a857c$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $17f526922e4a857c$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $17f526922e4a857c$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $17f526922e4a857c$var$Q === a && ($17f526922e4a857c$var$Z & c) === c && (4 === $17f526922e4a857c$var$T || 3 === $17f526922e4a857c$var$T && ($17f526922e4a857c$var$Z & 130023424) === $17f526922e4a857c$var$Z && 500 > $17f526922e4a857c$var$B() - $17f526922e4a857c$var$fk ? $17f526922e4a857c$var$Kk(a, 0) : $17f526922e4a857c$var$rk |= c);
    $17f526922e4a857c$var$Dk(a, b);
}
function $17f526922e4a857c$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $17f526922e4a857c$var$sc, $17f526922e4a857c$var$sc <<= 1, 0 === ($17f526922e4a857c$var$sc & 130023424) && ($17f526922e4a857c$var$sc = 4194304)));
    var c = $17f526922e4a857c$var$R();
    a = $17f526922e4a857c$var$ih(a, b);
    null !== a && ($17f526922e4a857c$var$Ac(a, b, c), $17f526922e4a857c$var$Dk(a, c));
}
function $17f526922e4a857c$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $17f526922e4a857c$var$Yk(a, c);
}
function $17f526922e4a857c$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($17f526922e4a857c$var$p(314));
    }
    null !== d && d.delete(b);
    $17f526922e4a857c$var$Yk(a, c);
}
var $17f526922e4a857c$var$Vk;
$17f526922e4a857c$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $17f526922e4a857c$var$Wf.current) $17f526922e4a857c$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $17f526922e4a857c$var$dh = !1, $17f526922e4a857c$var$yj(a, b, c);
            $17f526922e4a857c$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $17f526922e4a857c$var$dh = !1, $17f526922e4a857c$var$I && 0 !== (b.flags & 1048576) && $17f526922e4a857c$var$ug(b, $17f526922e4a857c$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $17f526922e4a857c$var$ij(a, b);
            a = b.pendingProps;
            var e = $17f526922e4a857c$var$Yf(b, $17f526922e4a857c$var$H.current);
            $17f526922e4a857c$var$ch(b, c);
            e = $17f526922e4a857c$var$Nh(null, b, d, a, e, c);
            var f = $17f526922e4a857c$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $17f526922e4a857c$var$Zf(d) ? (f = !0, $17f526922e4a857c$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $17f526922e4a857c$var$kh(b), e.updater = $17f526922e4a857c$var$Ei, b.stateNode = e, e._reactInternals = b, $17f526922e4a857c$var$Ii(b, d, a, c), b = $17f526922e4a857c$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $17f526922e4a857c$var$I && f && $17f526922e4a857c$var$vg(b), $17f526922e4a857c$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $17f526922e4a857c$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $17f526922e4a857c$var$Zk(d);
                a = $17f526922e4a857c$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $17f526922e4a857c$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $17f526922e4a857c$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $17f526922e4a857c$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $17f526922e4a857c$var$$i(null, b, d, $17f526922e4a857c$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($17f526922e4a857c$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $17f526922e4a857c$var$Ci(d, e), $17f526922e4a857c$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $17f526922e4a857c$var$Ci(d, e), $17f526922e4a857c$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $17f526922e4a857c$var$kj(b);
                if (null === a) throw Error($17f526922e4a857c$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $17f526922e4a857c$var$lh(a, b);
                $17f526922e4a857c$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $17f526922e4a857c$var$Ji(Error($17f526922e4a857c$var$p(423)), b);
                        b = $17f526922e4a857c$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $17f526922e4a857c$var$Ji(Error($17f526922e4a857c$var$p(424)), b);
                        b = $17f526922e4a857c$var$lj(a, b, d, c, e);
                        break a;
                    } else for($17f526922e4a857c$var$yg = $17f526922e4a857c$var$Lf(b.stateNode.containerInfo.firstChild), $17f526922e4a857c$var$xg = b, $17f526922e4a857c$var$I = !0, $17f526922e4a857c$var$zg = null, c = $17f526922e4a857c$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $17f526922e4a857c$var$Ig();
                    if (d === e) {
                        b = $17f526922e4a857c$var$Zi(a, b, c);
                        break a;
                    }
                    $17f526922e4a857c$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $17f526922e4a857c$var$Ah(b), null === a && $17f526922e4a857c$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $17f526922e4a857c$var$Ef(d, e) ? g = null : null !== f && $17f526922e4a857c$var$Ef(d, f) && (b.flags |= 32), $17f526922e4a857c$var$gj(a, b), $17f526922e4a857c$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $17f526922e4a857c$var$Eg(b), null;
        case 13:
            return $17f526922e4a857c$var$oj(a, b, c);
        case 4:
            return $17f526922e4a857c$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $17f526922e4a857c$var$Ug(b, null, d, c) : $17f526922e4a857c$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $17f526922e4a857c$var$Ci(d, e), $17f526922e4a857c$var$Yi(a, b, d, e, c);
        case 7:
            return $17f526922e4a857c$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $17f526922e4a857c$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $17f526922e4a857c$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $17f526922e4a857c$var$G($17f526922e4a857c$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($17f526922e4a857c$var$He(f.value, g)) {
                        if (f.children === e.children && !$17f526922e4a857c$var$Wf.current) {
                            b = $17f526922e4a857c$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $17f526922e4a857c$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $17f526922e4a857c$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($17f526922e4a857c$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $17f526922e4a857c$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $17f526922e4a857c$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $17f526922e4a857c$var$ch(b, c), e = $17f526922e4a857c$var$eh(e), d = d(e), b.flags |= 1, $17f526922e4a857c$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $17f526922e4a857c$var$Ci(d, b.pendingProps), e = $17f526922e4a857c$var$Ci(d.type, e), $17f526922e4a857c$var$$i(a, b, d, e, c);
        case 15:
            return $17f526922e4a857c$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $17f526922e4a857c$var$Ci(d, e), $17f526922e4a857c$var$ij(a, b), b.tag = 1, $17f526922e4a857c$var$Zf(d) ? (a = !0, $17f526922e4a857c$var$cg(b)) : a = !1, $17f526922e4a857c$var$ch(b, c), $17f526922e4a857c$var$Gi(b, d, e), $17f526922e4a857c$var$Ii(b, d, e, c), $17f526922e4a857c$var$jj(null, b, d, !0, a, c);
        case 19:
            return $17f526922e4a857c$var$xj(a, b, c);
        case 22:
            return $17f526922e4a857c$var$dj(a, b, c);
    }
    throw Error($17f526922e4a857c$var$p(156, b.tag));
};
function $17f526922e4a857c$var$Fk(a, b) {
    return $17f526922e4a857c$var$ac(a, b);
}
function $17f526922e4a857c$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $17f526922e4a857c$var$Bg(a, b, c, d) {
    return new $17f526922e4a857c$var$$k(a, b, c, d);
}
function $17f526922e4a857c$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $17f526922e4a857c$var$Zk(a) {
    if ("function" === typeof a) return $17f526922e4a857c$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $17f526922e4a857c$var$Da) return 11;
        if (a === $17f526922e4a857c$var$Ga) return 14;
    }
    return 2;
}
function $17f526922e4a857c$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $17f526922e4a857c$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $17f526922e4a857c$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $17f526922e4a857c$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $17f526922e4a857c$var$ya:
            return $17f526922e4a857c$var$Tg(c.children, e, f, b);
        case $17f526922e4a857c$var$za:
            g = 8;
            e |= 8;
            break;
        case $17f526922e4a857c$var$Aa:
            return a = $17f526922e4a857c$var$Bg(12, c, b, e | 2), a.elementType = $17f526922e4a857c$var$Aa, a.lanes = f, a;
        case $17f526922e4a857c$var$Ea:
            return a = $17f526922e4a857c$var$Bg(13, c, b, e), a.elementType = $17f526922e4a857c$var$Ea, a.lanes = f, a;
        case $17f526922e4a857c$var$Fa:
            return a = $17f526922e4a857c$var$Bg(19, c, b, e), a.elementType = $17f526922e4a857c$var$Fa, a.lanes = f, a;
        case $17f526922e4a857c$var$Ia:
            return $17f526922e4a857c$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $17f526922e4a857c$var$Ba:
                    g = 10;
                    break a;
                case $17f526922e4a857c$var$Ca:
                    g = 9;
                    break a;
                case $17f526922e4a857c$var$Da:
                    g = 11;
                    break a;
                case $17f526922e4a857c$var$Ga:
                    g = 14;
                    break a;
                case $17f526922e4a857c$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($17f526922e4a857c$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $17f526922e4a857c$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $17f526922e4a857c$var$Tg(a, b, c, d) {
    a = $17f526922e4a857c$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $17f526922e4a857c$var$pj(a, b, c, d) {
    a = $17f526922e4a857c$var$Bg(22, a, d, b);
    a.elementType = $17f526922e4a857c$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $17f526922e4a857c$var$Qg(a, b, c) {
    a = $17f526922e4a857c$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $17f526922e4a857c$var$Sg(a, b, c) {
    b = $17f526922e4a857c$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $17f526922e4a857c$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $17f526922e4a857c$var$zc(0);
    this.expirationTimes = $17f526922e4a857c$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $17f526922e4a857c$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $17f526922e4a857c$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $17f526922e4a857c$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $17f526922e4a857c$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $17f526922e4a857c$var$kh(f);
    return a;
}
function $17f526922e4a857c$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $17f526922e4a857c$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $17f526922e4a857c$var$dl(a) {
    if (!a) return $17f526922e4a857c$var$Vf;
    a = a._reactInternals;
    a: {
        if ($17f526922e4a857c$var$Vb(a) !== a || 1 !== a.tag) throw Error($17f526922e4a857c$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($17f526922e4a857c$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($17f526922e4a857c$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($17f526922e4a857c$var$Zf(c)) return $17f526922e4a857c$var$bg(a, c, b);
    }
    return b;
}
function $17f526922e4a857c$var$el(a, b, c, d, e, f, g, h, k) {
    a = $17f526922e4a857c$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $17f526922e4a857c$var$dl(null);
    c = a.current;
    d = $17f526922e4a857c$var$R();
    e = $17f526922e4a857c$var$yi(c);
    f = $17f526922e4a857c$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $17f526922e4a857c$var$nh(c, f, e);
    a.current.lanes = e;
    $17f526922e4a857c$var$Ac(a, e, d);
    $17f526922e4a857c$var$Dk(a, d);
    return a;
}
function $17f526922e4a857c$var$fl(a, b, c, d) {
    var e = b.current, f = $17f526922e4a857c$var$R(), g = $17f526922e4a857c$var$yi(e);
    c = $17f526922e4a857c$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $17f526922e4a857c$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $17f526922e4a857c$var$nh(e, b, g);
    null !== a && ($17f526922e4a857c$var$gi(a, e, g, f), $17f526922e4a857c$var$oh(a, e, g));
    return g;
}
function $17f526922e4a857c$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $17f526922e4a857c$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $17f526922e4a857c$var$il(a, b) {
    $17f526922e4a857c$var$hl(a, b);
    (a = a.alternate) && $17f526922e4a857c$var$hl(a, b);
}
function $17f526922e4a857c$var$jl() {
    return null;
}
var $17f526922e4a857c$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $17f526922e4a857c$var$ll(a) {
    this._internalRoot = a;
}
$17f526922e4a857c$var$ml.prototype.render = $17f526922e4a857c$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($17f526922e4a857c$var$p(409));
    $17f526922e4a857c$var$fl(a, b, null, null);
};
$17f526922e4a857c$var$ml.prototype.unmount = $17f526922e4a857c$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $17f526922e4a857c$var$Rk(function() {
            $17f526922e4a857c$var$fl(null, a, null, null);
        });
        b[$17f526922e4a857c$var$uf] = null;
    }
};
function $17f526922e4a857c$var$ml(a) {
    this._internalRoot = a;
}
$17f526922e4a857c$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $17f526922e4a857c$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $17f526922e4a857c$var$Qc.length && 0 !== b && b < $17f526922e4a857c$var$Qc[c].priority; c++);
        $17f526922e4a857c$var$Qc.splice(c, 0, a);
        0 === c && $17f526922e4a857c$var$Vc(a);
    }
};
function $17f526922e4a857c$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $17f526922e4a857c$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $17f526922e4a857c$var$pl() {}
function $17f526922e4a857c$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $17f526922e4a857c$var$gl(g);
                f.call(a);
            };
        }
        var g = $17f526922e4a857c$var$el(b, d, a, 0, null, !1, !1, "", $17f526922e4a857c$var$pl);
        a._reactRootContainer = g;
        a[$17f526922e4a857c$var$uf] = g.current;
        $17f526922e4a857c$var$sf(8 === a.nodeType ? a.parentNode : a);
        $17f526922e4a857c$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $17f526922e4a857c$var$gl(k);
            h.call(a);
        };
    }
    var k = $17f526922e4a857c$var$bl(a, 0, !1, null, null, !1, !1, "", $17f526922e4a857c$var$pl);
    a._reactRootContainer = k;
    a[$17f526922e4a857c$var$uf] = k.current;
    $17f526922e4a857c$var$sf(8 === a.nodeType ? a.parentNode : a);
    $17f526922e4a857c$var$Rk(function() {
        $17f526922e4a857c$var$fl(b, k, c, d);
    });
    return k;
}
function $17f526922e4a857c$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $17f526922e4a857c$var$gl(g);
                h.call(a);
            };
        }
        $17f526922e4a857c$var$fl(b, g, a, e);
    } else g = $17f526922e4a857c$var$ql(c, b, a, e, d);
    return $17f526922e4a857c$var$gl(g);
}
$17f526922e4a857c$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $17f526922e4a857c$var$tc(b.pendingLanes);
                0 !== c && ($17f526922e4a857c$var$Cc(b, c | 1), $17f526922e4a857c$var$Dk(b, $17f526922e4a857c$var$B()), 0 === ($17f526922e4a857c$var$K & 6) && ($17f526922e4a857c$var$Gj = $17f526922e4a857c$var$B() + 500, $17f526922e4a857c$var$jg()));
            }
            break;
        case 13:
            $17f526922e4a857c$var$Rk(function() {
                var b = $17f526922e4a857c$var$ih(a, 1);
                if (null !== b) {
                    var c = $17f526922e4a857c$var$R();
                    $17f526922e4a857c$var$gi(b, a, 1, c);
                }
            }), $17f526922e4a857c$var$il(a, 1);
    }
};
$17f526922e4a857c$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $17f526922e4a857c$var$ih(a, 134217728);
        if (null !== b) {
            var c = $17f526922e4a857c$var$R();
            $17f526922e4a857c$var$gi(b, a, 134217728, c);
        }
        $17f526922e4a857c$var$il(a, 134217728);
    }
};
$17f526922e4a857c$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $17f526922e4a857c$var$yi(a), c = $17f526922e4a857c$var$ih(a, b);
        if (null !== c) {
            var d = $17f526922e4a857c$var$R();
            $17f526922e4a857c$var$gi(c, a, b, d);
        }
        $17f526922e4a857c$var$il(a, b);
    }
};
$17f526922e4a857c$var$Hc = function() {
    return $17f526922e4a857c$var$C;
};
$17f526922e4a857c$var$Ic = function(a, b) {
    var c = $17f526922e4a857c$var$C;
    try {
        return $17f526922e4a857c$var$C = a, b();
    } finally{
        $17f526922e4a857c$var$C = c;
    }
};
$17f526922e4a857c$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $17f526922e4a857c$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $17f526922e4a857c$var$Db(d);
                        if (!e) throw Error($17f526922e4a857c$var$p(90));
                        $17f526922e4a857c$var$Wa(d);
                        $17f526922e4a857c$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $17f526922e4a857c$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $17f526922e4a857c$var$fb(a, !!c.multiple, b, !1);
    }
};
$17f526922e4a857c$var$Gb = $17f526922e4a857c$var$Qk;
$17f526922e4a857c$var$Hb = $17f526922e4a857c$var$Rk;
var $17f526922e4a857c$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $17f526922e4a857c$var$Cb,
        $17f526922e4a857c$var$ue,
        $17f526922e4a857c$var$Db,
        $17f526922e4a857c$var$Eb,
        $17f526922e4a857c$var$Fb,
        $17f526922e4a857c$var$Qk
    ]
}, $17f526922e4a857c$var$tl = {
    findFiberByHostInstance: $17f526922e4a857c$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $17f526922e4a857c$var$ul = {
    bundleType: $17f526922e4a857c$var$tl.bundleType,
    version: $17f526922e4a857c$var$tl.version,
    rendererPackageName: $17f526922e4a857c$var$tl.rendererPackageName,
    rendererConfig: $17f526922e4a857c$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $17f526922e4a857c$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $17f526922e4a857c$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $17f526922e4a857c$var$tl.findFiberByHostInstance || $17f526922e4a857c$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $17f526922e4a857c$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$17f526922e4a857c$var$vl.isDisabled && $17f526922e4a857c$var$vl.supportsFiber) try {
        $17f526922e4a857c$var$kc = $17f526922e4a857c$var$vl.inject($17f526922e4a857c$var$ul), $17f526922e4a857c$var$lc = $17f526922e4a857c$var$vl;
    } catch (a) {}
}
$17f526922e4a857c$export$ae55be85d98224ed = $17f526922e4a857c$var$sl;
$17f526922e4a857c$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$17f526922e4a857c$var$nl(b)) throw Error($17f526922e4a857c$var$p(200));
    return $17f526922e4a857c$var$cl(a, b, null, c);
};
$17f526922e4a857c$export$882461b6382ed46c = function(a, b) {
    if (!$17f526922e4a857c$var$nl(a)) throw Error($17f526922e4a857c$var$p(299));
    var c = !1, d = "", e = $17f526922e4a857c$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $17f526922e4a857c$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$17f526922e4a857c$var$uf] = b.current;
    $17f526922e4a857c$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $17f526922e4a857c$var$ll(b);
};
$17f526922e4a857c$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($17f526922e4a857c$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($17f526922e4a857c$var$p(268, a));
    }
    a = $17f526922e4a857c$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$17f526922e4a857c$export$cd75ccfd720a3cd4 = function(a) {
    return $17f526922e4a857c$var$Rk(a);
};
$17f526922e4a857c$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$17f526922e4a857c$var$ol(b)) throw Error($17f526922e4a857c$var$p(200));
    return $17f526922e4a857c$var$rl(null, a, b, !0, c);
};
$17f526922e4a857c$export$757ceba2d55c277e = function(a, b, c) {
    if (!$17f526922e4a857c$var$nl(a)) throw Error($17f526922e4a857c$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $17f526922e4a857c$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $17f526922e4a857c$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$17f526922e4a857c$var$uf] = b.current;
    $17f526922e4a857c$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $17f526922e4a857c$var$ml(b);
};
$17f526922e4a857c$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$17f526922e4a857c$var$ol(b)) throw Error($17f526922e4a857c$var$p(200));
    return $17f526922e4a857c$var$rl(null, a, b, !1, c);
};
$17f526922e4a857c$export$502457920280e6be = function(a) {
    if (!$17f526922e4a857c$var$ol(a)) throw Error($17f526922e4a857c$var$p(40));
    return a._reactRootContainer ? ($17f526922e4a857c$var$Rk(function() {
        $17f526922e4a857c$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$17f526922e4a857c$var$uf] = null;
        });
    }), !0) : !1;
};
$17f526922e4a857c$export$c78a37762a8d58e1 = $17f526922e4a857c$var$Qk;
$17f526922e4a857c$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$17f526922e4a857c$var$ol(c)) throw Error($17f526922e4a857c$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($17f526922e4a857c$var$p(38));
    return $17f526922e4a857c$var$rl(a, b, c, !1, d);
};
$17f526922e4a857c$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("clk2u", function(module, exports) {
"use strict";

module.exports = (parcelRequire("5fXYF"));

});
parcelRegister("5fXYF", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $3d3ce0c592af0505$export$c4744153514ff05d, (v) => $3d3ce0c592af0505$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $3d3ce0c592af0505$export$3e506c1ccc9cc1a7, (v) => $3d3ce0c592af0505$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $3d3ce0c592af0505$export$e26fe2ed2fa76875, (v) => $3d3ce0c592af0505$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $3d3ce0c592af0505$export$502329bbf4b505b1, (v) => $3d3ce0c592af0505$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $3d3ce0c592af0505$export$6e3807111c4874c4, (v) => $3d3ce0c592af0505$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $3d3ce0c592af0505$export$c27134553091fb3a, (v) => $3d3ce0c592af0505$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $3d3ce0c592af0505$export$33ee1acdc04fd2a2, (v) => $3d3ce0c592af0505$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $3d3ce0c592af0505$export$b00a404bbd5edef2, (v) => $3d3ce0c592af0505$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $3d3ce0c592af0505$export$8352ce38b91d0c62, (v) => $3d3ce0c592af0505$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $3d3ce0c592af0505$export$d66a1c1c77bd778b, (v) => $3d3ce0c592af0505$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $3d3ce0c592af0505$export$d3dfb8e4810cb555, (v) => $3d3ce0c592af0505$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $3d3ce0c592af0505$export$839f9183b0465a69, (v) => $3d3ce0c592af0505$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $3d3ce0c592af0505$export$72fdf0e06517287b, (v) => $3d3ce0c592af0505$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $3d3ce0c592af0505$export$4b844e58a3e414b4, (v) => $3d3ce0c592af0505$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $3d3ce0c592af0505$export$816d2913ae6b83b1, (v) => $3d3ce0c592af0505$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $3d3ce0c592af0505$export$61bcfe829111a1d0, (v) => $3d3ce0c592af0505$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $3d3ce0c592af0505$export$7ee8c9beb337bc3f, (v) => $3d3ce0c592af0505$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $3d3ce0c592af0505$export$b5836b71941fa3ed, (v) => $3d3ce0c592af0505$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $3d3ce0c592af0505$export$cf845f2c119da08a, (v) => $3d3ce0c592af0505$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3d3ce0c592af0505$export$c4744153514ff05d;
var $3d3ce0c592af0505$export$3e506c1ccc9cc1a7;
var $3d3ce0c592af0505$export$e26fe2ed2fa76875;
var $3d3ce0c592af0505$export$502329bbf4b505b1;
var $3d3ce0c592af0505$export$6e3807111c4874c4;
var $3d3ce0c592af0505$export$c27134553091fb3a;
var $3d3ce0c592af0505$export$33ee1acdc04fd2a2;
var $3d3ce0c592af0505$export$b00a404bbd5edef2;
var $3d3ce0c592af0505$export$8352ce38b91d0c62;
var $3d3ce0c592af0505$export$d66a1c1c77bd778b;
var $3d3ce0c592af0505$export$d3dfb8e4810cb555;
var $3d3ce0c592af0505$export$839f9183b0465a69;
var $3d3ce0c592af0505$export$72fdf0e06517287b;
var $3d3ce0c592af0505$export$4b844e58a3e414b4;
var $3d3ce0c592af0505$export$816d2913ae6b83b1;
var $3d3ce0c592af0505$export$61bcfe829111a1d0;
var $3d3ce0c592af0505$export$7ee8c9beb337bc3f;
var $3d3ce0c592af0505$export$b5836b71941fa3ed;
var $3d3ce0c592af0505$export$cf845f2c119da08a;
"use strict";
function $3d3ce0c592af0505$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $3d3ce0c592af0505$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $3d3ce0c592af0505$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $3d3ce0c592af0505$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $3d3ce0c592af0505$var$g(C, c)) n < e && 0 > $3d3ce0c592af0505$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $3d3ce0c592af0505$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $3d3ce0c592af0505$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $3d3ce0c592af0505$var$l = performance;
    $3d3ce0c592af0505$export$c4744153514ff05d = function() {
        return $3d3ce0c592af0505$var$l.now();
    };
} else {
    var $3d3ce0c592af0505$var$p = Date, $3d3ce0c592af0505$var$q = $3d3ce0c592af0505$var$p.now();
    $3d3ce0c592af0505$export$c4744153514ff05d = function() {
        return $3d3ce0c592af0505$var$p.now() - $3d3ce0c592af0505$var$q;
    };
}
var $3d3ce0c592af0505$var$r = [], $3d3ce0c592af0505$var$t = [], $3d3ce0c592af0505$var$u = 1, $3d3ce0c592af0505$var$v = null, $3d3ce0c592af0505$var$y = 3, $3d3ce0c592af0505$var$z = !1, $3d3ce0c592af0505$var$A = !1, $3d3ce0c592af0505$var$B = !1, $3d3ce0c592af0505$var$D = "function" === typeof setTimeout ? setTimeout : null, $3d3ce0c592af0505$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $3d3ce0c592af0505$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $3d3ce0c592af0505$var$G(a) {
    for(var b = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t); null !== b;){
        if (null === b.callback) $3d3ce0c592af0505$var$k($3d3ce0c592af0505$var$t);
        else if (b.startTime <= a) $3d3ce0c592af0505$var$k($3d3ce0c592af0505$var$t), b.sortIndex = b.expirationTime, $3d3ce0c592af0505$var$f($3d3ce0c592af0505$var$r, b);
        else break;
        b = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t);
    }
}
function $3d3ce0c592af0505$var$H(a) {
    $3d3ce0c592af0505$var$B = !1;
    $3d3ce0c592af0505$var$G(a);
    if (!$3d3ce0c592af0505$var$A) {
        if (null !== $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r)) $3d3ce0c592af0505$var$A = !0, $3d3ce0c592af0505$var$I($3d3ce0c592af0505$var$J);
        else {
            var b = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t);
            null !== b && $3d3ce0c592af0505$var$K($3d3ce0c592af0505$var$H, b.startTime - a);
        }
    }
}
function $3d3ce0c592af0505$var$J(a, b) {
    $3d3ce0c592af0505$var$A = !1;
    $3d3ce0c592af0505$var$B && ($3d3ce0c592af0505$var$B = !1, $3d3ce0c592af0505$var$E($3d3ce0c592af0505$var$L), $3d3ce0c592af0505$var$L = -1);
    $3d3ce0c592af0505$var$z = !0;
    var c = $3d3ce0c592af0505$var$y;
    try {
        $3d3ce0c592af0505$var$G(b);
        for($3d3ce0c592af0505$var$v = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r); null !== $3d3ce0c592af0505$var$v && (!($3d3ce0c592af0505$var$v.expirationTime > b) || a && !$3d3ce0c592af0505$var$M());){
            var d = $3d3ce0c592af0505$var$v.callback;
            if ("function" === typeof d) {
                $3d3ce0c592af0505$var$v.callback = null;
                $3d3ce0c592af0505$var$y = $3d3ce0c592af0505$var$v.priorityLevel;
                var e = d($3d3ce0c592af0505$var$v.expirationTime <= b);
                b = $3d3ce0c592af0505$export$c4744153514ff05d();
                "function" === typeof e ? $3d3ce0c592af0505$var$v.callback = e : $3d3ce0c592af0505$var$v === $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r) && $3d3ce0c592af0505$var$k($3d3ce0c592af0505$var$r);
                $3d3ce0c592af0505$var$G(b);
            } else $3d3ce0c592af0505$var$k($3d3ce0c592af0505$var$r);
            $3d3ce0c592af0505$var$v = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r);
        }
        if (null !== $3d3ce0c592af0505$var$v) var w = !0;
        else {
            var m = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t);
            null !== m && $3d3ce0c592af0505$var$K($3d3ce0c592af0505$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $3d3ce0c592af0505$var$v = null, $3d3ce0c592af0505$var$y = c, $3d3ce0c592af0505$var$z = !1;
    }
}
var $3d3ce0c592af0505$var$N = !1, $3d3ce0c592af0505$var$O = null, $3d3ce0c592af0505$var$L = -1, $3d3ce0c592af0505$var$P = 5, $3d3ce0c592af0505$var$Q = -1;
function $3d3ce0c592af0505$var$M() {
    return $3d3ce0c592af0505$export$c4744153514ff05d() - $3d3ce0c592af0505$var$Q < $3d3ce0c592af0505$var$P ? !1 : !0;
}
function $3d3ce0c592af0505$var$R() {
    if (null !== $3d3ce0c592af0505$var$O) {
        var a = $3d3ce0c592af0505$export$c4744153514ff05d();
        $3d3ce0c592af0505$var$Q = a;
        var b = !0;
        try {
            b = $3d3ce0c592af0505$var$O(!0, a);
        } finally{
            b ? $3d3ce0c592af0505$var$S() : ($3d3ce0c592af0505$var$N = !1, $3d3ce0c592af0505$var$O = null);
        }
    } else $3d3ce0c592af0505$var$N = !1;
}
var $3d3ce0c592af0505$var$S;
if ("function" === typeof $3d3ce0c592af0505$var$F) $3d3ce0c592af0505$var$S = function() {
    $3d3ce0c592af0505$var$F($3d3ce0c592af0505$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $3d3ce0c592af0505$var$T = new MessageChannel, $3d3ce0c592af0505$var$U = $3d3ce0c592af0505$var$T.port2;
    $3d3ce0c592af0505$var$T.port1.onmessage = $3d3ce0c592af0505$var$R;
    $3d3ce0c592af0505$var$S = function() {
        $3d3ce0c592af0505$var$U.postMessage(null);
    };
} else $3d3ce0c592af0505$var$S = function() {
    $3d3ce0c592af0505$var$D($3d3ce0c592af0505$var$R, 0);
};
function $3d3ce0c592af0505$var$I(a) {
    $3d3ce0c592af0505$var$O = a;
    $3d3ce0c592af0505$var$N || ($3d3ce0c592af0505$var$N = !0, $3d3ce0c592af0505$var$S());
}
function $3d3ce0c592af0505$var$K(a, b) {
    $3d3ce0c592af0505$var$L = $3d3ce0c592af0505$var$D(function() {
        a($3d3ce0c592af0505$export$c4744153514ff05d());
    }, b);
}
$3d3ce0c592af0505$export$3e506c1ccc9cc1a7 = 5;
$3d3ce0c592af0505$export$e26fe2ed2fa76875 = 1;
$3d3ce0c592af0505$export$502329bbf4b505b1 = 4;
$3d3ce0c592af0505$export$6e3807111c4874c4 = 3;
$3d3ce0c592af0505$export$c27134553091fb3a = null;
$3d3ce0c592af0505$export$33ee1acdc04fd2a2 = 2;
$3d3ce0c592af0505$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$3d3ce0c592af0505$export$8352ce38b91d0c62 = function() {
    $3d3ce0c592af0505$var$A || $3d3ce0c592af0505$var$z || ($3d3ce0c592af0505$var$A = !0, $3d3ce0c592af0505$var$I($3d3ce0c592af0505$var$J));
};
$3d3ce0c592af0505$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $3d3ce0c592af0505$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$3d3ce0c592af0505$export$d3dfb8e4810cb555 = function() {
    return $3d3ce0c592af0505$var$y;
};
$3d3ce0c592af0505$export$839f9183b0465a69 = function() {
    return $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r);
};
$3d3ce0c592af0505$export$72fdf0e06517287b = function(a) {
    switch($3d3ce0c592af0505$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $3d3ce0c592af0505$var$y;
    }
    var c = $3d3ce0c592af0505$var$y;
    $3d3ce0c592af0505$var$y = b;
    try {
        return a();
    } finally{
        $3d3ce0c592af0505$var$y = c;
    }
};
$3d3ce0c592af0505$export$4b844e58a3e414b4 = function() {};
$3d3ce0c592af0505$export$816d2913ae6b83b1 = function() {};
$3d3ce0c592af0505$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $3d3ce0c592af0505$var$y;
    $3d3ce0c592af0505$var$y = a;
    try {
        return b();
    } finally{
        $3d3ce0c592af0505$var$y = c;
    }
};
$3d3ce0c592af0505$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $3d3ce0c592af0505$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $3d3ce0c592af0505$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $3d3ce0c592af0505$var$f($3d3ce0c592af0505$var$t, a), null === $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r) && a === $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t) && ($3d3ce0c592af0505$var$B ? ($3d3ce0c592af0505$var$E($3d3ce0c592af0505$var$L), $3d3ce0c592af0505$var$L = -1) : $3d3ce0c592af0505$var$B = !0, $3d3ce0c592af0505$var$K($3d3ce0c592af0505$var$H, c - d))) : (a.sortIndex = e, $3d3ce0c592af0505$var$f($3d3ce0c592af0505$var$r, a), $3d3ce0c592af0505$var$A || $3d3ce0c592af0505$var$z || ($3d3ce0c592af0505$var$A = !0, $3d3ce0c592af0505$var$I($3d3ce0c592af0505$var$J)));
    return a;
};
$3d3ce0c592af0505$export$b5836b71941fa3ed = $3d3ce0c592af0505$var$M;
$3d3ce0c592af0505$export$cf845f2c119da08a = function(a) {
    var b = $3d3ce0c592af0505$var$y;
    return function() {
        var c = $3d3ce0c592af0505$var$y;
        $3d3ce0c592af0505$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $3d3ce0c592af0505$var$y = c;
        }
    };
};

});





parcelRegister("1BMjF", function(module, exports) {
"use strict";
var $12beb9b8fb7778a1$var$__rest = module.exports && module.exports.__rest || function(e, t) {
    var o = {};
    for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (o[r] = e[r]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var s = 0;
        for(r = Object.getOwnPropertySymbols(e); s < r.length; s++)t.indexOf(r[s]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[s]) && (o[r[s]] = e[r[s]]);
    }
    return o;
}, $12beb9b8fb7778a1$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.Workspace = void 0;

const $12beb9b8fb7778a1$var$react_1 = $12beb9b8fb7778a1$var$__importDefault((parcelRequire("8NFma")));

var $5R7Wm = parcelRequire("5R7Wm");

var $aCLBN = parcelRequire("aCLBN");

var $8OWT0 = parcelRequire("8OWT0");
const $12beb9b8fb7778a1$var$Workspace = (e)=>{
    var t, o, { components: r } = e, s = $12beb9b8fb7778a1$var$__rest(e, [
        "components"
    ]);
    return (r = r || {}).PageControls = null !== (t = r.PageControls) && void 0 !== t ? t : $aCLBN.PageControls, r.Tooltip = null !== (o = r.Tooltip) && void 0 !== o ? o : $8OWT0.Tooltip, $12beb9b8fb7778a1$var$react_1.default.createElement($5R7Wm.WorkspaceCanvas, Object.assign({}, s, {
        components: r
    }));
};
module.exports.Workspace = $12beb9b8fb7778a1$var$Workspace, module.exports.default = module.exports.Workspace;

});
parcelRegister("5R7Wm", function(module, exports) {
"use strict";
var $44380fc2f05075e1$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.WorkspaceCanvas = void 0;

const $44380fc2f05075e1$var$react_1 = $44380fc2f05075e1$var$__importDefault((parcelRequire("8NFma")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

const $44380fc2f05075e1$var$page_1 = $44380fc2f05075e1$var$__importDefault((parcelRequire("gvVvd")));

var $msF0x = parcelRequire("msF0x");

var $ej9US = parcelRequire("ej9US");

var $xARwM = parcelRequire("xARwM");
const $44380fc2f05075e1$var$limit = (e, t, r)=>Math.max(t, Math.min(r, e)), $44380fc2f05075e1$var$ZERO_SIZE_WARNING = "Polotno warning: <Workspace /> component can not automatically detect its size.\nWidth or height of parent elements is equal 0.\nPlease make sure it has non-zero size. You may need to adjust it with your styles. <Workspace /> will automatically fit into parent container.\nFor simpler debugging here is the log of the parent element:", $44380fc2f05075e1$var$useSaveScrollOnScaleChange = (e, t, r, a, n, l)=>{
    const o = $44380fc2f05075e1$var$react_1.default.useRef({
        width: t,
        height: r
    }), c = $44380fc2f05075e1$var$react_1.default.useRef({
        top: 0,
        left: 0
    }), s = $44380fc2f05075e1$var$react_1.default.useRef(!1), i = $44380fc2f05075e1$var$react_1.default.useRef(n.pages.length);
    s.current = i.current !== n.pages.length, i.current = n.pages.length, $44380fc2f05075e1$var$react_1.default.useEffect(()=>{
        const t = e.current, r = (e)=>{
            c.current = {
                top: t.scrollTop,
                left: t.scrollLeft
            };
        };
        return t.addEventListener("scroll", r), ()=>{
            t.removeEventListener("scroll", r);
        };
    }, []), $44380fc2f05075e1$var$react_1.default.useLayoutEffect(()=>{
        if (!e.current) return;
        if (s.current) return;
        const a = e.current, n = (c.current.left + a.offsetWidth / 2) / o.current.width, i = (c.current.top + a.offsetHeight / 2) / o.current.height;
        l.current = !0, a.scrollLeft = n * t - a.offsetWidth / 2, a.scrollTop = i * r - a.offsetHeight / 2, o.current = {
            width: t,
            height: r
        };
    }, [
        a,
        t,
        r
    ]);
}, $44380fc2f05075e1$var$useScrollOnActiveChange = (e, t, r, a, n)=>{
    const l = $44380fc2f05075e1$var$react_1.default.useRef(!1), o = $44380fc2f05075e1$var$react_1.default.useRef(null);
    $44380fc2f05075e1$var$react_1.default.useEffect(()=>{
        const t = e.current, r = ()=>{
            n.current;
        };
        return t.addEventListener("scroll", r), ()=>{
            t.removeEventListener("scroll", r);
        };
    }, []);
    const c = r.pages.indexOf(r.activePage);
    $44380fc2f05075e1$var$react_1.default.useLayoutEffect(()=>{
        if (!r.activePage) return;
        if (!e.current) return;
        if (l.current) return;
        const a = e.current, o = r.pages.indexOf(r.activePage) * t;
        Math.abs(o - a.scrollTop) > .5 * t && (n.current = !0, a.scrollTop = o);
    }, [
        r.activePage,
        c
    ]);
    return {
        handleScroll: (e)=>{
            if (n.current) return void (n.current = !1);
            l.current = !0, clearTimeout(o.current), o.current = setTimeout(()=>{
                l.current = !1;
            }, 300);
            const t = e.currentTarget.childNodes[0].offsetHeight, c = e.currentTarget.scrollTop, s = Math.floor((c + a.height / 3) / t), i = r.pages[s];
            i && i.select();
        }
    };
}, $44380fc2f05075e1$var$NoPages = ({ store: e })=>$44380fc2f05075e1$var$react_1.default.createElement("div", {
        style: {
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center"
        }
    }, $44380fc2f05075e1$var$react_1.default.createElement("p", null, (0, $xARwM.t)("workspace.noPages")), $44380fc2f05075e1$var$react_1.default.createElement("button", {
        onClick: ()=>{
            e.addPage();
        }
    }, (0, $xARwM.t)("workspace.addPage"))), $44380fc2f05075e1$var$PagePlaceholder = ({ width: e, height: t, xPadding: r, yPadding: a, backgroundColor: n })=>$44380fc2f05075e1$var$react_1.default.createElement("div", {
        style: {
            width: e + "px",
            height: t + "px",
            backgroundColor: n,
            paddingLeft: r + "px",
            paddingRight: r + "px",
            paddingTop: a + "px",
            paddingBottom: a + "px"
        }
    }, $44380fc2f05075e1$var$react_1.default.createElement("div", {
        style: {
            width: " 100%",
            height: "100%",
            backgroundColor: "white"
        }
    }));
module.exports.WorkspaceCanvas = (0, $O1ETn.observer)(({ store: e, pageControlsEnabled: t, backgroundColor: r, pageBorderColor: a, activePageBorderColor: n, bleedColor: l, components: o, onKeyDown: c, paddingX: s, paddingY: i, altCloneEnabled: u = !0 })=>{
    const d = null != s ? s : 20, h = null != i ? i : 55, [g, f] = $44380fc2f05075e1$var$react_1.default.useState({
        width: 100,
        height: 100
    }), p = $44380fc2f05075e1$var$react_1.default.useRef(g), m = $44380fc2f05075e1$var$react_1.default.useRef(null), _ = $44380fc2f05075e1$var$react_1.default.useRef(null), v = e.bleedVisible ? Math.max(0, ...e.pages.map((e)=>e.bleed)) : 0, w = Math.max(...e.pages.map((e)=>e.computedWidth)), b = Math.max(...e.pages.map((e)=>e.computedHeight)), E = w + 2 * v, x = b + 2 * v, k = async ({ skipTimeout: t } = {
        skipTimeout: !1
    })=>{
        if (t || await new Promise((e)=>setTimeout(e, 50)), null === m.current) return;
        const r = m.current.getBoundingClientRect();
        0 !== r.width && 0 !== r.height || (console.warn($44380fc2f05075e1$var$ZERO_SIZE_WARNING), console.log(m.current));
        const a = _.current.clientWidth || r.width, n = {
            width: a,
            height: r.height
        };
        (p.current.width !== n.width || p.current.height !== n.height) && (f(n), p.current = n);
        const l = (a - 2 * d) / E, o = (r.height - 2 * h) / x, c = Math.max(Math.min(l, o), .01);
        e.scaleToFit !== c && (e.setScale(c), e._setScaleToFit(c));
    };
    $44380fc2f05075e1$var$react_1.default.useLayoutEffect(()=>{
        k({
            skipTimeout: !0
        });
    }, []), $44380fc2f05075e1$var$react_1.default.useEffect(()=>{
        k();
    }, [
        E,
        x
    ]), $44380fc2f05075e1$var$react_1.default.useEffect(()=>{
        const e = m.current;
        if (window.ResizeObserver) {
            const t = new ResizeObserver(()=>{
                k({
                    skipTimeout: !0
                });
            });
            return t.observe(e), ()=>t.unobserve(e);
        }
        {
            const e = setInterval(()=>{
                k({
                    skipTimeout: !0
                });
            }, 100);
            return ()=>clearInterval(e);
        }
    }, [
        E,
        x
    ]);
    const y = Math.max(d, (g.width - E * e.scale) / 2), P = x * e.scale * e.pages.length, C = Math.max(h, (g.height - P) / e.pages.length / 2);
    $44380fc2f05075e1$var$react_1.default.useEffect(()=>{
        const t = (t)=>{
            (c || $ej9US.handleHotkey)(t, e);
        };
        return window.addEventListener("keydown", t), ()=>window.removeEventListener("keydown", t);
    }, []), $44380fc2f05075e1$var$react_1.default.useEffect(()=>{
        var t;
        const r = (t)=>{
            if (t.ctrlKey || t.metaKey) {
                t.preventDefault();
                const l = Math.max(3, e.scaleToFit), o = Math.min(.1, e.scaleToFit), c = (r = t.deltaY < 0 ? 1.05 * e.scale : e.scale / 1.05, a = o, n = l, Math.max(a, Math.min(n, r)));
                e.setScale(c);
            } else var r, a, n;
        };
        return null === (t = _.current) || void 0 === t || t.addEventListener("wheel", r), ()=>{
            var e;
            return null === (e = _.current) || void 0 === e ? void 0 : e.removeEventListener("wheel", r);
        };
    }, []);
    const M = $44380fc2f05075e1$var$react_1.default.useRef(!1);
    $44380fc2f05075e1$var$useSaveScrollOnScaleChange(_, E * e.scale + 2 * y, x * e.scale + 2 * C, e.scale, e, M);
    const { handleScroll: T } = $44380fc2f05075e1$var$useScrollOnActiveChange(_, x * e.scale + 2 * C, e, g, M), R = g.width >= E * e.scale + 2 * y, S = r || "rgba(232, 232, 232, 0.9)", L = e.pages.indexOf(e.activePage), O = (null == o ? void 0 : o.NoPages) || $44380fc2f05075e1$var$NoPages, W = Math.min(3, Math.max(1, Math.ceil(g.height / 2 / (x * e.scale))));
    return $44380fc2f05075e1$var$react_1.default.createElement("div", {
        ref: m,
        style: {
            width: "100%",
            height: "100%",
            position: "relative",
            outline: "none",
            flex: 1,
            backgroundColor: S
        },
        tabIndex: 0,
        className: "polotno-workspace-container"
    }, $44380fc2f05075e1$var$react_1.default.createElement("div", {
        ref: _,
        onScroll: T,
        style: {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            overflow: "auto",
            overflowX: R ? "hidden" : "auto"
        },
        className: "polotno-workspace-inner"
    }, e.pages.map((r, c)=>Math.abs(c - L) <= W || r._exporting ? $44380fc2f05075e1$var$react_1.default.createElement($44380fc2f05075e1$var$page_1.default, {
            key: r.id,
            page: r,
            xPadding: y,
            yPadding: C,
            width: E * e.scale + 2 * y,
            height: x * e.scale + 2 * C,
            store: e,
            pageControlsEnabled: t,
            backColor: S,
            pageBorderColor: a || "lightgrey",
            activePageBorderColor: n || "rgb(0, 161, 255)",
            altCloneEnabled: u,
            bleedColor: l || "rgba(255, 0, 0, 0.1)",
            components: o
        }) : $44380fc2f05075e1$var$react_1.default.createElement($44380fc2f05075e1$var$PagePlaceholder, {
            key: r.id,
            width: E * e.scale + 2 * y,
            height: x * e.scale + 2 * C,
            backgroundColor: S,
            xPadding: y,
            yPadding: C
        })), e.rulesVisible && $44380fc2f05075e1$var$react_1.default.createElement($msF0x.TopRules, {
        store: e,
        xPadding: y,
        yPadding: C,
        width: E * e.scale + 2 * y,
        height: x * e.scale + 2 * C
    }), 0 === e.pages.length && $44380fc2f05075e1$var$react_1.default.createElement(O, {
        store: e
    })));
}), module.exports.default = module.exports.WorkspaceCanvas;

});
parcelRegister("1w94b", function(module, exports) {

$parcel$export(module.exports, "observer", () => (parcelRequire("O1ETn")).observer);
$parcel$export(module.exports, "useLocalObservable", () => (parcelRequire("i3QX2")).useLocalObservable);
parcelRequire("5oDAH");
parcelRequire("diRXV");
var $2pmb0 = parcelRequire("2pmb0");

var $aDZHk = parcelRequire("aDZHk");
parcelRequire("1usTX");

var $bVXrj = parcelRequire("bVXrj");

var $fYQhH = parcelRequire("fYQhH");

var $lltNi = parcelRequire("lltNi");

var $O1ETn = parcelRequire("O1ETn");

var $dAvow = parcelRequire("dAvow");

var $i3QX2 = parcelRequire("i3QX2");

var $2FXrs = parcelRequire("2FXrs");

var $fid9Y = parcelRequire("fid9Y");
var $11afd00155cce221$var$_a;
(0, $aDZHk.observerBatching)((0, $2pmb0.unstable_batchedUpdates));
var $11afd00155cce221$export$469d51fb8d268227 = ($11afd00155cce221$var$_a = (0, $lltNi.observerFinalizationRegistry)["finalizeAllImmediately"]) !== null && $11afd00155cce221$var$_a !== void 0 ? $11afd00155cce221$var$_a : function() {};
function $11afd00155cce221$export$b9c7ecd090a87b14(fn, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    return (0, $bVXrj.useObserver)(fn, baseComponentName);
}
function $11afd00155cce221$export$7613124ee4202834(enable) {
    (0, $fYQhH.enableStaticRendering)(enable);
}

});
parcelRegister("5oDAH", function(module, exports) {

var $2SBKn = parcelRequire("2SBKn");

var $8NFma = parcelRequire("8NFma");
if (!(0, $8NFma.useState)) throw new Error("mobx-react-lite requires React with Hooks support");
if (!(0, $2SBKn.makeObservable)) throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");

});
parcelRegister("2SBKn", function(module, exports) {

$parcel$export(module.exports, "$mobx", () => $mobx);
$parcel$export(module.exports, "createAtom", () => createAtom);
$parcel$export(module.exports, "onBecomeObserved", () => onBecomeObserved);
$parcel$export(module.exports, "onBecomeUnobserved", () => onBecomeUnobserved);
$parcel$export(module.exports, "comparer", () => comparer);
$parcel$export(module.exports, "isObservable", () => isObservable);
$parcel$export(module.exports, "observable", () => observable);
$parcel$export(module.exports, "isAction", () => isAction);
$parcel$export(module.exports, "isFlow", () => isFlow);
$parcel$export(module.exports, "flow", () => flow);
$parcel$export(module.exports, "_autoAction", () => autoAction);
$parcel$export(module.exports, "isObservableObject", () => isObservableObject);
$parcel$export(module.exports, "isObservableArray", () => isObservableArray);
$parcel$export(module.exports, "isObservableMap", () => isObservableMap);
$parcel$export(module.exports, "isObservableSet", () => isObservableSet);
$parcel$export(module.exports, "override", () => override);
$parcel$export(module.exports, "computed", () => computed);
$parcel$export(module.exports, "ObservableMap", () => ObservableMap);
$parcel$export(module.exports, "ObservableSet", () => ObservableSet);
$parcel$export(module.exports, "extendObservable", () => extendObservable);
$parcel$export(module.exports, "_startAction", () => _startAction);
$parcel$export(module.exports, "_endAction", () => _endAction);
$parcel$export(module.exports, "_allowStateReadsStart", () => allowStateReadsStart);
$parcel$export(module.exports, "_allowStateReadsEnd", () => allowStateReadsEnd);
$parcel$export(module.exports, "_allowStateChanges", () => allowStateChanges);
$parcel$export(module.exports, "isBoxedObservable", () => isObservableValue);
$parcel$export(module.exports, "autorun", () => autorun);
$parcel$export(module.exports, "_isComputingDerivation", () => isComputingDerivation);
$parcel$export(module.exports, "untracked", () => untracked);
$parcel$export(module.exports, "_getGlobalState", () => getGlobalState);
$parcel$export(module.exports, "_resetGlobalState", () => resetGlobalState);
$parcel$export(module.exports, "getDependencyTree", () => getDependencyTree);
$parcel$export(module.exports, "Reaction", () => Reaction);
$parcel$export(module.exports, "trace", () => trace);
$parcel$export(module.exports, "onReactionError", () => onReactionError);
$parcel$export(module.exports, "spy", () => spy);
$parcel$export(module.exports, "action", () => action);
$parcel$export(module.exports, "_allowStateChangesInsideComputed", () => runInAction);
$parcel$export(module.exports, "reaction", () => reaction);
$parcel$export(module.exports, "getAtom", () => getAtom);
$parcel$export(module.exports, "configure", () => configure);
$parcel$export(module.exports, "getObserverTree", () => getObserverTree);
$parcel$export(module.exports, "FlowCancellationError", () => FlowCancellationError);
$parcel$export(module.exports, "isFlowCancellationError", () => isFlowCancellationError);
$parcel$export(module.exports, "flowResult", () => flowResult);
$parcel$export(module.exports, "_interceptReads", () => interceptReads);
$parcel$export(module.exports, "_getAdministration", () => getAdministration);
$parcel$export(module.exports, "intercept", () => intercept);
$parcel$export(module.exports, "isComputed", () => isComputed);
$parcel$export(module.exports, "isComputedProp", () => isComputedProp);
$parcel$export(module.exports, "isObservableProp", () => isObservableProp);
$parcel$export(module.exports, "keys", () => keys);
$parcel$export(module.exports, "values", () => values);
$parcel$export(module.exports, "entries", () => entries);
$parcel$export(module.exports, "set", () => set);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "has", () => has);
$parcel$export(module.exports, "get", () => get);
$parcel$export(module.exports, "defineProperty", () => apiDefineProperty);
$parcel$export(module.exports, "ownKeys", () => apiOwnKeys);
$parcel$export(module.exports, "observe", () => observe);
$parcel$export(module.exports, "toJS", () => toJS);
$parcel$export(module.exports, "transaction", () => transaction);
$parcel$export(module.exports, "when", () => when);
$parcel$export(module.exports, "makeObservable", () => makeObservable);
$parcel$export(module.exports, "makeAutoObservable", () => makeAutoObservable);
$parcel$export(module.exports, "getDebugName", () => getDebugName);
$parcel$export(module.exports, "runInAction", () => runInAction);
var niceErrors = {
    0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
    1: function _(annotationType, key) {
        return "Cannot apply '" + annotationType + "' to '" + key.toString() + "': Field not found.";
    },
    /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */ 5: "'keys()' can only be used on observable objects, arrays, sets and maps",
    6: "'values()' can only be used on observable objects, arrays, sets and maps",
    7: "'entries()' can only be used on observable objects, arrays and maps",
    8: "'set()' can only be used on observable objects, arrays and maps",
    9: "'remove()' can only be used on observable objects, arrays and maps",
    10: "'has()' can only be used on observable objects, arrays and maps",
    11: "'get()' can only be used on observable objects, arrays and maps",
    12: "Invalid annotation",
    13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    14: "Intercept handlers should return nothing or a change object",
    15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    16: "Modification exception: the internal structure of an observable array was changed.",
    17: function _(index, length) {
        return "[mobx.array] Index out of bounds, " + index + " is larger than " + length;
    },
    18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
    19: function _(other) {
        return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
    },
    20: function _(other) {
        return "Cannot initialize map from " + other;
    },
    21: function _(dataStructure) {
        return "Cannot convert to map from '" + dataStructure + "'";
    },
    22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
    23: "It is not possible to get index atoms from arrays",
    24: function _(thing) {
        return "Cannot obtain administration from " + thing;
    },
    25: function _(property, name) {
        return "the entry '" + property + "' does not exist in the observable map '" + name + "'";
    },
    26: "please specify a property",
    27: function _(property, name) {
        return "no observable property '" + property.toString() + "' found on the observable object '" + name + "'";
    },
    28: function _(thing) {
        return "Cannot obtain atom from " + thing;
    },
    29: "Expecting some object",
    30: "invalid action stack. did you forget to finish an action?",
    31: "missing option for computed: get",
    32: function _(name, derivation) {
        return "Cycle detected in computation " + name + ": " + derivation;
    },
    33: function _(name) {
        return "The setter of computed value '" + name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
    },
    34: function _(name) {
        return "[ComputedValue '" + name + "'] It is not possible to assign a new value to a computed value.";
    },
    35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
    36: "isolateGlobalState should be called before MobX is running any reactions",
    37: function _(method) {
        return "[mobx] `observableArray." + method + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + method + "()` instead";
    },
    38: "'ownKeys()' can only be used on observable objects",
    39: "'defineProperty()' can only be used on observable objects"
};
var errors = {};
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var e;
    throw new Error(typeof error === "number" ? "[MobX] minified error nr: " + error + (args.length ? " " + args.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + error);
}
var mockGlobal = {};
function getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (typeof self !== "undefined") return self;
    return mockGlobal;
}
// We shorten anything used > 5 times
var assign = Object.assign;
var getDescriptor = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var objectPrototype = Object.prototype;
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var hasProxy = typeof Proxy !== "undefined";
var plainObjectString = /*#__PURE__*/ Object.toString();
function assertProxies() {
    if (!hasProxy) die("Proxy not available");
}
function warnAboutProxyRequirement(msg) {}
function getNextId() {
    return ++globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */ function once(func) {
    var invoked = false;
    return function() {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function noop() {};
function isFunction(fn) {
    return typeof fn === "function";
}
function isStringish(value) {
    var t = typeof value;
    switch(t){
        case "string":
        case "symbol":
        case "number":
            return true;
    }
    return false;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (!isObject(value)) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    var protoConstructor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof protoConstructor === "function" && protoConstructor.toString() === plainObjectString;
}
// https://stackoverflow.com/a/37865170
function isGenerator(obj) {
    var constructor = obj == null ? void 0 : obj.constructor;
    if (!constructor) return false;
    if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) return true;
    return false;
}
function addHiddenProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function createInstanceofPredicate(name, theClass) {
    var propName = "isMobX" + name;
    theClass.prototype[propName] = true;
    return function(x) {
        return isObject(x) && x[propName] === true;
    };
}
function isES6Map(thing) {
    return thing instanceof Map;
}
function isES6Set(thing) {
    return thing instanceof Set;
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols !== "undefined";
/**
 * Returns the following: own enumerable keys and symbols.
 */ function getPlainObjectKeys(object) {
    var keys = Object.keys(object);
    // Not supported in IE, so there are not going to be symbol props anyway...
    if (!hasGetOwnPropertySymbols) return keys;
    var symbols = Object.getOwnPropertySymbols(object);
    if (!symbols.length) return keys;
    return [].concat(keys, symbols.filter(function(s) {
        return objectPrototype.propertyIsEnumerable.call(object, s);
    }));
}
// From Immer utils
// Returns all own keys, including non-enumerable and symbolic
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function(obj) {
    return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */ Object.getOwnPropertyNames;
function stringifyKey(key) {
    if (typeof key === "string") return key;
    if (typeof key === "symbol") return key.toString();
    return new String(key).toString();
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
function hasProp(target, prop) {
    return objectPrototype.hasOwnProperty.call(target, prop);
}
// From Immer utils
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(target) {
    // Polyfill needed for Hermes and IE, see https://github.com/facebook/hermes/issues/274
    var res = {};
    // Note: without polyfill for ownKeys, symbols won't be picked up
    ownKeys(target).forEach(function(key) {
        res[key] = getDescriptor(target, key);
    });
    return res;
};
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
var storedAnnotationsSymbol = /*#__PURE__*/ Symbol("mobx-stored-annotations");
/**
 * Creates a function that acts as
 * - decorator
 * - annotation object
 */ function createDecoratorAnnotation(annotation) {
    function decorator(target, property) {
        if (is20223Decorator(property)) return annotation.decorate_20223_(target, property);
        else storeAnnotation(target, property, annotation);
    }
    return Object.assign(decorator, annotation);
}
/**
 * Stores annotation to prototype,
 * so it can be inspected later by `makeObservable` called from constructor
 */ function storeAnnotation(prototype, key, annotation) {
    if (!hasProp(prototype, storedAnnotationsSymbol)) addHiddenProp(prototype, storedAnnotationsSymbol, _extends({}, prototype[storedAnnotationsSymbol]));
    var fieldName;
    // Cannot re-decorate
    assertNotDecorated(prototype, annotation, key);
    // Ignore override
    if (!isOverride(annotation)) prototype[storedAnnotationsSymbol][key] = annotation;
}
function assertNotDecorated(prototype, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
/**
 * Collects annotations from prototypes and stores them on target (instance)
 */ function collectStoredAnnotations(target) {
    if (!hasProp(target, storedAnnotationsSymbol)) // if (__DEV__ && !target[storedAnnotationsSymbol]) {
    //     die(
    //         `No annotations were passed to makeObservable, but no decorated members have been found either`
    //     )
    // }
    // We need a copy as we will remove annotation from the list once it's applied.
    addHiddenProp(target, storedAnnotationsSymbol, _extends({}, target[storedAnnotationsSymbol]));
    return target[storedAnnotationsSymbol];
}
function is20223Decorator(context) {
    return typeof context == "object" && typeof context["kind"] == "string";
}
function assert20223DecoratorType(context, types) {}
var $mobx = /*#__PURE__*/ Symbol("mobx administration");
var Atom = /*#__PURE__*/ function() {
    // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
    /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */ function Atom(name_) {
        if (name_ === void 0) name_ = "Atom";
        this.name_ = void 0;
        this.isPendingUnobservation_ = false;
        this.isBeingObserved_ = false;
        this.observers_ = new Set();
        this.diffValue_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        this.name_ = name_;
    }
    // onBecomeObservedListeners
    var _proto = Atom.prototype;
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    } /**
   * Invoke this method to notify mobx that your atom has been used somehow.
   * Returns true if there is currently a reactive context.
   */ ;
    _proto.reportObserved = function reportObserved$1() {
        return reportObserved(this);
    } /**
   * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
   */ ;
    _proto.reportChanged = function reportChanged() {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    _proto.toString = function toString() {
        return this.name_;
    };
    return Atom;
}();
var isAtom = /*#__PURE__*/ createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) onBecomeObservedHandler = noop;
    if (onBecomeUnobservedHandler === void 0) onBecomeUnobservedHandler = noop;
    var atom = new Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== noop) onBecomeObserved(atom, onBecomeObservedHandler);
    if (onBecomeUnobservedHandler !== noop) onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    return atom;
}
function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    if (Object.is) return Object.is(a, b);
    return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    "default": defaultComparer,
    shallow: shallowComparer
};
function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v)) return v;
    // something that can be converted and mutated?
    if (Array.isArray(v)) return observable.array(v, {
        name: name
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name
    });
    if (typeof v === "function" && !isAction(v) && !isFlow(v)) {
        if (isGenerator(v)) return flow(v);
        else return autoAction(name, v);
    }
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) return v;
    if (Array.isArray(v)) return observable.array(v, {
        name: name,
        deep: false
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name,
        deep: false
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name,
        deep: false
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name,
        deep: false
    });
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue) {
    if (deepEqual(v, oldValue)) return oldValue;
    return v;
}
var OVERRIDE = "override";
var override = /*#__PURE__*/ createDecoratorAnnotation({
    annotationType_: OVERRIDE,
    make_: make_,
    extend_: extend_,
    decorate_20223_: decorate_20223_
});
function isOverride(annotation) {
    return annotation.annotationType_ === OVERRIDE;
}
function make_(adm, key) {
    return 0 /* MakeResult.Cancel */ ;
}
function extend_(adm, key, descriptor, proxyTrap) {
    die("'" + this.annotationType_ + "' can only be used with 'makeObservable'");
}
function decorate_20223_(desc, context) {
    console.warn("'" + this.annotationType_ + "' cannot be used with decorators - this is a no-op");
}
function createActionAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$1,
        extend_: extend_$1,
        decorate_20223_: decorate_20223_$1
    };
}
function make_$1(adm, key, descriptor, source) {
    var _this$options_;
    // bound
    if ((_this$options_ = this.options_) != null && _this$options_.bound) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    if (isAction(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor, false);
    defineProperty(source, key, actionDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$1(adm, key, descriptor, proxyTrap) {
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function decorate_20223_$1(mthd, context) {
    var kind = context.kind, name = context.name, addInitializer = context.addInitializer;
    var ann = this;
    var _createAction = function _createAction(m) {
        var _ann$options_$name, _ann$options_, _ann$options_$autoAct, _ann$options_2;
        return createAction((_ann$options_$name = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.name) != null ? _ann$options_$name : name.toString(), m, (_ann$options_$autoAct = (_ann$options_2 = ann.options_) == null ? void 0 : _ann$options_2.autoAction) != null ? _ann$options_$autoAct : false);
    };
    // Backwards/Legacy behavior, expects makeObservable(this)
    if (kind == "field") {
        addInitializer(function() {
            storeAnnotation(this, name, ann);
        });
        return;
    }
    if (kind == "method") {
        var _this$options_2;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_this$options_2 = this.options_) != null && _this$options_2.bound) addInitializer(function() {
            var self1 = this;
            var bound = self1[name].bind(self1);
            bound.isMobxAction = true;
            self1[name] = bound;
        });
        return mthd;
    }
    die("Cannot apply '" + ann.annotationType_ + "' to '" + String(name) + "' (kind: " + kind + "):" + ("\n'" + ann.annotationType_ + "' can only be used on properties with a function value."));
}
function assertActionDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createActionDescriptor(adm, annotation, key, descriptor, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3, _annotation$options_4, _adm$proxy_2;
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertActionDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) {
        var _adm$proxy_;
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return {
        value: createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false, // https://github.com/mobxjs/mobx/discussions/3140
        (_annotation$options_4 = annotation.options_) != null && _annotation$options_4.bound ? (_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_ : undefined),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createFlowAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$2,
        extend_: extend_$2,
        decorate_20223_: decorate_20223_$2
    };
}
function make_$2(adm, key, descriptor, source) {
    var _this$options_;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    // bound - must annotate protos to support super.flow()
    if ((_this$options_ = this.options_) != null && _this$options_.bound && (!hasProp(adm.target_, key) || !isFlow(adm.target_[key]))) {
        if (this.extend_(adm, key, descriptor, false) === null) return 0 /* MakeResult.Cancel */ ;
    }
    if (isFlow(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, false, false);
    defineProperty(source, key, flowDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$2(adm, key, descriptor, proxyTrap) {
    var _this$options_2;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.bound);
    return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function decorate_20223_$2(mthd, context) {
    var _this$options_3;
    var name = context.name, addInitializer = context.addInitializer;
    if (!isFlow(mthd)) mthd = flow(mthd);
    if ((_this$options_3 = this.options_) != null && _this$options_3.bound) addInitializer(function() {
        var self1 = this;
        var bound = self1[name].bind(self1);
        bound.isMobXFlow = true;
        self1[name] = bound;
    });
    return mthd;
}
function assertFlowDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createFlowDescriptor(adm, annotation, key, descriptor, bound, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertFlowDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    // In case of flow.bound, the descriptor can be from already annotated prototype
    if (!isFlow(value)) value = flow(value);
    if (bound) {
        var _adm$proxy_;
        // We do not keep original function around, so we bind the existing flow
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
        // This is normally set by `flow`, but `bind` returns new function...
        value.isMobXFlow = true;
    }
    return {
        value: value,
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createComputedAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$3,
        extend_: extend_$3,
        decorate_20223_: decorate_20223_$3
    };
}
function make_$3(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$3(adm, key, descriptor, proxyTrap) {
    assertComputedDescriptor(adm, this, key, descriptor);
    return adm.defineComputedProperty_(key, _extends({}, this.options_, {
        get: descriptor.get,
        set: descriptor.set
    }), proxyTrap);
}
function decorate_20223_$3(get, context) {
    var ann = this;
    var key = context.name, addInitializer = context.addInitializer;
    addInitializer(function() {
        var adm = asObservableObject(this)[$mobx];
        var options = _extends({}, ann.options_, {
            get: get,
            context: this
        });
        options.name || (options.name = "ObservableObject." + key.toString());
        adm.values_.set(key, new ComputedValue(options));
    });
    return function() {
        return this[$mobx].getObservablePropValue_(key);
    };
}
function assertComputedDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var get = _ref2.get;
}
function createObservableAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$4,
        extend_: extend_$4,
        decorate_20223_: decorate_20223_$4
    };
}
function make_$4(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$4(adm, key, descriptor, proxyTrap) {
    var _this$options_$enhanc, _this$options_;
    assertObservableDescriptor(adm, this, key, descriptor);
    return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer) != null ? _this$options_$enhanc : deepEnhancer, proxyTrap);
}
function decorate_20223_$4(desc, context) {
    var ann = this;
    var kind = context.kind, name = context.name;
    // The laziness here is not ideal... It's a workaround to how 2022.3 Decorators are implemented:
    //   `addInitializer` callbacks are executed _before_ any accessors are defined (instead of the ideal-for-us right after each).
    //   This means that, if we were to do our stuff in an `addInitializer`, we'd attempt to read a private slot
    //   before it has been initialized. The runtime doesn't like that and throws a `Cannot read private member
    //   from an object whose class did not declare it` error.
    // TODO: it seems that this will not be required anymore in the final version of the spec
    // See TODO: link
    var initializedObjects = new WeakSet();
    function initializeObservable(target, value) {
        var _ann$options_$enhance, _ann$options_;
        var adm = asObservableObject(target)[$mobx];
        var observable = new ObservableValue(value, (_ann$options_$enhance = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.enhancer) != null ? _ann$options_$enhance : deepEnhancer, "ObservableObject." + name.toString(), false);
        adm.values_.set(name, observable);
        initializedObjects.add(target);
    }
    if (kind == "accessor") return {
        get: function get() {
            if (!initializedObjects.has(this)) initializeObservable(this, desc.get.call(this));
            return this[$mobx].getObservablePropValue_(name);
        },
        set: function set(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return this[$mobx].setObservablePropValue_(name, value);
        },
        init: function init(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return value;
        }
    };
    return;
}
function assertObservableDescriptor(adm, _ref, key, descriptor) {
    var annotationType_ = _ref.annotationType_;
}
var AUTO = "true";
var autoAnnotation = /*#__PURE__*/ createAutoAnnotation();
function createAutoAnnotation(options) {
    return {
        annotationType_: AUTO,
        options_: options,
        make_: make_$5,
        extend_: extend_$5,
        decorate_20223_: decorate_20223_$5
    };
}
function make_$5(adm, key, descriptor, source) {
    var _this$options_3, _this$options_4;
    // getter -> computed
    if (descriptor.get) return computed.make_(adm, key, descriptor, source);
    // lone setter -> action setter
    if (descriptor.set) {
        // TODO make action applicable to setter and delegate to action.make_
        var set = createAction(key.toString(), descriptor.set);
        // own
        if (source === adm.target_) return adm.defineProperty_(key, {
            configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
            set: set
        }) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
        // proto
        defineProperty(source, key, {
            configurable: true,
            set: set
        });
        return 2 /* MakeResult.Continue */ ;
    }
    // function on proto -> autoAction/flow
    if (source !== adm.target_ && typeof descriptor.value === "function") {
        var _this$options_2;
        if (isGenerator(descriptor.value)) {
            var _this$options_;
            var flowAnnotation = (_this$options_ = this.options_) != null && _this$options_.autoBind ? flow.bound : flow;
            return flowAnnotation.make_(adm, key, descriptor, source);
        }
        var actionAnnotation = (_this$options_2 = this.options_) != null && _this$options_2.autoBind ? autoAction.bound : autoAction;
        return actionAnnotation.make_(adm, key, descriptor, source);
    }
    // other -> observable
    // Copy props from proto as well, see test:
    // "decorate should work with Object.create"
    var observableAnnotation = ((_this$options_3 = this.options_) == null ? void 0 : _this$options_3.deep) === false ? observable.ref : observable;
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_4 = this.options_) != null && _this$options_4.autoBind) {
        var _adm$proxy_;
        descriptor.value = descriptor.value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return observableAnnotation.make_(adm, key, descriptor, source);
}
function extend_$5(adm, key, descriptor, proxyTrap) {
    var _this$options_5, _this$options_6;
    // getter -> computed
    if (descriptor.get) return computed.extend_(adm, key, descriptor, proxyTrap);
    // lone setter -> action setter
    if (descriptor.set) // TODO make action applicable to setter and delegate to action.extend_
    return adm.defineProperty_(key, {
        configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
        set: createAction(key.toString(), descriptor.set)
    }, proxyTrap);
    // other -> observable
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_5 = this.options_) != null && _this$options_5.autoBind) {
        var _adm$proxy_2;
        descriptor.value = descriptor.value.bind((_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_);
    }
    var observableAnnotation = ((_this$options_6 = this.options_) == null ? void 0 : _this$options_6.deep) === false ? observable.ref : observable;
    return observableAnnotation.extend_(adm, key, descriptor, proxyTrap);
}
function decorate_20223_$5(desc, context) {
    die("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var OBSERVABLE = "observable";
var OBSERVABLE_REF = "observable.ref";
var OBSERVABLE_SHALLOW = "observable.shallow";
var OBSERVABLE_STRUCT = "observable.struct";
// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(thing) {
    return thing || defaultCreateObservableOptions;
}
var observableAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE);
var observableRefAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_REF, {
    enhancer: referenceEnhancer
});
var observableShallowAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_SHALLOW, {
    enhancer: shallowEnhancer
});
var observableStructAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_STRUCT, {
    enhancer: refStructEnhancer
});
var observableDecoratorAnnotation = /*#__PURE__*/ createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(options) {
    return options.deep === true ? deepEnhancer : options.deep === false ? referenceEnhancer : getEnhancerFromAnnotation(options.defaultDecorator);
}
function getAnnotationFromOptions(options) {
    var _options$defaultDecor;
    return options ? (_options$defaultDecor = options.defaultDecorator) != null ? _options$defaultDecor : createAutoAnnotation(options) : undefined;
}
function getEnhancerFromAnnotation(annotation) {
    var _annotation$options_$, _annotation$options_;
    return !annotation ? deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer) != null ? _annotation$options_$ : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */ function createObservable(v, arg2, arg3) {
    // @observable someProp; (2022.3 Decorators)
    if (is20223Decorator(arg2)) return observableAnnotation.decorate_20223_(v, arg2);
    // @observable someProp;
    if (isStringish(arg2)) {
        storeAnnotation(v, arg2, observableAnnotation);
        return;
    }
    // already observable - ignore
    if (isObservable(v)) return v;
    // plain object
    if (isPlainObject(v)) return observable.object(v, arg2, arg3);
    // Array
    if (Array.isArray(v)) return observable.array(v, arg2);
    // Map
    if (isES6Map(v)) return observable.map(v, arg2);
    // Set
    if (isES6Set(v)) return observable.set(v, arg2);
    // other object - ignore
    if (typeof v === "object" && v !== null) return v;
    // anything else
    return observable.box(v, arg2);
}
assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
    box: function box(value, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function array(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return (globalState.useProxies === false || o.proxy === false ? createLegacyArray : createObservableArray)(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function map(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    set: function set(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function object(props, decorators, options) {
        return initObservable(function() {
            return extendObservable(globalState.useProxies === false || (options == null ? void 0 : options.proxy) === false ? asObservableObject({}, options) : asDynamicObservableObject({}, options), props, decorators);
        });
    },
    ref: /*#__PURE__*/ createDecoratorAnnotation(observableRefAnnotation),
    shallow: /*#__PURE__*/ createDecoratorAnnotation(observableShallowAnnotation),
    deep: observableDecoratorAnnotation,
    struct: /*#__PURE__*/ createDecoratorAnnotation(observableStructAnnotation)
};
// eslint-disable-next-line
var observable = /*#__PURE__*/ assign(createObservable, observableFactories);
var COMPUTED = "computed";
var COMPUTED_STRUCT = "computed.struct";
var computedAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED);
var computedStructAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED_STRUCT, {
    equals: comparer.structural
});
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */ var computed = function computed(arg1, arg2) {
    if (is20223Decorator(arg2)) // @computed (2022.3 Decorators)
    return computedAnnotation.decorate_20223_(arg1, arg2);
    if (isStringish(arg2)) // @computed
    return storeAnnotation(arg1, arg2, computedAnnotation);
    if (isPlainObject(arg1)) // @computed({ options })
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, arg1));
    var opts = isPlainObject(arg2) ? arg2 : {};
    opts.get = arg1;
    opts.name || (opts.name = arg1.name || ""); /* for generated name */ 
    return new ComputedValue(opts);
};
Object.assign(computed, computedAnnotation);
computed.struct = /*#__PURE__*/ createDecoratorAnnotation(computedStructAnnotation);
var _getDescriptor$config, _getDescriptor;
// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /*#__PURE__*/ getDescriptor(function() {}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : false;
// we can safely recycle this object
var tmpNameDescriptor = {
    value: "action",
    configurable: true,
    writable: false,
    enumerable: false
};
function createAction(actionName, fn, autoAction, ref) {
    if (autoAction === void 0) autoAction = false;
    function res() {
        return executeAction(actionName, autoAction, fn, ref || this, arguments);
    }
    res.isMobxAction = true;
    res.toString = function() {
        return fn.toString();
    };
    if (isFunctionNameConfigurable) {
        tmpNameDescriptor.value = actionName;
        defineProperty(res, "name", tmpNameDescriptor);
    }
    return res;
}
function executeAction(actionName, canRunAsDerivation, fn, scope, args) {
    var runInfo = _startAction(actionName, canRunAsDerivation, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error_ = err;
        throw err;
    } finally{
        _endAction(runInfo);
    }
}
function _startAction(actionName, canRunAsDerivation, // true for autoAction
scope, args) {
    var notifySpy_ = false;
    var startTime_ = 0;
    var flattenedArgs;
    var prevDerivation_ = globalState.trackingDerivation;
    var runAsAction = !canRunAsDerivation || !prevDerivation_;
    startBatch();
    var prevAllowStateChanges_ = globalState.allowStateChanges; // by default preserve previous allow
    if (runAsAction) {
        untrackedStart();
        prevAllowStateChanges_ = allowStateChangesStart(true);
    }
    var prevAllowStateReads_ = allowStateReadsStart(true);
    var runInfo = {
        runAsAction_: runAsAction,
        prevDerivation_: prevDerivation_,
        prevAllowStateChanges_: prevAllowStateChanges_,
        prevAllowStateReads_: prevAllowStateReads_,
        notifySpy_: notifySpy_,
        startTime_: startTime_,
        actionId_: nextActionId++,
        parentActionId_: currentActionId
    };
    currentActionId = runInfo.actionId_;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId_) die(30);
    currentActionId = runInfo.parentActionId_;
    if (runInfo.error_ !== undefined) globalState.suppressReactionErrors = true;
    allowStateChangesEnd(runInfo.prevAllowStateChanges_);
    allowStateReadsEnd(runInfo.prevAllowStateReads_);
    endBatch();
    if (runInfo.runAsAction_) untrackedEnd(runInfo.prevDerivation_);
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    try {
        return func();
    } finally{
        allowStateChangesEnd(prev);
    }
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
var _Symbol$toPrimitive;
var CREATE = "create";
_Symbol$toPrimitive = Symbol.toPrimitive;
var ObservableValue = /*#__PURE__*/ function(_Atom) {
    _inheritsLoose(ObservableValue, _Atom);
    function ObservableValue(value, enhancer, name_, notifySpy, equals) {
        var _this;
        if (name_ === void 0) name_ = "ObservableValue";
        if (notifySpy === void 0) notifySpy = true;
        if (equals === void 0) equals = comparer["default"];
        _this = _Atom.call(this, name_) || this;
        _this.enhancer = void 0;
        _this.name_ = void 0;
        _this.equals = void 0;
        _this.hasUnreportedChange_ = false;
        _this.interceptors_ = void 0;
        _this.changeListeners_ = void 0;
        _this.value_ = void 0;
        _this.dehancer = void 0;
        _this.enhancer = enhancer;
        _this.name_ = name_;
        _this.equals = equals;
        _this.value_ = enhancer(value, undefined, name_);
        return _this;
    }
    var _proto = ObservableValue.prototype;
    _proto.dehanceValue = function dehanceValue(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.set = function set(newValue) {
        var oldValue = this.value_;
        newValue = this.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            this.setNewValue_(newValue);
        }
    };
    _proto.prepareNewValue_ = function prepareNewValue_(newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: UPDATE,
                newValue: newValue
            });
            if (!change) return globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value_, this.name_);
        return this.equals(this.value_, newValue) ? globalState.UNCHANGED : newValue;
    };
    _proto.setNewValue_ = function setNewValue_(newValue) {
        var oldValue = this.value_;
        this.value_ = newValue;
        this.reportChanged();
        if (hasListeners(this)) notifyListeners(this, {
            type: UPDATE,
            object: this,
            newValue: newValue,
            oldValue: oldValue
        });
    };
    _proto.get = function get() {
        this.reportObserved();
        return this.dehanceValue(this.value_);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately) listener({
            observableKind: "value",
            debugObjectName: this.name_,
            object: this,
            type: UPDATE,
            newValue: this.value_,
            oldValue: undefined
        });
        return registerListener(this, listener);
    };
    _proto.raw = function raw() {
        // used by MST ot get undehanced value
        return this.value_;
    };
    _proto.toJSON = function toJSON() {
        return this.get();
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.value_ + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[_Symbol$toPrimitive] = function() {
        return this.valueOf();
    };
    return ObservableValue;
}(Atom);
var isObservableValue = /*#__PURE__*/ createInstanceofPredicate("ObservableValue", ObservableValue);
var _Symbol$toPrimitive$1;
/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */ _Symbol$toPrimitive$1 = Symbol.toPrimitive;
var ComputedValue = /*#__PURE__*/ function() {
    // nodes we are looking at. Our value depends on these nodes
    // during tracking it's an array with new observed observers
    // to check for cycles
    // N.B: unminified as it is used by MST
    /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function to use to determine if a newly produced
   * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
   * compares based on identity comparison (===), and `structuralComparer` deeply compares the structure.
   * Structural comparison can be convenient if you always produce a new aggregated object and
   * don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */ function ComputedValue(options) {
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.observing_ = [];
        this.newObserving_ = null;
        this.isBeingObserved_ = false;
        this.isPendingUnobservation_ = false;
        this.observers_ = new Set();
        this.diffValue_ = 0;
        this.runId_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
        this.unboundDepsCount_ = 0;
        this.value_ = new CaughtException(null);
        this.name_ = void 0;
        this.triggeredBy_ = void 0;
        this.isComputing_ = false;
        this.isRunningSetter_ = false;
        this.derivation = void 0;
        this.setter_ = void 0;
        this.isTracing_ = TraceMode.NONE;
        this.scope_ = void 0;
        this.equals_ = void 0;
        this.requiresReaction_ = void 0;
        this.keepAlive_ = void 0;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        if (!options.get) die(31);
        this.derivation = options.get;
        this.name_ = options.name || "ComputedValue";
        if (options.set) this.setter_ = createAction("ComputedValue-setter", options.set);
        this.equals_ = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer["default"]);
        this.scope_ = options.context;
        this.requiresReaction_ = options.requiresReaction;
        this.keepAlive_ = !!options.keepAlive;
    }
    var _proto = ComputedValue.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        propagateMaybeChanged(this);
    };
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    } /**
   * Returns the current value of this computed value.
   * Will evaluate its computation first if needed.
   */ ;
    _proto.get = function get() {
        if (this.isComputing_) die(32, this.name_, this.derivation);
        if (globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
        this.observers_.size === 0 && !this.keepAlive_) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead_();
                startBatch(); // See perf test 'computed memoization'
                this.value_ = this.computeValue_(false);
                endBatch();
            }
        } else {
            reportObserved(this);
            if (shouldCompute(this)) {
                var prevTrackingContext = globalState.trackingContext;
                if (this.keepAlive_ && !prevTrackingContext) globalState.trackingContext = this;
                if (this.trackAndCompute()) propagateChangeConfirmed(this);
                globalState.trackingContext = prevTrackingContext;
            }
        }
        var result = this.value_;
        if (isCaughtException(result)) throw result.cause;
        return result;
    };
    _proto.set = function set(value) {
        if (this.setter_) {
            if (this.isRunningSetter_) die(33, this.name_);
            this.isRunningSetter_ = true;
            try {
                this.setter_.call(this.scope_, value);
            } finally{
                this.isRunningSetter_ = false;
            }
        } else die(34, this.name_);
    };
    _proto.trackAndCompute = function trackAndCompute() {
        // N.B: unminified as it is used by MST
        var oldValue = this.value_;
        var wasSuspended = /* see #1208 */ this.dependenciesState_ === IDerivationState_.NOT_TRACKING_;
        var newValue = this.computeValue_(true);
        var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals_(oldValue, newValue);
        if (changed) this.value_ = newValue;
        return changed;
    };
    _proto.computeValue_ = function computeValue_(track) {
        this.isComputing_ = true;
        // don't allow state changes during computation
        var prev = allowStateChangesStart(false);
        var res;
        if (track) res = trackDerivedFunction(this, this.derivation, this.scope_);
        else {
            if (globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope_);
            else try {
                res = this.derivation.call(this.scope_);
            } catch (e) {
                res = new CaughtException(e);
            }
        }
        allowStateChangesEnd(prev);
        this.isComputing_ = false;
        return res;
    };
    _proto.suspend_ = function suspend_() {
        if (!this.keepAlive_) {
            clearObserving(this);
            this.value_ = undefined; // don't hold on to computed value!
        }
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function() {
            // TODO: why is this in a different place than the spyReport() function? in all other observables it's called in the same place
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    observableKind: "computed",
                    debugObjectName: _this.name_,
                    type: UPDATE,
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    _proto.warnAboutUntrackedRead_ = function warnAboutUntrackedRead_() {
        return;
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.derivation.toString() + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[_Symbol$toPrimitive$1] = function() {
        return this.valueOf();
    };
    return ComputedValue;
}();
var isComputedValue = /*#__PURE__*/ createInstanceofPredicate("ComputedValue", ComputedValue);
var IDerivationState_;
(function(IDerivationState_) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState_[IDerivationState_["NOT_TRACKING_"] = -1] = "NOT_TRACKING_";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState_[IDerivationState_["UP_TO_DATE_"] = 0] = "UP_TO_DATE_";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState_[IDerivationState_["POSSIBLY_STALE_"] = 1] = "POSSIBLY_STALE_";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState_[IDerivationState_["STALE_"] = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function(TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function CaughtException(cause) {
    this.cause = void 0;
    this.cause = cause;
// Empty
};
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */ function shouldCompute(derivation) {
    switch(derivation.dependenciesState_){
        case IDerivationState_.UP_TO_DATE_:
            return false;
        case IDerivationState_.NOT_TRACKING_:
        case IDerivationState_.STALE_:
            return true;
        case IDerivationState_.POSSIBLY_STALE_:
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = allowStateReadsStart(true);
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing_, l = obs.length;
            for(var i = 0; i < l; i++){
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) obj.get();
                    else try {
                        obj.get();
                    } catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState_ === IDerivationState_.STALE_) {
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return false;
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers;
    return;
}
function checkIfStateReadsAreAllowed(observable) {}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */ function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true);
    // pre allocate array allocation + room for variation in deps
    // array will be trimmed by bindDependencies
    changeDependenciesStateTo0(derivation);
    derivation.newObserving_ = new Array(derivation.observing_.length + 100);
    derivation.unboundDepsCount_ = 0;
    derivation.runId_ = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    globalState.inBatch++;
    var result;
    if (globalState.disableErrorBoundaries === true) result = f.call(context);
    else try {
        result = f.call(context);
    } catch (e) {
        result = new CaughtException(e);
    }
    globalState.inBatch--;
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    return;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */ function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing_;
    var observing = derivation.observing_ = derivation.newObserving_;
    var lowestNewObservingDerivationState = IDerivationState_.UP_TO_DATE_;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount_;
    for(var i = 0; i < l; i++){
        var dep = observing[i];
        if (dep.diffValue_ === 0) {
            dep.diffValue_ = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState_ > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState_;
    }
    observing.length = i0;
    derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while(l--){
        var _dep = prevObserving[l];
        if (_dep.diffValue_ === 0) removeObserver(_dep, derivation);
        _dep.diffValue_ = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while(i0--){
        var _dep2 = observing[i0];
        if (_dep2.diffValue_ === 1) {
            _dep2.diffValue_ = 0;
            addObserver(_dep2, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState_.UP_TO_DATE_) {
        derivation.dependenciesState_ = lowestNewObservingDerivationState;
        derivation.onBecomeStale_();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing_;
    derivation.observing_ = [];
    var i = obs.length;
    while(i--)removeObserver(obs[i], derivation);
    derivation.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(action) {
    var prev = untrackedStart();
    try {
        return action();
    } finally{
        untrackedEnd(prev);
    }
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */ function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState_ === IDerivationState_.UP_TO_DATE_) return;
    derivation.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
    var obs = derivation.observing_;
    var i = obs.length;
    while(i--)obs[i].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
}
/**
 * These values will persist if global state is reset
 */ var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED",
    "useProxies"
];
var MobXGlobals = function MobXGlobals() {
    this.version = 6;
    this.UNCHANGED = {};
    this.trackingDerivation = null;
    this.trackingContext = null;
    this.runId = 0;
    this.mobxGuid = 0;
    this.inBatch = 0;
    this.pendingUnobservations = [];
    this.pendingReactions = [];
    this.isRunningReactions = false;
    this.allowStateChanges = false;
    this.allowStateReads = true;
    this.enforceActions = true;
    this.spyListeners = [];
    this.globalReactionErrorHandlers = [];
    this.computedRequiresReaction = false;
    this.reactionRequiresObservable = false;
    this.observableRequiresReaction = false;
    this.disableErrorBoundaries = false;
    this.suppressReactionErrors = false;
    this.useProxies = true;
    this.verifyProxies = false;
    this.safeDescriptors = true;
};
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = /*#__PURE__*/ function() {
    var global1 = /*#__PURE__*/ getGlobal();
    if (global1.__mobxInstanceCount > 0 && !global1.__mobxGlobals) canMergeGlobalState = false;
    if (global1.__mobxGlobals && global1.__mobxGlobals.version !== new MobXGlobals().version) canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        // Because this is a IIFE we need to let isolateCalled a chance to change
        // so we run it after the event loop completed at least 1 iteration
        setTimeout(function() {
            if (!isolateCalled) die(35);
        }, 1);
        return new MobXGlobals();
    } else if (global1.__mobxGlobals) {
        global1.__mobxInstanceCount += 1;
        if (!global1.__mobxGlobals.UNCHANGED) global1.__mobxGlobals.UNCHANGED = {};
         // make merge backward compatible
        return global1.__mobxGlobals;
    } else {
        global1.__mobxInstanceCount = 1;
        return global1.__mobxGlobals = /*#__PURE__*/ new MobXGlobals();
    }
}();
function isolateGlobalState() {
    if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) die(36);
    isolateCalled = true;
    if (canMergeGlobalState) {
        var global1 = getGlobal();
        if (--global1.__mobxInstanceCount === 0) global1.__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */ function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for(var key in defaultGlobals)if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}
function hasObservers(observable) {
    return observable.observers_ && observable.observers_.size > 0;
}
function getObservers(observable) {
    return observable.observers_;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers_.add(node);
    if (observable.lowestObserverState_ > node.dependenciesState_) observable.lowestObserverState_ = node.dependenciesState_;
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers_["delete"](node);
    if (observable.observers_.size === 0) // deleting last observer
    queueForUnobservation(observable);
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation_ === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation_ = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */ function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for(var i = 0; i < list.length; i++){
            var observable = list[i];
            observable.isPendingUnobservation_ = false;
            if (observable.observers_.size === 0) {
                if (observable.isBeingObserved_) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved_ = false;
                    observable.onBUO();
                }
                if (observable instanceof ComputedValue) // computed values are automatically teared down when the last observer leaves
                // this process happens recursively, this computed might be the last observabe of another, etc..
                observable.suspend_();
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */ if (derivation.runId_ !== observable.lastAccessedBy_) {
            observable.lastAccessedBy_ = derivation.runId_;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
            if (!observable.isBeingObserved_ && globalState.trackingContext) {
                observable.isBeingObserved_ = true;
                observable.onBO();
            }
        }
        return observable.isBeingObserved_;
    } else if (observable.observers_.size === 0 && globalState.inBatch > 0) queueForUnobservation(observable);
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */ // Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) d.onBecomeStale_();
        d.dependenciesState_ = IDerivationState_.STALE_;
    });
// invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_) d.dependenciesState_ = IDerivationState_.STALE_;
        else if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_ // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    });
// invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState_ !== IDerivationState_.UP_TO_DATE_) return;
    observable.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
            d.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_;
            d.onBecomeStale_();
        }
    });
// invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name_ + "' is invalidated due to a change in: '" + observable.name_ + "'");
    if (derivation.isTracing_ === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name_ + "'\n\nYou are entering this break point because derivation '" + derivation.name_ + "' is being traced and '" + observable.name_ + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + "	".repeat(depth - 1) + tree.name);
    if (tree.dependencies) tree.dependencies.forEach(function(child) {
        return printDepTree(child, lines, depth + 1);
    });
}
var Reaction = /*#__PURE__*/ function() {
    // nodes we are looking at. Our value depends on these nodes
    function Reaction(name_, onInvalidate_, errorHandler_, requiresObservable_) {
        if (name_ === void 0) name_ = "Reaction";
        this.name_ = void 0;
        this.onInvalidate_ = void 0;
        this.errorHandler_ = void 0;
        this.requiresObservable_ = void 0;
        this.observing_ = [];
        this.newObserving_ = [];
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.diffValue_ = 0;
        this.runId_ = 0;
        this.unboundDepsCount_ = 0;
        this.isDisposed_ = false;
        this.isScheduled_ = false;
        this.isTrackPending_ = false;
        this.isRunning_ = false;
        this.isTracing_ = TraceMode.NONE;
        this.name_ = name_;
        this.onInvalidate_ = onInvalidate_;
        this.errorHandler_ = errorHandler_;
        this.requiresObservable_ = requiresObservable_;
    }
    var _proto = Reaction.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        this.schedule_();
    };
    _proto.schedule_ = function schedule_() {
        if (!this.isScheduled_) {
            this.isScheduled_ = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    _proto.isScheduled = function isScheduled() {
        return this.isScheduled_;
    } /**
   * internal, use schedule() if you intend to kick off a reaction
   */ ;
    _proto.runReaction_ = function runReaction_() {
        if (!this.isDisposed_) {
            startBatch();
            this.isScheduled_ = false;
            var prev = globalState.trackingContext;
            globalState.trackingContext = this;
            if (shouldCompute(this)) {
                this.isTrackPending_ = true;
                try {
                    this.onInvalidate_();
                } catch (e) {
                    this.reportExceptionInDerivation_(e);
                }
            }
            globalState.trackingContext = prev;
            endBatch();
        }
    };
    _proto.track = function track(fn) {
        if (this.isDisposed_) return;
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        this.isRunning_ = true;
        var prevReaction = globalState.trackingContext; // reactions could create reactions...
        globalState.trackingContext = this;
        var result = trackDerivedFunction(this, fn, undefined);
        globalState.trackingContext = prevReaction;
        this.isRunning_ = false;
        this.isTrackPending_ = false;
        if (this.isDisposed_) // disposed during last run. Clean up everything that was bound after the dispose call.
        clearObserving(this);
        if (isCaughtException(result)) this.reportExceptionInDerivation_(result.cause);
        endBatch();
    };
    _proto.reportExceptionInDerivation_ = function reportExceptionInDerivation_(error) {
        var _this = this;
        if (this.errorHandler_) {
            this.errorHandler_(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries) throw error;
        var message = "[mobx] uncaught error in '" + this + "'";
        if (!globalState.suppressReactionErrors) console.error(message, error);
         // prettier-ignore
        globalState.globalReactionErrorHandlers.forEach(function(f) {
            return f(error, _this);
        });
    };
    _proto.dispose = function dispose() {
        if (!this.isDisposed_) {
            this.isDisposed_ = true;
            if (!this.isRunning_) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    _proto.getDisposer_ = function getDisposer_(abortSignal) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2.dispose();
            abortSignal == null || abortSignal.removeEventListener == null || abortSignal.removeEventListener("abort", dispose);
        };
        abortSignal == null || abortSignal.addEventListener == null || abortSignal.addEventListener("abort", dispose);
        dispose[$mobx] = this;
        return dispose;
    };
    _proto.toString = function toString() {
        return "Reaction[" + this.name_ + "]";
    };
    _proto.trace = function trace$1(enterBreakPoint) {
        if (enterBreakPoint === void 0) enterBreakPoint = false;
        trace(this, enterBreakPoint);
    };
    return Reaction;
}();
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function() {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */ var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function reactionScheduler(f) {
    return f();
};
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while(allReactions.length > 0){
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("[mobx] cycle in reaction: " + allReactions[0]);
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for(var i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction_();
    }
    globalState.isRunningReactions = false;
}
var isReaction = /*#__PURE__*/ createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function reactionScheduler(f) {
        return fn(function() {
            return baseScheduler(f);
        });
    };
}
function isSpyEnabled() {
    return false;
}
function spyReport(event) {
    var listeners, i, l;
    return;
}
function spyReportStart(event) {
    var change;
    return;
}
var END_EVENT = {
    type: "report-end",
    spyReportEnd: true
};
function spyReportEnd(change) {
    return;
}
function spy(listener) {
    console.warn("[mobx.spy] Is a no-op in production builds");
    return function() {};
}
var ACTION = "action";
var ACTION_BOUND = "action.bound";
var AUTOACTION = "autoAction";
var AUTOACTION_BOUND = "autoAction.bound";
var DEFAULT_ACTION_NAME = "<unnamed action>";
var actionAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION);
var actionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION_BOUND, {
    bound: true
});
var autoActionAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION, {
    autoAction: true
});
var autoActionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION_BOUND, {
    autoAction: true,
    bound: true
});
function createActionFactory(autoAction) {
    var res = function action(arg1, arg2) {
        // action(fn() {})
        if (isFunction(arg1)) return createAction(arg1.name || DEFAULT_ACTION_NAME, arg1, autoAction);
        // action("name", fn() {})
        if (isFunction(arg2)) return createAction(arg1, arg2, autoAction);
        // @action (2022.3 Decorators)
        if (is20223Decorator(arg2)) return (autoAction ? autoActionAnnotation : actionAnnotation).decorate_20223_(arg1, arg2);
        // @action
        if (isStringish(arg2)) return storeAnnotation(arg1, arg2, autoAction ? autoActionAnnotation : actionAnnotation);
        // action("name") & @action("name")
        if (isStringish(arg1)) return createDecoratorAnnotation(createActionAnnotation(autoAction ? AUTOACTION : ACTION, {
            name: arg1,
            autoAction: autoAction
        }));
    };
    return res;
}
var action = /*#__PURE__*/ createActionFactory(false);
Object.assign(action, actionAnnotation);
var autoAction = /*#__PURE__*/ createActionFactory(true);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /*#__PURE__*/ createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /*#__PURE__*/ createDecoratorAnnotation(autoActionBoundAnnotation);
function runInAction(fn) {
    return executeAction(fn.name || DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function isAction(thing) {
    return isFunction(thing) && thing.isMobxAction === true;
}
/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */ function autorun(view, opts) {
    var _opts$name, _opts, _opts2, _opts2$signal, _opts3;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name = (_opts = opts) == null ? void 0 : _opts.name) != null ? _opts$name : "Autorun";
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) // normal autorun
    reaction = new Reaction(name, function() {
        this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
    else {
        var scheduler = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled = false;
        reaction = new Reaction(name, function() {
            if (!isScheduled) {
                isScheduled = true;
                scheduler(function() {
                    isScheduled = false;
                    if (!reaction.isDisposed_) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    if (!((_opts2 = opts) != null && (_opts2$signal = _opts2.signal) != null && _opts2$signal.aborted)) reaction.schedule_();
    return reaction.getDisposer_((_opts3 = opts) == null ? void 0 : _opts3.signal);
}
var run = function run(f) {
    return f();
};
function createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? function(f) {
        return setTimeout(f, opts.delay);
    } : run;
}
function reaction(expression, effect, opts) {
    var _opts$name2, _opts4, _opts4$signal, _opts5;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name2 = opts.name) != null ? _opts$name2 : "Reaction";
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var oldValue;
    var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer["default"];
    var r = new Reaction(name, function() {
        if (firstTime || runSync) reactionRunner();
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false;
        if (r.isDisposed_) return;
        var changed = false;
        r.track(function() {
            var nextValue = allowStateChanges(false, function() {
                return expression(r);
            });
            changed = firstTime || !equals(value, nextValue);
            oldValue = value;
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, oldValue, r);
        else if (!firstTime && changed) effectAction(value, oldValue, r);
        firstTime = false;
    }
    if (!((_opts4 = opts) != null && (_opts4$signal = _opts4.signal) != null && _opts4$signal.aborted)) r.schedule_();
    return r.getDisposer_((_opts5 = opts) == null ? void 0 : _opts5.signal);
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function() {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}
var ON_BECOME_OBSERVED = "onBO";
var ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = isFunction(arg3) ? arg3 : arg2;
    var listenersKey = hook + "L";
    if (atom[listenersKey]) atom[listenersKey].add(cb);
    else atom[listenersKey] = new Set([
        cb
    ]);
    return function() {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners["delete"](cb);
            if (hookListeners.size === 0) delete atom[listenersKey];
        }
    };
}
var NEVER = "never";
var ALWAYS = "always";
var OBSERVED = "observed";
// const IF_AVAILABLE = "ifavailable"
function configure(options) {
    if (options.isolateGlobalState === true) isolateGlobalState();
    var useProxies = options.useProxies, enforceActions = options.enforceActions;
    if (useProxies !== undefined) globalState.useProxies = useProxies === ALWAYS ? true : useProxies === NEVER ? false : typeof Proxy !== "undefined";
    if (useProxies === "ifavailable") globalState.verifyProxies = true;
    if (enforceActions !== undefined) {
        var ea = enforceActions === ALWAYS ? ALWAYS : enforceActions === OBSERVED;
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === ALWAYS ? false : true;
    }
    [
        "computedRequiresReaction",
        "reactionRequiresObservable",
        "observableRequiresReaction",
        "disableErrorBoundaries",
        "safeDescriptors"
    ].forEach(function(key) {
        if (key in options) globalState[key] = !!options[key];
    });
    globalState.allowStateReads = !globalState.observableRequiresReaction;
    if (options.reactionScheduler) setReactionScheduler(options.reactionScheduler);
}
function extendObservable(target, properties, annotations, options) {
    // Pull descriptors first, so we don't have to deal with props added by administration ($mobx)
    var descriptors = getOwnPropertyDescriptors(properties);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        ownKeys(descriptors).forEach(function(key) {
            adm.extend_(key, descriptors[key], // must pass "undefined" for { key: undefined }
            !annotations ? true : key in annotations ? annotations[key] : true);
        });
    });
    return target;
}
function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name_
    };
    if (node.observing_ && node.observing_.length > 0) result.dependencies = unique(node.observing_).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name_
    };
    if (hasObservers(node)) result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
    return result;
}
function unique(list) {
    return Array.from(new Set(list));
}
var generatorId = 0;
function FlowCancellationError() {
    this.message = "FLOW_CANCELLED";
}
FlowCancellationError.prototype = /*#__PURE__*/ Object.create(Error.prototype);
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
var flowAnnotation = /*#__PURE__*/ createFlowAnnotation("flow");
var flowBoundAnnotation = /*#__PURE__*/ createFlowAnnotation("flow.bound", {
    bound: true
});
var flow = /*#__PURE__*/ Object.assign(function flow(arg1, arg2) {
    // @flow (2022.3 Decorators)
    if (is20223Decorator(arg2)) return flowAnnotation.decorate_20223_(arg1, arg2);
    // @flow
    if (isStringish(arg2)) return storeAnnotation(arg1, arg2, flowAnnotation);
    var generator = arg1;
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    var res = function res() {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function(resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen["throw"]).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (isFunction(ret == null ? void 0 : ret.then)) {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = action(name + " - runid: " + runId + " - cancel", function() {
            try {
                if (pendingPromise) cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var _res = gen["return"](undefined);
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(_res.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
    res.isMobXFlow = true;
    return res;
}, flowAnnotation);
flow.bound = /*#__PURE__*/ createDecoratorAnnotation(flowBoundAnnotation);
function cancelPromise(promise) {
    if (isFunction(promise.cancel)) promise.cancel();
}
function flowResult(result) {
    return result; // just tricking TypeScript :)
}
function isFlow(fn) {
    return (fn == null ? void 0 : fn.isMobXFlow) === true;
}
function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) target = getAdministration(thing);
    else if (isObservableObject(thing)) target = getAdministration(thing, propOrHandler);
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function() {
        target.dehancer = undefined;
    };
}
function intercept(thing, propOrHandler, handler) {
    if (isFunction(handler)) return interceptProperty(thing, propOrHandler, handler);
    else return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept_(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept_(handler);
}
function _isComputed(value, property) {
    if (property === undefined) return isComputedValue(value);
    if (isObservableObject(value) === false) return false;
    if (!value[$mobx].values_.has(property)) return false;
    var atom = getAtom(value, property);
    return isComputedValue(atom);
}
function isComputed(value) {
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    return _isComputed(value, propName);
}
function _isObservable(value, property) {
    if (!value) return false;
    if (property !== undefined) {
        if (isObservableObject(value)) return value[$mobx].values_.has(property);
        return false;
    }
    // For first check, see #701
    return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    return _isObservable(value, propName);
}
function keys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].keys_();
    if (isObservableMap(obj) || isObservableSet(obj)) return Array.from(obj.keys());
    if (isObservableArray(obj)) return obj.map(function(_, index) {
        return index;
    });
    die(5);
}
function values(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return obj[key];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return obj.get(key);
    });
    if (isObservableSet(obj)) return Array.from(obj.values());
    if (isObservableArray(obj)) return obj.slice();
    die(6);
}
function entries(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj.get(key)
        ];
    });
    if (isObservableSet(obj)) return Array.from(obj.entries());
    if (isObservableArray(obj)) return obj.map(function(key, index) {
        return [
            index,
            key
        ];
    });
    die(7);
}
function set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var _values = key;
        try {
            for(var _key in _values)set(obj, _key, _values[_key]);
        } finally{
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) obj[$mobx].set_(key, value);
    else if (isObservableMap(obj)) obj.set(key, value);
    else if (isObservableSet(obj)) obj.add(key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        if (key < 0) die("Invalid index: '" + key + "'");
        startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        endBatch();
    } else die(8);
}
function remove(obj, key) {
    if (isObservableObject(obj)) obj[$mobx].delete_(key);
    else if (isObservableMap(obj)) obj["delete"](key);
    else if (isObservableSet(obj)) obj["delete"](key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        obj.splice(key, 1);
    } else die(9);
}
function has(obj, key) {
    if (isObservableObject(obj)) return obj[$mobx].has_(key);
    else if (isObservableMap(obj)) return obj.has(key);
    else if (isObservableSet(obj)) return obj.has(key);
    else if (isObservableArray(obj)) return key >= 0 && key < obj.length;
    die(10);
}
function get(obj, key) {
    if (!has(obj, key)) return undefined;
    if (isObservableObject(obj)) return obj[$mobx].get_(key);
    else if (isObservableMap(obj)) return obj.get(key);
    else if (isObservableArray(obj)) return obj[key];
    die(11);
}
function apiDefineProperty(obj, key, descriptor) {
    if (isObservableObject(obj)) return obj[$mobx].defineProperty_(key, descriptor);
    die(39);
}
function apiOwnKeys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].ownKeys_();
    die(38);
}
function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (isFunction(cbOrFire)) return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe_(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe_(listener, fireImmediately);
}
function cache(map, key, value) {
    map.set(key, value);
    return value;
}
function toJSHelper(source, __alreadySeen) {
    if (source == null || typeof source !== "object" || source instanceof Date || !isObservable(source)) return source;
    if (isObservableValue(source) || isComputedValue(source)) return toJSHelper(source.get(), __alreadySeen);
    if (__alreadySeen.has(source)) return __alreadySeen.get(source);
    if (isObservableArray(source)) {
        var res = cache(__alreadySeen, source, new Array(source.length));
        source.forEach(function(value, idx) {
            res[idx] = toJSHelper(value, __alreadySeen);
        });
        return res;
    }
    if (isObservableSet(source)) {
        var _res = cache(__alreadySeen, source, new Set());
        source.forEach(function(value) {
            _res.add(toJSHelper(value, __alreadySeen));
        });
        return _res;
    }
    if (isObservableMap(source)) {
        var _res2 = cache(__alreadySeen, source, new Map());
        source.forEach(function(value, key) {
            _res2.set(key, toJSHelper(value, __alreadySeen));
        });
        return _res2;
    } else {
        // must be observable object
        var _res3 = cache(__alreadySeen, source, {});
        apiOwnKeys(source).forEach(function(key) {
            if (objectPrototype.propertyIsEnumerable.call(source, key)) _res3[key] = toJSHelper(source[key], __alreadySeen);
        });
        return _res3;
    }
}
/**
 * Recursively converts an observable to it's non-observable native counterpart.
 * It does NOT recurse into non-observables, these are left as they are, even if they contain observables.
 * Computed and other non-enumerable properties are completely ignored.
 * Complex scenarios require custom solution, eg implementing `toJSON` or using `serializr` lib.
 */ function toJS(source, options) {
    return toJSHelper(source, new Map());
}
function trace() {
    var enterBreakPoint, _len, args, _key, derivation;
    return;
}
function getAtomFromArgs(args) {
    switch(args.length){
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */ function transaction(action, thisArg) {
    if (thisArg === void 0) thisArg = undefined;
    startBatch();
    try {
        return action.apply(thisArg);
    } finally{
        endBatch();
    }
}
function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && typeof arg1 === "object") return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        var error = new Error("WHEN_TIMEOUT");
        timeoutHandle = setTimeout(function() {
            if (!disposer[$mobx].isDisposed_) {
                disposer();
                if (opts.onError) opts.onError(error);
                else throw error;
            }
        }, opts.timeout);
    }
    opts.name = "When";
    var effectAction = createAction("When-effect", effect);
    // eslint-disable-next-line
    var disposer = autorun(function(r) {
        // predicate should not change state
        var cond = allowStateChanges(false, predicate);
        if (cond) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    var _opts$signal;
    if (opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted) return Object.assign(Promise.reject(new Error("WHEN_ABORTED")), {
        cancel: function cancel() {
            return null;
        }
    });
    var cancel;
    var abort;
    var res = new Promise(function(resolve, reject) {
        var _opts$signal2;
        var disposer = _when(predicate, resolve, _extends({}, opts, {
            onError: reject
        }));
        cancel = function cancel() {
            disposer();
            reject(new Error("WHEN_CANCELLED"));
        };
        abort = function abort() {
            disposer();
            reject(new Error("WHEN_ABORTED"));
        };
        opts == null || (_opts$signal2 = opts.signal) == null || _opts$signal2.addEventListener == null || _opts$signal2.addEventListener("abort", abort);
    })["finally"](function() {
        var _opts$signal3;
        return opts == null ? void 0 : (_opts$signal3 = opts.signal) == null ? void 0 : _opts$signal3.removeEventListener == null ? void 0 : _opts$signal3.removeEventListener("abort", abort);
    });
    res.cancel = cancel;
    return res;
}
function getAdm(target) {
    return target[$mobx];
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function has(target, name) {
        return getAdm(target).has_(name);
    },
    get: function get(target, name) {
        return getAdm(target).get_(name);
    },
    set: function set(target, name, value) {
        var _getAdm$set_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$set_ = getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
    },
    deleteProperty: function deleteProperty(target, name) {
        var _getAdm$delete_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$delete_ = getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
    },
    defineProperty: function defineProperty(target, name, descriptor) {
        var _getAdm$definePropert;
        // null (intercepted) -> true (success)
        return (_getAdm$definePropert = getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
    },
    ownKeys: function ownKeys(target) {
        return getAdm(target).ownKeys_();
    },
    preventExtensions: function preventExtensions(target) {
        die(13);
    }
};
function asDynamicObservableObject(target, options) {
    var _target$$mobx, _target$$mobx$proxy_;
    assertProxies();
    target = asObservableObject(target, options);
    return (_target$$mobx$proxy_ = (_target$$mobx = target[$mobx]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, objectProxyTraps);
}
function hasInterceptors(interceptable) {
    return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors_ || (interceptable.interceptors_ = []);
    interceptors.push(handler);
    return once(function() {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = [].concat(interceptable.interceptors_ || []);
        for(var i = 0, l = interceptors.length; i < l; i++){
            change = interceptors[i](change);
            if (change && !change.type) die(14);
            if (!change) break;
        }
        return change;
    } finally{
        untrackedEnd(prevU);
    }
}
function hasListeners(listenable) {
    return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners_ || (listenable.changeListeners_ = []);
    listeners.push(handler);
    return once(function() {
        var idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners_;
    if (!listeners) return;
    listeners = listeners.slice();
    for(var i = 0, l = listeners.length; i < l; i++)listeners[i](change);
    untrackedEnd(prevU);
}
function makeObservable(target, annotations, options) {
    initObservable(function() {
        var _annotations;
        var adm = asObservableObject(target, options)[$mobx];
        // Default to decorators
        (_annotations = annotations) != null ? _annotations : annotations = collectStoredAnnotations(target);
        // Annotate
        ownKeys(annotations).forEach(function(key) {
            return adm.make_(key, annotations[key]);
        });
    });
    return target;
}
// proto[keysSymbol] = new Set<PropertyKey>()
var keysSymbol = /*#__PURE__*/ Symbol("mobx-keys");
function makeAutoObservable(target, overrides, options) {
    // Optimization: avoid visiting protos
    // Assumes that annotation.make_/.extend_ works the same for plain objects
    if (isPlainObject(target)) return extendObservable(target, target, overrides, options);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        // Optimization: cache keys on proto
        // Assumes makeAutoObservable can be called only once per object and can't be used in subclass
        if (!target[keysSymbol]) {
            var proto = Object.getPrototypeOf(target);
            var keys = new Set([].concat(ownKeys(target), ownKeys(proto)));
            keys["delete"]("constructor");
            keys["delete"]($mobx);
            addHiddenProp(proto, keysSymbol, keys);
        }
        target[keysSymbol].forEach(function(key) {
            return adm.make_(key, // must pass "undefined" for { key: undefined }
            !overrides ? true : key in overrides ? overrides[key] : true);
        });
    });
    return target;
}
var SPLICE = "splice";
var UPDATE = "update";
var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function get(target, name) {
        var adm = target[$mobx];
        if (name === $mobx) return adm;
        if (name === "length") return adm.getArrayLength_();
        if (typeof name === "string" && !isNaN(name)) return adm.get_(parseInt(name));
        if (hasProp(arrayExtensions, name)) return arrayExtensions[name];
        return target[name];
    },
    set: function set(target, name, value) {
        var adm = target[$mobx];
        if (name === "length") adm.setArrayLength_(value);
        if (typeof name === "symbol" || isNaN(name)) target[name] = value;
        else // numeric string
        adm.set_(parseInt(name), value);
        return true;
    },
    preventExtensions: function preventExtensions() {
        die(15);
    }
};
var ObservableArrayAdministration = /*#__PURE__*/ function() {
    // this is the prop that gets proxied, so can't replace it!
    function ObservableArrayAdministration(name, enhancer, owned_, legacyMode_) {
        if (name === void 0) name = "ObservableArray";
        this.owned_ = void 0;
        this.legacyMode_ = void 0;
        this.atom_ = void 0;
        this.values_ = [];
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.enhancer_ = void 0;
        this.dehancer = void 0;
        this.proxy_ = void 0;
        this.lastKnownLength_ = 0;
        this.owned_ = owned_;
        this.legacyMode_ = legacyMode_;
        this.atom_ = new Atom(name);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, "ObservableArray[..]");
        };
    }
    var _proto = ObservableArrayAdministration.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.dehanceValues_ = function dehanceValues_(values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately === void 0) fireImmediately = false;
        if (fireImmediately) listener({
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: "splice",
            index: 0,
            added: this.values_.slice(),
            addedCount: this.values_.length,
            removed: [],
            removedCount: 0
        });
        return registerListener(this, listener);
    };
    _proto.getArrayLength_ = function getArrayLength_() {
        this.atom_.reportObserved();
        return this.values_.length;
    };
    _proto.setArrayLength_ = function setArrayLength_(newLength) {
        if (typeof newLength !== "number" || isNaN(newLength) || newLength < 0) die("Out of range: " + newLength);
        var currentLength = this.values_.length;
        if (newLength === currentLength) return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for(var i = 0; i < newLength - currentLength; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            this.spliceWithArray_(currentLength, 0, newItems);
        } else this.spliceWithArray_(newLength, currentLength - newLength);
    };
    _proto.updateArrayLength_ = function updateArrayLength_(oldLength, delta) {
        if (oldLength !== this.lastKnownLength_) die(16);
        this.lastKnownLength_ += delta;
        if (this.legacyMode_ && delta > 0) reserveArrayBuffer(oldLength + delta + 1);
    };
    _proto.spliceWithArray_ = function spliceWithArray_(index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        var length = this.values_.length;
        if (index === undefined) index = 0;
        else if (index > length) index = length;
        else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
        else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_,
                type: SPLICE,
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function(v) {
            return _this.enhancer_(v, undefined);
        });
        if (this.legacyMode_ || false) {
            var lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength_(length, lengthDelta); // checks if internal array wasn't modified
        }
        var res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice_(index, newItems, res);
        return this.dehanceValues_(res);
    };
    _proto.spliceItemsIntoValues_ = function spliceItemsIntoValues_(index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            var _this$values_;
            return (_this$values_ = this.values_).splice.apply(_this$values_, [
                index,
                deleteCount
            ].concat(newItems));
        } else {
            // The items removed by the splice
            var res = this.values_.slice(index, index + deleteCount);
            // The items that that should remain at the end of the array
            var oldItems = this.values_.slice(index + deleteCount);
            // New length is the previous length + addition count - deletion count
            this.values_.length += newItems.length - deleteCount;
            for(var i = 0; i < newItems.length; i++)this.values_[index + i] = newItems[i];
            for(var _i = 0; _i < oldItems.length; _i++)this.values_[index + newItems.length + _i] = oldItems[_i];
            return res;
        }
    };
    _proto.notifyArrayChildUpdate_ = function notifyArrayChildUpdate_(index, newValue, oldValue) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            type: UPDATE,
            debugObjectName: this.atom_.name_,
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null;
        this.atom_.reportChanged();
        if (notify) notifyListeners(this, change);
    };
    _proto.notifyArraySplice_ = function notifyArraySplice_(index, added, removed) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: SPLICE,
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        this.atom_.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) notifyListeners(this, change);
    };
    _proto.get_ = function get_(index) {
        if (this.legacyMode_ && index >= this.values_.length) {
            console.warn("[mobx] Out of bounds read: " + index);
            return undefined;
        }
        this.atom_.reportObserved();
        return this.dehanceValue_(this.values_[index]);
    };
    _proto.set_ = function set_(index, newValue) {
        var values = this.values_;
        if (this.legacyMode_ && index > values.length) // out of bounds
        die(17, index, values.length);
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(this.atom_);
            var oldValue = values[index];
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    type: UPDATE,
                    object: this.proxy_,
                    index: index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = this.enhancer_(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                this.notifyArrayChildUpdate_(index, newValue, oldValue);
            }
        } else {
            // For out of bound index, we don't create an actual sparse array,
            // but rather fill the holes with undefined (same as setArrayLength_).
            // This could be considered a bug.
            var newItems = new Array(index + 1 - values.length);
            for(var i = 0; i < newItems.length - 1; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            newItems[newItems.length - 1] = newValue;
            this.spliceWithArray_(values.length, 0, newItems);
        }
    };
    return ObservableArrayAdministration;
}();
function createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) name = "ObservableArray";
    if (owned === void 0) owned = false;
    assertProxies();
    return initObservable(function() {
        var adm = new ObservableArrayAdministration(name, enhancer, owned, false);
        addHiddenFinalProp(adm.values_, $mobx, adm);
        var proxy = new Proxy(adm.values_, arrayTraps);
        adm.proxy_ = proxy;
        if (initialValues && initialValues.length) adm.spliceWithArray_(0, 0, initialValues);
        return proxy;
    });
}
// eslint-disable-next-line
var arrayExtensions = {
    clear: function clear() {
        return this.splice(0);
    },
    replace: function replace(newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray_(0, adm.values_.length, newItems);
    },
    // Used by JSON.stringify
    toJSON: function toJSON() {
        return this.slice();
    },
    /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */ splice: function splice(index, deleteCount) {
        for(var _len = arguments.length, newItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)newItems[_key - 2] = arguments[_key];
        var adm = this[$mobx];
        switch(arguments.length){
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray_(index);
            case 2:
                return adm.spliceWithArray_(index, deleteCount);
        }
        return adm.spliceWithArray_(index, deleteCount, newItems);
    },
    spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
        return this[$mobx].spliceWithArray_(index, deleteCount, newItems);
    },
    push: function push() {
        var adm = this[$mobx];
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        adm.spliceWithArray_(adm.values_.length, 0, items);
        return adm.values_.length;
    },
    pop: function pop() {
        return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
    },
    shift: function shift() {
        return this.splice(0, 1)[0];
    },
    unshift: function unshift() {
        var adm = this[$mobx];
        for(var _len3 = arguments.length, items = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)items[_key3] = arguments[_key3];
        adm.spliceWithArray_(0, 0, items);
        return adm.values_.length;
    },
    reverse: function reverse() {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        if (globalState.trackingDerivation) die(37, "reverse");
        this.replace(this.slice().reverse());
        return this;
    },
    sort: function sort() {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (globalState.trackingDerivation) die(37, "sort");
        var copy = this.slice();
        copy.sort.apply(copy, arguments);
        this.replace(copy);
        return this;
    },
    remove: function remove(value) {
        var adm = this[$mobx];
        var idx = adm.dehanceValues_(adm.values_).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */ addArrayExtension("at", simpleFunc);
addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc);
addArrayExtension("toSorted", simpleFunc);
addArrayExtension("toSpliced", simpleFunc);
addArrayExtension("with", simpleFunc);
// map
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("findLast", mapLikeFunc);
addArrayExtension("findLastIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc);
addArrayExtension("toReversed", mapLikeFunc);
// reduce
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(funcName, funcFactory) {
    if (typeof Array.prototype[funcName] === "function") arrayExtensions[funcName] = funcFactory(funcName);
}
// Report and delegate to dehanced array
function simpleFunc(funcName) {
    return function() {
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
// Make sure callbacks recieve correct array arg #2326
function mapLikeFunc(funcName) {
    return function(callback, thisArg) {
        var _this2 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName](function(element, index) {
            return callback.call(thisArg, element, index, _this2);
        });
    };
}
// Make sure callbacks recieve correct array arg #2326
function reduceLikeFunc(funcName) {
    return function() {
        var _this3 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function(accumulator, currentValue, index) {
            return callback(accumulator, currentValue, index, _this3);
        };
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
var isObservableArrayAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}
var _Symbol$iterator, _Symbol$toStringTag;
var ObservableMapMarker = {};
var ADD = "add";
var DELETE = "delete";
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
_Symbol$iterator = Symbol.iterator;
_Symbol$toStringTag = Symbol.toStringTag;
var ObservableMap = /*#__PURE__*/ function() {
    // hasMap, not hashMap >-).
    function ObservableMap(initialData, enhancer_, name_) {
        var _this = this;
        if (enhancer_ === void 0) enhancer_ = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableMap";
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this[$mobx] = ObservableMapMarker;
        this.data_ = void 0;
        this.hasMap_ = void 0;
        this.keysAtom_ = void 0;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        if (!isFunction(Map)) die(18);
        initObservable(function() {
            _this.keysAtom_ = createAtom("ObservableMap.keys()");
            _this.data_ = new Map();
            _this.hasMap_ = new Map();
            if (initialData) _this.merge(initialData);
        });
    }
    var _proto = ObservableMap.prototype;
    _proto.has_ = function has_(key) {
        return this.data_.has(key);
    };
    _proto.has = function has(key) {
        var _this2 = this;
        if (!globalState.trackingDerivation) return this.has_(key);
        var entry = this.hasMap_.get(key);
        if (!entry) {
            var newEntry = entry = new ObservableValue(this.has_(key), referenceEnhancer, "ObservableMap.key?", false);
            this.hasMap_.set(key, newEntry);
            onBecomeUnobserved(newEntry, function() {
                return _this2.hasMap_["delete"](key);
            });
        }
        return entry.get();
    };
    _proto.set = function set(key, value) {
        var hasKey = this.has_(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? UPDATE : ADD,
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) this.updateValue_(key, value);
        else this.addValue_(key, value);
        return this;
    };
    _proto["delete"] = function _delete(key) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this.has_(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: this.data_.get(key).value_,
                name: key
            } : null;
            transaction(function() {
                var _this3$hasMap_$get;
                _this3.keysAtom_.reportChanged();
                (_this3$hasMap_$get = _this3.hasMap_.get(key)) == null || _this3$hasMap_$get.setNewValue_(false);
                var observable = _this3.data_.get(key);
                observable.setNewValue_(undefined);
                _this3.data_["delete"](key);
            });
            if (notify) notifyListeners(this, _change);
            return true;
        }
        return false;
    };
    _proto.updateValue_ = function updateValue_(key, newValue) {
        var observable = this.data_.get(key);
        newValue = observable.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: UPDATE,
                object: this,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, change);
        }
    };
    _proto.addValue_ = function addValue_(key, newValue) {
        var _this4 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        transaction(function() {
            var _this4$hasMap_$get;
            var observable = new ObservableValue(newValue, _this4.enhancer_, "ObservableMap.key", false);
            _this4.data_.set(key, observable);
            newValue = observable.value_; // value might have been changed
            (_this4$hasMap_$get = _this4.hasMap_.get(key)) == null || _this4$hasMap_$get.setNewValue_(true);
            _this4.keysAtom_.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "map",
            debugObjectName: this.name_,
            type: ADD,
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if (notify) notifyListeners(this, change);
    };
    _proto.get = function get(key) {
        if (this.has(key)) return this.dehanceValue_(this.data_.get(key).get());
        return this.dehanceValue_(undefined);
    };
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.keys = function keys() {
        this.keysAtom_.reportObserved();
        return this.data_.keys();
    };
    _proto.values = function values() {
        var self1 = this;
        var keys = this.keys();
        return makeIterable({
            next: function next() {
                var _keys$next = keys.next(), done = _keys$next.done, value = _keys$next.value;
                return {
                    done: done,
                    value: done ? undefined : self1.get(value)
                };
            }
        });
    };
    _proto.entries = function entries() {
        var self1 = this;
        var keys = this.keys();
        return makeIterable({
            next: function next() {
                var _keys$next2 = keys.next(), done = _keys$next2.done, value = _keys$next2.value;
                return {
                    done: done,
                    value: done ? undefined : [
                        value,
                        self1.get(value)
                    ]
                };
            }
        });
    };
    _proto[_Symbol$iterator] = function() {
        return this.entries();
    };
    _proto.forEach = function forEach(callback, thisArg) {
        for(var _iterator = _createForOfIteratorHelperLoose(this), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            callback.call(thisArg, value, key, this);
        }
    } /** Merge another object into this object, returns this. */ ;
    _proto.merge = function merge(other) {
        var _this5 = this;
        if (isObservableMap(other)) other = new Map(other);
        transaction(function() {
            if (isPlainObject(other)) getPlainObjectKeys(other).forEach(function(key) {
                return _this5.set(key, other[key]);
            });
            else if (Array.isArray(other)) other.forEach(function(_ref) {
                var key = _ref[0], value = _ref[1];
                return _this5.set(key, value);
            });
            else if (isES6Map(other)) {
                if (other.constructor !== Map) die(19, other);
                other.forEach(function(value, key) {
                    return _this5.set(key, value);
                });
            } else if (other !== null && other !== undefined) die(20, other);
        });
        return this;
    };
    _proto.clear = function clear() {
        var _this6 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator2 = _createForOfIteratorHelperLoose(_this6.keys()), _step2; !(_step2 = _iterator2()).done;){
                    var key = _step2.value;
                    _this6["delete"](key);
                }
            });
        });
    };
    _proto.replace = function replace(values) {
        var _this7 = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        transaction(function() {
            // Convert to map so we can do quick key lookups
            var replacementMap = convertToMap(values);
            var orderedData = new Map();
            // Used for optimization
            var keysReportChangedCalled = false;
            // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            for(var _iterator3 = _createForOfIteratorHelperLoose(_this7.data_.keys()), _step3; !(_step3 = _iterator3()).done;){
                var key = _step3.value;
                // Concurrently iterating/deleting keys
                // iterator should handle this correctly
                if (!replacementMap.has(key)) {
                    var deleted = _this7["delete"](key);
                    // Was the key removed?
                    if (deleted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                    else {
                        // Delete prevented by interceptor
                        var value = _this7.data_.get(key);
                        orderedData.set(key, value);
                    }
                }
            }
            // Merge entries
            for(var _iterator4 = _createForOfIteratorHelperLoose(replacementMap.entries()), _step4; !(_step4 = _iterator4()).done;){
                var _step4$value = _step4.value, _key = _step4$value[0], _value = _step4$value[1];
                // We will want to know whether a new key is added
                var keyExisted = _this7.data_.has(_key);
                // Add or update value
                _this7.set(_key, _value);
                // The addition could have been prevent by interceptor
                if (_this7.data_.has(_key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    var _value2 = _this7.data_.get(_key);
                    orderedData.set(_key, _value2);
                    // Was a new key added?
                    if (!keyExisted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                }
            }
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this7.data_.size !== orderedData.size) // If size differs, keys are definitely modified
                _this7.keysAtom_.reportChanged();
                else {
                    var iter1 = _this7.data_.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while(!next1.done){
                        if (next1.value !== next2.value) {
                            _this7.keysAtom_.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            _this7.data_ = orderedData;
        });
        return this;
    };
    _proto.toString = function toString() {
        return "[object ObservableMap]";
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _createClass(ObservableMap, [
        {
            key: "size",
            get: function get() {
                this.keysAtom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: _Symbol$toStringTag,
            get: function get() {
                return "Map";
            }
        }
    ]);
    return ObservableMap;
}();
// eslint-disable-next-line
var isObservableMap = /*#__PURE__*/ createInstanceofPredicate("ObservableMap", ObservableMap);
function convertToMap(dataStructure) {
    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) return dataStructure;
    else if (Array.isArray(dataStructure)) return new Map(dataStructure);
    else if (isPlainObject(dataStructure)) {
        var map = new Map();
        for(var key in dataStructure)map.set(key, dataStructure[key]);
        return map;
    } else return die(21, dataStructure);
}
var _Symbol$iterator$1, _Symbol$toStringTag$1;
var ObservableSetMarker = {};
_Symbol$iterator$1 = Symbol.iterator;
_Symbol$toStringTag$1 = Symbol.toStringTag;
var ObservableSet = /*#__PURE__*/ function() {
    function ObservableSet(initialData, enhancer, name_) {
        var _this = this;
        if (enhancer === void 0) enhancer = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableSet";
        this.name_ = void 0;
        this[$mobx] = ObservableSetMarker;
        this.data_ = new Set();
        this.atom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = void 0;
        this.name_ = name_;
        if (!isFunction(Set)) die(22);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, name_);
        };
        initObservable(function() {
            _this.atom_ = createAtom(_this.name_);
            if (initialData) _this.replace(initialData);
        });
    }
    var _proto = ObservableSet.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.clear = function clear() {
        var _this2 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator = _createForOfIteratorHelperLoose(_this2.data_.values()), _step; !(_step = _iterator()).done;){
                    var value = _step.value;
                    _this2["delete"](value);
                }
            });
        });
    };
    _proto.forEach = function forEach(callbackFn, thisArg) {
        for(var _iterator2 = _createForOfIteratorHelperLoose(this), _step2; !(_step2 = _iterator2()).done;){
            var value = _step2.value;
            callbackFn.call(thisArg, value, value, this);
        }
    };
    _proto.add = function add(value) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: ADD,
                object: this,
                newValue: value
            });
            if (!change) return this;
        // ideally, value = change.value would be done here, so that values can be
        // changed by interceptor. Same applies for other Set and Map api's.
        }
        if (!this.has(value)) {
            transaction(function() {
                _this3.data_.add(_this3.enhancer_(value, undefined));
                _this3.atom_.reportChanged();
            });
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: ADD,
                object: this,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, _change);
        }
        return this;
    };
    _proto["delete"] = function _delete(value) {
        var _this4 = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change2 = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: value
            } : null;
            transaction(function() {
                _this4.atom_.reportChanged();
                _this4.data_["delete"](value);
            });
            if (notify) notifyListeners(this, _change2);
            return true;
        }
        return false;
    };
    _proto.has = function has(value) {
        this.atom_.reportObserved();
        return this.data_.has(this.dehanceValue_(value));
    };
    _proto.entries = function entries() {
        var nextIndex = 0;
        var keys = Array.from(this.keys());
        var values = Array.from(this.values());
        return makeIterable({
            next: function next() {
                var index = nextIndex;
                nextIndex += 1;
                return index < values.length ? {
                    value: [
                        keys[index],
                        values[index]
                    ],
                    done: false
                } : {
                    done: true
                };
            }
        });
    };
    _proto.keys = function keys() {
        return this.values();
    };
    _proto.values = function values() {
        this.atom_.reportObserved();
        var self1 = this;
        var nextIndex = 0;
        var observableValues = Array.from(this.data_.values());
        return makeIterable({
            next: function next() {
                return nextIndex < observableValues.length ? {
                    value: self1.dehanceValue_(observableValues[nextIndex++]),
                    done: false
                } : {
                    done: true
                };
            }
        });
    };
    _proto.replace = function replace(other) {
        var _this5 = this;
        if (isObservableSet(other)) other = new Set(other);
        transaction(function() {
            if (Array.isArray(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (isES6Set(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (other !== null && other !== undefined) die("Cannot initialize set from " + other);
        });
        return this;
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    _proto.toString = function toString() {
        return "[object ObservableSet]";
    };
    _proto[_Symbol$iterator$1] = function() {
        return this.values();
    };
    _createClass(ObservableSet, [
        {
            key: "size",
            get: function get() {
                this.atom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: _Symbol$toStringTag$1,
            get: function get() {
                return "Set";
            }
        }
    ]);
    return ObservableSet;
}();
// eslint-disable-next-line
var isObservableSet = /*#__PURE__*/ createInstanceofPredicate("ObservableSet", ObservableSet);
var descriptorCache = /*#__PURE__*/ Object.create(null);
var REMOVE = "remove";
var ObservableObjectAdministration = /*#__PURE__*/ function() {
    function ObservableObjectAdministration(target_, values_, name_, // Used anytime annotation is not explicitely provided
    defaultAnnotation_) {
        if (values_ === void 0) values_ = new Map();
        if (defaultAnnotation_ === void 0) defaultAnnotation_ = autoAnnotation;
        this.target_ = void 0;
        this.values_ = void 0;
        this.name_ = void 0;
        this.defaultAnnotation_ = void 0;
        this.keysAtom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.proxy_ = void 0;
        this.isPlainObject_ = void 0;
        this.appliedAnnotations_ = void 0;
        this.pendingKeys_ = void 0;
        this.target_ = target_;
        this.values_ = values_;
        this.name_ = name_;
        this.defaultAnnotation_ = defaultAnnotation_;
        this.keysAtom_ = new Atom("ObservableObject.keys");
        // Optimization: we use this frequently
        this.isPlainObject_ = isPlainObject(this.target_);
    }
    var _proto = ObservableObjectAdministration.prototype;
    _proto.getObservablePropValue_ = function getObservablePropValue_(key) {
        return this.values_.get(key).get();
    };
    _proto.setObservablePropValue_ = function setObservablePropValue_(key, newValue) {
        var observable = this.values_.get(key);
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return true;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: UPDATE,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: newValue
            });
            if (!change) return null;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue_(newValue);
        // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = false;
            var _change = notify || notifySpy ? {
                type: UPDATE,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, _change);
        }
        return true;
    };
    _proto.get_ = function get_(key) {
        if (globalState.trackingDerivation && !hasProp(this.target_, key)) // Key doesn't exist yet, subscribe for it in case it's added later
        this.has_(key);
        return this.target_[key];
    } /**
   * @param {PropertyKey} key
   * @param {any} value
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.set_ = function set_(key, value, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        // Don't use .has(key) - we care about own
        if (hasProp(this.target_, key)) {
            // Existing prop
            if (this.values_.has(key)) // Observable (can be intercepted)
            return this.setObservablePropValue_(key, value);
            else if (proxyTrap) // Non-observable - proxy
            return Reflect.set(this.target_, key, value);
            else {
                // Non-observable
                this.target_[key] = value;
                return true;
            }
        } else // New prop
        return this.extend_(key, {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
        }, this.defaultAnnotation_, proxyTrap);
    };
    _proto.has_ = function has_(key) {
        if (!globalState.trackingDerivation) // Skip key subscription outside derivation
        return key in this.target_;
        this.pendingKeys_ || (this.pendingKeys_ = new Map());
        var entry = this.pendingKeys_.get(key);
        if (!entry) {
            entry = new ObservableValue(key in this.target_, referenceEnhancer, "ObservableObject.key?", false);
            this.pendingKeys_.set(key, entry);
        }
        return entry.get();
    } /**
   * @param {PropertyKey} key
   * @param {Annotation|boolean} annotation true - use default annotation, false - ignore prop
   */ ;
    _proto.make_ = function make_(key, annotation) {
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return;
        assertAnnotable(this, annotation, key);
        if (!(key in this.target_)) {
            var _this$target_$storedA;
            // Throw on missing key, except for decorators:
            // Decorator annotations are collected from whole prototype chain.
            // When called from super() some props may not exist yet.
            // However we don't have to worry about missing prop,
            // because the decorator must have been applied to something.
            if ((_this$target_$storedA = this.target_[storedAnnotationsSymbol]) != null && _this$target_$storedA[key]) return; // will be annotated by subclass constructor
            else die(1, annotation.annotationType_, this.name_ + "." + key.toString());
        }
        var source = this.target_;
        while(source && source !== objectPrototype){
            var descriptor = getDescriptor(source, key);
            if (descriptor) {
                var outcome = annotation.make_(this, key, descriptor, source);
                if (outcome === 0 /* MakeResult.Cancel */ ) return;
                if (outcome === 1 /* MakeResult.Break */ ) break;
            }
            source = Object.getPrototypeOf(source);
        }
        recordAnnotationApplied(this, annotation, key);
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.extend_ = function extend_(key, descriptor, annotation, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return this.defineProperty_(key, descriptor, proxyTrap);
        assertAnnotable(this, annotation, key);
        var outcome = annotation.extend_(this, key, descriptor, proxyTrap);
        if (outcome) recordAnnotationApplied(this, annotation, key);
        return outcome;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.defineProperty_ = function defineProperty_(key, descriptor, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: descriptor.value
                });
                if (!change) return null;
                var newValue = change.newValue;
                if (descriptor.value !== newValue) descriptor = _extends({}, descriptor, {
                    value: newValue
                });
            }
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            // Notify
            this.notifyPropertyAddition_(key, descriptor.value);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineObservableProperty_ = function defineObservableProperty_(key, value, enhancer, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: value
                });
                if (!change) return null;
                value = change.newValue;
            }
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: true,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            var observable = new ObservableValue(value, enhancer, "ObservableObject.key", false);
            this.values_.set(key, observable);
            // Notify (value possibly changed by ObservableValue)
            this.notifyPropertyAddition_(key, observable.value_);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineComputedProperty_ = function defineComputedProperty_(key, options, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: undefined
                });
                if (!change) return null;
            }
            options.name || (options.name = "ObservableObject.key");
            options.context = this.proxy_ || this.target_;
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: false,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            this.values_.set(key, new ComputedValue(options));
            // Notify
            this.notifyPropertyAddition_(key, undefined);
        } finally{
            endBatch();
        }
        return true;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.delete_ = function delete_(key, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        // No such prop
        if (!hasProp(this.target_, key)) return true;
        // Intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_ || this.target_,
                name: key,
                type: REMOVE
            });
            // Cancelled
            if (!change) return null;
        }
        // Delete
        try {
            var _this$pendingKeys_, _this$pendingKeys_$ge;
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = false;
            var observable = this.values_.get(key);
            // Value needed for spies/listeners
            var value = undefined;
            // Optimization: don't pull the value unless we will need it
            if (!observable && (notify || notifySpy)) {
                var _getDescriptor;
                value = (_getDescriptor = getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
            }
            // delete prop (do first, may fail)
            if (proxyTrap) {
                if (!Reflect.deleteProperty(this.target_, key)) return false;
            } else delete this.target_[key];
            // Clear observable
            if (observable) {
                this.values_["delete"](key);
                // for computed, value is undefined
                if (observable instanceof ObservableValue) value = observable.value_;
                // Notify: autorun(() => obj[key]), see #1796
                propagateChanged(observable);
            }
            // Notify "keys/entries/values" observers
            this.keysAtom_.reportChanged();
            // Notify "has" observers
            // "in" as it may still exist in proto
            (_this$pendingKeys_ = this.pendingKeys_) == null || (_this$pendingKeys_$ge = _this$pendingKeys_.get(key)) == null || _this$pendingKeys_$ge.set(key in this.target_);
            // Notify spies/listeners
            if (notify || notifySpy) {
                var _change2 = {
                    type: REMOVE,
                    observableKind: "object",
                    object: this.proxy_ || this.target_,
                    debugObjectName: this.name_,
                    oldValue: value,
                    name: key
                };
                if (notify) notifyListeners(this, _change2);
            }
        } finally{
            endBatch();
        }
        return true;
    } /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ ;
    _proto.observe_ = function observe_(callback, fireImmediately) {
        return registerListener(this, callback);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.notifyPropertyAddition_ = function notifyPropertyAddition_(key, value) {
        var _this$pendingKeys_2, _this$pendingKeys_2$g;
        var notify = hasListeners(this);
        var notifySpy = false;
        if (notify || notifySpy) {
            var change = notify || notifySpy ? {
                type: ADD,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, change);
        }
        (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2$g = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2$g.set(true);
        // Notify "keys/entries/values" observers
        this.keysAtom_.reportChanged();
    };
    _proto.ownKeys_ = function ownKeys_() {
        this.keysAtom_.reportObserved();
        return ownKeys(this.target_);
    };
    _proto.keys_ = function keys_() {
        // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
        // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
        // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
        // We choose to over-report in Object.keys(object), because:
        // - typically it's used with simple data objects
        // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
        this.keysAtom_.reportObserved();
        return Object.keys(this.target_);
    };
    return ObservableObjectAdministration;
}();
function asObservableObject(target, options) {
    var _options$name;
    if (hasProp(target, $mobx)) return target;
    var name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name : "ObservableObject";
    var adm = new ObservableObjectAdministration(target, new Map(), String(name), getAnnotationFromOptions(options));
    addHiddenProp(target, $mobx, adm);
    return target;
}
var isObservableObjectAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(key) {
    return descriptorCache[key] || (descriptorCache[key] = {
        get: function get() {
            return this[$mobx].getObservablePropValue_(key);
        },
        set: function set(value) {
            return this[$mobx].setObservablePropValue_(key, value);
        }
    });
}
function isObservableObject(thing) {
    if (isObject(thing)) return isObservableObjectAdministration(thing[$mobx]);
    return false;
}
function recordAnnotationApplied(adm, annotation, key) {
    var _adm$target_$storedAn;
    // Remove applied decorator annotation so we don't try to apply it again in subclass constructor
    (_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null || delete _adm$target_$storedAn[key];
}
function assertAnnotable(adm, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
// Bug in safari 9.* (or iOS 9 safari mobile). See #364
var ENTRY_0 = /*#__PURE__*/ createArrayEntryDescriptor(0);
var safariPrototypeSetterInheritanceBug = /*#__PURE__*/ function() {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function set() {
            v = true;
        }
    });
    /*#__PURE__*/ Object.create(p)["0"] = 1;
    return v === false;
}();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */ var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = function StubArray() {};
function inherit(ctor, proto) {
    if (Object.setPrototypeOf) Object.setPrototypeOf(ctor.prototype, proto);
    else if (ctor.prototype.__proto__ !== undefined) ctor.prototype.__proto__ = proto;
    else ctor.prototype = proto;
}
inherit(StubArray, Array.prototype);
// Weex proto freeze protection was here,
// but it is unclear why the hack is need as MobX never changed the prototype
// anyway, so removed it in V6
var LegacyObservableArray = /*#__PURE__*/ function(_StubArray, _Symbol$toStringTag, _Symbol$iterator) {
    _inheritsLoose(LegacyObservableArray, _StubArray);
    function LegacyObservableArray(initialValues, enhancer, name, owned) {
        var _this;
        if (name === void 0) name = "ObservableArray";
        if (owned === void 0) owned = false;
        _this = _StubArray.call(this) || this;
        initObservable(function() {
            var adm = new ObservableArrayAdministration(name, enhancer, owned, true);
            adm.proxy_ = _assertThisInitialized(_this);
            addHiddenFinalProp(_assertThisInitialized(_this), $mobx, adm);
            if (initialValues && initialValues.length) // @ts-ignore
            _this.spliceWithArray(0, 0, initialValues);
            if (safariPrototypeSetterInheritanceBug) // Seems that Safari won't use numeric prototype setter untill any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(_assertThisInitialized(_this), "0", ENTRY_0);
        });
        return _this;
    }
    var _proto = LegacyObservableArray.prototype;
    _proto.concat = function concat() {
        this[$mobx].atom_.reportObserved();
        for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++)arrays[_key] = arguments[_key];
        return Array.prototype.concat.apply(this.slice(), //@ts-ignore
        arrays.map(function(a) {
            return isObservableArray(a) ? a.slice() : a;
        }));
    };
    _proto[_Symbol$iterator] = function() {
        var self1 = this;
        var nextIndex = 0;
        return makeIterable({
            next: function next() {
                return nextIndex < self1.length ? {
                    value: self1[nextIndex++],
                    done: false
                } : {
                    done: true,
                    value: undefined
                };
            }
        });
    };
    _createClass(LegacyObservableArray, [
        {
            key: "length",
            get: function get() {
                return this[$mobx].getArrayLength_();
            },
            set: function set(newLength) {
                this[$mobx].setArrayLength_(newLength);
            }
        },
        {
            key: _Symbol$toStringTag,
            get: function get() {
                return "Array";
            }
        }
    ]);
    return LegacyObservableArray;
}(StubArray, Symbol.toStringTag, Symbol.iterator);
Object.entries(arrayExtensions).forEach(function(_ref) {
    var prop = _ref[0], fn = _ref[1];
    if (prop !== "concat") addHiddenProp(LegacyObservableArray.prototype, prop, fn);
});
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: true,
        get: function get() {
            return this[$mobx].get_(index);
        },
        set: function set(value) {
            this[$mobx].set_(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    defineProperty(LegacyObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    if (max > OBSERVABLE_ARRAY_BUFFER_SIZE) {
        for(var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max + 100; index++)createArrayBufferItem(index);
        OBSERVABLE_ARRAY_BUFFER_SIZE = max;
    }
}
reserveArrayBuffer(1000);
function createLegacyArray(initialValues, enhancer, name) {
    return new LegacyObservableArray(initialValues, enhancer, name);
}
function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined) die(23);
            return thing[$mobx].atom_;
        }
        if (isObservableSet(thing)) return thing.atom_;
        if (isObservableMap(thing)) {
            if (property === undefined) return thing.keysAtom_;
            var observable = thing.data_.get(property) || thing.hasMap_.get(property);
            if (!observable) die(25, property, getDebugName(thing));
            return observable;
        }
        if (isObservableObject(thing)) {
            if (!property) return die(26);
            var _observable = thing[$mobx].values_.get(property);
            if (!_observable) die(27, property, getDebugName(thing));
            return _observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    } else if (isFunction(thing)) {
        if (isReaction(thing[$mobx])) // disposer function
        return thing[$mobx];
    }
    die(28);
}
function getAdministration(thing, property) {
    if (!thing) die(29);
    if (property !== undefined) return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    if (isObservableMap(thing) || isObservableSet(thing)) return thing;
    if (thing[$mobx]) return thing[$mobx];
    die(24, thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined) named = getAtom(thing, property);
    else if (isAction(thing)) return thing.name;
    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) named = getAdministration(thing);
    else // valid for arrays as well
    named = getAtom(thing);
    return named.name_;
}
/**
 * Helper function for initializing observable structures, it applies:
 * 1. allowStateChanges so we don't violate enforceActions.
 * 2. untracked so we don't accidentaly subscribe to anything observable accessed during init in case the observable is created inside derivation.
 * 3. batch to avoid state version updates
 */ function initObservable(cb) {
    var derivation = untrackedStart();
    var allowStateChanges = allowStateChangesStart(true);
    startBatch();
    try {
        return cb();
    } finally{
        endBatch();
        allowStateChangesEnd(allowStateChanges);
        untrackedEnd(derivation);
    }
}
var toString = objectPrototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) depth = -1;
    return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object") return false;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch(className){
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) depth++;
            break;
    }
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor && isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    if (depth === 0) return false;
    else if (depth < 0) depth = -1;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var key;
        length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== length) return false;
        while(length--){
            // Deep compare each member
            key = keys[length];
            if (!(hasProp(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a)) return a.slice();
    if (isES6Map(a) || isObservableMap(a)) return Array.from(a.entries());
    if (isES6Set(a) || isObservableSet(a)) return Array.from(a.entries());
    return a;
}
function makeIterable(iterator) {
    iterator[Symbol.iterator] = getSelf;
    return iterator;
}
function getSelf() {
    return this;
}
function isAnnotation(thing) {
    return(// Can be function
    thing instanceof Object && typeof thing.annotationType_ === "string" && isFunction(thing.make_) && isFunction(thing.extend_));
}
/**
 * (c) Michel Weststrate 2015 - 2020
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get a global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */ [
    "Symbol",
    "Map",
    "Set"
].forEach(function(m) {
    var g = getGlobal();
    if (typeof g[m] === "undefined") die("MobX requires global '" + m + "' to be available or polyfilled");
});
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") // See: https://github.com/andykog/mobx-devtools/
__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: spy,
    extras: {
        getDebugName: getDebugName
    },
    $mobx: $mobx
});

});


parcelRegister("diRXV", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", () => (parcelRequire("2pmb0")).unstable_batchedUpdates);

var $2pmb0 = parcelRequire("2pmb0");

});

parcelRegister("aDZHk", function(module, exports) {

$parcel$export(module.exports, "observerBatching", () => $7bfd67c85d688a74$export$294943bbc3c74f4f);

var $2SBKn = parcelRequire("2SBKn");
function $7bfd67c85d688a74$export$fb2daceae6f5097a(callback) {
    callback();
}
function $7bfd67c85d688a74$export$294943bbc3c74f4f(reactionScheduler) {
    if (!reactionScheduler) reactionScheduler = $7bfd67c85d688a74$export$fb2daceae6f5097a;
    (0, $2SBKn.configure)({
        reactionScheduler: reactionScheduler
    });
}
var $7bfd67c85d688a74$export$13ce1459b9a04b51 = function() {
    return true;
};

});

parcelRegister("1usTX", function(module, exports) {
var $115f030cddf5897f$var$deprecatedMessages = [];
function $115f030cddf5897f$export$be38475be17599d(msg) {
    if (!$115f030cddf5897f$var$deprecatedMessages.includes(msg)) {
        $115f030cddf5897f$var$deprecatedMessages.push(msg);
        console.warn(msg);
    }
}

});

parcelRegister("bVXrj", function(module, exports) {

$parcel$export(module.exports, "useObserver", () => $8b032003b4992c09$export$b9c7ecd090a87b14);

var $2SBKn = parcelRequire("2SBKn");

var $8NFma = parcelRequire("8NFma");

var $7CkpF = parcelRequire("7CkpF");

var $fYQhH = parcelRequire("fYQhH");

var $lltNi = parcelRequire("lltNi");

var $ck4pA = parcelRequire("ck4pA");
function $8b032003b4992c09$var$createReaction(adm) {
    adm.reaction = new (0, $2SBKn.Reaction)("observer".concat(adm.name), function() {
        var _a;
        adm.stateVersion = Symbol();
        // onStoreChange won't be available until the component "mounts".
        // If state changes in between initial render and mount,
        // `useSyncExternalStore` should handle that by checking the state version and issuing update.
        (_a = adm.onStoreChange) === null || _a === void 0 || _a.call(adm);
    });
}
function $8b032003b4992c09$export$b9c7ecd090a87b14(render, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    if ((0, $fYQhH.isUsingStaticRendering)()) return render();
    var admRef = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useRef(null);
    if (!admRef.current) {
        // First render
        var adm_1 = {
            reaction: null,
            onStoreChange: null,
            stateVersion: Symbol(),
            name: baseComponentName,
            subscribe: function(onStoreChange) {
                // Do NOT access admRef here!
                (0, $lltNi.observerFinalizationRegistry).unregister(adm_1);
                adm_1.onStoreChange = onStoreChange;
                if (!adm_1.reaction) {
                    // We've lost our reaction and therefore all subscriptions, occurs when:
                    // 1. Timer based finalization registry disposed reaction before component mounted.
                    // 2. React "re-mounts" same component without calling render in between (typically <StrictMode>).
                    // We have to recreate reaction and schedule re-render to recreate subscriptions,
                    // even if state did not change.
                    $8b032003b4992c09$var$createReaction(adm_1);
                    // `onStoreChange` won't force update if subsequent `getSnapshot` returns same value.
                    // So we make sure that is not the case
                    adm_1.stateVersion = Symbol();
                }
                return function() {
                    var _a;
                    // Do NOT access admRef here!
                    adm_1.onStoreChange = null;
                    (_a = adm_1.reaction) === null || _a === void 0 || _a.dispose();
                    adm_1.reaction = null;
                };
            },
            getSnapshot: function() {
                // Do NOT access admRef here!
                return adm_1.stateVersion;
            }
        };
        admRef.current = adm_1;
    }
    var adm = admRef.current;
    if (!adm.reaction) {
        // First render or reaction was disposed by registry before subscribe
        $8b032003b4992c09$var$createReaction(adm);
        // StrictMode/ConcurrentMode/Suspense may mean that our component is
        // rendered and abandoned multiple times, so we need to track leaked
        // Reactions.
        (0, $lltNi.observerFinalizationRegistry).register(admRef, adm, adm);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useDebugValue(adm.reaction, (0, $7CkpF.printDebugValue));
    (0, $ck4pA.useSyncExternalStore)(// Both of these must be stable, otherwise it would keep resubscribing every render.
    adm.subscribe, adm.getSnapshot, adm.getSnapshot);
    // render the original component, but have the
    // reaction track the observables, so that rendering
    // can be invalidated (see above) once a dependency changes
    var renderResult;
    var exception;
    adm.reaction.track(function() {
        try {
            renderResult = render();
        } catch (e) {
            exception = e;
        }
    });
    if (exception) throw exception; // re-throw any exceptions caught during rendering
    return renderResult;
}

});
parcelRegister("7CkpF", function(module, exports) {

$parcel$export(module.exports, "printDebugValue", () => $58bbea9d7d112450$export$ef795f1f307682c7);

var $2SBKn = parcelRequire("2SBKn");
function $58bbea9d7d112450$export$ef795f1f307682c7(v) {
    return (0, $2SBKn.getDependencyTree)(v);
}

});

parcelRegister("fYQhH", function(module, exports) {

$parcel$export(module.exports, "enableStaticRendering", () => $ba250434b0aa06f3$export$5d52eaa7c0f24c9e);
$parcel$export(module.exports, "isUsingStaticRendering", () => $ba250434b0aa06f3$export$55979271896d643e);
var $ba250434b0aa06f3$var$globalIsUsingStaticRendering = false;
function $ba250434b0aa06f3$export$5d52eaa7c0f24c9e(enable) {
    $ba250434b0aa06f3$var$globalIsUsingStaticRendering = enable;
}
function $ba250434b0aa06f3$export$55979271896d643e() {
    return $ba250434b0aa06f3$var$globalIsUsingStaticRendering;
}

});

parcelRegister("lltNi", function(module, exports) {

$parcel$export(module.exports, "observerFinalizationRegistry", () => $f8a2ab9dfbe24250$export$10e8a12fbfd8583c);

var $9jrr4 = parcelRequire("9jrr4");
var $f8a2ab9dfbe24250$export$10e8a12fbfd8583c = new (0, $9jrr4.UniversalFinalizationRegistry)(function(adm) {
    var _a;
    (_a = adm.reaction) === null || _a === void 0 || _a.dispose();
    adm.reaction = null;
});

});
parcelRegister("9jrr4", function(module, exports) {

$parcel$export(module.exports, "UniversalFinalizationRegistry", () => $6c7b2b897cffba09$export$da5d55a244964b51);
var $6c7b2b897cffba09$export$e901ba0ffe10ba41 = 10000;
var $6c7b2b897cffba09$export$1ae22ce5a82f26b6 = 10000;
var $6c7b2b897cffba09$export$b7a00d372cedeedd = /** @class */ function() {
    function TimerBasedFinalizationRegistry(finalize) {
        var _this = this;
        Object.defineProperty(this, "finalize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: finalize
        });
        Object.defineProperty(this, "registrations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "sweepTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Bound so it can be used directly as setTimeout callback.
        Object.defineProperty(this, "sweep", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function(maxAge) {
                if (maxAge === void 0) maxAge = $6c7b2b897cffba09$export$e901ba0ffe10ba41;
                // cancel timeout so we can force sweep anytime
                clearTimeout(_this.sweepTimeout);
                _this.sweepTimeout = undefined;
                var now = Date.now();
                _this.registrations.forEach(function(registration, token) {
                    if (now - registration.registeredAt >= maxAge) {
                        _this.finalize(registration.value);
                        _this.registrations.delete(token);
                    }
                });
                if (_this.registrations.size > 0) _this.scheduleSweep();
            }
        });
        // Bound so it can be exported directly as clearTimers test utility.
        Object.defineProperty(this, "finalizeAllImmediately", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function() {
                _this.sweep(0);
            }
        });
    }
    // Token is actually required with this impl
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "register", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(target, value, token) {
            this.registrations.set(token, {
                value: value,
                registeredAt: Date.now()
            });
            this.scheduleSweep();
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "unregister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(token) {
            this.registrations.delete(token);
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "scheduleSweep", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (this.sweepTimeout === undefined) this.sweepTimeout = setTimeout(this.sweep, $6c7b2b897cffba09$export$1ae22ce5a82f26b6);
        }
    });
    return TimerBasedFinalizationRegistry;
}();
var $6c7b2b897cffba09$export$da5d55a244964b51 = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : $6c7b2b897cffba09$export$b7a00d372cedeedd;

});


parcelRegister("ck4pA", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gIe59"));

});
parcelRegister("gIe59", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $0323cd20515dc210$export$306c0aa65ff9ec16, (v) => $0323cd20515dc210$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0323cd20515dc210$export$306c0aa65ff9ec16;
"use strict";

var $8NFma = parcelRequire("8NFma");
function $0323cd20515dc210$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0323cd20515dc210$var$k = "function" === typeof Object.is ? Object.is : $0323cd20515dc210$var$h, $0323cd20515dc210$var$l = $8NFma.useState, $0323cd20515dc210$var$m = $8NFma.useEffect, $0323cd20515dc210$var$n = $8NFma.useLayoutEffect, $0323cd20515dc210$var$p = $8NFma.useDebugValue;
function $0323cd20515dc210$var$q(a, b) {
    var d = b(), f = $0323cd20515dc210$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $0323cd20515dc210$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $0323cd20515dc210$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $0323cd20515dc210$var$m(function() {
        $0323cd20515dc210$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $0323cd20515dc210$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $0323cd20515dc210$var$p(d);
    return d;
}
function $0323cd20515dc210$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$0323cd20515dc210$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $0323cd20515dc210$var$t(a, b) {
    return b();
}
var $0323cd20515dc210$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $0323cd20515dc210$var$t : $0323cd20515dc210$var$q;
$0323cd20515dc210$export$306c0aa65ff9ec16 = void 0 !== $8NFma.useSyncExternalStore ? $8NFma.useSyncExternalStore : $0323cd20515dc210$var$u;

});



parcelRegister("O1ETn", function(module, exports) {

$parcel$export(module.exports, "observer", () => $0965f4fad5623863$export$b6ae1bc530f4c149);

var $8NFma = parcelRequire("8NFma");

var $fYQhH = parcelRequire("fYQhH");

var $bVXrj = parcelRequire("bVXrj");
var $0965f4fad5623863$var$_a, $0965f4fad5623863$var$_b;
var $0965f4fad5623863$var$warnObserverOptionsDeprecated = true;
var $0965f4fad5623863$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $0965f4fad5623863$var$isFunctionNameConfigurable = ($0965f4fad5623863$var$_b = ($0965f4fad5623863$var$_a = Object.getOwnPropertyDescriptor(function() {}, "name")) === null || $0965f4fad5623863$var$_a === void 0 ? void 0 : $0965f4fad5623863$var$_a.configurable) !== null && $0965f4fad5623863$var$_b !== void 0 ? $0965f4fad5623863$var$_b : false;
// Using react-is had some issues (and operates on elements, not on types), see #608 / #609
var $0965f4fad5623863$var$ReactForwardRefSymbol = $0965f4fad5623863$var$hasSymbol ? Symbol.for("react.forward_ref") : typeof (0, $8NFma.forwardRef) === "function" && (0, $8NFma.forwardRef)(function(props) {
    return null;
})["$$typeof"];
var $0965f4fad5623863$var$ReactMemoSymbol = $0965f4fad5623863$var$hasSymbol ? Symbol.for("react.memo") : typeof (0, $8NFma.memo) === "function" && (0, $8NFma.memo)(function(props) {
    return null;
})["$$typeof"];
function $0965f4fad5623863$export$b6ae1bc530f4c149(baseComponent, // TODO remove in next major
options) {
    var _a;
    if ($0965f4fad5623863$var$ReactMemoSymbol && baseComponent["$$typeof"] === $0965f4fad5623863$var$ReactMemoSymbol) throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
    // The working of observer is explained step by step in this talk: https://www.youtube.com/watch?v=cPF4iBedoF0&feature=youtu.be&t=1307
    if ((0, $fYQhH.isUsingStaticRendering)()) return baseComponent;
    var useForwardRef = (_a = options === null || options === void 0 ? void 0 : options.forwardRef) !== null && _a !== void 0 ? _a : false;
    var render = baseComponent;
    var baseComponentName = baseComponent.displayName || baseComponent.name;
    // If already wrapped with forwardRef, unwrap,
    // so we can patch render and apply memo
    if ($0965f4fad5623863$var$ReactForwardRefSymbol && baseComponent["$$typeof"] === $0965f4fad5623863$var$ReactForwardRefSymbol) {
        useForwardRef = true;
        render = baseComponent["render"];
        if (typeof render !== "function") throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
    }
    var observerComponent = function(props, ref) {
        return (0, $bVXrj.useObserver)(function() {
            return render(props, ref);
        }, baseComponentName);
    };
    observerComponent.displayName = baseComponent.displayName;
    if ($0965f4fad5623863$var$isFunctionNameConfigurable) Object.defineProperty(observerComponent, "name", {
        value: baseComponent.name,
        writable: true,
        configurable: true
    });
    // Support legacy context: `contextTypes` must be applied before `memo`
    if (baseComponent.contextTypes) observerComponent.contextTypes = baseComponent.contextTypes;
    if (useForwardRef) // `forwardRef` must be applied prior `memo`
    // `forwardRef(observer(cmp))` throws:
    // "forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))"
    observerComponent = (0, $8NFma.forwardRef)(observerComponent);
    // memo; we are not interested in deep updates
    // in props; we assume that if deep objects are changed,
    // this is in observables, which would have been tracked anyway
    observerComponent = (0, $8NFma.memo)(observerComponent);
    $0965f4fad5623863$var$copyStaticProperties(baseComponent, observerComponent);
    return observerComponent;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $0965f4fad5623863$var$hoistBlackList = {
    $$typeof: true,
    render: true,
    compare: true,
    type: true,
    // Don't redefine `displayName`,
    // it's defined as getter-setter pair on `memo` (see #3192).
    displayName: true
};
function $0965f4fad5623863$var$copyStaticProperties(base, target) {
    Object.keys(base).forEach(function(key) {
        if (!$0965f4fad5623863$var$hoistBlackList[key]) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}

});

parcelRegister("dAvow", function(module, exports) {

var $bVXrj = parcelRequire("bVXrj");
function $9e46fd78abbd0231$export$c1cbdee04e18ea8b(_a) {
    var children = _a.children, render = _a.render;
    var component = children || render;
    if (typeof component !== "function") return null;
    return (0, $bVXrj.useObserver)(component);
}
$9e46fd78abbd0231$export$c1cbdee04e18ea8b.displayName = "Observer";
function $9e46fd78abbd0231$var$ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    var hasProp = typeof props[key] === "function";
    var hasExtraProp = typeof props[extraKey] === "function";
    if (hasProp && hasExtraProp) return new Error("MobX Observer: Do not use children and render in the same time in`" + componentName);
    if (hasProp || hasExtraProp) return null;
    return new Error("Invalid prop `" + propFullName + "` of type `" + typeof props[key] + "` supplied to" + " `" + componentName + "`, expected `function`.");
}

});

parcelRegister("i3QX2", function(module, exports) {

$parcel$export(module.exports, "useLocalObservable", () => $d26194cb3ce75bef$export$aa207039f277c5f);

var $2SBKn = parcelRequire("2SBKn");

var $8NFma = parcelRequire("8NFma");
function $d26194cb3ce75bef$export$aa207039f277c5f(initializer, annotations) {
    return (0, $8NFma.useState)(function() {
        return (0, $2SBKn.observable)(initializer(), annotations, {
            autoBind: true
        });
    })[0];
}

});

parcelRegister("2FXrs", function(module, exports) {

var $2SBKn = parcelRequire("2SBKn");

var $8NFma = parcelRequire("8NFma");
parcelRequire("1usTX");

var $fid9Y = parcelRequire("fid9Y");
function $1f2d85005d21427a$export$f5b97ae82d1eeaf3(initializer, current) {
    var source = current && (0, $fid9Y.useAsObservableSource)(current);
    return (0, $8NFma.useState)(function() {
        return (0, $2SBKn.observable)(initializer(source), undefined, {
            autoBind: true
        });
    })[0];
}

});
parcelRegister("fid9Y", function(module, exports) {

$parcel$export(module.exports, "useAsObservableSource", () => $b222beb57ca6d51d$export$e0ded3646391939c);
parcelRequire("1usTX");

var $2SBKn = parcelRequire("2SBKn");

var $8NFma = parcelRequire("8NFma");
function $b222beb57ca6d51d$export$e0ded3646391939c(current) {
    // We're deliberately not using idiomatic destructuring for the hook here.
    // Accessing the state value as an array element prevents TypeScript from generating unnecessary helpers in the resulting code.
    // For further details, please refer to mobxjs/mobx#3842.
    var res = (0, $8NFma.useState)(function() {
        return (0, $2SBKn.observable)(current, {}, {
            deep: false
        });
    })[0];
    (0, $2SBKn.runInAction)(function() {
        Object.assign(res, current);
    });
    return res;
}

});



parcelRegister("gvVvd", function(module, exports) {
"use strict";
var $c05c2566446da3a9$var$__rest = module.exports && module.exports.__rest || function(e, t) {
    var n = {};
    for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var a = 0;
        for(r = Object.getOwnPropertySymbols(e); a < r.length; a++)t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
    }
    return n;
}, $c05c2566446da3a9$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.registerNextDomDrop = module.exports.registerTransformerAttrs = module.exports.setTransformerStyle = void 0;

const $c05c2566446da3a9$var$react_1 = $c05c2566446da3a9$var$__importDefault((parcelRequire("8NFma")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");
var $i3QX2 = parcelRequire("i3QX2");

var $2SBKn = parcelRequire("2SBKn");
parcelRequire("k3LwQ");
var $fBZlQ = parcelRequire("fBZlQ");

const $c05c2566446da3a9$var$use_image_1 = $c05c2566446da3a9$var$__importDefault((parcelRequire("fY5ZF")));

const $c05c2566446da3a9$var$konva_1 = $c05c2566446da3a9$var$__importDefault((parcelRequire("ciNAD")));

const $c05c2566446da3a9$var$element_1 = $c05c2566446da3a9$var$__importDefault((parcelRequire("1wL0c")));

var $agLHp = parcelRequire("agLHp");

var $J29T0 = parcelRequire("J29T0");

var $aCKlx = parcelRequire("aCKlx");

var $8PUQD = parcelRequire("8PUQD");

var $kYy5r = parcelRequire("kYy5r");

var $7ZydS = parcelRequire("7ZydS");

var $gS5ZA = parcelRequire("gS5ZA");

var $3pcZ0 = parcelRequire("3pcZ0");
const $c05c2566446da3a9$var$nativeDrag = $c05c2566446da3a9$var$konva_1.default.DD._drag;
window.removeEventListener("mousemove", $c05c2566446da3a9$var$nativeDrag), $c05c2566446da3a9$var$konva_1.default.DD._drag = function(e) {
    (0, $2SBKn.runInAction)(()=>{
        $c05c2566446da3a9$var$nativeDrag.call(this, e);
    });
}, window.addEventListener("mousemove", $c05c2566446da3a9$var$konva_1.default.DD._drag);
const $c05c2566446da3a9$var$rotateFillGroup = new $c05c2566446da3a9$var$konva_1.default.Group, $c05c2566446da3a9$var$rotateFillSize = 20;
$c05c2566446da3a9$var$rotateFillGroup.add(new $c05c2566446da3a9$var$konva_1.default.Rect({
    width: 20,
    height: 20,
    fill: "white"
})), $c05c2566446da3a9$var$rotateFillGroup.add(new $c05c2566446da3a9$var$konva_1.default.Path({
    scaleX: 20 / 24,
    scaleY: 20 / 24,
    data: "M4.98313549,11.0001422 C5.49589839,10.9914935 5.92501998,11.3703506 5.99116425,11.8666444 L5.99985778,11.9831355 L6.00348884,12.2068855 C6.11245031,15.4321748 8.76323537,17.9999971 11.9999971,17.9999971 C12.1869612,17.9999971 12.3726725,17.9914753 12.5567465,17.9745765 L12.2928932,17.7071068 C11.9023689,17.3165825 11.9023689,16.6834175 12.2928932,16.2928932 C12.6834175,15.9023689 13.3165825,15.9023689 13.7071068,16.2928932 L15.7071068,18.2928932 C16.0976311,18.6834175 16.0976311,19.3165825 15.7071068,19.7071068 L13.7071068,21.7071068 C13.3165825,22.0976311 12.6834175,22.0976311 12.2928932,21.7071068 C11.9023689,21.3165825 11.9023689,20.6834175 12.2928932,20.2928932 L12.6111505,19.9769552 C12.4086045,19.9922816 12.2047796,19.9999971 11.9999971,19.9999971 C7.7687005,19.9999971 4.28886152,16.7094374 4.01666425,12.5105203 L4.00420123,12.2575143 L4.00014222,12.0168645 C3.9908282,11.4646583 4.43092928,11.0094562 4.98313549,11.0001422 Z M11.7071068,2.29289322 C12.0675907,2.65337718 12.0953203,3.22060824 11.7902954,3.61289944 L11.7071068,3.70710678 L11.3891629,4.0230186 C11.5916051,4.00770767 11.7953244,4 12,4 C16.418278,4 20,7.581722 20,12 C20,12.5522847 19.5522847,13 19,13 C18.4477153,13 18,12.5522847 18,12 C18,8.6862915 15.3137085,6 12,6 C11.8129339,6 11.6271216,6.00853145 11.4429483,6.02544919 L11.7071068,6.29289322 C12.0976311,6.68341751 12.0976311,7.31658249 11.7071068,7.70710678 C11.3466228,8.06759074 10.7793918,8.09532028 10.3871006,7.79029539 L10.2928932,7.70710678 L8.29289322,5.70710678 C7.93240926,5.34662282 7.90467972,4.77939176 8.20970461,4.38710056 L8.29289322,4.29289322 L10.2928932,2.29289322 C10.6834175,1.90236893 11.3165825,1.90236893 11.7071068,2.29289322 Z",
    fill: "black"
}));
const $c05c2566446da3a9$var$rotaterFill = $c05c2566446da3a9$var$rotateFillGroup.toCanvas({
    pixelRatio: 2,
    width: 20,
    height: 20
}), $c05c2566446da3a9$var$TRANSFORMER_STYLE = {
    enabledAnchors: [
        "top-left",
        "top-center",
        "top-right",
        "middle-left",
        "bottom-left",
        "bottom-right",
        "bottom-center",
        "middle-right"
    ],
    borderEnabled: !0,
    rotateEnabled: !0,
    rotationSnaps: [
        0,
        45,
        90,
        135,
        180,
        225,
        270,
        315
    ],
    ignoreStroke: !0,
    flipEnabled: !1,
    anchorStrokeWidth: 2,
    borderStrokeWidth: 2,
    rotateAnchorOffset: 30,
    anchorStyleFunc: (e)=>{
        if (e.hasName("rotater")) {
            const t = 20;
            e.setAttrs({
                width: t,
                height: t,
                cornerRadius: t / 2,
                offsetX: t / 2,
                offsetY: t / 2,
                fillPatternImage: $c05c2566446da3a9$var$rotaterFill,
                fillPatternScaleX: t / 20 / 2,
                fillPatternScaleY: t / 20 / 2,
                fillPriority: "pattern",
                fillPatternRepeat: "no-repeat"
            });
        }
    }
}, $c05c2566446da3a9$var$setTransformerStyle = (e)=>{
    Object.assign($c05c2566446da3a9$var$TRANSFORMER_STYLE, e);
};
module.exports.setTransformerStyle = $c05c2566446da3a9$var$setTransformerStyle;
const $c05c2566446da3a9$var$transformerAttributes = {
    text: {
        enabledAnchors: [
            "top-left",
            "top-right",
            "middle-left",
            "bottom-left",
            "bottom-right",
            "middle-right"
        ]
    },
    svg: {
        enabledAnchors: [
            "top-left",
            "top-right",
            "bottom-left",
            "bottom-right"
        ]
    },
    line: {
        enabledAnchors: [],
        borderEnabled: !1,
        rotateEnabled: !1
    },
    image: {
        enabledAnchors: [
            "top-left",
            "top-right",
            "bottom-left",
            "bottom-right"
        ]
    },
    many: {
        enabledAnchors: [
            "top-left",
            "top-right",
            "bottom-left",
            "bottom-right"
        ]
    },
    group: {
        enabledAnchors: [
            "top-left",
            "top-right",
            "bottom-left",
            "bottom-right"
        ]
    }
};
function $c05c2566446da3a9$var$registerTransformerAttrs(e, t) {
    $c05c2566446da3a9$var$transformerAttributes[e] = $c05c2566446da3a9$var$transformerAttributes[e] || t, Object.assign($c05c2566446da3a9$var$transformerAttributes[e], t);
}
module.exports.registerTransformerAttrs = $c05c2566446da3a9$var$registerTransformerAttrs;
const $c05c2566446da3a9$var$Background = (e)=>$c05c2566446da3a9$var$react_1.default.createElement($fBZlQ.Rect, Object.assign({}, e, {
        preventDefault: !1
    })), $c05c2566446da3a9$var$ImageBackground = (e)=>{
    var { url: t } = e, n = $c05c2566446da3a9$var$__rest(e, [
        "url"
    ]);
    const [r, a] = (0, $c05c2566446da3a9$var$use_image_1.default)(t, "anonymous"), o = r ? (0, $aCKlx.getCrop)(r, {
        width: n.width,
        height: n.height
    }, "center-middle") : {};
    return (0, $J29T0.useImageLoader)(a, "background"), $c05c2566446da3a9$var$react_1.default.createElement($fBZlQ.Image, Object.assign({
        image: r
    }, n, o));
}, $c05c2566446da3a9$var$ColorBackground = (e)=>$c05c2566446da3a9$var$react_1.default.createElement($fBZlQ.Rect, Object.assign({}, e)), $c05c2566446da3a9$var$PageBackground = (e)=>{
    const { background: t, scale: n, borderColor: r } = e, a = $c05c2566446da3a9$var$__rest(e, [
        "background",
        "scale",
        "borderColor"
    ]), o = $c05c2566446da3a9$var$react_1.default.useMemo(()=>!!$c05c2566446da3a9$var$konva_1.default.Util.colorToRGBA(t), [
        t
    ]), i = $c05c2566446da3a9$var$react_1.default.useMemo(()=>{
        const e = document.createElement("canvas"), t = 30;
        e.width = 60, e.height = 60;
        const n = e.getContext("2d");
        return n && (n.fillStyle = "black", n.fillRect(t, 0, t, t), n.fillRect(0, t, t, t)), e;
    }, []);
    return $c05c2566446da3a9$var$react_1.default.createElement($c05c2566446da3a9$var$react_1.default.Fragment, null, $c05c2566446da3a9$var$react_1.default.createElement($fBZlQ.Rect, Object.assign({
        fillPatternImage: i
    }, a, {
        opacity: .1,
        hideInExport: !0
    })), o ? $c05c2566446da3a9$var$react_1.default.createElement($c05c2566446da3a9$var$ColorBackground, Object.assign({
        fill: t
    }, a)) : $c05c2566446da3a9$var$react_1.default.createElement($c05c2566446da3a9$var$ImageBackground, Object.assign({
        url: t
    }, a)));
}, $c05c2566446da3a9$var$Selection = (0, $O1ETn.observer)(({ selection: e })=>e.visible ? $c05c2566446da3a9$var$react_1.default.createElement($fBZlQ.Rect, {
        name: "selection",
        x: Math.min(e.x1, e.x2),
        y: Math.min(e.y1, e.y2),
        width: Math.abs(e.x1 - e.x2),
        height: Math.abs(e.y1 - e.y2),
        fill: "rgba(0, 161, 255, 0.3)"
    }) : null), $c05c2566446da3a9$var$TransformLabels = (0, $O1ETn.observer)(({ x: e, y: t, width: n, height: r, rotation: a, anchor: o, store: i })=>{
    const l = (0, $kYy5r.getClientRect)({
        x: e,
        y: t,
        width: n,
        height: r,
        rotation: $c05c2566446da3a9$var$konva_1.default.Util.radToDeg(a)
    });
    if (void 0 === o) return null;
    const c = (r / 2 + 70) * Math.cos(a - Math.PI / 2), s = (r / 2 + 70) * Math.sin(a - Math.PI / 2), d = (0, $7ZydS.pxToUnitRounded)({
        unit: i.unit,
        dpi: i.dpi,
        px: n / i.scale,
        precious: "px" === i.unit ? 0 : 1
    }) + " x " + (0, $7ZydS.pxToUnitRounded)({
        unit: i.unit,
        dpi: i.dpi,
        px: r / i.scale,
        precious: "px" === i.unit ? 0 : 1
    }) + ("px" === i.unit ? "" : " " + i.unit);
    return $c05c2566446da3a9$var$react_1.default.createElement($c05c2566446da3a9$var$react_1.default.Fragment, null, $c05c2566446da3a9$var$react_1.default.createElement($fBZlQ.Label, {
        x: (l.minX + l.maxX) / 2 + c,
        y: (l.minY + l.maxY) / 2 + s,
        offsetX: 14,
        offsetY: 14,
        visible: "rotater" === o
    }, $c05c2566446da3a9$var$react_1.default.createElement($fBZlQ.Tag, {
        cornerRadius: 5,
        fill: "rgb(0, 161, 255)"
    }), $c05c2566446da3a9$var$react_1.default.createElement($fBZlQ.Text, {
        align: "center",
        verticalAlign: "middle",
        fill: "white",
        padding: 8,
        text: Math.round($c05c2566446da3a9$var$konva_1.default.Util.radToDeg(a)).toString() + "\xb0"
    })), $c05c2566446da3a9$var$react_1.default.createElement($fBZlQ.Label, {
        x: (l.minX + l.maxX) / 2,
        y: l.maxY + 20,
        visible: "rotater" !== o
    }, $c05c2566446da3a9$var$react_1.default.createElement($fBZlQ.Tag, {
        cornerRadius: 5,
        fill: "rgb(0, 161, 255)",
        pointerDirection: "up",
        pointerHeight: 0,
        pointerWidth: 0
    }), $c05c2566446da3a9$var$react_1.default.createElement($fBZlQ.Text, {
        align: "center",
        verticalAlign: "middle",
        fill: "white",
        padding: 8,
        text: d
    })));
}), $c05c2566446da3a9$var$Elements = (0, $O1ETn.observer)(({ elements: e, store: t })=>{
    const n = e.filter((e)=>e.alwaysOnTop), r = e.filter((e)=>!e.alwaysOnTop).concat(n);
    return $c05c2566446da3a9$var$react_1.default.createElement($c05c2566446da3a9$var$react_1.default.Fragment, null, r.map((e)=>$c05c2566446da3a9$var$react_1.default.createElement($c05c2566446da3a9$var$element_1.default, {
            key: e.id,
            store: t,
            element: e,
            onClick: ()=>{
                console.warn("Polotno warning: onClick callback is deprecated. Just stop using it. Polotno will do selection automatically.");
            }
        })));
});
let $c05c2566446da3a9$var$onDomDrop = null;
const $c05c2566446da3a9$var$registerNextDomDrop = (e)=>{
    $c05c2566446da3a9$var$onDomDrop = e;
};
module.exports.registerNextDomDrop = $c05c2566446da3a9$var$registerNextDomDrop, module.exports.default = (0, $O1ETn.observer)(({ store: e, page: t, width: n, height: r, pageControlsEnabled: a, backColor: o, pageBorderColor: i, activePageBorderColor: l, components: c, bleedColor: s, altCloneEnabled: d })=>{
    const u = e.bleedVisible ? t.bleed : 0, m = t.computedWidth + 2 * u, g = t.computedHeight + 2 * u, h = (n - m * e.scale) / 2, _ = (r - g * e.scale) / 2, f = $c05c2566446da3a9$var$react_1.default.useRef(null), p = $c05c2566446da3a9$var$react_1.default.useRef(null), b = $c05c2566446da3a9$var$react_1.default.useRef(null), x = null == a || a, [v, E] = $c05c2566446da3a9$var$react_1.default.useState(null), [y, k] = $c05c2566446da3a9$var$react_1.default.useState({}), w = e.selectedElements.find((e)=>e._cropModeEnabled), S = e.selectedShapes.filter((e)=>!e.resizable).length > 0, Y = e.selectedShapes.filter((e)=>!e.draggable).length > 0, D = e.selectedElements.filter((e)=>!e.visible).length > 0;
    $c05c2566446da3a9$var$react_1.default.useLayoutEffect(()=>{
        var t, n, r;
        if (!f.current) return;
        const a = f.current.getStage(), o = e.selectedShapes.map((e)=>e._cropModeEnabled ? null : a.findOne("#" + e.id)).filter((e)=>e), i = 1 === e.selectedElements.length && (null === (t = e.selectedElements[0]) || void 0 === t ? void 0 : t.type) || "many";
        $c05c2566446da3a9$var$transformerAttributes[i] ? (f.current.setAttrs(Object.assign(Object.assign({}, $c05c2566446da3a9$var$TRANSFORMER_STYLE), $c05c2566446da3a9$var$transformerAttributes[i])), "svg" !== i && "image" !== i || e.selectedElements[0].keepRatio || f.current.setAttrs({
            enabledAnchors: $c05c2566446da3a9$var$TRANSFORMER_STYLE.enabledAnchors
        }), "text" === i && $gS5ZA.flags.textVerticalResizeEnabled && f.current.setAttrs({
            enabledAnchors: null === (n = $c05c2566446da3a9$var$transformerAttributes.text.enabledAnchors) || void 0 === n ? void 0 : n.concat([
                "bottom-center"
            ])
        })) : f.current.setAttrs($c05c2566446da3a9$var$TRANSFORMER_STYLE), S && f.current.enabledAnchors([]), Y && f.current.rotateEnabled(!1);
        o.find((e)=>null == e ? void 0 : e.isDragging()) && o.forEach((e)=>{
            e.isDragging() || null == e || e.startDrag();
        }), f.current.nodes(o), null === (r = f.current.getLayer()) || void 0 === r || r.batchDraw();
    }, [
        e.selectedElements,
        w,
        S,
        D,
        Y
    ]);
    const A = (0, $i3QX2.useLocalObservable)(()=>({
            visible: !1,
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 0
        })), R = $c05c2566446da3a9$var$react_1.default.useRef(!1), T = (0, $3pcZ0.useMobile)(), X = (0, $2SBKn.action)((e)=>{
        var t, n;
        if (T) return;
        R.current = !1;
        const r = e.target.findAncestor(".elements-container"), a = e.target.findAncestor("Transformer"), o = e.target.findAncestor(".page-abs-container");
        if (r || a || o) return;
        const i = null === (t = e.target.getStage()) || void 0 === t ? void 0 : t.getPointerPosition();
        i && (A.visible = !0, A.x1 = i.x, A.y1 = i.y, A.x2 = i.x, A.y2 = i.y, (null === (n = e.target.getStage()) || void 0 === n ? void 0 : n.getPointersPositions().length) >= 2 && (A.visible = !1));
    });
    $c05c2566446da3a9$var$react_1.default.useEffect(()=>{
        const t = (0, $2SBKn.action)((e)=>{
            var t, n;
            if (!A.visible) return;
            null === (t = p.current) || void 0 === t || t.setPointersPositions(e);
            let r = (null === (n = p.current) || void 0 === n ? void 0 : n.getPointerPosition()) || {
                x: A.x2,
                y: A.y2
            };
            A.x2 = r.x, A.y2 = r.y;
        }), n = (0, $2SBKn.action)(()=>{
            if (!A.visible) return;
            if (!p.current) return;
            const t = p.current.findOne(".selection"), n = t ? t.getClientRect() : {
                width: 0,
                height: 0,
                x: 0,
                y: 0
            };
            if (n.width && n.height) {
                const t = [];
                p.current.find(".element").forEach((r)=>{
                    const a = r.getClientRect(), o = e.getElementById(r.id()), i = null == o ? void 0 : o.draggable, l = null == o ? void 0 : o.selectable;
                    $c05c2566446da3a9$var$konva_1.default.Util.haveIntersection(n, a) && i && l && t.push(o.top.id);
                });
                const r = [
                    ...new Set(t)
                ];
                e.selectElements(r);
            }
            A.visible = !1, R.current = !0;
        });
        return window.addEventListener("mousemove", t), window.addEventListener("touchmove", t), window.addEventListener("mouseup", n), window.addEventListener("touchend", n), ()=>{
            window.removeEventListener("mousemove", t), window.removeEventListener("touchmove", t), window.removeEventListener("mouseup", n), window.removeEventListener("touchend", n);
        };
    }, []);
    const C = (n)=>{
        if (e.activePage !== t && t.select(), R.current) return;
        const r = n.evt.ctrlKey || n.evt.metaKey || n.evt.shiftKey, a = n.target.findAncestor(".elements-container"), o = n.target.findAncestor(".page-abs-container"), i = n.target.findAncestor("Transformer");
        if (!(r || a || i || o)) return void e.selectElements([]);
        const l = n.target.findAncestor(".element", !0), c = e.getElementById(null == l ? void 0 : l.id()), s = null == c ? void 0 : c.top, d = null == s ? void 0 : s.id, u = e.selectedElementsIds.indexOf(d) >= 0;
        d && r && !u ? e.selectElements(e.selectedElementsIds.concat([
            d
        ])) : d && r && u ? e.selectElements(e.selectedElementsIds.filter((e)=>e !== d)) : !d || r || u || e.selectElements([
            d
        ]);
    };
    (0, $agLHp.useSnap)(f);
    const L = e.activePage === t, O = null == c ? void 0 : c.PageControls, P = null == c ? void 0 : c.Tooltip, M = 1 / e.scale, I = 0 / e.scale;
    return $c05c2566446da3a9$var$react_1.default.createElement("div", {
        ref: b,
        onDragOver: (e)=>e.preventDefault(),
        onDrop: (n)=>{
            if (n.preventDefault(), !p.current) return;
            p.current.setPointersPositions(n);
            const r = p.current.findOne(".elements-container").getRelativePointerPosition(), a = p.current.getPointerPosition(), o = p.current.getAllIntersections(a).map((e)=>e.findAncestor(".element", !0)).filter(Boolean), i = [
                ...new Set(o.reverse())
            ].map((t)=>e.getElementById(t.id())), l = i[0];
            $c05c2566446da3a9$var$onDomDrop && ($c05c2566446da3a9$var$onDomDrop(r, l, {
                elements: i,
                page: t
            }), $c05c2566446da3a9$var$onDomDrop = null);
        },
        style: {
            position: "relative",
            width: n + "px"
        },
        className: "polotno-page-container" + (L ? " active-page" : "")
    }, $c05c2566446da3a9$var$react_1.default.createElement($fBZlQ.Stage, {
        ref: p,
        width: Math.min(n, 4 * window.innerWidth),
        height: Math.min(r, 4 * window.innerHeight),
        onClick: C,
        onTap: C,
        onMouseDown: X,
        onMouseMove: (n)=>{
            if (!n.evt.altKey && v) return void E(null);
            if (!n.evt.altKey) return;
            const r = n.target.findAncestor(".element", !0), a = null == r ? void 0 : r.id();
            if (!e.selectedElements[0]) return;
            if (e.selectedElementsIds.includes(a)) return;
            const o = (0, $kYy5r.getTotalClientRect)(e.selectedShapes), i = a ? e.getElementById(a) : {
                x: 0,
                y: 0,
                width: t.computedWidth,
                height: t.computedHeight,
                rotation: 0
            }, l = (0, $kYy5r.getClientRect)(i), c = [];
            o.minX > l.maxX && c.push({
                distance: o.minX - l.maxX,
                box1: o,
                box2: l,
                points: [
                    {
                        x: o.minX,
                        y: o.minY + o.height / 2
                    },
                    {
                        x: l.maxX,
                        y: o.minY + o.height / 2
                    },
                    {
                        x: l.maxX,
                        y: l.minY + l.height / 2
                    }
                ]
            }), o.maxX < l.minX && c.push({
                distance: l.minX - o.maxX,
                box1: o,
                box2: l,
                points: [
                    {
                        x: o.maxX,
                        y: o.minY + o.height / 2
                    },
                    {
                        x: l.minX,
                        y: o.minY + o.height / 2
                    },
                    {
                        x: l.minX,
                        y: l.minY + l.height / 2
                    }
                ]
            }), o.minY > l.maxY && c.push({
                box1: o,
                box2: l,
                distance: o.minY - l.maxY,
                points: [
                    {
                        x: o.minX + o.width / 2,
                        y: o.minY
                    },
                    {
                        x: o.minX + o.width / 2,
                        y: l.maxY
                    },
                    {
                        x: l.minX + l.width / 2,
                        y: l.maxY
                    }
                ]
            }), o.maxY < l.minY && c.push({
                box1: o,
                box2: l,
                distance: l.minY - o.maxY,
                points: [
                    {
                        x: o.minX + o.width / 2,
                        y: o.maxY
                    },
                    {
                        x: o.minX + o.width / 2,
                        y: l.minY
                    },
                    {
                        x: l.minX + l.width / 2,
                        y: l.minY
                    }
                ]
            });
            o.minX >= l.minX && o.maxX <= l.maxX && o.minY >= l.minY && o.maxY <= l.maxY && (c.push({
                distance: o.minX - l.minX,
                box1: o,
                box2: l,
                points: [
                    {
                        x: o.minX,
                        y: o.minY + o.height / 2
                    },
                    {
                        x: l.minX,
                        y: o.minY + o.height / 2
                    },
                    {
                        x: l.minX,
                        y: l.minY + l.height / 2
                    }
                ]
            }), c.push({
                distance: l.maxX - o.maxX,
                box1: o,
                box2: l,
                points: [
                    {
                        x: o.maxX,
                        y: o.minY + o.height / 2
                    },
                    {
                        x: l.maxX,
                        y: o.minY + o.height / 2
                    },
                    {
                        x: l.maxX,
                        y: l.minY + l.height / 2
                    }
                ]
            }), c.push({
                box1: o,
                box2: l,
                distance: o.minY - l.minY,
                points: [
                    {
                        x: o.minX + o.width / 2,
                        y: o.minY
                    },
                    {
                        x: o.minX + o.width / 2,
                        y: l.minY
                    },
                    {
                        x: l.minX + l.width / 2,
                        y: l.minY
                    }
                ]
            }), c.push({
                box1: o,
                box2: l,
                distance: l.maxY - o.maxY,
                points: [
                    {
                        x: o.minX + o.width / 2,
                        y: o.maxY
                    },
                    {
                        x: o.minX + o.width / 2,
                        y: l.maxY
                    },
                    {
                        x: l.minX + l.width / 2,
                        y: l.maxY
                    }
                ]
            })), JSON.stringify(v) !== JSON.stringify(c) && E(c);
        },
        onTouchStart: X,
        onDragStart: (t)=>{
            var n;
            const r = t.target.findAncestor(".element", !0);
            if (r) {
                const a = e.getElementById(null == r ? void 0 : r.id()), o = null == a ? void 0 : a.top, i = null == o ? void 0 : o.id;
                !(e.selectedElementsIds.indexOf(i) >= 0) && i && (e.selectElements([
                    i
                ]), t.target.stopDrag(), t.target.startDrag(t), null === (n = f.current) || void 0 === n || n.startDrag(t));
            }
            v && E(null);
        },
        pageId: t.id,
        style: {
            position: "relative"
        }
    }, $c05c2566446da3a9$var$react_1.default.createElement($fBZlQ.Layer, null, $c05c2566446da3a9$var$react_1.default.createElement($c05c2566446da3a9$var$Background, {
        width: n,
        height: r,
        fill: o
    }), $c05c2566446da3a9$var$react_1.default.createElement($fBZlQ.Group, {
        x: h,
        y: _,
        scaleX: e.scale,
        scaleY: e.scale,
        name: "page-container"
    }, $c05c2566446da3a9$var$react_1.default.createElement($fBZlQ.Group, {
        name: "page-container-2"
    }, $c05c2566446da3a9$var$react_1.default.createElement($fBZlQ.Group, {
        name: "page-background-group",
        x: u,
        y: u
    }, $c05c2566446da3a9$var$react_1.default.createElement($c05c2566446da3a9$var$PageBackground, {
        x: -t.bleed,
        y: -t.bleed,
        width: t.computedWidth + 2 * t.bleed,
        height: t.computedHeight + 2 * t.bleed,
        background: t.background,
        shadowBlur: 10,
        shadowColor: "lightgrey",
        name: "page-background",
        preventDefault: !1,
        scale: e.scale
    })), $c05c2566446da3a9$var$react_1.default.createElement($fBZlQ.Group, {
        x: u,
        y: u,
        name: "elements-container",
        listening: !e.isPlaying
    }, $c05c2566446da3a9$var$react_1.default.createElement($fBZlQ.Rect, {
        name: "elements-area",
        width: t.computedWidth,
        height: t.computedHeight,
        listening: !1
    }), $c05c2566446da3a9$var$react_1.default.createElement($c05c2566446da3a9$var$Elements, {
        elements: t.children,
        store: e
    })), $c05c2566446da3a9$var$react_1.default.createElement($fBZlQ.Rect, {
        stroke: s,
        name: "bleed",
        strokeWidth: t.bleed,
        x: t.bleed / 2,
        y: t.bleed / 2,
        width: t.computedWidth + t.bleed,
        height: t.computedHeight + t.bleed,
        listening: !1,
        visible: t.bleed > 0 && e.bleedVisible,
        hideInExport: !0
    }))), $c05c2566446da3a9$var$react_1.default.createElement($fBZlQ.Line, {
        name: "workspace-background",
        points: [
            0,
            0,
            n,
            0,
            n,
            r,
            0,
            r,
            0,
            0,
            h,
            _,
            h,
            r - _,
            n - h,
            r - _,
            n - h,
            _,
            h,
            _
        ],
        listening: !1,
        closed: !0,
        fill: o
    }), $c05c2566446da3a9$var$react_1.default.createElement($fBZlQ.Group, {
        x: h,
        y: _,
        scaleX: e.scale,
        scaleY: e.scale
    }, $c05c2566446da3a9$var$react_1.default.createElement($fBZlQ.Rect, {
        name: "page-highlight",
        hideInExport: !0,
        x: -M / 2 - I,
        y: -M / 2 - I,
        width: m + M + 2 * I,
        height: g + M + 2 * I,
        stroke: L && e.pages.length > 1 ? l : i,
        strokeWidth: 2,
        listening: !1,
        strokeScaleEnabled: !1
    })), $c05c2566446da3a9$var$react_1.default.createElement($fBZlQ.Group, {
        x: h + u * e.scale,
        y: _ + u * e.scale,
        scaleX: e.scale,
        scaleY: e.scale,
        name: "page-abs-container"
    }, $c05c2566446da3a9$var$react_1.default.createElement($fBZlQ.Transformer, {
        ref: f,
        onDragStart: (n)=>{
            var r;
            (null === (r = n.evt) || void 0 === r ? void 0 : r.altKey) && d && e.selectedElements.forEach((e)=>{
                const n = e.clone({}, {
                    skipSelect: !0
                }), r = t.children.indexOf(e);
                t.setElementZIndex(n.id, r);
            }), e.history.startTransaction();
        },
        onDragEnd: ()=>{
            e.history.endTransaction();
        },
        onTransformStart: ()=>{
            e.history.startTransaction();
        },
        boundBoxFunc: (e, t)=>{
            const n = Math.abs(t.width) < 1 || Math.abs(t.height) < 1, r = Math.abs(e.width) < 1 || Math.abs(e.height) < 1;
            return n && !r ? e : t;
        },
        onTransform: (e)=>{
            var t, n;
            const r = f.current.nodes(), a = r[r.length - 1];
            if (!(e.target === a)) return;
            const o = null === (t = f.current) || void 0 === t ? void 0 : t.__getNodeRect(), i = null === (n = f.current) || void 0 === n ? void 0 : n.getActiveAnchor();
            k({
                anchor: i,
                x: o.x,
                y: o.y,
                rotation: o.rotation,
                width: o.width,
                height: o.height
            });
        },
        onTransformEnd: (t)=>{
            k({}), e.history.endTransaction();
        },
        visible: !e.isPlaying
    }), v && v.map(({ points: t, distance: n, box1: r, box2: a }, o)=>$c05c2566446da3a9$var$react_1.default.createElement($fBZlQ.Group, {
            name: "distances-container",
            hideInExport: !0,
            key: o,
            listening: !1
        }, $c05c2566446da3a9$var$react_1.default.createElement($fBZlQ.Rect, Object.assign({}, r, {
            stroke: "rgb(0, 161, 255)",
            strokeWidth: 1,
            strokeScaleEnabled: !1
        })), $c05c2566446da3a9$var$react_1.default.createElement($fBZlQ.Rect, Object.assign({}, a, {
            stroke: "rgb(0, 161, 255)",
            strokeWidth: 1,
            strokeScaleEnabled: !1
        })), $c05c2566446da3a9$var$react_1.default.createElement($fBZlQ.Line, {
            points: [
                t[0].x,
                t[0].y,
                t[1].x,
                t[1].y
            ],
            stroke: "rgb(0, 161, 255)",
            strokeWidth: 1,
            strokeScaleEnabled: !1
        }), $c05c2566446da3a9$var$react_1.default.createElement($fBZlQ.Line, {
            points: [
                t[1].x,
                t[1].y,
                t[2].x,
                t[2].y
            ],
            stroke: "rgb(0, 161, 255)",
            strokeWidth: 1,
            strokeScaleEnabled: !1
        }), $c05c2566446da3a9$var$react_1.default.createElement($fBZlQ.Label, {
            x: (t[0].x + t[1].x) / 2,
            y: (t[0].y + t[1].y) / 2,
            offsetY: -10,
            scaleX: 1 / e.scale,
            scaleY: 1 / e.scale
        }, $c05c2566446da3a9$var$react_1.default.createElement($fBZlQ.Tag, {
            cornerRadius: 5,
            fill: "rgb(0, 161, 255)",
            pointerDirection: "down"
        }), $c05c2566446da3a9$var$react_1.default.createElement($fBZlQ.Text, {
            align: "center",
            verticalAlign: "middle",
            fill: "white",
            padding: 5,
            text: (0, $7ZydS.pxToUnitString)({
                unit: e.unit,
                dpi: e.dpi,
                px: n
            })
        })))), t._rendering && $c05c2566446da3a9$var$react_1.default.createElement($fBZlQ.Group, null, $c05c2566446da3a9$var$react_1.default.createElement($fBZlQ.Rect, {
        width: m,
        height: g,
        fill: "rgba(255,255,255,0.9)"
    }), $c05c2566446da3a9$var$react_1.default.createElement($fBZlQ.Text, {
        text: "Rendering...",
        fontSize: 60,
        width: m,
        height: g,
        align: "center",
        verticalAlign: "middle"
    })), P && $c05c2566446da3a9$var$react_1.default.createElement(P, {
        components: c,
        store: e,
        page: t,
        stageRef: p
    })), $c05c2566446da3a9$var$react_1.default.createElement($c05c2566446da3a9$var$TransformLabels, Object.assign({}, y, {
        store: e
    })), $c05c2566446da3a9$var$react_1.default.createElement($c05c2566446da3a9$var$Selection, {
        selection: A
    }), $8PUQD.shouldShowCredit.value && $c05c2566446da3a9$var$react_1.default.createElement($fBZlQ.Text, {
        text: "Powered by polotno.com",
        fontSize: 14,
        fill: "rgba(0,0,0,0.6)",
        x: n - 170,
        y: r - 18,
        onMouseEnter: (e)=>{
            e.target.getStage().container().style.cursor = "pointer";
        },
        onMouseLeave: (e)=>{
            e.target.getStage().container().style.cursor = "";
        },
        onTouchStart: (e)=>{
            e.cancelBubble = !0;
        },
        onMouseDown: (e)=>{
            e.cancelBubble = !0;
        },
        onClick: ()=>{
            window.open("https://polotno.com");
        },
        onTap: ()=>{
            window.open("https://polotno.com");
        }
    }), $c05c2566446da3a9$var$react_1.default.createElement($fBZlQ.Group, {
        name: "line-guides"
    }))), x && L && O && $c05c2566446da3a9$var$react_1.default.createElement(O, {
        store: e,
        page: t,
        xPadding: h,
        yPadding: _
    }));
});

});
parcelRegister("k3LwQ", function(module, exports) {
$parcel$export(module.exports, "Arc", () => (parcelRequire("fBZlQ")).Arc);
$parcel$export(module.exports, "Circle", () => (parcelRequire("fBZlQ")).Circle);
$parcel$export(module.exports, "Group", () => (parcelRequire("fBZlQ")).Group);
$parcel$export(module.exports, "Image", () => (parcelRequire("fBZlQ")).Image);
$parcel$export(module.exports, "Label", () => (parcelRequire("fBZlQ")).Label);
$parcel$export(module.exports, "Layer", () => (parcelRequire("fBZlQ")).Layer);
$parcel$export(module.exports, "Line", () => (parcelRequire("fBZlQ")).Line);
$parcel$export(module.exports, "Path", () => (parcelRequire("fBZlQ")).Path);
$parcel$export(module.exports, "Rect", () => (parcelRequire("fBZlQ")).Rect);
$parcel$export(module.exports, "Stage", () => (parcelRequire("fBZlQ")).Stage);
$parcel$export(module.exports, "Tag", () => (parcelRequire("fBZlQ")).Tag);
$parcel$export(module.exports, "Text", () => (parcelRequire("fBZlQ")).Text);
$parcel$export(module.exports, "Transformer", () => (parcelRequire("fBZlQ")).Transformer);
/**
 * Based on ReactArt.js
 * Copyright (c) 2017-present Lavrenov Anton.
 * All rights reserved.
 *
 * MIT
 */ parcelRequire("ciNAD");
parcelRequire("fBZlQ");
"use strict";

});
parcelRegister("ciNAD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $amkLH = parcelRequire("amkLH");
module.exports = $amkLH.Konva;

});
parcelRegister("amkLH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Konva = void 0;

var $3rme3 = parcelRequire("3rme3");

var $22qqi = parcelRequire("22qqi");

var $5NOpv = parcelRequire("5NOpv");

var $bVmKg = parcelRequire("bVmKg");

var $coMIK = parcelRequire("coMIK");

var $bGp9B = parcelRequire("bGp9B");

var $x9Ses = parcelRequire("x9Ses");

var $ht0WH = parcelRequire("ht0WH");

var $7s2S9 = parcelRequire("7s2S9");

var $frrTX = parcelRequire("frrTX");

var $fNWX2 = parcelRequire("fNWX2");

var $8hR4I = parcelRequire("8hR4I");

var $dY8gg = parcelRequire("dY8gg");

var $lG4Ld = parcelRequire("lG4Ld");

var $aepJ3 = parcelRequire("aepJ3");

var $iKGXd = parcelRequire("iKGXd");

var $aY3GY = parcelRequire("aY3GY");

var $6NrOY = parcelRequire("6NrOY");

var $kd1un = parcelRequire("kd1un");

var $gQWeB = parcelRequire("gQWeB");

var $1aAid = parcelRequire("1aAid");

var $5iinf = parcelRequire("5iinf");

var $6skQr = parcelRequire("6skQr");

var $kBAEq = parcelRequire("kBAEq");

var $iqULT = parcelRequire("iqULT");

var $aBbcJ = parcelRequire("aBbcJ");

var $inCrd = parcelRequire("inCrd");

var $8YRg7 = parcelRequire("8YRg7");

var $f4uhT = parcelRequire("f4uhT");

var $nXPb8 = parcelRequire("nXPb8");

var $ez1tv = parcelRequire("ez1tv");

var $54oRz = parcelRequire("54oRz");

var $awjyq = parcelRequire("awjyq");

var $jy4HT = parcelRequire("jy4HT");

var $aSL2k = parcelRequire("aSL2k");

var $irVuX = parcelRequire("irVuX");

var $fzRK8 = parcelRequire("fzRK8");
module.exports.Konva = $3rme3.Konva.Util._assign($3rme3.Konva, {
    Arc: $22qqi.Arc,
    Arrow: $5NOpv.Arrow,
    Circle: $bVmKg.Circle,
    Ellipse: $coMIK.Ellipse,
    Image: $bGp9B.Image,
    Label: $x9Ses.Label,
    Tag: $x9Ses.Tag,
    Line: $ht0WH.Line,
    Path: $7s2S9.Path,
    Rect: $frrTX.Rect,
    RegularPolygon: $fNWX2.RegularPolygon,
    Ring: $8hR4I.Ring,
    Sprite: $dY8gg.Sprite,
    Star: $lG4Ld.Star,
    Text: $aepJ3.Text,
    TextPath: $iKGXd.TextPath,
    Transformer: $aY3GY.Transformer,
    Wedge: $6NrOY.Wedge,
    Filters: {
        Blur: $kd1un.Blur,
        Brighten: $gQWeB.Brighten,
        Contrast: $1aAid.Contrast,
        Emboss: $5iinf.Emboss,
        Enhance: $6skQr.Enhance,
        Grayscale: $kBAEq.Grayscale,
        HSL: $iqULT.HSL,
        HSV: $aBbcJ.HSV,
        Invert: $inCrd.Invert,
        Kaleidoscope: $8YRg7.Kaleidoscope,
        Mask: $f4uhT.Mask,
        Noise: $nXPb8.Noise,
        Pixelate: $ez1tv.Pixelate,
        Posterize: $54oRz.Posterize,
        RGB: $awjyq.RGB,
        RGBA: $jy4HT.RGBA,
        Sepia: $aSL2k.Sepia,
        Solarize: $irVuX.Solarize,
        Threshold: $fzRK8.Threshold
    }
});

});
parcelRegister("3rme3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Konva = void 0;

var $4v96z = parcelRequire("4v96z");

var $kWs5g = parcelRequire("kWs5g");

var $1qU2E = parcelRequire("1qU2E");

var $jxWWI = parcelRequire("jxWWI");

var $8wE3K = parcelRequire("8wE3K");

var $l0qD1 = parcelRequire("l0qD1");

var $6TLyv = parcelRequire("6TLyv");

var $4gbUw = parcelRequire("4gbUw");

var $d8LUf = parcelRequire("d8LUf");

var $82UKb = parcelRequire("82UKb");

var $hgtvs = parcelRequire("hgtvs");

var $9zlC2 = parcelRequire("9zlC2");

var $bWu8b = parcelRequire("bWu8b");

var $bsljL = parcelRequire("bsljL");
module.exports.Konva = $kWs5g.Util._assign($4v96z.Konva, {
    Util: $kWs5g.Util,
    Transform: $kWs5g.Transform,
    Node: $1qU2E.Node,
    Container: $jxWWI.Container,
    Stage: $8wE3K.Stage,
    stages: $8wE3K.stages,
    Layer: $l0qD1.Layer,
    FastLayer: $6TLyv.FastLayer,
    Group: $4gbUw.Group,
    DD: $d8LUf.DD,
    Shape: $82UKb.Shape,
    shapes: $82UKb.shapes,
    Animation: $hgtvs.Animation,
    Tween: $9zlC2.Tween,
    Easings: $9zlC2.Easings,
    Context: $bWu8b.Context,
    Canvas: $bsljL.Canvas
});
module.exports.default = module.exports.Konva;

});
parcelRegister("4v96z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._registerNode = module.exports.Konva = module.exports.glob = void 0;
const $34711eb82f64aa27$var$PI_OVER_180 = Math.PI / 180;
function $34711eb82f64aa27$var$detectBrowser() {
    return typeof window !== "undefined" && (({}).toString.call(window) === "[object Window]" || ({}).toString.call(window) === "[object global]");
}
module.exports.glob = typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof WorkerGlobalScope !== "undefined" ? self : {};
module.exports.Konva = {
    _global: module.exports.glob,
    version: "9.3.9",
    isBrowser: $34711eb82f64aa27$var$detectBrowser(),
    isUnminified: /param/.test((function(param) {}).toString()),
    dblClickWindow: 400,
    getAngle (angle) {
        return module.exports.Konva.angleDeg ? angle * $34711eb82f64aa27$var$PI_OVER_180 : angle;
    },
    enableTrace: false,
    pointerEventsEnabled: true,
    autoDrawEnabled: true,
    hitOnDragEnabled: false,
    capturePointerEventsEnabled: false,
    _mouseListenClick: false,
    _touchListenClick: false,
    _pointerListenClick: false,
    _mouseInDblClickWindow: false,
    _touchInDblClickWindow: false,
    _pointerInDblClickWindow: false,
    _mouseDblClickPointerId: null,
    _touchDblClickPointerId: null,
    _pointerDblClickPointerId: null,
    _fixTextRendering: false,
    pixelRatio: typeof window !== "undefined" && window.devicePixelRatio || 1,
    dragDistance: 3,
    angleDeg: true,
    showWarnings: true,
    dragButtons: [
        0,
        1
    ],
    isDragging () {
        return module.exports.Konva["DD"].isDragging;
    },
    isTransforming () {
        var _a;
        return (_a = module.exports.Konva["Transformer"]) === null || _a === void 0 ? void 0 : _a.isTransforming();
    },
    isDragReady () {
        return !!module.exports.Konva["DD"].node;
    },
    releaseCanvasOnDestroy: true,
    document: module.exports.glob.document,
    _injectGlobal (Konva) {
        module.exports.glob.Konva = Konva;
    }
};
const $34711eb82f64aa27$var$_registerNode = (NodeClass)=>{
    module.exports.Konva[NodeClass.prototype.getClassName()] = NodeClass;
};
module.exports._registerNode = $34711eb82f64aa27$var$_registerNode;
module.exports.Konva._injectGlobal(module.exports.Konva);

});

parcelRegister("kWs5g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Util = module.exports.Transform = void 0;

var $4v96z = parcelRequire("4v96z");
class $f3ef0247e0ce0070$var$Transform {
    constructor(m = [
        1,
        0,
        0,
        1,
        0,
        0
    ]){
        this.dirty = false;
        this.m = m && m.slice() || [
            1,
            0,
            0,
            1,
            0,
            0
        ];
    }
    reset() {
        this.m[0] = 1;
        this.m[1] = 0;
        this.m[2] = 0;
        this.m[3] = 1;
        this.m[4] = 0;
        this.m[5] = 0;
    }
    copy() {
        return new $f3ef0247e0ce0070$var$Transform(this.m);
    }
    copyInto(tr) {
        tr.m[0] = this.m[0];
        tr.m[1] = this.m[1];
        tr.m[2] = this.m[2];
        tr.m[3] = this.m[3];
        tr.m[4] = this.m[4];
        tr.m[5] = this.m[5];
    }
    point(point) {
        var m = this.m;
        return {
            x: m[0] * point.x + m[2] * point.y + m[4],
            y: m[1] * point.x + m[3] * point.y + m[5]
        };
    }
    translate(x, y) {
        this.m[4] += this.m[0] * x + this.m[2] * y;
        this.m[5] += this.m[1] * x + this.m[3] * y;
        return this;
    }
    scale(sx, sy) {
        this.m[0] *= sx;
        this.m[1] *= sx;
        this.m[2] *= sy;
        this.m[3] *= sy;
        return this;
    }
    rotate(rad) {
        var c = Math.cos(rad);
        var s = Math.sin(rad);
        var m11 = this.m[0] * c + this.m[2] * s;
        var m12 = this.m[1] * c + this.m[3] * s;
        var m21 = this.m[0] * -s + this.m[2] * c;
        var m22 = this.m[1] * -s + this.m[3] * c;
        this.m[0] = m11;
        this.m[1] = m12;
        this.m[2] = m21;
        this.m[3] = m22;
        return this;
    }
    getTranslation() {
        return {
            x: this.m[4],
            y: this.m[5]
        };
    }
    skew(sx, sy) {
        var m11 = this.m[0] + this.m[2] * sy;
        var m12 = this.m[1] + this.m[3] * sy;
        var m21 = this.m[2] + this.m[0] * sx;
        var m22 = this.m[3] + this.m[1] * sx;
        this.m[0] = m11;
        this.m[1] = m12;
        this.m[2] = m21;
        this.m[3] = m22;
        return this;
    }
    multiply(matrix) {
        var m11 = this.m[0] * matrix.m[0] + this.m[2] * matrix.m[1];
        var m12 = this.m[1] * matrix.m[0] + this.m[3] * matrix.m[1];
        var m21 = this.m[0] * matrix.m[2] + this.m[2] * matrix.m[3];
        var m22 = this.m[1] * matrix.m[2] + this.m[3] * matrix.m[3];
        var dx = this.m[0] * matrix.m[4] + this.m[2] * matrix.m[5] + this.m[4];
        var dy = this.m[1] * matrix.m[4] + this.m[3] * matrix.m[5] + this.m[5];
        this.m[0] = m11;
        this.m[1] = m12;
        this.m[2] = m21;
        this.m[3] = m22;
        this.m[4] = dx;
        this.m[5] = dy;
        return this;
    }
    invert() {
        var d = 1 / (this.m[0] * this.m[3] - this.m[1] * this.m[2]);
        var m0 = this.m[3] * d;
        var m1 = -this.m[1] * d;
        var m2 = -this.m[2] * d;
        var m3 = this.m[0] * d;
        var m4 = d * (this.m[2] * this.m[5] - this.m[3] * this.m[4]);
        var m5 = d * (this.m[1] * this.m[4] - this.m[0] * this.m[5]);
        this.m[0] = m0;
        this.m[1] = m1;
        this.m[2] = m2;
        this.m[3] = m3;
        this.m[4] = m4;
        this.m[5] = m5;
        return this;
    }
    getMatrix() {
        return this.m;
    }
    decompose() {
        var a = this.m[0];
        var b = this.m[1];
        var c = this.m[2];
        var d = this.m[3];
        var e = this.m[4];
        var f = this.m[5];
        var delta = a * d - b * c;
        let result = {
            x: e,
            y: f,
            rotation: 0,
            scaleX: 0,
            scaleY: 0,
            skewX: 0,
            skewY: 0
        };
        if (a != 0 || b != 0) {
            var r = Math.sqrt(a * a + b * b);
            result.rotation = b > 0 ? Math.acos(a / r) : -Math.acos(a / r);
            result.scaleX = r;
            result.scaleY = delta / r;
            result.skewX = (a * c + b * d) / delta;
            result.skewY = 0;
        } else if (c != 0 || d != 0) {
            var s = Math.sqrt(c * c + d * d);
            result.rotation = Math.PI / 2 - (d > 0 ? Math.acos(-c / s) : -Math.acos(c / s));
            result.scaleX = delta / s;
            result.scaleY = s;
            result.skewX = 0;
            result.skewY = (a * c + b * d) / delta;
        }
        result.rotation = module.exports.Util._getRotation(result.rotation);
        return result;
    }
}
module.exports.Transform = $f3ef0247e0ce0070$var$Transform;
var $f3ef0247e0ce0070$var$OBJECT_ARRAY = "[object Array]", $f3ef0247e0ce0070$var$OBJECT_NUMBER = "[object Number]", $f3ef0247e0ce0070$var$OBJECT_STRING = "[object String]", $f3ef0247e0ce0070$var$OBJECT_BOOLEAN = "[object Boolean]", $f3ef0247e0ce0070$var$PI_OVER_DEG180 = Math.PI / 180, $f3ef0247e0ce0070$var$DEG180_OVER_PI = 180 / Math.PI, $f3ef0247e0ce0070$var$HASH = "#", $f3ef0247e0ce0070$var$EMPTY_STRING = "", $f3ef0247e0ce0070$var$ZERO = "0", $f3ef0247e0ce0070$var$KONVA_WARNING = "Konva warning: ", $f3ef0247e0ce0070$var$KONVA_ERROR = "Konva error: ", $f3ef0247e0ce0070$var$RGB_PAREN = "rgb(", $f3ef0247e0ce0070$var$COLORS = {
    aliceblue: [
        240,
        248,
        255
    ],
    antiquewhite: [
        250,
        235,
        215
    ],
    aqua: [
        0,
        255,
        255
    ],
    aquamarine: [
        127,
        255,
        212
    ],
    azure: [
        240,
        255,
        255
    ],
    beige: [
        245,
        245,
        220
    ],
    bisque: [
        255,
        228,
        196
    ],
    black: [
        0,
        0,
        0
    ],
    blanchedalmond: [
        255,
        235,
        205
    ],
    blue: [
        0,
        0,
        255
    ],
    blueviolet: [
        138,
        43,
        226
    ],
    brown: [
        165,
        42,
        42
    ],
    burlywood: [
        222,
        184,
        135
    ],
    cadetblue: [
        95,
        158,
        160
    ],
    chartreuse: [
        127,
        255,
        0
    ],
    chocolate: [
        210,
        105,
        30
    ],
    coral: [
        255,
        127,
        80
    ],
    cornflowerblue: [
        100,
        149,
        237
    ],
    cornsilk: [
        255,
        248,
        220
    ],
    crimson: [
        220,
        20,
        60
    ],
    cyan: [
        0,
        255,
        255
    ],
    darkblue: [
        0,
        0,
        139
    ],
    darkcyan: [
        0,
        139,
        139
    ],
    darkgoldenrod: [
        184,
        132,
        11
    ],
    darkgray: [
        169,
        169,
        169
    ],
    darkgreen: [
        0,
        100,
        0
    ],
    darkgrey: [
        169,
        169,
        169
    ],
    darkkhaki: [
        189,
        183,
        107
    ],
    darkmagenta: [
        139,
        0,
        139
    ],
    darkolivegreen: [
        85,
        107,
        47
    ],
    darkorange: [
        255,
        140,
        0
    ],
    darkorchid: [
        153,
        50,
        204
    ],
    darkred: [
        139,
        0,
        0
    ],
    darksalmon: [
        233,
        150,
        122
    ],
    darkseagreen: [
        143,
        188,
        143
    ],
    darkslateblue: [
        72,
        61,
        139
    ],
    darkslategray: [
        47,
        79,
        79
    ],
    darkslategrey: [
        47,
        79,
        79
    ],
    darkturquoise: [
        0,
        206,
        209
    ],
    darkviolet: [
        148,
        0,
        211
    ],
    deeppink: [
        255,
        20,
        147
    ],
    deepskyblue: [
        0,
        191,
        255
    ],
    dimgray: [
        105,
        105,
        105
    ],
    dimgrey: [
        105,
        105,
        105
    ],
    dodgerblue: [
        30,
        144,
        255
    ],
    firebrick: [
        178,
        34,
        34
    ],
    floralwhite: [
        255,
        255,
        240
    ],
    forestgreen: [
        34,
        139,
        34
    ],
    fuchsia: [
        255,
        0,
        255
    ],
    gainsboro: [
        220,
        220,
        220
    ],
    ghostwhite: [
        248,
        248,
        255
    ],
    gold: [
        255,
        215,
        0
    ],
    goldenrod: [
        218,
        165,
        32
    ],
    gray: [
        128,
        128,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    greenyellow: [
        173,
        255,
        47
    ],
    grey: [
        128,
        128,
        128
    ],
    honeydew: [
        240,
        255,
        240
    ],
    hotpink: [
        255,
        105,
        180
    ],
    indianred: [
        205,
        92,
        92
    ],
    indigo: [
        75,
        0,
        130
    ],
    ivory: [
        255,
        255,
        240
    ],
    khaki: [
        240,
        230,
        140
    ],
    lavender: [
        230,
        230,
        250
    ],
    lavenderblush: [
        255,
        240,
        245
    ],
    lawngreen: [
        124,
        252,
        0
    ],
    lemonchiffon: [
        255,
        250,
        205
    ],
    lightblue: [
        173,
        216,
        230
    ],
    lightcoral: [
        240,
        128,
        128
    ],
    lightcyan: [
        224,
        255,
        255
    ],
    lightgoldenrodyellow: [
        250,
        250,
        210
    ],
    lightgray: [
        211,
        211,
        211
    ],
    lightgreen: [
        144,
        238,
        144
    ],
    lightgrey: [
        211,
        211,
        211
    ],
    lightpink: [
        255,
        182,
        193
    ],
    lightsalmon: [
        255,
        160,
        122
    ],
    lightseagreen: [
        32,
        178,
        170
    ],
    lightskyblue: [
        135,
        206,
        250
    ],
    lightslategray: [
        119,
        136,
        153
    ],
    lightslategrey: [
        119,
        136,
        153
    ],
    lightsteelblue: [
        176,
        196,
        222
    ],
    lightyellow: [
        255,
        255,
        224
    ],
    lime: [
        0,
        255,
        0
    ],
    limegreen: [
        50,
        205,
        50
    ],
    linen: [
        250,
        240,
        230
    ],
    magenta: [
        255,
        0,
        255
    ],
    maroon: [
        128,
        0,
        0
    ],
    mediumaquamarine: [
        102,
        205,
        170
    ],
    mediumblue: [
        0,
        0,
        205
    ],
    mediumorchid: [
        186,
        85,
        211
    ],
    mediumpurple: [
        147,
        112,
        219
    ],
    mediumseagreen: [
        60,
        179,
        113
    ],
    mediumslateblue: [
        123,
        104,
        238
    ],
    mediumspringgreen: [
        0,
        250,
        154
    ],
    mediumturquoise: [
        72,
        209,
        204
    ],
    mediumvioletred: [
        199,
        21,
        133
    ],
    midnightblue: [
        25,
        25,
        112
    ],
    mintcream: [
        245,
        255,
        250
    ],
    mistyrose: [
        255,
        228,
        225
    ],
    moccasin: [
        255,
        228,
        181
    ],
    navajowhite: [
        255,
        222,
        173
    ],
    navy: [
        0,
        0,
        128
    ],
    oldlace: [
        253,
        245,
        230
    ],
    olive: [
        128,
        128,
        0
    ],
    olivedrab: [
        107,
        142,
        35
    ],
    orange: [
        255,
        165,
        0
    ],
    orangered: [
        255,
        69,
        0
    ],
    orchid: [
        218,
        112,
        214
    ],
    palegoldenrod: [
        238,
        232,
        170
    ],
    palegreen: [
        152,
        251,
        152
    ],
    paleturquoise: [
        175,
        238,
        238
    ],
    palevioletred: [
        219,
        112,
        147
    ],
    papayawhip: [
        255,
        239,
        213
    ],
    peachpuff: [
        255,
        218,
        185
    ],
    peru: [
        205,
        133,
        63
    ],
    pink: [
        255,
        192,
        203
    ],
    plum: [
        221,
        160,
        203
    ],
    powderblue: [
        176,
        224,
        230
    ],
    purple: [
        128,
        0,
        128
    ],
    rebeccapurple: [
        102,
        51,
        153
    ],
    red: [
        255,
        0,
        0
    ],
    rosybrown: [
        188,
        143,
        143
    ],
    royalblue: [
        65,
        105,
        225
    ],
    saddlebrown: [
        139,
        69,
        19
    ],
    salmon: [
        250,
        128,
        114
    ],
    sandybrown: [
        244,
        164,
        96
    ],
    seagreen: [
        46,
        139,
        87
    ],
    seashell: [
        255,
        245,
        238
    ],
    sienna: [
        160,
        82,
        45
    ],
    silver: [
        192,
        192,
        192
    ],
    skyblue: [
        135,
        206,
        235
    ],
    slateblue: [
        106,
        90,
        205
    ],
    slategray: [
        119,
        128,
        144
    ],
    slategrey: [
        119,
        128,
        144
    ],
    snow: [
        255,
        255,
        250
    ],
    springgreen: [
        0,
        255,
        127
    ],
    steelblue: [
        70,
        130,
        180
    ],
    tan: [
        210,
        180,
        140
    ],
    teal: [
        0,
        128,
        128
    ],
    thistle: [
        216,
        191,
        216
    ],
    transparent: [
        255,
        255,
        255,
        0
    ],
    tomato: [
        255,
        99,
        71
    ],
    turquoise: [
        64,
        224,
        208
    ],
    violet: [
        238,
        130,
        238
    ],
    wheat: [
        245,
        222,
        179
    ],
    white: [
        255,
        255,
        255
    ],
    whitesmoke: [
        245,
        245,
        245
    ],
    yellow: [
        255,
        255,
        0
    ],
    yellowgreen: [
        154,
        205,
        5
    ]
}, $f3ef0247e0ce0070$var$RGB_REGEX = /rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/, $f3ef0247e0ce0070$var$animQueue = [];
const $f3ef0247e0ce0070$var$req = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame || function(f) {
    setTimeout(f, 60);
};
module.exports.Util = {
    _isElement (obj) {
        return !!(obj && obj.nodeType == 1);
    },
    _isFunction (obj) {
        return !!(obj && obj.constructor && obj.call && obj.apply);
    },
    _isPlainObject (obj) {
        return !!obj && obj.constructor === Object;
    },
    _isArray (obj) {
        return Object.prototype.toString.call(obj) === $f3ef0247e0ce0070$var$OBJECT_ARRAY;
    },
    _isNumber (obj) {
        return Object.prototype.toString.call(obj) === $f3ef0247e0ce0070$var$OBJECT_NUMBER && !isNaN(obj) && isFinite(obj);
    },
    _isString (obj) {
        return Object.prototype.toString.call(obj) === $f3ef0247e0ce0070$var$OBJECT_STRING;
    },
    _isBoolean (obj) {
        return Object.prototype.toString.call(obj) === $f3ef0247e0ce0070$var$OBJECT_BOOLEAN;
    },
    isObject (val) {
        return val instanceof Object;
    },
    isValidSelector (selector) {
        if (typeof selector !== "string") return false;
        var firstChar = selector[0];
        return firstChar === "#" || firstChar === "." || firstChar === firstChar.toUpperCase();
    },
    _sign (number) {
        if (number === 0) return 1;
        if (number > 0) return 1;
        else return -1;
    },
    requestAnimFrame (callback) {
        $f3ef0247e0ce0070$var$animQueue.push(callback);
        if ($f3ef0247e0ce0070$var$animQueue.length === 1) $f3ef0247e0ce0070$var$req(function() {
            const queue = $f3ef0247e0ce0070$var$animQueue;
            $f3ef0247e0ce0070$var$animQueue = [];
            queue.forEach(function(cb) {
                cb();
            });
        });
    },
    createCanvasElement () {
        var canvas = document.createElement("canvas");
        try {
            canvas.style = canvas.style || {};
        } catch (e) {}
        return canvas;
    },
    createImageElement () {
        return document.createElement("img");
    },
    _isInDocument (el) {
        while(el = el.parentNode){
            if (el == document) return true;
        }
        return false;
    },
    _urlToImage (url, callback) {
        var imageObj = module.exports.Util.createImageElement();
        imageObj.onload = function() {
            callback(imageObj);
        };
        imageObj.src = url;
    },
    _rgbToHex (r, g, b) {
        return (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
    },
    _hexToRgb (hex) {
        hex = hex.replace($f3ef0247e0ce0070$var$HASH, $f3ef0247e0ce0070$var$EMPTY_STRING);
        var bigint = parseInt(hex, 16);
        return {
            r: bigint >> 16 & 255,
            g: bigint >> 8 & 255,
            b: bigint & 255
        };
    },
    getRandomColor () {
        var randColor = (Math.random() * 0xffffff << 0).toString(16);
        while(randColor.length < 6)randColor = $f3ef0247e0ce0070$var$ZERO + randColor;
        return $f3ef0247e0ce0070$var$HASH + randColor;
    },
    getRGB (color) {
        var rgb;
        if (color in $f3ef0247e0ce0070$var$COLORS) {
            rgb = $f3ef0247e0ce0070$var$COLORS[color];
            return {
                r: rgb[0],
                g: rgb[1],
                b: rgb[2]
            };
        } else if (color[0] === $f3ef0247e0ce0070$var$HASH) return this._hexToRgb(color.substring(1));
        else if (color.substr(0, 4) === $f3ef0247e0ce0070$var$RGB_PAREN) {
            rgb = $f3ef0247e0ce0070$var$RGB_REGEX.exec(color.replace(/ /g, ""));
            return {
                r: parseInt(rgb[1], 10),
                g: parseInt(rgb[2], 10),
                b: parseInt(rgb[3], 10)
            };
        } else return {
            r: 0,
            g: 0,
            b: 0
        };
    },
    colorToRGBA (str) {
        str = str || "black";
        return module.exports.Util._namedColorToRBA(str) || module.exports.Util._hex3ColorToRGBA(str) || module.exports.Util._hex4ColorToRGBA(str) || module.exports.Util._hex6ColorToRGBA(str) || module.exports.Util._hex8ColorToRGBA(str) || module.exports.Util._rgbColorToRGBA(str) || module.exports.Util._rgbaColorToRGBA(str) || module.exports.Util._hslColorToRGBA(str);
    },
    _namedColorToRBA (str) {
        var c = $f3ef0247e0ce0070$var$COLORS[str.toLowerCase()];
        if (!c) return null;
        return {
            r: c[0],
            g: c[1],
            b: c[2],
            a: 1
        };
    },
    _rgbColorToRGBA (str) {
        if (str.indexOf("rgb(") === 0) {
            str = str.match(/rgb\(([^)]+)\)/)[1];
            var parts = str.split(/ *, */).map(Number);
            return {
                r: parts[0],
                g: parts[1],
                b: parts[2],
                a: 1
            };
        }
    },
    _rgbaColorToRGBA (str) {
        if (str.indexOf("rgba(") === 0) {
            str = str.match(/rgba\(([^)]+)\)/)[1];
            var parts = str.split(/ *, */).map((n, index)=>{
                if (n.slice(-1) === "%") return index === 3 ? parseInt(n) / 100 : parseInt(n) / 100 * 255;
                return Number(n);
            });
            return {
                r: parts[0],
                g: parts[1],
                b: parts[2],
                a: parts[3]
            };
        }
    },
    _hex8ColorToRGBA (str) {
        if (str[0] === "#" && str.length === 9) return {
            r: parseInt(str.slice(1, 3), 16),
            g: parseInt(str.slice(3, 5), 16),
            b: parseInt(str.slice(5, 7), 16),
            a: parseInt(str.slice(7, 9), 16) / 0xff
        };
    },
    _hex6ColorToRGBA (str) {
        if (str[0] === "#" && str.length === 7) return {
            r: parseInt(str.slice(1, 3), 16),
            g: parseInt(str.slice(3, 5), 16),
            b: parseInt(str.slice(5, 7), 16),
            a: 1
        };
    },
    _hex4ColorToRGBA (str) {
        if (str[0] === "#" && str.length === 5) return {
            r: parseInt(str[1] + str[1], 16),
            g: parseInt(str[2] + str[2], 16),
            b: parseInt(str[3] + str[3], 16),
            a: parseInt(str[4] + str[4], 16) / 0xff
        };
    },
    _hex3ColorToRGBA (str) {
        if (str[0] === "#" && str.length === 4) return {
            r: parseInt(str[1] + str[1], 16),
            g: parseInt(str[2] + str[2], 16),
            b: parseInt(str[3] + str[3], 16),
            a: 1
        };
    },
    _hslColorToRGBA (str) {
        if (/hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.test(str)) {
            const [_, ...hsl] = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(str);
            const h = Number(hsl[0]) / 360;
            const s = Number(hsl[1]) / 100;
            const l = Number(hsl[2]) / 100;
            let t2;
            let t3;
            let val;
            if (s === 0) {
                val = l * 255;
                return {
                    r: Math.round(val),
                    g: Math.round(val),
                    b: Math.round(val),
                    a: 1
                };
            }
            if (l < 0.5) t2 = l * (1 + s);
            else t2 = l + s - l * s;
            const t1 = 2 * l - t2;
            const rgb = [
                0,
                0,
                0
            ];
            for(let i = 0; i < 3; i++){
                t3 = h + 1 / 3 * -(i - 1);
                if (t3 < 0) t3++;
                if (t3 > 1) t3--;
                if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
                else if (2 * t3 < 1) val = t2;
                else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
                else val = t1;
                rgb[i] = val * 255;
            }
            return {
                r: Math.round(rgb[0]),
                g: Math.round(rgb[1]),
                b: Math.round(rgb[2]),
                a: 1
            };
        }
    },
    haveIntersection (r1, r2) {
        return !(r2.x > r1.x + r1.width || r2.x + r2.width < r1.x || r2.y > r1.y + r1.height || r2.y + r2.height < r1.y);
    },
    cloneObject (obj) {
        var retObj = {};
        for(var key in obj){
            if (this._isPlainObject(obj[key])) retObj[key] = this.cloneObject(obj[key]);
            else if (this._isArray(obj[key])) retObj[key] = this.cloneArray(obj[key]);
            else retObj[key] = obj[key];
        }
        return retObj;
    },
    cloneArray (arr) {
        return arr.slice(0);
    },
    degToRad (deg) {
        return deg * $f3ef0247e0ce0070$var$PI_OVER_DEG180;
    },
    radToDeg (rad) {
        return rad * $f3ef0247e0ce0070$var$DEG180_OVER_PI;
    },
    _degToRad (deg) {
        module.exports.Util.warn("Util._degToRad is removed. Please use public Util.degToRad instead.");
        return module.exports.Util.degToRad(deg);
    },
    _radToDeg (rad) {
        module.exports.Util.warn("Util._radToDeg is removed. Please use public Util.radToDeg instead.");
        return module.exports.Util.radToDeg(rad);
    },
    _getRotation (radians) {
        return $4v96z.Konva.angleDeg ? module.exports.Util.radToDeg(radians) : radians;
    },
    _capitalize (str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    },
    throw (str) {
        throw new Error($f3ef0247e0ce0070$var$KONVA_ERROR + str);
    },
    error (str) {
        console.error($f3ef0247e0ce0070$var$KONVA_ERROR + str);
    },
    warn (str) {
        if (!$4v96z.Konva.showWarnings) return;
        console.warn($f3ef0247e0ce0070$var$KONVA_WARNING + str);
    },
    each (obj, func) {
        for(var key in obj)func(key, obj[key]);
    },
    _inRange (val, left, right) {
        return left <= val && val < right;
    },
    _getProjectionToSegment (x1, y1, x2, y2, x3, y3) {
        var x, y, dist;
        var pd2 = (x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2);
        if (pd2 == 0) {
            x = x1;
            y = y1;
            dist = (x3 - x2) * (x3 - x2) + (y3 - y2) * (y3 - y2);
        } else {
            var u = ((x3 - x1) * (x2 - x1) + (y3 - y1) * (y2 - y1)) / pd2;
            if (u < 0) {
                x = x1;
                y = y1;
                dist = (x1 - x3) * (x1 - x3) + (y1 - y3) * (y1 - y3);
            } else if (u > 1.0) {
                x = x2;
                y = y2;
                dist = (x2 - x3) * (x2 - x3) + (y2 - y3) * (y2 - y3);
            } else {
                x = x1 + u * (x2 - x1);
                y = y1 + u * (y2 - y1);
                dist = (x - x3) * (x - x3) + (y - y3) * (y - y3);
            }
        }
        return [
            x,
            y,
            dist
        ];
    },
    _getProjectionToLine (pt, line, isClosed) {
        var pc = module.exports.Util.cloneObject(pt);
        var dist = Number.MAX_VALUE;
        line.forEach(function(p1, i) {
            if (!isClosed && i === line.length - 1) return;
            var p2 = line[(i + 1) % line.length];
            var proj = module.exports.Util._getProjectionToSegment(p1.x, p1.y, p2.x, p2.y, pt.x, pt.y);
            var px = proj[0], py = proj[1], pdist = proj[2];
            if (pdist < dist) {
                pc.x = px;
                pc.y = py;
                dist = pdist;
            }
        });
        return pc;
    },
    _prepareArrayForTween (startArray, endArray, isClosed) {
        var n, start = [], end = [];
        if (startArray.length > endArray.length) {
            var temp = endArray;
            endArray = startArray;
            startArray = temp;
        }
        for(n = 0; n < startArray.length; n += 2)start.push({
            x: startArray[n],
            y: startArray[n + 1]
        });
        for(n = 0; n < endArray.length; n += 2)end.push({
            x: endArray[n],
            y: endArray[n + 1]
        });
        var newStart = [];
        end.forEach(function(point) {
            var pr = module.exports.Util._getProjectionToLine(point, start, isClosed);
            newStart.push(pr.x);
            newStart.push(pr.y);
        });
        return newStart;
    },
    _prepareToStringify (obj) {
        var desc;
        obj.visitedByCircularReferenceRemoval = true;
        for(var key in obj){
            if (!(obj.hasOwnProperty(key) && obj[key] && typeof obj[key] == "object")) continue;
            desc = Object.getOwnPropertyDescriptor(obj, key);
            if (obj[key].visitedByCircularReferenceRemoval || module.exports.Util._isElement(obj[key])) {
                if (desc.configurable) delete obj[key];
                else return null;
            } else if (module.exports.Util._prepareToStringify(obj[key]) === null) {
                if (desc.configurable) delete obj[key];
                else return null;
            }
        }
        delete obj.visitedByCircularReferenceRemoval;
        return obj;
    },
    _assign (target, source) {
        for(var key in source)target[key] = source[key];
        return target;
    },
    _getFirstPointerId (evt) {
        if (!evt.touches) return evt.pointerId || 999;
        else return evt.changedTouches[0].identifier;
    },
    releaseCanvas (...canvases) {
        if (!$4v96z.Konva.releaseCanvasOnDestroy) return;
        canvases.forEach((c)=>{
            c.width = 0;
            c.height = 0;
        });
    },
    drawRoundedRectPath (context, width, height, cornerRadius) {
        let topLeft = 0;
        let topRight = 0;
        let bottomLeft = 0;
        let bottomRight = 0;
        if (typeof cornerRadius === "number") topLeft = topRight = bottomLeft = bottomRight = Math.min(cornerRadius, width / 2, height / 2);
        else {
            topLeft = Math.min(cornerRadius[0] || 0, width / 2, height / 2);
            topRight = Math.min(cornerRadius[1] || 0, width / 2, height / 2);
            bottomRight = Math.min(cornerRadius[2] || 0, width / 2, height / 2);
            bottomLeft = Math.min(cornerRadius[3] || 0, width / 2, height / 2);
        }
        context.moveTo(topLeft, 0);
        context.lineTo(width - topRight, 0);
        context.arc(width - topRight, topRight, topRight, Math.PI * 3 / 2, 0, false);
        context.lineTo(width, height - bottomRight);
        context.arc(width - bottomRight, height - bottomRight, bottomRight, 0, Math.PI / 2, false);
        context.lineTo(bottomLeft, height);
        context.arc(bottomLeft, height - bottomLeft, bottomLeft, Math.PI / 2, Math.PI, false);
        context.lineTo(0, topLeft);
        context.arc(topLeft, topLeft, topLeft, Math.PI, Math.PI * 3 / 2, false);
    }
};

});

parcelRegister("1qU2E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Node = void 0;

var $kWs5g = parcelRequire("kWs5g");

var $3V3su = parcelRequire("3V3su");

var $bsljL = parcelRequire("bsljL");

var $4v96z = parcelRequire("4v96z");

var $d8LUf = parcelRequire("d8LUf");

var $2TXYV = parcelRequire("2TXYV");
var $10b3b0e56d39035f$var$ABSOLUTE_OPACITY = "absoluteOpacity", $10b3b0e56d39035f$var$ALL_LISTENERS = "allEventListeners", $10b3b0e56d39035f$var$ABSOLUTE_TRANSFORM = "absoluteTransform", $10b3b0e56d39035f$var$ABSOLUTE_SCALE = "absoluteScale", $10b3b0e56d39035f$var$CANVAS = "canvas", $10b3b0e56d39035f$var$CHANGE = "Change", $10b3b0e56d39035f$var$CHILDREN = "children", $10b3b0e56d39035f$var$KONVA = "konva", $10b3b0e56d39035f$var$LISTENING = "listening", $10b3b0e56d39035f$var$MOUSEENTER = "mouseenter", $10b3b0e56d39035f$var$MOUSELEAVE = "mouseleave", $10b3b0e56d39035f$var$NAME = "name", $10b3b0e56d39035f$var$SET = "set", $10b3b0e56d39035f$var$SHAPE = "Shape", $10b3b0e56d39035f$var$SPACE = " ", $10b3b0e56d39035f$var$STAGE = "stage", $10b3b0e56d39035f$var$TRANSFORM = "transform", $10b3b0e56d39035f$var$UPPER_STAGE = "Stage", $10b3b0e56d39035f$var$VISIBLE = "visible", $10b3b0e56d39035f$var$TRANSFORM_CHANGE_STR = [
    "xChange.konva",
    "yChange.konva",
    "scaleXChange.konva",
    "scaleYChange.konva",
    "skewXChange.konva",
    "skewYChange.konva",
    "rotationChange.konva",
    "offsetXChange.konva",
    "offsetYChange.konva",
    "transformsEnabledChange.konva"
].join($10b3b0e56d39035f$var$SPACE);
let $10b3b0e56d39035f$var$idCounter = 1;
class $10b3b0e56d39035f$var$Node {
    constructor(config){
        this._id = $10b3b0e56d39035f$var$idCounter++;
        this.eventListeners = {};
        this.attrs = {};
        this.index = 0;
        this._allEventListeners = null;
        this.parent = null;
        this._cache = new Map();
        this._attachedDepsListeners = new Map();
        this._lastPos = null;
        this._batchingTransformChange = false;
        this._needClearTransformCache = false;
        this._filterUpToDate = false;
        this._isUnderCache = false;
        this._dragEventId = null;
        this._shouldFireChangeEvents = false;
        this.setAttrs(config);
        this._shouldFireChangeEvents = true;
    }
    hasChildren() {
        return false;
    }
    _clearCache(attr) {
        if ((attr === $10b3b0e56d39035f$var$TRANSFORM || attr === $10b3b0e56d39035f$var$ABSOLUTE_TRANSFORM) && this._cache.get(attr)) this._cache.get(attr).dirty = true;
        else if (attr) this._cache.delete(attr);
        else this._cache.clear();
    }
    _getCache(attr, privateGetter) {
        var cache = this._cache.get(attr);
        var isTransform = attr === $10b3b0e56d39035f$var$TRANSFORM || attr === $10b3b0e56d39035f$var$ABSOLUTE_TRANSFORM;
        var invalid = cache === undefined || isTransform && cache.dirty === true;
        if (invalid) {
            cache = privateGetter.call(this);
            this._cache.set(attr, cache);
        }
        return cache;
    }
    _calculate(name, deps, getter) {
        if (!this._attachedDepsListeners.get(name)) {
            const depsString = deps.map((dep)=>dep + "Change.konva").join($10b3b0e56d39035f$var$SPACE);
            this.on(depsString, ()=>{
                this._clearCache(name);
            });
            this._attachedDepsListeners.set(name, true);
        }
        return this._getCache(name, getter);
    }
    _getCanvasCache() {
        return this._cache.get($10b3b0e56d39035f$var$CANVAS);
    }
    _clearSelfAndDescendantCache(attr) {
        this._clearCache(attr);
        if (attr === $10b3b0e56d39035f$var$ABSOLUTE_TRANSFORM) this.fire("absoluteTransformChange");
    }
    clearCache() {
        if (this._cache.has($10b3b0e56d39035f$var$CANVAS)) {
            const { scene: scene, filter: filter, hit: hit } = this._cache.get($10b3b0e56d39035f$var$CANVAS);
            $kWs5g.Util.releaseCanvas(scene, filter, hit);
            this._cache.delete($10b3b0e56d39035f$var$CANVAS);
        }
        this._clearSelfAndDescendantCache();
        this._requestDraw();
        return this;
    }
    cache(config) {
        var conf = config || {};
        var rect = {};
        if (conf.x === undefined || conf.y === undefined || conf.width === undefined || conf.height === undefined) rect = this.getClientRect({
            skipTransform: true,
            relativeTo: this.getParent() || undefined
        });
        var width = Math.ceil(conf.width || rect.width), height = Math.ceil(conf.height || rect.height), pixelRatio = conf.pixelRatio, x = conf.x === undefined ? Math.floor(rect.x) : conf.x, y = conf.y === undefined ? Math.floor(rect.y) : conf.y, offset = conf.offset || 0, drawBorder = conf.drawBorder || false, hitCanvasPixelRatio = conf.hitCanvasPixelRatio || 1;
        if (!width || !height) {
            $kWs5g.Util.error("Can not cache the node. Width or height of the node equals 0. Caching is skipped.");
            return;
        }
        const extraPaddingX = Math.abs(Math.round(rect.x) - x) > 0.5 ? 1 : 0;
        const extraPaddingY = Math.abs(Math.round(rect.y) - y) > 0.5 ? 1 : 0;
        width += offset * 2 + extraPaddingX;
        height += offset * 2 + extraPaddingY;
        x -= offset;
        y -= offset;
        var cachedSceneCanvas = new $bsljL.SceneCanvas({
            pixelRatio: pixelRatio,
            width: width,
            height: height
        }), cachedFilterCanvas = new $bsljL.SceneCanvas({
            pixelRatio: pixelRatio,
            width: 0,
            height: 0,
            willReadFrequently: true
        }), cachedHitCanvas = new $bsljL.HitCanvas({
            pixelRatio: hitCanvasPixelRatio,
            width: width,
            height: height
        }), sceneContext = cachedSceneCanvas.getContext(), hitContext = cachedHitCanvas.getContext();
        cachedHitCanvas.isCache = true;
        cachedSceneCanvas.isCache = true;
        this._cache.delete($10b3b0e56d39035f$var$CANVAS);
        this._filterUpToDate = false;
        if (conf.imageSmoothingEnabled === false) {
            cachedSceneCanvas.getContext()._context.imageSmoothingEnabled = false;
            cachedFilterCanvas.getContext()._context.imageSmoothingEnabled = false;
        }
        sceneContext.save();
        hitContext.save();
        sceneContext.translate(-x, -y);
        hitContext.translate(-x, -y);
        this._isUnderCache = true;
        this._clearSelfAndDescendantCache($10b3b0e56d39035f$var$ABSOLUTE_OPACITY);
        this._clearSelfAndDescendantCache($10b3b0e56d39035f$var$ABSOLUTE_SCALE);
        this.drawScene(cachedSceneCanvas, this);
        this.drawHit(cachedHitCanvas, this);
        this._isUnderCache = false;
        sceneContext.restore();
        hitContext.restore();
        if (drawBorder) {
            sceneContext.save();
            sceneContext.beginPath();
            sceneContext.rect(0, 0, width, height);
            sceneContext.closePath();
            sceneContext.setAttr("strokeStyle", "red");
            sceneContext.setAttr("lineWidth", 5);
            sceneContext.stroke();
            sceneContext.restore();
        }
        this._cache.set($10b3b0e56d39035f$var$CANVAS, {
            scene: cachedSceneCanvas,
            filter: cachedFilterCanvas,
            hit: cachedHitCanvas,
            x: x,
            y: y
        });
        this._requestDraw();
        return this;
    }
    isCached() {
        return this._cache.has($10b3b0e56d39035f$var$CANVAS);
    }
    getClientRect(config) {
        throw new Error('abstract "getClientRect" method call');
    }
    _transformedRect(rect, top) {
        var points = [
            {
                x: rect.x,
                y: rect.y
            },
            {
                x: rect.x + rect.width,
                y: rect.y
            },
            {
                x: rect.x + rect.width,
                y: rect.y + rect.height
            },
            {
                x: rect.x,
                y: rect.y + rect.height
            }
        ];
        var minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
        var trans = this.getAbsoluteTransform(top);
        points.forEach(function(point) {
            var transformed = trans.point(point);
            if (minX === undefined) {
                minX = maxX = transformed.x;
                minY = maxY = transformed.y;
            }
            minX = Math.min(minX, transformed.x);
            minY = Math.min(minY, transformed.y);
            maxX = Math.max(maxX, transformed.x);
            maxY = Math.max(maxY, transformed.y);
        });
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    _drawCachedSceneCanvas(context) {
        context.save();
        context._applyOpacity(this);
        context._applyGlobalCompositeOperation(this);
        const canvasCache = this._getCanvasCache();
        context.translate(canvasCache.x, canvasCache.y);
        var cacheCanvas = this._getCachedSceneCanvas();
        var ratio = cacheCanvas.pixelRatio;
        context.drawImage(cacheCanvas._canvas, 0, 0, cacheCanvas.width / ratio, cacheCanvas.height / ratio);
        context.restore();
    }
    _drawCachedHitCanvas(context) {
        var canvasCache = this._getCanvasCache(), hitCanvas = canvasCache.hit;
        context.save();
        context.translate(canvasCache.x, canvasCache.y);
        context.drawImage(hitCanvas._canvas, 0, 0, hitCanvas.width / hitCanvas.pixelRatio, hitCanvas.height / hitCanvas.pixelRatio);
        context.restore();
    }
    _getCachedSceneCanvas() {
        var filters = this.filters(), cachedCanvas = this._getCanvasCache(), sceneCanvas = cachedCanvas.scene, filterCanvas = cachedCanvas.filter, filterContext = filterCanvas.getContext(), len, imageData, n, filter;
        if (filters) {
            if (!this._filterUpToDate) {
                var ratio = sceneCanvas.pixelRatio;
                filterCanvas.setSize(sceneCanvas.width / sceneCanvas.pixelRatio, sceneCanvas.height / sceneCanvas.pixelRatio);
                try {
                    len = filters.length;
                    filterContext.clear();
                    filterContext.drawImage(sceneCanvas._canvas, 0, 0, sceneCanvas.getWidth() / ratio, sceneCanvas.getHeight() / ratio);
                    imageData = filterContext.getImageData(0, 0, filterCanvas.getWidth(), filterCanvas.getHeight());
                    for(n = 0; n < len; n++){
                        filter = filters[n];
                        if (typeof filter !== "function") {
                            $kWs5g.Util.error("Filter should be type of function, but got " + typeof filter + " instead. Please check correct filters");
                            continue;
                        }
                        filter.call(this, imageData);
                        filterContext.putImageData(imageData, 0, 0);
                    }
                } catch (e) {
                    $kWs5g.Util.error("Unable to apply filter. " + e.message + " This post my help you https://konvajs.org/docs/posts/Tainted_Canvas.html.");
                }
                this._filterUpToDate = true;
            }
            return filterCanvas;
        }
        return sceneCanvas;
    }
    on(evtStr, handler) {
        this._cache && this._cache.delete($10b3b0e56d39035f$var$ALL_LISTENERS);
        if (arguments.length === 3) return this._delegate.apply(this, arguments);
        var events = evtStr.split($10b3b0e56d39035f$var$SPACE), len = events.length, n, event, parts, baseEvent, name;
        for(n = 0; n < len; n++){
            event = events[n];
            parts = event.split(".");
            baseEvent = parts[0];
            name = parts[1] || "";
            if (!this.eventListeners[baseEvent]) this.eventListeners[baseEvent] = [];
            this.eventListeners[baseEvent].push({
                name: name,
                handler: handler
            });
        }
        return this;
    }
    off(evtStr, callback) {
        var events = (evtStr || "").split($10b3b0e56d39035f$var$SPACE), len = events.length, n, t, event, parts, baseEvent, name;
        this._cache && this._cache.delete($10b3b0e56d39035f$var$ALL_LISTENERS);
        if (!evtStr) for(t in this.eventListeners)this._off(t);
        for(n = 0; n < len; n++){
            event = events[n];
            parts = event.split(".");
            baseEvent = parts[0];
            name = parts[1];
            if (baseEvent) {
                if (this.eventListeners[baseEvent]) this._off(baseEvent, name, callback);
            } else for(t in this.eventListeners)this._off(t, name, callback);
        }
        return this;
    }
    dispatchEvent(evt) {
        var e = {
            target: this,
            type: evt.type,
            evt: evt
        };
        this.fire(evt.type, e);
        return this;
    }
    addEventListener(type, handler) {
        this.on(type, function(evt) {
            handler.call(this, evt.evt);
        });
        return this;
    }
    removeEventListener(type) {
        this.off(type);
        return this;
    }
    _delegate(event, selector, handler) {
        var stopNode = this;
        this.on(event, function(evt) {
            var targets = evt.target.findAncestors(selector, true, stopNode);
            for(var i = 0; i < targets.length; i++){
                evt = $kWs5g.Util.cloneObject(evt);
                evt.currentTarget = targets[i];
                handler.call(targets[i], evt);
            }
        });
    }
    remove() {
        if (this.isDragging()) this.stopDrag();
        $d8LUf.DD._dragElements.delete(this._id);
        this._remove();
        return this;
    }
    _clearCaches() {
        this._clearSelfAndDescendantCache($10b3b0e56d39035f$var$ABSOLUTE_TRANSFORM);
        this._clearSelfAndDescendantCache($10b3b0e56d39035f$var$ABSOLUTE_OPACITY);
        this._clearSelfAndDescendantCache($10b3b0e56d39035f$var$ABSOLUTE_SCALE);
        this._clearSelfAndDescendantCache($10b3b0e56d39035f$var$STAGE);
        this._clearSelfAndDescendantCache($10b3b0e56d39035f$var$VISIBLE);
        this._clearSelfAndDescendantCache($10b3b0e56d39035f$var$LISTENING);
    }
    _remove() {
        this._clearCaches();
        var parent = this.getParent();
        if (parent && parent.children) {
            parent.children.splice(this.index, 1);
            parent._setChildrenIndices();
            this.parent = null;
        }
    }
    destroy() {
        this.remove();
        this.clearCache();
        return this;
    }
    getAttr(attr) {
        var method = "get" + $kWs5g.Util._capitalize(attr);
        if ($kWs5g.Util._isFunction(this[method])) return this[method]();
        return this.attrs[attr];
    }
    getAncestors() {
        var parent = this.getParent(), ancestors = [];
        while(parent){
            ancestors.push(parent);
            parent = parent.getParent();
        }
        return ancestors;
    }
    getAttrs() {
        return this.attrs || {};
    }
    setAttrs(config) {
        this._batchTransformChanges(()=>{
            var key, method;
            if (!config) return this;
            for(key in config){
                if (key === $10b3b0e56d39035f$var$CHILDREN) continue;
                method = $10b3b0e56d39035f$var$SET + $kWs5g.Util._capitalize(key);
                if ($kWs5g.Util._isFunction(this[method])) this[method](config[key]);
                else this._setAttr(key, config[key]);
            }
        });
        return this;
    }
    isListening() {
        return this._getCache($10b3b0e56d39035f$var$LISTENING, this._isListening);
    }
    _isListening(relativeTo) {
        const listening = this.listening();
        if (!listening) return false;
        const parent = this.getParent();
        if (parent && parent !== relativeTo && this !== relativeTo) return parent._isListening(relativeTo);
        else return true;
    }
    isVisible() {
        return this._getCache($10b3b0e56d39035f$var$VISIBLE, this._isVisible);
    }
    _isVisible(relativeTo) {
        const visible = this.visible();
        if (!visible) return false;
        const parent = this.getParent();
        if (parent && parent !== relativeTo && this !== relativeTo) return parent._isVisible(relativeTo);
        else return true;
    }
    shouldDrawHit(top, skipDragCheck = false) {
        if (top) return this._isVisible(top) && this._isListening(top);
        var layer = this.getLayer();
        var layerUnderDrag = false;
        $d8LUf.DD._dragElements.forEach((elem)=>{
            if (elem.dragStatus !== "dragging") return;
            else if (elem.node.nodeType === "Stage") layerUnderDrag = true;
            else if (elem.node.getLayer() === layer) layerUnderDrag = true;
        });
        var dragSkip = !skipDragCheck && !$4v96z.Konva.hitOnDragEnabled && (layerUnderDrag || $4v96z.Konva.isTransforming());
        return this.isListening() && this.isVisible() && !dragSkip;
    }
    show() {
        this.visible(true);
        return this;
    }
    hide() {
        this.visible(false);
        return this;
    }
    getZIndex() {
        return this.index || 0;
    }
    getAbsoluteZIndex() {
        var depth = this.getDepth(), that = this, index = 0, nodes, len, n, child;
        function addChildren(children) {
            nodes = [];
            len = children.length;
            for(n = 0; n < len; n++){
                child = children[n];
                index++;
                if (child.nodeType !== $10b3b0e56d39035f$var$SHAPE) nodes = nodes.concat(child.getChildren().slice());
                if (child._id === that._id) n = len;
            }
            if (nodes.length > 0 && nodes[0].getDepth() <= depth) addChildren(nodes);
        }
        const stage = this.getStage();
        if (that.nodeType !== $10b3b0e56d39035f$var$UPPER_STAGE && stage) addChildren(stage.getChildren());
        return index;
    }
    getDepth() {
        var depth = 0, parent = this.parent;
        while(parent){
            depth++;
            parent = parent.parent;
        }
        return depth;
    }
    _batchTransformChanges(func) {
        this._batchingTransformChange = true;
        func();
        this._batchingTransformChange = false;
        if (this._needClearTransformCache) {
            this._clearCache($10b3b0e56d39035f$var$TRANSFORM);
            this._clearSelfAndDescendantCache($10b3b0e56d39035f$var$ABSOLUTE_TRANSFORM);
        }
        this._needClearTransformCache = false;
    }
    setPosition(pos) {
        this._batchTransformChanges(()=>{
            this.x(pos.x);
            this.y(pos.y);
        });
        return this;
    }
    getPosition() {
        return {
            x: this.x(),
            y: this.y()
        };
    }
    getRelativePointerPosition() {
        const stage = this.getStage();
        if (!stage) return null;
        var pos = stage.getPointerPosition();
        if (!pos) return null;
        var transform = this.getAbsoluteTransform().copy();
        transform.invert();
        return transform.point(pos);
    }
    getAbsolutePosition(top) {
        let haveCachedParent = false;
        let parent = this.parent;
        while(parent){
            if (parent.isCached()) {
                haveCachedParent = true;
                break;
            }
            parent = parent.parent;
        }
        if (haveCachedParent && !top) top = true;
        var absoluteMatrix = this.getAbsoluteTransform(top).getMatrix(), absoluteTransform = new $kWs5g.Transform(), offset = this.offset();
        absoluteTransform.m = absoluteMatrix.slice();
        absoluteTransform.translate(offset.x, offset.y);
        return absoluteTransform.getTranslation();
    }
    setAbsolutePosition(pos) {
        const { x: x, y: y, ...origTrans } = this._clearTransform();
        this.attrs.x = x;
        this.attrs.y = y;
        this._clearCache($10b3b0e56d39035f$var$TRANSFORM);
        var it = this._getAbsoluteTransform().copy();
        it.invert();
        it.translate(pos.x, pos.y);
        pos = {
            x: this.attrs.x + it.getTranslation().x,
            y: this.attrs.y + it.getTranslation().y
        };
        this._setTransform(origTrans);
        this.setPosition({
            x: pos.x,
            y: pos.y
        });
        this._clearCache($10b3b0e56d39035f$var$TRANSFORM);
        this._clearSelfAndDescendantCache($10b3b0e56d39035f$var$ABSOLUTE_TRANSFORM);
        return this;
    }
    _setTransform(trans) {
        var key;
        for(key in trans)this.attrs[key] = trans[key];
    }
    _clearTransform() {
        var trans = {
            x: this.x(),
            y: this.y(),
            rotation: this.rotation(),
            scaleX: this.scaleX(),
            scaleY: this.scaleY(),
            offsetX: this.offsetX(),
            offsetY: this.offsetY(),
            skewX: this.skewX(),
            skewY: this.skewY()
        };
        this.attrs.x = 0;
        this.attrs.y = 0;
        this.attrs.rotation = 0;
        this.attrs.scaleX = 1;
        this.attrs.scaleY = 1;
        this.attrs.offsetX = 0;
        this.attrs.offsetY = 0;
        this.attrs.skewX = 0;
        this.attrs.skewY = 0;
        return trans;
    }
    move(change) {
        var changeX = change.x, changeY = change.y, x = this.x(), y = this.y();
        if (changeX !== undefined) x += changeX;
        if (changeY !== undefined) y += changeY;
        this.setPosition({
            x: x,
            y: y
        });
        return this;
    }
    _eachAncestorReverse(func, top) {
        var family = [], parent = this.getParent(), len, n;
        if (top && top._id === this._id) return;
        family.unshift(this);
        while(parent && (!top || parent._id !== top._id)){
            family.unshift(parent);
            parent = parent.parent;
        }
        len = family.length;
        for(n = 0; n < len; n++)func(family[n]);
    }
    rotate(theta) {
        this.rotation(this.rotation() + theta);
        return this;
    }
    moveToTop() {
        if (!this.parent) {
            $kWs5g.Util.warn("Node has no parent. moveToTop function is ignored.");
            return false;
        }
        var index = this.index, len = this.parent.getChildren().length;
        if (index < len - 1) {
            this.parent.children.splice(index, 1);
            this.parent.children.push(this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    moveUp() {
        if (!this.parent) {
            $kWs5g.Util.warn("Node has no parent. moveUp function is ignored.");
            return false;
        }
        var index = this.index, len = this.parent.getChildren().length;
        if (index < len - 1) {
            this.parent.children.splice(index, 1);
            this.parent.children.splice(index + 1, 0, this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    moveDown() {
        if (!this.parent) {
            $kWs5g.Util.warn("Node has no parent. moveDown function is ignored.");
            return false;
        }
        var index = this.index;
        if (index > 0) {
            this.parent.children.splice(index, 1);
            this.parent.children.splice(index - 1, 0, this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    moveToBottom() {
        if (!this.parent) {
            $kWs5g.Util.warn("Node has no parent. moveToBottom function is ignored.");
            return false;
        }
        var index = this.index;
        if (index > 0) {
            this.parent.children.splice(index, 1);
            this.parent.children.unshift(this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    setZIndex(zIndex) {
        if (!this.parent) {
            $kWs5g.Util.warn("Node has no parent. zIndex parameter is ignored.");
            return this;
        }
        if (zIndex < 0 || zIndex >= this.parent.children.length) $kWs5g.Util.warn("Unexpected value " + zIndex + " for zIndex property. zIndex is just index of a node in children of its parent. Expected value is from 0 to " + (this.parent.children.length - 1) + ".");
        var index = this.index;
        this.parent.children.splice(index, 1);
        this.parent.children.splice(zIndex, 0, this);
        this.parent._setChildrenIndices();
        return this;
    }
    getAbsoluteOpacity() {
        return this._getCache($10b3b0e56d39035f$var$ABSOLUTE_OPACITY, this._getAbsoluteOpacity);
    }
    _getAbsoluteOpacity() {
        var absOpacity = this.opacity();
        var parent = this.getParent();
        if (parent && !parent._isUnderCache) absOpacity *= parent.getAbsoluteOpacity();
        return absOpacity;
    }
    moveTo(newContainer) {
        if (this.getParent() !== newContainer) {
            this._remove();
            newContainer.add(this);
        }
        return this;
    }
    toObject() {
        var attrs = this.getAttrs(), key, val, getter, defaultValue, nonPlainObject;
        const obj = {
            attrs: {},
            className: this.getClassName()
        };
        for(key in attrs){
            val = attrs[key];
            nonPlainObject = $kWs5g.Util.isObject(val) && !$kWs5g.Util._isPlainObject(val) && !$kWs5g.Util._isArray(val);
            if (nonPlainObject) continue;
            getter = typeof this[key] === "function" && this[key];
            delete attrs[key];
            defaultValue = getter ? getter.call(this) : null;
            attrs[key] = val;
            if (defaultValue !== val) obj.attrs[key] = val;
        }
        return $kWs5g.Util._prepareToStringify(obj);
    }
    toJSON() {
        return JSON.stringify(this.toObject());
    }
    getParent() {
        return this.parent;
    }
    findAncestors(selector, includeSelf, stopNode) {
        var res = [];
        if (includeSelf && this._isMatch(selector)) res.push(this);
        var ancestor = this.parent;
        while(ancestor){
            if (ancestor === stopNode) return res;
            if (ancestor._isMatch(selector)) res.push(ancestor);
            ancestor = ancestor.parent;
        }
        return res;
    }
    isAncestorOf(node) {
        return false;
    }
    findAncestor(selector, includeSelf, stopNode) {
        return this.findAncestors(selector, includeSelf, stopNode)[0];
    }
    _isMatch(selector) {
        if (!selector) return false;
        if (typeof selector === "function") return selector(this);
        var selectorArr = selector.replace(/ /g, "").split(","), len = selectorArr.length, n, sel;
        for(n = 0; n < len; n++){
            sel = selectorArr[n];
            if (!$kWs5g.Util.isValidSelector(sel)) {
                $kWs5g.Util.warn('Selector "' + sel + '" is invalid. Allowed selectors examples are "#foo", ".bar" or "Group".');
                $kWs5g.Util.warn('If you have a custom shape with such className, please change it to start with upper letter like "Triangle".');
                $kWs5g.Util.warn("Konva is awesome, right?");
            }
            if (sel.charAt(0) === "#") {
                if (this.id() === sel.slice(1)) return true;
            } else if (sel.charAt(0) === ".") {
                if (this.hasName(sel.slice(1))) return true;
            } else if (this.className === sel || this.nodeType === sel) return true;
        }
        return false;
    }
    getLayer() {
        var parent = this.getParent();
        return parent ? parent.getLayer() : null;
    }
    getStage() {
        return this._getCache($10b3b0e56d39035f$var$STAGE, this._getStage);
    }
    _getStage() {
        var parent = this.getParent();
        if (parent) return parent.getStage();
        else return null;
    }
    fire(eventType, evt = {}, bubble) {
        evt.target = evt.target || this;
        if (bubble) this._fireAndBubble(eventType, evt);
        else this._fire(eventType, evt);
        return this;
    }
    getAbsoluteTransform(top) {
        if (top) return this._getAbsoluteTransform(top);
        else return this._getCache($10b3b0e56d39035f$var$ABSOLUTE_TRANSFORM, this._getAbsoluteTransform);
    }
    _getAbsoluteTransform(top) {
        var at;
        if (top) {
            at = new $kWs5g.Transform();
            this._eachAncestorReverse(function(node) {
                var transformsEnabled = node.transformsEnabled();
                if (transformsEnabled === "all") at.multiply(node.getTransform());
                else if (transformsEnabled === "position") at.translate(node.x() - node.offsetX(), node.y() - node.offsetY());
            }, top);
            return at;
        } else {
            at = this._cache.get($10b3b0e56d39035f$var$ABSOLUTE_TRANSFORM) || new $kWs5g.Transform();
            if (this.parent) this.parent.getAbsoluteTransform().copyInto(at);
            else at.reset();
            var transformsEnabled = this.transformsEnabled();
            if (transformsEnabled === "all") at.multiply(this.getTransform());
            else if (transformsEnabled === "position") {
                const x = this.attrs.x || 0;
                const y = this.attrs.y || 0;
                const offsetX = this.attrs.offsetX || 0;
                const offsetY = this.attrs.offsetY || 0;
                at.translate(x - offsetX, y - offsetY);
            }
            at.dirty = false;
            return at;
        }
    }
    getAbsoluteScale(top) {
        var parent = this;
        while(parent){
            if (parent._isUnderCache) top = parent;
            parent = parent.getParent();
        }
        const transform = this.getAbsoluteTransform(top);
        const attrs = transform.decompose();
        return {
            x: attrs.scaleX,
            y: attrs.scaleY
        };
    }
    getAbsoluteRotation() {
        return this.getAbsoluteTransform().decompose().rotation;
    }
    getTransform() {
        return this._getCache($10b3b0e56d39035f$var$TRANSFORM, this._getTransform);
    }
    _getTransform() {
        var _a, _b;
        var m = this._cache.get($10b3b0e56d39035f$var$TRANSFORM) || new $kWs5g.Transform();
        m.reset();
        var x = this.x(), y = this.y(), rotation = $4v96z.Konva.getAngle(this.rotation()), scaleX = (_a = this.attrs.scaleX) !== null && _a !== void 0 ? _a : 1, scaleY = (_b = this.attrs.scaleY) !== null && _b !== void 0 ? _b : 1, skewX = this.attrs.skewX || 0, skewY = this.attrs.skewY || 0, offsetX = this.attrs.offsetX || 0, offsetY = this.attrs.offsetY || 0;
        if (x !== 0 || y !== 0) m.translate(x, y);
        if (rotation !== 0) m.rotate(rotation);
        if (skewX !== 0 || skewY !== 0) m.skew(skewX, skewY);
        if (scaleX !== 1 || scaleY !== 1) m.scale(scaleX, scaleY);
        if (offsetX !== 0 || offsetY !== 0) m.translate(-1 * offsetX, -1 * offsetY);
        m.dirty = false;
        return m;
    }
    clone(obj) {
        var attrs = $kWs5g.Util.cloneObject(this.attrs), key, allListeners, len, n, listener;
        for(key in obj)attrs[key] = obj[key];
        var node = new this.constructor(attrs);
        for(key in this.eventListeners){
            allListeners = this.eventListeners[key];
            len = allListeners.length;
            for(n = 0; n < len; n++){
                listener = allListeners[n];
                if (listener.name.indexOf($10b3b0e56d39035f$var$KONVA) < 0) {
                    if (!node.eventListeners[key]) node.eventListeners[key] = [];
                    node.eventListeners[key].push(listener);
                }
            }
        }
        return node;
    }
    _toKonvaCanvas(config) {
        config = config || {};
        var box = this.getClientRect();
        var stage = this.getStage(), x = config.x !== undefined ? config.x : Math.floor(box.x), y = config.y !== undefined ? config.y : Math.floor(box.y), pixelRatio = config.pixelRatio || 1, canvas = new $bsljL.SceneCanvas({
            width: config.width || Math.ceil(box.width) || (stage ? stage.width() : 0),
            height: config.height || Math.ceil(box.height) || (stage ? stage.height() : 0),
            pixelRatio: pixelRatio
        }), context = canvas.getContext();
        const bufferCanvas = new $bsljL.SceneCanvas({
            width: canvas.width / canvas.pixelRatio + Math.abs(x),
            height: canvas.height / canvas.pixelRatio + Math.abs(y),
            pixelRatio: canvas.pixelRatio
        });
        if (config.imageSmoothingEnabled === false) context._context.imageSmoothingEnabled = false;
        context.save();
        if (x || y) context.translate(-1 * x, -1 * y);
        this.drawScene(canvas, undefined, bufferCanvas);
        context.restore();
        return canvas;
    }
    toCanvas(config) {
        return this._toKonvaCanvas(config)._canvas;
    }
    toDataURL(config) {
        config = config || {};
        var mimeType = config.mimeType || null, quality = config.quality || null;
        var url = this._toKonvaCanvas(config).toDataURL(mimeType, quality);
        if (config.callback) config.callback(url);
        return url;
    }
    toImage(config) {
        return new Promise((resolve, reject)=>{
            try {
                const callback = config === null || config === void 0 ? void 0 : config.callback;
                if (callback) delete config.callback;
                $kWs5g.Util._urlToImage(this.toDataURL(config), function(img) {
                    resolve(img);
                    callback === null || callback === void 0 || callback(img);
                });
            } catch (err) {
                reject(err);
            }
        });
    }
    toBlob(config) {
        return new Promise((resolve, reject)=>{
            try {
                const callback = config === null || config === void 0 ? void 0 : config.callback;
                if (callback) delete config.callback;
                this.toCanvas(config).toBlob((blob)=>{
                    resolve(blob);
                    callback === null || callback === void 0 || callback(blob);
                }, config === null || config === void 0 ? void 0 : config.mimeType, config === null || config === void 0 ? void 0 : config.quality);
            } catch (err) {
                reject(err);
            }
        });
    }
    setSize(size) {
        this.width(size.width);
        this.height(size.height);
        return this;
    }
    getSize() {
        return {
            width: this.width(),
            height: this.height()
        };
    }
    getClassName() {
        return this.className || this.nodeType;
    }
    getType() {
        return this.nodeType;
    }
    getDragDistance() {
        if (this.attrs.dragDistance !== undefined) return this.attrs.dragDistance;
        else if (this.parent) return this.parent.getDragDistance();
        else return $4v96z.Konva.dragDistance;
    }
    _off(type, name, callback) {
        var evtListeners = this.eventListeners[type], i, evtName, handler;
        for(i = 0; i < evtListeners.length; i++){
            evtName = evtListeners[i].name;
            handler = evtListeners[i].handler;
            if ((evtName !== "konva" || name === "konva") && (!name || evtName === name) && (!callback || callback === handler)) {
                evtListeners.splice(i, 1);
                if (evtListeners.length === 0) {
                    delete this.eventListeners[type];
                    break;
                }
                i--;
            }
        }
    }
    _fireChangeEvent(attr, oldVal, newVal) {
        this._fire(attr + $10b3b0e56d39035f$var$CHANGE, {
            oldVal: oldVal,
            newVal: newVal
        });
    }
    addName(name) {
        if (!this.hasName(name)) {
            var oldName = this.name();
            var newName = oldName ? oldName + " " + name : name;
            this.name(newName);
        }
        return this;
    }
    hasName(name) {
        if (!name) return false;
        const fullName = this.name();
        if (!fullName) return false;
        var names = (fullName || "").split(/\s/g);
        return names.indexOf(name) !== -1;
    }
    removeName(name) {
        var names = (this.name() || "").split(/\s/g);
        var index = names.indexOf(name);
        if (index !== -1) {
            names.splice(index, 1);
            this.name(names.join(" "));
        }
        return this;
    }
    setAttr(attr, val) {
        var func = this[$10b3b0e56d39035f$var$SET + $kWs5g.Util._capitalize(attr)];
        if ($kWs5g.Util._isFunction(func)) func.call(this, val);
        else this._setAttr(attr, val);
        return this;
    }
    _requestDraw() {
        if ($4v96z.Konva.autoDrawEnabled) {
            const drawNode = this.getLayer() || this.getStage();
            drawNode === null || drawNode === void 0 || drawNode.batchDraw();
        }
    }
    _setAttr(key, val) {
        var oldVal = this.attrs[key];
        if (oldVal === val && !$kWs5g.Util.isObject(val)) return;
        if (val === undefined || val === null) delete this.attrs[key];
        else this.attrs[key] = val;
        if (this._shouldFireChangeEvents) this._fireChangeEvent(key, oldVal, val);
        this._requestDraw();
    }
    _setComponentAttr(key, component, val) {
        var oldVal;
        if (val !== undefined) {
            oldVal = this.attrs[key];
            if (!oldVal) this.attrs[key] = this.getAttr(key);
            this.attrs[key][component] = val;
            this._fireChangeEvent(key, oldVal, val);
        }
    }
    _fireAndBubble(eventType, evt, compareShape) {
        if (evt && this.nodeType === $10b3b0e56d39035f$var$SHAPE) evt.target = this;
        var shouldStop = (eventType === $10b3b0e56d39035f$var$MOUSEENTER || eventType === $10b3b0e56d39035f$var$MOUSELEAVE) && (compareShape && (this === compareShape || this.isAncestorOf && this.isAncestorOf(compareShape)) || this.nodeType === "Stage" && !compareShape);
        if (!shouldStop) {
            this._fire(eventType, evt);
            var stopBubble = (eventType === $10b3b0e56d39035f$var$MOUSEENTER || eventType === $10b3b0e56d39035f$var$MOUSELEAVE) && compareShape && compareShape.isAncestorOf && compareShape.isAncestorOf(this) && !compareShape.isAncestorOf(this.parent);
            if ((evt && !evt.cancelBubble || !evt) && this.parent && this.parent.isListening() && !stopBubble) {
                if (compareShape && compareShape.parent) this._fireAndBubble.call(this.parent, eventType, evt, compareShape);
                else this._fireAndBubble.call(this.parent, eventType, evt);
            }
        }
    }
    _getProtoListeners(eventType) {
        var _a, _b, _c;
        const allListeners = (_a = this._cache.get($10b3b0e56d39035f$var$ALL_LISTENERS)) !== null && _a !== void 0 ? _a : {};
        let events = allListeners === null || allListeners === void 0 ? void 0 : allListeners[eventType];
        if (events === undefined) {
            events = [];
            let obj = Object.getPrototypeOf(this);
            while(obj){
                const hierarchyEvents = (_c = (_b = obj.eventListeners) === null || _b === void 0 ? void 0 : _b[eventType]) !== null && _c !== void 0 ? _c : [];
                events.push(...hierarchyEvents);
                obj = Object.getPrototypeOf(obj);
            }
            allListeners[eventType] = events;
            this._cache.set($10b3b0e56d39035f$var$ALL_LISTENERS, allListeners);
        }
        return events;
    }
    _fire(eventType, evt) {
        evt = evt || {};
        evt.currentTarget = this;
        evt.type = eventType;
        const topListeners = this._getProtoListeners(eventType);
        if (topListeners) for(var i = 0; i < topListeners.length; i++)topListeners[i].handler.call(this, evt);
        const selfListeners = this.eventListeners[eventType];
        if (selfListeners) for(var i = 0; i < selfListeners.length; i++)selfListeners[i].handler.call(this, evt);
    }
    draw() {
        this.drawScene();
        this.drawHit();
        return this;
    }
    _createDragElement(evt) {
        var pointerId = evt ? evt.pointerId : undefined;
        var stage = this.getStage();
        var ap = this.getAbsolutePosition();
        if (!stage) return;
        var pos = stage._getPointerById(pointerId) || stage._changedPointerPositions[0] || ap;
        $d8LUf.DD._dragElements.set(this._id, {
            node: this,
            startPointerPos: pos,
            offset: {
                x: pos.x - ap.x,
                y: pos.y - ap.y
            },
            dragStatus: "ready",
            pointerId: pointerId
        });
    }
    startDrag(evt, bubbleEvent = true) {
        if (!$d8LUf.DD._dragElements.has(this._id)) this._createDragElement(evt);
        const elem = $d8LUf.DD._dragElements.get(this._id);
        elem.dragStatus = "dragging";
        this.fire("dragstart", {
            type: "dragstart",
            target: this,
            evt: evt && evt.evt
        }, bubbleEvent);
    }
    _setDragPosition(evt, elem) {
        const pos = this.getStage()._getPointerById(elem.pointerId);
        if (!pos) return;
        var newNodePos = {
            x: pos.x - elem.offset.x,
            y: pos.y - elem.offset.y
        };
        var dbf = this.dragBoundFunc();
        if (dbf !== undefined) {
            const bounded = dbf.call(this, newNodePos, evt);
            if (!bounded) $kWs5g.Util.warn("dragBoundFunc did not return any value. That is unexpected behavior. You must return new absolute position from dragBoundFunc.");
            else newNodePos = bounded;
        }
        if (!this._lastPos || this._lastPos.x !== newNodePos.x || this._lastPos.y !== newNodePos.y) {
            this.setAbsolutePosition(newNodePos);
            this._requestDraw();
        }
        this._lastPos = newNodePos;
    }
    stopDrag(evt) {
        const elem = $d8LUf.DD._dragElements.get(this._id);
        if (elem) elem.dragStatus = "stopped";
        $d8LUf.DD._endDragBefore(evt);
        $d8LUf.DD._endDragAfter(evt);
    }
    setDraggable(draggable) {
        this._setAttr("draggable", draggable);
        this._dragChange();
    }
    isDragging() {
        const elem = $d8LUf.DD._dragElements.get(this._id);
        return elem ? elem.dragStatus === "dragging" : false;
    }
    _listenDrag() {
        this._dragCleanup();
        this.on("mousedown.konva touchstart.konva", function(evt) {
            var shouldCheckButton = evt.evt["button"] !== undefined;
            var canDrag = !shouldCheckButton || $4v96z.Konva.dragButtons.indexOf(evt.evt["button"]) >= 0;
            if (!canDrag) return;
            if (this.isDragging()) return;
            var hasDraggingChild = false;
            $d8LUf.DD._dragElements.forEach((elem)=>{
                if (this.isAncestorOf(elem.node)) hasDraggingChild = true;
            });
            if (!hasDraggingChild) this._createDragElement(evt);
        });
    }
    _dragChange() {
        if (this.attrs.draggable) this._listenDrag();
        else {
            this._dragCleanup();
            var stage = this.getStage();
            if (!stage) return;
            const dragElement = $d8LUf.DD._dragElements.get(this._id);
            const isDragging = dragElement && dragElement.dragStatus === "dragging";
            const isReady = dragElement && dragElement.dragStatus === "ready";
            if (isDragging) this.stopDrag();
            else if (isReady) $d8LUf.DD._dragElements.delete(this._id);
        }
    }
    _dragCleanup() {
        this.off("mousedown.konva");
        this.off("touchstart.konva");
    }
    isClientRectOnScreen(margin = {
        x: 0,
        y: 0
    }) {
        const stage = this.getStage();
        if (!stage) return false;
        const screenRect = {
            x: -margin.x,
            y: -margin.y,
            width: stage.width() + 2 * margin.x,
            height: stage.height() + 2 * margin.y
        };
        return $kWs5g.Util.haveIntersection(screenRect, this.getClientRect());
    }
    static create(data, container) {
        if ($kWs5g.Util._isString(data)) data = JSON.parse(data);
        return this._createNode(data, container);
    }
    static _createNode(obj, container) {
        var className = $10b3b0e56d39035f$var$Node.prototype.getClassName.call(obj), children = obj.children, no, len, n;
        if (container) obj.attrs.container = container;
        if (!$4v96z.Konva[className]) {
            $kWs5g.Util.warn('Can not find a node with class name "' + className + '". Fallback to "Shape".');
            className = "Shape";
        }
        const Class = $4v96z.Konva[className];
        no = new Class(obj.attrs);
        if (children) {
            len = children.length;
            for(n = 0; n < len; n++)no.add($10b3b0e56d39035f$var$Node._createNode(children[n]));
        }
        return no;
    }
}
module.exports.Node = $10b3b0e56d39035f$var$Node;
$10b3b0e56d39035f$var$Node.prototype.nodeType = "Node";
$10b3b0e56d39035f$var$Node.prototype._attrsAffectingSize = [];
$10b3b0e56d39035f$var$Node.prototype.eventListeners = {};
$10b3b0e56d39035f$var$Node.prototype.on.call($10b3b0e56d39035f$var$Node.prototype, $10b3b0e56d39035f$var$TRANSFORM_CHANGE_STR, function() {
    if (this._batchingTransformChange) {
        this._needClearTransformCache = true;
        return;
    }
    this._clearCache($10b3b0e56d39035f$var$TRANSFORM);
    this._clearSelfAndDescendantCache($10b3b0e56d39035f$var$ABSOLUTE_TRANSFORM);
});
$10b3b0e56d39035f$var$Node.prototype.on.call($10b3b0e56d39035f$var$Node.prototype, "visibleChange.konva", function() {
    this._clearSelfAndDescendantCache($10b3b0e56d39035f$var$VISIBLE);
});
$10b3b0e56d39035f$var$Node.prototype.on.call($10b3b0e56d39035f$var$Node.prototype, "listeningChange.konva", function() {
    this._clearSelfAndDescendantCache($10b3b0e56d39035f$var$LISTENING);
});
$10b3b0e56d39035f$var$Node.prototype.on.call($10b3b0e56d39035f$var$Node.prototype, "opacityChange.konva", function() {
    this._clearSelfAndDescendantCache($10b3b0e56d39035f$var$ABSOLUTE_OPACITY);
});
const $10b3b0e56d39035f$var$addGetterSetter = $3V3su.Factory.addGetterSetter;
$10b3b0e56d39035f$var$addGetterSetter($10b3b0e56d39035f$var$Node, "zIndex");
$10b3b0e56d39035f$var$addGetterSetter($10b3b0e56d39035f$var$Node, "absolutePosition");
$10b3b0e56d39035f$var$addGetterSetter($10b3b0e56d39035f$var$Node, "position");
$10b3b0e56d39035f$var$addGetterSetter($10b3b0e56d39035f$var$Node, "x", 0, (0, $2TXYV.getNumberValidator)());
$10b3b0e56d39035f$var$addGetterSetter($10b3b0e56d39035f$var$Node, "y", 0, (0, $2TXYV.getNumberValidator)());
$10b3b0e56d39035f$var$addGetterSetter($10b3b0e56d39035f$var$Node, "globalCompositeOperation", "source-over", (0, $2TXYV.getStringValidator)());
$10b3b0e56d39035f$var$addGetterSetter($10b3b0e56d39035f$var$Node, "opacity", 1, (0, $2TXYV.getNumberValidator)());
$10b3b0e56d39035f$var$addGetterSetter($10b3b0e56d39035f$var$Node, "name", "", (0, $2TXYV.getStringValidator)());
$10b3b0e56d39035f$var$addGetterSetter($10b3b0e56d39035f$var$Node, "id", "", (0, $2TXYV.getStringValidator)());
$10b3b0e56d39035f$var$addGetterSetter($10b3b0e56d39035f$var$Node, "rotation", 0, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addComponentsGetterSetter($10b3b0e56d39035f$var$Node, "scale", [
    "x",
    "y"
]);
$10b3b0e56d39035f$var$addGetterSetter($10b3b0e56d39035f$var$Node, "scaleX", 1, (0, $2TXYV.getNumberValidator)());
$10b3b0e56d39035f$var$addGetterSetter($10b3b0e56d39035f$var$Node, "scaleY", 1, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addComponentsGetterSetter($10b3b0e56d39035f$var$Node, "skew", [
    "x",
    "y"
]);
$10b3b0e56d39035f$var$addGetterSetter($10b3b0e56d39035f$var$Node, "skewX", 0, (0, $2TXYV.getNumberValidator)());
$10b3b0e56d39035f$var$addGetterSetter($10b3b0e56d39035f$var$Node, "skewY", 0, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addComponentsGetterSetter($10b3b0e56d39035f$var$Node, "offset", [
    "x",
    "y"
]);
$10b3b0e56d39035f$var$addGetterSetter($10b3b0e56d39035f$var$Node, "offsetX", 0, (0, $2TXYV.getNumberValidator)());
$10b3b0e56d39035f$var$addGetterSetter($10b3b0e56d39035f$var$Node, "offsetY", 0, (0, $2TXYV.getNumberValidator)());
$10b3b0e56d39035f$var$addGetterSetter($10b3b0e56d39035f$var$Node, "dragDistance", null, (0, $2TXYV.getNumberValidator)());
$10b3b0e56d39035f$var$addGetterSetter($10b3b0e56d39035f$var$Node, "width", 0, (0, $2TXYV.getNumberValidator)());
$10b3b0e56d39035f$var$addGetterSetter($10b3b0e56d39035f$var$Node, "height", 0, (0, $2TXYV.getNumberValidator)());
$10b3b0e56d39035f$var$addGetterSetter($10b3b0e56d39035f$var$Node, "listening", true, (0, $2TXYV.getBooleanValidator)());
$10b3b0e56d39035f$var$addGetterSetter($10b3b0e56d39035f$var$Node, "preventDefault", true, (0, $2TXYV.getBooleanValidator)());
$10b3b0e56d39035f$var$addGetterSetter($10b3b0e56d39035f$var$Node, "filters", null, function(val) {
    this._filterUpToDate = false;
    return val;
});
$10b3b0e56d39035f$var$addGetterSetter($10b3b0e56d39035f$var$Node, "visible", true, (0, $2TXYV.getBooleanValidator)());
$10b3b0e56d39035f$var$addGetterSetter($10b3b0e56d39035f$var$Node, "transformsEnabled", "all", (0, $2TXYV.getStringValidator)());
$10b3b0e56d39035f$var$addGetterSetter($10b3b0e56d39035f$var$Node, "size");
$10b3b0e56d39035f$var$addGetterSetter($10b3b0e56d39035f$var$Node, "dragBoundFunc");
$10b3b0e56d39035f$var$addGetterSetter($10b3b0e56d39035f$var$Node, "draggable", false, (0, $2TXYV.getBooleanValidator)());
$3V3su.Factory.backCompat($10b3b0e56d39035f$var$Node, {
    rotateDeg: "rotate",
    setRotationDeg: "setRotation",
    getRotationDeg: "getRotation"
});

});
parcelRegister("3V3su", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Factory = void 0;

var $kWs5g = parcelRequire("kWs5g");

var $2TXYV = parcelRequire("2TXYV");
var $2da960c682f277af$var$GET = "get", $2da960c682f277af$var$SET = "set";
module.exports.Factory = {
    addGetterSetter (constructor, attr, def, validator, after) {
        module.exports.Factory.addGetter(constructor, attr, def);
        module.exports.Factory.addSetter(constructor, attr, validator, after);
        module.exports.Factory.addOverloadedGetterSetter(constructor, attr);
    },
    addGetter (constructor, attr, def) {
        var method = $2da960c682f277af$var$GET + $kWs5g.Util._capitalize(attr);
        constructor.prototype[method] = constructor.prototype[method] || function() {
            var val = this.attrs[attr];
            return val === undefined ? def : val;
        };
    },
    addSetter (constructor, attr, validator, after) {
        var method = $2da960c682f277af$var$SET + $kWs5g.Util._capitalize(attr);
        if (!constructor.prototype[method]) module.exports.Factory.overWriteSetter(constructor, attr, validator, after);
    },
    overWriteSetter (constructor, attr, validator, after) {
        var method = $2da960c682f277af$var$SET + $kWs5g.Util._capitalize(attr);
        constructor.prototype[method] = function(val) {
            if (validator && val !== undefined && val !== null) val = validator.call(this, val, attr);
            this._setAttr(attr, val);
            if (after) after.call(this);
            return this;
        };
    },
    addComponentsGetterSetter (constructor, attr, components, validator, after) {
        var len = components.length, capitalize = $kWs5g.Util._capitalize, getter = $2da960c682f277af$var$GET + capitalize(attr), setter = $2da960c682f277af$var$SET + capitalize(attr), n, component;
        constructor.prototype[getter] = function() {
            var ret = {};
            for(n = 0; n < len; n++){
                component = components[n];
                ret[component] = this.getAttr(attr + capitalize(component));
            }
            return ret;
        };
        var basicValidator = (0, $2TXYV.getComponentValidator)(components);
        constructor.prototype[setter] = function(val) {
            var oldVal = this.attrs[attr], key;
            if (validator) val = validator.call(this, val);
            if (basicValidator) basicValidator.call(this, val, attr);
            for(key in val){
                if (!val.hasOwnProperty(key)) continue;
                this._setAttr(attr + capitalize(key), val[key]);
            }
            if (!val) components.forEach((component)=>{
                this._setAttr(attr + capitalize(component), undefined);
            });
            this._fireChangeEvent(attr, oldVal, val);
            if (after) after.call(this);
            return this;
        };
        module.exports.Factory.addOverloadedGetterSetter(constructor, attr);
    },
    addOverloadedGetterSetter (constructor, attr) {
        var capitalizedAttr = $kWs5g.Util._capitalize(attr), setter = $2da960c682f277af$var$SET + capitalizedAttr, getter = $2da960c682f277af$var$GET + capitalizedAttr;
        constructor.prototype[attr] = function() {
            if (arguments.length) {
                this[setter](arguments[0]);
                return this;
            }
            return this[getter]();
        };
    },
    addDeprecatedGetterSetter (constructor, attr, def, validator) {
        $kWs5g.Util.error("Adding deprecated " + attr);
        var method = $2da960c682f277af$var$GET + $kWs5g.Util._capitalize(attr);
        var message = attr + " property is deprecated and will be removed soon. Look at Konva change log for more information.";
        constructor.prototype[method] = function() {
            $kWs5g.Util.error(message);
            var val = this.attrs[attr];
            return val === undefined ? def : val;
        };
        module.exports.Factory.addSetter(constructor, attr, validator, function() {
            $kWs5g.Util.error(message);
        });
        module.exports.Factory.addOverloadedGetterSetter(constructor, attr);
    },
    backCompat (constructor, methods) {
        $kWs5g.Util.each(methods, function(oldMethodName, newMethodName) {
            var method = constructor.prototype[newMethodName];
            var oldGetter = $2da960c682f277af$var$GET + $kWs5g.Util._capitalize(oldMethodName);
            var oldSetter = $2da960c682f277af$var$SET + $kWs5g.Util._capitalize(oldMethodName);
            function deprecated() {
                method.apply(this, arguments);
                $kWs5g.Util.error('"' + oldMethodName + '" method is deprecated and will be removed soon. Use ""' + newMethodName + '" instead.');
            }
            constructor.prototype[oldMethodName] = deprecated;
            constructor.prototype[oldGetter] = deprecated;
            constructor.prototype[oldSetter] = deprecated;
        });
    },
    afterSetFilter () {
        this._filterUpToDate = false;
    }
};

});
parcelRegister("2TXYV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getComponentValidator = module.exports.getBooleanValidator = module.exports.getNumberArrayValidator = module.exports.getFunctionValidator = module.exports.getStringOrGradientValidator = module.exports.getStringValidator = module.exports.getNumberOrAutoValidator = module.exports.getNumberOrArrayOfNumbersValidator = module.exports.getNumberValidator = module.exports.alphaComponent = module.exports.RGBComponent = void 0;

var $4v96z = parcelRequire("4v96z");

var $kWs5g = parcelRequire("kWs5g");
function $21cf3eeb4f5796da$var$_formatValue(val) {
    if ($kWs5g.Util._isString(val)) return '"' + val + '"';
    if (Object.prototype.toString.call(val) === "[object Number]") return val;
    if ($kWs5g.Util._isBoolean(val)) return val;
    return Object.prototype.toString.call(val);
}
function $21cf3eeb4f5796da$var$RGBComponent(val) {
    if (val > 255) return 255;
    else if (val < 0) return 0;
    return Math.round(val);
}
module.exports.RGBComponent = $21cf3eeb4f5796da$var$RGBComponent;
function $21cf3eeb4f5796da$var$alphaComponent(val) {
    if (val > 1) return 1;
    else if (val < 0.0001) return 0.0001;
    return val;
}
module.exports.alphaComponent = $21cf3eeb4f5796da$var$alphaComponent;
function $21cf3eeb4f5796da$var$getNumberValidator() {
    if ($4v96z.Konva.isUnminified) return function(val, attr) {
        if (!$kWs5g.Util._isNumber(val)) $kWs5g.Util.warn($21cf3eeb4f5796da$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a number.');
        return val;
    };
}
module.exports.getNumberValidator = $21cf3eeb4f5796da$var$getNumberValidator;
function $21cf3eeb4f5796da$var$getNumberOrArrayOfNumbersValidator(noOfElements) {
    if ($4v96z.Konva.isUnminified) return function(val, attr) {
        let isNumber = $kWs5g.Util._isNumber(val);
        let isValidArray = $kWs5g.Util._isArray(val) && val.length == noOfElements;
        if (!isNumber && !isValidArray) $kWs5g.Util.warn($21cf3eeb4f5796da$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a number or Array<number>(' + noOfElements + ")");
        return val;
    };
}
module.exports.getNumberOrArrayOfNumbersValidator = $21cf3eeb4f5796da$var$getNumberOrArrayOfNumbersValidator;
function $21cf3eeb4f5796da$var$getNumberOrAutoValidator() {
    if ($4v96z.Konva.isUnminified) return function(val, attr) {
        var isNumber = $kWs5g.Util._isNumber(val);
        var isAuto = val === "auto";
        if (!(isNumber || isAuto)) $kWs5g.Util.warn($21cf3eeb4f5796da$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a number or "auto".');
        return val;
    };
}
module.exports.getNumberOrAutoValidator = $21cf3eeb4f5796da$var$getNumberOrAutoValidator;
function $21cf3eeb4f5796da$var$getStringValidator() {
    if ($4v96z.Konva.isUnminified) return function(val, attr) {
        if (!$kWs5g.Util._isString(val)) $kWs5g.Util.warn($21cf3eeb4f5796da$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a string.');
        return val;
    };
}
module.exports.getStringValidator = $21cf3eeb4f5796da$var$getStringValidator;
function $21cf3eeb4f5796da$var$getStringOrGradientValidator() {
    if ($4v96z.Konva.isUnminified) return function(val, attr) {
        const isString = $kWs5g.Util._isString(val);
        const isGradient = Object.prototype.toString.call(val) === "[object CanvasGradient]" || val && val.addColorStop;
        if (!(isString || isGradient)) $kWs5g.Util.warn($21cf3eeb4f5796da$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a string or a native gradient.');
        return val;
    };
}
module.exports.getStringOrGradientValidator = $21cf3eeb4f5796da$var$getStringOrGradientValidator;
function $21cf3eeb4f5796da$var$getFunctionValidator() {
    if ($4v96z.Konva.isUnminified) return function(val, attr) {
        if (!$kWs5g.Util._isFunction(val)) $kWs5g.Util.warn($21cf3eeb4f5796da$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a function.');
        return val;
    };
}
module.exports.getFunctionValidator = $21cf3eeb4f5796da$var$getFunctionValidator;
function $21cf3eeb4f5796da$var$getNumberArrayValidator() {
    if ($4v96z.Konva.isUnminified) return function(val, attr) {
        const TypedArray = Int8Array ? Object.getPrototypeOf(Int8Array) : null;
        if (TypedArray && val instanceof TypedArray) return val;
        if (!$kWs5g.Util._isArray(val)) $kWs5g.Util.warn($21cf3eeb4f5796da$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a array of numbers.');
        else val.forEach(function(item) {
            if (!$kWs5g.Util._isNumber(item)) $kWs5g.Util.warn('"' + attr + '" attribute has non numeric element ' + item + ". Make sure that all elements are numbers.");
        });
        return val;
    };
}
module.exports.getNumberArrayValidator = $21cf3eeb4f5796da$var$getNumberArrayValidator;
function $21cf3eeb4f5796da$var$getBooleanValidator() {
    if ($4v96z.Konva.isUnminified) return function(val, attr) {
        var isBool = val === true || val === false;
        if (!isBool) $kWs5g.Util.warn($21cf3eeb4f5796da$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a boolean.');
        return val;
    };
}
module.exports.getBooleanValidator = $21cf3eeb4f5796da$var$getBooleanValidator;
function $21cf3eeb4f5796da$var$getComponentValidator(components) {
    if ($4v96z.Konva.isUnminified) return function(val, attr) {
        if (val === undefined || val === null) return val;
        if (!$kWs5g.Util.isObject(val)) $kWs5g.Util.warn($21cf3eeb4f5796da$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be an object with properties ' + components);
        return val;
    };
}
module.exports.getComponentValidator = $21cf3eeb4f5796da$var$getComponentValidator;

});


parcelRegister("bsljL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HitCanvas = module.exports.SceneCanvas = module.exports.Canvas = void 0;

var $kWs5g = parcelRequire("kWs5g");

var $bWu8b = parcelRequire("bWu8b");

var $4v96z = parcelRequire("4v96z");

var $3V3su = parcelRequire("3V3su");

var $2TXYV = parcelRequire("2TXYV");
var $8572d87da73b0f2e$var$_pixelRatio;
function $8572d87da73b0f2e$var$getDevicePixelRatio() {
    if ($8572d87da73b0f2e$var$_pixelRatio) return $8572d87da73b0f2e$var$_pixelRatio;
    var canvas = $kWs5g.Util.createCanvasElement();
    var context = canvas.getContext("2d");
    $8572d87da73b0f2e$var$_pixelRatio = function() {
        var devicePixelRatio = $4v96z.Konva._global.devicePixelRatio || 1, backingStoreRatio = context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio || context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || context.backingStorePixelRatio || 1;
        return devicePixelRatio / backingStoreRatio;
    }();
    $kWs5g.Util.releaseCanvas(canvas);
    return $8572d87da73b0f2e$var$_pixelRatio;
}
class $8572d87da73b0f2e$var$Canvas {
    constructor(config){
        this.pixelRatio = 1;
        this.width = 0;
        this.height = 0;
        this.isCache = false;
        var conf = config || {};
        var pixelRatio = conf.pixelRatio || $4v96z.Konva.pixelRatio || $8572d87da73b0f2e$var$getDevicePixelRatio();
        this.pixelRatio = pixelRatio;
        this._canvas = $kWs5g.Util.createCanvasElement();
        this._canvas.style.padding = "0";
        this._canvas.style.margin = "0";
        this._canvas.style.border = "0";
        this._canvas.style.background = "transparent";
        this._canvas.style.position = "absolute";
        this._canvas.style.top = "0";
        this._canvas.style.left = "0";
    }
    getContext() {
        return this.context;
    }
    getPixelRatio() {
        return this.pixelRatio;
    }
    setPixelRatio(pixelRatio) {
        var previousRatio = this.pixelRatio;
        this.pixelRatio = pixelRatio;
        this.setSize(this.getWidth() / previousRatio, this.getHeight() / previousRatio);
    }
    setWidth(width) {
        this.width = this._canvas.width = width * this.pixelRatio;
        this._canvas.style.width = width + "px";
        var pixelRatio = this.pixelRatio, _context = this.getContext()._context;
        _context.scale(pixelRatio, pixelRatio);
    }
    setHeight(height) {
        this.height = this._canvas.height = height * this.pixelRatio;
        this._canvas.style.height = height + "px";
        var pixelRatio = this.pixelRatio, _context = this.getContext()._context;
        _context.scale(pixelRatio, pixelRatio);
    }
    getWidth() {
        return this.width;
    }
    getHeight() {
        return this.height;
    }
    setSize(width, height) {
        this.setWidth(width || 0);
        this.setHeight(height || 0);
    }
    toDataURL(mimeType, quality) {
        try {
            return this._canvas.toDataURL(mimeType, quality);
        } catch (e) {
            try {
                return this._canvas.toDataURL();
            } catch (err) {
                $kWs5g.Util.error("Unable to get data URL. " + err.message + " For more info read https://konvajs.org/docs/posts/Tainted_Canvas.html.");
                return "";
            }
        }
    }
}
module.exports.Canvas = $8572d87da73b0f2e$var$Canvas;
$3V3su.Factory.addGetterSetter($8572d87da73b0f2e$var$Canvas, "pixelRatio", undefined, (0, $2TXYV.getNumberValidator)());
class $8572d87da73b0f2e$var$SceneCanvas extends $8572d87da73b0f2e$var$Canvas {
    constructor(config = {
        width: 0,
        height: 0,
        willReadFrequently: false
    }){
        super(config);
        this.context = new $bWu8b.SceneContext(this, {
            willReadFrequently: config.willReadFrequently
        });
        this.setSize(config.width, config.height);
    }
}
module.exports.SceneCanvas = $8572d87da73b0f2e$var$SceneCanvas;
class $8572d87da73b0f2e$var$HitCanvas extends $8572d87da73b0f2e$var$Canvas {
    constructor(config = {
        width: 0,
        height: 0
    }){
        super(config);
        this.hitCanvas = true;
        this.context = new $bWu8b.HitContext(this);
        this.setSize(config.width, config.height);
    }
}
module.exports.HitCanvas = $8572d87da73b0f2e$var$HitCanvas;

});
parcelRegister("bWu8b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HitContext = module.exports.SceneContext = module.exports.Context = void 0;

var $kWs5g = parcelRequire("kWs5g");

var $4v96z = parcelRequire("4v96z");
function $8b1c7bdf4c6ac7f0$var$simplifyArray(arr) {
    var retArr = [], len = arr.length, util = $kWs5g.Util, n, val;
    for(n = 0; n < len; n++){
        val = arr[n];
        if (util._isNumber(val)) val = Math.round(val * 1000) / 1000;
        else if (!util._isString(val)) val = val + "";
        retArr.push(val);
    }
    return retArr;
}
var $8b1c7bdf4c6ac7f0$var$COMMA = ",", $8b1c7bdf4c6ac7f0$var$OPEN_PAREN = "(", $8b1c7bdf4c6ac7f0$var$CLOSE_PAREN = ")", $8b1c7bdf4c6ac7f0$var$OPEN_PAREN_BRACKET = "([", $8b1c7bdf4c6ac7f0$var$CLOSE_BRACKET_PAREN = "])", $8b1c7bdf4c6ac7f0$var$SEMICOLON = ";", $8b1c7bdf4c6ac7f0$var$DOUBLE_PAREN = "()", $8b1c7bdf4c6ac7f0$var$EQUALS = "=", $8b1c7bdf4c6ac7f0$var$CONTEXT_METHODS = [
    "arc",
    "arcTo",
    "beginPath",
    "bezierCurveTo",
    "clearRect",
    "clip",
    "closePath",
    "createLinearGradient",
    "createPattern",
    "createRadialGradient",
    "drawImage",
    "ellipse",
    "fill",
    "fillText",
    "getImageData",
    "createImageData",
    "lineTo",
    "moveTo",
    "putImageData",
    "quadraticCurveTo",
    "rect",
    "roundRect",
    "restore",
    "rotate",
    "save",
    "scale",
    "setLineDash",
    "setTransform",
    "stroke",
    "strokeText",
    "transform",
    "translate"
];
var $8b1c7bdf4c6ac7f0$var$CONTEXT_PROPERTIES = [
    "fillStyle",
    "strokeStyle",
    "shadowColor",
    "shadowBlur",
    "shadowOffsetX",
    "shadowOffsetY",
    "letterSpacing",
    "lineCap",
    "lineDashOffset",
    "lineJoin",
    "lineWidth",
    "miterLimit",
    "direction",
    "font",
    "textAlign",
    "textBaseline",
    "globalAlpha",
    "globalCompositeOperation",
    "imageSmoothingEnabled"
];
const $8b1c7bdf4c6ac7f0$var$traceArrMax = 100;
class $8b1c7bdf4c6ac7f0$var$Context {
    constructor(canvas){
        this.canvas = canvas;
        if ($4v96z.Konva.enableTrace) {
            this.traceArr = [];
            this._enableTrace();
        }
    }
    fillShape(shape) {
        if (shape.fillEnabled()) this._fill(shape);
    }
    _fill(shape) {}
    strokeShape(shape) {
        if (shape.hasStroke()) this._stroke(shape);
    }
    _stroke(shape) {}
    fillStrokeShape(shape) {
        if (shape.attrs.fillAfterStrokeEnabled) {
            this.strokeShape(shape);
            this.fillShape(shape);
        } else {
            this.fillShape(shape);
            this.strokeShape(shape);
        }
    }
    getTrace(relaxed, rounded) {
        var traceArr = this.traceArr, len = traceArr.length, str = "", n, trace, method, args;
        for(n = 0; n < len; n++){
            trace = traceArr[n];
            method = trace.method;
            if (method) {
                args = trace.args;
                str += method;
                if (relaxed) str += $8b1c7bdf4c6ac7f0$var$DOUBLE_PAREN;
                else if ($kWs5g.Util._isArray(args[0])) str += $8b1c7bdf4c6ac7f0$var$OPEN_PAREN_BRACKET + args.join($8b1c7bdf4c6ac7f0$var$COMMA) + $8b1c7bdf4c6ac7f0$var$CLOSE_BRACKET_PAREN;
                else {
                    if (rounded) args = args.map((a)=>typeof a === "number" ? Math.floor(a) : a);
                    str += $8b1c7bdf4c6ac7f0$var$OPEN_PAREN + args.join($8b1c7bdf4c6ac7f0$var$COMMA) + $8b1c7bdf4c6ac7f0$var$CLOSE_PAREN;
                }
            } else {
                str += trace.property;
                if (!relaxed) str += $8b1c7bdf4c6ac7f0$var$EQUALS + trace.val;
            }
            str += $8b1c7bdf4c6ac7f0$var$SEMICOLON;
        }
        return str;
    }
    clearTrace() {
        this.traceArr = [];
    }
    _trace(str) {
        var traceArr = this.traceArr, len;
        traceArr.push(str);
        len = traceArr.length;
        if (len >= $8b1c7bdf4c6ac7f0$var$traceArrMax) traceArr.shift();
    }
    reset() {
        var pixelRatio = this.getCanvas().getPixelRatio();
        this.setTransform(1 * pixelRatio, 0, 0, 1 * pixelRatio, 0, 0);
    }
    getCanvas() {
        return this.canvas;
    }
    clear(bounds) {
        var canvas = this.getCanvas();
        if (bounds) this.clearRect(bounds.x || 0, bounds.y || 0, bounds.width || 0, bounds.height || 0);
        else this.clearRect(0, 0, canvas.getWidth() / canvas.pixelRatio, canvas.getHeight() / canvas.pixelRatio);
    }
    _applyLineCap(shape) {
        const lineCap = shape.attrs.lineCap;
        if (lineCap) this.setAttr("lineCap", lineCap);
    }
    _applyOpacity(shape) {
        var absOpacity = shape.getAbsoluteOpacity();
        if (absOpacity !== 1) this.setAttr("globalAlpha", absOpacity);
    }
    _applyLineJoin(shape) {
        const lineJoin = shape.attrs.lineJoin;
        if (lineJoin) this.setAttr("lineJoin", lineJoin);
    }
    setAttr(attr, val) {
        this._context[attr] = val;
    }
    arc(x, y, radius, startAngle, endAngle, counterClockwise) {
        this._context.arc(x, y, radius, startAngle, endAngle, counterClockwise);
    }
    arcTo(x1, y1, x2, y2, radius) {
        this._context.arcTo(x1, y1, x2, y2, radius);
    }
    beginPath() {
        this._context.beginPath();
    }
    bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y) {
        this._context.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
    }
    clearRect(x, y, width, height) {
        this._context.clearRect(x, y, width, height);
    }
    clip(...args) {
        this._context.clip.apply(this._context, args);
    }
    closePath() {
        this._context.closePath();
    }
    createImageData(width, height) {
        var a = arguments;
        if (a.length === 2) return this._context.createImageData(width, height);
        else if (a.length === 1) return this._context.createImageData(width);
    }
    createLinearGradient(x0, y0, x1, y1) {
        return this._context.createLinearGradient(x0, y0, x1, y1);
    }
    createPattern(image, repetition) {
        return this._context.createPattern(image, repetition);
    }
    createRadialGradient(x0, y0, r0, x1, y1, r1) {
        return this._context.createRadialGradient(x0, y0, r0, x1, y1, r1);
    }
    drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight) {
        var a = arguments, _context = this._context;
        if (a.length === 3) _context.drawImage(image, sx, sy);
        else if (a.length === 5) _context.drawImage(image, sx, sy, sWidth, sHeight);
        else if (a.length === 9) _context.drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);
    }
    ellipse(x, y, radiusX, radiusY, rotation, startAngle, endAngle, counterclockwise) {
        this._context.ellipse(x, y, radiusX, radiusY, rotation, startAngle, endAngle, counterclockwise);
    }
    isPointInPath(x, y, path, fillRule) {
        if (path) return this._context.isPointInPath(path, x, y, fillRule);
        return this._context.isPointInPath(x, y, fillRule);
    }
    fill(...args) {
        this._context.fill.apply(this._context, args);
    }
    fillRect(x, y, width, height) {
        this._context.fillRect(x, y, width, height);
    }
    strokeRect(x, y, width, height) {
        this._context.strokeRect(x, y, width, height);
    }
    fillText(text, x, y, maxWidth) {
        if (maxWidth) this._context.fillText(text, x, y, maxWidth);
        else this._context.fillText(text, x, y);
    }
    measureText(text) {
        return this._context.measureText(text);
    }
    getImageData(sx, sy, sw, sh) {
        return this._context.getImageData(sx, sy, sw, sh);
    }
    lineTo(x, y) {
        this._context.lineTo(x, y);
    }
    moveTo(x, y) {
        this._context.moveTo(x, y);
    }
    rect(x, y, width, height) {
        this._context.rect(x, y, width, height);
    }
    roundRect(x, y, width, height, radii) {
        this._context.roundRect(x, y, width, height, radii);
    }
    putImageData(imageData, dx, dy) {
        this._context.putImageData(imageData, dx, dy);
    }
    quadraticCurveTo(cpx, cpy, x, y) {
        this._context.quadraticCurveTo(cpx, cpy, x, y);
    }
    restore() {
        this._context.restore();
    }
    rotate(angle) {
        this._context.rotate(angle);
    }
    save() {
        this._context.save();
    }
    scale(x, y) {
        this._context.scale(x, y);
    }
    setLineDash(segments) {
        if (this._context.setLineDash) this._context.setLineDash(segments);
        else if ("mozDash" in this._context) this._context["mozDash"] = segments;
        else if ("webkitLineDash" in this._context) this._context["webkitLineDash"] = segments;
    }
    getLineDash() {
        return this._context.getLineDash();
    }
    setTransform(a, b, c, d, e, f) {
        this._context.setTransform(a, b, c, d, e, f);
    }
    stroke(path2d) {
        if (path2d) this._context.stroke(path2d);
        else this._context.stroke();
    }
    strokeText(text, x, y, maxWidth) {
        this._context.strokeText(text, x, y, maxWidth);
    }
    transform(a, b, c, d, e, f) {
        this._context.transform(a, b, c, d, e, f);
    }
    translate(x, y) {
        this._context.translate(x, y);
    }
    _enableTrace() {
        var that = this, len = $8b1c7bdf4c6ac7f0$var$CONTEXT_METHODS.length, origSetter = this.setAttr, n, args;
        var func = function(methodName) {
            var origMethod = that[methodName], ret;
            that[methodName] = function() {
                args = $8b1c7bdf4c6ac7f0$var$simplifyArray(Array.prototype.slice.call(arguments, 0));
                ret = origMethod.apply(that, arguments);
                that._trace({
                    method: methodName,
                    args: args
                });
                return ret;
            };
        };
        for(n = 0; n < len; n++)func($8b1c7bdf4c6ac7f0$var$CONTEXT_METHODS[n]);
        that.setAttr = function() {
            origSetter.apply(that, arguments);
            var prop = arguments[0];
            var val = arguments[1];
            if (prop === "shadowOffsetX" || prop === "shadowOffsetY" || prop === "shadowBlur") val = val / this.canvas.getPixelRatio();
            that._trace({
                property: prop,
                val: val
            });
        };
    }
    _applyGlobalCompositeOperation(node) {
        const op = node.attrs.globalCompositeOperation;
        var def = !op || op === "source-over";
        if (!def) this.setAttr("globalCompositeOperation", op);
    }
}
module.exports.Context = $8b1c7bdf4c6ac7f0$var$Context;
$8b1c7bdf4c6ac7f0$var$CONTEXT_PROPERTIES.forEach(function(prop) {
    Object.defineProperty($8b1c7bdf4c6ac7f0$var$Context.prototype, prop, {
        get () {
            return this._context[prop];
        },
        set (val) {
            this._context[prop] = val;
        }
    });
});
class $8b1c7bdf4c6ac7f0$var$SceneContext extends $8b1c7bdf4c6ac7f0$var$Context {
    constructor(canvas, { willReadFrequently: willReadFrequently = false } = {}){
        super(canvas);
        this._context = canvas._canvas.getContext("2d", {
            willReadFrequently: willReadFrequently
        });
    }
    _fillColor(shape) {
        var fill = shape.fill();
        this.setAttr("fillStyle", fill);
        shape._fillFunc(this);
    }
    _fillPattern(shape) {
        this.setAttr("fillStyle", shape._getFillPattern());
        shape._fillFunc(this);
    }
    _fillLinearGradient(shape) {
        var grd = shape._getLinearGradient();
        if (grd) {
            this.setAttr("fillStyle", grd);
            shape._fillFunc(this);
        }
    }
    _fillRadialGradient(shape) {
        const grd = shape._getRadialGradient();
        if (grd) {
            this.setAttr("fillStyle", grd);
            shape._fillFunc(this);
        }
    }
    _fill(shape) {
        const hasColor = shape.fill(), fillPriority = shape.getFillPriority();
        if (hasColor && fillPriority === "color") {
            this._fillColor(shape);
            return;
        }
        const hasPattern = shape.getFillPatternImage();
        if (hasPattern && fillPriority === "pattern") {
            this._fillPattern(shape);
            return;
        }
        const hasLinearGradient = shape.getFillLinearGradientColorStops();
        if (hasLinearGradient && fillPriority === "linear-gradient") {
            this._fillLinearGradient(shape);
            return;
        }
        const hasRadialGradient = shape.getFillRadialGradientColorStops();
        if (hasRadialGradient && fillPriority === "radial-gradient") {
            this._fillRadialGradient(shape);
            return;
        }
        if (hasColor) this._fillColor(shape);
        else if (hasPattern) this._fillPattern(shape);
        else if (hasLinearGradient) this._fillLinearGradient(shape);
        else if (hasRadialGradient) this._fillRadialGradient(shape);
    }
    _strokeLinearGradient(shape) {
        const start = shape.getStrokeLinearGradientStartPoint(), end = shape.getStrokeLinearGradientEndPoint(), colorStops = shape.getStrokeLinearGradientColorStops(), grd = this.createLinearGradient(start.x, start.y, end.x, end.y);
        if (colorStops) {
            for(var n = 0; n < colorStops.length; n += 2)grd.addColorStop(colorStops[n], colorStops[n + 1]);
            this.setAttr("strokeStyle", grd);
        }
    }
    _stroke(shape) {
        var dash = shape.dash(), strokeScaleEnabled = shape.getStrokeScaleEnabled();
        if (shape.hasStroke()) {
            if (!strokeScaleEnabled) {
                this.save();
                var pixelRatio = this.getCanvas().getPixelRatio();
                this.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
            }
            this._applyLineCap(shape);
            if (dash && shape.dashEnabled()) {
                this.setLineDash(dash);
                this.setAttr("lineDashOffset", shape.dashOffset());
            }
            this.setAttr("lineWidth", shape.strokeWidth());
            if (!shape.getShadowForStrokeEnabled()) this.setAttr("shadowColor", "rgba(0,0,0,0)");
            var hasLinearGradient = shape.getStrokeLinearGradientColorStops();
            if (hasLinearGradient) this._strokeLinearGradient(shape);
            else this.setAttr("strokeStyle", shape.stroke());
            shape._strokeFunc(this);
            if (!strokeScaleEnabled) this.restore();
        }
    }
    _applyShadow(shape) {
        var _a, _b, _c;
        var color = (_a = shape.getShadowRGBA()) !== null && _a !== void 0 ? _a : "black", blur = (_b = shape.getShadowBlur()) !== null && _b !== void 0 ? _b : 5, offset = (_c = shape.getShadowOffset()) !== null && _c !== void 0 ? _c : {
            x: 0,
            y: 0
        }, scale = shape.getAbsoluteScale(), ratio = this.canvas.getPixelRatio(), scaleX = scale.x * ratio, scaleY = scale.y * ratio;
        this.setAttr("shadowColor", color);
        this.setAttr("shadowBlur", blur * Math.min(Math.abs(scaleX), Math.abs(scaleY)));
        this.setAttr("shadowOffsetX", offset.x * scaleX);
        this.setAttr("shadowOffsetY", offset.y * scaleY);
    }
}
module.exports.SceneContext = $8b1c7bdf4c6ac7f0$var$SceneContext;
class $8b1c7bdf4c6ac7f0$var$HitContext extends $8b1c7bdf4c6ac7f0$var$Context {
    constructor(canvas){
        super(canvas);
        this._context = canvas._canvas.getContext("2d", {
            willReadFrequently: true
        });
    }
    _fill(shape) {
        this.save();
        this.setAttr("fillStyle", shape.colorKey);
        shape._fillFuncHit(this);
        this.restore();
    }
    strokeShape(shape) {
        if (shape.hasHitStroke()) this._stroke(shape);
    }
    _stroke(shape) {
        if (shape.hasHitStroke()) {
            const strokeScaleEnabled = shape.getStrokeScaleEnabled();
            if (!strokeScaleEnabled) {
                this.save();
                var pixelRatio = this.getCanvas().getPixelRatio();
                this.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
            }
            this._applyLineCap(shape);
            var hitStrokeWidth = shape.hitStrokeWidth();
            var strokeWidth = hitStrokeWidth === "auto" ? shape.strokeWidth() : hitStrokeWidth;
            this.setAttr("lineWidth", strokeWidth);
            this.setAttr("strokeStyle", shape.colorKey);
            shape._strokeFuncHit(this);
            if (!strokeScaleEnabled) this.restore();
        }
    }
}
module.exports.HitContext = $8b1c7bdf4c6ac7f0$var$HitContext;

});


parcelRegister("d8LUf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DD = void 0;

var $4v96z = parcelRequire("4v96z");

var $kWs5g = parcelRequire("kWs5g");
module.exports.DD = {
    get isDragging () {
        var flag = false;
        module.exports.DD._dragElements.forEach((elem)=>{
            if (elem.dragStatus === "dragging") flag = true;
        });
        return flag;
    },
    justDragged: false,
    get node () {
        var node;
        module.exports.DD._dragElements.forEach((elem)=>{
            node = elem.node;
        });
        return node;
    },
    _dragElements: new Map(),
    _drag (evt) {
        const nodesToFireEvents = [];
        module.exports.DD._dragElements.forEach((elem, key)=>{
            const { node: node } = elem;
            const stage = node.getStage();
            stage.setPointersPositions(evt);
            if (elem.pointerId === undefined) elem.pointerId = $kWs5g.Util._getFirstPointerId(evt);
            const pos = stage._changedPointerPositions.find((pos)=>pos.id === elem.pointerId);
            if (!pos) return;
            if (elem.dragStatus !== "dragging") {
                var dragDistance = node.dragDistance();
                var distance = Math.max(Math.abs(pos.x - elem.startPointerPos.x), Math.abs(pos.y - elem.startPointerPos.y));
                if (distance < dragDistance) return;
                node.startDrag({
                    evt: evt
                });
                if (!node.isDragging()) return;
            }
            node._setDragPosition(evt, elem);
            nodesToFireEvents.push(node);
        });
        nodesToFireEvents.forEach((node)=>{
            node.fire("dragmove", {
                type: "dragmove",
                target: node,
                evt: evt
            }, true);
        });
    },
    _endDragBefore (evt) {
        const drawNodes = [];
        module.exports.DD._dragElements.forEach((elem)=>{
            const { node: node } = elem;
            const stage = node.getStage();
            if (evt) stage.setPointersPositions(evt);
            const pos = stage._changedPointerPositions.find((pos)=>pos.id === elem.pointerId);
            if (!pos) return;
            if (elem.dragStatus === "dragging" || elem.dragStatus === "stopped") {
                module.exports.DD.justDragged = true;
                $4v96z.Konva._mouseListenClick = false;
                $4v96z.Konva._touchListenClick = false;
                $4v96z.Konva._pointerListenClick = false;
                elem.dragStatus = "stopped";
            }
            const drawNode = elem.node.getLayer() || elem.node instanceof $4v96z.Konva["Stage"] && elem.node;
            if (drawNode && drawNodes.indexOf(drawNode) === -1) drawNodes.push(drawNode);
        });
        drawNodes.forEach((drawNode)=>{
            drawNode.draw();
        });
    },
    _endDragAfter (evt) {
        module.exports.DD._dragElements.forEach((elem, key)=>{
            if (elem.dragStatus === "stopped") elem.node.fire("dragend", {
                type: "dragend",
                target: elem.node,
                evt: evt
            }, true);
            if (elem.dragStatus !== "dragging") module.exports.DD._dragElements.delete(key);
        });
    }
};
if ($4v96z.Konva.isBrowser) {
    window.addEventListener("mouseup", module.exports.DD._endDragBefore, true);
    window.addEventListener("touchend", module.exports.DD._endDragBefore, true);
    window.addEventListener("mousemove", module.exports.DD._drag);
    window.addEventListener("touchmove", module.exports.DD._drag);
    window.addEventListener("mouseup", module.exports.DD._endDragAfter, false);
    window.addEventListener("touchend", module.exports.DD._endDragAfter, false);
}

});


parcelRegister("jxWWI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Container = void 0;

var $3V3su = parcelRequire("3V3su");

var $1qU2E = parcelRequire("1qU2E");

var $2TXYV = parcelRequire("2TXYV");
class $e3aed2d410135434$var$Container extends $1qU2E.Node {
    constructor(){
        super(...arguments);
        this.children = [];
    }
    getChildren(filterFunc) {
        if (!filterFunc) return this.children || [];
        const children = this.children || [];
        var results = [];
        children.forEach(function(child) {
            if (filterFunc(child)) results.push(child);
        });
        return results;
    }
    hasChildren() {
        return this.getChildren().length > 0;
    }
    removeChildren() {
        this.getChildren().forEach((child)=>{
            child.parent = null;
            child.index = 0;
            child.remove();
        });
        this.children = [];
        this._requestDraw();
        return this;
    }
    destroyChildren() {
        this.getChildren().forEach((child)=>{
            child.parent = null;
            child.index = 0;
            child.destroy();
        });
        this.children = [];
        this._requestDraw();
        return this;
    }
    add(...children) {
        if (children.length === 0) return this;
        if (children.length > 1) {
            for(var i = 0; i < children.length; i++)this.add(children[i]);
            return this;
        }
        const child = children[0];
        if (child.getParent()) {
            child.moveTo(this);
            return this;
        }
        this._validateAdd(child);
        child.index = this.getChildren().length;
        child.parent = this;
        child._clearCaches();
        this.getChildren().push(child);
        this._fire("add", {
            child: child
        });
        this._requestDraw();
        return this;
    }
    destroy() {
        if (this.hasChildren()) this.destroyChildren();
        super.destroy();
        return this;
    }
    find(selector) {
        return this._generalFind(selector, false);
    }
    findOne(selector) {
        var result = this._generalFind(selector, true);
        return result.length > 0 ? result[0] : undefined;
    }
    _generalFind(selector, findOne) {
        var retArr = [];
        this._descendants((node)=>{
            const valid = node._isMatch(selector);
            if (valid) retArr.push(node);
            if (valid && findOne) return true;
            return false;
        });
        return retArr;
    }
    _descendants(fn) {
        let shouldStop = false;
        const children = this.getChildren();
        for (const child of children){
            shouldStop = fn(child);
            if (shouldStop) return true;
            if (!child.hasChildren()) continue;
            shouldStop = child._descendants(fn);
            if (shouldStop) return true;
        }
        return false;
    }
    toObject() {
        var obj = $1qU2E.Node.prototype.toObject.call(this);
        obj.children = [];
        this.getChildren().forEach((child)=>{
            obj.children.push(child.toObject());
        });
        return obj;
    }
    isAncestorOf(node) {
        var parent = node.getParent();
        while(parent){
            if (parent._id === this._id) return true;
            parent = parent.getParent();
        }
        return false;
    }
    clone(obj) {
        var node = $1qU2E.Node.prototype.clone.call(this, obj);
        this.getChildren().forEach(function(no) {
            node.add(no.clone());
        });
        return node;
    }
    getAllIntersections(pos) {
        var arr = [];
        this.find("Shape").forEach((shape)=>{
            if (shape.isVisible() && shape.intersects(pos)) arr.push(shape);
        });
        return arr;
    }
    _clearSelfAndDescendantCache(attr) {
        var _a;
        super._clearSelfAndDescendantCache(attr);
        if (this.isCached()) return;
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(node) {
            node._clearSelfAndDescendantCache(attr);
        });
    }
    _setChildrenIndices() {
        var _a;
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(child, n) {
            child.index = n;
        });
        this._requestDraw();
    }
    drawScene(can, top, bufferCanvas) {
        var layer = this.getLayer(), canvas = can || layer && layer.getCanvas(), context = canvas && canvas.getContext(), cachedCanvas = this._getCanvasCache(), cachedSceneCanvas = cachedCanvas && cachedCanvas.scene;
        var caching = canvas && canvas.isCache;
        if (!this.isVisible() && !caching) return this;
        if (cachedSceneCanvas) {
            context.save();
            var m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedSceneCanvas(context);
            context.restore();
        } else this._drawChildren("drawScene", canvas, top, bufferCanvas);
        return this;
    }
    drawHit(can, top) {
        if (!this.shouldDrawHit(top)) return this;
        var layer = this.getLayer(), canvas = can || layer && layer.hitCanvas, context = canvas && canvas.getContext(), cachedCanvas = this._getCanvasCache(), cachedHitCanvas = cachedCanvas && cachedCanvas.hit;
        if (cachedHitCanvas) {
            context.save();
            var m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedHitCanvas(context);
            context.restore();
        } else this._drawChildren("drawHit", canvas, top);
        return this;
    }
    _drawChildren(drawMethod, canvas, top, bufferCanvas) {
        var _a;
        var context = canvas && canvas.getContext(), clipWidth = this.clipWidth(), clipHeight = this.clipHeight(), clipFunc = this.clipFunc(), hasClip = typeof clipWidth === "number" && typeof clipHeight === "number" || clipFunc;
        const selfCache = top === this;
        if (hasClip) {
            context.save();
            var transform = this.getAbsoluteTransform(top);
            var m = transform.getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            context.beginPath();
            let clipArgs;
            if (clipFunc) clipArgs = clipFunc.call(this, context, this);
            else {
                var clipX = this.clipX();
                var clipY = this.clipY();
                context.rect(clipX || 0, clipY || 0, clipWidth, clipHeight);
            }
            context.clip.apply(context, clipArgs);
            m = transform.copy().invert().getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
        }
        var hasComposition = !selfCache && this.globalCompositeOperation() !== "source-over" && drawMethod === "drawScene";
        if (hasComposition) {
            context.save();
            context._applyGlobalCompositeOperation(this);
        }
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(child) {
            child[drawMethod](canvas, top, bufferCanvas);
        });
        if (hasComposition) context.restore();
        if (hasClip) context.restore();
    }
    getClientRect(config = {}) {
        var _a;
        var skipTransform = config.skipTransform;
        var relativeTo = config.relativeTo;
        var minX, minY, maxX, maxY;
        var selfRect = {
            x: Infinity,
            y: Infinity,
            width: 0,
            height: 0
        };
        var that = this;
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(child) {
            if (!child.visible()) return;
            var rect = child.getClientRect({
                relativeTo: that,
                skipShadow: config.skipShadow,
                skipStroke: config.skipStroke
            });
            if (rect.width === 0 && rect.height === 0) return;
            if (minX === undefined) {
                minX = rect.x;
                minY = rect.y;
                maxX = rect.x + rect.width;
                maxY = rect.y + rect.height;
            } else {
                minX = Math.min(minX, rect.x);
                minY = Math.min(minY, rect.y);
                maxX = Math.max(maxX, rect.x + rect.width);
                maxY = Math.max(maxY, rect.y + rect.height);
            }
        });
        var shapes = this.find("Shape");
        var hasVisible = false;
        for(var i = 0; i < shapes.length; i++){
            var shape = shapes[i];
            if (shape._isVisible(this)) {
                hasVisible = true;
                break;
            }
        }
        if (hasVisible && minX !== undefined) selfRect = {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
        else selfRect = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        if (!skipTransform) return this._transformedRect(selfRect, relativeTo);
        return selfRect;
    }
}
module.exports.Container = $e3aed2d410135434$var$Container;
$3V3su.Factory.addComponentsGetterSetter($e3aed2d410135434$var$Container, "clip", [
    "x",
    "y",
    "width",
    "height"
]);
$3V3su.Factory.addGetterSetter($e3aed2d410135434$var$Container, "clipX", undefined, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($e3aed2d410135434$var$Container, "clipY", undefined, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($e3aed2d410135434$var$Container, "clipWidth", undefined, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($e3aed2d410135434$var$Container, "clipHeight", undefined, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($e3aed2d410135434$var$Container, "clipFunc");

});

parcelRegister("8wE3K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Stage = module.exports.stages = void 0;

var $kWs5g = parcelRequire("kWs5g");

var $3V3su = parcelRequire("3V3su");

var $jxWWI = parcelRequire("jxWWI");

var $4v96z = parcelRequire("4v96z");

var $bsljL = parcelRequire("bsljL");

var $d8LUf = parcelRequire("d8LUf");

var $4v96z = parcelRequire("4v96z");

var $4iqf2 = parcelRequire("4iqf2");
var $635062da0a59b87b$var$STAGE = "Stage", $635062da0a59b87b$var$STRING = "string", $635062da0a59b87b$var$PX = "px", $635062da0a59b87b$var$MOUSEOUT = "mouseout", $635062da0a59b87b$var$MOUSELEAVE = "mouseleave", $635062da0a59b87b$var$MOUSEOVER = "mouseover", $635062da0a59b87b$var$MOUSEENTER = "mouseenter", $635062da0a59b87b$var$MOUSEMOVE = "mousemove", $635062da0a59b87b$var$MOUSEDOWN = "mousedown", $635062da0a59b87b$var$MOUSEUP = "mouseup", $635062da0a59b87b$var$POINTERMOVE = "pointermove", $635062da0a59b87b$var$POINTERDOWN = "pointerdown", $635062da0a59b87b$var$POINTERUP = "pointerup", $635062da0a59b87b$var$POINTERCANCEL = "pointercancel", $635062da0a59b87b$var$LOSTPOINTERCAPTURE = "lostpointercapture", $635062da0a59b87b$var$POINTEROUT = "pointerout", $635062da0a59b87b$var$POINTERLEAVE = "pointerleave", $635062da0a59b87b$var$POINTEROVER = "pointerover", $635062da0a59b87b$var$POINTERENTER = "pointerenter", $635062da0a59b87b$var$CONTEXTMENU = "contextmenu", $635062da0a59b87b$var$TOUCHSTART = "touchstart", $635062da0a59b87b$var$TOUCHEND = "touchend", $635062da0a59b87b$var$TOUCHMOVE = "touchmove", $635062da0a59b87b$var$TOUCHCANCEL = "touchcancel", $635062da0a59b87b$var$WHEEL = "wheel", $635062da0a59b87b$var$MAX_LAYERS_NUMBER = 5, $635062da0a59b87b$var$EVENTS = [
    [
        $635062da0a59b87b$var$MOUSEENTER,
        "_pointerenter"
    ],
    [
        $635062da0a59b87b$var$MOUSEDOWN,
        "_pointerdown"
    ],
    [
        $635062da0a59b87b$var$MOUSEMOVE,
        "_pointermove"
    ],
    [
        $635062da0a59b87b$var$MOUSEUP,
        "_pointerup"
    ],
    [
        $635062da0a59b87b$var$MOUSELEAVE,
        "_pointerleave"
    ],
    [
        $635062da0a59b87b$var$TOUCHSTART,
        "_pointerdown"
    ],
    [
        $635062da0a59b87b$var$TOUCHMOVE,
        "_pointermove"
    ],
    [
        $635062da0a59b87b$var$TOUCHEND,
        "_pointerup"
    ],
    [
        $635062da0a59b87b$var$TOUCHCANCEL,
        "_pointercancel"
    ],
    [
        $635062da0a59b87b$var$MOUSEOVER,
        "_pointerover"
    ],
    [
        $635062da0a59b87b$var$WHEEL,
        "_wheel"
    ],
    [
        $635062da0a59b87b$var$CONTEXTMENU,
        "_contextmenu"
    ],
    [
        $635062da0a59b87b$var$POINTERDOWN,
        "_pointerdown"
    ],
    [
        $635062da0a59b87b$var$POINTERMOVE,
        "_pointermove"
    ],
    [
        $635062da0a59b87b$var$POINTERUP,
        "_pointerup"
    ],
    [
        $635062da0a59b87b$var$POINTERCANCEL,
        "_pointercancel"
    ],
    [
        $635062da0a59b87b$var$LOSTPOINTERCAPTURE,
        "_lostpointercapture"
    ]
];
const $635062da0a59b87b$var$EVENTS_MAP = {
    mouse: {
        [$635062da0a59b87b$var$POINTEROUT]: $635062da0a59b87b$var$MOUSEOUT,
        [$635062da0a59b87b$var$POINTERLEAVE]: $635062da0a59b87b$var$MOUSELEAVE,
        [$635062da0a59b87b$var$POINTEROVER]: $635062da0a59b87b$var$MOUSEOVER,
        [$635062da0a59b87b$var$POINTERENTER]: $635062da0a59b87b$var$MOUSEENTER,
        [$635062da0a59b87b$var$POINTERMOVE]: $635062da0a59b87b$var$MOUSEMOVE,
        [$635062da0a59b87b$var$POINTERDOWN]: $635062da0a59b87b$var$MOUSEDOWN,
        [$635062da0a59b87b$var$POINTERUP]: $635062da0a59b87b$var$MOUSEUP,
        [$635062da0a59b87b$var$POINTERCANCEL]: "mousecancel",
        pointerclick: "click",
        pointerdblclick: "dblclick"
    },
    touch: {
        [$635062da0a59b87b$var$POINTEROUT]: "touchout",
        [$635062da0a59b87b$var$POINTERLEAVE]: "touchleave",
        [$635062da0a59b87b$var$POINTEROVER]: "touchover",
        [$635062da0a59b87b$var$POINTERENTER]: "touchenter",
        [$635062da0a59b87b$var$POINTERMOVE]: $635062da0a59b87b$var$TOUCHMOVE,
        [$635062da0a59b87b$var$POINTERDOWN]: $635062da0a59b87b$var$TOUCHSTART,
        [$635062da0a59b87b$var$POINTERUP]: $635062da0a59b87b$var$TOUCHEND,
        [$635062da0a59b87b$var$POINTERCANCEL]: $635062da0a59b87b$var$TOUCHCANCEL,
        pointerclick: "tap",
        pointerdblclick: "dbltap"
    },
    pointer: {
        [$635062da0a59b87b$var$POINTEROUT]: $635062da0a59b87b$var$POINTEROUT,
        [$635062da0a59b87b$var$POINTERLEAVE]: $635062da0a59b87b$var$POINTERLEAVE,
        [$635062da0a59b87b$var$POINTEROVER]: $635062da0a59b87b$var$POINTEROVER,
        [$635062da0a59b87b$var$POINTERENTER]: $635062da0a59b87b$var$POINTERENTER,
        [$635062da0a59b87b$var$POINTERMOVE]: $635062da0a59b87b$var$POINTERMOVE,
        [$635062da0a59b87b$var$POINTERDOWN]: $635062da0a59b87b$var$POINTERDOWN,
        [$635062da0a59b87b$var$POINTERUP]: $635062da0a59b87b$var$POINTERUP,
        [$635062da0a59b87b$var$POINTERCANCEL]: $635062da0a59b87b$var$POINTERCANCEL,
        pointerclick: "pointerclick",
        pointerdblclick: "pointerdblclick"
    }
};
const $635062da0a59b87b$var$getEventType = (type)=>{
    if (type.indexOf("pointer") >= 0) return "pointer";
    if (type.indexOf("touch") >= 0) return "touch";
    return "mouse";
};
const $635062da0a59b87b$var$getEventsMap = (eventType)=>{
    const type = $635062da0a59b87b$var$getEventType(eventType);
    if (type === "pointer") return $4v96z.Konva.pointerEventsEnabled && $635062da0a59b87b$var$EVENTS_MAP.pointer;
    if (type === "touch") return $635062da0a59b87b$var$EVENTS_MAP.touch;
    if (type === "mouse") return $635062da0a59b87b$var$EVENTS_MAP.mouse;
};
function $635062da0a59b87b$var$checkNoClip(attrs = {}) {
    if (attrs.clipFunc || attrs.clipWidth || attrs.clipHeight) $kWs5g.Util.warn("Stage does not support clipping. Please use clip for Layers or Groups.");
    return attrs;
}
const $635062da0a59b87b$var$NO_POINTERS_MESSAGE = `Pointer position is missing and not registered by the stage. Looks like it is outside of the stage container. You can set it manually from event: stage.setPointersPositions(event);`;
module.exports.stages = [];
class $635062da0a59b87b$var$Stage extends $jxWWI.Container {
    constructor(config){
        super($635062da0a59b87b$var$checkNoClip(config));
        this._pointerPositions = [];
        this._changedPointerPositions = [];
        this._buildDOM();
        this._bindContentEvents();
        module.exports.stages.push(this);
        this.on("widthChange.konva heightChange.konva", this._resizeDOM);
        this.on("visibleChange.konva", this._checkVisibility);
        this.on("clipWidthChange.konva clipHeightChange.konva clipFuncChange.konva", ()=>{
            $635062da0a59b87b$var$checkNoClip(this.attrs);
        });
        this._checkVisibility();
    }
    _validateAdd(child) {
        const isLayer = child.getType() === "Layer";
        const isFastLayer = child.getType() === "FastLayer";
        const valid = isLayer || isFastLayer;
        if (!valid) $kWs5g.Util.throw("You may only add layers to the stage.");
    }
    _checkVisibility() {
        if (!this.content) return;
        const style = this.visible() ? "" : "none";
        this.content.style.display = style;
    }
    setContainer(container) {
        if (typeof container === $635062da0a59b87b$var$STRING) {
            if (container.charAt(0) === ".") {
                var className = container.slice(1);
                container = document.getElementsByClassName(className)[0];
            } else {
                var id;
                if (container.charAt(0) !== "#") id = container;
                else id = container.slice(1);
                container = document.getElementById(id);
            }
            if (!container) throw "Can not find container in document with id " + id;
        }
        this._setAttr("container", container);
        if (this.content) {
            if (this.content.parentElement) this.content.parentElement.removeChild(this.content);
            container.appendChild(this.content);
        }
        return this;
    }
    shouldDrawHit() {
        return true;
    }
    clear() {
        var layers = this.children, len = layers.length, n;
        for(n = 0; n < len; n++)layers[n].clear();
        return this;
    }
    clone(obj) {
        if (!obj) obj = {};
        obj.container = typeof document !== "undefined" && document.createElement("div");
        return $jxWWI.Container.prototype.clone.call(this, obj);
    }
    destroy() {
        super.destroy();
        var content = this.content;
        if (content && $kWs5g.Util._isInDocument(content)) this.container().removeChild(content);
        var index = module.exports.stages.indexOf(this);
        if (index > -1) module.exports.stages.splice(index, 1);
        $kWs5g.Util.releaseCanvas(this.bufferCanvas._canvas, this.bufferHitCanvas._canvas);
        return this;
    }
    getPointerPosition() {
        const pos = this._pointerPositions[0] || this._changedPointerPositions[0];
        if (!pos) {
            $kWs5g.Util.warn($635062da0a59b87b$var$NO_POINTERS_MESSAGE);
            return null;
        }
        return {
            x: pos.x,
            y: pos.y
        };
    }
    _getPointerById(id) {
        return this._pointerPositions.find((p)=>p.id === id);
    }
    getPointersPositions() {
        return this._pointerPositions;
    }
    getStage() {
        return this;
    }
    getContent() {
        return this.content;
    }
    _toKonvaCanvas(config) {
        config = config || {};
        config.x = config.x || 0;
        config.y = config.y || 0;
        config.width = config.width || this.width();
        config.height = config.height || this.height();
        var canvas = new $bsljL.SceneCanvas({
            width: config.width,
            height: config.height,
            pixelRatio: config.pixelRatio || 1
        });
        var _context = canvas.getContext()._context;
        var layers = this.children;
        if (config.x || config.y) _context.translate(-1 * config.x, -1 * config.y);
        layers.forEach(function(layer) {
            if (!layer.isVisible()) return;
            var layerCanvas = layer._toKonvaCanvas(config);
            _context.drawImage(layerCanvas._canvas, config.x, config.y, layerCanvas.getWidth() / layerCanvas.getPixelRatio(), layerCanvas.getHeight() / layerCanvas.getPixelRatio());
        });
        return canvas;
    }
    getIntersection(pos) {
        if (!pos) return null;
        var layers = this.children, len = layers.length, end = len - 1, n;
        for(n = end; n >= 0; n--){
            const shape = layers[n].getIntersection(pos);
            if (shape) return shape;
        }
        return null;
    }
    _resizeDOM() {
        var width = this.width();
        var height = this.height();
        if (this.content) {
            this.content.style.width = width + $635062da0a59b87b$var$PX;
            this.content.style.height = height + $635062da0a59b87b$var$PX;
        }
        this.bufferCanvas.setSize(width, height);
        this.bufferHitCanvas.setSize(width, height);
        this.children.forEach((layer)=>{
            layer.setSize({
                width: width,
                height: height
            });
            layer.draw();
        });
    }
    add(layer, ...rest) {
        if (arguments.length > 1) {
            for(var i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        super.add(layer);
        var length = this.children.length;
        if (length > $635062da0a59b87b$var$MAX_LAYERS_NUMBER) $kWs5g.Util.warn("The stage has " + length + " layers. Recommended maximum number of layers is 3-5. Adding more layers into the stage may drop the performance. Rethink your tree structure, you can use Konva.Group.");
        layer.setSize({
            width: this.width(),
            height: this.height()
        });
        layer.draw();
        if ($4v96z.Konva.isBrowser) this.content.appendChild(layer.canvas._canvas);
        return this;
    }
    getParent() {
        return null;
    }
    getLayer() {
        return null;
    }
    hasPointerCapture(pointerId) {
        return $4iqf2.hasPointerCapture(pointerId, this);
    }
    setPointerCapture(pointerId) {
        $4iqf2.setPointerCapture(pointerId, this);
    }
    releaseCapture(pointerId) {
        $4iqf2.releaseCapture(pointerId, this);
    }
    getLayers() {
        return this.children;
    }
    _bindContentEvents() {
        if (!$4v96z.Konva.isBrowser) return;
        $635062da0a59b87b$var$EVENTS.forEach(([event, methodName])=>{
            this.content.addEventListener(event, (evt)=>{
                this[methodName](evt);
            }, {
                passive: false
            });
        });
    }
    _pointerenter(evt) {
        this.setPointersPositions(evt);
        const events = $635062da0a59b87b$var$getEventsMap(evt.type);
        if (events) this._fire(events.pointerenter, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _pointerover(evt) {
        this.setPointersPositions(evt);
        const events = $635062da0a59b87b$var$getEventsMap(evt.type);
        if (events) this._fire(events.pointerover, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _getTargetShape(evenType) {
        let shape = this[evenType + "targetShape"];
        if (shape && !shape.getStage()) shape = null;
        return shape;
    }
    _pointerleave(evt) {
        const events = $635062da0a59b87b$var$getEventsMap(evt.type);
        const eventType = $635062da0a59b87b$var$getEventType(evt.type);
        if (!events) return;
        this.setPointersPositions(evt);
        var targetShape = this._getTargetShape(eventType);
        var eventsEnabled = !($4v96z.Konva.isDragging() || $4v96z.Konva.isTransforming()) || $4v96z.Konva.hitOnDragEnabled;
        if (targetShape && eventsEnabled) {
            targetShape._fireAndBubble(events.pointerout, {
                evt: evt
            });
            targetShape._fireAndBubble(events.pointerleave, {
                evt: evt
            });
            this._fire(events.pointerleave, {
                evt: evt,
                target: this,
                currentTarget: this
            });
            this[eventType + "targetShape"] = null;
        } else if (eventsEnabled) {
            this._fire(events.pointerleave, {
                evt: evt,
                target: this,
                currentTarget: this
            });
            this._fire(events.pointerout, {
                evt: evt,
                target: this,
                currentTarget: this
            });
        }
        this.pointerPos = null;
        this._pointerPositions = [];
    }
    _pointerdown(evt) {
        const events = $635062da0a59b87b$var$getEventsMap(evt.type);
        const eventType = $635062da0a59b87b$var$getEventType(evt.type);
        if (!events) return;
        this.setPointersPositions(evt);
        var triggeredOnShape = false;
        this._changedPointerPositions.forEach((pos)=>{
            var shape = this.getIntersection(pos);
            $d8LUf.DD.justDragged = false;
            $4v96z.Konva["_" + eventType + "ListenClick"] = true;
            if (!shape || !shape.isListening()) {
                this[eventType + "ClickStartShape"] = undefined;
                return;
            }
            if ($4v96z.Konva.capturePointerEventsEnabled) shape.setPointerCapture(pos.id);
            this[eventType + "ClickStartShape"] = shape;
            shape._fireAndBubble(events.pointerdown, {
                evt: evt,
                pointerId: pos.id
            });
            triggeredOnShape = true;
            const isTouch = evt.type.indexOf("touch") >= 0;
            if (shape.preventDefault() && evt.cancelable && isTouch) evt.preventDefault();
        });
        if (!triggeredOnShape) this._fire(events.pointerdown, {
            evt: evt,
            target: this,
            currentTarget: this,
            pointerId: this._pointerPositions[0].id
        });
    }
    _pointermove(evt) {
        const events = $635062da0a59b87b$var$getEventsMap(evt.type);
        const eventType = $635062da0a59b87b$var$getEventType(evt.type);
        if (!events) return;
        if ($4v96z.Konva.isDragging() && $d8LUf.DD.node.preventDefault() && evt.cancelable) evt.preventDefault();
        this.setPointersPositions(evt);
        var eventsEnabled = !($4v96z.Konva.isDragging() || $4v96z.Konva.isTransforming()) || $4v96z.Konva.hitOnDragEnabled;
        if (!eventsEnabled) return;
        var processedShapesIds = {};
        let triggeredOnShape = false;
        var targetShape = this._getTargetShape(eventType);
        this._changedPointerPositions.forEach((pos)=>{
            const shape = $4iqf2.getCapturedShape(pos.id) || this.getIntersection(pos);
            const pointerId = pos.id;
            const event = {
                evt: evt,
                pointerId: pointerId
            };
            var differentTarget = targetShape !== shape;
            if (differentTarget && targetShape) {
                targetShape._fireAndBubble(events.pointerout, {
                    ...event
                }, shape);
                targetShape._fireAndBubble(events.pointerleave, {
                    ...event
                }, shape);
            }
            if (shape) {
                if (processedShapesIds[shape._id]) return;
                processedShapesIds[shape._id] = true;
            }
            if (shape && shape.isListening()) {
                triggeredOnShape = true;
                if (differentTarget) {
                    shape._fireAndBubble(events.pointerover, {
                        ...event
                    }, targetShape);
                    shape._fireAndBubble(events.pointerenter, {
                        ...event
                    }, targetShape);
                    this[eventType + "targetShape"] = shape;
                }
                shape._fireAndBubble(events.pointermove, {
                    ...event
                });
            } else if (targetShape) {
                this._fire(events.pointerover, {
                    evt: evt,
                    target: this,
                    currentTarget: this,
                    pointerId: pointerId
                });
                this[eventType + "targetShape"] = null;
            }
        });
        if (!triggeredOnShape) this._fire(events.pointermove, {
            evt: evt,
            target: this,
            currentTarget: this,
            pointerId: this._changedPointerPositions[0].id
        });
    }
    _pointerup(evt) {
        const events = $635062da0a59b87b$var$getEventsMap(evt.type);
        const eventType = $635062da0a59b87b$var$getEventType(evt.type);
        if (!events) return;
        this.setPointersPositions(evt);
        const clickStartShape = this[eventType + "ClickStartShape"];
        const clickEndShape = this[eventType + "ClickEndShape"];
        var processedShapesIds = {};
        let triggeredOnShape = false;
        this._changedPointerPositions.forEach((pos)=>{
            const shape = $4iqf2.getCapturedShape(pos.id) || this.getIntersection(pos);
            if (shape) {
                shape.releaseCapture(pos.id);
                if (processedShapesIds[shape._id]) return;
                processedShapesIds[shape._id] = true;
            }
            const pointerId = pos.id;
            const event = {
                evt: evt,
                pointerId: pointerId
            };
            let fireDblClick = false;
            if ($4v96z.Konva["_" + eventType + "InDblClickWindow"]) {
                fireDblClick = true;
                clearTimeout(this[eventType + "DblTimeout"]);
            } else if (!$d8LUf.DD.justDragged) {
                $4v96z.Konva["_" + eventType + "InDblClickWindow"] = true;
                clearTimeout(this[eventType + "DblTimeout"]);
            }
            this[eventType + "DblTimeout"] = setTimeout(function() {
                $4v96z.Konva["_" + eventType + "InDblClickWindow"] = false;
            }, $4v96z.Konva.dblClickWindow);
            if (shape && shape.isListening()) {
                triggeredOnShape = true;
                this[eventType + "ClickEndShape"] = shape;
                shape._fireAndBubble(events.pointerup, {
                    ...event
                });
                if ($4v96z.Konva["_" + eventType + "ListenClick"] && clickStartShape && clickStartShape === shape) {
                    shape._fireAndBubble(events.pointerclick, {
                        ...event
                    });
                    if (fireDblClick && clickEndShape && clickEndShape === shape) shape._fireAndBubble(events.pointerdblclick, {
                        ...event
                    });
                }
            } else {
                this[eventType + "ClickEndShape"] = null;
                if ($4v96z.Konva["_" + eventType + "ListenClick"]) this._fire(events.pointerclick, {
                    evt: evt,
                    target: this,
                    currentTarget: this,
                    pointerId: pointerId
                });
                if (fireDblClick) this._fire(events.pointerdblclick, {
                    evt: evt,
                    target: this,
                    currentTarget: this,
                    pointerId: pointerId
                });
            }
        });
        if (!triggeredOnShape) this._fire(events.pointerup, {
            evt: evt,
            target: this,
            currentTarget: this,
            pointerId: this._changedPointerPositions[0].id
        });
        $4v96z.Konva["_" + eventType + "ListenClick"] = false;
        if (evt.cancelable && eventType !== "touch") evt.preventDefault();
    }
    _contextmenu(evt) {
        this.setPointersPositions(evt);
        var shape = this.getIntersection(this.getPointerPosition());
        if (shape && shape.isListening()) shape._fireAndBubble($635062da0a59b87b$var$CONTEXTMENU, {
            evt: evt
        });
        else this._fire($635062da0a59b87b$var$CONTEXTMENU, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _wheel(evt) {
        this.setPointersPositions(evt);
        var shape = this.getIntersection(this.getPointerPosition());
        if (shape && shape.isListening()) shape._fireAndBubble($635062da0a59b87b$var$WHEEL, {
            evt: evt
        });
        else this._fire($635062da0a59b87b$var$WHEEL, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _pointercancel(evt) {
        this.setPointersPositions(evt);
        const shape = $4iqf2.getCapturedShape(evt.pointerId) || this.getIntersection(this.getPointerPosition());
        if (shape) shape._fireAndBubble($635062da0a59b87b$var$POINTERUP, $4iqf2.createEvent(evt));
        $4iqf2.releaseCapture(evt.pointerId);
    }
    _lostpointercapture(evt) {
        $4iqf2.releaseCapture(evt.pointerId);
    }
    setPointersPositions(evt) {
        var contentPosition = this._getContentPosition(), x = null, y = null;
        evt = evt ? evt : window.event;
        if (evt.touches !== undefined) {
            this._pointerPositions = [];
            this._changedPointerPositions = [];
            Array.prototype.forEach.call(evt.touches, (touch)=>{
                this._pointerPositions.push({
                    id: touch.identifier,
                    x: (touch.clientX - contentPosition.left) / contentPosition.scaleX,
                    y: (touch.clientY - contentPosition.top) / contentPosition.scaleY
                });
            });
            Array.prototype.forEach.call(evt.changedTouches || evt.touches, (touch)=>{
                this._changedPointerPositions.push({
                    id: touch.identifier,
                    x: (touch.clientX - contentPosition.left) / contentPosition.scaleX,
                    y: (touch.clientY - contentPosition.top) / contentPosition.scaleY
                });
            });
        } else {
            x = (evt.clientX - contentPosition.left) / contentPosition.scaleX;
            y = (evt.clientY - contentPosition.top) / contentPosition.scaleY;
            this.pointerPos = {
                x: x,
                y: y
            };
            this._pointerPositions = [
                {
                    x: x,
                    y: y,
                    id: $kWs5g.Util._getFirstPointerId(evt)
                }
            ];
            this._changedPointerPositions = [
                {
                    x: x,
                    y: y,
                    id: $kWs5g.Util._getFirstPointerId(evt)
                }
            ];
        }
    }
    _setPointerPosition(evt) {
        $kWs5g.Util.warn('Method _setPointerPosition is deprecated. Use "stage.setPointersPositions(event)" instead.');
        this.setPointersPositions(evt);
    }
    _getContentPosition() {
        if (!this.content || !this.content.getBoundingClientRect) return {
            top: 0,
            left: 0,
            scaleX: 1,
            scaleY: 1
        };
        var rect = this.content.getBoundingClientRect();
        return {
            top: rect.top,
            left: rect.left,
            scaleX: rect.width / this.content.clientWidth || 1,
            scaleY: rect.height / this.content.clientHeight || 1
        };
    }
    _buildDOM() {
        this.bufferCanvas = new $bsljL.SceneCanvas({
            width: this.width(),
            height: this.height()
        });
        this.bufferHitCanvas = new $bsljL.HitCanvas({
            pixelRatio: 1,
            width: this.width(),
            height: this.height()
        });
        if (!$4v96z.Konva.isBrowser) return;
        var container = this.container();
        if (!container) throw "Stage has no container. A container is required.";
        container.innerHTML = "";
        this.content = document.createElement("div");
        this.content.style.position = "relative";
        this.content.style.userSelect = "none";
        this.content.className = "konvajs-content";
        this.content.setAttribute("role", "presentation");
        container.appendChild(this.content);
        this._resizeDOM();
    }
    cache() {
        $kWs5g.Util.warn("Cache function is not allowed for stage. You may use cache only for layers, groups and shapes.");
        return this;
    }
    clearCache() {
        return this;
    }
    batchDraw() {
        this.getChildren().forEach(function(layer) {
            layer.batchDraw();
        });
        return this;
    }
}
module.exports.Stage = $635062da0a59b87b$var$Stage;
$635062da0a59b87b$var$Stage.prototype.nodeType = $635062da0a59b87b$var$STAGE;
(0, $4v96z._registerNode)($635062da0a59b87b$var$Stage);
$3V3su.Factory.addGetterSetter($635062da0a59b87b$var$Stage, "container");

});
parcelRegister("4iqf2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.releaseCapture = module.exports.setPointerCapture = module.exports.hasPointerCapture = module.exports.createEvent = module.exports.getCapturedShape = void 0;

var $4v96z = parcelRequire("4v96z");
const $320d32dd6c43f37b$var$Captures = new Map();
const $320d32dd6c43f37b$var$SUPPORT_POINTER_EVENTS = $4v96z.Konva._global["PointerEvent"] !== undefined;
function $320d32dd6c43f37b$var$getCapturedShape(pointerId) {
    return $320d32dd6c43f37b$var$Captures.get(pointerId);
}
module.exports.getCapturedShape = $320d32dd6c43f37b$var$getCapturedShape;
function $320d32dd6c43f37b$var$createEvent(evt) {
    return {
        evt: evt,
        pointerId: evt.pointerId
    };
}
module.exports.createEvent = $320d32dd6c43f37b$var$createEvent;
function $320d32dd6c43f37b$var$hasPointerCapture(pointerId, shape) {
    return $320d32dd6c43f37b$var$Captures.get(pointerId) === shape;
}
module.exports.hasPointerCapture = $320d32dd6c43f37b$var$hasPointerCapture;
function $320d32dd6c43f37b$var$setPointerCapture(pointerId, shape) {
    $320d32dd6c43f37b$var$releaseCapture(pointerId);
    const stage = shape.getStage();
    if (!stage) return;
    $320d32dd6c43f37b$var$Captures.set(pointerId, shape);
    if ($320d32dd6c43f37b$var$SUPPORT_POINTER_EVENTS) shape._fire("gotpointercapture", $320d32dd6c43f37b$var$createEvent(new PointerEvent("gotpointercapture")));
}
module.exports.setPointerCapture = $320d32dd6c43f37b$var$setPointerCapture;
function $320d32dd6c43f37b$var$releaseCapture(pointerId, target) {
    const shape = $320d32dd6c43f37b$var$Captures.get(pointerId);
    if (!shape) return;
    const stage = shape.getStage();
    stage && stage.content;
    $320d32dd6c43f37b$var$Captures.delete(pointerId);
    if ($320d32dd6c43f37b$var$SUPPORT_POINTER_EVENTS) shape._fire("lostpointercapture", $320d32dd6c43f37b$var$createEvent(new PointerEvent("lostpointercapture")));
}
module.exports.releaseCapture = $320d32dd6c43f37b$var$releaseCapture;

});


parcelRegister("l0qD1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Layer = void 0;

var $kWs5g = parcelRequire("kWs5g");

var $jxWWI = parcelRequire("jxWWI");

var $1qU2E = parcelRequire("1qU2E");

var $3V3su = parcelRequire("3V3su");

var $bsljL = parcelRequire("bsljL");

var $2TXYV = parcelRequire("2TXYV");

var $82UKb = parcelRequire("82UKb");

var $4v96z = parcelRequire("4v96z");
var $f4ae40e132a57e0a$var$HASH = "#", $f4ae40e132a57e0a$var$BEFORE_DRAW = "beforeDraw", $f4ae40e132a57e0a$var$DRAW = "draw", $f4ae40e132a57e0a$var$INTERSECTION_OFFSETS = [
    {
        x: 0,
        y: 0
    },
    {
        x: -1,
        y: -1
    },
    {
        x: 1,
        y: -1
    },
    {
        x: 1,
        y: 1
    },
    {
        x: -1,
        y: 1
    }
], $f4ae40e132a57e0a$var$INTERSECTION_OFFSETS_LEN = $f4ae40e132a57e0a$var$INTERSECTION_OFFSETS.length;
class $f4ae40e132a57e0a$var$Layer extends $jxWWI.Container {
    constructor(config){
        super(config);
        this.canvas = new $bsljL.SceneCanvas();
        this.hitCanvas = new $bsljL.HitCanvas({
            pixelRatio: 1
        });
        this._waitingForDraw = false;
        this.on("visibleChange.konva", this._checkVisibility);
        this._checkVisibility();
        this.on("imageSmoothingEnabledChange.konva", this._setSmoothEnabled);
        this._setSmoothEnabled();
    }
    createPNGStream() {
        const c = this.canvas._canvas;
        return c.createPNGStream();
    }
    getCanvas() {
        return this.canvas;
    }
    getNativeCanvasElement() {
        return this.canvas._canvas;
    }
    getHitCanvas() {
        return this.hitCanvas;
    }
    getContext() {
        return this.getCanvas().getContext();
    }
    clear(bounds) {
        this.getContext().clear(bounds);
        this.getHitCanvas().getContext().clear(bounds);
        return this;
    }
    setZIndex(index) {
        super.setZIndex(index);
        var stage = this.getStage();
        if (stage && stage.content) {
            stage.content.removeChild(this.getNativeCanvasElement());
            if (index < stage.children.length - 1) stage.content.insertBefore(this.getNativeCanvasElement(), stage.children[index + 1].getCanvas()._canvas);
            else stage.content.appendChild(this.getNativeCanvasElement());
        }
        return this;
    }
    moveToTop() {
        $1qU2E.Node.prototype.moveToTop.call(this);
        var stage = this.getStage();
        if (stage && stage.content) {
            stage.content.removeChild(this.getNativeCanvasElement());
            stage.content.appendChild(this.getNativeCanvasElement());
        }
        return true;
    }
    moveUp() {
        var moved = $1qU2E.Node.prototype.moveUp.call(this);
        if (!moved) return false;
        var stage = this.getStage();
        if (!stage || !stage.content) return false;
        stage.content.removeChild(this.getNativeCanvasElement());
        if (this.index < stage.children.length - 1) stage.content.insertBefore(this.getNativeCanvasElement(), stage.children[this.index + 1].getCanvas()._canvas);
        else stage.content.appendChild(this.getNativeCanvasElement());
        return true;
    }
    moveDown() {
        if ($1qU2E.Node.prototype.moveDown.call(this)) {
            var stage = this.getStage();
            if (stage) {
                var children = stage.children;
                if (stage.content) {
                    stage.content.removeChild(this.getNativeCanvasElement());
                    stage.content.insertBefore(this.getNativeCanvasElement(), children[this.index + 1].getCanvas()._canvas);
                }
            }
            return true;
        }
        return false;
    }
    moveToBottom() {
        if ($1qU2E.Node.prototype.moveToBottom.call(this)) {
            var stage = this.getStage();
            if (stage) {
                var children = stage.children;
                if (stage.content) {
                    stage.content.removeChild(this.getNativeCanvasElement());
                    stage.content.insertBefore(this.getNativeCanvasElement(), children[1].getCanvas()._canvas);
                }
            }
            return true;
        }
        return false;
    }
    getLayer() {
        return this;
    }
    remove() {
        var _canvas = this.getNativeCanvasElement();
        $1qU2E.Node.prototype.remove.call(this);
        if (_canvas && _canvas.parentNode && $kWs5g.Util._isInDocument(_canvas)) _canvas.parentNode.removeChild(_canvas);
        return this;
    }
    getStage() {
        return this.parent;
    }
    setSize({ width: width, height: height }) {
        this.canvas.setSize(width, height);
        this.hitCanvas.setSize(width, height);
        this._setSmoothEnabled();
        return this;
    }
    _validateAdd(child) {
        var type = child.getType();
        if (type !== "Group" && type !== "Shape") $kWs5g.Util.throw("You may only add groups and shapes to a layer.");
    }
    _toKonvaCanvas(config) {
        config = config || {};
        config.width = config.width || this.getWidth();
        config.height = config.height || this.getHeight();
        config.x = config.x !== undefined ? config.x : this.x();
        config.y = config.y !== undefined ? config.y : this.y();
        return $1qU2E.Node.prototype._toKonvaCanvas.call(this, config);
    }
    _checkVisibility() {
        const visible = this.visible();
        if (visible) this.canvas._canvas.style.display = "block";
        else this.canvas._canvas.style.display = "none";
    }
    _setSmoothEnabled() {
        this.getContext()._context.imageSmoothingEnabled = this.imageSmoothingEnabled();
    }
    getWidth() {
        if (this.parent) return this.parent.width();
    }
    setWidth() {
        $kWs5g.Util.warn('Can not change width of layer. Use "stage.width(value)" function instead.');
    }
    getHeight() {
        if (this.parent) return this.parent.height();
    }
    setHeight() {
        $kWs5g.Util.warn('Can not change height of layer. Use "stage.height(value)" function instead.');
    }
    batchDraw() {
        if (!this._waitingForDraw) {
            this._waitingForDraw = true;
            $kWs5g.Util.requestAnimFrame(()=>{
                this.draw();
                this._waitingForDraw = false;
            });
        }
        return this;
    }
    getIntersection(pos) {
        if (!this.isListening() || !this.isVisible()) return null;
        var spiralSearchDistance = 1;
        var continueSearch = false;
        while(true){
            for(let i = 0; i < $f4ae40e132a57e0a$var$INTERSECTION_OFFSETS_LEN; i++){
                const intersectionOffset = $f4ae40e132a57e0a$var$INTERSECTION_OFFSETS[i];
                const obj = this._getIntersection({
                    x: pos.x + intersectionOffset.x * spiralSearchDistance,
                    y: pos.y + intersectionOffset.y * spiralSearchDistance
                });
                const shape = obj.shape;
                if (shape) return shape;
                continueSearch = !!obj.antialiased;
                if (!obj.antialiased) break;
            }
            if (continueSearch) spiralSearchDistance += 1;
            else return null;
        }
    }
    _getIntersection(pos) {
        const ratio = this.hitCanvas.pixelRatio;
        const p = this.hitCanvas.context.getImageData(Math.round(pos.x * ratio), Math.round(pos.y * ratio), 1, 1).data;
        const p3 = p[3];
        if (p3 === 255) {
            const colorKey = $kWs5g.Util._rgbToHex(p[0], p[1], p[2]);
            const shape = $82UKb.shapes[$f4ae40e132a57e0a$var$HASH + colorKey];
            if (shape) return {
                shape: shape
            };
            return {
                antialiased: true
            };
        } else if (p3 > 0) return {
            antialiased: true
        };
        return {};
    }
    drawScene(can, top) {
        var layer = this.getLayer(), canvas = can || layer && layer.getCanvas();
        this._fire($f4ae40e132a57e0a$var$BEFORE_DRAW, {
            node: this
        });
        if (this.clearBeforeDraw()) canvas.getContext().clear();
        $jxWWI.Container.prototype.drawScene.call(this, canvas, top);
        this._fire($f4ae40e132a57e0a$var$DRAW, {
            node: this
        });
        return this;
    }
    drawHit(can, top) {
        var layer = this.getLayer(), canvas = can || layer && layer.hitCanvas;
        if (layer && layer.clearBeforeDraw()) layer.getHitCanvas().getContext().clear();
        $jxWWI.Container.prototype.drawHit.call(this, canvas, top);
        return this;
    }
    enableHitGraph() {
        this.hitGraphEnabled(true);
        return this;
    }
    disableHitGraph() {
        this.hitGraphEnabled(false);
        return this;
    }
    setHitGraphEnabled(val) {
        $kWs5g.Util.warn("hitGraphEnabled method is deprecated. Please use layer.listening() instead.");
        this.listening(val);
    }
    getHitGraphEnabled(val) {
        $kWs5g.Util.warn("hitGraphEnabled method is deprecated. Please use layer.listening() instead.");
        return this.listening();
    }
    toggleHitCanvas() {
        if (!this.parent || !this.parent["content"]) return;
        var parent = this.parent;
        var added = !!this.hitCanvas._canvas.parentNode;
        if (added) parent.content.removeChild(this.hitCanvas._canvas);
        else parent.content.appendChild(this.hitCanvas._canvas);
    }
    destroy() {
        $kWs5g.Util.releaseCanvas(this.getNativeCanvasElement(), this.getHitCanvas()._canvas);
        return super.destroy();
    }
}
module.exports.Layer = $f4ae40e132a57e0a$var$Layer;
$f4ae40e132a57e0a$var$Layer.prototype.nodeType = "Layer";
(0, $4v96z._registerNode)($f4ae40e132a57e0a$var$Layer);
$3V3su.Factory.addGetterSetter($f4ae40e132a57e0a$var$Layer, "imageSmoothingEnabled", true);
$3V3su.Factory.addGetterSetter($f4ae40e132a57e0a$var$Layer, "clearBeforeDraw", true);
$3V3su.Factory.addGetterSetter($f4ae40e132a57e0a$var$Layer, "hitGraphEnabled", true, (0, $2TXYV.getBooleanValidator)());

});
parcelRegister("82UKb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Shape = module.exports.shapes = void 0;

var $4v96z = parcelRequire("4v96z");

var $kWs5g = parcelRequire("kWs5g");

var $3V3su = parcelRequire("3V3su");

var $1qU2E = parcelRequire("1qU2E");

var $2TXYV = parcelRequire("2TXYV");

var $4v96z = parcelRequire("4v96z");

var $4iqf2 = parcelRequire("4iqf2");
var $5dba86c3e13a022e$var$HAS_SHADOW = "hasShadow";
var $5dba86c3e13a022e$var$SHADOW_RGBA = "shadowRGBA";
var $5dba86c3e13a022e$var$patternImage = "patternImage";
var $5dba86c3e13a022e$var$linearGradient = "linearGradient";
var $5dba86c3e13a022e$var$radialGradient = "radialGradient";
let $5dba86c3e13a022e$var$dummyContext;
function $5dba86c3e13a022e$var$getDummyContext() {
    if ($5dba86c3e13a022e$var$dummyContext) return $5dba86c3e13a022e$var$dummyContext;
    $5dba86c3e13a022e$var$dummyContext = $kWs5g.Util.createCanvasElement().getContext("2d");
    return $5dba86c3e13a022e$var$dummyContext;
}
module.exports.shapes = {};
function $5dba86c3e13a022e$var$_fillFunc(context) {
    const fillRule = this.attrs.fillRule;
    if (fillRule) context.fill(fillRule);
    else context.fill();
}
function $5dba86c3e13a022e$var$_strokeFunc(context) {
    context.stroke();
}
function $5dba86c3e13a022e$var$_fillFuncHit(context) {
    context.fill();
}
function $5dba86c3e13a022e$var$_strokeFuncHit(context) {
    context.stroke();
}
function $5dba86c3e13a022e$var$_clearHasShadowCache() {
    this._clearCache($5dba86c3e13a022e$var$HAS_SHADOW);
}
function $5dba86c3e13a022e$var$_clearGetShadowRGBACache() {
    this._clearCache($5dba86c3e13a022e$var$SHADOW_RGBA);
}
function $5dba86c3e13a022e$var$_clearFillPatternCache() {
    this._clearCache($5dba86c3e13a022e$var$patternImage);
}
function $5dba86c3e13a022e$var$_clearLinearGradientCache() {
    this._clearCache($5dba86c3e13a022e$var$linearGradient);
}
function $5dba86c3e13a022e$var$_clearRadialGradientCache() {
    this._clearCache($5dba86c3e13a022e$var$radialGradient);
}
class $5dba86c3e13a022e$var$Shape extends $1qU2E.Node {
    constructor(config){
        super(config);
        let key;
        while(true){
            key = $kWs5g.Util.getRandomColor();
            if (key && !(key in module.exports.shapes)) break;
        }
        this.colorKey = key;
        module.exports.shapes[key] = this;
    }
    getContext() {
        $kWs5g.Util.warn("shape.getContext() method is deprecated. Please do not use it.");
        return this.getLayer().getContext();
    }
    getCanvas() {
        $kWs5g.Util.warn("shape.getCanvas() method is deprecated. Please do not use it.");
        return this.getLayer().getCanvas();
    }
    getSceneFunc() {
        return this.attrs.sceneFunc || this["_sceneFunc"];
    }
    getHitFunc() {
        return this.attrs.hitFunc || this["_hitFunc"];
    }
    hasShadow() {
        return this._getCache($5dba86c3e13a022e$var$HAS_SHADOW, this._hasShadow);
    }
    _hasShadow() {
        return this.shadowEnabled() && this.shadowOpacity() !== 0 && !!(this.shadowColor() || this.shadowBlur() || this.shadowOffsetX() || this.shadowOffsetY());
    }
    _getFillPattern() {
        return this._getCache($5dba86c3e13a022e$var$patternImage, this.__getFillPattern);
    }
    __getFillPattern() {
        if (this.fillPatternImage()) {
            var ctx = $5dba86c3e13a022e$var$getDummyContext();
            const pattern = ctx.createPattern(this.fillPatternImage(), this.fillPatternRepeat() || "repeat");
            if (pattern && pattern.setTransform) {
                const tr = new $kWs5g.Transform();
                tr.translate(this.fillPatternX(), this.fillPatternY());
                tr.rotate($4v96z.Konva.getAngle(this.fillPatternRotation()));
                tr.scale(this.fillPatternScaleX(), this.fillPatternScaleY());
                tr.translate(-1 * this.fillPatternOffsetX(), -1 * this.fillPatternOffsetY());
                const m = tr.getMatrix();
                const matrix = typeof DOMMatrix === "undefined" ? {
                    a: m[0],
                    b: m[1],
                    c: m[2],
                    d: m[3],
                    e: m[4],
                    f: m[5]
                } : new DOMMatrix(m);
                pattern.setTransform(matrix);
            }
            return pattern;
        }
    }
    _getLinearGradient() {
        return this._getCache($5dba86c3e13a022e$var$linearGradient, this.__getLinearGradient);
    }
    __getLinearGradient() {
        var colorStops = this.fillLinearGradientColorStops();
        if (colorStops) {
            var ctx = $5dba86c3e13a022e$var$getDummyContext();
            var start = this.fillLinearGradientStartPoint();
            var end = this.fillLinearGradientEndPoint();
            var grd = ctx.createLinearGradient(start.x, start.y, end.x, end.y);
            for(var n = 0; n < colorStops.length; n += 2)grd.addColorStop(colorStops[n], colorStops[n + 1]);
            return grd;
        }
    }
    _getRadialGradient() {
        return this._getCache($5dba86c3e13a022e$var$radialGradient, this.__getRadialGradient);
    }
    __getRadialGradient() {
        var colorStops = this.fillRadialGradientColorStops();
        if (colorStops) {
            var ctx = $5dba86c3e13a022e$var$getDummyContext();
            var start = this.fillRadialGradientStartPoint();
            var end = this.fillRadialGradientEndPoint();
            var grd = ctx.createRadialGradient(start.x, start.y, this.fillRadialGradientStartRadius(), end.x, end.y, this.fillRadialGradientEndRadius());
            for(var n = 0; n < colorStops.length; n += 2)grd.addColorStop(colorStops[n], colorStops[n + 1]);
            return grd;
        }
    }
    getShadowRGBA() {
        return this._getCache($5dba86c3e13a022e$var$SHADOW_RGBA, this._getShadowRGBA);
    }
    _getShadowRGBA() {
        if (!this.hasShadow()) return;
        var rgba = $kWs5g.Util.colorToRGBA(this.shadowColor());
        if (rgba) return "rgba(" + rgba.r + "," + rgba.g + "," + rgba.b + "," + rgba.a * (this.shadowOpacity() || 1) + ")";
    }
    hasFill() {
        return this._calculate("hasFill", [
            "fillEnabled",
            "fill",
            "fillPatternImage",
            "fillLinearGradientColorStops",
            "fillRadialGradientColorStops"
        ], ()=>{
            return this.fillEnabled() && !!(this.fill() || this.fillPatternImage() || this.fillLinearGradientColorStops() || this.fillRadialGradientColorStops());
        });
    }
    hasStroke() {
        return this._calculate("hasStroke", [
            "strokeEnabled",
            "strokeWidth",
            "stroke",
            "strokeLinearGradientColorStops"
        ], ()=>{
            return this.strokeEnabled() && this.strokeWidth() && !!(this.stroke() || this.strokeLinearGradientColorStops());
        });
    }
    hasHitStroke() {
        const width = this.hitStrokeWidth();
        if (width === "auto") return this.hasStroke();
        return this.strokeEnabled() && !!width;
    }
    intersects(point) {
        var stage = this.getStage();
        if (!stage) return false;
        const bufferHitCanvas = stage.bufferHitCanvas;
        bufferHitCanvas.getContext().clear();
        this.drawHit(bufferHitCanvas, undefined, true);
        const p = bufferHitCanvas.context.getImageData(Math.round(point.x), Math.round(point.y), 1, 1).data;
        return p[3] > 0;
    }
    destroy() {
        $1qU2E.Node.prototype.destroy.call(this);
        delete module.exports.shapes[this.colorKey];
        delete this.colorKey;
        return this;
    }
    _useBufferCanvas(forceFill) {
        var _a;
        const perfectDrawEnabled = (_a = this.attrs.perfectDrawEnabled) !== null && _a !== void 0 ? _a : true;
        if (!perfectDrawEnabled) return false;
        const hasFill = forceFill || this.hasFill();
        const hasStroke = this.hasStroke();
        const isTransparent = this.getAbsoluteOpacity() !== 1;
        if (hasFill && hasStroke && isTransparent) return true;
        const hasShadow = this.hasShadow();
        const strokeForShadow = this.shadowForStrokeEnabled();
        if (hasFill && hasStroke && hasShadow && strokeForShadow) return true;
        return false;
    }
    setStrokeHitEnabled(val) {
        $kWs5g.Util.warn("strokeHitEnabled property is deprecated. Please use hitStrokeWidth instead.");
        if (val) this.hitStrokeWidth("auto");
        else this.hitStrokeWidth(0);
    }
    getStrokeHitEnabled() {
        if (this.hitStrokeWidth() === 0) return false;
        else return true;
    }
    getSelfRect() {
        var size = this.size();
        return {
            x: this._centroid ? -size.width / 2 : 0,
            y: this._centroid ? -size.height / 2 : 0,
            width: size.width,
            height: size.height
        };
    }
    getClientRect(config = {}) {
        const skipTransform = config.skipTransform;
        const relativeTo = config.relativeTo;
        const fillRect = this.getSelfRect();
        const applyStroke = !config.skipStroke && this.hasStroke();
        const strokeWidth = applyStroke && this.strokeWidth() || 0;
        const fillAndStrokeWidth = fillRect.width + strokeWidth;
        const fillAndStrokeHeight = fillRect.height + strokeWidth;
        const applyShadow = !config.skipShadow && this.hasShadow();
        const shadowOffsetX = applyShadow ? this.shadowOffsetX() : 0;
        const shadowOffsetY = applyShadow ? this.shadowOffsetY() : 0;
        const preWidth = fillAndStrokeWidth + Math.abs(shadowOffsetX);
        const preHeight = fillAndStrokeHeight + Math.abs(shadowOffsetY);
        const blurRadius = applyShadow && this.shadowBlur() || 0;
        const width = preWidth + blurRadius * 2;
        const height = preHeight + blurRadius * 2;
        const rect = {
            width: width,
            height: height,
            x: -(strokeWidth / 2 + blurRadius) + Math.min(shadowOffsetX, 0) + fillRect.x,
            y: -(strokeWidth / 2 + blurRadius) + Math.min(shadowOffsetY, 0) + fillRect.y
        };
        if (!skipTransform) return this._transformedRect(rect, relativeTo);
        return rect;
    }
    drawScene(can, top, bufferCanvas) {
        var layer = this.getLayer();
        var canvas = can || layer.getCanvas(), context = canvas.getContext(), cachedCanvas = this._getCanvasCache(), drawFunc = this.getSceneFunc(), hasShadow = this.hasShadow(), stage, bufferContext;
        var skipBuffer = canvas.isCache;
        var cachingSelf = top === this;
        if (!this.isVisible() && !cachingSelf) return this;
        if (cachedCanvas) {
            context.save();
            var m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedSceneCanvas(context);
            context.restore();
            return this;
        }
        if (!drawFunc) return this;
        context.save();
        if (this._useBufferCanvas() && !skipBuffer) {
            stage = this.getStage();
            const bc = bufferCanvas || stage.bufferCanvas;
            bufferContext = bc.getContext();
            bufferContext.clear();
            bufferContext.save();
            bufferContext._applyLineJoin(this);
            var o = this.getAbsoluteTransform(top).getMatrix();
            bufferContext.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
            drawFunc.call(this, bufferContext, this);
            bufferContext.restore();
            var ratio = bc.pixelRatio;
            if (hasShadow) context._applyShadow(this);
            context._applyOpacity(this);
            context._applyGlobalCompositeOperation(this);
            context.drawImage(bc._canvas, 0, 0, bc.width / ratio, bc.height / ratio);
        } else {
            context._applyLineJoin(this);
            if (!cachingSelf) {
                var o = this.getAbsoluteTransform(top).getMatrix();
                context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
                context._applyOpacity(this);
                context._applyGlobalCompositeOperation(this);
            }
            if (hasShadow) context._applyShadow(this);
            drawFunc.call(this, context, this);
        }
        context.restore();
        return this;
    }
    drawHit(can, top, skipDragCheck = false) {
        if (!this.shouldDrawHit(top, skipDragCheck)) return this;
        var layer = this.getLayer(), canvas = can || layer.hitCanvas, context = canvas && canvas.getContext(), drawFunc = this.hitFunc() || this.sceneFunc(), cachedCanvas = this._getCanvasCache(), cachedHitCanvas = cachedCanvas && cachedCanvas.hit;
        if (!this.colorKey) $kWs5g.Util.warn("Looks like your canvas has a destroyed shape in it. Do not reuse shape after you destroyed it. If you want to reuse shape you should call remove() instead of destroy()");
        if (cachedHitCanvas) {
            context.save();
            var m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedHitCanvas(context);
            context.restore();
            return this;
        }
        if (!drawFunc) return this;
        context.save();
        context._applyLineJoin(this);
        const selfCache = this === top;
        if (!selfCache) {
            var o = this.getAbsoluteTransform(top).getMatrix();
            context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
        }
        drawFunc.call(this, context, this);
        context.restore();
        return this;
    }
    drawHitFromCache(alphaThreshold = 0) {
        var cachedCanvas = this._getCanvasCache(), sceneCanvas = this._getCachedSceneCanvas(), hitCanvas = cachedCanvas.hit, hitContext = hitCanvas.getContext(), hitWidth = hitCanvas.getWidth(), hitHeight = hitCanvas.getHeight(), hitImageData, hitData, len, rgbColorKey, i, alpha;
        hitContext.clear();
        hitContext.drawImage(sceneCanvas._canvas, 0, 0, hitWidth, hitHeight);
        try {
            hitImageData = hitContext.getImageData(0, 0, hitWidth, hitHeight);
            hitData = hitImageData.data;
            len = hitData.length;
            rgbColorKey = $kWs5g.Util._hexToRgb(this.colorKey);
            for(i = 0; i < len; i += 4){
                alpha = hitData[i + 3];
                if (alpha > alphaThreshold) {
                    hitData[i] = rgbColorKey.r;
                    hitData[i + 1] = rgbColorKey.g;
                    hitData[i + 2] = rgbColorKey.b;
                    hitData[i + 3] = 255;
                } else hitData[i + 3] = 0;
            }
            hitContext.putImageData(hitImageData, 0, 0);
        } catch (e) {
            $kWs5g.Util.error("Unable to draw hit graph from cached scene canvas. " + e.message);
        }
        return this;
    }
    hasPointerCapture(pointerId) {
        return $4iqf2.hasPointerCapture(pointerId, this);
    }
    setPointerCapture(pointerId) {
        $4iqf2.setPointerCapture(pointerId, this);
    }
    releaseCapture(pointerId) {
        $4iqf2.releaseCapture(pointerId, this);
    }
}
module.exports.Shape = $5dba86c3e13a022e$var$Shape;
$5dba86c3e13a022e$var$Shape.prototype._fillFunc = $5dba86c3e13a022e$var$_fillFunc;
$5dba86c3e13a022e$var$Shape.prototype._strokeFunc = $5dba86c3e13a022e$var$_strokeFunc;
$5dba86c3e13a022e$var$Shape.prototype._fillFuncHit = $5dba86c3e13a022e$var$_fillFuncHit;
$5dba86c3e13a022e$var$Shape.prototype._strokeFuncHit = $5dba86c3e13a022e$var$_strokeFuncHit;
$5dba86c3e13a022e$var$Shape.prototype._centroid = false;
$5dba86c3e13a022e$var$Shape.prototype.nodeType = "Shape";
(0, $4v96z._registerNode)($5dba86c3e13a022e$var$Shape);
$5dba86c3e13a022e$var$Shape.prototype.eventListeners = {};
$5dba86c3e13a022e$var$Shape.prototype.on.call($5dba86c3e13a022e$var$Shape.prototype, "shadowColorChange.konva shadowBlurChange.konva shadowOffsetChange.konva shadowOpacityChange.konva shadowEnabledChange.konva", $5dba86c3e13a022e$var$_clearHasShadowCache);
$5dba86c3e13a022e$var$Shape.prototype.on.call($5dba86c3e13a022e$var$Shape.prototype, "shadowColorChange.konva shadowOpacityChange.konva shadowEnabledChange.konva", $5dba86c3e13a022e$var$_clearGetShadowRGBACache);
$5dba86c3e13a022e$var$Shape.prototype.on.call($5dba86c3e13a022e$var$Shape.prototype, "fillPriorityChange.konva fillPatternImageChange.konva fillPatternRepeatChange.konva fillPatternScaleXChange.konva fillPatternScaleYChange.konva fillPatternOffsetXChange.konva fillPatternOffsetYChange.konva fillPatternXChange.konva fillPatternYChange.konva fillPatternRotationChange.konva", $5dba86c3e13a022e$var$_clearFillPatternCache);
$5dba86c3e13a022e$var$Shape.prototype.on.call($5dba86c3e13a022e$var$Shape.prototype, "fillPriorityChange.konva fillLinearGradientColorStopsChange.konva fillLinearGradientStartPointXChange.konva fillLinearGradientStartPointYChange.konva fillLinearGradientEndPointXChange.konva fillLinearGradientEndPointYChange.konva", $5dba86c3e13a022e$var$_clearLinearGradientCache);
$5dba86c3e13a022e$var$Shape.prototype.on.call($5dba86c3e13a022e$var$Shape.prototype, "fillPriorityChange.konva fillRadialGradientColorStopsChange.konva fillRadialGradientStartPointXChange.konva fillRadialGradientStartPointYChange.konva fillRadialGradientEndPointXChange.konva fillRadialGradientEndPointYChange.konva fillRadialGradientStartRadiusChange.konva fillRadialGradientEndRadiusChange.konva", $5dba86c3e13a022e$var$_clearRadialGradientCache);
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "stroke", undefined, (0, $2TXYV.getStringOrGradientValidator)());
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "strokeWidth", 2, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "fillAfterStrokeEnabled", false);
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "hitStrokeWidth", "auto", (0, $2TXYV.getNumberOrAutoValidator)());
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "strokeHitEnabled", true, (0, $2TXYV.getBooleanValidator)());
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "perfectDrawEnabled", true, (0, $2TXYV.getBooleanValidator)());
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "shadowForStrokeEnabled", true, (0, $2TXYV.getBooleanValidator)());
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "lineJoin");
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "lineCap");
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "sceneFunc");
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "hitFunc");
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "dash");
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "dashOffset", 0, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "shadowColor", undefined, (0, $2TXYV.getStringValidator)());
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "shadowBlur", 0, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "shadowOpacity", 1, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addComponentsGetterSetter($5dba86c3e13a022e$var$Shape, "shadowOffset", [
    "x",
    "y"
]);
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "shadowOffsetX", 0, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "shadowOffsetY", 0, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "fillPatternImage");
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "fill", undefined, (0, $2TXYV.getStringOrGradientValidator)());
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "fillPatternX", 0, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "fillPatternY", 0, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "fillLinearGradientColorStops");
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "strokeLinearGradientColorStops");
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "fillRadialGradientStartRadius", 0);
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "fillRadialGradientEndRadius", 0);
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "fillRadialGradientColorStops");
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "fillPatternRepeat", "repeat");
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "fillEnabled", true);
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "strokeEnabled", true);
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "shadowEnabled", true);
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "dashEnabled", true);
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "strokeScaleEnabled", true);
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "fillPriority", "color");
$3V3su.Factory.addComponentsGetterSetter($5dba86c3e13a022e$var$Shape, "fillPatternOffset", [
    "x",
    "y"
]);
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "fillPatternOffsetX", 0, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "fillPatternOffsetY", 0, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addComponentsGetterSetter($5dba86c3e13a022e$var$Shape, "fillPatternScale", [
    "x",
    "y"
]);
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "fillPatternScaleX", 1, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "fillPatternScaleY", 1, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addComponentsGetterSetter($5dba86c3e13a022e$var$Shape, "fillLinearGradientStartPoint", [
    "x",
    "y"
]);
$3V3su.Factory.addComponentsGetterSetter($5dba86c3e13a022e$var$Shape, "strokeLinearGradientStartPoint", [
    "x",
    "y"
]);
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "fillLinearGradientStartPointX", 0);
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "strokeLinearGradientStartPointX", 0);
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "fillLinearGradientStartPointY", 0);
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "strokeLinearGradientStartPointY", 0);
$3V3su.Factory.addComponentsGetterSetter($5dba86c3e13a022e$var$Shape, "fillLinearGradientEndPoint", [
    "x",
    "y"
]);
$3V3su.Factory.addComponentsGetterSetter($5dba86c3e13a022e$var$Shape, "strokeLinearGradientEndPoint", [
    "x",
    "y"
]);
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "fillLinearGradientEndPointX", 0);
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "strokeLinearGradientEndPointX", 0);
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "fillLinearGradientEndPointY", 0);
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "strokeLinearGradientEndPointY", 0);
$3V3su.Factory.addComponentsGetterSetter($5dba86c3e13a022e$var$Shape, "fillRadialGradientStartPoint", [
    "x",
    "y"
]);
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "fillRadialGradientStartPointX", 0);
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "fillRadialGradientStartPointY", 0);
$3V3su.Factory.addComponentsGetterSetter($5dba86c3e13a022e$var$Shape, "fillRadialGradientEndPoint", [
    "x",
    "y"
]);
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "fillRadialGradientEndPointX", 0);
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "fillRadialGradientEndPointY", 0);
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "fillPatternRotation", 0);
$3V3su.Factory.addGetterSetter($5dba86c3e13a022e$var$Shape, "fillRule", undefined, (0, $2TXYV.getStringValidator)());
$3V3su.Factory.backCompat($5dba86c3e13a022e$var$Shape, {
    dashArray: "dash",
    getDashArray: "getDash",
    setDashArray: "getDash",
    drawFunc: "sceneFunc",
    getDrawFunc: "getSceneFunc",
    setDrawFunc: "setSceneFunc",
    drawHitFunc: "hitFunc",
    getDrawHitFunc: "getHitFunc",
    setDrawHitFunc: "setHitFunc"
});

});


parcelRegister("6TLyv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FastLayer = void 0;

var $kWs5g = parcelRequire("kWs5g");

var $l0qD1 = parcelRequire("l0qD1");

var $4v96z = parcelRequire("4v96z");
class $505cc4a6f464c380$var$FastLayer extends $l0qD1.Layer {
    constructor(attrs){
        super(attrs);
        this.listening(false);
        $kWs5g.Util.warn('Konva.Fast layer is deprecated. Please use "new Konva.Layer({ listening: false })" instead.');
    }
}
module.exports.FastLayer = $505cc4a6f464c380$var$FastLayer;
$505cc4a6f464c380$var$FastLayer.prototype.nodeType = "FastLayer";
(0, $4v96z._registerNode)($505cc4a6f464c380$var$FastLayer);

});

parcelRegister("4gbUw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Group = void 0;

var $kWs5g = parcelRequire("kWs5g");

var $jxWWI = parcelRequire("jxWWI");

var $4v96z = parcelRequire("4v96z");
class $31a1e53ab668aeb6$var$Group extends $jxWWI.Container {
    _validateAdd(child) {
        var type = child.getType();
        if (type !== "Group" && type !== "Shape") $kWs5g.Util.throw("You may only add groups and shapes to groups.");
    }
}
module.exports.Group = $31a1e53ab668aeb6$var$Group;
$31a1e53ab668aeb6$var$Group.prototype.nodeType = "Group";
(0, $4v96z._registerNode)($31a1e53ab668aeb6$var$Group);

});

parcelRegister("hgtvs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Animation = void 0;

var $4v96z = parcelRequire("4v96z");

var $kWs5g = parcelRequire("kWs5g");
const $c91ad1a521847385$var$now = function() {
    if ($4v96z.glob.performance && $4v96z.glob.performance.now) return function() {
        return $4v96z.glob.performance.now();
    };
    return function() {
        return new Date().getTime();
    };
}();
class $c91ad1a521847385$var$Animation {
    constructor(func, layers){
        this.id = $c91ad1a521847385$var$Animation.animIdCounter++;
        this.frame = {
            time: 0,
            timeDiff: 0,
            lastTime: $c91ad1a521847385$var$now(),
            frameRate: 0
        };
        this.func = func;
        this.setLayers(layers);
    }
    setLayers(layers) {
        let lays = [];
        if (layers) lays = Array.isArray(layers) ? layers : [
            layers
        ];
        this.layers = lays;
        return this;
    }
    getLayers() {
        return this.layers;
    }
    addLayer(layer) {
        const layers = this.layers;
        const len = layers.length;
        for(let n = 0; n < len; n++){
            if (layers[n]._id === layer._id) return false;
        }
        this.layers.push(layer);
        return true;
    }
    isRunning() {
        const a = $c91ad1a521847385$var$Animation;
        const animations = a.animations;
        const len = animations.length;
        for(let n = 0; n < len; n++){
            if (animations[n].id === this.id) return true;
        }
        return false;
    }
    start() {
        this.stop();
        this.frame.timeDiff = 0;
        this.frame.lastTime = $c91ad1a521847385$var$now();
        $c91ad1a521847385$var$Animation._addAnimation(this);
        return this;
    }
    stop() {
        $c91ad1a521847385$var$Animation._removeAnimation(this);
        return this;
    }
    _updateFrameObject(time) {
        this.frame.timeDiff = time - this.frame.lastTime;
        this.frame.lastTime = time;
        this.frame.time += this.frame.timeDiff;
        this.frame.frameRate = 1000 / this.frame.timeDiff;
    }
    static _addAnimation(anim) {
        this.animations.push(anim);
        this._handleAnimation();
    }
    static _removeAnimation(anim) {
        const id = anim.id;
        const animations = this.animations;
        const len = animations.length;
        for(let n = 0; n < len; n++)if (animations[n].id === id) {
            this.animations.splice(n, 1);
            break;
        }
    }
    static _runFrames() {
        const layerHash = {};
        const animations = this.animations;
        for(let n = 0; n < animations.length; n++){
            const anim = animations[n];
            const layers = anim.layers;
            const func = anim.func;
            anim._updateFrameObject($c91ad1a521847385$var$now());
            const layersLen = layers.length;
            let needRedraw;
            if (func) needRedraw = func.call(anim, anim.frame) !== false;
            else needRedraw = true;
            if (!needRedraw) continue;
            for(let i = 0; i < layersLen; i++){
                const layer = layers[i];
                if (layer._id !== undefined) layerHash[layer._id] = layer;
            }
        }
        for(let key in layerHash){
            if (!layerHash.hasOwnProperty(key)) continue;
            layerHash[key].batchDraw();
        }
    }
    static _animationLoop() {
        const Anim = $c91ad1a521847385$var$Animation;
        if (Anim.animations.length) {
            Anim._runFrames();
            $kWs5g.Util.requestAnimFrame(Anim._animationLoop);
        } else Anim.animRunning = false;
    }
    static _handleAnimation() {
        if (!this.animRunning) {
            this.animRunning = true;
            $kWs5g.Util.requestAnimFrame(this._animationLoop);
        }
    }
}
module.exports.Animation = $c91ad1a521847385$var$Animation;
$c91ad1a521847385$var$Animation.animations = [];
$c91ad1a521847385$var$Animation.animIdCounter = 0;
$c91ad1a521847385$var$Animation.animRunning = false;

});

parcelRegister("9zlC2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Easings = module.exports.Tween = void 0;

var $kWs5g = parcelRequire("kWs5g");

var $hgtvs = parcelRequire("hgtvs");

var $1qU2E = parcelRequire("1qU2E");

var $4v96z = parcelRequire("4v96z");
var $6f7825b98a980f2a$var$blacklist = {
    node: 1,
    duration: 1,
    easing: 1,
    onFinish: 1,
    yoyo: 1
}, $6f7825b98a980f2a$var$PAUSED = 1, $6f7825b98a980f2a$var$PLAYING = 2, $6f7825b98a980f2a$var$REVERSING = 3, $6f7825b98a980f2a$var$idCounter = 0, $6f7825b98a980f2a$var$colorAttrs = [
    "fill",
    "stroke",
    "shadowColor"
];
class $6f7825b98a980f2a$var$TweenEngine {
    constructor(prop, propFunc, func, begin, finish, duration, yoyo){
        this.prop = prop;
        this.propFunc = propFunc;
        this.begin = begin;
        this._pos = begin;
        this.duration = duration;
        this._change = 0;
        this.prevPos = 0;
        this.yoyo = yoyo;
        this._time = 0;
        this._position = 0;
        this._startTime = 0;
        this._finish = 0;
        this.func = func;
        this._change = finish - this.begin;
        this.pause();
    }
    fire(str) {
        var handler = this[str];
        if (handler) handler();
    }
    setTime(t) {
        if (t > this.duration) {
            if (this.yoyo) {
                this._time = this.duration;
                this.reverse();
            } else this.finish();
        } else if (t < 0) {
            if (this.yoyo) {
                this._time = 0;
                this.play();
            } else this.reset();
        } else {
            this._time = t;
            this.update();
        }
    }
    getTime() {
        return this._time;
    }
    setPosition(p) {
        this.prevPos = this._pos;
        this.propFunc(p);
        this._pos = p;
    }
    getPosition(t) {
        if (t === undefined) t = this._time;
        return this.func(t, this.begin, this._change, this.duration);
    }
    play() {
        this.state = $6f7825b98a980f2a$var$PLAYING;
        this._startTime = this.getTimer() - this._time;
        this.onEnterFrame();
        this.fire("onPlay");
    }
    reverse() {
        this.state = $6f7825b98a980f2a$var$REVERSING;
        this._time = this.duration - this._time;
        this._startTime = this.getTimer() - this._time;
        this.onEnterFrame();
        this.fire("onReverse");
    }
    seek(t) {
        this.pause();
        this._time = t;
        this.update();
        this.fire("onSeek");
    }
    reset() {
        this.pause();
        this._time = 0;
        this.update();
        this.fire("onReset");
    }
    finish() {
        this.pause();
        this._time = this.duration;
        this.update();
        this.fire("onFinish");
    }
    update() {
        this.setPosition(this.getPosition(this._time));
        this.fire("onUpdate");
    }
    onEnterFrame() {
        var t = this.getTimer() - this._startTime;
        if (this.state === $6f7825b98a980f2a$var$PLAYING) this.setTime(t);
        else if (this.state === $6f7825b98a980f2a$var$REVERSING) this.setTime(this.duration - t);
    }
    pause() {
        this.state = $6f7825b98a980f2a$var$PAUSED;
        this.fire("onPause");
    }
    getTimer() {
        return new Date().getTime();
    }
}
class $6f7825b98a980f2a$var$Tween {
    constructor(config){
        var that = this, node = config.node, nodeId = node._id, duration, easing = config.easing || module.exports.Easings.Linear, yoyo = !!config.yoyo, key;
        if (typeof config.duration === "undefined") duration = 0.3;
        else if (config.duration === 0) duration = 0.001;
        else duration = config.duration;
        this.node = node;
        this._id = $6f7825b98a980f2a$var$idCounter++;
        var layers = node.getLayer() || (node instanceof $4v96z.Konva["Stage"] ? node.getLayers() : null);
        if (!layers) $kWs5g.Util.error("Tween constructor have `node` that is not in a layer. Please add node into layer first.");
        this.anim = new $hgtvs.Animation(function() {
            that.tween.onEnterFrame();
        }, layers);
        this.tween = new $6f7825b98a980f2a$var$TweenEngine(key, function(i) {
            that._tweenFunc(i);
        }, easing, 0, 1, duration * 1000, yoyo);
        this._addListeners();
        if (!$6f7825b98a980f2a$var$Tween.attrs[nodeId]) $6f7825b98a980f2a$var$Tween.attrs[nodeId] = {};
        if (!$6f7825b98a980f2a$var$Tween.attrs[nodeId][this._id]) $6f7825b98a980f2a$var$Tween.attrs[nodeId][this._id] = {};
        if (!$6f7825b98a980f2a$var$Tween.tweens[nodeId]) $6f7825b98a980f2a$var$Tween.tweens[nodeId] = {};
        for(key in config)if ($6f7825b98a980f2a$var$blacklist[key] === undefined) this._addAttr(key, config[key]);
        this.reset();
        this.onFinish = config.onFinish;
        this.onReset = config.onReset;
        this.onUpdate = config.onUpdate;
    }
    _addAttr(key, end) {
        var node = this.node, nodeId = node._id, start, diff, tweenId, n, len, trueEnd, trueStart, endRGBA;
        tweenId = $6f7825b98a980f2a$var$Tween.tweens[nodeId][key];
        if (tweenId) delete $6f7825b98a980f2a$var$Tween.attrs[nodeId][tweenId][key];
        start = node.getAttr(key);
        if ($kWs5g.Util._isArray(end)) {
            diff = [];
            len = Math.max(end.length, start.length);
            if (key === "points" && end.length !== start.length) {
                if (end.length > start.length) {
                    trueStart = start;
                    start = $kWs5g.Util._prepareArrayForTween(start, end, node.closed());
                } else {
                    trueEnd = end;
                    end = $kWs5g.Util._prepareArrayForTween(end, start, node.closed());
                }
            }
            if (key.indexOf("fill") === 0) {
                for(n = 0; n < len; n++)if (n % 2 === 0) diff.push(end[n] - start[n]);
                else {
                    var startRGBA = $kWs5g.Util.colorToRGBA(start[n]);
                    endRGBA = $kWs5g.Util.colorToRGBA(end[n]);
                    start[n] = startRGBA;
                    diff.push({
                        r: endRGBA.r - startRGBA.r,
                        g: endRGBA.g - startRGBA.g,
                        b: endRGBA.b - startRGBA.b,
                        a: endRGBA.a - startRGBA.a
                    });
                }
            } else for(n = 0; n < len; n++)diff.push(end[n] - start[n]);
        } else if ($6f7825b98a980f2a$var$colorAttrs.indexOf(key) !== -1) {
            start = $kWs5g.Util.colorToRGBA(start);
            endRGBA = $kWs5g.Util.colorToRGBA(end);
            diff = {
                r: endRGBA.r - start.r,
                g: endRGBA.g - start.g,
                b: endRGBA.b - start.b,
                a: endRGBA.a - start.a
            };
        } else diff = end - start;
        $6f7825b98a980f2a$var$Tween.attrs[nodeId][this._id][key] = {
            start: start,
            diff: diff,
            end: end,
            trueEnd: trueEnd,
            trueStart: trueStart
        };
        $6f7825b98a980f2a$var$Tween.tweens[nodeId][key] = this._id;
    }
    _tweenFunc(i) {
        var node = this.node, attrs = $6f7825b98a980f2a$var$Tween.attrs[node._id][this._id], key, attr, start, diff, newVal, n, len, end;
        for(key in attrs){
            attr = attrs[key];
            start = attr.start;
            diff = attr.diff;
            end = attr.end;
            if ($kWs5g.Util._isArray(start)) {
                newVal = [];
                len = Math.max(start.length, end.length);
                if (key.indexOf("fill") === 0) {
                    for(n = 0; n < len; n++)if (n % 2 === 0) newVal.push((start[n] || 0) + diff[n] * i);
                    else newVal.push("rgba(" + Math.round(start[n].r + diff[n].r * i) + "," + Math.round(start[n].g + diff[n].g * i) + "," + Math.round(start[n].b + diff[n].b * i) + "," + (start[n].a + diff[n].a * i) + ")");
                } else for(n = 0; n < len; n++)newVal.push((start[n] || 0) + diff[n] * i);
            } else if ($6f7825b98a980f2a$var$colorAttrs.indexOf(key) !== -1) newVal = "rgba(" + Math.round(start.r + diff.r * i) + "," + Math.round(start.g + diff.g * i) + "," + Math.round(start.b + diff.b * i) + "," + (start.a + diff.a * i) + ")";
            else newVal = start + diff * i;
            node.setAttr(key, newVal);
        }
    }
    _addListeners() {
        this.tween.onPlay = ()=>{
            this.anim.start();
        };
        this.tween.onReverse = ()=>{
            this.anim.start();
        };
        this.tween.onPause = ()=>{
            this.anim.stop();
        };
        this.tween.onFinish = ()=>{
            var node = this.node;
            var attrs = $6f7825b98a980f2a$var$Tween.attrs[node._id][this._id];
            if (attrs.points && attrs.points.trueEnd) node.setAttr("points", attrs.points.trueEnd);
            if (this.onFinish) this.onFinish.call(this);
        };
        this.tween.onReset = ()=>{
            var node = this.node;
            var attrs = $6f7825b98a980f2a$var$Tween.attrs[node._id][this._id];
            if (attrs.points && attrs.points.trueStart) node.points(attrs.points.trueStart);
            if (this.onReset) this.onReset();
        };
        this.tween.onUpdate = ()=>{
            if (this.onUpdate) this.onUpdate.call(this);
        };
    }
    play() {
        this.tween.play();
        return this;
    }
    reverse() {
        this.tween.reverse();
        return this;
    }
    reset() {
        this.tween.reset();
        return this;
    }
    seek(t) {
        this.tween.seek(t * 1000);
        return this;
    }
    pause() {
        this.tween.pause();
        return this;
    }
    finish() {
        this.tween.finish();
        return this;
    }
    destroy() {
        var nodeId = this.node._id, thisId = this._id, attrs = $6f7825b98a980f2a$var$Tween.tweens[nodeId], key;
        this.pause();
        for(key in attrs)delete $6f7825b98a980f2a$var$Tween.tweens[nodeId][key];
        delete $6f7825b98a980f2a$var$Tween.attrs[nodeId][thisId];
    }
}
module.exports.Tween = $6f7825b98a980f2a$var$Tween;
$6f7825b98a980f2a$var$Tween.attrs = {};
$6f7825b98a980f2a$var$Tween.tweens = {};
$1qU2E.Node.prototype.to = function(params) {
    var onFinish = params.onFinish;
    params.node = this;
    params.onFinish = function() {
        this.destroy();
        if (onFinish) onFinish();
    };
    var tween = new $6f7825b98a980f2a$var$Tween(params);
    tween.play();
};
module.exports.Easings = {
    BackEaseIn (t, b, c, d) {
        var s = 1.70158;
        return c * (t /= d) * t * ((s + 1) * t - s) + b;
    },
    BackEaseOut (t, b, c, d) {
        var s = 1.70158;
        return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
    },
    BackEaseInOut (t, b, c, d) {
        var s = 1.70158;
        if ((t /= d / 2) < 1) return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
        return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
    },
    ElasticEaseIn (t, b, c, d, a, p) {
        var s = 0;
        if (t === 0) return b;
        if ((t /= d) === 1) return b + c;
        if (!p) p = d * 0.3;
        if (!a || a < Math.abs(c)) {
            a = c;
            s = p / 4;
        } else s = p / (2 * Math.PI) * Math.asin(c / a);
        return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
    },
    ElasticEaseOut (t, b, c, d, a, p) {
        var s = 0;
        if (t === 0) return b;
        if ((t /= d) === 1) return b + c;
        if (!p) p = d * 0.3;
        if (!a || a < Math.abs(c)) {
            a = c;
            s = p / 4;
        } else s = p / (2 * Math.PI) * Math.asin(c / a);
        return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
    },
    ElasticEaseInOut (t, b, c, d, a, p) {
        var s = 0;
        if (t === 0) return b;
        if ((t /= d / 2) === 2) return b + c;
        if (!p) p = d * (0.3 * 1.5);
        if (!a || a < Math.abs(c)) {
            a = c;
            s = p / 4;
        } else s = p / (2 * Math.PI) * Math.asin(c / a);
        if (t < 1) return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
        return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * 0.5 + c + b;
    },
    BounceEaseOut (t, b, c, d) {
        if ((t /= d) < 1 / 2.75) return c * (7.5625 * t * t) + b;
        else if (t < 2 / 2.75) return c * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + b;
        else if (t < 2.5 / 2.75) return c * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + b;
        else return c * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + b;
    },
    BounceEaseIn (t, b, c, d) {
        return c - module.exports.Easings.BounceEaseOut(d - t, 0, c, d) + b;
    },
    BounceEaseInOut (t, b, c, d) {
        if (t < d / 2) return module.exports.Easings.BounceEaseIn(t * 2, 0, c, d) * 0.5 + b;
        else return module.exports.Easings.BounceEaseOut(t * 2 - d, 0, c, d) * 0.5 + c * 0.5 + b;
    },
    EaseIn (t, b, c, d) {
        return c * (t /= d) * t + b;
    },
    EaseOut (t, b, c, d) {
        return -c * (t /= d) * (t - 2) + b;
    },
    EaseInOut (t, b, c, d) {
        if ((t /= d / 2) < 1) return c / 2 * t * t + b;
        return -c / 2 * (--t * (t - 2) - 1) + b;
    },
    StrongEaseIn (t, b, c, d) {
        return c * (t /= d) * t * t * t * t + b;
    },
    StrongEaseOut (t, b, c, d) {
        return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
    },
    StrongEaseInOut (t, b, c, d) {
        if ((t /= d / 2) < 1) return c / 2 * t * t * t * t * t + b;
        return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
    },
    Linear (t, b, c, d) {
        return c * t / d + b;
    }
};

});


parcelRegister("22qqi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Arc = void 0;

var $3V3su = parcelRequire("3V3su");

var $82UKb = parcelRequire("82UKb");

var $4v96z = parcelRequire("4v96z");

var $2TXYV = parcelRequire("2TXYV");

var $4v96z = parcelRequire("4v96z");
class $17c043bbc1754635$var$Arc extends $82UKb.Shape {
    _sceneFunc(context) {
        var angle = $4v96z.Konva.getAngle(this.angle()), clockwise = this.clockwise();
        context.beginPath();
        context.arc(0, 0, this.outerRadius(), 0, angle, clockwise);
        context.arc(0, 0, this.innerRadius(), angle, 0, !clockwise);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.outerRadius() * 2;
    }
    getHeight() {
        return this.outerRadius() * 2;
    }
    setWidth(width) {
        this.outerRadius(width / 2);
    }
    setHeight(height) {
        this.outerRadius(height / 2);
    }
    getSelfRect() {
        const innerRadius = this.innerRadius();
        const outerRadius = this.outerRadius();
        const clockwise = this.clockwise();
        const angle = $4v96z.Konva.getAngle(clockwise ? 360 - this.angle() : this.angle());
        const boundLeftRatio = Math.cos(Math.min(angle, Math.PI));
        const boundRightRatio = 1;
        const boundTopRatio = Math.sin(Math.min(Math.max(Math.PI, angle), 3 * Math.PI / 2));
        const boundBottomRatio = Math.sin(Math.min(angle, Math.PI / 2));
        const boundLeft = boundLeftRatio * (boundLeftRatio > 0 ? innerRadius : outerRadius);
        const boundRight = boundRightRatio * (boundRightRatio > 0 ? outerRadius : innerRadius);
        const boundTop = boundTopRatio * (boundTopRatio > 0 ? innerRadius : outerRadius);
        const boundBottom = boundBottomRatio * (boundBottomRatio > 0 ? outerRadius : innerRadius);
        return {
            x: boundLeft,
            y: clockwise ? -1 * boundBottom : boundTop,
            width: boundRight - boundLeft,
            height: boundBottom - boundTop
        };
    }
}
module.exports.Arc = $17c043bbc1754635$var$Arc;
$17c043bbc1754635$var$Arc.prototype._centroid = true;
$17c043bbc1754635$var$Arc.prototype.className = "Arc";
$17c043bbc1754635$var$Arc.prototype._attrsAffectingSize = [
    "innerRadius",
    "outerRadius"
];
(0, $4v96z._registerNode)($17c043bbc1754635$var$Arc);
$3V3su.Factory.addGetterSetter($17c043bbc1754635$var$Arc, "innerRadius", 0, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($17c043bbc1754635$var$Arc, "outerRadius", 0, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($17c043bbc1754635$var$Arc, "angle", 0, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($17c043bbc1754635$var$Arc, "clockwise", false, (0, $2TXYV.getBooleanValidator)());

});

parcelRegister("5NOpv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Arrow = void 0;

var $3V3su = parcelRequire("3V3su");

var $ht0WH = parcelRequire("ht0WH");

var $2TXYV = parcelRequire("2TXYV");

var $4v96z = parcelRequire("4v96z");

var $7s2S9 = parcelRequire("7s2S9");
class $4398a1ce6d5005a6$var$Arrow extends $ht0WH.Line {
    _sceneFunc(ctx) {
        super._sceneFunc(ctx);
        var PI2 = Math.PI * 2;
        var points = this.points();
        var tp = points;
        var fromTension = this.tension() !== 0 && points.length > 4;
        if (fromTension) tp = this.getTensionPoints();
        var length = this.pointerLength();
        var n = points.length;
        var dx, dy;
        if (fromTension) {
            const lp = [
                tp[tp.length - 4],
                tp[tp.length - 3],
                tp[tp.length - 2],
                tp[tp.length - 1],
                points[n - 2],
                points[n - 1]
            ];
            const lastLength = $7s2S9.Path.calcLength(tp[tp.length - 4], tp[tp.length - 3], "C", lp);
            const previous = $7s2S9.Path.getPointOnQuadraticBezier(Math.min(1, 1 - length / lastLength), lp[0], lp[1], lp[2], lp[3], lp[4], lp[5]);
            dx = points[n - 2] - previous.x;
            dy = points[n - 1] - previous.y;
        } else {
            dx = points[n - 2] - points[n - 4];
            dy = points[n - 1] - points[n - 3];
        }
        var radians = (Math.atan2(dy, dx) + PI2) % PI2;
        var width = this.pointerWidth();
        if (this.pointerAtEnding()) {
            ctx.save();
            ctx.beginPath();
            ctx.translate(points[n - 2], points[n - 1]);
            ctx.rotate(radians);
            ctx.moveTo(0, 0);
            ctx.lineTo(-length, width / 2);
            ctx.lineTo(-length, -width / 2);
            ctx.closePath();
            ctx.restore();
            this.__fillStroke(ctx);
        }
        if (this.pointerAtBeginning()) {
            ctx.save();
            ctx.beginPath();
            ctx.translate(points[0], points[1]);
            if (fromTension) {
                dx = (tp[0] + tp[2]) / 2 - points[0];
                dy = (tp[1] + tp[3]) / 2 - points[1];
            } else {
                dx = points[2] - points[0];
                dy = points[3] - points[1];
            }
            ctx.rotate((Math.atan2(-dy, -dx) + PI2) % PI2);
            ctx.moveTo(0, 0);
            ctx.lineTo(-length, width / 2);
            ctx.lineTo(-length, -width / 2);
            ctx.closePath();
            ctx.restore();
            this.__fillStroke(ctx);
        }
    }
    __fillStroke(ctx) {
        var isDashEnabled = this.dashEnabled();
        if (isDashEnabled) {
            this.attrs.dashEnabled = false;
            ctx.setLineDash([]);
        }
        ctx.fillStrokeShape(this);
        if (isDashEnabled) this.attrs.dashEnabled = true;
    }
    getSelfRect() {
        const lineRect = super.getSelfRect();
        const offset = this.pointerWidth() / 2;
        return {
            x: lineRect.x - offset,
            y: lineRect.y - offset,
            width: lineRect.width + offset * 2,
            height: lineRect.height + offset * 2
        };
    }
}
module.exports.Arrow = $4398a1ce6d5005a6$var$Arrow;
$4398a1ce6d5005a6$var$Arrow.prototype.className = "Arrow";
(0, $4v96z._registerNode)($4398a1ce6d5005a6$var$Arrow);
$3V3su.Factory.addGetterSetter($4398a1ce6d5005a6$var$Arrow, "pointerLength", 10, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($4398a1ce6d5005a6$var$Arrow, "pointerWidth", 10, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($4398a1ce6d5005a6$var$Arrow, "pointerAtBeginning", false);
$3V3su.Factory.addGetterSetter($4398a1ce6d5005a6$var$Arrow, "pointerAtEnding", true);

});
parcelRegister("ht0WH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Line = void 0;

var $3V3su = parcelRequire("3V3su");

var $82UKb = parcelRequire("82UKb");

var $2TXYV = parcelRequire("2TXYV");

var $4v96z = parcelRequire("4v96z");
function $cb75e0ee0c2958b9$var$getControlPoints(x0, y0, x1, y1, x2, y2, t) {
    var d01 = Math.sqrt(Math.pow(x1 - x0, 2) + Math.pow(y1 - y0, 2)), d12 = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2)), fa = t * d01 / (d01 + d12), fb = t * d12 / (d01 + d12), p1x = x1 - fa * (x2 - x0), p1y = y1 - fa * (y2 - y0), p2x = x1 + fb * (x2 - x0), p2y = y1 + fb * (y2 - y0);
    return [
        p1x,
        p1y,
        p2x,
        p2y
    ];
}
function $cb75e0ee0c2958b9$var$expandPoints(p, tension) {
    var len = p.length, allPoints = [], n, cp;
    for(n = 2; n < len - 2; n += 2){
        cp = $cb75e0ee0c2958b9$var$getControlPoints(p[n - 2], p[n - 1], p[n], p[n + 1], p[n + 2], p[n + 3], tension);
        if (isNaN(cp[0])) continue;
        allPoints.push(cp[0]);
        allPoints.push(cp[1]);
        allPoints.push(p[n]);
        allPoints.push(p[n + 1]);
        allPoints.push(cp[2]);
        allPoints.push(cp[3]);
    }
    return allPoints;
}
class $cb75e0ee0c2958b9$var$Line extends $82UKb.Shape {
    constructor(config){
        super(config);
        this.on("pointsChange.konva tensionChange.konva closedChange.konva bezierChange.konva", function() {
            this._clearCache("tensionPoints");
        });
    }
    _sceneFunc(context) {
        var points = this.points(), length = points.length, tension = this.tension(), closed = this.closed(), bezier = this.bezier(), tp, len, n;
        if (!length) return;
        context.beginPath();
        context.moveTo(points[0], points[1]);
        if (tension !== 0 && length > 4) {
            tp = this.getTensionPoints();
            len = tp.length;
            n = closed ? 0 : 4;
            if (!closed) context.quadraticCurveTo(tp[0], tp[1], tp[2], tp[3]);
            while(n < len - 2)context.bezierCurveTo(tp[n++], tp[n++], tp[n++], tp[n++], tp[n++], tp[n++]);
            if (!closed) context.quadraticCurveTo(tp[len - 2], tp[len - 1], points[length - 2], points[length - 1]);
        } else if (bezier) {
            n = 2;
            while(n < length)context.bezierCurveTo(points[n++], points[n++], points[n++], points[n++], points[n++], points[n++]);
        } else for(n = 2; n < length; n += 2)context.lineTo(points[n], points[n + 1]);
        if (closed) {
            context.closePath();
            context.fillStrokeShape(this);
        } else context.strokeShape(this);
    }
    getTensionPoints() {
        return this._getCache("tensionPoints", this._getTensionPoints);
    }
    _getTensionPoints() {
        if (this.closed()) return this._getTensionPointsClosed();
        else return $cb75e0ee0c2958b9$var$expandPoints(this.points(), this.tension());
    }
    _getTensionPointsClosed() {
        var p = this.points(), len = p.length, tension = this.tension(), firstControlPoints = $cb75e0ee0c2958b9$var$getControlPoints(p[len - 2], p[len - 1], p[0], p[1], p[2], p[3], tension), lastControlPoints = $cb75e0ee0c2958b9$var$getControlPoints(p[len - 4], p[len - 3], p[len - 2], p[len - 1], p[0], p[1], tension), middle = $cb75e0ee0c2958b9$var$expandPoints(p, tension), tp = [
            firstControlPoints[2],
            firstControlPoints[3]
        ].concat(middle).concat([
            lastControlPoints[0],
            lastControlPoints[1],
            p[len - 2],
            p[len - 1],
            lastControlPoints[2],
            lastControlPoints[3],
            firstControlPoints[0],
            firstControlPoints[1],
            p[0],
            p[1]
        ]);
        return tp;
    }
    getWidth() {
        return this.getSelfRect().width;
    }
    getHeight() {
        return this.getSelfRect().height;
    }
    getSelfRect() {
        var points = this.points();
        if (points.length < 4) return {
            x: points[0] || 0,
            y: points[1] || 0,
            width: 0,
            height: 0
        };
        if (this.tension() !== 0) points = [
            points[0],
            points[1],
            ...this._getTensionPoints(),
            points[points.length - 2],
            points[points.length - 1]
        ];
        else points = this.points();
        var minX = points[0];
        var maxX = points[0];
        var minY = points[1];
        var maxY = points[1];
        var x, y;
        for(var i = 0; i < points.length / 2; i++){
            x = points[i * 2];
            y = points[i * 2 + 1];
            minX = Math.min(minX, x);
            maxX = Math.max(maxX, x);
            minY = Math.min(minY, y);
            maxY = Math.max(maxY, y);
        }
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
}
module.exports.Line = $cb75e0ee0c2958b9$var$Line;
$cb75e0ee0c2958b9$var$Line.prototype.className = "Line";
$cb75e0ee0c2958b9$var$Line.prototype._attrsAffectingSize = [
    "points",
    "bezier",
    "tension"
];
(0, $4v96z._registerNode)($cb75e0ee0c2958b9$var$Line);
$3V3su.Factory.addGetterSetter($cb75e0ee0c2958b9$var$Line, "closed", false);
$3V3su.Factory.addGetterSetter($cb75e0ee0c2958b9$var$Line, "bezier", false);
$3V3su.Factory.addGetterSetter($cb75e0ee0c2958b9$var$Line, "tension", 0, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($cb75e0ee0c2958b9$var$Line, "points", [], (0, $2TXYV.getNumberArrayValidator)());

});

parcelRegister("7s2S9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Path = void 0;

var $3V3su = parcelRequire("3V3su");

var $82UKb = parcelRequire("82UKb");

var $4v96z = parcelRequire("4v96z");

var $6lfci = parcelRequire("6lfci");
class $56cd605265cb3997$var$Path extends $82UKb.Shape {
    constructor(config){
        super(config);
        this.dataArray = [];
        this.pathLength = 0;
        this._readDataAttribute();
        this.on("dataChange.konva", function() {
            this._readDataAttribute();
        });
    }
    _readDataAttribute() {
        this.dataArray = $56cd605265cb3997$var$Path.parsePathData(this.data());
        this.pathLength = $56cd605265cb3997$var$Path.getPathLength(this.dataArray);
    }
    _sceneFunc(context) {
        var ca = this.dataArray;
        context.beginPath();
        var isClosed = false;
        for(var n = 0; n < ca.length; n++){
            var c = ca[n].command;
            var p = ca[n].points;
            switch(c){
                case "L":
                    context.lineTo(p[0], p[1]);
                    break;
                case "M":
                    context.moveTo(p[0], p[1]);
                    break;
                case "C":
                    context.bezierCurveTo(p[0], p[1], p[2], p[3], p[4], p[5]);
                    break;
                case "Q":
                    context.quadraticCurveTo(p[0], p[1], p[2], p[3]);
                    break;
                case "A":
                    var cx = p[0], cy = p[1], rx = p[2], ry = p[3], theta = p[4], dTheta = p[5], psi = p[6], fs = p[7];
                    var r = rx > ry ? rx : ry;
                    var scaleX = rx > ry ? 1 : rx / ry;
                    var scaleY = rx > ry ? ry / rx : 1;
                    context.translate(cx, cy);
                    context.rotate(psi);
                    context.scale(scaleX, scaleY);
                    context.arc(0, 0, r, theta, theta + dTheta, 1 - fs);
                    context.scale(1 / scaleX, 1 / scaleY);
                    context.rotate(-psi);
                    context.translate(-cx, -cy);
                    break;
                case "z":
                    isClosed = true;
                    context.closePath();
                    break;
            }
        }
        if (!isClosed && !this.hasFill()) context.strokeShape(this);
        else context.fillStrokeShape(this);
    }
    getSelfRect() {
        var points = [];
        this.dataArray.forEach(function(data) {
            if (data.command === "A") {
                var start = data.points[4];
                var dTheta = data.points[5];
                var end = data.points[4] + dTheta;
                var inc = Math.PI / 180.0;
                if (Math.abs(start - end) < inc) inc = Math.abs(start - end);
                if (dTheta < 0) for(let t = start - inc; t > end; t -= inc){
                    const point = $56cd605265cb3997$var$Path.getPointOnEllipticalArc(data.points[0], data.points[1], data.points[2], data.points[3], t, 0);
                    points.push(point.x, point.y);
                }
                else for(let t = start + inc; t < end; t += inc){
                    const point = $56cd605265cb3997$var$Path.getPointOnEllipticalArc(data.points[0], data.points[1], data.points[2], data.points[3], t, 0);
                    points.push(point.x, point.y);
                }
            } else if (data.command === "C") for(let t = 0.0; t <= 1; t += 0.01){
                const point = $56cd605265cb3997$var$Path.getPointOnCubicBezier(t, data.start.x, data.start.y, data.points[0], data.points[1], data.points[2], data.points[3], data.points[4], data.points[5]);
                points.push(point.x, point.y);
            }
            else points = points.concat(data.points);
        });
        var minX = points[0];
        var maxX = points[0];
        var minY = points[1];
        var maxY = points[1];
        var x, y;
        for(var i = 0; i < points.length / 2; i++){
            x = points[i * 2];
            y = points[i * 2 + 1];
            if (!isNaN(x)) {
                minX = Math.min(minX, x);
                maxX = Math.max(maxX, x);
            }
            if (!isNaN(y)) {
                minY = Math.min(minY, y);
                maxY = Math.max(maxY, y);
            }
        }
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    getLength() {
        return this.pathLength;
    }
    getPointAtLength(length) {
        return $56cd605265cb3997$var$Path.getPointAtLengthOfDataArray(length, this.dataArray);
    }
    static getLineLength(x1, y1, x2, y2) {
        return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    }
    static getPathLength(dataArray) {
        let pathLength = 0;
        for(var i = 0; i < dataArray.length; ++i)pathLength += dataArray[i].pathLength;
        return pathLength;
    }
    static getPointAtLengthOfDataArray(length, dataArray) {
        var point, i = 0, ii = dataArray.length;
        if (!ii) return null;
        while(i < ii && length > dataArray[i].pathLength){
            length -= dataArray[i].pathLength;
            ++i;
        }
        if (i === ii) {
            point = dataArray[i - 1].points.slice(-2);
            return {
                x: point[0],
                y: point[1]
            };
        }
        if (length < 0.01) {
            point = dataArray[i].points.slice(0, 2);
            return {
                x: point[0],
                y: point[1]
            };
        }
        var cp = dataArray[i];
        var p = cp.points;
        switch(cp.command){
            case "L":
                return $56cd605265cb3997$var$Path.getPointOnLine(length, cp.start.x, cp.start.y, p[0], p[1]);
            case "C":
                return $56cd605265cb3997$var$Path.getPointOnCubicBezier((0, $6lfci.t2length)(length, $56cd605265cb3997$var$Path.getPathLength(dataArray), (i)=>{
                    return (0, $6lfci.getCubicArcLength)([
                        cp.start.x,
                        p[0],
                        p[2],
                        p[4]
                    ], [
                        cp.start.y,
                        p[1],
                        p[3],
                        p[5]
                    ], i);
                }), cp.start.x, cp.start.y, p[0], p[1], p[2], p[3], p[4], p[5]);
            case "Q":
                return $56cd605265cb3997$var$Path.getPointOnQuadraticBezier((0, $6lfci.t2length)(length, $56cd605265cb3997$var$Path.getPathLength(dataArray), (i)=>{
                    return (0, $6lfci.getQuadraticArcLength)([
                        cp.start.x,
                        p[0],
                        p[2]
                    ], [
                        cp.start.y,
                        p[1],
                        p[3]
                    ], i);
                }), cp.start.x, cp.start.y, p[0], p[1], p[2], p[3]);
            case "A":
                var cx = p[0], cy = p[1], rx = p[2], ry = p[3], theta = p[4], dTheta = p[5], psi = p[6];
                theta += dTheta * length / cp.pathLength;
                return $56cd605265cb3997$var$Path.getPointOnEllipticalArc(cx, cy, rx, ry, theta, psi);
        }
        return null;
    }
    static getPointOnLine(dist, P1x, P1y, P2x, P2y, fromX, fromY) {
        if (fromX === undefined) fromX = P1x;
        if (fromY === undefined) fromY = P1y;
        var m = (P2y - P1y) / (P2x - P1x + 0.00000001);
        var run = Math.sqrt(dist * dist / (1 + m * m));
        if (P2x < P1x) run *= -1;
        var rise = m * run;
        var pt;
        if (P2x === P1x) pt = {
            x: fromX,
            y: fromY + rise
        };
        else if ((fromY - P1y) / (fromX - P1x + 0.00000001) === m) pt = {
            x: fromX + run,
            y: fromY + rise
        };
        else {
            var ix, iy;
            var len = this.getLineLength(P1x, P1y, P2x, P2y);
            var u = (fromX - P1x) * (P2x - P1x) + (fromY - P1y) * (P2y - P1y);
            u = u / (len * len);
            ix = P1x + u * (P2x - P1x);
            iy = P1y + u * (P2y - P1y);
            var pRise = this.getLineLength(fromX, fromY, ix, iy);
            var pRun = Math.sqrt(dist * dist - pRise * pRise);
            run = Math.sqrt(pRun * pRun / (1 + m * m));
            if (P2x < P1x) run *= -1;
            rise = m * run;
            pt = {
                x: ix + run,
                y: iy + rise
            };
        }
        return pt;
    }
    static getPointOnCubicBezier(pct, P1x, P1y, P2x, P2y, P3x, P3y, P4x, P4y) {
        function CB1(t) {
            return t * t * t;
        }
        function CB2(t) {
            return 3 * t * t * (1 - t);
        }
        function CB3(t) {
            return 3 * t * (1 - t) * (1 - t);
        }
        function CB4(t) {
            return (1 - t) * (1 - t) * (1 - t);
        }
        var x = P4x * CB1(pct) + P3x * CB2(pct) + P2x * CB3(pct) + P1x * CB4(pct);
        var y = P4y * CB1(pct) + P3y * CB2(pct) + P2y * CB3(pct) + P1y * CB4(pct);
        return {
            x: x,
            y: y
        };
    }
    static getPointOnQuadraticBezier(pct, P1x, P1y, P2x, P2y, P3x, P3y) {
        function QB1(t) {
            return t * t;
        }
        function QB2(t) {
            return 2 * t * (1 - t);
        }
        function QB3(t) {
            return (1 - t) * (1 - t);
        }
        var x = P3x * QB1(pct) + P2x * QB2(pct) + P1x * QB3(pct);
        var y = P3y * QB1(pct) + P2y * QB2(pct) + P1y * QB3(pct);
        return {
            x: x,
            y: y
        };
    }
    static getPointOnEllipticalArc(cx, cy, rx, ry, theta, psi) {
        var cosPsi = Math.cos(psi), sinPsi = Math.sin(psi);
        var pt = {
            x: rx * Math.cos(theta),
            y: ry * Math.sin(theta)
        };
        return {
            x: cx + (pt.x * cosPsi - pt.y * sinPsi),
            y: cy + (pt.x * sinPsi + pt.y * cosPsi)
        };
    }
    static parsePathData(data) {
        if (!data) return [];
        var cs = data;
        var cc = [
            "m",
            "M",
            "l",
            "L",
            "v",
            "V",
            "h",
            "H",
            "z",
            "Z",
            "c",
            "C",
            "q",
            "Q",
            "t",
            "T",
            "s",
            "S",
            "a",
            "A"
        ];
        cs = cs.replace(new RegExp(" ", "g"), ",");
        for(var n = 0; n < cc.length; n++)cs = cs.replace(new RegExp(cc[n], "g"), "|" + cc[n]);
        var arr = cs.split("|");
        var ca = [];
        var coords = [];
        var cpx = 0;
        var cpy = 0;
        var re = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:e[-+]?\d+)?)/gi;
        var match;
        for(n = 1; n < arr.length; n++){
            var str = arr[n];
            var c = str.charAt(0);
            str = str.slice(1);
            coords.length = 0;
            while(match = re.exec(str))coords.push(match[0]);
            var p = [];
            for(var j = 0, jlen = coords.length; j < jlen; j++){
                if (coords[j] === "00") {
                    p.push(0, 0);
                    continue;
                }
                var parsed = parseFloat(coords[j]);
                if (!isNaN(parsed)) p.push(parsed);
                else p.push(0);
            }
            while(p.length > 0){
                if (isNaN(p[0])) break;
                var cmd = "";
                var points = [];
                var startX = cpx, startY = cpy;
                var prevCmd, ctlPtx, ctlPty;
                var rx, ry, psi, fa, fs, x1, y1;
                switch(c){
                    case "l":
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = "L";
                        points.push(cpx, cpy);
                        break;
                    case "L":
                        cpx = p.shift();
                        cpy = p.shift();
                        points.push(cpx, cpy);
                        break;
                    case "m":
                        var dx = p.shift();
                        var dy = p.shift();
                        cpx += dx;
                        cpy += dy;
                        cmd = "M";
                        if (ca.length > 2 && ca[ca.length - 1].command === "z") {
                            for(var idx = ca.length - 2; idx >= 0; idx--)if (ca[idx].command === "M") {
                                cpx = ca[idx].points[0] + dx;
                                cpy = ca[idx].points[1] + dy;
                                break;
                            }
                        }
                        points.push(cpx, cpy);
                        c = "l";
                        break;
                    case "M":
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = "M";
                        points.push(cpx, cpy);
                        c = "L";
                        break;
                    case "h":
                        cpx += p.shift();
                        cmd = "L";
                        points.push(cpx, cpy);
                        break;
                    case "H":
                        cpx = p.shift();
                        cmd = "L";
                        points.push(cpx, cpy);
                        break;
                    case "v":
                        cpy += p.shift();
                        cmd = "L";
                        points.push(cpx, cpy);
                        break;
                    case "V":
                        cpy = p.shift();
                        cmd = "L";
                        points.push(cpx, cpy);
                        break;
                    case "C":
                        points.push(p.shift(), p.shift(), p.shift(), p.shift());
                        cpx = p.shift();
                        cpy = p.shift();
                        points.push(cpx, cpy);
                        break;
                    case "c":
                        points.push(cpx + p.shift(), cpy + p.shift(), cpx + p.shift(), cpy + p.shift());
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = "C";
                        points.push(cpx, cpy);
                        break;
                    case "S":
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === "C") {
                            ctlPtx = cpx + (cpx - prevCmd.points[2]);
                            ctlPty = cpy + (cpy - prevCmd.points[3]);
                        }
                        points.push(ctlPtx, ctlPty, p.shift(), p.shift());
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = "C";
                        points.push(cpx, cpy);
                        break;
                    case "s":
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === "C") {
                            ctlPtx = cpx + (cpx - prevCmd.points[2]);
                            ctlPty = cpy + (cpy - prevCmd.points[3]);
                        }
                        points.push(ctlPtx, ctlPty, cpx + p.shift(), cpy + p.shift());
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = "C";
                        points.push(cpx, cpy);
                        break;
                    case "Q":
                        points.push(p.shift(), p.shift());
                        cpx = p.shift();
                        cpy = p.shift();
                        points.push(cpx, cpy);
                        break;
                    case "q":
                        points.push(cpx + p.shift(), cpy + p.shift());
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = "Q";
                        points.push(cpx, cpy);
                        break;
                    case "T":
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === "Q") {
                            ctlPtx = cpx + (cpx - prevCmd.points[0]);
                            ctlPty = cpy + (cpy - prevCmd.points[1]);
                        }
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = "Q";
                        points.push(ctlPtx, ctlPty, cpx, cpy);
                        break;
                    case "t":
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === "Q") {
                            ctlPtx = cpx + (cpx - prevCmd.points[0]);
                            ctlPty = cpy + (cpy - prevCmd.points[1]);
                        }
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = "Q";
                        points.push(ctlPtx, ctlPty, cpx, cpy);
                        break;
                    case "A":
                        rx = p.shift();
                        ry = p.shift();
                        psi = p.shift();
                        fa = p.shift();
                        fs = p.shift();
                        x1 = cpx;
                        y1 = cpy;
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = "A";
                        points = this.convertEndpointToCenterParameterization(x1, y1, cpx, cpy, fa, fs, rx, ry, psi);
                        break;
                    case "a":
                        rx = p.shift();
                        ry = p.shift();
                        psi = p.shift();
                        fa = p.shift();
                        fs = p.shift();
                        x1 = cpx;
                        y1 = cpy;
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = "A";
                        points = this.convertEndpointToCenterParameterization(x1, y1, cpx, cpy, fa, fs, rx, ry, psi);
                        break;
                }
                ca.push({
                    command: cmd || c,
                    points: points,
                    start: {
                        x: startX,
                        y: startY
                    },
                    pathLength: this.calcLength(startX, startY, cmd || c, points)
                });
            }
            if (c === "z" || c === "Z") ca.push({
                command: "z",
                points: [],
                start: undefined,
                pathLength: 0
            });
        }
        return ca;
    }
    static calcLength(x, y, cmd, points) {
        var len, p1, p2, t;
        var path = $56cd605265cb3997$var$Path;
        switch(cmd){
            case "L":
                return path.getLineLength(x, y, points[0], points[1]);
            case "C":
                return (0, $6lfci.getCubicArcLength)([
                    x,
                    points[0],
                    points[2],
                    points[4]
                ], [
                    y,
                    points[1],
                    points[3],
                    points[5]
                ], 1);
            case "Q":
                return (0, $6lfci.getQuadraticArcLength)([
                    x,
                    points[0],
                    points[2]
                ], [
                    y,
                    points[1],
                    points[3]
                ], 1);
            case "A":
                len = 0.0;
                var start = points[4];
                var dTheta = points[5];
                var end = points[4] + dTheta;
                var inc = Math.PI / 180.0;
                if (Math.abs(start - end) < inc) inc = Math.abs(start - end);
                p1 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], start, 0);
                if (dTheta < 0) for(t = start - inc; t > end; t -= inc){
                    p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t, 0);
                    len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                    p1 = p2;
                }
                else for(t = start + inc; t < end; t += inc){
                    p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t, 0);
                    len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                    p1 = p2;
                }
                p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], end, 0);
                len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                return len;
        }
        return 0;
    }
    static convertEndpointToCenterParameterization(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg) {
        var psi = psiDeg * (Math.PI / 180.0);
        var xp = Math.cos(psi) * (x1 - x2) / 2.0 + Math.sin(psi) * (y1 - y2) / 2.0;
        var yp = -1 * Math.sin(psi) * (x1 - x2) / 2.0 + Math.cos(psi) * (y1 - y2) / 2.0;
        var lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);
        if (lambda > 1) {
            rx *= Math.sqrt(lambda);
            ry *= Math.sqrt(lambda);
        }
        var f = Math.sqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp)));
        if (fa === fs) f *= -1;
        if (isNaN(f)) f = 0;
        var cxp = f * rx * yp / ry;
        var cyp = f * -ry * xp / rx;
        var cx = (x1 + x2) / 2.0 + Math.cos(psi) * cxp - Math.sin(psi) * cyp;
        var cy = (y1 + y2) / 2.0 + Math.sin(psi) * cxp + Math.cos(psi) * cyp;
        var vMag = function(v) {
            return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
        };
        var vRatio = function(u, v) {
            return (u[0] * v[0] + u[1] * v[1]) / (vMag(u) * vMag(v));
        };
        var vAngle = function(u, v) {
            return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos(vRatio(u, v));
        };
        var theta = vAngle([
            1,
            0
        ], [
            (xp - cxp) / rx,
            (yp - cyp) / ry
        ]);
        var u = [
            (xp - cxp) / rx,
            (yp - cyp) / ry
        ];
        var v = [
            (-1 * xp - cxp) / rx,
            (-1 * yp - cyp) / ry
        ];
        var dTheta = vAngle(u, v);
        if (vRatio(u, v) <= -1) dTheta = Math.PI;
        if (vRatio(u, v) >= 1) dTheta = 0;
        if (fs === 0 && dTheta > 0) dTheta = dTheta - 2 * Math.PI;
        if (fs === 1 && dTheta < 0) dTheta = dTheta + 2 * Math.PI;
        return [
            cx,
            cy,
            rx,
            ry,
            theta,
            dTheta,
            psi,
            fs
        ];
    }
}
module.exports.Path = $56cd605265cb3997$var$Path;
$56cd605265cb3997$var$Path.prototype.className = "Path";
$56cd605265cb3997$var$Path.prototype._attrsAffectingSize = [
    "data"
];
(0, $4v96z._registerNode)($56cd605265cb3997$var$Path);
$3V3su.Factory.addGetterSetter($56cd605265cb3997$var$Path, "data");

});
parcelRegister("6lfci", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.t2length = module.exports.getQuadraticArcLength = module.exports.getCubicArcLength = module.exports.binomialCoefficients = module.exports.cValues = module.exports.tValues = void 0;
module.exports.tValues = [
    [],
    [],
    [
        -0.5773502691896257,
        0.5773502691896257645091487805019574556476
    ],
    [
        0,
        -0.7745966692414834,
        0.7745966692414833770358530799564799221665
    ],
    [
        -0.33998104358485626,
        0.3399810435848562648026657591032446872005,
        -0.8611363115940526,
        0.8611363115940525752239464888928095050957
    ],
    [
        0,
        -0.5384693101056831,
        0.5384693101056830910363144207002088049672,
        -0.906179845938664,
        0.9061798459386639927976268782993929651256
    ],
    [
        0.6612093864662645136613995950199053470064,
        -0.6612093864662645,
        -0.2386191860831969,
        0.2386191860831969086305017216807119354186,
        -0.932469514203152,
        0.9324695142031520278123015544939946091347
    ],
    [
        0,
        0.4058451513773971669066064120769614633473,
        -0.4058451513773972,
        -0.7415311855993945,
        0.7415311855993944398638647732807884070741,
        -0.9491079123427585,
        0.9491079123427585245261896840478512624007
    ],
    [
        -0.1834346424956498,
        0.1834346424956498049394761423601839806667,
        -0.525532409916329,
        0.5255324099163289858177390491892463490419,
        -0.7966664774136267,
        0.7966664774136267395915539364758304368371,
        -0.9602898564975363,
        0.9602898564975362316835608685694729904282
    ],
    [
        0,
        -0.8360311073266358,
        0.8360311073266357942994297880697348765441,
        -0.9681602395076261,
        0.9681602395076260898355762029036728700494,
        -0.3242534234038089,
        0.3242534234038089290385380146433366085719,
        -0.6133714327005904,
        0.6133714327005903973087020393414741847857
    ],
    [
        -0.14887433898163122,
        0.1488743389816312108848260011297199846175,
        -0.4333953941292472,
        0.4333953941292471907992659431657841622,
        -0.6794095682990244,
        0.6794095682990244062343273651148735757692,
        -0.8650633666889845,
        0.8650633666889845107320966884234930485275,
        -0.9739065285171717,
        0.9739065285171717200779640120844520534282
    ],
    [
        0,
        -0.26954315595234496,
        0.2695431559523449723315319854008615246796,
        -0.5190961292068118,
        0.5190961292068118159257256694586095544802,
        -0.7301520055740494,
        0.7301520055740493240934162520311534580496,
        -0.8870625997680953,
        0.8870625997680952990751577693039272666316,
        -0.978228658146057,
        0.9782286581460569928039380011228573907714
    ],
    [
        -0.1252334085114689,
        0.1252334085114689154724413694638531299833,
        -0.3678314989981802,
        0.3678314989981801937526915366437175612563,
        -0.5873179542866175,
        0.587317954286617447296702418940534280369,
        -0.7699026741943047,
        0.7699026741943046870368938332128180759849,
        -0.9041172563704749,
        0.9041172563704748566784658661190961925375,
        -0.9815606342467192,
        0.9815606342467192506905490901492808229601
    ],
    [
        0,
        -0.2304583159551348,
        0.2304583159551347940655281210979888352115,
        -0.44849275103644687,
        0.4484927510364468528779128521276398678019,
        -0.6423493394403402,
        0.6423493394403402206439846069955156500716,
        -0.8015780907333099,
        0.8015780907333099127942064895828598903056,
        -0.9175983992229779,
        0.9175983992229779652065478365007195123904,
        -0.9841830547185881,
        0.9841830547185881494728294488071096110649
    ],
    [
        -0.10805494870734367,
        0.1080549487073436620662446502198347476119,
        -0.31911236892788974,
        0.3191123689278897604356718241684754668342,
        -0.5152486363581541,
        0.5152486363581540919652907185511886623088,
        -0.6872929048116855,
        0.6872929048116854701480198030193341375384,
        -0.827201315069765,
        0.8272013150697649931897947426503949610397,
        -0.9284348836635735,
        0.928434883663573517336391139377874264477,
        -0.9862838086968123,
        0.986283808696812338841597266704052801676
    ],
    [
        0,
        -0.20119409399743451,
        0.2011940939974345223006283033945962078128,
        -0.3941513470775634,
        0.3941513470775633698972073709810454683627,
        -0.5709721726085388,
        0.5709721726085388475372267372539106412383,
        -0.7244177313601701,
        0.7244177313601700474161860546139380096308,
        -0.8482065834104272,
        0.8482065834104272162006483207742168513662,
        -0.937273392400706,
        0.9372733924007059043077589477102094712439,
        -0.9879925180204854,
        0.9879925180204854284895657185866125811469
    ],
    [
        -0.09501250983763744,
        0.0950125098376374401853193354249580631303,
        -0.2816035507792589,
        0.281603550779258913230460501460496106486,
        -0.45801677765722737,
        0.45801677765722738634241944298357757354,
        -0.6178762444026438,
        0.6178762444026437484466717640487910189918,
        -0.755404408355003,
        0.7554044083550030338951011948474422683538,
        -0.8656312023878318,
        0.8656312023878317438804678977123931323873,
        -0.9445750230732326,
        0.9445750230732325760779884155346083450911,
        -0.9894009349916499,
        0.9894009349916499325961541734503326274262
    ],
    [
        0,
        -0.17848418149584785,
        0.1784841814958478558506774936540655574754,
        -0.3512317634538763,
        0.3512317634538763152971855170953460050405,
        -0.5126905370864769,
        0.5126905370864769678862465686295518745829,
        -0.6576711592166907,
        0.6576711592166907658503022166430023351478,
        -0.7815140038968014,
        0.7815140038968014069252300555204760502239,
        -0.8802391537269859,
        0.8802391537269859021229556944881556926234,
        -0.9506755217687678,
        0.9506755217687677612227169578958030214433,
        -0.9905754753144174,
        0.9905754753144173356754340199406652765077
    ],
    [
        -0.0847750130417353,
        0.0847750130417353012422618529357838117333,
        -0.2518862256915055,
        0.2518862256915055095889728548779112301628,
        -0.41175116146284263,
        0.4117511614628426460359317938330516370789,
        -0.5597708310739475,
        0.5597708310739475346078715485253291369276,
        -0.6916870430603532,
        0.6916870430603532078748910812888483894522,
        -0.8037049589725231,
        0.8037049589725231156824174550145907971032,
        -0.8926024664975557,
        0.8926024664975557392060605911271455154078,
        -0.9558239495713977,
        0.9558239495713977551811958929297763099728,
        -0.9915651684209309,
        0.9915651684209309467300160047061507702525
    ],
    [
        0,
        -0.16035864564022537,
        0.1603586456402253758680961157407435495048,
        -0.31656409996362983,
        0.3165640999636298319901173288498449178922,
        -0.46457074137596094,
        0.4645707413759609457172671481041023679762,
        -0.600545304661681,
        0.6005453046616810234696381649462392798683,
        -0.7209661773352294,
        0.7209661773352293786170958608237816296571,
        -0.8227146565371428,
        0.8227146565371428249789224867127139017745,
        -0.9031559036148179,
        0.9031559036148179016426609285323124878093,
        -0.96020815213483,
        0.960208152134830030852778840687651526615,
        -0.9924068438435844,
        0.9924068438435844031890176702532604935893
    ],
    [
        -0.07652652113349734,
        0.0765265211334973337546404093988382110047,
        -0.22778585114164507,
        0.227785851141645078080496195368574624743,
        -0.37370608871541955,
        0.3737060887154195606725481770249272373957,
        -0.5108670019508271,
        0.5108670019508270980043640509552509984254,
        -0.636053680726515,
        0.6360536807265150254528366962262859367433,
        -0.7463319064601508,
        0.7463319064601507926143050703556415903107,
        -0.8391169718222188,
        0.8391169718222188233945290617015206853296,
        -0.912234428251326,
        0.9122344282513259058677524412032981130491,
        -0.9639719272779138,
        0.963971927277913791267666131197277221912,
        -0.9931285991850949,
        0.9931285991850949247861223884713202782226
    ],
    [
        0,
        -0.1455618541608951,
        0.1455618541608950909370309823386863301163,
        -0.2880213168024011,
        0.288021316802401096600792516064600319909,
        -0.4243421202074388,
        0.4243421202074387835736688885437880520964,
        -0.5516188358872198,
        0.551618835887219807059018796724313286622,
        -0.6671388041974123,
        0.667138804197412319305966669990339162597,
        -0.7684399634756779,
        0.7684399634756779086158778513062280348209,
        -0.8533633645833173,
        0.8533633645833172836472506385875676702761,
        -0.9200993341504008,
        0.9200993341504008287901871337149688941591,
        -0.9672268385663063,
        0.9672268385663062943166222149076951614246,
        -0.9937521706203895,
        0.9937521706203895002602420359379409291933
    ],
    [
        -0.06973927331972223,
        0.0697392733197222212138417961186280818222,
        -0.20786042668822127,
        0.2078604266882212854788465339195457342156,
        -0.34193582089208424,
        0.3419358208920842251581474204273796195591,
        -0.469355837986757,
        0.4693558379867570264063307109664063460953,
        -0.5876404035069116,
        0.5876404035069115929588769276386473488776,
        -0.6944872631866827,
        0.6944872631866827800506898357622567712673,
        -0.7878168059792081,
        0.7878168059792081620042779554083515213881,
        -0.8658125777203002,
        0.8658125777203001365364256370193787290847,
        -0.926956772187174,
        0.9269567721871740005206929392590531966353,
        -0.9700604978354287,
        0.9700604978354287271239509867652687108059,
        -0.9942945854823992,
        0.994294585482399292073031421161298980393
    ],
    [
        0,
        -0.1332568242984661,
        0.1332568242984661109317426822417661370104,
        -0.26413568097034495,
        0.264135680970344930533869538283309602979,
        -0.3903010380302908,
        0.390301038030290831421488872880605458578,
        -0.5095014778460075,
        0.5095014778460075496897930478668464305448,
        -0.6196098757636461,
        0.6196098757636461563850973116495956533871,
        -0.7186613631319502,
        0.7186613631319501944616244837486188483299,
        -0.8048884016188399,
        0.8048884016188398921511184069967785579414,
        -0.8767523582704416,
        0.8767523582704416673781568859341456716389,
        -0.9329710868260161,
        0.9329710868260161023491969890384229782357,
        -0.9725424712181152,
        0.9725424712181152319560240768207773751816,
        -0.9947693349975522,
        0.9947693349975521235239257154455743605736
    ],
    [
        -0.06405689286260563,
        0.0640568928626056260850430826247450385909,
        -0.1911188674736163,
        0.1911188674736163091586398207570696318404,
        -0.3150426796961634,
        0.3150426796961633743867932913198102407864,
        -0.4337935076260451,
        0.4337935076260451384870842319133497124524,
        -0.5454214713888396,
        0.5454214713888395356583756172183723700107,
        -0.6480936519369755,
        0.6480936519369755692524957869107476266696,
        -0.7401241915785544,
        0.7401241915785543642438281030999784255232,
        -0.820001985973903,
        0.8200019859739029219539498726697452080761,
        -0.8864155270044011,
        0.8864155270044010342131543419821967550873,
        -0.9382745520027328,
        0.9382745520027327585236490017087214496548,
        -0.9747285559713095,
        0.9747285559713094981983919930081690617411,
        -0.9951872199970213,
        0.9951872199970213601799974097007368118745
    ]
];
module.exports.cValues = [
    [],
    [],
    [
        1.0,
        1.0
    ],
    [
        0.8888888888888888888888888888888888888888,
        0.5555555555555555555555555555555555555555,
        0.5555555555555555555555555555555555555555
    ],
    [
        0.6521451548625461426269360507780005927646,
        0.6521451548625461426269360507780005927646,
        0.3478548451374538573730639492219994072353,
        0.3478548451374538573730639492219994072353
    ],
    [
        0.5688888888888888888888888888888888888888,
        0.4786286704993664680412915148356381929122,
        0.4786286704993664680412915148356381929122,
        0.2369268850561890875142640407199173626432,
        0.2369268850561890875142640407199173626432
    ],
    [
        0.3607615730481386075698335138377161116615,
        0.3607615730481386075698335138377161116615,
        0.4679139345726910473898703439895509948116,
        0.4679139345726910473898703439895509948116,
        0.1713244923791703450402961421727328935268,
        0.1713244923791703450402961421727328935268
    ],
    [
        0.4179591836734693877551020408163265306122,
        0.3818300505051189449503697754889751338783,
        0.3818300505051189449503697754889751338783,
        0.2797053914892766679014677714237795824869,
        0.2797053914892766679014677714237795824869,
        0.1294849661688696932706114326790820183285,
        0.1294849661688696932706114326790820183285
    ],
    [
        0.3626837833783619829651504492771956121941,
        0.3626837833783619829651504492771956121941,
        0.3137066458778872873379622019866013132603,
        0.3137066458778872873379622019866013132603,
        0.2223810344533744705443559944262408844301,
        0.2223810344533744705443559944262408844301,
        0.1012285362903762591525313543099621901153,
        0.1012285362903762591525313543099621901153
    ],
    [
        0.3302393550012597631645250692869740488788,
        0.1806481606948574040584720312429128095143,
        0.1806481606948574040584720312429128095143,
        0.0812743883615744119718921581105236506756,
        0.0812743883615744119718921581105236506756,
        0.3123470770400028400686304065844436655987,
        0.3123470770400028400686304065844436655987,
        0.2606106964029354623187428694186328497718,
        0.2606106964029354623187428694186328497718
    ],
    [
        0.295524224714752870173892994651338329421,
        0.295524224714752870173892994651338329421,
        0.2692667193099963550912269215694693528597,
        0.2692667193099963550912269215694693528597,
        0.2190863625159820439955349342281631924587,
        0.2190863625159820439955349342281631924587,
        0.1494513491505805931457763396576973324025,
        0.1494513491505805931457763396576973324025,
        0.0666713443086881375935688098933317928578,
        0.0666713443086881375935688098933317928578
    ],
    [
        0.272925086777900630714483528336342189156,
        0.2628045445102466621806888698905091953727,
        0.2628045445102466621806888698905091953727,
        0.2331937645919904799185237048431751394317,
        0.2331937645919904799185237048431751394317,
        0.1862902109277342514260976414316558916912,
        0.1862902109277342514260976414316558916912,
        0.1255803694649046246346942992239401001976,
        0.1255803694649046246346942992239401001976,
        0.0556685671161736664827537204425485787285,
        0.0556685671161736664827537204425485787285
    ],
    [
        0.2491470458134027850005624360429512108304,
        0.2491470458134027850005624360429512108304,
        0.2334925365383548087608498989248780562594,
        0.2334925365383548087608498989248780562594,
        0.2031674267230659217490644558097983765065,
        0.2031674267230659217490644558097983765065,
        0.160078328543346226334652529543359071872,
        0.160078328543346226334652529543359071872,
        0.1069393259953184309602547181939962242145,
        0.1069393259953184309602547181939962242145,
        0.047175336386511827194615961485017060317,
        0.047175336386511827194615961485017060317
    ],
    [
        0.2325515532308739101945895152688359481566,
        0.2262831802628972384120901860397766184347,
        0.2262831802628972384120901860397766184347,
        0.2078160475368885023125232193060527633865,
        0.2078160475368885023125232193060527633865,
        0.1781459807619457382800466919960979955128,
        0.1781459807619457382800466919960979955128,
        0.1388735102197872384636017768688714676218,
        0.1388735102197872384636017768688714676218,
        0.0921214998377284479144217759537971209236,
        0.0921214998377284479144217759537971209236,
        0.0404840047653158795200215922009860600419,
        0.0404840047653158795200215922009860600419
    ],
    [
        0.2152638534631577901958764433162600352749,
        0.2152638534631577901958764433162600352749,
        0.2051984637212956039659240656612180557103,
        0.2051984637212956039659240656612180557103,
        0.1855383974779378137417165901251570362489,
        0.1855383974779378137417165901251570362489,
        0.1572031671581935345696019386238421566056,
        0.1572031671581935345696019386238421566056,
        0.1215185706879031846894148090724766259566,
        0.1215185706879031846894148090724766259566,
        0.0801580871597602098056332770628543095836,
        0.0801580871597602098056332770628543095836,
        0.0351194603317518630318328761381917806197,
        0.0351194603317518630318328761381917806197
    ],
    [
        0.2025782419255612728806201999675193148386,
        0.1984314853271115764561183264438393248186,
        0.1984314853271115764561183264438393248186,
        0.1861610000155622110268005618664228245062,
        0.1861610000155622110268005618664228245062,
        0.1662692058169939335532008604812088111309,
        0.1662692058169939335532008604812088111309,
        0.1395706779261543144478047945110283225208,
        0.1395706779261543144478047945110283225208,
        0.1071592204671719350118695466858693034155,
        0.1071592204671719350118695466858693034155,
        0.0703660474881081247092674164506673384667,
        0.0703660474881081247092674164506673384667,
        0.0307532419961172683546283935772044177217,
        0.0307532419961172683546283935772044177217
    ],
    [
        0.1894506104550684962853967232082831051469,
        0.1894506104550684962853967232082831051469,
        0.1826034150449235888667636679692199393835,
        0.1826034150449235888667636679692199393835,
        0.1691565193950025381893120790303599622116,
        0.1691565193950025381893120790303599622116,
        0.1495959888165767320815017305474785489704,
        0.1495959888165767320815017305474785489704,
        0.1246289712555338720524762821920164201448,
        0.1246289712555338720524762821920164201448,
        0.0951585116824927848099251076022462263552,
        0.0951585116824927848099251076022462263552,
        0.0622535239386478928628438369943776942749,
        0.0622535239386478928628438369943776942749,
        0.0271524594117540948517805724560181035122,
        0.0271524594117540948517805724560181035122
    ],
    [
        0.1794464703562065254582656442618856214487,
        0.1765627053669926463252709901131972391509,
        0.1765627053669926463252709901131972391509,
        0.1680041021564500445099706637883231550211,
        0.1680041021564500445099706637883231550211,
        0.1540457610768102880814315948019586119404,
        0.1540457610768102880814315948019586119404,
        0.1351363684685254732863199817023501973721,
        0.1351363684685254732863199817023501973721,
        0.1118838471934039710947883856263559267358,
        0.1118838471934039710947883856263559267358,
        0.0850361483171791808835353701910620738504,
        0.0850361483171791808835353701910620738504,
        0.0554595293739872011294401653582446605128,
        0.0554595293739872011294401653582446605128,
        0.0241483028685479319601100262875653246916,
        0.0241483028685479319601100262875653246916
    ],
    [
        0.1691423829631435918406564701349866103341,
        0.1691423829631435918406564701349866103341,
        0.1642764837458327229860537764659275904123,
        0.1642764837458327229860537764659275904123,
        0.1546846751262652449254180038363747721932,
        0.1546846751262652449254180038363747721932,
        0.1406429146706506512047313037519472280955,
        0.1406429146706506512047313037519472280955,
        0.1225552067114784601845191268002015552281,
        0.1225552067114784601845191268002015552281,
        0.1009420441062871655628139849248346070628,
        0.1009420441062871655628139849248346070628,
        0.0764257302548890565291296776166365256053,
        0.0764257302548890565291296776166365256053,
        0.0497145488949697964533349462026386416808,
        0.0497145488949697964533349462026386416808,
        0.0216160135264833103133427102664524693876,
        0.0216160135264833103133427102664524693876
    ],
    [
        0.1610544498487836959791636253209167350399,
        0.1589688433939543476499564394650472016787,
        0.1589688433939543476499564394650472016787,
        0.152766042065859666778855400897662998461,
        0.152766042065859666778855400897662998461,
        0.1426067021736066117757461094419029724756,
        0.1426067021736066117757461094419029724756,
        0.1287539625393362276755157848568771170558,
        0.1287539625393362276755157848568771170558,
        0.1115666455473339947160239016817659974813,
        0.1115666455473339947160239016817659974813,
        0.0914900216224499994644620941238396526609,
        0.0914900216224499994644620941238396526609,
        0.0690445427376412265807082580060130449618,
        0.0690445427376412265807082580060130449618,
        0.0448142267656996003328381574019942119517,
        0.0448142267656996003328381574019942119517,
        0.0194617882297264770363120414644384357529,
        0.0194617882297264770363120414644384357529
    ],
    [
        0.1527533871307258506980843319550975934919,
        0.1527533871307258506980843319550975934919,
        0.1491729864726037467878287370019694366926,
        0.1491729864726037467878287370019694366926,
        0.1420961093183820513292983250671649330345,
        0.1420961093183820513292983250671649330345,
        0.1316886384491766268984944997481631349161,
        0.1316886384491766268984944997481631349161,
        0.118194531961518417312377377711382287005,
        0.118194531961518417312377377711382287005,
        0.1019301198172404350367501354803498761666,
        0.1019301198172404350367501354803498761666,
        0.0832767415767047487247581432220462061001,
        0.0832767415767047487247581432220462061001,
        0.0626720483341090635695065351870416063516,
        0.0626720483341090635695065351870416063516,
        0.040601429800386941331039952274932109879,
        0.040601429800386941331039952274932109879,
        0.0176140071391521183118619623518528163621,
        0.0176140071391521183118619623518528163621
    ],
    [
        0.1460811336496904271919851476833711882448,
        0.1445244039899700590638271665537525436099,
        0.1445244039899700590638271665537525436099,
        0.1398873947910731547221334238675831108927,
        0.1398873947910731547221334238675831108927,
        0.132268938633337461781052574496775604329,
        0.132268938633337461781052574496775604329,
        0.1218314160537285341953671771257335983563,
        0.1218314160537285341953671771257335983563,
        0.1087972991671483776634745780701056420336,
        0.1087972991671483776634745780701056420336,
        0.0934444234560338615532897411139320884835,
        0.0934444234560338615532897411139320884835,
        0.0761001136283793020170516533001831792261,
        0.0761001136283793020170516533001831792261,
        0.0571344254268572082836358264724479574912,
        0.0571344254268572082836358264724479574912,
        0.0369537897708524937999506682993296661889,
        0.0369537897708524937999506682993296661889,
        0.0160172282577743333242246168584710152658,
        0.0160172282577743333242246168584710152658
    ],
    [
        0.1392518728556319933754102483418099578739,
        0.1392518728556319933754102483418099578739,
        0.1365414983460151713525738312315173965863,
        0.1365414983460151713525738312315173965863,
        0.1311735047870623707329649925303074458757,
        0.1311735047870623707329649925303074458757,
        0.1232523768105124242855609861548144719594,
        0.1232523768105124242855609861548144719594,
        0.1129322960805392183934006074217843191142,
        0.1129322960805392183934006074217843191142,
        0.1004141444428809649320788378305362823508,
        0.1004141444428809649320788378305362823508,
        0.0859416062170677274144436813727028661891,
        0.0859416062170677274144436813727028661891,
        0.0697964684245204880949614189302176573987,
        0.0697964684245204880949614189302176573987,
        0.0522933351526832859403120512732112561121,
        0.0522933351526832859403120512732112561121,
        0.0337749015848141547933022468659129013491,
        0.0337749015848141547933022468659129013491,
        0.0146279952982722006849910980471854451902,
        0.0146279952982722006849910980471854451902
    ],
    [
        0.1336545721861061753514571105458443385831,
        0.132462039404696617371642464703316925805,
        0.132462039404696617371642464703316925805,
        0.1289057221880821499785953393997936532597,
        0.1289057221880821499785953393997936532597,
        0.1230490843067295304675784006720096548158,
        0.1230490843067295304675784006720096548158,
        0.1149966402224113649416435129339613014914,
        0.1149966402224113649416435129339613014914,
        0.1048920914645414100740861850147438548584,
        0.1048920914645414100740861850147438548584,
        0.0929157660600351474770186173697646486034,
        0.0929157660600351474770186173697646486034,
        0.0792814117767189549228925247420432269137,
        0.0792814117767189549228925247420432269137,
        0.0642324214085258521271696151589109980391,
        0.0642324214085258521271696151589109980391,
        0.0480376717310846685716410716320339965612,
        0.0480376717310846685716410716320339965612,
        0.0309880058569794443106942196418845053837,
        0.0309880058569794443106942196418845053837,
        0.0134118594871417720813094934586150649766,
        0.0134118594871417720813094934586150649766
    ],
    [
        0.1279381953467521569740561652246953718517,
        0.1279381953467521569740561652246953718517,
        0.1258374563468282961213753825111836887264,
        0.1258374563468282961213753825111836887264,
        0.121670472927803391204463153476262425607,
        0.121670472927803391204463153476262425607,
        0.1155056680537256013533444839067835598622,
        0.1155056680537256013533444839067835598622,
        0.1074442701159656347825773424466062227946,
        0.1074442701159656347825773424466062227946,
        0.0976186521041138882698806644642471544279,
        0.0976186521041138882698806644642471544279,
        0.086190161531953275917185202983742667185,
        0.086190161531953275917185202983742667185,
        0.0733464814110803057340336152531165181193,
        0.0733464814110803057340336152531165181193,
        0.0592985849154367807463677585001085845412,
        0.0592985849154367807463677585001085845412,
        0.0442774388174198061686027482113382288593,
        0.0442774388174198061686027482113382288593,
        0.0285313886289336631813078159518782864491,
        0.0285313886289336631813078159518782864491,
        0.0123412297999871995468056670700372915759,
        0.0123412297999871995468056670700372915759
    ]
];
module.exports.binomialCoefficients = [
    [
        1
    ],
    [
        1,
        1
    ],
    [
        1,
        2,
        1
    ],
    [
        1,
        3,
        3,
        1
    ]
];
const $49e07e1bab74aa35$var$getCubicArcLength = (xs, ys, t)=>{
    let z;
    let sum;
    let correctedT;
    const n = 20;
    z = t / 2;
    sum = 0;
    for(let i = 0; i < n; i++){
        correctedT = z * module.exports.tValues[n][i] + z;
        sum += module.exports.cValues[n][i] * $49e07e1bab74aa35$var$BFunc(xs, ys, correctedT);
    }
    return z * sum;
};
module.exports.getCubicArcLength = $49e07e1bab74aa35$var$getCubicArcLength;
const $49e07e1bab74aa35$var$getQuadraticArcLength = (xs, ys, t)=>{
    if (t === undefined) t = 1;
    const ax = xs[0] - 2 * xs[1] + xs[2];
    const ay = ys[0] - 2 * ys[1] + ys[2];
    const bx = 2 * xs[1] - 2 * xs[0];
    const by = 2 * ys[1] - 2 * ys[0];
    const A = 4 * (ax * ax + ay * ay);
    const B = 4 * (ax * bx + ay * by);
    const C = bx * bx + by * by;
    if (A === 0) return t * Math.sqrt(Math.pow(xs[2] - xs[0], 2) + Math.pow(ys[2] - ys[0], 2));
    const b = B / (2 * A);
    const c = C / A;
    const u = t + b;
    const k = c - b * b;
    const uuk = u * u + k > 0 ? Math.sqrt(u * u + k) : 0;
    const bbk = b * b + k > 0 ? Math.sqrt(b * b + k) : 0;
    const term = b + Math.sqrt(b * b + k) !== 0 ? k * Math.log(Math.abs((u + uuk) / (b + bbk))) : 0;
    return Math.sqrt(A) / 2 * (u * uuk - b * bbk + term);
};
module.exports.getQuadraticArcLength = $49e07e1bab74aa35$var$getQuadraticArcLength;
function $49e07e1bab74aa35$var$BFunc(xs, ys, t) {
    const xbase = $49e07e1bab74aa35$var$getDerivative(1, t, xs);
    const ybase = $49e07e1bab74aa35$var$getDerivative(1, t, ys);
    const combined = xbase * xbase + ybase * ybase;
    return Math.sqrt(combined);
}
const $49e07e1bab74aa35$var$getDerivative = (derivative, t, vs)=>{
    const n = vs.length - 1;
    let _vs;
    let value;
    if (n === 0) return 0;
    if (derivative === 0) {
        value = 0;
        for(let k = 0; k <= n; k++)value += module.exports.binomialCoefficients[n][k] * Math.pow(1 - t, n - k) * Math.pow(t, k) * vs[k];
        return value;
    } else {
        _vs = new Array(n);
        for(let k = 0; k < n; k++)_vs[k] = n * (vs[k + 1] - vs[k]);
        return $49e07e1bab74aa35$var$getDerivative(derivative - 1, t, _vs);
    }
};
const $49e07e1bab74aa35$var$t2length = (length, totalLength, func)=>{
    let error = 1;
    let t = length / totalLength;
    let step = (length - func(t)) / totalLength;
    let numIterations = 0;
    while(error > 0.001){
        const increasedTLength = func(t + step);
        const increasedTError = Math.abs(length - increasedTLength) / totalLength;
        if (increasedTError < error) {
            error = increasedTError;
            t += step;
        } else {
            const decreasedTLength = func(t - step);
            const decreasedTError = Math.abs(length - decreasedTLength) / totalLength;
            if (decreasedTError < error) {
                error = decreasedTError;
                t -= step;
            } else step /= 2;
        }
        numIterations++;
        if (numIterations > 500) break;
    }
    return t;
};
module.exports.t2length = $49e07e1bab74aa35$var$t2length;

});



parcelRegister("bVmKg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Circle = void 0;

var $3V3su = parcelRequire("3V3su");

var $82UKb = parcelRequire("82UKb");

var $2TXYV = parcelRequire("2TXYV");

var $4v96z = parcelRequire("4v96z");
class $8ae6a9511dbe5f49$var$Circle extends $82UKb.Shape {
    _sceneFunc(context) {
        context.beginPath();
        context.arc(0, 0, this.attrs.radius || 0, 0, Math.PI * 2, false);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.radius() * 2;
    }
    getHeight() {
        return this.radius() * 2;
    }
    setWidth(width) {
        if (this.radius() !== width / 2) this.radius(width / 2);
    }
    setHeight(height) {
        if (this.radius() !== height / 2) this.radius(height / 2);
    }
}
module.exports.Circle = $8ae6a9511dbe5f49$var$Circle;
$8ae6a9511dbe5f49$var$Circle.prototype._centroid = true;
$8ae6a9511dbe5f49$var$Circle.prototype.className = "Circle";
$8ae6a9511dbe5f49$var$Circle.prototype._attrsAffectingSize = [
    "radius"
];
(0, $4v96z._registerNode)($8ae6a9511dbe5f49$var$Circle);
$3V3su.Factory.addGetterSetter($8ae6a9511dbe5f49$var$Circle, "radius", 0, (0, $2TXYV.getNumberValidator)());

});

parcelRegister("coMIK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Ellipse = void 0;

var $3V3su = parcelRequire("3V3su");

var $82UKb = parcelRequire("82UKb");

var $2TXYV = parcelRequire("2TXYV");

var $4v96z = parcelRequire("4v96z");
class $906d84dd84d76785$var$Ellipse extends $82UKb.Shape {
    _sceneFunc(context) {
        var rx = this.radiusX(), ry = this.radiusY();
        context.beginPath();
        context.save();
        if (rx !== ry) context.scale(1, ry / rx);
        context.arc(0, 0, rx, 0, Math.PI * 2, false);
        context.restore();
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.radiusX() * 2;
    }
    getHeight() {
        return this.radiusY() * 2;
    }
    setWidth(width) {
        this.radiusX(width / 2);
    }
    setHeight(height) {
        this.radiusY(height / 2);
    }
}
module.exports.Ellipse = $906d84dd84d76785$var$Ellipse;
$906d84dd84d76785$var$Ellipse.prototype.className = "Ellipse";
$906d84dd84d76785$var$Ellipse.prototype._centroid = true;
$906d84dd84d76785$var$Ellipse.prototype._attrsAffectingSize = [
    "radiusX",
    "radiusY"
];
(0, $4v96z._registerNode)($906d84dd84d76785$var$Ellipse);
$3V3su.Factory.addComponentsGetterSetter($906d84dd84d76785$var$Ellipse, "radius", [
    "x",
    "y"
]);
$3V3su.Factory.addGetterSetter($906d84dd84d76785$var$Ellipse, "radiusX", 0, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($906d84dd84d76785$var$Ellipse, "radiusY", 0, (0, $2TXYV.getNumberValidator)());

});

parcelRegister("bGp9B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Image = void 0;

var $kWs5g = parcelRequire("kWs5g");

var $3V3su = parcelRequire("3V3su");

var $82UKb = parcelRequire("82UKb");

var $4v96z = parcelRequire("4v96z");

var $2TXYV = parcelRequire("2TXYV");
class $881720fd47ed215b$var$Image extends $82UKb.Shape {
    constructor(attrs){
        super(attrs);
        this.on("imageChange.konva", ()=>{
            this._setImageLoad();
        });
        this._setImageLoad();
    }
    _setImageLoad() {
        const image = this.image();
        if (image && image.complete) return;
        if (image && image.readyState === 4) return;
        if (image && image["addEventListener"]) image["addEventListener"]("load", ()=>{
            this._requestDraw();
        });
    }
    _useBufferCanvas() {
        return super._useBufferCanvas(true);
    }
    _sceneFunc(context) {
        const width = this.getWidth();
        const height = this.getHeight();
        const cornerRadius = this.cornerRadius();
        const image = this.attrs.image;
        let params;
        if (image) {
            const cropWidth = this.attrs.cropWidth;
            const cropHeight = this.attrs.cropHeight;
            if (cropWidth && cropHeight) params = [
                image,
                this.cropX(),
                this.cropY(),
                cropWidth,
                cropHeight,
                0,
                0,
                width,
                height
            ];
            else params = [
                image,
                0,
                0,
                width,
                height
            ];
        }
        if (this.hasFill() || this.hasStroke() || cornerRadius) {
            context.beginPath();
            cornerRadius ? $kWs5g.Util.drawRoundedRectPath(context, width, height, cornerRadius) : context.rect(0, 0, width, height);
            context.closePath();
            context.fillStrokeShape(this);
        }
        if (image) {
            if (cornerRadius) context.clip();
            context.drawImage.apply(context, params);
        }
    }
    _hitFunc(context) {
        var width = this.width(), height = this.height(), cornerRadius = this.cornerRadius();
        context.beginPath();
        if (!cornerRadius) context.rect(0, 0, width, height);
        else $kWs5g.Util.drawRoundedRectPath(context, width, height, cornerRadius);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        var _a, _b;
        return (_a = this.attrs.width) !== null && _a !== void 0 ? _a : (_b = this.image()) === null || _b === void 0 ? void 0 : _b.width;
    }
    getHeight() {
        var _a, _b;
        return (_a = this.attrs.height) !== null && _a !== void 0 ? _a : (_b = this.image()) === null || _b === void 0 ? void 0 : _b.height;
    }
    static fromURL(url, callback, onError = null) {
        var img = $kWs5g.Util.createImageElement();
        img.onload = function() {
            var image = new $881720fd47ed215b$var$Image({
                image: img
            });
            callback(image);
        };
        img.onerror = onError;
        img.crossOrigin = "Anonymous";
        img.src = url;
    }
}
module.exports.Image = $881720fd47ed215b$var$Image;
$881720fd47ed215b$var$Image.prototype.className = "Image";
(0, $4v96z._registerNode)($881720fd47ed215b$var$Image);
$3V3su.Factory.addGetterSetter($881720fd47ed215b$var$Image, "cornerRadius", 0, (0, $2TXYV.getNumberOrArrayOfNumbersValidator)(4));
$3V3su.Factory.addGetterSetter($881720fd47ed215b$var$Image, "image");
$3V3su.Factory.addComponentsGetterSetter($881720fd47ed215b$var$Image, "crop", [
    "x",
    "y",
    "width",
    "height"
]);
$3V3su.Factory.addGetterSetter($881720fd47ed215b$var$Image, "cropX", 0, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($881720fd47ed215b$var$Image, "cropY", 0, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($881720fd47ed215b$var$Image, "cropWidth", 0, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($881720fd47ed215b$var$Image, "cropHeight", 0, (0, $2TXYV.getNumberValidator)());

});

parcelRegister("x9Ses", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Tag = module.exports.Label = void 0;

var $3V3su = parcelRequire("3V3su");

var $82UKb = parcelRequire("82UKb");

var $4gbUw = parcelRequire("4gbUw");

var $2TXYV = parcelRequire("2TXYV");

var $4v96z = parcelRequire("4v96z");
var $063abde53f9e977c$var$ATTR_CHANGE_LIST = [
    "fontFamily",
    "fontSize",
    "fontStyle",
    "padding",
    "lineHeight",
    "text",
    "width",
    "height",
    "pointerDirection",
    "pointerWidth",
    "pointerHeight"
], $063abde53f9e977c$var$CHANGE_KONVA = "Change.konva", $063abde53f9e977c$var$NONE = "none", $063abde53f9e977c$var$UP = "up", $063abde53f9e977c$var$RIGHT = "right", $063abde53f9e977c$var$DOWN = "down", $063abde53f9e977c$var$LEFT = "left", $063abde53f9e977c$var$attrChangeListLen = $063abde53f9e977c$var$ATTR_CHANGE_LIST.length;
class $063abde53f9e977c$var$Label extends $4gbUw.Group {
    constructor(config){
        super(config);
        this.on("add.konva", function(evt) {
            this._addListeners(evt.child);
            this._sync();
        });
    }
    getText() {
        return this.find("Text")[0];
    }
    getTag() {
        return this.find("Tag")[0];
    }
    _addListeners(text) {
        var that = this, n;
        var func = function() {
            that._sync();
        };
        for(n = 0; n < $063abde53f9e977c$var$attrChangeListLen; n++)text.on($063abde53f9e977c$var$ATTR_CHANGE_LIST[n] + $063abde53f9e977c$var$CHANGE_KONVA, func);
    }
    getWidth() {
        return this.getText().width();
    }
    getHeight() {
        return this.getText().height();
    }
    _sync() {
        var text = this.getText(), tag = this.getTag(), width, height, pointerDirection, pointerWidth, x, y, pointerHeight;
        if (text && tag) {
            width = text.width();
            height = text.height();
            pointerDirection = tag.pointerDirection();
            pointerWidth = tag.pointerWidth();
            pointerHeight = tag.pointerHeight();
            x = 0;
            y = 0;
            switch(pointerDirection){
                case $063abde53f9e977c$var$UP:
                    x = width / 2;
                    y = -1 * pointerHeight;
                    break;
                case $063abde53f9e977c$var$RIGHT:
                    x = width + pointerWidth;
                    y = height / 2;
                    break;
                case $063abde53f9e977c$var$DOWN:
                    x = width / 2;
                    y = height + pointerHeight;
                    break;
                case $063abde53f9e977c$var$LEFT:
                    x = -1 * pointerWidth;
                    y = height / 2;
                    break;
            }
            tag.setAttrs({
                x: -1 * x,
                y: -1 * y,
                width: width,
                height: height
            });
            text.setAttrs({
                x: -1 * x,
                y: -1 * y
            });
        }
    }
}
module.exports.Label = $063abde53f9e977c$var$Label;
$063abde53f9e977c$var$Label.prototype.className = "Label";
(0, $4v96z._registerNode)($063abde53f9e977c$var$Label);
class $063abde53f9e977c$var$Tag extends $82UKb.Shape {
    _sceneFunc(context) {
        var width = this.width(), height = this.height(), pointerDirection = this.pointerDirection(), pointerWidth = this.pointerWidth(), pointerHeight = this.pointerHeight(), cornerRadius = this.cornerRadius();
        let topLeft = 0;
        let topRight = 0;
        let bottomLeft = 0;
        let bottomRight = 0;
        if (typeof cornerRadius === "number") topLeft = topRight = bottomLeft = bottomRight = Math.min(cornerRadius, width / 2, height / 2);
        else {
            topLeft = Math.min(cornerRadius[0] || 0, width / 2, height / 2);
            topRight = Math.min(cornerRadius[1] || 0, width / 2, height / 2);
            bottomRight = Math.min(cornerRadius[2] || 0, width / 2, height / 2);
            bottomLeft = Math.min(cornerRadius[3] || 0, width / 2, height / 2);
        }
        context.beginPath();
        context.moveTo(topLeft, 0);
        if (pointerDirection === $063abde53f9e977c$var$UP) {
            context.lineTo((width - pointerWidth) / 2, 0);
            context.lineTo(width / 2, -1 * pointerHeight);
            context.lineTo((width + pointerWidth) / 2, 0);
        }
        context.lineTo(width - topRight, 0);
        context.arc(width - topRight, topRight, topRight, Math.PI * 3 / 2, 0, false);
        if (pointerDirection === $063abde53f9e977c$var$RIGHT) {
            context.lineTo(width, (height - pointerHeight) / 2);
            context.lineTo(width + pointerWidth, height / 2);
            context.lineTo(width, (height + pointerHeight) / 2);
        }
        context.lineTo(width, height - bottomRight);
        context.arc(width - bottomRight, height - bottomRight, bottomRight, 0, Math.PI / 2, false);
        if (pointerDirection === $063abde53f9e977c$var$DOWN) {
            context.lineTo((width + pointerWidth) / 2, height);
            context.lineTo(width / 2, height + pointerHeight);
            context.lineTo((width - pointerWidth) / 2, height);
        }
        context.lineTo(bottomLeft, height);
        context.arc(bottomLeft, height - bottomLeft, bottomLeft, Math.PI / 2, Math.PI, false);
        if (pointerDirection === $063abde53f9e977c$var$LEFT) {
            context.lineTo(0, (height + pointerHeight) / 2);
            context.lineTo(-1 * pointerWidth, height / 2);
            context.lineTo(0, (height - pointerHeight) / 2);
        }
        context.lineTo(0, topLeft);
        context.arc(topLeft, topLeft, topLeft, Math.PI, Math.PI * 3 / 2, false);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getSelfRect() {
        var x = 0, y = 0, pointerWidth = this.pointerWidth(), pointerHeight = this.pointerHeight(), direction = this.pointerDirection(), width = this.width(), height = this.height();
        if (direction === $063abde53f9e977c$var$UP) {
            y -= pointerHeight;
            height += pointerHeight;
        } else if (direction === $063abde53f9e977c$var$DOWN) height += pointerHeight;
        else if (direction === $063abde53f9e977c$var$LEFT) {
            x -= pointerWidth * 1.5;
            width += pointerWidth;
        } else if (direction === $063abde53f9e977c$var$RIGHT) width += pointerWidth * 1.5;
        return {
            x: x,
            y: y,
            width: width,
            height: height
        };
    }
}
module.exports.Tag = $063abde53f9e977c$var$Tag;
$063abde53f9e977c$var$Tag.prototype.className = "Tag";
(0, $4v96z._registerNode)($063abde53f9e977c$var$Tag);
$3V3su.Factory.addGetterSetter($063abde53f9e977c$var$Tag, "pointerDirection", $063abde53f9e977c$var$NONE);
$3V3su.Factory.addGetterSetter($063abde53f9e977c$var$Tag, "pointerWidth", 0, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($063abde53f9e977c$var$Tag, "pointerHeight", 0, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($063abde53f9e977c$var$Tag, "cornerRadius", 0, (0, $2TXYV.getNumberOrArrayOfNumbersValidator)(4));

});

parcelRegister("frrTX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Rect = void 0;

var $3V3su = parcelRequire("3V3su");

var $82UKb = parcelRequire("82UKb");

var $4v96z = parcelRequire("4v96z");

var $kWs5g = parcelRequire("kWs5g");

var $2TXYV = parcelRequire("2TXYV");
class $b3df05478dd33d17$var$Rect extends $82UKb.Shape {
    _sceneFunc(context) {
        var cornerRadius = this.cornerRadius(), width = this.width(), height = this.height();
        context.beginPath();
        if (!cornerRadius) context.rect(0, 0, width, height);
        else $kWs5g.Util.drawRoundedRectPath(context, width, height, cornerRadius);
        context.closePath();
        context.fillStrokeShape(this);
    }
}
module.exports.Rect = $b3df05478dd33d17$var$Rect;
$b3df05478dd33d17$var$Rect.prototype.className = "Rect";
(0, $4v96z._registerNode)($b3df05478dd33d17$var$Rect);
$3V3su.Factory.addGetterSetter($b3df05478dd33d17$var$Rect, "cornerRadius", 0, (0, $2TXYV.getNumberOrArrayOfNumbersValidator)(4));

});

parcelRegister("fNWX2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RegularPolygon = void 0;

var $3V3su = parcelRequire("3V3su");

var $82UKb = parcelRequire("82UKb");

var $2TXYV = parcelRequire("2TXYV");

var $4v96z = parcelRequire("4v96z");
class $b81929159d2c3945$var$RegularPolygon extends $82UKb.Shape {
    _sceneFunc(context) {
        const points = this._getPoints();
        context.beginPath();
        context.moveTo(points[0].x, points[0].y);
        for(var n = 1; n < points.length; n++)context.lineTo(points[n].x, points[n].y);
        context.closePath();
        context.fillStrokeShape(this);
    }
    _getPoints() {
        const sides = this.attrs.sides;
        const radius = this.attrs.radius || 0;
        const points = [];
        for(var n = 0; n < sides; n++)points.push({
            x: radius * Math.sin(n * 2 * Math.PI / sides),
            y: -1 * radius * Math.cos(n * 2 * Math.PI / sides)
        });
        return points;
    }
    getSelfRect() {
        const points = this._getPoints();
        var minX = points[0].x;
        var maxX = points[0].y;
        var minY = points[0].x;
        var maxY = points[0].y;
        points.forEach((point)=>{
            minX = Math.min(minX, point.x);
            maxX = Math.max(maxX, point.x);
            minY = Math.min(minY, point.y);
            maxY = Math.max(maxY, point.y);
        });
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    getWidth() {
        return this.radius() * 2;
    }
    getHeight() {
        return this.radius() * 2;
    }
    setWidth(width) {
        this.radius(width / 2);
    }
    setHeight(height) {
        this.radius(height / 2);
    }
}
module.exports.RegularPolygon = $b81929159d2c3945$var$RegularPolygon;
$b81929159d2c3945$var$RegularPolygon.prototype.className = "RegularPolygon";
$b81929159d2c3945$var$RegularPolygon.prototype._centroid = true;
$b81929159d2c3945$var$RegularPolygon.prototype._attrsAffectingSize = [
    "radius"
];
(0, $4v96z._registerNode)($b81929159d2c3945$var$RegularPolygon);
$3V3su.Factory.addGetterSetter($b81929159d2c3945$var$RegularPolygon, "radius", 0, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($b81929159d2c3945$var$RegularPolygon, "sides", 0, (0, $2TXYV.getNumberValidator)());

});

parcelRegister("8hR4I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Ring = void 0;

var $3V3su = parcelRequire("3V3su");

var $82UKb = parcelRequire("82UKb");

var $2TXYV = parcelRequire("2TXYV");

var $4v96z = parcelRequire("4v96z");
var $608914e3114c545f$var$PIx2 = Math.PI * 2;
class $608914e3114c545f$var$Ring extends $82UKb.Shape {
    _sceneFunc(context) {
        context.beginPath();
        context.arc(0, 0, this.innerRadius(), 0, $608914e3114c545f$var$PIx2, false);
        context.moveTo(this.outerRadius(), 0);
        context.arc(0, 0, this.outerRadius(), $608914e3114c545f$var$PIx2, 0, true);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.outerRadius() * 2;
    }
    getHeight() {
        return this.outerRadius() * 2;
    }
    setWidth(width) {
        this.outerRadius(width / 2);
    }
    setHeight(height) {
        this.outerRadius(height / 2);
    }
}
module.exports.Ring = $608914e3114c545f$var$Ring;
$608914e3114c545f$var$Ring.prototype.className = "Ring";
$608914e3114c545f$var$Ring.prototype._centroid = true;
$608914e3114c545f$var$Ring.prototype._attrsAffectingSize = [
    "innerRadius",
    "outerRadius"
];
(0, $4v96z._registerNode)($608914e3114c545f$var$Ring);
$3V3su.Factory.addGetterSetter($608914e3114c545f$var$Ring, "innerRadius", 0, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($608914e3114c545f$var$Ring, "outerRadius", 0, (0, $2TXYV.getNumberValidator)());

});

parcelRegister("dY8gg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sprite = void 0;

var $3V3su = parcelRequire("3V3su");

var $82UKb = parcelRequire("82UKb");

var $hgtvs = parcelRequire("hgtvs");

var $2TXYV = parcelRequire("2TXYV");

var $4v96z = parcelRequire("4v96z");
class $a2b74979e7ba6693$var$Sprite extends $82UKb.Shape {
    constructor(config){
        super(config);
        this._updated = true;
        this.anim = new $hgtvs.Animation(()=>{
            var updated = this._updated;
            this._updated = false;
            return updated;
        });
        this.on("animationChange.konva", function() {
            this.frameIndex(0);
        });
        this.on("frameIndexChange.konva", function() {
            this._updated = true;
        });
        this.on("frameRateChange.konva", function() {
            if (!this.anim.isRunning()) return;
            clearInterval(this.interval);
            this._setInterval();
        });
    }
    _sceneFunc(context) {
        var anim = this.animation(), index = this.frameIndex(), ix4 = index * 4, set = this.animations()[anim], offsets = this.frameOffsets(), x = set[ix4 + 0], y = set[ix4 + 1], width = set[ix4 + 2], height = set[ix4 + 3], image = this.image();
        if (this.hasFill() || this.hasStroke()) {
            context.beginPath();
            context.rect(0, 0, width, height);
            context.closePath();
            context.fillStrokeShape(this);
        }
        if (image) {
            if (offsets) {
                var offset = offsets[anim], ix2 = index * 2;
                context.drawImage(image, x, y, width, height, offset[ix2 + 0], offset[ix2 + 1], width, height);
            } else context.drawImage(image, x, y, width, height, 0, 0, width, height);
        }
    }
    _hitFunc(context) {
        var anim = this.animation(), index = this.frameIndex(), ix4 = index * 4, set = this.animations()[anim], offsets = this.frameOffsets(), width = set[ix4 + 2], height = set[ix4 + 3];
        context.beginPath();
        if (offsets) {
            var offset = offsets[anim];
            var ix2 = index * 2;
            context.rect(offset[ix2 + 0], offset[ix2 + 1], width, height);
        } else context.rect(0, 0, width, height);
        context.closePath();
        context.fillShape(this);
    }
    _useBufferCanvas() {
        return super._useBufferCanvas(true);
    }
    _setInterval() {
        var that = this;
        this.interval = setInterval(function() {
            that._updateIndex();
        }, 1000 / this.frameRate());
    }
    start() {
        if (this.isRunning()) return;
        var layer = this.getLayer();
        this.anim.setLayers(layer);
        this._setInterval();
        this.anim.start();
    }
    stop() {
        this.anim.stop();
        clearInterval(this.interval);
    }
    isRunning() {
        return this.anim.isRunning();
    }
    _updateIndex() {
        var index = this.frameIndex(), animation = this.animation(), animations = this.animations(), anim = animations[animation], len = anim.length / 4;
        if (index < len - 1) this.frameIndex(index + 1);
        else this.frameIndex(0);
    }
}
module.exports.Sprite = $a2b74979e7ba6693$var$Sprite;
$a2b74979e7ba6693$var$Sprite.prototype.className = "Sprite";
(0, $4v96z._registerNode)($a2b74979e7ba6693$var$Sprite);
$3V3su.Factory.addGetterSetter($a2b74979e7ba6693$var$Sprite, "animation");
$3V3su.Factory.addGetterSetter($a2b74979e7ba6693$var$Sprite, "animations");
$3V3su.Factory.addGetterSetter($a2b74979e7ba6693$var$Sprite, "frameOffsets");
$3V3su.Factory.addGetterSetter($a2b74979e7ba6693$var$Sprite, "image");
$3V3su.Factory.addGetterSetter($a2b74979e7ba6693$var$Sprite, "frameIndex", 0, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($a2b74979e7ba6693$var$Sprite, "frameRate", 17, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.backCompat($a2b74979e7ba6693$var$Sprite, {
    index: "frameIndex",
    getIndex: "getFrameIndex",
    setIndex: "setFrameIndex"
});

});

parcelRegister("lG4Ld", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Star = void 0;

var $3V3su = parcelRequire("3V3su");

var $82UKb = parcelRequire("82UKb");

var $2TXYV = parcelRequire("2TXYV");

var $4v96z = parcelRequire("4v96z");
class $fc81368e1bfb786e$var$Star extends $82UKb.Shape {
    _sceneFunc(context) {
        var innerRadius = this.innerRadius(), outerRadius = this.outerRadius(), numPoints = this.numPoints();
        context.beginPath();
        context.moveTo(0, 0 - outerRadius);
        for(var n = 1; n < numPoints * 2; n++){
            var radius = n % 2 === 0 ? outerRadius : innerRadius;
            var x = radius * Math.sin(n * Math.PI / numPoints);
            var y = -1 * radius * Math.cos(n * Math.PI / numPoints);
            context.lineTo(x, y);
        }
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.outerRadius() * 2;
    }
    getHeight() {
        return this.outerRadius() * 2;
    }
    setWidth(width) {
        this.outerRadius(width / 2);
    }
    setHeight(height) {
        this.outerRadius(height / 2);
    }
}
module.exports.Star = $fc81368e1bfb786e$var$Star;
$fc81368e1bfb786e$var$Star.prototype.className = "Star";
$fc81368e1bfb786e$var$Star.prototype._centroid = true;
$fc81368e1bfb786e$var$Star.prototype._attrsAffectingSize = [
    "innerRadius",
    "outerRadius"
];
(0, $4v96z._registerNode)($fc81368e1bfb786e$var$Star);
$3V3su.Factory.addGetterSetter($fc81368e1bfb786e$var$Star, "numPoints", 5, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($fc81368e1bfb786e$var$Star, "innerRadius", 0, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($fc81368e1bfb786e$var$Star, "outerRadius", 0, (0, $2TXYV.getNumberValidator)());

});

parcelRegister("aepJ3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Text = module.exports.stringToArray = void 0;

var $kWs5g = parcelRequire("kWs5g");

var $3V3su = parcelRequire("3V3su");

var $82UKb = parcelRequire("82UKb");

var $4v96z = parcelRequire("4v96z");

var $2TXYV = parcelRequire("2TXYV");

var $4v96z = parcelRequire("4v96z");
function $772f2ac6841f7b98$var$stringToArray(string) {
    return Array.from(string);
}
module.exports.stringToArray = $772f2ac6841f7b98$var$stringToArray;
var $772f2ac6841f7b98$var$AUTO = "auto", $772f2ac6841f7b98$var$CENTER = "center", $772f2ac6841f7b98$var$INHERIT = "inherit", $772f2ac6841f7b98$var$JUSTIFY = "justify", $772f2ac6841f7b98$var$CHANGE_KONVA = "Change.konva", $772f2ac6841f7b98$var$CONTEXT_2D = "2d", $772f2ac6841f7b98$var$DASH = "-", $772f2ac6841f7b98$var$LEFT = "left", $772f2ac6841f7b98$var$LTR = "ltr", $772f2ac6841f7b98$var$TEXT = "text", $772f2ac6841f7b98$var$TEXT_UPPER = "Text", $772f2ac6841f7b98$var$TOP = "top", $772f2ac6841f7b98$var$BOTTOM = "bottom", $772f2ac6841f7b98$var$MIDDLE = "middle", $772f2ac6841f7b98$var$NORMAL = "normal", $772f2ac6841f7b98$var$PX_SPACE = "px ", $772f2ac6841f7b98$var$SPACE = " ", $772f2ac6841f7b98$var$RIGHT = "right", $772f2ac6841f7b98$var$RTL = "rtl", $772f2ac6841f7b98$var$WORD = "word", $772f2ac6841f7b98$var$CHAR = "char", $772f2ac6841f7b98$var$NONE = "none", $772f2ac6841f7b98$var$ELLIPSIS = "\u2026", $772f2ac6841f7b98$var$ATTR_CHANGE_LIST = [
    "direction",
    "fontFamily",
    "fontSize",
    "fontStyle",
    "fontVariant",
    "padding",
    "align",
    "verticalAlign",
    "lineHeight",
    "text",
    "width",
    "height",
    "wrap",
    "ellipsis",
    "letterSpacing"
], $772f2ac6841f7b98$var$attrChangeListLen = $772f2ac6841f7b98$var$ATTR_CHANGE_LIST.length;
function $772f2ac6841f7b98$var$normalizeFontFamily(fontFamily) {
    return fontFamily.split(",").map((family)=>{
        family = family.trim();
        const hasSpace = family.indexOf(" ") >= 0;
        const hasQuotes = family.indexOf('"') >= 0 || family.indexOf("'") >= 0;
        if (hasSpace && !hasQuotes) family = `"${family}"`;
        return family;
    }).join(", ");
}
var $772f2ac6841f7b98$var$dummyContext;
function $772f2ac6841f7b98$var$getDummyContext() {
    if ($772f2ac6841f7b98$var$dummyContext) return $772f2ac6841f7b98$var$dummyContext;
    $772f2ac6841f7b98$var$dummyContext = $kWs5g.Util.createCanvasElement().getContext($772f2ac6841f7b98$var$CONTEXT_2D);
    return $772f2ac6841f7b98$var$dummyContext;
}
function $772f2ac6841f7b98$var$_fillFunc(context) {
    context.fillText(this._partialText, this._partialTextX, this._partialTextY);
}
function $772f2ac6841f7b98$var$_strokeFunc(context) {
    context.setAttr("miterLimit", 2);
    context.strokeText(this._partialText, this._partialTextX, this._partialTextY);
}
function $772f2ac6841f7b98$var$checkDefaultFill(config) {
    config = config || {};
    if (!config.fillLinearGradientColorStops && !config.fillRadialGradientColorStops && !config.fillPatternImage) config.fill = config.fill || "black";
    return config;
}
class $772f2ac6841f7b98$var$Text extends $82UKb.Shape {
    constructor(config){
        super($772f2ac6841f7b98$var$checkDefaultFill(config));
        this._partialTextX = 0;
        this._partialTextY = 0;
        for(var n = 0; n < $772f2ac6841f7b98$var$attrChangeListLen; n++)this.on($772f2ac6841f7b98$var$ATTR_CHANGE_LIST[n] + $772f2ac6841f7b98$var$CHANGE_KONVA, this._setTextData);
        this._setTextData();
    }
    _sceneFunc(context) {
        var textArr = this.textArr, textArrLen = textArr.length;
        if (!this.text()) return;
        var padding = this.padding(), fontSize = this.fontSize(), lineHeightPx = this.lineHeight() * fontSize, verticalAlign = this.verticalAlign(), direction = this.direction(), alignY = 0, align = this.align(), totalWidth = this.getWidth(), letterSpacing = this.letterSpacing(), fill = this.fill(), textDecoration = this.textDecoration(), shouldUnderline = textDecoration.indexOf("underline") !== -1, shouldLineThrough = textDecoration.indexOf("line-through") !== -1, n;
        direction = direction === $772f2ac6841f7b98$var$INHERIT ? context.direction : direction;
        var translateY = lineHeightPx / 2;
        var baseline = $772f2ac6841f7b98$var$MIDDLE;
        if ($4v96z.Konva._fixTextRendering) {
            var metrics = this.measureSize("M");
            baseline = "alphabetic";
            translateY = (metrics.fontBoundingBoxAscent - metrics.fontBoundingBoxDescent) / 2 + lineHeightPx / 2;
        }
        var lineTranslateX = 0;
        var lineTranslateY = 0;
        if (direction === $772f2ac6841f7b98$var$RTL) context.setAttr("direction", direction);
        context.setAttr("font", this._getContextFont());
        context.setAttr("textBaseline", baseline);
        context.setAttr("textAlign", $772f2ac6841f7b98$var$LEFT);
        if (verticalAlign === $772f2ac6841f7b98$var$MIDDLE) alignY = (this.getHeight() - textArrLen * lineHeightPx - padding * 2) / 2;
        else if (verticalAlign === $772f2ac6841f7b98$var$BOTTOM) alignY = this.getHeight() - textArrLen * lineHeightPx - padding * 2;
        context.translate(padding, alignY + padding);
        for(n = 0; n < textArrLen; n++){
            var lineTranslateX = 0;
            var lineTranslateY = 0;
            var obj = textArr[n], text = obj.text, width = obj.width, lastLine = obj.lastInParagraph, spacesNumber, oneWord, lineWidth;
            context.save();
            if (align === $772f2ac6841f7b98$var$RIGHT) lineTranslateX += totalWidth - width - padding * 2;
            else if (align === $772f2ac6841f7b98$var$CENTER) lineTranslateX += (totalWidth - width - padding * 2) / 2;
            if (shouldUnderline) {
                context.save();
                context.beginPath();
                let yOffset = $4v96z.Konva._fixTextRendering ? Math.round(fontSize / 4) : Math.round(fontSize / 2);
                const x = lineTranslateX;
                const y = translateY + lineTranslateY + yOffset;
                context.moveTo(x, y);
                spacesNumber = text.split(" ").length - 1;
                oneWord = spacesNumber === 0;
                lineWidth = align === $772f2ac6841f7b98$var$JUSTIFY && !lastLine ? totalWidth - padding * 2 : width;
                context.lineTo(x + Math.round(lineWidth), y);
                context.lineWidth = fontSize / 15;
                const gradient = this._getLinearGradient();
                context.strokeStyle = gradient || fill;
                context.stroke();
                context.restore();
            }
            if (shouldLineThrough) {
                context.save();
                context.beginPath();
                let yOffset = $4v96z.Konva._fixTextRendering ? -Math.round(fontSize / 4) : 0;
                context.moveTo(lineTranslateX, translateY + lineTranslateY + yOffset);
                spacesNumber = text.split(" ").length - 1;
                oneWord = spacesNumber === 0;
                lineWidth = align === $772f2ac6841f7b98$var$JUSTIFY && lastLine && !oneWord ? totalWidth - padding * 2 : width;
                context.lineTo(lineTranslateX + Math.round(lineWidth), translateY + lineTranslateY + yOffset);
                context.lineWidth = fontSize / 15;
                const gradient = this._getLinearGradient();
                context.strokeStyle = gradient || fill;
                context.stroke();
                context.restore();
            }
            if (direction !== $772f2ac6841f7b98$var$RTL && (letterSpacing !== 0 || align === $772f2ac6841f7b98$var$JUSTIFY)) {
                spacesNumber = text.split(" ").length - 1;
                var array = $772f2ac6841f7b98$var$stringToArray(text);
                for(var li = 0; li < array.length; li++){
                    var letter = array[li];
                    if (letter === " " && !lastLine && align === $772f2ac6841f7b98$var$JUSTIFY) lineTranslateX += (totalWidth - padding * 2 - width) / spacesNumber;
                    this._partialTextX = lineTranslateX;
                    this._partialTextY = translateY + lineTranslateY;
                    this._partialText = letter;
                    context.fillStrokeShape(this);
                    lineTranslateX += this.measureSize(letter).width + letterSpacing;
                }
            } else {
                if (letterSpacing !== 0) context.setAttr("letterSpacing", `${letterSpacing}px`);
                this._partialTextX = lineTranslateX;
                this._partialTextY = translateY + lineTranslateY;
                this._partialText = text;
                context.fillStrokeShape(this);
            }
            context.restore();
            if (textArrLen > 1) translateY += lineHeightPx;
        }
    }
    _hitFunc(context) {
        var width = this.getWidth(), height = this.getHeight();
        context.beginPath();
        context.rect(0, 0, width, height);
        context.closePath();
        context.fillStrokeShape(this);
    }
    setText(text) {
        var str = $kWs5g.Util._isString(text) ? text : text === null || text === undefined ? "" : text + "";
        this._setAttr($772f2ac6841f7b98$var$TEXT, str);
        return this;
    }
    getWidth() {
        var isAuto = this.attrs.width === $772f2ac6841f7b98$var$AUTO || this.attrs.width === undefined;
        return isAuto ? this.getTextWidth() + this.padding() * 2 : this.attrs.width;
    }
    getHeight() {
        var isAuto = this.attrs.height === $772f2ac6841f7b98$var$AUTO || this.attrs.height === undefined;
        return isAuto ? this.fontSize() * this.textArr.length * this.lineHeight() + this.padding() * 2 : this.attrs.height;
    }
    getTextWidth() {
        return this.textWidth;
    }
    getTextHeight() {
        $kWs5g.Util.warn("text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height.");
        return this.textHeight;
    }
    measureSize(text) {
        var _context = $772f2ac6841f7b98$var$getDummyContext(), fontSize = this.fontSize(), metrics;
        _context.save();
        _context.font = this._getContextFont();
        metrics = _context.measureText(text);
        _context.restore();
        return {
            actualBoundingBoxAscent: metrics.actualBoundingBoxAscent,
            actualBoundingBoxDescent: metrics.actualBoundingBoxDescent,
            actualBoundingBoxLeft: metrics.actualBoundingBoxLeft,
            actualBoundingBoxRight: metrics.actualBoundingBoxRight,
            alphabeticBaseline: metrics.alphabeticBaseline,
            emHeightAscent: metrics.emHeightAscent,
            emHeightDescent: metrics.emHeightDescent,
            fontBoundingBoxAscent: metrics.fontBoundingBoxAscent,
            fontBoundingBoxDescent: metrics.fontBoundingBoxDescent,
            hangingBaseline: metrics.hangingBaseline,
            ideographicBaseline: metrics.ideographicBaseline,
            width: metrics.width,
            height: fontSize
        };
    }
    _getContextFont() {
        return this.fontStyle() + $772f2ac6841f7b98$var$SPACE + this.fontVariant() + $772f2ac6841f7b98$var$SPACE + (this.fontSize() + $772f2ac6841f7b98$var$PX_SPACE) + $772f2ac6841f7b98$var$normalizeFontFamily(this.fontFamily());
    }
    _addTextLine(line) {
        const align = this.align();
        if (align === $772f2ac6841f7b98$var$JUSTIFY) line = line.trim();
        var width = this._getTextWidth(line);
        return this.textArr.push({
            text: line,
            width: width,
            lastInParagraph: false
        });
    }
    _getTextWidth(text) {
        var letterSpacing = this.letterSpacing();
        var length = text.length;
        return $772f2ac6841f7b98$var$getDummyContext().measureText(text).width + (length ? letterSpacing * (length - 1) : 0);
    }
    _setTextData() {
        var lines = this.text().split("\n"), fontSize = +this.fontSize(), textWidth = 0, lineHeightPx = this.lineHeight() * fontSize, width = this.attrs.width, height = this.attrs.height, fixedWidth = width !== $772f2ac6841f7b98$var$AUTO && width !== undefined, fixedHeight = height !== $772f2ac6841f7b98$var$AUTO && height !== undefined, padding = this.padding(), maxWidth = width - padding * 2, maxHeightPx = height - padding * 2, currentHeightPx = 0, wrap = this.wrap(), shouldWrap = wrap !== $772f2ac6841f7b98$var$NONE, wrapAtWord = wrap !== $772f2ac6841f7b98$var$CHAR && shouldWrap, shouldAddEllipsis = this.ellipsis();
        this.textArr = [];
        $772f2ac6841f7b98$var$getDummyContext().font = this._getContextFont();
        var additionalWidth = shouldAddEllipsis ? this._getTextWidth($772f2ac6841f7b98$var$ELLIPSIS) : 0;
        for(var i = 0, max = lines.length; i < max; ++i){
            var line = lines[i];
            var lineWidth = this._getTextWidth(line);
            if (fixedWidth && lineWidth > maxWidth) while(line.length > 0){
                var low = 0, high = line.length, match = "", matchWidth = 0;
                while(low < high){
                    var mid = low + high >>> 1, substr = line.slice(0, mid + 1), substrWidth = this._getTextWidth(substr) + additionalWidth;
                    if (substrWidth <= maxWidth) {
                        low = mid + 1;
                        match = substr;
                        matchWidth = substrWidth;
                    } else high = mid;
                }
                if (match) {
                    if (wrapAtWord) {
                        var wrapIndex;
                        var nextChar = line[match.length];
                        var nextIsSpaceOrDash = nextChar === $772f2ac6841f7b98$var$SPACE || nextChar === $772f2ac6841f7b98$var$DASH;
                        if (nextIsSpaceOrDash && matchWidth <= maxWidth) wrapIndex = match.length;
                        else wrapIndex = Math.max(match.lastIndexOf($772f2ac6841f7b98$var$SPACE), match.lastIndexOf($772f2ac6841f7b98$var$DASH)) + 1;
                        if (wrapIndex > 0) {
                            low = wrapIndex;
                            match = match.slice(0, low);
                            matchWidth = this._getTextWidth(match);
                        }
                    }
                    match = match.trimRight();
                    this._addTextLine(match);
                    textWidth = Math.max(textWidth, matchWidth);
                    currentHeightPx += lineHeightPx;
                    var shouldHandleEllipsis = this._shouldHandleEllipsis(currentHeightPx);
                    if (shouldHandleEllipsis) {
                        this._tryToAddEllipsisToLastLine();
                        break;
                    }
                    line = line.slice(low);
                    line = line.trimLeft();
                    if (line.length > 0) {
                        lineWidth = this._getTextWidth(line);
                        if (lineWidth <= maxWidth) {
                            this._addTextLine(line);
                            currentHeightPx += lineHeightPx;
                            textWidth = Math.max(textWidth, lineWidth);
                            break;
                        }
                    }
                } else break;
            }
            else {
                this._addTextLine(line);
                currentHeightPx += lineHeightPx;
                textWidth = Math.max(textWidth, lineWidth);
                if (this._shouldHandleEllipsis(currentHeightPx) && i < max - 1) this._tryToAddEllipsisToLastLine();
            }
            if (this.textArr[this.textArr.length - 1]) this.textArr[this.textArr.length - 1].lastInParagraph = true;
            if (fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx) break;
        }
        this.textHeight = fontSize;
        this.textWidth = textWidth;
    }
    _shouldHandleEllipsis(currentHeightPx) {
        var fontSize = +this.fontSize(), lineHeightPx = this.lineHeight() * fontSize, height = this.attrs.height, fixedHeight = height !== $772f2ac6841f7b98$var$AUTO && height !== undefined, padding = this.padding(), maxHeightPx = height - padding * 2, wrap = this.wrap(), shouldWrap = wrap !== $772f2ac6841f7b98$var$NONE;
        return !shouldWrap || fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx;
    }
    _tryToAddEllipsisToLastLine() {
        var width = this.attrs.width, fixedWidth = width !== $772f2ac6841f7b98$var$AUTO && width !== undefined, padding = this.padding(), maxWidth = width - padding * 2, shouldAddEllipsis = this.ellipsis();
        var lastLine = this.textArr[this.textArr.length - 1];
        if (!lastLine || !shouldAddEllipsis) return;
        if (fixedWidth) {
            var haveSpace = this._getTextWidth(lastLine.text + $772f2ac6841f7b98$var$ELLIPSIS) < maxWidth;
            if (!haveSpace) lastLine.text = lastLine.text.slice(0, lastLine.text.length - 3);
        }
        this.textArr.splice(this.textArr.length - 1, 1);
        this._addTextLine(lastLine.text + $772f2ac6841f7b98$var$ELLIPSIS);
    }
    getStrokeScaleEnabled() {
        return true;
    }
    _useBufferCanvas() {
        const hasLine = this.textDecoration().indexOf("underline") !== -1 || this.textDecoration().indexOf("line-through") !== -1;
        const hasShadow = this.hasShadow();
        if (hasLine && hasShadow) return true;
        return super._useBufferCanvas();
    }
}
module.exports.Text = $772f2ac6841f7b98$var$Text;
$772f2ac6841f7b98$var$Text.prototype._fillFunc = $772f2ac6841f7b98$var$_fillFunc;
$772f2ac6841f7b98$var$Text.prototype._strokeFunc = $772f2ac6841f7b98$var$_strokeFunc;
$772f2ac6841f7b98$var$Text.prototype.className = $772f2ac6841f7b98$var$TEXT_UPPER;
$772f2ac6841f7b98$var$Text.prototype._attrsAffectingSize = [
    "text",
    "fontSize",
    "padding",
    "wrap",
    "lineHeight",
    "letterSpacing"
];
(0, $4v96z._registerNode)($772f2ac6841f7b98$var$Text);
$3V3su.Factory.overWriteSetter($772f2ac6841f7b98$var$Text, "width", (0, $2TXYV.getNumberOrAutoValidator)());
$3V3su.Factory.overWriteSetter($772f2ac6841f7b98$var$Text, "height", (0, $2TXYV.getNumberOrAutoValidator)());
$3V3su.Factory.addGetterSetter($772f2ac6841f7b98$var$Text, "direction", $772f2ac6841f7b98$var$INHERIT);
$3V3su.Factory.addGetterSetter($772f2ac6841f7b98$var$Text, "fontFamily", "Arial");
$3V3su.Factory.addGetterSetter($772f2ac6841f7b98$var$Text, "fontSize", 12, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($772f2ac6841f7b98$var$Text, "fontStyle", $772f2ac6841f7b98$var$NORMAL);
$3V3su.Factory.addGetterSetter($772f2ac6841f7b98$var$Text, "fontVariant", $772f2ac6841f7b98$var$NORMAL);
$3V3su.Factory.addGetterSetter($772f2ac6841f7b98$var$Text, "padding", 0, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($772f2ac6841f7b98$var$Text, "align", $772f2ac6841f7b98$var$LEFT);
$3V3su.Factory.addGetterSetter($772f2ac6841f7b98$var$Text, "verticalAlign", $772f2ac6841f7b98$var$TOP);
$3V3su.Factory.addGetterSetter($772f2ac6841f7b98$var$Text, "lineHeight", 1, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($772f2ac6841f7b98$var$Text, "wrap", $772f2ac6841f7b98$var$WORD);
$3V3su.Factory.addGetterSetter($772f2ac6841f7b98$var$Text, "ellipsis", false, (0, $2TXYV.getBooleanValidator)());
$3V3su.Factory.addGetterSetter($772f2ac6841f7b98$var$Text, "letterSpacing", 0, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($772f2ac6841f7b98$var$Text, "text", "", (0, $2TXYV.getStringValidator)());
$3V3su.Factory.addGetterSetter($772f2ac6841f7b98$var$Text, "textDecoration", "");

});

parcelRegister("iKGXd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TextPath = void 0;

var $kWs5g = parcelRequire("kWs5g");

var $3V3su = parcelRequire("3V3su");

var $82UKb = parcelRequire("82UKb");

var $7s2S9 = parcelRequire("7s2S9");

var $aepJ3 = parcelRequire("aepJ3");

var $2TXYV = parcelRequire("2TXYV");

var $4v96z = parcelRequire("4v96z");
var $da6dd7a345a1b906$var$EMPTY_STRING = "", $da6dd7a345a1b906$var$NORMAL = "normal";
function $da6dd7a345a1b906$var$_fillFunc(context) {
    context.fillText(this.partialText, 0, 0);
}
function $da6dd7a345a1b906$var$_strokeFunc(context) {
    context.strokeText(this.partialText, 0, 0);
}
class $da6dd7a345a1b906$var$TextPath extends $82UKb.Shape {
    constructor(config){
        super(config);
        this.dummyCanvas = $kWs5g.Util.createCanvasElement();
        this.dataArray = [];
        this._readDataAttribute();
        this.on("dataChange.konva", function() {
            this._readDataAttribute();
            this._setTextData();
        });
        this.on("textChange.konva alignChange.konva letterSpacingChange.konva kerningFuncChange.konva fontSizeChange.konva fontFamilyChange.konva", this._setTextData);
        this._setTextData();
    }
    _getTextPathLength() {
        return $7s2S9.Path.getPathLength(this.dataArray);
    }
    _getPointAtLength(length) {
        if (!this.attrs.data) return null;
        const totalLength = this.pathLength;
        if (length - 1 > totalLength) return null;
        return $7s2S9.Path.getPointAtLengthOfDataArray(length, this.dataArray);
    }
    _readDataAttribute() {
        this.dataArray = $7s2S9.Path.parsePathData(this.attrs.data);
        this.pathLength = this._getTextPathLength();
    }
    _sceneFunc(context) {
        context.setAttr("font", this._getContextFont());
        context.setAttr("textBaseline", this.textBaseline());
        context.setAttr("textAlign", "left");
        context.save();
        var textDecoration = this.textDecoration();
        var fill = this.fill();
        var fontSize = this.fontSize();
        var glyphInfo = this.glyphInfo;
        if (textDecoration === "underline") context.beginPath();
        for(var i = 0; i < glyphInfo.length; i++){
            context.save();
            var p0 = glyphInfo[i].p0;
            context.translate(p0.x, p0.y);
            context.rotate(glyphInfo[i].rotation);
            this.partialText = glyphInfo[i].text;
            context.fillStrokeShape(this);
            if (textDecoration === "underline") {
                if (i === 0) context.moveTo(0, fontSize / 2 + 1);
                context.lineTo(fontSize, fontSize / 2 + 1);
            }
            context.restore();
        }
        if (textDecoration === "underline") {
            context.strokeStyle = fill;
            context.lineWidth = fontSize / 20;
            context.stroke();
        }
        context.restore();
    }
    _hitFunc(context) {
        context.beginPath();
        var glyphInfo = this.glyphInfo;
        if (glyphInfo.length >= 1) {
            var p0 = glyphInfo[0].p0;
            context.moveTo(p0.x, p0.y);
        }
        for(var i = 0; i < glyphInfo.length; i++){
            var p1 = glyphInfo[i].p1;
            context.lineTo(p1.x, p1.y);
        }
        context.setAttr("lineWidth", this.fontSize());
        context.setAttr("strokeStyle", this.colorKey);
        context.stroke();
    }
    getTextWidth() {
        return this.textWidth;
    }
    getTextHeight() {
        $kWs5g.Util.warn("text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height.");
        return this.textHeight;
    }
    setText(text) {
        return $aepJ3.Text.prototype.setText.call(this, text);
    }
    _getContextFont() {
        return $aepJ3.Text.prototype._getContextFont.call(this);
    }
    _getTextSize(text) {
        var dummyCanvas = this.dummyCanvas;
        var _context = dummyCanvas.getContext("2d");
        _context.save();
        _context.font = this._getContextFont();
        var metrics = _context.measureText(text);
        _context.restore();
        return {
            width: metrics.width,
            height: parseInt(`${this.fontSize()}`, 10)
        };
    }
    _setTextData() {
        const { width: width, height: height } = this._getTextSize(this.attrs.text);
        this.textWidth = width;
        this.textHeight = height;
        this.glyphInfo = [];
        if (!this.attrs.data) return null;
        const letterSpacing = this.letterSpacing();
        const align = this.align();
        const kerningFunc = this.kerningFunc();
        const textWidth = Math.max(this.textWidth + ((this.attrs.text || "").length - 1) * letterSpacing, 0);
        let offset = 0;
        if (align === "center") offset = Math.max(0, this.pathLength / 2 - textWidth / 2);
        if (align === "right") offset = Math.max(0, this.pathLength - textWidth);
        const charArr = (0, $aepJ3.stringToArray)(this.text());
        let offsetToGlyph = offset;
        for(var i = 0; i < charArr.length; i++){
            const charStartPoint = this._getPointAtLength(offsetToGlyph);
            if (!charStartPoint) return;
            let glyphWidth = this._getTextSize(charArr[i]).width + letterSpacing;
            if (charArr[i] === " " && align === "justify") {
                const numberOfSpaces = this.text().split(" ").length - 1;
                glyphWidth += (this.pathLength - textWidth) / numberOfSpaces;
            }
            const charEndPoint = this._getPointAtLength(offsetToGlyph + glyphWidth);
            if (!charEndPoint) return;
            const width = $7s2S9.Path.getLineLength(charStartPoint.x, charStartPoint.y, charEndPoint.x, charEndPoint.y);
            let kern = 0;
            if (kerningFunc) try {
                kern = kerningFunc(charArr[i - 1], charArr[i]) * this.fontSize();
            } catch (e) {
                kern = 0;
            }
            charStartPoint.x += kern;
            charEndPoint.x += kern;
            this.textWidth += kern;
            const midpoint = $7s2S9.Path.getPointOnLine(kern + width / 2.0, charStartPoint.x, charStartPoint.y, charEndPoint.x, charEndPoint.y);
            const rotation = Math.atan2(charEndPoint.y - charStartPoint.y, charEndPoint.x - charStartPoint.x);
            this.glyphInfo.push({
                transposeX: midpoint.x,
                transposeY: midpoint.y,
                text: charArr[i],
                rotation: rotation,
                p0: charStartPoint,
                p1: charEndPoint
            });
            offsetToGlyph += glyphWidth;
        }
    }
    getSelfRect() {
        if (!this.glyphInfo.length) return {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        var points = [];
        this.glyphInfo.forEach(function(info) {
            points.push(info.p0.x);
            points.push(info.p0.y);
            points.push(info.p1.x);
            points.push(info.p1.y);
        });
        var minX = points[0] || 0;
        var maxX = points[0] || 0;
        var minY = points[1] || 0;
        var maxY = points[1] || 0;
        var x, y;
        for(var i = 0; i < points.length / 2; i++){
            x = points[i * 2];
            y = points[i * 2 + 1];
            minX = Math.min(minX, x);
            maxX = Math.max(maxX, x);
            minY = Math.min(minY, y);
            maxY = Math.max(maxY, y);
        }
        var fontSize = this.fontSize();
        return {
            x: minX - fontSize / 2,
            y: minY - fontSize / 2,
            width: maxX - minX + fontSize,
            height: maxY - minY + fontSize
        };
    }
    destroy() {
        $kWs5g.Util.releaseCanvas(this.dummyCanvas);
        return super.destroy();
    }
}
module.exports.TextPath = $da6dd7a345a1b906$var$TextPath;
$da6dd7a345a1b906$var$TextPath.prototype._fillFunc = $da6dd7a345a1b906$var$_fillFunc;
$da6dd7a345a1b906$var$TextPath.prototype._strokeFunc = $da6dd7a345a1b906$var$_strokeFunc;
$da6dd7a345a1b906$var$TextPath.prototype._fillFuncHit = $da6dd7a345a1b906$var$_fillFunc;
$da6dd7a345a1b906$var$TextPath.prototype._strokeFuncHit = $da6dd7a345a1b906$var$_strokeFunc;
$da6dd7a345a1b906$var$TextPath.prototype.className = "TextPath";
$da6dd7a345a1b906$var$TextPath.prototype._attrsAffectingSize = [
    "text",
    "fontSize",
    "data"
];
(0, $4v96z._registerNode)($da6dd7a345a1b906$var$TextPath);
$3V3su.Factory.addGetterSetter($da6dd7a345a1b906$var$TextPath, "data");
$3V3su.Factory.addGetterSetter($da6dd7a345a1b906$var$TextPath, "fontFamily", "Arial");
$3V3su.Factory.addGetterSetter($da6dd7a345a1b906$var$TextPath, "fontSize", 12, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($da6dd7a345a1b906$var$TextPath, "fontStyle", $da6dd7a345a1b906$var$NORMAL);
$3V3su.Factory.addGetterSetter($da6dd7a345a1b906$var$TextPath, "align", "left");
$3V3su.Factory.addGetterSetter($da6dd7a345a1b906$var$TextPath, "letterSpacing", 0, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($da6dd7a345a1b906$var$TextPath, "textBaseline", "middle");
$3V3su.Factory.addGetterSetter($da6dd7a345a1b906$var$TextPath, "fontVariant", $da6dd7a345a1b906$var$NORMAL);
$3V3su.Factory.addGetterSetter($da6dd7a345a1b906$var$TextPath, "text", $da6dd7a345a1b906$var$EMPTY_STRING);
$3V3su.Factory.addGetterSetter($da6dd7a345a1b906$var$TextPath, "textDecoration", null);
$3V3su.Factory.addGetterSetter($da6dd7a345a1b906$var$TextPath, "kerningFunc", null);

});

parcelRegister("aY3GY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Transformer = void 0;

var $kWs5g = parcelRequire("kWs5g");

var $3V3su = parcelRequire("3V3su");

var $1qU2E = parcelRequire("1qU2E");

var $82UKb = parcelRequire("82UKb");

var $frrTX = parcelRequire("frrTX");

var $4gbUw = parcelRequire("4gbUw");

var $4v96z = parcelRequire("4v96z");

var $2TXYV = parcelRequire("2TXYV");

var $4v96z = parcelRequire("4v96z");
var $020f85a9f399d602$var$EVENTS_NAME = "tr-konva";
var $020f85a9f399d602$var$ATTR_CHANGE_LIST = [
    "resizeEnabledChange",
    "rotateAnchorOffsetChange",
    "rotateEnabledChange",
    "enabledAnchorsChange",
    "anchorSizeChange",
    "borderEnabledChange",
    "borderStrokeChange",
    "borderStrokeWidthChange",
    "borderDashChange",
    "anchorStrokeChange",
    "anchorStrokeWidthChange",
    "anchorFillChange",
    "anchorCornerRadiusChange",
    "ignoreStrokeChange",
    "anchorStyleFuncChange"
].map((e)=>e + `.${$020f85a9f399d602$var$EVENTS_NAME}`).join(" ");
var $020f85a9f399d602$var$NODES_RECT = "nodesRect";
var $020f85a9f399d602$var$TRANSFORM_CHANGE_STR = [
    "widthChange",
    "heightChange",
    "scaleXChange",
    "scaleYChange",
    "skewXChange",
    "skewYChange",
    "rotationChange",
    "offsetXChange",
    "offsetYChange",
    "transformsEnabledChange",
    "strokeWidthChange"
];
var $020f85a9f399d602$var$ANGLES = {
    "top-left": -45,
    "top-center": 0,
    "top-right": 45,
    "middle-right": -90,
    "middle-left": 90,
    "bottom-left": -135,
    "bottom-center": 180,
    "bottom-right": 135
};
const $020f85a9f399d602$var$TOUCH_DEVICE = "ontouchstart" in $4v96z.Konva._global;
function $020f85a9f399d602$var$getCursor(anchorName, rad, rotateCursor) {
    if (anchorName === "rotater") return rotateCursor;
    rad += $kWs5g.Util.degToRad($020f85a9f399d602$var$ANGLES[anchorName] || 0);
    var angle = ($kWs5g.Util.radToDeg(rad) % 360 + 360) % 360;
    if ($kWs5g.Util._inRange(angle, 337.5, 360) || $kWs5g.Util._inRange(angle, 0, 22.5)) return "ns-resize";
    else if ($kWs5g.Util._inRange(angle, 22.5, 67.5)) return "nesw-resize";
    else if ($kWs5g.Util._inRange(angle, 67.5, 112.5)) return "ew-resize";
    else if ($kWs5g.Util._inRange(angle, 112.5, 157.5)) return "nwse-resize";
    else if ($kWs5g.Util._inRange(angle, 157.5, 202.5)) return "ns-resize";
    else if ($kWs5g.Util._inRange(angle, 202.5, 247.5)) return "nesw-resize";
    else if ($kWs5g.Util._inRange(angle, 247.5, 292.5)) return "ew-resize";
    else if ($kWs5g.Util._inRange(angle, 292.5, 337.5)) return "nwse-resize";
    else {
        $kWs5g.Util.error("Transformer has unknown angle for cursor detection: " + angle);
        return "pointer";
    }
}
var $020f85a9f399d602$var$ANCHORS_NAMES = [
    "top-left",
    "top-center",
    "top-right",
    "middle-right",
    "middle-left",
    "bottom-left",
    "bottom-center",
    "bottom-right"
];
var $020f85a9f399d602$var$MAX_SAFE_INTEGER = 100000000;
function $020f85a9f399d602$var$getCenter(shape) {
    return {
        x: shape.x + shape.width / 2 * Math.cos(shape.rotation) + shape.height / 2 * Math.sin(-shape.rotation),
        y: shape.y + shape.height / 2 * Math.cos(shape.rotation) + shape.width / 2 * Math.sin(shape.rotation)
    };
}
function $020f85a9f399d602$var$rotateAroundPoint(shape, angleRad, point) {
    const x = point.x + (shape.x - point.x) * Math.cos(angleRad) - (shape.y - point.y) * Math.sin(angleRad);
    const y = point.y + (shape.x - point.x) * Math.sin(angleRad) + (shape.y - point.y) * Math.cos(angleRad);
    return {
        ...shape,
        rotation: shape.rotation + angleRad,
        x: x,
        y: y
    };
}
function $020f85a9f399d602$var$rotateAroundCenter(shape, deltaRad) {
    const center = $020f85a9f399d602$var$getCenter(shape);
    return $020f85a9f399d602$var$rotateAroundPoint(shape, deltaRad, center);
}
function $020f85a9f399d602$var$getSnap(snaps, newRotationRad, tol) {
    let snapped = newRotationRad;
    for(let i = 0; i < snaps.length; i++){
        const angle = $4v96z.Konva.getAngle(snaps[i]);
        const absDiff = Math.abs(angle - newRotationRad) % (Math.PI * 2);
        const dif = Math.min(absDiff, Math.PI * 2 - absDiff);
        if (dif < tol) snapped = angle;
    }
    return snapped;
}
let $020f85a9f399d602$var$activeTransformersCount = 0;
class $020f85a9f399d602$var$Transformer extends $4gbUw.Group {
    constructor(config){
        super(config);
        this._movingAnchorName = null;
        this._transforming = false;
        this._createElements();
        this._handleMouseMove = this._handleMouseMove.bind(this);
        this._handleMouseUp = this._handleMouseUp.bind(this);
        this.update = this.update.bind(this);
        this.on($020f85a9f399d602$var$ATTR_CHANGE_LIST, this.update);
        if (this.getNode()) this.update();
    }
    attachTo(node) {
        this.setNode(node);
        return this;
    }
    setNode(node) {
        $kWs5g.Util.warn("tr.setNode(shape), tr.node(shape) and tr.attachTo(shape) methods are deprecated. Please use tr.nodes(nodesArray) instead.");
        return this.setNodes([
            node
        ]);
    }
    getNode() {
        return this._nodes && this._nodes[0];
    }
    _getEventNamespace() {
        return $020f85a9f399d602$var$EVENTS_NAME + this._id;
    }
    setNodes(nodes = []) {
        if (this._nodes && this._nodes.length) this.detach();
        const filteredNodes = nodes.filter((node)=>{
            if (node.isAncestorOf(this)) {
                $kWs5g.Util.error("Konva.Transformer cannot be an a child of the node you are trying to attach");
                return false;
            }
            return true;
        });
        this._nodes = nodes = filteredNodes;
        if (nodes.length === 1 && this.useSingleNodeRotation()) this.rotation(nodes[0].getAbsoluteRotation());
        else this.rotation(0);
        this._nodes.forEach((node)=>{
            const onChange = ()=>{
                if (this.nodes().length === 1 && this.useSingleNodeRotation()) this.rotation(this.nodes()[0].getAbsoluteRotation());
                this._resetTransformCache();
                if (!this._transforming && !this.isDragging()) this.update();
            };
            const additionalEvents = node._attrsAffectingSize.map((prop)=>prop + "Change." + this._getEventNamespace()).join(" ");
            node.on(additionalEvents, onChange);
            node.on($020f85a9f399d602$var$TRANSFORM_CHANGE_STR.map((e)=>e + `.${this._getEventNamespace()}`).join(" "), onChange);
            node.on(`absoluteTransformChange.${this._getEventNamespace()}`, onChange);
            this._proxyDrag(node);
        });
        this._resetTransformCache();
        var elementsCreated = !!this.findOne(".top-left");
        if (elementsCreated) this.update();
        return this;
    }
    _proxyDrag(node) {
        let lastPos;
        node.on(`dragstart.${this._getEventNamespace()}`, (e)=>{
            lastPos = node.getAbsolutePosition();
            if (!this.isDragging() && node !== this.findOne(".back")) this.startDrag(e, false);
        });
        node.on(`dragmove.${this._getEventNamespace()}`, (e)=>{
            if (!lastPos) return;
            const abs = node.getAbsolutePosition();
            const dx = abs.x - lastPos.x;
            const dy = abs.y - lastPos.y;
            this.nodes().forEach((otherNode)=>{
                if (otherNode === node) return;
                if (otherNode.isDragging()) return;
                const otherAbs = otherNode.getAbsolutePosition();
                otherNode.setAbsolutePosition({
                    x: otherAbs.x + dx,
                    y: otherAbs.y + dy
                });
                otherNode.startDrag(e);
            });
            lastPos = null;
        });
    }
    getNodes() {
        return this._nodes || [];
    }
    getActiveAnchor() {
        return this._movingAnchorName;
    }
    detach() {
        if (this._nodes) this._nodes.forEach((node)=>{
            node.off("." + this._getEventNamespace());
        });
        this._nodes = [];
        this._resetTransformCache();
    }
    _resetTransformCache() {
        this._clearCache($020f85a9f399d602$var$NODES_RECT);
        this._clearCache("transform");
        this._clearSelfAndDescendantCache("absoluteTransform");
    }
    _getNodeRect() {
        return this._getCache($020f85a9f399d602$var$NODES_RECT, this.__getNodeRect);
    }
    __getNodeShape(node, rot = this.rotation(), relative) {
        var rect = node.getClientRect({
            skipTransform: true,
            skipShadow: true,
            skipStroke: this.ignoreStroke()
        });
        var absScale = node.getAbsoluteScale(relative);
        var absPos = node.getAbsolutePosition(relative);
        var dx = rect.x * absScale.x - node.offsetX() * absScale.x;
        var dy = rect.y * absScale.y - node.offsetY() * absScale.y;
        const rotation = ($4v96z.Konva.getAngle(node.getAbsoluteRotation()) + Math.PI * 2) % (Math.PI * 2);
        const box = {
            x: absPos.x + dx * Math.cos(rotation) + dy * Math.sin(-rotation),
            y: absPos.y + dy * Math.cos(rotation) + dx * Math.sin(rotation),
            width: rect.width * absScale.x,
            height: rect.height * absScale.y,
            rotation: rotation
        };
        return $020f85a9f399d602$var$rotateAroundPoint(box, -$4v96z.Konva.getAngle(rot), {
            x: 0,
            y: 0
        });
    }
    __getNodeRect() {
        var node = this.getNode();
        if (!node) return {
            x: -$020f85a9f399d602$var$MAX_SAFE_INTEGER,
            y: -$020f85a9f399d602$var$MAX_SAFE_INTEGER,
            width: 0,
            height: 0,
            rotation: 0
        };
        const totalPoints = [];
        this.nodes().map((node)=>{
            const box = node.getClientRect({
                skipTransform: true,
                skipShadow: true,
                skipStroke: this.ignoreStroke()
            });
            var points = [
                {
                    x: box.x,
                    y: box.y
                },
                {
                    x: box.x + box.width,
                    y: box.y
                },
                {
                    x: box.x + box.width,
                    y: box.y + box.height
                },
                {
                    x: box.x,
                    y: box.y + box.height
                }
            ];
            var trans = node.getAbsoluteTransform();
            points.forEach(function(point) {
                var transformed = trans.point(point);
                totalPoints.push(transformed);
            });
        });
        const tr = new $kWs5g.Transform();
        tr.rotate(-$4v96z.Konva.getAngle(this.rotation()));
        var minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
        totalPoints.forEach(function(point) {
            var transformed = tr.point(point);
            if (minX === undefined) {
                minX = maxX = transformed.x;
                minY = maxY = transformed.y;
            }
            minX = Math.min(minX, transformed.x);
            minY = Math.min(minY, transformed.y);
            maxX = Math.max(maxX, transformed.x);
            maxY = Math.max(maxY, transformed.y);
        });
        tr.invert();
        const p = tr.point({
            x: minX,
            y: minY
        });
        return {
            x: p.x,
            y: p.y,
            width: maxX - minX,
            height: maxY - minY,
            rotation: $4v96z.Konva.getAngle(this.rotation())
        };
    }
    getX() {
        return this._getNodeRect().x;
    }
    getY() {
        return this._getNodeRect().y;
    }
    getWidth() {
        return this._getNodeRect().width;
    }
    getHeight() {
        return this._getNodeRect().height;
    }
    _createElements() {
        this._createBack();
        $020f85a9f399d602$var$ANCHORS_NAMES.forEach((name)=>{
            this._createAnchor(name);
        });
        this._createAnchor("rotater");
    }
    _createAnchor(name) {
        var anchor = new $frrTX.Rect({
            stroke: "rgb(0, 161, 255)",
            fill: "white",
            strokeWidth: 1,
            name: name + " _anchor",
            dragDistance: 0,
            draggable: true,
            hitStrokeWidth: $020f85a9f399d602$var$TOUCH_DEVICE ? 10 : "auto"
        });
        var self = this;
        anchor.on("mousedown touchstart", function(e) {
            self._handleMouseDown(e);
        });
        anchor.on("dragstart", (e)=>{
            anchor.stopDrag();
            e.cancelBubble = true;
        });
        anchor.on("dragend", (e)=>{
            e.cancelBubble = true;
        });
        anchor.on("mouseenter", ()=>{
            var rad = $4v96z.Konva.getAngle(this.rotation());
            var rotateCursor = this.rotateAnchorCursor();
            var cursor = $020f85a9f399d602$var$getCursor(name, rad, rotateCursor);
            anchor.getStage().content && (anchor.getStage().content.style.cursor = cursor);
            this._cursorChange = true;
        });
        anchor.on("mouseout", ()=>{
            anchor.getStage().content && (anchor.getStage().content.style.cursor = "");
            this._cursorChange = false;
        });
        this.add(anchor);
    }
    _createBack() {
        var back = new $82UKb.Shape({
            name: "back",
            width: 0,
            height: 0,
            draggable: true,
            sceneFunc (ctx, shape) {
                var tr = shape.getParent();
                var padding = tr.padding();
                ctx.beginPath();
                ctx.rect(-padding, -padding, shape.width() + padding * 2, shape.height() + padding * 2);
                ctx.moveTo(shape.width() / 2, -padding);
                if (tr.rotateEnabled() && tr.rotateLineVisible()) ctx.lineTo(shape.width() / 2, -tr.rotateAnchorOffset() * $kWs5g.Util._sign(shape.height()) - padding);
                ctx.fillStrokeShape(shape);
            },
            hitFunc: (ctx, shape)=>{
                if (!this.shouldOverdrawWholeArea()) return;
                var padding = this.padding();
                ctx.beginPath();
                ctx.rect(-padding, -padding, shape.width() + padding * 2, shape.height() + padding * 2);
                ctx.fillStrokeShape(shape);
            }
        });
        this.add(back);
        this._proxyDrag(back);
        back.on("dragstart", (e)=>{
            e.cancelBubble = true;
        });
        back.on("dragmove", (e)=>{
            e.cancelBubble = true;
        });
        back.on("dragend", (e)=>{
            e.cancelBubble = true;
        });
        this.on("dragmove", (e)=>{
            this.update();
        });
    }
    _handleMouseDown(e) {
        this._movingAnchorName = e.target.name().split(" ")[0];
        var attrs = this._getNodeRect();
        var width = attrs.width;
        var height = attrs.height;
        var hypotenuse = Math.sqrt(Math.pow(width, 2) + Math.pow(height, 2));
        this.sin = Math.abs(height / hypotenuse);
        this.cos = Math.abs(width / hypotenuse);
        if (typeof window !== "undefined") {
            window.addEventListener("mousemove", this._handleMouseMove);
            window.addEventListener("touchmove", this._handleMouseMove);
            window.addEventListener("mouseup", this._handleMouseUp, true);
            window.addEventListener("touchend", this._handleMouseUp, true);
        }
        this._transforming = true;
        var ap = e.target.getAbsolutePosition();
        var pos = e.target.getStage().getPointerPosition();
        this._anchorDragOffset = {
            x: pos.x - ap.x,
            y: pos.y - ap.y
        };
        $020f85a9f399d602$var$activeTransformersCount++;
        this._fire("transformstart", {
            evt: e.evt,
            target: this.getNode()
        });
        this._nodes.forEach((target)=>{
            target._fire("transformstart", {
                evt: e.evt,
                target: target
            });
        });
    }
    _handleMouseMove(e) {
        var x, y, newHypotenuse;
        var anchorNode = this.findOne("." + this._movingAnchorName);
        var stage = anchorNode.getStage();
        stage.setPointersPositions(e);
        const pp = stage.getPointerPosition();
        let newNodePos = {
            x: pp.x - this._anchorDragOffset.x,
            y: pp.y - this._anchorDragOffset.y
        };
        const oldAbs = anchorNode.getAbsolutePosition();
        if (this.anchorDragBoundFunc()) newNodePos = this.anchorDragBoundFunc()(oldAbs, newNodePos, e);
        anchorNode.setAbsolutePosition(newNodePos);
        const newAbs = anchorNode.getAbsolutePosition();
        if (oldAbs.x === newAbs.x && oldAbs.y === newAbs.y) return;
        if (this._movingAnchorName === "rotater") {
            var attrs = this._getNodeRect();
            x = anchorNode.x() - attrs.width / 2;
            y = -anchorNode.y() + attrs.height / 2;
            let delta = Math.atan2(-y, x) + Math.PI / 2;
            if (attrs.height < 0) delta -= Math.PI;
            var oldRotation = $4v96z.Konva.getAngle(this.rotation());
            const newRotation = oldRotation + delta;
            const tol = $4v96z.Konva.getAngle(this.rotationSnapTolerance());
            const snappedRot = $020f85a9f399d602$var$getSnap(this.rotationSnaps(), newRotation, tol);
            const diff = snappedRot - attrs.rotation;
            const shape = $020f85a9f399d602$var$rotateAroundCenter(attrs, diff);
            this._fitNodesInto(shape, e);
            return;
        }
        var shiftBehavior = this.shiftBehavior();
        var keepProportion;
        if (shiftBehavior === "inverted") keepProportion = this.keepRatio() && !e.shiftKey;
        else if (shiftBehavior === "none") keepProportion = this.keepRatio();
        else keepProportion = this.keepRatio() || e.shiftKey;
        var centeredScaling = this.centeredScaling() || e.altKey;
        if (this._movingAnchorName === "top-left") {
            if (keepProportion) {
                var comparePoint = centeredScaling ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this.findOne(".bottom-right").x(),
                    y: this.findOne(".bottom-right").y()
                };
                newHypotenuse = Math.sqrt(Math.pow(comparePoint.x - anchorNode.x(), 2) + Math.pow(comparePoint.y - anchorNode.y(), 2));
                var reverseX = this.findOne(".top-left").x() > comparePoint.x ? -1 : 1;
                var reverseY = this.findOne(".top-left").y() > comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                this.findOne(".top-left").x(comparePoint.x - x);
                this.findOne(".top-left").y(comparePoint.y - y);
            }
        } else if (this._movingAnchorName === "top-center") this.findOne(".top-left").y(anchorNode.y());
        else if (this._movingAnchorName === "top-right") {
            if (keepProportion) {
                var comparePoint = centeredScaling ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this.findOne(".bottom-left").x(),
                    y: this.findOne(".bottom-left").y()
                };
                newHypotenuse = Math.sqrt(Math.pow(anchorNode.x() - comparePoint.x, 2) + Math.pow(comparePoint.y - anchorNode.y(), 2));
                var reverseX = this.findOne(".top-right").x() < comparePoint.x ? -1 : 1;
                var reverseY = this.findOne(".top-right").y() > comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                this.findOne(".top-right").x(comparePoint.x + x);
                this.findOne(".top-right").y(comparePoint.y - y);
            }
            var pos = anchorNode.position();
            this.findOne(".top-left").y(pos.y);
            this.findOne(".bottom-right").x(pos.x);
        } else if (this._movingAnchorName === "middle-left") this.findOne(".top-left").x(anchorNode.x());
        else if (this._movingAnchorName === "middle-right") this.findOne(".bottom-right").x(anchorNode.x());
        else if (this._movingAnchorName === "bottom-left") {
            if (keepProportion) {
                var comparePoint = centeredScaling ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this.findOne(".top-right").x(),
                    y: this.findOne(".top-right").y()
                };
                newHypotenuse = Math.sqrt(Math.pow(comparePoint.x - anchorNode.x(), 2) + Math.pow(anchorNode.y() - comparePoint.y, 2));
                var reverseX = comparePoint.x < anchorNode.x() ? -1 : 1;
                var reverseY = anchorNode.y() < comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                anchorNode.x(comparePoint.x - x);
                anchorNode.y(comparePoint.y + y);
            }
            pos = anchorNode.position();
            this.findOne(".top-left").x(pos.x);
            this.findOne(".bottom-right").y(pos.y);
        } else if (this._movingAnchorName === "bottom-center") this.findOne(".bottom-right").y(anchorNode.y());
        else if (this._movingAnchorName === "bottom-right") {
            if (keepProportion) {
                var comparePoint = centeredScaling ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this.findOne(".top-left").x(),
                    y: this.findOne(".top-left").y()
                };
                newHypotenuse = Math.sqrt(Math.pow(anchorNode.x() - comparePoint.x, 2) + Math.pow(anchorNode.y() - comparePoint.y, 2));
                var reverseX = this.findOne(".bottom-right").x() < comparePoint.x ? -1 : 1;
                var reverseY = this.findOne(".bottom-right").y() < comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                this.findOne(".bottom-right").x(comparePoint.x + x);
                this.findOne(".bottom-right").y(comparePoint.y + y);
            }
        } else console.error(new Error("Wrong position argument of selection resizer: " + this._movingAnchorName));
        var centeredScaling = this.centeredScaling() || e.altKey;
        if (centeredScaling) {
            var topLeft = this.findOne(".top-left");
            var bottomRight = this.findOne(".bottom-right");
            var topOffsetX = topLeft.x();
            var topOffsetY = topLeft.y();
            var bottomOffsetX = this.getWidth() - bottomRight.x();
            var bottomOffsetY = this.getHeight() - bottomRight.y();
            bottomRight.move({
                x: -topOffsetX,
                y: -topOffsetY
            });
            topLeft.move({
                x: bottomOffsetX,
                y: bottomOffsetY
            });
        }
        var absPos = this.findOne(".top-left").getAbsolutePosition();
        x = absPos.x;
        y = absPos.y;
        var width = this.findOne(".bottom-right").x() - this.findOne(".top-left").x();
        var height = this.findOne(".bottom-right").y() - this.findOne(".top-left").y();
        this._fitNodesInto({
            x: x,
            y: y,
            width: width,
            height: height,
            rotation: $4v96z.Konva.getAngle(this.rotation())
        }, e);
    }
    _handleMouseUp(e) {
        this._removeEvents(e);
    }
    getAbsoluteTransform() {
        return this.getTransform();
    }
    _removeEvents(e) {
        var _a;
        if (this._transforming) {
            this._transforming = false;
            if (typeof window !== "undefined") {
                window.removeEventListener("mousemove", this._handleMouseMove);
                window.removeEventListener("touchmove", this._handleMouseMove);
                window.removeEventListener("mouseup", this._handleMouseUp, true);
                window.removeEventListener("touchend", this._handleMouseUp, true);
            }
            var node = this.getNode();
            $020f85a9f399d602$var$activeTransformersCount--;
            this._fire("transformend", {
                evt: e,
                target: node
            });
            (_a = this.getLayer()) === null || _a === void 0 || _a.batchDraw();
            if (node) this._nodes.forEach((target)=>{
                var _a;
                target._fire("transformend", {
                    evt: e,
                    target: target
                });
                (_a = target.getLayer()) === null || _a === void 0 || _a.batchDraw();
            });
            this._movingAnchorName = null;
        }
    }
    _fitNodesInto(newAttrs, evt) {
        var oldAttrs = this._getNodeRect();
        const minSize = 1;
        if ($kWs5g.Util._inRange(newAttrs.width, -this.padding() * 2 - minSize, minSize)) {
            this.update();
            return;
        }
        if ($kWs5g.Util._inRange(newAttrs.height, -this.padding() * 2 - minSize, minSize)) {
            this.update();
            return;
        }
        var t = new $kWs5g.Transform();
        t.rotate($4v96z.Konva.getAngle(this.rotation()));
        if (this._movingAnchorName && newAttrs.width < 0 && this._movingAnchorName.indexOf("left") >= 0) {
            const offset = t.point({
                x: -this.padding() * 2,
                y: 0
            });
            newAttrs.x += offset.x;
            newAttrs.y += offset.y;
            newAttrs.width += this.padding() * 2;
            this._movingAnchorName = this._movingAnchorName.replace("left", "right");
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
        } else if (this._movingAnchorName && newAttrs.width < 0 && this._movingAnchorName.indexOf("right") >= 0) {
            const offset = t.point({
                x: this.padding() * 2,
                y: 0
            });
            this._movingAnchorName = this._movingAnchorName.replace("right", "left");
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
            newAttrs.width += this.padding() * 2;
        }
        if (this._movingAnchorName && newAttrs.height < 0 && this._movingAnchorName.indexOf("top") >= 0) {
            const offset = t.point({
                x: 0,
                y: -this.padding() * 2
            });
            newAttrs.x += offset.x;
            newAttrs.y += offset.y;
            this._movingAnchorName = this._movingAnchorName.replace("top", "bottom");
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
            newAttrs.height += this.padding() * 2;
        } else if (this._movingAnchorName && newAttrs.height < 0 && this._movingAnchorName.indexOf("bottom") >= 0) {
            const offset = t.point({
                x: 0,
                y: this.padding() * 2
            });
            this._movingAnchorName = this._movingAnchorName.replace("bottom", "top");
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
            newAttrs.height += this.padding() * 2;
        }
        if (this.boundBoxFunc()) {
            const bounded = this.boundBoxFunc()(oldAttrs, newAttrs);
            if (bounded) newAttrs = bounded;
            else $kWs5g.Util.warn("boundBoxFunc returned falsy. You should return new bound rect from it!");
        }
        const baseSize = 10000000;
        const oldTr = new $kWs5g.Transform();
        oldTr.translate(oldAttrs.x, oldAttrs.y);
        oldTr.rotate(oldAttrs.rotation);
        oldTr.scale(oldAttrs.width / baseSize, oldAttrs.height / baseSize);
        const newTr = new $kWs5g.Transform();
        const newScaleX = newAttrs.width / baseSize;
        const newScaleY = newAttrs.height / baseSize;
        if (this.flipEnabled() === false) {
            newTr.translate(newAttrs.x, newAttrs.y);
            newTr.rotate(newAttrs.rotation);
            newTr.translate(newAttrs.width < 0 ? newAttrs.width : 0, newAttrs.height < 0 ? newAttrs.height : 0);
            newTr.scale(Math.abs(newScaleX), Math.abs(newScaleY));
        } else {
            newTr.translate(newAttrs.x, newAttrs.y);
            newTr.rotate(newAttrs.rotation);
            newTr.scale(newScaleX, newScaleY);
        }
        const delta = newTr.multiply(oldTr.invert());
        this._nodes.forEach((node)=>{
            var _a;
            const parentTransform = node.getParent().getAbsoluteTransform();
            const localTransform = node.getTransform().copy();
            localTransform.translate(node.offsetX(), node.offsetY());
            const newLocalTransform = new $kWs5g.Transform();
            newLocalTransform.multiply(parentTransform.copy().invert()).multiply(delta).multiply(parentTransform).multiply(localTransform);
            const attrs = newLocalTransform.decompose();
            node.setAttrs(attrs);
            (_a = node.getLayer()) === null || _a === void 0 || _a.batchDraw();
        });
        this.rotation($kWs5g.Util._getRotation(newAttrs.rotation));
        this._nodes.forEach((node)=>{
            this._fire("transform", {
                evt: evt,
                target: node
            });
            node._fire("transform", {
                evt: evt,
                target: node
            });
        });
        this._resetTransformCache();
        this.update();
        this.getLayer().batchDraw();
    }
    forceUpdate() {
        this._resetTransformCache();
        this.update();
    }
    _batchChangeChild(selector, attrs) {
        const anchor = this.findOne(selector);
        anchor.setAttrs(attrs);
    }
    update() {
        var _a;
        var attrs = this._getNodeRect();
        this.rotation($kWs5g.Util._getRotation(attrs.rotation));
        var width = attrs.width;
        var height = attrs.height;
        var enabledAnchors = this.enabledAnchors();
        var resizeEnabled = this.resizeEnabled();
        var padding = this.padding();
        var anchorSize = this.anchorSize();
        const anchors = this.find("._anchor");
        anchors.forEach((node)=>{
            node.setAttrs({
                width: anchorSize,
                height: anchorSize,
                offsetX: anchorSize / 2,
                offsetY: anchorSize / 2,
                stroke: this.anchorStroke(),
                strokeWidth: this.anchorStrokeWidth(),
                fill: this.anchorFill(),
                cornerRadius: this.anchorCornerRadius()
            });
        });
        this._batchChangeChild(".top-left", {
            x: 0,
            y: 0,
            offsetX: anchorSize / 2 + padding,
            offsetY: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf("top-left") >= 0
        });
        this._batchChangeChild(".top-center", {
            x: width / 2,
            y: 0,
            offsetY: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf("top-center") >= 0
        });
        this._batchChangeChild(".top-right", {
            x: width,
            y: 0,
            offsetX: anchorSize / 2 - padding,
            offsetY: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf("top-right") >= 0
        });
        this._batchChangeChild(".middle-left", {
            x: 0,
            y: height / 2,
            offsetX: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf("middle-left") >= 0
        });
        this._batchChangeChild(".middle-right", {
            x: width,
            y: height / 2,
            offsetX: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf("middle-right") >= 0
        });
        this._batchChangeChild(".bottom-left", {
            x: 0,
            y: height,
            offsetX: anchorSize / 2 + padding,
            offsetY: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf("bottom-left") >= 0
        });
        this._batchChangeChild(".bottom-center", {
            x: width / 2,
            y: height,
            offsetY: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf("bottom-center") >= 0
        });
        this._batchChangeChild(".bottom-right", {
            x: width,
            y: height,
            offsetX: anchorSize / 2 - padding,
            offsetY: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf("bottom-right") >= 0
        });
        this._batchChangeChild(".rotater", {
            x: width / 2,
            y: -this.rotateAnchorOffset() * $kWs5g.Util._sign(height) - padding,
            visible: this.rotateEnabled()
        });
        this._batchChangeChild(".back", {
            width: width,
            height: height,
            visible: this.borderEnabled(),
            stroke: this.borderStroke(),
            strokeWidth: this.borderStrokeWidth(),
            dash: this.borderDash(),
            x: 0,
            y: 0
        });
        const styleFunc = this.anchorStyleFunc();
        if (styleFunc) anchors.forEach((node)=>{
            styleFunc(node);
        });
        (_a = this.getLayer()) === null || _a === void 0 || _a.batchDraw();
    }
    isTransforming() {
        return this._transforming;
    }
    stopTransform() {
        if (this._transforming) {
            this._removeEvents();
            var anchorNode = this.findOne("." + this._movingAnchorName);
            if (anchorNode) anchorNode.stopDrag();
        }
    }
    destroy() {
        if (this.getStage() && this._cursorChange) this.getStage().content && (this.getStage().content.style.cursor = "");
        $4gbUw.Group.prototype.destroy.call(this);
        this.detach();
        this._removeEvents();
        return this;
    }
    toObject() {
        return $1qU2E.Node.prototype.toObject.call(this);
    }
    clone(obj) {
        var node = $1qU2E.Node.prototype.clone.call(this, obj);
        return node;
    }
    getClientRect() {
        if (this.nodes().length > 0) return super.getClientRect();
        else return {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
    }
}
module.exports.Transformer = $020f85a9f399d602$var$Transformer;
$020f85a9f399d602$var$Transformer.isTransforming = ()=>{
    return $020f85a9f399d602$var$activeTransformersCount > 0;
};
function $020f85a9f399d602$var$validateAnchors(val) {
    if (!(val instanceof Array)) $kWs5g.Util.warn("enabledAnchors value should be an array");
    if (val instanceof Array) val.forEach(function(name) {
        if ($020f85a9f399d602$var$ANCHORS_NAMES.indexOf(name) === -1) $kWs5g.Util.warn("Unknown anchor name: " + name + ". Available names are: " + $020f85a9f399d602$var$ANCHORS_NAMES.join(", "));
    });
    return val || [];
}
$020f85a9f399d602$var$Transformer.prototype.className = "Transformer";
(0, $4v96z._registerNode)($020f85a9f399d602$var$Transformer);
$3V3su.Factory.addGetterSetter($020f85a9f399d602$var$Transformer, "enabledAnchors", $020f85a9f399d602$var$ANCHORS_NAMES, $020f85a9f399d602$var$validateAnchors);
$3V3su.Factory.addGetterSetter($020f85a9f399d602$var$Transformer, "flipEnabled", true, (0, $2TXYV.getBooleanValidator)());
$3V3su.Factory.addGetterSetter($020f85a9f399d602$var$Transformer, "resizeEnabled", true);
$3V3su.Factory.addGetterSetter($020f85a9f399d602$var$Transformer, "anchorSize", 10, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($020f85a9f399d602$var$Transformer, "rotateEnabled", true);
$3V3su.Factory.addGetterSetter($020f85a9f399d602$var$Transformer, "rotateLineVisible", true);
$3V3su.Factory.addGetterSetter($020f85a9f399d602$var$Transformer, "rotationSnaps", []);
$3V3su.Factory.addGetterSetter($020f85a9f399d602$var$Transformer, "rotateAnchorOffset", 50, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($020f85a9f399d602$var$Transformer, "rotateAnchorCursor", "crosshair");
$3V3su.Factory.addGetterSetter($020f85a9f399d602$var$Transformer, "rotationSnapTolerance", 5, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($020f85a9f399d602$var$Transformer, "borderEnabled", true);
$3V3su.Factory.addGetterSetter($020f85a9f399d602$var$Transformer, "anchorStroke", "rgb(0, 161, 255)");
$3V3su.Factory.addGetterSetter($020f85a9f399d602$var$Transformer, "anchorStrokeWidth", 1, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($020f85a9f399d602$var$Transformer, "anchorFill", "white");
$3V3su.Factory.addGetterSetter($020f85a9f399d602$var$Transformer, "anchorCornerRadius", 0, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($020f85a9f399d602$var$Transformer, "borderStroke", "rgb(0, 161, 255)");
$3V3su.Factory.addGetterSetter($020f85a9f399d602$var$Transformer, "borderStrokeWidth", 1, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($020f85a9f399d602$var$Transformer, "borderDash");
$3V3su.Factory.addGetterSetter($020f85a9f399d602$var$Transformer, "keepRatio", true);
$3V3su.Factory.addGetterSetter($020f85a9f399d602$var$Transformer, "shiftBehavior", "default");
$3V3su.Factory.addGetterSetter($020f85a9f399d602$var$Transformer, "centeredScaling", false);
$3V3su.Factory.addGetterSetter($020f85a9f399d602$var$Transformer, "ignoreStroke", false);
$3V3su.Factory.addGetterSetter($020f85a9f399d602$var$Transformer, "padding", 0, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($020f85a9f399d602$var$Transformer, "node");
$3V3su.Factory.addGetterSetter($020f85a9f399d602$var$Transformer, "nodes");
$3V3su.Factory.addGetterSetter($020f85a9f399d602$var$Transformer, "boundBoxFunc");
$3V3su.Factory.addGetterSetter($020f85a9f399d602$var$Transformer, "anchorDragBoundFunc");
$3V3su.Factory.addGetterSetter($020f85a9f399d602$var$Transformer, "anchorStyleFunc");
$3V3su.Factory.addGetterSetter($020f85a9f399d602$var$Transformer, "shouldOverdrawWholeArea", false);
$3V3su.Factory.addGetterSetter($020f85a9f399d602$var$Transformer, "useSingleNodeRotation", true);
$3V3su.Factory.backCompat($020f85a9f399d602$var$Transformer, {
    lineEnabled: "borderEnabled",
    rotateHandlerOffset: "rotateAnchorOffset",
    enabledHandlers: "enabledAnchors"
});

});

parcelRegister("6NrOY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Wedge = void 0;

var $3V3su = parcelRequire("3V3su");

var $82UKb = parcelRequire("82UKb");

var $4v96z = parcelRequire("4v96z");

var $2TXYV = parcelRequire("2TXYV");

var $4v96z = parcelRequire("4v96z");
class $4f2ce65ce1d8cf82$var$Wedge extends $82UKb.Shape {
    _sceneFunc(context) {
        context.beginPath();
        context.arc(0, 0, this.radius(), 0, $4v96z.Konva.getAngle(this.angle()), this.clockwise());
        context.lineTo(0, 0);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.radius() * 2;
    }
    getHeight() {
        return this.radius() * 2;
    }
    setWidth(width) {
        this.radius(width / 2);
    }
    setHeight(height) {
        this.radius(height / 2);
    }
}
module.exports.Wedge = $4f2ce65ce1d8cf82$var$Wedge;
$4f2ce65ce1d8cf82$var$Wedge.prototype.className = "Wedge";
$4f2ce65ce1d8cf82$var$Wedge.prototype._centroid = true;
$4f2ce65ce1d8cf82$var$Wedge.prototype._attrsAffectingSize = [
    "radius"
];
(0, $4v96z._registerNode)($4f2ce65ce1d8cf82$var$Wedge);
$3V3su.Factory.addGetterSetter($4f2ce65ce1d8cf82$var$Wedge, "radius", 0, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($4f2ce65ce1d8cf82$var$Wedge, "angle", 0, (0, $2TXYV.getNumberValidator)());
$3V3su.Factory.addGetterSetter($4f2ce65ce1d8cf82$var$Wedge, "clockwise", false);
$3V3su.Factory.backCompat($4f2ce65ce1d8cf82$var$Wedge, {
    angleDeg: "angle",
    getAngleDeg: "getAngle",
    setAngleDeg: "setAngle"
});

});

parcelRegister("kd1un", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Blur = void 0;

var $3V3su = parcelRequire("3V3su");

var $1qU2E = parcelRequire("1qU2E");

var $2TXYV = parcelRequire("2TXYV");
function $eb662d394c901ba9$var$BlurStack() {
    this.r = 0;
    this.g = 0;
    this.b = 0;
    this.a = 0;
    this.next = null;
}
var $eb662d394c901ba9$var$mul_table = [
    512,
    512,
    456,
    512,
    328,
    456,
    335,
    512,
    405,
    328,
    271,
    456,
    388,
    335,
    292,
    512,
    454,
    405,
    364,
    328,
    298,
    271,
    496,
    456,
    420,
    388,
    360,
    335,
    312,
    292,
    273,
    512,
    482,
    454,
    428,
    405,
    383,
    364,
    345,
    328,
    312,
    298,
    284,
    271,
    259,
    496,
    475,
    456,
    437,
    420,
    404,
    388,
    374,
    360,
    347,
    335,
    323,
    312,
    302,
    292,
    282,
    273,
    265,
    512,
    497,
    482,
    468,
    454,
    441,
    428,
    417,
    405,
    394,
    383,
    373,
    364,
    354,
    345,
    337,
    328,
    320,
    312,
    305,
    298,
    291,
    284,
    278,
    271,
    265,
    259,
    507,
    496,
    485,
    475,
    465,
    456,
    446,
    437,
    428,
    420,
    412,
    404,
    396,
    388,
    381,
    374,
    367,
    360,
    354,
    347,
    341,
    335,
    329,
    323,
    318,
    312,
    307,
    302,
    297,
    292,
    287,
    282,
    278,
    273,
    269,
    265,
    261,
    512,
    505,
    497,
    489,
    482,
    475,
    468,
    461,
    454,
    447,
    441,
    435,
    428,
    422,
    417,
    411,
    405,
    399,
    394,
    389,
    383,
    378,
    373,
    368,
    364,
    359,
    354,
    350,
    345,
    341,
    337,
    332,
    328,
    324,
    320,
    316,
    312,
    309,
    305,
    301,
    298,
    294,
    291,
    287,
    284,
    281,
    278,
    274,
    271,
    268,
    265,
    262,
    259,
    257,
    507,
    501,
    496,
    491,
    485,
    480,
    475,
    470,
    465,
    460,
    456,
    451,
    446,
    442,
    437,
    433,
    428,
    424,
    420,
    416,
    412,
    408,
    404,
    400,
    396,
    392,
    388,
    385,
    381,
    377,
    374,
    370,
    367,
    363,
    360,
    357,
    354,
    350,
    347,
    344,
    341,
    338,
    335,
    332,
    329,
    326,
    323,
    320,
    318,
    315,
    312,
    310,
    307,
    304,
    302,
    299,
    297,
    294,
    292,
    289,
    287,
    285,
    282,
    280,
    278,
    275,
    273,
    271,
    269,
    267,
    265,
    263,
    261,
    259
];
var $eb662d394c901ba9$var$shg_table = [
    9,
    11,
    12,
    13,
    13,
    14,
    14,
    15,
    15,
    15,
    15,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24
];
function $eb662d394c901ba9$var$filterGaussBlurRGBA(imageData, radius) {
    var pixels = imageData.data, width = imageData.width, height = imageData.height;
    var x, y, i, p, yp, yi, yw, r_sum, g_sum, b_sum, a_sum, r_out_sum, g_out_sum, b_out_sum, a_out_sum, r_in_sum, g_in_sum, b_in_sum, a_in_sum, pr, pg, pb, pa, rbs;
    var div = radius + radius + 1, widthMinus1 = width - 1, heightMinus1 = height - 1, radiusPlus1 = radius + 1, sumFactor = radiusPlus1 * (radiusPlus1 + 1) / 2, stackStart = new $eb662d394c901ba9$var$BlurStack(), stackEnd = null, stack = stackStart, stackIn = null, stackOut = null, mul_sum = $eb662d394c901ba9$var$mul_table[radius], shg_sum = $eb662d394c901ba9$var$shg_table[radius];
    for(i = 1; i < div; i++){
        stack = stack.next = new $eb662d394c901ba9$var$BlurStack();
        if (i === radiusPlus1) stackEnd = stack;
    }
    stack.next = stackStart;
    yw = yi = 0;
    for(y = 0; y < height; y++){
        r_in_sum = g_in_sum = b_in_sum = a_in_sum = r_sum = g_sum = b_sum = a_sum = 0;
        r_out_sum = radiusPlus1 * (pr = pixels[yi]);
        g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
        b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
        a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);
        r_sum += sumFactor * pr;
        g_sum += sumFactor * pg;
        b_sum += sumFactor * pb;
        a_sum += sumFactor * pa;
        stack = stackStart;
        for(i = 0; i < radiusPlus1; i++){
            stack.r = pr;
            stack.g = pg;
            stack.b = pb;
            stack.a = pa;
            stack = stack.next;
        }
        for(i = 1; i < radiusPlus1; i++){
            p = yi + ((widthMinus1 < i ? widthMinus1 : i) << 2);
            r_sum += (stack.r = pr = pixels[p]) * (rbs = radiusPlus1 - i);
            g_sum += (stack.g = pg = pixels[p + 1]) * rbs;
            b_sum += (stack.b = pb = pixels[p + 2]) * rbs;
            a_sum += (stack.a = pa = pixels[p + 3]) * rbs;
            r_in_sum += pr;
            g_in_sum += pg;
            b_in_sum += pb;
            a_in_sum += pa;
            stack = stack.next;
        }
        stackIn = stackStart;
        stackOut = stackEnd;
        for(x = 0; x < width; x++){
            pixels[yi + 3] = pa = a_sum * mul_sum >> shg_sum;
            if (pa !== 0) {
                pa = 255 / pa;
                pixels[yi] = (r_sum * mul_sum >> shg_sum) * pa;
                pixels[yi + 1] = (g_sum * mul_sum >> shg_sum) * pa;
                pixels[yi + 2] = (b_sum * mul_sum >> shg_sum) * pa;
            } else pixels[yi] = pixels[yi + 1] = pixels[yi + 2] = 0;
            r_sum -= r_out_sum;
            g_sum -= g_out_sum;
            b_sum -= b_out_sum;
            a_sum -= a_out_sum;
            r_out_sum -= stackIn.r;
            g_out_sum -= stackIn.g;
            b_out_sum -= stackIn.b;
            a_out_sum -= stackIn.a;
            p = yw + ((p = x + radius + 1) < widthMinus1 ? p : widthMinus1) << 2;
            r_in_sum += stackIn.r = pixels[p];
            g_in_sum += stackIn.g = pixels[p + 1];
            b_in_sum += stackIn.b = pixels[p + 2];
            a_in_sum += stackIn.a = pixels[p + 3];
            r_sum += r_in_sum;
            g_sum += g_in_sum;
            b_sum += b_in_sum;
            a_sum += a_in_sum;
            stackIn = stackIn.next;
            r_out_sum += pr = stackOut.r;
            g_out_sum += pg = stackOut.g;
            b_out_sum += pb = stackOut.b;
            a_out_sum += pa = stackOut.a;
            r_in_sum -= pr;
            g_in_sum -= pg;
            b_in_sum -= pb;
            a_in_sum -= pa;
            stackOut = stackOut.next;
            yi += 4;
        }
        yw += width;
    }
    for(x = 0; x < width; x++){
        g_in_sum = b_in_sum = a_in_sum = r_in_sum = g_sum = b_sum = a_sum = r_sum = 0;
        yi = x << 2;
        r_out_sum = radiusPlus1 * (pr = pixels[yi]);
        g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
        b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
        a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);
        r_sum += sumFactor * pr;
        g_sum += sumFactor * pg;
        b_sum += sumFactor * pb;
        a_sum += sumFactor * pa;
        stack = stackStart;
        for(i = 0; i < radiusPlus1; i++){
            stack.r = pr;
            stack.g = pg;
            stack.b = pb;
            stack.a = pa;
            stack = stack.next;
        }
        yp = width;
        for(i = 1; i <= radius; i++){
            yi = yp + x << 2;
            r_sum += (stack.r = pr = pixels[yi]) * (rbs = radiusPlus1 - i);
            g_sum += (stack.g = pg = pixels[yi + 1]) * rbs;
            b_sum += (stack.b = pb = pixels[yi + 2]) * rbs;
            a_sum += (stack.a = pa = pixels[yi + 3]) * rbs;
            r_in_sum += pr;
            g_in_sum += pg;
            b_in_sum += pb;
            a_in_sum += pa;
            stack = stack.next;
            if (i < heightMinus1) yp += width;
        }
        yi = x;
        stackIn = stackStart;
        stackOut = stackEnd;
        for(y = 0; y < height; y++){
            p = yi << 2;
            pixels[p + 3] = pa = a_sum * mul_sum >> shg_sum;
            if (pa > 0) {
                pa = 255 / pa;
                pixels[p] = (r_sum * mul_sum >> shg_sum) * pa;
                pixels[p + 1] = (g_sum * mul_sum >> shg_sum) * pa;
                pixels[p + 2] = (b_sum * mul_sum >> shg_sum) * pa;
            } else pixels[p] = pixels[p + 1] = pixels[p + 2] = 0;
            r_sum -= r_out_sum;
            g_sum -= g_out_sum;
            b_sum -= b_out_sum;
            a_sum -= a_out_sum;
            r_out_sum -= stackIn.r;
            g_out_sum -= stackIn.g;
            b_out_sum -= stackIn.b;
            a_out_sum -= stackIn.a;
            p = x + ((p = y + radiusPlus1) < heightMinus1 ? p : heightMinus1) * width << 2;
            r_sum += r_in_sum += stackIn.r = pixels[p];
            g_sum += g_in_sum += stackIn.g = pixels[p + 1];
            b_sum += b_in_sum += stackIn.b = pixels[p + 2];
            a_sum += a_in_sum += stackIn.a = pixels[p + 3];
            stackIn = stackIn.next;
            r_out_sum += pr = stackOut.r;
            g_out_sum += pg = stackOut.g;
            b_out_sum += pb = stackOut.b;
            a_out_sum += pa = stackOut.a;
            r_in_sum -= pr;
            g_in_sum -= pg;
            b_in_sum -= pb;
            a_in_sum -= pa;
            stackOut = stackOut.next;
            yi += width;
        }
    }
}
const $eb662d394c901ba9$var$Blur = function Blur(imageData) {
    var radius = Math.round(this.blurRadius());
    if (radius > 0) $eb662d394c901ba9$var$filterGaussBlurRGBA(imageData, radius);
};
module.exports.Blur = $eb662d394c901ba9$var$Blur;
$3V3su.Factory.addGetterSetter($1qU2E.Node, "blurRadius", 0, (0, $2TXYV.getNumberValidator)(), $3V3su.Factory.afterSetFilter);

});

parcelRegister("gQWeB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Brighten = void 0;

var $3V3su = parcelRequire("3V3su");

var $1qU2E = parcelRequire("1qU2E");

var $2TXYV = parcelRequire("2TXYV");
const $c44eacd4197cc28b$var$Brighten = function(imageData) {
    var brightness = this.brightness() * 255, data = imageData.data, len = data.length, i;
    for(i = 0; i < len; i += 4){
        data[i] += brightness;
        data[i + 1] += brightness;
        data[i + 2] += brightness;
    }
};
module.exports.Brighten = $c44eacd4197cc28b$var$Brighten;
$3V3su.Factory.addGetterSetter($1qU2E.Node, "brightness", 0, (0, $2TXYV.getNumberValidator)(), $3V3su.Factory.afterSetFilter);

});

parcelRegister("1aAid", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Contrast = void 0;

var $3V3su = parcelRequire("3V3su");

var $1qU2E = parcelRequire("1qU2E");

var $2TXYV = parcelRequire("2TXYV");
const $0da2e0a1c7512c5a$var$Contrast = function(imageData) {
    var adjust = Math.pow((this.contrast() + 100) / 100, 2);
    var data = imageData.data, nPixels = data.length, red = 150, green = 150, blue = 150, i;
    for(i = 0; i < nPixels; i += 4){
        red = data[i];
        green = data[i + 1];
        blue = data[i + 2];
        red /= 255;
        red -= 0.5;
        red *= adjust;
        red += 0.5;
        red *= 255;
        green /= 255;
        green -= 0.5;
        green *= adjust;
        green += 0.5;
        green *= 255;
        blue /= 255;
        blue -= 0.5;
        blue *= adjust;
        blue += 0.5;
        blue *= 255;
        red = red < 0 ? 0 : red > 255 ? 255 : red;
        green = green < 0 ? 0 : green > 255 ? 255 : green;
        blue = blue < 0 ? 0 : blue > 255 ? 255 : blue;
        data[i] = red;
        data[i + 1] = green;
        data[i + 2] = blue;
    }
};
module.exports.Contrast = $0da2e0a1c7512c5a$var$Contrast;
$3V3su.Factory.addGetterSetter($1qU2E.Node, "contrast", 0, (0, $2TXYV.getNumberValidator)(), $3V3su.Factory.afterSetFilter);

});

parcelRegister("5iinf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Emboss = void 0;

var $3V3su = parcelRequire("3V3su");

var $1qU2E = parcelRequire("1qU2E");

var $kWs5g = parcelRequire("kWs5g");

var $2TXYV = parcelRequire("2TXYV");
const $3dace2e64b8f777c$var$Emboss = function(imageData) {
    var strength = this.embossStrength() * 10, greyLevel = this.embossWhiteLevel() * 255, direction = this.embossDirection(), blend = this.embossBlend(), dirY = 0, dirX = 0, data = imageData.data, w = imageData.width, h = imageData.height, w4 = w * 4, y = h;
    switch(direction){
        case "top-left":
            dirY = -1;
            dirX = -1;
            break;
        case "top":
            dirY = -1;
            dirX = 0;
            break;
        case "top-right":
            dirY = -1;
            dirX = 1;
            break;
        case "right":
            dirY = 0;
            dirX = 1;
            break;
        case "bottom-right":
            dirY = 1;
            dirX = 1;
            break;
        case "bottom":
            dirY = 1;
            dirX = 0;
            break;
        case "bottom-left":
            dirY = 1;
            dirX = -1;
            break;
        case "left":
            dirY = 0;
            dirX = -1;
            break;
        default:
            $kWs5g.Util.error("Unknown emboss direction: " + direction);
    }
    do {
        var offsetY = (y - 1) * w4;
        var otherY = dirY;
        if (y + otherY < 1) otherY = 0;
        if (y + otherY > h) otherY = 0;
        var offsetYOther = (y - 1 + otherY) * w * 4;
        var x = w;
        do {
            var offset = offsetY + (x - 1) * 4;
            var otherX = dirX;
            if (x + otherX < 1) otherX = 0;
            if (x + otherX > w) otherX = 0;
            var offsetOther = offsetYOther + (x - 1 + otherX) * 4;
            var dR = data[offset] - data[offsetOther];
            var dG = data[offset + 1] - data[offsetOther + 1];
            var dB = data[offset + 2] - data[offsetOther + 2];
            var dif = dR;
            var absDif = dif > 0 ? dif : -dif;
            var absG = dG > 0 ? dG : -dG;
            var absB = dB > 0 ? dB : -dB;
            if (absG > absDif) dif = dG;
            if (absB > absDif) dif = dB;
            dif *= strength;
            if (blend) {
                var r = data[offset] + dif;
                var g = data[offset + 1] + dif;
                var b = data[offset + 2] + dif;
                data[offset] = r > 255 ? 255 : r < 0 ? 0 : r;
                data[offset + 1] = g > 255 ? 255 : g < 0 ? 0 : g;
                data[offset + 2] = b > 255 ? 255 : b < 0 ? 0 : b;
            } else {
                var grey = greyLevel - dif;
                if (grey < 0) grey = 0;
                else if (grey > 255) grey = 255;
                data[offset] = data[offset + 1] = data[offset + 2] = grey;
            }
        }while (--x);
    }while (--y);
};
module.exports.Emboss = $3dace2e64b8f777c$var$Emboss;
$3V3su.Factory.addGetterSetter($1qU2E.Node, "embossStrength", 0.5, (0, $2TXYV.getNumberValidator)(), $3V3su.Factory.afterSetFilter);
$3V3su.Factory.addGetterSetter($1qU2E.Node, "embossWhiteLevel", 0.5, (0, $2TXYV.getNumberValidator)(), $3V3su.Factory.afterSetFilter);
$3V3su.Factory.addGetterSetter($1qU2E.Node, "embossDirection", "top-left", null, $3V3su.Factory.afterSetFilter);
$3V3su.Factory.addGetterSetter($1qU2E.Node, "embossBlend", false, null, $3V3su.Factory.afterSetFilter);

});

parcelRegister("6skQr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Enhance = void 0;

var $3V3su = parcelRequire("3V3su");

var $1qU2E = parcelRequire("1qU2E");

var $2TXYV = parcelRequire("2TXYV");
function $4b3586f013a7fbde$var$remap(fromValue, fromMin, fromMax, toMin, toMax) {
    var fromRange = fromMax - fromMin, toRange = toMax - toMin, toValue;
    if (fromRange === 0) return toMin + toRange / 2;
    if (toRange === 0) return toMin;
    toValue = (fromValue - fromMin) / fromRange;
    toValue = toRange * toValue + toMin;
    return toValue;
}
const $4b3586f013a7fbde$var$Enhance = function(imageData) {
    var data = imageData.data, nSubPixels = data.length, rMin = data[0], rMax = rMin, r, gMin = data[1], gMax = gMin, g, bMin = data[2], bMax = bMin, b, i;
    var enhanceAmount = this.enhance();
    if (enhanceAmount === 0) return;
    for(i = 0; i < nSubPixels; i += 4){
        r = data[i + 0];
        if (r < rMin) rMin = r;
        else if (r > rMax) rMax = r;
        g = data[i + 1];
        if (g < gMin) gMin = g;
        else if (g > gMax) gMax = g;
        b = data[i + 2];
        if (b < bMin) bMin = b;
        else if (b > bMax) bMax = b;
    }
    if (rMax === rMin) {
        rMax = 255;
        rMin = 0;
    }
    if (gMax === gMin) {
        gMax = 255;
        gMin = 0;
    }
    if (bMax === bMin) {
        bMax = 255;
        bMin = 0;
    }
    var rMid, rGoalMax, rGoalMin, gMid, gGoalMax, gGoalMin, bMid, bGoalMax, bGoalMin;
    if (enhanceAmount > 0) {
        rGoalMax = rMax + enhanceAmount * (255 - rMax);
        rGoalMin = rMin - enhanceAmount * (rMin - 0);
        gGoalMax = gMax + enhanceAmount * (255 - gMax);
        gGoalMin = gMin - enhanceAmount * (gMin - 0);
        bGoalMax = bMax + enhanceAmount * (255 - bMax);
        bGoalMin = bMin - enhanceAmount * (bMin - 0);
    } else {
        rMid = (rMax + rMin) * 0.5;
        rGoalMax = rMax + enhanceAmount * (rMax - rMid);
        rGoalMin = rMin + enhanceAmount * (rMin - rMid);
        gMid = (gMax + gMin) * 0.5;
        gGoalMax = gMax + enhanceAmount * (gMax - gMid);
        gGoalMin = gMin + enhanceAmount * (gMin - gMid);
        bMid = (bMax + bMin) * 0.5;
        bGoalMax = bMax + enhanceAmount * (bMax - bMid);
        bGoalMin = bMin + enhanceAmount * (bMin - bMid);
    }
    for(i = 0; i < nSubPixels; i += 4){
        data[i + 0] = $4b3586f013a7fbde$var$remap(data[i + 0], rMin, rMax, rGoalMin, rGoalMax);
        data[i + 1] = $4b3586f013a7fbde$var$remap(data[i + 1], gMin, gMax, gGoalMin, gGoalMax);
        data[i + 2] = $4b3586f013a7fbde$var$remap(data[i + 2], bMin, bMax, bGoalMin, bGoalMax);
    }
};
module.exports.Enhance = $4b3586f013a7fbde$var$Enhance;
$3V3su.Factory.addGetterSetter($1qU2E.Node, "enhance", 0, (0, $2TXYV.getNumberValidator)(), $3V3su.Factory.afterSetFilter);

});

parcelRegister("kBAEq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Grayscale = void 0;
const $f003b176233c038c$var$Grayscale = function(imageData) {
    var data = imageData.data, len = data.length, i, brightness;
    for(i = 0; i < len; i += 4){
        brightness = 0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2];
        data[i] = brightness;
        data[i + 1] = brightness;
        data[i + 2] = brightness;
    }
};
module.exports.Grayscale = $f003b176233c038c$var$Grayscale;

});

parcelRegister("iqULT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HSL = void 0;

var $3V3su = parcelRequire("3V3su");

var $1qU2E = parcelRequire("1qU2E");

var $2TXYV = parcelRequire("2TXYV");
$3V3su.Factory.addGetterSetter($1qU2E.Node, "hue", 0, (0, $2TXYV.getNumberValidator)(), $3V3su.Factory.afterSetFilter);
$3V3su.Factory.addGetterSetter($1qU2E.Node, "saturation", 0, (0, $2TXYV.getNumberValidator)(), $3V3su.Factory.afterSetFilter);
$3V3su.Factory.addGetterSetter($1qU2E.Node, "luminance", 0, (0, $2TXYV.getNumberValidator)(), $3V3su.Factory.afterSetFilter);
const $d6b6b157b1ac99bd$var$HSL = function(imageData) {
    var data = imageData.data, nPixels = data.length, v = 1, s = Math.pow(2, this.saturation()), h = Math.abs(this.hue() + 360) % 360, l = this.luminance() * 127, i;
    var vsu = v * s * Math.cos(h * Math.PI / 180), vsw = v * s * Math.sin(h * Math.PI / 180);
    var rr = 0.299 * v + 0.701 * vsu + 0.167 * vsw, rg = 0.587 * v - 0.587 * vsu + 0.33 * vsw, rb = 0.114 * v - 0.114 * vsu - 0.497 * vsw;
    var gr = 0.299 * v - 0.299 * vsu - 0.328 * vsw, gg = 0.587 * v + 0.413 * vsu + 0.035 * vsw, gb = 0.114 * v - 0.114 * vsu + 0.293 * vsw;
    var br = 0.299 * v - 0.3 * vsu + 1.25 * vsw, bg = 0.587 * v - 0.586 * vsu - 1.05 * vsw, bb = 0.114 * v + 0.886 * vsu - 0.2 * vsw;
    var r, g, b, a;
    for(i = 0; i < nPixels; i += 4){
        r = data[i + 0];
        g = data[i + 1];
        b = data[i + 2];
        a = data[i + 3];
        data[i + 0] = rr * r + rg * g + rb * b + l;
        data[i + 1] = gr * r + gg * g + gb * b + l;
        data[i + 2] = br * r + bg * g + bb * b + l;
        data[i + 3] = a;
    }
};
module.exports.HSL = $d6b6b157b1ac99bd$var$HSL;

});

parcelRegister("aBbcJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HSV = void 0;

var $3V3su = parcelRequire("3V3su");

var $1qU2E = parcelRequire("1qU2E");

var $2TXYV = parcelRequire("2TXYV");
const $7b760d0cbe813232$var$HSV = function(imageData) {
    var data = imageData.data, nPixels = data.length, v = Math.pow(2, this.value()), s = Math.pow(2, this.saturation()), h = Math.abs(this.hue() + 360) % 360, i;
    var vsu = v * s * Math.cos(h * Math.PI / 180), vsw = v * s * Math.sin(h * Math.PI / 180);
    var rr = 0.299 * v + 0.701 * vsu + 0.167 * vsw, rg = 0.587 * v - 0.587 * vsu + 0.33 * vsw, rb = 0.114 * v - 0.114 * vsu - 0.497 * vsw;
    var gr = 0.299 * v - 0.299 * vsu - 0.328 * vsw, gg = 0.587 * v + 0.413 * vsu + 0.035 * vsw, gb = 0.114 * v - 0.114 * vsu + 0.293 * vsw;
    var br = 0.299 * v - 0.3 * vsu + 1.25 * vsw, bg = 0.587 * v - 0.586 * vsu - 1.05 * vsw, bb = 0.114 * v + 0.886 * vsu - 0.2 * vsw;
    var r, g, b, a;
    for(i = 0; i < nPixels; i += 4){
        r = data[i + 0];
        g = data[i + 1];
        b = data[i + 2];
        a = data[i + 3];
        data[i + 0] = rr * r + rg * g + rb * b;
        data[i + 1] = gr * r + gg * g + gb * b;
        data[i + 2] = br * r + bg * g + bb * b;
        data[i + 3] = a;
    }
};
module.exports.HSV = $7b760d0cbe813232$var$HSV;
$3V3su.Factory.addGetterSetter($1qU2E.Node, "hue", 0, (0, $2TXYV.getNumberValidator)(), $3V3su.Factory.afterSetFilter);
$3V3su.Factory.addGetterSetter($1qU2E.Node, "saturation", 0, (0, $2TXYV.getNumberValidator)(), $3V3su.Factory.afterSetFilter);
$3V3su.Factory.addGetterSetter($1qU2E.Node, "value", 0, (0, $2TXYV.getNumberValidator)(), $3V3su.Factory.afterSetFilter);

});

parcelRegister("inCrd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Invert = void 0;
const $d61830ef7667da27$var$Invert = function(imageData) {
    var data = imageData.data, len = data.length, i;
    for(i = 0; i < len; i += 4){
        data[i] = 255 - data[i];
        data[i + 1] = 255 - data[i + 1];
        data[i + 2] = 255 - data[i + 2];
    }
};
module.exports.Invert = $d61830ef7667da27$var$Invert;

});

parcelRegister("8YRg7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Kaleidoscope = void 0;

var $3V3su = parcelRequire("3V3su");

var $1qU2E = parcelRequire("1qU2E");

var $kWs5g = parcelRequire("kWs5g");

var $2TXYV = parcelRequire("2TXYV");
var $689d3d7812c8bdcb$var$ToPolar = function(src, dst, opt) {
    var srcPixels = src.data, dstPixels = dst.data, xSize = src.width, ySize = src.height, xMid = opt.polarCenterX || xSize / 2, yMid = opt.polarCenterY || ySize / 2, i, x, y, r = 0, g = 0, b = 0, a = 0;
    var rad, rMax = Math.sqrt(xMid * xMid + yMid * yMid);
    x = xSize - xMid;
    y = ySize - yMid;
    rad = Math.sqrt(x * x + y * y);
    rMax = rad > rMax ? rad : rMax;
    var rSize = ySize, tSize = xSize, radius, theta;
    var conversion = 360 / tSize * Math.PI / 180, sin, cos;
    for(theta = 0; theta < tSize; theta += 1){
        sin = Math.sin(theta * conversion);
        cos = Math.cos(theta * conversion);
        for(radius = 0; radius < rSize; radius += 1){
            x = Math.floor(xMid + rMax * radius / rSize * cos);
            y = Math.floor(yMid + rMax * radius / rSize * sin);
            i = (y * xSize + x) * 4;
            r = srcPixels[i + 0];
            g = srcPixels[i + 1];
            b = srcPixels[i + 2];
            a = srcPixels[i + 3];
            i = (theta + radius * xSize) * 4;
            dstPixels[i + 0] = r;
            dstPixels[i + 1] = g;
            dstPixels[i + 2] = b;
            dstPixels[i + 3] = a;
        }
    }
};
var $689d3d7812c8bdcb$var$FromPolar = function(src, dst, opt) {
    var srcPixels = src.data, dstPixels = dst.data, xSize = src.width, ySize = src.height, xMid = opt.polarCenterX || xSize / 2, yMid = opt.polarCenterY || ySize / 2, i, x, y, dx, dy, r = 0, g = 0, b = 0, a = 0;
    var rad, rMax = Math.sqrt(xMid * xMid + yMid * yMid);
    x = xSize - xMid;
    y = ySize - yMid;
    rad = Math.sqrt(x * x + y * y);
    rMax = rad > rMax ? rad : rMax;
    var rSize = ySize, tSize = xSize, radius, theta, phaseShift = opt.polarRotation || 0;
    var x1, y1;
    for(x = 0; x < xSize; x += 1)for(y = 0; y < ySize; y += 1){
        dx = x - xMid;
        dy = y - yMid;
        radius = Math.sqrt(dx * dx + dy * dy) * rSize / rMax;
        theta = (Math.atan2(dy, dx) * 180 / Math.PI + 360 + phaseShift) % 360;
        theta = theta * tSize / 360;
        x1 = Math.floor(theta);
        y1 = Math.floor(radius);
        i = (y1 * xSize + x1) * 4;
        r = srcPixels[i + 0];
        g = srcPixels[i + 1];
        b = srcPixels[i + 2];
        a = srcPixels[i + 3];
        i = (y * xSize + x) * 4;
        dstPixels[i + 0] = r;
        dstPixels[i + 1] = g;
        dstPixels[i + 2] = b;
        dstPixels[i + 3] = a;
    }
};
const $689d3d7812c8bdcb$var$Kaleidoscope = function(imageData) {
    var xSize = imageData.width, ySize = imageData.height;
    var x, y, xoff, i, r, g, b, a, srcPos, dstPos;
    var power = Math.round(this.kaleidoscopePower());
    var angle = Math.round(this.kaleidoscopeAngle());
    var offset = Math.floor(xSize * (angle % 360) / 360);
    if (power < 1) return;
    var tempCanvas = $kWs5g.Util.createCanvasElement();
    tempCanvas.width = xSize;
    tempCanvas.height = ySize;
    var scratchData = tempCanvas.getContext("2d").getImageData(0, 0, xSize, ySize);
    $kWs5g.Util.releaseCanvas(tempCanvas);
    $689d3d7812c8bdcb$var$ToPolar(imageData, scratchData, {
        polarCenterX: xSize / 2,
        polarCenterY: ySize / 2
    });
    var minSectionSize = xSize / Math.pow(2, power);
    while(minSectionSize <= 8){
        minSectionSize = minSectionSize * 2;
        power -= 1;
    }
    minSectionSize = Math.ceil(minSectionSize);
    var sectionSize = minSectionSize;
    var xStart = 0, xEnd = sectionSize, xDelta = 1;
    if (offset + minSectionSize > xSize) {
        xStart = sectionSize;
        xEnd = 0;
        xDelta = -1;
    }
    for(y = 0; y < ySize; y += 1)for(x = xStart; x !== xEnd; x += xDelta){
        xoff = Math.round(x + offset) % xSize;
        srcPos = (xSize * y + xoff) * 4;
        r = scratchData.data[srcPos + 0];
        g = scratchData.data[srcPos + 1];
        b = scratchData.data[srcPos + 2];
        a = scratchData.data[srcPos + 3];
        dstPos = (xSize * y + x) * 4;
        scratchData.data[dstPos + 0] = r;
        scratchData.data[dstPos + 1] = g;
        scratchData.data[dstPos + 2] = b;
        scratchData.data[dstPos + 3] = a;
    }
    for(y = 0; y < ySize; y += 1){
        sectionSize = Math.floor(minSectionSize);
        for(i = 0; i < power; i += 1){
            for(x = 0; x < sectionSize + 1; x += 1){
                srcPos = (xSize * y + x) * 4;
                r = scratchData.data[srcPos + 0];
                g = scratchData.data[srcPos + 1];
                b = scratchData.data[srcPos + 2];
                a = scratchData.data[srcPos + 3];
                dstPos = (xSize * y + sectionSize * 2 - x - 1) * 4;
                scratchData.data[dstPos + 0] = r;
                scratchData.data[dstPos + 1] = g;
                scratchData.data[dstPos + 2] = b;
                scratchData.data[dstPos + 3] = a;
            }
            sectionSize *= 2;
        }
    }
    $689d3d7812c8bdcb$var$FromPolar(scratchData, imageData, {
        polarRotation: 0
    });
};
module.exports.Kaleidoscope = $689d3d7812c8bdcb$var$Kaleidoscope;
$3V3su.Factory.addGetterSetter($1qU2E.Node, "kaleidoscopePower", 2, (0, $2TXYV.getNumberValidator)(), $3V3su.Factory.afterSetFilter);
$3V3su.Factory.addGetterSetter($1qU2E.Node, "kaleidoscopeAngle", 0, (0, $2TXYV.getNumberValidator)(), $3V3su.Factory.afterSetFilter);

});

parcelRegister("f4uhT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Mask = void 0;

var $3V3su = parcelRequire("3V3su");

var $1qU2E = parcelRequire("1qU2E");

var $2TXYV = parcelRequire("2TXYV");
function $af8eb937ca1ba411$var$pixelAt(idata, x, y) {
    var idx = (y * idata.width + x) * 4;
    var d = [];
    d.push(idata.data[idx++], idata.data[idx++], idata.data[idx++], idata.data[idx++]);
    return d;
}
function $af8eb937ca1ba411$var$rgbDistance(p1, p2) {
    return Math.sqrt(Math.pow(p1[0] - p2[0], 2) + Math.pow(p1[1] - p2[1], 2) + Math.pow(p1[2] - p2[2], 2));
}
function $af8eb937ca1ba411$var$rgbMean(pTab) {
    var m = [
        0,
        0,
        0
    ];
    for(var i = 0; i < pTab.length; i++){
        m[0] += pTab[i][0];
        m[1] += pTab[i][1];
        m[2] += pTab[i][2];
    }
    m[0] /= pTab.length;
    m[1] /= pTab.length;
    m[2] /= pTab.length;
    return m;
}
function $af8eb937ca1ba411$var$backgroundMask(idata, threshold) {
    var rgbv_no = $af8eb937ca1ba411$var$pixelAt(idata, 0, 0);
    var rgbv_ne = $af8eb937ca1ba411$var$pixelAt(idata, idata.width - 1, 0);
    var rgbv_so = $af8eb937ca1ba411$var$pixelAt(idata, 0, idata.height - 1);
    var rgbv_se = $af8eb937ca1ba411$var$pixelAt(idata, idata.width - 1, idata.height - 1);
    var thres = threshold || 10;
    if ($af8eb937ca1ba411$var$rgbDistance(rgbv_no, rgbv_ne) < thres && $af8eb937ca1ba411$var$rgbDistance(rgbv_ne, rgbv_se) < thres && $af8eb937ca1ba411$var$rgbDistance(rgbv_se, rgbv_so) < thres && $af8eb937ca1ba411$var$rgbDistance(rgbv_so, rgbv_no) < thres) {
        var mean = $af8eb937ca1ba411$var$rgbMean([
            rgbv_ne,
            rgbv_no,
            rgbv_se,
            rgbv_so
        ]);
        var mask = [];
        for(var i = 0; i < idata.width * idata.height; i++){
            var d = $af8eb937ca1ba411$var$rgbDistance(mean, [
                idata.data[i * 4],
                idata.data[i * 4 + 1],
                idata.data[i * 4 + 2]
            ]);
            mask[i] = d < thres ? 0 : 255;
        }
        return mask;
    }
}
function $af8eb937ca1ba411$var$applyMask(idata, mask) {
    for(var i = 0; i < idata.width * idata.height; i++)idata.data[4 * i + 3] = mask[i];
}
function $af8eb937ca1ba411$var$erodeMask(mask, sw, sh) {
    var weights = [
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1
    ];
    var side = Math.round(Math.sqrt(weights.length));
    var halfSide = Math.floor(side / 2);
    var maskResult = [];
    for(var y = 0; y < sh; y++)for(var x = 0; x < sw; x++){
        var so = y * sw + x;
        var a = 0;
        for(var cy = 0; cy < side; cy++)for(var cx = 0; cx < side; cx++){
            var scy = y + cy - halfSide;
            var scx = x + cx - halfSide;
            if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
                var srcOff = scy * sw + scx;
                var wt = weights[cy * side + cx];
                a += mask[srcOff] * wt;
            }
        }
        maskResult[so] = a === 2040 ? 255 : 0;
    }
    return maskResult;
}
function $af8eb937ca1ba411$var$dilateMask(mask, sw, sh) {
    var weights = [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
    ];
    var side = Math.round(Math.sqrt(weights.length));
    var halfSide = Math.floor(side / 2);
    var maskResult = [];
    for(var y = 0; y < sh; y++)for(var x = 0; x < sw; x++){
        var so = y * sw + x;
        var a = 0;
        for(var cy = 0; cy < side; cy++)for(var cx = 0; cx < side; cx++){
            var scy = y + cy - halfSide;
            var scx = x + cx - halfSide;
            if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
                var srcOff = scy * sw + scx;
                var wt = weights[cy * side + cx];
                a += mask[srcOff] * wt;
            }
        }
        maskResult[so] = a >= 1020 ? 255 : 0;
    }
    return maskResult;
}
function $af8eb937ca1ba411$var$smoothEdgeMask(mask, sw, sh) {
    var weights = [
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9
    ];
    var side = Math.round(Math.sqrt(weights.length));
    var halfSide = Math.floor(side / 2);
    var maskResult = [];
    for(var y = 0; y < sh; y++)for(var x = 0; x < sw; x++){
        var so = y * sw + x;
        var a = 0;
        for(var cy = 0; cy < side; cy++)for(var cx = 0; cx < side; cx++){
            var scy = y + cy - halfSide;
            var scx = x + cx - halfSide;
            if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
                var srcOff = scy * sw + scx;
                var wt = weights[cy * side + cx];
                a += mask[srcOff] * wt;
            }
        }
        maskResult[so] = a;
    }
    return maskResult;
}
const $af8eb937ca1ba411$var$Mask = function(imageData) {
    var threshold = this.threshold(), mask = $af8eb937ca1ba411$var$backgroundMask(imageData, threshold);
    if (mask) {
        mask = $af8eb937ca1ba411$var$erodeMask(mask, imageData.width, imageData.height);
        mask = $af8eb937ca1ba411$var$dilateMask(mask, imageData.width, imageData.height);
        mask = $af8eb937ca1ba411$var$smoothEdgeMask(mask, imageData.width, imageData.height);
        $af8eb937ca1ba411$var$applyMask(imageData, mask);
    }
    return imageData;
};
module.exports.Mask = $af8eb937ca1ba411$var$Mask;
$3V3su.Factory.addGetterSetter($1qU2E.Node, "threshold", 0, (0, $2TXYV.getNumberValidator)(), $3V3su.Factory.afterSetFilter);

});

parcelRegister("nXPb8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Noise = void 0;

var $3V3su = parcelRequire("3V3su");

var $1qU2E = parcelRequire("1qU2E");

var $2TXYV = parcelRequire("2TXYV");
const $04808dfd2c93f45e$var$Noise = function(imageData) {
    var amount = this.noise() * 255, data = imageData.data, nPixels = data.length, half = amount / 2, i;
    for(i = 0; i < nPixels; i += 4){
        data[i + 0] += half - 2 * half * Math.random();
        data[i + 1] += half - 2 * half * Math.random();
        data[i + 2] += half - 2 * half * Math.random();
    }
};
module.exports.Noise = $04808dfd2c93f45e$var$Noise;
$3V3su.Factory.addGetterSetter($1qU2E.Node, "noise", 0.2, (0, $2TXYV.getNumberValidator)(), $3V3su.Factory.afterSetFilter);

});

parcelRegister("ez1tv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Pixelate = void 0;

var $3V3su = parcelRequire("3V3su");

var $kWs5g = parcelRequire("kWs5g");

var $1qU2E = parcelRequire("1qU2E");

var $2TXYV = parcelRequire("2TXYV");
const $a9a57a6f186bc95f$var$Pixelate = function(imageData) {
    var pixelSize = Math.ceil(this.pixelSize()), width = imageData.width, height = imageData.height, x, y, i, red, green, blue, alpha, nBinsX = Math.ceil(width / pixelSize), nBinsY = Math.ceil(height / pixelSize), xBinStart, xBinEnd, yBinStart, yBinEnd, xBin, yBin, pixelsInBin, data = imageData.data;
    if (pixelSize <= 0) {
        $kWs5g.Util.error("pixelSize value can not be <= 0");
        return;
    }
    for(xBin = 0; xBin < nBinsX; xBin += 1)for(yBin = 0; yBin < nBinsY; yBin += 1){
        red = 0;
        green = 0;
        blue = 0;
        alpha = 0;
        xBinStart = xBin * pixelSize;
        xBinEnd = xBinStart + pixelSize;
        yBinStart = yBin * pixelSize;
        yBinEnd = yBinStart + pixelSize;
        pixelsInBin = 0;
        for(x = xBinStart; x < xBinEnd; x += 1){
            if (x >= width) continue;
            for(y = yBinStart; y < yBinEnd; y += 1){
                if (y >= height) continue;
                i = (width * y + x) * 4;
                red += data[i + 0];
                green += data[i + 1];
                blue += data[i + 2];
                alpha += data[i + 3];
                pixelsInBin += 1;
            }
        }
        red = red / pixelsInBin;
        green = green / pixelsInBin;
        blue = blue / pixelsInBin;
        alpha = alpha / pixelsInBin;
        for(x = xBinStart; x < xBinEnd; x += 1){
            if (x >= width) continue;
            for(y = yBinStart; y < yBinEnd; y += 1){
                if (y >= height) continue;
                i = (width * y + x) * 4;
                data[i + 0] = red;
                data[i + 1] = green;
                data[i + 2] = blue;
                data[i + 3] = alpha;
            }
        }
    }
};
module.exports.Pixelate = $a9a57a6f186bc95f$var$Pixelate;
$3V3su.Factory.addGetterSetter($1qU2E.Node, "pixelSize", 8, (0, $2TXYV.getNumberValidator)(), $3V3su.Factory.afterSetFilter);

});

parcelRegister("54oRz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Posterize = void 0;

var $3V3su = parcelRequire("3V3su");

var $1qU2E = parcelRequire("1qU2E");

var $2TXYV = parcelRequire("2TXYV");
const $3b109cbd8a806cdd$var$Posterize = function(imageData) {
    var levels = Math.round(this.levels() * 254) + 1, data = imageData.data, len = data.length, scale = 255 / levels, i;
    for(i = 0; i < len; i += 1)data[i] = Math.floor(data[i] / scale) * scale;
};
module.exports.Posterize = $3b109cbd8a806cdd$var$Posterize;
$3V3su.Factory.addGetterSetter($1qU2E.Node, "levels", 0.5, (0, $2TXYV.getNumberValidator)(), $3V3su.Factory.afterSetFilter);

});

parcelRegister("awjyq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RGB = void 0;

var $3V3su = parcelRequire("3V3su");

var $1qU2E = parcelRequire("1qU2E");

var $2TXYV = parcelRequire("2TXYV");
const $7a8c0f9f4cfb110c$var$RGB = function(imageData) {
    var data = imageData.data, nPixels = data.length, red = this.red(), green = this.green(), blue = this.blue(), i, brightness;
    for(i = 0; i < nPixels; i += 4){
        brightness = (0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2]) / 255;
        data[i] = brightness * red;
        data[i + 1] = brightness * green;
        data[i + 2] = brightness * blue;
        data[i + 3] = data[i + 3];
    }
};
module.exports.RGB = $7a8c0f9f4cfb110c$var$RGB;
$3V3su.Factory.addGetterSetter($1qU2E.Node, "red", 0, function(val) {
    this._filterUpToDate = false;
    if (val > 255) return 255;
    else if (val < 0) return 0;
    else return Math.round(val);
});
$3V3su.Factory.addGetterSetter($1qU2E.Node, "green", 0, function(val) {
    this._filterUpToDate = false;
    if (val > 255) return 255;
    else if (val < 0) return 0;
    else return Math.round(val);
});
$3V3su.Factory.addGetterSetter($1qU2E.Node, "blue", 0, $2TXYV.RGBComponent, $3V3su.Factory.afterSetFilter);

});

parcelRegister("jy4HT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RGBA = void 0;

var $3V3su = parcelRequire("3V3su");

var $1qU2E = parcelRequire("1qU2E");

var $2TXYV = parcelRequire("2TXYV");
const $e3b4d804b71b9da5$var$RGBA = function(imageData) {
    var data = imageData.data, nPixels = data.length, red = this.red(), green = this.green(), blue = this.blue(), alpha = this.alpha(), i, ia;
    for(i = 0; i < nPixels; i += 4){
        ia = 1 - alpha;
        data[i] = red * alpha + data[i] * ia;
        data[i + 1] = green * alpha + data[i + 1] * ia;
        data[i + 2] = blue * alpha + data[i + 2] * ia;
    }
};
module.exports.RGBA = $e3b4d804b71b9da5$var$RGBA;
$3V3su.Factory.addGetterSetter($1qU2E.Node, "red", 0, function(val) {
    this._filterUpToDate = false;
    if (val > 255) return 255;
    else if (val < 0) return 0;
    else return Math.round(val);
});
$3V3su.Factory.addGetterSetter($1qU2E.Node, "green", 0, function(val) {
    this._filterUpToDate = false;
    if (val > 255) return 255;
    else if (val < 0) return 0;
    else return Math.round(val);
});
$3V3su.Factory.addGetterSetter($1qU2E.Node, "blue", 0, $2TXYV.RGBComponent, $3V3su.Factory.afterSetFilter);
$3V3su.Factory.addGetterSetter($1qU2E.Node, "alpha", 1, function(val) {
    this._filterUpToDate = false;
    if (val > 1) return 1;
    else if (val < 0) return 0;
    else return val;
});

});

parcelRegister("aSL2k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sepia = void 0;
const $7ec36f025f1ae62b$var$Sepia = function(imageData) {
    var data = imageData.data, nPixels = data.length, i, r, g, b;
    for(i = 0; i < nPixels; i += 4){
        r = data[i + 0];
        g = data[i + 1];
        b = data[i + 2];
        data[i + 0] = Math.min(255, r * 0.393 + g * 0.769 + b * 0.189);
        data[i + 1] = Math.min(255, r * 0.349 + g * 0.686 + b * 0.168);
        data[i + 2] = Math.min(255, r * 0.272 + g * 0.534 + b * 0.131);
    }
};
module.exports.Sepia = $7ec36f025f1ae62b$var$Sepia;

});

parcelRegister("irVuX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Solarize = void 0;
const $d6e7599627425596$var$Solarize = function(imageData) {
    var data = imageData.data, w = imageData.width, h = imageData.height, w4 = w * 4, y = h;
    do {
        var offsetY = (y - 1) * w4;
        var x = w;
        do {
            var offset = offsetY + (x - 1) * 4;
            var r = data[offset];
            var g = data[offset + 1];
            var b = data[offset + 2];
            if (r > 127) r = 255 - r;
            if (g > 127) g = 255 - g;
            if (b > 127) b = 255 - b;
            data[offset] = r;
            data[offset + 1] = g;
            data[offset + 2] = b;
        }while (--x);
    }while (--y);
};
module.exports.Solarize = $d6e7599627425596$var$Solarize;

});

parcelRegister("fzRK8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Threshold = void 0;

var $3V3su = parcelRequire("3V3su");

var $1qU2E = parcelRequire("1qU2E");

var $2TXYV = parcelRequire("2TXYV");
const $b573d02a4fe9e6b9$var$Threshold = function(imageData) {
    var level = this.threshold() * 255, data = imageData.data, len = data.length, i;
    for(i = 0; i < len; i += 1)data[i] = data[i] < level ? 0 : 255;
};
module.exports.Threshold = $b573d02a4fe9e6b9$var$Threshold;
$3V3su.Factory.addGetterSetter($1qU2E.Node, "threshold", 0.5, (0, $2TXYV.getNumberValidator)(), $3V3su.Factory.afterSetFilter);

});



parcelRegister("fBZlQ", function(module, exports) {

$parcel$export(module.exports, "Layer", () => $b5d9e6d31d9c118e$export$936d0764594b6eb3);
$parcel$export(module.exports, "Group", () => $b5d9e6d31d9c118e$export$eb2fcfdbd7ba97d4);
$parcel$export(module.exports, "Label", () => $b5d9e6d31d9c118e$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Rect", () => $b5d9e6d31d9c118e$export$c79fc6492f3af13d);
$parcel$export(module.exports, "Circle", () => $b5d9e6d31d9c118e$export$c89a927ffc67e6fa);
$parcel$export(module.exports, "Line", () => $b5d9e6d31d9c118e$export$17d680238e50603e);
$parcel$export(module.exports, "Image", () => $b5d9e6d31d9c118e$export$3e431a229df88919);
$parcel$export(module.exports, "Text", () => $b5d9e6d31d9c118e$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "Arc", () => $b5d9e6d31d9c118e$export$6ef80ffb606dd232);
$parcel$export(module.exports, "Tag", () => $b5d9e6d31d9c118e$export$3288d34c523a1192);
$parcel$export(module.exports, "Path", () => $b5d9e6d31d9c118e$export$4b2950bdac9b6ee9);
$parcel$export(module.exports, "Transformer", () => $b5d9e6d31d9c118e$export$f993aef960936087);
$parcel$export(module.exports, "Stage", () => $b5d9e6d31d9c118e$export$208cd1682bd0e4b6);
/**
 * Based on ReactArt.js
 * Copyright (c) 2017-present Lavrenov Anton.
 * All rights reserved.
 *
 * MIT
 */ 
var $8NFma = parcelRequire("8NFma");

var $d46Uo = parcelRequire("d46Uo");

var $5mBOe = parcelRequire("5mBOe");

var $d2SWu = parcelRequire("d2SWu");

var $cRXqO = parcelRequire("cRXqO");

var $9zm1x = parcelRequire("9zm1x");

var $fGeNI = parcelRequire("fGeNI");
"use strict";
function $b5d9e6d31d9c118e$var$usePrevious(value) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useRef({});
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useLayoutEffect(()=>{
        ref.current = value;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useLayoutEffect(()=>{
        return ()=>{
            // when using suspense it is possible that stage is unmounted
            // but React still keep component ref
            // in that case we need to manually flush props
            // we have a special test for that
            ref.current = {};
        };
    }, []);
    return ref.current;
}
const $b5d9e6d31d9c118e$var$StageWrap = (props)=>{
    const container = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useRef();
    const stage = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useRef();
    const fiberRef = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useRef();
    const oldProps = $b5d9e6d31d9c118e$var$usePrevious(props);
    const Bridge = (0, $fGeNI.useContextBridge)();
    const _setRef = (stage)=>{
        const { forwardedRef: forwardedRef } = props;
        if (!forwardedRef) return;
        if (typeof forwardedRef === "function") forwardedRef(stage);
        else forwardedRef.current = stage;
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useLayoutEffect(()=>{
        stage.current = new (0, (/*@__PURE__*/$parcel$interopDefault($d46Uo))).Stage({
            width: props.width,
            height: props.height,
            container: container.current
        });
        _setRef(stage.current);
        // @ts-ignore
        fiberRef.current = $b5d9e6d31d9c118e$export$1998d71d1bc35390.createContainer(stage.current, (0, $d2SWu.LegacyRoot), false, null);
        $b5d9e6d31d9c118e$export$1998d71d1bc35390.updateContainer((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement(Bridge, {}, props.children), fiberRef.current);
        return ()=>{
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($d46Uo))).isBrowser) return;
            _setRef(null);
            $b5d9e6d31d9c118e$export$1998d71d1bc35390.updateContainer(null, fiberRef.current, null);
            stage.current.destroy();
        };
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useLayoutEffect(()=>{
        _setRef(stage.current);
        (0, $9zm1x.applyNodeProps)(stage.current, props, oldProps);
        $b5d9e6d31d9c118e$export$1998d71d1bc35390.updateContainer((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement(Bridge, {}, props.children), fiberRef.current, null);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("div", {
        ref: container,
        id: props.id,
        accessKey: props.accessKey,
        className: props.className,
        role: props.role,
        style: props.style,
        tabIndex: props.tabIndex,
        title: props.title
    });
};
const $b5d9e6d31d9c118e$export$936d0764594b6eb3 = "Layer";
const $b5d9e6d31d9c118e$export$92d64f29192d1118 = "FastLayer";
const $b5d9e6d31d9c118e$export$eb2fcfdbd7ba97d4 = "Group";
const $b5d9e6d31d9c118e$export$b04be29aa201d4f5 = "Label";
const $b5d9e6d31d9c118e$export$c79fc6492f3af13d = "Rect";
const $b5d9e6d31d9c118e$export$c89a927ffc67e6fa = "Circle";
const $b5d9e6d31d9c118e$export$80b0269ab108fa11 = "Ellipse";
const $b5d9e6d31d9c118e$export$28718c7785907330 = "Wedge";
const $b5d9e6d31d9c118e$export$17d680238e50603e = "Line";
const $b5d9e6d31d9c118e$export$3075603db8e6204c = "Sprite";
const $b5d9e6d31d9c118e$export$3e431a229df88919 = "Image";
const $b5d9e6d31d9c118e$export$5f1af8db9871e1d6 = "Text";
const $b5d9e6d31d9c118e$export$f7e34a95cc06fac7 = "TextPath";
const $b5d9e6d31d9c118e$export$1644ba17714857f1 = "Star";
const $b5d9e6d31d9c118e$export$a6e3577650b6d6d7 = "Ring";
const $b5d9e6d31d9c118e$export$6ef80ffb606dd232 = "Arc";
const $b5d9e6d31d9c118e$export$3288d34c523a1192 = "Tag";
const $b5d9e6d31d9c118e$export$4b2950bdac9b6ee9 = "Path";
const $b5d9e6d31d9c118e$export$e2ee866164812ecd = "RegularPolygon";
const $b5d9e6d31d9c118e$export$21b07c8f274aebd5 = "Arrow";
const $b5d9e6d31d9c118e$export$6428a7f2611ef1fa = "Shape";
const $b5d9e6d31d9c118e$export$f993aef960936087 = "Transformer";
const $b5d9e6d31d9c118e$export$1998d71d1bc35390 = (0, (/*@__PURE__*/$parcel$interopDefault($5mBOe)))($cRXqO);
$b5d9e6d31d9c118e$export$1998d71d1bc35390.injectIntoDevTools({
    // @ts-ignore
    findHostInstanceByFiber: ()=>null,
    bundleType: 0,
    version: (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).version,
    rendererPackageName: "react-konva"
});
const $b5d9e6d31d9c118e$export$208cd1682bd0e4b6 = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).forwardRef((props, ref)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $fGeNI.FiberProvider), {}, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement($b5d9e6d31d9c118e$var$StageWrap, {
        ...props,
        forwardedRef: ref
    }));
});
const $b5d9e6d31d9c118e$export$2e548393fba9b338 = (0, $9zm1x.toggleStrictMode);

});
parcelRegister("d46Uo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Konva = void 0;

var $3rme3 = parcelRequire("3rme3");
Object.defineProperty(module.exports, "Konva", {
    enumerable: true,
    get: function() {
        return $3rme3.Konva;
    }
});

var $3rme3 = parcelRequire("3rme3");
module.exports = $3rme3.Konva;

});

parcelRegister("5mBOe", function(module, exports) {
"use strict";

module.exports = (parcelRequire("bBlAQ"));

});
parcelRegister("bBlAQ", function(module, exports) {
/**
 * @license React
 * react-reconciler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 

module.exports = function $$$reconciler($$$hostConfig) {
    var exports = {};
    "use strict";
    var aa = (parcelRequire("8NFma")), ba = (parcelRequire("clk2u")), ca = Object.assign;
    function n(a) {
        for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
        return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    var da = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, ea = Symbol.for("react.element"), fa = Symbol.for("react.portal"), ha = Symbol.for("react.fragment"), ia = Symbol.for("react.strict_mode"), ja = Symbol.for("react.profiler"), ka = Symbol.for("react.provider"), la = Symbol.for("react.context"), ma = Symbol.for("react.forward_ref"), na = Symbol.for("react.suspense"), oa = Symbol.for("react.suspense_list"), pa = Symbol.for("react.memo"), qa = Symbol.for("react.lazy");
    Symbol.for("react.scope");
    Symbol.for("react.debug_trace_mode");
    var ra = Symbol.for("react.offscreen");
    Symbol.for("react.legacy_hidden");
    Symbol.for("react.cache");
    Symbol.for("react.tracing_marker");
    var sa = Symbol.iterator;
    function ta(a) {
        if (null === a || "object" !== typeof a) return null;
        a = sa && a[sa] || a["@@iterator"];
        return "function" === typeof a ? a : null;
    }
    function ua(a) {
        if (null == a) return null;
        if ("function" === typeof a) return a.displayName || a.name || null;
        if ("string" === typeof a) return a;
        switch(a){
            case ha:
                return "Fragment";
            case fa:
                return "Portal";
            case ja:
                return "Profiler";
            case ia:
                return "StrictMode";
            case na:
                return "Suspense";
            case oa:
                return "SuspenseList";
        }
        if ("object" === typeof a) switch(a.$$typeof){
            case la:
                return (a.displayName || "Context") + ".Consumer";
            case ka:
                return (a._context.displayName || "Context") + ".Provider";
            case ma:
                var b = a.render;
                a = a.displayName;
                a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
                return a;
            case pa:
                return b = a.displayName || null, null !== b ? b : ua(a.type) || "Memo";
            case qa:
                b = a._payload;
                a = a._init;
                try {
                    return ua(a(b));
                } catch (c) {}
        }
        return null;
    }
    function va(a) {
        var b = a.type;
        switch(a.tag){
            case 24:
                return "Cache";
            case 9:
                return (b.displayName || "Context") + ".Consumer";
            case 10:
                return (b._context.displayName || "Context") + ".Provider";
            case 18:
                return "DehydratedFragment";
            case 11:
                return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            case 7:
                return "Fragment";
            case 5:
                return b;
            case 4:
                return "Portal";
            case 3:
                return "Root";
            case 6:
                return "Text";
            case 16:
                return ua(b);
            case 8:
                return b === ia ? "StrictMode" : "Mode";
            case 22:
                return "Offscreen";
            case 12:
                return "Profiler";
            case 21:
                return "Scope";
            case 13:
                return "Suspense";
            case 19:
                return "SuspenseList";
            case 25:
                return "TracingMarker";
            case 1:
            case 0:
            case 17:
            case 2:
            case 14:
            case 15:
                if ("function" === typeof b) return b.displayName || b.name || null;
                if ("string" === typeof b) return b;
        }
        return null;
    }
    function wa(a) {
        var b = a, c = a;
        if (a.alternate) for(; b.return;)b = b.return;
        else {
            a = b;
            do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
            while (a);
        }
        return 3 === b.tag ? c : null;
    }
    function xa(a) {
        if (wa(a) !== a) throw Error(n(188));
    }
    function za(a) {
        var b = a.alternate;
        if (!b) {
            b = wa(a);
            if (null === b) throw Error(n(188));
            return b !== a ? null : a;
        }
        for(var c = a, d = b;;){
            var e = c.return;
            if (null === e) break;
            var f = e.alternate;
            if (null === f) {
                d = e.return;
                if (null !== d) {
                    c = d;
                    continue;
                }
                break;
            }
            if (e.child === f.child) {
                for(f = e.child; f;){
                    if (f === c) return xa(e), a;
                    if (f === d) return xa(e), b;
                    f = f.sibling;
                }
                throw Error(n(188));
            }
            if (c.return !== d.return) c = e, d = f;
            else {
                for(var g = !1, h = e.child; h;){
                    if (h === c) {
                        g = !0;
                        c = e;
                        d = f;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = e;
                        c = f;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) {
                    for(h = f.child; h;){
                        if (h === c) {
                            g = !0;
                            c = f;
                            d = e;
                            break;
                        }
                        if (h === d) {
                            g = !0;
                            d = f;
                            c = e;
                            break;
                        }
                        h = h.sibling;
                    }
                    if (!g) throw Error(n(189));
                }
            }
            if (c.alternate !== d) throw Error(n(190));
        }
        if (3 !== c.tag) throw Error(n(188));
        return c.stateNode.current === c ? a : b;
    }
    function Aa(a) {
        a = za(a);
        return null !== a ? Ba(a) : null;
    }
    function Ba(a) {
        if (5 === a.tag || 6 === a.tag) return a;
        for(a = a.child; null !== a;){
            var b = Ba(a);
            if (null !== b) return b;
            a = a.sibling;
        }
        return null;
    }
    function Ca(a) {
        if (5 === a.tag || 6 === a.tag) return a;
        for(a = a.child; null !== a;){
            if (4 !== a.tag) {
                var b = Ca(a);
                if (null !== b) return b;
            }
            a = a.sibling;
        }
        return null;
    }
    var Da = Array.isArray, Ea = $$$hostConfig.getPublicInstance, Fa = $$$hostConfig.getRootHostContext, Ga = $$$hostConfig.getChildHostContext, Ha = $$$hostConfig.prepareForCommit, Ia = $$$hostConfig.resetAfterCommit, Ja = $$$hostConfig.createInstance, Ka = $$$hostConfig.appendInitialChild, La = $$$hostConfig.finalizeInitialChildren, Ma = $$$hostConfig.prepareUpdate, Na = $$$hostConfig.shouldSetTextContent, Oa = $$$hostConfig.createTextInstance, Pa = $$$hostConfig.scheduleTimeout, Qa = $$$hostConfig.cancelTimeout, Ra = $$$hostConfig.noTimeout, Sa = $$$hostConfig.isPrimaryRenderer, Ta = $$$hostConfig.supportsMutation, Ua = $$$hostConfig.supportsPersistence, Va = $$$hostConfig.supportsHydration, Wa = $$$hostConfig.getInstanceFromNode, Xa = $$$hostConfig.preparePortalMount, Ya = $$$hostConfig.getCurrentEventPriority, Za = $$$hostConfig.detachDeletedInstance, $a = $$$hostConfig.supportsMicrotasks, ab = $$$hostConfig.scheduleMicrotask, bb = $$$hostConfig.supportsTestSelectors, cb = $$$hostConfig.findFiberRoot, db = $$$hostConfig.getBoundingRect, eb = $$$hostConfig.getTextContent, fb = $$$hostConfig.isHiddenSubtree, gb = $$$hostConfig.matchAccessibilityRole, hb = $$$hostConfig.setFocusIfFocusable, ib = $$$hostConfig.setupIntersectionObserver, jb = $$$hostConfig.appendChild, kb = $$$hostConfig.appendChildToContainer, lb = $$$hostConfig.commitTextUpdate, mb = $$$hostConfig.commitMount, nb = $$$hostConfig.commitUpdate, ob = $$$hostConfig.insertBefore, pb = $$$hostConfig.insertInContainerBefore, qb = $$$hostConfig.removeChild, rb = $$$hostConfig.removeChildFromContainer, sb = $$$hostConfig.resetTextContent, tb = $$$hostConfig.hideInstance, ub = $$$hostConfig.hideTextInstance, vb = $$$hostConfig.unhideInstance, wb = $$$hostConfig.unhideTextInstance, xb = $$$hostConfig.clearContainer, yb = $$$hostConfig.cloneInstance, zb = $$$hostConfig.createContainerChildSet, Ab = $$$hostConfig.appendChildToContainerChildSet, Bb = $$$hostConfig.finalizeContainerChildren, Cb = $$$hostConfig.replaceContainerChildren, Eb = $$$hostConfig.cloneHiddenInstance, Fb = $$$hostConfig.cloneHiddenTextInstance, Gb = $$$hostConfig.canHydrateInstance, Hb = $$$hostConfig.canHydrateTextInstance, Ib = $$$hostConfig.canHydrateSuspenseInstance, Jb = $$$hostConfig.isSuspenseInstancePending, Kb = $$$hostConfig.isSuspenseInstanceFallback, Lb = $$$hostConfig.getSuspenseInstanceFallbackErrorDetails, Mb = $$$hostConfig.registerSuspenseInstanceRetry, Nb = $$$hostConfig.getNextHydratableSibling, Ob = $$$hostConfig.getFirstHydratableChild, Pb = $$$hostConfig.getFirstHydratableChildWithinContainer, Qb = $$$hostConfig.getFirstHydratableChildWithinSuspenseInstance, Rb = $$$hostConfig.hydrateInstance, Sb = $$$hostConfig.hydrateTextInstance, Tb = $$$hostConfig.hydrateSuspenseInstance, Ub = $$$hostConfig.getNextHydratableInstanceAfterSuspenseInstance, Vb = $$$hostConfig.commitHydratedContainer, Wb = $$$hostConfig.commitHydratedSuspenseInstance, Xb = $$$hostConfig.clearSuspenseBoundary, Yb = $$$hostConfig.clearSuspenseBoundaryFromContainer, Zb = $$$hostConfig.shouldDeleteUnhydratedTailInstances, $b = $$$hostConfig.didNotMatchHydratedContainerTextInstance, ac = $$$hostConfig.didNotMatchHydratedTextInstance, bc;
    function cc(a) {
        if (void 0 === bc) try {
            throw Error();
        } catch (c) {
            var b = c.stack.trim().match(/\n( *(at )?)/);
            bc = b && b[1] || "";
        }
        return "\n" + bc + a;
    }
    var dc = !1;
    function ec(a, b) {
        if (!a || dc) return "";
        dc = !0;
        var c = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        try {
            if (b) {
                if (b = function() {
                    throw Error();
                }, Object.defineProperty(b.prototype, "props", {
                    set: function() {
                        throw Error();
                    }
                }), "object" === typeof Reflect && Reflect.construct) {
                    try {
                        Reflect.construct(b, []);
                    } catch (l) {
                        var d = l;
                    }
                    Reflect.construct(a, [], b);
                } else {
                    try {
                        b.call();
                    } catch (l) {
                        d = l;
                    }
                    a.call(b.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (l) {
                    d = l;
                }
                a();
            }
        } catch (l) {
            if (l && d && "string" === typeof l.stack) {
                for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
                for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                    if (1 !== g || 1 !== h) {
                        do if (g--, h--, 0 > h || e[g] !== f[h]) {
                            var k = "\n" + e[g].replace(" at new ", " at ");
                            a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                            return k;
                        }
                        while (1 <= g && 0 <= h);
                    }
                    break;
                }
            }
        } finally{
            dc = !1, Error.prepareStackTrace = c;
        }
        return (a = a ? a.displayName || a.name : "") ? cc(a) : "";
    }
    var fc = Object.prototype.hasOwnProperty, gc = [], hc = -1;
    function ic(a) {
        return {
            current: a
        };
    }
    function q(a) {
        0 > hc || (a.current = gc[hc], gc[hc] = null, hc--);
    }
    function v(a, b) {
        hc++;
        gc[hc] = a.current;
        a.current = b;
    }
    var jc = {}, x = ic(jc), z = ic(!1), kc = jc;
    function mc(a, b) {
        var c = a.type.contextTypes;
        if (!c) return jc;
        var d = a.stateNode;
        if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
        var e = {}, f;
        for(f in c)e[f] = b[f];
        d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
        return e;
    }
    function A(a) {
        a = a.childContextTypes;
        return null !== a && void 0 !== a;
    }
    function nc() {
        q(z);
        q(x);
    }
    function oc(a, b, c) {
        if (x.current !== jc) throw Error(n(168));
        v(x, b);
        v(z, c);
    }
    function pc(a, b, c) {
        var d = a.stateNode;
        b = b.childContextTypes;
        if ("function" !== typeof d.getChildContext) return c;
        d = d.getChildContext();
        for(var e in d)if (!(e in b)) throw Error(n(108, va(a) || "Unknown", e));
        return ca({}, c, d);
    }
    function qc(a) {
        a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || jc;
        kc = x.current;
        v(x, a);
        v(z, z.current);
        return !0;
    }
    function rc(a, b, c) {
        var d = a.stateNode;
        if (!d) throw Error(n(169));
        c ? (a = pc(a, b, kc), d.__reactInternalMemoizedMergedChildContext = a, q(z), q(x), v(x, a)) : q(z);
        v(z, c);
    }
    var tc = Math.clz32 ? Math.clz32 : sc, uc = Math.log, vc = Math.LN2;
    function sc(a) {
        a >>>= 0;
        return 0 === a ? 32 : 31 - (uc(a) / vc | 0) | 0;
    }
    var wc = 64, xc = 4194304;
    function yc(a) {
        switch(a & -a){
            case 1:
                return 1;
            case 2:
                return 2;
            case 4:
                return 4;
            case 8:
                return 8;
            case 16:
                return 16;
            case 32:
                return 32;
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
                return a & 4194240;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
            case 67108864:
                return a & 130023424;
            case 134217728:
                return 134217728;
            case 268435456:
                return 268435456;
            case 536870912:
                return 536870912;
            case 1073741824:
                return 1073741824;
            default:
                return a;
        }
    }
    function zc(a, b) {
        var c = a.pendingLanes;
        if (0 === c) return 0;
        var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
        if (0 !== g) {
            var h = g & ~e;
            0 !== h ? d = yc(h) : (f &= g, 0 !== f && (d = yc(f)));
        } else g = c & ~e, 0 !== g ? d = yc(g) : 0 !== f && (d = yc(f));
        if (0 === d) return 0;
        if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
        0 !== (d & 4) && (d |= c & 16);
        b = a.entangledLanes;
        if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - tc(b), e = 1 << c, d |= a[c], b &= ~e;
        return d;
    }
    function Ac(a, b) {
        switch(a){
            case 1:
            case 2:
            case 4:
                return b + 250;
            case 8:
            case 16:
            case 32:
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
                return b + 5E3;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
            case 67108864:
                return -1;
            case 134217728:
            case 268435456:
            case 536870912:
            case 1073741824:
                return -1;
            default:
                return -1;
        }
    }
    function Bc(a, b) {
        for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
            var g = 31 - tc(f), h = 1 << g, k = e[g];
            if (-1 === k) {
                if (0 === (h & c) || 0 !== (h & d)) e[g] = Ac(h, b);
            } else k <= b && (a.expiredLanes |= h);
            f &= ~h;
        }
    }
    function Cc(a) {
        a = a.pendingLanes & -1073741825;
        return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
    }
    function Dc() {
        var a = wc;
        wc <<= 1;
        0 === (wc & 4194240) && (wc = 64);
        return a;
    }
    function Ec(a) {
        for(var b = [], c = 0; 31 > c; c++)b.push(a);
        return b;
    }
    function Fc(a, b, c) {
        a.pendingLanes |= b;
        536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
        a = a.eventTimes;
        b = 31 - tc(b);
        a[b] = c;
    }
    function Gc(a, b) {
        var c = a.pendingLanes & ~b;
        a.pendingLanes = b;
        a.suspendedLanes = 0;
        a.pingedLanes = 0;
        a.expiredLanes &= b;
        a.mutableReadLanes &= b;
        a.entangledLanes &= b;
        b = a.entanglements;
        var d = a.eventTimes;
        for(a = a.expirationTimes; 0 < c;){
            var e = 31 - tc(c), f = 1 << e;
            b[e] = 0;
            d[e] = -1;
            a[e] = -1;
            c &= ~f;
        }
    }
    function Hc(a, b) {
        var c = a.entangledLanes |= b;
        for(a = a.entanglements; c;){
            var d = 31 - tc(c), e = 1 << d;
            e & b | a[d] & b && (a[d] |= b);
            c &= ~e;
        }
    }
    var C = 0;
    function Ic(a) {
        a &= -a;
        return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
    }
    var Jc = ba.unstable_scheduleCallback, Kc = ba.unstable_cancelCallback, Lc = ba.unstable_shouldYield, Mc = ba.unstable_requestPaint, D = ba.unstable_now, Nc = ba.unstable_ImmediatePriority, Oc = ba.unstable_UserBlockingPriority, Pc = ba.unstable_NormalPriority, Qc = ba.unstable_IdlePriority, Rc = null, Sc = null;
    function Tc(a) {
        if (Sc && "function" === typeof Sc.onCommitFiberRoot) try {
            Sc.onCommitFiberRoot(Rc, a, void 0, 128 === (a.current.flags & 128));
        } catch (b) {}
    }
    function Uc(a, b) {
        return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
    }
    var Vc = "function" === typeof Object.is ? Object.is : Uc, Wc = null, Xc = !1, Yc = !1;
    function Zc(a) {
        null === Wc ? Wc = [
            a
        ] : Wc.push(a);
    }
    function $c(a) {
        Xc = !0;
        Zc(a);
    }
    function ad() {
        if (!Yc && null !== Wc) {
            Yc = !0;
            var a = 0, b = C;
            try {
                var c = Wc;
                for(C = 1; a < c.length; a++){
                    var d = c[a];
                    do d = d(!0);
                    while (null !== d);
                }
                Wc = null;
                Xc = !1;
            } catch (e) {
                throw null !== Wc && (Wc = Wc.slice(a + 1)), Jc(Nc, ad), e;
            } finally{
                C = b, Yc = !1;
            }
        }
        return null;
    }
    var bd = [], cd = 0, dd = null, ed = 0, fd = [], gd = 0, hd = null, id = 1, jd = "";
    function kd(a, b) {
        bd[cd++] = ed;
        bd[cd++] = dd;
        dd = a;
        ed = b;
    }
    function ld(a, b, c) {
        fd[gd++] = id;
        fd[gd++] = jd;
        fd[gd++] = hd;
        hd = a;
        var d = id;
        a = jd;
        var e = 32 - tc(d) - 1;
        d &= ~(1 << e);
        c += 1;
        var f = 32 - tc(b) + e;
        if (30 < f) {
            var g = e - e % 5;
            f = (d & (1 << g) - 1).toString(32);
            d >>= g;
            e -= g;
            id = 1 << 32 - tc(b) + e | c << e | d;
            jd = f + a;
        } else id = 1 << f | c << e | d, jd = a;
    }
    function md(a) {
        null !== a.return && (kd(a, 1), ld(a, 1, 0));
    }
    function nd(a) {
        for(; a === dd;)dd = bd[--cd], bd[cd] = null, ed = bd[--cd], bd[cd] = null;
        for(; a === hd;)hd = fd[--gd], fd[gd] = null, jd = fd[--gd], fd[gd] = null, id = fd[--gd], fd[gd] = null;
    }
    var od = null, pd = null, F = !1, qd = !1, rd = null;
    function sd(a, b) {
        var c = td(5, null, null, 0);
        c.elementType = "DELETED";
        c.stateNode = b;
        c.return = a;
        b = a.deletions;
        null === b ? (a.deletions = [
            c
        ], a.flags |= 16) : b.push(c);
    }
    function ud(a, b) {
        switch(a.tag){
            case 5:
                return b = Gb(b, a.type, a.pendingProps), null !== b ? (a.stateNode = b, od = a, pd = Ob(b), !0) : !1;
            case 6:
                return b = Hb(b, a.pendingProps), null !== b ? (a.stateNode = b, od = a, pd = null, !0) : !1;
            case 13:
                b = Ib(b);
                if (null !== b) {
                    var c = null !== hd ? {
                        id: id,
                        overflow: jd
                    } : null;
                    a.memoizedState = {
                        dehydrated: b,
                        treeContext: c,
                        retryLane: 1073741824
                    };
                    c = td(18, null, null, 0);
                    c.stateNode = b;
                    c.return = a;
                    a.child = c;
                    od = a;
                    pd = null;
                    return !0;
                }
                return !1;
            default:
                return !1;
        }
    }
    function vd(a) {
        return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
    }
    function wd(a) {
        if (F) {
            var b = pd;
            if (b) {
                var c = b;
                if (!ud(a, b)) {
                    if (vd(a)) throw Error(n(418));
                    b = Nb(c);
                    var d = od;
                    b && ud(a, b) ? sd(d, c) : (a.flags = a.flags & -4097 | 2, F = !1, od = a);
                }
            } else {
                if (vd(a)) throw Error(n(418));
                a.flags = a.flags & -4097 | 2;
                F = !1;
                od = a;
            }
        }
    }
    function xd(a) {
        for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
        od = a;
    }
    function yd(a) {
        if (!Va || a !== od) return !1;
        if (!F) return xd(a), F = !0, !1;
        if (3 !== a.tag && (5 !== a.tag || Zb(a.type) && !Na(a.type, a.memoizedProps))) {
            var b = pd;
            if (b) {
                if (vd(a)) throw zd(), Error(n(418));
                for(; b;)sd(a, b), b = Nb(b);
            }
        }
        xd(a);
        if (13 === a.tag) {
            if (!Va) throw Error(n(316));
            a = a.memoizedState;
            a = null !== a ? a.dehydrated : null;
            if (!a) throw Error(n(317));
            pd = Ub(a);
        } else pd = od ? Nb(a.stateNode) : null;
        return !0;
    }
    function zd() {
        for(var a = pd; a;)a = Nb(a);
    }
    function Ad() {
        Va && (pd = od = null, qd = F = !1);
    }
    function Bd(a) {
        null === rd ? rd = [
            a
        ] : rd.push(a);
    }
    var Cd = da.ReactCurrentBatchConfig;
    function Dd(a, b) {
        if (Vc(a, b)) return !0;
        if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
        var c = Object.keys(a), d = Object.keys(b);
        if (c.length !== d.length) return !1;
        for(d = 0; d < c.length; d++){
            var e = c[d];
            if (!fc.call(b, e) || !Vc(a[e], b[e])) return !1;
        }
        return !0;
    }
    function Ed(a) {
        switch(a.tag){
            case 5:
                return cc(a.type);
            case 16:
                return cc("Lazy");
            case 13:
                return cc("Suspense");
            case 19:
                return cc("SuspenseList");
            case 0:
            case 2:
            case 15:
                return a = ec(a.type, !1), a;
            case 11:
                return a = ec(a.type.render, !1), a;
            case 1:
                return a = ec(a.type, !0), a;
            default:
                return "";
        }
    }
    function Fd(a, b, c) {
        a = c.ref;
        if (null !== a && "function" !== typeof a && "object" !== typeof a) {
            if (c._owner) {
                c = c._owner;
                if (c) {
                    if (1 !== c.tag) throw Error(n(309));
                    var d = c.stateNode;
                }
                if (!d) throw Error(n(147, a));
                var e = d, f = "" + a;
                if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
                b = function(a) {
                    var b = e.refs;
                    null === a ? delete b[f] : b[f] = a;
                };
                b._stringRef = f;
                return b;
            }
            if ("string" !== typeof a) throw Error(n(284));
            if (!c._owner) throw Error(n(290, a));
        }
        return a;
    }
    function Gd(a, b) {
        a = Object.prototype.toString.call(b);
        throw Error(n(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
    }
    function Hd(a) {
        var b = a._init;
        return b(a._payload);
    }
    function Id(a) {
        function b(b, c) {
            if (a) {
                var d = b.deletions;
                null === d ? (b.deletions = [
                    c
                ], b.flags |= 16) : d.push(c);
            }
        }
        function c(c, d) {
            if (!a) return null;
            for(; null !== d;)b(c, d), d = d.sibling;
            return null;
        }
        function d(a, b) {
            for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
            return a;
        }
        function e(a, b) {
            a = Jd(a, b);
            a.index = 0;
            a.sibling = null;
            return a;
        }
        function f(b, c, d) {
            b.index = d;
            if (!a) return b.flags |= 1048576, c;
            d = b.alternate;
            if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
            b.flags |= 2;
            return c;
        }
        function g(b) {
            a && null === b.alternate && (b.flags |= 2);
            return b;
        }
        function h(a, b, c, d) {
            if (null === b || 6 !== b.tag) return b = Kd(c, a.mode, d), b.return = a, b;
            b = e(b, c);
            b.return = a;
            return b;
        }
        function k(a, b, c, d) {
            var f = c.type;
            if (f === ha) return m(a, b, c.props.children, d, c.key);
            if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === qa && Hd(f) === b.type)) return d = e(b, c.props), d.ref = Fd(a, b, c), d.return = a, d;
            d = Ld(c.type, c.key, c.props, null, a.mode, d);
            d.ref = Fd(a, b, c);
            d.return = a;
            return d;
        }
        function l(a, b, c, d) {
            if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Md(c, a.mode, d), b.return = a, b;
            b = e(b, c.children || []);
            b.return = a;
            return b;
        }
        function m(a, b, c, d, f) {
            if (null === b || 7 !== b.tag) return b = Nd(c, a.mode, d, f), b.return = a, b;
            b = e(b, c);
            b.return = a;
            return b;
        }
        function r(a, b, c) {
            if ("string" === typeof b && "" !== b || "number" === typeof b) return b = Kd("" + b, a.mode, c), b.return = a, b;
            if ("object" === typeof b && null !== b) {
                switch(b.$$typeof){
                    case ea:
                        return c = Ld(b.type, b.key, b.props, null, a.mode, c), c.ref = Fd(a, null, b), c.return = a, c;
                    case fa:
                        return b = Md(b, a.mode, c), b.return = a, b;
                    case qa:
                        var d = b._init;
                        return r(a, d(b._payload), c);
                }
                if (Da(b) || ta(b)) return b = Nd(b, a.mode, c, null), b.return = a, b;
                Gd(a, b);
            }
            return null;
        }
        function p(a, b, c, d) {
            var e = null !== b ? b.key : null;
            if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
            if ("object" === typeof c && null !== c) {
                switch(c.$$typeof){
                    case ea:
                        return c.key === e ? k(a, b, c, d) : null;
                    case fa:
                        return c.key === e ? l(a, b, c, d) : null;
                    case qa:
                        return e = c._init, p(a, b, e(c._payload), d);
                }
                if (Da(c) || ta(c)) return null !== e ? null : m(a, b, c, d, null);
                Gd(a, c);
            }
            return null;
        }
        function B(a, b, c, d, e) {
            if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
            if ("object" === typeof d && null !== d) {
                switch(d.$$typeof){
                    case ea:
                        return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                    case fa:
                        return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                    case qa:
                        var f = d._init;
                        return B(a, b, c, f(d._payload), e);
                }
                if (Da(d) || ta(d)) return a = a.get(c) || null, m(b, a, d, e, null);
                Gd(b, d);
            }
            return null;
        }
        function w(e, g, h, k) {
            for(var l = null, m = null, u = g, t = g = 0, E = null; null !== u && t < h.length; t++){
                u.index > t ? (E = u, u = null) : E = u.sibling;
                var y = p(e, u, h[t], k);
                if (null === y) {
                    null === u && (u = E);
                    break;
                }
                a && u && null === y.alternate && b(e, u);
                g = f(y, g, t);
                null === m ? l = y : m.sibling = y;
                m = y;
                u = E;
            }
            if (t === h.length) return c(e, u), F && kd(e, t), l;
            if (null === u) {
                for(; t < h.length; t++)u = r(e, h[t], k), null !== u && (g = f(u, g, t), null === m ? l = u : m.sibling = u, m = u);
                F && kd(e, t);
                return l;
            }
            for(u = d(e, u); t < h.length; t++)E = B(u, e, t, h[t], k), null !== E && (a && null !== E.alternate && u.delete(null === E.key ? t : E.key), g = f(E, g, t), null === m ? l = E : m.sibling = E, m = E);
            a && u.forEach(function(a) {
                return b(e, a);
            });
            F && kd(e, t);
            return l;
        }
        function Y(e, g, h, k) {
            var l = ta(h);
            if ("function" !== typeof l) throw Error(n(150));
            h = l.call(h);
            if (null == h) throw Error(n(151));
            for(var u = l = null, m = g, t = g = 0, E = null, y = h.next(); null !== m && !y.done; t++, y = h.next()){
                m.index > t ? (E = m, m = null) : E = m.sibling;
                var w = p(e, m, y.value, k);
                if (null === w) {
                    null === m && (m = E);
                    break;
                }
                a && m && null === w.alternate && b(e, m);
                g = f(w, g, t);
                null === u ? l = w : u.sibling = w;
                u = w;
                m = E;
            }
            if (y.done) return c(e, m), F && kd(e, t), l;
            if (null === m) {
                for(; !y.done; t++, y = h.next())y = r(e, y.value, k), null !== y && (g = f(y, g, t), null === u ? l = y : u.sibling = y, u = y);
                F && kd(e, t);
                return l;
            }
            for(m = d(e, m); !y.done; t++, y = h.next())y = B(m, e, t, y.value, k), null !== y && (a && null !== y.alternate && m.delete(null === y.key ? t : y.key), g = f(y, g, t), null === u ? l = y : u.sibling = y, u = y);
            a && m.forEach(function(a) {
                return b(e, a);
            });
            F && kd(e, t);
            return l;
        }
        function ya(a, d, f, h) {
            "object" === typeof f && null !== f && f.type === ha && null === f.key && (f = f.props.children);
            if ("object" === typeof f && null !== f) {
                switch(f.$$typeof){
                    case ea:
                        a: {
                            for(var k = f.key, l = d; null !== l;){
                                if (l.key === k) {
                                    k = f.type;
                                    if (k === ha) {
                                        if (7 === l.tag) {
                                            c(a, l.sibling);
                                            d = e(l, f.props.children);
                                            d.return = a;
                                            a = d;
                                            break a;
                                        }
                                    } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === qa && Hd(k) === l.type) {
                                        c(a, l.sibling);
                                        d = e(l, f.props);
                                        d.ref = Fd(a, l, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    c(a, l);
                                    break;
                                } else b(a, l);
                                l = l.sibling;
                            }
                            f.type === ha ? (d = Nd(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Ld(f.type, f.key, f.props, null, a.mode, h), h.ref = Fd(a, d, f), h.return = a, a = h);
                        }
                        return g(a);
                    case fa:
                        a: {
                            for(l = f.key; null !== d;){
                                if (d.key === l) {
                                    if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                        c(a, d.sibling);
                                        d = e(d, f.children || []);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    } else {
                                        c(a, d);
                                        break;
                                    }
                                } else b(a, d);
                                d = d.sibling;
                            }
                            d = Md(f, a.mode, h);
                            d.return = a;
                            a = d;
                        }
                        return g(a);
                    case qa:
                        return l = f._init, ya(a, d, l(f._payload), h);
                }
                if (Da(f)) return w(a, d, f, h);
                if (ta(f)) return Y(a, d, f, h);
                Gd(a, f);
            }
            return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Kd(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
        }
        return ya;
    }
    var Od = Id(!0), Pd = Id(!1), Qd = ic(null), Rd = null, Sd = null, Td = null;
    function Ud() {
        Td = Sd = Rd = null;
    }
    function Vd(a, b, c) {
        Sa ? (v(Qd, b._currentValue), b._currentValue = c) : (v(Qd, b._currentValue2), b._currentValue2 = c);
    }
    function Wd(a) {
        var b = Qd.current;
        q(Qd);
        Sa ? a._currentValue = b : a._currentValue2 = b;
    }
    function Xd(a, b, c) {
        for(; null !== a;){
            var d = a.alternate;
            (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
            if (a === c) break;
            a = a.return;
        }
    }
    function Yd(a, b) {
        Rd = a;
        Td = Sd = null;
        a = a.dependencies;
        null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (G = !0), a.firstContext = null);
    }
    function Zd(a) {
        var b = Sa ? a._currentValue : a._currentValue2;
        if (Td !== a) {
            if (a = {
                context: a,
                memoizedValue: b,
                next: null
            }, null === Sd) {
                if (null === Rd) throw Error(n(308));
                Sd = a;
                Rd.dependencies = {
                    lanes: 0,
                    firstContext: a
                };
            } else Sd = Sd.next = a;
        }
        return b;
    }
    var $d = null;
    function ae(a) {
        null === $d ? $d = [
            a
        ] : $d.push(a);
    }
    function be(a, b, c, d) {
        var e = b.interleaved;
        null === e ? (c.next = c, ae(b)) : (c.next = e.next, e.next = c);
        b.interleaved = c;
        return ce(a, d);
    }
    function ce(a, b) {
        a.lanes |= b;
        var c = a.alternate;
        null !== c && (c.lanes |= b);
        c = a;
        for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
        return 3 === c.tag ? c.stateNode : null;
    }
    var de = !1;
    function ee(a) {
        a.updateQueue = {
            baseState: a.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null,
                interleaved: null,
                lanes: 0
            },
            effects: null
        };
    }
    function fe(a, b) {
        a = a.updateQueue;
        b.updateQueue === a && (b.updateQueue = {
            baseState: a.baseState,
            firstBaseUpdate: a.firstBaseUpdate,
            lastBaseUpdate: a.lastBaseUpdate,
            shared: a.shared,
            effects: a.effects
        });
    }
    function ge(a, b) {
        return {
            eventTime: a,
            lane: b,
            tag: 0,
            payload: null,
            callback: null,
            next: null
        };
    }
    function he(a, b, c) {
        var d = a.updateQueue;
        if (null === d) return null;
        d = d.shared;
        if (0 !== (H & 2)) {
            var e = d.pending;
            null === e ? b.next = b : (b.next = e.next, e.next = b);
            d.pending = b;
            return ce(a, c);
        }
        e = d.interleaved;
        null === e ? (b.next = b, ae(d)) : (b.next = e.next, e.next = b);
        d.interleaved = b;
        return ce(a, c);
    }
    function ie(a, b, c) {
        b = b.updateQueue;
        if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
            var d = b.lanes;
            d &= a.pendingLanes;
            c |= d;
            b.lanes = c;
            Hc(a, c);
        }
    }
    function je(a, b) {
        var c = a.updateQueue, d = a.alternate;
        if (null !== d && (d = d.updateQueue, c === d)) {
            var e = null, f = null;
            c = c.firstBaseUpdate;
            if (null !== c) {
                do {
                    var g = {
                        eventTime: c.eventTime,
                        lane: c.lane,
                        tag: c.tag,
                        payload: c.payload,
                        callback: c.callback,
                        next: null
                    };
                    null === f ? e = f = g : f = f.next = g;
                    c = c.next;
                }while (null !== c);
                null === f ? e = f = b : f = f.next = b;
            } else e = f = b;
            c = {
                baseState: d.baseState,
                firstBaseUpdate: e,
                lastBaseUpdate: f,
                shared: d.shared,
                effects: d.effects
            };
            a.updateQueue = c;
            return;
        }
        a = c.lastBaseUpdate;
        null === a ? c.firstBaseUpdate = b : a.next = b;
        c.lastBaseUpdate = b;
    }
    function ke(a, b, c, d) {
        var e = a.updateQueue;
        de = !1;
        var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
        if (null !== h) {
            e.shared.pending = null;
            var k = h, l = k.next;
            k.next = null;
            null === g ? f = l : g.next = l;
            g = k;
            var m = a.alternate;
            null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
        }
        if (null !== f) {
            var r = e.baseState;
            g = 0;
            m = l = k = null;
            h = f;
            do {
                var p = h.lane, B = h.eventTime;
                if ((d & p) === p) {
                    null !== m && (m = m.next = {
                        eventTime: B,
                        lane: 0,
                        tag: h.tag,
                        payload: h.payload,
                        callback: h.callback,
                        next: null
                    });
                    a: {
                        var w = a, Y = h;
                        p = b;
                        B = c;
                        switch(Y.tag){
                            case 1:
                                w = Y.payload;
                                if ("function" === typeof w) {
                                    r = w.call(B, r, p);
                                    break a;
                                }
                                r = w;
                                break a;
                            case 3:
                                w.flags = w.flags & -65537 | 128;
                            case 0:
                                w = Y.payload;
                                p = "function" === typeof w ? w.call(B, r, p) : w;
                                if (null === p || void 0 === p) break a;
                                r = ca({}, r, p);
                                break a;
                            case 2:
                                de = !0;
                        }
                    }
                    null !== h.callback && 0 !== h.lane && (a.flags |= 64, p = e.effects, null === p ? e.effects = [
                        h
                    ] : p.push(h));
                } else B = {
                    eventTime: B,
                    lane: p,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                }, null === m ? (l = m = B, k = r) : m = m.next = B, g |= p;
                h = h.next;
                if (null === h) {
                    if (h = e.shared.pending, null === h) break;
                    else p = h, h = p.next, p.next = null, e.lastBaseUpdate = p, e.shared.pending = null;
                }
            }while (1);
            null === m && (k = r);
            e.baseState = k;
            e.firstBaseUpdate = l;
            e.lastBaseUpdate = m;
            b = e.shared.interleaved;
            if (null !== b) {
                e = b;
                do g |= e.lane, e = e.next;
                while (e !== b);
            } else null === f && (e.shared.lanes = 0);
            le |= g;
            a.lanes = g;
            a.memoizedState = r;
        }
    }
    function me(a, b, c) {
        a = b.effects;
        b.effects = null;
        if (null !== a) for(b = 0; b < a.length; b++){
            var d = a[b], e = d.callback;
            if (null !== e) {
                d.callback = null;
                d = c;
                if ("function" !== typeof e) throw Error(n(191, e));
                e.call(d);
            }
        }
    }
    var ne = {}, oe = ic(ne), pe = ic(ne), qe = ic(ne);
    function re(a) {
        if (a === ne) throw Error(n(174));
        return a;
    }
    function se(a, b) {
        v(qe, b);
        v(pe, a);
        v(oe, ne);
        a = Fa(b);
        q(oe);
        v(oe, a);
    }
    function te() {
        q(oe);
        q(pe);
        q(qe);
    }
    function ue(a) {
        var b = re(qe.current), c = re(oe.current);
        b = Ga(c, a.type, b);
        c !== b && (v(pe, a), v(oe, b));
    }
    function ve(a) {
        pe.current === a && (q(oe), q(pe));
    }
    var I = ic(0);
    function we(a) {
        for(var b = a; null !== b;){
            if (13 === b.tag) {
                var c = b.memoizedState;
                if (null !== c && (c = c.dehydrated, null === c || Jb(c) || Kb(c))) return b;
            } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
                if (0 !== (b.flags & 128)) return b;
            } else if (null !== b.child) {
                b.child.return = b;
                b = b.child;
                continue;
            }
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
        return null;
    }
    var xe = [];
    function ye() {
        for(var a = 0; a < xe.length; a++){
            var b = xe[a];
            Sa ? b._workInProgressVersionPrimary = null : b._workInProgressVersionSecondary = null;
        }
        xe.length = 0;
    }
    var ze = da.ReactCurrentDispatcher, Ae = da.ReactCurrentBatchConfig, Be = 0, J = null, K = null, L = null, Ce = !1, De = !1, Ee = 0, Fe = 0;
    function M() {
        throw Error(n(321));
    }
    function Ge(a, b) {
        if (null === b) return !1;
        for(var c = 0; c < b.length && c < a.length; c++)if (!Vc(a[c], b[c])) return !1;
        return !0;
    }
    function He(a, b, c, d, e, f) {
        Be = f;
        J = b;
        b.memoizedState = null;
        b.updateQueue = null;
        b.lanes = 0;
        ze.current = null === a || null === a.memoizedState ? Ie : Je;
        a = c(d, e);
        if (De) {
            f = 0;
            do {
                De = !1;
                Ee = 0;
                if (25 <= f) throw Error(n(301));
                f += 1;
                L = K = null;
                b.updateQueue = null;
                ze.current = Ke;
                a = c(d, e);
            }while (De);
        }
        ze.current = Le;
        b = null !== K && null !== K.next;
        Be = 0;
        L = K = J = null;
        Ce = !1;
        if (b) throw Error(n(300));
        return a;
    }
    function Me() {
        var a = 0 !== Ee;
        Ee = 0;
        return a;
    }
    function Ne() {
        var a = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        null === L ? J.memoizedState = L = a : L = L.next = a;
        return L;
    }
    function Oe() {
        if (null === K) {
            var a = J.alternate;
            a = null !== a ? a.memoizedState : null;
        } else a = K.next;
        var b = null === L ? J.memoizedState : L.next;
        if (null !== b) L = b, K = a;
        else {
            if (null === a) throw Error(n(310));
            K = a;
            a = {
                memoizedState: K.memoizedState,
                baseState: K.baseState,
                baseQueue: K.baseQueue,
                queue: K.queue,
                next: null
            };
            null === L ? J.memoizedState = L = a : L = L.next = a;
        }
        return L;
    }
    function Pe(a, b) {
        return "function" === typeof b ? b(a) : b;
    }
    function Qe(a) {
        var b = Oe(), c = b.queue;
        if (null === c) throw Error(n(311));
        c.lastRenderedReducer = a;
        var d = K, e = d.baseQueue, f = c.pending;
        if (null !== f) {
            if (null !== e) {
                var g = e.next;
                e.next = f.next;
                f.next = g;
            }
            d.baseQueue = e = f;
            c.pending = null;
        }
        if (null !== e) {
            f = e.next;
            d = d.baseState;
            var h = g = null, k = null, l = f;
            do {
                var m = l.lane;
                if ((Be & m) === m) null !== k && (k = k.next = {
                    lane: 0,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
                else {
                    var r = {
                        lane: m,
                        action: l.action,
                        hasEagerState: l.hasEagerState,
                        eagerState: l.eagerState,
                        next: null
                    };
                    null === k ? (h = k = r, g = d) : k = k.next = r;
                    J.lanes |= m;
                    le |= m;
                }
                l = l.next;
            }while (null !== l && l !== f);
            null === k ? g = d : k.next = h;
            Vc(d, b.memoizedState) || (G = !0);
            b.memoizedState = d;
            b.baseState = g;
            b.baseQueue = k;
            c.lastRenderedState = d;
        }
        a = c.interleaved;
        if (null !== a) {
            e = a;
            do f = e.lane, J.lanes |= f, le |= f, e = e.next;
            while (e !== a);
        } else null === e && (c.lanes = 0);
        return [
            b.memoizedState,
            c.dispatch
        ];
    }
    function Re(a) {
        var b = Oe(), c = b.queue;
        if (null === c) throw Error(n(311));
        c.lastRenderedReducer = a;
        var d = c.dispatch, e = c.pending, f = b.memoizedState;
        if (null !== e) {
            c.pending = null;
            var g = e = e.next;
            do f = a(f, g.action), g = g.next;
            while (g !== e);
            Vc(f, b.memoizedState) || (G = !0);
            b.memoizedState = f;
            null === b.baseQueue && (b.baseState = f);
            c.lastRenderedState = f;
        }
        return [
            f,
            d
        ];
    }
    function Se() {}
    function Te(a, b) {
        var c = J, d = Oe(), e = b(), f = !Vc(d.memoizedState, e);
        f && (d.memoizedState = e, G = !0);
        d = d.queue;
        Ue(Ve.bind(null, c, d, a), [
            a
        ]);
        if (d.getSnapshot !== b || f || null !== L && L.memoizedState.tag & 1) {
            c.flags |= 2048;
            We(9, Xe.bind(null, c, d, e, b), void 0, null);
            if (null === N) throw Error(n(349));
            0 !== (Be & 30) || Ye(c, b, e);
        }
        return e;
    }
    function Ye(a, b, c) {
        a.flags |= 16384;
        a = {
            getSnapshot: b,
            value: c
        };
        b = J.updateQueue;
        null === b ? (b = {
            lastEffect: null,
            stores: null
        }, J.updateQueue = b, b.stores = [
            a
        ]) : (c = b.stores, null === c ? b.stores = [
            a
        ] : c.push(a));
    }
    function Xe(a, b, c, d) {
        b.value = c;
        b.getSnapshot = d;
        Ze(b) && $e(a);
    }
    function Ve(a, b, c) {
        return c(function() {
            Ze(b) && $e(a);
        });
    }
    function Ze(a) {
        var b = a.getSnapshot;
        a = a.value;
        try {
            var c = b();
            return !Vc(a, c);
        } catch (d) {
            return !0;
        }
    }
    function $e(a) {
        var b = ce(a, 1);
        null !== b && af(b, a, 1, -1);
    }
    function bf(a) {
        var b = Ne();
        "function" === typeof a && (a = a());
        b.memoizedState = b.baseState = a;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: Pe,
            lastRenderedState: a
        };
        b.queue = a;
        a = a.dispatch = cf.bind(null, J, a);
        return [
            b.memoizedState,
            a
        ];
    }
    function We(a, b, c, d) {
        a = {
            tag: a,
            create: b,
            destroy: c,
            deps: d,
            next: null
        };
        b = J.updateQueue;
        null === b ? (b = {
            lastEffect: null,
            stores: null
        }, J.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
        return a;
    }
    function df() {
        return Oe().memoizedState;
    }
    function ef(a, b, c, d) {
        var e = Ne();
        J.flags |= a;
        e.memoizedState = We(1 | b, c, void 0, void 0 === d ? null : d);
    }
    function ff(a, b, c, d) {
        var e = Oe();
        d = void 0 === d ? null : d;
        var f = void 0;
        if (null !== K) {
            var g = K.memoizedState;
            f = g.destroy;
            if (null !== d && Ge(d, g.deps)) {
                e.memoizedState = We(b, c, f, d);
                return;
            }
        }
        J.flags |= a;
        e.memoizedState = We(1 | b, c, f, d);
    }
    function gf(a, b) {
        return ef(8390656, 8, a, b);
    }
    function Ue(a, b) {
        return ff(2048, 8, a, b);
    }
    function hf(a, b) {
        return ff(4, 2, a, b);
    }
    function jf(a, b) {
        return ff(4, 4, a, b);
    }
    function kf(a, b) {
        if ("function" === typeof b) return a = a(), b(a), function() {
            b(null);
        };
        if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
            b.current = null;
        };
    }
    function lf(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return ff(4, 4, kf.bind(null, b, a), c);
    }
    function mf() {}
    function nf(a, b) {
        var c = Oe();
        b = void 0 === b ? null : b;
        var d = c.memoizedState;
        if (null !== d && null !== b && Ge(b, d[1])) return d[0];
        c.memoizedState = [
            a,
            b
        ];
        return a;
    }
    function of(a, b) {
        var c = Oe();
        b = void 0 === b ? null : b;
        var d = c.memoizedState;
        if (null !== d && null !== b && Ge(b, d[1])) return d[0];
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    }
    function pf(a, b, c) {
        if (0 === (Be & 21)) return a.baseState && (a.baseState = !1, G = !0), a.memoizedState = c;
        Vc(c, b) || (c = Dc(), J.lanes |= c, le |= c, a.baseState = !0);
        return b;
    }
    function qf(a, b) {
        var c = C;
        C = 0 !== c && 4 > c ? c : 4;
        a(!0);
        var d = Ae.transition;
        Ae.transition = {};
        try {
            a(!1), b();
        } finally{
            C = c, Ae.transition = d;
        }
    }
    function rf() {
        return Oe().memoizedState;
    }
    function sf(a, b, c) {
        var d = tf(a);
        c = {
            lane: d,
            action: c,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        if (uf(a)) vf(b, c);
        else if (c = be(a, b, c, d), null !== c) {
            var e = O();
            af(c, a, d, e);
            wf(c, b, d);
        }
    }
    function cf(a, b, c) {
        var d = tf(a), e = {
            lane: d,
            action: c,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        if (uf(a)) vf(b, e);
        else {
            var f = a.alternate;
            if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
                var g = b.lastRenderedState, h = f(g, c);
                e.hasEagerState = !0;
                e.eagerState = h;
                if (Vc(h, g)) {
                    var k = b.interleaved;
                    null === k ? (e.next = e, ae(b)) : (e.next = k.next, k.next = e);
                    b.interleaved = e;
                    return;
                }
            } catch (l) {} finally{}
            c = be(a, b, e, d);
            null !== c && (e = O(), af(c, a, d, e), wf(c, b, d));
        }
    }
    function uf(a) {
        var b = a.alternate;
        return a === J || null !== b && b === J;
    }
    function vf(a, b) {
        De = Ce = !0;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
    function wf(a, b, c) {
        if (0 !== (c & 4194240)) {
            var d = b.lanes;
            d &= a.pendingLanes;
            c |= d;
            b.lanes = c;
            Hc(a, c);
        }
    }
    var Le = {
        readContext: Zd,
        useCallback: M,
        useContext: M,
        useEffect: M,
        useImperativeHandle: M,
        useInsertionEffect: M,
        useLayoutEffect: M,
        useMemo: M,
        useReducer: M,
        useRef: M,
        useState: M,
        useDebugValue: M,
        useDeferredValue: M,
        useTransition: M,
        useMutableSource: M,
        useSyncExternalStore: M,
        useId: M,
        unstable_isNewReconciler: !1
    }, Ie = {
        readContext: Zd,
        useCallback: function(a, b) {
            Ne().memoizedState = [
                a,
                void 0 === b ? null : b
            ];
            return a;
        },
        useContext: Zd,
        useEffect: gf,
        useImperativeHandle: function(a, b, c) {
            c = null !== c && void 0 !== c ? c.concat([
                a
            ]) : null;
            return ef(4194308, 4, kf.bind(null, b, a), c);
        },
        useLayoutEffect: function(a, b) {
            return ef(4194308, 4, a, b);
        },
        useInsertionEffect: function(a, b) {
            return ef(4, 2, a, b);
        },
        useMemo: function(a, b) {
            var c = Ne();
            b = void 0 === b ? null : b;
            a = a();
            c.memoizedState = [
                a,
                b
            ];
            return a;
        },
        useReducer: function(a, b, c) {
            var d = Ne();
            b = void 0 !== c ? c(b) : b;
            d.memoizedState = d.baseState = b;
            a = {
                pending: null,
                interleaved: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: a,
                lastRenderedState: b
            };
            d.queue = a;
            a = a.dispatch = sf.bind(null, J, a);
            return [
                d.memoizedState,
                a
            ];
        },
        useRef: function(a) {
            var b = Ne();
            a = {
                current: a
            };
            return b.memoizedState = a;
        },
        useState: bf,
        useDebugValue: mf,
        useDeferredValue: function(a) {
            return Ne().memoizedState = a;
        },
        useTransition: function() {
            var a = bf(!1), b = a[0];
            a = qf.bind(null, a[1]);
            Ne().memoizedState = a;
            return [
                b,
                a
            ];
        },
        useMutableSource: function() {},
        useSyncExternalStore: function(a, b, c) {
            var d = J, e = Ne();
            if (F) {
                if (void 0 === c) throw Error(n(407));
                c = c();
            } else {
                c = b();
                if (null === N) throw Error(n(349));
                0 !== (Be & 30) || Ye(d, b, c);
            }
            e.memoizedState = c;
            var f = {
                value: c,
                getSnapshot: b
            };
            e.queue = f;
            gf(Ve.bind(null, d, f, a), [
                a
            ]);
            d.flags |= 2048;
            We(9, Xe.bind(null, d, f, c, b), void 0, null);
            return c;
        },
        useId: function() {
            var a = Ne(), b = N.identifierPrefix;
            if (F) {
                var c = jd;
                var d = id;
                c = (d & ~(1 << 32 - tc(d) - 1)).toString(32) + c;
                b = ":" + b + "R" + c;
                c = Ee++;
                0 < c && (b += "H" + c.toString(32));
                b += ":";
            } else c = Fe++, b = ":" + b + "r" + c.toString(32) + ":";
            return a.memoizedState = b;
        },
        unstable_isNewReconciler: !1
    }, Je = {
        readContext: Zd,
        useCallback: nf,
        useContext: Zd,
        useEffect: Ue,
        useImperativeHandle: lf,
        useInsertionEffect: hf,
        useLayoutEffect: jf,
        useMemo: of,
        useReducer: Qe,
        useRef: df,
        useState: function() {
            return Qe(Pe);
        },
        useDebugValue: mf,
        useDeferredValue: function(a) {
            var b = Oe();
            return pf(b, K.memoizedState, a);
        },
        useTransition: function() {
            var a = Qe(Pe)[0], b = Oe().memoizedState;
            return [
                a,
                b
            ];
        },
        useMutableSource: Se,
        useSyncExternalStore: Te,
        useId: rf,
        unstable_isNewReconciler: !1
    }, Ke = {
        readContext: Zd,
        useCallback: nf,
        useContext: Zd,
        useEffect: Ue,
        useImperativeHandle: lf,
        useInsertionEffect: hf,
        useLayoutEffect: jf,
        useMemo: of,
        useReducer: Re,
        useRef: df,
        useState: function() {
            return Re(Pe);
        },
        useDebugValue: mf,
        useDeferredValue: function(a) {
            var b = Oe();
            return null === K ? b.memoizedState = a : pf(b, K.memoizedState, a);
        },
        useTransition: function() {
            var a = Re(Pe)[0], b = Oe().memoizedState;
            return [
                a,
                b
            ];
        },
        useMutableSource: Se,
        useSyncExternalStore: Te,
        useId: rf,
        unstable_isNewReconciler: !1
    };
    function xf(a, b) {
        if (a && a.defaultProps) {
            b = ca({}, b);
            a = a.defaultProps;
            for(var c in a)void 0 === b[c] && (b[c] = a[c]);
            return b;
        }
        return b;
    }
    function yf(a, b, c, d) {
        b = a.memoizedState;
        c = c(d, b);
        c = null === c || void 0 === c ? b : ca({}, b, c);
        a.memoizedState = c;
        0 === a.lanes && (a.updateQueue.baseState = c);
    }
    var zf = {
        isMounted: function(a) {
            return (a = a._reactInternals) ? wa(a) === a : !1;
        },
        enqueueSetState: function(a, b, c) {
            a = a._reactInternals;
            var d = O(), e = tf(a), f = ge(d, e);
            f.payload = b;
            void 0 !== c && null !== c && (f.callback = c);
            b = he(a, f, e);
            null !== b && (af(b, a, e, d), ie(b, a, e));
        },
        enqueueReplaceState: function(a, b, c) {
            a = a._reactInternals;
            var d = O(), e = tf(a), f = ge(d, e);
            f.tag = 1;
            f.payload = b;
            void 0 !== c && null !== c && (f.callback = c);
            b = he(a, f, e);
            null !== b && (af(b, a, e, d), ie(b, a, e));
        },
        enqueueForceUpdate: function(a, b) {
            a = a._reactInternals;
            var c = O(), d = tf(a), e = ge(c, d);
            e.tag = 2;
            void 0 !== b && null !== b && (e.callback = b);
            b = he(a, e, d);
            null !== b && (af(b, a, d, c), ie(b, a, d));
        }
    };
    function Af(a, b, c, d, e, f, g) {
        a = a.stateNode;
        return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Dd(c, d) || !Dd(e, f) : !0;
    }
    function Bf(a, b, c) {
        var d = !1, e = jc;
        var f = b.contextType;
        "object" === typeof f && null !== f ? f = Zd(f) : (e = A(b) ? kc : x.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? mc(a, e) : jc);
        b = new b(c, f);
        a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
        b.updater = zf;
        a.stateNode = b;
        b._reactInternals = a;
        d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
        return b;
    }
    function Cf(a, b, c, d) {
        a = b.state;
        "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
        "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
        b.state !== a && zf.enqueueReplaceState(b, b.state, null);
    }
    function Df(a, b, c, d) {
        var e = a.stateNode;
        e.props = c;
        e.state = a.memoizedState;
        e.refs = {};
        ee(a);
        var f = b.contextType;
        "object" === typeof f && null !== f ? e.context = Zd(f) : (f = A(b) ? kc : x.current, e.context = mc(a, f));
        e.state = a.memoizedState;
        f = b.getDerivedStateFromProps;
        "function" === typeof f && (yf(a, b, f, c), e.state = a.memoizedState);
        "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && zf.enqueueReplaceState(e, e.state, null), ke(a, c, e, d), e.state = a.memoizedState);
        "function" === typeof e.componentDidMount && (a.flags |= 4194308);
    }
    function Ef(a, b) {
        try {
            var c = "", d = b;
            do c += Ed(d), d = d.return;
            while (d);
            var e = c;
        } catch (f) {
            e = "\nError generating stack: " + f.message + "\n" + f.stack;
        }
        return {
            value: a,
            source: b,
            stack: e,
            digest: null
        };
    }
    function Ff(a, b, c) {
        return {
            value: a,
            source: null,
            stack: null != c ? c : null,
            digest: null != b ? b : null
        };
    }
    function Gf(a, b) {
        try {
            console.error(b.value);
        } catch (c) {
            setTimeout(function() {
                throw c;
            });
        }
    }
    var Hf = "function" === typeof WeakMap ? WeakMap : Map;
    function If(a, b, c) {
        c = ge(-1, c);
        c.tag = 3;
        c.payload = {
            element: null
        };
        var d = b.value;
        c.callback = function() {
            Jf || (Jf = !0, Kf = d);
            Gf(a, b);
        };
        return c;
    }
    function Lf(a, b, c) {
        c = ge(-1, c);
        c.tag = 3;
        var d = a.type.getDerivedStateFromError;
        if ("function" === typeof d) {
            var e = b.value;
            c.payload = function() {
                return d(e);
            };
            c.callback = function() {
                Gf(a, b);
            };
        }
        var f = a.stateNode;
        null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
            Gf(a, b);
            "function" !== typeof d && (null === Mf ? Mf = new Set([
                this
            ]) : Mf.add(this));
            var c = b.stack;
            this.componentDidCatch(b.value, {
                componentStack: null !== c ? c : ""
            });
        });
        return c;
    }
    function Nf(a, b, c) {
        var d = a.pingCache;
        if (null === d) {
            d = a.pingCache = new Hf;
            var e = new Set;
            d.set(b, e);
        } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
        e.has(c) || (e.add(c), a = Of.bind(null, a, b, c), b.then(a, a));
    }
    function Pf(a) {
        do {
            var b;
            if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
            if (b) return a;
            a = a.return;
        }while (null !== a);
        return null;
    }
    function Qf(a, b, c, d, e) {
        if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = ge(-1, 1), b.tag = 2, he(c, b, 1))), c.lanes |= 1), a;
        a.flags |= 65536;
        a.lanes = e;
        return a;
    }
    var Rf = da.ReactCurrentOwner, G = !1;
    function P(a, b, c, d) {
        b.child = null === a ? Pd(b, null, c, d) : Od(b, a.child, c, d);
    }
    function Sf(a, b, c, d, e) {
        c = c.render;
        var f = b.ref;
        Yd(b, e);
        d = He(a, b, c, d, f, e);
        c = Me();
        if (null !== a && !G) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Tf(a, b, e);
        F && c && md(b);
        b.flags |= 1;
        P(a, b, d, e);
        return b.child;
    }
    function Uf(a, b, c, d, e) {
        if (null === a) {
            var f = c.type;
            if ("function" === typeof f && !Vf(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, Wf(a, b, f, d, e);
            a = Ld(c.type, null, d, b, b.mode, e);
            a.ref = b.ref;
            a.return = b;
            return b.child = a;
        }
        f = a.child;
        if (0 === (a.lanes & e)) {
            var g = f.memoizedProps;
            c = c.compare;
            c = null !== c ? c : Dd;
            if (c(g, d) && a.ref === b.ref) return Tf(a, b, e);
        }
        b.flags |= 1;
        a = Jd(f, d);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    function Wf(a, b, c, d, e) {
        if (null !== a) {
            var f = a.memoizedProps;
            if (Dd(f, d) && a.ref === b.ref) {
                if (G = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (G = !0);
                else return b.lanes = a.lanes, Tf(a, b, e);
            }
        }
        return Xf(a, b, c, d, e);
    }
    function Yf(a, b, c) {
        var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
        if ("hidden" === d.mode) {
            if (0 === (b.mode & 1)) b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            }, v(Zf, $f), $f |= c;
            else {
                if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                    baseLanes: a,
                    cachePool: null,
                    transitions: null
                }, b.updateQueue = null, v(Zf, $f), $f |= a, null;
                b.memoizedState = {
                    baseLanes: 0,
                    cachePool: null,
                    transitions: null
                };
                d = null !== f ? f.baseLanes : c;
                v(Zf, $f);
                $f |= d;
            }
        } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, v(Zf, $f), $f |= d;
        P(a, b, e, c);
        return b.child;
    }
    function ag(a, b) {
        var c = b.ref;
        if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
    }
    function Xf(a, b, c, d, e) {
        var f = A(c) ? kc : x.current;
        f = mc(b, f);
        Yd(b, e);
        c = He(a, b, c, d, f, e);
        d = Me();
        if (null !== a && !G) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Tf(a, b, e);
        F && d && md(b);
        b.flags |= 1;
        P(a, b, c, e);
        return b.child;
    }
    function bg(a, b, c, d, e) {
        if (A(c)) {
            var f = !0;
            qc(b);
        } else f = !1;
        Yd(b, e);
        if (null === b.stateNode) cg(a, b), Bf(b, c, d), Df(b, c, d, e), d = !0;
        else if (null === a) {
            var g = b.stateNode, h = b.memoizedProps;
            g.props = h;
            var k = g.context, l = c.contextType;
            "object" === typeof l && null !== l ? l = Zd(l) : (l = A(c) ? kc : x.current, l = mc(b, l));
            var m = c.getDerivedStateFromProps, r = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
            r || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Cf(b, g, d, l);
            de = !1;
            var p = b.memoizedState;
            g.state = p;
            ke(b, d, g, e);
            k = b.memoizedState;
            h !== d || p !== k || z.current || de ? ("function" === typeof m && (yf(b, c, m, d), k = b.memoizedState), (h = de || Af(b, c, h, d, p, k, l)) ? (r || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
        } else {
            g = b.stateNode;
            fe(a, b);
            h = b.memoizedProps;
            l = b.type === b.elementType ? h : xf(b.type, h);
            g.props = l;
            r = b.pendingProps;
            p = g.context;
            k = c.contextType;
            "object" === typeof k && null !== k ? k = Zd(k) : (k = A(c) ? kc : x.current, k = mc(b, k));
            var B = c.getDerivedStateFromProps;
            (m = "function" === typeof B || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== r || p !== k) && Cf(b, g, d, k);
            de = !1;
            p = b.memoizedState;
            g.state = p;
            ke(b, d, g, e);
            var w = b.memoizedState;
            h !== r || p !== w || z.current || de ? ("function" === typeof B && (yf(b, c, B, d), w = b.memoizedState), (l = de || Af(b, c, l, d, p, w, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, w, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, w, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = w), g.props = d, g.state = w, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 1024), d = !1);
        }
        return dg(a, b, c, d, f, e);
    }
    function dg(a, b, c, d, e, f) {
        ag(a, b);
        var g = 0 !== (b.flags & 128);
        if (!d && !g) return e && rc(b, c, !1), Tf(a, b, f);
        d = b.stateNode;
        Rf.current = b;
        var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
        b.flags |= 1;
        null !== a && g ? (b.child = Od(b, a.child, null, f), b.child = Od(b, null, h, f)) : P(a, b, h, f);
        b.memoizedState = d.state;
        e && rc(b, c, !0);
        return b.child;
    }
    function eg(a) {
        var b = a.stateNode;
        b.pendingContext ? oc(a, b.pendingContext, b.pendingContext !== b.context) : b.context && oc(a, b.context, !1);
        se(a, b.containerInfo);
    }
    function fg(a, b, c, d, e) {
        Ad();
        Bd(e);
        b.flags |= 256;
        P(a, b, c, d);
        return b.child;
    }
    var gg = {
        dehydrated: null,
        treeContext: null,
        retryLane: 0
    };
    function hg(a) {
        return {
            baseLanes: a,
            cachePool: null,
            transitions: null
        };
    }
    function ig(a, b, c) {
        var d = b.pendingProps, e = I.current, f = !1, g = 0 !== (b.flags & 128), h;
        (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
        if (h) f = !0, b.flags &= -129;
        else if (null === a || null !== a.memoizedState) e |= 1;
        v(I, e & 1);
        if (null === a) {
            wd(b);
            a = b.memoizedState;
            if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : Kb(a) ? b.lanes = 8 : b.lanes = 1073741824, null;
            g = d.children;
            a = d.fallback;
            return f ? (d = b.mode, f = b.child, g = {
                mode: "hidden",
                children: g
            }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = jg(g, d, 0, null), a = Nd(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = hg(c), b.memoizedState = gg, a) : kg(b, g);
        }
        e = a.memoizedState;
        if (null !== e && (h = e.dehydrated, null !== h)) return lg(a, b, g, d, h, e, c);
        if (f) {
            f = d.fallback;
            g = b.mode;
            e = a.child;
            h = e.sibling;
            var k = {
                mode: "hidden",
                children: d.children
            };
            0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = Jd(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
            null !== h ? f = Jd(h, f) : (f = Nd(f, g, c, null), f.flags |= 2);
            f.return = b;
            d.return = b;
            d.sibling = f;
            b.child = d;
            d = f;
            f = b.child;
            g = a.child.memoizedState;
            g = null === g ? hg(c) : {
                baseLanes: g.baseLanes | c,
                cachePool: null,
                transitions: g.transitions
            };
            f.memoizedState = g;
            f.childLanes = a.childLanes & ~c;
            b.memoizedState = gg;
            return d;
        }
        f = a.child;
        a = f.sibling;
        d = Jd(f, {
            mode: "visible",
            children: d.children
        });
        0 === (b.mode & 1) && (d.lanes = c);
        d.return = b;
        d.sibling = null;
        null !== a && (c = b.deletions, null === c ? (b.deletions = [
            a
        ], b.flags |= 16) : c.push(a));
        b.child = d;
        b.memoizedState = null;
        return d;
    }
    function kg(a, b) {
        b = jg({
            mode: "visible",
            children: b
        }, a.mode, 0, null);
        b.return = a;
        return a.child = b;
    }
    function mg(a, b, c, d) {
        null !== d && Bd(d);
        Od(b, a.child, null, c);
        a = kg(b, b.pendingProps.children);
        a.flags |= 2;
        b.memoizedState = null;
        return a;
    }
    function lg(a, b, c, d, e, f, g) {
        if (c) {
            if (b.flags & 256) return b.flags &= -257, d = Ff(Error(n(422))), mg(a, b, g, d);
            if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
            f = d.fallback;
            e = b.mode;
            d = jg({
                mode: "visible",
                children: d.children
            }, e, 0, null);
            f = Nd(f, e, g, null);
            f.flags |= 2;
            d.return = b;
            f.return = b;
            d.sibling = f;
            b.child = d;
            0 !== (b.mode & 1) && Od(b, a.child, null, g);
            b.child.memoizedState = hg(g);
            b.memoizedState = gg;
            return f;
        }
        if (0 === (b.mode & 1)) return mg(a, b, g, null);
        if (Kb(e)) return d = Lb(e).digest, f = Error(n(419)), d = Ff(f, d, void 0), mg(a, b, g, d);
        c = 0 !== (g & a.childLanes);
        if (G || c) {
            d = N;
            if (null !== d) {
                switch(g & -g){
                    case 4:
                        e = 2;
                        break;
                    case 16:
                        e = 8;
                        break;
                    case 64:
                    case 128:
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                    case 67108864:
                        e = 32;
                        break;
                    case 536870912:
                        e = 268435456;
                        break;
                    default:
                        e = 0;
                }
                e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
                0 !== e && e !== f.retryLane && (f.retryLane = e, ce(a, e), af(d, a, e, -1));
            }
            ng();
            d = Ff(Error(n(421)));
            return mg(a, b, g, d);
        }
        if (Jb(e)) return b.flags |= 128, b.child = a.child, b = og.bind(null, a), Mb(e, b), null;
        a = f.treeContext;
        Va && (pd = Qb(e), od = b, F = !0, rd = null, qd = !1, null !== a && (fd[gd++] = id, fd[gd++] = jd, fd[gd++] = hd, id = a.id, jd = a.overflow, hd = b));
        b = kg(b, d.children);
        b.flags |= 4096;
        return b;
    }
    function pg(a, b, c) {
        a.lanes |= b;
        var d = a.alternate;
        null !== d && (d.lanes |= b);
        Xd(a.return, b, c);
    }
    function qg(a, b, c, d, e) {
        var f = a.memoizedState;
        null === f ? a.memoizedState = {
            isBackwards: b,
            rendering: null,
            renderingStartTime: 0,
            last: d,
            tail: c,
            tailMode: e
        } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
    }
    function rg(a, b, c) {
        var d = b.pendingProps, e = d.revealOrder, f = d.tail;
        P(a, b, d.children, c);
        d = I.current;
        if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
        else {
            if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
                if (13 === a.tag) null !== a.memoizedState && pg(a, c, b);
                else if (19 === a.tag) pg(a, c, b);
                else if (null !== a.child) {
                    a.child.return = a;
                    a = a.child;
                    continue;
                }
                if (a === b) break a;
                for(; null === a.sibling;){
                    if (null === a.return || a.return === b) break a;
                    a = a.return;
                }
                a.sibling.return = a.return;
                a = a.sibling;
            }
            d &= 1;
        }
        v(I, d);
        if (0 === (b.mode & 1)) b.memoizedState = null;
        else switch(e){
            case "forwards":
                c = b.child;
                for(e = null; null !== c;)a = c.alternate, null !== a && null === we(a) && (e = c), c = c.sibling;
                c = e;
                null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
                qg(b, !1, e, c, f);
                break;
            case "backwards":
                c = null;
                e = b.child;
                for(b.child = null; null !== e;){
                    a = e.alternate;
                    if (null !== a && null === we(a)) {
                        b.child = e;
                        break;
                    }
                    a = e.sibling;
                    e.sibling = c;
                    c = e;
                    e = a;
                }
                qg(b, !0, c, null, f);
                break;
            case "together":
                qg(b, !1, null, null, void 0);
                break;
            default:
                b.memoizedState = null;
        }
        return b.child;
    }
    function cg(a, b) {
        0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
    }
    function Tf(a, b, c) {
        null !== a && (b.dependencies = a.dependencies);
        le |= b.lanes;
        if (0 === (c & b.childLanes)) return null;
        if (null !== a && b.child !== a.child) throw Error(n(153));
        if (null !== b.child) {
            a = b.child;
            c = Jd(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Jd(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    function sg(a, b, c) {
        switch(b.tag){
            case 3:
                eg(b);
                Ad();
                break;
            case 5:
                ue(b);
                break;
            case 1:
                A(b.type) && qc(b);
                break;
            case 4:
                se(b, b.stateNode.containerInfo);
                break;
            case 10:
                Vd(b, b.type._context, b.memoizedProps.value);
                break;
            case 13:
                var d = b.memoizedState;
                if (null !== d) {
                    if (null !== d.dehydrated) return v(I, I.current & 1), b.flags |= 128, null;
                    if (0 !== (c & b.child.childLanes)) return ig(a, b, c);
                    v(I, I.current & 1);
                    a = Tf(a, b, c);
                    return null !== a ? a.sibling : null;
                }
                v(I, I.current & 1);
                break;
            case 19:
                d = 0 !== (c & b.childLanes);
                if (0 !== (a.flags & 128)) {
                    if (d) return rg(a, b, c);
                    b.flags |= 128;
                }
                var e = b.memoizedState;
                null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                v(I, I.current);
                if (d) break;
                else return null;
            case 22:
            case 23:
                return b.lanes = 0, Yf(a, b, c);
        }
        return Tf(a, b, c);
    }
    function tg(a) {
        a.flags |= 4;
    }
    function ug(a, b) {
        if (null !== a && a.child === b.child) return !0;
        if (0 !== (b.flags & 16)) return !1;
        for(a = b.child; null !== a;){
            if (0 !== (a.flags & 12854) || 0 !== (a.subtreeFlags & 12854)) return !1;
            a = a.sibling;
        }
        return !0;
    }
    var vg, wg, xg, yg;
    if (Ta) vg = function(a, b) {
        for(var c = b.child; null !== c;){
            if (5 === c.tag || 6 === c.tag) Ka(a, c.stateNode);
            else if (4 !== c.tag && null !== c.child) {
                c.child.return = c;
                c = c.child;
                continue;
            }
            if (c === b) break;
            for(; null === c.sibling;){
                if (null === c.return || c.return === b) return;
                c = c.return;
            }
            c.sibling.return = c.return;
            c = c.sibling;
        }
    }, wg = function() {}, xg = function(a, b, c, d, e) {
        a = a.memoizedProps;
        if (a !== d) {
            var f = b.stateNode, g = re(oe.current);
            c = Ma(f, c, a, d, e, g);
            (b.updateQueue = c) && tg(b);
        }
    }, yg = function(a, b, c, d) {
        c !== d && tg(b);
    };
    else if (Ua) {
        vg = function(a, b, c, d) {
            for(var e = b.child; null !== e;){
                if (5 === e.tag) {
                    var f = e.stateNode;
                    c && d && (f = Eb(f, e.type, e.memoizedProps, e));
                    Ka(a, f);
                } else if (6 === e.tag) f = e.stateNode, c && d && (f = Fb(f, e.memoizedProps, e)), Ka(a, f);
                else if (4 !== e.tag) {
                    if (22 === e.tag && null !== e.memoizedState) f = e.child, null !== f && (f.return = e), vg(a, e, !0, !0);
                    else if (null !== e.child) {
                        e.child.return = e;
                        e = e.child;
                        continue;
                    }
                }
                if (e === b) break;
                for(; null === e.sibling;){
                    if (null === e.return || e.return === b) return;
                    e = e.return;
                }
                e.sibling.return = e.return;
                e = e.sibling;
            }
        };
        var zg = function(a, b, c, d) {
            for(var e = b.child; null !== e;){
                if (5 === e.tag) {
                    var f = e.stateNode;
                    c && d && (f = Eb(f, e.type, e.memoizedProps, e));
                    Ab(a, f);
                } else if (6 === e.tag) f = e.stateNode, c && d && (f = Fb(f, e.memoizedProps, e)), Ab(a, f);
                else if (4 !== e.tag) {
                    if (22 === e.tag && null !== e.memoizedState) f = e.child, null !== f && (f.return = e), zg(a, e, !0, !0);
                    else if (null !== e.child) {
                        e.child.return = e;
                        e = e.child;
                        continue;
                    }
                }
                if (e === b) break;
                for(; null === e.sibling;){
                    if (null === e.return || e.return === b) return;
                    e = e.return;
                }
                e.sibling.return = e.return;
                e = e.sibling;
            }
        };
        wg = function(a, b) {
            var c = b.stateNode;
            if (!ug(a, b)) {
                a = c.containerInfo;
                var d = zb(a);
                zg(d, b, !1, !1);
                c.pendingChildren = d;
                tg(b);
                Bb(a, d);
            }
        };
        xg = function(a, b, c, d, e) {
            var f = a.stateNode, g = a.memoizedProps;
            if ((a = ug(a, b)) && g === d) b.stateNode = f;
            else {
                var h = b.stateNode, k = re(oe.current), l = null;
                g !== d && (l = Ma(h, c, g, d, e, k));
                a && null === l ? b.stateNode = f : (f = yb(f, l, c, g, d, b, a, h), La(f, c, d, e, k) && tg(b), b.stateNode = f, a ? tg(b) : vg(f, b, !1, !1));
            }
        };
        yg = function(a, b, c, d) {
            c !== d ? (a = re(qe.current), c = re(oe.current), b.stateNode = Oa(d, a, c, b), tg(b)) : b.stateNode = a.stateNode;
        };
    } else wg = function() {}, xg = function() {}, yg = function() {};
    function Ag(a, b) {
        if (!F) switch(a.tailMode){
            case "hidden":
                b = a.tail;
                for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
                null === c ? a.tail = null : c.sibling = null;
                break;
            case "collapsed":
                c = a.tail;
                for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
                null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
        }
    }
    function Q(a) {
        var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
        if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
        else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
        a.subtreeFlags |= d;
        a.childLanes = c;
        return b;
    }
    function Bg(a, b, c) {
        var d = b.pendingProps;
        nd(b);
        switch(b.tag){
            case 2:
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
                return Q(b), null;
            case 1:
                return A(b.type) && nc(), Q(b), null;
            case 3:
                c = b.stateNode;
                te();
                q(z);
                q(x);
                ye();
                c.pendingContext && (c.context = c.pendingContext, c.pendingContext = null);
                if (null === a || null === a.child) yd(b) ? tg(b) : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== rd && (Cg(rd), rd = null));
                wg(a, b);
                Q(b);
                return null;
            case 5:
                ve(b);
                c = re(qe.current);
                var e = b.type;
                if (null !== a && null != b.stateNode) xg(a, b, e, d, c), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
                else {
                    if (!d) {
                        if (null === b.stateNode) throw Error(n(166));
                        Q(b);
                        return null;
                    }
                    a = re(oe.current);
                    if (yd(b)) {
                        if (!Va) throw Error(n(175));
                        a = Rb(b.stateNode, b.type, b.memoizedProps, c, a, b, !qd);
                        b.updateQueue = a;
                        null !== a && tg(b);
                    } else {
                        var f = Ja(e, d, c, a, b);
                        vg(f, b, !1, !1);
                        b.stateNode = f;
                        La(f, e, d, c, a) && tg(b);
                    }
                    null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
                }
                Q(b);
                return null;
            case 6:
                if (a && null != b.stateNode) yg(a, b, a.memoizedProps, d);
                else {
                    if ("string" !== typeof d && null === b.stateNode) throw Error(n(166));
                    a = re(qe.current);
                    c = re(oe.current);
                    if (yd(b)) {
                        if (!Va) throw Error(n(176));
                        a = b.stateNode;
                        c = b.memoizedProps;
                        if (d = Sb(a, c, b, !qd)) {
                            if (e = od, null !== e) switch(e.tag){
                                case 3:
                                    $b(e.stateNode.containerInfo, a, c, 0 !== (e.mode & 1));
                                    break;
                                case 5:
                                    ac(e.type, e.memoizedProps, e.stateNode, a, c, 0 !== (e.mode & 1));
                            }
                        }
                        d && tg(b);
                    } else b.stateNode = Oa(d, a, c, b);
                }
                Q(b);
                return null;
            case 13:
                q(I);
                d = b.memoizedState;
                if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                    if (F && null !== pd && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) zd(), Ad(), b.flags |= 98560, e = !1;
                    else if (e = yd(b), null !== d && null !== d.dehydrated) {
                        if (null === a) {
                            if (!e) throw Error(n(318));
                            if (!Va) throw Error(n(344));
                            e = b.memoizedState;
                            e = null !== e ? e.dehydrated : null;
                            if (!e) throw Error(n(317));
                            Tb(e, b);
                        } else Ad(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                        Q(b);
                        e = !1;
                    } else null !== rd && (Cg(rd), rd = null), e = !0;
                    if (!e) return b.flags & 65536 ? b : null;
                }
                if (0 !== (b.flags & 128)) return b.lanes = c, b;
                c = null !== d;
                c !== (null !== a && null !== a.memoizedState) && c && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (I.current & 1) ? 0 === R && (R = 3) : ng()));
                null !== b.updateQueue && (b.flags |= 4);
                Q(b);
                return null;
            case 4:
                return te(), wg(a, b), null === a && Xa(b.stateNode.containerInfo), Q(b), null;
            case 10:
                return Wd(b.type._context), Q(b), null;
            case 17:
                return A(b.type) && nc(), Q(b), null;
            case 19:
                q(I);
                e = b.memoizedState;
                if (null === e) return Q(b), null;
                d = 0 !== (b.flags & 128);
                f = e.rendering;
                if (null === f) {
                    if (d) Ag(e, !1);
                    else {
                        if (0 !== R || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                            f = we(a);
                            if (null !== f) {
                                b.flags |= 128;
                                Ag(e, !1);
                                a = f.updateQueue;
                                null !== a && (b.updateQueue = a, b.flags |= 4);
                                b.subtreeFlags = 0;
                                a = c;
                                for(c = b.child; null !== c;)d = c, e = a, d.flags &= 14680066, f = d.alternate, null === f ? (d.childLanes = 0, d.lanes = e, d.child = null, d.subtreeFlags = 0, d.memoizedProps = null, d.memoizedState = null, d.updateQueue = null, d.dependencies = null, d.stateNode = null) : (d.childLanes = f.childLanes, d.lanes = f.lanes, d.child = f.child, d.subtreeFlags = 0, d.deletions = null, d.memoizedProps = f.memoizedProps, d.memoizedState = f.memoizedState, d.updateQueue = f.updateQueue, d.type = f.type, e = f.dependencies, d.dependencies = null === e ? null : {
                                    lanes: e.lanes,
                                    firstContext: e.firstContext
                                }), c = c.sibling;
                                v(I, I.current & 1 | 2);
                                return b.child;
                            }
                            a = a.sibling;
                        }
                        null !== e.tail && D() > Dg && (b.flags |= 128, d = !0, Ag(e, !1), b.lanes = 4194304);
                    }
                } else {
                    if (!d) {
                        if (a = we(f), null !== a) {
                            if (b.flags |= 128, d = !0, a = a.updateQueue, null !== a && (b.updateQueue = a, b.flags |= 4), Ag(e, !0), null === e.tail && "hidden" === e.tailMode && !f.alternate && !F) return Q(b), null;
                        } else 2 * D() - e.renderingStartTime > Dg && 1073741824 !== c && (b.flags |= 128, d = !0, Ag(e, !1), b.lanes = 4194304);
                    }
                    e.isBackwards ? (f.sibling = b.child, b.child = f) : (a = e.last, null !== a ? a.sibling = f : b.child = f, e.last = f);
                }
                if (null !== e.tail) return b = e.tail, e.rendering = b, e.tail = b.sibling, e.renderingStartTime = D(), b.sibling = null, a = I.current, v(I, d ? a & 1 | 2 : a & 1), b;
                Q(b);
                return null;
            case 22:
            case 23:
                return Eg(), c = null !== b.memoizedState, null !== a && null !== a.memoizedState !== c && (b.flags |= 8192), c && 0 !== (b.mode & 1) ? 0 !== ($f & 1073741824) && (Q(b), Ta && b.subtreeFlags & 6 && (b.flags |= 8192)) : Q(b), null;
            case 24:
                return null;
            case 25:
                return null;
        }
        throw Error(n(156, b.tag));
    }
    function Fg(a, b) {
        nd(b);
        switch(b.tag){
            case 1:
                return A(b.type) && nc(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
            case 3:
                return te(), q(z), q(x), ye(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
            case 5:
                return ve(b), null;
            case 13:
                q(I);
                a = b.memoizedState;
                if (null !== a && null !== a.dehydrated) {
                    if (null === b.alternate) throw Error(n(340));
                    Ad();
                }
                a = b.flags;
                return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
            case 19:
                return q(I), null;
            case 4:
                return te(), null;
            case 10:
                return Wd(b.type._context), null;
            case 22:
            case 23:
                return Eg(), null;
            case 24:
                return null;
            default:
                return null;
        }
    }
    var Gg = !1, S = !1, Hg = "function" === typeof WeakSet ? WeakSet : Set, T = null;
    function Ig(a, b) {
        var c = a.ref;
        if (null !== c) {
            if ("function" === typeof c) try {
                c(null);
            } catch (d) {
                U(a, b, d);
            }
            else c.current = null;
        }
    }
    function Jg(a, b, c) {
        try {
            c();
        } catch (d) {
            U(a, b, d);
        }
    }
    var Kg = !1;
    function Lg(a, b) {
        Ha(a.containerInfo);
        for(T = b; null !== T;)if (a = T, b = a.child, 0 !== (a.subtreeFlags & 1028) && null !== b) b.return = a, T = b;
        else for(; null !== T;){
            a = T;
            try {
                var c = a.alternate;
                if (0 !== (a.flags & 1024)) switch(a.tag){
                    case 0:
                    case 11:
                    case 15:
                        break;
                    case 1:
                        if (null !== c) {
                            var d = c.memoizedProps, e = c.memoizedState, f = a.stateNode, g = f.getSnapshotBeforeUpdate(a.elementType === a.type ? d : xf(a.type, d), e);
                            f.__reactInternalSnapshotBeforeUpdate = g;
                        }
                        break;
                    case 3:
                        Ta && xb(a.stateNode.containerInfo);
                        break;
                    case 5:
                    case 6:
                    case 4:
                    case 17:
                        break;
                    default:
                        throw Error(n(163));
                }
            } catch (h) {
                U(a, a.return, h);
            }
            b = a.sibling;
            if (null !== b) {
                b.return = a.return;
                T = b;
                break;
            }
            T = a.return;
        }
        c = Kg;
        Kg = !1;
        return c;
    }
    function Mg(a, b, c) {
        var d = b.updateQueue;
        d = null !== d ? d.lastEffect : null;
        if (null !== d) {
            var e = d = d.next;
            do {
                if ((e.tag & a) === a) {
                    var f = e.destroy;
                    e.destroy = void 0;
                    void 0 !== f && Jg(b, c, f);
                }
                e = e.next;
            }while (e !== d);
        }
    }
    function Ng(a, b) {
        b = b.updateQueue;
        b = null !== b ? b.lastEffect : null;
        if (null !== b) {
            var c = b = b.next;
            do {
                if ((c.tag & a) === a) {
                    var d = c.create;
                    c.destroy = d();
                }
                c = c.next;
            }while (c !== b);
        }
    }
    function Og(a) {
        var b = a.ref;
        if (null !== b) {
            var c = a.stateNode;
            switch(a.tag){
                case 5:
                    a = Ea(c);
                    break;
                default:
                    a = c;
            }
            "function" === typeof b ? b(a) : b.current = a;
        }
    }
    function Pg(a) {
        var b = a.alternate;
        null !== b && (a.alternate = null, Pg(b));
        a.child = null;
        a.deletions = null;
        a.sibling = null;
        5 === a.tag && (b = a.stateNode, null !== b && Za(b));
        a.stateNode = null;
        a.return = null;
        a.dependencies = null;
        a.memoizedProps = null;
        a.memoizedState = null;
        a.pendingProps = null;
        a.stateNode = null;
        a.updateQueue = null;
    }
    function Qg(a) {
        return 5 === a.tag || 3 === a.tag || 4 === a.tag;
    }
    function Rg(a) {
        a: for(;;){
            for(; null === a.sibling;){
                if (null === a.return || Qg(a.return)) return null;
                a = a.return;
            }
            a.sibling.return = a.return;
            for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
                if (a.flags & 2) continue a;
                if (null === a.child || 4 === a.tag) continue a;
                else a.child.return = a, a = a.child;
            }
            if (!(a.flags & 2)) return a.stateNode;
        }
    }
    function Sg(a, b, c) {
        var d = a.tag;
        if (5 === d || 6 === d) a = a.stateNode, b ? pb(c, a, b) : kb(c, a);
        else if (4 !== d && (a = a.child, null !== a)) for(Sg(a, b, c), a = a.sibling; null !== a;)Sg(a, b, c), a = a.sibling;
    }
    function Tg(a, b, c) {
        var d = a.tag;
        if (5 === d || 6 === d) a = a.stateNode, b ? ob(c, a, b) : jb(c, a);
        else if (4 !== d && (a = a.child, null !== a)) for(Tg(a, b, c), a = a.sibling; null !== a;)Tg(a, b, c), a = a.sibling;
    }
    var V = null, Ug = !1;
    function Vg(a, b, c) {
        for(c = c.child; null !== c;)Wg(a, b, c), c = c.sibling;
    }
    function Wg(a, b, c) {
        if (Sc && "function" === typeof Sc.onCommitFiberUnmount) try {
            Sc.onCommitFiberUnmount(Rc, c);
        } catch (h) {}
        switch(c.tag){
            case 5:
                S || Ig(c, b);
            case 6:
                if (Ta) {
                    var d = V, e = Ug;
                    V = null;
                    Vg(a, b, c);
                    V = d;
                    Ug = e;
                    null !== V && (Ug ? rb(V, c.stateNode) : qb(V, c.stateNode));
                } else Vg(a, b, c);
                break;
            case 18:
                Ta && null !== V && (Ug ? Yb(V, c.stateNode) : Xb(V, c.stateNode));
                break;
            case 4:
                Ta ? (d = V, e = Ug, V = c.stateNode.containerInfo, Ug = !0, Vg(a, b, c), V = d, Ug = e) : (Ua && (d = c.stateNode.containerInfo, e = zb(d), Cb(d, e)), Vg(a, b, c));
                break;
            case 0:
            case 11:
            case 14:
            case 15:
                if (!S && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                    e = d = d.next;
                    do {
                        var f = e, g = f.destroy;
                        f = f.tag;
                        void 0 !== g && (0 !== (f & 2) ? Jg(c, b, g) : 0 !== (f & 4) && Jg(c, b, g));
                        e = e.next;
                    }while (e !== d);
                }
                Vg(a, b, c);
                break;
            case 1:
                if (!S && (Ig(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                    d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
                } catch (h) {
                    U(c, b, h);
                }
                Vg(a, b, c);
                break;
            case 21:
                Vg(a, b, c);
                break;
            case 22:
                c.mode & 1 ? (S = (d = S) || null !== c.memoizedState, Vg(a, b, c), S = d) : Vg(a, b, c);
                break;
            default:
                Vg(a, b, c);
        }
    }
    function Xg(a) {
        var b = a.updateQueue;
        if (null !== b) {
            a.updateQueue = null;
            var c = a.stateNode;
            null === c && (c = a.stateNode = new Hg);
            b.forEach(function(b) {
                var d = Yg.bind(null, a, b);
                c.has(b) || (c.add(b), b.then(d, d));
            });
        }
    }
    function Zg(a, b) {
        var c = b.deletions;
        if (null !== c) for(var d = 0; d < c.length; d++){
            var e = c[d];
            try {
                var f = a, g = b;
                if (Ta) {
                    var h = g;
                    a: for(; null !== h;){
                        switch(h.tag){
                            case 5:
                                V = h.stateNode;
                                Ug = !1;
                                break a;
                            case 3:
                                V = h.stateNode.containerInfo;
                                Ug = !0;
                                break a;
                            case 4:
                                V = h.stateNode.containerInfo;
                                Ug = !0;
                                break a;
                        }
                        h = h.return;
                    }
                    if (null === V) throw Error(n(160));
                    Wg(f, g, e);
                    V = null;
                    Ug = !1;
                } else Wg(f, g, e);
                var k = e.alternate;
                null !== k && (k.return = null);
                e.return = null;
            } catch (l) {
                U(e, b, l);
            }
        }
        if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$g(b, a), b = b.sibling;
    }
    function $g(a, b) {
        var c = a.alternate, d = a.flags;
        switch(a.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                Zg(b, a);
                ah(a);
                if (d & 4) {
                    try {
                        Mg(3, a, a.return), Ng(3, a);
                    } catch (p) {
                        U(a, a.return, p);
                    }
                    try {
                        Mg(5, a, a.return);
                    } catch (p) {
                        U(a, a.return, p);
                    }
                }
                break;
            case 1:
                Zg(b, a);
                ah(a);
                d & 512 && null !== c && Ig(c, c.return);
                break;
            case 5:
                Zg(b, a);
                ah(a);
                d & 512 && null !== c && Ig(c, c.return);
                if (Ta) {
                    if (a.flags & 32) {
                        var e = a.stateNode;
                        try {
                            sb(e);
                        } catch (p) {
                            U(a, a.return, p);
                        }
                    }
                    if (d & 4 && (e = a.stateNode, null != e)) {
                        var f = a.memoizedProps;
                        c = null !== c ? c.memoizedProps : f;
                        d = a.type;
                        b = a.updateQueue;
                        a.updateQueue = null;
                        if (null !== b) try {
                            nb(e, b, d, c, f, a);
                        } catch (p) {
                            U(a, a.return, p);
                        }
                    }
                }
                break;
            case 6:
                Zg(b, a);
                ah(a);
                if (d & 4 && Ta) {
                    if (null === a.stateNode) throw Error(n(162));
                    e = a.stateNode;
                    f = a.memoizedProps;
                    c = null !== c ? c.memoizedProps : f;
                    try {
                        lb(e, c, f);
                    } catch (p) {
                        U(a, a.return, p);
                    }
                }
                break;
            case 3:
                Zg(b, a);
                ah(a);
                if (d & 4) {
                    if (Ta && Va && null !== c && c.memoizedState.isDehydrated) try {
                        Vb(b.containerInfo);
                    } catch (p) {
                        U(a, a.return, p);
                    }
                    if (Ua) {
                        e = b.containerInfo;
                        f = b.pendingChildren;
                        try {
                            Cb(e, f);
                        } catch (p) {
                            U(a, a.return, p);
                        }
                    }
                }
                break;
            case 4:
                Zg(b, a);
                ah(a);
                if (d & 4 && Ua) {
                    f = a.stateNode;
                    e = f.containerInfo;
                    f = f.pendingChildren;
                    try {
                        Cb(e, f);
                    } catch (p) {
                        U(a, a.return, p);
                    }
                }
                break;
            case 13:
                Zg(b, a);
                ah(a);
                e = a.child;
                e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || (bh = D()));
                d & 4 && Xg(a);
                break;
            case 22:
                var g = null !== c && null !== c.memoizedState;
                a.mode & 1 ? (S = (c = S) || g, Zg(b, a), S = c) : Zg(b, a);
                ah(a);
                if (d & 8192) {
                    c = null !== a.memoizedState;
                    if ((a.stateNode.isHidden = c) && !g && 0 !== (a.mode & 1)) for(T = a, d = a.child; null !== d;){
                        for(b = T = d; null !== T;){
                            g = T;
                            var h = g.child;
                            switch(g.tag){
                                case 0:
                                case 11:
                                case 14:
                                case 15:
                                    Mg(4, g, g.return);
                                    break;
                                case 1:
                                    Ig(g, g.return);
                                    var k = g.stateNode;
                                    if ("function" === typeof k.componentWillUnmount) {
                                        var l = g, m = g.return;
                                        try {
                                            var r = l;
                                            k.props = r.memoizedProps;
                                            k.state = r.memoizedState;
                                            k.componentWillUnmount();
                                        } catch (p) {
                                            U(l, m, p);
                                        }
                                    }
                                    break;
                                case 5:
                                    Ig(g, g.return);
                                    break;
                                case 22:
                                    if (null !== g.memoizedState) {
                                        ch(b);
                                        continue;
                                    }
                            }
                            null !== h ? (h.return = g, T = h) : ch(b);
                        }
                        d = d.sibling;
                    }
                    if (Ta) {
                        a: if (d = null, Ta) for(b = a;;){
                            if (5 === b.tag) {
                                if (null === d) {
                                    d = b;
                                    try {
                                        e = b.stateNode, c ? tb(e) : vb(b.stateNode, b.memoizedProps);
                                    } catch (p) {
                                        U(a, a.return, p);
                                    }
                                }
                            } else if (6 === b.tag) {
                                if (null === d) try {
                                    f = b.stateNode, c ? ub(f) : wb(f, b.memoizedProps);
                                } catch (p) {
                                    U(a, a.return, p);
                                }
                            } else if ((22 !== b.tag && 23 !== b.tag || null === b.memoizedState || b === a) && null !== b.child) {
                                b.child.return = b;
                                b = b.child;
                                continue;
                            }
                            if (b === a) break a;
                            for(; null === b.sibling;){
                                if (null === b.return || b.return === a) break a;
                                d === b && (d = null);
                                b = b.return;
                            }
                            d === b && (d = null);
                            b.sibling.return = b.return;
                            b = b.sibling;
                        }
                    }
                }
                break;
            case 19:
                Zg(b, a);
                ah(a);
                d & 4 && Xg(a);
                break;
            case 21:
                break;
            default:
                Zg(b, a), ah(a);
        }
    }
    function ah(a) {
        var b = a.flags;
        if (b & 2) {
            try {
                if (Ta) {
                    b: {
                        for(var c = a.return; null !== c;){
                            if (Qg(c)) {
                                var d = c;
                                break b;
                            }
                            c = c.return;
                        }
                        throw Error(n(160));
                    }
                    switch(d.tag){
                        case 5:
                            var e = d.stateNode;
                            d.flags & 32 && (sb(e), d.flags &= -33);
                            var f = Rg(a);
                            Tg(a, f, e);
                            break;
                        case 3:
                        case 4:
                            var g = d.stateNode.containerInfo, h = Rg(a);
                            Sg(a, h, g);
                            break;
                        default:
                            throw Error(n(161));
                    }
                }
            } catch (k) {
                U(a, a.return, k);
            }
            a.flags &= -3;
        }
        b & 4096 && (a.flags &= -4097);
    }
    function dh(a, b, c) {
        T = a;
        eh(a, b, c);
    }
    function eh(a, b, c) {
        for(var d = 0 !== (a.mode & 1); null !== T;){
            var e = T, f = e.child;
            if (22 === e.tag && d) {
                var g = null !== e.memoizedState || Gg;
                if (!g) {
                    var h = e.alternate, k = null !== h && null !== h.memoizedState || S;
                    h = Gg;
                    var l = S;
                    Gg = g;
                    if ((S = k) && !l) for(T = e; null !== T;)g = T, k = g.child, 22 === g.tag && null !== g.memoizedState ? fh(e) : null !== k ? (k.return = g, T = k) : fh(e);
                    for(; null !== f;)T = f, eh(f, b, c), f = f.sibling;
                    T = e;
                    Gg = h;
                    S = l;
                }
                gh(a, b, c);
            } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, T = f) : gh(a, b, c);
        }
    }
    function gh(a) {
        for(; null !== T;){
            var b = T;
            if (0 !== (b.flags & 8772)) {
                var c = b.alternate;
                try {
                    if (0 !== (b.flags & 8772)) switch(b.tag){
                        case 0:
                        case 11:
                        case 15:
                            S || Ng(5, b);
                            break;
                        case 1:
                            var d = b.stateNode;
                            if (b.flags & 4 && !S) {
                                if (null === c) d.componentDidMount();
                                else {
                                    var e = b.elementType === b.type ? c.memoizedProps : xf(b.type, c.memoizedProps);
                                    d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                                }
                            }
                            var f = b.updateQueue;
                            null !== f && me(b, f, d);
                            break;
                        case 3:
                            var g = b.updateQueue;
                            if (null !== g) {
                                c = null;
                                if (null !== b.child) switch(b.child.tag){
                                    case 5:
                                        c = Ea(b.child.stateNode);
                                        break;
                                    case 1:
                                        c = b.child.stateNode;
                                }
                                me(b, g, c);
                            }
                            break;
                        case 5:
                            var h = b.stateNode;
                            null === c && b.flags & 4 && mb(h, b.type, b.memoizedProps, b);
                            break;
                        case 6:
                            break;
                        case 4:
                            break;
                        case 12:
                            break;
                        case 13:
                            if (Va && null === b.memoizedState) {
                                var k = b.alternate;
                                if (null !== k) {
                                    var l = k.memoizedState;
                                    if (null !== l) {
                                        var m = l.dehydrated;
                                        null !== m && Wb(m);
                                    }
                                }
                            }
                            break;
                        case 19:
                        case 17:
                        case 21:
                        case 22:
                        case 23:
                        case 25:
                            break;
                        default:
                            throw Error(n(163));
                    }
                    S || b.flags & 512 && Og(b);
                } catch (r) {
                    U(b, b.return, r);
                }
            }
            if (b === a) {
                T = null;
                break;
            }
            c = b.sibling;
            if (null !== c) {
                c.return = b.return;
                T = c;
                break;
            }
            T = b.return;
        }
    }
    function ch(a) {
        for(; null !== T;){
            var b = T;
            if (b === a) {
                T = null;
                break;
            }
            var c = b.sibling;
            if (null !== c) {
                c.return = b.return;
                T = c;
                break;
            }
            T = b.return;
        }
    }
    function fh(a) {
        for(; null !== T;){
            var b = T;
            try {
                switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        var c = b.return;
                        try {
                            Ng(4, b);
                        } catch (k) {
                            U(b, c, k);
                        }
                        break;
                    case 1:
                        var d = b.stateNode;
                        if ("function" === typeof d.componentDidMount) {
                            var e = b.return;
                            try {
                                d.componentDidMount();
                            } catch (k) {
                                U(b, e, k);
                            }
                        }
                        var f = b.return;
                        try {
                            Og(b);
                        } catch (k) {
                            U(b, f, k);
                        }
                        break;
                    case 5:
                        var g = b.return;
                        try {
                            Og(b);
                        } catch (k) {
                            U(b, g, k);
                        }
                }
            } catch (k) {
                U(b, b.return, k);
            }
            if (b === a) {
                T = null;
                break;
            }
            var h = b.sibling;
            if (null !== h) {
                h.return = b.return;
                T = h;
                break;
            }
            T = b.return;
        }
    }
    var hh = 0, ih = 1, jh = 2, kh = 3, lh = 4;
    if ("function" === typeof Symbol && Symbol.for) {
        var mh = Symbol.for;
        hh = mh("selector.component");
        ih = mh("selector.has_pseudo_class");
        jh = mh("selector.role");
        kh = mh("selector.test_id");
        lh = mh("selector.text");
    }
    function nh(a) {
        var b = Wa(a);
        if (null != b) {
            if ("string" !== typeof b.memoizedProps["data-testname"]) throw Error(n(364));
            return b;
        }
        a = cb(a);
        if (null === a) throw Error(n(362));
        return a.stateNode.current;
    }
    function oh(a, b) {
        switch(b.$$typeof){
            case hh:
                if (a.type === b.value) return !0;
                break;
            case ih:
                a: {
                    b = b.value;
                    a = [
                        a,
                        0
                    ];
                    for(var c = 0; c < a.length;){
                        var d = a[c++], e = a[c++], f = b[e];
                        if (5 !== d.tag || !fb(d)) {
                            for(; null != f && oh(d, f);)e++, f = b[e];
                            if (e === b.length) {
                                b = !0;
                                break a;
                            } else for(d = d.child; null !== d;)a.push(d, e), d = d.sibling;
                        }
                    }
                    b = !1;
                }
                return b;
            case jh:
                if (5 === a.tag && gb(a.stateNode, b.value)) return !0;
                break;
            case lh:
                if (5 === a.tag || 6 === a.tag) {
                    if (a = eb(a), null !== a && 0 <= a.indexOf(b.value)) return !0;
                }
                break;
            case kh:
                if (5 === a.tag && (a = a.memoizedProps["data-testname"], "string" === typeof a && a.toLowerCase() === b.value.toLowerCase())) return !0;
                break;
            default:
                throw Error(n(365));
        }
        return !1;
    }
    function ph(a) {
        switch(a.$$typeof){
            case hh:
                return "<" + (ua(a.value) || "Unknown") + ">";
            case ih:
                return ":has(" + (ph(a) || "") + ")";
            case jh:
                return '[role="' + a.value + '"]';
            case lh:
                return '"' + a.value + '"';
            case kh:
                return '[data-testname="' + a.value + '"]';
            default:
                throw Error(n(365));
        }
    }
    function qh(a, b) {
        var c = [];
        a = [
            a,
            0
        ];
        for(var d = 0; d < a.length;){
            var e = a[d++], f = a[d++], g = b[f];
            if (5 !== e.tag || !fb(e)) {
                for(; null != g && oh(e, g);)f++, g = b[f];
                if (f === b.length) c.push(e);
                else for(e = e.child; null !== e;)a.push(e, f), e = e.sibling;
            }
        }
        return c;
    }
    function rh(a, b) {
        if (!bb) throw Error(n(363));
        a = nh(a);
        a = qh(a, b);
        b = [];
        a = Array.from(a);
        for(var c = 0; c < a.length;){
            var d = a[c++];
            if (5 === d.tag) fb(d) || b.push(d.stateNode);
            else for(d = d.child; null !== d;)a.push(d), d = d.sibling;
        }
        return b;
    }
    var sh = Math.ceil, th = da.ReactCurrentDispatcher, uh = da.ReactCurrentOwner, W = da.ReactCurrentBatchConfig, H = 0, N = null, X = null, Z = 0, $f = 0, Zf = ic(0), R = 0, vh = null, le = 0, wh = 0, xh = 0, yh = null, zh = null, bh = 0, Dg = Infinity, Ah = null;
    function Bh() {
        Dg = D() + 500;
    }
    var Jf = !1, Kf = null, Mf = null, Ch = !1, Dh = null, Eh = 0, Fh = 0, Gh = null, Hh = -1, Ih = 0;
    function O() {
        return 0 !== (H & 6) ? D() : -1 !== Hh ? Hh : Hh = D();
    }
    function tf(a) {
        if (0 === (a.mode & 1)) return 1;
        if (0 !== (H & 2) && 0 !== Z) return Z & -Z;
        if (null !== Cd.transition) return 0 === Ih && (Ih = Dc()), Ih;
        a = C;
        return 0 !== a ? a : Ya();
    }
    function af(a, b, c, d) {
        if (50 < Fh) throw Fh = 0, Gh = null, Error(n(185));
        Fc(a, c, d);
        if (0 === (H & 2) || a !== N) a === N && (0 === (H & 2) && (wh |= c), 4 === R && Jh(a, Z)), Kh(a, d), 1 === c && 0 === H && 0 === (b.mode & 1) && (Bh(), Xc && ad());
    }
    function Kh(a, b) {
        var c = a.callbackNode;
        Bc(a, b);
        var d = zc(a, a === N ? Z : 0);
        if (0 === d) null !== c && Kc(c), a.callbackNode = null, a.callbackPriority = 0;
        else if (b = d & -d, a.callbackPriority !== b) {
            null != c && Kc(c);
            if (1 === b) 0 === a.tag ? $c(Lh.bind(null, a)) : Zc(Lh.bind(null, a)), $a ? ab(function() {
                0 === (H & 6) && ad();
            }) : Jc(Nc, ad), c = null;
            else {
                switch(Ic(d)){
                    case 1:
                        c = Nc;
                        break;
                    case 4:
                        c = Oc;
                        break;
                    case 16:
                        c = Pc;
                        break;
                    case 536870912:
                        c = Qc;
                        break;
                    default:
                        c = Pc;
                }
                c = Mh(c, Nh.bind(null, a));
            }
            a.callbackPriority = b;
            a.callbackNode = c;
        }
    }
    function Nh(a, b) {
        Hh = -1;
        Ih = 0;
        if (0 !== (H & 6)) throw Error(n(327));
        var c = a.callbackNode;
        if (Oh() && a.callbackNode !== c) return null;
        var d = zc(a, a === N ? Z : 0);
        if (0 === d) return null;
        if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Ph(a, d);
        else {
            b = d;
            var e = H;
            H |= 2;
            var f = Qh();
            if (N !== a || Z !== b) Ah = null, Bh(), Rh(a, b);
            for(;;)try {
                Sh();
                break;
            } catch (h) {
                Th(a, h);
            }
            Ud();
            th.current = f;
            H = e;
            null !== X ? b = 0 : (N = null, Z = 0, b = R);
        }
        if (0 !== b) {
            2 === b && (e = Cc(a), 0 !== e && (d = e, b = Uh(a, e)));
            if (1 === b) throw c = vh, Rh(a, 0), Jh(a, d), Kh(a, D()), c;
            if (6 === b) Jh(a, d);
            else {
                e = a.current.alternate;
                if (0 === (d & 30) && !Vh(e) && (b = Ph(a, d), 2 === b && (f = Cc(a), 0 !== f && (d = f, b = Uh(a, f))), 1 === b)) throw c = vh, Rh(a, 0), Jh(a, d), Kh(a, D()), c;
                a.finishedWork = e;
                a.finishedLanes = d;
                switch(b){
                    case 0:
                    case 1:
                        throw Error(n(345));
                    case 2:
                        Wh(a, zh, Ah);
                        break;
                    case 3:
                        Jh(a, d);
                        if ((d & 130023424) === d && (b = bh + 500 - D(), 10 < b)) {
                            if (0 !== zc(a, 0)) break;
                            e = a.suspendedLanes;
                            if ((e & d) !== d) {
                                O();
                                a.pingedLanes |= a.suspendedLanes & e;
                                break;
                            }
                            a.timeoutHandle = Pa(Wh.bind(null, a, zh, Ah), b);
                            break;
                        }
                        Wh(a, zh, Ah);
                        break;
                    case 4:
                        Jh(a, d);
                        if ((d & 4194240) === d) break;
                        b = a.eventTimes;
                        for(e = -1; 0 < d;){
                            var g = 31 - tc(d);
                            f = 1 << g;
                            g = b[g];
                            g > e && (e = g);
                            d &= ~f;
                        }
                        d = e;
                        d = D() - d;
                        d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * sh(d / 1960)) - d;
                        if (10 < d) {
                            a.timeoutHandle = Pa(Wh.bind(null, a, zh, Ah), d);
                            break;
                        }
                        Wh(a, zh, Ah);
                        break;
                    case 5:
                        Wh(a, zh, Ah);
                        break;
                    default:
                        throw Error(n(329));
                }
            }
        }
        Kh(a, D());
        return a.callbackNode === c ? Nh.bind(null, a) : null;
    }
    function Uh(a, b) {
        var c = yh;
        a.current.memoizedState.isDehydrated && (Rh(a, b).flags |= 256);
        a = Ph(a, b);
        2 !== a && (b = zh, zh = c, null !== b && Cg(b));
        return a;
    }
    function Cg(a) {
        null === zh ? zh = a : zh.push.apply(zh, a);
    }
    function Vh(a) {
        for(var b = a;;){
            if (b.flags & 16384) {
                var c = b.updateQueue;
                if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                    var e = c[d], f = e.getSnapshot;
                    e = e.value;
                    try {
                        if (!Vc(f(), e)) return !1;
                    } catch (g) {
                        return !1;
                    }
                }
            }
            c = b.child;
            if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
            else {
                if (b === a) break;
                for(; null === b.sibling;){
                    if (null === b.return || b.return === a) return !0;
                    b = b.return;
                }
                b.sibling.return = b.return;
                b = b.sibling;
            }
        }
        return !0;
    }
    function Jh(a, b) {
        b &= ~xh;
        b &= ~wh;
        a.suspendedLanes |= b;
        a.pingedLanes &= ~b;
        for(a = a.expirationTimes; 0 < b;){
            var c = 31 - tc(b), d = 1 << c;
            a[c] = -1;
            b &= ~d;
        }
    }
    function Lh(a) {
        if (0 !== (H & 6)) throw Error(n(327));
        Oh();
        var b = zc(a, 0);
        if (0 === (b & 1)) return Kh(a, D()), null;
        var c = Ph(a, b);
        if (0 !== a.tag && 2 === c) {
            var d = Cc(a);
            0 !== d && (b = d, c = Uh(a, d));
        }
        if (1 === c) throw c = vh, Rh(a, 0), Jh(a, b), Kh(a, D()), c;
        if (6 === c) throw Error(n(345));
        a.finishedWork = a.current.alternate;
        a.finishedLanes = b;
        Wh(a, zh, Ah);
        Kh(a, D());
        return null;
    }
    function Xh(a) {
        null !== Dh && 0 === Dh.tag && 0 === (H & 6) && Oh();
        var b = H;
        H |= 1;
        var c = W.transition, d = C;
        try {
            if (W.transition = null, C = 1, a) return a();
        } finally{
            C = d, W.transition = c, H = b, 0 === (H & 6) && ad();
        }
    }
    function Eg() {
        $f = Zf.current;
        q(Zf);
    }
    function Rh(a, b) {
        a.finishedWork = null;
        a.finishedLanes = 0;
        var c = a.timeoutHandle;
        c !== Ra && (a.timeoutHandle = Ra, Qa(c));
        if (null !== X) for(c = X.return; null !== c;){
            var d = c;
            nd(d);
            switch(d.tag){
                case 1:
                    d = d.type.childContextTypes;
                    null !== d && void 0 !== d && nc();
                    break;
                case 3:
                    te();
                    q(z);
                    q(x);
                    ye();
                    break;
                case 5:
                    ve(d);
                    break;
                case 4:
                    te();
                    break;
                case 13:
                    q(I);
                    break;
                case 19:
                    q(I);
                    break;
                case 10:
                    Wd(d.type._context);
                    break;
                case 22:
                case 23:
                    Eg();
            }
            c = c.return;
        }
        N = a;
        X = a = Jd(a.current, null);
        Z = $f = b;
        R = 0;
        vh = null;
        xh = wh = le = 0;
        zh = yh = null;
        if (null !== $d) {
            for(b = 0; b < $d.length; b++)if (c = $d[b], d = c.interleaved, null !== d) {
                c.interleaved = null;
                var e = d.next, f = c.pending;
                if (null !== f) {
                    var g = f.next;
                    f.next = e;
                    d.next = g;
                }
                c.pending = d;
            }
            $d = null;
        }
        return a;
    }
    function Th(a, b) {
        do {
            var c = X;
            try {
                Ud();
                ze.current = Le;
                if (Ce) {
                    for(var d = J.memoizedState; null !== d;){
                        var e = d.queue;
                        null !== e && (e.pending = null);
                        d = d.next;
                    }
                    Ce = !1;
                }
                Be = 0;
                L = K = J = null;
                De = !1;
                Ee = 0;
                uh.current = null;
                if (null === c || null === c.return) {
                    R = 1;
                    vh = b;
                    X = null;
                    break;
                }
                a: {
                    var f = a, g = c.return, h = c, k = b;
                    b = Z;
                    h.flags |= 32768;
                    if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                        var l = k, m = h, r = m.tag;
                        if (0 === (m.mode & 1) && (0 === r || 11 === r || 15 === r)) {
                            var p = m.alternate;
                            p ? (m.updateQueue = p.updateQueue, m.memoizedState = p.memoizedState, m.lanes = p.lanes) : (m.updateQueue = null, m.memoizedState = null);
                        }
                        var B = Pf(g);
                        if (null !== B) {
                            B.flags &= -257;
                            Qf(B, g, h, f, b);
                            B.mode & 1 && Nf(f, l, b);
                            b = B;
                            k = l;
                            var w = b.updateQueue;
                            if (null === w) {
                                var Y = new Set;
                                Y.add(k);
                                b.updateQueue = Y;
                            } else w.add(k);
                            break a;
                        } else {
                            if (0 === (b & 1)) {
                                Nf(f, l, b);
                                ng();
                                break a;
                            }
                            k = Error(n(426));
                        }
                    } else if (F && h.mode & 1) {
                        var ya = Pf(g);
                        if (null !== ya) {
                            0 === (ya.flags & 65536) && (ya.flags |= 256);
                            Qf(ya, g, h, f, b);
                            Bd(Ef(k, h));
                            break a;
                        }
                    }
                    f = k = Ef(k, h);
                    4 !== R && (R = 2);
                    null === yh ? yh = [
                        f
                    ] : yh.push(f);
                    f = g;
                    do {
                        switch(f.tag){
                            case 3:
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var E = If(f, k, b);
                                je(f, E);
                                break a;
                            case 1:
                                h = k;
                                var u = f.type, t = f.stateNode;
                                if (0 === (f.flags & 128) && ("function" === typeof u.getDerivedStateFromError || null !== t && "function" === typeof t.componentDidCatch && (null === Mf || !Mf.has(t)))) {
                                    f.flags |= 65536;
                                    b &= -b;
                                    f.lanes |= b;
                                    var Db = Lf(f, h, b);
                                    je(f, Db);
                                    break a;
                                }
                        }
                        f = f.return;
                    }while (null !== f);
                }
                Yh(c);
            } catch (lc) {
                b = lc;
                X === c && null !== c && (X = c = c.return);
                continue;
            }
            break;
        }while (1);
    }
    function Qh() {
        var a = th.current;
        th.current = Le;
        return null === a ? Le : a;
    }
    function ng() {
        if (0 === R || 3 === R || 2 === R) R = 4;
        null === N || 0 === (le & 268435455) && 0 === (wh & 268435455) || Jh(N, Z);
    }
    function Ph(a, b) {
        var c = H;
        H |= 2;
        var d = Qh();
        if (N !== a || Z !== b) Ah = null, Rh(a, b);
        for(;;)try {
            Zh();
            break;
        } catch (e) {
            Th(a, e);
        }
        Ud();
        H = c;
        th.current = d;
        if (null !== X) throw Error(n(261));
        N = null;
        Z = 0;
        return R;
    }
    function Zh() {
        for(; null !== X;)$h(X);
    }
    function Sh() {
        for(; null !== X && !Lc();)$h(X);
    }
    function $h(a) {
        var b = ai(a.alternate, a, $f);
        a.memoizedProps = a.pendingProps;
        null === b ? Yh(a) : X = b;
        uh.current = null;
    }
    function Yh(a) {
        var b = a;
        do {
            var c = b.alternate;
            a = b.return;
            if (0 === (b.flags & 32768)) {
                if (c = Bg(c, b, $f), null !== c) {
                    X = c;
                    return;
                }
            } else {
                c = Fg(c, b);
                if (null !== c) {
                    c.flags &= 32767;
                    X = c;
                    return;
                }
                if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
                else {
                    R = 6;
                    X = null;
                    return;
                }
            }
            b = b.sibling;
            if (null !== b) {
                X = b;
                return;
            }
            X = b = a;
        }while (null !== b);
        0 === R && (R = 5);
    }
    function Wh(a, b, c) {
        var d = C, e = W.transition;
        try {
            W.transition = null, C = 1, bi(a, b, c, d);
        } finally{
            W.transition = e, C = d;
        }
        return null;
    }
    function bi(a, b, c, d) {
        do Oh();
        while (null !== Dh);
        if (0 !== (H & 6)) throw Error(n(327));
        c = a.finishedWork;
        var e = a.finishedLanes;
        if (null === c) return null;
        a.finishedWork = null;
        a.finishedLanes = 0;
        if (c === a.current) throw Error(n(177));
        a.callbackNode = null;
        a.callbackPriority = 0;
        var f = c.lanes | c.childLanes;
        Gc(a, f);
        a === N && (X = N = null, Z = 0);
        0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || Ch || (Ch = !0, Mh(Pc, function() {
            Oh();
            return null;
        }));
        f = 0 !== (c.flags & 15990);
        if (0 !== (c.subtreeFlags & 15990) || f) {
            f = W.transition;
            W.transition = null;
            var g = C;
            C = 1;
            var h = H;
            H |= 4;
            uh.current = null;
            Lg(a, c);
            $g(c, a);
            Ia(a.containerInfo);
            a.current = c;
            dh(c, a, e);
            Mc();
            H = h;
            C = g;
            W.transition = f;
        } else a.current = c;
        Ch && (Ch = !1, Dh = a, Eh = e);
        f = a.pendingLanes;
        0 === f && (Mf = null);
        Tc(c.stateNode, d);
        Kh(a, D());
        if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
            componentStack: e.stack,
            digest: e.digest
        });
        if (Jf) throw Jf = !1, a = Kf, Kf = null, a;
        0 !== (Eh & 1) && 0 !== a.tag && Oh();
        f = a.pendingLanes;
        0 !== (f & 1) ? a === Gh ? Fh++ : (Fh = 0, Gh = a) : Fh = 0;
        ad();
        return null;
    }
    function Oh() {
        if (null !== Dh) {
            var a = Ic(Eh), b = W.transition, c = C;
            try {
                W.transition = null;
                C = 16 > a ? 16 : a;
                if (null === Dh) var d = !1;
                else {
                    a = Dh;
                    Dh = null;
                    Eh = 0;
                    if (0 !== (H & 6)) throw Error(n(331));
                    var e = H;
                    H |= 4;
                    for(T = a.current; null !== T;){
                        var f = T, g = f.child;
                        if (0 !== (T.flags & 16)) {
                            var h = f.deletions;
                            if (null !== h) {
                                for(var k = 0; k < h.length; k++){
                                    var l = h[k];
                                    for(T = l; null !== T;){
                                        var m = T;
                                        switch(m.tag){
                                            case 0:
                                            case 11:
                                            case 15:
                                                Mg(8, m, f);
                                        }
                                        var r = m.child;
                                        if (null !== r) r.return = m, T = r;
                                        else for(; null !== T;){
                                            m = T;
                                            var p = m.sibling, B = m.return;
                                            Pg(m);
                                            if (m === l) {
                                                T = null;
                                                break;
                                            }
                                            if (null !== p) {
                                                p.return = B;
                                                T = p;
                                                break;
                                            }
                                            T = B;
                                        }
                                    }
                                }
                                var w = f.alternate;
                                if (null !== w) {
                                    var Y = w.child;
                                    if (null !== Y) {
                                        w.child = null;
                                        do {
                                            var ya = Y.sibling;
                                            Y.sibling = null;
                                            Y = ya;
                                        }while (null !== Y);
                                    }
                                }
                                T = f;
                            }
                        }
                        if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, T = g;
                        else b: for(; null !== T;){
                            f = T;
                            if (0 !== (f.flags & 2048)) switch(f.tag){
                                case 0:
                                case 11:
                                case 15:
                                    Mg(9, f, f.return);
                            }
                            var E = f.sibling;
                            if (null !== E) {
                                E.return = f.return;
                                T = E;
                                break b;
                            }
                            T = f.return;
                        }
                    }
                    var u = a.current;
                    for(T = u; null !== T;){
                        g = T;
                        var t = g.child;
                        if (0 !== (g.subtreeFlags & 2064) && null !== t) t.return = g, T = t;
                        else b: for(g = u; null !== T;){
                            h = T;
                            if (0 !== (h.flags & 2048)) try {
                                switch(h.tag){
                                    case 0:
                                    case 11:
                                    case 15:
                                        Ng(9, h);
                                }
                            } catch (lc) {
                                U(h, h.return, lc);
                            }
                            if (h === g) {
                                T = null;
                                break b;
                            }
                            var Db = h.sibling;
                            if (null !== Db) {
                                Db.return = h.return;
                                T = Db;
                                break b;
                            }
                            T = h.return;
                        }
                    }
                    H = e;
                    ad();
                    if (Sc && "function" === typeof Sc.onPostCommitFiberRoot) try {
                        Sc.onPostCommitFiberRoot(Rc, a);
                    } catch (lc) {}
                    d = !0;
                }
                return d;
            } finally{
                C = c, W.transition = b;
            }
        }
        return !1;
    }
    function ci(a, b, c) {
        b = Ef(c, b);
        b = If(a, b, 1);
        a = he(a, b, 1);
        b = O();
        null !== a && (Fc(a, 1, b), Kh(a, b));
    }
    function U(a, b, c) {
        if (3 === a.tag) ci(a, a, c);
        else for(; null !== b;){
            if (3 === b.tag) {
                ci(b, a, c);
                break;
            } else if (1 === b.tag) {
                var d = b.stateNode;
                if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Mf || !Mf.has(d))) {
                    a = Ef(c, a);
                    a = Lf(b, a, 1);
                    b = he(b, a, 1);
                    a = O();
                    null !== b && (Fc(b, 1, a), Kh(b, a));
                    break;
                }
            }
            b = b.return;
        }
    }
    function Of(a, b, c) {
        var d = a.pingCache;
        null !== d && d.delete(b);
        b = O();
        a.pingedLanes |= a.suspendedLanes & c;
        N === a && (Z & c) === c && (4 === R || 3 === R && (Z & 130023424) === Z && 500 > D() - bh ? Rh(a, 0) : xh |= c);
        Kh(a, b);
    }
    function di(a, b) {
        0 === b && (0 === (a.mode & 1) ? b = 1 : (b = xc, xc <<= 1, 0 === (xc & 130023424) && (xc = 4194304)));
        var c = O();
        a = ce(a, b);
        null !== a && (Fc(a, b, c), Kh(a, c));
    }
    function og(a) {
        var b = a.memoizedState, c = 0;
        null !== b && (c = b.retryLane);
        di(a, c);
    }
    function Yg(a, b) {
        var c = 0;
        switch(a.tag){
            case 13:
                var d = a.stateNode;
                var e = a.memoizedState;
                null !== e && (c = e.retryLane);
                break;
            case 19:
                d = a.stateNode;
                break;
            default:
                throw Error(n(314));
        }
        null !== d && d.delete(b);
        di(a, c);
    }
    var ai;
    ai = function(a, b, c) {
        if (null !== a) {
            if (a.memoizedProps !== b.pendingProps || z.current) G = !0;
            else {
                if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return G = !1, sg(a, b, c);
                G = 0 !== (a.flags & 131072) ? !0 : !1;
            }
        } else G = !1, F && 0 !== (b.flags & 1048576) && ld(b, ed, b.index);
        b.lanes = 0;
        switch(b.tag){
            case 2:
                var d = b.type;
                cg(a, b);
                a = b.pendingProps;
                var e = mc(b, x.current);
                Yd(b, c);
                e = He(null, b, d, a, e, c);
                var f = Me();
                b.flags |= 1;
                "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, A(d) ? (f = !0, qc(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, ee(b), e.updater = zf, b.stateNode = e, e._reactInternals = b, Df(b, d, a, c), b = dg(null, b, d, !0, f, c)) : (b.tag = 0, F && f && md(b), P(null, b, e, c), b = b.child);
                return b;
            case 16:
                d = b.elementType;
                a: {
                    cg(a, b);
                    a = b.pendingProps;
                    e = d._init;
                    d = e(d._payload);
                    b.type = d;
                    e = b.tag = ei(d);
                    a = xf(d, a);
                    switch(e){
                        case 0:
                            b = Xf(null, b, d, a, c);
                            break a;
                        case 1:
                            b = bg(null, b, d, a, c);
                            break a;
                        case 11:
                            b = Sf(null, b, d, a, c);
                            break a;
                        case 14:
                            b = Uf(null, b, d, xf(d.type, a), c);
                            break a;
                    }
                    throw Error(n(306, d, ""));
                }
                return b;
            case 0:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : xf(d, e), Xf(a, b, d, e, c);
            case 1:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : xf(d, e), bg(a, b, d, e, c);
            case 3:
                a: {
                    eg(b);
                    if (null === a) throw Error(n(387));
                    d = b.pendingProps;
                    f = b.memoizedState;
                    e = f.element;
                    fe(a, b);
                    ke(b, d, null, c);
                    var g = b.memoizedState;
                    d = g.element;
                    if (Va && f.isDehydrated) {
                        if (f = {
                            element: d,
                            isDehydrated: !1,
                            cache: g.cache,
                            pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                            transitions: g.transitions
                        }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                            e = Ef(Error(n(423)), b);
                            b = fg(a, b, d, c, e);
                            break a;
                        } else if (d !== e) {
                            e = Ef(Error(n(424)), b);
                            b = fg(a, b, d, c, e);
                            break a;
                        } else for(Va && (pd = Pb(b.stateNode.containerInfo), od = b, F = !0, rd = null, qd = !1), c = Pd(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                    } else {
                        Ad();
                        if (d === e) {
                            b = Tf(a, b, c);
                            break a;
                        }
                        P(a, b, d, c);
                    }
                    b = b.child;
                }
                return b;
            case 5:
                return ue(b), null === a && wd(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Na(d, e) ? g = null : null !== f && Na(d, f) && (b.flags |= 32), ag(a, b), P(a, b, g, c), b.child;
            case 6:
                return null === a && wd(b), null;
            case 13:
                return ig(a, b, c);
            case 4:
                return se(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Od(b, null, d, c) : P(a, b, d, c), b.child;
            case 11:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : xf(d, e), Sf(a, b, d, e, c);
            case 7:
                return P(a, b, b.pendingProps, c), b.child;
            case 8:
                return P(a, b, b.pendingProps.children, c), b.child;
            case 12:
                return P(a, b, b.pendingProps.children, c), b.child;
            case 10:
                a: {
                    d = b.type._context;
                    e = b.pendingProps;
                    f = b.memoizedProps;
                    g = e.value;
                    Vd(b, d, g);
                    if (null !== f) {
                        if (Vc(f.value, g)) {
                            if (f.children === e.children && !z.current) {
                                b = Tf(a, b, c);
                                break a;
                            }
                        } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                            var h = f.dependencies;
                            if (null !== h) {
                                g = f.child;
                                for(var k = h.firstContext; null !== k;){
                                    if (k.context === d) {
                                        if (1 === f.tag) {
                                            k = ge(-1, c & -c);
                                            k.tag = 2;
                                            var l = f.updateQueue;
                                            if (null !== l) {
                                                l = l.shared;
                                                var m = l.pending;
                                                null === m ? k.next = k : (k.next = m.next, m.next = k);
                                                l.pending = k;
                                            }
                                        }
                                        f.lanes |= c;
                                        k = f.alternate;
                                        null !== k && (k.lanes |= c);
                                        Xd(f.return, c, b);
                                        h.lanes |= c;
                                        break;
                                    }
                                    k = k.next;
                                }
                            } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                            else if (18 === f.tag) {
                                g = f.return;
                                if (null === g) throw Error(n(341));
                                g.lanes |= c;
                                h = g.alternate;
                                null !== h && (h.lanes |= c);
                                Xd(g, c, b);
                                g = f.sibling;
                            } else g = f.child;
                            if (null !== g) g.return = f;
                            else for(g = f; null !== g;){
                                if (g === b) {
                                    g = null;
                                    break;
                                }
                                f = g.sibling;
                                if (null !== f) {
                                    f.return = g.return;
                                    g = f;
                                    break;
                                }
                                g = g.return;
                            }
                            f = g;
                        }
                    }
                    P(a, b, e.children, c);
                    b = b.child;
                }
                return b;
            case 9:
                return e = b.type, d = b.pendingProps.children, Yd(b, c), e = Zd(e), d = d(e), b.flags |= 1, P(a, b, d, c), b.child;
            case 14:
                return d = b.type, e = xf(d, b.pendingProps), e = xf(d.type, e), Uf(a, b, d, e, c);
            case 15:
                return Wf(a, b, b.type, b.pendingProps, c);
            case 17:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : xf(d, e), cg(a, b), b.tag = 1, A(d) ? (a = !0, qc(b)) : a = !1, Yd(b, c), Bf(b, d, e), Df(b, d, e, c), dg(null, b, d, !0, a, c);
            case 19:
                return rg(a, b, c);
            case 22:
                return Yf(a, b, c);
        }
        throw Error(n(156, b.tag));
    };
    function Mh(a, b) {
        return Jc(a, b);
    }
    function fi(a, b, c, d) {
        this.tag = a;
        this.key = c;
        this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = b;
        this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
        this.mode = d;
        this.subtreeFlags = this.flags = 0;
        this.deletions = null;
        this.childLanes = this.lanes = 0;
        this.alternate = null;
    }
    function td(a, b, c, d) {
        return new fi(a, b, c, d);
    }
    function Vf(a) {
        a = a.prototype;
        return !(!a || !a.isReactComponent);
    }
    function ei(a) {
        if ("function" === typeof a) return Vf(a) ? 1 : 0;
        if (void 0 !== a && null !== a) {
            a = a.$$typeof;
            if (a === ma) return 11;
            if (a === pa) return 14;
        }
        return 2;
    }
    function Jd(a, b) {
        var c = a.alternate;
        null === c ? (c = td(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
        c.flags = a.flags & 14680064;
        c.childLanes = a.childLanes;
        c.lanes = a.lanes;
        c.child = a.child;
        c.memoizedProps = a.memoizedProps;
        c.memoizedState = a.memoizedState;
        c.updateQueue = a.updateQueue;
        b = a.dependencies;
        c.dependencies = null === b ? null : {
            lanes: b.lanes,
            firstContext: b.firstContext
        };
        c.sibling = a.sibling;
        c.index = a.index;
        c.ref = a.ref;
        return c;
    }
    function Ld(a, b, c, d, e, f) {
        var g = 2;
        d = a;
        if ("function" === typeof a) Vf(a) && (g = 1);
        else if ("string" === typeof a) g = 5;
        else a: switch(a){
            case ha:
                return Nd(c.children, e, f, b);
            case ia:
                g = 8;
                e |= 8;
                break;
            case ja:
                return a = td(12, c, b, e | 2), a.elementType = ja, a.lanes = f, a;
            case na:
                return a = td(13, c, b, e), a.elementType = na, a.lanes = f, a;
            case oa:
                return a = td(19, c, b, e), a.elementType = oa, a.lanes = f, a;
            case ra:
                return jg(c, e, f, b);
            default:
                if ("object" === typeof a && null !== a) switch(a.$$typeof){
                    case ka:
                        g = 10;
                        break a;
                    case la:
                        g = 9;
                        break a;
                    case ma:
                        g = 11;
                        break a;
                    case pa:
                        g = 14;
                        break a;
                    case qa:
                        g = 16;
                        d = null;
                        break a;
                }
                throw Error(n(130, null == a ? a : typeof a, ""));
        }
        b = td(g, c, b, e);
        b.elementType = a;
        b.type = d;
        b.lanes = f;
        return b;
    }
    function Nd(a, b, c, d) {
        a = td(7, a, d, b);
        a.lanes = c;
        return a;
    }
    function jg(a, b, c, d) {
        a = td(22, a, d, b);
        a.elementType = ra;
        a.lanes = c;
        a.stateNode = {
            isHidden: !1
        };
        return a;
    }
    function Kd(a, b, c) {
        a = td(6, a, null, b);
        a.lanes = c;
        return a;
    }
    function Md(a, b, c) {
        b = td(4, null !== a.children ? a.children : [], a.key, b);
        b.lanes = c;
        b.stateNode = {
            containerInfo: a.containerInfo,
            pendingChildren: null,
            implementation: a.implementation
        };
        return b;
    }
    function gi(a, b, c, d, e) {
        this.tag = b;
        this.containerInfo = a;
        this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
        this.timeoutHandle = Ra;
        this.callbackNode = this.pendingContext = this.context = null;
        this.callbackPriority = 0;
        this.eventTimes = Ec(0);
        this.expirationTimes = Ec(-1);
        this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
        this.entanglements = Ec(0);
        this.identifierPrefix = d;
        this.onRecoverableError = e;
        Va && (this.mutableSourceEagerHydrationData = null);
    }
    function hi(a, b, c, d, e, f, g, h, k) {
        a = new gi(a, b, c, h, k);
        1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
        f = td(3, null, null, b);
        a.current = f;
        f.stateNode = a;
        f.memoizedState = {
            element: d,
            isDehydrated: c,
            cache: null,
            transitions: null,
            pendingSuspenseBoundaries: null
        };
        ee(f);
        return a;
    }
    function ii(a) {
        if (!a) return jc;
        a = a._reactInternals;
        a: {
            if (wa(a) !== a || 1 !== a.tag) throw Error(n(170));
            var b = a;
            do {
                switch(b.tag){
                    case 3:
                        b = b.stateNode.context;
                        break a;
                    case 1:
                        if (A(b.type)) {
                            b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                            break a;
                        }
                }
                b = b.return;
            }while (null !== b);
            throw Error(n(171));
        }
        if (1 === a.tag) {
            var c = a.type;
            if (A(c)) return pc(a, c, b);
        }
        return b;
    }
    function ji(a) {
        var b = a._reactInternals;
        if (void 0 === b) {
            if ("function" === typeof a.render) throw Error(n(188));
            a = Object.keys(a).join(",");
            throw Error(n(268, a));
        }
        a = Aa(b);
        return null === a ? null : a.stateNode;
    }
    function ki(a, b) {
        a = a.memoizedState;
        if (null !== a && null !== a.dehydrated) {
            var c = a.retryLane;
            a.retryLane = 0 !== c && c < b ? c : b;
        }
    }
    function li(a, b) {
        ki(a, b);
        (a = a.alternate) && ki(a, b);
    }
    function mi(a) {
        a = Aa(a);
        return null === a ? null : a.stateNode;
    }
    function ni() {
        return null;
    }
    exports.attemptContinuousHydration = function(a) {
        if (13 === a.tag) {
            var b = ce(a, 134217728);
            if (null !== b) {
                var c = O();
                af(b, a, 134217728, c);
            }
            li(a, 134217728);
        }
    };
    exports.attemptDiscreteHydration = function(a) {
        if (13 === a.tag) {
            var b = ce(a, 1);
            if (null !== b) {
                var c = O();
                af(b, a, 1, c);
            }
            li(a, 1);
        }
    };
    exports.attemptHydrationAtCurrentPriority = function(a) {
        if (13 === a.tag) {
            var b = tf(a), c = ce(a, b);
            if (null !== c) {
                var d = O();
                af(c, a, b, d);
            }
            li(a, b);
        }
    };
    exports.attemptSynchronousHydration = function(a) {
        switch(a.tag){
            case 3:
                var b = a.stateNode;
                if (b.current.memoizedState.isDehydrated) {
                    var c = yc(b.pendingLanes);
                    0 !== c && (Hc(b, c | 1), Kh(b, D()), 0 === (H & 6) && (Bh(), ad()));
                }
                break;
            case 13:
                Xh(function() {
                    var b = ce(a, 1);
                    if (null !== b) {
                        var c = O();
                        af(b, a, 1, c);
                    }
                }), li(a, 1);
        }
    };
    exports.batchedUpdates = function(a, b) {
        var c = H;
        H |= 1;
        try {
            return a(b);
        } finally{
            H = c, 0 === H && (Bh(), Xc && ad());
        }
    };
    exports.createComponentSelector = function(a) {
        return {
            $$typeof: hh,
            value: a
        };
    };
    exports.createContainer = function(a, b, c, d, e, f, g) {
        return hi(a, b, !1, null, c, d, e, f, g);
    };
    exports.createHasPseudoClassSelector = function(a) {
        return {
            $$typeof: ih,
            value: a
        };
    };
    exports.createHydrationContainer = function(a, b, c, d, e, f, g, h, k) {
        a = hi(c, d, !0, a, e, f, g, h, k);
        a.context = ii(null);
        c = a.current;
        d = O();
        e = tf(c);
        f = ge(d, e);
        f.callback = void 0 !== b && null !== b ? b : null;
        he(c, f, e);
        a.current.lanes = e;
        Fc(a, e, d);
        Kh(a, d);
        return a;
    };
    exports.createPortal = function(a, b, c) {
        var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
        return {
            $$typeof: fa,
            key: null == d ? null : "" + d,
            children: a,
            containerInfo: b,
            implementation: c
        };
    };
    exports.createRoleSelector = function(a) {
        return {
            $$typeof: jh,
            value: a
        };
    };
    exports.createTestNameSelector = function(a) {
        return {
            $$typeof: kh,
            value: a
        };
    };
    exports.createTextSelector = function(a) {
        return {
            $$typeof: lh,
            value: a
        };
    };
    exports.deferredUpdates = function(a) {
        var b = C, c = W.transition;
        try {
            return W.transition = null, C = 16, a();
        } finally{
            C = b, W.transition = c;
        }
    };
    exports.discreteUpdates = function(a, b, c, d, e) {
        var f = C, g = W.transition;
        try {
            return W.transition = null, C = 1, a(b, c, d, e);
        } finally{
            C = f, W.transition = g, 0 === H && Bh();
        }
    };
    exports.findAllNodes = rh;
    exports.findBoundingRects = function(a, b) {
        if (!bb) throw Error(n(363));
        b = rh(a, b);
        a = [];
        for(var c = 0; c < b.length; c++)a.push(db(b[c]));
        for(b = a.length - 1; 0 < b; b--){
            c = a[b];
            for(var d = c.x, e = d + c.width, f = c.y, g = f + c.height, h = b - 1; 0 <= h; h--)if (b !== h) {
                var k = a[h], l = k.x, m = l + k.width, r = k.y, p = r + k.height;
                if (d >= l && f >= r && e <= m && g <= p) {
                    a.splice(b, 1);
                    break;
                } else if (!(d !== l || c.width !== k.width || p < f || r > g)) {
                    r > f && (k.height += r - f, k.y = f);
                    p < g && (k.height = g - r);
                    a.splice(b, 1);
                    break;
                } else if (!(f !== r || c.height !== k.height || m < d || l > e)) {
                    l > d && (k.width += l - d, k.x = d);
                    m < e && (k.width = e - l);
                    a.splice(b, 1);
                    break;
                }
            }
        }
        return a;
    };
    exports.findHostInstance = ji;
    exports.findHostInstanceWithNoPortals = function(a) {
        a = za(a);
        a = null !== a ? Ca(a) : null;
        return null === a ? null : a.stateNode;
    };
    exports.findHostInstanceWithWarning = function(a) {
        return ji(a);
    };
    exports.flushControlled = function(a) {
        var b = H;
        H |= 1;
        var c = W.transition, d = C;
        try {
            W.transition = null, C = 1, a();
        } finally{
            C = d, W.transition = c, H = b, 0 === H && (Bh(), ad());
        }
    };
    exports.flushPassiveEffects = Oh;
    exports.flushSync = Xh;
    exports.focusWithin = function(a, b) {
        if (!bb) throw Error(n(363));
        a = nh(a);
        b = qh(a, b);
        b = Array.from(b);
        for(a = 0; a < b.length;){
            var c = b[a++];
            if (!fb(c)) {
                if (5 === c.tag && hb(c.stateNode)) return !0;
                for(c = c.child; null !== c;)b.push(c), c = c.sibling;
            }
        }
        return !1;
    };
    exports.getCurrentUpdatePriority = function() {
        return C;
    };
    exports.getFindAllNodesFailureDescription = function(a, b) {
        if (!bb) throw Error(n(363));
        var c = 0, d = [];
        a = [
            nh(a),
            0
        ];
        for(var e = 0; e < a.length;){
            var f = a[e++], g = a[e++], h = b[g];
            if (5 !== f.tag || !fb(f)) {
                if (oh(f, h) && (d.push(ph(h)), g++, g > c && (c = g)), g < b.length) for(f = f.child; null !== f;)a.push(f, g), f = f.sibling;
            }
        }
        if (c < b.length) {
            for(a = []; c < b.length; c++)a.push(ph(b[c]));
            return "findAllNodes was able to match part of the selector:\n  " + (d.join(" > ") + "\n\nNo matching component was found for:\n  ") + a.join(" > ");
        }
        return null;
    };
    exports.getPublicRootInstance = function(a) {
        a = a.current;
        if (!a.child) return null;
        switch(a.child.tag){
            case 5:
                return Ea(a.child.stateNode);
            default:
                return a.child.stateNode;
        }
    };
    exports.injectIntoDevTools = function(a) {
        a = {
            bundleType: a.bundleType,
            version: a.version,
            rendererPackageName: a.rendererPackageName,
            rendererConfig: a.rendererConfig,
            overrideHookState: null,
            overrideHookStateDeletePath: null,
            overrideHookStateRenamePath: null,
            overrideProps: null,
            overridePropsDeletePath: null,
            overridePropsRenamePath: null,
            setErrorHandler: null,
            setSuspenseHandler: null,
            scheduleUpdate: null,
            currentDispatcherRef: da.ReactCurrentDispatcher,
            findHostInstanceByFiber: mi,
            findFiberByHostInstance: a.findFiberByHostInstance || ni,
            findHostInstancesForRefresh: null,
            scheduleRefresh: null,
            scheduleRoot: null,
            setRefreshHandler: null,
            getCurrentFiber: null,
            reconcilerVersion: "18.3.1"
        };
        if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) a = !1;
        else {
            var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
            if (b.isDisabled || !b.supportsFiber) a = !0;
            else {
                try {
                    Rc = b.inject(a), Sc = b;
                } catch (c) {}
                a = b.checkDCE ? !0 : !1;
            }
        }
        return a;
    };
    exports.isAlreadyRendering = function() {
        return !1;
    };
    exports.observeVisibleRects = function(a, b, c, d) {
        if (!bb) throw Error(n(363));
        a = rh(a, b);
        var e = ib(a, c, d).disconnect;
        return {
            disconnect: function() {
                e();
            }
        };
    };
    exports.registerMutableSourceForHydration = function(a, b) {
        var c = b._getVersion;
        c = c(b._source);
        null == a.mutableSourceEagerHydrationData ? a.mutableSourceEagerHydrationData = [
            b,
            c
        ] : a.mutableSourceEagerHydrationData.push(b, c);
    };
    exports.runWithPriority = function(a, b) {
        var c = C;
        try {
            return C = a, b();
        } finally{
            C = c;
        }
    };
    exports.shouldError = function() {
        return null;
    };
    exports.shouldSuspend = function() {
        return !1;
    };
    exports.updateContainer = function(a, b, c, d) {
        var e = b.current, f = O(), g = tf(e);
        c = ii(c);
        null === b.context ? b.context = c : b.pendingContext = c;
        b = ge(f, g);
        b.payload = {
            element: a
        };
        d = void 0 === d ? null : d;
        null !== d && (b.callback = d);
        a = he(e, b, g);
        null !== a && (af(a, e, g, f), ie(a, e, g));
        return g;
    };
    return exports;
};

});


parcelRegister("d2SWu", function(module, exports) {
"use strict";

module.exports = (parcelRequire("d74WH"));

});
parcelRegister("d74WH", function(module, exports) {

$parcel$export(module.exports, "ConcurrentRoot", () => $98bfc3f36889cadf$export$816aac48d41c2f81, (v) => $98bfc3f36889cadf$export$816aac48d41c2f81 = v);
$parcel$export(module.exports, "ContinuousEventPriority", () => $98bfc3f36889cadf$export$3bb88615cd12cb3b, (v) => $98bfc3f36889cadf$export$3bb88615cd12cb3b = v);
$parcel$export(module.exports, "DefaultEventPriority", () => $98bfc3f36889cadf$export$d46163d5c045f347, (v) => $98bfc3f36889cadf$export$d46163d5c045f347 = v);
$parcel$export(module.exports, "DiscreteEventPriority", () => $98bfc3f36889cadf$export$8ee75c97f0333f15, (v) => $98bfc3f36889cadf$export$8ee75c97f0333f15 = v);
$parcel$export(module.exports, "IdleEventPriority", () => $98bfc3f36889cadf$export$d1c113b83e1f881a, (v) => $98bfc3f36889cadf$export$d1c113b83e1f881a = v);
$parcel$export(module.exports, "LegacyRoot", () => $98bfc3f36889cadf$export$ff78c4883554845d, (v) => $98bfc3f36889cadf$export$ff78c4883554845d = v);
/**
 * @license React
 * react-reconciler-constants.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $98bfc3f36889cadf$export$816aac48d41c2f81;
var $98bfc3f36889cadf$export$3bb88615cd12cb3b;
var $98bfc3f36889cadf$export$d46163d5c045f347;
var $98bfc3f36889cadf$export$8ee75c97f0333f15;
var $98bfc3f36889cadf$export$d1c113b83e1f881a;
var $98bfc3f36889cadf$export$ff78c4883554845d;
"use strict";
$98bfc3f36889cadf$export$816aac48d41c2f81 = 1;
$98bfc3f36889cadf$export$3bb88615cd12cb3b = 4;
$98bfc3f36889cadf$export$d46163d5c045f347 = 16;
$98bfc3f36889cadf$export$8ee75c97f0333f15 = 1;
$98bfc3f36889cadf$export$d1c113b83e1f881a = 536870912;
$98bfc3f36889cadf$export$ff78c4883554845d = 0;

});


parcelRegister("cRXqO", function(module, exports) {

$parcel$export(module.exports, "appendInitialChild", () => $95e889239f1c1ff6$export$b1cefef778e97ee8);
$parcel$export(module.exports, "createInstance", () => $95e889239f1c1ff6$export$99152e8d49ca4e7d);
$parcel$export(module.exports, "createTextInstance", () => $95e889239f1c1ff6$export$d1ef805cf7083486);
$parcel$export(module.exports, "finalizeInitialChildren", () => $95e889239f1c1ff6$export$7bb0b211bcb5abfd);
$parcel$export(module.exports, "getPublicInstance", () => $95e889239f1c1ff6$export$d2475cc200518c86);
$parcel$export(module.exports, "prepareForCommit", () => $95e889239f1c1ff6$export$ba5994afaabfdb0c);
$parcel$export(module.exports, "preparePortalMount", () => $95e889239f1c1ff6$export$e15c8ecd0a0092b2);
$parcel$export(module.exports, "prepareUpdate", () => $95e889239f1c1ff6$export$c885331d842f22b5);
$parcel$export(module.exports, "resetAfterCommit", () => $95e889239f1c1ff6$export$683e88f306512aed);
$parcel$export(module.exports, "resetTextContent", () => $95e889239f1c1ff6$export$2119d6fc5d6f51aa);
$parcel$export(module.exports, "shouldDeprioritizeSubtree", () => $95e889239f1c1ff6$export$70ab89a99d11d186);
$parcel$export(module.exports, "getRootHostContext", () => $95e889239f1c1ff6$export$dce2ca0b0f5feeb5);
$parcel$export(module.exports, "getChildHostContext", () => $95e889239f1c1ff6$export$1236a84b6992d37a);
$parcel$export(module.exports, "scheduleTimeout", () => $95e889239f1c1ff6$export$5f4d6617421d489b);
$parcel$export(module.exports, "cancelTimeout", () => $95e889239f1c1ff6$export$f78ec70d8091ca88);
$parcel$export(module.exports, "noTimeout", () => $95e889239f1c1ff6$export$78506abae4a4951d);
$parcel$export(module.exports, "shouldSetTextContent", () => $95e889239f1c1ff6$export$c82139d6d374ec34);
$parcel$export(module.exports, "isPrimaryRenderer", () => $95e889239f1c1ff6$export$a5fcb8abea5b71a4);
$parcel$export(module.exports, "warnsIfNotActing", () => $95e889239f1c1ff6$export$2516db7323c01bd5);
$parcel$export(module.exports, "supportsMutation", () => $95e889239f1c1ff6$export$20f97ad47f9ebeb);
$parcel$export(module.exports, "appendChild", () => $95e889239f1c1ff6$export$1b8e57c9ea42f1d2);
$parcel$export(module.exports, "appendChildToContainer", () => $95e889239f1c1ff6$export$5e391de19acdf645);
$parcel$export(module.exports, "insertBefore", () => $95e889239f1c1ff6$export$86b68c7dbeb53c22);
$parcel$export(module.exports, "insertInContainerBefore", () => $95e889239f1c1ff6$export$7ec3655259385e44);
$parcel$export(module.exports, "removeChild", () => $95e889239f1c1ff6$export$7ae609f7af59e4f7);
$parcel$export(module.exports, "removeChildFromContainer", () => $95e889239f1c1ff6$export$2e4ef5d75a473f1a);
$parcel$export(module.exports, "commitTextUpdate", () => $95e889239f1c1ff6$export$50a92d0155bee474);
$parcel$export(module.exports, "commitMount", () => $95e889239f1c1ff6$export$fe90794743fbfeb0);
$parcel$export(module.exports, "commitUpdate", () => $95e889239f1c1ff6$export$fd8222818e57ec6);
$parcel$export(module.exports, "hideInstance", () => $95e889239f1c1ff6$export$6db9fd2b8188b8b7);
$parcel$export(module.exports, "hideTextInstance", () => $95e889239f1c1ff6$export$17ed9cbd9cb3aad2);
$parcel$export(module.exports, "unhideInstance", () => $95e889239f1c1ff6$export$933e25c2090d1941);
$parcel$export(module.exports, "unhideTextInstance", () => $95e889239f1c1ff6$export$8ff685cdcb7326ff);
$parcel$export(module.exports, "clearContainer", () => $95e889239f1c1ff6$export$28e08eff11ac64f6);
$parcel$export(module.exports, "detachDeletedInstance", () => $95e889239f1c1ff6$export$92ab91999be04e45);
$parcel$export(module.exports, "getCurrentEventPriority", () => $95e889239f1c1ff6$export$e23f0d5a7e18b951);
$parcel$export(module.exports, "now", () => (parcelRequire("clk2u")).unstable_now);
$parcel$export(module.exports, "idlePriority", () => (parcelRequire("clk2u")).unstable_IdlePriority);
$parcel$export(module.exports, "run", () => (parcelRequire("clk2u")).unstable_runWithPriority);

var $d46Uo = parcelRequire("d46Uo");

var $9zm1x = parcelRequire("9zm1x");

var $clk2u = parcelRequire("clk2u");

var $d2SWu = parcelRequire("d2SWu");
const $95e889239f1c1ff6$var$NO_CONTEXT = {};
const $95e889239f1c1ff6$var$UPDATE_SIGNAL = {};
// for react-spring capability
(0, (/*@__PURE__*/$parcel$interopDefault($d46Uo))).Node.prototype._applyProps = (0, $9zm1x.applyNodeProps);
function $95e889239f1c1ff6$export$b1cefef778e97ee8(parentInstance, child) {
    if (typeof child === "string") {
        // Noop for string children of Text (eg <Text>foo</Text>)
        console.error(`Do not use plain text as child of Konva.Node. You are using text: ${child}`);
        return;
    }
    parentInstance.add(child);
    (0, $9zm1x.updatePicture)(parentInstance);
}
function $95e889239f1c1ff6$export$99152e8d49ca4e7d(type, props, internalInstanceHandle) {
    let NodeClass = (0, (/*@__PURE__*/$parcel$interopDefault($d46Uo)))[type];
    if (!NodeClass) {
        console.error(`Konva has no node with the type ${type}. Group will be used instead. If you use minimal version of react-konva, just import required nodes into Konva: "import "konva/lib/shapes/${type}"  If you want to render DOM elements as part of canvas tree take a look into this demo: https://konvajs.github.io/docs/react/DOM_Portal.html`);
        NodeClass = (0, (/*@__PURE__*/$parcel$interopDefault($d46Uo))).Group;
    }
    // we need to split props into events and non events
    // we we can pass non events into constructor directly
    // that way the performance should be better
    // we we apply change "applyNodeProps"
    // then it will trigger change events on first run
    // but we don't need them!
    const propsWithoutEvents = {};
    const propsWithOnlyEvents = {};
    for(var key in props){
        var isEvent = key.slice(0, 2) === "on";
        if (isEvent) propsWithOnlyEvents[key] = props[key];
        else propsWithoutEvents[key] = props[key];
    }
    const instance = new NodeClass(propsWithoutEvents);
    (0, $9zm1x.applyNodeProps)(instance, propsWithOnlyEvents);
    return instance;
}
function $95e889239f1c1ff6$export$d1ef805cf7083486(text, rootContainerInstance, internalInstanceHandle) {
    console.error(`Text components are not supported for now in ReactKonva. Your text is: "${text}"`);
}
function $95e889239f1c1ff6$export$7bb0b211bcb5abfd(domElement, type, props) {
    return false;
}
function $95e889239f1c1ff6$export$d2475cc200518c86(instance) {
    return instance;
}
function $95e889239f1c1ff6$export$ba5994afaabfdb0c() {
    return null;
}
function $95e889239f1c1ff6$export$e15c8ecd0a0092b2() {
    return null;
}
function $95e889239f1c1ff6$export$c885331d842f22b5(domElement, type, oldProps, newProps) {
    return $95e889239f1c1ff6$var$UPDATE_SIGNAL;
}
function $95e889239f1c1ff6$export$683e88f306512aed() {
// Noop
}
function $95e889239f1c1ff6$export$2119d6fc5d6f51aa(domElement) {
// Noop
}
function $95e889239f1c1ff6$export$70ab89a99d11d186(type, props) {
    return false;
}
function $95e889239f1c1ff6$export$dce2ca0b0f5feeb5() {
    return $95e889239f1c1ff6$var$NO_CONTEXT;
}
function $95e889239f1c1ff6$export$1236a84b6992d37a() {
    return $95e889239f1c1ff6$var$NO_CONTEXT;
}
const $95e889239f1c1ff6$export$5f4d6617421d489b = setTimeout;
const $95e889239f1c1ff6$export$f78ec70d8091ca88 = clearTimeout;
const $95e889239f1c1ff6$export$78506abae4a4951d = -1;
function $95e889239f1c1ff6$export$c82139d6d374ec34(type, props) {
    return false;
}
const $95e889239f1c1ff6$export$a5fcb8abea5b71a4 = false;
const $95e889239f1c1ff6$export$2516db7323c01bd5 = true;
const $95e889239f1c1ff6$export$20f97ad47f9ebeb = true;
function $95e889239f1c1ff6$export$1b8e57c9ea42f1d2(parentInstance, child) {
    if (child.parent === parentInstance) child.moveToTop();
    else parentInstance.add(child);
    (0, $9zm1x.updatePicture)(parentInstance);
}
function $95e889239f1c1ff6$export$5e391de19acdf645(parentInstance, child) {
    if (child.parent === parentInstance) child.moveToTop();
    else parentInstance.add(child);
    (0, $9zm1x.updatePicture)(parentInstance);
}
function $95e889239f1c1ff6$export$86b68c7dbeb53c22(parentInstance, child, beforeChild) {
    // child._remove() will not stop dragging
    // but child.remove() will stop it, but we don't need it
    // removing will reset zIndexes
    child._remove();
    parentInstance.add(child);
    child.setZIndex(beforeChild.getZIndex());
    (0, $9zm1x.updatePicture)(parentInstance);
}
function $95e889239f1c1ff6$export$7ec3655259385e44(parentInstance, child, beforeChild) {
    $95e889239f1c1ff6$export$86b68c7dbeb53c22(parentInstance, child, beforeChild);
}
function $95e889239f1c1ff6$export$7ae609f7af59e4f7(parentInstance, child) {
    child.destroy();
    child.off((0, $9zm1x.EVENTS_NAMESPACE));
    (0, $9zm1x.updatePicture)(parentInstance);
}
function $95e889239f1c1ff6$export$2e4ef5d75a473f1a(parentInstance, child) {
    child.destroy();
    child.off((0, $9zm1x.EVENTS_NAMESPACE));
    (0, $9zm1x.updatePicture)(parentInstance);
}
function $95e889239f1c1ff6$export$50a92d0155bee474(textInstance, oldText, newText) {
    console.error(`Text components are not yet supported in ReactKonva. You text is: "${newText}"`);
}
function $95e889239f1c1ff6$export$fe90794743fbfeb0(instance, type, newProps) {
// Noop
}
function $95e889239f1c1ff6$export$fd8222818e57ec6(instance, updatePayload, type, oldProps, newProps) {
    (0, $9zm1x.applyNodeProps)(instance, newProps, oldProps);
}
function $95e889239f1c1ff6$export$6db9fd2b8188b8b7(instance) {
    instance.hide();
    (0, $9zm1x.updatePicture)(instance);
}
function $95e889239f1c1ff6$export$17ed9cbd9cb3aad2(textInstance) {
// Noop
}
function $95e889239f1c1ff6$export$933e25c2090d1941(instance, props) {
    if (props.visible == null || props.visible) instance.show();
}
function $95e889239f1c1ff6$export$8ff685cdcb7326ff(textInstance, text) {
// Noop
}
function $95e889239f1c1ff6$export$28e08eff11ac64f6(container) {
// Noop
}
function $95e889239f1c1ff6$export$92ab91999be04e45() {}
const $95e889239f1c1ff6$export$e23f0d5a7e18b951 = ()=>(0, $d2SWu.DefaultEventPriority);

});
parcelRegister("9zm1x", function(module, exports) {

$parcel$export(module.exports, "EVENTS_NAMESPACE", () => $6f78776afe035dd6$export$3a20cc353cdae1b2);
$parcel$export(module.exports, "toggleStrictMode", () => $6f78776afe035dd6$export$5a38dcef855281ce);
$parcel$export(module.exports, "applyNodeProps", () => $6f78776afe035dd6$export$25d4dd8d7c7a61f6);
$parcel$export(module.exports, "updatePicture", () => $6f78776afe035dd6$export$8d64f55d8bab80d4);

var $4v96z = parcelRequire("4v96z");
const $6f78776afe035dd6$var$propsToSkip = {
    children: true,
    ref: true,
    key: true,
    style: true,
    forwardedRef: true,
    unstable_applyCache: true,
    unstable_applyDrawHitFromCache: true
};
let $6f78776afe035dd6$var$zIndexWarningShowed = false;
let $6f78776afe035dd6$var$dragWarningShowed = false;
const $6f78776afe035dd6$export$3a20cc353cdae1b2 = ".react-konva-event";
let $6f78776afe035dd6$var$useStrictMode = false;
function $6f78776afe035dd6$export$5a38dcef855281ce(value) {
    $6f78776afe035dd6$var$useStrictMode = value;
}
const $6f78776afe035dd6$var$DRAGGABLE_WARNING = `ReactKonva: You have a Konva node with draggable = true and position defined but no onDragMove or onDragEnd events are handled.
Position of a node will be changed during drag&drop, so you should update state of the react app as well.
Consider to add onDragMove or onDragEnd events.
For more info see: https://github.com/konvajs/react-konva/issues/256
`;
const $6f78776afe035dd6$var$Z_INDEX_WARNING = `ReactKonva: You are using "zIndex" attribute for a Konva node.
react-konva may get confused with ordering. Just define correct order of elements in your render function of a component.
For more info see: https://github.com/konvajs/react-konva/issues/194
`;
const $6f78776afe035dd6$var$EMPTY_PROPS = {};
function $6f78776afe035dd6$export$25d4dd8d7c7a61f6(instance, props, oldProps = $6f78776afe035dd6$var$EMPTY_PROPS) {
    // don't use zIndex in react-konva
    if (!$6f78776afe035dd6$var$zIndexWarningShowed && "zIndex" in props) {
        console.warn($6f78776afe035dd6$var$Z_INDEX_WARNING);
        $6f78776afe035dd6$var$zIndexWarningShowed = true;
    }
    // check correct draggable usage
    if (!$6f78776afe035dd6$var$dragWarningShowed && props.draggable) {
        var hasPosition = props.x !== undefined || props.y !== undefined;
        var hasEvents = props.onDragEnd || props.onDragMove;
        if (hasPosition && !hasEvents) {
            console.warn($6f78776afe035dd6$var$DRAGGABLE_WARNING);
            $6f78776afe035dd6$var$dragWarningShowed = true;
        }
    }
    // check old props
    // we need to unset properties that are not in new props
    // and remove all events
    for(var key in oldProps){
        if ($6f78776afe035dd6$var$propsToSkip[key]) continue;
        var isEvent = key.slice(0, 2) === "on";
        var propChanged = oldProps[key] !== props[key];
        // if that is a changed event, we need to remove it
        if (isEvent && propChanged) {
            var eventName = key.substr(2).toLowerCase();
            if (eventName.substr(0, 7) === "content") eventName = "content" + eventName.substr(7, 1).toUpperCase() + eventName.substr(8);
            instance.off(eventName, oldProps[key]);
        }
        var toRemove = !props.hasOwnProperty(key);
        if (toRemove) instance.setAttr(key, undefined);
    }
    var strictUpdate = $6f78776afe035dd6$var$useStrictMode || props._useStrictMode;
    var updatedProps = {};
    var hasUpdates = false;
    const newEvents = {};
    for(var key in props){
        if ($6f78776afe035dd6$var$propsToSkip[key]) continue;
        var isEvent = key.slice(0, 2) === "on";
        var toAdd = oldProps[key] !== props[key];
        if (isEvent && toAdd) {
            var eventName = key.substr(2).toLowerCase();
            if (eventName.substr(0, 7) === "content") eventName = "content" + eventName.substr(7, 1).toUpperCase() + eventName.substr(8);
            // check that event is not undefined
            if (props[key]) newEvents[eventName] = props[key];
        }
        if (!isEvent && (props[key] !== oldProps[key] || strictUpdate && props[key] !== instance.getAttr(key))) {
            hasUpdates = true;
            updatedProps[key] = props[key];
        }
    }
    if (hasUpdates) {
        instance.setAttrs(updatedProps);
        $6f78776afe035dd6$export$8d64f55d8bab80d4(instance);
    }
    // subscribe to events AFTER we set attrs
    // we need it to fix https://github.com/konvajs/react-konva/issues/471
    // settings attrs may add events. Like "draggable: true" will add "mousedown" listener
    for(var eventName in newEvents)instance.on(eventName + $6f78776afe035dd6$export$3a20cc353cdae1b2, newEvents[eventName]);
}
function $6f78776afe035dd6$export$8d64f55d8bab80d4(node) {
    if (!(0, $4v96z.Konva).autoDrawEnabled) {
        var drawingNode = node.getLayer() || node.getStage();
        drawingNode && drawingNode.batchDraw();
    }
}

});


parcelRegister("fGeNI", function(module, exports) {

$parcel$export(module.exports, "FiberProvider", () => $b6a6426d8d582e18$export$5a20fcbfd44d38b7);
$parcel$export(module.exports, "useContextBridge", () => $b6a6426d8d582e18$export$39579d26c695d393);

var $8NFma = parcelRequire("8NFma");
var $b6a6426d8d582e18$var$__defProp = Object.defineProperty;
var $b6a6426d8d582e18$var$__defProps = Object.defineProperties;
var $b6a6426d8d582e18$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $b6a6426d8d582e18$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $b6a6426d8d582e18$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $b6a6426d8d582e18$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $b6a6426d8d582e18$var$__defNormalProp = (obj, key, value)=>key in obj ? $b6a6426d8d582e18$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $b6a6426d8d582e18$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($b6a6426d8d582e18$var$__hasOwnProp.call(b, prop)) $b6a6426d8d582e18$var$__defNormalProp(a, prop, b[prop]);
    if ($b6a6426d8d582e18$var$__getOwnPropSymbols) {
        for (var prop of $b6a6426d8d582e18$var$__getOwnPropSymbols(b))if ($b6a6426d8d582e18$var$__propIsEnum.call(b, prop)) $b6a6426d8d582e18$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $b6a6426d8d582e18$var$__spreadProps = (a, b)=>$b6a6426d8d582e18$var$__defProps(a, $b6a6426d8d582e18$var$__getOwnPropDescs(b));
var $b6a6426d8d582e18$var$_a, $b6a6426d8d582e18$var$_b;
const $b6a6426d8d582e18$var$useIsomorphicLayoutEffect = typeof window !== "undefined" && ((($b6a6426d8d582e18$var$_a = window.document) == null ? void 0 : $b6a6426d8d582e18$var$_a.createElement) || (($b6a6426d8d582e18$var$_b = window.navigator) == null ? void 0 : $b6a6426d8d582e18$var$_b.product) === "ReactNative") ? $8NFma.useLayoutEffect : $8NFma.useEffect;
function $b6a6426d8d582e18$export$e2f435051054a3fd(fiber, ascending, selector) {
    if (!fiber) return;
    if (selector(fiber) === true) return fiber;
    let child = ascending ? fiber.return : fiber.child;
    while(child){
        const match = $b6a6426d8d582e18$export$e2f435051054a3fd(child, ascending, selector);
        if (match) return match;
        child = ascending ? null : child.sibling;
    }
}
function $b6a6426d8d582e18$var$wrapContext(context) {
    try {
        return Object.defineProperties(context, {
            _currentRenderer: {
                get () {
                    return null;
                },
                set () {}
            },
            _currentRenderer2: {
                get () {
                    return null;
                },
                set () {}
            }
        });
    } catch (_) {
        return context;
    }
}
const $b6a6426d8d582e18$var$error = console.error;
console.error = function() {
    const message = [
        ...arguments
    ].join("");
    if ((message == null ? void 0 : message.startsWith("Warning:")) && message.includes("useContext")) {
        console.error = $b6a6426d8d582e18$var$error;
        return;
    }
    return $b6a6426d8d582e18$var$error.apply(this, arguments);
};
const $b6a6426d8d582e18$var$FiberContext = $b6a6426d8d582e18$var$wrapContext($8NFma.createContext(null));
class $b6a6426d8d582e18$export$5a20fcbfd44d38b7 extends $8NFma.Component {
    render() {
        return /* @__PURE__ */ $8NFma.createElement($b6a6426d8d582e18$var$FiberContext.Provider, {
            value: this._reactInternals
        }, this.props.children);
    }
}
function $b6a6426d8d582e18$export$69c8591d5df5c7d6() {
    const root = $8NFma.useContext($b6a6426d8d582e18$var$FiberContext);
    if (root === null) throw new Error("its-fine: useFiber must be called within a <FiberProvider />!");
    const id = $8NFma.useId();
    const fiber = $8NFma.useMemo(()=>{
        for (const maybeFiber of [
            root,
            root == null ? void 0 : root.alternate
        ]){
            if (!maybeFiber) continue;
            const fiber2 = $b6a6426d8d582e18$export$e2f435051054a3fd(maybeFiber, false, (node)=>{
                let state = node.memoizedState;
                while(state){
                    if (state.memoizedState === id) return true;
                    state = state.next;
                }
            });
            if (fiber2) return fiber2;
        }
    }, [
        root,
        id
    ]);
    return fiber;
}
function $b6a6426d8d582e18$export$b537cf6ebaf7ff54() {
    const fiber = $b6a6426d8d582e18$export$69c8591d5df5c7d6();
    const root = $8NFma.useMemo(()=>$b6a6426d8d582e18$export$e2f435051054a3fd(fiber, true, (node)=>{
            var _a2;
            return ((_a2 = node.stateNode) == null ? void 0 : _a2.containerInfo) != null;
        }), [
        fiber
    ]);
    return root == null ? void 0 : root.stateNode.containerInfo;
}
function $b6a6426d8d582e18$export$aec415ac1d7388b6(type) {
    const fiber = $b6a6426d8d582e18$export$69c8591d5df5c7d6();
    const childRef = $8NFma.useRef();
    $b6a6426d8d582e18$var$useIsomorphicLayoutEffect(()=>{
        var _a2;
        childRef.current = (_a2 = $b6a6426d8d582e18$export$e2f435051054a3fd(fiber, false, (node)=>typeof node.type === "string" && (type === void 0 || node.type === type))) == null ? void 0 : _a2.stateNode;
    }, [
        fiber
    ]);
    return childRef;
}
function $b6a6426d8d582e18$export$b57c9fdd1434988b(type) {
    const fiber = $b6a6426d8d582e18$export$69c8591d5df5c7d6();
    const parentRef = $8NFma.useRef();
    $b6a6426d8d582e18$var$useIsomorphicLayoutEffect(()=>{
        var _a2;
        parentRef.current = (_a2 = $b6a6426d8d582e18$export$e2f435051054a3fd(fiber, true, (node)=>typeof node.type === "string" && (type === void 0 || node.type === type))) == null ? void 0 : _a2.stateNode;
    }, [
        fiber
    ]);
    return parentRef;
}
function $b6a6426d8d582e18$export$8859381a76e56404() {
    const fiber = $b6a6426d8d582e18$export$69c8591d5df5c7d6();
    const [contextMap] = $8NFma.useState(()=>/* @__PURE__ */ new Map());
    contextMap.clear();
    let node = fiber;
    while(node){
        if (node.type && typeof node.type === "object") {
            const enableRenderableContext = node.type._context === void 0 && node.type.Provider === node.type;
            const context = enableRenderableContext ? node.type : node.type._context;
            if (context && context !== $b6a6426d8d582e18$var$FiberContext && !contextMap.has(context)) contextMap.set(context, $8NFma.useContext($b6a6426d8d582e18$var$wrapContext(context)));
        }
        node = node.return;
    }
    return contextMap;
}
function $b6a6426d8d582e18$export$39579d26c695d393() {
    const contextMap = $b6a6426d8d582e18$export$8859381a76e56404();
    return $8NFma.useMemo(()=>Array.from(contextMap.keys()).reduce((Prev, context)=>(props)=>/* @__PURE__ */ $8NFma.createElement(Prev, null, /* @__PURE__ */ $8NFma.createElement(context.Provider, $b6a6426d8d582e18$var$__spreadProps($b6a6426d8d582e18$var$__spreadValues({}, props), {
                    value: contextMap.get(context)
                }))), (props)=>/* @__PURE__ */ $8NFma.createElement($b6a6426d8d582e18$export$5a20fcbfd44d38b7, $b6a6426d8d582e18$var$__spreadValues({}, props))), [
        contextMap
    ]);
}

});



parcelRegister("fY5ZF", function(module, exports) {

var $8NFma = parcelRequire("8NFma");
module.exports = function useImage(url, crossOrigin, referrerpolicy) {
    // lets use refs for image and status
    // so we can update them during render
    // to have instant update in status/image when new data comes in
    const statusRef = $8NFma.useRef("loading");
    const imageRef = $8NFma.useRef();
    // we are not going to use token
    // but we need to just to trigger state update
    const [_, setStateToken] = $8NFma.useState(0);
    // keep track of old props to trigger changes
    const oldUrl = $8NFma.useRef();
    const oldCrossOrigin = $8NFma.useRef();
    const oldReferrerPolicy = $8NFma.useRef();
    if (oldUrl.current !== url || oldCrossOrigin.current !== crossOrigin || oldReferrerPolicy.current !== referrerpolicy) {
        statusRef.current = "loading";
        imageRef.current = undefined;
        oldUrl.current = url;
        oldCrossOrigin.current = crossOrigin;
        oldReferrerPolicy.current = referrerpolicy;
    }
    $8NFma.useLayoutEffect(function() {
        if (!url) return;
        var img = document.createElement("img");
        function onload() {
            statusRef.current = "loaded";
            imageRef.current = img;
            setStateToken(Math.random());
        }
        function onerror() {
            statusRef.current = "failed";
            imageRef.current = undefined;
            setStateToken(Math.random());
        }
        img.addEventListener("load", onload);
        img.addEventListener("error", onerror);
        crossOrigin && (img.crossOrigin = crossOrigin);
        referrerpolicy && (img.referrerPolicy = referrerpolicy);
        img.src = url;
        return function cleanup() {
            img.removeEventListener("load", onload);
            img.removeEventListener("error", onerror);
        };
    }, [
        url,
        crossOrigin,
        referrerpolicy
    ]);
    // return array because it is better to use in case of several useImage hooks
    // const [background, backgroundStatus] = useImage(url1);
    // const [patter] = useImage(url2);
    return [
        imageRef.current,
        statusRef.current
    ];
};

});

parcelRegister("1wL0c", function(module, exports) {
"use strict";
var $11cd3d430c6d0be5$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.registerShapeComponent = void 0;

const $11cd3d430c6d0be5$var$react_1 = $11cd3d430c6d0be5$var$__importDefault((parcelRequire("8NFma")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

var $eQSol = parcelRequire("eQSol");

var $J29T0 = parcelRequire("J29T0");

var $1gtCb = parcelRequire("1gtCb");

var $dB0vw = parcelRequire("dB0vw");

var $e2GRP = parcelRequire("e2GRP");

var $50iP9 = parcelRequire("50iP9");
parcelRequire("k3LwQ");
var $fBZlQ = parcelRequire("fBZlQ");

var $gS5ZA = parcelRequire("gS5ZA");
const $11cd3d430c6d0be5$var$GroupElement = (0, $O1ETn.observer)((e)=>{
    const { element: t, store: n } = e, { children: r } = t, l = t.selectable || "admin" === n.role;
    return $11cd3d430c6d0be5$var$react_1.default.createElement($fBZlQ.Group, {
        opacity: t.opacity,
        listening: l,
        hideInExport: !t.showInExport
    }, r.map((t)=>$11cd3d430c6d0be5$var$react_1.default.createElement($11cd3d430c6d0be5$var$Element, Object.assign({}, e, {
            key: t.id,
            store: n,
            element: t
        }))));
}), $11cd3d430c6d0be5$var$SHAPES_TYPES = {
    text: $eQSol.TextElement,
    image: $J29T0.ImageElement,
    svg: $J29T0.ImageElement,
    line: $dB0vw.LineElement,
    video: $e2GRP.VideoElement,
    figure: $50iP9.FigureElement,
    group: $11cd3d430c6d0be5$var$GroupElement
};
function $11cd3d430c6d0be5$var$registerShapeComponent(e, t) {
    $11cd3d430c6d0be5$var$SHAPES_TYPES[e] = t;
}
module.exports.registerShapeComponent = $11cd3d430c6d0be5$var$registerShapeComponent;
const $11cd3d430c6d0be5$var$Element = (0, $O1ETn.observer)((e)=>{
    let t = $11cd3d430c6d0be5$var$SHAPES_TYPES[e.element.type];
    return "text" === e.element.type && $gS5ZA.flags.htmlRenderEnabled && (t = $1gtCb.HTMLElement), e.element.visible ? t ? $11cd3d430c6d0be5$var$react_1.default.createElement(t, Object.assign({}, e)) : (console.error("Can not find component for " + e.element.type), null) : null;
});
module.exports.default = $11cd3d430c6d0be5$var$Element;

});
parcelRegister("eQSol", function(module, exports) {
"use strict";
var $ad001d0df2601ba5$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.TextElement = module.exports.usePrevious = module.exports.getLineHeight = module.exports.useFontLoader = module.exports.getDir = module.exports.isRTLText = void 0;

const $ad001d0df2601ba5$var$react_1 = $ad001d0df2601ba5$var$__importDefault((parcelRequire("8NFma")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");
parcelRequire("k3LwQ");
var $fBZlQ = parcelRequire("fBZlQ");
parcelRequire("7TL1v");
var $1SE86 = parcelRequire("1SE86");

var $2SBKn = parcelRequire("2SBKn");

const $ad001d0df2601ba5$var$konva_1 = $ad001d0df2601ba5$var$__importDefault((parcelRequire("ciNAD")));

var $6K19x = parcelRequire("6K19x");

var $kWHDJ = parcelRequire("kWHDJ");

var $l4lre = parcelRequire("l4lre");

var $iPHWg = parcelRequire("iPHWg");

var $gS5ZA = parcelRequire("gS5ZA");

var $8vcNW = parcelRequire("8vcNW");

var $aWsdH = parcelRequire("aWsdH");

var $9uXpD = parcelRequire("9uXpD");

var $4WWR6 = parcelRequire("4WWR6");

var $3pcZ0 = parcelRequire("3pcZ0");

var $58B0H = parcelRequire("58B0H");
$ad001d0df2601ba5$var$konva_1.default._fixTextRendering = !0;
const $ad001d0df2601ba5$var$styleNode = document.createElement("style");
$ad001d0df2601ba5$var$styleNode.type = "text/css", document.head.appendChild($ad001d0df2601ba5$var$styleNode);
const $ad001d0df2601ba5$var$initialStyles = {
    border: "none",
    padding: "0px",
    overflow: "hidden",
    background: "none",
    outline: "none",
    resize: "none",
    overflowWrap: "break-word",
    whiteSpace: "pre-wrap",
    userSelect: "text",
    wordBreak: "normal"
};
function $ad001d0df2601ba5$var$isRTL(e) {
    var t = "\u0591-\u07FF\u200F\u202B\u202E\uFB1D-\uFDFD\uFE70-\uFEFC";
    return new RegExp("^[^" + t + "]*?[" + t + "]").test(e);
}
function $ad001d0df2601ba5$var$isRTLText(e) {
    e = e.replace(/\s/g, "");
    let t = 0;
    for(var r = 0; r < e.length; r++)$ad001d0df2601ba5$var$isRTL(e[r]) && (t += 1);
    return t > e.length / 2;
}
function $ad001d0df2601ba5$var$getDir(e) {
    return $ad001d0df2601ba5$var$isRTLText(e) ? "rtl" : "ltr";
}
module.exports.isRTLText = $ad001d0df2601ba5$var$isRTLText, module.exports.getDir = $ad001d0df2601ba5$var$getDir;
const $ad001d0df2601ba5$var$TextInput = (0, $O1ETn.observer)(({ textNodeRef: e, element: t, onBlur: r, selectAll: n, cursorPosition: i })=>{
    const [o, a] = $ad001d0df2601ba5$var$react_1.default.useState($ad001d0df2601ba5$var$initialStyles), l = e.current;
    $ad001d0df2601ba5$var$react_1.default.useLayoutEffect(()=>{
        const e = {};
        e.width = l.width() - 2 * l.padding() + "px", e.height = l.height() - 2 * l.padding() + l.fontSize() * l.lineHeight() + "px", e.fontSize = l.fontSize() + "px", e.lineHeight = l.lineHeight() + .01, e.fontFamily = l.fontFamily(), e.textAlign = l.align(), e.color = l.fill(), e.fontWeight = t.fontWeight, e.fontStyle = t.fontStyle, e.letterSpacing = t.letterSpacing + "em";
        const r = `\n        .polotno-input::placeholder {\n          color: ${o.color};\n          opacity: 0.6;\n        }\n      `;
        $ad001d0df2601ba5$var$styleNode.innerHTML = "", $ad001d0df2601ba5$var$styleNode.appendChild(document.createTextNode(r)), JSON.stringify(e) !== JSON.stringify(o) && a(e);
    });
    const s = $ad001d0df2601ba5$var$react_1.default.useRef(null);
    $ad001d0df2601ba5$var$react_1.default.useEffect(()=>{
        const e = setTimeout(()=>{
            var e;
            const t = s.current;
            if (!t) return;
            null === (e = s.current) || void 0 === e || e.focus();
            const r = i || t.value.length;
            t.selectionStart = t.selectionEnd = r, n && (null == t || t.select(), document.execCommand("selectAll", !1, null));
        });
        return ()=>{
            clearTimeout(e);
        };
    }, []), $ad001d0df2601ba5$var$react_1.default.useEffect(()=>{
        window.addEventListener("blur", r);
        const e = (e)=>{
            var t;
            (null === (t = s.current) || void 0 === t ? void 0 : t.contains(e.target)) || r();
        };
        return window.addEventListener("touchstart", e), ()=>{
            window.removeEventListener("blur", r), window.removeEventListener("touchstart", e);
        };
    }, []);
    let d = 0;
    const c = l.textArr.length * l.lineHeight() * l.fontSize();
    "middle" === t.verticalAlign && (d = (t.a.height - c) / 2), "bottom" === t.verticalAlign && (d = t.a.height - c);
    const u = (0, $8vcNW.removeTags)(t.text);
    return $ad001d0df2601ba5$var$react_1.default.createElement($1SE86.Html, null, $ad001d0df2601ba5$var$react_1.default.createElement("textarea", {
        className: "polotno-input",
        ref: s,
        dir: $ad001d0df2601ba5$var$getDir(u),
        style: Object.assign(Object.assign(Object.assign({}, $ad001d0df2601ba5$var$initialStyles), o), {
            paddingTop: d + "px"
        }),
        value: u,
        onChange: (e)=>{
            t.set({
                text: e.target.value
            });
        },
        placeholder: t.placeholder,
        onBlur: r
    }));
}), $ad001d0df2601ba5$var$useEditor = (e)=>{
    const [t, r] = $ad001d0df2601ba5$var$react_1.default.useState(!1), n = $ad001d0df2601ba5$var$react_1.default.useRef(!1);
    return $ad001d0df2601ba5$var$react_1.default.useEffect(()=>{
        var t = !0;
        return setTimeout(()=>{
            t && (e._editModeEnabled && (n.current = !0), r(!0), setTimeout(()=>{
                n.current = !1;
            }, 50));
        }, 50), ()=>{
            t = !1;
        };
    }, []), {
        editorEnabled: t && e._editModeEnabled,
        selectAll: n.current
    };
}, $ad001d0df2601ba5$var$useFontLoader = (e, t)=>{
    const [r, n] = $ad001d0df2601ba5$var$react_1.default.useReducer((e)=>e + 1, 0), i = $ad001d0df2601ba5$var$react_1.default.useRef((0, $iPHWg.isFontLoaded)(t));
    return $ad001d0df2601ba5$var$react_1.default.useLayoutEffect(()=>{
        if (i.current = (0, $iPHWg.isFontLoaded)(t), i.current) return;
        let r = !0;
        return (async ()=>{
            i.current = !1, n();
            const o = (0, $l4lre.incrementLoader)(`text ${t}`);
            await e.loadFont(t), setTimeout(o, 100), r && (i.current = !0, n());
        })(), ()=>{
            r = !1;
        };
    }, [
        t
    ]), [
        i.current
    ];
};
module.exports.useFontLoader = $ad001d0df2601ba5$var$useFontLoader;
const $ad001d0df2601ba5$var$getLineHeight = ({ fontLoaded: e, fontFamily: t, fontSize: r, lineHeight: n })=>$ad001d0df2601ba5$var$react_1.default.useMemo(()=>{
        if ("number" == typeof n) return n;
        const e = document.createElement("div");
        e.style.fontFamily = t, e.style.fontSize = r + "px", e.style.lineHeight = n, e.innerText = "Test text", document.body.appendChild(e);
        const i = e.offsetHeight;
        return document.body.removeChild(e), i / r;
    }, [
        e,
        t,
        r,
        n
    ]);
function $ad001d0df2601ba5$var$getRelativePointerPosition(e) {
    var t = e.getAbsoluteTransform().copy();
    t.invert();
    var r = e.getStage().getPointerPosition();
    return t.point(r);
}
function $ad001d0df2601ba5$var$getCursorPosition(e) {
    var t;
    const r = e.target, n = $ad001d0df2601ba5$var$getRelativePointerPosition(r), i = r.textArr, o = Math.floor(n.y / (r.fontSize() * r.lineHeight())), a = i.slice(0, o).reduce((e, t)=>e + t.text.length, o), l = null !== (t = i[o]) && void 0 !== t ? t : i[0];
    let s = 0;
    "right" === r.align() ? s = r.width() - l.width : "center" === r.align() && (s = r.width() / 2 - l.width / 2);
    return a + Math.round((n.x - s) / l.width * l.text.length);
}
function $ad001d0df2601ba5$var$usePrevious(e) {
    const t = $ad001d0df2601ba5$var$react_1.default.useRef(e), r = $ad001d0df2601ba5$var$react_1.default.useRef(e);
    return $ad001d0df2601ba5$var$react_1.default.useMemo(()=>{
        r.current = t.current, t.current = e;
    }, [
        e
    ]), r.current;
}
function $ad001d0df2601ba5$var$findFitFontSize(e, t) {
    const r = e.fontSize(), n = e.height(), i = (0, $8vcNW.removeTags)(t.text);
    let o = t.a.fontSize;
    e.height(void 0);
    const a = Math.round(2 * t.a.fontSize) - 1;
    for(let r = 1; r < a; r++){
        const r = t.a.height && e.height() > t.a.height, n = i.split("\n").join(" ").split(/[\s-]+/);
        let a = e.textArr.map((e)=>e.text).join(";");
        const l = n.find((e)=>!a.includes(e) || (a = a.replace(e, ""), !1));
        if (!(r || l)) break;
        o -= .5, e.fontSize(o);
    }
    return e.fontSize(r), e.height(n), o;
}
function $ad001d0df2601ba5$var$generateBackgroundShape({ lines: e, lineHeight: t, width: r, align: n = "left", padding: i = 0, cornerRadius: o = 0 }) {
    var a;
    e.forEach((e, t)=>{
        e.cx = r / 2, "right" === n ? e.cx = r - e.width / 2 : "left" === n && (e.cx = e.width / 2), "justify" !== n || e.lastInParagraph || (e.width = r), "justify" === n && (e.cx = e.width / 2);
    });
    let l = `M ${null === (a = e[0]) || void 0 === a ? void 0 : a.cx} ${-i}`;
    e.forEach((r, n)=>{
        const { cx: o } = r, a = e[n - 1];
        a && a.width > r.width ? l += ` L ${o + r.width / 2 + i} ${n * t + i}` : l += ` L ${o + r.width / 2 + i} ${n * t - i}`;
        const s = e[n + 1];
        s && s.width > r.width ? l += ` L ${o + r.width / 2 + i} ${(n + 1) * t - i}` : l += ` L ${o + r.width / 2 + i} ${(n + 1) * t + i}`;
    });
    for(var s = e.length - 1; s >= 0; s--){
        const r = e[s], { cx: n } = r, o = e[s + 1];
        o && o.width > r.width ? l += ` L ${n - r.width / 2 - i} ${(s + 1) * t - i}` : l += ` L ${n - r.width / 2 - i} ${(s + 1) * t + i}`;
        const a = e[s - 1];
        a && a.width > r.width ? l += ` L ${n - r.width / 2 - i} ${s * t + i}` : l += ` L ${n - r.width / 2 - i} ${s * t - i}`;
    }
    l += " Z";
    const d = (0, $6K19x.parsePath)(l);
    return (0, $6K19x.roundCommands)(d, o).path;
}
module.exports.getLineHeight = $ad001d0df2601ba5$var$getLineHeight, module.exports.usePrevious = $ad001d0df2601ba5$var$usePrevious, module.exports.TextElement = (0, $O1ETn.observer)(({ element: e, store: t })=>{
    const r = $ad001d0df2601ba5$var$react_1.default.useRef(null), n = $ad001d0df2601ba5$var$react_1.default.useRef(null), { editorEnabled: i, selectAll: o } = $ad001d0df2601ba5$var$useEditor(e), [a, l] = $ad001d0df2601ba5$var$react_1.default.useState(!1), [s, d] = $ad001d0df2601ba5$var$react_1.default.useState(!1), c = $ad001d0df2601ba5$var$react_1.default.useRef(e.a.height), u = t.selectedElements.indexOf(e) >= 0, { textVerticalResizeEnabled: f } = $gS5ZA.flags, h = $ad001d0df2601ba5$var$usePrevious(e.fontFamily), [g, _] = $ad001d0df2601ba5$var$react_1.default.useState([]);
    $ad001d0df2601ba5$var$react_1.default.useEffect(()=>{
        var e, t;
        const n = null !== (t = null === (e = r.current) || void 0 === e ? void 0 : e.textArr) && void 0 !== t ? t : [];
        JSON.stringify(n) !== JSON.stringify(g) && _(n);
    }), $ad001d0df2601ba5$var$react_1.default.useEffect(()=>{
        if (e.a.width) return;
        const t = r.current;
        t.width(600), e.set({
            width: 1.4 * t.getTextWidth()
        });
    }, []), $ad001d0df2601ba5$var$react_1.default.useLayoutEffect(()=>(0, $2SBKn.autorun)(()=>{
            const t = r.current;
            (0, $aWsdH.applyFilter)(t, e);
        }));
    const [x] = (0, module.exports.useFontLoader)(t, e.fontFamily), p = (0, $8vcNW.removeTags)(e.text), v = ()=>{
        const e = r.current.clone({
            height: void 0
        }), t = Math.ceil(e.fontSize() * e.lineHeight() * e.textArr.length + 1);
        return e.destroy(), t;
    };
    $ad001d0df2601ba5$var$react_1.default.useLayoutEffect(()=>{
        if (!x) return;
        const { textOverflow: n } = $gS5ZA.flags;
        if (e.a.height) {
            if ("change-font-size" !== n || s || t.isPlaying) {
                if ("resize" === n) {
                    const n = v();
                    f && e.a.height < n && t.history.ignore(()=>{
                        var t;
                        (0, $58B0H.isAlive)(e) && e.set({
                            height: n
                        }), null === (t = r.current) || void 0 === t || t.height(n);
                    }, !1, !0), f || e.a.height === n || t.history.ignore(()=>{
                        var t;
                        (0, $58B0H.isAlive)(e) && e.set({
                            height: n
                        }), null === (t = r.current) || void 0 === t || t.height(n);
                    }, !1, !0);
                }
            } else {
                const n = $ad001d0df2601ba5$var$findFitFontSize(r.current, e);
                if (n !== e.a.fontSize) return void t.history.ignore(()=>{
                    e.set({
                        fontSize: n
                    });
                }, !1, !0);
                const i = v();
                e.a.height === i || f || t.history.ignore(()=>{
                    e.set({
                        height: i
                    });
                }, !1, !0);
            }
        } else {
            const r = v();
            t.history.ignore(()=>{
                e.set({
                    height: r
                });
            }, !1, !0);
        }
    }), $ad001d0df2601ba5$var$react_1.default.useLayoutEffect(()=>{
        const t = r.current;
        t && (t.width(t.width() + 1e-8), t._setTextData(), (0, $aWsdH.applyFilter)(t, e));
    }, [
        x
    ]);
    const m = $ad001d0df2601ba5$var$react_1.default.useRef(null), y = $ad001d0df2601ba5$var$react_1.default.useRef(0), w = (r)=>{
        r.evt.preventDefault();
        const n = t.selectedShapes.find((t)=>t === e);
        n && e.contentEditable && (y.current = $ad001d0df2601ba5$var$getCursorPosition(r), e.toggleEditMode());
    }, S = !p && e.placeholder ? .6 : e.a.opacity;
    (0, $9uXpD.useFadeIn)(r, S);
    const b = (0, module.exports.getLineHeight)({
        fontLoaded: x,
        fontFamily: e.fontFamily,
        fontSize: e.a.fontSize,
        lineHeight: e.lineHeight
    }), E = e.selectable || "admin" === t.role, L = (0, $kWHDJ.useColor)(e), T = $ad001d0df2601ba5$var$react_1.default.useMemo(()=>e.backgroundEnabled ? $ad001d0df2601ba5$var$generateBackgroundShape({
            lines: JSON.parse(JSON.stringify(g)),
            cornerRadius: e.backgroundCornerRadius * (e.a.fontSize * b * .5),
            lineHeight: b * e.a.fontSize,
            padding: e.backgroundPadding * (e.a.fontSize * b * .5),
            width: e.a.width,
            align: e.align
        }) : "", [
        e.backgroundEnabled,
        e.backgroundCornerRadius,
        e.a.fontSize,
        b,
        e.backgroundPadding,
        e.a.width,
        e.align,
        g
    ]), z = (0, $3pcZ0.useMobile)();
    let k = 0;
    return "middle" === e.verticalAlign ? k = (e.a.height - g.length * b * e.a.fontSize) / 2 : "bottom" === e.verticalAlign && (k = e.a.height - g.length * b * e.a.fontSize), $ad001d0df2601ba5$var$react_1.default.createElement($ad001d0df2601ba5$var$react_1.default.Fragment, null, $ad001d0df2601ba5$var$react_1.default.createElement($fBZlQ.Path, {
        ref: n,
        x: e.a.x,
        y: e.a.y,
        rotation: e.a.rotation,
        hideInExport: !e.showInExport || !p,
        listening: !1,
        visible: e.backgroundEnabled,
        opacity: e.backgroundOpacity,
        data: T,
        fill: e.backgroundColor,
        offsetY: -k
    }), $ad001d0df2601ba5$var$react_1.default.createElement($fBZlQ.Text, Object.assign({
        ref: r,
        id: e.id,
        name: "element",
        hideInExport: !e.showInExport || !p,
        editModeEnabled: e._editModeEnabled,
        x: e.a.x,
        y: e.a.y,
        rotation: e.a.rotation,
        width: e.a.width,
        height: e.a.height,
        text: p || e.placeholder
    }, L, {
        stroke: e.stroke,
        lineJoin: "round",
        strokeWidth: e.strokeWidth,
        fillAfterStrokeEnabled: !0,
        fontSize: e.a.fontSize,
        fontFamily: `"${e.fontFamily}", "${h}"`,
        fontStyle: e.fontStyle + " " + e.fontWeight,
        textDecoration: e.textDecoration,
        align: e.align,
        verticalAlign: e.verticalAlign,
        draggable: z ? e.draggable && u : e.draggable,
        preventDefault: !z || u,
        opacity: S,
        visible: !e._editModeEnabled,
        ellipsis: "ellipsis" === $gS5ZA.flags.textOverflow,
        shadowEnabled: e.shadowEnabled,
        shadowBlur: e.shadowBlur,
        shadowOffsetX: e.shadowOffsetX,
        shadowOffsetY: e.shadowOffsetY,
        shadowColor: e.shadowColor,
        shadowOpacity: e.shadowOpacity,
        lineHeight: b,
        letterSpacing: e.letterSpacing * e.a.fontSize,
        listening: E,
        onDragMove: (t)=>{
            e.set({
                x: t.target.x(),
                y: t.target.y()
            });
        },
        onDragEnd: (t)=>{
            e.set({
                x: t.target.x(),
                y: t.target.y()
            });
        },
        onMouseEnter: ()=>{
            l(!0);
        },
        onMouseLeave: ()=>{
            l(!1);
        },
        onClick: w,
        onTap: w,
        onTransformStart: ()=>{
            d(!0), c.current = r.current.height();
        },
        onTransform: (t)=>{
            var r, i;
            const o = t.target;
            null === (r = n.current) || void 0 === r || r.setAttrs({
                x: o.x(),
                y: o.y(),
                rotation: o.rotation(),
                scale: o.scale()
            });
            const a = (null === (i = o.getStage()) || void 0 === i ? void 0 : i.findOne("Transformer")).getActiveAnchor();
            if ("middle-left" === a || "middle-right" === a) {
                const t = o.scaleX(), r = o.width() * t, n = e.a.fontSize;
                let i = r;
                r < n && (i = n, m.current && o.position(m.current)), o.width(i), o.scaleX(1), o.scaleY(1);
                const a = v();
                if ("ellipsis" !== $gS5ZA.flags.textOverflow) {
                    const t = Math.max(a, c.current);
                    o.height(t), e.set({
                        height: o.height()
                    });
                }
                e.set({
                    x: o.x(),
                    y: o.y(),
                    width: o.width(),
                    rotation: o.rotation()
                }), (0, $aWsdH.applyFilter)(o, e);
            }
            if ("top-center" === a || "bottom-center" === a) {
                let r = "resize" === $gS5ZA.flags.textOverflow ? v() : b * e.a.fontSize;
                t.target.height(Math.max(r, t.target.height() * t.target.scaleY())), t.target.scaleY(1);
            }
            m.current = t.target.position();
        },
        onTransformEnd: (t)=>{
            var r;
            const i = t.target.scaleX();
            t.target.scaleX(1), t.target.scaleY(1), e.set({
                fontSize: Math.round(e.a.fontSize * i),
                width: Math.ceil(t.target.width() * i),
                x: t.target.x(),
                y: t.target.y(),
                rotation: t.target.rotation(),
                height: t.target.height() * i,
                shadowBlur: e.shadowBlur * i,
                shadowOffsetX: e.shadowOffsetX * i,
                shadowOffsetY: e.shadowOffsetY * i,
                strokeWidth: e.strokeWidth * i
            }), null === (r = n.current) || void 0 === r || r.setAttrs({
                scaleX: 1,
                scaleY: 1
            }), d(!1);
        }
    })), i && $ad001d0df2601ba5$var$react_1.default.createElement($fBZlQ.Group, {
        x: e.a.x,
        y: e.a.y,
        rotation: e.a.rotation
    }, $ad001d0df2601ba5$var$react_1.default.createElement($ad001d0df2601ba5$var$TextInput, {
        textNodeRef: r,
        element: e,
        selectAll: o,
        cursorPosition: y.current,
        onBlur: ()=>{
            e.toggleEditMode(!1);
        }
    })), !s && (a || u) && $ad001d0df2601ba5$var$react_1.default.createElement($4WWR6.Highlighter, {
        element: e
    }));
});

});
parcelRegister("7TL1v", function(module, exports) {
$parcel$export(module.exports, "Html", () => (parcelRequire("1SE86")).Html);

$parcel$export(module.exports, "Portal", () => (parcelRequire("eQWOP")).Portal);
parcelRequire("1SE86");

var $eQWOP = parcelRequire("eQWOP");
parcelRequire("ivYYl");
var $fY5ZF = parcelRequire("fY5ZF");

});
parcelRegister("1SE86", function(module, exports) {

$parcel$export(module.exports, "Html", () => $15e9f684b9d46a92$export$13f9d3c4397c4713);

var $8NFma = parcelRequire("8NFma");

var $6T1J1 = parcelRequire("6T1J1");
parcelRequire("k3LwQ");
var $fBZlQ = parcelRequire("fBZlQ");

var $fGeNI = parcelRequire("fGeNI");
var $15e9f684b9d46a92$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $15e9f684b9d46a92$var$needForceStyle = (el)=>{
    const pos = window.getComputedStyle(el).position;
    const ok = pos === "absolute" || pos === "relative";
    return !ok;
};
function $15e9f684b9d46a92$export$90fc3a17d93f704c(fn = ()=>{}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useRef(fn);
    ref.current = fn;
    return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useCallback((...args)=>{
        return ref.current.apply(null, args);
    }, []);
}
const $15e9f684b9d46a92$export$13f9d3c4397c4713 = ({ children: children, groupProps: groupProps, divProps: divProps, transform: transform, transformFunc: transformFunc })=>{
    const Bridge = (0, $fGeNI.useContextBridge)();
    const groupRef = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useRef(null);
    const container = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useRef();
    const [div] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState(()=>document.createElement("div"));
    const root = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useMemo(()=>(0, (/*@__PURE__*/$parcel$interopDefault($6T1J1))).createRoot(div), [
        div
    ]);
    const shouldTransform = transform !== null && transform !== void 0 ? transform : true;
    const handleTransform = $15e9f684b9d46a92$export$90fc3a17d93f704c(()=>{
        if (shouldTransform && groupRef.current) {
            const tr = groupRef.current.getAbsoluteTransform();
            let attrs = tr.decompose();
            if (transformFunc) attrs = transformFunc(attrs);
            div.style.position = "absolute";
            div.style.zIndex = "10";
            div.style.top = "0px";
            div.style.left = "0px";
            div.style.transform = `translate(${attrs.x}px, ${attrs.y}px) rotate(${attrs.rotation}deg) scaleX(${attrs.scaleX}) scaleY(${attrs.scaleY})`;
            div.style.transformOrigin = "top left";
        } else {
            div.style.position = "";
            div.style.zIndex = "";
            div.style.top = "";
            div.style.left = "";
            div.style.transform = ``;
            div.style.transformOrigin = "";
        }
        const _a = divProps || {}, { style: style } = _a, restProps = $15e9f684b9d46a92$var$__rest(_a, [
            "style"
        ]);
        Object.assign(div.style, style);
        Object.assign(div, restProps);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useLayoutEffect(()=>{
        var _a;
        const group = groupRef.current;
        if (!group) return;
        const parent = (_a = group.getStage()) === null || _a === void 0 ? void 0 : _a.container();
        if (!parent) return;
        parent.appendChild(div);
        if (shouldTransform && $15e9f684b9d46a92$var$needForceStyle(parent)) parent.style.position = "relative";
        group.on("absoluteTransformChange", handleTransform);
        handleTransform();
        return ()=>{
            var _a;
            group.off("absoluteTransformChange", handleTransform);
            (_a = div.parentNode) === null || _a === void 0 || _a.removeChild(div);
        };
    }, [
        shouldTransform
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useLayoutEffect(()=>{
        handleTransform();
    }, [
        divProps,
        transformFunc
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useLayoutEffect(()=>{
        root.render((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement(Bridge, null, children));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useLayoutEffect(()=>{
        return ()=>{
            setTimeout(()=>{
                root.unmount();
            });
        };
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $fBZlQ.Group), Object.assign({
        ref: groupRef
    }, groupProps));
};

});

parcelRegister("eQWOP", function(module, exports) {

$parcel$export(module.exports, "Portal", () => $ad038c318a8ab0be$export$602eac185826482c);

var $8NFma = parcelRequire("8NFma");
parcelRequire("k3LwQ");
var $fBZlQ = parcelRequire("fBZlQ");
const $ad038c318a8ab0be$export$602eac185826482c = ({ selector: selector, enabled: enabled, children: children })=>{
    const outer = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useRef(null);
    const inner = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useRef(null);
    const safeRef = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useRef();
    const shouldMove = enabled !== null && enabled !== void 0 ? enabled : true;
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useLayoutEffect(()=>{
        if (!outer.current || !inner.current) return;
        safeRef.current = inner.current;
        const stage = outer.current.getStage();
        const newContainer = stage.findOne(selector);
        if (shouldMove && newContainer) inner.current.moveTo(newContainer);
        else inner.current.moveTo(outer.current);
        const outerLayer = outer.current.getLayer();
        if (!outerLayer) return;
        outerLayer.batchDraw();
        if (newContainer) {
            const newContainerLayer = newContainer.getLayer();
            if (!newContainerLayer) return;
            newContainerLayer.batchDraw();
        }
    }, [
        selector,
        shouldMove
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        return ()=>{
            var _a;
            (_a = safeRef.current) === null || _a === void 0 || _a.destroy();
        };
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $fBZlQ.Group), {
        name: "_outer_portal",
        ref: outer
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $fBZlQ.Group), {
        name: "_inner_portal",
        ref: inner
    }, children));
};

});

parcelRegister("ivYYl", function(module, exports) {

var $fY5ZF = parcelRequire("fY5ZF");

});


parcelRegister("6K19x", function(module, exports) {

$parcel$export(module.exports, "parsePath", () => $4e87eee274742ace$export$8ccf933b0513f8d0);
$parcel$export(module.exports, "roundCommands", () => $4e87eee274742ace$export$877ed57b5d7c5e55);

var $k8Oib = parcelRequire("k8Oib");
/**
 * Parses the given command string and generates an array of parsed commands.
 * This function normalises all relative commands into absolute commands and
 * transforms h, H, v, V to L commands
 * @param {string} str Raw string from 'd' Attribute
 * @returns {array} Array of normalised commands
 */ function $4e87eee274742ace$export$8ccf933b0513f8d0(str) {
    const markerRegEx = /[MmLlSsQqLlHhVvCcSsQqTtAaZz]/g;
    const digitRegEx = /-?[0-9]*\.?\d+/g;
    return [
        ...str.matchAll(markerRegEx)
    ].map((match)=>{
        return {
            marker: match[0],
            index: match.index
        };
    }).reduceRight((acc, cur)=>{
        const chunk = str.substring(cur.index, acc.length ? acc[acc.length - 1].index : str.length);
        return acc.concat([
            {
                marker: cur.marker,
                index: cur.index,
                chunk: chunk.length > 0 ? chunk.substr(1, chunk.length - 1) : chunk
            }
        ]);
    }, []).reverse().flatMap((cmd)=>{
        const values = cmd.chunk.match(digitRegEx);
        const vals = values ? values.map(parseFloat) : [];
        return (0, $k8Oib.newCommands)(cmd.marker, vals);
    }).map((0, $k8Oib.convertToAbsolute));
}
/**
 * Iterates through an array of normalised commands and insert arcs where applicable.
 * This function modifies the array in place.
 * @param {array} _cmds Array with commands to be modified
 * @param {number} r Expected radius of the arcs.
 * @param {number} round Number of decimal digits to round values
 * @returns {array} Sequence of commands containing arcs in place of corners
 */ function $4e87eee274742ace$export$877ed57b5d7c5e55(cmds, r, round) {
    let subpaths = [];
    let newCmds = [];
    if (round) cmds.forEach((el)=>(0, $k8Oib.roundValues)(el, round));
    cmds// split sub paths
    .forEach((e)=>{
        if (e.marker === "M") subpaths.push([]);
        subpaths[subpaths.length - 1].push(e);
    });
    subpaths.forEach((subPathCmds)=>{
        subPathCmds// We are only excluding lineTo commands that may be overlapping
        .map((0, $k8Oib.markOverlapped));
        (0, $k8Oib.reverseMarkOverlapped)(subPathCmds, subPathCmds.length - 1);
        // is this an open or closed path? don't add arcs to start/end.
        const closedPath = subPathCmds[subPathCmds.length - 1].marker == "Z";
        subPathCmds.filter((el)=>!el.overlap).map((el, i, arr)=>{
            const largeArcFlag = 0;
            const prev = (0, $k8Oib.getPreviousNoZ)(el, i, arr);
            const next = (0, $k8Oib.getNextNoZ)(el, i, arr);
            const anglePrv = (0, $k8Oib.getAngle)(el.values, prev.values);
            const angleNxt = (0, $k8Oib.getAngle)(el.values, next.values);
            const angle = angleNxt - anglePrv; // radians
            const degrees = angle * (180 / Math.PI);
            // prevent arc crossing the next command
            const shortest = (0, $k8Oib.shortestSide)(el, prev, next);
            const maxRadius = Math.abs((0, $k8Oib.getTangentNoHyp)(angle / 2, shortest / 2));
            const radius = Math.min(r, maxRadius);
            const o = (0, $k8Oib.getOffset)(angle, radius);
            const offset = o.offset;
            const sweepFlag = o.sweepFlag;
            const openFirstOrLast = (i == 0 || i == arr.length - 1) && !closedPath;
            switch(el.marker){
                case "M":
                case "L":
                    /* eslint-disable no-case-declarations */ const prevPoint = [
                        el.values.x + (0, $k8Oib.getOppositeLength)(anglePrv, offset),
                        el.values.y + (0, $k8Oib.getAdjacentLength)(anglePrv, offset)
                    ];
                    /* eslint-disable no-case-declarations */ const nextPoint = [
                        el.values.x + (0, $k8Oib.getOppositeLength)(angleNxt, offset),
                        el.values.y + (0, $k8Oib.getAdjacentLength)(angleNxt, offset)
                    ];
                    // there only need be a curve if and only if the next marker is a corner
                    if (!openFirstOrLast) newCmds.push({
                        marker: el.marker,
                        values: {
                            x: parseFloat(prevPoint[0].toFixed(3)),
                            y: parseFloat(prevPoint[1].toFixed(3))
                        }
                    });
                    else newCmds.push({
                        marker: el.marker,
                        values: el.values
                    });
                    if (!openFirstOrLast && (next.marker === "L" || next.marker === "M")) newCmds.push({
                        marker: "A",
                        radius: radius,
                        values: {
                            radiusX: parseFloat(radius.toFixed(3)),
                            radiusY: parseFloat(radius.toFixed(3)),
                            rotation: degrees,
                            largeArc: largeArcFlag,
                            sweep: sweepFlag,
                            x: parseFloat(nextPoint[0].toFixed(3)),
                            y: parseFloat(nextPoint[1].toFixed(3))
                        }
                    });
                    break;
                // case 'H': // horizontalTo x. Transformed to L in utils
                // case 'V': // verticalTo y. Transformed to L in utils
                case "C":
                case "S":
                case "Q":
                case "T":
                case "A":
                case "Z":
                    newCmds.push({
                        marker: el.marker,
                        values: el.values
                    });
                    break;
            }
        });
    });
    return {
        path: (0, $k8Oib.commandsToSvgPath)(newCmds),
        commands: newCmds
    };
}
/**
 * This is a shorthand for parsePath() and roundCommands().
 * You get the end result in one function call.
 * @param {string} str Raw string with commands from the path element
 * @param {number} r Expected radius of the arcs.
 * @param {number} round Number of decimal digits to round values
 * @returns {array} New commands sequence with rounded corners
 */ function $4e87eee274742ace$export$28cc47cdc2523da5(str, r, round) {
    return $4e87eee274742ace$export$877ed57b5d7c5e55([
        ...$4e87eee274742ace$export$8ccf933b0513f8d0(str)
    ], r, round);
}

});
parcelRegister("k8Oib", function(module, exports) {

$parcel$export(module.exports, "roundValues", () => $ea9b90fbaa241851$export$b3ae667a7b21d97);
$parcel$export(module.exports, "getPreviousNoZ", () => $ea9b90fbaa241851$export$21aef0a2c6669271);
$parcel$export(module.exports, "getNextNoZ", () => $ea9b90fbaa241851$export$8eec060ef616c6d3);
$parcel$export(module.exports, "convertToAbsolute", () => $ea9b90fbaa241851$export$7ac5e30ec17eb6b7);
$parcel$export(module.exports, "newCommands", () => $ea9b90fbaa241851$export$ee04f7695e5fecdd);
$parcel$export(module.exports, "markOverlapped", () => $ea9b90fbaa241851$export$eca7d03985dbd7c1);
$parcel$export(module.exports, "reverseMarkOverlapped", () => $ea9b90fbaa241851$export$4fb173f96dd8234);
$parcel$export(module.exports, "shortestSide", () => $ea9b90fbaa241851$export$6eac82bb9de8ebd9);
$parcel$export(module.exports, "getAngle", () => $ea9b90fbaa241851$export$b363da9ded343252);
$parcel$export(module.exports, "getOppositeLength", () => $ea9b90fbaa241851$export$4c75c967e2fd8ffc);
$parcel$export(module.exports, "getAdjacentLength", () => $ea9b90fbaa241851$export$83dc82c5c2e962b);
$parcel$export(module.exports, "getTangentNoHyp", () => $ea9b90fbaa241851$export$4137c1c2a326735b);
$parcel$export(module.exports, "getOffset", () => $ea9b90fbaa241851$export$622cea445a1c5b7d);
$parcel$export(module.exports, "commandsToSvgPath", () => $ea9b90fbaa241851$export$3fb51c83e3050e6a);
/**
 * Round the values of each command to the given number of decimals.
 * This function modifies the object in place.
 * @param {array} cmds Sequence of commands
 * @param {number} round Number of decimal place to be rounded
 * @returns {array} Sequence of commands with their values rounded
 */ function $ea9b90fbaa241851$export$b3ae667a7b21d97(el, round) {
    Object.keys(el.values).forEach((key)=>el.values[key] = el.values[key] && parseFloat(el.values[key].toFixed(round)));
    return el;
}
function $ea9b90fbaa241851$export$21aef0a2c6669271(e, i, a) {
    const counter = i - 1;
    const previous = a[$ea9b90fbaa241851$export$842a2cf37af977e1(counter, a.length)];
    if (previous.marker !== "Z") return previous;
    else return $ea9b90fbaa241851$export$21aef0a2c6669271(e, counter, a);
}
function $ea9b90fbaa241851$export$8eec060ef616c6d3(e, i, a) {
    const counter = i + 1;
    const next = a[$ea9b90fbaa241851$export$842a2cf37af977e1(counter, a.length)];
    if (next.marker === "Z") return $ea9b90fbaa241851$export$8eec060ef616c6d3(e, counter, a);
    else return next;
}
function $ea9b90fbaa241851$export$7ac5e30ec17eb6b7(el, index, arr) {
    // get previous item or create one empty if it doesnt exist
    let prev = arr[index - 1] || {
        values: {
            x: 0,
            y: 0
        }
    };
    // only need to test lowercase (relative) commands
    if (el.marker === el.marker.toLowerCase()) {
        // convert all to uppercase
        el.marker = el.marker.toUpperCase();
        switch(el.marker){
            case "M":
                el.values.x += prev.values.x;
                el.values.y += prev.values.y;
                break;
            case "L":
            case "A":
                el.values.x += prev.values.x;
                el.values.y += prev.values.y;
                break;
            case "H":
                el.marker = "L";
                el.values.x += prev.values.x;
                el.values.y = prev.values.y;
                break;
            case "V":
                el.marker = "L";
                el.values.x = prev.values.x;
                el.values.y += prev.values.y;
                break;
            case "C":
                el.values.x += prev.values.x;
                el.values.y += prev.values.y;
                el.values.x1 += prev.values.x;
                el.values.y1 += prev.values.y;
                el.values.x2 += prev.values.x;
                el.values.y2 += prev.values.y;
                break;
            case "S":
                el.values.x += prev.values.x;
                el.values.y += prev.values.y;
                el.values.x2 += prev.values.x;
                el.values.y2 += prev.values.y;
                break;
            case "Q":
                el.values.x += prev.values.x;
                el.values.y += prev.values.y;
                el.values.x1 += prev.values.x;
                el.values.y1 += prev.values.y;
                break;
            case "T":
                el.values.x += prev.values.x;
                el.values.y += prev.values.y;
                break;
            case "Z":
                break;
        }
    // H/V uppercase need to be converted too. Convert to L and add missing value
    } else if (el.marker === el.marker.toUpperCase()) switch(el.marker){
        case "H":
            el.marker = "L";
            el.values.y = prev.values.y;
            break;
        case "V":
            el.marker = "L";
            el.values.x = prev.values.x;
            break;
    }
    /*
    'Z' commands don't have any coordinate but we are cloning the
    start coordinates defined by this subpath initial 'M' so it's
    easier to do the stitching later.
  */ if (el.marker === "Z") {
        // find previous 'M' recursively
        function rec(arr, i) {
            if (arr[i].marker === "M") return arr[i];
            else return rec(arr, i - 1);
        }
        let mBefore = rec(arr, index);
        el.values.x = mBefore.values.x;
        el.values.y = mBefore.values.y;
    }
    return el;
}
function $ea9b90fbaa241851$export$ee04f7695e5fecdd(marker, values) {
    const cmds = [];
    switch(marker.toUpperCase()){
        case "M":
            for(let i = 0; i < values.length; i += 2){
                let m;
                if (marker === marker.toUpperCase()) m = i === 0 ? "M" : "L";
                else m = i === 0 ? "m" : "l";
                cmds.push({
                    marker: m,
                    values: {
                        x: values[i],
                        y: values[i + 1]
                    }
                });
            }
            break;
        case "L":
            for(let i = 0; i < values.length; i += 2)cmds.push({
                marker: marker,
                values: {
                    x: values[i],
                    y: values[i + 1]
                }
            });
            break;
        case "H":
            for(let i = 0; i < values.length; i++)cmds.push({
                marker: marker,
                values: {
                    x: values[i],
                    y: 0
                }
            });
            break;
        case "V":
            for(let i = 0; i < values.length; i++)cmds.push({
                marker: marker,
                values: {
                    x: 0,
                    y: values[i]
                }
            });
            break;
        case "C":
            for(let i = 0; i < values.length; i += 6)cmds.push({
                marker: marker,
                values: {
                    x1: values[i],
                    y1: values[i + 1],
                    x2: values[i + 2],
                    y2: values[i + 3],
                    x: values[i + 4],
                    y: values[i + 5]
                }
            });
            break;
        case "S":
            for(let i = 0; i < values.length; i += 4)cmds.push({
                marker: marker,
                values: {
                    x2: values[i],
                    y2: values[i + 1],
                    x: values[i + 2],
                    y: values[i + 3]
                }
            });
            break;
        case "Q":
            for(let i = 0; i < values.length; i += 4)cmds.push({
                marker: marker,
                values: {
                    x1: values[i],
                    y1: values[i + 1],
                    x: values[i + 2],
                    y: values[i + 3]
                }
            });
            break;
        case "T":
            for(let i = 0; i < values.length; i += 2)cmds.push({
                marker: marker,
                values: {
                    x: values[i],
                    y: values[i + 1]
                }
            });
            break;
        case "A":
            for(let i = 0; i < values.length; i += 7)cmds.push({
                marker: marker,
                values: {
                    radiusX: values[i],
                    radiusY: values[i + 1],
                    rotation: values[i + 2],
                    largeArc: values[i + 3],
                    sweep: values[i + 4],
                    x: values[i + 5],
                    y: values[i + 6]
                }
            });
            break;
        case "Z":
            cmds.push({
                marker: marker,
                values: {
                    // values will be overriden later by convertToAbsolute()
                    x: 0,
                    y: 0
                }
            });
            break;
    }
    return cmds;
}
function $ea9b90fbaa241851$export$842a2cf37af977e1(x, m) {
    return (x % m + m) % m;
}
function $ea9b90fbaa241851$export$eca7d03985dbd7c1(el, index, array) {
    // Skip the first moveTo command and any other that's not a lineTo.
    if (index !== 0 && el.marker === "L") {
        // It seems we have a lineTo here. Get the immediate previous command
        let previous = array[index - 1];
        // …and check if the x, y coordinates are equals.
        const overlap = [
            "x",
            "y"
        ].every((key)=>{
            // If x AND y overlap, this command should be skipped
            return Math.round(Math.abs(previous.values[key] - el.values[key])) === 0;
        });
        if (overlap) el.overlap = true;
    }
    return el;
}
function $ea9b90fbaa241851$export$4fb173f96dd8234(cmds, counter) {
    const overlap = [
        "x",
        "y"
    ].every((key)=>{
        // If x AND y overlap, this command should be skipped
        return Math.round(Math.abs(cmds[counter].values[key] - cmds[0].values[key])) === 0;
    });
    if (cmds[counter].marker === "L" && overlap) {
        cmds[counter].overlap = true;
        $ea9b90fbaa241851$export$4fb173f96dd8234(cmds, counter - 1);
    }
    if (cmds[counter].marker === "Z") $ea9b90fbaa241851$export$4fb173f96dd8234(cmds, counter - 1);
}
function $ea9b90fbaa241851$export$6eac82bb9de8ebd9(el, previous, next) {
    const nxtSide = $ea9b90fbaa241851$export$79376507b09a66f(el.values, next.values);
    const prvSide = $ea9b90fbaa241851$export$79376507b09a66f(previous.values, el.values);
    return Math.min(prvSide, nxtSide);
}
function $ea9b90fbaa241851$export$b363da9ded343252(p1, p2) {
    return Math.atan2(p2.x - p1.x, p2.y - p1.y);
}
function $ea9b90fbaa241851$export$79376507b09a66f(p1, p2) {
    const xDiff = p1.x - p2.x;
    const yDiff = p1.y - p2.y;
    return Math.sqrt(Math.pow(xDiff, 2) + Math.pow(yDiff, 2));
}
function $ea9b90fbaa241851$export$4c75c967e2fd8ffc(angle, hip) {
    return Math.sin(angle) * hip;
}
function $ea9b90fbaa241851$export$83dc82c5c2e962b(angle, hip) {
    return Math.cos(angle) * hip;
}
function $ea9b90fbaa241851$export$c7b34a197884bfbc(angle, opposite) {
    const a = opposite / Math.tan(angle);
    if (a === Infinity || a === -Infinity || isNaN(a)) return opposite;
    return a;
}
function $ea9b90fbaa241851$export$4137c1c2a326735b(angle, adjacent) {
    return adjacent * Math.tan(angle);
}
function $ea9b90fbaa241851$export$622cea445a1c5b7d(angle, r) {
    let offset;
    let sweepFlag = 0;
    let degrees = angle * (180 / Math.PI);
    // sharp angles
    if (degrees < 0 && degrees >= -180 || degrees > 180 && degrees < 360) offset = $ea9b90fbaa241851$export$c7b34a197884bfbc(angle / 2, -r);
    else {
        offset = $ea9b90fbaa241851$export$c7b34a197884bfbc(angle / 2, r);
        sweepFlag = 1;
        if (offset === Infinity) offset = r;
    }
    return {
        offset: offset,
        sweepFlag: sweepFlag
    };
}
function $ea9b90fbaa241851$export$1f9a23a6058afc02(points, t0) {
    const n = points.length - 1; // number of control points
    const b = []; // coefficients as in De Casteljau's algorithm
    const res1 = []; // first curve resulting control points
    const res2 = []; // second curve resulting control points
    const t1 = 1 - t0;
    // multiply point with scalar factor
    const pf = function(p, f) {
        const res = [];
        for(let i = 0; i < p.length; i++)res.push(f * p[i]);
        return res;
    };
    // add points as vectors
    const pp = function(p1, p2) {
        const res = [];
        for(let i = 0; i < Math.min(p1.length, p2.length); i++)res.push(p1[i] + p2[i]);
        return res;
    };
    // set original coefficients: b[i][0] = points[i]
    for(let i = 0; i <= n; i++){
        points[i] = typeof points[i] == "object" ? points[i] : [
            points[i]
        ];
        b.push([
            points[i]
        ]);
    }
    // get all coefficients
    for(let j = 1; j <= n; j++)for(let i = 0; i <= n - j; i++)b[i].push(pp(pf(b[i][j - 1], t1), pf(b[i + 1][j - 1], t0)));
    // set result: res1 & res2
    for(let j = 0; j <= n; j++){
        res1.push(b[0][j]);
        res2.push(b[j][n - j]);
    }
    return [
        res1,
        res2
    ];
}
function $ea9b90fbaa241851$export$3fb51c83e3050e6a(cmds) {
    // when writing the commands back, the relevant values should be written in this order
    const valuesOrder = [
        "radiusX",
        "radiusY",
        "rotation",
        "largeArc",
        "sweep",
        "x1",
        "y1",
        "x2",
        "y2",
        "x",
        "y"
    ];
    return cmds.map((cmd)=>{
        // defaults for empty string, so Z will output no values
        let d = "";
        // filter any command that's not Z
        if (cmd.marker !== "Z") {
            // get all values from current command
            const cmdKeys = Object.keys(cmd.values);
            // filter the valuesOrder array for only the values that appear in the current command.
            // We do this because valuesOrder guarantees that the relevant values will be in the right order
            d = valuesOrder.filter((v)=>cmdKeys.indexOf(v) !== -1)// replace the key with it's value
            .map((key)=>cmd.values[key])// and stringify everything together with a comma inbetween values
            .join();
        }
        return `${cmd.marker}${d}`;
    }).join("").trim();
}

});


parcelRegister("kWHDJ", function(module, exports) {
"use strict";
var $f3fb13688e9aa7c7$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(t, e, r, i) {
    void 0 === i && (i = r);
    var o = Object.getOwnPropertyDescriptor(e, r);
    o && !("get" in o ? !e.__esModule : o.writable || o.configurable) || (o = {
        enumerable: !0,
        get: function() {
            return e[r];
        }
    }), Object.defineProperty(t, i, o);
} : function(t, e, r, i) {
    void 0 === i && (i = r), t[i] = e[r];
}), $f3fb13688e9aa7c7$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(t, e) {
    Object.defineProperty(t, "default", {
        enumerable: !0,
        value: e
    });
} : function(t, e) {
    t.default = e;
}), $f3fb13688e9aa7c7$var$__importStar = module.exports && module.exports.__importStar || function(t) {
    if (t && t.__esModule) return t;
    var e = {};
    if (null != t) for(var r in t)"default" !== r && Object.prototype.hasOwnProperty.call(t, r) && $f3fb13688e9aa7c7$var$__createBinding(e, t, r);
    return $f3fb13688e9aa7c7$var$__setModuleDefault(e, t), e;
}, $f3fb13688e9aa7c7$var$__importDefault = module.exports && module.exports.__importDefault || function(t) {
    return t && t.__esModule ? t : {
        default: t
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.useColor = void 0;

const $f3fb13688e9aa7c7$var$react_1 = $f3fb13688e9aa7c7$var$__importDefault((parcelRequire("8NFma")));

const $f3fb13688e9aa7c7$var$gradient = $f3fb13688e9aa7c7$var$__importStar((parcelRequire("1Jif0")));

const $f3fb13688e9aa7c7$var$konva_1 = $f3fb13688e9aa7c7$var$__importDefault((parcelRequire("ciNAD"))), $f3fb13688e9aa7c7$var$useColor = (t, e = t.fill, r = "fill")=>$f3fb13688e9aa7c7$var$react_1.default.useMemo(()=>{
        if (!$f3fb13688e9aa7c7$var$gradient.isGradient(e)) return {
            [r]: e
        };
        const { stops: i, rotation: o } = $f3fb13688e9aa7c7$var$gradient.parseColor(e), a = {
            x: t.a.width / 2,
            y: t.a.height / 2
        }, n = Math.sqrt(Math.pow(a.x, 2) + Math.pow(a.y, 2)), l = $f3fb13688e9aa7c7$var$konva_1.default.Util.degToRad(o) - Math.PI / 2, s = [];
        return i.forEach(({ offset: t, color: e })=>{
            s.push(t, e);
        }), "fill" === r ? {
            fillLinearGradientStartPointX: a.x - n * Math.cos(l),
            fillLinearGradientStartPointY: a.y - n * Math.sin(l),
            fillLinearGradientColorStops: s,
            fillLinearGradientEndPointX: a.x + n * Math.cos(l),
            fillLinearGradientEndPointY: a.y + n * Math.sin(l),
            fill: i[1].color,
            fillPriority: "linear-gradient"
        } : {
            strokeLinearGradientStartPointX: a.x - n * Math.cos(l),
            strokeLinearGradientStartPointY: a.y - n * Math.sin(l),
            strokeLinearGradientColorStops: s,
            strokeLinearGradientEndPointX: a.x + n * Math.cos(l),
            strokeLinearGradientEndPointY: a.y + n * Math.sin(l)
        };
    }, [
        e,
        t.width,
        t.height
    ]);
module.exports.useColor = $f3fb13688e9aa7c7$var$useColor;

});
parcelRegister("1Jif0", function(module, exports) {
"use strict";
var $142824b227144dde$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.parseColor = module.exports.isGradient = void 0;

const $142824b227144dde$var$gradient_parser_1 = $142824b227144dde$var$__importDefault((parcelRequire("1Lube"))), $142824b227144dde$var$isGradient = (e)=>e.indexOf("linear-gradient") >= 0;
module.exports.isGradient = $142824b227144dde$var$isGradient;
const $142824b227144dde$var$stopToColor = (e)=>"hex" === e.type ? "#" + e.value : "literal" === e.type ? e.value : `${e.type}(${e.value.join(",")})`, $142824b227144dde$var$parseColor = (e)=>{
    if (!(0, module.exports.isGradient)(e)) return {
        rotation: 0,
        stops: [
            {
                offset: 0,
                color: e
            },
            {
                offset: 1,
                color: e
            }
        ]
    };
    const t = $142824b227144dde$var$gradient_parser_1.default.parse(e)[0];
    return {
        rotation: parseFloat(t.orientation.value),
        stops: t.colorStops.map((e, o)=>({
                color: $142824b227144dde$var$stopToColor(e),
                offset: e.length ? parseFloat(e.length.value) / 100 : o / (t.colorStops.length - 1)
            }))
    };
};
module.exports.parseColor = $142824b227144dde$var$parseColor;

});
parcelRegister("1Lube", function(module, exports) {

$parcel$export(module.exports, "parse", () => $1491975c97e0baa4$export$98e6a39c04603d36, (v) => $1491975c97e0baa4$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $1491975c97e0baa4$export$fac44ee5b035f737, (v) => $1491975c97e0baa4$export$fac44ee5b035f737 = v);
// Copyright (c) 2014 Rafael Caricio. All rights reserved.
// Use of this source code is governed by a BSD-style license that can be
// found in the LICENSE file.
var $1491975c97e0baa4$export$98e6a39c04603d36;
var $1491975c97e0baa4$export$fac44ee5b035f737;
var $1491975c97e0baa4$var$GradientParser = $1491975c97e0baa4$var$GradientParser || {};
$1491975c97e0baa4$var$GradientParser.stringify = function() {
    var visitor = {
        "visit_linear-gradient": function(node) {
            return visitor.visit_gradient(node);
        },
        "visit_repeating-linear-gradient": function(node) {
            return visitor.visit_gradient(node);
        },
        "visit_radial-gradient": function(node) {
            return visitor.visit_gradient(node);
        },
        "visit_repeating-radial-gradient": function(node) {
            return visitor.visit_gradient(node);
        },
        "visit_gradient": function(node) {
            var orientation = visitor.visit(node.orientation);
            if (orientation) orientation += ", ";
            return node.type + "(" + orientation + visitor.visit(node.colorStops) + ")";
        },
        "visit_shape": function(node) {
            var result = node.value, at = visitor.visit(node.at), style = visitor.visit(node.style);
            if (style) result += " " + style;
            if (at) result += " at " + at;
            return result;
        },
        "visit_default-radial": function(node) {
            var result = "", at = visitor.visit(node.at);
            if (at) result += at;
            return result;
        },
        "visit_extent-keyword": function(node) {
            var result = node.value, at = visitor.visit(node.at);
            if (at) result += " at " + at;
            return result;
        },
        "visit_position-keyword": function(node) {
            return node.value;
        },
        "visit_position": function(node) {
            return visitor.visit(node.value.x) + " " + visitor.visit(node.value.y);
        },
        "visit_%": function(node) {
            return node.value + "%";
        },
        "visit_em": function(node) {
            return node.value + "em";
        },
        "visit_px": function(node) {
            return node.value + "px";
        },
        "visit_literal": function(node) {
            return visitor.visit_color(node.value, node);
        },
        "visit_hex": function(node) {
            return visitor.visit_color("#" + node.value, node);
        },
        "visit_rgb": function(node) {
            return visitor.visit_color("rgb(" + node.value.join(", ") + ")", node);
        },
        "visit_rgba": function(node) {
            return visitor.visit_color("rgba(" + node.value.join(", ") + ")", node);
        },
        "visit_color": function(resultColor, node) {
            var result = resultColor, length = visitor.visit(node.length);
            if (length) result += " " + length;
            return result;
        },
        "visit_angular": function(node) {
            return node.value + "deg";
        },
        "visit_directional": function(node) {
            return "to " + node.value;
        },
        "visit_array": function(elements) {
            var result = "", size = elements.length;
            elements.forEach(function(element, i) {
                result += visitor.visit(element);
                if (i < size - 1) result += ", ";
            });
            return result;
        },
        "visit": function(element) {
            if (!element) return "";
            var result = "";
            if (element instanceof Array) return visitor.visit_array(element, result);
            else if (element.type) {
                var nodeVisitor = visitor["visit_" + element.type];
                if (nodeVisitor) return nodeVisitor(element);
                else throw Error("Missing visitor visit_" + element.type);
            } else throw Error("Invalid node.");
        }
    };
    return function(root) {
        return visitor.visit(root);
    };
}();
// Copyright (c) 2014 Rafael Caricio. All rights reserved.
// Use of this source code is governed by a BSD-style license that can be
// found in the LICENSE file.
var $1491975c97e0baa4$var$GradientParser = $1491975c97e0baa4$var$GradientParser || {};
$1491975c97e0baa4$var$GradientParser.parse = function() {
    var tokens = {
        linearGradient: /^(\-(webkit|o|ms|moz)\-)?(linear\-gradient)/i,
        repeatingLinearGradient: /^(\-(webkit|o|ms|moz)\-)?(repeating\-linear\-gradient)/i,
        radialGradient: /^(\-(webkit|o|ms|moz)\-)?(radial\-gradient)/i,
        repeatingRadialGradient: /^(\-(webkit|o|ms|moz)\-)?(repeating\-radial\-gradient)/i,
        sideOrCorner: /^to (left (top|bottom)|right (top|bottom)|left|right|top|bottom)/i,
        extentKeywords: /^(closest\-side|closest\-corner|farthest\-side|farthest\-corner|contain|cover)/,
        positionKeywords: /^(left|center|right|top|bottom)/i,
        pixelValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))px/,
        percentageValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))\%/,
        emValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))em/,
        angleValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))deg/,
        startCall: /^\(/,
        endCall: /^\)/,
        comma: /^,/,
        hexColor: /^\#([0-9a-fA-F]+)/,
        literalColor: /^([a-zA-Z]+)/,
        rgbColor: /^rgb/i,
        rgbaColor: /^rgba/i,
        number: /^(([0-9]*\.[0-9]+)|([0-9]+\.?))/
    };
    var input = "";
    function error(msg) {
        var err = new Error(input + ": " + msg);
        err.source = input;
        throw err;
    }
    function getAST() {
        var ast = matchListDefinitions();
        if (input.length > 0) error("Invalid input not EOF");
        return ast;
    }
    function matchListDefinitions() {
        return matchListing(matchDefinition);
    }
    function matchDefinition() {
        return matchGradient("linear-gradient", tokens.linearGradient, matchLinearOrientation) || matchGradient("repeating-linear-gradient", tokens.repeatingLinearGradient, matchLinearOrientation) || matchGradient("radial-gradient", tokens.radialGradient, matchListRadialOrientations) || matchGradient("repeating-radial-gradient", tokens.repeatingRadialGradient, matchListRadialOrientations);
    }
    function matchGradient(gradientType, pattern, orientationMatcher) {
        return matchCall(pattern, function(captures) {
            var orientation = orientationMatcher();
            if (orientation) {
                if (!scan(tokens.comma)) error("Missing comma before color stops");
            }
            return {
                type: gradientType,
                orientation: orientation,
                colorStops: matchListing(matchColorStop)
            };
        });
    }
    function matchCall(pattern, callback) {
        var captures = scan(pattern);
        if (captures) {
            if (!scan(tokens.startCall)) error("Missing (");
            var result = callback(captures);
            if (!scan(tokens.endCall)) error("Missing )");
            return result;
        }
    }
    function matchLinearOrientation() {
        return matchSideOrCorner() || matchAngle();
    }
    function matchSideOrCorner() {
        return match("directional", tokens.sideOrCorner, 1);
    }
    function matchAngle() {
        return match("angular", tokens.angleValue, 1);
    }
    function matchListRadialOrientations() {
        var radialOrientations, radialOrientation = matchRadialOrientation(), lookaheadCache;
        if (radialOrientation) {
            radialOrientations = [];
            radialOrientations.push(radialOrientation);
            lookaheadCache = input;
            if (scan(tokens.comma)) {
                radialOrientation = matchRadialOrientation();
                if (radialOrientation) radialOrientations.push(radialOrientation);
                else input = lookaheadCache;
            }
        }
        return radialOrientations;
    }
    function matchRadialOrientation() {
        var radialType = matchCircle() || matchEllipse();
        if (radialType) radialType.at = matchAtPosition();
        else {
            var extent = matchExtentKeyword();
            if (extent) {
                radialType = extent;
                var positionAt = matchAtPosition();
                if (positionAt) radialType.at = positionAt;
            } else {
                var defaultPosition = matchPositioning();
                if (defaultPosition) radialType = {
                    type: "default-radial",
                    at: defaultPosition
                };
            }
        }
        return radialType;
    }
    function matchCircle() {
        var circle = match("shape", /^(circle)/i, 0);
        if (circle) circle.style = matchLength() || matchExtentKeyword();
        return circle;
    }
    function matchEllipse() {
        var ellipse = match("shape", /^(ellipse)/i, 0);
        if (ellipse) ellipse.style = matchDistance() || matchExtentKeyword();
        return ellipse;
    }
    function matchExtentKeyword() {
        return match("extent-keyword", tokens.extentKeywords, 1);
    }
    function matchAtPosition() {
        if (match("position", /^at/, 0)) {
            var positioning = matchPositioning();
            if (!positioning) error("Missing positioning value");
            return positioning;
        }
    }
    function matchPositioning() {
        var location = matchCoordinates();
        if (location.x || location.y) return {
            type: "position",
            value: location
        };
    }
    function matchCoordinates() {
        return {
            x: matchDistance(),
            y: matchDistance()
        };
    }
    function matchListing(matcher) {
        var captures = matcher(), result = [];
        if (captures) {
            result.push(captures);
            while(scan(tokens.comma)){
                captures = matcher();
                if (captures) result.push(captures);
                else error("One extra comma");
            }
        }
        return result;
    }
    function matchColorStop() {
        var color = matchColor();
        if (!color) error("Expected color definition");
        color.length = matchDistance();
        return color;
    }
    function matchColor() {
        return matchHexColor() || matchRGBAColor() || matchRGBColor() || matchLiteralColor();
    }
    function matchLiteralColor() {
        return match("literal", tokens.literalColor, 0);
    }
    function matchHexColor() {
        return match("hex", tokens.hexColor, 1);
    }
    function matchRGBColor() {
        return matchCall(tokens.rgbColor, function() {
            return {
                type: "rgb",
                value: matchListing(matchNumber)
            };
        });
    }
    function matchRGBAColor() {
        return matchCall(tokens.rgbaColor, function() {
            return {
                type: "rgba",
                value: matchListing(matchNumber)
            };
        });
    }
    function matchNumber() {
        return scan(tokens.number)[1];
    }
    function matchDistance() {
        return match("%", tokens.percentageValue, 1) || matchPositionKeyword() || matchLength();
    }
    function matchPositionKeyword() {
        return match("position-keyword", tokens.positionKeywords, 1);
    }
    function matchLength() {
        return match("px", tokens.pixelValue, 1) || match("em", tokens.emValue, 1);
    }
    function match(type, pattern, captureIndex) {
        var captures = scan(pattern);
        if (captures) return {
            type: type,
            value: captures[captureIndex]
        };
    }
    function scan(regexp) {
        var captures, blankCaptures;
        blankCaptures = /^[\n\r\t\s]+/.exec(input);
        if (blankCaptures) consume(blankCaptures[0].length);
        captures = regexp.exec(input);
        if (captures) consume(captures[0].length);
        return captures;
    }
    function consume(size) {
        input = input.substr(size);
    }
    return function(code) {
        input = code.toString();
        return getAST();
    };
}();
$1491975c97e0baa4$export$98e6a39c04603d36 = $1491975c97e0baa4$var$GradientParser.parse;
$1491975c97e0baa4$export$fac44ee5b035f737 = $1491975c97e0baa4$var$GradientParser.stringify;

});



parcelRegister("l4lre", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.triggerLoadError = module.exports.onLoadError = module.exports.whenLoaded = module.exports.decrementLoader = module.exports.incrementLoader = module.exports.getFontLoadTimeout = module.exports.setFontLoadTimeout = module.exports.getAssetLoadTimeout = module.exports.setAssetLoadTimeout = void 0;

var $9uXpD = parcelRequire("9uXpD");
let $f56a99dbe85515b4$var$loadCount = 0, $f56a99dbe85515b4$var$listeners = [], $f56a99dbe85515b4$var$assetLoadTimeout = 3e4;
const $f56a99dbe85515b4$var$setAssetLoadTimeout = (e)=>{
    $f56a99dbe85515b4$var$assetLoadTimeout = e;
};
module.exports.setAssetLoadTimeout = $f56a99dbe85515b4$var$setAssetLoadTimeout;
const $f56a99dbe85515b4$var$getAssetLoadTimeout = ()=>$f56a99dbe85515b4$var$assetLoadTimeout;
module.exports.getAssetLoadTimeout = $f56a99dbe85515b4$var$getAssetLoadTimeout;
let $f56a99dbe85515b4$var$fontLoadTimeout = 6e3;
const $f56a99dbe85515b4$var$setFontLoadTimeout = (e)=>{
    $f56a99dbe85515b4$var$fontLoadTimeout = e;
};
module.exports.setFontLoadTimeout = $f56a99dbe85515b4$var$setFontLoadTimeout;
const $f56a99dbe85515b4$var$getFontLoadTimeout = ()=>$f56a99dbe85515b4$var$fontLoadTimeout;
function $f56a99dbe85515b4$var$incrementLoader(e) {
    $f56a99dbe85515b4$var$loadCount += 1;
    let o = !1;
    const t = setTimeout(()=>{
        o || ($f56a99dbe85515b4$var$triggerLoadError(`Timeout loading asset ${e}`), console.error("Timeout triggered for loader. Some assets may not have loaded.", e), o = !0, $f56a99dbe85515b4$var$decrementLoader());
    }, $f56a99dbe85515b4$var$assetLoadTimeout);
    return ()=>{
        o || (clearTimeout(t), $f56a99dbe85515b4$var$decrementLoader());
    };
}
function $f56a99dbe85515b4$var$decrementLoader() {
    $f56a99dbe85515b4$var$loadCount -= 1, 0 === $f56a99dbe85515b4$var$loadCount && ($f56a99dbe85515b4$var$listeners.forEach((e)=>e()), $f56a99dbe85515b4$var$listeners = []);
}
function $f56a99dbe85515b4$var$whenLoadedCallback(e) {
    0 === $f56a99dbe85515b4$var$loadCount ? e() : $f56a99dbe85515b4$var$listeners.push(e);
}
function $f56a99dbe85515b4$var$whenLoaded() {
    return new Promise((e)=>$f56a99dbe85515b4$var$whenLoadedCallback(()=>{
            (0, $9uXpD.isAnimationUsed)() ? setTimeout(e, 300) : e(!0);
        }));
}
module.exports.getFontLoadTimeout = $f56a99dbe85515b4$var$getFontLoadTimeout, module.exports.incrementLoader = $f56a99dbe85515b4$var$incrementLoader, module.exports.decrementLoader = $f56a99dbe85515b4$var$decrementLoader, module.exports.whenLoaded = $f56a99dbe85515b4$var$whenLoaded;
let $f56a99dbe85515b4$var$errorListeners = [];
function $f56a99dbe85515b4$var$onLoadError(e) {
    $f56a99dbe85515b4$var$errorListeners.push(e);
}
function $f56a99dbe85515b4$var$triggerLoadError(e) {
    $f56a99dbe85515b4$var$errorListeners.forEach((o)=>o(e));
}
module.exports.onLoadError = $f56a99dbe85515b4$var$onLoadError, module.exports.triggerLoadError = $f56a99dbe85515b4$var$triggerLoadError;

});
parcelRegister("9uXpD", function(module, exports) {
"use strict";
var $6ea5007b8b724e2c$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.useFadeIn = module.exports.isAnimationUsed = module.exports.toggleFadeInAnimation = void 0;

const $6ea5007b8b724e2c$var$react_1 = $6ea5007b8b724e2c$var$__importDefault((parcelRequire("8NFma")));

const $6ea5007b8b724e2c$var$konva_1 = $6ea5007b8b724e2c$var$__importDefault((parcelRequire("ciNAD")));
let $6ea5007b8b724e2c$var$fadeInEnabled = !1;
const $6ea5007b8b724e2c$var$toggleFadeInAnimation = (e = !$6ea5007b8b724e2c$var$fadeInEnabled)=>{
    $6ea5007b8b724e2c$var$fadeInEnabled = e;
};
module.exports.toggleFadeInAnimation = $6ea5007b8b724e2c$var$toggleFadeInAnimation;
const $6ea5007b8b724e2c$var$isAnimationUsed = ()=>$6ea5007b8b724e2c$var$fadeInEnabled;
function $6ea5007b8b724e2c$var$useFadeIn(e, t) {
    const n = $6ea5007b8b724e2c$var$react_1.default.useRef();
    $6ea5007b8b724e2c$var$react_1.default.useLayoutEffect(()=>{
        n.current && n.current.destroy();
    }, [
        t
    ]), $6ea5007b8b724e2c$var$react_1.default.useLayoutEffect(()=>{
        if (!$6ea5007b8b724e2c$var$fadeInEnabled) return;
        const t = e.current.opacity();
        return t ? (e.current.opacity(0), n.current = new $6ea5007b8b724e2c$var$konva_1.default.Tween({
            node: e.current,
            opacity: t,
            onFinish: ()=>{
                var e;
                null === (e = n.current) || void 0 === e || e.destroy();
            }
        }), n.current.play(), ()=>{
            var e;
            null === (e = n.current) || void 0 === e || e.destroy();
        }) : void 0;
    }, []);
}
module.exports.isAnimationUsed = $6ea5007b8b724e2c$var$isAnimationUsed, module.exports.useFadeIn = $6ea5007b8b724e2c$var$useFadeIn;

});


parcelRegister("iPHWg", function(module, exports) {
"use strict";
var $db5f12ba7f508e94$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(t, o, e, n) {
    void 0 === n && (n = e);
    var s = Object.getOwnPropertyDescriptor(o, e);
    s && !("get" in s ? !o.__esModule : s.writable || s.configurable) || (s = {
        enumerable: !0,
        get: function() {
            return o[e];
        }
    }), Object.defineProperty(t, n, s);
} : function(t, o, e, n) {
    void 0 === n && (n = e), t[n] = o[e];
}), $db5f12ba7f508e94$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(t, o) {
    Object.defineProperty(t, "default", {
        enumerable: !0,
        value: o
    });
} : function(t, o) {
    t.default = o;
}), $db5f12ba7f508e94$var$__importStar = module.exports && module.exports.__importStar || function(t) {
    if (t && t.__esModule) return t;
    var o = {};
    if (null != t) for(var e in t)"default" !== e && Object.prototype.hasOwnProperty.call(t, e) && $db5f12ba7f508e94$var$__createBinding(o, t, e);
    return $db5f12ba7f508e94$var$__setModuleDefault(o, t), o;
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.injectCustomFont = module.exports.injectGoogleFont = module.exports.getGoogleFontsVariants = module.exports.setGoogleFontsVariants = module.exports.loadFont = module.exports.isFontLoaded = module.exports.replaceGlobalFonts = module.exports.removeGlobalFont = module.exports.addGlobalFont = module.exports.globalFonts = module.exports.getFontsList = module.exports.setGoogleFonts = module.exports.isGoogleFontChanged = void 0;

const $db5f12ba7f508e94$var$mobx = $db5f12ba7f508e94$var$__importStar((parcelRequire("2SBKn")));

var $l4lre = parcelRequire("l4lre");
let $db5f12ba7f508e94$var$GOOGLE_FONTS = $db5f12ba7f508e94$var$mobx.observable([
    "Roboto",
    "Amatic SC",
    "Press Start 2P",
    "Marck Script",
    "Rubik Mono One"
]), $db5f12ba7f508e94$var$googleFontsChanged = $db5f12ba7f508e94$var$mobx.observable({
    value: !1
});
function $db5f12ba7f508e94$var$isGoogleFontChanged() {
    return $db5f12ba7f508e94$var$googleFontsChanged.value;
}
function $db5f12ba7f508e94$var$setGoogleFonts(t) {
    "default" !== t ? ($db5f12ba7f508e94$var$googleFontsChanged.value = !0, $db5f12ba7f508e94$var$GOOGLE_FONTS.splice(0, $db5f12ba7f508e94$var$GOOGLE_FONTS.length), $db5f12ba7f508e94$var$GOOGLE_FONTS.push(...t)) : $db5f12ba7f508e94$var$googleFontsChanged.value = !1;
}
function $db5f12ba7f508e94$var$getFontsList() {
    return $db5f12ba7f508e94$var$GOOGLE_FONTS;
}
function $db5f12ba7f508e94$var$addGlobalFont(t) {
    module.exports.globalFonts.push(t);
}
function $db5f12ba7f508e94$var$removeGlobalFont(t) {
    const o = module.exports.globalFonts.findIndex((o)=>o.fontFamily === t);
    -1 !== o && module.exports.globalFonts.splice(o, 1);
}
function $db5f12ba7f508e94$var$replaceGlobalFonts(t) {
    module.exports.globalFonts.replace(t);
}
module.exports.isGoogleFontChanged = $db5f12ba7f508e94$var$isGoogleFontChanged, module.exports.setGoogleFonts = $db5f12ba7f508e94$var$setGoogleFonts, module.exports.getFontsList = $db5f12ba7f508e94$var$getFontsList, module.exports.globalFonts = $db5f12ba7f508e94$var$mobx.observable([]), module.exports.addGlobalFont = $db5f12ba7f508e94$var$addGlobalFont, module.exports.removeGlobalFont = $db5f12ba7f508e94$var$removeGlobalFont, module.exports.replaceGlobalFonts = $db5f12ba7f508e94$var$replaceGlobalFonts;
var $db5f12ba7f508e94$var$TEXT_TEXT = "Some test text;?#D-\u041F\u0420\u0418\u0412\u0415\u0422!1230o9u8i7y6t5r4e3w2q1", $db5f12ba7f508e94$var$canvas = document.createElement("canvas");
function $db5f12ba7f508e94$var$measureArial() {
    return $db5f12ba7f508e94$var$measureFont("Arial");
}
function $db5f12ba7f508e94$var$measureTimes() {
    return $db5f12ba7f508e94$var$measureFont("Times", "Times");
}
function $db5f12ba7f508e94$var$measureFont(t, o = "Arial") {
    var e = $db5f12ba7f508e94$var$canvas.getContext("2d");
    return e.font = `normal 40px '${t}', ${o}`, e.measureText($db5f12ba7f508e94$var$TEXT_TEXT).width;
}
const $db5f12ba7f508e94$var$MAX_ATTEMPTS = 100, $db5f12ba7f508e94$var$loadedFonts = {
    Arial: !0
}, $db5f12ba7f508e94$var$isFontLoaded = (t)=>!!$db5f12ba7f508e94$var$loadedFonts[t];
async function $db5f12ba7f508e94$var$loadFont(t) {
    var o;
    if ($db5f12ba7f508e94$var$loadedFonts[t]) return;
    const e = !!(null === (o = document.fonts) || void 0 === o ? void 0 : o.load), n = $db5f12ba7f508e94$var$measureArial();
    if (e) try {
        await document.fonts.load(`16px '${t}'`);
        const o = $db5f12ba7f508e94$var$measureFont(t);
        if (n !== o) return void ($db5f12ba7f508e94$var$loadedFonts[t] = !0);
    } catch (t) {}
    const s = $db5f12ba7f508e94$var$measureTimes(), r = $db5f12ba7f508e94$var$measureFont(t), a = Math.min(6e3, (0, $l4lre.getFontLoadTimeout)()) / 60;
    for(let o = 0; o < a; o++){
        const o = $db5f12ba7f508e94$var$measureFont(t, "Arial"), e = $db5f12ba7f508e94$var$measureFont(t, "Times");
        if (o !== r || o !== n || e !== s) return void ($db5f12ba7f508e94$var$loadedFonts[t] = !0);
        await new Promise((t)=>setTimeout(t, 60));
    }
    console.warn(`Timeout for loading font "${t}". Looks like polotno can't load it. Is it a correct font family?`), (0, $l4lre.triggerLoadError)(`Timeout for loading font "${t}"`);
}
module.exports.isFontLoaded = $db5f12ba7f508e94$var$isFontLoaded, module.exports.loadFont = $db5f12ba7f508e94$var$loadFont;
const $db5f12ba7f508e94$var$registeredGoogleFonts = {};
let $db5f12ba7f508e94$var$googleFontsVariants = "400,400italic,700,700italic";
function $db5f12ba7f508e94$var$setGoogleFontsVariants(t) {
    $db5f12ba7f508e94$var$googleFontsVariants = t;
}
function $db5f12ba7f508e94$var$getGoogleFontsVariants() {
    return $db5f12ba7f508e94$var$googleFontsVariants;
}
function $db5f12ba7f508e94$var$injectGoogleFont(t) {
    if ($db5f12ba7f508e94$var$registeredGoogleFonts[t]) return;
    const o = `https://fonts.googleapis.com/css?family=${t.replace(/ /g, "+")}:${$db5f12ba7f508e94$var$googleFontsVariants}`, e = document.createElement("link");
    e.type = "text/css", e.href = o, e.rel = "stylesheet", document.getElementsByTagName("head")[0].appendChild(e), $db5f12ba7f508e94$var$registeredGoogleFonts[t] = !0;
}
module.exports.setGoogleFontsVariants = $db5f12ba7f508e94$var$setGoogleFontsVariants, module.exports.getGoogleFontsVariants = $db5f12ba7f508e94$var$getGoogleFontsVariants, module.exports.injectGoogleFont = $db5f12ba7f508e94$var$injectGoogleFont;
const $db5f12ba7f508e94$var$registeredCustomFonts = {};
function $db5f12ba7f508e94$var$injectCustomFont(t) {
    const o = t.fontFamily;
    if ($db5f12ba7f508e94$var$registeredCustomFonts[o]) return;
    if (!t.url && !t.styles) return;
    const e = document.createElement("style");
    e.type = "text/css";
    const n = t.styles || (t.url ? [
        {
            src: `url("${t.url}")`
        }
    ] : []);
    let s = "";
    n.forEach((t)=>{
        s += `\n      @font-face {\n        font-family: '${o}';\n        src: ${t.src};\n        font-style: ${t.fontStyle || "normal"};\n        font-weight: ${t.fontWeight || "normal"};\n      }\n    `;
    }), e.innerHTML = s, document.getElementsByTagName("head")[0].appendChild(e), $db5f12ba7f508e94$var$registeredCustomFonts[t.fontFamily] = !0;
}
module.exports.injectCustomFont = $db5f12ba7f508e94$var$injectCustomFont;

});

parcelRegister("gS5ZA", function(module, exports) {
"use strict";
var $c4865670b410a652$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(e, t, o, n) {
    void 0 === n && (n = o);
    var r = Object.getOwnPropertyDescriptor(t, o);
    r && !("get" in r ? !t.__esModule : r.writable || r.configurable) || (r = {
        enumerable: !0,
        get: function() {
            return t[o];
        }
    }), Object.defineProperty(e, n, r);
} : function(e, t, o, n) {
    void 0 === n && (n = o), e[n] = t[o];
}), $c4865670b410a652$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(e, t) {
    Object.defineProperty(e, "default", {
        enumerable: !0,
        value: t
    });
} : function(e, t) {
    e.default = t;
}), $c4865670b410a652$var$__importStar = module.exports && module.exports.__importStar || function(e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for(var o in e)"default" !== o && Object.prototype.hasOwnProperty.call(e, o) && $c4865670b410a652$var$__createBinding(t, e, o);
    return $c4865670b410a652$var$__setModuleDefault(t, e), t;
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.setAnimationsEnabled = module.exports.setTextOverflow = module.exports.setForceTextFit = module.exports.useDownScaling = module.exports.setDownScalingEnabled = module.exports.useHtmlTextRender = module.exports.useRemoveBackground = module.exports.setTextVerticalResizeEnabled = module.exports.flags = void 0;

const $c4865670b410a652$var$mobx = $c4865670b410a652$var$__importStar((parcelRequire("2SBKn")));
module.exports.flags = $c4865670b410a652$var$mobx.observable({
    imageDownScalingEnabled: !0,
    removeBackgroundEnabled: !0,
    htmlRenderEnabled: !1,
    forceTextFitEnabled: !1,
    textVerticalResizeEnabled: !1,
    textOverflow: "resize",
    animationsEnabled: !1
}), module.exports.setTextVerticalResizeEnabled = $c4865670b410a652$var$mobx.action((e)=>{
    module.exports.flags.textVerticalResizeEnabled = e;
}), module.exports.useRemoveBackground = $c4865670b410a652$var$mobx.action((e)=>{
    module.exports.flags.removeBackgroundEnabled = e;
}), module.exports.useHtmlTextRender = $c4865670b410a652$var$mobx.action((e)=>{
    module.exports.flags.htmlRenderEnabled = e;
}), module.exports.setDownScalingEnabled = $c4865670b410a652$var$mobx.action((e)=>{
    module.exports.flags.imageDownScalingEnabled = e;
}), module.exports.useDownScaling = $c4865670b410a652$var$mobx.action((e)=>{
    console.warn("useDownScaling is deprecated. Use setDownScalingEnabled instead."), (0, module.exports.setDownScalingEnabled)(e);
}), module.exports.setForceTextFit = $c4865670b410a652$var$mobx.action((e)=>{
    console.warn("setForceTextFit is deprecated. Use setTextOverflow instead."), module.exports.flags.textOverflow = "change-font-size";
}), module.exports.setTextOverflow = $c4865670b410a652$var$mobx.action((e)=>{
    module.exports.flags.textOverflow = e;
}), module.exports.setAnimationsEnabled = $c4865670b410a652$var$mobx.action((e)=>{
    module.exports.flags.animationsEnabled = e;
});

});

parcelRegister("8vcNW", function(module, exports) {
"use strict";
function $630b26ad1c24f6e8$var$removeTags(e = "") {
    return (e = e.replace(/<\/p>/gi, "\n")).replace(/(<([^>]+)>)/gi, "");
}
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.removeTags = void 0, module.exports.removeTags = $630b26ad1c24f6e8$var$removeTags;

});

parcelRegister("aWsdH", function(module, exports) {
"use strict";
var $7f75360904759634$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.applyFilter = void 0;

const $7f75360904759634$var$konva_1 = $7f75360904759634$var$__importDefault((parcelRequire("ciNAD")));
function $7f75360904759634$var$applyFilter(e, t) {
    var l;
    const r = {
        filters: []
    };
    t.brightnessEnabled && (r.filters.push($7f75360904759634$var$konva_1.default.Filters.Brighten), r.brightness = t.brightness), t.blurEnabled && (r.filters.push($7f75360904759634$var$konva_1.default.Filters.Blur), r.blurRadius = t.blurRadius), t.sepiaEnabled && r.filters.push($7f75360904759634$var$konva_1.default.Filters.Sepia), t.grayscaleEnabled && r.filters.push($7f75360904759634$var$konva_1.default.Filters.Grayscale), e.setAttrs(r), r.filters.length ? e.cache({
        pixelRatio: t.store._elementsPixelRatio
    }) : e.clearCache(), null === (l = e.getLayer()) || void 0 === l || l.batchDraw();
}
module.exports.applyFilter = $7f75360904759634$var$applyFilter;

});

parcelRegister("4WWR6", function(module, exports) {
"use strict";
var $39aa3bb369222a9d$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.Highlighter = module.exports.setHighlighterStyle = void 0;

const $39aa3bb369222a9d$var$react_1 = $39aa3bb369222a9d$var$__importDefault((parcelRequire("8NFma")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");
parcelRequire("k3LwQ");
var $fBZlQ = parcelRequire("fBZlQ");
const $39aa3bb369222a9d$var$STYLE = {
    stroke: "rgb(0, 161, 255)",
    strokeWidth: 2
}, $39aa3bb369222a9d$var$setHighlighterStyle = (e)=>{
    Object.assign($39aa3bb369222a9d$var$STYLE, e);
};
module.exports.setHighlighterStyle = $39aa3bb369222a9d$var$setHighlighterStyle, module.exports.Highlighter = (0, $O1ETn.observer)(({ element: e })=>$39aa3bb369222a9d$var$react_1.default.createElement($fBZlQ.Rect, Object.assign({
        name: "highlighter",
        x: e.a.x,
        y: e.a.y,
        rotation: e.a.rotation,
        width: e.a.width,
        height: e.a.height,
        listening: !1,
        strokeScaleEnabled: !1
    }, $39aa3bb369222a9d$var$STYLE)));

});

parcelRegister("3pcZ0", function(module, exports) {
"use strict";
var $27adc7074b55fbfc$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.useMobile = module.exports.mobileStyle = module.exports.isMobile = module.exports.MOBILE_BREAKPOINT = void 0;

const $27adc7074b55fbfc$var$react_1 = $27adc7074b55fbfc$var$__importDefault((parcelRequire("8NFma")));
module.exports.MOBILE_BREAKPOINT = 500;
const $27adc7074b55fbfc$var$isMobile = ()=>window.innerWidth <= module.exports.MOBILE_BREAKPOINT;
module.exports.isMobile = $27adc7074b55fbfc$var$isMobile;
const $27adc7074b55fbfc$var$mobileStyle = (e)=>`\n  @media (max-width: ${module.exports.MOBILE_BREAKPOINT}px) {\n    ${e}\n  }\n\n  .polotno-mobile & {\n    ${e}\n  }\n`;
module.exports.mobileStyle = $27adc7074b55fbfc$var$mobileStyle;
const $27adc7074b55fbfc$var$useMobile = ()=>{
    const [e, t] = $27adc7074b55fbfc$var$react_1.default.useState((0, module.exports.isMobile)());
    return $27adc7074b55fbfc$var$react_1.default.useEffect(()=>{
        const e = ()=>{
            t((0, module.exports.isMobile)());
        };
        return window.addEventListener("resize", e), ()=>{
            window.removeEventListener("resize", e);
        };
    }, []), e;
};
module.exports.useMobile = $27adc7074b55fbfc$var$useMobile;

});

parcelRegister("58B0H", function(module, exports) {

$parcel$export(module.exports, "setLivelinessChecking", () => setLivelinessChecking);
$parcel$export(module.exports, "onSnapshot", () => onSnapshot);
$parcel$export(module.exports, "applySnapshot", () => applySnapshot);
$parcel$export(module.exports, "getSnapshot", () => getSnapshot);
$parcel$export(module.exports, "hasParentOfType", () => hasParentOfType);
$parcel$export(module.exports, "getParentOfType", () => getParentOfType);
$parcel$export(module.exports, "resolvePath", () => resolvePath);
$parcel$export(module.exports, "isAlive", () => isAlive);
$parcel$export(module.exports, "detach", () => detach);
$parcel$export(module.exports, "destroy", () => destroy);
$parcel$export(module.exports, "cast", () => cast);
$parcel$export(module.exports, "types", () => types);

var $2SBKn = parcelRequire("2SBKn");

var $ibaza = parcelRequire("ibaza");
var livelinessChecking = "warn";
/**
 * Defines what MST should do when running into reads / writes to objects that have died.
 * By default it will print a warning.
 * Use the `"error"` option to easy debugging to see where the error was thrown and when the offending read / write took place
 *
 * @param mode `"warn"`, `"error"` or `"ignore"`
 */ function setLivelinessChecking(mode) {
    livelinessChecking = mode;
}
/**
 * Returns the current liveliness checking mode.
 *
 * @returns `"warn"`, `"error"` or `"ignore"`
 */ function getLivelinessChecking() {
    return livelinessChecking;
}
/**
 * @deprecated use setLivelinessChecking instead
 * @hidden
 *
 * Defines what MST should do when running into reads / writes to objects that have died.
 * By default it will print a warning.
 * Use the `"error"` option to easy debugging to see where the error was thrown and when the offending read / write took place
 *
 * @param mode `"warn"`, `"error"` or `"ignore"`
 */ function setLivelynessChecking(mode) {
    setLivelinessChecking(mode);
}
/**
 * @hidden
 */ var Hook;
(function(Hook) {
    Hook["afterCreate"] = "afterCreate";
    Hook["afterAttach"] = "afterAttach";
    Hook["afterCreationFinalization"] = "afterCreationFinalization";
    Hook["beforeDetach"] = "beforeDetach";
    Hook["beforeDestroy"] = "beforeDestroy";
})(Hook || (Hook = {}));
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
/** @deprecated */ function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
/**
 * Returns the _actual_ type of the given tree node. (Or throws)
 *
 * @param object
 * @returns
 */ function getType(object) {
    assertIsStateTreeNode(object, 1);
    return getStateTreeNode(object).type;
}
/**
 * Returns the _declared_ type of the given sub property of an object, array or map.
 * In the case of arrays and maps the property name is optional and will be ignored.
 *
 * Example:
 * ```ts
 * const Box = types.model({ x: 0, y: 0 })
 * const box = Box.create()
 *
 * console.log(getChildType(box, "x").name) // 'number'
 * ```
 *
 * @param object
 * @param propertyName
 * @returns
 */ function getChildType(object, propertyName) {
    assertIsStateTreeNode(object, 1);
    return getStateTreeNode(object).getChildType(propertyName);
}
/**
 * Registers a function that will be invoked for each mutation that is applied to the provided model instance, or to any of its children.
 * See [patches](https://github.com/mobxjs/mobx-state-tree#patches) for more details. onPatch events are emitted immediately and will not await the end of a transaction.
 * Patches can be used to deeply observe a model tree.
 *
 * @param target the model instance from which to receive patches
 * @param callback the callback that is invoked for each patch. The reversePatch is a patch that would actually undo the emitted patch
 * @returns function to remove the listener
 */ function onPatch(target, callback) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    assertIsFunction(callback, 2);
    return getStateTreeNode(target).onPatch(callback);
}
/**
 * Registers a function that is invoked whenever a new snapshot for the given model instance is available.
 * The listener will only be fire at the end of the current MobX (trans)action.
 * See [snapshots](https://github.com/mobxjs/mobx-state-tree#snapshots) for more details.
 *
 * @param target
 * @param callback
 * @returns
 */ function onSnapshot(target, callback) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    assertIsFunction(callback, 2);
    return getStateTreeNode(target).onSnapshot(callback);
}
/**
 * Applies a JSON-patch to the given model instance or bails out if the patch couldn't be applied
 * See [patches](https://github.com/mobxjs/mobx-state-tree#patches) for more details.
 *
 * Can apply a single past, or an array of patches.
 *
 * @param target
 * @param patch
 * @returns
 */ function applyPatch(target, patch) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    assertArg(patch, function(p) {
        return typeof p === "object";
    }, "object or array", 2);
    getStateTreeNode(target).applyPatches(asArray(patch));
}
/**
 * Small abstraction around `onPatch` and `applyPatch`, attaches a patch listener to a tree and records all the patches.
 * Returns a recorder object with the following signature:
 *
 * Example:
 * ```ts
 * export interface IPatchRecorder {
 *      // the recorded patches
 *      patches: IJsonPatch[]
 *      // the inverse of the recorded patches
 *      inversePatches: IJsonPatch[]
 *      // true if currently recording
 *      recording: boolean
 *      // stop recording patches
 *      stop(): void
 *      // resume recording patches
 *      resume(): void
 *      // apply all the recorded patches on the given target (the original subject if omitted)
 *      replay(target?: IAnyStateTreeNode): void
 *      // reverse apply the recorded patches on the given target  (the original subject if omitted)
 *      // stops the recorder if not already stopped
 *      undo(): void
 * }
 * ```
 *
 * The optional filter function allows to skip recording certain patches.
 *
 * @param subject
 * @param filter
 * @returns
 */ function recordPatches(subject, filter) {
    // check all arguments
    assertIsStateTreeNode(subject, 1);
    var data = {
        patches: [],
        inversePatches: []
    };
    // we will generate the immutable copy of patches on demand for public consumption
    var publicData = {};
    var disposer;
    var recorder = {
        get recording () {
            return !!disposer;
        },
        get patches () {
            if (!publicData.patches) publicData.patches = data.patches.slice();
            return publicData.patches;
        },
        get reversedInversePatches () {
            if (!publicData.reversedInversePatches) publicData.reversedInversePatches = data.inversePatches.slice().reverse();
            return publicData.reversedInversePatches;
        },
        get inversePatches () {
            if (!publicData.inversePatches) publicData.inversePatches = data.inversePatches.slice();
            return publicData.inversePatches;
        },
        stop: function() {
            if (disposer) {
                disposer();
                disposer = undefined;
            }
        },
        resume: function() {
            if (disposer) return;
            disposer = onPatch(subject, function(patch, inversePatch) {
                // skip patches that are asked to be filtered if there's a filter in place
                if (filter && !filter(patch, inversePatch, getRunningActionContext())) return;
                data.patches.push(patch);
                data.inversePatches.push(inversePatch);
                // mark immutable public patches as dirty
                publicData.patches = undefined;
                publicData.inversePatches = undefined;
                publicData.reversedInversePatches = undefined;
            });
        },
        replay: function(target) {
            applyPatch(target || subject, data.patches);
        },
        undo: function(target) {
            applyPatch(target || subject, data.inversePatches.slice().reverse());
        }
    };
    recorder.resume();
    return recorder;
}
/**
 * The inverse of `unprotect`.
 *
 * @param target
 */ function protect(target) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    var node = getStateTreeNode(target);
    if (!node.isRoot) throw fail("`protect` can only be invoked on root nodes");
    node.isProtectionEnabled = true;
}
/**
 * By default it is not allowed to directly modify a model. Models can only be modified through actions.
 * However, in some cases you don't care about the advantages (like replayability, traceability, etc) this yields.
 * For example because you are building a PoC or don't have any middleware attached to your tree.
 *
 * In that case you can disable this protection by calling `unprotect` on the root of your tree.
 *
 * Example:
 * ```ts
 * const Todo = types.model({
 *     done: false
 * }).actions(self => ({
 *     toggle() {
 *         self.done = !self.done
 *     }
 * }))
 *
 * const todo = Todo.create()
 * todo.done = true // throws!
 * todo.toggle() // OK
 * unprotect(todo)
 * todo.done = false // OK
 * ```
 */ function unprotect(target) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    var node = getStateTreeNode(target);
    if (!node.isRoot) throw fail("`unprotect` can only be invoked on root nodes");
    node.isProtectionEnabled = false;
}
/**
 * Returns true if the object is in protected mode, @see protect
 */ function isProtected(target) {
    return getStateTreeNode(target).isProtected;
}
/**
 * Applies a snapshot to a given model instances. Patch and snapshot listeners will be invoked as usual.
 *
 * @param target
 * @param snapshot
 * @returns
 */ function applySnapshot(target, snapshot) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    return getStateTreeNode(target).applySnapshot(snapshot);
}
/**
 * Calculates a snapshot from the given model instance. The snapshot will always reflect the latest state but use
 * structural sharing where possible. Doesn't require MobX transactions to be completed.
 *
 * @param target
 * @param applyPostProcess If true (the default) then postProcessSnapshot gets applied.
 * @returns
 */ function getSnapshot(target, applyPostProcess) {
    if (applyPostProcess === void 0) applyPostProcess = true;
    // check all arguments
    assertIsStateTreeNode(target, 1);
    var node = getStateTreeNode(target);
    if (applyPostProcess) return node.snapshot;
    return freeze(node.type.getSnapshot(node, false));
}
/**
 * Given a model instance, returns `true` if the object has a parent, that is, is part of another object, map or array.
 *
 * @param target
 * @param depth How far should we look upward? 1 by default.
 * @returns
 */ function hasParent(target, depth) {
    if (depth === void 0) depth = 1;
    // check all arguments
    assertIsStateTreeNode(target, 1);
    assertIsNumber(depth, 2, 0);
    var parent = getStateTreeNode(target).parent;
    while(parent){
        if (--depth === 0) return true;
        parent = parent.parent;
    }
    return false;
}
/**
 * Returns the immediate parent of this object, or throws.
 *
 * Note that the immediate parent can be either an object, map or array, and
 * doesn't necessarily refer to the parent model.
 *
 * Please note that in child nodes access to the root is only possible
 * once the `afterAttach` hook has fired.
 *
 * @param target
 * @param depth How far should we look upward? 1 by default.
 * @returns
 */ function getParent(target, depth) {
    if (depth === void 0) depth = 1;
    // check all arguments
    assertIsStateTreeNode(target, 1);
    assertIsNumber(depth, 2, 0);
    var d = depth;
    var parent = getStateTreeNode(target).parent;
    while(parent){
        if (--d === 0) return parent.storedValue;
        parent = parent.parent;
    }
    throw fail("Failed to find the parent of " + getStateTreeNode(target) + " at depth " + depth);
}
/**
 * Given a model instance, returns `true` if the object has a parent of given type, that is, is part of another object, map or array
 *
 * @param target
 * @param type
 * @returns
 */ function hasParentOfType(target, type) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    assertIsType(type, 2);
    var parent = getStateTreeNode(target).parent;
    while(parent){
        if (type.is(parent.storedValue)) return true;
        parent = parent.parent;
    }
    return false;
}
/**
 * Returns the target's parent of a given type, or throws.
 *
 * @param target
 * @param type
 * @returns
 */ function getParentOfType(target, type) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    assertIsType(type, 2);
    var parent = getStateTreeNode(target).parent;
    while(parent){
        if (type.is(parent.storedValue)) return parent.storedValue;
        parent = parent.parent;
    }
    throw fail("Failed to find the parent of " + getStateTreeNode(target) + " of a given type");
}
/**
 * Given an object in a model tree, returns the root object of that tree.
 *
 * Please note that in child nodes access to the root is only possible
 * once the `afterAttach` hook has fired.
 *
 * @param target
 * @returns
 */ function getRoot(target) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    return getStateTreeNode(target).root.storedValue;
}
/**
 * Returns the path of the given object in the model tree
 *
 * @param target
 * @returns
 */ function getPath(target) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    return getStateTreeNode(target).path;
}
/**
 * Returns the path of the given object as unescaped string array.
 *
 * @param target
 * @returns
 */ function getPathParts(target) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    return splitJsonPath(getStateTreeNode(target).path);
}
/**
 * Returns true if the given object is the root of a model tree.
 *
 * @param target
 * @returns
 */ function isRoot(target) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    return getStateTreeNode(target).isRoot;
}
/**
 * Resolves a path relatively to a given object.
 * Returns undefined if no value can be found.
 *
 * @param target
 * @param path escaped json path
 * @returns
 */ function resolvePath(target, path) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    assertIsString(path, 2);
    var node = resolveNodeByPath(getStateTreeNode(target), path);
    return node ? node.value : undefined;
}
/**
 * Resolves a model instance given a root target, the type and the identifier you are searching for.
 * Returns undefined if no value can be found.
 *
 * @param type
 * @param target
 * @param identifier
 * @returns
 */ function resolveIdentifier(type, target, identifier) {
    // check all arguments
    assertIsType(type, 1);
    assertIsStateTreeNode(target, 2);
    assertIsValidIdentifier(identifier, 3);
    var node = getStateTreeNode(target).root.identifierCache.resolve(type, normalizeIdentifier(identifier));
    return node === null || node === void 0 ? void 0 : node.value;
}
/**
 * Returns the identifier of the target node.
 * This is the *string normalized* identifier, which might not match the type of the identifier attribute
 *
 * @param target
 * @returns
 */ function getIdentifier(target) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    return getStateTreeNode(target).identifier;
}
/**
 * Tests if a reference is valid (pointing to an existing node and optionally if alive) and returns such reference if the check passes,
 * else it returns undefined.
 *
 * @param getter Function to access the reference.
 * @param checkIfAlive true to also make sure the referenced node is alive (default), false to skip this check.
 * @returns
 */ function tryReference(getter, checkIfAlive) {
    if (checkIfAlive === void 0) checkIfAlive = true;
    try {
        var node = getter();
        if (node === undefined || node === null) return undefined;
        else if (isStateTreeNode(node)) {
            if (!checkIfAlive) return node;
            else return isAlive(node) ? node : undefined;
        } else throw fail("The reference to be checked is not one of node, null or undefined");
    } catch (e) {
        if (e instanceof InvalidReferenceError) return undefined;
        throw e;
    }
}
/**
 * Tests if a reference is valid (pointing to an existing node and optionally if alive) and returns if the check passes or not.
 *
 * @param getter Function to access the reference.
 * @param checkIfAlive true to also make sure the referenced node is alive (default), false to skip this check.
 * @returns
 */ function isValidReference(getter, checkIfAlive) {
    if (checkIfAlive === void 0) checkIfAlive = true;
    try {
        var node = getter();
        if (node === undefined || node === null) return false;
        else if (isStateTreeNode(node)) return checkIfAlive ? isAlive(node) : true;
        else throw fail("The reference to be checked is not one of node, null or undefined");
    } catch (e) {
        if (e instanceof InvalidReferenceError) return false;
        throw e;
    }
}
/**
 * Try to resolve a given path relative to a given node.
 *
 * @param target
 * @param path
 * @returns
 */ function tryResolve(target, path) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    assertIsString(path, 2);
    var node = resolveNodeByPath(getStateTreeNode(target), path, false);
    if (node === undefined) return undefined;
    try {
        return node.value;
    } catch (e) {
        // For what ever reason not resolvable (e.g. totally not existing path, or value that cannot be fetched)
        // see test / issue: 'try resolve doesn't work #686'
        return undefined;
    }
}
/**
 * Given two state tree nodes that are part of the same tree,
 * returns the shortest jsonpath needed to navigate from the one to the other
 *
 * @param base
 * @param target
 * @returns
 */ function getRelativePath(base, target) {
    // check all arguments
    assertIsStateTreeNode(base, 1);
    assertIsStateTreeNode(target, 2);
    return getRelativePathBetweenNodes(getStateTreeNode(base), getStateTreeNode(target));
}
/**
 * Returns a deep copy of the given state tree node as new tree.
 * Shorthand for `snapshot(x) = getType(x).create(getSnapshot(x))`
 *
 * _Tip: clone will create a literal copy, including the same identifiers. To modify identifiers etc. during cloning, don't use clone but take a snapshot of the tree, modify it, and create new instance_
 *
 * @param source
 * @param keepEnvironment indicates whether the clone should inherit the same environment (`true`, the default), or not have an environment (`false`). If an object is passed in as second argument, that will act as the environment for the cloned tree.
 * @returns
 */ function clone(source, keepEnvironment) {
    if (keepEnvironment === void 0) keepEnvironment = true;
    // check all arguments
    assertIsStateTreeNode(source, 1);
    var node = getStateTreeNode(source);
    return node.type.create(node.snapshot, keepEnvironment === true ? node.root.environment : keepEnvironment === false ? undefined : keepEnvironment); // it's an object or something else
}
/**
 * Removes a model element from the state tree, and let it live on as a new state tree
 */ function detach(target) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    getStateTreeNode(target).detach();
    return target;
}
/**
 * Removes a model element from the state tree, and mark it as end-of-life; the element should not be used anymore
 */ function destroy(target) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    var node = getStateTreeNode(target);
    if (node.isRoot) node.die();
    else node.parent.removeChild(node.subpath);
}
/**
 * Returns true if the given state tree node is not killed yet.
 * This means that the node is still a part of a tree, and that `destroy`
 * has not been called. If a node is not alive anymore, the only thing one can do with it
 * is requesting it's last path and snapshot
 *
 * @param target
 * @returns
 */ function isAlive(target) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    return getStateTreeNode(target).observableIsAlive;
}
/**
 * Use this utility to register a function that should be called whenever the
 * targeted state tree node is destroyed. This is a useful alternative to managing
 * cleanup methods yourself using the `beforeDestroy` hook.
 *
 * This methods returns the same disposer that was passed as argument.
 *
 * Example:
 * ```ts
 * const Todo = types.model({
 *   title: types.string
 * }).actions(self => ({
 *   afterCreate() {
 *     const autoSaveDisposer = reaction(
 *       () => getSnapshot(self),
 *       snapshot => sendSnapshotToServerSomehow(snapshot)
 *     )
 *     // stop sending updates to server if this
 *     // instance is destroyed
 *     addDisposer(self, autoSaveDisposer)
 *   }
 * }))
 * ```
 *
 * @param target
 * @param disposer
 * @returns The same disposer that was passed as argument
 */ function addDisposer(target, disposer) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    assertIsFunction(disposer, 2);
    var node = getStateTreeNode(target);
    node.addDisposer(disposer);
    return disposer;
}
/**
 * Returns the environment of the current state tree. For more info on environments,
 * see [Dependency injection](https://github.com/mobxjs/mobx-state-tree#dependency-injection)
 *
 * Please note that in child nodes access to the root is only possible
 * once the `afterAttach` hook has fired
 *
 * Returns an empty environment if the tree wasn't initialized with an environment
 *
 * @param target
 * @returns
 */ function getEnv(target) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    var node = getStateTreeNode(target);
    var env = node.root.environment;
    if (!env) return EMPTY_OBJECT;
    return env;
}
/**
 * Performs a depth first walk through a tree.
 */ function walk(target, processor) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    assertIsFunction(processor, 2);
    var node = getStateTreeNode(target);
    // tslint:disable-next-line:no_unused-variable
    node.getChildren().forEach(function(child) {
        if (isStateTreeNode(child.storedValue)) walk(child.storedValue, processor);
    });
    processor(node.storedValue);
}
/**
 * Returns a reflection of the model type properties and name for either a model type or model node.
 *
 * @param typeOrNode
 * @returns
 */ function getPropertyMembers(typeOrNode) {
    var type;
    if (isStateTreeNode(typeOrNode)) type = getType(typeOrNode);
    else type = typeOrNode;
    assertArg(type, function(t) {
        return isModelType(t);
    }, "model type or model instance", 1);
    return {
        name: type.name,
        properties: __assign({}, type.properties)
    };
}
/**
 * Returns a reflection of the model node, including name, properties, views, volatile state,
 * and actions. `flowActions` is also provided as a separate array of names for any action that
 * came from a flow generator as well.
 *
 * In the case where a model has two actions: `doSomething` and `doSomethingWithFlow`, where
 * `doSomethingWithFlow` is a flow generator, the `actions` array will contain both actions,
 * i.e. ["doSomething", "doSomethingWithFlow"], and the `flowActions` array will contain only
 * the flow action, i.e. ["doSomethingWithFlow"].
 *
 * @param target
 * @returns
 */ function getMembers(target) {
    var type = getStateTreeNode(target).type;
    var reflected = __assign(__assign({}, getPropertyMembers(type)), {
        actions: [],
        volatile: [],
        views: [],
        flowActions: []
    });
    var props = Object.getOwnPropertyNames(target);
    props.forEach(function(key) {
        if (key in reflected.properties) return;
        var descriptor = Object.getOwnPropertyDescriptor(target, key);
        if (descriptor.get) {
            if ((0, $2SBKn.isComputedProp)(target, key)) reflected.views.push(key);
            else reflected.volatile.push(key);
            return;
        }
        if (descriptor.value._isMSTAction === true) reflected.actions.push(key);
        if (descriptor.value._isFlowAction === true) reflected.flowActions.push(key);
        else if ((0, $2SBKn.isObservableProp)(target, key)) reflected.volatile.push(key);
        else reflected.views.push(key);
    });
    return reflected;
}
/**
 * Casts a node snapshot or instance type to an instance type so it can be assigned to a type instance.
 * Note that this is just a cast for the type system, this is, it won't actually convert a snapshot to an instance,
 * but just fool typescript into thinking so.
 * Either way, casting when outside an assignation operation won't compile.
 *
 * Example:
 * ```ts
 * const ModelA = types.model({
 *   n: types.number
 * }).actions(self => ({
 *   setN(aNumber: number) {
 *     self.n = aNumber
 *   }
 * }))
 *
 * const ModelB = types.model({
 *   innerModel: ModelA
 * }).actions(self => ({
 *   someAction() {
 *     // this will allow the compiler to assign a snapshot to the property
 *     self.innerModel = cast({ a: 5 })
 *   }
 * }))
 * ```
 *
 * @param snapshotOrInstance Snapshot or instance
 * @returns The same object cast as an instance
 */ function cast(snapshotOrInstance) {
    return snapshotOrInstance;
}
/**
 * Casts a node instance type to a snapshot type so it can be assigned to a type snapshot (e.g. to be used inside a create call).
 * Note that this is just a cast for the type system, this is, it won't actually convert an instance to a snapshot,
 * but just fool typescript into thinking so.
 *
 * Example:
 * ```ts
 * const ModelA = types.model({
 *   n: types.number
 * }).actions(self => ({
 *   setN(aNumber: number) {
 *     self.n = aNumber
 *   }
 * }))
 *
 * const ModelB = types.model({
 *   innerModel: ModelA
 * })
 *
 * const a = ModelA.create({ n: 5 });
 * // this will allow the compiler to use a model as if it were a snapshot
 * const b = ModelB.create({ innerModel: castToSnapshot(a)})
 * ```
 *
 * @param snapshotOrInstance Snapshot or instance
 * @returns The same object cast as an input (creation) snapshot
 */ function castToSnapshot(snapshotOrInstance) {
    return snapshotOrInstance;
}
/**
 * Casts a node instance type to a reference snapshot type so it can be assigned to a reference snapshot (e.g. to be used inside a create call).
 * Note that this is just a cast for the type system, this is, it won't actually convert an instance to a reference snapshot,
 * but just fool typescript into thinking so.
 *
 * Example:
 * ```ts
 * const ModelA = types.model({
 *   id: types.identifier,
 *   n: types.number
 * }).actions(self => ({
 *   setN(aNumber: number) {
 *     self.n = aNumber
 *   }
 * }))
 *
 * const ModelB = types.model({
 *   refA: types.reference(ModelA)
 * })
 *
 * const a = ModelA.create({ id: 'someId', n: 5 });
 * // this will allow the compiler to use a model as if it were a reference snapshot
 * const b = ModelB.create({ refA: castToReferenceSnapshot(a)})
 * ```
 *
 * @param instance Instance
 * @returns The same object cast as a reference snapshot (string or number)
 */ function castToReferenceSnapshot(instance) {
    return instance;
}
/**
 * Returns the unique node id (not to be confused with the instance identifier) for a
 * given instance.
 * This id is a number that is unique for each instance.
 *
 * @export
 * @param target
 * @returns
 */ function getNodeId(target) {
    assertIsStateTreeNode(target, 1);
    return getStateTreeNode(target).nodeId;
}
/**
 * @internal
 * @hidden
 */ var BaseNode = /** @class */ function() {
    function BaseNode(type, parent, subpath, environment) {
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: type
        });
        Object.defineProperty(this, "environment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: environment
        });
        Object.defineProperty(this, "_escapedSubpath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_subpath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_subpathUponDeath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_pathUponDeath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "storedValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        }); // usually the same type as the value, but not always (such as with references)
        Object.defineProperty(this, "aliveAtom", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_state", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: NodeLifeCycle.INITIALIZING
        });
        Object.defineProperty(this, "_hookSubscribers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_parent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "pathAtom", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.environment = environment;
        this.baseSetParent(parent, subpath);
    }
    Object.defineProperty(BaseNode.prototype, "subpath", {
        get: function() {
            return this._subpath;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "subpathUponDeath", {
        get: function() {
            return this._subpathUponDeath;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "pathUponDeath", {
        get: function() {
            return this._pathUponDeath;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "value", {
        get: function() {
            return this.type.getValue(this);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "state", {
        get: function() {
            return this._state;
        },
        set: function(val) {
            var wasAlive = this.isAlive;
            this._state = val;
            var isAlive = this.isAlive;
            if (this.aliveAtom && wasAlive !== isAlive) this.aliveAtom.reportChanged();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "fireInternalHook", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(name) {
            if (this._hookSubscribers) this._hookSubscribers.emit(name, this, name);
        }
    });
    Object.defineProperty(BaseNode.prototype, "registerHook", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(hook, hookHandler) {
            if (!this._hookSubscribers) this._hookSubscribers = new EventHandlers();
            return this._hookSubscribers.register(hook, hookHandler);
        }
    });
    Object.defineProperty(BaseNode.prototype, "parent", {
        get: function() {
            return this._parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "getReconciliationType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return this.type;
        }
    });
    Object.defineProperty(BaseNode.prototype, "baseSetParent", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(parent, subpath) {
            this._parent = parent;
            this._subpath = subpath;
            this._escapedSubpath = undefined; // regenerate when needed
            if (this.pathAtom) this.pathAtom.reportChanged();
        }
    });
    Object.defineProperty(BaseNode.prototype, "path", {
        /*
         * Returns (escaped) path representation as string
         */ get: function() {
            return this.getEscapedPath(true);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "getEscapedPath", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(reportObserved) {
            if (reportObserved) {
                if (!this.pathAtom) this.pathAtom = (0, $2SBKn.createAtom)("path");
                this.pathAtom.reportObserved();
            }
            if (!this.parent) return "";
            // regenerate escaped subpath if needed
            if (this._escapedSubpath === undefined) this._escapedSubpath = !this._subpath ? "" : escapeJsonPath(this._subpath);
            return this.parent.getEscapedPath(reportObserved) + "/" + this._escapedSubpath;
        }
    });
    Object.defineProperty(BaseNode.prototype, "isRoot", {
        get: function() {
            return this.parent === null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "isAlive", {
        get: function() {
            return this.state !== NodeLifeCycle.DEAD;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "isDetaching", {
        get: function() {
            return this.state === NodeLifeCycle.DETACHING;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "observableIsAlive", {
        get: function() {
            if (!this.aliveAtom) this.aliveAtom = (0, $2SBKn.createAtom)("alive");
            this.aliveAtom.reportObserved();
            return this.isAlive;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "baseFinalizeCreation", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(whenFinalized) {
            if (devMode()) {
                if (!this.isAlive) // istanbul ignore next
                throw fail("assertion failed: cannot finalize the creation of a node that is already dead");
            }
            // goal: afterCreate hooks runs depth-first. After attach runs parent first, so on afterAttach the parent has completed already
            if (this.state === NodeLifeCycle.CREATED) {
                if (this.parent) {
                    if (this.parent.state !== NodeLifeCycle.FINALIZED) // parent not ready yet, postpone
                    return;
                    this.fireHook(Hook.afterAttach);
                }
                this.state = NodeLifeCycle.FINALIZED;
                if (whenFinalized) whenFinalized();
            }
        }
    });
    Object.defineProperty(BaseNode.prototype, "baseFinalizeDeath", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (this._hookSubscribers) this._hookSubscribers.clearAll();
            this._subpathUponDeath = this._subpath;
            this._pathUponDeath = this.getEscapedPath(false);
            this.baseSetParent(null, "");
            this.state = NodeLifeCycle.DEAD;
        }
    });
    Object.defineProperty(BaseNode.prototype, "baseAboutToDie", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            this.fireHook(Hook.beforeDestroy);
        }
    });
    return BaseNode;
}();
/**
 * @internal
 * @hidden
 */ var ScalarNode = /** @class */ function(_super) {
    __extends(ScalarNode, _super);
    function ScalarNode(simpleType, parent, subpath, environment, initialSnapshot) {
        var _this = _super.call(this, simpleType, parent, subpath, environment) || this;
        try {
            _this.storedValue = simpleType.createNewInstance(initialSnapshot);
        } catch (e) {
            // short-cut to die the instance, to avoid the snapshot computed starting to throw...
            _this.state = NodeLifeCycle.DEAD;
            throw e;
        }
        _this.state = NodeLifeCycle.CREATED;
        // for scalar nodes there's no point in firing this event since it would fire on the constructor, before
        // anybody can actually register for/listen to it
        // this.fireHook(Hook.AfterCreate)
        _this.finalizeCreation();
        return _this;
    }
    Object.defineProperty(ScalarNode.prototype, "root", {
        get: function() {
            // future optimization: store root ref in the node and maintain it
            if (!this.parent) throw fail("This scalar node is not part of a tree");
            return this.parent.root;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScalarNode.prototype, "setParent", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(newParent, subpath) {
            var parentChanged = this.parent !== newParent;
            var subpathChanged = this.subpath !== subpath;
            if (!parentChanged && !subpathChanged) return;
            if (devMode()) {
                if (!subpath) // istanbul ignore next
                throw fail("assertion failed: subpath expected");
                if (!newParent) // istanbul ignore next
                throw fail("assertion failed: parent expected");
                if (parentChanged) // istanbul ignore next
                throw fail("assertion failed: scalar nodes cannot change their parent");
            }
            this.environment = undefined; // use parent's
            this.baseSetParent(this.parent, subpath);
        }
    });
    Object.defineProperty(ScalarNode.prototype, "snapshot", {
        get: function() {
            return freeze(this.getSnapshot());
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScalarNode.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return this.type.getSnapshot(this);
        }
    });
    Object.defineProperty(ScalarNode.prototype, "toString", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            var path = (this.isAlive ? this.path : this.pathUponDeath) || "<root>";
            return this.type.name + "@" + path + (this.isAlive ? "" : " [dead]");
        }
    });
    Object.defineProperty(ScalarNode.prototype, "die", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (!this.isAlive || this.state === NodeLifeCycle.DETACHING) return;
            this.aboutToDie();
            this.finalizeDeath();
        }
    });
    Object.defineProperty(ScalarNode.prototype, "finalizeCreation", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            this.baseFinalizeCreation();
        }
    });
    Object.defineProperty(ScalarNode.prototype, "aboutToDie", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            this.baseAboutToDie();
        }
    });
    Object.defineProperty(ScalarNode.prototype, "finalizeDeath", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            this.baseFinalizeDeath();
        }
    });
    Object.defineProperty(ScalarNode.prototype, "fireHook", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(name) {
            this.fireInternalHook(name);
        }
    });
    return ScalarNode;
}(BaseNode);
ScalarNode.prototype.die = (0, $2SBKn.action)(ScalarNode.prototype.die);
var nextNodeId = 1;
var snapshotReactionOptions = {
    onError: function(e) {
        throw e;
    }
};
/**
 * @internal
 * @hidden
 */ var ObjectNode = /** @class */ function(_super) {
    __extends(ObjectNode, _super);
    function ObjectNode(complexType, parent, subpath, environment, initialValue) {
        var _this = _super.call(this, complexType, parent, subpath, environment) || this;
        Object.defineProperty(_this, "nodeId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ++nextNodeId
        });
        Object.defineProperty(_this, "identifierAttribute", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "identifier", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        }); // Identifier is always normalized to string, even if the identifier property isn't
        Object.defineProperty(_this, "unnormalizedIdentifier", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "identifierCache", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "isProtectionEnabled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(_this, "middlewares", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "hasSnapshotPostProcessor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(_this, "_applyPatches", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "_applySnapshot", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "_autoUnbox", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        }); // unboxing is disabled when reading child nodes
        Object.defineProperty(_this, "_isRunningAction", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        }); // only relevant for root
        Object.defineProperty(_this, "_hasSnapshotReaction", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(_this, "_observableInstanceState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0 /* UNINITIALIZED */ 
        });
        Object.defineProperty(_this, "_childNodes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "_initialSnapshot", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "_cachedInitialSnapshot", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "_cachedInitialSnapshotCreated", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(_this, "_snapshotComputed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "_snapshotUponDeath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // #region internal event handling
        Object.defineProperty(_this, "_internalEvents", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        _this._snapshotComputed = (0, $2SBKn.computed)(function() {
            return freeze(_this.getSnapshot());
        });
        _this.unbox = _this.unbox.bind(_this);
        _this._initialSnapshot = freeze(initialValue);
        _this.identifierAttribute = complexType.identifierAttribute;
        if (!parent) _this.identifierCache = new IdentifierCache();
        _this._childNodes = complexType.initializeChildNodes(_this, _this._initialSnapshot);
        // identifier can not be changed during lifecycle of a node
        // so we safely can read it from initial snapshot
        _this.identifier = null;
        _this.unnormalizedIdentifier = null;
        if (_this.identifierAttribute && _this._initialSnapshot) {
            var id = _this._initialSnapshot[_this.identifierAttribute];
            if (id === undefined) {
                // try with the actual node if not (for optional identifiers)
                var childNode = _this._childNodes[_this.identifierAttribute];
                if (childNode) id = childNode.value;
            }
            if (typeof id !== "string" && typeof id !== "number") throw fail("Instance identifier '" + _this.identifierAttribute + "' for type '" + _this.type.name + "' must be a string or a number");
            // normalize internal identifier to string
            _this.identifier = normalizeIdentifier(id);
            _this.unnormalizedIdentifier = id;
        }
        if (!parent) _this.identifierCache.addNodeToCache(_this);
        else parent.root.identifierCache.addNodeToCache(_this);
        return _this;
    }
    Object.defineProperty(ObjectNode.prototype, "applyPatches", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(patches) {
            this.createObservableInstanceIfNeeded();
            this._applyPatches(patches);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "applySnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(snapshot) {
            this.createObservableInstanceIfNeeded();
            this._applySnapshot(snapshot);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "createObservableInstanceIfNeeded", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(fireHooks) {
            if (fireHooks === void 0) fireHooks = true;
            if (this._observableInstanceState === 0 /* UNINITIALIZED */ ) this.createObservableInstance(fireHooks);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "createObservableInstance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(fireHooks) {
            var e_1, _a, e_2, _b;
            if (fireHooks === void 0) fireHooks = true;
            if (devMode()) {
                if (this.state !== NodeLifeCycle.INITIALIZING) // istanbul ignore next
                throw fail("assertion failed: the creation of the observable instance must be done on the initializing phase");
            }
            this._observableInstanceState = 1 /* CREATING */ ;
            // make sure the parent chain is created as well
            // array with parent chain from parent to child
            var parentChain = [];
            var parent = this.parent;
            // for performance reasons we never go back further than the most direct
            // uninitialized parent
            // this is done to avoid traversing the whole tree to the root when using
            // the same reference again
            while(parent && parent._observableInstanceState === 0 /* UNINITIALIZED */ ){
                parentChain.unshift(parent);
                parent = parent.parent;
            }
            try {
                // initialize the uninitialized parent chain from parent to child
                for(var parentChain_1 = __values(parentChain), parentChain_1_1 = parentChain_1.next(); !parentChain_1_1.done; parentChain_1_1 = parentChain_1.next()){
                    var p = parentChain_1_1.value;
                    // delay firing hooks until after all parents have been created
                    p.createObservableInstanceIfNeeded(false);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (parentChain_1_1 && !parentChain_1_1.done && (_a = parentChain_1.return)) _a.call(parentChain_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            var type = this.type;
            try {
                this.storedValue = type.createNewInstance(this._childNodes);
                this.preboot();
                this._isRunningAction = true;
                type.finalizeNewInstance(this, this.storedValue);
            } catch (e) {
                // short-cut to die the instance, to avoid the snapshot computed starting to throw...
                this.state = NodeLifeCycle.DEAD;
                throw e;
            } finally{
                this._isRunningAction = false;
            }
            this._observableInstanceState = 2 /* CREATED */ ;
            this._snapshotComputed.trackAndCompute();
            if (this.isRoot) this._addSnapshotReaction();
            this._childNodes = EMPTY_OBJECT;
            this.state = NodeLifeCycle.CREATED;
            if (fireHooks) {
                this.fireHook(Hook.afterCreate);
                // Note that the parent might not be finalized at this point
                // so afterAttach won't be called until later in that case
                this.finalizeCreation();
                try {
                    // fire the hooks of the parents that we created
                    for(var _c = __values(parentChain.reverse()), _d = _c.next(); !_d.done; _d = _c.next()){
                        var p = _d.value;
                        p.fireHook(Hook.afterCreate);
                        // This will call afterAttach on the child if necessary
                        p.finalizeCreation();
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "root", {
        get: function() {
            var parent = this.parent;
            return parent ? parent.root : this;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObjectNode.prototype, "clearParent", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (!this.parent) return;
            // detach if attached
            this.fireHook(Hook.beforeDetach);
            var previousState = this.state;
            this.state = NodeLifeCycle.DETACHING;
            var root = this.root;
            var newEnv = root.environment;
            var newIdCache = root.identifierCache.splitCache(this);
            try {
                this.parent.removeChild(this.subpath);
                this.baseSetParent(null, "");
                this.environment = newEnv;
                this.identifierCache = newIdCache;
            } finally{
                this.state = previousState;
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "setParent", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(newParent, subpath) {
            var parentChanged = newParent !== this.parent;
            var subpathChanged = subpath !== this.subpath;
            if (!parentChanged && !subpathChanged) return;
            if (devMode()) {
                if (!subpath) // istanbul ignore next
                throw fail("assertion failed: subpath expected");
                if (!newParent) // istanbul ignore next
                throw fail("assertion failed: new parent expected");
                if (this.parent && parentChanged) throw fail("A node cannot exists twice in the state tree. Failed to add " + this + " to path '" + newParent.path + "/" + subpath + "'.");
                if (!this.parent && newParent.root === this) throw fail("A state tree is not allowed to contain itself. Cannot assign " + this + " to path '" + newParent.path + "/" + subpath + "'");
                if (!this.parent && !!this.environment && this.environment !== newParent.root.environment) throw fail("A state tree cannot be made part of another state tree as long as their environments are different.");
            }
            if (parentChanged) {
                // attach to new parent
                this.environment = undefined; // will use root's
                newParent.root.identifierCache.mergeCache(this);
                this.baseSetParent(newParent, subpath);
                this.fireHook(Hook.afterAttach);
            } else if (subpathChanged) // moving to a new subpath on the same parent
            this.baseSetParent(this.parent, subpath);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "fireHook", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(name) {
            var _this = this;
            this.fireInternalHook(name);
            var fn = this.storedValue && typeof this.storedValue === "object" && this.storedValue[name];
            if (typeof fn === "function") {
                // we check for it to allow old mobx peer dependencies that don't have the method to work (even when still bugged)
                if (0, $2SBKn._allowStateChangesInsideComputed) (0, $2SBKn._allowStateChangesInsideComputed)(function() {
                    fn.apply(_this.storedValue);
                });
                else fn.apply(this.storedValue);
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "snapshot", {
        // advantage of using computed for a snapshot is that nicely respects transactions etc.
        get: function() {
            if (this.hasSnapshotPostProcessor) this.createObservableInstanceIfNeeded();
            return this._snapshotComputed.get();
        },
        enumerable: false,
        configurable: true
    });
    // NOTE: we use this method to get snapshot without creating @computed overhead
    Object.defineProperty(ObjectNode.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (!this.isAlive) return this._snapshotUponDeath;
            return this._observableInstanceState === 2 /* CREATED */  ? this._getActualSnapshot() : this._getCachedInitialSnapshot();
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_getActualSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return this.type.getSnapshot(this);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_getCachedInitialSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (!this._cachedInitialSnapshotCreated) {
                var type = this.type;
                var childNodes = this._childNodes;
                var snapshot = this._initialSnapshot;
                this._cachedInitialSnapshot = type.processInitialSnapshot(childNodes, snapshot);
                this._cachedInitialSnapshotCreated = true;
            }
            return this._cachedInitialSnapshot;
        }
    });
    Object.defineProperty(ObjectNode.prototype, "isRunningAction", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (this._isRunningAction) return true;
            if (this.isRoot) return false;
            return this.parent.isRunningAction();
        }
    });
    Object.defineProperty(ObjectNode.prototype, "assertAlive", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(context) {
            var livelinessChecking = getLivelinessChecking();
            if (!this.isAlive && livelinessChecking !== "ignore") {
                var error = this._getAssertAliveError(context);
                switch(livelinessChecking){
                    case "error":
                        throw fail(error);
                    case "warn":
                        warnError(error);
                }
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_getAssertAliveError", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(context) {
            var escapedPath = this.getEscapedPath(false) || this.pathUponDeath || "";
            var subpath = context.subpath && escapeJsonPath(context.subpath) || "";
            var actionContext = context.actionContext || getCurrentActionContext();
            // try to use a real action context if possible since it includes the action name
            if (actionContext && actionContext.type !== "action" && actionContext.parentActionEvent) actionContext = actionContext.parentActionEvent;
            var actionFullPath = "";
            if (actionContext && actionContext.name != null) {
                // try to use the context, and if it not available use the node one
                var actionPath = actionContext && actionContext.context && getPath(actionContext.context) || escapedPath;
                actionFullPath = actionPath + "." + actionContext.name + "()";
            }
            return "You are trying to read or write to an object that is no longer part of a state tree. (Object type: '" + this.type.name + "', Path upon death: '" + escapedPath + "', Subpath: '" + subpath + "', Action: '" + actionFullPath + "'). Either detach nodes first, or don't use objects after removing / replacing them in the tree.";
        }
    });
    Object.defineProperty(ObjectNode.prototype, "getChildNode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(subpath) {
            this.assertAlive({
                subpath: subpath
            });
            this._autoUnbox = false;
            try {
                return this._observableInstanceState === 2 /* CREATED */  ? this.type.getChildNode(this, subpath) : this._childNodes[subpath];
            } finally{
                this._autoUnbox = true;
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "getChildren", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            this.assertAlive(EMPTY_OBJECT);
            this._autoUnbox = false;
            try {
                return this._observableInstanceState === 2 /* CREATED */  ? this.type.getChildren(this) : convertChildNodesToArray(this._childNodes);
            } finally{
                this._autoUnbox = true;
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "getChildType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(propertyName) {
            return this.type.getChildType(propertyName);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "isProtected", {
        get: function() {
            return this.root.isProtectionEnabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObjectNode.prototype, "assertWritable", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(context) {
            this.assertAlive(context);
            if (!this.isRunningAction() && this.isProtected) throw fail("Cannot modify '" + this + "', the object is protected and can only be modified by using an action.");
        }
    });
    Object.defineProperty(ObjectNode.prototype, "removeChild", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(subpath) {
            this.type.removeChild(this, subpath);
        }
    });
    // bound on the constructor
    Object.defineProperty(ObjectNode.prototype, "unbox", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(childNode) {
            if (!childNode) return childNode;
            this.assertAlive({
                subpath: childNode.subpath || childNode.subpathUponDeath
            });
            return this._autoUnbox ? childNode.value : childNode;
        }
    });
    Object.defineProperty(ObjectNode.prototype, "toString", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            var path = (this.isAlive ? this.path : this.pathUponDeath) || "<root>";
            var identifier = this.identifier ? "(id: " + this.identifier + ")" : "";
            return this.type.name + "@" + path + identifier + (this.isAlive ? "" : " [dead]");
        }
    });
    Object.defineProperty(ObjectNode.prototype, "finalizeCreation", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            var _this = this;
            this.baseFinalizeCreation(function() {
                var e_3, _a;
                try {
                    for(var _b = __values(_this.getChildren()), _c = _b.next(); !_c.done; _c = _b.next()){
                        var child = _c.value;
                        child.finalizeCreation();
                    }
                } catch (e_3_1) {
                    e_3 = {
                        error: e_3_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_3) throw e_3.error;
                    }
                }
                _this.fireInternalHook(Hook.afterCreationFinalization);
            });
        }
    });
    Object.defineProperty(ObjectNode.prototype, "detach", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (!this.isAlive) throw fail("Error while detaching, node is not alive.");
            this.clearParent();
        }
    });
    Object.defineProperty(ObjectNode.prototype, "preboot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            var self = this;
            this._applyPatches = createActionInvoker(this.storedValue, "@APPLY_PATCHES", function(patches) {
                patches.forEach(function(patch) {
                    if (!patch.path) {
                        self.type.applySnapshot(self, patch.value);
                        return;
                    }
                    var parts = splitJsonPath(patch.path);
                    var node = resolveNodeByPathParts(self, parts.slice(0, -1));
                    node.applyPatchLocally(parts[parts.length - 1], patch);
                });
            });
            this._applySnapshot = createActionInvoker(this.storedValue, "@APPLY_SNAPSHOT", function(snapshot) {
                // if the snapshot is the same as the current one, avoid performing a reconcile
                if (snapshot === self.snapshot) return;
                // else, apply it by calling the type logic
                return self.type.applySnapshot(self, snapshot);
            });
            addHiddenFinalProp(this.storedValue, "$treenode", this);
            addHiddenFinalProp(this.storedValue, "toJSON", toJSON);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "die", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (!this.isAlive || this.state === NodeLifeCycle.DETACHING) return;
            this.aboutToDie();
            this.finalizeDeath();
        }
    });
    Object.defineProperty(ObjectNode.prototype, "aboutToDie", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (this._observableInstanceState === 0 /* UNINITIALIZED */ ) return;
            this.getChildren().forEach(function(node) {
                node.aboutToDie();
            });
            // beforeDestroy should run before the disposers since else we could end up in a situation where
            // a disposer added with addDisposer at this stage (beforeDestroy) is actually never released
            this.baseAboutToDie();
            this._internalEventsEmit("dispose" /* Dispose */ );
            this._internalEventsClear("dispose" /* Dispose */ );
        }
    });
    Object.defineProperty(ObjectNode.prototype, "finalizeDeath", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            // invariant: not called directly but from "die"
            this.getChildren().forEach(function(node) {
                node.finalizeDeath();
            });
            this.root.identifierCache.notifyDied(this);
            // "kill" the computed prop and just store the last snapshot
            var snapshot = this.snapshot;
            this._snapshotUponDeath = snapshot;
            this._internalEventsClearAll();
            this.baseFinalizeDeath();
        }
    });
    Object.defineProperty(ObjectNode.prototype, "onSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(onChange) {
            this._addSnapshotReaction();
            return this._internalEventsRegister("snapshot" /* Snapshot */ , onChange);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "emitSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(snapshot) {
            this._internalEventsEmit("snapshot" /* Snapshot */ , snapshot);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "onPatch", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(handler) {
            return this._internalEventsRegister("patch" /* Patch */ , handler);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "emitPatch", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(basePatch, source) {
            if (this._internalEventsHasSubscribers("patch" /* Patch */ )) {
                var localizedPatch = extend({}, basePatch, {
                    path: source.path.substr(this.path.length) + "/" + basePatch.path // calculate the relative path of the patch
                });
                var _a = __read(splitPatch(localizedPatch), 2), patch = _a[0], reversePatch = _a[1];
                this._internalEventsEmit("patch" /* Patch */ , patch, reversePatch);
            }
            if (this.parent) this.parent.emitPatch(basePatch, source);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "hasDisposer", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(disposer) {
            return this._internalEventsHas("dispose" /* Dispose */ , disposer);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "addDisposer", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(disposer) {
            if (!this.hasDisposer(disposer)) {
                this._internalEventsRegister("dispose" /* Dispose */ , disposer, true);
                return;
            }
            throw fail("cannot add a disposer when it is already registered for execution");
        }
    });
    Object.defineProperty(ObjectNode.prototype, "removeDisposer", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(disposer) {
            if (!this._internalEventsHas("dispose" /* Dispose */ , disposer)) throw fail("cannot remove a disposer which was never registered for execution");
            this._internalEventsUnregister("dispose" /* Dispose */ , disposer);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "removeMiddleware", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(middleware) {
            if (this.middlewares) {
                var index = this.middlewares.indexOf(middleware);
                if (index >= 0) this.middlewares.splice(index, 1);
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "addMiddleWare", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(handler, includeHooks) {
            var _this = this;
            if (includeHooks === void 0) includeHooks = true;
            var middleware = {
                handler: handler,
                includeHooks: includeHooks
            };
            if (!this.middlewares) this.middlewares = [
                middleware
            ];
            else this.middlewares.push(middleware);
            return function() {
                _this.removeMiddleware(middleware);
            };
        }
    });
    Object.defineProperty(ObjectNode.prototype, "applyPatchLocally", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(subpath, patch) {
            this.assertWritable({
                subpath: subpath
            });
            this.createObservableInstanceIfNeeded();
            this.type.applyPatchLocally(this, subpath, patch);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_addSnapshotReaction", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            var _this = this;
            if (!this._hasSnapshotReaction) {
                var snapshotDisposer = (0, $2SBKn.reaction)(function() {
                    return _this.snapshot;
                }, function(snapshot) {
                    return _this.emitSnapshot(snapshot);
                }, snapshotReactionOptions);
                this.addDisposer(snapshotDisposer);
                this._hasSnapshotReaction = true;
            }
        }
    });
    // we proxy the methods to avoid creating an EventHandlers instance when it is not needed
    Object.defineProperty(ObjectNode.prototype, "_internalEventsHasSubscribers", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(event) {
            return !!this._internalEvents && this._internalEvents.hasSubscribers(event);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_internalEventsRegister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(event, eventHandler, atTheBeginning) {
            if (atTheBeginning === void 0) atTheBeginning = false;
            if (!this._internalEvents) this._internalEvents = new EventHandlers();
            return this._internalEvents.register(event, eventHandler, atTheBeginning);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_internalEventsHas", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(event, eventHandler) {
            return !!this._internalEvents && this._internalEvents.has(event, eventHandler);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_internalEventsUnregister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(event, eventHandler) {
            if (this._internalEvents) this._internalEvents.unregister(event, eventHandler);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_internalEventsEmit", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(event) {
            var _a;
            var args = [];
            for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
            if (this._internalEvents) (_a = this._internalEvents).emit.apply(_a, __spread([
                event
            ], args));
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_internalEventsClear", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(event) {
            if (this._internalEvents) this._internalEvents.clear(event);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_internalEventsClearAll", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (this._internalEvents) this._internalEvents.clearAll();
        }
    });
    return ObjectNode;
}(BaseNode);
ObjectNode.prototype.createObservableInstance = (0, $2SBKn.action)(ObjectNode.prototype.createObservableInstance);
ObjectNode.prototype.detach = (0, $2SBKn.action)(ObjectNode.prototype.detach);
ObjectNode.prototype.die = (0, $2SBKn.action)(ObjectNode.prototype.die);
var _a;
/**
 * @internal
 * @hidden
 */ var TypeFlags;
(function(TypeFlags) {
    TypeFlags[TypeFlags["String"] = 1] = "String";
    TypeFlags[TypeFlags["Number"] = 2] = "Number";
    TypeFlags[TypeFlags["Boolean"] = 4] = "Boolean";
    TypeFlags[TypeFlags["Date"] = 8] = "Date";
    TypeFlags[TypeFlags["Literal"] = 16] = "Literal";
    TypeFlags[TypeFlags["Array"] = 32] = "Array";
    TypeFlags[TypeFlags["Map"] = 64] = "Map";
    TypeFlags[TypeFlags["Object"] = 128] = "Object";
    TypeFlags[TypeFlags["Frozen"] = 256] = "Frozen";
    TypeFlags[TypeFlags["Optional"] = 512] = "Optional";
    TypeFlags[TypeFlags["Reference"] = 1024] = "Reference";
    TypeFlags[TypeFlags["Identifier"] = 2048] = "Identifier";
    TypeFlags[TypeFlags["Late"] = 4096] = "Late";
    TypeFlags[TypeFlags["Refinement"] = 8192] = "Refinement";
    TypeFlags[TypeFlags["Union"] = 16384] = "Union";
    TypeFlags[TypeFlags["Null"] = 32768] = "Null";
    TypeFlags[TypeFlags["Undefined"] = 65536] = "Undefined";
    TypeFlags[TypeFlags["Integer"] = 131072] = "Integer";
    TypeFlags[TypeFlags["Custom"] = 262144] = "Custom";
    TypeFlags[TypeFlags["SnapshotProcessor"] = 524288] = "SnapshotProcessor";
    TypeFlags[TypeFlags["Lazy"] = 1048576] = "Lazy";
    TypeFlags[TypeFlags["Finite"] = 2097152] = "Finite";
    TypeFlags[TypeFlags["Float"] = 4194304] = "Float";
})(TypeFlags || (TypeFlags = {}));
/**
 * @internal
 * @hidden
 */ var cannotDetermineSubtype = "cannotDetermine";
/** @hidden */ var $type = Symbol("$type");
/**
 * A base type produces a MST node (Node in the state tree)
 *
 * @internal
 * @hidden
 */ var BaseType = /** @class */ function() {
    function BaseType(name) {
        Object.defineProperty(this, _a, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // these are just to make inner types avaialable to inherited classes
        Object.defineProperty(this, "C", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "S", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "T", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "N", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = name;
    }
    Object.defineProperty(BaseType.prototype, "create", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(snapshot, environment) {
            typecheckInternal(this, snapshot);
            return this.instantiate(null, "", environment, snapshot).value;
        }
    });
    Object.defineProperty(BaseType.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node, applyPostProcess) {
            // istanbul ignore next
            throw fail("unimplemented method");
        }
    });
    Object.defineProperty(BaseType.prototype, "isAssignableFrom", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(type) {
            return type === this;
        }
    });
    Object.defineProperty(BaseType.prototype, "validate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value, context) {
            var node = getStateTreeNodeSafe(value);
            if (node) {
                var valueType = getType(value);
                return this.isAssignableFrom(valueType) ? typeCheckSuccess() : typeCheckFailure(context, value);
            // it is tempting to compare snapshots, but in that case we should always clone on assignments...
            }
            return this.isValidSnapshot(value, context);
        }
    });
    Object.defineProperty(BaseType.prototype, "is", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(thing) {
            return this.validate(thing, [
                {
                    path: "",
                    type: this
                }
            ]).length === 0;
        }
    });
    Object.defineProperty(BaseType.prototype, "Type", {
        get: function() {
            // istanbul ignore next
            throw fail("Factory.Type should not be actually called. It is just a Type signature that can be used at compile time with Typescript, by using `typeof type.Type`");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseType.prototype, "TypeWithoutSTN", {
        get: function() {
            // istanbul ignore next
            throw fail("Factory.TypeWithoutSTN should not be actually called. It is just a Type signature that can be used at compile time with Typescript, by using `typeof type.TypeWithoutSTN`");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseType.prototype, "SnapshotType", {
        get: function() {
            // istanbul ignore next
            throw fail("Factory.SnapshotType should not be actually called. It is just a Type signature that can be used at compile time with Typescript, by using `typeof type.SnapshotType`");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseType.prototype, "CreationType", {
        get: function() {
            // istanbul ignore next
            throw fail("Factory.CreationType should not be actually called. It is just a Type signature that can be used at compile time with Typescript, by using `typeof type.CreationType`");
        },
        enumerable: false,
        configurable: true
    });
    return BaseType;
}();
_a = $type;
BaseType.prototype.create = (0, $2SBKn.action)(BaseType.prototype.create);
/**
 * A complex type produces a MST node (Node in the state tree)
 *
 * @internal
 * @hidden
 */ var ComplexType = /** @class */ function(_super) {
    __extends(ComplexType, _super);
    function ComplexType(name) {
        var _this = _super.call(this, name) || this;
        Object.defineProperty(_this, "identifierAttribute", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        return _this;
    }
    Object.defineProperty(ComplexType.prototype, "create", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(snapshot, environment) {
            if (snapshot === void 0) snapshot = this.getDefaultSnapshot();
            return _super.prototype.create.call(this, snapshot, environment);
        }
    });
    Object.defineProperty(ComplexType.prototype, "getValue", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node) {
            node.createObservableInstanceIfNeeded();
            return node.storedValue;
        }
    });
    Object.defineProperty(ComplexType.prototype, "isMatchingSnapshotId", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(current, snapshot) {
            return !current.identifierAttribute || current.identifier === normalizeIdentifier(snapshot[current.identifierAttribute]);
        }
    });
    Object.defineProperty(ComplexType.prototype, "tryToReconcileNode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(current, newValue) {
            if (current.isDetaching) return false;
            if (current.snapshot === newValue) // newValue is the current snapshot of the node, noop
            return true;
            if (isStateTreeNode(newValue) && getStateTreeNode(newValue) === current) // the current node is the same as the new one
            return true;
            if (current.type === this && isMutable(newValue) && !isStateTreeNode(newValue) && this.isMatchingSnapshotId(current, newValue)) {
                // the newValue has no node, so can be treated like a snapshot
                // we can reconcile
                current.applySnapshot(newValue);
                return true;
            }
            return false;
        }
    });
    Object.defineProperty(ComplexType.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(current, newValue, parent, subpath) {
            var nodeReconciled = this.tryToReconcileNode(current, newValue);
            if (nodeReconciled) {
                current.setParent(parent, subpath);
                return current;
            }
            // current node cannot be recycled in any way
            current.die(); // noop if detaching
            // attempt to reuse the new one
            if (isStateTreeNode(newValue) && this.isAssignableFrom(getType(newValue))) {
                // newValue is a Node as well, move it here..
                var newNode = getStateTreeNode(newValue);
                newNode.setParent(parent, subpath);
                return newNode;
            }
            // nothing to do, we have to create a new node
            return this.instantiate(parent, subpath, undefined, newValue);
        }
    });
    Object.defineProperty(ComplexType.prototype, "getSubTypes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return null;
        }
    });
    return ComplexType;
}(BaseType);
ComplexType.prototype.create = (0, $2SBKn.action)(ComplexType.prototype.create);
/**
 * @internal
 * @hidden
 */ var SimpleType = /** @class */ function(_super) {
    __extends(SimpleType, _super);
    function SimpleType() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SimpleType.prototype, "createNewInstance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(snapshot) {
            return snapshot;
        }
    });
    Object.defineProperty(SimpleType.prototype, "getValue", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node) {
            // if we ever find a case where scalar nodes can be accessed without iterating through its parent
            // uncomment this to make sure the parent chain is created when this is accessed
            // if (node.parent) {
            //     node.parent.createObservableInstanceIfNeeded()
            // }
            return node.storedValue;
        }
    });
    Object.defineProperty(SimpleType.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node) {
            return node.storedValue;
        }
    });
    Object.defineProperty(SimpleType.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(current, newValue, parent, subpath) {
            // reconcile only if type and value are still the same, and only if the node is not detaching
            if (!current.isDetaching && current.type === this && current.storedValue === newValue) return current;
            var res = this.instantiate(parent, subpath, undefined, newValue);
            current.die(); // noop if detaching
            return res;
        }
    });
    Object.defineProperty(SimpleType.prototype, "getSubTypes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return null;
        }
    });
    return SimpleType;
}(BaseType);
/**
 * Returns if a given value represents a type.
 *
 * @param value Value to check.
 * @returns `true` if the value is a type.
 */ function isType(value) {
    return typeof value === "object" && value && value.isType === true;
}
/**
 * @internal
 * @hidden
 */ function assertIsType(type, argNumber) {
    assertArg(type, isType, "mobx-state-tree type", argNumber);
}
var runningActions = new Map();
/**
 * Note: Consider migrating to `createActionTrackingMiddleware2`, it is easier to use.
 *
 * Convenience utility to create action based middleware that supports async processes more easily.
 * All hooks are called for both synchronous and asynchronous actions. Except that either `onSuccess` or `onFail` is called
 *
 * The create middleware tracks the process of an action (assuming it passes the `filter`).
 * `onResume` can return any value, which will be passed as second argument to any other hook. This makes it possible to keep state during a process.
 *
 * See the `atomic` middleware for an example
 *
 * @param hooks
 * @returns
 */ function createActionTrackingMiddleware(hooks) {
    return function actionTrackingMiddleware(call, next, abort) {
        switch(call.type){
            case "action":
                if (!hooks.filter || hooks.filter(call) === true) {
                    var context = hooks.onStart(call);
                    hooks.onResume(call, context);
                    runningActions.set(call.id, {
                        call: call,
                        context: context,
                        async: false
                    });
                    try {
                        var res = next(call);
                        hooks.onSuspend(call, context);
                        if (runningActions.get(call.id).async === false) {
                            runningActions.delete(call.id);
                            hooks.onSuccess(call, context, res);
                        }
                        return res;
                    } catch (e) {
                        runningActions.delete(call.id);
                        hooks.onFail(call, context, e);
                        throw e;
                    }
                } else return next(call);
            case "flow_spawn":
                var root = runningActions.get(call.rootId);
                root.async = true;
                return next(call);
            case "flow_resume":
            case "flow_resume_error":
                var root = runningActions.get(call.rootId);
                hooks.onResume(call, root.context);
                try {
                    return next(call);
                } finally{
                    hooks.onSuspend(call, root.context);
                }
            case "flow_throw":
                var root = runningActions.get(call.rootId);
                runningActions.delete(call.rootId);
                hooks.onFail(call, root.context, call.args[0]);
                return next(call);
            case "flow_return":
                var root = runningActions.get(call.rootId);
                runningActions.delete(call.rootId);
                hooks.onSuccess(call, root.context, call.args[0]);
                return next(call);
        }
    };
}
var RunningAction = /** @class */ function() {
    function RunningAction(hooks, call) {
        Object.defineProperty(this, "hooks", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: hooks
        });
        Object.defineProperty(this, "call", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: call
        });
        Object.defineProperty(this, "flowsPending", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "running", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        if (hooks) hooks.onStart(call);
    }
    Object.defineProperty(RunningAction.prototype, "finish", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(error) {
            if (this.running) {
                this.running = false;
                if (this.hooks) this.hooks.onFinish(this.call, error);
            }
        }
    });
    Object.defineProperty(RunningAction.prototype, "incFlowsPending", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            this.flowsPending++;
        }
    });
    Object.defineProperty(RunningAction.prototype, "decFlowsPending", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            this.flowsPending--;
        }
    });
    Object.defineProperty(RunningAction.prototype, "hasFlowsPending", {
        get: function() {
            return this.flowsPending > 0;
        },
        enumerable: false,
        configurable: true
    });
    return RunningAction;
}();
/**
 * Convenience utility to create action based middleware that supports async processes more easily.
 * The flow is like this:
 * - for each action: if filter passes -> `onStart` -> (inner actions recursively) -> `onFinish`
 *
 * Example: if we had an action `a` that called inside an action `b1`, then `b2` the flow would be:
 * - `filter(a)`
 * - `onStart(a)`
 *   - `filter(b1)`
 *   - `onStart(b1)`
 *   - `onFinish(b1)`
 *   - `filter(b2)`
 *   - `onStart(b2)`
 *   - `onFinish(b2)`
 * - `onFinish(a)`
 *
 * The flow is the same no matter if the actions are sync or async.
 *
 * See the `atomic` middleware for an example
 *
 * @param hooks
 * @returns
 */ function createActionTrackingMiddleware2(middlewareHooks) {
    var runningActions = new Map();
    return function actionTrackingMiddleware(call, next) {
        // find parentRunningAction
        var parentRunningAction = call.parentActionEvent ? runningActions.get(call.parentActionEvent.id) : undefined;
        if (call.type === "action") {
            var newCall = __assign(__assign({}, call), {
                // make a shallow copy of the parent action env
                env: parentRunningAction && parentRunningAction.call.env,
                parentCall: parentRunningAction && parentRunningAction.call
            });
            var passesFilter = !middlewareHooks.filter || middlewareHooks.filter(newCall);
            var hooks = passesFilter ? middlewareHooks : undefined;
            var runningAction = new RunningAction(hooks, newCall);
            runningActions.set(call.id, runningAction);
            var res = void 0;
            try {
                res = next(call);
            } catch (e) {
                runningActions.delete(call.id);
                runningAction.finish(e);
                throw e;
            }
            // sync action finished
            if (!runningAction.hasFlowsPending) {
                runningActions.delete(call.id);
                runningAction.finish();
            }
            return res;
        } else {
            if (!parentRunningAction) return next(call);
            switch(call.type){
                case "flow_spawn":
                    parentRunningAction.incFlowsPending();
                    return next(call);
                case "flow_resume":
                case "flow_resume_error":
                    return next(call);
                case "flow_throw":
                    var error = call.args[0];
                    try {
                        return next(call);
                    } finally{
                        parentRunningAction.decFlowsPending();
                        if (!parentRunningAction.hasFlowsPending) {
                            runningActions.delete(call.parentActionEvent.id);
                            parentRunningAction.finish(error);
                        }
                    }
                case "flow_return":
                    try {
                        return next(call);
                    } finally{
                        parentRunningAction.decFlowsPending();
                        if (!parentRunningAction.hasFlowsPending) {
                            runningActions.delete(call.parentActionEvent.id);
                            parentRunningAction.finish();
                        }
                    }
            }
        }
    };
}
function serializeArgument(node, actionName, index, arg) {
    if (arg instanceof Date) return {
        $MST_DATE: arg.getTime()
    };
    if (isPrimitive(arg)) return arg;
    // We should not serialize MST nodes, even if we can, because we don't know if the receiving party can handle a raw snapshot instead of an
    // MST type instance. So if one wants to serialize a MST node that was pass in, either explitly pass: 1: an id, 2: a (relative) path, 3: a snapshot
    if (isStateTreeNode(arg)) return serializeTheUnserializable("[MSTNode: " + getType(arg).name + "]");
    if (typeof arg === "function") return serializeTheUnserializable("[function]");
    if (typeof arg === "object" && !isPlainObject(arg) && !isArray(arg)) return serializeTheUnserializable("[object " + (arg && arg.constructor && arg.constructor.name || "Complex Object") + "]");
    try {
        // Check if serializable, cycle free etc...
        // MWE: there must be a better way....
        JSON.stringify(arg); // or throws
        return arg;
    } catch (e) {
        return serializeTheUnserializable("" + e);
    }
}
function deserializeArgument(adm, value) {
    if (value && typeof value === "object" && "$MST_DATE" in value) return new Date(value["$MST_DATE"]);
    return value;
}
function serializeTheUnserializable(baseType) {
    return {
        $MST_UNSERIALIZABLE: true,
        type: baseType
    };
}
/**
 * Applies an action or a series of actions in a single MobX transaction.
 * Does not return any value
 * Takes an action description as produced by the `onAction` middleware.
 *
 * @param target
 * @param actions
 */ function applyAction(target, actions) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    assertArg(actions, function(a) {
        return typeof a === "object";
    }, "object or array", 2);
    (0, $2SBKn.runInAction)(function() {
        asArray(actions).forEach(function(action) {
            return baseApplyAction(target, action);
        });
    });
}
function baseApplyAction(target, action) {
    var resolvedTarget = tryResolve(target, action.path || "");
    if (!resolvedTarget) throw fail("Invalid action path: " + (action.path || ""));
    var node = getStateTreeNode(resolvedTarget);
    // Reserved functions
    if (action.name === "@APPLY_PATCHES") return applyPatch.call(null, resolvedTarget, action.args[0]);
    if (action.name === "@APPLY_SNAPSHOT") return applySnapshot.call(null, resolvedTarget, action.args[0]);
    if (!(typeof resolvedTarget[action.name] === "function")) throw fail("Action '" + action.name + "' does not exist in '" + node.path + "'");
    return resolvedTarget[action.name].apply(resolvedTarget, action.args ? action.args.map(function(v) {
        return deserializeArgument(node, v);
    }) : []);
}
/**
 * Small abstraction around `onAction` and `applyAction`, attaches an action listener to a tree and records all the actions emitted.
 * Returns an recorder object with the following signature:
 *
 * Example:
 * ```ts
 * export interface IActionRecorder {
 *      // the recorded actions
 *      actions: ISerializedActionCall[]
 *      // true if currently recording
 *      recording: boolean
 *      // stop recording actions
 *      stop(): void
 *      // resume recording actions
 *      resume(): void
 *      // apply all the recorded actions on the given object
 *      replay(target: IAnyStateTreeNode): void
 * }
 * ```
 *
 * The optional filter function allows to skip recording certain actions.
 *
 * @param subject
 * @returns
 */ function recordActions(subject, filter) {
    // check all arguments
    assertIsStateTreeNode(subject, 1);
    var actions = [];
    var listener = function(call) {
        var recordThis = filter ? filter(call, getRunningActionContext()) : true;
        if (recordThis) actions.push(call);
    };
    var disposer;
    var recorder = {
        actions: actions,
        get recording () {
            return !!disposer;
        },
        stop: function() {
            if (disposer) {
                disposer();
                disposer = undefined;
            }
        },
        resume: function() {
            if (disposer) return;
            disposer = onAction(subject, listener);
        },
        replay: function(target) {
            applyAction(target, actions);
        }
    };
    recorder.resume();
    return recorder;
}
/**
 * Registers a function that will be invoked for each action that is called on the provided model instance, or to any of its children.
 * See [actions](https://github.com/mobxjs/mobx-state-tree#actions) for more details. onAction events are emitted only for the outermost called action in the stack.
 * Action can also be intercepted by middleware using addMiddleware to change the function call before it will be run.
 *
 * Not all action arguments might be serializable. For unserializable arguments, a struct like `{ $MST_UNSERIALIZABLE: true, type: "someType" }` will be generated.
 * MST Nodes are considered non-serializable as well (they could be serialized as there snapshot, but it is uncertain whether an replaying party will be able to handle such a non-instantiated snapshot).
 * Rather, when using `onAction` middleware, one should consider in passing arguments which are 1: an id, 2: a (relative) path, or 3: a snapshot. Instead of a real MST node.
 *
 * Example:
 * ```ts
 * const Todo = types.model({
 *   task: types.string
 * })
 *
 * const TodoStore = types.model({
 *   todos: types.array(Todo)
 * }).actions(self => ({
 *   add(todo) {
 *     self.todos.push(todo);
 *   }
 * }))
 *
 * const s = TodoStore.create({ todos: [] })
 *
 * let disposer = onAction(s, (call) => {
 *   console.log(call);
 * })
 *
 * s.add({ task: "Grab a coffee" })
 * // Logs: { name: "add", path: "", args: [{ task: "Grab a coffee" }] }
 * ```
 *
 * @param target
 * @param listener
 * @param attachAfter (default false) fires the listener *after* the action has executed instead of before.
 * @returns
 */ function onAction(target, listener, attachAfter) {
    if (attachAfter === void 0) attachAfter = false;
    // check all arguments
    assertIsStateTreeNode(target, 1);
    if (devMode()) {
        if (!isRoot(target)) warnError("Warning: Attaching onAction listeners to non root nodes is dangerous: No events will be emitted for actions initiated higher up in the tree.");
        if (!isProtected(target)) warnError("Warning: Attaching onAction listeners to non protected nodes is dangerous: No events will be emitted for direct modifications without action.");
    }
    return addMiddleware(target, function handler(rawCall, next) {
        if (rawCall.type === "action" && rawCall.id === rawCall.rootId) {
            var sourceNode_1 = getStateTreeNode(rawCall.context);
            var info = {
                name: rawCall.name,
                path: getRelativePathBetweenNodes(getStateTreeNode(target), sourceNode_1),
                args: rawCall.args.map(function(arg, index) {
                    return serializeArgument(sourceNode_1, rawCall.name, index, arg);
                })
            };
            if (attachAfter) {
                var res = next(rawCall);
                listener(info);
                return res;
            } else {
                listener(info);
                return next(rawCall);
            }
        } else return next(rawCall);
    });
}
var nextActionId = 1;
var currentActionContext;
/**
 * @internal
 * @hidden
 */ function getCurrentActionContext() {
    return currentActionContext;
}
/**
 * @internal
 * @hidden
 */ function getNextActionId() {
    return nextActionId++;
}
// TODO: optimize away entire action context if there is no middleware in tree?
/**
 * @internal
 * @hidden
 */ function runWithActionContext(context, fn) {
    var node = getStateTreeNode(context.context);
    if (context.type === "action") node.assertAlive({
        actionContext: context
    });
    var baseIsRunningAction = node._isRunningAction;
    node._isRunningAction = true;
    var previousContext = currentActionContext;
    currentActionContext = context;
    try {
        return runMiddleWares(node, context, fn);
    } finally{
        currentActionContext = previousContext;
        node._isRunningAction = baseIsRunningAction;
    }
}
/**
 * @internal
 * @hidden
 */ function getParentActionContext(parentContext) {
    if (!parentContext) return undefined;
    if (parentContext.type === "action") return parentContext;
    return parentContext.parentActionEvent;
}
/**
 * @internal
 * @hidden
 */ function createActionInvoker(target, name, fn) {
    var res = function() {
        var id = getNextActionId();
        var parentContext = currentActionContext;
        var parentActionContext = getParentActionContext(parentContext);
        return runWithActionContext({
            type: "action",
            name: name,
            id: id,
            args: argsToArray(arguments),
            context: target,
            tree: getRoot(target),
            rootId: parentContext ? parentContext.rootId : id,
            parentId: parentContext ? parentContext.id : 0,
            allParentIds: parentContext ? __spread(parentContext.allParentIds, [
                parentContext.id
            ]) : [],
            parentEvent: parentContext,
            parentActionEvent: parentActionContext
        }, fn);
    };
    res._isMSTAction = true;
    res._isFlowAction = fn._isFlowAction;
    return res;
}
/**
 * Middleware can be used to intercept any action is invoked on the subtree where it is attached.
 * If a tree is protected (by default), this means that any mutation of the tree will pass through your middleware.
 *
 * For more details, see the [middleware docs](concepts/middleware.md)
 *
 * @param target Node to apply the middleware to.
 * @param middleware Middleware to apply.
 * @returns A callable function to dispose the middleware.
 */ function addMiddleware(target, handler, includeHooks) {
    if (includeHooks === void 0) includeHooks = true;
    var node = getStateTreeNode(target);
    if (devMode()) {
        if (!node.isProtectionEnabled) warnError("It is recommended to protect the state tree before attaching action middleware, as otherwise it cannot be guaranteed that all changes are passed through middleware. See `protect`");
    }
    return node.addMiddleWare(handler, includeHooks);
}
/**
 * Binds middleware to a specific action.
 *
 * Example:
 * ```ts
 * type.actions(self => {
 *   function takeA____() {
 *       self.toilet.donate()
 *       self.wipe()
 *       self.wipe()
 *       self.toilet.flush()
 *   }
 *   return {
 *     takeA____: decorate(atomic, takeA____)
 *   }
 * })
 * ```
 *
 * @param handler
 * @param fn
 * @param includeHooks
 * @returns The original function
 */ function decorate(handler, fn, includeHooks) {
    if (includeHooks === void 0) includeHooks = true;
    var middleware = {
        handler: handler,
        includeHooks: includeHooks
    };
    fn.$mst_middleware = fn.$mst_middleware || [];
    fn.$mst_middleware.push(middleware);
    return fn;
}
var CollectedMiddlewares = /** @class */ function() {
    function CollectedMiddlewares(node, fn) {
        Object.defineProperty(this, "arrayIndex", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "inArrayIndex", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "middlewares", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        // we just push middleware arrays into an array of arrays to avoid making copies
        if (fn.$mst_middleware) this.middlewares.push(fn.$mst_middleware);
        var n = node;
        // Find all middlewares. Optimization: cache this?
        while(n){
            if (n.middlewares) this.middlewares.push(n.middlewares);
            n = n.parent;
        }
    }
    Object.defineProperty(CollectedMiddlewares.prototype, "isEmpty", {
        get: function() {
            return this.middlewares.length <= 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectedMiddlewares.prototype, "getNextMiddleware", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            var array = this.middlewares[this.arrayIndex];
            if (!array) return undefined;
            var item = array[this.inArrayIndex++];
            if (!item) {
                this.arrayIndex++;
                this.inArrayIndex = 0;
                return this.getNextMiddleware();
            }
            return item;
        }
    });
    return CollectedMiddlewares;
}();
function runMiddleWares(node, baseCall, originalFn) {
    var middlewares = new CollectedMiddlewares(node, originalFn);
    // Short circuit
    if (middlewares.isEmpty) return (0, $2SBKn.action)(originalFn).apply(null, baseCall.args);
    var result = null;
    function runNextMiddleware(call) {
        var middleware = middlewares.getNextMiddleware();
        var handler = middleware && middleware.handler;
        if (!handler) return (0, $2SBKn.action)(originalFn).apply(null, call.args);
        // skip hooks if asked to
        if (!middleware.includeHooks && Hook[call.name]) return runNextMiddleware(call);
        var nextInvoked = false;
        function next(call2, callback) {
            nextInvoked = true;
            // the result can contain
            // - the non manipulated return value from an action
            // - the non manipulated abort value
            // - one of the above but manipulated through the callback function
            result = runNextMiddleware(call2);
            if (callback) result = callback(result);
        }
        var abortInvoked = false;
        function abort(value) {
            abortInvoked = true;
            // overwrite the result
            // can be manipulated through middlewares earlier in the queue using the callback fn
            result = value;
        }
        handler(call, next, abort);
        if (devMode()) {
            if (!nextInvoked && !abortInvoked) {
                var node2 = getStateTreeNode(call.tree);
                throw fail("Neither the next() nor the abort() callback within the middleware " + handler.name + ' for the action: "' + call.name + '" on the node: ' + node2.type.name + " was invoked.");
            } else if (nextInvoked && abortInvoked) {
                var node2 = getStateTreeNode(call.tree);
                throw fail("The next() and abort() callback within the middleware " + handler.name + ' for the action: "' + call.name + '" on the node: ' + node2.type.name + " were invoked.");
            }
        }
        return result;
    }
    return runNextMiddleware(baseCall);
}
/**
 * Returns the currently executing MST action context, or undefined if none.
 */ function getRunningActionContext() {
    var current = getCurrentActionContext();
    while(current && current.type !== "action")current = current.parentActionEvent;
    return current;
}
function _isActionContextThisOrChildOf(actionContext, sameOrParent, includeSame) {
    var parentId = typeof sameOrParent === "number" ? sameOrParent : sameOrParent.id;
    var current = includeSame ? actionContext : actionContext.parentActionEvent;
    while(current){
        if (current.id === parentId) return true;
        current = current.parentActionEvent;
    }
    return false;
}
/**
 * Returns if the given action context is a parent of this action context.
 */ function isActionContextChildOf(actionContext, parent) {
    return _isActionContextThisOrChildOf(actionContext, parent, false);
}
/**
 * Returns if the given action context is this or a parent of this action context.
 */ function isActionContextThisOrChildOf(actionContext, parentOrThis) {
    return _isActionContextThisOrChildOf(actionContext, parentOrThis, true);
}
function safeStringify(value) {
    try {
        return JSON.stringify(value);
    } catch (e) {
        // istanbul ignore next
        return "<Unserializable: " + e + ">";
    }
}
/**
 * @internal
 * @hidden
 */ function prettyPrintValue(value) {
    return typeof value === "function" ? "<function" + (value.name ? " " + value.name : "") + ">" : isStateTreeNode(value) ? "<" + value + ">" : "`" + safeStringify(value) + "`";
}
function shortenPrintValue(valueInString) {
    return valueInString.length < 280 ? valueInString : valueInString.substring(0, 272) + "......" + valueInString.substring(valueInString.length - 8);
}
function toErrorString(error) {
    var value = error.value;
    var type = error.context[error.context.length - 1].type;
    var fullPath = error.context.map(function(_a) {
        var path = _a.path;
        return path;
    }).filter(function(path) {
        return path.length > 0;
    }).join("/");
    var pathPrefix = fullPath.length > 0 ? 'at path "/' + fullPath + '" ' : "";
    var currentTypename = isStateTreeNode(value) ? "value of type " + getStateTreeNode(value).type.name + ":" : isPrimitive(value) ? "value" : "snapshot";
    var isSnapshotCompatible = type && isStateTreeNode(value) && type.is(getStateTreeNode(value).snapshot);
    return "" + pathPrefix + currentTypename + " " + prettyPrintValue(value) + " is not assignable " + (type ? "to type: `" + type.name + "`" : "") + (error.message ? " (" + error.message + ")" : "") + (type ? isPrimitiveType(type) || isPrimitive(value) ? "." : ", expected an instance of `" + type.name + "` or a snapshot like `" + type.describe() + "` instead." + (isSnapshotCompatible ? " (Note that a snapshot of the provided value is compatible with the targeted type)" : "") : ".");
}
/**
 * @internal
 * @hidden
 */ function getContextForPath(context, path, type) {
    return context.concat([
        {
            path: path,
            type: type
        }
    ]);
}
/**
 * @internal
 * @hidden
 */ function typeCheckSuccess() {
    return EMPTY_ARRAY;
}
/**
 * @internal
 * @hidden
 */ function typeCheckFailure(context, value, message) {
    return [
        {
            context: context,
            value: value,
            message: message
        }
    ];
}
/**
 * @internal
 * @hidden
 */ function flattenTypeErrors(errors) {
    return errors.reduce(function(a, i) {
        return a.concat(i);
    }, []);
}
// TODO; doublecheck: typecheck should only needed to be invoked from: type.create and array / map / value.property will change
/**
 * @internal
 * @hidden
 */ function typecheckInternal(type, value) {
    // runs typeChecking if it is in dev-mode or through a process.env.ENABLE_TYPE_CHECK flag
    if (isTypeCheckingEnabled()) typecheck(type, value);
}
/**
 * Run's the typechecker for the given type on the given value, which can be a snapshot or an instance.
 * Throws if the given value is not according the provided type specification.
 * Use this if you need typechecks even in a production build (by default all automatic runtime type checks will be skipped in production builds)
 *
 * @param type Type to check against.
 * @param value Value to be checked, either a snapshot or an instance.
 */ function typecheck(type, value) {
    var errors = type.validate(value, [
        {
            path: "",
            type: type
        }
    ]);
    if (errors.length > 0) throw fail(validationErrorsToString(type, value, errors));
}
function validationErrorsToString(type, value, errors) {
    if (errors.length === 0) return undefined;
    return "Error while converting " + shortenPrintValue(prettyPrintValue(value)) + " to `" + type.name + "`:\n\n    " + errors.map(toErrorString).join("\n    ");
}
var identifierCacheId = 0;
/**
 * @internal
 * @hidden
 */ var IdentifierCache = /** @class */ function() {
    function IdentifierCache() {
        Object.defineProperty(this, "cacheId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: identifierCacheId++
        });
        // n.b. in cache all identifiers are normalized to strings
        Object.defineProperty(this, "cache", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $2SBKn.observable).map()
        });
        // last time the cache (array) for a given time changed
        // n.b. it is not really the time, but just an integer that gets increased after each modification to the array
        Object.defineProperty(this, "lastCacheModificationPerId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $2SBKn.observable).map()
        });
    }
    Object.defineProperty(IdentifierCache.prototype, "updateLastCacheModificationPerId", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(identifier) {
            var lcm = this.lastCacheModificationPerId.get(identifier);
            // we start at 1 since 0 means no update since cache creation
            this.lastCacheModificationPerId.set(identifier, lcm === undefined ? 1 : lcm + 1);
        }
    });
    Object.defineProperty(IdentifierCache.prototype, "getLastCacheModificationPerId", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(identifier) {
            var modificationId = this.lastCacheModificationPerId.get(identifier) || 0;
            return this.cacheId + "-" + modificationId;
        }
    });
    Object.defineProperty(IdentifierCache.prototype, "addNodeToCache", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node, lastCacheUpdate) {
            if (lastCacheUpdate === void 0) lastCacheUpdate = true;
            if (node.identifierAttribute) {
                var identifier = node.identifier;
                if (!this.cache.has(identifier)) this.cache.set(identifier, (0, $2SBKn.observable).array([], mobxShallow));
                var set = this.cache.get(identifier);
                if (set.indexOf(node) !== -1) throw fail("Already registered");
                set.push(node);
                if (lastCacheUpdate) this.updateLastCacheModificationPerId(identifier);
            }
        }
    });
    Object.defineProperty(IdentifierCache.prototype, "mergeCache", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node) {
            var _this = this;
            (0, $2SBKn.values)(node.identifierCache.cache).forEach(function(nodes) {
                return nodes.forEach(function(child) {
                    _this.addNodeToCache(child);
                });
            });
        }
    });
    Object.defineProperty(IdentifierCache.prototype, "notifyDied", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node) {
            if (node.identifierAttribute) {
                var id = node.identifier;
                var set = this.cache.get(id);
                if (set) {
                    set.remove(node);
                    // remove empty sets from cache
                    if (!set.length) this.cache.delete(id);
                    this.updateLastCacheModificationPerId(node.identifier);
                }
            }
        }
    });
    Object.defineProperty(IdentifierCache.prototype, "splitCache", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(splitNode) {
            var _this = this;
            var newCache = new IdentifierCache();
            // The slash is added here so we only match children of the splitNode. In version 5.1.8 and
            // earlier there was no trailing slash, so non children that started with the same path string
            // were being matched incorrectly.
            var basePath = splitNode.path + "/";
            (0, $2SBKn.entries)(this.cache).forEach(function(_a) {
                var _b = __read(_a, 2), id = _b[0], nodes = _b[1];
                var modified = false;
                for(var i = nodes.length - 1; i >= 0; i--){
                    var node = nodes[i];
                    if (node === splitNode || node.path.indexOf(basePath) === 0) {
                        newCache.addNodeToCache(node, false); // no need to update lastUpdated since it is a whole new cache
                        nodes.splice(i, 1);
                        // remove empty sets from cache
                        if (!nodes.length) _this.cache.delete(id);
                        modified = true;
                    }
                }
                if (modified) _this.updateLastCacheModificationPerId(id);
            });
            return newCache;
        }
    });
    Object.defineProperty(IdentifierCache.prototype, "has", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(type, identifier) {
            var set = this.cache.get(identifier);
            if (!set) return false;
            return set.some(function(candidate) {
                return type.isAssignableFrom(candidate.type);
            });
        }
    });
    Object.defineProperty(IdentifierCache.prototype, "resolve", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(type, identifier) {
            var set = this.cache.get(identifier);
            if (!set) return null;
            var matches = set.filter(function(candidate) {
                return type.isAssignableFrom(candidate.type);
            });
            switch(matches.length){
                case 0:
                    return null;
                case 1:
                    return matches[0];
                default:
                    throw fail("Cannot resolve a reference to type '" + type.name + "' with id: '" + identifier + "' unambigously, there are multiple candidates: " + matches.map(function(n) {
                        return n.path;
                    }).join(", "));
            }
        }
    });
    return IdentifierCache;
}();
/**
 * @internal
 * @hidden
 */ function createObjectNode(type, parent, subpath, environment, initialValue) {
    var existingNode = getStateTreeNodeSafe(initialValue);
    if (existingNode) {
        if (existingNode.parent) // istanbul ignore next
        throw fail("Cannot add an object to a state tree if it is already part of the same or another state tree. Tried to assign an object to '" + (parent ? parent.path : "") + "/" + subpath + "', but it lives already at '" + existingNode.path + "'");
        if (parent) existingNode.setParent(parent, subpath);
        // else it already has no parent since it is a pre-requisite
        return existingNode;
    }
    // not a node, a snapshot
    return new ObjectNode(type, parent, subpath, environment, initialValue);
}
/**
 * @internal
 * @hidden
 */ function createScalarNode(type, parent, subpath, environment, initialValue) {
    return new ScalarNode(type, parent, subpath, environment, initialValue);
}
/**
 * @internal
 * @hidden
 */ function isNode(value) {
    return value instanceof ScalarNode || value instanceof ObjectNode;
}
/**
 * @internal
 * @hidden
 */ var NodeLifeCycle;
(function(NodeLifeCycle) {
    NodeLifeCycle[NodeLifeCycle["INITIALIZING"] = 0] = "INITIALIZING";
    NodeLifeCycle[NodeLifeCycle["CREATED"] = 1] = "CREATED";
    NodeLifeCycle[NodeLifeCycle["FINALIZED"] = 2] = "FINALIZED";
    NodeLifeCycle[NodeLifeCycle["DETACHING"] = 3] = "DETACHING";
    NodeLifeCycle[NodeLifeCycle["DEAD"] = 4] = "DEAD"; // no coming back from this one
})(NodeLifeCycle || (NodeLifeCycle = {}));
/**
 * Returns true if the given value is a node in a state tree.
 * More precisely, that is, if the value is an instance of a
 * `types.model`, `types.array` or `types.map`.
 *
 * @param value
 * @returns true if the value is a state tree node.
 */ function isStateTreeNode(value) {
    return !!(value && value.$treenode);
}
/**
 * @internal
 * @hidden
 */ function assertIsStateTreeNode(value, argNumber) {
    assertArg(value, isStateTreeNode, "mobx-state-tree node", argNumber);
}
/**
 * @internal
 * @hidden
 */ function getStateTreeNode(value) {
    if (!isStateTreeNode(value)) // istanbul ignore next
    throw fail("Value " + value + " is no MST Node");
    return value.$treenode;
}
/**
 * @internal
 * @hidden
 */ function getStateTreeNodeSafe(value) {
    return value && value.$treenode || null;
}
/**
 * @internal
 * @hidden
 */ function toJSON() {
    return getStateTreeNode(this).snapshot;
}
var doubleDot = function(_) {
    return "..";
};
/**
 * @internal
 * @hidden
 */ function getRelativePathBetweenNodes(base, target) {
    // PRE condition target is (a child of) base!
    if (base.root !== target.root) throw fail("Cannot calculate relative path: objects '" + base + "' and '" + target + "' are not part of the same object tree");
    var baseParts = splitJsonPath(base.path);
    var targetParts = splitJsonPath(target.path);
    var common = 0;
    for(; common < baseParts.length; common++){
        if (baseParts[common] !== targetParts[common]) break;
    }
    // TODO: assert that no targetParts paths are "..", "." or ""!
    return baseParts.slice(common).map(doubleDot).join("/") + joinJsonPath(targetParts.slice(common));
}
/**
 * @internal
 * @hidden
 */ function resolveNodeByPath(base, path, failIfResolveFails) {
    if (failIfResolveFails === void 0) failIfResolveFails = true;
    return resolveNodeByPathParts(base, splitJsonPath(path), failIfResolveFails);
}
/**
 * @internal
 * @hidden
 */ function resolveNodeByPathParts(base, pathParts, failIfResolveFails) {
    if (failIfResolveFails === void 0) failIfResolveFails = true;
    var current = base;
    try {
        for(var i = 0; i < pathParts.length; i++){
            var part = pathParts[i];
            if (part === "..") {
                current = current.parent;
                if (current) continue; // not everything has a parent
            } else if (part === ".") continue;
            else if (current) {
                if (current instanceof ScalarNode) {
                    // check if the value of a scalar resolves to a state tree node (e.g. references)
                    // then we can continue resolving...
                    var value = current.value;
                    if (isStateTreeNode(value)) current = getStateTreeNode(value);
                }
                if (current instanceof ObjectNode) {
                    var subType = current.getChildType(part);
                    if (subType) {
                        current = current.getChildNode(part);
                        if (current) continue;
                    }
                }
            }
            throw fail("Could not resolve '" + part + "' in path '" + (joinJsonPath(pathParts.slice(0, i)) || "/") + "' while resolving '" + joinJsonPath(pathParts) + "'");
        }
    } catch (e) {
        if (!failIfResolveFails) return undefined;
        throw e;
    }
    return current;
}
/**
 * @internal
 * @hidden
 */ function convertChildNodesToArray(childNodes) {
    if (!childNodes) return EMPTY_ARRAY;
    var keys = Object.keys(childNodes);
    if (!keys.length) return EMPTY_ARRAY;
    var result = new Array(keys.length);
    keys.forEach(function(key, index) {
        result[index] = childNodes[key];
    });
    return result;
}
// based on: https://github.com/mobxjs/mobx-utils/blob/master/src/async-action.ts
/*
    All contents of this file are deprecated.

    The term `process` has been replaced with `flow` to avoid conflicts with the
    global `process` object.

    Refer to `flow.ts` for any further changes to this implementation.
*/ var DEPRECATION_MESSAGE = "See https://github.com/mobxjs/mobx-state-tree/issues/399 for more information. Note that the middleware event types starting with `process` now start with `flow`.";
/**
 * @hidden
 *
 * @deprecated has been renamed to `flow()`.
 * See https://github.com/mobxjs/mobx-state-tree/issues/399 for more information.
 * Note that the middleware event types starting with `process` now start with `flow`.
 *
 * @returns {Promise}
 */ function process$1(asyncAction) {
    deprecated("process", "`process()` has been renamed to `flow()`. " + DEPRECATION_MESSAGE);
    return flow(asyncAction);
}
var plainObjectString = Object.toString();
/**
 * @internal
 * @hidden
 */ var EMPTY_ARRAY = Object.freeze([]);
/**
 * @internal
 * @hidden
 */ var EMPTY_OBJECT = Object.freeze({});
/**
 * @internal
 * @hidden
 */ var mobxShallow = (0, $2SBKn._getGlobalState)().useProxies ? {
    deep: false
} : {
    deep: false,
    proxy: false
};
Object.freeze(mobxShallow);
/**
 * @internal
 * @hidden
 */ function fail(message) {
    if (message === void 0) message = "Illegal state";
    return new Error("[mobx-state-tree] " + message);
}
/**
 * @internal
 * @hidden
 */ function identity(_) {
    return _;
}
/**
 * @internal
 * @hidden
 */ var isInteger = Number.isInteger;
/**
 * @internal
 * @hidden
 */ function isFloat(val) {
    return Number(val) === val && val % 1 !== 0;
}
/**
 * @internal
 * @hidden
 */ function isFinite(val) {
    return Number.isFinite(val);
}
/**
 * @internal
 * @hidden
 */ function isArray(val) {
    return Array.isArray(val) || (0, $2SBKn.isObservableArray)(val);
}
/**
 * @internal
 * @hidden
 */ function asArray(val) {
    if (!val) return EMPTY_ARRAY;
    if (isArray(val)) return val;
    return [
        val
    ];
}
/**
 * @internal
 * @hidden
 */ function extend(a) {
    var b = [];
    for(var _i = 1; _i < arguments.length; _i++)b[_i - 1] = arguments[_i];
    for(var i = 0; i < b.length; i++){
        var current = b[i];
        for(var key in current)a[key] = current[key];
    }
    return a;
}
/**
 * @internal
 * @hidden
 */ function isPlainObject(value) {
    var _a;
    if (value === null || typeof value !== "object") return false;
    var proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    return ((_a = proto.constructor) === null || _a === void 0 ? void 0 : _a.toString()) === plainObjectString;
}
/**
 * @internal
 * @hidden
 */ function isMutable(value) {
    return value !== null && typeof value === "object" && !(value instanceof Date) && !(value instanceof RegExp);
}
/**
 * @internal
 * @hidden
 */ function isPrimitive(value, includeDate) {
    if (includeDate === void 0) includeDate = true;
    return value === null || value === undefined || typeof value === "string" || typeof value === "number" || typeof value === "boolean" || includeDate && value instanceof Date;
}
/**
 * @internal
 * @hidden
 * Freeze a value and return it (if not in production)
 */ function freeze(value) {
    if (!devMode()) return value;
    return isPrimitive(value) || (0, $2SBKn.isObservableArray)(value) ? value : Object.freeze(value);
}
/**
 * @internal
 * @hidden
 * Recursively freeze a value (if not in production)
 */ function deepFreeze(value) {
    if (!devMode()) return value;
    freeze(value);
    if (isPlainObject(value)) Object.keys(value).forEach(function(propKey) {
        if (!isPrimitive(value[propKey]) && !Object.isFrozen(value[propKey])) deepFreeze(value[propKey]);
    });
    return value;
}
/**
 * @internal
 * @hidden
 */ function isSerializable(value) {
    return typeof value !== "function";
}
/**
 * @internal
 * @hidden
 */ function defineProperty(object, key, descriptor) {
    (0, $2SBKn.isObservableObject)(object) ? (0, $2SBKn.defineProperty)(object, key, descriptor) : Object.defineProperty(object, key, descriptor);
}
/**
 * @internal
 * @hidden
 */ function addHiddenFinalProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
/**
 * @internal
 * @hidden
 */ function addHiddenWritableProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
/**
 * @internal
 * @hidden
 */ var EventHandler = /** @class */ function() {
    function EventHandler() {
        Object.defineProperty(this, "handlers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
    }
    Object.defineProperty(EventHandler.prototype, "hasSubscribers", {
        get: function() {
            return this.handlers.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventHandler.prototype, "register", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(fn, atTheBeginning) {
            var _this = this;
            if (atTheBeginning === void 0) atTheBeginning = false;
            if (atTheBeginning) this.handlers.unshift(fn);
            else this.handlers.push(fn);
            return function() {
                _this.unregister(fn);
            };
        }
    });
    Object.defineProperty(EventHandler.prototype, "has", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(fn) {
            return this.handlers.indexOf(fn) >= 0;
        }
    });
    Object.defineProperty(EventHandler.prototype, "unregister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(fn) {
            var index = this.handlers.indexOf(fn);
            if (index >= 0) this.handlers.splice(index, 1);
        }
    });
    Object.defineProperty(EventHandler.prototype, "clear", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            this.handlers.length = 0;
        }
    });
    Object.defineProperty(EventHandler.prototype, "emit", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            // make a copy just in case it changes
            var handlers = this.handlers.slice();
            handlers.forEach(function(f) {
                return f.apply(void 0, __spread(args));
            });
        }
    });
    return EventHandler;
}();
/**
 * @internal
 * @hidden
 */ var EventHandlers = /** @class */ function() {
    function EventHandlers() {
        Object.defineProperty(this, "eventHandlers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    Object.defineProperty(EventHandlers.prototype, "hasSubscribers", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(event) {
            var handler = this.eventHandlers && this.eventHandlers[event];
            return !!handler && handler.hasSubscribers;
        }
    });
    Object.defineProperty(EventHandlers.prototype, "register", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(event, fn, atTheBeginning) {
            if (atTheBeginning === void 0) atTheBeginning = false;
            if (!this.eventHandlers) this.eventHandlers = {};
            var handler = this.eventHandlers[event];
            if (!handler) handler = this.eventHandlers[event] = new EventHandler();
            return handler.register(fn, atTheBeginning);
        }
    });
    Object.defineProperty(EventHandlers.prototype, "has", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(event, fn) {
            var handler = this.eventHandlers && this.eventHandlers[event];
            return !!handler && handler.has(fn);
        }
    });
    Object.defineProperty(EventHandlers.prototype, "unregister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(event, fn) {
            var handler = this.eventHandlers && this.eventHandlers[event];
            if (handler) handler.unregister(fn);
        }
    });
    Object.defineProperty(EventHandlers.prototype, "clear", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(event) {
            if (this.eventHandlers) delete this.eventHandlers[event];
        }
    });
    Object.defineProperty(EventHandlers.prototype, "clearAll", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            this.eventHandlers = undefined;
        }
    });
    Object.defineProperty(EventHandlers.prototype, "emit", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(event) {
            var _a;
            var args = [];
            for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
            var handler = this.eventHandlers && this.eventHandlers[event];
            if (handler) (_a = handler).emit.apply(_a, __spread(args));
        }
    });
    return EventHandlers;
}();
/**
 * @internal
 * @hidden
 */ function argsToArray(args) {
    var res = new Array(args.length);
    for(var i = 0; i < args.length; i++)res[i] = args[i];
    return res;
}
/**
 * @internal
 * @hidden
 */ function stringStartsWith(str, beginning) {
    return str.indexOf(beginning) === 0;
}
/**
 * @internal
 * @hidden
 */ var deprecated = function(id, message) {
    // skip if running production
    if (!devMode()) return;
    // warn if hasn't been warned before
    if (deprecated.ids && !deprecated.ids.hasOwnProperty(id)) warnError("Deprecation warning: " + message);
    // mark as warned to avoid duplicate warn message
    if (deprecated.ids) deprecated.ids[id] = true;
};
deprecated.ids = {};
/**
 * @internal
 * @hidden
 */ function warnError(msg) {
    console.warn(new Error("[mobx-state-tree] " + msg));
}
/**
 * @internal
 * @hidden
 */ function isTypeCheckingEnabled() {
    return devMode() || typeof $ibaza !== "undefined" && $ibaza.env && false;
}
/**
 * @internal
 * @hidden
 */ function devMode() {
    return false;
}
/**
 * @internal
 * @hidden
 */ function assertArg(value, fn, typeName, argNumber) {
    if (devMode()) {
        if (!fn(value)) // istanbul ignore next
        throw fail("expected " + typeName + " as argument " + asArray(argNumber).join(" or ") + ", got " + value + " instead");
    }
}
/**
 * @internal
 * @hidden
 */ function assertIsFunction(value, argNumber) {
    assertArg(value, function(fn) {
        return typeof fn === "function";
    }, "function", argNumber);
}
/**
 * @internal
 * @hidden
 */ function assertIsNumber(value, argNumber, min, max) {
    assertArg(value, function(n) {
        return typeof n === "number";
    }, "number", argNumber);
    if (min !== undefined) assertArg(value, function(n) {
        return n >= min;
    }, "number greater than " + min, argNumber);
    if (max !== undefined) assertArg(value, function(n) {
        return n <= max;
    }, "number lesser than " + max, argNumber);
}
/**
 * @internal
 * @hidden
 */ function assertIsString(value, argNumber, canBeEmpty) {
    if (canBeEmpty === void 0) canBeEmpty = true;
    assertArg(value, function(s) {
        return typeof s === "string";
    }, "string", argNumber);
    if (!canBeEmpty) assertArg(value, function(s) {
        return s !== "";
    }, "not empty string", argNumber);
}
/**
 * @internal
 * @hidden
 */ function setImmediateWithFallback(fn) {
    if (typeof queueMicrotask === "function") queueMicrotask(fn);
    else if (typeof setImmediate === "function") setImmediate(fn);
    else setTimeout(fn, 1);
}
/**
 * See [asynchronous actions](concepts/async-actions.md).
 *
 * @returns The flow as a promise.
 */ function flow(generator) {
    return createFlowSpawner(generator.name, generator);
}
/**
 * @deprecated Not needed since TS3.6.
 * Used for TypeScript to make flows that return a promise return the actual promise result.
 *
 * @param val
 * @returns
 */ function castFlowReturn(val) {
    return val;
}
/**
 * @experimental
 * experimental api - might change on minor/patch releases
 *
 * Convert a promise-returning function to a generator-returning one.
 * This is intended to allow for usage of `yield*` in async actions to
 * retain the promise return type.
 *
 * Example:
 * ```ts
 * function getDataAsync(input: string): Promise<number> { ... }
 * const getDataGen = toGeneratorFunction(getDataAsync);
 *
 * const someModel.actions(self => ({
 *   someAction: flow(function*() {
 *     // value is typed as number
 *     const value = yield* getDataGen("input value");
 *     ...
 *   })
 * }))
 * ```
 */ function toGeneratorFunction(p) {
    return function() {
        var _i;
        var args = [];
        for(_i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        p.apply(void 0, __spread(args))
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        _a.sent()
                    ];
            }
        });
    };
}
/**
 * @experimental
 * experimental api - might change on minor/patch releases
 *
 * Convert a promise to a generator yielding that promise
 * This is intended to allow for usage of `yield*` in async actions to
 * retain the promise return type.
 *
 * Example:
 * ```ts
 * function getDataAsync(input: string): Promise<number> { ... }
 *
 * const someModel.actions(self => ({
 *   someAction: flow(function*() {
 *     // value is typed as number
 *     const value = yield* toGenerator(getDataAsync("input value"));
 *     ...
 *   })
 * }))
 * ```
 */ function toGenerator(p) {
    return __generator(this, function(_a) {
        switch(_a.label){
            case 0:
                return [
                    4 /*yield*/ ,
                    p
                ];
            case 1:
                return [
                    2 /*return*/ ,
                    _a.sent()
                ];
        }
    });
}
/**
 * @internal
 * @hidden
 */ function createFlowSpawner(name, generator) {
    var spawner = function flowSpawner() {
        // Implementation based on https://github.com/tj/co/blob/master/index.js
        var runId = getNextActionId();
        var parentContext = getCurrentActionContext();
        if (!parentContext) throw fail("a mst flow must always have a parent context");
        var parentActionContext = getParentActionContext(parentContext);
        if (!parentActionContext) throw fail("a mst flow must always have a parent action context");
        var contextBase = {
            name: name,
            id: runId,
            tree: parentContext.tree,
            context: parentContext.context,
            parentId: parentContext.id,
            allParentIds: __spread(parentContext.allParentIds, [
                parentContext.id
            ]),
            rootId: parentContext.rootId,
            parentEvent: parentContext,
            parentActionEvent: parentActionContext
        };
        var args = arguments;
        function wrap(fn, type, arg) {
            fn.$mst_middleware = spawner.$mst_middleware; // pick up any middleware attached to the flow
            return runWithActionContext(__assign(__assign({}, contextBase), {
                type: type,
                args: [
                    arg
                ]
            }), fn);
        }
        return new Promise(function(resolve, reject) {
            var gen;
            var init = function asyncActionInit() {
                gen = generator.apply(null, arguments);
                onFulfilled(undefined); // kick off the flow
            };
            init.$mst_middleware = spawner.$mst_middleware;
            runWithActionContext(__assign(__assign({}, contextBase), {
                type: "flow_spawn",
                args: argsToArray(args)
            }), init);
            function onFulfilled(res) {
                var ret;
                try {
                    // prettier-ignore
                    var cancelError = wrap(function(r) {
                        ret = gen.next(r);
                    }, "flow_resume", res);
                    if (cancelError instanceof Error) ret = gen.throw(cancelError);
                } catch (e) {
                    // prettier-ignore
                    setImmediateWithFallback(function() {
                        wrap(function(r) {
                            reject(e);
                        }, "flow_throw", e);
                    });
                    return;
                }
                next(ret);
                return;
            }
            function onRejected(err) {
                var ret;
                try {
                    // prettier-ignore
                    wrap(function(r) {
                        ret = gen.throw(r);
                    }, "flow_resume_error", err); // or yieldError?
                } catch (e) {
                    // prettier-ignore
                    setImmediateWithFallback(function() {
                        wrap(function(r) {
                            reject(e);
                        }, "flow_throw", e);
                    });
                    return;
                }
                next(ret);
            }
            function next(ret) {
                if (ret.done) {
                    // prettier-ignore
                    setImmediateWithFallback(function() {
                        wrap(function(r) {
                            resolve(r);
                        }, "flow_return", ret.value);
                    });
                    return;
                }
                // TODO: support more type of values? See https://github.com/tj/co/blob/249bbdc72da24ae44076afd716349d2089b31c4c/index.js#L100
                if (!ret.value || typeof ret.value.then !== "function") // istanbul ignore next
                throw fail("Only promises can be yielded to `async`, got: " + ret);
                return ret.value.then(onFulfilled, onRejected);
            }
        });
    };
    spawner._isFlowAction = true;
    return spawner;
}
/**
 * @internal
 * @hidden
 */ function splitPatch(patch) {
    if (!("oldValue" in patch)) throw fail("Patches without `oldValue` field cannot be inversed");
    return [
        stripPatch(patch),
        invertPatch(patch)
    ];
}
/**
 * @internal
 * @hidden
 */ function stripPatch(patch) {
    // strips `oldvalue` information from the patch, so that it becomes a patch conform the json-patch spec
    // this removes the ability to undo the patch
    switch(patch.op){
        case "add":
            return {
                op: "add",
                path: patch.path,
                value: patch.value
            };
        case "remove":
            return {
                op: "remove",
                path: patch.path
            };
        case "replace":
            return {
                op: "replace",
                path: patch.path,
                value: patch.value
            };
    }
}
function invertPatch(patch) {
    switch(patch.op){
        case "add":
            return {
                op: "remove",
                path: patch.path
            };
        case "remove":
            return {
                op: "add",
                path: patch.path,
                value: patch.oldValue
            };
        case "replace":
            return {
                op: "replace",
                path: patch.path,
                value: patch.oldValue
            };
    }
}
/**
 * Simple simple check to check it is a number.
 */ function isNumber(x) {
    return typeof x === "number";
}
/**
 * Escape slashes and backslashes.
 *
 * http://tools.ietf.org/html/rfc6901
 */ function escapeJsonPath(path) {
    if (isNumber(path) === true) return "" + path;
    if (path.indexOf("/") === -1 && path.indexOf("~") === -1) return path;
    return path.replace(/~/g, "~0").replace(/\//g, "~1");
}
/**
 * Unescape slashes and backslashes.
 */ function unescapeJsonPath(path) {
    return path.replace(/~1/g, "/").replace(/~0/g, "~");
}
/**
 * Generates a json-path compliant json path from path parts.
 *
 * @param path
 * @returns
 */ function joinJsonPath(path) {
    // `/` refers to property with an empty name, while `` refers to root itself!
    if (path.length === 0) return "";
    var getPathStr = function(p) {
        return p.map(escapeJsonPath).join("/");
    };
    if (path[0] === "." || path[0] === "..") // relative
    return getPathStr(path);
    else // absolute
    return "/" + getPathStr(path);
}
/**
 * Splits and decodes a json path into several parts.
 *
 * @param path
 * @returns
 */ function splitJsonPath(path) {
    // `/` refers to property with an empty name, while `` refers to root itself!
    var parts = path.split("/").map(unescapeJsonPath);
    var valid = path === "" || path === "." || path === ".." || stringStartsWith(path, "/") || stringStartsWith(path, "./") || stringStartsWith(path, "../");
    if (!valid) throw fail("a json path must be either rooted, empty or relative, but got '" + path + "'");
    // '/a/b/c' -> ["a", "b", "c"]
    // '../../b/c' -> ["..", "..", "b", "c"]
    // '' -> []
    // '/' -> ['']
    // './a' -> [".", "a"]
    // /./a' -> [".", "a"] equivalent to './a'
    if (parts[0] === "") parts.shift();
    return parts;
}
/** @hidden */ var $preProcessorFailed = Symbol("$preProcessorFailed");
var SnapshotProcessor = /** @class */ function(_super) {
    __extends(SnapshotProcessor, _super);
    function SnapshotProcessor(_subtype, _processors, name) {
        var _this = _super.call(this, name || _subtype.name) || this;
        Object.defineProperty(_this, "_subtype", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _subtype
        });
        Object.defineProperty(_this, "_processors", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _processors
        });
        return _this;
    }
    Object.defineProperty(SnapshotProcessor.prototype, "flags", {
        get: function() {
            return this._subtype.flags | TypeFlags.SnapshotProcessor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SnapshotProcessor.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return "snapshotProcessor(" + this._subtype.describe() + ")";
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "preProcessSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(sn) {
            if (this._processors.preProcessor) return this._processors.preProcessor.call(null, sn);
            return sn;
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "preProcessSnapshotSafe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(sn) {
            try {
                return this.preProcessSnapshot(sn);
            } catch (e) {
                return $preProcessorFailed;
            }
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "postProcessSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(sn, node) {
            if (this._processors.postProcessor) return this._processors.postProcessor.call(null, sn, node.storedValue);
            return sn;
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "_fixNode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node) {
            var _this = this;
            // the node has to use these methods rather than the original type ones
            proxyNodeTypeMethods(node.type, this, "create");
            if (node instanceof ObjectNode) node.hasSnapshotPostProcessor = !!this._processors.postProcessor;
            var oldGetSnapshot = node.getSnapshot;
            node.getSnapshot = function() {
                return _this.postProcessSnapshot(oldGetSnapshot.call(node), node);
            };
            if (!isUnionType(this._subtype)) node.getReconciliationType = function() {
                return _this;
            };
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(parent, subpath, environment, initialValue) {
            var processedInitialValue = isStateTreeNode(initialValue) ? initialValue : this.preProcessSnapshot(initialValue);
            var node = this._subtype.instantiate(parent, subpath, environment, processedInitialValue);
            this._fixNode(node);
            return node;
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(current, newValue, parent, subpath) {
            var node = this._subtype.reconcile(current, isStateTreeNode(newValue) ? newValue : this.preProcessSnapshot(newValue), parent, subpath);
            if (node !== current) this._fixNode(node);
            return node;
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node, applyPostProcess) {
            if (applyPostProcess === void 0) applyPostProcess = true;
            var sn = this._subtype.getSnapshot(node);
            return applyPostProcess ? this.postProcessSnapshot(sn, node) : sn;
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value, context) {
            var processedSn = this.preProcessSnapshotSafe(value);
            if (processedSn === $preProcessorFailed) return typeCheckFailure(context, value, "Failed to preprocess value");
            return this._subtype.validate(processedSn, context);
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "getSubTypes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return this._subtype;
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "is", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(thing) {
            var value = isType(thing) ? this._subtype : isStateTreeNode(thing) ? getSnapshot(thing, false) : this.preProcessSnapshotSafe(thing);
            if (value === $preProcessorFailed) return false;
            return this._subtype.validate(value, [
                {
                    path: "",
                    type: this._subtype
                }
            ]).length === 0;
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "isAssignableFrom", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(type) {
            return this._subtype.isAssignableFrom(type);
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "isMatchingSnapshotId", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(current, snapshot) {
            if (!(this._subtype instanceof ComplexType)) return false;
            var processedSn = this.preProcessSnapshot(snapshot);
            return this._subtype.isMatchingSnapshotId(current, processedSn);
        }
    });
    return SnapshotProcessor;
}(BaseType);
function proxyNodeTypeMethods(nodeType, snapshotProcessorType) {
    var e_1, _a;
    var methods = [];
    for(var _i = 2; _i < arguments.length; _i++)methods[_i - 2] = arguments[_i];
    try {
        for(var methods_1 = __values(methods), methods_1_1 = methods_1.next(); !methods_1_1.done; methods_1_1 = methods_1.next()){
            var method = methods_1_1.value;
            nodeType[method] = snapshotProcessorType[method].bind(snapshotProcessorType);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (methods_1_1 && !methods_1_1.done && (_a = methods_1.return)) _a.call(methods_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
}
/**
 * `types.snapshotProcessor` - Runs a pre/post snapshot processor before/after serializing a given type.
 *
 * Example:
 * ```ts
 * const Todo1 = types.model({ text: types.string })
 * // in the backend the text type must be null when empty
 * interface BackendTodo {
 *     text: string | null
 * }
 *
 * const Todo2 = types.snapshotProcessor(Todo1, {
 *     // from snapshot to instance
 *     preProcessor(snapshot: BackendTodo) {
 *         return {
 *             text: sn.text || "";
 *         }
 *     },
 *
 *     // from instance to snapshot
 *     postProcessor(snapshot, node): BackendTodo {
 *         return {
 *             text: !sn.text ? null : sn.text
 *         }
 *     }
 * })
 * ```
 *
 * @param type Type to run the processors over.
 * @param processors Processors to run.
 * @param name Type name, or undefined to inherit the inner type one.
 * @returns
 */ function snapshotProcessor(type, processors, name) {
    assertIsType(type, 1);
    if (devMode()) {
        if (processors.postProcessor && typeof processors.postProcessor !== "function") // istanbul ignore next
        throw fail("postSnapshotProcessor must be a function");
        if (processors.preProcessor && typeof processors.preProcessor !== "function") // istanbul ignore next
        throw fail("preSnapshotProcessor must be a function");
    }
    return new SnapshotProcessor(type, processors, name);
}
var needsIdentifierError = "Map.put can only be used to store complex values that have an identifier type attribute";
function tryCollectModelTypes(type, modelTypes) {
    var e_1, _a;
    var subtypes = type.getSubTypes();
    if (subtypes === cannotDetermineSubtype) return false;
    if (subtypes) {
        var subtypesArray = asArray(subtypes);
        try {
            for(var subtypesArray_1 = __values(subtypesArray), subtypesArray_1_1 = subtypesArray_1.next(); !subtypesArray_1_1.done; subtypesArray_1_1 = subtypesArray_1.next()){
                var subtype = subtypesArray_1_1.value;
                if (!tryCollectModelTypes(subtype, modelTypes)) return false;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (subtypesArray_1_1 && !subtypesArray_1_1.done && (_a = subtypesArray_1.return)) _a.call(subtypesArray_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    }
    if (type instanceof ModelType) modelTypes.push(type);
    return true;
}
/**
 * @internal
 * @hidden
 */ var MapIdentifierMode;
(function(MapIdentifierMode) {
    MapIdentifierMode[MapIdentifierMode["UNKNOWN"] = 0] = "UNKNOWN";
    MapIdentifierMode[MapIdentifierMode["YES"] = 1] = "YES";
    MapIdentifierMode[MapIdentifierMode["NO"] = 2] = "NO";
})(MapIdentifierMode || (MapIdentifierMode = {}));
var MSTMap = /** @class */ function(_super) {
    __extends(MSTMap, _super);
    function MSTMap(initialData, name) {
        return _super.call(this, initialData, (0, $2SBKn.observable).ref.enhancer, name) || this;
    }
    Object.defineProperty(MSTMap.prototype, "get", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(key) {
            // maybe this is over-enthousiastic? normalize numeric keys to strings
            return _super.prototype.get.call(this, "" + key);
        }
    });
    Object.defineProperty(MSTMap.prototype, "has", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(key) {
            return _super.prototype.has.call(this, "" + key);
        }
    });
    Object.defineProperty(MSTMap.prototype, "delete", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(key) {
            return _super.prototype.delete.call(this, "" + key);
        }
    });
    Object.defineProperty(MSTMap.prototype, "set", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(key, value) {
            return _super.prototype.set.call(this, "" + key, value);
        }
    });
    Object.defineProperty(MSTMap.prototype, "put", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value) {
            if (!value) throw fail("Map.put cannot be used to set empty values");
            if (isStateTreeNode(value)) {
                var node = getStateTreeNode(value);
                if (devMode()) {
                    if (!node.identifierAttribute) throw fail(needsIdentifierError);
                }
                if (node.identifier === null) throw fail(needsIdentifierError);
                this.set(node.identifier, value);
                return value;
            } else if (!isMutable(value)) throw fail("Map.put can only be used to store complex values");
            else {
                var mapNode = getStateTreeNode(this);
                var mapType = mapNode.type;
                if (mapType.identifierMode !== MapIdentifierMode.YES) throw fail(needsIdentifierError);
                var idAttr = mapType.mapIdentifierAttribute;
                var id = value[idAttr];
                if (!isValidIdentifier(id)) {
                    // try again but this time after creating a node for the value
                    // since it might be an optional identifier
                    var newNode = this.put(mapType.getChildType().create(value, mapNode.environment));
                    return this.put(getSnapshot(newNode));
                }
                var key = normalizeIdentifier(id);
                this.set(key, value);
                return this.get(key);
            }
        }
    });
    return MSTMap;
}((0, $2SBKn.ObservableMap));
/**
 * @internal
 * @hidden
 */ var MapType = /** @class */ function(_super) {
    __extends(MapType, _super);
    function MapType(name, _subType, hookInitializers) {
        if (hookInitializers === void 0) hookInitializers = [];
        var _this = _super.call(this, name) || this;
        Object.defineProperty(_this, "_subType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _subType
        });
        Object.defineProperty(_this, "identifierMode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: MapIdentifierMode.UNKNOWN
        });
        Object.defineProperty(_this, "mapIdentifierAttribute", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: undefined
        });
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Map
        });
        Object.defineProperty(_this, "hookInitializers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        _this._determineIdentifierMode();
        _this.hookInitializers = hookInitializers;
        return _this;
    }
    Object.defineProperty(MapType.prototype, "hooks", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(hooks) {
            var hookInitializers = this.hookInitializers.length > 0 ? this.hookInitializers.concat(hooks) : [
                hooks
            ];
            return new MapType(this.name, this._subType, hookInitializers);
        }
    });
    Object.defineProperty(MapType.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(parent, subpath, environment, initialValue) {
            this._determineIdentifierMode();
            return createObjectNode(this, parent, subpath, environment, initialValue);
        }
    });
    Object.defineProperty(MapType.prototype, "_determineIdentifierMode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (this.identifierMode !== MapIdentifierMode.UNKNOWN) return;
            var modelTypes = [];
            if (tryCollectModelTypes(this._subType, modelTypes)) {
                var identifierAttribute = modelTypes.reduce(function(current, type) {
                    if (!type.identifierAttribute) return current;
                    if (current && current !== type.identifierAttribute) throw fail("The objects in a map should all have the same identifier attribute, expected '" + current + "', but child of type '" + type.name + "' declared attribute '" + type.identifierAttribute + "' as identifier");
                    return type.identifierAttribute;
                }, undefined);
                if (identifierAttribute) {
                    this.identifierMode = MapIdentifierMode.YES;
                    this.mapIdentifierAttribute = identifierAttribute;
                } else this.identifierMode = MapIdentifierMode.NO;
            }
        }
    });
    Object.defineProperty(MapType.prototype, "initializeChildNodes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(objNode, initialSnapshot) {
            if (initialSnapshot === void 0) initialSnapshot = {};
            var subType = objNode.type._subType;
            var result = {};
            Object.keys(initialSnapshot).forEach(function(name) {
                result[name] = subType.instantiate(objNode, name, undefined, initialSnapshot[name]);
            });
            return result;
        }
    });
    Object.defineProperty(MapType.prototype, "createNewInstance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(childNodes) {
            return new MSTMap(childNodes, this.name);
        }
    });
    Object.defineProperty(MapType.prototype, "finalizeNewInstance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node, instance) {
            (0, $2SBKn._interceptReads)(instance, node.unbox);
            var type = node.type;
            type.hookInitializers.forEach(function(initializer) {
                var hooks = initializer(instance);
                Object.keys(hooks).forEach(function(name) {
                    var hook = hooks[name];
                    var actionInvoker = createActionInvoker(instance, name, hook);
                    (!devMode() ? addHiddenFinalProp : addHiddenWritableProp)(instance, name, actionInvoker);
                });
            });
            (0, $2SBKn.intercept)(instance, this.willChange);
            (0, $2SBKn.observe)(instance, this.didChange);
        }
    });
    Object.defineProperty(MapType.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return this.name;
        }
    });
    Object.defineProperty(MapType.prototype, "getChildren", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node) {
            // return (node.storedValue as ObservableMap<any>).values()
            return (0, $2SBKn.values)(node.storedValue);
        }
    });
    Object.defineProperty(MapType.prototype, "getChildNode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node, key) {
            var childNode = node.storedValue.get("" + key);
            if (!childNode) throw fail("Not a child " + key);
            return childNode;
        }
    });
    Object.defineProperty(MapType.prototype, "willChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(change) {
            var node = getStateTreeNode(change.object);
            var key = change.name;
            node.assertWritable({
                subpath: key
            });
            var mapType = node.type;
            var subType = mapType._subType;
            switch(change.type){
                case "update":
                    var newValue = change.newValue;
                    var oldValue = change.object.get(key);
                    if (newValue === oldValue) return null;
                    typecheckInternal(subType, newValue);
                    change.newValue = subType.reconcile(node.getChildNode(key), change.newValue, node, key);
                    mapType.processIdentifier(key, change.newValue);
                    break;
                case "add":
                    typecheckInternal(subType, change.newValue);
                    change.newValue = subType.instantiate(node, key, undefined, change.newValue);
                    mapType.processIdentifier(key, change.newValue);
                    break;
            }
            return change;
        }
    });
    Object.defineProperty(MapType.prototype, "processIdentifier", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(expected, node) {
            if (this.identifierMode === MapIdentifierMode.YES && node instanceof ObjectNode) {
                var identifier = node.identifier;
                if (identifier !== expected) throw fail("A map of objects containing an identifier should always store the object under their own identifier. Trying to store key '" + identifier + "', but expected: '" + expected + "'");
            }
        }
    });
    Object.defineProperty(MapType.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node) {
            var res = {};
            node.getChildren().forEach(function(childNode) {
                res[childNode.subpath] = childNode.snapshot;
            });
            return res;
        }
    });
    Object.defineProperty(MapType.prototype, "processInitialSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(childNodes) {
            var processed = {};
            Object.keys(childNodes).forEach(function(key) {
                processed[key] = childNodes[key].getSnapshot();
            });
            return processed;
        }
    });
    Object.defineProperty(MapType.prototype, "didChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(change) {
            var node = getStateTreeNode(change.object);
            switch(change.type){
                case "update":
                    return void node.emitPatch({
                        op: "replace",
                        path: escapeJsonPath(change.name),
                        value: change.newValue.snapshot,
                        oldValue: change.oldValue ? change.oldValue.snapshot : undefined
                    }, node);
                case "add":
                    return void node.emitPatch({
                        op: "add",
                        path: escapeJsonPath(change.name),
                        value: change.newValue.snapshot,
                        oldValue: undefined
                    }, node);
                case "delete":
                    // a node got deleted, get the old snapshot and make the node die
                    var oldSnapshot = change.oldValue.snapshot;
                    change.oldValue.die();
                    // emit the patch
                    return void node.emitPatch({
                        op: "remove",
                        path: escapeJsonPath(change.name),
                        oldValue: oldSnapshot
                    }, node);
            }
        }
    });
    Object.defineProperty(MapType.prototype, "applyPatchLocally", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node, subpath, patch) {
            var target = node.storedValue;
            switch(patch.op){
                case "add":
                case "replace":
                    target.set(subpath, patch.value);
                    break;
                case "remove":
                    target.delete(subpath);
                    break;
            }
        }
    });
    Object.defineProperty(MapType.prototype, "applySnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node, snapshot) {
            typecheckInternal(this, snapshot);
            var target = node.storedValue;
            var currentKeys = {};
            Array.from(target.keys()).forEach(function(key) {
                currentKeys[key] = false;
            });
            if (snapshot) // Don't use target.replace, as it will throw away all existing items first
            for(var key in snapshot){
                target.set(key, snapshot[key]);
                currentKeys["" + key] = true;
            }
            Object.keys(currentKeys).forEach(function(key) {
                if (currentKeys[key] === false) target.delete(key);
            });
        }
    });
    Object.defineProperty(MapType.prototype, "getChildType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return this._subType;
        }
    });
    Object.defineProperty(MapType.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value, context) {
            var _this = this;
            if (!isPlainObject(value)) return typeCheckFailure(context, value, "Value is not a plain object");
            return flattenTypeErrors(Object.keys(value).map(function(path) {
                return _this._subType.validate(value[path], getContextForPath(context, path, _this._subType));
            }));
        }
    });
    Object.defineProperty(MapType.prototype, "getDefaultSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return EMPTY_OBJECT;
        }
    });
    Object.defineProperty(MapType.prototype, "removeChild", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node, subpath) {
            node.storedValue.delete(subpath);
        }
    });
    return MapType;
}(ComplexType);
MapType.prototype.applySnapshot = (0, $2SBKn.action)(MapType.prototype.applySnapshot);
/**
 * `types.map` - Creates a key based collection type who's children are all of a uniform declared type.
 * If the type stored in a map has an identifier, it is mandatory to store the child under that identifier in the map.
 *
 * This type will always produce [observable maps](https://mobx.js.org/api.html#observablemap)
 *
 * Example:
 * ```ts
 * const Todo = types.model({
 *   id: types.identifier,
 *   task: types.string
 * })
 *
 * const TodoStore = types.model({
 *   todos: types.map(Todo)
 * })
 *
 * const s = TodoStore.create({ todos: {} })
 * unprotect(s)
 * s.todos.set(17, { task: "Grab coffee", id: 17 })
 * s.todos.put({ task: "Grab cookie", id: 18 }) // put will infer key from the identifier
 * console.log(s.todos.get(17).task) // prints: "Grab coffee"
 * ```
 *
 * @param subtype
 * @returns
 */ function map(subtype) {
    return new MapType("Map<string, " + subtype.name + ">", subtype);
}
/**
 * Returns if a given value represents a map type.
 *
 * @param type
 * @returns `true` if it is a map type.
 */ function isMapType(type) {
    return isType(type) && (type.flags & TypeFlags.Map) > 0;
}
/**
 * @internal
 * @hidden
 */ var ArrayType = /** @class */ function(_super) {
    __extends(ArrayType, _super);
    function ArrayType(name, _subType, hookInitializers) {
        if (hookInitializers === void 0) hookInitializers = [];
        var _this = _super.call(this, name) || this;
        Object.defineProperty(_this, "_subType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _subType
        });
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Array
        });
        Object.defineProperty(_this, "hookInitializers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        _this.hookInitializers = hookInitializers;
        return _this;
    }
    Object.defineProperty(ArrayType.prototype, "hooks", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(hooks) {
            var hookInitializers = this.hookInitializers.length > 0 ? this.hookInitializers.concat(hooks) : [
                hooks
            ];
            return new ArrayType(this.name, this._subType, hookInitializers);
        }
    });
    Object.defineProperty(ArrayType.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(parent, subpath, environment, initialValue) {
            return createObjectNode(this, parent, subpath, environment, initialValue);
        }
    });
    Object.defineProperty(ArrayType.prototype, "initializeChildNodes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(objNode, snapshot) {
            if (snapshot === void 0) snapshot = [];
            var subType = objNode.type._subType;
            var result = {};
            snapshot.forEach(function(item, index) {
                var subpath = "" + index;
                result[subpath] = subType.instantiate(objNode, subpath, undefined, item);
            });
            return result;
        }
    });
    Object.defineProperty(ArrayType.prototype, "createNewInstance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(childNodes) {
            var options = __assign(__assign({}, mobxShallow), {
                name: this.name
            });
            return (0, $2SBKn.observable).array(convertChildNodesToArray(childNodes), options);
        }
    });
    Object.defineProperty(ArrayType.prototype, "finalizeNewInstance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node, instance) {
            (0, $2SBKn._getAdministration)(instance).dehancer = node.unbox;
            var type = node.type;
            type.hookInitializers.forEach(function(initializer) {
                var hooks = initializer(instance);
                Object.keys(hooks).forEach(function(name) {
                    var hook = hooks[name];
                    var actionInvoker = createActionInvoker(instance, name, hook);
                    (!devMode() ? addHiddenFinalProp : addHiddenWritableProp)(instance, name, actionInvoker);
                });
            });
            (0, $2SBKn.intercept)(instance, this.willChange);
            (0, $2SBKn.observe)(instance, this.didChange);
        }
    });
    Object.defineProperty(ArrayType.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return this.name;
        }
    });
    Object.defineProperty(ArrayType.prototype, "getChildren", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node) {
            return node.storedValue.slice();
        }
    });
    Object.defineProperty(ArrayType.prototype, "getChildNode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node, key) {
            var index = Number(key);
            if (index < node.storedValue.length) return node.storedValue[index];
            throw fail("Not a child: " + key);
        }
    });
    Object.defineProperty(ArrayType.prototype, "willChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(change) {
            var node = getStateTreeNode(change.object);
            node.assertWritable({
                subpath: "" + change.index
            });
            var subType = node.type._subType;
            var childNodes = node.getChildren();
            switch(change.type){
                case "update":
                    if (change.newValue === change.object[change.index]) return null;
                    var updatedNodes = reconcileArrayChildren(node, subType, [
                        childNodes[change.index]
                    ], [
                        change.newValue
                    ], [
                        change.index
                    ]);
                    if (!updatedNodes) return null;
                    change.newValue = updatedNodes[0];
                    break;
                case "splice":
                    var index_1 = change.index, removedCount = change.removedCount, added = change.added;
                    var addedNodes = reconcileArrayChildren(node, subType, childNodes.slice(index_1, index_1 + removedCount), added, added.map(function(_, i) {
                        return index_1 + i;
                    }));
                    if (!addedNodes) return null;
                    change.added = addedNodes;
                    // update paths of remaining items
                    for(var i = index_1 + removedCount; i < childNodes.length; i++)childNodes[i].setParent(node, "" + (i + added.length - removedCount));
                    break;
            }
            return change;
        }
    });
    Object.defineProperty(ArrayType.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node) {
            return node.getChildren().map(function(childNode) {
                return childNode.snapshot;
            });
        }
    });
    Object.defineProperty(ArrayType.prototype, "processInitialSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(childNodes) {
            var processed = [];
            Object.keys(childNodes).forEach(function(key) {
                processed.push(childNodes[key].getSnapshot());
            });
            return processed;
        }
    });
    Object.defineProperty(ArrayType.prototype, "didChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(change) {
            var node = getStateTreeNode(change.object);
            switch(change.type){
                case "update":
                    return void node.emitPatch({
                        op: "replace",
                        path: "" + change.index,
                        value: change.newValue.snapshot,
                        oldValue: change.oldValue ? change.oldValue.snapshot : undefined
                    }, node);
                case "splice":
                    for(var i = change.removedCount - 1; i >= 0; i--)node.emitPatch({
                        op: "remove",
                        path: "" + (change.index + i),
                        oldValue: change.removed[i].snapshot
                    }, node);
                    for(var i = 0; i < change.addedCount; i++)node.emitPatch({
                        op: "add",
                        path: "" + (change.index + i),
                        value: node.getChildNode("" + (change.index + i)).snapshot,
                        oldValue: undefined
                    }, node);
                    return;
            }
        }
    });
    Object.defineProperty(ArrayType.prototype, "applyPatchLocally", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node, subpath, patch) {
            var target = node.storedValue;
            var index = subpath === "-" ? target.length : Number(subpath);
            switch(patch.op){
                case "replace":
                    target[index] = patch.value;
                    break;
                case "add":
                    target.splice(index, 0, patch.value);
                    break;
                case "remove":
                    target.splice(index, 1);
                    break;
            }
        }
    });
    Object.defineProperty(ArrayType.prototype, "applySnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node, snapshot) {
            typecheckInternal(this, snapshot);
            var target = node.storedValue;
            target.replace(snapshot);
        }
    });
    Object.defineProperty(ArrayType.prototype, "getChildType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return this._subType;
        }
    });
    Object.defineProperty(ArrayType.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value, context) {
            var _this = this;
            if (!isArray(value)) return typeCheckFailure(context, value, "Value is not an array");
            return flattenTypeErrors(value.map(function(item, index) {
                return _this._subType.validate(item, getContextForPath(context, "" + index, _this._subType));
            }));
        }
    });
    Object.defineProperty(ArrayType.prototype, "getDefaultSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return EMPTY_ARRAY;
        }
    });
    Object.defineProperty(ArrayType.prototype, "removeChild", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node, subpath) {
            node.storedValue.splice(Number(subpath), 1);
        }
    });
    return ArrayType;
}(ComplexType);
ArrayType.prototype.applySnapshot = (0, $2SBKn.action)(ArrayType.prototype.applySnapshot);
/**
 * `types.array` - Creates an index based collection type who's children are all of a uniform declared type.
 *
 * This type will always produce [observable arrays](https://mobx.js.org/api.html#observablearray)
 *
 * Example:
 * ```ts
 * const Todo = types.model({
 *   task: types.string
 * })
 *
 * const TodoStore = types.model({
 *   todos: types.array(Todo)
 * })
 *
 * const s = TodoStore.create({ todos: [] })
 * unprotect(s) // needed to allow modifying outside of an action
 * s.todos.push({ task: "Grab coffee" })
 * console.log(s.todos[0]) // prints: "Grab coffee"
 * ```
 *
 * @param subtype
 * @returns
 */ function array(subtype) {
    assertIsType(subtype, 1);
    return new ArrayType(subtype.name + "[]", subtype);
}
function reconcileArrayChildren(parent, childType, oldNodes, newValues, newPaths) {
    var nothingChanged = true;
    for(var i = 0;; i++){
        var hasNewNode = i <= newValues.length - 1;
        var oldNode = oldNodes[i];
        var newValue = hasNewNode ? newValues[i] : undefined;
        var newPath = "" + newPaths[i];
        // for some reason, instead of newValue we got a node, fallback to the storedValue
        // TODO: https://github.com/mobxjs/mobx-state-tree/issues/340#issuecomment-325581681
        if (isNode(newValue)) newValue = newValue.storedValue;
        if (!oldNode && !hasNewNode) break;
        else if (!hasNewNode) {
            // new one does not exists
            nothingChanged = false;
            oldNodes.splice(i, 1);
            if (oldNode instanceof ObjectNode) // since it is going to be returned by pop/splice/shift better create it before killing it
            // so it doesn't end up in an undead state
            oldNode.createObservableInstanceIfNeeded();
            oldNode.die();
            i--;
        } else if (!oldNode) {
            // there is no old node, create it
            // check if already belongs to the same parent. if so, avoid pushing item in. only swapping can occur.
            if (isStateTreeNode(newValue) && getStateTreeNode(newValue).parent === parent) // this node is owned by this parent, but not in the reconcilable set, so it must be double
            throw fail("Cannot add an object to a state tree if it is already part of the same or another state tree. Tried to assign an object to '" + parent.path + "/" + newPath + "', but it lives already at '" + getStateTreeNode(newValue).path + "'");
            nothingChanged = false;
            var newNode = valueAsNode(childType, parent, newPath, newValue);
            oldNodes.splice(i, 0, newNode);
        } else if (areSame(oldNode, newValue)) // both are the same, reconcile
        oldNodes[i] = valueAsNode(childType, parent, newPath, newValue, oldNode);
        else {
            // nothing to do, try to reorder
            var oldMatch = undefined;
            // find a possible candidate to reuse
            for(var j = i; j < oldNodes.length; j++)if (areSame(oldNodes[j], newValue)) {
                oldMatch = oldNodes.splice(j, 1)[0];
                break;
            }
            nothingChanged = false;
            var newNode = valueAsNode(childType, parent, newPath, newValue, oldMatch);
            oldNodes.splice(i, 0, newNode);
        }
    }
    return nothingChanged ? null : oldNodes;
}
/**
 * Convert a value to a node at given parent and subpath. Attempts to reuse old node if possible and given.
 */ function valueAsNode(childType, parent, subpath, newValue, oldNode) {
    // ensure the value is valid-ish
    typecheckInternal(childType, newValue);
    function getNewNode() {
        // the new value has a MST node
        if (isStateTreeNode(newValue)) {
            var childNode = getStateTreeNode(newValue);
            childNode.assertAlive(EMPTY_OBJECT);
            // the node lives here
            if (childNode.parent !== null && childNode.parent === parent) {
                childNode.setParent(parent, subpath);
                return childNode;
            }
        }
        // there is old node and new one is a value/snapshot
        if (oldNode) return childType.reconcile(oldNode, newValue, parent, subpath);
        // nothing to do, create from scratch
        return childType.instantiate(parent, subpath, undefined, newValue);
    }
    var newNode = getNewNode();
    if (oldNode && oldNode !== newNode) {
        if (oldNode instanceof ObjectNode) // since it is going to be returned by pop/splice/shift better create it before killing it
        // so it doesn't end up in an undead state
        oldNode.createObservableInstanceIfNeeded();
        oldNode.die();
    }
    return newNode;
}
/**
 * Check if a node holds a value.
 */ function areSame(oldNode, newValue) {
    // never consider dead old nodes for reconciliation
    if (!oldNode.isAlive) return false;
    // the new value has the same node
    if (isStateTreeNode(newValue)) {
        var newNode = getStateTreeNode(newValue);
        return newNode.isAlive && newNode === oldNode;
    }
    // the provided value is the snapshot of the old node
    if (oldNode.snapshot === newValue) return true;
    // Non object nodes don't get reconciled
    if (!(oldNode instanceof ObjectNode)) return false;
    var oldNodeType = oldNode.getReconciliationType();
    // new value is a snapshot with the correct identifier
    return oldNode.identifier !== null && oldNode.identifierAttribute && isPlainObject(newValue) && oldNodeType.is(newValue) && oldNodeType.isMatchingSnapshotId(oldNode, newValue);
}
/**
 * Returns if a given value represents an array type.
 *
 * @param type
 * @returns `true` if the type is an array type.
 */ function isArrayType(type) {
    return isType(type) && (type.flags & TypeFlags.Array) > 0;
}
var PRE_PROCESS_SNAPSHOT = "preProcessSnapshot";
var POST_PROCESS_SNAPSHOT = "postProcessSnapshot";
function objectTypeToString() {
    return getStateTreeNode(this).toString();
}
var defaultObjectOptions = {
    name: "AnonymousModel",
    properties: {},
    initializers: EMPTY_ARRAY
};
function toPropertiesObject(declaredProps) {
    var keysList = Object.keys(declaredProps);
    var alreadySeenKeys = new Set();
    keysList.forEach(function(key) {
        if (alreadySeenKeys.has(key)) throw fail(key + " is declared twice in the model. Model should not contain the same keys");
        alreadySeenKeys.add(key);
    });
    // loop through properties and ensures that all items are types
    return keysList.reduce(function(props, key) {
        // warn if user intended a HOOK
        if (key in Hook) throw fail("Hook '" + key + "' was defined as property. Hooks should be defined as part of the actions");
        // the user intended to use a view
        var descriptor = Object.getOwnPropertyDescriptor(declaredProps, key);
        if ("get" in descriptor) throw fail("Getters are not supported as properties. Please use views instead");
        // undefined and null are not valid
        var value = descriptor.value;
        if (value === null || value === undefined) throw fail("The default value of an attribute cannot be null or undefined as the type cannot be inferred. Did you mean `types.maybe(someType)`?");
        else if (isPrimitive(value)) props[key] = optional(getPrimitiveFactoryFromValue(value), value);
        else if (value instanceof MapType) props[key] = optional(value, {});
        else if (value instanceof ArrayType) props[key] = optional(value, []);
        else if (isType(value)) ;
        else if (devMode() && typeof value === "function") throw fail("Invalid type definition for property '" + key + "', it looks like you passed a function. Did you forget to invoke it, or did you intend to declare a view / action?");
        else if (devMode() && typeof value === "object") throw fail("Invalid type definition for property '" + key + "', it looks like you passed an object. Try passing another model type or a types.frozen.");
        else throw fail("Invalid type definition for property '" + key + "', cannot infer a type from a value like '" + value + "' (" + typeof value + ")");
        return props;
    }, declaredProps);
}
/**
 * @internal
 * @hidden
 */ var ModelType = /** @class */ function(_super) {
    __extends(ModelType, _super);
    function ModelType(opts) {
        var _this = _super.call(this, opts.name || defaultObjectOptions.name) || this;
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Object
        });
        /*
         * The original object definition
         */ Object.defineProperty(_this, "initializers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "properties", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "preProcessor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "postProcessor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "propertyNames", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "named", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function(name) {
                return _this.cloneAndEnhance({
                    name: name
                });
            }
        });
        Object.defineProperty(_this, "props", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function(properties) {
                return _this.cloneAndEnhance({
                    properties: properties
                });
            }
        });
        Object.defineProperty(_this, "preProcessSnapshot", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function(preProcessor) {
                var currentPreprocessor = _this.preProcessor;
                if (!currentPreprocessor) return _this.cloneAndEnhance({
                    preProcessor: preProcessor
                });
                else return _this.cloneAndEnhance({
                    preProcessor: function(snapshot) {
                        return currentPreprocessor(preProcessor(snapshot));
                    }
                });
            }
        });
        Object.defineProperty(_this, "postProcessSnapshot", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function(postProcessor) {
                var currentPostprocessor = _this.postProcessor;
                if (!currentPostprocessor) return _this.cloneAndEnhance({
                    postProcessor: postProcessor
                });
                else return _this.cloneAndEnhance({
                    postProcessor: function(snapshot) {
                        return postProcessor(currentPostprocessor(snapshot));
                    }
                });
            }
        });
        Object.assign(_this, defaultObjectOptions, opts);
        // ensures that any default value gets converted to its related type
        _this.properties = toPropertiesObject(_this.properties);
        freeze(_this.properties); // make sure nobody messes with it
        _this.propertyNames = Object.keys(_this.properties);
        _this.identifierAttribute = _this._getIdentifierAttribute();
        return _this;
    }
    Object.defineProperty(ModelType.prototype, "_getIdentifierAttribute", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            var identifierAttribute = undefined;
            this.forAllProps(function(propName, propType) {
                if (propType.flags & TypeFlags.Identifier) {
                    if (identifierAttribute) throw fail("Cannot define property '" + propName + "' as object identifier, property '" + identifierAttribute + "' is already defined as identifier property");
                    identifierAttribute = propName;
                }
            });
            return identifierAttribute;
        }
    });
    Object.defineProperty(ModelType.prototype, "cloneAndEnhance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(opts) {
            return new ModelType({
                name: opts.name || this.name,
                properties: Object.assign({}, this.properties, opts.properties),
                initializers: this.initializers.concat(opts.initializers || []),
                preProcessor: opts.preProcessor || this.preProcessor,
                postProcessor: opts.postProcessor || this.postProcessor
            });
        }
    });
    Object.defineProperty(ModelType.prototype, "actions", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(fn) {
            var _this = this;
            var actionInitializer = function(self) {
                _this.instantiateActions(self, fn(self));
                return self;
            };
            return this.cloneAndEnhance({
                initializers: [
                    actionInitializer
                ]
            });
        }
    });
    Object.defineProperty(ModelType.prototype, "instantiateActions", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(self, actions) {
            // check if return is correct
            if (!isPlainObject(actions)) throw fail("actions initializer should return a plain object containing actions");
            // bind actions to the object created
            Object.keys(actions).forEach(function(name) {
                // warn if preprocessor was given
                if (name === PRE_PROCESS_SNAPSHOT) throw fail("Cannot define action '" + PRE_PROCESS_SNAPSHOT + "', it should be defined using 'type.preProcessSnapshot(fn)' instead");
                // warn if postprocessor was given
                if (name === POST_PROCESS_SNAPSHOT) throw fail("Cannot define action '" + POST_PROCESS_SNAPSHOT + "', it should be defined using 'type.postProcessSnapshot(fn)' instead");
                var action2 = actions[name];
                // apply hook composition
                var baseAction = self[name];
                if (name in Hook && baseAction) {
                    var specializedAction_1 = action2;
                    action2 = function() {
                        baseAction.apply(null, arguments);
                        specializedAction_1.apply(null, arguments);
                    };
                }
                // the goal of this is to make sure actions using "this" can call themselves,
                // while still allowing the middlewares to register them
                var middlewares = action2.$mst_middleware; // make sure middlewares are not lost
                var boundAction = action2.bind(actions);
                boundAction._isFlowAction = action2._isFlowAction || false;
                boundAction.$mst_middleware = middlewares;
                var actionInvoker = createActionInvoker(self, name, boundAction);
                actions[name] = actionInvoker;
                (!devMode() ? addHiddenFinalProp : addHiddenWritableProp)(self, name, actionInvoker);
            });
        }
    });
    Object.defineProperty(ModelType.prototype, "volatile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(fn) {
            var _this = this;
            if (typeof fn !== "function") throw fail("You passed an " + typeof fn + " to volatile state as an argument, when function is expected");
            var stateInitializer = function(self) {
                _this.instantiateVolatileState(self, fn(self));
                return self;
            };
            return this.cloneAndEnhance({
                initializers: [
                    stateInitializer
                ]
            });
        }
    });
    Object.defineProperty(ModelType.prototype, "instantiateVolatileState", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(self, state) {
            // check views return
            if (!isPlainObject(state)) throw fail("volatile state initializer should return a plain object containing state");
            (0, $2SBKn.set)(self, state);
        }
    });
    Object.defineProperty(ModelType.prototype, "extend", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(fn) {
            var _this = this;
            var initializer = function(self) {
                var _a = fn(self), actions = _a.actions, views = _a.views, state = _a.state, rest = __rest(_a, [
                    "actions",
                    "views",
                    "state"
                ]);
                for(var key in rest)throw fail("The `extend` function should return an object with a subset of the fields 'actions', 'views' and 'state'. Found invalid key '" + key + "'");
                if (state) _this.instantiateVolatileState(self, state);
                if (views) _this.instantiateViews(self, views);
                if (actions) _this.instantiateActions(self, actions);
                return self;
            };
            return this.cloneAndEnhance({
                initializers: [
                    initializer
                ]
            });
        }
    });
    Object.defineProperty(ModelType.prototype, "views", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(fn) {
            var _this = this;
            var viewInitializer = function(self) {
                _this.instantiateViews(self, fn(self));
                return self;
            };
            return this.cloneAndEnhance({
                initializers: [
                    viewInitializer
                ]
            });
        }
    });
    Object.defineProperty(ModelType.prototype, "instantiateViews", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(self, views) {
            // check views return
            if (!isPlainObject(views)) throw fail("views initializer should return a plain object containing views");
            Object.getOwnPropertyNames(views).forEach(function(key) {
                var _a;
                // is this a computed property?
                var descriptor = Object.getOwnPropertyDescriptor(views, key);
                if ("get" in descriptor) {
                    (0, $2SBKn.defineProperty)(self, key, descriptor);
                    (0, $2SBKn.makeObservable)(self, (_a = {}, _a[key] = (0, $2SBKn.computed), _a));
                } else if (typeof descriptor.value === "function") (!devMode() ? addHiddenFinalProp : addHiddenWritableProp)(self, key, descriptor.value);
                else throw fail("A view member should either be a function or getter based property");
            });
        }
    });
    Object.defineProperty(ModelType.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(parent, subpath, environment, initialValue) {
            var value = isStateTreeNode(initialValue) ? initialValue : this.applySnapshotPreProcessor(initialValue);
            return createObjectNode(this, parent, subpath, environment, value);
        // Optimization: record all prop- view- and action names after first construction, and generate an optimal base class
        // that pre-reserves all these fields for fast object-member lookups
        }
    });
    Object.defineProperty(ModelType.prototype, "initializeChildNodes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(objNode, initialSnapshot) {
            if (initialSnapshot === void 0) initialSnapshot = {};
            var type = objNode.type;
            var result = {};
            type.forAllProps(function(name, childType) {
                result[name] = childType.instantiate(objNode, name, undefined, initialSnapshot[name]);
            });
            return result;
        }
    });
    Object.defineProperty(ModelType.prototype, "createNewInstance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(childNodes) {
            var options = __assign(__assign({}, mobxShallow), {
                name: this.name
            });
            return (0, $2SBKn.observable).object(childNodes, EMPTY_OBJECT, options);
        }
    });
    Object.defineProperty(ModelType.prototype, "finalizeNewInstance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node, instance) {
            addHiddenFinalProp(instance, "toString", objectTypeToString);
            this.forAllProps(function(name) {
                (0, $2SBKn._interceptReads)(instance, name, node.unbox);
            });
            this.initializers.reduce(function(self, fn) {
                return fn(self);
            }, instance);
            (0, $2SBKn.intercept)(instance, this.willChange);
            (0, $2SBKn.observe)(instance, this.didChange);
        }
    });
    Object.defineProperty(ModelType.prototype, "willChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(chg) {
            // TODO: mobx typings don't seem to take into account that newValue can be set even when removing a prop
            var change = chg;
            var node = getStateTreeNode(change.object);
            var subpath = change.name;
            node.assertWritable({
                subpath: subpath
            });
            var childType = node.type.properties[subpath];
            // only properties are typed, state are stored as-is references
            if (childType) {
                typecheckInternal(childType, change.newValue);
                change.newValue = childType.reconcile(node.getChildNode(subpath), change.newValue, node, subpath);
            }
            return change;
        }
    });
    Object.defineProperty(ModelType.prototype, "didChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(chg) {
            // TODO: mobx typings don't seem to take into account that newValue can be set even when removing a prop
            var change = chg;
            var childNode = getStateTreeNode(change.object);
            var childType = childNode.type.properties[change.name];
            if (!childType) // don't emit patches for volatile state
            return;
            var oldChildValue = change.oldValue ? change.oldValue.snapshot : undefined;
            childNode.emitPatch({
                op: "replace",
                path: escapeJsonPath(change.name),
                value: change.newValue.snapshot,
                oldValue: oldChildValue
            }, childNode);
        }
    });
    Object.defineProperty(ModelType.prototype, "getChildren", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node) {
            var _this = this;
            var res = [];
            this.forAllProps(function(name) {
                res.push(_this.getChildNode(node, name));
            });
            return res;
        }
    });
    Object.defineProperty(ModelType.prototype, "getChildNode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node, key) {
            var _a;
            if (!(key in this.properties)) throw fail("Not a value property: " + key);
            var adm = (0, $2SBKn._getAdministration)(node.storedValue, key);
            var childNode = (_a = adm.raw) === null || _a === void 0 ? void 0 : _a.call(adm);
            if (!childNode) throw fail("Node not available for property " + key);
            return childNode;
        }
    });
    Object.defineProperty(ModelType.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node, applyPostProcess) {
            var _this = this;
            if (applyPostProcess === void 0) applyPostProcess = true;
            var res = {};
            this.forAllProps(function(name, type) {
                try {
                    // TODO: FIXME, make sure the observable ref is used!
                    var atom = (0, $2SBKn.getAtom)(node.storedValue, name);
                    atom.reportObserved();
                } catch (e) {
                    throw fail(name + " property is declared twice");
                }
                res[name] = _this.getChildNode(node, name).snapshot;
            });
            if (applyPostProcess) return this.applySnapshotPostProcessor(res);
            return res;
        }
    });
    Object.defineProperty(ModelType.prototype, "processInitialSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(childNodes) {
            var processed = {};
            Object.keys(childNodes).forEach(function(key) {
                processed[key] = childNodes[key].getSnapshot();
            });
            return this.applySnapshotPostProcessor(processed);
        }
    });
    Object.defineProperty(ModelType.prototype, "applyPatchLocally", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node, subpath, patch) {
            if (!(patch.op === "replace" || patch.op === "add")) throw fail("object does not support operation " + patch.op);
            node.storedValue[subpath] = patch.value;
        }
    });
    Object.defineProperty(ModelType.prototype, "applySnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node, snapshot) {
            typecheckInternal(this, snapshot);
            var preProcessedSnapshot = this.applySnapshotPreProcessor(snapshot);
            this.forAllProps(function(name) {
                node.storedValue[name] = preProcessedSnapshot[name];
            });
        }
    });
    Object.defineProperty(ModelType.prototype, "applySnapshotPreProcessor", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(snapshot) {
            var processor = this.preProcessor;
            return processor ? processor.call(null, snapshot) : snapshot;
        }
    });
    Object.defineProperty(ModelType.prototype, "applySnapshotPostProcessor", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(snapshot) {
            var postProcessor = this.postProcessor;
            if (postProcessor) return postProcessor.call(null, snapshot);
            return snapshot;
        }
    });
    Object.defineProperty(ModelType.prototype, "getChildType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(propertyName) {
            assertIsString(propertyName, 1);
            return this.properties[propertyName];
        }
    });
    Object.defineProperty(ModelType.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value, context) {
            var _this = this;
            var snapshot = this.applySnapshotPreProcessor(value);
            if (!isPlainObject(snapshot)) return typeCheckFailure(context, snapshot, "Value is not a plain object");
            return flattenTypeErrors(this.propertyNames.map(function(key) {
                return _this.properties[key].validate(snapshot[key], getContextForPath(context, key, _this.properties[key]));
            }));
        }
    });
    Object.defineProperty(ModelType.prototype, "forAllProps", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(fn) {
            var _this = this;
            this.propertyNames.forEach(function(key) {
                return fn(key, _this.properties[key]);
            });
        }
    });
    Object.defineProperty(ModelType.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            var _this = this;
            // optimization: cache
            return "{ " + this.propertyNames.map(function(key) {
                return key + ": " + _this.properties[key].describe();
            }).join("; ") + " }";
        }
    });
    Object.defineProperty(ModelType.prototype, "getDefaultSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return EMPTY_OBJECT;
        }
    });
    Object.defineProperty(ModelType.prototype, "removeChild", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node, subpath) {
            node.storedValue[subpath] = undefined;
        }
    });
    return ModelType;
}(ComplexType);
ModelType.prototype.applySnapshot = (0, $2SBKn.action)(ModelType.prototype.applySnapshot);
/**
 * `types.model` - Creates a new model type by providing a name, properties, volatile state and actions.
 *
 * See the [model type](/concepts/trees#creating-models) description or the [getting started](intro/getting-started.md#getting-started-1) tutorial.
 */ function model() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (devMode() && typeof args[0] !== "string" && args[1]) throw fail("Model creation failed. First argument must be a string when two arguments are provided");
    var name = typeof args[0] === "string" ? args.shift() : "AnonymousModel";
    var properties = args.shift() || {};
    return new ModelType({
        name: name,
        properties: properties
    });
}
/**
 * `types.compose` - Composes a new model from one or more existing model types.
 * This method can be invoked in two forms:
 * Given 2 or more model types, the types are composed into a new Type.
 * Given first parameter as a string and 2 or more model types,
 * the types are composed into a new Type with the given name
 */ function compose() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    // TODO: just join the base type names if no name is provided
    var hasTypename = typeof args[0] === "string";
    var typeName = hasTypename ? args[0] : "AnonymousModel";
    if (hasTypename) args.shift();
    // check all parameters
    if (devMode()) args.forEach(function(type, i) {
        assertArg(type, isModelType, "mobx-state-tree model type", hasTypename ? i + 2 : i + 1);
    });
    return args.reduce(function(prev, cur) {
        return prev.cloneAndEnhance({
            name: prev.name + "_" + cur.name,
            properties: cur.properties,
            initializers: cur.initializers,
            preProcessor: function(snapshot) {
                return cur.applySnapshotPreProcessor(prev.applySnapshotPreProcessor(snapshot));
            },
            postProcessor: function(snapshot) {
                return cur.applySnapshotPostProcessor(prev.applySnapshotPostProcessor(snapshot));
            }
        });
    }).named(typeName);
}
/**
 * Returns if a given value represents a model type.
 *
 * @param type
 * @returns
 */ function isModelType(type) {
    return isType(type) && (type.flags & TypeFlags.Object) > 0;
}
// TODO: implement CoreType using types.custom ?
/**
 * @internal
 * @hidden
 */ var CoreType = /** @class */ function(_super) {
    __extends(CoreType, _super);
    function CoreType(name, flags, checker, initializer) {
        if (initializer === void 0) initializer = identity;
        var _this = _super.call(this, name) || this;
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: flags
        });
        Object.defineProperty(_this, "checker", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: checker
        });
        Object.defineProperty(_this, "initializer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: initializer
        });
        _this.flags = flags;
        return _this;
    }
    Object.defineProperty(CoreType.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return this.name;
        }
    });
    Object.defineProperty(CoreType.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(parent, subpath, environment, initialValue) {
            return createScalarNode(this, parent, subpath, environment, initialValue);
        }
    });
    Object.defineProperty(CoreType.prototype, "createNewInstance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(snapshot) {
            return this.initializer(snapshot);
        }
    });
    Object.defineProperty(CoreType.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value, context) {
            if (isPrimitive(value) && this.checker(value)) return typeCheckSuccess();
            var typeName = this.name === "Date" ? "Date or a unix milliseconds timestamp" : this.name;
            return typeCheckFailure(context, value, "Value is not a " + typeName);
        }
    });
    return CoreType;
}(SimpleType);
/**
 * `types.string` - Creates a type that can only contain a string value.
 * This type is used for string values by default
 *
 * Example:
 * ```ts
 * const Person = types.model({
 *   firstName: types.string,
 *   lastName: "Doe"
 * })
 * ```
 */ // tslint:disable-next-line:variable-name
var string = new CoreType("string", TypeFlags.String, function(v) {
    return typeof v === "string";
});
/**
 * `types.number` - Creates a type that can only contain a numeric value.
 * This type is used for numeric values by default
 *
 * Example:
 * ```ts
 * const Vector = types.model({
 *   x: types.number,
 *   y: 1.5
 * })
 * ```
 */ // tslint:disable-next-line:variable-name
var number = new CoreType("number", TypeFlags.Number, function(v) {
    return typeof v === "number";
});
/**
 * `types.integer` - Creates a type that can only contain an integer value.
 *
 * Example:
 * ```ts
 * const Size = types.model({
 *   width: types.integer,
 *   height: 10
 * })
 * ```
 */ // tslint:disable-next-line:variable-name
var integer = new CoreType("integer", TypeFlags.Integer, function(v) {
    return isInteger(v);
});
/**
 * `types.float` - Creates a type that can only contain an float value.
 *
 * Example:
 * ```ts
 * const Size = types.model({
 *   width: types.float,
 *   height: 10
 * })
 * ```
 */ // tslint:disable-next-line:variable-name
var float = new CoreType("float", TypeFlags.Float, function(v) {
    return isFloat(v);
});
/**
 * `types.finite` - Creates a type that can only contain an finite value.
 *
 * Example:
 * ```ts
 * const Size = types.model({
 *   width: types.finite,
 *   height: 10
 * })
 * ```
 */ // tslint:disable-next-line:variable-name
var finite = new CoreType("finite", TypeFlags.Finite, function(v) {
    return isFinite(v);
});
/**
 * `types.boolean` - Creates a type that can only contain a boolean value.
 * This type is used for boolean values by default
 *
 * Example:
 * ```ts
 * const Thing = types.model({
 *   isCool: types.boolean,
 *   isAwesome: false
 * })
 * ```
 */ // tslint:disable-next-line:variable-name
var boolean = new CoreType("boolean", TypeFlags.Boolean, function(v) {
    return typeof v === "boolean";
});
/**
 * `types.null` - The type of the value `null`
 */ var nullType = new CoreType("null", TypeFlags.Null, function(v) {
    return v === null;
});
/**
 * `types.undefined` - The type of the value `undefined`
 */ var undefinedType = new CoreType("undefined", TypeFlags.Undefined, function(v) {
    return v === undefined;
});
var _DatePrimitive = new CoreType("Date", TypeFlags.Date, function(v) {
    return typeof v === "number" || v instanceof Date;
}, function(v) {
    return v instanceof Date ? v : new Date(v);
});
_DatePrimitive.getSnapshot = function(node) {
    return node.storedValue.getTime();
};
/**
 * `types.Date` - Creates a type that can only contain a javascript Date value.
 *
 * Example:
 * ```ts
 * const LogLine = types.model({
 *   timestamp: types.Date,
 * })
 *
 * LogLine.create({ timestamp: new Date() })
 * ```
 */ var DatePrimitive = _DatePrimitive;
/**
 * @internal
 * @hidden
 */ function getPrimitiveFactoryFromValue(value) {
    switch(typeof value){
        case "string":
            return string;
        case "number":
            return number; // In the future, isInteger(value) ? integer : number would be interesting, but would be too breaking for now
        case "boolean":
            return boolean;
        case "object":
            if (value instanceof Date) return DatePrimitive;
    }
    throw fail("Cannot determine primitive type from value " + value);
}
/**
 * Returns if a given value represents a primitive type.
 *
 * @param type
 * @returns
 */ function isPrimitiveType(type) {
    return isType(type) && (type.flags & (TypeFlags.String | TypeFlags.Number | TypeFlags.Integer | TypeFlags.Boolean | TypeFlags.Date)) > 0;
}
/**
 * @internal
 * @hidden
 */ var Literal = /** @class */ function(_super) {
    __extends(Literal, _super);
    function Literal(value) {
        var _this = _super.call(this, JSON.stringify(value)) || this;
        Object.defineProperty(_this, "value", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Literal
        });
        _this.value = value;
        return _this;
    }
    Object.defineProperty(Literal.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(parent, subpath, environment, initialValue) {
            return createScalarNode(this, parent, subpath, environment, initialValue);
        }
    });
    Object.defineProperty(Literal.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return JSON.stringify(this.value);
        }
    });
    Object.defineProperty(Literal.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value, context) {
            if (isPrimitive(value) && value === this.value) return typeCheckSuccess();
            return typeCheckFailure(context, value, "Value is not a literal " + JSON.stringify(this.value));
        }
    });
    return Literal;
}(SimpleType);
/**
 * `types.literal` - The literal type will return a type that will match only the exact given type.
 * The given value must be a primitive, in order to be serialized to a snapshot correctly.
 * You can use literal to match exact strings for example the exact male or female string.
 *
 * Example:
 * ```ts
 * const Person = types.model({
 *     name: types.string,
 *     gender: types.union(types.literal('male'), types.literal('female'))
 * })
 * ```
 *
 * @param value The value to use in the strict equal check
 * @returns
 */ function literal(value) {
    // check that the given value is a primitive
    assertArg(value, isPrimitive, "primitive", 1);
    return new Literal(value);
}
/**
 * Returns if a given value represents a literal type.
 *
 * @param type
 * @returns
 */ function isLiteralType(type) {
    return isType(type) && (type.flags & TypeFlags.Literal) > 0;
}
var Refinement = /** @class */ function(_super) {
    __extends(Refinement, _super);
    function Refinement(name, _subtype, _predicate, _message) {
        var _this = _super.call(this, name) || this;
        Object.defineProperty(_this, "_subtype", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _subtype
        });
        Object.defineProperty(_this, "_predicate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _predicate
        });
        Object.defineProperty(_this, "_message", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _message
        });
        return _this;
    }
    Object.defineProperty(Refinement.prototype, "flags", {
        get: function() {
            return this._subtype.flags | TypeFlags.Refinement;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Refinement.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return this.name;
        }
    });
    Object.defineProperty(Refinement.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(parent, subpath, environment, initialValue) {
            // create the child type
            return this._subtype.instantiate(parent, subpath, environment, initialValue);
        }
    });
    Object.defineProperty(Refinement.prototype, "isAssignableFrom", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(type) {
            return this._subtype.isAssignableFrom(type);
        }
    });
    Object.defineProperty(Refinement.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value, context) {
            var subtypeErrors = this._subtype.validate(value, context);
            if (subtypeErrors.length > 0) return subtypeErrors;
            var snapshot = isStateTreeNode(value) ? getStateTreeNode(value).snapshot : value;
            if (!this._predicate(snapshot)) return typeCheckFailure(context, value, this._message(value));
            return typeCheckSuccess();
        }
    });
    Object.defineProperty(Refinement.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(current, newValue, parent, subpath) {
            return this._subtype.reconcile(current, newValue, parent, subpath);
        }
    });
    Object.defineProperty(Refinement.prototype, "getSubTypes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return this._subtype;
        }
    });
    return Refinement;
}(BaseType);
/**
 * `types.refinement` - Creates a type that is more specific than the base type, e.g. `types.refinement(types.string, value => value.length > 5)` to create a type of strings that can only be longer then 5.
 *
 * @param name
 * @param type
 * @param predicate
 * @returns
 */ function refinement() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var name = typeof args[0] === "string" ? args.shift() : isType(args[0]) ? args[0].name : null;
    var type = args[0];
    var predicate = args[1];
    var message = args[2] ? args[2] : function(v) {
        return "Value does not respect the refinement predicate";
    };
    // ensures all parameters are correct
    assertIsType(type, [
        1,
        2
    ]);
    assertIsString(name, 1);
    assertIsFunction(predicate, [
        2,
        3
    ]);
    assertIsFunction(message, [
        3,
        4
    ]);
    return new Refinement(name, type, predicate, message);
}
/**
 * Returns if a given value is a refinement type.
 *
 * @param type
 * @returns
 */ function isRefinementType(type) {
    return (type.flags & TypeFlags.Refinement) > 0;
}
/**
 * `types.enumeration` - Can be used to create an string based enumeration.
 * (note: this methods is just sugar for a union of string literals)
 *
 * Example:
 * ```ts
 * const TrafficLight = types.model({
 *   color: types.enumeration("Color", ["Red", "Orange", "Green"])
 * })
 * ```
 *
 * @param name descriptive name of the enumeration (optional)
 * @param options possible values this enumeration can have
 * @returns
 */ function enumeration(name, options) {
    var realOptions = typeof name === "string" ? options : name;
    // check all options
    if (devMode()) realOptions.forEach(function(option, i) {
        assertIsString(option, i + 1);
    });
    var type = union.apply(void 0, __spread(realOptions.map(function(option) {
        return literal("" + option);
    })));
    if (typeof name === "string") type.name = name;
    return type;
}
/**
 * @internal
 * @hidden
 */ var Union = /** @class */ function(_super) {
    __extends(Union, _super);
    function Union(name, _types, options) {
        var _this = _super.call(this, name) || this;
        Object.defineProperty(_this, "_types", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _types
        });
        Object.defineProperty(_this, "_dispatcher", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "_eager", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        options = __assign({
            eager: true,
            dispatcher: undefined
        }, options);
        _this._dispatcher = options.dispatcher;
        if (!options.eager) _this._eager = false;
        return _this;
    }
    Object.defineProperty(Union.prototype, "flags", {
        get: function() {
            var result = TypeFlags.Union;
            this._types.forEach(function(type) {
                result |= type.flags;
            });
            return result;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Union.prototype, "isAssignableFrom", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(type) {
            return this._types.some(function(subType) {
                return subType.isAssignableFrom(type);
            });
        }
    });
    Object.defineProperty(Union.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return "(" + this._types.map(function(factory) {
                return factory.describe();
            }).join(" | ") + ")";
        }
    });
    Object.defineProperty(Union.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(parent, subpath, environment, initialValue) {
            var type = this.determineType(initialValue, undefined);
            if (!type) throw fail("No matching type for union " + this.describe()); // can happen in prod builds
            return type.instantiate(parent, subpath, environment, initialValue);
        }
    });
    Object.defineProperty(Union.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(current, newValue, parent, subpath) {
            var type = this.determineType(newValue, current.getReconciliationType());
            if (!type) throw fail("No matching type for union " + this.describe()); // can happen in prod builds
            return type.reconcile(current, newValue, parent, subpath);
        }
    });
    Object.defineProperty(Union.prototype, "determineType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value, reconcileCurrentType) {
            // try the dispatcher, if defined
            if (this._dispatcher) return this._dispatcher(value);
            // find the most accomodating type
            // if we are using reconciliation try the current node type first (fix for #1045)
            if (reconcileCurrentType) {
                if (reconcileCurrentType.is(value)) return reconcileCurrentType;
                return this._types.filter(function(t) {
                    return t !== reconcileCurrentType;
                }).find(function(type) {
                    return type.is(value);
                });
            } else return this._types.find(function(type) {
                return type.is(value);
            });
        }
    });
    Object.defineProperty(Union.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value, context) {
            if (this._dispatcher) return this._dispatcher(value).validate(value, context);
            var allErrors = [];
            var applicableTypes = 0;
            for(var i = 0; i < this._types.length; i++){
                var type = this._types[i];
                var errors = type.validate(value, context);
                if (errors.length === 0) {
                    if (this._eager) return typeCheckSuccess();
                    else applicableTypes++;
                } else allErrors.push(errors);
            }
            if (applicableTypes === 1) return typeCheckSuccess();
            return typeCheckFailure(context, value, "No type is applicable for the union").concat(flattenTypeErrors(allErrors));
        }
    });
    Object.defineProperty(Union.prototype, "getSubTypes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return this._types;
        }
    });
    return Union;
}(BaseType);
/**
 * `types.union` - Create a union of multiple types. If the correct type cannot be inferred unambiguously from a snapshot, provide a dispatcher function of the form `(snapshot) => Type`.
 *
 * @param optionsOrType
 * @param otherTypes
 * @returns
 */ function union(optionsOrType) {
    var otherTypes = [];
    for(var _i = 1; _i < arguments.length; _i++)otherTypes[_i - 1] = arguments[_i];
    var options = isType(optionsOrType) ? undefined : optionsOrType;
    var types = isType(optionsOrType) ? __spread([
        optionsOrType
    ], otherTypes) : otherTypes;
    var name = "(" + types.map(function(type) {
        return type.name;
    }).join(" | ") + ")";
    // check all options
    if (devMode()) {
        if (options) assertArg(options, function(o) {
            return isPlainObject(o);
        }, "object { eager?: boolean, dispatcher?: Function }", 1);
        types.forEach(function(type, i) {
            assertIsType(type, options ? i + 2 : i + 1);
        });
    }
    return new Union(name, types, options);
}
/**
 * Returns if a given value represents a union type.
 *
 * @param type
 * @returns
 */ function isUnionType(type) {
    return (type.flags & TypeFlags.Union) > 0;
}
/**
 * @hidden
 * @internal
 */ var OptionalValue = /** @class */ function(_super) {
    __extends(OptionalValue, _super);
    function OptionalValue(_subtype, _defaultValue, optionalValues) {
        var _this = _super.call(this, _subtype.name) || this;
        Object.defineProperty(_this, "_subtype", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _subtype
        });
        Object.defineProperty(_this, "_defaultValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _defaultValue
        });
        Object.defineProperty(_this, "optionalValues", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: optionalValues
        });
        return _this;
    }
    Object.defineProperty(OptionalValue.prototype, "flags", {
        get: function() {
            return this._subtype.flags | TypeFlags.Optional;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OptionalValue.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return this._subtype.describe() + "?";
        }
    });
    Object.defineProperty(OptionalValue.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(parent, subpath, environment, initialValue) {
            if (this.optionalValues.indexOf(initialValue) >= 0) {
                var defaultInstanceOrSnapshot = this.getDefaultInstanceOrSnapshot();
                return this._subtype.instantiate(parent, subpath, environment, defaultInstanceOrSnapshot);
            }
            return this._subtype.instantiate(parent, subpath, environment, initialValue);
        }
    });
    Object.defineProperty(OptionalValue.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(current, newValue, parent, subpath) {
            return this._subtype.reconcile(current, this.optionalValues.indexOf(newValue) < 0 && this._subtype.is(newValue) ? newValue : this.getDefaultInstanceOrSnapshot(), parent, subpath);
        }
    });
    Object.defineProperty(OptionalValue.prototype, "getDefaultInstanceOrSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            var defaultInstanceOrSnapshot = typeof this._defaultValue === "function" ? this._defaultValue() : this._defaultValue;
            // while static values are already snapshots and checked on types.optional
            // generator functions must always be rechecked just in case
            if (typeof this._defaultValue === "function") typecheckInternal(this, defaultInstanceOrSnapshot);
            return defaultInstanceOrSnapshot;
        }
    });
    Object.defineProperty(OptionalValue.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value, context) {
            // defaulted values can be skipped
            if (this.optionalValues.indexOf(value) >= 0) return typeCheckSuccess();
            // bounce validation to the sub-type
            return this._subtype.validate(value, context);
        }
    });
    Object.defineProperty(OptionalValue.prototype, "isAssignableFrom", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(type) {
            return this._subtype.isAssignableFrom(type);
        }
    });
    Object.defineProperty(OptionalValue.prototype, "getSubTypes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return this._subtype;
        }
    });
    return OptionalValue;
}(BaseType);
function checkOptionalPreconditions(type, defaultValueOrFunction) {
    // make sure we never pass direct instances
    if (typeof defaultValueOrFunction !== "function" && isStateTreeNode(defaultValueOrFunction)) throw fail("default value cannot be an instance, pass a snapshot or a function that creates an instance/snapshot instead");
    assertIsType(type, 1);
    if (devMode()) // we only check default values if they are passed directly
    // if they are generator functions they will be checked once they are generated
    // we don't check generator function results here to avoid generating a node just for type-checking purposes
    // which might generate side-effects
    {
        if (typeof defaultValueOrFunction !== "function") typecheckInternal(type, defaultValueOrFunction);
    }
}
/**
 * `types.optional` - Can be used to create a property with a default value.
 *
 * Depending on the third argument (`optionalValues`) there are two ways of operation:
 * - If the argument is not provided, then if a value is not provided in the snapshot (`undefined` or missing),
 *   it will default to the provided `defaultValue`
 * - If the argument is provided, then if the value in the snapshot matches one of the optional values inside the array then it will
 *   default to the provided `defaultValue`. Additionally, if one of the optional values inside the array is `undefined` then a missing
 *   property is also valid.
 *
 *   Note that it is also possible to include values of the same type as the intended subtype as optional values,
 *   in this case the optional value will be transformed into the `defaultValue` (e.g. `types.optional(types.string, "unnamed", [undefined, ""])`
 *   will transform the snapshot values `undefined` (and therefore missing) and empty strings into the string `"unnamed"` when it gets
 *   instantiated).
 *
 * If `defaultValue` is a function, the function will be invoked for every new instance.
 * Applying a snapshot in which the optional value is one of the optional values (or `undefined`/_not_ present if none are provided) causes the
 * value to be reset.
 *
 * Example:
 * ```ts
 * const Todo = types.model({
 *   title: types.string,
 *   subtitle1: types.optional(types.string, "", [null]),
 *   subtitle2: types.optional(types.string, "", [null, undefined]),
 *   done: types.optional(types.boolean, false),
 *   created: types.optional(types.Date, () => new Date()),
 * })
 *
 * // if done is missing / undefined it will become false
 * // if created is missing / undefined it will get a freshly generated timestamp
 * // if subtitle1 is null it will default to "", but it cannot be missing or undefined
 * // if subtitle2 is null or undefined it will default to ""; since it can be undefined it can also be missing
 * const todo = Todo.create({ title: "Get coffee", subtitle1: null })
 * ```
 *
 * @param type
 * @param defaultValueOrFunction
 * @param optionalValues an optional array with zero or more primitive values (string, number, boolean, null or undefined)
 *                       that will be converted into the default. `[ undefined ]` is assumed when none is provided
 * @returns
 */ function optional(type, defaultValueOrFunction, optionalValues) {
    checkOptionalPreconditions(type, defaultValueOrFunction);
    return new OptionalValue(type, defaultValueOrFunction, optionalValues ? optionalValues : undefinedAsOptionalValues);
}
var undefinedAsOptionalValues = [
    undefined
];
/**
 * Returns if a value represents an optional type.
 *
 * @template IT
 * @param type
 * @returns
 */ function isOptionalType(type) {
    return isType(type) && (type.flags & TypeFlags.Optional) > 0;
}
var optionalUndefinedType = optional(undefinedType, undefined);
var optionalNullType = optional(nullType, null);
/**
 * `types.maybe` - Maybe will make a type nullable, and also optional.
 * The value `undefined` will be used to represent nullability.
 *
 * @param type
 * @returns
 */ function maybe(type) {
    assertIsType(type, 1);
    return union(type, optionalUndefinedType);
}
/**
 * `types.maybeNull` - Maybe will make a type nullable, and also optional.
 * The value `null` will be used to represent no value.
 *
 * @param type
 * @returns
 */ function maybeNull(type) {
    assertIsType(type, 1);
    return union(type, optionalNullType);
}
var Late = /** @class */ function(_super) {
    __extends(Late, _super);
    function Late(name, _definition) {
        var _this = _super.call(this, name) || this;
        Object.defineProperty(_this, "_definition", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _definition
        });
        Object.defineProperty(_this, "_subType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        return _this;
    }
    Object.defineProperty(Late.prototype, "flags", {
        get: function() {
            return (this._subType ? this._subType.flags : 0) | TypeFlags.Late;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Late.prototype, "getSubType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(mustSucceed) {
            if (!this._subType) {
                var t = undefined;
                try {
                    t = this._definition();
                } catch (e) {
                    if (e instanceof ReferenceError) // can happen in strict ES5 code when a definition is self refering
                    t = undefined;
                    else throw e;
                }
                if (mustSucceed && t === undefined) throw fail("Late type seems to be used too early, the definition (still) returns undefined");
                if (t) {
                    if (devMode() && !isType(t)) throw fail("Failed to determine subtype, make sure types.late returns a type definition.");
                    this._subType = t;
                }
            }
            return this._subType;
        }
    });
    Object.defineProperty(Late.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(parent, subpath, environment, initialValue) {
            return this.getSubType(true).instantiate(parent, subpath, environment, initialValue);
        }
    });
    Object.defineProperty(Late.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(current, newValue, parent, subpath) {
            return this.getSubType(true).reconcile(current, newValue, parent, subpath);
        }
    });
    Object.defineProperty(Late.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            var t = this.getSubType(false);
            return t ? t.name : "<uknown late type>";
        }
    });
    Object.defineProperty(Late.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value, context) {
            var t = this.getSubType(false);
            if (!t) // See #916; the variable the definition closure is pointing to wasn't defined yet, so can't be evaluted yet here
            return typeCheckSuccess();
            return t.validate(value, context);
        }
    });
    Object.defineProperty(Late.prototype, "isAssignableFrom", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(type) {
            var t = this.getSubType(false);
            return t ? t.isAssignableFrom(type) : false;
        }
    });
    Object.defineProperty(Late.prototype, "getSubTypes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            var subtype = this.getSubType(false);
            return subtype ? subtype : cannotDetermineSubtype;
        }
    });
    return Late;
}(BaseType);
/**
 * `types.late` - Defines a type that gets implemented later. This is useful when you have to deal with circular dependencies.
 * Please notice that when defining circular dependencies TypeScript isn't smart enough to inference them.
 *
 * Example:
 * ```ts
 *   // TypeScript isn't smart enough to infer self referencing types.
 *  const Node = types.model({
 *       children: types.array(types.late((): IAnyModelType => Node)) // then typecast each array element to Instance<typeof Node>
 *  })
 * ```
 *
 * @param name The name to use for the type that will be returned.
 * @param type A function that returns the type that will be defined.
 * @returns
 */ function late(nameOrType, maybeType) {
    var name = typeof nameOrType === "string" ? nameOrType : "late(" + nameOrType.toString() + ")";
    var type = typeof nameOrType === "string" ? maybeType : nameOrType;
    // checks that the type is actually a late type
    if (devMode()) {
        if (!(typeof type === "function" && type.length === 0)) throw fail("Invalid late type, expected a function with zero arguments that returns a type, got: " + type);
    }
    return new Late(name, type);
}
/**
 * Returns if a given value represents a late type.
 *
 * @param type
 * @returns
 */ function isLateType(type) {
    return isType(type) && (type.flags & TypeFlags.Late) > 0;
}
function lazy(name, options) {
    // TODO: fix this unknown casting to be stricter
    return new Lazy(name, options);
}
/**
 * @internal
 * @hidden
 */ var Lazy = /** @class */ function(_super) {
    __extends(Lazy, _super);
    function Lazy(name, options) {
        var _this = _super.call(this, name) || this;
        Object.defineProperty(_this, "options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: options
        });
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Lazy
        });
        Object.defineProperty(_this, "loadedType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(_this, "pendingNodeList", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $2SBKn.observable).array()
        });
        (0, $2SBKn.when)(function() {
            return _this.pendingNodeList.length > 0 && _this.pendingNodeList.some(function(node) {
                return node.isAlive && _this.options.shouldLoadPredicate(node.parent ? node.parent.value : null);
            });
        }, function() {
            _this.options.loadType().then((0, $2SBKn.action)(function(type) {
                _this.loadedType = type;
                _this.pendingNodeList.forEach(function(node) {
                    if (!node.parent) return;
                    if (!_this.loadedType) return;
                    node.parent.applyPatches([
                        {
                            op: "replace",
                            path: "/" + node.subpath,
                            value: node.snapshot
                        }
                    ]);
                });
            }));
        });
        return _this;
    }
    Object.defineProperty(Lazy.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return "<lazy " + this.name + ">";
        }
    });
    Object.defineProperty(Lazy.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(parent, subpath, environment, value) {
            var _this = this;
            if (this.loadedType) return this.loadedType.instantiate(parent, subpath, environment, value);
            var node = createScalarNode(this, parent, subpath, environment, deepFreeze(value));
            this.pendingNodeList.push(node);
            (0, $2SBKn.when)(function() {
                return !node.isAlive;
            }, function() {
                return _this.pendingNodeList.splice(_this.pendingNodeList.indexOf(node), 1);
            });
            return node;
        }
    });
    Object.defineProperty(Lazy.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value, context) {
            if (this.loadedType) return this.loadedType.validate(value, context);
            if (!isSerializable(value)) return typeCheckFailure(context, value, "Value is not serializable and cannot be lazy");
            return typeCheckSuccess();
        }
    });
    Object.defineProperty(Lazy.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(current, value, parent, subpath) {
            if (this.loadedType) {
                current.die();
                return this.loadedType.instantiate(parent, subpath, parent.environment, value);
            }
            return _super.prototype.reconcile.call(this, current, value, parent, subpath);
        }
    });
    return Lazy;
}(SimpleType);
/**
 * @internal
 * @hidden
 */ var Frozen = /** @class */ function(_super) {
    __extends(Frozen, _super);
    function Frozen(subType) {
        var _this = _super.call(this, subType ? "frozen(" + subType.name + ")" : "frozen") || this;
        Object.defineProperty(_this, "subType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: subType
        });
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Frozen
        });
        return _this;
    }
    Object.defineProperty(Frozen.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return "<any immutable value>";
        }
    });
    Object.defineProperty(Frozen.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(parent, subpath, environment, value) {
            // create the node
            return createScalarNode(this, parent, subpath, environment, deepFreeze(value));
        }
    });
    Object.defineProperty(Frozen.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value, context) {
            if (!isSerializable(value)) return typeCheckFailure(context, value, "Value is not serializable and cannot be frozen");
            if (this.subType) return this.subType.validate(value, context);
            return typeCheckSuccess();
        }
    });
    return Frozen;
}(SimpleType);
var untypedFrozenInstance = new Frozen();
/**
 * `types.frozen` - Frozen can be used to store any value that is serializable in itself (that is valid JSON).
 * Frozen values need to be immutable or treated as if immutable. They need be serializable as well.
 * Values stored in frozen will snapshotted as-is by MST, and internal changes will not be tracked.
 *
 * This is useful to store complex, but immutable values like vectors etc. It can form a powerful bridge to parts of your application that should be immutable, or that assume data to be immutable.
 *
 * Note: if you want to store free-form state that is mutable, or not serializeable, consider using volatile state instead.
 *
 * Frozen properties can be defined in three different ways
 * 1. `types.frozen(SubType)` - provide a valid MST type and frozen will check if the provided data conforms the snapshot for that type
 * 2. `types.frozen({ someDefaultValue: true})` - provide a primitive value, object or array, and MST will infer the type from that object, and also make it the default value for the field
 * 3. `types.frozen<TypeScriptType>()` - provide a typescript type, to help in strongly typing the field (design time only)
 *
 * Example:
 * ```ts
 * const GameCharacter = types.model({
 *   name: string,
 *   location: types.frozen({ x: 0, y: 0})
 * })
 *
 * const hero = GameCharacter.create({
 *   name: "Mario",
 *   location: { x: 7, y: 4 }
 * })
 *
 * hero.location = { x: 10, y: 2 } // OK
 * hero.location.x = 7 // Not ok!
 * ```
 *
 * ```ts
 * type Point = { x: number, y: number }
 *    const Mouse = types.model({
 *         loc: types.frozen<Point>()
 *    })
 * ```
 *
 * @param defaultValueOrType
 * @returns
 */ function frozen(arg) {
    if (arguments.length === 0) return untypedFrozenInstance;
    else if (isType(arg)) return new Frozen(arg);
    else return optional(untypedFrozenInstance, arg);
}
/**
 * Returns if a given value represents a frozen type.
 *
 * @param type
 * @returns
 */ function isFrozenType(type) {
    return isType(type) && (type.flags & TypeFlags.Frozen) > 0;
}
function getInvalidationCause(hook) {
    switch(hook){
        case Hook.beforeDestroy:
            return "destroy";
        case Hook.beforeDetach:
            return "detach";
        default:
            return undefined;
    }
}
var StoredReference = /** @class */ function() {
    function StoredReference(value, targetType) {
        Object.defineProperty(this, "targetType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: targetType
        });
        Object.defineProperty(this, "identifier", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "node", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "resolvedReference", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        if (isValidIdentifier(value)) this.identifier = value;
        else if (isStateTreeNode(value)) {
            var targetNode = getStateTreeNode(value);
            if (!targetNode.identifierAttribute) throw fail("Can only store references with a defined identifier attribute.");
            var id = targetNode.unnormalizedIdentifier;
            if (id === null || id === undefined) throw fail("Can only store references to tree nodes with a defined identifier.");
            this.identifier = id;
        } else throw fail("Can only store references to tree nodes or identifiers, got: '" + value + "'");
    }
    Object.defineProperty(StoredReference.prototype, "updateResolvedReference", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node) {
            var normalizedId = normalizeIdentifier(this.identifier);
            var root = node.root;
            var lastCacheModification = root.identifierCache.getLastCacheModificationPerId(normalizedId);
            if (!this.resolvedReference || this.resolvedReference.lastCacheModification !== lastCacheModification) {
                var targetType = this.targetType;
                // reference was initialized with the identifier of the target
                var target = root.identifierCache.resolve(targetType, normalizedId);
                if (!target) throw new InvalidReferenceError("[mobx-state-tree] Failed to resolve reference '" + this.identifier + "' to type '" + this.targetType.name + "' (from node: " + node.path + ")");
                this.resolvedReference = {
                    node: target,
                    lastCacheModification: lastCacheModification
                };
            }
        }
    });
    Object.defineProperty(StoredReference.prototype, "resolvedValue", {
        get: function() {
            this.updateResolvedReference(this.node);
            return this.resolvedReference.node.value;
        },
        enumerable: false,
        configurable: true
    });
    return StoredReference;
}();
/**
 * @internal
 * @hidden
 */ var InvalidReferenceError = /** @class */ function(_super) {
    __extends(InvalidReferenceError, _super);
    function InvalidReferenceError(m) {
        var _this = _super.call(this, m) || this;
        Object.setPrototypeOf(_this, InvalidReferenceError.prototype);
        return _this;
    }
    return InvalidReferenceError;
}(Error);
/**
 * @internal
 * @hidden
 */ var BaseReferenceType = /** @class */ function(_super) {
    __extends(BaseReferenceType, _super);
    function BaseReferenceType(targetType, onInvalidated) {
        var _this = _super.call(this, "reference(" + targetType.name + ")") || this;
        Object.defineProperty(_this, "targetType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: targetType
        });
        Object.defineProperty(_this, "onInvalidated", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: onInvalidated
        });
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Reference
        });
        return _this;
    }
    Object.defineProperty(BaseReferenceType.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return this.name;
        }
    });
    Object.defineProperty(BaseReferenceType.prototype, "isAssignableFrom", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(type) {
            return this.targetType.isAssignableFrom(type);
        }
    });
    Object.defineProperty(BaseReferenceType.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value, context) {
            return isValidIdentifier(value) ? typeCheckSuccess() : typeCheckFailure(context, value, "Value is not a valid identifier, which is a string or a number");
        }
    });
    Object.defineProperty(BaseReferenceType.prototype, "fireInvalidated", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(cause, storedRefNode, referenceId, refTargetNode) {
            // to actually invalidate a reference we need an alive parent,
            // since it is a scalar value (immutable-ish) and we need to change it
            // from the parent
            var storedRefParentNode = storedRefNode.parent;
            if (!storedRefParentNode || !storedRefParentNode.isAlive) return;
            var storedRefParentValue = storedRefParentNode.storedValue;
            if (!storedRefParentValue) return;
            this.onInvalidated({
                cause: cause,
                parent: storedRefParentValue,
                invalidTarget: refTargetNode ? refTargetNode.storedValue : undefined,
                invalidId: referenceId,
                replaceRef: function(newRef) {
                    applyPatch(storedRefNode.root.storedValue, {
                        op: "replace",
                        value: newRef,
                        path: storedRefNode.path
                    });
                },
                removeRef: function() {
                    if (isModelType(storedRefParentNode.type)) this.replaceRef(undefined);
                    else applyPatch(storedRefNode.root.storedValue, {
                        op: "remove",
                        path: storedRefNode.path
                    });
                }
            });
        }
    });
    Object.defineProperty(BaseReferenceType.prototype, "addTargetNodeWatcher", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(storedRefNode, referenceId) {
            var _this = this;
            // this will make sure the target node becomes created
            var refTargetValue = this.getValue(storedRefNode);
            if (!refTargetValue) return undefined;
            var refTargetNode = getStateTreeNode(refTargetValue);
            var hookHandler = function(_, refTargetNodeHook) {
                var cause = getInvalidationCause(refTargetNodeHook);
                if (!cause) return;
                _this.fireInvalidated(cause, storedRefNode, referenceId, refTargetNode);
            };
            var refTargetDetachHookDisposer = refTargetNode.registerHook(Hook.beforeDetach, hookHandler);
            var refTargetDestroyHookDisposer = refTargetNode.registerHook(Hook.beforeDestroy, hookHandler);
            return function() {
                refTargetDetachHookDisposer();
                refTargetDestroyHookDisposer();
            };
        }
    });
    Object.defineProperty(BaseReferenceType.prototype, "watchTargetNodeForInvalidations", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(storedRefNode, identifier, customGetSet) {
            var _this = this;
            if (!this.onInvalidated) return;
            var onRefTargetDestroyedHookDisposer;
            // get rid of the watcher hook when the stored ref node is destroyed
            // detached is ignored since scalar nodes (where the reference resides) cannot be detached
            storedRefNode.registerHook(Hook.beforeDestroy, function() {
                if (onRefTargetDestroyedHookDisposer) onRefTargetDestroyedHookDisposer();
            });
            var startWatching = function(sync) {
                // re-create hook in case the stored ref gets reattached
                if (onRefTargetDestroyedHookDisposer) onRefTargetDestroyedHookDisposer();
                // make sure the target node is actually there and initialized
                var storedRefParentNode = storedRefNode.parent;
                var storedRefParentValue = storedRefParentNode && storedRefParentNode.storedValue;
                if (storedRefParentNode && storedRefParentNode.isAlive && storedRefParentValue) {
                    var refTargetNodeExists = void 0;
                    if (customGetSet) refTargetNodeExists = !!customGetSet.get(identifier, storedRefParentValue);
                    else refTargetNodeExists = storedRefNode.root.identifierCache.has(_this.targetType, normalizeIdentifier(identifier));
                    if (!refTargetNodeExists) // we cannot change the reference in sync mode
                    // since we are in the middle of a reconciliation/instantiation and the change would be overwritten
                    // for those cases just let the wrong reference be assigned and fail upon usage
                    // (like current references do)
                    // this means that effectively this code will only run when it is created from a snapshot
                    {
                        if (!sync) _this.fireInvalidated("invalidSnapshotReference", storedRefNode, identifier, null);
                    } else onRefTargetDestroyedHookDisposer = _this.addTargetNodeWatcher(storedRefNode, identifier);
                }
            };
            if (storedRefNode.state === NodeLifeCycle.FINALIZED) // already attached, so the whole tree is ready
            startWatching(true);
            else {
                if (!storedRefNode.isRoot) // start watching once the whole tree is ready
                storedRefNode.root.registerHook(Hook.afterCreationFinalization, function() {
                    // make sure to attach it so it can start listening
                    if (storedRefNode.parent) storedRefNode.parent.createObservableInstanceIfNeeded();
                });
                // start watching once the node is attached somewhere / parent changes
                storedRefNode.registerHook(Hook.afterAttach, function() {
                    startWatching(false);
                });
            }
        }
    });
    return BaseReferenceType;
}(SimpleType);
/**
 * @internal
 * @hidden
 */ var IdentifierReferenceType = /** @class */ function(_super) {
    __extends(IdentifierReferenceType, _super);
    function IdentifierReferenceType(targetType, onInvalidated) {
        return _super.call(this, targetType, onInvalidated) || this;
    }
    Object.defineProperty(IdentifierReferenceType.prototype, "getValue", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(storedRefNode) {
            if (!storedRefNode.isAlive) return undefined;
            var storedRef = storedRefNode.storedValue;
            return storedRef.resolvedValue;
        }
    });
    Object.defineProperty(IdentifierReferenceType.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(storedRefNode) {
            var ref = storedRefNode.storedValue;
            return ref.identifier;
        }
    });
    Object.defineProperty(IdentifierReferenceType.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(parent, subpath, environment, initialValue) {
            var identifier = isStateTreeNode(initialValue) ? getIdentifier(initialValue) : initialValue;
            var storedRef = new StoredReference(initialValue, this.targetType);
            var storedRefNode = createScalarNode(this, parent, subpath, environment, storedRef);
            storedRef.node = storedRefNode;
            this.watchTargetNodeForInvalidations(storedRefNode, identifier, undefined);
            return storedRefNode;
        }
    });
    Object.defineProperty(IdentifierReferenceType.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(current, newValue, parent, subpath) {
            if (!current.isDetaching && current.type === this) {
                var compareByValue = isStateTreeNode(newValue);
                var ref = current.storedValue;
                if (!compareByValue && ref.identifier === newValue || compareByValue && ref.resolvedValue === newValue) {
                    current.setParent(parent, subpath);
                    return current;
                }
            }
            var newNode = this.instantiate(parent, subpath, undefined, newValue);
            current.die(); // noop if detaching
            return newNode;
        }
    });
    return IdentifierReferenceType;
}(BaseReferenceType);
/**
 * @internal
 * @hidden
 */ var CustomReferenceType = /** @class */ function(_super) {
    __extends(CustomReferenceType, _super);
    function CustomReferenceType(targetType, options, onInvalidated) {
        var _this = _super.call(this, targetType, onInvalidated) || this;
        Object.defineProperty(_this, "options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: options
        });
        return _this;
    }
    Object.defineProperty(CustomReferenceType.prototype, "getValue", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(storedRefNode) {
            if (!storedRefNode.isAlive) return undefined;
            var referencedNode = this.options.get(storedRefNode.storedValue, storedRefNode.parent ? storedRefNode.parent.storedValue : null);
            return referencedNode;
        }
    });
    Object.defineProperty(CustomReferenceType.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(storedRefNode) {
            return storedRefNode.storedValue;
        }
    });
    Object.defineProperty(CustomReferenceType.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(parent, subpath, environment, newValue) {
            var identifier = isStateTreeNode(newValue) ? this.options.set(newValue, parent ? parent.storedValue : null) : newValue;
            var storedRefNode = createScalarNode(this, parent, subpath, environment, identifier);
            this.watchTargetNodeForInvalidations(storedRefNode, identifier, this.options);
            return storedRefNode;
        }
    });
    Object.defineProperty(CustomReferenceType.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(current, newValue, parent, subpath) {
            var newIdentifier = isStateTreeNode(newValue) ? this.options.set(newValue, current ? current.storedValue : null) : newValue;
            if (!current.isDetaching && current.type === this && current.storedValue === newIdentifier) {
                current.setParent(parent, subpath);
                return current;
            }
            var newNode = this.instantiate(parent, subpath, undefined, newIdentifier);
            current.die(); // noop if detaching
            return newNode;
        }
    });
    return CustomReferenceType;
}(BaseReferenceType);
/**
 * `types.reference` - Creates a reference to another type, which should have defined an identifier.
 * See also the [reference and identifiers](https://github.com/mobxjs/mobx-state-tree#references-and-identifiers) section.
 */ function reference(subType, options) {
    assertIsType(subType, 1);
    if (devMode()) {
        if (arguments.length === 2 && typeof arguments[1] === "string") // istanbul ignore next
        throw fail("References with base path are no longer supported. Please remove the base path.");
    }
    var getSetOptions = options ? options : undefined;
    var onInvalidated = options ? options.onInvalidated : undefined;
    if (getSetOptions && (getSetOptions.get || getSetOptions.set)) {
        if (devMode()) {
            if (!getSetOptions.get || !getSetOptions.set) throw fail("reference options must either contain both a 'get' and a 'set' method or none of them");
        }
        return new CustomReferenceType(subType, {
            get: getSetOptions.get,
            set: getSetOptions.set
        }, onInvalidated);
    } else return new IdentifierReferenceType(subType, onInvalidated);
}
/**
 * Returns if a given value represents a reference type.
 *
 * @param type
 * @returns
 */ function isReferenceType(type) {
    return (type.flags & TypeFlags.Reference) > 0;
}
/**
 * `types.safeReference` - A safe reference is like a standard reference, except that it accepts the undefined value by default
 * and automatically sets itself to undefined (when the parent is a model) / removes itself from arrays and maps
 * when the reference it is pointing to gets detached/destroyed.
 *
 * The optional options parameter object accepts a parameter named `acceptsUndefined`, which is set to true by default, so it is suitable
 * for model properties.
 * When used inside collections (arrays/maps), it is recommended to set this option to false so it can't take undefined as value,
 * which is usually the desired in those cases.
 * Additionally, the optional options parameter object accepts a parameter named `onInvalidated`, which will be called when the reference target node that the reference is pointing to is about to be detached/destroyed
 *
 * Strictly speaking it is a `types.maybe(types.reference(X))` (when `acceptsUndefined` is set to true, the default) and
 * `types.reference(X)` (when `acceptsUndefined` is set to false), both of them with a customized `onInvalidated` option.
 *
 * @param subType
 * @param options
 * @returns
 */ function safeReference(subType, options) {
    var refType = reference(subType, __assign(__assign({}, options), {
        onInvalidated: function(ev) {
            if (options && options.onInvalidated) options.onInvalidated(ev);
            ev.removeRef();
        }
    }));
    if (options && options.acceptsUndefined === false) return refType;
    else return maybe(refType);
}
var BaseIdentifierType = /** @class */ function(_super) {
    __extends(BaseIdentifierType, _super);
    function BaseIdentifierType(name, validType) {
        var _this = _super.call(this, name) || this;
        Object.defineProperty(_this, "validType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: validType
        });
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Identifier
        });
        return _this;
    }
    Object.defineProperty(BaseIdentifierType.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(parent, subpath, environment, initialValue) {
            if (!parent || !(parent.type instanceof ModelType)) throw fail("Identifier types can only be instantiated as direct child of a model type");
            return createScalarNode(this, parent, subpath, environment, initialValue);
        }
    });
    Object.defineProperty(BaseIdentifierType.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(current, newValue, parent, subpath) {
            // we don't consider detaching here since identifier are scalar nodes, and scalar nodes cannot be detached
            if (current.storedValue !== newValue) throw fail("Tried to change identifier from '" + current.storedValue + "' to '" + newValue + "'. Changing identifiers is not allowed.");
            current.setParent(parent, subpath);
            return current;
        }
    });
    Object.defineProperty(BaseIdentifierType.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value, context) {
            if (typeof value !== this.validType) return typeCheckFailure(context, value, "Value is not a valid " + this.describe() + ", expected a " + this.validType);
            return typeCheckSuccess();
        }
    });
    return BaseIdentifierType;
}(SimpleType);
/**
 * @internal
 * @hidden
 */ var IdentifierType = /** @class */ function(_super) {
    __extends(IdentifierType, _super);
    function IdentifierType() {
        var _this = _super.call(this, "identifier", "string") || this;
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Identifier
        });
        return _this;
    }
    Object.defineProperty(IdentifierType.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return "identifier";
        }
    });
    return IdentifierType;
}(BaseIdentifierType);
/**
 * @internal
 * @hidden
 */ var IdentifierNumberType = /** @class */ function(_super) {
    __extends(IdentifierNumberType, _super);
    function IdentifierNumberType() {
        return _super.call(this, "identifierNumber", "number") || this;
    }
    Object.defineProperty(IdentifierNumberType.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node) {
            return node.storedValue;
        }
    });
    Object.defineProperty(IdentifierNumberType.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return "identifierNumber";
        }
    });
    return IdentifierNumberType;
}(BaseIdentifierType);
/**
 * `types.identifier` - Identifiers are used to make references, lifecycle events and reconciling works.
 * Inside a state tree, for each type can exist only one instance for each given identifier.
 * For example there couldn't be 2 instances of user with id 1. If you need more, consider using references.
 * Identifier can be used only as type property of a model.
 * This type accepts as parameter the value type of the identifier field that can be either string or number.
 *
 * Example:
 * ```ts
 *  const Todo = types.model("Todo", {
 *      id: types.identifier,
 *      title: types.string
 *  })
 * ```
 *
 * @returns
 */ var identifier = new IdentifierType();
/**
 * `types.identifierNumber` - Similar to `types.identifier`. This one will serialize from / to a number when applying snapshots
 *
 * Example:
 * ```ts
 *  const Todo = types.model("Todo", {
 *      id: types.identifierNumber,
 *      title: types.string
 *  })
 * ```
 *
 * @returns
 */ var identifierNumber = new IdentifierNumberType();
/**
 * Returns if a given value represents an identifier type.
 *
 * @param type
 * @returns
 */ function isIdentifierType(type) {
    return isType(type) && (type.flags & TypeFlags.Identifier) > 0;
}
/**
 * @internal
 * @hidden
 */ function normalizeIdentifier(id) {
    return "" + id;
}
/**
 * @internal
 * @hidden
 */ function isValidIdentifier(id) {
    return typeof id === "string" || typeof id === "number";
}
/**
 * @internal
 * @hidden
 */ function assertIsValidIdentifier(id, argNumber) {
    assertArg(id, isValidIdentifier, "string or number (identifier)", argNumber);
}
/**
 * `types.custom` - Creates a custom type. Custom types can be used for arbitrary immutable values, that have a serializable representation. For example, to create your own Date representation, Decimal type etc.
 *
 * The signature of the options is:
 * ```ts
 * export interface CustomTypeOptions<S, T> {
 *     // Friendly name
 *     name: string
 *     // given a serialized value and environment, how to turn it into the target type
 *     fromSnapshot(snapshot: S, env: any): T
 *     // return the serialization of the current value
 *     toSnapshot(value: T): S
 *     // if true, this is a converted value, if false, it's a snapshot
 *     isTargetType(value: T | S): value is T
 *     // a non empty string is assumed to be a validation error
 *     getValidationMessage?(snapshot: S): string
 * }
 * ```
 *
 * Example:
 * ```ts
 * const DecimalPrimitive = types.custom<string, Decimal>({
 *     name: "Decimal",
 *     fromSnapshot(value: string) {
 *         return new Decimal(value)
 *     },
 *     toSnapshot(value: Decimal) {
 *         return value.toString()
 *     },
 *     isTargetType(value: string | Decimal): boolean {
 *         return value instanceof Decimal
 *     },
 *     getValidationMessage(value: string): string {
 *         if (/^-?\d+\.\d+$/.test(value)) return "" // OK
 *         return `'${value}' doesn't look like a valid decimal number`
 *     }
 * })
 *
 * const Wallet = types.model({
 *     balance: DecimalPrimitive
 * })
 * ```
 *
 * @param options
 * @returns
 */ function custom(options) {
    return new CustomType(options);
}
/**
 * @internal
 * @hidden
 */ var CustomType = /** @class */ function(_super) {
    __extends(CustomType, _super);
    function CustomType(options) {
        var _this = _super.call(this, options.name) || this;
        Object.defineProperty(_this, "options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: options
        });
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Custom
        });
        return _this;
    }
    Object.defineProperty(CustomType.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return this.name;
        }
    });
    Object.defineProperty(CustomType.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value, context) {
            if (this.options.isTargetType(value)) return typeCheckSuccess();
            var typeError = this.options.getValidationMessage(value);
            if (typeError) return typeCheckFailure(context, value, "Invalid value for type '" + this.name + "': " + typeError);
            return typeCheckSuccess();
        }
    });
    Object.defineProperty(CustomType.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node) {
            return this.options.toSnapshot(node.storedValue);
        }
    });
    Object.defineProperty(CustomType.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(parent, subpath, environment, initialValue) {
            var valueToStore = this.options.isTargetType(initialValue) ? initialValue : this.options.fromSnapshot(initialValue, parent && parent.root.environment);
            return createScalarNode(this, parent, subpath, environment, valueToStore);
        }
    });
    Object.defineProperty(CustomType.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(current, value, parent, subpath) {
            var isSnapshot = !this.options.isTargetType(value);
            // in theory customs use scalar nodes which cannot be detached, but still...
            if (!current.isDetaching) {
                var unchanged = current.type === this && (isSnapshot ? value === current.snapshot : value === current.storedValue);
                if (unchanged) {
                    current.setParent(parent, subpath);
                    return current;
                }
            }
            var valueToStore = isSnapshot ? this.options.fromSnapshot(value, parent.root.environment) : value;
            var newNode = this.instantiate(parent, subpath, undefined, valueToStore);
            current.die(); // noop if detaching
            return newNode;
        }
    });
    return CustomType;
}(SimpleType);
// we import the types to re-export them inside types.
var types = {
    enumeration: enumeration,
    model: model,
    compose: compose,
    custom: custom,
    reference: reference,
    safeReference: safeReference,
    union: union,
    optional: optional,
    literal: literal,
    maybe: maybe,
    maybeNull: maybeNull,
    refinement: refinement,
    string: string,
    boolean: boolean,
    number: number,
    integer: integer,
    float: float,
    finite: finite,
    Date: DatePrimitive,
    map: map,
    array: array,
    frozen: frozen,
    identifier: identifier,
    identifierNumber: identifierNumber,
    late: late,
    lazy: lazy,
    undefined: undefinedType,
    null: nullType,
    snapshotProcessor: snapshotProcessor
};

});
parcelRegister("ibaza", function(module, exports) {
// shim for using process in browser
var $d3c1734dacb01657$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $d3c1734dacb01657$var$cachedSetTimeout;
var $d3c1734dacb01657$var$cachedClearTimeout;
function $d3c1734dacb01657$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $d3c1734dacb01657$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        else $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        else $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    }
})();
function $d3c1734dacb01657$var$runTimeout(fun) {
    if ($d3c1734dacb01657$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedSetTimeout === $d3c1734dacb01657$var$defaultSetTimout || !$d3c1734dacb01657$var$cachedSetTimeout) && setTimeout) {
        $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $d3c1734dacb01657$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $d3c1734dacb01657$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $d3c1734dacb01657$var$runClearTimeout(marker) {
    if ($d3c1734dacb01657$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedClearTimeout === $d3c1734dacb01657$var$defaultClearTimeout || !$d3c1734dacb01657$var$cachedClearTimeout) && clearTimeout) {
        $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $d3c1734dacb01657$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $d3c1734dacb01657$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $d3c1734dacb01657$var$queue = [];
var $d3c1734dacb01657$var$draining = false;
var $d3c1734dacb01657$var$currentQueue;
var $d3c1734dacb01657$var$queueIndex = -1;
function $d3c1734dacb01657$var$cleanUpNextTick() {
    if (!$d3c1734dacb01657$var$draining || !$d3c1734dacb01657$var$currentQueue) return;
    $d3c1734dacb01657$var$draining = false;
    if ($d3c1734dacb01657$var$currentQueue.length) $d3c1734dacb01657$var$queue = $d3c1734dacb01657$var$currentQueue.concat($d3c1734dacb01657$var$queue);
    else $d3c1734dacb01657$var$queueIndex = -1;
    if ($d3c1734dacb01657$var$queue.length) $d3c1734dacb01657$var$drainQueue();
}
function $d3c1734dacb01657$var$drainQueue() {
    if ($d3c1734dacb01657$var$draining) return;
    var timeout = $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$cleanUpNextTick);
    $d3c1734dacb01657$var$draining = true;
    var len = $d3c1734dacb01657$var$queue.length;
    while(len){
        $d3c1734dacb01657$var$currentQueue = $d3c1734dacb01657$var$queue;
        $d3c1734dacb01657$var$queue = [];
        while(++$d3c1734dacb01657$var$queueIndex < len)if ($d3c1734dacb01657$var$currentQueue) $d3c1734dacb01657$var$currentQueue[$d3c1734dacb01657$var$queueIndex].run();
        $d3c1734dacb01657$var$queueIndex = -1;
        len = $d3c1734dacb01657$var$queue.length;
    }
    $d3c1734dacb01657$var$currentQueue = null;
    $d3c1734dacb01657$var$draining = false;
    $d3c1734dacb01657$var$runClearTimeout(timeout);
}
$d3c1734dacb01657$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $d3c1734dacb01657$var$queue.push(new $d3c1734dacb01657$var$Item(fun, args));
    if ($d3c1734dacb01657$var$queue.length === 1 && !$d3c1734dacb01657$var$draining) $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$drainQueue);
};
// v8 likes predictible objects
function $d3c1734dacb01657$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$d3c1734dacb01657$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$d3c1734dacb01657$var$process.title = "browser";
$d3c1734dacb01657$var$process.browser = true;
$d3c1734dacb01657$var$process.env = {};
$d3c1734dacb01657$var$process.argv = [];
$d3c1734dacb01657$var$process.version = ""; // empty string to avoid regexp issues
$d3c1734dacb01657$var$process.versions = {};
function $d3c1734dacb01657$var$noop() {}
$d3c1734dacb01657$var$process.on = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.addListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.once = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.off = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeAllListeners = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.emit = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependOnceListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.listeners = function(name) {
    return [];
};
$d3c1734dacb01657$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$d3c1734dacb01657$var$process.cwd = function() {
    return "/";
};
$d3c1734dacb01657$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$d3c1734dacb01657$var$process.umask = function() {
    return 0;
};

});



parcelRegister("J29T0", function(module, exports) {
"use strict";
var $0875e0b548893cce$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(e, t, a, r) {
    void 0 === r && (r = a);
    var o = Object.getOwnPropertyDescriptor(t, a);
    o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
        enumerable: !0,
        get: function() {
            return t[a];
        }
    }), Object.defineProperty(e, r, o);
} : function(e, t, a, r) {
    void 0 === r && (r = a), e[r] = t[a];
}), $0875e0b548893cce$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(e, t) {
    Object.defineProperty(e, "default", {
        enumerable: !0,
        value: t
    });
} : function(e, t) {
    e.default = t;
}), $0875e0b548893cce$var$__importStar = module.exports && module.exports.__importStar || function(e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for(var a in e)"default" !== a && Object.prototype.hasOwnProperty.call(e, a) && $0875e0b548893cce$var$__createBinding(t, e, a);
    return $0875e0b548893cce$var$__setModuleDefault(t, e), t;
}, $0875e0b548893cce$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.ImageElement = module.exports.useImageLoader = module.exports.setImageLoaderHook = void 0;

const $0875e0b548893cce$var$react_1 = $0875e0b548893cce$var$__importDefault((parcelRequire("8NFma")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

var $2SBKn = parcelRequire("2SBKn");
parcelRequire("k3LwQ");
var $fBZlQ = parcelRequire("fBZlQ");

const $0875e0b548893cce$var$use_image_1 = $0875e0b548893cce$var$__importDefault((parcelRequire("fY5ZF")));

const $0875e0b548893cce$var$konva_1 = $0875e0b548893cce$var$__importDefault((parcelRequire("ciNAD")));
parcelRequire("7TL1v");
var $eQWOP = parcelRequire("eQWOP");

var $4WWR6 = parcelRequire("4WWR6");

var $l4lre = parcelRequire("l4lre");

const $0875e0b548893cce$var$svg = $0875e0b548893cce$var$__importStar((parcelRequire("eRGXT")));

var $gS5ZA = parcelRequire("gS5ZA");

var $aWsdH = parcelRequire("aWsdH");

var $9uXpD = parcelRequire("9uXpD");

var $3pcZ0 = parcelRequire("3pcZ0");
function $0875e0b548893cce$var$createCanvas() {
    return document.createElement("canvas");
}
async function $0875e0b548893cce$var$getFixedUrl(e) {
    if (!(e.indexOf("data:image/svg+xml") >= 0 || e.indexOf(".svg") >= 0)) return e;
    const t = await $0875e0b548893cce$var$svg.urlToString(e), a = $0875e0b548893cce$var$svg.fixSize(t);
    return $0875e0b548893cce$var$svg.svgToURL(a);
}
const $0875e0b548893cce$var$useSizeFixer = (e)=>{
    const [t, a] = $0875e0b548893cce$var$react_1.default.useState(e);
    return $0875e0b548893cce$var$react_1.default.useEffect(()=>{
        (async ()=>{
            const r = await $0875e0b548893cce$var$getFixedUrl(e);
            r !== t && a(r);
        })();
    }, [
        e
    ]), t;
};
function $0875e0b548893cce$var$getDistance(e, t) {
    return Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2));
}
function $0875e0b548893cce$var$getCenter(e, t) {
    return {
        x: (e.x + t.x) / 2,
        y: (e.y + t.y) / 2
    };
}
const $0875e0b548893cce$var$useFlip = (e, t, a)=>{
    const r = $0875e0b548893cce$var$react_1.default.useMemo(()=>{
        var r, o;
        const { flipX: i, flipY: n } = e, h = "svg" === e.type || e.src.indexOf("data:image/svg+xml") >= 0 || e.src.indexOf(".svg") >= 0, c = navigator.userAgent.toLowerCase().indexOf("firefox") > -1 && h || e.maskSrc;
        if (!i && !n && !c) return t;
        if (!t || !t.width || !t.height) return null;
        const d = $0875e0b548893cce$var$createCanvas();
        let l = 1;
        "svg" === e.type && (l = Math.max(e.a.width / t.width * a, e.a.height / t.height * a)), d.width = Math.max(t.width * l, 1), d.height = Math.max(t.height * l, 1);
        let s = i ? -d.width : 0, u = n ? -d.height : 0;
        return null === (r = d.getContext("2d")) || void 0 === r || r.scale(i ? -1 : 1, n ? -1 : 1), null === (o = d.getContext("2d")) || void 0 === o || o.drawImage(t, s, u, d.width, d.height), d;
    }, [
        e.maskSrc,
        e.flipX,
        e.flipY,
        t,
        e.a.width,
        e.a.height,
        a
    ]);
    return $0875e0b548893cce$var$react_1.default.useEffect(()=>()=>{
            r && "CANVAS" === r.nodeName && $0875e0b548893cce$var$konva_1.default.Util.releaseCanvas(r);
        }, [
        r
    ]), r;
};
function $0875e0b548893cce$var$getCrop(e, t) {
    const a = t.width / t.height;
    let r, o;
    a >= e.width / e.height ? (r = e.width, o = e.width / a) : (r = e.height * a, o = e.height);
    return {
        x: (e.width - r) / 2,
        y: (e.height - o) / 2,
        width: r,
        height: o
    };
}
function $0875e0b548893cce$var$downsample(e, t, a, r, o, i, n) {
    for(var h = new ImageData(t, a), c = new Int32Array(e.data.buffer), d = e.width, l = new Int32Array(h.data.buffer), s = h.width, u = t / i, g = a / n, f = Math.round(1 / u), p = Math.round(1 / g), _ = f * p, m = 0; m < h.height; m++)for(var w = 0; w < s; w++){
        for(var x = r + Math.round(w / u) + (o + Math.round(m / g)) * d, v = 0, y = 0, M = 0, b = 0, E = 0; E < p; E++)for(var k = 0; k < f; k++){
            var C = c[x + k + E * d];
            v += C << 24 >>> 24, y += C << 16 >>> 24, M += C << 8 >>> 24, b += C >>> 24;
        }
        v = Math.round(v / _), y = Math.round(y / _), M = Math.round(M / _), b = Math.round(b / _), l[w + m * s] = b << 24 | M << 16 | y << 8 | v;
    }
    return h;
}
function $0875e0b548893cce$var$downScaleCanvas(e, t) {
    var a, r;
    const o = $0875e0b548893cce$var$createCanvas();
    o.width = e.width, o.height = e.height;
    const i = Math.max(1, Math.floor(o.width * t)), n = Math.max(1, Math.floor(o.height * t));
    null === (a = o.getContext("2d")) || void 0 === a || a.drawImage(e, 0, 0, o.width, o.height);
    const h = $0875e0b548893cce$var$downsample(o.getContext("2d").getImageData(0, 0, o.width, o.height), i, n, 0, 0, o.width, o.height);
    return o.width = i, o.height = n, null === (r = o.getContext("2d")) || void 0 === r || r.putImageData(h, 0, 0), o;
}
const $0875e0b548893cce$var$useMask = (e, t)=>{
    const [a, r] = $0875e0b548893cce$var$useImageHook(e.maskSrc, "anonymous"), o = e.maskSrc ? r : "loaded";
    return (0, module.exports.useImageLoader)(o, e.id + "-mask"), $0875e0b548893cce$var$react_1.default.useMemo(()=>{
        if (!a) return t;
        if (!t || !t.width || !t.height) return t;
        const r = $0875e0b548893cce$var$createCanvas();
        r.width = Math.max(t.width, 1), r.height = Math.max(t.height, 1);
        const o = r.getContext("2d");
        if (!o) return t;
        o.drawImage(t, 0, 0), o.globalCompositeOperation = "source-in";
        const i = $0875e0b548893cce$var$getCrop(a, e);
        return o.drawImage(a, i.x, i.y, i.width, i.height, 0, 0, t.width, t.height), r;
    }, [
        t,
        a,
        e.a.width,
        e.a.height
    ]);
}, $0875e0b548893cce$var$useCornerRadiusAndCrop = (e, t, a, r, o = 0, i = !1)=>{
    const n = Math.floor(Math.max(e.a.width * r, 1)), h = Math.floor(Math.max(e.a.height * r, 1)), c = Math.min(o * r, n / 2, h / 2), d = Math.max(e.a.width / a.width, e.a.height / a.height) * r, l = e.page._exporting && $gS5ZA.flags.imageDownScalingEnabled && d < 1 && !i, s = 0 === a.x && 0 === a.y && a.width === (null == t ? void 0 : t.width) && a.height === (null == t ? void 0 : t.height), u = $0875e0b548893cce$var$react_1.default.useMemo(()=>{
        if (!t || !t.width || !t.height) return;
        return s && 0 === c && !l ? void 0 : $0875e0b548893cce$var$createCanvas();
    }, [
        t,
        c,
        l,
        s
    ]);
    return $0875e0b548893cce$var$react_1.default.useLayoutEffect(()=>{
        if (!u || !t) return;
        u.width = n, u.height = h;
        const e = u.getContext("2d");
        if (!e) return;
        c && (e.beginPath(), e.moveTo(c, 0), e.lineTo(n - c, 0), e.arc(n - c, c, c, 3 * Math.PI / 2, 0, !1), e.lineTo(n, h - c), e.arc(n - c, h - c, c, 0, Math.PI / 2, !1), e.lineTo(c, h), e.arc(c, h - c, c, Math.PI / 2, Math.PI, !1), e.lineTo(0, c), e.arc(c, c, c, Math.PI, 3 * Math.PI / 2, !1), e.clip());
        const r = l ? $0875e0b548893cce$var$downScaleCanvas(t, d) : t, o = l ? {
            x: Math.floor(a.x * d),
            y: Math.floor(a.y * d),
            width: Math.floor(a.width * d),
            height: Math.floor(a.height * d)
        } : a;
        e.drawImage(r, o.x, o.y, o.width, o.height, 0, 0, u.width, u.height);
    }, [
        u,
        e.a.width,
        e.a.height,
        a.x,
        a.y,
        a.width,
        a.height,
        o,
        r,
        i,
        e.page._exporting,
        l
    ]), $0875e0b548893cce$var$react_1.default.useEffect(()=>()=>{
            u && "CANVAS" === u.nodeName && $0875e0b548893cce$var$konva_1.default.Util.releaseCanvas(u);
        }, [
        u
    ]), u || t;
}, $0875e0b548893cce$var$useClip = (e, t, a, r)=>{
    const o = $0875e0b548893cce$var$useSizeFixer(e.clipSrc || ""), [i, n] = $0875e0b548893cce$var$useImageHook(o, "anonymous"), h = e.clipSrc ? n : "loaded";
    (0, module.exports.useImageLoader)(h, e.id + "-clip");
    const c = $0875e0b548893cce$var$react_1.default.useMemo(()=>{
        if (t && i) return $0875e0b548893cce$var$createCanvas();
    }, [
        t,
        i
    ]);
    $0875e0b548893cce$var$react_1.default.useLayoutEffect(()=>{
        var r;
        if (!i) return;
        if (!t || !t.width || !t.height) return;
        if (!i || !i.width || !i.height) return;
        if (!c) return;
        const o = $0875e0b548893cce$var$createCanvas(), n = Math.max(e.a.width / i.width * a, e.a.height / i.height * a);
        o.width = i.width * n, o.height = i.height * n, null === (r = o.getContext("2d")) || void 0 === r || r.drawImage(i, 0, 0, o.width, o.height), c.width = Math.max(t.width, 1), c.height = Math.max(t.height, 1);
        const h = c.getContext("2d");
        h && (h.save(), h.drawImage(o, 0, 0, t.width, t.height), $0875e0b548893cce$var$konva_1.default.Util.releaseCanvas(o), h.globalCompositeOperation = "source-in", h.drawImage(t, 0, 0, c.width, c.height), h.restore());
    }, [
        c,
        t,
        i,
        e.a.width,
        e.a.height,
        a,
        ...r
    ]);
    return e.clipSrc && i ? c : t;
}, $0875e0b548893cce$var$PLACEHOLDER_CANVAS = $0875e0b548893cce$var$createCanvas(), $0875e0b548893cce$var$LoadingPlaceholder = (0, $O1ETn.observer)(({ element: e })=>{
    const t = Math.min(30, e.a.width / 4, e.a.height / 4), a = $0875e0b548893cce$var$react_1.default.useRef(null);
    return $0875e0b548893cce$var$react_1.default.useEffect(()=>{
        const e = a.current;
        if (!e) return;
        const t = new $0875e0b548893cce$var$konva_1.default.Animation((t)=>{
            e.rotate(((null == t ? void 0 : t.timeDiff) || 0) / 2);
        }, e.getLayer());
        return t.start(), ()=>{
            t.stop();
        };
    }), $0875e0b548893cce$var$react_1.default.createElement($fBZlQ.Group, {
        x: e.x,
        y: e.y,
        rotation: e.rotation,
        listening: !1,
        opacity: e.a.opacity,
        hideInExport: !e.showInExport
    }, $0875e0b548893cce$var$react_1.default.createElement($fBZlQ.Rect, {
        width: e.a.width,
        height: e.a.height,
        fill: "rgba(124, 173, 212, 0.8)"
    }), $0875e0b548893cce$var$react_1.default.createElement($fBZlQ.Arc, {
        ref: a,
        x: e.a.width / 2,
        y: e.a.height / 2,
        fill: "white",
        outerRadius: Math.abs(t),
        innerRadius: Math.max(1, t - 5),
        angle: 270
    }));
}), $0875e0b548893cce$var$ErrorPlaceholder = (0, $O1ETn.observer)(({ element: e })=>{
    const t = "Can not load the image...", a = Math.max(10, Math.min(30, e.a.width / 25));
    return $0875e0b548893cce$var$react_1.default.createElement($fBZlQ.Group, {
        x: e.x,
        y: e.y,
        rotation: e.rotation,
        listening: !1,
        opacity: e.a.opacity,
        hideInExport: !e.showInExport
    }, $0875e0b548893cce$var$react_1.default.createElement($fBZlQ.Rect, {
        width: e.a.width,
        height: e.a.height,
        fill: "rgba(223, 102, 102, 0.8)"
    }), $0875e0b548893cce$var$react_1.default.createElement($fBZlQ.Text, {
        text: t,
        fontSize: a,
        width: e.a.width,
        height: e.a.height,
        align: "center",
        fill: "white",
        verticalAlign: "middle",
        padding: 5
    }));
});
let $0875e0b548893cce$var$useImageHook = $0875e0b548893cce$var$use_image_1.default;
const $0875e0b548893cce$var$setImageLoaderHook = (e)=>{
    $0875e0b548893cce$var$useImageHook = e;
};
module.exports.setImageLoaderHook = $0875e0b548893cce$var$setImageLoaderHook;
const $0875e0b548893cce$var$useImageLoader = (e, t)=>{
    const a = $0875e0b548893cce$var$react_1.default.useRef(), r = ()=>{
        var e;
        null === (e = a.current) || void 0 === e || e.call(a), a.current = void 0;
    };
    $0875e0b548893cce$var$react_1.default.useEffect(()=>r, []), $0875e0b548893cce$var$react_1.default.useLayoutEffect(()=>{
        "loading" !== e || a.current || (a.current = (0, $l4lre.incrementLoader)(`image ${t}`)), "loading" !== e && r(), "failed" === e && (0, $l4lre.triggerLoadError)(`image ${t}`);
    }, [
        e
    ]);
};
module.exports.useImageLoader = $0875e0b548893cce$var$useImageLoader;
const $0875e0b548893cce$var$usePreviousImage = ({ image: e, status: t, type: a })=>{
    const r = $0875e0b548893cce$var$react_1.default.useRef();
    $0875e0b548893cce$var$react_1.default.useEffect(()=>{
        r.current = e || r.current;
    }, [
        e
    ]);
    return "failed" !== t || "failed" !== t && "svg" === a ? r.current : void 0;
}, $0875e0b548893cce$var$useImageSource = (e)=>{
    const [t, a] = $0875e0b548893cce$var$react_1.default.useReducer((e)=>e + 1, 0), r = $0875e0b548893cce$var$react_1.default.useRef("loading"), o = $0875e0b548893cce$var$react_1.default.useRef(e.src), i = $0875e0b548893cce$var$react_1.default.useRef(e.src);
    return i.current !== e.src && (i.current = e.src, r.current = "loading"), $0875e0b548893cce$var$react_1.default.useEffect(()=>{
        if ("svg" !== e.type) return;
        if (!e.src) return;
        let t = !1;
        return (async ()=>{
            r.current = "loading", a();
            const i = await $0875e0b548893cce$var$svg.urlToString(e.src), n = $0875e0b548893cce$var$svg.fixSize(i), h = $0875e0b548893cce$var$svg.replaceColors(n, e.colorsReplace);
            t || (o.current = h, r.current = "loaded", a());
        })(), ()=>{
            t = !0;
        };
    }, [
        e.src,
        JSON.stringify(e.colorsReplace)
    ]), "svg" !== e.type ? [
        e.src,
        "loaded"
    ] : [
        o.current,
        r.current
    ];
};
module.exports.ImageElement = (0, $O1ETn.observer)(({ element: e, store: t })=>{
    var a;
    const [r, o] = $0875e0b548893cce$var$react_1.default.useState(!1), i = $0875e0b548893cce$var$react_1.default.useRef(null), n = $0875e0b548893cce$var$react_1.default.useRef(null), [h, c] = $0875e0b548893cce$var$react_1.default.useState(!1), d = t.selectedElements.indexOf(e) >= 0, [l, s] = $0875e0b548893cce$var$useImageSource(e), [u, g] = $0875e0b548893cce$var$useImageHook(l, "anonymous"), f = "svg" !== e.type || "loaded" === s ? g : "loading";
    (0, module.exports.useImageLoader)(f, e.id);
    const p = $0875e0b548893cce$var$usePreviousImage({
        image: u,
        status: g,
        type: e.type
    }), _ = $0875e0b548893cce$var$useMask(e, $0875e0b548893cce$var$useFlip(e, u || p, t._elementsPixelRatio)) || $0875e0b548893cce$var$PLACEHOLDER_CANVAS;
    let { cropX: m, cropY: w, cropWidth: x, cropHeight: v } = e;
    "loaded" !== g && (m = w = 0, x = v = 1);
    const y = _.width * x, M = _.height * v, b = e.a.width / e.a.height;
    let E, k;
    const C = y / M, I = "svg" === e.type;
    I ? (E = y, k = M) : b >= C ? (E = y, k = y / b) : (E = M * b, k = M);
    const S = {
        x: _.width * m,
        y: _.height * w,
        width: E,
        height: k
    }, R = null !== (a = e.cornerRadius) && void 0 !== a ? a : 0, O = e.page._exporting ? 1 : Math.min(2, t.scale), D = t._elementsPixelRatio * O;
    let L = $0875e0b548893cce$var$useClip(e, $0875e0b548893cce$var$useCornerRadiusAndCrop(e, _, S, D, R, r || e._cropModeEnabled || "svg" === e.type), D, [
        S,
        R,
        D
    ]);
    const P = Math.max(e.a.width / E, e.a.height / k);
    $0875e0b548893cce$var$react_1.default.useEffect(()=>{
        var t;
        if (!e._cropModeEnabled) return;
        const a = null === (t = i.current) || void 0 === t ? void 0 : t.getStage();
        function r(t) {
            e._cropModeEnabled && t.target !== n.current && e.toggleCropMode(!1);
        }
        function o(t) {
            e._cropModeEnabled && t.target.parentNode !== a.content && e.toggleCropMode(!1);
        }
        return document.body.addEventListener("click", o), null == a || a.on("click", r), null == a || a.on("tap", r), ()=>{
            document.body.removeEventListener("click", o), document.body.removeEventListener("touchstart", o), null == a || a.off("click", r), null == a || a.off("click", r);
        };
    }, [
        e._cropModeEnabled
    ]), $0875e0b548893cce$var$react_1.default.useLayoutEffect(()=>{
        if (r || e._cropModeEnabled) return;
        (0, $aWsdH.applyFilter)(i.current, e);
        return (0, $2SBKn.autorun)(()=>{
            (0, $aWsdH.applyFilter)(i.current, e);
        }, {
            delay: 100
        });
    }, [
        L,
        e.page._exporting,
        r,
        x,
        v,
        e._cropModeEnabled
    ]), $0875e0b548893cce$var$react_1.default.useLayoutEffect(()=>{
        var t;
        r || e._cropModeEnabled ? null === (t = i.current) || void 0 === t || t.clearCache() : (0, $aWsdH.applyFilter)(i.current, e);
    }, [
        r,
        e.a.width,
        e.a.height,
        e._cropModeEnabled
    ]), $0875e0b548893cce$var$react_1.default.useEffect(()=>{
        (0, $aWsdH.applyFilter)(i.current, e);
    }, [
        e.shadowEnabled,
        e.shadowBlur,
        e.cornerRadius,
        e.shadowColor,
        e.shadowOffsetX,
        e.shadowOffsetY,
        e.shadowOpacity
    ]);
    const X = $0875e0b548893cce$var$react_1.default.useRef(null), Y = $0875e0b548893cce$var$react_1.default.useRef(null), A = $0875e0b548893cce$var$react_1.default.useRef(null);
    $0875e0b548893cce$var$react_1.default.useLayoutEffect(()=>{
        e._cropModeEnabled && (Y.current.nodes([
            X.current
        ]), A.current.nodes([
            n.current
        ]));
    }, [
        e._cropModeEnabled
    ]);
    var H = $0875e0b548893cce$var$react_1.default.useRef(null), T = $0875e0b548893cce$var$react_1.default.useRef(0), W = $0875e0b548893cce$var$react_1.default.useRef(!1);
    const q = (t)=>{
        var a;
        (null === (a = t.evt.touches) || void 0 === a ? void 0 : a.length) > 2 && t.target.stopDrag(), Math.round(t.target.x()) > 0 && (t.target.x(0), t.target.scaleX(1)), Math.round(t.target.y()) > 0 && (t.target.y(0), t.target.scaleY(1));
        const r = t.target.width() * t.target.scaleX(), o = t.target.height() * t.target.scaleY(), i = Math.min(1, E / r), n = Math.min(1, k / o), h = 1 - i, c = Math.min(h, Math.max(0, Math.round(-t.target.x()) / r)), d = 1 - n, l = Math.min(d, Math.max(0, Math.round(-t.target.y()) / o));
        t.target.setAttrs({
            x: -c * _.width,
            y: -l * _.height,
            scaleX: 1,
            scaleY: 1
        }), e.set({
            cropX: c,
            cropY: l,
            cropWidth: i,
            cropHeight: n
        });
    }, F = ()=>{
        "svg" !== e.type && e.contentEditable && setTimeout(()=>{
            e.toggleCropMode(!0);
        });
    }, z = "svg" === e.type && p, B = "loading" === g && !z, N = "failed" === g, j = !B && !N, U = $0875e0b548893cce$var$react_1.default.useRef({
        cropX: 0,
        cropY: 0,
        cropWidth: 0,
        cropHeight: 0
    }), V = j ? e.a.opacity : 0;
    (0, $9uXpD.useFadeIn)(i, V);
    const G = e.selectable || "admin" === t.role, $ = (0, $3pcZ0.useMobile)();
    return $0875e0b548893cce$var$react_1.default.createElement($0875e0b548893cce$var$react_1.default.Fragment, null, B && $0875e0b548893cce$var$react_1.default.createElement($0875e0b548893cce$var$LoadingPlaceholder, {
        element: e
    }), N && $0875e0b548893cce$var$react_1.default.createElement($0875e0b548893cce$var$ErrorPlaceholder, {
        element: e
    }), $0875e0b548893cce$var$react_1.default.createElement($fBZlQ.Image, {
        ref: i,
        name: "element",
        id: e.id,
        image: L,
        x: e.a.x,
        y: e.a.y,
        width: e.a.width || 1,
        height: e.a.height || 1,
        rotation: e.rotation,
        opacity: V,
        shadowEnabled: e.shadowEnabled,
        shadowBlur: e.shadowBlur,
        shadowOffsetX: e.shadowOffsetX,
        shadowOffsetY: e.shadowOffsetY,
        shadowColor: e.shadowColor,
        shadowOpacity: e.shadowOpacity,
        customCrop: S,
        listening: G,
        draggable: $ ? e.draggable && d : e.draggable,
        preventDefault: !$ || d,
        hideInExport: !e.showInExport,
        onMouseEnter: ()=>{
            c(!0);
        },
        onMouseLeave: ()=>{
            c(!1);
        },
        onDragMove: (t)=>{
            e.set({
                x: t.target.x(),
                y: t.target.y()
            });
        },
        onDragEnd: (t)=>{
            e.set({
                x: t.target.x(),
                y: t.target.y()
            });
        },
        onDblClick: F,
        onDblTap: F,
        onTransformStart: ()=>{
            o(!0), U.current = {
                cropX: e.cropX,
                cropY: e.cropY,
                cropWidth: e.cropWidth,
                cropHeight: e.cropHeight
            };
        },
        onTransform: (t)=>{
            var a;
            const r = t.currentTarget, o = Math.abs(r.scaleX() - 1) < 1e-7 ? 1 : r.scaleX(), i = Math.abs(r.scaleY() - 1) < 1e-7 ? 1 : r.scaleY();
            r.scaleX(1), r.scaleY(1);
            const n = null === (a = t.target.getStage()) || void 0 === a ? void 0 : a.findOne("Transformer"), h = 1 - E / _.width, c = Math.min(h, Math.max(0, e.cropX)), d = 1 - k / _.height, l = Math.min(d, Math.max(0, e.cropY)), s = n.getActiveAnchor(), u = !(s.indexOf("middle") >= 0 || s.indexOf("center") >= 0), g = !u && o < 1 && U.current.cropHeight > k / _.height;
            let f = u ? e.cropWidth : e.cropWidth * o;
            g && (f = e.cropWidth);
            const p = !u && i < 1 && U.current.cropWidth > E / _.width;
            let m = u ? e.cropHeight : e.cropHeight * i;
            p && (m = e.cropHeight), I && (f = e.cropWidth, m = e.cropHeight), e.set({
                cropX: c,
                cropY: l,
                x: r.x(),
                y: r.y(),
                width: r.width() * o,
                height: r.height() * i,
                rotation: t.target.rotation(),
                cropWidth: Math.min(f, 1 - c),
                cropHeight: Math.min(m, 1 - l)
            });
        },
        onTransformEnd: (t)=>{
            const a = t.currentTarget;
            e.set({
                width: a.width(),
                height: a.height(),
                x: a.x(),
                y: a.y(),
                rotation: t.target.rotation(),
                cropWidth: E / _.width,
                cropHeight: k / _.height
            }), o(!1);
        }
    }), $0875e0b548893cce$var$react_1.default.createElement($fBZlQ.Rect, {
        x: e.x,
        y: e.y,
        width: Math.max(e.a.width - e.borderSize, 0),
        height: Math.max(e.a.height - e.borderSize, 0),
        opacity: V,
        offsetX: -e.borderSize / 2,
        offsetY: -e.borderSize / 2,
        stroke: e.borderColor,
        strokeWidth: e.borderSize,
        listening: !1,
        visible: !!e.borderSize,
        rotation: e.rotation,
        cornerRadius: Math.max(0, R - e.borderSize),
        hideInExport: !e.showInExport
    }), e._cropModeEnabled && $0875e0b548893cce$var$react_1.default.createElement($eQWOP.Portal, {
        selector: ".page-abs-container",
        enabled: !0
    }, $0875e0b548893cce$var$react_1.default.createElement($fBZlQ.Rect, {
        x: -window.innerWidth / t.scale,
        y: -window.innerWidth / t.scale,
        width: window.innerWidth / t.scale * 3,
        height: window.innerWidth / t.scale * 3,
        fill: "rgba(0,0,0,0.3)"
    }), $0875e0b548893cce$var$react_1.default.createElement($fBZlQ.Image, {
        listening: !1,
        image: L,
        x: e.x,
        y: e.y,
        width: e.a.width,
        height: e.a.height,
        rotation: e.rotation,
        shadowEnabled: e.shadowEnabled,
        shadowBlur: e.shadowBlur
    }), $0875e0b548893cce$var$react_1.default.createElement($fBZlQ.Group, {
        x: e.x,
        y: e.y,
        rotation: e.rotation,
        scaleX: P,
        scaleY: P
    }, $0875e0b548893cce$var$react_1.default.createElement($fBZlQ.Image, {
        image: _,
        ref: n,
        opacity: .4,
        draggable: !0,
        x: -e.cropX * _.width,
        y: -e.cropY * _.height,
        onDragMove: q,
        onTransform: q,
        onTouchMove: (e)=>{
            e.evt.preventDefault();
            const t = e.target.getStage().getPointersPositions();
            var a = t[0], r = t[1];
            const o = e.target;
            if (a && !r && !o.isDragging() && W.current && (o.startDrag(), W.current = !1), a && r) {
                $0875e0b548893cce$var$konva_1.default.hitOnDragEnabled = !0, o.isDragging() && (W.current = !0, o.stopDrag());
                const t = e.target.getAbsoluteTransform().copy();
                t.invert();
                var i = {
                    x: a.x,
                    y: a.y
                }, n = {
                    x: r.x,
                    y: r.y
                };
                if (!H.current) return void (H.current = $0875e0b548893cce$var$getCenter(i, n));
                var h = $0875e0b548893cce$var$getCenter(i, n), c = $0875e0b548893cce$var$getDistance(i, n);
                T.current || (T.current = c);
                const f = o.position();
                var d = {
                    x: h.x - f.x,
                    y: h.y - f.y
                }, l = c / T.current;
                o.scaleX(l), o.scaleY(l);
                const p = t.point(h), _ = t.point(H.current);
                var s = p.x - _.x, u = p.y - _.y, g = {
                    x: Math.min(0, h.x - d.x * l + s),
                    y: Math.min(0, h.y - d.y * l + u)
                };
                o.position(g), T.current = c, H.current = h, q(e);
            }
        },
        onTouchEnd: (e)=>{
            T.current = 0, H.current = null, $0875e0b548893cce$var$konva_1.default.hitOnDragEnabled = !1;
        }
    }), $0875e0b548893cce$var$react_1.default.createElement($fBZlQ.Transformer, {
        ref: A,
        anchorSize: 20,
        enabledAnchors: [
            "top-left",
            "top-right",
            "bottom-left",
            "bottom-right"
        ],
        boundBoxFunc: (e, t)=>t.width < 5 || t.height < 5 ? e : t,
        rotateEnabled: !1,
        borderEnabled: !1,
        anchorCornerRadius: 10,
        anchorStrokeWidth: 2,
        borderStrokeWidth: 2
    }), $0875e0b548893cce$var$react_1.default.createElement($fBZlQ.Rect, {
        width: E,
        height: k,
        ref: X,
        listening: !1,
        onTransform: (t)=>{
            t.target.x() < -e.cropX * _.width - 1e-9 && (t.target.x(-e.cropX * _.width), t.target.scaleX(1)), t.target.y() < -e.cropY * _.height - 1e-9 && (t.target.y(-e.cropY * _.height), t.target.scaleY(1));
            const a = Math.min(1, Math.max(0, e.cropX + t.target.x() / _.width)), r = Math.min(1, Math.max(0, t.target.y() / _.height + e.cropY)), o = t.target.width() * t.target.scaleX(), i = t.target.height() * t.target.scaleY(), n = Math.min(1 - a, o / _.width), h = Math.min(1 - r, i / _.height), c = t.target.getAbsolutePosition(t.target.getParent().getParent());
            t.target.scale({
                x: 1,
                y: 1
            }), t.target.position({
                x: 0,
                y: 0
            }), e.set({
                x: c.x,
                y: c.y,
                cropX: a,
                cropY: r,
                cropWidth: n,
                cropHeight: h,
                width: Math.min(o * P, _.width * (1 - a) * P),
                height: Math.min(i * P, _.height * (1 - r) * P)
            });
        }
    }), $0875e0b548893cce$var$react_1.default.createElement($fBZlQ.Transformer, {
        ref: Y,
        enabledAnchors: [
            "top-left",
            "top-right",
            "bottom-left",
            "bottom-right"
        ],
        boundBoxFunc: (e, t)=>t.width < 5 || t.height < 5 ? e : t,
        visible: e.resizable,
        keepRatio: !1,
        rotateEnabled: !1,
        anchorFill: "rgb(240, 240, 240)",
        anchorStrokeWidth: 2,
        borderStrokeWidth: 2
    }))), (h || d) && $0875e0b548893cce$var$react_1.default.createElement($4WWR6.Highlighter, {
        element: e
    }));
});

});
parcelRegister("eRGXT", function(module, exports) {
"use strict";
var $ad2757e4360abc3d$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.useSvgColors = module.exports.replaceColors = module.exports.sameColors = module.exports.fixSize = module.exports.getSvgSize = module.exports.svgToURL = module.exports.getColors = module.exports.urlToString = module.exports.urlToBase64 = void 0;

const $ad2757e4360abc3d$var$konva_1 = $ad2757e4360abc3d$var$__importDefault((parcelRequire("ciNAD")));

const $ad2757e4360abc3d$var$react_1 = $ad2757e4360abc3d$var$__importDefault((parcelRequire("8NFma")));

var $1Jif0 = parcelRequire("1Jif0");
function $ad2757e4360abc3d$var$isInsideDef(e) {
    for(; e.parentNode;){
        if ("defs" === e.nodeName) return !0;
        e = e.parentNode;
    }
    return !1;
}
function $ad2757e4360abc3d$var$getElementColors(e) {
    const t = {
        fill: "",
        stroke: ""
    };
    if (e.getAttribute("fill") && "none" !== e.getAttribute("fill") && (t.fill = e.getAttribute("fill")), !t.fill && e.style.fill && "none" !== e.style.fill && (t.fill = e.style.fill), e.getAttribute("stroke") && (t.stroke = e.getAttribute("stroke")), !t.stroke && e.style.stroke && (t.stroke = e.style.stroke), !t.stroke && !t.fill) {
        const r = e.ownerSVGElement, o = r && r !== e && $ad2757e4360abc3d$var$getElementColors(r);
        "currentColor" === (null == o ? void 0 : o.fill) || "currentColor" === (null == o ? void 0 : o.stroke) || (t.fill = "black");
    }
    return t;
}
const $ad2757e4360abc3d$var$SVG_SHAPES = [
    "path",
    "rect",
    "circle"
];
function $ad2757e4360abc3d$var$getAllElementsWithColor(e) {
    for(var t = [], r = e.getElementsByTagName("*"), o = 0, s = r.length; o < s; o++){
        const e = r[o];
        $ad2757e4360abc3d$var$isInsideDef(e) || (null !== e.getAttribute("fill") && t.push(e), (null !== e.getAttribute("stroke") || e.style && e.style.fill || $ad2757e4360abc3d$var$SVG_SHAPES.indexOf(e.nodeName) >= 0) && t.push(e));
    }
    return t;
}
async function $ad2757e4360abc3d$var$urlToBase64(e) {
    const t = await fetch(e);
    return $ad2757e4360abc3d$var$svgToURL(await t.text());
}
async function $ad2757e4360abc3d$var$urlToString(e) {
    const t = await fetch(e, {
        mode: "cors"
    });
    return await t.text();
}
function $ad2757e4360abc3d$var$getColors(e) {
    const t = $ad2757e4360abc3d$var$getAllElementsWithColor((new DOMParser).parseFromString(e, "image/svg+xml")), r = [];
    return t.forEach((e)=>{
        const { fill: t, stroke: o } = $ad2757e4360abc3d$var$getElementColors(e);
        [
            t,
            o
        ].forEach((e)=>{
            if (!e) return;
            "currentColor" === e && (e = "black");
            $ad2757e4360abc3d$var$konva_1.default.Util.colorToRGBA(e) && -1 === r.indexOf(e) && r.push(e);
        });
    }), r;
}
function $ad2757e4360abc3d$var$svgToURL(e) {
    return "data:image/svg+xml;base64," + window.btoa(unescape(encodeURIComponent(e)));
}
async function $ad2757e4360abc3d$var$getSvgSize(e) {
    const t = await $ad2757e4360abc3d$var$urlToString(e);
    const r = (new DOMParser).parseFromString(t, "image/svg+xml").documentElement.getAttribute("viewBox"), [o, s, n, l] = (null == r ? void 0 : r.split(" ")) || [];
    return {
        width: parseFloat(n),
        height: parseFloat(l)
    };
}
function $ad2757e4360abc3d$var$fixSize(e) {
    var t = (new DOMParser).parseFromString(e, "image/svg+xml");
    const r = t.documentElement.getAttribute("viewBox"), [o, s, n, l] = (null == r ? void 0 : r.split(" ")) || [], i = t.documentElement.getAttribute("width");
    !i && t.documentElement.setAttribute("width", n + "px");
    const a = t.documentElement.getAttribute("height");
    if ((!a || a.indexOf("%") >= 0) && t.documentElement.setAttribute("height", l + "px"), i && i.indexOf("%") >= 0 && a && -1 === a.indexOf("%")) {
        const e = parseFloat(a) / parseFloat(l);
        t.documentElement.setAttribute("width", e * parseFloat(n) + "px");
    }
    if (a && a.indexOf("%") >= 0 && i && -1 === i.indexOf("%")) {
        const e = parseFloat(i) / parseFloat(n);
        t.documentElement.setAttribute("height", e * parseFloat(l) + "px");
    }
    "100%" === i && "100%" === a && (t.documentElement.setAttribute("width", n + "px"), t.documentElement.setAttribute("height", l + "px"));
    return (new XMLSerializer).serializeToString(t);
}
module.exports.urlToBase64 = $ad2757e4360abc3d$var$urlToBase64, module.exports.urlToString = $ad2757e4360abc3d$var$urlToString, module.exports.getColors = $ad2757e4360abc3d$var$getColors, module.exports.svgToURL = $ad2757e4360abc3d$var$svgToURL, module.exports.getSvgSize = $ad2757e4360abc3d$var$getSvgSize, module.exports.fixSize = $ad2757e4360abc3d$var$fixSize;
const $ad2757e4360abc3d$var$sameColors = (e, t)=>{
    if (!e || !t) return !1;
    if ("currentColor" === t && "black" === e) return !0;
    const r = $ad2757e4360abc3d$var$konva_1.default.Util.colorToRGBA(e), o = $ad2757e4360abc3d$var$konva_1.default.Util.colorToRGBA(t);
    return r && o ? r.r === o.r && r.g === o.g && r.b === o.b && r.a === o.a : void 0;
};
function $ad2757e4360abc3d$var$createGradient(e, t, r, o) {
    var s = e.namespaceURI, n = document.createElementNS(s, "linearGradient");
    const l = $ad2757e4360abc3d$var$konva_1.default.Util.degToRad(r + 90), i = (Math.cos(l) + 1) / 2, a = (Math.sin(l) + 1) / 2, u = (Math.cos(l + Math.PI) + 1) / 2, c = (Math.sin(l + Math.PI) + 1) / 2;
    n.setAttribute("x1", 100 * i + "%"), n.setAttribute("y1", 100 * a + "%"), n.setAttribute("x2", 100 * u + "%"), n.setAttribute("y2", 100 * c + "%"), n.setAttribute("gradientUnits", "userSpaceOnUse"), n.setAttribute("id", t);
    for(var f = 0; f < o.length; f++){
        var g = o[f], d = document.createElementNS(s, "stop");
        for(var p in g)g.hasOwnProperty(p) && d.setAttribute(p, g[p]);
        n.appendChild(d);
    }
    return (e.querySelector("defs") || e.insertBefore(document.createElementNS(s, "defs"), e.firstChild)).appendChild(n);
}
function $ad2757e4360abc3d$var$replaceColors(e, t) {
    var r = (new DOMParser).parseFromString(e, "image/svg+xml");
    const o = $ad2757e4360abc3d$var$getAllElementsWithColor(r), s = Array.from(t.keys());
    o.forEach((e)=>{
        const { fill: o, stroke: n } = $ad2757e4360abc3d$var$getElementColors(e);
        [
            {
                prop: "fill",
                color: o
            },
            {
                prop: "stroke",
                color: n
            }
        ].forEach(({ prop: o, color: n })=>{
            const l = s.find((e)=>(0, module.exports.sameColors)(e, n));
            if (l) {
                const s = t.get(l);
                if ((0, $1Jif0.isGradient)(s)) {
                    const { rotation: t, stops: n } = (0, $1Jif0.parseColor)(s), l = n.map((e)=>({
                            offset: 100 * e.offset + "%",
                            "stop-color": e.color
                        })), i = "color" + Math.round(1e8 * Math.random());
                    $ad2757e4360abc3d$var$createGradient(r.children[0], i, t, l), e.style[o] = null, e.setAttribute(o, `url('#${i}')`);
                } else e.style[o] = t.get(l);
            }
        });
    });
    return $ad2757e4360abc3d$var$svgToURL((new XMLSerializer).serializeToString(r));
}
module.exports.sameColors = $ad2757e4360abc3d$var$sameColors, module.exports.replaceColors = $ad2757e4360abc3d$var$replaceColors;
const $ad2757e4360abc3d$var$useSvgColors = (e)=>{
    const [t, r] = $ad2757e4360abc3d$var$react_1.default.useState([]);
    return $ad2757e4360abc3d$var$react_1.default.useEffect(()=>{
        let t = !1;
        return (async ()=>{
            r([]);
            const o = $ad2757e4360abc3d$var$getColors(await $ad2757e4360abc3d$var$urlToString(e));
            t || r(o);
        })(), ()=>{
            t = !0;
        };
    }, [
        e
    ]), t;
};
module.exports.useSvgColors = $ad2757e4360abc3d$var$useSvgColors;

});


parcelRegister("1gtCb", function(module, exports) {
"use strict";
var $0ebe41f88638a370$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(e, t, i, r) {
    void 0 === r && (r = i);
    var a = Object.getOwnPropertyDescriptor(t, i);
    a && !("get" in a ? !t.__esModule : a.writable || a.configurable) || (a = {
        enumerable: !0,
        get: function() {
            return t[i];
        }
    }), Object.defineProperty(e, r, a);
} : function(e, t, i, r) {
    void 0 === r && (r = i), e[r] = t[i];
}), $0ebe41f88638a370$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(e, t) {
    Object.defineProperty(e, "default", {
        enumerable: !0,
        value: t
    });
} : function(e, t) {
    e.default = t;
}), $0ebe41f88638a370$var$__importStar = module.exports && module.exports.__importStar || function(e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for(var i in e)"default" !== i && Object.prototype.hasOwnProperty.call(e, i) && $0ebe41f88638a370$var$__createBinding(t, e, i);
    return $0ebe41f88638a370$var$__setModuleDefault(t, e), t;
}, $0ebe41f88638a370$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.HTMLElement = module.exports.quillRef = void 0;

const $0ebe41f88638a370$var$react_1 = $0ebe41f88638a370$var$__importDefault((parcelRequire("8NFma")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");
parcelRequire("k3LwQ");
var $fBZlQ = parcelRequire("fBZlQ");

const $0ebe41f88638a370$var$quill_1 = $0ebe41f88638a370$var$__importDefault((parcelRequire("1BElU")));
parcelRequire("1YL9c");

const $0ebe41f88638a370$var$konva_1 = $0ebe41f88638a370$var$__importDefault((parcelRequire("ciNAD")));

const $0ebe41f88638a370$var$mobx = $0ebe41f88638a370$var$__importStar((parcelRequire("2SBKn")));

var $gS5ZA = parcelRequire("gS5ZA");

var $aWsdH = parcelRequire("aWsdH");

var $eQSol = parcelRequire("eQSol");

var $kWHDJ = parcelRequire("kWHDJ");

var $2o2rI = parcelRequire("2o2rI");

var $9uXpD = parcelRequire("9uXpD");

var $4WWR6 = parcelRequire("4WWR6");
parcelRequire("7TL1v");
var $1SE86 = parcelRequire("1SE86");

const $0ebe41f88638a370$var$styled_1 = $0ebe41f88638a370$var$__importDefault((parcelRequire("MPenY")));

var $l4lre = parcelRequire("l4lre");

var $8vcNW = parcelRequire("8vcNW");

const $0ebe41f88638a370$var$fonts = $0ebe41f88638a370$var$__importStar((parcelRequire("iPHWg")));

var $3pcZ0 = parcelRequire("3pcZ0");
module.exports.quillRef = $0ebe41f88638a370$var$mobx.observable({
    enabled: !1,
    currentFormat: {},
    editor: $0ebe41f88638a370$var$mobx.observable.object({
        instance: null
    }, {}, {
        deep: !1
    })
});
const $0ebe41f88638a370$var$RichTextContainer = (0, $0ebe41f88638a370$var$styled_1.default)("div", $0ebe41f88638a370$var$react_1.default.forwardRef)`
  .ql-editor {
    outline: none;
  }
  ul {
    list-style-position: inside;
    margin: 0;
  }
  p {
    line-height: auto;
    margin: 0;
  }
  strong {
    font-weight: 1800;
  }
  .ql-direction-rtl {
    direction: rtl;
  }
`, $0ebe41f88638a370$var$RichEditor = ({ html: e, onBlur: t, onChange: i, element: r })=>{
    const a = $0ebe41f88638a370$var$react_1.default.useRef(null);
    $0ebe41f88638a370$var$react_1.default.useEffect(()=>{
        if (!a.current) return;
        const e = new $0ebe41f88638a370$var$quill_1.default(a.current, {
            toolbar: !1,
            keyboard: !1,
            clipboard: {
                matchVisual: !1
            },
            formats: [
                "background",
                "bold",
                "color",
                "font",
                "italic",
                "size",
                "strike",
                "underline",
                "indent",
                "align",
                "direction"
            ]
        });
        return module.exports.quillRef.editor.instance = e, window.__polotnoQuill = e, e.on("text-change", ()=>{
            e.getSelection() && (module.exports.quillRef.currentFormat = e.getFormat()), setTimeout(()=>{
                var e;
                i(null === (e = a.current) || void 0 === e ? void 0 : e.childNodes[0].innerHTML);
            }, 10);
        }), e.setSelection(0, 0, "api"), e.on("selection-change", (i)=>{
            i || t(), i && (module.exports.quillRef.currentFormat = e.getFormat());
        }), a.current.childNodes[0].addEventListener("blur", (e)=>{
            var i;
            (null === (i = e.relatedTarget) || void 0 === i ? void 0 : i.classList.contains("ql-clipboard")) || t();
        }), ()=>{
            module.exports.quillRef.editor.instance = null, module.exports.quillRef.currentFormat = {}, delete window.__polotnoQuill;
        };
    }, []), $0ebe41f88638a370$var$react_1.default.useEffect(()=>{
        var t;
        const i = module.exports.quillRef.editor.instance;
        if (!i) return;
        const o = i.getSelection();
        if (!((null === (t = a.current) || void 0 === t ? void 0 : t.childNodes[0].innerHTML) === r.text)) {
            var n = i.clipboard.convert("<div class='ql-editor' style='outline: none;'>" + e + "<p><br></p></div>");
            i.setContents(n), i.history.clear(), o && (i.setSelection(o.index, o.length), module.exports.quillRef.currentFormat = i.getFormat());
        }
    }, [
        r.text
    ]);
    const o = (0, $kWHDJ.useColor)(r).fill;
    return $0ebe41f88638a370$var$react_1.default.createElement($0ebe41f88638a370$var$RichTextContainer, {
        ref: a,
        style: {
            fontSize: r.fontSize,
            color: o,
            width: r.a.width,
            fontFamily: r.fontFamily,
            lineHeight: r.lineHeight,
            letterSpacing: r.letterSpacing + "rem",
            textAlign: r.align
        },
        dir: (0, $eQSol.getDir)((0, $8vcNW.removeTags)(r.text))
    });
};
function $0ebe41f88638a370$var$useHtmlSize(e, t, i) {
    return $0ebe41f88638a370$var$react_1.default.useMemo(()=>(0, $2o2rI.detectSize)(e), [
        e,
        t.width,
        i
    ]);
}
function $0ebe41f88638a370$var$hasNonTransparentPixel(e) {
    const t = e.getContext("2d").getImageData(0, 0, e.width, e.height).data;
    for(let e = 0; e < t.length; e += 4)if (0 !== t[e + 3]) return !0;
    return !1;
}
function $0ebe41f88638a370$var$isCanvasBlank(e) {
    return !$0ebe41f88638a370$var$hasNonTransparentPixel(e);
}
function $0ebe41f88638a370$var$getHtml(e, { fontFamily: t = "", color: i = "black" } = {}) {
    let r = `color: ${i || e.fill}`;
    return `<div style="white-space: unset; width: ${Math.round(e.width || 100)}px; ${r}; font-size: ${e.fontSize}px; font-family: '${t}'; text-decoration: ${e.textDecoration}; text-align: ${e.align}; line-height: ${e.lineHeight}; letter-spacing: ${e.letterSpacing}rem; font-style: ${e.fontStyle}; font-weight: ${e.fontWeight}; -webkit-text-stroke: ${e.strokeWidth}px ${e.stroke};" contentEditable dir="${(0, $eQSol.getDir)((0, $8vcNW.removeTags)(e.text))}">${e.text}</div>`;
}
const $0ebe41f88638a370$var$findFitFontSize = (e)=>{
    let t = e.fontSize;
    for(let i = 1; i < 50; i++){
        const i = $0ebe41f88638a370$var$getHtml(Object.assign(Object.assign({}, e.toJSON()), {
            fontSize: t
        }), {
            fontFamily: e.fontFamily
        }), { height: r } = (0, $2o2rI.detectSize)(i);
        if (!(e.height && r > e.height)) break;
        t -= .5;
    }
    return t;
}, $0ebe41f88638a370$var$isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
module.exports.HTMLElement = (0, $O1ETn.observer)(({ element: e, store: t })=>{
    const i = $0ebe41f88638a370$var$react_1.default.useRef(null), [r, a] = $0ebe41f88638a370$var$react_1.default.useState(), [o, n] = $0ebe41f88638a370$var$react_1.default.useState(!1), [l, s] = $0ebe41f88638a370$var$react_1.default.useState(!0), [c, d] = $0ebe41f88638a370$var$react_1.default.useState(!1), u = $0ebe41f88638a370$var$react_1.default.useRef(e.height), f = t.selectedElements.indexOf(e) >= 0, h = e.fontSize / 3, { textVerticalResizeEnabled: g } = $gS5ZA.flags, _ = (0, $eQSol.usePrevious)(e.fontFamily), [m] = (0, $eQSol.useFontLoader)(t, e.fontFamily), x = e._editModeEnabled;
    (0, $9uXpD.useFadeIn)(i);
    const p = m ? e.fontFamily : _ !== e.fontFamily ? _ : "Arial", y = (0, $kWHDJ.useColor)(e).fill, v = $0ebe41f88638a370$var$getHtml(e, {
        fontFamily: p,
        color: y
    }), { width: b, height: w } = $0ebe41f88638a370$var$useHtmlSize(v, e, m);
    $0ebe41f88638a370$var$react_1.default.useEffect(()=>{
        if (!m) return;
        if (!e.height) return void e.set({
            height: w
        });
        const { textOverflow: i } = $gS5ZA.flags;
        if ("change-font-size" !== i || o) "resize" === i && (g && e.height < w && t.history.ignore(()=>{
            e.set({
                height: w
            });
        }), g || e.height === w || t.history.ignore(()=>{
            e.set({
                height: w
            });
        }));
        else {
            const i = $0ebe41f88638a370$var$findFitFontSize(e);
            i !== e.fontSize ? t.history.ignore(()=>{
                e.set({
                    fontSize: i
                });
            }) : e.height !== w && (g && e.height < w ? t.history.ignore(()=>{
                e.set({
                    height: w
                });
            }) : g || t.history.ignore(()=>{
                e.set({
                    height: w
                });
            }));
        }
    });
    const S = $0ebe41f88638a370$var$react_1.default.useRef(0);
    $0ebe41f88638a370$var$react_1.default.useEffect(()=>{
        o || x || (async ()=>{
            S.current++;
            const i = S.current, r = (0, $l4lre.incrementLoader)(`text ${e.id}`);
            s(!0);
            let o = null;
            const n = $0ebe41f88638a370$var$isSafari ? 5 : 1;
            for(let a = 0; a < n; a++){
                if (o = await (0, $2o2rI.htmlToCanvas)({
                    html: v,
                    width: e.width || 1,
                    height: e.height || w || 1,
                    fontFamily: p,
                    padding: h,
                    pixelRatio: t._elementsPixelRatio,
                    font: t.fonts.find((e)=>e.fontFamily === p) || $0ebe41f88638a370$var$fonts.globalFonts.find((e)=>e.fontFamily === p)
                }), i !== S.current) return void r();
                $0ebe41f88638a370$var$isCanvasBlank(o) && $0ebe41f88638a370$var$isSafari && await new Promise((e)=>setTimeout(e, 50 * (a + 1)));
            }
            o ? (a(o), s(!1), $0ebe41f88638a370$var$konva_1.default.Util.requestAnimFrame(r)) : r();
        })();
    }, [
        v,
        o,
        w,
        x,
        p,
        e.height,
        t._elementsPixelRatio
    ]);
    const E = o || l;
    $0ebe41f88638a370$var$react_1.default.useEffect(()=>$0ebe41f88638a370$var$mobx.autorun(()=>{
            const t = i.current;
            (0, $aWsdH.applyFilter)(t, e);
        }), [
        r,
        E,
        e.shadowColor,
        e.shadowOffsetX,
        e.shadowOffsetY,
        e.shadowOpacity
    ]);
    let q = 0;
    "middle" === e.verticalAlign && (q = (e.height - w) / 2), "bottom" === e.verticalAlign && (q = e.height - w);
    const k = (0, $eQSol.getLineHeight)({
        fontLoaded: m,
        fontFamily: e.fontFamily,
        fontSize: e.fontSize,
        lineHeight: e.lineHeight
    }), z = (0, $3pcZ0.useMobile)();
    return $0ebe41f88638a370$var$react_1.default.createElement($0ebe41f88638a370$var$react_1.default.Fragment, null, $0ebe41f88638a370$var$react_1.default.createElement($fBZlQ.Rect, {
        x: e.a.x,
        y: e.a.y,
        offsetX: e.backgroundPadding * (e.fontSize * k * .5),
        offsetY: e.backgroundPadding * (e.fontSize * k * .5),
        rotation: e.rotation,
        hideInExport: !e.showInExport || !e.text,
        listening: !1,
        visible: e.backgroundEnabled,
        opacity: e.backgroundOpacity,
        fill: e.backgroundColor,
        width: e.a.width + e.backgroundPadding * (e.fontSize * k),
        height: e.a.height + e.backgroundPadding * (e.fontSize * k),
        cornerRadius: e.backgroundCornerRadius * (e.fontSize * k * .5)
    }), $0ebe41f88638a370$var$react_1.default.createElement($fBZlQ.Rect, {
        ref: i,
        name: "element",
        x: e.a.x,
        y: e.a.y,
        listening: e.selectable,
        rotation: e.rotation,
        width: e.a.width,
        height: e.a.height,
        visible: !E,
        draggable: z ? e.draggable && f : e.draggable,
        preventDefault: !z || f,
        opacity: x ? 0 : e.a.opacity,
        hideInExport: !e.showInExport,
        onMouseEnter: ()=>{
            d(!0);
        },
        onMouseLeave: ()=>{
            d(!1);
        },
        onDragMove: (t)=>{
            e.set({
                x: t.target.x(),
                y: t.target.y()
            });
        },
        onDragEnd: (t)=>{
            e.set({
                x: t.target.x(),
                y: t.target.y()
            });
        },
        id: e.id,
        onDblClick: ()=>{
            e.contentEditable && e.toggleEditMode(!0);
        },
        onDblTap: ()=>{
            e.contentEditable && e.toggleEditMode(!0);
        },
        onTransformStart: (t)=>{
            n(!0), u.current = e.height;
        },
        onTransform: (t)=>{
            var i;
            const r = t.target, a = (null === (i = r.getStage()) || void 0 === i ? void 0 : i.findOne("Transformer")).getActiveAnchor(), o = "middle-left" === a || "middle-right" === a, n = "top-center" === a || "bottom-center" === a, l = r.scaleX();
            if (o) {
                const t = r.scaleX(), i = Math.max(r.width() * t, e.fontSize);
                if (r.width(i), r.scaleX(1), $gS5ZA.flags.textVerticalResizeEnabled) {
                    const t = Math.max(w, u.current);
                    e.set({
                        height: t
                    });
                }
                e.set({
                    width: i,
                    x: r.x(),
                    y: r.y()
                });
            } else if (n) {
                let i = "resize" === $gS5ZA.flags.textOverflow ? w : e.lineHeight * e.fontSize;
                const a = Math.max(i, t.target.height() * t.target.scaleY());
                r.scaleY(1), e.set({
                    x: r.x(),
                    y: r.y(),
                    height: a,
                    rotation: r.rotation()
                });
            } else r.scaleX(1), r.scaleY(1), e.set({
                fontSize: e.fontSize * l,
                width: r.width() * l,
                x: r.x(),
                y: r.y(),
                rotation: r.rotation(),
                height: r.height() * l
            });
        },
        onTransformEnd: (t)=>{
            n(!1), s(!0);
            const i = t.target.scaleX();
            t.target.scaleX(1), t.target.scaleY(1), e.set({
                fontSize: e.fontSize * i,
                width: t.target.width() * i,
                x: t.target.x(),
                y: t.target.y(),
                rotation: t.target.rotation(),
                shadowBlur: e.shadowBlur * i,
                shadowOffsetX: e.shadowOffsetX * i,
                shadowOffsetY: e.shadowOffsetY * i,
                strokeWidth: e.strokeWidth * i
            });
        }
    }), $0ebe41f88638a370$var$react_1.default.createElement($fBZlQ.Image, {
        ref: i,
        image: r,
        x: e.a.x,
        y: e.a.y,
        offsetX: h,
        offsetY: h - q,
        listening: !1,
        rotation: e.rotation,
        width: e.a.width + 2 * h,
        height: e.a.height + 2 * h,
        visible: !E,
        opacity: x ? 0 : e.a.opacity,
        shadowEnabled: e.shadowEnabled,
        shadowBlur: e.shadowBlur,
        shadowOffsetX: e.shadowOffsetX,
        shadowOffsetY: e.shadowOffsetY,
        shadowColor: e.shadowColor,
        shadowOpacity: e.shadowOpacity,
        hideInExport: !e.showInExport
    }), E && $0ebe41f88638a370$var$react_1.default.createElement($fBZlQ.Group, {
        x: e.a.x,
        y: e.a.y,
        rotation: e.rotation,
        offsetY: -q
    }, $0ebe41f88638a370$var$react_1.default.createElement($1SE86.Html, {
        divProps: {
            style: {
                pointerEvents: "none"
            }
        }
    }, $0ebe41f88638a370$var$react_1.default.createElement($0ebe41f88638a370$var$RichTextContainer, {
        dangerouslySetInnerHTML: {
            __html: v
        },
        style: {
            pointerEvents: "none",
            display: "inline-block"
        }
    }))), x && $0ebe41f88638a370$var$react_1.default.createElement($fBZlQ.Group, {
        x: e.a.x,
        y: e.a.y,
        rotation: e.rotation,
        offsetY: -q
    }, $0ebe41f88638a370$var$react_1.default.createElement($1SE86.Html, null, $0ebe41f88638a370$var$react_1.default.createElement($0ebe41f88638a370$var$RichEditor, {
        html: v,
        element: e,
        onChange: (t)=>{
            e.set({
                text: t
            });
        },
        onBlur: (t)=>{
            e.toggleEditMode(!1);
        }
    }))), (f || c) && $0ebe41f88638a370$var$react_1.default.createElement($4WWR6.Highlighter, {
        element: e
    }));
});

});
parcelRegister("1BElU", function(module, exports) {

var $N0o3H = parcelRequire("N0o3H");
var $12b88c448c5fec35$require$Buffer = $N0o3H.Buffer;
/*!
 * Quill Editor v1.3.7
 * https://quilljs.com/
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */ (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(typeof self !== "undefined" ? self : module.exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1["default"];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, "a", getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 109);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var container_1 = __webpack_require__(17);
            var format_1 = __webpack_require__(18);
            var leaf_1 = __webpack_require__(19);
            var scroll_1 = __webpack_require__(45);
            var inline_1 = __webpack_require__(46);
            var block_1 = __webpack_require__(47);
            var embed_1 = __webpack_require__(48);
            var text_1 = __webpack_require__(49);
            var attributor_1 = __webpack_require__(12);
            var class_1 = __webpack_require__(32);
            var style_1 = __webpack_require__(33);
            var store_1 = __webpack_require__(31);
            var Registry = __webpack_require__(1);
            var Parchment = {
                Scope: Registry.Scope,
                create: Registry.create,
                find: Registry.find,
                query: Registry.query,
                register: Registry.register,
                Container: container_1.default,
                Format: format_1.default,
                Leaf: leaf_1.default,
                Embed: embed_1.default,
                Scroll: scroll_1.default,
                Block: block_1.default,
                Inline: inline_1.default,
                Text: text_1.default,
                Attributor: {
                    Attribute: attributor_1.default,
                    Class: class_1.default,
                    Style: style_1.default,
                    Store: store_1.default
                }
            };
            exports.default = Parchment;
        /***/ },
        /* 1 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var ParchmentError = /** @class */ function(_super) {
                __extends(ParchmentError, _super);
                function ParchmentError(message) {
                    var _this = this;
                    message = "[Parchment] " + message;
                    _this = _super.call(this, message) || this;
                    _this.message = message;
                    _this.name = _this.constructor.name;
                    return _this;
                }
                return ParchmentError;
            }(Error);
            exports.ParchmentError = ParchmentError;
            var attributes = {};
            var classes = {};
            var tags = {};
            var types = {};
            exports.DATA_KEY = "__blot";
            var Scope;
            (function(Scope) {
                Scope[Scope["TYPE"] = 3] = "TYPE";
                Scope[Scope["LEVEL"] = 12] = "LEVEL";
                Scope[Scope["ATTRIBUTE"] = 13] = "ATTRIBUTE";
                Scope[Scope["BLOT"] = 14] = "BLOT";
                Scope[Scope["INLINE"] = 7] = "INLINE";
                Scope[Scope["BLOCK"] = 11] = "BLOCK";
                Scope[Scope["BLOCK_BLOT"] = 10] = "BLOCK_BLOT";
                Scope[Scope["INLINE_BLOT"] = 6] = "INLINE_BLOT";
                Scope[Scope["BLOCK_ATTRIBUTE"] = 9] = "BLOCK_ATTRIBUTE";
                Scope[Scope["INLINE_ATTRIBUTE"] = 5] = "INLINE_ATTRIBUTE";
                Scope[Scope["ANY"] = 15] = "ANY";
            })(Scope = exports.Scope || (exports.Scope = {}));
            function create(input, value) {
                var match = query(input);
                if (match == null) throw new ParchmentError("Unable to create " + input + " blot");
                var BlotClass = match;
                var node = // @ts-ignore
                input instanceof Node || input["nodeType"] === Node.TEXT_NODE ? input : BlotClass.create(value);
                return new BlotClass(node, value);
            }
            exports.create = create;
            function find(node, bubble) {
                if (bubble === void 0) bubble = false;
                if (node == null) return null;
                // @ts-ignore
                if (node[exports.DATA_KEY] != null) return node[exports.DATA_KEY].blot;
                if (bubble) return find(node.parentNode, bubble);
                return null;
            }
            exports.find = find;
            function query(query, scope) {
                if (scope === void 0) scope = Scope.ANY;
                var match;
                if (typeof query === "string") match = types[query] || attributes[query];
                else if (query instanceof Text || query["nodeType"] === Node.TEXT_NODE) match = types["text"];
                else if (typeof query === "number") {
                    if (query & Scope.LEVEL & Scope.BLOCK) match = types["block"];
                    else if (query & Scope.LEVEL & Scope.INLINE) match = types["inline"];
                } else if (query instanceof HTMLElement) {
                    var names = (query.getAttribute("class") || "").split(/\s+/);
                    for(var i in names){
                        match = classes[names[i]];
                        if (match) break;
                    }
                    match = match || tags[query.tagName];
                }
                if (match == null) return null;
                // @ts-ignore
                if (scope & Scope.LEVEL & match.scope && scope & Scope.TYPE & match.scope) return match;
                return null;
            }
            exports.query = query;
            function register() {
                var Definitions = [];
                for(var _i = 0; _i < arguments.length; _i++)Definitions[_i] = arguments[_i];
                if (Definitions.length > 1) return Definitions.map(function(d) {
                    return register(d);
                });
                var Definition = Definitions[0];
                if (typeof Definition.blotName !== "string" && typeof Definition.attrName !== "string") throw new ParchmentError("Invalid definition");
                else if (Definition.blotName === "abstract") throw new ParchmentError("Cannot register abstract class");
                types[Definition.blotName || Definition.attrName] = Definition;
                if (typeof Definition.keyName === "string") attributes[Definition.keyName] = Definition;
                else {
                    if (Definition.className != null) classes[Definition.className] = Definition;
                    if (Definition.tagName != null) {
                        if (Array.isArray(Definition.tagName)) Definition.tagName = Definition.tagName.map(function(tagName) {
                            return tagName.toUpperCase();
                        });
                        else Definition.tagName = Definition.tagName.toUpperCase();
                        var tagNames = Array.isArray(Definition.tagName) ? Definition.tagName : [
                            Definition.tagName
                        ];
                        tagNames.forEach(function(tag) {
                            if (tags[tag] == null || Definition.className == null) tags[tag] = Definition;
                        });
                    }
                }
                return Definition;
            }
            exports.register = register;
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            var diff = __webpack_require__(51);
            var equal = __webpack_require__(11);
            var extend = __webpack_require__(3);
            var op = __webpack_require__(20);
            var NULL_CHARACTER = String.fromCharCode(0); // Placeholder char for embed in diff()
            var Delta = function(ops) {
                // Assume we are given a well formed ops
                if (Array.isArray(ops)) this.ops = ops;
                else if (ops != null && Array.isArray(ops.ops)) this.ops = ops.ops;
                else this.ops = [];
            };
            Delta.prototype.insert = function(text, attributes) {
                var newOp = {};
                if (text.length === 0) return this;
                newOp.insert = text;
                if (attributes != null && typeof attributes === "object" && Object.keys(attributes).length > 0) newOp.attributes = attributes;
                return this.push(newOp);
            };
            Delta.prototype["delete"] = function(length) {
                if (length <= 0) return this;
                return this.push({
                    "delete": length
                });
            };
            Delta.prototype.retain = function(length, attributes) {
                if (length <= 0) return this;
                var newOp = {
                    retain: length
                };
                if (attributes != null && typeof attributes === "object" && Object.keys(attributes).length > 0) newOp.attributes = attributes;
                return this.push(newOp);
            };
            Delta.prototype.push = function(newOp) {
                var index = this.ops.length;
                var lastOp = this.ops[index - 1];
                newOp = extend(true, {}, newOp);
                if (typeof lastOp === "object") {
                    if (typeof newOp["delete"] === "number" && typeof lastOp["delete"] === "number") {
                        this.ops[index - 1] = {
                            "delete": lastOp["delete"] + newOp["delete"]
                        };
                        return this;
                    }
                    // Since it does not matter if we insert before or after deleting at the same index,
                    // always prefer to insert first
                    if (typeof lastOp["delete"] === "number" && newOp.insert != null) {
                        index -= 1;
                        lastOp = this.ops[index - 1];
                        if (typeof lastOp !== "object") {
                            this.ops.unshift(newOp);
                            return this;
                        }
                    }
                    if (equal(newOp.attributes, lastOp.attributes)) {
                        if (typeof newOp.insert === "string" && typeof lastOp.insert === "string") {
                            this.ops[index - 1] = {
                                insert: lastOp.insert + newOp.insert
                            };
                            if (typeof newOp.attributes === "object") this.ops[index - 1].attributes = newOp.attributes;
                            return this;
                        } else if (typeof newOp.retain === "number" && typeof lastOp.retain === "number") {
                            this.ops[index - 1] = {
                                retain: lastOp.retain + newOp.retain
                            };
                            if (typeof newOp.attributes === "object") this.ops[index - 1].attributes = newOp.attributes;
                            return this;
                        }
                    }
                }
                if (index === this.ops.length) this.ops.push(newOp);
                else this.ops.splice(index, 0, newOp);
                return this;
            };
            Delta.prototype.chop = function() {
                var lastOp = this.ops[this.ops.length - 1];
                if (lastOp && lastOp.retain && !lastOp.attributes) this.ops.pop();
                return this;
            };
            Delta.prototype.filter = function(predicate) {
                return this.ops.filter(predicate);
            };
            Delta.prototype.forEach = function(predicate) {
                this.ops.forEach(predicate);
            };
            Delta.prototype.map = function(predicate) {
                return this.ops.map(predicate);
            };
            Delta.prototype.partition = function(predicate) {
                var passed = [], failed = [];
                this.forEach(function(op) {
                    var target = predicate(op) ? passed : failed;
                    target.push(op);
                });
                return [
                    passed,
                    failed
                ];
            };
            Delta.prototype.reduce = function(predicate, initial) {
                return this.ops.reduce(predicate, initial);
            };
            Delta.prototype.changeLength = function() {
                return this.reduce(function(length, elem) {
                    if (elem.insert) return length + op.length(elem);
                    else if (elem.delete) return length - elem.delete;
                    return length;
                }, 0);
            };
            Delta.prototype.length = function() {
                return this.reduce(function(length, elem) {
                    return length + op.length(elem);
                }, 0);
            };
            Delta.prototype.slice = function(start, end) {
                start = start || 0;
                if (typeof end !== "number") end = Infinity;
                var ops = [];
                var iter = op.iterator(this.ops);
                var index = 0;
                while(index < end && iter.hasNext()){
                    var nextOp;
                    if (index < start) nextOp = iter.next(start - index);
                    else {
                        nextOp = iter.next(end - index);
                        ops.push(nextOp);
                    }
                    index += op.length(nextOp);
                }
                return new Delta(ops);
            };
            Delta.prototype.compose = function(other) {
                var thisIter = op.iterator(this.ops);
                var otherIter = op.iterator(other.ops);
                var ops = [];
                var firstOther = otherIter.peek();
                if (firstOther != null && typeof firstOther.retain === "number" && firstOther.attributes == null) {
                    var firstLeft = firstOther.retain;
                    while(thisIter.peekType() === "insert" && thisIter.peekLength() <= firstLeft){
                        firstLeft -= thisIter.peekLength();
                        ops.push(thisIter.next());
                    }
                    if (firstOther.retain - firstLeft > 0) otherIter.next(firstOther.retain - firstLeft);
                }
                var delta = new Delta(ops);
                while(thisIter.hasNext() || otherIter.hasNext()){
                    if (otherIter.peekType() === "insert") delta.push(otherIter.next());
                    else if (thisIter.peekType() === "delete") delta.push(thisIter.next());
                    else {
                        var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
                        var thisOp = thisIter.next(length);
                        var otherOp = otherIter.next(length);
                        if (typeof otherOp.retain === "number") {
                            var newOp = {};
                            if (typeof thisOp.retain === "number") newOp.retain = length;
                            else newOp.insert = thisOp.insert;
                            // Preserve null when composing with a retain, otherwise remove it for inserts
                            var attributes = op.attributes.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === "number");
                            if (attributes) newOp.attributes = attributes;
                            delta.push(newOp);
                            // Optimization if rest of other is just retain
                            if (!otherIter.hasNext() && equal(delta.ops[delta.ops.length - 1], newOp)) {
                                var rest = new Delta(thisIter.rest());
                                return delta.concat(rest).chop();
                            }
                        // Other op should be delete, we could be an insert or retain
                        // Insert + delete cancels out
                        } else if (typeof otherOp["delete"] === "number" && typeof thisOp.retain === "number") delta.push(otherOp);
                    }
                }
                return delta.chop();
            };
            Delta.prototype.concat = function(other) {
                var delta = new Delta(this.ops.slice());
                if (other.ops.length > 0) {
                    delta.push(other.ops[0]);
                    delta.ops = delta.ops.concat(other.ops.slice(1));
                }
                return delta;
            };
            Delta.prototype.diff = function(other, index) {
                if (this.ops === other.ops) return new Delta();
                var strings = [
                    this,
                    other
                ].map(function(delta) {
                    return delta.map(function(op) {
                        if (op.insert != null) return typeof op.insert === "string" ? op.insert : NULL_CHARACTER;
                        var prep = delta === other ? "on" : "with";
                        throw new Error("diff() called " + prep + " non-document");
                    }).join("");
                });
                var delta = new Delta();
                var diffResult = diff(strings[0], strings[1], index);
                var thisIter = op.iterator(this.ops);
                var otherIter = op.iterator(other.ops);
                diffResult.forEach(function(component) {
                    var length = component[1].length;
                    while(length > 0){
                        var opLength = 0;
                        switch(component[0]){
                            case diff.INSERT:
                                opLength = Math.min(otherIter.peekLength(), length);
                                delta.push(otherIter.next(opLength));
                                break;
                            case diff.DELETE:
                                opLength = Math.min(length, thisIter.peekLength());
                                thisIter.next(opLength);
                                delta["delete"](opLength);
                                break;
                            case diff.EQUAL:
                                opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
                                var thisOp = thisIter.next(opLength);
                                var otherOp = otherIter.next(opLength);
                                if (equal(thisOp.insert, otherOp.insert)) delta.retain(opLength, op.attributes.diff(thisOp.attributes, otherOp.attributes));
                                else delta.push(otherOp)["delete"](opLength);
                                break;
                        }
                        length -= opLength;
                    }
                });
                return delta.chop();
            };
            Delta.prototype.eachLine = function(predicate, newline) {
                newline = newline || "\n";
                var iter = op.iterator(this.ops);
                var line = new Delta();
                var i = 0;
                while(iter.hasNext()){
                    if (iter.peekType() !== "insert") return;
                    var thisOp = iter.peek();
                    var start = op.length(thisOp) - iter.peekLength();
                    var index = typeof thisOp.insert === "string" ? thisOp.insert.indexOf(newline, start) - start : -1;
                    if (index < 0) line.push(iter.next());
                    else if (index > 0) line.push(iter.next(index));
                    else {
                        if (predicate(line, iter.next(1).attributes || {}, i) === false) return;
                        i += 1;
                        line = new Delta();
                    }
                }
                if (line.length() > 0) predicate(line, {}, i);
            };
            Delta.prototype.transform = function(other, priority) {
                priority = !!priority;
                if (typeof other === "number") return this.transformPosition(other, priority);
                var thisIter = op.iterator(this.ops);
                var otherIter = op.iterator(other.ops);
                var delta = new Delta();
                while(thisIter.hasNext() || otherIter.hasNext()){
                    if (thisIter.peekType() === "insert" && (priority || otherIter.peekType() !== "insert")) delta.retain(op.length(thisIter.next()));
                    else if (otherIter.peekType() === "insert") delta.push(otherIter.next());
                    else {
                        var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
                        var thisOp = thisIter.next(length);
                        var otherOp = otherIter.next(length);
                        if (thisOp["delete"]) continue;
                        else if (otherOp["delete"]) delta.push(otherOp);
                        else // We retain either their retain or insert
                        delta.retain(length, op.attributes.transform(thisOp.attributes, otherOp.attributes, priority));
                    }
                }
                return delta.chop();
            };
            Delta.prototype.transformPosition = function(index, priority) {
                priority = !!priority;
                var thisIter = op.iterator(this.ops);
                var offset = 0;
                while(thisIter.hasNext() && offset <= index){
                    var length = thisIter.peekLength();
                    var nextType = thisIter.peekType();
                    thisIter.next();
                    if (nextType === "delete") {
                        index -= Math.min(length, index - offset);
                        continue;
                    } else if (nextType === "insert" && (offset < index || !priority)) index += length;
                    offset += length;
                }
                return index;
            };
            module1.exports = Delta;
        /***/ },
        /* 3 */ /***/ function(module1, exports) {
            "use strict";
            var hasOwn = Object.prototype.hasOwnProperty;
            var toStr = Object.prototype.toString;
            var defineProperty = Object.defineProperty;
            var gOPD = Object.getOwnPropertyDescriptor;
            var isArray = function isArray(arr) {
                if (typeof Array.isArray === "function") return Array.isArray(arr);
                return toStr.call(arr) === "[object Array]";
            };
            var isPlainObject = function isPlainObject(obj) {
                if (!obj || toStr.call(obj) !== "[object Object]") return false;
                var hasOwnConstructor = hasOwn.call(obj, "constructor");
                var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, "isPrototypeOf");
                // Not own constructor property must be Object
                if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
                // Own properties are enumerated firstly, so to speed up,
                // if last one is own, then all properties are own.
                var key;
                for(key in obj);
                return typeof key === "undefined" || hasOwn.call(obj, key);
            };
            // If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
            var setProperty = function setProperty(target, options) {
                if (defineProperty && options.name === "__proto__") defineProperty(target, options.name, {
                    enumerable: true,
                    configurable: true,
                    value: options.newValue,
                    writable: true
                });
                else target[options.name] = options.newValue;
            };
            // Return undefined instead of __proto__ if '__proto__' is not an own property
            var getProperty = function getProperty(obj, name) {
                if (name === "__proto__") {
                    if (!hasOwn.call(obj, name)) return void 0;
                    else if (gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
                    // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
                    return gOPD(obj, name).value;
                }
                return obj[name];
            };
            module1.exports = function extend() {
                var options, name, src, copy, copyIsArray, clone;
                var target = arguments[0];
                var i = 1;
                var length = arguments.length;
                var deep = false;
                // Handle a deep copy situation
                if (typeof target === "boolean") {
                    deep = target;
                    target = arguments[1] || {};
                    // skip the boolean and the target
                    i = 2;
                }
                if (target == null || typeof target !== "object" && typeof target !== "function") target = {};
                for(; i < length; ++i){
                    options = arguments[i];
                    // Only deal with non-null/undefined values
                    if (options != null) // Extend the base object
                    for(name in options){
                        src = getProperty(target, name);
                        copy = getProperty(options, name);
                        // Prevent never-ending loop
                        if (target !== copy) {
                            // Recurse if we're merging plain objects or arrays
                            if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
                                if (copyIsArray) {
                                    copyIsArray = false;
                                    clone = src && isArray(src) ? src : [];
                                } else clone = src && isPlainObject(src) ? src : {};
                                // Never move original objects, clone them
                                setProperty(target, {
                                    name: name,
                                    newValue: extend(deep, clone, copy)
                                });
                            // Don't bring in undefined values
                            } else if (typeof copy !== "undefined") setProperty(target, {
                                name: name,
                                newValue: copy
                            });
                        }
                    }
                }
                // Return the modified object
                return target;
            };
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.BlockEmbed = exports.bubbleFormats = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _break = __webpack_require__(16);
            var _break2 = _interopRequireDefault(_break);
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            var _text = __webpack_require__(7);
            var _text2 = _interopRequireDefault(_text);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var NEWLINE_LENGTH = 1;
            var BlockEmbed = function(_Parchment$Embed) {
                _inherits(BlockEmbed, _Parchment$Embed);
                function BlockEmbed() {
                    _classCallCheck(this, BlockEmbed);
                    return _possibleConstructorReturn(this, (BlockEmbed.__proto__ || Object.getPrototypeOf(BlockEmbed)).apply(this, arguments));
                }
                _createClass(BlockEmbed, [
                    {
                        key: "attach",
                        value: function attach() {
                            _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), "attach", this).call(this);
                            this.attributes = new _parchment2.default.Attributor.Store(this.domNode);
                        }
                    },
                    {
                        key: "delta",
                        value: function delta() {
                            return new _quillDelta2.default().insert(this.value(), (0, _extend2.default)(this.formats(), this.attributes.values()));
                        }
                    },
                    {
                        key: "format",
                        value: function format(name, value) {
                            var attribute = _parchment2.default.query(name, _parchment2.default.Scope.BLOCK_ATTRIBUTE);
                            if (attribute != null) this.attributes.attribute(attribute, value);
                        }
                    },
                    {
                        key: "formatAt",
                        value: function formatAt(index, length, name, value) {
                            this.format(name, value);
                        }
                    },
                    {
                        key: "insertAt",
                        value: function insertAt(index, value, def) {
                            if (typeof value === "string" && value.endsWith("\n")) {
                                var block = _parchment2.default.create(Block.blotName);
                                this.parent.insertBefore(block, index === 0 ? this : this.next);
                                block.insertAt(0, value.slice(0, -1));
                            } else _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), "insertAt", this).call(this, index, value, def);
                        }
                    }
                ]);
                return BlockEmbed;
            }(_parchment2.default.Embed);
            BlockEmbed.scope = _parchment2.default.Scope.BLOCK_BLOT;
            // It is important for cursor behavior BlockEmbeds use tags that are block level elements
            var Block = function(_Parchment$Block) {
                _inherits(Block, _Parchment$Block);
                function Block(domNode) {
                    _classCallCheck(this, Block);
                    var _this2 = _possibleConstructorReturn(this, (Block.__proto__ || Object.getPrototypeOf(Block)).call(this, domNode));
                    _this2.cache = {};
                    return _this2;
                }
                _createClass(Block, [
                    {
                        key: "delta",
                        value: function delta() {
                            if (this.cache.delta == null) this.cache.delta = this.descendants(_parchment2.default.Leaf).reduce(function(delta, leaf) {
                                if (leaf.length() === 0) return delta;
                                else return delta.insert(leaf.value(), bubbleFormats(leaf));
                            }, new _quillDelta2.default()).insert("\n", bubbleFormats(this));
                            return this.cache.delta;
                        }
                    },
                    {
                        key: "deleteAt",
                        value: function deleteAt(index, length) {
                            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), "deleteAt", this).call(this, index, length);
                            this.cache = {};
                        }
                    },
                    {
                        key: "formatAt",
                        value: function formatAt(index, length, name, value) {
                            if (length <= 0) return;
                            if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
                                if (index + length === this.length()) this.format(name, value);
                            } else _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), "formatAt", this).call(this, index, Math.min(length, this.length() - index - 1), name, value);
                            this.cache = {};
                        }
                    },
                    {
                        key: "insertAt",
                        value: function insertAt(index, value, def) {
                            if (def != null) return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), "insertAt", this).call(this, index, value, def);
                            if (value.length === 0) return;
                            var lines = value.split("\n");
                            var text = lines.shift();
                            if (text.length > 0) {
                                if (index < this.length() - 1 || this.children.tail == null) _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), "insertAt", this).call(this, Math.min(index, this.length() - 1), text);
                                else this.children.tail.insertAt(this.children.tail.length(), text);
                                this.cache = {};
                            }
                            var block = this;
                            lines.reduce(function(index, line) {
                                block = block.split(index, true);
                                block.insertAt(0, line);
                                return line.length;
                            }, index + text.length);
                        }
                    },
                    {
                        key: "insertBefore",
                        value: function insertBefore(blot, ref) {
                            var head = this.children.head;
                            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), "insertBefore", this).call(this, blot, ref);
                            if (head instanceof _break2.default) head.remove();
                            this.cache = {};
                        }
                    },
                    {
                        key: "length",
                        value: function length() {
                            if (this.cache.length == null) this.cache.length = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), "length", this).call(this) + NEWLINE_LENGTH;
                            return this.cache.length;
                        }
                    },
                    {
                        key: "moveChildren",
                        value: function moveChildren(target, ref) {
                            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), "moveChildren", this).call(this, target, ref);
                            this.cache = {};
                        }
                    },
                    {
                        key: "optimize",
                        value: function optimize(context) {
                            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), "optimize", this).call(this, context);
                            this.cache = {};
                        }
                    },
                    {
                        key: "path",
                        value: function path(index) {
                            return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), "path", this).call(this, index, true);
                        }
                    },
                    {
                        key: "removeChild",
                        value: function removeChild(child) {
                            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), "removeChild", this).call(this, child);
                            this.cache = {};
                        }
                    },
                    {
                        key: "split",
                        value: function split(index) {
                            var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                            if (force && (index === 0 || index >= this.length() - NEWLINE_LENGTH)) {
                                var clone = this.clone();
                                if (index === 0) {
                                    this.parent.insertBefore(clone, this);
                                    return this;
                                } else {
                                    this.parent.insertBefore(clone, this.next);
                                    return clone;
                                }
                            } else {
                                var next = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), "split", this).call(this, index, force);
                                this.cache = {};
                                return next;
                            }
                        }
                    }
                ]);
                return Block;
            }(_parchment2.default.Block);
            Block.blotName = "block";
            Block.tagName = "P";
            Block.defaultChild = "break";
            Block.allowedChildren = [
                _inline2.default,
                _parchment2.default.Embed,
                _text2.default
            ];
            function bubbleFormats(blot) {
                var formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (blot == null) return formats;
                if (typeof blot.formats === "function") formats = (0, _extend2.default)(formats, blot.formats());
                if (blot.parent == null || blot.parent.blotName == "scroll" || blot.parent.statics.scope !== blot.statics.scope) return formats;
                return bubbleFormats(blot.parent, formats);
            }
            exports.bubbleFormats = bubbleFormats;
            exports.BlockEmbed = BlockEmbed;
            exports.default = Block;
        /***/ },
        /* 5 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.overload = exports.expandConfig = undefined;
            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            __webpack_require__(50);
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _editor = __webpack_require__(14);
            var _editor2 = _interopRequireDefault(_editor);
            var _emitter3 = __webpack_require__(8);
            var _emitter4 = _interopRequireDefault(_emitter3);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _selection = __webpack_require__(15);
            var _selection2 = _interopRequireDefault(_selection);
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            var _logger = __webpack_require__(10);
            var _logger2 = _interopRequireDefault(_logger);
            var _theme = __webpack_require__(34);
            var _theme2 = _interopRequireDefault(_theme);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var debug = (0, _logger2.default)("quill");
            var Quill = function() {
                _createClass(Quill, null, [
                    {
                        key: "debug",
                        value: function debug(limit) {
                            if (limit === true) limit = "log";
                            _logger2.default.level(limit);
                        }
                    },
                    {
                        key: "find",
                        value: function find(node) {
                            return node.__quill || _parchment2.default.find(node);
                        }
                    },
                    {
                        key: "import",
                        value: function _import(name) {
                            if (this.imports[name] == null) debug.error("Cannot import " + name + ". Are you sure it was registered?");
                            return this.imports[name];
                        }
                    },
                    {
                        key: "register",
                        value: function register(path, target) {
                            var _this = this;
                            var overwrite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                            if (typeof path !== "string") {
                                var name = path.attrName || path.blotName;
                                if (typeof name === "string") // register(Blot | Attributor, overwrite)
                                this.register("formats/" + name, path, target);
                                else Object.keys(path).forEach(function(key) {
                                    _this.register(key, path[key], target);
                                });
                            } else {
                                if (this.imports[path] != null && !overwrite) debug.warn("Overwriting " + path + " with", target);
                                this.imports[path] = target;
                                if ((path.startsWith("blots/") || path.startsWith("formats/")) && target.blotName !== "abstract") _parchment2.default.register(target);
                                else if (path.startsWith("modules") && typeof target.register === "function") target.register();
                            }
                        }
                    }
                ]);
                function Quill(container) {
                    var _this2 = this;
                    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    _classCallCheck(this, Quill);
                    this.options = expandConfig(container, options);
                    this.container = this.options.container;
                    if (this.container == null) return debug.error("Invalid Quill container", container);
                    if (this.options.debug) Quill.debug(this.options.debug);
                    var html = this.container.innerHTML.trim();
                    this.container.classList.add("ql-container");
                    this.container.innerHTML = "";
                    this.container.__quill = this;
                    this.root = this.addContainer("ql-editor");
                    this.root.classList.add("ql-blank");
                    this.root.setAttribute("data-gramm", false);
                    this.scrollingContainer = this.options.scrollingContainer || this.root;
                    this.emitter = new _emitter4.default();
                    this.scroll = _parchment2.default.create(this.root, {
                        emitter: this.emitter,
                        whitelist: this.options.formats
                    });
                    this.editor = new _editor2.default(this.scroll);
                    this.selection = new _selection2.default(this.scroll, this.emitter);
                    this.theme = new this.options.theme(this, this.options);
                    this.keyboard = this.theme.addModule("keyboard");
                    this.clipboard = this.theme.addModule("clipboard");
                    this.history = this.theme.addModule("history");
                    this.theme.init();
                    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function(type) {
                        if (type === _emitter4.default.events.TEXT_CHANGE) _this2.root.classList.toggle("ql-blank", _this2.editor.isBlank());
                    });
                    this.emitter.on(_emitter4.default.events.SCROLL_UPDATE, function(source, mutations) {
                        var range = _this2.selection.lastRange;
                        var index = range && range.length === 0 ? range.index : undefined;
                        modify.call(_this2, function() {
                            return _this2.editor.update(null, mutations, index);
                        }, source);
                    });
                    var contents = this.clipboard.convert("<div class='ql-editor' style=\"white-space: normal;\">" + html + "<p><br></p></div>");
                    this.setContents(contents);
                    this.history.clear();
                    if (this.options.placeholder) this.root.setAttribute("data-placeholder", this.options.placeholder);
                    if (this.options.readOnly) this.disable();
                }
                _createClass(Quill, [
                    {
                        key: "addContainer",
                        value: function addContainer(container) {
                            var refNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                            if (typeof container === "string") {
                                var className = container;
                                container = document.createElement("div");
                                container.classList.add(className);
                            }
                            this.container.insertBefore(container, refNode);
                            return container;
                        }
                    },
                    {
                        key: "blur",
                        value: function blur() {
                            this.selection.setRange(null);
                        }
                    },
                    {
                        key: "deleteText",
                        value: function deleteText(index, length, source) {
                            var _this3 = this;
                            var _overload = overload(index, length, source);
                            var _overload2 = _slicedToArray(_overload, 4);
                            index = _overload2[0];
                            length = _overload2[1];
                            source = _overload2[3];
                            return modify.call(this, function() {
                                return _this3.editor.deleteText(index, length);
                            }, source, index, -1 * length);
                        }
                    },
                    {
                        key: "disable",
                        value: function disable() {
                            this.enable(false);
                        }
                    },
                    {
                        key: "enable",
                        value: function enable() {
                            var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                            this.scroll.enable(enabled);
                            this.container.classList.toggle("ql-disabled", !enabled);
                        }
                    },
                    {
                        key: "focus",
                        value: function focus() {
                            var scrollTop = this.scrollingContainer.scrollTop;
                            this.selection.focus();
                            this.scrollingContainer.scrollTop = scrollTop;
                            this.scrollIntoView();
                        }
                    },
                    {
                        key: "format",
                        value: function format(name, value) {
                            var _this4 = this;
                            var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;
                            return modify.call(this, function() {
                                var range = _this4.getSelection(true);
                                var change = new _quillDelta2.default();
                                if (range == null) return change;
                                else if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) change = _this4.editor.formatLine(range.index, range.length, _defineProperty({}, name, value));
                                else if (range.length === 0) {
                                    _this4.selection.format(name, value);
                                    return change;
                                } else change = _this4.editor.formatText(range.index, range.length, _defineProperty({}, name, value));
                                _this4.setSelection(range, _emitter4.default.sources.SILENT);
                                return change;
                            }, source);
                        }
                    },
                    {
                        key: "formatLine",
                        value: function formatLine(index, length, name, value, source) {
                            var _this5 = this;
                            var formats = void 0;
                            var _overload3 = overload(index, length, name, value, source);
                            var _overload4 = _slicedToArray(_overload3, 4);
                            index = _overload4[0];
                            length = _overload4[1];
                            formats = _overload4[2];
                            source = _overload4[3];
                            return modify.call(this, function() {
                                return _this5.editor.formatLine(index, length, formats);
                            }, source, index, 0);
                        }
                    },
                    {
                        key: "formatText",
                        value: function formatText(index, length, name, value, source) {
                            var _this6 = this;
                            var formats = void 0;
                            var _overload5 = overload(index, length, name, value, source);
                            var _overload6 = _slicedToArray(_overload5, 4);
                            index = _overload6[0];
                            length = _overload6[1];
                            formats = _overload6[2];
                            source = _overload6[3];
                            return modify.call(this, function() {
                                return _this6.editor.formatText(index, length, formats);
                            }, source, index, 0);
                        }
                    },
                    {
                        key: "getBounds",
                        value: function getBounds(index) {
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                            var bounds = void 0;
                            if (typeof index === "number") bounds = this.selection.getBounds(index, length);
                            else bounds = this.selection.getBounds(index.index, index.length);
                            var containerBounds = this.container.getBoundingClientRect();
                            return {
                                bottom: bounds.bottom - containerBounds.top,
                                height: bounds.height,
                                left: bounds.left - containerBounds.left,
                                right: bounds.right - containerBounds.left,
                                top: bounds.top - containerBounds.top,
                                width: bounds.width
                            };
                        }
                    },
                    {
                        key: "getContents",
                        value: function getContents() {
                            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;
                            var _overload7 = overload(index, length);
                            var _overload8 = _slicedToArray(_overload7, 2);
                            index = _overload8[0];
                            length = _overload8[1];
                            return this.editor.getContents(index, length);
                        }
                    },
                    {
                        key: "getFormat",
                        value: function getFormat() {
                            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelection(true);
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                            if (typeof index === "number") return this.editor.getFormat(index, length);
                            else return this.editor.getFormat(index.index, index.length);
                        }
                    },
                    {
                        key: "getIndex",
                        value: function getIndex(blot) {
                            return blot.offset(this.scroll);
                        }
                    },
                    {
                        key: "getLength",
                        value: function getLength() {
                            return this.scroll.length();
                        }
                    },
                    {
                        key: "getLeaf",
                        value: function getLeaf(index) {
                            return this.scroll.leaf(index);
                        }
                    },
                    {
                        key: "getLine",
                        value: function getLine(index) {
                            return this.scroll.line(index);
                        }
                    },
                    {
                        key: "getLines",
                        value: function getLines() {
                            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
                            if (typeof index !== "number") return this.scroll.lines(index.index, index.length);
                            else return this.scroll.lines(index, length);
                        }
                    },
                    {
                        key: "getModule",
                        value: function getModule(name) {
                            return this.theme.modules[name];
                        }
                    },
                    {
                        key: "getSelection",
                        value: function getSelection() {
                            var focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                            if (focus) this.focus();
                            this.update(); // Make sure we access getRange with editor in consistent state
                            return this.selection.getRange()[0];
                        }
                    },
                    {
                        key: "getText",
                        value: function getText() {
                            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;
                            var _overload9 = overload(index, length);
                            var _overload10 = _slicedToArray(_overload9, 2);
                            index = _overload10[0];
                            length = _overload10[1];
                            return this.editor.getText(index, length);
                        }
                    },
                    {
                        key: "hasFocus",
                        value: function hasFocus() {
                            return this.selection.hasFocus();
                        }
                    },
                    {
                        key: "insertEmbed",
                        value: function insertEmbed(index, embed, value) {
                            var _this7 = this;
                            var source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Quill.sources.API;
                            return modify.call(this, function() {
                                return _this7.editor.insertEmbed(index, embed, value);
                            }, source, index);
                        }
                    },
                    {
                        key: "insertText",
                        value: function insertText(index, text, name, value, source) {
                            var _this8 = this;
                            var formats = void 0;
                            var _overload11 = overload(index, 0, name, value, source);
                            var _overload12 = _slicedToArray(_overload11, 4);
                            index = _overload12[0];
                            formats = _overload12[2];
                            source = _overload12[3];
                            return modify.call(this, function() {
                                return _this8.editor.insertText(index, text, formats);
                            }, source, index, text.length);
                        }
                    },
                    {
                        key: "isEnabled",
                        value: function isEnabled() {
                            return !this.container.classList.contains("ql-disabled");
                        }
                    },
                    {
                        key: "off",
                        value: function off() {
                            return this.emitter.off.apply(this.emitter, arguments);
                        }
                    },
                    {
                        key: "on",
                        value: function on() {
                            return this.emitter.on.apply(this.emitter, arguments);
                        }
                    },
                    {
                        key: "once",
                        value: function once() {
                            return this.emitter.once.apply(this.emitter, arguments);
                        }
                    },
                    {
                        key: "pasteHTML",
                        value: function pasteHTML(index, html, source) {
                            this.clipboard.dangerouslyPasteHTML(index, html, source);
                        }
                    },
                    {
                        key: "removeFormat",
                        value: function removeFormat(index, length, source) {
                            var _this9 = this;
                            var _overload13 = overload(index, length, source);
                            var _overload14 = _slicedToArray(_overload13, 4);
                            index = _overload14[0];
                            length = _overload14[1];
                            source = _overload14[3];
                            return modify.call(this, function() {
                                return _this9.editor.removeFormat(index, length);
                            }, source, index);
                        }
                    },
                    {
                        key: "scrollIntoView",
                        value: function scrollIntoView() {
                            this.selection.scrollIntoView(this.scrollingContainer);
                        }
                    },
                    {
                        key: "setContents",
                        value: function setContents(delta) {
                            var _this10 = this;
                            var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;
                            return modify.call(this, function() {
                                delta = new _quillDelta2.default(delta);
                                var length = _this10.getLength();
                                var deleted = _this10.editor.deleteText(0, length);
                                var applied = _this10.editor.applyDelta(delta);
                                var lastOp = applied.ops[applied.ops.length - 1];
                                if (lastOp != null && typeof lastOp.insert === "string" && lastOp.insert[lastOp.insert.length - 1] === "\n") {
                                    _this10.editor.deleteText(_this10.getLength() - 1, 1);
                                    applied.delete(1);
                                }
                                var ret = deleted.compose(applied);
                                return ret;
                            }, source);
                        }
                    },
                    {
                        key: "setSelection",
                        value: function setSelection(index, length, source) {
                            if (index == null) this.selection.setRange(null, length || Quill.sources.API);
                            else {
                                var _overload15 = overload(index, length, source);
                                var _overload16 = _slicedToArray(_overload15, 4);
                                index = _overload16[0];
                                length = _overload16[1];
                                source = _overload16[3];
                                this.selection.setRange(new _selection.Range(index, length), source);
                                if (source !== _emitter4.default.sources.SILENT) this.selection.scrollIntoView(this.scrollingContainer);
                            }
                        }
                    },
                    {
                        key: "setText",
                        value: function setText(text) {
                            var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;
                            var delta = new _quillDelta2.default().insert(text);
                            return this.setContents(delta, source);
                        }
                    },
                    {
                        key: "update",
                        value: function update() {
                            var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;
                            var change = this.scroll.update(source); // Will update selection before selection.update() does if text changes
                            this.selection.update(source);
                            return change;
                        }
                    },
                    {
                        key: "updateContents",
                        value: function updateContents(delta) {
                            var _this11 = this;
                            var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;
                            return modify.call(this, function() {
                                delta = new _quillDelta2.default(delta);
                                return _this11.editor.applyDelta(delta, source);
                            }, source, true);
                        }
                    }
                ]);
                return Quill;
            }();
            Quill.DEFAULTS = {
                bounds: null,
                formats: null,
                modules: {},
                placeholder: "",
                readOnly: false,
                scrollingContainer: null,
                strict: true,
                theme: "default"
            };
            Quill.events = _emitter4.default.events;
            Quill.sources = _emitter4.default.sources;
            // eslint-disable-next-line no-undef
            Quill.version = "1.3.7";
            Quill.imports = {
                "delta": _quillDelta2.default,
                "parchment": _parchment2.default,
                "core/module": _module2.default,
                "core/theme": _theme2.default
            };
            function expandConfig(container, userConfig) {
                userConfig = (0, _extend2.default)(true, {
                    container: container,
                    modules: {
                        clipboard: true,
                        keyboard: true,
                        history: true
                    }
                }, userConfig);
                if (!userConfig.theme || userConfig.theme === Quill.DEFAULTS.theme) userConfig.theme = _theme2.default;
                else {
                    userConfig.theme = Quill.import("themes/" + userConfig.theme);
                    if (userConfig.theme == null) throw new Error("Invalid theme " + userConfig.theme + ". Did you register it?");
                }
                var themeConfig = (0, _extend2.default)(true, {}, userConfig.theme.DEFAULTS);
                [
                    themeConfig,
                    userConfig
                ].forEach(function(config) {
                    config.modules = config.modules || {};
                    Object.keys(config.modules).forEach(function(module1) {
                        if (config.modules[module1] === true) config.modules[module1] = {};
                    });
                });
                var moduleNames = Object.keys(themeConfig.modules).concat(Object.keys(userConfig.modules));
                var moduleConfig = moduleNames.reduce(function(config, name) {
                    var moduleClass = Quill.import("modules/" + name);
                    if (moduleClass == null) debug.error("Cannot load " + name + " module. Are you sure you registered it?");
                    else config[name] = moduleClass.DEFAULTS || {};
                    return config;
                }, {});
                // Special case toolbar shorthand
                if (userConfig.modules != null && userConfig.modules.toolbar && userConfig.modules.toolbar.constructor !== Object) userConfig.modules.toolbar = {
                    container: userConfig.modules.toolbar
                };
                userConfig = (0, _extend2.default)(true, {}, Quill.DEFAULTS, {
                    modules: moduleConfig
                }, themeConfig, userConfig);
                [
                    "bounds",
                    "container",
                    "scrollingContainer"
                ].forEach(function(key) {
                    if (typeof userConfig[key] === "string") userConfig[key] = document.querySelector(userConfig[key]);
                });
                userConfig.modules = Object.keys(userConfig.modules).reduce(function(config, name) {
                    if (userConfig.modules[name]) config[name] = userConfig.modules[name];
                    return config;
                }, {});
                return userConfig;
            }
            // Handle selection preservation and TEXT_CHANGE emission
            // common to modification APIs
            function modify(modifier, source, index, shift) {
                if (this.options.strict && !this.isEnabled() && source === _emitter4.default.sources.USER) return new _quillDelta2.default();
                var range = index == null ? null : this.getSelection();
                var oldDelta = this.editor.delta;
                var change = modifier();
                if (range != null) {
                    if (index === true) index = range.index;
                    if (shift == null) range = shiftRange(range, change, source);
                    else if (shift !== 0) range = shiftRange(range, index, shift, source);
                    this.setSelection(range, _emitter4.default.sources.SILENT);
                }
                if (change.length() > 0) {
                    var _emitter;
                    var args = [
                        _emitter4.default.events.TEXT_CHANGE,
                        change,
                        oldDelta,
                        source
                    ];
                    (_emitter = this.emitter).emit.apply(_emitter, [
                        _emitter4.default.events.EDITOR_CHANGE
                    ].concat(args));
                    if (source !== _emitter4.default.sources.SILENT) {
                        var _emitter2;
                        (_emitter2 = this.emitter).emit.apply(_emitter2, args);
                    }
                }
                return change;
            }
            function overload(index, length, name, value, source) {
                var formats = {};
                if (typeof index.index === "number" && typeof index.length === "number") {
                    // Allow for throwaway end (used by insertText/insertEmbed)
                    if (typeof length !== "number") source = value, value = name, name = length, length = index.length, index = index.index;
                    else length = index.length, index = index.index;
                } else if (typeof length !== "number") source = value, value = name, name = length, length = 0;
                // Handle format being object, two format name/value strings or excluded
                if ((typeof name === "undefined" ? "undefined" : _typeof(name)) === "object") {
                    formats = name;
                    source = value;
                } else if (typeof name === "string") {
                    if (value != null) formats[name] = value;
                    else source = name;
                }
                // Handle optional source
                source = source || _emitter4.default.sources.API;
                return [
                    index,
                    length,
                    formats,
                    source
                ];
            }
            function shiftRange(range, index, length, source) {
                if (range == null) return null;
                var start = void 0, end = void 0;
                if (index instanceof _quillDelta2.default) {
                    var _map = [
                        range.index,
                        range.index + range.length
                    ].map(function(pos) {
                        return index.transformPosition(pos, source !== _emitter4.default.sources.USER);
                    });
                    var _map2 = _slicedToArray(_map, 2);
                    start = _map2[0];
                    end = _map2[1];
                } else {
                    var _map3 = [
                        range.index,
                        range.index + range.length
                    ].map(function(pos) {
                        if (pos < index || pos === index && source === _emitter4.default.sources.USER) return pos;
                        if (length >= 0) return pos + length;
                        else return Math.max(index, pos + length);
                    });
                    var _map4 = _slicedToArray(_map3, 2);
                    start = _map4[0];
                    end = _map4[1];
                }
                return new _selection.Range(start, end - start);
            }
            exports.expandConfig = expandConfig;
            exports.overload = overload;
            exports.default = Quill;
        /***/ },
        /* 6 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _text = __webpack_require__(7);
            var _text2 = _interopRequireDefault(_text);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Inline = function(_Parchment$Inline) {
                _inherits(Inline, _Parchment$Inline);
                function Inline() {
                    _classCallCheck(this, Inline);
                    return _possibleConstructorReturn(this, (Inline.__proto__ || Object.getPrototypeOf(Inline)).apply(this, arguments));
                }
                _createClass(Inline, [
                    {
                        key: "formatAt",
                        value: function formatAt(index, length, name, value) {
                            if (Inline.compare(this.statics.blotName, name) < 0 && _parchment2.default.query(name, _parchment2.default.Scope.BLOT)) {
                                var blot = this.isolate(index, length);
                                if (value) blot.wrap(name, value);
                            } else _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), "formatAt", this).call(this, index, length, name, value);
                        }
                    },
                    {
                        key: "optimize",
                        value: function optimize(context) {
                            _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), "optimize", this).call(this, context);
                            if (this.parent instanceof Inline && Inline.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
                                var parent = this.parent.isolate(this.offset(), this.length());
                                this.moveChildren(parent);
                                parent.wrap(this);
                            }
                        }
                    }
                ], [
                    {
                        key: "compare",
                        value: function compare(self1, other) {
                            var selfIndex = Inline.order.indexOf(self1);
                            var otherIndex = Inline.order.indexOf(other);
                            if (selfIndex >= 0 || otherIndex >= 0) return selfIndex - otherIndex;
                            else if (self1 === other) return 0;
                            else if (self1 < other) return -1;
                            else return 1;
                        }
                    }
                ]);
                return Inline;
            }(_parchment2.default.Inline);
            Inline.allowedChildren = [
                Inline,
                _parchment2.default.Embed,
                _text2.default
            ];
            // Lower index means deeper in the DOM tree, since not found (-1) is for embeds
            Inline.order = [
                "cursor",
                "inline",
                "underline",
                "strike",
                "italic",
                "bold",
                "script",
                "link",
                "code" // Must be higher
            ];
            exports.default = Inline;
        /***/ },
        /* 7 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var TextBlot = function(_Parchment$Text) {
                _inherits(TextBlot, _Parchment$Text);
                function TextBlot() {
                    _classCallCheck(this, TextBlot);
                    return _possibleConstructorReturn(this, (TextBlot.__proto__ || Object.getPrototypeOf(TextBlot)).apply(this, arguments));
                }
                return TextBlot;
            }(_parchment2.default.Text);
            exports.default = TextBlot;
        /***/ },
        /* 8 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _eventemitter = __webpack_require__(54);
            var _eventemitter2 = _interopRequireDefault(_eventemitter);
            var _logger = __webpack_require__(10);
            var _logger2 = _interopRequireDefault(_logger);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var debug = (0, _logger2.default)("quill:events");
            var EVENTS = [
                "selectionchange",
                "mousedown",
                "mouseup",
                "click"
            ];
            EVENTS.forEach(function(eventName) {
                document.addEventListener(eventName, function() {
                    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    [].slice.call(document.querySelectorAll(".ql-container")).forEach(function(node) {
                        // TODO use WeakMap
                        if (node.__quill && node.__quill.emitter) {
                            var _node$__quill$emitter;
                            (_node$__quill$emitter = node.__quill.emitter).handleDOM.apply(_node$__quill$emitter, args);
                        }
                    });
                });
            });
            var Emitter = function(_EventEmitter) {
                _inherits(Emitter, _EventEmitter);
                function Emitter() {
                    _classCallCheck(this, Emitter);
                    var _this = _possibleConstructorReturn(this, (Emitter.__proto__ || Object.getPrototypeOf(Emitter)).call(this));
                    _this.listeners = {};
                    _this.on("error", debug.error);
                    return _this;
                }
                _createClass(Emitter, [
                    {
                        key: "emit",
                        value: function emit() {
                            debug.log.apply(debug, arguments);
                            _get(Emitter.prototype.__proto__ || Object.getPrototypeOf(Emitter.prototype), "emit", this).apply(this, arguments);
                        }
                    },
                    {
                        key: "handleDOM",
                        value: function handleDOM(event) {
                            for(var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                            (this.listeners[event.type] || []).forEach(function(_ref) {
                                var node = _ref.node, handler = _ref.handler;
                                if (event.target === node || node.contains(event.target)) handler.apply(undefined, [
                                    event
                                ].concat(args));
                            });
                        }
                    },
                    {
                        key: "listenDOM",
                        value: function listenDOM(eventName, node, handler) {
                            if (!this.listeners[eventName]) this.listeners[eventName] = [];
                            this.listeners[eventName].push({
                                node: node,
                                handler: handler
                            });
                        }
                    }
                ]);
                return Emitter;
            }(_eventemitter2.default);
            Emitter.events = {
                EDITOR_CHANGE: "editor-change",
                SCROLL_BEFORE_UPDATE: "scroll-before-update",
                SCROLL_OPTIMIZE: "scroll-optimize",
                SCROLL_UPDATE: "scroll-update",
                SELECTION_CHANGE: "selection-change",
                TEXT_CHANGE: "text-change"
            };
            Emitter.sources = {
                API: "api",
                SILENT: "silent",
                USER: "user"
            };
            exports.default = Emitter;
        /***/ },
        /* 9 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var Module = function Module(quill) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                _classCallCheck(this, Module);
                this.quill = quill;
                this.options = options;
            };
            Module.DEFAULTS = {};
            exports.default = Module;
        /***/ },
        /* 10 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var levels = [
                "error",
                "warn",
                "log",
                "info"
            ];
            var level = "warn";
            function debug(method) {
                if (levels.indexOf(method) <= levels.indexOf(level)) {
                    var _console;
                    for(var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                    (_console = console)[method].apply(_console, args); // eslint-disable-line no-console
                }
            }
            function namespace(ns) {
                return levels.reduce(function(logger, method) {
                    logger[method] = debug.bind(console, method, ns);
                    return logger;
                }, {});
            }
            debug.level = namespace.level = function(newLevel) {
                level = newLevel;
            };
            exports.default = namespace;
        /***/ },
        /* 11 */ /***/ function(module1, exports, __webpack_require__) {
            var pSlice = Array.prototype.slice;
            var objectKeys = __webpack_require__(52);
            var isArguments = __webpack_require__(53);
            var deepEqual = module1.exports = function(actual, expected, opts) {
                if (!opts) opts = {};
                // 7.1. All identical values are equivalent, as determined by ===.
                if (actual === expected) return true;
                else if (actual instanceof Date && expected instanceof Date) return actual.getTime() === expected.getTime();
                else if (!actual || !expected || typeof actual != "object" && typeof expected != "object") return opts.strict ? actual === expected : actual == expected;
                else return objEquiv(actual, expected, opts);
            };
            function isUndefinedOrNull(value) {
                return value === null || value === undefined;
            }
            function isBuffer(x) {
                if (!x || typeof x !== "object" || typeof x.length !== "number") return false;
                if (typeof x.copy !== "function" || typeof x.slice !== "function") return false;
                if (x.length > 0 && typeof x[0] !== "number") return false;
                return true;
            }
            function objEquiv(a, b, opts) {
                var i, key;
                if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) return false;
                // an identical 'prototype' property.
                if (a.prototype !== b.prototype) return false;
                //~~~I've managed to break Object.keys through screwy arguments passing.
                //   Converting to array solves the problem.
                if (isArguments(a)) {
                    if (!isArguments(b)) return false;
                    a = pSlice.call(a);
                    b = pSlice.call(b);
                    return deepEqual(a, b, opts);
                }
                if (isBuffer(a)) {
                    if (!isBuffer(b)) return false;
                    if (a.length !== b.length) return false;
                    for(i = 0; i < a.length; i++){
                        if (a[i] !== b[i]) return false;
                    }
                    return true;
                }
                try {
                    var ka = objectKeys(a), kb = objectKeys(b);
                } catch (e) {
                    return false;
                }
                // having the same number of owned properties (keys incorporates
                // hasOwnProperty)
                if (ka.length != kb.length) return false;
                //the same set of keys (although not necessarily the same order),
                ka.sort();
                kb.sort();
                //~~~cheap key test
                for(i = ka.length - 1; i >= 0; i--){
                    if (ka[i] != kb[i]) return false;
                }
                //equivalent values for every corresponding key, and
                //~~~possibly expensive deep test
                for(i = ka.length - 1; i >= 0; i--){
                    key = ka[i];
                    if (!deepEqual(a[key], b[key], opts)) return false;
                }
                return typeof a === typeof b;
            }
        /***/ },
        /* 12 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var Registry = __webpack_require__(1);
            var Attributor = /** @class */ function() {
                function Attributor(attrName, keyName, options) {
                    if (options === void 0) options = {};
                    this.attrName = attrName;
                    this.keyName = keyName;
                    var attributeBit = Registry.Scope.TYPE & Registry.Scope.ATTRIBUTE;
                    if (options.scope != null) // Ignore type bits, force attribute bit
                    this.scope = options.scope & Registry.Scope.LEVEL | attributeBit;
                    else this.scope = Registry.Scope.ATTRIBUTE;
                    if (options.whitelist != null) this.whitelist = options.whitelist;
                }
                Attributor.keys = function(node) {
                    return [].map.call(node.attributes, function(item) {
                        return item.name;
                    });
                };
                Attributor.prototype.add = function(node, value) {
                    if (!this.canAdd(node, value)) return false;
                    node.setAttribute(this.keyName, value);
                    return true;
                };
                Attributor.prototype.canAdd = function(node, value) {
                    var match = Registry.query(node, Registry.Scope.BLOT & (this.scope | Registry.Scope.TYPE));
                    if (match == null) return false;
                    if (this.whitelist == null) return true;
                    if (typeof value === "string") return this.whitelist.indexOf(value.replace(/["']/g, "")) > -1;
                    else return this.whitelist.indexOf(value) > -1;
                };
                Attributor.prototype.remove = function(node) {
                    node.removeAttribute(this.keyName);
                };
                Attributor.prototype.value = function(node) {
                    var value = node.getAttribute(this.keyName);
                    if (this.canAdd(node, value) && value) return value;
                    return "";
                };
                return Attributor;
            }();
            exports.default = Attributor;
        /***/ },
        /* 13 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.Code = undefined;
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            var _text = __webpack_require__(7);
            var _text2 = _interopRequireDefault(_text);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Code = function(_Inline) {
                _inherits(Code, _Inline);
                function Code() {
                    _classCallCheck(this, Code);
                    return _possibleConstructorReturn(this, (Code.__proto__ || Object.getPrototypeOf(Code)).apply(this, arguments));
                }
                return Code;
            }(_inline2.default);
            Code.blotName = "code";
            Code.tagName = "CODE";
            var CodeBlock = function(_Block) {
                _inherits(CodeBlock, _Block);
                function CodeBlock() {
                    _classCallCheck(this, CodeBlock);
                    return _possibleConstructorReturn(this, (CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock)).apply(this, arguments));
                }
                _createClass(CodeBlock, [
                    {
                        key: "delta",
                        value: function delta() {
                            var _this3 = this;
                            var text = this.domNode.textContent;
                            if (text.endsWith("\n")) // Should always be true
                            text = text.slice(0, -1);
                            return text.split("\n").reduce(function(delta, frag) {
                                return delta.insert(frag).insert("\n", _this3.formats());
                            }, new _quillDelta2.default());
                        }
                    },
                    {
                        key: "format",
                        value: function format(name, value) {
                            if (name === this.statics.blotName && value) return;
                            var _descendant = this.descendant(_text2.default, this.length() - 1), _descendant2 = _slicedToArray(_descendant, 1), text = _descendant2[0];
                            if (text != null) text.deleteAt(text.length() - 1, 1);
                            _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), "format", this).call(this, name, value);
                        }
                    },
                    {
                        key: "formatAt",
                        value: function formatAt(index, length, name, value) {
                            if (length === 0) return;
                            if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK) == null || name === this.statics.blotName && value === this.statics.formats(this.domNode)) return;
                            var nextNewline = this.newlineIndex(index);
                            if (nextNewline < 0 || nextNewline >= index + length) return;
                            var prevNewline = this.newlineIndex(index, true) + 1;
                            var isolateLength = nextNewline - prevNewline + 1;
                            var blot = this.isolate(prevNewline, isolateLength);
                            var next = blot.next;
                            blot.format(name, value);
                            if (next instanceof CodeBlock) next.formatAt(0, index - prevNewline + length - isolateLength, name, value);
                        }
                    },
                    {
                        key: "insertAt",
                        value: function insertAt(index, value, def) {
                            if (def != null) return;
                            var _descendant3 = this.descendant(_text2.default, index), _descendant4 = _slicedToArray(_descendant3, 2), text = _descendant4[0], offset = _descendant4[1];
                            text.insertAt(offset, value);
                        }
                    },
                    {
                        key: "length",
                        value: function length() {
                            var length = this.domNode.textContent.length;
                            if (!this.domNode.textContent.endsWith("\n")) return length + 1;
                            return length;
                        }
                    },
                    {
                        key: "newlineIndex",
                        value: function newlineIndex(searchIndex) {
                            var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                            if (!reverse) {
                                var offset = this.domNode.textContent.slice(searchIndex).indexOf("\n");
                                return offset > -1 ? searchIndex + offset : -1;
                            } else return this.domNode.textContent.slice(0, searchIndex).lastIndexOf("\n");
                        }
                    },
                    {
                        key: "optimize",
                        value: function optimize(context) {
                            if (!this.domNode.textContent.endsWith("\n")) this.appendChild(_parchment2.default.create("text", "\n"));
                            _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), "optimize", this).call(this, context);
                            var next = this.next;
                            if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && this.statics.formats(this.domNode) === next.statics.formats(next.domNode)) {
                                next.optimize(context);
                                next.moveChildren(this);
                                next.remove();
                            }
                        }
                    },
                    {
                        key: "replace",
                        value: function replace(target) {
                            _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), "replace", this).call(this, target);
                            [].slice.call(this.domNode.querySelectorAll("*")).forEach(function(node) {
                                var blot = _parchment2.default.find(node);
                                if (blot == null) node.parentNode.removeChild(node);
                                else if (blot instanceof _parchment2.default.Embed) blot.remove();
                                else blot.unwrap();
                            });
                        }
                    }
                ], [
                    {
                        key: "create",
                        value: function create(value) {
                            var domNode = _get(CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock), "create", this).call(this, value);
                            domNode.setAttribute("spellcheck", false);
                            return domNode;
                        }
                    },
                    {
                        key: "formats",
                        value: function formats() {
                            return true;
                        }
                    }
                ]);
                return CodeBlock;
            }(_block2.default);
            CodeBlock.blotName = "code-block";
            CodeBlock.tagName = "PRE";
            CodeBlock.TAB = "  ";
            exports.Code = Code;
            exports.default = CodeBlock;
        /***/ },
        /* 14 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _op = __webpack_require__(20);
            var _op2 = _interopRequireDefault(_op);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _code = __webpack_require__(13);
            var _code2 = _interopRequireDefault(_code);
            var _cursor = __webpack_require__(24);
            var _cursor2 = _interopRequireDefault(_cursor);
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            var _break = __webpack_require__(16);
            var _break2 = _interopRequireDefault(_break);
            var _clone = __webpack_require__(21);
            var _clone2 = _interopRequireDefault(_clone);
            var _deepEqual = __webpack_require__(11);
            var _deepEqual2 = _interopRequireDefault(_deepEqual);
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var ASCII = /^[ -~]*$/;
            var Editor = function() {
                function Editor(scroll) {
                    _classCallCheck(this, Editor);
                    this.scroll = scroll;
                    this.delta = this.getDelta();
                }
                _createClass(Editor, [
                    {
                        key: "applyDelta",
                        value: function applyDelta(delta) {
                            var _this = this;
                            var consumeNextNewline = false;
                            this.scroll.update();
                            var scrollLength = this.scroll.length();
                            this.scroll.batchStart();
                            delta = normalizeDelta(delta);
                            delta.reduce(function(index, op) {
                                var length = op.retain || op.delete || op.insert.length || 1;
                                var attributes = op.attributes || {};
                                if (op.insert != null) {
                                    if (typeof op.insert === "string") {
                                        var text = op.insert;
                                        if (text.endsWith("\n") && consumeNextNewline) {
                                            consumeNextNewline = false;
                                            text = text.slice(0, -1);
                                        }
                                        if (index >= scrollLength && !text.endsWith("\n")) consumeNextNewline = true;
                                        _this.scroll.insertAt(index, text);
                                        var _scroll$line = _this.scroll.line(index), _scroll$line2 = _slicedToArray(_scroll$line, 2), line = _scroll$line2[0], offset = _scroll$line2[1];
                                        var formats = (0, _extend2.default)({}, (0, _block.bubbleFormats)(line));
                                        if (line instanceof _block2.default) {
                                            var _line$descendant = line.descendant(_parchment2.default.Leaf, offset), _line$descendant2 = _slicedToArray(_line$descendant, 1), leaf = _line$descendant2[0];
                                            formats = (0, _extend2.default)(formats, (0, _block.bubbleFormats)(leaf));
                                        }
                                        attributes = _op2.default.attributes.diff(formats, attributes) || {};
                                    } else if (_typeof(op.insert) === "object") {
                                        var key = Object.keys(op.insert)[0]; // There should only be one key
                                        if (key == null) return index;
                                        _this.scroll.insertAt(index, key, op.insert[key]);
                                    }
                                    scrollLength += length;
                                }
                                Object.keys(attributes).forEach(function(name) {
                                    _this.scroll.formatAt(index, length, name, attributes[name]);
                                });
                                return index + length;
                            }, 0);
                            delta.reduce(function(index, op) {
                                if (typeof op.delete === "number") {
                                    _this.scroll.deleteAt(index, op.delete);
                                    return index;
                                }
                                return index + (op.retain || op.insert.length || 1);
                            }, 0);
                            this.scroll.batchEnd();
                            return this.update(delta);
                        }
                    },
                    {
                        key: "deleteText",
                        value: function deleteText(index, length) {
                            this.scroll.deleteAt(index, length);
                            return this.update(new _quillDelta2.default().retain(index).delete(length));
                        }
                    },
                    {
                        key: "formatLine",
                        value: function formatLine(index, length) {
                            var _this2 = this;
                            var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                            this.scroll.update();
                            Object.keys(formats).forEach(function(format) {
                                if (_this2.scroll.whitelist != null && !_this2.scroll.whitelist[format]) return;
                                var lines = _this2.scroll.lines(index, Math.max(length, 1));
                                var lengthRemaining = length;
                                lines.forEach(function(line) {
                                    var lineLength = line.length();
                                    if (!(line instanceof _code2.default)) line.format(format, formats[format]);
                                    else {
                                        var codeIndex = index - line.offset(_this2.scroll);
                                        var codeLength = line.newlineIndex(codeIndex + lengthRemaining) - codeIndex + 1;
                                        line.formatAt(codeIndex, codeLength, format, formats[format]);
                                    }
                                    lengthRemaining -= lineLength;
                                });
                            });
                            this.scroll.optimize();
                            return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
                        }
                    },
                    {
                        key: "formatText",
                        value: function formatText(index, length) {
                            var _this3 = this;
                            var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                            Object.keys(formats).forEach(function(format) {
                                _this3.scroll.formatAt(index, length, format, formats[format]);
                            });
                            return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
                        }
                    },
                    {
                        key: "getContents",
                        value: function getContents(index, length) {
                            return this.delta.slice(index, index + length);
                        }
                    },
                    {
                        key: "getDelta",
                        value: function getDelta() {
                            return this.scroll.lines().reduce(function(delta, line) {
                                return delta.concat(line.delta());
                            }, new _quillDelta2.default());
                        }
                    },
                    {
                        key: "getFormat",
                        value: function getFormat(index) {
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                            var lines = [], leaves = [];
                            if (length === 0) this.scroll.path(index).forEach(function(path) {
                                var _path = _slicedToArray(path, 1), blot = _path[0];
                                if (blot instanceof _block2.default) lines.push(blot);
                                else if (blot instanceof _parchment2.default.Leaf) leaves.push(blot);
                            });
                            else {
                                lines = this.scroll.lines(index, length);
                                leaves = this.scroll.descendants(_parchment2.default.Leaf, index, length);
                            }
                            var formatsArr = [
                                lines,
                                leaves
                            ].map(function(blots) {
                                if (blots.length === 0) return {};
                                var formats = (0, _block.bubbleFormats)(blots.shift());
                                while(Object.keys(formats).length > 0){
                                    var blot = blots.shift();
                                    if (blot == null) return formats;
                                    formats = combineFormats((0, _block.bubbleFormats)(blot), formats);
                                }
                                return formats;
                            });
                            return _extend2.default.apply(_extend2.default, formatsArr);
                        }
                    },
                    {
                        key: "getText",
                        value: function getText(index, length) {
                            return this.getContents(index, length).filter(function(op) {
                                return typeof op.insert === "string";
                            }).map(function(op) {
                                return op.insert;
                            }).join("");
                        }
                    },
                    {
                        key: "insertEmbed",
                        value: function insertEmbed(index, embed, value) {
                            this.scroll.insertAt(index, embed, value);
                            return this.update(new _quillDelta2.default().retain(index).insert(_defineProperty({}, embed, value)));
                        }
                    },
                    {
                        key: "insertText",
                        value: function insertText(index, text) {
                            var _this4 = this;
                            var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                            text = text.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
                            this.scroll.insertAt(index, text);
                            Object.keys(formats).forEach(function(format) {
                                _this4.scroll.formatAt(index, text.length, format, formats[format]);
                            });
                            return this.update(new _quillDelta2.default().retain(index).insert(text, (0, _clone2.default)(formats)));
                        }
                    },
                    {
                        key: "isBlank",
                        value: function isBlank() {
                            if (this.scroll.children.length == 0) return true;
                            if (this.scroll.children.length > 1) return false;
                            var block = this.scroll.children.head;
                            if (block.statics.blotName !== _block2.default.blotName) return false;
                            if (block.children.length > 1) return false;
                            return block.children.head instanceof _break2.default;
                        }
                    },
                    {
                        key: "removeFormat",
                        value: function removeFormat(index, length) {
                            var text = this.getText(index, length);
                            var _scroll$line3 = this.scroll.line(index + length), _scroll$line4 = _slicedToArray(_scroll$line3, 2), line = _scroll$line4[0], offset = _scroll$line4[1];
                            var suffixLength = 0, suffix = new _quillDelta2.default();
                            if (line != null) {
                                if (!(line instanceof _code2.default)) suffixLength = line.length() - offset;
                                else suffixLength = line.newlineIndex(offset) - offset + 1;
                                suffix = line.delta().slice(offset, offset + suffixLength - 1).insert("\n");
                            }
                            var contents = this.getContents(index, length + suffixLength);
                            var diff = contents.diff(new _quillDelta2.default().insert(text).concat(suffix));
                            var delta = new _quillDelta2.default().retain(index).concat(diff);
                            return this.applyDelta(delta);
                        }
                    },
                    {
                        key: "update",
                        value: function update(change) {
                            var mutations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                            var cursorIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                            var oldDelta = this.delta;
                            if (mutations.length === 1 && mutations[0].type === "characterData" && mutations[0].target.data.match(ASCII) && _parchment2.default.find(mutations[0].target)) {
                                // Optimization for character changes
                                var textBlot = _parchment2.default.find(mutations[0].target);
                                var formats = (0, _block.bubbleFormats)(textBlot);
                                var index = textBlot.offset(this.scroll);
                                var oldValue = mutations[0].oldValue.replace(_cursor2.default.CONTENTS, "");
                                var oldText = new _quillDelta2.default().insert(oldValue);
                                var newText = new _quillDelta2.default().insert(textBlot.value());
                                var diffDelta = new _quillDelta2.default().retain(index).concat(oldText.diff(newText, cursorIndex));
                                change = diffDelta.reduce(function(delta, op) {
                                    if (op.insert) return delta.insert(op.insert, formats);
                                    else return delta.push(op);
                                }, new _quillDelta2.default());
                                this.delta = oldDelta.compose(change);
                            } else {
                                this.delta = this.getDelta();
                                if (!change || !(0, _deepEqual2.default)(oldDelta.compose(change), this.delta)) change = oldDelta.diff(this.delta, cursorIndex);
                            }
                            return change;
                        }
                    }
                ]);
                return Editor;
            }();
            function combineFormats(formats, combined) {
                return Object.keys(combined).reduce(function(merged, name) {
                    if (formats[name] == null) return merged;
                    if (combined[name] === formats[name]) merged[name] = combined[name];
                    else if (Array.isArray(combined[name])) {
                        if (combined[name].indexOf(formats[name]) < 0) merged[name] = combined[name].concat([
                            formats[name]
                        ]);
                    } else merged[name] = [
                        combined[name],
                        formats[name]
                    ];
                    return merged;
                }, {});
            }
            function normalizeDelta(delta) {
                return delta.reduce(function(delta, op) {
                    if (op.insert === 1) {
                        var attributes = (0, _clone2.default)(op.attributes);
                        delete attributes["image"];
                        return delta.insert({
                            image: op.attributes.image
                        }, attributes);
                    }
                    if (op.attributes != null && (op.attributes.list === true || op.attributes.bullet === true)) {
                        op = (0, _clone2.default)(op);
                        if (op.attributes.list) op.attributes.list = "ordered";
                        else {
                            op.attributes.list = "bullet";
                            delete op.attributes.bullet;
                        }
                    }
                    if (typeof op.insert === "string") {
                        var text = op.insert.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
                        return delta.insert(text, op.attributes);
                    }
                    return delta.push(op);
                }, new _quillDelta2.default());
            }
            exports.default = Editor;
        /***/ },
        /* 15 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.Range = undefined;
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _clone = __webpack_require__(21);
            var _clone2 = _interopRequireDefault(_clone);
            var _deepEqual = __webpack_require__(11);
            var _deepEqual2 = _interopRequireDefault(_deepEqual);
            var _emitter3 = __webpack_require__(8);
            var _emitter4 = _interopRequireDefault(_emitter3);
            var _logger = __webpack_require__(10);
            var _logger2 = _interopRequireDefault(_logger);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _toConsumableArray(arr) {
                if (Array.isArray(arr)) {
                    for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
                    return arr2;
                } else return Array.from(arr);
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var debug = (0, _logger2.default)("quill:selection");
            var Range = function Range(index) {
                var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                _classCallCheck(this, Range);
                this.index = index;
                this.length = length;
            };
            var Selection = function() {
                function Selection(scroll, emitter) {
                    var _this = this;
                    _classCallCheck(this, Selection);
                    this.emitter = emitter;
                    this.scroll = scroll;
                    this.composing = false;
                    this.mouseDown = false;
                    this.root = this.scroll.domNode;
                    this.cursor = _parchment2.default.create("cursor", this);
                    // savedRange is last non-null range
                    this.lastRange = this.savedRange = new Range(0, 0);
                    this.handleComposition();
                    this.handleDragging();
                    this.emitter.listenDOM("selectionchange", document, function() {
                        if (!_this.mouseDown) setTimeout(_this.update.bind(_this, _emitter4.default.sources.USER), 1);
                    });
                    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function(type, delta) {
                        if (type === _emitter4.default.events.TEXT_CHANGE && delta.length() > 0) _this.update(_emitter4.default.sources.SILENT);
                    });
                    this.emitter.on(_emitter4.default.events.SCROLL_BEFORE_UPDATE, function() {
                        if (!_this.hasFocus()) return;
                        var native = _this.getNativeRange();
                        if (native == null) return;
                        if (native.start.node === _this.cursor.textNode) return; // cursor.restore() will handle
                        // TODO unclear if this has negative side effects
                        _this.emitter.once(_emitter4.default.events.SCROLL_UPDATE, function() {
                            try {
                                _this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
                            } catch (ignored) {}
                        });
                    });
                    this.emitter.on(_emitter4.default.events.SCROLL_OPTIMIZE, function(mutations, context) {
                        if (context.range) {
                            var _context$range = context.range, startNode = _context$range.startNode, startOffset = _context$range.startOffset, endNode = _context$range.endNode, endOffset = _context$range.endOffset;
                            _this.setNativeRange(startNode, startOffset, endNode, endOffset);
                        }
                    });
                    this.update(_emitter4.default.sources.SILENT);
                }
                _createClass(Selection, [
                    {
                        key: "handleComposition",
                        value: function handleComposition() {
                            var _this2 = this;
                            this.root.addEventListener("compositionstart", function() {
                                _this2.composing = true;
                            });
                            this.root.addEventListener("compositionend", function() {
                                _this2.composing = false;
                                if (_this2.cursor.parent) {
                                    var range = _this2.cursor.restore();
                                    if (!range) return;
                                    setTimeout(function() {
                                        _this2.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
                                    }, 1);
                                }
                            });
                        }
                    },
                    {
                        key: "handleDragging",
                        value: function handleDragging() {
                            var _this3 = this;
                            this.emitter.listenDOM("mousedown", document.body, function() {
                                _this3.mouseDown = true;
                            });
                            this.emitter.listenDOM("mouseup", document.body, function() {
                                _this3.mouseDown = false;
                                _this3.update(_emitter4.default.sources.USER);
                            });
                        }
                    },
                    {
                        key: "focus",
                        value: function focus() {
                            if (this.hasFocus()) return;
                            this.root.focus();
                            this.setRange(this.savedRange);
                        }
                    },
                    {
                        key: "format",
                        value: function format(_format, value) {
                            if (this.scroll.whitelist != null && !this.scroll.whitelist[_format]) return;
                            this.scroll.update();
                            var nativeRange = this.getNativeRange();
                            if (nativeRange == null || !nativeRange.native.collapsed || _parchment2.default.query(_format, _parchment2.default.Scope.BLOCK)) return;
                            if (nativeRange.start.node !== this.cursor.textNode) {
                                var blot = _parchment2.default.find(nativeRange.start.node, false);
                                if (blot == null) return;
                                // TODO Give blot ability to not split
                                if (blot instanceof _parchment2.default.Leaf) {
                                    var after = blot.split(nativeRange.start.offset);
                                    blot.parent.insertBefore(this.cursor, after);
                                } else blot.insertBefore(this.cursor, nativeRange.start.node); // Should never happen
                                this.cursor.attach();
                            }
                            this.cursor.format(_format, value);
                            this.scroll.optimize();
                            this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
                            this.update();
                        }
                    },
                    {
                        key: "getBounds",
                        value: function getBounds(index) {
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                            var scrollLength = this.scroll.length();
                            index = Math.min(index, scrollLength - 1);
                            length = Math.min(index + length, scrollLength - 1) - index;
                            var node = void 0, _scroll$leaf = this.scroll.leaf(index), _scroll$leaf2 = _slicedToArray(_scroll$leaf, 2), leaf = _scroll$leaf2[0], offset = _scroll$leaf2[1];
                            if (leaf == null) return null;
                            var _leaf$position = leaf.position(offset, true);
                            var _leaf$position2 = _slicedToArray(_leaf$position, 2);
                            node = _leaf$position2[0];
                            offset = _leaf$position2[1];
                            var range = document.createRange();
                            if (length > 0) {
                                range.setStart(node, offset);
                                var _scroll$leaf3 = this.scroll.leaf(index + length);
                                var _scroll$leaf4 = _slicedToArray(_scroll$leaf3, 2);
                                leaf = _scroll$leaf4[0];
                                offset = _scroll$leaf4[1];
                                if (leaf == null) return null;
                                var _leaf$position3 = leaf.position(offset, true);
                                var _leaf$position4 = _slicedToArray(_leaf$position3, 2);
                                node = _leaf$position4[0];
                                offset = _leaf$position4[1];
                                range.setEnd(node, offset);
                                return range.getBoundingClientRect();
                            } else {
                                var side = "left";
                                var rect = void 0;
                                if (node instanceof Text) {
                                    if (offset < node.data.length) {
                                        range.setStart(node, offset);
                                        range.setEnd(node, offset + 1);
                                    } else {
                                        range.setStart(node, offset - 1);
                                        range.setEnd(node, offset);
                                        side = "right";
                                    }
                                    rect = range.getBoundingClientRect();
                                } else {
                                    rect = leaf.domNode.getBoundingClientRect();
                                    if (offset > 0) side = "right";
                                }
                                return {
                                    bottom: rect.top + rect.height,
                                    height: rect.height,
                                    left: rect[side],
                                    right: rect[side],
                                    top: rect.top,
                                    width: 0
                                };
                            }
                        }
                    },
                    {
                        key: "getNativeRange",
                        value: function getNativeRange() {
                            var selection = document.getSelection();
                            if (selection == null || selection.rangeCount <= 0) return null;
                            var nativeRange = selection.getRangeAt(0);
                            if (nativeRange == null) return null;
                            var range = this.normalizeNative(nativeRange);
                            debug.info("getNativeRange", range);
                            return range;
                        }
                    },
                    {
                        key: "getRange",
                        value: function getRange() {
                            var normalized = this.getNativeRange();
                            if (normalized == null) return [
                                null,
                                null
                            ];
                            var range = this.normalizedToRange(normalized);
                            return [
                                range,
                                normalized
                            ];
                        }
                    },
                    {
                        key: "hasFocus",
                        value: function hasFocus() {
                            return document.activeElement === this.root;
                        }
                    },
                    {
                        key: "normalizedToRange",
                        value: function normalizedToRange(range) {
                            var _this4 = this;
                            var positions = [
                                [
                                    range.start.node,
                                    range.start.offset
                                ]
                            ];
                            if (!range.native.collapsed) positions.push([
                                range.end.node,
                                range.end.offset
                            ]);
                            var indexes = positions.map(function(position) {
                                var _position = _slicedToArray(position, 2), node = _position[0], offset = _position[1];
                                var blot = _parchment2.default.find(node, true);
                                var index = blot.offset(_this4.scroll);
                                if (offset === 0) return index;
                                else if (blot instanceof _parchment2.default.Container) return index + blot.length();
                                else return index + blot.index(node, offset);
                            });
                            var end = Math.min(Math.max.apply(Math, _toConsumableArray(indexes)), this.scroll.length() - 1);
                            var start = Math.min.apply(Math, [
                                end
                            ].concat(_toConsumableArray(indexes)));
                            return new Range(start, end - start);
                        }
                    },
                    {
                        key: "normalizeNative",
                        value: function normalizeNative(nativeRange) {
                            if (!contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !contains(this.root, nativeRange.endContainer)) return null;
                            var range = {
                                start: {
                                    node: nativeRange.startContainer,
                                    offset: nativeRange.startOffset
                                },
                                end: {
                                    node: nativeRange.endContainer,
                                    offset: nativeRange.endOffset
                                },
                                native: nativeRange
                            };
                            [
                                range.start,
                                range.end
                            ].forEach(function(position) {
                                var node = position.node, offset = position.offset;
                                while(!(node instanceof Text) && node.childNodes.length > 0){
                                    if (node.childNodes.length > offset) {
                                        node = node.childNodes[offset];
                                        offset = 0;
                                    } else if (node.childNodes.length === offset) {
                                        node = node.lastChild;
                                        offset = node instanceof Text ? node.data.length : node.childNodes.length + 1;
                                    } else break;
                                }
                                position.node = node, position.offset = offset;
                            });
                            return range;
                        }
                    },
                    {
                        key: "rangeToNative",
                        value: function rangeToNative(range) {
                            var _this5 = this;
                            var indexes = range.collapsed ? [
                                range.index
                            ] : [
                                range.index,
                                range.index + range.length
                            ];
                            var args = [];
                            var scrollLength = this.scroll.length();
                            indexes.forEach(function(index, i) {
                                index = Math.min(scrollLength - 1, index);
                                var node = void 0, _scroll$leaf5 = _this5.scroll.leaf(index), _scroll$leaf6 = _slicedToArray(_scroll$leaf5, 2), leaf = _scroll$leaf6[0], offset = _scroll$leaf6[1];
                                var _leaf$position5 = leaf.position(offset, i !== 0);
                                var _leaf$position6 = _slicedToArray(_leaf$position5, 2);
                                node = _leaf$position6[0];
                                offset = _leaf$position6[1];
                                args.push(node, offset);
                            });
                            if (args.length < 2) args = args.concat(args);
                            return args;
                        }
                    },
                    {
                        key: "scrollIntoView",
                        value: function scrollIntoView(scrollingContainer) {
                            var range = this.lastRange;
                            if (range == null) return;
                            var bounds = this.getBounds(range.index, range.length);
                            if (bounds == null) return;
                            var limit = this.scroll.length() - 1;
                            var _scroll$line = this.scroll.line(Math.min(range.index, limit)), _scroll$line2 = _slicedToArray(_scroll$line, 1), first = _scroll$line2[0];
                            var last = first;
                            if (range.length > 0) {
                                var _scroll$line3 = this.scroll.line(Math.min(range.index + range.length, limit));
                                var _scroll$line4 = _slicedToArray(_scroll$line3, 1);
                                last = _scroll$line4[0];
                            }
                            if (first == null || last == null) return;
                            var scrollBounds = scrollingContainer.getBoundingClientRect();
                            if (bounds.top < scrollBounds.top) scrollingContainer.scrollTop -= scrollBounds.top - bounds.top;
                            else if (bounds.bottom > scrollBounds.bottom) scrollingContainer.scrollTop += bounds.bottom - scrollBounds.bottom;
                        }
                    },
                    {
                        key: "setNativeRange",
                        value: function setNativeRange(startNode, startOffset) {
                            var endNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startNode;
                            var endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : startOffset;
                            var force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
                            debug.info("setNativeRange", startNode, startOffset, endNode, endOffset);
                            if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || endNode.parentNode == null)) return;
                            var selection = document.getSelection();
                            if (selection == null) return;
                            if (startNode != null) {
                                if (!this.hasFocus()) this.root.focus();
                                var native = (this.getNativeRange() || {}).native;
                                if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {
                                    if (startNode.tagName == "BR") {
                                        startOffset = [].indexOf.call(startNode.parentNode.childNodes, startNode);
                                        startNode = startNode.parentNode;
                                    }
                                    if (endNode.tagName == "BR") {
                                        endOffset = [].indexOf.call(endNode.parentNode.childNodes, endNode);
                                        endNode = endNode.parentNode;
                                    }
                                    var range = document.createRange();
                                    range.setStart(startNode, startOffset);
                                    range.setEnd(endNode, endOffset);
                                    selection.removeAllRanges();
                                    selection.addRange(range);
                                }
                            } else {
                                selection.removeAllRanges();
                                this.root.blur();
                                document.body.focus(); // root.blur() not enough on IE11+Travis+SauceLabs (but not local VMs)
                            }
                        }
                    },
                    {
                        key: "setRange",
                        value: function setRange(range) {
                            var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                            var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;
                            if (typeof force === "string") {
                                source = force;
                                force = false;
                            }
                            debug.info("setRange", range);
                            if (range != null) {
                                var args = this.rangeToNative(range);
                                this.setNativeRange.apply(this, _toConsumableArray(args).concat([
                                    force
                                ]));
                            } else this.setNativeRange(null);
                            this.update(source);
                        }
                    },
                    {
                        key: "update",
                        value: function update() {
                            var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;
                            var oldRange = this.lastRange;
                            var _getRange = this.getRange(), _getRange2 = _slicedToArray(_getRange, 2), lastRange = _getRange2[0], nativeRange = _getRange2[1];
                            this.lastRange = lastRange;
                            if (this.lastRange != null) this.savedRange = this.lastRange;
                            if (!(0, _deepEqual2.default)(oldRange, this.lastRange)) {
                                var _emitter;
                                if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) this.cursor.restore();
                                var args = [
                                    _emitter4.default.events.SELECTION_CHANGE,
                                    (0, _clone2.default)(this.lastRange),
                                    (0, _clone2.default)(oldRange),
                                    source
                                ];
                                (_emitter = this.emitter).emit.apply(_emitter, [
                                    _emitter4.default.events.EDITOR_CHANGE
                                ].concat(args));
                                if (source !== _emitter4.default.sources.SILENT) {
                                    var _emitter2;
                                    (_emitter2 = this.emitter).emit.apply(_emitter2, args);
                                }
                            }
                        }
                    }
                ]);
                return Selection;
            }();
            function contains(parent, descendant) {
                try {
                    // Firefox inserts inaccessible nodes around video elements
                    descendant.parentNode;
                } catch (e) {
                    return false;
                }
                // IE11 has bug with Text nodes
                // https://connect.microsoft.com/IE/feedback/details/780874/node-contains-is-incorrect
                if (descendant instanceof Text) descendant = descendant.parentNode;
                return parent.contains(descendant);
            }
            exports.Range = Range;
            exports.default = Selection;
        /***/ },
        /* 16 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Break = function(_Parchment$Embed) {
                _inherits(Break, _Parchment$Embed);
                function Break() {
                    _classCallCheck(this, Break);
                    return _possibleConstructorReturn(this, (Break.__proto__ || Object.getPrototypeOf(Break)).apply(this, arguments));
                }
                _createClass(Break, [
                    {
                        key: "insertInto",
                        value: function insertInto(parent, ref) {
                            if (parent.children.length === 0) _get(Break.prototype.__proto__ || Object.getPrototypeOf(Break.prototype), "insertInto", this).call(this, parent, ref);
                            else this.remove();
                        }
                    },
                    {
                        key: "length",
                        value: function length() {
                            return 0;
                        }
                    },
                    {
                        key: "value",
                        value: function value() {
                            return "";
                        }
                    }
                ], [
                    {
                        key: "value",
                        value: function value() {
                            return undefined;
                        }
                    }
                ]);
                return Break;
            }(_parchment2.default.Embed);
            Break.blotName = "break";
            Break.tagName = "BR";
            exports.default = Break;
        /***/ },
        /* 17 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var linked_list_1 = __webpack_require__(44);
            var shadow_1 = __webpack_require__(30);
            var Registry = __webpack_require__(1);
            var ContainerBlot = /** @class */ function(_super) {
                __extends(ContainerBlot, _super);
                function ContainerBlot(domNode) {
                    var _this = _super.call(this, domNode) || this;
                    _this.build();
                    return _this;
                }
                ContainerBlot.prototype.appendChild = function(other) {
                    this.insertBefore(other);
                };
                ContainerBlot.prototype.attach = function() {
                    _super.prototype.attach.call(this);
                    this.children.forEach(function(child) {
                        child.attach();
                    });
                };
                ContainerBlot.prototype.build = function() {
                    var _this = this;
                    this.children = new linked_list_1.default();
                    // Need to be reversed for if DOM nodes already in order
                    [].slice.call(this.domNode.childNodes).reverse().forEach(function(node) {
                        try {
                            var child = makeBlot(node);
                            _this.insertBefore(child, _this.children.head || undefined);
                        } catch (err) {
                            if (err instanceof Registry.ParchmentError) return;
                            else throw err;
                        }
                    });
                };
                ContainerBlot.prototype.deleteAt = function(index, length) {
                    if (index === 0 && length === this.length()) return this.remove();
                    this.children.forEachAt(index, length, function(child, offset, length) {
                        child.deleteAt(offset, length);
                    });
                };
                ContainerBlot.prototype.descendant = function(criteria, index) {
                    var _a = this.children.find(index), child = _a[0], offset = _a[1];
                    if (criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria) return [
                        child,
                        offset
                    ];
                    else if (child instanceof ContainerBlot) return child.descendant(criteria, offset);
                    else return [
                        null,
                        -1
                    ];
                };
                ContainerBlot.prototype.descendants = function(criteria, index, length) {
                    if (index === void 0) index = 0;
                    if (length === void 0) length = Number.MAX_VALUE;
                    var descendants = [];
                    var lengthLeft = length;
                    this.children.forEachAt(index, length, function(child, index, length) {
                        if (criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria) descendants.push(child);
                        if (child instanceof ContainerBlot) descendants = descendants.concat(child.descendants(criteria, index, lengthLeft));
                        lengthLeft -= length;
                    });
                    return descendants;
                };
                ContainerBlot.prototype.detach = function() {
                    this.children.forEach(function(child) {
                        child.detach();
                    });
                    _super.prototype.detach.call(this);
                };
                ContainerBlot.prototype.formatAt = function(index, length, name, value) {
                    this.children.forEachAt(index, length, function(child, offset, length) {
                        child.formatAt(offset, length, name, value);
                    });
                };
                ContainerBlot.prototype.insertAt = function(index, value, def) {
                    var _a = this.children.find(index), child = _a[0], offset = _a[1];
                    if (child) child.insertAt(offset, value, def);
                    else {
                        var blot = def == null ? Registry.create("text", value) : Registry.create(value, def);
                        this.appendChild(blot);
                    }
                };
                ContainerBlot.prototype.insertBefore = function(childBlot, refBlot) {
                    if (this.statics.allowedChildren != null && !this.statics.allowedChildren.some(function(child) {
                        return childBlot instanceof child;
                    })) throw new Registry.ParchmentError("Cannot insert " + childBlot.statics.blotName + " into " + this.statics.blotName);
                    childBlot.insertInto(this, refBlot);
                };
                ContainerBlot.prototype.length = function() {
                    return this.children.reduce(function(memo, child) {
                        return memo + child.length();
                    }, 0);
                };
                ContainerBlot.prototype.moveChildren = function(targetParent, refNode) {
                    this.children.forEach(function(child) {
                        targetParent.insertBefore(child, refNode);
                    });
                };
                ContainerBlot.prototype.optimize = function(context) {
                    _super.prototype.optimize.call(this, context);
                    if (this.children.length === 0) {
                        if (this.statics.defaultChild != null) {
                            var child = Registry.create(this.statics.defaultChild);
                            this.appendChild(child);
                            child.optimize(context);
                        } else this.remove();
                    }
                };
                ContainerBlot.prototype.path = function(index, inclusive) {
                    if (inclusive === void 0) inclusive = false;
                    var _a = this.children.find(index, inclusive), child = _a[0], offset = _a[1];
                    var position = [
                        [
                            this,
                            index
                        ]
                    ];
                    if (child instanceof ContainerBlot) return position.concat(child.path(offset, inclusive));
                    else if (child != null) position.push([
                        child,
                        offset
                    ]);
                    return position;
                };
                ContainerBlot.prototype.removeChild = function(child) {
                    this.children.remove(child);
                };
                ContainerBlot.prototype.replace = function(target) {
                    if (target instanceof ContainerBlot) target.moveChildren(this);
                    _super.prototype.replace.call(this, target);
                };
                ContainerBlot.prototype.split = function(index, force) {
                    if (force === void 0) force = false;
                    if (!force) {
                        if (index === 0) return this;
                        if (index === this.length()) return this.next;
                    }
                    var after = this.clone();
                    this.parent.insertBefore(after, this.next);
                    this.children.forEachAt(index, this.length(), function(child, offset, length) {
                        child = child.split(offset, force);
                        after.appendChild(child);
                    });
                    return after;
                };
                ContainerBlot.prototype.unwrap = function() {
                    this.moveChildren(this.parent, this.next);
                    this.remove();
                };
                ContainerBlot.prototype.update = function(mutations, context) {
                    var _this = this;
                    var addedNodes = [];
                    var removedNodes = [];
                    mutations.forEach(function(mutation) {
                        if (mutation.target === _this.domNode && mutation.type === "childList") {
                            addedNodes.push.apply(addedNodes, mutation.addedNodes);
                            removedNodes.push.apply(removedNodes, mutation.removedNodes);
                        }
                    });
                    removedNodes.forEach(function(node) {
                        // Check node has actually been removed
                        // One exception is Chrome does not immediately remove IFRAMEs
                        // from DOM but MutationRecord is correct in its reported removal
                        if (node.parentNode != null && // @ts-ignore
                        node.tagName !== "IFRAME" && document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) return;
                        var blot = Registry.find(node);
                        if (blot == null) return;
                        if (blot.domNode.parentNode == null || blot.domNode.parentNode === _this.domNode) blot.detach();
                    });
                    addedNodes.filter(function(node) {
                        return node.parentNode == _this.domNode;
                    }).sort(function(a, b) {
                        if (a === b) return 0;
                        if (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) return 1;
                        return -1;
                    }).forEach(function(node) {
                        var refBlot = null;
                        if (node.nextSibling != null) refBlot = Registry.find(node.nextSibling);
                        var blot = makeBlot(node);
                        if (blot.next != refBlot || blot.next == null) {
                            if (blot.parent != null) blot.parent.removeChild(_this);
                            _this.insertBefore(blot, refBlot || undefined);
                        }
                    });
                };
                return ContainerBlot;
            }(shadow_1.default);
            function makeBlot(node) {
                var blot = Registry.find(node);
                if (blot == null) try {
                    blot = Registry.create(node);
                } catch (e) {
                    blot = Registry.create(Registry.Scope.INLINE);
                    [].slice.call(node.childNodes).forEach(function(child) {
                        // @ts-ignore
                        blot.domNode.appendChild(child);
                    });
                    if (node.parentNode) node.parentNode.replaceChild(blot.domNode, node);
                    blot.attach();
                }
                return blot;
            }
            exports.default = ContainerBlot;
        /***/ },
        /* 18 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var attributor_1 = __webpack_require__(12);
            var store_1 = __webpack_require__(31);
            var container_1 = __webpack_require__(17);
            var Registry = __webpack_require__(1);
            var FormatBlot = /** @class */ function(_super) {
                __extends(FormatBlot, _super);
                function FormatBlot(domNode) {
                    var _this = _super.call(this, domNode) || this;
                    _this.attributes = new store_1.default(_this.domNode);
                    return _this;
                }
                FormatBlot.formats = function(domNode) {
                    if (typeof this.tagName === "string") return true;
                    else if (Array.isArray(this.tagName)) return domNode.tagName.toLowerCase();
                    return undefined;
                };
                FormatBlot.prototype.format = function(name, value) {
                    var format = Registry.query(name);
                    if (format instanceof attributor_1.default) this.attributes.attribute(format, value);
                    else if (value) {
                        if (format != null && (name !== this.statics.blotName || this.formats()[name] !== value)) this.replaceWith(name, value);
                    }
                };
                FormatBlot.prototype.formats = function() {
                    var formats = this.attributes.values();
                    var format = this.statics.formats(this.domNode);
                    if (format != null) formats[this.statics.blotName] = format;
                    return formats;
                };
                FormatBlot.prototype.replaceWith = function(name, value) {
                    var replacement = _super.prototype.replaceWith.call(this, name, value);
                    this.attributes.copy(replacement);
                    return replacement;
                };
                FormatBlot.prototype.update = function(mutations, context) {
                    var _this = this;
                    _super.prototype.update.call(this, mutations, context);
                    if (mutations.some(function(mutation) {
                        return mutation.target === _this.domNode && mutation.type === "attributes";
                    })) this.attributes.build();
                };
                FormatBlot.prototype.wrap = function(name, value) {
                    var wrapper = _super.prototype.wrap.call(this, name, value);
                    if (wrapper instanceof FormatBlot && wrapper.statics.scope === this.statics.scope) this.attributes.move(wrapper);
                    return wrapper;
                };
                return FormatBlot;
            }(container_1.default);
            exports.default = FormatBlot;
        /***/ },
        /* 19 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var shadow_1 = __webpack_require__(30);
            var Registry = __webpack_require__(1);
            var LeafBlot = /** @class */ function(_super) {
                __extends(LeafBlot, _super);
                function LeafBlot() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                LeafBlot.value = function(domNode) {
                    return true;
                };
                LeafBlot.prototype.index = function(node, offset) {
                    if (this.domNode === node || this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) return Math.min(offset, 1);
                    return -1;
                };
                LeafBlot.prototype.position = function(index, inclusive) {
                    var offset = [].indexOf.call(this.parent.domNode.childNodes, this.domNode);
                    if (index > 0) offset += 1;
                    return [
                        this.parent.domNode,
                        offset
                    ];
                };
                LeafBlot.prototype.value = function() {
                    var _a;
                    return _a = {}, _a[this.statics.blotName] = this.statics.value(this.domNode) || true, _a;
                };
                LeafBlot.scope = Registry.Scope.INLINE_BLOT;
                return LeafBlot;
            }(shadow_1.default);
            exports.default = LeafBlot;
        /***/ },
        /* 20 */ /***/ function(module1, exports, __webpack_require__) {
            var equal = __webpack_require__(11);
            var extend = __webpack_require__(3);
            var lib = {
                attributes: {
                    compose: function(a, b, keepNull) {
                        if (typeof a !== "object") a = {};
                        if (typeof b !== "object") b = {};
                        var attributes = extend(true, {}, b);
                        if (!keepNull) attributes = Object.keys(attributes).reduce(function(copy, key) {
                            if (attributes[key] != null) copy[key] = attributes[key];
                            return copy;
                        }, {});
                        for(var key in a)if (a[key] !== undefined && b[key] === undefined) attributes[key] = a[key];
                        return Object.keys(attributes).length > 0 ? attributes : undefined;
                    },
                    diff: function(a, b) {
                        if (typeof a !== "object") a = {};
                        if (typeof b !== "object") b = {};
                        var attributes = Object.keys(a).concat(Object.keys(b)).reduce(function(attributes, key) {
                            if (!equal(a[key], b[key])) attributes[key] = b[key] === undefined ? null : b[key];
                            return attributes;
                        }, {});
                        return Object.keys(attributes).length > 0 ? attributes : undefined;
                    },
                    transform: function(a, b, priority) {
                        if (typeof a !== "object") return b;
                        if (typeof b !== "object") return undefined;
                        if (!priority) return b; // b simply overwrites us without priority
                        var attributes = Object.keys(b).reduce(function(attributes, key) {
                            if (a[key] === undefined) attributes[key] = b[key]; // null is a valid value
                            return attributes;
                        }, {});
                        return Object.keys(attributes).length > 0 ? attributes : undefined;
                    }
                },
                iterator: function(ops) {
                    return new Iterator(ops);
                },
                length: function(op) {
                    if (typeof op["delete"] === "number") return op["delete"];
                    else if (typeof op.retain === "number") return op.retain;
                    else return typeof op.insert === "string" ? op.insert.length : 1;
                }
            };
            function Iterator(ops) {
                this.ops = ops;
                this.index = 0;
                this.offset = 0;
            }
            Iterator.prototype.hasNext = function() {
                return this.peekLength() < Infinity;
            };
            Iterator.prototype.next = function(length) {
                if (!length) length = Infinity;
                var nextOp = this.ops[this.index];
                if (nextOp) {
                    var offset = this.offset;
                    var opLength = lib.length(nextOp);
                    if (length >= opLength - offset) {
                        length = opLength - offset;
                        this.index += 1;
                        this.offset = 0;
                    } else this.offset += length;
                    if (typeof nextOp["delete"] === "number") return {
                        "delete": length
                    };
                    else {
                        var retOp = {};
                        if (nextOp.attributes) retOp.attributes = nextOp.attributes;
                        if (typeof nextOp.retain === "number") retOp.retain = length;
                        else if (typeof nextOp.insert === "string") retOp.insert = nextOp.insert.substr(offset, length);
                        else // offset should === 0, length should === 1
                        retOp.insert = nextOp.insert;
                        return retOp;
                    }
                } else return {
                    retain: Infinity
                };
            };
            Iterator.prototype.peek = function() {
                return this.ops[this.index];
            };
            Iterator.prototype.peekLength = function() {
                if (this.ops[this.index]) // Should never return 0 if our index is being managed correctly
                return lib.length(this.ops[this.index]) - this.offset;
                else return Infinity;
            };
            Iterator.prototype.peekType = function() {
                if (this.ops[this.index]) {
                    if (typeof this.ops[this.index]["delete"] === "number") return "delete";
                    else if (typeof this.ops[this.index].retain === "number") return "retain";
                    else return "insert";
                }
                return "retain";
            };
            Iterator.prototype.rest = function() {
                if (!this.hasNext()) return [];
                else if (this.offset === 0) return this.ops.slice(this.index);
                else {
                    var offset = this.offset;
                    var index = this.index;
                    var next = this.next();
                    var rest = this.ops.slice(this.index);
                    this.offset = offset;
                    this.index = index;
                    return [
                        next
                    ].concat(rest);
                }
            };
            module1.exports = lib;
        /***/ },
        /* 21 */ /***/ function(module1, exports) {
            var clone = function() {
                "use strict";
                function _instanceof(obj, type) {
                    return type != null && obj instanceof type;
                }
                var nativeMap;
                try {
                    nativeMap = Map;
                } catch (_) {
                    // maybe a reference error because no `Map`. Give it a dummy value that no
                    // value will ever be an instanceof.
                    nativeMap = function() {};
                }
                var nativeSet;
                try {
                    nativeSet = Set;
                } catch (_) {
                    nativeSet = function() {};
                }
                var nativePromise;
                try {
                    nativePromise = Promise;
                } catch (_) {
                    nativePromise = function() {};
                }
                /**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
 *    should be cloned as well. Non-enumerable properties on the prototype
 *    chain will be ignored. (optional - false by default)
*/ function clone(parent, circular, depth, prototype, includeNonEnumerable) {
                    if (typeof circular === "object") {
                        depth = circular.depth;
                        prototype = circular.prototype;
                        includeNonEnumerable = circular.includeNonEnumerable;
                        circular = circular.circular;
                    }
                    // maintain two arrays for circular references, where corresponding parents
                    // and children have the same index
                    var allParents = [];
                    var allChildren = [];
                    var useBuffer = typeof $12b88c448c5fec35$require$Buffer != "undefined";
                    if (typeof circular == "undefined") circular = true;
                    if (typeof depth == "undefined") depth = Infinity;
                    // recurse this function so we don't reset allParents and allChildren
                    function _clone(parent, depth) {
                        // cloning null always returns null
                        if (parent === null) return null;
                        if (depth === 0) return parent;
                        var child;
                        var proto;
                        if (typeof parent != "object") return parent;
                        if (_instanceof(parent, nativeMap)) child = new nativeMap();
                        else if (_instanceof(parent, nativeSet)) child = new nativeSet();
                        else if (_instanceof(parent, nativePromise)) child = new nativePromise(function(resolve, reject) {
                            parent.then(function(value) {
                                resolve(_clone(value, depth - 1));
                            }, function(err) {
                                reject(_clone(err, depth - 1));
                            });
                        });
                        else if (clone.__isArray(parent)) child = [];
                        else if (clone.__isRegExp(parent)) {
                            child = new RegExp(parent.source, __getRegExpFlags(parent));
                            if (parent.lastIndex) child.lastIndex = parent.lastIndex;
                        } else if (clone.__isDate(parent)) child = new Date(parent.getTime());
                        else if (useBuffer && $12b88c448c5fec35$require$Buffer.isBuffer(parent)) {
                            if ($12b88c448c5fec35$require$Buffer.allocUnsafe) // Node.js >= 4.5.0
                            child = $12b88c448c5fec35$require$Buffer.allocUnsafe(parent.length);
                            else // Older Node.js versions
                            child = new $12b88c448c5fec35$require$Buffer(parent.length);
                            parent.copy(child);
                            return child;
                        } else if (_instanceof(parent, Error)) child = Object.create(parent);
                        else if (typeof prototype == "undefined") {
                            proto = Object.getPrototypeOf(parent);
                            child = Object.create(proto);
                        } else {
                            child = Object.create(prototype);
                            proto = prototype;
                        }
                        if (circular) {
                            var index = allParents.indexOf(parent);
                            if (index != -1) return allChildren[index];
                            allParents.push(parent);
                            allChildren.push(child);
                        }
                        if (_instanceof(parent, nativeMap)) parent.forEach(function(value, key) {
                            var keyChild = _clone(key, depth - 1);
                            var valueChild = _clone(value, depth - 1);
                            child.set(keyChild, valueChild);
                        });
                        if (_instanceof(parent, nativeSet)) parent.forEach(function(value) {
                            var entryChild = _clone(value, depth - 1);
                            child.add(entryChild);
                        });
                        for(var i in parent){
                            var attrs;
                            if (proto) attrs = Object.getOwnPropertyDescriptor(proto, i);
                            if (attrs && attrs.set == null) continue;
                            child[i] = _clone(parent[i], depth - 1);
                        }
                        if (Object.getOwnPropertySymbols) {
                            var symbols = Object.getOwnPropertySymbols(parent);
                            for(var i = 0; i < symbols.length; i++){
                                // Don't need to worry about cloning a symbol because it is a primitive,
                                // like a number or string.
                                var symbol = symbols[i];
                                var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
                                if (descriptor && !descriptor.enumerable && !includeNonEnumerable) continue;
                                child[symbol] = _clone(parent[symbol], depth - 1);
                                if (!descriptor.enumerable) Object.defineProperty(child, symbol, {
                                    enumerable: false
                                });
                            }
                        }
                        if (includeNonEnumerable) {
                            var allPropertyNames = Object.getOwnPropertyNames(parent);
                            for(var i = 0; i < allPropertyNames.length; i++){
                                var propertyName = allPropertyNames[i];
                                var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
                                if (descriptor && descriptor.enumerable) continue;
                                child[propertyName] = _clone(parent[propertyName], depth - 1);
                                Object.defineProperty(child, propertyName, {
                                    enumerable: false
                                });
                            }
                        }
                        return child;
                    }
                    return _clone(parent, depth);
                }
                /**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */ clone.clonePrototype = function clonePrototype(parent) {
                    if (parent === null) return null;
                    var c = function() {};
                    c.prototype = parent;
                    return new c();
                };
                // private utility functions
                function __objToStr(o) {
                    return Object.prototype.toString.call(o);
                }
                clone.__objToStr = __objToStr;
                function __isDate(o) {
                    return typeof o === "object" && __objToStr(o) === "[object Date]";
                }
                clone.__isDate = __isDate;
                function __isArray(o) {
                    return typeof o === "object" && __objToStr(o) === "[object Array]";
                }
                clone.__isArray = __isArray;
                function __isRegExp(o) {
                    return typeof o === "object" && __objToStr(o) === "[object RegExp]";
                }
                clone.__isRegExp = __isRegExp;
                function __getRegExpFlags(re) {
                    var flags = "";
                    if (re.global) flags += "g";
                    if (re.ignoreCase) flags += "i";
                    if (re.multiline) flags += "m";
                    return flags;
                }
                clone.__getRegExpFlags = __getRegExpFlags;
                return clone;
            }();
            if (typeof module1 === "object" && module1.exports) module1.exports = clone;
        /***/ },
        /* 22 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _emitter = __webpack_require__(8);
            var _emitter2 = _interopRequireDefault(_emitter);
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            var _break = __webpack_require__(16);
            var _break2 = _interopRequireDefault(_break);
            var _code = __webpack_require__(13);
            var _code2 = _interopRequireDefault(_code);
            var _container = __webpack_require__(25);
            var _container2 = _interopRequireDefault(_container);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            function isLine(blot) {
                return blot instanceof _block2.default || blot instanceof _block.BlockEmbed;
            }
            var Scroll = function(_Parchment$Scroll) {
                _inherits(Scroll, _Parchment$Scroll);
                function Scroll(domNode, config) {
                    _classCallCheck(this, Scroll);
                    var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, domNode));
                    _this.emitter = config.emitter;
                    if (Array.isArray(config.whitelist)) _this.whitelist = config.whitelist.reduce(function(whitelist, format) {
                        whitelist[format] = true;
                        return whitelist;
                    }, {});
                    // Some reason fixes composition issues with character languages in Windows/Chrome, Safari
                    _this.domNode.addEventListener("DOMNodeInserted", function() {});
                    _this.optimize();
                    _this.enable();
                    return _this;
                }
                _createClass(Scroll, [
                    {
                        key: "batchStart",
                        value: function batchStart() {
                            this.batch = true;
                        }
                    },
                    {
                        key: "batchEnd",
                        value: function batchEnd() {
                            this.batch = false;
                            this.optimize();
                        }
                    },
                    {
                        key: "deleteAt",
                        value: function deleteAt(index, length) {
                            var _line = this.line(index), _line2 = _slicedToArray(_line, 2), first = _line2[0], offset = _line2[1];
                            var _line3 = this.line(index + length), _line4 = _slicedToArray(_line3, 1), last = _line4[0];
                            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), "deleteAt", this).call(this, index, length);
                            if (last != null && first !== last && offset > 0) {
                                if (first instanceof _block.BlockEmbed || last instanceof _block.BlockEmbed) {
                                    this.optimize();
                                    return;
                                }
                                if (first instanceof _code2.default) {
                                    var newlineIndex = first.newlineIndex(first.length(), true);
                                    if (newlineIndex > -1) {
                                        first = first.split(newlineIndex + 1);
                                        if (first === last) {
                                            this.optimize();
                                            return;
                                        }
                                    }
                                } else if (last instanceof _code2.default) {
                                    var _newlineIndex = last.newlineIndex(0);
                                    if (_newlineIndex > -1) last.split(_newlineIndex + 1);
                                }
                                var ref = last.children.head instanceof _break2.default ? null : last.children.head;
                                first.moveChildren(last, ref);
                                first.remove();
                            }
                            this.optimize();
                        }
                    },
                    {
                        key: "enable",
                        value: function enable() {
                            var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                            this.domNode.setAttribute("contenteditable", enabled);
                        }
                    },
                    {
                        key: "formatAt",
                        value: function formatAt(index, length, format, value) {
                            if (this.whitelist != null && !this.whitelist[format]) return;
                            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), "formatAt", this).call(this, index, length, format, value);
                            this.optimize();
                        }
                    },
                    {
                        key: "insertAt",
                        value: function insertAt(index, value, def) {
                            if (def != null && this.whitelist != null && !this.whitelist[value]) return;
                            if (index >= this.length()) {
                                if (def == null || _parchment2.default.query(value, _parchment2.default.Scope.BLOCK) == null) {
                                    var blot = _parchment2.default.create(this.statics.defaultChild);
                                    this.appendChild(blot);
                                    if (def == null && value.endsWith("\n")) value = value.slice(0, -1);
                                    blot.insertAt(0, value, def);
                                } else {
                                    var embed = _parchment2.default.create(value, def);
                                    this.appendChild(embed);
                                }
                            } else _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), "insertAt", this).call(this, index, value, def);
                            this.optimize();
                        }
                    },
                    {
                        key: "insertBefore",
                        value: function insertBefore(blot, ref) {
                            if (blot.statics.scope === _parchment2.default.Scope.INLINE_BLOT) {
                                var wrapper = _parchment2.default.create(this.statics.defaultChild);
                                wrapper.appendChild(blot);
                                blot = wrapper;
                            }
                            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), "insertBefore", this).call(this, blot, ref);
                        }
                    },
                    {
                        key: "leaf",
                        value: function leaf(index) {
                            return this.path(index).pop() || [
                                null,
                                -1
                            ];
                        }
                    },
                    {
                        key: "line",
                        value: function line(index) {
                            if (index === this.length()) return this.line(index - 1);
                            return this.descendant(isLine, index);
                        }
                    },
                    {
                        key: "lines",
                        value: function lines() {
                            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
                            var getLines = function getLines(blot, index, length) {
                                var lines = [], lengthLeft = length;
                                blot.children.forEachAt(index, length, function(child, index, length) {
                                    if (isLine(child)) lines.push(child);
                                    else if (child instanceof _parchment2.default.Container) lines = lines.concat(getLines(child, index, lengthLeft));
                                    lengthLeft -= length;
                                });
                                return lines;
                            };
                            return getLines(this, index, length);
                        }
                    },
                    {
                        key: "optimize",
                        value: function optimize() {
                            var mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                            var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            if (this.batch === true) return;
                            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), "optimize", this).call(this, mutations, context);
                            if (mutations.length > 0) this.emitter.emit(_emitter2.default.events.SCROLL_OPTIMIZE, mutations, context);
                        }
                    },
                    {
                        key: "path",
                        value: function path(index) {
                            return _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), "path", this).call(this, index).slice(1); // Exclude self
                        }
                    },
                    {
                        key: "update",
                        value: function update(mutations) {
                            if (this.batch === true) return;
                            var source = _emitter2.default.sources.USER;
                            if (typeof mutations === "string") source = mutations;
                            if (!Array.isArray(mutations)) mutations = this.observer.takeRecords();
                            if (mutations.length > 0) this.emitter.emit(_emitter2.default.events.SCROLL_BEFORE_UPDATE, source, mutations);
                            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), "update", this).call(this, mutations.concat([])); // pass copy
                            if (mutations.length > 0) this.emitter.emit(_emitter2.default.events.SCROLL_UPDATE, source, mutations);
                        }
                    }
                ]);
                return Scroll;
            }(_parchment2.default.Scroll);
            Scroll.blotName = "scroll";
            Scroll.className = "ql-editor";
            Scroll.tagName = "DIV";
            Scroll.defaultChild = "block";
            Scroll.allowedChildren = [
                _block2.default,
                _block.BlockEmbed,
                _container2.default
            ];
            exports.default = Scroll;
        /***/ },
        /* 23 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.SHORTKEY = exports.default = undefined;
            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _clone = __webpack_require__(21);
            var _clone2 = _interopRequireDefault(_clone);
            var _deepEqual = __webpack_require__(11);
            var _deepEqual2 = _interopRequireDefault(_deepEqual);
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _op = __webpack_require__(20);
            var _op2 = _interopRequireDefault(_op);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _logger = __webpack_require__(10);
            var _logger2 = _interopRequireDefault(_logger);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var debug = (0, _logger2.default)("quill:keyboard");
            var SHORTKEY = /Mac/i.test(navigator.platform) ? "metaKey" : "ctrlKey";
            var Keyboard = function(_Module) {
                _inherits(Keyboard, _Module);
                _createClass(Keyboard, null, [
                    {
                        key: "match",
                        value: function match(evt, binding) {
                            binding = normalize(binding);
                            if ([
                                "altKey",
                                "ctrlKey",
                                "metaKey",
                                "shiftKey"
                            ].some(function(key) {
                                return !!binding[key] !== evt[key] && binding[key] !== null;
                            })) return false;
                            return binding.key === (evt.which || evt.keyCode);
                        }
                    }
                ]);
                function Keyboard(quill, options) {
                    _classCallCheck(this, Keyboard);
                    var _this = _possibleConstructorReturn(this, (Keyboard.__proto__ || Object.getPrototypeOf(Keyboard)).call(this, quill, options));
                    _this.bindings = {};
                    Object.keys(_this.options.bindings).forEach(function(name) {
                        if (name === "list autofill" && quill.scroll.whitelist != null && !quill.scroll.whitelist["list"]) return;
                        if (_this.options.bindings[name]) _this.addBinding(_this.options.bindings[name]);
                    });
                    _this.addBinding({
                        key: Keyboard.keys.ENTER,
                        shiftKey: null
                    }, handleEnter);
                    _this.addBinding({
                        key: Keyboard.keys.ENTER,
                        metaKey: null,
                        ctrlKey: null,
                        altKey: null
                    }, function() {});
                    if (/Firefox/i.test(navigator.userAgent)) {
                        // Need to handle delete and backspace for Firefox in the general case #1171
                        _this.addBinding({
                            key: Keyboard.keys.BACKSPACE
                        }, {
                            collapsed: true
                        }, handleBackspace);
                        _this.addBinding({
                            key: Keyboard.keys.DELETE
                        }, {
                            collapsed: true
                        }, handleDelete);
                    } else {
                        _this.addBinding({
                            key: Keyboard.keys.BACKSPACE
                        }, {
                            collapsed: true,
                            prefix: /^.?$/
                        }, handleBackspace);
                        _this.addBinding({
                            key: Keyboard.keys.DELETE
                        }, {
                            collapsed: true,
                            suffix: /^.?$/
                        }, handleDelete);
                    }
                    _this.addBinding({
                        key: Keyboard.keys.BACKSPACE
                    }, {
                        collapsed: false
                    }, handleDeleteRange);
                    _this.addBinding({
                        key: Keyboard.keys.DELETE
                    }, {
                        collapsed: false
                    }, handleDeleteRange);
                    _this.addBinding({
                        key: Keyboard.keys.BACKSPACE,
                        altKey: null,
                        ctrlKey: null,
                        metaKey: null,
                        shiftKey: null
                    }, {
                        collapsed: true,
                        offset: 0
                    }, handleBackspace);
                    _this.listen();
                    return _this;
                }
                _createClass(Keyboard, [
                    {
                        key: "addBinding",
                        value: function addBinding(key) {
                            var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            var handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                            var binding = normalize(key);
                            if (binding == null || binding.key == null) return debug.warn("Attempted to add invalid keyboard binding", binding);
                            if (typeof context === "function") context = {
                                handler: context
                            };
                            if (typeof handler === "function") handler = {
                                handler: handler
                            };
                            binding = (0, _extend2.default)(binding, context, handler);
                            this.bindings[binding.key] = this.bindings[binding.key] || [];
                            this.bindings[binding.key].push(binding);
                        }
                    },
                    {
                        key: "listen",
                        value: function listen() {
                            var _this2 = this;
                            this.quill.root.addEventListener("keydown", function(evt) {
                                if (evt.defaultPrevented) return;
                                var which = evt.which || evt.keyCode;
                                var bindings = (_this2.bindings[which] || []).filter(function(binding) {
                                    return Keyboard.match(evt, binding);
                                });
                                if (bindings.length === 0) return;
                                var range = _this2.quill.getSelection();
                                if (range == null || !_this2.quill.hasFocus()) return;
                                var _quill$getLine = _this2.quill.getLine(range.index), _quill$getLine2 = _slicedToArray(_quill$getLine, 2), line = _quill$getLine2[0], offset = _quill$getLine2[1];
                                var _quill$getLeaf = _this2.quill.getLeaf(range.index), _quill$getLeaf2 = _slicedToArray(_quill$getLeaf, 2), leafStart = _quill$getLeaf2[0], offsetStart = _quill$getLeaf2[1];
                                var _ref = range.length === 0 ? [
                                    leafStart,
                                    offsetStart
                                ] : _this2.quill.getLeaf(range.index + range.length), _ref2 = _slicedToArray(_ref, 2), leafEnd = _ref2[0], offsetEnd = _ref2[1];
                                var prefixText = leafStart instanceof _parchment2.default.Text ? leafStart.value().slice(0, offsetStart) : "";
                                var suffixText = leafEnd instanceof _parchment2.default.Text ? leafEnd.value().slice(offsetEnd) : "";
                                var curContext = {
                                    collapsed: range.length === 0,
                                    empty: range.length === 0 && line.length() <= 1,
                                    format: _this2.quill.getFormat(range),
                                    offset: offset,
                                    prefix: prefixText,
                                    suffix: suffixText
                                };
                                var prevented = bindings.some(function(binding) {
                                    if (binding.collapsed != null && binding.collapsed !== curContext.collapsed) return false;
                                    if (binding.empty != null && binding.empty !== curContext.empty) return false;
                                    if (binding.offset != null && binding.offset !== curContext.offset) return false;
                                    if (Array.isArray(binding.format)) {
                                        // any format is present
                                        if (binding.format.every(function(name) {
                                            return curContext.format[name] == null;
                                        })) return false;
                                    } else if (_typeof(binding.format) === "object") {
                                        // all formats must match
                                        if (!Object.keys(binding.format).every(function(name) {
                                            if (binding.format[name] === true) return curContext.format[name] != null;
                                            if (binding.format[name] === false) return curContext.format[name] == null;
                                            return (0, _deepEqual2.default)(binding.format[name], curContext.format[name]);
                                        })) return false;
                                    }
                                    if (binding.prefix != null && !binding.prefix.test(curContext.prefix)) return false;
                                    if (binding.suffix != null && !binding.suffix.test(curContext.suffix)) return false;
                                    return binding.handler.call(_this2, range, curContext) !== true;
                                });
                                if (prevented) evt.preventDefault();
                            });
                        }
                    }
                ]);
                return Keyboard;
            }(_module2.default);
            Keyboard.keys = {
                BACKSPACE: 8,
                TAB: 9,
                ENTER: 13,
                ESCAPE: 27,
                LEFT: 37,
                UP: 38,
                RIGHT: 39,
                DOWN: 40,
                DELETE: 46
            };
            Keyboard.DEFAULTS = {
                bindings: {
                    "bold": makeFormatHandler("bold"),
                    "italic": makeFormatHandler("italic"),
                    "underline": makeFormatHandler("underline"),
                    "indent": {
                        // highlight tab or tab at beginning of list, indent or blockquote
                        key: Keyboard.keys.TAB,
                        format: [
                            "blockquote",
                            "indent",
                            "list"
                        ],
                        handler: function handler(range, context) {
                            if (context.collapsed && context.offset !== 0) return true;
                            this.quill.format("indent", "+1", _quill2.default.sources.USER);
                        }
                    },
                    "outdent": {
                        key: Keyboard.keys.TAB,
                        shiftKey: true,
                        format: [
                            "blockquote",
                            "indent",
                            "list"
                        ],
                        // highlight tab or tab at beginning of list, indent or blockquote
                        handler: function handler(range, context) {
                            if (context.collapsed && context.offset !== 0) return true;
                            this.quill.format("indent", "-1", _quill2.default.sources.USER);
                        }
                    },
                    "outdent backspace": {
                        key: Keyboard.keys.BACKSPACE,
                        collapsed: true,
                        shiftKey: null,
                        metaKey: null,
                        ctrlKey: null,
                        altKey: null,
                        format: [
                            "indent",
                            "list"
                        ],
                        offset: 0,
                        handler: function handler(range, context) {
                            if (context.format.indent != null) this.quill.format("indent", "-1", _quill2.default.sources.USER);
                            else if (context.format.list != null) this.quill.format("list", false, _quill2.default.sources.USER);
                        }
                    },
                    "indent code-block": makeCodeBlockHandler(true),
                    "outdent code-block": makeCodeBlockHandler(false),
                    "remove tab": {
                        key: Keyboard.keys.TAB,
                        shiftKey: true,
                        collapsed: true,
                        prefix: /\t$/,
                        handler: function handler(range) {
                            this.quill.deleteText(range.index - 1, 1, _quill2.default.sources.USER);
                        }
                    },
                    "tab": {
                        key: Keyboard.keys.TAB,
                        handler: function handler(range) {
                            this.quill.history.cutoff();
                            var delta = new _quillDelta2.default().retain(range.index).delete(range.length).insert("	");
                            this.quill.updateContents(delta, _quill2.default.sources.USER);
                            this.quill.history.cutoff();
                            this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
                        }
                    },
                    "list empty enter": {
                        key: Keyboard.keys.ENTER,
                        collapsed: true,
                        format: [
                            "list"
                        ],
                        empty: true,
                        handler: function handler(range, context) {
                            this.quill.format("list", false, _quill2.default.sources.USER);
                            if (context.format.indent) this.quill.format("indent", false, _quill2.default.sources.USER);
                        }
                    },
                    "checklist enter": {
                        key: Keyboard.keys.ENTER,
                        collapsed: true,
                        format: {
                            list: "checked"
                        },
                        handler: function handler(range) {
                            var _quill$getLine3 = this.quill.getLine(range.index), _quill$getLine4 = _slicedToArray(_quill$getLine3, 2), line = _quill$getLine4[0], offset = _quill$getLine4[1];
                            var formats = (0, _extend2.default)({}, line.formats(), {
                                list: "checked"
                            });
                            var delta = new _quillDelta2.default().retain(range.index).insert("\n", formats).retain(line.length() - offset - 1).retain(1, {
                                list: "unchecked"
                            });
                            this.quill.updateContents(delta, _quill2.default.sources.USER);
                            this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
                            this.quill.scrollIntoView();
                        }
                    },
                    "header enter": {
                        key: Keyboard.keys.ENTER,
                        collapsed: true,
                        format: [
                            "header"
                        ],
                        suffix: /^$/,
                        handler: function handler(range, context) {
                            var _quill$getLine5 = this.quill.getLine(range.index), _quill$getLine6 = _slicedToArray(_quill$getLine5, 2), line = _quill$getLine6[0], offset = _quill$getLine6[1];
                            var delta = new _quillDelta2.default().retain(range.index).insert("\n", context.format).retain(line.length() - offset - 1).retain(1, {
                                header: null
                            });
                            this.quill.updateContents(delta, _quill2.default.sources.USER);
                            this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
                            this.quill.scrollIntoView();
                        }
                    },
                    "list autofill": {
                        key: " ",
                        collapsed: true,
                        format: {
                            list: false
                        },
                        prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
                        handler: function handler(range, context) {
                            var length = context.prefix.length;
                            var _quill$getLine7 = this.quill.getLine(range.index), _quill$getLine8 = _slicedToArray(_quill$getLine7, 2), line = _quill$getLine8[0], offset = _quill$getLine8[1];
                            if (offset > length) return true;
                            var value = void 0;
                            switch(context.prefix.trim()){
                                case "[]":
                                case "[ ]":
                                    value = "unchecked";
                                    break;
                                case "[x]":
                                    value = "checked";
                                    break;
                                case "-":
                                case "*":
                                    value = "bullet";
                                    break;
                                default:
                                    value = "ordered";
                            }
                            this.quill.insertText(range.index, " ", _quill2.default.sources.USER);
                            this.quill.history.cutoff();
                            var delta = new _quillDelta2.default().retain(range.index - offset).delete(length + 1).retain(line.length() - 2 - offset).retain(1, {
                                list: value
                            });
                            this.quill.updateContents(delta, _quill2.default.sources.USER);
                            this.quill.history.cutoff();
                            this.quill.setSelection(range.index - length, _quill2.default.sources.SILENT);
                        }
                    },
                    "code exit": {
                        key: Keyboard.keys.ENTER,
                        collapsed: true,
                        format: [
                            "code-block"
                        ],
                        prefix: /\n\n$/,
                        suffix: /^\s+$/,
                        handler: function handler(range) {
                            var _quill$getLine9 = this.quill.getLine(range.index), _quill$getLine10 = _slicedToArray(_quill$getLine9, 2), line = _quill$getLine10[0], offset = _quill$getLine10[1];
                            var delta = new _quillDelta2.default().retain(range.index + line.length() - offset - 2).retain(1, {
                                "code-block": null
                            }).delete(1);
                            this.quill.updateContents(delta, _quill2.default.sources.USER);
                        }
                    },
                    "embed left": makeEmbedArrowHandler(Keyboard.keys.LEFT, false),
                    "embed left shift": makeEmbedArrowHandler(Keyboard.keys.LEFT, true),
                    "embed right": makeEmbedArrowHandler(Keyboard.keys.RIGHT, false),
                    "embed right shift": makeEmbedArrowHandler(Keyboard.keys.RIGHT, true)
                }
            };
            function makeEmbedArrowHandler(key, shiftKey) {
                var _ref3;
                var where = key === Keyboard.keys.LEFT ? "prefix" : "suffix";
                return _ref3 = {
                    key: key,
                    shiftKey: shiftKey,
                    altKey: null
                }, _defineProperty(_ref3, where, /^$/), _defineProperty(_ref3, "handler", function handler(range) {
                    var index = range.index;
                    if (key === Keyboard.keys.RIGHT) index += range.length + 1;
                    var _quill$getLeaf3 = this.quill.getLeaf(index), _quill$getLeaf4 = _slicedToArray(_quill$getLeaf3, 1), leaf = _quill$getLeaf4[0];
                    if (!(leaf instanceof _parchment2.default.Embed)) return true;
                    if (key === Keyboard.keys.LEFT) {
                        if (shiftKey) this.quill.setSelection(range.index - 1, range.length + 1, _quill2.default.sources.USER);
                        else this.quill.setSelection(range.index - 1, _quill2.default.sources.USER);
                    } else if (shiftKey) this.quill.setSelection(range.index, range.length + 1, _quill2.default.sources.USER);
                    else this.quill.setSelection(range.index + range.length + 1, _quill2.default.sources.USER);
                    return false;
                }), _ref3;
            }
            function handleBackspace(range, context) {
                if (range.index === 0 || this.quill.getLength() <= 1) return;
                var _quill$getLine11 = this.quill.getLine(range.index), _quill$getLine12 = _slicedToArray(_quill$getLine11, 1), line = _quill$getLine12[0];
                var formats = {};
                if (context.offset === 0) {
                    var _quill$getLine13 = this.quill.getLine(range.index - 1), _quill$getLine14 = _slicedToArray(_quill$getLine13, 1), prev = _quill$getLine14[0];
                    if (prev != null && prev.length() > 1) {
                        var curFormats = line.formats();
                        var prevFormats = this.quill.getFormat(range.index - 1, 1);
                        formats = _op2.default.attributes.diff(curFormats, prevFormats) || {};
                    }
                }
                // Check for astral symbols
                var length = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(context.prefix) ? 2 : 1;
                this.quill.deleteText(range.index - length, length, _quill2.default.sources.USER);
                if (Object.keys(formats).length > 0) this.quill.formatLine(range.index - length, length, formats, _quill2.default.sources.USER);
                this.quill.focus();
            }
            function handleDelete(range, context) {
                // Check for astral symbols
                var length = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(context.suffix) ? 2 : 1;
                if (range.index >= this.quill.getLength() - length) return;
                var formats = {}, nextLength = 0;
                var _quill$getLine15 = this.quill.getLine(range.index), _quill$getLine16 = _slicedToArray(_quill$getLine15, 1), line = _quill$getLine16[0];
                if (context.offset >= line.length() - 1) {
                    var _quill$getLine17 = this.quill.getLine(range.index + 1), _quill$getLine18 = _slicedToArray(_quill$getLine17, 1), next = _quill$getLine18[0];
                    if (next) {
                        var curFormats = line.formats();
                        var nextFormats = this.quill.getFormat(range.index, 1);
                        formats = _op2.default.attributes.diff(curFormats, nextFormats) || {};
                        nextLength = next.length();
                    }
                }
                this.quill.deleteText(range.index, length, _quill2.default.sources.USER);
                if (Object.keys(formats).length > 0) this.quill.formatLine(range.index + nextLength - 1, length, formats, _quill2.default.sources.USER);
            }
            function handleDeleteRange(range) {
                var lines = this.quill.getLines(range);
                var formats = {};
                if (lines.length > 1) {
                    var firstFormats = lines[0].formats();
                    var lastFormats = lines[lines.length - 1].formats();
                    formats = _op2.default.attributes.diff(lastFormats, firstFormats) || {};
                }
                this.quill.deleteText(range, _quill2.default.sources.USER);
                if (Object.keys(formats).length > 0) this.quill.formatLine(range.index, 1, formats, _quill2.default.sources.USER);
                this.quill.setSelection(range.index, _quill2.default.sources.SILENT);
                this.quill.focus();
            }
            function handleEnter(range, context) {
                var _this3 = this;
                if (range.length > 0) this.quill.scroll.deleteAt(range.index, range.length); // So we do not trigger text-change
                var lineFormats = Object.keys(context.format).reduce(function(lineFormats, format) {
                    if (_parchment2.default.query(format, _parchment2.default.Scope.BLOCK) && !Array.isArray(context.format[format])) lineFormats[format] = context.format[format];
                    return lineFormats;
                }, {});
                this.quill.insertText(range.index, "\n", lineFormats, _quill2.default.sources.USER);
                // Earlier scroll.deleteAt might have messed up our selection,
                // so insertText's built in selection preservation is not reliable
                this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
                this.quill.focus();
                Object.keys(context.format).forEach(function(name) {
                    if (lineFormats[name] != null) return;
                    if (Array.isArray(context.format[name])) return;
                    if (name === "link") return;
                    _this3.quill.format(name, context.format[name], _quill2.default.sources.USER);
                });
            }
            function makeCodeBlockHandler(indent) {
                return {
                    key: Keyboard.keys.TAB,
                    shiftKey: !indent,
                    format: {
                        "code-block": true
                    },
                    handler: function handler(range) {
                        var CodeBlock = _parchment2.default.query("code-block");
                        var index = range.index, length = range.length;
                        var _quill$scroll$descend = this.quill.scroll.descendant(CodeBlock, index), _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2), block = _quill$scroll$descend2[0], offset = _quill$scroll$descend2[1];
                        if (block == null) return;
                        var scrollIndex = this.quill.getIndex(block);
                        var start = block.newlineIndex(offset, true) + 1;
                        var end = block.newlineIndex(scrollIndex + offset + length);
                        var lines = block.domNode.textContent.slice(start, end).split("\n");
                        offset = 0;
                        lines.forEach(function(line, i) {
                            if (indent) {
                                block.insertAt(start + offset, CodeBlock.TAB);
                                offset += CodeBlock.TAB.length;
                                if (i === 0) index += CodeBlock.TAB.length;
                                else length += CodeBlock.TAB.length;
                            } else if (line.startsWith(CodeBlock.TAB)) {
                                block.deleteAt(start + offset, CodeBlock.TAB.length);
                                offset -= CodeBlock.TAB.length;
                                if (i === 0) index -= CodeBlock.TAB.length;
                                else length -= CodeBlock.TAB.length;
                            }
                            offset += line.length + 1;
                        });
                        this.quill.update(_quill2.default.sources.USER);
                        this.quill.setSelection(index, length, _quill2.default.sources.SILENT);
                    }
                };
            }
            function makeFormatHandler(format) {
                return {
                    key: format[0].toUpperCase(),
                    shortKey: true,
                    handler: function handler(range, context) {
                        this.quill.format(format, !context.format[format], _quill2.default.sources.USER);
                    }
                };
            }
            function normalize(binding) {
                if (typeof binding === "string" || typeof binding === "number") return normalize({
                    key: binding
                });
                if ((typeof binding === "undefined" ? "undefined" : _typeof(binding)) === "object") binding = (0, _clone2.default)(binding, false);
                if (typeof binding.key === "string") {
                    if (Keyboard.keys[binding.key.toUpperCase()] != null) binding.key = Keyboard.keys[binding.key.toUpperCase()];
                    else if (binding.key.length === 1) binding.key = binding.key.toUpperCase().charCodeAt(0);
                    else return null;
                }
                if (binding.shortKey) {
                    binding[SHORTKEY] = binding.shortKey;
                    delete binding.shortKey;
                }
                return binding;
            }
            exports.default = Keyboard;
            exports.SHORTKEY = SHORTKEY;
        /***/ },
        /* 24 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _text = __webpack_require__(7);
            var _text2 = _interopRequireDefault(_text);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Cursor = function(_Parchment$Embed) {
                _inherits(Cursor, _Parchment$Embed);
                _createClass(Cursor, null, [
                    {
                        key: "value",
                        value: function value() {
                            return undefined;
                        }
                    }
                ]);
                function Cursor(domNode, selection) {
                    _classCallCheck(this, Cursor);
                    var _this = _possibleConstructorReturn(this, (Cursor.__proto__ || Object.getPrototypeOf(Cursor)).call(this, domNode));
                    _this.selection = selection;
                    _this.textNode = document.createTextNode(Cursor.CONTENTS);
                    _this.domNode.appendChild(_this.textNode);
                    _this._length = 0;
                    return _this;
                }
                _createClass(Cursor, [
                    {
                        key: "detach",
                        value: function detach() {
                            // super.detach() will also clear domNode.__blot
                            if (this.parent != null) this.parent.removeChild(this);
                        }
                    },
                    {
                        key: "format",
                        value: function format(name, value) {
                            if (this._length !== 0) return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), "format", this).call(this, name, value);
                            var target = this, index = 0;
                            while(target != null && target.statics.scope !== _parchment2.default.Scope.BLOCK_BLOT){
                                index += target.offset(target.parent);
                                target = target.parent;
                            }
                            if (target != null) {
                                this._length = Cursor.CONTENTS.length;
                                target.optimize();
                                target.formatAt(index, Cursor.CONTENTS.length, name, value);
                                this._length = 0;
                            }
                        }
                    },
                    {
                        key: "index",
                        value: function index(node, offset) {
                            if (node === this.textNode) return 0;
                            return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), "index", this).call(this, node, offset);
                        }
                    },
                    {
                        key: "length",
                        value: function length() {
                            return this._length;
                        }
                    },
                    {
                        key: "position",
                        value: function position() {
                            return [
                                this.textNode,
                                this.textNode.data.length
                            ];
                        }
                    },
                    {
                        key: "remove",
                        value: function remove() {
                            _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), "remove", this).call(this);
                            this.parent = null;
                        }
                    },
                    {
                        key: "restore",
                        value: function restore() {
                            if (this.selection.composing || this.parent == null) return;
                            var textNode = this.textNode;
                            var range = this.selection.getNativeRange();
                            var restoreText = void 0, start = void 0, end = void 0;
                            if (range != null && range.start.node === textNode && range.end.node === textNode) {
                                var _ref = [
                                    textNode,
                                    range.start.offset,
                                    range.end.offset
                                ];
                                restoreText = _ref[0];
                                start = _ref[1];
                                end = _ref[2];
                            }
                            // Link format will insert text outside of anchor tag
                            while(this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode)this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
                            if (this.textNode.data !== Cursor.CONTENTS) {
                                var text = this.textNode.data.split(Cursor.CONTENTS).join("");
                                if (this.next instanceof _text2.default) {
                                    restoreText = this.next.domNode;
                                    this.next.insertAt(0, text);
                                    this.textNode.data = Cursor.CONTENTS;
                                } else {
                                    this.textNode.data = text;
                                    this.parent.insertBefore(_parchment2.default.create(this.textNode), this);
                                    this.textNode = document.createTextNode(Cursor.CONTENTS);
                                    this.domNode.appendChild(this.textNode);
                                }
                            }
                            this.remove();
                            if (start != null) {
                                var _map = [
                                    start,
                                    end
                                ].map(function(offset) {
                                    return Math.max(0, Math.min(restoreText.data.length, offset - 1));
                                });
                                var _map2 = _slicedToArray(_map, 2);
                                start = _map2[0];
                                end = _map2[1];
                                return {
                                    startNode: restoreText,
                                    startOffset: start,
                                    endNode: restoreText,
                                    endOffset: end
                                };
                            }
                        }
                    },
                    {
                        key: "update",
                        value: function update(mutations, context) {
                            var _this2 = this;
                            if (mutations.some(function(mutation) {
                                return mutation.type === "characterData" && mutation.target === _this2.textNode;
                            })) {
                                var range = this.restore();
                                if (range) context.range = range;
                            }
                        }
                    },
                    {
                        key: "value",
                        value: function value() {
                            return "";
                        }
                    }
                ]);
                return Cursor;
            }(_parchment2.default.Embed);
            Cursor.blotName = "cursor";
            Cursor.className = "ql-cursor";
            Cursor.tagName = "span";
            Cursor.CONTENTS = "\uFEFF"; // Zero width no break space
            exports.default = Cursor;
        /***/ },
        /* 25 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Container = function(_Parchment$Container) {
                _inherits(Container, _Parchment$Container);
                function Container() {
                    _classCallCheck(this, Container);
                    return _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
                }
                return Container;
            }(_parchment2.default.Container);
            Container.allowedChildren = [
                _block2.default,
                _block.BlockEmbed,
                Container
            ];
            exports.default = Container;
        /***/ },
        /* 26 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.ColorStyle = exports.ColorClass = exports.ColorAttributor = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var ColorAttributor = function(_Parchment$Attributor) {
                _inherits(ColorAttributor, _Parchment$Attributor);
                function ColorAttributor() {
                    _classCallCheck(this, ColorAttributor);
                    return _possibleConstructorReturn(this, (ColorAttributor.__proto__ || Object.getPrototypeOf(ColorAttributor)).apply(this, arguments));
                }
                _createClass(ColorAttributor, [
                    {
                        key: "value",
                        value: function value(domNode) {
                            var value = _get(ColorAttributor.prototype.__proto__ || Object.getPrototypeOf(ColorAttributor.prototype), "value", this).call(this, domNode);
                            if (!value.startsWith("rgb(")) return value;
                            value = value.replace(/^[^\d]+/, "").replace(/[^\d]+$/, "");
                            return "#" + value.split(",").map(function(component) {
                                return ("00" + parseInt(component).toString(16)).slice(-2);
                            }).join("");
                        }
                    }
                ]);
                return ColorAttributor;
            }(_parchment2.default.Attributor.Style);
            var ColorClass = new _parchment2.default.Attributor.Class("color", "ql-color", {
                scope: _parchment2.default.Scope.INLINE
            });
            var ColorStyle = new ColorAttributor("color", "color", {
                scope: _parchment2.default.Scope.INLINE
            });
            exports.ColorAttributor = ColorAttributor;
            exports.ColorClass = ColorClass;
            exports.ColorStyle = ColorStyle;
        /***/ },
        /* 27 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.sanitize = exports.default = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Link = function(_Inline) {
                _inherits(Link, _Inline);
                function Link() {
                    _classCallCheck(this, Link);
                    return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).apply(this, arguments));
                }
                _createClass(Link, [
                    {
                        key: "format",
                        value: function format(name, value) {
                            if (name !== this.statics.blotName || !value) return _get(Link.prototype.__proto__ || Object.getPrototypeOf(Link.prototype), "format", this).call(this, name, value);
                            value = this.constructor.sanitize(value);
                            this.domNode.setAttribute("href", value);
                        }
                    }
                ], [
                    {
                        key: "create",
                        value: function create(value) {
                            var node = _get(Link.__proto__ || Object.getPrototypeOf(Link), "create", this).call(this, value);
                            value = this.sanitize(value);
                            node.setAttribute("href", value);
                            node.setAttribute("rel", "noopener noreferrer");
                            node.setAttribute("target", "_blank");
                            return node;
                        }
                    },
                    {
                        key: "formats",
                        value: function formats(domNode) {
                            return domNode.getAttribute("href");
                        }
                    },
                    {
                        key: "sanitize",
                        value: function sanitize(url) {
                            return _sanitize(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
                        }
                    }
                ]);
                return Link;
            }(_inline2.default);
            Link.blotName = "link";
            Link.tagName = "A";
            Link.SANITIZED_URL = "about:blank";
            Link.PROTOCOL_WHITELIST = [
                "http",
                "https",
                "mailto",
                "tel"
            ];
            function _sanitize(url, protocols) {
                var anchor = document.createElement("a");
                anchor.href = url;
                var protocol = anchor.href.slice(0, anchor.href.indexOf(":"));
                return protocols.indexOf(protocol) > -1;
            }
            exports.default = Link;
            exports.sanitize = _sanitize;
        /***/ },
        /* 28 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _keyboard = __webpack_require__(23);
            var _keyboard2 = _interopRequireDefault(_keyboard);
            var _dropdown = __webpack_require__(107);
            var _dropdown2 = _interopRequireDefault(_dropdown);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var optionsCounter = 0;
            function toggleAriaAttribute(element, attribute) {
                element.setAttribute(attribute, !(element.getAttribute(attribute) === "true"));
            }
            var Picker = function() {
                function Picker(select) {
                    var _this = this;
                    _classCallCheck(this, Picker);
                    this.select = select;
                    this.container = document.createElement("span");
                    this.buildPicker();
                    this.select.style.display = "none";
                    this.select.parentNode.insertBefore(this.container, this.select);
                    this.label.addEventListener("mousedown", function() {
                        _this.togglePicker();
                    });
                    this.label.addEventListener("keydown", function(event) {
                        switch(event.keyCode){
                            // Allows the "Enter" key to open the picker
                            case _keyboard2.default.keys.ENTER:
                                _this.togglePicker();
                                break;
                            // Allows the "Escape" key to close the picker
                            case _keyboard2.default.keys.ESCAPE:
                                _this.escape();
                                event.preventDefault();
                                break;
                            default:
                        }
                    });
                    this.select.addEventListener("change", this.update.bind(this));
                }
                _createClass(Picker, [
                    {
                        key: "togglePicker",
                        value: function togglePicker() {
                            this.container.classList.toggle("ql-expanded");
                            // Toggle aria-expanded and aria-hidden to make the picker accessible
                            toggleAriaAttribute(this.label, "aria-expanded");
                            toggleAriaAttribute(this.options, "aria-hidden");
                        }
                    },
                    {
                        key: "buildItem",
                        value: function buildItem(option) {
                            var _this2 = this;
                            var item = document.createElement("span");
                            item.tabIndex = "0";
                            item.setAttribute("role", "button");
                            item.classList.add("ql-picker-item");
                            if (option.hasAttribute("value")) item.setAttribute("data-value", option.getAttribute("value"));
                            if (option.textContent) item.setAttribute("data-label", option.textContent);
                            item.addEventListener("click", function() {
                                _this2.selectItem(item, true);
                            });
                            item.addEventListener("keydown", function(event) {
                                switch(event.keyCode){
                                    // Allows the "Enter" key to select an item
                                    case _keyboard2.default.keys.ENTER:
                                        _this2.selectItem(item, true);
                                        event.preventDefault();
                                        break;
                                    // Allows the "Escape" key to close the picker
                                    case _keyboard2.default.keys.ESCAPE:
                                        _this2.escape();
                                        event.preventDefault();
                                        break;
                                    default:
                                }
                            });
                            return item;
                        }
                    },
                    {
                        key: "buildLabel",
                        value: function buildLabel() {
                            var label = document.createElement("span");
                            label.classList.add("ql-picker-label");
                            label.innerHTML = _dropdown2.default;
                            label.tabIndex = "0";
                            label.setAttribute("role", "button");
                            label.setAttribute("aria-expanded", "false");
                            this.container.appendChild(label);
                            return label;
                        }
                    },
                    {
                        key: "buildOptions",
                        value: function buildOptions() {
                            var _this3 = this;
                            var options = document.createElement("span");
                            options.classList.add("ql-picker-options");
                            // Don't want screen readers to read this until options are visible
                            options.setAttribute("aria-hidden", "true");
                            options.tabIndex = "-1";
                            // Need a unique id for aria-controls
                            options.id = "ql-picker-options-" + optionsCounter;
                            optionsCounter += 1;
                            this.label.setAttribute("aria-controls", options.id);
                            this.options = options;
                            [].slice.call(this.select.options).forEach(function(option) {
                                var item = _this3.buildItem(option);
                                options.appendChild(item);
                                if (option.selected === true) _this3.selectItem(item);
                            });
                            this.container.appendChild(options);
                        }
                    },
                    {
                        key: "buildPicker",
                        value: function buildPicker() {
                            var _this4 = this;
                            [].slice.call(this.select.attributes).forEach(function(item) {
                                _this4.container.setAttribute(item.name, item.value);
                            });
                            this.container.classList.add("ql-picker");
                            this.label = this.buildLabel();
                            this.buildOptions();
                        }
                    },
                    {
                        key: "escape",
                        value: function escape() {
                            var _this5 = this;
                            // Close menu and return focus to trigger label
                            this.close();
                            // Need setTimeout for accessibility to ensure that the browser executes
                            // focus on the next process thread and after any DOM content changes
                            setTimeout(function() {
                                return _this5.label.focus();
                            }, 1);
                        }
                    },
                    {
                        key: "close",
                        value: function close() {
                            this.container.classList.remove("ql-expanded");
                            this.label.setAttribute("aria-expanded", "false");
                            this.options.setAttribute("aria-hidden", "true");
                        }
                    },
                    {
                        key: "selectItem",
                        value: function selectItem(item) {
                            var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                            var selected = this.container.querySelector(".ql-selected");
                            if (item === selected) return;
                            if (selected != null) selected.classList.remove("ql-selected");
                            if (item == null) return;
                            item.classList.add("ql-selected");
                            this.select.selectedIndex = [].indexOf.call(item.parentNode.children, item);
                            if (item.hasAttribute("data-value")) this.label.setAttribute("data-value", item.getAttribute("data-value"));
                            else this.label.removeAttribute("data-value");
                            if (item.hasAttribute("data-label")) this.label.setAttribute("data-label", item.getAttribute("data-label"));
                            else this.label.removeAttribute("data-label");
                            if (trigger) {
                                if (typeof Event === "function") this.select.dispatchEvent(new Event("change"));
                                else if ((typeof Event === "undefined" ? "undefined" : _typeof(Event)) === "object") {
                                    // IE11
                                    var event = document.createEvent("Event");
                                    event.initEvent("change", true, true);
                                    this.select.dispatchEvent(event);
                                }
                                this.close();
                            }
                        }
                    },
                    {
                        key: "update",
                        value: function update() {
                            var option = void 0;
                            if (this.select.selectedIndex > -1) {
                                var item = this.container.querySelector(".ql-picker-options").children[this.select.selectedIndex];
                                option = this.select.options[this.select.selectedIndex];
                                this.selectItem(item);
                            } else this.selectItem(null);
                            var isActive = option != null && option !== this.select.querySelector("option[selected]");
                            this.label.classList.toggle("ql-active", isActive);
                        }
                    }
                ]);
                return Picker;
            }();
            exports.default = Picker;
        /***/ },
        /* 29 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            var _break = __webpack_require__(16);
            var _break2 = _interopRequireDefault(_break);
            var _container = __webpack_require__(25);
            var _container2 = _interopRequireDefault(_container);
            var _cursor = __webpack_require__(24);
            var _cursor2 = _interopRequireDefault(_cursor);
            var _embed = __webpack_require__(35);
            var _embed2 = _interopRequireDefault(_embed);
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            var _scroll = __webpack_require__(22);
            var _scroll2 = _interopRequireDefault(_scroll);
            var _text = __webpack_require__(7);
            var _text2 = _interopRequireDefault(_text);
            var _clipboard = __webpack_require__(55);
            var _clipboard2 = _interopRequireDefault(_clipboard);
            var _history = __webpack_require__(42);
            var _history2 = _interopRequireDefault(_history);
            var _keyboard = __webpack_require__(23);
            var _keyboard2 = _interopRequireDefault(_keyboard);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            _quill2.default.register({
                "blots/block": _block2.default,
                "blots/block/embed": _block.BlockEmbed,
                "blots/break": _break2.default,
                "blots/container": _container2.default,
                "blots/cursor": _cursor2.default,
                "blots/embed": _embed2.default,
                "blots/inline": _inline2.default,
                "blots/scroll": _scroll2.default,
                "blots/text": _text2.default,
                "modules/clipboard": _clipboard2.default,
                "modules/history": _history2.default,
                "modules/keyboard": _keyboard2.default
            });
            _parchment2.default.register(_block2.default, _break2.default, _cursor2.default, _inline2.default, _scroll2.default, _text2.default);
            exports.default = _quill2.default;
        /***/ },
        /* 30 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var Registry = __webpack_require__(1);
            var ShadowBlot = /** @class */ function() {
                function ShadowBlot(domNode) {
                    this.domNode = domNode;
                    // @ts-ignore
                    this.domNode[Registry.DATA_KEY] = {
                        blot: this
                    };
                }
                Object.defineProperty(ShadowBlot.prototype, "statics", {
                    // Hack for accessing inherited static methods
                    get: function() {
                        return this.constructor;
                    },
                    enumerable: true,
                    configurable: true
                });
                ShadowBlot.create = function(value) {
                    if (this.tagName == null) throw new Registry.ParchmentError("Blot definition missing tagName");
                    var node;
                    if (Array.isArray(this.tagName)) {
                        if (typeof value === "string") {
                            value = value.toUpperCase();
                            if (parseInt(value).toString() === value) value = parseInt(value);
                        }
                        if (typeof value === "number") node = document.createElement(this.tagName[value - 1]);
                        else if (this.tagName.indexOf(value) > -1) node = document.createElement(value);
                        else node = document.createElement(this.tagName[0]);
                    } else node = document.createElement(this.tagName);
                    if (this.className) node.classList.add(this.className);
                    return node;
                };
                ShadowBlot.prototype.attach = function() {
                    if (this.parent != null) this.scroll = this.parent.scroll;
                };
                ShadowBlot.prototype.clone = function() {
                    var domNode = this.domNode.cloneNode(false);
                    return Registry.create(domNode);
                };
                ShadowBlot.prototype.detach = function() {
                    if (this.parent != null) this.parent.removeChild(this);
                    // @ts-ignore
                    delete this.domNode[Registry.DATA_KEY];
                };
                ShadowBlot.prototype.deleteAt = function(index, length) {
                    var blot = this.isolate(index, length);
                    blot.remove();
                };
                ShadowBlot.prototype.formatAt = function(index, length, name, value) {
                    var blot = this.isolate(index, length);
                    if (Registry.query(name, Registry.Scope.BLOT) != null && value) blot.wrap(name, value);
                    else if (Registry.query(name, Registry.Scope.ATTRIBUTE) != null) {
                        var parent = Registry.create(this.statics.scope);
                        blot.wrap(parent);
                        parent.format(name, value);
                    }
                };
                ShadowBlot.prototype.insertAt = function(index, value, def) {
                    var blot = def == null ? Registry.create("text", value) : Registry.create(value, def);
                    var ref = this.split(index);
                    this.parent.insertBefore(blot, ref);
                };
                ShadowBlot.prototype.insertInto = function(parentBlot, refBlot) {
                    if (refBlot === void 0) refBlot = null;
                    if (this.parent != null) this.parent.children.remove(this);
                    var refDomNode = null;
                    parentBlot.children.insertBefore(this, refBlot);
                    if (refBlot != null) refDomNode = refBlot.domNode;
                    if (this.domNode.parentNode != parentBlot.domNode || this.domNode.nextSibling != refDomNode) parentBlot.domNode.insertBefore(this.domNode, refDomNode);
                    this.parent = parentBlot;
                    this.attach();
                };
                ShadowBlot.prototype.isolate = function(index, length) {
                    var target = this.split(index);
                    target.split(length);
                    return target;
                };
                ShadowBlot.prototype.length = function() {
                    return 1;
                };
                ShadowBlot.prototype.offset = function(root) {
                    if (root === void 0) root = this.parent;
                    if (this.parent == null || this == root) return 0;
                    return this.parent.children.offset(this) + this.parent.offset(root);
                };
                ShadowBlot.prototype.optimize = function(context) {
                    // TODO clean up once we use WeakMap
                    // @ts-ignore
                    if (this.domNode[Registry.DATA_KEY] != null) // @ts-ignore
                    delete this.domNode[Registry.DATA_KEY].mutations;
                };
                ShadowBlot.prototype.remove = function() {
                    if (this.domNode.parentNode != null) this.domNode.parentNode.removeChild(this.domNode);
                    this.detach();
                };
                ShadowBlot.prototype.replace = function(target) {
                    if (target.parent == null) return;
                    target.parent.insertBefore(this, target.next);
                    target.remove();
                };
                ShadowBlot.prototype.replaceWith = function(name, value) {
                    var replacement = typeof name === "string" ? Registry.create(name, value) : name;
                    replacement.replace(this);
                    return replacement;
                };
                ShadowBlot.prototype.split = function(index, force) {
                    return index === 0 ? this : this.next;
                };
                ShadowBlot.prototype.update = function(mutations, context) {
                // Nothing to do by default
                };
                ShadowBlot.prototype.wrap = function(name, value) {
                    var wrapper = typeof name === "string" ? Registry.create(name, value) : name;
                    if (this.parent != null) this.parent.insertBefore(wrapper, this.next);
                    wrapper.appendChild(this);
                    return wrapper;
                };
                ShadowBlot.blotName = "abstract";
                return ShadowBlot;
            }();
            exports.default = ShadowBlot;
        /***/ },
        /* 31 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var attributor_1 = __webpack_require__(12);
            var class_1 = __webpack_require__(32);
            var style_1 = __webpack_require__(33);
            var Registry = __webpack_require__(1);
            var AttributorStore = /** @class */ function() {
                function AttributorStore(domNode) {
                    this.attributes = {};
                    this.domNode = domNode;
                    this.build();
                }
                AttributorStore.prototype.attribute = function(attribute, value) {
                    // verb
                    if (value) {
                        if (attribute.add(this.domNode, value)) {
                            if (attribute.value(this.domNode) != null) this.attributes[attribute.attrName] = attribute;
                            else delete this.attributes[attribute.attrName];
                        }
                    } else {
                        attribute.remove(this.domNode);
                        delete this.attributes[attribute.attrName];
                    }
                };
                AttributorStore.prototype.build = function() {
                    var _this = this;
                    this.attributes = {};
                    var attributes = attributor_1.default.keys(this.domNode);
                    var classes = class_1.default.keys(this.domNode);
                    var styles = style_1.default.keys(this.domNode);
                    attributes.concat(classes).concat(styles).forEach(function(name) {
                        var attr = Registry.query(name, Registry.Scope.ATTRIBUTE);
                        if (attr instanceof attributor_1.default) _this.attributes[attr.attrName] = attr;
                    });
                };
                AttributorStore.prototype.copy = function(target) {
                    var _this = this;
                    Object.keys(this.attributes).forEach(function(key) {
                        var value = _this.attributes[key].value(_this.domNode);
                        target.format(key, value);
                    });
                };
                AttributorStore.prototype.move = function(target) {
                    var _this = this;
                    this.copy(target);
                    Object.keys(this.attributes).forEach(function(key) {
                        _this.attributes[key].remove(_this.domNode);
                    });
                    this.attributes = {};
                };
                AttributorStore.prototype.values = function() {
                    var _this = this;
                    return Object.keys(this.attributes).reduce(function(attributes, name) {
                        attributes[name] = _this.attributes[name].value(_this.domNode);
                        return attributes;
                    }, {});
                };
                return AttributorStore;
            }();
            exports.default = AttributorStore;
        /***/ },
        /* 32 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var attributor_1 = __webpack_require__(12);
            function match(node, prefix) {
                var className = node.getAttribute("class") || "";
                return className.split(/\s+/).filter(function(name) {
                    return name.indexOf(prefix + "-") === 0;
                });
            }
            var ClassAttributor = /** @class */ function(_super) {
                __extends(ClassAttributor, _super);
                function ClassAttributor() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                ClassAttributor.keys = function(node) {
                    return (node.getAttribute("class") || "").split(/\s+/).map(function(name) {
                        return name.split("-").slice(0, -1).join("-");
                    });
                };
                ClassAttributor.prototype.add = function(node, value) {
                    if (!this.canAdd(node, value)) return false;
                    this.remove(node);
                    node.classList.add(this.keyName + "-" + value);
                    return true;
                };
                ClassAttributor.prototype.remove = function(node) {
                    var matches = match(node, this.keyName);
                    matches.forEach(function(name) {
                        node.classList.remove(name);
                    });
                    if (node.classList.length === 0) node.removeAttribute("class");
                };
                ClassAttributor.prototype.value = function(node) {
                    var result = match(node, this.keyName)[0] || "";
                    var value = result.slice(this.keyName.length + 1); // +1 for hyphen
                    return this.canAdd(node, value) ? value : "";
                };
                return ClassAttributor;
            }(attributor_1.default);
            exports.default = ClassAttributor;
        /***/ },
        /* 33 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var attributor_1 = __webpack_require__(12);
            function camelize(name) {
                var parts = name.split("-");
                var rest = parts.slice(1).map(function(part) {
                    return part[0].toUpperCase() + part.slice(1);
                }).join("");
                return parts[0] + rest;
            }
            var StyleAttributor = /** @class */ function(_super) {
                __extends(StyleAttributor, _super);
                function StyleAttributor() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                StyleAttributor.keys = function(node) {
                    return (node.getAttribute("style") || "").split(";").map(function(value) {
                        var arr = value.split(":");
                        return arr[0].trim();
                    });
                };
                StyleAttributor.prototype.add = function(node, value) {
                    if (!this.canAdd(node, value)) return false;
                    // @ts-ignore
                    node.style[camelize(this.keyName)] = value;
                    return true;
                };
                StyleAttributor.prototype.remove = function(node) {
                    // @ts-ignore
                    node.style[camelize(this.keyName)] = "";
                    if (!node.getAttribute("style")) node.removeAttribute("style");
                };
                StyleAttributor.prototype.value = function(node) {
                    // @ts-ignore
                    var value = node.style[camelize(this.keyName)];
                    return this.canAdd(node, value) ? value : "";
                };
                return StyleAttributor;
            }(attributor_1.default);
            exports.default = StyleAttributor;
        /***/ },
        /* 34 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var Theme = function() {
                function Theme(quill, options) {
                    _classCallCheck(this, Theme);
                    this.quill = quill;
                    this.options = options;
                    this.modules = {};
                }
                _createClass(Theme, [
                    {
                        key: "init",
                        value: function init() {
                            var _this = this;
                            Object.keys(this.options.modules).forEach(function(name) {
                                if (_this.modules[name] == null) _this.addModule(name);
                            });
                        }
                    },
                    {
                        key: "addModule",
                        value: function addModule(name) {
                            var moduleClass = this.quill.constructor.import("modules/" + name);
                            this.modules[name] = new moduleClass(this.quill, this.options.modules[name] || {});
                            return this.modules[name];
                        }
                    }
                ]);
                return Theme;
            }();
            Theme.DEFAULTS = {
                modules: {}
            };
            Theme.themes = {
                "default": Theme
            };
            exports.default = Theme;
        /***/ },
        /* 35 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _text = __webpack_require__(7);
            var _text2 = _interopRequireDefault(_text);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var GUARD_TEXT = "\uFEFF";
            var Embed = function(_Parchment$Embed) {
                _inherits(Embed, _Parchment$Embed);
                function Embed(node) {
                    _classCallCheck(this, Embed);
                    var _this = _possibleConstructorReturn(this, (Embed.__proto__ || Object.getPrototypeOf(Embed)).call(this, node));
                    _this.contentNode = document.createElement("span");
                    _this.contentNode.setAttribute("contenteditable", false);
                    [].slice.call(_this.domNode.childNodes).forEach(function(childNode) {
                        _this.contentNode.appendChild(childNode);
                    });
                    _this.leftGuard = document.createTextNode(GUARD_TEXT);
                    _this.rightGuard = document.createTextNode(GUARD_TEXT);
                    _this.domNode.appendChild(_this.leftGuard);
                    _this.domNode.appendChild(_this.contentNode);
                    _this.domNode.appendChild(_this.rightGuard);
                    return _this;
                }
                _createClass(Embed, [
                    {
                        key: "index",
                        value: function index(node, offset) {
                            if (node === this.leftGuard) return 0;
                            if (node === this.rightGuard) return 1;
                            return _get(Embed.prototype.__proto__ || Object.getPrototypeOf(Embed.prototype), "index", this).call(this, node, offset);
                        }
                    },
                    {
                        key: "restore",
                        value: function restore(node) {
                            var range = void 0, textNode = void 0;
                            var text = node.data.split(GUARD_TEXT).join("");
                            if (node === this.leftGuard) {
                                if (this.prev instanceof _text2.default) {
                                    var prevLength = this.prev.length();
                                    this.prev.insertAt(prevLength, text);
                                    range = {
                                        startNode: this.prev.domNode,
                                        startOffset: prevLength + text.length
                                    };
                                } else {
                                    textNode = document.createTextNode(text);
                                    this.parent.insertBefore(_parchment2.default.create(textNode), this);
                                    range = {
                                        startNode: textNode,
                                        startOffset: text.length
                                    };
                                }
                            } else if (node === this.rightGuard) {
                                if (this.next instanceof _text2.default) {
                                    this.next.insertAt(0, text);
                                    range = {
                                        startNode: this.next.domNode,
                                        startOffset: text.length
                                    };
                                } else {
                                    textNode = document.createTextNode(text);
                                    this.parent.insertBefore(_parchment2.default.create(textNode), this.next);
                                    range = {
                                        startNode: textNode,
                                        startOffset: text.length
                                    };
                                }
                            }
                            node.data = GUARD_TEXT;
                            return range;
                        }
                    },
                    {
                        key: "update",
                        value: function update(mutations, context) {
                            var _this2 = this;
                            mutations.forEach(function(mutation) {
                                if (mutation.type === "characterData" && (mutation.target === _this2.leftGuard || mutation.target === _this2.rightGuard)) {
                                    var range = _this2.restore(mutation.target);
                                    if (range) context.range = range;
                                }
                            });
                        }
                    }
                ]);
                return Embed;
            }(_parchment2.default.Embed);
            exports.default = Embed;
        /***/ },
        /* 36 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.AlignStyle = exports.AlignClass = exports.AlignAttribute = undefined;
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var config = {
                scope: _parchment2.default.Scope.BLOCK,
                whitelist: [
                    "right",
                    "center",
                    "justify"
                ]
            };
            var AlignAttribute = new _parchment2.default.Attributor.Attribute("align", "align", config);
            var AlignClass = new _parchment2.default.Attributor.Class("align", "ql-align", config);
            var AlignStyle = new _parchment2.default.Attributor.Style("align", "text-align", config);
            exports.AlignAttribute = AlignAttribute;
            exports.AlignClass = AlignClass;
            exports.AlignStyle = AlignStyle;
        /***/ },
        /* 37 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.BackgroundStyle = exports.BackgroundClass = undefined;
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _color = __webpack_require__(26);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var BackgroundClass = new _parchment2.default.Attributor.Class("background", "ql-bg", {
                scope: _parchment2.default.Scope.INLINE
            });
            var BackgroundStyle = new _color.ColorAttributor("background", "background-color", {
                scope: _parchment2.default.Scope.INLINE
            });
            exports.BackgroundClass = BackgroundClass;
            exports.BackgroundStyle = BackgroundStyle;
        /***/ },
        /* 38 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.DirectionStyle = exports.DirectionClass = exports.DirectionAttribute = undefined;
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var config = {
                scope: _parchment2.default.Scope.BLOCK,
                whitelist: [
                    "rtl"
                ]
            };
            var DirectionAttribute = new _parchment2.default.Attributor.Attribute("direction", "dir", config);
            var DirectionClass = new _parchment2.default.Attributor.Class("direction", "ql-direction", config);
            var DirectionStyle = new _parchment2.default.Attributor.Style("direction", "direction", config);
            exports.DirectionAttribute = DirectionAttribute;
            exports.DirectionClass = DirectionClass;
            exports.DirectionStyle = DirectionStyle;
        /***/ },
        /* 39 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.FontClass = exports.FontStyle = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var config = {
                scope: _parchment2.default.Scope.INLINE,
                whitelist: [
                    "serif",
                    "monospace"
                ]
            };
            var FontClass = new _parchment2.default.Attributor.Class("font", "ql-font", config);
            var FontStyleAttributor = function(_Parchment$Attributor) {
                _inherits(FontStyleAttributor, _Parchment$Attributor);
                function FontStyleAttributor() {
                    _classCallCheck(this, FontStyleAttributor);
                    return _possibleConstructorReturn(this, (FontStyleAttributor.__proto__ || Object.getPrototypeOf(FontStyleAttributor)).apply(this, arguments));
                }
                _createClass(FontStyleAttributor, [
                    {
                        key: "value",
                        value: function value(node) {
                            return _get(FontStyleAttributor.prototype.__proto__ || Object.getPrototypeOf(FontStyleAttributor.prototype), "value", this).call(this, node).replace(/["']/g, "");
                        }
                    }
                ]);
                return FontStyleAttributor;
            }(_parchment2.default.Attributor.Style);
            var FontStyle = new FontStyleAttributor("font", "font-family", config);
            exports.FontStyle = FontStyle;
            exports.FontClass = FontClass;
        /***/ },
        /* 40 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.SizeStyle = exports.SizeClass = undefined;
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var SizeClass = new _parchment2.default.Attributor.Class("size", "ql-size", {
                scope: _parchment2.default.Scope.INLINE,
                whitelist: [
                    "small",
                    "large",
                    "huge"
                ]
            });
            var SizeStyle = new _parchment2.default.Attributor.Style("size", "font-size", {
                scope: _parchment2.default.Scope.INLINE,
                whitelist: [
                    "10px",
                    "18px",
                    "32px"
                ]
            });
            exports.SizeClass = SizeClass;
            exports.SizeStyle = SizeStyle;
        /***/ },
        /* 41 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = {
                "align": {
                    "": __webpack_require__(76),
                    "center": __webpack_require__(77),
                    "right": __webpack_require__(78),
                    "justify": __webpack_require__(79)
                },
                "background": __webpack_require__(80),
                "blockquote": __webpack_require__(81),
                "bold": __webpack_require__(82),
                "clean": __webpack_require__(83),
                "code": __webpack_require__(58),
                "code-block": __webpack_require__(58),
                "color": __webpack_require__(84),
                "direction": {
                    "": __webpack_require__(85),
                    "rtl": __webpack_require__(86)
                },
                "float": {
                    "center": __webpack_require__(87),
                    "full": __webpack_require__(88),
                    "left": __webpack_require__(89),
                    "right": __webpack_require__(90)
                },
                "formula": __webpack_require__(91),
                "header": {
                    "1": __webpack_require__(92),
                    "2": __webpack_require__(93)
                },
                "italic": __webpack_require__(94),
                "image": __webpack_require__(95),
                "indent": {
                    "+1": __webpack_require__(96),
                    "-1": __webpack_require__(97)
                },
                "link": __webpack_require__(98),
                "list": {
                    "ordered": __webpack_require__(99),
                    "bullet": __webpack_require__(100),
                    "check": __webpack_require__(101)
                },
                "script": {
                    "sub": __webpack_require__(102),
                    "super": __webpack_require__(103)
                },
                "strike": __webpack_require__(104),
                "underline": __webpack_require__(105),
                "video": __webpack_require__(106)
            };
        /***/ },
        /* 42 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.getLastChangeIndex = exports.default = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var History = function(_Module) {
                _inherits(History, _Module);
                function History(quill, options) {
                    _classCallCheck(this, History);
                    var _this = _possibleConstructorReturn(this, (History.__proto__ || Object.getPrototypeOf(History)).call(this, quill, options));
                    _this.lastRecorded = 0;
                    _this.ignoreChange = false;
                    _this.clear();
                    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function(eventName, delta, oldDelta, source) {
                        if (eventName !== _quill2.default.events.TEXT_CHANGE || _this.ignoreChange) return;
                        if (!_this.options.userOnly || source === _quill2.default.sources.USER) _this.record(delta, oldDelta);
                        else _this.transform(delta);
                    });
                    _this.quill.keyboard.addBinding({
                        key: "Z",
                        shortKey: true
                    }, _this.undo.bind(_this));
                    _this.quill.keyboard.addBinding({
                        key: "Z",
                        shortKey: true,
                        shiftKey: true
                    }, _this.redo.bind(_this));
                    if (/Win/i.test(navigator.platform)) _this.quill.keyboard.addBinding({
                        key: "Y",
                        shortKey: true
                    }, _this.redo.bind(_this));
                    return _this;
                }
                _createClass(History, [
                    {
                        key: "change",
                        value: function change(source, dest) {
                            if (this.stack[source].length === 0) return;
                            var delta = this.stack[source].pop();
                            this.stack[dest].push(delta);
                            this.lastRecorded = 0;
                            this.ignoreChange = true;
                            this.quill.updateContents(delta[source], _quill2.default.sources.USER);
                            this.ignoreChange = false;
                            var index = getLastChangeIndex(delta[source]);
                            this.quill.setSelection(index);
                        }
                    },
                    {
                        key: "clear",
                        value: function clear() {
                            this.stack = {
                                undo: [],
                                redo: []
                            };
                        }
                    },
                    {
                        key: "cutoff",
                        value: function cutoff() {
                            this.lastRecorded = 0;
                        }
                    },
                    {
                        key: "record",
                        value: function record(changeDelta, oldDelta) {
                            if (changeDelta.ops.length === 0) return;
                            this.stack.redo = [];
                            var undoDelta = this.quill.getContents().diff(oldDelta);
                            var timestamp = Date.now();
                            if (this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
                                var delta = this.stack.undo.pop();
                                undoDelta = undoDelta.compose(delta.undo);
                                changeDelta = delta.redo.compose(changeDelta);
                            } else this.lastRecorded = timestamp;
                            this.stack.undo.push({
                                redo: changeDelta,
                                undo: undoDelta
                            });
                            if (this.stack.undo.length > this.options.maxStack) this.stack.undo.shift();
                        }
                    },
                    {
                        key: "redo",
                        value: function redo() {
                            this.change("redo", "undo");
                        }
                    },
                    {
                        key: "transform",
                        value: function transform(delta) {
                            this.stack.undo.forEach(function(change) {
                                change.undo = delta.transform(change.undo, true);
                                change.redo = delta.transform(change.redo, true);
                            });
                            this.stack.redo.forEach(function(change) {
                                change.undo = delta.transform(change.undo, true);
                                change.redo = delta.transform(change.redo, true);
                            });
                        }
                    },
                    {
                        key: "undo",
                        value: function undo() {
                            this.change("undo", "redo");
                        }
                    }
                ]);
                return History;
            }(_module2.default);
            History.DEFAULTS = {
                delay: 1000,
                maxStack: 100,
                userOnly: false
            };
            function endsWithNewlineChange(delta) {
                var lastOp = delta.ops[delta.ops.length - 1];
                if (lastOp == null) return false;
                if (lastOp.insert != null) return typeof lastOp.insert === "string" && lastOp.insert.endsWith("\n");
                if (lastOp.attributes != null) return Object.keys(lastOp.attributes).some(function(attr) {
                    return _parchment2.default.query(attr, _parchment2.default.Scope.BLOCK) != null;
                });
                return false;
            }
            function getLastChangeIndex(delta) {
                var deleteLength = delta.reduce(function(length, op) {
                    length += op.delete || 0;
                    return length;
                }, 0);
                var changeIndex = delta.length() - deleteLength;
                if (endsWithNewlineChange(delta)) changeIndex -= 1;
                return changeIndex;
            }
            exports.default = History;
            exports.getLastChangeIndex = getLastChangeIndex;
        /***/ },
        /* 43 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.BaseTooltip = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _emitter = __webpack_require__(8);
            var _emitter2 = _interopRequireDefault(_emitter);
            var _keyboard = __webpack_require__(23);
            var _keyboard2 = _interopRequireDefault(_keyboard);
            var _theme = __webpack_require__(34);
            var _theme2 = _interopRequireDefault(_theme);
            var _colorPicker = __webpack_require__(59);
            var _colorPicker2 = _interopRequireDefault(_colorPicker);
            var _iconPicker = __webpack_require__(60);
            var _iconPicker2 = _interopRequireDefault(_iconPicker);
            var _picker = __webpack_require__(28);
            var _picker2 = _interopRequireDefault(_picker);
            var _tooltip = __webpack_require__(61);
            var _tooltip2 = _interopRequireDefault(_tooltip);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var ALIGNS = [
                false,
                "center",
                "right",
                "justify"
            ];
            var COLORS = [
                "#000000",
                "#e60000",
                "#ff9900",
                "#ffff00",
                "#008a00",
                "#0066cc",
                "#9933ff",
                "#ffffff",
                "#facccc",
                "#ffebcc",
                "#ffffcc",
                "#cce8cc",
                "#cce0f5",
                "#ebd6ff",
                "#bbbbbb",
                "#f06666",
                "#ffc266",
                "#ffff66",
                "#66b966",
                "#66a3e0",
                "#c285ff",
                "#888888",
                "#a10000",
                "#b26b00",
                "#b2b200",
                "#006100",
                "#0047b2",
                "#6b24b2",
                "#444444",
                "#5c0000",
                "#663d00",
                "#666600",
                "#003700",
                "#002966",
                "#3d1466"
            ];
            var FONTS = [
                false,
                "serif",
                "monospace"
            ];
            var HEADERS = [
                "1",
                "2",
                "3",
                false
            ];
            var SIZES = [
                "small",
                false,
                "large",
                "huge"
            ];
            var BaseTheme = function(_Theme) {
                _inherits(BaseTheme, _Theme);
                function BaseTheme(quill, options) {
                    _classCallCheck(this, BaseTheme);
                    var _this = _possibleConstructorReturn(this, (BaseTheme.__proto__ || Object.getPrototypeOf(BaseTheme)).call(this, quill, options));
                    var listener = function listener(e) {
                        if (!document.body.contains(quill.root)) return document.body.removeEventListener("click", listener);
                        if (_this.tooltip != null && !_this.tooltip.root.contains(e.target) && document.activeElement !== _this.tooltip.textbox && !_this.quill.hasFocus()) _this.tooltip.hide();
                        if (_this.pickers != null) _this.pickers.forEach(function(picker) {
                            if (!picker.container.contains(e.target)) picker.close();
                        });
                    };
                    quill.emitter.listenDOM("click", document.body, listener);
                    return _this;
                }
                _createClass(BaseTheme, [
                    {
                        key: "addModule",
                        value: function addModule(name) {
                            var module1 = _get(BaseTheme.prototype.__proto__ || Object.getPrototypeOf(BaseTheme.prototype), "addModule", this).call(this, name);
                            if (name === "toolbar") this.extendToolbar(module1);
                            return module1;
                        }
                    },
                    {
                        key: "buildButtons",
                        value: function buildButtons(buttons, icons) {
                            buttons.forEach(function(button) {
                                var className = button.getAttribute("class") || "";
                                className.split(/\s+/).forEach(function(name) {
                                    if (!name.startsWith("ql-")) return;
                                    name = name.slice(3);
                                    if (icons[name] == null) return;
                                    if (name === "direction") button.innerHTML = icons[name][""] + icons[name]["rtl"];
                                    else if (typeof icons[name] === "string") button.innerHTML = icons[name];
                                    else {
                                        var value = button.value || "";
                                        if (value != null && icons[name][value]) button.innerHTML = icons[name][value];
                                    }
                                });
                            });
                        }
                    },
                    {
                        key: "buildPickers",
                        value: function buildPickers(selects, icons) {
                            var _this2 = this;
                            this.pickers = selects.map(function(select) {
                                if (select.classList.contains("ql-align")) {
                                    if (select.querySelector("option") == null) fillSelect(select, ALIGNS);
                                    return new _iconPicker2.default(select, icons.align);
                                } else if (select.classList.contains("ql-background") || select.classList.contains("ql-color")) {
                                    var format = select.classList.contains("ql-background") ? "background" : "color";
                                    if (select.querySelector("option") == null) fillSelect(select, COLORS, format === "background" ? "#ffffff" : "#000000");
                                    return new _colorPicker2.default(select, icons[format]);
                                } else {
                                    if (select.querySelector("option") == null) {
                                        if (select.classList.contains("ql-font")) fillSelect(select, FONTS);
                                        else if (select.classList.contains("ql-header")) fillSelect(select, HEADERS);
                                        else if (select.classList.contains("ql-size")) fillSelect(select, SIZES);
                                    }
                                    return new _picker2.default(select);
                                }
                            });
                            var update = function update() {
                                _this2.pickers.forEach(function(picker) {
                                    picker.update();
                                });
                            };
                            this.quill.on(_emitter2.default.events.EDITOR_CHANGE, update);
                        }
                    }
                ]);
                return BaseTheme;
            }(_theme2.default);
            BaseTheme.DEFAULTS = (0, _extend2.default)(true, {}, _theme2.default.DEFAULTS, {
                modules: {
                    toolbar: {
                        handlers: {
                            formula: function formula() {
                                this.quill.theme.tooltip.edit("formula");
                            },
                            image: function image() {
                                var _this3 = this;
                                var fileInput = this.container.querySelector("input.ql-image[type=file]");
                                if (fileInput == null) {
                                    fileInput = document.createElement("input");
                                    fileInput.setAttribute("type", "file");
                                    fileInput.setAttribute("accept", "image/png, image/gif, image/jpeg, image/bmp, image/x-icon");
                                    fileInput.classList.add("ql-image");
                                    fileInput.addEventListener("change", function() {
                                        if (fileInput.files != null && fileInput.files[0] != null) {
                                            var reader = new FileReader();
                                            reader.onload = function(e) {
                                                var range = _this3.quill.getSelection(true);
                                                _this3.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert({
                                                    image: e.target.result
                                                }), _emitter2.default.sources.USER);
                                                _this3.quill.setSelection(range.index + 1, _emitter2.default.sources.SILENT);
                                                fileInput.value = "";
                                            };
                                            reader.readAsDataURL(fileInput.files[0]);
                                        }
                                    });
                                    this.container.appendChild(fileInput);
                                }
                                fileInput.click();
                            },
                            video: function video() {
                                this.quill.theme.tooltip.edit("video");
                            }
                        }
                    }
                }
            });
            var BaseTooltip = function(_Tooltip) {
                _inherits(BaseTooltip, _Tooltip);
                function BaseTooltip(quill, boundsContainer) {
                    _classCallCheck(this, BaseTooltip);
                    var _this4 = _possibleConstructorReturn(this, (BaseTooltip.__proto__ || Object.getPrototypeOf(BaseTooltip)).call(this, quill, boundsContainer));
                    _this4.textbox = _this4.root.querySelector('input[type="text"]');
                    _this4.listen();
                    return _this4;
                }
                _createClass(BaseTooltip, [
                    {
                        key: "listen",
                        value: function listen() {
                            var _this5 = this;
                            this.textbox.addEventListener("keydown", function(event) {
                                if (_keyboard2.default.match(event, "enter")) {
                                    _this5.save();
                                    event.preventDefault();
                                } else if (_keyboard2.default.match(event, "escape")) {
                                    _this5.cancel();
                                    event.preventDefault();
                                }
                            });
                        }
                    },
                    {
                        key: "cancel",
                        value: function cancel() {
                            this.hide();
                        }
                    },
                    {
                        key: "edit",
                        value: function edit() {
                            var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "link";
                            var preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                            this.root.classList.remove("ql-hidden");
                            this.root.classList.add("ql-editing");
                            if (preview != null) this.textbox.value = preview;
                            else if (mode !== this.root.getAttribute("data-mode")) this.textbox.value = "";
                            this.position(this.quill.getBounds(this.quill.selection.savedRange));
                            this.textbox.select();
                            this.textbox.setAttribute("placeholder", this.textbox.getAttribute("data-" + mode) || "");
                            this.root.setAttribute("data-mode", mode);
                        }
                    },
                    {
                        key: "restoreFocus",
                        value: function restoreFocus() {
                            var scrollTop = this.quill.scrollingContainer.scrollTop;
                            this.quill.focus();
                            this.quill.scrollingContainer.scrollTop = scrollTop;
                        }
                    },
                    {
                        key: "save",
                        value: function save() {
                            var value = this.textbox.value;
                            switch(this.root.getAttribute("data-mode")){
                                case "link":
                                    var scrollTop = this.quill.root.scrollTop;
                                    if (this.linkRange) {
                                        this.quill.formatText(this.linkRange, "link", value, _emitter2.default.sources.USER);
                                        delete this.linkRange;
                                    } else {
                                        this.restoreFocus();
                                        this.quill.format("link", value, _emitter2.default.sources.USER);
                                    }
                                    this.quill.root.scrollTop = scrollTop;
                                    break;
                                case "video":
                                    value = extractVideoUrl(value);
                                case "formula":
                                    if (!value) break;
                                    var range = this.quill.getSelection(true);
                                    if (range != null) {
                                        var index = range.index + range.length;
                                        this.quill.insertEmbed(index, this.root.getAttribute("data-mode"), value, _emitter2.default.sources.USER);
                                        if (this.root.getAttribute("data-mode") === "formula") this.quill.insertText(index + 1, " ", _emitter2.default.sources.USER);
                                        this.quill.setSelection(index + 2, _emitter2.default.sources.USER);
                                    }
                                    break;
                                default:
                            }
                            this.textbox.value = "";
                            this.hide();
                        }
                    }
                ]);
                return BaseTooltip;
            }(_tooltip2.default);
            function extractVideoUrl(url) {
                var match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
                if (match) return (match[1] || "https") + "://www.youtube.com/embed/" + match[2] + "?showinfo=0";
                if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) // eslint-disable-line no-cond-assign
                return (match[1] || "https") + "://player.vimeo.com/video/" + match[2] + "/";
                return url;
            }
            function fillSelect(select, values) {
                var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                values.forEach(function(value) {
                    var option = document.createElement("option");
                    if (value === defaultValue) option.setAttribute("selected", "selected");
                    else option.setAttribute("value", value);
                    select.appendChild(option);
                });
            }
            exports.BaseTooltip = BaseTooltip;
            exports.default = BaseTheme;
        /***/ },
        /* 44 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var LinkedList = /** @class */ function() {
                function LinkedList() {
                    this.head = this.tail = null;
                    this.length = 0;
                }
                LinkedList.prototype.append = function() {
                    var nodes = [];
                    for(var _i = 0; _i < arguments.length; _i++)nodes[_i] = arguments[_i];
                    this.insertBefore(nodes[0], null);
                    if (nodes.length > 1) this.append.apply(this, nodes.slice(1));
                };
                LinkedList.prototype.contains = function(node) {
                    var cur, next = this.iterator();
                    while(cur = next()){
                        if (cur === node) return true;
                    }
                    return false;
                };
                LinkedList.prototype.insertBefore = function(node, refNode) {
                    if (!node) return;
                    node.next = refNode;
                    if (refNode != null) {
                        node.prev = refNode.prev;
                        if (refNode.prev != null) refNode.prev.next = node;
                        refNode.prev = node;
                        if (refNode === this.head) this.head = node;
                    } else if (this.tail != null) {
                        this.tail.next = node;
                        node.prev = this.tail;
                        this.tail = node;
                    } else {
                        node.prev = null;
                        this.head = this.tail = node;
                    }
                    this.length += 1;
                };
                LinkedList.prototype.offset = function(target) {
                    var index = 0, cur = this.head;
                    while(cur != null){
                        if (cur === target) return index;
                        index += cur.length();
                        cur = cur.next;
                    }
                    return -1;
                };
                LinkedList.prototype.remove = function(node) {
                    if (!this.contains(node)) return;
                    if (node.prev != null) node.prev.next = node.next;
                    if (node.next != null) node.next.prev = node.prev;
                    if (node === this.head) this.head = node.next;
                    if (node === this.tail) this.tail = node.prev;
                    this.length -= 1;
                };
                LinkedList.prototype.iterator = function(curNode) {
                    if (curNode === void 0) curNode = this.head;
                    // TODO use yield when we can
                    return function() {
                        var ret = curNode;
                        if (curNode != null) curNode = curNode.next;
                        return ret;
                    };
                };
                LinkedList.prototype.find = function(index, inclusive) {
                    if (inclusive === void 0) inclusive = false;
                    var cur, next = this.iterator();
                    while(cur = next()){
                        var length = cur.length();
                        if (index < length || inclusive && index === length && (cur.next == null || cur.next.length() !== 0)) return [
                            cur,
                            index
                        ];
                        index -= length;
                    }
                    return [
                        null,
                        0
                    ];
                };
                LinkedList.prototype.forEach = function(callback) {
                    var cur, next = this.iterator();
                    while(cur = next())callback(cur);
                };
                LinkedList.prototype.forEachAt = function(index, length, callback) {
                    if (length <= 0) return;
                    var _a = this.find(index), startNode = _a[0], offset = _a[1];
                    var cur, curIndex = index - offset, next = this.iterator(startNode);
                    while((cur = next()) && curIndex < index + length){
                        var curLength = cur.length();
                        if (index > curIndex) callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index));
                        else callback(cur, 0, Math.min(curLength, index + length - curIndex));
                        curIndex += curLength;
                    }
                };
                LinkedList.prototype.map = function(callback) {
                    return this.reduce(function(memo, cur) {
                        memo.push(callback(cur));
                        return memo;
                    }, []);
                };
                LinkedList.prototype.reduce = function(callback, memo) {
                    var cur, next = this.iterator();
                    while(cur = next())memo = callback(memo, cur);
                    return memo;
                };
                return LinkedList;
            }();
            exports.default = LinkedList;
        /***/ },
        /* 45 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var container_1 = __webpack_require__(17);
            var Registry = __webpack_require__(1);
            var OBSERVER_CONFIG = {
                attributes: true,
                characterData: true,
                characterDataOldValue: true,
                childList: true,
                subtree: true
            };
            var MAX_OPTIMIZE_ITERATIONS = 100;
            var ScrollBlot = /** @class */ function(_super) {
                __extends(ScrollBlot, _super);
                function ScrollBlot(node) {
                    var _this = _super.call(this, node) || this;
                    _this.scroll = _this;
                    _this.observer = new MutationObserver(function(mutations) {
                        _this.update(mutations);
                    });
                    _this.observer.observe(_this.domNode, OBSERVER_CONFIG);
                    _this.attach();
                    return _this;
                }
                ScrollBlot.prototype.detach = function() {
                    _super.prototype.detach.call(this);
                    this.observer.disconnect();
                };
                ScrollBlot.prototype.deleteAt = function(index, length) {
                    this.update();
                    if (index === 0 && length === this.length()) this.children.forEach(function(child) {
                        child.remove();
                    });
                    else _super.prototype.deleteAt.call(this, index, length);
                };
                ScrollBlot.prototype.formatAt = function(index, length, name, value) {
                    this.update();
                    _super.prototype.formatAt.call(this, index, length, name, value);
                };
                ScrollBlot.prototype.insertAt = function(index, value, def) {
                    this.update();
                    _super.prototype.insertAt.call(this, index, value, def);
                };
                ScrollBlot.prototype.optimize = function(mutations, context) {
                    var _this = this;
                    if (mutations === void 0) mutations = [];
                    if (context === void 0) context = {};
                    _super.prototype.optimize.call(this, context);
                    // We must modify mutations directly, cannot make copy and then modify
                    var records = [].slice.call(this.observer.takeRecords());
                    // Array.push currently seems to be implemented by a non-tail recursive function
                    // so we cannot just mutations.push.apply(mutations, this.observer.takeRecords());
                    while(records.length > 0)mutations.push(records.pop());
                    // TODO use WeakMap
                    var mark = function(blot, markParent) {
                        if (markParent === void 0) markParent = true;
                        if (blot == null || blot === _this) return;
                        if (blot.domNode.parentNode == null) return;
                        // @ts-ignore
                        if (blot.domNode[Registry.DATA_KEY].mutations == null) // @ts-ignore
                        blot.domNode[Registry.DATA_KEY].mutations = [];
                        if (markParent) mark(blot.parent);
                    };
                    var optimize = function(blot) {
                        // Post-order traversal
                        if (// @ts-ignore
                        blot.domNode[Registry.DATA_KEY] == null || // @ts-ignore
                        blot.domNode[Registry.DATA_KEY].mutations == null) return;
                        if (blot instanceof container_1.default) blot.children.forEach(optimize);
                        blot.optimize(context);
                    };
                    var remaining = mutations;
                    for(var i = 0; remaining.length > 0; i += 1){
                        if (i >= MAX_OPTIMIZE_ITERATIONS) throw new Error("[Parchment] Maximum optimize iterations reached");
                        remaining.forEach(function(mutation) {
                            var blot = Registry.find(mutation.target, true);
                            if (blot == null) return;
                            if (blot.domNode === mutation.target) {
                                if (mutation.type === "childList") {
                                    mark(Registry.find(mutation.previousSibling, false));
                                    [].forEach.call(mutation.addedNodes, function(node) {
                                        var child = Registry.find(node, false);
                                        mark(child, false);
                                        if (child instanceof container_1.default) child.children.forEach(function(grandChild) {
                                            mark(grandChild, false);
                                        });
                                    });
                                } else if (mutation.type === "attributes") mark(blot.prev);
                            }
                            mark(blot);
                        });
                        this.children.forEach(optimize);
                        remaining = [].slice.call(this.observer.takeRecords());
                        records = remaining.slice();
                        while(records.length > 0)mutations.push(records.pop());
                    }
                };
                ScrollBlot.prototype.update = function(mutations, context) {
                    var _this = this;
                    if (context === void 0) context = {};
                    mutations = mutations || this.observer.takeRecords();
                    // TODO use WeakMap
                    mutations.map(function(mutation) {
                        var blot = Registry.find(mutation.target, true);
                        if (blot == null) return null;
                        // @ts-ignore
                        if (blot.domNode[Registry.DATA_KEY].mutations == null) {
                            // @ts-ignore
                            blot.domNode[Registry.DATA_KEY].mutations = [
                                mutation
                            ];
                            return blot;
                        } else {
                            // @ts-ignore
                            blot.domNode[Registry.DATA_KEY].mutations.push(mutation);
                            return null;
                        }
                    }).forEach(function(blot) {
                        if (blot == null || blot === _this || //@ts-ignore
                        blot.domNode[Registry.DATA_KEY] == null) return;
                        // @ts-ignore
                        blot.update(blot.domNode[Registry.DATA_KEY].mutations || [], context);
                    });
                    // @ts-ignore
                    if (this.domNode[Registry.DATA_KEY].mutations != null) // @ts-ignore
                    _super.prototype.update.call(this, this.domNode[Registry.DATA_KEY].mutations, context);
                    this.optimize(mutations, context);
                };
                ScrollBlot.blotName = "scroll";
                ScrollBlot.defaultChild = "block";
                ScrollBlot.scope = Registry.Scope.BLOCK_BLOT;
                ScrollBlot.tagName = "DIV";
                return ScrollBlot;
            }(container_1.default);
            exports.default = ScrollBlot;
        /***/ },
        /* 46 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var format_1 = __webpack_require__(18);
            var Registry = __webpack_require__(1);
            // Shallow object comparison
            function isEqual(obj1, obj2) {
                if (Object.keys(obj1).length !== Object.keys(obj2).length) return false;
                // @ts-ignore
                for(var prop in obj1){
                    // @ts-ignore
                    if (obj1[prop] !== obj2[prop]) return false;
                }
                return true;
            }
            var InlineBlot = /** @class */ function(_super) {
                __extends(InlineBlot, _super);
                function InlineBlot() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                InlineBlot.formats = function(domNode) {
                    if (domNode.tagName === InlineBlot.tagName) return undefined;
                    return _super.formats.call(this, domNode);
                };
                InlineBlot.prototype.format = function(name, value) {
                    var _this = this;
                    if (name === this.statics.blotName && !value) {
                        this.children.forEach(function(child) {
                            if (!(child instanceof format_1.default)) child = child.wrap(InlineBlot.blotName, true);
                            _this.attributes.copy(child);
                        });
                        this.unwrap();
                    } else _super.prototype.format.call(this, name, value);
                };
                InlineBlot.prototype.formatAt = function(index, length, name, value) {
                    if (this.formats()[name] != null || Registry.query(name, Registry.Scope.ATTRIBUTE)) {
                        var blot = this.isolate(index, length);
                        blot.format(name, value);
                    } else _super.prototype.formatAt.call(this, index, length, name, value);
                };
                InlineBlot.prototype.optimize = function(context) {
                    _super.prototype.optimize.call(this, context);
                    var formats = this.formats();
                    if (Object.keys(formats).length === 0) return this.unwrap(); // unformatted span
                    var next = this.next;
                    if (next instanceof InlineBlot && next.prev === this && isEqual(formats, next.formats())) {
                        next.moveChildren(this);
                        next.remove();
                    }
                };
                InlineBlot.blotName = "inline";
                InlineBlot.scope = Registry.Scope.INLINE_BLOT;
                InlineBlot.tagName = "SPAN";
                return InlineBlot;
            }(format_1.default);
            exports.default = InlineBlot;
        /***/ },
        /* 47 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var format_1 = __webpack_require__(18);
            var Registry = __webpack_require__(1);
            var BlockBlot = /** @class */ function(_super) {
                __extends(BlockBlot, _super);
                function BlockBlot() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                BlockBlot.formats = function(domNode) {
                    var tagName = Registry.query(BlockBlot.blotName).tagName;
                    if (domNode.tagName === tagName) return undefined;
                    return _super.formats.call(this, domNode);
                };
                BlockBlot.prototype.format = function(name, value) {
                    if (Registry.query(name, Registry.Scope.BLOCK) == null) return;
                    else if (name === this.statics.blotName && !value) this.replaceWith(BlockBlot.blotName);
                    else _super.prototype.format.call(this, name, value);
                };
                BlockBlot.prototype.formatAt = function(index, length, name, value) {
                    if (Registry.query(name, Registry.Scope.BLOCK) != null) this.format(name, value);
                    else _super.prototype.formatAt.call(this, index, length, name, value);
                };
                BlockBlot.prototype.insertAt = function(index, value, def) {
                    if (def == null || Registry.query(value, Registry.Scope.INLINE) != null) // Insert text or inline
                    _super.prototype.insertAt.call(this, index, value, def);
                    else {
                        var after = this.split(index);
                        var blot = Registry.create(value, def);
                        after.parent.insertBefore(blot, after);
                    }
                };
                BlockBlot.prototype.update = function(mutations, context) {
                    if (navigator.userAgent.match(/Trident/)) this.build();
                    else _super.prototype.update.call(this, mutations, context);
                };
                BlockBlot.blotName = "block";
                BlockBlot.scope = Registry.Scope.BLOCK_BLOT;
                BlockBlot.tagName = "P";
                return BlockBlot;
            }(format_1.default);
            exports.default = BlockBlot;
        /***/ },
        /* 48 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var leaf_1 = __webpack_require__(19);
            var EmbedBlot = /** @class */ function(_super) {
                __extends(EmbedBlot, _super);
                function EmbedBlot() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                EmbedBlot.formats = function(domNode) {
                    return undefined;
                };
                EmbedBlot.prototype.format = function(name, value) {
                    // super.formatAt wraps, which is what we want in general,
                    // but this allows subclasses to overwrite for formats
                    // that just apply to particular embeds
                    _super.prototype.formatAt.call(this, 0, this.length(), name, value);
                };
                EmbedBlot.prototype.formatAt = function(index, length, name, value) {
                    if (index === 0 && length === this.length()) this.format(name, value);
                    else _super.prototype.formatAt.call(this, index, length, name, value);
                };
                EmbedBlot.prototype.formats = function() {
                    return this.statics.formats(this.domNode);
                };
                return EmbedBlot;
            }(leaf_1.default);
            exports.default = EmbedBlot;
        /***/ },
        /* 49 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var leaf_1 = __webpack_require__(19);
            var Registry = __webpack_require__(1);
            var TextBlot = /** @class */ function(_super) {
                __extends(TextBlot, _super);
                function TextBlot(node) {
                    var _this = _super.call(this, node) || this;
                    _this.text = _this.statics.value(_this.domNode);
                    return _this;
                }
                TextBlot.create = function(value) {
                    return document.createTextNode(value);
                };
                TextBlot.value = function(domNode) {
                    var text = domNode.data;
                    // @ts-ignore
                    if (text["normalize"]) text = text["normalize"]();
                    return text;
                };
                TextBlot.prototype.deleteAt = function(index, length) {
                    this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
                };
                TextBlot.prototype.index = function(node, offset) {
                    if (this.domNode === node) return offset;
                    return -1;
                };
                TextBlot.prototype.insertAt = function(index, value, def) {
                    if (def == null) {
                        this.text = this.text.slice(0, index) + value + this.text.slice(index);
                        this.domNode.data = this.text;
                    } else _super.prototype.insertAt.call(this, index, value, def);
                };
                TextBlot.prototype.length = function() {
                    return this.text.length;
                };
                TextBlot.prototype.optimize = function(context) {
                    _super.prototype.optimize.call(this, context);
                    this.text = this.statics.value(this.domNode);
                    if (this.text.length === 0) this.remove();
                    else if (this.next instanceof TextBlot && this.next.prev === this) {
                        this.insertAt(this.length(), this.next.value());
                        this.next.remove();
                    }
                };
                TextBlot.prototype.position = function(index, inclusive) {
                    if (inclusive === void 0) inclusive = false;
                    return [
                        this.domNode,
                        index
                    ];
                };
                TextBlot.prototype.split = function(index, force) {
                    if (force === void 0) force = false;
                    if (!force) {
                        if (index === 0) return this;
                        if (index === this.length()) return this.next;
                    }
                    var after = Registry.create(this.domNode.splitText(index));
                    this.parent.insertBefore(after, this.next);
                    this.text = this.statics.value(this.domNode);
                    return after;
                };
                TextBlot.prototype.update = function(mutations, context) {
                    var _this = this;
                    if (mutations.some(function(mutation) {
                        return mutation.type === "characterData" && mutation.target === _this.domNode;
                    })) this.text = this.statics.value(this.domNode);
                };
                TextBlot.prototype.value = function() {
                    return this.text;
                };
                TextBlot.blotName = "text";
                TextBlot.scope = Registry.Scope.INLINE_BLOT;
                return TextBlot;
            }(leaf_1.default);
            exports.default = TextBlot;
        /***/ },
        /* 50 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var elem = document.createElement("div");
            elem.classList.toggle("test-class", false);
            if (elem.classList.contains("test-class")) {
                var _toggle = DOMTokenList.prototype.toggle;
                DOMTokenList.prototype.toggle = function(token, force) {
                    if (arguments.length > 1 && !this.contains(token) === !force) return force;
                    else return _toggle.call(this, token);
                };
            }
            if (!String.prototype.startsWith) String.prototype.startsWith = function(searchString, position) {
                position = position || 0;
                return this.substr(position, searchString.length) === searchString;
            };
            if (!String.prototype.endsWith) String.prototype.endsWith = function(searchString, position) {
                var subjectString = this.toString();
                if (typeof position !== "number" || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) position = subjectString.length;
                position -= searchString.length;
                var lastIndex = subjectString.indexOf(searchString, position);
                return lastIndex !== -1 && lastIndex === position;
            };
            if (!Array.prototype.find) Object.defineProperty(Array.prototype, "find", {
                value: function value(predicate) {
                    if (this === null) throw new TypeError("Array.prototype.find called on null or undefined");
                    if (typeof predicate !== "function") throw new TypeError("predicate must be a function");
                    var list = Object(this);
                    var length = list.length >>> 0;
                    var thisArg = arguments[1];
                    var value;
                    for(var i = 0; i < length; i++){
                        value = list[i];
                        if (predicate.call(thisArg, value, i, list)) return value;
                    }
                    return undefined;
                }
            });
            document.addEventListener("DOMContentLoaded", function() {
                // Disable resizing in Firefox
                document.execCommand("enableObjectResizing", false, false);
                // Disable automatic linkifying in IE11
                document.execCommand("autoUrlDetect", false, false);
            });
        /***/ },
        /* 51 */ /***/ function(module1, exports) {
            /**
 * This library modifies the diff-patch-match library by Neil Fraser
 * by removing the patch and match functionality and certain advanced
 * options in the diff function. The original license is as follows:
 *
 * ===
 *
 * Diff Match and Patch
 *
 * Copyright 2006 Google Inc.
 * http://code.google.com/p/google-diff-match-patch/
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The data structure representing a diff is an array of tuples:
 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
 */ var DIFF_DELETE = -1;
            var DIFF_INSERT = 1;
            var DIFF_EQUAL = 0;
            /**
 * Find the differences between two texts.  Simplifies the problem by stripping
 * any common prefix or suffix off the texts before diffing.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {Int} cursor_pos Expected edit position in text1 (optional)
 * @return {Array} Array of diff tuples.
 */ function diff_main(text1, text2, cursor_pos) {
                // Check for equality (speedup).
                if (text1 == text2) {
                    if (text1) return [
                        [
                            DIFF_EQUAL,
                            text1
                        ]
                    ];
                    return [];
                }
                // Check cursor_pos within bounds
                if (cursor_pos < 0 || text1.length < cursor_pos) cursor_pos = null;
                // Trim off common prefix (speedup).
                var commonlength = diff_commonPrefix(text1, text2);
                var commonprefix = text1.substring(0, commonlength);
                text1 = text1.substring(commonlength);
                text2 = text2.substring(commonlength);
                // Trim off common suffix (speedup).
                commonlength = diff_commonSuffix(text1, text2);
                var commonsuffix = text1.substring(text1.length - commonlength);
                text1 = text1.substring(0, text1.length - commonlength);
                text2 = text2.substring(0, text2.length - commonlength);
                // Compute the diff on the middle block.
                var diffs = diff_compute_(text1, text2);
                // Restore the prefix and suffix.
                if (commonprefix) diffs.unshift([
                    DIFF_EQUAL,
                    commonprefix
                ]);
                if (commonsuffix) diffs.push([
                    DIFF_EQUAL,
                    commonsuffix
                ]);
                diff_cleanupMerge(diffs);
                if (cursor_pos != null) diffs = fix_cursor(diffs, cursor_pos);
                diffs = fix_emoji(diffs);
                return diffs;
            }
            /**
 * Find the differences between two texts.  Assumes that the texts do not
 * have any common prefix or suffix.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 */ function diff_compute_(text1, text2) {
                var diffs;
                if (!text1) // Just add some text (speedup).
                return [
                    [
                        DIFF_INSERT,
                        text2
                    ]
                ];
                if (!text2) // Just delete some text (speedup).
                return [
                    [
                        DIFF_DELETE,
                        text1
                    ]
                ];
                var longtext = text1.length > text2.length ? text1 : text2;
                var shorttext = text1.length > text2.length ? text2 : text1;
                var i = longtext.indexOf(shorttext);
                if (i != -1) {
                    // Shorter text is inside the longer text (speedup).
                    diffs = [
                        [
                            DIFF_INSERT,
                            longtext.substring(0, i)
                        ],
                        [
                            DIFF_EQUAL,
                            shorttext
                        ],
                        [
                            DIFF_INSERT,
                            longtext.substring(i + shorttext.length)
                        ]
                    ];
                    // Swap insertions for deletions if diff is reversed.
                    if (text1.length > text2.length) diffs[0][0] = diffs[2][0] = DIFF_DELETE;
                    return diffs;
                }
                if (shorttext.length == 1) // Single character string.
                // After the previous speedup, the character can't be an equality.
                return [
                    [
                        DIFF_DELETE,
                        text1
                    ],
                    [
                        DIFF_INSERT,
                        text2
                    ]
                ];
                // Check to see if the problem can be split in two.
                var hm = diff_halfMatch_(text1, text2);
                if (hm) {
                    // A half-match was found, sort out the return data.
                    var text1_a = hm[0];
                    var text1_b = hm[1];
                    var text2_a = hm[2];
                    var text2_b = hm[3];
                    var mid_common = hm[4];
                    // Send both pairs off for separate processing.
                    var diffs_a = diff_main(text1_a, text2_a);
                    var diffs_b = diff_main(text1_b, text2_b);
                    // Merge the results.
                    return diffs_a.concat([
                        [
                            DIFF_EQUAL,
                            mid_common
                        ]
                    ], diffs_b);
                }
                return diff_bisect_(text1, text2);
            }
            /**
 * Find the 'middle snake' of a diff, split the problem in two
 * and return the recursively constructed diff.
 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 * @private
 */ function diff_bisect_(text1, text2) {
                // Cache the text lengths to prevent multiple calls.
                var text1_length = text1.length;
                var text2_length = text2.length;
                var max_d = Math.ceil((text1_length + text2_length) / 2);
                var v_offset = max_d;
                var v_length = 2 * max_d;
                var v1 = new Array(v_length);
                var v2 = new Array(v_length);
                // Setting all elements to -1 is faster in Chrome & Firefox than mixing
                // integers and undefined.
                for(var x = 0; x < v_length; x++){
                    v1[x] = -1;
                    v2[x] = -1;
                }
                v1[v_offset + 1] = 0;
                v2[v_offset + 1] = 0;
                var delta = text1_length - text2_length;
                // If the total number of characters is odd, then the front path will collide
                // with the reverse path.
                var front = delta % 2 != 0;
                // Offsets for start and end of k loop.
                // Prevents mapping of space beyond the grid.
                var k1start = 0;
                var k1end = 0;
                var k2start = 0;
                var k2end = 0;
                for(var d = 0; d < max_d; d++){
                    // Walk the front path one step.
                    for(var k1 = -d + k1start; k1 <= d - k1end; k1 += 2){
                        var k1_offset = v_offset + k1;
                        var x1;
                        if (k1 == -d || k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1]) x1 = v1[k1_offset + 1];
                        else x1 = v1[k1_offset - 1] + 1;
                        var y1 = x1 - k1;
                        while(x1 < text1_length && y1 < text2_length && text1.charAt(x1) == text2.charAt(y1)){
                            x1++;
                            y1++;
                        }
                        v1[k1_offset] = x1;
                        if (x1 > text1_length) // Ran off the right of the graph.
                        k1end += 2;
                        else if (y1 > text2_length) // Ran off the bottom of the graph.
                        k1start += 2;
                        else if (front) {
                            var k2_offset = v_offset + delta - k1;
                            if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
                                // Mirror x2 onto top-left coordinate system.
                                var x2 = text1_length - v2[k2_offset];
                                if (x1 >= x2) // Overlap detected.
                                return diff_bisectSplit_(text1, text2, x1, y1);
                            }
                        }
                    }
                    // Walk the reverse path one step.
                    for(var k2 = -d + k2start; k2 <= d - k2end; k2 += 2){
                        var k2_offset = v_offset + k2;
                        var x2;
                        if (k2 == -d || k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1]) x2 = v2[k2_offset + 1];
                        else x2 = v2[k2_offset - 1] + 1;
                        var y2 = x2 - k2;
                        while(x2 < text1_length && y2 < text2_length && text1.charAt(text1_length - x2 - 1) == text2.charAt(text2_length - y2 - 1)){
                            x2++;
                            y2++;
                        }
                        v2[k2_offset] = x2;
                        if (x2 > text1_length) // Ran off the left of the graph.
                        k2end += 2;
                        else if (y2 > text2_length) // Ran off the top of the graph.
                        k2start += 2;
                        else if (!front) {
                            var k1_offset = v_offset + delta - k2;
                            if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
                                var x1 = v1[k1_offset];
                                var y1 = v_offset + x1 - k1_offset;
                                // Mirror x2 onto top-left coordinate system.
                                x2 = text1_length - x2;
                                if (x1 >= x2) // Overlap detected.
                                return diff_bisectSplit_(text1, text2, x1, y1);
                            }
                        }
                    }
                }
                // Diff took too long and hit the deadline or
                // number of diffs equals number of characters, no commonality at all.
                return [
                    [
                        DIFF_DELETE,
                        text1
                    ],
                    [
                        DIFF_INSERT,
                        text2
                    ]
                ];
            }
            /**
 * Given the location of the 'middle snake', split the diff in two parts
 * and recurse.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} x Index of split point in text1.
 * @param {number} y Index of split point in text2.
 * @return {Array} Array of diff tuples.
 */ function diff_bisectSplit_(text1, text2, x, y) {
                var text1a = text1.substring(0, x);
                var text2a = text2.substring(0, y);
                var text1b = text1.substring(x);
                var text2b = text2.substring(y);
                // Compute both diffs serially.
                var diffs = diff_main(text1a, text2a);
                var diffsb = diff_main(text1b, text2b);
                return diffs.concat(diffsb);
            }
            /**
 * Determine the common prefix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the start of each
 *     string.
 */ function diff_commonPrefix(text1, text2) {
                // Quick check for common null cases.
                if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) return 0;
                // Binary search.
                // Performance analysis: http://neil.fraser.name/news/2007/10/09/
                var pointermin = 0;
                var pointermax = Math.min(text1.length, text2.length);
                var pointermid = pointermax;
                var pointerstart = 0;
                while(pointermin < pointermid){
                    if (text1.substring(pointerstart, pointermid) == text2.substring(pointerstart, pointermid)) {
                        pointermin = pointermid;
                        pointerstart = pointermin;
                    } else pointermax = pointermid;
                    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
                }
                return pointermid;
            }
            /**
 * Determine the common suffix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of each string.
 */ function diff_commonSuffix(text1, text2) {
                // Quick check for common null cases.
                if (!text1 || !text2 || text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) return 0;
                // Binary search.
                // Performance analysis: http://neil.fraser.name/news/2007/10/09/
                var pointermin = 0;
                var pointermax = Math.min(text1.length, text2.length);
                var pointermid = pointermax;
                var pointerend = 0;
                while(pointermin < pointermid){
                    if (text1.substring(text1.length - pointermid, text1.length - pointerend) == text2.substring(text2.length - pointermid, text2.length - pointerend)) {
                        pointermin = pointermid;
                        pointerend = pointermin;
                    } else pointermax = pointermid;
                    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
                }
                return pointermid;
            }
            /**
 * Do the two texts share a substring which is at least half the length of the
 * longer text?
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {Array.<string>} Five element Array, containing the prefix of
 *     text1, the suffix of text1, the prefix of text2, the suffix of
 *     text2 and the common middle.  Or null if there was no match.
 */ function diff_halfMatch_(text1, text2) {
                var longtext = text1.length > text2.length ? text1 : text2;
                var shorttext = text1.length > text2.length ? text2 : text1;
                if (longtext.length < 4 || shorttext.length * 2 < longtext.length) return null; // Pointless.
                /**
   * Does a substring of shorttext exist within longtext such that the substring
   * is at least half the length of longtext?
   * Closure, but does not reference any external variables.
   * @param {string} longtext Longer string.
   * @param {string} shorttext Shorter string.
   * @param {number} i Start index of quarter length substring within longtext.
   * @return {Array.<string>} Five element Array, containing the prefix of
   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
   *     of shorttext and the common middle.  Or null if there was no match.
   * @private
   */ function diff_halfMatchI_(longtext, shorttext, i) {
                    // Start with a 1/4 length substring at position i as a seed.
                    var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
                    var j = -1;
                    var best_common = "";
                    var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
                    while((j = shorttext.indexOf(seed, j + 1)) != -1){
                        var prefixLength = diff_commonPrefix(longtext.substring(i), shorttext.substring(j));
                        var suffixLength = diff_commonSuffix(longtext.substring(0, i), shorttext.substring(0, j));
                        if (best_common.length < suffixLength + prefixLength) {
                            best_common = shorttext.substring(j - suffixLength, j) + shorttext.substring(j, j + prefixLength);
                            best_longtext_a = longtext.substring(0, i - suffixLength);
                            best_longtext_b = longtext.substring(i + prefixLength);
                            best_shorttext_a = shorttext.substring(0, j - suffixLength);
                            best_shorttext_b = shorttext.substring(j + prefixLength);
                        }
                    }
                    if (best_common.length * 2 >= longtext.length) return [
                        best_longtext_a,
                        best_longtext_b,
                        best_shorttext_a,
                        best_shorttext_b,
                        best_common
                    ];
                    else return null;
                }
                // First check if the second quarter is the seed for a half-match.
                var hm1 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 4));
                // Check again based on the third quarter.
                var hm2 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 2));
                var hm;
                if (!hm1 && !hm2) return null;
                else if (!hm2) hm = hm1;
                else if (!hm1) hm = hm2;
                else // Both matched.  Select the longest.
                hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
                // A half-match was found, sort out the return data.
                var text1_a, text1_b, text2_a, text2_b;
                if (text1.length > text2.length) {
                    text1_a = hm[0];
                    text1_b = hm[1];
                    text2_a = hm[2];
                    text2_b = hm[3];
                } else {
                    text2_a = hm[0];
                    text2_b = hm[1];
                    text1_a = hm[2];
                    text1_b = hm[3];
                }
                var mid_common = hm[4];
                return [
                    text1_a,
                    text1_b,
                    text2_a,
                    text2_b,
                    mid_common
                ];
            }
            /**
 * Reorder and merge like edit sections.  Merge equalities.
 * Any edit section can move as long as it doesn't cross an equality.
 * @param {Array} diffs Array of diff tuples.
 */ function diff_cleanupMerge(diffs) {
                diffs.push([
                    DIFF_EQUAL,
                    ""
                ]); // Add a dummy entry at the end.
                var pointer = 0;
                var count_delete = 0;
                var count_insert = 0;
                var text_delete = "";
                var text_insert = "";
                var commonlength;
                while(pointer < diffs.length)switch(diffs[pointer][0]){
                    case DIFF_INSERT:
                        count_insert++;
                        text_insert += diffs[pointer][1];
                        pointer++;
                        break;
                    case DIFF_DELETE:
                        count_delete++;
                        text_delete += diffs[pointer][1];
                        pointer++;
                        break;
                    case DIFF_EQUAL:
                        // Upon reaching an equality, check for prior redundancies.
                        if (count_delete + count_insert > 1) {
                            if (count_delete !== 0 && count_insert !== 0) {
                                // Factor out any common prefixies.
                                commonlength = diff_commonPrefix(text_insert, text_delete);
                                if (commonlength !== 0) {
                                    if (pointer - count_delete - count_insert > 0 && diffs[pointer - count_delete - count_insert - 1][0] == DIFF_EQUAL) diffs[pointer - count_delete - count_insert - 1][1] += text_insert.substring(0, commonlength);
                                    else {
                                        diffs.splice(0, 0, [
                                            DIFF_EQUAL,
                                            text_insert.substring(0, commonlength)
                                        ]);
                                        pointer++;
                                    }
                                    text_insert = text_insert.substring(commonlength);
                                    text_delete = text_delete.substring(commonlength);
                                }
                                // Factor out any common suffixies.
                                commonlength = diff_commonSuffix(text_insert, text_delete);
                                if (commonlength !== 0) {
                                    diffs[pointer][1] = text_insert.substring(text_insert.length - commonlength) + diffs[pointer][1];
                                    text_insert = text_insert.substring(0, text_insert.length - commonlength);
                                    text_delete = text_delete.substring(0, text_delete.length - commonlength);
                                }
                            }
                            // Delete the offending records and add the merged ones.
                            if (count_delete === 0) diffs.splice(pointer - count_insert, count_delete + count_insert, [
                                DIFF_INSERT,
                                text_insert
                            ]);
                            else if (count_insert === 0) diffs.splice(pointer - count_delete, count_delete + count_insert, [
                                DIFF_DELETE,
                                text_delete
                            ]);
                            else diffs.splice(pointer - count_delete - count_insert, count_delete + count_insert, [
                                DIFF_DELETE,
                                text_delete
                            ], [
                                DIFF_INSERT,
                                text_insert
                            ]);
                            pointer = pointer - count_delete - count_insert + (count_delete ? 1 : 0) + (count_insert ? 1 : 0) + 1;
                        } else if (pointer !== 0 && diffs[pointer - 1][0] == DIFF_EQUAL) {
                            // Merge this equality with the previous one.
                            diffs[pointer - 1][1] += diffs[pointer][1];
                            diffs.splice(pointer, 1);
                        } else pointer++;
                        count_insert = 0;
                        count_delete = 0;
                        text_delete = "";
                        text_insert = "";
                        break;
                }
                if (diffs[diffs.length - 1][1] === "") diffs.pop(); // Remove the dummy entry at the end.
                // Second pass: look for single edits surrounded on both sides by equalities
                // which can be shifted sideways to eliminate an equality.
                // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
                var changes = false;
                pointer = 1;
                // Intentionally ignore the first and last element (don't need checking).
                while(pointer < diffs.length - 1){
                    if (diffs[pointer - 1][0] == DIFF_EQUAL && diffs[pointer + 1][0] == DIFF_EQUAL) {
                        // This is a single edit surrounded by equalities.
                        if (diffs[pointer][1].substring(diffs[pointer][1].length - diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
                            // Shift the edit over the previous equality.
                            diffs[pointer][1] = diffs[pointer - 1][1] + diffs[pointer][1].substring(0, diffs[pointer][1].length - diffs[pointer - 1][1].length);
                            diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
                            diffs.splice(pointer - 1, 1);
                            changes = true;
                        } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) == diffs[pointer + 1][1]) {
                            // Shift the edit over the next equality.
                            diffs[pointer - 1][1] += diffs[pointer + 1][1];
                            diffs[pointer][1] = diffs[pointer][1].substring(diffs[pointer + 1][1].length) + diffs[pointer + 1][1];
                            diffs.splice(pointer + 1, 1);
                            changes = true;
                        }
                    }
                    pointer++;
                }
                // If shifts were made, the diff needs reordering and another shift sweep.
                if (changes) diff_cleanupMerge(diffs);
            }
            var diff = diff_main;
            diff.INSERT = DIFF_INSERT;
            diff.DELETE = DIFF_DELETE;
            diff.EQUAL = DIFF_EQUAL;
            module1.exports = diff;
            /*
 * Modify a diff such that the cursor position points to the start of a change:
 * E.g.
 *   cursor_normalize_diff([[DIFF_EQUAL, 'abc']], 1)
 *     => [1, [[DIFF_EQUAL, 'a'], [DIFF_EQUAL, 'bc']]]
 *   cursor_normalize_diff([[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xyz']], 2)
 *     => [2, [[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xy'], [DIFF_DELETE, 'z']]]
 *
 * @param {Array} diffs Array of diff tuples
 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
 * @return {Array} A tuple [cursor location in the modified diff, modified diff]
 */ function cursor_normalize_diff(diffs, cursor_pos) {
                if (cursor_pos === 0) return [
                    DIFF_EQUAL,
                    diffs
                ];
                for(var current_pos = 0, i = 0; i < diffs.length; i++){
                    var d = diffs[i];
                    if (d[0] === DIFF_DELETE || d[0] === DIFF_EQUAL) {
                        var next_pos = current_pos + d[1].length;
                        if (cursor_pos === next_pos) return [
                            i + 1,
                            diffs
                        ];
                        else if (cursor_pos < next_pos) {
                            // copy to prevent side effects
                            diffs = diffs.slice();
                            // split d into two diff changes
                            var split_pos = cursor_pos - current_pos;
                            var d_left = [
                                d[0],
                                d[1].slice(0, split_pos)
                            ];
                            var d_right = [
                                d[0],
                                d[1].slice(split_pos)
                            ];
                            diffs.splice(i, 1, d_left, d_right);
                            return [
                                i + 1,
                                diffs
                            ];
                        } else current_pos = next_pos;
                    }
                }
                throw new Error("cursor_pos is out of bounds!");
            }
            /*
 * Modify a diff such that the edit position is "shifted" to the proposed edit location (cursor_position).
 *
 * Case 1)
 *   Check if a naive shift is possible:
 *     [0, X], [ 1, Y] -> [ 1, Y], [0, X]    (if X + Y === Y + X)
 *     [0, X], [-1, Y] -> [-1, Y], [0, X]    (if X + Y === Y + X) - holds same result
 * Case 2)
 *   Check if the following shifts are possible:
 *     [0, 'pre'], [ 1, 'prefix'] -> [ 1, 'pre'], [0, 'pre'], [ 1, 'fix']
 *     [0, 'pre'], [-1, 'prefix'] -> [-1, 'pre'], [0, 'pre'], [-1, 'fix']
 *         ^            ^
 *         d          d_next
 *
 * @param {Array} diffs Array of diff tuples
 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
 * @return {Array} Array of diff tuples
 */ function fix_cursor(diffs, cursor_pos) {
                var norm = cursor_normalize_diff(diffs, cursor_pos);
                var ndiffs = norm[1];
                var cursor_pointer = norm[0];
                var d = ndiffs[cursor_pointer];
                var d_next = ndiffs[cursor_pointer + 1];
                if (d == null) // Text was deleted from end of original string,
                // cursor is now out of bounds in new string
                return diffs;
                else if (d[0] !== DIFF_EQUAL) // A modification happened at the cursor location.
                // This is the expected outcome, so we can return the original diff.
                return diffs;
                else {
                    if (d_next != null && d[1] + d_next[1] === d_next[1] + d[1]) {
                        // Case 1)
                        // It is possible to perform a naive shift
                        ndiffs.splice(cursor_pointer, 2, d_next, d);
                        return merge_tuples(ndiffs, cursor_pointer, 2);
                    } else if (d_next != null && d_next[1].indexOf(d[1]) === 0) {
                        // Case 2)
                        // d[1] is a prefix of d_next[1]
                        // We can assume that d_next[0] !== 0, since d[0] === 0
                        // Shift edit locations..
                        ndiffs.splice(cursor_pointer, 2, [
                            d_next[0],
                            d[1]
                        ], [
                            0,
                            d[1]
                        ]);
                        var suffix = d_next[1].slice(d[1].length);
                        if (suffix.length > 0) ndiffs.splice(cursor_pointer + 2, 0, [
                            d_next[0],
                            suffix
                        ]);
                        return merge_tuples(ndiffs, cursor_pointer, 3);
                    } else // Not possible to perform any modification
                    return diffs;
                }
            }
            /*
 * Check diff did not split surrogate pairs.
 * Ex. [0, '\uD83D'], [-1, '\uDC36'], [1, '\uDC2F'] -> [-1, '\uD83D\uDC36'], [1, '\uD83D\uDC2F']
 *     '\uD83D\uDC36' === '🐶', '\uD83D\uDC2F' === '🐯'
 *
 * @param {Array} diffs Array of diff tuples
 * @return {Array} Array of diff tuples
 */ function fix_emoji(diffs) {
                var compact = false;
                var starts_with_pair_end = function(str) {
                    return str.charCodeAt(0) >= 0xDC00 && str.charCodeAt(0) <= 0xDFFF;
                };
                var ends_with_pair_start = function(str) {
                    return str.charCodeAt(str.length - 1) >= 0xD800 && str.charCodeAt(str.length - 1) <= 0xDBFF;
                };
                for(var i = 2; i < diffs.length; i += 1)if (diffs[i - 2][0] === DIFF_EQUAL && ends_with_pair_start(diffs[i - 2][1]) && diffs[i - 1][0] === DIFF_DELETE && starts_with_pair_end(diffs[i - 1][1]) && diffs[i][0] === DIFF_INSERT && starts_with_pair_end(diffs[i][1])) {
                    compact = true;
                    diffs[i - 1][1] = diffs[i - 2][1].slice(-1) + diffs[i - 1][1];
                    diffs[i][1] = diffs[i - 2][1].slice(-1) + diffs[i][1];
                    diffs[i - 2][1] = diffs[i - 2][1].slice(0, -1);
                }
                if (!compact) return diffs;
                var fixed_diffs = [];
                for(var i = 0; i < diffs.length; i += 1)if (diffs[i][1].length > 0) fixed_diffs.push(diffs[i]);
                return fixed_diffs;
            }
            /*
 * Try to merge tuples with their neigbors in a given range.
 * E.g. [0, 'a'], [0, 'b'] -> [0, 'ab']
 *
 * @param {Array} diffs Array of diff tuples.
 * @param {Int} start Position of the first element to merge (diffs[start] is also merged with diffs[start - 1]).
 * @param {Int} length Number of consecutive elements to check.
 * @return {Array} Array of merged diff tuples.
 */ function merge_tuples(diffs, start, length) {
                // Check from (start-1) to (start+length).
                for(var i = start + length - 1; i >= 0 && i >= start - 1; i--)if (i + 1 < diffs.length) {
                    var left_d = diffs[i];
                    var right_d = diffs[i + 1];
                    if (left_d[0] === right_d[1]) diffs.splice(i, 2, [
                        left_d[0],
                        left_d[1] + right_d[1]
                    ]);
                }
                return diffs;
            }
        /***/ },
        /* 52 */ /***/ function(module1, exports) {
            exports = module1.exports = typeof Object.keys === "function" ? Object.keys : shim;
            exports.shim = shim;
            function shim(obj) {
                var keys = [];
                for(var key in obj)keys.push(key);
                return keys;
            }
        /***/ },
        /* 53 */ /***/ function(module1, exports) {
            var supportsArgumentsClass = function() {
                return Object.prototype.toString.call(arguments);
            }() == "[object Arguments]";
            exports = module1.exports = supportsArgumentsClass ? supported : unsupported;
            exports.supported = supported;
            function supported(object) {
                return Object.prototype.toString.call(object) == "[object Arguments]";
            }
            exports.unsupported = unsupported;
            function unsupported(object) {
                return object && typeof object == "object" && typeof object.length == "number" && Object.prototype.hasOwnProperty.call(object, "callee") && !Object.prototype.propertyIsEnumerable.call(object, "callee") || false;
            }
        /***/ },
        /* 54 */ /***/ function(module1, exports) {
            "use strict";
            var has = Object.prototype.hasOwnProperty, prefix = "~";
            /**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @api private
 */ function Events() {}
            //
            // We try to not inherit from `Object.prototype`. In some engines creating an
            // instance in this way is faster than calling `Object.create(null)` directly.
            // If `Object.create(null)` is not supported we prefix the event names with a
            // character to make sure that the built-in object properties are not
            // overridden or used as an attack vector.
            //
            if (Object.create) {
                Events.prototype = Object.create(null);
                //
                // This hack is needed because the `__proto__` property is still inherited in
                // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
                //
                if (!new Events().__proto__) prefix = false;
            }
            /**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {Mixed} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @api private
 */ function EE(fn, context, once) {
                this.fn = fn;
                this.context = context;
                this.once = once || false;
            }
            /**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @api public
 */ function EventEmitter() {
                this._events = new Events();
                this._eventsCount = 0;
            }
            /**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */ EventEmitter.prototype.eventNames = function eventNames() {
                var names = [], events, name;
                if (this._eventsCount === 0) return names;
                for(name in events = this._events)if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
                if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
                return names;
            };
            /**
 * Return the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Boolean} exists Only check if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */ EventEmitter.prototype.listeners = function listeners(event, exists) {
                var evt = prefix ? prefix + event : event, available = this._events[evt];
                if (exists) return !!available;
                if (!available) return [];
                if (available.fn) return [
                    available.fn
                ];
                for(var i = 0, l = available.length, ee = new Array(l); i < l; i++)ee[i] = available[i].fn;
                return ee;
            };
            /**
 * Calls each of the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @api public
 */ EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
                var evt = prefix ? prefix + event : event;
                if (!this._events[evt]) return false;
                var listeners = this._events[evt], len = arguments.length, args, i;
                if (listeners.fn) {
                    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
                    switch(len){
                        case 1:
                            return listeners.fn.call(listeners.context), true;
                        case 2:
                            return listeners.fn.call(listeners.context, a1), true;
                        case 3:
                            return listeners.fn.call(listeners.context, a1, a2), true;
                        case 4:
                            return listeners.fn.call(listeners.context, a1, a2, a3), true;
                        case 5:
                            return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
                        case 6:
                            return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
                    }
                    for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
                    listeners.fn.apply(listeners.context, args);
                } else {
                    var length = listeners.length, j;
                    for(i = 0; i < length; i++){
                        if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
                        switch(len){
                            case 1:
                                listeners[i].fn.call(listeners[i].context);
                                break;
                            case 2:
                                listeners[i].fn.call(listeners[i].context, a1);
                                break;
                            case 3:
                                listeners[i].fn.call(listeners[i].context, a1, a2);
                                break;
                            case 4:
                                listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                                break;
                            default:
                                if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                                listeners[i].fn.apply(listeners[i].context, args);
                        }
                    }
                }
                return true;
            };
            /**
 * Add a listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */ EventEmitter.prototype.on = function on(event, fn, context) {
                var listener = new EE(fn, context || this), evt = prefix ? prefix + event : event;
                if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
                else if (!this._events[evt].fn) this._events[evt].push(listener);
                else this._events[evt] = [
                    this._events[evt],
                    listener
                ];
                return this;
            };
            /**
 * Add a one-time listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */ EventEmitter.prototype.once = function once(event, fn, context) {
                var listener = new EE(fn, context || this, true), evt = prefix ? prefix + event : event;
                if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
                else if (!this._events[evt].fn) this._events[evt].push(listener);
                else this._events[evt] = [
                    this._events[evt],
                    listener
                ];
                return this;
            };
            /**
 * Remove the listeners of a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {Mixed} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @api public
 */ EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
                var evt = prefix ? prefix + event : event;
                if (!this._events[evt]) return this;
                if (!fn) {
                    if (--this._eventsCount === 0) this._events = new Events();
                    else delete this._events[evt];
                    return this;
                }
                var listeners = this._events[evt];
                if (listeners.fn) {
                    if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) {
                        if (--this._eventsCount === 0) this._events = new Events();
                        else delete this._events[evt];
                    }
                } else {
                    for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
                    //
                    // Reset the array, or remove it completely if we have no more listeners.
                    //
                    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
                    else if (--this._eventsCount === 0) this._events = new Events();
                    else delete this._events[evt];
                }
                return this;
            };
            /**
 * Remove all listeners, or those of the specified event.
 *
 * @param {String|Symbol} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @api public
 */ EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
                var evt;
                if (event) {
                    evt = prefix ? prefix + event : event;
                    if (this._events[evt]) {
                        if (--this._eventsCount === 0) this._events = new Events();
                        else delete this._events[evt];
                    }
                } else {
                    this._events = new Events();
                    this._eventsCount = 0;
                }
                return this;
            };
            //
            // Alias methods names because people roll like that.
            //
            EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
            EventEmitter.prototype.addListener = EventEmitter.prototype.on;
            //
            // This function doesn't apply anymore.
            //
            EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
                return this;
            };
            //
            // Expose the prefix.
            //
            EventEmitter.prefixed = prefix;
            //
            // Allow `EventEmitter` to be imported as module namespace.
            //
            EventEmitter.EventEmitter = EventEmitter;
            //
            // Expose the module.
            //
            if ("undefined" !== typeof module1) module1.exports = EventEmitter;
        /***/ },
        /* 55 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.matchText = exports.matchSpacing = exports.matchNewline = exports.matchBlot = exports.matchAttributor = exports.default = undefined;
            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _extend2 = __webpack_require__(3);
            var _extend3 = _interopRequireDefault(_extend2);
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _logger = __webpack_require__(10);
            var _logger2 = _interopRequireDefault(_logger);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            var _align = __webpack_require__(36);
            var _background = __webpack_require__(37);
            var _code = __webpack_require__(13);
            var _code2 = _interopRequireDefault(_code);
            var _color = __webpack_require__(26);
            var _direction = __webpack_require__(38);
            var _font = __webpack_require__(39);
            var _size = __webpack_require__(40);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var debug = (0, _logger2.default)("quill:clipboard");
            var DOM_KEY = "__ql-matcher";
            var CLIPBOARD_CONFIG = [
                [
                    Node.TEXT_NODE,
                    matchText
                ],
                [
                    Node.TEXT_NODE,
                    matchNewline
                ],
                [
                    "br",
                    matchBreak
                ],
                [
                    Node.ELEMENT_NODE,
                    matchNewline
                ],
                [
                    Node.ELEMENT_NODE,
                    matchBlot
                ],
                [
                    Node.ELEMENT_NODE,
                    matchSpacing
                ],
                [
                    Node.ELEMENT_NODE,
                    matchAttributor
                ],
                [
                    Node.ELEMENT_NODE,
                    matchStyles
                ],
                [
                    "li",
                    matchIndent
                ],
                [
                    "b",
                    matchAlias.bind(matchAlias, "bold")
                ],
                [
                    "i",
                    matchAlias.bind(matchAlias, "italic")
                ],
                [
                    "style",
                    matchIgnore
                ]
            ];
            var ATTRIBUTE_ATTRIBUTORS = [
                _align.AlignAttribute,
                _direction.DirectionAttribute
            ].reduce(function(memo, attr) {
                memo[attr.keyName] = attr;
                return memo;
            }, {});
            var STYLE_ATTRIBUTORS = [
                _align.AlignStyle,
                _background.BackgroundStyle,
                _color.ColorStyle,
                _direction.DirectionStyle,
                _font.FontStyle,
                _size.SizeStyle
            ].reduce(function(memo, attr) {
                memo[attr.keyName] = attr;
                return memo;
            }, {});
            var Clipboard = function(_Module) {
                _inherits(Clipboard, _Module);
                function Clipboard(quill, options) {
                    _classCallCheck(this, Clipboard);
                    var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this, quill, options));
                    _this.quill.root.addEventListener("paste", _this.onPaste.bind(_this));
                    _this.container = _this.quill.addContainer("ql-clipboard");
                    _this.container.setAttribute("contenteditable", true);
                    _this.container.setAttribute("tabindex", -1);
                    _this.matchers = [];
                    CLIPBOARD_CONFIG.concat(_this.options.matchers).forEach(function(_ref) {
                        var _ref2 = _slicedToArray(_ref, 2), selector = _ref2[0], matcher = _ref2[1];
                        if (!options.matchVisual && matcher === matchSpacing) return;
                        _this.addMatcher(selector, matcher);
                    });
                    return _this;
                }
                _createClass(Clipboard, [
                    {
                        key: "addMatcher",
                        value: function addMatcher(selector, matcher) {
                            this.matchers.push([
                                selector,
                                matcher
                            ]);
                        }
                    },
                    {
                        key: "convert",
                        value: function convert(html) {
                            if (typeof html === "string") {
                                this.container.innerHTML = html.replace(/\>\r?\n +\</g, "><"); // Remove spaces between tags
                                return this.convert();
                            }
                            var formats = this.quill.getFormat(this.quill.selection.savedRange.index);
                            if (formats[_code2.default.blotName]) {
                                var text = this.container.innerText;
                                this.container.innerHTML = "";
                                return new _quillDelta2.default().insert(text, _defineProperty({}, _code2.default.blotName, formats[_code2.default.blotName]));
                            }
                            var _prepareMatching = this.prepareMatching(), _prepareMatching2 = _slicedToArray(_prepareMatching, 2), elementMatchers = _prepareMatching2[0], textMatchers = _prepareMatching2[1];
                            var delta = traverse(this.container, elementMatchers, textMatchers);
                            // Remove trailing newline
                            if (deltaEndsWith(delta, "\n") && delta.ops[delta.ops.length - 1].attributes == null) delta = delta.compose(new _quillDelta2.default().retain(delta.length() - 1).delete(1));
                            debug.log("convert", this.container.innerHTML, delta);
                            this.container.innerHTML = "";
                            return delta;
                        }
                    },
                    {
                        key: "dangerouslyPasteHTML",
                        value: function dangerouslyPasteHTML(index, html) {
                            var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _quill2.default.sources.API;
                            if (typeof index === "string") {
                                this.quill.setContents(this.convert(index), html);
                                this.quill.setSelection(0, _quill2.default.sources.SILENT);
                            } else {
                                var paste = this.convert(html);
                                this.quill.updateContents(new _quillDelta2.default().retain(index).concat(paste), source);
                                this.quill.setSelection(index + paste.length(), _quill2.default.sources.SILENT);
                            }
                        }
                    },
                    {
                        key: "onPaste",
                        value: function onPaste(e) {
                            var _this2 = this;
                            if (e.defaultPrevented || !this.quill.isEnabled()) return;
                            var range = this.quill.getSelection();
                            var delta = new _quillDelta2.default().retain(range.index);
                            var scrollTop = this.quill.scrollingContainer.scrollTop;
                            this.container.focus();
                            this.quill.selection.update(_quill2.default.sources.SILENT);
                            setTimeout(function() {
                                delta = delta.concat(_this2.convert()).delete(range.length);
                                _this2.quill.updateContents(delta, _quill2.default.sources.USER);
                                // range.length contributes to delta.length()
                                _this2.quill.setSelection(delta.length() - range.length, _quill2.default.sources.SILENT);
                                _this2.quill.scrollingContainer.scrollTop = scrollTop;
                                _this2.quill.focus();
                            }, 1);
                        }
                    },
                    {
                        key: "prepareMatching",
                        value: function prepareMatching() {
                            var _this3 = this;
                            var elementMatchers = [], textMatchers = [];
                            this.matchers.forEach(function(pair) {
                                var _pair = _slicedToArray(pair, 2), selector = _pair[0], matcher = _pair[1];
                                switch(selector){
                                    case Node.TEXT_NODE:
                                        textMatchers.push(matcher);
                                        break;
                                    case Node.ELEMENT_NODE:
                                        elementMatchers.push(matcher);
                                        break;
                                    default:
                                        [].forEach.call(_this3.container.querySelectorAll(selector), function(node) {
                                            // TODO use weakmap
                                            node[DOM_KEY] = node[DOM_KEY] || [];
                                            node[DOM_KEY].push(matcher);
                                        });
                                        break;
                                }
                            });
                            return [
                                elementMatchers,
                                textMatchers
                            ];
                        }
                    }
                ]);
                return Clipboard;
            }(_module2.default);
            Clipboard.DEFAULTS = {
                matchers: [],
                matchVisual: true
            };
            function applyFormat(delta, format, value) {
                if ((typeof format === "undefined" ? "undefined" : _typeof(format)) === "object") return Object.keys(format).reduce(function(delta, key) {
                    return applyFormat(delta, key, format[key]);
                }, delta);
                else return delta.reduce(function(delta, op) {
                    if (op.attributes && op.attributes[format]) return delta.push(op);
                    else return delta.insert(op.insert, (0, _extend3.default)({}, _defineProperty({}, format, value), op.attributes));
                }, new _quillDelta2.default());
            }
            function computeStyle(node) {
                if (node.nodeType !== Node.ELEMENT_NODE) return {};
                var DOM_KEY = "__ql-computed-style";
                return node[DOM_KEY] || (node[DOM_KEY] = window.getComputedStyle(node));
            }
            function deltaEndsWith(delta, text) {
                var endText = "";
                for(var i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i){
                    var op = delta.ops[i];
                    if (typeof op.insert !== "string") break;
                    endText = op.insert + endText;
                }
                return endText.slice(-1 * text.length) === text;
            }
            function isLine(node) {
                if (node.childNodes.length === 0) return false; // Exclude embed blocks
                var style = computeStyle(node);
                return [
                    "block",
                    "list-item"
                ].indexOf(style.display) > -1;
            }
            function traverse(node, elementMatchers, textMatchers) {
                // Post-order
                if (node.nodeType === node.TEXT_NODE) return textMatchers.reduce(function(delta, matcher) {
                    return matcher(node, delta);
                }, new _quillDelta2.default());
                else if (node.nodeType === node.ELEMENT_NODE) return [].reduce.call(node.childNodes || [], function(delta, childNode) {
                    var childrenDelta = traverse(childNode, elementMatchers, textMatchers);
                    if (childNode.nodeType === node.ELEMENT_NODE) {
                        childrenDelta = elementMatchers.reduce(function(childrenDelta, matcher) {
                            return matcher(childNode, childrenDelta);
                        }, childrenDelta);
                        childrenDelta = (childNode[DOM_KEY] || []).reduce(function(childrenDelta, matcher) {
                            return matcher(childNode, childrenDelta);
                        }, childrenDelta);
                    }
                    return delta.concat(childrenDelta);
                }, new _quillDelta2.default());
                else return new _quillDelta2.default();
            }
            function matchAlias(format, node, delta) {
                return applyFormat(delta, format, true);
            }
            function matchAttributor(node, delta) {
                var attributes = _parchment2.default.Attributor.Attribute.keys(node);
                var classes = _parchment2.default.Attributor.Class.keys(node);
                var styles = _parchment2.default.Attributor.Style.keys(node);
                var formats = {};
                attributes.concat(classes).concat(styles).forEach(function(name) {
                    var attr = _parchment2.default.query(name, _parchment2.default.Scope.ATTRIBUTE);
                    if (attr != null) {
                        formats[attr.attrName] = attr.value(node);
                        if (formats[attr.attrName]) return;
                    }
                    attr = ATTRIBUTE_ATTRIBUTORS[name];
                    if (attr != null && (attr.attrName === name || attr.keyName === name)) formats[attr.attrName] = attr.value(node) || undefined;
                    attr = STYLE_ATTRIBUTORS[name];
                    if (attr != null && (attr.attrName === name || attr.keyName === name)) {
                        attr = STYLE_ATTRIBUTORS[name];
                        formats[attr.attrName] = attr.value(node) || undefined;
                    }
                });
                if (Object.keys(formats).length > 0) delta = applyFormat(delta, formats);
                return delta;
            }
            function matchBlot(node, delta) {
                var match = _parchment2.default.query(node);
                if (match == null) return delta;
                if (match.prototype instanceof _parchment2.default.Embed) {
                    var embed = {};
                    var value = match.value(node);
                    if (value != null) {
                        embed[match.blotName] = value;
                        delta = new _quillDelta2.default().insert(embed, match.formats(node));
                    }
                } else if (typeof match.formats === "function") delta = applyFormat(delta, match.blotName, match.formats(node));
                return delta;
            }
            function matchBreak(node, delta) {
                if (!deltaEndsWith(delta, "\n")) delta.insert("\n");
                return delta;
            }
            function matchIgnore() {
                return new _quillDelta2.default();
            }
            function matchIndent(node, delta) {
                var match = _parchment2.default.query(node);
                if (match == null || match.blotName !== "list-item" || !deltaEndsWith(delta, "\n")) return delta;
                var indent = -1, parent = node.parentNode;
                while(!parent.classList.contains("ql-clipboard")){
                    if ((_parchment2.default.query(parent) || {}).blotName === "list") indent += 1;
                    parent = parent.parentNode;
                }
                if (indent <= 0) return delta;
                return delta.compose(new _quillDelta2.default().retain(delta.length() - 1).retain(1, {
                    indent: indent
                }));
            }
            function matchNewline(node, delta) {
                if (!deltaEndsWith(delta, "\n")) {
                    if (isLine(node) || delta.length() > 0 && node.nextSibling && isLine(node.nextSibling)) delta.insert("\n");
                }
                return delta;
            }
            function matchSpacing(node, delta) {
                if (isLine(node) && node.nextElementSibling != null && !deltaEndsWith(delta, "\n\n")) {
                    var nodeHeight = node.offsetHeight + parseFloat(computeStyle(node).marginTop) + parseFloat(computeStyle(node).marginBottom);
                    if (node.nextElementSibling.offsetTop > node.offsetTop + nodeHeight * 1.5) delta.insert("\n");
                }
                return delta;
            }
            function matchStyles(node, delta) {
                var formats = {};
                var style = node.style || {};
                if (style.fontStyle && computeStyle(node).fontStyle === "italic") formats.italic = true;
                if (style.fontWeight && (computeStyle(node).fontWeight.startsWith("bold") || parseInt(computeStyle(node).fontWeight) >= 700)) formats.bold = true;
                if (Object.keys(formats).length > 0) delta = applyFormat(delta, formats);
                if (parseFloat(style.textIndent || 0) > 0) // Could be 0.5in
                delta = new _quillDelta2.default().insert("	").concat(delta);
                return delta;
            }
            function matchText(node, delta) {
                var text = node.data;
                // Word represents empty line with <o:p>&nbsp;</o:p>
                if (node.parentNode.tagName === "O:P") return delta.insert(text.trim());
                if (text.trim().length === 0 && node.parentNode.classList.contains("ql-clipboard")) return delta;
                if (!computeStyle(node.parentNode).whiteSpace.startsWith("pre")) {
                    // eslint-disable-next-line func-style
                    var replacer = function replacer(collapse, match) {
                        match = match.replace(/[^\u00a0]/g, ""); // \u00a0 is nbsp;
                        return match.length < 1 && collapse ? " " : match;
                    };
                    text = text.replace(/\r\n/g, " ").replace(/\n/g, " ");
                    text = text.replace(/\s\s+/g, replacer.bind(replacer, true)); // collapse whitespace
                    if (node.previousSibling == null && isLine(node.parentNode) || node.previousSibling != null && isLine(node.previousSibling)) text = text.replace(/^\s+/, replacer.bind(replacer, false));
                    if (node.nextSibling == null && isLine(node.parentNode) || node.nextSibling != null && isLine(node.nextSibling)) text = text.replace(/\s+$/, replacer.bind(replacer, false));
                }
                return delta.insert(text);
            }
            exports.default = Clipboard;
            exports.matchAttributor = matchAttributor;
            exports.matchBlot = matchBlot;
            exports.matchNewline = matchNewline;
            exports.matchSpacing = matchSpacing;
            exports.matchText = matchText;
        /***/ },
        /* 56 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Bold = function(_Inline) {
                _inherits(Bold, _Inline);
                function Bold() {
                    _classCallCheck(this, Bold);
                    return _possibleConstructorReturn(this, (Bold.__proto__ || Object.getPrototypeOf(Bold)).apply(this, arguments));
                }
                _createClass(Bold, [
                    {
                        key: "optimize",
                        value: function optimize(context) {
                            _get(Bold.prototype.__proto__ || Object.getPrototypeOf(Bold.prototype), "optimize", this).call(this, context);
                            if (this.domNode.tagName !== this.statics.tagName[0]) this.replaceWith(this.statics.blotName);
                        }
                    }
                ], [
                    {
                        key: "create",
                        value: function create() {
                            return _get(Bold.__proto__ || Object.getPrototypeOf(Bold), "create", this).call(this);
                        }
                    },
                    {
                        key: "formats",
                        value: function formats() {
                            return true;
                        }
                    }
                ]);
                return Bold;
            }(_inline2.default);
            Bold.blotName = "bold";
            Bold.tagName = [
                "STRONG",
                "B"
            ];
            exports.default = Bold;
        /***/ },
        /* 57 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.addControls = exports.default = undefined;
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _logger = __webpack_require__(10);
            var _logger2 = _interopRequireDefault(_logger);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var debug = (0, _logger2.default)("quill:toolbar");
            var Toolbar = function(_Module) {
                _inherits(Toolbar, _Module);
                function Toolbar(quill, options) {
                    _classCallCheck(this, Toolbar);
                    var _this = _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).call(this, quill, options));
                    if (Array.isArray(_this.options.container)) {
                        var container = document.createElement("div");
                        addControls(container, _this.options.container);
                        quill.container.parentNode.insertBefore(container, quill.container);
                        _this.container = container;
                    } else if (typeof _this.options.container === "string") _this.container = document.querySelector(_this.options.container);
                    else _this.container = _this.options.container;
                    if (!(_this.container instanceof HTMLElement)) {
                        var _ret;
                        return _ret = debug.error("Container required for toolbar", _this.options), _possibleConstructorReturn(_this, _ret);
                    }
                    _this.container.classList.add("ql-toolbar");
                    _this.controls = [];
                    _this.handlers = {};
                    Object.keys(_this.options.handlers).forEach(function(format) {
                        _this.addHandler(format, _this.options.handlers[format]);
                    });
                    [].forEach.call(_this.container.querySelectorAll("button, select"), function(input) {
                        _this.attach(input);
                    });
                    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function(type, range) {
                        if (type === _quill2.default.events.SELECTION_CHANGE) _this.update(range);
                    });
                    _this.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function() {
                        var _this$quill$selection = _this.quill.selection.getRange(), _this$quill$selection2 = _slicedToArray(_this$quill$selection, 1), range = _this$quill$selection2[0]; // quill.getSelection triggers update
                        _this.update(range);
                    });
                    return _this;
                }
                _createClass(Toolbar, [
                    {
                        key: "addHandler",
                        value: function addHandler(format, handler) {
                            this.handlers[format] = handler;
                        }
                    },
                    {
                        key: "attach",
                        value: function attach(input) {
                            var _this2 = this;
                            var format = [].find.call(input.classList, function(className) {
                                return className.indexOf("ql-") === 0;
                            });
                            if (!format) return;
                            format = format.slice(3);
                            if (input.tagName === "BUTTON") input.setAttribute("type", "button");
                            if (this.handlers[format] == null) {
                                if (this.quill.scroll.whitelist != null && this.quill.scroll.whitelist[format] == null) {
                                    debug.warn("ignoring attaching to disabled format", format, input);
                                    return;
                                }
                                if (_parchment2.default.query(format) == null) {
                                    debug.warn("ignoring attaching to nonexistent format", format, input);
                                    return;
                                }
                            }
                            var eventName = input.tagName === "SELECT" ? "change" : "click";
                            input.addEventListener(eventName, function(e) {
                                var value = void 0;
                                if (input.tagName === "SELECT") {
                                    if (input.selectedIndex < 0) return;
                                    var selected = input.options[input.selectedIndex];
                                    if (selected.hasAttribute("selected")) value = false;
                                    else value = selected.value || false;
                                } else {
                                    if (input.classList.contains("ql-active")) value = false;
                                    else value = input.value || !input.hasAttribute("value");
                                    e.preventDefault();
                                }
                                _this2.quill.focus();
                                var _quill$selection$getR = _this2.quill.selection.getRange(), _quill$selection$getR2 = _slicedToArray(_quill$selection$getR, 1), range = _quill$selection$getR2[0];
                                if (_this2.handlers[format] != null) _this2.handlers[format].call(_this2, value);
                                else if (_parchment2.default.query(format).prototype instanceof _parchment2.default.Embed) {
                                    value = prompt("Enter " + format);
                                    if (!value) return;
                                    _this2.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert(_defineProperty({}, format, value)), _quill2.default.sources.USER);
                                } else _this2.quill.format(format, value, _quill2.default.sources.USER);
                                _this2.update(range);
                            });
                            // TODO use weakmap
                            this.controls.push([
                                format,
                                input
                            ]);
                        }
                    },
                    {
                        key: "update",
                        value: function update(range) {
                            var formats = range == null ? {} : this.quill.getFormat(range);
                            this.controls.forEach(function(pair) {
                                var _pair = _slicedToArray(pair, 2), format = _pair[0], input = _pair[1];
                                if (input.tagName === "SELECT") {
                                    var option = void 0;
                                    if (range == null) option = null;
                                    else if (formats[format] == null) option = input.querySelector("option[selected]");
                                    else if (!Array.isArray(formats[format])) {
                                        var value = formats[format];
                                        if (typeof value === "string") value = value.replace(/\"/g, '\\"');
                                        option = input.querySelector('option[value="' + value + '"]');
                                    }
                                    if (option == null) {
                                        input.value = ""; // TODO make configurable?
                                        input.selectedIndex = -1;
                                    } else option.selected = true;
                                } else {
                                    if (range == null) input.classList.remove("ql-active");
                                    else if (input.hasAttribute("value")) {
                                        // both being null should match (default values)
                                        // '1' should match with 1 (headers)
                                        var isActive = formats[format] === input.getAttribute("value") || formats[format] != null && formats[format].toString() === input.getAttribute("value") || formats[format] == null && !input.getAttribute("value");
                                        input.classList.toggle("ql-active", isActive);
                                    } else input.classList.toggle("ql-active", formats[format] != null);
                                }
                            });
                        }
                    }
                ]);
                return Toolbar;
            }(_module2.default);
            Toolbar.DEFAULTS = {};
            function addButton(container, format, value) {
                var input = document.createElement("button");
                input.setAttribute("type", "button");
                input.classList.add("ql-" + format);
                if (value != null) input.value = value;
                container.appendChild(input);
            }
            function addControls(container, groups) {
                if (!Array.isArray(groups[0])) groups = [
                    groups
                ];
                groups.forEach(function(controls) {
                    var group = document.createElement("span");
                    group.classList.add("ql-formats");
                    controls.forEach(function(control) {
                        if (typeof control === "string") addButton(group, control);
                        else {
                            var format = Object.keys(control)[0];
                            var value = control[format];
                            if (Array.isArray(value)) addSelect(group, format, value);
                            else addButton(group, format, value);
                        }
                    });
                    container.appendChild(group);
                });
            }
            function addSelect(container, format, values) {
                var input = document.createElement("select");
                input.classList.add("ql-" + format);
                values.forEach(function(value) {
                    var option = document.createElement("option");
                    if (value !== false) option.setAttribute("value", value);
                    else option.setAttribute("selected", "selected");
                    input.appendChild(option);
                });
                container.appendChild(input);
            }
            Toolbar.DEFAULTS = {
                container: null,
                handlers: {
                    clean: function clean() {
                        var _this3 = this;
                        var range = this.quill.getSelection();
                        if (range == null) return;
                        if (range.length == 0) {
                            var formats = this.quill.getFormat();
                            Object.keys(formats).forEach(function(name) {
                                // Clean functionality in existing apps only clean inline formats
                                if (_parchment2.default.query(name, _parchment2.default.Scope.INLINE) != null) _this3.quill.format(name, false);
                            });
                        } else this.quill.removeFormat(range, _quill2.default.sources.USER);
                    },
                    direction: function direction(value) {
                        var align = this.quill.getFormat()["align"];
                        if (value === "rtl" && align == null) this.quill.format("align", "right", _quill2.default.sources.USER);
                        else if (!value && align === "right") this.quill.format("align", false, _quill2.default.sources.USER);
                        this.quill.format("direction", value, _quill2.default.sources.USER);
                    },
                    indent: function indent(value) {
                        var range = this.quill.getSelection();
                        var formats = this.quill.getFormat(range);
                        var indent = parseInt(formats.indent || 0);
                        if (value === "+1" || value === "-1") {
                            var modifier = value === "+1" ? 1 : -1;
                            if (formats.direction === "rtl") modifier *= -1;
                            this.quill.format("indent", indent + modifier, _quill2.default.sources.USER);
                        }
                    },
                    link: function link(value) {
                        if (value === true) value = prompt("Enter link URL:");
                        this.quill.format("link", value, _quill2.default.sources.USER);
                    },
                    list: function list(value) {
                        var range = this.quill.getSelection();
                        var formats = this.quill.getFormat(range);
                        if (value === "check") {
                            if (formats["list"] === "checked" || formats["list"] === "unchecked") this.quill.format("list", false, _quill2.default.sources.USER);
                            else this.quill.format("list", "unchecked", _quill2.default.sources.USER);
                        } else this.quill.format("list", value, _quill2.default.sources.USER);
                    }
                }
            };
            exports.default = Toolbar;
            exports.addControls = addControls;
        /***/ },
        /* 58 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <polyline class="ql-even ql-stroke" points="5 7 3 9 5 11"></polyline> <polyline class="ql-even ql-stroke" points="13 7 15 9 13 11"></polyline> <line class=ql-stroke x1=10 x2=8 y1=5 y2=13></line> </svg>';
        /***/ },
        /* 59 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _picker = __webpack_require__(28);
            var _picker2 = _interopRequireDefault(_picker);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var ColorPicker = function(_Picker) {
                _inherits(ColorPicker, _Picker);
                function ColorPicker(select, label) {
                    _classCallCheck(this, ColorPicker);
                    var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this, select));
                    _this.label.innerHTML = label;
                    _this.container.classList.add("ql-color-picker");
                    [].slice.call(_this.container.querySelectorAll(".ql-picker-item"), 0, 7).forEach(function(item) {
                        item.classList.add("ql-primary");
                    });
                    return _this;
                }
                _createClass(ColorPicker, [
                    {
                        key: "buildItem",
                        value: function buildItem(option) {
                            var item = _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), "buildItem", this).call(this, option);
                            item.style.backgroundColor = option.getAttribute("value") || "";
                            return item;
                        }
                    },
                    {
                        key: "selectItem",
                        value: function selectItem(item, trigger) {
                            _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), "selectItem", this).call(this, item, trigger);
                            var colorLabel = this.label.querySelector(".ql-color-label");
                            var value = item ? item.getAttribute("data-value") || "" : "";
                            if (colorLabel) {
                                if (colorLabel.tagName === "line") colorLabel.style.stroke = value;
                                else colorLabel.style.fill = value;
                            }
                        }
                    }
                ]);
                return ColorPicker;
            }(_picker2.default);
            exports.default = ColorPicker;
        /***/ },
        /* 60 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _picker = __webpack_require__(28);
            var _picker2 = _interopRequireDefault(_picker);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var IconPicker = function(_Picker) {
                _inherits(IconPicker, _Picker);
                function IconPicker(select, icons) {
                    _classCallCheck(this, IconPicker);
                    var _this = _possibleConstructorReturn(this, (IconPicker.__proto__ || Object.getPrototypeOf(IconPicker)).call(this, select));
                    _this.container.classList.add("ql-icon-picker");
                    [].forEach.call(_this.container.querySelectorAll(".ql-picker-item"), function(item) {
                        item.innerHTML = icons[item.getAttribute("data-value") || ""];
                    });
                    _this.defaultItem = _this.container.querySelector(".ql-selected");
                    _this.selectItem(_this.defaultItem);
                    return _this;
                }
                _createClass(IconPicker, [
                    {
                        key: "selectItem",
                        value: function selectItem(item, trigger) {
                            _get(IconPicker.prototype.__proto__ || Object.getPrototypeOf(IconPicker.prototype), "selectItem", this).call(this, item, trigger);
                            item = item || this.defaultItem;
                            this.label.innerHTML = item.innerHTML;
                        }
                    }
                ]);
                return IconPicker;
            }(_picker2.default);
            exports.default = IconPicker;
        /***/ },
        /* 61 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var Tooltip = function() {
                function Tooltip(quill, boundsContainer) {
                    var _this = this;
                    _classCallCheck(this, Tooltip);
                    this.quill = quill;
                    this.boundsContainer = boundsContainer || document.body;
                    this.root = quill.addContainer("ql-tooltip");
                    this.root.innerHTML = this.constructor.TEMPLATE;
                    if (this.quill.root === this.quill.scrollingContainer) this.quill.root.addEventListener("scroll", function() {
                        _this.root.style.marginTop = -1 * _this.quill.root.scrollTop + "px";
                    });
                    this.hide();
                }
                _createClass(Tooltip, [
                    {
                        key: "hide",
                        value: function hide() {
                            this.root.classList.add("ql-hidden");
                        }
                    },
                    {
                        key: "position",
                        value: function position(reference) {
                            var left = reference.left + reference.width / 2 - this.root.offsetWidth / 2;
                            // root.scrollTop should be 0 if scrollContainer !== root
                            var top = reference.bottom + this.quill.root.scrollTop;
                            this.root.style.left = left + "px";
                            this.root.style.top = top + "px";
                            this.root.classList.remove("ql-flip");
                            var containerBounds = this.boundsContainer.getBoundingClientRect();
                            var rootBounds = this.root.getBoundingClientRect();
                            var shift = 0;
                            if (rootBounds.right > containerBounds.right) {
                                shift = containerBounds.right - rootBounds.right;
                                this.root.style.left = left + shift + "px";
                            }
                            if (rootBounds.left < containerBounds.left) {
                                shift = containerBounds.left - rootBounds.left;
                                this.root.style.left = left + shift + "px";
                            }
                            if (rootBounds.bottom > containerBounds.bottom) {
                                var height = rootBounds.bottom - rootBounds.top;
                                var verticalShift = reference.bottom - reference.top + height;
                                this.root.style.top = top - verticalShift + "px";
                                this.root.classList.add("ql-flip");
                            }
                            return shift;
                        }
                    },
                    {
                        key: "show",
                        value: function show() {
                            this.root.classList.remove("ql-editing");
                            this.root.classList.remove("ql-hidden");
                        }
                    }
                ]);
                return Tooltip;
            }();
            exports.default = Tooltip;
        /***/ },
        /* 62 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            var _emitter = __webpack_require__(8);
            var _emitter2 = _interopRequireDefault(_emitter);
            var _base = __webpack_require__(43);
            var _base2 = _interopRequireDefault(_base);
            var _link = __webpack_require__(27);
            var _link2 = _interopRequireDefault(_link);
            var _selection = __webpack_require__(15);
            var _icons = __webpack_require__(41);
            var _icons2 = _interopRequireDefault(_icons);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var TOOLBAR_CONFIG = [
                [
                    {
                        header: [
                            "1",
                            "2",
                            "3",
                            false
                        ]
                    }
                ],
                [
                    "bold",
                    "italic",
                    "underline",
                    "link"
                ],
                [
                    {
                        list: "ordered"
                    },
                    {
                        list: "bullet"
                    }
                ],
                [
                    "clean"
                ]
            ];
            var SnowTheme = function(_BaseTheme) {
                _inherits(SnowTheme, _BaseTheme);
                function SnowTheme(quill, options) {
                    _classCallCheck(this, SnowTheme);
                    if (options.modules.toolbar != null && options.modules.toolbar.container == null) options.modules.toolbar.container = TOOLBAR_CONFIG;
                    var _this = _possibleConstructorReturn(this, (SnowTheme.__proto__ || Object.getPrototypeOf(SnowTheme)).call(this, quill, options));
                    _this.quill.container.classList.add("ql-snow");
                    return _this;
                }
                _createClass(SnowTheme, [
                    {
                        key: "extendToolbar",
                        value: function extendToolbar(toolbar) {
                            toolbar.container.classList.add("ql-snow");
                            this.buildButtons([].slice.call(toolbar.container.querySelectorAll("button")), _icons2.default);
                            this.buildPickers([].slice.call(toolbar.container.querySelectorAll("select")), _icons2.default);
                            this.tooltip = new SnowTooltip(this.quill, this.options.bounds);
                            if (toolbar.container.querySelector(".ql-link")) this.quill.keyboard.addBinding({
                                key: "K",
                                shortKey: true
                            }, function(range, context) {
                                toolbar.handlers["link"].call(toolbar, !context.format.link);
                            });
                        }
                    }
                ]);
                return SnowTheme;
            }(_base2.default);
            SnowTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
                modules: {
                    toolbar: {
                        handlers: {
                            link: function link(value) {
                                if (value) {
                                    var range = this.quill.getSelection();
                                    if (range == null || range.length == 0) return;
                                    var preview = this.quill.getText(range);
                                    if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf("mailto:") !== 0) preview = "mailto:" + preview;
                                    var tooltip = this.quill.theme.tooltip;
                                    tooltip.edit("link", preview);
                                } else this.quill.format("link", false);
                            }
                        }
                    }
                }
            });
            var SnowTooltip = function(_BaseTooltip) {
                _inherits(SnowTooltip, _BaseTooltip);
                function SnowTooltip(quill, bounds) {
                    _classCallCheck(this, SnowTooltip);
                    var _this2 = _possibleConstructorReturn(this, (SnowTooltip.__proto__ || Object.getPrototypeOf(SnowTooltip)).call(this, quill, bounds));
                    _this2.preview = _this2.root.querySelector("a.ql-preview");
                    return _this2;
                }
                _createClass(SnowTooltip, [
                    {
                        key: "listen",
                        value: function listen() {
                            var _this3 = this;
                            _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), "listen", this).call(this);
                            this.root.querySelector("a.ql-action").addEventListener("click", function(event) {
                                if (_this3.root.classList.contains("ql-editing")) _this3.save();
                                else _this3.edit("link", _this3.preview.textContent);
                                event.preventDefault();
                            });
                            this.root.querySelector("a.ql-remove").addEventListener("click", function(event) {
                                if (_this3.linkRange != null) {
                                    var range = _this3.linkRange;
                                    _this3.restoreFocus();
                                    _this3.quill.formatText(range, "link", false, _emitter2.default.sources.USER);
                                    delete _this3.linkRange;
                                }
                                event.preventDefault();
                                _this3.hide();
                            });
                            this.quill.on(_emitter2.default.events.SELECTION_CHANGE, function(range, oldRange, source) {
                                if (range == null) return;
                                if (range.length === 0 && source === _emitter2.default.sources.USER) {
                                    var _quill$scroll$descend = _this3.quill.scroll.descendant(_link2.default, range.index), _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2), link = _quill$scroll$descend2[0], offset = _quill$scroll$descend2[1];
                                    if (link != null) {
                                        _this3.linkRange = new _selection.Range(range.index - offset, link.length());
                                        var preview = _link2.default.formats(link.domNode);
                                        _this3.preview.textContent = preview;
                                        _this3.preview.setAttribute("href", preview);
                                        _this3.show();
                                        _this3.position(_this3.quill.getBounds(_this3.linkRange));
                                        return;
                                    }
                                } else delete _this3.linkRange;
                                _this3.hide();
                            });
                        }
                    },
                    {
                        key: "show",
                        value: function show() {
                            _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), "show", this).call(this);
                            this.root.removeAttribute("data-mode");
                        }
                    }
                ]);
                return SnowTooltip;
            }(_base.BaseTooltip);
            SnowTooltip.TEMPLATE = [
                '<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>',
                '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">',
                '<a class="ql-action"></a>',
                '<a class="ql-remove"></a>'
            ].join("");
            exports.default = SnowTheme;
        /***/ },
        /* 63 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _core = __webpack_require__(29);
            var _core2 = _interopRequireDefault(_core);
            var _align = __webpack_require__(36);
            var _direction = __webpack_require__(38);
            var _indent = __webpack_require__(64);
            var _blockquote = __webpack_require__(65);
            var _blockquote2 = _interopRequireDefault(_blockquote);
            var _header = __webpack_require__(66);
            var _header2 = _interopRequireDefault(_header);
            var _list = __webpack_require__(67);
            var _list2 = _interopRequireDefault(_list);
            var _background = __webpack_require__(37);
            var _color = __webpack_require__(26);
            var _font = __webpack_require__(39);
            var _size = __webpack_require__(40);
            var _bold = __webpack_require__(56);
            var _bold2 = _interopRequireDefault(_bold);
            var _italic = __webpack_require__(68);
            var _italic2 = _interopRequireDefault(_italic);
            var _link = __webpack_require__(27);
            var _link2 = _interopRequireDefault(_link);
            var _script = __webpack_require__(69);
            var _script2 = _interopRequireDefault(_script);
            var _strike = __webpack_require__(70);
            var _strike2 = _interopRequireDefault(_strike);
            var _underline = __webpack_require__(71);
            var _underline2 = _interopRequireDefault(_underline);
            var _image = __webpack_require__(72);
            var _image2 = _interopRequireDefault(_image);
            var _video = __webpack_require__(73);
            var _video2 = _interopRequireDefault(_video);
            var _code = __webpack_require__(13);
            var _code2 = _interopRequireDefault(_code);
            var _formula = __webpack_require__(74);
            var _formula2 = _interopRequireDefault(_formula);
            var _syntax = __webpack_require__(75);
            var _syntax2 = _interopRequireDefault(_syntax);
            var _toolbar = __webpack_require__(57);
            var _toolbar2 = _interopRequireDefault(_toolbar);
            var _icons = __webpack_require__(41);
            var _icons2 = _interopRequireDefault(_icons);
            var _picker = __webpack_require__(28);
            var _picker2 = _interopRequireDefault(_picker);
            var _colorPicker = __webpack_require__(59);
            var _colorPicker2 = _interopRequireDefault(_colorPicker);
            var _iconPicker = __webpack_require__(60);
            var _iconPicker2 = _interopRequireDefault(_iconPicker);
            var _tooltip = __webpack_require__(61);
            var _tooltip2 = _interopRequireDefault(_tooltip);
            var _bubble = __webpack_require__(108);
            var _bubble2 = _interopRequireDefault(_bubble);
            var _snow = __webpack_require__(62);
            var _snow2 = _interopRequireDefault(_snow);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            _core2.default.register({
                "attributors/attribute/direction": _direction.DirectionAttribute,
                "attributors/class/align": _align.AlignClass,
                "attributors/class/background": _background.BackgroundClass,
                "attributors/class/color": _color.ColorClass,
                "attributors/class/direction": _direction.DirectionClass,
                "attributors/class/font": _font.FontClass,
                "attributors/class/size": _size.SizeClass,
                "attributors/style/align": _align.AlignStyle,
                "attributors/style/background": _background.BackgroundStyle,
                "attributors/style/color": _color.ColorStyle,
                "attributors/style/direction": _direction.DirectionStyle,
                "attributors/style/font": _font.FontStyle,
                "attributors/style/size": _size.SizeStyle
            }, true);
            _core2.default.register({
                "formats/align": _align.AlignClass,
                "formats/direction": _direction.DirectionClass,
                "formats/indent": _indent.IndentClass,
                "formats/background": _background.BackgroundStyle,
                "formats/color": _color.ColorStyle,
                "formats/font": _font.FontClass,
                "formats/size": _size.SizeClass,
                "formats/blockquote": _blockquote2.default,
                "formats/code-block": _code2.default,
                "formats/header": _header2.default,
                "formats/list": _list2.default,
                "formats/bold": _bold2.default,
                "formats/code": _code.Code,
                "formats/italic": _italic2.default,
                "formats/link": _link2.default,
                "formats/script": _script2.default,
                "formats/strike": _strike2.default,
                "formats/underline": _underline2.default,
                "formats/image": _image2.default,
                "formats/video": _video2.default,
                "formats/list/item": _list.ListItem,
                "modules/formula": _formula2.default,
                "modules/syntax": _syntax2.default,
                "modules/toolbar": _toolbar2.default,
                "themes/bubble": _bubble2.default,
                "themes/snow": _snow2.default,
                "ui/icons": _icons2.default,
                "ui/picker": _picker2.default,
                "ui/icon-picker": _iconPicker2.default,
                "ui/color-picker": _colorPicker2.default,
                "ui/tooltip": _tooltip2.default
            }, true);
            exports.default = _core2.default;
        /***/ },
        /* 64 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.IndentClass = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var IdentAttributor = function(_Parchment$Attributor) {
                _inherits(IdentAttributor, _Parchment$Attributor);
                function IdentAttributor() {
                    _classCallCheck(this, IdentAttributor);
                    return _possibleConstructorReturn(this, (IdentAttributor.__proto__ || Object.getPrototypeOf(IdentAttributor)).apply(this, arguments));
                }
                _createClass(IdentAttributor, [
                    {
                        key: "add",
                        value: function add(node, value) {
                            if (value === "+1" || value === "-1") {
                                var indent = this.value(node) || 0;
                                value = value === "+1" ? indent + 1 : indent - 1;
                            }
                            if (value === 0) {
                                this.remove(node);
                                return true;
                            } else return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), "add", this).call(this, node, value);
                        }
                    },
                    {
                        key: "canAdd",
                        value: function canAdd(node, value) {
                            return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), "canAdd", this).call(this, node, value) || _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), "canAdd", this).call(this, node, parseInt(value));
                        }
                    },
                    {
                        key: "value",
                        value: function value(node) {
                            return parseInt(_get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), "value", this).call(this, node)) || undefined; // Don't return NaN
                        }
                    }
                ]);
                return IdentAttributor;
            }(_parchment2.default.Attributor.Class);
            var IndentClass = new IdentAttributor("indent", "ql-indent", {
                scope: _parchment2.default.Scope.BLOCK,
                whitelist: [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8
                ]
            });
            exports.IndentClass = IndentClass;
        /***/ },
        /* 65 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Blockquote = function(_Block) {
                _inherits(Blockquote, _Block);
                function Blockquote() {
                    _classCallCheck(this, Blockquote);
                    return _possibleConstructorReturn(this, (Blockquote.__proto__ || Object.getPrototypeOf(Blockquote)).apply(this, arguments));
                }
                return Blockquote;
            }(_block2.default);
            Blockquote.blotName = "blockquote";
            Blockquote.tagName = "blockquote";
            exports.default = Blockquote;
        /***/ },
        /* 66 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Header = function(_Block) {
                _inherits(Header, _Block);
                function Header() {
                    _classCallCheck(this, Header);
                    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
                }
                _createClass(Header, null, [
                    {
                        key: "formats",
                        value: function formats(domNode) {
                            return this.tagName.indexOf(domNode.tagName) + 1;
                        }
                    }
                ]);
                return Header;
            }(_block2.default);
            Header.blotName = "header";
            Header.tagName = [
                "H1",
                "H2",
                "H3",
                "H4",
                "H5",
                "H6"
            ];
            exports.default = Header;
        /***/ },
        /* 67 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.ListItem = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            var _container = __webpack_require__(25);
            var _container2 = _interopRequireDefault(_container);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var ListItem = function(_Block) {
                _inherits(ListItem, _Block);
                function ListItem() {
                    _classCallCheck(this, ListItem);
                    return _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
                }
                _createClass(ListItem, [
                    {
                        key: "format",
                        value: function format(name, value) {
                            if (name === List.blotName && !value) this.replaceWith(_parchment2.default.create(this.statics.scope));
                            else _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), "format", this).call(this, name, value);
                        }
                    },
                    {
                        key: "remove",
                        value: function remove() {
                            if (this.prev == null && this.next == null) this.parent.remove();
                            else _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), "remove", this).call(this);
                        }
                    },
                    {
                        key: "replaceWith",
                        value: function replaceWith(name, value) {
                            this.parent.isolate(this.offset(this.parent), this.length());
                            if (name === this.parent.statics.blotName) {
                                this.parent.replaceWith(name, value);
                                return this;
                            } else {
                                this.parent.unwrap();
                                return _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), "replaceWith", this).call(this, name, value);
                            }
                        }
                    }
                ], [
                    {
                        key: "formats",
                        value: function formats(domNode) {
                            return domNode.tagName === this.tagName ? undefined : _get(ListItem.__proto__ || Object.getPrototypeOf(ListItem), "formats", this).call(this, domNode);
                        }
                    }
                ]);
                return ListItem;
            }(_block2.default);
            ListItem.blotName = "list-item";
            ListItem.tagName = "LI";
            var List = function(_Container) {
                _inherits(List, _Container);
                _createClass(List, null, [
                    {
                        key: "create",
                        value: function create(value) {
                            var tagName = value === "ordered" ? "OL" : "UL";
                            var node = _get(List.__proto__ || Object.getPrototypeOf(List), "create", this).call(this, tagName);
                            if (value === "checked" || value === "unchecked") node.setAttribute("data-checked", value === "checked");
                            return node;
                        }
                    },
                    {
                        key: "formats",
                        value: function formats(domNode) {
                            if (domNode.tagName === "OL") return "ordered";
                            if (domNode.tagName === "UL") {
                                if (domNode.hasAttribute("data-checked")) return domNode.getAttribute("data-checked") === "true" ? "checked" : "unchecked";
                                else return "bullet";
                            }
                            return undefined;
                        }
                    }
                ]);
                function List(domNode) {
                    _classCallCheck(this, List);
                    var _this2 = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, domNode));
                    var listEventHandler = function listEventHandler(e) {
                        if (e.target.parentNode !== domNode) return;
                        var format = _this2.statics.formats(domNode);
                        var blot = _parchment2.default.find(e.target);
                        if (format === "checked") blot.format("list", "unchecked");
                        else if (format === "unchecked") blot.format("list", "checked");
                    };
                    domNode.addEventListener("touchstart", listEventHandler);
                    domNode.addEventListener("mousedown", listEventHandler);
                    return _this2;
                }
                _createClass(List, [
                    {
                        key: "format",
                        value: function format(name, value) {
                            if (this.children.length > 0) this.children.tail.format(name, value);
                        }
                    },
                    {
                        key: "formats",
                        value: function formats() {
                            // We don't inherit from FormatBlot
                            return _defineProperty({}, this.statics.blotName, this.statics.formats(this.domNode));
                        }
                    },
                    {
                        key: "insertBefore",
                        value: function insertBefore(blot, ref) {
                            if (blot instanceof ListItem) _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), "insertBefore", this).call(this, blot, ref);
                            else {
                                var index = ref == null ? this.length() : ref.offset(this);
                                var after = this.split(index);
                                after.parent.insertBefore(blot, after);
                            }
                        }
                    },
                    {
                        key: "optimize",
                        value: function optimize(context) {
                            _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), "optimize", this).call(this, context);
                            var next = this.next;
                            if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && next.domNode.tagName === this.domNode.tagName && next.domNode.getAttribute("data-checked") === this.domNode.getAttribute("data-checked")) {
                                next.moveChildren(this);
                                next.remove();
                            }
                        }
                    },
                    {
                        key: "replace",
                        value: function replace(target) {
                            if (target.statics.blotName !== this.statics.blotName) {
                                var item = _parchment2.default.create(this.statics.defaultChild);
                                target.moveChildren(item);
                                this.appendChild(item);
                            }
                            _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), "replace", this).call(this, target);
                        }
                    }
                ]);
                return List;
            }(_container2.default);
            List.blotName = "list";
            List.scope = _parchment2.default.Scope.BLOCK_BLOT;
            List.tagName = [
                "OL",
                "UL"
            ];
            List.defaultChild = "list-item";
            List.allowedChildren = [
                ListItem
            ];
            exports.ListItem = ListItem;
            exports.default = List;
        /***/ },
        /* 68 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _bold = __webpack_require__(56);
            var _bold2 = _interopRequireDefault(_bold);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Italic = function(_Bold) {
                _inherits(Italic, _Bold);
                function Italic() {
                    _classCallCheck(this, Italic);
                    return _possibleConstructorReturn(this, (Italic.__proto__ || Object.getPrototypeOf(Italic)).apply(this, arguments));
                }
                return Italic;
            }(_bold2.default);
            Italic.blotName = "italic";
            Italic.tagName = [
                "EM",
                "I"
            ];
            exports.default = Italic;
        /***/ },
        /* 69 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Script = function(_Inline) {
                _inherits(Script, _Inline);
                function Script() {
                    _classCallCheck(this, Script);
                    return _possibleConstructorReturn(this, (Script.__proto__ || Object.getPrototypeOf(Script)).apply(this, arguments));
                }
                _createClass(Script, null, [
                    {
                        key: "create",
                        value: function create(value) {
                            if (value === "super") return document.createElement("sup");
                            else if (value === "sub") return document.createElement("sub");
                            else return _get(Script.__proto__ || Object.getPrototypeOf(Script), "create", this).call(this, value);
                        }
                    },
                    {
                        key: "formats",
                        value: function formats(domNode) {
                            if (domNode.tagName === "SUB") return "sub";
                            if (domNode.tagName === "SUP") return "super";
                            return undefined;
                        }
                    }
                ]);
                return Script;
            }(_inline2.default);
            Script.blotName = "script";
            Script.tagName = [
                "SUB",
                "SUP"
            ];
            exports.default = Script;
        /***/ },
        /* 70 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Strike = function(_Inline) {
                _inherits(Strike, _Inline);
                function Strike() {
                    _classCallCheck(this, Strike);
                    return _possibleConstructorReturn(this, (Strike.__proto__ || Object.getPrototypeOf(Strike)).apply(this, arguments));
                }
                return Strike;
            }(_inline2.default);
            Strike.blotName = "strike";
            Strike.tagName = "S";
            exports.default = Strike;
        /***/ },
        /* 71 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Underline = function(_Inline) {
                _inherits(Underline, _Inline);
                function Underline() {
                    _classCallCheck(this, Underline);
                    return _possibleConstructorReturn(this, (Underline.__proto__ || Object.getPrototypeOf(Underline)).apply(this, arguments));
                }
                return Underline;
            }(_inline2.default);
            Underline.blotName = "underline";
            Underline.tagName = "U";
            exports.default = Underline;
        /***/ },
        /* 72 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _link = __webpack_require__(27);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var ATTRIBUTES = [
                "alt",
                "height",
                "width"
            ];
            var Image = function(_Parchment$Embed) {
                _inherits(Image, _Parchment$Embed);
                function Image() {
                    _classCallCheck(this, Image);
                    return _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).apply(this, arguments));
                }
                _createClass(Image, [
                    {
                        key: "format",
                        value: function format(name, value) {
                            if (ATTRIBUTES.indexOf(name) > -1) {
                                if (value) this.domNode.setAttribute(name, value);
                                else this.domNode.removeAttribute(name);
                            } else _get(Image.prototype.__proto__ || Object.getPrototypeOf(Image.prototype), "format", this).call(this, name, value);
                        }
                    }
                ], [
                    {
                        key: "create",
                        value: function create(value) {
                            var node = _get(Image.__proto__ || Object.getPrototypeOf(Image), "create", this).call(this, value);
                            if (typeof value === "string") node.setAttribute("src", this.sanitize(value));
                            return node;
                        }
                    },
                    {
                        key: "formats",
                        value: function formats(domNode) {
                            return ATTRIBUTES.reduce(function(formats, attribute) {
                                if (domNode.hasAttribute(attribute)) formats[attribute] = domNode.getAttribute(attribute);
                                return formats;
                            }, {});
                        }
                    },
                    {
                        key: "match",
                        value: function match(url) {
                            return /\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url);
                        }
                    },
                    {
                        key: "sanitize",
                        value: function sanitize(url) {
                            return (0, _link.sanitize)(url, [
                                "http",
                                "https",
                                "data"
                            ]) ? url : "//:0";
                        }
                    },
                    {
                        key: "value",
                        value: function value(domNode) {
                            return domNode.getAttribute("src");
                        }
                    }
                ]);
                return Image;
            }(_parchment2.default.Embed);
            Image.blotName = "image";
            Image.tagName = "IMG";
            exports.default = Image;
        /***/ },
        /* 73 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _block = __webpack_require__(4);
            var _link = __webpack_require__(27);
            var _link2 = _interopRequireDefault(_link);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var ATTRIBUTES = [
                "height",
                "width"
            ];
            var Video = function(_BlockEmbed) {
                _inherits(Video, _BlockEmbed);
                function Video() {
                    _classCallCheck(this, Video);
                    return _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).apply(this, arguments));
                }
                _createClass(Video, [
                    {
                        key: "format",
                        value: function format(name, value) {
                            if (ATTRIBUTES.indexOf(name) > -1) {
                                if (value) this.domNode.setAttribute(name, value);
                                else this.domNode.removeAttribute(name);
                            } else _get(Video.prototype.__proto__ || Object.getPrototypeOf(Video.prototype), "format", this).call(this, name, value);
                        }
                    }
                ], [
                    {
                        key: "create",
                        value: function create(value) {
                            var node = _get(Video.__proto__ || Object.getPrototypeOf(Video), "create", this).call(this, value);
                            node.setAttribute("frameborder", "0");
                            node.setAttribute("allowfullscreen", true);
                            node.setAttribute("src", this.sanitize(value));
                            return node;
                        }
                    },
                    {
                        key: "formats",
                        value: function formats(domNode) {
                            return ATTRIBUTES.reduce(function(formats, attribute) {
                                if (domNode.hasAttribute(attribute)) formats[attribute] = domNode.getAttribute(attribute);
                                return formats;
                            }, {});
                        }
                    },
                    {
                        key: "sanitize",
                        value: function sanitize(url) {
                            return _link2.default.sanitize(url);
                        }
                    },
                    {
                        key: "value",
                        value: function value(domNode) {
                            return domNode.getAttribute("src");
                        }
                    }
                ]);
                return Video;
            }(_block.BlockEmbed);
            Video.blotName = "video";
            Video.className = "ql-video";
            Video.tagName = "IFRAME";
            exports.default = Video;
        /***/ },
        /* 74 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.FormulaBlot = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _embed = __webpack_require__(35);
            var _embed2 = _interopRequireDefault(_embed);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var FormulaBlot = function(_Embed) {
                _inherits(FormulaBlot, _Embed);
                function FormulaBlot() {
                    _classCallCheck(this, FormulaBlot);
                    return _possibleConstructorReturn(this, (FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot)).apply(this, arguments));
                }
                _createClass(FormulaBlot, null, [
                    {
                        key: "create",
                        value: function create(value) {
                            var node = _get(FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot), "create", this).call(this, value);
                            if (typeof value === "string") {
                                window.katex.render(value, node, {
                                    throwOnError: false,
                                    errorColor: "#f00"
                                });
                                node.setAttribute("data-value", value);
                            }
                            return node;
                        }
                    },
                    {
                        key: "value",
                        value: function value(domNode) {
                            return domNode.getAttribute("data-value");
                        }
                    }
                ]);
                return FormulaBlot;
            }(_embed2.default);
            FormulaBlot.blotName = "formula";
            FormulaBlot.className = "ql-formula";
            FormulaBlot.tagName = "SPAN";
            var Formula = function(_Module) {
                _inherits(Formula, _Module);
                _createClass(Formula, null, [
                    {
                        key: "register",
                        value: function register() {
                            _quill2.default.register(FormulaBlot, true);
                        }
                    }
                ]);
                function Formula() {
                    _classCallCheck(this, Formula);
                    var _this2 = _possibleConstructorReturn(this, (Formula.__proto__ || Object.getPrototypeOf(Formula)).call(this));
                    if (window.katex == null) throw new Error("Formula module requires KaTeX.");
                    return _this2;
                }
                return Formula;
            }(_module2.default);
            exports.FormulaBlot = FormulaBlot;
            exports.default = Formula;
        /***/ },
        /* 75 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.CodeToken = exports.CodeBlock = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            var _code = __webpack_require__(13);
            var _code2 = _interopRequireDefault(_code);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var SyntaxCodeBlock = function(_CodeBlock) {
                _inherits(SyntaxCodeBlock, _CodeBlock);
                function SyntaxCodeBlock() {
                    _classCallCheck(this, SyntaxCodeBlock);
                    return _possibleConstructorReturn(this, (SyntaxCodeBlock.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock)).apply(this, arguments));
                }
                _createClass(SyntaxCodeBlock, [
                    {
                        key: "replaceWith",
                        value: function replaceWith(block) {
                            this.domNode.textContent = this.domNode.textContent;
                            this.attach();
                            _get(SyntaxCodeBlock.prototype.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock.prototype), "replaceWith", this).call(this, block);
                        }
                    },
                    {
                        key: "highlight",
                        value: function highlight(_highlight) {
                            var text = this.domNode.textContent;
                            if (this.cachedText !== text) {
                                if (text.trim().length > 0 || this.cachedText == null) {
                                    this.domNode.innerHTML = _highlight(text);
                                    this.domNode.normalize();
                                    this.attach();
                                }
                                this.cachedText = text;
                            }
                        }
                    }
                ]);
                return SyntaxCodeBlock;
            }(_code2.default);
            SyntaxCodeBlock.className = "ql-syntax";
            var CodeToken = new _parchment2.default.Attributor.Class("token", "hljs", {
                scope: _parchment2.default.Scope.INLINE
            });
            var Syntax = function(_Module) {
                _inherits(Syntax, _Module);
                _createClass(Syntax, null, [
                    {
                        key: "register",
                        value: function register() {
                            _quill2.default.register(CodeToken, true);
                            _quill2.default.register(SyntaxCodeBlock, true);
                        }
                    }
                ]);
                function Syntax(quill, options) {
                    _classCallCheck(this, Syntax);
                    var _this2 = _possibleConstructorReturn(this, (Syntax.__proto__ || Object.getPrototypeOf(Syntax)).call(this, quill, options));
                    if (typeof _this2.options.highlight !== "function") throw new Error("Syntax module requires highlight.js. Please include the library on the page before Quill.");
                    var timer = null;
                    _this2.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function() {
                        clearTimeout(timer);
                        timer = setTimeout(function() {
                            _this2.highlight();
                            timer = null;
                        }, _this2.options.interval);
                    });
                    _this2.highlight();
                    return _this2;
                }
                _createClass(Syntax, [
                    {
                        key: "highlight",
                        value: function highlight() {
                            var _this3 = this;
                            if (this.quill.selection.composing) return;
                            this.quill.update(_quill2.default.sources.USER);
                            var range = this.quill.getSelection();
                            this.quill.scroll.descendants(SyntaxCodeBlock).forEach(function(code) {
                                code.highlight(_this3.options.highlight);
                            });
                            this.quill.update(_quill2.default.sources.SILENT);
                            if (range != null) this.quill.setSelection(range, _quill2.default.sources.SILENT);
                        }
                    }
                ]);
                return Syntax;
            }(_module2.default);
            Syntax.DEFAULTS = {
                highlight: function() {
                    if (window.hljs == null) return null;
                    return function(text) {
                        var result = window.hljs.highlightAuto(text);
                        return result.value;
                    };
                }(),
                interval: 1000
            };
            exports.CodeBlock = SyntaxCodeBlock;
            exports.CodeToken = CodeToken;
            exports.default = Syntax;
        /***/ },
        /* 76 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>';
        /***/ },
        /* 77 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=14 x2=4 y1=14 y2=14></line> <line class=ql-stroke x1=12 x2=6 y1=4 y2=4></line> </svg>';
        /***/ },
        /* 78 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>';
        /***/ },
        /* 79 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=3 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=3 y1=4 y2=4></line> </svg>';
        /***/ },
        /* 80 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <g class="ql-fill ql-color-label"> <polygon points="6 6.868 6 6 5 6 5 7 5.942 7 6 6.868"></polygon> <rect height=1 width=1 x=4 y=4></rect> <polygon points="6.817 5 6 5 6 6 6.38 6 6.817 5"></polygon> <rect height=1 width=1 x=2 y=6></rect> <rect height=1 width=1 x=3 y=5></rect> <rect height=1 width=1 x=4 y=7></rect> <polygon points="4 11.439 4 11 3 11 3 12 3.755 12 4 11.439"></polygon> <rect height=1 width=1 x=2 y=12></rect> <rect height=1 width=1 x=2 y=9></rect> <rect height=1 width=1 x=2 y=15></rect> <polygon points="4.63 10 4 10 4 11 4.192 11 4.63 10"></polygon> <rect height=1 width=1 x=3 y=8></rect> <path d=M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z></path> <path d=M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z></path> <path d=M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z></path> <rect height=1 width=1 x=12 y=2></rect> <rect height=1 width=1 x=11 y=3></rect> <path d=M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z></path> <rect height=1 width=1 x=2 y=3></rect> <rect height=1 width=1 x=6 y=2></rect> <rect height=1 width=1 x=3 y=2></rect> <rect height=1 width=1 x=5 y=3></rect> <rect height=1 width=1 x=9 y=2></rect> <rect height=1 width=1 x=15 y=14></rect> <polygon points="13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174"></polygon> <rect height=1 width=1 x=13 y=7></rect> <rect height=1 width=1 x=15 y=5></rect> <rect height=1 width=1 x=14 y=6></rect> <rect height=1 width=1 x=15 y=8></rect> <rect height=1 width=1 x=14 y=9></rect> <path d=M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z></path> <rect height=1 width=1 x=14 y=3></rect> <polygon points="12 6.868 12 6 11.62 6 12 6.868"></polygon> <rect height=1 width=1 x=15 y=2></rect> <rect height=1 width=1 x=12 y=5></rect> <rect height=1 width=1 x=13 y=4></rect> <polygon points="12.933 9 13 9 13 8 12.495 8 12.933 9"></polygon> <rect height=1 width=1 x=9 y=14></rect> <rect height=1 width=1 x=8 y=15></rect> <path d=M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z></path> <rect height=1 width=1 x=5 y=15></rect> <path d=M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z></path> <rect height=1 width=1 x=11 y=15></rect> <path d=M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z></path> <rect height=1 width=1 x=14 y=15></rect> <rect height=1 width=1 x=15 y=11></rect> </g> <polyline class=ql-stroke points="5.5 13 9 5 12.5 13"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=11 y2=11></line> </svg>';
        /***/ },
        /* 81 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <rect class="ql-fill ql-stroke" height=3 width=3 x=4 y=5></rect> <rect class="ql-fill ql-stroke" height=3 width=3 x=11 y=5></rect> <path class="ql-even ql-fill ql-stroke" d=M7,8c0,4.031-3,5-3,5></path> <path class="ql-even ql-fill ql-stroke" d=M14,8c0,4.031-3,5-3,5></path> </svg>';
        /***/ },
        /* 82 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <path class=ql-stroke d=M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z></path> <path class=ql-stroke d=M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z></path> </svg>';
        /***/ },
        /* 83 */ /***/ function(module1, exports) {
            module1.exports = '<svg class="" viewbox="0 0 18 18"> <line class=ql-stroke x1=5 x2=13 y1=3 y2=3></line> <line class=ql-stroke x1=6 x2=9.35 y1=12 y2=3></line> <line class=ql-stroke x1=11 x2=15 y1=11 y2=15></line> <line class=ql-stroke x1=15 x2=11 y1=11 y2=15></line> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=7 x=2 y=14></rect> </svg>';
        /***/ },
        /* 84 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <line class="ql-color-label ql-stroke ql-transparent" x1=3 x2=15 y1=15 y2=15></line> <polyline class=ql-stroke points="5.5 11 9 3 12.5 11"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=9 y2=9></line> </svg>';
        /***/ },
        /* 85 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <polygon class="ql-stroke ql-fill" points="3 11 5 9 3 7 3 11"></polygon> <line class="ql-stroke ql-fill" x1=15 x2=11 y1=4 y2=4></line> <path class=ql-fill d=M11,3a3,3,0,0,0,0,6h1V3H11Z></path> <rect class=ql-fill height=11 width=1 x=11 y=4></rect> <rect class=ql-fill height=11 width=1 x=13 y=4></rect> </svg>';
        /***/ },
        /* 86 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <polygon class="ql-stroke ql-fill" points="15 12 13 10 15 8 15 12"></polygon> <line class="ql-stroke ql-fill" x1=9 x2=5 y1=4 y2=4></line> <path class=ql-fill d=M5,3A3,3,0,0,0,5,9H6V3H5Z></path> <rect class=ql-fill height=11 width=1 x=5 y=4></rect> <rect class=ql-fill height=11 width=1 x=7 y=4></rect> </svg>';
        /***/ },
        /* 87 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M14,16H4a1,1,0,0,1,0-2H14A1,1,0,0,1,14,16Z /> <path class=ql-fill d=M14,4H4A1,1,0,0,1,4,2H14A1,1,0,0,1,14,4Z /> <rect class=ql-fill x=3 y=6 width=12 height=6 rx=1 ry=1 /> </svg>';
        /***/ },
        /* 88 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=2 y=6 width=14 height=6 rx=1 ry=1 /> </svg>';
        /***/ },
        /* 89 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15,8H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,8Z /> <path class=ql-fill d=M15,12H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,12Z /> <path class=ql-fill d=M15,16H5a1,1,0,0,1,0-2H15A1,1,0,0,1,15,16Z /> <path class=ql-fill d=M15,4H5A1,1,0,0,1,5,2H15A1,1,0,0,1,15,4Z /> <rect class=ql-fill x=2 y=6 width=8 height=6 rx=1 ry=1 /> </svg>';
        /***/ },
        /* 90 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M5,8H3A1,1,0,0,1,3,6H5A1,1,0,0,1,5,8Z /> <path class=ql-fill d=M5,12H3a1,1,0,0,1,0-2H5A1,1,0,0,1,5,12Z /> <path class=ql-fill d=M13,16H3a1,1,0,0,1,0-2H13A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H3A1,1,0,0,1,3,2H13A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=8 y=6 width=8 height=6 rx=1 ry=1 transform="translate(24 18) rotate(-180)"/> </svg>';
        /***/ },
        /* 91 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z></path> <rect class=ql-fill height=1.6 rx=0.8 ry=0.8 width=5 x=5.15 y=6.2></rect> <path class=ql-fill d=M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z></path> </svg>';
        /***/ },
        /* 92 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 18 18"> <path class=ql-fill d=M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z /> </svg>';
        /***/ },
        /* 93 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 18 18"> <path class=ql-fill d=M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z /> </svg>';
        /***/ },
        /* 94 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>';
        /***/ },
        /* 95 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <rect class=ql-stroke height=10 width=12 x=3 y=4></rect> <circle class=ql-fill cx=6 cy=7 r=1></circle> <polyline class="ql-even ql-fill" points="5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12"></polyline> </svg>';
        /***/ },
        /* 96 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class="ql-fill ql-stroke" points="3 7 3 11 5 9 3 7"></polyline> </svg>';
        /***/ },
        /* 97 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points="5 7 5 11 3 9 5 7"></polyline> </svg>';
        /***/ },
        /* 98 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=11 y1=7 y2=11></line> <path class="ql-even ql-stroke" d=M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z></path> <path class="ql-even ql-stroke" d=M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z></path> </svg>';
        /***/ },
        /* 99 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=7 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=7 x2=15 y1=14 y2=14></line> <line class="ql-stroke ql-thin" x1=2.5 x2=4.5 y1=5.5 y2=5.5></line> <path class=ql-fill d=M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z></path> <path class="ql-stroke ql-thin" d=M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156></path> <path class="ql-stroke ql-thin" d=M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109></path> </svg>';
        /***/ },
        /* 100 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=6 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=6 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=6 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=3 y1=4 y2=4></line> <line class=ql-stroke x1=3 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=3 y1=14 y2=14></line> </svg>';
        /***/ },
        /* 101 */ /***/ function(module1, exports) {
            module1.exports = '<svg class="" viewbox="0 0 18 18"> <line class=ql-stroke x1=9 x2=15 y1=4 y2=4></line> <polyline class=ql-stroke points="3 4 4 5 6 3"></polyline> <line class=ql-stroke x1=9 x2=15 y1=14 y2=14></line> <polyline class=ql-stroke points="3 14 4 15 6 13"></polyline> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points="3 9 4 10 6 8"></polyline> </svg>';
        /***/ },
        /* 102 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z /> <path class=ql-fill d=M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z /> </svg>';
        /***/ },
        /* 103 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z /> <path class=ql-fill d=M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z /> </svg>';
        /***/ },
        /* 104 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <line class="ql-stroke ql-thin" x1=15.5 x2=2.5 y1=8.5 y2=9.5></line> <path class=ql-fill d=M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z></path> <path class=ql-fill d=M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z></path> </svg>';
        /***/ },
        /* 105 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>';
        /***/ },
        /* 106 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=12 width=1 x=5 y=3></rect> <rect class=ql-fill height=12 width=1 x=12 y=3></rect> <rect class=ql-fill height=2 width=8 x=5 y=8></rect> <rect class=ql-fill height=1 width=3 x=3 y=5></rect> <rect class=ql-fill height=1 width=3 x=3 y=7></rect> <rect class=ql-fill height=1 width=3 x=3 y=10></rect> <rect class=ql-fill height=1 width=3 x=3 y=12></rect> <rect class=ql-fill height=1 width=3 x=12 y=5></rect> <rect class=ql-fill height=1 width=3 x=12 y=7></rect> <rect class=ql-fill height=1 width=3 x=12 y=10></rect> <rect class=ql-fill height=1 width=3 x=12 y=12></rect> </svg>';
        /***/ },
        /* 107 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <polygon class=ql-stroke points="7 11 9 13 11 11 7 11"></polygon> <polygon class=ql-stroke points="7 7 9 5 11 7 7 7"></polygon> </svg>';
        /***/ },
        /* 108 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.BubbleTooltip = undefined;
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            var _emitter = __webpack_require__(8);
            var _emitter2 = _interopRequireDefault(_emitter);
            var _base = __webpack_require__(43);
            var _base2 = _interopRequireDefault(_base);
            var _selection = __webpack_require__(15);
            var _icons = __webpack_require__(41);
            var _icons2 = _interopRequireDefault(_icons);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var TOOLBAR_CONFIG = [
                [
                    "bold",
                    "italic",
                    "link"
                ],
                [
                    {
                        header: 1
                    },
                    {
                        header: 2
                    },
                    "blockquote"
                ]
            ];
            var BubbleTheme = function(_BaseTheme) {
                _inherits(BubbleTheme, _BaseTheme);
                function BubbleTheme(quill, options) {
                    _classCallCheck(this, BubbleTheme);
                    if (options.modules.toolbar != null && options.modules.toolbar.container == null) options.modules.toolbar.container = TOOLBAR_CONFIG;
                    var _this = _possibleConstructorReturn(this, (BubbleTheme.__proto__ || Object.getPrototypeOf(BubbleTheme)).call(this, quill, options));
                    _this.quill.container.classList.add("ql-bubble");
                    return _this;
                }
                _createClass(BubbleTheme, [
                    {
                        key: "extendToolbar",
                        value: function extendToolbar(toolbar) {
                            this.tooltip = new BubbleTooltip(this.quill, this.options.bounds);
                            this.tooltip.root.appendChild(toolbar.container);
                            this.buildButtons([].slice.call(toolbar.container.querySelectorAll("button")), _icons2.default);
                            this.buildPickers([].slice.call(toolbar.container.querySelectorAll("select")), _icons2.default);
                        }
                    }
                ]);
                return BubbleTheme;
            }(_base2.default);
            BubbleTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
                modules: {
                    toolbar: {
                        handlers: {
                            link: function link(value) {
                                if (!value) this.quill.format("link", false);
                                else this.quill.theme.tooltip.edit();
                            }
                        }
                    }
                }
            });
            var BubbleTooltip = function(_BaseTooltip) {
                _inherits(BubbleTooltip, _BaseTooltip);
                function BubbleTooltip(quill, bounds) {
                    _classCallCheck(this, BubbleTooltip);
                    var _this2 = _possibleConstructorReturn(this, (BubbleTooltip.__proto__ || Object.getPrototypeOf(BubbleTooltip)).call(this, quill, bounds));
                    _this2.quill.on(_emitter2.default.events.EDITOR_CHANGE, function(type, range, oldRange, source) {
                        if (type !== _emitter2.default.events.SELECTION_CHANGE) return;
                        if (range != null && range.length > 0 && source === _emitter2.default.sources.USER) {
                            _this2.show();
                            // Lock our width so we will expand beyond our offsetParent boundaries
                            _this2.root.style.left = "0px";
                            _this2.root.style.width = "";
                            _this2.root.style.width = _this2.root.offsetWidth + "px";
                            var lines = _this2.quill.getLines(range.index, range.length);
                            if (lines.length === 1) _this2.position(_this2.quill.getBounds(range));
                            else {
                                var lastLine = lines[lines.length - 1];
                                var index = _this2.quill.getIndex(lastLine);
                                var length = Math.min(lastLine.length() - 1, range.index + range.length - index);
                                var _bounds = _this2.quill.getBounds(new _selection.Range(index, length));
                                _this2.position(_bounds);
                            }
                        } else if (document.activeElement !== _this2.textbox && _this2.quill.hasFocus()) _this2.hide();
                    });
                    return _this2;
                }
                _createClass(BubbleTooltip, [
                    {
                        key: "listen",
                        value: function listen() {
                            var _this3 = this;
                            _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), "listen", this).call(this);
                            this.root.querySelector(".ql-close").addEventListener("click", function() {
                                _this3.root.classList.remove("ql-editing");
                            });
                            this.quill.on(_emitter2.default.events.SCROLL_OPTIMIZE, function() {
                                // Let selection be restored by toolbar handlers before repositioning
                                setTimeout(function() {
                                    if (_this3.root.classList.contains("ql-hidden")) return;
                                    var range = _this3.quill.getSelection();
                                    if (range != null) _this3.position(_this3.quill.getBounds(range));
                                }, 1);
                            });
                        }
                    },
                    {
                        key: "cancel",
                        value: function cancel() {
                            this.show();
                        }
                    },
                    {
                        key: "position",
                        value: function position(reference) {
                            var shift = _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), "position", this).call(this, reference);
                            var arrow = this.root.querySelector(".ql-tooltip-arrow");
                            arrow.style.marginLeft = "";
                            if (shift === 0) return shift;
                            arrow.style.marginLeft = -1 * shift - arrow.offsetWidth / 2 + "px";
                        }
                    }
                ]);
                return BubbleTooltip;
            }(_base.BaseTooltip);
            BubbleTooltip.TEMPLATE = [
                '<span class="ql-tooltip-arrow"></span>',
                '<div class="ql-tooltip-editor">',
                '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">',
                '<a class="ql-close"></a>',
                "</div>"
            ].join("");
            exports.BubbleTooltip = BubbleTooltip;
            exports.default = BubbleTheme;
        /***/ },
        /* 109 */ /***/ function(module1, exports, __webpack_require__) {
            module1.exports = __webpack_require__(63);
        /***/ }
    ])["default"];
});

});
parcelRegister("N0o3H", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $0934e0939605d48c$export$a143d493d941bafc, (v) => $0934e0939605d48c$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $0934e0939605d48c$export$f99ded8fe4b79145, (v) => $0934e0939605d48c$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $0934e0939605d48c$export$a143d493d941bafc;
var $0934e0939605d48c$export$e4cf37d7f6fb9e0a;
var $0934e0939605d48c$export$f99ded8fe4b79145;
var $0934e0939605d48c$export$599f31c3813fae4d;
"use strict";

var $bQMRt = parcelRequire("bQMRt");

var $dbnIE = parcelRequire("dbnIE");
const $0934e0939605d48c$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$0934e0939605d48c$export$a143d493d941bafc = $0934e0939605d48c$var$Buffer;
$0934e0939605d48c$export$e4cf37d7f6fb9e0a = $0934e0939605d48c$var$SlowBuffer;
$0934e0939605d48c$export$f99ded8fe4b79145 = 50;
const $0934e0939605d48c$var$K_MAX_LENGTH = 0x7fffffff;
$0934e0939605d48c$export$599f31c3813fae4d = $0934e0939605d48c$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT = $0934e0939605d48c$var$typedArraySupport();
if (!$0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $0934e0939605d48c$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $0934e0939605d48c$var$createBuffer(length) {
    if (length > $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $0934e0939605d48c$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $0934e0939605d48c$var$allocUnsafe(arg);
    }
    return $0934e0939605d48c$var$from(arg, encodingOrOffset, length);
}
$0934e0939605d48c$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $0934e0939605d48c$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $0934e0939605d48c$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $0934e0939605d48c$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($0934e0939605d48c$var$isInstance(value, ArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, ArrayBuffer)) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($0934e0939605d48c$var$isInstance(value, SharedArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, SharedArrayBuffer))) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $0934e0939605d48c$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $0934e0939605d48c$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $0934e0939605d48c$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $0934e0939605d48c$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $0934e0939605d48c$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($0934e0939605d48c$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($0934e0939605d48c$var$Buffer, Uint8Array);
function $0934e0939605d48c$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $0934e0939605d48c$var$alloc(size, fill, encoding) {
    $0934e0939605d48c$var$assertSize(size);
    if (size <= 0) return $0934e0939605d48c$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $0934e0939605d48c$var$createBuffer(size).fill(fill, encoding) : $0934e0939605d48c$var$createBuffer(size).fill(fill);
    return $0934e0939605d48c$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $0934e0939605d48c$var$Buffer.alloc = function(size, fill, encoding) {
    return $0934e0939605d48c$var$alloc(size, fill, encoding);
};
function $0934e0939605d48c$var$allocUnsafe(size) {
    $0934e0939605d48c$var$assertSize(size);
    return $0934e0939605d48c$var$createBuffer(size < 0 ? 0 : $0934e0939605d48c$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $0934e0939605d48c$var$Buffer.allocUnsafe = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $0934e0939605d48c$var$Buffer.allocUnsafeSlow = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
function $0934e0939605d48c$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $0934e0939605d48c$var$byteLength(string, encoding) | 0;
    let buf = $0934e0939605d48c$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $0934e0939605d48c$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $0934e0939605d48c$var$checked(array.length) | 0;
    const buf = $0934e0939605d48c$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $0934e0939605d48c$var$fromArrayView(arrayView) {
    if ($0934e0939605d48c$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $0934e0939605d48c$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $0934e0939605d48c$var$fromArrayLike(arrayView);
}
function $0934e0939605d48c$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
function $0934e0939605d48c$var$fromObject(obj) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(obj)) {
        const len = $0934e0939605d48c$var$checked(obj.length) | 0;
        const buf = $0934e0939605d48c$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $0934e0939605d48c$var$numberIsNaN(obj.length)) return $0934e0939605d48c$var$createBuffer(0);
        return $0934e0939605d48c$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $0934e0939605d48c$var$fromArrayLike(obj.data);
}
function $0934e0939605d48c$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $0934e0939605d48c$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $0934e0939605d48c$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $0934e0939605d48c$var$Buffer.alloc(+length);
}
$0934e0939605d48c$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $0934e0939605d48c$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$0934e0939605d48c$var$Buffer.compare = function compare(a, b) {
    if ($0934e0939605d48c$var$isInstance(a, Uint8Array)) a = $0934e0939605d48c$var$Buffer.from(a, a.offset, a.byteLength);
    if ($0934e0939605d48c$var$isInstance(b, Uint8Array)) b = $0934e0939605d48c$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(a) || !$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$0934e0939605d48c$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$0934e0939605d48c$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $0934e0939605d48c$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $0934e0939605d48c$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($0934e0939605d48c$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) buf = $0934e0939605d48c$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $0934e0939605d48c$var$byteLength(string, encoding) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $0934e0939605d48c$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $0934e0939605d48c$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $0934e0939605d48c$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $0934e0939605d48c$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$0934e0939605d48c$var$Buffer.byteLength = $0934e0939605d48c$var$byteLength;
function $0934e0939605d48c$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $0934e0939605d48c$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $0934e0939605d48c$var$utf8Slice(this, start, end);
        case "ascii":
            return $0934e0939605d48c$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $0934e0939605d48c$var$latin1Slice(this, start, end);
        case "base64":
            return $0934e0939605d48c$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $0934e0939605d48c$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$0934e0939605d48c$var$Buffer.prototype._isBuffer = true;
function $0934e0939605d48c$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$0934e0939605d48c$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$0934e0939605d48c$var$swap(this, i, i + 1);
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $0934e0939605d48c$var$swap(this, i, i + 3);
        $0934e0939605d48c$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $0934e0939605d48c$var$swap(this, i, i + 7);
        $0934e0939605d48c$var$swap(this, i + 1, i + 6);
        $0934e0939605d48c$var$swap(this, i + 2, i + 5);
        $0934e0939605d48c$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $0934e0939605d48c$var$utf8Slice(this, 0, length);
    return $0934e0939605d48c$var$slowToString.apply(this, arguments);
};
$0934e0939605d48c$var$Buffer.prototype.toLocaleString = $0934e0939605d48c$var$Buffer.prototype.toString;
$0934e0939605d48c$var$Buffer.prototype.equals = function equals(b) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $0934e0939605d48c$var$Buffer.compare(this, b) === 0;
};
$0934e0939605d48c$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $0934e0939605d48c$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($0934e0939605d48c$var$customInspectSymbol) $0934e0939605d48c$var$Buffer.prototype[$0934e0939605d48c$var$customInspectSymbol] = $0934e0939605d48c$var$Buffer.prototype.inspect;
$0934e0939605d48c$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($0934e0939605d48c$var$isInstance(target, Uint8Array)) target = $0934e0939605d48c$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $0934e0939605d48c$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($0934e0939605d48c$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $0934e0939605d48c$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($0934e0939605d48c$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $0934e0939605d48c$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $0934e0939605d48c$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $0934e0939605d48c$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$0934e0939605d48c$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$0934e0939605d48c$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$0934e0939605d48c$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $0934e0939605d48c$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($0934e0939605d48c$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $0934e0939605d48c$var$utf8Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $0934e0939605d48c$var$asciiWrite(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$asciiToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$base64Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$base64ToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$ucs2Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$0934e0939605d48c$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $0934e0939605d48c$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $0934e0939605d48c$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $0934e0939605d48c$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $0934e0939605d48c$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $0934e0939605d48c$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$0934e0939605d48c$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $0934e0939605d48c$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $bQMRt.fromByteArray(buf);
    else return $bQMRt.fromByteArray(buf.slice(start, end));
}
function $0934e0939605d48c$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $0934e0939605d48c$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $0934e0939605d48c$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $0934e0939605d48c$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $0934e0939605d48c$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $0934e0939605d48c$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $0934e0939605d48c$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $0934e0939605d48c$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$0934e0939605d48c$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $0934e0939605d48c$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $0934e0939605d48c$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$0934e0939605d48c$var$Buffer.prototype.readUintLE = $0934e0939605d48c$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUintBE = $0934e0939605d48c$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUint8 = $0934e0939605d48c$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$0934e0939605d48c$var$Buffer.prototype.readUint16LE = $0934e0939605d48c$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$0934e0939605d48c$var$Buffer.prototype.readUint16BE = $0934e0939605d48c$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$0934e0939605d48c$var$Buffer.prototype.readUint32LE = $0934e0939605d48c$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$0934e0939605d48c$var$Buffer.prototype.readUint32BE = $0934e0939605d48c$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$0934e0939605d48c$var$Buffer.prototype.readBigUInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$0934e0939605d48c$var$Buffer.prototype.readBigUInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$0934e0939605d48c$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$0934e0939605d48c$var$Buffer.prototype.readBigInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$0934e0939605d48c$var$Buffer.prototype.readBigInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$0934e0939605d48c$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $dbnIE.read(this, offset, true, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $dbnIE.read(this, offset, false, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $dbnIE.read(this, offset, true, 52, 8);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $dbnIE.read(this, offset, false, 52, 8);
};
function $0934e0939605d48c$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$0934e0939605d48c$var$Buffer.prototype.writeUintLE = $0934e0939605d48c$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUintBE = $0934e0939605d48c$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint8 = $0934e0939605d48c$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $0934e0939605d48c$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $0934e0939605d48c$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$0934e0939605d48c$var$Buffer.prototype.writeBigUInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$0934e0939605d48c$var$Buffer.prototype.writeBigUInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$0934e0939605d48c$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeBigInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$0934e0939605d48c$var$Buffer.prototype.writeBigInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $0934e0939605d48c$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $0934e0939605d48c$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $dbnIE.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$0934e0939605d48c$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, false, noAssert);
};
function $0934e0939605d48c$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $dbnIE.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$0934e0939605d48c$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$0934e0939605d48c$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$0934e0939605d48c$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $0934e0939605d48c$var$Buffer.isBuffer(val) ? val : $0934e0939605d48c$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $0934e0939605d48c$var$errors = {};
function $0934e0939605d48c$var$E(sym, getMessage, Base) {
    $0934e0939605d48c$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$0934e0939605d48c$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$0934e0939605d48c$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$0934e0939605d48c$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $0934e0939605d48c$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $0934e0939605d48c$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $0934e0939605d48c$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $0934e0939605d48c$var$checkBounds(buf, offset, byteLength) {
    $0934e0939605d48c$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $0934e0939605d48c$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $0934e0939605d48c$var$checkBounds(buf, offset, byteLength);
}
function $0934e0939605d48c$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $0934e0939605d48c$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $0934e0939605d48c$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $0934e0939605d48c$var$validateNumber(value, type);
        throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $0934e0939605d48c$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $0934e0939605d48c$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $0934e0939605d48c$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($0934e0939605d48c$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $0934e0939605d48c$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $0934e0939605d48c$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $0934e0939605d48c$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $0934e0939605d48c$var$base64ToBytes(str) {
    return $bQMRt.toByteArray($0934e0939605d48c$var$base64clean(str));
}
function $0934e0939605d48c$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $0934e0939605d48c$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $0934e0939605d48c$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $0934e0939605d48c$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $0934e0939605d48c$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $0934e0939605d48c$var$BufferBigIntNotDefined : fn;
}
function $0934e0939605d48c$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("bQMRt", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $8a0a73e6b73fd0c4$export$d622b2ad8d90c771, (v) => $8a0a73e6b73fd0c4$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $8a0a73e6b73fd0c4$export$6100ba28696e12de, (v) => $8a0a73e6b73fd0c4$export$6100ba28696e12de = v);
var $8a0a73e6b73fd0c4$export$a48f0734ac7c2329;
var $8a0a73e6b73fd0c4$export$d622b2ad8d90c771;
var $8a0a73e6b73fd0c4$export$6100ba28696e12de;
"use strict";
$8a0a73e6b73fd0c4$export$a48f0734ac7c2329 = $8a0a73e6b73fd0c4$var$byteLength;
$8a0a73e6b73fd0c4$export$d622b2ad8d90c771 = $8a0a73e6b73fd0c4$var$toByteArray;
$8a0a73e6b73fd0c4$export$6100ba28696e12de = $8a0a73e6b73fd0c4$var$fromByteArray;
var $8a0a73e6b73fd0c4$var$lookup = [];
var $8a0a73e6b73fd0c4$var$revLookup = [];
var $8a0a73e6b73fd0c4$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $8a0a73e6b73fd0c4$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $8a0a73e6b73fd0c4$var$i = 0, $8a0a73e6b73fd0c4$var$len = $8a0a73e6b73fd0c4$var$code.length; $8a0a73e6b73fd0c4$var$i < $8a0a73e6b73fd0c4$var$len; ++$8a0a73e6b73fd0c4$var$i){
    $8a0a73e6b73fd0c4$var$lookup[$8a0a73e6b73fd0c4$var$i] = $8a0a73e6b73fd0c4$var$code[$8a0a73e6b73fd0c4$var$i];
    $8a0a73e6b73fd0c4$var$revLookup[$8a0a73e6b73fd0c4$var$code.charCodeAt($8a0a73e6b73fd0c4$var$i)] = $8a0a73e6b73fd0c4$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$8a0a73e6b73fd0c4$var$revLookup["-".charCodeAt(0)] = 62;
$8a0a73e6b73fd0c4$var$revLookup["_".charCodeAt(0)] = 63;
function $8a0a73e6b73fd0c4$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $8a0a73e6b73fd0c4$var$byteLength(b64) {
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$toByteArray(b64) {
    var tmp;
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $8a0a73e6b73fd0c4$var$Arr($8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 18 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 2 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 10 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $8a0a73e6b73fd0c4$var$tripletToBase64(num) {
    return $8a0a73e6b73fd0c4$var$lookup[num >> 18 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 12 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 6 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num & 0x3F];
}
function $8a0a73e6b73fd0c4$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($8a0a73e6b73fd0c4$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $8a0a73e6b73fd0c4$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($8a0a73e6b73fd0c4$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 2] + $8a0a73e6b73fd0c4$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 10] + $8a0a73e6b73fd0c4$var$lookup[tmp >> 4 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("dbnIE", function(module, exports) {

$parcel$export(module.exports, "read", () => $998eb38f4d082829$export$aafa59e2e03f2942, (v) => $998eb38f4d082829$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $998eb38f4d082829$export$68d8715fc104d294, (v) => $998eb38f4d082829$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $998eb38f4d082829$export$aafa59e2e03f2942;
var $998eb38f4d082829$export$68d8715fc104d294;
$998eb38f4d082829$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$998eb38f4d082829$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("1YL9c", function(module, exports) {

!function(e, t) {
    module.exports = t((parcelRequire("1BElU")));
}(window, function(e) {
    return function(e) {
        var t = {};
        function n(o) {
            if (t[o]) return t[o].exports;
            var i = t[o] = {
                i: o,
                l: !1,
                exports: {}
            };
            return e[o].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
        }
        return n.m = e, n.c = t, n.d = function(e, t, o) {
            n.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: o
            });
        }, n.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, n.t = function(e, t) {
            if (1 & t && (e = n(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var o = Object.create(null);
            if (n.r(o), Object.defineProperty(o, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var i in e)n.d(o, i, (function(t) {
                return e[t];
            }).bind(null, i));
            return o;
        }, n.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return n.d(t, "a", t), t;
        }, n.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, n.p = "", n(n.s = 2);
    }([
        function(e, t, n) {
            /*! @license DOMPurify 3.0.5 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.0.5/LICENSE */ e.exports = function() {
                "use strict";
                const { entries: e, setPrototypeOf: t, isFrozen: n, getPrototypeOf: o, getOwnPropertyDescriptor: i } = Object;
                let { freeze: r, seal: a, create: l } = Object, { apply: u, construct: s } = "undefined" != typeof Reflect && Reflect;
                u || (u = function(e, t, n) {
                    return e.apply(t, n);
                }), r || (r = function(e) {
                    return e;
                }), a || (a = function(e) {
                    return e;
                }), s || (s = function(e, t) {
                    return new e(...t);
                });
                const c = D(Array.prototype.forEach), f = D(Array.prototype.pop), p = D(Array.prototype.push), d = D(String.prototype.toLowerCase), m = D(String.prototype.toString), h = D(String.prototype.match), g = D(String.prototype.replace), T = D(String.prototype.indexOf), A = D(String.prototype.trim), b = D(RegExp.prototype.test), E = (y = TypeError, function() {
                    for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
                    return s(y, t);
                });
                var y;
                function D(e) {
                    return function(t) {
                        for(var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)o[i - 1] = arguments[i];
                        return u(e, t, o);
                    };
                }
                function L(e, o, i) {
                    var r;
                    i = null !== (r = i) && void 0 !== r ? r : d, t && t(e, null);
                    let a = o.length;
                    for(; a--;){
                        let t = o[a];
                        if ("string" == typeof t) {
                            const e = i(t);
                            e !== t && (n(o) || (o[a] = e), t = e);
                        }
                        e[t] = !0;
                    }
                    return e;
                }
                function S(t) {
                    const n = l(null);
                    for (const [o, i] of e(t))n[o] = i;
                    return n;
                }
                function F(e, t) {
                    for(; null !== e;){
                        const n = i(e, t);
                        if (n) {
                            if (n.get) return D(n.get);
                            if ("function" == typeof n.value) return D(n.value);
                        }
                        e = o(e);
                    }
                    return function(e) {
                        return console.warn("fallback value for", e), null;
                    };
                }
                const _ = r([
                    "a",
                    "abbr",
                    "acronym",
                    "address",
                    "area",
                    "article",
                    "aside",
                    "audio",
                    "b",
                    "bdi",
                    "bdo",
                    "big",
                    "blink",
                    "blockquote",
                    "body",
                    "br",
                    "button",
                    "canvas",
                    "caption",
                    "center",
                    "cite",
                    "code",
                    "col",
                    "colgroup",
                    "content",
                    "data",
                    "datalist",
                    "dd",
                    "decorator",
                    "del",
                    "details",
                    "dfn",
                    "dialog",
                    "dir",
                    "div",
                    "dl",
                    "dt",
                    "element",
                    "em",
                    "fieldset",
                    "figcaption",
                    "figure",
                    "font",
                    "footer",
                    "form",
                    "h1",
                    "h2",
                    "h3",
                    "h4",
                    "h5",
                    "h6",
                    "head",
                    "header",
                    "hgroup",
                    "hr",
                    "html",
                    "i",
                    "img",
                    "input",
                    "ins",
                    "kbd",
                    "label",
                    "legend",
                    "li",
                    "main",
                    "map",
                    "mark",
                    "marquee",
                    "menu",
                    "menuitem",
                    "meter",
                    "nav",
                    "nobr",
                    "ol",
                    "optgroup",
                    "option",
                    "output",
                    "p",
                    "picture",
                    "pre",
                    "progress",
                    "q",
                    "rp",
                    "rt",
                    "ruby",
                    "s",
                    "samp",
                    "section",
                    "select",
                    "shadow",
                    "small",
                    "source",
                    "spacer",
                    "span",
                    "strike",
                    "strong",
                    "style",
                    "sub",
                    "summary",
                    "sup",
                    "table",
                    "tbody",
                    "td",
                    "template",
                    "textarea",
                    "tfoot",
                    "th",
                    "thead",
                    "time",
                    "tr",
                    "track",
                    "tt",
                    "u",
                    "ul",
                    "var",
                    "video",
                    "wbr"
                ]), v = r([
                    "svg",
                    "a",
                    "altglyph",
                    "altglyphdef",
                    "altglyphitem",
                    "animatecolor",
                    "animatemotion",
                    "animatetransform",
                    "circle",
                    "clippath",
                    "defs",
                    "desc",
                    "ellipse",
                    "filter",
                    "font",
                    "g",
                    "glyph",
                    "glyphref",
                    "hkern",
                    "image",
                    "line",
                    "lineargradient",
                    "marker",
                    "mask",
                    "metadata",
                    "mpath",
                    "path",
                    "pattern",
                    "polygon",
                    "polyline",
                    "radialgradient",
                    "rect",
                    "stop",
                    "style",
                    "switch",
                    "symbol",
                    "text",
                    "textpath",
                    "title",
                    "tref",
                    "tspan",
                    "view",
                    "vkern"
                ]), O = r([
                    "feBlend",
                    "feColorMatrix",
                    "feComponentTransfer",
                    "feComposite",
                    "feConvolveMatrix",
                    "feDiffuseLighting",
                    "feDisplacementMap",
                    "feDistantLight",
                    "feDropShadow",
                    "feFlood",
                    "feFuncA",
                    "feFuncB",
                    "feFuncG",
                    "feFuncR",
                    "feGaussianBlur",
                    "feImage",
                    "feMerge",
                    "feMergeNode",
                    "feMorphology",
                    "feOffset",
                    "fePointLight",
                    "feSpecularLighting",
                    "feSpotLight",
                    "feTile",
                    "feTurbulence"
                ]), k = r([
                    "animate",
                    "color-profile",
                    "cursor",
                    "discard",
                    "font-face",
                    "font-face-format",
                    "font-face-name",
                    "font-face-src",
                    "font-face-uri",
                    "foreignobject",
                    "hatch",
                    "hatchpath",
                    "mesh",
                    "meshgradient",
                    "meshpatch",
                    "meshrow",
                    "missing-glyph",
                    "script",
                    "set",
                    "solidcolor",
                    "unknown",
                    "use"
                ]), w = r([
                    "math",
                    "menclose",
                    "merror",
                    "mfenced",
                    "mfrac",
                    "mglyph",
                    "mi",
                    "mlabeledtr",
                    "mmultiscripts",
                    "mn",
                    "mo",
                    "mover",
                    "mpadded",
                    "mphantom",
                    "mroot",
                    "mrow",
                    "ms",
                    "mspace",
                    "msqrt",
                    "mstyle",
                    "msub",
                    "msup",
                    "msubsup",
                    "mtable",
                    "mtd",
                    "mtext",
                    "mtr",
                    "munder",
                    "munderover",
                    "mprescripts"
                ]), N = r([
                    "maction",
                    "maligngroup",
                    "malignmark",
                    "mlongdiv",
                    "mscarries",
                    "mscarry",
                    "msgroup",
                    "mstack",
                    "msline",
                    "msrow",
                    "semantics",
                    "annotation",
                    "annotation-xml",
                    "mprescripts",
                    "none"
                ]), x = r([
                    "#text"
                ]), R = r([
                    "accept",
                    "action",
                    "align",
                    "alt",
                    "autocapitalize",
                    "autocomplete",
                    "autopictureinpicture",
                    "autoplay",
                    "background",
                    "bgcolor",
                    "border",
                    "capture",
                    "cellpadding",
                    "cellspacing",
                    "checked",
                    "cite",
                    "class",
                    "clear",
                    "color",
                    "cols",
                    "colspan",
                    "controls",
                    "controlslist",
                    "coords",
                    "crossorigin",
                    "datetime",
                    "decoding",
                    "default",
                    "dir",
                    "disabled",
                    "disablepictureinpicture",
                    "disableremoteplayback",
                    "download",
                    "draggable",
                    "enctype",
                    "enterkeyhint",
                    "face",
                    "for",
                    "headers",
                    "height",
                    "hidden",
                    "high",
                    "href",
                    "hreflang",
                    "id",
                    "inputmode",
                    "integrity",
                    "ismap",
                    "kind",
                    "label",
                    "lang",
                    "list",
                    "loading",
                    "loop",
                    "low",
                    "max",
                    "maxlength",
                    "media",
                    "method",
                    "min",
                    "minlength",
                    "multiple",
                    "muted",
                    "name",
                    "nonce",
                    "noshade",
                    "novalidate",
                    "nowrap",
                    "open",
                    "optimum",
                    "pattern",
                    "placeholder",
                    "playsinline",
                    "poster",
                    "preload",
                    "pubdate",
                    "radiogroup",
                    "readonly",
                    "rel",
                    "required",
                    "rev",
                    "reversed",
                    "role",
                    "rows",
                    "rowspan",
                    "spellcheck",
                    "scope",
                    "selected",
                    "shape",
                    "size",
                    "sizes",
                    "span",
                    "srclang",
                    "start",
                    "src",
                    "srcset",
                    "step",
                    "style",
                    "summary",
                    "tabindex",
                    "title",
                    "translate",
                    "type",
                    "usemap",
                    "valign",
                    "value",
                    "width",
                    "xmlns",
                    "slot"
                ]), C = r([
                    "accent-height",
                    "accumulate",
                    "additive",
                    "alignment-baseline",
                    "ascent",
                    "attributename",
                    "attributetype",
                    "azimuth",
                    "basefrequency",
                    "baseline-shift",
                    "begin",
                    "bias",
                    "by",
                    "class",
                    "clip",
                    "clippathunits",
                    "clip-path",
                    "clip-rule",
                    "color",
                    "color-interpolation",
                    "color-interpolation-filters",
                    "color-profile",
                    "color-rendering",
                    "cx",
                    "cy",
                    "d",
                    "dx",
                    "dy",
                    "diffuseconstant",
                    "direction",
                    "display",
                    "divisor",
                    "dur",
                    "edgemode",
                    "elevation",
                    "end",
                    "fill",
                    "fill-opacity",
                    "fill-rule",
                    "filter",
                    "filterunits",
                    "flood-color",
                    "flood-opacity",
                    "font-family",
                    "font-size",
                    "font-size-adjust",
                    "font-stretch",
                    "font-style",
                    "font-variant",
                    "font-weight",
                    "fx",
                    "fy",
                    "g1",
                    "g2",
                    "glyph-name",
                    "glyphref",
                    "gradientunits",
                    "gradienttransform",
                    "height",
                    "href",
                    "id",
                    "image-rendering",
                    "in",
                    "in2",
                    "k",
                    "k1",
                    "k2",
                    "k3",
                    "k4",
                    "kerning",
                    "keypoints",
                    "keysplines",
                    "keytimes",
                    "lang",
                    "lengthadjust",
                    "letter-spacing",
                    "kernelmatrix",
                    "kernelunitlength",
                    "lighting-color",
                    "local",
                    "marker-end",
                    "marker-mid",
                    "marker-start",
                    "markerheight",
                    "markerunits",
                    "markerwidth",
                    "maskcontentunits",
                    "maskunits",
                    "max",
                    "mask",
                    "media",
                    "method",
                    "mode",
                    "min",
                    "name",
                    "numoctaves",
                    "offset",
                    "operator",
                    "opacity",
                    "order",
                    "orient",
                    "orientation",
                    "origin",
                    "overflow",
                    "paint-order",
                    "path",
                    "pathlength",
                    "patterncontentunits",
                    "patterntransform",
                    "patternunits",
                    "points",
                    "preservealpha",
                    "preserveaspectratio",
                    "primitiveunits",
                    "r",
                    "rx",
                    "ry",
                    "radius",
                    "refx",
                    "refy",
                    "repeatcount",
                    "repeatdur",
                    "restart",
                    "result",
                    "rotate",
                    "scale",
                    "seed",
                    "shape-rendering",
                    "specularconstant",
                    "specularexponent",
                    "spreadmethod",
                    "startoffset",
                    "stddeviation",
                    "stitchtiles",
                    "stop-color",
                    "stop-opacity",
                    "stroke-dasharray",
                    "stroke-dashoffset",
                    "stroke-linecap",
                    "stroke-linejoin",
                    "stroke-miterlimit",
                    "stroke-opacity",
                    "stroke",
                    "stroke-width",
                    "style",
                    "surfacescale",
                    "systemlanguage",
                    "tabindex",
                    "targetx",
                    "targety",
                    "transform",
                    "transform-origin",
                    "text-anchor",
                    "text-decoration",
                    "text-rendering",
                    "textlength",
                    "type",
                    "u1",
                    "u2",
                    "unicode",
                    "values",
                    "viewbox",
                    "visibility",
                    "version",
                    "vert-adv-y",
                    "vert-origin-x",
                    "vert-origin-y",
                    "width",
                    "word-spacing",
                    "wrap",
                    "writing-mode",
                    "xchannelselector",
                    "ychannelselector",
                    "x",
                    "x1",
                    "x2",
                    "xmlns",
                    "y",
                    "y1",
                    "y2",
                    "z",
                    "zoomandpan"
                ]), M = r([
                    "accent",
                    "accentunder",
                    "align",
                    "bevelled",
                    "close",
                    "columnsalign",
                    "columnlines",
                    "columnspan",
                    "denomalign",
                    "depth",
                    "dir",
                    "display",
                    "displaystyle",
                    "encoding",
                    "fence",
                    "frame",
                    "height",
                    "href",
                    "id",
                    "largeop",
                    "length",
                    "linethickness",
                    "lspace",
                    "lquote",
                    "mathbackground",
                    "mathcolor",
                    "mathsize",
                    "mathvariant",
                    "maxsize",
                    "minsize",
                    "movablelimits",
                    "notation",
                    "numalign",
                    "open",
                    "rowalign",
                    "rowlines",
                    "rowspacing",
                    "rowspan",
                    "rspace",
                    "rquote",
                    "scriptlevel",
                    "scriptminsize",
                    "scriptsizemultiplier",
                    "selection",
                    "separator",
                    "separators",
                    "stretchy",
                    "subscriptshift",
                    "supscriptshift",
                    "symmetric",
                    "voffset",
                    "width",
                    "xmlns"
                ]), I = r([
                    "xlink:href",
                    "xml:id",
                    "xlink:title",
                    "xml:space",
                    "xmlns:xlink"
                ]), P = a(/\{\{[\w\W]*|[\w\W]*\}\}/gm), z = a(/<%[\w\W]*|[\w\W]*%>/gm), W = a(/\${[\w\W]*}/gm), H = a(/^data-[\-\w.\u00B7-\uFFFF]/), U = a(/^aria-[\-\w]+$/), G = a(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i), B = a(/^(?:\w+script|data):/i), j = a(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g), q = a(/^html$/i);
                var Y = Object.freeze({
                    __proto__: null,
                    MUSTACHE_EXPR: P,
                    ERB_EXPR: z,
                    TMPLIT_EXPR: W,
                    DATA_ATTR: H,
                    ARIA_ATTR: U,
                    IS_ALLOWED_URI: G,
                    IS_SCRIPT_OR_DATA: B,
                    ATTR_WHITESPACE: j,
                    DOCTYPE_NAME: q
                });
                const K = ()=>"undefined" == typeof window ? null : window, X = function(e, t) {
                    if ("object" != typeof e || "function" != typeof e.createPolicy) return null;
                    let n = null;
                    t && t.hasAttribute("data-tt-policy-suffix") && (n = t.getAttribute("data-tt-policy-suffix"));
                    const o = "dompurify" + (n ? "#" + n : "");
                    try {
                        return e.createPolicy(o, {
                            createHTML: (e)=>e,
                            createScriptURL: (e)=>e
                        });
                    } catch (e) {
                        return console.warn("TrustedTypes policy " + o + " could not be created."), null;
                    }
                };
                return function t() {
                    let n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : K();
                    const o = (e)=>t(e);
                    if (o.version = "3.0.5", o.removed = [], !n || !n.document || 9 !== n.document.nodeType) return o.isSupported = !1, o;
                    const i = n.document, a = i.currentScript;
                    let { document: l } = n;
                    const { DocumentFragment: u, HTMLTemplateElement: s, Node: y, Element: D, NodeFilter: P, NamedNodeMap: z = n.NamedNodeMap || n.MozNamedAttrMap, HTMLFormElement: W, DOMParser: H, trustedTypes: U } = n, B = D.prototype, j = F(B, "cloneNode"), V = F(B, "nextSibling"), $ = F(B, "childNodes"), Q = F(B, "parentNode");
                    if ("function" == typeof s) {
                        const e = l.createElement("template");
                        e.content && e.content.ownerDocument && (l = e.content.ownerDocument);
                    }
                    let Z, J = "";
                    const { implementation: ee, createNodeIterator: te, createDocumentFragment: ne, getElementsByTagName: oe } = l, { importNode: ie } = i;
                    let re = {};
                    o.isSupported = "function" == typeof e && "function" == typeof Q && ee && void 0 !== ee.createHTMLDocument;
                    const { MUSTACHE_EXPR: ae, ERB_EXPR: le, TMPLIT_EXPR: ue, DATA_ATTR: se, ARIA_ATTR: ce, IS_SCRIPT_OR_DATA: fe, ATTR_WHITESPACE: pe } = Y;
                    let { IS_ALLOWED_URI: de } = Y, me = null;
                    const he = L({}, [
                        ..._,
                        ...v,
                        ...O,
                        ...w,
                        ...x
                    ]);
                    let ge = null;
                    const Te = L({}, [
                        ...R,
                        ...C,
                        ...M,
                        ...I
                    ]);
                    let Ae = Object.seal(Object.create(null, {
                        tagNameCheck: {
                            writable: !0,
                            configurable: !1,
                            enumerable: !0,
                            value: null
                        },
                        attributeNameCheck: {
                            writable: !0,
                            configurable: !1,
                            enumerable: !0,
                            value: null
                        },
                        allowCustomizedBuiltInElements: {
                            writable: !0,
                            configurable: !1,
                            enumerable: !0,
                            value: !1
                        }
                    })), be = null, Ee = null, ye = !0, De = !0, Le = !1, Se = !0, Fe = !1, _e = !1, ve = !1, Oe = !1, ke = !1, we = !1, Ne = !1, xe = !0, Re = !1;
                    const Ce = "user-content-";
                    let Me = !0, Ie = !1, Pe = {}, ze = null;
                    const We = L({}, [
                        "annotation-xml",
                        "audio",
                        "colgroup",
                        "desc",
                        "foreignobject",
                        "head",
                        "iframe",
                        "math",
                        "mi",
                        "mn",
                        "mo",
                        "ms",
                        "mtext",
                        "noembed",
                        "noframes",
                        "noscript",
                        "plaintext",
                        "script",
                        "style",
                        "svg",
                        "template",
                        "thead",
                        "title",
                        "video",
                        "xmp"
                    ]);
                    let He = null;
                    const Ue = L({}, [
                        "audio",
                        "video",
                        "img",
                        "source",
                        "image",
                        "track"
                    ]);
                    let Ge = null;
                    const Be = L({}, [
                        "alt",
                        "class",
                        "for",
                        "id",
                        "label",
                        "name",
                        "pattern",
                        "placeholder",
                        "role",
                        "summary",
                        "title",
                        "value",
                        "style",
                        "xmlns"
                    ]), je = "http://www.w3.org/1998/Math/MathML", qe = "http://www.w3.org/2000/svg", Ye = "http://www.w3.org/1999/xhtml";
                    let Ke = Ye, Xe = !1, Ve = null;
                    const $e = L({}, [
                        je,
                        qe,
                        Ye
                    ], m);
                    let Qe;
                    const Ze = [
                        "application/xhtml+xml",
                        "text/html"
                    ], Je = "text/html";
                    let et, tt = null;
                    const nt = l.createElement("form"), ot = function(e) {
                        return e instanceof RegExp || e instanceof Function;
                    }, it = function(e) {
                        if (!tt || tt !== e) {
                            if (e && "object" == typeof e || (e = {}), e = S(e), Qe = Qe = -1 === Ze.indexOf(e.PARSER_MEDIA_TYPE) ? Je : e.PARSER_MEDIA_TYPE, et = "application/xhtml+xml" === Qe ? m : d, me = "ALLOWED_TAGS" in e ? L({}, e.ALLOWED_TAGS, et) : he, ge = "ALLOWED_ATTR" in e ? L({}, e.ALLOWED_ATTR, et) : Te, Ve = "ALLOWED_NAMESPACES" in e ? L({}, e.ALLOWED_NAMESPACES, m) : $e, Ge = "ADD_URI_SAFE_ATTR" in e ? L(S(Be), e.ADD_URI_SAFE_ATTR, et) : Be, He = "ADD_DATA_URI_TAGS" in e ? L(S(Ue), e.ADD_DATA_URI_TAGS, et) : Ue, ze = "FORBID_CONTENTS" in e ? L({}, e.FORBID_CONTENTS, et) : We, be = "FORBID_TAGS" in e ? L({}, e.FORBID_TAGS, et) : {}, Ee = "FORBID_ATTR" in e ? L({}, e.FORBID_ATTR, et) : {}, Pe = "USE_PROFILES" in e && e.USE_PROFILES, ye = !1 !== e.ALLOW_ARIA_ATTR, De = !1 !== e.ALLOW_DATA_ATTR, Le = e.ALLOW_UNKNOWN_PROTOCOLS || !1, Se = !1 !== e.ALLOW_SELF_CLOSE_IN_ATTR, Fe = e.SAFE_FOR_TEMPLATES || !1, _e = e.WHOLE_DOCUMENT || !1, ke = e.RETURN_DOM || !1, we = e.RETURN_DOM_FRAGMENT || !1, Ne = e.RETURN_TRUSTED_TYPE || !1, Oe = e.FORCE_BODY || !1, xe = !1 !== e.SANITIZE_DOM, Re = e.SANITIZE_NAMED_PROPS || !1, Me = !1 !== e.KEEP_CONTENT, Ie = e.IN_PLACE || !1, de = e.ALLOWED_URI_REGEXP || G, Ke = e.NAMESPACE || Ye, Ae = e.CUSTOM_ELEMENT_HANDLING || {}, e.CUSTOM_ELEMENT_HANDLING && ot(e.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (Ae.tagNameCheck = e.CUSTOM_ELEMENT_HANDLING.tagNameCheck), e.CUSTOM_ELEMENT_HANDLING && ot(e.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (Ae.attributeNameCheck = e.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), e.CUSTOM_ELEMENT_HANDLING && "boolean" == typeof e.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (Ae.allowCustomizedBuiltInElements = e.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), Fe && (De = !1), we && (ke = !0), Pe && (me = L({}, [
                                ...x
                            ]), ge = [], !0 === Pe.html && (L(me, _), L(ge, R)), !0 === Pe.svg && (L(me, v), L(ge, C), L(ge, I)), !0 === Pe.svgFilters && (L(me, O), L(ge, C), L(ge, I)), !0 === Pe.mathMl && (L(me, w), L(ge, M), L(ge, I))), e.ADD_TAGS && (me === he && (me = S(me)), L(me, e.ADD_TAGS, et)), e.ADD_ATTR && (ge === Te && (ge = S(ge)), L(ge, e.ADD_ATTR, et)), e.ADD_URI_SAFE_ATTR && L(Ge, e.ADD_URI_SAFE_ATTR, et), e.FORBID_CONTENTS && (ze === We && (ze = S(ze)), L(ze, e.FORBID_CONTENTS, et)), Me && (me["#text"] = !0), _e && L(me, [
                                "html",
                                "head",
                                "body"
                            ]), me.table && (L(me, [
                                "tbody"
                            ]), delete be.tbody), e.TRUSTED_TYPES_POLICY) {
                                if ("function" != typeof e.TRUSTED_TYPES_POLICY.createHTML) throw E('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                                if ("function" != typeof e.TRUSTED_TYPES_POLICY.createScriptURL) throw E('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                                Z = e.TRUSTED_TYPES_POLICY, J = Z.createHTML("");
                            } else void 0 === Z && (Z = X(U, a)), null !== Z && "string" == typeof J && (J = Z.createHTML(""));
                            r && r(e), tt = e;
                        }
                    }, rt = L({}, [
                        "mi",
                        "mo",
                        "mn",
                        "ms",
                        "mtext"
                    ]), at = L({}, [
                        "foreignobject",
                        "desc",
                        "title",
                        "annotation-xml"
                    ]), lt = L({}, [
                        "title",
                        "style",
                        "font",
                        "a",
                        "script"
                    ]), ut = L({}, v);
                    L(ut, O), L(ut, k);
                    const st = L({}, w);
                    L(st, N);
                    const ct = function(e) {
                        let t = Q(e);
                        t && t.tagName || (t = {
                            namespaceURI: Ke,
                            tagName: "template"
                        });
                        const n = d(e.tagName), o = d(t.tagName);
                        return !!Ve[e.namespaceURI] && (e.namespaceURI === qe ? t.namespaceURI === Ye ? "svg" === n : t.namespaceURI === je ? "svg" === n && ("annotation-xml" === o || rt[o]) : Boolean(ut[n]) : e.namespaceURI === je ? t.namespaceURI === Ye ? "math" === n : t.namespaceURI === qe ? "math" === n && at[o] : Boolean(st[n]) : e.namespaceURI === Ye ? !(t.namespaceURI === qe && !at[o]) && !(t.namespaceURI === je && !rt[o]) && !st[n] && (lt[n] || !ut[n]) : !("application/xhtml+xml" !== Qe || !Ve[e.namespaceURI]));
                    }, ft = function(e) {
                        p(o.removed, {
                            element: e
                        });
                        try {
                            e.parentNode.removeChild(e);
                        } catch (t) {
                            e.remove();
                        }
                    }, pt = function(e, t) {
                        try {
                            p(o.removed, {
                                attribute: t.getAttributeNode(e),
                                from: t
                            });
                        } catch (e) {
                            p(o.removed, {
                                attribute: null,
                                from: t
                            });
                        }
                        if (t.removeAttribute(e), "is" === e && !ge[e]) {
                            if (ke || we) try {
                                ft(t);
                            } catch (e) {}
                            else try {
                                t.setAttribute(e, "");
                            } catch (e) {}
                        }
                    }, dt = function(e) {
                        let t, n;
                        if (Oe) e = "<remove></remove>" + e;
                        else {
                            const t = h(e, /^[\r\n\t ]+/);
                            n = t && t[0];
                        }
                        "application/xhtml+xml" === Qe && Ke === Ye && (e = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + e + "</body></html>");
                        const o = Z ? Z.createHTML(e) : e;
                        if (Ke === Ye) try {
                            t = (new H).parseFromString(o, Qe);
                        } catch (e) {}
                        if (!t || !t.documentElement) {
                            t = ee.createDocument(Ke, "template", null);
                            try {
                                t.documentElement.innerHTML = Xe ? J : o;
                            } catch (e) {}
                        }
                        const i = t.body || t.documentElement;
                        return e && n && i.insertBefore(l.createTextNode(n), i.childNodes[0] || null), Ke === Ye ? oe.call(t, _e ? "html" : "body")[0] : _e ? t.documentElement : i;
                    }, mt = function(e) {
                        return te.call(e.ownerDocument || e, e, P.SHOW_ELEMENT | P.SHOW_COMMENT | P.SHOW_TEXT, null, !1);
                    }, ht = function(e) {
                        return e instanceof W && ("string" != typeof e.nodeName || "string" != typeof e.textContent || "function" != typeof e.removeChild || !(e.attributes instanceof z) || "function" != typeof e.removeAttribute || "function" != typeof e.setAttribute || "string" != typeof e.namespaceURI || "function" != typeof e.insertBefore || "function" != typeof e.hasChildNodes);
                    }, gt = function(e) {
                        return "object" == typeof y ? e instanceof y : e && "object" == typeof e && "number" == typeof e.nodeType && "string" == typeof e.nodeName;
                    }, Tt = function(e, t, n) {
                        re[e] && c(re[e], (e)=>{
                            e.call(o, t, n, tt);
                        });
                    }, At = function(e) {
                        let t;
                        if (Tt("beforeSanitizeElements", e, null), ht(e)) return ft(e), !0;
                        const n = et(e.nodeName);
                        if (Tt("uponSanitizeElement", e, {
                            tagName: n,
                            allowedTags: me
                        }), e.hasChildNodes() && !gt(e.firstElementChild) && (!gt(e.content) || !gt(e.content.firstElementChild)) && b(/<[/\w]/g, e.innerHTML) && b(/<[/\w]/g, e.textContent)) return ft(e), !0;
                        if (!me[n] || be[n]) {
                            if (!be[n] && Et(n)) {
                                if (Ae.tagNameCheck instanceof RegExp && b(Ae.tagNameCheck, n)) return !1;
                                if (Ae.tagNameCheck instanceof Function && Ae.tagNameCheck(n)) return !1;
                            }
                            if (Me && !ze[n]) {
                                const t = Q(e) || e.parentNode, n = $(e) || e.childNodes;
                                if (n && t) for(let o = n.length - 1; o >= 0; --o)t.insertBefore(j(n[o], !0), V(e));
                            }
                            return ft(e), !0;
                        }
                        return e instanceof D && !ct(e) ? (ft(e), !0) : "noscript" !== n && "noembed" !== n && "noframes" !== n || !b(/<\/no(script|embed|frames)/i, e.innerHTML) ? (Fe && 3 === e.nodeType && (t = e.textContent, t = g(t, ae, " "), t = g(t, le, " "), t = g(t, ue, " "), e.textContent !== t && (p(o.removed, {
                            element: e.cloneNode()
                        }), e.textContent = t)), Tt("afterSanitizeElements", e, null), !1) : (ft(e), !0);
                    }, bt = function(e, t, n) {
                        if (xe && ("id" === t || "name" === t) && (n in l || n in nt)) return !1;
                        if (De && !Ee[t] && b(se, t)) ;
                        else if (ye && b(ce, t)) ;
                        else if (!ge[t] || Ee[t]) {
                            if (!(Et(e) && (Ae.tagNameCheck instanceof RegExp && b(Ae.tagNameCheck, e) || Ae.tagNameCheck instanceof Function && Ae.tagNameCheck(e)) && (Ae.attributeNameCheck instanceof RegExp && b(Ae.attributeNameCheck, t) || Ae.attributeNameCheck instanceof Function && Ae.attributeNameCheck(t)) || "is" === t && Ae.allowCustomizedBuiltInElements && (Ae.tagNameCheck instanceof RegExp && b(Ae.tagNameCheck, n) || Ae.tagNameCheck instanceof Function && Ae.tagNameCheck(n)))) return !1;
                        } else if (Ge[t]) ;
                        else if (b(de, g(n, pe, ""))) ;
                        else if ("src" !== t && "xlink:href" !== t && "href" !== t || "script" === e || 0 !== T(n, "data:") || !He[e]) {
                            if (Le && !b(fe, g(n, pe, ""))) ;
                            else if (n) return !1;
                        }
                        return !0;
                    }, Et = function(e) {
                        return e.indexOf("-") > 0;
                    }, yt = function(e) {
                        let t, n, i, r;
                        Tt("beforeSanitizeAttributes", e, null);
                        const { attributes: a } = e;
                        if (!a) return;
                        const l = {
                            attrName: "",
                            attrValue: "",
                            keepAttr: !0,
                            allowedAttributes: ge
                        };
                        for(r = a.length; r--;){
                            t = a[r];
                            const { name: u, namespaceURI: s } = t;
                            if (n = "value" === u ? t.value : A(t.value), i = et(u), l.attrName = i, l.attrValue = n, l.keepAttr = !0, l.forceKeepAttr = void 0, Tt("uponSanitizeAttribute", e, l), n = l.attrValue, l.forceKeepAttr) continue;
                            if (pt(u, e), !l.keepAttr) continue;
                            if (!Se && b(/\/>/i, n)) {
                                pt(u, e);
                                continue;
                            }
                            Fe && (n = g(n, ae, " "), n = g(n, le, " "), n = g(n, ue, " "));
                            const c = et(e.nodeName);
                            if (bt(c, i, n)) {
                                if (!Re || "id" !== i && "name" !== i || (pt(u, e), n = Ce + n), Z && "object" == typeof U && "function" == typeof U.getAttributeType) {
                                    if (s) ;
                                    else switch(U.getAttributeType(c, i)){
                                        case "TrustedHTML":
                                            n = Z.createHTML(n);
                                            break;
                                        case "TrustedScriptURL":
                                            n = Z.createScriptURL(n);
                                    }
                                }
                                try {
                                    s ? e.setAttributeNS(s, u, n) : e.setAttribute(u, n), f(o.removed);
                                } catch (e) {}
                            }
                        }
                        Tt("afterSanitizeAttributes", e, null);
                    }, Dt = function e(t) {
                        let n;
                        const o = mt(t);
                        for(Tt("beforeSanitizeShadowDOM", t, null); n = o.nextNode();)Tt("uponSanitizeShadowNode", n, null), At(n) || (n.content instanceof u && e(n.content), yt(n));
                        Tt("afterSanitizeShadowDOM", t, null);
                    };
                    return o.sanitize = function(e) {
                        let t, n, r, a, l = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        if (Xe = !e, Xe && (e = "<!-->"), "string" != typeof e && !gt(e)) {
                            if ("function" != typeof e.toString) throw E("toString is not a function");
                            if ("string" != typeof (e = e.toString())) throw E("dirty is not a string, aborting");
                        }
                        if (!o.isSupported) return e;
                        if (ve || it(l), o.removed = [], "string" == typeof e && (Ie = !1), Ie) {
                            if (e.nodeName) {
                                const t = et(e.nodeName);
                                if (!me[t] || be[t]) throw E("root node is forbidden and cannot be sanitized in-place");
                            }
                        } else if (e instanceof y) t = dt("<!---->"), n = t.ownerDocument.importNode(e, !0), 1 === n.nodeType && "BODY" === n.nodeName || "HTML" === n.nodeName ? t = n : t.appendChild(n);
                        else {
                            if (!ke && !Fe && !_e && -1 === e.indexOf("<")) return Z && Ne ? Z.createHTML(e) : e;
                            if (t = dt(e), !t) return ke ? null : Ne ? J : "";
                        }
                        t && Oe && ft(t.firstChild);
                        const s = mt(Ie ? e : t);
                        for(; r = s.nextNode();)At(r) || (r.content instanceof u && Dt(r.content), yt(r));
                        if (Ie) return e;
                        if (ke) {
                            if (we) for(a = ne.call(t.ownerDocument); t.firstChild;)a.appendChild(t.firstChild);
                            else a = t;
                            return (ge.shadowroot || ge.shadowrootmode) && (a = ie.call(i, a, !0)), a;
                        }
                        let c = _e ? t.outerHTML : t.innerHTML;
                        return _e && me["!doctype"] && t.ownerDocument && t.ownerDocument.doctype && t.ownerDocument.doctype.name && b(q, t.ownerDocument.doctype.name) && (c = "<!DOCTYPE " + t.ownerDocument.doctype.name + ">\n" + c), Fe && (c = g(c, ae, " "), c = g(c, le, " "), c = g(c, ue, " ")), Z && Ne ? Z.createHTML(c) : c;
                    }, o.setConfig = function(e) {
                        it(e), ve = !0;
                    }, o.clearConfig = function() {
                        tt = null, ve = !1;
                    }, o.isValidAttribute = function(e, t, n) {
                        tt || it({});
                        const o = et(e), i = et(t);
                        return bt(o, i, n);
                    }, o.addHook = function(e, t) {
                        "function" == typeof t && (re[e] = re[e] || [], p(re[e], t));
                    }, o.removeHook = function(e) {
                        if (re[e]) return f(re[e]);
                    }, o.removeHooks = function(e) {
                        re[e] && (re[e] = []);
                    }, o.removeAllHooks = function() {
                        re = {};
                    }, o;
                }();
            }();
        },
        function(t, n) {
            t.exports = e;
        },
        function(e, t, n) {
            "use strict";
            n.r(t);
            var o = n(1), i = n.n(o), r = n(0), a = n.n(r);
            function l(e) {
                return (l = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            function u(e, t) {
                var n = Object.keys(e);
                if (Object.getOwnPropertySymbols) {
                    var o = Object.getOwnPropertySymbols(e);
                    t && (o = o.filter(function(t) {
                        return Object.getOwnPropertyDescriptor(e, t).enumerable;
                    })), n.push.apply(n, o);
                }
                return n;
            }
            function s(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = null != arguments[t] ? arguments[t] : {};
                    t % 2 ? u(Object(n), !0).forEach(function(t) {
                        c(e, t, n[t]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : u(Object(n)).forEach(function(t) {
                        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                    });
                }
                return e;
            }
            function c(e, t, n) {
                return t in e ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e[t] = n, e;
            }
            function f(e, t) {
                for(var n = 0; n < t.length; n++){
                    var o = t[n];
                    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
                }
            }
            function p(e, t) {
                return (p = Object.setPrototypeOf || function(e, t) {
                    return e.__proto__ = t, e;
                })(e, t);
            }
            function d(e) {
                var t = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }();
                return function() {
                    var n, o = h(e);
                    if (t) {
                        var i = h(this).constructor;
                        n = Reflect.construct(o, arguments, i);
                    } else n = o.apply(this, arguments);
                    return m(this, n);
                };
            }
            function m(e, t) {
                return !t || "object" !== l(t) && "function" != typeof t ? function(e) {
                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e;
                }(e) : t;
            }
            function h(e) {
                return (h = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                    return e.__proto__ || Object.getPrototypeOf(e);
                })(e);
            }
            var g = i.a.import("modules/clipboard"), T = i.a.import("delta"), A = function(e) {
                !function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e,
                            writable: !0,
                            configurable: !0
                        }
                    }), t && p(e, t);
                }(l, e);
                var t, n, o, r = d(l);
                function l(e, t) {
                    var n;
                    return function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, l), (n = r.call(this, e, t)).allowed = t.allowed, n.keepSelection = t.keepSelection, n.substituteBlockElements = t.substituteBlockElements, n.magicPasteLinks = t.magicPasteLinks, n.hooks = t.hooks, n;
                }
                return t = l, n = [
                    {
                        key: "onPaste",
                        value: function(e) {
                            var t = this;
                            e.preventDefault();
                            var n, o, r, l, u, s = this.quill.getSelection();
                            e.clipboardData && e.clipboardData.getData || !window.clipboardData || !window.clipboardData.getData ? (n = e.clipboardData.getData("text/plain"), o = e.clipboardData.getData("text/html"), r = null === (l = e.clipboardData) || void 0 === l || null === (u = l.items) || void 0 === u ? void 0 : u[0]) : n = window.clipboardData.getData("Text");
                            var c = (new T).retain(s.index).delete(s.length), f = this.getDOMPurifyOptions(), p = !1, d = n;
                            if (!o && f.ALLOWED_TAGS.includes("a") && this.isURL(n) && s.length > 0 && this.magicPasteLinks) d = this.quill.getText(s.index, s.length), c = c.insert(d, {
                                link: n
                            });
                            else if (!o && f.ALLOWED_TAGS.includes("img") && r && "file" === r.kind && r.type.match(/^image\//i)) {
                                var m = r.getAsFile(), h = new FileReader;
                                h.onload = function(e) {
                                    t.quill.insertEmbed(s.index, "image", e.target.result), t.keepSelection || t.quill.setSelection(s.index + 1);
                                }, h.readAsDataURL(m);
                            } else {
                                var g, A, b, E, y, D, L, S, F;
                                o || (p = !0, o = d), "function" == typeof (null === (g = this.hooks) || void 0 === g ? void 0 : g.beforeSanitizeElements) && a.a.addHook("beforeSanitizeElements", this.hooks.beforeSanitizeElements), "function" == typeof (null === (A = this.hooks) || void 0 === A ? void 0 : A.uponSanitizeElement) && a.a.addHook("uponSanitizeElement", this.hooks.uponSanitizeElement), "function" == typeof (null === (b = this.hooks) || void 0 === b ? void 0 : b.afterSanitizeElements) && a.a.addHook("afterSanitizeElements", this.hooks.afterSanitizeElements), "function" == typeof (null === (E = this.hooks) || void 0 === E ? void 0 : E.beforeSanitizeAttributes) && a.a.addHook("beforeSanitizeAttributes", this.hooks.beforeSanitizeAttributes), "function" == typeof (null === (y = this.hooks) || void 0 === y ? void 0 : y.uponSanitizeAttribute) && a.a.addHook("uponSanitizeAttribute", this.hooks.uponSanitizeAttribute), "function" == typeof (null === (D = this.hooks) || void 0 === D ? void 0 : D.afterSanitizeAttributes) && a.a.addHook("afterSanitizeAttributes", this.hooks.afterSanitizeAttributes), "function" == typeof (null === (L = this.hooks) || void 0 === L ? void 0 : L.beforeSanitizeShadowDOM) && a.a.addHook("beforeSanitizeShadowDOM", this.hooks.beforeSanitizeShadowDOM), "function" == typeof (null === (S = this.hooks) || void 0 === S ? void 0 : S.uponSanitizeShadowNode) && a.a.addHook("uponSanitizeShadowNode", this.hooks.uponSanitizeShadowNode), "function" == typeof (null === (F = this.hooks) || void 0 === F ? void 0 : F.afterSanitizeShadowDOM) && a.a.addHook("afterSanitizeShadowDOM", this.hooks.afterSanitizeShadowDOM), p ? (d = a.a.sanitize(o, f), c = c.insert(d)) : (d = !1 !== this.substituteBlockElements ? (o = this.substitute(o, f)).innerHTML : a.a.sanitize(o, f), c = c.concat(this.convert(d)));
                            }
                            this.quill.updateContents(c, i.a.sources.USER), p || (c = this.convert(d)), this.keepSelection ? this.quill.setSelection(s.index, c.length(), i.a.sources.SILENT) : this.quill.setSelection(s.index + c.length(), i.a.sources.SILENT), this.quill.scrollIntoView(), a.a.removeAllHooks();
                        }
                    },
                    {
                        key: "getDOMPurifyOptions",
                        value: function() {
                            var e, t, n = {};
                            if (null !== (e = this.allowed) && void 0 !== e && e.tags && (n.ALLOWED_TAGS = this.allowed.tags), null !== (t = this.allowed) && void 0 !== t && t.attributes && (n.ALLOWED_ATTR = this.allowed.attributes), void 0 === n.ALLOWED_TAGS || void 0 === n.ALLOWED_ATTR) {
                                var o, i = !1;
                                void 0 === n.ALLOWED_TAGS && (i = !0, n.ALLOWED_TAGS = [
                                    "p",
                                    "br",
                                    "span"
                                ]);
                                var r = !1;
                                void 0 === n.ALLOWED_ATTR && (r = !0, n.ALLOWED_ATTR = [
                                    "class"
                                ]);
                                var a = this.quill.getModule("toolbar");
                                null == a || null === (o = a.controls) || void 0 === o || o.forEach(function(e) {
                                    switch(e[0]){
                                        case "bold":
                                            i && (n.ALLOWED_TAGS.push("b"), n.ALLOWED_TAGS.push("strong"));
                                            break;
                                        case "italic":
                                            i && (n.ALLOWED_TAGS.push("i"), n.ALLOWED_TAGS.push("em"));
                                            break;
                                        case "underline":
                                            i && n.ALLOWED_TAGS.push("u");
                                            break;
                                        case "strike":
                                            i && n.ALLOWED_TAGS.push("s");
                                            break;
                                        case "color":
                                        case "background":
                                            r && n.ALLOWED_ATTR.push("style");
                                            break;
                                        case "script":
                                            i && ("super" === e[1].value ? n.ALLOWED_TAGS.push("sup") : "sub" === e[1].value && n.ALLOWED_TAGS.push("sub"));
                                            break;
                                        case "header":
                                            if (i) {
                                                var t = function(e) {
                                                    "1" === e ? n.ALLOWED_TAGS.push("h1") : "2" === e ? n.ALLOWED_TAGS.push("h2") : "3" === e ? n.ALLOWED_TAGS.push("h3") : "4" === e ? n.ALLOWED_TAGS.push("h4") : "5" === e ? n.ALLOWED_TAGS.push("h5") : "6" === e && n.ALLOWED_TAGS.push("h6");
                                                };
                                                e[1].value ? t(e[1].value) : e[1].options && e[1].options.length && [].forEach.call(e[1].options, function(e) {
                                                    e.value && t(e.value);
                                                });
                                            }
                                            break;
                                        case "code-block":
                                            i && n.ALLOWED_TAGS.push("pre"), r && n.ALLOWED_ATTR.push("spellcheck");
                                            break;
                                        case "list":
                                            i && ("ordered" === e[1].value ? n.ALLOWED_TAGS.push("ol") : "bullet" === e[1].value && n.ALLOWED_TAGS.push("ul"), n.ALLOWED_TAGS.push("li"));
                                            break;
                                        case "link":
                                            i && n.ALLOWED_TAGS.push("a"), r && (n.ALLOWED_ATTR.push("href"), n.ALLOWED_ATTR.push("target"), n.ALLOWED_ATTR.push("rel"));
                                            break;
                                        case "image":
                                            i && n.ALLOWED_TAGS.push("img"), r && (n.ALLOWED_ATTR.push("src"), n.ALLOWED_ATTR.push("title"), n.ALLOWED_ATTR.push("alt"));
                                            break;
                                        case "video":
                                            i && n.ALLOWED_TAGS.push("iframe"), r && (n.ALLOWED_ATTR.push("frameborder"), n.ALLOWED_ATTR.push("allowfullscreen"), n.ALLOWED_ATTR.push("src"));
                                            break;
                                        case "blockquote":
                                            i && n.ALLOWED_TAGS.push(e[0]);
                                    }
                                });
                            }
                            return n;
                        }
                    },
                    {
                        key: "substitute",
                        value: function(e, t) {
                            var n, o = [
                                "h1",
                                "h2",
                                "h3",
                                "h4",
                                "h5",
                                "h6"
                            ], i = [
                                "p",
                                "div",
                                "section",
                                "article",
                                "fieldset",
                                "address",
                                "aside",
                                "blockquote",
                                "canvas",
                                "dl",
                                "figcaption",
                                "figure",
                                "footer",
                                "form",
                                "header",
                                "main",
                                "nav",
                                "noscript",
                                "ol",
                                "pre",
                                "table",
                                "tfoot",
                                "ul",
                                "video"
                            ], r = [
                                "li",
                                "dt",
                                "dd",
                                "hr"
                            ];
                            a.a.addHook("uponSanitizeElement", function(e, a, l) {
                                for(var u = 0; !n && u < 3;)t.ALLOWED_TAGS.includes(i[u]) && (n = i[u]), ++u;
                                if (n && e.tagName && !t.ALLOWED_TAGS.includes(e.tagName.toLowerCase())) {
                                    var s = e.tagName.toLowerCase();
                                    o.includes(s) ? e.innerHTML = "<".concat(n, "><b>").concat(e.innerHTML, "</b></").concat(n, ">") : i.includes(s) ? e.innerHTML = "<".concat(n, ">").concat(e.innerHTML, "</").concat(n, ">") : r.includes(s) && (e.innerHTML = "".concat(e.innerHTML, "<br>"));
                                }
                            }), e = a.a.sanitize(e, s(s({}, t), {
                                RETURN_DOM: !0,
                                WHOLE_DOCUMENT: !1
                            })), a.a.removeAllHooks();
                            var l, u = function(e) {
                                var t = document.createElement(e.tagName.toLowerCase()), n = e.attributes;
                                return n.length && Array.from(n).forEach(function(e) {
                                    return t.setAttribute(e.nodeName, e.value);
                                }), t;
                            }, c = 0, f = document.createElement("body");
                            return function e(t, n) {
                                for(n(t, c), t = c <= 1 ? t.firstChild : void 0; t;)++c, e(t, n), t = t.nextSibling;
                                --c;
                            }(e, function(e, t) {
                                if (1 === t) {
                                    if (e.tagName && i.includes(e.tagName.toLowerCase())) {
                                        l && (l = void 0);
                                        var o = u(e);
                                        o.innerHTML = e.innerHTML, f.appendChild(o);
                                    } else if (void 0 === l && (l = document.createElement(n), f.appendChild(l)), e.tagName) {
                                        var r = u(e);
                                        e.innerHTML && (r.innerHTML = e.innerHTML), l.appendChild(r);
                                    } else {
                                        var a = document.createTextNode(e.textContent);
                                        l.appendChild(a);
                                    }
                                }
                            }), f;
                        }
                    },
                    {
                        key: "isURL",
                        value: function(e) {
                            return !!/^(?:(?:http[s\u017F]?|ftp):\/\/)(?:(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+(?::(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?@)?(?:(?!10(?:\.[0-9]{1,3}){3})(?!127(?:\.[0-9]{1,3}){3})(?!169\.254(?:\.[0-9]{1,3}){2})(?!192\.168(?:\.[0-9]{1,3}){2})(?!172\.(?:1[6-9]|2[0-9]|3[01])(?:\.[0-9]{1,3}){2})(?:[1-9][0-9]?|1[0-9][0-9]|2[01][0-9]|22[0-3])(?:\.(?:1?[0-9]{1,2}|2[0-4][0-9]|25[0-5])){2}(?:\.(?:[1-9][0-9]?|1[0-9][0-9]|2[0-4][0-9]|25[0-4]))|(?:(?:(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+\x2D?)*(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)(?:\.(?:(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+\x2D?)*(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)*(?:\.(?:(?:[KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]){2,})))(?::[0-9]{2,5})?(?:\/(?:(?![\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF])[\s\S])*)?$/i.test(e);
                        }
                    }
                ], f(t.prototype, n), o && f(t, o), l;
            }(g);
            i.a.register("modules/clipboard", A, !0), t.default = A;
        }
    ]);
});

});

parcelRegister("2o2rI", function(module, exports) {
"use strict";
var $1bcfb868a9cab5d1$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(e, t, n, i) {
    void 0 === i && (i = n);
    var o = Object.getOwnPropertyDescriptor(t, n);
    o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
        enumerable: !0,
        get: function() {
            return t[n];
        }
    }), Object.defineProperty(e, i, o);
} : function(e, t, n, i) {
    void 0 === i && (i = n), e[i] = t[n];
}), $1bcfb868a9cab5d1$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(e, t) {
    Object.defineProperty(e, "default", {
        enumerable: !0,
        value: t
    });
} : function(e, t) {
    e.default = t;
}), $1bcfb868a9cab5d1$var$__importStar = module.exports && module.exports.__importStar || function(e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for(var n in e)"default" !== n && Object.prototype.hasOwnProperty.call(e, n) && $1bcfb868a9cab5d1$var$__createBinding(t, e, n);
    return $1bcfb868a9cab5d1$var$__setModuleDefault(t, e), t;
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.htmlToCanvas = module.exports.detectSize = void 0;

const $1bcfb868a9cab5d1$var$rasterizeHTML = $1bcfb868a9cab5d1$var$__importStar((parcelRequire("8Eauq")));

var $iPHWg = parcelRequire("iPHWg");
const $1bcfb868a9cab5d1$var$resetStyle = "\n<style>\n  html, body {\n    padding: 0;\n    margin: 0;\n  }\n  p {\n    margin: 0;\n    padding: 0\n  }\n  ul {\n    list-style-position: inside;\n    margin: 0;\n  }\n</style>\n", $1bcfb868a9cab5d1$var$hidden = document.createElement("div");
function $1bcfb868a9cab5d1$var$detectSize(e) {
    const t = document.createElement("div");
    t.innerHTML = e, t.style.display = "inline-block", t.style.position = "fixed", t.style.top = "0px", t.style.left = "0px", t.style.zIndex = "1000", $1bcfb868a9cab5d1$var$hidden.appendChild(t);
    const n = t.getBoundingClientRect();
    return $1bcfb868a9cab5d1$var$hidden.removeChild(t), {
        width: n.width,
        height: n.height
    };
}
async function $1bcfb868a9cab5d1$var$htmlToCanvas({ html: e, width: t, height: n, fontFamily: i, padding: o, font: d, pixelRatio: r }) {
    const l = document.createElement("canvas");
    if ("Arial" !== i && !d) {
        const t = (0, $iPHWg.getGoogleFontsVariants)();
        e += `<link type="text/css" href="https://fonts.googleapis.com/css?family=${i}:${t}" rel="stylesheet">`;
    }
    if (d) {
        const t = d.styles || (d.url ? [
            {
                src: `url("${d.url}")`
            }
        ] : []);
        e += "<style>", t.forEach((t)=>{
            e += `\n      @font-face {\n        font-family: '${i}';\n        src: ${t.src};\n        font-style: ${t.fontStyle || "normal"};\n        font-weight: ${t.fontWeight || "normal"};\n      }\n    `;
        }), e += "</style>";
    }
    e += $1bcfb868a9cab5d1$var$resetStyle;
    const s = await $1bcfb868a9cab5d1$var$rasterizeHTML.drawHTML(`<div style="padding: ${o}px;">${e}</div>`, l, {
        width: t + 2 * o,
        height: n + 2 * o
    });
    l.width = (t + 2 * o) * r, l.height = (n + 2 * o) * r;
    const a = l.getContext("2d");
    return null == a || a.drawImage(s.image, 0, 0, s.image.width * r, s.image.height * r), l;
}
$1bcfb868a9cab5d1$var$hidden.id = "polotno-hidden-do-not-touch", $1bcfb868a9cab5d1$var$hidden.style.overflow = "hidden", $1bcfb868a9cab5d1$var$hidden.style.position = "relative", document.body.appendChild($1bcfb868a9cab5d1$var$hidden), $1bcfb868a9cab5d1$var$hidden.innerHTML = "<style>\n#polotno-hidden-do-not-touch p {\n  margin: 0;\n  padding: 0\n}\n#polotno-hidden-do-not-touch ul {\n  list-style-position: inside;\n  margin: 0;\n}\n</style>", module.exports.detectSize = $1bcfb868a9cab5d1$var$detectSize, module.exports.htmlToCanvas = $1bcfb868a9cab5d1$var$htmlToCanvas;

});
parcelRegister("8Eauq", function(module, exports) {




/*! rasterizeHTML.js - v1.3.1 - 2022-01-16
* http://www.github.com/cburgmer/rasterizeHTML.js
* Copyright (c) 2022 Christoph Burgmer; Licensed MIT */ (function(root, factory) {
    if (root === undefined && window !== undefined) root = window;
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module unless amdModuleId is set
    define([
        "url",
        "xmlserializer",
        "sane-domparser-error",
        "inlineresources"
    ], function(a0, b1, c2, d3) {
        return root["rasterizeHTML"] = factory(a0, b1, c2, d3);
    });
    else if (0, module.exports) // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory((parcelRequire("kRFNf")), (parcelRequire("l4MZj")), (parcelRequire("lDFX4")), (parcelRequire("6cJtK")));
    else root["rasterizeHTML"] = factory(root["url"], root["xmlserializer"], root["sanedomparsererror"], root["inlineresources"]);
})(module.exports, function(url, xmlserializer, sanedomparsererror, inlineresources) {
    var util = function(url) {
        "use strict";
        var module1 = {};
        var uniqueIdList = [];
        module1.joinUrl = function(baseUrl, relUrl) {
            if (!baseUrl) return relUrl;
            return url.resolve(baseUrl, relUrl);
        };
        module1.getConstantUniqueIdFor = function(element) {
            // HACK, using a list results in O(n), but how do we hash e.g. a DOM node?
            if (uniqueIdList.indexOf(element) < 0) uniqueIdList.push(element);
            return uniqueIdList.indexOf(element);
        };
        module1.clone = function(object) {
            var theClone = {}, i;
            for(i in object)if (object.hasOwnProperty(i)) theClone[i] = object[i];
            return theClone;
        };
        var isObject = function(obj) {
            return typeof obj === "object" && obj !== null;
        };
        var isCanvas = function(obj) {
            return isObject(obj) && Object.prototype.toString.apply(obj).match(/\[object (Canvas|HTMLCanvasElement)\]/i);
        };
        // args: canvas, options
        module1.parseOptionalParameters = function(args) {
            var parameters = {
                canvas: null,
                options: {}
            };
            if (args[0] == null || isCanvas(args[0])) {
                parameters.canvas = args[0] || null;
                parameters.options = module1.clone(args[1]);
            } else parameters.options = module1.clone(args[0]);
            return parameters;
        };
        return module1;
    }(url);
    // Proxy objects by monkey patching
    var proxies = function(util) {
        "use strict";
        var module1 = {};
        var monkeyPatchInstanceMethod = function(object, methodName, proxyFunc) {
            var originalFunc = object[methodName];
            object[methodName] = function() {
                var args = Array.prototype.slice.call(arguments);
                return proxyFunc.apply(this, [
                    args,
                    originalFunc
                ]);
            };
            return originalFunc;
        };
        // Bases all XHR calls on the given base URL
        module1.baseUrlRespectingXhr = function(XHRObject, baseUrl) {
            var xhrConstructor = function() {
                var xhr = new XHRObject();
                monkeyPatchInstanceMethod(xhr, "open", function(args, originalOpen) {
                    var method = args.shift(), url = args.shift(), joinedUrl = util.joinUrl(baseUrl, url);
                    return originalOpen.apply(this, [
                        method,
                        joinedUrl
                    ].concat(args));
                });
                return xhr;
            };
            return xhrConstructor;
        };
        // Provides a convenient way of being notified when all pending XHR calls are finished
        module1.finishNotifyingXhr = function(XHRObject) {
            var totalXhrCount = 0, doneXhrCount = 0, waitingForPendingToClose = false;
            var checkAllRequestsFinished;
            var promise = new Promise(function(resolve) {
                checkAllRequestsFinished = function() {
                    var pendingXhrCount = totalXhrCount - doneXhrCount;
                    if (pendingXhrCount <= 0 && waitingForPendingToClose) resolve({
                        totalCount: totalXhrCount
                    });
                };
            });
            var xhrConstructor = function() {
                var xhr = new XHRObject();
                monkeyPatchInstanceMethod(xhr, "send", function(_, originalSend) {
                    totalXhrCount += 1;
                    return originalSend.apply(this, arguments);
                });
                xhr.addEventListener("load", function() {
                    doneXhrCount += 1;
                    checkAllRequestsFinished();
                });
                return xhr;
            };
            xhrConstructor.waitForRequestsToFinish = function() {
                waitingForPendingToClose = true;
                checkAllRequestsFinished();
                return promise;
            };
            return xhrConstructor;
        };
        return module1;
    }(util);
    var documentUtil = function() {
        "use strict";
        var module1 = {};
        var asArray = function(arrayLike) {
            return Array.prototype.slice.call(arrayLike);
        };
        module1.addClassName = function(element, className) {
            element.className += " " + className;
        };
        module1.addClassNameRecursively = function(element, className) {
            module1.addClassName(element, className);
            if (element.parentNode !== element.ownerDocument) module1.addClassNameRecursively(element.parentNode, className);
        };
        var changeCssRule = function(rule, newRuleText) {
            var styleSheet = rule.parentStyleSheet, ruleIdx = asArray(styleSheet.cssRules).indexOf(rule);
            // Exchange rule with the new text
            styleSheet.insertRule(newRuleText, ruleIdx + 1);
            styleSheet.deleteRule(ruleIdx);
        };
        var updateRuleSelector = function(rule, updatedSelector) {
            var styleDefinitions = rule.cssText.replace(/^[^\{]+/, ""), newRule = updatedSelector + " " + styleDefinitions;
            changeCssRule(rule, newRule);
        };
        var cssRulesToText = function(cssRules) {
            return asArray(cssRules).reduce(function(cssText, rule) {
                return cssText + rule.cssText;
            }, "");
        };
        var rewriteStyleContent = function(styleElement) {
            styleElement.textContent = cssRulesToText(styleElement.sheet.cssRules);
        };
        var addSheetPropertyToSvgStyleElement = function(svgStyleElement) {
            var doc = document.implementation.createHTMLDocument(""), cssStyleElement = document.createElement("style");
            cssStyleElement.textContent = svgStyleElement.textContent;
            // the style will only be parsed once it is added to a document
            doc.body.appendChild(cssStyleElement);
            svgStyleElement.sheet = cssStyleElement.sheet;
        };
        var matchingSimpleSelectorsRegex = function(simpleSelectorList) {
            return "((?:^|[^.#:\\w])|(?=\\W))(" + simpleSelectorList.join("|") + // one out of the given simple selectors
            ")" + "(?=\\W|$)"; // followed either by a non-alphabetic character or the end of the string
        };
        var replaceSimpleSelectorsBy = function(element, simpleSelectorList, caseInsensitiveReplaceFunc) {
            var selectorRegex = matchingSimpleSelectorsRegex(simpleSelectorList);
            asArray(element.querySelectorAll("style")).forEach(function(styleElement) {
                // SVGStyleElement doesn't have a property sheet in Safari, we need some workaround here
                // more details can be found here: https://github.com/cburgmer/rasterizeHTML.js/issues/158
                if (typeof styleElement.sheet === "undefined") addSheetPropertyToSvgStyleElement(styleElement);
                var matchingRules = asArray(styleElement.sheet.cssRules).filter(function(rule) {
                    return rule.selectorText && new RegExp(selectorRegex, "i").test(rule.selectorText);
                });
                if (matchingRules.length) {
                    matchingRules.forEach(function(rule) {
                        var newSelector = rule.selectorText.replace(new RegExp(selectorRegex, "gi"), function(_, prefixMatch, selectorMatch) {
                            return prefixMatch + caseInsensitiveReplaceFunc(selectorMatch);
                        });
                        if (newSelector !== rule.selectorText) updateRuleSelector(rule, newSelector);
                    });
                    rewriteStyleContent(styleElement);
                }
            });
        };
        module1.rewriteCssSelectorWith = function(element, oldSelector, newSelector) {
            replaceSimpleSelectorsBy(element, [
                oldSelector
            ], function() {
                return newSelector;
            });
        };
        module1.lowercaseCssTypeSelectors = function(element, matchingTagNames) {
            replaceSimpleSelectorsBy(element, matchingTagNames, function(match) {
                return match.toLowerCase();
            });
        };
        module1.findHtmlOnlyNodeNames = function(element) {
            var treeWalker = element.ownerDocument.createTreeWalker(element, NodeFilter.SHOW_ELEMENT), htmlNodeNames = {}, nonHtmlNodeNames = {}, currentTagName;
            do {
                currentTagName = treeWalker.currentNode.tagName.toLowerCase();
                if (treeWalker.currentNode.namespaceURI === "http://www.w3.org/1999/xhtml") htmlNodeNames[currentTagName] = true;
                else nonHtmlNodeNames[currentTagName] = true;
            }while (treeWalker.nextNode());
            return Object.keys(htmlNodeNames).filter(function(tagName) {
                return !nonHtmlNodeNames[tagName];
            });
        };
        return module1;
    }();
    var documentHelper = function(documentUtil) {
        "use strict";
        var module1 = {};
        var asArray = function(arrayLike) {
            return Array.prototype.slice.call(arrayLike);
        };
        var cascadingAction = {
            active: true,
            hover: true,
            focus: false,
            target: false
        };
        module1.fakeUserAction = function(element, selector, action) {
            var elem = element.querySelector(selector), pseudoClass = ":" + action, fakeActionClass = "rasterizehtml" + action;
            if (!elem) return;
            if (cascadingAction[action]) documentUtil.addClassNameRecursively(elem, fakeActionClass);
            else documentUtil.addClassName(elem, fakeActionClass);
            documentUtil.rewriteCssSelectorWith(element, pseudoClass, "." + fakeActionClass);
        };
        module1.persistInputValues = function(doc) {
            var inputs = doc.querySelectorAll("input"), textareas = doc.querySelectorAll("textarea"), isCheckable = function(input) {
                return input.type === "checkbox" || input.type === "radio";
            };
            asArray(inputs).filter(isCheckable).forEach(function(input) {
                if (input.checked) input.setAttribute("checked", "");
                else input.removeAttribute("checked");
            });
            asArray(inputs).filter(function(input) {
                return !isCheckable(input);
            }).forEach(function(input) {
                input.setAttribute("value", input.value);
            });
            asArray(textareas).forEach(function(textarea) {
                textarea.textContent = textarea.value;
            });
        };
        module1.rewriteTagNameSelectorsToLowerCase = function(element) {
            documentUtil.lowercaseCssTypeSelectors(element, documentUtil.findHtmlOnlyNodeNames(element));
        };
        return module1;
    }(documentUtil);
    var browser = function(util, proxies, sanedomparsererror, theWindow) {
        "use strict";
        var module1 = {};
        var createHiddenElement = function(doc, tagName, width, height) {
            var element = doc.createElement(tagName);
            // 'display: none' doesn't cut it, as browsers seem to be lazy loading CSS
            element.style.visibility = "hidden";
            element.style.width = width + "px";
            element.style.height = height + "px";
            element.style.position = "absolute";
            element.style.top = -10000 - height + "px";
            element.style.left = -10000 - width + "px";
            // We need to add the element to the document so that its content gets loaded
            doc.getElementsByTagName("body")[0].appendChild(element);
            return element;
        };
        var wait = function(timeout) {
            if (timeout > 0) return new Promise(function(resolve) {
                setTimeout(resolve, timeout);
            });
            else return Promise.resolve();
        };
        module1.executeJavascript = function(element, options) {
            return new Promise(function(resolve) {
                var iframe = createHiddenElement(theWindow.document, "iframe", options.width, options.height), html = element.outerHTML, iframeErrorsMessages = [], executeJsTimeout = options.executeJsTimeout || 0;
                var cleanUp = function() {
                    // We have to defer removing the iframe from the current document, see https://github.com/cburgmer/rasterizeHTML.js/issues/219
                    theWindow.document.getElementsByTagName("body")[0].removeChild(iframe);
                };
                var doResolve = function() {
                    var doc = iframe.contentDocument;
                    resolve({
                        document: doc,
                        errors: iframeErrorsMessages,
                        cleanUp: cleanUp
                    });
                };
                var xhr = iframe.contentWindow.XMLHttpRequest, finishNotifyXhrProxy = proxies.finishNotifyingXhr(xhr), baseUrlXhrProxy = proxies.baseUrlRespectingXhr(finishNotifyXhrProxy, options.baseUrl);
                iframe.onload = function() {
                    wait(executeJsTimeout).then(finishNotifyXhrProxy.waitForRequestsToFinish).then(doResolve);
                };
                iframe.contentDocument.open();
                iframe.contentWindow.XMLHttpRequest = baseUrlXhrProxy;
                iframe.contentWindow.onerror = function(msg) {
                    iframeErrorsMessages.push({
                        resourceType: "scriptExecution",
                        msg: msg
                    });
                };
                iframe.contentDocument.write("<!DOCTYPE html>");
                iframe.contentDocument.write(html);
                iframe.contentDocument.close();
            });
        };
        var createHiddenSandboxedIFrame = function(doc, width, height) {
            var iframe = doc.createElement("iframe");
            iframe.style.width = width + "px";
            iframe.style.height = height + "px";
            // 'display: none' doesn't cut it, as browsers seem to be lazy loading content
            iframe.style.visibility = "hidden";
            iframe.style.position = "absolute";
            iframe.style.top = -10000 - height + "px";
            iframe.style.left = -10000 - width + "px";
            // make sure content gets exact width independent of box-sizing value
            iframe.style.borderWidth = 0;
            // Don't execute JS, all we need from sandboxing is access to the iframe's document
            iframe.sandbox = "allow-same-origin";
            // Don't include a scrollbar on Linux
            iframe.scrolling = "no";
            return iframe;
        };
        var createIframeWithSizeAtZoomLevel1 = function(width, height, zoom) {
            var scaledViewportWidth = Math.floor(width / zoom), scaledViewportHeight = Math.floor(height / zoom);
            return createHiddenSandboxedIFrame(theWindow.document, scaledViewportWidth, scaledViewportHeight);
        };
        var calculateZoomedContentSizeAndRoundUp = function(actualViewport, requestedWidth, requestedHeight, zoom) {
            return {
                width: Math.max(actualViewport.width * zoom, requestedWidth),
                height: Math.max(actualViewport.height * zoom, requestedHeight)
            };
        };
        var selectElementOrDescendant = function(element, selector) {
            var descendant = element.querySelector(selector);
            if (descendant) return descendant;
            else if (element.ownerDocument.querySelector(selector) === element) return element;
            throw {
                message: "Clipping selector not found"
            };
        };
        var calculateContentSize = function(rootElement, selector, requestedWidth, requestedHeight, zoom) {
            // clientWidth/clientHeight needed for PhantomJS
            var actualViewportWidth = Math.max(rootElement.scrollWidth, rootElement.clientWidth), actualViewportHeight = Math.max(rootElement.scrollHeight, rootElement.clientHeight), top, left, originalWidth, originalHeight, rootFontSize, element, rect, contentSize;
            if (selector) {
                element = selectElementOrDescendant(rootElement, selector);
                rect = element.getBoundingClientRect();
                top = rect.top;
                left = rect.left;
                originalWidth = rect.width;
                originalHeight = rect.height;
            } else {
                top = 0;
                left = 0;
                originalWidth = actualViewportWidth;
                originalHeight = actualViewportHeight;
            }
            contentSize = calculateZoomedContentSizeAndRoundUp({
                width: originalWidth,
                height: originalHeight
            }, requestedWidth, requestedHeight, zoom);
            rootFontSize = theWindow.getComputedStyle(rootElement.ownerDocument.documentElement).fontSize;
            return {
                left: left,
                top: top,
                width: contentSize.width,
                height: contentSize.height,
                viewportWidth: actualViewportWidth,
                viewportHeight: actualViewportHeight,
                rootFontSize: rootFontSize
            };
        };
        var findCorrelatingElement = function(element, documentClone) {
            var tagName = element.tagName;
            // Stupid but simple method: find first match. Should work for a single HTML element, and any other element given as root
            return documentClone.querySelector(tagName);
        };
        var elementToFullHtmlDocument = function(element) {
            var tagName = element.tagName.toLowerCase();
            if (tagName === "html" || tagName === "body") return element.outerHTML;
            // Simple hack: hide the body from sizing, otherwise browser would apply a 8px margin
            return '<body style="margin: 0;">' + element.outerHTML + "</body>";
        };
        module1.calculateDocumentContentSize = function(element, options) {
            return new Promise(function(resolve, reject) {
                var zoom = options.zoom || 1, iframe;
                iframe = createIframeWithSizeAtZoomLevel1(options.width, options.height, zoom);
                // We need to add the element to the document so that its content gets loaded
                theWindow.document.getElementsByTagName("body")[0].appendChild(iframe);
                iframe.onload = function() {
                    var doc = iframe.contentDocument, size;
                    try {
                        size = calculateContentSize(findCorrelatingElement(element, doc), options.clip, options.width, options.height, zoom);
                        resolve(size);
                    } catch (e) {
                        reject(e);
                    } finally{
                        theWindow.document.getElementsByTagName("body")[0].removeChild(iframe);
                    }
                };
                // srcdoc doesn't work in PhantomJS yet
                iframe.contentDocument.open();
                iframe.contentDocument.write("<!DOCTYPE html>");
                iframe.contentDocument.write(elementToFullHtmlDocument(element));
                iframe.contentDocument.close();
            });
        };
        module1.parseHtmlFragment = function(htmlFragment) {
            var doc = theWindow.document.implementation.createHTMLDocument("");
            doc.documentElement.innerHTML = htmlFragment;
            var element = doc.querySelector("body").firstChild;
            if (!element) throw "Invalid source";
            return element;
        };
        var addHTMLTagAttributes = function(doc, html) {
            var attributeMatch = /<html((?:\s+[^>]*)?)>/im.exec(html), helperDoc = theWindow.document.implementation.createHTMLDocument(""), htmlTagSubstitute, i, elementSubstitute, attribute;
            if (!attributeMatch) return;
            htmlTagSubstitute = "<div" + attributeMatch[1] + "></div>";
            helperDoc.documentElement.innerHTML = htmlTagSubstitute;
            elementSubstitute = helperDoc.querySelector("div");
            for(i = 0; i < elementSubstitute.attributes.length; i++){
                attribute = elementSubstitute.attributes[i];
                doc.documentElement.setAttribute(attribute.name, attribute.value);
            }
        };
        module1.parseHTML = function(html) {
            // We should be using the DOMParser, but it is not supported in older browsers
            var doc = theWindow.document.implementation.createHTMLDocument("");
            doc.documentElement.innerHTML = html;
            addHTMLTagAttributes(doc, html);
            return doc;
        };
        var failOnInvalidSource = function(doc) {
            try {
                return sanedomparsererror.failOnParseError(doc);
            } catch (e) {
                throw {
                    message: "Invalid source",
                    originalError: e
                };
            }
        };
        module1.validateXHTML = function(xhtml) {
            var p = new DOMParser(), doc = p.parseFromString(xhtml, "application/xml");
            failOnInvalidSource(doc);
        };
        var lastCacheDate = null;
        var getUncachableURL = function(url, cache) {
            if (cache === "none" || cache === "repeated") {
                if (lastCacheDate === null || cache !== "repeated") lastCacheDate = Date.now();
                return url + "?_=" + lastCacheDate;
            } else return url;
        };
        var doDocumentLoad = function(url, options) {
            return new Promise(function(resolve, reject) {
                var xhr = new window.XMLHttpRequest(), joinedUrl = util.joinUrl(options.baseUrl, url), augmentedUrl = getUncachableURL(joinedUrl, options.cache), doReject = function(e) {
                    reject({
                        message: "Unable to load page",
                        originalError: e
                    });
                };
                xhr.addEventListener("load", function() {
                    if (xhr.status === 200 || xhr.status === 0) resolve(xhr.responseXML);
                    else doReject(xhr.statusText);
                }, false);
                xhr.addEventListener("error", function(e) {
                    doReject(e);
                }, false);
                try {
                    xhr.open("GET", augmentedUrl, true);
                    xhr.responseType = "document";
                    xhr.send(null);
                } catch (e) {
                    doReject(e);
                }
            });
        };
        module1.loadDocument = function(url, options) {
            return doDocumentLoad(url, options).then(function(doc) {
                return failOnInvalidSource(doc);
            });
        };
        return module1;
    }(util, proxies, sanedomparsererror, window);
    var svg2image = function(window1) {
        "use strict";
        var module1 = {};
        var urlForSvg = function(svg, useBlobs) {
            if (useBlobs) return URL.createObjectURL(new Blob([
                svg
            ], {
                type: "image/svg+xml"
            }));
            else return "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg);
        };
        var cleanUpUrl = function(url) {
            if (url instanceof Blob) URL.revokeObjectURL(url);
        };
        var simpleForeignObjectSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="1" height="1"><foreignObject></foreignObject></svg>';
        var supportsReadingObjectFromCanvas = function(url) {
            return new Promise(function(resolve, reject) {
                var canvas = document.createElement("canvas"), image = new Image();
                image.onload = function() {
                    var context = canvas.getContext("2d");
                    try {
                        context.drawImage(image, 0, 0);
                        // This will fail in Chrome & Safari
                        canvas.toDataURL("image/png");
                        resolve(true);
                    } catch (e) {
                        resolve(false);
                    }
                };
                image.onerror = reject;
                image.src = url;
            });
        };
        var readingBackFromCanvasBenefitsFromOldSchoolDataUris = function() {
            // Check for work around for https://code.google.com/p/chromium/issues/detail?id=294129
            var blobUrl = urlForSvg(simpleForeignObjectSvg, true);
            return supportsReadingObjectFromCanvas(blobUrl).then(function(supportsReadingFromBlobs) {
                cleanUpUrl(blobUrl);
                if (supportsReadingFromBlobs) return false;
                return supportsReadingObjectFromCanvas(urlForSvg(simpleForeignObjectSvg, false)).then(function(s) {
                    return s;
                });
            }, function() {
                return false;
            });
        };
        var supportsBlobBuilding = function() {
            if (window1.Blob) // Available as constructor only in newer builds for all browsers
            try {
                new Blob([
                    "<b></b>"
                ], {
                    type: "text/xml"
                });
                return true;
            } catch (err) {}
            return false;
        };
        var checkBlobSupport = function() {
            return new Promise(function(resolve, reject) {
                if (supportsBlobBuilding() && window1.URL) readingBackFromCanvasBenefitsFromOldSchoolDataUris().then(function(doesBenefit) {
                    resolve(!doesBenefit);
                }, function() {
                    reject();
                });
                else resolve(false);
            });
        };
        var checkForBlobsResult;
        var checkForBlobs = function() {
            if (checkForBlobsResult === undefined) checkForBlobsResult = checkBlobSupport();
            return checkForBlobsResult;
        };
        var buildImageUrl = function(svg) {
            return checkForBlobs().then(function(useBlobs) {
                return urlForSvg(svg, useBlobs);
            });
        };
        module1.renderSvg = function(svg) {
            return new Promise(function(resolve, reject) {
                var url, image, resetEventHandlers = function() {
                    image.onload = null;
                    image.onerror = null;
                }, cleanUp = function() {
                    if (url) cleanUpUrl(url);
                };
                image = new Image();
                image.onload = function() {
                    resetEventHandlers();
                    cleanUp();
                    resolve(image);
                };
                image.onerror = function() {
                    cleanUp();
                    reject();
                };
                buildImageUrl(svg).then(function(imageUrl) {
                    url = imageUrl;
                    image.src = url;
                }, reject);
            });
        };
        return module1;
    }(window);
    var document2svg = function(util, browser, documentHelper, xmlserializer) {
        "use strict";
        var module1 = {};
        var svgAttributes = function(size, zoom) {
            var zoomFactor = zoom || 1;
            var attributes = {
                width: size.width,
                height: size.height,
                "font-size": size.rootFontSize
            };
            if (zoomFactor !== 1) attributes.style = "transform:scale(" + zoomFactor + "); transform-origin: 0 0;";
            return attributes;
        };
        var foreignObjectAttributes = function(size) {
            var closestScaledWith, closestScaledHeight, offsetX, offsetY;
            closestScaledWith = Math.round(size.viewportWidth);
            closestScaledHeight = Math.round(size.viewportHeight);
            offsetX = -size.left;
            offsetY = -size.top;
            var attributes = {
                x: offsetX,
                y: offsetY,
                width: closestScaledWith,
                height: closestScaledHeight
            };
            return attributes;
        };
        var workAroundCollapsingMarginsAcrossSVGElementInWebKitLike = function(attributes) {
            var style = attributes.style || "";
            attributes.style = style + "float: left;";
        };
        var workAroundSafariSometimesNotShowingExternalResources = function(attributes) {
            /* Let's hope that works some magic. The spec says SVGLoad only fires
         * now when all externals are available.
         * http://www.w3.org/TR/SVG/struct.html#ExternalResourcesRequired */ attributes.externalResourcesRequired = true;
        };
        var workAroundChromeShowingScrollbarsUnderLinuxIfHtmlIsOverflowScroll = function() {
            return '<style scoped="">html::-webkit-scrollbar { display: none; }</style>';
        };
        var serializeAttributes = function(attributes) {
            var keys = Object.keys(attributes);
            if (!keys.length) return "";
            return " " + keys.map(function(key) {
                return key + '="' + attributes[key] + '"';
            }).join(" ");
        };
        var convertElementToSvg = function(element, size, zoomFactor) {
            var xhtml = xmlserializer.serializeToString(element);
            browser.validateXHTML(xhtml);
            var foreignObjectAttrs = foreignObjectAttributes(size);
            workAroundCollapsingMarginsAcrossSVGElementInWebKitLike(foreignObjectAttrs);
            workAroundSafariSometimesNotShowingExternalResources(foreignObjectAttrs);
            return '<svg xmlns="http://www.w3.org/2000/svg"' + serializeAttributes(svgAttributes(size, zoomFactor)) + ">" + workAroundChromeShowingScrollbarsUnderLinuxIfHtmlIsOverflowScroll() + "<foreignObject" + serializeAttributes(foreignObjectAttrs) + ">" + xhtml + "</foreignObject>" + "</svg>";
        };
        module1.getSvgForDocument = function(element, size, zoomFactor) {
            documentHelper.rewriteTagNameSelectorsToLowerCase(element);
            return convertElementToSvg(element, size, zoomFactor);
        };
        module1.drawDocumentAsSvg = function(element, options) {
            [
                "hover",
                "active",
                "focus",
                "target"
            ].forEach(function(action) {
                if (options[action]) documentHelper.fakeUserAction(element, options[action], action);
            });
            return browser.calculateDocumentContentSize(element, options).then(function(size) {
                return module1.getSvgForDocument(element, size, options.zoom);
            });
        };
        return module1;
    }(util, browser, documentHelper, xmlserializer);
    var rasterize = function(util, browser, documentHelper, document2svg, svg2image, inlineresources) {
        "use strict";
        var module1 = {};
        var generalDrawError = function(e) {
            return {
                message: "Error rendering page",
                originalError: e
            };
        };
        var drawSvgAsImg = function(svg) {
            return svg2image.renderSvg(svg).then(function(image) {
                return {
                    image: image,
                    svg: svg
                };
            }, function(e) {
                throw generalDrawError(e);
            });
        };
        var drawImageOnCanvas = function(image, canvas) {
            try {
                canvas.getContext("2d").drawImage(image, 0, 0);
            } catch (e) {
                // Firefox throws a 'NS_ERROR_NOT_AVAILABLE' if the SVG is faulty
                throw generalDrawError(e);
            }
        };
        var doDraw = function(element, canvas, options) {
            return document2svg.drawDocumentAsSvg(element, options).then(drawSvgAsImg).then(function(result) {
                if (canvas) drawImageOnCanvas(result.image, canvas);
                return result;
            });
        };
        var operateJavaScriptOnDocument = function(element, options) {
            return browser.executeJavascript(element, options).then(function(result) {
                var document1 = result.document;
                documentHelper.persistInputValues(document1);
                return {
                    document: document1,
                    errors: result.errors,
                    cleanUp: result.cleanUp
                };
            });
        };
        module1.rasterize = function(element, canvas, options) {
            var inlineOptions;
            inlineOptions = util.clone(options);
            inlineOptions.inlineScripts = options.executeJs === true;
            return inlineresources.inlineReferences(element, inlineOptions).then(function(errors) {
                if (options.executeJs) return operateJavaScriptOnDocument(element, options).then(function(result) {
                    return {
                        element: result.document.documentElement,
                        errors: errors.concat(result.errors),
                        cleanUp: result.cleanUp
                    };
                });
                else return {
                    element: element,
                    errors: errors,
                    cleanUp: function() {}
                };
            }).then(function(result) {
                return doDraw(result.element, canvas, options).then(function(drawResult) {
                    result.cleanUp();
                    return {
                        image: drawResult.image,
                        svg: drawResult.svg,
                        errors: result.errors
                    };
                });
            });
        };
        return module1;
    }(util, browser, documentHelper, document2svg, svg2image, inlineresources);
    var rasterizeHTML = function(util, browser, rasterize) {
        "use strict";
        var module1 = {};
        var getViewportSize = function(canvas, options) {
            var defaultWidth = 300, defaultHeight = 200, fallbackWidth = canvas ? canvas.width : defaultWidth, fallbackHeight = canvas ? canvas.height : defaultHeight, width = options.width !== undefined ? options.width : fallbackWidth, height = options.height !== undefined ? options.height : fallbackHeight;
            return {
                width: width,
                height: height
            };
        };
        var constructOptions = function(params) {
            var viewport = getViewportSize(params.canvas, params.options), options;
            options = util.clone(params.options);
            options.width = viewport.width;
            options.height = viewport.height;
            return options;
        };
        /**
     * Draws a Document to the canvas.
     * rasterizeHTML.drawDocument( document [, canvas] [, options] ).then(function (result) { ... });
     */ module1.drawDocument = function() {
            var doc = arguments[0], optionalArguments = Array.prototype.slice.call(arguments, 1), params = util.parseOptionalParameters(optionalArguments);
            var element = doc.documentElement ? doc.documentElement : doc;
            return rasterize.rasterize(element, params.canvas, constructOptions(params));
        };
        var drawHTML = function(html, canvas, options) {
            var doc = browser.parseHTML(html);
            return module1.drawDocument(doc, canvas, options);
        };
        /**
     * Draws a HTML string to the canvas.
     * rasterizeHTML.drawHTML( html [, canvas] [, options] ).then(function (result) { ... });
     */ module1.drawHTML = function() {
            var html = arguments[0], optionalArguments = Array.prototype.slice.call(arguments, 1), params = util.parseOptionalParameters(optionalArguments);
            return drawHTML(html, params.canvas, params.options);
        };
        // work around https://bugzilla.mozilla.org/show_bug.cgi?id=925493
        var workAroundFirefoxNotLoadingStylesheetStyles = function(doc, url, options) {
            var d = document.implementation.createHTMLDocument("");
            d.replaceChild(doc.documentElement, d.documentElement);
            var extendedOptions = options ? util.clone(options) : {};
            if (!options.baseUrl) extendedOptions.baseUrl = url;
            return {
                document: d,
                options: extendedOptions
            };
        };
        var drawURL = function(url, canvas, options) {
            return browser.loadDocument(url, options).then(function(doc) {
                var workaround = workAroundFirefoxNotLoadingStylesheetStyles(doc, url, options);
                return module1.drawDocument(workaround.document, canvas, workaround.options);
            });
        };
        /**
     * Draws a page to the canvas.
     * rasterizeHTML.drawURL( url [, canvas] [, options] ).then(function (result) { ... });
     */ module1.drawURL = function() {
            var url = arguments[0], optionalArguments = Array.prototype.slice.call(arguments, 1), params = util.parseOptionalParameters(optionalArguments);
            return drawURL(url, params.canvas, params.options);
        };
        return module1;
    }(util, browser, rasterize);
    return rasterizeHTML;
});

});
parcelRegister("kRFNf", function(module, exports) {
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ "use strict";

var $hvgp4 = parcelRequire("hvgp4");
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */ var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */ delims = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    "\n",
    "	"
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    "'"
].concat(unwise), /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */ nonHostChars = [
    "%",
    "/",
    "?",
    ";",
    "#"
].concat(autoEscape), hostEndingChars = [
    "/",
    "?",
    "#"
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    javascript: true,
    "javascript:": true
}, // protocols that never have a hostname.
hostlessProtocol = {
    javascript: true,
    "javascript:": true
}, // protocols that always contain a // bit.
slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    "http:": true,
    "https:": true,
    "ftp:": true,
    "gopher:": true,
    "file:": true
};

var $kddvv = parcelRequire("kddvv");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && typeof url === "object" && url instanceof Url) return url;
    var u = new Url();
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (typeof url !== "string") throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */ var queryIndex = url.indexOf("?"), splitter = queryIndex !== -1 && queryIndex < url.indexOf("#") ? "?" : "#", uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, "/");
    url = uSplit.join(splitter);
    var rest = url;
    /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */ rest = rest.trim();
    if (!slashesDenoteHost && url.split("#").length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $kddvv.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = "";
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
        var slashes = rest.substr(0, 2) === "//";
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */ /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */ // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */ var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf("@");
        else /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */ atSign = rest.lastIndexOf("@", hostEnd);
        /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */ if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */ this.hostname = this.hostname || "";
        /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */ var ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = "";
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */ newpart += "x";
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = "/" + notHost.join(".") + rest;
                        this.hostname = validParts.join(".");
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = "";
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */ this.hostname = $hvgp4.toASCII(this.hostname);
        var p = this.port ? ":" + this.port : "";
        var h = this.hostname || "";
        this.host = h + p;
        this.href += this.host;
        /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */ if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== "/") rest = "/" + rest;
        }
    }
    /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */ if (!unsafeProtocol[lowerProto]) /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */ for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf("#");
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf("?");
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $kddvv.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = "";
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "/";
    // to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || "";
        var s = this.search || "";
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */ if (typeof obj === "string") obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || "";
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ":");
        auth += "@";
    }
    var protocol = this.protocol || "", pathname = this.pathname || "", hash = this.hash || "", host = false, query = "";
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]");
        if (this.port) host += ":" + this.port;
    }
    if (this.query && typeof this.query === "object" && Object.keys(this.query).length) query = $kddvv.stringify(this.query, {
        arrayFormat: "repeat",
        addQueryPrefix: false
    });
    var search = this.search || query && "?" + query || "";
    if (protocol && protocol.substr(-1) !== ":") protocol += ":";
    /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */ if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = "//" + (host || "");
        if (pathname && pathname.charAt(0) !== "/") pathname = "/" + pathname;
    } else if (!host) host = "";
    if (hash && hash.charAt(0) !== "#") hash = "#" + hash;
    if (search && search.charAt(0) !== "?") search = "?" + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace("#", "%23");
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if (typeof relative === "string") {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */ result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === "") {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== "protocol") result[rkey] = relative[rkey];
        }
        // urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
            result.pathname = "/";
            result.path = result.pathname;
        }
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */ if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || "").split("/");
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = "";
            if (!relative.hostname) relative.hostname = "";
            if (relPath[0] !== "") relPath.unshift("");
            if (relPath.length < 2) relPath.unshift("");
            result.pathname = relPath.join("/");
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || "";
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || "";
            var s = result.search || "";
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === "/", isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === "/", mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split("/") || [], relPath = relative.pathname && relative.pathname.split("/") || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */ if (psychotic) {
        result.hostname = "";
        result.port = null;
        if (result.host) {
            if (srcPath[0] === "") srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = "";
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === "") relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === "" || srcPath[0] === "");
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === "" ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === "" ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */ if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (relative.search != null) {
        /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */ if (psychotic) {
            result.host = srcPath.shift();
            result.hostname = result.host;
            /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */ var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.hostname = authInHost.shift();
                result.host = result.hostname;
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        // to support http.request
        if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */ result.pathname = null;
        // to support http.request
        if (result.search) result.path = "/" + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */ var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === "." || last === "..") || last === "";
    /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */ var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === ".") srcPath.splice(i, 1);
        else if (last === "..") {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift("..");
    if (mustEndAbs && srcPath[0] !== "" && (!srcPath[0] || srcPath[0].charAt(0) !== "/")) srcPath.unshift("");
    if (hasTrailingSlash && srcPath.join("/").substr(-1) !== "/") srcPath.push("");
    var isAbsolute = srcPath[0] === "" || srcPath[0] && srcPath[0].charAt(0) === "/";
    // put the host back
    if (psychotic) {
        result.hostname = isAbsolute ? "" : srcPath.length ? srcPath.shift() : "";
        result.host = result.hostname;
        /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */ var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.hostname = authInHost.shift();
            result.host = result.hostname;
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift("");
    if (srcPath.length > 0) result.pathname = srcPath.join("/");
    else {
        result.pathname = null;
        result.path = null;
    }
    // to support request.http
    if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ":") this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;

});
parcelRegister("hvgp4", function(module, exports) {
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == "object" && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = "";
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join("");
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error("invalid-input");
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error("overflow");
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error("overflow");
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error("overflow");
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ "version": "1.4.1",
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) define("punycode", function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

});

parcelRegister("kddvv", function(module, exports) {
"use strict";

var $2T9Py = parcelRequire("2T9Py");

var $btZEt = parcelRequire("btZEt");

var $jScx1 = parcelRequire("jScx1");
module.exports = {
    formats: $jScx1,
    parse: $btZEt,
    stringify: $2T9Py
};

});
parcelRegister("2T9Py", function(module, exports) {
"use strict";

var $aF2j2 = parcelRequire("aF2j2");

var $gHu7A = parcelRequire("gHu7A");

var $jScx1 = parcelRequire("jScx1");
var $21a857f2c632f015$var$has = Object.prototype.hasOwnProperty;
var $21a857f2c632f015$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $21a857f2c632f015$var$isArray = Array.isArray;
var $21a857f2c632f015$var$push = Array.prototype.push;
var $21a857f2c632f015$var$pushToArray = function(arr, valueOrArray) {
    $21a857f2c632f015$var$push.apply(arr, $21a857f2c632f015$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $21a857f2c632f015$var$toISO = Date.prototype.toISOString;
var $21a857f2c632f015$var$defaultFormat = $jScx1.default;
var $21a857f2c632f015$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encodeDotInKeys: false,
    encoder: $gHu7A.encode,
    encodeValuesOnly: false,
    format: $21a857f2c632f015$var$defaultFormat,
    formatter: $jScx1.formatters[$21a857f2c632f015$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $21a857f2c632f015$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $21a857f2c632f015$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var $21a857f2c632f015$var$sentinel = {};
var $21a857f2c632f015$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($21a857f2c632f015$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== "undefined") {
            if (pos === step) throw new RangeError("Cyclic object value");
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($21a857f2c632f015$var$sentinel) === "undefined") step = 0;
    }
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && $21a857f2c632f015$var$isArray(obj)) obj = $gHu7A.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $21a857f2c632f015$var$defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if ($21a857f2c632f015$var$isNonNullishPrimitive(obj) || $gHu7A.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $21a857f2c632f015$var$defaults.encoder, charset, "key", format);
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, $21a857f2c632f015$var$defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && $21a857f2c632f015$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $gHu7A.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(",") || null : void 0
            }
        ];
    } else if ($21a857f2c632f015$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? prefix.replace(/\./g, "%2E") : prefix;
    var adjustedPrefix = commaRoundTrip && $21a857f2c632f015$var$isArray(obj) && obj.length === 1 ? encodedPrefix + "[]" : encodedPrefix;
    if (allowEmptyArrays && $21a857f2c632f015$var$isArray(obj) && obj.length === 0) return adjustedPrefix + "[]";
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? key.replace(/\./g, "%2E") : key;
        var keyPrefix = $21a857f2c632f015$var$isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + encodedKey : "[" + encodedKey + "]");
        sideChannel.set(object, step);
        var valueSideChannel = $aF2j2();
        valueSideChannel.set($21a857f2c632f015$var$sentinel, sideChannel);
        $21a857f2c632f015$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === "comma" && encodeValuesOnly && $21a857f2c632f015$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $21a857f2c632f015$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $21a857f2c632f015$var$defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.encodeDotInKeys !== "undefined" && typeof opts.encodeDotInKeys !== "boolean") throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || $21a857f2c632f015$var$defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = $jScx1.default;
    if (typeof opts.format !== "undefined") {
        if (!$21a857f2c632f015$var$has.call($jScx1.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = $jScx1.formatters[format];
    var filter = $21a857f2c632f015$var$defaults.filter;
    if (typeof opts.filter === "function" || $21a857f2c632f015$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $21a857f2c632f015$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ("indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = $21a857f2c632f015$var$defaults.arrayFormat;
    if ("commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.encodeDotInKeys === true ? true : $21a857f2c632f015$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : $21a857f2c632f015$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : $21a857f2c632f015$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $21a857f2c632f015$var$defaults.charsetSentinel,
        commaRoundTrip: opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === "undefined" ? $21a857f2c632f015$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : $21a857f2c632f015$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === "boolean" ? opts.encodeDotInKeys : $21a857f2c632f015$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === "function" ? opts.encoder : $21a857f2c632f015$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : $21a857f2c632f015$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : $21a857f2c632f015$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : $21a857f2c632f015$var$defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $21a857f2c632f015$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $21a857f2c632f015$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if ($21a857f2c632f015$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var generateArrayPrefix = $21a857f2c632f015$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === "comma" && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $aF2j2();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $21a857f2c632f015$var$pushToArray(keys, $21a857f2c632f015$var$stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};

});
parcelRegister("aF2j2", function(module, exports) {
"use strict";

var $2DXy1 = parcelRequire("2DXy1");

var $46SHr = parcelRequire("46SHr");

var $1vLFW = parcelRequire("1vLFW");

var $6bQrM = parcelRequire("6bQrM");
var $7c2f85ad8c1b0afb$var$$WeakMap = $2DXy1("%WeakMap%", true);
var $7c2f85ad8c1b0afb$var$$Map = $2DXy1("%Map%", true);
var $7c2f85ad8c1b0afb$var$$weakMapGet = $46SHr("WeakMap.prototype.get", true);
var $7c2f85ad8c1b0afb$var$$weakMapSet = $46SHr("WeakMap.prototype.set", true);
var $7c2f85ad8c1b0afb$var$$weakMapHas = $46SHr("WeakMap.prototype.has", true);
var $7c2f85ad8c1b0afb$var$$mapGet = $46SHr("Map.prototype.get", true);
var $7c2f85ad8c1b0afb$var$$mapSet = $46SHr("Map.prototype.set", true);
var $7c2f85ad8c1b0afb$var$$mapHas = $46SHr("Map.prototype.has", true);
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list. By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('.').listGetNode} */ var $7c2f85ad8c1b0afb$var$listGetNode = function(list, key) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    for(; (curr = prev.next) !== null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        // eslint-disable-next-line no-extra-parens
        curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
        list.next = curr; // eslint-disable-line no-param-reassign
        return curr;
    }
};
/** @type {import('.').listGet} */ var $7c2f85ad8c1b0afb$var$listGet = function(objects, key) {
    var node = $7c2f85ad8c1b0afb$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('.').listSet} */ var $7c2f85ad8c1b0afb$var$listSet = function(objects, key, value) {
    var node = $7c2f85ad8c1b0afb$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('.').ListNode<typeof value>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('.').listHas} */ var $7c2f85ad8c1b0afb$var$listHas = function(objects, key) {
    return !!$7c2f85ad8c1b0afb$var$listGetNode(objects, key);
};
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @type {WeakMap<object, unknown>} */ var $wm;
    /** @type {Map<object, unknown>} */ var $m;
    /** @type {import('.').RootNode<unknown>} */ var $o;
    /** @type {import('.').Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $6bQrM("Side channel does not contain " + $1vLFW(key));
        },
        get: function(key) {
            if ($7c2f85ad8c1b0afb$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $7c2f85ad8c1b0afb$var$$weakMapGet($wm, key);
            } else if ($7c2f85ad8c1b0afb$var$$Map) {
                if ($m) return $7c2f85ad8c1b0afb$var$$mapGet($m, key);
            } else {
                if ($o) return $7c2f85ad8c1b0afb$var$listGet($o, key);
            }
        },
        has: function(key) {
            if ($7c2f85ad8c1b0afb$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $7c2f85ad8c1b0afb$var$$weakMapHas($wm, key);
            } else if ($7c2f85ad8c1b0afb$var$$Map) {
                if ($m) return $7c2f85ad8c1b0afb$var$$mapHas($m, key);
            } else {
                if ($o) return $7c2f85ad8c1b0afb$var$listHas($o, key);
            }
            return false;
        },
        set: function(key, value) {
            if ($7c2f85ad8c1b0afb$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if (!$wm) $wm = new $7c2f85ad8c1b0afb$var$$WeakMap();
                $7c2f85ad8c1b0afb$var$$weakMapSet($wm, key, value);
            } else if ($7c2f85ad8c1b0afb$var$$Map) {
                if (!$m) $m = new $7c2f85ad8c1b0afb$var$$Map();
                $7c2f85ad8c1b0afb$var$$mapSet($m, key, value);
            } else {
                if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
                $o = {
                    key: {},
                    next: null
                };
                $7c2f85ad8c1b0afb$var$listSet($o, key, value);
            }
        }
    };
    return channel;
};

});
parcelRegister("2DXy1", function(module, exports) {
"use strict";
var $1ecd6a3b805ecadb$var$undefined1;

var $c7Ac6 = parcelRequire("c7Ac6");

var $elYtN = parcelRequire("elYtN");

var $1S2Qw = parcelRequire("1S2Qw");

var $8T8lL = parcelRequire("8T8lL");

var $f0gvj = parcelRequire("f0gvj");

var $6bQrM = parcelRequire("6bQrM");

var $03ZFS = parcelRequire("03ZFS");
var $1ecd6a3b805ecadb$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $1ecd6a3b805ecadb$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $1ecd6a3b805ecadb$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $1ecd6a3b805ecadb$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($1ecd6a3b805ecadb$var$$gOPD) try {
    $1ecd6a3b805ecadb$var$$gOPD({}, "");
} catch (e) {
    $1ecd6a3b805ecadb$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $1ecd6a3b805ecadb$var$throwTypeError = function() {
    throw new $6bQrM();
};
var $1ecd6a3b805ecadb$var$ThrowTypeError = $1ecd6a3b805ecadb$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $1ecd6a3b805ecadb$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $1ecd6a3b805ecadb$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $1ecd6a3b805ecadb$var$throwTypeError;
        }
    }
}() : $1ecd6a3b805ecadb$var$throwTypeError;

var $1ecd6a3b805ecadb$var$hasSymbols = (parcelRequire("dKI7M"))();

var $1ecd6a3b805ecadb$var$hasProto = (parcelRequire("eNnvx"))();
var $1ecd6a3b805ecadb$var$getProto = Object.getPrototypeOf || ($1ecd6a3b805ecadb$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $1ecd6a3b805ecadb$var$needsEval = {};
var $1ecd6a3b805ecadb$var$TypedArray = typeof Uint8Array === "undefined" || !$1ecd6a3b805ecadb$var$getProto ? undefined : $1ecd6a3b805ecadb$var$getProto(Uint8Array);
var $1ecd6a3b805ecadb$var$INTRINSICS = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $1ecd6a3b805ecadb$var$hasSymbols && $1ecd6a3b805ecadb$var$getProto ? $1ecd6a3b805ecadb$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $1ecd6a3b805ecadb$var$needsEval,
    "%AsyncGenerator%": $1ecd6a3b805ecadb$var$needsEval,
    "%AsyncGeneratorFunction%": $1ecd6a3b805ecadb$var$needsEval,
    "%AsyncIteratorPrototype%": $1ecd6a3b805ecadb$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": $c7Ac6,
    "%eval%": eval,
    "%EvalError%": $elYtN,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $1ecd6a3b805ecadb$var$$Function,
    "%GeneratorFunction%": $1ecd6a3b805ecadb$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $1ecd6a3b805ecadb$var$hasSymbols && $1ecd6a3b805ecadb$var$getProto ? $1ecd6a3b805ecadb$var$getProto($1ecd6a3b805ecadb$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$1ecd6a3b805ecadb$var$hasSymbols || !$1ecd6a3b805ecadb$var$getProto ? undefined : $1ecd6a3b805ecadb$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": $1S2Qw,
    "%ReferenceError%": $8T8lL,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$1ecd6a3b805ecadb$var$hasSymbols || !$1ecd6a3b805ecadb$var$getProto ? undefined : $1ecd6a3b805ecadb$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $1ecd6a3b805ecadb$var$hasSymbols && $1ecd6a3b805ecadb$var$getProto ? $1ecd6a3b805ecadb$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $1ecd6a3b805ecadb$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $f0gvj,
    "%ThrowTypeError%": $1ecd6a3b805ecadb$var$ThrowTypeError,
    "%TypedArray%": $1ecd6a3b805ecadb$var$TypedArray,
    "%TypeError%": $6bQrM,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": $03ZFS,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($1ecd6a3b805ecadb$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $1ecd6a3b805ecadb$var$errorProto = $1ecd6a3b805ecadb$var$getProto($1ecd6a3b805ecadb$var$getProto(e));
    $1ecd6a3b805ecadb$var$INTRINSICS["%Error.prototype%"] = $1ecd6a3b805ecadb$var$errorProto;
}
var $1ecd6a3b805ecadb$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $1ecd6a3b805ecadb$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $1ecd6a3b805ecadb$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $1ecd6a3b805ecadb$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $1ecd6a3b805ecadb$var$getProto) value = $1ecd6a3b805ecadb$var$getProto(gen.prototype);
    }
    $1ecd6a3b805ecadb$var$INTRINSICS[name] = value;
    return value;
};
var $1ecd6a3b805ecadb$var$LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $6FqDH = parcelRequire("6FqDH");

var $aZPoB = parcelRequire("aZPoB");
var $1ecd6a3b805ecadb$var$$concat = $6FqDH.call(Function.call, Array.prototype.concat);
var $1ecd6a3b805ecadb$var$$spliceApply = $6FqDH.call(Function.apply, Array.prototype.splice);
var $1ecd6a3b805ecadb$var$$replace = $6FqDH.call(Function.call, String.prototype.replace);
var $1ecd6a3b805ecadb$var$$strSlice = $6FqDH.call(Function.call, String.prototype.slice);
var $1ecd6a3b805ecadb$var$$exec = $6FqDH.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $1ecd6a3b805ecadb$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $1ecd6a3b805ecadb$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $1ecd6a3b805ecadb$var$stringToPath = function stringToPath(string) {
    var first = $1ecd6a3b805ecadb$var$$strSlice(string, 0, 1);
    var last = $1ecd6a3b805ecadb$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $f0gvj("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $f0gvj("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $1ecd6a3b805ecadb$var$$replace(string, $1ecd6a3b805ecadb$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $1ecd6a3b805ecadb$var$$replace(subString, $1ecd6a3b805ecadb$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $1ecd6a3b805ecadb$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($aZPoB($1ecd6a3b805ecadb$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $1ecd6a3b805ecadb$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($aZPoB($1ecd6a3b805ecadb$var$INTRINSICS, intrinsicName)) {
        var value = $1ecd6a3b805ecadb$var$INTRINSICS[intrinsicName];
        if (value === $1ecd6a3b805ecadb$var$needsEval) value = $1ecd6a3b805ecadb$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $6bQrM("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $f0gvj("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $6bQrM("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $6bQrM('"allowMissing" argument must be a boolean');
    if ($1ecd6a3b805ecadb$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $f0gvj("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $1ecd6a3b805ecadb$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $1ecd6a3b805ecadb$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $1ecd6a3b805ecadb$var$$spliceApply(parts, $1ecd6a3b805ecadb$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $1ecd6a3b805ecadb$var$$strSlice(part, 0, 1);
        var last = $1ecd6a3b805ecadb$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $f0gvj("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($aZPoB($1ecd6a3b805ecadb$var$INTRINSICS, intrinsicRealName)) value = $1ecd6a3b805ecadb$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $6bQrM("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($1ecd6a3b805ecadb$var$$gOPD && i + 1 >= parts.length) {
                var desc = $1ecd6a3b805ecadb$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $aZPoB(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $1ecd6a3b805ecadb$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("c7Ac6", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("elYtN", function(module, exports) {
"use strict";
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("1S2Qw", function(module, exports) {
"use strict";
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("8T8lL", function(module, exports) {
"use strict";
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("f0gvj", function(module, exports) {
"use strict";
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("6bQrM", function(module, exports) {
"use strict";
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("03ZFS", function(module, exports) {
"use strict";
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("dKI7M", function(module, exports) {
"use strict";
var $a031cc6b762c4e12$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $3ukNm = parcelRequire("3ukNm");
module.exports = function hasNativeSymbols() {
    if (typeof $a031cc6b762c4e12$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $a031cc6b762c4e12$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $3ukNm();
};

});
parcelRegister("3ukNm", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("eNnvx", function(module, exports) {
"use strict";
var $ac57e0689712e64d$var$test = {
    __proto__: null,
    foo: {}
};
var $ac57e0689712e64d$var$$Object = Object;
/** @type {import('.')} */ module.exports = function hasProto() {
    // @ts-expect-error: TS errors on an inherited property for some reason
    return ({
        __proto__: $ac57e0689712e64d$var$test
    }).foo === $ac57e0689712e64d$var$test.foo && !($ac57e0689712e64d$var$test instanceof $ac57e0689712e64d$var$$Object);
};

});

parcelRegister("6FqDH", function(module, exports) {
"use strict";

var $kfm3A = parcelRequire("kfm3A");
module.exports = Function.prototype.bind || $kfm3A;

});
parcelRegister("kfm3A", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $ebd6516147fbc56f$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $ebd6516147fbc56f$var$toStr = Object.prototype.toString;
var $ebd6516147fbc56f$var$max = Math.max;
var $ebd6516147fbc56f$var$funcType = "[object Function]";
var $ebd6516147fbc56f$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $ebd6516147fbc56f$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $ebd6516147fbc56f$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $ebd6516147fbc56f$var$toStr.apply(target) !== $ebd6516147fbc56f$var$funcType) throw new TypeError($ebd6516147fbc56f$var$ERROR_MESSAGE + target);
    var args = $ebd6516147fbc56f$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $ebd6516147fbc56f$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $ebd6516147fbc56f$var$concatty(args, arguments));
    };
    var boundLength = $ebd6516147fbc56f$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $ebd6516147fbc56f$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("aZPoB", function(module, exports) {
"use strict";
var $8017780892750505$var$call = Function.prototype.call;
var $8017780892750505$var$$hasOwn = Object.prototype.hasOwnProperty;

var $6FqDH = parcelRequire("6FqDH");
/** @type {import('.')} */ module.exports = $6FqDH.call($8017780892750505$var$call, $8017780892750505$var$$hasOwn);

});


parcelRegister("46SHr", function(module, exports) {
"use strict";

var $2DXy1 = parcelRequire("2DXy1");

var $fxEK7 = parcelRequire("fxEK7");
var $2fe227279405861b$var$$indexOf = $fxEK7($2DXy1("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $2DXy1(name, !!allowMissing);
    if (typeof intrinsic === "function" && $2fe227279405861b$var$$indexOf(name, ".prototype.") > -1) return $fxEK7(intrinsic);
    return intrinsic;
};

});
parcelRegister("fxEK7", function(module, exports) {
"use strict";

var $6FqDH = parcelRequire("6FqDH");

var $2DXy1 = parcelRequire("2DXy1");

var $ix8O9 = parcelRequire("ix8O9");

var $6bQrM = parcelRequire("6bQrM");
var $b5098ac553b04d45$var$$apply = $2DXy1("%Function.prototype.apply%");
var $b5098ac553b04d45$var$$call = $2DXy1("%Function.prototype.call%");
var $b5098ac553b04d45$var$$reflectApply = $2DXy1("%Reflect.apply%", true) || $6FqDH.call($b5098ac553b04d45$var$$call, $b5098ac553b04d45$var$$apply);

var $5bmkL = parcelRequire("5bmkL");
var $b5098ac553b04d45$var$$max = $2DXy1("%Math.max%");
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $6bQrM("a function is required");
    var func = $b5098ac553b04d45$var$$reflectApply($6FqDH, $b5098ac553b04d45$var$$call, arguments);
    return $ix8O9(func, 1 + $b5098ac553b04d45$var$$max(0, originalFunction.length - (arguments.length - 1)), true);
};
var $b5098ac553b04d45$var$applyBind = function applyBind() {
    return $b5098ac553b04d45$var$$reflectApply($6FqDH, $b5098ac553b04d45$var$$apply, arguments);
};
if ($5bmkL) $5bmkL(module.exports, "apply", {
    value: $b5098ac553b04d45$var$applyBind
});
else module.exports.apply = $b5098ac553b04d45$var$applyBind;

});
parcelRegister("ix8O9", function(module, exports) {
"use strict";

var $2DXy1 = parcelRequire("2DXy1");

var $326QS = parcelRequire("326QS");

var $d7e2241cf3c714ea$var$hasDescriptors = (parcelRequire("aszze"))();

var $liPrR = parcelRequire("liPrR");

var $6bQrM = parcelRequire("6bQrM");
var $d7e2241cf3c714ea$var$$floor = $2DXy1("%Math.floor%");
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $6bQrM("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $d7e2241cf3c714ea$var$$floor(length) !== length) throw new $6bQrM("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && $liPrR) {
        var desc = $liPrR(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($d7e2241cf3c714ea$var$hasDescriptors) $326QS(/** @type {Parameters<define>[0]} */ fn, "length", length, true, true);
        else $326QS(/** @type {Parameters<define>[0]} */ fn, "length", length);
    }
    return fn;
};

});
parcelRegister("326QS", function(module, exports) {
"use strict";

var $5bmkL = parcelRequire("5bmkL");

var $f0gvj = parcelRequire("f0gvj");

var $6bQrM = parcelRequire("6bQrM");

var $liPrR = parcelRequire("liPrR");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $6bQrM("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $6bQrM("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $6bQrM("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $6bQrM("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $6bQrM("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $6bQrM("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$liPrR && $liPrR(obj, property);
    if ($5bmkL) $5bmkL(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $f0gvj("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

});
parcelRegister("5bmkL", function(module, exports) {
"use strict";

var $2DXy1 = parcelRequire("2DXy1");
/** @type {import('.')} */ var $3c5f4de337a65054$var$$defineProperty = $2DXy1("%Object.defineProperty%", true) || false;
if ($3c5f4de337a65054$var$$defineProperty) try {
    $3c5f4de337a65054$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $3c5f4de337a65054$var$$defineProperty = false;
}
module.exports = $3c5f4de337a65054$var$$defineProperty;

});

parcelRegister("liPrR", function(module, exports) {
"use strict";

var $2DXy1 = parcelRequire("2DXy1");
var $f8232ffed2d58f72$var$$gOPD = $2DXy1("%Object.getOwnPropertyDescriptor%", true);
if ($f8232ffed2d58f72$var$$gOPD) try {
    $f8232ffed2d58f72$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $f8232ffed2d58f72$var$$gOPD = null;
}
module.exports = $f8232ffed2d58f72$var$$gOPD;

});


parcelRegister("aszze", function(module, exports) {
"use strict";

var $5bmkL = parcelRequire("5bmkL");
var $79d81bcf012c6ef5$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$5bmkL;
};
$79d81bcf012c6ef5$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$5bmkL) return null;
    try {
        return $5bmkL([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $79d81bcf012c6ef5$var$hasPropertyDescriptors;

});




parcelRegister("1vLFW", function(module, exports) {
var $119dab09bed9f066$var$hasMap = typeof Map === "function" && Map.prototype;
var $119dab09bed9f066$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $119dab09bed9f066$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var $119dab09bed9f066$var$mapSize = $119dab09bed9f066$var$hasMap && $119dab09bed9f066$var$mapSizeDescriptor && typeof $119dab09bed9f066$var$mapSizeDescriptor.get === "function" ? $119dab09bed9f066$var$mapSizeDescriptor.get : null;
var $119dab09bed9f066$var$mapForEach = $119dab09bed9f066$var$hasMap && Map.prototype.forEach;
var $119dab09bed9f066$var$hasSet = typeof Set === "function" && Set.prototype;
var $119dab09bed9f066$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $119dab09bed9f066$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var $119dab09bed9f066$var$setSize = $119dab09bed9f066$var$hasSet && $119dab09bed9f066$var$setSizeDescriptor && typeof $119dab09bed9f066$var$setSizeDescriptor.get === "function" ? $119dab09bed9f066$var$setSizeDescriptor.get : null;
var $119dab09bed9f066$var$setForEach = $119dab09bed9f066$var$hasSet && Set.prototype.forEach;
var $119dab09bed9f066$var$hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var $119dab09bed9f066$var$weakMapHas = $119dab09bed9f066$var$hasWeakMap ? WeakMap.prototype.has : null;
var $119dab09bed9f066$var$hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var $119dab09bed9f066$var$weakSetHas = $119dab09bed9f066$var$hasWeakSet ? WeakSet.prototype.has : null;
var $119dab09bed9f066$var$hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var $119dab09bed9f066$var$weakRefDeref = $119dab09bed9f066$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $119dab09bed9f066$var$booleanValueOf = Boolean.prototype.valueOf;
var $119dab09bed9f066$var$objectToString = Object.prototype.toString;
var $119dab09bed9f066$var$functionToString = Function.prototype.toString;
var $119dab09bed9f066$var$$match = String.prototype.match;
var $119dab09bed9f066$var$$slice = String.prototype.slice;
var $119dab09bed9f066$var$$replace = String.prototype.replace;
var $119dab09bed9f066$var$$toUpperCase = String.prototype.toUpperCase;
var $119dab09bed9f066$var$$toLowerCase = String.prototype.toLowerCase;
var $119dab09bed9f066$var$$test = RegExp.prototype.test;
var $119dab09bed9f066$var$$concat = Array.prototype.concat;
var $119dab09bed9f066$var$$join = Array.prototype.join;
var $119dab09bed9f066$var$$arrSlice = Array.prototype.slice;
var $119dab09bed9f066$var$$floor = Math.floor;
var $119dab09bed9f066$var$bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var $119dab09bed9f066$var$gOPS = Object.getOwnPropertySymbols;
var $119dab09bed9f066$var$symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var $119dab09bed9f066$var$hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
// ie, `has-tostringtag/shams
var $119dab09bed9f066$var$toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === $119dab09bed9f066$var$hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var $119dab09bed9f066$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $119dab09bed9f066$var$gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $119dab09bed9f066$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $119dab09bed9f066$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === "number") {
        var int = num < 0 ? -$119dab09bed9f066$var$$floor(-num) : $119dab09bed9f066$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $119dab09bed9f066$var$$slice.call(str, intStr.length + 1);
            return $119dab09bed9f066$var$$replace.call(intStr, sepRegex, "$&_") + "." + $119dab09bed9f066$var$$replace.call($119dab09bed9f066$var$$replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
    }
    return $119dab09bed9f066$var$$replace.call(str, sepRegex, "$&_");
}

var $foUwZ = parcelRequire("foUwZ");
var $119dab09bed9f066$var$inspectCustom = $foUwZ.custom;
var $119dab09bed9f066$var$inspectSymbol = $119dab09bed9f066$var$isSymbol($119dab09bed9f066$var$inspectCustom) ? $119dab09bed9f066$var$inspectCustom : null;
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($119dab09bed9f066$var$has(opts, "quoteStyle") && opts.quoteStyle !== "single" && opts.quoteStyle !== "double") throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($119dab09bed9f066$var$has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $119dab09bed9f066$var$has(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean" && customInspect !== "symbol") throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if ($119dab09bed9f066$var$has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($119dab09bed9f066$var$has(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === "undefined") return "undefined";
    if (obj === null) return "null";
    if (typeof obj === "boolean") return obj ? "true" : "false";
    if (typeof obj === "string") return $119dab09bed9f066$var$inspectString(obj, opts);
    if (typeof obj === "number") {
        if (obj === 0) return Infinity / obj > 0 ? "0" : "-0";
        var str = String(obj);
        return numericSeparator ? $119dab09bed9f066$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === "bigint") {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? $119dab09bed9f066$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") return $119dab09bed9f066$var$isArray(obj) ? "[Array]" : "[Object]";
    var indent = $119dab09bed9f066$var$getIndent(opts, depth);
    if (typeof seen === "undefined") seen = [];
    else if ($119dab09bed9f066$var$indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $119dab09bed9f066$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($119dab09bed9f066$var$has(opts, "quoteStyle")) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function" && !$119dab09bed9f066$var$isRegExp(obj)) {
        var name = $119dab09bed9f066$var$nameOf(obj);
        var keys = $119dab09bed9f066$var$arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $119dab09bed9f066$var$$join.call(keys, ", ") + " }" : "");
    }
    if ($119dab09bed9f066$var$isSymbol(obj)) {
        var symString = $119dab09bed9f066$var$hasShammedSymbols ? $119dab09bed9f066$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : $119dab09bed9f066$var$symToString.call(obj);
        return typeof obj === "object" && !$119dab09bed9f066$var$hasShammedSymbols ? $119dab09bed9f066$var$markBoxed(symString) : symString;
    }
    if ($119dab09bed9f066$var$isElement(obj)) {
        var s = "<" + $119dab09bed9f066$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + $119dab09bed9f066$var$wrapQuotes($119dab09bed9f066$var$quote(attrs[i].value), "double", opts);
        s += ">";
        if (obj.childNodes && obj.childNodes.length) s += "...";
        s += "</" + $119dab09bed9f066$var$$toLowerCase.call(String(obj.nodeName)) + ">";
        return s;
    }
    if ($119dab09bed9f066$var$isArray(obj)) {
        if (obj.length === 0) return "[]";
        var xs = $119dab09bed9f066$var$arrObjKeys(obj, inspect);
        if (indent && !$119dab09bed9f066$var$singleLineValues(xs)) return "[" + $119dab09bed9f066$var$indentedJoin(xs, indent) + "]";
        return "[ " + $119dab09bed9f066$var$$join.call(xs, ", ") + " ]";
    }
    if ($119dab09bed9f066$var$isError(obj)) {
        var parts = $119dab09bed9f066$var$arrObjKeys(obj, inspect);
        if (!("cause" in Error.prototype) && "cause" in obj && !$119dab09bed9f066$var$isEnumerable.call(obj, "cause")) return "{ [" + String(obj) + "] " + $119dab09bed9f066$var$$join.call($119dab09bed9f066$var$$concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
        if (parts.length === 0) return "[" + String(obj) + "]";
        return "{ [" + String(obj) + "] " + $119dab09bed9f066$var$$join.call(parts, ", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
        if ($119dab09bed9f066$var$inspectSymbol && typeof obj[$119dab09bed9f066$var$inspectSymbol] === "function" && $foUwZ) return $foUwZ(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== "symbol" && typeof obj.inspect === "function") return obj.inspect();
    }
    if ($119dab09bed9f066$var$isMap(obj)) {
        var mapParts = [];
        if ($119dab09bed9f066$var$mapForEach) $119dab09bed9f066$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
        return $119dab09bed9f066$var$collectionOf("Map", $119dab09bed9f066$var$mapSize.call(obj), mapParts, indent);
    }
    if ($119dab09bed9f066$var$isSet(obj)) {
        var setParts = [];
        if ($119dab09bed9f066$var$setForEach) $119dab09bed9f066$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $119dab09bed9f066$var$collectionOf("Set", $119dab09bed9f066$var$setSize.call(obj), setParts, indent);
    }
    if ($119dab09bed9f066$var$isWeakMap(obj)) return $119dab09bed9f066$var$weakCollectionOf("WeakMap");
    if ($119dab09bed9f066$var$isWeakSet(obj)) return $119dab09bed9f066$var$weakCollectionOf("WeakSet");
    if ($119dab09bed9f066$var$isWeakRef(obj)) return $119dab09bed9f066$var$weakCollectionOf("WeakRef");
    if ($119dab09bed9f066$var$isNumber(obj)) return $119dab09bed9f066$var$markBoxed(inspect(Number(obj)));
    if ($119dab09bed9f066$var$isBigInt(obj)) return $119dab09bed9f066$var$markBoxed(inspect($119dab09bed9f066$var$bigIntValueOf.call(obj)));
    if ($119dab09bed9f066$var$isBoolean(obj)) return $119dab09bed9f066$var$markBoxed($119dab09bed9f066$var$booleanValueOf.call(obj));
    if ($119dab09bed9f066$var$isString(obj)) return $119dab09bed9f066$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== "undefined" && obj === window) return "{ [object Window] }";
    if (obj === $parcel$global) return "{ [object globalThis] }";
    if (!$119dab09bed9f066$var$isDate(obj) && !$119dab09bed9f066$var$isRegExp(obj)) {
        var ys = $119dab09bed9f066$var$arrObjKeys(obj, inspect);
        var isPlainObject = $119dab09bed9f066$var$gPO ? $119dab09bed9f066$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && $119dab09bed9f066$var$toStringTag && Object(obj) === obj && $119dab09bed9f066$var$toStringTag in obj ? $119dab09bed9f066$var$$slice.call($119dab09bed9f066$var$toStr(obj), 8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + $119dab09bed9f066$var$$join.call($119dab09bed9f066$var$$concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        if (ys.length === 0) return tag + "{}";
        if (indent) return tag + "{" + $119dab09bed9f066$var$indentedJoin(ys, indent) + "}";
        return tag + "{ " + $119dab09bed9f066$var$$join.call(ys, ", ") + " }";
    }
    return String(obj);
};
function $119dab09bed9f066$var$wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
    return quoteChar + s + quoteChar;
}
function $119dab09bed9f066$var$quote(s) {
    return $119dab09bed9f066$var$$replace.call(String(s), /"/g, "&quot;");
}
function $119dab09bed9f066$var$isArray(obj) {
    return $119dab09bed9f066$var$toStr(obj) === "[object Array]" && (!$119dab09bed9f066$var$toStringTag || !(typeof obj === "object" && $119dab09bed9f066$var$toStringTag in obj));
}
function $119dab09bed9f066$var$isDate(obj) {
    return $119dab09bed9f066$var$toStr(obj) === "[object Date]" && (!$119dab09bed9f066$var$toStringTag || !(typeof obj === "object" && $119dab09bed9f066$var$toStringTag in obj));
}
function $119dab09bed9f066$var$isRegExp(obj) {
    return $119dab09bed9f066$var$toStr(obj) === "[object RegExp]" && (!$119dab09bed9f066$var$toStringTag || !(typeof obj === "object" && $119dab09bed9f066$var$toStringTag in obj));
}
function $119dab09bed9f066$var$isError(obj) {
    return $119dab09bed9f066$var$toStr(obj) === "[object Error]" && (!$119dab09bed9f066$var$toStringTag || !(typeof obj === "object" && $119dab09bed9f066$var$toStringTag in obj));
}
function $119dab09bed9f066$var$isString(obj) {
    return $119dab09bed9f066$var$toStr(obj) === "[object String]" && (!$119dab09bed9f066$var$toStringTag || !(typeof obj === "object" && $119dab09bed9f066$var$toStringTag in obj));
}
function $119dab09bed9f066$var$isNumber(obj) {
    return $119dab09bed9f066$var$toStr(obj) === "[object Number]" && (!$119dab09bed9f066$var$toStringTag || !(typeof obj === "object" && $119dab09bed9f066$var$toStringTag in obj));
}
function $119dab09bed9f066$var$isBoolean(obj) {
    return $119dab09bed9f066$var$toStr(obj) === "[object Boolean]" && (!$119dab09bed9f066$var$toStringTag || !(typeof obj === "object" && $119dab09bed9f066$var$toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $119dab09bed9f066$var$isSymbol(obj) {
    if ($119dab09bed9f066$var$hasShammedSymbols) return obj && typeof obj === "object" && obj instanceof Symbol;
    if (typeof obj === "symbol") return true;
    if (!obj || typeof obj !== "object" || !$119dab09bed9f066$var$symToString) return false;
    try {
        $119dab09bed9f066$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $119dab09bed9f066$var$isBigInt(obj) {
    if (!obj || typeof obj !== "object" || !$119dab09bed9f066$var$bigIntValueOf) return false;
    try {
        $119dab09bed9f066$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $119dab09bed9f066$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $119dab09bed9f066$var$has(obj, key) {
    return $119dab09bed9f066$var$hasOwn.call(obj, key);
}
function $119dab09bed9f066$var$toStr(obj) {
    return $119dab09bed9f066$var$objectToString.call(obj);
}
function $119dab09bed9f066$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $119dab09bed9f066$var$$match.call($119dab09bed9f066$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $119dab09bed9f066$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $119dab09bed9f066$var$isMap(x) {
    if (!$119dab09bed9f066$var$mapSize || !x || typeof x !== "object") return false;
    try {
        $119dab09bed9f066$var$mapSize.call(x);
        try {
            $119dab09bed9f066$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $119dab09bed9f066$var$isWeakMap(x) {
    if (!$119dab09bed9f066$var$weakMapHas || !x || typeof x !== "object") return false;
    try {
        $119dab09bed9f066$var$weakMapHas.call(x, $119dab09bed9f066$var$weakMapHas);
        try {
            $119dab09bed9f066$var$weakSetHas.call(x, $119dab09bed9f066$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $119dab09bed9f066$var$isWeakRef(x) {
    if (!$119dab09bed9f066$var$weakRefDeref || !x || typeof x !== "object") return false;
    try {
        $119dab09bed9f066$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $119dab09bed9f066$var$isSet(x) {
    if (!$119dab09bed9f066$var$setSize || !x || typeof x !== "object") return false;
    try {
        $119dab09bed9f066$var$setSize.call(x);
        try {
            $119dab09bed9f066$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $119dab09bed9f066$var$isWeakSet(x) {
    if (!$119dab09bed9f066$var$weakSetHas || !x || typeof x !== "object") return false;
    try {
        $119dab09bed9f066$var$weakSetHas.call(x, $119dab09bed9f066$var$weakSetHas);
        try {
            $119dab09bed9f066$var$weakMapHas.call(x, $119dab09bed9f066$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $119dab09bed9f066$var$isElement(x) {
    if (!x || typeof x !== "object") return false;
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) return true;
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function $119dab09bed9f066$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return $119dab09bed9f066$var$inspectString($119dab09bed9f066$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $119dab09bed9f066$var$$replace.call($119dab09bed9f066$var$$replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, $119dab09bed9f066$var$lowbyte);
    return $119dab09bed9f066$var$wrapQuotes(s, "single", opts);
}
function $119dab09bed9f066$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    if (x) return "\\" + x;
    return "\\x" + (n < 0x10 ? "0" : "") + $119dab09bed9f066$var$$toUpperCase.call(n.toString(16));
}
function $119dab09bed9f066$var$markBoxed(str) {
    return "Object(" + str + ")";
}
function $119dab09bed9f066$var$weakCollectionOf(type) {
    return type + " { ? }";
}
function $119dab09bed9f066$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $119dab09bed9f066$var$indentedJoin(entries, indent) : $119dab09bed9f066$var$$join.call(entries, ", ");
    return type + " (" + size + ") {" + joinedEntries + "}";
}
function $119dab09bed9f066$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($119dab09bed9f066$var$indexOf(xs[i], "\n") >= 0) return false;
    }
    return true;
}
function $119dab09bed9f066$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") baseIndent = "	";
    else if (typeof opts.indent === "number" && opts.indent > 0) baseIndent = $119dab09bed9f066$var$$join.call(Array(opts.indent + 1), " ");
    else return null;
    return {
        base: baseIndent,
        prev: $119dab09bed9f066$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $119dab09bed9f066$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + $119dab09bed9f066$var$$join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function $119dab09bed9f066$var$arrObjKeys(obj, inspect) {
    var isArr = $119dab09bed9f066$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $119dab09bed9f066$var$has(obj, i) ? inspect(obj[i], obj) : "";
    }
    var syms = typeof $119dab09bed9f066$var$gOPS === "function" ? $119dab09bed9f066$var$gOPS(obj) : [];
    var symMap;
    if ($119dab09bed9f066$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap["$" + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$119dab09bed9f066$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($119dab09bed9f066$var$hasShammedSymbols && symMap["$" + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($119dab09bed9f066$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        else xs.push(key + ": " + inspect(obj[key], obj));
    }
    if (typeof $119dab09bed9f066$var$gOPS === "function") {
        for(var j = 0; j < syms.length; j++)if ($119dab09bed9f066$var$isEnumerable.call(obj, syms[j])) xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});
parcelRegister("foUwZ", function(module, exports) {
"use strict";

});



parcelRegister("gHu7A", function(module, exports) {
"use strict";

var $jScx1 = parcelRequire("jScx1");
var $c28806fde4f5d743$var$has = Object.prototype.hasOwnProperty;
var $c28806fde4f5d743$var$isArray = Array.isArray;
var $c28806fde4f5d743$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var $c28806fde4f5d743$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($c28806fde4f5d743$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $c28806fde4f5d743$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var $c28806fde4f5d743$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if ($c28806fde4f5d743$var$isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !$c28806fde4f5d743$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($c28806fde4f5d743$var$isArray(target) && !$c28806fde4f5d743$var$isArray(source)) mergeTarget = $c28806fde4f5d743$var$arrayToObject(target, options);
    if ($c28806fde4f5d743$var$isArray(target) && $c28806fde4f5d743$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($c28806fde4f5d743$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($c28806fde4f5d743$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $c28806fde4f5d743$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $c28806fde4f5d743$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $c28806fde4f5d743$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $c28806fde4f5d743$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var j = 0; j < string.length; j += $c28806fde4f5d743$var$limit){
        var segment = string.length >= $c28806fde4f5d743$var$limit ? string.slice(j, j + $c28806fde4f5d743$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $jScx1.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $c28806fde4f5d743$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $c28806fde4f5d743$var$hexTable[0xC0 | c >> 6] + $c28806fde4f5d743$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $c28806fde4f5d743$var$hexTable[0xE0 | c >> 12] + $c28806fde4f5d743$var$hexTable[0x80 | c >> 6 & 0x3F] + $c28806fde4f5d743$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $c28806fde4f5d743$var$hexTable[0xF0 | c >> 18] + $c28806fde4f5d743$var$hexTable[0x80 | c >> 12 & 0x3F] + $c28806fde4f5d743$var$hexTable[0x80 | c >> 6 & 0x3F] + $c28806fde4f5d743$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join("");
    }
    return out;
};
var $c28806fde4f5d743$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $c28806fde4f5d743$var$compactQueue(queue);
    return value;
};
var $c28806fde4f5d743$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var $c28806fde4f5d743$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $c28806fde4f5d743$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $c28806fde4f5d743$var$maybeMap = function maybeMap(val, fn) {
    if ($c28806fde4f5d743$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $c28806fde4f5d743$var$arrayToObject,
    assign: $c28806fde4f5d743$var$assign,
    combine: $c28806fde4f5d743$var$combine,
    compact: $c28806fde4f5d743$var$compact,
    decode: $c28806fde4f5d743$var$decode,
    encode: $c28806fde4f5d743$var$encode,
    isBuffer: $c28806fde4f5d743$var$isBuffer,
    isRegExp: $c28806fde4f5d743$var$isRegExp,
    maybeMap: $c28806fde4f5d743$var$maybeMap,
    merge: $c28806fde4f5d743$var$merge
};

});
parcelRegister("jScx1", function(module, exports) {
"use strict";
var $e77cc7fa9fbe3dde$var$replace = String.prototype.replace;
var $e77cc7fa9fbe3dde$var$percentTwenties = /%20/g;
var $e77cc7fa9fbe3dde$var$Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
module.exports = {
    "default": $e77cc7fa9fbe3dde$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $e77cc7fa9fbe3dde$var$replace.call(value, $e77cc7fa9fbe3dde$var$percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $e77cc7fa9fbe3dde$var$Format.RFC1738,
    RFC3986: $e77cc7fa9fbe3dde$var$Format.RFC3986
};

});



parcelRegister("btZEt", function(module, exports) {
"use strict";

var $gHu7A = parcelRequire("gHu7A");
var $85c239e60adf14b2$var$has = Object.prototype.hasOwnProperty;
var $85c239e60adf14b2$var$isArray = Array.isArray;
var $85c239e60adf14b2$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $gHu7A.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};
var $85c239e60adf14b2$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $85c239e60adf14b2$var$parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $85c239e60adf14b2$var$isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $85c239e60adf14b2$var$charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var $85c239e60adf14b2$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === $85c239e60adf14b2$var$charsetSentinel) charset = "utf-8";
            else if (parts[i] === $85c239e60adf14b2$var$isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $85c239e60adf14b2$var$defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), $85c239e60adf14b2$var$defaults.decoder, charset, "key");
            val = $gHu7A.maybeMap($85c239e60adf14b2$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $85c239e60adf14b2$var$defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = $85c239e60adf14b2$var$interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = $85c239e60adf14b2$var$isArray(val) ? [
            val
        ] : val;
        var existing = $85c239e60adf14b2$var$has.call(obj, key);
        if (existing && options.duplicates === "combine") obj[key] = $gHu7A.combine(obj[key], val);
        else if (!existing || options.duplicates === "last") obj[key] = val;
    }
    return obj;
};
var $85c239e60adf14b2$var$parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $85c239e60adf14b2$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = options.allowEmptyArrays && leaf === "" ? [] : [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, ".") : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== "__proto__") obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $85c239e60adf14b2$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $85c239e60adf14b2$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $85c239e60adf14b2$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push("[" + key.slice(segment.index) + "]");
    return $85c239e60adf14b2$var$parseObject(keys, val, options, valuesParsed);
};
var $85c239e60adf14b2$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $85c239e60adf14b2$var$defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.decodeDotInKeys !== "undefined" && typeof opts.decodeDotInKeys !== "boolean") throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.decoder !== null && typeof opts.decoder !== "undefined" && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? $85c239e60adf14b2$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === "undefined" ? $85c239e60adf14b2$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== "combine" && duplicates !== "first" && duplicates !== "last") throw new TypeError("The duplicates option must be either combine, first, or last");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.decodeDotInKeys === true ? true : $85c239e60adf14b2$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : $85c239e60adf14b2$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : $85c239e60adf14b2$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : $85c239e60adf14b2$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : $85c239e60adf14b2$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $85c239e60adf14b2$var$defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : $85c239e60adf14b2$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === "boolean" ? opts.decodeDotInKeys : $85c239e60adf14b2$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === "function" ? opts.decoder : $85c239e60adf14b2$var$defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || $gHu7A.isRegExp(opts.delimiter) ? opts.delimiter : $85c239e60adf14b2$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : $85c239e60adf14b2$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : $85c239e60adf14b2$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : $85c239e60adf14b2$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : $85c239e60adf14b2$var$defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $85c239e60adf14b2$var$defaults.strictNullHandling
    };
};
module.exports = function(str, opts) {
    var options = $85c239e60adf14b2$var$normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? $85c239e60adf14b2$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $85c239e60adf14b2$var$parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = $gHu7A.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $gHu7A.compact(obj);
};

});



parcelRegister("l4MZj", function(module, exports) {
(function(root, factory) {
    if (typeof define === "function" && define.amd) define([], factory);
    else if (0, module.exports) module.exports = factory();
    else root.xmlserializer = factory();
})(module.exports, function() {
    var removeInvalidCharacters = function(content) {
        // See http://www.w3.org/TR/xml/#NT-Char for valid XML 1.0 characters
        return content.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F]/g, "");
    };
    var serializeAttributeValue = function(value) {
        return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
    };
    var serializeTextContent = function(content) {
        return content.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    };
    var serializeAttribute = function(attr) {
        var value = attr.value;
        return " " + attr.name + '="' + serializeAttributeValue(value) + '"';
    };
    var getTagName = function(node) {
        var tagName = node.tagName;
        // Aid in serializing of original HTML documents
        if (node.namespaceURI === "http://www.w3.org/1999/xhtml") tagName = tagName.toLowerCase();
        return tagName;
    };
    var serializeNamespace = function(node, isRootNode) {
        var nodeHasXmlnsAttr = Array.prototype.map.call(node.attributes || node.attrs, function(attr) {
            return attr.name;
        }).indexOf("xmlns") >= 0;
        // Serialize the namespace as an xmlns attribute whenever the element
        // doesn't already have one and the inherited namespace does not match
        // the element's namespace.
        if (!nodeHasXmlnsAttr && (isRootNode || node.namespaceURI !== node.parentNode.namespaceURI)) return ' xmlns="' + node.namespaceURI + '"';
        else return "";
    };
    var serializeChildren = function(node) {
        return Array.prototype.map.call(node.childNodes, function(childNode) {
            return nodeTreeToXHTML(childNode);
        }).join("");
    };
    var serializeTag = function(node, isRootNode) {
        var output = "<" + getTagName(node);
        output += serializeNamespace(node, isRootNode);
        Array.prototype.forEach.call(node.attributes || node.attrs, function(attr) {
            output += serializeAttribute(attr);
        });
        if (node.childNodes.length > 0) {
            output += ">";
            output += serializeChildren(node);
            output += "</" + getTagName(node) + ">";
        } else output += "/>";
        return output;
    };
    var serializeText = function(node) {
        var text = node.nodeValue || node.value || "";
        return serializeTextContent(text);
    };
    var serializeComment = function(node) {
        return "<!--" + node.data.replace(/-/g, "&#45;") + "-->";
    };
    var serializeCDATA = function(node) {
        return "<![CDATA[" + node.nodeValue + "]]>";
    };
    var nodeTreeToXHTML = function(node, options) {
        var isRootNode = options && options.rootNode;
        if (node.nodeName === "#document" || node.nodeName === "#document-fragment") return serializeChildren(node);
        else {
            if (node.tagName) return serializeTag(node, isRootNode);
            else if (node.nodeName === "#text") return serializeText(node);
            else if (node.nodeName === "#comment") return serializeComment(node);
            else if (node.nodeName === "#cdata-section") return serializeCDATA(node);
        }
    };
    return {
        serializeToString: function(node) {
            return removeInvalidCharacters(nodeTreeToXHTML(node, {
                rootNode: true
            }));
        }
    };
});

});

parcelRegister("lDFX4", function(module, exports) {

$parcel$export(module.exports, "failOnParseError", () => $fc0dc838a1190e6e$export$d51faff9e290e5ce, (v) => $fc0dc838a1190e6e$export$d51faff9e290e5ce = v);
var $fc0dc838a1190e6e$export$d51faff9e290e5ce;
"use strict";
var $fc0dc838a1190e6e$var$innerXML = function(node) {
    var s = new XMLSerializer();
    return Array.prototype.map.call(node.childNodes, function(node) {
        return s.serializeToString(node);
    }).join("");
};
var $fc0dc838a1190e6e$var$getParseError = function(doc) {
    // Firefox
    if (doc.documentElement.tagName === "parsererror" && doc.documentElement.namespaceURI === "http://www.mozilla.org/newlayout/xml/parsererror.xml") return doc.documentElement;
    // Chrome, Safari
    if ((doc.documentElement.tagName === "xml" || doc.documentElement.tagName === "html") && doc.documentElement.childNodes && doc.documentElement.childNodes.length > 0 && doc.documentElement.childNodes[0].nodeName === "parsererror") return doc.documentElement.childNodes[0];
    // PhantomJS
    if (doc.documentElement.tagName === "html" && doc.documentElement.childNodes && doc.documentElement.childNodes.length > 0 && doc.documentElement.childNodes[0].nodeName === "body" && doc.documentElement.childNodes[0].childNodes && doc.documentElement.childNodes[0].childNodes.length && doc.documentElement.childNodes[0].childNodes[0].nodeName === "parsererror") return doc.documentElement.childNodes[0].childNodes[0];
    return undefined;
};
var $fc0dc838a1190e6e$var$errorMessagePatterns = [
    // Chrome, Safari, PhantomJS
    new RegExp("^<h3[^>]*>This page contains the following errors:</h3><div[^>]*>(.+?)\n?</div>"),
    // Firefox
    new RegExp("^(.+)\n")
];
var $fc0dc838a1190e6e$var$extractParseError = function(errorNode) {
    var content = $fc0dc838a1190e6e$var$innerXML(errorNode);
    var i, match;
    for(i = 0; i < $fc0dc838a1190e6e$var$errorMessagePatterns.length; i++){
        match = $fc0dc838a1190e6e$var$errorMessagePatterns[i].exec(content);
        if (match) return match[1];
    }
    return undefined;
};
var $fc0dc838a1190e6e$var$failOnParseError = function(doc) {
    var errorMessage;
    if (doc === null) throw new Error("Parse error");
    var parseError = $fc0dc838a1190e6e$var$getParseError(doc);
    if (parseError !== undefined) {
        errorMessage = $fc0dc838a1190e6e$var$extractParseError(parseError) || "Parse error";
        throw new Error(errorMessage);
    }
};
$fc0dc838a1190e6e$export$d51faff9e290e5ce = function(doc) {
    $fc0dc838a1190e6e$var$failOnParseError(doc);
    return doc;
};

});

parcelRegister("6cJtK", function(module, exports) {

$parcel$export(module.exports, "loadAndInlineStyles", () => $484724368992e695$export$9a02ce286da16516, (v) => $484724368992e695$export$9a02ce286da16516 = v);
$parcel$export(module.exports, "loadAndInlineCssLinks", () => $484724368992e695$export$b728abf4953c7d7c, (v) => $484724368992e695$export$b728abf4953c7d7c = v);
$parcel$export(module.exports, "loadAndInlineImages", () => $484724368992e695$export$2bf99ae07fcd8861, (v) => $484724368992e695$export$2bf99ae07fcd8861 = v);
$parcel$export(module.exports, "loadAndInlineScript", () => $484724368992e695$export$91b8badcb7027546, (v) => $484724368992e695$export$91b8badcb7027546 = v);
$parcel$export(module.exports, "inlineReferences", () => $484724368992e695$export$3ad2ac2e363486fd, (v) => $484724368992e695$export$3ad2ac2e363486fd = v);
var $484724368992e695$export$9a02ce286da16516;
var $484724368992e695$export$b728abf4953c7d7c;
/* Main */ var $484724368992e695$export$2bf99ae07fcd8861;
var $484724368992e695$export$91b8badcb7027546;
var $484724368992e695$export$3ad2ac2e363486fd;
"use strict";

var $86nT0 = parcelRequire("86nT0");

var $h1K4Y = parcelRequire("h1K4Y");

var $8461k = parcelRequire("8461k");

var $hKQZR = parcelRequire("hKQZR");

var $ej93s = parcelRequire("ej93s");
var $484724368992e695$var$getUrlBasePath = function(url) {
    return $86nT0.joinUrl(url, ".");
};
var $484724368992e695$var$parameterHashFunction = function(params) {
    // HACK JSON.stringify is poor man's hashing;
    // same objects might not receive same result as key order is not guaranteed
    var a = params.map(function(param, idx) {
        // Only include options relevant for method
        if (idx === params.length - 1) param = {
            // Two different HTML pages on the same path level have the same base path, but a different URL
            baseUrl: $484724368992e695$var$getUrlBasePath(param.baseUrl)
        };
        return JSON.stringify(param);
    });
    return a;
};
var $484724368992e695$var$memoizeFunctionOnCaching = function(func, options) {
    if (options.cache !== false && options.cache !== "none" && options.cacheBucket) return $86nT0.memoize(func, $484724368992e695$var$parameterHashFunction, options.cacheBucket);
    else return func;
};
/* Style inlining */ var $484724368992e695$var$requestExternalsForStylesheet = function(styleContent, alreadyLoadedCssUrls, options) {
    var cssRules = $ej93s.rulesForCssText(styleContent);
    return $hKQZR.loadCSSImportsForRules(cssRules, alreadyLoadedCssUrls, options).then(function(cssImportResult) {
        return $hKQZR.loadAndInlineCSSResourcesForRules(cssRules, options).then(function(cssResourcesResult) {
            var errors = cssImportResult.errors.concat(cssResourcesResult.errors), hasChanges = cssImportResult.hasChanges || cssResourcesResult.hasChanges;
            if (hasChanges) styleContent = $ej93s.cssRulesToText(cssRules);
            return {
                hasChanges: hasChanges,
                content: styleContent,
                errors: errors
            };
        });
    });
};
var $484724368992e695$var$loadAndInlineCssForStyle = function(style, options, alreadyLoadedCssUrls) {
    var styleContent = style.textContent, processExternals = $484724368992e695$var$memoizeFunctionOnCaching($484724368992e695$var$requestExternalsForStylesheet, options);
    return processExternals(styleContent, alreadyLoadedCssUrls, options).then(function(result) {
        if (result.hasChanges) style.childNodes[0].nodeValue = result.content;
        return $86nT0.cloneArray(result.errors);
    });
};
var $484724368992e695$var$getCssStyleElements = function(doc) {
    var styles = doc.getElementsByTagName("style");
    return Array.prototype.filter.call(styles, function(style) {
        return !style.attributes.type || style.attributes.type.value === "text/css";
    });
};
$484724368992e695$export$9a02ce286da16516 = function(doc, options) {
    var styles = $484724368992e695$var$getCssStyleElements(doc), allErrors = [], alreadyLoadedCssUrls = [], inlineOptions;
    inlineOptions = $86nT0.clone(options);
    inlineOptions.baseUrl = inlineOptions.baseUrl || $86nT0.getDocumentBaseUrl(doc);
    return Promise.all(styles.map(function(style) {
        return $484724368992e695$var$loadAndInlineCssForStyle(style, inlineOptions, alreadyLoadedCssUrls).then(function(errors) {
            allErrors = allErrors.concat(errors);
        });
    })).then(function() {
        return allErrors;
    });
};
/* CSS link inlining */ var $484724368992e695$var$substituteLinkWithInlineStyle = function(oldLinkNode, styleContent) {
    var parent = oldLinkNode.parentNode, styleNode;
    styleContent = styleContent.trim();
    if (styleContent) {
        styleNode = oldLinkNode.ownerDocument.createElement("style");
        styleNode.type = "text/css";
        styleNode.appendChild(oldLinkNode.ownerDocument.createTextNode(styleContent));
        parent.insertBefore(styleNode, oldLinkNode);
    }
    parent.removeChild(oldLinkNode);
};
var $484724368992e695$var$requestStylesheetAndInlineResources = function(url, options) {
    return $86nT0.ajax(url, options).then(function(content) {
        var cssRules = $ej93s.rulesForCssText(content);
        return {
            content: content,
            cssRules: cssRules
        };
    }).then(function(result) {
        var hasChangesFromPathAdjustment = $hKQZR.adjustPathsOfCssResources(url, result.cssRules);
        return {
            content: result.content,
            cssRules: result.cssRules,
            hasChanges: hasChangesFromPathAdjustment
        };
    }).then(function(result) {
        return $hKQZR.loadCSSImportsForRules(result.cssRules, [], options).then(function(cssImportResult) {
            return {
                content: result.content,
                cssRules: result.cssRules,
                hasChanges: result.hasChanges || cssImportResult.hasChanges,
                errors: cssImportResult.errors
            };
        });
    }).then(function(result) {
        return $hKQZR.loadAndInlineCSSResourcesForRules(result.cssRules, options).then(function(cssResourcesResult) {
            return {
                content: result.content,
                cssRules: result.cssRules,
                hasChanges: result.hasChanges || cssResourcesResult.hasChanges,
                errors: result.errors.concat(cssResourcesResult.errors)
            };
        });
    }).then(function(result) {
        var content = result.content;
        if (result.hasChanges) content = $ej93s.cssRulesToText(result.cssRules);
        return {
            content: content,
            errors: result.errors
        };
    });
};
var $484724368992e695$var$loadLinkedCSS = function(link, options) {
    var cssHref = link.attributes.href.value, documentBaseUrl = $86nT0.getDocumentBaseUrl(link.ownerDocument), ajaxOptions = $86nT0.clone(options);
    if (!ajaxOptions.baseUrl && documentBaseUrl) ajaxOptions.baseUrl = documentBaseUrl;
    var processStylesheet = $484724368992e695$var$memoizeFunctionOnCaching($484724368992e695$var$requestStylesheetAndInlineResources, options);
    return processStylesheet(cssHref, ajaxOptions).then(function(result) {
        return {
            content: result.content,
            errors: $86nT0.cloneArray(result.errors)
        };
    });
};
var $484724368992e695$var$getCssStylesheetLinks = function(doc) {
    var links = doc.getElementsByTagName("link");
    return Array.prototype.filter.call(links, function(link) {
        return link.attributes.rel && link.attributes.rel.value === "stylesheet" && (!link.attributes.type || link.attributes.type.value === "text/css");
    });
};
$484724368992e695$export$b728abf4953c7d7c = function(doc, options) {
    var links = $484724368992e695$var$getCssStylesheetLinks(doc), errors = [];
    return Promise.all(links.map(function(link) {
        return $484724368992e695$var$loadLinkedCSS(link, options).then(function(result) {
            $484724368992e695$var$substituteLinkWithInlineStyle(link, result.content + "\n");
            errors = errors.concat(result.errors);
        }, function(e) {
            errors.push({
                resourceType: "stylesheet",
                url: e.url,
                msg: "Unable to load stylesheet " + e.url
            });
        });
    })).then(function() {
        return errors;
    });
};
$484724368992e695$export$2bf99ae07fcd8861 = $h1K4Y.inline;
$484724368992e695$export$91b8badcb7027546 = $8461k.inline;
$484724368992e695$export$3ad2ac2e363486fd = function(doc, options) {
    var allErrors = [], inlineFuncs = [
        $484724368992e695$export$2bf99ae07fcd8861,
        $484724368992e695$export$9a02ce286da16516,
        $484724368992e695$export$b728abf4953c7d7c
    ];
    if (options.inlineScripts !== false) inlineFuncs.push($484724368992e695$export$91b8badcb7027546);
    return Promise.all(inlineFuncs.map(function(func) {
        return func(doc, options).then(function(errors) {
            allErrors = allErrors.concat(errors);
        });
    })).then(function() {
        return allErrors;
    });
};

});
parcelRegister("86nT0", function(module, exports) {

$parcel$export(module.exports, "getDocumentBaseUrl", () => $5e61698e19723444$export$f92856abc868de44, (v) => $5e61698e19723444$export$f92856abc868de44 = v);
$parcel$export(module.exports, "clone", () => $5e61698e19723444$export$9cd59f9826255e47, (v) => $5e61698e19723444$export$9cd59f9826255e47 = v);
$parcel$export(module.exports, "cloneArray", () => $5e61698e19723444$export$fb653c219fcc4270, (v) => $5e61698e19723444$export$fb653c219fcc4270 = v);
$parcel$export(module.exports, "joinUrl", () => $5e61698e19723444$export$3b3b88c3d59ef562, (v) => $5e61698e19723444$export$3b3b88c3d59ef562 = v);
$parcel$export(module.exports, "isDataUri", () => $5e61698e19723444$export$e854552991cc2d9c, (v) => $5e61698e19723444$export$e854552991cc2d9c = v);
$parcel$export(module.exports, "collectAndReportErrors", () => $5e61698e19723444$export$ee80a728dc3b3b62, (v) => $5e61698e19723444$export$ee80a728dc3b3b62 = v);
$parcel$export(module.exports, "ajax", () => $5e61698e19723444$export$e68fce4c5f453854, (v) => $5e61698e19723444$export$e68fce4c5f453854 = v);
$parcel$export(module.exports, "binaryAjax", () => $5e61698e19723444$export$627a6b28532aa955, (v) => $5e61698e19723444$export$627a6b28532aa955 = v);
$parcel$export(module.exports, "getDataURIForImageURL", () => $5e61698e19723444$export$5918b1a95d81873b, (v) => $5e61698e19723444$export$5918b1a95d81873b = v);
$parcel$export(module.exports, "memoize", () => $5e61698e19723444$export$fc10aeed3a532e2a, (v) => $5e61698e19723444$export$fc10aeed3a532e2a = v);
var $5e61698e19723444$export$f92856abc868de44;
var $5e61698e19723444$export$9cd59f9826255e47;
var $5e61698e19723444$export$fb653c219fcc4270;
var $5e61698e19723444$export$3b3b88c3d59ef562;
var $5e61698e19723444$export$e854552991cc2d9c;
var $5e61698e19723444$export$ee80a728dc3b3b62;
var $5e61698e19723444$export$e68fce4c5f453854;
var $5e61698e19723444$export$627a6b28532aa955;
var $5e61698e19723444$export$5918b1a95d81873b;
var $5e61698e19723444$export$fc10aeed3a532e2a;
"use strict";

var $kRFNf = parcelRequire("kRFNf");
$5e61698e19723444$export$f92856abc868de44 = function(doc) {
    if (doc.baseURI !== "about:blank") return doc.baseURI;
    return null;
};
$5e61698e19723444$export$9cd59f9826255e47 = function(object) {
    var theClone = {}, i;
    for(i in object)if (object.hasOwnProperty(i)) theClone[i] = object[i];
    return theClone;
};
$5e61698e19723444$export$fb653c219fcc4270 = function(nodeList) {
    return Array.prototype.slice.apply(nodeList, [
        0
    ]);
};
$5e61698e19723444$export$3b3b88c3d59ef562 = function(baseUrl, relUrl) {
    if (!baseUrl) return relUrl;
    return $kRFNf.resolve(baseUrl, relUrl);
};
$5e61698e19723444$export$e854552991cc2d9c = function(url) {
    return /^data:/.test(url);
};
$5e61698e19723444$export$ee80a728dc3b3b62 = function(promises) {
    var errors = [];
    return Promise.all(promises.map(function(promise) {
        return promise.catch(function(e) {
            errors.push(e);
        });
    })).then(function() {
        return errors;
    });
};
var $5e61698e19723444$var$lastCacheDate = null;
var $5e61698e19723444$var$getUncachableURL = function(url, cache) {
    if (cache === false || cache === "none" || cache === "repeated") {
        if ($5e61698e19723444$var$lastCacheDate === null || cache !== "repeated") $5e61698e19723444$var$lastCacheDate = Date.now();
        return url + "?_=" + $5e61698e19723444$var$lastCacheDate;
    } else return url;
};
$5e61698e19723444$export$e68fce4c5f453854 = function(url, options) {
    return new Promise(function(resolve, reject) {
        var ajaxRequest = new window.XMLHttpRequest(), joinedUrl = $5e61698e19723444$export$3b3b88c3d59ef562(options.baseUrl, url), augmentedUrl;
        var doReject = function() {
            reject({
                msg: "Unable to load url",
                url: joinedUrl
            });
        };
        augmentedUrl = $5e61698e19723444$var$getUncachableURL(joinedUrl, options.cache);
        ajaxRequest.addEventListener("load", function() {
            if (ajaxRequest.status === 200 || ajaxRequest.status === 0) resolve(ajaxRequest.response);
            else doReject();
        }, false);
        ajaxRequest.addEventListener("error", doReject, false);
        try {
            ajaxRequest.open("GET", augmentedUrl, true);
            ajaxRequest.overrideMimeType(options.mimeType);
            ajaxRequest.send(null);
        } catch (e) {
            doReject();
        }
    });
};
$5e61698e19723444$export$627a6b28532aa955 = function(url, options) {
    var ajaxOptions = $5e61698e19723444$export$9cd59f9826255e47(options);
    ajaxOptions.mimeType = "text/plain; charset=x-user-defined";
    return $5e61698e19723444$export$e68fce4c5f453854(url, ajaxOptions).then(function(content) {
        var binaryContent = "";
        for(var i = 0; i < content.length; i++)binaryContent += String.fromCharCode(content.charCodeAt(i) & 0xff);
        return binaryContent;
    });
};
var $5e61698e19723444$var$detectMimeType = function(content) {
    var startsWith = function(string, substring) {
        return string.substring(0, substring.length) === substring;
    };
    if (startsWith(content, "<?xml") || startsWith(content, "<svg")) return "image/svg+xml";
    return "image/png";
};
$5e61698e19723444$export$5918b1a95d81873b = function(url, options) {
    return $5e61698e19723444$export$627a6b28532aa955(url, options).then(function(content) {
        var base64Content = btoa(content), mimeType = $5e61698e19723444$var$detectMimeType(content);
        return "data:" + mimeType + ";base64," + base64Content;
    });
};
var $5e61698e19723444$var$uniqueIdList = [];
var $5e61698e19723444$var$constantUniqueIdFor = function(element) {
    // HACK, using a list results in O(n), but how do we hash a function?
    if ($5e61698e19723444$var$uniqueIdList.indexOf(element) < 0) $5e61698e19723444$var$uniqueIdList.push(element);
    return $5e61698e19723444$var$uniqueIdList.indexOf(element);
};
$5e61698e19723444$export$fc10aeed3a532e2a = function(func, hasher, memo) {
    if (typeof memo !== "object") throw new Error("cacheBucket is not an object");
    return function() {
        var args = Array.prototype.slice.call(arguments);
        var argumentHash = hasher(args), funcHash = $5e61698e19723444$var$constantUniqueIdFor(func), retValue;
        if (memo[funcHash] && memo[funcHash][argumentHash]) return memo[funcHash][argumentHash];
        else {
            retValue = func.apply(null, args);
            memo[funcHash] = memo[funcHash] || {};
            memo[funcHash][argumentHash] = retValue;
            return retValue;
        }
    };
};

});

parcelRegister("h1K4Y", function(module, exports) {

$parcel$export(module.exports, "inline", () => $c656460583a3ea94$export$18c8ad048e32c7d5, (v) => $c656460583a3ea94$export$18c8ad048e32c7d5 = v);
var $c656460583a3ea94$export$18c8ad048e32c7d5;
"use strict";

var $86nT0 = parcelRequire("86nT0");
var $c656460583a3ea94$var$encodeImageAsDataURI = function(image, options) {
    var url = null;
    if (image.hasAttribute("src")) url = image.getAttribute("src");
    else if (image.hasAttributeNS("http://www.w3.org/1999/xlink", "href")) url = image.getAttributeNS("http://www.w3.org/1999/xlink", "href");
    else if (image.hasAttribute("href")) url = image.getAttribute("href");
    var documentBase = $86nT0.getDocumentBaseUrl(image.ownerDocument), ajaxOptions = $86nT0.clone(options);
    if (!ajaxOptions.baseUrl && documentBase) ajaxOptions.baseUrl = documentBase;
    return $86nT0.getDataURIForImageURL(url, ajaxOptions).then(function(dataURI) {
        return dataURI;
    }, function(e) {
        throw {
            resourceType: "image",
            url: e.url,
            msg: "Unable to load image " + e.url
        };
    });
};
var $c656460583a3ea94$var$filterExternalImages = function(images) {
    return images.filter(function(image) {
        var url = null;
        if (image.hasAttribute("src")) url = image.getAttribute("src");
        else if (image.hasAttributeNS("http://www.w3.org/1999/xlink", "href")) url = image.getAttributeNS("http://www.w3.org/1999/xlink", "href");
        else if (image.hasAttribute("href")) url = image.getAttribute("href");
        return url !== null && !$86nT0.isDataUri(url);
    });
};
var $c656460583a3ea94$var$filterInputsForImageType = function(inputs) {
    return Array.prototype.filter.call(inputs, function(input) {
        return input.type === "image";
    });
};
var $c656460583a3ea94$var$toArray = function(arrayLike) {
    return Array.prototype.slice.call(arrayLike);
};
$c656460583a3ea94$export$18c8ad048e32c7d5 = function(doc, options) {
    var images = $c656460583a3ea94$var$toArray(doc.getElementsByTagName("img")), svgImages = $c656460583a3ea94$var$toArray(doc.getElementsByTagName("image")), imageInputs = $c656460583a3ea94$var$filterInputsForImageType(doc.getElementsByTagName("input"));
    images = images.concat(svgImages);
    images = images.concat(imageInputs);
    var externalImages = $c656460583a3ea94$var$filterExternalImages(images);
    return $86nT0.collectAndReportErrors(externalImages.map(function(image) {
        return $c656460583a3ea94$var$encodeImageAsDataURI(image, options).then(function(dataURI) {
            if (!!image.attributes.src) image.attributes.src.value = dataURI;
            else if (!!image.attributes["xlink:href"]) image.attributes["xlink:href"].value = dataURI;
            else if (!!image.attributes.href) image.attributes.href.value = dataURI;
        });
    }));
};

});

parcelRegister("8461k", function(module, exports) {

$parcel$export(module.exports, "inline", () => $5df35dfadcbf51ac$export$18c8ad048e32c7d5, (v) => $5df35dfadcbf51ac$export$18c8ad048e32c7d5 = v);
var $5df35dfadcbf51ac$export$18c8ad048e32c7d5;
"use strict";

var $86nT0 = parcelRequire("86nT0");
var $5df35dfadcbf51ac$var$loadLinkedScript = function(script, options) {
    var src = script.attributes.src.value, documentBase = $86nT0.getDocumentBaseUrl(script.ownerDocument), ajaxOptions = $86nT0.clone(options);
    if (!ajaxOptions.baseUrl && documentBase) ajaxOptions.baseUrl = documentBase;
    return $86nT0.ajax(src, ajaxOptions).catch(function(e) {
        throw {
            resourceType: "script",
            url: e.url,
            msg: "Unable to load script " + e.url
        };
    });
};
var $5df35dfadcbf51ac$var$escapeClosingTags = function(text) {
    // http://stackoverflow.com/questions/9246382/escaping-script-tag-inside-javascript
    return text.replace(/<\//g, "<\\/");
};
var $5df35dfadcbf51ac$var$substituteExternalScriptWithInline = function(scriptNode, jsCode) {
    scriptNode.attributes.removeNamedItem("src");
    scriptNode.textContent = $5df35dfadcbf51ac$var$escapeClosingTags(jsCode);
};
var $5df35dfadcbf51ac$var$getScripts = function(doc) {
    var scripts = doc.getElementsByTagName("script");
    return Array.prototype.filter.call(scripts, function(script) {
        return !!script.attributes.src;
    });
};
$5df35dfadcbf51ac$export$18c8ad048e32c7d5 = function(doc, options) {
    var scripts = $5df35dfadcbf51ac$var$getScripts(doc);
    return $86nT0.collectAndReportErrors(scripts.map(function(script) {
        return $5df35dfadcbf51ac$var$loadLinkedScript(script, options).then(function(jsCode) {
            $5df35dfadcbf51ac$var$substituteExternalScriptWithInline(script, jsCode);
        });
    }));
};

});

parcelRegister("hKQZR", function(module, exports) {

$parcel$export(module.exports, "adjustPathsOfCssResources", () => $cecfd79b64bfcb7e$export$1249dc72dcc33b05, (v) => $cecfd79b64bfcb7e$export$1249dc72dcc33b05 = v);
$parcel$export(module.exports, "loadCSSImportsForRules", () => $cecfd79b64bfcb7e$export$ccaee9777e89bdd0, (v) => $cecfd79b64bfcb7e$export$ccaee9777e89bdd0 = v);
$parcel$export(module.exports, "loadAndInlineCSSResourcesForRules", () => $cecfd79b64bfcb7e$export$4d10698d11d4f34e, (v) => $cecfd79b64bfcb7e$export$4d10698d11d4f34e = v);
var $cecfd79b64bfcb7e$export$1249dc72dcc33b05;
var $cecfd79b64bfcb7e$export$ccaee9777e89bdd0;
var $cecfd79b64bfcb7e$export$4d10698d11d4f34e;
"use strict";

var $86nT0 = parcelRequire("86nT0");

var $ej93s = parcelRequire("ej93s");

var $ifuje = parcelRequire("ifuje");

var $hj1Yg = parcelRequire("hj1Yg");
var $cecfd79b64bfcb7e$var$updateCssPropertyValue = function(rule, property, value) {
    rule.style.setProperty(property, value, rule.style.getPropertyPriority(property));
};
var $cecfd79b64bfcb7e$var$findBackgroundImageRules = function(cssRules) {
    return cssRules.filter(function(rule) {
        return rule.type === window.CSSRule.STYLE_RULE && (rule.style.getPropertyValue("background-image") || rule.style.getPropertyValue("background"));
    });
};
var $cecfd79b64bfcb7e$var$findBackgroundDeclarations = function(rules) {
    var backgroundDeclarations = [];
    rules.forEach(function(rule) {
        if (rule.style.getPropertyValue("background-image")) backgroundDeclarations.push({
            property: "background-image",
            value: rule.style.getPropertyValue("background-image"),
            rule: rule
        });
        else if (rule.style.getPropertyValue("background")) backgroundDeclarations.push({
            property: "background",
            value: rule.style.getPropertyValue("background"),
            rule: rule
        });
    });
    return backgroundDeclarations;
};
var $cecfd79b64bfcb7e$var$findFontFaceRules = function(cssRules) {
    return cssRules.filter(function(rule) {
        return rule.type === window.CSSRule.FONT_FACE_RULE && rule.style.getPropertyValue("src");
    });
};
var $cecfd79b64bfcb7e$var$findCSSImportRules = function(cssRules) {
    return cssRules.filter(function(rule) {
        return rule.type === window.CSSRule.IMPORT_RULE && rule.href;
    });
};
var $cecfd79b64bfcb7e$var$findExternalBackgroundUrls = function(parsedBackground) {
    var matchIndices = [];
    parsedBackground.forEach(function(backgroundLayer, i) {
        if (backgroundLayer.url && !$86nT0.isDataUri(backgroundLayer.url)) matchIndices.push(i);
    });
    return matchIndices;
};
var $cecfd79b64bfcb7e$var$findExternalFontFaceUrls = function(parsedFontFaceSources) {
    var sourceIndices = [];
    parsedFontFaceSources.forEach(function(sourceItem, i) {
        if (sourceItem.url && !$86nT0.isDataUri(sourceItem.url)) sourceIndices.push(i);
    });
    return sourceIndices;
};
$cecfd79b64bfcb7e$export$1249dc72dcc33b05 = function(baseUrl, cssRules) {
    var backgroundRules = $cecfd79b64bfcb7e$var$findBackgroundImageRules(cssRules), backgroundDeclarations = $cecfd79b64bfcb7e$var$findBackgroundDeclarations(backgroundRules), change = false;
    backgroundDeclarations.forEach(function(declaration) {
        var parsedBackground = $ifuje.parse(declaration.value), externalBackgroundIndices = $cecfd79b64bfcb7e$var$findExternalBackgroundUrls(parsedBackground), backgroundValue;
        if (externalBackgroundIndices.length > 0) {
            externalBackgroundIndices.forEach(function(backgroundLayerIndex) {
                var relativeUrl = parsedBackground[backgroundLayerIndex].url, url = $86nT0.joinUrl(baseUrl, relativeUrl);
                parsedBackground[backgroundLayerIndex].url = url;
            });
            backgroundValue = $ifuje.serialize(parsedBackground);
            $cecfd79b64bfcb7e$var$updateCssPropertyValue(declaration.rule, declaration.property, backgroundValue);
            change = true;
        }
    });
    $cecfd79b64bfcb7e$var$findFontFaceRules(cssRules).forEach(function(rule) {
        var fontFaceSrcDeclaration = rule.style.getPropertyValue("src"), parsedFontFaceSources, externalFontFaceUrlIndices;
        try {
            parsedFontFaceSources = $hj1Yg.parse(fontFaceSrcDeclaration);
        } catch (e) {
            return;
        }
        externalFontFaceUrlIndices = $cecfd79b64bfcb7e$var$findExternalFontFaceUrls(parsedFontFaceSources);
        if (externalFontFaceUrlIndices.length > 0) {
            externalFontFaceUrlIndices.forEach(function(fontFaceUrlIndex) {
                var relativeUrl = parsedFontFaceSources[fontFaceUrlIndex].url, url = $86nT0.joinUrl(baseUrl, relativeUrl);
                parsedFontFaceSources[fontFaceUrlIndex].url = url;
            });
            $ej93s.changeFontFaceRuleSrc(cssRules, rule, $hj1Yg.serialize(parsedFontFaceSources));
            change = true;
        }
    });
    $cecfd79b64bfcb7e$var$findCSSImportRules(cssRules).forEach(function(rule) {
        var cssUrl = rule.href, url = $86nT0.joinUrl(baseUrl, cssUrl);
        $ej93s.exchangeRule(cssRules, rule, "@import url(" + url + ");");
        change = true;
    });
    return change;
};
/* CSS import inlining */ var $cecfd79b64bfcb7e$var$substituteRule = function(cssRules, rule, newCssRules) {
    var position = cssRules.indexOf(rule);
    cssRules.splice(position, 1);
    newCssRules.forEach(function(newRule, i) {
        cssRules.splice(position + i, 0, newRule);
    });
};
var $cecfd79b64bfcb7e$var$loadAndInlineCSSImport = function(cssRules, rule, alreadyLoadedCssUrls, options) {
    var url = rule.href, cssHrefRelativeToDoc;
    url = $ej93s.unquoteString(url);
    cssHrefRelativeToDoc = $86nT0.joinUrl(options.baseUrl, url);
    if (alreadyLoadedCssUrls.indexOf(cssHrefRelativeToDoc) >= 0) {
        // Remove URL by adding empty string
        $cecfd79b64bfcb7e$var$substituteRule(cssRules, rule, []);
        return Promise.resolve([]);
    } else alreadyLoadedCssUrls.push(cssHrefRelativeToDoc);
    return $86nT0.ajax(url, options).then(function(cssText) {
        var externalCssRules = $ej93s.rulesForCssText(cssText);
        // Recursively follow @import statements
        return $cecfd79b64bfcb7e$export$ccaee9777e89bdd0(externalCssRules, alreadyLoadedCssUrls, options).then(function(result) {
            $cecfd79b64bfcb7e$export$1249dc72dcc33b05(url, externalCssRules);
            $cecfd79b64bfcb7e$var$substituteRule(cssRules, rule, externalCssRules);
            return result.errors;
        });
    }, function(e) {
        throw {
            resourceType: "stylesheet",
            url: e.url,
            msg: "Unable to load stylesheet " + e.url
        };
    });
};
$cecfd79b64bfcb7e$export$ccaee9777e89bdd0 = function(cssRules, alreadyLoadedCssUrls, options) {
    var rulesToInline = $cecfd79b64bfcb7e$var$findCSSImportRules(cssRules), errors = [], hasChanges = false;
    return Promise.all(rulesToInline.map(function(rule) {
        return $cecfd79b64bfcb7e$var$loadAndInlineCSSImport(cssRules, rule, alreadyLoadedCssUrls, options).then(function(moreErrors) {
            errors = errors.concat(moreErrors);
            hasChanges = true;
        }, function(e) {
            errors.push(e);
        });
    })).then(function() {
        return {
            hasChanges: hasChanges,
            errors: errors
        };
    });
};
/* CSS linked resource inlining */ var $cecfd79b64bfcb7e$var$loadAndInlineBackgroundImages = function(backgroundValue, options) {
    var parsedBackground = $ifuje.parse(backgroundValue), externalBackgroundLayerIndices = $cecfd79b64bfcb7e$var$findExternalBackgroundUrls(parsedBackground), hasChanges = false;
    return $86nT0.collectAndReportErrors(externalBackgroundLayerIndices.map(function(backgroundLayerIndex) {
        var url = parsedBackground[backgroundLayerIndex].url;
        return $86nT0.getDataURIForImageURL(url, options).then(function(dataURI) {
            parsedBackground[backgroundLayerIndex].url = dataURI;
            hasChanges = true;
        }, function(e) {
            throw {
                resourceType: "backgroundImage",
                url: e.url,
                msg: "Unable to load background-image " + e.url
            };
        });
    })).then(function(errors) {
        return {
            backgroundValue: $ifuje.serialize(parsedBackground),
            hasChanges: hasChanges,
            errors: errors
        };
    });
};
var $cecfd79b64bfcb7e$var$iterateOverRulesAndInlineBackgroundImages = function(cssRules, options) {
    var rulesToInline = $cecfd79b64bfcb7e$var$findBackgroundImageRules(cssRules), backgroundDeclarations = $cecfd79b64bfcb7e$var$findBackgroundDeclarations(rulesToInline), errors = [], cssHasChanges = false;
    return Promise.all(backgroundDeclarations.map(function(declaration) {
        return $cecfd79b64bfcb7e$var$loadAndInlineBackgroundImages(declaration.value, options).then(function(result) {
            if (result.hasChanges) {
                $cecfd79b64bfcb7e$var$updateCssPropertyValue(declaration.rule, declaration.property, result.backgroundValue);
                cssHasChanges = true;
            }
            errors = errors.concat(result.errors);
        });
    })).then(function() {
        return {
            hasChanges: cssHasChanges,
            errors: errors
        };
    });
};
var $cecfd79b64bfcb7e$var$loadAndInlineFontFace = function(srcDeclarationValue, options) {
    var hasChanges = false, parsedFontFaceSources, externalFontFaceUrlIndices;
    try {
        parsedFontFaceSources = $hj1Yg.parse(srcDeclarationValue);
    } catch (e) {
        parsedFontFaceSources = [];
    }
    externalFontFaceUrlIndices = $cecfd79b64bfcb7e$var$findExternalFontFaceUrls(parsedFontFaceSources);
    return $86nT0.collectAndReportErrors(externalFontFaceUrlIndices.map(function(urlIndex) {
        var fontSrc = parsedFontFaceSources[urlIndex], format = fontSrc.format || "woff";
        return $86nT0.binaryAjax(fontSrc.url, options).then(function(content) {
            var base64Content = btoa(content);
            fontSrc.url = "data:font/" + format + ";base64," + base64Content;
            hasChanges = true;
        }, function(e) {
            throw {
                resourceType: "fontFace",
                url: e.url,
                msg: "Unable to load font-face " + e.url
            };
        });
    })).then(function(errors) {
        return {
            srcDeclarationValue: $hj1Yg.serialize(parsedFontFaceSources),
            hasChanges: hasChanges,
            errors: errors
        };
    });
};
var $cecfd79b64bfcb7e$var$iterateOverRulesAndInlineFontFace = function(cssRules, options) {
    var rulesToInline = $cecfd79b64bfcb7e$var$findFontFaceRules(cssRules), errors = [], hasChanges = false;
    return Promise.all(rulesToInline.map(function(rule) {
        var srcDeclarationValue = rule.style.getPropertyValue("src");
        return $cecfd79b64bfcb7e$var$loadAndInlineFontFace(srcDeclarationValue, options).then(function(result) {
            if (result.hasChanges) {
                $ej93s.changeFontFaceRuleSrc(cssRules, rule, result.srcDeclarationValue);
                hasChanges = true;
            }
            errors = errors.concat(result.errors);
        });
    })).then(function() {
        return {
            hasChanges: hasChanges,
            errors: errors
        };
    });
};
$cecfd79b64bfcb7e$export$4d10698d11d4f34e = function(cssRules, options) {
    var hasChanges = false, errors = [];
    return Promise.all([
        $cecfd79b64bfcb7e$var$iterateOverRulesAndInlineBackgroundImages,
        $cecfd79b64bfcb7e$var$iterateOverRulesAndInlineFontFace
    ].map(function(func) {
        return func(cssRules, options).then(function(result) {
            hasChanges = hasChanges || result.hasChanges;
            errors = errors.concat(result.errors);
        });
    })).then(function() {
        return {
            hasChanges: hasChanges,
            errors: errors
        };
    });
};

});
parcelRegister("ej93s", function(module, exports) {

$parcel$export(module.exports, "unquoteString", () => $a6a9dd1be3631776$export$f3cd630c4f65003b, (v) => $a6a9dd1be3631776$export$f3cd630c4f65003b = v);
$parcel$export(module.exports, "rulesForCssText", () => $a6a9dd1be3631776$export$f0a1e9cbd910f4f7, (v) => $a6a9dd1be3631776$export$f0a1e9cbd910f4f7 = v);
$parcel$export(module.exports, "cssRulesToText", () => $a6a9dd1be3631776$export$973c7ade6cdd5d8b, (v) => $a6a9dd1be3631776$export$973c7ade6cdd5d8b = v);
$parcel$export(module.exports, "exchangeRule", () => $a6a9dd1be3631776$export$c5dacf6cc42613a2, (v) => $a6a9dd1be3631776$export$c5dacf6cc42613a2 = v);
$parcel$export(module.exports, "changeFontFaceRuleSrc", () => $a6a9dd1be3631776$export$9bc84c8bc61968cc, (v) => $a6a9dd1be3631776$export$9bc84c8bc61968cc = v);
var $a6a9dd1be3631776$export$f3cd630c4f65003b;
var $a6a9dd1be3631776$export$f0a1e9cbd910f4f7;
var $a6a9dd1be3631776$export$973c7ade6cdd5d8b;
var $a6a9dd1be3631776$export$c5dacf6cc42613a2;
// Workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=443978
var $a6a9dd1be3631776$export$9bc84c8bc61968cc;
"use strict";
$a6a9dd1be3631776$export$f3cd630c4f65003b = function(quotedUrl) {
    var doubleQuoteRegex = /^"(.*)"$/, singleQuoteRegex = /^'(.*)'$/;
    if (doubleQuoteRegex.test(quotedUrl)) return quotedUrl.replace(doubleQuoteRegex, "$1");
    else {
        if (singleQuoteRegex.test(quotedUrl)) return quotedUrl.replace(singleQuoteRegex, "$1");
        else return quotedUrl;
    }
};
$a6a9dd1be3631776$export$f0a1e9cbd910f4f7 = function(styleContent) {
    var doc = document.implementation.createHTMLDocument(""), styleElement = document.createElement("style"), rules;
    styleElement.textContent = styleContent;
    // the style will only be parsed once it is added to a document
    doc.body.appendChild(styleElement);
    rules = styleElement.sheet.cssRules;
    return Array.prototype.slice.call(rules);
};
$a6a9dd1be3631776$export$973c7ade6cdd5d8b = function(cssRules) {
    return cssRules.reduce(function(cssText, rule) {
        return cssText + rule.cssText;
    }, "");
};
$a6a9dd1be3631776$export$c5dacf6cc42613a2 = function(cssRules, rule, newRuleText) {
    var ruleIdx = cssRules.indexOf(rule);
    // We create a new document and stylesheet to parse the rule,
    // instead of relying on rule.parentStyleSheet, because
    // rule.parentStyleSheet may be null
    // (https://github.com/cburgmer/inlineresources/issues/3)
    cssRules[ruleIdx] = $a6a9dd1be3631776$export$f0a1e9cbd910f4f7(newRuleText)[0];
};
$a6a9dd1be3631776$export$9bc84c8bc61968cc = function(cssRules, rule, newSrc) {
    var newRuleText = "@font-face { font-family: " + rule.style.getPropertyValue("font-family") + "; ";
    if (rule.style.getPropertyValue("font-style")) newRuleText += "font-style: " + rule.style.getPropertyValue("font-style") + "; ";
    if (rule.style.getPropertyValue("font-weight")) newRuleText += "font-weight: " + rule.style.getPropertyValue("font-weight") + "; ";
    if (rule.style.getPropertyValue("unicode-range")) newRuleText += "unicode-range: " + rule.style.getPropertyValue("unicode-range") + "; ";
    newRuleText += "src: " + newSrc + "}";
    $a6a9dd1be3631776$export$c5dacf6cc42613a2(cssRules, rule, newRuleText);
};

});

parcelRegister("ifuje", function(module, exports) {

$parcel$export(module.exports, "extractCssUrl", () => $d49123816e52c732$export$5cfc8e1de0b27419, (v) => $d49123816e52c732$export$5cfc8e1de0b27419 = v);
$parcel$export(module.exports, "parse", () => $d49123816e52c732$export$98e6a39c04603d36, (v) => $d49123816e52c732$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "serialize", () => $d49123816e52c732$export$dfdc1655ccc5b9cb, (v) => $d49123816e52c732$export$dfdc1655ccc5b9cb = v);
// Simple, stupid "background"/"background-image" value parser that just aims at exposing the image URLs
// TODO exporting this for the sake of unit testing. Should rather test the background value parser explicitly.
var $d49123816e52c732$export$5cfc8e1de0b27419;
var $d49123816e52c732$export$98e6a39c04603d36;
var $d49123816e52c732$export$dfdc1655ccc5b9cb;
"use strict";

var $ej93s = parcelRequire("ej93s");
var $d49123816e52c732$var$trimCSSWhitespace = function(url) {
    var whitespaceRegex = /^[\t\r\f\n ]*(.+?)[\t\r\f\n ]*$/;
    return url.replace(whitespaceRegex, "$1");
};
$d49123816e52c732$export$5cfc8e1de0b27419 = function(cssUrl) {
    var urlRegex = /^url\(("[^"]+"|'[^']+'|[^\)]+)\)/, quotedUrl;
    if (!urlRegex.test(cssUrl)) throw new Error("Invalid url");
    quotedUrl = urlRegex.exec(cssUrl)[1];
    return $ej93s.unquoteString($d49123816e52c732$var$trimCSSWhitespace(quotedUrl));
};
var $d49123816e52c732$var$sliceBackgroundDeclaration = function(backgroundDeclarationText) {
    var functionParamRegexS = "\\s*(?:\"[^\"]*\"|'[^']*'|[^\\(]+)\\s*", valueRegexS = "(url\\(" + functionParamRegexS + "\\)" + "|" + "[^,\\s]+" + ")", simpleSingularBackgroundRegexS = "(?:\\s*" + valueRegexS + ")+", simpleBackgroundRegexS = "^\\s*(" + simpleSingularBackgroundRegexS + ")" + "(?:\\s*,\\s*(" + simpleSingularBackgroundRegexS + "))*" + "\\s*$", simpleSingularBackgroundRegex = new RegExp(simpleSingularBackgroundRegexS, "g"), outerRepeatedMatch, backgroundLayers = [], getValues = function(singularBackgroundDeclaration) {
        var valueRegex = new RegExp(valueRegexS, "g"), backgroundValues = [], repeatedMatch;
        repeatedMatch = valueRegex.exec(singularBackgroundDeclaration);
        while(repeatedMatch){
            backgroundValues.push(repeatedMatch[1]);
            repeatedMatch = valueRegex.exec(singularBackgroundDeclaration);
        }
        return backgroundValues;
    };
    if (backgroundDeclarationText.match(new RegExp(simpleBackgroundRegexS))) {
        outerRepeatedMatch = simpleSingularBackgroundRegex.exec(backgroundDeclarationText);
        while(outerRepeatedMatch){
            backgroundLayers.push(getValues(outerRepeatedMatch[0]));
            outerRepeatedMatch = simpleSingularBackgroundRegex.exec(backgroundDeclarationText);
        }
        return backgroundLayers;
    }
    return [];
};
var $d49123816e52c732$var$findBackgroundImageUrlInValues = function(values) {
    var i, url;
    for(i = 0; i < values.length; i++)try {
        url = $d49123816e52c732$export$5cfc8e1de0b27419(values[i]);
        return {
            url: url,
            idx: i
        };
    } catch (e) {}
};
$d49123816e52c732$export$98e6a39c04603d36 = function(backgroundValue) {
    var backgroundLayers = $d49123816e52c732$var$sliceBackgroundDeclaration(backgroundValue);
    return backgroundLayers.map(function(backgroundLayerValues) {
        var urlMatch = $d49123816e52c732$var$findBackgroundImageUrlInValues(backgroundLayerValues);
        if (urlMatch) return {
            preUrl: backgroundLayerValues.slice(0, urlMatch.idx),
            url: urlMatch.url,
            postUrl: backgroundLayerValues.slice(urlMatch.idx + 1)
        };
        else return {
            preUrl: backgroundLayerValues
        };
    });
};
$d49123816e52c732$export$dfdc1655ccc5b9cb = function(parsedBackground) {
    var backgroundLayers = parsedBackground.map(function(backgroundLayer) {
        var values = [].concat(backgroundLayer.preUrl);
        if (backgroundLayer.url) values.push('url("' + backgroundLayer.url + '")');
        if (backgroundLayer.postUrl) values = values.concat(backgroundLayer.postUrl);
        return values.join(" ");
    });
    return backgroundLayers.join(", ");
};

});

parcelRegister("hj1Yg", function(module, exports) {
(function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(e) {
                    var n = t[o][1][e];
                    return s(n ? n : e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(_dereq_, module1, exports) {
                /*
 * Generated by PEG.js 0.10.0.
 *
 * http://pegjs.org/
 */ "use strict";
                function peg$subclass(child, parent) {
                    function ctor() {
                        this.constructor = child;
                    }
                    ctor.prototype = parent.prototype;
                    child.prototype = new ctor();
                }
                function peg$SyntaxError(message, expected, found, location) {
                    this.message = message;
                    this.expected = expected;
                    this.found = found;
                    this.location = location;
                    this.name = "SyntaxError";
                    if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, peg$SyntaxError);
                }
                peg$subclass(peg$SyntaxError, Error);
                peg$SyntaxError.buildMessage = function(expected, found) {
                    var DESCRIBE_EXPECTATION_FNS = {
                        literal: function(expectation) {
                            return '"' + literalEscape(expectation.text) + '"';
                        },
                        "class": function(expectation) {
                            var escapedParts = "", i;
                            for(i = 0; i < expectation.parts.length; i++)escapedParts += expectation.parts[i] instanceof Array ? classEscape(expectation.parts[i][0]) + "-" + classEscape(expectation.parts[i][1]) : classEscape(expectation.parts[i]);
                            return "[" + (expectation.inverted ? "^" : "") + escapedParts + "]";
                        },
                        any: function(expectation) {
                            return "any character";
                        },
                        end: function(expectation) {
                            return "end of input";
                        },
                        other: function(expectation) {
                            return expectation.description;
                        }
                    };
                    function hex(ch) {
                        return ch.charCodeAt(0).toString(16).toUpperCase();
                    }
                    function literalEscape(s) {
                        return s.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(ch) {
                            return "\\x0" + hex(ch);
                        }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) {
                            return "\\x" + hex(ch);
                        });
                    }
                    function classEscape(s) {
                        return s.replace(/\\/g, "\\\\").replace(/\]/g, "\\]").replace(/\^/g, "\\^").replace(/-/g, "\\-").replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(ch) {
                            return "\\x0" + hex(ch);
                        }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) {
                            return "\\x" + hex(ch);
                        });
                    }
                    function describeExpectation(expectation) {
                        return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
                    }
                    function describeExpected(expected) {
                        var descriptions = new Array(expected.length), i, j;
                        for(i = 0; i < expected.length; i++)descriptions[i] = describeExpectation(expected[i]);
                        descriptions.sort();
                        if (descriptions.length > 0) {
                            for(i = 1, j = 1; i < descriptions.length; i++)if (descriptions[i - 1] !== descriptions[i]) {
                                descriptions[j] = descriptions[i];
                                j++;
                            }
                            descriptions.length = j;
                        }
                        switch(descriptions.length){
                            case 1:
                                return descriptions[0];
                            case 2:
                                return descriptions[0] + " or " + descriptions[1];
                            default:
                                return descriptions.slice(0, -1).join(", ") + ", or " + descriptions[descriptions.length - 1];
                        }
                    }
                    function describeFound(found) {
                        return found ? '"' + literalEscape(found) + '"' : "end of input";
                    }
                    return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
                };
                function peg$parse(input, options) {
                    options = options !== void 0 ? options : {};
                    var peg$FAILED = {}, peg$startRuleFunctions = {
                        start: peg$parsestart
                    }, peg$startRuleFunction = peg$parsestart, peg$c0 = "", peg$c1 = function() {
                        return [];
                    }, peg$c2 = ",", peg$c3 = peg$literalExpectation(",", false), peg$c4 = function(x, xs) {
                        return [
                            x
                        ].concat(xs);
                    }, peg$c5 = function(entry) {
                        return [
                            entry
                        ];
                    }, peg$c6 = function(url, format) {
                        return {
                            url: url,
                            format: format
                        };
                    }, peg$c7 = function(url) {
                        return {
                            url: url
                        };
                    }, peg$c8 = "url(", peg$c9 = peg$literalExpectation("url(", false), peg$c10 = ")", peg$c11 = peg$literalExpectation(")", false), peg$c12 = function(value) {
                        return value;
                    }, peg$c13 = "format(", peg$c14 = peg$literalExpectation("format(", false), peg$c15 = "local(", peg$c16 = peg$literalExpectation("local(", false), peg$c17 = function(value) {
                        return {
                            local: value
                        };
                    }, peg$c18 = /^[^)]/, peg$c19 = peg$classExpectation([
                        ")"
                    ], true, false), peg$c20 = function(chars) {
                        return util.extractValue(chars.join(""));
                    }, peg$c21 = /^[ \t\r\n\f]/, peg$c22 = peg$classExpectation([
                        " ",
                        "	",
                        "\r",
                        "\n",
                        "\f"
                    ], false, false), peg$currPos = 0, peg$savedPos = 0, peg$posDetailsCache = [
                        {
                            line: 1,
                            column: 1
                        }
                    ], peg$maxFailPos = 0, peg$maxFailExpected = [], peg$silentFails = 0, peg$result;
                    if ("startRule" in options) {
                        if (!(options.startRule in peg$startRuleFunctions)) throw new Error("Can't start parsing from rule \"" + options.startRule + '".');
                        peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
                    }
                    function text() {
                        return input.substring(peg$savedPos, peg$currPos);
                    }
                    function location() {
                        return peg$computeLocation(peg$savedPos, peg$currPos);
                    }
                    function expected(description, location) {
                        location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos);
                        throw peg$buildStructuredError([
                            peg$otherExpectation(description)
                        ], input.substring(peg$savedPos, peg$currPos), location);
                    }
                    function error(message, location) {
                        location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos);
                        throw peg$buildSimpleError(message, location);
                    }
                    function peg$literalExpectation(text, ignoreCase) {
                        return {
                            type: "literal",
                            text: text,
                            ignoreCase: ignoreCase
                        };
                    }
                    function peg$classExpectation(parts, inverted, ignoreCase) {
                        return {
                            type: "class",
                            parts: parts,
                            inverted: inverted,
                            ignoreCase: ignoreCase
                        };
                    }
                    function peg$anyExpectation() {
                        return {
                            type: "any"
                        };
                    }
                    function peg$endExpectation() {
                        return {
                            type: "end"
                        };
                    }
                    function peg$otherExpectation(description) {
                        return {
                            type: "other",
                            description: description
                        };
                    }
                    function peg$computePosDetails(pos) {
                        var details = peg$posDetailsCache[pos], p;
                        if (details) return details;
                        else {
                            p = pos - 1;
                            while(!peg$posDetailsCache[p])p--;
                            details = peg$posDetailsCache[p];
                            details = {
                                line: details.line,
                                column: details.column
                            };
                            while(p < pos){
                                if (input.charCodeAt(p) === 10) {
                                    details.line++;
                                    details.column = 1;
                                } else details.column++;
                                p++;
                            }
                            peg$posDetailsCache[pos] = details;
                            return details;
                        }
                    }
                    function peg$computeLocation(startPos, endPos) {
                        var startPosDetails = peg$computePosDetails(startPos), endPosDetails = peg$computePosDetails(endPos);
                        return {
                            start: {
                                offset: startPos,
                                line: startPosDetails.line,
                                column: startPosDetails.column
                            },
                            end: {
                                offset: endPos,
                                line: endPosDetails.line,
                                column: endPosDetails.column
                            }
                        };
                    }
                    function peg$fail(expected) {
                        if (peg$currPos < peg$maxFailPos) return;
                        if (peg$currPos > peg$maxFailPos) {
                            peg$maxFailPos = peg$currPos;
                            peg$maxFailExpected = [];
                        }
                        peg$maxFailExpected.push(expected);
                    }
                    function peg$buildSimpleError(message, location) {
                        return new peg$SyntaxError(message, null, null, location);
                    }
                    function peg$buildStructuredError(expected, found, location) {
                        return new peg$SyntaxError(peg$SyntaxError.buildMessage(expected, found), expected, found, location);
                    }
                    function peg$parsestart() {
                        var s0, s1;
                        s0 = peg$parsesourceEntries();
                        if (s0 === peg$FAILED) {
                            s0 = peg$currPos;
                            s1 = peg$c0;
                            if (s1 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c1();
                            }
                            s0 = s1;
                        }
                        return s0;
                    }
                    function peg$parsesourceEntries() {
                        var s0, s1, s2, s3, s4, s5;
                        s0 = peg$currPos;
                        s1 = peg$parsesourceEntry();
                        if (s1 !== peg$FAILED) {
                            s2 = [];
                            s3 = peg$parsewhitespace();
                            while(s3 !== peg$FAILED){
                                s2.push(s3);
                                s3 = peg$parsewhitespace();
                            }
                            if (s2 !== peg$FAILED) {
                                if (input.charCodeAt(peg$currPos) === 44) {
                                    s3 = peg$c2;
                                    peg$currPos++;
                                } else {
                                    s3 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c3);
                                }
                                if (s3 !== peg$FAILED) {
                                    s4 = [];
                                    s5 = peg$parsewhitespace();
                                    while(s5 !== peg$FAILED){
                                        s4.push(s5);
                                        s5 = peg$parsewhitespace();
                                    }
                                    if (s4 !== peg$FAILED) {
                                        s5 = peg$parsesourceEntries();
                                        if (s5 !== peg$FAILED) {
                                            peg$savedPos = s0;
                                            s1 = peg$c4(s1, s5);
                                            s0 = s1;
                                        } else {
                                            peg$currPos = s0;
                                            s0 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                        if (s0 === peg$FAILED) {
                            s0 = peg$currPos;
                            s1 = peg$parsesourceEntry();
                            if (s1 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c5(s1);
                            }
                            s0 = s1;
                        }
                        return s0;
                    }
                    function peg$parsesourceEntry() {
                        var s0;
                        s0 = peg$parseurlEntry();
                        if (s0 === peg$FAILED) s0 = peg$parselocalEntry();
                        return s0;
                    }
                    function peg$parseurlEntry() {
                        var s0, s1, s2, s3;
                        s0 = peg$currPos;
                        s1 = peg$parseurl();
                        if (s1 !== peg$FAILED) {
                            s2 = [];
                            s3 = peg$parsewhitespace();
                            if (s3 !== peg$FAILED) while(s3 !== peg$FAILED){
                                s2.push(s3);
                                s3 = peg$parsewhitespace();
                            }
                            else s2 = peg$FAILED;
                            if (s2 !== peg$FAILED) {
                                s3 = peg$parseformat();
                                if (s3 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c6(s1, s3);
                                    s0 = s1;
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                        if (s0 === peg$FAILED) {
                            s0 = peg$currPos;
                            s1 = peg$parseurl();
                            if (s1 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c7(s1);
                            }
                            s0 = s1;
                        }
                        return s0;
                    }
                    function peg$parseurl() {
                        var s0, s1, s2, s3;
                        s0 = peg$currPos;
                        if (input.substr(peg$currPos, 4) === peg$c8) {
                            s1 = peg$c8;
                            peg$currPos += 4;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c9);
                        }
                        if (s1 !== peg$FAILED) {
                            s2 = peg$parsevalue();
                            if (s2 !== peg$FAILED) {
                                if (input.charCodeAt(peg$currPos) === 41) {
                                    s3 = peg$c10;
                                    peg$currPos++;
                                } else {
                                    s3 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c11);
                                }
                                if (s3 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c12(s2);
                                    s0 = s1;
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                        return s0;
                    }
                    function peg$parseformat() {
                        var s0, s1, s2, s3;
                        s0 = peg$currPos;
                        if (input.substr(peg$currPos, 7) === peg$c13) {
                            s1 = peg$c13;
                            peg$currPos += 7;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c14);
                        }
                        if (s1 !== peg$FAILED) {
                            s2 = peg$parsevalue();
                            if (s2 !== peg$FAILED) {
                                if (input.charCodeAt(peg$currPos) === 41) {
                                    s3 = peg$c10;
                                    peg$currPos++;
                                } else {
                                    s3 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c11);
                                }
                                if (s3 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c12(s2);
                                    s0 = s1;
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                        return s0;
                    }
                    function peg$parselocalEntry() {
                        var s0, s1, s2, s3;
                        s0 = peg$currPos;
                        if (input.substr(peg$currPos, 6) === peg$c15) {
                            s1 = peg$c15;
                            peg$currPos += 6;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c16);
                        }
                        if (s1 !== peg$FAILED) {
                            s2 = peg$parsevalue();
                            if (s2 !== peg$FAILED) {
                                if (input.charCodeAt(peg$currPos) === 41) {
                                    s3 = peg$c10;
                                    peg$currPos++;
                                } else {
                                    s3 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c11);
                                }
                                if (s3 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c17(s2);
                                    s0 = s1;
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                        return s0;
                    }
                    function peg$parsevalue() {
                        var s0, s1, s2;
                        s0 = peg$currPos;
                        s1 = [];
                        if (peg$c18.test(input.charAt(peg$currPos))) {
                            s2 = input.charAt(peg$currPos);
                            peg$currPos++;
                        } else {
                            s2 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c19);
                        }
                        if (s2 !== peg$FAILED) while(s2 !== peg$FAILED){
                            s1.push(s2);
                            if (peg$c18.test(input.charAt(peg$currPos))) {
                                s2 = input.charAt(peg$currPos);
                                peg$currPos++;
                            } else {
                                s2 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c19);
                            }
                        }
                        else s1 = peg$FAILED;
                        if (s1 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c20(s1);
                        }
                        s0 = s1;
                        return s0;
                    }
                    function peg$parsewhitespace() {
                        var s0;
                        if (peg$c21.test(input.charAt(peg$currPos))) {
                            s0 = input.charAt(peg$currPos);
                            peg$currPos++;
                        } else {
                            s0 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c22);
                        }
                        return s0;
                    }
                    var util = _dereq_("../util");
                    peg$result = peg$startRuleFunction();
                    if (peg$result !== peg$FAILED && peg$currPos === input.length) return peg$result;
                    else {
                        if (peg$result !== peg$FAILED && peg$currPos < input.length) peg$fail(peg$endExpectation());
                        throw peg$buildStructuredError(peg$maxFailExpected, peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null, peg$maxFailPos < input.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
                    }
                }
                module1.exports = {
                    SyntaxError: peg$SyntaxError,
                    parse: peg$parse
                };
            },
            {
                "../util": 3
            }
        ],
        2: [
            function(_dereq_, module1, exports) {
                var grammar = _dereq_("./grammar");
                exports.SyntaxError = function(message, offset) {
                    this.message = message;
                    this.offset = offset;
                };
                exports.parse = function(fontFaceSourceValue) {
                    try {
                        return grammar.parse(fontFaceSourceValue);
                    } catch (e) {
                        throw new exports.SyntaxError(e.message, e.offset);
                    }
                };
                exports.serialize = function(parsedFontFaceSources) {
                    return parsedFontFaceSources.map(function(sourceItem) {
                        var itemValue;
                        if (sourceItem.url) {
                            itemValue = 'url("' + sourceItem.url + '")';
                            if (sourceItem.format) itemValue += ' format("' + sourceItem.format + '")';
                        } else itemValue = 'local("' + sourceItem.local + '")';
                        return itemValue;
                    }).join(", ");
                };
            },
            {
                "./grammar": 1
            }
        ],
        3: [
            function(_dereq_, module1, exports) {
                var trimCSSWhitespace = function(value) {
                    var whitespaceRegex = /^[\t\r\f\n ]*(.+?)[\t\r\f\n ]*$/;
                    return value.replace(whitespaceRegex, "$1");
                };
                var unquoteString = function(quotedUrl) {
                    var doubleQuoteRegex = /^"(.*)"$/, singleQuoteRegex = /^'(.*)'$/;
                    if (doubleQuoteRegex.test(quotedUrl)) return quotedUrl.replace(doubleQuoteRegex, "$1");
                    else {
                        if (singleQuoteRegex.test(quotedUrl)) return quotedUrl.replace(singleQuoteRegex, "$1");
                        else return quotedUrl;
                    }
                };
                exports.extractValue = function(value) {
                    return unquoteString(trimCSSWhitespace(value));
                };
            },
            {}
        ]
    }, {}, [
        2
    ])(2);
});

});





parcelRegister("MPenY", function(module, exports) {
"use strict";
var $092c39395755e8e9$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
});

const $092c39395755e8e9$var$react_1 = $092c39395755e8e9$var$__importDefault((parcelRequire("8NFma")));

var $7lEwu = parcelRequire("7lEwu");
(0, $7lEwu.setup)($092c39395755e8e9$var$react_1.default.createElement), module.exports.default = $7lEwu.styled;

});
parcelRegister("7lEwu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.styled = module.exports.setup = module.exports.keyframes = module.exports.glob = module.exports.extractCss = module.exports.css = void 0;
let $5599ed9d15711d7f$var$e = {
    data: ""
}, $5599ed9d15711d7f$var$t = (t)=>"object" == typeof window ? ((t ? t.querySelector("#_goober") : window._goober) || Object.assign((t || document.head).appendChild(document.createElement("style")), {
        innerHTML: " ",
        id: "_goober"
    })).firstChild : t || $5599ed9d15711d7f$var$e, $5599ed9d15711d7f$var$r = (e)=>{
    let r = $5599ed9d15711d7f$var$t(e), s = r.data;
    return r.data = "", s;
}, $5599ed9d15711d7f$var$l = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, $5599ed9d15711d7f$var$a = /\/\*[^]*?\*\/|\s\s+|\n/g, $5599ed9d15711d7f$var$n = (e, t)=>{
    let r = "", s = "", o = "";
    for(let l in e){
        let a = e[l];
        "@" == l[0] ? "i" == l[1] ? r = l + " " + a + ";" : s += "f" == l[1] ? $5599ed9d15711d7f$var$n(a, l) : l + "{" + $5599ed9d15711d7f$var$n(a, "k" == l[1] ? "" : t) + "}" : "object" == typeof a ? s += $5599ed9d15711d7f$var$n(a, t ? t.replace(/([^,])+/g, (e)=>l.replace(/(^:.*)|([^,])+/g, (t)=>/&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t)) : l) : null != a && (l = l.replace(/[A-Z]/g, "-$&").toLowerCase(), o += $5599ed9d15711d7f$var$n.p ? $5599ed9d15711d7f$var$n.p(l, a) : l + ":" + a + ";");
    }
    return r + (t && o ? t + "{" + o + "}" : o) + s;
}, $5599ed9d15711d7f$var$o = {}, $5599ed9d15711d7f$var$s = (e)=>{
    if ("object" == typeof e) {
        let t = "";
        for(let r in e)t += r + $5599ed9d15711d7f$var$s(e[r]);
        return t;
    }
    return e;
}, $5599ed9d15711d7f$var$c = (e, t, r, p, c)=>{
    let u = $5599ed9d15711d7f$var$s(e), i = $5599ed9d15711d7f$var$o[u] || ($5599ed9d15711d7f$var$o[u] = ((e)=>{
        let t = 0, r = 11;
        for(; t < e.length;)r = 101 * r + e.charCodeAt(t++) >>> 0;
        return "go" + r;
    })(u));
    if (!$5599ed9d15711d7f$var$o[i]) {
        let t = u !== e ? e : ((e)=>{
            let t, r = [
                {}
            ];
            for(; t = $5599ed9d15711d7f$var$l.exec(e.replace($5599ed9d15711d7f$var$a, ""));)t[4] ? r.shift() : t[3] ? r.unshift(r[0][t[3]] = r[0][t[3]] || {}) : r[0][t[1]] = t[2];
            return r[0];
        })(e);
        $5599ed9d15711d7f$var$o[i] = $5599ed9d15711d7f$var$n(c ? {
            ["@keyframes " + i]: t
        } : t, r ? "" : "." + i);
    }
    return ((e, t, r)=>{
        -1 == t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
    })($5599ed9d15711d7f$var$o[i], t, p), i;
}, $5599ed9d15711d7f$var$i = (e, t, r)=>e.reduce((e, s, o)=>{
        let l = t[o];
        if (l && l.call) {
            let e = l(r), t = e && e.props && e.props.className || /^go/.test(e) && e;
            l = t ? "." + t : e && "object" == typeof e ? e.props ? "" : $5599ed9d15711d7f$var$n(e, "") : !1 === e ? "" : e;
        }
        return e + s + (null == l ? "" : l);
    }, "");
function $5599ed9d15711d7f$var$u(e) {
    let r = this || {}, s = e.call ? e(r.p) : e;
    return $5599ed9d15711d7f$var$c(s.unshift ? s.raw ? $5599ed9d15711d7f$var$i(s, [].slice.call(arguments, 1), r.p) : s.reduce((e, t)=>Object.assign(e, t && t.call ? t(r.p) : t), {}) : s, $5599ed9d15711d7f$var$t(r.target), r.g, r.o, r.k);
}
module.exports.extractCss = $5599ed9d15711d7f$var$r, module.exports.css = $5599ed9d15711d7f$var$u;
let $5599ed9d15711d7f$var$p, $5599ed9d15711d7f$var$d, $5599ed9d15711d7f$var$f, $5599ed9d15711d7f$var$g = $5599ed9d15711d7f$var$u.bind({
    g: 1
}), $5599ed9d15711d7f$var$b = $5599ed9d15711d7f$var$u.bind({
    k: 1
});
function $5599ed9d15711d7f$var$h(e, t, r, s) {
    $5599ed9d15711d7f$var$n.p = t, $5599ed9d15711d7f$var$p = e, $5599ed9d15711d7f$var$d = r, $5599ed9d15711d7f$var$f = s;
}
function $5599ed9d15711d7f$var$m(e, t) {
    let r = this || {};
    return function() {
        let s = arguments;
        function o(l, n) {
            let a = Object.assign({}, l), c = a.className || o.className;
            r.p = Object.assign({
                theme: $5599ed9d15711d7f$var$d && $5599ed9d15711d7f$var$d()
            }, a), r.o = / *go\d+/.test(c), a.className = $5599ed9d15711d7f$var$u.apply(r, s) + (c ? " " + c : ""), t && (a.ref = n);
            let i = e;
            return e[0] && (i = a.as || e, delete a.as), $5599ed9d15711d7f$var$f && i[0] && $5599ed9d15711d7f$var$f(a), $5599ed9d15711d7f$var$p(i, a);
        }
        return t ? t(o) : o;
    };
}
module.exports.glob = $5599ed9d15711d7f$var$g, module.exports.keyframes = $5599ed9d15711d7f$var$b, module.exports.setup = $5599ed9d15711d7f$var$h, module.exports.styled = $5599ed9d15711d7f$var$m;

});



parcelRegister("dB0vw", function(module, exports) {
"use strict";
var $9e5f1fd868351684$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.LineElement = module.exports.getLinePositionFromMiddlePoints = module.exports.getMiddlePoints = void 0;

const $9e5f1fd868351684$var$react_1 = $9e5f1fd868351684$var$__importDefault((parcelRequire("8NFma")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");
parcelRequire("k3LwQ");
var $fBZlQ = parcelRequire("fBZlQ");

var $kWHDJ = parcelRequire("kWHDJ");
parcelRequire("7TL1v");
var $eQWOP = parcelRequire("eQWOP");

var $4WWR6 = parcelRequire("4WWR6");

var $agLHp = parcelRequire("agLHp");

var $3pcZ0 = parcelRequire("3pcZ0");
function $9e5f1fd868351684$var$getMiddlePoints(e) {
    const { x: t, y: a, width: r, height: o, rotation: n } = e.a, i = n * Math.PI / 180, s = {
        x: t + o / 2 * Math.cos(i + Math.PI / 2),
        y: a + o / 2 * Math.sin(i + Math.PI / 2)
    };
    return {
        middleLeft: s,
        middleRight: {
            x: s.x + r * Math.cos(i),
            y: s.y + r * Math.sin(i)
        }
    };
}
function $9e5f1fd868351684$var$getLinePositionFromMiddlePoints(e, t, a) {
    const r = Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2)), o = Math.atan2(t.y - e.y, t.x - e.x), n = 180 * o / Math.PI;
    return {
        x: e.x + Math.cos(o - Math.PI / 2) * a / 2,
        y: e.y + Math.sin(o - Math.PI / 2) * a / 2,
        width: r,
        height: a,
        rotation: n
    };
}
module.exports.getMiddlePoints = $9e5f1fd868351684$var$getMiddlePoints, module.exports.getLinePositionFromMiddlePoints = $9e5f1fd868351684$var$getLinePositionFromMiddlePoints;
const $9e5f1fd868351684$var$getAnchorAttrs = (e, t)=>({
        offsetX: 5 / e,
        offsetY: 5 / e,
        width: 10 / e,
        height: 10 / e,
        fill: "white",
        stroke: "rgb(0, 161, 255)",
        strokeWidth: 2,
        strokeScaleEnabled: !1,
        draggable: !0,
        dragDistance: 0,
        onMouseEnter: (e)=>{
            e.target.getStage().container().style.cursor = "crosshair";
        },
        onMouseLeave: (e)=>{
            e.target.getStage().container().style.cursor = "";
        },
        onDragStart: (e)=>{
            t.history.startTransaction();
        },
        onDragEnd: (e)=>{
            t.history.endTransaction();
        }
    }), $9e5f1fd868351684$var$Head = (0, $O1ETn.observer)(({ element: e, type: t })=>{
    const a = (0, $kWHDJ.useColor)(e, e.a.color, "fill"), r = (0, $kWHDJ.useColor)(e, e.a.color, "stroke"), o = Object.assign(Object.assign(Object.assign({
        strokeWidth: e.height,
        lineCap: "round",
        lineJoin: "round"
    }, r), a), {
        opacity: e.a.opacity,
        hideInExport: !e.showInExport
    });
    return $9e5f1fd868351684$var$react_1.default.createElement($9e5f1fd868351684$var$react_1.default.Fragment, null, "arrow" === t && $9e5f1fd868351684$var$react_1.default.createElement($fBZlQ.Line, Object.assign({
        points: [
            3 * e.height,
            2 * -e.height,
            0,
            0,
            3 * e.height,
            2 * e.height
        ]
    }, o)), "triangle" === t && $9e5f1fd868351684$var$react_1.default.createElement($fBZlQ.Line, Object.assign({
        points: [
            3 * e.height,
            2 * -e.height,
            0,
            0,
            3 * e.height,
            2 * e.height
        ],
        closed: !0
    }, o)), "bar" === t && $9e5f1fd868351684$var$react_1.default.createElement($fBZlQ.Line, Object.assign({
        points: [
            0,
            2 * -e.height,
            0,
            2 * e.height
        ],
        closed: !0
    }, o)), "square" === t && $9e5f1fd868351684$var$react_1.default.createElement($fBZlQ.Line, Object.assign({
        points: [
            0,
            2 * -e.height,
            4 * e.height,
            2 * -e.height,
            4 * e.height,
            2 * e.height,
            0,
            2 * e.height
        ],
        closed: !0
    }, o)), "circle" === t && $9e5f1fd868351684$var$react_1.default.createElement($fBZlQ.Circle, Object.assign({
        x: 2 * e.height,
        y: 0,
        radius: 2 * e.height
    }, o)));
});
module.exports.LineElement = (0, $O1ETn.observer)(({ element: e, store: t })=>{
    const a = $9e5f1fd868351684$var$react_1.default.useRef(null), r = $9e5f1fd868351684$var$react_1.default.useRef(null), o = $9e5f1fd868351684$var$react_1.default.useRef(null), n = e.selectable || "admin" === t.role, i = (0, $3pcZ0.useMobile)(), [s, l] = $9e5f1fd868351684$var$react_1.default.useState(!1), c = t.selectedElements.indexOf(e) >= 0 && 1 === t.selectedElements.length, { middleLeft: h, middleRight: d } = $9e5f1fd868351684$var$getMiddlePoints(e);
    (0, $agLHp.useAnchorSnap)(r, [
        a
    ], [
        c
    ]), (0, $agLHp.useAnchorSnap)(o, [
        a
    ], [
        c
    ]);
    const g = (0, $kWHDJ.useColor)(e, e.a.color, "stroke");
    return $9e5f1fd868351684$var$react_1.default.createElement($9e5f1fd868351684$var$react_1.default.Fragment, null, $9e5f1fd868351684$var$react_1.default.createElement($fBZlQ.Line, Object.assign({
        ref: a,
        name: "element",
        id: e.id,
        x: e.a.x,
        y: e.a.y,
        points: [
            0,
            0,
            e.a.width,
            0
        ],
        offsetY: -e.a.height / 2,
        strokeWidth: e.a.height,
        hitStrokeWidth: Math.max(e.a.height, 20),
        dash: e.dash.map((t)=>t * e.a.height)
    }, g, {
        rotation: e.a.rotation,
        opacity: e.animated("opacity"),
        shadowEnabled: e.shadowEnabled,
        shadowBlur: e.shadowBlur,
        shadowOffsetX: e.shadowOffsetX,
        shadowOffsetY: e.shadowOffsetY,
        shadowColor: e.shadowColor,
        shadowOpacity: e.shadowOpacity,
        listening: n,
        draggable: i ? e.draggable && c : e.draggable,
        preventDefault: !i || c,
        hideInExport: !e.showInExport,
        onMouseEnter: ()=>{
            l(!0);
        },
        onMouseLeave: ()=>{
            l(!1);
        },
        onDragMove: (t)=>{
            e.set({
                x: t.target.x(),
                y: t.target.y()
            });
        },
        onDragEnd: (t)=>{
            e.set({
                x: t.target.x(),
                y: t.target.y()
            });
        },
        onTransform: (t)=>{
            const a = t.target.scaleX();
            t.target.scaleX(1), t.target.scaleY(1), e.set({
                height: e.height * a,
                width: e.width * a,
                x: t.target.x(),
                y: t.target.y(),
                rotation: t.target.rotation()
            });
        }
    })), $9e5f1fd868351684$var$react_1.default.createElement($fBZlQ.Group, {
        x: h.x,
        y: h.y,
        rotation: e.rotation,
        hideInExport: !e.showInExport
    }, $9e5f1fd868351684$var$react_1.default.createElement($9e5f1fd868351684$var$Head, {
        element: e,
        type: e.startHead
    })), $9e5f1fd868351684$var$react_1.default.createElement($fBZlQ.Group, {
        x: d.x,
        y: d.y,
        rotation: e.rotation + 180
    }, $9e5f1fd868351684$var$react_1.default.createElement($9e5f1fd868351684$var$Head, {
        element: e,
        type: e.endHead
    })), s && !c && $9e5f1fd868351684$var$react_1.default.createElement($4WWR6.Highlighter, {
        element: e
    }), c && e.resizable && $9e5f1fd868351684$var$react_1.default.createElement($eQWOP.Portal, {
        selector: ".page-abs-container",
        enabled: !0
    }, $9e5f1fd868351684$var$react_1.default.createElement($fBZlQ.Group, {
        visible: c
    }, $9e5f1fd868351684$var$react_1.default.createElement($fBZlQ.Rect, Object.assign({
        x: h.x,
        y: h.y,
        ref: r,
        name: "line-anchor"
    }, $9e5f1fd868351684$var$getAnchorAttrs(t.scale, t), {
        onDragMove: (t)=>{
            const a = $9e5f1fd868351684$var$getLinePositionFromMiddlePoints(t.target.position(), d, e.height);
            e.set({
                x: a.x,
                y: a.y,
                width: a.width,
                rotation: a.rotation
            });
        }
    })), $9e5f1fd868351684$var$react_1.default.createElement($fBZlQ.Rect, Object.assign({
        x: d.x,
        y: d.y,
        ref: o,
        name: "line-anchor"
    }, $9e5f1fd868351684$var$getAnchorAttrs(t.scale, t), {
        onDragMove: (t)=>{
            const a = $9e5f1fd868351684$var$getLinePositionFromMiddlePoints(h, t.target.position(), e.height);
            e.set({
                x: a.x,
                y: a.y,
                width: a.width,
                rotation: a.rotation
            });
        }
    })))));
});

});
parcelRegister("agLHp", function(module, exports) {
"use strict";
var $77a0660d4af51d01$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.useAnchorSnap = module.exports.useSnap = void 0;

const $77a0660d4af51d01$var$react_1 = $77a0660d4af51d01$var$__importDefault((parcelRequire("8NFma")));

const $77a0660d4af51d01$var$konva_1 = $77a0660d4af51d01$var$__importDefault((parcelRequire("ciNAD")));

var $kYy5r = parcelRequire("kYy5r");
var $77a0660d4af51d01$var$GUIDELINE_OFFSET = 5;
function $77a0660d4af51d01$var$getObjectSnappingEdges(e) {
    const t = e.__getNodeRect(), n = (0, $kYy5r.getClientRect)(Object.assign(Object.assign({}, t), {
        rotation: $77a0660d4af51d01$var$konva_1.default.Util.radToDeg(t.rotation)
    })), a = e.getAbsolutePosition();
    return {
        vertical: [
            {
                guide: n.x,
                offset: a.x - n.x,
                snap: "start"
            },
            {
                guide: n.x + n.width / 2,
                offset: a.x - n.x - n.width / 2,
                snap: "center"
            },
            {
                guide: n.x + n.width,
                offset: a.x - n.x - n.width,
                snap: "end"
            }
        ],
        horizontal: [
            {
                guide: n.y,
                offset: a.y - n.y,
                snap: "start"
            },
            {
                guide: n.y + n.height / 2,
                offset: a.y - n.y - n.height / 2,
                snap: "center"
            },
            {
                guide: n.y + n.height,
                offset: a.y - n.y - n.height,
                snap: "end"
            }
        ]
    };
}
function $77a0660d4af51d01$var$getGuides(e, t) {
    var n = [], a = [];
    e.vertical.forEach((e)=>{
        t.vertical.forEach((t)=>{
            var a = Math.abs(e - t.guide);
            a < $77a0660d4af51d01$var$GUIDELINE_OFFSET && n.push({
                lineGuide: e,
                diff: a,
                snap: t.snap,
                offset: t.offset
            });
        });
    }), e.horizontal.forEach((e)=>{
        t.horizontal.forEach((t)=>{
            var n = Math.abs(e - t.guide);
            n < $77a0660d4af51d01$var$GUIDELINE_OFFSET && a.push({
                lineGuide: e,
                diff: n,
                snap: t.snap,
                offset: t.offset
            });
        });
    });
    var i = [];
    const r = n.sort((e, t)=>e.diff - t.diff), o = a.sort((e, t)=>e.diff - t.diff);
    var s = r[0], d = o[0];
    if (s) r.filter((e)=>Math.abs(e.diff - s.diff) < .1).forEach((e)=>{
        i.push(Object.assign({
            orientation: "V"
        }, e));
    });
    if (d) o.filter((e)=>Math.abs(e.diff - d.diff) < .1).forEach((e)=>{
        i.push(Object.assign({
            orientation: "H"
        }, e));
    });
    return i;
}
function $77a0660d4af51d01$var$useSnap(e) {
    const t = (e)=>e.hasName("element") || e.hasName("page-background") || e.hasName("elements-area");
    function n(n) {
        var a;
        const i = null === (a = e.current) || void 0 === a ? void 0 : a.getStage();
        var r = [], o = [];
        return i.find(t).forEach((e)=>{
            if (!(n.indexOf(e) >= 0)) {
                var t = e.getClientRect({
                    skipShadow: !0,
                    skipStroke: !0
                });
                r.push(t.x, t.x + t.width, t.x + t.width / 2), o.push(t.y, t.y + t.height, t.y + t.height / 2);
            }
        }), {
            vertical: r,
            horizontal: o
        };
    }
    function a(t) {
        var n;
        const a = null === (n = e.current) || void 0 === n ? void 0 : n.getLayer(), i = null == a ? void 0 : a.children.find((e)=>"line-guides" === e.name());
        t.forEach((e)=>{
            if ("H" === e.orientation) {
                var t = new $77a0660d4af51d01$var$konva_1.default.Line({
                    points: [
                        -6000,
                        e.lineGuide,
                        6e3,
                        e.lineGuide
                    ],
                    stroke: "rgb(0, 161, 255)",
                    strokeWidth: 1,
                    name: "guid-line",
                    dash: [
                        4,
                        6
                    ]
                });
                null == i || i.add(t), a.batchDraw();
            } else if ("V" === e.orientation) {
                t = new $77a0660d4af51d01$var$konva_1.default.Line({
                    points: [
                        e.lineGuide,
                        -6000,
                        e.lineGuide,
                        6e3
                    ],
                    stroke: "rgb(0, 161, 255)",
                    strokeWidth: 1,
                    name: "guid-line",
                    dash: [
                        4,
                        6
                    ]
                });
                null == i || i.add(t);
            }
        });
    }
    const i = (e)=>{
        e.target.getLayer().children.find((e)=>"line-guides" === e.name()).destroyChildren();
        var t = $77a0660d4af51d01$var$getGuides(n(e.target.nodes()), $77a0660d4af51d01$var$getObjectSnappingEdges(e.target));
        if (!t.length) return;
        a(t);
        const i = e.target.getAbsolutePosition(), r = Object.assign({}, i);
        t.forEach((e)=>{
            switch(e.snap){
                case "start":
                case "center":
                case "end":
                    switch(e.orientation){
                        case "V":
                            r.x = e.lineGuide + e.offset;
                            break;
                        case "H":
                            r.y = e.lineGuide + e.offset;
                    }
            }
        });
        const o = r.x - i.x, s = r.y - i.y;
        e.evt.ctrlKey || e.evt.metaKey || e.target.nodes().forEach((e)=>{
            const t = e.getAbsolutePosition();
            e.setAbsolutePosition({
                x: t.x + o,
                y: t.y + s
            });
        });
    }, r = (t, i, r)=>{
        const o = e.current, s = o.getLayer();
        if (s.children.find((e)=>"line-guides" === e.name()).destroyChildren(), "rotater" === o.getActiveAnchor()) return i;
        if (Math.sqrt(Math.pow(i.x - t.x, 2) + Math.pow(i.y - t.y, 2)) > 50) return i;
        if (!s) return i;
        var d = $77a0660d4af51d01$var$getGuides(n(o.nodes()), {
            vertical: [
                {
                    guide: i.x,
                    offset: 0,
                    snap: "start"
                }
            ],
            horizontal: [
                {
                    guide: i.y,
                    offset: 0,
                    snap: "start"
                }
            ]
        });
        if (!d.length) return i;
        a(d);
        if (r.ctrlKey || r.metaKey) return i;
        let u = i.x, c = i.x;
        d.forEach((e)=>{
            switch(e.orientation){
                case "V":
                    u = e.lineGuide;
                    break;
                case "H":
                    c = e.lineGuide;
            }
        });
        const l = Math.abs(i.x - u) < 10, f = Math.abs(i.y - c) < 10;
        return l && !f ? {
            x: u,
            y: t.y
        } : f && !l ? {
            x: t.x,
            y: c
        } : l && f ? {
            x: u,
            y: c
        } : i;
    }, o = (e)=>{
        if (!e.target) return;
        const t = e.target.getLayer();
        t.children.find((e)=>"line-guides" === e.name()).destroyChildren(), t.batchDraw();
    };
    $77a0660d4af51d01$var$react_1.default.useEffect(()=>{
        e.current && (e.current.anchorDragBoundFunc(r), e.current.on("dragstart", ()=>{
            setTimeout(()=>{
                const e = [
                    ...$77a0660d4af51d01$var$konva_1.default.DD._dragElements.entries()
                ];
                e.reverse(), $77a0660d4af51d01$var$konva_1.default.DD._dragElements.clear(), e.forEach(([e, t])=>{
                    $77a0660d4af51d01$var$konva_1.default.DD._dragElements.set(e, t);
                });
            });
        }), e.current.on("dragmove", i), e.current.on("dragend", o), e.current.on("transformend", o), e.current.on("transform", (t)=>{
            var n, a;
            t.evt.ctrlKey || t.evt.metaKey ? null === (n = e.current) || void 0 === n || n.rotationSnapTolerance(0) : null === (a = e.current) || void 0 === a || a.rotationSnapTolerance(5);
        }));
    }, []);
}
function $77a0660d4af51d01$var$getAnchorSnappingEdges(e) {
    return {
        vertical: [
            {
                guide: e.absolutePosition().x,
                offset: 0,
                snap: "center"
            }
        ],
        horizontal: [
            {
                guide: e.absolutePosition().y,
                offset: 0,
                snap: "center"
            }
        ]
    };
}
function $77a0660d4af51d01$var$useAnchorSnap(e, t, n) {
    const a = (e)=>e.hasName("element") || e.hasName("line-anchor") || e.hasName("page-background") || e.hasName("elements-area");
    const i = (n)=>{
        n.target.getLayer().children.find((e)=>"line-guides" === e.name()).destroyChildren();
        var i = $77a0660d4af51d01$var$getGuides(function(t) {
            var n;
            const i = null === (n = e.current) || void 0 === n ? void 0 : n.getStage();
            var r = [], o = [];
            return i.find(a).forEach((e)=>{
                if (!(t.indexOf(e) >= 0)) {
                    var n = e.getClientRect({
                        skipShadow: !0,
                        skipStroke: !0
                    });
                    e.hasName("line-anchor") && (n = {
                        x: e.absolutePosition().x,
                        y: e.absolutePosition().y,
                        width: 0,
                        height: 0
                    }), r.push(n.x, n.x + n.width, n.x + n.width / 2), o.push(n.y, n.y + n.height, n.y + n.height / 2);
                }
            }), {
                vertical: r,
                horizontal: o
            };
        }([
            n.target,
            ...t.map((e)=>e.current)
        ]), $77a0660d4af51d01$var$getAnchorSnappingEdges(n.target));
        if (!i.length) return;
        !function(t) {
            var n;
            const a = null === (n = e.current) || void 0 === n ? void 0 : n.getLayer(), i = null == a ? void 0 : a.children.find((e)=>"line-guides" === e.name());
            t.forEach((e)=>{
                if ("H" === e.orientation) {
                    var t = new $77a0660d4af51d01$var$konva_1.default.Line({
                        points: [
                            -6000,
                            e.lineGuide,
                            6e3,
                            e.lineGuide
                        ],
                        stroke: "rgb(0, 161, 255)",
                        strokeWidth: 1,
                        name: "guid-line",
                        dash: [
                            4,
                            6
                        ]
                    });
                    null == i || i.add(t), a.batchDraw();
                } else "V" === e.orientation && (t = new $77a0660d4af51d01$var$konva_1.default.Line({
                    points: [
                        e.lineGuide,
                        -6000,
                        e.lineGuide,
                        6e3
                    ],
                    stroke: "rgb(0, 161, 255)",
                    strokeWidth: 1,
                    name: "guid-line",
                    dash: [
                        4,
                        6
                    ]
                }), null == i || i.add(t));
            });
        }(i);
        const r = n.target.getAbsolutePosition(), o = Object.assign({}, r);
        i.forEach((e)=>{
            switch(e.snap){
                case "start":
                case "center":
                case "end":
                    switch(e.orientation){
                        case "V":
                            o.x = e.lineGuide + e.offset;
                            break;
                        case "H":
                            o.y = e.lineGuide + e.offset;
                    }
            }
        });
        const s = o.x - r.x, d = o.y - r.y;
        if (!(n.evt.ctrlKey || n.evt.metaKey)) {
            const e = n.target.getAbsolutePosition();
            n.target.absolutePosition({
                x: e.x + s,
                y: e.y + d
            });
        }
    }, r = (e)=>{
        if (!e.target) return;
        const t = e.target.getLayer();
        t.children.find((e)=>"line-guides" === e.name()).destroyChildren(), t.batchDraw();
    };
    $77a0660d4af51d01$var$react_1.default.useEffect(()=>{
        e.current && (e.current.on("dragmove", i), e.current.on("dragend", r));
    }, n);
}
module.exports.useSnap = $77a0660d4af51d01$var$useSnap, module.exports.useAnchorSnap = $77a0660d4af51d01$var$useAnchorSnap;

});
parcelRegister("kYy5r", function(module, exports) {
"use strict";
var $f453da26e3fa660e$var$__importDefault = module.exports && module.exports.__importDefault || function(t) {
    return t && t.__esModule ? t : {
        default: t
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.getTotalClientRect = module.exports.getClientRect = void 0;

const $f453da26e3fa660e$var$konva_1 = $f453da26e3fa660e$var$__importDefault((parcelRequire("ciNAD")));
function $f453da26e3fa660e$var$getCorner(t, e, n, a, i) {
    const o = Math.sqrt(n * n + a * a);
    i += Math.atan2(a, n);
    return {
        x: t + o * Math.cos(i),
        y: e + o * Math.sin(i)
    };
}
function $f453da26e3fa660e$var$getClientRect(t) {
    const { x: e, y: n, width: a, height: i } = t, o = $f453da26e3fa660e$var$konva_1.default.Util.degToRad(t.rotation), r = $f453da26e3fa660e$var$getCorner(e, n, 0, 0, o), m = $f453da26e3fa660e$var$getCorner(e, n, a, 0, o), x = $f453da26e3fa660e$var$getCorner(e, n, a, i, o), h = $f453da26e3fa660e$var$getCorner(e, n, 0, i, o), l = Math.min(r.x, m.x, x.x, h.x), c = Math.min(r.y, m.y, x.y, h.y), g = Math.max(r.x, m.x, x.x, h.x), s = Math.max(r.y, m.y, x.y, h.y);
    return {
        x: l,
        y: c,
        width: g - l,
        height: s - c,
        minX: l,
        minY: c,
        maxX: g,
        maxY: s
    };
}
function $f453da26e3fa660e$var$getTotalClientRect(t) {
    const e = t.map((t)=>$f453da26e3fa660e$var$getClientRect(t)), n = Math.min(...e.map((t)=>t.minX)), a = Math.min(...e.map((t)=>t.minY)), i = Math.max(...e.map((t)=>t.maxX)), o = Math.max(...e.map((t)=>t.maxY));
    return {
        x: n,
        y: a,
        width: i - n,
        height: o - a,
        minX: n,
        minY: a,
        maxX: i,
        maxY: o
    };
}
module.exports.getClientRect = $f453da26e3fa660e$var$getClientRect, module.exports.getTotalClientRect = $f453da26e3fa660e$var$getTotalClientRect;

});



parcelRegister("e2GRP", function(module, exports) {
"use strict";
var $a392811eb6e8bd8c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(e, t, r, a) {
    void 0 === a && (a = r);
    var i = Object.getOwnPropertyDescriptor(t, r);
    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
        enumerable: !0,
        get: function() {
            return t[r];
        }
    }), Object.defineProperty(e, a, i);
} : function(e, t, r, a) {
    void 0 === a && (a = r), e[a] = t[r];
}), $a392811eb6e8bd8c$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(e, t) {
    Object.defineProperty(e, "default", {
        enumerable: !0,
        value: t
    });
} : function(e, t) {
    e.default = t;
}), $a392811eb6e8bd8c$var$__importStar = module.exports && module.exports.__importStar || function(e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && $a392811eb6e8bd8c$var$__createBinding(t, e, r);
    return $a392811eb6e8bd8c$var$__setModuleDefault(t, e), t;
}, $a392811eb6e8bd8c$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.VideoElement = module.exports.useImageLoader = module.exports.setImageLoaderHook = void 0;

const $a392811eb6e8bd8c$var$react_1 = $a392811eb6e8bd8c$var$__importDefault((parcelRequire("8NFma")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

var $2SBKn = parcelRequire("2SBKn");
parcelRequire("k3LwQ");
var $fBZlQ = parcelRequire("fBZlQ");

const $a392811eb6e8bd8c$var$use_image_1 = $a392811eb6e8bd8c$var$__importDefault((parcelRequire("fY5ZF")));

const $a392811eb6e8bd8c$var$konva_1 = $a392811eb6e8bd8c$var$__importDefault((parcelRequire("ciNAD")));
parcelRequire("7TL1v");
var $eQWOP = parcelRequire("eQWOP");

var $4WWR6 = parcelRequire("4WWR6");

var $l4lre = parcelRequire("l4lre");

const $a392811eb6e8bd8c$var$svg = $a392811eb6e8bd8c$var$__importStar((parcelRequire("eRGXT")));

var $gS5ZA = parcelRequire("gS5ZA");

var $aWsdH = parcelRequire("aWsdH");

var $9uXpD = parcelRequire("9uXpD");

var $3pcZ0 = parcelRequire("3pcZ0");
function $a392811eb6e8bd8c$var$createCanvas() {
    return document.createElement("canvas");
}
async function $a392811eb6e8bd8c$var$getFixedUrl(e) {
    if (!(e.indexOf("data:image/svg+xml") >= 0 || e.indexOf(".svg") >= 0)) return e;
    const t = await $a392811eb6e8bd8c$var$svg.urlToString(e), r = $a392811eb6e8bd8c$var$svg.fixSize(t);
    return $a392811eb6e8bd8c$var$svg.svgToURL(r);
}
const $a392811eb6e8bd8c$var$useSizeFixer = (e)=>{
    const [t, r] = $a392811eb6e8bd8c$var$react_1.default.useState(e);
    return $a392811eb6e8bd8c$var$react_1.default.useEffect(()=>{
        (async ()=>{
            const a = await $a392811eb6e8bd8c$var$getFixedUrl(e);
            a !== t && r(a);
        })();
    }, [
        e
    ]), t;
}, $a392811eb6e8bd8c$var$playIcon = new window.Image;
$a392811eb6e8bd8c$var$playIcon.src = $a392811eb6e8bd8c$var$svg.svgToURL('\n  <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path opacity="0.6" d="M4 5.49683V18.5032C4 20.05 5.68077 21.0113 7.01404 20.227L18.0694 13.7239C19.384 12.9506 19.384 11.0494 18.0694 10.2761L7.01404 3.77296C5.68077 2.98869 4 3.95 4 5.49683Z" fill="white"/>\n  <path d="M4 5.49683V18.5032C4 20.05 5.68077 21.0113 7.01404 20.227L18.0694 13.7239C19.384 12.9506 19.384 11.0494 18.0694 10.2761L7.01404 3.77296C5.68077 2.98869 4 3.95 4 5.49683Z" stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n  </svg>\n');
const $a392811eb6e8bd8c$var$pauseIcon = new window.Image;
$a392811eb6e8bd8c$var$pauseIcon.src = $a392811eb6e8bd8c$var$svg.svgToURL('\n  <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path opacity="0.6" d="M14 19L14 5C14 3.89543 14.8954 3 16 3L17 3C18.1046 3 19 3.89543 19 5L19 19C19 20.1046 18.1046 21 17 21L16 21C14.8954 21 14 20.1046 14 19Z" fill="white"/>\n  <path opacity="0.6" d="M10 19L10 5C10 3.89543 9.10457 3 8 3L7 3C5.89543 3 5 3.89543 5 5L5 19C5 20.1046 5.89543 21 7 21L8 21C9.10457 21 10 20.1046 10 19Z" fill="white"/>\n  <path d="M14 19L14 5C14 3.89543 14.8954 3 16 3L17 3C18.1046 3 19 3.89543 19 5L19 19C19 20.1046 18.1046 21 17 21L16 21C14.8954 21 14 20.1046 14 19Z" stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n  <path d="M10 19L10 5C10 3.89543 9.10457 3 8 3L7 3C5.89543 3 5 3.89543 5 5L5 19C5 20.1046 5.89543 21 7 21L8 21C9.10457 21 10 20.1046 10 19Z" stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n  </svg>\n');
const $a392811eb6e8bd8c$var$useFlip = (e, t, r)=>{
    const a = $a392811eb6e8bd8c$var$react_1.default.useMemo(()=>{
        var a, i;
        const { flipX: o, flipY: n } = e, d = "svg" === e.type || e.src.indexOf("data:image/svg+xml") >= 0 || e.src.indexOf(".svg") >= 0, c = navigator.userAgent.toLowerCase().indexOf("firefox") > -1 && d || e.maskSrc;
        if (!o && !n && !c) return t;
        if (!t || !t.width || !t.height) return null;
        const l = $a392811eb6e8bd8c$var$createCanvas();
        let h = 1;
        "svg" === e.type && (h = Math.max(e.width / t.width * r, e.height / t.height * r)), l.width = Math.max(t.width * h, 1), l.height = Math.max(t.height * h, 1);
        let u = o ? -l.width : 0, s = n ? -l.height : 0;
        return null === (a = l.getContext("2d")) || void 0 === a || a.scale(o ? -1 : 1, n ? -1 : 1), null === (i = l.getContext("2d")) || void 0 === i || i.drawImage(t, u, s, l.width, l.height), l;
    }, [
        e.maskSrc,
        e.flipX,
        e.flipY,
        t,
        e.width,
        e.height,
        r
    ]);
    return $a392811eb6e8bd8c$var$react_1.default.useEffect(()=>()=>{
            a && "CANVAS" === a.nodeName && $a392811eb6e8bd8c$var$konva_1.default.Util.releaseCanvas(a);
        }, [
        a
    ]), a;
};
function $a392811eb6e8bd8c$var$getCrop(e, t) {
    const r = t.width / t.height;
    let a, i;
    r >= e.width / e.height ? (a = e.width, i = e.width / r) : (a = e.height * r, i = e.height);
    return {
        x: (e.width - a) / 2,
        y: (e.height - i) / 2,
        width: a,
        height: i
    };
}
function $a392811eb6e8bd8c$var$downsample(e, t, r, a, i, o, n) {
    for(var d = new ImageData(t, r), c = new Int32Array(e.data.buffer), l = e.width, h = new Int32Array(d.data.buffer), u = d.width, s = t / o, g = r / n, f = Math.round(1 / s), p = Math.round(1 / g), _ = f * p, m = 0; m < d.height; m++)for(var w = 0; w < u; w++){
        for(var v = a + Math.round(w / s) + (i + Math.round(m / g)) * l, x = 0, y = 0, M = 0, E = 0, b = 0; b < p; b++)for(var L = 0; L < f; L++){
            var C = c[v + L + b * l];
            x += C << 24 >>> 24, y += C << 16 >>> 24, M += C << 8 >>> 24, E += C >>> 24;
        }
        x = Math.round(x / _), y = Math.round(y / _), M = Math.round(M / _), E = Math.round(E / _), h[w + m * u] = E << 24 | M << 16 | y << 8 | x;
    }
    return d;
}
function $a392811eb6e8bd8c$var$downScaleCanvas(e, t) {
    var r, a;
    const i = $a392811eb6e8bd8c$var$createCanvas();
    i.width = e.width, i.height = e.height, null === (r = i.getContext("2d")) || void 0 === r || r.drawImage(e, 0, 0, i.width, i.height);
    const o = $a392811eb6e8bd8c$var$downsample(i.getContext("2d").getImageData(0, 0, i.width, i.height), Math.floor(i.width * t), Math.floor(i.height * t), 0, 0, i.width, i.height);
    return i.width = Math.floor(i.width * t), i.height = Math.floor(i.height * t), null === (a = i.getContext("2d")) || void 0 === a || a.putImageData(o, 0, 0), i;
}
const $a392811eb6e8bd8c$var$useCornerRadiusAndCrop = (e, t, r, a, i = 0, o = !1)=>{
    const n = Math.floor(Math.max(e.width * a, 1)), d = Math.floor(Math.max(e.height * a, 1)), c = Math.min(i * a, n / 2, d / 2), l = Math.max(e.width / r.width, e.height / r.height) * a, h = e.page._exporting && $gS5ZA.flags.imageDownScalingEnabled && l < 1 && !o, u = 0 === r.x && 0 === r.y && r.width === (null == t ? void 0 : t.width) && r.height === (null == t ? void 0 : t.height), s = $a392811eb6e8bd8c$var$react_1.default.useMemo(()=>{
        if (!t || !t.width || !t.height) return;
        return u && 0 === c && !h ? void 0 : $a392811eb6e8bd8c$var$createCanvas();
    }, [
        t,
        c,
        h,
        u
    ]);
    return $a392811eb6e8bd8c$var$react_1.default.useLayoutEffect(()=>{
        if (!s || !t) return;
        s.width = n, s.height = d;
        const e = s.getContext("2d");
        if (!e) return;
        c && (e.beginPath(), e.moveTo(c, 0), e.lineTo(n - c, 0), e.arc(n - c, c, c, 3 * Math.PI / 2, 0, !1), e.lineTo(n, d - c), e.arc(n - c, d - c, c, 0, Math.PI / 2, !1), e.lineTo(c, d), e.arc(c, d - c, c, Math.PI / 2, Math.PI, !1), e.lineTo(0, c), e.arc(c, c, c, Math.PI, 3 * Math.PI / 2, !1), e.clip());
        const a = h ? $a392811eb6e8bd8c$var$downScaleCanvas(t, l) : t, i = h ? {
            x: Math.floor(r.x * l),
            y: Math.floor(r.y * l),
            width: Math.floor(r.width * l),
            height: Math.floor(r.height * l)
        } : r;
        e.drawImage(a, i.x, i.y, i.width, i.height, 0, 0, s.width, s.height);
    }, [
        s,
        e.width,
        e.height,
        r.x,
        r.y,
        r.width,
        r.height,
        i,
        a,
        o,
        e.page._exporting,
        h
    ]), $a392811eb6e8bd8c$var$react_1.default.useEffect(()=>()=>{
            s && "CANVAS" === s.nodeName && $a392811eb6e8bd8c$var$konva_1.default.Util.releaseCanvas(s);
        }, [
        s
    ]), s || t;
}, $a392811eb6e8bd8c$var$useClip = (e, t, r, a)=>{
    const i = $a392811eb6e8bd8c$var$useSizeFixer(e.clipSrc || ""), [o, n] = $a392811eb6e8bd8c$var$useImageHook(i, "anonymous"), d = e.clipSrc ? n : "loaded";
    (0, module.exports.useImageLoader)(d, e.id + "-clip");
    const c = $a392811eb6e8bd8c$var$react_1.default.useMemo(()=>{
        if (t && o) return $a392811eb6e8bd8c$var$createCanvas();
    }, [
        t,
        o
    ]);
    $a392811eb6e8bd8c$var$react_1.default.useLayoutEffect(()=>{
        var a;
        if (!o) return;
        if (!t || !t.width || !t.height) return;
        if (!o || !o.width || !o.height) return;
        if (!c) return;
        const i = $a392811eb6e8bd8c$var$createCanvas(), n = Math.max(e.width / o.width * r, e.height / o.height * r);
        i.width = o.width * n, i.height = o.height * n, null === (a = i.getContext("2d")) || void 0 === a || a.drawImage(o, 0, 0, i.width, i.height), c.width = Math.max(t.width, 1), c.height = Math.max(t.height, 1);
        const d = c.getContext("2d");
        d && (d.save(), d.drawImage(i, 0, 0, t.width, t.height), $a392811eb6e8bd8c$var$konva_1.default.Util.releaseCanvas(i), d.globalCompositeOperation = "source-in", d.drawImage(t, 0, 0, c.width, c.height), d.restore());
    }, [
        c,
        t,
        o,
        e.width,
        e.height,
        r,
        ...a
    ]);
    return e.clipSrc && o ? c : t;
}, $a392811eb6e8bd8c$var$PLACEHOLDER_CANVAS = $a392811eb6e8bd8c$var$createCanvas(), $a392811eb6e8bd8c$var$LoadingPlaceholder = (0, $O1ETn.observer)(({ element: e })=>{
    const t = Math.min(30, e.width / 4, e.height / 4), r = $a392811eb6e8bd8c$var$react_1.default.useRef(null);
    return $a392811eb6e8bd8c$var$react_1.default.useEffect(()=>{
        const e = r.current;
        if (!e) return;
        const t = new $a392811eb6e8bd8c$var$konva_1.default.Animation((t)=>{
            e.rotate(((null == t ? void 0 : t.timeDiff) || 0) / 2);
        }, e.getLayer());
        return t.start(), ()=>{
            t.stop();
        };
    }), $a392811eb6e8bd8c$var$react_1.default.createElement($fBZlQ.Group, {
        x: e.x,
        y: e.y,
        rotation: e.rotation,
        listening: !1,
        opacity: e.a.opacity,
        hideInExport: !e.showInExport
    }, $a392811eb6e8bd8c$var$react_1.default.createElement($fBZlQ.Rect, {
        width: e.width,
        height: e.height,
        fill: "rgba(124, 173, 212, 0.8)"
    }), $a392811eb6e8bd8c$var$react_1.default.createElement($fBZlQ.Arc, {
        ref: r,
        x: e.width / 2,
        y: e.height / 2,
        fill: "white",
        outerRadius: Math.abs(t),
        innerRadius: Math.max(1, t - 5),
        angle: 270
    }));
}), $a392811eb6e8bd8c$var$ErrorPlaceholder = (0, $O1ETn.observer)(({ element: e })=>{
    const t = "Can not load the video...", r = Math.max(10, Math.min(30, e.width / 25));
    return $a392811eb6e8bd8c$var$react_1.default.createElement($fBZlQ.Group, {
        x: e.x,
        y: e.y,
        rotation: e.rotation,
        listening: !1,
        opacity: e.a.opacity,
        hideInExport: !e.showInExport
    }, $a392811eb6e8bd8c$var$react_1.default.createElement($fBZlQ.Rect, {
        width: e.width,
        height: e.height,
        fill: "rgba(223, 102, 102, 0.8)"
    }), $a392811eb6e8bd8c$var$react_1.default.createElement($fBZlQ.Text, {
        text: t,
        fontSize: r,
        width: e.width,
        height: e.height,
        align: "center",
        fill: "white",
        verticalAlign: "middle",
        padding: 5
    }));
});
let $a392811eb6e8bd8c$var$useImageHook = $a392811eb6e8bd8c$var$use_image_1.default;
const $a392811eb6e8bd8c$var$setImageLoaderHook = (e)=>{
    $a392811eb6e8bd8c$var$useImageHook = e;
};
module.exports.setImageLoaderHook = $a392811eb6e8bd8c$var$setImageLoaderHook;
const $a392811eb6e8bd8c$var$useImageLoader = (e, t)=>{
    const r = $a392811eb6e8bd8c$var$react_1.default.useRef(), a = ()=>{
        var e;
        null === (e = r.current) || void 0 === e || e.call(r), r.current = void 0;
    };
    $a392811eb6e8bd8c$var$react_1.default.useEffect(()=>a, []), $a392811eb6e8bd8c$var$react_1.default.useLayoutEffect(()=>{
        "loading" !== e || r.current || (r.current = (0, $l4lre.incrementLoader)(`video ${t}`)), "loading" !== e && a(), "failed" === e && (0, $l4lre.triggerLoadError)(`video ${t}`);
    }, [
        e
    ]);
};
module.exports.useImageLoader = $a392811eb6e8bd8c$var$useImageLoader;
const $a392811eb6e8bd8c$var$usePreviousImage = ({ image: e, status: t, type: r })=>{
    const a = $a392811eb6e8bd8c$var$react_1.default.useRef();
    $a392811eb6e8bd8c$var$react_1.default.useEffect(()=>{
        a.current = e || a.current;
    }, [
        e
    ]);
    return "failed" !== t || "failed" !== t && "svg" === r ? a.current : void 0;
};
function $a392811eb6e8bd8c$var$isBuffered(e, t) {
    for(var r = e.buffered, a = 0; a < r.length; a++)if (t >= r.start(a) && t <= r.end(a)) return !0;
    return !1;
}
const $a392811eb6e8bd8c$var$useImageSource = (e)=>{
    const [t, r] = $a392811eb6e8bd8c$var$react_1.default.useReducer((e)=>e + 1, 0), a = $a392811eb6e8bd8c$var$react_1.default.useRef("loading"), i = $a392811eb6e8bd8c$var$react_1.default.useRef(e.src), o = $a392811eb6e8bd8c$var$react_1.default.useRef(e.src);
    return o.current !== e.src && (o.current = e.src, a.current = "loading"), $a392811eb6e8bd8c$var$react_1.default.useEffect(()=>{
        if ("image" === e.type) return;
        if (!e.src) return;
        let t = !1;
        return (async ()=>{
            a.current = "loading", r();
            const o = await $a392811eb6e8bd8c$var$svg.urlToString(e.src), n = $a392811eb6e8bd8c$var$svg.fixSize(o), d = $a392811eb6e8bd8c$var$svg.replaceColors(n, e.colorsReplace);
            t || (i.current = d, a.current = "loaded", r());
        })(), ()=>{
            t = !0;
        };
    }, [
        e.src,
        JSON.stringify(e.colorsReplace)
    ]), "image" === e.type ? [
        e.src,
        "loaded"
    ] : [
        i.current,
        a.current
    ];
};
function $a392811eb6e8bd8c$var$useVideo(e, t, r) {
    const a = $a392811eb6e8bd8c$var$react_1.default.useRef("loading"), i = $a392811eb6e8bd8c$var$react_1.default.useRef(), [o, n] = $a392811eb6e8bd8c$var$react_1.default.useState(0), d = $a392811eb6e8bd8c$var$react_1.default.useRef(), c = $a392811eb6e8bd8c$var$react_1.default.useRef(), l = $a392811eb6e8bd8c$var$react_1.default.useRef();
    return d.current === e && c.current === t && l.current === r || (a.current = "loading", i.current = void 0, d.current = e, c.current = t, l.current = r), $a392811eb6e8bd8c$var$react_1.default.useLayoutEffect(function() {
        if (e) {
            var o = document.createElement("video");
            return o.addEventListener("canplay", d), o.addEventListener("error", c), t && (o.crossOrigin = t), r && (o.referrerpolicy = r), o.src = e, function() {
                o.removeEventListener("canplay", d), o.removeEventListener("error", c);
            };
        }
        function d() {
            a.current = "loaded", i.current = o, i.current.currentTime = 0, n(Math.random()), i.current.removeEventListener("canplay", d);
        }
        function c(e) {
            a.current = "failed", i.current = void 0, n(Math.random());
        }
    }, [
        e,
        t,
        r
    ]), [
        i.current,
        a.current
    ];
}
module.exports.VideoElement = (0, $O1ETn.observer)(({ element: e, store: t })=>{
    var r;
    const [a, i] = $a392811eb6e8bd8c$var$react_1.default.useState(!1), o = $a392811eb6e8bd8c$var$react_1.default.useRef(null), n = $a392811eb6e8bd8c$var$react_1.default.useRef(null), [d, c] = $a392811eb6e8bd8c$var$react_1.default.useState(!1), l = t.selectedElements.indexOf(e) >= 0, [h, u] = $a392811eb6e8bd8c$var$react_1.default.useState(!1), [s, g] = $a392811eb6e8bd8c$var$useVideo(e.src, "anonymous"), f = t.activePage === e.page;
    (0, module.exports.useImageLoader)(g, e.id + "-video"), s && (s.width = s.videoWidth, s.height = s.videoHeight);
    const p = s || $a392811eb6e8bd8c$var$PLACEHOLDER_CANVAS;
    $a392811eb6e8bd8c$var$react_1.default.useEffect(()=>{
        s && t.history.ignore(()=>{
            e.set({
                duration: 1e3 * s.duration
            });
        });
    }, [
        s
    ]), $a392811eb6e8bd8c$var$react_1.default.useEffect(()=>{
        var r;
        if (!s) return;
        const a = f && (t.isPlaying || h);
        if (!a) return void s.pause();
        a && (s.currentTime = e.startTime * s.duration, s.play());
        const i = new $a392811eb6e8bd8c$var$konva_1.default.Animation(()=>{}, null === (r = o.current) || void 0 === r ? void 0 : r.getLayer());
        i.start();
        const n = ()=>{
            u(!1), s.currentTime = e.startTime * s.duration;
        }, d = ()=>{
            s.currentTime >= e.endTime * s.duration && (s.pause(), s.currentTime = e.startTime * s.duration, u(!1));
        };
        return s.addEventListener("ended", n), s.addEventListener("timeupdate", d), ()=>{
            i.stop(), s.removeEventListener("ended", n), s.removeEventListener("timeupdate", d);
        };
    }, [
        s,
        h,
        t.isPlaying,
        f
    ]);
    const _ = $a392811eb6e8bd8c$var$react_1.default.useRef();
    $a392811eb6e8bd8c$var$react_1.default.useEffect(()=>(0, $2SBKn.autorun)(()=>{
            var r, a;
            if (s) {
                const i = (t.currentTime - e.page.startTime) % e.duration;
                (Math.abs(1e3 * s.currentTime - i) > 500 || !t.isPlaying) && (s.currentTime = i / 1e3, t.isPlaying || 0 === s.currentTime || (_.current = (0, $l4lre.incrementLoader)(`video ${e.id}`))), null === (a = null === (r = o.current) || void 0 === r ? void 0 : r.getLayer()) || void 0 === a || a.batchDraw();
            }
        }), [
        t,
        s
    ]), $a392811eb6e8bd8c$var$react_1.default.useEffect(()=>{
        if (!s) return;
        let t = null;
        const r = ()=>{
            var r, a;
            _.current && (null === (a = null === (r = o.current) || void 0 === r ? void 0 : r.getLayer()) || void 0 === a || a.batchDraw(), _.current(), _.current = null), $a392811eb6e8bd8c$var$isBuffered(s, s.currentTime) || (t && console.error("finish already exists"), t = (0, $l4lre.incrementLoader)(`video ${e.id}`));
        }, a = ()=>{
            t && (t(), t = null);
        };
        return s.addEventListener("timeupdate", r), s.addEventListener("canplay", a), ()=>{
            s.removeEventListener("timeupdate", r), s.removeEventListener("canplay", a);
        };
    }, [
        s,
        e.id,
        $l4lre.incrementLoader
    ]);
    let { cropX: m, cropY: w, cropWidth: v, cropHeight: x } = e;
    "loaded" !== g && (m = w = 0, v = x = 1);
    const y = p.width * v, M = p.height * x, E = e.width / e.height;
    let b, L;
    const C = y / M, k = "svg" === e.type;
    k ? (b = y, L = M) : E >= C ? (b = y, L = y / E) : (b = M * E, L = M);
    const I = {
        x: p.width * m,
        y: p.height * w,
        width: b,
        height: L
    }, S = null !== (r = e.cornerRadius) && void 0 !== r ? r : 0;
    let R = $a392811eb6e8bd8c$var$useClip(e, $a392811eb6e8bd8c$var$useCornerRadiusAndCrop(e, p, I, t._elementsPixelRatio, S, a || e._cropModeEnabled || "svg" === e.type), t._elementsPixelRatio, [
        I,
        S,
        t._elementsPixelRatio
    ]);
    const T = Math.max(e.width / b, e.height / L);
    $a392811eb6e8bd8c$var$react_1.default.useEffect(()=>{
        var t;
        if (!e._cropModeEnabled) return;
        const r = null === (t = o.current) || void 0 === t ? void 0 : t.getStage();
        function a(t) {
            e._cropModeEnabled && t.target !== n.current && e.toggleCropMode(!1);
        }
        function i(t) {
            e._cropModeEnabled && t.target.parentNode !== r.content && e.toggleCropMode(!1);
        }
        return document.body.addEventListener("click", i), null == r || r.on("click", a), null == r || r.on("tap", a), ()=>{
            document.body.removeEventListener("click", i), document.body.removeEventListener("touchstart", i), null == r || r.off("click", a), null == r || r.off("click", a);
        };
    }, [
        e._cropModeEnabled
    ]), $a392811eb6e8bd8c$var$react_1.default.useLayoutEffect(()=>{
        if (a || e._cropModeEnabled) return;
        (0, $aWsdH.applyFilter)(o.current, e);
        return (0, $2SBKn.autorun)(()=>{
            (0, $aWsdH.applyFilter)(o.current, e);
        }, {
            delay: 100
        });
    }, [
        p,
        a,
        v,
        x,
        e._cropModeEnabled
    ]), $a392811eb6e8bd8c$var$react_1.default.useLayoutEffect(()=>{
        var t;
        a || e._cropModeEnabled ? null === (t = o.current) || void 0 === t || t.clearCache() : (0, $aWsdH.applyFilter)(o.current, e);
    }, [
        a,
        e.width,
        e.height,
        e._cropModeEnabled
    ]), $a392811eb6e8bd8c$var$react_1.default.useEffect(()=>{
        (0, $aWsdH.applyFilter)(o.current, e);
    }, [
        e.shadowEnabled,
        e.shadowBlur,
        e.cornerRadius,
        e.shadowColor,
        e.shadowOffsetX,
        e.shadowOffsetY,
        e.shadowOpacity
    ]);
    const P = $a392811eb6e8bd8c$var$react_1.default.useRef(null), O = $a392811eb6e8bd8c$var$react_1.default.useRef(null), X = $a392811eb6e8bd8c$var$react_1.default.useRef(null);
    $a392811eb6e8bd8c$var$react_1.default.useLayoutEffect(()=>{
        e._cropModeEnabled && (O.current.nodes([
            P.current
        ]), X.current.nodes([
            n.current
        ]));
    }, [
        e._cropModeEnabled
    ]);
    const Y = (t)=>{
        Math.round(t.target.x()) > 0 && (t.target.x(0), t.target.scaleX(1)), Math.round(t.target.y()) > 0 && (t.target.y(0), t.target.scaleY(1));
        const r = t.target.width() * t.target.scaleX(), a = t.target.height() * t.target.scaleY(), i = Math.min(1, b / r), o = Math.min(1, L / a), n = 1 - i, d = Math.min(n, Math.max(0, Math.round(-t.target.x()) / r)), c = 1 - o, l = Math.min(c, Math.max(0, Math.round(-t.target.y()) / a));
        t.target.setAttrs({
            x: -d * p.width,
            y: -l * p.height,
            scaleX: 1,
            scaleY: 1
        }), e.set({
            cropX: d,
            cropY: l,
            cropWidth: i,
            cropHeight: o
        });
    }, A = ()=>{
        "svg" !== e.type && e.contentEditable && setTimeout(()=>{
            e.toggleCropMode(!0);
        });
    }, H = "loading" === g, D = "failed" === g, W = !H && !D, q = $a392811eb6e8bd8c$var$react_1.default.useRef({
        cropX: 0,
        cropY: 0,
        cropWidth: 0,
        cropHeight: 0
    }), B = W ? e.a.opacity : 0;
    (0, $9uXpD.useFadeIn)(o, B);
    const F = e.selectable || "admin" === t.role, z = (0, $3pcZ0.useMobile)();
    return $a392811eb6e8bd8c$var$react_1.default.createElement($a392811eb6e8bd8c$var$react_1.default.Fragment, null, H && $a392811eb6e8bd8c$var$react_1.default.createElement($a392811eb6e8bd8c$var$LoadingPlaceholder, {
        element: e
    }), D && $a392811eb6e8bd8c$var$react_1.default.createElement($a392811eb6e8bd8c$var$ErrorPlaceholder, {
        element: e
    }), $a392811eb6e8bd8c$var$react_1.default.createElement($fBZlQ.Image, {
        ref: o,
        name: "element",
        id: e.id,
        image: p,
        x: e.x,
        y: e.y,
        width: e.width || 1,
        height: e.height || 1,
        rotation: e.rotation,
        opacity: B,
        shadowEnabled: e.shadowEnabled,
        shadowBlur: e.shadowBlur,
        shadowOffsetX: e.shadowOffsetX,
        shadowOffsetY: e.shadowOffsetY,
        shadowColor: e.shadowColor,
        shadowOpacity: e.shadowOpacity,
        customCrop: I,
        listening: F,
        cropX: I.x,
        cropY: I.y,
        cropWidth: I.width,
        cropHeight: I.height,
        draggable: z ? e.draggable && l : e.draggable,
        preventDefault: !z || l,
        hideInExport: !e.showInExport,
        onMouseEnter: ()=>{
            c(!0);
        },
        onMouseLeave: ()=>{
            c(!1);
        },
        onDragMove: (t)=>{
            e.set({
                x: t.target.x(),
                y: t.target.y()
            });
        },
        onDragEnd: (t)=>{
            e.set({
                x: t.target.x(),
                y: t.target.y()
            });
        },
        onDblClick: A,
        onDblTap: A,
        onTransformStart: ()=>{
            i(!0), q.current = {
                cropX: e.cropX,
                cropY: e.cropY,
                cropWidth: e.cropWidth,
                cropHeight: e.cropHeight
            };
        },
        onTransform: (t)=>{
            var r;
            const a = t.currentTarget, i = Math.abs(a.scaleX() - 1) < 1e-7 ? 1 : a.scaleX(), o = Math.abs(a.scaleY() - 1) < 1e-7 ? 1 : a.scaleY();
            a.scaleX(1), a.scaleY(1);
            const n = null === (r = t.target.getStage()) || void 0 === r ? void 0 : r.findOne("Transformer"), d = 1 - b / p.width, c = Math.min(d, Math.max(0, e.cropX)), l = 1 - L / p.height, h = Math.min(l, Math.max(0, e.cropY)), u = n.getActiveAnchor(), s = !(u.indexOf("middle") >= 0 || u.indexOf("center") >= 0), g = !s && i < 1 && q.current.cropHeight > L / p.height;
            let f = s ? e.cropWidth : e.cropWidth * i;
            g && (f = e.cropWidth);
            const _ = !s && o < 1 && q.current.cropWidth > b / p.width;
            let m = s ? e.cropHeight : e.cropHeight * o;
            _ && (m = e.cropHeight), k && (f = e.cropWidth, m = e.cropHeight), e.set({
                cropX: c,
                cropY: h,
                x: a.x(),
                y: a.y(),
                width: a.width() * i,
                height: a.height() * o,
                rotation: t.target.rotation(),
                cropWidth: Math.min(f, 1 - c),
                cropHeight: Math.min(m, 1 - h)
            });
        },
        onTransformEnd: (t)=>{
            const r = t.currentTarget;
            e.set({
                width: r.width(),
                height: r.height(),
                x: r.x(),
                y: r.y(),
                rotation: t.target.rotation(),
                cropWidth: b / p.width,
                cropHeight: L / p.height
            }), i(!1);
        }
    }), $a392811eb6e8bd8c$var$react_1.default.createElement($fBZlQ.Rect, {
        x: e.x,
        y: e.y,
        width: Math.max(e.width - e.borderSize, 0),
        height: Math.max(e.height - e.borderSize, 0),
        opacity: B,
        offsetX: -e.borderSize / 2,
        offsetY: -e.borderSize / 2,
        stroke: e.borderColor,
        strokeWidth: e.borderSize,
        listening: !1,
        visible: !!e.borderSize,
        rotation: e.rotation,
        cornerRadius: Math.max(0, S - e.borderSize),
        hideInExport: !e.showInExport
    }), !h && !t.isPlaying && $a392811eb6e8bd8c$var$react_1.default.createElement($fBZlQ.Image, {
        image: $a392811eb6e8bd8c$var$playIcon,
        x: e.x + e.width / 2 - 15 / t.scale,
        y: e.y + e.height / 2 - 15 / t.scale,
        width: 30 / t.scale,
        height: 30 / t.scale,
        hideInExport: !0,
        onClick: ()=>{
            u(!0);
        }
    }), h && !t.isPlaying && $a392811eb6e8bd8c$var$react_1.default.createElement($fBZlQ.Image, {
        image: $a392811eb6e8bd8c$var$pauseIcon,
        x: e.x + e.width / 2 - 15 / t.scale,
        y: e.y + e.height / 2 - 15 / t.scale,
        width: 30 / t.scale,
        height: 30 / t.scale,
        hideInExport: !0,
        onClick: ()=>{
            u(!1);
        }
    }), e._cropModeEnabled && $a392811eb6e8bd8c$var$react_1.default.createElement($eQWOP.Portal, {
        selector: ".page-abs-container",
        enabled: !0
    }, $a392811eb6e8bd8c$var$react_1.default.createElement($fBZlQ.Rect, {
        x: -window.innerWidth / t.scale,
        y: -window.innerWidth / t.scale,
        width: window.innerWidth / t.scale * 3,
        height: window.innerWidth / t.scale * 3,
        fill: "rgba(0,0,0,0.3)"
    }), $a392811eb6e8bd8c$var$react_1.default.createElement($fBZlQ.Image, {
        listening: !1,
        image: R,
        x: e.x,
        y: e.y,
        width: e.width,
        height: e.height,
        rotation: e.rotation,
        shadowEnabled: e.shadowEnabled,
        shadowBlur: e.shadowBlur
    }), $a392811eb6e8bd8c$var$react_1.default.createElement($fBZlQ.Group, {
        x: e.x,
        y: e.y,
        rotation: e.rotation,
        scaleX: T,
        scaleY: T
    }, $a392811eb6e8bd8c$var$react_1.default.createElement($fBZlQ.Image, {
        image: p,
        ref: n,
        opacity: .4,
        draggable: !0,
        x: -e.cropX * p.width,
        y: -e.cropY * p.height,
        onDragMove: Y,
        onTransform: Y
    }), $a392811eb6e8bd8c$var$react_1.default.createElement($fBZlQ.Transformer, {
        ref: X,
        anchorSize: 20,
        enabledAnchors: [
            "top-left",
            "top-right",
            "bottom-left",
            "bottom-right"
        ],
        boundBoxFunc: (e, t)=>t.width < 5 || t.height < 5 ? e : t,
        rotateEnabled: !1,
        borderEnabled: !1,
        anchorCornerRadius: 10,
        anchorStrokeWidth: 2,
        borderStrokeWidth: 2
    }), $a392811eb6e8bd8c$var$react_1.default.createElement($fBZlQ.Rect, {
        width: b,
        height: L,
        ref: P,
        listening: !1,
        onTransform: (t)=>{
            t.target.x() < -e.cropX * p.width - 1e-9 && (t.target.x(-e.cropX * p.width), t.target.scaleX(1)), t.target.y() < -e.cropY * p.height - 1e-9 && (t.target.y(-e.cropY * p.height), t.target.scaleY(1));
            const r = Math.min(1, Math.max(0, e.cropX + t.target.x() / p.width)), a = Math.min(1, Math.max(0, t.target.y() / p.height + e.cropY)), i = t.target.width() * t.target.scaleX(), o = t.target.height() * t.target.scaleY(), n = Math.min(1 - r, i / p.width), d = Math.min(1 - a, o / p.height), c = t.target.getAbsolutePosition(t.target.getParent().getParent());
            t.target.scale({
                x: 1,
                y: 1
            }), t.target.position({
                x: 0,
                y: 0
            }), e.set({
                x: c.x,
                y: c.y,
                cropX: r,
                cropY: a,
                cropWidth: n,
                cropHeight: d,
                width: Math.min(i * T, p.width * (1 - r) * T),
                height: Math.min(o * T, p.height * (1 - a) * T)
            });
        }
    }), $a392811eb6e8bd8c$var$react_1.default.createElement($fBZlQ.Transformer, {
        ref: O,
        enabledAnchors: [
            "top-left",
            "top-right",
            "bottom-left",
            "bottom-right"
        ],
        boundBoxFunc: (e, t)=>t.width < 5 || t.height < 5 ? e : t,
        keepRatio: !1,
        rotateEnabled: !1,
        anchorFill: "rgb(240, 240, 240)",
        anchorStrokeWidth: 2,
        borderStrokeWidth: 2
    }))), (d || l) && $a392811eb6e8bd8c$var$react_1.default.createElement($4WWR6.Highlighter, {
        element: e
    }));
});

});

parcelRegister("50iP9", function(module, exports) {
"use strict";
var $3a4b8deb9f44d2c4$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.FigureElement = void 0;

const $3a4b8deb9f44d2c4$var$react_1 = $3a4b8deb9f44d2c4$var$__importDefault((parcelRequire("8NFma")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");
parcelRequire("k3LwQ");
var $fBZlQ = parcelRequire("fBZlQ");

var $jkJqh = parcelRequire("jkJqh");

var $4WWR6 = parcelRequire("4WWR6");

var $3pcZ0 = parcelRequire("3pcZ0");

var $kWHDJ = parcelRequire("kWHDJ");
const $3a4b8deb9f44d2c4$var$createComponent = (e)=>(0, $O1ETn.observer)(({ element: t1, fillProps: a, strokeProps: r })=>{
        let s = e({
            width: t1.a.width,
            height: t1.a.height,
            cornerRadius: t1.cornerRadius
        }), c = 1, o = 1;
        "string" != typeof s && (c = s.scaleX, o = s.scaleY, s = s.path);
        const l = $3a4b8deb9f44d2c4$var$react_1.default.useRef(null);
        return $3a4b8deb9f44d2c4$var$react_1.default.createElement($3a4b8deb9f44d2c4$var$react_1.default.Fragment, null, $3a4b8deb9f44d2c4$var$react_1.default.createElement($fBZlQ.Rect, {
            width: t1.width,
            height: t1.height,
            fill: "transparent"
        }), $3a4b8deb9f44d2c4$var$react_1.default.createElement($fBZlQ.Path, Object.assign({}, a, {
            ref: l,
            data: s,
            scaleX: c,
            scaleY: o
        })), $3a4b8deb9f44d2c4$var$react_1.default.createElement($fBZlQ.Group, {
            clipFunc: (e)=>{
                const t1 = l.current;
                if (t1) {
                    var a = t1.dataArray;
                    e.beginPath();
                    for(var r = 0; r < a.length; r++){
                        var s = a[r].command, c = a[r].points;
                        switch(s){
                            case "L":
                                e.lineTo(c[0], c[1]);
                                break;
                            case "M":
                                e.moveTo(c[0], c[1]);
                                break;
                            case "C":
                                e.bezierCurveTo(c[0], c[1], c[2], c[3], c[4], c[5]);
                                break;
                            case "Q":
                                e.quadraticCurveTo(c[0], c[1], c[2], c[3]);
                                break;
                            case "A":
                                var o = c[0], i = c[1], n = c[2], h = c[3], d = c[4], u = c[5], _ = c[6], g = c[7], f = n > h ? n : h, m = n > h ? 1 : n / h, p = n > h ? h / n : 1;
                                e.translate(o, i), e.rotate(_), e.scale(m, p), e.arc(0, 0, f, d, d + u, 1 - g), e.scale(1 / m, 1 / p), e.rotate(-_), e.translate(-o, -i);
                                break;
                            case "z":
                                e.closePath();
                        }
                    }
                }
            },
            scaleX: c,
            scaleY: o
        }, $3a4b8deb9f44d2c4$var$react_1.default.createElement($fBZlQ.Path, Object.assign({}, r, {
            x: 0,
            y: 0,
            data: s,
            strokeWidth: 2 * r.strokeWidth,
            dash: r.dash.map((e)=>e)
        }))));
    }), $3a4b8deb9f44d2c4$var$COMPONENTS_CACHE = {}, $3a4b8deb9f44d2c4$var$getComponent = (e)=>{
    var f;
    return $3a4b8deb9f44d2c4$var$COMPONENTS_CACHE[e] || ($3a4b8deb9f44d2c4$var$COMPONENTS_CACHE[e] = (t = (0, $jkJqh.subTypeToPathDataFunc)(e), (0, $O1ETn.observer)(({ element: e, fillProps: a, strokeProps: r })=>{
        let s = t({
            width: e.a.width,
            height: e.a.height,
            cornerRadius: e.cornerRadius
        }), c = 1, o = 1;
        "string" != typeof s && (c = s.scaleX, o = s.scaleY, s = s.path);
        const l = $3a4b8deb9f44d2c4$var$react_1.default.useRef(null);
        return $3a4b8deb9f44d2c4$var$react_1.default.createElement($3a4b8deb9f44d2c4$var$react_1.default.Fragment, null, $3a4b8deb9f44d2c4$var$react_1.default.createElement($fBZlQ.Rect, {
            width: e.width,
            height: e.height,
            fill: "transparent"
        }), $3a4b8deb9f44d2c4$var$react_1.default.createElement($fBZlQ.Path, Object.assign({}, a, {
            ref: l,
            data: s,
            scaleX: c,
            scaleY: o
        })), $3a4b8deb9f44d2c4$var$react_1.default.createElement($fBZlQ.Group, {
            clipFunc: (e)=>{
                const t1 = l.current;
                if (t1) {
                    var a = t1.dataArray;
                    e.beginPath();
                    for(var r = 0; r < a.length; r++){
                        var s = a[r].command, c = a[r].points;
                        switch(s){
                            case "L":
                                e.lineTo(c[0], c[1]);
                                break;
                            case "M":
                                e.moveTo(c[0], c[1]);
                                break;
                            case "C":
                                e.bezierCurveTo(c[0], c[1], c[2], c[3], c[4], c[5]);
                                break;
                            case "Q":
                                e.quadraticCurveTo(c[0], c[1], c[2], c[3]);
                                break;
                            case "A":
                                var o = c[0], i = c[1], n = c[2], h = c[3], d = c[4], u = c[5], _ = c[6], g = c[7], f = n > h ? n : h, m = n > h ? 1 : n / h, p = n > h ? h / n : 1;
                                e.translate(o, i), e.rotate(_), e.scale(m, p), e.arc(0, 0, f, d, d + u, 1 - g), e.scale(1 / m, 1 / p), e.rotate(-_), e.translate(-o, -i);
                                break;
                            case "z":
                                e.closePath();
                        }
                    }
                }
            },
            scaleX: c,
            scaleY: o
        }, $3a4b8deb9f44d2c4$var$react_1.default.createElement($fBZlQ.Path, Object.assign({}, r, {
            x: 0,
            y: 0,
            data: s,
            strokeWidth: 2 * r.strokeWidth,
            dash: r.dash.map((e)=>e)
        }))));
    }))), $3a4b8deb9f44d2c4$var$COMPONENTS_CACHE[e];
};
module.exports.FigureElement = (0, $O1ETn.observer)(({ element: e, store: t1 })=>{
    const a = e.selectable || "admin" === t1.role, r = (0, $3pcZ0.useMobile)(), [s, c] = $3a4b8deb9f44d2c4$var$react_1.default.useState(!1), o = t1.selectedElements.indexOf(e) >= 0 && 1 === t1.selectedElements.length, l = Math.min(e.strokeWidth, e.width / 2, e.height / 2), i = Math.max(0, Math.min(e.width / 2, e.height / 2, e.cornerRadius)), n = (0, $kWHDJ.useColor)(e, e.a.fill, "fill"), h = Object.assign(Object.assign({
        width: e.a.width,
        height: e.a.height
    }, n), {
        cornerRadius: i,
        opacity: e.animated("opacity"),
        shadowEnabled: e.shadowEnabled,
        shadowBlur: e.shadowBlur,
        shadowOffsetX: e.shadowOffsetX,
        shadowOffsetY: e.shadowOffsetY,
        shadowColor: e.shadowColor,
        shadowOpacity: e.shadowOpacity,
        listening: a,
        preventDefault: !r || o,
        hideInExport: !e.showInExport
    }), d = (0, $kWHDJ.useColor)(e, e.stroke, "stroke"), u = Object.assign(Object.assign({
        visible: l > 0,
        x: l / 2,
        y: l / 2,
        width: e.a.width - l,
        height: e.a.height - l
    }, d), {
        strokeWidth: l,
        cornerRadius: Math.max(0, i - l),
        dash: e.dash.map((e)=>e * l),
        opacity: e.animated("opacity"),
        hideInExport: !e.showInExport,
        listening: !1
    }), _ = (g = e.subType, $3a4b8deb9f44d2c4$var$COMPONENTS_CACHE[g] || ($3a4b8deb9f44d2c4$var$COMPONENTS_CACHE[g] = (f = (0, $jkJqh.subTypeToPathDataFunc)(g), (0, $O1ETn.observer)(({ element: e, fillProps: t1, strokeProps: a })=>{
        let r = f({
            width: e.a.width,
            height: e.a.height,
            cornerRadius: e.cornerRadius
        }), s = 1, c = 1;
        "string" != typeof r && (s = r.scaleX, c = r.scaleY, r = r.path);
        const o = $3a4b8deb9f44d2c4$var$react_1.default.useRef(null);
        return $3a4b8deb9f44d2c4$var$react_1.default.createElement($3a4b8deb9f44d2c4$var$react_1.default.Fragment, null, $3a4b8deb9f44d2c4$var$react_1.default.createElement($fBZlQ.Rect, {
            width: e.width,
            height: e.height,
            fill: "transparent"
        }), $3a4b8deb9f44d2c4$var$react_1.default.createElement($fBZlQ.Path, Object.assign({}, t1, {
            ref: o,
            data: r,
            scaleX: s,
            scaleY: c
        })), $3a4b8deb9f44d2c4$var$react_1.default.createElement($fBZlQ.Group, {
            clipFunc: (e)=>{
                const t1 = o.current;
                if (t1) {
                    var a = t1.dataArray;
                    e.beginPath();
                    for(var r = 0; r < a.length; r++){
                        var s = a[r].command, c = a[r].points;
                        switch(s){
                            case "L":
                                e.lineTo(c[0], c[1]);
                                break;
                            case "M":
                                e.moveTo(c[0], c[1]);
                                break;
                            case "C":
                                e.bezierCurveTo(c[0], c[1], c[2], c[3], c[4], c[5]);
                                break;
                            case "Q":
                                e.quadraticCurveTo(c[0], c[1], c[2], c[3]);
                                break;
                            case "A":
                                var l = c[0], i = c[1], n = c[2], h = c[3], d = c[4], u = c[5], _ = c[6], g = c[7], f = n > h ? n : h, m = n > h ? 1 : n / h, p = n > h ? h / n : 1;
                                e.translate(l, i), e.rotate(_), e.scale(m, p), e.arc(0, 0, f, d, d + u, 1 - g), e.scale(1 / m, 1 / p), e.rotate(-_), e.translate(-l, -i);
                                break;
                            case "z":
                                e.closePath();
                        }
                    }
                }
            },
            scaleX: s,
            scaleY: c
        }, $3a4b8deb9f44d2c4$var$react_1.default.createElement($fBZlQ.Path, Object.assign({}, a, {
            x: 0,
            y: 0,
            data: r,
            strokeWidth: 2 * a.strokeWidth,
            dash: a.dash.map((e)=>e)
        }))));
    }))), $3a4b8deb9f44d2c4$var$COMPONENTS_CACHE[g] || $fBZlQ.Group);
    var g, f;
    return $3a4b8deb9f44d2c4$var$react_1.default.createElement($3a4b8deb9f44d2c4$var$react_1.default.Fragment, null, $3a4b8deb9f44d2c4$var$react_1.default.createElement($fBZlQ.Group, {
        id: e.id,
        x: e.a.x,
        y: e.a.y,
        rotation: e.a.rotation,
        opacity: e.a.opacity,
        draggable: r ? e.draggable && o : e.draggable,
        name: "element",
        onMouseEnter: ()=>{
            c(!0);
        },
        onMouseLeave: ()=>{
            c(!1);
        },
        onDragMove: (t1)=>{
            e.set({
                x: t1.target.x(),
                y: t1.target.y()
            });
        },
        onDragEnd: (t1)=>{
            e.set({
                x: t1.target.x(),
                y: t1.target.y()
            });
        },
        onTransform: (t1)=>{
            const a = t1.target.scale();
            t1.target.scaleX(1), t1.target.scaleY(1), e.set({
                width: e.width * a.x,
                height: e.height * a.y,
                x: t1.target.x(),
                y: t1.target.y(),
                rotation: t1.target.rotation()
            });
        }
    }, $3a4b8deb9f44d2c4$var$react_1.default.createElement(_, {
        element: e,
        fillProps: h,
        strokeProps: u
    })), s && !o && $3a4b8deb9f44d2c4$var$react_1.default.createElement($4WWR6.Highlighter, {
        element: e
    }));
});

});
parcelRegister("jkJqh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.figureToSvg = module.exports.subTypeToPathDataFunc = module.exports.TYPES = module.exports.crossPath = module.exports.speechBubblePath = module.exports.hexagonPath = module.exports.pentagonPath = module.exports.diamondPath = module.exports.starPath = module.exports.circleData = module.exports.rightTriangleData = module.exports.triangleData = module.exports.rectData = void 0;
const $e1331ea2709a183e$var$rectData = ({ width: t, height: h, cornerRadius: e })=>{
    if (e > 0) {
        const i = Math.min(e, t / 2, h / 2);
        return `M 0 ${i} A ${i} ${i} 0 0 1 ${i} 0 L ${t - i} 0 A ${i} ${i} 0 0 1 ${t} ${i} L ${t} ${h - i} A ${i} ${i} 0 0 1 ${t - i} ${h} L ${i} ${h} A ${i} ${i} 0 0 1 0 ${h - i} Z`;
    }
    return `M 0 0 L ${t} 0 L ${t} ${h} L 0 ${h} Z`;
};
module.exports.rectData = $e1331ea2709a183e$var$rectData;
const $e1331ea2709a183e$var$triangleData = ({ width: t, height: h })=>`M ${t / 2} 0 L ${t} ${h} L 0 ${h} Z`;
module.exports.triangleData = $e1331ea2709a183e$var$triangleData;
const $e1331ea2709a183e$var$rightTriangleData = ({ width: t, height: h })=>`M 0 0 L ${t} 0 L 0 ${h} Z`;
module.exports.rightTriangleData = $e1331ea2709a183e$var$rightTriangleData;
const $e1331ea2709a183e$var$circleData = ({ width: t, height: h })=>`M ${t / 2} ${h / 2} m -${t / 2}, 0 a ${t / 2},${h / 2} 0 1,0 ${t},0 a ${t / 2},${h / 2} 0 1,0 -${t},0`;
function $e1331ea2709a183e$var$starPath({ width: t, height: h }) {
    const e = t / 2, i = h / 2, a = t / 2, C = h / 2, g = a / 2, d = C / 2;
    let o = "", w = Math.PI / 5;
    for(let t = 0; t < 10; t++){
        const h = t % 2 == 0 ? C : d, c = e + (t % 2 == 0 ? a : g) * Math.sin(t * w), p = i - h * Math.cos(t * w);
        0 === t ? o = `M ${c} ${p}` : o += ` L ${c} ${p}`;
    }
    return o + " Z";
}
function $e1331ea2709a183e$var$diamondPath({ width: t, height: h }) {
    const e = t / 2, i = h / 2;
    return `M ${e} 0 L ${t} ${i} L ${e} ${h} L 0 ${i} Z`;
}
function $e1331ea2709a183e$var$pentagonPath({ width: t, height: h }) {
    const e = t / 2, i = h / 2, a = t / 2, C = h / 2;
    let g = "", d = 2 * Math.PI / 5;
    for(let t = 0; t < 5; t++){
        const h = C, o = e + a * Math.sin(t * d), w = i - h * Math.cos(t * d);
        0 === t ? g = `M ${o} ${w}` : g += ` L ${o} ${w}`;
    }
    return g + " Z";
}
function $e1331ea2709a183e$var$hexagonPath({ width: t, height: h }) {
    const e = t / 2, i = h / 2, a = t / 2, C = h / 2;
    let g = "", d = 2 * Math.PI / 6;
    for(let t = 0; t < 6; t++){
        const h = C, o = e + a * Math.sin(t * d), w = i - h * Math.cos(t * d);
        0 === t ? g = `M ${o} ${w}` : g += ` L ${o} ${w}`;
    }
    return g + " Z";
}
function $e1331ea2709a183e$var$getScaledPath({ path: t, aspectRatio: h, width: e, height: i }) {
    return {
        path: t,
        scaleX: e / h.width,
        scaleY: i / h.height
    };
}
function $e1331ea2709a183e$var$speechBubblePath({ width: t, height: h }) {
    const e = .1 * Math.min(t, h), i = .2 * t, a = .2 * h, C = .5 * t;
    let g = `M ${e},0`;
    return g += " H " + (t - e), g += ` A ${e},${e} 0 0 1 ${t},${e}`, g += " V " + (h - e - a), g += ` A ${e},${e} 0 0 1 ${t - e},${h - a}`, g += ` H ${C + i / 2}`, g += ` L ${C},${h}`, g += ` L ${C - i / 2},${h - a}`, g += ` H ${e}`, g += ` A ${e},${e} 0 0 1 0,${h - e - a}`, g += ` V ${e}`, g += ` A ${e},${e} 0 0 1 ${e},0`, g += " Z", g;
}
function $e1331ea2709a183e$var$crossPath({ width: t, height: h }) {
    const e = .3 * t, i = .3 * h, a = t / 2, C = h / 2, g = a - e / 2, d = a + e / 2, o = C - i / 2, w = C + i / 2;
    let c = `M ${g},0 `;
    return c += `H ${d} `, c += `V ${o} `, c += `H ${t} `, c += `V ${w} `, c += `H ${d} `, c += `V ${h} `, c += `H ${g} `, c += `V ${w} `, c += "H 0 ", c += `V ${o} `, c += `H ${g} `, c += "V 0 ", c += "Z", c;
}
function $e1331ea2709a183e$var$subTypeToPathDataFunc(t) {
    return module.exports.TYPES[t] || module.exports.rectData;
}
function $e1331ea2709a183e$var$createSvgFromPath(t, h) {
    const { width: e, height: i, fill: a, stroke: C, strokeWidth: g, dash: d } = t, o = (d || []).map((t)=>t * g);
    let w = h(t), c = 1, p = 1;
    "string" != typeof w && (c = w.scaleX, p = w.scaleY, w = w.path);
    const s = `clip-${Math.random()}`;
    return `\n    <svg xmlns="http://www.w3.org/2000/svg" width="${e}" height="${i}">\n    <defs>\n    <clipPath id="${s}">\n      <path d="${w}" />\n    </clipPath>\n  </defs>\n\n  \x3c!-- Path for the fill --\x3e\n  <path d="${w}" fill="${a}" transform="scale(${c}, ${p})"/>\n\n  \x3c!-- Path for the stroke, clipped by the star path --\x3e\n  <path d="${w}" fill="none" stroke="${C}" stroke-width="${2 * g}" clip-path="url(#${s})" transform="scale(${c}, ${p})" stroke-dasharray="${o.join(" ")}"/>\n    </svg>\n  `;
}
function $e1331ea2709a183e$var$figureToSvg(t) {
    const { subType: h } = t, e = $e1331ea2709a183e$var$subTypeToPathDataFunc(h);
    return e ? $e1331ea2709a183e$var$createSvgFromPath(t, e) : (console.error(`Polotno error: Can not convert ${t.subType} figure to svg.`), (0, module.exports.rectData)(t));
}
module.exports.circleData = $e1331ea2709a183e$var$circleData, module.exports.starPath = $e1331ea2709a183e$var$starPath, module.exports.diamondPath = $e1331ea2709a183e$var$diamondPath, module.exports.pentagonPath = $e1331ea2709a183e$var$pentagonPath, module.exports.hexagonPath = $e1331ea2709a183e$var$hexagonPath, module.exports.speechBubblePath = $e1331ea2709a183e$var$speechBubblePath, module.exports.crossPath = $e1331ea2709a183e$var$crossPath, module.exports.TYPES = {
    rect: module.exports.rectData,
    circle: module.exports.circleData,
    star: $e1331ea2709a183e$var$starPath,
    triangle: module.exports.triangleData,
    rightTriangle: module.exports.rightTriangleData,
    diamond: $e1331ea2709a183e$var$diamondPath,
    pentagon: $e1331ea2709a183e$var$pentagonPath,
    hexagon: $e1331ea2709a183e$var$hexagonPath,
    speechBubble: $e1331ea2709a183e$var$speechBubblePath,
    cross: $e1331ea2709a183e$var$crossPath,
    arc: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M234 117C234 85.97 221.673 56.21 199.731 34.269C177.79 12.327 148.03 0 117 0C85.97 0 56.2103 12.327 34.2685 34.268C12.3268 56.21 0 85.97 0 117H117H234Z",
            aspectRatio: {
                width: 234,
                height: 117
            },
            width: t,
            height: h
        }),
    cloud: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M216.41 57.006C216.961 54.084 217.249 51.069 217.249 47.986C217.249 21.4841 195.972 0 169.725 0C153.666 0 139.467 8.043 130.865 20.3575C122.606 13.3566 111.954 9.1402 100.327 9.1402C74.3322 9.1402 53.2123 30.2136 52.8094 56.364H52.8035C23.6407 56.364 0 80.235 0 109.682C0 139.129 23.6407 163 52.8035 163H208.197C237.359 163 261 139.129 261 109.682C261 83.056 241.672 60.99 216.41 57.006Z",
            aspectRatio: {
                width: 261,
                height: 163
            },
            width: t,
            height: h
        }),
    rightArrow: ({ width: t, height: h })=>{
        const e = .6 * t;
        return `M 0 ${h / 4} L ${e} ${h / 4} L ${e} 0 L ${t} ${h / 2} L ${e} ${h} L ${e} ${.75 * h} L 0 ${.75 * h} Z`;
    },
    leftArrow: ({ width: t, height: h })=>{
        const e = .4 * t;
        return `M ${t} ${h / 4} L ${e} ${h / 4} L ${e} 0 L 0 ${h / 2} L ${e} ${h} L ${e} ${.75 * h} L ${t} ${.75 * h} Z`;
    },
    downArrow: ({ width: t, height: h })=>{
        const e = .6 * h;
        return `M ${t / 4} 0 L ${t / 4} ${e} L 0 ${e} L ${t / 2} ${h} L ${t} ${e} L ${.75 * t} ${e} L ${.75 * t} 0 Z`;
    },
    upArrow: ({ width: t, height: h })=>{
        const e = .4 * h;
        return `M ${t / 4} ${h} L ${t / 4} ${e} L 0 ${e} L ${t / 2} 0 L ${t} ${e} L ${.75 * t} ${e} L ${.75 * t} ${h} Z`;
    },
    asterisk1: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M45.5265 218.498C51.5466 222.87 58.5359 224.98 65.4742 224.98C75.916 224.98 86.221 220.2 92.853 211.217C92.872 211.198 92.89 211.178 92.907 211.157C92.923 211.136 92.939 211.115 92.954 211.094L92.977 211.061C92.993 211.039 93.008 211.017 93.023 210.996L116.491 178.725L139.959 210.996C139.982 211.031 140.006 211.058 140.029 211.088C140.04 211.102 140.05 211.116 140.061 211.132C151.115 226.188 172.355 229.505 187.473 218.515C202.608 207.526 205.992 186.278 195.074 171.104L195.05 171.066C195.03 171.034 195.014 171.01 194.989 170.985L171.572 138.696L209.512 126.346C227.334 120.545 237.129 101.305 231.33 83.476C225.532 65.648 206.315 55.8493 188.476 61.6334L150.537 73.933L150.52 34.0064C150.502 15.2594 135.248 0 116.508 0C97.768 0 82.514 15.2594 82.497 34.0234L82.463 73.916L44.5233 61.6163C44.5083 61.6163 44.49 61.613 44.4716 61.6078C44.4477 61.6014 44.4232 61.5918 44.4041 61.5823C26.5992 55.8664 7.45076 65.665 1.66886 83.46C-4.11314 101.254 5.61427 120.426 23.3511 126.278C23.3675 126.283 23.3822 126.289 23.3963 126.295L23.4588 126.319L23.4873 126.329L61.4098 138.679L37.9929 170.968C37.9844 170.985 37.9718 171.002 37.9591 171.019C37.9462 171.036 37.9336 171.053 37.9251 171.07C26.9903 186.244 30.3915 207.509 45.5265 218.498Z",
            aspectRatio: {
                width: 233,
                height: 225
            },
            width: t,
            height: h
        }),
    asterisk2: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M46.0556 112L0 85.388L33.9456 26.6121L80.028 53.1781L80.054 0H147.946L147.972 53.1781L194.054 26.6121L228 85.388L181.944 112L228 138.612L194.054 197.388L147.972 170.822L147.946 224H80.054L80.028 170.822L33.9456 197.388L0 138.612L46.0556 112Z",
            aspectRatio: {
                width: 228,
                height: 224
            },
            width: t,
            height: h
        }),
    bookmark: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M0 0H199V238L99.5 142.8L0 238V0Z",
            aspectRatio: {
                width: 199,
                height: 238
            },
            width: t,
            height: h
        }),
    butterfly: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M94.5 100.713C91.935 150.916 50.703 190.909 0 191.493V0C50.703 0.5845 91.935 40.5767 94.5 90.78C97.031 41.2385 137.217 1.6407 187 0.0438004V191.45C137.217 189.853 97.031 150.255 94.5 100.713Z",
            aspectRatio: {
                width: 187,
                height: 192
            },
            width: t,
            height: h
        }),
    cylinder: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M169 36.8497V218.15C169 238.502 131.168 255 84.5 255C37.832 255 0 238.502 0 218.15V36.8497C0 16.4982 37.832 0 84.5 0C131.168 0 169 16.4982 169 36.8497Z",
            aspectRatio: {
                width: 169,
                height: 255
            },
            width: t,
            height: h
        }),
    diamond2: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M0 55.5L124 185L248 55.5L189.307 0H58.6933L0 55.5Z",
            aspectRatio: {
                width: 248,
                height: 185
            },
            width: t,
            height: h
        }),
    door: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M140 69.697C140 31.2044 108.66 0 70 0C31.34 0 0 31.2044 0 69.697V207H140V69.697Z",
            aspectRatio: {
                width: 140,
                height: 207
            },
            width: t,
            height: h
        }),
    drop1: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M167 150.687C167 196.328 129.407 234 83.139 234C37.593 234 0 196.328 0 150.687C0 100.7 51.329 36.9474 83.139 0C114.948 39.1207 167 98.526 167 150.687Z",
            aspectRatio: {
                width: 167,
                height: 234
            },
            width: t,
            height: h
        }),
    drop2: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M73 239C53.64 239 35.071 231.315 21.3812 217.634C7.691 203.954 0 185.4 0 166.054C0 136.091 13.8696 113.633 30.768 86.27C43.912 64.9877 58.888 40.7377 70.597 7.6816C71.281 5.7496 72.989 0 72.989 0C72.989 0 72.993 0.0124998 73 0.0363998C73.007 0.0124998 73.011 0 73.011 0C73.011 0 74.719 5.7496 75.403 7.6816C87.112 40.7377 102.088 64.9877 115.232 86.27C132.13 113.633 146 136.091 146 166.054C146 185.4 138.309 203.954 124.619 217.634C111.025 231.218 92.225 239 73 239Z",
            aspectRatio: {
                width: 146,
                height: 239
            },
            width: t,
            height: h
        }),
    explosion: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M165.802 184.465L118.997 260L125.343 182.079L34.9058 219.45L99.164 159.817L0 163.792L78.538 134.373L0 74.7401L86.471 89.052V0L118.997 89.052L165.802 10.3364L149.143 97.798L217.368 29.419L165.802 112.905L245.927 81.101L165.802 143.914H261L165.802 184.465Z",
            aspectRatio: {
                width: 261,
                height: 260
            },
            width: t,
            height: h
        }),
    flag: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M0 142.161C0 142.161 51.9956 118.626 103 137.469C159.992 158.525 206 141.31 206 141.31V11.1373C206 11.1373 160 28.3218 103.016 7.28273C52 -11.553 0 12.0974 0 12.0974V142.161Z",
            aspectRatio: {
                width: 206,
                height: 148
            },
            width: t,
            height: h
        }),
    flower: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M135.351 66.1893C196.683 -5.00591 256.536 100.304 164.908 117.361C256.536 135.16 195.944 239.728 135.351 168.532C166.386 257.526 45.9394 256.785 76.975 168.532C15.643 239.728 -44.2109 135.16 47.4173 117.361C-44.9498 100.304 15.643 -4.26431 76.975 66.1893C45.2005 -22.0631 166.386 -22.0631 135.351 66.1893ZM105.793 104.012C113.183 104.012 119.833 109.945 119.833 117.361C119.833 124.777 113.183 131.452 105.793 131.452C98.404 131.452 92.492 124.777 92.492 117.361C92.492 109.945 98.404 104.012 105.793 104.012Z",
            aspectRatio: {
                width: 212,
                height: 235
            },
            width: t,
            height: h
        }),
    frame: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M0 0H240L200 88L240 176H0L40 88L0 0Z",
            aspectRatio: {
                width: 240,
                height: 176
            },
            width: t,
            height: h
        }),
    heart1: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M215.886 56.157C215.886 24.729 191.112 0 160.584 0C135.933 0 115.08 16.983 107.937 39.93C100.788 16.986 79.935 0.591 55.284 0.591C24.75 0.591 0 24.615 0 56.055C0 71.919 6.321 83.127 16.494 95.121L107.988 189.447L199.377 95.121C209.559 83.127 215.886 72.009 215.886 56.157Z",
            aspectRatio: {
                width: 216,
                height: 190
            },
            width: t,
            height: h
        }),
    home: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M0 62.143L95.5 0L191 62.143V195H0V62.143Z",
            aspectRatio: {
                width: 191,
                height: 195
            },
            width: t,
            height: h
        }),
    home2: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M206 94.076L103 0L0 94.076H31.2377V189H175.607V94.076H206Z",
            aspectRatio: {
                width: 206,
                height: 189
            },
            width: t,
            height: h
        }),
    hourglass: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M0.392782 0H187.607C193.014 43.3688 140.804 53.797 140.804 97.5C140.804 141.203 193.014 151.631 187.607 195H0.392782C-5.01452 151.631 47.196 141.203 47.196 97.5C47.196 53.797 -5.01452 43.3688 0.392782 0Z",
            aspectRatio: {
                width: 188,
                height: 195
            },
            width: t,
            height: h
        }),
    house: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M0 92.367L95 0L190 92.367V223H0V92.367Z",
            aspectRatio: {
                width: 190,
                height: 223
            },
            width: t,
            height: h
        }),
    keyhole: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M115 57.0494C115 25.5387 89.416 0 57.863 0C26.311 0 0.726898 25.5414 0.726898 57.0494C0.726898 78.652 12.759 97.451 30.505 107.136L0 219H114.845L84.448 107.524C102.608 97.962 115 78.959 115 57.0494Z",
            aspectRatio: {
                width: 115,
                height: 219
            },
            width: t,
            height: h
        }),
    kiss: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M124.5 17.1468C80.036 -36.5162 0 52.9218 0 52.9218C0 52.9218 44.4643 120 124.5 120C204.536 120 249 52.9218 249 52.9218C249 52.9218 168.964 -36.5162 124.5 17.1468Z",
            aspectRatio: {
                width: 249,
                height: 120
            },
            width: t,
            height: h
        }),
    leaf: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M204.414 0.0151567C204.414 0.0151567 206.837 93.9509 150.394 150.394C93.9507 206.837 0.0151569 204.413 0.0151569 204.413C0.0151569 204.413 -2.40835 110.478 54.0347 54.0349C110.478 -2.40834 204.414 0.0151567 204.414 0.0151567Z",
            aspectRatio: {
                width: 205,
                height: 205
            },
            width: t,
            height: h
        }),
    lightning1: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M111.5 0L0 142H51.433L31.5 253L143 111H91.567L111.5 0Z",
            aspectRatio: {
                width: 143,
                height: 253
            },
            width: t,
            height: h
        }),
    lightning2: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M126 0H43L0 120.531H36L6 227L110 80.354H73L126 0Z",
            aspectRatio: {
                width: 126,
                height: 227
            },
            width: t,
            height: h
        }),
    magnet: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M88.402 0H0V67.669H88.402C105.271 67.669 118.957 81.308 118.957 98C118.957 114.689 105.271 128.331 88.402 128.331H0V196H88.402C142.747 196 187 152.072 187 98C187 43.9279 142.747 0 88.402 0Z",
            aspectRatio: {
                width: 187,
                height: 196
            },
            width: t,
            height: h
        }),
    mithosis: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M150.996 136.45C137.141 128.926 117.559 128.7 103.532 135.896C93.843 140.867 82.875 143.67 71.2577 143.67C31.9033 143.67 0 111.508 0 71.835C0 32.161 31.9033 0 71.2577 0C83.467 0 94.959 3.0955 105.004 8.5504C118.859 16.0745 138.441 16.3 152.467 9.1038C162.157 4.1328 173.125 1.3303 184.742 1.3303C224.097 1.3303 256 33.492 256 73.165C256 112.839 224.097 145 184.742 145C172.533 145 161.041 141.905 150.996 136.45Z",
            aspectRatio: {
                width: 256,
                height: 145
            },
            width: t,
            height: h
        }),
    orangeRicky: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M69 0H0V69V138V207H69H138V138H69V69V0Z",
            aspectRatio: {
                width: 138,
                height: 207
            },
            width: t,
            height: h
        }),
    party: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M134.622 0L144.682 68.2539L174.415 5.9977L163.91 74.1846L210.671 23.4578L180.535 85.519L240.169 50.8289L193.079 101.25L260.29 85.679L200.43 119.98L269.245 124.911L201.934 140.044L266.237 165.04L197.456 159.661L251.535 202.5L187.396 177.086L226.445 233.962L172.646 190.771L193.197 256.631L154.518 199.501L154.743 268.492L134.622 202.5L114.501 268.492L114.727 199.501L76.0482 256.631L96.5985 190.771L42.7992 233.962L81.8489 177.086L17.7091 202.5L71.7885 159.661L3.0072 165.04L67.3112 140.044L0 124.911L68.8149 119.98L8.9545 85.679L76.1658 101.25L29.0753 50.8289L88.7105 85.519L58.5743 23.4578L105.335 74.1846L94.8305 5.9977L124.562 68.2539L134.622 0Z",
            aspectRatio: {
                width: 270,
                height: 269
            },
            width: t,
            height: h
        }),
    pillow: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M176 0.00169945C157.812 16.9062 125.203 28.174 88.001 28.174C50.798 28.174 18.1881 16.9054 0 0V258.421C18.1882 241.516 50.798 230.248 88 230.248C125.202 230.248 157.812 241.516 176 258.421V0.00169945Z",
            aspectRatio: {
                width: 176,
                height: 259
            },
            width: t,
            height: h
        }),
    polygon: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M110 0L219.119 63V189L110 252L0.880798 189V63L110 0Z",
            aspectRatio: {
                width: 220,
                height: 252
            },
            width: t,
            height: h
        }),
    rainbow: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M186.907 141H282C282 63.128 218.872 0 141 0C63.1278 0 0 63.128 0 141H95.093C95.093 115.646 115.646 95.093 141 95.093C166.354 95.093 186.907 115.646 186.907 141Z",
            aspectRatio: {
                width: 282,
                height: 141
            },
            width: t,
            height: h
        }),
    rhodeIsland: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M69 0H0V69V138H69V207H138V138V69H69V0Z",
            aspectRatio: {
                width: 138,
                height: 207
            },
            width: t,
            height: h
        }),
    shell: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M109 0C169.199 0 218 48.743 218 108.87C185.392 108.87 158.958 135.273 158.958 167.842C158.958 179.736 158.958 191 158.958 191H59.042C59.042 191 59.042 179.736 59.042 167.842C59.042 135.273 32.6077 108.87 0 108.87C0 48.743 48.8007 0 109 0Z",
            aspectRatio: {
                width: 218,
                height: 191
            },
            width: t,
            height: h
        }),
    shield1: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M203.184 30.7277C142.457 30.7277 102.853 0 102.853 0C102.853 0 63.249 30.7277 3.05098 30.7277C3.05098 30.7277 -3.81372 128.209 3.05098 162.115C9.38758 193.902 102.853 249 102.853 249C102.853 249 196.319 193.902 203.184 162.115C209.52 128.738 203.184 30.7277 203.184 30.7277Z",
            aspectRatio: {
                width: 206,
                height: 249
            },
            width: t,
            height: h
        }),
    shield2: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M0 12.9585C64.624 -4.3195 136.376 -4.3195 201 12.9585C201 51.0564 201 89.154 201 127.252C201 184.396 100.498 240 100.498 240C100.498 240 0 184.406 0 127.252C0 89.154 0 51.0564 0 12.9585Z",
            aspectRatio: {
                width: 201,
                height: 240
            },
            width: t,
            height: h
        }),
    skewedRectangle: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M85.9799 0H290L204.02 141H0L85.9799 0Z",
            aspectRatio: {
                width: 290,
                height: 141
            },
            width: t,
            height: h
        }),
    softFlower: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M109 0C80.073 0 56.6234 23.4498 56.6234 52.3766C56.6234 54.722 54.722 56.6234 52.3766 56.6234C23.4498 56.6234 0 80.073 0 109C0 137.927 23.4498 161.377 52.3766 161.377C54.722 161.377 56.6234 163.278 56.6234 165.623C56.6234 194.55 80.073 218 109 218C137.927 218 161.377 194.55 161.377 165.623C161.377 163.278 163.278 161.377 165.623 161.377C194.55 161.377 218 137.927 218 109C218 80.073 194.55 56.6234 165.623 56.6234C163.278 56.6234 161.377 54.722 161.377 52.3766C161.377 23.4498 137.927 0 109 0Z",
            aspectRatio: {
                width: 218,
                height: 218
            },
            width: t,
            height: h
        }),
    softStar: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M130.424 3.17662C130.927 -1.05888 137.073 -1.05888 137.576 3.17662L141.792 38.7086C147.236 84.59 183.41 120.764 229.291 126.208L264.823 130.424C269.059 130.927 269.059 137.073 264.823 137.576L229.291 141.792C183.41 147.236 147.236 183.41 141.792 229.291L137.576 264.823C137.073 269.059 130.927 269.059 130.424 264.823L126.208 229.291C120.764 183.41 84.59 147.236 38.7086 141.792L3.17662 137.576C-1.05888 137.073 -1.05888 130.927 3.17662 130.424L38.7086 126.208C84.59 120.764 120.764 84.59 126.208 38.7086L130.424 3.17662Z",
            aspectRatio: {
                width: 268,
                height: 268
            },
            width: t,
            height: h
        }),
    stairs1: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M0 0H67.667V67.667H135.333V135.333H203V203H0V0Z",
            aspectRatio: {
                width: 203,
                height: 203
            },
            width: t,
            height: h
        }),
    stairs2: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M50 0H0V200H200V150H150V100H100V50H50V0Z",
            aspectRatio: {
                width: 200,
                height: 200
            },
            width: t,
            height: h
        }),
    teewee: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M69 0H138V69H207V138H138H69H0V69H69V0Z",
            aspectRatio: {
                width: 207,
                height: 138
            },
            width: t,
            height: h
        }),
    blob1: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M172.979 19.611C191.285 33.0858 204.505 54.442 210.861 78.5949C217.471 103.002 217.471 130.46 205.776 151.816C194.335 173.427 171.454 189.444 147.047 196.054C122.639 202.919 96.7069 200.631 75.3506 190.715C54.2486 180.546 37.7229 163.003 23.4855 142.155C9.5022 121.307 -2.19289 97.4087 0.349524 74.7813C3.14617 52.1538 19.9261 30.7976 40.2654 17.8313C60.6046 4.61077 84.5033 -0.474048 108.148 0.0344341C131.538 0.542916 154.928 6.13621 172.979 19.611Z",
            aspectRatio: {
                width: 216,
                height: 200
            },
            width: t,
            height: h
        }),
    blob10: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M188.684 8.95173C205.601 24.3309 200.988 63.0866 191.453 99.3816C182.225 135.677 168.076 169.511 146.238 175.355C124.399 181.507 94.871 159.668 66.5733 143.059C37.9679 126.449 10.5929 115.068 2.59569 95.0754C-5.4015 75.0824 5.97912 46.1694 24.4342 30.4826C42.8893 14.7958 68.4188 12.0276 100.715 6.79864C132.704 1.5697 171.767 -6.42749 188.684 8.95173Z",
            aspectRatio: {
                width: 200,
                height: 177
            },
            width: t,
            height: h
        }),
    blob11: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M137.368 29.4923C148.97 46.7605 146.542 72.1231 148.161 99.1046C149.779 126.086 155.715 154.956 144.113 174.383C132.781 193.81 103.911 203.793 80.4369 198.666C56.963 193.27 38.6156 173.034 28.3626 153.607C17.8398 134.181 15.4115 115.833 9.47555 91.5498C3.53961 67.2664 -5.63411 37.3169 4.61887 20.0488C15.1417 2.51078 45.0911 -1.80626 72.8821 0.622074C100.673 2.78059 126.036 12.2241 137.368 29.4923Z",
            aspectRatio: {
                width: 152,
                height: 200
            },
            width: t,
            height: h
        }),
    blob12: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M158.391 17.923C172.491 28.5703 180.261 48.1384 187.743 70.5842C194.937 93.3177 202.419 118.641 194.649 138.785C187.167 158.928 164.146 173.317 138.535 184.54C112.923 196.05 84.4347 204.108 58.8235 197.777C33.2123 191.446 10.191 170.439 2.99688 146.267C-4.48504 121.807 3.57241 94.181 10.4788 68.282C17.0974 42.0953 22.565 17.6352 37.8166 7.27563C53.0682 -3.37171 78.1038 0.081487 100.837 2.67138C123.859 5.26127 144.29 7.27563 158.391 17.923Z",
            aspectRatio: {
                width: 198,
                height: 200
            },
            width: t,
            height: h
        }),
    blob13: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M149.668 1.37595C170.663 5.22017 193.728 17.3442 198.755 34.7911C204.078 52.2379 191.363 75.3032 178.943 93.9329C166.819 112.563 154.99 126.757 140.501 145.386C126.011 164.312 108.86 187.673 92.5957 186.194C76.3317 185.011 60.9549 159.285 45.8737 140.655C30.4968 122.321 15.7114 110.788 7.43151 95.1157C-0.848339 79.4432 -2.32688 59.0392 3.5873 41.5924C9.50148 23.8498 23.1041 8.76868 38.7767 3.44592C54.745 -1.87685 73.3746 2.55879 91.7086 2.26308C110.338 2.26308 128.968 -2.17256 149.668 1.37595Z",
            aspectRatio: {
                width: 200,
                height: 187
            },
            width: t,
            height: h
        }),
    blob14: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M137.838 28.6426C150.711 40.5617 165.014 46.5213 178.363 58.2021C191.474 69.8828 203.87 87.0464 198.864 99.6807C193.858 112.315 171.689 120.42 157.862 135.676C144.275 151.171 139.269 173.579 126.873 182.161C114.477 190.505 94.9294 185.022 76.8123 178.109C58.4568 171.196 41.5316 163.091 28.1822 150.456C14.5943 137.822 4.58225 120.42 1.24488 101.826C-2.09248 83.2322 1.00651 62.9697 13.8792 52.4809C26.7519 41.992 49.1598 41.0385 65.6083 30.788C82.0567 20.5376 92.0688 0.990158 103.034 0.0366268C113.762 -0.916905 125.204 16.9618 137.838 28.6426Z",
            aspectRatio: {
                width: 200,
                height: 187
            },
            width: t,
            height: h
        }),
    blob15: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M185.203 1.52939C197.679 7.62217 200 32.2835 200 51.7223C200 71.1612 197.389 85.3777 197.679 100.175C198.259 114.681 201.741 129.768 198.259 143.114C194.778 156.46 184.623 168.356 171.567 173.868C158.801 179.671 143.134 179.091 130.368 174.739C117.312 170.387 106.867 162.263 86.8482 160.812C66.539 159.362 36.9454 164.294 18.9572 155.3C0.968966 146.306 -5.41395 123.095 5.03083 105.977C15.4756 88.5692 42.4579 77.5442 55.5139 59.5559C68.2798 41.8578 67.1192 17.4867 76.9837 9.6531C86.5581 2.10965 107.158 11.3939 128.627 9.6531C150.097 8.20244 172.728 -4.27327 185.203 1.52939Z",
            aspectRatio: {
                width: 200,
                height: 179
            },
            width: t,
            height: h
        }),
    blob16: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M158.441 55.3221C167.253 80.2399 160.264 105.462 147.501 134.938C134.738 164.717 116.81 199.055 97.0576 199.967C77.3057 201.182 55.7305 168.668 34.4592 133.722C13.1879 99.0802 -7.77953 62.3112 2.85612 36.4818C13.4918 10.6523 56.0344 -3.93369 90.0685 0.928322C123.799 6.09421 149.324 30.7081 158.441 55.3221Z",
            aspectRatio: {
                width: 163,
                height: 200
            },
            width: t,
            height: h
        }),
    blob17: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M168.917 36.7587C178.871 53.2457 175.138 76.5764 172.961 106.129C170.472 135.37 169.85 170.832 150.563 187.63C131.276 204.739 93.3252 203.495 65.0173 187.63C36.7095 172.077 18.0449 142.213 7.77943 107.373C-2.79714 72.2213 -4.35252 32.7147 14.312 14.0502C32.9765 -4.3033 72.1721 -1.50361 103.591 4.7179C135.32 10.6283 158.962 20.2717 168.917 36.7587Z",
            aspectRatio: {
                width: 176,
                height: 200
            },
            width: t,
            height: h
        }),
    blob18: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M178.188 21.1464C193.012 36.3069 196.381 62.9219 198.739 88.1893C200.76 113.12 201.771 136.366 190.316 149.168C178.862 162.307 155.279 164.665 135.065 167.697C115.188 170.73 99.0168 174.098 72.4018 177.131C46.1237 180.163 9.40176 182.521 1.65309 168.371C-6.09559 154.221 15.4659 123.564 23.5515 92.9059C31.6371 62.2481 26.2467 31.2534 38.3751 15.4192C50.1665 -0.0781831 79.8136 -1.08888 107.776 0.595609C136.076 1.9432 163.028 5.64909 178.188 21.1464Z",
            aspectRatio: {
                width: 200,
                height: 180
            },
            width: t,
            height: h
        }),
    blob19: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M148.621 13.3857C171.945 24.3818 194.937 41.3756 192.938 60.702C190.605 80.3615 163.282 101.687 149.953 123.346C136.958 145.005 137.958 166.664 128.295 174.661C118.631 182.325 98.3054 175.994 73.6476 181.991C48.9899 187.989 20.0004 205.983 11.0036 197.986C1.67366 189.989 12.6697 156.001 12.3365 131.343C12.0033 106.685 0.340809 91.0243 0.00759636 75.0301C-0.325616 59.0359 10.3372 42.3753 25.3318 28.7135C39.9931 15.0518 58.9863 4.05578 80.3119 1.05687C101.638 -2.27526 124.962 2.38972 148.621 13.3857Z",
            aspectRatio: {
                width: 194,
                height: 200
            },
            width: t,
            height: h
        }),
    blob2: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M140.464 18.6393C156.081 28.3718 169.887 39.9149 178.714 54.853C187.541 69.5649 191.389 87.6717 189.578 104.421C187.768 121.396 180.525 137.239 172.377 153.535C164.455 169.832 155.854 186.58 142.048 194.276C128.241 201.971 109.456 200.613 92.4804 197.671C75.2789 194.502 60.1144 189.749 45.1762 182.733C30.4644 175.716 16.2052 166.21 8.28346 153.083C0.361703 139.729 -1.44898 122.527 1.04072 106.91C3.30408 91.2931 9.64147 76.8076 15.9789 60.5114C22.0899 44.2153 28.201 26.1084 40.6495 14.7916C53.0979 3.24849 71.8838 -1.27823 89.7643 0.306124C107.871 1.66414 124.846 9.13322 140.464 18.6393Z",
            aspectRatio: {
                width: 191,
                height: 200
            },
            width: t,
            height: h
        }),
    blob20: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M150.035 13.2464C157.376 24.9386 153.026 48.323 157.92 65.7254C163.087 83.1277 177.498 94.2761 182.392 108.415C187.287 122.555 182.392 139.957 173.147 156.272C163.63 172.587 149.763 187.814 132.089 195.155C114.414 202.225 93.2053 201.137 73.6276 194.611C54.3219 188.357 36.9196 176.937 25.7712 161.438C14.8947 145.667 10.5441 126.09 5.92163 105.696C1.57105 85.0311 -3.05145 63.5501 2.65869 45.0601C8.64075 26.5701 24.6835 11.0711 43.1735 4.54524C61.6635 -1.98064 82.6007 0.194657 102.722 1.01039C122.844 1.82613 142.421 1.55421 150.035 13.2464Z",
            aspectRatio: {
                width: 185,
                height: 200
            },
            width: t,
            height: h
        }),
    blob21: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M152.611 0.184799C172.596 -0.723643 197.73 1.39606 199.85 13.8114C201.969 26.2268 181.075 48.9379 174.716 68.0151C168.357 87.0924 176.533 102.536 174.11 114.649C171.991 127.064 159.575 136.148 146.252 139.782C132.928 143.719 118.696 141.902 105.977 139.176C93.562 136.451 82.6606 132.212 63.2805 131.909C43.9004 131.606 16.0416 135.24 5.44306 125.853C-5.15543 116.465 1.50648 94.0572 10.2881 76.4939C18.7669 59.2335 29.6682 46.8182 38.7526 35.3112C48.1398 23.5015 56.3158 12.903 66.9143 8.36078C77.5128 4.12138 91.1394 6.24108 104.766 5.63546C118.696 4.72701 132.928 1.09324 152.611 0.184799Z",
            aspectRatio: {
                width: 200,
                height: 143
            },
            width: t,
            height: h
        }),
    blob22: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M195.507 15.5715C206.818 33.1668 193.622 69.3001 190.166 101.663C186.71 134.34 193.308 163.561 181.996 178.014C170.685 192.153 141.464 191.525 114.443 189.326C87.1072 187.44 62.2852 183.67 40.6052 169.531C19.2395 155.077 1.6441 130.255 0.0730908 103.862C-1.18372 77.4694 13.898 49.5054 35.2638 31.91C56.6296 14.0004 84.5936 6.45958 116.328 2.37494C148.063 -1.70969 184.196 -2.3381 195.507 15.5715Z",
            aspectRatio: {
                width: 200,
                height: 191
            },
            width: t,
            height: h
        }),
    blob23: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M135.742 9.14189C157.815 19.2326 179.258 38.4681 176.105 56.7576C172.951 74.7317 145.202 92.0751 127.858 109.734C110.83 127.077 104.523 145.052 87.4953 164.918C70.4672 184.468 42.7177 206.227 27.5816 198.343C12.4455 190.46 9.60747 153.566 6.45411 126.762C2.98542 100.274 -0.798607 84.1917 0.147399 67.1636C0.77807 50.4508 6.76944 32.4767 19.0675 20.8093C31.0503 9.14189 49.6551 3.78119 70.4672 1.2585C90.964 -1.26418 113.668 -0.633508 135.742 9.14189Z",
            aspectRatio: {
                width: 177,
                height: 200
            },
            width: t,
            height: h
        }),
    blob24: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M165.663 24.3715C171.555 44.4059 158.003 76.2254 151.816 96.2598C145.923 116.294 147.691 124.544 148.28 135.445C148.575 146.346 147.396 159.309 140.62 170.8C133.549 181.996 120.88 191.424 104.381 196.432C87.8821 201.441 67.553 202.03 54.8841 192.602C41.9207 183.469 36.6174 164.023 25.1271 143.105C13.3421 122.187 -4.33535 99.7953 0.967891 85.0641C6.27113 70.6275 34.2604 63.8511 56.0626 48.5307C77.5702 33.5048 92.8907 9.93489 113.22 2.56928C133.843 -4.79633 159.77 4.04241 165.663 24.3715Z",
            aspectRatio: {
                width: 168,
                height: 200
            },
            width: t,
            height: h
        }),
    blob25: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M180.115 1.256C192.651 2.1962 189.83 34.163 190.771 58.2947C191.711 82.4265 196.098 98.4099 198.606 117.214C201.113 136.018 201.426 157.642 189.204 165.791C177.294 173.626 153.163 167.671 135.299 163.91C117.749 159.836 106.466 157.956 85.7818 162.97C65.0974 168.298 35.3244 180.521 18.7143 174.253C1.79068 167.985 -1.97012 142.913 0.850478 120.975C3.67107 99.0367 13.0731 79.6059 18.4009 54.8473C23.7287 30.0888 24.9823 -0.310996 40.0254 0.00240332C54.7552 0.00240332 82.9612 31.029 111.167 31.029C139.373 31.029 167.579 0.315802 180.115 1.256Z",
            aspectRatio: {
                width: 200,
                height: 176
            },
            width: t,
            height: h
        }),
    blob26: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M142.571 0.586925C159.976 3.39414 176.258 15.1844 184.96 30.9048C193.662 46.6253 194.224 66.8372 189.171 83.6805C183.837 100.805 172.327 114.56 163.064 129.157C153.8 143.755 146.501 158.914 134.43 173.231C122.359 187.828 105.516 201.303 89.5146 199.899C73.2327 198.776 58.0738 182.775 42.9148 169.862C28.0366 157.23 13.7198 147.685 6.42103 134.491C-0.877729 121.297 -1.15845 103.892 1.64876 88.4528C4.45598 72.7324 10.0704 58.6963 18.4921 47.4674C27.1944 36.2386 38.4233 27.8169 50.4943 22.2025C62.846 16.3073 75.7592 13.5001 91.1989 8.72785C106.919 4.23631 125.166 -1.93957 142.571 0.586925Z",
            aspectRatio: {
                width: 193,
                height: 200
            },
            width: t,
            height: h
        }),
    blob27: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M112.602 54.9337C129.225 71.8646 155.391 78.9448 158.777 89.719C162.471 100.493 143.693 114.654 127.07 135.586C110.447 156.519 96.2866 184.224 71.0442 194.998C46.1096 205.465 10.4008 199.308 2.0893 178.375C-6.22223 157.443 12.5557 121.734 18.4045 92.1817C24.5612 62.6296 17.7889 38.9263 26.4082 21.9954C34.7197 5.06454 58.423 -5.40183 73.5069 2.9097C88.8986 10.9134 95.9788 38.0028 112.602 54.9337Z",
            aspectRatio: {
                width: 160,
                height: 200
            },
            width: t,
            height: h
        }),
    blob28: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M125.281 68.5835C142.15 82.9923 165.344 90.021 181.862 108.998C198.028 127.624 207.516 158.902 192.405 166.634C177.293 174.716 137.581 159.605 112.629 156.442C87.326 152.928 77.1344 161.713 59.9142 165.579C43.0453 169.445 19.1478 168.391 11.7677 157.496C4.73907 146.25 14.2278 124.813 11.4163 94.2382C8.2534 63.6634 -6.85825 23.9514 3.68476 8.48836C14.2278 -7.32615 50.4254 1.10826 73.9715 16.2199C97.5175 31.683 108.412 54.1747 125.281 68.5835Z",
            aspectRatio: {
                width: 200,
                height: 169
            },
            width: t,
            height: h
        }),
    blob29: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M162.987 10.2348C169.16 25.1809 154.864 58.6471 147.066 79.4417C139.268 100.236 138.293 108.359 134.719 114.532C131.47 120.706 125.297 124.93 119.448 143.45C113.6 161.97 107.426 194.461 98.004 199.335C88.5814 204.209 75.5849 181.14 55.7651 167.494C35.6203 153.522 8.65241 148.648 1.8292 135.327C-4.994 122.33 8.65241 100.561 20.0244 82.041C31.3964 63.5208 40.1691 48.2498 53.4906 35.5782C66.8122 22.9065 84.0326 13.159 106.452 6.33584C128.871 -0.812285 156.489 -4.71127 162.987 10.2348Z",
            aspectRatio: {
                width: 165,
                height: 200
            },
            width: t,
            height: h
        }),
    blob3: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M158.095 64.2637C176.543 95.19 192.277 129.1 181.697 155.686C171.117 182.001 133.951 201.533 99.4982 199.905C64.7739 198.549 33.0338 176.032 15.4004 145.377C-2.23296 114.994 -5.75963 76.2002 10.2461 46.6303C26.2518 17.0605 61.5185 -3.557 89.732 0.512241C118.217 4.58149 139.377 33.0662 158.095 64.2637Z",
            aspectRatio: {
                width: 186,
                height: 200
            },
            width: t,
            height: h
        }),
    blob30: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M146.076 34.4585C157.052 54.582 155.833 80.1936 164.675 100.622C173.212 121.355 191.201 136.905 189.372 149.711C187.542 162.212 165.285 171.969 146.99 175.018C129.001 178.372 114.671 174.713 103.39 175.018C92.1083 175.018 83.876 178.982 66.8015 186.299C49.7271 193.617 23.8105 204.288 14.3586 198.19C4.90665 191.787 11.6145 168.615 10.3949 147.882C8.87037 127.148 -0.581561 108.549 0.0282404 89.3407C0.638042 70.1319 11.6145 50.6182 28.384 32.934C44.8487 15.5546 67.4113 0.309578 89.974 0.00467694C112.537 -0.300224 135.099 14.335 146.076 34.4585Z",
            aspectRatio: {
                width: 190,
                height: 200
            },
            width: t,
            height: h
        }),
    blob31: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M134.218 44.0392C153.568 36.4264 184.97 26.9105 195.755 33.2544C206.222 39.9156 195.755 62.1194 181.481 76.3933C166.89 90.35 148.175 96.0596 145.638 116.36C143.1 136.661 156.74 171.235 151.664 183.923C146.589 196.928 123.434 187.413 105.036 178.531C86.6388 169.967 73.3165 161.72 52.0643 158.548C30.812 155.058 1.62986 156.644 0.0438693 145.225C-1.22492 133.806 25.4197 109.382 29.2261 86.8609C32.7152 64.3398 13.6834 44.0392 11.7802 26.9105C9.877 9.46461 24.7853 -4.80928 42.5484 1.53467C59.9942 7.87863 79.9777 34.5232 93.6172 45.308C107.257 56.4099 114.869 51.3347 134.218 44.0392Z",
            aspectRatio: {
                width: 200,
                height: 191
            },
            width: t,
            height: h
        }),
    blob32: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M200 100.339C200 149.831 145.763 197.966 95.5932 197.966C45.7627 197.966 0 149.831 0 100.339C0 50.8475 45.7627 0 95.5932 0C145.763 0 200 50.8475 200 100.339Z",
            aspectRatio: {
                width: 200,
                height: 198
            },
            width: t,
            height: h
        }),
    blob4: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M183.427 38.712C198.21 63.2519 196.141 95.1833 189.341 126.523C182.836 157.863 171.305 188.908 150.609 197.482C130.208 205.76 100.642 192.16 69.8936 177.968C39.4405 164.072 7.80478 150.176 1.30024 128.593C-5.2043 107.01 13.718 77.7393 35.3012 51.7211C56.5888 25.9986 81.1287 3.23272 108.921 0.276112C137.009 -2.38484 168.349 14.4678 183.427 38.712Z",
            aspectRatio: {
                width: 195,
                height: 200
            },
            width: t,
            height: h
        }),
    blob5: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M166.251 30.6913C183.816 48.5185 195.875 71.8512 199.021 98.8542C202.429 125.595 197.186 155.744 179.359 169.115C161.794 182.223 131.645 178.815 103.331 176.979C75.0171 175.144 48.8006 174.882 29.6625 161.512C10.7866 148.141 -0.748681 121.925 0.0378149 96.2326C0.824311 70.8025 14.1947 46.159 33.0706 28.3318C52.2087 10.5045 76.8522 -0.5064 100.971 0.0179307C125.091 0.804426 148.423 12.864 166.251 30.6913Z",
            aspectRatio: {
                width: 200,
                height: 179
            },
            width: t,
            height: h
        }),
    blob6: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M149.146 50.5452C161.911 68.0278 171.901 81.9028 176.619 97.9979C181.336 114.37 180.781 133.241 173.011 149.891C165.519 166.541 151.366 180.693 133.051 189.851C114.736 199.008 92.2586 202.893 71.446 197.621C50.6334 192.348 30.9308 177.918 18.1658 158.216C5.12323 138.791 -0.981801 113.815 0.128204 87.7304C1.51571 61.6453 10.6733 34.1726 29.2658 17.5226C48.1359 1.14999 76.996 -4.40004 98.9186 3.6475C120.841 11.695 136.381 32.7851 149.146 50.5452Z",
            aspectRatio: {
                width: 180,
                height: 200
            },
            width: t,
            height: h
        }),
    blob7: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M158.662 41.8295C178.593 57.8305 204.138 64.5677 213.402 79.7266C222.666 94.6047 215.367 118.466 203.015 135.028C190.383 151.871 172.698 161.977 156.416 168.434C140.134 174.89 124.975 177.697 104.483 185.277C83.9903 192.856 58.1642 205.208 44.9704 197.629C31.4959 190.33 31.2152 163.1 21.9514 138.116C12.9684 112.851 -4.71688 90.1132 1.17822 75.5158C7.35404 61.1991 36.8295 55.5847 58.7256 40.1452C80.9024 24.7056 95.4998 -0.278374 109.816 0.00234533C124.414 0.283064 138.45 25.8285 158.662 41.8295Z",
            aspectRatio: {
                width: 218,
                height: 200
            },
            width: t,
            height: h
        }),
    blob8: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M153.53 11.0108C168.179 18.1858 181.931 29.5461 192.993 44.4939C203.755 59.4417 212.425 78.2759 210.631 96.5122C209.136 114.748 197.477 132.088 182.529 142.252C167.581 152.716 148.747 156.004 128.717 168.262C108.687 180.22 87.1622 201.147 69.8228 199.951C52.7823 198.456 39.6283 174.54 32.4533 153.015C25.2784 131.49 24.0826 112.357 16.6087 91.131C9.13477 70.2041 -4.31825 46.8855 1.36191 31.9377C7.04207 16.691 31.8554 9.51607 52.7823 5.33069C73.4103 0.846349 90.4507 -0.648433 106.594 0.248435C123.037 1.1453 138.882 4.13486 153.53 11.0108Z",
            aspectRatio: {
                width: 211,
                height: 200
            },
            width: t,
            height: h
        }),
    blob9: ({ width: t, height: h })=>$e1331ea2709a183e$var$getScaledPath({
            path: "M140.289 20.2182C156.96 27.7956 176.661 32.0895 189.29 43.9608C201.667 55.5796 206.718 75.0283 202.424 91.6987C198.131 108.622 184.491 122.766 175.651 140.952C166.81 158.885 162.769 180.607 150.393 191.216C138.016 201.824 117.052 201.572 98.866 197.025C80.6802 192.479 65.2727 183.891 48.3497 175.808C31.4268 167.726 13.2409 160.148 5.1583 146.761C-2.67172 133.122 -0.398493 113.673 4.14797 96.7504C8.69444 80.08 15.5141 65.6828 23.3442 52.296C31.4268 38.6566 40.5197 25.775 52.6436 15.6717C65.0201 5.82101 80.6802 -1.50385 95.3299 0.264221C109.98 1.77971 123.619 12.6407 140.289 20.2182Z",
            aspectRatio: {
                width: 204,
                height: 200
            },
            width: t,
            height: h
        })
}, module.exports.subTypeToPathDataFunc = $e1331ea2709a183e$var$subTypeToPathDataFunc, module.exports.figureToSvg = $e1331ea2709a183e$var$figureToSvg;

});



parcelRegister("aCKlx", function(module, exports) {
"use strict";
function $7bc16769f5e24533$var$getCrop(t, e, h = "scale") {
    const i = e.width / e.height;
    let o, r;
    i >= t.width / t.height ? (o = t.width, r = t.width / i) : (o = t.height * i, r = t.height);
    let d = 0, g = 0;
    return "left-top" === h ? (d = 0, g = 0) : "left-middle" === h ? (d = 0, g = (t.height - r) / 2) : "left-bottom" === h ? (d = 0, g = t.height - r) : "center-top" === h ? (d = (t.width - o) / 2, g = 0) : "center-middle" === h ? (d = (t.width - o) / 2, g = (t.height - r) / 2) : "center-bottom" === h ? (d = (t.width - o) / 2, g = t.height - r) : "right-top" === h ? (d = t.width - o, g = 0) : "right-middle" === h ? (d = t.width - o, g = (t.height - r) / 2) : "right-bottom" === h ? (d = t.width - o, g = t.height - r) : "scale" === h ? (d = 0, g = 0, o = t.width, r = t.height) : console.error(new Error("Unknown clip position property - " + h)), {
        cropX: d,
        cropY: g,
        cropWidth: o,
        cropHeight: r
    };
}
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.getCrop = void 0, module.exports.getCrop = $7bc16769f5e24533$var$getCrop;

});

parcelRegister("8PUQD", function(module, exports) {
"use strict";
var $66ef2ef2e123e03c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(e, o, t, i) {
    void 0 === i && (i = t);
    var n = Object.getOwnPropertyDescriptor(o, t);
    n && !("get" in n ? !o.__esModule : n.writable || n.configurable) || (n = {
        enumerable: !0,
        get: function() {
            return o[t];
        }
    }), Object.defineProperty(e, i, n);
} : function(e, o, t, i) {
    void 0 === i && (i = t), e[i] = o[t];
}), $66ef2ef2e123e03c$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(e, o) {
    Object.defineProperty(e, "default", {
        enumerable: !0,
        value: o
    });
} : function(e, o) {
    e.default = o;
}), $66ef2ef2e123e03c$var$__importStar = module.exports && module.exports.__importStar || function(e) {
    if (e && e.__esModule) return e;
    var o = {};
    if (null != e) for(var t in e)"default" !== t && Object.prototype.hasOwnProperty.call(e, t) && $66ef2ef2e123e03c$var$__createBinding(o, e, t);
    return $66ef2ef2e123e03c$var$__setModuleDefault(o, e), o;
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.validateKey = module.exports.isKeyPaid = module.exports.getKey = module.exports.shouldShowCredit = void 0;

const $66ef2ef2e123e03c$var$mobx = $66ef2ef2e123e03c$var$__importStar((parcelRequire("2SBKn")));

var $6laUv = parcelRequire("6laUv");

var $gS5ZA = parcelRequire("gS5ZA");
module.exports.shouldShowCredit = $66ef2ef2e123e03c$var$mobx.observable({
    value: !1
});
const $66ef2ef2e123e03c$var$showCredit = $66ef2ef2e123e03c$var$mobx.action(()=>{
    module.exports.shouldShowCredit.value = !0;
});
let $66ef2ef2e123e03c$var$API_KEY = "";
const $66ef2ef2e123e03c$var$getKey = ()=>$66ef2ef2e123e03c$var$API_KEY || "";
module.exports.getKey = $66ef2ef2e123e03c$var$getKey;
const $66ef2ef2e123e03c$var$ATTEMPTS = 5, $66ef2ef2e123e03c$var$TIMEOUT = 3e3, $66ef2ef2e123e03c$var$NO_KEY_MESSAGE = "Polotno API is initialized without API key. It may lead to unexpected behavior and stop working. Please create API key here: https://polotno.com/cabinet", $66ef2ef2e123e03c$var$NO_VALID_MESSAGE = "Polotno API key is not valid. Please get new API key here: https://polotno.com/cabinet", $66ef2ef2e123e03c$var$ERROR_MESSAGE = "Can not validate Polotno API key. Please report to anton@polotno.com immediately.", $66ef2ef2e123e03c$var$NOT_PAID_MESSAGE = "%cPolotno Free Version. Development or non-commercial usage only. https://polotno.com/";
let $66ef2ef2e123e03c$var$origin = window.location.origin;
const $66ef2ef2e123e03c$var$headless = navigator.userAgent.indexOf("Headless") > -1, $66ef2ef2e123e03c$var$electron = navigator.userAgent.indexOf("Electron") > -1;
"file://" === $66ef2ef2e123e03c$var$origin && $66ef2ef2e123e03c$var$headless && ($66ef2ef2e123e03c$var$origin = "headless"), "file://" === $66ef2ef2e123e03c$var$origin && $66ef2ef2e123e03c$var$electron && ($66ef2ef2e123e03c$var$origin = "electron");
const $66ef2ef2e123e03c$var$BAD_DOMAIN_MESSAGE = `%cPolotno error! Current domain is not allowed. It may lead to unexpected behavior and stop working. Please add "${$66ef2ef2e123e03c$var$origin}" here: https://polotno.com/cabinet`;
async function $66ef2ef2e123e03c$var$isKeyPaid(e) {
    for(let o = 0; o < $66ef2ef2e123e03c$var$ATTEMPTS; o++)try {
        const o = await fetch((0, $6laUv.getAPI)() + "/validate-key", {
            method: "POST",
            body: JSON.stringify({
                key: e,
                site: location.host
            })
        });
        if (!e) return console.warn($66ef2ef2e123e03c$var$NO_KEY_MESSAGE), !1;
        if (200 !== o.status) {
            await new Promise((e)=>setTimeout(e, $66ef2ef2e123e03c$var$TIMEOUT));
            continue;
        }
        const t = await o.json();
        return t.is_valid || console.warn($66ef2ef2e123e03c$var$NO_VALID_MESSAGE), t.is_paid || console.log($66ef2ef2e123e03c$var$NOT_PAID_MESSAGE, "background: rgb(0, 161, 255); color: white; padding: 5px; margin: 5px;"), t.is_domain_valid || console.log($66ef2ef2e123e03c$var$BAD_DOMAIN_MESSAGE, "background: rgba(247, 101, 68, 1); color: white; padding: 5px; margin: 5px;"), (0, $gS5ZA.useRemoveBackground)(t.remove_background_enabled), t.is_paid || !1;
    } catch (e) {
        await new Promise((e)=>setTimeout(e, $66ef2ef2e123e03c$var$TIMEOUT));
    }
    return console.error($66ef2ef2e123e03c$var$ERROR_MESSAGE), !0;
}
async function $66ef2ef2e123e03c$var$validateKey(e, o) {
    $66ef2ef2e123e03c$var$API_KEY = e;
    await $66ef2ef2e123e03c$var$isKeyPaid(e) && !o || $66ef2ef2e123e03c$var$showCredit();
}
module.exports.isKeyPaid = $66ef2ef2e123e03c$var$isKeyPaid, module.exports.validateKey = $66ef2ef2e123e03c$var$validateKey;

});
parcelRegister("6laUv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.setAPI = module.exports.iconscoutDownload = module.exports.iconscoutList = module.exports.svgapiDownload = module.exports.svgapiList = module.exports.unsplashDownload = module.exports.unsplashList = module.exports.textTemplateList = module.exports.templateList = module.exports.removeBackground = module.exports.polotnoShapesList = module.exports.getGoogleFontImage = module.exports.getGoogleFontsListAPI = module.exports.URLS = module.exports._dangerous = module.exports.getAPI = module.exports.getDomain = module.exports.API = module.exports.URL = void 0;

var $8PUQD = parcelRequire("8PUQD");
module.exports.URL = "https://api.polotno.com", module.exports.API = "https://api.polotno.com/api";
let $49dd2ad68998f710$var$DOMAIN = module.exports.URL;
const $49dd2ad68998f710$var$getDomain = ()=>$49dd2ad68998f710$var$DOMAIN;
module.exports.getDomain = $49dd2ad68998f710$var$getDomain;
const $49dd2ad68998f710$var$getAPI = ()=>$49dd2ad68998f710$var$DOMAIN + "/api";
module.exports.getAPI = $49dd2ad68998f710$var$getAPI;
const $49dd2ad68998f710$var$_dangerous = (e)=>{
    $49dd2ad68998f710$var$DOMAIN = e;
};
module.exports._dangerous = $49dd2ad68998f710$var$_dangerous;
const $49dd2ad68998f710$var$showedWarnings = {}, $49dd2ad68998f710$var$warn = (e, t)=>{
    $49dd2ad68998f710$var$showedWarnings[e] || ($49dd2ad68998f710$var$showedWarnings[e] = !0, console.error(t));
}, $49dd2ad68998f710$var$replaceAll = (e, t, o)=>e.replace(new RegExp(t, "g"), o), $49dd2ad68998f710$var$ICONSCOUT_MESSAGE = "API for iconscout is provided as a demonstration.\nFor production usage you have to use your own API endpoint.\nhttps://iconscout.com/developers, https://iconscout.com/legal/api-license-development-agreement\nhttps://polotno.com/docs/server-api";
module.exports.URLS = {
    unsplashList: ({ query: e, page: t = 1 })=>`${(0, module.exports.getAPI)()}/get-unsplash?query=${e}&per_page=20&page=${t}&KEY=${(0, $8PUQD.getKey)()}`,
    unsplashDownload: (e)=>`${(0, module.exports.getAPI)()}/download-unsplash?id=${e}&KEY=${(0, $8PUQD.getKey)()}`,
    svgapiList: ({ query: e, page: t = 0 })=>`${(0, module.exports.getAPI)()}/get-svgapi?query=${e}&page=${t}&per_page=20&KEY=${(0, $8PUQD.getKey)()}`,
    svgapiDownload: (e)=>`${(0, module.exports.getAPI)()}/download-svgapi?path=${e}&KEY=${(0, $8PUQD.getKey)()}`,
    iconscoutList: ({ query: e, page: t = 1 })=>($49dd2ad68998f710$var$warn("iconscout", $49dd2ad68998f710$var$ICONSCOUT_MESSAGE), `${(0, module.exports.getAPI)()}/get-iconscout?query=${e}&page=${t}&KEY=${(0, $8PUQD.getKey)()}`),
    iconscoutDownload: (e)=>($49dd2ad68998f710$var$warn("iconscout", $49dd2ad68998f710$var$ICONSCOUT_MESSAGE), `${(0, module.exports.getAPI)()}/download-iconscout?uuid=${e}&KEY=${(0, $8PUQD.getKey)()}`),
    templateList: ({ query: e, page: t = 1, sizeQuery: o })=>`${(0, module.exports.getAPI)()}/get-templates?${o}&query=${e}&per_page=30&page=${t}&KEY=${(0, $8PUQD.getKey)()}`
};
const $49dd2ad68998f710$var$getGoogleFontsListAPI = ()=>`${(0, module.exports.getAPI)()}/get-google-fonts?KEY=${(0, $8PUQD.getKey)()}`;
module.exports.getGoogleFontsListAPI = $49dd2ad68998f710$var$getGoogleFontsListAPI;
const $49dd2ad68998f710$var$getGoogleFontImage = (e)=>{
    var t, o, s;
    return `${(0, module.exports.getDomain)()}/google-fonts-previews/black/${t = e, o = " ", s = "-", t.replace(new RegExp(o, "g"), s)}.png`;
};
module.exports.getGoogleFontImage = $49dd2ad68998f710$var$getGoogleFontImage;
const $49dd2ad68998f710$var$polotnoShapesList = ()=>`${(0, module.exports.getAPI)()}/get-basic-shapes?KEY=${(0, $8PUQD.getKey)()}`;
module.exports.polotnoShapesList = $49dd2ad68998f710$var$polotnoShapesList;
const $49dd2ad68998f710$var$removeBackground = ()=>`${(0, module.exports.getAPI)()}/remove-image-background?KEY=${(0, $8PUQD.getKey)()}`;
module.exports.removeBackground = $49dd2ad68998f710$var$removeBackground;
const $49dd2ad68998f710$var$templateList = (e)=>module.exports.URLS.templateList(e);
module.exports.templateList = $49dd2ad68998f710$var$templateList;
const $49dd2ad68998f710$var$textTemplateList = ()=>`${(0, module.exports.getAPI)()}/get-text-templates?KEY=${(0, $8PUQD.getKey)()}`;
module.exports.textTemplateList = $49dd2ad68998f710$var$textTemplateList;
const $49dd2ad68998f710$var$unsplashList = (e)=>module.exports.URLS.unsplashList(e);
module.exports.unsplashList = $49dd2ad68998f710$var$unsplashList;
const $49dd2ad68998f710$var$unsplashDownload = (e)=>module.exports.URLS.unsplashDownload(e);
module.exports.unsplashDownload = $49dd2ad68998f710$var$unsplashDownload;
const $49dd2ad68998f710$var$svgapiList = (e)=>module.exports.URLS.svgapiList(e);
module.exports.svgapiList = $49dd2ad68998f710$var$svgapiList;
const $49dd2ad68998f710$var$svgapiDownload = (e)=>module.exports.URLS.svgapiDownload(e);
module.exports.svgapiDownload = $49dd2ad68998f710$var$svgapiDownload;
const $49dd2ad68998f710$var$iconscoutList = (e)=>module.exports.URLS.iconscoutList(e);
module.exports.iconscoutList = $49dd2ad68998f710$var$iconscoutList;
const $49dd2ad68998f710$var$iconscoutDownload = (e)=>module.exports.URLS.iconscoutDownload(e);
module.exports.iconscoutDownload = $49dd2ad68998f710$var$iconscoutDownload;
const $49dd2ad68998f710$var$setAPI = (e, t)=>{
    module.exports.URLS[e] = t;
};
module.exports.setAPI = $49dd2ad68998f710$var$setAPI;

});


parcelRegister("7ZydS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.pxToUnitString = module.exports.unitToPx = module.exports.pxToUnitRounded = module.exports.pxToUnit = void 0;
const $5d18c6df350dbf3f$var$pxToUnit = ({ px: t, unit: n = "px", dpi: o })=>{
    switch(n){
        case "pt":
        default:
            return t;
        case "mm":
            return t / (o / 25.4);
        case "cm":
            return t / (o / 2.54);
        case "in":
            return t / o;
    }
};
module.exports.pxToUnit = $5d18c6df350dbf3f$var$pxToUnit;
const $5d18c6df350dbf3f$var$pxToUnitRounded = ({ px: t, precious: n = 2, dpi: o = 72, unit: e = "px" })=>parseFloat((0, module.exports.pxToUnit)({
        px: t,
        dpi: o,
        unit: e
    }).toFixed(n));
module.exports.pxToUnitRounded = $5d18c6df350dbf3f$var$pxToUnitRounded;
const $5d18c6df350dbf3f$var$unitToPx = ({ unitVal: t, dpi: n, unit: o })=>t / (0, module.exports.pxToUnit)({
        px: 1,
        unit: o,
        dpi: n
    });
module.exports.unitToPx = $5d18c6df350dbf3f$var$unitToPx;
const $5d18c6df350dbf3f$var$pxToUnitString = (t)=>{
    const n = parseFloat((0, module.exports.pxToUnit)(t).toFixed(1));
    switch(t.unit){
        case "pt":
            return `${Math.round(n)}pt`;
        case "mm":
            return `${n}mm`;
        case "cm":
            return `${n}cm`;
        case "in":
            return `${n}in`;
        default:
            return `${Math.round(n)}px`;
    }
};
module.exports.pxToUnitString = $5d18c6df350dbf3f$var$pxToUnitString;

});


parcelRegister("msF0x", function(module, exports) {
"use strict";
var $0438498cb843df0b$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.LeftRules = module.exports.TopRules = void 0;

const $0438498cb843df0b$var$react_1 = $0438498cb843df0b$var$__importDefault((parcelRequire("8NFma")));

var $kYy5r = parcelRequire("kYy5r");

var $7ZydS = parcelRequire("7ZydS");
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

var $7lEwu = parcelRequire("7lEwu");
const $0438498cb843df0b$var$RulersContainer = (0, $7lEwu.styled)("div", $0438498cb843df0b$var$react_1.default.forwardRef)`
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
`, $0438498cb843df0b$var$TopRuler = (0, $7lEwu.styled)("div", $0438498cb843df0b$var$react_1.default.forwardRef)`
  height: 14px;
  position: sticky;
  font-size: 8px;
  line-height: 14px;
  top: 0;
  left: 0;
  color: grey;
  border-bottom: 1px solid grey;
  background-color: #e8e8e8;
  overflow: hidden;
`, $0438498cb843df0b$var$LeftRuler = (0, $7lEwu.styled)("div", $0438498cb843df0b$var$react_1.default.forwardRef)`
  left: 0;
  width: 14px;
  position: sticky;
  font-size: 8px;
  line-height: 14px;
  color: grey;
  border-right: 1px solid grey;
  background-color: #e8e8e8;
  overflow: hidden;
`, $0438498cb843df0b$var$SectionX = (0, $7lEwu.styled)("div", $0438498cb843df0b$var$react_1.default.forwardRef)`
  position: absolute;
  border-left: 1px solid grey;
  padding-left: 2px;
`, $0438498cb843df0b$var$SectionY = (0, $7lEwu.styled)("div", $0438498cb843df0b$var$react_1.default.forwardRef)`
  position: absolute;
  left: 14px;
  border-left: 1px solid grey;
  padding-left: 2px;
  transform: rotate(90deg);
  transform-origin: left top;
  overflow: hidden;
`, $0438498cb843df0b$var$realMetricsSteps = [
    .1,
    .2,
    .5,
    1,
    2,
    5,
    10,
    20,
    25,
    50,
    100,
    200,
    500,
    1e3,
    2e3,
    5e3,
    1e4
], $0438498cb843df0b$var$MIN_SECTION_WIDTH = 30, $0438498cb843df0b$var$findSplitSize = (e)=>$0438498cb843df0b$var$realMetricsSteps.find((t)=>e(t) > 30) || 1e4;
function $0438498cb843df0b$var$LeftRules() {
    return $0438498cb843df0b$var$react_1.default.createElement("div", null, $0438498cb843df0b$var$react_1.default.createElement("h1", null, "Top rules"));
}
module.exports.TopRules = (0, $O1ETn.observer)(({ store: e, width: t, height: r })=>{
    const o = $0438498cb843df0b$var$react_1.default.useRef(null);
    if (!e.activePage) return null;
    const l = e.activePage, i = (e.bleedVisible && l.bleed, l.computedWidth * e.scale), a = l.computedHeight * e.scale, s = (t - i) / 2, d = (n = (t)=>(0, $7ZydS.unitToPx)({
            unitVal: t,
            dpi: e.dpi,
            unit: e.unit
        }) * e.scale, $0438498cb843df0b$var$realMetricsSteps.find((e)=>n(e) > 30) || 1e4);
    var n;
    const u = (0, $7ZydS.unitToPx)({
        unitVal: d,
        dpi: e.dpi,
        unit: e.unit
    }) * e.scale, c = Math.round(i / u) + 1, p = Math.round(a / u) + 1, f = (0, $kYy5r.getTotalClientRect)(e.selectedShapes);
    return $0438498cb843df0b$var$react_1.default.createElement($0438498cb843df0b$var$RulersContainer, {
        ref: o,
        className: "polotno-rulers"
    }, $0438498cb843df0b$var$react_1.default.createElement($0438498cb843df0b$var$TopRuler, {
        style: {
            width: t + "px"
        },
        className: "polotno-x-ruler"
    }, [
        ...Array(c)
    ].map((t, r)=>$0438498cb843df0b$var$react_1.default.createElement($0438498cb843df0b$var$SectionX, {
            key: r,
            style: {
                left: s + r * u + "px",
                width: u + "px"
            }
        }, "px" === e.unit || d >= 1 ? Math.round(d * r) : (d * r).toFixed(1))), !!e.selectedShapes.length && $0438498cb843df0b$var$react_1.default.createElement("div", {
        style: {
            position: "absolute",
            left: s + f.x * e.scale + "px",
            height: "14px",
            width: f.width * e.scale,
            backgroundColor: "rgba(0,0,0,0.15)"
        }
    })), e.pages.map((t, o)=>{
        var l;
        const i = t.computedHeight * e.scale, a = (r - i) / 2;
        return $0438498cb843df0b$var$react_1.default.createElement($0438498cb843df0b$var$LeftRuler, {
            key: t.id,
            style: {
                height: r + "px"
            },
            className: "polotno-y-ruler"
        }, [
            ...Array(p)
        ].map((t, r)=>$0438498cb843df0b$var$react_1.default.createElement($0438498cb843df0b$var$SectionY, {
                key: r,
                style: {
                    top: a + r * u - 14 + "px",
                    width: u + "px"
                }
            }, "px" === e.unit || d >= 1 ? Math.round(d * r) : (d * r).toFixed(1))), (null === (l = e.selectedShapes[0]) || void 0 === l ? void 0 : l.page) === t && $0438498cb843df0b$var$react_1.default.createElement("div", {
            style: {
                position: "absolute",
                top: a + f.y * e.scale - 14 + "px",
                width: "14px",
                height: f.height * e.scale,
                backgroundColor: "rgba(0,0,0,0.15)"
            }
        }));
    }));
}), module.exports.LeftRules = $0438498cb843df0b$var$LeftRules;

});

parcelRegister("ej9US", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.handleHotkey = void 0;

var $6k1PQ = parcelRequire("6k1PQ");
let $a6aa883a196f1152$var$_LOCAL_CLIPBOARD = [], $a6aa883a196f1152$var$copyPage = "";
const $a6aa883a196f1152$var$KEY = "polotno_clipboard", $a6aa883a196f1152$var$setClipBoard = (e)=>{
    $a6aa883a196f1152$var$_LOCAL_CLIPBOARD = JSON.parse(JSON.stringify(e));
    try {
        localStorage.setItem($a6aa883a196f1152$var$KEY, JSON.stringify(e));
    } catch (e) {}
}, $a6aa883a196f1152$var$getClipBoard = ()=>{
    try {
        const e = localStorage.getItem($a6aa883a196f1152$var$KEY);
        if (e) return JSON.parse(e);
    } catch (e) {}
    return $a6aa883a196f1152$var$_LOCAL_CLIPBOARD;
};
function $a6aa883a196f1152$var$handleHotkey(e, t) {
    var o, l, d, a, r, i, n, c;
    if ("INPUT" === (null === (o = document.activeElement) || void 0 === o ? void 0 : o.tagName) || "TEXTAREA" === (null === (l = document.activeElement) || void 0 === l ? void 0 : l.tagName) || "true" === (null === (d = document.activeElement) || void 0 === d ? void 0 : d.contentEditable)) return;
    const s = t.selectedElements.filter((e)=>e.removable), v = s.map((e)=>e.id);
    46 !== e.keyCode && 8 !== e.keyCode || t.deleteElements(v);
    const p = e.ctrlKey || e.metaKey, u = e.shiftKey;
    if (p && !u && "KeyZ" === e.code && (e.preventDefault(), t.history.undo()), p && u && "KeyZ" === e.code && (e.preventDefault(), t.history.redo()), p && "KeyA" === e.code) {
        e.preventDefault();
        const o = null === (a = t.activePage) || void 0 === a ? void 0 : a.children.filter((e)=>e.selectable), l = (null == o ? void 0 : o.map((e)=>e.id)) || [];
        t.selectElements(l);
    }
    if (p && "KeyC" === e.code && (e.preventDefault(), $a6aa883a196f1152$var$copyPage = null === (r = t.activePage) || void 0 === r ? void 0 : r.id, $a6aa883a196f1152$var$setClipBoard(t.selectedElements.map((e)=>e.toJSON()))), p && "KeyX" === e.code && (e.preventDefault(), $a6aa883a196f1152$var$copyPage = null === (i = t.activePage) || void 0 === i ? void 0 : i.id, $a6aa883a196f1152$var$setClipBoard(t.selectedElements.map((e)=>e.toJSON())), t.deleteElements(s)), p && "KeyV" === e.code) {
        e.preventDefault();
        let o = 0;
        $a6aa883a196f1152$var$copyPage === (null === (n = t.activePage) || void 0 === n ? void 0 : n.id) && (o = t.width / 20), $a6aa883a196f1152$var$copyPage = null === (c = t.activePage) || void 0 === c ? void 0 : c.id, t.history.transaction(()=>{
            const e = [], l = $a6aa883a196f1152$var$getClipBoard();
            (0, $6k1PQ.forEveryChild)({
                children: l
            }, (e)=>{
                delete e.id, "group" !== e.type && (e.x += o, e.y += o);
            }), console.log(l), l.forEach((o)=>{
                var l;
                const d = null === (l = t.activePage) || void 0 === l ? void 0 : l.addElement(o);
                d && e.push(d.id);
            }), $a6aa883a196f1152$var$setClipBoard(l), t.selectElements(e);
        });
    }
    "ArrowDown" === e.code && (e.preventDefault(), t.selectedElements.forEach((e)=>{
        e.set({
            y: e.y + 1
        });
    })), "ArrowUp" === e.code && (e.preventDefault(), t.selectedElements.forEach((e)=>{
        e.set({
            y: e.y - 1
        });
    })), "ArrowLeft" === e.code && (e.preventDefault(), t.selectedElements.forEach((e)=>{
        e.set({
            x: e.x - 1
        });
    })), "ArrowRight" === e.code && (e.preventDefault(), t.selectedElements.forEach((e)=>{
        e.set({
            x: e.x + 1
        });
    }));
}
module.exports.handleHotkey = $a6aa883a196f1152$var$handleHotkey;

});
parcelRegister("6k1PQ", function(module, exports) {
"use strict";
var $49a608c5489d744c$var$__rest = module.exports && module.exports.__rest || function(e, t) {
    var r = {};
    for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (r[o] = e[o]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var l = 0;
        for(o = Object.getOwnPropertySymbols(e); l < o.length; l++)t.indexOf(o[l]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[l]) && (r[o[l]] = e[o[l]]);
    }
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.registerShapeModel = module.exports.TYPES_MAP = module.exports.GroupElement = module.exports.ElementTypes = module.exports.forEveryChild = void 0;

var $58B0H = parcelRequire("58B0H");

var $aQPnZ = parcelRequire("aQPnZ");

var $9xvfK = parcelRequire("9xvfK");

var $lfvTK = parcelRequire("lfvTK");

var $dPiE9 = parcelRequire("dPiE9");

var $cgQqz = parcelRequire("cgQqz");

var $btOWX = parcelRequire("btOWX");

var $atkrP = parcelRequire("atkrP");

var $j92iZ = parcelRequire("j92iZ");

var $bjsE3 = parcelRequire("bjsE3");
const $49a608c5489d744c$var$forEveryChild = (e, t)=>{
    if (e.children) for (const r of e.children){
        if (!0 === t(r)) break;
        (0, module.exports.forEveryChild)(r, t);
    }
};
module.exports.forEveryChild = $49a608c5489d744c$var$forEveryChild;
const $49a608c5489d744c$var$additionalTypesUnion = [
    ...new Array(20)
].map((e, t)=>$58B0H.types.late(()=>$49a608c5489d744c$var$ADDITIONAL_TYPES[t]));
module.exports.ElementTypes = $58B0H.types.union({
    dispatcher: (e)=>{
        const t = module.exports.TYPES_MAP[e.type];
        if (!t) throw new Error(`Unknown element type: "${e.type}"`);
        return t;
    }
}, $j92iZ.SVGElement, $dPiE9.TextElement, $cgQqz.ImageElement, $atkrP.LineElement, $btOWX.VideoElement, $bjsE3.FigureElement, $58B0H.types.late(()=>module.exports.GroupElement), ...$49a608c5489d744c$var$additionalTypesUnion), module.exports.GroupElement = $9xvfK.Node.named("Group").props({
    type: "group",
    children: $58B0H.types.array(module.exports.ElementTypes)
}).views((e)=>({
        get draggable () {
            let t = !0;
            return (0, module.exports.forEveryChild)(e, (e)=>{
                e.draggable || (t = !1);
            }), t;
        },
        get resizable () {
            let t = !0;
            return (0, module.exports.forEveryChild)(e, (e)=>{
                e.resizable || (t = !1);
            }), t;
        },
        get contentEditable () {
            let t = !0;
            return (0, module.exports.forEveryChild)(e, (e)=>{
                e.contentEditable || (t = !1);
            }), t;
        },
        get styleEditable () {
            let t = !0;
            return (0, module.exports.forEveryChild)(e, (e)=>{
                e.styleEditable || (t = !1);
            }), t;
        },
        get locked () {
            let t = !0;
            return (0, module.exports.forEveryChild)(e, (e)=>{
                e.locked || (t = !1);
            }), t;
        }
    })).actions((e)=>({
        set (t) {
            var { draggable: r, contentEditable: o, styleEditable: l, resizable: i } = t, n = $49a608c5489d744c$var$__rest(t, [
                "draggable",
                "contentEditable",
                "styleEditable",
                "resizable"
            ]);
            void 0 !== r && (0, module.exports.forEveryChild)(e, (e)=>{
                e.set({
                    draggable: r
                });
            }), void 0 !== o && (0, module.exports.forEveryChild)(e, (e)=>{
                e.set({
                    contentEditable: o
                });
            }), void 0 !== l && (0, module.exports.forEveryChild)(e, (e)=>{
                e.set({
                    styleEditable: l
                });
            }), void 0 !== i && (0, module.exports.forEveryChild)(e, (e)=>{
                e.set({
                    resizable: i
                });
            }), Object.assign(e, n);
        },
        addElement (t, { skipSelect: r = !1 } = {}) {
            const o = module.exports.TYPES_MAP[t.type];
            if (!o) return void console.error("Can not find model with type " + t.type);
            t.children && t.children.forEach((e)=>{
                e.id = (0, $aQPnZ.nanoid)(10);
            });
            const l = o.create(Object.assign({
                id: (0, $aQPnZ.nanoid)(10)
            }, t));
            return e.children.push(l), l.selectable && !r && e.store.selectElements([
                l.id
            ]), l;
        },
        setElementZIndex (t, r) {
            const o = e.children.find((e)=>e.id === t);
            o && (console.log({
                zIndex: r
            }), (0, $58B0H.detach)(o), e.children.remove(o), e.children.splice(r, 0, o));
        }
    }));
const $49a608c5489d744c$var$ADDITIONAL_TYPES = [];
function $49a608c5489d744c$var$registerShapeModel(e, t) {
    const r = e.type;
    if (!r) throw new Error('You must pass "type" attribute to custom model.');
    let o = $lfvTK.Shape.named(r).props(e);
    t && (o = t(o)), module.exports.TYPES_MAP[r] = o, $49a608c5489d744c$var$ADDITIONAL_TYPES.push(o);
}
module.exports.TYPES_MAP = {
    svg: $j92iZ.SVGElement,
    text: $dPiE9.TextElement,
    image: $cgQqz.ImageElement,
    group: module.exports.GroupElement,
    line: $atkrP.LineElement,
    video: $btOWX.VideoElement,
    figure: $bjsE3.FigureElement
}, module.exports.registerShapeModel = $49a608c5489d744c$var$registerShapeModel;

});
parcelRegister("aQPnZ", function(module, exports) {

$parcel$export(module.exports, "nanoid", () => $7e669edeb7a3f946$export$ac4959f4f1338dfc);

var $58lla = parcelRequire("58lla");
let $7e669edeb7a3f946$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let $7e669edeb7a3f946$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
    let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    let step = -~(1.6 * mask * defaultSize / alphabet.length);
    return (size = defaultSize)=>{
        let id = "";
        while(true){
            let bytes = getRandom(step);
            let j = step;
            while(j--){
                id += alphabet[bytes[j] & mask] || "";
                if (id.length === size) return id;
            }
        }
    };
};
let $7e669edeb7a3f946$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$7e669edeb7a3f946$export$a5cee9e955a615e5(alphabet, size, $7e669edeb7a3f946$export$4385e60b38654f68);
let $7e669edeb7a3f946$export$ac4959f4f1338dfc = (size = 21)=>crypto.getRandomValues(new Uint8Array(size)).reduce((id, byte)=>{
        byte &= 63;
        if (byte < 36) id += byte.toString(36);
        else if (byte < 62) id += (byte - 26).toString(36).toUpperCase();
        else if (byte > 62) id += "-";
        else id += "_";
        return id;
    }, "");

});
parcelRegister("58lla", function(module, exports) {
let $3bce40defd566837$export$2b646eea95309f00 = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";

});


parcelRegister("9xvfK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.Node = void 0;

var $58B0H = parcelRequire("58B0H");

var $aQPnZ = parcelRequire("aQPnZ");

var $kBxKd = parcelRequire("kBxKd");

var $10zrZ = parcelRequire("10zrZ");

var $6k1PQ = parcelRequire("6k1PQ");
module.exports.Node = $58B0H.types.model("Node", {
    id: $58B0H.types.identifier,
    type: "none",
    name: "",
    opacity: 1,
    custom: $58B0H.types.frozen(),
    visible: !0,
    selectable: !0,
    removable: !0,
    alwaysOnTop: !1,
    showInExport: !0
}).preProcessSnapshot((e)=>{
    for(var t in e)null === e[t] && (e[t] = void 0);
    return e;
}).postProcessSnapshot((e)=>{
    const t = Object.assign({}, e), o = {};
    for(var r in t)"_" !== r[0] && (o[r] = e[r]);
    return o;
}).views((e)=>({
        get locked () {
            return !(e.draggable || e.contentEditable || e.styleEditable || e.resizable);
        },
        get page () {
            return (0, $58B0H.getParentOfType)(e, $10zrZ.Page);
        },
        get store () {
            return (0, $58B0H.getParentOfType)(e, $kBxKd.Store);
        },
        get top () {
            let t = e;
            for(;;){
                if (!(0, $58B0H.hasParentOfType)(t, $6k1PQ.GroupElement)) return t;
                t = (0, $58B0H.getParentOfType)(t, $6k1PQ.GroupElement);
            }
        },
        get parent () {
            return (0, $58B0H.hasParentOfType)(e, $6k1PQ.GroupElement) ? (0, $58B0H.getParentOfType)(e, $6k1PQ.GroupElement) : (0, $58B0H.hasParentOfType)(e, $10zrZ.Page) ? (0, $58B0H.getParentOfType)(e, $10zrZ.Page) : (0, $58B0H.hasParentOfType)(e, $kBxKd.Store) ? (0, $58B0H.getParentOfType)(e, $kBxKd.Store) : null;
        },
        get zIndex () {
            return e.parent.children.indexOf(e);
        }
    })).actions((e)=>({
        toJSON: ()=>Object.assign({}, (0, $58B0H.getSnapshot)(e))
    })).actions((e)=>({
        clone (t = {}, { skipSelect: o = !1 } = {}) {
            const r = JSON.parse(JSON.stringify(e.toJSON()));
            return t.id = t.id || (0, $aQPnZ.nanoid)(10), (0, $6k1PQ.forEveryChild)(r, (e)=>{
                e.id = (0, $aQPnZ.nanoid)(10);
            }), Object.assign(r, t), e.page.addElement(r, {
                skipSelect: o
            });
        },
        set (t) {
            Object.assign(e, t);
        },
        moveUp () {
            e.page.moveElementsUp([
                e.id
            ]);
        },
        moveTop () {
            e.page.moveElementsTop([
                e.id
            ]);
        },
        moveDown () {
            e.page.moveElementsDown([
                e.id
            ]);
        },
        moveBottom () {
            e.page.moveElementsBottom([
                e.id
            ]);
        },
        setZIndex (t) {
            e.parent.setElementZIndex(e.id, t);
        },
        beforeDestroy () {}
    }));

});
parcelRegister("kBxKd", function(module, exports) {
"use strict";
var $f001704b07bcdbd8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(e, t, i, a) {
    void 0 === a && (a = i);
    var o = Object.getOwnPropertyDescriptor(t, i);
    o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
        enumerable: !0,
        get: function() {
            return t[i];
        }
    }), Object.defineProperty(e, a, o);
} : function(e, t, i, a) {
    void 0 === a && (a = i), e[a] = t[i];
}), $f001704b07bcdbd8$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(e, t) {
    Object.defineProperty(e, "default", {
        enumerable: !0,
        value: t
    });
} : function(e, t) {
    e.default = t;
}), $f001704b07bcdbd8$var$__importStar = module.exports && module.exports.__importStar || function(e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for(var i in e)"default" !== i && Object.prototype.hasOwnProperty.call(e, i) && $f001704b07bcdbd8$var$__createBinding(t, e, i);
    return $f001704b07bcdbd8$var$__setModuleDefault(t, e), t;
}, $f001704b07bcdbd8$var$__rest = module.exports && module.exports.__rest || function(e, t) {
    var i = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (i[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;
        for(a = Object.getOwnPropertySymbols(e); o < a.length; o++)t.indexOf(a[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[o]) && (i[a[o]] = e[a[o]]);
    }
    return i;
}, $f001704b07bcdbd8$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.createStore = module.exports.Store = module.exports.Font = void 0;

var $58B0H = parcelRequire("58B0H");

var $arKXl = parcelRequire("arKXl");

var $aQPnZ = parcelRequire("aQPnZ");

const $f001704b07bcdbd8$var$konva_1 = $f001704b07bcdbd8$var$__importDefault((parcelRequire("ciNAD")));

var $k1Pfl = parcelRequire("k1Pfl");

var $2Lkr1 = parcelRequire("2Lkr1");

var $h8tVe = parcelRequire("h8tVe");

var $8PUQD = parcelRequire("8PUQD");

const $f001704b07bcdbd8$var$fonts = $f001704b07bcdbd8$var$__importStar((parcelRequire("iPHWg")));

var $l4lre = parcelRequire("l4lre");

var $7ZydS = parcelRequire("7ZydS");

var $3VySl = parcelRequire("3VySl");

var $aMp8g = parcelRequire("aMp8g");

var $cneqt = parcelRequire("cneqt");

var $e8Ns6 = parcelRequire("e8Ns6");

var $10zrZ = parcelRequire("10zrZ");

var $6k1PQ = parcelRequire("6k1PQ");
function $f001704b07bcdbd8$var$createStore({ key: e, showCredit: t } = {
    key: "",
    showCredit: !1
}) {
    const i = module.exports.Store.create();
    return (0, $8PUQD.validateKey)(e, t), i;
}
(0, $58B0H.setLivelinessChecking)("ignore"), module.exports.Font = $58B0H.types.model("Font", {
    fontFamily: $58B0H.types.string,
    url: $58B0H.types.optional($58B0H.types.string, ""),
    styles: $58B0H.types.frozen()
}).preProcessSnapshot((e)=>Object.assign(Object.assign({}, e), {
        fontFamily: e.fontFamily || e.name
    })), module.exports.Store = $58B0H.types.model("Store", {
    role: "",
    pages: $58B0H.types.array($10zrZ.Page),
    fonts: $58B0H.types.array(module.exports.Font),
    width: 1080,
    height: 1080,
    currentTime: 0,
    isPlaying: !1,
    scale: 1,
    scaleToFit: 1,
    unit: "px",
    dpi: 72,
    bleedVisible: !1,
    rulesVisible: !1,
    openedSidePanel: "",
    previousOpenedSidePanel: "",
    custom: $58B0H.types.frozen(),
    selectedElementsIds: $58B0H.types.array($58B0H.types.string),
    animatedElementsIds: $58B0H.types.array($58B0H.types.string),
    history: $58B0H.types.optional($arKXl.UndoManager, {
        targetPath: "../pages"
    }),
    _elementsPixelRatio: 2,
    _activePageId: ""
}).views((e)=>({
        get _bleedVisible () {
            return console.warn("store._bleedVisible is deprecated. Please use store.bleedVisible instead."), e.bleedVisible;
        },
        get selectedElements () {
            return e.selectedElementsIds.map((t)=>{
                for (const i of e.pages)for (const e of i.children)if (e.id === t) return e;
            }).filter((e)=>!!e);
        },
        get children () {
            return e.pages;
        },
        get selectedShapes () {
            const t = [];
            return (0, $6k1PQ.forEveryChild)({
                children: e.selectedElements
            }, (e)=>{
                "group" !== e.type && t.push(e);
            }), t;
        },
        get activePage () {
            return e.pages.slice().find((t)=>t.id === e._activePageId) || (e.pages.length ? e.pages[0] : null);
        },
        get duration () {
            let t = 0;
            return e.pages.forEach((e)=>{
                t += e.duration;
            }), t;
        },
        get _hasCroppedImages () {
            return e.find((e)=>"image" === e.type && e._cropModeEnabled);
        },
        find (t) {
            let i;
            return (0, $6k1PQ.forEveryChild)({
                children: e.pages
            }, (e)=>{
                if (!i && t(e)) return i = e, !0;
            }), i;
        },
        getElementById: (t)=>e.find((e)=>e.id === t)
    })).actions((e)=>{
    let t = 0, i = null, a = !1;
    return {
        afterCreate () {
            e.history.canUndo;
        },
        setCurrentTime (t) {
            e.currentTime = t;
        },
        play ({ animatedElementsIds: o = [], startTime: n = 0, currentTime: s = 0, endTime: r = e.duration, repeat: l = !1 } = {}) {
            s && (console.warn("currentTime property of store.play() is deprecated. Please use startTime instead."), n = s), e.animatedElementsIds = (0, $58B0H.cast)(o), e.currentTime = n, e.isPlaying = !0, t = Date.now(), i = r, a = l, requestAnimationFrame(e.seek);
        },
        checkActivePage () {
            let t = 0;
            for (const i of e.pages){
                if (e.currentTime >= i.startTime && e.currentTime < i.startTime + i.duration) {
                    e.selectPage(i.id);
                    break;
                }
                t += i.duration;
            }
        },
        seek () {
            if (!e.isPlaying) return;
            const o = Date.now(), n = o - t;
            t = o, e.currentTime += n, e.checkActivePage();
            const s = i || e.duration;
            e.isPlaying && e.currentTime < s ? requestAnimationFrame(e.seek) : e.isPlaying && a ? (e.currentTime = 0, requestAnimationFrame(e.seek)) : e.stop();
        },
        stop () {
            e.isPlaying = !1, e.currentTime = 0, e.animatedElementsIds = (0, $58B0H.cast)([]), e.checkActivePage();
        }
    };
}).actions((e)=>({
        set (t) {
            Object.assign(e, t);
        },
        setUnit ({ unit: t, dpi: i }) {
            e.unit = t || e.unit, e.dpi = i || e.dpi;
        },
        setRole (t) {
            e.role = t;
        },
        addPage (t) {
            const i = $10zrZ.Page.create(Object.assign({
                id: (0, $aQPnZ.nanoid)(10)
            }, t));
            return e.pages.push(i), e._activePageId = i.id, i;
        },
        selectPage (t) {
            e._activePageId = t;
        },
        selectElements (t) {
            const i = t.map((t)=>e.getElementById(t)).sort((e, t)=>e.page.children.indexOf(e) - e.page.children.indexOf(t)).filter((e)=>!!e).map((e)=>e.id);
            e.selectedElementsIds = (0, $58B0H.cast)(i);
        },
        toggleBleed (t) {
            e.bleedVisible = null != t ? t : !e.bleedVisible;
        },
        toggleRulers (t) {
            e.rulesVisible = null != t ? t : !e.rulesVisible;
        },
        openSidePanel (t) {
            e.openedSidePanel !== t && (e.previousOpenedSidePanel = e.openedSidePanel, e.openedSidePanel = t);
        },
        setScale (t) {
            e.scale = t;
        },
        _setScaleToFit (t) {
            e.scaleToFit = t;
        },
        setElementsPixelRatio (t) {
            e._elementsPixelRatio = t;
        },
        setSize (t, i, a) {
            e.pages.forEach((e)=>{
                e.setSize({
                    width: t,
                    height: i,
                    useMagic: a,
                    softChange: !0
                });
            }), e.width = t, e.height = i;
        },
        setPageZIndex (t, i) {
            const a = e.pages.find((e)=>e.id === t);
            a && ((0, $58B0H.detach)(a), e.pages.remove(a), e.pages.splice(i, 0, a));
        },
        deletePages (t) {
            const i = e.pages.indexOf(e.activePage);
            t.forEach((t)=>{
                const i = e.pages.find((e)=>e.id === t);
                (0, $58B0H.destroy)(i);
            });
            const a = Math.min(e.pages.length - 1, i), o = e.pages[a];
            o && (e._activePageId = o.id), e.selectedElementsIds = (0, $58B0H.cast)(e.selectedElementsIds.filter((t)=>e.getElementById(t)));
        },
        groupElements (t) {
            const i = t.map((t)=>e.getElementById(t));
            i.forEach((e)=>{
                e && (0, $58B0H.detach)(e);
            });
            const a = e.activePage, o = {
                id: (0, $aQPnZ.nanoid)(10),
                children: i,
                type: "group"
            };
            return a.children.push(o), e.selectedElementsIds = (0, $58B0H.cast)([
                o.id
            ]), o;
        },
        ungroupElements (t) {
            const i = t.map((t)=>e.getElementById(t)), a = [];
            i.forEach((e)=>{
                if (e && "group" === e.type) {
                    const t = e.page, i = t.children.indexOf(e);
                    e.children.forEach((e)=>{
                        a.push(e.id);
                    }), e.children.forEach((e)=>{
                        (0, $58B0H.detach)(e), t.children.push(e);
                    }), t.children.splice(i, 1);
                }
            }), e.selectedElementsIds = (0, $58B0H.cast)(a);
        },
        deleteElements (t) {
            const i = [];
            e.find((e)=>(t.includes(e.id) && i.push(e), !1)), i.forEach((e)=>{
                (0, $58B0H.destroy)(e);
            }), e.selectedElementsIds = (0, $58B0H.cast)(e.selectedElementsIds.filter((t)=>e.getElementById(t)));
        },
        on (t, i) {
            if ("change" === t) {
                let t = e.toJSON();
                return (0, $58B0H.onSnapshot)(e, (a)=>{
                    const o = e.toJSON();
                    !(0, $3VySl.deepEqual)(t, o) && (t = o, i(o));
                });
            }
        },
        async _toCanvas ({ pixelRatio: t, ignoreBackground: i, pageId: a, mimeType: o, includeBleed: n, _skipTimeout: s } = {}) {
            var r;
            const l = t || 1;
            a = a || (null === (r = e.pages[0]) || void 0 === r ? void 0 : r.id);
            const d = e.pages.find((e)=>e.id === a);
            if (!d) throw new Error(`No page for export with id ${a}`);
            null == d || d.set({
                _exporting: !0
            });
            const c = await (0, $aMp8g.waitTillAvailable)(()=>$f001704b07bcdbd8$var$konva_1.default.stages.find((e)=>e.getAttr("pageId") === a));
            if (!c) throw new Error(`Export is failed. Can not find stage for page ${a}. Looks like <Workspace /> component is not mounted, but it is required in order to process the export.`);
            const p = !!c.findOne(".page-container"), u = e._elementsPixelRatio;
            l > e._elementsPixelRatio && e.setElementsPixelRatio(l), await e.waitLoading({
                _skipTimeout: s
            });
            const _ = c.findOne(".page-container");
            if (!_) throw e.setElementsPixelRatio(u), new Error(`Export is failed. Can't find page container. ${p}`);
            c.find("Transformer").forEach((e)=>e.visible(!1)), _.find(".page-background").forEach((e)=>e.shadowEnabled(!1)), _.find(".page-background").forEach((e)=>e.strokeEnabled(!1)), _.find(".highlighter").forEach((e)=>e.visible(!1));
            const g = _.findOne(".page-background-group"), m = g.clip();
            g.clip({
                x: null,
                y: null,
                width: null,
                height: null
            });
            const f = _.findOne(".elements-container"), h = f.clip();
            f.clip({
                x: null,
                y: null,
                width: null,
                height: null
            });
            const b = _.find((e)=>e.getAttr("hideInExport"));
            b.forEach((e)=>{
                e.setAttr("oldVisible", e.visible()), e.hide();
            });
            const y = _.find((e)=>!e.visible() && e.getAttr("editModeEnabled"));
            y.forEach((e)=>{
                e.setAttr("oldVisible", e.visible()), e.show();
            }), i && _.find(".page-background").forEach((e)=>e.hide());
            const v = n ? d.bleed : 0;
            let x = v;
            !e.bleedVisible && n || (e.bleedVisible || n ? e.bleedVisible && n ? x = 0 : e.bleedVisible && !n && (x = -d.bleed) : x = 0);
            const w = document.createElement("canvas");
            w.width = Math.round((d.computedWidth + 2 * v) * l), w.height = Math.round((d.computedHeight + 2 * v) * l);
            const E = w.getContext("2d");
            "image/jpeg" === o && (E.fillStyle = "white", E.fillRect(0, 0, w.width, w.height));
            const P = _.scale();
            _.scale({
                x: 1,
                y: 1
            });
            const O = _.toCanvas({
                x: _.x() - x,
                y: _.y() - x,
                width: d.computedWidth + 2 * v,
                height: d.computedHeight + 2 * v,
                pixelRatio: l
            });
            return _.scale(P), E.drawImage(O, 0, 0, w.width, w.height), $f001704b07bcdbd8$var$konva_1.default.Util.releaseCanvas(O), i && _.find(".page-background").forEach((e)=>e.show()), b.forEach((e)=>{
                e.visible(e.getAttr("oldVisible"));
            }), y.forEach((e)=>{
                e.visible(e.getAttr("oldVisible"));
            }), _.find(".page-background").forEach((e)=>e.shadowEnabled(!0)), _.find(".page-background").forEach((e)=>e.strokeEnabled(!0)), c.find("Transformer").forEach((e)=>e.visible(!0)), _.find(".highlighter").forEach((e)=>e.visible(!0)), g.clip(m), f.clip(h), e.setElementsPixelRatio(u), null == d || d.set({
                _exporting: !1
            }), w;
        },
        async toDataURL (t = {}) {
            var { mimeType: i, quality: a } = t, o = $f001704b07bcdbd8$var$__rest(t, [
                "mimeType",
                "quality"
            ]);
            const n = await e._toCanvas(Object.assign({
                mimeType: i
            }, o)), s = n.toDataURL(i, a);
            return $f001704b07bcdbd8$var$konva_1.default.Util.releaseCanvas(n), s;
        },
        async toBlob (t = {}) {
            var { mimeType: i, quality: a } = t, o = $f001704b07bcdbd8$var$__rest(t, [
                "mimeType",
                "quality"
            ]);
            const n = await e._toCanvas(Object.assign({
                mimeType: i
            }, o)), s = new Promise((e)=>{
                n.toBlob(e, i, a);
            });
            return $f001704b07bcdbd8$var$konva_1.default.Util.releaseCanvas(n), s;
        },
        async saveAsImage (t = {}) {
            var { fileName: i } = t, a = $f001704b07bcdbd8$var$__rest(t, [
                "fileName"
            ]);
            const o = a.mimeType || "image/png", n = o.split("/")[1];
            (0, $k1Pfl.downloadFile)(await e.toDataURL(a), i || "polotno." + n, o);
        },
        async _toPDF (t) {
            const i = t.dpi || e.dpi, a = t.parallel || 1, o = t.unit || ("px" === e.unit ? "mm" : e.unit), n = t.pixelRatio || 1, s = t.pageIds || e.pages.map((e)=>e.id), r = e.pages.filter((e)=>s.includes(e.id)), l = await (0, $2Lkr1.getJsPDF)(), d = (e)=>(0, $7ZydS.pxToUnit)({
                    px: e,
                    unit: o,
                    dpi: i
                }), c = d(t.cropMarkSize || 0), p = r[0] || {}, u = t.includeBleed ? p.bleed : 0, _ = d(p.computedWidth + 2 * u) + 2 * c, g = d(p.computedHeight + 2 * u) + 2 * c;
            var m = new l({
                unit: o,
                orientation: _ > g ? "landscape" : "portrait",
                format: [
                    _,
                    g
                ],
                compress: !0,
                putOnlyUsedFonts: !0
            });
            m.deletePage(1);
            const f = ((e, t)=>{
                for(var i = [], a = 0; a < e.length; a += t)i.push(e.slice(a, a + t));
                return i;
            })(r, a);
            for (const i of f){
                const a = i.map(async (i)=>{
                    const a = t.includeBleed ? i.bleed : 0, o = d(i.computedWidth + 2 * a) + 2 * c, s = d(i.computedHeight + 2 * a) + 2 * c;
                    let r = 0, l = n;
                    for(; r < 10;){
                        r += 1, 2 === r && console.error("Polotno can not export PDF with current settings. Quality is automatically reduced.");
                        const a = await e.toDataURL(Object.assign(Object.assign({}, t), {
                            pageId: i.id,
                            pixelRatio: l
                        }));
                        if (a.length > 20) return {
                            url: a,
                            width: o,
                            height: s
                        };
                        l *= .8;
                    }
                });
                (await Promise.all(a)).forEach(({ url: e, width: t, height: i })=>{
                    m.addPage([
                        t,
                        i
                    ], t > i ? "landscape" : "portrait"), c && (m.setLineWidth(d(1)), m.line(2 * c, 0, 2 * c, c), m.line(0, 2 * c, c, 2 * c), m.line(t - 2 * c, 0, t - 2 * c, c), m.line(t, 2 * c, t - c, 2 * c), m.line(0, i - 2 * c, c, i - 2 * c), m.line(2 * c, i, 2 * c, i - c), m.line(t, i - 2 * c, t - c, i - 2 * c), m.line(t - 2 * c, i, t - 2 * c, i - c)), m.addImage(e, c, c, t - 2 * c, i - 2 * c, void 0, "FAST");
                });
            }
            return m;
        },
        toPDFDataURL: async (t)=>(await e._toPDF(Object.assign({
                mimeType: "image/jpeg"
            }, t))).output("datauristring"),
        async toGIFDataURL (t = {}) {
            const i = t.pixelRatio || 1, a = await (0, $h8tVe.createGIF)({
                width: e.width * i,
                height: e.height * i
            }), o = 1e3 / (t.fps || 10), n = e.duration / o;
            for(let t = 0; t < n - 1; t++){
                const n = t * o || 1;
                e.setCurrentTime(n);
                let s = 0, r = "";
                for (const t of e.pages)if (s += t.duration, t.set({
                    _rendering: s > n
                }), s > n) {
                    r = t.id;
                    break;
                }
                const l = await e._toCanvas({
                    pixelRatio: i,
                    pageId: r,
                    _skipTimeout: !0
                });
                a.addFrame(l.getContext("2d"), {
                    delay: o,
                    copy: !0
                });
            }
            for (const t of e.pages)t.set({
                _rendering: !1
            });
            e.stop(), a.render();
            return new Promise((e)=>{
                a.on("finished", function(t) {
                    !function(e, t) {
                        var i = new FileReader;
                        i.onload = function(e) {
                            t(e.target.result);
                        }, i.readAsDataURL(e);
                    }(t, e);
                });
            });
        },
        async saveAsGIF (t = {}) {
            var { fileName: i } = t, a = $f001704b07bcdbd8$var$__rest(t, [
                "fileName"
            ]);
            const o = await e.toGIFDataURL(a);
            (0, $k1Pfl.downloadFile)(o, i || "polotno.gif");
        },
        async toHTML ({ elementHook: t } = {
            elementHook: void 0
        }) {
            const i = e.toJSON();
            return (0, $cneqt.jsonToHTML)({
                json: i,
                elementHook: t
            });
        },
        async saveAsHTML ({ fileName: t } = {}) {
            const i = await e.toHTML(), a = "data:text/html;base64," + window.btoa(unescape(encodeURIComponent(i)));
            (0, $k1Pfl.downloadFile)(a, t || "polotno.html");
        },
        async toSVG () {
            const t = e.toJSON();
            return (0, $e8Ns6.jsonToSVG)({
                json: t
            });
        },
        async saveAsSVG ({ fileName: t } = {}) {
            const i = await e.toSVG(), a = "data:text/svg;base64," + window.btoa(unescape(encodeURIComponent(i)));
            (0, $k1Pfl.downloadFile)(a, t || "polotno.svg");
        },
        async saveAsPDF (t = {}) {
            var { fileName: i } = t, a = $f001704b07bcdbd8$var$__rest(t, [
                "fileName"
            ]);
            (await e._toPDF(Object.assign({
                mimeType: "image/jpeg"
            }, a))).save(i || "polotno.pdf");
        },
        async waitLoading ({ _skipTimeout: e = !1 } = {}) {
            e || await new Promise((e)=>setTimeout(e, 50)), await (0, $l4lre.whenLoaded)();
        },
        toJSON: ()=>({
                width: e.width,
                height: e.height,
                fonts: (0, $58B0H.getSnapshot)(e.fonts),
                pages: (0, $58B0H.getSnapshot)(e.pages),
                unit: e.unit,
                dpi: e.dpi,
                custom: e.custom
            }),
        loadJSON (t, i = !1) {
            var a;
            const o = Object.assign({}, t), n = e.pages.indexOf(e.activePage);
            let s = null === (a = o.pages[n] || o.pages[0]) || void 0 === a ? void 0 : a.id;
            o._activePageId = s;
            const r = Object.assign({}, (0, $58B0H.getSnapshot)(e));
            Object.assign(r, o), r.history = i ? e.history.toJSON() : {
                history: [],
                undoIdx: -1
            }, (0, $58B0H.applySnapshot)(e, r);
        },
        clear ({ keepHistory: t = !1 } = {}) {
            const i = e.pages.map((e)=>e.id);
            e.deletePages(i), t || e.history.clear();
        },
        addFont (t) {
            e.removeFont(t.fontFamily), e.fonts.push(t), e.loadFont(t.fontFamily);
        },
        removeFont (t) {
            e.fonts.filter((e)=>e.fontFamily === t).forEach((e)=>(0, $58B0H.destroy)(e));
        },
        async loadFont (t) {
            const i = e.fonts.find((e)=>e.fontFamily === t) || $f001704b07bcdbd8$var$fonts.globalFonts.find((e)=>e.fontFamily === t);
            i ? $f001704b07bcdbd8$var$fonts.injectCustomFont(i) : $f001704b07bcdbd8$var$fonts.injectGoogleFont(t), await $f001704b07bcdbd8$var$fonts.loadFont(t);
        },
        validate: (e)=>module.exports.Store.validate(e, [
                {
                    path: "",
                    type: module.exports.Store
                }
            ]).map((e)=>({
                    path: "store" + e.context.map((e)=>e.path).join("."),
                    message: e.message
                }))
    })), module.exports.createStore = $f001704b07bcdbd8$var$createStore, module.exports.default = $f001704b07bcdbd8$var$createStore;

});
parcelRegister("arKXl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.UndoManager = void 0;

var $58B0H = parcelRequire("58B0H");

var $3VySl = parcelRequire("3VySl");
Object.assign($58B0H.types), module.exports.UndoManager = $58B0H.types.model("UndoManager", {
    history: $58B0H.types.array($58B0H.types.frozen()),
    undoIdx: -1,
    targetPath: ""
}).views((e)=>({
        get canUndo () {
            return e.undoIdx > 0;
        },
        get canRedo () {
            return e.undoIdx < e.history.length - 1;
        }
    })).actions((e)=>{
    let t, o, a = !1, r = null, n = 0, s = 0;
    const d = ()=>s > 0;
    function i() {
        const e = (0, $58B0H.getSnapshot)(t);
        return {
            pages: e.pages,
            width: e.width,
            height: e.height
        };
    }
    function h(e) {
        const o = t.pages.map((e)=>e.id), a = e.pages.map((e)=>e.id);
        !(0, $3VySl.deepEqual)(o, a) ? (0, $58B0H.applySnapshot)(t.pages, e.pages) : t.pages.forEach((t, o)=>{
            (0, $58B0H.applySnapshot)(t, e.pages[o]);
        }), t.setSize(e.width, e.height);
    }
    return {
        startTransaction () {
            s++;
        },
        endTransaction (e) {
            s--, e || this.requestAddState(i());
        },
        async ignore (t, o = !1, a = !1) {
            a && await new Promise((e)=>setTimeout(e, 10)), n && e.addUndoState();
            let r = d();
            e.startTransaction();
            let i = s;
            try {
                await t();
            } catch (e) {
                setTimeout(()=>{
                    throw e;
                });
            }
            const h = i !== s, u = !h;
            e.endTransaction(u), o || r || e.replaceState(), h || (clearTimeout(n), n = 0);
        },
        async transaction (t) {
            await e.ignore(t, !0), this.addUndoState();
        },
        requestAddState (e) {
            r = e, n || d() || (a ? a = !1 : n = setTimeout(()=>{
                n = 0, clearTimeout(n), d() || this.addUndoState();
            }, 100));
        },
        addUndoState () {
            if (a) return void (a = !1);
            const t = e.history[e.undoIdx];
            !(0, $3VySl.deepEqual)(r, t) && (clearTimeout(n), n = 0, e.history.splice(e.undoIdx + 1), e.history.push(r), e.undoIdx = e.history.length - 1);
        },
        afterCreate () {
            if (t = (0, $58B0H.resolvePath)(e, ".."), !t) throw new Error("Failed to find target store for UndoManager. Please provide `targetPath` property, or a `targetStore` in the environment");
            o = (0, $58B0H.onSnapshot)(t, ()=>{
                this.requestAddState(i());
            }), 0 === e.history.length && this.requestAddState(i());
        },
        clear () {
            clearTimeout(n), n = 0, e.history.splice(0, e.history.length), e.undoIdx = -1, e.addUndoState(i());
        },
        beforeDestroy () {
            o();
        },
        undo () {
            n && this.addUndoState(), e.canUndo ? (e.undoIdx--, a = !0, h(e.history[e.undoIdx])) : console.warn("No undo history. Please check `store.history.canUndo` before calling undo action.");
        },
        redo () {
            n && this.addUndoState(), e.canRedo ? (e.undoIdx++, a = !0, h(e.history[e.undoIdx])) : console.warn("No redo history. Please check `store.history.canRedo` before calling redo action.");
        },
        replaceState () {
            e.history[e.undoIdx] = i();
        }
    };
}), module.exports.default = module.exports.UndoManager;

});
parcelRegister("3VySl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.deepEqual = void 0;
const $2dc1bf8baec73a25$var$deepEqual = function(e, t) {
    if (e === t) return !0;
    if ("object" == typeof e && null != e && "object" == typeof t && null != t) {
        if (Object.keys(e).length != Object.keys(t).length) return !1;
        for(var r in e){
            if (!t.hasOwnProperty(r)) return !1;
            if (!(0, module.exports.deepEqual)(e[r], t[r])) return !1;
        }
        return !0;
    }
    return !1;
};
module.exports.deepEqual = $2dc1bf8baec73a25$var$deepEqual;

});


parcelRegister("k1Pfl", function(module, exports) {
"use strict";
async function $e94ba721178f3466$var$downloadFile(e, o) {
    const t = await (await fetch(e)).blob(), d = document.createElement("a"), n = URL.createObjectURL(t);
    d.href = n, d.download = o, document.body.appendChild(d), d.click(), setTimeout(function() {
        document.body.removeChild(d), window.URL.revokeObjectURL(n);
    }, 0);
}
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.downloadFile = void 0, module.exports.downloadFile = $e94ba721178f3466$var$downloadFile;

});

parcelRegister("2Lkr1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.getJsPDF = void 0;
const $202fd27af4672290$var$url = "https://unpkg.com/jspdf@2.2.0/dist/jspdf.umd.min.js";
let $202fd27af4672290$var$jsPDF;
function $202fd27af4672290$var$getJsPDF() {
    return $202fd27af4672290$var$jsPDF ? Promise.resolve($202fd27af4672290$var$jsPDF) : new Promise((e)=>{
        var s = document.createElement("script");
        s.onload = function() {
            $202fd27af4672290$var$jsPDF = window.jspdf.jsPDF, e($202fd27af4672290$var$jsPDF);
        }, s.src = $202fd27af4672290$var$url, document.head.appendChild(s);
    });
}
module.exports.getJsPDF = $202fd27af4672290$var$getJsPDF;

});

parcelRegister("h8tVe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.createGIF = module.exports.getGIF = void 0;
const $c79a64f3a60c742f$var$url = "https://cdnjs.cloudflare.com/ajax/libs/gif.js/0.2.0/gif.js";
function $c79a64f3a60c742f$var$getGIF() {
    return window.GIF ? Promise.resolve(window.GIF) : new Promise((t)=>{
        var e = document.createElement("script");
        e.onload = function() {
            t(window.GIF);
        }, e.src = $c79a64f3a60c742f$var$url, document.head.appendChild(e);
    });
}
async function $c79a64f3a60c742f$var$createGIF({ width: t, height: e }) {
    return new (await $c79a64f3a60c742f$var$getGIF())({
        workers: 4,
        width: t,
        height: e,
        workerScript: URL.createObjectURL(new Blob([
            '// gif.worker.js 0.2.0 - https://github.com/jnordberg/gif.js\n  (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module \'"+o+"\'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){var NeuQuant=require("./TypedNeuQuant.js");var LZWEncoder=require("./LZWEncoder.js");function ByteArray(){this.page=-1;this.pages=[];this.newPage()}ByteArray.pageSize=4096;ByteArray.charMap={};for(var i=0;i<256;i++)ByteArray.charMap[i]=String.fromCharCode(i);ByteArray.prototype.newPage=function(){this.pages[++this.page]=new Uint8Array(ByteArray.pageSize);this.cursor=0};ByteArray.prototype.getData=function(){var rv="";for(var p=0;p<this.pages.length;p++){for(var i=0;i<ByteArray.pageSize;i++){rv+=ByteArray.charMap[this.pages[p][i]]}}return rv};ByteArray.prototype.writeByte=function(val){if(this.cursor>=ByteArray.pageSize)this.newPage();this.pages[this.page][this.cursor++]=val};ByteArray.prototype.writeUTFBytes=function(string){for(var l=string.length,i=0;i<l;i++)this.writeByte(string.charCodeAt(i))};ByteArray.prototype.writeBytes=function(array,offset,length){for(var l=length||array.length,i=offset||0;i<l;i++)this.writeByte(array[i])};function GIFEncoder(width,height){this.width=~~width;this.height=~~height;this.transparent=null;this.transIndex=0;this.repeat=-1;this.delay=0;this.image=null;this.pixels=null;this.indexedPixels=null;this.colorDepth=null;this.colorTab=null;this.neuQuant=null;this.usedEntry=new Array;this.palSize=7;this.dispose=-1;this.firstFrame=true;this.sample=10;this.dither=false;this.globalPalette=false;this.out=new ByteArray}GIFEncoder.prototype.setDelay=function(milliseconds){this.delay=Math.round(milliseconds/10)};GIFEncoder.prototype.setFrameRate=function(fps){this.delay=Math.round(100/fps)};GIFEncoder.prototype.setDispose=function(disposalCode){if(disposalCode>=0)this.dispose=disposalCode};GIFEncoder.prototype.setRepeat=function(repeat){this.repeat=repeat};GIFEncoder.prototype.setTransparent=function(color){this.transparent=color};GIFEncoder.prototype.addFrame=function(imageData){this.image=imageData;this.colorTab=this.globalPalette&&this.globalPalette.slice?this.globalPalette:null;this.getImagePixels();this.analyzePixels();if(this.globalPalette===true)this.globalPalette=this.colorTab;if(this.firstFrame){this.writeLSD();this.writePalette();if(this.repeat>=0){this.writeNetscapeExt()}}this.writeGraphicCtrlExt();this.writeImageDesc();if(!this.firstFrame&&!this.globalPalette)this.writePalette();this.writePixels();this.firstFrame=false};GIFEncoder.prototype.finish=function(){this.out.writeByte(59)};GIFEncoder.prototype.setQuality=function(quality){if(quality<1)quality=1;this.sample=quality};GIFEncoder.prototype.setDither=function(dither){if(dither===true)dither="FloydSteinberg";this.dither=dither};GIFEncoder.prototype.setGlobalPalette=function(palette){this.globalPalette=palette};GIFEncoder.prototype.getGlobalPalette=function(){return this.globalPalette&&this.globalPalette.slice&&this.globalPalette.slice(0)||this.globalPalette};GIFEncoder.prototype.writeHeader=function(){this.out.writeUTFBytes("GIF89a")};GIFEncoder.prototype.analyzePixels=function(){if(!this.colorTab){this.neuQuant=new NeuQuant(this.pixels,this.sample);this.neuQuant.buildColormap();this.colorTab=this.neuQuant.getColormap()}if(this.dither){this.ditherPixels(this.dither.replace("-serpentine",""),this.dither.match(/-serpentine/)!==null)}else{this.indexPixels()}this.pixels=null;this.colorDepth=8;this.palSize=7;if(this.transparent!==null){this.transIndex=this.findClosest(this.transparent,true)}};GIFEncoder.prototype.indexPixels=function(imgq){var nPix=this.pixels.length/3;this.indexedPixels=new Uint8Array(nPix);var k=0;for(var j=0;j<nPix;j++){var index=this.findClosestRGB(this.pixels[k++]&255,this.pixels[k++]&255,this.pixels[k++]&255);this.usedEntry[index]=true;this.indexedPixels[j]=index}};GIFEncoder.prototype.ditherPixels=function(kernel,serpentine){var kernels={FalseFloydSteinberg:[[3/8,1,0],[3/8,0,1],[2/8,1,1]],FloydSteinberg:[[7/16,1,0],[3/16,-1,1],[5/16,0,1],[1/16,1,1]],Stucki:[[8/42,1,0],[4/42,2,0],[2/42,-2,1],[4/42,-1,1],[8/42,0,1],[4/42,1,1],[2/42,2,1],[1/42,-2,2],[2/42,-1,2],[4/42,0,2],[2/42,1,2],[1/42,2,2]],Atkinson:[[1/8,1,0],[1/8,2,0],[1/8,-1,1],[1/8,0,1],[1/8,1,1],[1/8,0,2]]};if(!kernel||!kernels[kernel]){throw"Unknown dithering kernel: "+kernel}var ds=kernels[kernel];var index=0,height=this.height,width=this.width,data=this.pixels;var direction=serpentine?-1:1;this.indexedPixels=new Uint8Array(this.pixels.length/3);for(var y=0;y<height;y++){if(serpentine)direction=direction*-1;for(var x=direction==1?0:width-1,xend=direction==1?width:0;x!==xend;x+=direction){index=y*width+x;var idx=index*3;var r1=data[idx];var g1=data[idx+1];var b1=data[idx+2];idx=this.findClosestRGB(r1,g1,b1);this.usedEntry[idx]=true;this.indexedPixels[index]=idx;idx*=3;var r2=this.colorTab[idx];var g2=this.colorTab[idx+1];var b2=this.colorTab[idx+2];var er=r1-r2;var eg=g1-g2;var eb=b1-b2;for(var i=direction==1?0:ds.length-1,end=direction==1?ds.length:0;i!==end;i+=direction){var x1=ds[i][1];var y1=ds[i][2];if(x1+x>=0&&x1+x<width&&y1+y>=0&&y1+y<height){var d=ds[i][0];idx=index+x1+y1*width;idx*=3;data[idx]=Math.max(0,Math.min(255,data[idx]+er*d));data[idx+1]=Math.max(0,Math.min(255,data[idx+1]+eg*d));data[idx+2]=Math.max(0,Math.min(255,data[idx+2]+eb*d))}}}}};GIFEncoder.prototype.findClosest=function(c,used){return this.findClosestRGB((c&16711680)>>16,(c&65280)>>8,c&255,used)};GIFEncoder.prototype.findClosestRGB=function(r,g,b,used){if(this.colorTab===null)return-1;if(this.neuQuant&&!used){return this.neuQuant.lookupRGB(r,g,b)}var c=b|g<<8|r<<16;var minpos=0;var dmin=256*256*256;var len=this.colorTab.length;for(var i=0,index=0;i<len;index++){var dr=r-(this.colorTab[i++]&255);var dg=g-(this.colorTab[i++]&255);var db=b-(this.colorTab[i++]&255);var d=dr*dr+dg*dg+db*db;if((!used||this.usedEntry[index])&&d<dmin){dmin=d;minpos=index}}return minpos};GIFEncoder.prototype.getImagePixels=function(){var w=this.width;var h=this.height;this.pixels=new Uint8Array(w*h*3);var data=this.image;var srcPos=0;var count=0;for(var i=0;i<h;i++){for(var j=0;j<w;j++){this.pixels[count++]=data[srcPos++];this.pixels[count++]=data[srcPos++];this.pixels[count++]=data[srcPos++];srcPos++}}};GIFEncoder.prototype.writeGraphicCtrlExt=function(){this.out.writeByte(33);this.out.writeByte(249);this.out.writeByte(4);var transp,disp;if(this.transparent===null){transp=0;disp=0}else{transp=1;disp=2}if(this.dispose>=0){disp=dispose&7}disp<<=2;this.out.writeByte(0|disp|0|transp);this.writeShort(this.delay);this.out.writeByte(this.transIndex);this.out.writeByte(0)};GIFEncoder.prototype.writeImageDesc=function(){this.out.writeByte(44);this.writeShort(0);this.writeShort(0);this.writeShort(this.width);this.writeShort(this.height);if(this.firstFrame||this.globalPalette){this.out.writeByte(0)}else{this.out.writeByte(128|0|0|0|this.palSize)}};GIFEncoder.prototype.writeLSD=function(){this.writeShort(this.width);this.writeShort(this.height);this.out.writeByte(128|112|0|this.palSize);this.out.writeByte(0);this.out.writeByte(0)};GIFEncoder.prototype.writeNetscapeExt=function(){this.out.writeByte(33);this.out.writeByte(255);this.out.writeByte(11);this.out.writeUTFBytes("NETSCAPE2.0");this.out.writeByte(3);this.out.writeByte(1);this.writeShort(this.repeat);this.out.writeByte(0)};GIFEncoder.prototype.writePalette=function(){this.out.writeBytes(this.colorTab);var n=3*256-this.colorTab.length;for(var i=0;i<n;i++)this.out.writeByte(0)};GIFEncoder.prototype.writeShort=function(pValue){this.out.writeByte(pValue&255);this.out.writeByte(pValue>>8&255)};GIFEncoder.prototype.writePixels=function(){var enc=new LZWEncoder(this.width,this.height,this.indexedPixels,this.colorDepth);enc.encode(this.out)};GIFEncoder.prototype.stream=function(){return this.out};module.exports=GIFEncoder},{"./LZWEncoder.js":2,"./TypedNeuQuant.js":3}],2:[function(require,module,exports){var EOF=-1;var BITS=12;var HSIZE=5003;var masks=[0,1,3,7,15,31,63,127,255,511,1023,2047,4095,8191,16383,32767,65535];function LZWEncoder(width,height,pixels,colorDepth){var initCodeSize=Math.max(2,colorDepth);var accum=new Uint8Array(256);var htab=new Int32Array(HSIZE);var codetab=new Int32Array(HSIZE);var cur_accum,cur_bits=0;var a_count;var free_ent=0;var maxcode;var clear_flg=false;var g_init_bits,ClearCode,EOFCode;function char_out(c,outs){accum[a_count++]=c;if(a_count>=254)flush_char(outs)}function cl_block(outs){cl_hash(HSIZE);free_ent=ClearCode+2;clear_flg=true;output(ClearCode,outs)}function cl_hash(hsize){for(var i=0;i<hsize;++i)htab[i]=-1}function compress(init_bits,outs){var fcode,c,i,ent,disp,hsize_reg,hshift;g_init_bits=init_bits;clear_flg=false;n_bits=g_init_bits;maxcode=MAXCODE(n_bits);ClearCode=1<<init_bits-1;EOFCode=ClearCode+1;free_ent=ClearCode+2;a_count=0;ent=nextPixel();hshift=0;for(fcode=HSIZE;fcode<65536;fcode*=2)++hshift;hshift=8-hshift;hsize_reg=HSIZE;cl_hash(hsize_reg);output(ClearCode,outs);outer_loop:while((c=nextPixel())!=EOF){fcode=(c<<BITS)+ent;i=c<<hshift^ent;if(htab[i]===fcode){ent=codetab[i];continue}else if(htab[i]>=0){disp=hsize_reg-i;if(i===0)disp=1;do{if((i-=disp)<0)i+=hsize_reg;if(htab[i]===fcode){ent=codetab[i];continue outer_loop}}while(htab[i]>=0)}output(ent,outs);ent=c;if(free_ent<1<<BITS){codetab[i]=free_ent++;htab[i]=fcode}else{cl_block(outs)}}output(ent,outs);output(EOFCode,outs)}function encode(outs){outs.writeByte(initCodeSize);remaining=width*height;curPixel=0;compress(initCodeSize+1,outs);outs.writeByte(0)}function flush_char(outs){if(a_count>0){outs.writeByte(a_count);outs.writeBytes(accum,0,a_count);a_count=0}}function MAXCODE(n_bits){return(1<<n_bits)-1}function nextPixel(){if(remaining===0)return EOF;--remaining;var pix=pixels[curPixel++];return pix&255}function output(code,outs){cur_accum&=masks[cur_bits];if(cur_bits>0)cur_accum|=code<<cur_bits;else cur_accum=code;cur_bits+=n_bits;while(cur_bits>=8){char_out(cur_accum&255,outs);cur_accum>>=8;cur_bits-=8}if(free_ent>maxcode||clear_flg){if(clear_flg){maxcode=MAXCODE(n_bits=g_init_bits);clear_flg=false}else{++n_bits;if(n_bits==BITS)maxcode=1<<BITS;else maxcode=MAXCODE(n_bits)}}if(code==EOFCode){while(cur_bits>0){char_out(cur_accum&255,outs);cur_accum>>=8;cur_bits-=8}flush_char(outs)}}this.encode=encode}module.exports=LZWEncoder},{}],3:[function(require,module,exports){var ncycles=100;var netsize=256;var maxnetpos=netsize-1;var netbiasshift=4;var intbiasshift=16;var intbias=1<<intbiasshift;var gammashift=10;var gamma=1<<gammashift;var betashift=10;var beta=intbias>>betashift;var betagamma=intbias<<gammashift-betashift;var initrad=netsize>>3;var radiusbiasshift=6;var radiusbias=1<<radiusbiasshift;var initradius=initrad*radiusbias;var radiusdec=30;var alphabiasshift=10;var initalpha=1<<alphabiasshift;var alphadec;var radbiasshift=8;var radbias=1<<radbiasshift;var alpharadbshift=alphabiasshift+radbiasshift;var alpharadbias=1<<alpharadbshift;var prime1=499;var prime2=491;var prime3=487;var prime4=503;var minpicturebytes=3*prime4;function NeuQuant(pixels,samplefac){var network;var netindex;var bias;var freq;var radpower;function init(){network=[];netindex=new Int32Array(256);bias=new Int32Array(netsize);freq=new Int32Array(netsize);radpower=new Int32Array(netsize>>3);var i,v;for(i=0;i<netsize;i++){v=(i<<netbiasshift+8)/netsize;network[i]=new Float64Array([v,v,v,0]);freq[i]=intbias/netsize;bias[i]=0}}function unbiasnet(){for(var i=0;i<netsize;i++){network[i][0]>>=netbiasshift;network[i][1]>>=netbiasshift;network[i][2]>>=netbiasshift;network[i][3]=i}}function altersingle(alpha,i,b,g,r){network[i][0]-=alpha*(network[i][0]-b)/initalpha;network[i][1]-=alpha*(network[i][1]-g)/initalpha;network[i][2]-=alpha*(network[i][2]-r)/initalpha}function alterneigh(radius,i,b,g,r){var lo=Math.abs(i-radius);var hi=Math.min(i+radius,netsize);var j=i+1;var k=i-1;var m=1;var p,a;while(j<hi||k>lo){a=radpower[m++];if(j<hi){p=network[j++];p[0]-=a*(p[0]-b)/alpharadbias;p[1]-=a*(p[1]-g)/alpharadbias;p[2]-=a*(p[2]-r)/alpharadbias}if(k>lo){p=network[k--];p[0]-=a*(p[0]-b)/alpharadbias;p[1]-=a*(p[1]-g)/alpharadbias;p[2]-=a*(p[2]-r)/alpharadbias}}}function contest(b,g,r){var bestd=~(1<<31);var bestbiasd=bestd;var bestpos=-1;var bestbiaspos=bestpos;var i,n,dist,biasdist,betafreq;for(i=0;i<netsize;i++){n=network[i];dist=Math.abs(n[0]-b)+Math.abs(n[1]-g)+Math.abs(n[2]-r);if(dist<bestd){bestd=dist;bestpos=i}biasdist=dist-(bias[i]>>intbiasshift-netbiasshift);if(biasdist<bestbiasd){bestbiasd=biasdist;bestbiaspos=i}betafreq=freq[i]>>betashift;freq[i]-=betafreq;bias[i]+=betafreq<<gammashift}freq[bestpos]+=beta;bias[bestpos]-=betagamma;return bestbiaspos}function inxbuild(){var i,j,p,q,smallpos,smallval,previouscol=0,startpos=0;for(i=0;i<netsize;i++){p=network[i];smallpos=i;smallval=p[1];for(j=i+1;j<netsize;j++){q=network[j];if(q[1]<smallval){smallpos=j;smallval=q[1]}}q=network[smallpos];if(i!=smallpos){j=q[0];q[0]=p[0];p[0]=j;j=q[1];q[1]=p[1];p[1]=j;j=q[2];q[2]=p[2];p[2]=j;j=q[3];q[3]=p[3];p[3]=j}if(smallval!=previouscol){netindex[previouscol]=startpos+i>>1;for(j=previouscol+1;j<smallval;j++)netindex[j]=i;previouscol=smallval;startpos=i}}netindex[previouscol]=startpos+maxnetpos>>1;for(j=previouscol+1;j<256;j++)netindex[j]=maxnetpos}function inxsearch(b,g,r){var a,p,dist;var bestd=1e3;var best=-1;var i=netindex[g];var j=i-1;while(i<netsize||j>=0){if(i<netsize){p=network[i];dist=p[1]-g;if(dist>=bestd)i=netsize;else{i++;if(dist<0)dist=-dist;a=p[0]-b;if(a<0)a=-a;dist+=a;if(dist<bestd){a=p[2]-r;if(a<0)a=-a;dist+=a;if(dist<bestd){bestd=dist;best=p[3]}}}}if(j>=0){p=network[j];dist=g-p[1];if(dist>=bestd)j=-1;else{j--;if(dist<0)dist=-dist;a=p[0]-b;if(a<0)a=-a;dist+=a;if(dist<bestd){a=p[2]-r;if(a<0)a=-a;dist+=a;if(dist<bestd){bestd=dist;best=p[3]}}}}}return best}function learn(){var i;var lengthcount=pixels.length;var alphadec=30+(samplefac-1)/3;var samplepixels=lengthcount/(3*samplefac);var delta=~~(samplepixels/ncycles);var alpha=initalpha;var radius=initradius;var rad=radius>>radiusbiasshift;if(rad<=1)rad=0;for(i=0;i<rad;i++)radpower[i]=alpha*((rad*rad-i*i)*radbias/(rad*rad));var step;if(lengthcount<minpicturebytes){samplefac=1;step=3}else if(lengthcount%prime1!==0){step=3*prime1}else if(lengthcount%prime2!==0){step=3*prime2}else if(lengthcount%prime3!==0){step=3*prime3}else{step=3*prime4}var b,g,r,j;var pix=0;i=0;while(i<samplepixels){b=(pixels[pix]&255)<<netbiasshift;g=(pixels[pix+1]&255)<<netbiasshift;r=(pixels[pix+2]&255)<<netbiasshift;j=contest(b,g,r);altersingle(alpha,j,b,g,r);if(rad!==0)alterneigh(rad,j,b,g,r);pix+=step;if(pix>=lengthcount)pix-=lengthcount;i++;if(delta===0)delta=1;if(i%delta===0){alpha-=alpha/alphadec;radius-=radius/radiusdec;rad=radius>>radiusbiasshift;if(rad<=1)rad=0;for(j=0;j<rad;j++)radpower[j]=alpha*((rad*rad-j*j)*radbias/(rad*rad))}}}function buildColormap(){init();learn();unbiasnet();inxbuild()}this.buildColormap=buildColormap;function getColormap(){var map=[];var index=[];for(var i=0;i<netsize;i++)index[network[i][3]]=i;var k=0;for(var l=0;l<netsize;l++){var j=index[l];map[k++]=network[j][0];map[k++]=network[j][1];map[k++]=network[j][2]}return map}this.getColormap=getColormap;this.lookupRGB=inxsearch}module.exports=NeuQuant},{}],4:[function(require,module,exports){var GIFEncoder,renderFrame;GIFEncoder=require("./GIFEncoder.js");renderFrame=function(frame){var encoder,page,stream,transfer;encoder=new GIFEncoder(frame.width,frame.height);if(frame.index===0){encoder.writeHeader()}else{encoder.firstFrame=false}encoder.setTransparent(frame.transparent);encoder.setRepeat(frame.repeat);encoder.setDelay(frame.delay);encoder.setQuality(frame.quality);encoder.setDither(frame.dither);encoder.setGlobalPalette(frame.globalPalette);encoder.addFrame(frame.data);if(frame.last){encoder.finish()}if(frame.globalPalette===true){frame.globalPalette=encoder.getGlobalPalette()}stream=encoder.stream();frame.data=stream.pages;frame.cursor=stream.cursor;frame.pageSize=stream.constructor.pageSize;if(frame.canTransfer){transfer=function(){var i,len,ref,results;ref=frame.data;results=[];for(i=0,len=ref.length;i<len;i++){page=ref[i];results.push(page.buffer)}return results}();return self.postMessage(frame,transfer)}else{return self.postMessage(frame)}};self.onmessage=function(event){return renderFrame(event.data)}},{"./GIFEncoder.js":1}]},{},[4]);\n'
        ], {
            type: "application/javascript"
        }))
    });
}
module.exports.getGIF = $c79a64f3a60c742f$var$getGIF, module.exports.createGIF = $c79a64f3a60c742f$var$createGIF;

});

parcelRegister("aMp8g", function(module, exports) {
"use strict";
async function $7d91e1d9df847d2e$var$waitTillAvailable(e) {
    for(let i = 0; i < 30; i++){
        const i = await e();
        if (i) return i;
        await new Promise((e)=>setTimeout(e, 50));
    }
}
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.waitTillAvailable = void 0, module.exports.waitTillAvailable = $7d91e1d9df847d2e$var$waitTillAvailable;

});

parcelRegister("cneqt", function(module, exports) {
"use strict";
var $9022d2b99fd44168$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(e, t, o, i) {
    void 0 === i && (i = o);
    var n = Object.getOwnPropertyDescriptor(t, o);
    n && !("get" in n ? !t.__esModule : n.writable || n.configurable) || (n = {
        enumerable: !0,
        get: function() {
            return t[o];
        }
    }), Object.defineProperty(e, i, n);
} : function(e, t, o, i) {
    void 0 === i && (i = o), e[i] = t[o];
}), $9022d2b99fd44168$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(e, t) {
    Object.defineProperty(e, "default", {
        enumerable: !0,
        value: t
    });
} : function(e, t) {
    e.default = t;
}), $9022d2b99fd44168$var$__importStar = module.exports && module.exports.__importStar || function(e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for(var o in e)"default" !== o && Object.prototype.hasOwnProperty.call(e, o) && $9022d2b99fd44168$var$__createBinding(t, e, o);
    return $9022d2b99fd44168$var$__setModuleDefault(t, e), t;
}, $9022d2b99fd44168$var$__rest = module.exports && module.exports.__rest || function(e, t) {
    var o = {};
    for(var i in e)Object.prototype.hasOwnProperty.call(e, i) && t.indexOf(i) < 0 && (o[i] = e[i]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var n = 0;
        for(i = Object.getOwnPropertySymbols(e); n < i.length; n++)t.indexOf(i[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[n]) && (o[i[n]] = e[i[n]]);
    }
    return o;
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.jsonToHTML = module.exports.jsonToDOM = module.exports.fixRatio = void 0;

var $8VFx4 = parcelRequire("8VFx4");

const $9022d2b99fd44168$var$svg = $9022d2b99fd44168$var$__importStar((parcelRequire("eRGXT")));

var $8VFx4 = parcelRequire("8VFx4");

var $jkJqh = parcelRequire("jkJqh");
const $9022d2b99fd44168$var$h = (e, t, ...o)=>({
        type: e,
        props: t,
        children: o || []
    });
function $9022d2b99fd44168$var$fixRatio(e) {
    var t = (new DOMParser).parseFromString(e, "image/svg+xml");
    t.documentElement.setAttribute("preserveAspectRatio", "none");
    return (new XMLSerializer).serializeToString(t);
}
module.exports.fixRatio = $9022d2b99fd44168$var$fixRatio;
const $9022d2b99fd44168$var$imageToDOM = async ({ element: e, page: t, store: o })=>{
    let { src: i } = e;
    if ("svg" === e.type && Object.keys(e.colorsReplace).length) {
        const t = await $9022d2b99fd44168$var$svg.urlToString(i);
        i = $9022d2b99fd44168$var$svg.replaceColors(t, new Map(Object.entries(e.colorsReplace)));
    }
    let n = "";
    e.flipX && (n += "scaleX(-1)"), e.flipY && (n += "scaleY(-1)"), n || (n = "none");
    const r = {};
    if (e.clipSrc) {
        const t = await $9022d2b99fd44168$var$svg.urlToBase64(e.clipSrc);
        r["clip-path"] = `url(${t})`;
    }
    const a = await (0, $8VFx4.loadImage)(i), s = a.width * e.cropWidth, l = a.height * e.cropHeight, g = e.width / e.height;
    let p, c;
    const d = s / l;
    "svg" === e.type ? (p = s, c = l) : g >= d ? (p = s, c = s / g) : (p = l * g, c = l);
    const u = p / a.width, f = c / a.height, m = p / c > e.width / e.height ? e.height / c : e.width / p, b = p * m / u, y = c * m / f, O = e.cropX * m * a.width, x = e.cropY * m * a.height;
    return $9022d2b99fd44168$var$h("div", {
        style: Object.assign(Object.assign({}, r), {
            width: "100%",
            height: "100%",
            "border-radius": e.cornerRadius + "px",
            border: e.borderSize ? `${e.borderSize}px solid ${e.borderColor}` : "none",
            background: `url(${i})`,
            transform: n,
            "background-size": `${Math.round(b)}px ${Math.round(y)}px`,
            "background-position-x": -Math.round(O) + "px",
            "background-position-y": -Math.round(x) + "px"
        })
    });
}, $9022d2b99fd44168$var$textToDOM = async ({ element: e, page: t, store: o })=>{
    let i = {};
    e.fill.indexOf("gradient") >= 0 && (i = Object.assign(Object.assign({}, i), {
        "background-color": e.fill,
        "background-image": e.fill,
        "background-clip": "text",
        "text-fill-color": "transparent",
        "-webkit-background-clip": "text",
        "-webkit-text-fill-color": "transparent"
    }));
    const n = e.backgroundPadding * (e.fontSize * e.lineHeight), r = $9022d2b99fd44168$var$h("div", {
        style: {
            position: "absolute",
            top: -n / 2 + "px",
            left: -n / 2 + "px",
            display: e.backgroundEnabled ? "block" : "none",
            width: e.width + n + "px",
            height: e.height + n + "px",
            "background-color": e.backgroundColor,
            "border-radius": e.backgroundCornerRadius * (e.fontSize * e.lineHeight * .5) + "px"
        }
    }), a = $9022d2b99fd44168$var$h("div", {
        style: Object.assign(Object.assign({}, i), {
            position: "absolute",
            top: 0,
            left: 0,
            width: e.width + "px",
            color: e.fill,
            "white-space": "pre-wrap",
            "font-size": e.fontSize + "px",
            "text-align": e.align,
            "font-family": e.fontFamily,
            "text-decoration": e.textDecoration || "none",
            "line-height": e.lineHeight,
            "letter-spacing": e.letterSpacing + "em",
            "font-style": e.fontStyle,
            "font-weight": e.fontWeight,
            "-webkit-text-stroke": `${e.strokeWidth}px ${e.stroke}`,
            "text-stroke": `${e.strokeWidth}px ${e.stroke}`
        })
    }, e.text.split("\n").join("<br />"));
    return $9022d2b99fd44168$var$h("div", {
        style: {
            position: "relative"
        }
    }, r, a);
}, $9022d2b99fd44168$var$getLineHead = ({ element: e, type: t })=>{
    const o = {
        "stroke-width": e.height,
        stroke: e.color,
        "line-cap": "round",
        "stroke-linejoin": "round",
        opacity: e.opacity
    };
    return "arrow" === t || "triangle" === t ? $9022d2b99fd44168$var$h("polyline", Object.assign({
        points: `${3 * e.height},${2 * -e.height} 0,0 ${3 * e.height},${2 * e.height}`
    }, o)) : "bar" === t ? $9022d2b99fd44168$var$h("polyline", Object.assign({
        points: `0,${2 * -e.height} 0,${2 * e.height}`
    }, o)) : "circle" === t ? $9022d2b99fd44168$var$h("circle", Object.assign({
        r: e.height
    }, o)) : "square" === t ? $9022d2b99fd44168$var$h("polyline", Object.assign({
        points: `${-e.height},${-e.height} ${-e.height},${e.height} ${e.height},${e.height} ${e.height},${-e.height}`
    }, o)) : null;
}, $9022d2b99fd44168$var$lineToDOM = async ({ element: e, page: t, store: o })=>$9022d2b99fd44168$var$h("svg", {
        style: {
            width: "100%",
            height: "100%",
            contain: "layout style size",
            overflow: "visible"
        }
    }, $9022d2b99fd44168$var$h("rect", {
        x: 0,
        y: 0,
        width: e.width,
        height: e.height,
        fill: e.color
    }), $9022d2b99fd44168$var$h("g", {
        transform: `translate(0 ${e.height / 2})`
    }, $9022d2b99fd44168$var$getLineHead({
        element: e,
        type: e.startHead
    })), $9022d2b99fd44168$var$h("g", {
        transform: `translate(${e.width} ${e.height / 2}) rotate(180)`
    }, $9022d2b99fd44168$var$getLineHead({
        element: e,
        type: e.endHead
    }))), $9022d2b99fd44168$var$groupToDOM = async ({ element: e, page: t, store: o, elementHook: i })=>{
    const n = await Promise.all(e.children.map((e)=>$9022d2b99fd44168$var$elementToDOM({
            element: e,
            page: t,
            store: o,
            elementHook: i
        }))), r = $9022d2b99fd44168$var$h("div", {
        style: {
            "transform-origin": "top left",
            opacity: e.opacity
        }
    }, ...n);
    return i && i({
        dom: r,
        element: e
    }) || r;
}, $9022d2b99fd44168$var$figureToDOM = async ({ element: e, page: t, store: o, elementHook: i })=>{
    const n = (0, $jkJqh.figureToSvg)(e), r = $9022d2b99fd44168$var$h("div", {
        innerHTML: n
    });
    return i && i({
        dom: r,
        element: e
    }) || r;
}, $9022d2b99fd44168$var$type = {
    image: $9022d2b99fd44168$var$imageToDOM,
    svg: $9022d2b99fd44168$var$imageToDOM,
    text: $9022d2b99fd44168$var$textToDOM,
    line: $9022d2b99fd44168$var$lineToDOM,
    figure: $9022d2b99fd44168$var$figureToDOM,
    group: $9022d2b99fd44168$var$groupToDOM
};
async function $9022d2b99fd44168$var$elementToDOM({ element: e, page: t, store: o, elementHook: i }) {
    let n = await $9022d2b99fd44168$var$type[e.type];
    n || (n = ()=>$9022d2b99fd44168$var$h("div", {}), console.error(`HTML export does not support ${e.type} type...`));
    const r = await n({
        element: e,
        page: t,
        store: o
    }), a = [];
    e.blurEnabled && a.push(`blur(${e.blurRadius / 2}px)`), e.brightnessEnabled && a.push(`brightness(${100 * e.brightness + 100}%)`), e.sepiaEnabled && a.push("sepia()"), e.grayscaleEnabled && a.push("grayscale()"), e.shadowEnabled && a.push(`drop-shadow(${e.shadowOffsetX}px ${e.shadowOffsetY}px ${e.shadowBlur}px ${e.shadowColor})`);
    const s = $9022d2b99fd44168$var$h("div", {
        style: {
            position: "absolute",
            left: e.x + "px",
            top: e.y + "px",
            width: e.width + "px",
            height: e.height + "px",
            transform: `rotate(${e.rotation}deg)`,
            "transform-origin": "top left",
            opacity: e.opacity,
            filter: a.join(" ") || "none"
        }
    }, r);
    return i && i({
        dom: s,
        element: e
    }) || s;
}
async function $9022d2b99fd44168$var$pageToDOM({ page: e, store: t, elementHook: o }) {
    const i = await Promise.all(e.children.map((i)=>$9022d2b99fd44168$var$elementToDOM({
            element: i,
            page: e,
            store: t,
            elementHook: o
        }))), n = "auto" === e.width ? t.width : e.width, r = "auto" === e.height ? t.height : e.height;
    let a = {};
    if (e.background.indexOf("url") >= 0 || e.background.indexOf("http") >= 0 || e.background.indexOf(".jpg") >= 0 || e.background.indexOf(".png") >= 0 || e.background.indexOf(".jpeg") >= 0) {
        const { width: o, height: n } = await (0, $8VFx4.loadImage)(e.background), r = await $9022d2b99fd44168$var$imageToDOM({
            element: Object.assign({
                x: 0,
                y: 0,
                width: o,
                height: n,
                src: e.background,
                cornerRadius: 0
            }, (0, $8VFx4.getCrop)({
                width: o,
                height: n
            }, {
                width: o,
                height: n
            })),
            page: e,
            store: t
        });
        i.unshift(r);
    } else a = Object.assign(Object.assign({}, a), {
        "background-color": e.background
    });
    return $9022d2b99fd44168$var$h("div", {
        className: "page",
        style: Object.assign(Object.assign({}, a), {
            width: n + "px",
            height: r + "px",
            border: "1px solid grey",
            overflow: "hidden",
            position: "relative"
        })
    }, ...i);
}
async function $9022d2b99fd44168$var$jsonToDOM({ json: e, elementHook: t }) {
    const o = await Promise.all(e.pages.map((o)=>$9022d2b99fd44168$var$pageToDOM({
            page: o,
            store: e,
            elementHook: t
        }))), i = [];
    e.pages.forEach((e)=>{
        e.children.forEach((e)=>{
            "text" === e.type && -1 === i.indexOf(e.fontFamily) && i.push(e.fontFamily);
        });
    });
    const n = i.map((t)=>e.fonts.find((e)=>e.fontFamily === t) ? $9022d2b99fd44168$var$h("style", {}, "") : $9022d2b99fd44168$var$h("link", {
            href: `https://fonts.googleapis.com/css?family=${t}`,
            rel: "stylesheet"
        }));
    return $9022d2b99fd44168$var$h("div", {
        className: "design"
    }, ...n, ...o);
}
module.exports.jsonToDOM = $9022d2b99fd44168$var$jsonToDOM;
const $9022d2b99fd44168$var$serializeProp = (e, t)=>"object" == typeof t ? `${e}="${Object.keys(t).map((e)=>`${e}:${t[e]};`).join(" ")}"` : `${e}="${t}"`, $9022d2b99fd44168$var$domToHTML = ({ dom: e })=>{
    if ("string" == typeof e) return e;
    if (!e) return "";
    const t = e.props, { innerHTML: o } = t, i = $9022d2b99fd44168$var$__rest(t, [
        "innerHTML"
    ]);
    return `<${e.type} ${Object.keys(i).map((t)=>$9022d2b99fd44168$var$serializeProp(t, e.props[t])).join(" ")}>${o || e.children.map((e)=>$9022d2b99fd44168$var$domToHTML({
            dom: e
        })).join("")}</${e.type}>`;
};
async function $9022d2b99fd44168$var$jsonToHTML({ json: e, elementHook: t }) {
    const o = await $9022d2b99fd44168$var$jsonToDOM({
        json: e,
        elementHook: t
    });
    return $9022d2b99fd44168$var$domToHTML({
        dom: o
    });
}
module.exports.jsonToHTML = $9022d2b99fd44168$var$jsonToHTML;

});
parcelRegister("8VFx4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.getCrop = module.exports.cropImage = module.exports.loadImage = module.exports.getImageSize = void 0;

var $eRGXT = parcelRequire("eRGXT");
function $6803dd176ce72bf5$var$getImageSize(t) {
    return new Promise((e)=>{
        const o = document.createElement("img");
        o.onload = async ()=>{
            0 === o.width || 0 === o.height ? e(await (0, $eRGXT.getSvgSize)(t)) : e({
                width: o.width,
                height: o.height
            });
        }, o.crossOrigin = "anonymous", o.src = t;
    });
}
function $6803dd176ce72bf5$var$loadImage(t) {
    return new Promise((e, o)=>{
        const i = document.createElement("img");
        i.onload = ()=>{
            e(i);
        }, i.onerror = (t)=>{
            o(t);
        }, i.crossOrigin = "anonymous", i.src = t;
    });
}
async function $6803dd176ce72bf5$var$cropImage(t, e) {
    const o = await $6803dd176ce72bf5$var$loadImage(t), i = document.createElement("canvas");
    i.width = 2 * o.width, i.height = 2 * o.height, i.getContext("2d").drawImage(o, 0, 0, i.width, i.height);
    const h = document.createElement("canvas");
    h.width = e.width, h.height = e.height;
    const g = h.getContext("2d");
    let { cropX: r, cropY: n } = e;
    const a = i.width * e.cropWidth, c = i.height * e.cropHeight, s = e.width / e.height;
    let d, m;
    const p = a / c;
    return "svg" === e.type ? (d = a, m = c) : s >= p ? (d = a, m = a / s) : (d = c * s, m = c), g.drawImage(i, r * i.width, n * i.height, d, m, 0, 0, h.width, h.height), h.toDataURL("image/png");
}
function $6803dd176ce72bf5$var$getCrop(t, e) {
    const { width: o, height: i } = t, h = o / i;
    let g, r;
    h >= e.width / e.height ? (g = e.width, r = e.width / h) : (g = e.height * h, r = e.height);
    const n = (e.width - g) / 2, a = (e.height - r) / 2;
    return {
        cropX: n / e.width,
        cropY: a / e.height,
        cropWidth: g / e.width,
        cropHeight: r / e.height
    };
}
module.exports.getImageSize = $6803dd176ce72bf5$var$getImageSize, module.exports.loadImage = $6803dd176ce72bf5$var$loadImage, module.exports.cropImage = $6803dd176ce72bf5$var$cropImage, module.exports.getCrop = $6803dd176ce72bf5$var$getCrop;

});


parcelRegister("e8Ns6", function(module, exports) {
"use strict";
var $a4b82c3c648d1ec6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(e, t, i, o) {
    void 0 === o && (o = i);
    var n = Object.getOwnPropertyDescriptor(t, i);
    n && !("get" in n ? !t.__esModule : n.writable || n.configurable) || (n = {
        enumerable: !0,
        get: function() {
            return t[i];
        }
    }), Object.defineProperty(e, o, n);
} : function(e, t, i, o) {
    void 0 === o && (o = i), e[o] = t[i];
}), $a4b82c3c648d1ec6$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(e, t) {
    Object.defineProperty(e, "default", {
        enumerable: !0,
        value: t
    });
} : function(e, t) {
    e.default = t;
}), $a4b82c3c648d1ec6$var$__importStar = module.exports && module.exports.__importStar || function(e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for(var i in e)"default" !== i && Object.prototype.hasOwnProperty.call(e, i) && $a4b82c3c648d1ec6$var$__createBinding(t, e, i);
    return $a4b82c3c648d1ec6$var$__setModuleDefault(t, e), t;
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.jsonToSVG = module.exports.jsonToDOM = module.exports.fixRatio = void 0;

var $8VFx4 = parcelRequire("8VFx4");

const $a4b82c3c648d1ec6$var$svg = $a4b82c3c648d1ec6$var$__importStar((parcelRequire("eRGXT")));

var $8VFx4 = parcelRequire("8VFx4");
const $a4b82c3c648d1ec6$var$h = (e, t, ...i)=>({
        type: e,
        props: t,
        children: i || []
    });
function $a4b82c3c648d1ec6$var$fixRatio(e) {
    var t = (new DOMParser).parseFromString(e, "image/svg+xml");
    t.documentElement.setAttribute("preserveAspectRatio", "none");
    return (new XMLSerializer).serializeToString(t);
}
module.exports.fixRatio = $a4b82c3c648d1ec6$var$fixRatio;
const $a4b82c3c648d1ec6$var$imageToDataURL = async (e)=>{
    const t = await (0, $8VFx4.loadImage)(e), i = document.createElement("canvas");
    i.width = t.width, i.height = t.height;
    return i.getContext("2d").drawImage(t, 0, 0), i.toDataURL("image/png");
}, $a4b82c3c648d1ec6$var$imageToDOM = async ({ element: e, page: t, store: i })=>{
    let { src: o } = e;
    if ("svg" === e.type) {
        const t = await $a4b82c3c648d1ec6$var$svg.urlToString(o);
        o = $a4b82c3c648d1ec6$var$svg.replaceColors(t, new Map(Object.entries(e.colorsReplace)));
    }
    let n = "";
    e.flipX && (n += "scaleX(-1)"), e.flipY && (n += "scaleY(-1)");
    const a = {};
    if (e.clipSrc) {
        const t = await $a4b82c3c648d1ec6$var$svg.urlToBase64(e.clipSrc);
        a["clip-path"] = `url(${t})`;
    }
    const r = await (0, $8VFx4.loadImage)(o), s = r.width * e.cropWidth, l = r.height * e.cropHeight, g = e.width / e.height;
    let c, p;
    const d = s / l;
    "svg" === e.type ? (c = s, p = l) : g >= d ? (c = s, p = s / g) : (c = l * g, p = l);
    const m = c / r.width, u = p / r.height, f = c / p > e.width / e.height ? e.height / p : e.width / c, w = c * f / m, b = p * f / u, y = e.cropX * f * r.width, x = e.cropY * f * r.height, O = `clip-${Math.random()}`;
    return $a4b82c3c648d1ec6$var$h("g", {
        style: {
            "clip-path": a["clip-path"],
            transform: n
        }
    }, $a4b82c3c648d1ec6$var$h("defs", {}, $a4b82c3c648d1ec6$var$h("clipPath", {
        id: O
    }, $a4b82c3c648d1ec6$var$h("rect", {
        x: y,
        y: x,
        width: w,
        height: b
    }))), $a4b82c3c648d1ec6$var$h("image", {
        "xlink:href": await $a4b82c3c648d1ec6$var$imageToDataURL(o),
        width: e.width,
        height: e.height,
        preserveAspectRatio: "none",
        "clip-path": `url(#${O})`
    }));
}, $a4b82c3c648d1ec6$var$textToDOM = async ({ element: e, page: t, store: i })=>{
    let o = {};
    e.fill.indexOf("gradient") >= 0 && (o = Object.assign(Object.assign({}, o), {
        "background-color": e.fill,
        "background-image": e.fill,
        "background-clip": "text",
        "text-fill-color": "transparent",
        "-webkit-background-clip": "text",
        "-webkit-text-fill-color": "transparent"
    }));
    const n = e.backgroundPadding * (e.fontSize * e.lineHeight), a = $a4b82c3c648d1ec6$var$h("div", {
        style: {
            position: "absolute",
            top: -n / 2 + "px",
            left: -n / 2 + "px",
            display: e.backgroundEnabled ? "block" : "none",
            width: e.width + n + "px",
            height: e.height + n + "px",
            "background-color": e.backgroundColor,
            "border-radius": e.backgroundCornerRadius * (e.fontSize * e.lineHeight * .5) + "px"
        }
    }), r = $a4b82c3c648d1ec6$var$h("div", {
        style: Object.assign(Object.assign({}, o), {
            position: "absolute",
            top: 0,
            left: 0,
            width: e.width + "px",
            color: e.fill,
            "white-space": "pre-wrap",
            "font-size": e.fontSize + "px",
            "text-align": e.align,
            "font-family": e.fontFamily,
            "text-decoration": e.textDecoration || "none",
            "line-height": e.lineHeight,
            "letter-spacing": e.letterSpacing + "em",
            "font-style": e.fontStyle,
            "font-weight": e.fontWeight,
            "-webkit-text-stroke": `${e.strokeWidth}px ${e.stroke}`,
            "text-stroke": `${e.strokeWidth}px ${e.stroke}`
        })
    }, e.text.split("\n").join("<br />"));
    return $a4b82c3c648d1ec6$var$h("foreignObject", {
        width: e.width,
        height: e.height
    }, $a4b82c3c648d1ec6$var$h("div", {
        style: {
            position: "relative"
        },
        xmlns: "http://www.w3.org/1999/xhtml"
    }, a, r));
}, $a4b82c3c648d1ec6$var$getLineHead = ({ element: e, type: t })=>{
    const i = {
        "stroke-width": e.height,
        stroke: e.color,
        "line-cap": "round",
        "stroke-linejoin": "round",
        opacity: e.opacity
    };
    return "arrow" === t || "triangle" === t ? $a4b82c3c648d1ec6$var$h("polyline", Object.assign({
        points: `${3 * e.height},${2 * -e.height} 0,0 ${3 * e.height},${2 * e.height}`
    }, i)) : "bar" === t ? $a4b82c3c648d1ec6$var$h("polyline", Object.assign({
        points: `0,${2 * -e.height} 0,${2 * e.height}`
    }, i)) : "circle" === t ? $a4b82c3c648d1ec6$var$h("circle", Object.assign({
        r: e.height
    }, i)) : "square" === t ? $a4b82c3c648d1ec6$var$h("polyline", Object.assign({
        points: `${-e.height},${-e.height} ${-e.height},${e.height} ${e.height},${e.height} ${e.height},${-e.height}`
    }, i)) : null;
}, $a4b82c3c648d1ec6$var$lineToDOM = async ({ element: e, page: t, store: i })=>$a4b82c3c648d1ec6$var$h("svg", {
        style: {
            width: "100%",
            height: "100%",
            contain: "layout style size",
            overflow: "visible"
        }
    }, $a4b82c3c648d1ec6$var$h("rect", {
        x: 0,
        y: 0,
        width: e.width,
        height: e.height,
        fill: e.color
    }), $a4b82c3c648d1ec6$var$h("g", {
        transform: `translate(0 ${e.height / 2})`
    }, $a4b82c3c648d1ec6$var$getLineHead({
        element: e,
        type: e.startHead
    })), $a4b82c3c648d1ec6$var$h("g", {
        transform: `translate(${e.width} ${e.height / 2}) rotate(180)`
    }, $a4b82c3c648d1ec6$var$getLineHead({
        element: e,
        type: e.endHead
    }))), $a4b82c3c648d1ec6$var$groupToDOM = async ({ element: e, page: t, store: i, elementHook: o })=>{
    const n = await Promise.all(e.children.map((e)=>$a4b82c3c648d1ec6$var$elementToDOM({
            element: e,
            page: t,
            store: i,
            elementHook: o
        }))), a = $a4b82c3c648d1ec6$var$h("g", {
        opacity: e.opacity,
        style: {
            "transform-origin": "top left"
        }
    }, ...n);
    return o && o({
        dom: a,
        element: e
    }) || a;
}, $a4b82c3c648d1ec6$var$type = {
    image: $a4b82c3c648d1ec6$var$imageToDOM,
    svg: $a4b82c3c648d1ec6$var$imageToDOM,
    text: $a4b82c3c648d1ec6$var$textToDOM,
    line: $a4b82c3c648d1ec6$var$lineToDOM,
    group: $a4b82c3c648d1ec6$var$groupToDOM
};
async function $a4b82c3c648d1ec6$var$elementToDOM({ element: e, page: t, store: i, elementHook: o }) {
    let n = await $a4b82c3c648d1ec6$var$type[e.type];
    n || (n = ()=>$a4b82c3c648d1ec6$var$h("div", {}), console.error(`HTML export does not support ${e.type} type...`));
    const a = await n({
        element: e,
        page: t,
        store: i
    }), r = [];
    e.blurEnabled && r.push(`blur(${e.blurRadius / 2}px)`), e.brightnessEnabled && r.push(`brightness(${100 * e.brightness + 100}%)`), e.sepiaEnabled && r.push("sepia()"), e.grayscaleEnabled && r.push("grayscale()"), e.shadowEnabled && r.push(`drop-shadow(${e.shadowOffsetX}px ${e.shadowOffsetY}px ${e.shadowBlur}px ${e.shadowColor})`);
    const s = $a4b82c3c648d1ec6$var$h("g", {
        transform: `translate(${e.x}, ${e.y}) rotate(${e.rotation})`,
        rotation: e.rotation,
        width: e.width,
        height: e.height,
        opacity: e.opacity,
        style: {
            "transform-origin": "top left",
            filter: r.join(" ")
        }
    }, a);
    return o && o({
        dom: s,
        element: e
    }) || s;
}
async function $a4b82c3c648d1ec6$var$pageToDOM({ page: e, store: t, elementHook: i }) {
    const o = await Promise.all(e.children.map((o)=>$a4b82c3c648d1ec6$var$elementToDOM({
            element: o,
            page: e,
            store: t,
            elementHook: i
        })));
    let n = {};
    if (e.background.indexOf("url") >= 0 || e.background.indexOf("http") >= 0 || e.background.indexOf(".jpg") >= 0 || e.background.indexOf(".png") >= 0 || e.background.indexOf(".jpeg") >= 0) {
        const i = await (0, $8VFx4.loadImage)(e.background), o = await (0, $8VFx4.cropImage)(e.background, Object.assign({
            width: t.width,
            height: t.height,
            x: 0,
            y: 0
        }, (0, $8VFx4.getCrop)({
            width: t.width,
            height: t.height
        }, {
            width: i.width,
            height: i.height
        })));
        n = Object.assign(Object.assign({}, n), {
            "background-image": `url(${o})`
        });
    }
    return $a4b82c3c648d1ec6$var$h("g", {
        className: "page",
        style: Object.assign(Object.assign({}, n), {
            background: e.background
        })
    }, $a4b82c3c648d1ec6$var$h("rect", {
        x: 0,
        y: 0,
        width: t.width,
        height: t.height,
        fill: e.background
    }), ...o);
}
async function $a4b82c3c648d1ec6$var$jsonToDOM({ json: e, elementHook: t }) {
    const i = await Promise.all(e.pages.map((i)=>$a4b82c3c648d1ec6$var$pageToDOM({
            page: i,
            store: e,
            elementHook: t
        }))), o = [];
    e.pages.forEach((e)=>{
        e.children.forEach((e)=>{
            "text" === e.type && -1 === o.indexOf(e.fontFamily) && o.push(e.fontFamily);
        });
    });
    const n = o.map((t)=>e.fonts.find((e)=>e.fontFamily === t) ? $a4b82c3c648d1ec6$var$h("style", {}, "") : $a4b82c3c648d1ec6$var$h("link", {
            href: `https://fonts.googleapis.com/css?family=${t}`,
            rel: "stylesheet"
        }));
    return $a4b82c3c648d1ec6$var$h("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        viewBox: `0 0 ${e.width} ${e.height}`,
        preserveAspectRatio: "xMidYMin slice"
    }, ...n, ...i);
}
module.exports.jsonToDOM = $a4b82c3c648d1ec6$var$jsonToDOM;
const $a4b82c3c648d1ec6$var$serializeProp = (e, t)=>"object" == typeof t ? `${e}="${Object.keys(t).map((e)=>`${e}:${t[e]};`).join(" ")}"` : `${e}="${t}"`, $a4b82c3c648d1ec6$var$domToHTML = ({ dom: e })=>"string" == typeof e ? e : e ? `<${e.type} ${Object.keys(e.props).map((t)=>$a4b82c3c648d1ec6$var$serializeProp(t, e.props[t])).join(" ")}>${e.children.map((e)=>$a4b82c3c648d1ec6$var$domToHTML({
            dom: e
        })).join("")}</${e.type}>\n` : "";
async function $a4b82c3c648d1ec6$var$jsonToSVG({ json: e, elementHook: t }) {
    const i = await $a4b82c3c648d1ec6$var$jsonToDOM({
        json: e,
        elementHook: t
    });
    return $a4b82c3c648d1ec6$var$domToHTML({
        dom: i
    });
}
module.exports.jsonToSVG = $a4b82c3c648d1ec6$var$jsonToSVG;

});

parcelRegister("10zrZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.Page = void 0;

var $58B0H = parcelRequire("58B0H");

var $aQPnZ = parcelRequire("aQPnZ");

var $6k1PQ = parcelRequire("6k1PQ");

var $kBxKd = parcelRequire("kBxKd");

var $6k1PQ = parcelRequire("6k1PQ");
module.exports.Page = $58B0H.types.model("Page", {
    id: $58B0H.types.identifier,
    children: $58B0H.types.array($58B0H.types.late(()=>$6k1PQ.ElementTypes)),
    width: $58B0H.types.optional($58B0H.types.union($58B0H.types.number, $58B0H.types.literal("auto")), "auto"),
    height: $58B0H.types.optional($58B0H.types.union($58B0H.types.number, $58B0H.types.literal("auto")), "auto"),
    background: "white",
    bleed: 0,
    custom: $58B0H.types.frozen(),
    duration: 5e3,
    _exporting: !1,
    _rendering: !1
}).postProcessSnapshot((e)=>{
    const t = Object.assign({}, e), o = {};
    for(var n in t)"_" !== n[0] && (o[n] = e[n]);
    return o;
}).views((e)=>({
        get store () {
            return (0, $58B0H.getParentOfType)(e, $kBxKd.Store);
        },
        get startTime () {
            let t = 0;
            for (const o of e.store.pages){
                if (o.id === e.id) return t;
                t += o.duration;
            }
            return t;
        }
    })).views((e)=>({
        get computedWidth () {
            return "auto" === e.width ? e.store.width : e.width;
        },
        get computedHeight () {
            return "auto" === e.height ? e.store.height : e.height;
        }
    })).actions((e)=>({
        toJSON: ()=>JSON.parse(JSON.stringify((0, $58B0H.getSnapshot)(e))),
        _forEachElementUp (t, o) {
            const n = t.map((t)=>({
                    id: t,
                    index: e.children.findIndex((e)=>e.id === t)
                }));
            n.sort((e, t)=>t.index - e.index);
            for (const { index: i } of n){
                if (-1 == i) continue;
                const n = i < e.children.length - 1 && e.children[i + 1], r = t.indexOf(null == n ? void 0 : n.id) >= 0;
                i === e.children.length - 1 || r || o(i);
            }
        },
        _forEachElementDown (t, o) {
            const n = t.map((t)=>({
                    id: t,
                    index: e.children.findIndex((e)=>e.id === t)
                }));
            n.sort((e, t)=>e.index - t.index);
            for (const { index: i } of n){
                if (-1 == i) continue;
                const n = i > 0 && e.children[i - 1], r = t.indexOf(null == n ? void 0 : n.id) >= 0;
                0 === i || r || o(i);
            }
            return !1;
        }
    })).actions((e)=>({
        clone (t = {}) {
            const o = e.toJSON();
            o.children.forEach((e)=>{
                e.id = (0, $aQPnZ.nanoid)(10), (0, $6k1PQ.forEveryChild)(e, (e)=>{
                    e.id = (0, $aQPnZ.nanoid)(10);
                });
            });
            const n = Object.assign(Object.assign(Object.assign({}, o), {
                id: (0, $aQPnZ.nanoid)(10)
            }), t), i = e.store.addPage(n), r = e.store.pages.indexOf(e);
            i.setZIndex(r + 1), i.select();
        },
        setZIndex (t) {
            e.store.setPageZIndex(e.id, t);
        },
        set (t) {
            Object.assign(e, t);
        },
        select () {
            e.store.selectPage(e.id);
        },
        addElement (t, { skipSelect: o = !1 } = {}) {
            const n = $6k1PQ.TYPES_MAP[t.type];
            if (!n) return void console.error("Can not find model with type " + t.type);
            t.children && t.children.forEach((e)=>{
                e.id = (0, $aQPnZ.nanoid)(10);
            });
            const i = n.create(Object.assign({
                id: (0, $aQPnZ.nanoid)(10)
            }, t));
            return e.children.push(i), i.selectable && !o && e.store.selectElements([
                i.id
            ]), i;
        },
        canMoveElementsUp (t) {
            let o = !1;
            return e._forEachElementUp(t, ()=>{
                o = o || !0;
            }), o;
        },
        moveElementsUp (t) {
            e._forEachElementUp(t, (t)=>{
                const o = e.children[t];
                (0, $58B0H.detach)(o), e.children.splice(t + 1, 0, o);
            });
        },
        canMoveElementsTop (e) {
            return this.canMoveElementsUp(e);
        },
        moveElementsTop (t) {
            const o = [], n = [];
            e.children.forEach((e)=>{
                t.indexOf(e.id) >= 0 ? o.push(e) : n.push(e);
            }), e.children.replace(n.concat(o));
        },
        canMoveElementsDown (t) {
            let o = !1;
            return e._forEachElementDown(t, ()=>{
                o = o || !0;
            }), o;
        },
        moveElementsDown (t) {
            e._forEachElementDown(t, (t)=>{
                const o = e.children[t];
                (0, $58B0H.detach)(o), e.children.splice(t - 1, 0, o);
            });
        },
        canMoveElementsBottom (e) {
            return this.canMoveElementsDown(e);
        },
        moveElementsBottom (t) {
            const o = [], n = [];
            e.children.forEach((e)=>{
                t.indexOf(e.id) >= 0 ? o.push(e) : n.push(e);
            }), e.children.replace(o.concat(n));
        },
        setElementZIndex (t, o) {
            const n = e.children.find((e)=>e.id === t);
            n && ((0, $58B0H.detach)(n), e.children.remove(n), e.children.splice(o, 0, n));
        },
        setSize ({ width: t, height: o, useMagic: n, softChange: i }) {
            if (n) {
                const n = t / e.computedWidth, i = o / e.computedHeight, r = Math.min(n, i), s = Math.max(0, (t - e.computedWidth * r) / 2), d = Math.max(0, (o - e.computedHeight * r) / 2);
                (0, $6k1PQ.forEveryChild)(e, (t)=>{
                    if ("group" === t.type) return;
                    "image" === t.type && t.x < 1 && t.y < 1 && t.width >= e.computedWidth - 2 && t.height >= e.computedHeight - 2 ? t.set({
                        x: t.x * r,
                        y: t.y * r,
                        width: t.width * n,
                        height: t.height * i,
                        cropX: 0,
                        cropY: 0,
                        cropWidth: 1,
                        cropHeight: 1
                    }) : (t.set({
                        x: s + t.x * r,
                        y: d + t.y * r,
                        width: t.width * r,
                        height: t.height * r
                    }), "text" === t.type ? t.set({
                        fontSize: t.fontSize * r
                    }) : "figure" === t.type && t.set({
                        strokeWidth: t.strokeWidth * r
                    }));
                });
            }
            i || (e.width = t), i || (e.height = o);
        }
    })).actions((e)=>({
        moveElementUp (t) {
            console.warn("page.moveElementUp(id) is deprecated. Please use page.moveElementsUp([id1, id2]) instead."), e.moveElementsUp([
                t
            ]);
        },
        moveElementDown (t) {
            console.warn("page.moveElementDown(id) is deprecated. Please use page.moveElementsDown([id1, id2]) instead."), e.moveElementsDown([
                t
            ]);
        },
        moveElementTop (t) {
            console.warn("page.moveElementTop(id) is deprecated. Please use page.moveElementsTop([id1, id2]) instead."), e.moveElementsTop([
                t
            ]);
        },
        moveElementBottom (t) {
            console.warn("page.moveElementBottom(id) is deprecated. Please use page.moveElementsBottom([id1, id2]) instead."), e.moveElementsBottom([
                t
            ]);
        },
        play () {
            e.store.play({
                startTime: e.startTime,
                endTime: e.startTime + e.duration
            });
        }
    }));

});



parcelRegister("lfvTK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.Shape = module.exports.Animation = void 0;

var $58B0H = parcelRequire("58B0H");

var $UnmLk = parcelRequire("UnmLk");

var $9xvfK = parcelRequire("9xvfK");
module.exports.Animation = $58B0H.types.model("Animation", {
    delay: 0,
    duration: 500,
    enabled: !0,
    type: $58B0H.types.enumeration("Type", [
        "enter",
        "exit"
    ]),
    name: "none",
    data: $58B0H.types.frozen({})
}), module.exports.Shape = $9xvfK.Node.named("Shape").props({
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    rotation: 0,
    opacity: 1,
    animations: $58B0H.types.array(module.exports.Animation),
    blurEnabled: !1,
    blurRadius: 10,
    brightnessEnabled: !1,
    brightness: 0,
    sepiaEnabled: !1,
    grayscaleEnabled: !1,
    shadowEnabled: !1,
    shadowBlur: 5,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    shadowColor: "black",
    shadowOpacity: 1,
    visible: !0,
    draggable: !0,
    resizable: !0,
    selectable: !0,
    contentEditable: !0,
    styleEditable: !0,
    alwaysOnTop: !1,
    showInExport: !0
}).preProcessSnapshot((e)=>{
    const t = Object.assign(Object.assign({}, e), {
        x: e.x || 0,
        y: e.y || 0
    });
    return "width" in e && (t.width = t.width || 1), "height" in e && (t.height = t.height || 1), e.locked && (t.draggable = !1, t.contentEditable = !1, t.styleEditable = !1, t.resizable = !1), t;
}).views((e)=>({
        get a () {
            const { currentTime: t } = e.store, a = {
                x: e.x,
                y: e.y,
                width: e.width,
                height: e.height,
                rotation: e.rotation,
                opacity: e.opacity,
                color: e.color,
                fontSize: e.fontSize
            };
            if (0 === t) return a;
            const n = t - e.page.startTime;
            if (n > e.page.duration) return a;
            if (n < 0) return a;
            const i = e.store.animatedElementsIds;
            if (i.length && !i.includes(e.id)) return a;
            const o = e.animations.find((e)=>"enter" === e.type);
            (null == o ? void 0 : o.enabled) && n < o.delay && (a.opacity = 0);
            if ((null == o ? void 0 : o.enabled) && n >= o.delay && n <= o.delay + o.duration) {
                const t = n - o.delay, i = (0, $UnmLk.animate)({
                    element: e,
                    animation: o,
                    dTime: t
                });
                Object.assign(a, i);
            }
            const s = e.animations.find((e)=>"exit" === e.type);
            if ((null == s ? void 0 : s.enabled) && n >= e.page.duration - s.duration) {
                const t = n - (e.page.duration - s.duration), i = (0, $UnmLk.animate)({
                    element: e,
                    animation: s,
                    dTime: t
                });
                Object.assign(a, i);
            }
            return a;
        },
        animated: (t)=>e.a[t]
    })).actions((e)=>({
        setAnimation (t, a) {
            const n = e.animations.find((e)=>e.type === t);
            n ? Object.assign(n, a) : e.animations.push(Object.assign({
                type: t
            }, a));
        }
    }));

});
parcelRegister("UnmLk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.registerAnimation = module.exports.animate = module.exports.animations = void 0;
const $0a975b1af736efb8$var$MOVE_DIRECTION = {
    right: {
        from: {
            x: -200
        },
        to: {
            x: 0
        }
    },
    left: {
        from: {
            x: 200
        },
        to: {
            x: 0
        }
    },
    up: {
        from: {
            y: 200
        },
        to: {
            y: 0
        }
    },
    down: {
        from: {
            y: -200
        },
        to: {
            y: 0
        }
    },
    "bottom-right": {
        from: {
            x: -200,
            y: -200
        },
        to: {
            x: 0,
            y: 0
        }
    },
    "bottom-left": {
        from: {
            x: 200,
            y: -200
        },
        to: {
            x: 0,
            y: 0
        }
    },
    "top-right": {
        from: {
            x: -200,
            y: 200
        },
        to: {
            x: 0,
            y: 0
        }
    },
    "top-left": {
        from: {
            x: 200,
            y: 200
        },
        to: {
            x: 0,
            y: 0
        }
    }
};
module.exports.animations = {
    fade: ({ dTime: t, element: o, animation: e })=>{
        const i = t / e.duration;
        return "enter" === e.type ? {
            opacity: i * o.opacity
        } : {
            opacity: (1 - i) * o.opacity
        };
    },
    move: ({ dTime: t, element: o, animation: e })=>{
        const i = $0a975b1af736efb8$var$MOVE_DIRECTION[e.data.direction] || $0a975b1af736efb8$var$MOVE_DIRECTION.right, n = {};
        for(var r in i.from){
            let a = i.from[r], m = i.to[r];
            "exit" === e.type && (a = i.to[r], m = -i.from[r]);
            const s = o[r] + a, x = o[r] + m - s;
            n[r] = s + t / e.duration * x;
        }
        return n;
    },
    zoom: ({ dTime: t, element: o, animation: e })=>{
        const i = {}, n = {
            x: o.x + o.width / 3,
            y: o.y + o.height / 3,
            width: o.width / 3,
            height: o.height / 3,
            fontSize: o.fontSize / 3
        }, r = {
            x: o.x,
            y: o.y,
            width: o.width,
            height: o.height,
            fontSize: o.fontSize
        };
        for(var a in n){
            let o = n[a], m = r[a];
            if ("exit" === e.type) {
                const t = o;
                o = m, m = t;
            }
            const s = m - o;
            i[a] = o + t / e.duration * s;
        }
        return i;
    }
};
const $0a975b1af736efb8$var$animate = ({ element: t, dTime: o, animation: e })=>{
    const i = module.exports.animations[e.name];
    return i ? i({
        element: t,
        dTime: o,
        animation: e
    }) : (console.error("Can not find animation type: " + e.name), {});
};
module.exports.animate = $0a975b1af736efb8$var$animate;
const $0a975b1af736efb8$var$registerAnimation = (t, o)=>{};
module.exports.registerAnimation = $0a975b1af736efb8$var$registerAnimation;

});


parcelRegister("dPiE9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.TextElement = void 0;

var $58B0H = parcelRequire("58B0H");

var $lfvTK = parcelRequire("lfvTK");
module.exports.TextElement = $lfvTK.Shape.named("Text").props({
    type: "text",
    text: "",
    placeholder: "",
    fontSize: 14,
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "",
    fill: "black",
    align: "center",
    width: 100,
    height: 0,
    verticalAlign: "top",
    strokeWidth: 0,
    stroke: "black",
    lineHeight: $58B0H.types.optional($58B0H.types.union($58B0H.types.number, $58B0H.types.string), 1.2),
    letterSpacing: 0,
    _editModeEnabled: !1,
    backgroundEnabled: !1,
    backgroundColor: "#7ED321",
    backgroundOpacity: 1,
    backgroundCornerRadius: .5,
    backgroundPadding: .5
}).preProcessSnapshot((e)=>Object.assign({}, e)).actions((e)=>({
        toggleEditMode (t) {
            e._editModeEnabled = null != t ? t : !e._editModeEnabled, e._editModeEnabled ? e.store.history.startTransaction() : e.store.history.endTransaction();
        }
    }));

});

parcelRegister("cgQqz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.ImageElement = void 0;

var $lfvTK = parcelRequire("lfvTK");
module.exports.ImageElement = $lfvTK.Shape.named("Image").props({
    type: "image",
    width: 100,
    height: 100,
    src: "",
    cropX: 0,
    cropY: 0,
    cropWidth: 1,
    cropHeight: 1,
    cornerRadius: 0,
    flipX: !1,
    flipY: !1,
    clipSrc: "",
    borderColor: "black",
    borderSize: 0,
    keepRatio: !1,
    _cropModeEnabled: !1
}).actions((e)=>({
        toggleCropMode (o) {
            e._cropModeEnabled = null != o ? o : !e._cropModeEnabled, e._cropModeEnabled ? e.store.history.startTransaction() : e.store.history.endTransaction();
        },
        beforeDestroy () {
            e._cropModeEnabled && e.store.history.endTransaction();
        }
    }));

});

parcelRegister("btOWX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.VideoElement = void 0;

var $cgQqz = parcelRequire("cgQqz");
module.exports.VideoElement = $cgQqz.ImageElement.named("Video").props({
    type: "video",
    duration: 0,
    startTime: 0,
    endTime: 1
});

});

parcelRegister("atkrP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.LineElement = void 0;

var $58B0H = parcelRequire("58B0H");

var $lfvTK = parcelRequire("lfvTK");
module.exports.LineElement = $lfvTK.Shape.named("Line").props({
    type: "line",
    width: 400,
    height: 10,
    color: "black",
    dash: $58B0H.types.array($58B0H.types.number),
    startHead: "",
    endHead: ""
}).actions((e)=>({}));

});

parcelRegister("j92iZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.SVGElement = void 0;

var $58B0H = parcelRequire("58B0H");

var $lfvTK = parcelRequire("lfvTK");
module.exports.SVGElement = $lfvTK.Shape.named("SVG").props({
    type: "svg",
    src: "",
    maskSrc: "",
    cropX: 0,
    cropY: 0,
    cropWidth: 1,
    cropHeight: 1,
    keepRatio: !0,
    flipX: !1,
    flipY: !1,
    width: 100,
    height: 100,
    borderColor: "black",
    borderSize: 0,
    cornerRadius: 0,
    colorsReplace: $58B0H.types.map($58B0H.types.string)
}).preProcessSnapshot((e)=>Object.assign(Object.assign({}, e), {
        src: e.src || e.svgSource
    })).actions((e)=>({
        replaceColor (r, s) {
            e.colorsReplace.set(r, s);
        }
    }));

});

parcelRegister("bjsE3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.FigureElement = void 0;

var $58B0H = parcelRequire("58B0H");

var $lfvTK = parcelRequire("lfvTK");
module.exports.FigureElement = $lfvTK.Shape.named("Figure").props({
    type: "figure",
    subType: "rect",
    fill: "rgb(0, 161, 255)",
    dash: $58B0H.types.array($58B0H.types.number),
    strokeWidth: 0,
    stroke: "rgba(98, 197, 255, 1)",
    cornerRadius: 0
});

});



parcelRegister("xARwM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.t = module.exports.getTranslations = module.exports.setTranslations = void 0;

var $2SBKn = parcelRequire("2SBKn");
const $064fad46f6b3dbc0$var$translation = (0, $2SBKn.observable)({
    toolbar: {
        duration: "Duration",
        opacity: "Opacity",
        effects: "Effects",
        blur: "Blur",
        textBackground: "Background",
        backgroundCornerRadius: "Corner radius",
        backgroundOpacity: "Opacity",
        backgroundPadding: "Padding",
        brightness: "Brightness",
        sepia: "Sepia",
        grayscale: "Grayscale",
        textStroke: "Text Stroke",
        shadow: "Shadow",
        border: "Border",
        cornerRadius: "Corner Radius",
        position: "Position",
        layering: "Layering",
        toForward: "To forward",
        up: "Up",
        down: "Down",
        toBottom: "To bottom",
        alignLeft: "Align left",
        alignCenter: "Align center",
        alignRight: "Align right",
        alignTop: "Align top",
        alignMiddle: "Align middle",
        alignBottom: "Align bottom",
        flip: "Flip",
        flipHorizontally: "Flip horizontally",
        flipVertically: "Flip vertically",
        fitToBackground: "Fit to page",
        removeBackground: "Remove background",
        removeBackgroundTitle: "Remove background from image",
        cancelRemoveBackground: "Cancel",
        confirmRemoveBackground: "Confirm",
        crop: "Crop",
        cropDone: "Done",
        cropCancel: "Cancel",
        clip: "Apply mask",
        removeClip: "Remove mask",
        removeMask: "Remove mask",
        transparency: "Transparency",
        lockedDescription: "Object is locked. Unlock it to allow changes from canvas.",
        unlockedDescription: "Object is unlocked. Lock it to prevent changes from canvas.",
        removeElements: "Remove elements",
        duplicateElements: "Duplicate elements",
        download: "Download",
        saveAsImage: "Save as image",
        saveAsPDF: "Save as PDF",
        lineHeight: "Line height",
        letterSpacing: "Letter spacing",
        offsetX: "Offset X",
        offsetY: "Offset Y",
        color: "Color",
        selectable: "Selectable",
        draggable: "Draggable",
        removable: "Removable",
        resizable: "Resizable",
        contentEditable: "Can change content",
        styleEditable: "Can change style",
        alwaysOnTop: "Always on top",
        showInExport: "Show in export",
        ungroupElements: "Ungroup",
        groupElements: "Group",
        lineSize: "Line size",
        fade: "Fade",
        move: "Move",
        zoom: "Zoom",
        animate: "Animate",
        spaceEvenly: "Space evenly",
        horizontalDistribution: "Horizontally",
        verticalDistribution: "Vertically",
        strokeWidth: "Stroke Width",
        colorPicker: {
            solid: "Solid",
            linear: "Linear"
        }
    },
    workspace: {
        noPages: "There are no pages yet...",
        addPage: "Add page",
        removePage: "Remove page",
        duplicatePage: "Duplicate page",
        moveUp: "Move up",
        moveDown: "Move down"
    },
    scale: {
        reset: "Reset"
    },
    error: {
        removeBackground: "Ops! Something went wrong. Background can not be removed."
    },
    sidePanel: {
        templates: "Templates",
        searchTemplatesWithSameSize: "Show templates with the same size",
        searchPlaceholder: "Search...",
        otherFormats: "Other formats",
        noResults: "No results",
        error: "Loading is failed...",
        text: "Text",
        uploadFont: "Upload font",
        myFonts: "My fonts",
        photos: "Photos",
        elements: "Elements",
        shapes: "Shapes",
        lines: "Lines",
        upload: "Upload",
        uploadImage: "Upload Image",
        uploadTip: "Do you want to upload your own images?",
        background: "Background",
        resize: "Resize",
        layers: "Layers",
        layerTypes: {
            image: "Image",
            text: "Text",
            svg: "SVG",
            line: "Line",
            figure: "Figure",
            group: "Group"
        },
        layersTip: "Elements on your active page:",
        noLayers: "No elements on the page...",
        namePlaceholder: "Type element name...",
        useMagicResize: "Use magic resize",
        clipImage: "Mask image",
        width: "Width",
        height: "Height",
        magicResizeDescription: "Magic resize will automatically resize and move all elements on the canvas",
        headerText: "Header",
        createHeader: "Create header",
        subHeaderText: "Sub Header",
        createSubHeader: "Create sub header",
        bodyText: "Body text",
        createBody: "Create body text"
    }
});
function $064fad46f6b3dbc0$var$get(e, o) {
    var a, t = o.split("."), r = e;
    for(a = 0; a < t.length; ++a){
        if (null == r[t[a]]) return;
        r = r[t[a]];
    }
    return r;
}
const $064fad46f6b3dbc0$var$isObject = (e)=>e && "object" == typeof e;
function $064fad46f6b3dbc0$var$mergeDeep(e, o) {
    Object.keys(o).forEach((a)=>{
        const t = e[a], r = o[a];
        $064fad46f6b3dbc0$var$isObject(r) && $064fad46f6b3dbc0$var$isObject(t) ? $064fad46f6b3dbc0$var$mergeDeep(t, r) : e[a] = r;
    });
}
module.exports.setTranslations = (0, $2SBKn.action)((e)=>{
    $064fad46f6b3dbc0$var$mergeDeep($064fad46f6b3dbc0$var$translation, e);
});
const $064fad46f6b3dbc0$var$getTranslations = ()=>(0, $2SBKn.toJS)($064fad46f6b3dbc0$var$translation);
module.exports.getTranslations = $064fad46f6b3dbc0$var$getTranslations;
const $064fad46f6b3dbc0$var$WARNED = {}, $064fad46f6b3dbc0$var$t = (e)=>{
    const o = $064fad46f6b3dbc0$var$get($064fad46f6b3dbc0$var$translation, e);
    if (void 0 !== o) return o;
    $064fad46f6b3dbc0$var$WARNED[e] || ($064fad46f6b3dbc0$var$WARNED[e] = !0, console.warn(`Missing translation '${e}'`));
    const a = e.split("."), t = a[a.length - 1] || " ";
    return t.charAt(0).toUpperCase() + t.slice(1);
};
module.exports.t = $064fad46f6b3dbc0$var$t;

});


parcelRegister("aCLBN", function(module, exports) {
"use strict";
var $7bc2621098434d06$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.PageControls = void 0;

const $7bc2621098434d06$var$react_1 = $7bc2621098434d06$var$__importDefault((parcelRequire("8NFma")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

var $gUePa = parcelRequire("gUePa");
var $gVVt3 = parcelRequire("gVVt3");

var $xARwM = parcelRequire("xARwM");
module.exports.PageControls = (0, $O1ETn.observer)(({ store: e, page: t, xPadding: o, yPadding: a })=>{
    const n = e.pages.length > 1, r = e.pages.indexOf(t);
    return $7bc2621098434d06$var$react_1.default.createElement("div", {
        style: {
            position: "absolute",
            top: a - 40 + "px",
            right: o + "px"
        }
    }, n && $7bc2621098434d06$var$react_1.default.createElement($gVVt3.Tooltip, {
        content: (0, $xARwM.t)("workspace.moveUp"),
        disabled: 0 === r
    }, $7bc2621098434d06$var$react_1.default.createElement($gUePa.Button, {
        icon: "chevron-up",
        minimal: !0,
        disabled: 0 === r,
        onClick: ()=>{
            t.setZIndex(r - 1);
        }
    })), n && $7bc2621098434d06$var$react_1.default.createElement($gVVt3.Tooltip, {
        content: (0, $xARwM.t)("workspace.moveDown"),
        disabled: r === e.pages.length - 1
    }, $7bc2621098434d06$var$react_1.default.createElement($gUePa.Button, {
        icon: "chevron-down",
        minimal: !0,
        disabled: r === e.pages.length - 1,
        onClick: ()=>{
            const o = e.pages.indexOf(t);
            t.setZIndex(o + 1);
        }
    })), $7bc2621098434d06$var$react_1.default.createElement($gVVt3.Tooltip, {
        content: (0, $xARwM.t)("workspace.duplicatePage")
    }, $7bc2621098434d06$var$react_1.default.createElement($gUePa.Button, {
        icon: "duplicate",
        minimal: !0,
        onClick: ()=>{
            t.clone();
        }
    })), n && $7bc2621098434d06$var$react_1.default.createElement($gVVt3.Tooltip, {
        content: (0, $xARwM.t)("workspace.removePage")
    }, $7bc2621098434d06$var$react_1.default.createElement($gUePa.Button, {
        icon: "trash",
        minimal: !0,
        onClick: ()=>{
            e.deletePages([
                t.id
            ]);
        }
    })), $7bc2621098434d06$var$react_1.default.createElement($gVVt3.Tooltip, {
        content: (0, $xARwM.t)("workspace.addPage")
    }, $7bc2621098434d06$var$react_1.default.createElement($gUePa.Button, {
        icon: "insert",
        minimal: !0,
        onClick: ()=>{
            var o;
            const a = e.addPage({
                bleed: (null === (o = e.activePage) || void 0 === o ? void 0 : o.bleed) || 0
            }), n = e.pages.indexOf(t);
            a.setZIndex(n + 1);
        }
    })));
});

});
parcelRegister("gUePa", function(module, exports) {

$parcel$export(module.exports, "Button", () => $c4ed601db6b2f977$export$353f5b6fc5456de1);
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $auzpd = parcelRequire("auzpd");
var $iP8Ix = parcelRequire("iP8Ix");

var $hffzE = parcelRequire("hffzE");

var $8k66C = parcelRequire("8k66C");

var $gKgL3 = parcelRequire("gKgL3");

var $h3xJq = parcelRequire("h3xJq");

var $M9AJy = parcelRequire("M9AJy");
var $c4ed601db6b2f977$export$353f5b6fc5456de1 = $8NFma.forwardRef(function(props, ref) {
    var commonAttributes = $c4ed601db6b2f977$var$useSharedButtonAttributes(props, ref);
    return $8NFma.createElement("button", (0, $gztBd.__assign)({
        type: "button"
    }, (0, $hffzE.removeNonHTMLProps)(props), commonAttributes), $c4ed601db6b2f977$var$renderButtonContents(props));
});
$c4ed601db6b2f977$export$353f5b6fc5456de1.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".Button");
var $c4ed601db6b2f977$export$59a34841c163ed64 = $8NFma.forwardRef(function(props, ref) {
    var href = props.href, _a = props.tabIndex, tabIndex = _a === void 0 ? 0 : _a;
    var commonProps = $c4ed601db6b2f977$var$useSharedButtonAttributes(props, ref);
    return $8NFma.createElement("a", (0, $gztBd.__assign)({
        role: "button"
    }, (0, $hffzE.removeNonHTMLProps)(props), commonProps, {
        "aria-disabled": commonProps.disabled,
        href: commonProps.disabled ? undefined : href,
        tabIndex: commonProps.disabled ? -1 : tabIndex
    }), $c4ed601db6b2f977$var$renderButtonContents(props));
});
$c4ed601db6b2f977$export$59a34841c163ed64.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".AnchorButton");
/**
 * Most of the button logic lives in this shared hook.
 */ function $c4ed601db6b2f977$var$useSharedButtonAttributes(props, ref) {
    var _a;
    var _b = props.active, active = _b === void 0 ? false : _b, alignText = props.alignText, fill = props.fill, large = props.large, _c = props.loading, loading = _c === void 0 ? false : _c, minimal = props.minimal, onBlur = props.onBlur, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, outlined = props.outlined, small = props.small, tabIndex = props.tabIndex;
    var disabled = props.disabled || loading;
    // the current key being pressed
    var _d = $8NFma.useState(), currentKeyPressed = _d[0], setCurrentKeyPressed = _d[1];
    // whether the button is in "active" state
    var _e = $8NFma.useState(false), isActive = _e[0], setIsActive = _e[1];
    // our local ref for the button element, merged with the consumer's own ref (if supplied) in this hook's return value
    var buttonRef = $8NFma.useRef(null);
    var handleBlur = $8NFma.useCallback(function(e) {
        if (isActive) setIsActive(false);
        onBlur === null || onBlur === void 0 || onBlur(e);
    }, [
        isActive,
        onBlur
    ]);
    var handleKeyDown = $8NFma.useCallback(function(e) {
        if ((0, $iP8Ix).isKeyboardClick(e)) {
            e.preventDefault();
            if (e.key !== currentKeyPressed) setIsActive(true);
        }
        setCurrentKeyPressed(e.key);
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
    }, [
        currentKeyPressed,
        onKeyDown
    ]);
    var handleKeyUp = $8NFma.useCallback(function(e) {
        var _a;
        if ((0, $iP8Ix).isKeyboardClick(e)) {
            setIsActive(false);
            (_a = buttonRef.current) === null || _a === void 0 || _a.click();
        }
        setCurrentKeyPressed(undefined);
        onKeyUp === null || onKeyUp === void 0 || onKeyUp(e);
    }, [
        onKeyUp
    ]);
    var className = (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $auzpd).BUTTON, (_a = {}, _a[(0, $auzpd).ACTIVE] = !disabled && (active || isActive), _a[(0, $auzpd).DISABLED] = disabled, _a[(0, $auzpd).FILL] = fill, _a[(0, $auzpd).LARGE] = large, _a[(0, $auzpd).LOADING] = loading, _a[(0, $auzpd).MINIMAL] = minimal, _a[(0, $auzpd).OUTLINED] = outlined, _a[(0, $auzpd).SMALL] = small, _a), (0, $auzpd).alignmentClass(alignText), (0, $auzpd).intentClass(props.intent), props.className);
    return {
        className: className,
        disabled: disabled,
        onBlur: handleBlur,
        onClick: disabled ? undefined : props.onClick,
        onFocus: disabled ? undefined : props.onFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: (0, $8k66C.mergeRefs)(buttonRef, ref),
        tabIndex: disabled ? -1 : tabIndex
    };
}
/**
 * Shared rendering code for button contents.
 */ function $c4ed601db6b2f977$var$renderButtonContents(props) {
    var children = props.children, ellipsizeText = props.ellipsizeText, icon = props.icon, loading = props.loading, rightIcon = props.rightIcon, text = props.text, textClassName = props.textClassName;
    var hasTextContent = !(0, $iP8Ix).isReactNodeEmpty(text) || !(0, $iP8Ix).isReactNodeEmpty(children);
    return $8NFma.createElement($8NFma.Fragment, null, loading && $8NFma.createElement((0, $h3xJq.Spinner), {
        key: "loading",
        className: (0, $auzpd).BUTTON_SPINNER,
        size: (0, $h3xJq.SpinnerSize).SMALL
    }), $8NFma.createElement((0, $gKgL3.Icon), {
        key: "leftIcon",
        icon: icon
    }), hasTextContent && $8NFma.createElement((0, $M9AJy.Text), {
        key: "text",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $auzpd).BUTTON_TEXT, textClassName),
        ellipsize: ellipsizeText,
        tagName: "span"
    }, text, children), $8NFma.createElement((0, $gKgL3.Icon), {
        key: "rightIcon",
        icon: rightIcon
    }));
}

});
parcelRegister("gztBd", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $c106e002a49a00cb$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $c106e002a49a00cb$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $c106e002a49a00cb$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $c106e002a49a00cb$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $c106e002a49a00cb$export$67ebef60e6f28a6);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $c106e002a49a00cb$var$extendStatics = function(d, b) {
    $c106e002a49a00cb$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $c106e002a49a00cb$var$extendStatics(d, b);
};
function $c106e002a49a00cb$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $c106e002a49a00cb$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $c106e002a49a00cb$export$18ce0697a983be9b = function() {
    $c106e002a49a00cb$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c106e002a49a00cb$export$18ce0697a983be9b.apply(this, arguments);
};
function $c106e002a49a00cb$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $c106e002a49a00cb$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $c106e002a49a00cb$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $c106e002a49a00cb$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $c106e002a49a00cb$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $c106e002a49a00cb$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $c106e002a49a00cb$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $c106e002a49a00cb$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $c106e002a49a00cb$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $c106e002a49a00cb$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $c106e002a49a00cb$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $c106e002a49a00cb$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $c106e002a49a00cb$export$45d3717a4c69092e(o, m, p);
}
function $c106e002a49a00cb$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $c106e002a49a00cb$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $c106e002a49a00cb$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($c106e002a49a00cb$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $c106e002a49a00cb$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $c106e002a49a00cb$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $c106e002a49a00cb$export$10c90e4f7922046c(v) {
    return this instanceof $c106e002a49a00cb$export$10c90e4f7922046c ? (this.v = v, this) : new $c106e002a49a00cb$export$10c90e4f7922046c(v);
}
function $c106e002a49a00cb$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $c106e002a49a00cb$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $c106e002a49a00cb$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $c106e002a49a00cb$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $c106e002a49a00cb$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $c106e002a49a00cb$export$19a8beecd37a4c45 === "function" ? $c106e002a49a00cb$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $c106e002a49a00cb$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $c106e002a49a00cb$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $c106e002a49a00cb$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c106e002a49a00cb$export$45d3717a4c69092e(result, mod, k);
    }
    $c106e002a49a00cb$var$__setModuleDefault(result, mod);
    return result;
}
function $c106e002a49a00cb$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $c106e002a49a00cb$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $c106e002a49a00cb$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $c106e002a49a00cb$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $c106e002a49a00cb$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $c106e002a49a00cb$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $c106e002a49a00cb$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $c106e002a49a00cb$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $c106e002a49a00cb$export$2e2bcd8739ae039 = {
    __extends: $c106e002a49a00cb$export$a8ba968b8961cb8a,
    __assign: $c106e002a49a00cb$export$18ce0697a983be9b,
    __rest: $c106e002a49a00cb$export$3c9a16f847548506,
    __decorate: $c106e002a49a00cb$export$29e00dfd3077644b,
    __param: $c106e002a49a00cb$export$d5ad3fd78186038f,
    __metadata: $c106e002a49a00cb$export$f1db080c865becb9,
    __awaiter: $c106e002a49a00cb$export$1050f835b63b671e,
    __generator: $c106e002a49a00cb$export$67ebef60e6f28a6,
    __createBinding: $c106e002a49a00cb$export$45d3717a4c69092e,
    __exportStar: $c106e002a49a00cb$export$f33643c0debef087,
    __values: $c106e002a49a00cb$export$19a8beecd37a4c45,
    __read: $c106e002a49a00cb$export$8d051b38c9118094,
    __spread: $c106e002a49a00cb$export$afc72e2116322959,
    __spreadArrays: $c106e002a49a00cb$export$6388937ca91ccae8,
    __spreadArray: $c106e002a49a00cb$export$1216008129fb82ed,
    __await: $c106e002a49a00cb$export$10c90e4f7922046c,
    __asyncGenerator: $c106e002a49a00cb$export$e427f37a30a4de9b,
    __asyncDelegator: $c106e002a49a00cb$export$bbd80228419bb833,
    __asyncValues: $c106e002a49a00cb$export$e3b29a3d6162315f,
    __makeTemplateObject: $c106e002a49a00cb$export$4fb47efe1390b86f,
    __importStar: $c106e002a49a00cb$export$c21735bcef00d192,
    __importDefault: $c106e002a49a00cb$export$da59b14a69baef04,
    __classPrivateFieldGet: $c106e002a49a00cb$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $c106e002a49a00cb$export$d40a35129aaff81f,
    __classPrivateFieldIn: $c106e002a49a00cb$export$81fdc39f203e4e04,
    __addDisposableResource: $c106e002a49a00cb$export$88ac25d8e944e405,
    __disposeResources: $c106e002a49a00cb$export$8f076105dc360e92
};

});

parcelRegister("lmhZG", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("auzpd", function(module, exports) {

$parcel$export(module.exports, "ACTIVE", () => $7a382b8d33300736$export$2b35adb71b3f6143);
$parcel$export(module.exports, "ALIGN_LEFT", () => $7a382b8d33300736$export$7895aadd1956b1c7);
$parcel$export(module.exports, "ALIGN_RIGHT", () => $7a382b8d33300736$export$f1299af03a3c605a);
$parcel$export(module.exports, "COMPACT", () => $7a382b8d33300736$export$db1cdb8627b81f84);
$parcel$export(module.exports, "DARK", () => $7a382b8d33300736$export$b9b16d1820185434);
$parcel$export(module.exports, "DISABLED", () => $7a382b8d33300736$export$8cd212c10b4124d2);
$parcel$export(module.exports, "FILL", () => $7a382b8d33300736$export$5672a3e1deb5b505);
$parcel$export(module.exports, "FIXED", () => $7a382b8d33300736$export$91f67f1eeaea8c1e);
$parcel$export(module.exports, "FIXED_TOP", () => $7a382b8d33300736$export$3df9f2c23b50ca42);
$parcel$export(module.exports, "INLINE", () => $7a382b8d33300736$export$1ff9623b26415f8);
$parcel$export(module.exports, "INTERACTIVE", () => $7a382b8d33300736$export$ceebd5febfdef8a3);
$parcel$export(module.exports, "LARGE", () => $7a382b8d33300736$export$7b93a10c0fefe3e3);
$parcel$export(module.exports, "LOADING", () => $7a382b8d33300736$export$26d55645375ca9a);
$parcel$export(module.exports, "MINIMAL", () => $7a382b8d33300736$export$a61ada011bb84f5);
$parcel$export(module.exports, "OUTLINED", () => $7a382b8d33300736$export$d31ef73d8bd6b2be);
$parcel$export(module.exports, "PADDED", () => $7a382b8d33300736$export$1f3db38142bdf083);
$parcel$export(module.exports, "MULTILINE", () => $7a382b8d33300736$export$49f467056ef3fc6c);
$parcel$export(module.exports, "READ_ONLY", () => $7a382b8d33300736$export$a45819e0f9bcfea2);
$parcel$export(module.exports, "ROUND", () => $7a382b8d33300736$export$58785fc667c0c50b);
$parcel$export(module.exports, "SELECTED", () => $7a382b8d33300736$export$657f886463d93938);
$parcel$export(module.exports, "SMALL", () => $7a382b8d33300736$export$71dd4c8ecd45e95f);
$parcel$export(module.exports, "VERTICAL", () => $7a382b8d33300736$export$9f2fe7df0ae9fdea);
$parcel$export(module.exports, "POSITION_TOP", () => $7a382b8d33300736$export$4fb34bdcd97adf85);
$parcel$export(module.exports, "positionClass", () => $7a382b8d33300736$export$4f8aee4b943e40e);
$parcel$export(module.exports, "POSITION_BOTTOM", () => $7a382b8d33300736$export$cec9b06edc71d96c);
$parcel$export(module.exports, "POSITION_LEFT", () => $7a382b8d33300736$export$b0758137ee643e7);
$parcel$export(module.exports, "POSITION_RIGHT", () => $7a382b8d33300736$export$4ed9c122bcc20157);
$parcel$export(module.exports, "ELEVATION_0", () => $7a382b8d33300736$export$c8efb467fc55a6a1);
$parcel$export(module.exports, "elevationClass", () => $7a382b8d33300736$export$b7727d57dec24270);
$parcel$export(module.exports, "ELEVATION_1", () => $7a382b8d33300736$export$7b5afc1ddf65f8b7);
$parcel$export(module.exports, "ELEVATION_2", () => $7a382b8d33300736$export$86dd92dfea4f39dd);
$parcel$export(module.exports, "ELEVATION_3", () => $7a382b8d33300736$export$ef7592bd90f2537f);
$parcel$export(module.exports, "ELEVATION_4", () => $7a382b8d33300736$export$1d67a24a95ef24c2);
$parcel$export(module.exports, "INTENT_PRIMARY", () => $7a382b8d33300736$export$37c8deab6e9ff120);
$parcel$export(module.exports, "intentClass", () => $7a382b8d33300736$export$6771d82d925c8189);
$parcel$export(module.exports, "INTENT_SUCCESS", () => $7a382b8d33300736$export$fd8d2f5f74a29424);
$parcel$export(module.exports, "INTENT_WARNING", () => $7a382b8d33300736$export$355c57fd095a7f5a);
$parcel$export(module.exports, "INTENT_DANGER", () => $7a382b8d33300736$export$373495f4c0568b73);
$parcel$export(module.exports, "FOCUS_DISABLED", () => $7a382b8d33300736$export$aeda8252e54b50f7);
$parcel$export(module.exports, "FOCUS_STYLE_MANAGER_IGNORE", () => $7a382b8d33300736$export$bedc1b77a139edca);
$parcel$export(module.exports, "UI_TEXT", () => $7a382b8d33300736$export$88620a540780da7c);
$parcel$export(module.exports, "RUNNING_TEXT", () => $7a382b8d33300736$export$d0190f823696a5cc);
$parcel$export(module.exports, "MONOSPACE_TEXT", () => $7a382b8d33300736$export$558d226ddadcf457);
$parcel$export(module.exports, "TEXT_LARGE", () => $7a382b8d33300736$export$50e449675bbd8ae2);
$parcel$export(module.exports, "TEXT_SMALL", () => $7a382b8d33300736$export$504f956f6b2a8e65);
$parcel$export(module.exports, "TEXT_MUTED", () => $7a382b8d33300736$export$31a5874ec7f49f29);
$parcel$export(module.exports, "TEXT_DISABLED", () => $7a382b8d33300736$export$4aa79107ea222f04);
$parcel$export(module.exports, "TEXT_OVERFLOW_ELLIPSIS", () => $7a382b8d33300736$export$cd50c877adf39dd7);
$parcel$export(module.exports, "BLOCKQUOTE", () => $7a382b8d33300736$export$afa7aa09bb57d54f);
$parcel$export(module.exports, "CODE", () => $7a382b8d33300736$export$ec5856072852bd7f);
$parcel$export(module.exports, "CODE_BLOCK", () => $7a382b8d33300736$export$cf55d1bff75690da);
$parcel$export(module.exports, "HEADING", () => $7a382b8d33300736$export$eef1738e402a65e6);
$parcel$export(module.exports, "LIST", () => $7a382b8d33300736$export$84cc8e12a434d4e);
$parcel$export(module.exports, "LIST_UNSTYLED", () => $7a382b8d33300736$export$e52b656749d9474c);
$parcel$export(module.exports, "RTL", () => $7a382b8d33300736$export$850f7749a2909601);
$parcel$export(module.exports, "ALERT", () => $7a382b8d33300736$export$8dfce1a3f4c39a);
$parcel$export(module.exports, "ALERT_BODY", () => $7a382b8d33300736$export$5d3ddfb12869545d);
$parcel$export(module.exports, "ALERT_CONTENTS", () => $7a382b8d33300736$export$1dba7da5e8205b5f);
$parcel$export(module.exports, "ALERT_FOOTER", () => $7a382b8d33300736$export$a928c8e2db526b6c);
$parcel$export(module.exports, "BREADCRUMB", () => $7a382b8d33300736$export$474829b260ce19ab);
$parcel$export(module.exports, "BREADCRUMB_CURRENT", () => $7a382b8d33300736$export$d25ee28b316abe2a);
$parcel$export(module.exports, "BREADCRUMBS", () => $7a382b8d33300736$export$c3619772211b515b);
$parcel$export(module.exports, "BREADCRUMBS_COLLAPSED", () => $7a382b8d33300736$export$6c5df38f864cf0e3);
$parcel$export(module.exports, "BUTTON", () => $7a382b8d33300736$export$b887e88d8d0739f6);
$parcel$export(module.exports, "BUTTON_GROUP", () => $7a382b8d33300736$export$cbb1216936bf389c);
$parcel$export(module.exports, "BUTTON_SPINNER", () => $7a382b8d33300736$export$3fd25a11349a7fac);
$parcel$export(module.exports, "BUTTON_TEXT", () => $7a382b8d33300736$export$22617f068a979d82);
$parcel$export(module.exports, "CALLOUT", () => $7a382b8d33300736$export$ae3fb0b35b6ca2a9);
$parcel$export(module.exports, "CALLOUT_HAS_BODY_CONTENT", () => $7a382b8d33300736$export$c801bbbb1e2ccb0b);
$parcel$export(module.exports, "CALLOUT_ICON", () => $7a382b8d33300736$export$c4700bfd78cb069a);
$parcel$export(module.exports, "CARD", () => $7a382b8d33300736$export$95783a805443ad7d);
$parcel$export(module.exports, "CONTROL_CARD", () => $7a382b8d33300736$export$6769bd973fd6af36);
$parcel$export(module.exports, "CONTROL_CARD_LABEL", () => $7a382b8d33300736$export$d60e975594bbe489);
$parcel$export(module.exports, "SWITCH_CONTROL_CARD", () => $7a382b8d33300736$export$9cedcb03c3922bb7);
$parcel$export(module.exports, "CHECKBOX_CONTROL_CARD", () => $7a382b8d33300736$export$3412f17fbe03c097);
$parcel$export(module.exports, "RADIO_CONTROL_CARD", () => $7a382b8d33300736$export$4de35bcdbf177a1f);
$parcel$export(module.exports, "CARD_LIST", () => $7a382b8d33300736$export$ad39b86c40d3c47c);
$parcel$export(module.exports, "CARD_LIST_BORDERED", () => $7a382b8d33300736$export$5adfba49857b538f);
$parcel$export(module.exports, "COLLAPSE", () => $7a382b8d33300736$export$a1b955d4799a6f74);
$parcel$export(module.exports, "COLLAPSE_BODY", () => $7a382b8d33300736$export$e4d292b696959393);
$parcel$export(module.exports, "CONTEXT_MENU", () => $7a382b8d33300736$export$6a0da22e72d4f0eb);
$parcel$export(module.exports, "CONTEXT_MENU_VIRTUAL_TARGET", () => $7a382b8d33300736$export$b9534b88b3cef166);
$parcel$export(module.exports, "CONTEXT_MENU_POPOVER", () => $7a382b8d33300736$export$7ee0ba3b9fa0a5ea);
$parcel$export(module.exports, "CONTEXT_MENU_BACKDROP", () => $7a382b8d33300736$export$418ef826d3ba978d);
$parcel$export(module.exports, "CONTROL_GROUP", () => $7a382b8d33300736$export$1c86bb6d85c165);
$parcel$export(module.exports, "DIALOG", () => $7a382b8d33300736$export$f99739dbfcd2e015);
$parcel$export(module.exports, "DIALOG_CONTAINER", () => $7a382b8d33300736$export$d84b649f32bf6ead);
$parcel$export(module.exports, "DIALOG_HEADER", () => $7a382b8d33300736$export$c09efbe888b20fd);
$parcel$export(module.exports, "DIALOG_BODY", () => $7a382b8d33300736$export$12096ec1410ccb2);
$parcel$export(module.exports, "DIALOG_BODY_SCROLL_CONTAINER", () => $7a382b8d33300736$export$dd51a6f3fef5a9d4);
$parcel$export(module.exports, "DIALOG_CLOSE_BUTTON", () => $7a382b8d33300736$export$9588cbdf14f4605f);
$parcel$export(module.exports, "DIALOG_FOOTER", () => $7a382b8d33300736$export$6ea271a01e7dc590);
$parcel$export(module.exports, "DIALOG_FOOTER_FIXED", () => $7a382b8d33300736$export$b60b0eff9b84a85c);
$parcel$export(module.exports, "DIALOG_FOOTER_MAIN_SECTION", () => $7a382b8d33300736$export$a01581f2cb63a5c5);
$parcel$export(module.exports, "DIALOG_FOOTER_ACTIONS", () => $7a382b8d33300736$export$6ab793fb94a2b7f8);
$parcel$export(module.exports, "DIALOG_STEP", () => $7a382b8d33300736$export$ff97c652790bdec);
$parcel$export(module.exports, "DIALOG_STEP_CONTAINER", () => $7a382b8d33300736$export$15158775e667dbe6);
$parcel$export(module.exports, "DIALOG_STEP_TITLE", () => $7a382b8d33300736$export$e6263bc32f85a4a4);
$parcel$export(module.exports, "DIALOG_STEP_ICON", () => $7a382b8d33300736$export$e7c377477d704043);
$parcel$export(module.exports, "DIALOG_STEP_VIEWED", () => $7a382b8d33300736$export$97e1fe7e02b9bd0);
$parcel$export(module.exports, "DIVIDER", () => $7a382b8d33300736$export$59669b530bfa91b6);
$parcel$export(module.exports, "DRAWER", () => $7a382b8d33300736$export$9d2de6eebf7462b5);
$parcel$export(module.exports, "DRAWER_BODY", () => $7a382b8d33300736$export$a772fb749abfcf1d);
$parcel$export(module.exports, "DRAWER_FOOTER", () => $7a382b8d33300736$export$b9287ddc8f6e3044);
$parcel$export(module.exports, "DRAWER_HEADER", () => $7a382b8d33300736$export$4cd03a6721b31533);
$parcel$export(module.exports, "EDITABLE_TEXT", () => $7a382b8d33300736$export$8cffb49e9dd41ae);
$parcel$export(module.exports, "EDITABLE_TEXT_CONTENT", () => $7a382b8d33300736$export$78b1aa7020d6af37);
$parcel$export(module.exports, "EDITABLE_TEXT_EDITING", () => $7a382b8d33300736$export$2d16d4c1c295606c);
$parcel$export(module.exports, "EDITABLE_TEXT_INPUT", () => $7a382b8d33300736$export$4d6e427d15d16553);
$parcel$export(module.exports, "EDITABLE_TEXT_PLACEHOLDER", () => $7a382b8d33300736$export$90d364a014ea6f0a);
$parcel$export(module.exports, "ENTITY_TITLE", () => $7a382b8d33300736$export$659c2dc95c10337e);
$parcel$export(module.exports, "ENTITY_TITLE_ELLIPSIZE", () => $7a382b8d33300736$export$c92e868735e7ed90);
$parcel$export(module.exports, "ENTITY_TITLE_HAS_SUBTITLE", () => $7a382b8d33300736$export$32306a4d67fbbec);
$parcel$export(module.exports, "ENTITY_TITLE_ICON_CONTAINER", () => $7a382b8d33300736$export$4a30999b77042528);
$parcel$export(module.exports, "ENTITY_TITLE_SUBTITLE", () => $7a382b8d33300736$export$6d113d689052ca80);
$parcel$export(module.exports, "ENTITY_TITLE_TAGS_CONTAINER", () => $7a382b8d33300736$export$2b6f21fa0a5321de);
$parcel$export(module.exports, "ENTITY_TITLE_TEXT", () => $7a382b8d33300736$export$dfa64ede72bd0307);
$parcel$export(module.exports, "ENTITY_TITLE_TITLE", () => $7a382b8d33300736$export$e57a71e20aa8627);
$parcel$export(module.exports, "ENTITY_TITLE_TITLE_AND_TAGS", () => $7a382b8d33300736$export$85f27204a6624107);
$parcel$export(module.exports, "FLEX_EXPANDER", () => $7a382b8d33300736$export$bab85e3adc70edd1);
$parcel$export(module.exports, "HTML_SELECT", () => $7a382b8d33300736$export$c50fbf6be7ac3331);
$parcel$export(module.exports, "SELECT", () => $7a382b8d33300736$export$718a6b7ababf8ba7);
$parcel$export(module.exports, "HTML_TABLE", () => $7a382b8d33300736$export$76a315d343674c9b);
$parcel$export(module.exports, "HTML_TABLE_BORDERED", () => $7a382b8d33300736$export$13618d7eda5fcc77);
$parcel$export(module.exports, "HTML_TABLE_STRIPED", () => $7a382b8d33300736$export$a2a4accb8fbddd4a);
$parcel$export(module.exports, "INPUT", () => $7a382b8d33300736$export$9ea760072c364d49);
$parcel$export(module.exports, "INPUT_GHOST", () => $7a382b8d33300736$export$e8d5c1be80b7588b);
$parcel$export(module.exports, "INPUT_GROUP", () => $7a382b8d33300736$export$87f36efdfb463a6f);
$parcel$export(module.exports, "INPUT_LEFT_CONTAINER", () => $7a382b8d33300736$export$9705bb16375b49e5);
$parcel$export(module.exports, "INPUT_ACTION", () => $7a382b8d33300736$export$217bb10d53bd2e48);
$parcel$export(module.exports, "RESIZABLE_INPUT_SPAN", () => $7a382b8d33300736$export$f038e7a42893c7e5);
$parcel$export(module.exports, "TEXT_AREA", () => $7a382b8d33300736$export$794d3720201fcdd9);
$parcel$export(module.exports, "TEXT_AREA_AUTO_RESIZE", () => $7a382b8d33300736$export$9c466612a9056aac);
$parcel$export(module.exports, "CONTROL", () => $7a382b8d33300736$export$43f367b3e957f219);
$parcel$export(module.exports, "CONTROL_INDICATOR", () => $7a382b8d33300736$export$947bb9f998f185cb);
$parcel$export(module.exports, "CONTROL_INDICATOR_CHILD", () => $7a382b8d33300736$export$f717c522dcd748f);
$parcel$export(module.exports, "CHECKBOX", () => $7a382b8d33300736$export$6b636bdca7063f33);
$parcel$export(module.exports, "RADIO", () => $7a382b8d33300736$export$f0fd3c01e562401e);
$parcel$export(module.exports, "RADIO_GROUP", () => $7a382b8d33300736$export$fd120c956045e61b);
$parcel$export(module.exports, "SWITCH", () => $7a382b8d33300736$export$d19595eff304150b);
$parcel$export(module.exports, "SWITCH_INNER_TEXT", () => $7a382b8d33300736$export$33abfe9257d195b1);
$parcel$export(module.exports, "FILE_INPUT", () => $7a382b8d33300736$export$57b7f518a2a69b0e);
$parcel$export(module.exports, "FILE_INPUT_HAS_SELECTION", () => $7a382b8d33300736$export$3359eeec929a0672);
$parcel$export(module.exports, "FILE_UPLOAD_INPUT", () => $7a382b8d33300736$export$c7e0715fb31daeab);
$parcel$export(module.exports, "FILE_UPLOAD_INPUT_CUSTOM_TEXT", () => $7a382b8d33300736$export$59e222d99c2278dc);
$parcel$export(module.exports, "KEY", () => $7a382b8d33300736$export$7167c830cefcb6b5);
$parcel$export(module.exports, "KEY_COMBO", () => $7a382b8d33300736$export$3fe55454f8e5fecc);
$parcel$export(module.exports, "MODIFIER_KEY", () => $7a382b8d33300736$export$c0bfb400388c9a25);
$parcel$export(module.exports, "HOTKEY", () => $7a382b8d33300736$export$524232ca2c12639f);
$parcel$export(module.exports, "HOTKEY_LABEL", () => $7a382b8d33300736$export$df79a4ea2a4b4f00);
$parcel$export(module.exports, "HOTKEY_COLUMN", () => $7a382b8d33300736$export$9781926db144baeb);
$parcel$export(module.exports, "HOTKEY_DIALOG", () => $7a382b8d33300736$export$66e6d5f9c266313f);
$parcel$export(module.exports, "LABEL", () => $7a382b8d33300736$export$37aee82a3cb1e8f7);
$parcel$export(module.exports, "FORM_GROUP", () => $7a382b8d33300736$export$eb9b2b8480b01f1a);
$parcel$export(module.exports, "FORM_CONTENT", () => $7a382b8d33300736$export$1247dfb8c6ce45b3);
$parcel$export(module.exports, "FORM_HELPER_TEXT", () => $7a382b8d33300736$export$7b266b21b246878c);
$parcel$export(module.exports, "FORM_GROUP_SUB_LABEL", () => $7a382b8d33300736$export$650c7aa14bc99906);
$parcel$export(module.exports, "MENU", () => $7a382b8d33300736$export$4f072ecaef317163);
$parcel$export(module.exports, "MENU_ITEM", () => $7a382b8d33300736$export$fec55ff920461811);
$parcel$export(module.exports, "MENU_ITEM_IS_SELECTABLE", () => $7a382b8d33300736$export$1607fdc199b2002d);
$parcel$export(module.exports, "MENU_ITEM_SELECTED_ICON", () => $7a382b8d33300736$export$57ecfc48b890391e);
$parcel$export(module.exports, "MENU_ITEM_ICON", () => $7a382b8d33300736$export$83ad8bedeaf892db);
$parcel$export(module.exports, "MENU_ITEM_LABEL", () => $7a382b8d33300736$export$127f1aff25359810);
$parcel$export(module.exports, "MENU_SUBMENU", () => $7a382b8d33300736$export$cb67094da280ec15);
$parcel$export(module.exports, "MENU_SUBMENU_ICON", () => $7a382b8d33300736$export$c803f550eda0736b);
$parcel$export(module.exports, "MENU_DIVIDER", () => $7a382b8d33300736$export$3d44661fef1f8fab);
$parcel$export(module.exports, "MENU_HEADER", () => $7a382b8d33300736$export$935edc360fae2305);
$parcel$export(module.exports, "MULTISTEP_DIALOG", () => $7a382b8d33300736$export$e4907b506e27c727);
$parcel$export(module.exports, "MULTISTEP_DIALOG_PANELS", () => $7a382b8d33300736$export$165374e683bfc3d1);
$parcel$export(module.exports, "MULTISTEP_DIALOG_LEFT_PANEL", () => $7a382b8d33300736$export$90dcb6be9a743a48);
$parcel$export(module.exports, "MULTISTEP_DIALOG_RIGHT_PANEL", () => $7a382b8d33300736$export$e9411f2a7cfd9180);
$parcel$export(module.exports, "MULTISTEP_DIALOG_NAV_TOP", () => $7a382b8d33300736$export$d124f327de7e3466);
$parcel$export(module.exports, "MULTISTEP_DIALOG_NAV_RIGHT", () => $7a382b8d33300736$export$ea2fba933a716cc1);
$parcel$export(module.exports, "SECTION", () => $7a382b8d33300736$export$524548702ba0011d);
$parcel$export(module.exports, "SECTION_COLLAPSED", () => $7a382b8d33300736$export$9ba725bcf1af0077);
$parcel$export(module.exports, "SECTION_HEADER", () => $7a382b8d33300736$export$63456c6676f3202e);
$parcel$export(module.exports, "SECTION_HEADER_LEFT", () => $7a382b8d33300736$export$9b06418cb438289c);
$parcel$export(module.exports, "SECTION_HEADER_TITLE", () => $7a382b8d33300736$export$74c36f1cd002a019);
$parcel$export(module.exports, "SECTION_HEADER_SUB_TITLE", () => $7a382b8d33300736$export$8ed21854aa0cfd29);
$parcel$export(module.exports, "SECTION_HEADER_DIVIDER", () => $7a382b8d33300736$export$de57f6a3819660b5);
$parcel$export(module.exports, "SECTION_HEADER_TABS", () => $7a382b8d33300736$export$7694981ef852b7da);
$parcel$export(module.exports, "SECTION_HEADER_RIGHT", () => $7a382b8d33300736$export$62cb9e4fef796ae4);
$parcel$export(module.exports, "SECTION_CARD", () => $7a382b8d33300736$export$4164b234af6a614a);
$parcel$export(module.exports, "NAVBAR", () => $7a382b8d33300736$export$f326e925396cee25);
$parcel$export(module.exports, "NAVBAR_GROUP", () => $7a382b8d33300736$export$1deea56284aa1171);
$parcel$export(module.exports, "NAVBAR_HEADING", () => $7a382b8d33300736$export$cad935353152fe7);
$parcel$export(module.exports, "NAVBAR_DIVIDER", () => $7a382b8d33300736$export$b91d5a600cda5fbf);
$parcel$export(module.exports, "NON_IDEAL_STATE", () => $7a382b8d33300736$export$c5a432c36e3e4b78);
$parcel$export(module.exports, "NON_IDEAL_STATE_VISUAL", () => $7a382b8d33300736$export$da806f614bdc1508);
$parcel$export(module.exports, "NON_IDEAL_STATE_TEXT", () => $7a382b8d33300736$export$d60a07aa759048a);
$parcel$export(module.exports, "NUMERIC_INPUT", () => $7a382b8d33300736$export$80e675620d8e3b55);
$parcel$export(module.exports, "OVERFLOW_LIST", () => $7a382b8d33300736$export$b73498d5fb011014);
$parcel$export(module.exports, "OVERFLOW_LIST_SPACER", () => $7a382b8d33300736$export$22f5645f551377bf);
$parcel$export(module.exports, "OVERLAY", () => $7a382b8d33300736$export$abec5a3e0b81aaba);
$parcel$export(module.exports, "OVERLAY_BACKDROP", () => $7a382b8d33300736$export$5b24c9aa87f5d19);
$parcel$export(module.exports, "OVERLAY_CONTAINER", () => $7a382b8d33300736$export$5c46fa2471ac640f);
$parcel$export(module.exports, "OVERLAY_CONTENT", () => $7a382b8d33300736$export$649e0e2ba5bce2b2);
$parcel$export(module.exports, "OVERLAY_INLINE", () => $7a382b8d33300736$export$d070066894e6449f);
$parcel$export(module.exports, "OVERLAY_OPEN", () => $7a382b8d33300736$export$15df4039dd977837);
$parcel$export(module.exports, "OVERLAY_SCROLL_CONTAINER", () => $7a382b8d33300736$export$164be6ff0724d89e);
$parcel$export(module.exports, "OVERLAY_START_FOCUS_TRAP", () => $7a382b8d33300736$export$b05704f848ce027);
$parcel$export(module.exports, "OVERLAY_END_FOCUS_TRAP", () => $7a382b8d33300736$export$72317839a64c29d3);
$parcel$export(module.exports, "PANEL_STACK", () => $7a382b8d33300736$export$977c8163a074ab4c);
$parcel$export(module.exports, "PANEL_STACK_HEADER", () => $7a382b8d33300736$export$86f0fc908ef772ca);
$parcel$export(module.exports, "PANEL_STACK_HEADER_BACK", () => $7a382b8d33300736$export$dba4a9d0529c5123);
$parcel$export(module.exports, "PANEL_STACK_VIEW", () => $7a382b8d33300736$export$9ba9ddd2abc1a482);
$parcel$export(module.exports, "PANEL_STACK2", () => $7a382b8d33300736$export$8b7fecf2fba0abf9);
$parcel$export(module.exports, "PANEL_STACK2_HEADER", () => $7a382b8d33300736$export$f9f46f21fbe4920c);
$parcel$export(module.exports, "PANEL_STACK2_HEADER_BACK", () => $7a382b8d33300736$export$bea2f695ce1f90b1);
$parcel$export(module.exports, "PANEL_STACK2_VIEW", () => $7a382b8d33300736$export$e6cf7858677f7d09);
$parcel$export(module.exports, "POPOVER", () => $7a382b8d33300736$export$dbe3482d899925c4);
$parcel$export(module.exports, "POPOVER_ARROW", () => $7a382b8d33300736$export$8eaa9259ba89a7e8);
$parcel$export(module.exports, "POPOVER_BACKDROP", () => $7a382b8d33300736$export$cd1026626bfe5c07);
$parcel$export(module.exports, "POPOVER_CAPTURING_DISMISS", () => $7a382b8d33300736$export$2cfbe2eb60c57d5b);
$parcel$export(module.exports, "POPOVER_CONTENT", () => $7a382b8d33300736$export$1e96671e28a297dd);
$parcel$export(module.exports, "POPOVER_CONTENT_PLACEMENT", () => $7a382b8d33300736$export$345b7893b44144f1);
$parcel$export(module.exports, "POPOVER_CONTENT_SIZING", () => $7a382b8d33300736$export$5b0bac172c0cf3a);
$parcel$export(module.exports, "POPOVER_DISMISS", () => $7a382b8d33300736$export$7d23743fb33d0182);
$parcel$export(module.exports, "POPOVER_DISMISS_OVERRIDE", () => $7a382b8d33300736$export$1f4f24a25ef790c0);
$parcel$export(module.exports, "POPOVER_MATCH_TARGET_WIDTH", () => $7a382b8d33300736$export$4e93ab2f5f3e0b11);
$parcel$export(module.exports, "POPOVER_OPEN", () => $7a382b8d33300736$export$e864f5b391d71738);
$parcel$export(module.exports, "POPOVER_POPPER_ESCAPED", () => $7a382b8d33300736$export$28f35cf1b92fac04);
$parcel$export(module.exports, "POPOVER_REFERENCE_HIDDEN", () => $7a382b8d33300736$export$4b518c2bca894b80);
$parcel$export(module.exports, "POPOVER_TARGET", () => $7a382b8d33300736$export$534b03eda12f917);
$parcel$export(module.exports, "POPOVER_TRANSITION_CONTAINER", () => $7a382b8d33300736$export$620767fe6c31e984);
$parcel$export(module.exports, "POPOVER_WRAPPER", () => $7a382b8d33300736$export$9361cd420f832cf2);
$parcel$export(module.exports, "PROGRESS_BAR", () => $7a382b8d33300736$export$40c78f7c1065c43c);
$parcel$export(module.exports, "PROGRESS_METER", () => $7a382b8d33300736$export$19dacc38bfe958b2);
$parcel$export(module.exports, "PROGRESS_NO_STRIPES", () => $7a382b8d33300736$export$52fec100aaa98b55);
$parcel$export(module.exports, "PROGRESS_NO_ANIMATION", () => $7a382b8d33300736$export$890ea6f485d6060f);
$parcel$export(module.exports, "PORTAL", () => $7a382b8d33300736$export$ac4d91f5203d82ae);
$parcel$export(module.exports, "SKELETON", () => $7a382b8d33300736$export$169e587b68892b4e);
$parcel$export(module.exports, "SLIDER", () => $7a382b8d33300736$export$992366d871da5550);
$parcel$export(module.exports, "SLIDER_AXIS", () => $7a382b8d33300736$export$229cabfdbcbdfc2d);
$parcel$export(module.exports, "SLIDER_HANDLE", () => $7a382b8d33300736$export$d5ec8f6bd4e7f30c);
$parcel$export(module.exports, "SLIDER_LABEL", () => $7a382b8d33300736$export$c7563cb73c31904);
$parcel$export(module.exports, "SLIDER_TRACK", () => $7a382b8d33300736$export$c17129aaccf9f04f);
$parcel$export(module.exports, "SLIDER_PROGRESS", () => $7a382b8d33300736$export$cb8b3334a21a52ed);
$parcel$export(module.exports, "START", () => $7a382b8d33300736$export$21c466265830bc3a);
$parcel$export(module.exports, "END", () => $7a382b8d33300736$export$32239d68d9c6cb49);
$parcel$export(module.exports, "SPINNER", () => $7a382b8d33300736$export$6bf3d9c372a8b76a);
$parcel$export(module.exports, "SPINNER_ANIMATION", () => $7a382b8d33300736$export$c422a257b54d6303);
$parcel$export(module.exports, "SPINNER_HEAD", () => $7a382b8d33300736$export$67c4dde5cd44a3bf);
$parcel$export(module.exports, "SPINNER_NO_SPIN", () => $7a382b8d33300736$export$35495e002696aec2);
$parcel$export(module.exports, "SPINNER_TRACK", () => $7a382b8d33300736$export$cf9c7c98d20f3675);
$parcel$export(module.exports, "SEGMENTED_CONTROL", () => $7a382b8d33300736$export$a9da50bcccdc2ea1);
$parcel$export(module.exports, "TAB", () => $7a382b8d33300736$export$f1c9dd0f5207dd5e);
$parcel$export(module.exports, "TAB_ICON", () => $7a382b8d33300736$export$761ffa813d3bcf7b);
$parcel$export(module.exports, "TAB_TAG", () => $7a382b8d33300736$export$21993928ad2e2f77);
$parcel$export(module.exports, "TAB_INDICATOR", () => $7a382b8d33300736$export$32364f631fea0fb);
$parcel$export(module.exports, "TAB_INDICATOR_WRAPPER", () => $7a382b8d33300736$export$8da12ef58da8ed12);
$parcel$export(module.exports, "TAB_LIST", () => $7a382b8d33300736$export$29216fa86fc3af12);
$parcel$export(module.exports, "TAB_PANEL", () => $7a382b8d33300736$export$1bc1faf0ee61fa47);
$parcel$export(module.exports, "TABS", () => $7a382b8d33300736$export$73b877b58963a4f);
$parcel$export(module.exports, "TAG", () => $7a382b8d33300736$export$2680f340d0781853);
$parcel$export(module.exports, "TAG_REMOVE", () => $7a382b8d33300736$export$1dace92eb43d2917);
$parcel$export(module.exports, "COMPOUND_TAG", () => $7a382b8d33300736$export$fe7a531a68939d45);
$parcel$export(module.exports, "COMPOUND_TAG_LEFT", () => $7a382b8d33300736$export$936a90ee17829787);
$parcel$export(module.exports, "COMPOUND_TAG_LEFT_CONTENT", () => $7a382b8d33300736$export$23fcc0f95d746a8);
$parcel$export(module.exports, "COMPOUND_TAG_RIGHT", () => $7a382b8d33300736$export$8b9fa1756fbe1a2c);
$parcel$export(module.exports, "COMPOUND_TAG_RIGHT_CONTENT", () => $7a382b8d33300736$export$eb7199f9fc66b8f3);
$parcel$export(module.exports, "TAG_INPUT", () => $7a382b8d33300736$export$ffaf3bbf154e07cf);
$parcel$export(module.exports, "TAG_INPUT_ICON", () => $7a382b8d33300736$export$999c53f91b6a7a4a);
$parcel$export(module.exports, "TAG_INPUT_VALUES", () => $7a382b8d33300736$export$1711f8b4411c6f5f);
$parcel$export(module.exports, "TOAST", () => $7a382b8d33300736$export$6d378d1ab7ed5175);
$parcel$export(module.exports, "TOAST_CONTAINER", () => $7a382b8d33300736$export$bda400aeced77722);
$parcel$export(module.exports, "TOAST_MESSAGE", () => $7a382b8d33300736$export$ce2171b20910fc4b);
$parcel$export(module.exports, "TOOLTIP", () => $7a382b8d33300736$export$1517edb21b105800);
$parcel$export(module.exports, "TOOLTIP_INDICATOR", () => $7a382b8d33300736$export$db434af9cd0173fa);
$parcel$export(module.exports, "TREE", () => $7a382b8d33300736$export$33ecaa422889cd80);
$parcel$export(module.exports, "TREE_NODE", () => $7a382b8d33300736$export$497d287dd067ff98);
$parcel$export(module.exports, "TREE_NODE_CARET", () => $7a382b8d33300736$export$bcef107a0b76070f);
$parcel$export(module.exports, "TREE_NODE_CARET_CLOSED", () => $7a382b8d33300736$export$ea4d3d46c22ddfed);
$parcel$export(module.exports, "TREE_NODE_CARET_NONE", () => $7a382b8d33300736$export$94af84e54168f6de);
$parcel$export(module.exports, "TREE_NODE_CARET_OPEN", () => $7a382b8d33300736$export$e023ef8de1b4549b);
$parcel$export(module.exports, "TREE_NODE_CONTENT", () => $7a382b8d33300736$export$2f310b4a8c8311c8);
$parcel$export(module.exports, "TREE_NODE_EXPANDED", () => $7a382b8d33300736$export$22ed5f498d01ae6c);
$parcel$export(module.exports, "TREE_NODE_ICON", () => $7a382b8d33300736$export$50f70f673012be50);
$parcel$export(module.exports, "TREE_NODE_LABEL", () => $7a382b8d33300736$export$9e24c367c0ac6f88);
$parcel$export(module.exports, "TREE_NODE_LIST", () => $7a382b8d33300736$export$eb052bba2c207529);
$parcel$export(module.exports, "TREE_NODE_SECONDARY_LABEL", () => $7a382b8d33300736$export$15c472de16dfeefd);
$parcel$export(module.exports, "TREE_NODE_SELECTED", () => $7a382b8d33300736$export$4a8bcbdf26c6e4af);
$parcel$export(module.exports, "TREE_ROOT", () => $7a382b8d33300736$export$b397da2e1679ac19);
$parcel$export(module.exports, "ICON", () => $7a382b8d33300736$export$d2b60e6b56e900e8);
$parcel$export(module.exports, "ICON_STANDARD", () => $7a382b8d33300736$export$9e817070703bebe0);
$parcel$export(module.exports, "ICON_LARGE", () => $7a382b8d33300736$export$ef62356806fa9c5a);
$parcel$export(module.exports, "ICON_MUTED", () => $7a382b8d33300736$export$42eab3af8b7fb664);
$parcel$export(module.exports, "getClassNamespace", () => $7a382b8d33300736$export$e018c2ab23bd5a2c);
$parcel$export(module.exports, "alignmentClass", () => $7a382b8d33300736$export$4677781bb583a8b4);
$parcel$export(module.exports, "iconClass", () => $7a382b8d33300736$export$9a22524e6364be6);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $2nesQ = parcelRequire("2nesQ");

var $ijRoR = parcelRequire("ijRoR");

var $1xlC6 = parcelRequire("1xlC6");

var $71KpR = parcelRequire("71KpR");
var $7a382b8d33300736$var$NS = "bp5";
if (typeof BLUEPRINT_NAMESPACE !== "undefined") $7a382b8d33300736$var$NS = BLUEPRINT_NAMESPACE;
else if (typeof REACT_APP_BLUEPRINT_NAMESPACE !== "undefined") $7a382b8d33300736$var$NS = REACT_APP_BLUEPRINT_NAMESPACE;
var $7a382b8d33300736$export$2b35adb71b3f6143 = "".concat($7a382b8d33300736$var$NS, "-active");
var $7a382b8d33300736$export$7895aadd1956b1c7 = "".concat($7a382b8d33300736$var$NS, "-align-left");
var $7a382b8d33300736$export$f1299af03a3c605a = "".concat($7a382b8d33300736$var$NS, "-align-right");
var $7a382b8d33300736$export$db1cdb8627b81f84 = "".concat($7a382b8d33300736$var$NS, "-compact");
var $7a382b8d33300736$export$b9b16d1820185434 = "".concat($7a382b8d33300736$var$NS, "-dark");
var $7a382b8d33300736$export$8cd212c10b4124d2 = "".concat($7a382b8d33300736$var$NS, "-disabled");
var $7a382b8d33300736$export$5672a3e1deb5b505 = "".concat($7a382b8d33300736$var$NS, "-fill");
var $7a382b8d33300736$export$91f67f1eeaea8c1e = "".concat($7a382b8d33300736$var$NS, "-fixed");
var $7a382b8d33300736$export$3df9f2c23b50ca42 = "".concat($7a382b8d33300736$var$NS, "-fixed-top");
var $7a382b8d33300736$export$1ff9623b26415f8 = "".concat($7a382b8d33300736$var$NS, "-inline");
var $7a382b8d33300736$export$ceebd5febfdef8a3 = "".concat($7a382b8d33300736$var$NS, "-interactive");
var $7a382b8d33300736$export$7b93a10c0fefe3e3 = "".concat($7a382b8d33300736$var$NS, "-large");
var $7a382b8d33300736$export$26d55645375ca9a = "".concat($7a382b8d33300736$var$NS, "-loading");
var $7a382b8d33300736$export$a61ada011bb84f5 = "".concat($7a382b8d33300736$var$NS, "-minimal");
var $7a382b8d33300736$export$d31ef73d8bd6b2be = "".concat($7a382b8d33300736$var$NS, "-outlined");
var $7a382b8d33300736$export$1f3db38142bdf083 = "".concat($7a382b8d33300736$var$NS, "-padded");
var $7a382b8d33300736$export$49f467056ef3fc6c = "".concat($7a382b8d33300736$var$NS, "-multiline");
var $7a382b8d33300736$export$a45819e0f9bcfea2 = "".concat($7a382b8d33300736$var$NS, "-read-only");
var $7a382b8d33300736$export$58785fc667c0c50b = "".concat($7a382b8d33300736$var$NS, "-round");
var $7a382b8d33300736$export$657f886463d93938 = "".concat($7a382b8d33300736$var$NS, "-selected");
var $7a382b8d33300736$export$71dd4c8ecd45e95f = "".concat($7a382b8d33300736$var$NS, "-small");
var $7a382b8d33300736$export$9f2fe7df0ae9fdea = "".concat($7a382b8d33300736$var$NS, "-vertical");
var $7a382b8d33300736$export$4fb34bdcd97adf85 = $7a382b8d33300736$export$4f8aee4b943e40e((0, $71KpR.Position).TOP);
var $7a382b8d33300736$export$cec9b06edc71d96c = $7a382b8d33300736$export$4f8aee4b943e40e((0, $71KpR.Position).BOTTOM);
var $7a382b8d33300736$export$b0758137ee643e7 = $7a382b8d33300736$export$4f8aee4b943e40e((0, $71KpR.Position).LEFT);
var $7a382b8d33300736$export$4ed9c122bcc20157 = $7a382b8d33300736$export$4f8aee4b943e40e((0, $71KpR.Position).RIGHT);
var $7a382b8d33300736$export$c8efb467fc55a6a1 = $7a382b8d33300736$export$b7727d57dec24270((0, $ijRoR.Elevation).ZERO);
var $7a382b8d33300736$export$7b5afc1ddf65f8b7 = $7a382b8d33300736$export$b7727d57dec24270((0, $ijRoR.Elevation).ONE);
var $7a382b8d33300736$export$86dd92dfea4f39dd = $7a382b8d33300736$export$b7727d57dec24270((0, $ijRoR.Elevation).TWO);
var $7a382b8d33300736$export$ef7592bd90f2537f = $7a382b8d33300736$export$b7727d57dec24270((0, $ijRoR.Elevation).THREE);
var $7a382b8d33300736$export$1d67a24a95ef24c2 = $7a382b8d33300736$export$b7727d57dec24270((0, $ijRoR.Elevation).FOUR);
var $7a382b8d33300736$export$37c8deab6e9ff120 = $7a382b8d33300736$export$6771d82d925c8189((0, $1xlC6.Intent).PRIMARY);
var $7a382b8d33300736$export$fd8d2f5f74a29424 = $7a382b8d33300736$export$6771d82d925c8189((0, $1xlC6.Intent).SUCCESS);
var $7a382b8d33300736$export$355c57fd095a7f5a = $7a382b8d33300736$export$6771d82d925c8189((0, $1xlC6.Intent).WARNING);
var $7a382b8d33300736$export$373495f4c0568b73 = $7a382b8d33300736$export$6771d82d925c8189((0, $1xlC6.Intent).DANGER);
var $7a382b8d33300736$export$aeda8252e54b50f7 = "".concat($7a382b8d33300736$var$NS, "-focus-disabled");
var $7a382b8d33300736$export$bedc1b77a139edca = "".concat($7a382b8d33300736$var$NS, "-focus-style-manager-ignore");
var $7a382b8d33300736$export$88620a540780da7c = "".concat($7a382b8d33300736$var$NS, "-ui-text");
var $7a382b8d33300736$export$d0190f823696a5cc = "".concat($7a382b8d33300736$var$NS, "-running-text");
var $7a382b8d33300736$export$558d226ddadcf457 = "".concat($7a382b8d33300736$var$NS, "-monospace-text");
var $7a382b8d33300736$export$50e449675bbd8ae2 = "".concat($7a382b8d33300736$var$NS, "-text-large");
var $7a382b8d33300736$export$504f956f6b2a8e65 = "".concat($7a382b8d33300736$var$NS, "-text-small");
var $7a382b8d33300736$export$31a5874ec7f49f29 = "".concat($7a382b8d33300736$var$NS, "-text-muted");
var $7a382b8d33300736$export$4aa79107ea222f04 = "".concat($7a382b8d33300736$var$NS, "-text-disabled");
var $7a382b8d33300736$export$cd50c877adf39dd7 = "".concat($7a382b8d33300736$var$NS, "-text-overflow-ellipsis");
var $7a382b8d33300736$export$afa7aa09bb57d54f = "".concat($7a382b8d33300736$var$NS, "-blockquote");
var $7a382b8d33300736$export$ec5856072852bd7f = "".concat($7a382b8d33300736$var$NS, "-code");
var $7a382b8d33300736$export$cf55d1bff75690da = "".concat($7a382b8d33300736$var$NS, "-code-block");
var $7a382b8d33300736$export$eef1738e402a65e6 = "".concat($7a382b8d33300736$var$NS, "-heading");
var $7a382b8d33300736$export$84cc8e12a434d4e = "".concat($7a382b8d33300736$var$NS, "-list");
var $7a382b8d33300736$export$e52b656749d9474c = "".concat($7a382b8d33300736$var$NS, "-list-unstyled");
var $7a382b8d33300736$export$850f7749a2909601 = "".concat($7a382b8d33300736$var$NS, "-rtl");
var $7a382b8d33300736$export$8dfce1a3f4c39a = "".concat($7a382b8d33300736$var$NS, "-alert");
var $7a382b8d33300736$export$5d3ddfb12869545d = "".concat($7a382b8d33300736$export$8dfce1a3f4c39a, "-body");
var $7a382b8d33300736$export$1dba7da5e8205b5f = "".concat($7a382b8d33300736$export$8dfce1a3f4c39a, "-contents");
var $7a382b8d33300736$export$a928c8e2db526b6c = "".concat($7a382b8d33300736$export$8dfce1a3f4c39a, "-footer");
var $7a382b8d33300736$export$474829b260ce19ab = "".concat($7a382b8d33300736$var$NS, "-breadcrumb");
var $7a382b8d33300736$export$d25ee28b316abe2a = "".concat($7a382b8d33300736$export$474829b260ce19ab, "-current");
var $7a382b8d33300736$export$c3619772211b515b = "".concat($7a382b8d33300736$export$474829b260ce19ab, "s");
var $7a382b8d33300736$export$6c5df38f864cf0e3 = "".concat($7a382b8d33300736$export$474829b260ce19ab, "s-collapsed");
var $7a382b8d33300736$export$b887e88d8d0739f6 = "".concat($7a382b8d33300736$var$NS, "-button");
var $7a382b8d33300736$export$cbb1216936bf389c = "".concat($7a382b8d33300736$export$b887e88d8d0739f6, "-group");
var $7a382b8d33300736$export$3fd25a11349a7fac = "".concat($7a382b8d33300736$export$b887e88d8d0739f6, "-spinner");
var $7a382b8d33300736$export$22617f068a979d82 = "".concat($7a382b8d33300736$export$b887e88d8d0739f6, "-text");
var $7a382b8d33300736$export$ae3fb0b35b6ca2a9 = "".concat($7a382b8d33300736$var$NS, "-callout");
var $7a382b8d33300736$export$c801bbbb1e2ccb0b = "".concat($7a382b8d33300736$export$ae3fb0b35b6ca2a9, "-has-body-content");
var $7a382b8d33300736$export$c4700bfd78cb069a = "".concat($7a382b8d33300736$export$ae3fb0b35b6ca2a9, "-icon");
var $7a382b8d33300736$export$95783a805443ad7d = "".concat($7a382b8d33300736$var$NS, "-card");
var $7a382b8d33300736$export$6769bd973fd6af36 = "".concat($7a382b8d33300736$var$NS, "-control-card");
var $7a382b8d33300736$export$d60e975594bbe489 = "".concat($7a382b8d33300736$export$6769bd973fd6af36, "-label");
var $7a382b8d33300736$export$9cedcb03c3922bb7 = "".concat($7a382b8d33300736$var$NS, "-switch-control-card");
var $7a382b8d33300736$export$3412f17fbe03c097 = "".concat($7a382b8d33300736$var$NS, "-checkbox-control-card");
var $7a382b8d33300736$export$4de35bcdbf177a1f = "".concat($7a382b8d33300736$var$NS, "-radio-control-card");
var $7a382b8d33300736$export$ad39b86c40d3c47c = "".concat($7a382b8d33300736$var$NS, "-card-list");
var $7a382b8d33300736$export$5adfba49857b538f = "".concat($7a382b8d33300736$export$ad39b86c40d3c47c, "-bordered");
var $7a382b8d33300736$export$a1b955d4799a6f74 = "".concat($7a382b8d33300736$var$NS, "-collapse");
var $7a382b8d33300736$export$e4d292b696959393 = "".concat($7a382b8d33300736$export$a1b955d4799a6f74, "-body");
var $7a382b8d33300736$export$6a0da22e72d4f0eb = "".concat($7a382b8d33300736$var$NS, "-context-menu");
var $7a382b8d33300736$export$b9534b88b3cef166 = "".concat($7a382b8d33300736$export$6a0da22e72d4f0eb, "-virtual-target");
var $7a382b8d33300736$export$7ee0ba3b9fa0a5ea = "".concat($7a382b8d33300736$export$6a0da22e72d4f0eb, "-popover");
var $7a382b8d33300736$export$418ef826d3ba978d = "".concat($7a382b8d33300736$export$6a0da22e72d4f0eb, "-backdrop");
var $7a382b8d33300736$export$1c86bb6d85c165 = "".concat($7a382b8d33300736$var$NS, "-control-group");
var $7a382b8d33300736$export$f99739dbfcd2e015 = "".concat($7a382b8d33300736$var$NS, "-dialog");
var $7a382b8d33300736$export$d84b649f32bf6ead = "".concat($7a382b8d33300736$export$f99739dbfcd2e015, "-container");
var $7a382b8d33300736$export$c09efbe888b20fd = "".concat($7a382b8d33300736$export$f99739dbfcd2e015, "-header");
var $7a382b8d33300736$export$12096ec1410ccb2 = "".concat($7a382b8d33300736$export$f99739dbfcd2e015, "-body");
var $7a382b8d33300736$export$dd51a6f3fef5a9d4 = "".concat($7a382b8d33300736$export$f99739dbfcd2e015, "-body-scroll-container");
var $7a382b8d33300736$export$9588cbdf14f4605f = "".concat($7a382b8d33300736$export$f99739dbfcd2e015, "-close-button");
var $7a382b8d33300736$export$6ea271a01e7dc590 = "".concat($7a382b8d33300736$export$f99739dbfcd2e015, "-footer");
var $7a382b8d33300736$export$b60b0eff9b84a85c = "".concat($7a382b8d33300736$export$f99739dbfcd2e015, "-footer-fixed");
var $7a382b8d33300736$export$a01581f2cb63a5c5 = "".concat($7a382b8d33300736$export$f99739dbfcd2e015, "-footer-main-section");
var $7a382b8d33300736$export$6ab793fb94a2b7f8 = "".concat($7a382b8d33300736$export$f99739dbfcd2e015, "-footer-actions");
var $7a382b8d33300736$export$ff97c652790bdec = "".concat($7a382b8d33300736$var$NS, "-dialog-step");
var $7a382b8d33300736$export$15158775e667dbe6 = "".concat($7a382b8d33300736$export$ff97c652790bdec, "-container");
var $7a382b8d33300736$export$e6263bc32f85a4a4 = "".concat($7a382b8d33300736$export$ff97c652790bdec, "-title");
var $7a382b8d33300736$export$e7c377477d704043 = "".concat($7a382b8d33300736$export$ff97c652790bdec, "-icon");
var $7a382b8d33300736$export$97e1fe7e02b9bd0 = "".concat($7a382b8d33300736$export$ff97c652790bdec, "-viewed");
var $7a382b8d33300736$export$59669b530bfa91b6 = "".concat($7a382b8d33300736$var$NS, "-divider");
var $7a382b8d33300736$export$9d2de6eebf7462b5 = "".concat($7a382b8d33300736$var$NS, "-drawer");
var $7a382b8d33300736$export$a772fb749abfcf1d = "".concat($7a382b8d33300736$export$9d2de6eebf7462b5, "-body");
var $7a382b8d33300736$export$b9287ddc8f6e3044 = "".concat($7a382b8d33300736$export$9d2de6eebf7462b5, "-footer");
var $7a382b8d33300736$export$4cd03a6721b31533 = "".concat($7a382b8d33300736$export$9d2de6eebf7462b5, "-header");
var $7a382b8d33300736$export$8cffb49e9dd41ae = "".concat($7a382b8d33300736$var$NS, "-editable-text");
var $7a382b8d33300736$export$78b1aa7020d6af37 = "".concat($7a382b8d33300736$export$8cffb49e9dd41ae, "-content");
var $7a382b8d33300736$export$2d16d4c1c295606c = "".concat($7a382b8d33300736$export$8cffb49e9dd41ae, "-editing");
var $7a382b8d33300736$export$4d6e427d15d16553 = "".concat($7a382b8d33300736$export$8cffb49e9dd41ae, "-input");
var $7a382b8d33300736$export$90d364a014ea6f0a = "".concat($7a382b8d33300736$export$8cffb49e9dd41ae, "-placeholder");
var $7a382b8d33300736$export$659c2dc95c10337e = "".concat($7a382b8d33300736$var$NS, "-entity-title");
var $7a382b8d33300736$export$c92e868735e7ed90 = "".concat($7a382b8d33300736$var$NS, "-entity-title-ellipsize");
var $7a382b8d33300736$export$32306a4d67fbbec = "".concat($7a382b8d33300736$export$659c2dc95c10337e, "-has-subtitle");
var $7a382b8d33300736$export$4a30999b77042528 = "".concat($7a382b8d33300736$export$659c2dc95c10337e, "-icon-container");
var $7a382b8d33300736$export$6d113d689052ca80 = "".concat($7a382b8d33300736$export$659c2dc95c10337e, "-subtitle");
var $7a382b8d33300736$export$2b6f21fa0a5321de = "".concat($7a382b8d33300736$export$659c2dc95c10337e, "-tags-container");
var $7a382b8d33300736$export$dfa64ede72bd0307 = "".concat($7a382b8d33300736$export$659c2dc95c10337e, "-text");
var $7a382b8d33300736$export$e57a71e20aa8627 = "".concat($7a382b8d33300736$export$659c2dc95c10337e, "-title");
var $7a382b8d33300736$export$85f27204a6624107 = "".concat($7a382b8d33300736$export$659c2dc95c10337e, "-title-and-tags");
var $7a382b8d33300736$export$bab85e3adc70edd1 = "".concat($7a382b8d33300736$var$NS, "-flex-expander");
var $7a382b8d33300736$export$c50fbf6be7ac3331 = "".concat($7a382b8d33300736$var$NS, "-html-select");
var $7a382b8d33300736$export$718a6b7ababf8ba7 = "".concat($7a382b8d33300736$var$NS, "-select");
var $7a382b8d33300736$export$76a315d343674c9b = "".concat($7a382b8d33300736$var$NS, "-html-table");
var $7a382b8d33300736$export$13618d7eda5fcc77 = "".concat($7a382b8d33300736$export$76a315d343674c9b, "-bordered");
var $7a382b8d33300736$export$a2a4accb8fbddd4a = "".concat($7a382b8d33300736$export$76a315d343674c9b, "-striped");
var $7a382b8d33300736$export$9ea760072c364d49 = "".concat($7a382b8d33300736$var$NS, "-input");
var $7a382b8d33300736$export$e8d5c1be80b7588b = "".concat($7a382b8d33300736$export$9ea760072c364d49, "-ghost");
var $7a382b8d33300736$export$87f36efdfb463a6f = "".concat($7a382b8d33300736$export$9ea760072c364d49, "-group");
var $7a382b8d33300736$export$9705bb16375b49e5 = "".concat($7a382b8d33300736$export$9ea760072c364d49, "-left-container");
var $7a382b8d33300736$export$217bb10d53bd2e48 = "".concat($7a382b8d33300736$export$9ea760072c364d49, "-action");
var $7a382b8d33300736$export$f038e7a42893c7e5 = "".concat($7a382b8d33300736$var$NS, "-resizable-input-span");
var $7a382b8d33300736$export$794d3720201fcdd9 = "".concat($7a382b8d33300736$var$NS, "-text-area");
var $7a382b8d33300736$export$9c466612a9056aac = "".concat($7a382b8d33300736$export$794d3720201fcdd9, "-auto-resize");
var $7a382b8d33300736$export$43f367b3e957f219 = "".concat($7a382b8d33300736$var$NS, "-control");
var $7a382b8d33300736$export$947bb9f998f185cb = "".concat($7a382b8d33300736$export$43f367b3e957f219, "-indicator");
var $7a382b8d33300736$export$f717c522dcd748f = "".concat($7a382b8d33300736$export$947bb9f998f185cb, "-child");
var $7a382b8d33300736$export$6b636bdca7063f33 = "".concat($7a382b8d33300736$var$NS, "-checkbox");
var $7a382b8d33300736$export$f0fd3c01e562401e = "".concat($7a382b8d33300736$var$NS, "-radio");
var $7a382b8d33300736$export$fd120c956045e61b = "".concat($7a382b8d33300736$var$NS, "-radio-group");
var $7a382b8d33300736$export$d19595eff304150b = "".concat($7a382b8d33300736$var$NS, "-switch");
var $7a382b8d33300736$export$33abfe9257d195b1 = "".concat($7a382b8d33300736$export$d19595eff304150b, "-inner-text");
var $7a382b8d33300736$export$57b7f518a2a69b0e = "".concat($7a382b8d33300736$var$NS, "-file-input");
var $7a382b8d33300736$export$3359eeec929a0672 = "".concat($7a382b8d33300736$var$NS, "-file-input-has-selection");
var $7a382b8d33300736$export$c7e0715fb31daeab = "".concat($7a382b8d33300736$var$NS, "-file-upload-input");
var $7a382b8d33300736$export$59e222d99c2278dc = "".concat($7a382b8d33300736$var$NS, "-file-upload-input-custom-text");
var $7a382b8d33300736$export$7167c830cefcb6b5 = "".concat($7a382b8d33300736$var$NS, "-key");
var $7a382b8d33300736$export$3fe55454f8e5fecc = "".concat($7a382b8d33300736$export$7167c830cefcb6b5, "-combo");
var $7a382b8d33300736$export$c0bfb400388c9a25 = "".concat($7a382b8d33300736$var$NS, "-modifier-key");
var $7a382b8d33300736$export$524232ca2c12639f = "".concat($7a382b8d33300736$var$NS, "-hotkey");
var $7a382b8d33300736$export$df79a4ea2a4b4f00 = "".concat($7a382b8d33300736$export$524232ca2c12639f, "-label");
var $7a382b8d33300736$export$9781926db144baeb = "".concat($7a382b8d33300736$export$524232ca2c12639f, "-column");
var $7a382b8d33300736$export$66e6d5f9c266313f = "".concat($7a382b8d33300736$export$524232ca2c12639f, "-dialog");
var $7a382b8d33300736$export$37aee82a3cb1e8f7 = "".concat($7a382b8d33300736$var$NS, "-label");
var $7a382b8d33300736$export$eb9b2b8480b01f1a = "".concat($7a382b8d33300736$var$NS, "-form-group");
var $7a382b8d33300736$export$1247dfb8c6ce45b3 = "".concat($7a382b8d33300736$var$NS, "-form-content");
var $7a382b8d33300736$export$7b266b21b246878c = "".concat($7a382b8d33300736$var$NS, "-form-helper-text");
var $7a382b8d33300736$export$650c7aa14bc99906 = "".concat($7a382b8d33300736$var$NS, "-form-group-sub-label");
var $7a382b8d33300736$export$4f072ecaef317163 = "".concat($7a382b8d33300736$var$NS, "-menu");
var $7a382b8d33300736$export$fec55ff920461811 = "".concat($7a382b8d33300736$export$4f072ecaef317163, "-item");
var $7a382b8d33300736$export$1607fdc199b2002d = "".concat($7a382b8d33300736$export$fec55ff920461811, "-is-selectable");
var $7a382b8d33300736$export$57ecfc48b890391e = "".concat($7a382b8d33300736$export$fec55ff920461811, "-selected-icon");
var $7a382b8d33300736$export$83ad8bedeaf892db = "".concat($7a382b8d33300736$export$fec55ff920461811, "-icon");
var $7a382b8d33300736$export$127f1aff25359810 = "".concat($7a382b8d33300736$export$fec55ff920461811, "-label");
var $7a382b8d33300736$export$cb67094da280ec15 = "".concat($7a382b8d33300736$var$NS, "-submenu");
var $7a382b8d33300736$export$c803f550eda0736b = "".concat($7a382b8d33300736$export$cb67094da280ec15, "-icon");
var $7a382b8d33300736$export$3d44661fef1f8fab = "".concat($7a382b8d33300736$export$4f072ecaef317163, "-divider");
var $7a382b8d33300736$export$935edc360fae2305 = "".concat($7a382b8d33300736$export$4f072ecaef317163, "-header");
var $7a382b8d33300736$export$e4907b506e27c727 = "".concat($7a382b8d33300736$var$NS, "-multistep-dialog");
var $7a382b8d33300736$export$165374e683bfc3d1 = "".concat($7a382b8d33300736$export$e4907b506e27c727, "-panels");
var $7a382b8d33300736$export$90dcb6be9a743a48 = "".concat($7a382b8d33300736$export$e4907b506e27c727, "-left-panel");
var $7a382b8d33300736$export$e9411f2a7cfd9180 = "".concat($7a382b8d33300736$export$e4907b506e27c727, "-right-panel");
var $7a382b8d33300736$export$d124f327de7e3466 = "".concat($7a382b8d33300736$export$e4907b506e27c727, "-nav-top");
var $7a382b8d33300736$export$ea2fba933a716cc1 = "".concat($7a382b8d33300736$export$e4907b506e27c727, "-nav-right");
var $7a382b8d33300736$export$524548702ba0011d = "".concat($7a382b8d33300736$var$NS, "-section");
var $7a382b8d33300736$export$9ba725bcf1af0077 = "".concat($7a382b8d33300736$export$524548702ba0011d, "-collapsed");
var $7a382b8d33300736$export$63456c6676f3202e = "".concat($7a382b8d33300736$export$524548702ba0011d, "-header");
var $7a382b8d33300736$export$9b06418cb438289c = "".concat($7a382b8d33300736$export$63456c6676f3202e, "-left");
var $7a382b8d33300736$export$74c36f1cd002a019 = "".concat($7a382b8d33300736$export$63456c6676f3202e, "-title");
var $7a382b8d33300736$export$8ed21854aa0cfd29 = "".concat($7a382b8d33300736$export$63456c6676f3202e, "-sub-title");
var $7a382b8d33300736$export$de57f6a3819660b5 = "".concat($7a382b8d33300736$export$63456c6676f3202e, "-divider");
var $7a382b8d33300736$export$7694981ef852b7da = "".concat($7a382b8d33300736$export$63456c6676f3202e, "-tabs");
var $7a382b8d33300736$export$62cb9e4fef796ae4 = "".concat($7a382b8d33300736$export$63456c6676f3202e, "-right");
var $7a382b8d33300736$export$4164b234af6a614a = "".concat($7a382b8d33300736$export$524548702ba0011d, "-card");
var $7a382b8d33300736$export$f326e925396cee25 = "".concat($7a382b8d33300736$var$NS, "-navbar");
var $7a382b8d33300736$export$1deea56284aa1171 = "".concat($7a382b8d33300736$export$f326e925396cee25, "-group");
var $7a382b8d33300736$export$cad935353152fe7 = "".concat($7a382b8d33300736$export$f326e925396cee25, "-heading");
var $7a382b8d33300736$export$b91d5a600cda5fbf = "".concat($7a382b8d33300736$export$f326e925396cee25, "-divider");
var $7a382b8d33300736$export$c5a432c36e3e4b78 = "".concat($7a382b8d33300736$var$NS, "-non-ideal-state");
var $7a382b8d33300736$export$da806f614bdc1508 = "".concat($7a382b8d33300736$export$c5a432c36e3e4b78, "-visual");
var $7a382b8d33300736$export$d60a07aa759048a = "".concat($7a382b8d33300736$export$c5a432c36e3e4b78, "-text");
var $7a382b8d33300736$export$80e675620d8e3b55 = "".concat($7a382b8d33300736$var$NS, "-numeric-input");
var $7a382b8d33300736$export$b73498d5fb011014 = "".concat($7a382b8d33300736$var$NS, "-overflow-list");
var $7a382b8d33300736$export$22f5645f551377bf = "".concat($7a382b8d33300736$export$b73498d5fb011014, "-spacer");
var $7a382b8d33300736$export$abec5a3e0b81aaba = "".concat($7a382b8d33300736$var$NS, "-overlay");
var $7a382b8d33300736$export$5b24c9aa87f5d19 = "".concat($7a382b8d33300736$export$abec5a3e0b81aaba, "-backdrop");
var $7a382b8d33300736$export$5c46fa2471ac640f = "".concat($7a382b8d33300736$export$abec5a3e0b81aaba, "-container");
var $7a382b8d33300736$export$649e0e2ba5bce2b2 = "".concat($7a382b8d33300736$export$abec5a3e0b81aaba, "-content");
var $7a382b8d33300736$export$d070066894e6449f = "".concat($7a382b8d33300736$export$abec5a3e0b81aaba, "-inline");
var $7a382b8d33300736$export$15df4039dd977837 = "".concat($7a382b8d33300736$export$abec5a3e0b81aaba, "-open");
var $7a382b8d33300736$export$164be6ff0724d89e = "".concat($7a382b8d33300736$export$abec5a3e0b81aaba, "-scroll-container");
var $7a382b8d33300736$export$b05704f848ce027 = "".concat($7a382b8d33300736$export$abec5a3e0b81aaba, "-start-focus-trap");
var $7a382b8d33300736$export$72317839a64c29d3 = "".concat($7a382b8d33300736$export$abec5a3e0b81aaba, "-end-focus-trap");
var $7a382b8d33300736$export$977c8163a074ab4c = "".concat($7a382b8d33300736$var$NS, "-panel-stack");
var $7a382b8d33300736$export$86f0fc908ef772ca = "".concat($7a382b8d33300736$export$977c8163a074ab4c, "-header");
var $7a382b8d33300736$export$dba4a9d0529c5123 = "".concat($7a382b8d33300736$export$977c8163a074ab4c, "-header-back");
var $7a382b8d33300736$export$9ba9ddd2abc1a482 = "".concat($7a382b8d33300736$export$977c8163a074ab4c, "-view");
var $7a382b8d33300736$export$8b7fecf2fba0abf9 = "".concat($7a382b8d33300736$var$NS, "-panel-stack2");
var $7a382b8d33300736$export$f9f46f21fbe4920c = "".concat($7a382b8d33300736$export$977c8163a074ab4c, "-header");
var $7a382b8d33300736$export$bea2f695ce1f90b1 = "".concat($7a382b8d33300736$export$977c8163a074ab4c, "-header-back");
var $7a382b8d33300736$export$e6cf7858677f7d09 = "".concat($7a382b8d33300736$export$977c8163a074ab4c, "-view");
var $7a382b8d33300736$export$dbe3482d899925c4 = "".concat($7a382b8d33300736$var$NS, "-popover");
var $7a382b8d33300736$export$8eaa9259ba89a7e8 = "".concat($7a382b8d33300736$export$dbe3482d899925c4, "-arrow");
var $7a382b8d33300736$export$cd1026626bfe5c07 = "".concat($7a382b8d33300736$export$dbe3482d899925c4, "-backdrop");
var $7a382b8d33300736$export$2cfbe2eb60c57d5b = "".concat($7a382b8d33300736$export$dbe3482d899925c4, "-capturing-dismiss");
var $7a382b8d33300736$export$1e96671e28a297dd = "".concat($7a382b8d33300736$export$dbe3482d899925c4, "-content");
var $7a382b8d33300736$export$345b7893b44144f1 = "".concat($7a382b8d33300736$export$dbe3482d899925c4, "-placement");
var $7a382b8d33300736$export$5b0bac172c0cf3a = "".concat($7a382b8d33300736$export$1e96671e28a297dd, "-sizing");
var $7a382b8d33300736$export$7d23743fb33d0182 = "".concat($7a382b8d33300736$export$dbe3482d899925c4, "-dismiss");
var $7a382b8d33300736$export$1f4f24a25ef790c0 = "".concat($7a382b8d33300736$export$7d23743fb33d0182, "-override");
var $7a382b8d33300736$export$4e93ab2f5f3e0b11 = "".concat($7a382b8d33300736$export$dbe3482d899925c4, "-match-target-width");
var $7a382b8d33300736$export$e864f5b391d71738 = "".concat($7a382b8d33300736$export$dbe3482d899925c4, "-open");
var $7a382b8d33300736$export$28f35cf1b92fac04 = "".concat($7a382b8d33300736$export$dbe3482d899925c4, "-popper-escaped");
var $7a382b8d33300736$export$4b518c2bca894b80 = "".concat($7a382b8d33300736$export$dbe3482d899925c4, "-reference-hidden");
var $7a382b8d33300736$export$534b03eda12f917 = "".concat($7a382b8d33300736$export$dbe3482d899925c4, "-target");
var $7a382b8d33300736$export$620767fe6c31e984 = "".concat($7a382b8d33300736$export$dbe3482d899925c4, "-transition-container");
var $7a382b8d33300736$export$9361cd420f832cf2 = "".concat($7a382b8d33300736$export$dbe3482d899925c4, "-wrapper");
var $7a382b8d33300736$export$40c78f7c1065c43c = "".concat($7a382b8d33300736$var$NS, "-progress-bar");
var $7a382b8d33300736$export$19dacc38bfe958b2 = "".concat($7a382b8d33300736$var$NS, "-progress-meter");
var $7a382b8d33300736$export$52fec100aaa98b55 = "".concat($7a382b8d33300736$var$NS, "-no-stripes");
var $7a382b8d33300736$export$890ea6f485d6060f = "".concat($7a382b8d33300736$var$NS, "-no-animation");
var $7a382b8d33300736$export$ac4d91f5203d82ae = "".concat($7a382b8d33300736$var$NS, "-portal");
var $7a382b8d33300736$export$169e587b68892b4e = "".concat($7a382b8d33300736$var$NS, "-skeleton");
var $7a382b8d33300736$export$992366d871da5550 = "".concat($7a382b8d33300736$var$NS, "-slider");
var $7a382b8d33300736$export$229cabfdbcbdfc2d = "".concat($7a382b8d33300736$export$992366d871da5550, "-axis");
var $7a382b8d33300736$export$d5ec8f6bd4e7f30c = "".concat($7a382b8d33300736$export$992366d871da5550, "-handle");
var $7a382b8d33300736$export$c7563cb73c31904 = "".concat($7a382b8d33300736$export$992366d871da5550, "-label");
var $7a382b8d33300736$export$c17129aaccf9f04f = "".concat($7a382b8d33300736$export$992366d871da5550, "-track");
var $7a382b8d33300736$export$cb8b3334a21a52ed = "".concat($7a382b8d33300736$export$992366d871da5550, "-progress");
var $7a382b8d33300736$export$21c466265830bc3a = "".concat($7a382b8d33300736$var$NS, "-start");
var $7a382b8d33300736$export$32239d68d9c6cb49 = "".concat($7a382b8d33300736$var$NS, "-end");
var $7a382b8d33300736$export$6bf3d9c372a8b76a = "".concat($7a382b8d33300736$var$NS, "-spinner");
var $7a382b8d33300736$export$c422a257b54d6303 = "".concat($7a382b8d33300736$export$6bf3d9c372a8b76a, "-animation");
var $7a382b8d33300736$export$67c4dde5cd44a3bf = "".concat($7a382b8d33300736$export$6bf3d9c372a8b76a, "-head");
var $7a382b8d33300736$export$35495e002696aec2 = "".concat($7a382b8d33300736$var$NS, "-no-spin");
var $7a382b8d33300736$export$cf9c7c98d20f3675 = "".concat($7a382b8d33300736$export$6bf3d9c372a8b76a, "-track");
var $7a382b8d33300736$export$a9da50bcccdc2ea1 = "".concat($7a382b8d33300736$var$NS, "-segmented-control");
var $7a382b8d33300736$export$f1c9dd0f5207dd5e = "".concat($7a382b8d33300736$var$NS, "-tab");
var $7a382b8d33300736$export$761ffa813d3bcf7b = "".concat($7a382b8d33300736$export$f1c9dd0f5207dd5e, "-icon");
var $7a382b8d33300736$export$21993928ad2e2f77 = "".concat($7a382b8d33300736$export$f1c9dd0f5207dd5e, "-tag");
var $7a382b8d33300736$export$32364f631fea0fb = "".concat($7a382b8d33300736$export$f1c9dd0f5207dd5e, "-indicator");
var $7a382b8d33300736$export$8da12ef58da8ed12 = "".concat($7a382b8d33300736$export$32364f631fea0fb, "-wrapper");
var $7a382b8d33300736$export$29216fa86fc3af12 = "".concat($7a382b8d33300736$export$f1c9dd0f5207dd5e, "-list");
var $7a382b8d33300736$export$1bc1faf0ee61fa47 = "".concat($7a382b8d33300736$export$f1c9dd0f5207dd5e, "-panel");
var $7a382b8d33300736$export$73b877b58963a4f = "".concat($7a382b8d33300736$export$f1c9dd0f5207dd5e, "s");
var $7a382b8d33300736$export$2680f340d0781853 = "".concat($7a382b8d33300736$var$NS, "-tag");
var $7a382b8d33300736$export$1dace92eb43d2917 = "".concat($7a382b8d33300736$export$2680f340d0781853, "-remove");
var $7a382b8d33300736$export$fe7a531a68939d45 = "".concat($7a382b8d33300736$var$NS, "-compound-tag");
var $7a382b8d33300736$export$936a90ee17829787 = "".concat($7a382b8d33300736$export$fe7a531a68939d45, "-left");
var $7a382b8d33300736$export$23fcc0f95d746a8 = "".concat($7a382b8d33300736$export$fe7a531a68939d45, "-left-content");
var $7a382b8d33300736$export$8b9fa1756fbe1a2c = "".concat($7a382b8d33300736$export$fe7a531a68939d45, "-right");
var $7a382b8d33300736$export$eb7199f9fc66b8f3 = "".concat($7a382b8d33300736$export$fe7a531a68939d45, "-right-content");
var $7a382b8d33300736$export$ffaf3bbf154e07cf = "".concat($7a382b8d33300736$var$NS, "-tag-input");
var $7a382b8d33300736$export$999c53f91b6a7a4a = "".concat($7a382b8d33300736$export$ffaf3bbf154e07cf, "-icon");
var $7a382b8d33300736$export$1711f8b4411c6f5f = "".concat($7a382b8d33300736$export$ffaf3bbf154e07cf, "-values");
var $7a382b8d33300736$export$6d378d1ab7ed5175 = "".concat($7a382b8d33300736$var$NS, "-toast");
var $7a382b8d33300736$export$bda400aeced77722 = "".concat($7a382b8d33300736$export$6d378d1ab7ed5175, "-container");
var $7a382b8d33300736$export$ce2171b20910fc4b = "".concat($7a382b8d33300736$export$6d378d1ab7ed5175, "-message");
var $7a382b8d33300736$export$1517edb21b105800 = "".concat($7a382b8d33300736$var$NS, "-tooltip");
var $7a382b8d33300736$export$db434af9cd0173fa = "".concat($7a382b8d33300736$export$1517edb21b105800, "-indicator");
var $7a382b8d33300736$export$33ecaa422889cd80 = "".concat($7a382b8d33300736$var$NS, "-tree");
var $7a382b8d33300736$export$497d287dd067ff98 = "".concat($7a382b8d33300736$var$NS, "-tree-node");
var $7a382b8d33300736$export$bcef107a0b76070f = "".concat($7a382b8d33300736$export$497d287dd067ff98, "-caret");
var $7a382b8d33300736$export$ea4d3d46c22ddfed = "".concat($7a382b8d33300736$export$bcef107a0b76070f, "-closed");
var $7a382b8d33300736$export$94af84e54168f6de = "".concat($7a382b8d33300736$export$bcef107a0b76070f, "-none");
var $7a382b8d33300736$export$e023ef8de1b4549b = "".concat($7a382b8d33300736$export$bcef107a0b76070f, "-open");
var $7a382b8d33300736$export$2f310b4a8c8311c8 = "".concat($7a382b8d33300736$export$497d287dd067ff98, "-content");
var $7a382b8d33300736$export$22ed5f498d01ae6c = "".concat($7a382b8d33300736$export$497d287dd067ff98, "-expanded");
var $7a382b8d33300736$export$50f70f673012be50 = "".concat($7a382b8d33300736$export$497d287dd067ff98, "-icon");
var $7a382b8d33300736$export$9e24c367c0ac6f88 = "".concat($7a382b8d33300736$export$497d287dd067ff98, "-label");
var $7a382b8d33300736$export$eb052bba2c207529 = "".concat($7a382b8d33300736$export$497d287dd067ff98, "-list");
var $7a382b8d33300736$export$15c472de16dfeefd = "".concat($7a382b8d33300736$export$497d287dd067ff98, "-secondary-label");
var $7a382b8d33300736$export$4a8bcbdf26c6e4af = "".concat($7a382b8d33300736$export$497d287dd067ff98, "-selected");
var $7a382b8d33300736$export$b397da2e1679ac19 = "".concat($7a382b8d33300736$var$NS, "-tree-root");
var $7a382b8d33300736$export$d2b60e6b56e900e8 = "".concat($7a382b8d33300736$var$NS, "-icon");
var $7a382b8d33300736$export$9e817070703bebe0 = "".concat($7a382b8d33300736$export$d2b60e6b56e900e8, "-standard");
var $7a382b8d33300736$export$ef62356806fa9c5a = "".concat($7a382b8d33300736$export$d2b60e6b56e900e8, "-large");
var $7a382b8d33300736$export$42eab3af8b7fb664 = "".concat($7a382b8d33300736$export$d2b60e6b56e900e8, "-muted");
function $7a382b8d33300736$export$e018c2ab23bd5a2c() {
    return $7a382b8d33300736$var$NS;
}
function $7a382b8d33300736$export$4677781bb583a8b4(alignment) {
    switch(alignment){
        case (0, $2nesQ.Alignment).LEFT:
            return $7a382b8d33300736$export$7895aadd1956b1c7;
        case (0, $2nesQ.Alignment).RIGHT:
            return $7a382b8d33300736$export$f1299af03a3c605a;
        default:
            return undefined;
    }
}
function $7a382b8d33300736$export$b7727d57dec24270(elevation) {
    if (elevation === undefined) return undefined;
    return "".concat($7a382b8d33300736$var$NS, "-elevation-").concat(elevation);
}
function $7a382b8d33300736$export$9a22524e6364be6(iconName) {
    if (iconName == null) return undefined;
    return iconName.indexOf("".concat($7a382b8d33300736$var$NS, "-icon-")) === 0 ? iconName : "".concat($7a382b8d33300736$var$NS, "-icon-").concat(iconName);
}
function $7a382b8d33300736$export$6771d82d925c8189(intent) {
    if (intent == null || intent === (0, $1xlC6.Intent).NONE) return undefined;
    return "".concat($7a382b8d33300736$var$NS, "-intent-").concat(intent.toLowerCase());
}
function $7a382b8d33300736$export$4f8aee4b943e40e(position) {
    if (position === undefined) return undefined;
    return "".concat($7a382b8d33300736$var$NS, "-position-").concat(position);
}

});
parcelRegister("2nesQ", function(module, exports) {

$parcel$export(module.exports, "Alignment", () => $1ba8f310ef4e8246$export$9d7927214ed7d2cf);
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Alignment along the horizontal axis. */ var $1ba8f310ef4e8246$export$9d7927214ed7d2cf = {
    CENTER: "center",
    LEFT: "left",
    RIGHT: "right"
};

});

parcelRegister("ijRoR", function(module, exports) {

$parcel$export(module.exports, "Elevation", () => $d5636c7a3efd16e7$export$58bfb4f6ec5aa58d);
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // tslint:disable:object-literal-sort-keys
var $d5636c7a3efd16e7$export$58bfb4f6ec5aa58d = {
    ZERO: 0,
    ONE: 1,
    TWO: 2,
    THREE: 3,
    FOUR: 4
};

});

parcelRegister("1xlC6", function(module, exports) {

$parcel$export(module.exports, "Intent", () => $11e9a380819bb500$export$dc3e8878c31a5f1c);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // tslint:disable:object-literal-sort-keys
/**
 * The four basic intents.
 */ var $11e9a380819bb500$export$dc3e8878c31a5f1c = {
    NONE: "none",
    PRIMARY: "primary",
    SUCCESS: "success",
    WARNING: "warning",
    DANGER: "danger"
};

});

parcelRegister("71KpR", function(module, exports) {

$parcel$export(module.exports, "Position", () => $51dca1ac3378e1b8$export$13807d9ee5a34a42);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $51dca1ac3378e1b8$export$13807d9ee5a34a42 = {
    BOTTOM: "bottom",
    BOTTOM_LEFT: "bottom-left",
    BOTTOM_RIGHT: "bottom-right",
    LEFT: "left",
    LEFT_BOTTOM: "left-bottom",
    LEFT_TOP: "left-top",
    RIGHT: "right",
    RIGHT_BOTTOM: "right-bottom",
    RIGHT_TOP: "right-top",
    TOP: "top",
    TOP_LEFT: "top-left",
    TOP_RIGHT: "top-right"
};
function $51dca1ac3378e1b8$export$b0b056baf6a0eb37(position) {
    /* istanbul ignore next */ return position === $51dca1ac3378e1b8$export$13807d9ee5a34a42.TOP || position === $51dca1ac3378e1b8$export$13807d9ee5a34a42.TOP_LEFT || position === $51dca1ac3378e1b8$export$13807d9ee5a34a42.TOP_RIGHT || position === $51dca1ac3378e1b8$export$13807d9ee5a34a42.BOTTOM || position === $51dca1ac3378e1b8$export$13807d9ee5a34a42.BOTTOM_LEFT || position === $51dca1ac3378e1b8$export$13807d9ee5a34a42.BOTTOM_RIGHT;
}
function $51dca1ac3378e1b8$export$5df8e457999da1ae(position) {
    /* istanbul ignore next */ return position === $51dca1ac3378e1b8$export$13807d9ee5a34a42.LEFT || position === $51dca1ac3378e1b8$export$13807d9ee5a34a42.LEFT_TOP || position === $51dca1ac3378e1b8$export$13807d9ee5a34a42.LEFT_BOTTOM || position === $51dca1ac3378e1b8$export$13807d9ee5a34a42.RIGHT || position === $51dca1ac3378e1b8$export$13807d9ee5a34a42.RIGHT_TOP || position === $51dca1ac3378e1b8$export$13807d9ee5a34a42.RIGHT_BOTTOM;
}
function $51dca1ac3378e1b8$export$a531f93822c3a253(position) {
    if (position === $51dca1ac3378e1b8$export$13807d9ee5a34a42.TOP || position === $51dca1ac3378e1b8$export$13807d9ee5a34a42.TOP_LEFT || position === $51dca1ac3378e1b8$export$13807d9ee5a34a42.TOP_RIGHT) return $51dca1ac3378e1b8$export$13807d9ee5a34a42.TOP;
    else if (position === $51dca1ac3378e1b8$export$13807d9ee5a34a42.BOTTOM || position === $51dca1ac3378e1b8$export$13807d9ee5a34a42.BOTTOM_LEFT || position === $51dca1ac3378e1b8$export$13807d9ee5a34a42.BOTTOM_RIGHT) return $51dca1ac3378e1b8$export$13807d9ee5a34a42.BOTTOM;
    else if (position === $51dca1ac3378e1b8$export$13807d9ee5a34a42.LEFT || position === $51dca1ac3378e1b8$export$13807d9ee5a34a42.LEFT_TOP || position === $51dca1ac3378e1b8$export$13807d9ee5a34a42.LEFT_BOTTOM) return $51dca1ac3378e1b8$export$13807d9ee5a34a42.LEFT;
    else return $51dca1ac3378e1b8$export$13807d9ee5a34a42.RIGHT;
}

});


parcelRegister("iP8Ix", function(module, exports) {

$parcel$export(module.exports, "clickElementOnKeyPress", () => (parcelRequire("lgubC")).clickElementOnKeyPress);
$parcel$export(module.exports, "elementIsOrContains", () => (parcelRequire("lgubC")).elementIsOrContains);
$parcel$export(module.exports, "elementIsTextInput", () => (parcelRequire("lgubC")).elementIsTextInput);
$parcel$export(module.exports, "getActiveElement", () => (parcelRequire("lgubC")).getActiveElement);
$parcel$export(module.exports, "throttle", () => (parcelRequire("lgubC")).throttle);
$parcel$export(module.exports, "throttleEvent", () => (parcelRequire("lgubC")).throttleEvent);
$parcel$export(module.exports, "throttleReactEventCallback", () => (parcelRequire("lgubC")).throttleReactEventCallback);
$parcel$export(module.exports, "isFunction", () => (parcelRequire("3u1r0")).isFunction);
$parcel$export(module.exports, "isArrowKey", () => (parcelRequire("lJ8GL")).isArrowKey);
$parcel$export(module.exports, "isKeyboardClick", () => (parcelRequire("lJ8GL")).isKeyboardClick);
$parcel$export(module.exports, "isDarkTheme", () => (parcelRequire("2Z1MG")).isDarkTheme);
$parcel$export(module.exports, "setRef", () => (parcelRequire("8k66C")).setRef);
$parcel$export(module.exports, "getRef", () => (parcelRequire("8k66C")).getRef);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $9ST00 = parcelRequire("9ST00");

var $lgubC = parcelRequire("lgubC");

var $3u1r0 = parcelRequire("3u1r0");

var $h8UCV = parcelRequire("h8UCV");

var $4FOwp = parcelRequire("4FOwp");

var $lJ8GL = parcelRequire("lJ8GL");

var $2Z1MG = parcelRequire("2Z1MG");

var $8k66C = parcelRequire("8k66C");
$parcel$exportWildcard(module.exports, $9ST00);
$parcel$exportWildcard(module.exports, $h8UCV);
$parcel$exportWildcard(module.exports, $4FOwp);

});
parcelRegister("9ST00", function(module, exports) {

$parcel$export(module.exports, "arraysEqual", () => $7323d1dc4ebd48d5$export$234180f8206db11b);
$parcel$export(module.exports, "shallowCompareKeys", () => $7323d1dc4ebd48d5$export$d9dfaae715e1ab60);
$parcel$export(module.exports, "deepCompareKeys", () => $7323d1dc4ebd48d5$export$64d4bb231c0f132b);
$parcel$export(module.exports, "getDeepUnequalKeyValues", () => $7323d1dc4ebd48d5$export$685403fd77bd7c39);
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns true if the arrays are equal. Elements will be shallowly compared by
 * default, or they will be compared using the custom `compare` function if one
 * is provided.
 */ function $7323d1dc4ebd48d5$export$234180f8206db11b(arrA, arrB, compare) {
    if (compare === void 0) compare = function(a, b) {
        return a === b;
    };
    // treat `null` and `undefined` as the same
    if (arrA == null && arrB == null) return true;
    else if (arrA == null || arrB == null || arrA.length !== arrB.length) return false;
    else return arrA.every(function(a, i) {
        return compare(a, arrB[i]);
    });
}
function $7323d1dc4ebd48d5$export$d9dfaae715e1ab60(objA, objB, keys) {
    // treat `null` and `undefined` as the same
    if (objA == null && objB == null) return true;
    else if (objA == null || objB == null) return false;
    else if (Array.isArray(objA) || Array.isArray(objB)) return false;
    else if (keys != null) return $7323d1dc4ebd48d5$var$shallowCompareKeysImpl(objA, objB, keys);
    else {
        // shallowly compare all keys from both objects
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        return $7323d1dc4ebd48d5$var$shallowCompareKeysImpl(objA, objB, {
            include: keysA
        }) && $7323d1dc4ebd48d5$var$shallowCompareKeysImpl(objA, objB, {
            include: keysB
        });
    }
}
function $7323d1dc4ebd48d5$export$64d4bb231c0f132b(objA, objB, keys) {
    if (objA === objB) return true;
    else if (objA == null && objB == null) // treat `null` and `undefined` as the same
    return true;
    else if (objA == null || objB == null) return false;
    else if (Array.isArray(objA) || Array.isArray(objB)) return $7323d1dc4ebd48d5$export$234180f8206db11b(objA, objB, $7323d1dc4ebd48d5$export$64d4bb231c0f132b);
    else if ($7323d1dc4ebd48d5$var$isSimplePrimitiveType(objA) || $7323d1dc4ebd48d5$var$isSimplePrimitiveType(objB)) return objA === objB;
    else if (keys != null) return $7323d1dc4ebd48d5$var$deepCompareKeysImpl(objA, objB, keys);
    else if (objA.constructor !== objB.constructor) return false;
    else {
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        if (keysA == null || keysB == null) return false;
        if (keysA.length === 0 && keysB.length === 0) return true;
        return $7323d1dc4ebd48d5$export$234180f8206db11b(keysA, keysB) && $7323d1dc4ebd48d5$var$deepCompareKeysImpl(objA, objB, keysA);
    }
}
function $7323d1dc4ebd48d5$export$685403fd77bd7c39(objA, objB, keys) {
    if (objA === void 0) objA = {};
    if (objB === void 0) objB = {};
    var filteredKeys = keys == null ? $7323d1dc4ebd48d5$var$unionKeys(objA, objB) : keys;
    return $7323d1dc4ebd48d5$var$getUnequalKeyValues(objA, objB, filteredKeys, function(a, b, key) {
        return $7323d1dc4ebd48d5$export$64d4bb231c0f132b(a, b, [
            key
        ]);
    });
}
// Private helpers
// ===============
/**
 * Partial shallow comparison between objects using the given list of keys.
 */ function $7323d1dc4ebd48d5$var$shallowCompareKeysImpl(objA, objB, keys) {
    return $7323d1dc4ebd48d5$var$filterKeys(objA, objB, keys).every(function(key) {
        return objA.hasOwnProperty(key) === objB.hasOwnProperty(key) && objA[key] === objB[key];
    });
}
/**
 * Partial deep comparison between objects using the given list of keys.
 */ function $7323d1dc4ebd48d5$var$deepCompareKeysImpl(objA, objB, keys) {
    return keys.every(function(key) {
        return objA.hasOwnProperty(key) === objB.hasOwnProperty(key) && $7323d1dc4ebd48d5$export$64d4bb231c0f132b(objA[key], objB[key]);
    });
}
function $7323d1dc4ebd48d5$var$isSimplePrimitiveType(value) {
    return typeof value === "number" || typeof value === "string" || typeof value === "boolean";
}
function $7323d1dc4ebd48d5$var$filterKeys(objA, objB, keys) {
    if ($7323d1dc4ebd48d5$var$isAllowlist(keys)) return keys.include;
    else if ($7323d1dc4ebd48d5$var$isDenylist(keys)) {
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        // merge keys from both objects into a big set for quick access
        var keySet_1 = $7323d1dc4ebd48d5$var$arrayToObject(keysA.concat(keysB));
        // delete denied keys from the key set
        keys.exclude.forEach(function(key) {
            return delete keySet_1[key];
        });
        // return the remaining keys as an array
        return Object.keys(keySet_1);
    }
    return [];
}
function $7323d1dc4ebd48d5$var$isAllowlist(keys) {
    return keys != null && keys.include != null;
}
function $7323d1dc4ebd48d5$var$isDenylist(keys) {
    return keys != null && keys.exclude != null;
}
function $7323d1dc4ebd48d5$var$arrayToObject(arr) {
    return arr.reduce(function(obj, element) {
        obj[element] = true;
        return obj;
    }, {});
}
function $7323d1dc4ebd48d5$var$getUnequalKeyValues(objA, objB, keys, compareFn) {
    var unequalKeys = keys.filter(function(key) {
        return !compareFn(objA, objB, key);
    });
    var unequalKeyValues = unequalKeys.map(function(key) {
        return {
            key: key,
            valueA: objA[key],
            valueB: objB[key]
        };
    });
    return unequalKeyValues;
}
function $7323d1dc4ebd48d5$var$unionKeys(objA, objB) {
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    var concatKeys = keysA.concat(keysB);
    var keySet = $7323d1dc4ebd48d5$var$arrayToObject(concatKeys);
    return Object.keys(keySet);
}

});

parcelRegister("lgubC", function(module, exports) {

$parcel$export(module.exports, "hasDOMEnvironment", () => $03fec0082baae3a5$export$974c8c6d1fbc6154);
$parcel$export(module.exports, "elementIsOrContains", () => $03fec0082baae3a5$export$3c0fcc112e8e7788);
$parcel$export(module.exports, "elementIsTextInput", () => $03fec0082baae3a5$export$dea6a6e5494f51e0);
$parcel$export(module.exports, "getActiveElement", () => $03fec0082baae3a5$export$cd4e5573fbe2b576);
$parcel$export(module.exports, "throttleEvent", () => $03fec0082baae3a5$export$4897e46a283195b6);
$parcel$export(module.exports, "throttleReactEventCallback", () => $03fec0082baae3a5$export$deef02b46be8a843);
$parcel$export(module.exports, "throttle", () => $03fec0082baae3a5$export$de363e709c412c8a);
$parcel$export(module.exports, "clickElementOnKeyPress", () => $03fec0082baae3a5$export$d429894ed4cff305);
/*
 * Copyright 2020 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");
function $03fec0082baae3a5$export$974c8c6d1fbc6154() {
    return typeof window !== "undefined" && window.document != null;
}
function $03fec0082baae3a5$export$3c0fcc112e8e7788(element, testElement) {
    return element === testElement || element.contains(testElement);
}
function $03fec0082baae3a5$export$dea6a6e5494f51e0(elem) {
    // we check these cases for unit testing, but this should not happen
    // during normal operation
    if (elem == null || elem.closest == null) return false;
    var editable = elem.closest("input, textarea, [contenteditable=true]");
    if (editable == null) return false;
    // don't let checkboxes, switches, and radio buttons prevent hotkey behavior
    if (editable.tagName.toLowerCase() === "input") {
        var inputType = editable.type;
        if (inputType === "checkbox" || inputType === "radio") return false;
    }
    // don't let read-only fields prevent hotkey behavior
    if (editable.readOnly) return false;
    return true;
}
function $03fec0082baae3a5$export$cd4e5573fbe2b576(element, options) {
    var _a;
    if (element == null) return document.activeElement;
    var rootNode = (_a = element.getRootNode(options)) !== null && _a !== void 0 ? _a : document;
    return rootNode.activeElement;
}
function $03fec0082baae3a5$export$4897e46a283195b6(target, eventName, newEventName) {
    var throttledFunc = $03fec0082baae3a5$var$throttleImpl(function(event) {
        target.dispatchEvent(new CustomEvent(newEventName, event));
    });
    target.addEventListener(eventName, throttledFunc);
    return throttledFunc;
}
function $03fec0082baae3a5$export$deef02b46be8a843(callback, options) {
    if (options === void 0) options = {};
    var throttledFunc = $03fec0082baae3a5$var$throttleImpl(callback, function(event2) {
        if (options.preventDefault) event2.preventDefault();
    }, // prevent React from reclaiming the event object before we reference it
    function(event2) {
        return event2.persist();
    });
    return throttledFunc;
}
function $03fec0082baae3a5$export$de363e709c412c8a(method) {
    return $03fec0082baae3a5$var$throttleImpl(method);
}
// eslint-disable-next-line @typescript-eslint/ban-types
function $03fec0082baae3a5$var$throttleImpl(onAnimationFrameRequested, onBeforeIsRunningCheck, onAfterIsRunningCheck) {
    var isRunning = false;
    var func = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        onBeforeIsRunningCheck === null || onBeforeIsRunningCheck === void 0 || onBeforeIsRunningCheck.apply(void 0, args);
        if (isRunning) return;
        isRunning = true;
        onAfterIsRunningCheck === null || onAfterIsRunningCheck === void 0 || onAfterIsRunningCheck.apply(void 0, args);
        requestAnimationFrame(function() {
            onAnimationFrameRequested.apply(void 0, args);
            isRunning = false;
        });
    };
    return func;
}
function $03fec0082baae3a5$export$d429894ed4cff305(keys) {
    return function(e) {
        if (keys.some(function(key) {
            return e.key === key;
        })) {
            // Prevent spacebar from scrolling the page unless we're in a text field
            if (!$03fec0082baae3a5$export$dea6a6e5494f51e0(e.target)) e.preventDefault();
            e.target.dispatchEvent(new MouseEvent("click", (0, $gztBd.__assign)((0, $gztBd.__assign)({}, e), {
                view: undefined
            })));
        }
    };
}

});

parcelRegister("3u1r0", function(module, exports) {

$parcel$export(module.exports, "isFunction", () => $289549512ebf85ba$export$f6e2535fb5126e54);
/*
 * Copyright 2020 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns whether the value is a function. Acts as a type guard. */ /* istanbul ignore next */ // eslint-disable-next-line @typescript-eslint/ban-types
function $289549512ebf85ba$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}

});

parcelRegister("h8UCV", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", () => $c7af1bed83ff3310$export$ba99498080d0627b);
$parcel$export(module.exports, "arrayLengthCompare", () => $c7af1bed83ff3310$export$a508c2eeffcdc594);
$parcel$export(module.exports, "approxEqual", () => $c7af1bed83ff3310$export$8a4f1dcc58a69dbd);
$parcel$export(module.exports, "clamp", () => $c7af1bed83ff3310$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "countDecimalPlaces", () => $c7af1bed83ff3310$export$a42544f265f8403);
$parcel$export(module.exports, "uniqueId", () => $c7af1bed83ff3310$export$8b15d37bc3f197d4);
$parcel$export(module.exports, "isEmptyString", () => $c7af1bed83ff3310$export$78d1711480f95c3e);
/*
 * Copyright 2020 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $bzsu8 = parcelRequire("bzsu8");
function $c7af1bed83ff3310$export$ba99498080d0627b(env) {
    return typeof NODE_ENV !== "undefined" && NODE_ENV === env;
}
function $c7af1bed83ff3310$export$a508c2eeffcdc594(a, b) {
    if (a === void 0) a = [];
    if (b === void 0) b = [];
    return a.length - b.length;
}
function $c7af1bed83ff3310$export$8a4f1dcc58a69dbd(a, b, tolerance) {
    if (tolerance === void 0) tolerance = 0.00001;
    return Math.abs(a - b) <= tolerance;
}
function $c7af1bed83ff3310$export$7d15b64cf5a3a4c4(val, min, max) {
    if (val == null) return val;
    if (max < min) throw new Error((0, $bzsu8.CLAMP_MIN_MAX));
    return Math.min(Math.max(val, min), max);
}
function $c7af1bed83ff3310$export$a42544f265f8403(num) {
    if (!isFinite(num)) return 0;
    var e = 1;
    var p = 0;
    while(Math.round(num * e) / e !== num){
        e *= 10;
        p++;
    }
    return p;
}
var $c7af1bed83ff3310$var$uniqueCountForNamespace = new Map();
function $c7af1bed83ff3310$export$8b15d37bc3f197d4(namespace) {
    var _a;
    var curCount = (_a = $c7af1bed83ff3310$var$uniqueCountForNamespace.get(namespace)) !== null && _a !== void 0 ? _a : 0;
    $c7af1bed83ff3310$var$uniqueCountForNamespace.set(namespace, curCount + 1);
    return "".concat(namespace, "-").concat(curCount);
}
function $c7af1bed83ff3310$export$78d1711480f95c3e(val) {
    return typeof val === "string" && val.trim().length === 0;
}

});
parcelRegister("bzsu8", function(module, exports) {

$parcel$export(module.exports, "CLAMP_MIN_MAX", () => $86c90f20010f257e$export$4fcb16c0555f6e60);
$parcel$export(module.exports, "INPUT_WARN_LEFT_ELEMENT_LEFT_ICON_MUTEX", () => $86c90f20010f257e$export$7dcc26c4d745a6de);
$parcel$export(module.exports, "NUMERIC_INPUT_MIN_MAX", () => $86c90f20010f257e$export$5813ec87ec3acb90);
$parcel$export(module.exports, "NUMERIC_INPUT_MINOR_STEP_SIZE_BOUND", () => $86c90f20010f257e$export$560b8988862ea429);
$parcel$export(module.exports, "NUMERIC_INPUT_MAJOR_STEP_SIZE_BOUND", () => $86c90f20010f257e$export$6e5c02badc46235e);
$parcel$export(module.exports, "NUMERIC_INPUT_MINOR_STEP_SIZE_NON_POSITIVE", () => $86c90f20010f257e$export$bfff41693cbc35d4);
$parcel$export(module.exports, "NUMERIC_INPUT_MAJOR_STEP_SIZE_NON_POSITIVE", () => $86c90f20010f257e$export$659f97d5057a476);
$parcel$export(module.exports, "NUMERIC_INPUT_STEP_SIZE_NON_POSITIVE", () => $86c90f20010f257e$export$cf406687fba595e5);
$parcel$export(module.exports, "NUMERIC_INPUT_CONTROLLED_VALUE_INVALID", () => $86c90f20010f257e$export$b9f78c93f51845b9);
$parcel$export(module.exports, "OVERFLOW_LIST_OBSERVE_PARENTS_CHANGED", () => $86c90f20010f257e$export$19bc0ed8b2e0d575);
$parcel$export(module.exports, "POPOVER_REQUIRES_TARGET", () => $86c90f20010f257e$export$3cf04cff067b1497);
$parcel$export(module.exports, "POPOVER_HAS_BACKDROP_INTERACTION", () => $86c90f20010f257e$export$deb4db7b191454de);
$parcel$export(module.exports, "POPOVER_WARN_TOO_MANY_CHILDREN", () => $86c90f20010f257e$export$d26b2b7b10deb660);
$parcel$export(module.exports, "POPOVER_WARN_DOUBLE_TARGET", () => $86c90f20010f257e$export$92bbc536d12dd3d6);
$parcel$export(module.exports, "POPOVER_WARN_EMPTY_CONTENT", () => $86c90f20010f257e$export$fb9dc24caac9c30e);
$parcel$export(module.exports, "POPOVER_WARN_HAS_BACKDROP_INLINE", () => $86c90f20010f257e$export$d2c026502cfc32e6);
$parcel$export(module.exports, "POPOVER_WARN_PLACEMENT_AND_POSITION_MUTEX", () => $86c90f20010f257e$export$bd8a2148d985bb65);
$parcel$export(module.exports, "POPOVER_WARN_UNCONTROLLED_ONINTERACTION", () => $86c90f20010f257e$export$cdb7203a6f2d3ac9);
$parcel$export(module.exports, "POPOVER_WARN_TARGET_PROPS_WITH_RENDER_TARGET", () => $86c90f20010f257e$export$958f5bcc111a3890);
$parcel$export(module.exports, "PORTAL_CONTEXT_CLASS_NAME_STRING", () => $86c90f20010f257e$export$c806064fdc775efa);
$parcel$export(module.exports, "PORTAL_LEGACY_CONTEXT_API", () => $86c90f20010f257e$export$26dc7cef361ed92a);
$parcel$export(module.exports, "SLIDER_ZERO_STEP", () => $86c90f20010f257e$export$3f628d74aa22ee14);
$parcel$export(module.exports, "SLIDER_ZERO_LABEL_STEP", () => $86c90f20010f257e$export$e1e1f71b44b50957);
$parcel$export(module.exports, "SLIDER_MIN", () => $86c90f20010f257e$export$bd089811e8f6237d);
$parcel$export(module.exports, "SLIDER_MAX", () => $86c90f20010f257e$export$34f34bdfff94a103);
$parcel$export(module.exports, "MULTISLIDER_INVALID_CHILD", () => $86c90f20010f257e$export$5c23f31d1ea14389);
$parcel$export(module.exports, "MULTISLIDER_WARN_LABEL_STEP_SIZE_LABEL_VALUES_MUTEX", () => $86c90f20010f257e$export$be7e9beb3b581c37);
$parcel$export(module.exports, "SPINNER_WARN_CLASSES_SIZE", () => $86c90f20010f257e$export$612c20961251008f);
$parcel$export(module.exports, "DIALOG_WARN_NO_HEADER_ICON", () => $86c90f20010f257e$export$2c7c4d8c17b24fc3);
$parcel$export(module.exports, "DIALOG_WARN_NO_HEADER_CLOSE_BUTTON", () => $86c90f20010f257e$export$b1ffdd5a20552cca);
$parcel$export(module.exports, "OVERLAY2_REQUIRES_OVERLAY_PROVDER", () => $86c90f20010f257e$export$ec9bf1f3f03eed46);
$parcel$export(module.exports, "OVERLAY_CHILD_REF_AND_REFS_MUTEX", () => $86c90f20010f257e$export$9a7688a076ebfc22);
$parcel$export(module.exports, "OVERLAY_WITH_MULTIPLE_CHILDREN_REQUIRES_CHILD_REFS", () => $86c90f20010f257e$export$d1780dd5da45c8d8);
$parcel$export(module.exports, "OVERLAY_CHILD_REQUIRES_KEY", () => $86c90f20010f257e$export$5c53f620d79bf998);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $86c90f20010f257e$var$ns = "[Blueprint]";
var $86c90f20010f257e$export$4fcb16c0555f6e60 = $86c90f20010f257e$var$ns + " clamp: max cannot be less than min";
var $86c90f20010f257e$export$5b85f29a2be29baf = $86c90f20010f257e$var$ns + " <Alert> cancelButtonText and onCancel should be set together.";
var $86c90f20010f257e$export$f6e5524776d50d97 = $86c90f20010f257e$var$ns + " <Alert> canEscapeKeyCancel enabled without onCancel or onClose handler.";
var $86c90f20010f257e$export$b72cc84fa7249bbc = $86c90f20010f257e$var$ns + " <Alert> canOutsideClickCancel enabled without onCancel or onClose handler.";
var $86c90f20010f257e$export$a966041437837cbb = $86c90f20010f257e$var$ns + " <Hotkeys> only accepts <Hotkey> children.";
var $86c90f20010f257e$export$670242ac4c5d7db8 = $86c90f20010f257e$var$ns + " useHotkeys() was used outside of a <HotkeysProvider> context. These hotkeys will not be shown in the hotkeys help dialog.";
var $86c90f20010f257e$export$9dbacdb91396601 = $86c90f20010f257e$var$ns + " <HotkeysTarget2> was configured with local hotkeys, but you did not use the generated event handlers to bind their event handlers. Try using a render function as the child of this component.";
var $86c90f20010f257e$export$7dcc26c4d745a6de = $86c90f20010f257e$var$ns + " <InputGroup> leftElement and leftIcon prop are mutually exclusive, with leftElement taking priority.";
var $86c90f20010f257e$export$5813ec87ec3acb90 = $86c90f20010f257e$var$ns + " <NumericInput> requires min to be no greater than max if both are defined.";
var $86c90f20010f257e$export$560b8988862ea429 = $86c90f20010f257e$var$ns + " <NumericInput> requires minorStepSize to be no greater than stepSize.";
var $86c90f20010f257e$export$6e5c02badc46235e = $86c90f20010f257e$var$ns + " <NumericInput> requires stepSize to be no greater than majorStepSize.";
var $86c90f20010f257e$export$bfff41693cbc35d4 = $86c90f20010f257e$var$ns + " <NumericInput> requires minorStepSize to be strictly greater than zero.";
var $86c90f20010f257e$export$659f97d5057a476 = $86c90f20010f257e$var$ns + " <NumericInput> requires majorStepSize to be strictly greater than zero.";
var $86c90f20010f257e$export$cf406687fba595e5 = $86c90f20010f257e$var$ns + " <NumericInput> requires stepSize to be strictly greater than zero.";
var $86c90f20010f257e$export$b9f78c93f51845b9 = $86c90f20010f257e$var$ns + " <NumericInput> controlled value prop does not adhere to stepSize, min, and/or max constraints.";
var $86c90f20010f257e$export$8a4f82273d0e92f = $86c90f20010f257e$var$ns + " <PanelStack> requires exactly one of initialPanel and stack prop";
var $86c90f20010f257e$export$3a88d598d258d4d5 = $86c90f20010f257e$var$ns + " <PanelStack> requires at least one panel in the stack";
var $86c90f20010f257e$export$19bc0ed8b2e0d575 = $86c90f20010f257e$var$ns + " <OverflowList> does not support changing observeParents after mounting.";
var $86c90f20010f257e$export$3cf04cff067b1497 = "".concat($86c90f20010f257e$var$ns, " <Popover> requires renderTarget prop or a child element.");
var $86c90f20010f257e$export$deb4db7b191454de = "".concat($86c90f20010f257e$var$ns, ' <Popover hasBackdrop={true}> requires interactionKind="click".');
var $86c90f20010f257e$export$d26b2b7b10deb660 = "".concat($86c90f20010f257e$var$ns, " <Popover> supports only one child which is rendered as its target; additional children are ignored.");
var $86c90f20010f257e$export$92bbc536d12dd3d6 = $86c90f20010f257e$var$ns + " <Popover> with children ignores renderTarget prop; use either prop or children.";
var $86c90f20010f257e$export$fb9dc24caac9c30e = $86c90f20010f257e$var$ns + " Disabling <Popover> with empty/whitespace content...";
var $86c90f20010f257e$export$d2c026502cfc32e6 = $86c90f20010f257e$var$ns + " <Popover usePortal={false}> ignores hasBackdrop";
var $86c90f20010f257e$export$bd8a2148d985bb65 = $86c90f20010f257e$var$ns + " <Popover> supports either placement or position prop, not both.";
var $86c90f20010f257e$export$cdb7203a6f2d3ac9 = $86c90f20010f257e$var$ns + " <Popover> onInteraction is ignored when uncontrolled.";
var $86c90f20010f257e$export$958f5bcc111a3890 = $86c90f20010f257e$var$ns + " <Popover> targetProps value is ignored when renderTarget API is used.";
var $86c90f20010f257e$export$c806064fdc775efa = $86c90f20010f257e$var$ns + " <Portal> context blueprintPortalClassName must be string";
var $86c90f20010f257e$export$26dc7cef361ed92a = $86c90f20010f257e$var$ns + " setting blueprintPortalClassName via legacy React context API is deprecated, use <PortalProvider> instead.";
var $86c90f20010f257e$export$85aa0d720577b224 = $86c90f20010f257e$var$ns + " <RadioGroup> children and options prop are mutually exclusive, with options taking priority.";
var $86c90f20010f257e$export$3f628d74aa22ee14 = $86c90f20010f257e$var$ns + " <Slider> stepSize must be greater than zero.";
var $86c90f20010f257e$export$e1e1f71b44b50957 = $86c90f20010f257e$var$ns + " <Slider> labelStepSize must be greater than zero.";
var $86c90f20010f257e$export$bd089811e8f6237d = $86c90f20010f257e$var$ns + " <Slider> min prop must be a finite number.";
var $86c90f20010f257e$export$34f34bdfff94a103 = $86c90f20010f257e$var$ns + " <Slider> max prop must be a finite number.";
var $86c90f20010f257e$export$8cdad9f5b77513a2 = $86c90f20010f257e$var$ns + " <RangeSlider> value prop must be an array of two non-null numbers.";
var $86c90f20010f257e$export$5c23f31d1ea14389 = $86c90f20010f257e$var$ns + " <MultiSlider> children must be <SliderHandle>s or <SliderTrackStop>s";
var $86c90f20010f257e$export$be7e9beb3b581c37 = $86c90f20010f257e$var$ns + " <MultiSlider> labelStepSize and labelValues prop are mutually exclusive, with labelStepSize taking priority.";
var $86c90f20010f257e$export$612c20961251008f = $86c90f20010f257e$var$ns + " <Spinner> Classes.SMALL/LARGE are ignored if size prop is set.";
var $86c90f20010f257e$export$fdceab30a81a80e3 = $86c90f20010f257e$var$ns + " OverlayToaster.create() is not supported inside React lifecycle methods in React 16." + " See usage example on the docs site. https://blueprintjs.com/docs/#core/components/toast.example";
var $86c90f20010f257e$export$b43eb3d543c5291f = $86c90f20010f257e$var$ns + " OverlayToaster.createAsync() received a null component ref. This can happen if called inside React lifecycle " + "methods in React 16. See usage example on the docs site. " + "https://blueprintjs.com/docs/#core/components/toast.example";
var $86c90f20010f257e$export$2451692ca60e5d58 = $86c90f20010f257e$var$ns + " <OverlayToaster> maxToasts is set to an invalid number, must be greater than 0";
var $86c90f20010f257e$export$18ab8fe30147e847 = $86c90f20010f257e$var$ns + " OverlayToaster.create() ignores inline prop as it always creates a new element.";
var $86c90f20010f257e$export$2c7c4d8c17b24fc3 = $86c90f20010f257e$var$ns + " <Dialog> iconName is ignored if title is omitted.";
var $86c90f20010f257e$export$b1ffdd5a20552cca = $86c90f20010f257e$var$ns + " <Dialog> isCloseButtonShown prop is ignored if title is omitted.";
var $86c90f20010f257e$export$ee41c46c4147fad0 = $86c90f20010f257e$var$ns + " <Drawer> all angle positions are casted into pure position (TOP, BOTTOM, LEFT or RIGHT)";
var $86c90f20010f257e$export$ec9bf1f3f03eed46 = $86c90f20010f257e$var$ns + " <Overlay2> was used outside of a <OverlaysProvider> context. This will no longer be supported in " + "Blueprint v6. See https://github.com/palantir/blueprint/wiki/Overlay2-migration";
var $86c90f20010f257e$export$9a7688a076ebfc22 = $86c90f20010f257e$var$ns + " <Overlay2> cannot use childRef and childRefs props simultaneously";
var $86c90f20010f257e$export$d1780dd5da45c8d8 = $86c90f20010f257e$var$ns + " <Overlay2> requires childRefs prop when rendering multiple child elements";
var $86c90f20010f257e$export$5c53f620d79bf998 = $86c90f20010f257e$var$ns + " <Overlay2> requires each child element to have a unique key prop when childRefs is used";

});


parcelRegister("4FOwp", function(module, exports) {

$parcel$export(module.exports, "isReactNodeEmpty", () => $36722e4ea79f3d2b$export$5a81b62107752acd);
$parcel$export(module.exports, "isReactChildrenElementOrElements", () => $36722e4ea79f3d2b$export$1a5f9f98c90cf6a1);
$parcel$export(module.exports, "ensureElement", () => $36722e4ea79f3d2b$export$7210cc31459d553a);
$parcel$export(module.exports, "isReactElement", () => $36722e4ea79f3d2b$export$564ec7e3bcdb7847);
$parcel$export(module.exports, "isElementOfType", () => $36722e4ea79f3d2b$export$8bb8d43ade7732d8);
$parcel$export(module.exports, "isReact18", () => $36722e4ea79f3d2b$export$f4e52b20fe962eb2);
/*
 * Copyright 2020 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $8NFma = parcelRequire("8NFma");

var $h8UCV = parcelRequire("h8UCV");
function $36722e4ea79f3d2b$export$5a81b62107752acd(node, skipArray) {
    if (skipArray === void 0) skipArray = false;
    return node == null || node === "" || node === false || !skipArray && Array.isArray(node) && // only recurse one level through arrays, for performance
    (node.length === 0 || node.every(function(n) {
        return $36722e4ea79f3d2b$export$5a81b62107752acd(n, true);
    }));
}
function $36722e4ea79f3d2b$export$1a5f9f98c90cf6a1(children) {
    return !$36722e4ea79f3d2b$export$5a81b62107752acd(children, true) && children !== true;
}
function $36722e4ea79f3d2b$export$7210cc31459d553a(child, tagName, props) {
    if (tagName === void 0) tagName = "span";
    if (props === void 0) props = {};
    if (child == null || typeof child === "boolean" || (0, $h8UCV.isEmptyString)(child)) return undefined;
    else if (typeof child === "string" || typeof child === "number" || $36722e4ea79f3d2b$var$isReactFragment(child) || $36722e4ea79f3d2b$var$isReactNodeArray(child)) // wrap the child element
    return $8NFma.createElement(tagName, props, child);
    else if ($36722e4ea79f3d2b$export$564ec7e3bcdb7847(child)) {
        if (Object.keys(props).length > 0) // clone the element and merge props
        return $8NFma.cloneElement(child, props);
        else // nothing to do, it's a valid ReactElement
        return child;
    } else // child is inferred as {}
    return undefined;
}
function $36722e4ea79f3d2b$export$564ec7e3bcdb7847(child) {
    return typeof child === "object" && typeof child.type !== "undefined" && typeof child.props !== "undefined";
}
function $36722e4ea79f3d2b$var$isReactFragment(child) {
    // bit hacky, but generally works
    return typeof child.type === "symbol";
}
function $36722e4ea79f3d2b$var$isReactNodeArray(child) {
    return Array.isArray(child);
}
function $36722e4ea79f3d2b$export$8bb8d43ade7732d8(element, ComponentType) {
    return element != null && element.type != null && element.type.displayName != null && element.type.displayName === ComponentType.displayName;
}
function $36722e4ea79f3d2b$export$f4e52b20fe962eb2() {
    return $8NFma.version.startsWith("18");
}

});

parcelRegister("lJ8GL", function(module, exports) {

$parcel$export(module.exports, "isKeyboardClick", () => $fd148a5b892c62dd$export$746ace428e2a5877);
$parcel$export(module.exports, "isArrowKey", () => $fd148a5b892c62dd$export$a0d3f776048184d0);
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns whether the keyboard event was triggered by Enter or Space, the two keys that are expected to trigger
 * interactive elements like buttons.
 */ function $fd148a5b892c62dd$export$746ace428e2a5877(event) {
    return event.key === "Enter" || event.key === " ";
}
function $fd148a5b892c62dd$export$a0d3f776048184d0(event) {
    return [
        "ArrowUp",
        "ArrowDown",
        "ArrowLeft",
        "ArrowRight"
    ].indexOf(event.key) >= 0;
}

});

parcelRegister("2Z1MG", function(module, exports) {

$parcel$export(module.exports, "isDarkTheme", () => $22c2a9950834db28$export$5a63ccfbe4d87ef0);
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $auzpd = parcelRequire("auzpd");
function $22c2a9950834db28$export$5a63ccfbe4d87ef0(element) {
    return element != null && element instanceof Element && element.closest(".".concat($auzpd.DARK)) != null;
}

});

parcelRegister("8k66C", function(module, exports) {

$parcel$export(module.exports, "setRef", () => $60f4ed75369e5333$export$4bb192c7cacf928f);
$parcel$export(module.exports, "mergeRefs", () => $60f4ed75369e5333$export$c9058316764c140e);
$parcel$export(module.exports, "getRef", () => $60f4ed75369e5333$export$f0c653cfd7dea798);
$parcel$export(module.exports, "refHandler", () => $60f4ed75369e5333$export$e9e0d2af9a57b401);
/*
 * Copyright 2020 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $60f4ed75369e5333$export$dedd81df7bc1307(value) {
    return value != null && typeof value !== "function";
}
function $60f4ed75369e5333$export$76025ed275866d92(value) {
    return typeof value === "function";
}
function $60f4ed75369e5333$export$4bb192c7cacf928f(refTarget, ref) {
    if ($60f4ed75369e5333$export$dedd81df7bc1307(refTarget)) // HACKHACK: .current property is readonly
    refTarget.current = ref;
    else if ($60f4ed75369e5333$export$76025ed275866d92(refTarget)) refTarget(ref);
}
function $60f4ed75369e5333$export$c9058316764c140e() {
    var refs = [];
    for(var _i = 0; _i < arguments.length; _i++)refs[_i] = arguments[_i];
    return function(value) {
        refs.forEach(function(ref) {
            $60f4ed75369e5333$export$4bb192c7cacf928f(ref, value);
        });
    };
}
function $60f4ed75369e5333$export$f0c653cfd7dea798(ref) {
    if (ref === null) return null;
    if (typeof ref.current === "undefined") return ref;
    return ref.current;
}
function $60f4ed75369e5333$export$e9e0d2af9a57b401(refTargetParent, refTargetKey, refProp) {
    return function(ref) {
        refTargetParent[refTargetKey] = ref;
        $60f4ed75369e5333$export$4bb192c7cacf928f(refProp, ref);
    };
}

});


parcelRegister("hffzE", function(module, exports) {

$parcel$export(module.exports, "DISPLAYNAME_PREFIX", () => $c8dfeb0cee8b94a0$export$64b684a1d3f6f6a6);
$parcel$export(module.exports, "removeNonHTMLProps", () => $c8dfeb0cee8b94a0$export$962dd23b3e663274);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");
var $c8dfeb0cee8b94a0$export$64b684a1d3f6f6a6 = "Blueprint5";
/** A collection of curated prop keys used across our Components which are not valid HTMLElement props. */ var $c8dfeb0cee8b94a0$var$INVALID_PROPS = [
    "active",
    "alignText",
    "asyncControl",
    "containerRef",
    "current",
    "elementRef",
    "ellipsizeText",
    "fill",
    "icon",
    "iconSize",
    "inputClassName",
    "inputRef",
    "intent",
    "inline",
    "large",
    "loading",
    "leftElement",
    "leftIcon",
    "minimal",
    "onRemove",
    "outlined",
    "panel",
    "panelClassName",
    "popoverProps",
    "rightElement",
    "rightIcon",
    "round",
    "size",
    "small",
    "tagName",
    "text",
    "textClassName"
];
function $c8dfeb0cee8b94a0$export$962dd23b3e663274(props, invalidProps, shouldMerge) {
    if (invalidProps === void 0) invalidProps = $c8dfeb0cee8b94a0$var$INVALID_PROPS;
    if (shouldMerge === void 0) shouldMerge = false;
    if (shouldMerge) invalidProps = invalidProps.concat($c8dfeb0cee8b94a0$var$INVALID_PROPS);
    return invalidProps.reduce(function(prev, curr) {
        // Props with hyphens (e.g. data-*) are always considered html props
        if (curr.indexOf("-") !== -1) return prev;
        if (prev.hasOwnProperty(curr)) delete prev[curr];
        return prev;
    }, (0, $gztBd.__assign)({}, props));
}

});

parcelRegister("gKgL3", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $c30df0ff93ab0f32$export$f04a61298a47a40f);
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $eMPTp = parcelRequire("eMPTp");
var $leH9B = parcelRequire("leH9B");
var $eog74 = parcelRequire("eog74");

var $auzpd = parcelRequire("auzpd");
var $hffzE = parcelRequire("hffzE");
var $c30df0ff93ab0f32$export$f04a61298a47a40f = $8NFma.forwardRef(function(props, ref) {
    var _a, _b;
    var autoLoad = props.autoLoad, className = props.className, color = props.color, icon = props.icon, intent = props.intent, tagName = props.tagName, svgProps = props.svgProps, title = props.title, htmlTitle = props.htmlTitle, htmlProps = (0, $gztBd.__rest)(props, [
        "autoLoad",
        "className",
        "color",
        "icon",
        "intent",
        "tagName",
        "svgProps",
        "title",
        "htmlTitle"
    ]);
    // Preserve Blueprint v4.x behavior: iconSize prop takes predecence, then size prop, then fall back to default value
    // eslint-disable-next-line deprecation/deprecation
    var size = (_b = (_a = props.iconSize) !== null && _a !== void 0 ? _a : props.size) !== null && _b !== void 0 ? _b : (0, $leH9B.IconSize).STANDARD;
    var _c = $8NFma.useState(function() {
        return typeof icon === "string" ? (0, $eMPTp.Icons).getPaths(icon, size) : undefined;
    }), iconPaths = _c[0], setIconPaths = _c[1];
    $8NFma.useEffect(function() {
        var shouldCancelIconLoading = false;
        if (typeof icon === "string") {
            // The icon may have been loaded already, in which case we can simply grab it.
            // N.B. when `autoLoad={true}`, we can't rely on simply calling Icons.load() here to re-load an icon module
            // which has already been loaded & cached, since it may have been loaded with special loading options which
            // this component knows nothing about.
            var loadedIconPaths = (0, $eMPTp.Icons).getPaths(icon, size);
            if (loadedIconPaths !== undefined) setIconPaths(loadedIconPaths);
            else if (autoLoad) (0, $eMPTp.Icons).load(icon, size).then(function() {
                // if this effect expired by the time icon loaded, then don't set state
                if (!shouldCancelIconLoading) setIconPaths((0, $eMPTp.Icons).getPaths(icon, size));
            }).catch(function(reason) {
                console.error("[Blueprint] Icon '".concat(icon, "' (").concat(size, "px) could not be loaded."), reason);
            });
            else console.error("[Blueprint] Icon '".concat(icon, "' (").concat(size, "px) is not loaded yet and autoLoad={false}, did you call Icons.load('").concat(icon, "', ").concat(size, ")?"));
        }
        return function() {
            shouldCancelIconLoading = true;
        };
    }, [
        autoLoad,
        icon,
        size
    ]);
    if (icon == null || typeof icon === "boolean") return null;
    else if (typeof icon !== "string") return icon;
    if (iconPaths == null) {
        // fall back to icon font if unloaded or unable to load SVG implementation
        var sizeClass = size === (0, $leH9B.IconSize).STANDARD ? (0, $auzpd).ICON_STANDARD : size === (0, $leH9B.IconSize).LARGE ? (0, $auzpd).ICON_LARGE : undefined;
        return $8NFma.createElement(tagName, (0, $gztBd.__assign)((0, $gztBd.__assign)({
            "aria-hidden": title ? undefined : true
        }, (0, $hffzE.removeNonHTMLProps)(htmlProps)), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $auzpd).ICON, sizeClass, (0, $auzpd).iconClass(icon), (0, $auzpd).intentClass(intent), className),
            "data-icon": icon,
            ref: ref,
            title: htmlTitle
        }));
    } else {
        var pathElements = iconPaths.map(function(d, i) {
            return $8NFma.createElement("path", {
                d: d,
                key: i,
                fillRule: "evenodd"
            });
        });
        // HACKHACK: there is no good way to narrow the type of SVGIconContainerProps here because of the use
        // of a conditional type within the type union that defines that interface. So we cast to <any>.
        // see https://github.com/microsoft/TypeScript/issues/24929, https://github.com/microsoft/TypeScript/issues/33014
        return $8NFma.createElement((0, $eog74.SVGIconContainer), (0, $gztBd.__assign)({
            children: pathElements,
            // don't forward `Classes.ICON` or `Classes.iconClass(icon)` here, since the container will render those classes
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $auzpd).intentClass(intent), className),
            color: color,
            htmlTitle: htmlTitle,
            iconName: icon,
            ref: ref,
            size: size,
            svgProps: svgProps,
            tagName: tagName,
            title: title
        }, (0, $hffzE.removeNonHTMLProps)(htmlProps)));
    }
});
$c30df0ff93ab0f32$export$f04a61298a47a40f.defaultProps = {
    autoLoad: true,
    tagName: "span"
};
$c30df0ff93ab0f32$export$f04a61298a47a40f.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".Icon");

});
parcelRegister("eMPTp", function(module, exports) {

$parcel$export(module.exports, "Icons", () => $ac3dcd31e314f9f8$export$4f13f83fd8bb1dac);
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $aEHIg = parcelRequire("aEHIg");

var $leH9B = parcelRequire("leH9B");

var $7zSP3 = parcelRequire("7zSP3");


function $ac3dcd31e314f9f8$var$getLoaderFn(options) {
    return (0, $gztBd.__awaiter)(this, void 0, void 0, function() {
        var _a, loader;
        return (0, $gztBd.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _a = options.loader, loader = _a === void 0 ? $ac3dcd31e314f9f8$var$singleton.defaultLoader : _a;
                    if (!(typeof loader === "function")) return [
                        3 /*break*/ ,
                        1
                    ];
                    return [
                        2 /*return*/ ,
                        loader
                    ];
                case 1:
                    if (!(loader === "all")) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        (parcelRequire("k5h1n"))
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        _b.sent().allPathsLoader
                    ];
                case 3:
                    return [
                        4 /*yield*/ ,
                        (parcelRequire("3emq3"))
                    ];
                case 4:
                    return [
                        2 /*return*/ ,
                        _b.sent().splitPathsBySizeLoader
                    ];
            }
        });
    });
}
/**
 * Blueprint icons loader.
 */ var $ac3dcd31e314f9f8$export$4f13f83fd8bb1dac = /** @class */ function() {
    function Icons() {
        /** @internal */ this.defaultLoader = "split-by-size";
        /** @internal */ this.loadedIconPaths16 = new Map();
        /** @internal */ this.loadedIconPaths20 = new Map();
    }
    /**
     * Set global icon loading options for all subsequent `Icons.load()` calls.
     */ Icons.setLoaderOptions = function(options) {
        if (options.loader !== undefined) $ac3dcd31e314f9f8$var$singleton.defaultLoader = options.loader;
    };
    Icons.load = function(icons, size, options) {
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, $gztBd.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!Array.isArray(icons)) icons = [
                            icons
                        ];
                        return [
                            4 /*yield*/ ,
                            Promise.all(icons.map(function(icon) {
                                return _this.loadImpl(icon, size, options);
                            }))
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Load all available icons for use in Blueprint components.
     */ Icons.loadAll = function(options) {
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function() {
            var allIcons;
            var _this = this;
            return (0, $gztBd.__generator)(this, function(_a) {
                allIcons = Object.values((0, $aEHIg.IconNames));
                (0, $7zSP3.wrapWithTimer)("[Blueprint] loading all icons", function() {
                    return (0, $gztBd.__awaiter)(_this, void 0, void 0, function() {
                        return (0, $gztBd.__generator)(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    return [
                                        4 /*yield*/ ,
                                        Promise.all([
                                            this.load(allIcons, (0, $leH9B.IconSize).STANDARD, options),
                                            this.load(allIcons, (0, $leH9B.IconSize).LARGE, options)
                                        ])
                                    ];
                                case 1:
                                    _a.sent();
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                });
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Get the icon SVG paths. Returns `undefined` if the icon has not been loaded yet.
     */ Icons.getPaths = function(icon, size) {
        if (!this.isValidIconName(icon)) // don't warn, since this.load() will have warned already
        return undefined;
        var loadedIcons = size < (0, $leH9B.IconSize).LARGE ? $ac3dcd31e314f9f8$var$singleton.loadedIconPaths16 : $ac3dcd31e314f9f8$var$singleton.loadedIconPaths20;
        return loadedIcons.get(icon);
    };
    Icons.loadImpl = function(icon, size, options) {
        if (options === void 0) options = {};
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function() {
            var loadedIcons, loaderFn, supportedSize, paths, e_1;
            return (0, $gztBd.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.isValidIconName(icon)) {
                            console.error("[Blueprint] Unknown icon '".concat(icon, "'"));
                            return [
                                2 /*return*/ 
                            ];
                        }
                        loadedIcons = size < (0, $leH9B.IconSize).LARGE ? $ac3dcd31e314f9f8$var$singleton.loadedIconPaths16 : $ac3dcd31e314f9f8$var$singleton.loadedIconPaths20;
                        if (loadedIcons.has(icon)) // already loaded, no-op
                        return [
                            2 /*return*/ 
                        ];
                        return [
                            4 /*yield*/ ,
                            $ac3dcd31e314f9f8$var$getLoaderFn(options)
                        ];
                    case 1:
                        loaderFn = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        supportedSize = size < (0, $leH9B.IconSize).LARGE ? (0, $leH9B.IconSize).STANDARD : (0, $leH9B.IconSize).LARGE;
                        return [
                            4 /*yield*/ ,
                            loaderFn(icon, supportedSize)
                        ];
                    case 3:
                        paths = _a.sent();
                        loadedIcons.set(icon, paths);
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        e_1 = _a.sent();
                        console.error("[Blueprint] Unable to load ".concat(size, "px icon '").concat(icon, "'"), e_1);
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * @returns true if the given string is a valid {@link IconName}
     */ Icons.isValidIconName = function(iconName) {
        return (0, $aEHIg.IconNamesSet).has(iconName);
    };
    return Icons;
}();
var $ac3dcd31e314f9f8$var$singleton = new $ac3dcd31e314f9f8$export$4f13f83fd8bb1dac();

});
parcelRegister("aEHIg", function(module, exports) {

$parcel$export(module.exports, "IconNames", () => $7c1f8c4eed4eb62c$export$897be40ab5372714);
$parcel$export(module.exports, "IconNamesSet", () => $7c1f8c4eed4eb62c$export$9c3c8ad8ae0fef6c);
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $704DA = parcelRequire("704DA");
var $hZLvw = parcelRequire("hZLvw");

var $eaXMZ = parcelRequire("eaXMZ");
var $7c1f8c4eed4eb62c$var$IconNamesNew = {};
var $7c1f8c4eed4eb62c$var$IconNamesLegacy = {};
for(var $7c1f8c4eed4eb62c$var$_i = 0, $7c1f8c4eed4eb62c$var$_a = Object.values((0, $eaXMZ.BlueprintIcons_16)); $7c1f8c4eed4eb62c$var$_i < $7c1f8c4eed4eb62c$var$_a.length; $7c1f8c4eed4eb62c$var$_i++){
    var $7c1f8c4eed4eb62c$var$name_1 = $7c1f8c4eed4eb62c$var$_a[$7c1f8c4eed4eb62c$var$_i];
    $7c1f8c4eed4eb62c$var$IconNamesNew[(0, $704DA.pascalCase)($7c1f8c4eed4eb62c$var$name_1)] = $7c1f8c4eed4eb62c$var$name_1;
    $7c1f8c4eed4eb62c$var$IconNamesLegacy[(0, $hZLvw.snakeCase)($7c1f8c4eed4eb62c$var$name_1).toUpperCase()] = $7c1f8c4eed4eb62c$var$name_1;
}
var $7c1f8c4eed4eb62c$export$897be40ab5372714 = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, $7c1f8c4eed4eb62c$var$IconNamesNew), $7c1f8c4eed4eb62c$var$IconNamesLegacy);
var $7c1f8c4eed4eb62c$export$9c3c8ad8ae0fef6c = new Set(Object.values($7c1f8c4eed4eb62c$export$897be40ab5372714));

});
parcelRegister("704DA", function(module, exports) {

$parcel$export(module.exports, "pascalCase", () => $518c2169c8583fb6$export$26c6f48841fe1a8a);

var $gztBd = parcelRequire("gztBd");

var $bYk83 = parcelRequire("bYk83");
function $518c2169c8583fb6$export$66a4dfea2695736(input, index) {
    var firstChar = input.charAt(0);
    var lowerChars = input.substr(1).toLowerCase();
    if (index > 0 && firstChar >= "0" && firstChar <= "9") return "_" + firstChar + lowerChars;
    return "" + firstChar.toUpperCase() + lowerChars;
}
function $518c2169c8583fb6$export$c27cf446dc44c0b9(input) {
    return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
}
function $518c2169c8583fb6$export$26c6f48841fe1a8a(input, options) {
    if (options === void 0) options = {};
    return (0, $bYk83.noCase)(input, (0, $gztBd.__assign)({
        delimiter: "",
        transform: $518c2169c8583fb6$export$66a4dfea2695736
    }, options));
}

});
parcelRegister("bYk83", function(module, exports) {

$parcel$export(module.exports, "noCase", () => $8b74e97fd94f2b02$export$a596972587f860c8);

var $f9ENP = parcelRequire("f9ENP");
// Support camel case ("camelCase" -> "camel Case" and "CAMELCase" -> "CAMEL Case").
var $8b74e97fd94f2b02$var$DEFAULT_SPLIT_REGEXP = [
    /([a-z0-9])([A-Z])/g,
    /([A-Z])([A-Z][a-z])/g
];
// Remove all non-word characters.
var $8b74e97fd94f2b02$var$DEFAULT_STRIP_REGEXP = /[^A-Z0-9]+/gi;
function $8b74e97fd94f2b02$export$a596972587f860c8(input, options) {
    if (options === void 0) options = {};
    var _a = options.splitRegexp, splitRegexp = _a === void 0 ? $8b74e97fd94f2b02$var$DEFAULT_SPLIT_REGEXP : _a, _b = options.stripRegexp, stripRegexp = _b === void 0 ? $8b74e97fd94f2b02$var$DEFAULT_STRIP_REGEXP : _b, _c = options.transform, transform = _c === void 0 ? (0, $f9ENP.lowerCase) : _c, _d = options.delimiter, delimiter = _d === void 0 ? " " : _d;
    var result = $8b74e97fd94f2b02$var$replace($8b74e97fd94f2b02$var$replace(input, splitRegexp, "$1\0$2"), stripRegexp, "\0");
    var start = 0;
    var end = result.length;
    // Trim the delimiter from around the output string.
    while(result.charAt(start) === "\0")start++;
    while(result.charAt(end - 1) === "\0")end--;
    // Transform each token independently.
    return result.slice(start, end).split("\0").map(transform).join(delimiter);
}
/**
 * Replace `re` in the input string with the replacement value.
 */ function $8b74e97fd94f2b02$var$replace(input, re, value) {
    if (re instanceof RegExp) return input.replace(re, value);
    return re.reduce(function(input, re) {
        return input.replace(re, value);
    }, input);
}

});
parcelRegister("f9ENP", function(module, exports) {

$parcel$export(module.exports, "lowerCase", () => $b08758dc9b4bdf27$export$61d6efbc6547e8eb);
/**
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 */ var $b08758dc9b4bdf27$var$SUPPORTED_LOCALE = {
    tr: {
        regexp: /\u0130|\u0049|\u0049\u0307/g,
        map: {
            \u0130: "i",
            I: "\u0131",
            I\u0307: "i"
        }
    },
    az: {
        regexp: /\u0130/g,
        map: {
            \u0130: "i",
            I: "\u0131",
            I\u0307: "i"
        }
    },
    lt: {
        regexp: /\u0049|\u004A|\u012E|\u00CC|\u00CD|\u0128/g,
        map: {
            I: "i\u0307",
            J: "j\u0307",
            \u012E: "\u012F\u0307",
            "\xcc": "i\u0307\u0300",
            "\xcd": "i\u0307\u0301",
            \u0128: "i\u0307\u0303"
        }
    }
};
function $b08758dc9b4bdf27$export$206cd6ecad4fcdde(str, locale) {
    var lang = $b08758dc9b4bdf27$var$SUPPORTED_LOCALE[locale.toLowerCase()];
    if (lang) return $b08758dc9b4bdf27$export$61d6efbc6547e8eb(str.replace(lang.regexp, function(m) {
        return lang.map[m];
    }));
    return $b08758dc9b4bdf27$export$61d6efbc6547e8eb(str);
}
function $b08758dc9b4bdf27$export$61d6efbc6547e8eb(str) {
    return str.toLowerCase();
}

});



parcelRegister("hZLvw", function(module, exports) {

$parcel$export(module.exports, "snakeCase", () => $d19cfc2b935f9229$export$feae9a740c003485);

var $gztBd = parcelRequire("gztBd");

var $4enwX = parcelRequire("4enwX");
function $d19cfc2b935f9229$export$feae9a740c003485(input, options) {
    if (options === void 0) options = {};
    return (0, $4enwX.dotCase)(input, (0, $gztBd.__assign)({
        delimiter: "_"
    }, options));
}

});
parcelRegister("4enwX", function(module, exports) {

$parcel$export(module.exports, "dotCase", () => $314ab8e6fa3d31fa$export$e1b697368b9a68f5);

var $gztBd = parcelRequire("gztBd");

var $bYk83 = parcelRequire("bYk83");
function $314ab8e6fa3d31fa$export$e1b697368b9a68f5(input, options) {
    if (options === void 0) options = {};
    return (0, $bYk83.noCase)(input, (0, $gztBd.__assign)({
        delimiter: "."
    }, options));
}

});


parcelRegister("eaXMZ", function(module, exports) {

$parcel$export(module.exports, "BlueprintIcons_16", () => $a52060bda87dc153$export$f9661b8856577c15);
var $a52060bda87dc153$var$_a;
var $a52060bda87dc153$export$f9661b8856577c15;
(function(BlueprintIcons_16) {
    BlueprintIcons_16["AddClip"] = "add-clip";
    BlueprintIcons_16["AddColumnLeft"] = "add-column-left";
    BlueprintIcons_16["AddColumnRight"] = "add-column-right";
    BlueprintIcons_16["AddLocation"] = "add-location";
    BlueprintIcons_16["AddRowBottom"] = "add-row-bottom";
    BlueprintIcons_16["AddRowTop"] = "add-row-top";
    BlueprintIcons_16["AddToArtifact"] = "add-to-artifact";
    BlueprintIcons_16["AddToFolder"] = "add-to-folder";
    BlueprintIcons_16["Add"] = "add";
    BlueprintIcons_16["AimpointsTarget"] = "aimpoints-target";
    BlueprintIcons_16["Airplane"] = "airplane";
    BlueprintIcons_16["AlignCenter"] = "align-center";
    BlueprintIcons_16["AlignJustify"] = "align-justify";
    BlueprintIcons_16["AlignLeft"] = "align-left";
    BlueprintIcons_16["AlignRight"] = "align-right";
    BlueprintIcons_16["AlignmentBottom"] = "alignment-bottom";
    BlueprintIcons_16["AlignmentHorizontalCenter"] = "alignment-horizontal-center";
    BlueprintIcons_16["AlignmentLeft"] = "alignment-left";
    BlueprintIcons_16["AlignmentRight"] = "alignment-right";
    BlueprintIcons_16["AlignmentTop"] = "alignment-top";
    BlueprintIcons_16["AlignmentVerticalCenter"] = "alignment-vertical-center";
    BlueprintIcons_16["Ammunition"] = "ammunition";
    BlueprintIcons_16["Anchor"] = "anchor";
    BlueprintIcons_16["Annotation"] = "annotation";
    BlueprintIcons_16["Antenna"] = "antenna";
    BlueprintIcons_16["AppHeader"] = "app-header";
    BlueprintIcons_16["Application"] = "application";
    BlueprintIcons_16["Applications"] = "applications";
    BlueprintIcons_16["Archive"] = "archive";
    BlueprintIcons_16["AreaOfInterest"] = "area-of-interest";
    BlueprintIcons_16["ArrayBoolean"] = "array-boolean";
    BlueprintIcons_16["ArrayDate"] = "array-date";
    BlueprintIcons_16["ArrayFloatingPoint"] = "array-floating-point";
    BlueprintIcons_16["ArrayNumeric"] = "array-numeric";
    BlueprintIcons_16["ArrayString"] = "array-string";
    BlueprintIcons_16["ArrayTimestamp"] = "array-timestamp";
    BlueprintIcons_16["Array"] = "array";
    BlueprintIcons_16["ArrowBottomLeft"] = "arrow-bottom-left";
    BlueprintIcons_16["ArrowBottomRight"] = "arrow-bottom-right";
    BlueprintIcons_16["ArrowDown"] = "arrow-down";
    BlueprintIcons_16["ArrowLeft"] = "arrow-left";
    BlueprintIcons_16["ArrowRight"] = "arrow-right";
    BlueprintIcons_16["ArrowTopLeft"] = "arrow-top-left";
    BlueprintIcons_16["ArrowTopRight"] = "arrow-top-right";
    BlueprintIcons_16["ArrowUp"] = "arrow-up";
    BlueprintIcons_16["ArrowsHorizontal"] = "arrows-horizontal";
    BlueprintIcons_16["ArrowsVertical"] = "arrows-vertical";
    BlueprintIcons_16["Asterisk"] = "asterisk";
    BlueprintIcons_16["At"] = "at";
    BlueprintIcons_16["AutomaticUpdates"] = "automatic-updates";
    BlueprintIcons_16["Axle"] = "axle";
    BlueprintIcons_16["Backlink"] = "backlink";
    BlueprintIcons_16["BackwardTen"] = "backward-ten";
    BlueprintIcons_16["Badge"] = "badge";
    BlueprintIcons_16["BanCircle"] = "ban-circle";
    BlueprintIcons_16["BankAccount"] = "bank-account";
    BlueprintIcons_16["Barcode"] = "barcode";
    BlueprintIcons_16["BinaryNumber"] = "binary-number";
    BlueprintIcons_16["Blank"] = "blank";
    BlueprintIcons_16["BlockedPerson"] = "blocked-person";
    BlueprintIcons_16["Bold"] = "bold";
    BlueprintIcons_16["Book"] = "book";
    BlueprintIcons_16["Bookmark"] = "bookmark";
    BlueprintIcons_16["Box"] = "box";
    BlueprintIcons_16["Briefcase"] = "briefcase";
    BlueprintIcons_16["BringData"] = "bring-data";
    BlueprintIcons_16["BringForward"] = "bring-forward";
    BlueprintIcons_16["Bug"] = "bug";
    BlueprintIcons_16["Buggy"] = "buggy";
    BlueprintIcons_16["Build"] = "build";
    BlueprintIcons_16["Bullseye"] = "bullseye";
    BlueprintIcons_16["Calculator"] = "calculator";
    BlueprintIcons_16["Calendar"] = "calendar";
    BlueprintIcons_16["Camera"] = "camera";
    BlueprintIcons_16["CaretDown"] = "caret-down";
    BlueprintIcons_16["CaretLeft"] = "caret-left";
    BlueprintIcons_16["CaretRight"] = "caret-right";
    BlueprintIcons_16["CaretUp"] = "caret-up";
    BlueprintIcons_16["CargoShip"] = "cargo-ship";
    BlueprintIcons_16["CellTower"] = "cell-tower";
    BlueprintIcons_16["Changes"] = "changes";
    BlueprintIcons_16["Chart"] = "chart";
    BlueprintIcons_16["Chat"] = "chat";
    BlueprintIcons_16["ChevronBackward"] = "chevron-backward";
    BlueprintIcons_16["ChevronDown"] = "chevron-down";
    BlueprintIcons_16["ChevronForward"] = "chevron-forward";
    BlueprintIcons_16["ChevronLeft"] = "chevron-left";
    BlueprintIcons_16["ChevronRight"] = "chevron-right";
    BlueprintIcons_16["ChevronUp"] = "chevron-up";
    BlueprintIcons_16["CircleArrowDown"] = "circle-arrow-down";
    BlueprintIcons_16["CircleArrowLeft"] = "circle-arrow-left";
    BlueprintIcons_16["CircleArrowRight"] = "circle-arrow-right";
    BlueprintIcons_16["CircleArrowUp"] = "circle-arrow-up";
    BlueprintIcons_16["Circle"] = "circle";
    BlueprintIcons_16["Citation"] = "citation";
    BlueprintIcons_16["Clean"] = "clean";
    BlueprintIcons_16["Clip"] = "clip";
    BlueprintIcons_16["ClipboardFile"] = "clipboard-file";
    BlueprintIcons_16["Clipboard"] = "clipboard";
    BlueprintIcons_16["CloudDownload"] = "cloud-download";
    BlueprintIcons_16["CloudServer"] = "cloud-server";
    BlueprintIcons_16["CloudTick"] = "cloud-tick";
    BlueprintIcons_16["CloudUpload"] = "cloud-upload";
    BlueprintIcons_16["Cloud"] = "cloud";
    BlueprintIcons_16["CodeBlock"] = "code-block";
    BlueprintIcons_16["Code"] = "code";
    BlueprintIcons_16["Cog"] = "cog";
    BlueprintIcons_16["CollapseAll"] = "collapse-all";
    BlueprintIcons_16["ColorFill"] = "color-fill";
    BlueprintIcons_16["ColumnLayout"] = "column-layout";
    BlueprintIcons_16["Comment"] = "comment";
    BlueprintIcons_16["Comparison"] = "comparison";
    BlueprintIcons_16["Compass"] = "compass";
    BlueprintIcons_16["Compressed"] = "compressed";
    BlueprintIcons_16["Confirm"] = "confirm";
    BlueprintIcons_16["Console"] = "console";
    BlueprintIcons_16["Contrast"] = "contrast";
    BlueprintIcons_16["Control"] = "control";
    BlueprintIcons_16["CreditCard"] = "credit-card";
    BlueprintIcons_16["Crop"] = "crop";
    BlueprintIcons_16["CrossCircle"] = "cross-circle";
    BlueprintIcons_16["Cross"] = "cross";
    BlueprintIcons_16["Crown"] = "crown";
    BlueprintIcons_16["CubeAdd"] = "cube-add";
    BlueprintIcons_16["CubeRemove"] = "cube-remove";
    BlueprintIcons_16["Cube"] = "cube";
    BlueprintIcons_16["CurlyBraces"] = "curly-braces";
    BlueprintIcons_16["CurvedRangeChart"] = "curved-range-chart";
    BlueprintIcons_16["Cut"] = "cut";
    BlueprintIcons_16["Cycle"] = "cycle";
    BlueprintIcons_16["Dashboard"] = "dashboard";
    BlueprintIcons_16["DataConnection"] = "data-connection";
    BlueprintIcons_16["DataLineage"] = "data-lineage";
    BlueprintIcons_16["Database"] = "database";
    BlueprintIcons_16["Delete"] = "delete";
    BlueprintIcons_16["Delta"] = "delta";
    BlueprintIcons_16["DeriveColumn"] = "derive-column";
    BlueprintIcons_16["Desktop"] = "desktop";
    BlueprintIcons_16["Detection"] = "detection";
    BlueprintIcons_16["Diagnosis"] = "diagnosis";
    BlueprintIcons_16["DiagramTree"] = "diagram-tree";
    BlueprintIcons_16["DirectionLeft"] = "direction-left";
    BlueprintIcons_16["DirectionRight"] = "direction-right";
    BlueprintIcons_16["Disable"] = "disable";
    BlueprintIcons_16["Divide"] = "divide";
    BlueprintIcons_16["DocumentOpen"] = "document-open";
    BlueprintIcons_16["DocumentShare"] = "document-share";
    BlueprintIcons_16["Document"] = "document";
    BlueprintIcons_16["Dollar"] = "dollar";
    BlueprintIcons_16["Dot"] = "dot";
    BlueprintIcons_16["DoubleCaretHorizontal"] = "double-caret-horizontal";
    BlueprintIcons_16["DoubleCaretVertical"] = "double-caret-vertical";
    BlueprintIcons_16["DoubleChevronDown"] = "double-chevron-down";
    BlueprintIcons_16["DoubleChevronLeft"] = "double-chevron-left";
    BlueprintIcons_16["DoubleChevronRight"] = "double-chevron-right";
    BlueprintIcons_16["DoubleChevronUp"] = "double-chevron-up";
    BlueprintIcons_16["DoughnutChart"] = "doughnut-chart";
    BlueprintIcons_16["Download"] = "download";
    BlueprintIcons_16["DragHandleHorizontal"] = "drag-handle-horizontal";
    BlueprintIcons_16["DragHandleVertical"] = "drag-handle-vertical";
    BlueprintIcons_16["Draw"] = "draw";
    BlueprintIcons_16["DrawerLeftFilled"] = "drawer-left-filled";
    BlueprintIcons_16["DrawerLeft"] = "drawer-left";
    BlueprintIcons_16["DrawerRightFilled"] = "drawer-right-filled";
    BlueprintIcons_16["DrawerRight"] = "drawer-right";
    BlueprintIcons_16["DriveTime"] = "drive-time";
    BlueprintIcons_16["Duplicate"] = "duplicate";
    BlueprintIcons_16["Edit"] = "edit";
    BlueprintIcons_16["Eject"] = "eject";
    BlueprintIcons_16["Emoji"] = "emoji";
    BlueprintIcons_16["Endnote"] = "endnote";
    BlueprintIcons_16["Endorsed"] = "endorsed";
    BlueprintIcons_16["Envelope"] = "envelope";
    BlueprintIcons_16["Equals"] = "equals";
    BlueprintIcons_16["Eraser"] = "eraser";
    BlueprintIcons_16["Error"] = "error";
    BlueprintIcons_16["Euro"] = "euro";
    BlueprintIcons_16["Exchange"] = "exchange";
    BlueprintIcons_16["ExcludeRow"] = "exclude-row";
    BlueprintIcons_16["ExpandAll"] = "expand-all";
    BlueprintIcons_16["Explain"] = "explain";
    BlueprintIcons_16["Export"] = "export";
    BlueprintIcons_16["EyeOff"] = "eye-off";
    BlueprintIcons_16["EyeOn"] = "eye-on";
    BlueprintIcons_16["EyeOpen"] = "eye-open";
    BlueprintIcons_16["FastBackward"] = "fast-backward";
    BlueprintIcons_16["FastForward"] = "fast-forward";
    BlueprintIcons_16["FeedSubscribed"] = "feed-subscribed";
    BlueprintIcons_16["Feed"] = "feed";
    BlueprintIcons_16["Film"] = "film";
    BlueprintIcons_16["FilterKeep"] = "filter-keep";
    BlueprintIcons_16["FilterList"] = "filter-list";
    BlueprintIcons_16["FilterOpen"] = "filter-open";
    BlueprintIcons_16["FilterRemove"] = "filter-remove";
    BlueprintIcons_16["Filter"] = "filter";
    BlueprintIcons_16["Flag"] = "flag";
    BlueprintIcons_16["Flame"] = "flame";
    BlueprintIcons_16["Flash"] = "flash";
    BlueprintIcons_16["FloatingPoint"] = "floating-point";
    BlueprintIcons_16["FloppyDisk"] = "floppy-disk";
    BlueprintIcons_16["FlowBranch"] = "flow-branch";
    BlueprintIcons_16["FlowEnd"] = "flow-end";
    BlueprintIcons_16["FlowLinear"] = "flow-linear";
    BlueprintIcons_16["FlowReviewBranch"] = "flow-review-branch";
    BlueprintIcons_16["FlowReview"] = "flow-review";
    BlueprintIcons_16["Flows"] = "flows";
    BlueprintIcons_16["FolderClose"] = "folder-close";
    BlueprintIcons_16["FolderNew"] = "folder-new";
    BlueprintIcons_16["FolderOpen"] = "folder-open";
    BlueprintIcons_16["FolderSharedOpen"] = "folder-shared-open";
    BlueprintIcons_16["FolderShared"] = "folder-shared";
    BlueprintIcons_16["Follower"] = "follower";
    BlueprintIcons_16["Following"] = "following";
    BlueprintIcons_16["Font"] = "font";
    BlueprintIcons_16["Fork"] = "fork";
    BlueprintIcons_16["Form"] = "form";
    BlueprintIcons_16["ForwardTen"] = "forward-ten";
    BlueprintIcons_16["Fuel"] = "fuel";
    BlueprintIcons_16["FullCircle"] = "full-circle";
    BlueprintIcons_16["FullStackedChart"] = "full-stacked-chart";
    BlueprintIcons_16["Fullscreen"] = "fullscreen";
    BlueprintIcons_16["Function"] = "function";
    BlueprintIcons_16["GanttChart"] = "gantt-chart";
    BlueprintIcons_16["Generate"] = "generate";
    BlueprintIcons_16["Geofence"] = "geofence";
    BlueprintIcons_16["Geolocation"] = "geolocation";
    BlueprintIcons_16["Geosearch"] = "geosearch";
    BlueprintIcons_16["Geotime"] = "geotime";
    BlueprintIcons_16["GitBranch"] = "git-branch";
    BlueprintIcons_16["GitCommit"] = "git-commit";
    BlueprintIcons_16["GitMerge"] = "git-merge";
    BlueprintIcons_16["GitNewBranch"] = "git-new-branch";
    BlueprintIcons_16["GitPull"] = "git-pull";
    BlueprintIcons_16["GitPush"] = "git-push";
    BlueprintIcons_16["GitRepo"] = "git-repo";
    BlueprintIcons_16["Glass"] = "glass";
    BlueprintIcons_16["GlobeNetwork"] = "globe-network";
    BlueprintIcons_16["Globe"] = "globe";
    BlueprintIcons_16["GraphRemove"] = "graph-remove";
    BlueprintIcons_16["Graph"] = "graph";
    BlueprintIcons_16["GreaterThanOrEqualTo"] = "greater-than-or-equal-to";
    BlueprintIcons_16["GreaterThan"] = "greater-than";
    BlueprintIcons_16["GridView"] = "grid-view";
    BlueprintIcons_16["Grid"] = "grid";
    BlueprintIcons_16["GroupItem"] = "group-item";
    BlueprintIcons_16["GroupObjects"] = "group-objects";
    BlueprintIcons_16["GroupedBarChart"] = "grouped-bar-chart";
    BlueprintIcons_16["HandDown"] = "hand-down";
    BlueprintIcons_16["HandLeft"] = "hand-left";
    BlueprintIcons_16["HandRight"] = "hand-right";
    BlueprintIcons_16["HandUp"] = "hand-up";
    BlueprintIcons_16["Hand"] = "hand";
    BlueprintIcons_16["Hat"] = "hat";
    BlueprintIcons_16["HeaderOne"] = "header-one";
    BlueprintIcons_16["HeaderThree"] = "header-three";
    BlueprintIcons_16["HeaderTwo"] = "header-two";
    BlueprintIcons_16["Header"] = "header";
    BlueprintIcons_16["Headset"] = "headset";
    BlueprintIcons_16["HeartBroken"] = "heart-broken";
    BlueprintIcons_16["Heart"] = "heart";
    BlueprintIcons_16["HeatGrid"] = "heat-grid";
    BlueprintIcons_16["Heatmap"] = "heatmap";
    BlueprintIcons_16["Helicopter"] = "helicopter";
    BlueprintIcons_16["Help"] = "help";
    BlueprintIcons_16["HelperManagement"] = "helper-management";
    BlueprintIcons_16["HighPriority"] = "high-priority";
    BlueprintIcons_16["HighVoltagePole"] = "high-voltage-pole";
    BlueprintIcons_16["Highlight"] = "highlight";
    BlueprintIcons_16["History"] = "history";
    BlueprintIcons_16["Home"] = "home";
    BlueprintIcons_16["HorizontalBarChartAsc"] = "horizontal-bar-chart-asc";
    BlueprintIcons_16["HorizontalBarChartDesc"] = "horizontal-bar-chart-desc";
    BlueprintIcons_16["HorizontalBarChart"] = "horizontal-bar-chart";
    BlueprintIcons_16["HorizontalDistribution"] = "horizontal-distribution";
    BlueprintIcons_16["HorizontalInbetween"] = "horizontal-inbetween";
    BlueprintIcons_16["Hurricane"] = "hurricane";
    BlueprintIcons_16["IdNumber"] = "id-number";
    BlueprintIcons_16["ImageRotateLeft"] = "image-rotate-left";
    BlueprintIcons_16["ImageRotateRight"] = "image-rotate-right";
    BlueprintIcons_16["Import"] = "import";
    BlueprintIcons_16["InboxFiltered"] = "inbox-filtered";
    BlueprintIcons_16["InboxGeo"] = "inbox-geo";
    BlueprintIcons_16["InboxSearch"] = "inbox-search";
    BlueprintIcons_16["InboxUpdate"] = "inbox-update";
    BlueprintIcons_16["Inbox"] = "inbox";
    BlueprintIcons_16["InfoSign"] = "info-sign";
    BlueprintIcons_16["Inheritance"] = "inheritance";
    BlueprintIcons_16["InheritedGroup"] = "inherited-group";
    BlueprintIcons_16["InnerJoin"] = "inner-join";
    BlueprintIcons_16["Input"] = "input";
    BlueprintIcons_16["Insert"] = "insert";
    BlueprintIcons_16["Intelligence"] = "intelligence";
    BlueprintIcons_16["Intersection"] = "intersection";
    BlueprintIcons_16["IpAddress"] = "ip-address";
    BlueprintIcons_16["IssueClosed"] = "issue-closed";
    BlueprintIcons_16["IssueNew"] = "issue-new";
    BlueprintIcons_16["Issue"] = "issue";
    BlueprintIcons_16["Italic"] = "italic";
    BlueprintIcons_16["JoinTable"] = "join-table";
    BlueprintIcons_16["KeyBackspace"] = "key-backspace";
    BlueprintIcons_16["KeyCommand"] = "key-command";
    BlueprintIcons_16["KeyControl"] = "key-control";
    BlueprintIcons_16["KeyDelete"] = "key-delete";
    BlueprintIcons_16["KeyEnter"] = "key-enter";
    BlueprintIcons_16["KeyEscape"] = "key-escape";
    BlueprintIcons_16["KeyOption"] = "key-option";
    BlueprintIcons_16["KeyShift"] = "key-shift";
    BlueprintIcons_16["KeyTab"] = "key-tab";
    BlueprintIcons_16["Key"] = "key";
    BlueprintIcons_16["KnownVehicle"] = "known-vehicle";
    BlueprintIcons_16["LabTest"] = "lab-test";
    BlueprintIcons_16["Label"] = "label";
    BlueprintIcons_16["LayerOutline"] = "layer-outline";
    BlueprintIcons_16["Layer"] = "layer";
    BlueprintIcons_16["Layers"] = "layers";
    BlueprintIcons_16["LayoutAuto"] = "layout-auto";
    BlueprintIcons_16["LayoutBalloon"] = "layout-balloon";
    BlueprintIcons_16["LayoutCircle"] = "layout-circle";
    BlueprintIcons_16["LayoutGrid"] = "layout-grid";
    BlueprintIcons_16["LayoutGroupBy"] = "layout-group-by";
    BlueprintIcons_16["LayoutHierarchy"] = "layout-hierarchy";
    BlueprintIcons_16["LayoutLinear"] = "layout-linear";
    BlueprintIcons_16["LayoutSkewGrid"] = "layout-skew-grid";
    BlueprintIcons_16["LayoutSortedClusters"] = "layout-sorted-clusters";
    BlueprintIcons_16["Layout"] = "layout";
    BlueprintIcons_16["Learning"] = "learning";
    BlueprintIcons_16["LeftJoin"] = "left-join";
    BlueprintIcons_16["LengthenText"] = "lengthen-text";
    BlueprintIcons_16["LessThanOrEqualTo"] = "less-than-or-equal-to";
    BlueprintIcons_16["LessThan"] = "less-than";
    BlueprintIcons_16["Lifesaver"] = "lifesaver";
    BlueprintIcons_16["Lightbulb"] = "lightbulb";
    BlueprintIcons_16["Lightning"] = "lightning";
    BlueprintIcons_16["Link"] = "link";
    BlueprintIcons_16["ListColumns"] = "list-columns";
    BlueprintIcons_16["ListDetailView"] = "list-detail-view";
    BlueprintIcons_16["List"] = "list";
    BlueprintIcons_16["Locate"] = "locate";
    BlueprintIcons_16["Lock"] = "lock";
    BlueprintIcons_16["Locomotive"] = "locomotive";
    BlueprintIcons_16["LogIn"] = "log-in";
    BlueprintIcons_16["LogOut"] = "log-out";
    BlueprintIcons_16["LowVoltagePole"] = "low-voltage-pole";
    BlueprintIcons_16["Manual"] = "manual";
    BlueprintIcons_16["ManuallyEnteredData"] = "manually-entered-data";
    BlueprintIcons_16["ManyToMany"] = "many-to-many";
    BlueprintIcons_16["ManyToOne"] = "many-to-one";
    BlueprintIcons_16["MapCreate"] = "map-create";
    BlueprintIcons_16["MapMarker"] = "map-marker";
    BlueprintIcons_16["Map"] = "map";
    BlueprintIcons_16["Maximize"] = "maximize";
    BlueprintIcons_16["Media"] = "media";
    BlueprintIcons_16["MenuClosed"] = "menu-closed";
    BlueprintIcons_16["MenuOpen"] = "menu-open";
    BlueprintIcons_16["Menu"] = "menu";
    BlueprintIcons_16["MergeColumns"] = "merge-columns";
    BlueprintIcons_16["MergeLinks"] = "merge-links";
    BlueprintIcons_16["Microphone"] = "microphone";
    BlueprintIcons_16["Minimize"] = "minimize";
    BlueprintIcons_16["Minus"] = "minus";
    BlueprintIcons_16["MobilePhone"] = "mobile-phone";
    BlueprintIcons_16["MobileVideo"] = "mobile-video";
    BlueprintIcons_16["ModalFilled"] = "modal-filled";
    BlueprintIcons_16["Modal"] = "modal";
    BlueprintIcons_16["Model"] = "model";
    BlueprintIcons_16["Moon"] = "moon";
    BlueprintIcons_16["More"] = "more";
    BlueprintIcons_16["Mountain"] = "mountain";
    BlueprintIcons_16["Move"] = "move";
    BlueprintIcons_16["Mugshot"] = "mugshot";
    BlueprintIcons_16["MultiSelect"] = "multi-select";
    BlueprintIcons_16["Music"] = "music";
    BlueprintIcons_16["Nest"] = "nest";
    BlueprintIcons_16["NewDrawing"] = "new-drawing";
    BlueprintIcons_16["NewGridItem"] = "new-grid-item";
    BlueprintIcons_16["NewLayer"] = "new-layer";
    BlueprintIcons_16["NewLayers"] = "new-layers";
    BlueprintIcons_16["NewLink"] = "new-link";
    BlueprintIcons_16["NewObject"] = "new-object";
    BlueprintIcons_16["NewPerson"] = "new-person";
    BlueprintIcons_16["NewPrescription"] = "new-prescription";
    BlueprintIcons_16["NewShield"] = "new-shield";
    BlueprintIcons_16["NewTextBox"] = "new-text-box";
    BlueprintIcons_16["Ninja"] = "ninja";
    BlueprintIcons_16["NotEqualTo"] = "not-equal-to";
    BlueprintIcons_16["NotificationsSnooze"] = "notifications-snooze";
    BlueprintIcons_16["NotificationsUpdated"] = "notifications-updated";
    BlueprintIcons_16["Notifications"] = "notifications";
    BlueprintIcons_16["NumberedList"] = "numbered-list";
    BlueprintIcons_16["Numerical"] = "numerical";
    BlueprintIcons_16["Office"] = "office";
    BlueprintIcons_16["Offline"] = "offline";
    BlueprintIcons_16["OilField"] = "oil-field";
    BlueprintIcons_16["OneColumn"] = "one-column";
    BlueprintIcons_16["OneToMany"] = "one-to-many";
    BlueprintIcons_16["OneToOne"] = "one-to-one";
    BlueprintIcons_16["OpenApplication"] = "open-application";
    BlueprintIcons_16["Outdated"] = "outdated";
    BlueprintIcons_16["PageLayout"] = "page-layout";
    BlueprintIcons_16["PanelStats"] = "panel-stats";
    BlueprintIcons_16["PanelTable"] = "panel-table";
    BlueprintIcons_16["Paperclip"] = "paperclip";
    BlueprintIcons_16["Paragraph"] = "paragraph";
    BlueprintIcons_16["PasteVariable"] = "paste-variable";
    BlueprintIcons_16["PathSearch"] = "path-search";
    BlueprintIcons_16["Path"] = "path";
    BlueprintIcons_16["Pause"] = "pause";
    BlueprintIcons_16["People"] = "people";
    BlueprintIcons_16["Percentage"] = "percentage";
    BlueprintIcons_16["Person"] = "person";
    BlueprintIcons_16["PhoneCall"] = "phone-call";
    BlueprintIcons_16["PhoneForward"] = "phone-forward";
    BlueprintIcons_16["Phone"] = "phone";
    BlueprintIcons_16["PieChart"] = "pie-chart";
    BlueprintIcons_16["Pin"] = "pin";
    BlueprintIcons_16["PivotTable"] = "pivot-table";
    BlueprintIcons_16["Pivot"] = "pivot";
    BlueprintIcons_16["Play"] = "play";
    BlueprintIcons_16["Playbook"] = "playbook";
    BlueprintIcons_16["Plus"] = "plus";
    BlueprintIcons_16["PolygonFilter"] = "polygon-filter";
    BlueprintIcons_16["Power"] = "power";
    BlueprintIcons_16["PredictiveAnalysis"] = "predictive-analysis";
    BlueprintIcons_16["Prescription"] = "prescription";
    BlueprintIcons_16["Presentation"] = "presentation";
    BlueprintIcons_16["Print"] = "print";
    BlueprintIcons_16["Projects"] = "projects";
    BlueprintIcons_16["Properties"] = "properties";
    BlueprintIcons_16["Property"] = "property";
    BlueprintIcons_16["PublishFunction"] = "publish-function";
    BlueprintIcons_16["Pulse"] = "pulse";
    BlueprintIcons_16["Rain"] = "rain";
    BlueprintIcons_16["Random"] = "random";
    BlueprintIcons_16["Record"] = "record";
    BlueprintIcons_16["RectHeight"] = "rect-height";
    BlueprintIcons_16["RectWidth"] = "rect-width";
    BlueprintIcons_16["Rectangle"] = "rectangle";
    BlueprintIcons_16["Redo"] = "redo";
    BlueprintIcons_16["Refresh"] = "refresh";
    BlueprintIcons_16["Regex"] = "regex";
    BlueprintIcons_16["RegressionChart"] = "regression-chart";
    BlueprintIcons_16["RemoveColumnLeft"] = "remove-column-left";
    BlueprintIcons_16["RemoveColumnRight"] = "remove-column-right";
    BlueprintIcons_16["RemoveColumn"] = "remove-column";
    BlueprintIcons_16["RemoveRowBottom"] = "remove-row-bottom";
    BlueprintIcons_16["RemoveRowTop"] = "remove-row-top";
    BlueprintIcons_16["Remove"] = "remove";
    BlueprintIcons_16["Repeat"] = "repeat";
    BlueprintIcons_16["Reset"] = "reset";
    BlueprintIcons_16["Resolve"] = "resolve";
    BlueprintIcons_16["Rig"] = "rig";
    BlueprintIcons_16["RightJoin"] = "right-join";
    BlueprintIcons_16["Ring"] = "ring";
    BlueprintIcons_16["RocketSlant"] = "rocket-slant";
    BlueprintIcons_16["Rocket"] = "rocket";
    BlueprintIcons_16["RotateDocument"] = "rotate-document";
    BlueprintIcons_16["RotatePage"] = "rotate-page";
    BlueprintIcons_16["Route"] = "route";
    BlueprintIcons_16["Satellite"] = "satellite";
    BlueprintIcons_16["Saved"] = "saved";
    BlueprintIcons_16["ScatterPlot"] = "scatter-plot";
    BlueprintIcons_16["SearchAround"] = "search-around";
    BlueprintIcons_16["SearchTemplate"] = "search-template";
    BlueprintIcons_16["SearchText"] = "search-text";
    BlueprintIcons_16["Search"] = "search";
    BlueprintIcons_16["SegmentedControl"] = "segmented-control";
    BlueprintIcons_16["Select"] = "select";
    BlueprintIcons_16["Selection"] = "selection";
    BlueprintIcons_16["SendBackward"] = "send-backward";
    BlueprintIcons_16["SendMessage"] = "send-message";
    BlueprintIcons_16["SendToGraph"] = "send-to-graph";
    BlueprintIcons_16["SendToMap"] = "send-to-map";
    BlueprintIcons_16["SendTo"] = "send-to";
    BlueprintIcons_16["Sensor"] = "sensor";
    BlueprintIcons_16["SeriesAdd"] = "series-add";
    BlueprintIcons_16["SeriesConfiguration"] = "series-configuration";
    BlueprintIcons_16["SeriesDerived"] = "series-derived";
    BlueprintIcons_16["SeriesFiltered"] = "series-filtered";
    BlueprintIcons_16["SeriesSearch"] = "series-search";
    BlueprintIcons_16["Settings"] = "settings";
    BlueprintIcons_16["Shapes"] = "shapes";
    BlueprintIcons_16["Share"] = "share";
    BlueprintIcons_16["SharedFilter"] = "shared-filter";
    BlueprintIcons_16["Shield"] = "shield";
    BlueprintIcons_16["Ship"] = "ship";
    BlueprintIcons_16["Shop"] = "shop";
    BlueprintIcons_16["ShoppingCart"] = "shopping-cart";
    BlueprintIcons_16["ShortenText"] = "shorten-text";
    BlueprintIcons_16["SignalSearch"] = "signal-search";
    BlueprintIcons_16["SimCard"] = "sim-card";
    BlueprintIcons_16["Slash"] = "slash";
    BlueprintIcons_16["SmallCross"] = "small-cross";
    BlueprintIcons_16["SmallInfoSign"] = "small-info-sign";
    BlueprintIcons_16["SmallMinus"] = "small-minus";
    BlueprintIcons_16["SmallPlus"] = "small-plus";
    BlueprintIcons_16["SmallSquare"] = "small-square";
    BlueprintIcons_16["SmallTick"] = "small-tick";
    BlueprintIcons_16["Snowflake"] = "snowflake";
    BlueprintIcons_16["SoccerBall"] = "soccer-ball";
    BlueprintIcons_16["SocialMedia"] = "social-media";
    BlueprintIcons_16["SortAlphabeticalDesc"] = "sort-alphabetical-desc";
    BlueprintIcons_16["SortAlphabetical"] = "sort-alphabetical";
    BlueprintIcons_16["SortAsc"] = "sort-asc";
    BlueprintIcons_16["SortDesc"] = "sort-desc";
    BlueprintIcons_16["SortNumericalDesc"] = "sort-numerical-desc";
    BlueprintIcons_16["SortNumerical"] = "sort-numerical";
    BlueprintIcons_16["Sort"] = "sort";
    BlueprintIcons_16["SpellCheck"] = "spell-check";
    BlueprintIcons_16["SplitColumns"] = "split-columns";
    BlueprintIcons_16["SportsStadium"] = "sports-stadium";
    BlueprintIcons_16["Square"] = "square";
    BlueprintIcons_16["StackedChart"] = "stacked-chart";
    BlueprintIcons_16["StadiumGeometry"] = "stadium-geometry";
    BlueprintIcons_16["StarEmpty"] = "star-empty";
    BlueprintIcons_16["Star"] = "star";
    BlueprintIcons_16["StepBackward"] = "step-backward";
    BlueprintIcons_16["StepChart"] = "step-chart";
    BlueprintIcons_16["StepForward"] = "step-forward";
    BlueprintIcons_16["Stop"] = "stop";
    BlueprintIcons_16["Stopwatch"] = "stopwatch";
    BlueprintIcons_16["Strikethrough"] = "strikethrough";
    BlueprintIcons_16["Style"] = "style";
    BlueprintIcons_16["Subscript"] = "subscript";
    BlueprintIcons_16["Superscript"] = "superscript";
    BlueprintIcons_16["SwapHorizontal"] = "swap-horizontal";
    BlueprintIcons_16["SwapVertical"] = "swap-vertical";
    BlueprintIcons_16["Switch"] = "switch";
    BlueprintIcons_16["SymbolCircle"] = "symbol-circle";
    BlueprintIcons_16["SymbolCross"] = "symbol-cross";
    BlueprintIcons_16["SymbolDiamond"] = "symbol-diamond";
    BlueprintIcons_16["SymbolRectangle"] = "symbol-rectangle";
    BlueprintIcons_16["SymbolSquare"] = "symbol-square";
    BlueprintIcons_16["SymbolTriangleDown"] = "symbol-triangle-down";
    BlueprintIcons_16["SymbolTriangleUp"] = "symbol-triangle-up";
    BlueprintIcons_16["Syringe"] = "syringe";
    BlueprintIcons_16["Tag"] = "tag";
    BlueprintIcons_16["TakeAction"] = "take-action";
    BlueprintIcons_16["Tank"] = "tank";
    BlueprintIcons_16["Target"] = "target";
    BlueprintIcons_16["Taxi"] = "taxi";
    BlueprintIcons_16["Team"] = "team";
    BlueprintIcons_16["Temperature"] = "temperature";
    BlueprintIcons_16["TextHighlight"] = "text-highlight";
    BlueprintIcons_16["ThDerived"] = "th-derived";
    BlueprintIcons_16["ThDisconnect"] = "th-disconnect";
    BlueprintIcons_16["ThFiltered"] = "th-filtered";
    BlueprintIcons_16["ThList"] = "th-list";
    BlueprintIcons_16["Th"] = "th";
    BlueprintIcons_16["ThirdParty"] = "third-party";
    BlueprintIcons_16["ThumbsDown"] = "thumbs-down";
    BlueprintIcons_16["ThumbsUp"] = "thumbs-up";
    BlueprintIcons_16["TickCircle"] = "tick-circle";
    BlueprintIcons_16["Tick"] = "tick";
    BlueprintIcons_16["Time"] = "time";
    BlueprintIcons_16["TimelineAreaChart"] = "timeline-area-chart";
    BlueprintIcons_16["TimelineBarChart"] = "timeline-bar-chart";
    BlueprintIcons_16["TimelineEvents"] = "timeline-events";
    BlueprintIcons_16["TimelineLineChart"] = "timeline-line-chart";
    BlueprintIcons_16["Tint"] = "tint";
    BlueprintIcons_16["Torch"] = "torch";
    BlueprintIcons_16["Tractor"] = "tractor";
    BlueprintIcons_16["Train"] = "train";
    BlueprintIcons_16["Translate"] = "translate";
    BlueprintIcons_16["Trash"] = "trash";
    BlueprintIcons_16["Tree"] = "tree";
    BlueprintIcons_16["TrendingDown"] = "trending-down";
    BlueprintIcons_16["TrendingUp"] = "trending-up";
    BlueprintIcons_16["Trophy"] = "trophy";
    BlueprintIcons_16["Truck"] = "truck";
    BlueprintIcons_16["TwoColumns"] = "two-columns";
    BlueprintIcons_16["Unarchive"] = "unarchive";
    BlueprintIcons_16["Underline"] = "underline";
    BlueprintIcons_16["Undo"] = "undo";
    BlueprintIcons_16["UngroupObjects"] = "ungroup-objects";
    BlueprintIcons_16["UnknownVehicle"] = "unknown-vehicle";
    BlueprintIcons_16["Unlink"] = "unlink";
    BlueprintIcons_16["Unlock"] = "unlock";
    BlueprintIcons_16["Unpin"] = "unpin";
    BlueprintIcons_16["Unresolve"] = "unresolve";
    BlueprintIcons_16["Updated"] = "updated";
    BlueprintIcons_16["Upload"] = "upload";
    BlueprintIcons_16["User"] = "user";
    BlueprintIcons_16["Variable"] = "variable";
    BlueprintIcons_16["VerticalBarChartAsc"] = "vertical-bar-chart-asc";
    BlueprintIcons_16["VerticalBarChartDesc"] = "vertical-bar-chart-desc";
    BlueprintIcons_16["VerticalDistribution"] = "vertical-distribution";
    BlueprintIcons_16["VerticalInbetween"] = "vertical-inbetween";
    BlueprintIcons_16["Video"] = "video";
    BlueprintIcons_16["Virus"] = "virus";
    BlueprintIcons_16["VolumeDown"] = "volume-down";
    BlueprintIcons_16["VolumeOff"] = "volume-off";
    BlueprintIcons_16["VolumeUp"] = "volume-up";
    BlueprintIcons_16["Walk"] = "walk";
    BlueprintIcons_16["WarningSign"] = "warning-sign";
    BlueprintIcons_16["WaterfallChart"] = "waterfall-chart";
    BlueprintIcons_16["Waves"] = "waves";
    BlueprintIcons_16["WidgetButton"] = "widget-button";
    BlueprintIcons_16["WidgetFooter"] = "widget-footer";
    BlueprintIcons_16["WidgetHeader"] = "widget-header";
    BlueprintIcons_16["Widget"] = "widget";
    BlueprintIcons_16["Wind"] = "wind";
    BlueprintIcons_16["Wrench"] = "wrench";
    BlueprintIcons_16["ZoomIn"] = "zoom-in";
    BlueprintIcons_16["ZoomOut"] = "zoom-out";
    BlueprintIcons_16["ZoomToFit"] = "zoom-to-fit";
})($a52060bda87dc153$export$f9661b8856577c15 || ($a52060bda87dc153$export$f9661b8856577c15 = {}));
var $a52060bda87dc153$export$579a898a65651aa0 = ($a52060bda87dc153$var$_a = {}, $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.AddClip] = "61697", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.AddColumnLeft] = "61698", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.AddColumnRight] = "61699", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.AddLocation] = "61700", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.AddRowBottom] = "61701", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.AddRowTop] = "61702", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.AddToArtifact] = "61703", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.AddToFolder] = "61704", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Add] = "61705", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.AimpointsTarget] = "62261", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Airplane] = "61706", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.AlignCenter] = "61707", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.AlignJustify] = "61708", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.AlignLeft] = "61709", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.AlignRight] = "61710", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.AlignmentBottom] = "61711", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.AlignmentHorizontalCenter] = "61712", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.AlignmentLeft] = "61713", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.AlignmentRight] = "61714", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.AlignmentTop] = "61715", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.AlignmentVerticalCenter] = "61716", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Ammunition] = "62274", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Anchor] = "62256", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Annotation] = "61717", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Antenna] = "61718", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.AppHeader] = "61719", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Application] = "61720", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Applications] = "61721", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Archive] = "61722", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.AreaOfInterest] = "61723", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ArrayBoolean] = "61724", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ArrayDate] = "61725", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ArrayFloatingPoint] = "62253", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ArrayNumeric] = "61726", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ArrayString] = "61727", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ArrayTimestamp] = "61728", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Array] = "61729", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ArrowBottomLeft] = "61730", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ArrowBottomRight] = "61731", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ArrowDown] = "61732", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ArrowLeft] = "61733", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ArrowRight] = "61734", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ArrowTopLeft] = "61735", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ArrowTopRight] = "61736", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ArrowUp] = "61737", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ArrowsHorizontal] = "61738", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ArrowsVertical] = "61739", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Asterisk] = "61740", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.At] = "62257", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.AutomaticUpdates] = "61741", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Axle] = "62264", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Backlink] = "61742", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.BackwardTen] = "62300", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Badge] = "61743", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.BanCircle] = "61744", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.BankAccount] = "61745", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Barcode] = "61746", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.BinaryNumber] = "62295", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Blank] = "61747", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.BlockedPerson] = "61748", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Bold] = "61749", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Book] = "61750", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Bookmark] = "61751", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Box] = "61752", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Briefcase] = "61753", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.BringData] = "61754", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.BringForward] = "62292", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Bug] = "62254", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Buggy] = "61755", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Build] = "61756", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Bullseye] = "62297", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Calculator] = "61757", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Calendar] = "61758", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Camera] = "61759", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.CaretDown] = "61760", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.CaretLeft] = "61761", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.CaretRight] = "61762", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.CaretUp] = "61763", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.CargoShip] = "61764", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.CellTower] = "61765", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Changes] = "61766", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Chart] = "61767", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Chat] = "61768", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ChevronBackward] = "61769", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ChevronDown] = "61770", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ChevronForward] = "61771", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ChevronLeft] = "61772", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ChevronRight] = "61773", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ChevronUp] = "61774", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.CircleArrowDown] = "61775", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.CircleArrowLeft] = "61776", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.CircleArrowRight] = "61777", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.CircleArrowUp] = "61778", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Circle] = "61779", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Citation] = "61780", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Clean] = "61781", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Clip] = "61782", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ClipboardFile] = "62299", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Clipboard] = "61783", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.CloudDownload] = "61784", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.CloudServer] = "62298", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.CloudTick] = "62286", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.CloudUpload] = "61785", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Cloud] = "61786", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.CodeBlock] = "61787", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Code] = "61788", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Cog] = "61789", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.CollapseAll] = "61790", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ColorFill] = "62248", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ColumnLayout] = "61791", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Comment] = "61792", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Comparison] = "61793", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Compass] = "61794", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Compressed] = "61795", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Confirm] = "61796", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Console] = "61797", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Contrast] = "61798", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Control] = "61799", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.CreditCard] = "61800", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Crop] = "62291", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.CrossCircle] = "62262", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Cross] = "61801", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Crown] = "61802", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.CubeAdd] = "61803", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.CubeRemove] = "61804", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Cube] = "61805", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.CurlyBraces] = "62296", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.CurvedRangeChart] = "61806", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Cut] = "61807", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Cycle] = "61808", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Dashboard] = "61809", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.DataConnection] = "61810", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.DataLineage] = "61811", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Database] = "61812", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Delete] = "61813", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Delta] = "61814", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.DeriveColumn] = "61815", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Desktop] = "61816", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Detection] = "62273", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Diagnosis] = "61817", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.DiagramTree] = "61818", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.DirectionLeft] = "61819", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.DirectionRight] = "61820", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Disable] = "61821", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Divide] = "62247", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.DocumentOpen] = "61822", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.DocumentShare] = "61823", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Document] = "61824", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Dollar] = "61825", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Dot] = "61826", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.DoubleCaretHorizontal] = "61827", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.DoubleCaretVertical] = "61828", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.DoubleChevronDown] = "61829", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.DoubleChevronLeft] = "61830", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.DoubleChevronRight] = "61831", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.DoubleChevronUp] = "61832", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.DoughnutChart] = "61833", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Download] = "61834", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.DragHandleHorizontal] = "61835", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.DragHandleVertical] = "61836", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Draw] = "61837", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.DrawerLeftFilled] = "61838", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.DrawerLeft] = "61839", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.DrawerRightFilled] = "61840", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.DrawerRight] = "61841", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.DriveTime] = "61842", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Duplicate] = "61843", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Edit] = "61844", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Eject] = "61845", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Emoji] = "61846", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Endnote] = "62294", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Endorsed] = "61847", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Envelope] = "61848", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Equals] = "61849", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Eraser] = "61850", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Error] = "61851", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Euro] = "61852", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Exchange] = "61853", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ExcludeRow] = "61854", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ExpandAll] = "61855", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Explain] = "62285", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Export] = "61856", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.EyeOff] = "61857", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.EyeOn] = "61858", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.EyeOpen] = "61859", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.FastBackward] = "61860", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.FastForward] = "61861", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.FeedSubscribed] = "61862", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Feed] = "61863", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Film] = "61864", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.FilterKeep] = "61865", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.FilterList] = "61866", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.FilterOpen] = "61867", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.FilterRemove] = "61868", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Filter] = "61869", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Flag] = "61870", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Flame] = "61871", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Flash] = "61872", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.FloatingPoint] = "62252", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.FloppyDisk] = "61873", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.FlowBranch] = "61874", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.FlowEnd] = "61875", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.FlowLinear] = "61876", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.FlowReviewBranch] = "61877", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.FlowReview] = "61878", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Flows] = "61879", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.FolderClose] = "61880", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.FolderNew] = "61881", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.FolderOpen] = "61882", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.FolderSharedOpen] = "61883", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.FolderShared] = "61884", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Follower] = "61885", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Following] = "61886", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Font] = "61887", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Fork] = "61888", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Form] = "61889", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ForwardTen] = "62301", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Fuel] = "62243", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.FullCircle] = "61890", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.FullStackedChart] = "61891", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Fullscreen] = "61892", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Function] = "61893", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.GanttChart] = "61894", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Generate] = "62284", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Geofence] = "61895", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Geolocation] = "61896", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Geosearch] = "61897", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Geotime] = "62276", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.GitBranch] = "61898", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.GitCommit] = "61899", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.GitMerge] = "61900", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.GitNewBranch] = "61901", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.GitPull] = "61902", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.GitPush] = "61903", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.GitRepo] = "61904", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Glass] = "61905", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.GlobeNetwork] = "61906", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Globe] = "61907", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.GraphRemove] = "61908", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Graph] = "61909", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.GreaterThanOrEqualTo] = "61910", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.GreaterThan] = "61911", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.GridView] = "61912", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Grid] = "61913", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.GroupItem] = "62282", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.GroupObjects] = "61914", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.GroupedBarChart] = "61915", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.HandDown] = "61916", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.HandLeft] = "61917", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.HandRight] = "61918", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.HandUp] = "61919", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Hand] = "61920", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Hat] = "61921", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.HeaderOne] = "61922", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.HeaderThree] = "61923", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.HeaderTwo] = "61924", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Header] = "61925", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Headset] = "61926", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.HeartBroken] = "61927", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Heart] = "61928", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.HeatGrid] = "61929", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Heatmap] = "61930", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Helicopter] = "61931", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Help] = "61932", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.HelperManagement] = "61933", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.HighPriority] = "61934", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.HighVoltagePole] = "62259", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Highlight] = "61935", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.History] = "61936", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Home] = "61937", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.HorizontalBarChartAsc] = "61938", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.HorizontalBarChartDesc] = "61939", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.HorizontalBarChart] = "61940", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.HorizontalDistribution] = "61941", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.HorizontalInbetween] = "62249", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Hurricane] = "61942", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.IdNumber] = "61943", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ImageRotateLeft] = "61944", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ImageRotateRight] = "61945", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Import] = "61946", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.InboxFiltered] = "61947", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.InboxGeo] = "61948", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.InboxSearch] = "61949", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.InboxUpdate] = "61950", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Inbox] = "61951", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.InfoSign] = "61952", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Inheritance] = "61953", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.InheritedGroup] = "61954", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.InnerJoin] = "61955", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Input] = "62283", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Insert] = "61956", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Intelligence] = "62263", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Intersection] = "61957", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.IpAddress] = "61958", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.IssueClosed] = "61959", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.IssueNew] = "61960", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Issue] = "61961", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Italic] = "61962", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.JoinTable] = "61963", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.KeyBackspace] = "61964", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.KeyCommand] = "61965", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.KeyControl] = "61966", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.KeyDelete] = "61967", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.KeyEnter] = "61968", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.KeyEscape] = "61969", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.KeyOption] = "61970", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.KeyShift] = "61971", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.KeyTab] = "61972", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Key] = "61973", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.KnownVehicle] = "61974", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.LabTest] = "61975", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Label] = "61976", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.LayerOutline] = "61977", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Layer] = "61978", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Layers] = "61979", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.LayoutAuto] = "61980", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.LayoutBalloon] = "61981", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.LayoutCircle] = "61982", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.LayoutGrid] = "61983", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.LayoutGroupBy] = "61984", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.LayoutHierarchy] = "61985", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.LayoutLinear] = "61986", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.LayoutSkewGrid] = "61987", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.LayoutSortedClusters] = "61988", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Layout] = "61989", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Learning] = "61990", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.LeftJoin] = "61991", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.LengthenText] = "62270", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.LessThanOrEqualTo] = "61992", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.LessThan] = "61993", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Lifesaver] = "61994", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Lightbulb] = "61995", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Lightning] = "61996", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Link] = "61997", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ListColumns] = "61998", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ListDetailView] = "61999", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.List] = "62000", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Locate] = "62001", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Lock] = "62002", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Locomotive] = "62267", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.LogIn] = "62003", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.LogOut] = "62004", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.LowVoltagePole] = "62258", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Manual] = "62005", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ManuallyEnteredData] = "62006", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ManyToMany] = "62007", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ManyToOne] = "62008", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.MapCreate] = "62009", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.MapMarker] = "62010", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Map] = "62011", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Maximize] = "62012", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Media] = "62013", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.MenuClosed] = "62014", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.MenuOpen] = "62015", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Menu] = "62016", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.MergeColumns] = "62017", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.MergeLinks] = "62018", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Microphone] = "62275", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Minimize] = "62019", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Minus] = "62020", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.MobilePhone] = "62021", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.MobileVideo] = "62022", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ModalFilled] = "62023", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Modal] = "62024", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Model] = "62269", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Moon] = "62025", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.More] = "62026", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Mountain] = "62027", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Move] = "62028", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Mugshot] = "62029", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.MultiSelect] = "62030", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Music] = "62031", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Nest] = "62032", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.NewDrawing] = "62033", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.NewGridItem] = "62034", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.NewLayer] = "62035", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.NewLayers] = "62036", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.NewLink] = "62037", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.NewObject] = "62038", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.NewPerson] = "62039", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.NewPrescription] = "62040", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.NewShield] = "62281", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.NewTextBox] = "62041", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Ninja] = "62042", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.NotEqualTo] = "62043", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.NotificationsSnooze] = "62044", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.NotificationsUpdated] = "62045", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Notifications] = "62046", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.NumberedList] = "62047", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Numerical] = "62048", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Office] = "62049", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Offline] = "62050", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.OilField] = "62051", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.OneColumn] = "62052", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.OneToMany] = "62053", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.OneToOne] = "62054", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.OpenApplication] = "62251", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Outdated] = "62055", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.PageLayout] = "62056", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.PanelStats] = "62057", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.PanelTable] = "62058", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Paperclip] = "62059", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Paragraph] = "62060", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.PasteVariable] = "62278", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.PathSearch] = "62061", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Path] = "62062", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Pause] = "62063", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.People] = "62064", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Percentage] = "62065", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Person] = "62066", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.PhoneCall] = "62279", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.PhoneForward] = "62280", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Phone] = "62067", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.PieChart] = "62068", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Pin] = "62069", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.PivotTable] = "62070", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Pivot] = "62071", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Play] = "62072", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Playbook] = "62244", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Plus] = "62073", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.PolygonFilter] = "62074", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Power] = "62075", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.PredictiveAnalysis] = "62076", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Prescription] = "62077", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Presentation] = "62078", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Print] = "62079", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Projects] = "62080", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Properties] = "62081", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Property] = "62082", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.PublishFunction] = "62083", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Pulse] = "62084", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Rain] = "62085", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Random] = "62086", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Record] = "62087", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.RectHeight] = "62245", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.RectWidth] = "62246", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Rectangle] = "62241", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Redo] = "62088", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Refresh] = "62089", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Regex] = "62255", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.RegressionChart] = "62090", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.RemoveColumnLeft] = "62091", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.RemoveColumnRight] = "62092", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.RemoveColumn] = "62093", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.RemoveRowBottom] = "62094", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.RemoveRowTop] = "62095", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Remove] = "62096", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Repeat] = "62097", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Reset] = "62098", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Resolve] = "62099", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Rig] = "62100", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.RightJoin] = "62101", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Ring] = "62102", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.RocketSlant] = "62103", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Rocket] = "62104", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.RotateDocument] = "62105", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.RotatePage] = "62106", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Route] = "62107", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Satellite] = "62108", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Saved] = "62109", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ScatterPlot] = "62110", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SearchAround] = "62111", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SearchTemplate] = "62112", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SearchText] = "62113", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Search] = "62114", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SegmentedControl] = "62115", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Select] = "62116", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Selection] = "62117", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SendBackward] = "62293", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SendMessage] = "62118", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SendToGraph] = "62119", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SendToMap] = "62120", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SendTo] = "62121", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Sensor] = "62268", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SeriesAdd] = "62122", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SeriesConfiguration] = "62123", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SeriesDerived] = "62124", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SeriesFiltered] = "62125", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SeriesSearch] = "62126", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Settings] = "62127", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Shapes] = "62128", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Share] = "62129", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SharedFilter] = "62130", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Shield] = "62131", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Ship] = "62132", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Shop] = "62133", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ShoppingCart] = "62134", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ShortenText] = "62271", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SignalSearch] = "62135", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SimCard] = "62136", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Slash] = "62137", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SmallCross] = "62138", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SmallInfoSign] = "62260", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SmallMinus] = "62139", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SmallPlus] = "62140", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SmallSquare] = "62141", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SmallTick] = "62142", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Snowflake] = "62143", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SoccerBall] = "62288", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SocialMedia] = "62144", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SortAlphabeticalDesc] = "62145", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SortAlphabetical] = "62146", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SortAsc] = "62147", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SortDesc] = "62148", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SortNumericalDesc] = "62149", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SortNumerical] = "62150", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Sort] = "62151", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SpellCheck] = "62272", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SplitColumns] = "62152", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SportsStadium] = "62289", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Square] = "62153", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.StackedChart] = "62154", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.StadiumGeometry] = "62155", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.StarEmpty] = "62156", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Star] = "62157", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.StepBackward] = "62158", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.StepChart] = "62159", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.StepForward] = "62160", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Stop] = "62161", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Stopwatch] = "62162", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Strikethrough] = "62163", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Style] = "62164", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Subscript] = "62265", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Superscript] = "62266", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SwapHorizontal] = "62165", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SwapVertical] = "62166", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Switch] = "62167", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SymbolCircle] = "62168", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SymbolCross] = "62169", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SymbolDiamond] = "62170", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SymbolRectangle] = "62242", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SymbolSquare] = "62171", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SymbolTriangleDown] = "62172", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.SymbolTriangleUp] = "62173", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Syringe] = "62174", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Tag] = "62175", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.TakeAction] = "62176", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Tank] = "62177", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Target] = "62178", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Taxi] = "62179", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Team] = "62290", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Temperature] = "62180", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.TextHighlight] = "62181", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ThDerived] = "62182", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ThDisconnect] = "62183", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ThFiltered] = "62184", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ThList] = "62185", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Th] = "62186", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ThirdParty] = "62187", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ThumbsDown] = "62188", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ThumbsUp] = "62189", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.TickCircle] = "62190", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Tick] = "62191", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Time] = "62192", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.TimelineAreaChart] = "62193", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.TimelineBarChart] = "62194", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.TimelineEvents] = "62195", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.TimelineLineChart] = "62196", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Tint] = "62197", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Torch] = "62198", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Tractor] = "62199", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Train] = "62200", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Translate] = "62201", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Trash] = "62202", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Tree] = "62203", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.TrendingDown] = "62204", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.TrendingUp] = "62205", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Trophy] = "62287", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Truck] = "62206", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.TwoColumns] = "62207", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Unarchive] = "62208", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Underline] = "62209", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Undo] = "62210", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.UngroupObjects] = "62211", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.UnknownVehicle] = "62212", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Unlink] = "62277", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Unlock] = "62213", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Unpin] = "62214", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Unresolve] = "62215", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Updated] = "62216", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Upload] = "62217", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.User] = "62218", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Variable] = "62219", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.VerticalBarChartAsc] = "62220", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.VerticalBarChartDesc] = "62221", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.VerticalDistribution] = "62222", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.VerticalInbetween] = "62250", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Video] = "62223", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Virus] = "62224", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.VolumeDown] = "62225", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.VolumeOff] = "62226", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.VolumeUp] = "62227", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Walk] = "62228", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.WarningSign] = "62229", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.WaterfallChart] = "62230", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Waves] = "62231", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.WidgetButton] = "62232", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.WidgetFooter] = "62233", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.WidgetHeader] = "62234", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Widget] = "62235", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Wind] = "62236", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.Wrench] = "62237", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ZoomIn] = "62238", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ZoomOut] = "62239", $a52060bda87dc153$var$_a[$a52060bda87dc153$export$f9661b8856577c15.ZoomToFit] = "62240", $a52060bda87dc153$var$_a);

});


parcelRegister("leH9B", function(module, exports) {

$parcel$export(module.exports, "IconSize", () => $f75c613b085437d2$export$ff775019b5b6e7df);
/*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $f75c613b085437d2$export$ff775019b5b6e7df;
(function(IconSize) {
    IconSize[IconSize["STANDARD"] = 16] = "STANDARD";
    IconSize[IconSize["LARGE"] = 20] = "LARGE";
})($f75c613b085437d2$export$ff775019b5b6e7df || ($f75c613b085437d2$export$ff775019b5b6e7df = {}));

});

parcelRegister("7zSP3", function(module, exports) {

$parcel$export(module.exports, "wrapWithTimer", () => $584653dca8fce7ce$export$af723ac7cb96136b);
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");
/** Returns whether bundler-injected variable `NODE_ENV` equals `env`. */ function $584653dca8fce7ce$var$isNodeEnv(env) {
    return typeof NODE_ENV !== "undefined" && NODE_ENV === env;
}
function $584653dca8fce7ce$export$af723ac7cb96136b(taskDescription, task) {
    return (0, $gztBd.__awaiter)(this, void 0, void 0, function() {
        var shouldMeasure, start, time;
        return (0, $gztBd.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    shouldMeasure = $584653dca8fce7ce$var$isNodeEnv("development") && typeof performance !== "undefined";
                    /* eslint-disable no-console */ if (shouldMeasure) {
                        start = performance.now();
                        console.info("Started '".concat(taskDescription, "'..."));
                    }
                    return [
                        4 /*yield*/ ,
                        task()
                    ];
                case 1:
                    _a.sent();
                    if (shouldMeasure) {
                        time = Math.round(performance.now() - start);
                        console.info("Finished '".concat(taskDescription, "' in ").concat(time, "ms"));
                    }
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}

});

parcelRegister("k5h1n", function(module, exports) {


module.exports = (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("6n2Xq")).then(()=>parcelRequire("krlkt"));

});
parcelRegister("dNLwc", function(module, exports) {
"use strict";

var $7lV8K = parcelRequire("7lV8K");
module.exports = $7lV8K(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("7lV8K", function(module, exports) {
"use strict";
var $55a6d16921f8ab25$var$cachedBundles = {};
var $55a6d16921f8ab25$var$cachedPreloads = {};
var $55a6d16921f8ab25$var$cachedPrefetches = {};
function $55a6d16921f8ab25$var$getCache(type) {
    switch(type){
        case "preload":
            return $55a6d16921f8ab25$var$cachedPreloads;
        case "prefetch":
            return $55a6d16921f8ab25$var$cachedPrefetches;
        default:
            return $55a6d16921f8ab25$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $55a6d16921f8ab25$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("3emq3", function(module, exports) {


module.exports = (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("2WTgo")).then(()=>parcelRequire("igKPH"));

});


parcelRegister("eog74", function(module, exports) {

$parcel$export(module.exports, "SVGIconContainer", () => $a79fce4b92774fa7$export$5529589efc4d4370);
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $8rmiw = parcelRequire("8rmiw");

var $leH9B = parcelRequire("leH9B");

var $3r8QN = parcelRequire("3r8QN");
var $a79fce4b92774fa7$export$5529589efc4d4370 = $8NFma.forwardRef(function(props, ref) {
    var children = props.children, className = props.className, color = props.color, htmlTitle = props.htmlTitle, iconName = props.iconName, _a = props.size, size = _a === void 0 ? (0, $leH9B.IconSize).STANDARD : _a, svgProps = props.svgProps, _b = props.tagName, tagName = _b === void 0 ? "span" : _b, title = props.title, htmlProps = (0, $gztBd.__rest)(props, [
        "children",
        "className",
        "color",
        "htmlTitle",
        "iconName",
        "size",
        "svgProps",
        "tagName",
        "title"
    ]);
    var isLarge = size >= (0, $leH9B.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, $leH9B.IconSize).LARGE : (0, $leH9B.IconSize).STANDARD;
    var viewBox = "0 0 ".concat(pixelGridSize, " ").concat(pixelGridSize);
    var titleId = (0, $3r8QN.uniqueId)("iconTitle");
    var sharedSvgProps = (0, $gztBd.__assign)({
        fill: color,
        height: size,
        role: "img",
        viewBox: viewBox,
        width: size
    }, svgProps);
    if (tagName === null) return $8NFma.createElement("svg", (0, $gztBd.__assign)({
        "aria-labelledby": title ? titleId : undefined,
        "data-icon": iconName,
        ref: ref
    }, sharedSvgProps, htmlProps, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(className, svgProps === null || svgProps === void 0 ? void 0 : svgProps.className)
    }), title && $8NFma.createElement("title", {
        id: titleId
    }, title), children);
    else // N.B. styles for `Classes.ICON` are defined in @blueprintjs/core in `_icon.scss`
    return $8NFma.createElement(tagName, (0, $gztBd.__assign)((0, $gztBd.__assign)({
        "aria-hidden": title ? undefined : true
    }, htmlProps), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))($8rmiw.ICON, "".concat($8rmiw.ICON, "-").concat(iconName), className),
        ref: ref,
        title: htmlTitle
    }), $8NFma.createElement("svg", (0, $gztBd.__assign)({
        "data-icon": iconName
    }, sharedSvgProps, {
        className: svgProps === null || svgProps === void 0 ? void 0 : svgProps.className
    }), title && $8NFma.createElement("title", null, title), children));
});
$a79fce4b92774fa7$export$5529589efc4d4370.displayName = "Blueprint5.SVGIconContainer";

});
parcelRegister("8rmiw", function(module, exports) {

$parcel$export(module.exports, "ICON", () => $6252243a4e3a409a$export$d2b60e6b56e900e8);
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6252243a4e3a409a$var$NS = "bp5";
var $6252243a4e3a409a$export$d2b60e6b56e900e8 = "".concat($6252243a4e3a409a$var$NS, "-icon");

});

parcelRegister("3r8QN", function(module, exports) {

$parcel$export(module.exports, "uniqueId", () => $280ac23adbe8b7e8$export$8b15d37bc3f197d4);
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $280ac23adbe8b7e8$var$uniqueCountForNamespace = new Map();
function $280ac23adbe8b7e8$export$8b15d37bc3f197d4(namespace) {
    var _a;
    var curCount = (_a = $280ac23adbe8b7e8$var$uniqueCountForNamespace.get(namespace)) !== null && _a !== void 0 ? _a : 0;
    $280ac23adbe8b7e8$var$uniqueCountForNamespace.set(namespace, curCount + 1);
    return "".concat(namespace, "-").concat(curCount);
}

});



parcelRegister("h3xJq", function(module, exports) {

$parcel$export(module.exports, "SpinnerSize", () => $c6ace1e66dd2f72f$export$11e6017846e949);
$parcel$export(module.exports, "Spinner", () => $c6ace1e66dd2f72f$export$7f7cbe89f1eacd2);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $4Jy2D = parcelRequire("4Jy2D");
var $auzpd = parcelRequire("auzpd");

var $bzsu8 = parcelRequire("bzsu8");

var $hffzE = parcelRequire("hffzE");

var $h8UCV = parcelRequire("h8UCV");
var $c6ace1e66dd2f72f$export$11e6017846e949;
(function(SpinnerSize) {
    SpinnerSize[SpinnerSize["SMALL"] = 20] = "SMALL";
    SpinnerSize[SpinnerSize["STANDARD"] = 50] = "STANDARD";
    SpinnerSize[SpinnerSize["LARGE"] = 100] = "LARGE";
})($c6ace1e66dd2f72f$export$11e6017846e949 || ($c6ace1e66dd2f72f$export$11e6017846e949 = {}));
// see http://stackoverflow.com/a/18473154/3124288 for calculating arc path
var $c6ace1e66dd2f72f$var$R = 45;
var $c6ace1e66dd2f72f$var$SPINNER_TRACK = "M 50,50 m 0,-".concat($c6ace1e66dd2f72f$var$R, " a ").concat($c6ace1e66dd2f72f$var$R, ",").concat($c6ace1e66dd2f72f$var$R, " 0 1 1 0,").concat($c6ace1e66dd2f72f$var$R * 2, " a ").concat($c6ace1e66dd2f72f$var$R, ",").concat($c6ace1e66dd2f72f$var$R, " 0 1 1 0,-").concat($c6ace1e66dd2f72f$var$R * 2);
// unitless total length of SVG path, to which stroke-dash* properties are relative.
// https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/pathLength
// this value is the result of `<path d={SPINNER_TRACK} />.getTotalLength()` and works in all browsers:
var $c6ace1e66dd2f72f$var$PATH_LENGTH = 280;
var $c6ace1e66dd2f72f$var$MIN_SIZE = 10;
var $c6ace1e66dd2f72f$var$STROKE_WIDTH = 4;
var $c6ace1e66dd2f72f$var$MIN_STROKE_WIDTH = 16;
/**
 * Spinner component.
 *
 * @see https://blueprintjs.com/docs/#core/components/spinner
 */ var $c6ace1e66dd2f72f$export$7f7cbe89f1eacd2 = /** @class */ function(_super) {
    (0, $gztBd.__extends)(Spinner, _super);
    function Spinner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Spinner.prototype.componentDidUpdate = function(prevProps) {
        if (prevProps.value !== this.props.value) // IE/Edge: re-render after changing value to force SVG update
        this.forceUpdate();
    };
    Spinner.prototype.render = function() {
        var _a;
        var _b = this.props, className = _b.className, intent = _b.intent, value = _b.value, _c = _b.tagName, tagName = _c === void 0 ? "div" : _c, htmlProps = (0, $gztBd.__rest)(_b, [
            "className",
            "intent",
            "value",
            "tagName"
        ]);
        var size = this.getSize();
        var classes = (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $auzpd).SPINNER, (0, $auzpd).intentClass(intent), (_a = {}, _a[(0, $auzpd).SPINNER_NO_SPIN] = value != null, _a), className);
        // keep spinner track width consistent at all sizes (down to about 10px).
        var strokeWidth = Math.min($c6ace1e66dd2f72f$var$MIN_STROKE_WIDTH, $c6ace1e66dd2f72f$var$STROKE_WIDTH * $c6ace1e66dd2f72f$export$11e6017846e949.LARGE / size);
        var strokeOffset = $c6ace1e66dd2f72f$var$PATH_LENGTH - $c6ace1e66dd2f72f$var$PATH_LENGTH * (value == null ? 0.25 : (0, $h8UCV.clamp)(value, 0, 1));
        // multiple DOM elements around SVG are necessary to properly isolate animation:
        // - SVG elements in IE do not support anim/trans so they must be set on a parent HTML element.
        // - SPINNER_ANIMATION isolates svg from parent display and is always centered inside root element.
        return $8NFma.createElement(tagName, (0, $gztBd.__assign)({
            "aria-label": "loading",
            "aria-valuemax": 100,
            "aria-valuemin": 0,
            "aria-valuenow": value === undefined ? undefined : value * 100,
            className: classes,
            role: "progressbar"
        }, htmlProps), $8NFma.createElement(tagName, {
            className: (0, $auzpd).SPINNER_ANIMATION
        }, $8NFma.createElement("svg", {
            width: size,
            height: size,
            strokeWidth: strokeWidth.toFixed(2),
            viewBox: this.getViewBox(strokeWidth)
        }, $8NFma.createElement("path", {
            className: (0, $auzpd).SPINNER_TRACK,
            d: $c6ace1e66dd2f72f$var$SPINNER_TRACK
        }), $8NFma.createElement("path", {
            className: (0, $auzpd).SPINNER_HEAD,
            d: $c6ace1e66dd2f72f$var$SPINNER_TRACK,
            pathLength: $c6ace1e66dd2f72f$var$PATH_LENGTH,
            strokeDasharray: "".concat($c6ace1e66dd2f72f$var$PATH_LENGTH, " ").concat($c6ace1e66dd2f72f$var$PATH_LENGTH),
            strokeDashoffset: strokeOffset
        }))));
    };
    Spinner.prototype.validateProps = function(_a) {
        var _b = _a.className, className = _b === void 0 ? "" : _b, size = _a.size;
        if (size != null && (className.indexOf((0, $auzpd).SMALL) >= 0 || className.indexOf((0, $auzpd).LARGE) >= 0)) console.warn((0, $bzsu8.SPINNER_WARN_CLASSES_SIZE));
    };
    /**
     * Resolve size to a pixel value.
     * Size can be set by className, props, default, or minimum constant.
     */ Spinner.prototype.getSize = function() {
        var _a = this.props, _b = _a.className, className = _b === void 0 ? "" : _b, size = _a.size;
        if (size == null) {
            // allow Classes constants to determine default size.
            if (className.indexOf((0, $auzpd).SMALL) >= 0) return $c6ace1e66dd2f72f$export$11e6017846e949.SMALL;
            else if (className.indexOf((0, $auzpd).LARGE) >= 0) return $c6ace1e66dd2f72f$export$11e6017846e949.LARGE;
            return $c6ace1e66dd2f72f$export$11e6017846e949.STANDARD;
        }
        return Math.max($c6ace1e66dd2f72f$var$MIN_SIZE, size);
    };
    /** Compute viewbox such that stroked track sits exactly at edge of image frame. */ Spinner.prototype.getViewBox = function(strokeWidth) {
        var radius = $c6ace1e66dd2f72f$var$R + strokeWidth / 2;
        var viewBoxX = (50 - radius).toFixed(2);
        var viewBoxWidth = (radius * 2).toFixed(2);
        return "".concat(viewBoxX, " ").concat(viewBoxX, " ").concat(viewBoxWidth, " ").concat(viewBoxWidth);
    };
    Spinner.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".Spinner");
    return Spinner;
}((0, $4Jy2D.AbstractPureComponent));

});
parcelRegister("4Jy2D", function(module, exports) {

$parcel$export(module.exports, "AbstractPureComponent", () => $3725c5599a80f552$export$844dfdc3b38c9679);
/*
 * Copyright 2019 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $8NFma = parcelRequire("8NFma");

var $h8UCV = parcelRequire("h8UCV");
/**
 * An abstract component that Blueprint components can extend
 * in order to add some common functionality like runtime props validation.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
var $3725c5599a80f552$export$844dfdc3b38c9679 = /** @class */ function(_super) {
    (0, $gztBd.__extends)(AbstractPureComponent, _super);
    function AbstractPureComponent(props) {
        var _this = _super.call(this, props) || this;
        // Not bothering to remove entries when their timeouts finish because clearing invalid ID is a no-op
        _this.timeoutIds = [];
        _this.requestIds = [];
        /**
         * Clear all known timeouts.
         */ _this.clearTimeouts = function() {
            if (_this.timeoutIds.length > 0) {
                for(var _i = 0, _a = _this.timeoutIds; _i < _a.length; _i++){
                    var timeoutId = _a[_i];
                    window.clearTimeout(timeoutId);
                }
                _this.timeoutIds = [];
            }
        };
        /**
         * Clear all known animation frame requests.
         */ _this.cancelAnimationFrames = function() {
            if (_this.requestIds.length > 0) {
                for(var _i = 0, _a = _this.requestIds; _i < _a.length; _i++){
                    var requestId = _a[_i];
                    window.cancelAnimationFrame(requestId);
                }
                _this.requestIds = [];
            }
        };
        if (!(0, $h8UCV.isNodeEnv)("production")) _this.validateProps(_this.props);
        return _this;
    }
    AbstractPureComponent.prototype.componentDidUpdate = function(_prevProps, _prevState, _snapshot) {
        if (!(0, $h8UCV.isNodeEnv)("production")) this.validateProps(this.props);
    };
    AbstractPureComponent.prototype.componentWillUnmount = function() {
        this.clearTimeouts();
        this.cancelAnimationFrames();
    };
    /**
     * Request an animation frame and remember its ID.
     * All pending requests will be canceled when component unmounts.
     *
     * @returns a "cancel" function that will cancel the request when invoked.
     */ AbstractPureComponent.prototype.requestAnimationFrame = function(callback) {
        var handle = window.requestAnimationFrame(callback);
        this.requestIds.push(handle);
        return function() {
            return window.cancelAnimationFrame(handle);
        };
    };
    /**
     * Set a timeout and remember its ID.
     * All pending timeouts will be cleared when component unmounts.
     *
     * @returns a "cancel" function that will clear timeout when invoked.
     */ AbstractPureComponent.prototype.setTimeout = function(callback, timeout) {
        var handle = window.setTimeout(callback, timeout);
        this.timeoutIds.push(handle);
        return function() {
            return window.clearTimeout(handle);
        };
    };
    /**
     * Ensures that the props specified for a component are valid.
     * Implementations should check that props are valid and usually throw an Error if they are not.
     * Implementations should not duplicate checks that the type system already guarantees.
     *
     * This method should be used instead of React's
     * [propTypes](https://facebook.github.io/react/docs/reusable-components.html#prop-validation) feature.
     * Like propTypes, these runtime checks run only in development mode.
     */ AbstractPureComponent.prototype.validateProps = function(_props) {
    // implement in subclass
    };
    return AbstractPureComponent;
}($8NFma.PureComponent);

});


parcelRegister("M9AJy", function(module, exports) {

$parcel$export(module.exports, "Text", () => $090bec7a586113f3$export$5f1af8db9871e1d6);
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $auzpd = parcelRequire("auzpd");
var $8k66C = parcelRequire("8k66C");

var $hffzE = parcelRequire("hffzE");

var $aNPAh = parcelRequire("aNPAh");
var $090bec7a586113f3$export$5f1af8db9871e1d6 = $8NFma.forwardRef(function(_a, forwardedRef) {
    var _b;
    var children = _a.children, _c = _a.tagName, tagName = _c === void 0 ? "div" : _c, title = _a.title, className = _a.className, ellipsize = _a.ellipsize, htmlProps = (0, $gztBd.__rest)(_a, [
        "children",
        "tagName",
        "title",
        "className",
        "ellipsize"
    ]);
    var contentMeasuringRef = $8NFma.useRef();
    var textRef = $8NFma.useMemo(function() {
        return (0, $8k66C.mergeRefs)(contentMeasuringRef, forwardedRef);
    }, [
        forwardedRef
    ]);
    var _d = $8NFma.useState(""), textContent = _d[0], setTextContent = _d[1];
    var _e = $8NFma.useState(), isContentOverflowing = _e[0], setIsContentOverflowing = _e[1];
    // try to be conservative about running this effect, since querying scrollWidth causes the browser to reflow / recalculate styles,
    // which can be very expensive for long lists (for example, in long Menus)
    (0, $aNPAh.useIsomorphicLayoutEffect)(function() {
        var _a;
        if (((_a = contentMeasuringRef.current) === null || _a === void 0 ? void 0 : _a.textContent) != null) {
            setIsContentOverflowing(ellipsize && contentMeasuringRef.current.scrollWidth > contentMeasuringRef.current.clientWidth);
            setTextContent(contentMeasuringRef.current.textContent);
        }
    }, [
        contentMeasuringRef,
        children,
        ellipsize
    ]);
    return $8NFma.createElement(tagName, (0, $gztBd.__assign)((0, $gztBd.__assign)({}, htmlProps), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((_b = {}, _b[(0, $auzpd).TEXT_OVERFLOW_ELLIPSIS] = ellipsize, _b), className),
        ref: textRef,
        title: title !== null && title !== void 0 ? title : isContentOverflowing ? textContent : undefined
    }), children);
});
$090bec7a586113f3$export$5f1af8db9871e1d6.defaultProps = {
    ellipsize: false
};
$090bec7a586113f3$export$5f1af8db9871e1d6.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".Text");

});
parcelRegister("aNPAh", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $7dd67e81b7a52eab$export$700979bc83e7db82);
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $8NFma = parcelRequire("8NFma");

var $lgubC = parcelRequire("lgubC");
var $7dd67e81b7a52eab$export$700979bc83e7db82 = (0, $lgubC.hasDOMEnvironment)() ? $8NFma.useLayoutEffect : $8NFma.useEffect;

});



parcelRegister("gVVt3", function(module, exports) {

$parcel$export(module.exports, "Tooltip", () => $c53e8c1252f1e44e$export$28c660c63b792dea);
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $4Jy2D = parcelRequire("4Jy2D");
var $hffzE = parcelRequire("hffzE");

var $auzpd = parcelRequire("auzpd");

var $ixLVk = parcelRequire("ixLVk");

var $jtuvn = parcelRequire("jtuvn");

var $8CO9e = parcelRequire("8CO9e");
/**
 * Tooltip component.
 *
 * @see https://blueprintjs.com/docs/#core/components/tooltip
 */ var $c53e8c1252f1e44e$export$28c660c63b792dea = /** @class */ function(_super) {
    (0, $gztBd.__extends)(Tooltip, _super);
    function Tooltip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.popoverRef = $8NFma.createRef();
        // any descendant ContextMenus may update this ctxState
        _this.renderPopover = function(ctxState) {
            var _a;
            var _b;
            var _c = _this.props, children = _c.children, compact = _c.compact, disabled = _c.disabled, intent = _c.intent, popoverClassName = _c.popoverClassName, restProps = (0, $gztBd.__rest)(_c, [
                "children",
                "compact",
                "disabled",
                "intent",
                "popoverClassName"
            ]);
            var popoverClasses = (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))($auzpd.TOOLTIP, $auzpd.intentClass(intent), popoverClassName, (_a = {}, _a[$auzpd.COMPACT] = compact, _a));
            return $8NFma.createElement((0, $ixLVk.Popover), (0, $gztBd.__assign)({
                modifiers: {
                    arrow: {
                        enabled: !_this.props.minimal
                    },
                    offset: {
                        options: {
                            offset: [
                                0,
                                (0, $jtuvn.TOOLTIP_ARROW_SVG_SIZE) / 2
                            ]
                        }
                    }
                }
            }, restProps, {
                autoFocus: false,
                canEscapeKeyClose: false,
                disabled: (_b = ctxState.forceDisabled) !== null && _b !== void 0 ? _b : disabled,
                enforceFocus: false,
                lazy: true,
                popoverClassName: popoverClasses,
                portalContainer: _this.props.portalContainer,
                ref: _this.popoverRef
            }), children);
        };
        return _this;
    }
    Tooltip.prototype.render = function() {
        var _this = this;
        // if we have an ancestor TooltipContext, we should take its state into account in this render path,
        // it was likely created by a parent ContextMenu
        return $8NFma.createElement((0, $8CO9e.TooltipContext).Consumer, null, function(_a) {
            var state = _a[0];
            return $8NFma.createElement((0, $8CO9e.TooltipProvider), (0, $gztBd.__assign)({}, state), _this.renderPopover);
        });
    };
    Tooltip.prototype.reposition = function() {
        var _a;
        (_a = this.popoverRef.current) === null || _a === void 0 || _a.reposition();
    };
    Tooltip.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".Tooltip");
    Tooltip.defaultProps = {
        compact: false,
        hoverCloseDelay: 0,
        hoverOpenDelay: 100,
        interactionKind: "hover-target",
        minimal: false,
        transitionDuration: 100
    };
    return Tooltip;
}((0, $4Jy2D.AbstractPureComponent));

});
parcelRegister("ixLVk", function(module, exports) {

$parcel$export(module.exports, "Popover", () => $d8007bafcfc703a7$export$5b6b19405a83ff9d);
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $17ExX = parcelRequire("17ExX");
var $aDCM4 = parcelRequire("aDCM4");
var $cgdjq = parcelRequire("cgdjq");

var $4Jy2D = parcelRequire("4Jy2D");
var $auzpd = parcelRequire("auzpd");
var $hffzE = parcelRequire("hffzE");
var $8k66C = parcelRequire("8k66C");
var $iP8Ix = parcelRequire("iP8Ix");

var $bzsu8 = parcelRequire("bzsu8");

var $duUmg = parcelRequire("duUmg");

var $kOBi8 = parcelRequire("kOBi8");

var $gVVt3 = parcelRequire("gVVt3");

var $7aA5C = parcelRequire("7aA5C");

var $jtuvn = parcelRequire("jtuvn");

var $adnTU = parcelRequire("adnTU");

var $awEmD = parcelRequire("awEmD");
var $d8007bafcfc703a7$export$6c571fbf65f9c7a6 = {
    CLICK: "click",
    CLICK_TARGET_ONLY: "click-target",
    HOVER: "hover",
    HOVER_TARGET_ONLY: "hover-target"
};
/**
 * Popover component, used to display a floating UI next to and tethered to a target element.
 *
 * @template T target element props interface. Consumers wishing to stay in sync with Blueprint's default target HTML
 * props interface should use the `DefaultPopoverTargetHTMLProps` type (although this is already the default type for
 * this type param).
 * @see https://blueprintjs.com/docs/#core/components/popover
 */ var $d8007bafcfc703a7$export$5b6b19405a83ff9d = /** @class */ function(_super) {
    (0, $gztBd.__extends)(Popover, _super);
    function Popover() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hasDarkParent: false,
            isClosingViaEscapeKeypress: false,
            isOpen: _this.getIsOpen(_this.props)
        };
        /**
         * DOM element that contains the popover.
         * When `usePortal={true}`, this element will be portaled outside the usual DOM flow,
         * so this reference can be very useful for testing.
         *
         * @public for testing
         */ _this.popoverElement = null;
        /** Popover ref handler */ _this.popoverRef = (0, $8k66C.refHandler)(_this, "popoverElement", _this.props.popoverRef);
        /**
         * Target DOM element ref.
         *
         * N.B. this must be a ref object since we pass it to `<ResizeSensor>`, which needs to know about the target
         * DOM element in order to observe its dimensions.
         *
         * @public for testing
         */ _this.targetRef = $8NFma.createRef();
        /**
         * Overlay2 transition container element ref.
         */ _this.transitionContainerElement = $8NFma.createRef();
        // a flag that lets us detect mouse movement between the target and popover,
        // now that mouseleave is triggered when you cross the gap between the two.
        _this.isMouseInTargetOrPopover = false;
        // a flag that indicates whether the target previously lost focus to another
        // element on the same page.
        _this.lostFocusOnSamePage = true;
        _this.isControlled = function() {
            return _this.props.isOpen !== undefined;
        };
        // arrow is disabled if minimal, or if the arrow modifier was explicitly disabled
        _this.isArrowEnabled = function() {
            var _a, _b;
            return !_this.props.minimal && ((_b = (_a = _this.props.modifiers) === null || _a === void 0 ? void 0 : _a.arrow) === null || _b === void 0 ? void 0 : _b.enabled) !== false;
        };
        _this.isHoverInteractionKind = function() {
            return _this.props.interactionKind === $d8007bafcfc703a7$export$6c571fbf65f9c7a6.HOVER || _this.props.interactionKind === $d8007bafcfc703a7$export$6c571fbf65f9c7a6.HOVER_TARGET_ONLY;
        };
        /**
         * Instance method to instruct the `Popover` to recompute its position.
         *
         * This method should only be used if you are updating the target in a way
         * that does not cause it to re-render, such as changing its _position_
         * without changing its _size_ (since `Popover` already repositions when it
         * detects a resize).
         */ _this.reposition = function() {
            var _a;
            return (_a = _this.popperScheduleUpdate) === null || _a === void 0 ? void 0 : _a.call(_this);
        };
        _this.renderTarget = function(_a) {
            var _b, _c;
            var _d, _e;
            var popperChildRef = _a.ref;
            var _f = _this.props, children = _f.children, className = _f.className, fill = _f.fill, openOnTargetFocus = _f.openOnTargetFocus, renderTarget = _f.renderTarget;
            var isOpen = _this.state.isOpen;
            var isControlled = _this.isControlled();
            var isHoverInteractionKind = _this.isHoverInteractionKind();
            var targetTagName = _this.props.targetTagName;
            if (fill) targetTagName = "div";
            // N.B. react-popper has a wide type for this ref, but we can narrow it based on the source,
            // see https://github.com/floating-ui/react-popper/blob/beac280d61082852c4efc302be902911ce2d424c/src/Reference.js#L17
            var ref = (0, $8k66C.mergeRefs)(popperChildRef, _this.targetRef);
            var targetEventHandlers = isHoverInteractionKind ? {
                // HOVER handlers
                onBlur: _this.handleTargetBlur,
                onContextMenu: _this.handleTargetContextMenu,
                onFocus: _this.handleTargetFocus,
                onMouseEnter: _this.handleMouseEnter,
                onMouseLeave: _this.handleMouseLeave
            } : {
                // CLICK needs only one handler
                onClick: _this.handleTargetClick,
                // For keyboard accessibility, trigger the same behavior as a click event upon pressing ENTER/SPACE
                onKeyDown: _this.handleKeyDown
            };
            // Ensure target is focusable if relevant prop enabled
            var targetTabIndex = openOnTargetFocus && isHoverInteractionKind ? 0 : undefined;
            var ownTargetProps = (0, $gztBd.__assign)({
                // N.B. this.props.className is passed along to renderTarget even though the user would have access to it.
                // If, instead, renderTarget is undefined and the target is provided as a child, this.props.className is
                // applied to the generated target wrapper element.
                className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(className, (0, $auzpd).POPOVER_TARGET, (_b = {}, _b[(0, $auzpd).POPOVER_OPEN] = isOpen, // this class is mainly useful for button targets
                _b[(0, $auzpd).ACTIVE] = isOpen && !isControlled && !isHoverInteractionKind, _b)),
                ref: ref
            }, targetEventHandlers);
            var childTargetProps = {
                "aria-expanded": isOpen,
                "aria-haspopup": _this.props.interactionKind === $d8007bafcfc703a7$export$6c571fbf65f9c7a6.HOVER_TARGET_ONLY ? undefined : (_d = _this.props.popupKind) !== null && _d !== void 0 ? _d : "menu"
            };
            var targetModifierClasses = (_c = {}, // this class is mainly useful for Blueprint <Button> targets; we should only apply it for
            // uncontrolled popovers when they are opened by a user interaction
            _c[(0, $auzpd).ACTIVE] = isOpen && !isControlled && !isHoverInteractionKind, // similarly, this class is mainly useful for targets like <Button>, <InputGroup>, etc.
            _c[(0, $auzpd).FILL] = fill, _c);
            var target;
            if (renderTarget !== undefined) target = renderTarget((0, $gztBd.__assign)((0, $gztBd.__assign)((0, $gztBd.__assign)({}, ownTargetProps), childTargetProps), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(ownTargetProps.className, targetModifierClasses),
                // if the consumer renders a tooltip target, it's their responsibility to disable that tooltip
                // when *this* popover is open
                isOpen: isOpen,
                tabIndex: targetTabIndex
            }));
            else {
                var childTarget = (0, $iP8Ix).ensureElement($8NFma.Children.toArray(children)[0]);
                if (childTarget === undefined) return null;
                var clonedTarget = $8NFma.cloneElement(childTarget, (0, $gztBd.__assign)((0, $gztBd.__assign)({}, childTargetProps), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(childTarget.props.className, targetModifierClasses),
                    // force disable single Tooltip child when popover is open
                    disabled: isOpen && (0, $iP8Ix).isElementOfType(childTarget, (0, $gVVt3.Tooltip)) ? true : childTarget.props.disabled,
                    tabIndex: (_e = childTarget.props.tabIndex) !== null && _e !== void 0 ? _e : targetTabIndex
                }));
                var wrappedTarget = $8NFma.createElement(targetTagName, (0, $gztBd.__assign)((0, $gztBd.__assign)({}, ownTargetProps), _this.props.targetProps), clonedTarget);
                target = wrappedTarget;
            }
            // No need to use the merged `ref` here, that only needs to be forwarded to the child node so that React can
            // notify both popper.js and our components about the mounted DOM element.
            return $8NFma.createElement((0, $kOBi8.ResizeSensor), {
                targetRef: _this.targetRef,
                onResize: _this.reposition
            }, target);
        };
        _this.renderPopover = function(popperProps) {
            var _a;
            var _b = _this.props, autoFocus = _b.autoFocus, enforceFocus = _b.enforceFocus, backdropProps = _b.backdropProps, canEscapeKeyClose = _b.canEscapeKeyClose, hasBackdrop = _b.hasBackdrop, interactionKind = _b.interactionKind, usePortal = _b.usePortal;
            var _c = _this.state, isClosingViaEscapeKeypress = _c.isClosingViaEscapeKeypress, isOpen = _c.isOpen;
            // compute an appropriate transform origin so the scale animation points towards target
            var transformOrigin = (0, $awEmD.getTransformOrigin)(popperProps.placement, _this.isArrowEnabled() ? popperProps.arrowProps.style : undefined);
            // need to update our reference to this function on every render as it will change.
            _this.popperScheduleUpdate = popperProps.update;
            var popoverHandlers = {
                // always check popover clicks for dismiss class
                onClick: _this.handlePopoverClick,
                // treat ENTER/SPACE keys the same as a click for accessibility
                onKeyDown: function(event) {
                    return (0, $iP8Ix).isKeyboardClick(event) && _this.handlePopoverClick(event);
                }
            };
            if (interactionKind === $d8007bafcfc703a7$export$6c571fbf65f9c7a6.HOVER || !usePortal && interactionKind === $d8007bafcfc703a7$export$6c571fbf65f9c7a6.HOVER_TARGET_ONLY) {
                popoverHandlers.onMouseEnter = _this.handleMouseEnter;
                popoverHandlers.onMouseLeave = _this.handleMouseLeave;
            }
            var basePlacement = (0, $awEmD.getBasePlacement)(popperProps.placement);
            var popoverClasses = (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $auzpd).POPOVER, (_a = {}, _a[(0, $auzpd).DARK] = _this.props.inheritDarkTheme && _this.state.hasDarkParent, _a[(0, $auzpd).MINIMAL] = _this.props.minimal, _a[(0, $auzpd).POPOVER_CAPTURING_DISMISS] = _this.props.captureDismiss, _a[(0, $auzpd).POPOVER_MATCH_TARGET_WIDTH] = _this.props.matchTargetWidth, _a[(0, $auzpd).POPOVER_REFERENCE_HIDDEN] = popperProps.isReferenceHidden === true, _a[(0, $auzpd).POPOVER_POPPER_ESCAPED] = popperProps.hasPopperEscaped === true, _a), "".concat((0, $auzpd).POPOVER_CONTENT_PLACEMENT, "-").concat(basePlacement), _this.props.popoverClassName);
            var defaultAutoFocus = _this.isHoverInteractionKind() ? false : undefined;
            // if hover interaction, it doesn't make sense to take over focus control
            var shouldReturnFocusOnClose = _this.isHoverInteractionKind() ? false : isClosingViaEscapeKeypress ? true : _this.props.shouldReturnFocusOnClose;
            return $8NFma.createElement((0, $duUmg.Overlay2), {
                autoFocus: autoFocus !== null && autoFocus !== void 0 ? autoFocus : defaultAutoFocus,
                backdropClassName: (0, $auzpd).POPOVER_BACKDROP,
                backdropProps: backdropProps,
                canEscapeKeyClose: canEscapeKeyClose,
                canOutsideClickClose: interactionKind === $d8007bafcfc703a7$export$6c571fbf65f9c7a6.CLICK,
                childRef: _this.transitionContainerElement,
                enforceFocus: enforceFocus,
                hasBackdrop: hasBackdrop,
                isOpen: isOpen,
                lazy: _this.props.lazy,
                onClose: _this.handleOverlayClose,
                onClosed: _this.props.onClosed,
                onClosing: _this.props.onClosing,
                onOpened: _this.props.onOpened,
                onOpening: _this.props.onOpening,
                transitionDuration: _this.props.transitionDuration,
                transitionName: (0, $auzpd).POPOVER,
                usePortal: usePortal,
                portalClassName: _this.props.portalClassName,
                portalContainer: _this.props.portalContainer,
                // eslint-disable-next-line deprecation/deprecation
                portalStopPropagationEvents: _this.props.portalStopPropagationEvents,
                shouldReturnFocusOnClose: shouldReturnFocusOnClose
            }, $8NFma.createElement("div", {
                className: (0, $auzpd).POPOVER_TRANSITION_CONTAINER,
                // We need to attach a ref that notifies both react-popper and our Popover component about the DOM
                // element inside the Overlay2. We cannot re-use `PopperChildrenProps.ref` because Overlay2 only
                // accepts a ref object (not a callback) due to a CSSTransition API limitation.
                // N.B. react-popper has a wide type for this ref, but we can narrow it based on the source,
                // see https://github.com/floating-ui/react-popper/blob/beac280d61082852c4efc302be902911ce2d424c/src/Popper.js#L94
                ref: (0, $8k66C.mergeRefs)(popperProps.ref, _this.transitionContainerElement),
                style: popperProps.style
            }, $8NFma.createElement((0, $kOBi8.ResizeSensor), {
                onResize: _this.reposition
            }, $8NFma.createElement("div", (0, $gztBd.__assign)({
                className: popoverClasses,
                style: {
                    transformOrigin: transformOrigin
                },
                ref: _this.popoverRef
            }, popoverHandlers), _this.isArrowEnabled() && $8NFma.createElement((0, $jtuvn.PopoverArrow), {
                arrowProps: popperProps.arrowProps,
                placement: popperProps.placement
            }), $8NFma.createElement("div", {
                className: (0, $auzpd).POPOVER_CONTENT
            }, _this.props.content)))));
        };
        _this.handleTargetFocus = function(e) {
            if (_this.props.openOnTargetFocus && _this.isHoverInteractionKind()) {
                if (e.relatedTarget == null && !_this.lostFocusOnSamePage) // ignore this focus event -- the target was already focused but the page itself
                // lost focus (e.g. due to switching tabs).
                return;
                _this.handleMouseEnter(e);
            }
        };
        _this.handleTargetBlur = function(e) {
            if (_this.props.openOnTargetFocus && _this.isHoverInteractionKind()) {
                if (e.relatedTarget != null) // if the next element to receive focus is within the popover, we'll want to leave the
                // popover open.
                {
                    if (e.relatedTarget !== _this.popoverElement && !_this.isElementInPopover(e.relatedTarget)) _this.handleMouseLeave(e);
                } else _this.handleMouseLeave(e);
            }
            _this.lostFocusOnSamePage = e.relatedTarget != null;
        };
        _this.handleTargetContextMenu = function(e) {
            // we assume that when someone prevents the default interaction on this event (a browser native context menu),
            // they are showing a custom context menu (as ContextMenu2 does); in this case, we should close this popover/tooltip
            if (e.defaultPrevented) _this.setOpenState(false, e);
        };
        _this.handleMouseEnter = function(e) {
            _this.isMouseInTargetOrPopover = true;
            // if we're entering the popover, and the mode is set to be HOVER_TARGET_ONLY, we want to manually
            // trigger the mouse leave event, as hovering over the popover shouldn't count.
            if (!_this.props.usePortal && _this.isElementInPopover(e.target) && _this.props.interactionKind === $d8007bafcfc703a7$export$6c571fbf65f9c7a6.HOVER_TARGET_ONLY && !_this.props.openOnTargetFocus) _this.handleMouseLeave(e);
            else if (!_this.props.disabled) // only begin opening popover when it is enabled
            _this.setOpenState(true, e, _this.props.hoverOpenDelay);
        };
        _this.handleMouseLeave = function(e) {
            _this.isMouseInTargetOrPopover = false;
            // Wait until the event queue is flushed, because we want to leave the
            // popover open if the mouse entered the popover immediately after
            // leaving the target (or vice versa). Make sure to persist the event since
            // we need to access `nativeEvent` in `this.setOpenState()`.
            e.persist();
            _this.setTimeout(function() {
                if (_this.isMouseInTargetOrPopover) return;
                // user-configurable closing delay is helpful when moving mouse from target to popover
                _this.setOpenState(false, e, _this.props.hoverCloseDelay);
            });
        };
        _this.handlePopoverClick = function(e) {
            var _a, _b, _c;
            var eventTarget = e.target;
            var eventPopover = eventTarget.closest(".".concat((0, $auzpd).POPOVER));
            var eventPopoverV1 = eventTarget.closest(".".concat((0, $auzpd).POPOVER));
            var isEventFromSelf = (eventPopover !== null && eventPopover !== void 0 ? eventPopover : eventPopoverV1) === _this.getPopoverElement();
            var isEventPopoverCapturing = (_b = (_a = eventPopover === null || eventPopover === void 0 ? void 0 : eventPopover.classList.contains((0, $auzpd).POPOVER_CAPTURING_DISMISS)) !== null && _a !== void 0 ? _a : eventPopoverV1 === null || eventPopoverV1 === void 0 ? void 0 : eventPopoverV1.classList.contains((0, $auzpd).POPOVER_CAPTURING_DISMISS)) !== null && _b !== void 0 ? _b : false;
            // an OVERRIDE inside a DISMISS does not dismiss, and a DISMISS inside an OVERRIDE will dismiss.
            var dismissElement = eventTarget.closest(".".concat((0, $auzpd).POPOVER_DISMISS, ", .").concat((0, $auzpd).POPOVER_DISMISS_OVERRIDE));
            var shouldDismiss = (_c = dismissElement === null || dismissElement === void 0 ? void 0 : dismissElement.classList.contains((0, $auzpd).POPOVER_DISMISS)) !== null && _c !== void 0 ? _c : false;
            var isDisabled = eventTarget.closest(":disabled, .".concat((0, $auzpd).DISABLED)) != null;
            if (shouldDismiss && !isDisabled && (!isEventPopoverCapturing || isEventFromSelf)) _this.setOpenState(false, e);
        };
        _this.handleOverlayClose = function(e) {
            var _a;
            if (_this.targetRef.current == null || e === undefined) return;
            var event = (_a = e.nativeEvent) !== null && _a !== void 0 ? _a : e;
            var eventTarget = event.composed ? event.composedPath()[0] : event.target;
            // if click was in target, target event listener will handle things, so don't close
            if (!(0, $iP8Ix).elementIsOrContains(_this.targetRef.current, eventTarget) || e.nativeEvent instanceof KeyboardEvent) _this.setOpenState(false, e);
        };
        _this.handleKeyDown = function(e) {
            var isKeyboardClick = (0, $iP8Ix).isKeyboardClick(e);
            // For keyboard accessibility, trigger the same behavior as a click event upon pressing ENTER/SPACE
            if (isKeyboardClick) _this.handleTargetClick(e);
        };
        _this.handleTargetClick = function(e) {
            // Target element(s) may fire simulated click event upon pressing ENTER/SPACE, which we should ignore
            // see: https://github.com/palantir/blueprint/issues/5775
            var shouldIgnoreClick = _this.state.isOpen && _this.isSimulatedButtonClick(e);
            if (!shouldIgnoreClick) // ensure click did not originate from within inline popover before closing
            {
                if (!_this.props.disabled && !_this.isElementInPopover(e.target)) {
                    if (_this.props.isOpen == null) _this.setState(function(prevState) {
                        return {
                            isOpen: !prevState.isOpen
                        };
                    });
                    else _this.setOpenState(!_this.props.isOpen, e);
                }
            }
        };
        _this.isSimulatedButtonClick = function(e) {
            return !e.isTrusted && e.target.matches(".".concat((0, $auzpd).BUTTON));
        };
        return _this;
    }
    // popper innerRef gives us a handle on the transition container, since that's what we render as the overlay child,
    // so if we want to look at our actual popover element, we need to reach inside a bit
    Popover.prototype.getPopoverElement = function() {
        var _a;
        return (_a = this.popoverElement) === null || _a === void 0 ? void 0 : _a.querySelector(".".concat((0, $auzpd).POPOVER));
    };
    Popover.prototype.getIsOpen = function(props) {
        var _a;
        // disabled popovers should never be allowed to open.
        if (props.disabled) return false;
        else return (_a = props.isOpen) !== null && _a !== void 0 ? _a : props.defaultIsOpen;
    };
    Popover.prototype.render = function() {
        var _a = this.props, disabled = _a.disabled, content = _a.content, placement = _a.placement, _b = _a.position, position = _b === void 0 ? "auto" : _b, positioningStrategy = _a.positioningStrategy;
        var isOpen = this.state.isOpen;
        var isContentEmpty = content == null || typeof content === "string" && content.trim() === "";
        if (isContentEmpty) {
            // need to do this check in render(), because `isOpen` is derived from
            // state, and state can't necessarily be accessed in validateProps.
            if (!disabled && isOpen !== false && !(0, $iP8Ix).isNodeEnv("production")) console.warn($bzsu8.POPOVER_WARN_EMPTY_CONTENT);
            // just render the target without a content overlay if there is no content to display
            return this.renderTarget({
                ref: $d8007bafcfc703a7$var$noop
            });
        }
        // Important: do not use <Reference innerRef> since it has a bug when used in React 18 strict mode
        // see https://github.com/floating-ui/react-popper/pull/459
        return $8NFma.createElement((0, $17ExX.Manager), null, $8NFma.createElement((0, $cgdjq.Reference), null, this.renderTarget), $8NFma.createElement((0, $aDCM4.Popper), {
            innerRef: this.popoverRef,
            placement: placement !== null && placement !== void 0 ? placement : (0, $adnTU.positionToPlacement)(position),
            strategy: positioningStrategy,
            modifiers: this.getPopperModifiers()
        }, this.renderPopover));
    };
    Popover.prototype.componentDidMount = function() {
        this.updateDarkParent();
    };
    Popover.prototype.componentDidUpdate = function(props, state) {
        _super.prototype.componentDidUpdate.call(this, props, state);
        this.updateDarkParent();
        var nextIsOpen = this.getIsOpen(this.props);
        if (this.props.isOpen != null && nextIsOpen !== this.state.isOpen) {
            this.setOpenState(nextIsOpen);
            // tricky: setOpenState calls setState only if this.props.isOpen is
            // not controlled, so we need to invoke setState manually here.
            this.setState({
                isOpen: nextIsOpen
            });
        } else if (this.props.disabled && this.state.isOpen && this.props.isOpen == null) // special case: close an uncontrolled popover when disabled is set to true
        this.setOpenState(false);
    };
    Popover.prototype.validateProps = function(props) {
        if (props.isOpen == null && props.onInteraction != null) console.warn($bzsu8.POPOVER_WARN_UNCONTROLLED_ONINTERACTION);
        if (props.hasBackdrop && !props.usePortal) console.warn($bzsu8.POPOVER_WARN_HAS_BACKDROP_INLINE);
        if (props.hasBackdrop && props.interactionKind !== $d8007bafcfc703a7$export$6c571fbf65f9c7a6.CLICK) console.warn($bzsu8.POPOVER_HAS_BACKDROP_INTERACTION);
        if (props.placement !== undefined && props.position !== undefined) console.warn($bzsu8.POPOVER_WARN_PLACEMENT_AND_POSITION_MUTEX);
        var childrenCount = $8NFma.Children.count(props.children);
        var hasRenderTargetProp = props.renderTarget !== undefined;
        var hasTargetPropsProp = props.targetProps !== undefined;
        if (childrenCount === 0 && !hasRenderTargetProp) console.warn($bzsu8.POPOVER_REQUIRES_TARGET);
        if (childrenCount > 1) console.warn($bzsu8.POPOVER_WARN_TOO_MANY_CHILDREN);
        if (childrenCount > 0 && hasRenderTargetProp) console.warn($bzsu8.POPOVER_WARN_DOUBLE_TARGET);
        if (hasRenderTargetProp && hasTargetPropsProp) console.warn($bzsu8.POPOVER_WARN_TARGET_PROPS_WITH_RENDER_TARGET);
    };
    Popover.prototype.getPopperModifiers = function() {
        var _a, _b, _c, _d;
        var _e = this.props, matchTargetWidth = _e.matchTargetWidth, modifiers = _e.modifiers, modifiersCustom = _e.modifiersCustom;
        var popperModifiers = [
            (0, $gztBd.__assign)({
                enabled: this.isArrowEnabled(),
                name: "arrow"
            }, modifiers === null || modifiers === void 0 ? void 0 : modifiers.arrow),
            (0, $gztBd.__assign)((0, $gztBd.__assign)({
                name: "computeStyles"
            }, modifiers === null || modifiers === void 0 ? void 0 : modifiers.computeStyles), {
                options: (0, $gztBd.__assign)({
                    adaptive: true,
                    // We disable the built-in gpuAcceleration so that
                    // Popper.js will return us easy to interpolate values
                    // (top, left instead of transform: translate3d)
                    // We'll then use these values to generate the needed
                    // css transform values blended with the react-spring values
                    gpuAcceleration: false
                }, (_a = modifiers === null || modifiers === void 0 ? void 0 : modifiers.computeStyles) === null || _a === void 0 ? void 0 : _a.options)
            }),
            (0, $gztBd.__assign)((0, $gztBd.__assign)({
                enabled: this.isArrowEnabled(),
                name: "offset"
            }, modifiers === null || modifiers === void 0 ? void 0 : modifiers.offset), {
                options: (0, $gztBd.__assign)({
                    offset: [
                        0,
                        (0, $jtuvn.POPOVER_ARROW_SVG_SIZE) / 2
                    ]
                }, (_b = modifiers === null || modifiers === void 0 ? void 0 : modifiers.offset) === null || _b === void 0 ? void 0 : _b.options)
            }),
            (0, $gztBd.__assign)((0, $gztBd.__assign)({
                name: "flip"
            }, modifiers === null || modifiers === void 0 ? void 0 : modifiers.flip), {
                options: (0, $gztBd.__assign)({
                    boundary: this.props.boundary,
                    rootBoundary: this.props.rootBoundary
                }, (_c = modifiers === null || modifiers === void 0 ? void 0 : modifiers.flip) === null || _c === void 0 ? void 0 : _c.options)
            }),
            (0, $gztBd.__assign)((0, $gztBd.__assign)({
                name: "preventOverflow"
            }, modifiers === null || modifiers === void 0 ? void 0 : modifiers.preventOverflow), {
                options: (0, $gztBd.__assign)({
                    boundary: this.props.boundary,
                    rootBoundary: this.props.rootBoundary
                }, (_d = modifiers === null || modifiers === void 0 ? void 0 : modifiers.preventOverflow) === null || _d === void 0 ? void 0 : _d.options)
            })
        ];
        if (matchTargetWidth) popperModifiers.push((0, $7aA5C.matchReferenceWidthModifier));
        if (modifiersCustom !== undefined) popperModifiers.push.apply(popperModifiers, modifiersCustom);
        return popperModifiers;
    };
    // a wrapper around setState({ isOpen }) that will call props.onInteraction instead when in controlled mode.
    // starts a timeout to delay changing the state if a non-zero duration is provided.
    Popover.prototype.setOpenState = function(isOpen, e, timeout) {
        var _this = this;
        var _a, _b, _c, _d, _e;
        // cancel any existing timeout because we have new state
        (_a = this.cancelOpenTimeout) === null || _a === void 0 || _a.call(this);
        if (timeout !== undefined && timeout > 0) {
            // Persist the react event since it will be used in a later macrotask.
            e === null || e === void 0 || e.persist();
            this.cancelOpenTimeout = this.setTimeout(function() {
                _this.setOpenState(isOpen, e);
            }, timeout);
        } else {
            if (this.props.isOpen == null) this.setState({
                isOpen: isOpen
            });
            else (_c = (_b = this.props).onInteraction) === null || _c === void 0 || _c.call(_b, isOpen, e);
            if (!isOpen) {
                // non-null assertion because the only time `e` is undefined is when in controlled mode
                // or the rare special case in uncontrolled mode when the `disabled` flag is toggled true
                (_e = (_d = this.props).onClose) === null || _e === void 0 || _e.call(_d, e);
                this.setState({
                    isClosingViaEscapeKeypress: $d8007bafcfc703a7$var$isEscapeKeypressEvent(e === null || e === void 0 ? void 0 : e.nativeEvent)
                });
            }
        }
    };
    Popover.prototype.updateDarkParent = function() {
        var _a;
        if (this.props.usePortal && this.state.isOpen) {
            var hasDarkParent = ((_a = this.targetRef.current) === null || _a === void 0 ? void 0 : _a.closest(".".concat((0, $auzpd).DARK))) != null;
            this.setState({
                hasDarkParent: hasDarkParent
            });
        }
    };
    Popover.prototype.isElementInPopover = function(element) {
        var _a, _b;
        return (_b = (_a = this.getPopoverElement()) === null || _a === void 0 ? void 0 : _a.contains(element)) !== null && _b !== void 0 ? _b : false;
    };
    Popover.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".Popover");
    Popover.defaultProps = {
        boundary: "clippingParents",
        captureDismiss: false,
        defaultIsOpen: false,
        disabled: false,
        fill: false,
        hasBackdrop: false,
        hoverCloseDelay: 300,
        hoverOpenDelay: 150,
        inheritDarkTheme: true,
        interactionKind: $d8007bafcfc703a7$export$6c571fbf65f9c7a6.CLICK,
        matchTargetWidth: false,
        minimal: false,
        openOnTargetFocus: true,
        // N.B. we don't set a default for `placement` or `position` here because that would trigger
        // a warning in validateProps if the other prop is specified by a user of this component
        positioningStrategy: "absolute",
        renderTarget: undefined,
        shouldReturnFocusOnClose: false,
        targetTagName: "span",
        transitionDuration: 300,
        usePortal: true
    };
    return Popover;
}((0, $4Jy2D.AbstractPureComponent));
function $d8007bafcfc703a7$var$isEscapeKeypressEvent(e) {
    return e instanceof KeyboardEvent && e.key === "Escape";
}
function $d8007bafcfc703a7$var$noop() {
// no-op
}

});
parcelRegister("17ExX", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $0d15e59a727dbd5b$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $0d15e59a727dbd5b$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $0d15e59a727dbd5b$export$d0d38e7dec7a1a61);

var $8NFma = parcelRequire("8NFma");
var $0d15e59a727dbd5b$export$3dbd3405086fec7b = $8NFma.createContext();
var $0d15e59a727dbd5b$export$cbabb21c2529b130 = $8NFma.createContext();
function $0d15e59a727dbd5b$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $8NFma.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $8NFma.useRef(false);
    $8NFma.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $8NFma.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $8NFma.createElement($0d15e59a727dbd5b$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $8NFma.createElement($0d15e59a727dbd5b$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("aDCM4", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $7beb9fac02c468dd$export$badac9ada3a0bdf9);

var $8NFma = parcelRequire("8NFma");

var $17ExX = parcelRequire("17ExX");

var $fZ4KC = parcelRequire("fZ4KC");

var $7mqAI = parcelRequire("7mqAI");
var $7beb9fac02c468dd$var$NOOP = function NOOP() {
    return void 0;
};
var $7beb9fac02c468dd$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $7beb9fac02c468dd$var$EMPTY_MODIFIERS = [];
function $7beb9fac02c468dd$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom" : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "absolute" : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $7beb9fac02c468dd$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $8NFma.useContext((0, $17ExX.ManagerReferenceNodeContext));
    var _React$useState = $8NFma.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $8NFma.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $8NFma.useEffect(function() {
        (0, $fZ4KC.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $8NFma.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: "arrow",
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $7mqAI.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $8NFma.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $7beb9fac02c468dd$var$NOOP,
            update: update || $7beb9fac02c468dd$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $fZ4KC.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("fZ4KC", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", () => $ba303cf50ad0695c$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $ba303cf50ad0695c$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $ba303cf50ad0695c$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $ba303cf50ad0695c$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $ba303cf50ad0695c$export$700979bc83e7db82);

var $8NFma = parcelRequire("8NFma");
var $ba303cf50ad0695c$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $ba303cf50ad0695c$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === "function") {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $ba303cf50ad0695c$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === "function") return $ba303cf50ad0695c$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $ba303cf50ad0695c$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $ba303cf50ad0695c$export$700979bc83e7db82 = typeof window !== "undefined" && window.document && window.document.createElement ? $8NFma.useLayoutEffect : $8NFma.useEffect;

});

parcelRegister("7mqAI", function(module, exports) {

$parcel$export(module.exports, "usePopper", () => $55bf36ef74f0d061$export$f4d5bf230a36dd6e);

var $8NFma = parcelRequire("8NFma");

var $2pmb0 = parcelRequire("2pmb0");

var $2oJ1v = parcelRequire("2oJ1v");

var $ez2oT = parcelRequire("ez2oT");

var $fZ4KC = parcelRequire("fZ4KC");
var $55bf36ef74f0d061$var$EMPTY_MODIFIERS = [];
var $55bf36ef74f0d061$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $8NFma.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || "bottom",
        strategy: options.strategy || "absolute",
        modifiers: options.modifiers || $55bf36ef74f0d061$var$EMPTY_MODIFIERS
    };
    var _React$useState = $8NFma.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: "0",
                top: "0"
            },
            arrow: {
                position: "absolute"
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $8NFma.useMemo(function() {
        return {
            name: "updateState",
            enabled: true,
            phase: "write",
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $2pmb0.flushSync(function() {
                    setState({
                        styles: (0, $fZ4KC.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $fZ4KC.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                "computeStyles"
            ]
        };
    }, []);
    var popperOptions = $8NFma.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: "applyStyles",
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ez2oT)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $8NFma.useRef();
    (0, $fZ4KC.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $fZ4KC.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $2oJ1v.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("2oJ1v", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $1bf0bf541303046d$export$8f7491d57c8f97a9);

var $fqRLw = parcelRequire("fqRLw");

var $lUt2x = parcelRequire("lUt2x");

var $k1fcs = parcelRequire("k1fcs");

var $hfLNM = parcelRequire("hfLNM");

var $bjlic = parcelRequire("bjlic");

var $aE9ix = parcelRequire("aE9ix");

var $fhdOY = parcelRequire("fhdOY");

var $4lgpD = parcelRequire("4lgpD");

var $2c83k = parcelRequire("2c83k");

var $201VR = parcelRequire("201VR");


var $1bf0bf541303046d$export$d34966752335dd47 = [
    (0, $lUt2x.default),
    (0, $k1fcs.default),
    (0, $hfLNM.default),
    (0, $bjlic.default),
    (0, $aE9ix.default),
    (0, $fhdOY.default),
    (0, $4lgpD.default),
    (0, $2c83k.default),
    (0, $201VR.default)
];
var $1bf0bf541303046d$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $fqRLw.popperGenerator)({
    defaultModifiers: $1bf0bf541303046d$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("fqRLw", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $b3c2fd6800546b4b$export$ed5e13716264f202);

var $4wmXH = parcelRequire("4wmXH");

var $4bNP2 = parcelRequire("4bNP2");

var $egjGe = parcelRequire("egjGe");

var $ecwzm = parcelRequire("ecwzm");

var $10cit = parcelRequire("10cit");

var $dlaWb = parcelRequire("dlaWb");

var $657FY = parcelRequire("657FY");


var $iG0HL = parcelRequire("iG0HL");
var $b3c2fd6800546b4b$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $b3c2fd6800546b4b$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $b3c2fd6800546b4b$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $b3c2fd6800546b4b$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $b3c2fd6800546b4b$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $iG0HL.isElement)(reference) ? (0, $egjGe.default)(reference) : reference.contextElement ? (0, $egjGe.default)(reference.contextElement) : [],
                    popper: (0, $egjGe.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $10cit.default)((0, $657FY.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$b3c2fd6800546b4b$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $4wmXH.default)(reference, (0, $ecwzm.default)(popper), state.options.strategy === "fixed"),
                    popper: (0, $4bNP2.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $dlaWb.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$b3c2fd6800546b4b$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $b3c2fd6800546b4b$export$8f7491d57c8f97a9 = /*#__PURE__*/ $b3c2fd6800546b4b$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("4wmXH", function(module, exports) {

$parcel$export(module.exports, "default", () => $34abf65a06d63352$export$2e2bcd8739ae039);

var $bkFj6 = parcelRequire("bkFj6");

var $hlFJX = parcelRequire("hlFJX");

var $6NwRo = parcelRequire("6NwRo");

var $iG0HL = parcelRequire("iG0HL");

var $cJ1Bs = parcelRequire("cJ1Bs");

var $5LRDP = parcelRequire("5LRDP");

var $25Alw = parcelRequire("25Alw");

var $aPr9y = parcelRequire("aPr9y");
function $34abf65a06d63352$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $aPr9y.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $aPr9y.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $34abf65a06d63352$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $iG0HL.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $iG0HL.isHTMLElement)(offsetParent) && $34abf65a06d63352$var$isElementScaled(offsetParent);
    var documentElement = (0, $5LRDP.default)(offsetParent);
    var rect = (0, $bkFj6.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $6NwRo.default)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $25Alw.default)(documentElement)) scroll = (0, $hlFJX.default)(offsetParent);
        if ((0, $iG0HL.isHTMLElement)(offsetParent)) {
            offsets = (0, $bkFj6.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $cJ1Bs.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("bkFj6", function(module, exports) {

$parcel$export(module.exports, "default", () => $84019ab652aa921b$export$2e2bcd8739ae039);

var $iG0HL = parcelRequire("iG0HL");

var $aPr9y = parcelRequire("aPr9y");

var $jc5j7 = parcelRequire("jc5j7");

var $d9GIF = parcelRequire("d9GIF");
function $84019ab652aa921b$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $iG0HL.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $aPr9y.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $aPr9y.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $iG0HL.isElement)(element) ? (0, $jc5j7.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $d9GIF.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("iG0HL", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $d98cb23738a6d9d0$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $d98cb23738a6d9d0$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $d98cb23738a6d9d0$export$af51f0f06c0f328a);

var $jc5j7 = parcelRequire("jc5j7");
function $d98cb23738a6d9d0$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $jc5j7.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $d98cb23738a6d9d0$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $jc5j7.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $d98cb23738a6d9d0$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $jc5j7.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("jc5j7", function(module, exports) {

$parcel$export(module.exports, "default", () => $df9341392e6ed7b1$export$2e2bcd8739ae039);
function $df9341392e6ed7b1$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("aPr9y", function(module, exports) {

$parcel$export(module.exports, "max", () => $7e23bad950468b82$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $7e23bad950468b82$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $7e23bad950468b82$export$2077e0241d6afd3c);
var $7e23bad950468b82$export$8960430cfd85939f = Math.max;
var $7e23bad950468b82$export$96ec731ed4dcb222 = Math.min;
var $7e23bad950468b82$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("d9GIF", function(module, exports) {

$parcel$export(module.exports, "default", () => $993d40d65cc118cd$export$2e2bcd8739ae039);

var $cqLtw = parcelRequire("cqLtw");
function $993d40d65cc118cd$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $cqLtw.default)());
}

});
parcelRegister("cqLtw", function(module, exports) {

$parcel$export(module.exports, "default", () => $90ccbd5892233dd2$export$2e2bcd8739ae039);
function $90ccbd5892233dd2$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}

});



parcelRegister("hlFJX", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca14c6927ef497ac$export$2e2bcd8739ae039);

var $8Z1VN = parcelRequire("8Z1VN");

var $jc5j7 = parcelRequire("jc5j7");

var $iG0HL = parcelRequire("iG0HL");

var $crSja = parcelRequire("crSja");
function $ca14c6927ef497ac$export$2e2bcd8739ae039(node) {
    if (node === (0, $jc5j7.default)(node) || !(0, $iG0HL.isHTMLElement)(node)) return (0, $8Z1VN.default)(node);
    else return (0, $crSja.default)(node);
}

});
parcelRegister("8Z1VN", function(module, exports) {

$parcel$export(module.exports, "default", () => $68a584be1dc90596$export$2e2bcd8739ae039);

var $jc5j7 = parcelRequire("jc5j7");
function $68a584be1dc90596$export$2e2bcd8739ae039(node) {
    var win = (0, $jc5j7.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("crSja", function(module, exports) {

$parcel$export(module.exports, "default", () => $9102221f9e13ae54$export$2e2bcd8739ae039);
function $9102221f9e13ae54$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("6NwRo", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f30cf0ce50e075e$export$2e2bcd8739ae039);
function $4f30cf0ce50e075e$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}

});

parcelRegister("cJ1Bs", function(module, exports) {

$parcel$export(module.exports, "default", () => $943aee5c7065ad53$export$2e2bcd8739ae039);

var $bkFj6 = parcelRequire("bkFj6");

var $5LRDP = parcelRequire("5LRDP");

var $8Z1VN = parcelRequire("8Z1VN");
function $943aee5c7065ad53$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $bkFj6.default)((0, $5LRDP.default)(element)).left + (0, $8Z1VN.default)(element).scrollLeft;
}

});
parcelRegister("5LRDP", function(module, exports) {

$parcel$export(module.exports, "default", () => $433af39bc2fae35d$export$2e2bcd8739ae039);

var $iG0HL = parcelRequire("iG0HL");
function $433af39bc2fae35d$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $iG0HL.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("25Alw", function(module, exports) {

$parcel$export(module.exports, "default", () => $18583dfdff147fd4$export$2e2bcd8739ae039);

var $5Edas = parcelRequire("5Edas");
function $18583dfdff147fd4$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $5Edas.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("5Edas", function(module, exports) {

$parcel$export(module.exports, "default", () => $41cae7042543c5d5$export$2e2bcd8739ae039);

var $jc5j7 = parcelRequire("jc5j7");
function $41cae7042543c5d5$export$2e2bcd8739ae039(element) {
    return (0, $jc5j7.default)(element).getComputedStyle(element);
}

});



parcelRegister("4bNP2", function(module, exports) {

$parcel$export(module.exports, "default", () => $30ced62b744c6cfe$export$2e2bcd8739ae039);

var $bkFj6 = parcelRequire("bkFj6");
function $30ced62b744c6cfe$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $bkFj6.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("egjGe", function(module, exports) {

$parcel$export(module.exports, "default", () => $a621d360f1a81b88$export$2e2bcd8739ae039);

var $5nNqk = parcelRequire("5nNqk");

var $23yvR = parcelRequire("23yvR");

var $jc5j7 = parcelRequire("jc5j7");

var $25Alw = parcelRequire("25Alw");
function $a621d360f1a81b88$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $5nNqk.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $jc5j7.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $25Alw.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($a621d360f1a81b88$export$2e2bcd8739ae039((0, $23yvR.default)(target)));
}

});
parcelRegister("5nNqk", function(module, exports) {

$parcel$export(module.exports, "default", () => $3eb5703c925e0e5d$export$2e2bcd8739ae039);

var $23yvR = parcelRequire("23yvR");

var $25Alw = parcelRequire("25Alw");

var $6NwRo = parcelRequire("6NwRo");

var $iG0HL = parcelRequire("iG0HL");
function $3eb5703c925e0e5d$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $6NwRo.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $iG0HL.isHTMLElement)(node) && (0, $25Alw.default)(node)) return node;
    return $3eb5703c925e0e5d$export$2e2bcd8739ae039((0, $23yvR.default)(node));
}

});
parcelRegister("23yvR", function(module, exports) {

$parcel$export(module.exports, "default", () => $17f6a21d28fc02f5$export$2e2bcd8739ae039);

var $6NwRo = parcelRequire("6NwRo");

var $5LRDP = parcelRequire("5LRDP");

var $iG0HL = parcelRequire("iG0HL");
function $17f6a21d28fc02f5$export$2e2bcd8739ae039(element) {
    if ((0, $6NwRo.default)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $iG0HL.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $5LRDP.default)(element) // fallback
    );
}

});



parcelRegister("ecwzm", function(module, exports) {

$parcel$export(module.exports, "default", () => $a56b734280245ffb$export$2e2bcd8739ae039);

var $jc5j7 = parcelRequire("jc5j7");

var $6NwRo = parcelRequire("6NwRo");

var $5Edas = parcelRequire("5Edas");

var $iG0HL = parcelRequire("iG0HL");

var $8WsnW = parcelRequire("8WsnW");

var $23yvR = parcelRequire("23yvR");

var $cqLtw = parcelRequire("cqLtw");
function $a56b734280245ffb$var$getTrueOffsetParent(element) {
    if (!(0, $iG0HL.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $5Edas.default)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $a56b734280245ffb$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $cqLtw.default)());
    var isIE = /Trident/i.test((0, $cqLtw.default)());
    if (isIE && (0, $iG0HL.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $5Edas.default)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $23yvR.default)(element);
    if ((0, $iG0HL.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $iG0HL.isHTMLElement)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $6NwRo.default)(currentNode)) < 0){
        var css = (0, $5Edas.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $a56b734280245ffb$export$2e2bcd8739ae039(element) {
    var window = (0, $jc5j7.default)(element);
    var offsetParent = $a56b734280245ffb$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $8WsnW.default)(offsetParent) && (0, $5Edas.default)(offsetParent).position === "static")offsetParent = $a56b734280245ffb$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $6NwRo.default)(offsetParent) === "html" || (0, $6NwRo.default)(offsetParent) === "body" && (0, $5Edas.default)(offsetParent).position === "static")) return window;
    return offsetParent || $a56b734280245ffb$var$getContainingBlock(element) || window;
}

});
parcelRegister("8WsnW", function(module, exports) {

$parcel$export(module.exports, "default", () => $6829c22fb01dde5a$export$2e2bcd8739ae039);

var $6NwRo = parcelRequire("6NwRo");
function $6829c22fb01dde5a$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $6NwRo.default)(element)) >= 0;
}

});


parcelRegister("10cit", function(module, exports) {

$parcel$export(module.exports, "default", () => $0baf5472b5ad4a5a$export$2e2bcd8739ae039);

var $l6ej2 = parcelRequire("l6ej2");
function $0baf5472b5ad4a5a$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $0baf5472b5ad4a5a$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $0baf5472b5ad4a5a$var$order(modifiers); // order based on phase
    return (0, $l6ej2.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("l6ej2", function(module, exports) {

$parcel$export(module.exports, "top", () => $f5c54167a3c62105$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $f5c54167a3c62105$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $f5c54167a3c62105$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $f5c54167a3c62105$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $f5c54167a3c62105$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $f5c54167a3c62105$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $f5c54167a3c62105$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $f5c54167a3c62105$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $f5c54167a3c62105$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $f5c54167a3c62105$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $f5c54167a3c62105$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $f5c54167a3c62105$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $f5c54167a3c62105$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $f5c54167a3c62105$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $f5c54167a3c62105$export$d087d3878fdf71d5);
var $f5c54167a3c62105$export$1e95b668f3b82d = "top";
var $f5c54167a3c62105$export$40e543e69a8b3fbb = "bottom";
var $f5c54167a3c62105$export$79ffe56a765070d2 = "right";
var $f5c54167a3c62105$export$eabcd2c8791e7bf4 = "left";
var $f5c54167a3c62105$export$dfb5619354ba860 = "auto";
var $f5c54167a3c62105$export$aec2ce47c367b8c3 = [
    $f5c54167a3c62105$export$1e95b668f3b82d,
    $f5c54167a3c62105$export$40e543e69a8b3fbb,
    $f5c54167a3c62105$export$79ffe56a765070d2,
    $f5c54167a3c62105$export$eabcd2c8791e7bf4
];
var $f5c54167a3c62105$export$b3571188c770cc5a = "start";
var $f5c54167a3c62105$export$bd5df0f255a350f8 = "end";
var $f5c54167a3c62105$export$390fd549c5303b4d = "clippingParents";
var $f5c54167a3c62105$export$d7b7311ec04a3e8f = "viewport";
var $f5c54167a3c62105$export$ae5ab1c730825774 = "popper";
var $f5c54167a3c62105$export$ca50aac9f3ba507f = "reference";
var $f5c54167a3c62105$export$368f9a87e87fa4e1 = /*#__PURE__*/ $f5c54167a3c62105$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $f5c54167a3c62105$export$b3571188c770cc5a,
        placement + "-" + $f5c54167a3c62105$export$bd5df0f255a350f8
    ]);
}, []);
var $f5c54167a3c62105$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($f5c54167a3c62105$export$aec2ce47c367b8c3, [
    $f5c54167a3c62105$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $f5c54167a3c62105$export$b3571188c770cc5a,
        placement + "-" + $f5c54167a3c62105$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $f5c54167a3c62105$export$421679a7c3d56e = "beforeRead";
var $f5c54167a3c62105$export$aafa59e2e03f2942 = "read";
var $f5c54167a3c62105$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $f5c54167a3c62105$export$c65e99957a05207c = "beforeMain";
var $f5c54167a3c62105$export$f22da7240b7add18 = "main";
var $f5c54167a3c62105$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $f5c54167a3c62105$export$8d4d2d70e7d46032 = "beforeWrite";
var $f5c54167a3c62105$export$68d8715fc104d294 = "write";
var $f5c54167a3c62105$export$70a6e5159acce2e6 = "afterWrite";
var $f5c54167a3c62105$export$d087d3878fdf71d5 = [
    $f5c54167a3c62105$export$421679a7c3d56e,
    $f5c54167a3c62105$export$aafa59e2e03f2942,
    $f5c54167a3c62105$export$6964f6c886723980,
    $f5c54167a3c62105$export$c65e99957a05207c,
    $f5c54167a3c62105$export$f22da7240b7add18,
    $f5c54167a3c62105$export$bab79516f2d662fe,
    $f5c54167a3c62105$export$8d4d2d70e7d46032,
    $f5c54167a3c62105$export$68d8715fc104d294,
    $f5c54167a3c62105$export$70a6e5159acce2e6
];

});


parcelRegister("dlaWb", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b65b878009bf47f$export$2e2bcd8739ae039);
function $9b65b878009bf47f$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("657FY", function(module, exports) {

$parcel$export(module.exports, "default", () => $46d929ffbbd3136a$export$2e2bcd8739ae039);
function $46d929ffbbd3136a$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("lUt2x", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff355aafd082b0cd$export$2e2bcd8739ae039);

var $jc5j7 = parcelRequire("jc5j7");
var $ff355aafd082b0cd$var$passive = {
    passive: true
};
function $ff355aafd082b0cd$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $jc5j7.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $ff355aafd082b0cd$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $ff355aafd082b0cd$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $ff355aafd082b0cd$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $ff355aafd082b0cd$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $ff355aafd082b0cd$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $ff355aafd082b0cd$var$effect,
    data: {}
};

});

parcelRegister("k1fcs", function(module, exports) {

$parcel$export(module.exports, "default", () => $e92fb10df1450f31$export$2e2bcd8739ae039);

var $kcANe = parcelRequire("kcANe");
function $e92fb10df1450f31$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $kcANe.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $e92fb10df1450f31$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $e92fb10df1450f31$var$popperOffsets,
    data: {}
};

});
parcelRegister("kcANe", function(module, exports) {

$parcel$export(module.exports, "default", () => $03cba2f7a1498b5f$export$2e2bcd8739ae039);

var $f6ekA = parcelRequire("f6ekA");

var $ayUxD = parcelRequire("ayUxD");

var $fxYmH = parcelRequire("fxYmH");

var $l6ej2 = parcelRequire("l6ej2");
function $03cba2f7a1498b5f$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $f6ekA.default)(placement) : null;
    var variation = placement ? (0, $ayUxD.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $l6ej2.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $l6ej2.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $l6ej2.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $l6ej2.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $fxYmH.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $l6ej2.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $l6ej2.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("f6ekA", function(module, exports) {

$parcel$export(module.exports, "default", () => $afe288682115fde3$export$2e2bcd8739ae039);

function $afe288682115fde3$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}

});

parcelRegister("ayUxD", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b08f0526e425773$export$2e2bcd8739ae039);
function $7b08f0526e425773$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}

});

parcelRegister("fxYmH", function(module, exports) {

$parcel$export(module.exports, "default", () => $b518c35b71cf930f$export$2e2bcd8739ae039);
function $b518c35b71cf930f$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}

});



parcelRegister("hfLNM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8f8eadcf7685dc5$export$2e2bcd8739ae039);

var $l6ej2 = parcelRequire("l6ej2");

var $ecwzm = parcelRequire("ecwzm");

var $jc5j7 = parcelRequire("jc5j7");

var $5LRDP = parcelRequire("5LRDP");

var $5Edas = parcelRequire("5Edas");

var $f6ekA = parcelRequire("f6ekA");

var $ayUxD = parcelRequire("ayUxD");

var $aPr9y = parcelRequire("aPr9y");
var $c8f8eadcf7685dc5$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $c8f8eadcf7685dc5$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $aPr9y.round)(x * dpr) / dpr || 0,
        y: (0, $aPr9y.round)(y * dpr) / dpr || 0
    };
}
function $c8f8eadcf7685dc5$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $l6ej2.left);
    var sideY = (0, $l6ej2.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $ecwzm.default)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $jc5j7.default)(popper)) {
            offsetParent = (0, $5LRDP.default)(popper);
            if ((0, $5Edas.default)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $l6ej2.top) || (placement === (0, $l6ej2.left) || placement === (0, $l6ej2.right)) && variation === (0, $l6ej2.end)) {
            sideY = (0, $l6ej2.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $l6ej2.left) || (placement === (0, $l6ej2.top) || placement === (0, $l6ej2.bottom)) && variation === (0, $l6ej2.end)) {
            sideX = (0, $l6ej2.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $c8f8eadcf7685dc5$var$unsetSides);
    var _ref4 = roundOffsets === true ? $c8f8eadcf7685dc5$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $jc5j7.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $c8f8eadcf7685dc5$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $f6ekA.default)(state.placement),
        variation: (0, $ayUxD.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $c8f8eadcf7685dc5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $c8f8eadcf7685dc5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $c8f8eadcf7685dc5$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $c8f8eadcf7685dc5$var$computeStyles,
    data: {}
};

});

parcelRegister("bjlic", function(module, exports) {

$parcel$export(module.exports, "default", () => $83c1fc4c4e58d7dd$export$2e2bcd8739ae039);

var $6NwRo = parcelRequire("6NwRo");

var $iG0HL = parcelRequire("iG0HL");
// and applies them to the HTMLElements such as popper and arrow
function $83c1fc4c4e58d7dd$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $iG0HL.isHTMLElement)(element) || !(0, $6NwRo.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $83c1fc4c4e58d7dd$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $iG0HL.isHTMLElement)(element) || !(0, $6NwRo.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $83c1fc4c4e58d7dd$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $83c1fc4c4e58d7dd$var$applyStyles,
    effect: $83c1fc4c4e58d7dd$var$effect,
    requires: [
        "computeStyles"
    ]
};

});

parcelRegister("aE9ix", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c04da2e958a3fe8$export$2e2bcd8739ae039);

var $f6ekA = parcelRequire("f6ekA");

var $l6ej2 = parcelRequire("l6ej2");
function $7c04da2e958a3fe8$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $f6ekA.default)(placement);
    var invertDistance = [
        (0, $l6ej2.left),
        (0, $l6ej2.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $l6ej2.left),
        (0, $l6ej2.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $7c04da2e958a3fe8$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $l6ej2.placements).reduce(function(acc, placement) {
        acc[placement] = $7c04da2e958a3fe8$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $7c04da2e958a3fe8$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $7c04da2e958a3fe8$var$offset
};

});

parcelRegister("fhdOY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1f32a1d9525a032$export$2e2bcd8739ae039);

var $bbSog = parcelRequire("bbSog");

var $f6ekA = parcelRequire("f6ekA");

var $ac6AR = parcelRequire("ac6AR");

var $leSQw = parcelRequire("leSQw");

var $iScBU = parcelRequire("iScBU");

var $l6ej2 = parcelRequire("l6ej2");

var $ayUxD = parcelRequire("ayUxD");
function $b1f32a1d9525a032$var$getExpandedFallbackPlacements(placement) {
    if ((0, $f6ekA.default)(placement) === (0, $l6ej2.auto)) return [];
    var oppositePlacement = (0, $bbSog.default)(placement);
    return [
        (0, $ac6AR.default)(placement),
        oppositePlacement,
        (0, $ac6AR.default)(oppositePlacement)
    ];
}
function $b1f32a1d9525a032$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $f6ekA.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $bbSog.default)(preferredPlacement)
    ] : $b1f32a1d9525a032$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $f6ekA.default)(placement) === (0, $l6ej2.auto) ? (0, $iScBU.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $f6ekA.default)(placement);
        var isStartVariation = (0, $ayUxD.default)(placement) === (0, $l6ej2.start);
        var isVertical = [
            (0, $l6ej2.top),
            (0, $l6ej2.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $leSQw.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $l6ej2.right) : (0, $l6ej2.left) : isStartVariation ? (0, $l6ej2.bottom) : (0, $l6ej2.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $bbSog.default)(mainVariationSide);
        var altVariationSide = (0, $bbSog.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $b1f32a1d9525a032$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $b1f32a1d9525a032$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("bbSog", function(module, exports) {

$parcel$export(module.exports, "default", () => $825ae98fe4f5d029$export$2e2bcd8739ae039);
var $825ae98fe4f5d029$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $825ae98fe4f5d029$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $825ae98fe4f5d029$var$hash[matched];
    });
}

});

parcelRegister("ac6AR", function(module, exports) {

$parcel$export(module.exports, "default", () => $76c023b5f4bd6339$export$2e2bcd8739ae039);
var $76c023b5f4bd6339$var$hash = {
    start: "end",
    end: "start"
};
function $76c023b5f4bd6339$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $76c023b5f4bd6339$var$hash[matched];
    });
}

});

parcelRegister("leSQw", function(module, exports) {

$parcel$export(module.exports, "default", () => $f765731200b57f98$export$2e2bcd8739ae039);

var $8vjqA = parcelRequire("8vjqA");

var $5LRDP = parcelRequire("5LRDP");

var $bkFj6 = parcelRequire("bkFj6");

var $kcANe = parcelRequire("kcANe");

var $fbi7z = parcelRequire("fbi7z");

var $l6ej2 = parcelRequire("l6ej2");

var $iG0HL = parcelRequire("iG0HL");

var $4QECX = parcelRequire("4QECX");

var $6CeE3 = parcelRequire("6CeE3");
function $f765731200b57f98$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $l6ej2.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $l6ej2.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $l6ej2.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $4QECX.default)(typeof padding !== "number" ? padding : (0, $6CeE3.default)(padding, (0, $l6ej2.basePlacements)));
    var altContext = elementContext === (0, $l6ej2.popper) ? (0, $l6ej2.reference) : (0, $l6ej2.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $8vjqA.default)((0, $iG0HL.isElement)(element) ? element : element.contextElement || (0, $5LRDP.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $bkFj6.default)(state.elements.reference);
    var popperOffsets = (0, $kcANe.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $fbi7z.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $l6ej2.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $l6ej2.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $l6ej2.right),
                (0, $l6ej2.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $l6ej2.top),
                (0, $l6ej2.bottom)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("8vjqA", function(module, exports) {

$parcel$export(module.exports, "default", () => $631049efb60e96c6$export$2e2bcd8739ae039);

var $l6ej2 = parcelRequire("l6ej2");

var $ayVYt = parcelRequire("ayVYt");

var $5mmoF = parcelRequire("5mmoF");

var $egjGe = parcelRequire("egjGe");

var $ecwzm = parcelRequire("ecwzm");

var $5LRDP = parcelRequire("5LRDP");

var $5Edas = parcelRequire("5Edas");

var $iG0HL = parcelRequire("iG0HL");

var $bkFj6 = parcelRequire("bkFj6");

var $23yvR = parcelRequire("23yvR");

var $ioj8K = parcelRequire("ioj8K");

var $6NwRo = parcelRequire("6NwRo");

var $fbi7z = parcelRequire("fbi7z");

var $aPr9y = parcelRequire("aPr9y");
function $631049efb60e96c6$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $bkFj6.default)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $631049efb60e96c6$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $l6ej2.viewport) ? (0, $fbi7z.default)((0, $ayVYt.default)(element, strategy)) : (0, $iG0HL.isElement)(clippingParent) ? $631049efb60e96c6$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $fbi7z.default)((0, $5mmoF.default)((0, $5LRDP.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $631049efb60e96c6$var$getClippingParents(element) {
    var clippingParents = (0, $egjGe.default)((0, $23yvR.default)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $5Edas.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $iG0HL.isHTMLElement)(element) ? (0, $ecwzm.default)(element) : element;
    if (!(0, $iG0HL.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $iG0HL.isElement)(clippingParent) && (0, $ioj8K.default)(clippingParent, clipperElement) && (0, $6NwRo.default)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $631049efb60e96c6$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $631049efb60e96c6$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $631049efb60e96c6$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $aPr9y.max)(rect.top, accRect.top);
        accRect.right = (0, $aPr9y.min)(rect.right, accRect.right);
        accRect.bottom = (0, $aPr9y.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $aPr9y.max)(rect.left, accRect.left);
        return accRect;
    }, $631049efb60e96c6$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("ayVYt", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b0a0ce1fa68929f$export$2e2bcd8739ae039);

var $jc5j7 = parcelRequire("jc5j7");

var $5LRDP = parcelRequire("5LRDP");

var $cJ1Bs = parcelRequire("cJ1Bs");

var $d9GIF = parcelRequire("d9GIF");
function $7b0a0ce1fa68929f$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $jc5j7.default)(element);
    var html = (0, $5LRDP.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $d9GIF.default)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $cJ1Bs.default)(element),
        y: y
    };
}

});

parcelRegister("5mmoF", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e70615fb3e74824$export$2e2bcd8739ae039);

var $5LRDP = parcelRequire("5LRDP");

var $5Edas = parcelRequire("5Edas");

var $cJ1Bs = parcelRequire("cJ1Bs");

var $8Z1VN = parcelRequire("8Z1VN");

var $aPr9y = parcelRequire("aPr9y");
function $3e70615fb3e74824$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $5LRDP.default)(element);
    var winScroll = (0, $8Z1VN.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $aPr9y.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $aPr9y.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $cJ1Bs.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $5Edas.default)(body || html).direction === "rtl") x += (0, $aPr9y.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("ioj8K", function(module, exports) {

$parcel$export(module.exports, "default", () => $d63950b756706495$export$2e2bcd8739ae039);

var $iG0HL = parcelRequire("iG0HL");
function $d63950b756706495$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $iG0HL.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("fbi7z", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0d5f0927fb8bf5c$export$2e2bcd8739ae039);
function $b0d5f0927fb8bf5c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("4QECX", function(module, exports) {

$parcel$export(module.exports, "default", () => $387b887da02b7e69$export$2e2bcd8739ae039);

var $8WQnk = parcelRequire("8WQnk");
function $387b887da02b7e69$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $8WQnk.default)(), paddingObject);
}

});
parcelRegister("8WQnk", function(module, exports) {

$parcel$export(module.exports, "default", () => $683c5e26d5f8bfe5$export$2e2bcd8739ae039);
function $683c5e26d5f8bfe5$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("6CeE3", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d11a6decde23bf9$export$2e2bcd8739ae039);
function $4d11a6decde23bf9$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("iScBU", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbd70d4ba9902caa$export$2e2bcd8739ae039);

var $ayUxD = parcelRequire("ayUxD");

var $l6ej2 = parcelRequire("l6ej2");

var $leSQw = parcelRequire("leSQw");

var $f6ekA = parcelRequire("f6ekA");
function $dbd70d4ba9902caa$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $l6ej2.placements) : _options$allowedAutoP;
    var variation = (0, $ayUxD.default)(placement);
    var placements = variation ? flipVariations ? (0, $l6ej2.variationPlacements) : (0, $l6ej2.variationPlacements).filter(function(placement) {
        return (0, $ayUxD.default)(placement) === variation;
    }) : (0, $l6ej2.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $leSQw.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $f6ekA.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("4lgpD", function(module, exports) {

$parcel$export(module.exports, "default", () => $3295dac8746ffe59$export$2e2bcd8739ae039);

var $l6ej2 = parcelRequire("l6ej2");

var $f6ekA = parcelRequire("f6ekA");

var $fxYmH = parcelRequire("fxYmH");

var $iByzU = parcelRequire("iByzU");

var $fHMKD = parcelRequire("fHMKD");

var $4bNP2 = parcelRequire("4bNP2");

var $ecwzm = parcelRequire("ecwzm");

var $leSQw = parcelRequire("leSQw");

var $ayUxD = parcelRequire("ayUxD");

var $8WQnk = parcelRequire("8WQnk");

var $aPr9y = parcelRequire("aPr9y");
function $3295dac8746ffe59$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $leSQw.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $f6ekA.default)(state.placement);
    var variation = (0, $ayUxD.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $fxYmH.default)(basePlacement);
    var altAxis = (0, $iByzU.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $l6ej2.top) : (0, $l6ej2.left);
        var altSide = mainAxis === "y" ? (0, $l6ej2.bottom) : (0, $l6ej2.right);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $l6ej2.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $l6ej2.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $4bNP2.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $8WQnk.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $fHMKD.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $ecwzm.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $fHMKD.within)(tether ? (0, $aPr9y.min)(min, tetherMin) : min, offset, tether ? (0, $aPr9y.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $l6ej2.top) : (0, $l6ej2.left);
        var _altSide = mainAxis === "x" ? (0, $l6ej2.bottom) : (0, $l6ej2.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $l6ej2.top),
            (0, $l6ej2.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $fHMKD.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $fHMKD.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $3295dac8746ffe59$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $3295dac8746ffe59$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};

});
parcelRegister("iByzU", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8b68132b61080af$export$2e2bcd8739ae039);
function $d8b68132b61080af$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}

});

parcelRegister("fHMKD", function(module, exports) {

$parcel$export(module.exports, "within", () => $b6f0b0266e764faa$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $b6f0b0266e764faa$export$86c8af6d3ef0b4a);

var $aPr9y = parcelRequire("aPr9y");
function $b6f0b0266e764faa$export$f28d906d67a997f3(min, value, max) {
    return (0, $aPr9y.max)(min, (0, $aPr9y.min)(value, max));
}
function $b6f0b0266e764faa$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $b6f0b0266e764faa$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("2c83k", function(module, exports) {

$parcel$export(module.exports, "default", () => $1992f2d714808ab6$export$2e2bcd8739ae039);

var $f6ekA = parcelRequire("f6ekA");

var $4bNP2 = parcelRequire("4bNP2");

var $ioj8K = parcelRequire("ioj8K");

var $ecwzm = parcelRequire("ecwzm");

var $fxYmH = parcelRequire("fxYmH");

var $fHMKD = parcelRequire("fHMKD");

var $4QECX = parcelRequire("4QECX");

var $6CeE3 = parcelRequire("6CeE3");

var $l6ej2 = parcelRequire("l6ej2");
var $1992f2d714808ab6$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $4QECX.default)(typeof padding !== "number" ? padding : (0, $6CeE3.default)(padding, (0, $l6ej2.basePlacements)));
};
function $1992f2d714808ab6$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $f6ekA.default)(state.placement);
    var axis = (0, $fxYmH.default)(basePlacement);
    var isVertical = [
        (0, $l6ej2.left),
        (0, $l6ej2.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $1992f2d714808ab6$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $4bNP2.default)(arrowElement);
    var minProp = axis === "y" ? (0, $l6ej2.top) : (0, $l6ej2.left);
    var maxProp = axis === "y" ? (0, $l6ej2.bottom) : (0, $l6ej2.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $ecwzm.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $fHMKD.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $1992f2d714808ab6$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $ioj8K.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $1992f2d714808ab6$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $1992f2d714808ab6$var$arrow,
    effect: $1992f2d714808ab6$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};

});

parcelRegister("201VR", function(module, exports) {

$parcel$export(module.exports, "default", () => $174d14927bb4f43b$export$2e2bcd8739ae039);

var $l6ej2 = parcelRequire("l6ej2");

var $leSQw = parcelRequire("leSQw");
function $174d14927bb4f43b$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $174d14927bb4f43b$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $l6ej2.top),
        (0, $l6ej2.right),
        (0, $l6ej2.bottom),
        (0, $l6ej2.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $174d14927bb4f43b$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $leSQw.default)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $leSQw.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $174d14927bb4f43b$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $174d14927bb4f43b$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $174d14927bb4f43b$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $174d14927bb4f43b$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $174d14927bb4f43b$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $174d14927bb4f43b$var$hide
};

});


parcelRegister("ez2oT", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $a9a6323e247bed41$var$hasElementType = typeof Element !== "undefined";
var $a9a6323e247bed41$var$hasMap = typeof Map === "function";
var $a9a6323e247bed41$var$hasSet = typeof Set === "function";
var $a9a6323e247bed41$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $a9a6323e247bed41$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$a9a6323e247bed41$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($a9a6323e247bed41$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$a9a6323e247bed41$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($a9a6323e247bed41$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($a9a6323e247bed41$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($a9a6323e247bed41$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$a9a6323e247bed41$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $a9a6323e247bed41$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});



parcelRegister("cgdjq", function(module, exports) {

$parcel$export(module.exports, "Reference", () => $8ed14e2ffbe6afe9$export$e0be378c32fb70a7);

var $8NFma = parcelRequire("8NFma");

var $7jOyK = parcelRequire("7jOyK");

var $17ExX = parcelRequire("17ExX");

var $fZ4KC = parcelRequire("fZ4KC");
function $8ed14e2ffbe6afe9$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $8NFma.useContext((0, $17ExX.ManagerReferenceNodeSetterContext));
    var refHandler = $8NFma.useCallback(function(node) {
        (0, $fZ4KC.setRef)(innerRef, node);
        (0, $fZ4KC.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $8NFma.useEffect(function() {
        return function() {
            return (0, $fZ4KC.setRef)(innerRef, null);
        };
    }, []);
    $8NFma.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($7jOyK)))(Boolean(setReferenceNode), "`Reference` should not be used outside of a `Manager` component.");
    }, [
        setReferenceNode
    ]);
    return (0, $fZ4KC.unwrapArray)(children)({
        ref: refHandler
    });
}

});
parcelRegister("7jOyK", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $554186d44b3abd65$var$__DEV__ = false;
var $554186d44b3abd65$var$warning = function() {};
if ($554186d44b3abd65$var$__DEV__) {
    var $554186d44b3abd65$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $554186d44b3abd65$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $554186d44b3abd65$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $554186d44b3abd65$var$warning;

});


parcelRegister("duUmg", function(module, exports) {

$parcel$export(module.exports, "Overlay2", () => $9d39cb451665766b$export$2e8e2c61dfd53893);
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $4OXLD = parcelRequire("4OXLD");
var $gbRGj = parcelRequire("gbRGj");

var $ieuVO = parcelRequire("ieuVO");

var $auzpd = parcelRequire("auzpd");
var $8k66C = parcelRequire("8k66C");

var $bzsu8 = parcelRequire("bzsu8");

var $hffzE = parcelRequire("hffzE");

var $4FOwp = parcelRequire("4FOwp");
var $lgubC = parcelRequire("lgubC");
var $8k66C = parcelRequire("8k66C");
var $h8UCV = parcelRequire("h8UCV");

var $lgubC = parcelRequire("lgubC");

var $iwaGK = parcelRequire("iwaGK");

var $lrF67 = parcelRequire("lrF67");

var $7hlBq = parcelRequire("7hlBq");

var $hpzrO = parcelRequire("hpzrO");
var $9d39cb451665766b$export$2e8e2c61dfd53893 = $8NFma.forwardRef(function(props, forwardedRef) {
    var _a;
    var _b, _c;
    var autoFocus = props.autoFocus, backdropClassName = props.backdropClassName, backdropProps = props.backdropProps, canEscapeKeyClose = props.canEscapeKeyClose, canOutsideClickClose = props.canOutsideClickClose, childRef = props.childRef, childRefs = props.childRefs, children = props.children, className = props.className, enforceFocus = props.enforceFocus, hasBackdrop = props.hasBackdrop, isOpen = props.isOpen, lazy = props.lazy, onClose = props.onClose, onClosed = props.onClosed, onClosing = props.onClosing, onOpened = props.onOpened, onOpening = props.onOpening, portalClassName = props.portalClassName, portalContainer = props.portalContainer, shouldReturnFocusOnClose = props.shouldReturnFocusOnClose, transitionDuration = props.transitionDuration, transitionName = props.transitionName, usePortal = props.usePortal;
    $9d39cb451665766b$var$useOverlay2Validation(props);
    var _d = (0, $iwaGK.useOverlayStack)(), closeOverlay = _d.closeOverlay, getLastOpened = _d.getLastOpened, getThisOverlayAndDescendants = _d.getThisOverlayAndDescendants, openOverlay = _d.openOverlay;
    var _e = $8NFma.useState(false), isAutoFocusing = _e[0], setIsAutoFocusing = _e[1];
    var _f = $8NFma.useState(false), hasEverOpened = _f[0], setHasEverOpened = _f[1];
    var lastActiveElementBeforeOpened = $8NFma.useRef(null);
    /** Ref for container element, containing all children and the backdrop */ var containerElement = $8NFma.useRef(null);
    /** Ref for backdrop element */ var backdropElement = $8NFma.useRef(null);
    /* An empty, keyboard-focusable div at the beginning of the Overlay content */ var startFocusTrapElement = $8NFma.useRef(null);
    /* An empty, keyboard-focusable div at the end of the Overlay content */ var endFocusTrapElement = $8NFma.useRef(null);
    /**
     * Locally-generated DOM ref for a singleton child element.
     * This is only used iff the user does not specify the `childRef` or `childRefs` props.
     */ var localChildRef = $8NFma.useRef(null);
    var bringFocusInsideOverlay = $8NFma.useCallback(function() {
        // always delay focus manipulation to just before repaint to prevent scroll jumping
        return requestAnimationFrame(function() {
            var _a;
            // container element may be undefined between component mounting and Portal rendering
            // activeElement may be undefined in some rare cases in IE
            var container = (0, $8k66C.getRef)(containerElement);
            var activeElement = (0, $lgubC.getActiveElement)(container);
            if (container == null || activeElement == null) return;
            // Overlay2 is guaranteed to be mounted here
            var isFocusOutsideModal = !container.contains(activeElement);
            if (isFocusOutsideModal) {
                (_a = (0, $8k66C.getRef)(startFocusTrapElement)) === null || _a === void 0 || _a.focus({
                    preventScroll: true
                });
                setIsAutoFocusing(false);
            }
        });
    }, []);
    /** Unique ID for this overlay in the global stack */ var id = $9d39cb451665766b$var$useOverlay2ID();
    // N.B. use `null` here and not simply `undefined` because `useImperativeHandle` will set `null` on unmount,
    // and we need the following code to be resilient to that value.
    var instance = $8NFma.useRef(null);
    /**
     * When multiple `enforceFocus` Overlays are open, this event handler is only active for the most
     * recently opened one to avoid Overlays competing with each other for focus.
     */ var handleDocumentFocus = $8NFma.useCallback(function(e) {
        // get the actual target even in the Shadow DOM
        // see https://github.com/palantir/blueprint/issues/4220
        var eventTarget = e.composed ? e.composedPath()[0] : e.target;
        var container = (0, $8k66C.getRef)(containerElement);
        if (container != null && eventTarget instanceof Node && !container.contains(eventTarget)) {
            // prevent default focus behavior (sometimes auto-scrolls the page)
            e.preventDefault();
            e.stopImmediatePropagation();
            bringFocusInsideOverlay();
        }
    }, [
        bringFocusInsideOverlay
    ]);
    // N.B. this listener is only kept attached when `isOpen={true}` and `canOutsideClickClose={true}`
    var handleDocumentMousedown = $8NFma.useCallback(function(e) {
        // get the actual target even in the Shadow DOM
        // see https://github.com/palantir/blueprint/issues/4220
        var eventTarget = e.composed ? e.composedPath()[0] : e.target;
        var thisOverlayAndDescendants = getThisOverlayAndDescendants(id);
        var isClickInThisOverlayOrDescendant = thisOverlayAndDescendants.some(function(_a) {
            var containerRef = _a.containerElement;
            // `elem` is the container of backdrop & content, so clicking directly on that container
            // should not count as being "inside" the overlay.
            var elem = (0, $8k66C.getRef)(containerRef);
            return (elem === null || elem === void 0 ? void 0 : elem.contains(eventTarget)) && !elem.isSameNode(eventTarget);
        });
        if (!isClickInThisOverlayOrDescendant) // casting to any because this is a native event
        onClose === null || onClose === void 0 || onClose(e);
    }, [
        getThisOverlayAndDescendants,
        id,
        onClose
    ]);
    // Important: clean up old document-level event listeners if their memoized values change (this is rare, but
    // may happen, for example, if a user forgets to use `React.useCallback` in the `props.onClose` value).
    // Otherwise, we will lose the reference to those values and create a memory leak since we won't be able
    // to successfully detach them inside overlayWillClose.
    $8NFma.useEffect(function() {
        document.removeEventListener("mousedown", handleDocumentMousedown);
    }, [
        handleDocumentMousedown
    ]);
    $8NFma.useEffect(function() {
        document.removeEventListener("focus", handleDocumentFocus, /* useCapture */ true);
    }, [
        handleDocumentFocus
    ]);
    // send this instance's imperative handle to the the forwarded ref as well as our local ref
    var ref = $8NFma.useMemo(function() {
        return (0, $8k66C.mergeRefs)(forwardedRef, instance);
    }, [
        forwardedRef
    ]);
    $8NFma.useImperativeHandle(ref, function() {
        return {
            bringFocusInsideOverlay: bringFocusInsideOverlay,
            containerElement: containerElement,
            handleDocumentFocus: handleDocumentFocus,
            handleDocumentMousedown: handleDocumentMousedown,
            id: id,
            props: {
                autoFocus: autoFocus,
                enforceFocus: enforceFocus,
                hasBackdrop: hasBackdrop,
                usePortal: usePortal
            }
        };
    }, [
        autoFocus,
        bringFocusInsideOverlay,
        enforceFocus,
        handleDocumentFocus,
        handleDocumentMousedown,
        hasBackdrop,
        id,
        usePortal
    ]);
    var handleContainerKeyDown = $8NFma.useCallback(function(e) {
        if (e.key === "Escape" && canEscapeKeyClose) {
            onClose === null || onClose === void 0 || onClose(e);
            // prevent other overlays from closing
            e.stopPropagation();
            // prevent browser-specific escape key behavior (Safari exits fullscreen)
            e.preventDefault();
        }
    }, [
        canEscapeKeyClose,
        onClose
    ]);
    var overlayWillOpen = $8NFma.useCallback(function() {
        if (instance.current == null) return;
        var lastOpenedOverlay = getLastOpened();
        if ((lastOpenedOverlay === null || lastOpenedOverlay === void 0 ? void 0 : lastOpenedOverlay.handleDocumentFocus) !== undefined) document.removeEventListener("focus", lastOpenedOverlay.handleDocumentFocus, /* useCapture */ true);
        openOverlay(instance.current);
        if (autoFocus) {
            setIsAutoFocusing(true);
            bringFocusInsideOverlay();
        }
        if (enforceFocus) // Focus events do not bubble, but setting useCapture allows us to listen in and execute
        // our handler before all others
        document.addEventListener("focus", handleDocumentFocus, /* useCapture */ true);
        if (canOutsideClickClose && !hasBackdrop) document.addEventListener("mousedown", handleDocumentMousedown);
        (0, $8k66C.setRef)(lastActiveElementBeforeOpened, (0, $lgubC.getActiveElement)((0, $8k66C.getRef)(containerElement)));
    }, [
        autoFocus,
        bringFocusInsideOverlay,
        canOutsideClickClose,
        enforceFocus,
        getLastOpened,
        handleDocumentMousedown,
        handleDocumentFocus,
        hasBackdrop,
        openOverlay
    ]);
    var overlayWillClose = $8NFma.useCallback(function() {
        var _a;
        document.removeEventListener("focus", handleDocumentFocus, /* useCapture */ true);
        document.removeEventListener("mousedown", handleDocumentMousedown);
        // N.B. `instance.current` may be null at this point if we are cleaning up an open overlay during the unmount phase
        // (this is common, for example, with context menu's singleton `showContextMenu` / `hideContextMenu` imperative APIs).
        closeOverlay(id);
        var lastOpenedOverlay = getLastOpened();
        if (lastOpenedOverlay !== undefined) // Only bring focus back to last overlay if it had autoFocus _and_ enforceFocus enabled.
        // If `autoFocus={false}`, it's likely that the overlay never received focus in the first place,
        // so it would be surprising for us to send it there. See https://github.com/palantir/blueprint/issues/4921
        {
            if (lastOpenedOverlay.props.autoFocus && lastOpenedOverlay.props.enforceFocus) {
                (_a = lastOpenedOverlay.bringFocusInsideOverlay) === null || _a === void 0 || _a.call(lastOpenedOverlay);
                if (lastOpenedOverlay.handleDocumentFocus !== undefined) document.addEventListener("focus", lastOpenedOverlay.handleDocumentFocus, /* useCapture */ true);
            }
        }
    }, [
        closeOverlay,
        getLastOpened,
        handleDocumentFocus,
        handleDocumentMousedown,
        id
    ]);
    var prevIsOpen = (_b = (0, $lrF67.usePrevious)(isOpen)) !== null && _b !== void 0 ? _b : false;
    $8NFma.useEffect(function() {
        if (isOpen) setHasEverOpened(true);
        if (!prevIsOpen && isOpen) // just opened
        overlayWillOpen();
        if (prevIsOpen && !isOpen) // just closed
        overlayWillClose();
    }, [
        isOpen,
        overlayWillOpen,
        overlayWillClose,
        prevIsOpen
    ]);
    // run once on unmount
    $8NFma.useEffect(function() {
        return function() {
            if (isOpen) // if the overlay is still open, we need to run cleanup code to remove some event handlers
            overlayWillClose();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var handleTransitionExited = $8NFma.useCallback(function(node) {
        var lastActiveElement = (0, $8k66C.getRef)(lastActiveElementBeforeOpened);
        if (shouldReturnFocusOnClose && lastActiveElement instanceof HTMLElement) lastActiveElement.focus();
        onClosed === null || onClosed === void 0 || onClosed(node);
    }, [
        onClosed,
        shouldReturnFocusOnClose
    ]);
    // N.B. CSSTransition requires this callback to be defined, even if it's unused.
    var handleTransitionAddEnd = $8NFma.useCallback(function() {
    // no-op
    }, []);
    /**
     * Gets the relevant DOM ref for a child element using the `childRef` or `childRefs` props (if possible).
     * This ref is necessary for `CSSTransition` to work in React 18 without relying on `ReactDOM.findDOMNode`.
     *
     * Returns `undefined` if the user did not specify either of those props. In those cases, we use the ref we
     * have locally generated and expect that the user _did not_ specify their own `ref` on the child element
     * (it will get clobbered / overriden).
     *
     * @see https://reactcommunity.org/react-transition-group/css-transition
     */ var getUserChildRef = $8NFma.useCallback(function(child) {
        if (childRef != null) return childRef;
        else if (childRefs != null) {
            var key = child.key;
            if (key == null) {
                if (!(0, $h8UCV.isNodeEnv)("production")) console.error((0, $bzsu8.OVERLAY_CHILD_REQUIRES_KEY));
                return undefined;
            }
            return childRefs[key];
        }
        return undefined;
    }, [
        childRef,
        childRefs
    ]);
    var maybeRenderChild = $8NFma.useCallback(function(child) {
        if (child == null || (0, $h8UCV.isEmptyString)(child)) return null;
        // decorate the child with a few injected props
        var userChildRef = getUserChildRef(child);
        var childProps = (0, $4FOwp.isReactElement)(child) ? child.props : {};
        // if the child is a string, number, or fragment, it will be wrapped in a <span> element
        var decoratedChild = (0, $4FOwp.ensureElement)(child, "span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(childProps.className, (0, $auzpd).OVERLAY_CONTENT),
            // IMPORTANT: only inject our ref if the user didn't specify childRef or childRefs already. Otherwise,
            // we risk clobbering the user's ref (which we cannot inspect here while cloning/decorating the child).
            ref: userChildRef === undefined ? localChildRef : undefined,
            tabIndex: enforceFocus || autoFocus ? 0 : undefined
        });
        var resolvedChildRef = userChildRef !== null && userChildRef !== void 0 ? userChildRef : localChildRef;
        return $8NFma.createElement((0, $4OXLD.default), {
            addEndListener: handleTransitionAddEnd,
            classNames: transitionName,
            // HACKHACK: CSSTransition types are slightly incompatible with React types here.
            // React prefers `| null` but not `| undefined` for the ref value, while
            // CSSTransition _demands_ that `| undefined` be part of the element type.
            nodeRef: resolvedChildRef,
            onEntered: $9d39cb451665766b$var$getLifecycleCallbackWithChildRef(onOpened, resolvedChildRef),
            onEntering: $9d39cb451665766b$var$getLifecycleCallbackWithChildRef(onOpening, resolvedChildRef),
            onExited: $9d39cb451665766b$var$getLifecycleCallbackWithChildRef(handleTransitionExited, resolvedChildRef),
            onExiting: $9d39cb451665766b$var$getLifecycleCallbackWithChildRef(onClosing, resolvedChildRef),
            timeout: transitionDuration
        }, decoratedChild);
    }, [
        autoFocus,
        enforceFocus,
        getUserChildRef,
        handleTransitionAddEnd,
        handleTransitionExited,
        onClosing,
        onOpened,
        onOpening,
        transitionDuration,
        transitionName
    ]);
    var handleBackdropMouseDown = $8NFma.useCallback(function(e) {
        var _a;
        if (canOutsideClickClose) onClose === null || onClose === void 0 || onClose(e);
        if (enforceFocus) bringFocusInsideOverlay();
        (_a = backdropProps === null || backdropProps === void 0 ? void 0 : backdropProps.onMouseDown) === null || _a === void 0 || _a.call(backdropProps, e);
    }, [
        backdropProps,
        bringFocusInsideOverlay,
        canOutsideClickClose,
        enforceFocus,
        onClose
    ]);
    var renderDummyElement = $8NFma.useCallback(function(key, dummyElementProps) {
        return $8NFma.createElement((0, $4OXLD.default), {
            addEndListener: handleTransitionAddEnd,
            classNames: transitionName,
            key: key,
            nodeRef: dummyElementProps.ref,
            timeout: transitionDuration,
            unmountOnExit: true
        }, $8NFma.createElement("div", (0, $gztBd.__assign)({
            tabIndex: 0
        }, dummyElementProps)));
    }, [
        handleTransitionAddEnd,
        transitionDuration,
        transitionName
    ]);
    /**
     * Ensures repeatedly pressing shift+tab keeps focus inside the Overlay. Moves focus to
     * the `endFocusTrapElement` or the first keyboard-focusable element in the Overlay (excluding
     * the `startFocusTrapElement`), depending on whether the element losing focus is inside the
     * Overlay.
     */ var handleStartFocusTrapElementFocus = $8NFma.useCallback(function(e) {
        if (!enforceFocus || isAutoFocusing) return;
        // e.relatedTarget will not be defined if this was a programmatic focus event, as is the
        // case when we call this.bringFocusInsideOverlay() after a user clicked on the backdrop.
        // Otherwise, we're handling a user interaction, and we should wrap around to the last
        // element in this transition group.
        var container = (0, $8k66C.getRef)(containerElement);
        var endFocusTrap = (0, $8k66C.getRef)(endFocusTrapElement);
        if (e.relatedTarget != null && (container === null || container === void 0 ? void 0 : container.contains(e.relatedTarget)) && e.relatedTarget !== endFocusTrap) endFocusTrap === null || endFocusTrap === void 0 || endFocusTrap.focus({
            preventScroll: true
        });
    }, [
        enforceFocus,
        isAutoFocusing
    ]);
    /**
     * Wrap around to the end of the dialog if `enforceFocus` is enabled.
     */ var handleStartFocusTrapElementKeyDown = $8NFma.useCallback(function(e) {
        var _a;
        if (!enforceFocus) return;
        if (e.shiftKey && e.key === "Tab") {
            var lastFocusableElement = (0, $7hlBq.getKeyboardFocusableElements)(containerElement).pop();
            if (lastFocusableElement != null) lastFocusableElement.focus();
            else (_a = (0, $8k66C.getRef)(endFocusTrapElement)) === null || _a === void 0 || _a.focus({
                preventScroll: true
            });
        }
    }, [
        enforceFocus
    ]);
    /**
     * Ensures repeatedly pressing tab keeps focus inside the Overlay. Moves focus to the
     * `startFocusTrapElement` or the last keyboard-focusable element in the Overlay (excluding the
     * `startFocusTrapElement`), depending on whether the element losing focus is inside the
     * Overlay.
     */ var handleEndFocusTrapElementFocus = $8NFma.useCallback(function(e) {
        var _a;
        // No need for this.props.enforceFocus check here because this element is only rendered
        // when that prop is true.
        // During user interactions, e.relatedTarget will be defined, and we should wrap around to the
        // "start focus trap" element.
        // Otherwise, we're handling a programmatic focus event, which can only happen after a user
        // presses shift+tab from the first focusable element in the overlay.
        var startFocusTrap = (0, $8k66C.getRef)(startFocusTrapElement);
        if (e.relatedTarget != null && ((_a = (0, $8k66C.getRef)(containerElement)) === null || _a === void 0 ? void 0 : _a.contains(e.relatedTarget)) && e.relatedTarget !== startFocusTrap) {
            var firstFocusableElement = (0, $7hlBq.getKeyboardFocusableElements)(containerElement).shift();
            // ensure we don't re-focus an already active element by comparing against e.relatedTarget
            if (!isAutoFocusing && firstFocusableElement != null && firstFocusableElement !== e.relatedTarget) firstFocusableElement.focus();
            else startFocusTrap === null || startFocusTrap === void 0 || startFocusTrap.focus({
                preventScroll: true
            });
        } else {
            var lastFocusableElement = (0, $7hlBq.getKeyboardFocusableElements)(containerElement).pop();
            if (lastFocusableElement != null) lastFocusableElement.focus();
            else // Keeps focus within Overlay even if there are no keyboard-focusable children
            startFocusTrap === null || startFocusTrap === void 0 || startFocusTrap.focus({
                preventScroll: true
            });
        }
    }, [
        isAutoFocusing
    ]);
    var maybeBackdrop = $8NFma.useMemo(function() {
        return hasBackdrop && isOpen ? $8NFma.createElement((0, $4OXLD.default), {
            classNames: transitionName,
            key: "__backdrop",
            nodeRef: backdropElement,
            timeout: transitionDuration,
            addEndListener: handleTransitionAddEnd
        }, $8NFma.createElement("div", (0, $gztBd.__assign)({}, backdropProps, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $auzpd).OVERLAY_BACKDROP, backdropClassName, backdropProps === null || backdropProps === void 0 ? void 0 : backdropProps.className),
            onMouseDown: handleBackdropMouseDown,
            ref: backdropElement
        }))) : null;
    }, [
        backdropClassName,
        backdropProps,
        handleBackdropMouseDown,
        handleTransitionAddEnd,
        hasBackdrop,
        isOpen,
        transitionDuration,
        transitionName
    ]);
    // no reason to render anything at all if we're being truly lazy
    if (lazy && !hasEverOpened) return null;
    // TransitionGroup types require single array of children; does not support nested arrays.
    // So we must collapse backdrop and children into one array, and every item must be wrapped in a
    // Transition element (no ReactText allowed).
    var childrenWithTransitions = isOpen ? (_c = $8NFma.Children.map(children, maybeRenderChild)) !== null && _c !== void 0 ? _c : [] : [];
    // const maybeBackdrop = maybeRenderBackdrop();
    if (maybeBackdrop !== null) childrenWithTransitions.unshift(maybeBackdrop);
    if (isOpen && (autoFocus || enforceFocus) && childrenWithTransitions.length > 0) {
        childrenWithTransitions.unshift(renderDummyElement("__start", {
            className: (0, $auzpd).OVERLAY_START_FOCUS_TRAP,
            onFocus: handleStartFocusTrapElementFocus,
            onKeyDown: handleStartFocusTrapElementKeyDown,
            ref: startFocusTrapElement
        }));
        if (enforceFocus) childrenWithTransitions.push(renderDummyElement("__end", {
            className: (0, $auzpd).OVERLAY_END_FOCUS_TRAP,
            onFocus: handleEndFocusTrapElementFocus,
            ref: endFocusTrapElement
        }));
    }
    var transitionGroup = $8NFma.createElement("div", {
        "aria-live": "polite",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $auzpd).OVERLAY, (_a = {}, _a[(0, $auzpd).OVERLAY_OPEN] = isOpen, _a[(0, $auzpd).OVERLAY_INLINE] = !usePortal, _a), className),
        onKeyDown: handleContainerKeyDown,
        ref: containerElement
    }, $8NFma.createElement((0, $gbRGj.default), {
        appear: true,
        component: null
    }, childrenWithTransitions));
    if (usePortal) return $8NFma.createElement((0, $hpzrO.Portal), {
        className: portalClassName,
        container: portalContainer
    }, transitionGroup);
    else return transitionGroup;
});
$9d39cb451665766b$export$2e8e2c61dfd53893.defaultProps = {
    autoFocus: true,
    backdropProps: {},
    canEscapeKeyClose: true,
    canOutsideClickClose: true,
    enforceFocus: true,
    hasBackdrop: true,
    isOpen: false,
    lazy: (0, $lgubC.hasDOMEnvironment)(),
    shouldReturnFocusOnClose: true,
    transitionDuration: 300,
    transitionName: (0, $auzpd).OVERLAY,
    usePortal: true
};
$9d39cb451665766b$export$2e8e2c61dfd53893.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".Overlay2");
function $9d39cb451665766b$var$useOverlay2Validation(_a) {
    var childRef = _a.childRef, childRefs = _a.childRefs, children = _a.children;
    var numChildren = $8NFma.Children.count(children);
    $8NFma.useEffect(function() {
        if ((0, $h8UCV.isNodeEnv)("production")) return;
        if (childRef != null && childRefs != null) console.error((0, $bzsu8.OVERLAY_CHILD_REF_AND_REFS_MUTEX));
        if (numChildren > 1 && childRefs == null) console.error((0, $bzsu8.OVERLAY_WITH_MULTIPLE_CHILDREN_REQUIRES_CHILD_REFS));
    }, [
        childRef,
        childRefs,
        numChildren
    ]);
}
/**
 * Generates a unique ID for a given Overlay which persists across the component's lifecycle.
 */ function $9d39cb451665766b$var$useOverlay2ID() {
    // TODO: migrate to React.useId() in React 18
    var id = (0, $ieuVO.useUID)();
    return "".concat($9d39cb451665766b$export$2e8e2c61dfd53893.displayName, "-").concat(id);
}
// N.B. the `onExiting` callback is not provided with the `node` argument as suggested in CSSTransition types since
// we are using the `nodeRef` prop, so we must inject it dynamically.
function $9d39cb451665766b$var$getLifecycleCallbackWithChildRef(callback, childRef) {
    return function() {
        if ((childRef === null || childRef === void 0 ? void 0 : childRef.current) != null) callback === null || callback === void 0 || callback(childRef.current);
    };
}

});
parcelRegister("4OXLD", function(module, exports) {

$parcel$export(module.exports, "default", () => $382a3175b1b632fd$export$2e2bcd8739ae039);

var $jz4iA = parcelRequire("jz4iA");

var $hQtye = parcelRequire("hQtye");

var $gvoty = parcelRequire("gvoty");


var $haMLY = parcelRequire("haMLY");

var $8dZJo = parcelRequire("8dZJo");

var $8NFma = parcelRequire("8NFma");

var $4Z1kj = parcelRequire("4Z1kj");


var $fM6fj = parcelRequire("fM6fj");
var $382a3175b1b632fd$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $haMLY.default)(node, c);
    });
};
var $382a3175b1b632fd$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $8dZJo.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $382a3175b1b632fd$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $gvoty.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, "exit");
            _this.addClass(node, appearing ? "appear" : "enter", "base");
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? "appear" : "enter";
            _this.addClass(node, type, "active");
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? "appear" : "enter";
            _this.removeClasses(node, type);
            _this.addClass(node, type, "done");
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, "appear");
            _this.removeClasses(node, "enter");
            _this.addClass(node, "exit", "base");
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, "exit", "active");
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, "exit");
            _this.addClass(node, "exit", "done");
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === "string";
            var prefix = isStringClassNames && classNames ? classNames + "-" : "";
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames("enter"), doneClassName = _this$getClassNames.doneClassName;
        if (type === "appear" && phase === "done" && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === "active") {
            if (node) (0, $fM6fj.forceReflow)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $382a3175b1b632fd$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $382a3175b1b632fd$var$removeClass(node, baseClassName);
        if (activeClassName) $382a3175b1b632fd$var$removeClass(node, activeClassName);
        if (doneClassName) $382a3175b1b632fd$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $hQtye.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $4Z1kj.default), (0, $jz4iA.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component);
$382a3175b1b632fd$var$CSSTransition.defaultProps = {
    classNames: ""
};
$382a3175b1b632fd$var$CSSTransition.propTypes = {};
var $382a3175b1b632fd$export$2e2bcd8739ae039 = $382a3175b1b632fd$var$CSSTransition;

});
parcelRegister("jz4iA", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3e49ed681292e30$export$2e2bcd8739ae039);
function $e3e49ed681292e30$export$2e2bcd8739ae039() {
    $e3e49ed681292e30$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e3e49ed681292e30$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("hQtye", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfde373be945f92b$export$2e2bcd8739ae039);
function $cfde373be945f92b$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRegister("gvoty", function(module, exports) {

$parcel$export(module.exports, "default", () => $c04286edcac4109a$export$2e2bcd8739ae039);

var $5zL6F = parcelRequire("5zL6F");
function $c04286edcac4109a$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $5zL6F.default)(subClass, superClass);
}

});
parcelRegister("5zL6F", function(module, exports) {

$parcel$export(module.exports, "default", () => $40f4c2feb843f2da$export$2e2bcd8739ae039);
function $40f4c2feb843f2da$export$2e2bcd8739ae039(o, p) {
    $40f4c2feb843f2da$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $40f4c2feb843f2da$export$2e2bcd8739ae039(o, p);
}

});


parcelRegister("haMLY", function(module, exports) {

$parcel$export(module.exports, "default", () => $c809341340fce654$export$2e2bcd8739ae039);

var $hdXrI = parcelRequire("hdXrI");
function $c809341340fce654$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $hdXrI.default)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}

});
parcelRegister("hdXrI", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8a1c34a06a8c397$export$2e2bcd8739ae039);
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $c8a1c34a06a8c397$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

});


parcelRegister("8dZJo", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fcf6c25c378978d$export$2e2bcd8739ae039);
function $5fcf6c25c378978d$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function $5fcf6c25c378978d$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $5fcf6c25c378978d$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $5fcf6c25c378978d$var$replaceClassName(element.className && element.className.baseVal || "", className));
}

});

parcelRegister("4Z1kj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a0de358fcee31a7$export$2e2bcd8739ae039);

var $hQtye = parcelRequire("hQtye");

var $gvoty = parcelRequire("gvoty");


var $8NFma = parcelRequire("8NFma");

var $2pmb0 = parcelRequire("2pmb0");

var $adZnW = parcelRequire("adZnW");


var $6uueD = parcelRequire("6uueD");

var $fM6fj = parcelRequire("fM6fj");
var $3a0de358fcee31a7$export$bb38bb9a1161268 = "unmounted";
var $3a0de358fcee31a7$export$84cbff306f539230 = "exited";
var $3a0de358fcee31a7$export$df38205c966be359 = "entering";
var $3a0de358fcee31a7$export$78e9e6e3e014d60a = "entered";
var $3a0de358fcee31a7$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $3a0de358fcee31a7$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $gvoty.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $3a0de358fcee31a7$export$84cbff306f539230;
                _this.appearStatus = $3a0de358fcee31a7$export$df38205c966be359;
            } else initialStatus = $3a0de358fcee31a7$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $3a0de358fcee31a7$export$bb38bb9a1161268;
        else initialStatus = $3a0de358fcee31a7$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $3a0de358fcee31a7$export$bb38bb9a1161268) return {
            status: $3a0de358fcee31a7$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $3a0de358fcee31a7$export$df38205c966be359 && status !== $3a0de358fcee31a7$export$78e9e6e3e014d60a) nextStatus = $3a0de358fcee31a7$export$df38205c966be359;
            } else if (status === $3a0de358fcee31a7$export$df38205c966be359 || status === $3a0de358fcee31a7$export$78e9e6e3e014d60a) nextStatus = $3a0de358fcee31a7$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $3a0de358fcee31a7$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($2pmb0))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $fM6fj.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $3a0de358fcee31a7$export$84cbff306f539230) this.setState({
            status: $3a0de358fcee31a7$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($2pmb0))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $adZnW.default).disabled) {
            this.safeSetState({
                status: $3a0de358fcee31a7$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $3a0de358fcee31a7$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $3a0de358fcee31a7$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($2pmb0))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $adZnW.default).disabled) {
            this.safeSetState({
                status: $3a0de358fcee31a7$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $3a0de358fcee31a7$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $3a0de358fcee31a7$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($2pmb0))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $3a0de358fcee31a7$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $hQtye.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $6uueD.default).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component);
$3a0de358fcee31a7$var$Transition.contextType = (0, $6uueD.default);
$3a0de358fcee31a7$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $3a0de358fcee31a7$var$noop() {}
$3a0de358fcee31a7$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $3a0de358fcee31a7$var$noop,
    onEntering: $3a0de358fcee31a7$var$noop,
    onEntered: $3a0de358fcee31a7$var$noop,
    onExit: $3a0de358fcee31a7$var$noop,
    onExiting: $3a0de358fcee31a7$var$noop,
    onExited: $3a0de358fcee31a7$var$noop
};
$3a0de358fcee31a7$var$Transition.UNMOUNTED = $3a0de358fcee31a7$export$bb38bb9a1161268;
$3a0de358fcee31a7$var$Transition.EXITED = $3a0de358fcee31a7$export$84cbff306f539230;
$3a0de358fcee31a7$var$Transition.ENTERING = $3a0de358fcee31a7$export$df38205c966be359;
$3a0de358fcee31a7$var$Transition.ENTERED = $3a0de358fcee31a7$export$78e9e6e3e014d60a;
$3a0de358fcee31a7$var$Transition.EXITING = $3a0de358fcee31a7$export$4aacc83d4d59139f;
var $3a0de358fcee31a7$export$2e2bcd8739ae039 = $3a0de358fcee31a7$var$Transition;

});
parcelRegister("adZnW", function(module, exports) {

$parcel$export(module.exports, "default", () => $771abc1b9c3ac5e0$export$2e2bcd8739ae039);
var $771abc1b9c3ac5e0$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("6uueD", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b9cff7e01ef990e$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");
var $4b9cff7e01ef990e$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createContext(null);

});

parcelRegister("fM6fj", function(module, exports) {

$parcel$export(module.exports, "forceReflow", () => $b7c02f0ad3191e79$export$7d26bbb1236dafd6);
var $b7c02f0ad3191e79$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});



parcelRegister("gbRGj", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc975070b4f3fc58$export$2e2bcd8739ae039);

var $hQtye = parcelRequire("hQtye");

var $jz4iA = parcelRequire("jz4iA");

var $1oVxX = parcelRequire("1oVxX");

var $gvoty = parcelRequire("gvoty");


var $8NFma = parcelRequire("8NFma");

var $6uueD = parcelRequire("6uueD");

var $gZV0l = parcelRequire("gZV0l");
var $bc975070b4f3fc58$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $bc975070b4f3fc58$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $bc975070b4f3fc58$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $gvoty.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $1oVxX.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $gZV0l.getInitialChildMapping)(nextProps, handleExited) : (0, $gZV0l.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $gZV0l.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $jz4iA.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $hQtye.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $bc975070b4f3fc58$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $6uueD.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $6uueD.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component);
$bc975070b4f3fc58$var$TransitionGroup.propTypes = {};
$bc975070b4f3fc58$var$TransitionGroup.defaultProps = $bc975070b4f3fc58$var$defaultProps;
var $bc975070b4f3fc58$export$2e2bcd8739ae039 = $bc975070b4f3fc58$var$TransitionGroup;

});
parcelRegister("1oVxX", function(module, exports) {

$parcel$export(module.exports, "default", () => $1054abeafa6bc7e1$export$2e2bcd8739ae039);
function $1054abeafa6bc7e1$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("gZV0l", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", () => $c5fe8fc78c4704a1$export$bbc8a025727ea824);
$parcel$export(module.exports, "getInitialChildMapping", () => $c5fe8fc78c4704a1$export$fa71e2345c31d7a2);
$parcel$export(module.exports, "getNextChildMapping", () => $c5fe8fc78c4704a1$export$36fd1af28d383ec0);

var $8NFma = parcelRequire("8NFma");
function $c5fe8fc78c4704a1$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $8NFma.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $8NFma.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $c5fe8fc78c4704a1$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $c5fe8fc78c4704a1$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $c5fe8fc78c4704a1$export$fa71e2345c31d7a2(props, onExited) {
    return $c5fe8fc78c4704a1$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $8NFma.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $c5fe8fc78c4704a1$var$getProp(child, "appear", props),
            enter: $c5fe8fc78c4704a1$var$getProp(child, "enter", props),
            exit: $c5fe8fc78c4704a1$var$getProp(child, "exit", props)
        });
    });
}
function $c5fe8fc78c4704a1$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $c5fe8fc78c4704a1$export$bbc8a025727ea824(nextProps.children);
    var children = $c5fe8fc78c4704a1$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $8NFma.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $8NFma.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $8NFma.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $c5fe8fc78c4704a1$var$getProp(child, "exit", nextProps),
            enter: $c5fe8fc78c4704a1$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $8NFma.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $8NFma.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $8NFma.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $c5fe8fc78c4704a1$var$getProp(child, "exit", nextProps),
            enter: $c5fe8fc78c4704a1$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}

});


parcelRegister("ieuVO", function(module, exports) {

$parcel$export(module.exports, "useUID", () => $d4618726f9dead0d$export$87d05f07e65211f1);

var $8NFma = parcelRequire("8NFma");

var $etg8x = parcelRequire("etg8x");
var $d4618726f9dead0d$var$generateUID = function(context) {
    var quartz = context || (0, $etg8x.counter);
    var prefix = (0, $etg8x.getPrefix)(quartz);
    var id = (0, $etg8x.getId)(quartz);
    var uid = prefix + id;
    var gen = function(item) {
        return uid + quartz.uid(item);
    };
    return {
        uid: uid,
        gen: gen
    };
};
var $d4618726f9dead0d$var$useUIDState = function() {
    var context = (0, $8NFma.useContext)((0, $etg8x.source));
    var uid = (0, $8NFma.useState)(function() {
        return $d4618726f9dead0d$var$generateUID(context);
    })[0];
    return uid;
};
var $d4618726f9dead0d$export$87d05f07e65211f1 = function() {
    var uid = $d4618726f9dead0d$var$useUIDState().uid;
    return uid;
};
var $d4618726f9dead0d$export$bb5ca5fba6fb4f1f = function() {
    var gen = $d4618726f9dead0d$var$useUIDState().gen;
    return gen;
};

});
parcelRegister("etg8x", function(module, exports) {

$parcel$export(module.exports, "counter", () => $a8904a8654d6680b$export$e575061ef2a070eb);
$parcel$export(module.exports, "source", () => $a8904a8654d6680b$export$b4d5da5f34fb77ad);
$parcel$export(module.exports, "getId", () => $a8904a8654d6680b$export$218c8c3169c024d2);
$parcel$export(module.exports, "getPrefix", () => $a8904a8654d6680b$export$36e24695f02d4503);

var $8NFma = parcelRequire("8NFma");

var $hH42X = parcelRequire("hH42X");
var $a8904a8654d6680b$export$1921362e86c73c88 = function(prefix) {
    if (prefix === void 0) prefix = "";
    return {
        value: 1,
        prefix: prefix,
        uid: (0, $hH42X.generateUID)()
    };
};
var $a8904a8654d6680b$export$e575061ef2a070eb = $a8904a8654d6680b$export$1921362e86c73c88();
var $a8904a8654d6680b$export$b4d5da5f34fb77ad = $8NFma.createContext($a8904a8654d6680b$export$1921362e86c73c88());
var $a8904a8654d6680b$export$218c8c3169c024d2 = function(source) {
    return source.value++;
};
var $a8904a8654d6680b$export$36e24695f02d4503 = function(source) {
    return source ? source.prefix : "";
};

});
parcelRegister("hH42X", function(module, exports) {

$parcel$export(module.exports, "generateUID", () => $ce19976f06eea598$export$bdbb4cbb3078e58d);
/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */ var $ce19976f06eea598$export$bdbb4cbb3078e58d = function() {
    var counter = 1;
    var map = new WeakMap();
    /**
     * @borrows {uid}
     */ var uid = function(item, index) {
        if (typeof item === "number" || typeof item === "string") return index ? "idx-".concat(index) : "val-".concat(item);
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return "uid" + map.get(item);
    };
    return uid;
};
var $ce19976f06eea598$export$e2a22331486dcca0 = $ce19976f06eea598$export$bdbb4cbb3078e58d();

});



parcelRegister("iwaGK", function(module, exports) {

$parcel$export(module.exports, "useOverlayStack", () => $d7b381ad0c845753$export$b9eca684780184d5);
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $8NFma = parcelRequire("8NFma");

var $auzpd = parcelRequire("auzpd");

var $bzsu8 = parcelRequire("bzsu8");

var $h8UCV = parcelRequire("h8UCV");

var $f7xro = parcelRequire("f7xro");

var $43gZw = parcelRequire("43gZw");
function $d7b381ad0c845753$export$b9eca684780184d5() {
    // get the overlay stack from application-wide React context
    var _a = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useContext((0, $f7xro.OverlaysContext)), stack = _a.stack, hasProvider = _a.hasProvider;
    var legacyOverlayStack = (0, $43gZw.useLegacyOverlayStack)();
    var getLastOpened = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useCallback(function() {
        return stack.current.at(-1);
    }, [
        stack
    ]);
    var getThisOverlayAndDescendants = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useCallback(function(id) {
        var index = stack.current.findIndex(function(o) {
            return o.id === id;
        });
        if (index === -1) return [];
        return stack.current.slice(index);
    }, [
        stack
    ]);
    var resetStack = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useCallback(function() {
        stack.current = [];
    }, [
        stack
    ]);
    var openOverlay = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useCallback(function(overlay) {
        stack.current.push(overlay);
        if (overlay.props.usePortal && overlay.props.hasBackdrop) // add a class to the body to prevent scrolling of content below the overlay
        document.body.classList.add((0, $auzpd).OVERLAY_OPEN);
    }, [
        stack
    ]);
    var closeOverlay = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useCallback(function(id) {
        var otherOverlaysWithBackdrop = stack.current.filter(function(o) {
            return o.props.usePortal && o.props.hasBackdrop && o.id !== id;
        });
        var index = stack.current.findIndex(function(o) {
            return o.id === id;
        });
        if (index > -1) stack.current.splice(index, 1);
        if (otherOverlaysWithBackdrop.length === 0) // remove body class which prevents scrolling of content below overlay
        document.body.classList.remove((0, $auzpd).OVERLAY_OPEN);
    }, [
        stack
    ]);
    if (!hasProvider) {
        if ((0, $h8UCV.isNodeEnv)("development")) console.error((0, $bzsu8.OVERLAY2_REQUIRES_OVERLAY_PROVDER));
        return legacyOverlayStack;
    }
    return {
        closeOverlay: closeOverlay,
        getLastOpened: getLastOpened,
        getThisOverlayAndDescendants: getThisOverlayAndDescendants,
        openOverlay: openOverlay,
        resetStack: resetStack
    };
}

});
parcelRegister("f7xro", function(module, exports) {

$parcel$export(module.exports, "OverlaysContext", () => $b02173187bff931b$export$ffbb3c21604c2bde);
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $8NFma = parcelRequire("8NFma");
var $b02173187bff931b$export$ffbb3c21604c2bde = $8NFma.createContext({
    hasProvider: false,
    stack: {
        current: []
    }
});
var $b02173187bff931b$export$2e609a126d315e1b = function(_a) {
    var children = _a.children;
    var stack = $8NFma.useRef([]);
    var contextValue = $8NFma.useMemo(function() {
        return {
            hasProvider: true,
            stack: stack
        };
    }, [
        stack
    ]);
    return $8NFma.createElement($b02173187bff931b$export$ffbb3c21604c2bde.Provider, {
        value: contextValue
    }, children);
};

});

parcelRegister("43gZw", function(module, exports) {

$parcel$export(module.exports, "useLegacyOverlayStack", () => $2f349f58d3be1037$export$501bbf48543ad65d);
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $8NFma = parcelRequire("8NFma");

var $ck4pA = parcelRequire("ck4pA");

var $auzpd = parcelRequire("auzpd");
var $2f349f58d3be1037$var$globalStack = [];
var $2f349f58d3be1037$var$globalStackListeners = [];
var $2f349f58d3be1037$export$c93586c81c6b24b8 = function(fn) {
    fn($2f349f58d3be1037$var$globalStack);
    $2f349f58d3be1037$var$globalStackListeners.forEach(function(listener) {
        return listener();
    });
};
var $2f349f58d3be1037$var$legacyGlobalOverlayStackStore = {
    getSnapshot: function() {
        return $2f349f58d3be1037$var$globalStack;
    },
    subscribe: function(listener) {
        $2f349f58d3be1037$var$globalStackListeners.push(listener);
        return function() {
            var index = $2f349f58d3be1037$var$globalStackListeners.indexOf(listener);
            $2f349f58d3be1037$var$globalStackListeners.splice(index, 1);
        };
    }
};
function $2f349f58d3be1037$export$501bbf48543ad65d() {
    var stack = (0, $ck4pA.useSyncExternalStore)($2f349f58d3be1037$var$legacyGlobalOverlayStackStore.subscribe, $2f349f58d3be1037$var$legacyGlobalOverlayStackStore.getSnapshot, // server snapshot is the same as client snapshot
    $2f349f58d3be1037$var$legacyGlobalOverlayStackStore.getSnapshot);
    var getLastOpened = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useCallback(function() {
        return stack.at(-1);
    }, [
        stack
    ]);
    var getThisOverlayAndDescendants = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useCallback(function(id) {
        var stackIndex = stack.findIndex(function(o) {
            return o.id === id;
        });
        return stack.slice(stackIndex);
    }, [
        stack
    ]);
    var resetStack = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useCallback(function() {
        $2f349f58d3be1037$export$c93586c81c6b24b8(function(s) {
            return s.splice(0, s.length);
        });
    }, []);
    var openOverlay = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useCallback(function(overlay) {
        $2f349f58d3be1037$var$globalStack.push(overlay);
        if (overlay.props.usePortal && overlay.props.hasBackdrop) // add a class to the body to prevent scrolling of content below the overlay
        document.body.classList.add((0, $auzpd).OVERLAY_OPEN);
    }, []);
    var closeOverlay = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useCallback(function(id) {
        var otherOverlaysWithBackdrop = stack.filter(function(o) {
            return o.props.usePortal && o.props.hasBackdrop && o.id !== id;
        });
        var index = $2f349f58d3be1037$var$globalStack.findIndex(function(o) {
            return o.id === id;
        });
        if (index > -1) $2f349f58d3be1037$var$globalStack.splice(index, 1);
        if (otherOverlaysWithBackdrop.length === 0) // remove body class which prevents scrolling of content below overlay
        document.body.classList.remove((0, $auzpd).OVERLAY_OPEN);
    }, [
        stack
    ]);
    return {
        closeOverlay: closeOverlay,
        getLastOpened: getLastOpened,
        getThisOverlayAndDescendants: getThisOverlayAndDescendants,
        openOverlay: openOverlay,
        resetStack: resetStack
    };
}

});


parcelRegister("lrF67", function(module, exports) {

$parcel$export(module.exports, "usePrevious", () => $f9cbffb83f7426cd$export$5cae361ad82dce8b);
/*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $8NFma = parcelRequire("8NFma");
function $f9cbffb83f7426cd$export$5cae361ad82dce8b(value) {
    // create a new reference
    var ref = $8NFma.useRef();
    // store current value in ref
    $8NFma.useEffect(function() {
        ref.current = value;
    }, [
        value
    ]);
    // return previous value (happens before update in useEffect above)
    return ref.current;
}

});

parcelRegister("7hlBq", function(module, exports) {

$parcel$export(module.exports, "getKeyboardFocusableElements", () => $54cae0c929e5be08$export$d68aba5567a52975);
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $auzpd = parcelRequire("auzpd");

var $8k66C = parcelRequire("8k66C");
function $54cae0c929e5be08$export$d68aba5567a52975(container) {
    var containerElement = (0, $8k66C.getRef)(container);
    var focusableElements = containerElement != null ? Array.from(// Order may not be correct if children elements use tabindex values > 0.
    // Selectors derived from this SO question:
    // https://stackoverflow.com/questions/1599660/which-html-elements-can-receive-focus
    containerElement.querySelectorAll([
        'a[href]:not([tabindex="-1"])',
        'button:not([disabled]):not([tabindex="-1"])',
        'details:not([tabindex="-1"])',
        'input:not([disabled]):not([tabindex="-1"])',
        'select:not([disabled]):not([tabindex="-1"])',
        'textarea:not([disabled]):not([tabindex="-1"])',
        '[tabindex]:not([tabindex="-1"])'
    ].join(","))) : [];
    return focusableElements.filter(function(el) {
        return !el.classList.contains((0, $auzpd.OVERLAY_START_FOCUS_TRAP)) && !el.classList.contains((0, $auzpd.OVERLAY_END_FOCUS_TRAP));
    });
}

});

parcelRegister("hpzrO", function(module, exports) {

$parcel$export(module.exports, "Portal", () => $cad044a4935b3652$export$602eac185826482c);
/*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $8NFma = parcelRequire("8NFma");

var $2pmb0 = parcelRequire("2pmb0");

var $auzpd = parcelRequire("auzpd");
var $hffzE = parcelRequire("hffzE");

var $bzsu8 = parcelRequire("bzsu8");

var $4FOwp = parcelRequire("4FOwp");

var $2dpOe = parcelRequire("2dpOe");
/** @deprecated will be removed in Blueprint v6.0 */ var $cad044a4935b3652$var$PORTAL_LEGACY_CONTEXT_TYPES = {
    blueprintPortalClassName: function(obj, key) {
        if (obj[key] != null && typeof obj[key] !== "string") return new Error($bzsu8.PORTAL_CONTEXT_CLASS_NAME_STRING);
        return undefined;
    }
};
function $cad044a4935b3652$export$602eac185826482c(// eslint-disable-next-line deprecation/deprecation
_a, legacyContext) {
    var _b;
    var className = _a.className, stopPropagationEvents = _a.stopPropagationEvents, container = _a.container, onChildrenMount = _a.onChildrenMount, children = _a.children;
    if (legacyContext === void 0) legacyContext = {};
    var context = $8NFma.useContext((0, $2dpOe.PortalContext));
    var portalContainer = (_b = container !== null && container !== void 0 ? container : context.portalContainer) !== null && _b !== void 0 ? _b : typeof document !== "undefined" ? document.body : undefined;
    var _c = $8NFma.useState(), portalElement = _c[0], setPortalElement = _c[1];
    var createPortalElement = $8NFma.useCallback(function() {
        var newPortalElement = document.createElement("div");
        newPortalElement.classList.add((0, $auzpd).PORTAL);
        $cad044a4935b3652$var$maybeAddClass(newPortalElement.classList, className); // directly added to this portal element
        $cad044a4935b3652$var$maybeAddClass(newPortalElement.classList, context.portalClassName); // added via PortalProvider context
        $cad044a4935b3652$var$addStopPropagationListeners(newPortalElement, stopPropagationEvents);
        // TODO: remove legacy context support in Blueprint v6.0
        var blueprintPortalClassName = legacyContext.blueprintPortalClassName;
        if (blueprintPortalClassName != null && blueprintPortalClassName !== "") {
            console.error($bzsu8.PORTAL_LEGACY_CONTEXT_API);
            $cad044a4935b3652$var$maybeAddClass(newPortalElement.classList, blueprintPortalClassName); // added via legacy context
        }
        return newPortalElement;
    }, [
        className,
        context.portalClassName,
        legacyContext.blueprintPortalClassName,
        stopPropagationEvents
    ]);
    // create the container element & attach it to the DOM
    $8NFma.useEffect(function() {
        if (portalContainer == null) return;
        var newPortalElement = createPortalElement();
        portalContainer.appendChild(newPortalElement);
        setPortalElement(newPortalElement);
        return function() {
            $cad044a4935b3652$var$removeStopPropagationListeners(newPortalElement, stopPropagationEvents);
            newPortalElement.remove();
            setPortalElement(undefined);
        };
    }, [
        portalContainer,
        createPortalElement,
        stopPropagationEvents
    ]);
    // wait until next successful render to invoke onChildrenMount callback
    $8NFma.useEffect(function() {
        if (portalElement != null) onChildrenMount === null || onChildrenMount === void 0 || onChildrenMount();
    }, [
        portalElement,
        onChildrenMount
    ]);
    $8NFma.useEffect(function() {
        if (portalElement != null) {
            $cad044a4935b3652$var$maybeAddClass(portalElement.classList, className);
            return function() {
                return $cad044a4935b3652$var$maybeRemoveClass(portalElement.classList, className);
            };
        }
        return undefined;
    }, [
        className,
        portalElement
    ]);
    $8NFma.useEffect(function() {
        if (portalElement != null) {
            $cad044a4935b3652$var$addStopPropagationListeners(portalElement, stopPropagationEvents);
            return function() {
                return $cad044a4935b3652$var$removeStopPropagationListeners(portalElement, stopPropagationEvents);
            };
        }
        return undefined;
    }, [
        portalElement,
        stopPropagationEvents
    ]);
    // Only render `children` once this component has mounted in a browser environment, so they are
    // immediately attached to the DOM tree and can do DOM things like measuring or `autoFocus`.
    // See long comment on componentDidMount in https://reactjs.org/docs/portals.html#event-bubbling-through-portals
    if (typeof document === "undefined" || portalElement == null) return null;
    else return $2pmb0.createPortal(children, portalElement);
}
$cad044a4935b3652$export$602eac185826482c.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".Portal");
// only use legacy context in React 16 or 17
if (!(0, $4FOwp.isReact18)()) // eslint-disable-next-line deprecation/deprecation
$cad044a4935b3652$export$602eac185826482c.contextTypes = $cad044a4935b3652$var$PORTAL_LEGACY_CONTEXT_TYPES;
function $cad044a4935b3652$var$maybeRemoveClass(classList, className) {
    if (className != null && className !== "") classList.remove.apply(classList, className.split(" "));
}
function $cad044a4935b3652$var$maybeAddClass(classList, className) {
    if (className != null && className !== "") classList.add.apply(classList, className.split(" "));
}
function $cad044a4935b3652$var$addStopPropagationListeners(portalElement, eventNames) {
    eventNames === null || eventNames === void 0 || eventNames.forEach(function(event) {
        return portalElement.addEventListener(event, $cad044a4935b3652$var$handleStopProgation);
    });
}
function $cad044a4935b3652$var$removeStopPropagationListeners(portalElement, events) {
    events === null || events === void 0 || events.forEach(function(event) {
        return portalElement.removeEventListener(event, $cad044a4935b3652$var$handleStopProgation);
    });
}
function $cad044a4935b3652$var$handleStopProgation(e) {
    e.stopPropagation();
}

});
parcelRegister("2dpOe", function(module, exports) {

$parcel$export(module.exports, "PortalContext", () => $19d0d0dac9e296f3$export$60d741e20e0aa309);
/*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $8NFma = parcelRequire("8NFma");
var $19d0d0dac9e296f3$export$60d741e20e0aa309 = $8NFma.createContext({});
var $19d0d0dac9e296f3$export$6df4068a17305b10 = function(_a) {
    var children = _a.children, portalClassName = _a.portalClassName, portalContainer = _a.portalContainer;
    var contextOptions = $8NFma.useMemo(function() {
        return {
            portalClassName: portalClassName,
            portalContainer: portalContainer
        };
    }, [
        portalClassName,
        portalContainer
    ]);
    return $8NFma.createElement($19d0d0dac9e296f3$export$60d741e20e0aa309.Provider, {
        value: contextOptions
    }, children);
};

});



parcelRegister("kOBi8", function(module, exports) {

$parcel$export(module.exports, "ResizeSensor", () => $f275677b5f1ad90c$export$99e7f5e92b1f0cf9);
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $8NFma = parcelRequire("8NFma");

var $4Jy2D = parcelRequire("4Jy2D");
var $hffzE = parcelRequire("hffzE");
/**
 * Resize sensor component.
 *
 * It requires a single DOM element child and will error otherwise.
 *
 * @see https://blueprintjs.com/docs/#core/components/resize-sensor
 **/ var $f275677b5f1ad90c$export$99e7f5e92b1f0cf9 = /** @class */ function(_super) {
    (0, $gztBd.__extends)(ResizeSensor, _super);
    function ResizeSensor() {
        var _a;
        var _this = _super.apply(this, arguments) || this;
        _this.targetRef = (_a = _this.props.targetRef) !== null && _a !== void 0 ? _a : $8NFma.createRef();
        _this.prevElement = undefined;
        return _this;
    }
    ResizeSensor.prototype.render = function() {
        var onlyChild = $8NFma.Children.only(this.props.children);
        // If we're provided a mutable ref to the child element already, we must re-use that one. This is necessary
        // in cases where the child node is not a native DOM element and does not use `React.forwardRef`, since
        // there's no way for us to know how to attach to the underlying DOM node.
        if (this.props.targetRef !== undefined) return onlyChild;
        return $8NFma.cloneElement(onlyChild, {
            ref: this.targetRef
        });
    };
    ResizeSensor.prototype.componentDidMount = function() {
        var _this = this;
        // ResizeObserver is available in all modern browsers supported by Blueprint but not in server-side rendering
        // and some test environments like jsdom, so we to do a feature check here.
        this.observer = globalThis.ResizeObserver != null ? new ResizeObserver(function(entries) {
            var _a, _b;
            return (_b = (_a = _this.props).onResize) === null || _b === void 0 ? void 0 : _b.call(_a, entries);
        }) : undefined;
        this.observeElement();
    };
    ResizeSensor.prototype.componentDidUpdate = function(prevProps) {
        this.observeElement(this.props.observeParents !== prevProps.observeParents);
    };
    ResizeSensor.prototype.componentWillUnmount = function() {
        var _a;
        (_a = this.observer) === null || _a === void 0 || _a.disconnect();
        this.prevElement = undefined;
    };
    /**
     * Observe the DOM element, if defined and different from the currently
     * observed element. Pass `force` argument to skip element checks and always
     * re-observe.
     */ ResizeSensor.prototype.observeElement = function(force) {
        if (force === void 0) force = false;
        if (this.observer === undefined) return;
        if (!(this.targetRef.current instanceof Element)) {
            // stop everything if not defined
            this.observer.disconnect();
            return;
        }
        if (this.targetRef.current === this.prevElement && !force) // quit if given same element -- nothing to update (unless forced)
        return;
        else {
            // clear observer list if new element
            this.observer.disconnect();
            // remember element reference for next time
            this.prevElement = this.targetRef.current;
        }
        // observer callback is invoked immediately when observing new elements
        this.observer.observe(this.targetRef.current);
        if (this.props.observeParents) {
            var parent_1 = this.targetRef.current.parentElement;
            while(parent_1 != null){
                this.observer.observe(parent_1);
                parent_1 = parent_1.parentElement;
            }
        }
    };
    ResizeSensor.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".ResizeSensor");
    return ResizeSensor;
}((0, $4Jy2D.AbstractPureComponent));

});

parcelRegister("7aA5C", function(module, exports) {

$parcel$export(module.exports, "matchReferenceWidthModifier", () => $5385763d14d64503$export$a8e9b369768a413a);
/*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // tslint:disable object-literal-sort-keys
// adapted from https://popper.js.org/docs/v2/modifiers/community-modifiers/
var $5385763d14d64503$export$a8e9b369768a413a = {
    enabled: true,
    name: "matchReferenceWidth",
    phase: "beforeWrite",
    requires: [
        "computeStyles"
    ],
    fn: function(_a) {
        var state = _a.state;
        state.styles.popper.width = "".concat(state.rects.reference.width, "px");
    },
    effect: function(_a) {
        var state = _a.state;
        var referenceWidth = state.elements.reference.getBoundingClientRect().width;
        state.elements.popper.style.width = "".concat(referenceWidth, "px");
    }
};

});

parcelRegister("jtuvn", function(module, exports) {

$parcel$export(module.exports, "POPOVER_ARROW_SVG_SIZE", () => $e2d863670ac8b3b4$export$4c969461ca74ea0d);
$parcel$export(module.exports, "TOOLTIP_ARROW_SVG_SIZE", () => $e2d863670ac8b3b4$export$26419ed1e4945e0);
$parcel$export(module.exports, "PopoverArrow", () => $e2d863670ac8b3b4$export$3152841115e061b2);
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $8NFma = parcelRequire("8NFma");

var $auzpd = parcelRequire("auzpd");
var $hffzE = parcelRequire("hffzE");

var $awEmD = parcelRequire("awEmD");
// these paths come from the Core Kit Sketch file
// https://github.com/palantir/blueprint/blob/develop/resources/sketch/Core%20Kit.sketch
var $e2d863670ac8b3b4$var$SVG_SHADOW_PATH = "M8.11 6.302c1.015-.936 1.887-2.922 1.887-4.297v26c0-1.378-.868-3.357-1.888-4.297L.925 17.09c-1.237-1.14-1.233-3.034 0-4.17L8.11 6.302z";
var $e2d863670ac8b3b4$var$SVG_ARROW_PATH = "M8.787 7.036c1.22-1.125 2.21-3.376 2.21-5.03V0v30-2.005c0-1.654-.983-3.9-2.21-5.03l-7.183-6.616c-.81-.746-.802-1.96 0-2.7l7.183-6.614z";
// additional space between arrow and edge of target
var $e2d863670ac8b3b4$var$ARROW_SPACING = 4;
var $e2d863670ac8b3b4$export$4c969461ca74ea0d = 30;
var $e2d863670ac8b3b4$export$26419ed1e4945e0 = 22;
/* istanbul ignore next */ /** Modifier helper function to compute arrow rotate() transform */ function $e2d863670ac8b3b4$var$getArrowAngle(placement) {
    if (placement == null) return 0;
    // can only be top/left/bottom/right - auto is resolved internally
    switch((0, $awEmD.getBasePlacement)(placement)){
        case "top":
            return -90;
        case "left":
            return 180;
        case "bottom":
            return 90;
        default:
            return 0;
    }
}
/* istanbul ignore next */ /**
 * Popper's builtin "arrow" modifier options.padding doesn't seem to work for us, so we
 * need to compute our own offset in the direction of the popover relative to the reference.
 */ function $e2d863670ac8b3b4$var$getArrowReferenceOffsetStyle(placement) {
    var offset = $e2d863670ac8b3b4$export$4c969461ca74ea0d / 2 - $e2d863670ac8b3b4$var$ARROW_SPACING;
    switch((0, $awEmD.getBasePlacement)(placement)){
        case "top":
            return {
                bottom: -offset
            };
        case "left":
            return {
                right: -offset
            };
        case "bottom":
            return {
                top: -offset
            };
        default:
            return {
                left: -offset
            };
    }
}
var $e2d863670ac8b3b4$export$3152841115e061b2 = function(_a) {
    var _b = _a.arrowProps, ref = _b.ref, style = _b.style, placement = _a.placement;
    return(// data attribute allows popper.js to position the arrow
    $8NFma.createElement("div", {
        "aria-hidden": true,
        className: (0, $auzpd).POPOVER_ARROW,
        "data-popper-arrow": true,
        ref: ref,
        style: (0, $gztBd.__assign)((0, $gztBd.__assign)({}, style), $e2d863670ac8b3b4$var$getArrowReferenceOffsetStyle(placement))
    }, $8NFma.createElement("svg", {
        viewBox: "0 0 ".concat($e2d863670ac8b3b4$export$4c969461ca74ea0d, " ").concat($e2d863670ac8b3b4$export$4c969461ca74ea0d),
        style: {
            transform: "rotate(".concat($e2d863670ac8b3b4$var$getArrowAngle(placement), "deg)")
        }
    }, $8NFma.createElement("path", {
        className: (0, $auzpd).POPOVER_ARROW + "-border",
        d: $e2d863670ac8b3b4$var$SVG_SHADOW_PATH
    }), $8NFma.createElement("path", {
        className: (0, $auzpd).POPOVER_ARROW + "-fill",
        d: $e2d863670ac8b3b4$var$SVG_ARROW_PATH
    }))));
};
$e2d863670ac8b3b4$export$3152841115e061b2.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".PopoverArrow");

});
parcelRegister("awEmD", function(module, exports) {

$parcel$export(module.exports, "getBasePlacement", () => $7a9c33fe5485b4e1$export$1f716c21fc884054);
$parcel$export(module.exports, "getTransformOrigin", () => $7a9c33fe5485b4e1$export$ac94fefc82bff952);
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
function $7a9c33fe5485b4e1$export$1f716c21fc884054(placement) {
    return placement.split("-")[0];
}
function $7a9c33fe5485b4e1$export$14f7b3a1379533e9(side) {
    return [
        "left",
        "right"
    ].indexOf(side) !== -1;
}
function $7a9c33fe5485b4e1$export$9c5e28bad23365fa(side) {
    switch(side){
        case "top":
            return "bottom";
        case "left":
            return "right";
        case "bottom":
            return "top";
        default:
            return "left";
    }
}
function $7a9c33fe5485b4e1$export$f0989780f32bfcda(placement) {
    var align = placement.split("-")[1];
    switch(align){
        case "start":
            return "left";
        case "end":
            return "right";
        default:
            return "center";
    }
}
function $7a9c33fe5485b4e1$export$ac94fefc82bff952(placement, arrowStyles) {
    var basePlacement = $7a9c33fe5485b4e1$export$1f716c21fc884054(placement);
    if (arrowStyles === undefined) return $7a9c33fe5485b4e1$export$14f7b3a1379533e9(basePlacement) ? "".concat($7a9c33fe5485b4e1$export$9c5e28bad23365fa(basePlacement), " ").concat($7a9c33fe5485b4e1$export$f0989780f32bfcda(basePlacement)) : "".concat($7a9c33fe5485b4e1$export$f0989780f32bfcda(basePlacement), " ").concat($7a9c33fe5485b4e1$export$9c5e28bad23365fa(basePlacement));
    else {
        // const arrowSizeShift = state.elements.arrow.clientHeight / 2;
        var arrowSizeShift = 15;
        // can use keyword for dimension without the arrow, to ease computation burden.
        // move origin by half arrow's height to keep it centered.
        return $7a9c33fe5485b4e1$export$14f7b3a1379533e9(basePlacement) ? "".concat($7a9c33fe5485b4e1$export$9c5e28bad23365fa(basePlacement), " ").concat(parseInt(arrowStyles.top, 10) + arrowSizeShift, "px") : "".concat(parseInt(arrowStyles.left, 10) + arrowSizeShift, "px ").concat($7a9c33fe5485b4e1$export$9c5e28bad23365fa(basePlacement));
    }
}

});


parcelRegister("adnTU", function(module, exports) {

$parcel$export(module.exports, "positionToPlacement", () => $76fda87655ece267$export$d7fe7517a77957bc);
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $c0lTz = parcelRequire("c0lTz");
function $76fda87655ece267$export$d7fe7517a77957bc(position) {
    /* istanbul ignore next */ switch(position){
        case (0, $c0lTz.PopoverPosition).TOP_LEFT:
            return "top-start";
        case (0, $c0lTz.PopoverPosition).TOP:
            return "top";
        case (0, $c0lTz.PopoverPosition).TOP_RIGHT:
            return "top-end";
        case (0, $c0lTz.PopoverPosition).RIGHT_TOP:
            return "right-start";
        case (0, $c0lTz.PopoverPosition).RIGHT:
            return "right";
        case (0, $c0lTz.PopoverPosition).RIGHT_BOTTOM:
            return "right-end";
        case (0, $c0lTz.PopoverPosition).BOTTOM_RIGHT:
            return "bottom-end";
        case (0, $c0lTz.PopoverPosition).BOTTOM:
            return "bottom";
        case (0, $c0lTz.PopoverPosition).BOTTOM_LEFT:
            return "bottom-start";
        case (0, $c0lTz.PopoverPosition).LEFT_BOTTOM:
            return "left-end";
        case (0, $c0lTz.PopoverPosition).LEFT:
            return "left";
        case (0, $c0lTz.PopoverPosition).LEFT_TOP:
            return "left-start";
        case "auto":
        case "auto-start":
        case "auto-end":
            // Return the string unchanged.
            return position;
        default:
            return $76fda87655ece267$var$assertNever(position);
    }
}
/* istanbul ignore next */ function $76fda87655ece267$var$assertNever(x) {
    throw new Error("Unexpected position: " + x);
}

});
parcelRegister("c0lTz", function(module, exports) {

$parcel$export(module.exports, "PopoverPosition", () => $8bd678137f0334b6$export$2fdab12f67185662);
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $71KpR = parcelRequire("71KpR");
var $8bd678137f0334b6$export$2fdab12f67185662 = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, (0, $71KpR.Position)), {
    AUTO: "auto",
    AUTO_END: "auto-end",
    AUTO_START: "auto-start"
});

});



parcelRegister("8CO9e", function(module, exports) {

$parcel$export(module.exports, "TooltipContext", () => $019ed9e5d1c0f7b0$export$39ae08fa83328b12);
$parcel$export(module.exports, "TooltipProvider", () => $019ed9e5d1c0f7b0$export$f78649fb9ca566b8);
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $8NFma = parcelRequire("8NFma");
var $019ed9e5d1c0f7b0$var$noOpDispatch = function() {
    return null;
};
var $019ed9e5d1c0f7b0$export$39ae08fa83328b12 = $8NFma.createContext([
    {},
    $019ed9e5d1c0f7b0$var$noOpDispatch
]);
var $019ed9e5d1c0f7b0$var$tooltipContextReducer = function(state, action) {
    switch(action.type){
        case "FORCE_DISABLED_STATE":
            return {
                forceDisabled: true
            };
        case "RESET_DISABLED_STATE":
            return {};
        default:
            return state;
    }
};
var $019ed9e5d1c0f7b0$export$f78649fb9ca566b8 = function(_a) {
    var children = _a.children, forceDisable = _a.forceDisable;
    var _b = $8NFma.useReducer($019ed9e5d1c0f7b0$var$tooltipContextReducer, {}), state = _b[0], dispatch = _b[1];
    var contextValue = $8NFma.useMemo(function() {
        return [
            state,
            dispatch
        ];
    }, [
        state,
        dispatch
    ]);
    $8NFma.useEffect(function() {
        if (forceDisable) dispatch({
            type: "FORCE_DISABLED_STATE"
        });
        else dispatch({
            type: "RESET_DISABLED_STATE"
        });
    }, [
        forceDisable
    ]);
    return $8NFma.createElement($019ed9e5d1c0f7b0$export$39ae08fa83328b12.Provider, {
        value: contextValue
    }, typeof children === "function" ? children(state) : children);
};

});



parcelRegister("8OWT0", function(module, exports) {
"use strict";
var $66c0abc98d0e307d$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.Tooltip = void 0;

const $66c0abc98d0e307d$var$react_1 = $66c0abc98d0e307d$var$__importDefault((parcelRequire("8NFma")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");
parcelRequire("7TL1v");
var $1SE86 = parcelRequire("1SE86");

var $f5Zeh = parcelRequire("f5Zeh");
var $1Ym0q = parcelRequire("1Ym0q");

var $kYy5r = parcelRequire("kYy5r");

var $1hndE = parcelRequire("1hndE");

var $ds9SU = parcelRequire("ds9SU");

var $ex8Pn = parcelRequire("ex8Pn");

var $2YVWw = parcelRequire("2YVWw");
function $66c0abc98d0e307d$var$findParentWithClass(e, t) {
    return e.classList.contains(t) ? e : e.parentElement ? $66c0abc98d0e307d$var$findParentWithClass(e.parentElement, t) : null;
}
module.exports.Tooltip = (0, $O1ETn.observer)(({ store: e, page: t, components: n, stageRef: r })=>{
    var l, o;
    const a = (0, $kYy5r.getTotalClientRect)(e.selectedShapes), u = e.selectedShapes.every((e)=>e.page === t), i = $66c0abc98d0e307d$var$react_1.default.useRef(null), [s, c] = $66c0abc98d0e307d$var$react_1.default.useState(!1), d = e._hasCroppedImages;
    $66c0abc98d0e307d$var$react_1.default.useEffect(()=>{
        var e, t, n;
        const l = ()=>{
            c(!0);
        }, o = ()=>{
            c(!1);
        };
        null === (e = null == r ? void 0 : r.current) || void 0 === e || e.on("dragstart", l), null === (t = null == r ? void 0 : r.current) || void 0 === t || t.on("dragend", o);
        const a = null === (n = null == r ? void 0 : r.current) || void 0 === n ? void 0 : n.findOne("Transformer");
        return null == a || a.on("transformstart", l), null == a || a.on("transformend", o), ()=>{
            var e, t;
            null === (e = null == r ? void 0 : r.current) || void 0 === e || e.off("dragstart", l), null === (t = null == r ? void 0 : r.current) || void 0 === t || t.off("dragend", o), null == a || a.off("transformstart", l), null == a || a.off("transformend", o);
        };
    }, []);
    const [f, _] = $66c0abc98d0e307d$var$react_1.default.useState({
        fit: !0,
        needCalculate: !1,
        token: Math.random()
    });
    if ($66c0abc98d0e307d$var$react_1.default.useEffect(()=>{
        0 !== e.selectedElements.length && _({
            fit: !0,
            needCalculate: !0,
            token: Math.random()
        });
    }, [
        e.selectedElements,
        s
    ]), $66c0abc98d0e307d$var$react_1.default.useEffect(()=>{
        setTimeout(()=>{
            if (!i.current) return;
            if (!f.needCalculate) return;
            const e = $66c0abc98d0e307d$var$findParentWithClass(i.current, "polotno-workspace-container");
            if (!e) return;
            const t = e.getBoundingClientRect(), n = i.current.getBoundingClientRect(), r = (n.right, t.left, n.top - t.top), l = (n.left, t.left, n.bottom - t.top);
            r < 20 && f.fit && _({
                fit: !1,
                needCalculate: !1,
                token: f.token
            }), l - t.height > -20 && !f.fit && _({
                fit: !0,
                needCalculate: !1,
                token: f.token
            });
        }, 10);
    }, [
        f.needCalculate,
        i.current,
        f.token
    ]), $66c0abc98d0e307d$var$react_1.default.useEffect(()=>{
        const t = $66c0abc98d0e307d$var$findParentWithClass(r.current.content, "polotno-workspace-inner"), n = ()=>{
            e.selectedElements.length && _({
                fit: !0,
                needCalculate: !0,
                token: Math.random()
            });
        };
        return null == t || t.addEventListener("scroll", n), ()=>{
            null == t || t.removeEventListener("scroll", n);
        };
    }, []), 0 === e.selectedShapes.length) return null;
    if (s) return null;
    if (!u) return null;
    if (e.activePage !== t) return null;
    if (d) return null;
    const m = (null == n ? void 0 : n.Position) || $2YVWw.PositionPicker, p = (null == n ? void 0 : n.Duplicate) || $ds9SU.DuplicateButton, v = (null == n ? void 0 : n.Remove) || $ex8Pn.RemoveButton, h = e.selectedElements[0].type, b = (0, $1hndE.extendToolbar)({
        components: n,
        type: h,
        usedItems: []
    }), g = (null === (o = null === (l = null == r ? void 0 : r.current) || void 0 === l ? void 0 : l.findOne("Transformer")) || void 0 === o ? void 0 : o.rotation()) || 0;
    let E = 30;
    return Math.abs(g) < 5 && f.fit && (E = 80), Math.abs(g) > 160 && !f.fit && (E = 80), $66c0abc98d0e307d$var$react_1.default.createElement($1SE86.Html, {
        transformFunc: (e)=>{
            const t = a.x + a.width / 2, n = f.fit ? a.y * e.scaleY - E : a.y * e.scaleY + a.height * e.scaleY + E;
            return Object.assign(Object.assign({}, e), {
                x: e.x + t * e.scaleX,
                y: e.y + n,
                scaleX: 1,
                scaleY: 1
            });
        },
        divProps: {
            style: {
                pointerEvents: "none",
                zIndex: 9
            }
        }
    }, $66c0abc98d0e307d$var$react_1.default.createElement("div", {
        ref: i,
        style: {
            pointerEvents: "none"
        }
    }, $66c0abc98d0e307d$var$react_1.default.createElement($f5Zeh.Navbar, {
        style: {
            padding: "2px",
            borderRadius: "5px",
            height: "34px",
            transform: "translate(-50%, -50%)",
            pointerEvents: "auto"
        }
    }, $66c0abc98d0e307d$var$react_1.default.createElement($1Ym0q.NavbarGroup, {
        style: {
            height: "30px"
        }
    }, b.map((t)=>{
        const r = n[t];
        return $66c0abc98d0e307d$var$react_1.default.createElement(r, {
            elements: e.selectedElements,
            element: e.selectedElements[0],
            store: e,
            key: t
        });
    }), $66c0abc98d0e307d$var$react_1.default.createElement(p, {
        store: e
    }), $66c0abc98d0e307d$var$react_1.default.createElement(v, {
        store: e
    }), $66c0abc98d0e307d$var$react_1.default.createElement(m, {
        store: e
    })))));
});

});
parcelRegister("f5Zeh", function(module, exports) {

$parcel$export(module.exports, "Navbar", () => $afd6d17d7f348ada$export$42cfbb80f7861e77);
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $4Jy2D = parcelRequire("4Jy2D");
var $auzpd = parcelRequire("auzpd");

var $hffzE = parcelRequire("hffzE");

var $i0HFz = parcelRequire("i0HFz");

var $1Ym0q = parcelRequire("1Ym0q");

var $iDuDV = parcelRequire("iDuDV");
// this component is simple enough that tests would be purely tautological.
/* istanbul ignore next */ /**
 * Navbar component.
 *
 * @see https://blueprintjs.com/docs/#core/components/navbar
 */ var $afd6d17d7f348ada$export$42cfbb80f7861e77 = /** @class */ function(_super) {
    (0, $gztBd.__extends)(Navbar, _super);
    function Navbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Navbar.prototype.render = function() {
        var _a;
        var _b = this.props, children = _b.children, className = _b.className, fixedToTop = _b.fixedToTop, htmlProps = (0, $gztBd.__rest)(_b, [
            "children",
            "className",
            "fixedToTop"
        ]);
        var classes = (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $auzpd).NAVBAR, (_a = {}, _a[(0, $auzpd).FIXED_TOP] = fixedToTop, _a), className);
        return $8NFma.createElement("div", (0, $gztBd.__assign)({
            className: classes
        }, htmlProps), children);
    };
    Navbar.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".Navbar");
    Navbar.Divider = (0, $i0HFz.NavbarDivider);
    Navbar.Group = (0, $1Ym0q.NavbarGroup);
    Navbar.Heading = (0, $iDuDV.NavbarHeading);
    return Navbar;
}((0, $4Jy2D.AbstractPureComponent));

});
parcelRegister("i0HFz", function(module, exports) {

$parcel$export(module.exports, "NavbarDivider", () => $d1ca19f17cbbbda4$export$d2b2717c8fde48ba);
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $4Jy2D = parcelRequire("4Jy2D");
var $auzpd = parcelRequire("auzpd");

var $hffzE = parcelRequire("hffzE");
// this component is simple enough that tests would be purely tautological.
/* istanbul ignore next */ var $d1ca19f17cbbbda4$export$d2b2717c8fde48ba = /** @class */ function(_super) {
    (0, $gztBd.__extends)(NavbarDivider, _super);
    function NavbarDivider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NavbarDivider.prototype.render = function() {
        var _a = this.props, className = _a.className, htmlProps = (0, $gztBd.__rest)(_a, [
            "className"
        ]);
        return $8NFma.createElement("div", (0, $gztBd.__assign)({
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $auzpd).NAVBAR_DIVIDER, className)
        }, htmlProps));
    };
    NavbarDivider.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".NavbarDivider");
    return NavbarDivider;
}((0, $4Jy2D.AbstractPureComponent));

});

parcelRegister("1Ym0q", function(module, exports) {

$parcel$export(module.exports, "NavbarGroup", () => $16fc76f5a9ccf429$export$90df0bffe1bcd17c);
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $4Jy2D = parcelRequire("4Jy2D");
var $2nesQ = parcelRequire("2nesQ");
var $auzpd = parcelRequire("auzpd");

var $hffzE = parcelRequire("hffzE");
// this component is simple enough that tests would be purely tautological.
/* istanbul ignore next */ var $16fc76f5a9ccf429$export$90df0bffe1bcd17c = /** @class */ function(_super) {
    (0, $gztBd.__extends)(NavbarGroup, _super);
    function NavbarGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NavbarGroup.prototype.render = function() {
        var _a = this.props, align = _a.align, children = _a.children, className = _a.className, htmlProps = (0, $gztBd.__rest)(_a, [
            "align",
            "children",
            "className"
        ]);
        var classes = (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $auzpd).NAVBAR_GROUP, (0, $auzpd).alignmentClass(align), className);
        return $8NFma.createElement("div", (0, $gztBd.__assign)({
            className: classes
        }, htmlProps), children);
    };
    NavbarGroup.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".NavbarGroup");
    NavbarGroup.defaultProps = {
        align: (0, $2nesQ.Alignment).LEFT
    };
    return NavbarGroup;
}((0, $4Jy2D.AbstractPureComponent));

});

parcelRegister("iDuDV", function(module, exports) {

$parcel$export(module.exports, "NavbarHeading", () => $d913a38df88bdc38$export$d37a5b1da727490b);
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $4Jy2D = parcelRequire("4Jy2D");
var $auzpd = parcelRequire("auzpd");

var $hffzE = parcelRequire("hffzE");
// this component is simple enough that tests would be purely tautological.
/* istanbul ignore next */ var $d913a38df88bdc38$export$d37a5b1da727490b = /** @class */ function(_super) {
    (0, $gztBd.__extends)(NavbarHeading, _super);
    function NavbarHeading() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NavbarHeading.prototype.render = function() {
        var _a = this.props, children = _a.children, className = _a.className, htmlProps = (0, $gztBd.__rest)(_a, [
            "children",
            "className"
        ]);
        return $8NFma.createElement("div", (0, $gztBd.__assign)({
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $auzpd).NAVBAR_HEADING, className)
        }, htmlProps), children);
    };
    NavbarHeading.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".NavbarHeading");
    return NavbarHeading;
}((0, $4Jy2D.AbstractPureComponent));

});


parcelRegister("1hndE", function(module, exports) {
"use strict";
var $0ee963d394c2a256$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.ElementContainer = module.exports.extendToolbar = void 0;

const $0ee963d394c2a256$var$react_1 = $0ee963d394c2a256$var$__importDefault((parcelRequire("8NFma")));

var $bYcb5 = parcelRequire("bYcb5");
var $gUePa = parcelRequire("gUePa");
var $9eEFH = parcelRequire("9eEFH");
var $ixLVk = parcelRequire("ixLVk");
var $71KpR = parcelRequire("71KpR");

var $bYcb5 = parcelRequire("bYcb5");
var $gUePa = parcelRequire("gUePa");
var $9eEFH = parcelRequire("9eEFH");
var $ixLVk = parcelRequire("ixLVk");
var $71KpR = parcelRequire("71KpR");

const $0ee963d394c2a256$var$styled_1 = $0ee963d394c2a256$var$__importDefault((parcelRequire("MPenY")));

var $3pcZ0 = parcelRequire("3pcZ0");
const $0ee963d394c2a256$var$Container = (0, $0ee963d394c2a256$var$styled_1.default)("div", $0ee963d394c2a256$var$react_1.default.forwardRef)`
  ${(0, $3pcZ0.mobileStyle)("\n    width: auto !important;\n  ")}
`, $0ee963d394c2a256$var$extendToolbar = ({ type: e, usedItems: t, components: r })=>{
    const n = [];
    Object.keys(r).forEach((r)=>{
        0 === r.toLowerCase().indexOf(e) && (t.includes(r) || n.push(r));
    });
    return t.filter((e)=>Boolean(e)).concat(n);
};
module.exports.extendToolbar = $0ee963d394c2a256$var$extendToolbar;
const $0ee963d394c2a256$var$ElementContainer = ({ items: e, itemRender: t })=>{
    const [r, n] = $0ee963d394c2a256$var$react_1.default.useState(0), o = $0ee963d394c2a256$var$react_1.default.useRef(null), a = ()=>{
        if (null === o.current) return;
        const e = o.current.parentElement;
        let t = 0;
        [
            ...o.current.parentElement.children
        ].forEach((e)=>{
            e !== o.current && (t += e.offsetWidth);
        }), n(Math.max(20, e.offsetWidth - t - 10));
    };
    return $0ee963d394c2a256$var$react_1.default.useLayoutEffect(()=>{
        a();
    }), $0ee963d394c2a256$var$react_1.default.useLayoutEffect(()=>{
        const e = o.current.parentElement.parentElement;
        if (window.ResizeObserver) {
            const t = new ResizeObserver(a);
            return t.observe(e), ()=>t.unobserve(e);
        }
        {
            const e = setInterval(a, 100);
            return ()=>clearInterval(e);
        }
    }, []), $0ee963d394c2a256$var$react_1.default.createElement($0ee963d394c2a256$var$Container, {
        style: {
            width: r + "px"
        },
        ref: o,
        className: "bp5-navbar-group bp5-align-left"
    }, $0ee963d394c2a256$var$react_1.default.createElement($9eEFH.OverflowList, {
        items: e,
        style: {
            width: "100%"
        },
        visibleItemRenderer: t,
        collapseFrom: $bYcb5.Boundary.END,
        overflowRenderer: (e)=>$0ee963d394c2a256$var$react_1.default.createElement($ixLVk.Popover, {
                content: $0ee963d394c2a256$var$react_1.default.createElement("div", {
                    style: {
                        padding: "10px",
                        display: "flex"
                    }
                }, e.map(t)),
                position: $71KpR.Position.BOTTOM
            }, $0ee963d394c2a256$var$react_1.default.createElement($gUePa.Button, {
                icon: "more",
                minimal: !0,
                style: {
                    marginLeft: "10px"
                }
            }))
    }));
};
module.exports.ElementContainer = $0ee963d394c2a256$var$ElementContainer;

});
parcelRegister("bYcb5", function(module, exports) {

$parcel$export(module.exports, "Boundary", () => $8b6ebe8b21c96221$export$f43eab0e9866fe6f);
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Boundary of a one-dimensional interval. */ var $8b6ebe8b21c96221$export$f43eab0e9866fe6f = {
    START: "start",
    // tslint:disable-next-line:object-literal-sort-keys
    END: "end"
};

});

parcelRegister("9eEFH", function(module, exports) {

$parcel$export(module.exports, "OverflowList", () => $6b94f85f3f947564$export$50d81a6bd9718ce1);
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $bYcb5 = parcelRequire("bYcb5");
var $auzpd = parcelRequire("auzpd");
var $hffzE = parcelRequire("hffzE");

var $bzsu8 = parcelRequire("bzsu8");

var $9ST00 = parcelRequire("9ST00");

var $kOBi8 = parcelRequire("kOBi8");
/**
 * Overflow list component.
 *
 * @see https://blueprintjs.com/docs/#core/components/overflow-list
 */ var $6b94f85f3f947564$export$50d81a6bd9718ce1 = /** @class */ function(_super) {
    (0, $gztBd.__extends)(OverflowList, _super);
    function OverflowList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            chopSize: _this.defaultChopSize(),
            lastChopSize: null,
            lastOverflowCount: 0,
            overflow: [],
            repartitioning: false,
            visible: _this.props.items
        };
        _this.spacer = null;
        _this.resize = function() {
            _this.repartition();
        };
        return _this;
    }
    OverflowList.ofType = function() {
        return OverflowList;
    };
    OverflowList.prototype.componentDidMount = function() {
        this.repartition();
    };
    OverflowList.prototype.shouldComponentUpdate = function(nextProps, nextState) {
        // We want this component to always re-render, even when props haven't changed, so that
        // changes in the renderers' behavior can be reflected.
        // The following statement prevents re-rendering only in the case where the state changes
        // identity (i.e. setState was called), but the state is still the same when
        // shallow-compared to the previous state. Original context: https://github.com/palantir/blueprint/pull/3278.
        // We also ensure that we re-render if the props DO change (which isn't necessarily accounted for by other logic).
        return this.props !== nextProps || !(this.state !== nextState && (0, $9ST00.shallowCompareKeys)(this.state, nextState));
    };
    OverflowList.prototype.componentDidUpdate = function(prevProps, prevState) {
        var _a, _b;
        if (prevProps.observeParents !== this.props.observeParents) console.warn((0, $bzsu8.OVERFLOW_LIST_OBSERVE_PARENTS_CHANGED));
        if (prevProps.collapseFrom !== this.props.collapseFrom || prevProps.items !== this.props.items || prevProps.minVisibleItems !== this.props.minVisibleItems || prevProps.overflowRenderer !== this.props.overflowRenderer || prevProps.alwaysRenderOverflow !== this.props.alwaysRenderOverflow || prevProps.visibleItemRenderer !== this.props.visibleItemRenderer) // reset visible state if the above props change.
        this.setState({
            chopSize: this.defaultChopSize(),
            lastChopSize: null,
            lastOverflowCount: 0,
            overflow: [],
            repartitioning: true,
            visible: this.props.items
        });
        var _c = this.state, repartitioning = _c.repartitioning, overflow = _c.overflow, lastOverflowCount = _c.lastOverflowCount;
        if (// if a resize operation has just completed
        repartitioning === false && prevState.repartitioning === true) // only invoke the callback if the UI has actually changed
        {
            if (overflow.length !== lastOverflowCount) (_b = (_a = this.props).onOverflow) === null || _b === void 0 || _b.call(_a, overflow.slice());
        } else if (!(0, $9ST00.shallowCompareKeys)(prevState, this.state)) this.repartition();
    };
    OverflowList.prototype.render = function() {
        var _this = this;
        var _a = this.props, className = _a.className, collapseFrom = _a.collapseFrom, observeParents = _a.observeParents, style = _a.style, _b = _a.tagName, tagName = _b === void 0 ? "div" : _b, visibleItemRenderer = _a.visibleItemRenderer;
        var overflow = this.maybeRenderOverflow();
        var list = $8NFma.createElement(tagName, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $auzpd).OVERFLOW_LIST, className),
            style: style
        }, collapseFrom === (0, $bYcb5.Boundary).START ? overflow : null, this.state.visible.map(visibleItemRenderer), collapseFrom === (0, $bYcb5.Boundary).END ? overflow : null, $8NFma.createElement("div", {
            className: (0, $auzpd).OVERFLOW_LIST_SPACER,
            ref: function(ref) {
                return _this.spacer = ref;
            }
        }));
        return $8NFma.createElement((0, $kOBi8.ResizeSensor), {
            onResize: this.resize,
            observeParents: observeParents
        }, list);
    };
    OverflowList.prototype.maybeRenderOverflow = function() {
        var overflow = this.state.overflow;
        if (overflow.length === 0 && !this.props.alwaysRenderOverflow) return null;
        return this.props.overflowRenderer(overflow.slice());
    };
    OverflowList.prototype.repartition = function() {
        var _this = this;
        var _a;
        if (this.spacer == null) return;
        // if lastChopSize was 1, then our binary search has exhausted.
        var partitionExhausted = this.state.lastChopSize === 1;
        var minVisible = (_a = this.props.minVisibleItems) !== null && _a !== void 0 ? _a : 0;
        // spacer has flex-shrink and width 1px so if it's much smaller then we know to shrink
        var shouldShrink = this.spacer.offsetWidth < 0.9 && this.state.visible.length > minVisible;
        // we only check partitionExhausted for shouldGrow to ensure shrinking is the final operation.
        var shouldGrow = (this.spacer.offsetWidth >= 1 || this.state.visible.length < minVisible) && this.state.overflow.length > 0 && !partitionExhausted;
        if (shouldShrink || shouldGrow) this.setState(function(state) {
            var visible;
            var overflow;
            if (_this.props.collapseFrom === (0, $bYcb5.Boundary).END) {
                var result = $6b94f85f3f947564$var$shiftElements(state.visible, state.overflow, _this.state.chopSize * (shouldShrink ? 1 : -1));
                visible = result[0];
                overflow = result[1];
            } else {
                var result = $6b94f85f3f947564$var$shiftElements(state.overflow, state.visible, _this.state.chopSize * (shouldShrink ? -1 : 1));
                overflow = result[0];
                visible = result[1];
            }
            return {
                chopSize: $6b94f85f3f947564$var$halve(state.chopSize),
                lastChopSize: state.chopSize,
                // if we're starting a new partition cycle, record the last overflow count so we can track whether the UI changes after the new overflow is calculated
                lastOverflowCount: _this.isFirstPartitionCycle(state.chopSize) ? state.overflow.length : state.lastOverflowCount,
                overflow: overflow,
                repartitioning: true,
                visible: visible
            };
        });
        else // repartition complete!
        this.setState({
            chopSize: this.defaultChopSize(),
            lastChopSize: null,
            repartitioning: false
        });
    };
    OverflowList.prototype.defaultChopSize = function() {
        return $6b94f85f3f947564$var$halve(this.props.items.length);
    };
    OverflowList.prototype.isFirstPartitionCycle = function(currentChopSize) {
        return currentChopSize === this.defaultChopSize();
    };
    OverflowList.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".OverflowList");
    OverflowList.defaultProps = {
        alwaysRenderOverflow: false,
        collapseFrom: (0, $bYcb5.Boundary).START,
        minVisibleItems: 0
    };
    return OverflowList;
}($8NFma.Component);
function $6b94f85f3f947564$var$halve(num) {
    return Math.ceil(num / 2);
}
function $6b94f85f3f947564$var$shiftElements(leftArray, rightArray, num) {
    // if num is positive then elements are shifted from left-to-right, if negative then right-to-left
    var allElements = leftArray.concat(rightArray);
    var newLeftLength = leftArray.length - num;
    if (newLeftLength <= 0) return [
        [],
        allElements
    ];
    else if (newLeftLength >= allElements.length) return [
        allElements,
        []
    ];
    var sliceIndex = allElements.length - newLeftLength;
    return [
        allElements.slice(0, -sliceIndex),
        allElements.slice(-sliceIndex)
    ];
}

});


parcelRegister("ds9SU", function(module, exports) {
"use strict";
var $9cb58ec46ca99fe5$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.DuplicateButton = void 0;

const $9cb58ec46ca99fe5$var$react_1 = $9cb58ec46ca99fe5$var$__importDefault((parcelRequire("8NFma")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

var $gUePa = parcelRequire("gUePa");
var $gVVt3 = parcelRequire("gVVt3");

var $xARwM = parcelRequire("xARwM");
module.exports.DuplicateButton = (0, $O1ETn.observer)(({ store: e })=>{
    const t = e.selectedElements.length > 0;
    return $9cb58ec46ca99fe5$var$react_1.default.createElement($gVVt3.Tooltip, {
        content: (0, $xARwM.t)("toolbar.duplicateElements"),
        disabled: !t,
        position: "bottom"
    }, $9cb58ec46ca99fe5$var$react_1.default.createElement($gUePa.Button, {
        icon: "duplicate",
        minimal: !0,
        onClick: ()=>{
            const t = [];
            e.selectedElements.forEach((e)=>{
                const r = e.clone();
                "group" === e.type ? r.children.forEach((e)=>{
                    e.set({
                        x: e.x + 50,
                        y: e.y + 50
                    });
                }) : r.set({
                    x: e.x + 50,
                    y: e.y + 50
                }), t.push(r.id);
            }), e.selectElements(t);
        },
        disabled: !t
    }));
});

});

parcelRegister("ex8Pn", function(module, exports) {
"use strict";
var $a94afebc6258e587$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.RemoveButton = void 0;

const $a94afebc6258e587$var$react_1 = $a94afebc6258e587$var$__importDefault((parcelRequire("8NFma")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

var $gUePa = parcelRequire("gUePa");
var $gVVt3 = parcelRequire("gVVt3");

var $xARwM = parcelRequire("xARwM");
module.exports.RemoveButton = (0, $O1ETn.observer)(({ store: e })=>{
    const t = e.selectedElements.filter((e)=>e.removable);
    return $a94afebc6258e587$var$react_1.default.createElement($gVVt3.Tooltip, {
        content: (0, $xARwM.t)("toolbar.removeElements"),
        disabled: !t.length,
        position: "bottom"
    }, $a94afebc6258e587$var$react_1.default.createElement($gUePa.Button, {
        icon: "trash",
        minimal: !0,
        onClick: ()=>{
            e.deleteElements(t.map((e)=>e.id));
        },
        disabled: !t.length,
        style: {
            marginLeft: "auto"
        }
    }));
});

});

parcelRegister("2YVWw", function(module, exports) {
"use strict";
var $22be219fd3b9dc32$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.PositionPicker = void 0;

const $22be219fd3b9dc32$var$react_1 = $22be219fd3b9dc32$var$__importDefault((parcelRequire("8NFma")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

var $gUePa = parcelRequire("gUePa");
var $7RyvK = parcelRequire("7RyvK");
var $8nAI2 = parcelRequire("8nAI2");
var $2IwH6 = parcelRequire("2IwH6");
var $ixLVk = parcelRequire("ixLVk");

var $gUePa = parcelRequire("gUePa");
var $7RyvK = parcelRequire("7RyvK");
var $8nAI2 = parcelRequire("8nAI2");
var $2IwH6 = parcelRequire("2IwH6");
var $ixLVk = parcelRequire("ixLVk");

var $kYy5r = parcelRequire("kYy5r");

var $xARwM = parcelRequire("xARwM");
module.exports.PositionPicker = (0, $O1ETn.observer)(({ store: e })=>{
    var t, l, o, n;
    const a = e.selectedElements.length > 0, i = e.selectedElementsIds, c = e.selectedElements.every((e)=>e.draggable), r = !e.selectedElements.some((e)=>"group" === e.type) && c, s = (r && e.selectedElements.length, r && e.selectedElements.length > 1);
    return $22be219fd3b9dc32$var$react_1.default.createElement($ixLVk.Popover, {
        disabled: !a,
        content: $22be219fd3b9dc32$var$react_1.default.createElement($7RyvK.Menu, {
            style: {
                width: "280px"
            }
        }, $22be219fd3b9dc32$var$react_1.default.createElement($8nAI2.MenuDivider, {
            title: (0, $xARwM.t)("toolbar.layering")
        }), $22be219fd3b9dc32$var$react_1.default.createElement("div", {
            style: {
                display: "flex"
            }
        }, $22be219fd3b9dc32$var$react_1.default.createElement("div", {
            style: {
                width: "50%"
            }
        }, $22be219fd3b9dc32$var$react_1.default.createElement($2IwH6.MenuItem, {
            shouldDismissPopover: !1,
            icon: "chevron-up",
            text: (0, $xARwM.t)("toolbar.up"),
            disabled: !(null === (t = e.activePage) || void 0 === t ? void 0 : t.canMoveElementsUp(i)),
            onClick: ()=>{
                var t;
                null === (t = e.activePage) || void 0 === t || t.moveElementsUp(i);
            }
        }), $22be219fd3b9dc32$var$react_1.default.createElement($2IwH6.MenuItem, {
            shouldDismissPopover: !1,
            icon: "double-chevron-up",
            text: (0, $xARwM.t)("toolbar.toForward"),
            disabled: !(null === (l = e.activePage) || void 0 === l ? void 0 : l.canMoveElementsTop(i)),
            onClick: ()=>{
                var t;
                null === (t = e.activePage) || void 0 === t || t.moveElementsTop(i);
            }
        })), $22be219fd3b9dc32$var$react_1.default.createElement("div", {
            style: {
                width: "50%"
            }
        }, $22be219fd3b9dc32$var$react_1.default.createElement($2IwH6.MenuItem, {
            shouldDismissPopover: !1,
            icon: "chevron-down",
            text: (0, $xARwM.t)("toolbar.down"),
            disabled: !(null === (o = e.activePage) || void 0 === o ? void 0 : o.canMoveElementsDown(i)),
            onClick: ()=>{
                var t;
                null === (t = e.activePage) || void 0 === t || t.moveElementsDown(i);
            }
        }), $22be219fd3b9dc32$var$react_1.default.createElement($2IwH6.MenuItem, {
            shouldDismissPopover: !1,
            icon: "double-chevron-down",
            text: (0, $xARwM.t)("toolbar.toBottom"),
            disabled: !(null === (n = e.activePage) || void 0 === n ? void 0 : n.canMoveElementsBottom(i)),
            onClick: ()=>{
                var t;
                null === (t = e.activePage) || void 0 === t || t.moveElementsBottom(i);
            }
        }))), r && $22be219fd3b9dc32$var$react_1.default.createElement($22be219fd3b9dc32$var$react_1.default.Fragment, null, $22be219fd3b9dc32$var$react_1.default.createElement($8nAI2.MenuDivider, {
            title: (0, $xARwM.t)("toolbar.position")
        }), $22be219fd3b9dc32$var$react_1.default.createElement("div", {
            style: {
                display: "flex"
            }
        }, $22be219fd3b9dc32$var$react_1.default.createElement("div", {
            style: {
                width: "50%"
            }
        }, $22be219fd3b9dc32$var$react_1.default.createElement($2IwH6.MenuItem, {
            shouldDismissPopover: !1,
            icon: "alignment-left",
            text: (0, $xARwM.t)("toolbar.alignLeft"),
            onClick: ()=>{
                var t;
                let l = null === (t = e.activePage) || void 0 === t ? void 0 : t.computedWidth;
                e.selectedElements.forEach((e)=>{
                    l = Math.min(l, (0, $kYy5r.getClientRect)(e).x);
                }), 1 === e.selectedElements.length && (l = 0), e.selectedElements.forEach((e)=>{
                    const t = (0, $kYy5r.getClientRect)(e);
                    e.set({
                        x: e.x - t.x + l
                    });
                });
            }
        }), $22be219fd3b9dc32$var$react_1.default.createElement($2IwH6.MenuItem, {
            shouldDismissPopover: !1,
            icon: "alignment-vertical-center",
            text: (0, $xARwM.t)("toolbar.alignCenter"),
            onClick: ()=>{
                var t, l;
                let o = null === (t = e.activePage) || void 0 === t ? void 0 : t.computedWidth, n = 0;
                e.selectedElements.forEach((e)=>{
                    const t = (0, $kYy5r.getClientRect)(e);
                    o = Math.min(o, t.x), n = Math.max(n, t.x + t.width);
                });
                let a = (n + o) / 2;
                1 === e.selectedElements.length && (a = (null === (l = e.activePage) || void 0 === l ? void 0 : l.computedWidth) / 2), e.selectedElements.forEach((e)=>{
                    const t = (0, $kYy5r.getClientRect)(e), l = e.x - t.x;
                    e.set({
                        x: a + l - t.width / 2
                    });
                });
            }
        }), $22be219fd3b9dc32$var$react_1.default.createElement($2IwH6.MenuItem, {
            shouldDismissPopover: !1,
            icon: "alignment-right",
            text: (0, $xARwM.t)("toolbar.alignRight"),
            onClick: ()=>{
                var t;
                let l = 0;
                e.selectedElements.forEach((e)=>{
                    const t = (0, $kYy5r.getClientRect)(e);
                    l = Math.max(l, t.x + t.width);
                }), 1 === e.selectedElements.length && (l = null === (t = e.activePage) || void 0 === t ? void 0 : t.computedWidth), e.selectedElements.forEach((e)=>{
                    const t = (0, $kYy5r.getClientRect)(e);
                    e.set({
                        x: e.x - t.x + l - t.width
                    });
                });
            }
        })), $22be219fd3b9dc32$var$react_1.default.createElement("div", {
            style: {
                width: "50%"
            }
        }, $22be219fd3b9dc32$var$react_1.default.createElement($2IwH6.MenuItem, {
            shouldDismissPopover: !1,
            icon: "alignment-top",
            text: (0, $xARwM.t)("toolbar.alignTop"),
            onClick: ()=>{
                var t;
                let l = null === (t = e.activePage) || void 0 === t ? void 0 : t.computedHeight;
                e.selectedElements.forEach((e)=>{
                    l = Math.min(l, (0, $kYy5r.getClientRect)(e).y);
                }), 1 === e.selectedElements.length && (l = 0), e.selectedElements.forEach((e)=>{
                    const t = (0, $kYy5r.getClientRect)(e);
                    e.set({
                        y: e.y - t.y + l
                    });
                });
            }
        }), $22be219fd3b9dc32$var$react_1.default.createElement($2IwH6.MenuItem, {
            shouldDismissPopover: !1,
            icon: "alignment-horizontal-center",
            text: (0, $xARwM.t)("toolbar.alignMiddle"),
            onClick: ()=>{
                var t, l;
                let o = null === (t = e.activePage) || void 0 === t ? void 0 : t.computedHeight, n = 0;
                e.selectedElements.forEach((e)=>{
                    const t = (0, $kYy5r.getClientRect)(e);
                    o = Math.min(o, t.y), n = Math.max(n, t.y + t.height);
                });
                let a = (n + o) / 2;
                1 === e.selectedElements.length && (a = (null === (l = e.activePage) || void 0 === l ? void 0 : l.computedHeight) / 2), e.selectedElements.forEach((e)=>{
                    const t = (0, $kYy5r.getClientRect)(e), l = e.y - t.y;
                    e.set({
                        y: a + l - t.height / 2
                    });
                });
            }
        }), $22be219fd3b9dc32$var$react_1.default.createElement($2IwH6.MenuItem, {
            shouldDismissPopover: !1,
            icon: "alignment-bottom",
            text: (0, $xARwM.t)("toolbar.alignBottom"),
            onClick: ()=>{
                var t;
                let l = 0;
                e.selectedElements.forEach((e)=>{
                    const t = (0, $kYy5r.getClientRect)(e);
                    l = Math.max(l, t.y + t.height);
                }), 1 === e.selectedElements.length && (l = null === (t = e.activePage) || void 0 === t ? void 0 : t.computedHeight), e.selectedElements.forEach((e)=>{
                    const t = (0, $kYy5r.getClientRect)(e);
                    e.set({
                        y: e.y - t.y + l - t.height
                    });
                });
            }
        })))), s && $22be219fd3b9dc32$var$react_1.default.createElement($22be219fd3b9dc32$var$react_1.default.Fragment, null, $22be219fd3b9dc32$var$react_1.default.createElement($8nAI2.MenuDivider, {
            title: (0, $xARwM.t)("toolbar.spaceEvenly")
        }), $22be219fd3b9dc32$var$react_1.default.createElement("div", {
            style: {
                display: "flex"
            }
        }, $22be219fd3b9dc32$var$react_1.default.createElement("div", {
            style: {
                width: "50%"
            }
        }, " ", $22be219fd3b9dc32$var$react_1.default.createElement($2IwH6.MenuItem, {
            shouldDismissPopover: !1,
            icon: "vertical-distribution",
            text: (0, $xARwM.t)("toolbar.verticalDistribution"),
            onClick: ()=>{
                var t;
                let l = null === (t = e.activePage) || void 0 === t ? void 0 : t.computedHeight, o = 0, n = 0;
                e.selectedElements.forEach((e)=>{
                    const t = (0, $kYy5r.getClientRect)(e);
                    l = Math.min(l, t.y), o = Math.max(o, t.y + t.height), n += t.height;
                });
                const a = (o - l - n) / (e.selectedElements.length - 1), i = e.selectedElements.slice().sort((e, t)=>{
                    const l = (0, $kYy5r.getClientRect)(e), o = (0, $kYy5r.getClientRect)(t);
                    return l.y - o.y;
                });
                let c = 0;
                i.forEach((e)=>{
                    const t = (0, $kYy5r.getClientRect)(e);
                    e.set({
                        y: e.y - t.y + l + c
                    }), c += t.height + a;
                });
            }
        })), $22be219fd3b9dc32$var$react_1.default.createElement("div", {
            style: {
                width: "50%"
            }
        }, $22be219fd3b9dc32$var$react_1.default.createElement($2IwH6.MenuItem, {
            shouldDismissPopover: !1,
            icon: "horizontal-distribution",
            text: (0, $xARwM.t)("toolbar.horizontalDistribution"),
            onClick: ()=>{
                var t;
                let l = null === (t = e.activePage) || void 0 === t ? void 0 : t.computedWidth, o = 0, n = 0;
                e.selectedElements.forEach((e)=>{
                    const t = (0, $kYy5r.getClientRect)(e);
                    l = Math.min(l, t.x), o = Math.max(o, t.x + t.width), n += t.width;
                });
                const a = (o - l - n) / (e.selectedElements.length - 1), i = e.selectedElements.slice().sort((e, t)=>{
                    const l = (0, $kYy5r.getClientRect)(e), o = (0, $kYy5r.getClientRect)(t);
                    return l.x - o.x;
                });
                let c = 0;
                i.forEach((e)=>{
                    const t = (0, $kYy5r.getClientRect)(e);
                    e.set({
                        x: e.x - t.x + l + c
                    }), c += t.width + a;
                });
            }
        })))))
    }, $22be219fd3b9dc32$var$react_1.default.createElement($gUePa.Button, {
        icon: "layers",
        minimal: !0,
        text: (0, $xARwM.t)("toolbar.position"),
        disabled: !a
    }));
});

});
parcelRegister("7RyvK", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $5b9840d6a11068bc$export$d9b273488cd8ce6f);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $4Jy2D = parcelRequire("4Jy2D");
var $auzpd = parcelRequire("auzpd");

var $hffzE = parcelRequire("hffzE");
/**
 * Menu component.
 *
 * @see https://blueprintjs.com/docs/#core/components/menu
 */ var $5b9840d6a11068bc$export$d9b273488cd8ce6f = /** @class */ function(_super) {
    (0, $gztBd.__extends)(Menu, _super);
    function Menu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Menu.prototype.render = function() {
        var _a;
        var _b = this.props, className = _b.className, children = _b.children, large = _b.large, small = _b.small, ulRef = _b.ulRef, htmlProps = (0, $gztBd.__rest)(_b, [
            "className",
            "children",
            "large",
            "small",
            "ulRef"
        ]);
        var classes = (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(className, (0, $auzpd).MENU, (_a = {}, _a[(0, $auzpd).LARGE] = large, _a[(0, $auzpd).SMALL] = small, _a));
        return $8NFma.createElement("ul", (0, $gztBd.__assign)({
            role: "menu"
        }, htmlProps, {
            className: classes,
            ref: ulRef
        }), children);
    };
    Menu.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".Menu");
    return Menu;
}((0, $4Jy2D.AbstractPureComponent));

});

parcelRegister("8nAI2", function(module, exports) {

$parcel$export(module.exports, "MenuDivider", () => $619cf26de555a2ae$export$acb07b4664ac227c);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $auzpd = parcelRequire("auzpd");
var $hffzE = parcelRequire("hffzE");

var $dI9Vl = parcelRequire("dI9Vl");
/**
 * Menu divider component.
 *
 * @see https://blueprintjs.com/docs/#core/components/menu.menu-divider
 */ var $619cf26de555a2ae$export$acb07b4664ac227c = /** @class */ function(_super) {
    (0, $gztBd.__extends)(MenuDivider, _super);
    function MenuDivider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MenuDivider.prototype.render = function() {
        var _a = this.props, className = _a.className, title = _a.title, titleId = _a.titleId;
        if (title == null) // simple divider
        return $8NFma.createElement("li", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $auzpd).MENU_DIVIDER, className),
            role: "separator"
        });
        else // section header with title
        return $8NFma.createElement("li", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $auzpd).MENU_HEADER, className),
            role: "separator"
        }, $8NFma.createElement((0, $dI9Vl.H6), {
            id: titleId
        }, title));
    };
    MenuDivider.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".MenuDivider");
    return MenuDivider;
}($8NFma.Component);

});
parcelRegister("dI9Vl", function(module, exports) {

$parcel$export(module.exports, "H6", () => $9fb7151a49ee5a08$export$a559fb8039b06400);
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $auzpd = parcelRequire("auzpd");
function $9fb7151a49ee5a08$var$htmlElement(tagName, tagClassName) {
    /* eslint-disable-next-line react/display-name */ return $8NFma.forwardRef(function(props, ref) {
        var className = props.className, children = props.children, htmlProps = (0, $gztBd.__rest)(props, [
            "className",
            "children"
        ]);
        return $8NFma.createElement(tagName, (0, $gztBd.__assign)((0, $gztBd.__assign)({}, htmlProps), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(tagClassName, className),
            ref: ref
        }), children);
    });
}
var $9fb7151a49ee5a08$export$5523b16adee8048 = $9fb7151a49ee5a08$var$htmlElement("h1", (0, $auzpd.HEADING));
var $9fb7151a49ee5a08$export$cb94397127ac9363 = $9fb7151a49ee5a08$var$htmlElement("h2", (0, $auzpd.HEADING));
var $9fb7151a49ee5a08$export$746be9e3a3dfff1f = $9fb7151a49ee5a08$var$htmlElement("h3", (0, $auzpd.HEADING));
var $9fb7151a49ee5a08$export$cc5e069d64fda823 = $9fb7151a49ee5a08$var$htmlElement("h4", (0, $auzpd.HEADING));
var $9fb7151a49ee5a08$export$88ef9fdaf11f7a1f = $9fb7151a49ee5a08$var$htmlElement("h5", (0, $auzpd.HEADING));
var $9fb7151a49ee5a08$export$a559fb8039b06400 = $9fb7151a49ee5a08$var$htmlElement("h6", (0, $auzpd.HEADING));
var $9fb7151a49ee5a08$export$29a7a275fe11687 = $9fb7151a49ee5a08$var$htmlElement("blockquote", (0, $auzpd.BLOCKQUOTE));
var $9fb7151a49ee5a08$export$52f0f02147b12c03 = $9fb7151a49ee5a08$var$htmlElement("code", (0, $auzpd.CODE));
var $9fb7151a49ee5a08$export$bba54bd7e8a0d398 = $9fb7151a49ee5a08$var$htmlElement("pre", (0, $auzpd.CODE_BLOCK));
var $9fb7151a49ee5a08$export$b04be29aa201d4f5 = $9fb7151a49ee5a08$var$htmlElement("label", (0, $auzpd.LABEL));
var $9fb7151a49ee5a08$export$cf840b004443bad7 = $9fb7151a49ee5a08$var$htmlElement("ol", (0, $auzpd.LIST));
var $9fb7151a49ee5a08$export$f3ebe09c29d85c53 = $9fb7151a49ee5a08$var$htmlElement("ul", (0, $auzpd.LIST));

});


parcelRegister("2IwH6", function(module, exports) {

$parcel$export(module.exports, "MenuItem", () => $1fa90d39066add6c$export$2ce376c2cc3355c8);
/*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $b00CV = parcelRequire("b00CV");
var $4H34f = parcelRequire("4H34f");

var $auzpd = parcelRequire("auzpd");

var $hffzE = parcelRequire("hffzE");

var $lgubC = parcelRequire("lgubC");

var $gKgL3 = parcelRequire("gKgL3");

var $ixLVk = parcelRequire("ixLVk");

var $M9AJy = parcelRequire("M9AJy");

var $7RyvK = parcelRequire("7RyvK");
var $1fa90d39066add6c$export$2ce376c2cc3355c8 = $8NFma.forwardRef(function(props, ref) {
    var _a, _b;
    var active = props.active, className = props.className, children = props.children, disabled = props.disabled, icon = props.icon, intent = props.intent, labelClassName = props.labelClassName, labelElement = props.labelElement, multiline = props.multiline, popoverProps = props.popoverProps, _c = props.roleStructure, roleStructure = _c === void 0 ? "menuitem" : _c, selected = props.selected, shouldDismissPopover = props.shouldDismissPopover, submenuProps = props.submenuProps, text = props.text, textClassName = props.textClassName, _d = props.tagName, tagName = _d === void 0 ? "a" : _d, htmlTitle = props.htmlTitle, htmlProps = (0, $gztBd.__rest)(props, [
        "active",
        "className",
        "children",
        "disabled",
        "icon",
        "intent",
        "labelClassName",
        "labelElement",
        "multiline",
        "popoverProps",
        "roleStructure",
        "selected",
        "shouldDismissPopover",
        "submenuProps",
        "text",
        "textClassName",
        "tagName",
        "htmlTitle"
    ]);
    var _e = roleStructure === "listoption" // "listoption": parent has listbox role, or is a <select>
     ? [
        "option",
        undefined,
        Boolean(selected)
    ] : roleStructure === "menuitem" // "menuitem": parent has menu role
     ? [
        "none",
        "menuitem",
        undefined
    ] : roleStructure === "none" // "none": allows wrapping MenuItem in custom <li>
     ? [
        "none",
        undefined,
        undefined
    ] : [
        undefined,
        undefined,
        undefined
    ], liRole = _e[0], targetRole = _e[1], ariaSelected = _e[2];
    var isSelectable = roleStructure === "listoption";
    var isSelected = isSelectable && selected;
    var hasIcon = icon != null;
    var hasSubmenu = children != null;
    var intentClass = (0, $auzpd).intentClass(intent);
    var anchorClasses = (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $auzpd).MENU_ITEM, intentClass, (_a = {}, _a[(0, $auzpd).ACTIVE] = active, _a[(0, $auzpd).DISABLED] = disabled, // prevent popover from closing when clicking on submenu trigger or disabled item
    _a[(0, $auzpd).POPOVER_DISMISS] = shouldDismissPopover && !disabled && !hasSubmenu, _a[(0, $auzpd).MENU_ITEM_IS_SELECTABLE] = isSelectable, _a[(0, $auzpd).SELECTED] = isSelected, _a), className);
    var maybeLabel = props.label == null && labelElement == null ? null : $8NFma.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $auzpd).MENU_ITEM_LABEL, labelClassName)
    }, props.label, labelElement);
    var target = $8NFma.createElement(tagName, (0, $gztBd.__assign)((0, $gztBd.__assign)((0, $gztBd.__assign)({
        // for menuitems, onClick when enter key pressed doesn't take effect like it does for a button-- fix this
        onKeyDown: (0, $lgubC.clickElementOnKeyPress)([
            "Enter",
            " "
        ]),
        // if hasSubmenu, must apply correct role and tabIndex to the outer popover target <span> instead of this target element
        role: hasSubmenu ? "none" : targetRole,
        tabIndex: hasSubmenu ? -1 : 0
    }, (0, $hffzE.removeNonHTMLProps)(htmlProps)), disabled ? $1fa90d39066add6c$var$DISABLED_PROPS : {}), {
        className: anchorClasses
    }), isSelected ? $8NFma.createElement((0, $4H34f.SmallTick), {
        className: (0, $auzpd).MENU_ITEM_SELECTED_ICON
    }) : undefined, hasIcon ? // wrap icon in a <span> in case `icon` is a custom element rather than a built-in icon identifier,
    // so that we always render this class
    $8NFma.createElement("span", {
        className: (0, $auzpd).MENU_ITEM_ICON
    }, $8NFma.createElement((0, $gKgL3.Icon), {
        icon: icon,
        "aria-hidden": true,
        tabIndex: -1
    })) : undefined, $8NFma.createElement((0, $M9AJy.Text), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $auzpd).FILL, textClassName),
        ellipsize: !multiline,
        title: htmlTitle
    }, text), maybeLabel, hasSubmenu ? $8NFma.createElement((0, $b00CV.CaretRight), {
        className: (0, $auzpd).MENU_SUBMENU_ICON,
        title: "Open sub menu"
    }) : undefined);
    var liClasses = (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((_b = {}, _b[(0, $auzpd).MENU_SUBMENU] = hasSubmenu, _b));
    return $8NFma.createElement("li", {
        className: liClasses,
        ref: ref,
        role: liRole,
        "aria-selected": ariaSelected
    }, children == null ? target : $8NFma.createElement((0, $ixLVk.Popover), (0, $gztBd.__assign)({
        autoFocus: false,
        captureDismiss: false,
        disabled: disabled,
        enforceFocus: false,
        hoverCloseDelay: 0,
        interactionKind: "hover",
        modifiers: $1fa90d39066add6c$var$SUBMENU_POPOVER_MODIFIERS,
        targetProps: {
            role: targetRole,
            tabIndex: 0
        },
        placement: "right-start",
        usePortal: false
    }, popoverProps, {
        content: $8NFma.createElement((0, $7RyvK.Menu), (0, $gztBd.__assign)({}, submenuProps), children),
        minimal: true,
        popoverClassName: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $auzpd).MENU_SUBMENU, popoverProps === null || popoverProps === void 0 ? void 0 : popoverProps.popoverClassName)
    }), target));
});
$1fa90d39066add6c$export$2ce376c2cc3355c8.defaultProps = {
    active: false,
    disabled: false,
    multiline: false,
    popoverProps: {},
    selected: undefined,
    shouldDismissPopover: true,
    text: ""
};
$1fa90d39066add6c$export$2ce376c2cc3355c8.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".MenuItem");
var $1fa90d39066add6c$var$SUBMENU_POPOVER_MODIFIERS = {
    // 20px padding - scrollbar width + a bit
    flip: {
        options: {
            rootBoundary: "viewport",
            padding: 20
        },
        enabled: true
    },
    // shift popover up 5px so MenuItems align
    offset: {
        options: {
            offset: [
                -5,
                0
            ]
        },
        enabled: true
    },
    preventOverflow: {
        options: {
            rootBoundary: "viewport",
            padding: 20
        },
        enabled: true
    }
};
// props to ignore when disabled
var $1fa90d39066add6c$var$DISABLED_PROPS = {
    "aria-disabled": true,
    href: undefined,
    onClick: undefined,
    onMouseDown: undefined,
    onMouseEnter: undefined,
    onMouseLeave: undefined,
    tabIndex: -1
};

});
parcelRegister("b00CV", function(module, exports) {

$parcel$export(module.exports, "CaretRight", () => $80202e41891d4613$export$98ac0f496a0846de);
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $8NFma = parcelRequire("8NFma");

var $leH9B = parcelRequire("leH9B");

var $eog74 = parcelRequire("eog74");
var $80202e41891d4613$export$98ac0f496a0846de = $8NFma.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, $leH9B.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, $leH9B.IconSize).LARGE : (0, $leH9B.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return $8NFma.createElement((0, $eog74.SVGIconContainer), (0, $gztBd.__assign)({
        iconName: "caret-right",
        ref: ref
    }, props), $8NFma.createElement("path", {
        d: isLarge ? "M280 200C280 206.2 277 211.4 272.6 215.2L272.8 215.4L152.8 315.4L152.6 315.2C149.2 318 144.8 320 140 320C129 320 120 311 120 300V100C120 89 129 80 140 80C144.8 80 149.2 82 152.6 84.8L152.8 84.6L272.8 184.6L272.6 184.8C277 188.6 280 193.8 280 200z" : "M220 160C220 163 218.6 165.6 216.6 167.4L216.6 167.4L136.6 237.4L136.6 237.4C134.8 239 132.6 240 130 240C124.4 240 120 235.6 120 230V90C120 84.4 124.4 80 130 80C132.6 80 134.8 81 136.6 82.6C136.6 82.6 136.6 82.6 136.6 82.6L216.6 152.6L216.6 152.6C218.6 154.4 220 157 220 160z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
$80202e41891d4613$export$98ac0f496a0846de.defaultProps = {
    size: (0, $leH9B.IconSize).STANDARD
};
$80202e41891d4613$export$98ac0f496a0846de.displayName = "Blueprint5.Icon.CaretRight";
var $80202e41891d4613$export$2e2bcd8739ae039 = $80202e41891d4613$export$98ac0f496a0846de;

});

parcelRegister("4H34f", function(module, exports) {

$parcel$export(module.exports, "SmallTick", () => $36ad8eb771ebd7d7$export$4f10daf60b914288);
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $8NFma = parcelRequire("8NFma");

var $leH9B = parcelRequire("leH9B");

var $eog74 = parcelRequire("eog74");
var $36ad8eb771ebd7d7$export$4f10daf60b914288 = $8NFma.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, $leH9B.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, $leH9B.IconSize).LARGE : (0, $leH9B.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return $8NFma.createElement((0, $eog74.SVGIconContainer), (0, $gztBd.__assign)({
        iconName: "small-tick",
        ref: ref
    }, props), $8NFma.createElement("path", {
        d: isLarge ? "M300 300C294.4000000000001 300 289.4000000000001 297.8 285.8 294.2L160 168.2L114.2 214.2C110.6 217.8 105.6 220 100 220C89 220 80 211 80 200C80 194.4 82.2 189.4 85.8 185.8L145.8 125.8C149.4 122.2 154.4 120 160 120S170.6 122.2 174.2 125.8L314.2000000000001 265.8C317.8 269.4 320 274.4 320 280C320 291 311 300 300 300z" : "M240 220C234.4 220 229.4 217.8 225.8 214.2L140 128.2L94.2 174.2C90.6 177.8 85.6 180 80 180C69 180 60 171 60 160C60 154.4 62.2 149.4 65.8 145.8L125.8 85.8C129.4 82.2 134.4 80 140 80S150.6 82.2 154.2 85.8L254.2 185.8C257.8 189.4 260 194.4 260 200C260 211 251 220 240 220z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
$36ad8eb771ebd7d7$export$4f10daf60b914288.defaultProps = {
    size: (0, $leH9B.IconSize).STANDARD
};
$36ad8eb771ebd7d7$export$4f10daf60b914288.displayName = "Blueprint5.Icon.SmallTick";
var $36ad8eb771ebd7d7$export$2e2bcd8739ae039 = $36ad8eb771ebd7d7$export$4f10daf60b914288;

});





parcelRegister("fb0st", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b0c83d16b421d7f5$var$ReactIs, $b0c83d16b421d7f5$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("6DzO8"))();

});
parcelRegister("6DzO8", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $iz60K = parcelRequire("iz60K");
function $4d52293a79bcab4c$var$emptyFunction() {}
function $4d52293a79bcab4c$var$emptyFunctionWithReset() {}
$4d52293a79bcab4c$var$emptyFunctionWithReset.resetWarningCache = $4d52293a79bcab4c$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $iz60K) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $4d52293a79bcab4c$var$emptyFunctionWithReset,
        resetWarningCache: $4d52293a79bcab4c$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("iz60K", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $d840288929500773$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $d840288929500773$var$ReactPropTypesSecret;

});



parcelRegister("770rG", function(module, exports) {
"use strict";
var $52d9885330d54e1d$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.Toolbar = module.exports.registerToolbarComponent = void 0;

const $52d9885330d54e1d$var$react_1 = $52d9885330d54e1d$var$__importDefault((parcelRequire("8NFma")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

var $2nesQ = parcelRequire("2nesQ");
var $ccbj1 = parcelRequire("ccbj1");
var $f5Zeh = parcelRequire("f5Zeh");

const $52d9885330d54e1d$var$styled_1 = $52d9885330d54e1d$var$__importDefault((parcelRequire("MPenY")));

var $3pcZ0 = parcelRequire("3pcZ0");

var $i9w3j = parcelRequire("i9w3j");

var $9mdgj = parcelRequire("9mdgj");

var $6BBEN = parcelRequire("6BBEN");

var $hLtXc = parcelRequire("hLtXc");

var $a1B2e = parcelRequire("a1B2e");

var $eiAQ7 = parcelRequire("eiAQ7");

var $7Jat1 = parcelRequire("7Jat1");

var $fZbac = parcelRequire("fZbac");

var $7WWcq = parcelRequire("7WWcq");

var $fQSAB = parcelRequire("fQSAB");

var $318Bb = parcelRequire("318Bb");

var $ds9SU = parcelRequire("ds9SU");

var $ex8Pn = parcelRequire("ex8Pn");

var $9d0Is = parcelRequire("9d0Is");

var $2YVWw = parcelRequire("2YVWw");

var $aTTDL = parcelRequire("aTTDL");

var $tJXKh = parcelRequire("tJXKh");

var $2GDSi = parcelRequire("2GDSi");

var $gS5ZA = parcelRequire("gS5ZA");
const $52d9885330d54e1d$var$ComponentsTypes = {
    text: $9mdgj.TextToolbar,
    image: $hLtXc.ImageToolbar,
    svg: $a1B2e.SvgToolbar,
    many: $7WWcq.ManyToolbar,
    line: $eiAQ7.LineToolbar,
    video: $7Jat1.VideoToolbar,
    figure: $fZbac.FigureToolbar,
    page: $fQSAB.PageToolbar
};
function $52d9885330d54e1d$var$registerToolbarComponent(e, t) {
    $52d9885330d54e1d$var$ComponentsTypes[e] = t;
}
module.exports.registerToolbarComponent = $52d9885330d54e1d$var$registerToolbarComponent;
const $52d9885330d54e1d$var$NavbarContainer = (0, $52d9885330d54e1d$var$styled_1.default)("div")`
  white-space: nowrap;

  ${(0, $3pcZ0.mobileStyle)("\n    max-width: 100vw;\n    overflow-x: auto;\n    overflow-y: hidden;\n  ")}
`, $52d9885330d54e1d$var$NavInner = (0, $52d9885330d54e1d$var$styled_1.default)("div")`
  width: 100%;
  height: 100%;
  ${(0, $3pcZ0.mobileStyle)("\n    display: flex;\n  ")}
`;
module.exports.Toolbar = (0, $O1ETn.observer)(({ store: e, downloadButtonEnabled: t, components: o = {} })=>{
    const r = 1 === new Set(e.selectedElements.map((e)=>e.type)).size, l = 1 === e.selectedElements.length, a = e.selectedElements[0], n = e.selectedElements.every((e)=>e.styleEditable);
    let i = n && l && $52d9885330d54e1d$var$ComponentsTypes[a.type];
    r && "text" === (null == a ? void 0 : a.type) ? i = $52d9885330d54e1d$var$ComponentsTypes[a.type] : e.selectedElements.length > 1 && (i = $52d9885330d54e1d$var$ComponentsTypes.many), 0 === e.selectedElements.length && (i = $52d9885330d54e1d$var$ComponentsTypes.page), l && "text" === a.type && $gS5ZA.flags.htmlRenderEnabled && (i = $6BBEN.HtmlToolbar);
    const _ = l && a._cropModeEnabled, u = (null == o ? void 0 : o.ActionControls) || (t ? $318Bb.DownloadButton : null), s = (null == o ? void 0 : o.Position) || $2YVWw.PositionPicker, c = (null == o ? void 0 : o.Opacity) || $aTTDL.OpacityPicker, b = (null == o ? void 0 : o.Lock) || $9d0Is.LockButton, d = (null == o ? void 0 : o.Duplicate) || $ds9SU.DuplicateButton, m = (null == o ? void 0 : o.Remove) || $ex8Pn.RemoveButton, p = (null == o ? void 0 : o.Group) || $2GDSi.GroupButton, g = (null == o ? void 0 : o.History) || $i9w3j.HistoryButtons, v = (null == o ? void 0 : o.Admin) || $tJXKh.AdminButton;
    return $52d9885330d54e1d$var$react_1.default.createElement($52d9885330d54e1d$var$NavbarContainer, {
        className: "bp5-navbar"
    }, $52d9885330d54e1d$var$react_1.default.createElement($52d9885330d54e1d$var$NavInner, null, !_ && $52d9885330d54e1d$var$react_1.default.createElement(g, {
        store: e
    }), i && n && $52d9885330d54e1d$var$react_1.default.createElement(i, {
        store: e,
        components: o
    }), !_ && $52d9885330d54e1d$var$react_1.default.createElement($f5Zeh.Navbar.Group, {
        align: $2nesQ.Alignment.RIGHT
    }, "admin" === e.role && $52d9885330d54e1d$var$react_1.default.createElement(v, {
        store: e
    }), $52d9885330d54e1d$var$react_1.default.createElement(p, {
        store: e
    }), $52d9885330d54e1d$var$react_1.default.createElement(s, {
        store: e
    }), n && $52d9885330d54e1d$var$react_1.default.createElement(c, {
        store: e
    }), $52d9885330d54e1d$var$react_1.default.createElement(b, {
        store: e
    }), $52d9885330d54e1d$var$react_1.default.createElement(d, {
        store: e
    }), $52d9885330d54e1d$var$react_1.default.createElement(m, {
        store: e
    }), u && $52d9885330d54e1d$var$react_1.default.createElement($52d9885330d54e1d$var$react_1.default.Fragment, null, $52d9885330d54e1d$var$react_1.default.createElement($ccbj1.Divider, {
        style: {
            height: "100%",
            margin: "0 15px"
        }
    }), $52d9885330d54e1d$var$react_1.default.createElement(u, {
        store: e
    })))));
}), module.exports.default = module.exports.Toolbar;

});
parcelRegister("ccbj1", function(module, exports) {

$parcel$export(module.exports, "Divider", () => $8e0f601c957fc315$export$2e0a83ec2e27ecbb);
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $4Jy2D = parcelRequire("4Jy2D");

var $auzpd = parcelRequire("auzpd");

var $hffzE = parcelRequire("hffzE");
// this component is simple enough that tests would be purely tautological.
/* istanbul ignore next */ /**
 * Divider component.
 *
 * @see https://blueprintjs.com/docs/#core/components/divider
 */ var $8e0f601c957fc315$export$2e0a83ec2e27ecbb = /** @class */ function(_super) {
    (0, $gztBd.__extends)(Divider, _super);
    function Divider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Divider.prototype.render = function() {
        var _a = this.props, className = _a.className, _b = _a.tagName, tagName = _b === void 0 ? "div" : _b, htmlProps = (0, $gztBd.__rest)(_a, [
            "className",
            "tagName"
        ]);
        var classes = (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $auzpd.DIVIDER), className);
        return $8NFma.createElement(tagName, (0, $gztBd.__assign)((0, $gztBd.__assign)({}, htmlProps), {
            className: classes
        }));
    };
    Divider.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".Divider");
    return Divider;
}((0, $4Jy2D.AbstractPureComponent));

});

parcelRegister("i9w3j", function(module, exports) {
"use strict";
var $d371ee34b20618ab$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.HistoryButtons = void 0;

const $d371ee34b20618ab$var$react_1 = $d371ee34b20618ab$var$__importDefault((parcelRequire("8NFma")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

var $2nesQ = parcelRequire("2nesQ");
var $gUePa = parcelRequire("gUePa");
var $f5Zeh = parcelRequire("f5Zeh");
module.exports.HistoryButtons = (0, $O1ETn.observer)(({ store: e })=>$d371ee34b20618ab$var$react_1.default.createElement($f5Zeh.Navbar.Group, {
        align: $2nesQ.Alignment.LEFT
    }, $d371ee34b20618ab$var$react_1.default.createElement($gUePa.Button, {
        icon: "undo",
        minimal: !0,
        onClick: ()=>{
            e.history.undo();
        },
        disabled: !e.history.canUndo
    }), $d371ee34b20618ab$var$react_1.default.createElement($gUePa.Button, {
        icon: "redo",
        minimal: !0,
        onClick: ()=>{
            e.history.redo();
        },
        disabled: !e.history.canRedo
    })));

});

parcelRegister("9mdgj", function(module, exports) {
"use strict";
var $6d0074b474428d60$var$__rest = module.exports && module.exports.__rest || function(e, t) {
    var n = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (n[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var r = 0;
        for(a = Object.getOwnPropertySymbols(e); r < a.length; r++)t.indexOf(a[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[r]) && (n[a[r]] = e[a[r]]);
    }
    return n;
}, $6d0074b474428d60$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.TextToolbar = module.exports.TextSpacing = module.exports.NumberInput = module.exports.TextFill = module.exports.TextFontVariant = module.exports.TextFontSize = module.exports.TextFontFamily = void 0;

const $6d0074b474428d60$var$react_1 = $6d0074b474428d60$var$__importDefault((parcelRequire("8NFma")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

var $gUePa = parcelRequire("gUePa");
var $5tI5p = parcelRequire("5tI5p");
var $kTifg = parcelRequire("kTifg");
var $7RyvK = parcelRequire("7RyvK");
var $8nAI2 = parcelRequire("8nAI2");
var $2IwH6 = parcelRequire("2IwH6");
var $cQj25 = parcelRequire("cQj25");
var $ixLVk = parcelRequire("ixLVk");
var $71KpR = parcelRequire("71KpR");
var $88Rzx = parcelRequire("88Rzx");

var $gUePa = parcelRequire("gUePa");
var $5tI5p = parcelRequire("5tI5p");
var $kTifg = parcelRequire("kTifg");
var $7RyvK = parcelRequire("7RyvK");
var $8nAI2 = parcelRequire("8nAI2");
var $2IwH6 = parcelRequire("2IwH6");
var $cQj25 = parcelRequire("cQj25");
var $ixLVk = parcelRequire("ixLVk");
var $71KpR = parcelRequire("71KpR");
var $88Rzx = parcelRequire("88Rzx");

var $7ZgJv = parcelRequire("7ZgJv");

const $6d0074b474428d60$var$swr_1 = $6d0074b474428d60$var$__importDefault((parcelRequire("6Grnh")));

var $iPHWg = parcelRequire("iPHWg");

var $6laUv = parcelRequire("6laUv");

var $3TNde = parcelRequire("3TNde");

const $6d0074b474428d60$var$color_picker_1 = $6d0074b474428d60$var$__importDefault((parcelRequire("gaqum")));

const $6d0074b474428d60$var$filters_picker_1 = $6d0074b474428d60$var$__importDefault((parcelRequire("hPyFl")));

var $45tk4 = parcelRequire("45tk4");

var $1hndE = parcelRequire("1hndE");

const $6d0074b474428d60$var$MdcFormatLineSpacing_1 = $6d0074b474428d60$var$__importDefault((parcelRequire("8tTZP")));

const $6d0074b474428d60$var$styled_1 = $6d0074b474428d60$var$__importDefault((parcelRequire("MPenY")));

const $6d0074b474428d60$var$MdcFormatVerticalAlignTop_1 = $6d0074b474428d60$var$__importDefault((parcelRequire("elb7z")));

const $6d0074b474428d60$var$MdcFormatVerticalAlignCenter_1 = $6d0074b474428d60$var$__importDefault((parcelRequire("8JhES")));

const $6d0074b474428d60$var$MdcFormatVerticalAlignBottom_1 = $6d0074b474428d60$var$__importDefault((parcelRequire("eVEQI")));

var $xARwM = parcelRequire("xARwM");

var $gS5ZA = parcelRequire("gS5ZA");
const $6d0074b474428d60$var$Image = (0, $6d0074b474428d60$var$styled_1.default)("img")`
  height: 20px;

  .bp5-dark & {
    filter: invert(1);
  }
`, $6d0074b474428d60$var$googleFonts = (0, $iPHWg.getFontsList)(), $6d0074b474428d60$var$FontItem = ({ fontFamily: e, handleClick: t, modifiers: n, store: a, isCustom: r })=>{
    const [o, l] = $6d0074b474428d60$var$react_1.default.useState(!r);
    $6d0074b474428d60$var$react_1.default.useEffect(()=>{
        o || a.loadFont(e);
    }, [
        e,
        o
    ]);
    if ("_divider" === e) return $6d0074b474428d60$var$react_1.default.createElement("div", {
        style: {
            paddingTop: "10px"
        }
    }, $6d0074b474428d60$var$react_1.default.createElement($8nAI2.MenuDivider, null));
    const i = o ? $6d0074b474428d60$var$react_1.default.createElement($6d0074b474428d60$var$Image, {
        src: (0, $6laUv.getGoogleFontImage)(e),
        alt: e,
        onError: ()=>{
            l(!1);
        }
    }) : e;
    return $6d0074b474428d60$var$react_1.default.createElement($2IwH6.MenuItem, {
        text: i,
        active: n.active,
        disabled: n.disabled,
        onClick: t,
        style: {
            fontFamily: '"' + e + '"'
        }
    });
}, $6d0074b474428d60$var$SearchInput = ({ onChange: e, defaultValue: t })=>{
    const n = $6d0074b474428d60$var$react_1.default.useRef(null);
    return $6d0074b474428d60$var$react_1.default.useEffect(()=>{
        n.current && n.current.focus();
    }, []), $6d0074b474428d60$var$react_1.default.createElement($kTifg.InputGroup, {
        leftIcon: "search",
        inputRef: n,
        defaultValue: t,
        onChange: (t)=>e(t.target.value)
    });
}, $6d0074b474428d60$var$FontMenu = ({ store: e, fonts: t, activeFont: n, activeFontLabel: a, onFontSelect: r })=>{
    const [o, l] = $6d0074b474428d60$var$react_1.default.useState(""), i = t.filter((e)=>e.toLowerCase().indexOf(o.toLowerCase()) >= 0);
    return $6d0074b474428d60$var$react_1.default.createElement($ixLVk.Popover, {
        content: $6d0074b474428d60$var$react_1.default.createElement("div", null, $6d0074b474428d60$var$react_1.default.createElement($6d0074b474428d60$var$SearchInput, {
            onChange: (e)=>l(e),
            defaultValue: o
        }), $6d0074b474428d60$var$react_1.default.createElement("div", {
            style: {
                paddingTop: "5px"
            }
        }, $6d0074b474428d60$var$react_1.default.createElement($7ZgJv.FixedSizeList, {
            innerElementType: $6d0074b474428d60$var$react_1.default.forwardRef((e, t)=>$6d0074b474428d60$var$react_1.default.createElement($7RyvK.Menu, Object.assign({
                    ref: t
                }, e))),
            height: Math.min(400, 30 * i.length) + 10,
            width: 210,
            itemCount: i.length,
            itemSize: 30,
            children: ({ index: t, style: a })=>{
                const o = i[t];
                return $6d0074b474428d60$var$react_1.default.createElement("div", {
                    style: a
                }, $6d0074b474428d60$var$react_1.default.createElement($6d0074b474428d60$var$FontItem, {
                    key: o,
                    fontFamily: o,
                    modifiers: {
                        active: n === o
                    },
                    handleClick: ()=>r(o),
                    store: e,
                    isCustom: e.fonts.find((e)=>e.fontFamily === o) || $iPHWg.globalFonts.find((e)=>e.fontFamily === o)
                }));
            }
        })))
    }, $6d0074b474428d60$var$react_1.default.createElement($gUePa.Button, {
        text: a,
        rightIcon: "caret-down",
        minimal: !0,
        style: {
            marginRight: "5px",
            fontFamily: '"' + n + '"',
            overflow: "hidden",
            whiteSpace: "nowrap",
            maxHeight: "30px"
        }
    }));
};
module.exports.TextFontFamily = (0, $O1ETn.observer)(({ elements: e, store: t })=>{
    const { data: n, mutate: a } = (0, $6d0074b474428d60$var$swr_1.default)((0, $6laUv.getGoogleFontsListAPI)(), $3TNde.fetcher, {
        isPaused: ()=>(0, $iPHWg.isGoogleFontChanged)(),
        fallbackData: []
    });
    $6d0074b474428d60$var$react_1.default.useEffect(()=>{
        a();
    }, [
        (0, $iPHWg.isGoogleFontChanged)()
    ]);
    const r = t.fonts.concat($iPHWg.globalFonts).map((e)=>e.fontFamily).concat((null == n ? void 0 : n.length) && !(0, $iPHWg.isGoogleFontChanged)() ? n : $6d0074b474428d60$var$googleFonts);
    let o = e[0].fontFamily;
    o.length > 15 && (o = o.slice(0, 15) + "...");
    const l = [];
    t.find((e)=>("text" === e.type && l.push(e.fontFamily), !1));
    const i = [
        ...new Set(l.concat("_divider").concat(r))
    ];
    return $6d0074b474428d60$var$react_1.default.createElement($6d0074b474428d60$var$FontMenu, {
        fonts: i,
        activeFont: e[0].fontFamily,
        activeFontLabel: o,
        store: t,
        onFontSelect: (n)=>{
            t.history.transaction(()=>{
                e.forEach((e)=>{
                    e.set({
                        fontFamily: n
                    });
                });
            });
        }
    });
}), module.exports.TextFontSize = (0, $O1ETn.observer)(({ elements: e, store: t })=>$6d0074b474428d60$var$react_1.default.createElement($cQj25.NumericInput, {
        onValueChange: (n)=>{
            t.history.transaction(()=>{
                e.forEach((e)=>{
                    e.set({
                        fontSize: n,
                        width: Math.max(n, e.width)
                    });
                });
            });
        },
        value: Math.round(e[0].fontSize),
        style: {
            width: "50px"
        },
        min: 5,
        max: 4 * t.height
    }));
const $6d0074b474428d60$var$ALIGN_OPTIONS = [
    "left",
    "center",
    "right",
    "justify"
], $6d0074b474428d60$var$VERTICAL_ALIGN_OPTIONS = [
    "top",
    "middle",
    "bottom"
], $6d0074b474428d60$var$VERTICAL_ALIGN_ICONS = {
    top: $6d0074b474428d60$var$react_1.default.createElement("span", {
        className: "bp5-icon"
    }, $6d0074b474428d60$var$react_1.default.createElement($6d0074b474428d60$var$MdcFormatVerticalAlignTop_1.default, null)),
    middle: $6d0074b474428d60$var$react_1.default.createElement("span", {
        className: "bp5-icon"
    }, $6d0074b474428d60$var$react_1.default.createElement($6d0074b474428d60$var$MdcFormatVerticalAlignCenter_1.default, null)),
    bottom: $6d0074b474428d60$var$react_1.default.createElement("span", {
        className: "bp5-icon"
    }, $6d0074b474428d60$var$react_1.default.createElement($6d0074b474428d60$var$MdcFormatVerticalAlignBottom_1.default, null))
};
module.exports.TextFontVariant = (0, $O1ETn.observer)(({ elements: e, store: t })=>{
    const n = e[0];
    return $6d0074b474428d60$var$react_1.default.createElement($5tI5p.ButtonGroup, null, $6d0074b474428d60$var$react_1.default.createElement($gUePa.Button, {
        minimal: !0,
        icon: "align-" + n.align,
        onClick: ()=>{
            const a = ($6d0074b474428d60$var$ALIGN_OPTIONS.indexOf(n.align) + 1 + $6d0074b474428d60$var$ALIGN_OPTIONS.length) % $6d0074b474428d60$var$ALIGN_OPTIONS.length, r = $6d0074b474428d60$var$ALIGN_OPTIONS[a];
            t.history.transaction(()=>{
                e.forEach((e)=>{
                    e.set({
                        align: r
                    });
                });
            });
        }
    }), $gS5ZA.flags.textVerticalResizeEnabled && $6d0074b474428d60$var$react_1.default.createElement($gUePa.Button, {
        minimal: !0,
        icon: $6d0074b474428d60$var$VERTICAL_ALIGN_ICONS[n.verticalAlign],
        onClick: ()=>{
            const a = ($6d0074b474428d60$var$VERTICAL_ALIGN_OPTIONS.indexOf(n.verticalAlign) + 1 + $6d0074b474428d60$var$VERTICAL_ALIGN_OPTIONS.length) % $6d0074b474428d60$var$VERTICAL_ALIGN_OPTIONS.length, r = $6d0074b474428d60$var$VERTICAL_ALIGN_OPTIONS[a];
            t.history.transaction(()=>{
                e.forEach((e)=>{
                    e.set({
                        verticalAlign: r
                    });
                });
            });
        }
    }), $6d0074b474428d60$var$react_1.default.createElement($gUePa.Button, {
        minimal: !0,
        icon: "bold",
        active: "bold" === n.fontWeight || "700" === n.fontWeight,
        onClick: ()=>{
            const a = "bold" === n.fontWeight || "700" === n.fontWeight;
            t.history.transaction(()=>{
                e.forEach((e)=>{
                    a ? e.set({
                        fontWeight: "normal"
                    }) : e.set({
                        fontWeight: "bold"
                    });
                });
            });
        }
    }), $6d0074b474428d60$var$react_1.default.createElement($gUePa.Button, {
        minimal: !0,
        icon: "italic",
        active: "italic" === n.fontStyle,
        onClick: ()=>{
            const a = "italic" === n.fontStyle;
            t.history.transaction(()=>{
                e.forEach((e)=>{
                    a ? e.set({
                        fontStyle: "normal"
                    }) : e.set({
                        fontStyle: "italic"
                    });
                });
            });
        }
    }), $6d0074b474428d60$var$react_1.default.createElement($gUePa.Button, {
        minimal: !0,
        icon: "underline",
        active: n.textDecoration.indexOf("underline") >= 0,
        onClick: ()=>{
            let a = n.textDecoration.split(" ");
            a.indexOf("underline") >= 0 ? a = a.filter((e)=>"underline" !== e) : a.push("underline"), t.history.transaction(()=>{
                e.forEach((e)=>{
                    e.set({
                        textDecoration: a.join(" ")
                    });
                });
            });
        }
    }), $6d0074b474428d60$var$react_1.default.createElement($gUePa.Button, {
        minimal: !0,
        icon: "strikethrough",
        active: n.textDecoration.indexOf("line-through") >= 0,
        onClick: ()=>{
            let a = n.textDecoration.split(" ");
            a.indexOf("line-through") >= 0 ? a = a.filter((e)=>"line-through" !== e) : a.push("line-through"), t.history.transaction(()=>{
                e.forEach((e)=>{
                    e.set({
                        textDecoration: a.join(" ")
                    });
                });
            });
        }
    }));
}), module.exports.TextFill = (0, $O1ETn.observer)(({ elements: e, store: t })=>$6d0074b474428d60$var$react_1.default.createElement($6d0074b474428d60$var$color_picker_1.default, {
        value: e[0].fill,
        style: {
            marginRight: "5px"
        },
        gradientEnabled: !0,
        onChange: (n)=>t.history.transaction(()=>{
                e.forEach((e)=>{
                    e.set({
                        fill: n
                    });
                });
            }),
        store: t
    }));
const $6d0074b474428d60$var$limit = (e, t, n)=>Math.max(t, Math.min(n, e)), $6d0074b474428d60$var$NumberInput = (e)=>{
    var { value: t, onValueChange: n } = e, a = $6d0074b474428d60$var$__rest(e, [
        "value",
        "onValueChange"
    ]);
    const [r, o] = $6d0074b474428d60$var$react_1.default.useState(t.toString());
    $6d0074b474428d60$var$react_1.default.useEffect(()=>{
        o(t.toString());
    }, [
        t
    ]);
    return $6d0074b474428d60$var$react_1.default.createElement($cQj25.NumericInput, Object.assign({
        value: r,
        onValueChange: (e, t)=>{
            o(t), Number.isNaN(e) || n(e);
        }
    }, a));
};
module.exports.NumberInput = $6d0074b474428d60$var$NumberInput, module.exports.TextSpacing = (0, $O1ETn.observer)(({ elements: e, store: t })=>{
    const n = e[0], a = (n)=>{
        t.history.transaction(()=>{
            e.forEach((e)=>{
                e.set(n);
            });
        });
    }, r = "number" == typeof n.lineHeight ? 100 * n.lineHeight : 120;
    return $6d0074b474428d60$var$react_1.default.createElement($ixLVk.Popover, {
        content: $6d0074b474428d60$var$react_1.default.createElement("div", {
            style: {
                padding: "15px",
                width: "230px"
            }
        }, $6d0074b474428d60$var$react_1.default.createElement("div", {
            style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                paddingTop: "5px",
                paddingBottom: "5px"
            }
        }, $6d0074b474428d60$var$react_1.default.createElement("div", null, (0, $xARwM.t)("toolbar.lineHeight")), $6d0074b474428d60$var$react_1.default.createElement("div", null, $6d0074b474428d60$var$react_1.default.createElement(module.exports.NumberInput, {
            value: Math.round(r),
            onValueChange: (e)=>{
                a({
                    lineHeight: e / 100
                });
            },
            style: {
                width: "50px"
            },
            min: 50,
            max: 250,
            buttonPosition: "none"
        }))), $6d0074b474428d60$var$react_1.default.createElement($88Rzx.Slider, {
            value: Math.round(r),
            onChange: (e)=>{
                a({
                    lineHeight: e / 100
                });
            },
            min: 50,
            max: 250,
            stepSize: 1,
            showTrackFill: !1,
            labelRenderer: !1
        }), $6d0074b474428d60$var$react_1.default.createElement("div", {
            style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                paddingTop: "5px",
                paddingBottom: "5px"
            }
        }, $6d0074b474428d60$var$react_1.default.createElement("div", null, (0, $xARwM.t)("toolbar.letterSpacing")), $6d0074b474428d60$var$react_1.default.createElement("div", null, $6d0074b474428d60$var$react_1.default.createElement(module.exports.NumberInput, {
            value: Math.round(100 * n.letterSpacing),
            onValueChange: (e)=>{
                a({
                    letterSpacing: e / 100
                });
            },
            style: {
                width: "50px"
            },
            min: -50,
            max: 250,
            buttonPosition: "none"
        }))), $6d0074b474428d60$var$react_1.default.createElement($88Rzx.Slider, {
            value: Math.round(100 * n.letterSpacing),
            onChange: (e)=>{
                a({
                    letterSpacing: e / 100
                });
            },
            min: -50,
            max: 250,
            stepSize: 1,
            showTrackFill: !1,
            labelRenderer: !1
        })),
        position: $71KpR.Position.BOTTOM
    }, $6d0074b474428d60$var$react_1.default.createElement($gUePa.Button, {
        icon: $6d0074b474428d60$var$react_1.default.createElement($6d0074b474428d60$var$MdcFormatLineSpacing_1.default, {
            className: "bp5-icon",
            style: {
                fontSize: "20px"
            }
        }),
        minimal: !0
    }));
});
const $6d0074b474428d60$var$PROPS_MAP = {
    TextFontFamily: module.exports.TextFontFamily,
    TextFontSize: module.exports.TextFontSize,
    TextFontVariant: module.exports.TextFontVariant,
    TextFill: module.exports.TextFill,
    TextSpacing: module.exports.TextSpacing,
    TextFilters: $6d0074b474428d60$var$filters_picker_1.default,
    TextAnimations: $45tk4.AnimationsPicker
};
module.exports.TextToolbar = (0, $O1ETn.observer)(({ store: e, components: t })=>{
    const n = e.selectedElements, a = [
        "TextFill",
        "TextFontFamily",
        "TextFontSize",
        "TextFontVariant",
        "TextSpacing",
        "TextFilters",
        $gS5ZA.flags.animationsEnabled && "TextAnimations"
    ], r = (0, $1hndE.extendToolbar)({
        type: "text",
        usedItems: a,
        components: t
    });
    return $6d0074b474428d60$var$react_1.default.createElement($1hndE.ElementContainer, {
        items: r,
        itemRender: (a)=>{
            const r = t[a] || $6d0074b474428d60$var$PROPS_MAP[a];
            return $6d0074b474428d60$var$react_1.default.createElement(r, {
                elements: n,
                element: n[0],
                store: e,
                key: a
            });
        }
    });
}), module.exports.default = module.exports.TextToolbar;

});
parcelRegister("5tI5p", function(module, exports) {

$parcel$export(module.exports, "ButtonGroup", () => $3fd1dbc7490c0035$export$69b1032f2ecdf404);
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $auzpd = parcelRequire("auzpd");

var $hffzE = parcelRequire("hffzE");
var $3fd1dbc7490c0035$export$69b1032f2ecdf404 = $8NFma.forwardRef(function(props, ref) {
    var _a;
    var alignText = props.alignText, className = props.className, fill = props.fill, minimal = props.minimal, large = props.large, vertical = props.vertical, htmlProps = (0, $gztBd.__rest)(props, [
        "alignText",
        "className",
        "fill",
        "minimal",
        "large",
        "vertical"
    ]);
    var buttonGroupClasses = (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $auzpd).BUTTON_GROUP, (_a = {}, _a[(0, $auzpd).FILL] = fill, _a[(0, $auzpd).LARGE] = large, _a[(0, $auzpd).MINIMAL] = minimal, _a[(0, $auzpd).VERTICAL] = vertical, _a), (0, $auzpd).alignmentClass(alignText), className);
    return $8NFma.createElement("div", (0, $gztBd.__assign)({}, htmlProps, {
        ref: ref,
        className: buttonGroupClasses
    }), props.children);
});
$3fd1dbc7490c0035$export$69b1032f2ecdf404.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".ButtonGroup");

});

parcelRegister("kTifg", function(module, exports) {

$parcel$export(module.exports, "InputGroup", () => $f35718d12b8dbe95$export$6e5a9cd40e0c9b97);
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $4Jy2D = parcelRequire("4Jy2D");
var $auzpd = parcelRequire("auzpd");

var $bzsu8 = parcelRequire("bzsu8");

var $hffzE = parcelRequire("hffzE");

var $gKgL3 = parcelRequire("gKgL3");

var $bwTGj = parcelRequire("bwTGj");
var $f35718d12b8dbe95$var$NON_HTML_PROPS = [
    "onValueChange"
];
/**
 * Input group component.
 *
 * @see https://blueprintjs.com/docs/#core/components/input-group
 */ var $f35718d12b8dbe95$export$6e5a9cd40e0c9b97 = /** @class */ function(_super) {
    (0, $gztBd.__extends)(InputGroup, _super);
    function InputGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.leftElement = null;
        _this.rightElement = null;
        _this.refHandlers = {
            leftElement: function(ref) {
                return _this.leftElement = ref;
            },
            rightElement: function(ref) {
                return _this.rightElement = ref;
            }
        };
        _this.handleInputChange = function(event) {
            var _a, _b, _c, _d;
            var value = event.target.value;
            (_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, event);
            (_d = (_c = _this.props).onValueChange) === null || _d === void 0 || _d.call(_c, value, event.target);
        };
        return _this;
    }
    InputGroup.prototype.render = function() {
        var _a;
        var _b = this.props, _c = _b.asyncControl, asyncControl = _c === void 0 ? false : _c, className = _b.className, disabled = _b.disabled, fill = _b.fill, inputClassName = _b.inputClassName, inputRef = _b.inputRef, intent = _b.intent, large = _b.large, readOnly = _b.readOnly, round = _b.round, small = _b.small, _d = _b.tagName, tagName = _d === void 0 ? "div" : _d;
        var inputGroupClasses = (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $auzpd).INPUT_GROUP, (0, $auzpd).intentClass(intent), (_a = {}, _a[(0, $auzpd).DISABLED] = disabled, _a[(0, $auzpd).READ_ONLY] = readOnly, _a[(0, $auzpd).FILL] = fill, _a[(0, $auzpd).LARGE] = large, _a[(0, $auzpd).SMALL] = small, _a[(0, $auzpd).ROUND] = round, _a), className);
        var style = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, this.props.style), {
            paddingLeft: this.state.leftElementWidth,
            paddingRight: this.state.rightElementWidth
        });
        var inputProps = (0, $gztBd.__assign)((0, $gztBd.__assign)({
            type: "text"
        }, (0, $hffzE.removeNonHTMLProps)(this.props, $f35718d12b8dbe95$var$NON_HTML_PROPS, true)), {
            "aria-disabled": disabled,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $auzpd).INPUT, inputClassName),
            onChange: this.handleInputChange,
            style: style
        });
        var inputElement = asyncControl ? $8NFma.createElement((0, $bwTGj.AsyncControllableInput), (0, $gztBd.__assign)({}, inputProps, {
            inputRef: inputRef
        })) : $8NFma.createElement("input", (0, $gztBd.__assign)({}, inputProps, {
            ref: inputRef
        }));
        return $8NFma.createElement(tagName, {
            className: inputGroupClasses
        }, this.maybeRenderLeftElement(), inputElement, this.maybeRenderRightElement());
    };
    InputGroup.prototype.componentDidMount = function() {
        this.updateInputWidth();
    };
    InputGroup.prototype.componentDidUpdate = function(prevProps) {
        var _a = this.props, leftElement = _a.leftElement, rightElement = _a.rightElement;
        if (prevProps.leftElement !== leftElement || prevProps.rightElement !== rightElement) this.updateInputWidth();
    };
    InputGroup.prototype.validateProps = function(props) {
        if (props.leftElement != null && props.leftIcon != null) console.warn($bzsu8.INPUT_WARN_LEFT_ELEMENT_LEFT_ICON_MUTEX);
    };
    InputGroup.prototype.maybeRenderLeftElement = function() {
        var _a = this.props, leftElement = _a.leftElement, leftIcon = _a.leftIcon;
        if (leftElement != null) return $8NFma.createElement("span", {
            className: (0, $auzpd).INPUT_LEFT_CONTAINER,
            ref: this.refHandlers.leftElement
        }, leftElement);
        else if (leftIcon != null) return $8NFma.createElement((0, $gKgL3.Icon), {
            icon: leftIcon,
            "aria-hidden": true,
            tabIndex: -1
        });
        return undefined;
    };
    InputGroup.prototype.maybeRenderRightElement = function() {
        var rightElement = this.props.rightElement;
        if (rightElement == null) return undefined;
        return $8NFma.createElement("span", {
            className: (0, $auzpd).INPUT_ACTION,
            ref: this.refHandlers.rightElement
        }, rightElement);
    };
    InputGroup.prototype.updateInputWidth = function() {
        var _a = this.state, leftElementWidth = _a.leftElementWidth, rightElementWidth = _a.rightElementWidth;
        if (this.leftElement != null) {
            var clientWidth = this.leftElement.clientWidth;
            // small threshold to prevent infinite loops
            if (leftElementWidth === undefined || Math.abs(clientWidth - leftElementWidth) > 2) this.setState({
                leftElementWidth: clientWidth
            });
        } else this.setState({
            leftElementWidth: undefined
        });
        if (this.rightElement != null) {
            var clientWidth = this.rightElement.clientWidth;
            // small threshold to prevent infinite loops
            if (rightElementWidth === undefined || Math.abs(clientWidth - rightElementWidth) > 2) this.setState({
                rightElementWidth: clientWidth
            });
        } else this.setState({
            rightElementWidth: undefined
        });
    };
    InputGroup.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".InputGroup");
    return InputGroup;
}((0, $4Jy2D.AbstractPureComponent));

});
parcelRegister("bwTGj", function(module, exports) {

$parcel$export(module.exports, "AsyncControllableInput", () => $864de00d73695929$export$bc10c55cb47bf894);
/* !
 * Copyright 2020 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $8NFma = parcelRequire("8NFma");

var $4Jy2D = parcelRequire("4Jy2D");
var $hffzE = parcelRequire("hffzE");
/**
 * A stateful wrapper around the low-level <input> component which works around a
 * [React bug](https://github.com/facebook/react/issues/3926). This bug is reproduced when an input
 * receives CompositionEvents (for example, through IME composition) and has its value prop updated
 * asychronously. This might happen if a component chooses to do async validation of a value
 * returned by the input's `onChange` callback.
 *
 * Note: this component does not apply any Blueprint-specific styling.
 */ var $864de00d73695929$export$bc10c55cb47bf894 = /** @class */ function(_super) {
    (0, $gztBd.__extends)(AsyncControllableInput, _super);
    function AsyncControllableInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hasPendingUpdate: false,
            isComposing: false,
            nextValue: _this.props.value,
            value: _this.props.value
        };
        _this.cancelPendingCompositionEnd = null;
        _this.handleCompositionStart = function(e) {
            var _a, _b, _c;
            (_a = _this.cancelPendingCompositionEnd) === null || _a === void 0 || _a.call(_this);
            _this.setState({
                isComposing: true
            });
            (_c = (_b = _this.props).onCompositionStart) === null || _c === void 0 || _c.call(_b, e);
        };
        _this.handleCompositionEnd = function(e) {
            var _a, _b;
            // In some non-latin languages, a keystroke can end a composition event and immediately afterwards start another.
            // This can lead to unexpected characters showing up in the text input. In order to circumvent this problem, we
            // use a timeout which creates a delay which merges the two composition events, creating a more natural and predictable UX.
            // `this.state.nextValue` will become "locked" (it cannot be overwritten by the `value` prop) until a delay (10ms) has
            // passed without a new composition event starting.
            _this.cancelPendingCompositionEnd = _this.setTimeout(function() {
                return _this.setState({
                    isComposing: false
                });
            }, AsyncControllableInput.COMPOSITION_END_DELAY);
            (_b = (_a = _this.props).onCompositionEnd) === null || _b === void 0 || _b.call(_a, e);
        };
        _this.handleChange = function(e) {
            var _a, _b;
            var value = e.target.value;
            _this.setState({
                nextValue: value
            });
            (_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, e);
        };
        return _this;
    }
    AsyncControllableInput.getDerivedStateFromProps = function(nextProps, nextState) {
        if (nextState.isComposing || nextProps.value === undefined) // don't derive anything from props if:
        // - in uncontrolled mode, OR
        // - currently composing, since we'll do that after composition ends
        return null;
        var userTriggeredUpdate = nextState.nextValue !== nextState.value;
        if (userTriggeredUpdate) {
            if (nextProps.value === nextState.nextValue) {
                // parent has processed and accepted our update
                if (nextState.hasPendingUpdate) return {
                    value: nextProps.value,
                    hasPendingUpdate: false
                };
                else return {
                    value: nextState.nextValue
                };
            } else {
                if (nextProps.value === nextState.value) // we have sent the update to our parent, but it has not been processed yet. just wait.
                // DO NOT set nextValue here, since that will temporarily render a potentially stale controlled value,
                // causing the cursor to jump once the new value is accepted
                return {
                    hasPendingUpdate: true
                };
                // accept controlled update overriding user action
                return {
                    value: nextProps.value,
                    nextValue: nextProps.value,
                    hasPendingUpdate: false
                };
            }
        } else // accept controlled update, could be confirming or denying user action
        return {
            value: nextProps.value,
            nextValue: nextProps.value,
            hasPendingUpdate: false
        };
    };
    AsyncControllableInput.prototype.render = function() {
        var _a = this.state, isComposing = _a.isComposing, hasPendingUpdate = _a.hasPendingUpdate, value = _a.value, nextValue = _a.nextValue;
        var _b = this.props, inputRef = _b.inputRef, restProps = (0, $gztBd.__rest)(_b, [
            "inputRef"
        ]);
        return $8NFma.createElement("input", (0, $gztBd.__assign)({}, restProps, {
            ref: inputRef,
            // render the pending value even if it is not confirmed by a parent's async controlled update
            // so that the cursor does not jump to the end of input as reported in
            // https://github.com/palantir/blueprint/issues/4298
            value: isComposing || hasPendingUpdate ? nextValue : value,
            onCompositionStart: this.handleCompositionStart,
            onCompositionEnd: this.handleCompositionEnd,
            onChange: this.handleChange
        }));
    };
    AsyncControllableInput.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".AsyncControllableInput");
    /**
     * The amount of time (in milliseconds) which the input will wait after a compositionEnd event before
     * unlocking its state value for external updates via props. See `handleCompositionEnd` for more details.
     */ AsyncControllableInput.COMPOSITION_END_DELAY = 10;
    return AsyncControllableInput;
}((0, $4Jy2D.AbstractPureComponent));

});


parcelRegister("cQj25", function(module, exports) {

$parcel$export(module.exports, "NumericInput", () => $95991adae0e5b0a1$export$155c12e5e618c06c);
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $9cHs9 = parcelRequire("9cHs9");
var $7n6zn = parcelRequire("7n6zn");

var $4Jy2D = parcelRequire("4Jy2D");
var $auzpd = parcelRequire("auzpd");
var $hffzE = parcelRequire("hffzE");
var $1xlC6 = parcelRequire("1xlC6");
var $71KpR = parcelRequire("71KpR");
var $8k66C = parcelRequire("8k66C");
var $iP8Ix = parcelRequire("iP8Ix");

var $bzsu8 = parcelRequire("bzsu8");

var $5tI5p = parcelRequire("5tI5p");

var $gUePa = parcelRequire("gUePa");

var $1n5fR = parcelRequire("1n5fR");

var $kTifg = parcelRequire("kTifg");

var $1VEmZ = parcelRequire("1VEmZ");
var $95991adae0e5b0a1$var$IncrementDirection;
(function(IncrementDirection) {
    IncrementDirection[IncrementDirection["DOWN"] = -1] = "DOWN";
    IncrementDirection[IncrementDirection["UP"] = 1] = "UP";
})($95991adae0e5b0a1$var$IncrementDirection || ($95991adae0e5b0a1$var$IncrementDirection = {}));
var $95991adae0e5b0a1$var$NON_HTML_PROPS = [
    "allowNumericCharactersOnly",
    "buttonPosition",
    "clampValueOnBlur",
    "className",
    "defaultValue",
    "majorStepSize",
    "minorStepSize",
    "onButtonClick",
    "onValueChange",
    "selectAllOnFocus",
    "selectAllOnIncrement",
    "stepSize"
];
/**
 * Numeric input component.
 *
 * @see https://blueprintjs.com/docs/#core/components/numeric-input
 */ var $95991adae0e5b0a1$export$155c12e5e618c06c = /** @class */ function(_super) {
    (0, $gztBd.__extends)(NumericInput, _super);
    function NumericInput() {
        var _a;
        var _this = _super.apply(this, arguments) || this;
        _this.numericInputId = (0, $iP8Ix).uniqueId("numericInput");
        _this.state = {
            currentImeInputInvalid: false,
            shouldSelectAfterUpdate: false,
            stepMaxPrecision: NumericInput.getStepMaxPrecision(_this.props),
            value: (0, $1VEmZ.getValueOrEmptyValue)((_a = _this.props.value) !== null && _a !== void 0 ? _a : _this.props.defaultValue)
        };
        // updating these flags need not trigger re-renders, so don't include them in this.state.
        _this.didPasteEventJustOccur = false;
        _this.delta = 0;
        _this.inputElement = null;
        _this.inputRef = (0, $8k66C.refHandler)(_this, "inputElement", _this.props.inputRef);
        _this.incrementButtonHandlers = _this.getButtonEventHandlers($95991adae0e5b0a1$var$IncrementDirection.UP);
        _this.decrementButtonHandlers = _this.getButtonEventHandlers($95991adae0e5b0a1$var$IncrementDirection.DOWN);
        _this.getCurrentValueAsNumber = function() {
            return Number((0, $1VEmZ.parseStringToStringNumber)(_this.state.value, _this.props.locale));
        };
        _this.handleButtonClick = function(e, direction) {
            var _a, _b;
            var delta = _this.updateDelta(direction, e);
            var nextValue = _this.incrementValue(delta);
            (_b = (_a = _this.props).onButtonClick) === null || _b === void 0 || _b.call(_a, Number((0, $1VEmZ.parseStringToStringNumber)(nextValue, _this.props.locale)), nextValue);
        };
        _this.stopContinuousChange = function() {
            _this.delta = 0;
            _this.clearTimeouts();
            clearInterval(_this.intervalId);
            document.removeEventListener("mouseup", _this.stopContinuousChange);
        };
        _this.handleContinuousChange = function() {
            var _a, _b, _c, _d;
            // If either min or max prop is set, when reaching the limit
            // the button will be disabled and stopContinuousChange will be never fired,
            // hence the need to check on each iteration to properly clear the timeout
            if (_this.props.min !== undefined || _this.props.max !== undefined) {
                var min = (_a = _this.props.min) !== null && _a !== void 0 ? _a : -Infinity;
                var max = (_b = _this.props.max) !== null && _b !== void 0 ? _b : Infinity;
                var valueAsNumber = _this.getCurrentValueAsNumber();
                if (valueAsNumber <= min || valueAsNumber >= max) {
                    _this.stopContinuousChange();
                    return;
                }
            }
            var nextValue = _this.incrementValue(_this.delta);
            (_d = (_c = _this.props).onButtonClick) === null || _d === void 0 || _d.call(_c, Number((0, $1VEmZ.parseStringToStringNumber)(nextValue, _this.props.locale)), nextValue);
        };
        // Callbacks - Input
        // =================
        _this.handleInputFocus = function(e) {
            var _a, _b;
            // update this state flag to trigger update for input selection (see componentDidUpdate)
            _this.setState({
                shouldSelectAfterUpdate: _this.props.selectAllOnFocus
            });
            (_b = (_a = _this.props).onFocus) === null || _b === void 0 || _b.call(_a, e);
        };
        _this.handleInputBlur = function(e) {
            var _a, _b;
            // always disable this flag on blur so it's ready for next time.
            _this.setState({
                shouldSelectAfterUpdate: false
            });
            if (_this.props.clampValueOnBlur) {
                var value = e.target.value;
                _this.handleNextValue(_this.roundAndClampValue(value));
            }
            (_b = (_a = _this.props).onBlur) === null || _b === void 0 || _b.call(_a, e);
        };
        _this.handleInputKeyDown = function(e) {
            var _a, _b;
            if (_this.props.disabled || _this.props.readOnly) return;
            var direction;
            if (e.key === "ArrowUp") direction = $95991adae0e5b0a1$var$IncrementDirection.UP;
            else if (e.key === "ArrowDown") direction = $95991adae0e5b0a1$var$IncrementDirection.DOWN;
            if (direction !== undefined) {
                // when the input field has focus, some key combinations will modify
                // the field's selection range. we'll actually want to select all
                // text in the field after we modify the value on the following
                // lines. preventing the default selection behavior lets us do that
                // without interference.
                e.preventDefault();
                var delta = _this.updateDelta(direction, e);
                _this.incrementValue(delta);
            }
            (_b = (_a = _this.props).onKeyDown) === null || _b === void 0 || _b.call(_a, e);
        };
        _this.handleCompositionEnd = function(e) {
            if (_this.props.allowNumericCharactersOnly) {
                _this.handleNextValue((0, $1VEmZ.sanitizeNumericInput)(e.data, _this.props.locale));
                _this.setState({
                    currentImeInputInvalid: false
                });
            }
        };
        _this.handleCompositionUpdate = function(e) {
            if (_this.props.allowNumericCharactersOnly) {
                var data = e.data;
                var sanitizedValue = (0, $1VEmZ.sanitizeNumericInput)(data, _this.props.locale);
                if (sanitizedValue.length === 0 && data.length > 0) _this.setState({
                    currentImeInputInvalid: true
                });
                else _this.setState({
                    currentImeInputInvalid: false
                });
            }
        };
        _this.handleInputKeyPress = function(e) {
            var _a, _b;
            // we prohibit keystrokes in onKeyPress instead of onKeyDown, because
            // e.key is not trustworthy in onKeyDown in all browsers.
            if (_this.props.allowNumericCharactersOnly && !(0, $1VEmZ.isValidNumericKeyboardEvent)(e, _this.props.locale)) e.preventDefault();
            // eslint-disable-next-line deprecation/deprecation
            (_b = (_a = _this.props).onKeyPress) === null || _b === void 0 || _b.call(_a, e);
        };
        _this.handleInputPaste = function(e) {
            var _a, _b;
            _this.didPasteEventJustOccur = true;
            (_b = (_a = _this.props).onPaste) === null || _b === void 0 || _b.call(_a, e);
        };
        _this.handleInputChange = function(value) {
            var nextValue = value;
            if (_this.props.allowNumericCharactersOnly && _this.didPasteEventJustOccur) {
                _this.didPasteEventJustOccur = false;
                nextValue = (0, $1VEmZ.sanitizeNumericInput)(value, _this.props.locale);
            }
            _this.handleNextValue(nextValue);
            _this.setState({
                shouldSelectAfterUpdate: false
            });
        };
        return _this;
    }
    NumericInput.getDerivedStateFromProps = function(props, state) {
        var _a, _b;
        var nextState = {
            prevMaxProp: props.max,
            prevMinProp: props.min
        };
        var didMinChange = props.min !== state.prevMinProp;
        var didMaxChange = props.max !== state.prevMaxProp;
        var didBoundsChange = didMinChange || didMaxChange;
        // in controlled mode, use props.value
        // in uncontrolled mode, if state.value has not been assigned yet (upon initial mount), use props.defaultValue
        var value = (_b = (_a = props.value) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : state.value;
        var stepMaxPrecision = NumericInput.getStepMaxPrecision(props);
        var sanitizedValue = value !== NumericInput.VALUE_EMPTY ? NumericInput.roundAndClampValue(value, stepMaxPrecision, props.min, props.max, 0, props.locale) : NumericInput.VALUE_EMPTY;
        // if a new min and max were provided that cause the existing value to fall
        // outside of the new bounds, then clamp the value to the new valid range.
        if (didBoundsChange && sanitizedValue !== state.value) return (0, $gztBd.__assign)((0, $gztBd.__assign)({}, nextState), {
            stepMaxPrecision: stepMaxPrecision,
            value: sanitizedValue
        });
        return (0, $gztBd.__assign)((0, $gztBd.__assign)({}, nextState), {
            stepMaxPrecision: stepMaxPrecision,
            value: value
        });
    };
    // Value Helpers
    // =============
    NumericInput.getStepMaxPrecision = function(props) {
        if (props.minorStepSize != null) return (0, $iP8Ix).countDecimalPlaces(props.minorStepSize);
        else return (0, $iP8Ix).countDecimalPlaces(props.stepSize);
    };
    NumericInput.roundAndClampValue = function(value, stepMaxPrecision, min, max, delta, locale) {
        if (delta === void 0) delta = 0;
        if (!(0, $1VEmZ.isValueNumeric)(value, locale)) return NumericInput.VALUE_EMPTY;
        var currentValue = (0, $1VEmZ.parseStringToStringNumber)(value, locale);
        var nextValue = (0, $1VEmZ.toMaxPrecision)(Number(currentValue) + delta, stepMaxPrecision);
        var clampedValue = (0, $1VEmZ.clampValue)(nextValue, min, max);
        return (0, $1VEmZ.toLocaleString)(clampedValue, locale);
    };
    NumericInput.prototype.render = function() {
        var _a;
        var _b = this.props, buttonPosition = _b.buttonPosition, className = _b.className, fill = _b.fill, large = _b.large, small = _b.small;
        var containerClasses = (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $auzpd).NUMERIC_INPUT, (_a = {}, _a[(0, $auzpd).LARGE] = large, _a[(0, $auzpd).SMALL] = small, _a), className);
        var buttons = this.renderButtons();
        return $8NFma.createElement((0, $1n5fR.ControlGroup), {
            className: containerClasses,
            fill: fill
        }, buttonPosition === (0, $71KpR.Position).LEFT && buttons, this.renderInput(), buttonPosition === (0, $71KpR.Position).RIGHT && buttons);
    };
    NumericInput.prototype.componentDidUpdate = function(prevProps, prevState) {
        var _a, _b, _c;
        _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
        if (prevProps.inputRef !== this.props.inputRef) {
            (0, $8k66C.setRef)(prevProps.inputRef, null);
            this.inputRef = (0, $8k66C.refHandler)(this, "inputElement", this.props.inputRef);
            (0, $8k66C.setRef)(this.props.inputRef, this.inputElement);
        }
        if (this.state.shouldSelectAfterUpdate) (_a = this.inputElement) === null || _a === void 0 || _a.setSelectionRange(0, this.state.value.length);
        var didMinChange = this.props.min !== prevProps.min;
        var didMaxChange = this.props.max !== prevProps.max;
        var didBoundsChange = didMinChange || didMaxChange;
        var didLocaleChange = this.props.locale !== prevProps.locale;
        var didValueChange = this.state.value !== prevState.value;
        if (didBoundsChange && didValueChange || didLocaleChange && prevState.value !== NumericInput.VALUE_EMPTY) {
            // we clamped the value due to a bounds change, so we should fire the change callback
            var valueToParse = didLocaleChange ? prevState.value : this.state.value;
            var valueAsString = (0, $1VEmZ.parseStringToStringNumber)(valueToParse, prevProps.locale);
            var localizedValue = (0, $1VEmZ.toLocaleString)(+valueAsString, this.props.locale);
            (_c = (_b = this.props).onValueChange) === null || _c === void 0 || _c.call(_b, +valueAsString, localizedValue, this.inputElement);
        }
    };
    NumericInput.prototype.validateProps = function(nextProps) {
        var majorStepSize = nextProps.majorStepSize, max = nextProps.max, min = nextProps.min, minorStepSize = nextProps.minorStepSize, stepSize = nextProps.stepSize, value = nextProps.value;
        if (min != null && max != null && min > max) console.error($bzsu8.NUMERIC_INPUT_MIN_MAX);
        if (stepSize <= 0) console.error($bzsu8.NUMERIC_INPUT_STEP_SIZE_NON_POSITIVE);
        if (minorStepSize && minorStepSize <= 0) console.error($bzsu8.NUMERIC_INPUT_MINOR_STEP_SIZE_NON_POSITIVE);
        if (majorStepSize && majorStepSize <= 0) console.error($bzsu8.NUMERIC_INPUT_MAJOR_STEP_SIZE_NON_POSITIVE);
        if (minorStepSize && minorStepSize > stepSize) console.error($bzsu8.NUMERIC_INPUT_MINOR_STEP_SIZE_BOUND);
        if (majorStepSize && majorStepSize < stepSize) console.error($bzsu8.NUMERIC_INPUT_MAJOR_STEP_SIZE_BOUND);
        // controlled mode
        if (value != null) {
            var stepMaxPrecision = NumericInput.getStepMaxPrecision(nextProps);
            var sanitizedValue = NumericInput.roundAndClampValue(value.toString(), stepMaxPrecision, min, max, 0, this.props.locale);
            var valueDoesNotMatch = sanitizedValue !== value.toString();
            var localizedValue = (0, $1VEmZ.toLocaleString)(Number((0, $1VEmZ.parseStringToStringNumber)(value, this.props.locale)), this.props.locale);
            var isNotLocalized = sanitizedValue !== localizedValue;
            if (valueDoesNotMatch && isNotLocalized) console.warn($bzsu8.NUMERIC_INPUT_CONTROLLED_VALUE_INVALID);
        }
    };
    // Render Helpers
    // ==============
    NumericInput.prototype.renderButtons = function() {
        var _a = this.props, intent = _a.intent, max = _a.max, min = _a.min, locale = _a.locale;
        var value = (0, $1VEmZ.parseStringToStringNumber)(this.state.value, locale);
        var disabled = this.props.disabled || this.props.readOnly;
        var isIncrementDisabled = max !== undefined && value !== "" && +value >= max;
        var isDecrementDisabled = min !== undefined && value !== "" && +value <= min;
        return $8NFma.createElement((0, $5tI5p.ButtonGroup), {
            className: (0, $auzpd).FIXED,
            key: "button-group",
            vertical: true
        }, $8NFma.createElement((0, $gUePa.Button), (0, $gztBd.__assign)({
            "aria-label": "increment",
            "aria-controls": this.numericInputId,
            disabled: disabled || isIncrementDisabled,
            icon: $8NFma.createElement((0, $7n6zn.ChevronUp), null),
            intent: intent
        }, this.incrementButtonHandlers)), $8NFma.createElement((0, $gUePa.Button), (0, $gztBd.__assign)({
            "aria-label": "decrement",
            "aria-controls": this.numericInputId,
            disabled: disabled || isDecrementDisabled,
            icon: $8NFma.createElement((0, $9cHs9.ChevronDown), null),
            intent: intent
        }, this.decrementButtonHandlers)));
    };
    NumericInput.prototype.renderInput = function() {
        var inputGroupHtmlProps = (0, $hffzE.removeNonHTMLProps)(this.props, $95991adae0e5b0a1$var$NON_HTML_PROPS, true);
        var valueAsNumber = this.getCurrentValueAsNumber();
        return $8NFma.createElement((0, $kTifg.InputGroup), (0, $gztBd.__assign)({
            asyncControl: this.props.asyncControl,
            autoComplete: "off",
            id: this.numericInputId,
            role: this.props.allowNumericCharactersOnly ? "spinbutton" : undefined
        }, inputGroupHtmlProps, {
            "aria-valuemax": this.props.max,
            "aria-valuemin": this.props.min,
            "aria-valuenow": valueAsNumber,
            intent: this.state.currentImeInputInvalid ? (0, $1xlC6.Intent).DANGER : this.props.intent,
            inputClassName: this.props.inputClassName,
            inputRef: this.inputRef,
            large: this.props.large,
            leftElement: this.props.leftElement,
            leftIcon: this.props.leftIcon,
            onFocus: this.handleInputFocus,
            onBlur: this.handleInputBlur,
            onCompositionEnd: this.handleCompositionEnd,
            onCompositionUpdate: this.handleCompositionUpdate,
            onKeyDown: this.handleInputKeyDown,
            onKeyPress: this.handleInputKeyPress,
            onPaste: this.handleInputPaste,
            onValueChange: this.handleInputChange,
            rightElement: this.props.rightElement,
            small: this.props.small,
            value: this.state.value
        }));
    };
    // Callbacks - Buttons
    // ===================
    NumericInput.prototype.getButtonEventHandlers = function(direction) {
        var _this = this;
        return {
            // keydown is fired repeatedly when held so it's implicitly continuous
            onKeyDown: function(evt) {
                if (!_this.props.disabled && (0, $iP8Ix).isKeyboardClick(evt)) _this.handleButtonClick(evt, direction);
            },
            onMouseDown: function(evt) {
                if (!_this.props.disabled) {
                    _this.handleButtonClick(evt, direction);
                    _this.startContinuousChange();
                }
            }
        };
    };
    NumericInput.prototype.startContinuousChange = function() {
        var _this = this;
        // The button's onMouseUp event handler doesn't fire if the user
        // releases outside of the button, so we need to watch all the way
        // from the top.
        document.addEventListener("mouseup", this.stopContinuousChange);
        // Initial delay is slightly longer to prevent the user from
        // accidentally triggering the continuous increment/decrement.
        this.setTimeout(function() {
            _this.intervalId = window.setInterval(_this.handleContinuousChange, NumericInput.CONTINUOUS_CHANGE_INTERVAL);
        }, NumericInput.CONTINUOUS_CHANGE_DELAY);
    };
    // Data logic
    // ==========
    NumericInput.prototype.handleNextValue = function(valueAsString) {
        var _a, _b;
        if (this.props.value == null) this.setState({
            value: valueAsString
        });
        (_b = (_a = this.props).onValueChange) === null || _b === void 0 || _b.call(_a, Number((0, $1VEmZ.parseStringToStringNumber)(valueAsString, this.props.locale)), valueAsString, this.inputElement);
    };
    NumericInput.prototype.incrementValue = function(delta) {
        // pretend we're incrementing from 0 if currValue is empty
        var currValue = this.state.value === NumericInput.VALUE_EMPTY ? NumericInput.VALUE_ZERO : this.state.value;
        var nextValue = this.roundAndClampValue(currValue, delta);
        if (nextValue !== this.state.value) {
            this.handleNextValue(nextValue);
            this.setState({
                shouldSelectAfterUpdate: this.props.selectAllOnIncrement
            });
        }
        // return value used in continuous change updates
        return nextValue;
    };
    NumericInput.prototype.getIncrementDelta = function(direction, isShiftKeyPressed, isAltKeyPressed) {
        var _a = this.props, majorStepSize = _a.majorStepSize, minorStepSize = _a.minorStepSize, stepSize = _a.stepSize;
        if (isShiftKeyPressed && majorStepSize != null) return direction * majorStepSize;
        else if (isAltKeyPressed && minorStepSize != null) return direction * minorStepSize;
        else return direction * stepSize;
    };
    NumericInput.prototype.roundAndClampValue = function(value, delta) {
        if (delta === void 0) delta = 0;
        return NumericInput.roundAndClampValue(value, this.state.stepMaxPrecision, this.props.min, this.props.max, delta, this.props.locale);
    };
    NumericInput.prototype.updateDelta = function(direction, e) {
        this.delta = this.getIncrementDelta(direction, e.shiftKey, e.altKey);
        return this.delta;
    };
    NumericInput.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".NumericInput");
    NumericInput.VALUE_EMPTY = "";
    NumericInput.VALUE_ZERO = "0";
    NumericInput.defaultProps = {
        allowNumericCharactersOnly: true,
        buttonPosition: (0, $71KpR.Position).RIGHT,
        clampValueOnBlur: false,
        defaultValue: NumericInput.VALUE_EMPTY,
        large: false,
        majorStepSize: 10,
        minorStepSize: 0.1,
        selectAllOnFocus: false,
        selectAllOnIncrement: false,
        small: false,
        stepSize: 1
    };
    NumericInput.CONTINUOUS_CHANGE_DELAY = 300;
    NumericInput.CONTINUOUS_CHANGE_INTERVAL = 100;
    return NumericInput;
}((0, $4Jy2D.AbstractPureComponent));

});
parcelRegister("9cHs9", function(module, exports) {

$parcel$export(module.exports, "ChevronDown", () => $6b36f0e96c07c2f9$export$4e3778eb35f54199);
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $8NFma = parcelRequire("8NFma");

var $leH9B = parcelRequire("leH9B");

var $eog74 = parcelRequire("eog74");
var $6b36f0e96c07c2f9$export$4e3778eb35f54199 = $8NFma.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, $leH9B.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, $leH9B.IconSize).LARGE : (0, $leH9B.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return $8NFma.createElement((0, $eog74.SVGIconContainer), (0, $gztBd.__assign)({
        iconName: "chevron-down",
        ref: ref
    }, props), $8NFma.createElement("path", {
        d: isLarge ? "M320 280C314.4000000000001 280 309.4000000000001 277.8 305.8 274.2L200 168.2L94.2 274.2C90.6 277.8 85.6 280 80 280C69 280 60 271 60 260C60 254.4 62.2 249.4 65.8 245.8L185.8 125.8C189.4 122.2 194.4 120 200 120S210.6 122.2 214.2 125.8L334.2000000000001 245.8C337.8 249.4 340 254.4 340 260C340 271 331 280 320 280z" : "M240 220C234.4 220 229.4 217.8 225.8 214.2L160 148.2L94.2 214.2C90.6 217.8 85.6 220 80 220C69 220 60 211 60 200C60 194.4 62.2 189.4 65.8 185.8L145.8 105.8C149.4 102.2 154.4 100 160 100S170.6 102.2 174.2 105.8L254.2 185.8C257.8 189.4 260 194.4 260 200C260 211 251 220 240 220z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
$6b36f0e96c07c2f9$export$4e3778eb35f54199.defaultProps = {
    size: (0, $leH9B.IconSize).STANDARD
};
$6b36f0e96c07c2f9$export$4e3778eb35f54199.displayName = "Blueprint5.Icon.ChevronDown";
var $6b36f0e96c07c2f9$export$2e2bcd8739ae039 = $6b36f0e96c07c2f9$export$4e3778eb35f54199;

});

parcelRegister("7n6zn", function(module, exports) {

$parcel$export(module.exports, "ChevronUp", () => $55dfc6f8e2c1950b$export$9b80ee7d1e129684);
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $8NFma = parcelRequire("8NFma");

var $leH9B = parcelRequire("leH9B");

var $eog74 = parcelRequire("eog74");
var $55dfc6f8e2c1950b$export$9b80ee7d1e129684 = $8NFma.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, $leH9B.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, $leH9B.IconSize).LARGE : (0, $leH9B.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return $8NFma.createElement((0, $eog74.SVGIconContainer), (0, $gztBd.__assign)({
        iconName: "chevron-up",
        ref: ref
    }, props), $8NFma.createElement("path", {
        d: isLarge ? "M334.2000000000001 154.2L214.2 274.2000000000001C210.6 277.8 205.6 280 200 280S189.4 277.8 185.8 274.2L65.8 154.2C62.2 150.6 60 145.6 60 140C60 129 69 120 80 120C85.6 120 90.6 122.2 94.2 125.8L200 231.8L305.8 126C309.4000000000001 122.2 314.4000000000001 120 320 120C331 120 340 129 340 140C340 145.6 337.8 150.6 334.2000000000001 154.2z" : "M254.2 134.2L174.2 214.2C170.6 217.8 165.6 220 160 220S149.4 217.8 145.8 214.2L65.8 134.2C62.2 130.6 60 125.6 60 120C60 109 69 100 80 100C85.6 100 90.6 102.2 94.2 105.8L160 171.8L225.8 106C229.4 102.2 234.4 100 240 100C251 100 260 109 260 120C260 125.6 257.8 130.6 254.2 134.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
$55dfc6f8e2c1950b$export$9b80ee7d1e129684.defaultProps = {
    size: (0, $leH9B.IconSize).STANDARD
};
$55dfc6f8e2c1950b$export$9b80ee7d1e129684.displayName = "Blueprint5.Icon.ChevronUp";
var $55dfc6f8e2c1950b$export$2e2bcd8739ae039 = $55dfc6f8e2c1950b$export$9b80ee7d1e129684;

});

parcelRegister("1n5fR", function(module, exports) {

$parcel$export(module.exports, "ControlGroup", () => $0ffc03f1fe15176e$export$a0d46203173587a1);
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $auzpd = parcelRequire("auzpd");

var $hffzE = parcelRequire("hffzE");
var $0ffc03f1fe15176e$export$a0d46203173587a1 = $8NFma.forwardRef(function(props, ref) {
    var _a;
    var children = props.children, className = props.className, fill = props.fill, vertical = props.vertical, htmlProps = (0, $gztBd.__rest)(props, [
        "children",
        "className",
        "fill",
        "vertical"
    ]);
    var rootClasses = (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $auzpd).CONTROL_GROUP, (_a = {}, _a[(0, $auzpd).FILL] = fill, _a[(0, $auzpd).VERTICAL] = vertical, _a), className);
    return $8NFma.createElement("div", (0, $gztBd.__assign)({
        role: "group"
    }, htmlProps, {
        ref: ref,
        className: rootClasses
    }), children);
});
$0ffc03f1fe15176e$export$a0d46203173587a1.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".ControlGroup");

});

parcelRegister("1VEmZ", function(module, exports) {

$parcel$export(module.exports, "toLocaleString", () => $167a6de7a8aa80f6$export$5f2320d02799e74b);
$parcel$export(module.exports, "sanitizeNumericInput", () => $167a6de7a8aa80f6$export$1773b475753cc56b);
$parcel$export(module.exports, "clampValue", () => $167a6de7a8aa80f6$export$31ee16100cde6ce2);
$parcel$export(module.exports, "getValueOrEmptyValue", () => $167a6de7a8aa80f6$export$7bdb12257f9302ec);
$parcel$export(module.exports, "parseStringToStringNumber", () => $167a6de7a8aa80f6$export$bb9078bed6033d3d);
$parcel$export(module.exports, "isValueNumeric", () => $167a6de7a8aa80f6$export$f6d5e2ea5f852e2e);
$parcel$export(module.exports, "isValidNumericKeyboardEvent", () => $167a6de7a8aa80f6$export$f0391996ac5cc954);
$parcel$export(module.exports, "toMaxPrecision", () => $167a6de7a8aa80f6$export$c65802e82a64f039);
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $h8UCV = parcelRequire("h8UCV");
/** Returns the `decimal` number separator based on locale */ function $167a6de7a8aa80f6$var$getDecimalSeparator(locale) {
    var testNumber = 1.9;
    var testText = testNumber.toLocaleString(locale);
    var one = 1..toLocaleString(locale);
    var nine = 9..toLocaleString(locale);
    var pattern = "".concat(one, "(.+)").concat(nine);
    var result = new RegExp(pattern).exec(testText);
    return result && result[1] || ".";
}
function $167a6de7a8aa80f6$export$5f2320d02799e74b(num, locale) {
    if (locale === void 0) locale = "en-US";
    // HACKHACK: roundingPriority is not supported yet in TypeScript https://github.com/microsoft/TypeScript/issues/43336
    return $167a6de7a8aa80f6$export$1773b475753cc56b(num.toLocaleString(locale, {
        roundingPriority: "morePrecision"
    }), locale);
}
function $167a6de7a8aa80f6$export$31ee16100cde6ce2(value, min, max) {
    // defaultProps won't work if the user passes in null, so just default
    // to +/- infinity here instead, as a catch-all.
    var adjustedMin = min != null ? min : -Infinity;
    var adjustedMax = max != null ? max : Infinity;
    return (0, $h8UCV.clamp)(value, adjustedMin, adjustedMax);
}
function $167a6de7a8aa80f6$export$7bdb12257f9302ec(value) {
    if (value === void 0) value = "";
    return value.toString();
}
/** Transform the localized character (ex. "") to a javascript recognizable string number (ex. "10.99")  */ function $167a6de7a8aa80f6$var$transformLocalizedNumberToStringNumber(character, locale) {
    var charactersMap = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
    ].map(function(value) {
        return value.toLocaleString(locale);
    });
    var jsNumber = charactersMap.indexOf(character);
    if (jsNumber !== -1) return jsNumber;
    else return character;
}
function $167a6de7a8aa80f6$export$bb9078bed6033d3d(value, locale) {
    var valueAsString = "" + value;
    if (parseFloat(valueAsString).toString() === value.toString()) return value.toString();
    if (locale !== undefined) {
        var decimalSeparator = $167a6de7a8aa80f6$var$getDecimalSeparator(locale);
        var sanitizedString = $167a6de7a8aa80f6$export$1773b475753cc56b(valueAsString, locale);
        return sanitizedString.split("").map(function(character) {
            return $167a6de7a8aa80f6$var$transformLocalizedNumberToStringNumber(character, locale);
        }).join("").replace(decimalSeparator, ".");
    }
    return value.toString();
}
function $167a6de7a8aa80f6$export$f6d5e2ea5f852e2e(value, locale) {
    // checking if a string is numeric in Typescript is a big pain, because
    // we can't simply toss a string parameter to isFinite. below is the
    // essential approach that jQuery uses, which involves subtracting a
    // parsed numeric value from the string representation of the value. we
    // need to cast the value to the `any` type to allow this operation
    // between dissimilar types.
    var stringToStringNumber = $167a6de7a8aa80f6$export$bb9078bed6033d3d(value, locale);
    return value != null && stringToStringNumber - parseFloat(stringToStringNumber) + 1 >= 0;
}
function $167a6de7a8aa80f6$export$f0391996ac5cc954(e, locale) {
    // unit tests may not include e.key. don't bother disabling those events.
    if (e.key == null) return true;
    // allow modified key strokes that may involve letters and other
    // non-numeric/invalid characters (Cmd + A, Cmd + C, Cmd + V, Cmd + X).
    if (e.ctrlKey || e.altKey || e.metaKey) return true;
    // keys that print a single character when pressed have a `key` name of
    // length 1. every other key has a longer `key` name (e.g. "Backspace",
    // "ArrowUp", "Shift"). since none of those keys can print a character
    // to the field--and since they may have important native behaviors
    // beyond printing a character--we don't want to disable their effects.
    var isSingleCharKey = e.key.length === 1;
    if (!isSingleCharKey) return true;
    // now we can simply check that the single character that wants to be printed
    // is a floating-point number character that we're allowed to print.
    return $167a6de7a8aa80f6$var$isFloatingPointNumericCharacter(e.key, locale);
}
/**
 * A regex that matches a string of length 1 (i.e. a standalone character)
 * if and only if it is a floating-point number character as defined by W3C:
 * https://www.w3.org/TR/2012/WD-html-markup-20120329/datatypes.html#common.data.float
 *
 * Floating-point number characters are the only characters that can be
 * printed within a default input[type="number"]. This component should
 * behave the same way when this.props.allowNumericCharactersOnly = true.
 * See here for the input[type="number"].value spec:
 * https://www.w3.org/TR/2012/WD-html-markup-20120329/input.number.html#input.number.attrs.value
 */ function $167a6de7a8aa80f6$var$isFloatingPointNumericCharacter(character, locale) {
    if (locale !== undefined) {
        var decimalSeparator = $167a6de7a8aa80f6$var$getDecimalSeparator(locale).replace(".", "\\.");
        var numbers = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9
        ].map(function(value) {
            return value.toLocaleString(locale);
        }).join("");
        var localeFloatingPointNumericCharacterRegex = new RegExp("^[Ee" + numbers + "\\+\\-" + decimalSeparator + "]$");
        return localeFloatingPointNumericCharacterRegex.test(character);
    } else {
        var floatingPointNumericCharacterRegex = /^[Ee0-9\+\-\.]$/;
        return floatingPointNumericCharacterRegex.test(character);
    }
}
function $167a6de7a8aa80f6$export$c65802e82a64f039(value, maxPrecision) {
    // round the value to have the specified maximum precision (toFixed is the wrong choice,
    // because it would show trailing zeros in the decimal part out to the specified precision)
    // source: http://stackoverflow.com/a/18358056/5199574
    var scaleFactor = Math.pow(10, maxPrecision);
    return Math.round(value * scaleFactor) / scaleFactor;
}
/**
 * Convert Japanese full-width numbers, e.g. '５', to ASCII, e.g. '5'
 * This should be called before performing any other numeric string input validation.
 */ function $167a6de7a8aa80f6$var$convertFullWidthNumbersToAscii(value) {
    return value.replace(/[\uFF10-\uFF19]/g, function(m) {
        return String.fromCharCode(m.charCodeAt(0) - 0xfee0);
    });
}
function $167a6de7a8aa80f6$export$1773b475753cc56b(value, locale) {
    var valueChars = $167a6de7a8aa80f6$var$convertFullWidthNumbersToAscii(value).split("");
    var sanitizedValueChars = valueChars.filter(function(valueChar) {
        return $167a6de7a8aa80f6$var$isFloatingPointNumericCharacter(valueChar, locale);
    });
    return sanitizedValueChars.join("");
}

});


parcelRegister("88Rzx", function(module, exports) {

$parcel$export(module.exports, "Slider", () => $5ed8a06c6b0efc6f$export$472062a354075cee);
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $8NFma = parcelRequire("8NFma");

var $4Jy2D = parcelRequire("4Jy2D");
var $1xlC6 = parcelRequire("1xlC6");

var $hffzE = parcelRequire("hffzE");

var $kQmHi = parcelRequire("kQmHi");
/**
 * Slider component.
 *
 * @see https://blueprintjs.com/docs/#core/components/sliders.slider
 */ var $5ed8a06c6b0efc6f$export$472062a354075cee = /** @class */ function(_super) {
    (0, $gztBd.__extends)(Slider, _super);
    function Slider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Slider.prototype.render = function() {
        var _a = this.props, initialValue = _a.initialValue, intent = _a.intent, value = _a.value, onChange = _a.onChange, onRelease = _a.onRelease, handleHtmlProps = _a.handleHtmlProps, props = (0, $gztBd.__rest)(_a, [
            "initialValue",
            "intent",
            "value",
            "onChange",
            "onRelease",
            "handleHtmlProps"
        ]);
        return $8NFma.createElement((0, $kQmHi.MultiSlider), (0, $gztBd.__assign)({}, props), $8NFma.createElement((0, $kQmHi.MultiSlider).Handle, {
            value: value,
            intentAfter: value < initialValue ? intent : undefined,
            intentBefore: value >= initialValue ? intent : undefined,
            onChange: onChange,
            onRelease: onRelease,
            htmlProps: handleHtmlProps
        }), $8NFma.createElement((0, $kQmHi.MultiSlider).Handle, {
            value: initialValue,
            interactionKind: "none"
        }));
    };
    Slider.defaultProps = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, (0, $kQmHi.MultiSlider).defaultSliderProps), {
        initialValue: 0,
        intent: (0, $1xlC6.Intent).PRIMARY,
        value: 0
    });
    Slider.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".Slider");
    return Slider;
}((0, $4Jy2D.AbstractPureComponent));

});
parcelRegister("kQmHi", function(module, exports) {

$parcel$export(module.exports, "MultiSlider", () => $f2ca4537adb21e27$export$fc4448d95c7b75ac);
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $4Jy2D = parcelRequire("4Jy2D");
var $auzpd = parcelRequire("auzpd");
var $hffzE = parcelRequire("hffzE");
var $1xlC6 = parcelRequire("1xlC6");
var $iP8Ix = parcelRequire("iP8Ix");

var $bzsu8 = parcelRequire("bzsu8");

var $8IWWG = parcelRequire("8IWWG");

var $4s6fm = parcelRequire("4s6fm");

var $29qBo = parcelRequire("29qBo");
/**
 * SFC used to pass slider handle props to a `MultiSlider`.
 * This element is not rendered directly.
 */ var $f2ca4537adb21e27$var$MultiSliderHandle = function() {
    return null;
};
$f2ca4537adb21e27$var$MultiSliderHandle.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".MultiSliderHandle");
/**
 * Multi slider component.
 *
 * @see https://blueprintjs.com/docs/#core/components/sliders.multi-slider
 */ var $f2ca4537adb21e27$export$fc4448d95c7b75ac = /** @class */ function(_super) {
    (0, $gztBd.__extends)(MultiSlider, _super);
    function MultiSlider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            labelPrecision: $f2ca4537adb21e27$var$getLabelPrecision(_this.props),
            tickSize: 0,
            tickSizeRatio: 0
        };
        _this.handleElements = [];
        _this.trackElement = null;
        _this.addHandleRef = function(ref) {
            if (ref != null) _this.handleElements.push(ref);
        };
        _this.maybeHandleTrackClick = function(event) {
            if (_this.canHandleTrackEvent(event)) {
                var foundHandle = _this.nearestHandleForValue(_this.handleElements, function(handle) {
                    return handle.mouseEventClientOffset(event);
                });
                if (foundHandle) foundHandle.beginHandleMovement(event);
            }
        };
        _this.maybeHandleTrackTouch = function(event) {
            if (_this.canHandleTrackEvent(event)) {
                var foundHandle = _this.nearestHandleForValue(_this.handleElements, function(handle) {
                    return handle.touchEventClientOffset(event);
                });
                if (foundHandle) foundHandle.beginHandleTouchMovement(event);
            }
        };
        _this.canHandleTrackEvent = function(event) {
            var target = event.target;
            // ensure event does not come from inside the handle
            return !_this.props.disabled && target.closest(".".concat((0, $auzpd).SLIDER_HANDLE)) == null;
        };
        _this.getHandlerForIndex = function(index, callback) {
            return function(newValue) {
                callback === null || callback === void 0 || callback(_this.getNewHandleValues(newValue, index));
            };
        };
        _this.handleChange = function(newValues) {
            var _a, _b;
            var handleProps = $f2ca4537adb21e27$var$getSortedInteractiveHandleProps(_this.props);
            var oldValues = handleProps.map(function(handle) {
                return handle.value;
            });
            if (!(0, $iP8Ix).arraysEqual(newValues, oldValues)) {
                (_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, newValues);
                handleProps.forEach(function(handle, index) {
                    var _a;
                    if (oldValues[index] !== newValues[index]) (_a = handle.onChange) === null || _a === void 0 || _a.call(handle, newValues[index]);
                });
            }
        };
        _this.handleRelease = function(newValues) {
            var _a, _b;
            var handleProps = $f2ca4537adb21e27$var$getSortedInteractiveHandleProps(_this.props);
            (_b = (_a = _this.props).onRelease) === null || _b === void 0 || _b.call(_a, newValues);
            handleProps.forEach(function(handle, index) {
                var _a;
                (_a = handle.onRelease) === null || _a === void 0 || _a.call(handle, newValues[index]);
            });
        };
        return _this;
    }
    MultiSlider.getDerivedStateFromProps = function(props) {
        return {
            labelPrecision: MultiSlider.getLabelPrecision(props)
        };
    };
    MultiSlider.getLabelPrecision = function(_a) {
        var labelPrecision = _a.labelPrecision, stepSize = _a.stepSize;
        // infer default label precision from stepSize because that's how much the handle moves.
        return labelPrecision == null ? (0, $iP8Ix).countDecimalPlaces(stepSize) : labelPrecision;
    };
    MultiSlider.prototype.getSnapshotBeforeUpdate = function(prevProps) {
        var prevHandleProps = $f2ca4537adb21e27$var$getSortedInteractiveHandleProps(prevProps);
        var newHandleProps = $f2ca4537adb21e27$var$getSortedInteractiveHandleProps(this.props);
        if (newHandleProps.length !== prevHandleProps.length) // clear refs
        this.handleElements = [];
        return null;
    };
    MultiSlider.prototype.render = function() {
        var _a;
        var _this = this;
        var classes = (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $auzpd).SLIDER, (_a = {}, _a[(0, $auzpd).DISABLED] = this.props.disabled, _a["".concat((0, $auzpd).SLIDER, "-unlabeled")] = this.props.labelRenderer === false, _a[(0, $auzpd).VERTICAL] = this.props.vertical, _a), this.props.className);
        return $8NFma.createElement("div", {
            className: classes,
            onMouseDown: this.maybeHandleTrackClick,
            onTouchStart: this.maybeHandleTrackTouch
        }, $8NFma.createElement("div", {
            className: (0, $auzpd).SLIDER_TRACK,
            ref: function(ref) {
                return _this.trackElement = ref;
            }
        }, this.renderTracks()), $8NFma.createElement("div", {
            className: (0, $auzpd).SLIDER_AXIS
        }, this.renderLabels()), this.renderHandles());
    };
    MultiSlider.prototype.componentDidMount = function() {
        this.updateTickSize();
    };
    MultiSlider.prototype.componentDidUpdate = function(prevProps, prevState) {
        _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
        this.updateTickSize();
    };
    MultiSlider.prototype.validateProps = function(props) {
        if (props.stepSize <= 0) throw new Error($bzsu8.SLIDER_ZERO_STEP);
        if (props.labelStepSize !== undefined && props.labelValues !== undefined) throw new Error($bzsu8.MULTISLIDER_WARN_LABEL_STEP_SIZE_LABEL_VALUES_MUTEX);
        if (props.labelStepSize !== undefined && props.labelStepSize <= 0) throw new Error($bzsu8.SLIDER_ZERO_LABEL_STEP);
        if (props.min !== undefined && !isFinite(props.min)) throw new Error($bzsu8.SLIDER_MIN);
        if (props.max !== undefined && !isFinite(props.max)) throw new Error($bzsu8.SLIDER_MAX);
        var anyInvalidChildren = false;
        $8NFma.Children.forEach(props.children, function(child) {
            // allow boolean coercion to omit nulls and false values
            if (child && !(0, $iP8Ix).isElementOfType(child, MultiSlider.Handle)) anyInvalidChildren = true;
        });
        if (anyInvalidChildren) throw new Error($bzsu8.MULTISLIDER_INVALID_CHILD);
    };
    MultiSlider.prototype.formatLabel = function(value, isHandleTooltip) {
        if (isHandleTooltip === void 0) isHandleTooltip = false;
        var labelRenderer = this.props.labelRenderer;
        if (labelRenderer === false) return undefined;
        else if ((0, $iP8Ix).isFunction(labelRenderer)) return labelRenderer(value, {
            isHandleTooltip: isHandleTooltip
        });
        else return value.toFixed(this.state.labelPrecision);
    };
    MultiSlider.prototype.renderLabels = function() {
        var _this = this;
        if (this.props.labelRenderer === false) return null;
        var values = this.getLabelValues();
        var _a = this.props, max = _a.max, min = _a.min;
        var labels = values.map(function(step, i) {
            var offsetPercentage = (0, $29qBo.formatPercentage)((step - min) / (max - min));
            var style = _this.props.vertical ? {
                bottom: offsetPercentage
            } : {
                left: offsetPercentage
            };
            return $8NFma.createElement("div", {
                className: (0, $auzpd).SLIDER_LABEL,
                key: i,
                style: style
            }, _this.formatLabel(step));
        });
        return labels;
    };
    MultiSlider.prototype.renderTracks = function() {
        var trackStops = $f2ca4537adb21e27$var$getSortedHandleProps(this.props);
        trackStops.push({
            value: this.props.max
        });
        // render from current to previous, then increment previous
        var previous = {
            value: this.props.min
        };
        var handles = [];
        for(var index = 0; index < trackStops.length; index++){
            var current = trackStops[index];
            handles.push(this.renderTrackFill(index, previous, current));
            previous = current;
        }
        return handles;
    };
    MultiSlider.prototype.renderTrackFill = function(index, start, end) {
        // ensure startRatio <= endRatio
        var _a = [
            this.getOffsetRatio(start.value),
            this.getOffsetRatio(end.value)
        ].sort(function(left, right) {
            return left - right;
        }), startRatio = _a[0], endRatio = _a[1];
        var startOffset = (0, $29qBo.formatPercentage)(startRatio);
        var endOffset = (0, $29qBo.formatPercentage)(1 - endRatio);
        var orientationStyle = this.props.vertical ? {
            bottom: startOffset,
            top: endOffset,
            left: 0
        } : {
            left: startOffset,
            right: endOffset,
            top: 0
        };
        var style = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, orientationStyle), start.trackStyleAfter || end.trackStyleBefore || {});
        var classes = (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $auzpd).SLIDER_PROGRESS, (0, $auzpd).intentClass(this.getTrackIntent(start, end)));
        return $8NFma.createElement("div", {
            key: "track-".concat(index),
            className: classes,
            style: style
        });
    };
    MultiSlider.prototype.renderHandles = function() {
        var _this = this;
        var _a = this.props, disabled = _a.disabled, max = _a.max, min = _a.min, stepSize = _a.stepSize, vertical = _a.vertical;
        var handleProps = $f2ca4537adb21e27$var$getSortedInteractiveHandleProps(this.props);
        if (handleProps.length === 0) return null;
        return handleProps.map(function(_a, index) {
            var _b;
            var value = _a.value, type = _a.type, className = _a.className, htmlProps = _a.htmlProps;
            return $8NFma.createElement((0, $8IWWG.Handle), {
                htmlProps: htmlProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((_b = {}, _b[(0, $auzpd).START] = type === (0, $4s6fm.HandleType).START, _b[(0, $auzpd).END] = type === (0, $4s6fm.HandleType).END, _b), className),
                disabled: disabled,
                key: "".concat(index, "-").concat(handleProps.length),
                label: _this.formatLabel(value, true),
                max: max,
                min: min,
                onChange: _this.getHandlerForIndex(index, _this.handleChange),
                onRelease: _this.getHandlerForIndex(index, _this.handleRelease),
                ref: _this.addHandleRef,
                stepSize: stepSize,
                tickSize: _this.state.tickSize,
                tickSizeRatio: _this.state.tickSizeRatio,
                value: value,
                vertical: vertical
            });
        });
    };
    MultiSlider.prototype.nearestHandleForValue = function(handles, getOffset) {
        return (0, $29qBo.argMin)(handles, function(handle) {
            var offset = getOffset(handle);
            var offsetValue = handle.clientToValue(offset);
            var handleValue = handle.props.value;
            return Math.abs(offsetValue - handleValue);
        });
    };
    MultiSlider.prototype.getNewHandleValues = function(newValue, oldIndex) {
        var handleProps = $f2ca4537adb21e27$var$getSortedInteractiveHandleProps(this.props);
        var oldValues = handleProps.map(function(handle) {
            return handle.value;
        });
        var newValues = oldValues.slice();
        newValues[oldIndex] = newValue;
        newValues.sort(function(left, right) {
            return left - right;
        });
        var newIndex = newValues.indexOf(newValue);
        var lockIndex = this.findFirstLockedHandleIndex(oldIndex, newIndex);
        if (lockIndex === -1) (0, $29qBo.fillValues)(newValues, oldIndex, newIndex, newValue);
        else {
            // If pushing past a locked handle, discard the new value and only make the updates to clamp values against the lock.
            var lockValue = oldValues[lockIndex];
            (0, $29qBo.fillValues)(oldValues, oldIndex, lockIndex, lockValue);
            return oldValues;
        }
        return newValues;
    };
    MultiSlider.prototype.findFirstLockedHandleIndex = function(startIndex, endIndex) {
        var inc = startIndex < endIndex ? 1 : -1;
        var handleProps = $f2ca4537adb21e27$var$getSortedInteractiveHandleProps(this.props);
        for(var index = startIndex + inc; index !== endIndex + inc; index += inc){
            if (handleProps[index].interactionKind !== (0, $4s6fm.HandleInteractionKind).PUSH) return index;
        }
        return -1;
    };
    MultiSlider.prototype.getLabelValues = function() {
        var _a = this.props, labelStepSize = _a.labelStepSize, labelValues = _a.labelValues, min = _a.min, max = _a.max;
        var values = [];
        if (labelValues !== undefined) values = labelValues.slice();
        else for(var i = min; i < max || (0, $iP8Ix).approxEqual(i, max); i += labelStepSize !== null && labelStepSize !== void 0 ? labelStepSize : 1)values.push(i);
        return values;
    };
    MultiSlider.prototype.getOffsetRatio = function(value) {
        return (0, $iP8Ix).clamp((value - this.props.min) * this.state.tickSizeRatio, 0, 1);
    };
    MultiSlider.prototype.getTrackIntent = function(start, end) {
        if (!this.props.showTrackFill) return (0, $1xlC6.Intent).NONE;
        if (start.intentAfter !== undefined) return start.intentAfter;
        else if (end !== undefined && end.intentBefore !== undefined) return end.intentBefore;
        return this.props.defaultTrackIntent;
    };
    MultiSlider.prototype.updateTickSize = function() {
        if (this.trackElement != null) {
            var trackSize = this.props.vertical ? this.trackElement.clientHeight : this.trackElement.clientWidth;
            var tickSizeRatio = 1 / (this.props.max - this.props.min);
            var tickSize = trackSize * tickSizeRatio;
            this.setState({
                tickSize: tickSize,
                tickSizeRatio: tickSizeRatio
            });
        }
    };
    MultiSlider.defaultSliderProps = {
        disabled: false,
        max: 10,
        min: 0,
        showTrackFill: true,
        stepSize: 1,
        vertical: false
    };
    MultiSlider.defaultProps = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, MultiSlider.defaultSliderProps), {
        defaultTrackIntent: (0, $1xlC6.Intent).NONE
    });
    MultiSlider.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".MultiSlider");
    MultiSlider.Handle = $f2ca4537adb21e27$var$MultiSliderHandle;
    return MultiSlider;
}((0, $4Jy2D.AbstractPureComponent));
function $f2ca4537adb21e27$var$getLabelPrecision(_a) {
    var labelPrecision = _a.labelPrecision, _b = _a.stepSize, stepSize = _b === void 0 ? $f2ca4537adb21e27$export$fc4448d95c7b75ac.defaultSliderProps.stepSize : _b;
    // infer default label precision from stepSize because that's how much the handle moves.
    return labelPrecision == null ? (0, $iP8Ix).countDecimalPlaces(stepSize) : labelPrecision;
}
function $f2ca4537adb21e27$var$getSortedInteractiveHandleProps(props) {
    return $f2ca4537adb21e27$var$getSortedHandleProps(props, function(childProps) {
        return childProps.interactionKind !== (0, $4s6fm.HandleInteractionKind).NONE;
    });
}
function $f2ca4537adb21e27$var$getSortedHandleProps(_a, predicate) {
    var children = _a.children;
    if (predicate === void 0) predicate = function() {
        return true;
    };
    var maybeHandles = $8NFma.Children.map(children, function(child) {
        return (0, $iP8Ix).isElementOfType(child, $f2ca4537adb21e27$export$fc4448d95c7b75ac.Handle) && predicate(child.props) ? child.props : null;
    });
    var handles = maybeHandles != null ? maybeHandles : [];
    handles = handles.filter(function(handle) {
        return handle !== null;
    });
    handles.sort(function(left, right) {
        return left.value - right.value;
    });
    return handles;
}

});
parcelRegister("8IWWG", function(module, exports) {

$parcel$export(module.exports, "Handle", () => $65a02828fff87471$export$94890c79f4cae6d6);
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $4Jy2D = parcelRequire("4Jy2D");
var $auzpd = parcelRequire("auzpd");
var $iP8Ix = parcelRequire("iP8Ix");

var $hffzE = parcelRequire("hffzE");

var $h8UCV = parcelRequire("h8UCV");

var $29qBo = parcelRequire("29qBo");
// props that require number values, for validation
var $65a02828fff87471$var$NUMBER_PROPS = [
    "max",
    "min",
    "stepSize",
    "tickSize",
    "value"
];
/** Internal component for a Handle with click/drag/keyboard logic to determine a new value. */ var $65a02828fff87471$export$94890c79f4cae6d6 = /** @class */ function(_super) {
    (0, $gztBd.__extends)(Handle, _super);
    function Handle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isMoving: false
        };
        _this.handleElement = null;
        _this.refHandlers = {
            handle: function(el) {
                return _this.handleElement = el;
            }
        };
        _this.beginHandleMovement = function(event) {
            document.addEventListener("mousemove", _this.handleHandleMovement);
            document.addEventListener("mouseup", _this.endHandleMovement);
            _this.setState({
                isMoving: true
            });
            _this.changeValue(_this.clientToValue(_this.mouseEventClientOffset(event)));
        };
        _this.beginHandleTouchMovement = function(event) {
            document.addEventListener("touchmove", _this.handleHandleTouchMovement);
            document.addEventListener("touchend", _this.endHandleTouchMovement);
            document.addEventListener("touchcancel", _this.endHandleTouchMovement);
            _this.setState({
                isMoving: true
            });
            _this.changeValue(_this.clientToValue(_this.touchEventClientOffset(event)));
        };
        _this.getStyleProperties = function() {
            if (_this.handleElement == null) return {};
            // The handle midpoint of RangeSlider is actually shifted by a margin to
            // be on the edge of the visible handle element. Because the midpoint
            // calculation does not take this margin into account, we instead
            // measure the long side (which is equal to the short side plus the
            // margin).
            var _a = _this.props, _b = _a.min, min = _b === void 0 ? 0 : _b, tickSizeRatio = _a.tickSizeRatio, value = _a.value, vertical = _a.vertical;
            var handleMidpoint = _this.getHandleMidpointAndOffset(_this.handleElement, true).handleMidpoint;
            var offsetRatio = (value - min) * tickSizeRatio;
            var offsetCalc = "calc(".concat((0, $29qBo.formatPercentage)(offsetRatio), " - ").concat(handleMidpoint, "px)");
            return vertical ? {
                bottom: offsetCalc
            } : {
                left: offsetCalc
            };
        };
        _this.endHandleMovement = function(event) {
            _this.handleMoveEndedAt(_this.mouseEventClientOffset(event));
        };
        _this.endHandleTouchMovement = function(event) {
            _this.handleMoveEndedAt(_this.touchEventClientOffset(event));
        };
        _this.handleMoveEndedAt = function(clientPixel) {
            var _a, _b;
            _this.removeDocumentEventListeners();
            _this.setState({
                isMoving: false
            });
            // always invoke onRelease; changeValue may call onChange if value is different
            var finalValue = _this.changeValue(_this.clientToValue(clientPixel));
            (_b = (_a = _this.props).onRelease) === null || _b === void 0 || _b.call(_a, finalValue);
        };
        _this.handleHandleMovement = function(event) {
            _this.handleMovedTo(_this.mouseEventClientOffset(event));
        };
        _this.handleHandleTouchMovement = function(event) {
            _this.handleMovedTo(_this.touchEventClientOffset(event));
        };
        _this.handleMovedTo = function(clientPixel) {
            if (_this.state.isMoving && !_this.props.disabled) _this.changeValue(_this.clientToValue(clientPixel));
        };
        _this.handleKeyDown = function(event) {
            var _a = _this.props, stepSize = _a.stepSize, value = _a.value;
            var key = event.key;
            if (key === "ArrowDown" || key === "ArrowLeft") {
                _this.changeValue(value - stepSize);
                // this key event has been handled! prevent browser scroll on up/down
                event.preventDefault();
            } else if (key === "ArrowUp" || key === "ArrowRight") {
                _this.changeValue(value + stepSize);
                event.preventDefault();
            }
        };
        _this.handleKeyUp = function(event) {
            var _a, _b;
            if ((0, $iP8Ix).isArrowKey(event)) (_b = (_a = _this.props).onRelease) === null || _b === void 0 || _b.call(_a, _this.props.value);
        };
        return _this;
    }
    Handle.prototype.componentDidMount = function() {
        // The first time this component renders, it has no ref to the handle and thus incorrectly centers the handle.
        // Therefore, on the first mount, force a re-render to center the handle with the ref'd component.
        this.forceUpdate();
    };
    Handle.prototype.render = function() {
        var _a;
        var _b = this.props, className = _b.className, disabled = _b.disabled, label = _b.label, min = _b.min, max = _b.max, value = _b.value, vertical = _b.vertical, htmlProps = _b.htmlProps;
        var isMoving = this.state.isMoving;
        return $8NFma.createElement("span", (0, $gztBd.__assign)({
            role: "slider",
            tabIndex: 0
        }, htmlProps, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $auzpd).SLIDER_HANDLE, (_a = {}, _a[(0, $auzpd).ACTIVE] = isMoving, _a), className),
            onKeyDown: disabled ? undefined : this.handleKeyDown,
            onKeyUp: disabled ? undefined : this.handleKeyUp,
            onMouseDown: disabled ? undefined : this.beginHandleMovement,
            onTouchStart: disabled ? undefined : this.beginHandleTouchMovement,
            ref: this.refHandlers.handle,
            style: this.getStyleProperties(),
            "aria-valuemin": min,
            "aria-valuemax": max,
            "aria-valuenow": value,
            "aria-disabled": disabled,
            "aria-orientation": vertical ? "vertical" : "horizontal"
        }), label == null ? null : $8NFma.createElement("span", {
            className: (0, $auzpd).SLIDER_LABEL
        }, label));
    };
    Handle.prototype.componentWillUnmount = function() {
        this.removeDocumentEventListeners();
    };
    /** Convert client pixel to value between min and max. */ Handle.prototype.clientToValue = function(clientPixel) {
        var _a = this.props, stepSize = _a.stepSize, tickSize = _a.tickSize, value = _a.value, vertical = _a.vertical;
        if (this.handleElement == null) return value;
        // #1769: this logic doesn't work perfectly when the tick size is
        // smaller than the handle size; it may be off by a tick or two.
        var clientPixelNormalized = vertical ? window.innerHeight - clientPixel : clientPixel;
        var handleCenterPixel = this.getHandleElementCenterPixel(this.handleElement);
        var pixelDelta = clientPixelNormalized - handleCenterPixel;
        if (isNaN(pixelDelta)) return value;
        // convert pixels to range value in increments of `stepSize`
        return value + Math.round(pixelDelta / (tickSize * stepSize)) * stepSize;
    };
    Handle.prototype.mouseEventClientOffset = function(event) {
        return this.props.vertical ? event.clientY : event.clientX;
    };
    Handle.prototype.touchEventClientOffset = function(event) {
        var touch = event.changedTouches[0];
        return this.props.vertical ? touch.clientY : touch.clientX;
    };
    Handle.prototype.validateProps = function(props) {
        for(var _i = 0, NUMBER_PROPS_1 = $65a02828fff87471$var$NUMBER_PROPS; _i < NUMBER_PROPS_1.length; _i++){
            var prop = NUMBER_PROPS_1[_i];
            if (typeof props[prop] !== "number") throw new Error("[Blueprint] <Handle> requires number value for ".concat(prop, " prop"));
        }
    };
    /** Clamp value and invoke callback if it differs from current value */ Handle.prototype.changeValue = function(newValue, callback) {
        if (callback === void 0) callback = this.props.onChange;
        newValue = this.clamp(newValue);
        if (!isNaN(newValue) && this.props.value !== newValue) callback === null || callback === void 0 || callback(newValue);
        return newValue;
    };
    /** Clamp value between min and max props */ Handle.prototype.clamp = function(value) {
        return (0, $h8UCV.clamp)(value, this.props.min, this.props.max);
    };
    Handle.prototype.getHandleElementCenterPixel = function(handleElement) {
        var _a = this.getHandleMidpointAndOffset(handleElement), handleMidpoint = _a.handleMidpoint, handleOffset = _a.handleOffset;
        return handleOffset + handleMidpoint;
    };
    Handle.prototype.getHandleMidpointAndOffset = function(handleElement, useOppositeDimension) {
        if (useOppositeDimension === void 0) useOppositeDimension = false;
        if (handleElement == null) return {
            handleMidpoint: 0,
            handleOffset: 0
        };
        var vertical = this.props.vertical;
        // N.B. element.clientHeight does not include border size.
        // Also, element.getBoundingClientRect() is useful to get the top & left position on the page, but
        // it fails to accurately measure element width & height inside absolutely-positioned and CSS-transformed
        // containers like Popovers, so we use element.offsetWidth & offsetHeight instead (see https://github.com/palantir/blueprint/issues/4417).
        var handleRect = handleElement.getBoundingClientRect();
        handleRect.width = handleElement.offsetWidth;
        handleRect.height = handleElement.offsetHeight;
        var sizeKey = vertical ? useOppositeDimension ? "width" : "height" : useOppositeDimension ? "height" : "width";
        // "bottom" value seems to be consistently incorrect, so explicitly
        // calculate it using the window offset instead.
        var handleOffset = vertical ? window.innerHeight - (handleRect.top + handleRect[sizeKey]) : handleRect.left;
        return {
            handleMidpoint: handleRect[sizeKey] / 2,
            handleOffset: handleOffset
        };
    };
    Handle.prototype.removeDocumentEventListeners = function() {
        document.removeEventListener("mousemove", this.handleHandleMovement);
        document.removeEventListener("mouseup", this.endHandleMovement);
        document.removeEventListener("touchmove", this.handleHandleTouchMovement);
        document.removeEventListener("touchend", this.endHandleTouchMovement);
        document.removeEventListener("touchcancel", this.endHandleTouchMovement);
    };
    Handle.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".SliderHandle");
    return Handle;
}((0, $4Jy2D.AbstractPureComponent));

});
parcelRegister("29qBo", function(module, exports) {

$parcel$export(module.exports, "formatPercentage", () => $19110eac9020275e$export$3e1eee59f5dc52be);
$parcel$export(module.exports, "fillValues", () => $19110eac9020275e$export$f0f90f0300c414d);
$parcel$export(module.exports, "argMin", () => $19110eac9020275e$export$ec99a91cddfb29a2);
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Helper function for formatting ratios as CSS percentage values. */ function $19110eac9020275e$export$3e1eee59f5dc52be(ratio) {
    return "".concat((ratio * 100).toFixed(2), "%");
}
function $19110eac9020275e$export$f0f90f0300c414d(values, startIndex, endIndex, fillValue) {
    var inc = startIndex < endIndex ? 1 : -1;
    for(var index = startIndex; index !== endIndex + inc; index += inc)values[index] = fillValue;
}
function $19110eac9020275e$export$ec99a91cddfb29a2(values, argFn) {
    if (values.length === 0) return undefined;
    var minValue = values[0];
    var minArg = argFn(minValue);
    for(var index = 1; index < values.length; index++){
        var value = values[index];
        var arg = argFn(value);
        if (arg < minArg) {
            minValue = value;
            minArg = arg;
        }
    }
    return minValue;
}

});


parcelRegister("4s6fm", function(module, exports) {

$parcel$export(module.exports, "HandleType", () => $33de9f6b4ef700f9$export$d7dc57c4fbf7bb60);
$parcel$export(module.exports, "HandleInteractionKind", () => $33de9f6b4ef700f9$export$eb391d59b59f9c4b);
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $33de9f6b4ef700f9$export$d7dc57c4fbf7bb60 = {
    /** A full handle appears as a small square. */ FULL: "full",
    /** A start handle appears as the left or top half of a square. */ START: "start",
    /** An end handle appears as the right or bottom half of a square. */ END: "end"
};
var $33de9f6b4ef700f9$export$eb391d59b59f9c4b = {
    /** Locked handles prevent other handles from being dragged past then. */ LOCK: "lock",
    /** Push handles move overlapping handles with them as they are dragged. */ PUSH: "push",
    /**
     * Handles marked "none" are not interactive and do not appear in the UI.
     * They serve only to break the track into subsections that can be colored separately.
     */ NONE: "none"
};

});



parcelRegister("7ZgJv", function(module, exports) {

$parcel$export(module.exports, "FixedSizeList", () => $5d0b35b7639dac13$export$ae9e55e1d8a2f4b7);

var $jz4iA = parcelRequire("jz4iA");

var $1oVxX = parcelRequire("1oVxX");

var $gvoty = parcelRequire("gvoty");

var $j3Kiq = parcelRequire("j3Kiq");

var $8NFma = parcelRequire("8NFma");

var $hQtye = parcelRequire("hQtye");
// Animation frame based implementation of setTimeout.
// Inspired by Joe Lambert, https://gist.github.com/joelambert/1002116#file-requesttimeout-js
var $5d0b35b7639dac13$var$hasNativePerformanceNow = typeof performance === "object" && typeof performance.now === "function";
var $5d0b35b7639dac13$var$now = $5d0b35b7639dac13$var$hasNativePerformanceNow ? function() {
    return performance.now();
} : function() {
    return Date.now();
};
function $5d0b35b7639dac13$var$cancelTimeout(timeoutID) {
    cancelAnimationFrame(timeoutID.id);
}
function $5d0b35b7639dac13$var$requestTimeout(callback, delay) {
    var start = $5d0b35b7639dac13$var$now();
    function tick() {
        if ($5d0b35b7639dac13$var$now() - start >= delay) callback.call(null);
        else timeoutID.id = requestAnimationFrame(tick);
    }
    var timeoutID = {
        id: requestAnimationFrame(tick)
    };
    return timeoutID;
}
var $5d0b35b7639dac13$var$size = -1; // This utility copied from "dom-helpers" package.
function $5d0b35b7639dac13$var$getScrollbarSize(recalculate) {
    if (recalculate === void 0) recalculate = false;
    if ($5d0b35b7639dac13$var$size === -1 || recalculate) {
        var div = document.createElement("div");
        var style = div.style;
        style.width = "50px";
        style.height = "50px";
        style.overflow = "scroll";
        document.body.appendChild(div);
        $5d0b35b7639dac13$var$size = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
    }
    return $5d0b35b7639dac13$var$size;
}
var $5d0b35b7639dac13$var$cachedRTLResult = null; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
// Chrome does not seem to adhere; its scrollLeft values are positive (measured relative to the left).
// Safari's elastic bounce makes detecting this even more complicated wrt potential false positives.
// The safest way to check this is to intentionally set a negative offset,
// and then verify that the subsequent "scroll" event matches the negative offset.
// If it does not match, then we can assume a non-standard RTL scroll implementation.
function $5d0b35b7639dac13$var$getRTLOffsetType(recalculate) {
    if (recalculate === void 0) recalculate = false;
    if ($5d0b35b7639dac13$var$cachedRTLResult === null || recalculate) {
        var outerDiv = document.createElement("div");
        var outerStyle = outerDiv.style;
        outerStyle.width = "50px";
        outerStyle.height = "50px";
        outerStyle.overflow = "scroll";
        outerStyle.direction = "rtl";
        var innerDiv = document.createElement("div");
        var innerStyle = innerDiv.style;
        innerStyle.width = "100px";
        innerStyle.height = "100px";
        outerDiv.appendChild(innerDiv);
        document.body.appendChild(outerDiv);
        if (outerDiv.scrollLeft > 0) $5d0b35b7639dac13$var$cachedRTLResult = "positive-descending";
        else {
            outerDiv.scrollLeft = 1;
            if (outerDiv.scrollLeft === 0) $5d0b35b7639dac13$var$cachedRTLResult = "negative";
            else $5d0b35b7639dac13$var$cachedRTLResult = "positive-ascending";
        }
        document.body.removeChild(outerDiv);
        return $5d0b35b7639dac13$var$cachedRTLResult;
    }
    return $5d0b35b7639dac13$var$cachedRTLResult;
}
var $5d0b35b7639dac13$var$IS_SCROLLING_DEBOUNCE_INTERVAL = 150;
var $5d0b35b7639dac13$var$defaultItemKey = function defaultItemKey(_ref) {
    var columnIndex = _ref.columnIndex, data = _ref.data, rowIndex = _ref.rowIndex;
    return rowIndex + ":" + columnIndex;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.
var $5d0b35b7639dac13$var$devWarningsOverscanCount = null;
var $5d0b35b7639dac13$var$devWarningsOverscanRowsColumnsCount = null;
var $5d0b35b7639dac13$var$devWarningsTagName = null;
function $5d0b35b7639dac13$var$createGridComponent(_ref2) {
    var _class;
    var getColumnOffset = _ref2.getColumnOffset, getColumnStartIndexForOffset = _ref2.getColumnStartIndexForOffset, getColumnStopIndexForStartIndex = _ref2.getColumnStopIndexForStartIndex, getColumnWidth = _ref2.getColumnWidth, getEstimatedTotalHeight = _ref2.getEstimatedTotalHeight, getEstimatedTotalWidth = _ref2.getEstimatedTotalWidth, getOffsetForColumnAndAlignment = _ref2.getOffsetForColumnAndAlignment, getOffsetForRowAndAlignment = _ref2.getOffsetForRowAndAlignment, getRowHeight = _ref2.getRowHeight, getRowOffset = _ref2.getRowOffset, getRowStartIndexForOffset = _ref2.getRowStartIndexForOffset, getRowStopIndexForStartIndex = _ref2.getRowStopIndexForStartIndex, initInstanceProps = _ref2.initInstanceProps, shouldResetStyleCacheOnItemSizeChange = _ref2.shouldResetStyleCacheOnItemSizeChange, validateProps = _ref2.validateProps;
    return _class = /*#__PURE__*/ function(_PureComponent) {
        (0, $gvoty.default)(Grid, _PureComponent);
        // Always use explicit constructor for React components.
        // It produces less code after transpilation. (#26)
        // eslint-disable-next-line no-useless-constructor
        function Grid(props) {
            var _this;
            _this = _PureComponent.call(this, props) || this;
            _this._instanceProps = initInstanceProps(_this.props, (0, $1oVxX.default)(_this));
            _this._resetIsScrollingTimeoutId = null;
            _this._outerRef = void 0;
            _this.state = {
                instance: (0, $1oVxX.default)(_this),
                isScrolling: false,
                horizontalScrollDirection: "forward",
                scrollLeft: typeof _this.props.initialScrollLeft === "number" ? _this.props.initialScrollLeft : 0,
                scrollTop: typeof _this.props.initialScrollTop === "number" ? _this.props.initialScrollTop : 0,
                scrollUpdateWasRequested: false,
                verticalScrollDirection: "forward"
            };
            _this._callOnItemsRendered = void 0;
            _this._callOnItemsRendered = (0, $j3Kiq.default)(function(overscanColumnStartIndex, overscanColumnStopIndex, overscanRowStartIndex, overscanRowStopIndex, visibleColumnStartIndex, visibleColumnStopIndex, visibleRowStartIndex, visibleRowStopIndex) {
                return _this.props.onItemsRendered({
                    overscanColumnStartIndex: overscanColumnStartIndex,
                    overscanColumnStopIndex: overscanColumnStopIndex,
                    overscanRowStartIndex: overscanRowStartIndex,
                    overscanRowStopIndex: overscanRowStopIndex,
                    visibleColumnStartIndex: visibleColumnStartIndex,
                    visibleColumnStopIndex: visibleColumnStopIndex,
                    visibleRowStartIndex: visibleRowStartIndex,
                    visibleRowStopIndex: visibleRowStopIndex
                });
            });
            _this._callOnScroll = void 0;
            _this._callOnScroll = (0, $j3Kiq.default)(function(scrollLeft, scrollTop, horizontalScrollDirection, verticalScrollDirection, scrollUpdateWasRequested) {
                return _this.props.onScroll({
                    horizontalScrollDirection: horizontalScrollDirection,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    verticalScrollDirection: verticalScrollDirection,
                    scrollUpdateWasRequested: scrollUpdateWasRequested
                });
            });
            _this._getItemStyle = void 0;
            _this._getItemStyle = function(rowIndex, columnIndex) {
                var _this$props = _this.props, columnWidth = _this$props.columnWidth, direction = _this$props.direction, rowHeight = _this$props.rowHeight;
                var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && columnWidth, shouldResetStyleCacheOnItemSizeChange && direction, shouldResetStyleCacheOnItemSizeChange && rowHeight);
                var key = rowIndex + ":" + columnIndex;
                var style;
                if (itemStyleCache.hasOwnProperty(key)) style = itemStyleCache[key];
                else {
                    var _offset = getColumnOffset(_this.props, columnIndex, _this._instanceProps);
                    var isRtl = direction === "rtl";
                    itemStyleCache[key] = style = {
                        position: "absolute",
                        left: isRtl ? undefined : _offset,
                        right: isRtl ? _offset : undefined,
                        top: getRowOffset(_this.props, rowIndex, _this._instanceProps),
                        height: getRowHeight(_this.props, rowIndex, _this._instanceProps),
                        width: getColumnWidth(_this.props, columnIndex, _this._instanceProps)
                    };
                }
                return style;
            };
            _this._getItemStyleCache = void 0;
            _this._getItemStyleCache = (0, $j3Kiq.default)(function(_, __, ___) {
                return {};
            });
            _this._onScroll = function(event) {
                var _event$currentTarget = event.currentTarget, clientHeight = _event$currentTarget.clientHeight, clientWidth = _event$currentTarget.clientWidth, scrollLeft = _event$currentTarget.scrollLeft, scrollTop = _event$currentTarget.scrollTop, scrollHeight = _event$currentTarget.scrollHeight, scrollWidth = _event$currentTarget.scrollWidth;
                _this.setState(function(prevState) {
                    if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                    var direction = _this.props.direction; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
                    // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
                    var calculatedScrollLeft = scrollLeft;
                    if (direction === "rtl") switch($5d0b35b7639dac13$var$getRTLOffsetType()){
                        case "negative":
                            calculatedScrollLeft = -scrollLeft;
                            break;
                        case "positive-descending":
                            calculatedScrollLeft = scrollWidth - clientWidth - scrollLeft;
                            break;
                    }
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    calculatedScrollLeft = Math.max(0, Math.min(calculatedScrollLeft, scrollWidth - clientWidth));
                    var calculatedScrollTop = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
                    return {
                        isScrolling: true,
                        horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? "forward" : "backward",
                        scrollLeft: calculatedScrollLeft,
                        scrollTop: calculatedScrollTop,
                        verticalScrollDirection: prevState.scrollTop < scrollTop ? "forward" : "backward",
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._outerRefSetter = function(ref) {
                var outerRef = _this.props.outerRef;
                _this._outerRef = ref;
                if (typeof outerRef === "function") outerRef(ref);
                else if (outerRef != null && typeof outerRef === "object" && outerRef.hasOwnProperty("current")) outerRef.current = ref;
            };
            _this._resetIsScrollingDebounced = function() {
                if (_this._resetIsScrollingTimeoutId !== null) $5d0b35b7639dac13$var$cancelTimeout(_this._resetIsScrollingTimeoutId);
                _this._resetIsScrollingTimeoutId = $5d0b35b7639dac13$var$requestTimeout(_this._resetIsScrolling, $5d0b35b7639dac13$var$IS_SCROLLING_DEBOUNCE_INTERVAL);
            };
            _this._resetIsScrolling = function() {
                _this._resetIsScrollingTimeoutId = null;
                _this.setState({
                    isScrolling: false
                }, function() {
                    // Clear style cache after state update has been committed.
                    // This way we don't break pure sCU for items that don't use isScrolling param.
                    _this._getItemStyleCache(-1);
                });
            };
            return _this;
        }
        Grid.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            $5d0b35b7639dac13$var$validateSharedProps(nextProps, prevState);
            validateProps(nextProps);
            return null;
        };
        var _proto = Grid.prototype;
        _proto.scrollTo = function scrollTo(_ref3) {
            var scrollLeft = _ref3.scrollLeft, scrollTop = _ref3.scrollTop;
            if (scrollLeft !== undefined) scrollLeft = Math.max(0, scrollLeft);
            if (scrollTop !== undefined) scrollTop = Math.max(0, scrollTop);
            this.setState(function(prevState) {
                if (scrollLeft === undefined) scrollLeft = prevState.scrollLeft;
                if (scrollTop === undefined) scrollTop = prevState.scrollTop;
                if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) return null;
                return {
                    horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? "forward" : "backward",
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    scrollUpdateWasRequested: true,
                    verticalScrollDirection: prevState.scrollTop < scrollTop ? "forward" : "backward"
                };
            }, this._resetIsScrollingDebounced);
        };
        _proto.scrollToItem = function scrollToItem(_ref4) {
            var _ref4$align = _ref4.align, align = _ref4$align === void 0 ? "auto" : _ref4$align, columnIndex = _ref4.columnIndex, rowIndex = _ref4.rowIndex;
            var _this$props2 = this.props, columnCount = _this$props2.columnCount, height = _this$props2.height, rowCount = _this$props2.rowCount, width = _this$props2.width;
            var _this$state = this.state, scrollLeft = _this$state.scrollLeft, scrollTop = _this$state.scrollTop;
            var scrollbarSize = $5d0b35b7639dac13$var$getScrollbarSize();
            if (columnIndex !== undefined) columnIndex = Math.max(0, Math.min(columnIndex, columnCount - 1));
            if (rowIndex !== undefined) rowIndex = Math.max(0, Math.min(rowIndex, rowCount - 1));
            var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
            var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps); // The scrollbar size should be considered when scrolling an item into view,
            // to ensure it's fully visible.
            // But we only need to account for its size when it's actually visible.
            var horizontalScrollbarSize = estimatedTotalWidth > width ? scrollbarSize : 0;
            var verticalScrollbarSize = estimatedTotalHeight > height ? scrollbarSize : 0;
            this.scrollTo({
                scrollLeft: columnIndex !== undefined ? getOffsetForColumnAndAlignment(this.props, columnIndex, align, scrollLeft, this._instanceProps, verticalScrollbarSize) : scrollLeft,
                scrollTop: rowIndex !== undefined ? getOffsetForRowAndAlignment(this.props, rowIndex, align, scrollTop, this._instanceProps, horizontalScrollbarSize) : scrollTop
            });
        };
        _proto.componentDidMount = function componentDidMount() {
            var _this$props3 = this.props, initialScrollLeft = _this$props3.initialScrollLeft, initialScrollTop = _this$props3.initialScrollTop;
            if (this._outerRef != null) {
                var outerRef = this._outerRef;
                if (typeof initialScrollLeft === "number") outerRef.scrollLeft = initialScrollLeft;
                if (typeof initialScrollTop === "number") outerRef.scrollTop = initialScrollTop;
            }
            this._callPropsCallbacks();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            var direction = this.props.direction;
            var _this$state2 = this.state, scrollLeft = _this$state2.scrollLeft, scrollTop = _this$state2.scrollTop, scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;
            if (scrollUpdateWasRequested && this._outerRef != null) {
                // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                // So we need to determine which browser behavior we're dealing with, and mimic it.
                var outerRef = this._outerRef;
                if (direction === "rtl") switch($5d0b35b7639dac13$var$getRTLOffsetType()){
                    case "negative":
                        outerRef.scrollLeft = -scrollLeft;
                        break;
                    case "positive-ascending":
                        outerRef.scrollLeft = scrollLeft;
                        break;
                    default:
                        var clientWidth = outerRef.clientWidth, scrollWidth = outerRef.scrollWidth;
                        outerRef.scrollLeft = scrollWidth - clientWidth - scrollLeft;
                        break;
                }
                else outerRef.scrollLeft = Math.max(0, scrollLeft);
                outerRef.scrollTop = Math.max(0, scrollTop);
            }
            this._callPropsCallbacks();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            if (this._resetIsScrollingTimeoutId !== null) $5d0b35b7639dac13$var$cancelTimeout(this._resetIsScrollingTimeoutId);
        };
        _proto.render = function render() {
            var _this$props4 = this.props, children = _this$props4.children, className = _this$props4.className, columnCount = _this$props4.columnCount, direction = _this$props4.direction, height = _this$props4.height, innerRef = _this$props4.innerRef, innerElementType = _this$props4.innerElementType, innerTagName = _this$props4.innerTagName, itemData = _this$props4.itemData, _this$props4$itemKey = _this$props4.itemKey, itemKey = _this$props4$itemKey === void 0 ? $5d0b35b7639dac13$var$defaultItemKey : _this$props4$itemKey, outerElementType = _this$props4.outerElementType, outerTagName = _this$props4.outerTagName, rowCount = _this$props4.rowCount, style = _this$props4.style, useIsScrolling = _this$props4.useIsScrolling, width = _this$props4.width;
            var isScrolling = this.state.isScrolling;
            var _this$_getHorizontalR = this._getHorizontalRangeToRender(), columnStartIndex = _this$_getHorizontalR[0], columnStopIndex = _this$_getHorizontalR[1];
            var _this$_getVerticalRan = this._getVerticalRangeToRender(), rowStartIndex = _this$_getVerticalRan[0], rowStopIndex = _this$_getVerticalRan[1];
            var items = [];
            if (columnCount > 0 && rowCount) {
                for(var _rowIndex = rowStartIndex; _rowIndex <= rowStopIndex; _rowIndex++)for(var _columnIndex = columnStartIndex; _columnIndex <= columnStopIndex; _columnIndex++)items.push((0, $8NFma.createElement)(children, {
                    columnIndex: _columnIndex,
                    data: itemData,
                    isScrolling: useIsScrolling ? isScrolling : undefined,
                    key: itemKey({
                        columnIndex: _columnIndex,
                        data: itemData,
                        rowIndex: _rowIndex
                    }),
                    rowIndex: _rowIndex,
                    style: this._getItemStyle(_rowIndex, _columnIndex)
                }));
            } // Read this value AFTER items have been created,
            // So their actual sizes (if variable) are taken into consideration.
            var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
            var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps);
            return (0, $8NFma.createElement)(outerElementType || outerTagName || "div", {
                className: className,
                onScroll: this._onScroll,
                ref: this._outerRefSetter,
                style: (0, $jz4iA.default)({
                    position: "relative",
                    height: height,
                    width: width,
                    overflow: "auto",
                    WebkitOverflowScrolling: "touch",
                    willChange: "transform",
                    direction: direction
                }, style)
            }, (0, $8NFma.createElement)(innerElementType || innerTagName || "div", {
                children: items,
                ref: innerRef,
                style: {
                    height: estimatedTotalHeight,
                    pointerEvents: isScrolling ? "none" : undefined,
                    width: estimatedTotalWidth
                }
            }));
        };
        _proto._callPropsCallbacks = function _callPropsCallbacks() {
            var _this$props5 = this.props, columnCount = _this$props5.columnCount, onItemsRendered = _this$props5.onItemsRendered, onScroll = _this$props5.onScroll, rowCount = _this$props5.rowCount;
            if (typeof onItemsRendered === "function") {
                if (columnCount > 0 && rowCount > 0) {
                    var _this$_getHorizontalR2 = this._getHorizontalRangeToRender(), _overscanColumnStartIndex = _this$_getHorizontalR2[0], _overscanColumnStopIndex = _this$_getHorizontalR2[1], _visibleColumnStartIndex = _this$_getHorizontalR2[2], _visibleColumnStopIndex = _this$_getHorizontalR2[3];
                    var _this$_getVerticalRan2 = this._getVerticalRangeToRender(), _overscanRowStartIndex = _this$_getVerticalRan2[0], _overscanRowStopIndex = _this$_getVerticalRan2[1], _visibleRowStartIndex = _this$_getVerticalRan2[2], _visibleRowStopIndex = _this$_getVerticalRan2[3];
                    this._callOnItemsRendered(_overscanColumnStartIndex, _overscanColumnStopIndex, _overscanRowStartIndex, _overscanRowStopIndex, _visibleColumnStartIndex, _visibleColumnStopIndex, _visibleRowStartIndex, _visibleRowStopIndex);
                }
            }
            if (typeof onScroll === "function") {
                var _this$state3 = this.state, _horizontalScrollDirection = _this$state3.horizontalScrollDirection, _scrollLeft = _this$state3.scrollLeft, _scrollTop = _this$state3.scrollTop, _scrollUpdateWasRequested = _this$state3.scrollUpdateWasRequested, _verticalScrollDirection = _this$state3.verticalScrollDirection;
                this._callOnScroll(_scrollLeft, _scrollTop, _horizontalScrollDirection, _verticalScrollDirection, _scrollUpdateWasRequested);
            }
        } // Lazily create and cache item styles while scrolling,
        ;
        _proto._getHorizontalRangeToRender = function _getHorizontalRangeToRender() {
            var _this$props6 = this.props, columnCount = _this$props6.columnCount, overscanColumnCount = _this$props6.overscanColumnCount, overscanColumnsCount = _this$props6.overscanColumnsCount, overscanCount = _this$props6.overscanCount, rowCount = _this$props6.rowCount;
            var _this$state4 = this.state, horizontalScrollDirection = _this$state4.horizontalScrollDirection, isScrolling = _this$state4.isScrolling, scrollLeft = _this$state4.scrollLeft;
            var overscanCountResolved = overscanColumnCount || overscanColumnsCount || overscanCount || 1;
            if (columnCount === 0 || rowCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getColumnStartIndexForOffset(this.props, scrollLeft, this._instanceProps);
            var stopIndex = getColumnStopIndexForStartIndex(this.props, startIndex, scrollLeft, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || horizontalScrollDirection === "backward" ? Math.max(1, overscanCountResolved) : 1;
            var overscanForward = !isScrolling || horizontalScrollDirection === "forward" ? Math.max(1, overscanCountResolved) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(columnCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        _proto._getVerticalRangeToRender = function _getVerticalRangeToRender() {
            var _this$props7 = this.props, columnCount = _this$props7.columnCount, overscanCount = _this$props7.overscanCount, overscanRowCount = _this$props7.overscanRowCount, overscanRowsCount = _this$props7.overscanRowsCount, rowCount = _this$props7.rowCount;
            var _this$state5 = this.state, isScrolling = _this$state5.isScrolling, verticalScrollDirection = _this$state5.verticalScrollDirection, scrollTop = _this$state5.scrollTop;
            var overscanCountResolved = overscanRowCount || overscanRowsCount || overscanCount || 1;
            if (columnCount === 0 || rowCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getRowStartIndexForOffset(this.props, scrollTop, this._instanceProps);
            var stopIndex = getRowStopIndexForStartIndex(this.props, startIndex, scrollTop, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || verticalScrollDirection === "backward" ? Math.max(1, overscanCountResolved) : 1;
            var overscanForward = !isScrolling || verticalScrollDirection === "forward" ? Math.max(1, overscanCountResolved) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(rowCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        return Grid;
    }((0, $8NFma.PureComponent)), _class.defaultProps = {
        direction: "ltr",
        itemData: undefined,
        useIsScrolling: false
    }, _class;
}
var $5d0b35b7639dac13$var$validateSharedProps = function validateSharedProps(_ref5, _ref6) {
    var children = _ref5.children, direction = _ref5.direction, height = _ref5.height, innerTagName = _ref5.innerTagName, outerTagName = _ref5.outerTagName, overscanColumnsCount = _ref5.overscanColumnsCount, overscanCount = _ref5.overscanCount, overscanRowsCount = _ref5.overscanRowsCount, width = _ref5.width;
    var instance = _ref6.instance;
};
var $5d0b35b7639dac13$var$DEFAULT_ESTIMATED_ITEM_SIZE = 50;
var $5d0b35b7639dac13$var$getEstimatedTotalHeight = function getEstimatedTotalHeight(_ref, _ref2) {
    var rowCount = _ref.rowCount;
    var rowMetadataMap = _ref2.rowMetadataMap, estimatedRowHeight = _ref2.estimatedRowHeight, lastMeasuredRowIndex = _ref2.lastMeasuredRowIndex;
    var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredRowIndex >= rowCount) lastMeasuredRowIndex = rowCount - 1;
    if (lastMeasuredRowIndex >= 0) {
        var itemMetadata = rowMetadataMap[lastMeasuredRowIndex];
        totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = rowCount - lastMeasuredRowIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedRowHeight;
    return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};
var $5d0b35b7639dac13$var$getEstimatedTotalWidth = function getEstimatedTotalWidth(_ref3, _ref4) {
    var columnCount = _ref3.columnCount;
    var columnMetadataMap = _ref4.columnMetadataMap, estimatedColumnWidth = _ref4.estimatedColumnWidth, lastMeasuredColumnIndex = _ref4.lastMeasuredColumnIndex;
    var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredColumnIndex >= columnCount) lastMeasuredColumnIndex = columnCount - 1;
    if (lastMeasuredColumnIndex >= 0) {
        var itemMetadata = columnMetadataMap[lastMeasuredColumnIndex];
        totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = columnCount - lastMeasuredColumnIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedColumnWidth;
    return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};
var $5d0b35b7639dac13$var$getItemMetadata = function getItemMetadata(itemType, props, index, instanceProps) {
    var itemMetadataMap, itemSize, lastMeasuredIndex;
    if (itemType === "column") {
        itemMetadataMap = instanceProps.columnMetadataMap;
        itemSize = props.columnWidth;
        lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
    } else {
        itemMetadataMap = instanceProps.rowMetadataMap;
        itemSize = props.rowHeight;
        lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
    }
    if (index > lastMeasuredIndex) {
        var offset = 0;
        if (lastMeasuredIndex >= 0) {
            var itemMetadata = itemMetadataMap[lastMeasuredIndex];
            offset = itemMetadata.offset + itemMetadata.size;
        }
        for(var i = lastMeasuredIndex + 1; i <= index; i++){
            var size = itemSize(i);
            itemMetadataMap[i] = {
                offset: offset,
                size: size
            };
            offset += size;
        }
        if (itemType === "column") instanceProps.lastMeasuredColumnIndex = index;
        else instanceProps.lastMeasuredRowIndex = index;
    }
    return itemMetadataMap[index];
};
var $5d0b35b7639dac13$var$findNearestItem = function findNearestItem(itemType, props, instanceProps, offset) {
    var itemMetadataMap, lastMeasuredIndex;
    if (itemType === "column") {
        itemMetadataMap = instanceProps.columnMetadataMap;
        lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
    } else {
        itemMetadataMap = instanceProps.rowMetadataMap;
        lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
    }
    var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;
    if (lastMeasuredItemOffset >= offset) // If we've already measured items within this range just use a binary search as it's faster.
    return $5d0b35b7639dac13$var$findNearestItemBinarySearch(itemType, props, instanceProps, lastMeasuredIndex, 0, offset);
    else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return $5d0b35b7639dac13$var$findNearestItemExponentialSearch(itemType, props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
};
var $5d0b35b7639dac13$var$findNearestItemBinarySearch = function findNearestItemBinarySearch(itemType, props, instanceProps, high, low, offset) {
    while(low <= high){
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = $5d0b35b7639dac13$var$getItemMetadata(itemType, props, middle, instanceProps).offset;
        if (currentOffset === offset) return middle;
        else if (currentOffset < offset) low = middle + 1;
        else if (currentOffset > offset) high = middle - 1;
    }
    if (low > 0) return low - 1;
    else return 0;
};
var $5d0b35b7639dac13$var$findNearestItemExponentialSearch = function findNearestItemExponentialSearch(itemType, props, instanceProps, index, offset) {
    var itemCount = itemType === "column" ? props.columnCount : props.rowCount;
    var interval = 1;
    while(index < itemCount && $5d0b35b7639dac13$var$getItemMetadata(itemType, props, index, instanceProps).offset < offset){
        index += interval;
        interval *= 2;
    }
    return $5d0b35b7639dac13$var$findNearestItemBinarySearch(itemType, props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};
var $5d0b35b7639dac13$var$getOffsetForIndexAndAlignment = function getOffsetForIndexAndAlignment(itemType, props, index, align, scrollOffset, instanceProps, scrollbarSize) {
    var size = itemType === "column" ? props.width : props.height;
    var itemMetadata = $5d0b35b7639dac13$var$getItemMetadata(itemType, props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
    // To ensure it reflects actual measurements instead of just estimates.
    var estimatedTotalSize = itemType === "column" ? $5d0b35b7639dac13$var$getEstimatedTotalWidth(props, instanceProps) : $5d0b35b7639dac13$var$getEstimatedTotalHeight(props, instanceProps);
    var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
    var minOffset = Math.max(0, itemMetadata.offset - size + scrollbarSize + itemMetadata.size);
    if (align === "smart") {
        if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = "auto";
        else align = "center";
    }
    switch(align){
        case "start":
            return maxOffset;
        case "end":
            return minOffset;
        case "center":
            return Math.round(minOffset + (maxOffset - minOffset) / 2);
        case "auto":
        default:
            if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
            else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
            // this value can be larger than maxOffset when at the end of the list
            return minOffset;
            else if (scrollOffset < minOffset) return minOffset;
            else return maxOffset;
    }
};
var $5d0b35b7639dac13$export$32c206c84102e73c = /*#__PURE__*/ $5d0b35b7639dac13$var$createGridComponent({
    getColumnOffset: function getColumnOffset(props, index, instanceProps) {
        return $5d0b35b7639dac13$var$getItemMetadata("column", props, index, instanceProps).offset;
    },
    getColumnStartIndexForOffset: function getColumnStartIndexForOffset(props, scrollLeft, instanceProps) {
        return $5d0b35b7639dac13$var$findNearestItem("column", props, instanceProps, scrollLeft);
    },
    getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(props, startIndex, scrollLeft, instanceProps) {
        var columnCount = props.columnCount, width = props.width;
        var itemMetadata = $5d0b35b7639dac13$var$getItemMetadata("column", props, startIndex, instanceProps);
        var maxOffset = scrollLeft + width;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < columnCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $5d0b35b7639dac13$var$getItemMetadata("column", props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    getColumnWidth: function getColumnWidth(props, index, instanceProps) {
        return instanceProps.columnMetadataMap[index].size;
    },
    getEstimatedTotalHeight: $5d0b35b7639dac13$var$getEstimatedTotalHeight,
    getEstimatedTotalWidth: $5d0b35b7639dac13$var$getEstimatedTotalWidth,
    getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        return $5d0b35b7639dac13$var$getOffsetForIndexAndAlignment("column", props, index, align, scrollOffset, instanceProps, scrollbarSize);
    },
    getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        return $5d0b35b7639dac13$var$getOffsetForIndexAndAlignment("row", props, index, align, scrollOffset, instanceProps, scrollbarSize);
    },
    getRowOffset: function getRowOffset(props, index, instanceProps) {
        return $5d0b35b7639dac13$var$getItemMetadata("row", props, index, instanceProps).offset;
    },
    getRowHeight: function getRowHeight(props, index, instanceProps) {
        return instanceProps.rowMetadataMap[index].size;
    },
    getRowStartIndexForOffset: function getRowStartIndexForOffset(props, scrollTop, instanceProps) {
        return $5d0b35b7639dac13$var$findNearestItem("row", props, instanceProps, scrollTop);
    },
    getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(props, startIndex, scrollTop, instanceProps) {
        var rowCount = props.rowCount, height = props.height;
        var itemMetadata = $5d0b35b7639dac13$var$getItemMetadata("row", props, startIndex, instanceProps);
        var maxOffset = scrollTop + height;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < rowCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $5d0b35b7639dac13$var$getItemMetadata("row", props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    initInstanceProps: function initInstanceProps(props, instance) {
        var _ref5 = props, estimatedColumnWidth = _ref5.estimatedColumnWidth, estimatedRowHeight = _ref5.estimatedRowHeight;
        var instanceProps = {
            columnMetadataMap: {},
            estimatedColumnWidth: estimatedColumnWidth || $5d0b35b7639dac13$var$DEFAULT_ESTIMATED_ITEM_SIZE,
            estimatedRowHeight: estimatedRowHeight || $5d0b35b7639dac13$var$DEFAULT_ESTIMATED_ITEM_SIZE,
            lastMeasuredColumnIndex: -1,
            lastMeasuredRowIndex: -1,
            rowMetadataMap: {}
        };
        instance.resetAfterColumnIndex = function(columnIndex, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instance.resetAfterIndices({
                columnIndex: columnIndex,
                shouldForceUpdate: shouldForceUpdate
            });
        };
        instance.resetAfterRowIndex = function(rowIndex, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instance.resetAfterIndices({
                rowIndex: rowIndex,
                shouldForceUpdate: shouldForceUpdate
            });
        };
        instance.resetAfterIndices = function(_ref6) {
            var columnIndex = _ref6.columnIndex, rowIndex = _ref6.rowIndex, _ref6$shouldForceUpda = _ref6.shouldForceUpdate, shouldForceUpdate = _ref6$shouldForceUpda === void 0 ? true : _ref6$shouldForceUpda;
            if (typeof columnIndex === "number") instanceProps.lastMeasuredColumnIndex = Math.min(instanceProps.lastMeasuredColumnIndex, columnIndex - 1);
            if (typeof rowIndex === "number") instanceProps.lastMeasuredRowIndex = Math.min(instanceProps.lastMeasuredRowIndex, rowIndex - 1);
             // We could potentially optimize further by only evicting styles after this index,
            // But since styles are only cached while scrolling is in progress-
            // It seems an unnecessary optimization.
            // It's unlikely that resetAfterIndex() will be called while a user is scrolling.
            instance._getItemStyleCache(-1);
            if (shouldForceUpdate) instance.forceUpdate();
        };
        return instanceProps;
    },
    shouldResetStyleCacheOnItemSizeChange: false,
    validateProps: function validateProps(_ref7) {
        var columnWidth = _ref7.columnWidth, rowHeight = _ref7.rowHeight;
    }
});
var $5d0b35b7639dac13$var$IS_SCROLLING_DEBOUNCE_INTERVAL$1 = 150;
var $5d0b35b7639dac13$var$defaultItemKey$1 = function defaultItemKey(index, data) {
    return index;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.
var $5d0b35b7639dac13$var$devWarningsDirection = null;
var $5d0b35b7639dac13$var$devWarningsTagName$1 = null;
function $5d0b35b7639dac13$var$createListComponent(_ref) {
    var _class;
    var getItemOffset = _ref.getItemOffset, getEstimatedTotalSize = _ref.getEstimatedTotalSize, getItemSize = _ref.getItemSize, getOffsetForIndexAndAlignment = _ref.getOffsetForIndexAndAlignment, getStartIndexForOffset = _ref.getStartIndexForOffset, getStopIndexForStartIndex = _ref.getStopIndexForStartIndex, initInstanceProps = _ref.initInstanceProps, shouldResetStyleCacheOnItemSizeChange = _ref.shouldResetStyleCacheOnItemSizeChange, validateProps = _ref.validateProps;
    return _class = /*#__PURE__*/ function(_PureComponent) {
        (0, $gvoty.default)(List, _PureComponent);
        // Always use explicit constructor for React components.
        // It produces less code after transpilation. (#26)
        // eslint-disable-next-line no-useless-constructor
        function List(props) {
            var _this;
            _this = _PureComponent.call(this, props) || this;
            _this._instanceProps = initInstanceProps(_this.props, (0, $1oVxX.default)(_this));
            _this._outerRef = void 0;
            _this._resetIsScrollingTimeoutId = null;
            _this.state = {
                instance: (0, $1oVxX.default)(_this),
                isScrolling: false,
                scrollDirection: "forward",
                scrollOffset: typeof _this.props.initialScrollOffset === "number" ? _this.props.initialScrollOffset : 0,
                scrollUpdateWasRequested: false
            };
            _this._callOnItemsRendered = void 0;
            _this._callOnItemsRendered = (0, $j3Kiq.default)(function(overscanStartIndex, overscanStopIndex, visibleStartIndex, visibleStopIndex) {
                return _this.props.onItemsRendered({
                    overscanStartIndex: overscanStartIndex,
                    overscanStopIndex: overscanStopIndex,
                    visibleStartIndex: visibleStartIndex,
                    visibleStopIndex: visibleStopIndex
                });
            });
            _this._callOnScroll = void 0;
            _this._callOnScroll = (0, $j3Kiq.default)(function(scrollDirection, scrollOffset, scrollUpdateWasRequested) {
                return _this.props.onScroll({
                    scrollDirection: scrollDirection,
                    scrollOffset: scrollOffset,
                    scrollUpdateWasRequested: scrollUpdateWasRequested
                });
            });
            _this._getItemStyle = void 0;
            _this._getItemStyle = function(index) {
                var _this$props = _this.props, direction = _this$props.direction, itemSize = _this$props.itemSize, layout = _this$props.layout;
                var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && itemSize, shouldResetStyleCacheOnItemSizeChange && layout, shouldResetStyleCacheOnItemSizeChange && direction);
                var style;
                if (itemStyleCache.hasOwnProperty(index)) style = itemStyleCache[index];
                else {
                    var _offset = getItemOffset(_this.props, index, _this._instanceProps);
                    var size = getItemSize(_this.props, index, _this._instanceProps); // TODO Deprecate direction "horizontal"
                    var isHorizontal = direction === "horizontal" || layout === "horizontal";
                    var isRtl = direction === "rtl";
                    var offsetHorizontal = isHorizontal ? _offset : 0;
                    itemStyleCache[index] = style = {
                        position: "absolute",
                        left: isRtl ? undefined : offsetHorizontal,
                        right: isRtl ? offsetHorizontal : undefined,
                        top: !isHorizontal ? _offset : 0,
                        height: !isHorizontal ? size : "100%",
                        width: isHorizontal ? size : "100%"
                    };
                }
                return style;
            };
            _this._getItemStyleCache = void 0;
            _this._getItemStyleCache = (0, $j3Kiq.default)(function(_, __, ___) {
                return {};
            });
            _this._onScrollHorizontal = function(event) {
                var _event$currentTarget = event.currentTarget, clientWidth = _event$currentTarget.clientWidth, scrollLeft = _event$currentTarget.scrollLeft, scrollWidth = _event$currentTarget.scrollWidth;
                _this.setState(function(prevState) {
                    if (prevState.scrollOffset === scrollLeft) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                    var direction = _this.props.direction;
                    var scrollOffset = scrollLeft;
                    if (direction === "rtl") // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
                    // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
                    switch($5d0b35b7639dac13$var$getRTLOffsetType()){
                        case "negative":
                            scrollOffset = -scrollLeft;
                            break;
                        case "positive-descending":
                            scrollOffset = scrollWidth - clientWidth - scrollLeft;
                            break;
                    }
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    scrollOffset = Math.max(0, Math.min(scrollOffset, scrollWidth - clientWidth));
                    return {
                        isScrolling: true,
                        scrollDirection: prevState.scrollOffset < scrollOffset ? "forward" : "backward",
                        scrollOffset: scrollOffset,
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._onScrollVertical = function(event) {
                var _event$currentTarget2 = event.currentTarget, clientHeight = _event$currentTarget2.clientHeight, scrollHeight = _event$currentTarget2.scrollHeight, scrollTop = _event$currentTarget2.scrollTop;
                _this.setState(function(prevState) {
                    if (prevState.scrollOffset === scrollTop) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    var scrollOffset = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
                    return {
                        isScrolling: true,
                        scrollDirection: prevState.scrollOffset < scrollOffset ? "forward" : "backward",
                        scrollOffset: scrollOffset,
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._outerRefSetter = function(ref) {
                var outerRef = _this.props.outerRef;
                _this._outerRef = ref;
                if (typeof outerRef === "function") outerRef(ref);
                else if (outerRef != null && typeof outerRef === "object" && outerRef.hasOwnProperty("current")) outerRef.current = ref;
            };
            _this._resetIsScrollingDebounced = function() {
                if (_this._resetIsScrollingTimeoutId !== null) $5d0b35b7639dac13$var$cancelTimeout(_this._resetIsScrollingTimeoutId);
                _this._resetIsScrollingTimeoutId = $5d0b35b7639dac13$var$requestTimeout(_this._resetIsScrolling, $5d0b35b7639dac13$var$IS_SCROLLING_DEBOUNCE_INTERVAL$1);
            };
            _this._resetIsScrolling = function() {
                _this._resetIsScrollingTimeoutId = null;
                _this.setState({
                    isScrolling: false
                }, function() {
                    // Clear style cache after state update has been committed.
                    // This way we don't break pure sCU for items that don't use isScrolling param.
                    _this._getItemStyleCache(-1, null);
                });
            };
            return _this;
        }
        List.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            $5d0b35b7639dac13$var$validateSharedProps$1(nextProps, prevState);
            validateProps(nextProps);
            return null;
        };
        var _proto = List.prototype;
        _proto.scrollTo = function scrollTo(scrollOffset) {
            scrollOffset = Math.max(0, scrollOffset);
            this.setState(function(prevState) {
                if (prevState.scrollOffset === scrollOffset) return null;
                return {
                    scrollDirection: prevState.scrollOffset < scrollOffset ? "forward" : "backward",
                    scrollOffset: scrollOffset,
                    scrollUpdateWasRequested: true
                };
            }, this._resetIsScrollingDebounced);
        };
        _proto.scrollToItem = function scrollToItem(index, align) {
            if (align === void 0) align = "auto";
            var _this$props2 = this.props, itemCount = _this$props2.itemCount, layout = _this$props2.layout;
            var scrollOffset = this.state.scrollOffset;
            index = Math.max(0, Math.min(index, itemCount - 1)); // The scrollbar size should be considered when scrolling an item into view, to ensure it's fully visible.
            // But we only need to account for its size when it's actually visible.
            // This is an edge case for lists; normally they only scroll in the dominant direction.
            var scrollbarSize = 0;
            if (this._outerRef) {
                var outerRef = this._outerRef;
                if (layout === "vertical") scrollbarSize = outerRef.scrollWidth > outerRef.clientWidth ? $5d0b35b7639dac13$var$getScrollbarSize() : 0;
                else scrollbarSize = outerRef.scrollHeight > outerRef.clientHeight ? $5d0b35b7639dac13$var$getScrollbarSize() : 0;
            }
            this.scrollTo(getOffsetForIndexAndAlignment(this.props, index, align, scrollOffset, this._instanceProps, scrollbarSize));
        };
        _proto.componentDidMount = function componentDidMount() {
            var _this$props3 = this.props, direction = _this$props3.direction, initialScrollOffset = _this$props3.initialScrollOffset, layout = _this$props3.layout;
            if (typeof initialScrollOffset === "number" && this._outerRef != null) {
                var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"
                if (direction === "horizontal" || layout === "horizontal") outerRef.scrollLeft = initialScrollOffset;
                else outerRef.scrollTop = initialScrollOffset;
            }
            this._callPropsCallbacks();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            var _this$props4 = this.props, direction = _this$props4.direction, layout = _this$props4.layout;
            var _this$state = this.state, scrollOffset = _this$state.scrollOffset, scrollUpdateWasRequested = _this$state.scrollUpdateWasRequested;
            if (scrollUpdateWasRequested && this._outerRef != null) {
                var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"
                if (direction === "horizontal" || layout === "horizontal") {
                    if (direction === "rtl") // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // So we need to determine which browser behavior we're dealing with, and mimic it.
                    switch($5d0b35b7639dac13$var$getRTLOffsetType()){
                        case "negative":
                            outerRef.scrollLeft = -scrollOffset;
                            break;
                        case "positive-ascending":
                            outerRef.scrollLeft = scrollOffset;
                            break;
                        default:
                            var clientWidth = outerRef.clientWidth, scrollWidth = outerRef.scrollWidth;
                            outerRef.scrollLeft = scrollWidth - clientWidth - scrollOffset;
                            break;
                    }
                    else outerRef.scrollLeft = scrollOffset;
                } else outerRef.scrollTop = scrollOffset;
            }
            this._callPropsCallbacks();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            if (this._resetIsScrollingTimeoutId !== null) $5d0b35b7639dac13$var$cancelTimeout(this._resetIsScrollingTimeoutId);
        };
        _proto.render = function render() {
            var _this$props5 = this.props, children = _this$props5.children, className = _this$props5.className, direction = _this$props5.direction, height = _this$props5.height, innerRef = _this$props5.innerRef, innerElementType = _this$props5.innerElementType, innerTagName = _this$props5.innerTagName, itemCount = _this$props5.itemCount, itemData = _this$props5.itemData, _this$props5$itemKey = _this$props5.itemKey, itemKey = _this$props5$itemKey === void 0 ? $5d0b35b7639dac13$var$defaultItemKey$1 : _this$props5$itemKey, layout = _this$props5.layout, outerElementType = _this$props5.outerElementType, outerTagName = _this$props5.outerTagName, style = _this$props5.style, useIsScrolling = _this$props5.useIsScrolling, width = _this$props5.width;
            var isScrolling = this.state.isScrolling; // TODO Deprecate direction "horizontal"
            var isHorizontal = direction === "horizontal" || layout === "horizontal";
            var onScroll = isHorizontal ? this._onScrollHorizontal : this._onScrollVertical;
            var _this$_getRangeToRend = this._getRangeToRender(), startIndex = _this$_getRangeToRend[0], stopIndex = _this$_getRangeToRend[1];
            var items = [];
            if (itemCount > 0) for(var _index = startIndex; _index <= stopIndex; _index++)items.push((0, $8NFma.createElement)(children, {
                data: itemData,
                key: itemKey(_index, itemData),
                index: _index,
                isScrolling: useIsScrolling ? isScrolling : undefined,
                style: this._getItemStyle(_index)
            }));
             // Read this value AFTER items have been created,
            // So their actual sizes (if variable) are taken into consideration.
            var estimatedTotalSize = getEstimatedTotalSize(this.props, this._instanceProps);
            return (0, $8NFma.createElement)(outerElementType || outerTagName || "div", {
                className: className,
                onScroll: onScroll,
                ref: this._outerRefSetter,
                style: (0, $jz4iA.default)({
                    position: "relative",
                    height: height,
                    width: width,
                    overflow: "auto",
                    WebkitOverflowScrolling: "touch",
                    willChange: "transform",
                    direction: direction
                }, style)
            }, (0, $8NFma.createElement)(innerElementType || innerTagName || "div", {
                children: items,
                ref: innerRef,
                style: {
                    height: isHorizontal ? "100%" : estimatedTotalSize,
                    pointerEvents: isScrolling ? "none" : undefined,
                    width: isHorizontal ? estimatedTotalSize : "100%"
                }
            }));
        };
        _proto._callPropsCallbacks = function _callPropsCallbacks() {
            if (typeof this.props.onItemsRendered === "function") {
                var itemCount = this.props.itemCount;
                if (itemCount > 0) {
                    var _this$_getRangeToRend2 = this._getRangeToRender(), _overscanStartIndex = _this$_getRangeToRend2[0], _overscanStopIndex = _this$_getRangeToRend2[1], _visibleStartIndex = _this$_getRangeToRend2[2], _visibleStopIndex = _this$_getRangeToRend2[3];
                    this._callOnItemsRendered(_overscanStartIndex, _overscanStopIndex, _visibleStartIndex, _visibleStopIndex);
                }
            }
            if (typeof this.props.onScroll === "function") {
                var _this$state2 = this.state, _scrollDirection = _this$state2.scrollDirection, _scrollOffset = _this$state2.scrollOffset, _scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;
                this._callOnScroll(_scrollDirection, _scrollOffset, _scrollUpdateWasRequested);
            }
        } // Lazily create and cache item styles while scrolling,
        ;
        _proto._getRangeToRender = function _getRangeToRender() {
            var _this$props6 = this.props, itemCount = _this$props6.itemCount, overscanCount = _this$props6.overscanCount;
            var _this$state3 = this.state, isScrolling = _this$state3.isScrolling, scrollDirection = _this$state3.scrollDirection, scrollOffset = _this$state3.scrollOffset;
            if (itemCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getStartIndexForOffset(this.props, scrollOffset, this._instanceProps);
            var stopIndex = getStopIndexForStartIndex(this.props, startIndex, scrollOffset, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || scrollDirection === "backward" ? Math.max(1, overscanCount) : 1;
            var overscanForward = !isScrolling || scrollDirection === "forward" ? Math.max(1, overscanCount) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(itemCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        return List;
    }((0, $8NFma.PureComponent)), _class.defaultProps = {
        direction: "ltr",
        itemData: undefined,
        layout: "vertical",
        overscanCount: 2,
        useIsScrolling: false
    }, _class;
} // NOTE: I considered further wrapping individual items with a pure ListItem component.
// This would avoid ever calling the render function for the same index more than once,
// But it would also add the overhead of a lot of components/fibers.
// I assume people already do this (render function returning a class component),
// So my doing it would just unnecessarily double the wrappers.
var $5d0b35b7639dac13$var$validateSharedProps$1 = function validateSharedProps(_ref2, _ref3) {
    var children = _ref2.children, direction = _ref2.direction, height = _ref2.height, layout = _ref2.layout, innerTagName = _ref2.innerTagName, outerTagName = _ref2.outerTagName, width = _ref2.width;
    var instance = _ref3.instance;
    var isHorizontal;
};
var $5d0b35b7639dac13$var$DEFAULT_ESTIMATED_ITEM_SIZE$1 = 50;
var $5d0b35b7639dac13$var$getItemMetadata$1 = function getItemMetadata(props, index, instanceProps) {
    var _ref = props, itemSize = _ref.itemSize;
    var itemMetadataMap = instanceProps.itemMetadataMap, lastMeasuredIndex = instanceProps.lastMeasuredIndex;
    if (index > lastMeasuredIndex) {
        var offset = 0;
        if (lastMeasuredIndex >= 0) {
            var itemMetadata = itemMetadataMap[lastMeasuredIndex];
            offset = itemMetadata.offset + itemMetadata.size;
        }
        for(var i = lastMeasuredIndex + 1; i <= index; i++){
            var size = itemSize(i);
            itemMetadataMap[i] = {
                offset: offset,
                size: size
            };
            offset += size;
        }
        instanceProps.lastMeasuredIndex = index;
    }
    return itemMetadataMap[index];
};
var $5d0b35b7639dac13$var$findNearestItem$1 = function findNearestItem(props, instanceProps, offset) {
    var itemMetadataMap = instanceProps.itemMetadataMap, lastMeasuredIndex = instanceProps.lastMeasuredIndex;
    var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;
    if (lastMeasuredItemOffset >= offset) // If we've already measured items within this range just use a binary search as it's faster.
    return $5d0b35b7639dac13$var$findNearestItemBinarySearch$1(props, instanceProps, lastMeasuredIndex, 0, offset);
    else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return $5d0b35b7639dac13$var$findNearestItemExponentialSearch$1(props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
};
var $5d0b35b7639dac13$var$findNearestItemBinarySearch$1 = function findNearestItemBinarySearch(props, instanceProps, high, low, offset) {
    while(low <= high){
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = $5d0b35b7639dac13$var$getItemMetadata$1(props, middle, instanceProps).offset;
        if (currentOffset === offset) return middle;
        else if (currentOffset < offset) low = middle + 1;
        else if (currentOffset > offset) high = middle - 1;
    }
    if (low > 0) return low - 1;
    else return 0;
};
var $5d0b35b7639dac13$var$findNearestItemExponentialSearch$1 = function findNearestItemExponentialSearch(props, instanceProps, index, offset) {
    var itemCount = props.itemCount;
    var interval = 1;
    while(index < itemCount && $5d0b35b7639dac13$var$getItemMetadata$1(props, index, instanceProps).offset < offset){
        index += interval;
        interval *= 2;
    }
    return $5d0b35b7639dac13$var$findNearestItemBinarySearch$1(props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};
var $5d0b35b7639dac13$var$getEstimatedTotalSize = function getEstimatedTotalSize(_ref2, _ref3) {
    var itemCount = _ref2.itemCount;
    var itemMetadataMap = _ref3.itemMetadataMap, estimatedItemSize = _ref3.estimatedItemSize, lastMeasuredIndex = _ref3.lastMeasuredIndex;
    var totalSizeOfMeasuredItems = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredIndex >= itemCount) lastMeasuredIndex = itemCount - 1;
    if (lastMeasuredIndex >= 0) {
        var itemMetadata = itemMetadataMap[lastMeasuredIndex];
        totalSizeOfMeasuredItems = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = itemCount - lastMeasuredIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedItemSize;
    return totalSizeOfMeasuredItems + totalSizeOfUnmeasuredItems;
};
var $5d0b35b7639dac13$export$d8ac3b6b20be856e = /*#__PURE__*/ $5d0b35b7639dac13$var$createListComponent({
    getItemOffset: function getItemOffset(props, index, instanceProps) {
        return $5d0b35b7639dac13$var$getItemMetadata$1(props, index, instanceProps).offset;
    },
    getItemSize: function getItemSize(props, index, instanceProps) {
        return instanceProps.itemMetadataMap[index].size;
    },
    getEstimatedTotalSize: $5d0b35b7639dac13$var$getEstimatedTotalSize,
    getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        var direction = props.direction, height = props.height, layout = props.layout, width = props.width; // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === "horizontal" || layout === "horizontal";
        var size = isHorizontal ? width : height;
        var itemMetadata = $5d0b35b7639dac13$var$getItemMetadata$1(props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
        // To ensure it reflects actual measurements instead of just estimates.
        var estimatedTotalSize = $5d0b35b7639dac13$var$getEstimatedTotalSize(props, instanceProps);
        var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
        var minOffset = Math.max(0, itemMetadata.offset - size + itemMetadata.size + scrollbarSize);
        if (align === "smart") {
            if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = "auto";
            else align = "center";
        }
        switch(align){
            case "start":
                return maxOffset;
            case "end":
                return minOffset;
            case "center":
                return Math.round(minOffset + (maxOffset - minOffset) / 2);
            case "auto":
            default:
                if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
                else if (scrollOffset < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getStartIndexForOffset: function getStartIndexForOffset(props, offset, instanceProps) {
        return $5d0b35b7639dac13$var$findNearestItem$1(props, instanceProps, offset);
    },
    getStopIndexForStartIndex: function getStopIndexForStartIndex(props, startIndex, scrollOffset, instanceProps) {
        var direction = props.direction, height = props.height, itemCount = props.itemCount, layout = props.layout, width = props.width; // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === "horizontal" || layout === "horizontal";
        var size = isHorizontal ? width : height;
        var itemMetadata = $5d0b35b7639dac13$var$getItemMetadata$1(props, startIndex, instanceProps);
        var maxOffset = scrollOffset + size;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < itemCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $5d0b35b7639dac13$var$getItemMetadata$1(props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    initInstanceProps: function initInstanceProps(props, instance) {
        var _ref4 = props, estimatedItemSize = _ref4.estimatedItemSize;
        var instanceProps = {
            itemMetadataMap: {},
            estimatedItemSize: estimatedItemSize || $5d0b35b7639dac13$var$DEFAULT_ESTIMATED_ITEM_SIZE$1,
            lastMeasuredIndex: -1
        };
        instance.resetAfterIndex = function(index, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instanceProps.lastMeasuredIndex = Math.min(instanceProps.lastMeasuredIndex, index - 1); // We could potentially optimize further by only evicting styles after this index,
            // But since styles are only cached while scrolling is in progress-
            // It seems an unnecessary optimization.
            // It's unlikely that resetAfterIndex() will be called while a user is scrolling.
            instance._getItemStyleCache(-1);
            if (shouldForceUpdate) instance.forceUpdate();
        };
        return instanceProps;
    },
    shouldResetStyleCacheOnItemSizeChange: false,
    validateProps: function validateProps(_ref5) {
        var itemSize = _ref5.itemSize;
    }
});
var $5d0b35b7639dac13$export$f331158cccad7361 = /*#__PURE__*/ $5d0b35b7639dac13$var$createGridComponent({
    getColumnOffset: function getColumnOffset(_ref, index) {
        var columnWidth = _ref.columnWidth;
        return index * columnWidth;
    },
    getColumnWidth: function getColumnWidth(_ref2, index) {
        var columnWidth = _ref2.columnWidth;
        return columnWidth;
    },
    getRowOffset: function getRowOffset(_ref3, index) {
        var rowHeight = _ref3.rowHeight;
        return index * rowHeight;
    },
    getRowHeight: function getRowHeight(_ref4, index) {
        var rowHeight = _ref4.rowHeight;
        return rowHeight;
    },
    getEstimatedTotalHeight: function getEstimatedTotalHeight(_ref5) {
        var rowCount = _ref5.rowCount, rowHeight = _ref5.rowHeight;
        return rowHeight * rowCount;
    },
    getEstimatedTotalWidth: function getEstimatedTotalWidth(_ref6) {
        var columnCount = _ref6.columnCount, columnWidth = _ref6.columnWidth;
        return columnWidth * columnCount;
    },
    getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(_ref7, columnIndex, align, scrollLeft, instanceProps, scrollbarSize) {
        var columnCount = _ref7.columnCount, columnWidth = _ref7.columnWidth, width = _ref7.width;
        var lastColumnOffset = Math.max(0, columnCount * columnWidth - width);
        var maxOffset = Math.min(lastColumnOffset, columnIndex * columnWidth);
        var minOffset = Math.max(0, columnIndex * columnWidth - width + scrollbarSize + columnWidth);
        if (align === "smart") {
            if (scrollLeft >= minOffset - width && scrollLeft <= maxOffset + width) align = "auto";
            else align = "center";
        }
        switch(align){
            case "start":
                return maxOffset;
            case "end":
                return minOffset;
            case "center":
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(width / 2)) return 0; // near the beginning
                else if (middleOffset > lastColumnOffset + Math.floor(width / 2)) return lastColumnOffset; // near the end
                else return middleOffset;
            case "auto":
            default:
                if (scrollLeft >= minOffset && scrollLeft <= maxOffset) return scrollLeft;
                else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
                // this value can be larger than maxOffset when at the end of the list
                return minOffset;
                else if (scrollLeft < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(_ref8, rowIndex, align, scrollTop, instanceProps, scrollbarSize) {
        var rowHeight = _ref8.rowHeight, height = _ref8.height, rowCount = _ref8.rowCount;
        var lastRowOffset = Math.max(0, rowCount * rowHeight - height);
        var maxOffset = Math.min(lastRowOffset, rowIndex * rowHeight);
        var minOffset = Math.max(0, rowIndex * rowHeight - height + scrollbarSize + rowHeight);
        if (align === "smart") {
            if (scrollTop >= minOffset - height && scrollTop <= maxOffset + height) align = "auto";
            else align = "center";
        }
        switch(align){
            case "start":
                return maxOffset;
            case "end":
                return minOffset;
            case "center":
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(height / 2)) return 0; // near the beginning
                else if (middleOffset > lastRowOffset + Math.floor(height / 2)) return lastRowOffset; // near the end
                else return middleOffset;
            case "auto":
            default:
                if (scrollTop >= minOffset && scrollTop <= maxOffset) return scrollTop;
                else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
                // this value can be larger than maxOffset when at the end of the list
                return minOffset;
                else if (scrollTop < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getColumnStartIndexForOffset: function getColumnStartIndexForOffset(_ref9, scrollLeft) {
        var columnWidth = _ref9.columnWidth, columnCount = _ref9.columnCount;
        return Math.max(0, Math.min(columnCount - 1, Math.floor(scrollLeft / columnWidth)));
    },
    getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(_ref10, startIndex, scrollLeft) {
        var columnWidth = _ref10.columnWidth, columnCount = _ref10.columnCount, width = _ref10.width;
        var left = startIndex * columnWidth;
        var numVisibleColumns = Math.ceil((width + scrollLeft - left) / columnWidth);
        return Math.max(0, Math.min(columnCount - 1, startIndex + numVisibleColumns - 1 // -1 is because stop index is inclusive
        ));
    },
    getRowStartIndexForOffset: function getRowStartIndexForOffset(_ref11, scrollTop) {
        var rowHeight = _ref11.rowHeight, rowCount = _ref11.rowCount;
        return Math.max(0, Math.min(rowCount - 1, Math.floor(scrollTop / rowHeight)));
    },
    getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(_ref12, startIndex, scrollTop) {
        var rowHeight = _ref12.rowHeight, rowCount = _ref12.rowCount, height = _ref12.height;
        var top = startIndex * rowHeight;
        var numVisibleRows = Math.ceil((height + scrollTop - top) / rowHeight);
        return Math.max(0, Math.min(rowCount - 1, startIndex + numVisibleRows - 1 // -1 is because stop index is inclusive
        ));
    },
    initInstanceProps: function initInstanceProps(props) {},
    shouldResetStyleCacheOnItemSizeChange: true,
    validateProps: function validateProps(_ref13) {
        var columnWidth = _ref13.columnWidth, rowHeight = _ref13.rowHeight;
    }
});
var $5d0b35b7639dac13$export$ae9e55e1d8a2f4b7 = /*#__PURE__*/ $5d0b35b7639dac13$var$createListComponent({
    getItemOffset: function getItemOffset(_ref, index) {
        var itemSize = _ref.itemSize;
        return index * itemSize;
    },
    getItemSize: function getItemSize(_ref2, index) {
        var itemSize = _ref2.itemSize;
        return itemSize;
    },
    getEstimatedTotalSize: function getEstimatedTotalSize(_ref3) {
        var itemCount = _ref3.itemCount, itemSize = _ref3.itemSize;
        return itemSize * itemCount;
    },
    getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(_ref4, index, align, scrollOffset, instanceProps, scrollbarSize) {
        var direction = _ref4.direction, height = _ref4.height, itemCount = _ref4.itemCount, itemSize = _ref4.itemSize, layout = _ref4.layout, width = _ref4.width;
        // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === "horizontal" || layout === "horizontal";
        var size = isHorizontal ? width : height;
        var lastItemOffset = Math.max(0, itemCount * itemSize - size);
        var maxOffset = Math.min(lastItemOffset, index * itemSize);
        var minOffset = Math.max(0, index * itemSize - size + itemSize + scrollbarSize);
        if (align === "smart") {
            if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = "auto";
            else align = "center";
        }
        switch(align){
            case "start":
                return maxOffset;
            case "end":
                return minOffset;
            case "center":
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(size / 2)) return 0; // near the beginning
                else if (middleOffset > lastItemOffset + Math.floor(size / 2)) return lastItemOffset; // near the end
                else return middleOffset;
            case "auto":
            default:
                if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
                else if (scrollOffset < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getStartIndexForOffset: function getStartIndexForOffset(_ref5, offset) {
        var itemCount = _ref5.itemCount, itemSize = _ref5.itemSize;
        return Math.max(0, Math.min(itemCount - 1, Math.floor(offset / itemSize)));
    },
    getStopIndexForStartIndex: function getStopIndexForStartIndex(_ref6, startIndex, scrollOffset) {
        var direction = _ref6.direction, height = _ref6.height, itemCount = _ref6.itemCount, itemSize = _ref6.itemSize, layout = _ref6.layout, width = _ref6.width;
        // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === "horizontal" || layout === "horizontal";
        var offset = startIndex * itemSize;
        var size = isHorizontal ? width : height;
        var numVisibleItems = Math.ceil((size + scrollOffset - offset) / itemSize);
        return Math.max(0, Math.min(itemCount - 1, startIndex + numVisibleItems - 1 // -1 is because stop index is inclusive
        ));
    },
    initInstanceProps: function initInstanceProps(props) {},
    shouldResetStyleCacheOnItemSizeChange: true,
    validateProps: function validateProps(_ref7) {
        var itemSize = _ref7.itemSize;
    }
});
// Pulled from react-compat
// https://github.com/developit/preact-compat/blob/7c5de00e7c85e2ffd011bf3af02899b63f699d3a/src/index.js#L349
function $5d0b35b7639dac13$var$shallowDiffers(prev, next) {
    for(var attribute in prev){
        if (!(attribute in next)) return true;
    }
    for(var _attribute in next){
        if (prev[_attribute] !== next[_attribute]) return true;
    }
    return false;
}
var $5d0b35b7639dac13$var$_excluded = [
    "style"
], $5d0b35b7639dac13$var$_excluded2 = [
    "style"
];
// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-api.html#reactmemo
function $5d0b35b7639dac13$export$b141efd0b0fb9174(prevProps, nextProps) {
    var prevStyle = prevProps.style, prevRest = (0, $hQtye.default)(prevProps, $5d0b35b7639dac13$var$_excluded);
    var nextStyle = nextProps.style, nextRest = (0, $hQtye.default)(nextProps, $5d0b35b7639dac13$var$_excluded2);
    return !$5d0b35b7639dac13$var$shallowDiffers(prevStyle, nextStyle) && !$5d0b35b7639dac13$var$shallowDiffers(prevRest, nextRest);
}
// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-component.html#shouldcomponentupdate
function $5d0b35b7639dac13$export$aa365c903ed149ff(nextProps, nextState) {
    return !$5d0b35b7639dac13$export$b141efd0b0fb9174(this.props, nextProps) || $5d0b35b7639dac13$var$shallowDiffers(this.state, nextState);
}

});
parcelRegister("j3Kiq", function(module, exports) {

$parcel$export(module.exports, "default", () => $de02359db43fa8ed$export$2e2bcd8739ae039);
var $de02359db43fa8ed$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $de02359db43fa8ed$var$isEqual(first, second) {
    if (first === second) return true;
    if ($de02359db43fa8ed$var$safeIsNaN(first) && $de02359db43fa8ed$var$safeIsNaN(second)) return true;
    return false;
}
function $de02359db43fa8ed$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$de02359db43fa8ed$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $de02359db43fa8ed$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $de02359db43fa8ed$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $de02359db43fa8ed$export$2e2bcd8739ae039 = $de02359db43fa8ed$var$memoizeOne;

});


parcelRegister("6Grnh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "unstable_serialize", () => $4ddbe65021abc4ba$export$dbab534a48e651ef);
$parcel$export(module.exports, "SWRConfig", () => $4ddbe65021abc4ba$export$4c7bbecdacc3ca2c);
$parcel$export(module.exports, "default", () => $4ddbe65021abc4ba$export$2e2bcd8739ae039);
$parcel$export(module.exports, "mutate", () => (parcelRequire("eRk4j")).mutate);
$parcel$export(module.exports, "preload", () => (parcelRequire("eRk4j")).preload);
$parcel$export(module.exports, "useSWRConfig", () => (parcelRequire("eRk4j")).useSWRConfig);
parcelRequire("8kCQs");

var $8NFma = parcelRequire("8NFma");

var $ck4pA = parcelRequire("ck4pA");

var $eRk4j = parcelRequire("eRk4j");
const $4ddbe65021abc4ba$export$dbab534a48e651ef = (key)=>(0, $eRk4j.serialize)(key)[0];
/// <reference types="react/experimental" />
const $4ddbe65021abc4ba$var$use = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).use || ((promise)=>{
    if (promise.status === "pending") throw promise;
    else if (promise.status === "fulfilled") return promise.value;
    else if (promise.status === "rejected") throw promise.reason;
    else {
        promise.status = "pending";
        promise.then((v)=>{
            promise.status = "fulfilled";
            promise.value = v;
        }, (e)=>{
            promise.status = "rejected";
            promise.reason = e;
        });
        throw promise;
    }
});
const $4ddbe65021abc4ba$var$WITH_DEDUPE = {
    dedupe: true
};
const $4ddbe65021abc4ba$var$useSWRHandler = (_key, fetcher, config)=>{
    const { cache: cache, compare: compare, suspense: suspense, fallbackData: fallbackData, revalidateOnMount: revalidateOnMount, revalidateIfStale: revalidateIfStale, refreshInterval: refreshInterval, refreshWhenHidden: refreshWhenHidden, refreshWhenOffline: refreshWhenOffline, keepPreviousData: keepPreviousData } = config;
    const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = (0, $eRk4j.SWRGlobalState).get(cache);
    // `key` is the identifier of the SWR internal state,
    // `fnArg` is the argument/arguments parsed from the key, which will be passed
    // to the fetcher.
    // All of them are derived from `_key`.
    const [key, fnArg] = (0, $eRk4j.serialize)(_key);
    // If it's the initial render of this hook.
    const initialMountedRef = (0, $8NFma.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    const unmountedRef = (0, $8NFma.useRef)(false);
    // Refs to keep the key and config.
    const keyRef = (0, $8NFma.useRef)(key);
    const fetcherRef = (0, $8NFma.useRef)(fetcher);
    const configRef = (0, $8NFma.useRef)(config);
    const getConfig = ()=>configRef.current;
    const isActive = ()=>getConfig().isVisible() && getConfig().isOnline();
    const [getCache, setCache, subscribeCache, getInitialCache] = (0, $eRk4j.createCacheHelper)(cache, key);
    const stateDependencies = (0, $8NFma.useRef)({}).current;
    const fallback = (0, $eRk4j.isUndefined)(fallbackData) ? config.fallback[key] : fallbackData;
    const isEqual = (prev, current)=>{
        for(const _ in stateDependencies){
            const t = _;
            if (t === "data") {
                if (!compare(prev[t], current[t])) {
                    if (!(0, $eRk4j.isUndefined)(prev[t])) return false;
                    if (!compare(returnedData, current[t])) return false;
                }
            } else {
                if (current[t] !== prev[t]) return false;
            }
        }
        return true;
    };
    const getSnapshot = (0, $8NFma.useMemo)(()=>{
        const shouldStartRequest = (()=>{
            if (!key) return false;
            if (!fetcher) return false;
            // If `revalidateOnMount` is set, we take the value directly.
            if (!(0, $eRk4j.isUndefined)(revalidateOnMount)) return revalidateOnMount;
            // If it's paused, we skip revalidation.
            if (getConfig().isPaused()) return false;
            if (suspense) return false;
            if (!(0, $eRk4j.isUndefined)(revalidateIfStale)) return revalidateIfStale;
            return true;
        })();
        // Get the cache and merge it with expected states.
        const getSelectedCache = (state)=>{
            // We only select the needed fields from the state.
            const snapshot = (0, $eRk4j.mergeObjects)(state);
            delete snapshot._k;
            if (!shouldStartRequest) return snapshot;
            return {
                isValidating: true,
                isLoading: true,
                ...snapshot
            };
        };
        const cachedData = getCache();
        const initialData = getInitialCache();
        const clientSnapshot = getSelectedCache(cachedData);
        const serverSnapshot = cachedData === initialData ? clientSnapshot : getSelectedCache(initialData);
        // To make sure that we are returning the same object reference to avoid
        // unnecessary re-renders, we keep the previous snapshot and use deep
        // comparison to check if we need to return a new one.
        let memorizedSnapshot = clientSnapshot;
        return [
            ()=>{
                const newSnapshot = getSelectedCache(getCache());
                const compareResult = isEqual(newSnapshot, memorizedSnapshot);
                if (compareResult) {
                    // Mentally, we should always return the `memorizedSnapshot` here
                    // as there's no change between the new and old snapshots.
                    // However, since the `isEqual` function only compares selected fields,
                    // the values of the unselected fields might be changed. That's
                    // simply because we didn't track them.
                    // To support the case in https://github.com/vercel/swr/pull/2576,
                    // we need to update these fields in the `memorizedSnapshot` too
                    // with direct mutations to ensure the snapshot is always up-to-date
                    // even for the unselected fields, but only trigger re-renders when
                    // the selected fields are changed.
                    memorizedSnapshot.data = newSnapshot.data;
                    memorizedSnapshot.isLoading = newSnapshot.isLoading;
                    memorizedSnapshot.isValidating = newSnapshot.isValidating;
                    memorizedSnapshot.error = newSnapshot.error;
                    return memorizedSnapshot;
                } else {
                    memorizedSnapshot = newSnapshot;
                    return newSnapshot;
                }
            },
            ()=>serverSnapshot
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cache,
        key
    ]);
    // Get the current state that SWR should return.
    const cached = (0, $ck4pA.useSyncExternalStore)((0, $8NFma.useCallback)((callback)=>subscribeCache(key, (current, prev)=>{
            if (!isEqual(prev, current)) callback();
        }), [
        cache,
        key
    ]), getSnapshot[0], getSnapshot[1]);
    const isInitialMount = !initialMountedRef.current;
    const hasRevalidator = EVENT_REVALIDATORS[key] && EVENT_REVALIDATORS[key].length > 0;
    const cachedData = cached.data;
    const data = (0, $eRk4j.isUndefined)(cachedData) ? fallback : cachedData;
    const error = cached.error;
    // Use a ref to store previously returned data. Use the initial data as its initial value.
    const laggyDataRef = (0, $8NFma.useRef)(data);
    const returnedData = keepPreviousData ? (0, $eRk4j.isUndefined)(cachedData) ? laggyDataRef.current : cachedData : data;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    const shouldDoInitialRevalidation = (()=>{
        // if a key already has revalidators and also has error, we should not trigger revalidation
        if (hasRevalidator && !(0, $eRk4j.isUndefined)(error)) return false;
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !(0, $eRk4j.isUndefined)(revalidateOnMount)) return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused()) return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately mount it again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense) return (0, $eRk4j.isUndefined)(data) ? false : revalidateIfStale;
        // If there is no stale data, we need to revalidate when mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return (0, $eRk4j.isUndefined)(data) || revalidateIfStale;
    })();
    // Resolve the default validating state:
    // If it's able to validate, and it should revalidate when mount, this will be true.
    const defaultValidatingState = !!(key && fetcher && isInitialMount && shouldDoInitialRevalidation);
    const isValidating = (0, $eRk4j.isUndefined)(cached.isValidating) ? defaultValidatingState : cached.isValidating;
    const isLoading = (0, $eRk4j.isUndefined)(cached.isLoading) ? defaultValidatingState : cached.isLoading;
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    const revalidate = (0, $8NFma.useCallback)(async (revalidateOpts)=>{
        const currentFetcher = fetcherRef.current;
        if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) return false;
        let newData;
        let startAt;
        let loading = true;
        const opts = revalidateOpts || {};
        // If there is no ongoing concurrent request, or `dedupe` is not set, a
        // new request should be initiated.
        const shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
        /*
         For React 17
         Do unmount check for calls:
         If key has changed during the revalidation, or the component has been
         unmounted, old dispatch and old event callbacks should not take any
         effect

        For React 18
        only check if key has changed
        https://github.com/reactwg/react-18/discussions/82
      */ const callbackSafeguard = ()=>{
            if (0, $eRk4j.IS_REACT_LEGACY) return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
            return key === keyRef.current;
        };
        // The final state object when the request finishes.
        const finalState = {
            isValidating: false,
            isLoading: false
        };
        const finishRequestAndUpdateState = ()=>{
            setCache(finalState);
        };
        const cleanupState = ()=>{
            // Check if it's still the same request before deleting it.
            const requestInfo = FETCH[key];
            if (requestInfo && requestInfo[1] === startAt) delete FETCH[key];
        };
        // Start fetching. Change the `isValidating` state, update the cache.
        const initialState = {
            isValidating: true
        };
        // It is in the `isLoading` state, if and only if there is no cached data.
        // This bypasses fallback data and laggy data.
        if ((0, $eRk4j.isUndefined)(getCache().data)) initialState.isLoading = true;
        try {
            if (shouldStartNewRequest) {
                setCache(initialState);
                // If no cache is being rendered currently (it shows a blank page),
                // we trigger the loading slow event.
                if (config.loadingTimeout && (0, $eRk4j.isUndefined)(getCache().data)) setTimeout(()=>{
                    if (loading && callbackSafeguard()) getConfig().onLoadingSlow(key, config);
                }, config.loadingTimeout);
                // Start the request and save the timestamp.
                // Key must be truthy if entering here.
                FETCH[key] = [
                    currentFetcher(fnArg),
                    (0, $eRk4j.getTimestamp)()
                ];
            }
            [newData, startAt] = FETCH[key];
            newData = await newData;
            if (shouldStartNewRequest) // If the request isn't interrupted, clean it up after the
            // deduplication interval.
            setTimeout(cleanupState, config.dedupingInterval);
            // If there're other ongoing request(s), started after the current one,
            // we need to ignore the current one to avoid possible race conditions:
            //   req1------------------>res1        (current one)
            //        req2---------------->res2
            // the request that fired later will always be kept.
            // The timestamp maybe be `undefined` or a number
            if (!FETCH[key] || FETCH[key][1] !== startAt) {
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Clear error.
            finalState.error = (0, $eRk4j.UNDEFINED);
            // If there're other mutations(s), that overlapped with the current revalidation:
            // case 1:
            //   req------------------>res
            //       mutate------>end
            // case 2:
            //         req------------>res
            //   mutate------>end
            // case 3:
            //   req------------------>res
            //       mutate-------...---------->
            // we have to ignore the revalidation result (res) because it's no longer fresh.
            // meanwhile, a new revalidation should be triggered when the mutation ends.
            const mutationInfo = MUTATION[key];
            if (!(0, $eRk4j.isUndefined)(mutationInfo) && // case 1
            (startAt <= mutationInfo[0] || // case 2
            startAt <= mutationInfo[1] || // case 3
            mutationInfo[1] === 0)) {
                finishRequestAndUpdateState();
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Deep compare with the latest state to avoid extra re-renders.
            // For local state, compare and assign.
            const cacheData = getCache().data;
            // Since the compare fn could be custom fn
            // cacheData might be different from newData even when compare fn returns True
            finalState.data = compare(cacheData, newData) ? cacheData : newData;
            // Trigger the successful callback if it's the original request.
            if (shouldStartNewRequest) {
                if (callbackSafeguard()) getConfig().onSuccess(newData, key, config);
            }
        } catch (err) {
            cleanupState();
            const currentConfig = getConfig();
            const { shouldRetryOnError: shouldRetryOnError } = currentConfig;
            // Not paused, we continue handling the error. Otherwise, discard it.
            if (!currentConfig.isPaused()) {
                // Get a new error, don't use deep comparison for errors.
                finalState.error = err;
                // Error event and retry logic. Only for the actual request, not
                // deduped ones.
                if (shouldStartNewRequest && callbackSafeguard()) {
                    currentConfig.onError(err, key, currentConfig);
                    if (shouldRetryOnError === true || (0, $eRk4j.isFunction)(shouldRetryOnError) && shouldRetryOnError(err)) {
                        if (!getConfig().revalidateOnFocus || !getConfig().revalidateOnReconnect || isActive()) // If it's inactive, stop. It will auto-revalidate when
                        // refocusing or reconnecting.
                        // When retrying, deduplication is always enabled.
                        currentConfig.onErrorRetry(err, key, currentConfig, (_opts)=>{
                            const revalidators = EVENT_REVALIDATORS[key];
                            if (revalidators && revalidators[0]) revalidators[0]((0, $eRk4j.revalidateEvents).ERROR_REVALIDATE_EVENT, _opts);
                        }, {
                            retryCount: (opts.retryCount || 0) + 1,
                            dedupe: true
                        });
                    }
                }
            }
        }
        // Mark loading as stopped.
        loading = false;
        // Update the current hook's state.
        finishRequestAndUpdateState();
        return true;
    }, // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key,
        cache
    ]);
    // Similar to the global mutate but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    const boundMutate = (0, $8NFma.useCallback)((...args)=>{
        return (0, $eRk4j.internalMutate)(cache, keyRef.current, ...args);
    }, []);
    // The logic for updating refs.
    (0, $eRk4j.useIsomorphicLayoutEffect)(()=>{
        fetcherRef.current = fetcher;
        configRef.current = config;
        // Handle laggy data updates. If there's cached data of the current key,
        // it'll be the correct reference.
        if (!(0, $eRk4j.isUndefined)(cachedData)) laggyDataRef.current = cachedData;
    });
    // After mounted or key changed.
    (0, $eRk4j.useIsomorphicLayoutEffect)(()=>{
        if (!key) return;
        const softRevalidate = revalidate.bind((0, $eRk4j.UNDEFINED), $4ddbe65021abc4ba$var$WITH_DEDUPE);
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        let nextFocusRevalidatedAt = 0;
        const onRevalidate = (type, opts = {})=>{
            if (type == (0, $eRk4j.revalidateEvents).FOCUS_EVENT) {
                const now = Date.now();
                if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            } else if (type == (0, $eRk4j.revalidateEvents).RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) softRevalidate();
            } else if (type == (0, $eRk4j.revalidateEvents).MUTATE_EVENT) return revalidate();
            else if (type == (0, $eRk4j.revalidateEvents).ERROR_REVALIDATE_EVENT) return revalidate(opts);
            return;
        };
        const unsubEvents = (0, $eRk4j.subscribeCallback)(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // Keep the original key in the cache.
        setCache({
            _k: fnArg
        });
        // Trigger a revalidation
        if (shouldDoInitialRevalidation) {
            if ((0, $eRk4j.isUndefined)(data) || (0, $eRk4j.IS_SERVER)) // Revalidate immediately.
            softRevalidate();
            else // Delay the revalidate if we have data to return so we won't block
            // rendering.
            (0, $eRk4j.rAF)(softRevalidate);
        }
        return ()=>{
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubEvents();
        };
    }, [
        key
    ]);
    // Polling
    (0, $eRk4j.useIsomorphicLayoutEffect)(()=>{
        let timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            const interval = (0, $eRk4j.isFunction)(refreshInterval) ? refreshInterval(getCache().data) : refreshInterval;
            // We only start the next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) timer = setTimeout(execute, interval);
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online, and not errored.
            if (!getCache().error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) revalidate($4ddbe65021abc4ba$var$WITH_DEDUPE).then(next);
            else // Schedule the next interval to check again.
            next();
        }
        next();
        return ()=>{
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [
        refreshInterval,
        refreshWhenHidden,
        refreshWhenOffline,
        key
    ]);
    // Display debug info in React DevTools.
    (0, $8NFma.useDebugValue)(returnedData);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is an `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense && (0, $eRk4j.isUndefined)(data) && key) {
        // SWR should throw when trying to use Suspense on the server with React 18,
        // without providing any initial data. See:
        // https://github.com/vercel/swr/issues/1832
        if (!(0, $eRk4j.IS_REACT_LEGACY) && (0, $eRk4j.IS_SERVER)) throw new Error("Fallback data is required when using suspense in SSR.");
        // Always update fetcher and config refs even with the Suspense mode.
        fetcherRef.current = fetcher;
        configRef.current = config;
        unmountedRef.current = false;
        const req = PRELOAD[key];
        if (!(0, $eRk4j.isUndefined)(req)) {
            const promise = boundMutate(req);
            $4ddbe65021abc4ba$var$use(promise);
        }
        if ((0, $eRk4j.isUndefined)(error)) {
            const promise = revalidate($4ddbe65021abc4ba$var$WITH_DEDUPE);
            if (!(0, $eRk4j.isUndefined)(returnedData)) {
                promise.status = "fulfilled";
                promise.value = true;
            }
            $4ddbe65021abc4ba$var$use(promise);
        } else throw error;
    }
    return {
        mutate: boundMutate,
        get data () {
            stateDependencies.data = true;
            return returnedData;
        },
        get error () {
            stateDependencies.error = true;
            return error;
        },
        get isValidating () {
            stateDependencies.isValidating = true;
            return isValidating;
        },
        get isLoading () {
            stateDependencies.isLoading = true;
            return isLoading;
        }
    };
};
const $4ddbe65021abc4ba$export$4c7bbecdacc3ca2c = (0, $eRk4j.OBJECT).defineProperty((0, $eRk4j.SWRConfig), "defaultValue", {
    value: (0, $eRk4j.defaultConfig)
});
/**
 * A hook to fetch data.
 *
 * @link https://swr.vercel.app
 * @example
 * ```jsx
 * import useSWR from 'swr'
 * function Profile() {
 *   const { data, error, isLoading } = useSWR('/api/user', fetcher)
 *   if (error) return <div>failed to load</div>
 *   if (isLoading) return <div>loading...</div>
 *   return <div>hello {data.name}!</div>
 * }
 * ```
 */ const $4ddbe65021abc4ba$export$2e2bcd8739ae039 = (0, $eRk4j.withArgs)($4ddbe65021abc4ba$var$useSWRHandler);

});
parcelRegister("8kCQs", function(module, exports) {

});

parcelRegister("eRk4j", function(module, exports) {

$parcel$export(module.exports, "UNDEFINED", () => $ad15951bfec2967e$export$6db089fe7b26f5b6);
$parcel$export(module.exports, "OBJECT", () => $ad15951bfec2967e$export$8b8a958a7f6f130c);
$parcel$export(module.exports, "isUndefined", () => $ad15951bfec2967e$export$fce6876652108ab);
$parcel$export(module.exports, "isFunction", () => $ad15951bfec2967e$export$f6e2535fb5126e54);
$parcel$export(module.exports, "mergeObjects", () => $ad15951bfec2967e$export$2321aea138b44780);
$parcel$export(module.exports, "SWRGlobalState", () => $ad15951bfec2967e$export$b94ca9901c60634);
$parcel$export(module.exports, "createCacheHelper", () => $ad15951bfec2967e$export$1251d51d9c571b45);
$parcel$export(module.exports, "IS_REACT_LEGACY", () => $ad15951bfec2967e$export$ddb64fe6466374f7);
$parcel$export(module.exports, "IS_SERVER", () => $ad15951bfec2967e$export$d2f4d8e74279c212);
$parcel$export(module.exports, "rAF", () => $ad15951bfec2967e$export$eba6076d3d7d0c06);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $ad15951bfec2967e$export$700979bc83e7db82);
$parcel$export(module.exports, "serialize", () => $ad15951bfec2967e$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "getTimestamp", () => $ad15951bfec2967e$export$3c95c4c8b671ef0);
$parcel$export(module.exports, "revalidateEvents", () => $ad15951bfec2967e$export$10213d6aa5ce32e6);
$parcel$export(module.exports, "internalMutate", () => $ad15951bfec2967e$export$c9d44e5bea4509be);
$parcel$export(module.exports, "cache", () => $ad15951bfec2967e$export$69a3209f1a06c04d);
$parcel$export(module.exports, "mutate", () => $ad15951bfec2967e$export$57e795267c26e600);
$parcel$export(module.exports, "defaultConfig", () => $ad15951bfec2967e$export$f84bd70098573c5c);
$parcel$export(module.exports, "SWRConfig", () => $ad15951bfec2967e$export$4c7bbecdacc3ca2c);
$parcel$export(module.exports, "INFINITE_PREFIX", () => $ad15951bfec2967e$export$8667f065faedc62c);
$parcel$export(module.exports, "useSWRConfig", () => $ad15951bfec2967e$export$f1dc0e282d4c1c0);
$parcel$export(module.exports, "preload", () => $ad15951bfec2967e$export$513ccb98c53b8039);
$parcel$export(module.exports, "withArgs", () => $ad15951bfec2967e$export$84d44e54e14b0133);
$parcel$export(module.exports, "subscribeCallback", () => $ad15951bfec2967e$export$e005210ed621746);
$parcel$export(module.exports, "withMiddleware", () => $ad15951bfec2967e$export$525ea7fc6ba00096);

var $8NFma = parcelRequire("8NFma");
// Shared state between server components and client components
const $ad15951bfec2967e$export$8793edee2d425525 = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $ad15951bfec2967e$export$6db089fe7b26f5b6 = /*#__NOINLINE__*/ $ad15951bfec2967e$export$8793edee2d425525();
const $ad15951bfec2967e$export$8b8a958a7f6f130c = Object;
const $ad15951bfec2967e$export$fce6876652108ab = (v)=>v === $ad15951bfec2967e$export$6db089fe7b26f5b6;
const $ad15951bfec2967e$export$f6e2535fb5126e54 = (v)=>typeof v == "function";
const $ad15951bfec2967e$export$2321aea138b44780 = (a, b)=>({
        ...a,
        ...b
    });
const $ad15951bfec2967e$export$ae936b9d47e5870e = (x)=>$ad15951bfec2967e$export$f6e2535fb5126e54(x.then);
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $ad15951bfec2967e$var$table = new WeakMap();
// counter of the key
let $ad15951bfec2967e$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $ad15951bfec2967e$export$e9a4e06c7dfb0bd4 = (arg)=>{
    const type = typeof arg;
    const constructor = arg && arg.constructor;
    const isDate = constructor == Date;
    let result;
    let index;
    if ($ad15951bfec2967e$export$8b8a958a7f6f130c(arg) === arg && !isDate && constructor != RegExp) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $ad15951bfec2967e$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$ad15951bfec2967e$var$counter + "~";
        $ad15951bfec2967e$var$table.set(arg, result);
        if (constructor == Array) {
            // Array.
            result = "@";
            for(index = 0; index < arg.length; index++)result += $ad15951bfec2967e$export$e9a4e06c7dfb0bd4(arg[index]) + ",";
            $ad15951bfec2967e$var$table.set(arg, result);
        }
        if (constructor == $ad15951bfec2967e$export$8b8a958a7f6f130c) {
            // Object, sort keys.
            result = "#";
            const keys = $ad15951bfec2967e$export$8b8a958a7f6f130c.keys(arg).sort();
            while(!$ad15951bfec2967e$export$fce6876652108ab(index = keys.pop()))if (!$ad15951bfec2967e$export$fce6876652108ab(arg[index])) result += index + ":" + $ad15951bfec2967e$export$e9a4e06c7dfb0bd4(arg[index]) + ",";
            $ad15951bfec2967e$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == "symbol" ? arg.toString() : type == "string" ? JSON.stringify(arg) : "" + arg;
    return result;
};
// Global state used to deduplicate requests and store listeners
const $ad15951bfec2967e$export$b94ca9901c60634 = new WeakMap();
const $ad15951bfec2967e$var$EMPTY_CACHE = {};
const $ad15951bfec2967e$var$INITIAL_CACHE = {};
const $ad15951bfec2967e$var$STR_UNDEFINED = "undefined";
// NOTE: Use the function to guarantee it's re-evaluated between jsdom and node runtime for tests.
const $ad15951bfec2967e$export$6e85fd745dc51282 = typeof window != $ad15951bfec2967e$var$STR_UNDEFINED;
const $ad15951bfec2967e$export$842dfe7a9f24298 = typeof document != $ad15951bfec2967e$var$STR_UNDEFINED;
const $ad15951bfec2967e$export$a9116928c9d15917 = ()=>$ad15951bfec2967e$export$6e85fd745dc51282 && typeof window["requestAnimationFrame"] != $ad15951bfec2967e$var$STR_UNDEFINED;
const $ad15951bfec2967e$export$1251d51d9c571b45 = (cache, key)=>{
    const state = $ad15951bfec2967e$export$b94ca9901c60634.get(cache);
    return [
        // Getter
        ()=>!$ad15951bfec2967e$export$fce6876652108ab(key) && cache.get(key) || $ad15951bfec2967e$var$EMPTY_CACHE,
        // Setter
        (info)=>{
            if (!$ad15951bfec2967e$export$fce6876652108ab(key)) {
                const prev = cache.get(key);
                // Before writing to the store, we keep the value in the initial cache
                // if it's not there yet.
                if (!(key in $ad15951bfec2967e$var$INITIAL_CACHE)) $ad15951bfec2967e$var$INITIAL_CACHE[key] = prev;
                state[5](key, $ad15951bfec2967e$export$2321aea138b44780(prev, info), prev || $ad15951bfec2967e$var$EMPTY_CACHE);
            }
        },
        // Subscriber
        state[6],
        // Get server cache snapshot
        ()=>{
            if (!$ad15951bfec2967e$export$fce6876652108ab(key)) {
                // If the cache was updated on the client, we return the stored initial value.
                if (key in $ad15951bfec2967e$var$INITIAL_CACHE) return $ad15951bfec2967e$var$INITIAL_CACHE[key];
            }
            // If we haven't done any client-side updates, we return the current value.
            return !$ad15951bfec2967e$export$fce6876652108ab(key) && cache.get(key) || $ad15951bfec2967e$var$EMPTY_CACHE;
        }
    ];
} // export { UNDEFINED, OBJECT, isUndefined, isFunction, mergeObjects, isPromiseLike }
;
/**
 * Due to the bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a workaround, we always assume it's online on the first load, and change
 * the status upon `online` or `offline` events.
 */ let $ad15951bfec2967e$var$online = true;
const $ad15951bfec2967e$var$isOnline = ()=>$ad15951bfec2967e$var$online;
// For node and React Native, `add/removeEventListener` doesn't exist on window.
const [$ad15951bfec2967e$var$onWindowEvent, $ad15951bfec2967e$var$offWindowEvent] = $ad15951bfec2967e$export$6e85fd745dc51282 && window.addEventListener ? [
    window.addEventListener.bind(window),
    window.removeEventListener.bind(window)
] : [
    $ad15951bfec2967e$export$8793edee2d425525,
    $ad15951bfec2967e$export$8793edee2d425525
];
const $ad15951bfec2967e$var$isVisible = ()=>{
    const visibilityState = $ad15951bfec2967e$export$842dfe7a9f24298 && document.visibilityState;
    return $ad15951bfec2967e$export$fce6876652108ab(visibilityState) || visibilityState !== "hidden";
};
const $ad15951bfec2967e$var$initFocus = (callback)=>{
    // focus revalidate
    if ($ad15951bfec2967e$export$842dfe7a9f24298) document.addEventListener("visibilitychange", callback);
    $ad15951bfec2967e$var$onWindowEvent("focus", callback);
    return ()=>{
        if ($ad15951bfec2967e$export$842dfe7a9f24298) document.removeEventListener("visibilitychange", callback);
        $ad15951bfec2967e$var$offWindowEvent("focus", callback);
    };
};
const $ad15951bfec2967e$var$initReconnect = (callback)=>{
    // revalidate on reconnected
    const onOnline = ()=>{
        $ad15951bfec2967e$var$online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    const onOffline = ()=>{
        $ad15951bfec2967e$var$online = false;
    };
    $ad15951bfec2967e$var$onWindowEvent("online", onOnline);
    $ad15951bfec2967e$var$onWindowEvent("offline", onOffline);
    return ()=>{
        $ad15951bfec2967e$var$offWindowEvent("online", onOnline);
        $ad15951bfec2967e$var$offWindowEvent("offline", onOffline);
    };
};
const $ad15951bfec2967e$export$f5ab8217e0edff04 = {
    isOnline: $ad15951bfec2967e$var$isOnline,
    isVisible: $ad15951bfec2967e$var$isVisible
};
const $ad15951bfec2967e$export$b1857f3440a65373 = {
    initFocus: $ad15951bfec2967e$var$initFocus,
    initReconnect: $ad15951bfec2967e$var$initReconnect
};
const $ad15951bfec2967e$export$ddb64fe6466374f7 = !(0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useId;
const $ad15951bfec2967e$export$d2f4d8e74279c212 = !$ad15951bfec2967e$export$6e85fd745dc51282 || "Deno" in window;
// Polyfill requestAnimationFrame
const $ad15951bfec2967e$export$eba6076d3d7d0c06 = (f)=>$ad15951bfec2967e$export$a9116928c9d15917() ? window["requestAnimationFrame"](f) : setTimeout(f, 1);
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
const $ad15951bfec2967e$export$700979bc83e7db82 = $ad15951bfec2967e$export$d2f4d8e74279c212 ? (0, $8NFma.useEffect) : (0, $8NFma.useLayoutEffect);
// This assignment is to extend the Navigator type to use effectiveType.
const $ad15951bfec2967e$var$navigatorConnection = typeof navigator !== "undefined" && navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
const $ad15951bfec2967e$export$3723beb60427dc52 = !$ad15951bfec2967e$export$d2f4d8e74279c212 && $ad15951bfec2967e$var$navigatorConnection && ([
    "slow-2g",
    "2g"
].includes($ad15951bfec2967e$var$navigatorConnection.effectiveType) || $ad15951bfec2967e$var$navigatorConnection.saveData);
const $ad15951bfec2967e$export$dfdc1655ccc5b9cb = (key)=>{
    if ($ad15951bfec2967e$export$f6e2535fb5126e54(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = "";
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == "string" ? key : (Array.isArray(key) ? key.length : key) ? $ad15951bfec2967e$export$e9a4e06c7dfb0bd4(key) : "";
    return [
        key,
        args
    ];
};
// Global timestamp.
let $ad15951bfec2967e$var$__timestamp = 0;
const $ad15951bfec2967e$export$3c95c4c8b671ef0 = ()=>++$ad15951bfec2967e$var$__timestamp;
const $ad15951bfec2967e$var$FOCUS_EVENT = 0;
const $ad15951bfec2967e$var$RECONNECT_EVENT = 1;
const $ad15951bfec2967e$var$MUTATE_EVENT = 2;
const $ad15951bfec2967e$var$ERROR_REVALIDATE_EVENT = 3;
var $ad15951bfec2967e$export$10213d6aa5ce32e6 = {
    __proto__: null,
    ERROR_REVALIDATE_EVENT: $ad15951bfec2967e$var$ERROR_REVALIDATE_EVENT,
    FOCUS_EVENT: $ad15951bfec2967e$var$FOCUS_EVENT,
    MUTATE_EVENT: $ad15951bfec2967e$var$MUTATE_EVENT,
    RECONNECT_EVENT: $ad15951bfec2967e$var$RECONNECT_EVENT
};
async function $ad15951bfec2967e$export$c9d44e5bea4509be(...args) {
    const [cache, _key, _data, _opts] = args;
    // When passing as a boolean, it's explicitly used to disable/enable
    // revalidation.
    const options = $ad15951bfec2967e$export$2321aea138b44780({
        populateCache: true,
        throwOnError: true
    }, typeof _opts === "boolean" ? {
        revalidate: _opts
    } : _opts || {});
    let populateCache = options.populateCache;
    const rollbackOnErrorOption = options.rollbackOnError;
    let optimisticData = options.optimisticData;
    const rollbackOnError = (error)=>{
        return typeof rollbackOnErrorOption === "function" ? rollbackOnErrorOption(error) : rollbackOnErrorOption !== false;
    };
    const throwOnError = options.throwOnError;
    // If the second argument is a key filter, return the mutation results for all
    // filtered keys.
    if ($ad15951bfec2967e$export$f6e2535fb5126e54(_key)) {
        const keyFilter = _key;
        const matchedKeys = [];
        const it = cache.keys();
        for (const key of it)if (!/^\$(inf|sub)\$/.test(key) && keyFilter(cache.get(key)._k)) matchedKeys.push(key);
        return Promise.all(matchedKeys.map(mutateByKey));
    }
    return mutateByKey(_key);
    async function mutateByKey(_k) {
        // Serialize key
        const [key] = $ad15951bfec2967e$export$dfdc1655ccc5b9cb(_k);
        if (!key) return;
        const [get, set] = $ad15951bfec2967e$export$1251d51d9c571b45(cache, key);
        const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = $ad15951bfec2967e$export$b94ca9901c60634.get(cache);
        const startRevalidate = ()=>{
            const revalidators = EVENT_REVALIDATORS[key];
            const revalidate = $ad15951bfec2967e$export$f6e2535fb5126e54(options.revalidate) ? options.revalidate(get().data, _k) : options.revalidate !== false;
            if (revalidate) {
                // Invalidate the key by deleting the concurrent request markers so new
                // requests will not be deduped.
                delete FETCH[key];
                delete PRELOAD[key];
                if (revalidators && revalidators[0]) return revalidators[0]($ad15951bfec2967e$var$MUTATE_EVENT).then(()=>get().data);
            }
            return get().data;
        };
        // If there is no new data provided, revalidate the key with current state.
        if (args.length < 3) // Revalidate and broadcast state.
        return startRevalidate();
        let data = _data;
        let error;
        // Update global timestamps.
        const beforeMutationTs = $ad15951bfec2967e$export$3c95c4c8b671ef0();
        MUTATION[key] = [
            beforeMutationTs,
            0
        ];
        const hasOptimisticData = !$ad15951bfec2967e$export$fce6876652108ab(optimisticData);
        const state = get();
        // `displayedData` is the current value on screen. It could be the optimistic value
        // that is going to be overridden by a `committedData`, or get reverted back.
        // `committedData` is the validated value that comes from a fetch or mutation.
        const displayedData = state.data;
        const currentData = state._c;
        const committedData = $ad15951bfec2967e$export$fce6876652108ab(currentData) ? displayedData : currentData;
        // Do optimistic data update.
        if (hasOptimisticData) {
            optimisticData = $ad15951bfec2967e$export$f6e2535fb5126e54(optimisticData) ? optimisticData(committedData, displayedData) : optimisticData;
            // When we set optimistic data, backup the current committedData data in `_c`.
            set({
                data: optimisticData,
                _c: committedData
            });
        }
        if ($ad15951bfec2967e$export$f6e2535fb5126e54(data)) // `data` is a function, call it passing current cache value.
        try {
            data = data(committedData);
        } catch (err) {
            // If it throws an error synchronously, we shouldn't update the cache.
            error = err;
        }
        // `data` is a promise/thenable, resolve the final data first.
        if (data && $ad15951bfec2967e$export$ae936b9d47e5870e(data)) {
            // This means that the mutation is async, we need to check timestamps to
            // avoid race conditions.
            data = await data.catch((err)=>{
                error = err;
            });
            // Check if other mutations have occurred since we've started this mutation.
            // If there's a race we don't update cache or broadcast the change,
            // just return the data.
            if (beforeMutationTs !== MUTATION[key][0]) {
                if (error) throw error;
                return data;
            } else if (error && hasOptimisticData && rollbackOnError(error)) {
                // Rollback. Always populate the cache in this case but without
                // transforming the data.
                populateCache = true;
                // Reset data to be the latest committed data, and clear the `_c` value.
                set({
                    data: committedData,
                    _c: $ad15951bfec2967e$export$6db089fe7b26f5b6
                });
            }
        }
        // If we should write back the cache after request.
        if (populateCache) {
            if (!error) {
                // Transform the result into data.
                if ($ad15951bfec2967e$export$f6e2535fb5126e54(populateCache)) {
                    const populateCachedData = populateCache(data, committedData);
                    set({
                        data: populateCachedData,
                        error: $ad15951bfec2967e$export$6db089fe7b26f5b6,
                        _c: $ad15951bfec2967e$export$6db089fe7b26f5b6
                    });
                } else // Only update cached data and reset the error if there's no error. Data can be `undefined` here.
                set({
                    data: data,
                    error: $ad15951bfec2967e$export$6db089fe7b26f5b6,
                    _c: $ad15951bfec2967e$export$6db089fe7b26f5b6
                });
            }
        }
        // Reset the timestamp to mark the mutation has ended.
        MUTATION[key][1] = $ad15951bfec2967e$export$3c95c4c8b671ef0();
        // Update existing SWR Hooks' internal states:
        Promise.resolve(startRevalidate()).then(()=>{
            // The mutation and revalidation are ended, we can clear it since the data is
            // not an optimistic value anymore.
            set({
                _c: $ad15951bfec2967e$export$6db089fe7b26f5b6
            });
        });
        // Throw error or return data
        if (error) {
            if (throwOnError) throw error;
            return;
        }
        return data;
    }
}
const $ad15951bfec2967e$var$revalidateAllKeys = (revalidators, type)=>{
    for(const key in revalidators)if (revalidators[key][0]) revalidators[key][0](type);
};
const $ad15951bfec2967e$export$4008f5b66f9e0b3c = (provider, options)=>{
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that is bound to
    // the cache.
    // The provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!$ad15951bfec2967e$export$b94ca9901c60634.has(provider)) {
        const opts = $ad15951bfec2967e$export$2321aea138b44780($ad15951bfec2967e$export$b1857f3440a65373, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        const EVENT_REVALIDATORS = {};
        const mutate = $ad15951bfec2967e$export$c9d44e5bea4509be.bind($ad15951bfec2967e$export$6db089fe7b26f5b6, provider);
        let unmount = $ad15951bfec2967e$export$8793edee2d425525;
        const subscriptions = {};
        const subscribe = (key, callback)=>{
            const subs = subscriptions[key] || [];
            subscriptions[key] = subs;
            subs.push(callback);
            return ()=>subs.splice(subs.indexOf(callback), 1);
        };
        const setter = (key, value, prev)=>{
            provider.set(key, value);
            const subs = subscriptions[key];
            if (subs) for (const fn of subs)fn(value, prev);
        };
        const initProvider = ()=>{
            if (!$ad15951bfec2967e$export$b94ca9901c60634.has(provider)) {
                // Update the state if it's new, or if the provider has been extended.
                $ad15951bfec2967e$export$b94ca9901c60634.set(provider, [
                    EVENT_REVALIDATORS,
                    {},
                    {},
                    {},
                    mutate,
                    setter,
                    subscribe
                ]);
                if (!$ad15951bfec2967e$export$d2f4d8e74279c212) {
                    // When listening to the native events for auto revalidations,
                    // we intentionally put a delay (setTimeout) here to make sure they are
                    // fired after immediate JavaScript executions, which can be
                    // React's state updates.
                    // This avoids some unnecessary revalidations such as
                    // https://github.com/vercel/swr/issues/1680.
                    const releaseFocus = opts.initFocus(setTimeout.bind($ad15951bfec2967e$export$6db089fe7b26f5b6, $ad15951bfec2967e$var$revalidateAllKeys.bind($ad15951bfec2967e$export$6db089fe7b26f5b6, EVENT_REVALIDATORS, $ad15951bfec2967e$var$FOCUS_EVENT)));
                    const releaseReconnect = opts.initReconnect(setTimeout.bind($ad15951bfec2967e$export$6db089fe7b26f5b6, $ad15951bfec2967e$var$revalidateAllKeys.bind($ad15951bfec2967e$export$6db089fe7b26f5b6, EVENT_REVALIDATORS, $ad15951bfec2967e$var$RECONNECT_EVENT)));
                    unmount = ()=>{
                        releaseFocus && releaseFocus();
                        releaseReconnect && releaseReconnect();
                        // When un-mounting, we need to remove the cache provider from the state
                        // storage too because it's a side-effect. Otherwise, when re-mounting we
                        // will not re-register those event listeners.
                        $ad15951bfec2967e$export$b94ca9901c60634.delete(provider);
                    };
                }
            }
        };
        initProvider();
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [
            provider,
            mutate,
            initProvider,
            unmount
        ];
    }
    return [
        provider,
        $ad15951bfec2967e$export$b94ca9901c60634.get(provider)[4]
    ];
};
// error retry
const $ad15951bfec2967e$var$onErrorRetry = (_, __, config, revalidate, opts)=>{
    const maxRetryCount = config.errorRetryCount;
    const currentRetryCount = opts.retryCount;
    // Exponential backoff
    const timeout = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!$ad15951bfec2967e$export$fce6876652108ab(maxRetryCount) && currentRetryCount > maxRetryCount) return;
    setTimeout(revalidate, timeout, opts);
};
const $ad15951bfec2967e$export$398604a469f7de9a = (currentData, newData)=>$ad15951bfec2967e$export$e9a4e06c7dfb0bd4(currentData) == $ad15951bfec2967e$export$e9a4e06c7dfb0bd4(newData);
// Default cache provider
const [$ad15951bfec2967e$export$69a3209f1a06c04d, $ad15951bfec2967e$export$57e795267c26e600] = $ad15951bfec2967e$export$4008f5b66f9e0b3c(new Map());
// Default config
const $ad15951bfec2967e$export$f84bd70098573c5c = $ad15951bfec2967e$export$2321aea138b44780({
    // events
    onLoadingSlow: $ad15951bfec2967e$export$8793edee2d425525,
    onSuccess: $ad15951bfec2967e$export$8793edee2d425525,
    onError: $ad15951bfec2967e$export$8793edee2d425525,
    onErrorRetry: $ad15951bfec2967e$var$onErrorRetry,
    onDiscarded: $ad15951bfec2967e$export$8793edee2d425525,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: $ad15951bfec2967e$export$3723beb60427dc52 ? 10000 : 5000,
    focusThrottleInterval: 5000,
    dedupingInterval: 2000,
    loadingTimeout: $ad15951bfec2967e$export$3723beb60427dc52 ? 5000 : 3000,
    compare: // providers
    $ad15951bfec2967e$export$398604a469f7de9a,
    isPaused: ()=>false,
    cache: $ad15951bfec2967e$export$69a3209f1a06c04d,
    mutate: $ad15951bfec2967e$export$57e795267c26e600,
    fallback: {}
}, $ad15951bfec2967e$export$f5ab8217e0edff04);
const $ad15951bfec2967e$export$5d86b86a654a7039 = (a, b)=>{
    // Need to create a new object to avoid mutating the original here.
    const v = $ad15951bfec2967e$export$2321aea138b44780(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        const { use: u1, fallback: f1 } = a;
        const { use: u2, fallback: f2 } = b;
        if (u1 && u2) v.use = u1.concat(u2);
        if (f1 && f2) v.fallback = $ad15951bfec2967e$export$2321aea138b44780(f1, f2);
    }
    return v;
};
const $ad15951bfec2967e$var$SWRConfigContext = (0, $8NFma.createContext)({});
const $ad15951bfec2967e$export$4c7bbecdacc3ca2c = (props)=>{
    const { value: value } = props;
    const parentConfig = (0, $8NFma.useContext)($ad15951bfec2967e$var$SWRConfigContext);
    const isFunctionalConfig = $ad15951bfec2967e$export$f6e2535fb5126e54(value);
    const config = (0, $8NFma.useMemo)(()=>isFunctionalConfig ? value(parentConfig) : value, [
        isFunctionalConfig,
        parentConfig,
        value
    ]);
    // Extend parent context values and middleware.
    const extendedConfig = (0, $8NFma.useMemo)(()=>isFunctionalConfig ? config : $ad15951bfec2967e$export$5d86b86a654a7039(parentConfig, config), [
        isFunctionalConfig,
        parentConfig,
        config
    ]);
    // Should not use the inherited provider.
    const provider = config && config.provider;
    // initialize the cache only on first access.
    const cacheContextRef = (0, $8NFma.useRef)($ad15951bfec2967e$export$6db089fe7b26f5b6);
    if (provider && !cacheContextRef.current) cacheContextRef.current = $ad15951bfec2967e$export$4008f5b66f9e0b3c(provider(extendedConfig.cache || $ad15951bfec2967e$export$69a3209f1a06c04d), config);
    const cacheContext = cacheContextRef.current;
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    $ad15951bfec2967e$export$700979bc83e7db82(()=>{
        if (cacheContext) {
            cacheContext[2] && cacheContext[2]();
            return cacheContext[3];
        }
    }, []);
    return (0, $8NFma.createElement)($ad15951bfec2967e$var$SWRConfigContext.Provider, $ad15951bfec2967e$export$2321aea138b44780(props, {
        value: extendedConfig
    }));
};
const $ad15951bfec2967e$export$8667f065faedc62c = "$inf$";
// @ts-expect-error
const $ad15951bfec2967e$var$enableDevtools = $ad15951bfec2967e$export$6e85fd745dc51282 && window.__SWR_DEVTOOLS_USE__;
const $ad15951bfec2967e$var$use = $ad15951bfec2967e$var$enableDevtools ? window.__SWR_DEVTOOLS_USE__ : [];
const $ad15951bfec2967e$var$setupDevTools = ()=>{
    if ($ad15951bfec2967e$var$enableDevtools) // @ts-expect-error
    window.__SWR_DEVTOOLS_REACT__ = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma)));
};
const $ad15951bfec2967e$export$a3295358bff77e = (args)=>{
    return $ad15951bfec2967e$export$f6e2535fb5126e54(args[1]) ? [
        args[0],
        args[1],
        args[2] || {}
    ] : [
        args[0],
        null,
        (args[1] === null ? args[2] : args[1]) || {}
    ];
};
const $ad15951bfec2967e$export$f1dc0e282d4c1c0 = ()=>{
    return $ad15951bfec2967e$export$2321aea138b44780($ad15951bfec2967e$export$f84bd70098573c5c, (0, $8NFma.useContext)($ad15951bfec2967e$var$SWRConfigContext));
};
const $ad15951bfec2967e$export$513ccb98c53b8039 = (key_, fetcher)=>{
    const [key, fnArg] = $ad15951bfec2967e$export$dfdc1655ccc5b9cb(key_);
    const [, , , PRELOAD] = $ad15951bfec2967e$export$b94ca9901c60634.get($ad15951bfec2967e$export$69a3209f1a06c04d);
    // Prevent preload to be called multiple times before used.
    if (PRELOAD[key]) return PRELOAD[key];
    const req = fetcher(fnArg);
    PRELOAD[key] = req;
    return req;
};
const $ad15951bfec2967e$var$middleware = (useSWRNext)=>(key_, fetcher_, config)=>{
        // fetcher might be a sync function, so this should not be an async function
        const fetcher = fetcher_ && ((...args)=>{
            const [key] = $ad15951bfec2967e$export$dfdc1655ccc5b9cb(key_);
            const [, , , PRELOAD] = $ad15951bfec2967e$export$b94ca9901c60634.get($ad15951bfec2967e$export$69a3209f1a06c04d);
            if (key.startsWith($ad15951bfec2967e$export$8667f065faedc62c)) // we want the infinite fetcher to be called.
            // handling of the PRELOAD cache happens there.
            return fetcher_(...args);
            const req = PRELOAD[key];
            if ($ad15951bfec2967e$export$fce6876652108ab(req)) return fetcher_(...args);
            delete PRELOAD[key];
            return req;
        });
        return useSWRNext(key_, fetcher, config);
    };
const $ad15951bfec2967e$var$BUILT_IN_MIDDLEWARE = $ad15951bfec2967e$var$use.concat($ad15951bfec2967e$var$middleware);
// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
const $ad15951bfec2967e$export$84d44e54e14b0133 = (hook)=>{
    return function useSWRArgs(...args) {
        // Get the default and inherited configuration.
        const fallbackConfig = $ad15951bfec2967e$export$f1dc0e282d4c1c0();
        // Normalize arguments.
        const [key, fn, _config] = $ad15951bfec2967e$export$a3295358bff77e(args);
        // Merge configurations.
        const config = $ad15951bfec2967e$export$5d86b86a654a7039(fallbackConfig, _config);
        // Apply middleware
        let next = hook;
        const { use: use } = config;
        const middleware = (use || []).concat($ad15951bfec2967e$var$BUILT_IN_MIDDLEWARE);
        for(let i = middleware.length; i--;)next = middleware[i](next);
        return next(key, fn || config.fetcher || null, config);
    };
};
// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
const $ad15951bfec2967e$export$e005210ed621746 = (key, callbacks, callback)=>{
    const keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return ()=>{
        const index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};
// Create a custom hook with a middleware
const $ad15951bfec2967e$export$525ea7fc6ba00096 = (useSWR, middleware)=>{
    return (...args)=>{
        const [key, fn, config] = $ad15951bfec2967e$export$a3295358bff77e(args);
        const uses = (config.use || []).concat(middleware);
        return useSWR(key, fn, {
            ...config,
            use: uses
        });
    };
};
$ad15951bfec2967e$var$setupDevTools();

});


parcelRegister("3TNde", function(module, exports) {
"use strict";
var $2d6caebbfd635437$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.useInfiniteAPI = module.exports.fetcher = void 0;

const $2d6caebbfd635437$var$react_1 = $2d6caebbfd635437$var$__importDefault((parcelRequire("8NFma")));

const $2d6caebbfd635437$var$infinite_1 = $2d6caebbfd635437$var$__importDefault((parcelRequire("k8ShY"))), $2d6caebbfd635437$var$fetcher = (e)=>fetch(e).then((e)=>e.json());
module.exports.fetcher = $2d6caebbfd635437$var$fetcher;
const $2d6caebbfd635437$var$useInfiniteAPI = ({ defaultQuery: e = "", timeout: t = 100, getAPI: r, getSize: i = (e)=>e.total_pages, fetchFunc: u = module.exports.fetcher })=>{
    var n;
    const a = $2d6caebbfd635437$var$react_1.default.useRef(e), o = $2d6caebbfd635437$var$react_1.default.useRef(), { data: l, error: s, size: c, setSize: f, mutate: d } = (0, $2d6caebbfd635437$var$infinite_1.default)((e)=>r({
            query: a.current,
            page: e + 1
        }), u, {
        revalidateAll: !1,
        revalidateOnFocus: !1
    }), _ = !l && !s || !!(c > 0 && l && void 0 === l[c - 1]), h = 0 === (null === (n = null == l ? void 0 : l[0]) || void 0 === n ? void 0 : n.length), p = null == l ? void 0 : l[l.length - 1], v = h || p && i(p) === c;
    return {
        setQuery: $2d6caebbfd635437$var$react_1.default.useCallback((e)=>{
            a.current = e, clearTimeout(o.current), o.current = setTimeout(()=>{
                d();
            }, t);
        }, [
            t
        ]),
        isLoading: _,
        loadMore: ()=>{
            v || f(c + 1);
        },
        isReachingEnd: v,
        data: null == l ? void 0 : l.filter((e)=>e),
        items: null == l ? void 0 : l.reduce((e, t)=>e.concat(t), []),
        hasMore: !v,
        reset: d,
        error: s
    };
};
module.exports.useInfiniteAPI = $2d6caebbfd635437$var$useInfiniteAPI;

});
parcelRegister("k8ShY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "unstable_serialize", () => $ea9eaaaa982fb4fd$export$dbab534a48e651ef);
$parcel$export(module.exports, "infinite", () => $ea9eaaaa982fb4fd$export$f27219e7b43e81d);
$parcel$export(module.exports, "default", () => $ea9eaaaa982fb4fd$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");
parcelRequire("8kCQs");

var $ck4pA = parcelRequire("ck4pA");

var $eRk4j = parcelRequire("eRk4j");
/// <reference types="react/experimental" />
const $ea9eaaaa982fb4fd$var$use = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).use || ((promise)=>{
    if (promise.status === "pending") throw promise;
    else if (promise.status === "fulfilled") return promise.value;
    else if (promise.status === "rejected") throw promise.reason;
    else {
        promise.status = "pending";
        promise.then((v)=>{
            promise.status = "fulfilled";
            promise.value = v;
        }, (e)=>{
            promise.status = "rejected";
            promise.reason = e;
        });
        throw promise;
    }
});
const $ea9eaaaa982fb4fd$var$WITH_DEDUPE = {
    dedupe: true
};
const $ea9eaaaa982fb4fd$var$useSWRHandler = (_key, fetcher, config)=>{
    const { cache: cache, compare: compare, suspense: suspense, fallbackData: fallbackData, revalidateOnMount: revalidateOnMount, revalidateIfStale: revalidateIfStale, refreshInterval: refreshInterval, refreshWhenHidden: refreshWhenHidden, refreshWhenOffline: refreshWhenOffline, keepPreviousData: keepPreviousData } = config;
    const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = (0, $eRk4j.SWRGlobalState).get(cache);
    // `key` is the identifier of the SWR internal state,
    // `fnArg` is the argument/arguments parsed from the key, which will be passed
    // to the fetcher.
    // All of them are derived from `_key`.
    const [key, fnArg] = (0, $eRk4j.serialize)(_key);
    // If it's the initial render of this hook.
    const initialMountedRef = (0, $8NFma.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    const unmountedRef = (0, $8NFma.useRef)(false);
    // Refs to keep the key and config.
    const keyRef = (0, $8NFma.useRef)(key);
    const fetcherRef = (0, $8NFma.useRef)(fetcher);
    const configRef = (0, $8NFma.useRef)(config);
    const getConfig = ()=>configRef.current;
    const isActive = ()=>getConfig().isVisible() && getConfig().isOnline();
    const [getCache, setCache, subscribeCache, getInitialCache] = (0, $eRk4j.createCacheHelper)(cache, key);
    const stateDependencies = (0, $8NFma.useRef)({}).current;
    const fallback = (0, $eRk4j.isUndefined)(fallbackData) ? config.fallback[key] : fallbackData;
    const isEqual = (prev, current)=>{
        for(const _ in stateDependencies){
            const t = _;
            if (t === "data") {
                if (!compare(prev[t], current[t])) {
                    if (!(0, $eRk4j.isUndefined)(prev[t])) return false;
                    if (!compare(returnedData, current[t])) return false;
                }
            } else {
                if (current[t] !== prev[t]) return false;
            }
        }
        return true;
    };
    const getSnapshot = (0, $8NFma.useMemo)(()=>{
        const shouldStartRequest = (()=>{
            if (!key) return false;
            if (!fetcher) return false;
            // If `revalidateOnMount` is set, we take the value directly.
            if (!(0, $eRk4j.isUndefined)(revalidateOnMount)) return revalidateOnMount;
            // If it's paused, we skip revalidation.
            if (getConfig().isPaused()) return false;
            if (suspense) return false;
            if (!(0, $eRk4j.isUndefined)(revalidateIfStale)) return revalidateIfStale;
            return true;
        })();
        // Get the cache and merge it with expected states.
        const getSelectedCache = (state)=>{
            // We only select the needed fields from the state.
            const snapshot = (0, $eRk4j.mergeObjects)(state);
            delete snapshot._k;
            if (!shouldStartRequest) return snapshot;
            return {
                isValidating: true,
                isLoading: true,
                ...snapshot
            };
        };
        const cachedData = getCache();
        const initialData = getInitialCache();
        const clientSnapshot = getSelectedCache(cachedData);
        const serverSnapshot = cachedData === initialData ? clientSnapshot : getSelectedCache(initialData);
        // To make sure that we are returning the same object reference to avoid
        // unnecessary re-renders, we keep the previous snapshot and use deep
        // comparison to check if we need to return a new one.
        let memorizedSnapshot = clientSnapshot;
        return [
            ()=>{
                const newSnapshot = getSelectedCache(getCache());
                const compareResult = isEqual(newSnapshot, memorizedSnapshot);
                if (compareResult) {
                    // Mentally, we should always return the `memorizedSnapshot` here
                    // as there's no change between the new and old snapshots.
                    // However, since the `isEqual` function only compares selected fields,
                    // the values of the unselected fields might be changed. That's
                    // simply because we didn't track them.
                    // To support the case in https://github.com/vercel/swr/pull/2576,
                    // we need to update these fields in the `memorizedSnapshot` too
                    // with direct mutations to ensure the snapshot is always up-to-date
                    // even for the unselected fields, but only trigger re-renders when
                    // the selected fields are changed.
                    memorizedSnapshot.data = newSnapshot.data;
                    memorizedSnapshot.isLoading = newSnapshot.isLoading;
                    memorizedSnapshot.isValidating = newSnapshot.isValidating;
                    memorizedSnapshot.error = newSnapshot.error;
                    return memorizedSnapshot;
                } else {
                    memorizedSnapshot = newSnapshot;
                    return newSnapshot;
                }
            },
            ()=>serverSnapshot
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cache,
        key
    ]);
    // Get the current state that SWR should return.
    const cached = (0, $ck4pA.useSyncExternalStore)((0, $8NFma.useCallback)((callback)=>subscribeCache(key, (current, prev)=>{
            if (!isEqual(prev, current)) callback();
        }), [
        cache,
        key
    ]), getSnapshot[0], getSnapshot[1]);
    const isInitialMount = !initialMountedRef.current;
    const hasRevalidator = EVENT_REVALIDATORS[key] && EVENT_REVALIDATORS[key].length > 0;
    const cachedData = cached.data;
    const data = (0, $eRk4j.isUndefined)(cachedData) ? fallback : cachedData;
    const error = cached.error;
    // Use a ref to store previously returned data. Use the initial data as its initial value.
    const laggyDataRef = (0, $8NFma.useRef)(data);
    const returnedData = keepPreviousData ? (0, $eRk4j.isUndefined)(cachedData) ? laggyDataRef.current : cachedData : data;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    const shouldDoInitialRevalidation = (()=>{
        // if a key already has revalidators and also has error, we should not trigger revalidation
        if (hasRevalidator && !(0, $eRk4j.isUndefined)(error)) return false;
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !(0, $eRk4j.isUndefined)(revalidateOnMount)) return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused()) return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately mount it again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense) return (0, $eRk4j.isUndefined)(data) ? false : revalidateIfStale;
        // If there is no stale data, we need to revalidate when mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return (0, $eRk4j.isUndefined)(data) || revalidateIfStale;
    })();
    // Resolve the default validating state:
    // If it's able to validate, and it should revalidate when mount, this will be true.
    const defaultValidatingState = !!(key && fetcher && isInitialMount && shouldDoInitialRevalidation);
    const isValidating = (0, $eRk4j.isUndefined)(cached.isValidating) ? defaultValidatingState : cached.isValidating;
    const isLoading = (0, $eRk4j.isUndefined)(cached.isLoading) ? defaultValidatingState : cached.isLoading;
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    const revalidate = (0, $8NFma.useCallback)(async (revalidateOpts)=>{
        const currentFetcher = fetcherRef.current;
        if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) return false;
        let newData;
        let startAt;
        let loading = true;
        const opts = revalidateOpts || {};
        // If there is no ongoing concurrent request, or `dedupe` is not set, a
        // new request should be initiated.
        const shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
        /*
         For React 17
         Do unmount check for calls:
         If key has changed during the revalidation, or the component has been
         unmounted, old dispatch and old event callbacks should not take any
         effect

        For React 18
        only check if key has changed
        https://github.com/reactwg/react-18/discussions/82
      */ const callbackSafeguard = ()=>{
            if (0, $eRk4j.IS_REACT_LEGACY) return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
            return key === keyRef.current;
        };
        // The final state object when the request finishes.
        const finalState = {
            isValidating: false,
            isLoading: false
        };
        const finishRequestAndUpdateState = ()=>{
            setCache(finalState);
        };
        const cleanupState = ()=>{
            // Check if it's still the same request before deleting it.
            const requestInfo = FETCH[key];
            if (requestInfo && requestInfo[1] === startAt) delete FETCH[key];
        };
        // Start fetching. Change the `isValidating` state, update the cache.
        const initialState = {
            isValidating: true
        };
        // It is in the `isLoading` state, if and only if there is no cached data.
        // This bypasses fallback data and laggy data.
        if ((0, $eRk4j.isUndefined)(getCache().data)) initialState.isLoading = true;
        try {
            if (shouldStartNewRequest) {
                setCache(initialState);
                // If no cache is being rendered currently (it shows a blank page),
                // we trigger the loading slow event.
                if (config.loadingTimeout && (0, $eRk4j.isUndefined)(getCache().data)) setTimeout(()=>{
                    if (loading && callbackSafeguard()) getConfig().onLoadingSlow(key, config);
                }, config.loadingTimeout);
                // Start the request and save the timestamp.
                // Key must be truthy if entering here.
                FETCH[key] = [
                    currentFetcher(fnArg),
                    (0, $eRk4j.getTimestamp)()
                ];
            }
            [newData, startAt] = FETCH[key];
            newData = await newData;
            if (shouldStartNewRequest) // If the request isn't interrupted, clean it up after the
            // deduplication interval.
            setTimeout(cleanupState, config.dedupingInterval);
            // If there're other ongoing request(s), started after the current one,
            // we need to ignore the current one to avoid possible race conditions:
            //   req1------------------>res1        (current one)
            //        req2---------------->res2
            // the request that fired later will always be kept.
            // The timestamp maybe be `undefined` or a number
            if (!FETCH[key] || FETCH[key][1] !== startAt) {
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Clear error.
            finalState.error = (0, $eRk4j.UNDEFINED);
            // If there're other mutations(s), that overlapped with the current revalidation:
            // case 1:
            //   req------------------>res
            //       mutate------>end
            // case 2:
            //         req------------>res
            //   mutate------>end
            // case 3:
            //   req------------------>res
            //       mutate-------...---------->
            // we have to ignore the revalidation result (res) because it's no longer fresh.
            // meanwhile, a new revalidation should be triggered when the mutation ends.
            const mutationInfo = MUTATION[key];
            if (!(0, $eRk4j.isUndefined)(mutationInfo) && // case 1
            (startAt <= mutationInfo[0] || // case 2
            startAt <= mutationInfo[1] || // case 3
            mutationInfo[1] === 0)) {
                finishRequestAndUpdateState();
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Deep compare with the latest state to avoid extra re-renders.
            // For local state, compare and assign.
            const cacheData = getCache().data;
            // Since the compare fn could be custom fn
            // cacheData might be different from newData even when compare fn returns True
            finalState.data = compare(cacheData, newData) ? cacheData : newData;
            // Trigger the successful callback if it's the original request.
            if (shouldStartNewRequest) {
                if (callbackSafeguard()) getConfig().onSuccess(newData, key, config);
            }
        } catch (err) {
            cleanupState();
            const currentConfig = getConfig();
            const { shouldRetryOnError: shouldRetryOnError } = currentConfig;
            // Not paused, we continue handling the error. Otherwise, discard it.
            if (!currentConfig.isPaused()) {
                // Get a new error, don't use deep comparison for errors.
                finalState.error = err;
                // Error event and retry logic. Only for the actual request, not
                // deduped ones.
                if (shouldStartNewRequest && callbackSafeguard()) {
                    currentConfig.onError(err, key, currentConfig);
                    if (shouldRetryOnError === true || (0, $eRk4j.isFunction)(shouldRetryOnError) && shouldRetryOnError(err)) {
                        if (!getConfig().revalidateOnFocus || !getConfig().revalidateOnReconnect || isActive()) // If it's inactive, stop. It will auto-revalidate when
                        // refocusing or reconnecting.
                        // When retrying, deduplication is always enabled.
                        currentConfig.onErrorRetry(err, key, currentConfig, (_opts)=>{
                            const revalidators = EVENT_REVALIDATORS[key];
                            if (revalidators && revalidators[0]) revalidators[0]((0, $eRk4j.revalidateEvents).ERROR_REVALIDATE_EVENT, _opts);
                        }, {
                            retryCount: (opts.retryCount || 0) + 1,
                            dedupe: true
                        });
                    }
                }
            }
        }
        // Mark loading as stopped.
        loading = false;
        // Update the current hook's state.
        finishRequestAndUpdateState();
        return true;
    }, // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key,
        cache
    ]);
    // Similar to the global mutate but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    const boundMutate = (0, $8NFma.useCallback)((...args)=>{
        return (0, $eRk4j.internalMutate)(cache, keyRef.current, ...args);
    }, []);
    // The logic for updating refs.
    (0, $eRk4j.useIsomorphicLayoutEffect)(()=>{
        fetcherRef.current = fetcher;
        configRef.current = config;
        // Handle laggy data updates. If there's cached data of the current key,
        // it'll be the correct reference.
        if (!(0, $eRk4j.isUndefined)(cachedData)) laggyDataRef.current = cachedData;
    });
    // After mounted or key changed.
    (0, $eRk4j.useIsomorphicLayoutEffect)(()=>{
        if (!key) return;
        const softRevalidate = revalidate.bind((0, $eRk4j.UNDEFINED), $ea9eaaaa982fb4fd$var$WITH_DEDUPE);
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        let nextFocusRevalidatedAt = 0;
        const onRevalidate = (type, opts = {})=>{
            if (type == (0, $eRk4j.revalidateEvents).FOCUS_EVENT) {
                const now = Date.now();
                if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            } else if (type == (0, $eRk4j.revalidateEvents).RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) softRevalidate();
            } else if (type == (0, $eRk4j.revalidateEvents).MUTATE_EVENT) return revalidate();
            else if (type == (0, $eRk4j.revalidateEvents).ERROR_REVALIDATE_EVENT) return revalidate(opts);
            return;
        };
        const unsubEvents = (0, $eRk4j.subscribeCallback)(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // Keep the original key in the cache.
        setCache({
            _k: fnArg
        });
        // Trigger a revalidation
        if (shouldDoInitialRevalidation) {
            if ((0, $eRk4j.isUndefined)(data) || (0, $eRk4j.IS_SERVER)) // Revalidate immediately.
            softRevalidate();
            else // Delay the revalidate if we have data to return so we won't block
            // rendering.
            (0, $eRk4j.rAF)(softRevalidate);
        }
        return ()=>{
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubEvents();
        };
    }, [
        key
    ]);
    // Polling
    (0, $eRk4j.useIsomorphicLayoutEffect)(()=>{
        let timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            const interval = (0, $eRk4j.isFunction)(refreshInterval) ? refreshInterval(getCache().data) : refreshInterval;
            // We only start the next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) timer = setTimeout(execute, interval);
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online, and not errored.
            if (!getCache().error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) revalidate($ea9eaaaa982fb4fd$var$WITH_DEDUPE).then(next);
            else // Schedule the next interval to check again.
            next();
        }
        next();
        return ()=>{
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [
        refreshInterval,
        refreshWhenHidden,
        refreshWhenOffline,
        key
    ]);
    // Display debug info in React DevTools.
    (0, $8NFma.useDebugValue)(returnedData);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is an `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense && (0, $eRk4j.isUndefined)(data) && key) {
        // SWR should throw when trying to use Suspense on the server with React 18,
        // without providing any initial data. See:
        // https://github.com/vercel/swr/issues/1832
        if (!(0, $eRk4j.IS_REACT_LEGACY) && (0, $eRk4j.IS_SERVER)) throw new Error("Fallback data is required when using suspense in SSR.");
        // Always update fetcher and config refs even with the Suspense mode.
        fetcherRef.current = fetcher;
        configRef.current = config;
        unmountedRef.current = false;
        const req = PRELOAD[key];
        if (!(0, $eRk4j.isUndefined)(req)) {
            const promise = boundMutate(req);
            $ea9eaaaa982fb4fd$var$use(promise);
        }
        if ((0, $eRk4j.isUndefined)(error)) {
            const promise = revalidate($ea9eaaaa982fb4fd$var$WITH_DEDUPE);
            if (!(0, $eRk4j.isUndefined)(returnedData)) {
                promise.status = "fulfilled";
                promise.value = true;
            }
            $ea9eaaaa982fb4fd$var$use(promise);
        } else throw error;
    }
    return {
        mutate: boundMutate,
        get data () {
            stateDependencies.data = true;
            return returnedData;
        },
        get error () {
            stateDependencies.error = true;
            return error;
        },
        get isValidating () {
            stateDependencies.isValidating = true;
            return isValidating;
        },
        get isLoading () {
            stateDependencies.isLoading = true;
            return isLoading;
        }
    };
};
(0, $eRk4j.OBJECT).defineProperty((0, $eRk4j.SWRConfig), "defaultValue", {
    value: (0, $eRk4j.defaultConfig)
});
/**
 * A hook to fetch data.
 *
 * @link https://swr.vercel.app
 * @example
 * ```jsx
 * import useSWR from 'swr'
 * function Profile() {
 *   const { data, error, isLoading } = useSWR('/api/user', fetcher)
 *   if (error) return <div>failed to load</div>
 *   if (isLoading) return <div>loading...</div>
 *   return <div>hello {data.name}!</div>
 * }
 * ```
 */ const $ea9eaaaa982fb4fd$var$useSWR = (0, $eRk4j.withArgs)($ea9eaaaa982fb4fd$var$useSWRHandler);
const $ea9eaaaa982fb4fd$var$getFirstPageKey = (getKey)=>{
    return (0, $eRk4j.serialize)(getKey ? getKey(0, null) : null)[0];
};
const $ea9eaaaa982fb4fd$export$dbab534a48e651ef = (getKey)=>{
    return (0, $eRk4j.INFINITE_PREFIX) + $ea9eaaaa982fb4fd$var$getFirstPageKey(getKey);
};
// We have to several type castings here because `useSWRInfinite` is a special
// hook where `key` and return type are not like the normal `useSWR` types.
// const INFINITE_PREFIX = '$inf$'
const $ea9eaaaa982fb4fd$var$EMPTY_PROMISE = Promise.resolve();
// export const unstable_serialize = (getKey: SWRInfiniteKeyLoader) => {
//   return INFINITE_PREFIX + getFirstPageKey(getKey)
// }
const $ea9eaaaa982fb4fd$export$f27219e7b43e81d = (useSWRNext)=>(getKey, fn, config)=>{
        const didMountRef = (0, $8NFma.useRef)(false);
        const { cache: cache$1, initialSize: initialSize = 1, revalidateAll: revalidateAll = false, persistSize: persistSize = false, revalidateFirstPage: revalidateFirstPage = true, revalidateOnMount: revalidateOnMount = false, parallel: parallel = false } = config;
        const [, , , PRELOAD] = (0, $eRk4j.SWRGlobalState).get((0, $eRk4j.cache));
        // The serialized key of the first page. This key will be used to store
        // metadata of this SWR infinite hook.
        let infiniteKey;
        try {
            infiniteKey = $ea9eaaaa982fb4fd$var$getFirstPageKey(getKey);
            if (infiniteKey) infiniteKey = (0, $eRk4j.INFINITE_PREFIX) + infiniteKey;
        } catch (err) {
        // Not ready yet.
        }
        const [get, set, subscribeCache] = (0, $eRk4j.createCacheHelper)(cache$1, infiniteKey);
        const getSnapshot = (0, $8NFma.useCallback)(()=>{
            const size = (0, $eRk4j.isUndefined)(get()._l) ? initialSize : get()._l;
            return size;
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            cache$1,
            infiniteKey,
            initialSize
        ]);
        (0, $ck4pA.useSyncExternalStore)((0, $8NFma.useCallback)((callback)=>{
            if (infiniteKey) return subscribeCache(infiniteKey, ()=>{
                callback();
            });
            return ()=>{};
        }, [
            cache$1,
            infiniteKey
        ]), getSnapshot, getSnapshot);
        const resolvePageSize = (0, $8NFma.useCallback)(()=>{
            const cachedPageSize = get()._l;
            return (0, $eRk4j.isUndefined)(cachedPageSize) ? initialSize : cachedPageSize;
        // `cache` isn't allowed to change during the lifecycle
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            infiniteKey,
            initialSize
        ]);
        // keep the last page size to restore it with the persistSize option
        const lastPageSizeRef = (0, $8NFma.useRef)(resolvePageSize());
        // When the page key changes, we reset the page size if it's not persisted
        (0, $eRk4j.useIsomorphicLayoutEffect)(()=>{
            if (!didMountRef.current) {
                didMountRef.current = true;
                return;
            }
            if (infiniteKey) // If the key has been changed, we keep the current page size if persistSize is enabled
            // Otherwise, we reset the page size to cached pageSize
            set({
                _l: persistSize ? lastPageSizeRef.current : resolvePageSize()
            });
        // `initialSize` isn't allowed to change during the lifecycle
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            infiniteKey,
            cache$1
        ]);
        // Needs to check didMountRef during mounting, not in the fetcher
        const shouldRevalidateOnMount = revalidateOnMount && !didMountRef.current;
        // Actual SWR hook to load all pages in one fetcher.
        const swr = useSWRNext(infiniteKey, async (key)=>{
            // get the revalidate context
            const forceRevalidateAll = get()._i;
            const shouldRevalidatePage = get()._r;
            set({
                _r: (0, $eRk4j.UNDEFINED)
            });
            // return an array of page data
            const data = [];
            const pageSize = resolvePageSize();
            const [getCache] = (0, $eRk4j.createCacheHelper)(cache$1, key);
            const cacheData = getCache().data;
            const revalidators = [];
            let previousPageData = null;
            for(let i = 0; i < pageSize; ++i){
                const [pageKey, pageArg] = (0, $eRk4j.serialize)(getKey(i, parallel ? null : previousPageData));
                if (!pageKey) break;
                const [getSWRCache, setSWRCache] = (0, $eRk4j.createCacheHelper)(cache$1, pageKey);
                // Get the cached page data.
                let pageData = getSWRCache().data;
                // should fetch (or revalidate) if:
                // - `revalidateAll` is enabled
                // - `mutate()` called
                // - the cache is missing
                // - it's the first page and it's not the initial render
                // - `revalidateOnMount` is enabled and it's on mount
                // - cache for that page has changed
                const shouldFetchPage = revalidateAll || forceRevalidateAll || (0, $eRk4j.isUndefined)(pageData) || revalidateFirstPage && !i && !(0, $eRk4j.isUndefined)(cacheData) || shouldRevalidateOnMount || cacheData && !(0, $eRk4j.isUndefined)(cacheData[i]) && !config.compare(cacheData[i], pageData);
                if (fn && (typeof shouldRevalidatePage === "function" ? shouldRevalidatePage(pageData, pageArg) : shouldFetchPage)) {
                    const revalidate = async ()=>{
                        const hasPreloadedRequest = pageKey in PRELOAD;
                        if (!hasPreloadedRequest) pageData = await fn(pageArg);
                        else {
                            const req = PRELOAD[pageKey];
                            // delete the preload cache key before resolving it
                            // in case there's an error
                            delete PRELOAD[pageKey];
                            // get the page data from the preload cache
                            pageData = await req;
                        }
                        setSWRCache({
                            data: pageData,
                            _k: pageArg
                        });
                        data[i] = pageData;
                    };
                    if (parallel) revalidators.push(revalidate);
                    else await revalidate();
                } else data[i] = pageData;
                if (!parallel) previousPageData = pageData;
            }
            // flush all revalidateions in parallel
            if (parallel) await Promise.all(revalidators.map((r)=>r()));
            // once we executed the data fetching based on the context, clear the context
            set({
                _i: (0, $eRk4j.UNDEFINED)
            });
            // return the data
            return data;
        }, config);
        const mutate = (0, $8NFma.useCallback)(function(data, opts) {
            // When passing as a boolean, it's explicitly used to disable/enable
            // revalidation.
            const options = typeof opts === "boolean" ? {
                revalidate: opts
            } : opts || {};
            // Default to true.
            const shouldRevalidate = options.revalidate !== false;
            // It is possible that the key is still falsy.
            if (!infiniteKey) return $ea9eaaaa982fb4fd$var$EMPTY_PROMISE;
            if (shouldRevalidate) {
                if (!(0, $eRk4j.isUndefined)(data)) // We only revalidate the pages that are changed
                set({
                    _i: false,
                    _r: options.revalidate
                });
                else // Calling `mutate()`, we revalidate all pages
                set({
                    _i: true,
                    _r: options.revalidate
                });
            }
            return arguments.length ? swr.mutate(data, {
                ...options,
                revalidate: shouldRevalidate
            }) : swr.mutate();
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            infiniteKey,
            cache$1
        ]);
        // Extend the SWR API
        const setSize = (0, $8NFma.useCallback)((arg)=>{
            // It is possible that the key is still falsy.
            if (!infiniteKey) return $ea9eaaaa982fb4fd$var$EMPTY_PROMISE;
            const [, changeSize] = (0, $eRk4j.createCacheHelper)(cache$1, infiniteKey);
            let size;
            if ((0, $eRk4j.isFunction)(arg)) size = arg(resolvePageSize());
            else if (typeof arg == "number") size = arg;
            if (typeof size != "number") return $ea9eaaaa982fb4fd$var$EMPTY_PROMISE;
            changeSize({
                _l: size
            });
            lastPageSizeRef.current = size;
            // Calculate the page data after the size change.
            const data = [];
            const [getInfiniteCache] = (0, $eRk4j.createCacheHelper)(cache$1, infiniteKey);
            let previousPageData = null;
            for(let i = 0; i < size; ++i){
                const [pageKey] = (0, $eRk4j.serialize)(getKey(i, previousPageData));
                const [getCache] = (0, $eRk4j.createCacheHelper)(cache$1, pageKey);
                // Get the cached page data.
                const pageData = pageKey ? getCache().data : (0, $eRk4j.UNDEFINED);
                // Call `mutate` with infinte cache data if we can't get it from the page cache.
                if ((0, $eRk4j.isUndefined)(pageData)) return mutate(getInfiniteCache().data);
                data.push(pageData);
                previousPageData = pageData;
            }
            return mutate(data);
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            infiniteKey,
            cache$1,
            mutate,
            resolvePageSize
        ]);
        // Use getter functions to avoid unnecessary re-renders caused by triggering
        // all the getters of the returned swr object.
        return {
            size: resolvePageSize(),
            setSize: setSize,
            mutate: mutate,
            get data () {
                return swr.data;
            },
            get error () {
                return swr.error;
            },
            get isValidating () {
                return swr.isValidating;
            },
            get isLoading () {
                return swr.isLoading;
            }
        };
    };
const $ea9eaaaa982fb4fd$export$2e2bcd8739ae039 = (0, $eRk4j.withMiddleware)($ea9eaaaa982fb4fd$var$useSWR, $ea9eaaaa982fb4fd$export$f27219e7b43e81d);

});


parcelRegister("gaqum", function(module, exports) {
"use strict";
var $bc5220a337f82360$var$__rest = module.exports && module.exports.__rest || function(e, t) {
    var r = {};
    for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (r[o] = e[o]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var a = 0;
        for(o = Object.getOwnPropertySymbols(e); a < o.length; a++)t.indexOf(o[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[a]) && (r[o[a]] = e[o[a]]);
    }
    return r;
}, $bc5220a337f82360$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.ColorPicker = module.exports.setColorsPresetFunc = module.exports.getUsedColors = module.exports.DEFAULT_COLORS = void 0;

const $bc5220a337f82360$var$react_1 = $bc5220a337f82360$var$__importDefault((parcelRequire("8NFma")));

var $ixLVk = parcelRequire("ixLVk");
var $88Rzx = parcelRequire("88Rzx");
var $9NqsV = parcelRequire("9NqsV");
var $aQvf8 = parcelRequire("aQvf8");

var $ixLVk = parcelRequire("ixLVk");
var $88Rzx = parcelRequire("88Rzx");
var $9NqsV = parcelRequire("9NqsV");
var $aQvf8 = parcelRequire("aQvf8");
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

var $xARwM = parcelRequire("xARwM");

const $bc5220a337f82360$var$sketch_1 = $bc5220a337f82360$var$__importDefault((parcelRequire("5QsJ2")));

const $bc5220a337f82360$var$styled_1 = $bc5220a337f82360$var$__importDefault((parcelRequire("MPenY")));

var $1Jif0 = parcelRequire("1Jif0");

var $eRGXT = parcelRequire("eRGXT");
module.exports.DEFAULT_COLORS = [
    "#D0021B",
    "#F5A623",
    "#F8E71C",
    "#8B572A",
    "#7ED321",
    "#417505",
    "#BD10E0",
    "#9013FE",
    "#4A90E2",
    "#50E3C2",
    "#B8E986",
    "#000000",
    "#4A4A4A",
    "#9B9B9B",
    "#FFFFFF"
].reverse();
const $bc5220a337f82360$var$getUsedColors = (e)=>{
    const t = [];
    e.pages.forEach((e)=>{
        e.children.forEach((e)=>{
            e.shadowEnabled && t.push(e.shadowColor), "text" === e.type && (t.push(e.fill), e.backgroundEnabled && t.push(e.backgroundColor), e.strokeWidth && t.push(e.stroke)), "svg" === e.type && t.push(...e.colorsReplace.values()), "figure" === e.type && (t.push(e.fill), e.strokeWidth && t.push(e.stroke)), "line" === e.type && t.push(e.color);
        });
    });
    const r = [];
    return t.forEach((e)=>{
        if ((0, $1Jif0.isGradient)(e)) {
            const { stops: t } = (0, $1Jif0.parseColor)(e);
            r.push(...t.map((e)=>e.color));
        } else r.push(e);
    }), [
        ...new Set(r)
    ];
};
module.exports.getUsedColors = $bc5220a337f82360$var$getUsedColors;
const $bc5220a337f82360$var$SolidContainer = (0, $bc5220a337f82360$var$styled_1.default)("div")`
  & .sketch-picker {
    padding: 0px !important;
    box-shadow: none !important;
    background: none !important;
  }

  & .flexbox-fix {
    border-top: none !important;
  }

  .bp5-dark & .sketch-picker {
    background-color: #394b59;
  }

  .bp5-dark & .sketch-picker label {
    color: #f5f8fa !important;
  }
`, $bc5220a337f82360$var$SolidInput = (e)=>{
    var { style: t, color: r, onChange: o } = e, a = $bc5220a337f82360$var$__rest(e, [
        "style",
        "color",
        "onChange"
    ]);
    const [n, l] = $bc5220a337f82360$var$react_1.default.useState(r);
    $bc5220a337f82360$var$react_1.default.useEffect(()=>{
        l(r);
    }, [
        r
    ]);
    const s = $bc5220a337f82360$var$react_1.default.useRef(), i = $bc5220a337f82360$var$react_1.default.useRef();
    return $bc5220a337f82360$var$react_1.default.createElement($bc5220a337f82360$var$SolidContainer, {
        style: t,
        onMouseDown: (e)=>{
            "INPUT" !== e.target.tagName && e.preventDefault();
        }
    }, $bc5220a337f82360$var$react_1.default.createElement($bc5220a337f82360$var$sketch_1.default, Object.assign({
        color: n
    }, a, {
        onChange: (e)=>{
            const { r: t, g: r, b: a, a: n } = e.rgb, c = `rgba(${t},${r},${a},${n})`;
            l(c), i.current = c, s.current || (s.current = window.setTimeout(()=>{
                s.current = 0, o(c);
            }, 50));
        }
    })));
}, $bc5220a337f82360$var$serializeStops = (e)=>e.map((e)=>`${e.color} ${100 * e.offset}%`).join(","), $bc5220a337f82360$var$LinearGradient = ({ value: e, onChange: t, store: r, preset: o })=>{
    const { rotation: a, stops: n } = (0, $1Jif0.parseColor)(e), l = $bc5220a337f82360$var$react_1.default.useRef(n);
    l.current = n;
    const s = $bc5220a337f82360$var$react_1.default.useRef(a);
    s.current = a;
    const [i, c] = $bc5220a337f82360$var$react_1.default.useState(0), d = $bc5220a337f82360$var$react_1.default.useRef(null), u = $bc5220a337f82360$var$react_1.default.useRef(!1), p = ()=>{
        u.current = !0;
    };
    return $bc5220a337f82360$var$react_1.default.useEffect(()=>{
        const e = (e)=>{
            if (u.current) {
                const r = d.current.getBoundingClientRect(), o = e.clientX - r.left, a = o / r.width, p = a < -0.5 || a > 1.5;
                if (n.length > 2 && p) return c(0), u.current = !1, l.current.splice(i, 1), void t(`linear-gradient(${s.current}deg, ${$bc5220a337f82360$var$serializeStops(l.current)})`);
                const f = Math.min(1, Math.max(0, o / r.width)), g = [
                    ...l.current
                ];
                g[i].offset = f, t(`linear-gradient(${s.current}deg, ${$bc5220a337f82360$var$serializeStops(g)})`);
            }
        }, r = ()=>{
            u.current = !1;
        };
        return window.addEventListener("mousemove", e), window.addEventListener("mouseup", r), ()=>{
            window.removeEventListener("mousemove", e), window.removeEventListener("mouseup", r);
        };
    }, [
        i,
        l
    ]), $bc5220a337f82360$var$react_1.default.createElement("div", null, $bc5220a337f82360$var$react_1.default.createElement("div", {
        style: {
            width: "calc(100% - 35px)",
            height: "60px",
            position: "relative"
        }
    }, $bc5220a337f82360$var$react_1.default.createElement("div", {
        ref: d,
        style: {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            marginLeft: "15px",
            height: "100%",
            zIndex: 0
        },
        onMouseDown: (e)=>{
            const r = e.currentTarget.getBoundingClientRect(), o = e.clientX - r.left, l = Math.min(1, Math.max(0, o / r.width)), s = n[0].color;
            n.push({
                color: s,
                offset: l
            }), n.sort((e, t)=>e.offset - t.offset);
            const i = n.findIndex((e)=>e.offset === l);
            c(i), p(), t(`linear-gradient(${a}deg, ${$bc5220a337f82360$var$serializeStops(n)})`);
        }
    }), n.map(({ offset: e, color: t }, r)=>$bc5220a337f82360$var$react_1.default.createElement("div", {
            key: r,
            style: {
                position: "absolute",
                top: "10px",
                left: 100 * e + "%",
                border: r === i ? "2px solid rgb(0, 161, 255)" : "2px solid rgb(0, 0, 0, 0)",
                padding: "2px"
            },
            onMouseDown: (e)=>{
                e.stopPropagation(), c(r), p();
            }
        }, $bc5220a337f82360$var$react_1.default.createElement($bc5220a337f82360$var$ColoredBox, {
            background: t,
            style: {
                margin: 0
            }
        })))), $bc5220a337f82360$var$react_1.default.createElement("div", {
        style: {
            width: "calc(100% - 30px)",
            height: "10px",
            marginLeft: "15px",
            background: `linear-gradient(90deg,${$bc5220a337f82360$var$serializeStops(n)})`
        }
    }), $bc5220a337f82360$var$react_1.default.createElement("div", {
        style: {
            padding: "10px"
        }
    }, $bc5220a337f82360$var$react_1.default.createElement($88Rzx.Slider, {
        min: 0,
        max: 360,
        value: a,
        showTrackFill: !1,
        labelRenderer: !1,
        onChange: (e)=>{
            t(`linear-gradient(${e}deg,${$bc5220a337f82360$var$serializeStops(n)})`);
        }
    })), $bc5220a337f82360$var$react_1.default.createElement($bc5220a337f82360$var$SolidInput, {
        color: n[i].color,
        presetColors: o,
        onChange: (e)=>{
            const r = [
                ...n
            ];
            r[i].color = e, t(`linear-gradient(${a}deg, ${$bc5220a337f82360$var$serializeStops(r)})`);
        }
    }));
}, $bc5220a337f82360$var$VariantColorInput = (0, $O1ETn.observer)(({ value: e, onChange: t, preset: r, store: o })=>{
    const [a, n] = $bc5220a337f82360$var$react_1.default.useState((0, $1Jif0.isGradient)(e) ? "gradient" : "solid");
    return $bc5220a337f82360$var$react_1.default.createElement("div", {
        style: {
            padding: "5px"
        }
    }, $bc5220a337f82360$var$react_1.default.createElement($aQvf8.Tabs, {
        id: "TabsExample",
        selectedTabId: a,
        onChange: (e)=>n(e)
    }, $bc5220a337f82360$var$react_1.default.createElement($9NqsV.Tab, {
        id: "solid",
        title: (0, $xARwM.t)("toolbar.colorPicker.solid"),
        panel: $bc5220a337f82360$var$react_1.default.createElement($bc5220a337f82360$var$SolidInput, {
            color: e,
            onChange: t,
            presetColors: r,
            style: {
                padding: "0"
            }
        })
    }), $bc5220a337f82360$var$react_1.default.createElement($9NqsV.Tab, {
        id: "gradient",
        title: (0, $xARwM.t)("toolbar.colorPicker.linear"),
        panel: $bc5220a337f82360$var$react_1.default.createElement($bc5220a337f82360$var$LinearGradient, {
            value: e,
            onChange: t,
            store: o,
            preset: r
        }),
        panelClassName: "ember-panel"
    })));
}), $bc5220a337f82360$var$ColoredBox = (e)=>{
    var { size: t = 30, background: r, style: o = {}, children: a = null } = e, n = $bc5220a337f82360$var$__rest(e, [
        "size",
        "background",
        "style",
        "children"
    ]);
    return $bc5220a337f82360$var$react_1.default.createElement("div", Object.assign({
        onMouseDown: (e)=>e.preventDefault(),
        style: Object.assign({
            width: t + "px",
            height: t + "px",
            background: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='15' height='15' viewBox='0 0 8 8'%3E%3Cg fill='rgba(112, 112, 116, 1)' fill-opacity='1'%3E%3Cpath fill-rule='evenodd' d='M0 0h4v4H0V0zm4 4h4v4H4V4z'/%3E%3C/g%3E%3C/svg%3E\")",
            borderRadius: "2px",
            boxShadow: "0 0 2px grey",
            marginBottom: "-4px"
        }, o)
    }, n), $bc5220a337f82360$var$react_1.default.createElement("div", {
        style: {
            width: t + "px",
            height: t + "px",
            background: r
        }
    }, a));
};
let $bc5220a337f82360$var$getColorsPreset = (e)=>{
    const t = (0, module.exports.getUsedColors)(e).slice(0, 8).filter((e)=>!module.exports.DEFAULT_COLORS.find((t)=>(0, $eRGXT.sameColors)(t, e)));
    return t.concat(module.exports.DEFAULT_COLORS.slice(0, 16 - t.length).reverse());
};
function $bc5220a337f82360$var$setColorsPresetFunc(e) {
    $bc5220a337f82360$var$getColorsPreset = e;
}
module.exports.setColorsPresetFunc = $bc5220a337f82360$var$setColorsPresetFunc;
const $bc5220a337f82360$var$ColorPicker = ({ value: e, onChange: t, size: r, store: o, gradientEnabled: a, children: n, style: l })=>{
    const s = $bc5220a337f82360$var$getColorsPreset(o);
    return $bc5220a337f82360$var$react_1.default.createElement($ixLVk.Popover, {
        autoFocus: !1,
        enforceFocus: !0,
        interactionKind: "click",
        hasBackdrop: !0,
        content: a ? $bc5220a337f82360$var$react_1.default.createElement($bc5220a337f82360$var$VariantColorInput, {
            preset: s,
            value: e,
            onChange: t,
            store: o
        }) : $bc5220a337f82360$var$react_1.default.createElement("div", {
            style: {
                padding: "5px"
            }
        }, $bc5220a337f82360$var$react_1.default.createElement($bc5220a337f82360$var$SolidInput, {
            color: e,
            onChange: t,
            presetColors: s
        }))
    }, $bc5220a337f82360$var$react_1.default.createElement($bc5220a337f82360$var$ColoredBox, {
        size: r,
        background: e,
        style: l
    }, n));
};
module.exports.ColorPicker = $bc5220a337f82360$var$ColorPicker, module.exports.default = module.exports.ColorPicker;

});
parcelRegister("9NqsV", function(module, exports) {

$parcel$export(module.exports, "Tab", () => $721d382e99e6ac20$export$3e41faf802a29e71);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $4Jy2D = parcelRequire("4Jy2D");
var $auzpd = parcelRequire("auzpd");

var $hffzE = parcelRequire("hffzE");

var $3u1r0 = parcelRequire("3u1r0");
/**
 * Tab component.
 *
 * @see https://blueprintjs.com/docs/#core/components/tabs.tab
 */ var $721d382e99e6ac20$export$3e41faf802a29e71 = /** @class */ function(_super) {
    (0, $gztBd.__extends)(Tab, _super);
    function Tab() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // this component is never rendered directly; see Tabs#renderTabPanel()
    /* istanbul ignore next */ Tab.prototype.render = function() {
        var _a = this.props, className = _a.className, panel = _a.panel;
        return $8NFma.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $auzpd).TAB_PANEL, className),
            role: "tablist"
        }, (0, $3u1r0.isFunction)(panel) ? panel({
            tabTitleId: "",
            tabPanelId: ""
        }) : panel);
    };
    Tab.defaultProps = {
        disabled: false
    };
    Tab.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".Tab");
    return Tab;
}((0, $4Jy2D.AbstractPureComponent));

});

parcelRegister("aQvf8", function(module, exports) {

$parcel$export(module.exports, "Tabs", () => $7e56fef32dd9f31c$export$b2539bed5023c21c);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $4Jy2D = parcelRequire("4Jy2D");
var $auzpd = parcelRequire("auzpd");
var $hffzE = parcelRequire("hffzE");
var $iP8Ix = parcelRequire("iP8Ix");

var $9NqsV = parcelRequire("9NqsV");

var $253FW = parcelRequire("253FW");
var $7e56fef32dd9f31c$export$cd4364b9964725cb = function() {
    return $8NFma.createElement("div", {
        className: (0, $auzpd).FLEX_EXPANDER
    });
};
var $7e56fef32dd9f31c$export$1cfea591e85f6e12 = $7e56fef32dd9f31c$export$cd4364b9964725cb;
var $7e56fef32dd9f31c$var$TAB_SELECTOR = ".".concat((0, $auzpd).TAB);
/**
 * Tabs component.
 *
 * @see https://blueprintjs.com/docs/#core/components/tabs
 */ var $7e56fef32dd9f31c$export$b2539bed5023c21c = /** @class */ function(_super) {
    (0, $gztBd.__extends)(Tabs, _super);
    function Tabs(props) {
        var _this = _super.call(this, props) || this;
        _this.tablistElement = null;
        _this.refHandlers = {
            tablist: function(tabElement) {
                return _this.tablistElement = tabElement;
            }
        };
        _this.handleKeyDown = function(e) {
            var _a;
            var focusedElement = (_a = (0, $iP8Ix).getActiveElement(_this.tablistElement)) === null || _a === void 0 ? void 0 : _a.closest($7e56fef32dd9f31c$var$TAB_SELECTOR);
            // rest of this is potentially expensive and futile, so bail if no tab is focused
            if (focusedElement == null) return;
            // must rely on DOM state because we have no way of mapping `focusedElement` to a React.JSX.Element
            var enabledTabElements = _this.getTabElements().filter(function(el) {
                return el.getAttribute("aria-disabled") === "false";
            });
            var focusedIndex = enabledTabElements.indexOf(focusedElement);
            var direction = _this.getKeyCodeDirection(e);
            if (focusedIndex >= 0 && direction !== undefined) {
                e.preventDefault();
                var length_1 = enabledTabElements.length;
                // auto-wrapping at 0 and `length`
                var nextFocusedIndex = (focusedIndex + direction + length_1) % length_1;
                enabledTabElements[nextFocusedIndex].focus();
            }
        };
        _this.handleKeyPress = function(e) {
            var targetTabElement = e.target.closest($7e56fef32dd9f31c$var$TAB_SELECTOR);
            if (targetTabElement != null && (0, $iP8Ix).isKeyboardClick(e)) {
                e.preventDefault();
                targetTabElement.click();
            }
        };
        _this.handleTabClick = function(newTabId, event) {
            var _a, _b;
            (_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, newTabId, _this.state.selectedTabId, event);
            if (_this.props.selectedTabId === undefined) _this.setState({
                selectedTabId: newTabId
            });
        };
        _this.renderTabPanel = function(tab) {
            var _a = tab.props, className = _a.className, panel = _a.panel, id = _a.id, panelClassName = _a.panelClassName;
            if (panel === undefined) return undefined;
            var tabTitleId = (0, $253FW.generateTabTitleId)(_this.props.id, id);
            var tabPanelId = (0, $253FW.generateTabPanelId)(_this.props.id, id);
            return $8NFma.createElement("div", {
                "aria-labelledby": tabTitleId,
                "aria-hidden": id !== _this.state.selectedTabId,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $auzpd).TAB_PANEL, className, panelClassName),
                id: tabPanelId,
                key: id,
                role: "tabpanel"
            }, (0, $iP8Ix).isFunction(panel) ? panel({
                tabTitleId: tabTitleId,
                tabPanelId: tabPanelId
            }) : panel);
        };
        _this.renderTabTitle = function(child) {
            if ($7e56fef32dd9f31c$var$isTabElement(child)) {
                var id = child.props.id;
                return $8NFma.createElement((0, $253FW.TabTitle), (0, $gztBd.__assign)({}, child.props, {
                    parentId: _this.props.id,
                    onClick: _this.handleTabClick,
                    selected: id === _this.state.selectedTabId
                }));
            }
            return child;
        };
        var selectedTabId = _this.getInitialSelectedTabId();
        _this.state = {
            selectedTabId: selectedTabId
        };
        return _this;
    }
    Tabs.getDerivedStateFromProps = function(_a) {
        var selectedTabId = _a.selectedTabId;
        if (selectedTabId !== undefined) // keep state in sync with controlled prop, so state is canonical source of truth
        return {
            selectedTabId: selectedTabId
        };
        return null;
    };
    Tabs.prototype.render = function() {
        var _a, _b;
        var _c = this.state, indicatorWrapperStyle = _c.indicatorWrapperStyle, selectedTabId = _c.selectedTabId;
        var tabTitles = $8NFma.Children.map(this.props.children, this.renderTabTitle);
        var tabPanels = this.getTabChildren().filter(this.props.renderActiveTabPanelOnly ? function(tab) {
            return tab.props.id === selectedTabId;
        } : function() {
            return true;
        }).map(this.renderTabPanel);
        var tabIndicator = this.props.animate ? $8NFma.createElement("div", {
            className: (0, $auzpd).TAB_INDICATOR_WRAPPER,
            style: indicatorWrapperStyle
        }, $8NFma.createElement("div", {
            className: (0, $auzpd).TAB_INDICATOR
        })) : null;
        var classes = (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $auzpd).TABS, this.props.className, (_a = {}, _a[(0, $auzpd).VERTICAL] = this.props.vertical, _a[(0, $auzpd).FILL] = this.props.fill, _a));
        var tabListClasses = (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $auzpd).TAB_LIST, (_b = {}, _b[(0, $auzpd).LARGE] = this.props.large, _b));
        return $8NFma.createElement("div", {
            className: classes
        }, $8NFma.createElement("div", {
            className: tabListClasses,
            onKeyDown: this.handleKeyDown,
            onKeyPress: this.handleKeyPress,
            ref: this.refHandlers.tablist,
            role: "tablist"
        }, tabIndicator, tabTitles), tabPanels);
    };
    Tabs.prototype.componentDidMount = function() {
        this.moveSelectionIndicator(false);
    };
    Tabs.prototype.componentDidUpdate = function(prevProps, prevState) {
        if (this.state.selectedTabId !== prevState.selectedTabId) this.moveSelectionIndicator();
        else if (prevState.selectedTabId != null) {
            // comparing React nodes is difficult to do with simple logic, so
            // shallowly compare just their props as a workaround.
            var didChildrenChange = !(0, $iP8Ix).arraysEqual(this.getTabChildrenProps(prevProps), this.getTabChildrenProps(), (0, $iP8Ix).shallowCompareKeys);
            if (didChildrenChange) this.moveSelectionIndicator();
        }
    };
    Tabs.prototype.getInitialSelectedTabId = function() {
        // NOTE: providing an unknown ID will hide the selection
        var _a = this.props, defaultSelectedTabId = _a.defaultSelectedTabId, selectedTabId = _a.selectedTabId;
        if (selectedTabId !== undefined) return selectedTabId;
        else if (defaultSelectedTabId !== undefined) return defaultSelectedTabId;
        else {
            // select first tab in absence of user input
            var tabs = this.getTabChildren();
            return tabs.length === 0 ? undefined : tabs[0].props.id;
        }
    };
    Tabs.prototype.getKeyCodeDirection = function(e) {
        if (e.key === "ArrowLeft" || e.key === "ArrowUp") return -1;
        else if (e.key === "ArrowRight" || e.key === "ArrowDown") return 1;
        return undefined;
    };
    Tabs.prototype.getTabChildrenProps = function(props) {
        if (props === void 0) props = this.props;
        return this.getTabChildren(props).map(function(child) {
            return child.props;
        });
    };
    /** Filters children to only `<Tab>`s */ Tabs.prototype.getTabChildren = function(props) {
        if (props === void 0) props = this.props;
        return $8NFma.Children.toArray(props.children).filter($7e56fef32dd9f31c$var$isTabElement);
    };
    /** Queries root HTML element for all tabs with optional filter selector */ Tabs.prototype.getTabElements = function(subselector) {
        if (subselector === void 0) subselector = "";
        if (this.tablistElement == null) return [];
        return Array.from(this.tablistElement.querySelectorAll($7e56fef32dd9f31c$var$TAB_SELECTOR + subselector));
    };
    /**
     * Calculate the new height, width, and position of the tab indicator.
     * Store the CSS values so the transition animation can start.
     */ Tabs.prototype.moveSelectionIndicator = function(animate) {
        if (animate === void 0) animate = true;
        if (this.tablistElement == null || !this.props.animate) return;
        var tabIdSelector = "".concat($7e56fef32dd9f31c$var$TAB_SELECTOR, '[data-tab-id="').concat(this.state.selectedTabId, '"]');
        var selectedTabElement = this.tablistElement.querySelector(tabIdSelector);
        var indicatorWrapperStyle = {
            display: "none"
        };
        if (selectedTabElement != null) {
            var clientHeight = selectedTabElement.clientHeight, clientWidth = selectedTabElement.clientWidth, offsetLeft = selectedTabElement.offsetLeft, offsetTop = selectedTabElement.offsetTop;
            indicatorWrapperStyle = {
                height: clientHeight,
                transform: "translateX(".concat(Math.floor(offsetLeft), "px) translateY(").concat(Math.floor(offsetTop), "px)"),
                width: clientWidth
            };
            if (!animate) indicatorWrapperStyle.transition = "none";
        }
        this.setState({
            indicatorWrapperStyle: indicatorWrapperStyle
        });
    };
    /**
     * Insert a `TabsExpander` between any two children to right-align all subsequent children.
     *
     * @deprecated use `TabsExpander`
     */ Tabs.Expander = $7e56fef32dd9f31c$export$cd4364b9964725cb;
    Tabs.Tab = (0, $9NqsV.Tab);
    Tabs.defaultProps = {
        animate: true,
        fill: false,
        large: false,
        renderActiveTabPanelOnly: false,
        vertical: false
    };
    Tabs.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".Tabs");
    return Tabs;
}((0, $4Jy2D.AbstractPureComponent));
function $7e56fef32dd9f31c$var$isTabElement(child) {
    return (0, $iP8Ix).isElementOfType(child, (0, $9NqsV.Tab));
}

});
parcelRegister("253FW", function(module, exports) {

$parcel$export(module.exports, "TabTitle", () => $183ee64940189400$export$f5f4479861343295);
$parcel$export(module.exports, "generateTabPanelId", () => $183ee64940189400$export$75e59e2d215e305f);
$parcel$export(module.exports, "generateTabTitleId", () => $183ee64940189400$export$d8fe6a92b026838d);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $4Jy2D = parcelRequire("4Jy2D");
var $auzpd = parcelRequire("auzpd");
var $1xlC6 = parcelRequire("1xlC6");

var $hffzE = parcelRequire("hffzE");

var $gKgL3 = parcelRequire("gKgL3");

var $9qDPC = parcelRequire("9qDPC");
var $183ee64940189400$export$f5f4479861343295 = /** @class */ function(_super) {
    (0, $gztBd.__extends)(TabTitle, _super);
    function TabTitle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function(e) {
            return _this.props.onClick(_this.props.id, e);
        };
        return _this;
    }
    TabTitle.prototype.render = function() {
        var _a = this.props, className = _a.className, children = _a.children, disabled = _a.disabled, id = _a.id, parentId = _a.parentId, selected = _a.selected, title = _a.title, icon = _a.icon, tagContent = _a.tagContent, tagProps = _a.tagProps, htmlProps = (0, $gztBd.__rest)(_a, [
            "className",
            "children",
            "disabled",
            "id",
            "parentId",
            "selected",
            "title",
            "icon",
            "tagContent",
            "tagProps"
        ]);
        var intent = selected ? (0, $1xlC6.Intent).PRIMARY : (0, $1xlC6.Intent).NONE;
        return $8NFma.createElement("div", (0, $gztBd.__assign)({}, (0, $hffzE.removeNonHTMLProps)(htmlProps), {
            "aria-controls": $183ee64940189400$export$75e59e2d215e305f(parentId, id),
            "aria-disabled": disabled,
            "aria-expanded": selected,
            "aria-selected": selected,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $auzpd).TAB, className),
            "data-tab-id": id,
            id: $183ee64940189400$export$d8fe6a92b026838d(parentId, id),
            onClick: disabled ? undefined : this.handleClick,
            role: "tab",
            tabIndex: disabled ? undefined : selected ? 0 : -1
        }), icon != null && $8NFma.createElement((0, $gKgL3.Icon), {
            icon: icon,
            intent: intent,
            className: (0, $auzpd).TAB_ICON
        }), title, children, tagContent != null && $8NFma.createElement((0, $9qDPC.Tag), (0, $gztBd.__assign)({
            minimal: true,
            intent: intent
        }, tagProps, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $auzpd).TAB_TAG, tagProps === null || tagProps === void 0 ? void 0 : tagProps.className)
        }), tagContent));
    };
    TabTitle.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".TabTitle");
    return TabTitle;
}((0, $4Jy2D.AbstractPureComponent));
function $183ee64940189400$export$75e59e2d215e305f(parentId, tabId) {
    return "".concat((0, $auzpd).TAB_PANEL, "_").concat(parentId, "_").concat(tabId);
}
function $183ee64940189400$export$d8fe6a92b026838d(parentId, tabId) {
    return "".concat((0, $auzpd).TAB, "-title_").concat(parentId, "_").concat(tabId);
}

});
parcelRegister("9qDPC", function(module, exports) {

$parcel$export(module.exports, "Tag", () => $6dd570790b9f1503$export$3288d34c523a1192);
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $auzpd = parcelRequire("auzpd");
var $hffzE = parcelRequire("hffzE");
var $iP8Ix = parcelRequire("iP8Ix");

var $4FOwp = parcelRequire("4FOwp");

var $gKgL3 = parcelRequire("gKgL3");

var $M9AJy = parcelRequire("M9AJy");

var $8La4l = parcelRequire("8La4l");
var $6dd570790b9f1503$export$3288d34c523a1192 = $8NFma.forwardRef(function(props, ref) {
    var _a;
    var active = props.active, children = props.children, className = props.className, fill = props.fill, icon = props.icon, intent = props.intent, interactive = props.interactive, large = props.large, minimal = props.minimal, multiline = props.multiline, onRemove = props.onRemove, rightIcon = props.rightIcon, round = props.round, _b = props.tabIndex, tabIndex = _b === void 0 ? 0 : _b, htmlTitle = props.htmlTitle, htmlProps = (0, $gztBd.__rest)(props, [
        "active",
        "children",
        "className",
        "fill",
        "icon",
        "intent",
        "interactive",
        "large",
        "minimal",
        "multiline",
        "onRemove",
        "rightIcon",
        "round",
        "tabIndex",
        "htmlTitle"
    ]);
    var isRemovable = (0, $iP8Ix).isFunction(onRemove);
    var tagClasses = (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $auzpd).TAG, (0, $auzpd).intentClass(intent), (_a = {}, _a[(0, $auzpd).ACTIVE] = active, _a[(0, $auzpd).FILL] = fill, _a[(0, $auzpd).INTERACTIVE] = interactive, _a[(0, $auzpd).LARGE] = large, _a[(0, $auzpd).MINIMAL] = minimal, _a[(0, $auzpd).ROUND] = round, _a), className);
    return $8NFma.createElement("span", (0, $gztBd.__assign)({}, htmlProps, {
        className: tagClasses,
        tabIndex: interactive ? tabIndex : undefined,
        ref: ref
    }), $8NFma.createElement((0, $gKgL3.Icon), {
        icon: icon
    }), !(0, $4FOwp.isReactNodeEmpty)(children) && $8NFma.createElement((0, $M9AJy.Text), {
        className: (0, $auzpd).FILL,
        ellipsize: !multiline,
        tagName: "span",
        title: htmlTitle
    }, children), $8NFma.createElement((0, $gKgL3.Icon), {
        icon: rightIcon
    }), isRemovable && $8NFma.createElement((0, $8La4l.TagRemoveButton), (0, $gztBd.__assign)({}, props)));
});
$6dd570790b9f1503$export$3288d34c523a1192.defaultProps = {
    active: false,
    fill: false,
    interactive: false,
    large: false,
    minimal: false,
    round: false
};
$6dd570790b9f1503$export$3288d34c523a1192.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".Tag");

});
parcelRegister("8La4l", function(module, exports) {

$parcel$export(module.exports, "TagRemoveButton", () => $660a860a3b4f864a$export$eb6c87c0f34cc108);
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $8NFma = parcelRequire("8NFma");

var $leH9B = parcelRequire("leH9B");
var $bqtP4 = parcelRequire("bqtP4");

var $auzpd = parcelRequire("auzpd");
var $hffzE = parcelRequire("hffzE");
var $660a860a3b4f864a$export$eb6c87c0f34cc108 = function(props) {
    var className = props.className, large = props.large, onRemove = props.onRemove, tabIndex = props.tabIndex;
    var isLarge = large || (className === null || className === void 0 ? void 0 : className.includes((0, $auzpd).LARGE));
    var handleRemoveClick = $8NFma.useCallback(function(e) {
        onRemove === null || onRemove === void 0 || onRemove(e, props);
    }, [
        onRemove,
        props
    ]);
    return $8NFma.createElement("button", {
        "aria-label": "Remove tag",
        type: "button",
        className: (0, $auzpd).TAG_REMOVE,
        onClick: handleRemoveClick,
        tabIndex: tabIndex
    }, $8NFma.createElement((0, $bqtP4.SmallCross), {
        size: isLarge ? (0, $leH9B.IconSize).LARGE : (0, $leH9B.IconSize).STANDARD
    }));
};
$660a860a3b4f864a$export$eb6c87c0f34cc108.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".TagRemoveButton");

});
parcelRegister("bqtP4", function(module, exports) {

$parcel$export(module.exports, "SmallCross", () => $8519419669b1bad7$export$81585da998e09b11);
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $8NFma = parcelRequire("8NFma");

var $leH9B = parcelRequire("leH9B");

var $eog74 = parcelRequire("eog74");
var $8519419669b1bad7$export$81585da998e09b11 = $8NFma.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, $leH9B.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, $leH9B.IconSize).LARGE : (0, $leH9B.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return $8NFma.createElement((0, $eog74.SVGIconContainer), (0, $gztBd.__assign)({
        iconName: "small-cross",
        ref: ref
    }, props), $8NFma.createElement("path", {
        d: isLarge ? "M228.2 200L294 265.8C297.8 269.4 300 274.4 300 280C300 291 291 300 280 300C274.4000000000001 300 269.4000000000001 297.8 265.8 294.2L200 228.2L134.2 294.2C130.6 297.8 125.6 300 120 300C109 300 100 291 100 280C100 274.4 102.2 269.4 105.8 265.8L171.8 200L106 134.2000000000001C102.2 130.6 100 125.6 100 120C100 109 109 100 120 100C125.6 100 130.6 102.2 134.2 105.8L200 171.8L265.8 106C269.4000000000001 102.2 274.4000000000001 100 280 100C291 100 300 109 300 120C300 125.6 297.8 130.6 294.2000000000001 134.2000000000001L228.2 200z" : "M188.2 160L234 205.8C237.8 209.4 240 214.4 240 220C240 231 231 240 220 240C214.4 240 209.4 237.8 205.8 234.2L160 188.2L114.2 234.2C110.6 237.8 105.6 240 100 240C89 240 80 231 80 220C80 214.4 82.2 209.4 85.8 205.8L131.8 160L86 114.2C82.2 110.6 80 105.6 80 100C80 89 89 80 100 80C105.6 80 110.6 82.2 114.2 85.8L160 131.8L205.8 86C209.4 82.2 214.4 80 220 80C231 80 240 89 240 100C240 105.6 237.8 110.6 234.2 114.2L188.2 160z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
$8519419669b1bad7$export$81585da998e09b11.defaultProps = {
    size: (0, $leH9B.IconSize).STANDARD
};
$8519419669b1bad7$export$81585da998e09b11.displayName = "Blueprint5.Icon.SmallCross";
var $8519419669b1bad7$export$2e2bcd8739ae039 = $8519419669b1bad7$export$81585da998e09b11;

});





parcelRegister("5QsJ2", function(module, exports) {
"use strict";
var $4418175b445b6c20$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.Sketch = void 0;

const $4418175b445b6c20$var$react_1 = $4418175b445b6c20$var$__importDefault((parcelRequire("8NFma")));

const $4418175b445b6c20$var$prop_types_1 = $4418175b445b6c20$var$__importDefault((parcelRequire("fb0st")));

const $4418175b445b6c20$var$reactcss_1 = $4418175b445b6c20$var$__importDefault((parcelRequire("32YTy")));

const $4418175b445b6c20$var$merge_1 = $4418175b445b6c20$var$__importDefault((parcelRequire("5vxoY")));

var $gUePa = parcelRequire("gUePa");

const $4418175b445b6c20$var$CgColorPicker_1 = $4418175b445b6c20$var$__importDefault((parcelRequire("8iqVt")));

const $4418175b445b6c20$var$konva_1 = $4418175b445b6c20$var$__importDefault((parcelRequire("ciNAD")));

var $9Nyg4 = parcelRequire("9Nyg4");

const $4418175b445b6c20$var$SketchFields_1 = $4418175b445b6c20$var$__importDefault((parcelRequire("atmUA")));

const $4418175b445b6c20$var$SketchPresetColors_1 = $4418175b445b6c20$var$__importDefault((parcelRequire("fxPNj"))), $4418175b445b6c20$var$useEffectEvent = (e)=>{
    const t = $4418175b445b6c20$var$react_1.default.useRef(e);
    return t.current = e, $4418175b445b6c20$var$react_1.default.useCallback((...e)=>t.current(...e), []);
};
function $4418175b445b6c20$var$hasClassNameOrParentWithClassName(e, t) {
    let r = e.target;
    for(; r;){
        if (r.classList.contains(t)) return !0;
        r = r.parentElement;
    }
    return !1;
}
const $4418175b445b6c20$var$Sketch = ({ width: e, rgb: t, hex: r, hsv: a, hsl: o, onChange: l, onSwatchHover: n, disableAlpha: i, presetColors: s, renderers: c, styles: d = {}, className: u = "" })=>{
    const p = (0, $4418175b445b6c20$var$reactcss_1.default)((0, $4418175b445b6c20$var$merge_1.default)({
        default: Object.assign({
            picker: {
                width: e,
                padding: "10px 10px 0",
                boxSizing: "initial",
                background: "#fff",
                borderRadius: "4px",
                boxShadow: "0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)"
            },
            saturation: {
                width: "100%",
                paddingBottom: "75%",
                position: "relative",
                overflow: "hidden"
            },
            Saturation: {
                radius: "3px",
                shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
            },
            controls: {
                display: "flex"
            },
            sliders: {
                padding: "4px 0",
                flex: "1"
            },
            color: {
                width: "24px",
                height: "24px",
                position: "relative",
                marginTop: "4px",
                marginLeft: "4px",
                borderRadius: "3px"
            },
            activeColor: {
                absolute: "0px 0px 0px 0px",
                borderRadius: "2px",
                background: `rgba(${t.r},${t.g},${t.b},${t.a})`,
                boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
            },
            hue: {
                position: "relative",
                height: "10px",
                overflow: "hidden"
            },
            Hue: {
                radius: "2px",
                shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
            },
            alpha: {
                position: "relative",
                height: "10px",
                marginTop: "4px",
                overflow: "hidden"
            },
            Alpha: {
                radius: "2px",
                shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
            }
        }, d),
        disableAlpha: {
            color: {
                height: "10px"
            },
            hue: {
                height: "10px"
            },
            alpha: {
                display: "none"
            }
        }
    }, d), {
        disableAlpha: i
    }), [f, h] = $4418175b445b6c20$var$react_1.default.useState(!1), m = $4418175b445b6c20$var$react_1.default.useRef(null), _ = $4418175b445b6c20$var$useEffectEvent((e)=>{
        var t;
        if (f) {
            const r = null === (t = m.current) || void 0 === t ? void 0 : t.fill();
            r && l($4418175b445b6c20$var$konva_1.default.Util.colorToRGBA(r)), x(), $4418175b445b6c20$var$hasClassNameOrParentWithClassName(e, "color-picker-button") || h(!1), e.stopPropagation(), e.stopImmediatePropagation();
        }
    }), g = $4418175b445b6c20$var$useEffectEvent((e)=>{
        if (!f) return;
        const t = $4418175b445b6c20$var$konva_1.default.stages.find((t)=>{
            const r = t.getContent().getBoundingClientRect();
            return r.left < e.clientX && r.left + r.width > e.clientX && r.top < e.clientY && r.top + r.height > e.clientY;
        });
        if (!t) return void x();
        const r = t.getContent().getBoundingClientRect(), a = e.clientX - r.left, o = e.clientY - r.top, l = t.children[0], n = l.getNativeCanvasElement(), i = l.getCanvas().getPixelRatio(), { data: s } = n.getContext("2d").getImageData(a * i, o * i, 1, 1), c = t.findOne(".line-guides");
        c.findOne(".picker") || (m.current && m.current.destroy(), m.current = new $4418175b445b6c20$var$konva_1.default.Circle({
            name: "picker",
            radius: 14,
            stroke: "black",
            strokeWidth: 1
        }), c.add(m.current)), m.current.setAbsolutePosition({
            x: a - 15,
            y: o - 15
        }), m.current.fill("rgb(" + s[0] + "," + s[1] + "," + s[2] + ")");
    });
    $4418175b445b6c20$var$react_1.default.useEffect(()=>(window.addEventListener("mousemove", g), window.addEventListener("mousedown", _, !0), window.addEventListener("touchstart", _, !0), ()=>{
            window.removeEventListener("mousemove", g), window.removeEventListener("mousedown", _, !0), window.removeEventListener("touchstart", _, !0), x();
        }), []), $4418175b445b6c20$var$react_1.default.useEffect(()=>{
        f || x();
    }, [
        f
    ]), $4418175b445b6c20$var$react_1.default.useEffect(()=>(f && (document.body.style.cursor = "crosshair"), ()=>{
            document.body.style.cursor = "default";
        }), [
        f
    ]);
    const x = $4418175b445b6c20$var$useEffectEvent(()=>{
        m.current && (m.current.destroy(), m.current = null);
    });
    return $4418175b445b6c20$var$react_1.default.createElement("div", {
        style: p.picker,
        className: `sketch-picker ${u}`
    }, $4418175b445b6c20$var$react_1.default.createElement("div", {
        style: p.saturation
    }, $4418175b445b6c20$var$react_1.default.createElement($9Nyg4.Saturation, {
        style: p.Saturation,
        hsl: o,
        hsv: a,
        onChange: l
    })), $4418175b445b6c20$var$react_1.default.createElement("div", {
        style: p.controls,
        className: "flexbox-fix"
    }, $4418175b445b6c20$var$react_1.default.createElement("div", {
        style: p.sliders
    }, $4418175b445b6c20$var$react_1.default.createElement("div", {
        style: p.hue
    }, $4418175b445b6c20$var$react_1.default.createElement($9Nyg4.Hue, {
        style: p.Hue,
        hsl: o,
        onChange: l
    })), $4418175b445b6c20$var$react_1.default.createElement("div", {
        style: p.alpha
    }, $4418175b445b6c20$var$react_1.default.createElement($9Nyg4.Alpha, {
        style: p.Alpha,
        rgb: t,
        hsl: o,
        renderers: c,
        onChange: l
    }))), $4418175b445b6c20$var$react_1.default.createElement("div", {
        style: p.color
    }, $4418175b445b6c20$var$react_1.default.createElement($9Nyg4.Checkboard, null), $4418175b445b6c20$var$react_1.default.createElement("div", {
        style: p.activeColor
    })), $4418175b445b6c20$var$react_1.default.createElement("div", {
        style: p.color
    }, $4418175b445b6c20$var$react_1.default.createElement($gUePa.Button, {
        icon: $4418175b445b6c20$var$react_1.default.createElement($4418175b445b6c20$var$CgColorPicker_1.default, null),
        className: "color-picker-button",
        minimal: !0,
        style: {
            width: "24px",
            height: "24px",
            minWidth: "24px",
            minHeight: "24px",
            padding: 0,
            margin: 0
        },
        active: f,
        onClickCapture: (e)=>{
            h((e)=>!e), e.stopPropagation();
        }
    }))), $4418175b445b6c20$var$react_1.default.createElement($4418175b445b6c20$var$SketchFields_1.default, {
        rgb: t,
        hsl: o,
        hex: r,
        onChange: l,
        disableAlpha: i
    }), $4418175b445b6c20$var$react_1.default.createElement($4418175b445b6c20$var$SketchPresetColors_1.default, {
        colors: s,
        onClick: l,
        onSwatchHover: n
    }));
};
module.exports.Sketch = $4418175b445b6c20$var$Sketch, module.exports.Sketch.propTypes = {
    disableAlpha: $4418175b445b6c20$var$prop_types_1.default.bool,
    width: $4418175b445b6c20$var$prop_types_1.default.oneOfType([
        $4418175b445b6c20$var$prop_types_1.default.string,
        $4418175b445b6c20$var$prop_types_1.default.number
    ]),
    styles: $4418175b445b6c20$var$prop_types_1.default.object
}, module.exports.Sketch.defaultProps = {
    disableAlpha: !1,
    width: 200,
    styles: {},
    presetColors: [
        "#D0021B",
        "#F5A623",
        "#F8E71C",
        "#8B572A",
        "#7ED321",
        "#417505",
        "#BD10E0",
        "#9013FE",
        "#4A90E2",
        "#50E3C2",
        "#B8E986",
        "#000000",
        "#4A4A4A",
        "#9B9B9B",
        "#FFFFFF"
    ]
}, module.exports.default = (0, $9Nyg4.ColorWrap)(module.exports.Sketch);

});
parcelRegister("32YTy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ReactCSS = module.exports.loop = module.exports.handleActive = module.exports.handleHover = module.exports.hover = undefined;

var $KK9EL = parcelRequire("KK9EL");
var $2380cb7a65ddeaf7$var$_flattenNames2 = $2380cb7a65ddeaf7$var$_interopRequireDefault($KK9EL);

var $2Ku1G = parcelRequire("2Ku1G");
var $2380cb7a65ddeaf7$var$_mergeClasses2 = $2380cb7a65ddeaf7$var$_interopRequireDefault($2Ku1G);

var $S5QiM = parcelRequire("S5QiM");
var $2380cb7a65ddeaf7$var$_autoprefix2 = $2380cb7a65ddeaf7$var$_interopRequireDefault($S5QiM);

var $bPRui = parcelRequire("bPRui");
var $2380cb7a65ddeaf7$var$_hover3 = $2380cb7a65ddeaf7$var$_interopRequireDefault($bPRui);

var $j8O9v = parcelRequire("j8O9v");
var $2380cb7a65ddeaf7$var$_active2 = $2380cb7a65ddeaf7$var$_interopRequireDefault($j8O9v);

var $2YJVw = parcelRequire("2YJVw");
var $2380cb7a65ddeaf7$var$_loop3 = $2380cb7a65ddeaf7$var$_interopRequireDefault($2YJVw);
function $2380cb7a65ddeaf7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.hover = $2380cb7a65ddeaf7$var$_hover3.default;
module.exports.handleHover = $2380cb7a65ddeaf7$var$_hover3.default;
module.exports.handleActive = $2380cb7a65ddeaf7$var$_active2.default;
module.exports.loop = $2380cb7a65ddeaf7$var$_loop3.default;
var $2380cb7a65ddeaf7$var$ReactCSS = module.exports.ReactCSS = function ReactCSS(classes) {
    for(var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)activations[_key - 1] = arguments[_key];
    var activeNames = (0, $2380cb7a65ddeaf7$var$_flattenNames2.default)(activations);
    var merged = (0, $2380cb7a65ddeaf7$var$_mergeClasses2.default)(classes, activeNames);
    return (0, $2380cb7a65ddeaf7$var$_autoprefix2.default)(merged);
};
module.exports.default = $2380cb7a65ddeaf7$var$ReactCSS;

});
parcelRegister("KK9EL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.flattenNames = undefined;

var $dDu84 = parcelRequire("dDu84");
var $08c8195d5dbef82b$var$_isString3 = $08c8195d5dbef82b$var$_interopRequireDefault($dDu84);

var $aZveu = parcelRequire("aZveu");
var $08c8195d5dbef82b$var$_forOwn3 = $08c8195d5dbef82b$var$_interopRequireDefault($aZveu);

var $583Bp = parcelRequire("583Bp");
var $08c8195d5dbef82b$var$_isPlainObject3 = $08c8195d5dbef82b$var$_interopRequireDefault($583Bp);

var $crGAF = parcelRequire("crGAF");
var $08c8195d5dbef82b$var$_map3 = $08c8195d5dbef82b$var$_interopRequireDefault($crGAF);
function $08c8195d5dbef82b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $08c8195d5dbef82b$var$flattenNames = module.exports.flattenNames = function flattenNames() {
    var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var names = [];
    (0, $08c8195d5dbef82b$var$_map3.default)(things, function(thing) {
        if (Array.isArray(thing)) flattenNames(thing).map(function(name) {
            return names.push(name);
        });
        else if ((0, $08c8195d5dbef82b$var$_isPlainObject3.default)(thing)) (0, $08c8195d5dbef82b$var$_forOwn3.default)(thing, function(value, key) {
            value === true && names.push(key);
            names.push(key + "-" + value);
        });
        else if ((0, $08c8195d5dbef82b$var$_isString3.default)(thing)) names.push(thing);
    });
    return names;
};
module.exports.default = $08c8195d5dbef82b$var$flattenNames;

});
parcelRegister("dDu84", function(module, exports) {

var $h1l7t = parcelRequire("h1l7t");

var $5V8oz = parcelRequire("5V8oz");

var $hcK5n = parcelRequire("hcK5n");
/** `Object#toString` result references. */ var $9ed649e276a55693$var$stringTag = "[object String]";
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $9ed649e276a55693$var$isString(value) {
    return typeof value == "string" || !$5V8oz(value) && $hcK5n(value) && $h1l7t(value) == $9ed649e276a55693$var$stringTag;
}
module.exports = $9ed649e276a55693$var$isString;

});
parcelRegister("h1l7t", function(module, exports) {

var $4Cb5x = parcelRequire("4Cb5x");

var $dqMex = parcelRequire("dqMex");

var $3WsNE = parcelRequire("3WsNE");
/** `Object#toString` result references. */ var $c642e992d66c2487$var$nullTag = "[object Null]", $c642e992d66c2487$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $c642e992d66c2487$var$symToStringTag = $4Cb5x ? $4Cb5x.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $c642e992d66c2487$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $c642e992d66c2487$var$undefinedTag : $c642e992d66c2487$var$nullTag;
    return $c642e992d66c2487$var$symToStringTag && $c642e992d66c2487$var$symToStringTag in Object(value) ? $dqMex(value) : $3WsNE(value);
}
module.exports = $c642e992d66c2487$var$baseGetTag;

});
parcelRegister("4Cb5x", function(module, exports) {

var $eeOBM = parcelRequire("eeOBM");
/** Built-in value references. */ var $35c34fed223e8d4f$var$Symbol = $eeOBM.Symbol;
module.exports = $35c34fed223e8d4f$var$Symbol;

});
parcelRegister("eeOBM", function(module, exports) {

var $gipFg = parcelRequire("gipFg");
/** Detect free variable `self`. */ var $a5d9a14830ba4e3d$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $a5d9a14830ba4e3d$var$root = $gipFg || $a5d9a14830ba4e3d$var$freeSelf || Function("return this")();
module.exports = $a5d9a14830ba4e3d$var$root;

});
parcelRegister("gipFg", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $bdd23c336734cabc$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $bdd23c336734cabc$var$freeGlobal;

});



parcelRegister("dqMex", function(module, exports) {

var $4Cb5x = parcelRequire("4Cb5x");
/** Used for built-in method references. */ var $9c731e4150a7ad2a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9c731e4150a7ad2a$var$hasOwnProperty = $9c731e4150a7ad2a$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $9c731e4150a7ad2a$var$nativeObjectToString = $9c731e4150a7ad2a$var$objectProto.toString;
/** Built-in value references. */ var $9c731e4150a7ad2a$var$symToStringTag = $4Cb5x ? $4Cb5x.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $9c731e4150a7ad2a$var$getRawTag(value) {
    var isOwn = $9c731e4150a7ad2a$var$hasOwnProperty.call(value, $9c731e4150a7ad2a$var$symToStringTag), tag = value[$9c731e4150a7ad2a$var$symToStringTag];
    try {
        value[$9c731e4150a7ad2a$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $9c731e4150a7ad2a$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$9c731e4150a7ad2a$var$symToStringTag] = tag;
        else delete value[$9c731e4150a7ad2a$var$symToStringTag];
    }
    return result;
}
module.exports = $9c731e4150a7ad2a$var$getRawTag;

});

parcelRegister("3WsNE", function(module, exports) {
/** Used for built-in method references. */ var $2ded20f023f64d8f$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $2ded20f023f64d8f$var$nativeObjectToString = $2ded20f023f64d8f$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $2ded20f023f64d8f$var$objectToString(value) {
    return $2ded20f023f64d8f$var$nativeObjectToString.call(value);
}
module.exports = $2ded20f023f64d8f$var$objectToString;

});


parcelRegister("5V8oz", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $44f8c9c3c9c11cf1$var$isArray = Array.isArray;
module.exports = $44f8c9c3c9c11cf1$var$isArray;

});

parcelRegister("hcK5n", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $c8674e57225e697f$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = $c8674e57225e697f$var$isObjectLike;

});


parcelRegister("aZveu", function(module, exports) {

var $4V1MN = parcelRequire("4V1MN");

var $4hKXW = parcelRequire("4hKXW");
/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $8007d40704367421$var$forOwn(object, iteratee) {
    return object && $4V1MN(object, $4hKXW(iteratee));
}
module.exports = $8007d40704367421$var$forOwn;

});
parcelRegister("4V1MN", function(module, exports) {

var $e3j3J = parcelRequire("e3j3J");

var $8R54q = parcelRequire("8R54q");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $394ddef268e43e50$var$baseForOwn(object, iteratee) {
    return object && $e3j3J(object, iteratee, $8R54q);
}
module.exports = $394ddef268e43e50$var$baseForOwn;

});
parcelRegister("e3j3J", function(module, exports) {

var $f1U76 = parcelRequire("f1U76");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $a3b0213c2af2b439$var$baseFor = $f1U76();
module.exports = $a3b0213c2af2b439$var$baseFor;

});
parcelRegister("f1U76", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $af1279ff4e678a14$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $af1279ff4e678a14$var$createBaseFor;

});


parcelRegister("8R54q", function(module, exports) {

var $hopFG = parcelRequire("hopFG");

var $c9W6j = parcelRequire("c9W6j");

var $iiJxK = parcelRequire("iiJxK");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $672734dc5950c536$var$keys(object) {
    return $iiJxK(object) ? $hopFG(object) : $c9W6j(object);
}
module.exports = $672734dc5950c536$var$keys;

});
parcelRegister("hopFG", function(module, exports) {

var $6Cbuu = parcelRequire("6Cbuu");

var $4rbI4 = parcelRequire("4rbI4");

var $5V8oz = parcelRequire("5V8oz");

var $9e2tS = parcelRequire("9e2tS");

var $74Ail = parcelRequire("74Ail");

var $fAXjB = parcelRequire("fAXjB");
/** Used for built-in method references. */ var $ca98975307808bdc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ca98975307808bdc$var$hasOwnProperty = $ca98975307808bdc$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $ca98975307808bdc$var$arrayLikeKeys(value, inherited) {
    var isArr = $5V8oz(value), isArg = !isArr && $4rbI4(value), isBuff = !isArr && !isArg && $9e2tS(value), isType = !isArr && !isArg && !isBuff && $fAXjB(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $6Cbuu(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $ca98975307808bdc$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $74Ail(key, length)))) result.push(key);
    return result;
}
module.exports = $ca98975307808bdc$var$arrayLikeKeys;

});
parcelRegister("6Cbuu", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $4d0f34875e522983$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $4d0f34875e522983$var$baseTimes;

});

parcelRegister("4rbI4", function(module, exports) {

var $eqh6Y = parcelRequire("eqh6Y");

var $hcK5n = parcelRequire("hcK5n");
/** Used for built-in method references. */ var $33b2c45983452928$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $33b2c45983452928$var$hasOwnProperty = $33b2c45983452928$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $33b2c45983452928$var$propertyIsEnumerable = $33b2c45983452928$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $33b2c45983452928$var$isArguments = $eqh6Y(function() {
    return arguments;
}()) ? $eqh6Y : function(value) {
    return $hcK5n(value) && $33b2c45983452928$var$hasOwnProperty.call(value, "callee") && !$33b2c45983452928$var$propertyIsEnumerable.call(value, "callee");
};
module.exports = $33b2c45983452928$var$isArguments;

});
parcelRegister("eqh6Y", function(module, exports) {

var $h1l7t = parcelRequire("h1l7t");

var $hcK5n = parcelRequire("hcK5n");
/** `Object#toString` result references. */ var $a800c46306574cbb$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $a800c46306574cbb$var$baseIsArguments(value) {
    return $hcK5n(value) && $h1l7t(value) == $a800c46306574cbb$var$argsTag;
}
module.exports = $a800c46306574cbb$var$baseIsArguments;

});


parcelRegister("9e2tS", function(module, exports) {

var $eeOBM = parcelRequire("eeOBM");

var $hKlAl = parcelRequire("hKlAl");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $eeOBM.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $hKlAl;
module.exports = isBuffer;

});
parcelRegister("hKlAl", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $ceb779e839231b1e$var$stubFalse() {
    return false;
}
module.exports = $ceb779e839231b1e$var$stubFalse;

});


parcelRegister("74Ail", function(module, exports) {
/** Used as references for various `Number` constants. */ var $52650f84cdcbb7ab$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $52650f84cdcbb7ab$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $52650f84cdcbb7ab$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $52650f84cdcbb7ab$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $52650f84cdcbb7ab$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $52650f84cdcbb7ab$var$isIndex;

});

parcelRegister("fAXjB", function(module, exports) {

var $6uJSW = parcelRequire("6uJSW");

var $cLhdb = parcelRequire("cLhdb");

var $fwpsA = parcelRequire("fwpsA");
/* Node.js helper references. */ var $b5a83a94e196c557$var$nodeIsTypedArray = $fwpsA && $fwpsA.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $b5a83a94e196c557$var$isTypedArray = $b5a83a94e196c557$var$nodeIsTypedArray ? $cLhdb($b5a83a94e196c557$var$nodeIsTypedArray) : $6uJSW;
module.exports = $b5a83a94e196c557$var$isTypedArray;

});
parcelRegister("6uJSW", function(module, exports) {

var $h1l7t = parcelRequire("h1l7t");

var $2zEBJ = parcelRequire("2zEBJ");

var $hcK5n = parcelRequire("hcK5n");
/** `Object#toString` result references. */ var $4ba92344132c7f97$var$argsTag = "[object Arguments]", $4ba92344132c7f97$var$arrayTag = "[object Array]", $4ba92344132c7f97$var$boolTag = "[object Boolean]", $4ba92344132c7f97$var$dateTag = "[object Date]", $4ba92344132c7f97$var$errorTag = "[object Error]", $4ba92344132c7f97$var$funcTag = "[object Function]", $4ba92344132c7f97$var$mapTag = "[object Map]", $4ba92344132c7f97$var$numberTag = "[object Number]", $4ba92344132c7f97$var$objectTag = "[object Object]", $4ba92344132c7f97$var$regexpTag = "[object RegExp]", $4ba92344132c7f97$var$setTag = "[object Set]", $4ba92344132c7f97$var$stringTag = "[object String]", $4ba92344132c7f97$var$weakMapTag = "[object WeakMap]";
var $4ba92344132c7f97$var$arrayBufferTag = "[object ArrayBuffer]", $4ba92344132c7f97$var$dataViewTag = "[object DataView]", $4ba92344132c7f97$var$float32Tag = "[object Float32Array]", $4ba92344132c7f97$var$float64Tag = "[object Float64Array]", $4ba92344132c7f97$var$int8Tag = "[object Int8Array]", $4ba92344132c7f97$var$int16Tag = "[object Int16Array]", $4ba92344132c7f97$var$int32Tag = "[object Int32Array]", $4ba92344132c7f97$var$uint8Tag = "[object Uint8Array]", $4ba92344132c7f97$var$uint8ClampedTag = "[object Uint8ClampedArray]", $4ba92344132c7f97$var$uint16Tag = "[object Uint16Array]", $4ba92344132c7f97$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $4ba92344132c7f97$var$typedArrayTags = {};
$4ba92344132c7f97$var$typedArrayTags[$4ba92344132c7f97$var$float32Tag] = $4ba92344132c7f97$var$typedArrayTags[$4ba92344132c7f97$var$float64Tag] = $4ba92344132c7f97$var$typedArrayTags[$4ba92344132c7f97$var$int8Tag] = $4ba92344132c7f97$var$typedArrayTags[$4ba92344132c7f97$var$int16Tag] = $4ba92344132c7f97$var$typedArrayTags[$4ba92344132c7f97$var$int32Tag] = $4ba92344132c7f97$var$typedArrayTags[$4ba92344132c7f97$var$uint8Tag] = $4ba92344132c7f97$var$typedArrayTags[$4ba92344132c7f97$var$uint8ClampedTag] = $4ba92344132c7f97$var$typedArrayTags[$4ba92344132c7f97$var$uint16Tag] = $4ba92344132c7f97$var$typedArrayTags[$4ba92344132c7f97$var$uint32Tag] = true;
$4ba92344132c7f97$var$typedArrayTags[$4ba92344132c7f97$var$argsTag] = $4ba92344132c7f97$var$typedArrayTags[$4ba92344132c7f97$var$arrayTag] = $4ba92344132c7f97$var$typedArrayTags[$4ba92344132c7f97$var$arrayBufferTag] = $4ba92344132c7f97$var$typedArrayTags[$4ba92344132c7f97$var$boolTag] = $4ba92344132c7f97$var$typedArrayTags[$4ba92344132c7f97$var$dataViewTag] = $4ba92344132c7f97$var$typedArrayTags[$4ba92344132c7f97$var$dateTag] = $4ba92344132c7f97$var$typedArrayTags[$4ba92344132c7f97$var$errorTag] = $4ba92344132c7f97$var$typedArrayTags[$4ba92344132c7f97$var$funcTag] = $4ba92344132c7f97$var$typedArrayTags[$4ba92344132c7f97$var$mapTag] = $4ba92344132c7f97$var$typedArrayTags[$4ba92344132c7f97$var$numberTag] = $4ba92344132c7f97$var$typedArrayTags[$4ba92344132c7f97$var$objectTag] = $4ba92344132c7f97$var$typedArrayTags[$4ba92344132c7f97$var$regexpTag] = $4ba92344132c7f97$var$typedArrayTags[$4ba92344132c7f97$var$setTag] = $4ba92344132c7f97$var$typedArrayTags[$4ba92344132c7f97$var$stringTag] = $4ba92344132c7f97$var$typedArrayTags[$4ba92344132c7f97$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $4ba92344132c7f97$var$baseIsTypedArray(value) {
    return $hcK5n(value) && $2zEBJ(value.length) && !!$4ba92344132c7f97$var$typedArrayTags[$h1l7t(value)];
}
module.exports = $4ba92344132c7f97$var$baseIsTypedArray;

});
parcelRegister("2zEBJ", function(module, exports) {
/** Used as references for various `Number` constants. */ var $1dfe59792a6f48be$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $1dfe59792a6f48be$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $1dfe59792a6f48be$var$MAX_SAFE_INTEGER;
}
module.exports = $1dfe59792a6f48be$var$isLength;

});


parcelRegister("cLhdb", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $94a739b34ee9e2ca$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $94a739b34ee9e2ca$var$baseUnary;

});

parcelRegister("fwpsA", function(module, exports) {

var $gipFg = parcelRequire("gipFg");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $gipFg.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("c9W6j", function(module, exports) {

var $dWAd9 = parcelRequire("dWAd9");

var $6tRs6 = parcelRequire("6tRs6");
/** Used for built-in method references. */ var $8da364ef5ed4de55$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8da364ef5ed4de55$var$hasOwnProperty = $8da364ef5ed4de55$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $8da364ef5ed4de55$var$baseKeys(object) {
    if (!$dWAd9(object)) return $6tRs6(object);
    var result = [];
    for(var key in Object(object))if ($8da364ef5ed4de55$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = $8da364ef5ed4de55$var$baseKeys;

});
parcelRegister("dWAd9", function(module, exports) {
/** Used for built-in method references. */ var $a26cc7e647fc8136$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $a26cc7e647fc8136$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $a26cc7e647fc8136$var$objectProto;
    return value === proto;
}
module.exports = $a26cc7e647fc8136$var$isPrototype;

});

parcelRegister("6tRs6", function(module, exports) {

var $blfKu = parcelRequire("blfKu");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $4b7eea027a2df927$var$nativeKeys = $blfKu(Object.keys, Object);
module.exports = $4b7eea027a2df927$var$nativeKeys;

});
parcelRegister("blfKu", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $841ddf49968f3e16$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $841ddf49968f3e16$var$overArg;

});



parcelRegister("iiJxK", function(module, exports) {

var $1F4Th = parcelRequire("1F4Th");

var $2zEBJ = parcelRequire("2zEBJ");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $d52d3c60c7e1f1a1$var$isArrayLike(value) {
    return value != null && $2zEBJ(value.length) && !$1F4Th(value);
}
module.exports = $d52d3c60c7e1f1a1$var$isArrayLike;

});
parcelRegister("1F4Th", function(module, exports) {

var $h1l7t = parcelRequire("h1l7t");

var $kNSK3 = parcelRequire("kNSK3");
/** `Object#toString` result references. */ var $135d69eeba0c8c36$var$asyncTag = "[object AsyncFunction]", $135d69eeba0c8c36$var$funcTag = "[object Function]", $135d69eeba0c8c36$var$genTag = "[object GeneratorFunction]", $135d69eeba0c8c36$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $135d69eeba0c8c36$var$isFunction(value) {
    if (!$kNSK3(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $h1l7t(value);
    return tag == $135d69eeba0c8c36$var$funcTag || tag == $135d69eeba0c8c36$var$genTag || tag == $135d69eeba0c8c36$var$asyncTag || tag == $135d69eeba0c8c36$var$proxyTag;
}
module.exports = $135d69eeba0c8c36$var$isFunction;

});
parcelRegister("kNSK3", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f252d8db80447bb3$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = $f252d8db80447bb3$var$isObject;

});





parcelRegister("4hKXW", function(module, exports) {

var $38wdc = parcelRequire("38wdc");
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $31ed2e65a487b1f2$var$castFunction(value) {
    return typeof value == "function" ? value : $38wdc;
}
module.exports = $31ed2e65a487b1f2$var$castFunction;

});
parcelRegister("38wdc", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $248b1b0a969062ab$var$identity(value) {
    return value;
}
module.exports = $248b1b0a969062ab$var$identity;

});



parcelRegister("583Bp", function(module, exports) {

var $h1l7t = parcelRequire("h1l7t");

var $gKq7A = parcelRequire("gKq7A");

var $hcK5n = parcelRequire("hcK5n");
/** `Object#toString` result references. */ var $3bc07e7bf5b9fecc$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $3bc07e7bf5b9fecc$var$funcProto = Function.prototype, $3bc07e7bf5b9fecc$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $3bc07e7bf5b9fecc$var$funcToString = $3bc07e7bf5b9fecc$var$funcProto.toString;
/** Used to check objects for own properties. */ var $3bc07e7bf5b9fecc$var$hasOwnProperty = $3bc07e7bf5b9fecc$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $3bc07e7bf5b9fecc$var$objectCtorString = $3bc07e7bf5b9fecc$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $3bc07e7bf5b9fecc$var$isPlainObject(value) {
    if (!$hcK5n(value) || $h1l7t(value) != $3bc07e7bf5b9fecc$var$objectTag) return false;
    var proto = $gKq7A(value);
    if (proto === null) return true;
    var Ctor = $3bc07e7bf5b9fecc$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $3bc07e7bf5b9fecc$var$funcToString.call(Ctor) == $3bc07e7bf5b9fecc$var$objectCtorString;
}
module.exports = $3bc07e7bf5b9fecc$var$isPlainObject;

});
parcelRegister("gKq7A", function(module, exports) {

var $blfKu = parcelRequire("blfKu");
/** Built-in value references. */ var $c315345dd2e7b69e$var$getPrototype = $blfKu(Object.getPrototypeOf, Object);
module.exports = $c315345dd2e7b69e$var$getPrototype;

});


parcelRegister("crGAF", function(module, exports) {

var $cIKPk = parcelRequire("cIKPk");

var $7Odt0 = parcelRequire("7Odt0");

var $b6ejR = parcelRequire("b6ejR");

var $5V8oz = parcelRequire("5V8oz");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $90f90b34afd2c90c$var$map(collection, iteratee) {
    var func = $5V8oz(collection) ? $cIKPk : $b6ejR;
    return func(collection, $7Odt0(iteratee, 3));
}
module.exports = $90f90b34afd2c90c$var$map;

});
parcelRegister("cIKPk", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $942deaf4266cd57c$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $942deaf4266cd57c$var$arrayMap;

});

parcelRegister("7Odt0", function(module, exports) {

var $fUEfQ = parcelRequire("fUEfQ");

var $gIg4G = parcelRequire("gIg4G");

var $38wdc = parcelRequire("38wdc");

var $5V8oz = parcelRequire("5V8oz");

var $lIVno = parcelRequire("lIVno");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $5af7a6279c12bd16$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $38wdc;
    if (typeof value == "object") return $5V8oz(value) ? $gIg4G(value[0], value[1]) : $fUEfQ(value);
    return $lIVno(value);
}
module.exports = $5af7a6279c12bd16$var$baseIteratee;

});
parcelRegister("fUEfQ", function(module, exports) {

var $gORbz = parcelRequire("gORbz");

var $554dO = parcelRequire("554dO");

var $jcxk3 = parcelRequire("jcxk3");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $b95b4fb15a08e138$var$baseMatches(source) {
    var matchData = $554dO(source);
    if (matchData.length == 1 && matchData[0][2]) return $jcxk3(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $gORbz(object, source, matchData);
    };
}
module.exports = $b95b4fb15a08e138$var$baseMatches;

});
parcelRegister("gORbz", function(module, exports) {

var $jIdTJ = parcelRequire("jIdTJ");

var $idJmA = parcelRequire("idJmA");
/** Used to compose bitmasks for value comparisons. */ var $c3ea926ab6c14229$var$COMPARE_PARTIAL_FLAG = 1, $c3ea926ab6c14229$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $c3ea926ab6c14229$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $jIdTJ;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $idJmA(srcValue, objValue, $c3ea926ab6c14229$var$COMPARE_PARTIAL_FLAG | $c3ea926ab6c14229$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $c3ea926ab6c14229$var$baseIsMatch;

});
parcelRegister("jIdTJ", function(module, exports) {

var $kRbq8 = parcelRequire("kRbq8");

var $4mDjb = parcelRequire("4mDjb");

var $c5BXf = parcelRequire("c5BXf");

var $jwz8G = parcelRequire("jwz8G");

var $4ThXA = parcelRequire("4ThXA");

var $7ooyh = parcelRequire("7ooyh");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $e59ce83aa28f0740$var$Stack(entries) {
    var data = this.__data__ = new $kRbq8(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$e59ce83aa28f0740$var$Stack.prototype.clear = $4mDjb;
$e59ce83aa28f0740$var$Stack.prototype["delete"] = $c5BXf;
$e59ce83aa28f0740$var$Stack.prototype.get = $jwz8G;
$e59ce83aa28f0740$var$Stack.prototype.has = $4ThXA;
$e59ce83aa28f0740$var$Stack.prototype.set = $7ooyh;
module.exports = $e59ce83aa28f0740$var$Stack;

});
parcelRegister("kRbq8", function(module, exports) {

var $82c55 = parcelRequire("82c55");

var $aUtqk = parcelRequire("aUtqk");

var $7qumM = parcelRequire("7qumM");

var $304IZ = parcelRequire("304IZ");

var $k4Cyj = parcelRequire("k4Cyj");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f2f19dc0f676ccf7$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$f2f19dc0f676ccf7$var$ListCache.prototype.clear = $82c55;
$f2f19dc0f676ccf7$var$ListCache.prototype["delete"] = $aUtqk;
$f2f19dc0f676ccf7$var$ListCache.prototype.get = $7qumM;
$f2f19dc0f676ccf7$var$ListCache.prototype.has = $304IZ;
$f2f19dc0f676ccf7$var$ListCache.prototype.set = $k4Cyj;
module.exports = $f2f19dc0f676ccf7$var$ListCache;

});
parcelRegister("82c55", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $5d97e1b1005fd09f$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $5d97e1b1005fd09f$var$listCacheClear;

});

parcelRegister("aUtqk", function(module, exports) {

var $eANGZ = parcelRequire("eANGZ");
/** Used for built-in method references. */ var $7f15f540f9e191c2$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $7f15f540f9e191c2$var$splice = $7f15f540f9e191c2$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $7f15f540f9e191c2$var$listCacheDelete(key) {
    var data = this.__data__, index = $eANGZ(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $7f15f540f9e191c2$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $7f15f540f9e191c2$var$listCacheDelete;

});
parcelRegister("eANGZ", function(module, exports) {

var $1bk3X = parcelRequire("1bk3X");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a9faf96101a5f369$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($1bk3X(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $a9faf96101a5f369$var$assocIndexOf;

});
parcelRegister("1bk3X", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $0dc66199238ed4c7$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $0dc66199238ed4c7$var$eq;

});



parcelRegister("7qumM", function(module, exports) {

var $eANGZ = parcelRequire("eANGZ");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $5682843ca36b31af$var$listCacheGet(key) {
    var data = this.__data__, index = $eANGZ(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $5682843ca36b31af$var$listCacheGet;

});

parcelRegister("304IZ", function(module, exports) {

var $eANGZ = parcelRequire("eANGZ");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $22f50966e965466e$var$listCacheHas(key) {
    return $eANGZ(this.__data__, key) > -1;
}
module.exports = $22f50966e965466e$var$listCacheHas;

});

parcelRegister("k4Cyj", function(module, exports) {

var $eANGZ = parcelRequire("eANGZ");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $e9d216181376e797$var$listCacheSet(key, value) {
    var data = this.__data__, index = $eANGZ(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $e9d216181376e797$var$listCacheSet;

});


parcelRegister("4mDjb", function(module, exports) {

var $kRbq8 = parcelRequire("kRbq8");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $32d7b559e2067d54$var$stackClear() {
    this.__data__ = new $kRbq8;
    this.size = 0;
}
module.exports = $32d7b559e2067d54$var$stackClear;

});

parcelRegister("c5BXf", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $8cd364a8f4e74843$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = $8cd364a8f4e74843$var$stackDelete;

});

parcelRegister("jwz8G", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e36c4360b8623bac$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $e36c4360b8623bac$var$stackGet;

});

parcelRegister("4ThXA", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $38fa3afab9f80c6d$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $38fa3afab9f80c6d$var$stackHas;

});

parcelRegister("7ooyh", function(module, exports) {

var $kRbq8 = parcelRequire("kRbq8");

var $3wCBH = parcelRequire("3wCBH");

var $cetoL = parcelRequire("cetoL");
/** Used as the size to enable large array optimizations. */ var $561dd1c6ac133efc$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $561dd1c6ac133efc$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $kRbq8) {
        var pairs = data.__data__;
        if (!$3wCBH || pairs.length < $561dd1c6ac133efc$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $cetoL(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $561dd1c6ac133efc$var$stackSet;

});
parcelRegister("3wCBH", function(module, exports) {

var $6s7tc = parcelRequire("6s7tc");

var $eeOBM = parcelRequire("eeOBM");
/* Built-in method references that are verified to be native. */ var $29124ed28ffeb2f1$var$Map = $6s7tc($eeOBM, "Map");
module.exports = $29124ed28ffeb2f1$var$Map;

});
parcelRegister("6s7tc", function(module, exports) {

var $ccBXe = parcelRequire("ccBXe");

var $i9hH0 = parcelRequire("i9hH0");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $4b2b26fa8403a2dc$var$getNative(object, key) {
    var value = $i9hH0(object, key);
    return $ccBXe(value) ? value : undefined;
}
module.exports = $4b2b26fa8403a2dc$var$getNative;

});
parcelRegister("ccBXe", function(module, exports) {

var $1F4Th = parcelRequire("1F4Th");

var $2oCE4 = parcelRequire("2oCE4");

var $kNSK3 = parcelRequire("kNSK3");

var $cNK5K = parcelRequire("cNK5K");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $8e240bf50aff37de$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $8e240bf50aff37de$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $8e240bf50aff37de$var$funcProto = Function.prototype, $8e240bf50aff37de$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $8e240bf50aff37de$var$funcToString = $8e240bf50aff37de$var$funcProto.toString;
/** Used to check objects for own properties. */ var $8e240bf50aff37de$var$hasOwnProperty = $8e240bf50aff37de$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $8e240bf50aff37de$var$reIsNative = RegExp("^" + $8e240bf50aff37de$var$funcToString.call($8e240bf50aff37de$var$hasOwnProperty).replace($8e240bf50aff37de$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $8e240bf50aff37de$var$baseIsNative(value) {
    if (!$kNSK3(value) || $2oCE4(value)) return false;
    var pattern = $1F4Th(value) ? $8e240bf50aff37de$var$reIsNative : $8e240bf50aff37de$var$reIsHostCtor;
    return pattern.test($cNK5K(value));
}
module.exports = $8e240bf50aff37de$var$baseIsNative;

});
parcelRegister("2oCE4", function(module, exports) {

var $1CCzO = parcelRequire("1CCzO");
/** Used to detect methods masquerading as native. */ var $1bebcccb210a7916$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($1CCzO && $1CCzO.keys && $1CCzO.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $1bebcccb210a7916$var$isMasked(func) {
    return !!$1bebcccb210a7916$var$maskSrcKey && $1bebcccb210a7916$var$maskSrcKey in func;
}
module.exports = $1bebcccb210a7916$var$isMasked;

});
parcelRegister("1CCzO", function(module, exports) {

var $eeOBM = parcelRequire("eeOBM");
/** Used to detect overreaching core-js shims. */ var $12e7438e603ea2c7$var$coreJsData = $eeOBM["__core-js_shared__"];
module.exports = $12e7438e603ea2c7$var$coreJsData;

});


parcelRegister("cNK5K", function(module, exports) {
/** Used for built-in method references. */ var $951dd07d36cd53d9$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $951dd07d36cd53d9$var$funcToString = $951dd07d36cd53d9$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $951dd07d36cd53d9$var$toSource(func) {
    if (func != null) {
        try {
            return $951dd07d36cd53d9$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = $951dd07d36cd53d9$var$toSource;

});


parcelRegister("i9hH0", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d366caa317c01e8d$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $d366caa317c01e8d$var$getValue;

});



parcelRegister("cetoL", function(module, exports) {

var $kaomH = parcelRequire("kaomH");

var $5SEiD = parcelRequire("5SEiD");

var $caIbl = parcelRequire("caIbl");

var $4J6UL = parcelRequire("4J6UL");

var $hOY0z = parcelRequire("hOY0z");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8e7d98c7f361764c$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$8e7d98c7f361764c$var$MapCache.prototype.clear = $kaomH;
$8e7d98c7f361764c$var$MapCache.prototype["delete"] = $5SEiD;
$8e7d98c7f361764c$var$MapCache.prototype.get = $caIbl;
$8e7d98c7f361764c$var$MapCache.prototype.has = $4J6UL;
$8e7d98c7f361764c$var$MapCache.prototype.set = $hOY0z;
module.exports = $8e7d98c7f361764c$var$MapCache;

});
parcelRegister("kaomH", function(module, exports) {

var $84J3L = parcelRequire("84J3L");

var $kRbq8 = parcelRequire("kRbq8");

var $3wCBH = parcelRequire("3wCBH");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $eae7a43f6b3b68f6$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $84J3L,
        "map": new ($3wCBH || $kRbq8),
        "string": new $84J3L
    };
}
module.exports = $eae7a43f6b3b68f6$var$mapCacheClear;

});
parcelRegister("84J3L", function(module, exports) {

var $9gcHg = parcelRequire("9gcHg");

var $4CF5E = parcelRequire("4CF5E");

var $cTkX8 = parcelRequire("cTkX8");

var $26elL = parcelRequire("26elL");

var $kOO0E = parcelRequire("kOO0E");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $5e11a65b1046469d$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$5e11a65b1046469d$var$Hash.prototype.clear = $9gcHg;
$5e11a65b1046469d$var$Hash.prototype["delete"] = $4CF5E;
$5e11a65b1046469d$var$Hash.prototype.get = $cTkX8;
$5e11a65b1046469d$var$Hash.prototype.has = $26elL;
$5e11a65b1046469d$var$Hash.prototype.set = $kOO0E;
module.exports = $5e11a65b1046469d$var$Hash;

});
parcelRegister("9gcHg", function(module, exports) {

var $cZMsT = parcelRequire("cZMsT");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $6bdf74ffcf60444c$var$hashClear() {
    this.__data__ = $cZMsT ? $cZMsT(null) : {};
    this.size = 0;
}
module.exports = $6bdf74ffcf60444c$var$hashClear;

});
parcelRegister("cZMsT", function(module, exports) {

var $6s7tc = parcelRequire("6s7tc");
/* Built-in method references that are verified to be native. */ var $9760c6aeb02013d0$var$nativeCreate = $6s7tc(Object, "create");
module.exports = $9760c6aeb02013d0$var$nativeCreate;

});


parcelRegister("4CF5E", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $35da95b4dfea8fe0$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $35da95b4dfea8fe0$var$hashDelete;

});

parcelRegister("cTkX8", function(module, exports) {

var $cZMsT = parcelRequire("cZMsT");
/** Used to stand-in for `undefined` hash values. */ var $962adfe5632d1fad$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $962adfe5632d1fad$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $962adfe5632d1fad$var$hasOwnProperty = $962adfe5632d1fad$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $962adfe5632d1fad$var$hashGet(key) {
    var data = this.__data__;
    if ($cZMsT) {
        var result = data[key];
        return result === $962adfe5632d1fad$var$HASH_UNDEFINED ? undefined : result;
    }
    return $962adfe5632d1fad$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $962adfe5632d1fad$var$hashGet;

});

parcelRegister("26elL", function(module, exports) {

var $cZMsT = parcelRequire("cZMsT");
/** Used for built-in method references. */ var $187745f27494b9d3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $187745f27494b9d3$var$hasOwnProperty = $187745f27494b9d3$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $187745f27494b9d3$var$hashHas(key) {
    var data = this.__data__;
    return $cZMsT ? data[key] !== undefined : $187745f27494b9d3$var$hasOwnProperty.call(data, key);
}
module.exports = $187745f27494b9d3$var$hashHas;

});

parcelRegister("kOO0E", function(module, exports) {

var $cZMsT = parcelRequire("cZMsT");
/** Used to stand-in for `undefined` hash values. */ var $f27f4502e5e9b705$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $f27f4502e5e9b705$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $cZMsT && value === undefined ? $f27f4502e5e9b705$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $f27f4502e5e9b705$var$hashSet;

});



parcelRegister("5SEiD", function(module, exports) {

var $6zuLV = parcelRequire("6zuLV");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $4481418c4a1884f3$var$mapCacheDelete(key) {
    var result = $6zuLV(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $4481418c4a1884f3$var$mapCacheDelete;

});
parcelRegister("6zuLV", function(module, exports) {

var $iC4dR = parcelRequire("iC4dR");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $4c8de1a3f1ae1b17$var$getMapData(map, key) {
    var data = map.__data__;
    return $iC4dR(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = $4c8de1a3f1ae1b17$var$getMapData;

});
parcelRegister("iC4dR", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $d8cf0d226a382313$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = $d8cf0d226a382313$var$isKeyable;

});



parcelRegister("caIbl", function(module, exports) {

var $6zuLV = parcelRequire("6zuLV");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $8dc8b0d8f6ed60da$var$mapCacheGet(key) {
    return $6zuLV(this, key).get(key);
}
module.exports = $8dc8b0d8f6ed60da$var$mapCacheGet;

});

parcelRegister("4J6UL", function(module, exports) {

var $6zuLV = parcelRequire("6zuLV");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $3710ba749d11c71e$var$mapCacheHas(key) {
    return $6zuLV(this, key).has(key);
}
module.exports = $3710ba749d11c71e$var$mapCacheHas;

});

parcelRegister("hOY0z", function(module, exports) {

var $6zuLV = parcelRequire("6zuLV");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $cf95a791979b093f$var$mapCacheSet(key, value) {
    var data = $6zuLV(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $cf95a791979b093f$var$mapCacheSet;

});




parcelRegister("idJmA", function(module, exports) {

var $dd5lG = parcelRequire("dd5lG");

var $hcK5n = parcelRequire("hcK5n");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $d43ca11d5586fee4$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$hcK5n(value) && !$hcK5n(other)) return value !== value && other !== other;
    return $dd5lG(value, other, bitmask, customizer, $d43ca11d5586fee4$var$baseIsEqual, stack);
}
module.exports = $d43ca11d5586fee4$var$baseIsEqual;

});
parcelRegister("dd5lG", function(module, exports) {

var $jIdTJ = parcelRequire("jIdTJ");

var $6joxL = parcelRequire("6joxL");

var $8KS6f = parcelRequire("8KS6f");

var $lOYxD = parcelRequire("lOYxD");

var $fsqNS = parcelRequire("fsqNS");

var $5V8oz = parcelRequire("5V8oz");

var $9e2tS = parcelRequire("9e2tS");

var $fAXjB = parcelRequire("fAXjB");
/** Used to compose bitmasks for value comparisons. */ var $99e0a3673bd566a3$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $99e0a3673bd566a3$var$argsTag = "[object Arguments]", $99e0a3673bd566a3$var$arrayTag = "[object Array]", $99e0a3673bd566a3$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $99e0a3673bd566a3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $99e0a3673bd566a3$var$hasOwnProperty = $99e0a3673bd566a3$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $99e0a3673bd566a3$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $5V8oz(object), othIsArr = $5V8oz(other), objTag = objIsArr ? $99e0a3673bd566a3$var$arrayTag : $fsqNS(object), othTag = othIsArr ? $99e0a3673bd566a3$var$arrayTag : $fsqNS(other);
    objTag = objTag == $99e0a3673bd566a3$var$argsTag ? $99e0a3673bd566a3$var$objectTag : objTag;
    othTag = othTag == $99e0a3673bd566a3$var$argsTag ? $99e0a3673bd566a3$var$objectTag : othTag;
    var objIsObj = objTag == $99e0a3673bd566a3$var$objectTag, othIsObj = othTag == $99e0a3673bd566a3$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $9e2tS(object)) {
        if (!$9e2tS(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $jIdTJ);
        return objIsArr || $fAXjB(object) ? $6joxL(object, other, bitmask, customizer, equalFunc, stack) : $8KS6f(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $99e0a3673bd566a3$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $99e0a3673bd566a3$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $99e0a3673bd566a3$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $jIdTJ);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $jIdTJ);
    return $lOYxD(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $99e0a3673bd566a3$var$baseIsEqualDeep;

});
parcelRegister("6joxL", function(module, exports) {

var $f1aY7 = parcelRequire("f1aY7");

var $bnyI1 = parcelRequire("bnyI1");

var $bQEzS = parcelRequire("bQEzS");
/** Used to compose bitmasks for value comparisons. */ var $49878e472ac226f3$var$COMPARE_PARTIAL_FLAG = 1, $49878e472ac226f3$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $49878e472ac226f3$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $49878e472ac226f3$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $49878e472ac226f3$var$COMPARE_UNORDERED_FLAG ? new $f1aY7 : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$bnyI1(other, function(othValue, othIndex) {
                if (!$bQEzS(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
module.exports = $49878e472ac226f3$var$equalArrays;

});
parcelRegister("f1aY7", function(module, exports) {

var $cetoL = parcelRequire("cetoL");

var $1Iisy = parcelRequire("1Iisy");

var $i6TUM = parcelRequire("i6TUM");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $aeef7521eaa74a72$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $cetoL;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$aeef7521eaa74a72$var$SetCache.prototype.add = $aeef7521eaa74a72$var$SetCache.prototype.push = $1Iisy;
$aeef7521eaa74a72$var$SetCache.prototype.has = $i6TUM;
module.exports = $aeef7521eaa74a72$var$SetCache;

});
parcelRegister("1Iisy", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $13f838320d243ff5$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $13f838320d243ff5$var$setCacheAdd(value) {
    this.__data__.set(value, $13f838320d243ff5$var$HASH_UNDEFINED);
    return this;
}
module.exports = $13f838320d243ff5$var$setCacheAdd;

});

parcelRegister("i6TUM", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $d2f4290b08dabf20$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $d2f4290b08dabf20$var$setCacheHas;

});


parcelRegister("bnyI1", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $848cc43337007d21$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $848cc43337007d21$var$arraySome;

});

parcelRegister("bQEzS", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $8a0406eb34b9bd3c$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $8a0406eb34b9bd3c$var$cacheHas;

});


parcelRegister("8KS6f", function(module, exports) {

var $4Cb5x = parcelRequire("4Cb5x");

var $eQJVi = parcelRequire("eQJVi");

var $1bk3X = parcelRequire("1bk3X");

var $6joxL = parcelRequire("6joxL");

var $kCtBU = parcelRequire("kCtBU");

var $bJBjT = parcelRequire("bJBjT");
/** Used to compose bitmasks for value comparisons. */ var $65fc95b09a31ce83$var$COMPARE_PARTIAL_FLAG = 1, $65fc95b09a31ce83$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $65fc95b09a31ce83$var$boolTag = "[object Boolean]", $65fc95b09a31ce83$var$dateTag = "[object Date]", $65fc95b09a31ce83$var$errorTag = "[object Error]", $65fc95b09a31ce83$var$mapTag = "[object Map]", $65fc95b09a31ce83$var$numberTag = "[object Number]", $65fc95b09a31ce83$var$regexpTag = "[object RegExp]", $65fc95b09a31ce83$var$setTag = "[object Set]", $65fc95b09a31ce83$var$stringTag = "[object String]", $65fc95b09a31ce83$var$symbolTag = "[object Symbol]";
var $65fc95b09a31ce83$var$arrayBufferTag = "[object ArrayBuffer]", $65fc95b09a31ce83$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $65fc95b09a31ce83$var$symbolProto = $4Cb5x ? $4Cb5x.prototype : undefined, $65fc95b09a31ce83$var$symbolValueOf = $65fc95b09a31ce83$var$symbolProto ? $65fc95b09a31ce83$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $65fc95b09a31ce83$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $65fc95b09a31ce83$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $65fc95b09a31ce83$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $eQJVi(object), new $eQJVi(other))) return false;
            return true;
        case $65fc95b09a31ce83$var$boolTag:
        case $65fc95b09a31ce83$var$dateTag:
        case $65fc95b09a31ce83$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $1bk3X(+object, +other);
        case $65fc95b09a31ce83$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $65fc95b09a31ce83$var$regexpTag:
        case $65fc95b09a31ce83$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $65fc95b09a31ce83$var$mapTag:
            var convert = $kCtBU;
        case $65fc95b09a31ce83$var$setTag:
            var isPartial = bitmask & $65fc95b09a31ce83$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $bJBjT);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $65fc95b09a31ce83$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $6joxL(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $65fc95b09a31ce83$var$symbolTag:
            if ($65fc95b09a31ce83$var$symbolValueOf) return $65fc95b09a31ce83$var$symbolValueOf.call(object) == $65fc95b09a31ce83$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $65fc95b09a31ce83$var$equalByTag;

});
parcelRegister("eQJVi", function(module, exports) {

var $eeOBM = parcelRequire("eeOBM");
/** Built-in value references. */ var $acf98b66dddf02d5$var$Uint8Array = $eeOBM.Uint8Array;
module.exports = $acf98b66dddf02d5$var$Uint8Array;

});

parcelRegister("kCtBU", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $f02e534282d3a9b0$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $f02e534282d3a9b0$var$mapToArray;

});

parcelRegister("bJBjT", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $88b0d8a478563514$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $88b0d8a478563514$var$setToArray;

});


parcelRegister("lOYxD", function(module, exports) {

var $7Z0hO = parcelRequire("7Z0hO");
/** Used to compose bitmasks for value comparisons. */ var $fe2d3ac1d7d55d76$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $fe2d3ac1d7d55d76$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $fe2d3ac1d7d55d76$var$hasOwnProperty = $fe2d3ac1d7d55d76$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $fe2d3ac1d7d55d76$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $fe2d3ac1d7d55d76$var$COMPARE_PARTIAL_FLAG, objProps = $7Z0hO(object), objLength = objProps.length, othProps = $7Z0hO(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $fe2d3ac1d7d55d76$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
module.exports = $fe2d3ac1d7d55d76$var$equalObjects;

});
parcelRegister("7Z0hO", function(module, exports) {

var $fJkj3 = parcelRequire("fJkj3");

var $ixRIw = parcelRequire("ixRIw");

var $8R54q = parcelRequire("8R54q");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $5cfe73c4ae44782b$var$getAllKeys(object) {
    return $fJkj3(object, $8R54q, $ixRIw);
}
module.exports = $5cfe73c4ae44782b$var$getAllKeys;

});
parcelRegister("fJkj3", function(module, exports) {

var $99LgV = parcelRequire("99LgV");

var $5V8oz = parcelRequire("5V8oz");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $b73acf63a57aa562$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $5V8oz(object) ? result : $99LgV(result, symbolsFunc(object));
}
module.exports = $b73acf63a57aa562$var$baseGetAllKeys;

});
parcelRegister("99LgV", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $6aa99f89cac0b7cc$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $6aa99f89cac0b7cc$var$arrayPush;

});


parcelRegister("ixRIw", function(module, exports) {

var $dnVqq = parcelRequire("dnVqq");

var $bOAX3 = parcelRequire("bOAX3");
/** Used for built-in method references. */ var $d804fa25f15246df$var$objectProto = Object.prototype;
/** Built-in value references. */ var $d804fa25f15246df$var$propertyIsEnumerable = $d804fa25f15246df$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d804fa25f15246df$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $d804fa25f15246df$var$getSymbols = !$d804fa25f15246df$var$nativeGetSymbols ? $bOAX3 : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $dnVqq($d804fa25f15246df$var$nativeGetSymbols(object), function(symbol) {
        return $d804fa25f15246df$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $d804fa25f15246df$var$getSymbols;

});
parcelRegister("dnVqq", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $9be9f7cdd4a97765$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $9be9f7cdd4a97765$var$arrayFilter;

});

parcelRegister("bOAX3", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $89a106fe5a62a58a$var$stubArray() {
    return [];
}
module.exports = $89a106fe5a62a58a$var$stubArray;

});




parcelRegister("fsqNS", function(module, exports) {

var $4gMuV = parcelRequire("4gMuV");

var $3wCBH = parcelRequire("3wCBH");

var $kA4MR = parcelRequire("kA4MR");

var $i8iSs = parcelRequire("i8iSs");

var $3lsCQ = parcelRequire("3lsCQ");

var $h1l7t = parcelRequire("h1l7t");

var $cNK5K = parcelRequire("cNK5K");
/** `Object#toString` result references. */ var $b40e43279c8931f7$var$mapTag = "[object Map]", $b40e43279c8931f7$var$objectTag = "[object Object]", $b40e43279c8931f7$var$promiseTag = "[object Promise]", $b40e43279c8931f7$var$setTag = "[object Set]", $b40e43279c8931f7$var$weakMapTag = "[object WeakMap]";
var $b40e43279c8931f7$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $b40e43279c8931f7$var$dataViewCtorString = $cNK5K($4gMuV), $b40e43279c8931f7$var$mapCtorString = $cNK5K($3wCBH), $b40e43279c8931f7$var$promiseCtorString = $cNK5K($kA4MR), $b40e43279c8931f7$var$setCtorString = $cNK5K($i8iSs), $b40e43279c8931f7$var$weakMapCtorString = $cNK5K($3lsCQ);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $b40e43279c8931f7$var$getTag = $h1l7t;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($4gMuV && $b40e43279c8931f7$var$getTag(new $4gMuV(new ArrayBuffer(1))) != $b40e43279c8931f7$var$dataViewTag || $3wCBH && $b40e43279c8931f7$var$getTag(new $3wCBH) != $b40e43279c8931f7$var$mapTag || $kA4MR && $b40e43279c8931f7$var$getTag($kA4MR.resolve()) != $b40e43279c8931f7$var$promiseTag || $i8iSs && $b40e43279c8931f7$var$getTag(new $i8iSs) != $b40e43279c8931f7$var$setTag || $3lsCQ && $b40e43279c8931f7$var$getTag(new $3lsCQ) != $b40e43279c8931f7$var$weakMapTag) $b40e43279c8931f7$var$getTag = function(value) {
    var result = $h1l7t(value), Ctor = result == $b40e43279c8931f7$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $cNK5K(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $b40e43279c8931f7$var$dataViewCtorString:
            return $b40e43279c8931f7$var$dataViewTag;
        case $b40e43279c8931f7$var$mapCtorString:
            return $b40e43279c8931f7$var$mapTag;
        case $b40e43279c8931f7$var$promiseCtorString:
            return $b40e43279c8931f7$var$promiseTag;
        case $b40e43279c8931f7$var$setCtorString:
            return $b40e43279c8931f7$var$setTag;
        case $b40e43279c8931f7$var$weakMapCtorString:
            return $b40e43279c8931f7$var$weakMapTag;
    }
    return result;
};
module.exports = $b40e43279c8931f7$var$getTag;

});
parcelRegister("4gMuV", function(module, exports) {

var $6s7tc = parcelRequire("6s7tc");

var $eeOBM = parcelRequire("eeOBM");
/* Built-in method references that are verified to be native. */ var $31be46b4f84f434a$var$DataView = $6s7tc($eeOBM, "DataView");
module.exports = $31be46b4f84f434a$var$DataView;

});

parcelRegister("kA4MR", function(module, exports) {

var $6s7tc = parcelRequire("6s7tc");

var $eeOBM = parcelRequire("eeOBM");
/* Built-in method references that are verified to be native. */ var $efbae212448ce264$var$Promise = $6s7tc($eeOBM, "Promise");
module.exports = $efbae212448ce264$var$Promise;

});

parcelRegister("i8iSs", function(module, exports) {

var $6s7tc = parcelRequire("6s7tc");

var $eeOBM = parcelRequire("eeOBM");
/* Built-in method references that are verified to be native. */ var $d3379dfd122ea853$var$Set = $6s7tc($eeOBM, "Set");
module.exports = $d3379dfd122ea853$var$Set;

});

parcelRegister("3lsCQ", function(module, exports) {

var $6s7tc = parcelRequire("6s7tc");

var $eeOBM = parcelRequire("eeOBM");
/* Built-in method references that are verified to be native. */ var $26f989b387068cb6$var$WeakMap = $6s7tc($eeOBM, "WeakMap");
module.exports = $26f989b387068cb6$var$WeakMap;

});





parcelRegister("554dO", function(module, exports) {

var $9drtK = parcelRequire("9drtK");

var $8R54q = parcelRequire("8R54q");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $3b30b1c06722f062$var$getMatchData(object) {
    var result = $8R54q(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $9drtK(value)
        ];
    }
    return result;
}
module.exports = $3b30b1c06722f062$var$getMatchData;

});
parcelRegister("9drtK", function(module, exports) {

var $kNSK3 = parcelRequire("kNSK3");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $6b5aa4af50cc9b72$var$isStrictComparable(value) {
    return value === value && !$kNSK3(value);
}
module.exports = $6b5aa4af50cc9b72$var$isStrictComparable;

});


parcelRegister("jcxk3", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $dfa8fc7700b0e7c9$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $dfa8fc7700b0e7c9$var$matchesStrictComparable;

});


parcelRegister("gIg4G", function(module, exports) {

var $idJmA = parcelRequire("idJmA");

var $kfiEV = parcelRequire("kfiEV");

var $8igXI = parcelRequire("8igXI");

var $8mr39 = parcelRequire("8mr39");

var $9drtK = parcelRequire("9drtK");

var $jcxk3 = parcelRequire("jcxk3");

var $2ig1k = parcelRequire("2ig1k");
/** Used to compose bitmasks for value comparisons. */ var $0323d381e6d65a26$var$COMPARE_PARTIAL_FLAG = 1, $0323d381e6d65a26$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $0323d381e6d65a26$var$baseMatchesProperty(path, srcValue) {
    if ($8mr39(path) && $9drtK(srcValue)) return $jcxk3($2ig1k(path), srcValue);
    return function(object) {
        var objValue = $kfiEV(object, path);
        return objValue === undefined && objValue === srcValue ? $8igXI(object, path) : $idJmA(srcValue, objValue, $0323d381e6d65a26$var$COMPARE_PARTIAL_FLAG | $0323d381e6d65a26$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $0323d381e6d65a26$var$baseMatchesProperty;

});
parcelRegister("kfiEV", function(module, exports) {

var $3kV52 = parcelRequire("3kV52");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $ebd3aea761354996$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $3kV52(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $ebd3aea761354996$var$get;

});
parcelRegister("3kV52", function(module, exports) {

var $kRpsE = parcelRequire("kRpsE");

var $2ig1k = parcelRequire("2ig1k");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $26df844e2fd81e1b$var$baseGet(object, path) {
    path = $kRpsE(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$2ig1k(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $26df844e2fd81e1b$var$baseGet;

});
parcelRegister("kRpsE", function(module, exports) {

var $5V8oz = parcelRequire("5V8oz");

var $8mr39 = parcelRequire("8mr39");

var $ftGgb = parcelRequire("ftGgb");

var $28W6j = parcelRequire("28W6j");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $f2fc81f232516dbe$var$castPath(value, object) {
    if ($5V8oz(value)) return value;
    return $8mr39(value, object) ? [
        value
    ] : $ftGgb($28W6j(value));
}
module.exports = $f2fc81f232516dbe$var$castPath;

});
parcelRegister("8mr39", function(module, exports) {

var $5V8oz = parcelRequire("5V8oz");

var $7xC8V = parcelRequire("7xC8V");
/** Used to match property names within property paths. */ var $61655c51903cb085$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $61655c51903cb085$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $61655c51903cb085$var$isKey(value, object) {
    if ($5V8oz(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $7xC8V(value)) return true;
    return $61655c51903cb085$var$reIsPlainProp.test(value) || !$61655c51903cb085$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $61655c51903cb085$var$isKey;

});
parcelRegister("7xC8V", function(module, exports) {

var $h1l7t = parcelRequire("h1l7t");

var $hcK5n = parcelRequire("hcK5n");
/** `Object#toString` result references. */ var $57d933e0496b031f$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $57d933e0496b031f$var$isSymbol(value) {
    return typeof value == "symbol" || $hcK5n(value) && $h1l7t(value) == $57d933e0496b031f$var$symbolTag;
}
module.exports = $57d933e0496b031f$var$isSymbol;

});


parcelRegister("ftGgb", function(module, exports) {

var $ijGzl = parcelRequire("ijGzl");
/** Used to match property names within property paths. */ var $b44a5867e06d04b0$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $b44a5867e06d04b0$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $b44a5867e06d04b0$var$stringToPath = $ijGzl(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($b44a5867e06d04b0$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($b44a5867e06d04b0$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
module.exports = $b44a5867e06d04b0$var$stringToPath;

});
parcelRegister("ijGzl", function(module, exports) {

var $5UXbV = parcelRequire("5UXbV");
/** Used as the maximum memoize cache size. */ var $d55b05a6ed7e5a1a$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $d55b05a6ed7e5a1a$var$memoizeCapped(func) {
    var result = $5UXbV(func, function(key) {
        if (cache.size === $d55b05a6ed7e5a1a$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $d55b05a6ed7e5a1a$var$memoizeCapped;

});
parcelRegister("5UXbV", function(module, exports) {

var $cetoL = parcelRequire("cetoL");
/** Error message constants. */ var $44f018e49cee3b18$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $44f018e49cee3b18$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($44f018e49cee3b18$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($44f018e49cee3b18$var$memoize.Cache || $cetoL);
    return memoized;
}
// Expose `MapCache`.
$44f018e49cee3b18$var$memoize.Cache = $cetoL;
module.exports = $44f018e49cee3b18$var$memoize;

});



parcelRegister("28W6j", function(module, exports) {

var $95EYe = parcelRequire("95EYe");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $18f965bcdccf089e$var$toString(value) {
    return value == null ? "" : $95EYe(value);
}
module.exports = $18f965bcdccf089e$var$toString;

});
parcelRegister("95EYe", function(module, exports) {

var $4Cb5x = parcelRequire("4Cb5x");

var $cIKPk = parcelRequire("cIKPk");

var $5V8oz = parcelRequire("5V8oz");

var $7xC8V = parcelRequire("7xC8V");
/** Used as references for various `Number` constants. */ var $69e45c952d8e2d54$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $69e45c952d8e2d54$var$symbolProto = $4Cb5x ? $4Cb5x.prototype : undefined, $69e45c952d8e2d54$var$symbolToString = $69e45c952d8e2d54$var$symbolProto ? $69e45c952d8e2d54$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $69e45c952d8e2d54$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($5V8oz(value)) // Recursively convert values (susceptible to call stack limits).
    return $cIKPk(value, $69e45c952d8e2d54$var$baseToString) + "";
    if ($7xC8V(value)) return $69e45c952d8e2d54$var$symbolToString ? $69e45c952d8e2d54$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$69e45c952d8e2d54$var$INFINITY ? "-0" : result;
}
module.exports = $69e45c952d8e2d54$var$baseToString;

});



parcelRegister("2ig1k", function(module, exports) {

var $7xC8V = parcelRequire("7xC8V");
/** Used as references for various `Number` constants. */ var $1ab9b08710e855e0$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $1ab9b08710e855e0$var$toKey(value) {
    if (typeof value == "string" || $7xC8V(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$1ab9b08710e855e0$var$INFINITY ? "-0" : result;
}
module.exports = $1ab9b08710e855e0$var$toKey;

});



parcelRegister("8igXI", function(module, exports) {

var $jHnke = parcelRequire("jHnke");

var $5B9Ha = parcelRequire("5B9Ha");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $609d297d2a47e6cf$var$hasIn(object, path) {
    return object != null && $5B9Ha(object, path, $jHnke);
}
module.exports = $609d297d2a47e6cf$var$hasIn;

});
parcelRegister("jHnke", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $e574206325b2fc3f$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $e574206325b2fc3f$var$baseHasIn;

});

parcelRegister("5B9Ha", function(module, exports) {

var $kRpsE = parcelRequire("kRpsE");

var $4rbI4 = parcelRequire("4rbI4");

var $5V8oz = parcelRequire("5V8oz");

var $74Ail = parcelRequire("74Ail");

var $2zEBJ = parcelRequire("2zEBJ");

var $2ig1k = parcelRequire("2ig1k");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $4137edbcde41e9de$var$hasPath(object, path, hasFunc) {
    path = $kRpsE(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $2ig1k(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $2zEBJ(length) && $74Ail(key, length) && ($5V8oz(object) || $4rbI4(object));
}
module.exports = $4137edbcde41e9de$var$hasPath;

});



parcelRegister("lIVno", function(module, exports) {

var $eQAZV = parcelRequire("eQAZV");

var $egHxl = parcelRequire("egHxl");

var $8mr39 = parcelRequire("8mr39");

var $2ig1k = parcelRequire("2ig1k");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $fd0a36c46ef38492$var$property(path) {
    return $8mr39(path) ? $eQAZV($2ig1k(path)) : $egHxl(path);
}
module.exports = $fd0a36c46ef38492$var$property;

});
parcelRegister("eQAZV", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $acf29f05ebf1028f$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $acf29f05ebf1028f$var$baseProperty;

});

parcelRegister("egHxl", function(module, exports) {

var $3kV52 = parcelRequire("3kV52");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $a63454d5011872be$var$basePropertyDeep(path) {
    return function(object) {
        return $3kV52(object, path);
    };
}
module.exports = $a63454d5011872be$var$basePropertyDeep;

});



parcelRegister("b6ejR", function(module, exports) {

var $gl8yj = parcelRequire("gl8yj");

var $iiJxK = parcelRequire("iiJxK");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $814b5cc7a05c222a$var$baseMap(collection, iteratee) {
    var index = -1, result = $iiJxK(collection) ? Array(collection.length) : [];
    $gl8yj(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = $814b5cc7a05c222a$var$baseMap;

});
parcelRegister("gl8yj", function(module, exports) {

var $4V1MN = parcelRequire("4V1MN");

var $aJmOg = parcelRequire("aJmOg");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $be553dd7dece516c$var$baseEach = $aJmOg($4V1MN);
module.exports = $be553dd7dece516c$var$baseEach;

});
parcelRegister("aJmOg", function(module, exports) {

var $iiJxK = parcelRequire("iiJxK");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $7cffcce57718073b$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$iiJxK(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $7cffcce57718073b$var$createBaseEach;

});





parcelRegister("2Ku1G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mergeClasses = undefined;

var $aZveu = parcelRequire("aZveu");
var $20072b3927ae81ec$var$_forOwn3 = $20072b3927ae81ec$var$_interopRequireDefault($aZveu);

var $hv8IB = parcelRequire("hv8IB");
var $20072b3927ae81ec$var$_cloneDeep3 = $20072b3927ae81ec$var$_interopRequireDefault($hv8IB);
var $20072b3927ae81ec$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $20072b3927ae81ec$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $20072b3927ae81ec$var$mergeClasses = module.exports.mergeClasses = function mergeClasses(classes) {
    var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var styles = classes.default && (0, $20072b3927ae81ec$var$_cloneDeep3.default)(classes.default) || {};
    activeNames.map(function(name) {
        var toMerge = classes[name];
        if (toMerge) (0, $20072b3927ae81ec$var$_forOwn3.default)(toMerge, function(value, key) {
            if (!styles[key]) styles[key] = {};
            styles[key] = $20072b3927ae81ec$var$_extends({}, styles[key], toMerge[key]);
        });
        return name;
    });
    return styles;
};
module.exports.default = $20072b3927ae81ec$var$mergeClasses;

});
parcelRegister("hv8IB", function(module, exports) {

var $6ecZ7 = parcelRequire("6ecZ7");
/** Used to compose bitmasks for cloning. */ var $cbdc18328516372c$var$CLONE_DEEP_FLAG = 1, $cbdc18328516372c$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $cbdc18328516372c$var$cloneDeep(value) {
    return $6ecZ7(value, $cbdc18328516372c$var$CLONE_DEEP_FLAG | $cbdc18328516372c$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $cbdc18328516372c$var$cloneDeep;

});
parcelRegister("6ecZ7", function(module, exports) {

var $jIdTJ = parcelRequire("jIdTJ");

var $eQpse = parcelRequire("eQpse");

var $i1VlX = parcelRequire("i1VlX");

var $7rFSL = parcelRequire("7rFSL");

var $aEPhd = parcelRequire("aEPhd");

var $lJ72B = parcelRequire("lJ72B");

var $15W3B = parcelRequire("15W3B");

var $8pRFT = parcelRequire("8pRFT");

var $32s3N = parcelRequire("32s3N");

var $7Z0hO = parcelRequire("7Z0hO");

var $lxldT = parcelRequire("lxldT");

var $fsqNS = parcelRequire("fsqNS");

var $ddfRu = parcelRequire("ddfRu");

var $7IFLM = parcelRequire("7IFLM");

var $hEGb3 = parcelRequire("hEGb3");

var $5V8oz = parcelRequire("5V8oz");

var $9e2tS = parcelRequire("9e2tS");

var $47S1q = parcelRequire("47S1q");

var $kNSK3 = parcelRequire("kNSK3");

var $4O6CR = parcelRequire("4O6CR");

var $8R54q = parcelRequire("8R54q");

var $2bN3M = parcelRequire("2bN3M");
/** Used to compose bitmasks for cloning. */ var $488e1f5e07a1774f$var$CLONE_DEEP_FLAG = 1, $488e1f5e07a1774f$var$CLONE_FLAT_FLAG = 2, $488e1f5e07a1774f$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $488e1f5e07a1774f$var$argsTag = "[object Arguments]", $488e1f5e07a1774f$var$arrayTag = "[object Array]", $488e1f5e07a1774f$var$boolTag = "[object Boolean]", $488e1f5e07a1774f$var$dateTag = "[object Date]", $488e1f5e07a1774f$var$errorTag = "[object Error]", $488e1f5e07a1774f$var$funcTag = "[object Function]", $488e1f5e07a1774f$var$genTag = "[object GeneratorFunction]", $488e1f5e07a1774f$var$mapTag = "[object Map]", $488e1f5e07a1774f$var$numberTag = "[object Number]", $488e1f5e07a1774f$var$objectTag = "[object Object]", $488e1f5e07a1774f$var$regexpTag = "[object RegExp]", $488e1f5e07a1774f$var$setTag = "[object Set]", $488e1f5e07a1774f$var$stringTag = "[object String]", $488e1f5e07a1774f$var$symbolTag = "[object Symbol]", $488e1f5e07a1774f$var$weakMapTag = "[object WeakMap]";
var $488e1f5e07a1774f$var$arrayBufferTag = "[object ArrayBuffer]", $488e1f5e07a1774f$var$dataViewTag = "[object DataView]", $488e1f5e07a1774f$var$float32Tag = "[object Float32Array]", $488e1f5e07a1774f$var$float64Tag = "[object Float64Array]", $488e1f5e07a1774f$var$int8Tag = "[object Int8Array]", $488e1f5e07a1774f$var$int16Tag = "[object Int16Array]", $488e1f5e07a1774f$var$int32Tag = "[object Int32Array]", $488e1f5e07a1774f$var$uint8Tag = "[object Uint8Array]", $488e1f5e07a1774f$var$uint8ClampedTag = "[object Uint8ClampedArray]", $488e1f5e07a1774f$var$uint16Tag = "[object Uint16Array]", $488e1f5e07a1774f$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $488e1f5e07a1774f$var$cloneableTags = {};
$488e1f5e07a1774f$var$cloneableTags[$488e1f5e07a1774f$var$argsTag] = $488e1f5e07a1774f$var$cloneableTags[$488e1f5e07a1774f$var$arrayTag] = $488e1f5e07a1774f$var$cloneableTags[$488e1f5e07a1774f$var$arrayBufferTag] = $488e1f5e07a1774f$var$cloneableTags[$488e1f5e07a1774f$var$dataViewTag] = $488e1f5e07a1774f$var$cloneableTags[$488e1f5e07a1774f$var$boolTag] = $488e1f5e07a1774f$var$cloneableTags[$488e1f5e07a1774f$var$dateTag] = $488e1f5e07a1774f$var$cloneableTags[$488e1f5e07a1774f$var$float32Tag] = $488e1f5e07a1774f$var$cloneableTags[$488e1f5e07a1774f$var$float64Tag] = $488e1f5e07a1774f$var$cloneableTags[$488e1f5e07a1774f$var$int8Tag] = $488e1f5e07a1774f$var$cloneableTags[$488e1f5e07a1774f$var$int16Tag] = $488e1f5e07a1774f$var$cloneableTags[$488e1f5e07a1774f$var$int32Tag] = $488e1f5e07a1774f$var$cloneableTags[$488e1f5e07a1774f$var$mapTag] = $488e1f5e07a1774f$var$cloneableTags[$488e1f5e07a1774f$var$numberTag] = $488e1f5e07a1774f$var$cloneableTags[$488e1f5e07a1774f$var$objectTag] = $488e1f5e07a1774f$var$cloneableTags[$488e1f5e07a1774f$var$regexpTag] = $488e1f5e07a1774f$var$cloneableTags[$488e1f5e07a1774f$var$setTag] = $488e1f5e07a1774f$var$cloneableTags[$488e1f5e07a1774f$var$stringTag] = $488e1f5e07a1774f$var$cloneableTags[$488e1f5e07a1774f$var$symbolTag] = $488e1f5e07a1774f$var$cloneableTags[$488e1f5e07a1774f$var$uint8Tag] = $488e1f5e07a1774f$var$cloneableTags[$488e1f5e07a1774f$var$uint8ClampedTag] = $488e1f5e07a1774f$var$cloneableTags[$488e1f5e07a1774f$var$uint16Tag] = $488e1f5e07a1774f$var$cloneableTags[$488e1f5e07a1774f$var$uint32Tag] = true;
$488e1f5e07a1774f$var$cloneableTags[$488e1f5e07a1774f$var$errorTag] = $488e1f5e07a1774f$var$cloneableTags[$488e1f5e07a1774f$var$funcTag] = $488e1f5e07a1774f$var$cloneableTags[$488e1f5e07a1774f$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $488e1f5e07a1774f$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $488e1f5e07a1774f$var$CLONE_DEEP_FLAG, isFlat = bitmask & $488e1f5e07a1774f$var$CLONE_FLAT_FLAG, isFull = bitmask & $488e1f5e07a1774f$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$kNSK3(value)) return value;
    var isArr = $5V8oz(value);
    if (isArr) {
        result = $ddfRu(value);
        if (!isDeep) return $15W3B(value, result);
    } else {
        var tag = $fsqNS(value), isFunc = tag == $488e1f5e07a1774f$var$funcTag || tag == $488e1f5e07a1774f$var$genTag;
        if ($9e2tS(value)) return $lJ72B(value, isDeep);
        if (tag == $488e1f5e07a1774f$var$objectTag || tag == $488e1f5e07a1774f$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $hEGb3(value);
            if (!isDeep) return isFlat ? $32s3N(value, $aEPhd(result, value)) : $8pRFT(value, $7rFSL(result, value));
        } else {
            if (!$488e1f5e07a1774f$var$cloneableTags[tag]) return object ? value : {};
            result = $7IFLM(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $jIdTJ);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($4O6CR(value)) value.forEach(function(subValue) {
        result.add($488e1f5e07a1774f$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($47S1q(value)) value.forEach(function(subValue, key) {
        result.set(key, $488e1f5e07a1774f$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $lxldT : $7Z0hO : isFlat ? $2bN3M : $8R54q;
    var props = isArr ? undefined : keysFunc(value);
    $eQpse(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $i1VlX(result, key, $488e1f5e07a1774f$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $488e1f5e07a1774f$var$baseClone;

});
parcelRegister("eQpse", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $ace9aab6e0cb1ac1$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $ace9aab6e0cb1ac1$var$arrayEach;

});

parcelRegister("i1VlX", function(module, exports) {

var $8tq3x = parcelRequire("8tq3x");

var $1bk3X = parcelRequire("1bk3X");
/** Used for built-in method references. */ var $d204cf2605223b7c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d204cf2605223b7c$var$hasOwnProperty = $d204cf2605223b7c$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $d204cf2605223b7c$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($d204cf2605223b7c$var$hasOwnProperty.call(object, key) && $1bk3X(objValue, value)) || value === undefined && !(key in object)) $8tq3x(object, key, value);
}
module.exports = $d204cf2605223b7c$var$assignValue;

});
parcelRegister("8tq3x", function(module, exports) {

var $2FweT = parcelRequire("2FweT");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $62b53e562f4b98b4$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $2FweT) $2FweT(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
module.exports = $62b53e562f4b98b4$var$baseAssignValue;

});
parcelRegister("2FweT", function(module, exports) {

var $6s7tc = parcelRequire("6s7tc");
var $1f186b25dba4ac63$var$defineProperty = function() {
    try {
        var func = $6s7tc(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
module.exports = $1f186b25dba4ac63$var$defineProperty;

});



parcelRegister("7rFSL", function(module, exports) {

var $i4R0b = parcelRequire("i4R0b");

var $8R54q = parcelRequire("8R54q");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $56bb8afa75cadf77$var$baseAssign(object, source) {
    return object && $i4R0b(source, $8R54q(source), object);
}
module.exports = $56bb8afa75cadf77$var$baseAssign;

});
parcelRegister("i4R0b", function(module, exports) {

var $i1VlX = parcelRequire("i1VlX");

var $8tq3x = parcelRequire("8tq3x");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $d291b6d0ff004a77$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $8tq3x(object, key, newValue);
        else $i1VlX(object, key, newValue);
    }
    return object;
}
module.exports = $d291b6d0ff004a77$var$copyObject;

});


parcelRegister("aEPhd", function(module, exports) {

var $i4R0b = parcelRequire("i4R0b");

var $2bN3M = parcelRequire("2bN3M");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $7c256a4f195cecf6$var$baseAssignIn(object, source) {
    return object && $i4R0b(source, $2bN3M(source), object);
}
module.exports = $7c256a4f195cecf6$var$baseAssignIn;

});
parcelRegister("2bN3M", function(module, exports) {

var $hopFG = parcelRequire("hopFG");

var $5yY3y = parcelRequire("5yY3y");

var $iiJxK = parcelRequire("iiJxK");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $1982aa220a09d7c9$var$keysIn(object) {
    return $iiJxK(object) ? $hopFG(object, true) : $5yY3y(object);
}
module.exports = $1982aa220a09d7c9$var$keysIn;

});
parcelRegister("5yY3y", function(module, exports) {

var $kNSK3 = parcelRequire("kNSK3");

var $dWAd9 = parcelRequire("dWAd9");

var $gHLVF = parcelRequire("gHLVF");
/** Used for built-in method references. */ var $40ceb6abf6641c74$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $40ceb6abf6641c74$var$hasOwnProperty = $40ceb6abf6641c74$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $40ceb6abf6641c74$var$baseKeysIn(object) {
    if (!$kNSK3(object)) return $gHLVF(object);
    var isProto = $dWAd9(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$40ceb6abf6641c74$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = $40ceb6abf6641c74$var$baseKeysIn;

});
parcelRegister("gHLVF", function(module, exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $c295d734764abe56$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = $c295d734764abe56$var$nativeKeysIn;

});




parcelRegister("lJ72B", function(module, exports) {

var $eeOBM = parcelRequire("eeOBM");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $eeOBM.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("15W3B", function(module, exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $0cc34aff5d5f6f41$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = $0cc34aff5d5f6f41$var$copyArray;

});

parcelRegister("8pRFT", function(module, exports) {

var $i4R0b = parcelRequire("i4R0b");

var $ixRIw = parcelRequire("ixRIw");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $620a4b34b2487341$var$copySymbols(source, object) {
    return $i4R0b(source, $ixRIw(source), object);
}
module.exports = $620a4b34b2487341$var$copySymbols;

});

parcelRegister("32s3N", function(module, exports) {

var $i4R0b = parcelRequire("i4R0b");

var $7YRaf = parcelRequire("7YRaf");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $2367532bb5354cbc$var$copySymbolsIn(source, object) {
    return $i4R0b(source, $7YRaf(source), object);
}
module.exports = $2367532bb5354cbc$var$copySymbolsIn;

});
parcelRegister("7YRaf", function(module, exports) {

var $99LgV = parcelRequire("99LgV");

var $gKq7A = parcelRequire("gKq7A");

var $ixRIw = parcelRequire("ixRIw");

var $bOAX3 = parcelRequire("bOAX3");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5cf7604d8fccbc70$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $5cf7604d8fccbc70$var$getSymbolsIn = !$5cf7604d8fccbc70$var$nativeGetSymbols ? $bOAX3 : function(object) {
    var result = [];
    while(object){
        $99LgV(result, $ixRIw(object));
        object = $gKq7A(object);
    }
    return result;
};
module.exports = $5cf7604d8fccbc70$var$getSymbolsIn;

});


parcelRegister("lxldT", function(module, exports) {

var $fJkj3 = parcelRequire("fJkj3");

var $7YRaf = parcelRequire("7YRaf");

var $2bN3M = parcelRequire("2bN3M");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $fadd247f0eac1696$var$getAllKeysIn(object) {
    return $fJkj3(object, $2bN3M, $7YRaf);
}
module.exports = $fadd247f0eac1696$var$getAllKeysIn;

});

parcelRegister("ddfRu", function(module, exports) {
/** Used for built-in method references. */ var $99e8cb10ae9ecf87$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $99e8cb10ae9ecf87$var$hasOwnProperty = $99e8cb10ae9ecf87$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $99e8cb10ae9ecf87$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && $99e8cb10ae9ecf87$var$hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $99e8cb10ae9ecf87$var$initCloneArray;

});

parcelRegister("7IFLM", function(module, exports) {

var $1ED0S = parcelRequire("1ED0S");

var $5f7wf = parcelRequire("5f7wf");

var $hkNV4 = parcelRequire("hkNV4");

var $i8Vlg = parcelRequire("i8Vlg");

var $edrdn = parcelRequire("edrdn");
/** `Object#toString` result references. */ var $59ed0b0fd181778b$var$boolTag = "[object Boolean]", $59ed0b0fd181778b$var$dateTag = "[object Date]", $59ed0b0fd181778b$var$mapTag = "[object Map]", $59ed0b0fd181778b$var$numberTag = "[object Number]", $59ed0b0fd181778b$var$regexpTag = "[object RegExp]", $59ed0b0fd181778b$var$setTag = "[object Set]", $59ed0b0fd181778b$var$stringTag = "[object String]", $59ed0b0fd181778b$var$symbolTag = "[object Symbol]";
var $59ed0b0fd181778b$var$arrayBufferTag = "[object ArrayBuffer]", $59ed0b0fd181778b$var$dataViewTag = "[object DataView]", $59ed0b0fd181778b$var$float32Tag = "[object Float32Array]", $59ed0b0fd181778b$var$float64Tag = "[object Float64Array]", $59ed0b0fd181778b$var$int8Tag = "[object Int8Array]", $59ed0b0fd181778b$var$int16Tag = "[object Int16Array]", $59ed0b0fd181778b$var$int32Tag = "[object Int32Array]", $59ed0b0fd181778b$var$uint8Tag = "[object Uint8Array]", $59ed0b0fd181778b$var$uint8ClampedTag = "[object Uint8ClampedArray]", $59ed0b0fd181778b$var$uint16Tag = "[object Uint16Array]", $59ed0b0fd181778b$var$uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $59ed0b0fd181778b$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $59ed0b0fd181778b$var$arrayBufferTag:
            return $1ED0S(object);
        case $59ed0b0fd181778b$var$boolTag:
        case $59ed0b0fd181778b$var$dateTag:
            return new Ctor(+object);
        case $59ed0b0fd181778b$var$dataViewTag:
            return $5f7wf(object, isDeep);
        case $59ed0b0fd181778b$var$float32Tag:
        case $59ed0b0fd181778b$var$float64Tag:
        case $59ed0b0fd181778b$var$int8Tag:
        case $59ed0b0fd181778b$var$int16Tag:
        case $59ed0b0fd181778b$var$int32Tag:
        case $59ed0b0fd181778b$var$uint8Tag:
        case $59ed0b0fd181778b$var$uint8ClampedTag:
        case $59ed0b0fd181778b$var$uint16Tag:
        case $59ed0b0fd181778b$var$uint32Tag:
            return $edrdn(object, isDeep);
        case $59ed0b0fd181778b$var$mapTag:
            return new Ctor;
        case $59ed0b0fd181778b$var$numberTag:
        case $59ed0b0fd181778b$var$stringTag:
            return new Ctor(object);
        case $59ed0b0fd181778b$var$regexpTag:
            return $hkNV4(object);
        case $59ed0b0fd181778b$var$setTag:
            return new Ctor;
        case $59ed0b0fd181778b$var$symbolTag:
            return $i8Vlg(object);
    }
}
module.exports = $59ed0b0fd181778b$var$initCloneByTag;

});
parcelRegister("1ED0S", function(module, exports) {

var $eQJVi = parcelRequire("eQJVi");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $1347ca1346a7abd8$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $eQJVi(result).set(new $eQJVi(arrayBuffer));
    return result;
}
module.exports = $1347ca1346a7abd8$var$cloneArrayBuffer;

});

parcelRegister("5f7wf", function(module, exports) {

var $1ED0S = parcelRequire("1ED0S");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $3d142f9575e8ce3b$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $1ED0S(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $3d142f9575e8ce3b$var$cloneDataView;

});

parcelRegister("hkNV4", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $c9eb06e4cb49031d$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $c9eb06e4cb49031d$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $c9eb06e4cb49031d$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $c9eb06e4cb49031d$var$cloneRegExp;

});

parcelRegister("i8Vlg", function(module, exports) {

var $4Cb5x = parcelRequire("4Cb5x");
/** Used to convert symbols to primitives and strings. */ var $d3557443345bd080$var$symbolProto = $4Cb5x ? $4Cb5x.prototype : undefined, $d3557443345bd080$var$symbolValueOf = $d3557443345bd080$var$symbolProto ? $d3557443345bd080$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $d3557443345bd080$var$cloneSymbol(symbol) {
    return $d3557443345bd080$var$symbolValueOf ? Object($d3557443345bd080$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $d3557443345bd080$var$cloneSymbol;

});

parcelRegister("edrdn", function(module, exports) {

var $1ED0S = parcelRequire("1ED0S");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $a59763e32269c41e$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $1ED0S(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = $a59763e32269c41e$var$cloneTypedArray;

});


parcelRegister("hEGb3", function(module, exports) {

var $lG1oL = parcelRequire("lG1oL");

var $gKq7A = parcelRequire("gKq7A");

var $dWAd9 = parcelRequire("dWAd9");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $cda6e39a62d375c3$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !$dWAd9(object) ? $lG1oL($gKq7A(object)) : {};
}
module.exports = $cda6e39a62d375c3$var$initCloneObject;

});
parcelRegister("lG1oL", function(module, exports) {

var $kNSK3 = parcelRequire("kNSK3");
/** Built-in value references. */ var $fc7e9ae6c81273cb$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $fc7e9ae6c81273cb$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$kNSK3(proto)) return {};
        if ($fc7e9ae6c81273cb$var$objectCreate) return $fc7e9ae6c81273cb$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = $fc7e9ae6c81273cb$var$baseCreate;

});


parcelRegister("47S1q", function(module, exports) {

var $9knPZ = parcelRequire("9knPZ");

var $cLhdb = parcelRequire("cLhdb");

var $fwpsA = parcelRequire("fwpsA");
/* Node.js helper references. */ var $3011b888d3d5b1e0$var$nodeIsMap = $fwpsA && $fwpsA.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $3011b888d3d5b1e0$var$isMap = $3011b888d3d5b1e0$var$nodeIsMap ? $cLhdb($3011b888d3d5b1e0$var$nodeIsMap) : $9knPZ;
module.exports = $3011b888d3d5b1e0$var$isMap;

});
parcelRegister("9knPZ", function(module, exports) {

var $fsqNS = parcelRequire("fsqNS");

var $hcK5n = parcelRequire("hcK5n");
/** `Object#toString` result references. */ var $6ca878f5b8ed5946$var$mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $6ca878f5b8ed5946$var$baseIsMap(value) {
    return $hcK5n(value) && $fsqNS(value) == $6ca878f5b8ed5946$var$mapTag;
}
module.exports = $6ca878f5b8ed5946$var$baseIsMap;

});


parcelRegister("4O6CR", function(module, exports) {

var $1vSgG = parcelRequire("1vSgG");

var $cLhdb = parcelRequire("cLhdb");

var $fwpsA = parcelRequire("fwpsA");
/* Node.js helper references. */ var $3800f8b1fede3bc3$var$nodeIsSet = $fwpsA && $fwpsA.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $3800f8b1fede3bc3$var$isSet = $3800f8b1fede3bc3$var$nodeIsSet ? $cLhdb($3800f8b1fede3bc3$var$nodeIsSet) : $1vSgG;
module.exports = $3800f8b1fede3bc3$var$isSet;

});
parcelRegister("1vSgG", function(module, exports) {

var $fsqNS = parcelRequire("fsqNS");

var $hcK5n = parcelRequire("hcK5n");
/** `Object#toString` result references. */ var $11a2c8315c7a4a7a$var$setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $11a2c8315c7a4a7a$var$baseIsSet(value) {
    return $hcK5n(value) && $fsqNS(value) == $11a2c8315c7a4a7a$var$setTag;
}
module.exports = $11a2c8315c7a4a7a$var$baseIsSet;

});





parcelRegister("S5QiM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.autoprefix = undefined;

var $aZveu = parcelRequire("aZveu");
var $0a2993799754153b$var$_forOwn3 = $0a2993799754153b$var$_interopRequireDefault($aZveu);
var $0a2993799754153b$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $0a2993799754153b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $0a2993799754153b$var$transforms = {
    borderRadius: function borderRadius(value) {
        return {
            msBorderRadius: value,
            MozBorderRadius: value,
            OBorderRadius: value,
            WebkitBorderRadius: value,
            borderRadius: value
        };
    },
    boxShadow: function boxShadow(value) {
        return {
            msBoxShadow: value,
            MozBoxShadow: value,
            OBoxShadow: value,
            WebkitBoxShadow: value,
            boxShadow: value
        };
    },
    userSelect: function userSelect(value) {
        return {
            WebkitTouchCallout: value,
            KhtmlUserSelect: value,
            MozUserSelect: value,
            msUserSelect: value,
            WebkitUserSelect: value,
            userSelect: value
        };
    },
    flex: function flex(value) {
        return {
            WebkitBoxFlex: value,
            MozBoxFlex: value,
            WebkitFlex: value,
            msFlex: value,
            flex: value
        };
    },
    flexBasis: function flexBasis(value) {
        return {
            WebkitFlexBasis: value,
            flexBasis: value
        };
    },
    justifyContent: function justifyContent(value) {
        return {
            WebkitJustifyContent: value,
            justifyContent: value
        };
    },
    transition: function transition(value) {
        return {
            msTransition: value,
            MozTransition: value,
            OTransition: value,
            WebkitTransition: value,
            transition: value
        };
    },
    transform: function transform(value) {
        return {
            msTransform: value,
            MozTransform: value,
            OTransform: value,
            WebkitTransform: value,
            transform: value
        };
    },
    absolute: function absolute(value) {
        var direction = value && value.split(" ");
        return {
            position: "absolute",
            top: direction && direction[0],
            right: direction && direction[1],
            bottom: direction && direction[2],
            left: direction && direction[3]
        };
    },
    extend: function extend(name, otherElementStyles) {
        var otherStyle = otherElementStyles[name];
        if (otherStyle) return otherStyle;
        return {
            "extend": name
        };
    }
};
var $0a2993799754153b$var$autoprefix = module.exports.autoprefix = function autoprefix(elements) {
    var prefixed = {};
    (0, $0a2993799754153b$var$_forOwn3.default)(elements, function(styles, element) {
        var expanded = {};
        (0, $0a2993799754153b$var$_forOwn3.default)(styles, function(value, key) {
            var transform = $0a2993799754153b$var$transforms[key];
            if (transform) expanded = $0a2993799754153b$var$_extends({}, expanded, transform(value));
            else expanded[key] = value;
        });
        prefixed[element] = expanded;
    });
    return prefixed;
};
module.exports.default = $0a2993799754153b$var$autoprefix;

});

parcelRegister("bPRui", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hover = undefined;
var $89ddf2a62c167126$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $8NFma = parcelRequire("8NFma");
var $89ddf2a62c167126$var$_react2 = $89ddf2a62c167126$var$_interopRequireDefault($8NFma);
function $89ddf2a62c167126$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $89ddf2a62c167126$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $89ddf2a62c167126$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $89ddf2a62c167126$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $89ddf2a62c167126$var$hover = module.exports.hover = function hover(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "span";
    return function(_React$Component) {
        $89ddf2a62c167126$var$_inherits(Hover, _React$Component);
        function Hover() {
            var _ref;
            var _temp, _this, _ret;
            $89ddf2a62c167126$var$_classCallCheck(this, Hover);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $89ddf2a62c167126$var$_possibleConstructorReturn(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                hover: false
            }, _this.handleMouseOver = function() {
                return _this.setState({
                    hover: true
                });
            }, _this.handleMouseOut = function() {
                return _this.setState({
                    hover: false
                });
            }, _this.render = function() {
                return $89ddf2a62c167126$var$_react2.default.createElement(Span, {
                    onMouseOver: _this.handleMouseOver,
                    onMouseOut: _this.handleMouseOut
                }, $89ddf2a62c167126$var$_react2.default.createElement(Component, $89ddf2a62c167126$var$_extends({}, _this.props, _this.state)));
            }, _temp), $89ddf2a62c167126$var$_possibleConstructorReturn(_this, _ret);
        }
        return Hover;
    }($89ddf2a62c167126$var$_react2.default.Component);
};
module.exports.default = $89ddf2a62c167126$var$hover;

});

parcelRegister("j8O9v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.active = undefined;
var $def5aadff09153b6$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $8NFma = parcelRequire("8NFma");
var $def5aadff09153b6$var$_react2 = $def5aadff09153b6$var$_interopRequireDefault($8NFma);
function $def5aadff09153b6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $def5aadff09153b6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $def5aadff09153b6$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $def5aadff09153b6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $def5aadff09153b6$var$active = module.exports.active = function active(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "span";
    return function(_React$Component) {
        $def5aadff09153b6$var$_inherits(Active, _React$Component);
        function Active() {
            var _ref;
            var _temp, _this, _ret;
            $def5aadff09153b6$var$_classCallCheck(this, Active);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $def5aadff09153b6$var$_possibleConstructorReturn(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                active: false
            }, _this.handleMouseDown = function() {
                return _this.setState({
                    active: true
                });
            }, _this.handleMouseUp = function() {
                return _this.setState({
                    active: false
                });
            }, _this.render = function() {
                return $def5aadff09153b6$var$_react2.default.createElement(Span, {
                    onMouseDown: _this.handleMouseDown,
                    onMouseUp: _this.handleMouseUp
                }, $def5aadff09153b6$var$_react2.default.createElement(Component, $def5aadff09153b6$var$_extends({}, _this.props, _this.state)));
            }, _temp), $def5aadff09153b6$var$_possibleConstructorReturn(_this, _ret);
        }
        return Active;
    }($def5aadff09153b6$var$_react2.default.Component);
};
module.exports.default = $def5aadff09153b6$var$active;

});

parcelRegister("2YJVw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $22b4cf73337ccf0e$var$loopable = function loopable(i, length) {
    var props = {};
    var setProp = function setProp(name) {
        var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        props[name] = value;
    };
    i === 0 && setProp("first-child");
    i === length - 1 && setProp("last-child");
    (i === 0 || i % 2 === 0) && setProp("even");
    Math.abs(i % 2) === 1 && setProp("odd");
    setProp("nth-child", i);
    return props;
};
module.exports.default = $22b4cf73337ccf0e$var$loopable;

});


parcelRegister("5vxoY", function(module, exports) {

var $7WxoX = parcelRequire("7WxoX");

var $cSWb9 = parcelRequire("cSWb9");
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $4029c1eaa28c7484$var$merge = $cSWb9(function(object, source, srcIndex) {
    $7WxoX(object, source, srcIndex);
});
module.exports = $4029c1eaa28c7484$var$merge;

});
parcelRegister("7WxoX", function(module, exports) {

var $jIdTJ = parcelRequire("jIdTJ");

var $e20Ct = parcelRequire("e20Ct");

var $e3j3J = parcelRequire("e3j3J");

var $4Rw66 = parcelRequire("4Rw66");

var $kNSK3 = parcelRequire("kNSK3");

var $2bN3M = parcelRequire("2bN3M");

var $2oV2r = parcelRequire("2oV2r");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $5c87dc0954f7ca92$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    $e3j3J(source, function(srcValue, key) {
        stack || (stack = new $jIdTJ);
        if ($kNSK3(srcValue)) $4Rw66(object, source, key, srcIndex, $5c87dc0954f7ca92$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer($2oV2r(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            $e20Ct(object, key, newValue);
        }
    }, $2bN3M);
}
module.exports = $5c87dc0954f7ca92$var$baseMerge;

});
parcelRegister("e20Ct", function(module, exports) {

var $8tq3x = parcelRequire("8tq3x");

var $1bk3X = parcelRequire("1bk3X");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $a371bb98de6a1d4c$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !$1bk3X(object[key], value) || value === undefined && !(key in object)) $8tq3x(object, key, value);
}
module.exports = $a371bb98de6a1d4c$var$assignMergeValue;

});

parcelRegister("4Rw66", function(module, exports) {

var $e20Ct = parcelRequire("e20Ct");

var $lJ72B = parcelRequire("lJ72B");

var $edrdn = parcelRequire("edrdn");

var $15W3B = parcelRequire("15W3B");

var $hEGb3 = parcelRequire("hEGb3");

var $4rbI4 = parcelRequire("4rbI4");

var $5V8oz = parcelRequire("5V8oz");

var $9forf = parcelRequire("9forf");

var $9e2tS = parcelRequire("9e2tS");

var $1F4Th = parcelRequire("1F4Th");

var $kNSK3 = parcelRequire("kNSK3");

var $583Bp = parcelRequire("583Bp");

var $fAXjB = parcelRequire("fAXjB");

var $2oV2r = parcelRequire("2oV2r");

var $ijqiv = parcelRequire("ijqiv");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $38a5028faca2f800$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = $2oV2r(object, key), srcValue = $2oV2r(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        $e20Ct(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = $5V8oz(srcValue), isBuff = !isArr && $9e2tS(srcValue), isTyped = !isArr && !isBuff && $fAXjB(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ($5V8oz(objValue)) newValue = objValue;
            else if ($9forf(objValue)) newValue = $15W3B(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = $lJ72B(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = $edrdn(srcValue, true);
            } else newValue = [];
        } else if ($583Bp(srcValue) || $4rbI4(srcValue)) {
            newValue = objValue;
            if ($4rbI4(objValue)) newValue = $ijqiv(objValue);
            else if (!$kNSK3(objValue) || $1F4Th(objValue)) newValue = $hEGb3(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    $e20Ct(object, key, newValue);
}
module.exports = $38a5028faca2f800$var$baseMergeDeep;

});
parcelRegister("9forf", function(module, exports) {

var $iiJxK = parcelRequire("iiJxK");

var $hcK5n = parcelRequire("hcK5n");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $6bb878bfbd0b700f$var$isArrayLikeObject(value) {
    return $hcK5n(value) && $iiJxK(value);
}
module.exports = $6bb878bfbd0b700f$var$isArrayLikeObject;

});

parcelRegister("2oV2r", function(module, exports) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $1bfa1148dc174a8a$var$safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
module.exports = $1bfa1148dc174a8a$var$safeGet;

});

parcelRegister("ijqiv", function(module, exports) {

var $i4R0b = parcelRequire("i4R0b");

var $2bN3M = parcelRequire("2bN3M");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $d54e66741cc99c87$var$toPlainObject(value) {
    return $i4R0b(value, $2bN3M(value));
}
module.exports = $d54e66741cc99c87$var$toPlainObject;

});



parcelRegister("cSWb9", function(module, exports) {

var $4uucs = parcelRequire("4uucs");

var $ld7DH = parcelRequire("ld7DH");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $9617a84b8084f61e$var$createAssigner(assigner) {
    return $4uucs(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && $ld7DH(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
module.exports = $9617a84b8084f61e$var$createAssigner;

});
parcelRegister("4uucs", function(module, exports) {

var $38wdc = parcelRequire("38wdc");

var $bGwff = parcelRequire("bGwff");

var $cRHDK = parcelRequire("cRHDK");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $345163d83b19c620$var$baseRest(func, start) {
    return $cRHDK($bGwff(func, start, $38wdc), func + "");
}
module.exports = $345163d83b19c620$var$baseRest;

});
parcelRegister("bGwff", function(module, exports) {

var $i0CFu = parcelRequire("i0CFu");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $023202994a2c5bb1$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $023202994a2c5bb1$var$overRest(func, start, transform) {
    start = $023202994a2c5bb1$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $023202994a2c5bb1$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $i0CFu(func, this, otherArgs);
    };
}
module.exports = $023202994a2c5bb1$var$overRest;

});
parcelRegister("i0CFu", function(module, exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $d1c638c6c433c886$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = $d1c638c6c433c886$var$apply;

});


parcelRegister("cRHDK", function(module, exports) {

var $caA7l = parcelRequire("caA7l");

var $9wjPy = parcelRequire("9wjPy");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $95dc49494dbb4b0f$var$setToString = $9wjPy($caA7l);
module.exports = $95dc49494dbb4b0f$var$setToString;

});
parcelRegister("caA7l", function(module, exports) {

var $aWpbQ = parcelRequire("aWpbQ");

var $2FweT = parcelRequire("2FweT");

var $38wdc = parcelRequire("38wdc");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $8dc26f5cbd14da00$var$baseSetToString = !$2FweT ? $38wdc : function(func, string) {
    return $2FweT(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": $aWpbQ(string),
        "writable": true
    });
};
module.exports = $8dc26f5cbd14da00$var$baseSetToString;

});
parcelRegister("aWpbQ", function(module, exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $7f72dc63a56b5c51$var$constant(value) {
    return function() {
        return value;
    };
}
module.exports = $7f72dc63a56b5c51$var$constant;

});


parcelRegister("9wjPy", function(module, exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $6ee67c1e98961e07$var$HOT_COUNT = 800, $6ee67c1e98961e07$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6ee67c1e98961e07$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $6ee67c1e98961e07$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $6ee67c1e98961e07$var$nativeNow(), remaining = $6ee67c1e98961e07$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $6ee67c1e98961e07$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = $6ee67c1e98961e07$var$shortOut;

});



parcelRegister("ld7DH", function(module, exports) {

var $1bk3X = parcelRequire("1bk3X");

var $iiJxK = parcelRequire("iiJxK");

var $74Ail = parcelRequire("74Ail");

var $kNSK3 = parcelRequire("kNSK3");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $f710bcdbcd12ee56$var$isIterateeCall(value, index, object) {
    if (!$kNSK3(object)) return false;
    var type = typeof index;
    if (type == "number" ? $iiJxK(object) && $74Ail(index, object.length) : type == "string" && index in object) return $1bk3X(object[index], value);
    return false;
}
module.exports = $f710bcdbcd12ee56$var$isIterateeCall;

});



parcelRegister("8iqVt", function(module, exports) {
parcelRequire("kNUzI");
var $3H1D6 = parcelRequire("3H1D6");
var $60a4e4186883fbf6$require$GenIcon = $3H1D6.GenIcon;
module.exports = function(props) {
    return $60a4e4186883fbf6$require$GenIcon({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.3847 2.87868C19.2132 1.70711 17.3137 1.70711 16.1421 2.87868L14.0202 5.00052L13.313 4.29332C12.9225 3.9028 12.2894 3.9028 11.8988 4.29332C11.5083 4.68385 11.5083 5.31701 11.8988 5.70754L17.5557 11.3644C17.9462 11.7549 18.5794 11.7549 18.9699 11.3644C19.3604 10.9739 19.3604 10.3407 18.9699 9.95018L18.2629 9.24316L20.3847 7.12132C21.5563 5.94975 21.5563 4.05025 20.3847 2.87868Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M11.9297 7.09116L4.1515 14.8693C3.22786 15.793 3.03239 17.169 3.5651 18.2842L1.99994 19.8493L3.41415 21.2635L4.97931 19.6984C6.09444 20.2311 7.4705 20.0356 8.39414 19.112L16.1723 11.3338L11.9297 7.09116ZM13.3439 11.3338L11.9297 9.91959L5.56571 16.2835C5.17518 16.6741 5.17518 17.3072 5.56571 17.6978C5.95623 18.0883 6.5894 18.0883 6.97992 17.6978L13.3439 11.3338Z",
                    "fill": "currentColor"
                }
            }
        ],
        "content": "\n"
    })(props);
};

});
parcelRegister("kNUzI", function(module, exports) {
$parcel$export(module.exports, "GenIcon", () => (parcelRequire("3H1D6")).GenIcon);
parcelRequire("kBrSZ");
parcelRequire("3H1D6");
parcelRequire("lwAru");

});
parcelRegister("kBrSZ", function(module, exports) {
var $effce4eee42da00e$export$a0f7048edafc45cd = [
    {
        "id": "fa",
        "name": "Font Awesome",
        "projectUrl": "https://fontawesome.com/",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "ios",
        "name": "Ionicons",
        "projectUrl": "https://ionicons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
    },
    {
        "id": "md",
        "name": "Material Design Icons",
        "projectUrl": "http://google.github.io/material-design-icons/",
        "license": "Apache License Version 2.0",
        "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
    },
    {
        "id": "ti",
        "name": "Typicons",
        "projectUrl": "http://s-ings.com/typicons/",
        "license": "CC BY-SA 3.0",
        "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
    },
    {
        "id": "go",
        "name": "Github Octicons icons",
        "projectUrl": "https://octicons.github.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
    },
    {
        "id": "fi",
        "name": "Feather",
        "projectUrl": "https://feathericons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
    },
    {
        "id": "gi",
        "name": "Game Icons",
        "projectUrl": "https://game-icons.net/",
        "license": "CC BY 3.0",
        "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
    },
    {
        "id": "wi",
        "name": "Weather Icons",
        "projectUrl": "https://erikflowers.github.io/weather-icons/",
        "license": "SIL OFL 1.1",
        "licenseUrl": "http://scripts.sil.org/OFL"
    },
    {
        "id": "di",
        "name": "Devicons",
        "projectUrl": "https://vorillaz.github.io/devicons/",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "ai",
        "name": "Ant Design Icons",
        "projectUrl": "https://github.com/ant-design/ant-design-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "bs",
        "name": "Bootstrap Icons",
        "projectUrl": "https://github.com/twbs/icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "ri",
        "name": "Remix Icon",
        "projectUrl": "https://github.com/Remix-Design/RemixIcon",
        "license": "Apache License Version 2.0",
        "licenseUrl": "http://www.apache.org/licenses/"
    },
    {
        "id": "fc",
        "name": "Flat Color Icons",
        "projectUrl": "https://github.com/icons8/flat-color-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "gr",
        "name": "Grommet-Icons",
        "projectUrl": "https://github.com/grommet/grommet-icons",
        "license": "Apache License Version 2.0",
        "licenseUrl": "http://www.apache.org/licenses/"
    },
    {
        "id": "cg",
        "name": "css.gg",
        "projectUrl": "https://github.com/astrit/css.gg",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "mdc",
        "name": "MD Community Icons",
        "projectUrl": "https://github.com/templarian/MaterialDesign",
        "license": "SIL",
        "licenseUrl": "https://github.com/Templarian/MaterialDesign/blob/master/LICENSE"
    },
    {
        "id": "si",
        "name": "Simple Icons",
        "projectUrl": "https://simpleicons.org/",
        "license": "CC0 1.0 Universal",
        "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
    },
    {
        "id": "im",
        "name": "IcoMoon Free",
        "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "hi",
        "name": "Heroicons",
        "projectUrl": "https://github.com/refactoringui/heroicons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "vsc",
        "name": "VS Code Icons",
        "projectUrl": "https://github.com/microsoft/vscode-codicons",
        "license": "CC BY 4.0",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "fl",
        "name": "Flags Icons",
        "projectUrl": "https://github.com/lipis/flag-icon-css",
        "license": "MIT License",
        "licenseUrl": "https://github.com/lipis/flag-icon-css/blob/master/LICENSE"
    },
    {
        "id": "lg",
        "name": "Logos Icons",
        "projectUrl": "https://github.com/gilbarbara/logos",
        "license": "CC0 1.0 Universal",
        "licenseUrl": "https://github.com/gilbarbara/logos/blob/master/LICENSE.txt"
    },
    {
        "id": "bi",
        "name": "Boxicons",
        "projectUrl": "https://github.com/atisawd/boxicons",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "cr",
        "name": "Cryptoicons",
        "projectUrl": "https://github.com/spothq/cryptocurrency-icons",
        "license": "CC0 1.0 Universal",
        "licenseUrl": "https://github.com/spothq/cryptocurrency-icons/blob/master/LICENSE.md"
    },
    {
        "id": "en",
        "name": "Entypo",
        "projectUrl": "https://github.com/hypermodules/entypo",
        "license": "ISC License",
        "licenseUrl": "https://github.com/hypermodules/entypo/blob/master/LICENSE.md"
    },
    {
        "id": "fd",
        "name": "Foundation",
        "projectUrl": "https://github.com/meronex/foundation-icons-3",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "zo",
        "name": "Zondicons",
        "projectUrl": "https://github.com/dukestreetstudio/zondicons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "ei",
        "name": "Evil Icons",
        "projectUrl": "https://github.com/dukestreetstudio/zondicons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "oi",
        "name": "Open Iconic",
        "projectUrl": "https://github.com/iconic/open-iconic",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "su",
        "name": "System Uicons",
        "projectUrl": "https://github.com/CoreyGinnivan/system-uicons",
        "license": "The Unlicense",
        "licenseUrl": "https://github.com/CoreyGinnivan/system-uicons/blob/master/LICENSE"
    }
];

});

parcelRegister("3H1D6", function(module, exports) {

$parcel$export(module.exports, "GenIcon", () => $2b06a6df758baa25$export$6fce6cce1e9a936d);

var $8NFma = parcelRequire("8NFma");

var $lwAru = parcelRequire("lwAru");
var $2b06a6df758baa25$var$__assign = undefined && undefined.__assign || function() {
    $2b06a6df758baa25$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2b06a6df758baa25$var$__assign.apply(this, arguments);
};
var $2b06a6df758baa25$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $2b06a6df758baa25$var$Tree2Element(tree) {
    return tree && tree.map(function(node, i) {
        return $8NFma.createElement(node.tag, $2b06a6df758baa25$var$__assign({
            key: i
        }, node.attr), $2b06a6df758baa25$var$Tree2Element(node.child));
    });
}
function $2b06a6df758baa25$var$HasStrokes(svg) {
    for(var prop in svg){
        if (prop[0] === "_") continue; // don't go into any "private" properties
        if (prop === "stroke") return true;
        else if (typeof svg[prop] === "object") {
            var result = $2b06a6df758baa25$var$HasStrokes(svg[prop]);
            if (result) return result;
        } else if (prop === "content") // check if this content is for the <style> tag
        {
            if (svg["tag"] === "style") {
                // "content" may have styles for the stroke
                if (svg[prop].includes("stroke:")) return true;
            }
        }
    }
    return false;
}
function $2b06a6df758baa25$export$6fce6cce1e9a936d(data) {
    return function(props) {
        return $8NFma.createElement($2b06a6df758baa25$export$a188ecdd443fe91a, $2b06a6df758baa25$var$__assign({
            attr: $2b06a6df758baa25$var$__assign({}, data.attr)
        }, props, {
            hasStrokes: $2b06a6df758baa25$var$HasStrokes(data)
        }), $2b06a6df758baa25$var$Tree2Element(data.child));
    };
}
function $2b06a6df758baa25$export$a188ecdd443fe91a(props) {
    var elem = function(conf) {
        var computedSize = props.size || conf.size || "1em";
        var className;
        if (conf.className) className = conf.className;
        if (props.className) className = (className ? className + " " : "") + props.className;
        var attr = props.attr, fill = props.fill, title = props.title, hasStrokes = props.hasStrokes, svgProps = $2b06a6df758baa25$var$__rest(props, [
            "attr",
            "fill",
            "title",
            "hasStrokes"
        ]); // If the icon has explicit "stroke" attribute, do NOT set zero stroke width
        var stroke = hasStrokes ? null : {
            strokeWidth: 0
        };
        return $8NFma.createElement("svg", $2b06a6df758baa25$var$__assign({
            stroke: "currentColor",
            fill: fill
        }, stroke, conf.attr, attr, svgProps, {
            className: className,
            style: $2b06a6df758baa25$var$__assign($2b06a6df758baa25$var$__assign({
                color: props.color || conf.color
            }, conf.style), props.style),
            height: computedSize,
            width: computedSize,
            xmlns: "http://www.w3.org/2000/svg"
        }), title && $8NFma.createElement("title", null, title), props.children);
    };
    return (0, $lwAru.IconContext) !== undefined ? $8NFma.createElement((0, $lwAru.IconContext).Consumer, null, function(conf) {
        return elem(conf);
    }) : elem((0, $lwAru.DefaultContext));
}

});
parcelRegister("lwAru", function(module, exports) {

$parcel$export(module.exports, "DefaultContext", () => $fab8dad21b5893c7$export$4a4ef469214f8641);
$parcel$export(module.exports, "IconContext", () => $fab8dad21b5893c7$export$a49f528ae1a4d0ed);

var $8NFma = parcelRequire("8NFma");
var $fab8dad21b5893c7$export$4a4ef469214f8641 = {
    color: undefined,
    size: undefined,
    className: undefined,
    style: undefined,
    attr: undefined
};
var $fab8dad21b5893c7$export$a49f528ae1a4d0ed = $8NFma.createContext && $8NFma.createContext($fab8dad21b5893c7$export$4a4ef469214f8641);

});




parcelRegister("9Nyg4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $f2z1J = parcelRequire("f2z1J");
Object.defineProperty(module.exports, "Alpha", {
    enumerable: true,
    get: function get() {
        return $722343a14ccc3baf$var$_interopRequireDefault($f2z1J).default;
    }
});

var $1jQs3 = parcelRequire("1jQs3");
Object.defineProperty(module.exports, "Checkboard", {
    enumerable: true,
    get: function get() {
        return $722343a14ccc3baf$var$_interopRequireDefault($1jQs3).default;
    }
});

var $c1N9o = parcelRequire("c1N9o");
Object.defineProperty(module.exports, "EditableInput", {
    enumerable: true,
    get: function get() {
        return $722343a14ccc3baf$var$_interopRequireDefault($c1N9o).default;
    }
});

var $9u2tx = parcelRequire("9u2tx");
Object.defineProperty(module.exports, "Hue", {
    enumerable: true,
    get: function get() {
        return $722343a14ccc3baf$var$_interopRequireDefault($9u2tx).default;
    }
});

var $aaHcy = parcelRequire("aaHcy");
Object.defineProperty(module.exports, "Raised", {
    enumerable: true,
    get: function get() {
        return $722343a14ccc3baf$var$_interopRequireDefault($aaHcy).default;
    }
});

var $7jOou = parcelRequire("7jOou");
Object.defineProperty(module.exports, "Saturation", {
    enumerable: true,
    get: function get() {
        return $722343a14ccc3baf$var$_interopRequireDefault($7jOou).default;
    }
});

var $7JGkO = parcelRequire("7JGkO");
Object.defineProperty(module.exports, "ColorWrap", {
    enumerable: true,
    get: function get() {
        return $722343a14ccc3baf$var$_interopRequireDefault($7JGkO).default;
    }
});

var $6xzvP = parcelRequire("6xzvP");
Object.defineProperty(module.exports, "Swatch", {
    enumerable: true,
    get: function get() {
        return $722343a14ccc3baf$var$_interopRequireDefault($6xzvP).default;
    }
});
function $722343a14ccc3baf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("f2z1J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Alpha = undefined;
var $af32368cb1644e3b$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $af32368cb1644e3b$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $8NFma = parcelRequire("8NFma");
var $af32368cb1644e3b$var$_react2 = $af32368cb1644e3b$var$_interopRequireDefault($8NFma);

var $32YTy = parcelRequire("32YTy");
var $af32368cb1644e3b$var$_reactcss2 = $af32368cb1644e3b$var$_interopRequireDefault($32YTy);

var $dDKD3 = parcelRequire("dDKD3");
var $af32368cb1644e3b$var$alpha = $af32368cb1644e3b$var$_interopRequireWildcard($dDKD3);

var $1jQs3 = parcelRequire("1jQs3");
var $af32368cb1644e3b$var$_Checkboard2 = $af32368cb1644e3b$var$_interopRequireDefault($1jQs3);
function $af32368cb1644e3b$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $af32368cb1644e3b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $af32368cb1644e3b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $af32368cb1644e3b$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $af32368cb1644e3b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $af32368cb1644e3b$var$Alpha = module.exports.Alpha = function(_ref) {
    $af32368cb1644e3b$var$_inherits(Alpha, _ref);
    function Alpha() {
        var _ref2;
        var _temp, _this, _ret;
        $af32368cb1644e3b$var$_classCallCheck(this, Alpha);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $af32368cb1644e3b$var$_possibleConstructorReturn(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [
            this
        ].concat(args))), _this), _this.handleChange = function(e) {
            var change = $af32368cb1644e3b$var$alpha.calculateChange(e, _this.props.hsl, _this.props.direction, _this.props.a, _this.container);
            change && typeof _this.props.onChange === "function" && _this.props.onChange(change, e);
        }, _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            window.addEventListener("mousemove", _this.handleChange);
            window.addEventListener("mouseup", _this.handleMouseUp);
        }, _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        }, _this.unbindEventListeners = function() {
            window.removeEventListener("mousemove", _this.handleChange);
            window.removeEventListener("mouseup", _this.handleMouseUp);
        }, _temp), $af32368cb1644e3b$var$_possibleConstructorReturn(_this, _ret);
    }
    $af32368cb1644e3b$var$_createClass(Alpha, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var rgb = this.props.rgb;
                var styles = (0, $af32368cb1644e3b$var$_reactcss2.default)({
                    "default": {
                        alpha: {
                            absolute: "0px 0px 0px 0px",
                            borderRadius: this.props.radius
                        },
                        checkboard: {
                            absolute: "0px 0px 0px 0px",
                            overflow: "hidden",
                            borderRadius: this.props.radius
                        },
                        gradient: {
                            absolute: "0px 0px 0px 0px",
                            background: "linear-gradient(to right, rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 0) 0%,\n           rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 1) 100%)",
                            boxShadow: this.props.shadow,
                            borderRadius: this.props.radius
                        },
                        container: {
                            position: "relative",
                            height: "100%",
                            margin: "0 3px"
                        },
                        pointer: {
                            position: "absolute",
                            left: rgb.a * 100 + "%"
                        },
                        slider: {
                            width: "4px",
                            borderRadius: "1px",
                            height: "8px",
                            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
                            background: "#fff",
                            marginTop: "1px",
                            transform: "translateX(-2px)"
                        }
                    },
                    "vertical": {
                        gradient: {
                            background: "linear-gradient(to bottom, rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 0) 0%,\n           rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 1) 100%)"
                        },
                        pointer: {
                            left: 0,
                            top: rgb.a * 100 + "%"
                        }
                    },
                    "overwrite": $af32368cb1644e3b$var$_extends({}, this.props.style)
                }, {
                    vertical: this.props.direction === "vertical",
                    overwrite: true
                });
                return $af32368cb1644e3b$var$_react2.default.createElement("div", {
                    style: styles.alpha
                }, $af32368cb1644e3b$var$_react2.default.createElement("div", {
                    style: styles.checkboard
                }, $af32368cb1644e3b$var$_react2.default.createElement($af32368cb1644e3b$var$_Checkboard2.default, {
                    renderers: this.props.renderers
                })), $af32368cb1644e3b$var$_react2.default.createElement("div", {
                    style: styles.gradient
                }), $af32368cb1644e3b$var$_react2.default.createElement("div", {
                    style: styles.container,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, $af32368cb1644e3b$var$_react2.default.createElement("div", {
                    style: styles.pointer
                }, this.props.pointer ? $af32368cb1644e3b$var$_react2.default.createElement(this.props.pointer, this.props) : $af32368cb1644e3b$var$_react2.default.createElement("div", {
                    style: styles.slider
                }))));
            }
        }
    ]);
    return Alpha;
}($8NFma.PureComponent || $8NFma.Component);
module.exports.default = $af32368cb1644e3b$var$Alpha;

});
parcelRegister("dDKD3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $02900cbf87376290$var$calculateChange = module.exports.calculateChange = function calculateChange(e, hsl, direction, initialA, container) {
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === "number" ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === "number" ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (direction === "vertical") {
        var a = void 0;
        if (top < 0) a = 0;
        else if (top > containerHeight) a = 1;
        else a = Math.round(top * 100 / containerHeight) / 100;
        if (hsl.a !== a) return {
            h: hsl.h,
            s: hsl.s,
            l: hsl.l,
            a: a,
            source: "rgb"
        };
    } else {
        var _a = void 0;
        if (left < 0) _a = 0;
        else if (left > containerWidth) _a = 1;
        else _a = Math.round(left * 100 / containerWidth) / 100;
        if (initialA !== _a) return {
            h: hsl.h,
            s: hsl.s,
            l: hsl.l,
            a: _a,
            source: "rgb"
        };
    }
    return null;
};

});

parcelRegister("1jQs3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Checkboard = undefined;
var $0f60408b6b00e140$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $8NFma = parcelRequire("8NFma");
var $0f60408b6b00e140$var$_react2 = $0f60408b6b00e140$var$_interopRequireDefault($8NFma);

var $32YTy = parcelRequire("32YTy");
var $0f60408b6b00e140$var$_reactcss2 = $0f60408b6b00e140$var$_interopRequireDefault($32YTy);

var $gQPZS = parcelRequire("gQPZS");
var $0f60408b6b00e140$var$checkboard = $0f60408b6b00e140$var$_interopRequireWildcard($gQPZS);
function $0f60408b6b00e140$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $0f60408b6b00e140$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $0f60408b6b00e140$var$Checkboard = module.exports.Checkboard = function Checkboard(_ref) {
    var white = _ref.white, grey = _ref.grey, size = _ref.size, renderers = _ref.renderers, borderRadius = _ref.borderRadius, boxShadow = _ref.boxShadow, children = _ref.children;
    var styles = (0, $0f60408b6b00e140$var$_reactcss2.default)({
        "default": {
            grid: {
                borderRadius: borderRadius,
                boxShadow: boxShadow,
                absolute: "0px 0px 0px 0px",
                background: "url(" + $0f60408b6b00e140$var$checkboard.get(white, grey, size, renderers.canvas) + ") center left"
            }
        }
    });
    return (0, $8NFma.isValidElement)(children) ? $0f60408b6b00e140$var$_react2.default.cloneElement(children, $0f60408b6b00e140$var$_extends({}, children.props, {
        style: $0f60408b6b00e140$var$_extends({}, children.props.style, styles.grid)
    })) : $0f60408b6b00e140$var$_react2.default.createElement("div", {
        style: styles.grid
    });
};
$0f60408b6b00e140$var$Checkboard.defaultProps = {
    size: 8,
    white: "transparent",
    grey: "rgba(0,0,0,.08)",
    renderers: {}
};
module.exports.default = $0f60408b6b00e140$var$Checkboard;

});
parcelRegister("gQPZS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c449d62c55dcd8c5$var$checkboardCache = {};
var $c449d62c55dcd8c5$var$render = module.exports.render = function render(c1, c2, size, serverCanvas) {
    if (typeof document === "undefined" && !serverCanvas) return null;
    var canvas = serverCanvas ? new serverCanvas() : document.createElement("canvas");
    canvas.width = size * 2;
    canvas.height = size * 2;
    var ctx = canvas.getContext("2d");
    if (!ctx) return null;
     // If no context can be found, return early.
    ctx.fillStyle = c1;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = c2;
    ctx.fillRect(0, 0, size, size);
    ctx.translate(size, size);
    ctx.fillRect(0, 0, size, size);
    return canvas.toDataURL();
};
var $c449d62c55dcd8c5$var$get = module.exports.get = function get(c1, c2, size, serverCanvas) {
    var key = c1 + "-" + c2 + "-" + size + (serverCanvas ? "-server" : "");
    if ($c449d62c55dcd8c5$var$checkboardCache[key]) return $c449d62c55dcd8c5$var$checkboardCache[key];
    var checkboard = $c449d62c55dcd8c5$var$render(c1, c2, size, serverCanvas);
    $c449d62c55dcd8c5$var$checkboardCache[key] = checkboard;
    return checkboard;
};

});



parcelRegister("c1N9o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EditableInput = undefined;
var $8c1bb44c77c0e8f2$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $8NFma = parcelRequire("8NFma");
var $8c1bb44c77c0e8f2$var$_react2 = $8c1bb44c77c0e8f2$var$_interopRequireDefault($8NFma);

var $32YTy = parcelRequire("32YTy");
var $8c1bb44c77c0e8f2$var$_reactcss2 = $8c1bb44c77c0e8f2$var$_interopRequireDefault($32YTy);
function $8c1bb44c77c0e8f2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8c1bb44c77c0e8f2$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8c1bb44c77c0e8f2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8c1bb44c77c0e8f2$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $8c1bb44c77c0e8f2$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $8c1bb44c77c0e8f2$var$DEFAULT_ARROW_OFFSET = 1;
var $8c1bb44c77c0e8f2$var$UP_KEY_CODE = 38;
var $8c1bb44c77c0e8f2$var$DOWN_KEY_CODE = 40;
var $8c1bb44c77c0e8f2$var$VALID_KEY_CODES = [
    $8c1bb44c77c0e8f2$var$UP_KEY_CODE,
    $8c1bb44c77c0e8f2$var$DOWN_KEY_CODE
];
var $8c1bb44c77c0e8f2$var$isValidKeyCode = function isValidKeyCode(keyCode) {
    return $8c1bb44c77c0e8f2$var$VALID_KEY_CODES.indexOf(keyCode) > -1;
};
var $8c1bb44c77c0e8f2$var$getNumberValue = function getNumberValue(value) {
    return Number(String(value).replace(/%/g, ""));
};
var $8c1bb44c77c0e8f2$var$idCounter = 1;
var $8c1bb44c77c0e8f2$var$EditableInput = module.exports.EditableInput = function(_ref) {
    $8c1bb44c77c0e8f2$var$_inherits(EditableInput, _ref);
    function EditableInput(props) {
        $8c1bb44c77c0e8f2$var$_classCallCheck(this, EditableInput);
        var _this = $8c1bb44c77c0e8f2$var$_possibleConstructorReturn(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));
        _this.handleBlur = function() {
            if (_this.state.blurValue) _this.setState({
                value: _this.state.blurValue,
                blurValue: null
            });
        };
        _this.handleChange = function(e) {
            _this.setUpdatedValue(e.target.value, e);
        };
        _this.handleKeyDown = function(e) {
            // In case `e.target.value` is a percentage remove the `%` character
            // and update accordingly with a percentage
            // https://github.com/casesandberg/react-color/issues/383
            var value = $8c1bb44c77c0e8f2$var$getNumberValue(e.target.value);
            if (!isNaN(value) && $8c1bb44c77c0e8f2$var$isValidKeyCode(e.keyCode)) {
                var offset = _this.getArrowOffset();
                var updatedValue = e.keyCode === $8c1bb44c77c0e8f2$var$UP_KEY_CODE ? value + offset : value - offset;
                _this.setUpdatedValue(updatedValue, e);
            }
        };
        _this.handleDrag = function(e) {
            if (_this.props.dragLabel) {
                var newValue = Math.round(_this.props.value + e.movementX);
                if (newValue >= 0 && newValue <= _this.props.dragMax) _this.props.onChange && _this.props.onChange(_this.getValueObjectWithLabel(newValue), e);
            }
        };
        _this.handleMouseDown = function(e) {
            if (_this.props.dragLabel) {
                e.preventDefault();
                _this.handleDrag(e);
                window.addEventListener("mousemove", _this.handleDrag);
                window.addEventListener("mouseup", _this.handleMouseUp);
            }
        };
        _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        };
        _this.unbindEventListeners = function() {
            window.removeEventListener("mousemove", _this.handleDrag);
            window.removeEventListener("mouseup", _this.handleMouseUp);
        };
        _this.state = {
            value: String(props.value).toUpperCase(),
            blurValue: String(props.value).toUpperCase()
        };
        _this.inputId = "rc-editable-input-" + $8c1bb44c77c0e8f2$var$idCounter++;
        return _this;
    }
    $8c1bb44c77c0e8f2$var$_createClass(EditableInput, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.value !== this.state.value && (prevProps.value !== this.props.value || prevState.value !== this.state.value)) {
                    if (this.input === document.activeElement) this.setState({
                        blurValue: String(this.props.value).toUpperCase()
                    });
                    else this.setState({
                        value: String(this.props.value).toUpperCase(),
                        blurValue: !this.state.blurValue && String(this.props.value).toUpperCase()
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: "getValueObjectWithLabel",
            value: function getValueObjectWithLabel(value) {
                return $8c1bb44c77c0e8f2$var$_defineProperty({}, this.props.label, value);
            }
        },
        {
            key: "getArrowOffset",
            value: function getArrowOffset() {
                return this.props.arrowOffset || $8c1bb44c77c0e8f2$var$DEFAULT_ARROW_OFFSET;
            }
        },
        {
            key: "setUpdatedValue",
            value: function setUpdatedValue(value, e) {
                var onChangeValue = this.props.label ? this.getValueObjectWithLabel(value) : value;
                this.props.onChange && this.props.onChange(onChangeValue, e);
                this.setState({
                    value: value
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var styles = (0, $8c1bb44c77c0e8f2$var$_reactcss2.default)({
                    "default": {
                        wrap: {
                            position: "relative"
                        }
                    },
                    "user-override": {
                        wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
                        input: this.props.style && this.props.style.input ? this.props.style.input : {},
                        label: this.props.style && this.props.style.label ? this.props.style.label : {}
                    },
                    "dragLabel-true": {
                        label: {
                            cursor: "ew-resize"
                        }
                    }
                }, {
                    "user-override": true
                }, this.props);
                return $8c1bb44c77c0e8f2$var$_react2.default.createElement("div", {
                    style: styles.wrap
                }, $8c1bb44c77c0e8f2$var$_react2.default.createElement("input", {
                    id: this.inputId,
                    style: styles.input,
                    ref: function ref(input) {
                        return _this2.input = input;
                    },
                    value: this.state.value,
                    onKeyDown: this.handleKeyDown,
                    onChange: this.handleChange,
                    onBlur: this.handleBlur,
                    placeholder: this.props.placeholder,
                    spellCheck: "false"
                }), this.props.label && !this.props.hideLabel ? $8c1bb44c77c0e8f2$var$_react2.default.createElement("label", {
                    htmlFor: this.inputId,
                    style: styles.label,
                    onMouseDown: this.handleMouseDown
                }, this.props.label) : null);
            }
        }
    ]);
    return EditableInput;
}($8NFma.PureComponent || $8NFma.Component);
module.exports.default = $8c1bb44c77c0e8f2$var$EditableInput;

});

parcelRegister("9u2tx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hue = undefined;
var $6e78d5f86dc1d2dc$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $8NFma = parcelRequire("8NFma");
var $6e78d5f86dc1d2dc$var$_react2 = $6e78d5f86dc1d2dc$var$_interopRequireDefault($8NFma);

var $32YTy = parcelRequire("32YTy");
var $6e78d5f86dc1d2dc$var$_reactcss2 = $6e78d5f86dc1d2dc$var$_interopRequireDefault($32YTy);

var $gngAS = parcelRequire("gngAS");
var $6e78d5f86dc1d2dc$var$hue = $6e78d5f86dc1d2dc$var$_interopRequireWildcard($gngAS);
function $6e78d5f86dc1d2dc$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $6e78d5f86dc1d2dc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6e78d5f86dc1d2dc$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6e78d5f86dc1d2dc$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $6e78d5f86dc1d2dc$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $6e78d5f86dc1d2dc$var$Hue = module.exports.Hue = function(_ref) {
    $6e78d5f86dc1d2dc$var$_inherits(Hue, _ref);
    function Hue() {
        var _ref2;
        var _temp, _this, _ret;
        $6e78d5f86dc1d2dc$var$_classCallCheck(this, Hue);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $6e78d5f86dc1d2dc$var$_possibleConstructorReturn(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [
            this
        ].concat(args))), _this), _this.handleChange = function(e) {
            var change = $6e78d5f86dc1d2dc$var$hue.calculateChange(e, _this.props.direction, _this.props.hsl, _this.container);
            change && typeof _this.props.onChange === "function" && _this.props.onChange(change, e);
        }, _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            window.addEventListener("mousemove", _this.handleChange);
            window.addEventListener("mouseup", _this.handleMouseUp);
        }, _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        }, _temp), $6e78d5f86dc1d2dc$var$_possibleConstructorReturn(_this, _ret);
    }
    $6e78d5f86dc1d2dc$var$_createClass(Hue, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: "unbindEventListeners",
            value: function unbindEventListeners() {
                window.removeEventListener("mousemove", this.handleChange);
                window.removeEventListener("mouseup", this.handleMouseUp);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _props$direction = this.props.direction, direction = _props$direction === undefined ? "horizontal" : _props$direction;
                var styles = (0, $6e78d5f86dc1d2dc$var$_reactcss2.default)({
                    "default": {
                        hue: {
                            absolute: "0px 0px 0px 0px",
                            borderRadius: this.props.radius,
                            boxShadow: this.props.shadow
                        },
                        container: {
                            padding: "0 2px",
                            position: "relative",
                            height: "100%",
                            borderRadius: this.props.radius
                        },
                        pointer: {
                            position: "absolute",
                            left: this.props.hsl.h * 100 / 360 + "%"
                        },
                        slider: {
                            marginTop: "1px",
                            width: "4px",
                            borderRadius: "1px",
                            height: "8px",
                            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
                            background: "#fff",
                            transform: "translateX(-2px)"
                        }
                    },
                    "vertical": {
                        pointer: {
                            left: "0px",
                            top: -(this.props.hsl.h * 100 / 360) + 100 + "%"
                        }
                    }
                }, {
                    vertical: direction === "vertical"
                });
                return $6e78d5f86dc1d2dc$var$_react2.default.createElement("div", {
                    style: styles.hue
                }, $6e78d5f86dc1d2dc$var$_react2.default.createElement("div", {
                    className: "hue-" + direction,
                    style: styles.container,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, $6e78d5f86dc1d2dc$var$_react2.default.createElement("style", null, "\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          "), $6e78d5f86dc1d2dc$var$_react2.default.createElement("div", {
                    style: styles.pointer
                }, this.props.pointer ? $6e78d5f86dc1d2dc$var$_react2.default.createElement(this.props.pointer, this.props) : $6e78d5f86dc1d2dc$var$_react2.default.createElement("div", {
                    style: styles.slider
                }))));
            }
        }
    ]);
    return Hue;
}($8NFma.PureComponent || $8NFma.Component);
module.exports.default = $6e78d5f86dc1d2dc$var$Hue;

});
parcelRegister("gngAS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $bebbaa869b7d56c3$var$calculateChange = module.exports.calculateChange = function calculateChange(e, direction, hsl, container) {
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === "number" ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === "number" ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (direction === "vertical") {
        var h = void 0;
        if (top < 0) h = 359;
        else if (top > containerHeight) h = 0;
        else {
            var percent = -(top * 100 / containerHeight) + 100;
            h = 360 * percent / 100;
        }
        if (hsl.h !== h) return {
            h: h,
            s: hsl.s,
            l: hsl.l,
            a: hsl.a,
            source: "hsl"
        };
    } else {
        var _h = void 0;
        if (left < 0) _h = 0;
        else if (left > containerWidth) _h = 359;
        else {
            var _percent = left * 100 / containerWidth;
            _h = 360 * _percent / 100;
        }
        if (hsl.h !== _h) return {
            h: _h,
            s: hsl.s,
            l: hsl.l,
            a: hsl.a,
            source: "hsl"
        };
    }
    return null;
};

});


parcelRegister("aaHcy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Raised = undefined;

var $8NFma = parcelRequire("8NFma");
var $767c597da63bc1f6$var$_react2 = $767c597da63bc1f6$var$_interopRequireDefault($8NFma);

var $fb0st = parcelRequire("fb0st");
var $767c597da63bc1f6$var$_propTypes2 = $767c597da63bc1f6$var$_interopRequireDefault($fb0st);

var $32YTy = parcelRequire("32YTy");
var $767c597da63bc1f6$var$_reactcss2 = $767c597da63bc1f6$var$_interopRequireDefault($32YTy);

var $5vxoY = parcelRequire("5vxoY");
var $767c597da63bc1f6$var$_merge2 = $767c597da63bc1f6$var$_interopRequireDefault($5vxoY);
function $767c597da63bc1f6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $767c597da63bc1f6$var$Raised = module.exports.Raised = function Raised(_ref) {
    var zDepth = _ref.zDepth, radius = _ref.radius, background = _ref.background, children = _ref.children, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles;
    var styles = (0, $767c597da63bc1f6$var$_reactcss2.default)((0, $767c597da63bc1f6$var$_merge2.default)({
        "default": {
            wrap: {
                position: "relative",
                display: "inline-block"
            },
            content: {
                position: "relative"
            },
            bg: {
                absolute: "0px 0px 0px 0px",
                boxShadow: "0 " + zDepth + "px " + zDepth * 4 + "px rgba(0,0,0,.24)",
                borderRadius: radius,
                background: background
            }
        },
        "zDepth-0": {
            bg: {
                boxShadow: "none"
            }
        },
        "zDepth-1": {
            bg: {
                boxShadow: "0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)"
            }
        },
        "zDepth-2": {
            bg: {
                boxShadow: "0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)"
            }
        },
        "zDepth-3": {
            bg: {
                boxShadow: "0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)"
            }
        },
        "zDepth-4": {
            bg: {
                boxShadow: "0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)"
            }
        },
        "zDepth-5": {
            bg: {
                boxShadow: "0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)"
            }
        },
        "square": {
            bg: {
                borderRadius: "0"
            }
        },
        "circle": {
            bg: {
                borderRadius: "50%"
            }
        }
    }, passedStyles), {
        "zDepth-1": zDepth === 1
    });
    return $767c597da63bc1f6$var$_react2.default.createElement("div", {
        style: styles.wrap
    }, $767c597da63bc1f6$var$_react2.default.createElement("div", {
        style: styles.bg
    }), $767c597da63bc1f6$var$_react2.default.createElement("div", {
        style: styles.content
    }, children));
};
$767c597da63bc1f6$var$Raised.propTypes = {
    background: $767c597da63bc1f6$var$_propTypes2.default.string,
    zDepth: $767c597da63bc1f6$var$_propTypes2.default.oneOf([
        0,
        1,
        2,
        3,
        4,
        5
    ]),
    radius: $767c597da63bc1f6$var$_propTypes2.default.number,
    styles: $767c597da63bc1f6$var$_propTypes2.default.object
};
$767c597da63bc1f6$var$Raised.defaultProps = {
    background: "#fff",
    zDepth: 1,
    radius: 2,
    styles: {}
};
module.exports.default = $767c597da63bc1f6$var$Raised;

});

parcelRegister("7jOou", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Saturation = undefined;
var $554165f4ad80ece7$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $8NFma = parcelRequire("8NFma");
var $554165f4ad80ece7$var$_react2 = $554165f4ad80ece7$var$_interopRequireDefault($8NFma);

var $32YTy = parcelRequire("32YTy");
var $554165f4ad80ece7$var$_reactcss2 = $554165f4ad80ece7$var$_interopRequireDefault($32YTy);

var $1re9q = parcelRequire("1re9q");
var $554165f4ad80ece7$var$_throttle2 = $554165f4ad80ece7$var$_interopRequireDefault($1re9q);

var $6HyTU = parcelRequire("6HyTU");
var $554165f4ad80ece7$var$saturation = $554165f4ad80ece7$var$_interopRequireWildcard($6HyTU);
function $554165f4ad80ece7$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $554165f4ad80ece7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $554165f4ad80ece7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $554165f4ad80ece7$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $554165f4ad80ece7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $554165f4ad80ece7$var$Saturation = module.exports.Saturation = function(_ref) {
    $554165f4ad80ece7$var$_inherits(Saturation, _ref);
    function Saturation(props) {
        $554165f4ad80ece7$var$_classCallCheck(this, Saturation);
        var _this = $554165f4ad80ece7$var$_possibleConstructorReturn(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));
        _this.handleChange = function(e) {
            typeof _this.props.onChange === "function" && _this.throttle(_this.props.onChange, $554165f4ad80ece7$var$saturation.calculateChange(e, _this.props.hsl, _this.container), e);
        };
        _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            var renderWindow = _this.getContainerRenderWindow();
            renderWindow.addEventListener("mousemove", _this.handleChange);
            renderWindow.addEventListener("mouseup", _this.handleMouseUp);
        };
        _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        };
        _this.throttle = (0, $554165f4ad80ece7$var$_throttle2.default)(function(fn, data, e) {
            fn(data, e);
        }, 50);
        return _this;
    }
    $554165f4ad80ece7$var$_createClass(Saturation, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.throttle.cancel();
                this.unbindEventListeners();
            }
        },
        {
            key: "getContainerRenderWindow",
            value: function getContainerRenderWindow() {
                var container = this.container;
                var renderWindow = window;
                while(!renderWindow.document.contains(container) && renderWindow.parent !== renderWindow)renderWindow = renderWindow.parent;
                return renderWindow;
            }
        },
        {
            key: "unbindEventListeners",
            value: function unbindEventListeners() {
                var renderWindow = this.getContainerRenderWindow();
                renderWindow.removeEventListener("mousemove", this.handleChange);
                renderWindow.removeEventListener("mouseup", this.handleMouseUp);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _ref2 = this.props.style || {}, color = _ref2.color, white = _ref2.white, black = _ref2.black, pointer = _ref2.pointer, circle = _ref2.circle;
                var styles = (0, $554165f4ad80ece7$var$_reactcss2.default)({
                    "default": {
                        color: {
                            absolute: "0px 0px 0px 0px",
                            background: "hsl(" + this.props.hsl.h + ",100%, 50%)",
                            borderRadius: this.props.radius
                        },
                        white: {
                            absolute: "0px 0px 0px 0px",
                            borderRadius: this.props.radius
                        },
                        black: {
                            absolute: "0px 0px 0px 0px",
                            boxShadow: this.props.shadow,
                            borderRadius: this.props.radius
                        },
                        pointer: {
                            position: "absolute",
                            top: -(this.props.hsv.v * 100) + 100 + "%",
                            left: this.props.hsv.s * 100 + "%",
                            cursor: "default"
                        },
                        circle: {
                            width: "4px",
                            height: "4px",
                            boxShadow: "0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)",
                            borderRadius: "50%",
                            cursor: "hand",
                            transform: "translate(-2px, -2px)"
                        }
                    },
                    "custom": {
                        color: color,
                        white: white,
                        black: black,
                        pointer: pointer,
                        circle: circle
                    }
                }, {
                    "custom": !!this.props.style
                });
                return $554165f4ad80ece7$var$_react2.default.createElement("div", {
                    style: styles.color,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, $554165f4ad80ece7$var$_react2.default.createElement("style", null, "\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        "), $554165f4ad80ece7$var$_react2.default.createElement("div", {
                    style: styles.white,
                    className: "saturation-white"
                }, $554165f4ad80ece7$var$_react2.default.createElement("div", {
                    style: styles.black,
                    className: "saturation-black"
                }), $554165f4ad80ece7$var$_react2.default.createElement("div", {
                    style: styles.pointer
                }, this.props.pointer ? $554165f4ad80ece7$var$_react2.default.createElement(this.props.pointer, this.props) : $554165f4ad80ece7$var$_react2.default.createElement("div", {
                    style: styles.circle
                }))));
            }
        }
    ]);
    return Saturation;
}($8NFma.PureComponent || $8NFma.Component);
module.exports.default = $554165f4ad80ece7$var$Saturation;

});
parcelRegister("1re9q", function(module, exports) {

var $1dDTW = parcelRequire("1dDTW");

var $kNSK3 = parcelRequire("kNSK3");
/** Error message constants. */ var $10c34a22c834dedf$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $10c34a22c834dedf$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($10c34a22c834dedf$var$FUNC_ERROR_TEXT);
    if ($kNSK3(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $1dDTW(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
module.exports = $10c34a22c834dedf$var$throttle;

});
parcelRegister("1dDTW", function(module, exports) {

var $kNSK3 = parcelRequire("kNSK3");

var $1L8d9 = parcelRequire("1L8d9");

var $5wJyD = parcelRequire("5wJyD");
/** Error message constants. */ var $0e35f4eab9d23d34$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $0e35f4eab9d23d34$var$nativeMax = Math.max, $0e35f4eab9d23d34$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $0e35f4eab9d23d34$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($0e35f4eab9d23d34$var$FUNC_ERROR_TEXT);
    wait = $5wJyD(wait) || 0;
    if ($kNSK3(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $0e35f4eab9d23d34$var$nativeMax($5wJyD(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $0e35f4eab9d23d34$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $1L8d9();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($1L8d9());
    }
    function debounced() {
        var time = $1L8d9(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
module.exports = $0e35f4eab9d23d34$var$debounce;

});
parcelRegister("1L8d9", function(module, exports) {

var $eeOBM = parcelRequire("eeOBM");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $14808ccd12f91c2c$var$now = function() {
    return $eeOBM.Date.now();
};
module.exports = $14808ccd12f91c2c$var$now;

});

parcelRegister("5wJyD", function(module, exports) {

var $1yefP = parcelRequire("1yefP");

var $kNSK3 = parcelRequire("kNSK3");

var $7xC8V = parcelRequire("7xC8V");
/** Used as references for various `Number` constants. */ var $406347b540c1b6af$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $406347b540c1b6af$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $406347b540c1b6af$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $406347b540c1b6af$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $406347b540c1b6af$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $406347b540c1b6af$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($7xC8V(value)) return $406347b540c1b6af$var$NAN;
    if ($kNSK3(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $kNSK3(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = $1yefP(value);
    var isBinary = $406347b540c1b6af$var$reIsBinary.test(value);
    return isBinary || $406347b540c1b6af$var$reIsOctal.test(value) ? $406347b540c1b6af$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $406347b540c1b6af$var$reIsBadHex.test(value) ? $406347b540c1b6af$var$NAN : +value;
}
module.exports = $406347b540c1b6af$var$toNumber;

});
parcelRegister("1yefP", function(module, exports) {

var $33rSL = parcelRequire("33rSL");
/** Used to match leading whitespace. */ var $1214060930b72fb3$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $1214060930b72fb3$var$baseTrim(string) {
    return string ? string.slice(0, $33rSL(string) + 1).replace($1214060930b72fb3$var$reTrimStart, "") : string;
}
module.exports = $1214060930b72fb3$var$baseTrim;

});
parcelRegister("33rSL", function(module, exports) {
/** Used to match a single whitespace character. */ var $239747baff5e4ab8$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $239747baff5e4ab8$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $239747baff5e4ab8$var$reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = $239747baff5e4ab8$var$trimmedEndIndex;

});





parcelRegister("6HyTU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $4e11d4ca8cdc3f0e$var$calculateChange = module.exports.calculateChange = function calculateChange(e, hsl, container) {
    var _container$getBoundin = container.getBoundingClientRect(), containerWidth = _container$getBoundin.width, containerHeight = _container$getBoundin.height;
    var x = typeof e.pageX === "number" ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === "number" ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (left < 0) left = 0;
    else if (left > containerWidth) left = containerWidth;
    if (top < 0) top = 0;
    else if (top > containerHeight) top = containerHeight;
    var saturation = left / containerWidth;
    var bright = 1 - top / containerHeight;
    return {
        h: hsl.h,
        s: saturation,
        v: bright,
        a: hsl.a,
        source: "hsv"
    };
};

});


parcelRegister("7JGkO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ColorWrap = undefined;
var $5a1d932796599deb$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $5a1d932796599deb$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $8NFma = parcelRequire("8NFma");
var $5a1d932796599deb$var$_react2 = $5a1d932796599deb$var$_interopRequireDefault($8NFma);

var $1dDTW = parcelRequire("1dDTW");
var $5a1d932796599deb$var$_debounce2 = $5a1d932796599deb$var$_interopRequireDefault($1dDTW);

var $hbCun = parcelRequire("hbCun");
var $5a1d932796599deb$var$color = $5a1d932796599deb$var$_interopRequireWildcard($hbCun);
function $5a1d932796599deb$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $5a1d932796599deb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5a1d932796599deb$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5a1d932796599deb$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $5a1d932796599deb$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $5a1d932796599deb$var$ColorWrap = module.exports.ColorWrap = function ColorWrap(Picker) {
    var ColorPicker = function(_ref) {
        $5a1d932796599deb$var$_inherits(ColorPicker, _ref);
        function ColorPicker(props) {
            $5a1d932796599deb$var$_classCallCheck(this, ColorPicker);
            var _this = $5a1d932796599deb$var$_possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));
            _this.handleChange = function(data, event) {
                var isValidColor = $5a1d932796599deb$var$color.simpleCheckForValidColor(data);
                if (isValidColor) {
                    var colors = $5a1d932796599deb$var$color.toState(data, data.h || _this.state.oldHue);
                    _this.setState(colors);
                    _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
                    _this.props.onChange && _this.props.onChange(colors, event);
                }
            };
            _this.handleSwatchHover = function(data, event) {
                var isValidColor = $5a1d932796599deb$var$color.simpleCheckForValidColor(data);
                if (isValidColor) {
                    var colors = $5a1d932796599deb$var$color.toState(data, data.h || _this.state.oldHue);
                    _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
                }
            };
            _this.state = $5a1d932796599deb$var$_extends({}, $5a1d932796599deb$var$color.toState(props.color, 0));
            _this.debounce = (0, $5a1d932796599deb$var$_debounce2.default)(function(fn, data, event) {
                fn(data, event);
            }, 100);
            return _this;
        }
        $5a1d932796599deb$var$_createClass(ColorPicker, [
            {
                key: "render",
                value: function render() {
                    var optionalEvents = {};
                    if (this.props.onSwatchHover) optionalEvents.onSwatchHover = this.handleSwatchHover;
                    return $5a1d932796599deb$var$_react2.default.createElement(Picker, $5a1d932796599deb$var$_extends({}, this.props, this.state, {
                        onChange: this.handleChange
                    }, optionalEvents));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(nextProps, state) {
                    return $5a1d932796599deb$var$_extends({}, $5a1d932796599deb$var$color.toState(nextProps.color, state.oldHue));
                }
            }
        ]);
        return ColorPicker;
    }($8NFma.PureComponent || $8NFma.Component);
    ColorPicker.propTypes = $5a1d932796599deb$var$_extends({}, Picker.propTypes);
    ColorPicker.defaultProps = $5a1d932796599deb$var$_extends({}, Picker.defaultProps, {
        color: {
            h: 250,
            s: 0.50,
            l: 0.20,
            a: 1
        }
    });
    return ColorPicker;
};
module.exports.default = $5a1d932796599deb$var$ColorWrap;

});
parcelRegister("hbCun", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isvalidColorString = module.exports.red = module.exports.getContrastingColor = module.exports.isValidHex = module.exports.toState = module.exports.simpleCheckForValidColor = undefined;

var $86AaM = parcelRequire("86AaM");
var $c83151db995a9db5$var$_each2 = $c83151db995a9db5$var$_interopRequireDefault($86AaM);

var $lvKY8 = parcelRequire("lvKY8");
var $c83151db995a9db5$var$_tinycolor2 = $c83151db995a9db5$var$_interopRequireDefault($lvKY8);
function $c83151db995a9db5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $c83151db995a9db5$var$simpleCheckForValidColor = module.exports.simpleCheckForValidColor = function simpleCheckForValidColor(data) {
    var keysToCheck = [
        "r",
        "g",
        "b",
        "a",
        "h",
        "s",
        "l",
        "v"
    ];
    var checked = 0;
    var passed = 0;
    (0, $c83151db995a9db5$var$_each2.default)(keysToCheck, function(letter) {
        if (data[letter]) {
            checked += 1;
            if (!isNaN(data[letter])) passed += 1;
            if (letter === "s" || letter === "l") {
                var percentPatt = /^\d+%$/;
                if (percentPatt.test(data[letter])) passed += 1;
            }
        }
    });
    return checked === passed ? data : false;
};
var $c83151db995a9db5$var$toState = module.exports.toState = function toState(data, oldHue) {
    var color = data.hex ? (0, $c83151db995a9db5$var$_tinycolor2.default)(data.hex) : (0, $c83151db995a9db5$var$_tinycolor2.default)(data);
    var hsl = color.toHsl();
    var hsv = color.toHsv();
    var rgb = color.toRgb();
    var hex = color.toHex();
    if (hsl.s === 0) {
        hsl.h = oldHue || 0;
        hsv.h = oldHue || 0;
    }
    var transparent = hex === "000000" && rgb.a === 0;
    return {
        hsl: hsl,
        hex: transparent ? "transparent" : "#" + hex,
        rgb: rgb,
        hsv: hsv,
        oldHue: data.h || oldHue || hsl.h,
        source: data.source
    };
};
var $c83151db995a9db5$var$isValidHex = module.exports.isValidHex = function isValidHex(hex) {
    if (hex === "transparent") return true;
    // disable hex4 and hex8
    var lh = String(hex).charAt(0) === "#" ? 1 : 0;
    return hex.length !== 4 + lh && hex.length < 7 + lh && (0, $c83151db995a9db5$var$_tinycolor2.default)(hex).isValid();
};
var $c83151db995a9db5$var$getContrastingColor = module.exports.getContrastingColor = function getContrastingColor(data) {
    if (!data) return "#fff";
    var col = $c83151db995a9db5$var$toState(data);
    if (col.hex === "transparent") return "rgba(0,0,0,0.4)";
    var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1000;
    return yiq >= 128 ? "#000" : "#fff";
};
var $c83151db995a9db5$var$red = module.exports.red = {
    hsl: {
        a: 1,
        h: 0,
        l: 0.5,
        s: 1
    },
    hex: "#ff0000",
    rgb: {
        r: 255,
        g: 0,
        b: 0,
        a: 1
    },
    hsv: {
        h: 0,
        s: 1,
        v: 1,
        a: 1
    }
};
var $c83151db995a9db5$var$isvalidColorString = module.exports.isvalidColorString = function isvalidColorString(string, type) {
    var stringWithoutDegree = string.replace("\xb0", "");
    return (0, $c83151db995a9db5$var$_tinycolor2.default)(type + " (" + stringWithoutDegree + ")")._ok;
};

});
parcelRegister("86AaM", function(module, exports) {

module.exports = (parcelRequire("2MeUa"));

});
parcelRegister("2MeUa", function(module, exports) {

var $eQpse = parcelRequire("eQpse");

var $gl8yj = parcelRequire("gl8yj");

var $4hKXW = parcelRequire("4hKXW");

var $5V8oz = parcelRequire("5V8oz");
/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $205ba041c8d66b37$var$forEach(collection, iteratee) {
    var func = $5V8oz(collection) ? $eQpse : $gl8yj;
    return func(collection, $4hKXW(iteratee));
}
module.exports = $205ba041c8d66b37$var$forEach;

});


parcelRegister("lvKY8", function(module, exports) {
// This file is autogenerated. It's used to publish CJS to npm.
(function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    // https://github.com/bgrins/TinyColor
    // Brian Grinstead, MIT License
    var trimLeft = /^\s+/;
    var trimRight = /\s+$/;
    function tinycolor(color, opts) {
        color = color ? color : "";
        opts = opts || {};
        // If input is already a tinycolor, return itself
        if (color instanceof tinycolor) return color;
        // If we are called as a function, call using new instead
        if (!(this instanceof tinycolor)) return new tinycolor(color, opts);
        var rgb = inputToRGB(color);
        this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
        this._gradientType = opts.gradientType;
        // Don't let the range of [0,255] come back in [0,1].
        // Potentially lose a little bit of precision here, but will fix issues where
        // .5 gets interpreted as half of the total, instead of half of 1
        // If it was supposed to be 128, this was already taken care of by `inputToRgb`
        if (this._r < 1) this._r = Math.round(this._r);
        if (this._g < 1) this._g = Math.round(this._g);
        if (this._b < 1) this._b = Math.round(this._b);
        this._ok = rgb.ok;
    }
    tinycolor.prototype = {
        isDark: function isDark() {
            return this.getBrightness() < 128;
        },
        isLight: function isLight() {
            return !this.isDark();
        },
        isValid: function isValid() {
            return this._ok;
        },
        getOriginalInput: function getOriginalInput() {
            return this._originalInput;
        },
        getFormat: function getFormat() {
            return this._format;
        },
        getAlpha: function getAlpha() {
            return this._a;
        },
        getBrightness: function getBrightness() {
            //http://www.w3.org/TR/AERT#color-contrast
            var rgb = this.toRgb();
            return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
        },
        getLuminance: function getLuminance() {
            //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
            var rgb = this.toRgb();
            var RsRGB, GsRGB, BsRGB, R, G, B;
            RsRGB = rgb.r / 255;
            GsRGB = rgb.g / 255;
            BsRGB = rgb.b / 255;
            if (RsRGB <= 0.03928) R = RsRGB / 12.92;
            else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
            if (GsRGB <= 0.03928) G = GsRGB / 12.92;
            else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
            if (BsRGB <= 0.03928) B = BsRGB / 12.92;
            else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
            return 0.2126 * R + 0.7152 * G + 0.0722 * B;
        },
        setAlpha: function setAlpha(value) {
            this._a = boundAlpha(value);
            this._roundA = Math.round(100 * this._a) / 100;
            return this;
        },
        toHsv: function toHsv() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            return {
                h: hsv.h * 360,
                s: hsv.s,
                v: hsv.v,
                a: this._a
            };
        },
        toHsvString: function toHsvString() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            var h = Math.round(hsv.h * 360), s = Math.round(hsv.s * 100), v = Math.round(hsv.v * 100);
            return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
        },
        toHsl: function toHsl() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            return {
                h: hsl.h * 360,
                s: hsl.s,
                l: hsl.l,
                a: this._a
            };
        },
        toHslString: function toHslString() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            var h = Math.round(hsl.h * 360), s = Math.round(hsl.s * 100), l = Math.round(hsl.l * 100);
            return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
        },
        toHex: function toHex(allow3Char) {
            return rgbToHex(this._r, this._g, this._b, allow3Char);
        },
        toHexString: function toHexString(allow3Char) {
            return "#" + this.toHex(allow3Char);
        },
        toHex8: function toHex8(allow4Char) {
            return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
        },
        toHex8String: function toHex8String(allow4Char) {
            return "#" + this.toHex8(allow4Char);
        },
        toRgb: function toRgb() {
            return {
                r: Math.round(this._r),
                g: Math.round(this._g),
                b: Math.round(this._b),
                a: this._a
            };
        },
        toRgbString: function toRgbString() {
            return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
        },
        toPercentageRgb: function toPercentageRgb() {
            return {
                r: Math.round(bound01(this._r, 255) * 100) + "%",
                g: Math.round(bound01(this._g, 255) * 100) + "%",
                b: Math.round(bound01(this._b, 255) * 100) + "%",
                a: this._a
            };
        },
        toPercentageRgbString: function toPercentageRgbString() {
            return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
        },
        toName: function toName() {
            if (this._a === 0) return "transparent";
            if (this._a < 1) return false;
            return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
        },
        toFilter: function toFilter(secondColor) {
            var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
            var secondHex8String = hex8String;
            var gradientType = this._gradientType ? "GradientType = 1, " : "";
            if (secondColor) {
                var s = tinycolor(secondColor);
                secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
            }
            return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
        },
        toString: function toString(format) {
            var formatSet = !!format;
            format = format || this._format;
            var formattedString = false;
            var hasAlpha = this._a < 1 && this._a >= 0;
            var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
            if (needsAlphaFormat) {
                // Special case for "transparent", all other non-alpha formats
                // will return rgba when there is transparency.
                if (format === "name" && this._a === 0) return this.toName();
                return this.toRgbString();
            }
            if (format === "rgb") formattedString = this.toRgbString();
            if (format === "prgb") formattedString = this.toPercentageRgbString();
            if (format === "hex" || format === "hex6") formattedString = this.toHexString();
            if (format === "hex3") formattedString = this.toHexString(true);
            if (format === "hex4") formattedString = this.toHex8String(true);
            if (format === "hex8") formattedString = this.toHex8String();
            if (format === "name") formattedString = this.toName();
            if (format === "hsl") formattedString = this.toHslString();
            if (format === "hsv") formattedString = this.toHsvString();
            return formattedString || this.toHexString();
        },
        clone: function clone() {
            return tinycolor(this.toString());
        },
        _applyModification: function _applyModification(fn, args) {
            var color = fn.apply(null, [
                this
            ].concat([].slice.call(args)));
            this._r = color._r;
            this._g = color._g;
            this._b = color._b;
            this.setAlpha(color._a);
            return this;
        },
        lighten: function lighten() {
            return this._applyModification(_lighten, arguments);
        },
        brighten: function brighten() {
            return this._applyModification(_brighten, arguments);
        },
        darken: function darken() {
            return this._applyModification(_darken, arguments);
        },
        desaturate: function desaturate() {
            return this._applyModification(_desaturate, arguments);
        },
        saturate: function saturate() {
            return this._applyModification(_saturate, arguments);
        },
        greyscale: function greyscale() {
            return this._applyModification(_greyscale, arguments);
        },
        spin: function spin() {
            return this._applyModification(_spin, arguments);
        },
        _applyCombination: function _applyCombination(fn, args) {
            return fn.apply(null, [
                this
            ].concat([].slice.call(args)));
        },
        analogous: function analogous() {
            return this._applyCombination(_analogous, arguments);
        },
        complement: function complement() {
            return this._applyCombination(_complement, arguments);
        },
        monochromatic: function monochromatic() {
            return this._applyCombination(_monochromatic, arguments);
        },
        splitcomplement: function splitcomplement() {
            return this._applyCombination(_splitcomplement, arguments);
        },
        // Disabled until https://github.com/bgrins/TinyColor/issues/254
        // polyad: function (number) {
        //   return this._applyCombination(polyad, [number]);
        // },
        triad: function triad() {
            return this._applyCombination(polyad, [
                3
            ]);
        },
        tetrad: function tetrad() {
            return this._applyCombination(polyad, [
                4
            ]);
        }
    };
    // If input is an object, force 1 into "1.0" to handle ratios properly
    // String input requires "1.0" as input, so 1 will be treated as 1
    tinycolor.fromRatio = function(color, opts) {
        if (_typeof(color) == "object") {
            var newColor = {};
            for(var i in color)if (color.hasOwnProperty(i)) {
                if (i === "a") newColor[i] = color[i];
                else newColor[i] = convertToPercentage(color[i]);
            }
            color = newColor;
        }
        return tinycolor(color, opts);
    };
    // Given a string or object, convert that input to RGB
    // Possible string inputs:
    //
    //     "red"
    //     "#f00" or "f00"
    //     "#ff0000" or "ff0000"
    //     "#ff000000" or "ff000000"
    //     "rgb 255 0 0" or "rgb (255, 0, 0)"
    //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
    //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
    //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
    //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
    //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
    //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
    //
    function inputToRGB(color) {
        var rgb = {
            r: 0,
            g: 0,
            b: 0
        };
        var a = 1;
        var s = null;
        var v = null;
        var l = null;
        var ok = false;
        var format = false;
        if (typeof color == "string") color = stringInputToObject(color);
        if (_typeof(color) == "object") {
            if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
                rgb = rgbToRgb(color.r, color.g, color.b);
                ok = true;
                format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
                s = convertToPercentage(color.s);
                v = convertToPercentage(color.v);
                rgb = hsvToRgb(color.h, s, v);
                ok = true;
                format = "hsv";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
                s = convertToPercentage(color.s);
                l = convertToPercentage(color.l);
                rgb = hslToRgb(color.h, s, l);
                ok = true;
                format = "hsl";
            }
            if (color.hasOwnProperty("a")) a = color.a;
        }
        a = boundAlpha(a);
        return {
            ok: ok,
            format: color.format || format,
            r: Math.min(255, Math.max(rgb.r, 0)),
            g: Math.min(255, Math.max(rgb.g, 0)),
            b: Math.min(255, Math.max(rgb.b, 0)),
            a: a
        };
    }
    // Conversion Functions
    // --------------------
    // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
    // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
    // `rgbToRgb`
    // Handle bounds / percentage checking to conform to CSS color spec
    // <http://www.w3.org/TR/css3-color/>
    // *Assumes:* r, g, b in [0, 255] or [0, 1]
    // *Returns:* { r, g, b } in [0, 255]
    function rgbToRgb(r, g, b) {
        return {
            r: bound01(r, 255) * 255,
            g: bound01(g, 255) * 255,
            b: bound01(b, 255) * 255
        };
    }
    // `rgbToHsl`
    // Converts an RGB color value to HSL.
    // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
    // *Returns:* { h, s, l } in [0,1]
    function rgbToHsl(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, l = (max + min) / 2;
        if (max == min) h = s = 0; // achromatic
        else {
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            l: l
        };
    }
    // `hslToRgb`
    // Converts an HSL color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hslToRgb(h, s, l) {
        var r, g, b;
        h = bound01(h, 360);
        s = bound01(s, 100);
        l = bound01(l, 100);
        function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        }
        if (s === 0) r = g = b = l; // achromatic
        else {
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = hue2rgb(p, q, h + 1 / 3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1 / 3);
        }
        return {
            r: r * 255,
            g: g * 255,
            b: b * 255
        };
    }
    // `rgbToHsv`
    // Converts an RGB color value to HSV
    // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
    // *Returns:* { h, s, v } in [0,1]
    function rgbToHsv(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, v = max;
        var d = max - min;
        s = max === 0 ? 0 : d / max;
        if (max == min) h = 0; // achromatic
        else {
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            v: v
        };
    }
    // `hsvToRgb`
    // Converts an HSV color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hsvToRgb(h, s, v) {
        h = bound01(h, 360) * 6;
        s = bound01(s, 100);
        v = bound01(v, 100);
        var i = Math.floor(h), f = h - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s), mod = i % 6, r = [
            v,
            q,
            p,
            p,
            t,
            v
        ][mod], g = [
            t,
            v,
            v,
            q,
            p,
            p
        ][mod], b = [
            p,
            p,
            t,
            v,
            v,
            q
        ][mod];
        return {
            r: r * 255,
            g: g * 255,
            b: b * 255
        };
    }
    // `rgbToHex`
    // Converts an RGB color to hex
    // Assumes r, g, and b are contained in the set [0, 255]
    // Returns a 3 or 6 character hex
    function rgbToHex(r, g, b, allow3Char) {
        var hex = [
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16))
        ];
        // Return a 3 character hex if possible
        if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
        return hex.join("");
    }
    // `rgbaToHex`
    // Converts an RGBA color plus alpha transparency to hex
    // Assumes r, g, b are contained in the set [0, 255] and
    // a in [0, 1]. Returns a 4 or 8 character rgba hex
    function rgbaToHex(r, g, b, a, allow4Char) {
        var hex = [
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16)),
            pad2(convertDecimalToHex(a))
        ];
        // Return a 4 character hex if possible
        if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
        return hex.join("");
    }
    // `rgbaToArgbHex`
    // Converts an RGBA color to an ARGB Hex8 string
    // Rarely used, but required for "toFilter()"
    function rgbaToArgbHex(r, g, b, a) {
        var hex = [
            pad2(convertDecimalToHex(a)),
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16))
        ];
        return hex.join("");
    }
    // `equals`
    // Can be called with any tinycolor input
    tinycolor.equals = function(color1, color2) {
        if (!color1 || !color2) return false;
        return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
    };
    tinycolor.random = function() {
        return tinycolor.fromRatio({
            r: Math.random(),
            g: Math.random(),
            b: Math.random()
        });
    };
    // Modification Functions
    // ----------------------
    // Thanks to less.js for some of the basics here
    // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
    function _desaturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s -= amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }
    function _saturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s += amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }
    function _greyscale(color) {
        return tinycolor(color).desaturate(100);
    }
    function _lighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l += amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }
    function _brighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var rgb = tinycolor(color).toRgb();
        rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
        rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
        rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
        return tinycolor(rgb);
    }
    function _darken(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l -= amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }
    // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
    // Values outside of this range will be wrapped into this range.
    function _spin(color, amount) {
        var hsl = tinycolor(color).toHsl();
        var hue = (hsl.h + amount) % 360;
        hsl.h = hue < 0 ? 360 + hue : hue;
        return tinycolor(hsl);
    }
    // Combination Functions
    // ---------------------
    // Thanks to jQuery xColor for some of the ideas behind these
    // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
    function _complement(color) {
        var hsl = tinycolor(color).toHsl();
        hsl.h = (hsl.h + 180) % 360;
        return tinycolor(hsl);
    }
    function polyad(color, number) {
        if (isNaN(number) || number <= 0) throw new Error("Argument to polyad must be a positive number");
        var hsl = tinycolor(color).toHsl();
        var result = [
            tinycolor(color)
        ];
        var step = 360 / number;
        for(var i = 1; i < number; i++)result.push(tinycolor({
            h: (hsl.h + i * step) % 360,
            s: hsl.s,
            l: hsl.l
        }));
        return result;
    }
    function _splitcomplement(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({
                h: (h + 72) % 360,
                s: hsl.s,
                l: hsl.l
            }),
            tinycolor({
                h: (h + 216) % 360,
                s: hsl.s,
                l: hsl.l
            })
        ];
    }
    function _analogous(color, results, slices) {
        results = results || 6;
        slices = slices || 30;
        var hsl = tinycolor(color).toHsl();
        var part = 360 / slices;
        var ret = [
            tinycolor(color)
        ];
        for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
            hsl.h = (hsl.h + part) % 360;
            ret.push(tinycolor(hsl));
        }
        return ret;
    }
    function _monochromatic(color, results) {
        results = results || 6;
        var hsv = tinycolor(color).toHsv();
        var h = hsv.h, s = hsv.s, v = hsv.v;
        var ret = [];
        var modification = 1 / results;
        while(results--){
            ret.push(tinycolor({
                h: h,
                s: s,
                v: v
            }));
            v = (v + modification) % 1;
        }
        return ret;
    }
    // Utility Functions
    // ---------------------
    tinycolor.mix = function(color1, color2, amount) {
        amount = amount === 0 ? 0 : amount || 50;
        var rgb1 = tinycolor(color1).toRgb();
        var rgb2 = tinycolor(color2).toRgb();
        var p = amount / 100;
        var rgba = {
            r: (rgb2.r - rgb1.r) * p + rgb1.r,
            g: (rgb2.g - rgb1.g) * p + rgb1.g,
            b: (rgb2.b - rgb1.b) * p + rgb1.b,
            a: (rgb2.a - rgb1.a) * p + rgb1.a
        };
        return tinycolor(rgba);
    };
    // Readability Functions
    // ---------------------
    // <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
    // `contrast`
    // Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
    tinycolor.readability = function(color1, color2) {
        var c1 = tinycolor(color1);
        var c2 = tinycolor(color2);
        return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
    };
    // `isReadable`
    // Ensure that foreground and background color combinations meet WCAG2 guidelines.
    // The third argument is an optional Object.
    //      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
    //      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
    // If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
    // *Example*
    //    tinycolor.isReadable("#000", "#111") => false
    //    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
    tinycolor.isReadable = function(color1, color2, wcag2) {
        var readability = tinycolor.readability(color1, color2);
        var wcag2Parms, out;
        out = false;
        wcag2Parms = validateWCAG2Parms(wcag2);
        switch(wcag2Parms.level + wcag2Parms.size){
            case "AAsmall":
            case "AAAlarge":
                out = readability >= 4.5;
                break;
            case "AAlarge":
                out = readability >= 3;
                break;
            case "AAAsmall":
                out = readability >= 7;
                break;
        }
        return out;
    };
    // `mostReadable`
    // Given a base color and a list of possible foreground or background
    // colors for that base, returns the most readable color.
    // Optionally returns Black or White if the most readable color is unreadable.
    // *Example*
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
    tinycolor.mostReadable = function(baseColor, colorList, args) {
        var bestColor = null;
        var bestScore = 0;
        var readability;
        var includeFallbackColors, level, size;
        args = args || {};
        includeFallbackColors = args.includeFallbackColors;
        level = args.level;
        size = args.size;
        for(var i = 0; i < colorList.length; i++){
            readability = tinycolor.readability(baseColor, colorList[i]);
            if (readability > bestScore) {
                bestScore = readability;
                bestColor = tinycolor(colorList[i]);
            }
        }
        if (tinycolor.isReadable(baseColor, bestColor, {
            level: level,
            size: size
        }) || !includeFallbackColors) return bestColor;
        else {
            args.includeFallbackColors = false;
            return tinycolor.mostReadable(baseColor, [
                "#fff",
                "#000"
            ], args);
        }
    };
    // Big List of Colors
    // ------------------
    // <https://www.w3.org/TR/css-color-4/#named-colors>
    var names = tinycolor.names = {
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "0ff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000",
        blanchedalmond: "ffebcd",
        blue: "00f",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        burntsienna: "ea7e5d",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "0ff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkgrey: "a9a9a9",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkslategrey: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dimgrey: "696969",
        dodgerblue: "1e90ff",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "f0f",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        grey: "808080",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgray: "d3d3d3",
        lightgreen: "90ee90",
        lightgrey: "d3d3d3",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslategray: "789",
        lightslategrey: "789",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "0f0",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "f0f",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370db",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "db7093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        rebeccapurple: "663399",
        red: "f00",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        slategrey: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        wheat: "f5deb3",
        white: "fff",
        whitesmoke: "f5f5f5",
        yellow: "ff0",
        yellowgreen: "9acd32"
    };
    // Make it easy to access colors via `hexNames[hex]`
    var hexNames = tinycolor.hexNames = flip(names);
    // Utilities
    // ---------
    // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
    function flip(o) {
        var flipped = {};
        for(var i in o)if (o.hasOwnProperty(i)) flipped[o[i]] = i;
        return flipped;
    }
    // Return a valid alpha value [0,1] with all invalid values being set to 1
    function boundAlpha(a) {
        a = parseFloat(a);
        if (isNaN(a) || a < 0 || a > 1) a = 1;
        return a;
    }
    // Take input from [0, n] and return it as [0, 1]
    function bound01(n, max) {
        if (isOnePointZero(n)) n = "100%";
        var processPercent = isPercentage(n);
        n = Math.min(max, Math.max(0, parseFloat(n)));
        // Automatically convert percentage into number
        if (processPercent) n = parseInt(n * max, 10) / 100;
        // Handle floating point rounding errors
        if (Math.abs(n - max) < 0.000001) return 1;
        // Convert into [0, 1] range if it isn't already
        return n % max / parseFloat(max);
    }
    // Force a number between 0 and 1
    function clamp01(val) {
        return Math.min(1, Math.max(0, val));
    }
    // Parse a base-16 hex value into a base-10 integer
    function parseIntFromHex(val) {
        return parseInt(val, 16);
    }
    // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
    // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
    function isOnePointZero(n) {
        return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
    }
    // Check to see if string passed in is a percentage
    function isPercentage(n) {
        return typeof n === "string" && n.indexOf("%") != -1;
    }
    // Force a hex value to have 2 characters
    function pad2(c) {
        return c.length == 1 ? "0" + c : "" + c;
    }
    // Replace a decimal with it's percentage value
    function convertToPercentage(n) {
        if (n <= 1) n = n * 100 + "%";
        return n;
    }
    // Converts a decimal to a hex value
    function convertDecimalToHex(d) {
        return Math.round(parseFloat(d) * 255).toString(16);
    }
    // Converts a hex value to a decimal
    function convertHexToDecimal(h) {
        return parseIntFromHex(h) / 255;
    }
    var matchers = function() {
        // <http://www.w3.org/TR/css3-values/#integers>
        var CSS_INTEGER = "[-\\+]?\\d+%?";
        // <http://www.w3.org/TR/css3-values/#number-value>
        var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
        // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
        var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
        // Actual matching.
        // Parentheses and commas are optional, but not required.
        // Whitespace can take the place of commas or opening paren
        var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        return {
            CSS_UNIT: new RegExp(CSS_UNIT),
            rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
            rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
            hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
            hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
            hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
            hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
            hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
            hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
        };
    }();
    // `isValidCSSUnit`
    // Take in a single string / number and check to see if it looks like a CSS unit
    // (see `matchers` above for definition).
    function isValidCSSUnit(color) {
        return !!matchers.CSS_UNIT.exec(color);
    }
    // `stringInputToObject`
    // Permissive string parsing.  Take in a number of formats, and output an object
    // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
    function stringInputToObject(color) {
        color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
        var named = false;
        if (names[color]) {
            color = names[color];
            named = true;
        } else if (color == "transparent") return {
            r: 0,
            g: 0,
            b: 0,
            a: 0,
            format: "name"
        };
        // Try to match string input using regular expressions.
        // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
        // Just return an object and let the conversion functions handle that.
        // This way the result will be the same whether the tinycolor is initialized with string or object.
        var match;
        if (match = matchers.rgb.exec(color)) return {
            r: match[1],
            g: match[2],
            b: match[3]
        };
        if (match = matchers.rgba.exec(color)) return {
            r: match[1],
            g: match[2],
            b: match[3],
            a: match[4]
        };
        if (match = matchers.hsl.exec(color)) return {
            h: match[1],
            s: match[2],
            l: match[3]
        };
        if (match = matchers.hsla.exec(color)) return {
            h: match[1],
            s: match[2],
            l: match[3],
            a: match[4]
        };
        if (match = matchers.hsv.exec(color)) return {
            h: match[1],
            s: match[2],
            v: match[3]
        };
        if (match = matchers.hsva.exec(color)) return {
            h: match[1],
            s: match[2],
            v: match[3],
            a: match[4]
        };
        if (match = matchers.hex8.exec(color)) return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
        if (match = matchers.hex6.exec(color)) return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
        if (match = matchers.hex4.exec(color)) return {
            r: parseIntFromHex(match[1] + "" + match[1]),
            g: parseIntFromHex(match[2] + "" + match[2]),
            b: parseIntFromHex(match[3] + "" + match[3]),
            a: convertHexToDecimal(match[4] + "" + match[4]),
            format: named ? "name" : "hex8"
        };
        if (match = matchers.hex3.exec(color)) return {
            r: parseIntFromHex(match[1] + "" + match[1]),
            g: parseIntFromHex(match[2] + "" + match[2]),
            b: parseIntFromHex(match[3] + "" + match[3]),
            format: named ? "name" : "hex"
        };
        return false;
    }
    function validateWCAG2Parms(parms) {
        // return valid WCAG2 parms for isReadable.
        // If input parms are invalid, return {"level":"AA", "size":"small"}
        var level, size;
        parms = parms || {
            level: "AA",
            size: "small"
        };
        level = (parms.level || "AA").toUpperCase();
        size = (parms.size || "small").toLowerCase();
        if (level !== "AA" && level !== "AAA") level = "AA";
        if (size !== "small" && size !== "large") size = "small";
        return {
            level: level,
            size: size
        };
    }
    return tinycolor;
});

});



parcelRegister("6xzvP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Swatch = undefined;
var $4c315f250c57881e$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $8NFma = parcelRequire("8NFma");
var $4c315f250c57881e$var$_react2 = $4c315f250c57881e$var$_interopRequireDefault($8NFma);

var $32YTy = parcelRequire("32YTy");
var $4c315f250c57881e$var$_reactcss2 = $4c315f250c57881e$var$_interopRequireDefault($32YTy);

var $gxGlt = parcelRequire("gxGlt");

var $1jQs3 = parcelRequire("1jQs3");
var $4c315f250c57881e$var$_Checkboard2 = $4c315f250c57881e$var$_interopRequireDefault($1jQs3);
function $4c315f250c57881e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $4c315f250c57881e$var$ENTER = 13;
var $4c315f250c57881e$var$Swatch = module.exports.Swatch = function Swatch(_ref) {
    var color = _ref.color, style = _ref.style, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onHover = _ref.onHover, _ref$title = _ref.title, title = _ref$title === undefined ? color : _ref$title, children = _ref.children, focus = _ref.focus, _ref$focusStyle = _ref.focusStyle, focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;
    var transparent = color === "transparent";
    var styles = (0, $4c315f250c57881e$var$_reactcss2.default)({
        default: {
            swatch: $4c315f250c57881e$var$_extends({
                background: color,
                height: "100%",
                width: "100%",
                cursor: "pointer",
                position: "relative",
                outline: "none"
            }, style, focus ? focusStyle : {})
        }
    });
    var handleClick = function handleClick(e) {
        return onClick(color, e);
    };
    var handleKeyDown = function handleKeyDown(e) {
        return e.keyCode === $4c315f250c57881e$var$ENTER && onClick(color, e);
    };
    var handleHover = function handleHover(e) {
        return onHover(color, e);
    };
    var optionalEvents = {};
    if (onHover) optionalEvents.onMouseOver = handleHover;
    return $4c315f250c57881e$var$_react2.default.createElement("div", $4c315f250c57881e$var$_extends({
        style: styles.swatch,
        onClick: handleClick,
        title: title,
        tabIndex: 0,
        onKeyDown: handleKeyDown
    }, optionalEvents), children, transparent && $4c315f250c57881e$var$_react2.default.createElement($4c315f250c57881e$var$_Checkboard2.default, {
        borderRadius: styles.swatch.borderRadius,
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.1)"
    }));
};
module.exports.default = (0, $gxGlt.handleFocus)($4c315f250c57881e$var$Swatch);

});
parcelRegister("gxGlt", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.handleFocus = undefined;
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $8NFma = parcelRequire("8NFma");
var _react2 = _interopRequireDefault($8NFma);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint-disable no-invalid-this */ 
var handleFocus = exports.handleFocus = function handleFocus(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "span";
    return function(_React$Component) {
        _inherits(Focus, _React$Component);
        function Focus() {
            var _ref;
            var _temp, _this, _ret;
            _classCallCheck(this, Focus);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                focus: false
            }, _this.handleFocus = function() {
                return _this.setState({
                    focus: true
                });
            }, _this.handleBlur = function() {
                return _this.setState({
                    focus: false
                });
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }
        _createClass(Focus, [
            {
                key: "render",
                value: function render() {
                    return _react2.default.createElement(Span, {
                        onFocus: this.handleFocus,
                        onBlur: this.handleBlur
                    }, _react2.default.createElement(Component, _extends({}, this.props, this.state)));
                }
            }
        ]);
        return Focus;
    }(_react2.default.Component);
};

});



parcelRegister("atmUA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SketchFields = undefined;

var $8NFma = parcelRequire("8NFma");
var $79fe629f5a49de70$var$_react2 = $79fe629f5a49de70$var$_interopRequireDefault($8NFma);

var $32YTy = parcelRequire("32YTy");
var $79fe629f5a49de70$var$_reactcss2 = $79fe629f5a49de70$var$_interopRequireDefault($32YTy);

var $hbCun = parcelRequire("hbCun");
var $79fe629f5a49de70$var$color = $79fe629f5a49de70$var$_interopRequireWildcard($hbCun);

var $9Nyg4 = parcelRequire("9Nyg4");
function $79fe629f5a49de70$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $79fe629f5a49de70$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/* eslint-disable no-param-reassign */ var $79fe629f5a49de70$var$SketchFields = module.exports.SketchFields = function SketchFields(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hex = _ref.hex, disableAlpha = _ref.disableAlpha;
    var styles = (0, $79fe629f5a49de70$var$_reactcss2.default)({
        "default": {
            fields: {
                display: "flex",
                paddingTop: "4px"
            },
            single: {
                flex: "1",
                paddingLeft: "6px"
            },
            alpha: {
                flex: "1",
                paddingLeft: "6px"
            },
            double: {
                flex: "2"
            },
            input: {
                width: "80%",
                padding: "4px 10% 3px",
                border: "none",
                boxShadow: "inset 0 0 0 1px #ccc",
                fontSize: "11px"
            },
            label: {
                display: "block",
                textAlign: "center",
                fontSize: "11px",
                color: "#222",
                paddingTop: "3px",
                paddingBottom: "4px",
                textTransform: "capitalize"
            }
        },
        "disableAlpha": {
            alpha: {
                display: "none"
            }
        }
    }, {
        disableAlpha: disableAlpha
    });
    var handleChange = function handleChange(data, e) {
        if (data.hex) $79fe629f5a49de70$var$color.isValidHex(data.hex) && onChange({
            hex: data.hex,
            source: "hex"
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            a: rgb.a,
            source: "rgb"
        }, e);
        else if (data.a) {
            if (data.a < 0) data.a = 0;
            else if (data.a > 100) data.a = 100;
            data.a /= 100;
            onChange({
                h: hsl.h,
                s: hsl.s,
                l: hsl.l,
                a: data.a,
                source: "rgb"
            }, e);
        }
    };
    return $79fe629f5a49de70$var$_react2.default.createElement("div", {
        style: styles.fields,
        className: "flexbox-fix"
    }, $79fe629f5a49de70$var$_react2.default.createElement("div", {
        style: styles.double
    }, $79fe629f5a49de70$var$_react2.default.createElement($9Nyg4.EditableInput, {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "hex",
        value: hex.replace("#", ""),
        onChange: handleChange
    })), $79fe629f5a49de70$var$_react2.default.createElement("div", {
        style: styles.single
    }, $79fe629f5a49de70$var$_react2.default.createElement($9Nyg4.EditableInput, {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "r",
        value: rgb.r,
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "255"
    })), $79fe629f5a49de70$var$_react2.default.createElement("div", {
        style: styles.single
    }, $79fe629f5a49de70$var$_react2.default.createElement($9Nyg4.EditableInput, {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "g",
        value: rgb.g,
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "255"
    })), $79fe629f5a49de70$var$_react2.default.createElement("div", {
        style: styles.single
    }, $79fe629f5a49de70$var$_react2.default.createElement($9Nyg4.EditableInput, {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "b",
        value: rgb.b,
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "255"
    })), $79fe629f5a49de70$var$_react2.default.createElement("div", {
        style: styles.alpha
    }, $79fe629f5a49de70$var$_react2.default.createElement($9Nyg4.EditableInput, {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "a",
        value: Math.round(rgb.a * 100),
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "100"
    })));
};
module.exports.default = $79fe629f5a49de70$var$SketchFields;

});

parcelRegister("fxPNj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SketchPresetColors = undefined;
var $b5121d5b5b11c80e$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $8NFma = parcelRequire("8NFma");
var $b5121d5b5b11c80e$var$_react2 = $b5121d5b5b11c80e$var$_interopRequireDefault($8NFma);

var $fb0st = parcelRequire("fb0st");
var $b5121d5b5b11c80e$var$_propTypes2 = $b5121d5b5b11c80e$var$_interopRequireDefault($fb0st);

var $32YTy = parcelRequire("32YTy");
var $b5121d5b5b11c80e$var$_reactcss2 = $b5121d5b5b11c80e$var$_interopRequireDefault($32YTy);

var $9Nyg4 = parcelRequire("9Nyg4");
function $b5121d5b5b11c80e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b5121d5b5b11c80e$var$SketchPresetColors = module.exports.SketchPresetColors = function SketchPresetColors(_ref) {
    var colors = _ref.colors, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover;
    var styles = (0, $b5121d5b5b11c80e$var$_reactcss2.default)({
        "default": {
            colors: {
                margin: "0 -10px",
                padding: "10px 0 0 10px",
                borderTop: "1px solid #eee",
                display: "flex",
                flexWrap: "wrap",
                position: "relative"
            },
            swatchWrap: {
                width: "16px",
                height: "16px",
                margin: "0 10px 10px 0"
            },
            swatch: {
                borderRadius: "3px",
                boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15)"
            }
        },
        "no-presets": {
            colors: {
                display: "none"
            }
        }
    }, {
        "no-presets": !colors || !colors.length
    });
    var handleClick = function handleClick(hex, e) {
        onClick({
            hex: hex,
            source: "hex"
        }, e);
    };
    return $b5121d5b5b11c80e$var$_react2.default.createElement("div", {
        style: styles.colors,
        className: "flexbox-fix"
    }, colors.map(function(colorObjOrString) {
        var c = typeof colorObjOrString === "string" ? {
            color: colorObjOrString
        } : colorObjOrString;
        var key = "" + c.color + (c.title || "");
        return $b5121d5b5b11c80e$var$_react2.default.createElement("div", {
            key: key,
            style: styles.swatchWrap
        }, $b5121d5b5b11c80e$var$_react2.default.createElement($9Nyg4.Swatch, $b5121d5b5b11c80e$var$_extends({}, c, {
            style: styles.swatch,
            onClick: handleClick,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px " + c.color
            }
        })));
    }));
};
$b5121d5b5b11c80e$var$SketchPresetColors.propTypes = {
    colors: $b5121d5b5b11c80e$var$_propTypes2.default.arrayOf($b5121d5b5b11c80e$var$_propTypes2.default.oneOfType([
        $b5121d5b5b11c80e$var$_propTypes2.default.string,
        $b5121d5b5b11c80e$var$_propTypes2.default.shape({
            color: $b5121d5b5b11c80e$var$_propTypes2.default.string,
            title: $b5121d5b5b11c80e$var$_propTypes2.default.string
        })
    ])).isRequired
};
module.exports.default = $b5121d5b5b11c80e$var$SketchPresetColors;

});



parcelRegister("hPyFl", function(module, exports) {
"use strict";
var $cfb21703b3800802$var$__rest = module.exports && module.exports.__rest || function(e, t) {
    var a = {};
    for(var l in e)Object.prototype.hasOwnProperty.call(e, l) && t.indexOf(l) < 0 && (a[l] = e[l]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var n = 0;
        for(l = Object.getOwnPropertySymbols(e); n < l.length; n++)t.indexOf(l[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, l[n]) && (a[l[n]] = e[l[n]]);
    }
    return a;
}, $cfb21703b3800802$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.FiltersPicker = module.exports.NumberInput = void 0;

const $cfb21703b3800802$var$react_1 = $cfb21703b3800802$var$__importDefault((parcelRequire("8NFma")));

var $2nesQ = parcelRequire("2nesQ");
var $gUePa = parcelRequire("gUePa");
var $cQj25 = parcelRequire("cQj25");
var $ixLVk = parcelRequire("ixLVk");
var $71KpR = parcelRequire("71KpR");
var $88Rzx = parcelRequire("88Rzx");
var $5r5rj = parcelRequire("5r5rj");

var $2nesQ = parcelRequire("2nesQ");
var $gUePa = parcelRequire("gUePa");
var $cQj25 = parcelRequire("cQj25");
var $ixLVk = parcelRequire("ixLVk");
var $71KpR = parcelRequire("71KpR");
var $88Rzx = parcelRequire("88Rzx");
var $5r5rj = parcelRequire("5r5rj");
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

const $cfb21703b3800802$var$color_picker_1 = $cfb21703b3800802$var$__importDefault((parcelRequire("gaqum")));

var $xARwM = parcelRequire("xARwM");
const $cfb21703b3800802$var$limit = (e, t, a)=>Math.max(t, Math.min(a, e)), $cfb21703b3800802$var$NumberInput = (e)=>{
    var { value: t, onValueChange: a } = e, l = $cfb21703b3800802$var$__rest(e, [
        "value",
        "onValueChange"
    ]);
    const [n, r] = $cfb21703b3800802$var$react_1.default.useState(t.toString());
    $cfb21703b3800802$var$react_1.default.useEffect(()=>{
        r(t.toString());
    }, [
        t
    ]);
    return $cfb21703b3800802$var$react_1.default.createElement($cQj25.NumericInput, Object.assign({
        value: n,
        onValueChange: (e, t)=>{
            r(t), Number.isNaN(e) || a(e);
        }
    }, l));
};
module.exports.NumberInput = $cfb21703b3800802$var$NumberInput;
const $cfb21703b3800802$var$EnablerNumberInput = ({ label: e, enabled: t, visible: a = !0, onEnabledChange: l, numberValue: n, onNumberValueChange: r, min: o, max: i })=>a ? $cfb21703b3800802$var$react_1.default.createElement($cfb21703b3800802$var$react_1.default.Fragment, null, $cfb21703b3800802$var$react_1.default.createElement($5r5rj.Switch, {
        checked: t,
        label: e,
        onChange: (e)=>{
            l(e.target.checked);
        },
        alignIndicator: $2nesQ.Alignment.RIGHT,
        style: {
            marginTop: "20px"
        }
    }), t && $cfb21703b3800802$var$react_1.default.createElement("div", {
        style: {
            display: "flex",
            width: "100%",
            justifyContent: "space-between"
        }
    }, $cfb21703b3800802$var$react_1.default.createElement("div", {
        style: {
            paddingTop: "7px"
        }
    }, $cfb21703b3800802$var$react_1.default.createElement($88Rzx.Slider, {
        value: n,
        onChange: (e)=>{
            r(e);
        },
        min: o,
        max: i,
        labelStepSize: 50,
        showTrackFill: !1,
        labelRenderer: !1
    })), $cfb21703b3800802$var$react_1.default.createElement($cQj25.NumericInput, {
        value: n,
        onValueChange: (e)=>{
            r($cfb21703b3800802$var$limit(e, o, i));
        },
        buttonPosition: "none",
        style: {
            width: "45px",
            padding: "0 5px",
            marginLeft: "10px"
        },
        min: o,
        max: i
    }))) : null;
module.exports.FiltersPicker = (0, $O1ETn.observer)(({ element: e, store: t, elements: a })=>{
    const l = a || [
        e
    ], n = l[0], r = "text" === n.type, o = "image" === n.type, i = "svg" === n.type, d = o || i, c = (e)=>{
        t.history.transaction(()=>{
            l.forEach((t)=>{
                t.set(e);
            });
        });
    };
    return $cfb21703b3800802$var$react_1.default.createElement($ixLVk.Popover, {
        content: $cfb21703b3800802$var$react_1.default.createElement("div", {
            style: {
                padding: "15px",
                paddingTop: "15px",
                width: "230px",
                maxHeight: "calc(100vh - 150px)",
                overflow: "auto"
            }
        }, $cfb21703b3800802$var$react_1.default.createElement($cfb21703b3800802$var$EnablerNumberInput, {
            label: (0, $xARwM.t)("toolbar.blur"),
            enabled: n.blurEnabled,
            visible: d || r,
            onEnabledChange: (e)=>{
                c({
                    blurEnabled: e
                });
            },
            numberValue: n.blurRadius,
            onNumberValueChange: (e)=>{
                c({
                    blurRadius: e
                });
            },
            min: 0,
            max: 100
        }), $cfb21703b3800802$var$react_1.default.createElement($cfb21703b3800802$var$EnablerNumberInput, {
            label: (0, $xARwM.t)("toolbar.brightness"),
            visible: d,
            enabled: n.brightnessEnabled,
            onEnabledChange: (e)=>{
                c({
                    brightnessEnabled: e
                });
            },
            numberValue: 100 * n.brightness + 100,
            onNumberValueChange: (e)=>{
                c({
                    brightness: (e - 100) / 100
                });
            },
            min: 0,
            max: 200
        }), d && $cfb21703b3800802$var$react_1.default.createElement($5r5rj.Switch, {
            checked: n.sepiaEnabled,
            label: (0, $xARwM.t)("toolbar.sepia"),
            onChange: (e)=>{
                c({
                    sepiaEnabled: e.target.checked
                });
            },
            alignIndicator: $2nesQ.Alignment.RIGHT,
            style: {
                marginTop: "20px"
            }
        }), d && $cfb21703b3800802$var$react_1.default.createElement($5r5rj.Switch, {
            checked: n.grayscaleEnabled,
            label: (0, $xARwM.t)("toolbar.grayscale"),
            onChange: (e)=>{
                c({
                    grayscaleEnabled: e.target.checked
                });
            },
            alignIndicator: $2nesQ.Alignment.RIGHT,
            style: {
                marginTop: "20px"
            }
        }), r && $cfb21703b3800802$var$react_1.default.createElement($5r5rj.Switch, {
            checked: !!n.strokeWidth,
            label: (0, $xARwM.t)("toolbar.textStroke"),
            onChange: (e)=>{
                c({
                    strokeWidth: e.target.checked ? 2 : 0
                });
            },
            alignIndicator: $2nesQ.Alignment.RIGHT,
            style: {
                marginTop: "20px"
            }
        }), r && !!n.strokeWidth && $cfb21703b3800802$var$react_1.default.createElement($cfb21703b3800802$var$react_1.default.Fragment, null, $cfb21703b3800802$var$react_1.default.createElement("div", {
            style: {
                display: "flex",
                justifyContent: "space-between"
            }
        }, $cfb21703b3800802$var$react_1.default.createElement($cfb21703b3800802$var$color_picker_1.default, {
            value: n.stroke,
            size: 30,
            onChange: (e)=>{
                c({
                    stroke: e
                });
            },
            store: t
        }), $cfb21703b3800802$var$react_1.default.createElement($cQj25.NumericInput, {
            defaultValue: n.strokeWidth,
            onValueChange: (e)=>{
                c({
                    strokeWidth: $cfb21703b3800802$var$limit(e, 1, 30)
                });
            },
            style: {
                width: "80px"
            },
            min: 1,
            max: Math.round(n.fontSize / 2)
        }))), r && $cfb21703b3800802$var$react_1.default.createElement($5r5rj.Switch, {
            checked: !!n.backgroundEnabled,
            label: (0, $xARwM.t)("toolbar.textBackground"),
            onChange: (e)=>{
                c({
                    backgroundEnabled: e.target.checked
                });
            },
            alignIndicator: $2nesQ.Alignment.RIGHT,
            style: {
                marginTop: "20px"
            }
        }), !!n.backgroundEnabled && $cfb21703b3800802$var$react_1.default.createElement($cfb21703b3800802$var$react_1.default.Fragment, null, $cfb21703b3800802$var$react_1.default.createElement("div", {
            style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                paddingTop: "5px",
                paddingBottom: "5px"
            }
        }, $cfb21703b3800802$var$react_1.default.createElement("div", null, (0, $xARwM.t)("toolbar.backgroundCornerRadius")), $cfb21703b3800802$var$react_1.default.createElement("div", null, $cfb21703b3800802$var$react_1.default.createElement(module.exports.NumberInput, {
            value: 100 * n.backgroundCornerRadius,
            onValueChange: (e)=>{
                c({
                    backgroundCornerRadius: $cfb21703b3800802$var$limit(e, 0, 100) / 100
                });
            },
            style: {
                width: "50px"
            },
            min: 0,
            max: 100,
            buttonPosition: "none"
        }))), $cfb21703b3800802$var$react_1.default.createElement($88Rzx.Slider, {
            value: 100 * n.backgroundCornerRadius,
            onChange: (e)=>{
                c({
                    backgroundCornerRadius: $cfb21703b3800802$var$limit(e, 0, 100) / 100
                });
            },
            min: 0,
            max: 100,
            labelRenderer: !1
        }), $cfb21703b3800802$var$react_1.default.createElement("div", {
            style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                paddingTop: "5px",
                paddingBottom: "5px"
            }
        }, $cfb21703b3800802$var$react_1.default.createElement("div", null, (0, $xARwM.t)("toolbar.backgroundPadding")), $cfb21703b3800802$var$react_1.default.createElement("div", null, $cfb21703b3800802$var$react_1.default.createElement(module.exports.NumberInput, {
            value: Math.round(100 * n.backgroundPadding),
            onValueChange: (e)=>{
                c({
                    backgroundPadding: $cfb21703b3800802$var$limit(e, 0, 100) / 100
                });
            },
            style: {
                width: "50px"
            },
            min: 0,
            max: 100,
            buttonPosition: "none"
        }))), $cfb21703b3800802$var$react_1.default.createElement($88Rzx.Slider, {
            value: Math.round(100 * n.backgroundPadding),
            onChange: (e)=>{
                c({
                    backgroundPadding: $cfb21703b3800802$var$limit(e, 0, 100) / 100
                });
            },
            min: 0,
            max: 100,
            labelRenderer: !1
        }), $cfb21703b3800802$var$react_1.default.createElement("div", {
            style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                paddingTop: "5px",
                paddingBottom: "5px"
            }
        }, $cfb21703b3800802$var$react_1.default.createElement("div", null, (0, $xARwM.t)("toolbar.opacity")), $cfb21703b3800802$var$react_1.default.createElement("div", null, $cfb21703b3800802$var$react_1.default.createElement(module.exports.NumberInput, {
            value: Math.round(100 * n.backgroundOpacity),
            onValueChange: (e)=>{
                c({
                    backgroundOpacity: e / 100
                });
            },
            style: {
                width: "50px"
            },
            min: 0,
            max: 100,
            buttonPosition: "none"
        }))), $cfb21703b3800802$var$react_1.default.createElement($88Rzx.Slider, {
            value: 100 * n.backgroundOpacity,
            onChange: (e)=>{
                c({
                    backgroundOpacity: e / 100
                });
            },
            min: 0,
            max: 100,
            labelRenderer: !1
        }), $cfb21703b3800802$var$react_1.default.createElement("div", {
            style: {
                display: "flex",
                justifyContent: "space-between",
                paddingTop: "5px",
                paddingBottom: "5px"
            }
        }, $cfb21703b3800802$var$react_1.default.createElement("div", {
            style: {
                lineHeight: "30px"
            }
        }, (0, $xARwM.t)("toolbar.color")), $cfb21703b3800802$var$react_1.default.createElement($cfb21703b3800802$var$color_picker_1.default, {
            value: n.backgroundColor,
            size: 30,
            onChange: (e)=>{
                c({
                    backgroundColor: e
                });
            },
            store: t
        }))), d && $cfb21703b3800802$var$react_1.default.createElement($5r5rj.Switch, {
            checked: !!n.borderSize,
            label: (0, $xARwM.t)("toolbar.border"),
            onChange: (e)=>{
                c({
                    borderSize: e.target.checked ? 2 : 0
                });
            },
            alignIndicator: $2nesQ.Alignment.RIGHT,
            style: {
                marginTop: "20px"
            }
        }), !!n.borderSize && $cfb21703b3800802$var$react_1.default.createElement($cfb21703b3800802$var$react_1.default.Fragment, null, $cfb21703b3800802$var$react_1.default.createElement("div", {
            style: {
                display: "flex",
                justifyContent: "space-between"
            }
        }, $cfb21703b3800802$var$react_1.default.createElement($cfb21703b3800802$var$color_picker_1.default, {
            value: n.borderColor,
            size: 30,
            onChange: (e)=>{
                c({
                    borderColor: e
                });
            },
            store: t
        }), $cfb21703b3800802$var$react_1.default.createElement($cQj25.NumericInput, {
            defaultValue: n.borderSize,
            onValueChange: (e)=>{
                c({
                    borderSize: $cfb21703b3800802$var$limit(e, 1, Math.min(n.width, n.height) / 2)
                });
            },
            style: {
                width: "80px"
            },
            min: 1,
            max: Math.max(1, Math.min(n.width, n.height) / 2)
        }))), d && $cfb21703b3800802$var$react_1.default.createElement($5r5rj.Switch, {
            checked: !!n.cornerRadius,
            label: (0, $xARwM.t)("toolbar.cornerRadius"),
            onChange: (e)=>{
                c({
                    cornerRadius: e.target.checked ? Math.min(n.width / 4, n.height / 4) : 0
                });
            },
            alignIndicator: $2nesQ.Alignment.RIGHT,
            style: {
                marginTop: "20px"
            }
        }), d && !!n.cornerRadius && $cfb21703b3800802$var$react_1.default.createElement("div", {
            style: {
                display: "flex",
                width: "100%",
                justifyContent: "space-between"
            }
        }, $cfb21703b3800802$var$react_1.default.createElement("div", {
            style: {
                width: "150px",
                paddingTop: "7px"
            }
        }, $cfb21703b3800802$var$react_1.default.createElement($88Rzx.Slider, {
            value: Math.min(n.cornerRadius, Math.round(Math.min(n.width / 2, n.height / 2))),
            onChange: (e)=>{
                c({
                    cornerRadius: e
                });
            },
            min: 1,
            max: Math.round(Math.min(n.width / 2, n.height / 2)),
            labelStepSize: 50,
            showTrackFill: !1,
            labelRenderer: !1
        })), $cfb21703b3800802$var$react_1.default.createElement($cQj25.NumericInput, {
            value: n.cornerRadius,
            onValueChange: (e)=>{
                c({
                    cornerRadius: $cfb21703b3800802$var$limit(e, 1, Math.min(n.width, n.height) / 2)
                });
            },
            buttonPosition: "none",
            style: {
                width: "45px",
                padding: "0 5px"
            },
            min: 1,
            max: Math.round(Math.min(n.width / 2, n.height / 2))
        })), $cfb21703b3800802$var$react_1.default.createElement($5r5rj.Switch, {
            checked: n.shadowEnabled,
            label: (0, $xARwM.t)("toolbar.shadow"),
            onChange: (e)=>{
                c({
                    shadowEnabled: e.target.checked
                });
            },
            alignIndicator: $2nesQ.Alignment.RIGHT,
            style: {
                marginTop: "20px"
            }
        }), n.shadowEnabled && $cfb21703b3800802$var$react_1.default.createElement($cfb21703b3800802$var$react_1.default.Fragment, null, $cfb21703b3800802$var$react_1.default.createElement("div", {
            style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                paddingTop: "5px",
                paddingBottom: "5px"
            }
        }, $cfb21703b3800802$var$react_1.default.createElement("div", null, (0, $xARwM.t)("toolbar.blur")), $cfb21703b3800802$var$react_1.default.createElement("div", null, $cfb21703b3800802$var$react_1.default.createElement(module.exports.NumberInput, {
            value: n.shadowBlur,
            onValueChange: (e)=>{
                c({
                    shadowBlur: $cfb21703b3800802$var$limit(e, -50, 50)
                });
            },
            style: {
                width: "50px"
            },
            min: 0,
            max: 50,
            buttonPosition: "none"
        }))), $cfb21703b3800802$var$react_1.default.createElement($88Rzx.Slider, {
            value: n.shadowBlur,
            onChange: (e)=>{
                c({
                    shadowBlur: e
                });
            },
            min: 0,
            max: 50,
            showTrackFill: !1,
            labelRenderer: !1
        }), $cfb21703b3800802$var$react_1.default.createElement("div", {
            style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                paddingTop: "5px",
                paddingBottom: "5px"
            }
        }, $cfb21703b3800802$var$react_1.default.createElement("div", null, (0, $xARwM.t)("toolbar.offsetX")), $cfb21703b3800802$var$react_1.default.createElement("div", null, $cfb21703b3800802$var$react_1.default.createElement(module.exports.NumberInput, {
            value: n.shadowOffsetX,
            onValueChange: (e)=>{
                c({
                    shadowOffsetX: $cfb21703b3800802$var$limit(e, -50, 50)
                });
            },
            style: {
                width: "50px"
            },
            min: -50,
            max: 50,
            buttonPosition: "none"
        }))), $cfb21703b3800802$var$react_1.default.createElement($88Rzx.Slider, {
            value: n.shadowOffsetX,
            onChange: (e)=>{
                c({
                    shadowOffsetX: e
                });
            },
            min: -50,
            max: 50,
            showTrackFill: !1,
            labelRenderer: !1
        }), $cfb21703b3800802$var$react_1.default.createElement("div", {
            style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                paddingTop: "5px",
                paddingBottom: "5px"
            }
        }, $cfb21703b3800802$var$react_1.default.createElement("div", null, (0, $xARwM.t)("toolbar.offsetY")), $cfb21703b3800802$var$react_1.default.createElement("div", null, $cfb21703b3800802$var$react_1.default.createElement(module.exports.NumberInput, {
            value: n.shadowOffsetY,
            onValueChange: (e)=>{
                c({
                    shadowOffsetY: $cfb21703b3800802$var$limit(e, -50, 50)
                });
            },
            style: {
                width: "50px"
            },
            min: -50,
            max: 50,
            buttonPosition: "none"
        }))), $cfb21703b3800802$var$react_1.default.createElement($88Rzx.Slider, {
            value: n.shadowOffsetY,
            onChange: (e)=>{
                c({
                    shadowOffsetY: e
                });
            },
            min: -50,
            max: 50,
            showTrackFill: !1,
            labelRenderer: !1
        }), $cfb21703b3800802$var$react_1.default.createElement("div", {
            style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                paddingTop: "5px",
                paddingBottom: "5px"
            }
        }, $cfb21703b3800802$var$react_1.default.createElement("div", null, (0, $xARwM.t)("toolbar.opacity")), $cfb21703b3800802$var$react_1.default.createElement("div", null, $cfb21703b3800802$var$react_1.default.createElement(module.exports.NumberInput, {
            value: Math.round(100 * n.shadowOpacity),
            onValueChange: (e)=>{
                c({
                    shadowOpacity: e / 100
                });
            },
            style: {
                width: "50px"
            },
            min: 0,
            max: 100,
            buttonPosition: "none"
        }))), $cfb21703b3800802$var$react_1.default.createElement($88Rzx.Slider, {
            value: 100 * n.shadowOpacity,
            onChange: (e)=>{
                c({
                    shadowOpacity: e / 100
                });
            },
            min: 0,
            max: 100,
            labelRenderer: !1
        }), $cfb21703b3800802$var$react_1.default.createElement("div", {
            style: {
                display: "flex",
                justifyContent: "space-between",
                paddingTop: "5px",
                paddingBottom: "5px"
            }
        }, $cfb21703b3800802$var$react_1.default.createElement("div", {
            style: {
                lineHeight: "30px"
            }
        }, (0, $xARwM.t)("toolbar.color")), $cfb21703b3800802$var$react_1.default.createElement($cfb21703b3800802$var$color_picker_1.default, {
            value: n.shadowColor,
            size: 30,
            onChange: (e)=>{
                c({
                    shadowColor: e
                });
            },
            store: t
        })))),
        position: $71KpR.Position.BOTTOM
    }, $cfb21703b3800802$var$react_1.default.createElement($gUePa.Button, {
        icon: "left-join",
        text: (0, $xARwM.t)("toolbar.effects"),
        minimal: !0
    }));
}), module.exports.default = module.exports.FiltersPicker;

});
parcelRegister("5r5rj", function(module, exports) {

$parcel$export(module.exports, "Switch", () => $3f53b18e118531fe$export$b5d5cf8927ab7262);
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $auzpd = parcelRequire("auzpd");
var $8k66C = parcelRequire("8k66C");

var $hffzE = parcelRequire("hffzE");
/**
 * Renders common control elements, with additional props to customize appearance.
 * This component is not exported and is only used within this module for `Checkbox`, `Radio`, and `Switch` below.
 */ var $3f53b18e118531fe$var$ControlInternal = $8NFma.forwardRef(function(props, ref) {
    var _a;
    var alignIndicator = props.alignIndicator, children = props.children, className = props.className, indicatorChildren = props.indicatorChildren, inline = props.inline, inputRef = props.inputRef, label = props.label, labelElement = props.labelElement, large = props.large, style = props.style, type = props.type, typeClassName = props.typeClassName, _b = props.tagName, tagName = _b === void 0 ? "label" : _b, htmlProps = (0, $gztBd.__rest)(props, [
        "alignIndicator",
        "children",
        "className",
        "indicatorChildren",
        "inline",
        "inputRef",
        "label",
        "labelElement",
        "large",
        "style",
        "type",
        "typeClassName",
        "tagName"
    ]);
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $auzpd).CONTROL, typeClassName, (_a = {}, _a[(0, $auzpd).DISABLED] = htmlProps.disabled, _a[(0, $auzpd).INLINE] = inline, _a[(0, $auzpd).LARGE] = large, _a), (0, $auzpd).alignmentClass(alignIndicator), className);
    return $8NFma.createElement(tagName, {
        className: classes,
        style: style,
        ref: ref
    }, $8NFma.createElement("input", (0, $gztBd.__assign)({}, htmlProps, {
        ref: inputRef,
        type: type
    })), $8NFma.createElement("span", {
        className: (0, $auzpd).CONTROL_INDICATOR
    }, indicatorChildren), label, labelElement, children);
});
$3f53b18e118531fe$var$ControlInternal.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".Control");
var $3f53b18e118531fe$export$b5d5cf8927ab7262 = $8NFma.forwardRef(function(_a, ref) {
    var innerLabelChecked = _a.innerLabelChecked, innerLabel = _a.innerLabel, controlProps = (0, $gztBd.__rest)(_a, [
        "innerLabelChecked",
        "innerLabel"
    ]);
    var switchLabels = innerLabel || innerLabelChecked ? [
        $8NFma.createElement("div", {
            key: "checked",
            className: (0, $auzpd).CONTROL_INDICATOR_CHILD
        }, $8NFma.createElement("div", {
            className: (0, $auzpd).SWITCH_INNER_TEXT
        }, innerLabelChecked ? innerLabelChecked : innerLabel)),
        $8NFma.createElement("div", {
            key: "unchecked",
            className: (0, $auzpd).CONTROL_INDICATOR_CHILD
        }, $8NFma.createElement("div", {
            className: (0, $auzpd).SWITCH_INNER_TEXT
        }, innerLabel))
    ] : null;
    return $8NFma.createElement($3f53b18e118531fe$var$ControlInternal, (0, $gztBd.__assign)({}, controlProps, {
        indicatorChildren: switchLabels,
        ref: ref,
        type: "checkbox",
        typeClassName: (0, $auzpd).SWITCH
    }));
});
$3f53b18e118531fe$export$b5d5cf8927ab7262.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".Switch");
var $3f53b18e118531fe$export$d7b12c4107be0d61 = $8NFma.forwardRef(function(props, ref) {
    return $8NFma.createElement($3f53b18e118531fe$var$ControlInternal, (0, $gztBd.__assign)({}, props, {
        ref: ref,
        type: "radio",
        typeClassName: (0, $auzpd).RADIO
    }));
});
$3f53b18e118531fe$export$d7b12c4107be0d61.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".Radio");
var $3f53b18e118531fe$export$48513f6b9f8ce62d = $8NFma.forwardRef(function(props, ref) {
    var defaultIndeterminate = props.defaultIndeterminate, indeterminate = props.indeterminate, onChange = props.onChange, controlProps = (0, $gztBd.__rest)(props, [
        "defaultIndeterminate",
        "indeterminate",
        "onChange"
    ]);
    var _a = $8NFma.useState(indeterminate || defaultIndeterminate || false), isIndeterminate = _a[0], setIsIndeterminate = _a[1];
    var localInputRef = $8NFma.useRef(null);
    var inputRef = props.inputRef === undefined ? localInputRef : (0, $8k66C.mergeRefs)(props.inputRef, localInputRef);
    var handleChange = $8NFma.useCallback(function(evt) {
        // update state immediately only if uncontrolled
        if (indeterminate === undefined) setIsIndeterminate(evt.target.indeterminate);
        // otherwise wait for props change. always invoke handler.
        onChange === null || onChange === void 0 || onChange(evt);
    }, [
        indeterminate,
        onChange
    ]);
    $8NFma.useEffect(function() {
        if (indeterminate !== undefined) setIsIndeterminate(indeterminate);
    }, [
        indeterminate
    ]);
    $8NFma.useEffect(function() {
        if (localInputRef.current != null) localInputRef.current.indeterminate = isIndeterminate;
    }, [
        localInputRef,
        isIndeterminate
    ]);
    return $8NFma.createElement($3f53b18e118531fe$var$ControlInternal, (0, $gztBd.__assign)({}, controlProps, {
        inputRef: inputRef,
        onChange: handleChange,
        ref: ref,
        type: "checkbox",
        typeClassName: (0, $auzpd).CHECKBOX
    }));
});
$3f53b18e118531fe$export$48513f6b9f8ce62d.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".Checkbox");

});


parcelRegister("45tk4", function(module, exports) {
"use strict";
var $2f9e5feda9ce7879$var$__rest = module.exports && module.exports.__rest || function(e, t) {
    var n = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (n[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var r = 0;
        for(a = Object.getOwnPropertySymbols(e); r < a.length; r++)t.indexOf(a[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[r]) && (n[a[r]] = e[a[r]]);
    }
    return n;
}, $2f9e5feda9ce7879$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.AnimationsPicker = module.exports.NumberInput = void 0;

const $2f9e5feda9ce7879$var$react_1 = $2f9e5feda9ce7879$var$__importDefault((parcelRequire("8NFma")));

var $2nesQ = parcelRequire("2nesQ");
var $gUePa = parcelRequire("gUePa");
var $5tI5p = parcelRequire("5tI5p");
var $2IwH6 = parcelRequire("2IwH6");
var $cQj25 = parcelRequire("cQj25");
var $ixLVk = parcelRequire("ixLVk");
var $71KpR = parcelRequire("71KpR");
var $88Rzx = parcelRequire("88Rzx");
var $5r5rj = parcelRequire("5r5rj");

var $iD5yW = parcelRequire("iD5yW");
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

var $xARwM = parcelRequire("xARwM");
const $2f9e5feda9ce7879$var$NumberInput = (e)=>{
    var { value: t, onValueChange: n } = e, a = $2f9e5feda9ce7879$var$__rest(e, [
        "value",
        "onValueChange"
    ]);
    const [r, i] = $2f9e5feda9ce7879$var$react_1.default.useState(t.toString());
    $2f9e5feda9ce7879$var$react_1.default.useEffect(()=>{
        i(t.toString());
    }, [
        t
    ]);
    return $2f9e5feda9ce7879$var$react_1.default.createElement($cQj25.NumericInput, Object.assign({
        value: r,
        onValueChange: (e, t)=>{
            i(t), Number.isNaN(e) || n(e);
        }
    }, a));
};
module.exports.NumberInput = $2f9e5feda9ce7879$var$NumberInput;
const $2f9e5feda9ce7879$var$DirectionPicker = (0, $O1ETn.observer)(({ element: e, store: t, enabled: n })=>{
    const a = e.animations.find((e)=>"enter" === e.type), r = e.animations.find((e)=>"exit" === e.type);
    return n ? $2f9e5feda9ce7879$var$react_1.default.createElement($5tI5p.ButtonGroup, {
        style: {
            width: "100%"
        }
    }, $2f9e5feda9ce7879$var$react_1.default.createElement($gUePa.Button, {
        fill: !0,
        active: (null == a ? void 0 : a.enabled) && !(null == r ? void 0 : r.enabled),
        onClick: ()=>{
            t.history.transaction(()=>{
                e.setAnimation("enter", {
                    enabled: !0
                }), e.setAnimation("exit", {
                    enabled: !1
                });
            });
        }
    }, "Enter"), $2f9e5feda9ce7879$var$react_1.default.createElement($gUePa.Button, {
        fill: !0,
        active: (null == a ? void 0 : a.enabled) && (null == r ? void 0 : r.enabled),
        onClick: ()=>{
            t.history.transaction(()=>{
                e.setAnimation("enter", {
                    enabled: !0
                }), e.setAnimation("exit", {
                    enabled: !0
                });
            });
        }
    }, "Both"), $2f9e5feda9ce7879$var$react_1.default.createElement($gUePa.Button, {
        fill: !0,
        active: (null == r ? void 0 : r.enabled) && !(null == a ? void 0 : a.enabled),
        onClick: ()=>{
            t.history.transaction(()=>{
                e.setAnimation("enter", {
                    enabled: !1
                }), e.setAnimation("exit", {
                    enabled: !0
                });
            });
        }
    }, "Exit")) : null;
}), $2f9e5feda9ce7879$var$renderDirection = (e, { handleClick: t, handleFocus: n, modifiers: a, query: r })=>a.matchesPredicate ? $2f9e5feda9ce7879$var$react_1.default.createElement($2IwH6.MenuItem, {
        active: a.active,
        disabled: a.disabled,
        key: e,
        onClick: t,
        icon: "arrow-" + e,
        onFocus: n,
        roleStructure: "listoption",
        text: e,
        shouldDismissPopover: !1
    }) : null, $2f9e5feda9ce7879$var$directions = [
    "right",
    "left",
    "up",
    "down",
    "bottom-right",
    "bottom-left",
    "top-right",
    "top-left"
], $2f9e5feda9ce7879$var$MoveDirectionSelector = (0, $O1ETn.observer)(({ value: e, onChange: t })=>$2f9e5feda9ce7879$var$react_1.default.createElement("div", {
        style: {
            paddingTop: "10px"
        }
    }, $2f9e5feda9ce7879$var$react_1.default.createElement($iD5yW.Select, {
        items: $2f9e5feda9ce7879$var$directions,
        itemRenderer: $2f9e5feda9ce7879$var$renderDirection,
        filterable: !1,
        activeItem: e,
        onItemSelect: (e)=>{
            t(e);
        }
    }, $2f9e5feda9ce7879$var$react_1.default.createElement($gUePa.Button, {
        text: e,
        icon: "arrow-" + e,
        fill: !0
    })))), $2f9e5feda9ce7879$var$EnterDelayInput = (0, $O1ETn.observer)(({ element: e, store: t })=>{
    const n = e.animations.find((e)=>"enter" === e.type);
    return $2f9e5feda9ce7879$var$react_1.default.createElement("div", {
        style: {
            padding: "10px"
        }
    }, $2f9e5feda9ce7879$var$react_1.default.createElement("div", {
        style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingTop: "5px",
            paddingBottom: "5px"
        }
    }, $2f9e5feda9ce7879$var$react_1.default.createElement("div", null, "Delay"), $2f9e5feda9ce7879$var$react_1.default.createElement("div", null, $2f9e5feda9ce7879$var$react_1.default.createElement(module.exports.NumberInput, {
        value: parseFloat((n.delay / 1e3).toFixed(2)),
        onValueChange: (t)=>{
            e.setAnimation("enter", {
                delay: 1e3 * t
            });
        },
        style: {
            width: "50px"
        },
        minorStepSize: .01,
        stepSize: .01,
        min: 0,
        max: 2.5,
        buttonPosition: "none"
    }))), $2f9e5feda9ce7879$var$react_1.default.createElement($88Rzx.Slider, {
        min: 0,
        max: 1e3,
        value: n.delay,
        showTrackFill: !1,
        labelRenderer: !1,
        onChange: (t)=>{
            e.setAnimation("enter", {
                delay: t
            });
        }
    }));
}), $2f9e5feda9ce7879$var$EnterDurationInput = (0, $O1ETn.observer)(({ element: e, store: t })=>{
    const n = e.animations.find((e)=>"enter" === e.type);
    return $2f9e5feda9ce7879$var$react_1.default.createElement("div", {
        style: {
            padding: "10px"
        }
    }, $2f9e5feda9ce7879$var$react_1.default.createElement("div", {
        style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingTop: "5px",
            paddingBottom: "5px"
        }
    }, $2f9e5feda9ce7879$var$react_1.default.createElement("div", null, "Duration"), $2f9e5feda9ce7879$var$react_1.default.createElement("div", null, $2f9e5feda9ce7879$var$react_1.default.createElement(module.exports.NumberInput, {
        value: parseFloat((n.duration / 1e3).toFixed(2)),
        onValueChange: (t)=>{
            e.setAnimation("enter", {
                duration: 1e3 * t
            }), e.setAnimation("exit", {
                duration: 1e3 * t
            });
        },
        style: {
            width: "50px"
        },
        minorStepSize: .01,
        stepSize: .01,
        min: 0,
        max: 2.5,
        buttonPosition: "none"
    }))), $2f9e5feda9ce7879$var$react_1.default.createElement($88Rzx.Slider, {
        min: 0,
        max: 2500,
        value: n.duration,
        showTrackFill: !1,
        labelRenderer: !1,
        onChange: (t)=>{
            e.setAnimation("enter", {
                duration: t
            }), e.setAnimation("exit", {
                duration: t
            });
        }
    }));
});
module.exports.AnimationsPicker = (0, $O1ETn.observer)(({ element: e, store: t, elements: n })=>{
    var a, r;
    const i = n || [
        e
    ], o = i[0], l = (o.type, o.type, o.type, (e, n)=>{
        t.history.transaction(()=>{
            i.forEach((t)=>{
                t.setAnimation("enter", Object.assign({
                    name: e
                }, n)), t.setAnimation("exit", Object.assign(Object.assign({
                    name: e
                }, n), {
                    from: n.to,
                    to: n.from
                }));
            });
        }), n.enabled && (t.play({
            animatedElementsIds: i.map((e)=>e.id),
            currentTime: o.page.startTime
        }), setTimeout(()=>{
            t.stop();
        }, 1e3));
    }), c = (e)=>{
        var t;
        return !!((e ? null === (t = o.animations) || void 0 === t ? void 0 : t.filter((t)=>t.name === e) : o.animations) || []).find((e)=>e.enabled);
    };
    return $2f9e5feda9ce7879$var$react_1.default.createElement($ixLVk.Popover, {
        hasBackdrop: !1,
        autoFocus: !1,
        content: $2f9e5feda9ce7879$var$react_1.default.createElement("div", {
            style: {
                padding: "15px",
                paddingTop: "25px",
                width: "230px"
            }
        }, $2f9e5feda9ce7879$var$react_1.default.createElement($5r5rj.Switch, {
            checked: c("fade"),
            label: (0, $xARwM.t)("toolbar.fade"),
            onChange: (e)=>{
                l("fade", {
                    enabled: e.target.checked
                });
            },
            alignIndicator: $2nesQ.Alignment.RIGHT
        }), $2f9e5feda9ce7879$var$react_1.default.createElement($5r5rj.Switch, {
            checked: c("move"),
            label: (0, $xARwM.t)("toolbar.move"),
            onChange: (e)=>{
                l("move", {
                    enabled: e.target.checked
                });
            },
            alignIndicator: $2nesQ.Alignment.RIGHT
        }), $2f9e5feda9ce7879$var$react_1.default.createElement($5r5rj.Switch, {
            checked: c("zoom"),
            label: (0, $xARwM.t)("toolbar.zoom"),
            onChange: (e)=>{
                l("zoom", {
                    enabled: e.target.checked
                });
            },
            alignIndicator: $2nesQ.Alignment.RIGHT
        }), $2f9e5feda9ce7879$var$react_1.default.createElement($2f9e5feda9ce7879$var$DirectionPicker, {
            element: o,
            store: t,
            name: "move",
            enabled: c()
        }), c("move") && $2f9e5feda9ce7879$var$react_1.default.createElement($2f9e5feda9ce7879$var$MoveDirectionSelector, {
            value: (null === (r = null === (a = o.animations.find((e)=>"move" === e.name)) || void 0 === a ? void 0 : a.data) || void 0 === r ? void 0 : r.direction) || "right",
            onChange: (e)=>{
                l("move", {
                    data: {
                        direction: e
                    },
                    enabled: !0
                });
            }
        }), c() && $2f9e5feda9ce7879$var$react_1.default.createElement($2f9e5feda9ce7879$var$EnterDelayInput, {
            store: t,
            element: e
        }), c() && $2f9e5feda9ce7879$var$react_1.default.createElement($2f9e5feda9ce7879$var$EnterDurationInput, {
            store: t,
            element: e
        })),
        position: $71KpR.Position.BOTTOM
    }, $2f9e5feda9ce7879$var$react_1.default.createElement($gUePa.Button, {
        text: (0, $xARwM.t)("toolbar.animate"),
        minimal: !0
    }));
}), module.exports.default = module.exports.AnimationsPicker;

});
parcelRegister("iD5yW", function(module, exports) {

$parcel$export(module.exports, "Select", () => $d9002f229f145587$export$ef9b1a59e592288f);
/*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $88643 = parcelRequire("88643");
var $gmQNF = parcelRequire("gmQNF");
var $4Aw5U = parcelRequire("4Aw5U");
var $3lvnD = parcelRequire("3lvnD");
var $6PbAi = parcelRequire("6PbAi");
var $8Ntcp = parcelRequire("8Ntcp");
var $6vtLY = parcelRequire("6vtLY");
var $a6c1q = parcelRequire("a6c1q");
var $mqBXU = parcelRequire("mqBXU");

var $lP8NJ = parcelRequire("lP8NJ");
var $cImER = parcelRequire("cImER");

var $2czyQ = parcelRequire("2czyQ");

var $cNy3O = parcelRequire("cNy3O");
/**
 * Select component.
 *
 * @see https://blueprintjs.com/docs/#select/select
 */ var $d9002f229f145587$export$ef9b1a59e592288f = /** @class */ function(_super) {
    (0, $gztBd.__extends)(Select, _super);
    function Select() {
        var _a;
        var _this = _super.apply(this, arguments) || this;
        _this.state = {
            isOpen: false
        };
        _this.inputElement = null;
        _this.queryList = null;
        _this.handleInputRef = (0, $a6c1q.refHandler)(_this, "inputElement", (_a = _this.props.inputProps) === null || _a === void 0 ? void 0 : _a.inputRef);
        _this.handleQueryListRef = function(ref) {
            return _this.queryList = ref;
        };
        _this.listboxId = (0, $mqBXU).uniqueId("listbox");
        _this.renderQueryList = function(listProps) {
            // not using defaultProps cuz they're hard to type with generics (can't use <T> on static members)
            var _a = _this.props, _b = _a.filterable, filterable = _b === void 0 ? true : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.inputProps, inputProps = _d === void 0 ? {} : _d, _e = _a.popoverContentProps, popoverContentProps = _e === void 0 ? {} : _e, _f = _a.popoverProps, popoverProps = _f === void 0 ? {} : _f, popoverRef = _a.popoverRef;
            var input = $8NFma.createElement((0, $6PbAi.InputGroup), (0, $gztBd.__assign)({
                "aria-autocomplete": "list",
                leftIcon: $8NFma.createElement((0, $cImER.Search), null),
                placeholder: "Filter...",
                rightElement: _this.maybeRenderClearButton(listProps.query)
            }, inputProps, {
                inputRef: _this.handleInputRef,
                onChange: listProps.handleQueryChange,
                value: listProps.query
            }));
            var handleKeyDown = listProps.handleKeyDown, handleKeyUp = listProps.handleKeyUp;
            // N.B. no need to set `fill` since that is unused with the `renderTarget` API
            return $8NFma.createElement((0, $8Ntcp.Popover), (0, $gztBd.__assign)({
                autoFocus: false,
                enforceFocus: false,
                isOpen: _this.state.isOpen,
                disabled: disabled,
                placement: popoverProps.position || popoverProps.placement ? undefined : "bottom-start"
            }, popoverProps, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(listProps.className, popoverProps.className),
                content: $8NFma.createElement("div", (0, $gztBd.__assign)({}, popoverContentProps, {
                    onKeyDown: handleKeyDown,
                    onKeyUp: handleKeyUp
                }), filterable ? input : undefined, listProps.itemList),
                onClosing: _this.handlePopoverClosing,
                onInteraction: _this.handlePopoverInteraction,
                onOpened: _this.handlePopoverOpened,
                onOpening: _this.handlePopoverOpening,
                popoverClassName: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $2czyQ).SELECT_POPOVER, popoverProps.popoverClassName),
                popupKind: (0, $6vtLY.PopupKind).LISTBOX,
                ref: popoverRef,
                renderTarget: _this.getPopoverTargetRenderer(listProps, _this.state.isOpen)
            }));
        };
        // We use the renderTarget API to flatten the rendered DOM and make it easier to implement features like
        // the "fill" prop. Note that we must take `isOpen` as an argument to force this render function to be called
        // again after that state changes.
        _this.getPopoverTargetRenderer = function(listProps, isOpen) {
            // N.B. pull out `isOpen` so that it's not forwarded to the DOM, but remember not to use it directly
            // since it may be stale (`renderTarget` is not re-invoked on this.state changes).
            // eslint-disable-next-line react/display-name
            return function(_a) {
                var _b;
                var _isOpen = _a.isOpen, ref = _a.ref, targetProps = (0, $gztBd.__rest)(_a, [
                    "isOpen",
                    "ref"
                ]);
                var _c = _this.props, disabled = _c.disabled, _d = _c.popoverProps, popoverProps = _d === void 0 ? {} : _d, popoverTargetProps = _c.popoverTargetProps;
                var handleKeyDown = listProps.handleKeyDown, handleKeyUp = listProps.handleKeyUp;
                var _e = popoverProps.targetTagName, targetTagName = _e === void 0 ? "div" : _e;
                return $8NFma.createElement(targetTagName, (0, $gztBd.__assign)((0, $gztBd.__assign)((0, $gztBd.__assign)({
                    "aria-controls": _this.listboxId
                }, popoverTargetProps), targetProps), {
                    "aria-disabled": disabled,
                    "aria-expanded": isOpen,
                    // Note that we must set FILL here in addition to children to get the wrapper element to full width
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(targetProps.className, popoverTargetProps === null || popoverTargetProps === void 0 ? void 0 : popoverTargetProps.className, (_b = {}, _b[(0, $4Aw5U).FILL] = _this.props.fill, _b)),
                    // Normally, Popover would also need to attach its own `onKeyDown` handler via `targetProps`,
                    // but in our case we fully manage that interaction and listen for key events to open/close
                    // the popover, so we elide it from the DOM.
                    onKeyDown: _this.withPopoverTargetPropsHandler("keydown", isOpen ? handleKeyDown : _this.handleTargetKeyDown),
                    onKeyUp: _this.withPopoverTargetPropsHandler("keyup", isOpen ? handleKeyUp : undefined),
                    ref: ref,
                    role: "combobox"
                }), _this.props.children);
            };
        };
        _this.withPopoverTargetPropsHandler = function(eventType, handler) {
            switch(eventType){
                case "keydown":
                    return function(event) {
                        var _a, _b;
                        handler === null || handler === void 0 || handler(event);
                        (_b = (_a = _this.props.popoverTargetProps) === null || _a === void 0 ? void 0 : _a.onKeyDown) === null || _b === void 0 || _b.call(_a, event);
                    };
                case "keyup":
                    return function(event) {
                        var _a, _b;
                        handler === null || handler === void 0 || handler(event);
                        (_b = (_a = _this.props.popoverTargetProps) === null || _a === void 0 ? void 0 : _a.onKeyUp) === null || _b === void 0 || _b.call(_a, event);
                    };
            }
        };
        /**
         * Target wrapper element "keydown" handler while the popover is closed.
         */ _this.handleTargetKeyDown = function(event) {
            // open popover when arrow key pressed on target while closed
            if (event.key === "ArrowUp" || event.key === "ArrowDown") {
                event.preventDefault();
                _this.setState({
                    isOpen: true
                });
            } else if ((0, $mqBXU).isKeyboardClick(event)) _this.setState({
                isOpen: true
            });
        };
        _this.handleItemSelect = function(item, event) {
            var _a, _b;
            var target = event === null || event === void 0 ? void 0 : event.target;
            var menuItem = target === null || target === void 0 ? void 0 : target.closest(".".concat((0, $4Aw5U).MENU_ITEM));
            var menuItemDismiss = menuItem === null || menuItem === void 0 ? void 0 : menuItem.matches(".".concat((0, $4Aw5U).POPOVER_DISMISS));
            var shouldDismiss = menuItemDismiss !== null && menuItemDismiss !== void 0 ? menuItemDismiss : true;
            _this.setState({
                isOpen: !shouldDismiss
            });
            (_b = (_a = _this.props).onItemSelect) === null || _b === void 0 || _b.call(_a, item, event);
        };
        _this.handlePopoverInteraction = function(isOpen, event) {
            var _a, _b;
            _this.setState({
                isOpen: isOpen
            });
            (_b = (_a = _this.props.popoverProps) === null || _a === void 0 ? void 0 : _a.onInteraction) === null || _b === void 0 || _b.call(_a, isOpen, event);
        };
        _this.handlePopoverOpening = function(node) {
            var _a, _b, _c;
            // save currently focused element before popover steals focus, so we can restore it when closing.
            _this.previousFocusedElement = (_a = (0, $mqBXU).getActiveElement(_this.inputElement)) !== null && _a !== void 0 ? _a : undefined;
            if (_this.props.resetOnClose) _this.resetQuery();
            (_c = (_b = _this.props.popoverProps) === null || _b === void 0 ? void 0 : _b.onOpening) === null || _c === void 0 || _c.call(_b, node);
        };
        _this.handlePopoverOpened = function(node) {
            var _a, _b;
            // scroll active item into view after popover transition completes and all dimensions are stable.
            if (_this.queryList != null) _this.queryList.scrollActiveItemIntoView();
            _this.requestAnimationFrame(function() {
                var _a;
                var _b = _this.props.inputProps, inputProps = _b === void 0 ? {} : _b;
                // autofocus is enabled by default
                if (inputProps.autoFocus !== false) (_a = _this.inputElement) === null || _a === void 0 || _a.focus();
            });
            (_b = (_a = _this.props.popoverProps) === null || _a === void 0 ? void 0 : _a.onOpened) === null || _b === void 0 || _b.call(_a, node);
        };
        _this.handlePopoverClosing = function(node) {
            var _a, _b;
            // restore focus to saved element.
            // timeout allows popover to begin closing and remove focus handlers beforehand.
            /* istanbul ignore next */ _this.requestAnimationFrame(function() {
                if (_this.previousFocusedElement !== undefined) {
                    _this.previousFocusedElement.focus();
                    _this.previousFocusedElement = undefined;
                }
            });
            (_b = (_a = _this.props.popoverProps) === null || _a === void 0 ? void 0 : _a.onClosing) === null || _b === void 0 || _b.call(_a, node);
        };
        _this.resetQuery = function() {
            return _this.queryList && _this.queryList.setQuery("", true);
        };
        return _this;
    }
    /** @deprecated no longer necessary now that the TypeScript parser supports type arguments on JSX element tags */ Select.ofType = function() {
        return Select;
    };
    Select.prototype.render = function() {
        // omit props specific to this component, spread the rest.
        var _a = this.props, filterable = _a.filterable, inputProps = _a.inputProps, menuProps = _a.menuProps, popoverProps = _a.popoverProps, restProps = (0, $gztBd.__rest)(_a, [
            "filterable",
            "inputProps",
            "menuProps",
            "popoverProps"
        ]);
        return $8NFma.createElement((0, $cNy3O.QueryList), (0, $gztBd.__assign)({}, restProps, {
            menuProps: (0, $gztBd.__assign)((0, $gztBd.__assign)({
                "aria-label": "selectable options"
            }, menuProps), {
                id: this.listboxId
            }),
            onItemSelect: this.handleItemSelect,
            ref: this.handleQueryListRef,
            renderer: this.renderQueryList
        }));
    };
    Select.prototype.componentDidUpdate = function(prevProps, prevState) {
        var _a, _b, _c, _d, _e;
        if (((_a = prevProps.inputProps) === null || _a === void 0 ? void 0 : _a.inputRef) !== ((_b = this.props.inputProps) === null || _b === void 0 ? void 0 : _b.inputRef)) {
            (0, $a6c1q.setRef)((_c = prevProps.inputProps) === null || _c === void 0 ? void 0 : _c.inputRef, null);
            this.handleInputRef = (0, $a6c1q.refHandler)(this, "inputElement", (_d = this.props.inputProps) === null || _d === void 0 ? void 0 : _d.inputRef);
            (0, $a6c1q.setRef)((_e = this.props.inputProps) === null || _e === void 0 ? void 0 : _e.inputRef, this.inputElement);
        }
        if (this.state.isOpen && !prevState.isOpen && this.queryList != null) this.queryList.scrollActiveItemIntoView();
    };
    Select.prototype.maybeRenderClearButton = function(query) {
        return query.length > 0 ? $8NFma.createElement((0, $gmQNF.Button), {
            "aria-label": "Clear filter query",
            icon: $8NFma.createElement((0, $lP8NJ.Cross), null),
            minimal: true,
            onClick: this.resetQuery,
            title: "Clear filter query"
        }) : undefined;
    };
    Select.displayName = "".concat((0, $3lvnD.DISPLAYNAME_PREFIX), ".Select");
    return Select;
}((0, $88643.AbstractPureComponent));

});
parcelRegister("88643", function(module, exports) {

$parcel$export(module.exports, "AbstractPureComponent", () => $5eb3c6581e1dc45f$export$844dfdc3b38c9679);
/*
 * Copyright 2019 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $8NFma = parcelRequire("8NFma");

var $3T4CC = parcelRequire("3T4CC");
/**
 * An abstract component that Blueprint components can extend
 * in order to add some common functionality like runtime props validation.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
var $5eb3c6581e1dc45f$export$844dfdc3b38c9679 = /** @class */ function(_super) {
    (0, $gztBd.__extends)(AbstractPureComponent, _super);
    function AbstractPureComponent(props) {
        var _this = _super.call(this, props) || this;
        // Not bothering to remove entries when their timeouts finish because clearing invalid ID is a no-op
        _this.timeoutIds = [];
        _this.requestIds = [];
        /**
         * Clear all known timeouts.
         */ _this.clearTimeouts = function() {
            if (_this.timeoutIds.length > 0) {
                for(var _i = 0, _a = _this.timeoutIds; _i < _a.length; _i++){
                    var timeoutId = _a[_i];
                    window.clearTimeout(timeoutId);
                }
                _this.timeoutIds = [];
            }
        };
        /**
         * Clear all known animation frame requests.
         */ _this.cancelAnimationFrames = function() {
            if (_this.requestIds.length > 0) {
                for(var _i = 0, _a = _this.requestIds; _i < _a.length; _i++){
                    var requestId = _a[_i];
                    window.cancelAnimationFrame(requestId);
                }
                _this.requestIds = [];
            }
        };
        if (!(0, $3T4CC.isNodeEnv)("production")) _this.validateProps(_this.props);
        return _this;
    }
    AbstractPureComponent.prototype.componentDidUpdate = function(_prevProps, _prevState, _snapshot) {
        if (!(0, $3T4CC.isNodeEnv)("production")) this.validateProps(this.props);
    };
    AbstractPureComponent.prototype.componentWillUnmount = function() {
        this.clearTimeouts();
        this.cancelAnimationFrames();
    };
    /**
     * Request an animation frame and remember its ID.
     * All pending requests will be canceled when component unmounts.
     *
     * @returns a "cancel" function that will cancel the request when invoked.
     */ AbstractPureComponent.prototype.requestAnimationFrame = function(callback) {
        var handle = window.requestAnimationFrame(callback);
        this.requestIds.push(handle);
        return function() {
            return window.cancelAnimationFrame(handle);
        };
    };
    /**
     * Set a timeout and remember its ID.
     * All pending timeouts will be cleared when component unmounts.
     *
     * @returns a "cancel" function that will clear timeout when invoked.
     */ AbstractPureComponent.prototype.setTimeout = function(callback, timeout) {
        var handle = window.setTimeout(callback, timeout);
        this.timeoutIds.push(handle);
        return function() {
            return window.clearTimeout(handle);
        };
    };
    /**
     * Ensures that the props specified for a component are valid.
     * Implementations should check that props are valid and usually throw an Error if they are not.
     * Implementations should not duplicate checks that the type system already guarantees.
     *
     * This method should be used instead of React's
     * [propTypes](https://facebook.github.io/react/docs/reusable-components.html#prop-validation) feature.
     * Like propTypes, these runtime checks run only in development mode.
     */ AbstractPureComponent.prototype.validateProps = function(_props) {
    // implement in subclass
    };
    return AbstractPureComponent;
}($8NFma.PureComponent);

});
parcelRegister("3T4CC", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", () => $2d4a17fabbb379dc$export$ba99498080d0627b);
$parcel$export(module.exports, "arrayLengthCompare", () => $2d4a17fabbb379dc$export$a508c2eeffcdc594);
$parcel$export(module.exports, "approxEqual", () => $2d4a17fabbb379dc$export$8a4f1dcc58a69dbd);
$parcel$export(module.exports, "clamp", () => $2d4a17fabbb379dc$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "countDecimalPlaces", () => $2d4a17fabbb379dc$export$a42544f265f8403);
$parcel$export(module.exports, "uniqueId", () => $2d4a17fabbb379dc$export$8b15d37bc3f197d4);
$parcel$export(module.exports, "isEmptyString", () => $2d4a17fabbb379dc$export$78d1711480f95c3e);
/*
 * Copyright 2020 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $yL8qz = parcelRequire("yL8qz");
function $2d4a17fabbb379dc$export$ba99498080d0627b(env) {
    return typeof NODE_ENV !== "undefined" && NODE_ENV === env;
}
function $2d4a17fabbb379dc$export$a508c2eeffcdc594(a, b) {
    if (a === void 0) a = [];
    if (b === void 0) b = [];
    return a.length - b.length;
}
function $2d4a17fabbb379dc$export$8a4f1dcc58a69dbd(a, b, tolerance) {
    if (tolerance === void 0) tolerance = 0.00001;
    return Math.abs(a - b) <= tolerance;
}
function $2d4a17fabbb379dc$export$7d15b64cf5a3a4c4(val, min, max) {
    if (val == null) return val;
    if (max < min) throw new Error((0, $yL8qz.CLAMP_MIN_MAX));
    return Math.min(Math.max(val, min), max);
}
function $2d4a17fabbb379dc$export$a42544f265f8403(num) {
    if (!isFinite(num)) return 0;
    var e = 1;
    var p = 0;
    while(Math.round(num * e) / e !== num){
        e *= 10;
        p++;
    }
    return p;
}
var $2d4a17fabbb379dc$var$uniqueCountForNamespace = new Map();
function $2d4a17fabbb379dc$export$8b15d37bc3f197d4(namespace) {
    var _a;
    var curCount = (_a = $2d4a17fabbb379dc$var$uniqueCountForNamespace.get(namespace)) !== null && _a !== void 0 ? _a : 0;
    $2d4a17fabbb379dc$var$uniqueCountForNamespace.set(namespace, curCount + 1);
    return "".concat(namespace, "-").concat(curCount);
}
function $2d4a17fabbb379dc$export$78d1711480f95c3e(val) {
    return typeof val === "string" && val.trim().length === 0;
}

});
parcelRegister("yL8qz", function(module, exports) {

$parcel$export(module.exports, "CLAMP_MIN_MAX", () => $0687bd1aec24354a$export$4fcb16c0555f6e60);
$parcel$export(module.exports, "INPUT_WARN_LEFT_ELEMENT_LEFT_ICON_MUTEX", () => $0687bd1aec24354a$export$7dcc26c4d745a6de);
$parcel$export(module.exports, "POPOVER_REQUIRES_TARGET", () => $0687bd1aec24354a$export$3cf04cff067b1497);
$parcel$export(module.exports, "POPOVER_HAS_BACKDROP_INTERACTION", () => $0687bd1aec24354a$export$deb4db7b191454de);
$parcel$export(module.exports, "POPOVER_WARN_TOO_MANY_CHILDREN", () => $0687bd1aec24354a$export$d26b2b7b10deb660);
$parcel$export(module.exports, "POPOVER_WARN_DOUBLE_TARGET", () => $0687bd1aec24354a$export$92bbc536d12dd3d6);
$parcel$export(module.exports, "POPOVER_WARN_EMPTY_CONTENT", () => $0687bd1aec24354a$export$fb9dc24caac9c30e);
$parcel$export(module.exports, "POPOVER_WARN_HAS_BACKDROP_INLINE", () => $0687bd1aec24354a$export$d2c026502cfc32e6);
$parcel$export(module.exports, "POPOVER_WARN_PLACEMENT_AND_POSITION_MUTEX", () => $0687bd1aec24354a$export$bd8a2148d985bb65);
$parcel$export(module.exports, "POPOVER_WARN_UNCONTROLLED_ONINTERACTION", () => $0687bd1aec24354a$export$cdb7203a6f2d3ac9);
$parcel$export(module.exports, "POPOVER_WARN_TARGET_PROPS_WITH_RENDER_TARGET", () => $0687bd1aec24354a$export$958f5bcc111a3890);
$parcel$export(module.exports, "PORTAL_CONTEXT_CLASS_NAME_STRING", () => $0687bd1aec24354a$export$c806064fdc775efa);
$parcel$export(module.exports, "PORTAL_LEGACY_CONTEXT_API", () => $0687bd1aec24354a$export$26dc7cef361ed92a);
$parcel$export(module.exports, "SPINNER_WARN_CLASSES_SIZE", () => $0687bd1aec24354a$export$612c20961251008f);
$parcel$export(module.exports, "OVERLAY2_REQUIRES_OVERLAY_PROVDER", () => $0687bd1aec24354a$export$ec9bf1f3f03eed46);
$parcel$export(module.exports, "OVERLAY_CHILD_REF_AND_REFS_MUTEX", () => $0687bd1aec24354a$export$9a7688a076ebfc22);
$parcel$export(module.exports, "OVERLAY_WITH_MULTIPLE_CHILDREN_REQUIRES_CHILD_REFS", () => $0687bd1aec24354a$export$d1780dd5da45c8d8);
$parcel$export(module.exports, "OVERLAY_CHILD_REQUIRES_KEY", () => $0687bd1aec24354a$export$5c53f620d79bf998);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0687bd1aec24354a$var$ns = "[Blueprint]";
var $0687bd1aec24354a$export$4fcb16c0555f6e60 = $0687bd1aec24354a$var$ns + " clamp: max cannot be less than min";
var $0687bd1aec24354a$export$5b85f29a2be29baf = $0687bd1aec24354a$var$ns + " <Alert> cancelButtonText and onCancel should be set together.";
var $0687bd1aec24354a$export$f6e5524776d50d97 = $0687bd1aec24354a$var$ns + " <Alert> canEscapeKeyCancel enabled without onCancel or onClose handler.";
var $0687bd1aec24354a$export$b72cc84fa7249bbc = $0687bd1aec24354a$var$ns + " <Alert> canOutsideClickCancel enabled without onCancel or onClose handler.";
var $0687bd1aec24354a$export$a966041437837cbb = $0687bd1aec24354a$var$ns + " <Hotkeys> only accepts <Hotkey> children.";
var $0687bd1aec24354a$export$670242ac4c5d7db8 = $0687bd1aec24354a$var$ns + " useHotkeys() was used outside of a <HotkeysProvider> context. These hotkeys will not be shown in the hotkeys help dialog.";
var $0687bd1aec24354a$export$9dbacdb91396601 = $0687bd1aec24354a$var$ns + " <HotkeysTarget2> was configured with local hotkeys, but you did not use the generated event handlers to bind their event handlers. Try using a render function as the child of this component.";
var $0687bd1aec24354a$export$7dcc26c4d745a6de = $0687bd1aec24354a$var$ns + " <InputGroup> leftElement and leftIcon prop are mutually exclusive, with leftElement taking priority.";
var $0687bd1aec24354a$export$5813ec87ec3acb90 = $0687bd1aec24354a$var$ns + " <NumericInput> requires min to be no greater than max if both are defined.";
var $0687bd1aec24354a$export$560b8988862ea429 = $0687bd1aec24354a$var$ns + " <NumericInput> requires minorStepSize to be no greater than stepSize.";
var $0687bd1aec24354a$export$6e5c02badc46235e = $0687bd1aec24354a$var$ns + " <NumericInput> requires stepSize to be no greater than majorStepSize.";
var $0687bd1aec24354a$export$bfff41693cbc35d4 = $0687bd1aec24354a$var$ns + " <NumericInput> requires minorStepSize to be strictly greater than zero.";
var $0687bd1aec24354a$export$659f97d5057a476 = $0687bd1aec24354a$var$ns + " <NumericInput> requires majorStepSize to be strictly greater than zero.";
var $0687bd1aec24354a$export$cf406687fba595e5 = $0687bd1aec24354a$var$ns + " <NumericInput> requires stepSize to be strictly greater than zero.";
var $0687bd1aec24354a$export$b9f78c93f51845b9 = $0687bd1aec24354a$var$ns + " <NumericInput> controlled value prop does not adhere to stepSize, min, and/or max constraints.";
var $0687bd1aec24354a$export$8a4f82273d0e92f = $0687bd1aec24354a$var$ns + " <PanelStack> requires exactly one of initialPanel and stack prop";
var $0687bd1aec24354a$export$3a88d598d258d4d5 = $0687bd1aec24354a$var$ns + " <PanelStack> requires at least one panel in the stack";
var $0687bd1aec24354a$export$19bc0ed8b2e0d575 = $0687bd1aec24354a$var$ns + " <OverflowList> does not support changing observeParents after mounting.";
var $0687bd1aec24354a$export$3cf04cff067b1497 = "".concat($0687bd1aec24354a$var$ns, " <Popover> requires renderTarget prop or a child element.");
var $0687bd1aec24354a$export$deb4db7b191454de = "".concat($0687bd1aec24354a$var$ns, ' <Popover hasBackdrop={true}> requires interactionKind="click".');
var $0687bd1aec24354a$export$d26b2b7b10deb660 = "".concat($0687bd1aec24354a$var$ns, " <Popover> supports only one child which is rendered as its target; additional children are ignored.");
var $0687bd1aec24354a$export$92bbc536d12dd3d6 = $0687bd1aec24354a$var$ns + " <Popover> with children ignores renderTarget prop; use either prop or children.";
var $0687bd1aec24354a$export$fb9dc24caac9c30e = $0687bd1aec24354a$var$ns + " Disabling <Popover> with empty/whitespace content...";
var $0687bd1aec24354a$export$d2c026502cfc32e6 = $0687bd1aec24354a$var$ns + " <Popover usePortal={false}> ignores hasBackdrop";
var $0687bd1aec24354a$export$bd8a2148d985bb65 = $0687bd1aec24354a$var$ns + " <Popover> supports either placement or position prop, not both.";
var $0687bd1aec24354a$export$cdb7203a6f2d3ac9 = $0687bd1aec24354a$var$ns + " <Popover> onInteraction is ignored when uncontrolled.";
var $0687bd1aec24354a$export$958f5bcc111a3890 = $0687bd1aec24354a$var$ns + " <Popover> targetProps value is ignored when renderTarget API is used.";
var $0687bd1aec24354a$export$c806064fdc775efa = $0687bd1aec24354a$var$ns + " <Portal> context blueprintPortalClassName must be string";
var $0687bd1aec24354a$export$26dc7cef361ed92a = $0687bd1aec24354a$var$ns + " setting blueprintPortalClassName via legacy React context API is deprecated, use <PortalProvider> instead.";
var $0687bd1aec24354a$export$85aa0d720577b224 = $0687bd1aec24354a$var$ns + " <RadioGroup> children and options prop are mutually exclusive, with options taking priority.";
var $0687bd1aec24354a$export$3f628d74aa22ee14 = $0687bd1aec24354a$var$ns + " <Slider> stepSize must be greater than zero.";
var $0687bd1aec24354a$export$e1e1f71b44b50957 = $0687bd1aec24354a$var$ns + " <Slider> labelStepSize must be greater than zero.";
var $0687bd1aec24354a$export$bd089811e8f6237d = $0687bd1aec24354a$var$ns + " <Slider> min prop must be a finite number.";
var $0687bd1aec24354a$export$34f34bdfff94a103 = $0687bd1aec24354a$var$ns + " <Slider> max prop must be a finite number.";
var $0687bd1aec24354a$export$8cdad9f5b77513a2 = $0687bd1aec24354a$var$ns + " <RangeSlider> value prop must be an array of two non-null numbers.";
var $0687bd1aec24354a$export$5c23f31d1ea14389 = $0687bd1aec24354a$var$ns + " <MultiSlider> children must be <SliderHandle>s or <SliderTrackStop>s";
var $0687bd1aec24354a$export$be7e9beb3b581c37 = $0687bd1aec24354a$var$ns + " <MultiSlider> labelStepSize and labelValues prop are mutually exclusive, with labelStepSize taking priority.";
var $0687bd1aec24354a$export$612c20961251008f = $0687bd1aec24354a$var$ns + " <Spinner> Classes.SMALL/LARGE are ignored if size prop is set.";
var $0687bd1aec24354a$export$fdceab30a81a80e3 = $0687bd1aec24354a$var$ns + " OverlayToaster.create() is not supported inside React lifecycle methods in React 16." + " See usage example on the docs site. https://blueprintjs.com/docs/#core/components/toast.example";
var $0687bd1aec24354a$export$b43eb3d543c5291f = $0687bd1aec24354a$var$ns + " OverlayToaster.createAsync() received a null component ref. This can happen if called inside React lifecycle " + "methods in React 16. See usage example on the docs site. " + "https://blueprintjs.com/docs/#core/components/toast.example";
var $0687bd1aec24354a$export$2451692ca60e5d58 = $0687bd1aec24354a$var$ns + " <OverlayToaster> maxToasts is set to an invalid number, must be greater than 0";
var $0687bd1aec24354a$export$18ab8fe30147e847 = $0687bd1aec24354a$var$ns + " OverlayToaster.create() ignores inline prop as it always creates a new element.";
var $0687bd1aec24354a$export$2c7c4d8c17b24fc3 = $0687bd1aec24354a$var$ns + " <Dialog> iconName is ignored if title is omitted.";
var $0687bd1aec24354a$export$b1ffdd5a20552cca = $0687bd1aec24354a$var$ns + " <Dialog> isCloseButtonShown prop is ignored if title is omitted.";
var $0687bd1aec24354a$export$ee41c46c4147fad0 = $0687bd1aec24354a$var$ns + " <Drawer> all angle positions are casted into pure position (TOP, BOTTOM, LEFT or RIGHT)";
var $0687bd1aec24354a$export$ec9bf1f3f03eed46 = $0687bd1aec24354a$var$ns + " <Overlay2> was used outside of a <OverlaysProvider> context. This will no longer be supported in " + "Blueprint v6. See https://github.com/palantir/blueprint/wiki/Overlay2-migration";
var $0687bd1aec24354a$export$9a7688a076ebfc22 = $0687bd1aec24354a$var$ns + " <Overlay2> cannot use childRef and childRefs props simultaneously";
var $0687bd1aec24354a$export$d1780dd5da45c8d8 = $0687bd1aec24354a$var$ns + " <Overlay2> requires childRefs prop when rendering multiple child elements";
var $0687bd1aec24354a$export$5c53f620d79bf998 = $0687bd1aec24354a$var$ns + " <Overlay2> requires each child element to have a unique key prop when childRefs is used";

});



parcelRegister("gmQNF", function(module, exports) {

$parcel$export(module.exports, "Button", () => $bea7a86ba113666f$export$353f5b6fc5456de1);
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $4Aw5U = parcelRequire("4Aw5U");
var $mqBXU = parcelRequire("mqBXU");

var $3lvnD = parcelRequire("3lvnD");

var $a6c1q = parcelRequire("a6c1q");

var $8YRmi = parcelRequire("8YRmi");

var $1kPos = parcelRequire("1kPos");

var $ghE22 = parcelRequire("ghE22");
var $bea7a86ba113666f$export$353f5b6fc5456de1 = $8NFma.forwardRef(function(props, ref) {
    var commonAttributes = $bea7a86ba113666f$var$useSharedButtonAttributes(props, ref);
    return $8NFma.createElement("button", (0, $gztBd.__assign)({
        type: "button"
    }, (0, $3lvnD.removeNonHTMLProps)(props), commonAttributes), $bea7a86ba113666f$var$renderButtonContents(props));
});
$bea7a86ba113666f$export$353f5b6fc5456de1.displayName = "".concat((0, $3lvnD.DISPLAYNAME_PREFIX), ".Button");
var $bea7a86ba113666f$export$59a34841c163ed64 = $8NFma.forwardRef(function(props, ref) {
    var href = props.href, _a = props.tabIndex, tabIndex = _a === void 0 ? 0 : _a;
    var commonProps = $bea7a86ba113666f$var$useSharedButtonAttributes(props, ref);
    return $8NFma.createElement("a", (0, $gztBd.__assign)({
        role: "button"
    }, (0, $3lvnD.removeNonHTMLProps)(props), commonProps, {
        "aria-disabled": commonProps.disabled,
        href: commonProps.disabled ? undefined : href,
        tabIndex: commonProps.disabled ? -1 : tabIndex
    }), $bea7a86ba113666f$var$renderButtonContents(props));
});
$bea7a86ba113666f$export$59a34841c163ed64.displayName = "".concat((0, $3lvnD.DISPLAYNAME_PREFIX), ".AnchorButton");
/**
 * Most of the button logic lives in this shared hook.
 */ function $bea7a86ba113666f$var$useSharedButtonAttributes(props, ref) {
    var _a;
    var _b = props.active, active = _b === void 0 ? false : _b, alignText = props.alignText, fill = props.fill, large = props.large, _c = props.loading, loading = _c === void 0 ? false : _c, minimal = props.minimal, onBlur = props.onBlur, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, outlined = props.outlined, small = props.small, tabIndex = props.tabIndex;
    var disabled = props.disabled || loading;
    // the current key being pressed
    var _d = $8NFma.useState(), currentKeyPressed = _d[0], setCurrentKeyPressed = _d[1];
    // whether the button is in "active" state
    var _e = $8NFma.useState(false), isActive = _e[0], setIsActive = _e[1];
    // our local ref for the button element, merged with the consumer's own ref (if supplied) in this hook's return value
    var buttonRef = $8NFma.useRef(null);
    var handleBlur = $8NFma.useCallback(function(e) {
        if (isActive) setIsActive(false);
        onBlur === null || onBlur === void 0 || onBlur(e);
    }, [
        isActive,
        onBlur
    ]);
    var handleKeyDown = $8NFma.useCallback(function(e) {
        if ((0, $mqBXU).isKeyboardClick(e)) {
            e.preventDefault();
            if (e.key !== currentKeyPressed) setIsActive(true);
        }
        setCurrentKeyPressed(e.key);
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
    }, [
        currentKeyPressed,
        onKeyDown
    ]);
    var handleKeyUp = $8NFma.useCallback(function(e) {
        var _a;
        if ((0, $mqBXU).isKeyboardClick(e)) {
            setIsActive(false);
            (_a = buttonRef.current) === null || _a === void 0 || _a.click();
        }
        setCurrentKeyPressed(undefined);
        onKeyUp === null || onKeyUp === void 0 || onKeyUp(e);
    }, [
        onKeyUp
    ]);
    var className = (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $4Aw5U).BUTTON, (_a = {}, _a[(0, $4Aw5U).ACTIVE] = !disabled && (active || isActive), _a[(0, $4Aw5U).DISABLED] = disabled, _a[(0, $4Aw5U).FILL] = fill, _a[(0, $4Aw5U).LARGE] = large, _a[(0, $4Aw5U).LOADING] = loading, _a[(0, $4Aw5U).MINIMAL] = minimal, _a[(0, $4Aw5U).OUTLINED] = outlined, _a[(0, $4Aw5U).SMALL] = small, _a), (0, $4Aw5U).alignmentClass(alignText), (0, $4Aw5U).intentClass(props.intent), props.className);
    return {
        className: className,
        disabled: disabled,
        onBlur: handleBlur,
        onClick: disabled ? undefined : props.onClick,
        onFocus: disabled ? undefined : props.onFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: (0, $a6c1q.mergeRefs)(buttonRef, ref),
        tabIndex: disabled ? -1 : tabIndex
    };
}
/**
 * Shared rendering code for button contents.
 */ function $bea7a86ba113666f$var$renderButtonContents(props) {
    var children = props.children, ellipsizeText = props.ellipsizeText, icon = props.icon, loading = props.loading, rightIcon = props.rightIcon, text = props.text, textClassName = props.textClassName;
    var hasTextContent = !(0, $mqBXU).isReactNodeEmpty(text) || !(0, $mqBXU).isReactNodeEmpty(children);
    return $8NFma.createElement($8NFma.Fragment, null, loading && $8NFma.createElement((0, $1kPos.Spinner), {
        key: "loading",
        className: (0, $4Aw5U).BUTTON_SPINNER,
        size: (0, $1kPos.SpinnerSize).SMALL
    }), $8NFma.createElement((0, $8YRmi.Icon), {
        key: "leftIcon",
        icon: icon
    }), hasTextContent && $8NFma.createElement((0, $ghE22.Text), {
        key: "text",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $4Aw5U).BUTTON_TEXT, textClassName),
        ellipsize: ellipsizeText,
        tagName: "span"
    }, text, children), $8NFma.createElement((0, $8YRmi.Icon), {
        key: "rightIcon",
        icon: rightIcon
    }));
}

});
parcelRegister("4Aw5U", function(module, exports) {

$parcel$export(module.exports, "ACTIVE", () => $35736b752a767065$export$2b35adb71b3f6143);
$parcel$export(module.exports, "ALIGN_LEFT", () => $35736b752a767065$export$7895aadd1956b1c7);
$parcel$export(module.exports, "ALIGN_RIGHT", () => $35736b752a767065$export$f1299af03a3c605a);
$parcel$export(module.exports, "COMPACT", () => $35736b752a767065$export$db1cdb8627b81f84);
$parcel$export(module.exports, "DARK", () => $35736b752a767065$export$b9b16d1820185434);
$parcel$export(module.exports, "DISABLED", () => $35736b752a767065$export$8cd212c10b4124d2);
$parcel$export(module.exports, "FILL", () => $35736b752a767065$export$5672a3e1deb5b505);
$parcel$export(module.exports, "FIXED", () => $35736b752a767065$export$91f67f1eeaea8c1e);
$parcel$export(module.exports, "FIXED_TOP", () => $35736b752a767065$export$3df9f2c23b50ca42);
$parcel$export(module.exports, "INLINE", () => $35736b752a767065$export$1ff9623b26415f8);
$parcel$export(module.exports, "INTERACTIVE", () => $35736b752a767065$export$ceebd5febfdef8a3);
$parcel$export(module.exports, "LARGE", () => $35736b752a767065$export$7b93a10c0fefe3e3);
$parcel$export(module.exports, "LOADING", () => $35736b752a767065$export$26d55645375ca9a);
$parcel$export(module.exports, "MINIMAL", () => $35736b752a767065$export$a61ada011bb84f5);
$parcel$export(module.exports, "OUTLINED", () => $35736b752a767065$export$d31ef73d8bd6b2be);
$parcel$export(module.exports, "PADDED", () => $35736b752a767065$export$1f3db38142bdf083);
$parcel$export(module.exports, "MULTILINE", () => $35736b752a767065$export$49f467056ef3fc6c);
$parcel$export(module.exports, "READ_ONLY", () => $35736b752a767065$export$a45819e0f9bcfea2);
$parcel$export(module.exports, "ROUND", () => $35736b752a767065$export$58785fc667c0c50b);
$parcel$export(module.exports, "SELECTED", () => $35736b752a767065$export$657f886463d93938);
$parcel$export(module.exports, "SMALL", () => $35736b752a767065$export$71dd4c8ecd45e95f);
$parcel$export(module.exports, "VERTICAL", () => $35736b752a767065$export$9f2fe7df0ae9fdea);
$parcel$export(module.exports, "POSITION_TOP", () => $35736b752a767065$export$4fb34bdcd97adf85);
$parcel$export(module.exports, "positionClass", () => $35736b752a767065$export$4f8aee4b943e40e);
$parcel$export(module.exports, "POSITION_BOTTOM", () => $35736b752a767065$export$cec9b06edc71d96c);
$parcel$export(module.exports, "POSITION_LEFT", () => $35736b752a767065$export$b0758137ee643e7);
$parcel$export(module.exports, "POSITION_RIGHT", () => $35736b752a767065$export$4ed9c122bcc20157);
$parcel$export(module.exports, "ELEVATION_0", () => $35736b752a767065$export$c8efb467fc55a6a1);
$parcel$export(module.exports, "elevationClass", () => $35736b752a767065$export$b7727d57dec24270);
$parcel$export(module.exports, "ELEVATION_1", () => $35736b752a767065$export$7b5afc1ddf65f8b7);
$parcel$export(module.exports, "ELEVATION_2", () => $35736b752a767065$export$86dd92dfea4f39dd);
$parcel$export(module.exports, "ELEVATION_3", () => $35736b752a767065$export$ef7592bd90f2537f);
$parcel$export(module.exports, "ELEVATION_4", () => $35736b752a767065$export$1d67a24a95ef24c2);
$parcel$export(module.exports, "INTENT_PRIMARY", () => $35736b752a767065$export$37c8deab6e9ff120);
$parcel$export(module.exports, "intentClass", () => $35736b752a767065$export$6771d82d925c8189);
$parcel$export(module.exports, "INTENT_SUCCESS", () => $35736b752a767065$export$fd8d2f5f74a29424);
$parcel$export(module.exports, "INTENT_WARNING", () => $35736b752a767065$export$355c57fd095a7f5a);
$parcel$export(module.exports, "INTENT_DANGER", () => $35736b752a767065$export$373495f4c0568b73);
$parcel$export(module.exports, "FOCUS_DISABLED", () => $35736b752a767065$export$aeda8252e54b50f7);
$parcel$export(module.exports, "FOCUS_STYLE_MANAGER_IGNORE", () => $35736b752a767065$export$bedc1b77a139edca);
$parcel$export(module.exports, "UI_TEXT", () => $35736b752a767065$export$88620a540780da7c);
$parcel$export(module.exports, "RUNNING_TEXT", () => $35736b752a767065$export$d0190f823696a5cc);
$parcel$export(module.exports, "MONOSPACE_TEXT", () => $35736b752a767065$export$558d226ddadcf457);
$parcel$export(module.exports, "TEXT_LARGE", () => $35736b752a767065$export$50e449675bbd8ae2);
$parcel$export(module.exports, "TEXT_SMALL", () => $35736b752a767065$export$504f956f6b2a8e65);
$parcel$export(module.exports, "TEXT_MUTED", () => $35736b752a767065$export$31a5874ec7f49f29);
$parcel$export(module.exports, "TEXT_DISABLED", () => $35736b752a767065$export$4aa79107ea222f04);
$parcel$export(module.exports, "TEXT_OVERFLOW_ELLIPSIS", () => $35736b752a767065$export$cd50c877adf39dd7);
$parcel$export(module.exports, "BLOCKQUOTE", () => $35736b752a767065$export$afa7aa09bb57d54f);
$parcel$export(module.exports, "CODE", () => $35736b752a767065$export$ec5856072852bd7f);
$parcel$export(module.exports, "CODE_BLOCK", () => $35736b752a767065$export$cf55d1bff75690da);
$parcel$export(module.exports, "HEADING", () => $35736b752a767065$export$eef1738e402a65e6);
$parcel$export(module.exports, "LIST", () => $35736b752a767065$export$84cc8e12a434d4e);
$parcel$export(module.exports, "LIST_UNSTYLED", () => $35736b752a767065$export$e52b656749d9474c);
$parcel$export(module.exports, "RTL", () => $35736b752a767065$export$850f7749a2909601);
$parcel$export(module.exports, "ALERT", () => $35736b752a767065$export$8dfce1a3f4c39a);
$parcel$export(module.exports, "ALERT_BODY", () => $35736b752a767065$export$5d3ddfb12869545d);
$parcel$export(module.exports, "ALERT_CONTENTS", () => $35736b752a767065$export$1dba7da5e8205b5f);
$parcel$export(module.exports, "ALERT_FOOTER", () => $35736b752a767065$export$a928c8e2db526b6c);
$parcel$export(module.exports, "BREADCRUMB", () => $35736b752a767065$export$474829b260ce19ab);
$parcel$export(module.exports, "BREADCRUMB_CURRENT", () => $35736b752a767065$export$d25ee28b316abe2a);
$parcel$export(module.exports, "BREADCRUMBS", () => $35736b752a767065$export$c3619772211b515b);
$parcel$export(module.exports, "BREADCRUMBS_COLLAPSED", () => $35736b752a767065$export$6c5df38f864cf0e3);
$parcel$export(module.exports, "BUTTON", () => $35736b752a767065$export$b887e88d8d0739f6);
$parcel$export(module.exports, "BUTTON_GROUP", () => $35736b752a767065$export$cbb1216936bf389c);
$parcel$export(module.exports, "BUTTON_SPINNER", () => $35736b752a767065$export$3fd25a11349a7fac);
$parcel$export(module.exports, "BUTTON_TEXT", () => $35736b752a767065$export$22617f068a979d82);
$parcel$export(module.exports, "CALLOUT", () => $35736b752a767065$export$ae3fb0b35b6ca2a9);
$parcel$export(module.exports, "CALLOUT_HAS_BODY_CONTENT", () => $35736b752a767065$export$c801bbbb1e2ccb0b);
$parcel$export(module.exports, "CALLOUT_ICON", () => $35736b752a767065$export$c4700bfd78cb069a);
$parcel$export(module.exports, "CARD", () => $35736b752a767065$export$95783a805443ad7d);
$parcel$export(module.exports, "CONTROL_CARD", () => $35736b752a767065$export$6769bd973fd6af36);
$parcel$export(module.exports, "CONTROL_CARD_LABEL", () => $35736b752a767065$export$d60e975594bbe489);
$parcel$export(module.exports, "SWITCH_CONTROL_CARD", () => $35736b752a767065$export$9cedcb03c3922bb7);
$parcel$export(module.exports, "CHECKBOX_CONTROL_CARD", () => $35736b752a767065$export$3412f17fbe03c097);
$parcel$export(module.exports, "RADIO_CONTROL_CARD", () => $35736b752a767065$export$4de35bcdbf177a1f);
$parcel$export(module.exports, "CARD_LIST", () => $35736b752a767065$export$ad39b86c40d3c47c);
$parcel$export(module.exports, "CARD_LIST_BORDERED", () => $35736b752a767065$export$5adfba49857b538f);
$parcel$export(module.exports, "COLLAPSE", () => $35736b752a767065$export$a1b955d4799a6f74);
$parcel$export(module.exports, "COLLAPSE_BODY", () => $35736b752a767065$export$e4d292b696959393);
$parcel$export(module.exports, "CONTEXT_MENU", () => $35736b752a767065$export$6a0da22e72d4f0eb);
$parcel$export(module.exports, "CONTEXT_MENU_VIRTUAL_TARGET", () => $35736b752a767065$export$b9534b88b3cef166);
$parcel$export(module.exports, "CONTEXT_MENU_POPOVER", () => $35736b752a767065$export$7ee0ba3b9fa0a5ea);
$parcel$export(module.exports, "CONTEXT_MENU_BACKDROP", () => $35736b752a767065$export$418ef826d3ba978d);
$parcel$export(module.exports, "CONTROL_GROUP", () => $35736b752a767065$export$1c86bb6d85c165);
$parcel$export(module.exports, "DIALOG", () => $35736b752a767065$export$f99739dbfcd2e015);
$parcel$export(module.exports, "DIALOG_CONTAINER", () => $35736b752a767065$export$d84b649f32bf6ead);
$parcel$export(module.exports, "DIALOG_HEADER", () => $35736b752a767065$export$c09efbe888b20fd);
$parcel$export(module.exports, "DIALOG_BODY", () => $35736b752a767065$export$12096ec1410ccb2);
$parcel$export(module.exports, "DIALOG_BODY_SCROLL_CONTAINER", () => $35736b752a767065$export$dd51a6f3fef5a9d4);
$parcel$export(module.exports, "DIALOG_CLOSE_BUTTON", () => $35736b752a767065$export$9588cbdf14f4605f);
$parcel$export(module.exports, "DIALOG_FOOTER", () => $35736b752a767065$export$6ea271a01e7dc590);
$parcel$export(module.exports, "DIALOG_FOOTER_FIXED", () => $35736b752a767065$export$b60b0eff9b84a85c);
$parcel$export(module.exports, "DIALOG_FOOTER_MAIN_SECTION", () => $35736b752a767065$export$a01581f2cb63a5c5);
$parcel$export(module.exports, "DIALOG_FOOTER_ACTIONS", () => $35736b752a767065$export$6ab793fb94a2b7f8);
$parcel$export(module.exports, "DIALOG_STEP", () => $35736b752a767065$export$ff97c652790bdec);
$parcel$export(module.exports, "DIALOG_STEP_CONTAINER", () => $35736b752a767065$export$15158775e667dbe6);
$parcel$export(module.exports, "DIALOG_STEP_TITLE", () => $35736b752a767065$export$e6263bc32f85a4a4);
$parcel$export(module.exports, "DIALOG_STEP_ICON", () => $35736b752a767065$export$e7c377477d704043);
$parcel$export(module.exports, "DIALOG_STEP_VIEWED", () => $35736b752a767065$export$97e1fe7e02b9bd0);
$parcel$export(module.exports, "DIVIDER", () => $35736b752a767065$export$59669b530bfa91b6);
$parcel$export(module.exports, "DRAWER", () => $35736b752a767065$export$9d2de6eebf7462b5);
$parcel$export(module.exports, "DRAWER_BODY", () => $35736b752a767065$export$a772fb749abfcf1d);
$parcel$export(module.exports, "DRAWER_FOOTER", () => $35736b752a767065$export$b9287ddc8f6e3044);
$parcel$export(module.exports, "DRAWER_HEADER", () => $35736b752a767065$export$4cd03a6721b31533);
$parcel$export(module.exports, "EDITABLE_TEXT", () => $35736b752a767065$export$8cffb49e9dd41ae);
$parcel$export(module.exports, "EDITABLE_TEXT_CONTENT", () => $35736b752a767065$export$78b1aa7020d6af37);
$parcel$export(module.exports, "EDITABLE_TEXT_EDITING", () => $35736b752a767065$export$2d16d4c1c295606c);
$parcel$export(module.exports, "EDITABLE_TEXT_INPUT", () => $35736b752a767065$export$4d6e427d15d16553);
$parcel$export(module.exports, "EDITABLE_TEXT_PLACEHOLDER", () => $35736b752a767065$export$90d364a014ea6f0a);
$parcel$export(module.exports, "ENTITY_TITLE", () => $35736b752a767065$export$659c2dc95c10337e);
$parcel$export(module.exports, "ENTITY_TITLE_ELLIPSIZE", () => $35736b752a767065$export$c92e868735e7ed90);
$parcel$export(module.exports, "ENTITY_TITLE_HAS_SUBTITLE", () => $35736b752a767065$export$32306a4d67fbbec);
$parcel$export(module.exports, "ENTITY_TITLE_ICON_CONTAINER", () => $35736b752a767065$export$4a30999b77042528);
$parcel$export(module.exports, "ENTITY_TITLE_SUBTITLE", () => $35736b752a767065$export$6d113d689052ca80);
$parcel$export(module.exports, "ENTITY_TITLE_TAGS_CONTAINER", () => $35736b752a767065$export$2b6f21fa0a5321de);
$parcel$export(module.exports, "ENTITY_TITLE_TEXT", () => $35736b752a767065$export$dfa64ede72bd0307);
$parcel$export(module.exports, "ENTITY_TITLE_TITLE", () => $35736b752a767065$export$e57a71e20aa8627);
$parcel$export(module.exports, "ENTITY_TITLE_TITLE_AND_TAGS", () => $35736b752a767065$export$85f27204a6624107);
$parcel$export(module.exports, "FLEX_EXPANDER", () => $35736b752a767065$export$bab85e3adc70edd1);
$parcel$export(module.exports, "HTML_SELECT", () => $35736b752a767065$export$c50fbf6be7ac3331);
$parcel$export(module.exports, "SELECT", () => $35736b752a767065$export$718a6b7ababf8ba7);
$parcel$export(module.exports, "HTML_TABLE", () => $35736b752a767065$export$76a315d343674c9b);
$parcel$export(module.exports, "HTML_TABLE_BORDERED", () => $35736b752a767065$export$13618d7eda5fcc77);
$parcel$export(module.exports, "HTML_TABLE_STRIPED", () => $35736b752a767065$export$a2a4accb8fbddd4a);
$parcel$export(module.exports, "INPUT", () => $35736b752a767065$export$9ea760072c364d49);
$parcel$export(module.exports, "INPUT_GHOST", () => $35736b752a767065$export$e8d5c1be80b7588b);
$parcel$export(module.exports, "INPUT_GROUP", () => $35736b752a767065$export$87f36efdfb463a6f);
$parcel$export(module.exports, "INPUT_LEFT_CONTAINER", () => $35736b752a767065$export$9705bb16375b49e5);
$parcel$export(module.exports, "INPUT_ACTION", () => $35736b752a767065$export$217bb10d53bd2e48);
$parcel$export(module.exports, "RESIZABLE_INPUT_SPAN", () => $35736b752a767065$export$f038e7a42893c7e5);
$parcel$export(module.exports, "TEXT_AREA", () => $35736b752a767065$export$794d3720201fcdd9);
$parcel$export(module.exports, "TEXT_AREA_AUTO_RESIZE", () => $35736b752a767065$export$9c466612a9056aac);
$parcel$export(module.exports, "CONTROL", () => $35736b752a767065$export$43f367b3e957f219);
$parcel$export(module.exports, "CONTROL_INDICATOR", () => $35736b752a767065$export$947bb9f998f185cb);
$parcel$export(module.exports, "CONTROL_INDICATOR_CHILD", () => $35736b752a767065$export$f717c522dcd748f);
$parcel$export(module.exports, "CHECKBOX", () => $35736b752a767065$export$6b636bdca7063f33);
$parcel$export(module.exports, "RADIO", () => $35736b752a767065$export$f0fd3c01e562401e);
$parcel$export(module.exports, "RADIO_GROUP", () => $35736b752a767065$export$fd120c956045e61b);
$parcel$export(module.exports, "SWITCH", () => $35736b752a767065$export$d19595eff304150b);
$parcel$export(module.exports, "SWITCH_INNER_TEXT", () => $35736b752a767065$export$33abfe9257d195b1);
$parcel$export(module.exports, "FILE_INPUT", () => $35736b752a767065$export$57b7f518a2a69b0e);
$parcel$export(module.exports, "FILE_INPUT_HAS_SELECTION", () => $35736b752a767065$export$3359eeec929a0672);
$parcel$export(module.exports, "FILE_UPLOAD_INPUT", () => $35736b752a767065$export$c7e0715fb31daeab);
$parcel$export(module.exports, "FILE_UPLOAD_INPUT_CUSTOM_TEXT", () => $35736b752a767065$export$59e222d99c2278dc);
$parcel$export(module.exports, "KEY", () => $35736b752a767065$export$7167c830cefcb6b5);
$parcel$export(module.exports, "KEY_COMBO", () => $35736b752a767065$export$3fe55454f8e5fecc);
$parcel$export(module.exports, "MODIFIER_KEY", () => $35736b752a767065$export$c0bfb400388c9a25);
$parcel$export(module.exports, "HOTKEY", () => $35736b752a767065$export$524232ca2c12639f);
$parcel$export(module.exports, "HOTKEY_LABEL", () => $35736b752a767065$export$df79a4ea2a4b4f00);
$parcel$export(module.exports, "HOTKEY_COLUMN", () => $35736b752a767065$export$9781926db144baeb);
$parcel$export(module.exports, "HOTKEY_DIALOG", () => $35736b752a767065$export$66e6d5f9c266313f);
$parcel$export(module.exports, "LABEL", () => $35736b752a767065$export$37aee82a3cb1e8f7);
$parcel$export(module.exports, "FORM_GROUP", () => $35736b752a767065$export$eb9b2b8480b01f1a);
$parcel$export(module.exports, "FORM_CONTENT", () => $35736b752a767065$export$1247dfb8c6ce45b3);
$parcel$export(module.exports, "FORM_HELPER_TEXT", () => $35736b752a767065$export$7b266b21b246878c);
$parcel$export(module.exports, "FORM_GROUP_SUB_LABEL", () => $35736b752a767065$export$650c7aa14bc99906);
$parcel$export(module.exports, "MENU", () => $35736b752a767065$export$4f072ecaef317163);
$parcel$export(module.exports, "MENU_ITEM", () => $35736b752a767065$export$fec55ff920461811);
$parcel$export(module.exports, "MENU_ITEM_IS_SELECTABLE", () => $35736b752a767065$export$1607fdc199b2002d);
$parcel$export(module.exports, "MENU_ITEM_SELECTED_ICON", () => $35736b752a767065$export$57ecfc48b890391e);
$parcel$export(module.exports, "MENU_ITEM_ICON", () => $35736b752a767065$export$83ad8bedeaf892db);
$parcel$export(module.exports, "MENU_ITEM_LABEL", () => $35736b752a767065$export$127f1aff25359810);
$parcel$export(module.exports, "MENU_SUBMENU", () => $35736b752a767065$export$cb67094da280ec15);
$parcel$export(module.exports, "MENU_SUBMENU_ICON", () => $35736b752a767065$export$c803f550eda0736b);
$parcel$export(module.exports, "MENU_DIVIDER", () => $35736b752a767065$export$3d44661fef1f8fab);
$parcel$export(module.exports, "MENU_HEADER", () => $35736b752a767065$export$935edc360fae2305);
$parcel$export(module.exports, "MULTISTEP_DIALOG", () => $35736b752a767065$export$e4907b506e27c727);
$parcel$export(module.exports, "MULTISTEP_DIALOG_PANELS", () => $35736b752a767065$export$165374e683bfc3d1);
$parcel$export(module.exports, "MULTISTEP_DIALOG_LEFT_PANEL", () => $35736b752a767065$export$90dcb6be9a743a48);
$parcel$export(module.exports, "MULTISTEP_DIALOG_RIGHT_PANEL", () => $35736b752a767065$export$e9411f2a7cfd9180);
$parcel$export(module.exports, "MULTISTEP_DIALOG_NAV_TOP", () => $35736b752a767065$export$d124f327de7e3466);
$parcel$export(module.exports, "MULTISTEP_DIALOG_NAV_RIGHT", () => $35736b752a767065$export$ea2fba933a716cc1);
$parcel$export(module.exports, "SECTION", () => $35736b752a767065$export$524548702ba0011d);
$parcel$export(module.exports, "SECTION_COLLAPSED", () => $35736b752a767065$export$9ba725bcf1af0077);
$parcel$export(module.exports, "SECTION_HEADER", () => $35736b752a767065$export$63456c6676f3202e);
$parcel$export(module.exports, "SECTION_HEADER_LEFT", () => $35736b752a767065$export$9b06418cb438289c);
$parcel$export(module.exports, "SECTION_HEADER_TITLE", () => $35736b752a767065$export$74c36f1cd002a019);
$parcel$export(module.exports, "SECTION_HEADER_SUB_TITLE", () => $35736b752a767065$export$8ed21854aa0cfd29);
$parcel$export(module.exports, "SECTION_HEADER_DIVIDER", () => $35736b752a767065$export$de57f6a3819660b5);
$parcel$export(module.exports, "SECTION_HEADER_TABS", () => $35736b752a767065$export$7694981ef852b7da);
$parcel$export(module.exports, "SECTION_HEADER_RIGHT", () => $35736b752a767065$export$62cb9e4fef796ae4);
$parcel$export(module.exports, "SECTION_CARD", () => $35736b752a767065$export$4164b234af6a614a);
$parcel$export(module.exports, "NAVBAR", () => $35736b752a767065$export$f326e925396cee25);
$parcel$export(module.exports, "NAVBAR_GROUP", () => $35736b752a767065$export$1deea56284aa1171);
$parcel$export(module.exports, "NAVBAR_HEADING", () => $35736b752a767065$export$cad935353152fe7);
$parcel$export(module.exports, "NAVBAR_DIVIDER", () => $35736b752a767065$export$b91d5a600cda5fbf);
$parcel$export(module.exports, "NON_IDEAL_STATE", () => $35736b752a767065$export$c5a432c36e3e4b78);
$parcel$export(module.exports, "NON_IDEAL_STATE_VISUAL", () => $35736b752a767065$export$da806f614bdc1508);
$parcel$export(module.exports, "NON_IDEAL_STATE_TEXT", () => $35736b752a767065$export$d60a07aa759048a);
$parcel$export(module.exports, "NUMERIC_INPUT", () => $35736b752a767065$export$80e675620d8e3b55);
$parcel$export(module.exports, "OVERFLOW_LIST", () => $35736b752a767065$export$b73498d5fb011014);
$parcel$export(module.exports, "OVERFLOW_LIST_SPACER", () => $35736b752a767065$export$22f5645f551377bf);
$parcel$export(module.exports, "OVERLAY", () => $35736b752a767065$export$abec5a3e0b81aaba);
$parcel$export(module.exports, "OVERLAY_BACKDROP", () => $35736b752a767065$export$5b24c9aa87f5d19);
$parcel$export(module.exports, "OVERLAY_CONTAINER", () => $35736b752a767065$export$5c46fa2471ac640f);
$parcel$export(module.exports, "OVERLAY_CONTENT", () => $35736b752a767065$export$649e0e2ba5bce2b2);
$parcel$export(module.exports, "OVERLAY_INLINE", () => $35736b752a767065$export$d070066894e6449f);
$parcel$export(module.exports, "OVERLAY_OPEN", () => $35736b752a767065$export$15df4039dd977837);
$parcel$export(module.exports, "OVERLAY_SCROLL_CONTAINER", () => $35736b752a767065$export$164be6ff0724d89e);
$parcel$export(module.exports, "OVERLAY_START_FOCUS_TRAP", () => $35736b752a767065$export$b05704f848ce027);
$parcel$export(module.exports, "OVERLAY_END_FOCUS_TRAP", () => $35736b752a767065$export$72317839a64c29d3);
$parcel$export(module.exports, "PANEL_STACK", () => $35736b752a767065$export$977c8163a074ab4c);
$parcel$export(module.exports, "PANEL_STACK_HEADER", () => $35736b752a767065$export$86f0fc908ef772ca);
$parcel$export(module.exports, "PANEL_STACK_HEADER_BACK", () => $35736b752a767065$export$dba4a9d0529c5123);
$parcel$export(module.exports, "PANEL_STACK_VIEW", () => $35736b752a767065$export$9ba9ddd2abc1a482);
$parcel$export(module.exports, "PANEL_STACK2", () => $35736b752a767065$export$8b7fecf2fba0abf9);
$parcel$export(module.exports, "PANEL_STACK2_HEADER", () => $35736b752a767065$export$f9f46f21fbe4920c);
$parcel$export(module.exports, "PANEL_STACK2_HEADER_BACK", () => $35736b752a767065$export$bea2f695ce1f90b1);
$parcel$export(module.exports, "PANEL_STACK2_VIEW", () => $35736b752a767065$export$e6cf7858677f7d09);
$parcel$export(module.exports, "POPOVER", () => $35736b752a767065$export$dbe3482d899925c4);
$parcel$export(module.exports, "POPOVER_ARROW", () => $35736b752a767065$export$8eaa9259ba89a7e8);
$parcel$export(module.exports, "POPOVER_BACKDROP", () => $35736b752a767065$export$cd1026626bfe5c07);
$parcel$export(module.exports, "POPOVER_CAPTURING_DISMISS", () => $35736b752a767065$export$2cfbe2eb60c57d5b);
$parcel$export(module.exports, "POPOVER_CONTENT", () => $35736b752a767065$export$1e96671e28a297dd);
$parcel$export(module.exports, "POPOVER_CONTENT_PLACEMENT", () => $35736b752a767065$export$345b7893b44144f1);
$parcel$export(module.exports, "POPOVER_CONTENT_SIZING", () => $35736b752a767065$export$5b0bac172c0cf3a);
$parcel$export(module.exports, "POPOVER_DISMISS", () => $35736b752a767065$export$7d23743fb33d0182);
$parcel$export(module.exports, "POPOVER_DISMISS_OVERRIDE", () => $35736b752a767065$export$1f4f24a25ef790c0);
$parcel$export(module.exports, "POPOVER_MATCH_TARGET_WIDTH", () => $35736b752a767065$export$4e93ab2f5f3e0b11);
$parcel$export(module.exports, "POPOVER_OPEN", () => $35736b752a767065$export$e864f5b391d71738);
$parcel$export(module.exports, "POPOVER_POPPER_ESCAPED", () => $35736b752a767065$export$28f35cf1b92fac04);
$parcel$export(module.exports, "POPOVER_REFERENCE_HIDDEN", () => $35736b752a767065$export$4b518c2bca894b80);
$parcel$export(module.exports, "POPOVER_TARGET", () => $35736b752a767065$export$534b03eda12f917);
$parcel$export(module.exports, "POPOVER_TRANSITION_CONTAINER", () => $35736b752a767065$export$620767fe6c31e984);
$parcel$export(module.exports, "POPOVER_WRAPPER", () => $35736b752a767065$export$9361cd420f832cf2);
$parcel$export(module.exports, "PROGRESS_BAR", () => $35736b752a767065$export$40c78f7c1065c43c);
$parcel$export(module.exports, "PROGRESS_METER", () => $35736b752a767065$export$19dacc38bfe958b2);
$parcel$export(module.exports, "PROGRESS_NO_STRIPES", () => $35736b752a767065$export$52fec100aaa98b55);
$parcel$export(module.exports, "PROGRESS_NO_ANIMATION", () => $35736b752a767065$export$890ea6f485d6060f);
$parcel$export(module.exports, "PORTAL", () => $35736b752a767065$export$ac4d91f5203d82ae);
$parcel$export(module.exports, "SKELETON", () => $35736b752a767065$export$169e587b68892b4e);
$parcel$export(module.exports, "SLIDER", () => $35736b752a767065$export$992366d871da5550);
$parcel$export(module.exports, "SLIDER_AXIS", () => $35736b752a767065$export$229cabfdbcbdfc2d);
$parcel$export(module.exports, "SLIDER_HANDLE", () => $35736b752a767065$export$d5ec8f6bd4e7f30c);
$parcel$export(module.exports, "SLIDER_LABEL", () => $35736b752a767065$export$c7563cb73c31904);
$parcel$export(module.exports, "SLIDER_TRACK", () => $35736b752a767065$export$c17129aaccf9f04f);
$parcel$export(module.exports, "SLIDER_PROGRESS", () => $35736b752a767065$export$cb8b3334a21a52ed);
$parcel$export(module.exports, "START", () => $35736b752a767065$export$21c466265830bc3a);
$parcel$export(module.exports, "END", () => $35736b752a767065$export$32239d68d9c6cb49);
$parcel$export(module.exports, "SPINNER", () => $35736b752a767065$export$6bf3d9c372a8b76a);
$parcel$export(module.exports, "SPINNER_ANIMATION", () => $35736b752a767065$export$c422a257b54d6303);
$parcel$export(module.exports, "SPINNER_HEAD", () => $35736b752a767065$export$67c4dde5cd44a3bf);
$parcel$export(module.exports, "SPINNER_NO_SPIN", () => $35736b752a767065$export$35495e002696aec2);
$parcel$export(module.exports, "SPINNER_TRACK", () => $35736b752a767065$export$cf9c7c98d20f3675);
$parcel$export(module.exports, "SEGMENTED_CONTROL", () => $35736b752a767065$export$a9da50bcccdc2ea1);
$parcel$export(module.exports, "TAB", () => $35736b752a767065$export$f1c9dd0f5207dd5e);
$parcel$export(module.exports, "TAB_ICON", () => $35736b752a767065$export$761ffa813d3bcf7b);
$parcel$export(module.exports, "TAB_TAG", () => $35736b752a767065$export$21993928ad2e2f77);
$parcel$export(module.exports, "TAB_INDICATOR", () => $35736b752a767065$export$32364f631fea0fb);
$parcel$export(module.exports, "TAB_INDICATOR_WRAPPER", () => $35736b752a767065$export$8da12ef58da8ed12);
$parcel$export(module.exports, "TAB_LIST", () => $35736b752a767065$export$29216fa86fc3af12);
$parcel$export(module.exports, "TAB_PANEL", () => $35736b752a767065$export$1bc1faf0ee61fa47);
$parcel$export(module.exports, "TABS", () => $35736b752a767065$export$73b877b58963a4f);
$parcel$export(module.exports, "TAG", () => $35736b752a767065$export$2680f340d0781853);
$parcel$export(module.exports, "TAG_REMOVE", () => $35736b752a767065$export$1dace92eb43d2917);
$parcel$export(module.exports, "COMPOUND_TAG", () => $35736b752a767065$export$fe7a531a68939d45);
$parcel$export(module.exports, "COMPOUND_TAG_LEFT", () => $35736b752a767065$export$936a90ee17829787);
$parcel$export(module.exports, "COMPOUND_TAG_LEFT_CONTENT", () => $35736b752a767065$export$23fcc0f95d746a8);
$parcel$export(module.exports, "COMPOUND_TAG_RIGHT", () => $35736b752a767065$export$8b9fa1756fbe1a2c);
$parcel$export(module.exports, "COMPOUND_TAG_RIGHT_CONTENT", () => $35736b752a767065$export$eb7199f9fc66b8f3);
$parcel$export(module.exports, "TAG_INPUT", () => $35736b752a767065$export$ffaf3bbf154e07cf);
$parcel$export(module.exports, "TAG_INPUT_ICON", () => $35736b752a767065$export$999c53f91b6a7a4a);
$parcel$export(module.exports, "TAG_INPUT_VALUES", () => $35736b752a767065$export$1711f8b4411c6f5f);
$parcel$export(module.exports, "TOAST", () => $35736b752a767065$export$6d378d1ab7ed5175);
$parcel$export(module.exports, "TOAST_CONTAINER", () => $35736b752a767065$export$bda400aeced77722);
$parcel$export(module.exports, "TOAST_MESSAGE", () => $35736b752a767065$export$ce2171b20910fc4b);
$parcel$export(module.exports, "TOOLTIP", () => $35736b752a767065$export$1517edb21b105800);
$parcel$export(module.exports, "TOOLTIP_INDICATOR", () => $35736b752a767065$export$db434af9cd0173fa);
$parcel$export(module.exports, "TREE", () => $35736b752a767065$export$33ecaa422889cd80);
$parcel$export(module.exports, "TREE_NODE", () => $35736b752a767065$export$497d287dd067ff98);
$parcel$export(module.exports, "TREE_NODE_CARET", () => $35736b752a767065$export$bcef107a0b76070f);
$parcel$export(module.exports, "TREE_NODE_CARET_CLOSED", () => $35736b752a767065$export$ea4d3d46c22ddfed);
$parcel$export(module.exports, "TREE_NODE_CARET_NONE", () => $35736b752a767065$export$94af84e54168f6de);
$parcel$export(module.exports, "TREE_NODE_CARET_OPEN", () => $35736b752a767065$export$e023ef8de1b4549b);
$parcel$export(module.exports, "TREE_NODE_CONTENT", () => $35736b752a767065$export$2f310b4a8c8311c8);
$parcel$export(module.exports, "TREE_NODE_EXPANDED", () => $35736b752a767065$export$22ed5f498d01ae6c);
$parcel$export(module.exports, "TREE_NODE_ICON", () => $35736b752a767065$export$50f70f673012be50);
$parcel$export(module.exports, "TREE_NODE_LABEL", () => $35736b752a767065$export$9e24c367c0ac6f88);
$parcel$export(module.exports, "TREE_NODE_LIST", () => $35736b752a767065$export$eb052bba2c207529);
$parcel$export(module.exports, "TREE_NODE_SECONDARY_LABEL", () => $35736b752a767065$export$15c472de16dfeefd);
$parcel$export(module.exports, "TREE_NODE_SELECTED", () => $35736b752a767065$export$4a8bcbdf26c6e4af);
$parcel$export(module.exports, "TREE_ROOT", () => $35736b752a767065$export$b397da2e1679ac19);
$parcel$export(module.exports, "ICON", () => $35736b752a767065$export$d2b60e6b56e900e8);
$parcel$export(module.exports, "ICON_STANDARD", () => $35736b752a767065$export$9e817070703bebe0);
$parcel$export(module.exports, "ICON_LARGE", () => $35736b752a767065$export$ef62356806fa9c5a);
$parcel$export(module.exports, "ICON_MUTED", () => $35736b752a767065$export$42eab3af8b7fb664);
$parcel$export(module.exports, "getClassNamespace", () => $35736b752a767065$export$e018c2ab23bd5a2c);
$parcel$export(module.exports, "alignmentClass", () => $35736b752a767065$export$4677781bb583a8b4);
$parcel$export(module.exports, "iconClass", () => $35736b752a767065$export$9a22524e6364be6);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $jYXlB = parcelRequire("jYXlB");

var $buEzT = parcelRequire("buEzT");

var $jZOKR = parcelRequire("jZOKR");

var $iGyED = parcelRequire("iGyED");
var $35736b752a767065$var$NS = "bp5";
if (typeof BLUEPRINT_NAMESPACE !== "undefined") $35736b752a767065$var$NS = BLUEPRINT_NAMESPACE;
else if (typeof REACT_APP_BLUEPRINT_NAMESPACE !== "undefined") $35736b752a767065$var$NS = REACT_APP_BLUEPRINT_NAMESPACE;
var $35736b752a767065$export$2b35adb71b3f6143 = "".concat($35736b752a767065$var$NS, "-active");
var $35736b752a767065$export$7895aadd1956b1c7 = "".concat($35736b752a767065$var$NS, "-align-left");
var $35736b752a767065$export$f1299af03a3c605a = "".concat($35736b752a767065$var$NS, "-align-right");
var $35736b752a767065$export$db1cdb8627b81f84 = "".concat($35736b752a767065$var$NS, "-compact");
var $35736b752a767065$export$b9b16d1820185434 = "".concat($35736b752a767065$var$NS, "-dark");
var $35736b752a767065$export$8cd212c10b4124d2 = "".concat($35736b752a767065$var$NS, "-disabled");
var $35736b752a767065$export$5672a3e1deb5b505 = "".concat($35736b752a767065$var$NS, "-fill");
var $35736b752a767065$export$91f67f1eeaea8c1e = "".concat($35736b752a767065$var$NS, "-fixed");
var $35736b752a767065$export$3df9f2c23b50ca42 = "".concat($35736b752a767065$var$NS, "-fixed-top");
var $35736b752a767065$export$1ff9623b26415f8 = "".concat($35736b752a767065$var$NS, "-inline");
var $35736b752a767065$export$ceebd5febfdef8a3 = "".concat($35736b752a767065$var$NS, "-interactive");
var $35736b752a767065$export$7b93a10c0fefe3e3 = "".concat($35736b752a767065$var$NS, "-large");
var $35736b752a767065$export$26d55645375ca9a = "".concat($35736b752a767065$var$NS, "-loading");
var $35736b752a767065$export$a61ada011bb84f5 = "".concat($35736b752a767065$var$NS, "-minimal");
var $35736b752a767065$export$d31ef73d8bd6b2be = "".concat($35736b752a767065$var$NS, "-outlined");
var $35736b752a767065$export$1f3db38142bdf083 = "".concat($35736b752a767065$var$NS, "-padded");
var $35736b752a767065$export$49f467056ef3fc6c = "".concat($35736b752a767065$var$NS, "-multiline");
var $35736b752a767065$export$a45819e0f9bcfea2 = "".concat($35736b752a767065$var$NS, "-read-only");
var $35736b752a767065$export$58785fc667c0c50b = "".concat($35736b752a767065$var$NS, "-round");
var $35736b752a767065$export$657f886463d93938 = "".concat($35736b752a767065$var$NS, "-selected");
var $35736b752a767065$export$71dd4c8ecd45e95f = "".concat($35736b752a767065$var$NS, "-small");
var $35736b752a767065$export$9f2fe7df0ae9fdea = "".concat($35736b752a767065$var$NS, "-vertical");
var $35736b752a767065$export$4fb34bdcd97adf85 = $35736b752a767065$export$4f8aee4b943e40e((0, $iGyED.Position).TOP);
var $35736b752a767065$export$cec9b06edc71d96c = $35736b752a767065$export$4f8aee4b943e40e((0, $iGyED.Position).BOTTOM);
var $35736b752a767065$export$b0758137ee643e7 = $35736b752a767065$export$4f8aee4b943e40e((0, $iGyED.Position).LEFT);
var $35736b752a767065$export$4ed9c122bcc20157 = $35736b752a767065$export$4f8aee4b943e40e((0, $iGyED.Position).RIGHT);
var $35736b752a767065$export$c8efb467fc55a6a1 = $35736b752a767065$export$b7727d57dec24270((0, $buEzT.Elevation).ZERO);
var $35736b752a767065$export$7b5afc1ddf65f8b7 = $35736b752a767065$export$b7727d57dec24270((0, $buEzT.Elevation).ONE);
var $35736b752a767065$export$86dd92dfea4f39dd = $35736b752a767065$export$b7727d57dec24270((0, $buEzT.Elevation).TWO);
var $35736b752a767065$export$ef7592bd90f2537f = $35736b752a767065$export$b7727d57dec24270((0, $buEzT.Elevation).THREE);
var $35736b752a767065$export$1d67a24a95ef24c2 = $35736b752a767065$export$b7727d57dec24270((0, $buEzT.Elevation).FOUR);
var $35736b752a767065$export$37c8deab6e9ff120 = $35736b752a767065$export$6771d82d925c8189((0, $jZOKR.Intent).PRIMARY);
var $35736b752a767065$export$fd8d2f5f74a29424 = $35736b752a767065$export$6771d82d925c8189((0, $jZOKR.Intent).SUCCESS);
var $35736b752a767065$export$355c57fd095a7f5a = $35736b752a767065$export$6771d82d925c8189((0, $jZOKR.Intent).WARNING);
var $35736b752a767065$export$373495f4c0568b73 = $35736b752a767065$export$6771d82d925c8189((0, $jZOKR.Intent).DANGER);
var $35736b752a767065$export$aeda8252e54b50f7 = "".concat($35736b752a767065$var$NS, "-focus-disabled");
var $35736b752a767065$export$bedc1b77a139edca = "".concat($35736b752a767065$var$NS, "-focus-style-manager-ignore");
var $35736b752a767065$export$88620a540780da7c = "".concat($35736b752a767065$var$NS, "-ui-text");
var $35736b752a767065$export$d0190f823696a5cc = "".concat($35736b752a767065$var$NS, "-running-text");
var $35736b752a767065$export$558d226ddadcf457 = "".concat($35736b752a767065$var$NS, "-monospace-text");
var $35736b752a767065$export$50e449675bbd8ae2 = "".concat($35736b752a767065$var$NS, "-text-large");
var $35736b752a767065$export$504f956f6b2a8e65 = "".concat($35736b752a767065$var$NS, "-text-small");
var $35736b752a767065$export$31a5874ec7f49f29 = "".concat($35736b752a767065$var$NS, "-text-muted");
var $35736b752a767065$export$4aa79107ea222f04 = "".concat($35736b752a767065$var$NS, "-text-disabled");
var $35736b752a767065$export$cd50c877adf39dd7 = "".concat($35736b752a767065$var$NS, "-text-overflow-ellipsis");
var $35736b752a767065$export$afa7aa09bb57d54f = "".concat($35736b752a767065$var$NS, "-blockquote");
var $35736b752a767065$export$ec5856072852bd7f = "".concat($35736b752a767065$var$NS, "-code");
var $35736b752a767065$export$cf55d1bff75690da = "".concat($35736b752a767065$var$NS, "-code-block");
var $35736b752a767065$export$eef1738e402a65e6 = "".concat($35736b752a767065$var$NS, "-heading");
var $35736b752a767065$export$84cc8e12a434d4e = "".concat($35736b752a767065$var$NS, "-list");
var $35736b752a767065$export$e52b656749d9474c = "".concat($35736b752a767065$var$NS, "-list-unstyled");
var $35736b752a767065$export$850f7749a2909601 = "".concat($35736b752a767065$var$NS, "-rtl");
var $35736b752a767065$export$8dfce1a3f4c39a = "".concat($35736b752a767065$var$NS, "-alert");
var $35736b752a767065$export$5d3ddfb12869545d = "".concat($35736b752a767065$export$8dfce1a3f4c39a, "-body");
var $35736b752a767065$export$1dba7da5e8205b5f = "".concat($35736b752a767065$export$8dfce1a3f4c39a, "-contents");
var $35736b752a767065$export$a928c8e2db526b6c = "".concat($35736b752a767065$export$8dfce1a3f4c39a, "-footer");
var $35736b752a767065$export$474829b260ce19ab = "".concat($35736b752a767065$var$NS, "-breadcrumb");
var $35736b752a767065$export$d25ee28b316abe2a = "".concat($35736b752a767065$export$474829b260ce19ab, "-current");
var $35736b752a767065$export$c3619772211b515b = "".concat($35736b752a767065$export$474829b260ce19ab, "s");
var $35736b752a767065$export$6c5df38f864cf0e3 = "".concat($35736b752a767065$export$474829b260ce19ab, "s-collapsed");
var $35736b752a767065$export$b887e88d8d0739f6 = "".concat($35736b752a767065$var$NS, "-button");
var $35736b752a767065$export$cbb1216936bf389c = "".concat($35736b752a767065$export$b887e88d8d0739f6, "-group");
var $35736b752a767065$export$3fd25a11349a7fac = "".concat($35736b752a767065$export$b887e88d8d0739f6, "-spinner");
var $35736b752a767065$export$22617f068a979d82 = "".concat($35736b752a767065$export$b887e88d8d0739f6, "-text");
var $35736b752a767065$export$ae3fb0b35b6ca2a9 = "".concat($35736b752a767065$var$NS, "-callout");
var $35736b752a767065$export$c801bbbb1e2ccb0b = "".concat($35736b752a767065$export$ae3fb0b35b6ca2a9, "-has-body-content");
var $35736b752a767065$export$c4700bfd78cb069a = "".concat($35736b752a767065$export$ae3fb0b35b6ca2a9, "-icon");
var $35736b752a767065$export$95783a805443ad7d = "".concat($35736b752a767065$var$NS, "-card");
var $35736b752a767065$export$6769bd973fd6af36 = "".concat($35736b752a767065$var$NS, "-control-card");
var $35736b752a767065$export$d60e975594bbe489 = "".concat($35736b752a767065$export$6769bd973fd6af36, "-label");
var $35736b752a767065$export$9cedcb03c3922bb7 = "".concat($35736b752a767065$var$NS, "-switch-control-card");
var $35736b752a767065$export$3412f17fbe03c097 = "".concat($35736b752a767065$var$NS, "-checkbox-control-card");
var $35736b752a767065$export$4de35bcdbf177a1f = "".concat($35736b752a767065$var$NS, "-radio-control-card");
var $35736b752a767065$export$ad39b86c40d3c47c = "".concat($35736b752a767065$var$NS, "-card-list");
var $35736b752a767065$export$5adfba49857b538f = "".concat($35736b752a767065$export$ad39b86c40d3c47c, "-bordered");
var $35736b752a767065$export$a1b955d4799a6f74 = "".concat($35736b752a767065$var$NS, "-collapse");
var $35736b752a767065$export$e4d292b696959393 = "".concat($35736b752a767065$export$a1b955d4799a6f74, "-body");
var $35736b752a767065$export$6a0da22e72d4f0eb = "".concat($35736b752a767065$var$NS, "-context-menu");
var $35736b752a767065$export$b9534b88b3cef166 = "".concat($35736b752a767065$export$6a0da22e72d4f0eb, "-virtual-target");
var $35736b752a767065$export$7ee0ba3b9fa0a5ea = "".concat($35736b752a767065$export$6a0da22e72d4f0eb, "-popover");
var $35736b752a767065$export$418ef826d3ba978d = "".concat($35736b752a767065$export$6a0da22e72d4f0eb, "-backdrop");
var $35736b752a767065$export$1c86bb6d85c165 = "".concat($35736b752a767065$var$NS, "-control-group");
var $35736b752a767065$export$f99739dbfcd2e015 = "".concat($35736b752a767065$var$NS, "-dialog");
var $35736b752a767065$export$d84b649f32bf6ead = "".concat($35736b752a767065$export$f99739dbfcd2e015, "-container");
var $35736b752a767065$export$c09efbe888b20fd = "".concat($35736b752a767065$export$f99739dbfcd2e015, "-header");
var $35736b752a767065$export$12096ec1410ccb2 = "".concat($35736b752a767065$export$f99739dbfcd2e015, "-body");
var $35736b752a767065$export$dd51a6f3fef5a9d4 = "".concat($35736b752a767065$export$f99739dbfcd2e015, "-body-scroll-container");
var $35736b752a767065$export$9588cbdf14f4605f = "".concat($35736b752a767065$export$f99739dbfcd2e015, "-close-button");
var $35736b752a767065$export$6ea271a01e7dc590 = "".concat($35736b752a767065$export$f99739dbfcd2e015, "-footer");
var $35736b752a767065$export$b60b0eff9b84a85c = "".concat($35736b752a767065$export$f99739dbfcd2e015, "-footer-fixed");
var $35736b752a767065$export$a01581f2cb63a5c5 = "".concat($35736b752a767065$export$f99739dbfcd2e015, "-footer-main-section");
var $35736b752a767065$export$6ab793fb94a2b7f8 = "".concat($35736b752a767065$export$f99739dbfcd2e015, "-footer-actions");
var $35736b752a767065$export$ff97c652790bdec = "".concat($35736b752a767065$var$NS, "-dialog-step");
var $35736b752a767065$export$15158775e667dbe6 = "".concat($35736b752a767065$export$ff97c652790bdec, "-container");
var $35736b752a767065$export$e6263bc32f85a4a4 = "".concat($35736b752a767065$export$ff97c652790bdec, "-title");
var $35736b752a767065$export$e7c377477d704043 = "".concat($35736b752a767065$export$ff97c652790bdec, "-icon");
var $35736b752a767065$export$97e1fe7e02b9bd0 = "".concat($35736b752a767065$export$ff97c652790bdec, "-viewed");
var $35736b752a767065$export$59669b530bfa91b6 = "".concat($35736b752a767065$var$NS, "-divider");
var $35736b752a767065$export$9d2de6eebf7462b5 = "".concat($35736b752a767065$var$NS, "-drawer");
var $35736b752a767065$export$a772fb749abfcf1d = "".concat($35736b752a767065$export$9d2de6eebf7462b5, "-body");
var $35736b752a767065$export$b9287ddc8f6e3044 = "".concat($35736b752a767065$export$9d2de6eebf7462b5, "-footer");
var $35736b752a767065$export$4cd03a6721b31533 = "".concat($35736b752a767065$export$9d2de6eebf7462b5, "-header");
var $35736b752a767065$export$8cffb49e9dd41ae = "".concat($35736b752a767065$var$NS, "-editable-text");
var $35736b752a767065$export$78b1aa7020d6af37 = "".concat($35736b752a767065$export$8cffb49e9dd41ae, "-content");
var $35736b752a767065$export$2d16d4c1c295606c = "".concat($35736b752a767065$export$8cffb49e9dd41ae, "-editing");
var $35736b752a767065$export$4d6e427d15d16553 = "".concat($35736b752a767065$export$8cffb49e9dd41ae, "-input");
var $35736b752a767065$export$90d364a014ea6f0a = "".concat($35736b752a767065$export$8cffb49e9dd41ae, "-placeholder");
var $35736b752a767065$export$659c2dc95c10337e = "".concat($35736b752a767065$var$NS, "-entity-title");
var $35736b752a767065$export$c92e868735e7ed90 = "".concat($35736b752a767065$var$NS, "-entity-title-ellipsize");
var $35736b752a767065$export$32306a4d67fbbec = "".concat($35736b752a767065$export$659c2dc95c10337e, "-has-subtitle");
var $35736b752a767065$export$4a30999b77042528 = "".concat($35736b752a767065$export$659c2dc95c10337e, "-icon-container");
var $35736b752a767065$export$6d113d689052ca80 = "".concat($35736b752a767065$export$659c2dc95c10337e, "-subtitle");
var $35736b752a767065$export$2b6f21fa0a5321de = "".concat($35736b752a767065$export$659c2dc95c10337e, "-tags-container");
var $35736b752a767065$export$dfa64ede72bd0307 = "".concat($35736b752a767065$export$659c2dc95c10337e, "-text");
var $35736b752a767065$export$e57a71e20aa8627 = "".concat($35736b752a767065$export$659c2dc95c10337e, "-title");
var $35736b752a767065$export$85f27204a6624107 = "".concat($35736b752a767065$export$659c2dc95c10337e, "-title-and-tags");
var $35736b752a767065$export$bab85e3adc70edd1 = "".concat($35736b752a767065$var$NS, "-flex-expander");
var $35736b752a767065$export$c50fbf6be7ac3331 = "".concat($35736b752a767065$var$NS, "-html-select");
var $35736b752a767065$export$718a6b7ababf8ba7 = "".concat($35736b752a767065$var$NS, "-select");
var $35736b752a767065$export$76a315d343674c9b = "".concat($35736b752a767065$var$NS, "-html-table");
var $35736b752a767065$export$13618d7eda5fcc77 = "".concat($35736b752a767065$export$76a315d343674c9b, "-bordered");
var $35736b752a767065$export$a2a4accb8fbddd4a = "".concat($35736b752a767065$export$76a315d343674c9b, "-striped");
var $35736b752a767065$export$9ea760072c364d49 = "".concat($35736b752a767065$var$NS, "-input");
var $35736b752a767065$export$e8d5c1be80b7588b = "".concat($35736b752a767065$export$9ea760072c364d49, "-ghost");
var $35736b752a767065$export$87f36efdfb463a6f = "".concat($35736b752a767065$export$9ea760072c364d49, "-group");
var $35736b752a767065$export$9705bb16375b49e5 = "".concat($35736b752a767065$export$9ea760072c364d49, "-left-container");
var $35736b752a767065$export$217bb10d53bd2e48 = "".concat($35736b752a767065$export$9ea760072c364d49, "-action");
var $35736b752a767065$export$f038e7a42893c7e5 = "".concat($35736b752a767065$var$NS, "-resizable-input-span");
var $35736b752a767065$export$794d3720201fcdd9 = "".concat($35736b752a767065$var$NS, "-text-area");
var $35736b752a767065$export$9c466612a9056aac = "".concat($35736b752a767065$export$794d3720201fcdd9, "-auto-resize");
var $35736b752a767065$export$43f367b3e957f219 = "".concat($35736b752a767065$var$NS, "-control");
var $35736b752a767065$export$947bb9f998f185cb = "".concat($35736b752a767065$export$43f367b3e957f219, "-indicator");
var $35736b752a767065$export$f717c522dcd748f = "".concat($35736b752a767065$export$947bb9f998f185cb, "-child");
var $35736b752a767065$export$6b636bdca7063f33 = "".concat($35736b752a767065$var$NS, "-checkbox");
var $35736b752a767065$export$f0fd3c01e562401e = "".concat($35736b752a767065$var$NS, "-radio");
var $35736b752a767065$export$fd120c956045e61b = "".concat($35736b752a767065$var$NS, "-radio-group");
var $35736b752a767065$export$d19595eff304150b = "".concat($35736b752a767065$var$NS, "-switch");
var $35736b752a767065$export$33abfe9257d195b1 = "".concat($35736b752a767065$export$d19595eff304150b, "-inner-text");
var $35736b752a767065$export$57b7f518a2a69b0e = "".concat($35736b752a767065$var$NS, "-file-input");
var $35736b752a767065$export$3359eeec929a0672 = "".concat($35736b752a767065$var$NS, "-file-input-has-selection");
var $35736b752a767065$export$c7e0715fb31daeab = "".concat($35736b752a767065$var$NS, "-file-upload-input");
var $35736b752a767065$export$59e222d99c2278dc = "".concat($35736b752a767065$var$NS, "-file-upload-input-custom-text");
var $35736b752a767065$export$7167c830cefcb6b5 = "".concat($35736b752a767065$var$NS, "-key");
var $35736b752a767065$export$3fe55454f8e5fecc = "".concat($35736b752a767065$export$7167c830cefcb6b5, "-combo");
var $35736b752a767065$export$c0bfb400388c9a25 = "".concat($35736b752a767065$var$NS, "-modifier-key");
var $35736b752a767065$export$524232ca2c12639f = "".concat($35736b752a767065$var$NS, "-hotkey");
var $35736b752a767065$export$df79a4ea2a4b4f00 = "".concat($35736b752a767065$export$524232ca2c12639f, "-label");
var $35736b752a767065$export$9781926db144baeb = "".concat($35736b752a767065$export$524232ca2c12639f, "-column");
var $35736b752a767065$export$66e6d5f9c266313f = "".concat($35736b752a767065$export$524232ca2c12639f, "-dialog");
var $35736b752a767065$export$37aee82a3cb1e8f7 = "".concat($35736b752a767065$var$NS, "-label");
var $35736b752a767065$export$eb9b2b8480b01f1a = "".concat($35736b752a767065$var$NS, "-form-group");
var $35736b752a767065$export$1247dfb8c6ce45b3 = "".concat($35736b752a767065$var$NS, "-form-content");
var $35736b752a767065$export$7b266b21b246878c = "".concat($35736b752a767065$var$NS, "-form-helper-text");
var $35736b752a767065$export$650c7aa14bc99906 = "".concat($35736b752a767065$var$NS, "-form-group-sub-label");
var $35736b752a767065$export$4f072ecaef317163 = "".concat($35736b752a767065$var$NS, "-menu");
var $35736b752a767065$export$fec55ff920461811 = "".concat($35736b752a767065$export$4f072ecaef317163, "-item");
var $35736b752a767065$export$1607fdc199b2002d = "".concat($35736b752a767065$export$fec55ff920461811, "-is-selectable");
var $35736b752a767065$export$57ecfc48b890391e = "".concat($35736b752a767065$export$fec55ff920461811, "-selected-icon");
var $35736b752a767065$export$83ad8bedeaf892db = "".concat($35736b752a767065$export$fec55ff920461811, "-icon");
var $35736b752a767065$export$127f1aff25359810 = "".concat($35736b752a767065$export$fec55ff920461811, "-label");
var $35736b752a767065$export$cb67094da280ec15 = "".concat($35736b752a767065$var$NS, "-submenu");
var $35736b752a767065$export$c803f550eda0736b = "".concat($35736b752a767065$export$cb67094da280ec15, "-icon");
var $35736b752a767065$export$3d44661fef1f8fab = "".concat($35736b752a767065$export$4f072ecaef317163, "-divider");
var $35736b752a767065$export$935edc360fae2305 = "".concat($35736b752a767065$export$4f072ecaef317163, "-header");
var $35736b752a767065$export$e4907b506e27c727 = "".concat($35736b752a767065$var$NS, "-multistep-dialog");
var $35736b752a767065$export$165374e683bfc3d1 = "".concat($35736b752a767065$export$e4907b506e27c727, "-panels");
var $35736b752a767065$export$90dcb6be9a743a48 = "".concat($35736b752a767065$export$e4907b506e27c727, "-left-panel");
var $35736b752a767065$export$e9411f2a7cfd9180 = "".concat($35736b752a767065$export$e4907b506e27c727, "-right-panel");
var $35736b752a767065$export$d124f327de7e3466 = "".concat($35736b752a767065$export$e4907b506e27c727, "-nav-top");
var $35736b752a767065$export$ea2fba933a716cc1 = "".concat($35736b752a767065$export$e4907b506e27c727, "-nav-right");
var $35736b752a767065$export$524548702ba0011d = "".concat($35736b752a767065$var$NS, "-section");
var $35736b752a767065$export$9ba725bcf1af0077 = "".concat($35736b752a767065$export$524548702ba0011d, "-collapsed");
var $35736b752a767065$export$63456c6676f3202e = "".concat($35736b752a767065$export$524548702ba0011d, "-header");
var $35736b752a767065$export$9b06418cb438289c = "".concat($35736b752a767065$export$63456c6676f3202e, "-left");
var $35736b752a767065$export$74c36f1cd002a019 = "".concat($35736b752a767065$export$63456c6676f3202e, "-title");
var $35736b752a767065$export$8ed21854aa0cfd29 = "".concat($35736b752a767065$export$63456c6676f3202e, "-sub-title");
var $35736b752a767065$export$de57f6a3819660b5 = "".concat($35736b752a767065$export$63456c6676f3202e, "-divider");
var $35736b752a767065$export$7694981ef852b7da = "".concat($35736b752a767065$export$63456c6676f3202e, "-tabs");
var $35736b752a767065$export$62cb9e4fef796ae4 = "".concat($35736b752a767065$export$63456c6676f3202e, "-right");
var $35736b752a767065$export$4164b234af6a614a = "".concat($35736b752a767065$export$524548702ba0011d, "-card");
var $35736b752a767065$export$f326e925396cee25 = "".concat($35736b752a767065$var$NS, "-navbar");
var $35736b752a767065$export$1deea56284aa1171 = "".concat($35736b752a767065$export$f326e925396cee25, "-group");
var $35736b752a767065$export$cad935353152fe7 = "".concat($35736b752a767065$export$f326e925396cee25, "-heading");
var $35736b752a767065$export$b91d5a600cda5fbf = "".concat($35736b752a767065$export$f326e925396cee25, "-divider");
var $35736b752a767065$export$c5a432c36e3e4b78 = "".concat($35736b752a767065$var$NS, "-non-ideal-state");
var $35736b752a767065$export$da806f614bdc1508 = "".concat($35736b752a767065$export$c5a432c36e3e4b78, "-visual");
var $35736b752a767065$export$d60a07aa759048a = "".concat($35736b752a767065$export$c5a432c36e3e4b78, "-text");
var $35736b752a767065$export$80e675620d8e3b55 = "".concat($35736b752a767065$var$NS, "-numeric-input");
var $35736b752a767065$export$b73498d5fb011014 = "".concat($35736b752a767065$var$NS, "-overflow-list");
var $35736b752a767065$export$22f5645f551377bf = "".concat($35736b752a767065$export$b73498d5fb011014, "-spacer");
var $35736b752a767065$export$abec5a3e0b81aaba = "".concat($35736b752a767065$var$NS, "-overlay");
var $35736b752a767065$export$5b24c9aa87f5d19 = "".concat($35736b752a767065$export$abec5a3e0b81aaba, "-backdrop");
var $35736b752a767065$export$5c46fa2471ac640f = "".concat($35736b752a767065$export$abec5a3e0b81aaba, "-container");
var $35736b752a767065$export$649e0e2ba5bce2b2 = "".concat($35736b752a767065$export$abec5a3e0b81aaba, "-content");
var $35736b752a767065$export$d070066894e6449f = "".concat($35736b752a767065$export$abec5a3e0b81aaba, "-inline");
var $35736b752a767065$export$15df4039dd977837 = "".concat($35736b752a767065$export$abec5a3e0b81aaba, "-open");
var $35736b752a767065$export$164be6ff0724d89e = "".concat($35736b752a767065$export$abec5a3e0b81aaba, "-scroll-container");
var $35736b752a767065$export$b05704f848ce027 = "".concat($35736b752a767065$export$abec5a3e0b81aaba, "-start-focus-trap");
var $35736b752a767065$export$72317839a64c29d3 = "".concat($35736b752a767065$export$abec5a3e0b81aaba, "-end-focus-trap");
var $35736b752a767065$export$977c8163a074ab4c = "".concat($35736b752a767065$var$NS, "-panel-stack");
var $35736b752a767065$export$86f0fc908ef772ca = "".concat($35736b752a767065$export$977c8163a074ab4c, "-header");
var $35736b752a767065$export$dba4a9d0529c5123 = "".concat($35736b752a767065$export$977c8163a074ab4c, "-header-back");
var $35736b752a767065$export$9ba9ddd2abc1a482 = "".concat($35736b752a767065$export$977c8163a074ab4c, "-view");
var $35736b752a767065$export$8b7fecf2fba0abf9 = "".concat($35736b752a767065$var$NS, "-panel-stack2");
var $35736b752a767065$export$f9f46f21fbe4920c = "".concat($35736b752a767065$export$977c8163a074ab4c, "-header");
var $35736b752a767065$export$bea2f695ce1f90b1 = "".concat($35736b752a767065$export$977c8163a074ab4c, "-header-back");
var $35736b752a767065$export$e6cf7858677f7d09 = "".concat($35736b752a767065$export$977c8163a074ab4c, "-view");
var $35736b752a767065$export$dbe3482d899925c4 = "".concat($35736b752a767065$var$NS, "-popover");
var $35736b752a767065$export$8eaa9259ba89a7e8 = "".concat($35736b752a767065$export$dbe3482d899925c4, "-arrow");
var $35736b752a767065$export$cd1026626bfe5c07 = "".concat($35736b752a767065$export$dbe3482d899925c4, "-backdrop");
var $35736b752a767065$export$2cfbe2eb60c57d5b = "".concat($35736b752a767065$export$dbe3482d899925c4, "-capturing-dismiss");
var $35736b752a767065$export$1e96671e28a297dd = "".concat($35736b752a767065$export$dbe3482d899925c4, "-content");
var $35736b752a767065$export$345b7893b44144f1 = "".concat($35736b752a767065$export$dbe3482d899925c4, "-placement");
var $35736b752a767065$export$5b0bac172c0cf3a = "".concat($35736b752a767065$export$1e96671e28a297dd, "-sizing");
var $35736b752a767065$export$7d23743fb33d0182 = "".concat($35736b752a767065$export$dbe3482d899925c4, "-dismiss");
var $35736b752a767065$export$1f4f24a25ef790c0 = "".concat($35736b752a767065$export$7d23743fb33d0182, "-override");
var $35736b752a767065$export$4e93ab2f5f3e0b11 = "".concat($35736b752a767065$export$dbe3482d899925c4, "-match-target-width");
var $35736b752a767065$export$e864f5b391d71738 = "".concat($35736b752a767065$export$dbe3482d899925c4, "-open");
var $35736b752a767065$export$28f35cf1b92fac04 = "".concat($35736b752a767065$export$dbe3482d899925c4, "-popper-escaped");
var $35736b752a767065$export$4b518c2bca894b80 = "".concat($35736b752a767065$export$dbe3482d899925c4, "-reference-hidden");
var $35736b752a767065$export$534b03eda12f917 = "".concat($35736b752a767065$export$dbe3482d899925c4, "-target");
var $35736b752a767065$export$620767fe6c31e984 = "".concat($35736b752a767065$export$dbe3482d899925c4, "-transition-container");
var $35736b752a767065$export$9361cd420f832cf2 = "".concat($35736b752a767065$export$dbe3482d899925c4, "-wrapper");
var $35736b752a767065$export$40c78f7c1065c43c = "".concat($35736b752a767065$var$NS, "-progress-bar");
var $35736b752a767065$export$19dacc38bfe958b2 = "".concat($35736b752a767065$var$NS, "-progress-meter");
var $35736b752a767065$export$52fec100aaa98b55 = "".concat($35736b752a767065$var$NS, "-no-stripes");
var $35736b752a767065$export$890ea6f485d6060f = "".concat($35736b752a767065$var$NS, "-no-animation");
var $35736b752a767065$export$ac4d91f5203d82ae = "".concat($35736b752a767065$var$NS, "-portal");
var $35736b752a767065$export$169e587b68892b4e = "".concat($35736b752a767065$var$NS, "-skeleton");
var $35736b752a767065$export$992366d871da5550 = "".concat($35736b752a767065$var$NS, "-slider");
var $35736b752a767065$export$229cabfdbcbdfc2d = "".concat($35736b752a767065$export$992366d871da5550, "-axis");
var $35736b752a767065$export$d5ec8f6bd4e7f30c = "".concat($35736b752a767065$export$992366d871da5550, "-handle");
var $35736b752a767065$export$c7563cb73c31904 = "".concat($35736b752a767065$export$992366d871da5550, "-label");
var $35736b752a767065$export$c17129aaccf9f04f = "".concat($35736b752a767065$export$992366d871da5550, "-track");
var $35736b752a767065$export$cb8b3334a21a52ed = "".concat($35736b752a767065$export$992366d871da5550, "-progress");
var $35736b752a767065$export$21c466265830bc3a = "".concat($35736b752a767065$var$NS, "-start");
var $35736b752a767065$export$32239d68d9c6cb49 = "".concat($35736b752a767065$var$NS, "-end");
var $35736b752a767065$export$6bf3d9c372a8b76a = "".concat($35736b752a767065$var$NS, "-spinner");
var $35736b752a767065$export$c422a257b54d6303 = "".concat($35736b752a767065$export$6bf3d9c372a8b76a, "-animation");
var $35736b752a767065$export$67c4dde5cd44a3bf = "".concat($35736b752a767065$export$6bf3d9c372a8b76a, "-head");
var $35736b752a767065$export$35495e002696aec2 = "".concat($35736b752a767065$var$NS, "-no-spin");
var $35736b752a767065$export$cf9c7c98d20f3675 = "".concat($35736b752a767065$export$6bf3d9c372a8b76a, "-track");
var $35736b752a767065$export$a9da50bcccdc2ea1 = "".concat($35736b752a767065$var$NS, "-segmented-control");
var $35736b752a767065$export$f1c9dd0f5207dd5e = "".concat($35736b752a767065$var$NS, "-tab");
var $35736b752a767065$export$761ffa813d3bcf7b = "".concat($35736b752a767065$export$f1c9dd0f5207dd5e, "-icon");
var $35736b752a767065$export$21993928ad2e2f77 = "".concat($35736b752a767065$export$f1c9dd0f5207dd5e, "-tag");
var $35736b752a767065$export$32364f631fea0fb = "".concat($35736b752a767065$export$f1c9dd0f5207dd5e, "-indicator");
var $35736b752a767065$export$8da12ef58da8ed12 = "".concat($35736b752a767065$export$32364f631fea0fb, "-wrapper");
var $35736b752a767065$export$29216fa86fc3af12 = "".concat($35736b752a767065$export$f1c9dd0f5207dd5e, "-list");
var $35736b752a767065$export$1bc1faf0ee61fa47 = "".concat($35736b752a767065$export$f1c9dd0f5207dd5e, "-panel");
var $35736b752a767065$export$73b877b58963a4f = "".concat($35736b752a767065$export$f1c9dd0f5207dd5e, "s");
var $35736b752a767065$export$2680f340d0781853 = "".concat($35736b752a767065$var$NS, "-tag");
var $35736b752a767065$export$1dace92eb43d2917 = "".concat($35736b752a767065$export$2680f340d0781853, "-remove");
var $35736b752a767065$export$fe7a531a68939d45 = "".concat($35736b752a767065$var$NS, "-compound-tag");
var $35736b752a767065$export$936a90ee17829787 = "".concat($35736b752a767065$export$fe7a531a68939d45, "-left");
var $35736b752a767065$export$23fcc0f95d746a8 = "".concat($35736b752a767065$export$fe7a531a68939d45, "-left-content");
var $35736b752a767065$export$8b9fa1756fbe1a2c = "".concat($35736b752a767065$export$fe7a531a68939d45, "-right");
var $35736b752a767065$export$eb7199f9fc66b8f3 = "".concat($35736b752a767065$export$fe7a531a68939d45, "-right-content");
var $35736b752a767065$export$ffaf3bbf154e07cf = "".concat($35736b752a767065$var$NS, "-tag-input");
var $35736b752a767065$export$999c53f91b6a7a4a = "".concat($35736b752a767065$export$ffaf3bbf154e07cf, "-icon");
var $35736b752a767065$export$1711f8b4411c6f5f = "".concat($35736b752a767065$export$ffaf3bbf154e07cf, "-values");
var $35736b752a767065$export$6d378d1ab7ed5175 = "".concat($35736b752a767065$var$NS, "-toast");
var $35736b752a767065$export$bda400aeced77722 = "".concat($35736b752a767065$export$6d378d1ab7ed5175, "-container");
var $35736b752a767065$export$ce2171b20910fc4b = "".concat($35736b752a767065$export$6d378d1ab7ed5175, "-message");
var $35736b752a767065$export$1517edb21b105800 = "".concat($35736b752a767065$var$NS, "-tooltip");
var $35736b752a767065$export$db434af9cd0173fa = "".concat($35736b752a767065$export$1517edb21b105800, "-indicator");
var $35736b752a767065$export$33ecaa422889cd80 = "".concat($35736b752a767065$var$NS, "-tree");
var $35736b752a767065$export$497d287dd067ff98 = "".concat($35736b752a767065$var$NS, "-tree-node");
var $35736b752a767065$export$bcef107a0b76070f = "".concat($35736b752a767065$export$497d287dd067ff98, "-caret");
var $35736b752a767065$export$ea4d3d46c22ddfed = "".concat($35736b752a767065$export$bcef107a0b76070f, "-closed");
var $35736b752a767065$export$94af84e54168f6de = "".concat($35736b752a767065$export$bcef107a0b76070f, "-none");
var $35736b752a767065$export$e023ef8de1b4549b = "".concat($35736b752a767065$export$bcef107a0b76070f, "-open");
var $35736b752a767065$export$2f310b4a8c8311c8 = "".concat($35736b752a767065$export$497d287dd067ff98, "-content");
var $35736b752a767065$export$22ed5f498d01ae6c = "".concat($35736b752a767065$export$497d287dd067ff98, "-expanded");
var $35736b752a767065$export$50f70f673012be50 = "".concat($35736b752a767065$export$497d287dd067ff98, "-icon");
var $35736b752a767065$export$9e24c367c0ac6f88 = "".concat($35736b752a767065$export$497d287dd067ff98, "-label");
var $35736b752a767065$export$eb052bba2c207529 = "".concat($35736b752a767065$export$497d287dd067ff98, "-list");
var $35736b752a767065$export$15c472de16dfeefd = "".concat($35736b752a767065$export$497d287dd067ff98, "-secondary-label");
var $35736b752a767065$export$4a8bcbdf26c6e4af = "".concat($35736b752a767065$export$497d287dd067ff98, "-selected");
var $35736b752a767065$export$b397da2e1679ac19 = "".concat($35736b752a767065$var$NS, "-tree-root");
var $35736b752a767065$export$d2b60e6b56e900e8 = "".concat($35736b752a767065$var$NS, "-icon");
var $35736b752a767065$export$9e817070703bebe0 = "".concat($35736b752a767065$export$d2b60e6b56e900e8, "-standard");
var $35736b752a767065$export$ef62356806fa9c5a = "".concat($35736b752a767065$export$d2b60e6b56e900e8, "-large");
var $35736b752a767065$export$42eab3af8b7fb664 = "".concat($35736b752a767065$export$d2b60e6b56e900e8, "-muted");
function $35736b752a767065$export$e018c2ab23bd5a2c() {
    return $35736b752a767065$var$NS;
}
function $35736b752a767065$export$4677781bb583a8b4(alignment) {
    switch(alignment){
        case (0, $jYXlB.Alignment).LEFT:
            return $35736b752a767065$export$7895aadd1956b1c7;
        case (0, $jYXlB.Alignment).RIGHT:
            return $35736b752a767065$export$f1299af03a3c605a;
        default:
            return undefined;
    }
}
function $35736b752a767065$export$b7727d57dec24270(elevation) {
    if (elevation === undefined) return undefined;
    return "".concat($35736b752a767065$var$NS, "-elevation-").concat(elevation);
}
function $35736b752a767065$export$9a22524e6364be6(iconName) {
    if (iconName == null) return undefined;
    return iconName.indexOf("".concat($35736b752a767065$var$NS, "-icon-")) === 0 ? iconName : "".concat($35736b752a767065$var$NS, "-icon-").concat(iconName);
}
function $35736b752a767065$export$6771d82d925c8189(intent) {
    if (intent == null || intent === (0, $jZOKR.Intent).NONE) return undefined;
    return "".concat($35736b752a767065$var$NS, "-intent-").concat(intent.toLowerCase());
}
function $35736b752a767065$export$4f8aee4b943e40e(position) {
    if (position === undefined) return undefined;
    return "".concat($35736b752a767065$var$NS, "-position-").concat(position);
}

});
parcelRegister("jYXlB", function(module, exports) {

$parcel$export(module.exports, "Alignment", () => $e8c1a813dd49785e$export$9d7927214ed7d2cf);
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Alignment along the horizontal axis. */ var $e8c1a813dd49785e$export$9d7927214ed7d2cf = {
    CENTER: "center",
    LEFT: "left",
    RIGHT: "right"
};

});

parcelRegister("buEzT", function(module, exports) {

$parcel$export(module.exports, "Elevation", () => $85e1f8f7081cd3fa$export$58bfb4f6ec5aa58d);
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // tslint:disable:object-literal-sort-keys
var $85e1f8f7081cd3fa$export$58bfb4f6ec5aa58d = {
    ZERO: 0,
    ONE: 1,
    TWO: 2,
    THREE: 3,
    FOUR: 4
};

});

parcelRegister("jZOKR", function(module, exports) {

$parcel$export(module.exports, "Intent", () => $e8eb15a8210782dd$export$dc3e8878c31a5f1c);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // tslint:disable:object-literal-sort-keys
/**
 * The four basic intents.
 */ var $e8eb15a8210782dd$export$dc3e8878c31a5f1c = {
    NONE: "none",
    PRIMARY: "primary",
    SUCCESS: "success",
    WARNING: "warning",
    DANGER: "danger"
};

});

parcelRegister("iGyED", function(module, exports) {

$parcel$export(module.exports, "Position", () => $d9a707ded6b61403$export$13807d9ee5a34a42);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d9a707ded6b61403$export$13807d9ee5a34a42 = {
    BOTTOM: "bottom",
    BOTTOM_LEFT: "bottom-left",
    BOTTOM_RIGHT: "bottom-right",
    LEFT: "left",
    LEFT_BOTTOM: "left-bottom",
    LEFT_TOP: "left-top",
    RIGHT: "right",
    RIGHT_BOTTOM: "right-bottom",
    RIGHT_TOP: "right-top",
    TOP: "top",
    TOP_LEFT: "top-left",
    TOP_RIGHT: "top-right"
};
function $d9a707ded6b61403$export$b0b056baf6a0eb37(position) {
    /* istanbul ignore next */ return position === $d9a707ded6b61403$export$13807d9ee5a34a42.TOP || position === $d9a707ded6b61403$export$13807d9ee5a34a42.TOP_LEFT || position === $d9a707ded6b61403$export$13807d9ee5a34a42.TOP_RIGHT || position === $d9a707ded6b61403$export$13807d9ee5a34a42.BOTTOM || position === $d9a707ded6b61403$export$13807d9ee5a34a42.BOTTOM_LEFT || position === $d9a707ded6b61403$export$13807d9ee5a34a42.BOTTOM_RIGHT;
}
function $d9a707ded6b61403$export$5df8e457999da1ae(position) {
    /* istanbul ignore next */ return position === $d9a707ded6b61403$export$13807d9ee5a34a42.LEFT || position === $d9a707ded6b61403$export$13807d9ee5a34a42.LEFT_TOP || position === $d9a707ded6b61403$export$13807d9ee5a34a42.LEFT_BOTTOM || position === $d9a707ded6b61403$export$13807d9ee5a34a42.RIGHT || position === $d9a707ded6b61403$export$13807d9ee5a34a42.RIGHT_TOP || position === $d9a707ded6b61403$export$13807d9ee5a34a42.RIGHT_BOTTOM;
}
function $d9a707ded6b61403$export$a531f93822c3a253(position) {
    if (position === $d9a707ded6b61403$export$13807d9ee5a34a42.TOP || position === $d9a707ded6b61403$export$13807d9ee5a34a42.TOP_LEFT || position === $d9a707ded6b61403$export$13807d9ee5a34a42.TOP_RIGHT) return $d9a707ded6b61403$export$13807d9ee5a34a42.TOP;
    else if (position === $d9a707ded6b61403$export$13807d9ee5a34a42.BOTTOM || position === $d9a707ded6b61403$export$13807d9ee5a34a42.BOTTOM_LEFT || position === $d9a707ded6b61403$export$13807d9ee5a34a42.BOTTOM_RIGHT) return $d9a707ded6b61403$export$13807d9ee5a34a42.BOTTOM;
    else if (position === $d9a707ded6b61403$export$13807d9ee5a34a42.LEFT || position === $d9a707ded6b61403$export$13807d9ee5a34a42.LEFT_TOP || position === $d9a707ded6b61403$export$13807d9ee5a34a42.LEFT_BOTTOM) return $d9a707ded6b61403$export$13807d9ee5a34a42.LEFT;
    else return $d9a707ded6b61403$export$13807d9ee5a34a42.RIGHT;
}

});


parcelRegister("mqBXU", function(module, exports) {

$parcel$export(module.exports, "clickElementOnKeyPress", () => (parcelRequire("8zMLm")).clickElementOnKeyPress);
$parcel$export(module.exports, "elementIsOrContains", () => (parcelRequire("8zMLm")).elementIsOrContains);
$parcel$export(module.exports, "elementIsTextInput", () => (parcelRequire("8zMLm")).elementIsTextInput);
$parcel$export(module.exports, "getActiveElement", () => (parcelRequire("8zMLm")).getActiveElement);
$parcel$export(module.exports, "throttle", () => (parcelRequire("8zMLm")).throttle);
$parcel$export(module.exports, "throttleEvent", () => (parcelRequire("8zMLm")).throttleEvent);
$parcel$export(module.exports, "throttleReactEventCallback", () => (parcelRequire("8zMLm")).throttleReactEventCallback);
$parcel$export(module.exports, "isFunction", () => (parcelRequire("lh7kL")).isFunction);
$parcel$export(module.exports, "isArrowKey", () => (parcelRequire("ayhfh")).isArrowKey);
$parcel$export(module.exports, "isKeyboardClick", () => (parcelRequire("ayhfh")).isKeyboardClick);
$parcel$export(module.exports, "isDarkTheme", () => (parcelRequire("VjLgi")).isDarkTheme);
$parcel$export(module.exports, "setRef", () => (parcelRequire("a6c1q")).setRef);
$parcel$export(module.exports, "getRef", () => (parcelRequire("a6c1q")).getRef);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $av4mC = parcelRequire("av4mC");

var $8zMLm = parcelRequire("8zMLm");

var $lh7kL = parcelRequire("lh7kL");

var $3T4CC = parcelRequire("3T4CC");

var $6ROVj = parcelRequire("6ROVj");

var $ayhfh = parcelRequire("ayhfh");

var $VjLgi = parcelRequire("VjLgi");

var $a6c1q = parcelRequire("a6c1q");
$parcel$exportWildcard(module.exports, $av4mC);
$parcel$exportWildcard(module.exports, $3T4CC);
$parcel$exportWildcard(module.exports, $6ROVj);

});
parcelRegister("av4mC", function(module, exports) {

$parcel$export(module.exports, "arraysEqual", () => $7a502f2f8efe9fd0$export$234180f8206db11b);
$parcel$export(module.exports, "shallowCompareKeys", () => $7a502f2f8efe9fd0$export$d9dfaae715e1ab60);
$parcel$export(module.exports, "deepCompareKeys", () => $7a502f2f8efe9fd0$export$64d4bb231c0f132b);
$parcel$export(module.exports, "getDeepUnequalKeyValues", () => $7a502f2f8efe9fd0$export$685403fd77bd7c39);
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns true if the arrays are equal. Elements will be shallowly compared by
 * default, or they will be compared using the custom `compare` function if one
 * is provided.
 */ function $7a502f2f8efe9fd0$export$234180f8206db11b(arrA, arrB, compare) {
    if (compare === void 0) compare = function(a, b) {
        return a === b;
    };
    // treat `null` and `undefined` as the same
    if (arrA == null && arrB == null) return true;
    else if (arrA == null || arrB == null || arrA.length !== arrB.length) return false;
    else return arrA.every(function(a, i) {
        return compare(a, arrB[i]);
    });
}
function $7a502f2f8efe9fd0$export$d9dfaae715e1ab60(objA, objB, keys) {
    // treat `null` and `undefined` as the same
    if (objA == null && objB == null) return true;
    else if (objA == null || objB == null) return false;
    else if (Array.isArray(objA) || Array.isArray(objB)) return false;
    else if (keys != null) return $7a502f2f8efe9fd0$var$shallowCompareKeysImpl(objA, objB, keys);
    else {
        // shallowly compare all keys from both objects
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        return $7a502f2f8efe9fd0$var$shallowCompareKeysImpl(objA, objB, {
            include: keysA
        }) && $7a502f2f8efe9fd0$var$shallowCompareKeysImpl(objA, objB, {
            include: keysB
        });
    }
}
function $7a502f2f8efe9fd0$export$64d4bb231c0f132b(objA, objB, keys) {
    if (objA === objB) return true;
    else if (objA == null && objB == null) // treat `null` and `undefined` as the same
    return true;
    else if (objA == null || objB == null) return false;
    else if (Array.isArray(objA) || Array.isArray(objB)) return $7a502f2f8efe9fd0$export$234180f8206db11b(objA, objB, $7a502f2f8efe9fd0$export$64d4bb231c0f132b);
    else if ($7a502f2f8efe9fd0$var$isSimplePrimitiveType(objA) || $7a502f2f8efe9fd0$var$isSimplePrimitiveType(objB)) return objA === objB;
    else if (keys != null) return $7a502f2f8efe9fd0$var$deepCompareKeysImpl(objA, objB, keys);
    else if (objA.constructor !== objB.constructor) return false;
    else {
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        if (keysA == null || keysB == null) return false;
        if (keysA.length === 0 && keysB.length === 0) return true;
        return $7a502f2f8efe9fd0$export$234180f8206db11b(keysA, keysB) && $7a502f2f8efe9fd0$var$deepCompareKeysImpl(objA, objB, keysA);
    }
}
function $7a502f2f8efe9fd0$export$685403fd77bd7c39(objA, objB, keys) {
    if (objA === void 0) objA = {};
    if (objB === void 0) objB = {};
    var filteredKeys = keys == null ? $7a502f2f8efe9fd0$var$unionKeys(objA, objB) : keys;
    return $7a502f2f8efe9fd0$var$getUnequalKeyValues(objA, objB, filteredKeys, function(a, b, key) {
        return $7a502f2f8efe9fd0$export$64d4bb231c0f132b(a, b, [
            key
        ]);
    });
}
// Private helpers
// ===============
/**
 * Partial shallow comparison between objects using the given list of keys.
 */ function $7a502f2f8efe9fd0$var$shallowCompareKeysImpl(objA, objB, keys) {
    return $7a502f2f8efe9fd0$var$filterKeys(objA, objB, keys).every(function(key) {
        return objA.hasOwnProperty(key) === objB.hasOwnProperty(key) && objA[key] === objB[key];
    });
}
/**
 * Partial deep comparison between objects using the given list of keys.
 */ function $7a502f2f8efe9fd0$var$deepCompareKeysImpl(objA, objB, keys) {
    return keys.every(function(key) {
        return objA.hasOwnProperty(key) === objB.hasOwnProperty(key) && $7a502f2f8efe9fd0$export$64d4bb231c0f132b(objA[key], objB[key]);
    });
}
function $7a502f2f8efe9fd0$var$isSimplePrimitiveType(value) {
    return typeof value === "number" || typeof value === "string" || typeof value === "boolean";
}
function $7a502f2f8efe9fd0$var$filterKeys(objA, objB, keys) {
    if ($7a502f2f8efe9fd0$var$isAllowlist(keys)) return keys.include;
    else if ($7a502f2f8efe9fd0$var$isDenylist(keys)) {
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        // merge keys from both objects into a big set for quick access
        var keySet_1 = $7a502f2f8efe9fd0$var$arrayToObject(keysA.concat(keysB));
        // delete denied keys from the key set
        keys.exclude.forEach(function(key) {
            return delete keySet_1[key];
        });
        // return the remaining keys as an array
        return Object.keys(keySet_1);
    }
    return [];
}
function $7a502f2f8efe9fd0$var$isAllowlist(keys) {
    return keys != null && keys.include != null;
}
function $7a502f2f8efe9fd0$var$isDenylist(keys) {
    return keys != null && keys.exclude != null;
}
function $7a502f2f8efe9fd0$var$arrayToObject(arr) {
    return arr.reduce(function(obj, element) {
        obj[element] = true;
        return obj;
    }, {});
}
function $7a502f2f8efe9fd0$var$getUnequalKeyValues(objA, objB, keys, compareFn) {
    var unequalKeys = keys.filter(function(key) {
        return !compareFn(objA, objB, key);
    });
    var unequalKeyValues = unequalKeys.map(function(key) {
        return {
            key: key,
            valueA: objA[key],
            valueB: objB[key]
        };
    });
    return unequalKeyValues;
}
function $7a502f2f8efe9fd0$var$unionKeys(objA, objB) {
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    var concatKeys = keysA.concat(keysB);
    var keySet = $7a502f2f8efe9fd0$var$arrayToObject(concatKeys);
    return Object.keys(keySet);
}

});

parcelRegister("8zMLm", function(module, exports) {

$parcel$export(module.exports, "hasDOMEnvironment", () => $63e76ae31b1385d8$export$974c8c6d1fbc6154);
$parcel$export(module.exports, "elementIsOrContains", () => $63e76ae31b1385d8$export$3c0fcc112e8e7788);
$parcel$export(module.exports, "elementIsTextInput", () => $63e76ae31b1385d8$export$dea6a6e5494f51e0);
$parcel$export(module.exports, "getActiveElement", () => $63e76ae31b1385d8$export$cd4e5573fbe2b576);
$parcel$export(module.exports, "throttleEvent", () => $63e76ae31b1385d8$export$4897e46a283195b6);
$parcel$export(module.exports, "throttleReactEventCallback", () => $63e76ae31b1385d8$export$deef02b46be8a843);
$parcel$export(module.exports, "throttle", () => $63e76ae31b1385d8$export$de363e709c412c8a);
$parcel$export(module.exports, "clickElementOnKeyPress", () => $63e76ae31b1385d8$export$d429894ed4cff305);
/*
 * Copyright 2020 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");
function $63e76ae31b1385d8$export$974c8c6d1fbc6154() {
    return typeof window !== "undefined" && window.document != null;
}
function $63e76ae31b1385d8$export$3c0fcc112e8e7788(element, testElement) {
    return element === testElement || element.contains(testElement);
}
function $63e76ae31b1385d8$export$dea6a6e5494f51e0(elem) {
    // we check these cases for unit testing, but this should not happen
    // during normal operation
    if (elem == null || elem.closest == null) return false;
    var editable = elem.closest("input, textarea, [contenteditable=true]");
    if (editable == null) return false;
    // don't let checkboxes, switches, and radio buttons prevent hotkey behavior
    if (editable.tagName.toLowerCase() === "input") {
        var inputType = editable.type;
        if (inputType === "checkbox" || inputType === "radio") return false;
    }
    // don't let read-only fields prevent hotkey behavior
    if (editable.readOnly) return false;
    return true;
}
function $63e76ae31b1385d8$export$cd4e5573fbe2b576(element, options) {
    var _a;
    if (element == null) return document.activeElement;
    var rootNode = (_a = element.getRootNode(options)) !== null && _a !== void 0 ? _a : document;
    return rootNode.activeElement;
}
function $63e76ae31b1385d8$export$4897e46a283195b6(target, eventName, newEventName) {
    var throttledFunc = $63e76ae31b1385d8$var$throttleImpl(function(event) {
        target.dispatchEvent(new CustomEvent(newEventName, event));
    });
    target.addEventListener(eventName, throttledFunc);
    return throttledFunc;
}
function $63e76ae31b1385d8$export$deef02b46be8a843(callback, options) {
    if (options === void 0) options = {};
    var throttledFunc = $63e76ae31b1385d8$var$throttleImpl(callback, function(event2) {
        if (options.preventDefault) event2.preventDefault();
    }, // prevent React from reclaiming the event object before we reference it
    function(event2) {
        return event2.persist();
    });
    return throttledFunc;
}
function $63e76ae31b1385d8$export$de363e709c412c8a(method) {
    return $63e76ae31b1385d8$var$throttleImpl(method);
}
// eslint-disable-next-line @typescript-eslint/ban-types
function $63e76ae31b1385d8$var$throttleImpl(onAnimationFrameRequested, onBeforeIsRunningCheck, onAfterIsRunningCheck) {
    var isRunning = false;
    var func = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        onBeforeIsRunningCheck === null || onBeforeIsRunningCheck === void 0 || onBeforeIsRunningCheck.apply(void 0, args);
        if (isRunning) return;
        isRunning = true;
        onAfterIsRunningCheck === null || onAfterIsRunningCheck === void 0 || onAfterIsRunningCheck.apply(void 0, args);
        requestAnimationFrame(function() {
            onAnimationFrameRequested.apply(void 0, args);
            isRunning = false;
        });
    };
    return func;
}
function $63e76ae31b1385d8$export$d429894ed4cff305(keys) {
    return function(e) {
        if (keys.some(function(key) {
            return e.key === key;
        })) {
            // Prevent spacebar from scrolling the page unless we're in a text field
            if (!$63e76ae31b1385d8$export$dea6a6e5494f51e0(e.target)) e.preventDefault();
            e.target.dispatchEvent(new MouseEvent("click", (0, $gztBd.__assign)((0, $gztBd.__assign)({}, e), {
                view: undefined
            })));
        }
    };
}

});

parcelRegister("lh7kL", function(module, exports) {

$parcel$export(module.exports, "isFunction", () => $f7d0dfd7a7b67b92$export$f6e2535fb5126e54);
/*
 * Copyright 2020 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns whether the value is a function. Acts as a type guard. */ /* istanbul ignore next */ // eslint-disable-next-line @typescript-eslint/ban-types
function $f7d0dfd7a7b67b92$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}

});

parcelRegister("6ROVj", function(module, exports) {

$parcel$export(module.exports, "isReactNodeEmpty", () => $4fff31a4d739e975$export$5a81b62107752acd);
$parcel$export(module.exports, "isReactChildrenElementOrElements", () => $4fff31a4d739e975$export$1a5f9f98c90cf6a1);
$parcel$export(module.exports, "ensureElement", () => $4fff31a4d739e975$export$7210cc31459d553a);
$parcel$export(module.exports, "isReactElement", () => $4fff31a4d739e975$export$564ec7e3bcdb7847);
$parcel$export(module.exports, "isElementOfType", () => $4fff31a4d739e975$export$8bb8d43ade7732d8);
$parcel$export(module.exports, "isReact18", () => $4fff31a4d739e975$export$f4e52b20fe962eb2);
/*
 * Copyright 2020 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $8NFma = parcelRequire("8NFma");

var $3T4CC = parcelRequire("3T4CC");
function $4fff31a4d739e975$export$5a81b62107752acd(node, skipArray) {
    if (skipArray === void 0) skipArray = false;
    return node == null || node === "" || node === false || !skipArray && Array.isArray(node) && // only recurse one level through arrays, for performance
    (node.length === 0 || node.every(function(n) {
        return $4fff31a4d739e975$export$5a81b62107752acd(n, true);
    }));
}
function $4fff31a4d739e975$export$1a5f9f98c90cf6a1(children) {
    return !$4fff31a4d739e975$export$5a81b62107752acd(children, true) && children !== true;
}
function $4fff31a4d739e975$export$7210cc31459d553a(child, tagName, props) {
    if (tagName === void 0) tagName = "span";
    if (props === void 0) props = {};
    if (child == null || typeof child === "boolean" || (0, $3T4CC.isEmptyString)(child)) return undefined;
    else if (typeof child === "string" || typeof child === "number" || $4fff31a4d739e975$var$isReactFragment(child) || $4fff31a4d739e975$var$isReactNodeArray(child)) // wrap the child element
    return $8NFma.createElement(tagName, props, child);
    else if ($4fff31a4d739e975$export$564ec7e3bcdb7847(child)) {
        if (Object.keys(props).length > 0) // clone the element and merge props
        return $8NFma.cloneElement(child, props);
        else // nothing to do, it's a valid ReactElement
        return child;
    } else // child is inferred as {}
    return undefined;
}
function $4fff31a4d739e975$export$564ec7e3bcdb7847(child) {
    return typeof child === "object" && typeof child.type !== "undefined" && typeof child.props !== "undefined";
}
function $4fff31a4d739e975$var$isReactFragment(child) {
    // bit hacky, but generally works
    return typeof child.type === "symbol";
}
function $4fff31a4d739e975$var$isReactNodeArray(child) {
    return Array.isArray(child);
}
function $4fff31a4d739e975$export$8bb8d43ade7732d8(element, ComponentType) {
    return element != null && element.type != null && element.type.displayName != null && element.type.displayName === ComponentType.displayName;
}
function $4fff31a4d739e975$export$f4e52b20fe962eb2() {
    return $8NFma.version.startsWith("18");
}

});

parcelRegister("ayhfh", function(module, exports) {

$parcel$export(module.exports, "isKeyboardClick", () => $7aea74f5a43d6791$export$746ace428e2a5877);
$parcel$export(module.exports, "isArrowKey", () => $7aea74f5a43d6791$export$a0d3f776048184d0);
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns whether the keyboard event was triggered by Enter or Space, the two keys that are expected to trigger
 * interactive elements like buttons.
 */ function $7aea74f5a43d6791$export$746ace428e2a5877(event) {
    return event.key === "Enter" || event.key === " ";
}
function $7aea74f5a43d6791$export$a0d3f776048184d0(event) {
    return [
        "ArrowUp",
        "ArrowDown",
        "ArrowLeft",
        "ArrowRight"
    ].indexOf(event.key) >= 0;
}

});

parcelRegister("VjLgi", function(module, exports) {

$parcel$export(module.exports, "isDarkTheme", () => $0ac4a72a8bbae477$export$5a63ccfbe4d87ef0);
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $4Aw5U = parcelRequire("4Aw5U");
function $0ac4a72a8bbae477$export$5a63ccfbe4d87ef0(element) {
    return element != null && element instanceof Element && element.closest(".".concat($4Aw5U.DARK)) != null;
}

});

parcelRegister("a6c1q", function(module, exports) {

$parcel$export(module.exports, "setRef", () => $75a3ca42d002539f$export$4bb192c7cacf928f);
$parcel$export(module.exports, "mergeRefs", () => $75a3ca42d002539f$export$c9058316764c140e);
$parcel$export(module.exports, "getRef", () => $75a3ca42d002539f$export$f0c653cfd7dea798);
$parcel$export(module.exports, "refHandler", () => $75a3ca42d002539f$export$e9e0d2af9a57b401);
/*
 * Copyright 2020 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $75a3ca42d002539f$export$dedd81df7bc1307(value) {
    return value != null && typeof value !== "function";
}
function $75a3ca42d002539f$export$76025ed275866d92(value) {
    return typeof value === "function";
}
function $75a3ca42d002539f$export$4bb192c7cacf928f(refTarget, ref) {
    if ($75a3ca42d002539f$export$dedd81df7bc1307(refTarget)) // HACKHACK: .current property is readonly
    refTarget.current = ref;
    else if ($75a3ca42d002539f$export$76025ed275866d92(refTarget)) refTarget(ref);
}
function $75a3ca42d002539f$export$c9058316764c140e() {
    var refs = [];
    for(var _i = 0; _i < arguments.length; _i++)refs[_i] = arguments[_i];
    return function(value) {
        refs.forEach(function(ref) {
            $75a3ca42d002539f$export$4bb192c7cacf928f(ref, value);
        });
    };
}
function $75a3ca42d002539f$export$f0c653cfd7dea798(ref) {
    if (ref === null) return null;
    if (typeof ref.current === "undefined") return ref;
    return ref.current;
}
function $75a3ca42d002539f$export$e9e0d2af9a57b401(refTargetParent, refTargetKey, refProp) {
    return function(ref) {
        refTargetParent[refTargetKey] = ref;
        $75a3ca42d002539f$export$4bb192c7cacf928f(refProp, ref);
    };
}

});


parcelRegister("3lvnD", function(module, exports) {

$parcel$export(module.exports, "DISPLAYNAME_PREFIX", () => $26fbacb7721fbb65$export$64b684a1d3f6f6a6);
$parcel$export(module.exports, "removeNonHTMLProps", () => $26fbacb7721fbb65$export$962dd23b3e663274);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");
var $26fbacb7721fbb65$export$64b684a1d3f6f6a6 = "Blueprint5";
/** A collection of curated prop keys used across our Components which are not valid HTMLElement props. */ var $26fbacb7721fbb65$var$INVALID_PROPS = [
    "active",
    "alignText",
    "asyncControl",
    "containerRef",
    "current",
    "elementRef",
    "ellipsizeText",
    "fill",
    "icon",
    "iconSize",
    "inputClassName",
    "inputRef",
    "intent",
    "inline",
    "large",
    "loading",
    "leftElement",
    "leftIcon",
    "minimal",
    "onRemove",
    "outlined",
    "panel",
    "panelClassName",
    "popoverProps",
    "rightElement",
    "rightIcon",
    "round",
    "size",
    "small",
    "tagName",
    "text",
    "textClassName"
];
function $26fbacb7721fbb65$export$962dd23b3e663274(props, invalidProps, shouldMerge) {
    if (invalidProps === void 0) invalidProps = $26fbacb7721fbb65$var$INVALID_PROPS;
    if (shouldMerge === void 0) shouldMerge = false;
    if (shouldMerge) invalidProps = invalidProps.concat($26fbacb7721fbb65$var$INVALID_PROPS);
    return invalidProps.reduce(function(prev, curr) {
        // Props with hyphens (e.g. data-*) are always considered html props
        if (curr.indexOf("-") !== -1) return prev;
        if (prev.hasOwnProperty(curr)) delete prev[curr];
        return prev;
    }, (0, $gztBd.__assign)({}, props));
}

});

parcelRegister("8YRmi", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $689d5137550e1af5$export$f04a61298a47a40f);
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $eMPTp = parcelRequire("eMPTp");
var $leH9B = parcelRequire("leH9B");
var $eog74 = parcelRequire("eog74");

var $4Aw5U = parcelRequire("4Aw5U");
var $3lvnD = parcelRequire("3lvnD");
var $689d5137550e1af5$export$f04a61298a47a40f = $8NFma.forwardRef(function(props, ref) {
    var _a, _b;
    var autoLoad = props.autoLoad, className = props.className, color = props.color, icon = props.icon, intent = props.intent, tagName = props.tagName, svgProps = props.svgProps, title = props.title, htmlTitle = props.htmlTitle, htmlProps = (0, $gztBd.__rest)(props, [
        "autoLoad",
        "className",
        "color",
        "icon",
        "intent",
        "tagName",
        "svgProps",
        "title",
        "htmlTitle"
    ]);
    // Preserve Blueprint v4.x behavior: iconSize prop takes predecence, then size prop, then fall back to default value
    // eslint-disable-next-line deprecation/deprecation
    var size = (_b = (_a = props.iconSize) !== null && _a !== void 0 ? _a : props.size) !== null && _b !== void 0 ? _b : (0, $leH9B.IconSize).STANDARD;
    var _c = $8NFma.useState(function() {
        return typeof icon === "string" ? (0, $eMPTp.Icons).getPaths(icon, size) : undefined;
    }), iconPaths = _c[0], setIconPaths = _c[1];
    $8NFma.useEffect(function() {
        var shouldCancelIconLoading = false;
        if (typeof icon === "string") {
            // The icon may have been loaded already, in which case we can simply grab it.
            // N.B. when `autoLoad={true}`, we can't rely on simply calling Icons.load() here to re-load an icon module
            // which has already been loaded & cached, since it may have been loaded with special loading options which
            // this component knows nothing about.
            var loadedIconPaths = (0, $eMPTp.Icons).getPaths(icon, size);
            if (loadedIconPaths !== undefined) setIconPaths(loadedIconPaths);
            else if (autoLoad) (0, $eMPTp.Icons).load(icon, size).then(function() {
                // if this effect expired by the time icon loaded, then don't set state
                if (!shouldCancelIconLoading) setIconPaths((0, $eMPTp.Icons).getPaths(icon, size));
            }).catch(function(reason) {
                console.error("[Blueprint] Icon '".concat(icon, "' (").concat(size, "px) could not be loaded."), reason);
            });
            else console.error("[Blueprint] Icon '".concat(icon, "' (").concat(size, "px) is not loaded yet and autoLoad={false}, did you call Icons.load('").concat(icon, "', ").concat(size, ")?"));
        }
        return function() {
            shouldCancelIconLoading = true;
        };
    }, [
        autoLoad,
        icon,
        size
    ]);
    if (icon == null || typeof icon === "boolean") return null;
    else if (typeof icon !== "string") return icon;
    if (iconPaths == null) {
        // fall back to icon font if unloaded or unable to load SVG implementation
        var sizeClass = size === (0, $leH9B.IconSize).STANDARD ? (0, $4Aw5U).ICON_STANDARD : size === (0, $leH9B.IconSize).LARGE ? (0, $4Aw5U).ICON_LARGE : undefined;
        return $8NFma.createElement(tagName, (0, $gztBd.__assign)((0, $gztBd.__assign)({
            "aria-hidden": title ? undefined : true
        }, (0, $3lvnD.removeNonHTMLProps)(htmlProps)), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $4Aw5U).ICON, sizeClass, (0, $4Aw5U).iconClass(icon), (0, $4Aw5U).intentClass(intent), className),
            "data-icon": icon,
            ref: ref,
            title: htmlTitle
        }));
    } else {
        var pathElements = iconPaths.map(function(d, i) {
            return $8NFma.createElement("path", {
                d: d,
                key: i,
                fillRule: "evenodd"
            });
        });
        // HACKHACK: there is no good way to narrow the type of SVGIconContainerProps here because of the use
        // of a conditional type within the type union that defines that interface. So we cast to <any>.
        // see https://github.com/microsoft/TypeScript/issues/24929, https://github.com/microsoft/TypeScript/issues/33014
        return $8NFma.createElement((0, $eog74.SVGIconContainer), (0, $gztBd.__assign)({
            children: pathElements,
            // don't forward `Classes.ICON` or `Classes.iconClass(icon)` here, since the container will render those classes
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $4Aw5U).intentClass(intent), className),
            color: color,
            htmlTitle: htmlTitle,
            iconName: icon,
            ref: ref,
            size: size,
            svgProps: svgProps,
            tagName: tagName,
            title: title
        }, (0, $3lvnD.removeNonHTMLProps)(htmlProps)));
    }
});
$689d5137550e1af5$export$f04a61298a47a40f.defaultProps = {
    autoLoad: true,
    tagName: "span"
};
$689d5137550e1af5$export$f04a61298a47a40f.displayName = "".concat((0, $3lvnD.DISPLAYNAME_PREFIX), ".Icon");

});

parcelRegister("1kPos", function(module, exports) {

$parcel$export(module.exports, "SpinnerSize", () => $0f8f865ab42c4bb1$export$11e6017846e949);
$parcel$export(module.exports, "Spinner", () => $0f8f865ab42c4bb1$export$7f7cbe89f1eacd2);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $88643 = parcelRequire("88643");
var $4Aw5U = parcelRequire("4Aw5U");

var $yL8qz = parcelRequire("yL8qz");

var $3lvnD = parcelRequire("3lvnD");

var $3T4CC = parcelRequire("3T4CC");
var $0f8f865ab42c4bb1$export$11e6017846e949;
(function(SpinnerSize) {
    SpinnerSize[SpinnerSize["SMALL"] = 20] = "SMALL";
    SpinnerSize[SpinnerSize["STANDARD"] = 50] = "STANDARD";
    SpinnerSize[SpinnerSize["LARGE"] = 100] = "LARGE";
})($0f8f865ab42c4bb1$export$11e6017846e949 || ($0f8f865ab42c4bb1$export$11e6017846e949 = {}));
// see http://stackoverflow.com/a/18473154/3124288 for calculating arc path
var $0f8f865ab42c4bb1$var$R = 45;
var $0f8f865ab42c4bb1$var$SPINNER_TRACK = "M 50,50 m 0,-".concat($0f8f865ab42c4bb1$var$R, " a ").concat($0f8f865ab42c4bb1$var$R, ",").concat($0f8f865ab42c4bb1$var$R, " 0 1 1 0,").concat($0f8f865ab42c4bb1$var$R * 2, " a ").concat($0f8f865ab42c4bb1$var$R, ",").concat($0f8f865ab42c4bb1$var$R, " 0 1 1 0,-").concat($0f8f865ab42c4bb1$var$R * 2);
// unitless total length of SVG path, to which stroke-dash* properties are relative.
// https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/pathLength
// this value is the result of `<path d={SPINNER_TRACK} />.getTotalLength()` and works in all browsers:
var $0f8f865ab42c4bb1$var$PATH_LENGTH = 280;
var $0f8f865ab42c4bb1$var$MIN_SIZE = 10;
var $0f8f865ab42c4bb1$var$STROKE_WIDTH = 4;
var $0f8f865ab42c4bb1$var$MIN_STROKE_WIDTH = 16;
/**
 * Spinner component.
 *
 * @see https://blueprintjs.com/docs/#core/components/spinner
 */ var $0f8f865ab42c4bb1$export$7f7cbe89f1eacd2 = /** @class */ function(_super) {
    (0, $gztBd.__extends)(Spinner, _super);
    function Spinner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Spinner.prototype.componentDidUpdate = function(prevProps) {
        if (prevProps.value !== this.props.value) // IE/Edge: re-render after changing value to force SVG update
        this.forceUpdate();
    };
    Spinner.prototype.render = function() {
        var _a;
        var _b = this.props, className = _b.className, intent = _b.intent, value = _b.value, _c = _b.tagName, tagName = _c === void 0 ? "div" : _c, htmlProps = (0, $gztBd.__rest)(_b, [
            "className",
            "intent",
            "value",
            "tagName"
        ]);
        var size = this.getSize();
        var classes = (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $4Aw5U).SPINNER, (0, $4Aw5U).intentClass(intent), (_a = {}, _a[(0, $4Aw5U).SPINNER_NO_SPIN] = value != null, _a), className);
        // keep spinner track width consistent at all sizes (down to about 10px).
        var strokeWidth = Math.min($0f8f865ab42c4bb1$var$MIN_STROKE_WIDTH, $0f8f865ab42c4bb1$var$STROKE_WIDTH * $0f8f865ab42c4bb1$export$11e6017846e949.LARGE / size);
        var strokeOffset = $0f8f865ab42c4bb1$var$PATH_LENGTH - $0f8f865ab42c4bb1$var$PATH_LENGTH * (value == null ? 0.25 : (0, $3T4CC.clamp)(value, 0, 1));
        // multiple DOM elements around SVG are necessary to properly isolate animation:
        // - SVG elements in IE do not support anim/trans so they must be set on a parent HTML element.
        // - SPINNER_ANIMATION isolates svg from parent display and is always centered inside root element.
        return $8NFma.createElement(tagName, (0, $gztBd.__assign)({
            "aria-label": "loading",
            "aria-valuemax": 100,
            "aria-valuemin": 0,
            "aria-valuenow": value === undefined ? undefined : value * 100,
            className: classes,
            role: "progressbar"
        }, htmlProps), $8NFma.createElement(tagName, {
            className: (0, $4Aw5U).SPINNER_ANIMATION
        }, $8NFma.createElement("svg", {
            width: size,
            height: size,
            strokeWidth: strokeWidth.toFixed(2),
            viewBox: this.getViewBox(strokeWidth)
        }, $8NFma.createElement("path", {
            className: (0, $4Aw5U).SPINNER_TRACK,
            d: $0f8f865ab42c4bb1$var$SPINNER_TRACK
        }), $8NFma.createElement("path", {
            className: (0, $4Aw5U).SPINNER_HEAD,
            d: $0f8f865ab42c4bb1$var$SPINNER_TRACK,
            pathLength: $0f8f865ab42c4bb1$var$PATH_LENGTH,
            strokeDasharray: "".concat($0f8f865ab42c4bb1$var$PATH_LENGTH, " ").concat($0f8f865ab42c4bb1$var$PATH_LENGTH),
            strokeDashoffset: strokeOffset
        }))));
    };
    Spinner.prototype.validateProps = function(_a) {
        var _b = _a.className, className = _b === void 0 ? "" : _b, size = _a.size;
        if (size != null && (className.indexOf((0, $4Aw5U).SMALL) >= 0 || className.indexOf((0, $4Aw5U).LARGE) >= 0)) console.warn((0, $yL8qz.SPINNER_WARN_CLASSES_SIZE));
    };
    /**
     * Resolve size to a pixel value.
     * Size can be set by className, props, default, or minimum constant.
     */ Spinner.prototype.getSize = function() {
        var _a = this.props, _b = _a.className, className = _b === void 0 ? "" : _b, size = _a.size;
        if (size == null) {
            // allow Classes constants to determine default size.
            if (className.indexOf((0, $4Aw5U).SMALL) >= 0) return $0f8f865ab42c4bb1$export$11e6017846e949.SMALL;
            else if (className.indexOf((0, $4Aw5U).LARGE) >= 0) return $0f8f865ab42c4bb1$export$11e6017846e949.LARGE;
            return $0f8f865ab42c4bb1$export$11e6017846e949.STANDARD;
        }
        return Math.max($0f8f865ab42c4bb1$var$MIN_SIZE, size);
    };
    /** Compute viewbox such that stroked track sits exactly at edge of image frame. */ Spinner.prototype.getViewBox = function(strokeWidth) {
        var radius = $0f8f865ab42c4bb1$var$R + strokeWidth / 2;
        var viewBoxX = (50 - radius).toFixed(2);
        var viewBoxWidth = (radius * 2).toFixed(2);
        return "".concat(viewBoxX, " ").concat(viewBoxX, " ").concat(viewBoxWidth, " ").concat(viewBoxWidth);
    };
    Spinner.displayName = "".concat((0, $3lvnD.DISPLAYNAME_PREFIX), ".Spinner");
    return Spinner;
}((0, $88643.AbstractPureComponent));

});

parcelRegister("ghE22", function(module, exports) {

$parcel$export(module.exports, "Text", () => $bdad495de98492bf$export$5f1af8db9871e1d6);
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $4Aw5U = parcelRequire("4Aw5U");
var $a6c1q = parcelRequire("a6c1q");

var $3lvnD = parcelRequire("3lvnD");

var $7RAoo = parcelRequire("7RAoo");
var $bdad495de98492bf$export$5f1af8db9871e1d6 = $8NFma.forwardRef(function(_a, forwardedRef) {
    var _b;
    var children = _a.children, _c = _a.tagName, tagName = _c === void 0 ? "div" : _c, title = _a.title, className = _a.className, ellipsize = _a.ellipsize, htmlProps = (0, $gztBd.__rest)(_a, [
        "children",
        "tagName",
        "title",
        "className",
        "ellipsize"
    ]);
    var contentMeasuringRef = $8NFma.useRef();
    var textRef = $8NFma.useMemo(function() {
        return (0, $a6c1q.mergeRefs)(contentMeasuringRef, forwardedRef);
    }, [
        forwardedRef
    ]);
    var _d = $8NFma.useState(""), textContent = _d[0], setTextContent = _d[1];
    var _e = $8NFma.useState(), isContentOverflowing = _e[0], setIsContentOverflowing = _e[1];
    // try to be conservative about running this effect, since querying scrollWidth causes the browser to reflow / recalculate styles,
    // which can be very expensive for long lists (for example, in long Menus)
    (0, $7RAoo.useIsomorphicLayoutEffect)(function() {
        var _a;
        if (((_a = contentMeasuringRef.current) === null || _a === void 0 ? void 0 : _a.textContent) != null) {
            setIsContentOverflowing(ellipsize && contentMeasuringRef.current.scrollWidth > contentMeasuringRef.current.clientWidth);
            setTextContent(contentMeasuringRef.current.textContent);
        }
    }, [
        contentMeasuringRef,
        children,
        ellipsize
    ]);
    return $8NFma.createElement(tagName, (0, $gztBd.__assign)((0, $gztBd.__assign)({}, htmlProps), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((_b = {}, _b[(0, $4Aw5U).TEXT_OVERFLOW_ELLIPSIS] = ellipsize, _b), className),
        ref: textRef,
        title: title !== null && title !== void 0 ? title : isContentOverflowing ? textContent : undefined
    }), children);
});
$bdad495de98492bf$export$5f1af8db9871e1d6.defaultProps = {
    ellipsize: false
};
$bdad495de98492bf$export$5f1af8db9871e1d6.displayName = "".concat((0, $3lvnD.DISPLAYNAME_PREFIX), ".Text");

});
parcelRegister("7RAoo", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $5b99b665014cfdea$export$700979bc83e7db82);
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $8NFma = parcelRequire("8NFma");

var $8zMLm = parcelRequire("8zMLm");
var $5b99b665014cfdea$export$700979bc83e7db82 = (0, $8zMLm.hasDOMEnvironment)() ? $8NFma.useLayoutEffect : $8NFma.useEffect;

});



parcelRegister("6PbAi", function(module, exports) {

$parcel$export(module.exports, "InputGroup", () => $4f807de6f84de163$export$6e5a9cd40e0c9b97);
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $88643 = parcelRequire("88643");
var $4Aw5U = parcelRequire("4Aw5U");

var $yL8qz = parcelRequire("yL8qz");

var $3lvnD = parcelRequire("3lvnD");

var $8YRmi = parcelRequire("8YRmi");

var $7GByF = parcelRequire("7GByF");
var $4f807de6f84de163$var$NON_HTML_PROPS = [
    "onValueChange"
];
/**
 * Input group component.
 *
 * @see https://blueprintjs.com/docs/#core/components/input-group
 */ var $4f807de6f84de163$export$6e5a9cd40e0c9b97 = /** @class */ function(_super) {
    (0, $gztBd.__extends)(InputGroup, _super);
    function InputGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.leftElement = null;
        _this.rightElement = null;
        _this.refHandlers = {
            leftElement: function(ref) {
                return _this.leftElement = ref;
            },
            rightElement: function(ref) {
                return _this.rightElement = ref;
            }
        };
        _this.handleInputChange = function(event) {
            var _a, _b, _c, _d;
            var value = event.target.value;
            (_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, event);
            (_d = (_c = _this.props).onValueChange) === null || _d === void 0 || _d.call(_c, value, event.target);
        };
        return _this;
    }
    InputGroup.prototype.render = function() {
        var _a;
        var _b = this.props, _c = _b.asyncControl, asyncControl = _c === void 0 ? false : _c, className = _b.className, disabled = _b.disabled, fill = _b.fill, inputClassName = _b.inputClassName, inputRef = _b.inputRef, intent = _b.intent, large = _b.large, readOnly = _b.readOnly, round = _b.round, small = _b.small, _d = _b.tagName, tagName = _d === void 0 ? "div" : _d;
        var inputGroupClasses = (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $4Aw5U).INPUT_GROUP, (0, $4Aw5U).intentClass(intent), (_a = {}, _a[(0, $4Aw5U).DISABLED] = disabled, _a[(0, $4Aw5U).READ_ONLY] = readOnly, _a[(0, $4Aw5U).FILL] = fill, _a[(0, $4Aw5U).LARGE] = large, _a[(0, $4Aw5U).SMALL] = small, _a[(0, $4Aw5U).ROUND] = round, _a), className);
        var style = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, this.props.style), {
            paddingLeft: this.state.leftElementWidth,
            paddingRight: this.state.rightElementWidth
        });
        var inputProps = (0, $gztBd.__assign)((0, $gztBd.__assign)({
            type: "text"
        }, (0, $3lvnD.removeNonHTMLProps)(this.props, $4f807de6f84de163$var$NON_HTML_PROPS, true)), {
            "aria-disabled": disabled,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $4Aw5U).INPUT, inputClassName),
            onChange: this.handleInputChange,
            style: style
        });
        var inputElement = asyncControl ? $8NFma.createElement((0, $7GByF.AsyncControllableInput), (0, $gztBd.__assign)({}, inputProps, {
            inputRef: inputRef
        })) : $8NFma.createElement("input", (0, $gztBd.__assign)({}, inputProps, {
            ref: inputRef
        }));
        return $8NFma.createElement(tagName, {
            className: inputGroupClasses
        }, this.maybeRenderLeftElement(), inputElement, this.maybeRenderRightElement());
    };
    InputGroup.prototype.componentDidMount = function() {
        this.updateInputWidth();
    };
    InputGroup.prototype.componentDidUpdate = function(prevProps) {
        var _a = this.props, leftElement = _a.leftElement, rightElement = _a.rightElement;
        if (prevProps.leftElement !== leftElement || prevProps.rightElement !== rightElement) this.updateInputWidth();
    };
    InputGroup.prototype.validateProps = function(props) {
        if (props.leftElement != null && props.leftIcon != null) console.warn($yL8qz.INPUT_WARN_LEFT_ELEMENT_LEFT_ICON_MUTEX);
    };
    InputGroup.prototype.maybeRenderLeftElement = function() {
        var _a = this.props, leftElement = _a.leftElement, leftIcon = _a.leftIcon;
        if (leftElement != null) return $8NFma.createElement("span", {
            className: (0, $4Aw5U).INPUT_LEFT_CONTAINER,
            ref: this.refHandlers.leftElement
        }, leftElement);
        else if (leftIcon != null) return $8NFma.createElement((0, $8YRmi.Icon), {
            icon: leftIcon,
            "aria-hidden": true,
            tabIndex: -1
        });
        return undefined;
    };
    InputGroup.prototype.maybeRenderRightElement = function() {
        var rightElement = this.props.rightElement;
        if (rightElement == null) return undefined;
        return $8NFma.createElement("span", {
            className: (0, $4Aw5U).INPUT_ACTION,
            ref: this.refHandlers.rightElement
        }, rightElement);
    };
    InputGroup.prototype.updateInputWidth = function() {
        var _a = this.state, leftElementWidth = _a.leftElementWidth, rightElementWidth = _a.rightElementWidth;
        if (this.leftElement != null) {
            var clientWidth = this.leftElement.clientWidth;
            // small threshold to prevent infinite loops
            if (leftElementWidth === undefined || Math.abs(clientWidth - leftElementWidth) > 2) this.setState({
                leftElementWidth: clientWidth
            });
        } else this.setState({
            leftElementWidth: undefined
        });
        if (this.rightElement != null) {
            var clientWidth = this.rightElement.clientWidth;
            // small threshold to prevent infinite loops
            if (rightElementWidth === undefined || Math.abs(clientWidth - rightElementWidth) > 2) this.setState({
                rightElementWidth: clientWidth
            });
        } else this.setState({
            rightElementWidth: undefined
        });
    };
    InputGroup.displayName = "".concat((0, $3lvnD.DISPLAYNAME_PREFIX), ".InputGroup");
    return InputGroup;
}((0, $88643.AbstractPureComponent));

});
parcelRegister("7GByF", function(module, exports) {

$parcel$export(module.exports, "AsyncControllableInput", () => $598996ef68240895$export$bc10c55cb47bf894);
/* !
 * Copyright 2020 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $8NFma = parcelRequire("8NFma");

var $88643 = parcelRequire("88643");
var $3lvnD = parcelRequire("3lvnD");
/**
 * A stateful wrapper around the low-level <input> component which works around a
 * [React bug](https://github.com/facebook/react/issues/3926). This bug is reproduced when an input
 * receives CompositionEvents (for example, through IME composition) and has its value prop updated
 * asychronously. This might happen if a component chooses to do async validation of a value
 * returned by the input's `onChange` callback.
 *
 * Note: this component does not apply any Blueprint-specific styling.
 */ var $598996ef68240895$export$bc10c55cb47bf894 = /** @class */ function(_super) {
    (0, $gztBd.__extends)(AsyncControllableInput, _super);
    function AsyncControllableInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hasPendingUpdate: false,
            isComposing: false,
            nextValue: _this.props.value,
            value: _this.props.value
        };
        _this.cancelPendingCompositionEnd = null;
        _this.handleCompositionStart = function(e) {
            var _a, _b, _c;
            (_a = _this.cancelPendingCompositionEnd) === null || _a === void 0 || _a.call(_this);
            _this.setState({
                isComposing: true
            });
            (_c = (_b = _this.props).onCompositionStart) === null || _c === void 0 || _c.call(_b, e);
        };
        _this.handleCompositionEnd = function(e) {
            var _a, _b;
            // In some non-latin languages, a keystroke can end a composition event and immediately afterwards start another.
            // This can lead to unexpected characters showing up in the text input. In order to circumvent this problem, we
            // use a timeout which creates a delay which merges the two composition events, creating a more natural and predictable UX.
            // `this.state.nextValue` will become "locked" (it cannot be overwritten by the `value` prop) until a delay (10ms) has
            // passed without a new composition event starting.
            _this.cancelPendingCompositionEnd = _this.setTimeout(function() {
                return _this.setState({
                    isComposing: false
                });
            }, AsyncControllableInput.COMPOSITION_END_DELAY);
            (_b = (_a = _this.props).onCompositionEnd) === null || _b === void 0 || _b.call(_a, e);
        };
        _this.handleChange = function(e) {
            var _a, _b;
            var value = e.target.value;
            _this.setState({
                nextValue: value
            });
            (_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, e);
        };
        return _this;
    }
    AsyncControllableInput.getDerivedStateFromProps = function(nextProps, nextState) {
        if (nextState.isComposing || nextProps.value === undefined) // don't derive anything from props if:
        // - in uncontrolled mode, OR
        // - currently composing, since we'll do that after composition ends
        return null;
        var userTriggeredUpdate = nextState.nextValue !== nextState.value;
        if (userTriggeredUpdate) {
            if (nextProps.value === nextState.nextValue) {
                // parent has processed and accepted our update
                if (nextState.hasPendingUpdate) return {
                    value: nextProps.value,
                    hasPendingUpdate: false
                };
                else return {
                    value: nextState.nextValue
                };
            } else {
                if (nextProps.value === nextState.value) // we have sent the update to our parent, but it has not been processed yet. just wait.
                // DO NOT set nextValue here, since that will temporarily render a potentially stale controlled value,
                // causing the cursor to jump once the new value is accepted
                return {
                    hasPendingUpdate: true
                };
                // accept controlled update overriding user action
                return {
                    value: nextProps.value,
                    nextValue: nextProps.value,
                    hasPendingUpdate: false
                };
            }
        } else // accept controlled update, could be confirming or denying user action
        return {
            value: nextProps.value,
            nextValue: nextProps.value,
            hasPendingUpdate: false
        };
    };
    AsyncControllableInput.prototype.render = function() {
        var _a = this.state, isComposing = _a.isComposing, hasPendingUpdate = _a.hasPendingUpdate, value = _a.value, nextValue = _a.nextValue;
        var _b = this.props, inputRef = _b.inputRef, restProps = (0, $gztBd.__rest)(_b, [
            "inputRef"
        ]);
        return $8NFma.createElement("input", (0, $gztBd.__assign)({}, restProps, {
            ref: inputRef,
            // render the pending value even if it is not confirmed by a parent's async controlled update
            // so that the cursor does not jump to the end of input as reported in
            // https://github.com/palantir/blueprint/issues/4298
            value: isComposing || hasPendingUpdate ? nextValue : value,
            onCompositionStart: this.handleCompositionStart,
            onCompositionEnd: this.handleCompositionEnd,
            onChange: this.handleChange
        }));
    };
    AsyncControllableInput.displayName = "".concat((0, $3lvnD.DISPLAYNAME_PREFIX), ".AsyncControllableInput");
    /**
     * The amount of time (in milliseconds) which the input will wait after a compositionEnd event before
     * unlocking its state value for external updates via props. See `handleCompositionEnd` for more details.
     */ AsyncControllableInput.COMPOSITION_END_DELAY = 10;
    return AsyncControllableInput;
}((0, $88643.AbstractPureComponent));

});


parcelRegister("8Ntcp", function(module, exports) {

$parcel$export(module.exports, "Popover", () => $66798caafa0c5e06$export$5b6b19405a83ff9d);
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $17ExX = parcelRequire("17ExX");
var $aDCM4 = parcelRequire("aDCM4");
var $cgdjq = parcelRequire("cgdjq");

var $88643 = parcelRequire("88643");
var $4Aw5U = parcelRequire("4Aw5U");
var $3lvnD = parcelRequire("3lvnD");
var $a6c1q = parcelRequire("a6c1q");
var $mqBXU = parcelRequire("mqBXU");

var $yL8qz = parcelRequire("yL8qz");

var $4UEz6 = parcelRequire("4UEz6");

var $52TTV = parcelRequire("52TTV");

var $8R4ZP = parcelRequire("8R4ZP");

var $iPiJm = parcelRequire("iPiJm");

var $jxVrF = parcelRequire("jxVrF");

var $cjYAu = parcelRequire("cjYAu");

var $fgHs1 = parcelRequire("fgHs1");
var $66798caafa0c5e06$export$6c571fbf65f9c7a6 = {
    CLICK: "click",
    CLICK_TARGET_ONLY: "click-target",
    HOVER: "hover",
    HOVER_TARGET_ONLY: "hover-target"
};
/**
 * Popover component, used to display a floating UI next to and tethered to a target element.
 *
 * @template T target element props interface. Consumers wishing to stay in sync with Blueprint's default target HTML
 * props interface should use the `DefaultPopoverTargetHTMLProps` type (although this is already the default type for
 * this type param).
 * @see https://blueprintjs.com/docs/#core/components/popover
 */ var $66798caafa0c5e06$export$5b6b19405a83ff9d = /** @class */ function(_super) {
    (0, $gztBd.__extends)(Popover, _super);
    function Popover() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hasDarkParent: false,
            isClosingViaEscapeKeypress: false,
            isOpen: _this.getIsOpen(_this.props)
        };
        /**
         * DOM element that contains the popover.
         * When `usePortal={true}`, this element will be portaled outside the usual DOM flow,
         * so this reference can be very useful for testing.
         *
         * @public for testing
         */ _this.popoverElement = null;
        /** Popover ref handler */ _this.popoverRef = (0, $a6c1q.refHandler)(_this, "popoverElement", _this.props.popoverRef);
        /**
         * Target DOM element ref.
         *
         * N.B. this must be a ref object since we pass it to `<ResizeSensor>`, which needs to know about the target
         * DOM element in order to observe its dimensions.
         *
         * @public for testing
         */ _this.targetRef = $8NFma.createRef();
        /**
         * Overlay2 transition container element ref.
         */ _this.transitionContainerElement = $8NFma.createRef();
        // a flag that lets us detect mouse movement between the target and popover,
        // now that mouseleave is triggered when you cross the gap between the two.
        _this.isMouseInTargetOrPopover = false;
        // a flag that indicates whether the target previously lost focus to another
        // element on the same page.
        _this.lostFocusOnSamePage = true;
        _this.isControlled = function() {
            return _this.props.isOpen !== undefined;
        };
        // arrow is disabled if minimal, or if the arrow modifier was explicitly disabled
        _this.isArrowEnabled = function() {
            var _a, _b;
            return !_this.props.minimal && ((_b = (_a = _this.props.modifiers) === null || _a === void 0 ? void 0 : _a.arrow) === null || _b === void 0 ? void 0 : _b.enabled) !== false;
        };
        _this.isHoverInteractionKind = function() {
            return _this.props.interactionKind === $66798caafa0c5e06$export$6c571fbf65f9c7a6.HOVER || _this.props.interactionKind === $66798caafa0c5e06$export$6c571fbf65f9c7a6.HOVER_TARGET_ONLY;
        };
        /**
         * Instance method to instruct the `Popover` to recompute its position.
         *
         * This method should only be used if you are updating the target in a way
         * that does not cause it to re-render, such as changing its _position_
         * without changing its _size_ (since `Popover` already repositions when it
         * detects a resize).
         */ _this.reposition = function() {
            var _a;
            return (_a = _this.popperScheduleUpdate) === null || _a === void 0 ? void 0 : _a.call(_this);
        };
        _this.renderTarget = function(_a) {
            var _b, _c;
            var _d, _e;
            var popperChildRef = _a.ref;
            var _f = _this.props, children = _f.children, className = _f.className, fill = _f.fill, openOnTargetFocus = _f.openOnTargetFocus, renderTarget = _f.renderTarget;
            var isOpen = _this.state.isOpen;
            var isControlled = _this.isControlled();
            var isHoverInteractionKind = _this.isHoverInteractionKind();
            var targetTagName = _this.props.targetTagName;
            if (fill) targetTagName = "div";
            // N.B. react-popper has a wide type for this ref, but we can narrow it based on the source,
            // see https://github.com/floating-ui/react-popper/blob/beac280d61082852c4efc302be902911ce2d424c/src/Reference.js#L17
            var ref = (0, $a6c1q.mergeRefs)(popperChildRef, _this.targetRef);
            var targetEventHandlers = isHoverInteractionKind ? {
                // HOVER handlers
                onBlur: _this.handleTargetBlur,
                onContextMenu: _this.handleTargetContextMenu,
                onFocus: _this.handleTargetFocus,
                onMouseEnter: _this.handleMouseEnter,
                onMouseLeave: _this.handleMouseLeave
            } : {
                // CLICK needs only one handler
                onClick: _this.handleTargetClick,
                // For keyboard accessibility, trigger the same behavior as a click event upon pressing ENTER/SPACE
                onKeyDown: _this.handleKeyDown
            };
            // Ensure target is focusable if relevant prop enabled
            var targetTabIndex = openOnTargetFocus && isHoverInteractionKind ? 0 : undefined;
            var ownTargetProps = (0, $gztBd.__assign)({
                // N.B. this.props.className is passed along to renderTarget even though the user would have access to it.
                // If, instead, renderTarget is undefined and the target is provided as a child, this.props.className is
                // applied to the generated target wrapper element.
                className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(className, (0, $4Aw5U).POPOVER_TARGET, (_b = {}, _b[(0, $4Aw5U).POPOVER_OPEN] = isOpen, // this class is mainly useful for button targets
                _b[(0, $4Aw5U).ACTIVE] = isOpen && !isControlled && !isHoverInteractionKind, _b)),
                ref: ref
            }, targetEventHandlers);
            var childTargetProps = {
                "aria-expanded": isOpen,
                "aria-haspopup": _this.props.interactionKind === $66798caafa0c5e06$export$6c571fbf65f9c7a6.HOVER_TARGET_ONLY ? undefined : (_d = _this.props.popupKind) !== null && _d !== void 0 ? _d : "menu"
            };
            var targetModifierClasses = (_c = {}, // this class is mainly useful for Blueprint <Button> targets; we should only apply it for
            // uncontrolled popovers when they are opened by a user interaction
            _c[(0, $4Aw5U).ACTIVE] = isOpen && !isControlled && !isHoverInteractionKind, // similarly, this class is mainly useful for targets like <Button>, <InputGroup>, etc.
            _c[(0, $4Aw5U).FILL] = fill, _c);
            var target;
            if (renderTarget !== undefined) target = renderTarget((0, $gztBd.__assign)((0, $gztBd.__assign)((0, $gztBd.__assign)({}, ownTargetProps), childTargetProps), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(ownTargetProps.className, targetModifierClasses),
                // if the consumer renders a tooltip target, it's their responsibility to disable that tooltip
                // when *this* popover is open
                isOpen: isOpen,
                tabIndex: targetTabIndex
            }));
            else {
                var childTarget = (0, $mqBXU).ensureElement($8NFma.Children.toArray(children)[0]);
                if (childTarget === undefined) return null;
                var clonedTarget = $8NFma.cloneElement(childTarget, (0, $gztBd.__assign)((0, $gztBd.__assign)({}, childTargetProps), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(childTarget.props.className, targetModifierClasses),
                    // force disable single Tooltip child when popover is open
                    disabled: isOpen && (0, $mqBXU).isElementOfType(childTarget, (0, $8R4ZP.Tooltip)) ? true : childTarget.props.disabled,
                    tabIndex: (_e = childTarget.props.tabIndex) !== null && _e !== void 0 ? _e : targetTabIndex
                }));
                var wrappedTarget = $8NFma.createElement(targetTagName, (0, $gztBd.__assign)((0, $gztBd.__assign)({}, ownTargetProps), _this.props.targetProps), clonedTarget);
                target = wrappedTarget;
            }
            // No need to use the merged `ref` here, that only needs to be forwarded to the child node so that React can
            // notify both popper.js and our components about the mounted DOM element.
            return $8NFma.createElement((0, $52TTV.ResizeSensor), {
                targetRef: _this.targetRef,
                onResize: _this.reposition
            }, target);
        };
        _this.renderPopover = function(popperProps) {
            var _a;
            var _b = _this.props, autoFocus = _b.autoFocus, enforceFocus = _b.enforceFocus, backdropProps = _b.backdropProps, canEscapeKeyClose = _b.canEscapeKeyClose, hasBackdrop = _b.hasBackdrop, interactionKind = _b.interactionKind, usePortal = _b.usePortal;
            var _c = _this.state, isClosingViaEscapeKeypress = _c.isClosingViaEscapeKeypress, isOpen = _c.isOpen;
            // compute an appropriate transform origin so the scale animation points towards target
            var transformOrigin = (0, $fgHs1.getTransformOrigin)(popperProps.placement, _this.isArrowEnabled() ? popperProps.arrowProps.style : undefined);
            // need to update our reference to this function on every render as it will change.
            _this.popperScheduleUpdate = popperProps.update;
            var popoverHandlers = {
                // always check popover clicks for dismiss class
                onClick: _this.handlePopoverClick,
                // treat ENTER/SPACE keys the same as a click for accessibility
                onKeyDown: function(event) {
                    return (0, $mqBXU).isKeyboardClick(event) && _this.handlePopoverClick(event);
                }
            };
            if (interactionKind === $66798caafa0c5e06$export$6c571fbf65f9c7a6.HOVER || !usePortal && interactionKind === $66798caafa0c5e06$export$6c571fbf65f9c7a6.HOVER_TARGET_ONLY) {
                popoverHandlers.onMouseEnter = _this.handleMouseEnter;
                popoverHandlers.onMouseLeave = _this.handleMouseLeave;
            }
            var basePlacement = (0, $fgHs1.getBasePlacement)(popperProps.placement);
            var popoverClasses = (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $4Aw5U).POPOVER, (_a = {}, _a[(0, $4Aw5U).DARK] = _this.props.inheritDarkTheme && _this.state.hasDarkParent, _a[(0, $4Aw5U).MINIMAL] = _this.props.minimal, _a[(0, $4Aw5U).POPOVER_CAPTURING_DISMISS] = _this.props.captureDismiss, _a[(0, $4Aw5U).POPOVER_MATCH_TARGET_WIDTH] = _this.props.matchTargetWidth, _a[(0, $4Aw5U).POPOVER_REFERENCE_HIDDEN] = popperProps.isReferenceHidden === true, _a[(0, $4Aw5U).POPOVER_POPPER_ESCAPED] = popperProps.hasPopperEscaped === true, _a), "".concat((0, $4Aw5U).POPOVER_CONTENT_PLACEMENT, "-").concat(basePlacement), _this.props.popoverClassName);
            var defaultAutoFocus = _this.isHoverInteractionKind() ? false : undefined;
            // if hover interaction, it doesn't make sense to take over focus control
            var shouldReturnFocusOnClose = _this.isHoverInteractionKind() ? false : isClosingViaEscapeKeypress ? true : _this.props.shouldReturnFocusOnClose;
            return $8NFma.createElement((0, $4UEz6.Overlay2), {
                autoFocus: autoFocus !== null && autoFocus !== void 0 ? autoFocus : defaultAutoFocus,
                backdropClassName: (0, $4Aw5U).POPOVER_BACKDROP,
                backdropProps: backdropProps,
                canEscapeKeyClose: canEscapeKeyClose,
                canOutsideClickClose: interactionKind === $66798caafa0c5e06$export$6c571fbf65f9c7a6.CLICK,
                childRef: _this.transitionContainerElement,
                enforceFocus: enforceFocus,
                hasBackdrop: hasBackdrop,
                isOpen: isOpen,
                lazy: _this.props.lazy,
                onClose: _this.handleOverlayClose,
                onClosed: _this.props.onClosed,
                onClosing: _this.props.onClosing,
                onOpened: _this.props.onOpened,
                onOpening: _this.props.onOpening,
                transitionDuration: _this.props.transitionDuration,
                transitionName: (0, $4Aw5U).POPOVER,
                usePortal: usePortal,
                portalClassName: _this.props.portalClassName,
                portalContainer: _this.props.portalContainer,
                // eslint-disable-next-line deprecation/deprecation
                portalStopPropagationEvents: _this.props.portalStopPropagationEvents,
                shouldReturnFocusOnClose: shouldReturnFocusOnClose
            }, $8NFma.createElement("div", {
                className: (0, $4Aw5U).POPOVER_TRANSITION_CONTAINER,
                // We need to attach a ref that notifies both react-popper and our Popover component about the DOM
                // element inside the Overlay2. We cannot re-use `PopperChildrenProps.ref` because Overlay2 only
                // accepts a ref object (not a callback) due to a CSSTransition API limitation.
                // N.B. react-popper has a wide type for this ref, but we can narrow it based on the source,
                // see https://github.com/floating-ui/react-popper/blob/beac280d61082852c4efc302be902911ce2d424c/src/Popper.js#L94
                ref: (0, $a6c1q.mergeRefs)(popperProps.ref, _this.transitionContainerElement),
                style: popperProps.style
            }, $8NFma.createElement((0, $52TTV.ResizeSensor), {
                onResize: _this.reposition
            }, $8NFma.createElement("div", (0, $gztBd.__assign)({
                className: popoverClasses,
                style: {
                    transformOrigin: transformOrigin
                },
                ref: _this.popoverRef
            }, popoverHandlers), _this.isArrowEnabled() && $8NFma.createElement((0, $jxVrF.PopoverArrow), {
                arrowProps: popperProps.arrowProps,
                placement: popperProps.placement
            }), $8NFma.createElement("div", {
                className: (0, $4Aw5U).POPOVER_CONTENT
            }, _this.props.content)))));
        };
        _this.handleTargetFocus = function(e) {
            if (_this.props.openOnTargetFocus && _this.isHoverInteractionKind()) {
                if (e.relatedTarget == null && !_this.lostFocusOnSamePage) // ignore this focus event -- the target was already focused but the page itself
                // lost focus (e.g. due to switching tabs).
                return;
                _this.handleMouseEnter(e);
            }
        };
        _this.handleTargetBlur = function(e) {
            if (_this.props.openOnTargetFocus && _this.isHoverInteractionKind()) {
                if (e.relatedTarget != null) // if the next element to receive focus is within the popover, we'll want to leave the
                // popover open.
                {
                    if (e.relatedTarget !== _this.popoverElement && !_this.isElementInPopover(e.relatedTarget)) _this.handleMouseLeave(e);
                } else _this.handleMouseLeave(e);
            }
            _this.lostFocusOnSamePage = e.relatedTarget != null;
        };
        _this.handleTargetContextMenu = function(e) {
            // we assume that when someone prevents the default interaction on this event (a browser native context menu),
            // they are showing a custom context menu (as ContextMenu2 does); in this case, we should close this popover/tooltip
            if (e.defaultPrevented) _this.setOpenState(false, e);
        };
        _this.handleMouseEnter = function(e) {
            _this.isMouseInTargetOrPopover = true;
            // if we're entering the popover, and the mode is set to be HOVER_TARGET_ONLY, we want to manually
            // trigger the mouse leave event, as hovering over the popover shouldn't count.
            if (!_this.props.usePortal && _this.isElementInPopover(e.target) && _this.props.interactionKind === $66798caafa0c5e06$export$6c571fbf65f9c7a6.HOVER_TARGET_ONLY && !_this.props.openOnTargetFocus) _this.handleMouseLeave(e);
            else if (!_this.props.disabled) // only begin opening popover when it is enabled
            _this.setOpenState(true, e, _this.props.hoverOpenDelay);
        };
        _this.handleMouseLeave = function(e) {
            _this.isMouseInTargetOrPopover = false;
            // Wait until the event queue is flushed, because we want to leave the
            // popover open if the mouse entered the popover immediately after
            // leaving the target (or vice versa). Make sure to persist the event since
            // we need to access `nativeEvent` in `this.setOpenState()`.
            e.persist();
            _this.setTimeout(function() {
                if (_this.isMouseInTargetOrPopover) return;
                // user-configurable closing delay is helpful when moving mouse from target to popover
                _this.setOpenState(false, e, _this.props.hoverCloseDelay);
            });
        };
        _this.handlePopoverClick = function(e) {
            var _a, _b, _c;
            var eventTarget = e.target;
            var eventPopover = eventTarget.closest(".".concat((0, $4Aw5U).POPOVER));
            var eventPopoverV1 = eventTarget.closest(".".concat((0, $4Aw5U).POPOVER));
            var isEventFromSelf = (eventPopover !== null && eventPopover !== void 0 ? eventPopover : eventPopoverV1) === _this.getPopoverElement();
            var isEventPopoverCapturing = (_b = (_a = eventPopover === null || eventPopover === void 0 ? void 0 : eventPopover.classList.contains((0, $4Aw5U).POPOVER_CAPTURING_DISMISS)) !== null && _a !== void 0 ? _a : eventPopoverV1 === null || eventPopoverV1 === void 0 ? void 0 : eventPopoverV1.classList.contains((0, $4Aw5U).POPOVER_CAPTURING_DISMISS)) !== null && _b !== void 0 ? _b : false;
            // an OVERRIDE inside a DISMISS does not dismiss, and a DISMISS inside an OVERRIDE will dismiss.
            var dismissElement = eventTarget.closest(".".concat((0, $4Aw5U).POPOVER_DISMISS, ", .").concat((0, $4Aw5U).POPOVER_DISMISS_OVERRIDE));
            var shouldDismiss = (_c = dismissElement === null || dismissElement === void 0 ? void 0 : dismissElement.classList.contains((0, $4Aw5U).POPOVER_DISMISS)) !== null && _c !== void 0 ? _c : false;
            var isDisabled = eventTarget.closest(":disabled, .".concat((0, $4Aw5U).DISABLED)) != null;
            if (shouldDismiss && !isDisabled && (!isEventPopoverCapturing || isEventFromSelf)) _this.setOpenState(false, e);
        };
        _this.handleOverlayClose = function(e) {
            var _a;
            if (_this.targetRef.current == null || e === undefined) return;
            var event = (_a = e.nativeEvent) !== null && _a !== void 0 ? _a : e;
            var eventTarget = event.composed ? event.composedPath()[0] : event.target;
            // if click was in target, target event listener will handle things, so don't close
            if (!(0, $mqBXU).elementIsOrContains(_this.targetRef.current, eventTarget) || e.nativeEvent instanceof KeyboardEvent) _this.setOpenState(false, e);
        };
        _this.handleKeyDown = function(e) {
            var isKeyboardClick = (0, $mqBXU).isKeyboardClick(e);
            // For keyboard accessibility, trigger the same behavior as a click event upon pressing ENTER/SPACE
            if (isKeyboardClick) _this.handleTargetClick(e);
        };
        _this.handleTargetClick = function(e) {
            // Target element(s) may fire simulated click event upon pressing ENTER/SPACE, which we should ignore
            // see: https://github.com/palantir/blueprint/issues/5775
            var shouldIgnoreClick = _this.state.isOpen && _this.isSimulatedButtonClick(e);
            if (!shouldIgnoreClick) // ensure click did not originate from within inline popover before closing
            {
                if (!_this.props.disabled && !_this.isElementInPopover(e.target)) {
                    if (_this.props.isOpen == null) _this.setState(function(prevState) {
                        return {
                            isOpen: !prevState.isOpen
                        };
                    });
                    else _this.setOpenState(!_this.props.isOpen, e);
                }
            }
        };
        _this.isSimulatedButtonClick = function(e) {
            return !e.isTrusted && e.target.matches(".".concat((0, $4Aw5U).BUTTON));
        };
        return _this;
    }
    // popper innerRef gives us a handle on the transition container, since that's what we render as the overlay child,
    // so if we want to look at our actual popover element, we need to reach inside a bit
    Popover.prototype.getPopoverElement = function() {
        var _a;
        return (_a = this.popoverElement) === null || _a === void 0 ? void 0 : _a.querySelector(".".concat((0, $4Aw5U).POPOVER));
    };
    Popover.prototype.getIsOpen = function(props) {
        var _a;
        // disabled popovers should never be allowed to open.
        if (props.disabled) return false;
        else return (_a = props.isOpen) !== null && _a !== void 0 ? _a : props.defaultIsOpen;
    };
    Popover.prototype.render = function() {
        var _a = this.props, disabled = _a.disabled, content = _a.content, placement = _a.placement, _b = _a.position, position = _b === void 0 ? "auto" : _b, positioningStrategy = _a.positioningStrategy;
        var isOpen = this.state.isOpen;
        var isContentEmpty = content == null || typeof content === "string" && content.trim() === "";
        if (isContentEmpty) {
            // need to do this check in render(), because `isOpen` is derived from
            // state, and state can't necessarily be accessed in validateProps.
            if (!disabled && isOpen !== false && !(0, $mqBXU).isNodeEnv("production")) console.warn($yL8qz.POPOVER_WARN_EMPTY_CONTENT);
            // just render the target without a content overlay if there is no content to display
            return this.renderTarget({
                ref: $66798caafa0c5e06$var$noop
            });
        }
        // Important: do not use <Reference innerRef> since it has a bug when used in React 18 strict mode
        // see https://github.com/floating-ui/react-popper/pull/459
        return $8NFma.createElement((0, $17ExX.Manager), null, $8NFma.createElement((0, $cgdjq.Reference), null, this.renderTarget), $8NFma.createElement((0, $aDCM4.Popper), {
            innerRef: this.popoverRef,
            placement: placement !== null && placement !== void 0 ? placement : (0, $cjYAu.positionToPlacement)(position),
            strategy: positioningStrategy,
            modifiers: this.getPopperModifiers()
        }, this.renderPopover));
    };
    Popover.prototype.componentDidMount = function() {
        this.updateDarkParent();
    };
    Popover.prototype.componentDidUpdate = function(props, state) {
        _super.prototype.componentDidUpdate.call(this, props, state);
        this.updateDarkParent();
        var nextIsOpen = this.getIsOpen(this.props);
        if (this.props.isOpen != null && nextIsOpen !== this.state.isOpen) {
            this.setOpenState(nextIsOpen);
            // tricky: setOpenState calls setState only if this.props.isOpen is
            // not controlled, so we need to invoke setState manually here.
            this.setState({
                isOpen: nextIsOpen
            });
        } else if (this.props.disabled && this.state.isOpen && this.props.isOpen == null) // special case: close an uncontrolled popover when disabled is set to true
        this.setOpenState(false);
    };
    Popover.prototype.validateProps = function(props) {
        if (props.isOpen == null && props.onInteraction != null) console.warn($yL8qz.POPOVER_WARN_UNCONTROLLED_ONINTERACTION);
        if (props.hasBackdrop && !props.usePortal) console.warn($yL8qz.POPOVER_WARN_HAS_BACKDROP_INLINE);
        if (props.hasBackdrop && props.interactionKind !== $66798caafa0c5e06$export$6c571fbf65f9c7a6.CLICK) console.warn($yL8qz.POPOVER_HAS_BACKDROP_INTERACTION);
        if (props.placement !== undefined && props.position !== undefined) console.warn($yL8qz.POPOVER_WARN_PLACEMENT_AND_POSITION_MUTEX);
        var childrenCount = $8NFma.Children.count(props.children);
        var hasRenderTargetProp = props.renderTarget !== undefined;
        var hasTargetPropsProp = props.targetProps !== undefined;
        if (childrenCount === 0 && !hasRenderTargetProp) console.warn($yL8qz.POPOVER_REQUIRES_TARGET);
        if (childrenCount > 1) console.warn($yL8qz.POPOVER_WARN_TOO_MANY_CHILDREN);
        if (childrenCount > 0 && hasRenderTargetProp) console.warn($yL8qz.POPOVER_WARN_DOUBLE_TARGET);
        if (hasRenderTargetProp && hasTargetPropsProp) console.warn($yL8qz.POPOVER_WARN_TARGET_PROPS_WITH_RENDER_TARGET);
    };
    Popover.prototype.getPopperModifiers = function() {
        var _a, _b, _c, _d;
        var _e = this.props, matchTargetWidth = _e.matchTargetWidth, modifiers = _e.modifiers, modifiersCustom = _e.modifiersCustom;
        var popperModifiers = [
            (0, $gztBd.__assign)({
                enabled: this.isArrowEnabled(),
                name: "arrow"
            }, modifiers === null || modifiers === void 0 ? void 0 : modifiers.arrow),
            (0, $gztBd.__assign)((0, $gztBd.__assign)({
                name: "computeStyles"
            }, modifiers === null || modifiers === void 0 ? void 0 : modifiers.computeStyles), {
                options: (0, $gztBd.__assign)({
                    adaptive: true,
                    // We disable the built-in gpuAcceleration so that
                    // Popper.js will return us easy to interpolate values
                    // (top, left instead of transform: translate3d)
                    // We'll then use these values to generate the needed
                    // css transform values blended with the react-spring values
                    gpuAcceleration: false
                }, (_a = modifiers === null || modifiers === void 0 ? void 0 : modifiers.computeStyles) === null || _a === void 0 ? void 0 : _a.options)
            }),
            (0, $gztBd.__assign)((0, $gztBd.__assign)({
                enabled: this.isArrowEnabled(),
                name: "offset"
            }, modifiers === null || modifiers === void 0 ? void 0 : modifiers.offset), {
                options: (0, $gztBd.__assign)({
                    offset: [
                        0,
                        (0, $jxVrF.POPOVER_ARROW_SVG_SIZE) / 2
                    ]
                }, (_b = modifiers === null || modifiers === void 0 ? void 0 : modifiers.offset) === null || _b === void 0 ? void 0 : _b.options)
            }),
            (0, $gztBd.__assign)((0, $gztBd.__assign)({
                name: "flip"
            }, modifiers === null || modifiers === void 0 ? void 0 : modifiers.flip), {
                options: (0, $gztBd.__assign)({
                    boundary: this.props.boundary,
                    rootBoundary: this.props.rootBoundary
                }, (_c = modifiers === null || modifiers === void 0 ? void 0 : modifiers.flip) === null || _c === void 0 ? void 0 : _c.options)
            }),
            (0, $gztBd.__assign)((0, $gztBd.__assign)({
                name: "preventOverflow"
            }, modifiers === null || modifiers === void 0 ? void 0 : modifiers.preventOverflow), {
                options: (0, $gztBd.__assign)({
                    boundary: this.props.boundary,
                    rootBoundary: this.props.rootBoundary
                }, (_d = modifiers === null || modifiers === void 0 ? void 0 : modifiers.preventOverflow) === null || _d === void 0 ? void 0 : _d.options)
            })
        ];
        if (matchTargetWidth) popperModifiers.push((0, $iPiJm.matchReferenceWidthModifier));
        if (modifiersCustom !== undefined) popperModifiers.push.apply(popperModifiers, modifiersCustom);
        return popperModifiers;
    };
    // a wrapper around setState({ isOpen }) that will call props.onInteraction instead when in controlled mode.
    // starts a timeout to delay changing the state if a non-zero duration is provided.
    Popover.prototype.setOpenState = function(isOpen, e, timeout) {
        var _this = this;
        var _a, _b, _c, _d, _e;
        // cancel any existing timeout because we have new state
        (_a = this.cancelOpenTimeout) === null || _a === void 0 || _a.call(this);
        if (timeout !== undefined && timeout > 0) {
            // Persist the react event since it will be used in a later macrotask.
            e === null || e === void 0 || e.persist();
            this.cancelOpenTimeout = this.setTimeout(function() {
                _this.setOpenState(isOpen, e);
            }, timeout);
        } else {
            if (this.props.isOpen == null) this.setState({
                isOpen: isOpen
            });
            else (_c = (_b = this.props).onInteraction) === null || _c === void 0 || _c.call(_b, isOpen, e);
            if (!isOpen) {
                // non-null assertion because the only time `e` is undefined is when in controlled mode
                // or the rare special case in uncontrolled mode when the `disabled` flag is toggled true
                (_e = (_d = this.props).onClose) === null || _e === void 0 || _e.call(_d, e);
                this.setState({
                    isClosingViaEscapeKeypress: $66798caafa0c5e06$var$isEscapeKeypressEvent(e === null || e === void 0 ? void 0 : e.nativeEvent)
                });
            }
        }
    };
    Popover.prototype.updateDarkParent = function() {
        var _a;
        if (this.props.usePortal && this.state.isOpen) {
            var hasDarkParent = ((_a = this.targetRef.current) === null || _a === void 0 ? void 0 : _a.closest(".".concat((0, $4Aw5U).DARK))) != null;
            this.setState({
                hasDarkParent: hasDarkParent
            });
        }
    };
    Popover.prototype.isElementInPopover = function(element) {
        var _a, _b;
        return (_b = (_a = this.getPopoverElement()) === null || _a === void 0 ? void 0 : _a.contains(element)) !== null && _b !== void 0 ? _b : false;
    };
    Popover.displayName = "".concat((0, $3lvnD.DISPLAYNAME_PREFIX), ".Popover");
    Popover.defaultProps = {
        boundary: "clippingParents",
        captureDismiss: false,
        defaultIsOpen: false,
        disabled: false,
        fill: false,
        hasBackdrop: false,
        hoverCloseDelay: 300,
        hoverOpenDelay: 150,
        inheritDarkTheme: true,
        interactionKind: $66798caafa0c5e06$export$6c571fbf65f9c7a6.CLICK,
        matchTargetWidth: false,
        minimal: false,
        openOnTargetFocus: true,
        // N.B. we don't set a default for `placement` or `position` here because that would trigger
        // a warning in validateProps if the other prop is specified by a user of this component
        positioningStrategy: "absolute",
        renderTarget: undefined,
        shouldReturnFocusOnClose: false,
        targetTagName: "span",
        transitionDuration: 300,
        usePortal: true
    };
    return Popover;
}((0, $88643.AbstractPureComponent));
function $66798caafa0c5e06$var$isEscapeKeypressEvent(e) {
    return e instanceof KeyboardEvent && e.key === "Escape";
}
function $66798caafa0c5e06$var$noop() {
// no-op
}

});
parcelRegister("4UEz6", function(module, exports) {

$parcel$export(module.exports, "Overlay2", () => $393bdbce39ee64a8$export$2e8e2c61dfd53893);
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $4OXLD = parcelRequire("4OXLD");
var $gbRGj = parcelRequire("gbRGj");

var $ieuVO = parcelRequire("ieuVO");

var $4Aw5U = parcelRequire("4Aw5U");
var $a6c1q = parcelRequire("a6c1q");

var $yL8qz = parcelRequire("yL8qz");

var $3lvnD = parcelRequire("3lvnD");

var $6ROVj = parcelRequire("6ROVj");
var $8zMLm = parcelRequire("8zMLm");
var $a6c1q = parcelRequire("a6c1q");
var $3T4CC = parcelRequire("3T4CC");

var $8zMLm = parcelRequire("8zMLm");

var $gl4hP = parcelRequire("gl4hP");

var $11SU3 = parcelRequire("11SU3");

var $8o6Ut = parcelRequire("8o6Ut");

var $ftEZI = parcelRequire("ftEZI");
var $393bdbce39ee64a8$export$2e8e2c61dfd53893 = $8NFma.forwardRef(function(props, forwardedRef) {
    var _a;
    var _b, _c;
    var autoFocus = props.autoFocus, backdropClassName = props.backdropClassName, backdropProps = props.backdropProps, canEscapeKeyClose = props.canEscapeKeyClose, canOutsideClickClose = props.canOutsideClickClose, childRef = props.childRef, childRefs = props.childRefs, children = props.children, className = props.className, enforceFocus = props.enforceFocus, hasBackdrop = props.hasBackdrop, isOpen = props.isOpen, lazy = props.lazy, onClose = props.onClose, onClosed = props.onClosed, onClosing = props.onClosing, onOpened = props.onOpened, onOpening = props.onOpening, portalClassName = props.portalClassName, portalContainer = props.portalContainer, shouldReturnFocusOnClose = props.shouldReturnFocusOnClose, transitionDuration = props.transitionDuration, transitionName = props.transitionName, usePortal = props.usePortal;
    $393bdbce39ee64a8$var$useOverlay2Validation(props);
    var _d = (0, $gl4hP.useOverlayStack)(), closeOverlay = _d.closeOverlay, getLastOpened = _d.getLastOpened, getThisOverlayAndDescendants = _d.getThisOverlayAndDescendants, openOverlay = _d.openOverlay;
    var _e = $8NFma.useState(false), isAutoFocusing = _e[0], setIsAutoFocusing = _e[1];
    var _f = $8NFma.useState(false), hasEverOpened = _f[0], setHasEverOpened = _f[1];
    var lastActiveElementBeforeOpened = $8NFma.useRef(null);
    /** Ref for container element, containing all children and the backdrop */ var containerElement = $8NFma.useRef(null);
    /** Ref for backdrop element */ var backdropElement = $8NFma.useRef(null);
    /* An empty, keyboard-focusable div at the beginning of the Overlay content */ var startFocusTrapElement = $8NFma.useRef(null);
    /* An empty, keyboard-focusable div at the end of the Overlay content */ var endFocusTrapElement = $8NFma.useRef(null);
    /**
     * Locally-generated DOM ref for a singleton child element.
     * This is only used iff the user does not specify the `childRef` or `childRefs` props.
     */ var localChildRef = $8NFma.useRef(null);
    var bringFocusInsideOverlay = $8NFma.useCallback(function() {
        // always delay focus manipulation to just before repaint to prevent scroll jumping
        return requestAnimationFrame(function() {
            var _a;
            // container element may be undefined between component mounting and Portal rendering
            // activeElement may be undefined in some rare cases in IE
            var container = (0, $a6c1q.getRef)(containerElement);
            var activeElement = (0, $8zMLm.getActiveElement)(container);
            if (container == null || activeElement == null) return;
            // Overlay2 is guaranteed to be mounted here
            var isFocusOutsideModal = !container.contains(activeElement);
            if (isFocusOutsideModal) {
                (_a = (0, $a6c1q.getRef)(startFocusTrapElement)) === null || _a === void 0 || _a.focus({
                    preventScroll: true
                });
                setIsAutoFocusing(false);
            }
        });
    }, []);
    /** Unique ID for this overlay in the global stack */ var id = $393bdbce39ee64a8$var$useOverlay2ID();
    // N.B. use `null` here and not simply `undefined` because `useImperativeHandle` will set `null` on unmount,
    // and we need the following code to be resilient to that value.
    var instance = $8NFma.useRef(null);
    /**
     * When multiple `enforceFocus` Overlays are open, this event handler is only active for the most
     * recently opened one to avoid Overlays competing with each other for focus.
     */ var handleDocumentFocus = $8NFma.useCallback(function(e) {
        // get the actual target even in the Shadow DOM
        // see https://github.com/palantir/blueprint/issues/4220
        var eventTarget = e.composed ? e.composedPath()[0] : e.target;
        var container = (0, $a6c1q.getRef)(containerElement);
        if (container != null && eventTarget instanceof Node && !container.contains(eventTarget)) {
            // prevent default focus behavior (sometimes auto-scrolls the page)
            e.preventDefault();
            e.stopImmediatePropagation();
            bringFocusInsideOverlay();
        }
    }, [
        bringFocusInsideOverlay
    ]);
    // N.B. this listener is only kept attached when `isOpen={true}` and `canOutsideClickClose={true}`
    var handleDocumentMousedown = $8NFma.useCallback(function(e) {
        // get the actual target even in the Shadow DOM
        // see https://github.com/palantir/blueprint/issues/4220
        var eventTarget = e.composed ? e.composedPath()[0] : e.target;
        var thisOverlayAndDescendants = getThisOverlayAndDescendants(id);
        var isClickInThisOverlayOrDescendant = thisOverlayAndDescendants.some(function(_a) {
            var containerRef = _a.containerElement;
            // `elem` is the container of backdrop & content, so clicking directly on that container
            // should not count as being "inside" the overlay.
            var elem = (0, $a6c1q.getRef)(containerRef);
            return (elem === null || elem === void 0 ? void 0 : elem.contains(eventTarget)) && !elem.isSameNode(eventTarget);
        });
        if (!isClickInThisOverlayOrDescendant) // casting to any because this is a native event
        onClose === null || onClose === void 0 || onClose(e);
    }, [
        getThisOverlayAndDescendants,
        id,
        onClose
    ]);
    // Important: clean up old document-level event listeners if their memoized values change (this is rare, but
    // may happen, for example, if a user forgets to use `React.useCallback` in the `props.onClose` value).
    // Otherwise, we will lose the reference to those values and create a memory leak since we won't be able
    // to successfully detach them inside overlayWillClose.
    $8NFma.useEffect(function() {
        document.removeEventListener("mousedown", handleDocumentMousedown);
    }, [
        handleDocumentMousedown
    ]);
    $8NFma.useEffect(function() {
        document.removeEventListener("focus", handleDocumentFocus, /* useCapture */ true);
    }, [
        handleDocumentFocus
    ]);
    // send this instance's imperative handle to the the forwarded ref as well as our local ref
    var ref = $8NFma.useMemo(function() {
        return (0, $a6c1q.mergeRefs)(forwardedRef, instance);
    }, [
        forwardedRef
    ]);
    $8NFma.useImperativeHandle(ref, function() {
        return {
            bringFocusInsideOverlay: bringFocusInsideOverlay,
            containerElement: containerElement,
            handleDocumentFocus: handleDocumentFocus,
            handleDocumentMousedown: handleDocumentMousedown,
            id: id,
            props: {
                autoFocus: autoFocus,
                enforceFocus: enforceFocus,
                hasBackdrop: hasBackdrop,
                usePortal: usePortal
            }
        };
    }, [
        autoFocus,
        bringFocusInsideOverlay,
        enforceFocus,
        handleDocumentFocus,
        handleDocumentMousedown,
        hasBackdrop,
        id,
        usePortal
    ]);
    var handleContainerKeyDown = $8NFma.useCallback(function(e) {
        if (e.key === "Escape" && canEscapeKeyClose) {
            onClose === null || onClose === void 0 || onClose(e);
            // prevent other overlays from closing
            e.stopPropagation();
            // prevent browser-specific escape key behavior (Safari exits fullscreen)
            e.preventDefault();
        }
    }, [
        canEscapeKeyClose,
        onClose
    ]);
    var overlayWillOpen = $8NFma.useCallback(function() {
        if (instance.current == null) return;
        var lastOpenedOverlay = getLastOpened();
        if ((lastOpenedOverlay === null || lastOpenedOverlay === void 0 ? void 0 : lastOpenedOverlay.handleDocumentFocus) !== undefined) document.removeEventListener("focus", lastOpenedOverlay.handleDocumentFocus, /* useCapture */ true);
        openOverlay(instance.current);
        if (autoFocus) {
            setIsAutoFocusing(true);
            bringFocusInsideOverlay();
        }
        if (enforceFocus) // Focus events do not bubble, but setting useCapture allows us to listen in and execute
        // our handler before all others
        document.addEventListener("focus", handleDocumentFocus, /* useCapture */ true);
        if (canOutsideClickClose && !hasBackdrop) document.addEventListener("mousedown", handleDocumentMousedown);
        (0, $a6c1q.setRef)(lastActiveElementBeforeOpened, (0, $8zMLm.getActiveElement)((0, $a6c1q.getRef)(containerElement)));
    }, [
        autoFocus,
        bringFocusInsideOverlay,
        canOutsideClickClose,
        enforceFocus,
        getLastOpened,
        handleDocumentMousedown,
        handleDocumentFocus,
        hasBackdrop,
        openOverlay
    ]);
    var overlayWillClose = $8NFma.useCallback(function() {
        var _a;
        document.removeEventListener("focus", handleDocumentFocus, /* useCapture */ true);
        document.removeEventListener("mousedown", handleDocumentMousedown);
        // N.B. `instance.current` may be null at this point if we are cleaning up an open overlay during the unmount phase
        // (this is common, for example, with context menu's singleton `showContextMenu` / `hideContextMenu` imperative APIs).
        closeOverlay(id);
        var lastOpenedOverlay = getLastOpened();
        if (lastOpenedOverlay !== undefined) // Only bring focus back to last overlay if it had autoFocus _and_ enforceFocus enabled.
        // If `autoFocus={false}`, it's likely that the overlay never received focus in the first place,
        // so it would be surprising for us to send it there. See https://github.com/palantir/blueprint/issues/4921
        {
            if (lastOpenedOverlay.props.autoFocus && lastOpenedOverlay.props.enforceFocus) {
                (_a = lastOpenedOverlay.bringFocusInsideOverlay) === null || _a === void 0 || _a.call(lastOpenedOverlay);
                if (lastOpenedOverlay.handleDocumentFocus !== undefined) document.addEventListener("focus", lastOpenedOverlay.handleDocumentFocus, /* useCapture */ true);
            }
        }
    }, [
        closeOverlay,
        getLastOpened,
        handleDocumentFocus,
        handleDocumentMousedown,
        id
    ]);
    var prevIsOpen = (_b = (0, $11SU3.usePrevious)(isOpen)) !== null && _b !== void 0 ? _b : false;
    $8NFma.useEffect(function() {
        if (isOpen) setHasEverOpened(true);
        if (!prevIsOpen && isOpen) // just opened
        overlayWillOpen();
        if (prevIsOpen && !isOpen) // just closed
        overlayWillClose();
    }, [
        isOpen,
        overlayWillOpen,
        overlayWillClose,
        prevIsOpen
    ]);
    // run once on unmount
    $8NFma.useEffect(function() {
        return function() {
            // we need to run cleanup code to remove some event handlers from the overlay element
            overlayWillClose();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var handleTransitionExited = $8NFma.useCallback(function(node) {
        var lastActiveElement = (0, $a6c1q.getRef)(lastActiveElementBeforeOpened);
        if (shouldReturnFocusOnClose && lastActiveElement instanceof HTMLElement) lastActiveElement.focus();
        onClosed === null || onClosed === void 0 || onClosed(node);
    }, [
        onClosed,
        shouldReturnFocusOnClose
    ]);
    // N.B. CSSTransition requires this callback to be defined, even if it's unused.
    var handleTransitionAddEnd = $8NFma.useCallback(function() {
    // no-op
    }, []);
    /**
     * Gets the relevant DOM ref for a child element using the `childRef` or `childRefs` props (if possible).
     * This ref is necessary for `CSSTransition` to work in React 18 without relying on `ReactDOM.findDOMNode`.
     *
     * Returns `undefined` if the user did not specify either of those props. In those cases, we use the ref we
     * have locally generated and expect that the user _did not_ specify their own `ref` on the child element
     * (it will get clobbered / overriden).
     *
     * @see https://reactcommunity.org/react-transition-group/css-transition
     */ var getUserChildRef = $8NFma.useCallback(function(child) {
        if (childRef != null) return childRef;
        else if (childRefs != null) {
            var key = child.key;
            if (key == null) {
                if (!(0, $3T4CC.isNodeEnv)("production")) console.error((0, $yL8qz.OVERLAY_CHILD_REQUIRES_KEY));
                return undefined;
            }
            return childRefs[key];
        }
        return undefined;
    }, [
        childRef,
        childRefs
    ]);
    var maybeRenderChild = $8NFma.useCallback(function(child) {
        if (child == null || (0, $3T4CC.isEmptyString)(child)) return null;
        // decorate the child with a few injected props
        var userChildRef = getUserChildRef(child);
        var childProps = (0, $6ROVj.isReactElement)(child) ? child.props : {};
        // if the child is a string, number, or fragment, it will be wrapped in a <span> element
        var decoratedChild = (0, $6ROVj.ensureElement)(child, "span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(childProps.className, (0, $4Aw5U).OVERLAY_CONTENT),
            // IMPORTANT: only inject our ref if the user didn't specify childRef or childRefs already. Otherwise,
            // we risk clobbering the user's ref (which we cannot inspect here while cloning/decorating the child).
            ref: userChildRef === undefined ? localChildRef : undefined,
            tabIndex: enforceFocus || autoFocus ? 0 : undefined
        });
        var resolvedChildRef = userChildRef !== null && userChildRef !== void 0 ? userChildRef : localChildRef;
        return $8NFma.createElement((0, $4OXLD.default), {
            addEndListener: handleTransitionAddEnd,
            classNames: transitionName,
            // HACKHACK: CSSTransition types are slightly incompatible with React types here.
            // React prefers `| null` but not `| undefined` for the ref value, while
            // CSSTransition _demands_ that `| undefined` be part of the element type.
            nodeRef: resolvedChildRef,
            onEntered: $393bdbce39ee64a8$var$getLifecycleCallbackWithChildRef(onOpened, resolvedChildRef),
            onEntering: $393bdbce39ee64a8$var$getLifecycleCallbackWithChildRef(onOpening, resolvedChildRef),
            onExited: $393bdbce39ee64a8$var$getLifecycleCallbackWithChildRef(handleTransitionExited, resolvedChildRef),
            onExiting: $393bdbce39ee64a8$var$getLifecycleCallbackWithChildRef(onClosing, resolvedChildRef),
            timeout: transitionDuration
        }, decoratedChild);
    }, [
        autoFocus,
        enforceFocus,
        getUserChildRef,
        handleTransitionAddEnd,
        handleTransitionExited,
        onClosing,
        onOpened,
        onOpening,
        transitionDuration,
        transitionName
    ]);
    var handleBackdropMouseDown = $8NFma.useCallback(function(e) {
        var _a;
        if (canOutsideClickClose) onClose === null || onClose === void 0 || onClose(e);
        if (enforceFocus) bringFocusInsideOverlay();
        (_a = backdropProps === null || backdropProps === void 0 ? void 0 : backdropProps.onMouseDown) === null || _a === void 0 || _a.call(backdropProps, e);
    }, [
        backdropProps,
        bringFocusInsideOverlay,
        canOutsideClickClose,
        enforceFocus,
        onClose
    ]);
    var renderDummyElement = $8NFma.useCallback(function(key, dummyElementProps) {
        return $8NFma.createElement((0, $4OXLD.default), {
            addEndListener: handleTransitionAddEnd,
            classNames: transitionName,
            key: key,
            nodeRef: dummyElementProps.ref,
            timeout: transitionDuration,
            unmountOnExit: true
        }, $8NFma.createElement("div", (0, $gztBd.__assign)({
            tabIndex: 0
        }, dummyElementProps)));
    }, [
        handleTransitionAddEnd,
        transitionDuration,
        transitionName
    ]);
    /**
     * Ensures repeatedly pressing shift+tab keeps focus inside the Overlay. Moves focus to
     * the `endFocusTrapElement` or the first keyboard-focusable element in the Overlay (excluding
     * the `startFocusTrapElement`), depending on whether the element losing focus is inside the
     * Overlay.
     */ var handleStartFocusTrapElementFocus = $8NFma.useCallback(function(e) {
        if (!enforceFocus || isAutoFocusing) return;
        // e.relatedTarget will not be defined if this was a programmatic focus event, as is the
        // case when we call this.bringFocusInsideOverlay() after a user clicked on the backdrop.
        // Otherwise, we're handling a user interaction, and we should wrap around to the last
        // element in this transition group.
        var container = (0, $a6c1q.getRef)(containerElement);
        var endFocusTrap = (0, $a6c1q.getRef)(endFocusTrapElement);
        if (e.relatedTarget != null && (container === null || container === void 0 ? void 0 : container.contains(e.relatedTarget)) && e.relatedTarget !== endFocusTrap) endFocusTrap === null || endFocusTrap === void 0 || endFocusTrap.focus({
            preventScroll: true
        });
    }, [
        enforceFocus,
        isAutoFocusing
    ]);
    /**
     * Wrap around to the end of the dialog if `enforceFocus` is enabled.
     */ var handleStartFocusTrapElementKeyDown = $8NFma.useCallback(function(e) {
        var _a;
        if (!enforceFocus) return;
        if (e.shiftKey && e.key === "Tab") {
            var lastFocusableElement = (0, $8o6Ut.getKeyboardFocusableElements)(containerElement).pop();
            if (lastFocusableElement != null) lastFocusableElement.focus();
            else (_a = (0, $a6c1q.getRef)(endFocusTrapElement)) === null || _a === void 0 || _a.focus({
                preventScroll: true
            });
        }
    }, [
        enforceFocus
    ]);
    /**
     * Ensures repeatedly pressing tab keeps focus inside the Overlay. Moves focus to the
     * `startFocusTrapElement` or the last keyboard-focusable element in the Overlay (excluding the
     * `startFocusTrapElement`), depending on whether the element losing focus is inside the
     * Overlay.
     */ var handleEndFocusTrapElementFocus = $8NFma.useCallback(function(e) {
        var _a;
        // No need for this.props.enforceFocus check here because this element is only rendered
        // when that prop is true.
        // During user interactions, e.relatedTarget will be defined, and we should wrap around to the
        // "start focus trap" element.
        // Otherwise, we're handling a programmatic focus event, which can only happen after a user
        // presses shift+tab from the first focusable element in the overlay.
        var startFocusTrap = (0, $a6c1q.getRef)(startFocusTrapElement);
        if (e.relatedTarget != null && ((_a = (0, $a6c1q.getRef)(containerElement)) === null || _a === void 0 ? void 0 : _a.contains(e.relatedTarget)) && e.relatedTarget !== startFocusTrap) {
            var firstFocusableElement = (0, $8o6Ut.getKeyboardFocusableElements)(containerElement).shift();
            // ensure we don't re-focus an already active element by comparing against e.relatedTarget
            if (!isAutoFocusing && firstFocusableElement != null && firstFocusableElement !== e.relatedTarget) firstFocusableElement.focus();
            else startFocusTrap === null || startFocusTrap === void 0 || startFocusTrap.focus({
                preventScroll: true
            });
        } else {
            var lastFocusableElement = (0, $8o6Ut.getKeyboardFocusableElements)(containerElement).pop();
            if (lastFocusableElement != null) lastFocusableElement.focus();
            else // Keeps focus within Overlay even if there are no keyboard-focusable children
            startFocusTrap === null || startFocusTrap === void 0 || startFocusTrap.focus({
                preventScroll: true
            });
        }
    }, [
        isAutoFocusing
    ]);
    var maybeBackdrop = $8NFma.useMemo(function() {
        return hasBackdrop && isOpen ? $8NFma.createElement((0, $4OXLD.default), {
            classNames: transitionName,
            key: "__backdrop",
            nodeRef: backdropElement,
            timeout: transitionDuration,
            addEndListener: handleTransitionAddEnd
        }, $8NFma.createElement("div", (0, $gztBd.__assign)({}, backdropProps, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $4Aw5U).OVERLAY_BACKDROP, backdropClassName, backdropProps === null || backdropProps === void 0 ? void 0 : backdropProps.className),
            onMouseDown: handleBackdropMouseDown,
            ref: backdropElement
        }))) : null;
    }, [
        backdropClassName,
        backdropProps,
        handleBackdropMouseDown,
        handleTransitionAddEnd,
        hasBackdrop,
        isOpen,
        transitionDuration,
        transitionName
    ]);
    // no reason to render anything at all if we're being truly lazy
    if (lazy && !hasEverOpened) return null;
    // TransitionGroup types require single array of children; does not support nested arrays.
    // So we must collapse backdrop and children into one array, and every item must be wrapped in a
    // Transition element (no ReactText allowed).
    var childrenWithTransitions = isOpen ? (_c = $8NFma.Children.map(children, maybeRenderChild)) !== null && _c !== void 0 ? _c : [] : [];
    // const maybeBackdrop = maybeRenderBackdrop();
    if (maybeBackdrop !== null) childrenWithTransitions.unshift(maybeBackdrop);
    if (isOpen && (autoFocus || enforceFocus) && childrenWithTransitions.length > 0) {
        childrenWithTransitions.unshift(renderDummyElement("__start", {
            className: (0, $4Aw5U).OVERLAY_START_FOCUS_TRAP,
            onFocus: handleStartFocusTrapElementFocus,
            onKeyDown: handleStartFocusTrapElementKeyDown,
            ref: startFocusTrapElement
        }));
        if (enforceFocus) childrenWithTransitions.push(renderDummyElement("__end", {
            className: (0, $4Aw5U).OVERLAY_END_FOCUS_TRAP,
            onFocus: handleEndFocusTrapElementFocus,
            ref: endFocusTrapElement
        }));
    }
    var transitionGroup = $8NFma.createElement("div", {
        "aria-live": "polite",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $4Aw5U).OVERLAY, (_a = {}, _a[(0, $4Aw5U).OVERLAY_OPEN] = isOpen, _a[(0, $4Aw5U).OVERLAY_INLINE] = !usePortal, _a), className),
        onKeyDown: handleContainerKeyDown,
        ref: containerElement
    }, $8NFma.createElement((0, $gbRGj.default), {
        appear: true,
        component: null
    }, childrenWithTransitions));
    if (usePortal) return $8NFma.createElement((0, $ftEZI.Portal), {
        className: portalClassName,
        container: portalContainer
    }, transitionGroup);
    else return transitionGroup;
});
$393bdbce39ee64a8$export$2e8e2c61dfd53893.defaultProps = {
    autoFocus: true,
    backdropProps: {},
    canEscapeKeyClose: true,
    canOutsideClickClose: true,
    enforceFocus: true,
    hasBackdrop: true,
    isOpen: false,
    lazy: (0, $8zMLm.hasDOMEnvironment)(),
    shouldReturnFocusOnClose: true,
    transitionDuration: 300,
    transitionName: (0, $4Aw5U).OVERLAY,
    usePortal: true
};
$393bdbce39ee64a8$export$2e8e2c61dfd53893.displayName = "".concat((0, $3lvnD.DISPLAYNAME_PREFIX), ".Overlay2");
function $393bdbce39ee64a8$var$useOverlay2Validation(_a) {
    var childRef = _a.childRef, childRefs = _a.childRefs, children = _a.children;
    var numChildren = $8NFma.Children.count(children);
    $8NFma.useEffect(function() {
        if ((0, $3T4CC.isNodeEnv)("production")) return;
        if (childRef != null && childRefs != null) console.error((0, $yL8qz.OVERLAY_CHILD_REF_AND_REFS_MUTEX));
        if (numChildren > 1 && childRefs == null) console.error((0, $yL8qz.OVERLAY_WITH_MULTIPLE_CHILDREN_REQUIRES_CHILD_REFS));
    }, [
        childRef,
        childRefs,
        numChildren
    ]);
}
/**
 * Generates a unique ID for a given Overlay which persists across the component's lifecycle.
 */ function $393bdbce39ee64a8$var$useOverlay2ID() {
    // TODO: migrate to React.useId() in React 18
    var id = (0, $ieuVO.useUID)();
    return "".concat($393bdbce39ee64a8$export$2e8e2c61dfd53893.displayName, "-").concat(id);
}
// N.B. the `onExiting` callback is not provided with the `node` argument as suggested in CSSTransition types since
// we are using the `nodeRef` prop, so we must inject it dynamically.
function $393bdbce39ee64a8$var$getLifecycleCallbackWithChildRef(callback, childRef) {
    return function() {
        if ((childRef === null || childRef === void 0 ? void 0 : childRef.current) != null) callback === null || callback === void 0 || callback(childRef.current);
    };
}

});
parcelRegister("gl4hP", function(module, exports) {

$parcel$export(module.exports, "useOverlayStack", () => $be51eebfe6685930$export$b9eca684780184d5);
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $8NFma = parcelRequire("8NFma");

var $4Aw5U = parcelRequire("4Aw5U");

var $yL8qz = parcelRequire("yL8qz");

var $3T4CC = parcelRequire("3T4CC");

var $2NGeT = parcelRequire("2NGeT");

var $4xZSr = parcelRequire("4xZSr");
function $be51eebfe6685930$export$b9eca684780184d5() {
    // get the overlay stack from application-wide React context
    var _a = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useContext((0, $2NGeT.OverlaysContext)), stack = _a.stack, hasProvider = _a.hasProvider;
    var legacyOverlayStack = (0, $4xZSr.useLegacyOverlayStack)();
    var getLastOpened = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useCallback(function() {
        return stack.current.at(-1);
    }, [
        stack
    ]);
    var getThisOverlayAndDescendants = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useCallback(function(id) {
        var index = stack.current.findIndex(function(o) {
            return o.id === id;
        });
        if (index === -1) return [];
        return stack.current.slice(index);
    }, [
        stack
    ]);
    var resetStack = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useCallback(function() {
        stack.current = [];
    }, [
        stack
    ]);
    var openOverlay = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useCallback(function(overlay) {
        stack.current.push(overlay);
        if (overlay.props.usePortal && overlay.props.hasBackdrop) // add a class to the body to prevent scrolling of content below the overlay
        document.body.classList.add((0, $4Aw5U).OVERLAY_OPEN);
    }, [
        stack
    ]);
    var closeOverlay = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useCallback(function(id) {
        var otherOverlaysWithBackdrop = stack.current.filter(function(o) {
            return o.props.usePortal && o.props.hasBackdrop && o.id !== id;
        });
        var index = stack.current.findIndex(function(o) {
            return o.id === id;
        });
        if (index > -1) stack.current.splice(index, 1);
        if (otherOverlaysWithBackdrop.length === 0) // remove body class which prevents scrolling of content below overlay
        document.body.classList.remove((0, $4Aw5U).OVERLAY_OPEN);
    }, [
        stack
    ]);
    if (!hasProvider) {
        if ((0, $3T4CC.isNodeEnv)("development")) console.error((0, $yL8qz.OVERLAY2_REQUIRES_OVERLAY_PROVDER));
        return legacyOverlayStack;
    }
    return {
        closeOverlay: closeOverlay,
        getLastOpened: getLastOpened,
        getThisOverlayAndDescendants: getThisOverlayAndDescendants,
        openOverlay: openOverlay,
        resetStack: resetStack
    };
}

});
parcelRegister("2NGeT", function(module, exports) {

$parcel$export(module.exports, "OverlaysContext", () => $20a0ec2f4b307093$export$ffbb3c21604c2bde);
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $8NFma = parcelRequire("8NFma");
var $20a0ec2f4b307093$export$ffbb3c21604c2bde = $8NFma.createContext({
    hasProvider: false,
    stack: {
        current: []
    }
});
var $20a0ec2f4b307093$export$2e609a126d315e1b = function(_a) {
    var children = _a.children;
    var stack = $8NFma.useRef([]);
    var contextValue = $8NFma.useMemo(function() {
        return {
            hasProvider: true,
            stack: stack
        };
    }, [
        stack
    ]);
    return $8NFma.createElement($20a0ec2f4b307093$export$ffbb3c21604c2bde.Provider, {
        value: contextValue
    }, children);
};

});

parcelRegister("4xZSr", function(module, exports) {

$parcel$export(module.exports, "useLegacyOverlayStack", () => $34fa3dffe98ac46f$export$501bbf48543ad65d);
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $8NFma = parcelRequire("8NFma");

var $ck4pA = parcelRequire("ck4pA");

var $4Aw5U = parcelRequire("4Aw5U");
var $34fa3dffe98ac46f$var$globalStack = [];
var $34fa3dffe98ac46f$var$globalStackListeners = [];
var $34fa3dffe98ac46f$export$c93586c81c6b24b8 = function(fn) {
    fn($34fa3dffe98ac46f$var$globalStack);
    $34fa3dffe98ac46f$var$globalStackListeners.forEach(function(listener) {
        return listener();
    });
};
var $34fa3dffe98ac46f$var$legacyGlobalOverlayStackStore = {
    getSnapshot: function() {
        return $34fa3dffe98ac46f$var$globalStack;
    },
    subscribe: function(listener) {
        $34fa3dffe98ac46f$var$globalStackListeners.push(listener);
        return function() {
            var index = $34fa3dffe98ac46f$var$globalStackListeners.indexOf(listener);
            $34fa3dffe98ac46f$var$globalStackListeners.splice(index, 1);
        };
    }
};
function $34fa3dffe98ac46f$export$501bbf48543ad65d() {
    var stack = (0, $ck4pA.useSyncExternalStore)($34fa3dffe98ac46f$var$legacyGlobalOverlayStackStore.subscribe, $34fa3dffe98ac46f$var$legacyGlobalOverlayStackStore.getSnapshot, // server snapshot is the same as client snapshot
    $34fa3dffe98ac46f$var$legacyGlobalOverlayStackStore.getSnapshot);
    var getLastOpened = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useCallback(function() {
        return stack.at(-1);
    }, [
        stack
    ]);
    var getThisOverlayAndDescendants = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useCallback(function(id) {
        var stackIndex = stack.findIndex(function(o) {
            return o.id === id;
        });
        return stack.slice(stackIndex);
    }, [
        stack
    ]);
    var resetStack = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useCallback(function() {
        $34fa3dffe98ac46f$export$c93586c81c6b24b8(function(s) {
            return s.splice(0, s.length);
        });
    }, []);
    var openOverlay = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useCallback(function(overlay) {
        $34fa3dffe98ac46f$var$globalStack.push(overlay);
        if (overlay.props.usePortal && overlay.props.hasBackdrop) // add a class to the body to prevent scrolling of content below the overlay
        document.body.classList.add((0, $4Aw5U).OVERLAY_OPEN);
    }, []);
    var closeOverlay = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useCallback(function(id) {
        var otherOverlaysWithBackdrop = stack.filter(function(o) {
            return o.props.usePortal && o.props.hasBackdrop && o.id !== id;
        });
        var index = $34fa3dffe98ac46f$var$globalStack.findIndex(function(o) {
            return o.id === id;
        });
        if (index > -1) $34fa3dffe98ac46f$var$globalStack.splice(index, 1);
        if (otherOverlaysWithBackdrop.length === 0) // remove body class which prevents scrolling of content below overlay
        document.body.classList.remove((0, $4Aw5U).OVERLAY_OPEN);
    }, [
        stack
    ]);
    return {
        closeOverlay: closeOverlay,
        getLastOpened: getLastOpened,
        getThisOverlayAndDescendants: getThisOverlayAndDescendants,
        openOverlay: openOverlay,
        resetStack: resetStack
    };
}

});


parcelRegister("11SU3", function(module, exports) {

$parcel$export(module.exports, "usePrevious", () => $0c00790a7b69f454$export$5cae361ad82dce8b);
/*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $8NFma = parcelRequire("8NFma");
function $0c00790a7b69f454$export$5cae361ad82dce8b(value) {
    // create a new reference
    var ref = $8NFma.useRef();
    // store current value in ref
    $8NFma.useEffect(function() {
        ref.current = value;
    }, [
        value
    ]);
    // return previous value (happens before update in useEffect above)
    return ref.current;
}

});

parcelRegister("8o6Ut", function(module, exports) {

$parcel$export(module.exports, "getKeyboardFocusableElements", () => $61b5ecc293f09718$export$d68aba5567a52975);
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $4Aw5U = parcelRequire("4Aw5U");

var $a6c1q = parcelRequire("a6c1q");
function $61b5ecc293f09718$export$d68aba5567a52975(container) {
    var containerElement = (0, $a6c1q.getRef)(container);
    var focusableElements = containerElement != null ? Array.from(// Order may not be correct if children elements use tabindex values > 0.
    // Selectors derived from this SO question:
    // https://stackoverflow.com/questions/1599660/which-html-elements-can-receive-focus
    containerElement.querySelectorAll([
        'a[href]:not([tabindex="-1"])',
        'button:not([disabled]):not([tabindex="-1"])',
        'details:not([tabindex="-1"])',
        'input:not([disabled]):not([tabindex="-1"])',
        'select:not([disabled]):not([tabindex="-1"])',
        'textarea:not([disabled]):not([tabindex="-1"])',
        '[tabindex]:not([tabindex="-1"])'
    ].join(","))) : [];
    return focusableElements.filter(function(el) {
        return !el.classList.contains((0, $4Aw5U.OVERLAY_START_FOCUS_TRAP)) && !el.classList.contains((0, $4Aw5U.OVERLAY_END_FOCUS_TRAP));
    });
}

});

parcelRegister("ftEZI", function(module, exports) {

$parcel$export(module.exports, "Portal", () => $b4495d16b1569ee0$export$602eac185826482c);
/*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $8NFma = parcelRequire("8NFma");

var $2pmb0 = parcelRequire("2pmb0");

var $4Aw5U = parcelRequire("4Aw5U");
var $3lvnD = parcelRequire("3lvnD");

var $yL8qz = parcelRequire("yL8qz");

var $6ROVj = parcelRequire("6ROVj");

var $bQTox = parcelRequire("bQTox");
/** @deprecated will be removed in Blueprint v6.0 */ var $b4495d16b1569ee0$var$PORTAL_LEGACY_CONTEXT_TYPES = {
    blueprintPortalClassName: function(obj, key) {
        if (obj[key] != null && typeof obj[key] !== "string") return new Error($yL8qz.PORTAL_CONTEXT_CLASS_NAME_STRING);
        return undefined;
    }
};
function $b4495d16b1569ee0$export$602eac185826482c(// eslint-disable-next-line deprecation/deprecation
_a, legacyContext) {
    var _b;
    var className = _a.className, stopPropagationEvents = _a.stopPropagationEvents, container = _a.container, onChildrenMount = _a.onChildrenMount, children = _a.children;
    if (legacyContext === void 0) legacyContext = {};
    var context = $8NFma.useContext((0, $bQTox.PortalContext));
    var portalContainer = (_b = container !== null && container !== void 0 ? container : context.portalContainer) !== null && _b !== void 0 ? _b : typeof document !== "undefined" ? document.body : undefined;
    var _c = $8NFma.useState(), portalElement = _c[0], setPortalElement = _c[1];
    var createPortalElement = $8NFma.useCallback(function() {
        var newPortalElement = document.createElement("div");
        newPortalElement.classList.add((0, $4Aw5U).PORTAL);
        $b4495d16b1569ee0$var$maybeAddClass(newPortalElement.classList, className); // directly added to this portal element
        $b4495d16b1569ee0$var$maybeAddClass(newPortalElement.classList, context.portalClassName); // added via PortalProvider context
        $b4495d16b1569ee0$var$addStopPropagationListeners(newPortalElement, stopPropagationEvents);
        // TODO: remove legacy context support in Blueprint v6.0
        var blueprintPortalClassName = legacyContext.blueprintPortalClassName;
        if (blueprintPortalClassName != null && blueprintPortalClassName !== "") {
            console.error($yL8qz.PORTAL_LEGACY_CONTEXT_API);
            $b4495d16b1569ee0$var$maybeAddClass(newPortalElement.classList, blueprintPortalClassName); // added via legacy context
        }
        return newPortalElement;
    }, [
        className,
        context.portalClassName,
        legacyContext.blueprintPortalClassName,
        stopPropagationEvents
    ]);
    // create the container element & attach it to the DOM
    $8NFma.useEffect(function() {
        if (portalContainer == null) return;
        var newPortalElement = createPortalElement();
        portalContainer.appendChild(newPortalElement);
        setPortalElement(newPortalElement);
        return function() {
            $b4495d16b1569ee0$var$removeStopPropagationListeners(newPortalElement, stopPropagationEvents);
            newPortalElement.remove();
            setPortalElement(undefined);
        };
    }, [
        portalContainer,
        createPortalElement,
        stopPropagationEvents
    ]);
    // wait until next successful render to invoke onChildrenMount callback
    $8NFma.useEffect(function() {
        if (portalElement != null) onChildrenMount === null || onChildrenMount === void 0 || onChildrenMount();
    }, [
        portalElement,
        onChildrenMount
    ]);
    $8NFma.useEffect(function() {
        if (portalElement != null) {
            $b4495d16b1569ee0$var$maybeAddClass(portalElement.classList, className);
            return function() {
                return $b4495d16b1569ee0$var$maybeRemoveClass(portalElement.classList, className);
            };
        }
        return undefined;
    }, [
        className,
        portalElement
    ]);
    $8NFma.useEffect(function() {
        if (portalElement != null) {
            $b4495d16b1569ee0$var$addStopPropagationListeners(portalElement, stopPropagationEvents);
            return function() {
                return $b4495d16b1569ee0$var$removeStopPropagationListeners(portalElement, stopPropagationEvents);
            };
        }
        return undefined;
    }, [
        portalElement,
        stopPropagationEvents
    ]);
    // Only render `children` once this component has mounted in a browser environment, so they are
    // immediately attached to the DOM tree and can do DOM things like measuring or `autoFocus`.
    // See long comment on componentDidMount in https://reactjs.org/docs/portals.html#event-bubbling-through-portals
    if (typeof document === "undefined" || portalElement == null) return null;
    else return $2pmb0.createPortal(children, portalElement);
}
$b4495d16b1569ee0$export$602eac185826482c.displayName = "".concat((0, $3lvnD.DISPLAYNAME_PREFIX), ".Portal");
// only use legacy context in React 16 or 17
if (!(0, $6ROVj.isReact18)()) // eslint-disable-next-line deprecation/deprecation
$b4495d16b1569ee0$export$602eac185826482c.contextTypes = $b4495d16b1569ee0$var$PORTAL_LEGACY_CONTEXT_TYPES;
function $b4495d16b1569ee0$var$maybeRemoveClass(classList, className) {
    if (className != null && className !== "") classList.remove.apply(classList, className.split(" "));
}
function $b4495d16b1569ee0$var$maybeAddClass(classList, className) {
    if (className != null && className !== "") classList.add.apply(classList, className.split(" "));
}
function $b4495d16b1569ee0$var$addStopPropagationListeners(portalElement, eventNames) {
    eventNames === null || eventNames === void 0 || eventNames.forEach(function(event) {
        return portalElement.addEventListener(event, $b4495d16b1569ee0$var$handleStopProgation);
    });
}
function $b4495d16b1569ee0$var$removeStopPropagationListeners(portalElement, events) {
    events === null || events === void 0 || events.forEach(function(event) {
        return portalElement.removeEventListener(event, $b4495d16b1569ee0$var$handleStopProgation);
    });
}
function $b4495d16b1569ee0$var$handleStopProgation(e) {
    e.stopPropagation();
}

});
parcelRegister("bQTox", function(module, exports) {

$parcel$export(module.exports, "PortalContext", () => $8a0f8549b4bf92a6$export$60d741e20e0aa309);
/*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $8NFma = parcelRequire("8NFma");
var $8a0f8549b4bf92a6$export$60d741e20e0aa309 = $8NFma.createContext({});
var $8a0f8549b4bf92a6$export$6df4068a17305b10 = function(_a) {
    var children = _a.children, portalClassName = _a.portalClassName, portalContainer = _a.portalContainer;
    var contextOptions = $8NFma.useMemo(function() {
        return {
            portalClassName: portalClassName,
            portalContainer: portalContainer
        };
    }, [
        portalClassName,
        portalContainer
    ]);
    return $8NFma.createElement($8a0f8549b4bf92a6$export$60d741e20e0aa309.Provider, {
        value: contextOptions
    }, children);
};

});



parcelRegister("52TTV", function(module, exports) {

$parcel$export(module.exports, "ResizeSensor", () => $3ac8806ccd4ca54a$export$99e7f5e92b1f0cf9);
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $8NFma = parcelRequire("8NFma");

var $88643 = parcelRequire("88643");
var $3lvnD = parcelRequire("3lvnD");
/**
 * Resize sensor component.
 *
 * It requires a single DOM element child and will error otherwise.
 *
 * @see https://blueprintjs.com/docs/#core/components/resize-sensor
 **/ var $3ac8806ccd4ca54a$export$99e7f5e92b1f0cf9 = /** @class */ function(_super) {
    (0, $gztBd.__extends)(ResizeSensor, _super);
    function ResizeSensor() {
        var _a;
        var _this = _super.apply(this, arguments) || this;
        _this.targetRef = (_a = _this.props.targetRef) !== null && _a !== void 0 ? _a : $8NFma.createRef();
        _this.prevElement = undefined;
        return _this;
    }
    ResizeSensor.prototype.render = function() {
        var onlyChild = $8NFma.Children.only(this.props.children);
        // If we're provided a mutable ref to the child element already, we must re-use that one. This is necessary
        // in cases where the child node is not a native DOM element and does not use `React.forwardRef`, since
        // there's no way for us to know how to attach to the underlying DOM node.
        if (this.props.targetRef !== undefined) return onlyChild;
        return $8NFma.cloneElement(onlyChild, {
            ref: this.targetRef
        });
    };
    ResizeSensor.prototype.componentDidMount = function() {
        var _this = this;
        // ResizeObserver is available in all modern browsers supported by Blueprint but not in server-side rendering
        // and some test environments like jsdom, so we to do a feature check here.
        this.observer = globalThis.ResizeObserver != null ? new ResizeObserver(function(entries) {
            var _a, _b;
            return (_b = (_a = _this.props).onResize) === null || _b === void 0 ? void 0 : _b.call(_a, entries);
        }) : undefined;
        this.observeElement();
    };
    ResizeSensor.prototype.componentDidUpdate = function(prevProps) {
        this.observeElement(this.props.observeParents !== prevProps.observeParents);
    };
    ResizeSensor.prototype.componentWillUnmount = function() {
        var _a;
        (_a = this.observer) === null || _a === void 0 || _a.disconnect();
        this.prevElement = undefined;
    };
    /**
     * Observe the DOM element, if defined and different from the currently
     * observed element. Pass `force` argument to skip element checks and always
     * re-observe.
     */ ResizeSensor.prototype.observeElement = function(force) {
        if (force === void 0) force = false;
        if (this.observer === undefined) return;
        if (!(this.targetRef.current instanceof Element)) {
            // stop everything if not defined
            this.observer.disconnect();
            return;
        }
        if (this.targetRef.current === this.prevElement && !force) // quit if given same element -- nothing to update (unless forced)
        return;
        else {
            // clear observer list if new element
            this.observer.disconnect();
            // remember element reference for next time
            this.prevElement = this.targetRef.current;
        }
        // observer callback is invoked immediately when observing new elements
        this.observer.observe(this.targetRef.current);
        if (this.props.observeParents) {
            var parent_1 = this.targetRef.current.parentElement;
            while(parent_1 != null){
                this.observer.observe(parent_1);
                parent_1 = parent_1.parentElement;
            }
        }
    };
    ResizeSensor.displayName = "".concat((0, $3lvnD.DISPLAYNAME_PREFIX), ".ResizeSensor");
    return ResizeSensor;
}((0, $88643.AbstractPureComponent));

});

parcelRegister("8R4ZP", function(module, exports) {

$parcel$export(module.exports, "Tooltip", () => $67272621658e26b1$export$28c660c63b792dea);
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $88643 = parcelRequire("88643");
var $3lvnD = parcelRequire("3lvnD");

var $4Aw5U = parcelRequire("4Aw5U");

var $8Ntcp = parcelRequire("8Ntcp");

var $jxVrF = parcelRequire("jxVrF");

var $7G2K2 = parcelRequire("7G2K2");
/**
 * Tooltip component.
 *
 * @see https://blueprintjs.com/docs/#core/components/tooltip
 */ var $67272621658e26b1$export$28c660c63b792dea = /** @class */ function(_super) {
    (0, $gztBd.__extends)(Tooltip, _super);
    function Tooltip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.popoverRef = $8NFma.createRef();
        // any descendant ContextMenus may update this ctxState
        _this.renderPopover = function(ctxState) {
            var _a;
            var _b;
            var _c = _this.props, children = _c.children, compact = _c.compact, disabled = _c.disabled, intent = _c.intent, popoverClassName = _c.popoverClassName, restProps = (0, $gztBd.__rest)(_c, [
                "children",
                "compact",
                "disabled",
                "intent",
                "popoverClassName"
            ]);
            var popoverClasses = (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))($4Aw5U.TOOLTIP, $4Aw5U.intentClass(intent), popoverClassName, (_a = {}, _a[$4Aw5U.COMPACT] = compact, _a));
            return $8NFma.createElement((0, $8Ntcp.Popover), (0, $gztBd.__assign)({
                modifiers: {
                    arrow: {
                        enabled: !_this.props.minimal
                    },
                    offset: {
                        options: {
                            offset: [
                                0,
                                (0, $jxVrF.TOOLTIP_ARROW_SVG_SIZE) / 2
                            ]
                        }
                    }
                }
            }, restProps, {
                autoFocus: false,
                canEscapeKeyClose: false,
                disabled: (_b = ctxState.forceDisabled) !== null && _b !== void 0 ? _b : disabled,
                enforceFocus: false,
                lazy: true,
                popoverClassName: popoverClasses,
                portalContainer: _this.props.portalContainer,
                ref: _this.popoverRef
            }), children);
        };
        return _this;
    }
    Tooltip.prototype.render = function() {
        var _this = this;
        // if we have an ancestor TooltipContext, we should take its state into account in this render path,
        // it was likely created by a parent ContextMenu
        return $8NFma.createElement((0, $7G2K2.TooltipContext).Consumer, null, function(_a) {
            var state = _a[0];
            return $8NFma.createElement((0, $7G2K2.TooltipProvider), (0, $gztBd.__assign)({}, state), _this.renderPopover);
        });
    };
    Tooltip.prototype.reposition = function() {
        var _a;
        (_a = this.popoverRef.current) === null || _a === void 0 || _a.reposition();
    };
    Tooltip.displayName = "".concat((0, $3lvnD.DISPLAYNAME_PREFIX), ".Tooltip");
    Tooltip.defaultProps = {
        compact: false,
        hoverCloseDelay: 0,
        hoverOpenDelay: 100,
        interactionKind: "hover-target",
        minimal: false,
        transitionDuration: 100
    };
    return Tooltip;
}((0, $88643.AbstractPureComponent));

});
parcelRegister("jxVrF", function(module, exports) {

$parcel$export(module.exports, "POPOVER_ARROW_SVG_SIZE", () => $e3ada8cadba264c0$export$4c969461ca74ea0d);
$parcel$export(module.exports, "TOOLTIP_ARROW_SVG_SIZE", () => $e3ada8cadba264c0$export$26419ed1e4945e0);
$parcel$export(module.exports, "PopoverArrow", () => $e3ada8cadba264c0$export$3152841115e061b2);
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $8NFma = parcelRequire("8NFma");

var $4Aw5U = parcelRequire("4Aw5U");
var $3lvnD = parcelRequire("3lvnD");

var $fgHs1 = parcelRequire("fgHs1");
// these paths come from the Core Kit Sketch file
// https://github.com/palantir/blueprint/blob/develop/resources/sketch/Core%20Kit.sketch
var $e3ada8cadba264c0$var$SVG_SHADOW_PATH = "M8.11 6.302c1.015-.936 1.887-2.922 1.887-4.297v26c0-1.378-.868-3.357-1.888-4.297L.925 17.09c-1.237-1.14-1.233-3.034 0-4.17L8.11 6.302z";
var $e3ada8cadba264c0$var$SVG_ARROW_PATH = "M8.787 7.036c1.22-1.125 2.21-3.376 2.21-5.03V0v30-2.005c0-1.654-.983-3.9-2.21-5.03l-7.183-6.616c-.81-.746-.802-1.96 0-2.7l7.183-6.614z";
// additional space between arrow and edge of target
var $e3ada8cadba264c0$var$ARROW_SPACING = 4;
var $e3ada8cadba264c0$export$4c969461ca74ea0d = 30;
var $e3ada8cadba264c0$export$26419ed1e4945e0 = 22;
/* istanbul ignore next */ /** Modifier helper function to compute arrow rotate() transform */ function $e3ada8cadba264c0$var$getArrowAngle(placement) {
    if (placement == null) return 0;
    // can only be top/left/bottom/right - auto is resolved internally
    switch((0, $fgHs1.getBasePlacement)(placement)){
        case "top":
            return -90;
        case "left":
            return 180;
        case "bottom":
            return 90;
        default:
            return 0;
    }
}
/* istanbul ignore next */ /**
 * Popper's builtin "arrow" modifier options.padding doesn't seem to work for us, so we
 * need to compute our own offset in the direction of the popover relative to the reference.
 */ function $e3ada8cadba264c0$var$getArrowReferenceOffsetStyle(placement) {
    var offset = $e3ada8cadba264c0$export$4c969461ca74ea0d / 2 - $e3ada8cadba264c0$var$ARROW_SPACING;
    switch((0, $fgHs1.getBasePlacement)(placement)){
        case "top":
            return {
                bottom: -offset
            };
        case "left":
            return {
                right: -offset
            };
        case "bottom":
            return {
                top: -offset
            };
        default:
            return {
                left: -offset
            };
    }
}
var $e3ada8cadba264c0$export$3152841115e061b2 = function(_a) {
    var _b = _a.arrowProps, ref = _b.ref, style = _b.style, placement = _a.placement;
    return(// data attribute allows popper.js to position the arrow
    $8NFma.createElement("div", {
        "aria-hidden": true,
        className: (0, $4Aw5U).POPOVER_ARROW,
        "data-popper-arrow": true,
        ref: ref,
        style: (0, $gztBd.__assign)((0, $gztBd.__assign)({}, style), $e3ada8cadba264c0$var$getArrowReferenceOffsetStyle(placement))
    }, $8NFma.createElement("svg", {
        viewBox: "0 0 ".concat($e3ada8cadba264c0$export$4c969461ca74ea0d, " ").concat($e3ada8cadba264c0$export$4c969461ca74ea0d),
        style: {
            transform: "rotate(".concat($e3ada8cadba264c0$var$getArrowAngle(placement), "deg)")
        }
    }, $8NFma.createElement("path", {
        className: (0, $4Aw5U).POPOVER_ARROW + "-border",
        d: $e3ada8cadba264c0$var$SVG_SHADOW_PATH
    }), $8NFma.createElement("path", {
        className: (0, $4Aw5U).POPOVER_ARROW + "-fill",
        d: $e3ada8cadba264c0$var$SVG_ARROW_PATH
    }))));
};
$e3ada8cadba264c0$export$3152841115e061b2.displayName = "".concat((0, $3lvnD.DISPLAYNAME_PREFIX), ".PopoverArrow");

});
parcelRegister("fgHs1", function(module, exports) {

$parcel$export(module.exports, "getBasePlacement", () => $b1da0e1839c1ce13$export$1f716c21fc884054);
$parcel$export(module.exports, "getTransformOrigin", () => $b1da0e1839c1ce13$export$ac94fefc82bff952);
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
function $b1da0e1839c1ce13$export$1f716c21fc884054(placement) {
    return placement.split("-")[0];
}
function $b1da0e1839c1ce13$export$14f7b3a1379533e9(side) {
    return [
        "left",
        "right"
    ].indexOf(side) !== -1;
}
function $b1da0e1839c1ce13$export$9c5e28bad23365fa(side) {
    switch(side){
        case "top":
            return "bottom";
        case "left":
            return "right";
        case "bottom":
            return "top";
        default:
            return "left";
    }
}
function $b1da0e1839c1ce13$export$f0989780f32bfcda(placement) {
    var align = placement.split("-")[1];
    switch(align){
        case "start":
            return "left";
        case "end":
            return "right";
        default:
            return "center";
    }
}
function $b1da0e1839c1ce13$export$ac94fefc82bff952(placement, arrowStyles) {
    var basePlacement = $b1da0e1839c1ce13$export$1f716c21fc884054(placement);
    if (arrowStyles === undefined) return $b1da0e1839c1ce13$export$14f7b3a1379533e9(basePlacement) ? "".concat($b1da0e1839c1ce13$export$9c5e28bad23365fa(basePlacement), " ").concat($b1da0e1839c1ce13$export$f0989780f32bfcda(basePlacement)) : "".concat($b1da0e1839c1ce13$export$f0989780f32bfcda(basePlacement), " ").concat($b1da0e1839c1ce13$export$9c5e28bad23365fa(basePlacement));
    else {
        // const arrowSizeShift = state.elements.arrow.clientHeight / 2;
        var arrowSizeShift = 15;
        // can use keyword for dimension without the arrow, to ease computation burden.
        // move origin by half arrow's height to keep it centered.
        return $b1da0e1839c1ce13$export$14f7b3a1379533e9(basePlacement) ? "".concat($b1da0e1839c1ce13$export$9c5e28bad23365fa(basePlacement), " ").concat(parseInt(arrowStyles.top, 10) + arrowSizeShift, "px") : "".concat(parseInt(arrowStyles.left, 10) + arrowSizeShift, "px ").concat($b1da0e1839c1ce13$export$9c5e28bad23365fa(basePlacement));
    }
}

});


parcelRegister("7G2K2", function(module, exports) {

$parcel$export(module.exports, "TooltipContext", () => $596e95120ed335f4$export$39ae08fa83328b12);
$parcel$export(module.exports, "TooltipProvider", () => $596e95120ed335f4$export$f78649fb9ca566b8);
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $8NFma = parcelRequire("8NFma");
var $596e95120ed335f4$var$noOpDispatch = function() {
    return null;
};
var $596e95120ed335f4$export$39ae08fa83328b12 = $8NFma.createContext([
    {},
    $596e95120ed335f4$var$noOpDispatch
]);
var $596e95120ed335f4$var$tooltipContextReducer = function(state, action) {
    switch(action.type){
        case "FORCE_DISABLED_STATE":
            return {
                forceDisabled: true
            };
        case "RESET_DISABLED_STATE":
            return {};
        default:
            return state;
    }
};
var $596e95120ed335f4$export$f78649fb9ca566b8 = function(_a) {
    var children = _a.children, forceDisable = _a.forceDisable;
    var _b = $8NFma.useReducer($596e95120ed335f4$var$tooltipContextReducer, {}), state = _b[0], dispatch = _b[1];
    var contextValue = $8NFma.useMemo(function() {
        return [
            state,
            dispatch
        ];
    }, [
        state,
        dispatch
    ]);
    $8NFma.useEffect(function() {
        if (forceDisable) dispatch({
            type: "FORCE_DISABLED_STATE"
        });
        else dispatch({
            type: "RESET_DISABLED_STATE"
        });
    }, [
        forceDisable
    ]);
    return $8NFma.createElement($596e95120ed335f4$export$39ae08fa83328b12.Provider, {
        value: contextValue
    }, typeof children === "function" ? children(state) : children);
};

});


parcelRegister("iPiJm", function(module, exports) {

$parcel$export(module.exports, "matchReferenceWidthModifier", () => $db4b84f11a6371dd$export$a8e9b369768a413a);
/*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // tslint:disable object-literal-sort-keys
// adapted from https://popper.js.org/docs/v2/modifiers/community-modifiers/
var $db4b84f11a6371dd$export$a8e9b369768a413a = {
    enabled: true,
    name: "matchReferenceWidth",
    phase: "beforeWrite",
    requires: [
        "computeStyles"
    ],
    fn: function(_a) {
        var state = _a.state;
        state.styles.popper.width = "".concat(state.rects.reference.width, "px");
    },
    effect: function(_a) {
        var state = _a.state;
        var referenceWidth = state.elements.reference.getBoundingClientRect().width;
        state.elements.popper.style.width = "".concat(referenceWidth, "px");
    }
};

});

parcelRegister("cjYAu", function(module, exports) {

$parcel$export(module.exports, "positionToPlacement", () => $8f8641ca77d03d1c$export$d7fe7517a77957bc);
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $lfkg1 = parcelRequire("lfkg1");
function $8f8641ca77d03d1c$export$d7fe7517a77957bc(position) {
    /* istanbul ignore next */ switch(position){
        case (0, $lfkg1.PopoverPosition).TOP_LEFT:
            return "top-start";
        case (0, $lfkg1.PopoverPosition).TOP:
            return "top";
        case (0, $lfkg1.PopoverPosition).TOP_RIGHT:
            return "top-end";
        case (0, $lfkg1.PopoverPosition).RIGHT_TOP:
            return "right-start";
        case (0, $lfkg1.PopoverPosition).RIGHT:
            return "right";
        case (0, $lfkg1.PopoverPosition).RIGHT_BOTTOM:
            return "right-end";
        case (0, $lfkg1.PopoverPosition).BOTTOM_RIGHT:
            return "bottom-end";
        case (0, $lfkg1.PopoverPosition).BOTTOM:
            return "bottom";
        case (0, $lfkg1.PopoverPosition).BOTTOM_LEFT:
            return "bottom-start";
        case (0, $lfkg1.PopoverPosition).LEFT_BOTTOM:
            return "left-end";
        case (0, $lfkg1.PopoverPosition).LEFT:
            return "left";
        case (0, $lfkg1.PopoverPosition).LEFT_TOP:
            return "left-start";
        case "auto":
        case "auto-start":
        case "auto-end":
            // Return the string unchanged.
            return position;
        default:
            return $8f8641ca77d03d1c$var$assertNever(position);
    }
}
/* istanbul ignore next */ function $8f8641ca77d03d1c$var$assertNever(x) {
    throw new Error("Unexpected position: " + x);
}

});
parcelRegister("lfkg1", function(module, exports) {

$parcel$export(module.exports, "PopoverPosition", () => $f77ab66960cc7d4f$export$2fdab12f67185662);
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $iGyED = parcelRequire("iGyED");
var $f77ab66960cc7d4f$export$2fdab12f67185662 = (0, $gztBd.__assign)((0, $gztBd.__assign)({}, (0, $iGyED.Position)), {
    AUTO: "auto",
    AUTO_END: "auto-end",
    AUTO_START: "auto-start"
});

});



parcelRegister("6vtLY", function(module, exports) {

$parcel$export(module.exports, "PopupKind", () => $4bccbb996d34bdb3$export$4d5c295289e9b3bf);
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Specifies the popup kind for [aria-haspopup](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-haspopup).
 */ var $4bccbb996d34bdb3$export$4d5c295289e9b3bf;
(function(PopupKind) {
    /** The popup is a menu. */ PopupKind["MENU"] = "menu";
    /** The popup is a listbox. */ PopupKind["LISTBOX"] = "listbox";
    /** The popup is a tree. */ PopupKind["TREE"] = "tree";
    /** The popup is a grid. */ PopupKind["GRID"] = "grid";
    /** The popup is a dialog. */ PopupKind["DIALOG"] = "dialog";
})($4bccbb996d34bdb3$export$4d5c295289e9b3bf || ($4bccbb996d34bdb3$export$4d5c295289e9b3bf = {}));

});

parcelRegister("lP8NJ", function(module, exports) {

$parcel$export(module.exports, "Cross", () => $fe35302149d821ac$export$3c877bb842c36952);
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $8NFma = parcelRequire("8NFma");

var $leH9B = parcelRequire("leH9B");

var $eog74 = parcelRequire("eog74");
var $fe35302149d821ac$export$3c877bb842c36952 = $8NFma.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, $leH9B.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, $leH9B.IconSize).LARGE : (0, $leH9B.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return $8NFma.createElement((0, $eog74.SVGIconContainer), (0, $gztBd.__assign)({
        iconName: "cross",
        ref: ref
    }, props), $8NFma.createElement("path", {
        d: isLarge ? "M228.2 200L314 285.8C317.8 289.4 320 294.4 320 300C320 311 311 320 300 320C294.4000000000001 320 289.4000000000001 317.8 285.8 314.2L200 228.2L114.2 314.2C110.6 317.8 105.6 320 100 320C89 320 80 311 80 300C80 294.4 82.2 289.4 85.8 285.8L171.8 200L86 114.2000000000001C82.2 110.6 80 105.6 80 100C80 89 89 80 100 80C105.6 80 110.6 82.2 114.2 85.8L200 171.8L285.8 86C289.4000000000001 82.2 294.4000000000001 80 300 80C311 80 320 89 320 100C320 105.6 317.8 110.6 314.2000000000001 114.2000000000001L228.2 200z" : "M188.2 160L254 225.8C257.8 229.4 260 234.4 260 240C260 251 251 260 240 260C234.4 260 229.4 257.8 225.8 254.2L160 188.2L94.2 254.2C90.6 257.8 85.6 260 80 260C69 260 60 251 60 240C60 234.4 62.2 229.4 65.8 225.8L131.8 160L66 94.2C62.2 90.6 60 85.6 60 80C60 69 69 60 80 60C85.6 60 90.6 62.2 94.2 65.8L160 131.8L225.8 66C229.4 62.2 234.4 60 240 60C251 60 260 69 260 80C260 85.6 257.8 90.6 254.2 94.2L188.2 160z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
$fe35302149d821ac$export$3c877bb842c36952.defaultProps = {
    size: (0, $leH9B.IconSize).STANDARD
};
$fe35302149d821ac$export$3c877bb842c36952.displayName = "Blueprint5.Icon.Cross";
var $fe35302149d821ac$export$2e2bcd8739ae039 = $fe35302149d821ac$export$3c877bb842c36952;

});

parcelRegister("cImER", function(module, exports) {

$parcel$export(module.exports, "Search", () => $941b2b7dd212c904$export$4b85d3515bd863a5);
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $8NFma = parcelRequire("8NFma");

var $leH9B = parcelRequire("leH9B");

var $eog74 = parcelRequire("eog74");
var $941b2b7dd212c904$export$4b85d3515bd863a5 = $8NFma.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, $leH9B.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, $leH9B.IconSize).LARGE : (0, $leH9B.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return $8NFma.createElement((0, $eog74.SVGIconContainer), (0, $gztBd.__assign)({
        iconName: "search",
        ref: ref
    }, props), $8NFma.createElement("path", {
        d: isLarge ? "M391.2 51.2L292.4 150C309.8 175.8 320 206.6 320 240C320 328.4 248.4 400 160 400S0 328.4 0 240S71.6 80 160 80C193.4 80 224.2 90.2 250 107.6L348.8 8.8C354.2000000000001 3.4 361.8 0 370 0C386.6 0 400 13.4 400 30C400 38.2 396.6 45.8 391.2 51.2zM160 120C93.8 120 40 173.8 40 240S93.8 360 160 360S280 306.2000000000001 280 240S226.2 120 160 120z" : "M311 51.4L257.6 105C271.6 126.8 279.8 152.6 279.8 180.2C279.8 257.6 217.2 320.2 139.8 320.2S-0.2 257.6 -0.2 180.2S62.4 40.2 139.8 40.2C167.6 40.2 193.4 48.6 215 62.4L268.6 9C274 3.6 281.6 0.2 289.8 0.2C306.4 0.2 319.8 13.6 319.8 30.2C319.8 38.4 316.4 46 311 51.4zM139.8 80.2C84.6 80.2 39.8 125 39.8 180.2S84.6 280.2 139.8 280.2S239.8 235.4 239.8 180.2S195 80.2 139.8 80.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
$941b2b7dd212c904$export$4b85d3515bd863a5.defaultProps = {
    size: (0, $leH9B.IconSize).STANDARD
};
$941b2b7dd212c904$export$4b85d3515bd863a5.displayName = "Blueprint5.Icon.Search";
var $941b2b7dd212c904$export$2e2bcd8739ae039 = $941b2b7dd212c904$export$4b85d3515bd863a5;

});

parcelRegister("2czyQ", function(module, exports) {

$parcel$export(module.exports, "MULTISELECT", () => $19a84974adfc9f9c$export$bba0e784b747d8d7);
$parcel$export(module.exports, "MULTISELECT_POPOVER", () => $19a84974adfc9f9c$export$fbebd36a6deaeedb);
$parcel$export(module.exports, "MULTISELECT_TAG_INPUT_INPUT", () => $19a84974adfc9f9c$export$473396dff47d182f);
$parcel$export(module.exports, "OMNIBAR", () => $19a84974adfc9f9c$export$4df213ae3a2d0138);
$parcel$export(module.exports, "OMNIBAR_OVERLAY", () => $19a84974adfc9f9c$export$13ef787e18d22080);
$parcel$export(module.exports, "SELECT_POPOVER", () => $19a84974adfc9f9c$export$77109d4160ed3ec7);
$parcel$export(module.exports, "SUGGEST_POPOVER", () => $19a84974adfc9f9c$export$afb47d2c172a4cf);
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $4Aw5U = parcelRequire("4Aw5U");
var $19a84974adfc9f9c$var$NS = (0, $4Aw5U).getClassNamespace();
var $19a84974adfc9f9c$export$bba0e784b747d8d7 = "".concat($19a84974adfc9f9c$var$NS, "-multi-select");
var $19a84974adfc9f9c$export$fbebd36a6deaeedb = "".concat($19a84974adfc9f9c$export$bba0e784b747d8d7, "-popover");
var $19a84974adfc9f9c$export$473396dff47d182f = "".concat($19a84974adfc9f9c$export$bba0e784b747d8d7, "-tag-input-input");
var $19a84974adfc9f9c$export$4df213ae3a2d0138 = "".concat($19a84974adfc9f9c$var$NS, "-omnibar");
var $19a84974adfc9f9c$export$13ef787e18d22080 = "".concat($19a84974adfc9f9c$export$4df213ae3a2d0138, "-overlay");
var $19a84974adfc9f9c$export$77109d4160ed3ec7 = "".concat($19a84974adfc9f9c$var$NS, "-select-popover");
var $19a84974adfc9f9c$export$afb47d2c172a4cf = "".concat($19a84974adfc9f9c$var$NS, "-suggest-popover");

});

parcelRegister("cNy3O", function(module, exports) {

$parcel$export(module.exports, "QueryList", () => $95147b5dc785d25b$export$53fc189dda010966);
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $8NFma = parcelRequire("8NFma");

var $a3mBX = parcelRequire("a3mBX");
var $3lvnD = parcelRequire("3lvnD");
var $atiSU = parcelRequire("atiSU");
var $mqBXU = parcelRequire("mqBXU");

var $c2t3t = parcelRequire("c2t3t");
var $jHn5e = parcelRequire("jHn5e");
var $ecIOC = parcelRequire("ecIOC");
/**
 * Query list component.
 *
 * @see https://blueprintjs.com/docs/#select/query-list
 */ var $95147b5dc785d25b$export$53fc189dda010966 = /** @class */ function(_super) {
    (0, $gztBd.__extends)(QueryList, _super);
    function QueryList(props) {
        var _a, _b;
        var _this = _super.call(this, props) || this;
        _this.itemRefs = new Map();
        _this.refHandlers = {
            itemsParent: function(ref) {
                return _this.itemsParentRef = ref;
            }
        };
        /**
         * Flag indicating that we should check whether selected item is in viewport
         * after rendering, typically because of keyboard change. Set to `true` when
         * manipulating state in a way that may cause active item to scroll away.
         */ _this.shouldCheckActiveItemInViewport = false;
        /**
         * The item that we expect to be the next selected active item (based on click
         * or key interactions). When scrollToActiveItem = false, used to detect if
         * an unexpected external change to the active item has been made.
         */ _this.expectedNextActiveItem = null;
        /**
         * Flag which is set to true while in between an ENTER "keydown" event and its
         * corresponding "keyup" event.
         *
         * When entering text via an IME (https://en.wikipedia.org/wiki/Input_method),
         * the ENTER key is pressed to confirm the character(s) to be input from a list
         * of options. The operating system intercepts the ENTER "keydown" event and
         * prevents it from propagating to the application, but "keyup" is still
         * fired, triggering a spurious event which this component does not expect.
         *
         * To work around this quirk, we keep track of "real" key presses by setting
         * this flag in handleKeyDown.
         */ _this.isEnterKeyPressed = false;
        /** default `itemListRenderer` implementation */ _this.renderItemList = function(listProps) {
            var _a = _this.props, initialContent = _a.initialContent, noResults = _a.noResults;
            // omit noResults if createNewItemFromQuery and createNewItemRenderer are both supplied, and query is not empty
            var createItemView = listProps.renderCreateItem();
            var maybeNoResults = createItemView != null ? null : noResults;
            var menuContent = (0, $ecIOC.renderFilteredItems)(listProps, maybeNoResults, initialContent);
            if (menuContent == null && createItemView == null) return null;
            var createFirst = _this.isCreateItemFirst();
            return $8NFma.createElement((0, $atiSU.Menu), (0, $gztBd.__assign)({
                role: "listbox"
            }, listProps.menuProps, {
                ulRef: listProps.itemsParentRef
            }), createFirst && createItemView, menuContent, !createFirst && createItemView);
        };
        /** wrapper around `itemRenderer` to inject props */ _this.renderItem = function(item, index) {
            if (_this.props.disabled !== true) {
                var _a = _this.state, activeItem = _a.activeItem, query = _a.query, filteredItems = _a.filteredItems;
                var modifiers = {
                    active: (0, $c2t3t.executeItemsEqual)(_this.props.itemsEqual, (0, $jHn5e.getActiveItem)(activeItem), item),
                    disabled: $95147b5dc785d25b$var$isItemDisabled(item, index, _this.props.itemDisabled),
                    matchesPredicate: filteredItems.indexOf(item) >= 0
                };
                return _this.props.itemRenderer(item, {
                    handleClick: function(e) {
                        return _this.handleItemSelect(item, e);
                    },
                    handleFocus: function() {
                        return _this.setActiveItem(item);
                    },
                    index: index,
                    modifiers: modifiers,
                    query: query,
                    ref: function(node) {
                        if (node) _this.itemRefs.set(index, node);
                        else _this.itemRefs.delete(index);
                    }
                });
            }
            return null;
        };
        _this.renderCreateItemMenuItem = function() {
            if (_this.isCreateItemRendered(_this.state.createNewItem)) {
                var _a = _this.state, activeItem = _a.activeItem, query = _a.query;
                var trimmedQuery_1 = query.trim();
                var handleClick = function(evt) {
                    _this.handleItemCreate(trimmedQuery_1, evt);
                };
                var isActive = (0, $jHn5e.isCreateNewItem)(activeItem);
                return _this.props.createNewItemRenderer(trimmedQuery_1, isActive, handleClick);
            }
            return null;
        };
        _this.handleItemCreate = function(query, evt) {
            var _a, _b, _c, _d;
            // we keep a cached createNewItem in state, but might as well recompute
            // the result just to be sure it's perfectly in sync with the query.
            var value = (_b = (_a = _this.props).createNewItemFromQuery) === null || _b === void 0 ? void 0 : _b.call(_a, query);
            if (value != null) {
                var newItems = Array.isArray(value) ? value : [
                    value
                ];
                for(var _i = 0, newItems_1 = newItems; _i < newItems_1.length; _i++){
                    var item = newItems_1[_i];
                    (_d = (_c = _this.props).onItemSelect) === null || _d === void 0 || _d.call(_c, item, evt);
                }
                _this.maybeResetQuery();
            }
        };
        _this.handleItemSelect = function(item, event) {
            var _a, _b;
            _this.setActiveItem(item);
            (_b = (_a = _this.props).onItemSelect) === null || _b === void 0 || _b.call(_a, item, event);
            _this.maybeResetQuery();
        };
        _this.handlePaste = function(queries) {
            var _a = _this.props, createNewItemFromQuery = _a.createNewItemFromQuery, onItemsPaste = _a.onItemsPaste;
            var nextActiveItem;
            var nextQueries = [];
            // Find an exising item that exactly matches each pasted value, or
            // create a new item if possible. Ignore unmatched values if creating
            // items is disabled.
            var pastedItemsToEmit = [];
            for(var _i = 0, queries_1 = queries; _i < queries_1.length; _i++){
                var query = queries_1[_i];
                var equalItem = $95147b5dc785d25b$var$getMatchingItem(query, _this.props);
                if (equalItem !== undefined) {
                    nextActiveItem = equalItem;
                    pastedItemsToEmit.push(equalItem);
                } else if (_this.canCreateItems()) {
                    var value = createNewItemFromQuery === null || createNewItemFromQuery === void 0 ? void 0 : createNewItemFromQuery(query);
                    if (value !== undefined) {
                        var newItems = Array.isArray(value) ? value : [
                            value
                        ];
                        pastedItemsToEmit.push.apply(pastedItemsToEmit, newItems);
                    }
                } else nextQueries.push(query);
            }
            // UX nicety: combine all unmatched queries into a single
            // comma-separated query in the input, so we don't lose any information.
            // And don't reset the active item; we'll do that ourselves below.
            _this.setQuery(nextQueries.join(", "), false);
            // UX nicety: update the active item if we matched with at least one
            // existing item.
            if (nextActiveItem !== undefined) _this.setActiveItem(nextActiveItem);
            onItemsPaste === null || onItemsPaste === void 0 || onItemsPaste(pastedItemsToEmit);
        };
        _this.handleKeyDown = function(event) {
            var _a, _b;
            var key = event.key;
            if (key === "ArrowUp" || key === "ArrowDown") {
                event.preventDefault();
                var nextActiveItem = _this.getNextActiveItem(key === "ArrowUp" ? -1 : 1);
                if (nextActiveItem != null) _this.setActiveItem(nextActiveItem);
            } else if (key === "Enter") _this.isEnterKeyPressed = true;
            (_b = (_a = _this.props).onKeyDown) === null || _b === void 0 || _b.call(_a, event);
        };
        _this.handleKeyUp = function(event) {
            var onKeyUp = _this.props.onKeyUp;
            var activeItem = _this.state.activeItem;
            if (event.key === "Enter" && _this.isEnterKeyPressed) {
                // We handle ENTER in keyup here to play nice with the Button component's keyboard
                // clicking. Button is commonly used as the only child of Select. If we were to
                // instead process ENTER on keydown, then Button would click itself on keyup and
                // the Select popover would re-open.
                event.preventDefault();
                if (activeItem == null || (0, $jHn5e.isCreateNewItem)(activeItem)) _this.handleItemCreate(_this.state.query, event);
                else _this.handleItemSelect(activeItem, event);
                _this.isEnterKeyPressed = false;
            }
            onKeyUp === null || onKeyUp === void 0 || onKeyUp(event);
        };
        _this.handleInputQueryChange = function(event) {
            var _a, _b;
            var query = event == null ? "" : event.target.value;
            _this.setQuery(query);
            (_b = (_a = _this.props).onQueryChange) === null || _b === void 0 || _b.call(_a, query, event);
        };
        var _c = props.query, query = _c === void 0 ? "" : _c;
        var createNewItem = (_a = props.createNewItemFromQuery) === null || _a === void 0 ? void 0 : _a.call(props, query);
        var filteredItems = $95147b5dc785d25b$var$getFilteredItems(query, props);
        _this.state = {
            activeItem: props.activeItem !== undefined ? props.activeItem : (_b = props.initialActiveItem) !== null && _b !== void 0 ? _b : $95147b5dc785d25b$export$db4cfd88d8087392(filteredItems, props.itemDisabled),
            createNewItem: createNewItem,
            filteredItems: filteredItems,
            query: query
        };
        return _this;
    }
    /** @deprecated no longer necessary now that the TypeScript parser supports type arguments on JSX element tags */ QueryList.ofType = function() {
        return QueryList;
    };
    QueryList.prototype.render = function() {
        var _a = this.props, className = _a.className, items = _a.items, renderer = _a.renderer, _b = _a.itemListRenderer, itemListRenderer = _b === void 0 ? this.renderItemList : _b, menuProps = _a.menuProps;
        var _c = this.state, createNewItem = _c.createNewItem, spreadableState = (0, $gztBd.__rest)(_c, [
            "createNewItem"
        ]);
        return renderer((0, $gztBd.__assign)((0, $gztBd.__assign)({}, spreadableState), {
            className: className,
            handleItemSelect: this.handleItemSelect,
            handleKeyDown: this.handleKeyDown,
            handleKeyUp: this.handleKeyUp,
            handlePaste: this.handlePaste,
            handleQueryChange: this.handleInputQueryChange,
            itemList: itemListRenderer((0, $gztBd.__assign)((0, $gztBd.__assign)({}, spreadableState), {
                items: items,
                itemsParentRef: this.refHandlers.itemsParent,
                menuProps: menuProps,
                renderCreateItem: this.renderCreateItemMenuItem,
                renderItem: this.renderItem
            }))
        }));
    };
    QueryList.prototype.componentDidUpdate = function(prevProps) {
        var _this = this;
        if (this.props.activeItem !== undefined && this.props.activeItem !== this.state.activeItem) {
            this.shouldCheckActiveItemInViewport = true;
            this.setState({
                activeItem: this.props.activeItem
            });
        }
        if (this.props.query != null && this.props.query !== prevProps.query) // new query
        this.setQuery(this.props.query, this.props.resetOnQuery, this.props);
        else if (// same query (or uncontrolled query), but items in the list changed
        !(0, $mqBXU).shallowCompareKeys(this.props, prevProps, {
            include: [
                "items",
                "itemListPredicate",
                "itemPredicate"
            ]
        })) this.setQuery(this.state.query);
        if (this.shouldCheckActiveItemInViewport) {
            // update scroll position immediately before repaint so DOM is accurate
            // (latest filteredItems) and to avoid flicker.
            this.requestAnimationFrame(function() {
                return _this.scrollActiveItemIntoView();
            });
            // reset the flag
            this.shouldCheckActiveItemInViewport = false;
        }
    };
    QueryList.prototype.scrollActiveItemIntoView = function() {
        var scrollToActiveItem = this.props.scrollToActiveItem !== false;
        var externalChangeToActiveItem = !(0, $c2t3t.executeItemsEqual)(this.props.itemsEqual, (0, $jHn5e.getActiveItem)(this.expectedNextActiveItem), (0, $jHn5e.getActiveItem)(this.props.activeItem));
        this.expectedNextActiveItem = null;
        if (!scrollToActiveItem && externalChangeToActiveItem) return;
        var activeElement = this.getActiveElement();
        if (this.itemsParentRef != null && activeElement != null) {
            var activeTop = activeElement.offsetTop, activeHeight = activeElement.offsetHeight;
            var _a = this.itemsParentRef, parentOffsetTop = _a.offsetTop, parentScrollTop = _a.scrollTop, parentHeight = _a.clientHeight;
            // compute padding on parent element to ensure we always leave space
            var _b = this.getItemsParentPadding(), paddingTop = _b.paddingTop, paddingBottom = _b.paddingBottom;
            // compute the two edges of the active item for comparison, including parent padding
            var activeBottomEdge = activeTop + activeHeight + paddingBottom - parentOffsetTop;
            var activeTopEdge = activeTop - paddingTop - parentOffsetTop;
            if (activeBottomEdge >= parentScrollTop + parentHeight) // offscreen bottom: align bottom of item with bottom of viewport
            this.itemsParentRef.scrollTop = activeBottomEdge + activeHeight - parentHeight;
            else if (activeTopEdge <= parentScrollTop) // offscreen top: align top of item with top of viewport
            this.itemsParentRef.scrollTop = activeTopEdge - activeHeight;
        }
    };
    QueryList.prototype.setQuery = function(query, resetActiveItem, props) {
        var _a;
        if (resetActiveItem === void 0) resetActiveItem = this.props.resetOnQuery;
        if (props === void 0) props = this.props;
        var createNewItemFromQuery = props.createNewItemFromQuery;
        this.shouldCheckActiveItemInViewport = true;
        var hasQueryChanged = query !== this.state.query;
        if (hasQueryChanged) (_a = props.onQueryChange) === null || _a === void 0 || _a.call(props, query);
        // Leading and trailing whitespace can be confusing to display, so we remove it when passing it
        // to functions dealing with data, like createNewItemFromQuery. But we need the unaltered user-typed
        // query to remain in state to be able to render controlled text inputs properly.
        var trimmedQuery = query.trim();
        var filteredItems = $95147b5dc785d25b$var$getFilteredItems(trimmedQuery, props);
        var createNewItem = createNewItemFromQuery != null && trimmedQuery !== "" ? createNewItemFromQuery(trimmedQuery) : undefined;
        this.setState({
            createNewItem: createNewItem,
            filteredItems: filteredItems,
            query: query
        });
        // always reset active item if it's now filtered or disabled
        var activeIndex = this.getActiveIndex(filteredItems);
        var shouldUpdateActiveItem = resetActiveItem || activeIndex < 0 || $95147b5dc785d25b$var$isItemDisabled((0, $jHn5e.getActiveItem)(this.state.activeItem), activeIndex, props.itemDisabled);
        if (shouldUpdateActiveItem) {
            // if the `createNewItem` is first, that should be the first active item.
            if (this.isCreateItemRendered(createNewItem) && this.isCreateItemFirst()) this.setActiveItem((0, $jHn5e.getCreateNewItem)());
            else this.setActiveItem($95147b5dc785d25b$export$db4cfd88d8087392(filteredItems, props.itemDisabled));
        }
    };
    QueryList.prototype.setActiveItem = function(activeItem) {
        var _a, _b, _c, _d;
        this.expectedNextActiveItem = activeItem;
        if (this.props.activeItem === undefined) {
            // indicate that the active item may need to be scrolled into view after update.
            this.shouldCheckActiveItemInViewport = true;
            this.setState({
                activeItem: activeItem
            });
        }
        if ((0, $jHn5e.isCreateNewItem)(activeItem)) (_b = (_a = this.props).onActiveItemChange) === null || _b === void 0 || _b.call(_a, null, true);
        else (_d = (_c = this.props).onActiveItemChange) === null || _d === void 0 || _d.call(_c, activeItem, false);
    };
    QueryList.prototype.getActiveElement = function() {
        var _a;
        var activeItem = this.state.activeItem;
        if (this.itemsParentRef != null) {
            if ((0, $jHn5e.isCreateNewItem)(activeItem)) {
                var index = this.isCreateItemFirst() ? 0 : this.state.filteredItems.length;
                return this.itemsParentRef.children.item(index);
            } else {
                var activeIndex = this.getActiveIndex();
                return (_a = this.itemRefs.get(activeIndex)) !== null && _a !== void 0 ? _a : this.itemsParentRef.children.item(activeIndex);
            }
        }
        return undefined;
    };
    QueryList.prototype.getActiveIndex = function(items) {
        if (items === void 0) items = this.state.filteredItems;
        var activeItem = this.state.activeItem;
        if (activeItem == null || (0, $jHn5e.isCreateNewItem)(activeItem)) return -1;
        // NOTE: this operation is O(n) so it should be avoided in render(). safe for events though.
        for(var i = 0; i < items.length; ++i){
            if ((0, $c2t3t.executeItemsEqual)(this.props.itemsEqual, items[i], activeItem)) return i;
        }
        return -1;
    };
    QueryList.prototype.getItemsParentPadding = function() {
        // assert ref exists because it was checked before calling
        var _a = getComputedStyle(this.itemsParentRef), paddingTop = _a.paddingTop, paddingBottom = _a.paddingBottom;
        return {
            paddingBottom: $95147b5dc785d25b$var$pxToNumber(paddingBottom),
            paddingTop: $95147b5dc785d25b$var$pxToNumber(paddingTop)
        };
    };
    /**
     * Get the next enabled item, moving in the given direction from the start
     * index. A `null` return value means no suitable item was found.
     *
     * @param direction amount to move in each iteration, typically +/-1
     * @param startIndex item to start iteration
     */ QueryList.prototype.getNextActiveItem = function(direction, startIndex) {
        if (startIndex === void 0) startIndex = this.getActiveIndex();
        if (this.isCreateItemRendered(this.state.createNewItem)) {
            var reachedCreate = startIndex === 0 && direction === -1 || startIndex === this.state.filteredItems.length - 1 && direction === 1;
            if (reachedCreate) return (0, $jHn5e.getCreateNewItem)();
        }
        return $95147b5dc785d25b$export$db4cfd88d8087392(this.state.filteredItems, this.props.itemDisabled, direction, startIndex);
    };
    /**
     * @param createNewItem Checks if this item would match the current query. Cannot check this.state.createNewItem
     *  every time since state may not have been updated yet.
     */ QueryList.prototype.isCreateItemRendered = function(createNewItem) {
        return this.canCreateItems() && this.state.query !== "" && // this check is unfortunately O(N) on the number of items, but
        // alas, hiding the "Create Item" option when it exactly matches an
        // existing item is much clearer.
        !this.wouldCreatedItemMatchSomeExistingItem(createNewItem);
    };
    QueryList.prototype.isCreateItemFirst = function() {
        return this.props.createNewItemPosition === "first";
    };
    QueryList.prototype.canCreateItems = function() {
        return this.props.createNewItemFromQuery != null && this.props.createNewItemRenderer != null;
    };
    QueryList.prototype.wouldCreatedItemMatchSomeExistingItem = function(createNewItem) {
        var _this = this;
        // search only the filtered items, not the full items list, because we
        // only need to check items that match the current query.
        return this.state.filteredItems.some(function(item) {
            var newItems = Array.isArray(createNewItem) ? createNewItem : [
                createNewItem
            ];
            return newItems.some(function(newItem) {
                return (0, $c2t3t.executeItemsEqual)(_this.props.itemsEqual, item, newItem);
            });
        });
    };
    QueryList.prototype.maybeResetQuery = function() {
        if (this.props.resetOnSelect) this.setQuery("", true);
    };
    QueryList.displayName = "".concat((0, $3lvnD.DISPLAYNAME_PREFIX), ".QueryList");
    QueryList.defaultProps = {
        disabled: false,
        resetOnQuery: true
    };
    return QueryList;
}((0, $a3mBX.AbstractComponent));
function $95147b5dc785d25b$var$pxToNumber(value) {
    return value == null ? 0 : parseInt(value.slice(0, -2), 10);
}
function $95147b5dc785d25b$var$getMatchingItem(query, _a) {
    var items = _a.items, itemPredicate = _a.itemPredicate;
    if ((0, $mqBXU).isFunction(itemPredicate)) // .find() doesn't exist in ES5. Alternative: use a for loop instead of
    // .filter() so that we can return as soon as we find the first match.
    for(var i = 0; i < items.length; i++){
        var item = items[i];
        if (itemPredicate(query, item, i, true)) return item;
    }
    return undefined;
}
function $95147b5dc785d25b$var$getFilteredItems(query, _a) {
    var items = _a.items, itemPredicate = _a.itemPredicate, itemListPredicate = _a.itemListPredicate;
    if ((0, $mqBXU).isFunction(itemListPredicate)) // note that implementations can reorder the items here
    return itemListPredicate(query, items);
    else if ((0, $mqBXU).isFunction(itemPredicate)) return items.filter(function(item, index) {
        return itemPredicate(query, item, index);
    });
    return items;
}
/** Wrap number around min/max values: if it exceeds one bound, return the other. */ function $95147b5dc785d25b$var$wrapNumber(value, min, max) {
    if (value < min) return max;
    else if (value > max) return min;
    return value;
}
function $95147b5dc785d25b$var$isItemDisabled(item, index, itemDisabled) {
    if (itemDisabled == null || item == null) return false;
    else if ((0, $mqBXU).isFunction(itemDisabled)) return itemDisabled(item, index);
    return !!item[itemDisabled];
}
function $95147b5dc785d25b$export$db4cfd88d8087392(items, itemDisabled, direction, startIndex) {
    if (direction === void 0) direction = 1;
    if (startIndex === void 0) startIndex = items.length - 1;
    if (items.length === 0) return null;
    // remember where we started to prevent an infinite loop
    var index = startIndex;
    var maxIndex = items.length - 1;
    do {
        // find first non-disabled item
        index = $95147b5dc785d25b$var$wrapNumber(index + direction, 0, maxIndex);
        if (!$95147b5dc785d25b$var$isItemDisabled(items[index], index, itemDisabled)) return items[index];
    }while (index !== startIndex && startIndex !== -1);
    return null;
}

});
parcelRegister("a3mBX", function(module, exports) {

$parcel$export(module.exports, "AbstractComponent", () => $751bb94a779356a0$export$ca6a3753167de7aa);
/*
 * Copyright 2019 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $8NFma = parcelRequire("8NFma");

var $3T4CC = parcelRequire("3T4CC");
/**
 * An abstract component that Blueprint components can extend
 * in order to add some common functionality like runtime props validation.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
var $751bb94a779356a0$export$ca6a3753167de7aa = /** @class */ function(_super) {
    (0, $gztBd.__extends)(AbstractComponent, _super);
    function AbstractComponent(props) {
        var _this = _super.call(this, props) || this;
        // Not bothering to remove entries when their timeouts finish because clearing invalid ID is a no-op
        _this.timeoutIds = [];
        _this.requestIds = [];
        /**
         * Clear all known timeouts.
         */ _this.clearTimeouts = function() {
            if (_this.timeoutIds.length > 0) {
                for(var _i = 0, _a = _this.timeoutIds; _i < _a.length; _i++){
                    var timeoutId = _a[_i];
                    window.clearTimeout(timeoutId);
                }
                _this.timeoutIds = [];
            }
        };
        /**
         * Clear all known animation frame requests.
         */ _this.cancelAnimationFrames = function() {
            if (_this.requestIds.length > 0) {
                for(var _i = 0, _a = _this.requestIds; _i < _a.length; _i++){
                    var requestId = _a[_i];
                    window.cancelAnimationFrame(requestId);
                }
                _this.requestIds = [];
            }
        };
        if (!(0, $3T4CC.isNodeEnv)("production")) _this.validateProps(_this.props);
        return _this;
    }
    AbstractComponent.prototype.componentDidUpdate = function(_prevProps, _prevState, _snapshot) {
        if (!(0, $3T4CC.isNodeEnv)("production")) this.validateProps(this.props);
    };
    AbstractComponent.prototype.componentWillUnmount = function() {
        this.clearTimeouts();
        this.cancelAnimationFrames();
    };
    /**
     * Request an animation frame and remember its ID.
     * All pending requests will be canceled when component unmounts.
     *
     * @returns a "cancel" function that will cancel the request when invoked.
     */ AbstractComponent.prototype.requestAnimationFrame = function(callback) {
        var handle = window.requestAnimationFrame(callback);
        this.requestIds.push(handle);
        return function() {
            return window.cancelAnimationFrame(handle);
        };
    };
    /**
     * Set a timeout and remember its ID.
     * All stored timeouts will be cleared when component unmounts.
     *
     * @returns a "cancel" function that will clear timeout when invoked.
     */ AbstractComponent.prototype.setTimeout = function(callback, timeout) {
        var handle = window.setTimeout(callback, timeout);
        this.timeoutIds.push(handle);
        return function() {
            return window.clearTimeout(handle);
        };
    };
    /**
     * Ensures that the props specified for a component are valid.
     * Implementations should check that props are valid and usually throw an Error if they are not.
     * Implementations should not duplicate checks that the type system already guarantees.
     *
     * This method should be used instead of React's
     * [propTypes](https://facebook.github.io/react/docs/reusable-components.html#prop-validation) feature.
     * Like propTypes, these runtime checks run only in development mode.
     */ AbstractComponent.prototype.validateProps = function(_props) {
    // implement in subclass
    };
    return AbstractComponent;
}($8NFma.Component);

});

parcelRegister("atiSU", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $79fb42e8dbb5345b$export$d9b273488cd8ce6f);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $88643 = parcelRequire("88643");
var $4Aw5U = parcelRequire("4Aw5U");

var $3lvnD = parcelRequire("3lvnD");
/**
 * Menu component.
 *
 * @see https://blueprintjs.com/docs/#core/components/menu
 */ var $79fb42e8dbb5345b$export$d9b273488cd8ce6f = /** @class */ function(_super) {
    (0, $gztBd.__extends)(Menu, _super);
    function Menu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Menu.prototype.render = function() {
        var _a;
        var _b = this.props, className = _b.className, children = _b.children, large = _b.large, small = _b.small, ulRef = _b.ulRef, htmlProps = (0, $gztBd.__rest)(_b, [
            "className",
            "children",
            "large",
            "small",
            "ulRef"
        ]);
        var classes = (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(className, (0, $4Aw5U).MENU, (_a = {}, _a[(0, $4Aw5U).LARGE] = large, _a[(0, $4Aw5U).SMALL] = small, _a));
        return $8NFma.createElement("ul", (0, $gztBd.__assign)({
            role: "menu"
        }, htmlProps, {
            className: classes,
            ref: ulRef
        }), children);
    };
    Menu.displayName = "".concat((0, $3lvnD.DISPLAYNAME_PREFIX), ".Menu");
    return Menu;
}((0, $88643.AbstractPureComponent));

});

parcelRegister("c2t3t", function(module, exports) {

$parcel$export(module.exports, "executeItemsEqual", () => $8c3c35a9912a5e02$export$4dd70a7c4549164b);
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $mqBXU = parcelRequire("mqBXU");
function $8c3c35a9912a5e02$export$4dd70a7c4549164b(itemsEqualProp, itemA, itemB) {
    // Use strict equality if:
    // A) Default equality check is necessary because itemsEqualProp is undefined.
    // OR
    // B) Either item is null/undefined. Note that null represents "no item", while
    //    undefined represents an uncontrolled prop. This strict equality check ensures
    //    nothing will ever be considered equivalent to an uncontrolled prop.
    if (itemsEqualProp === undefined || itemA == null || itemB == null) return itemA === itemB;
    if ((0, $mqBXU).isFunction(itemsEqualProp)) // itemsEqualProp is an equality comparator function, so use it
    return itemsEqualProp(itemA, itemB);
    else // itemsEqualProp is a property name, so strictly compare the values of the property.
    return itemA[itemsEqualProp] === itemB[itemsEqualProp];
}

});

parcelRegister("jHn5e", function(module, exports) {

$parcel$export(module.exports, "getCreateNewItem", () => $e573f05b12a72765$export$3af999347d244081);
$parcel$export(module.exports, "isCreateNewItem", () => $e573f05b12a72765$export$34f76065d3c0d679);
$parcel$export(module.exports, "getActiveItem", () => $e573f05b12a72765$export$f0f14253205ef68f);
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns an instance of a "Create Item" object. */ function $e573f05b12a72765$export$3af999347d244081() {
    return {
        __blueprintCreateNewItemBrand: "blueprint-create-new-item"
    };
}
function $e573f05b12a72765$export$34f76065d3c0d679(item) {
    if (item == null) return false;
    // see if the provided item exactly matches the `CreateNewItem` object,
    // with no superfluous keys.
    var keys = Object.keys(item);
    if (keys.length !== 1 || keys[0] !== "__blueprintCreateNewItemBrand") return false;
    return item.__blueprintCreateNewItemBrand === "blueprint-create-new-item";
}
function $e573f05b12a72765$export$f0f14253205ef68f(activeItem) {
    return activeItem == null || $e573f05b12a72765$export$34f76065d3c0d679(activeItem) ? null : activeItem;
}

});

parcelRegister("ecIOC", function(module, exports) {

$parcel$export(module.exports, "renderFilteredItems", () => $a574f3142afd2b66$export$f58d484c96d9e9e6);
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * `ItemListRenderer` helper method for rendering each item in `filteredItems`,
 * with optional support for `noResults` (when filtered items is empty)
 * and `initialContent` (when query is empty).
 */ function $a574f3142afd2b66$export$f58d484c96d9e9e6(props, noResults, initialContent) {
    if (props.query.length === 0 && initialContent !== undefined) return initialContent;
    var items = props.filteredItems.map(props.renderItem).filter(function(item) {
        return item != null;
    });
    return items.length > 0 ? items : noResults;
}

});




parcelRegister("8tTZP", function(module, exports) {
parcelRequire("kNUzI");
var $3H1D6 = parcelRequire("3H1D6");
var $62cc77dbf1347b0f$require$GenIcon = $3H1D6.GenIcon;
module.exports = function(props) {
    return $62cc77dbf1347b0f$require$GenIcon({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "id": "mdi-format-line-spacing",
            "viewBox": "0 0 24 24",
            "fill": "currentColor"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10,13H22V11H10M10,19H22V17H10M10,7H22V5H10M6,7H8.5L5,3.5L1.5,7H4V17H1.5L5,20.5L8.5,17H6V7Z"
                }
            }
        ]
    })(props);
};

});

parcelRegister("elb7z", function(module, exports) {
parcelRequire("kNUzI");
var $3H1D6 = parcelRequire("3H1D6");
var $a70ba746d1484f54$require$GenIcon = $3H1D6.GenIcon;
module.exports = function(props) {
    return $a70ba746d1484f54$require$GenIcon({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "id": "mdi-format-vertical-align-top",
            "viewBox": "0 0 24 24",
            "fill": "currentColor"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8,11H11V21H13V11H16L12,7L8,11M4,3V5H20V3H4Z"
                }
            }
        ]
    })(props);
};

});

parcelRegister("8JhES", function(module, exports) {
parcelRequire("kNUzI");
var $3H1D6 = parcelRequire("3H1D6");
var $65b039497f0b4111$require$GenIcon = $3H1D6.GenIcon;
module.exports = function(props) {
    return $65b039497f0b4111$require$GenIcon({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "id": "mdi-format-vertical-align-center",
            "viewBox": "0 0 24 24",
            "fill": "currentColor"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8,19H11V23H13V19H16L12,15L8,19M16,5H13V1H11V5H8L12,9L16,5M4,11V13H20V11H4Z"
                }
            }
        ]
    })(props);
};

});

parcelRegister("eVEQI", function(module, exports) {
parcelRequire("kNUzI");
var $3H1D6 = parcelRequire("3H1D6");
var $ade61364573ce53f$require$GenIcon = $3H1D6.GenIcon;
module.exports = function(props) {
    return $ade61364573ce53f$require$GenIcon({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "id": "mdi-format-vertical-align-bottom",
            "viewBox": "0 0 24 24",
            "fill": "currentColor"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16,13H13V3H11V13H8L12,17L16,13M4,19V21H20V19H4Z"
                }
            }
        ]
    })(props);
};

});


parcelRegister("6BBEN", function(module, exports) {
"use strict";
var $4cf368af09439e86$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.HtmlToolbar = module.exports.DirectionInput = module.exports.FontColorInput = module.exports.FontStyleGroup = module.exports.FontSizeInput = void 0;

const $4cf368af09439e86$var$react_1 = $4cf368af09439e86$var$__importDefault((parcelRequire("8NFma")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

var $gUePa = parcelRequire("gUePa");
var $5tI5p = parcelRequire("5tI5p");
var $cQj25 = parcelRequire("cQj25");

var $1hndE = parcelRequire("1hndE");

const $4cf368af09439e86$var$color_picker_1 = $4cf368af09439e86$var$__importDefault((parcelRequire("gaqum")));

const $4cf368af09439e86$var$filters_picker_1 = $4cf368af09439e86$var$__importDefault((parcelRequire("hPyFl")));

const $4cf368af09439e86$var$MdFormatTextdirectionRToL_1 = $4cf368af09439e86$var$__importDefault((parcelRequire("dRXPx")));

const $4cf368af09439e86$var$MdFormatTextdirectionLToR_1 = $4cf368af09439e86$var$__importDefault((parcelRequire("74nEV")));

const $4cf368af09439e86$var$MdcFormatVerticalAlignTop_1 = $4cf368af09439e86$var$__importDefault((parcelRequire("elb7z")));

const $4cf368af09439e86$var$MdcFormatVerticalAlignCenter_1 = $4cf368af09439e86$var$__importDefault((parcelRequire("8JhES")));

const $4cf368af09439e86$var$MdcFormatVerticalAlignBottom_1 = $4cf368af09439e86$var$__importDefault((parcelRequire("eVEQI")));

var $45tk4 = parcelRequire("45tk4");

var $gS5ZA = parcelRequire("gS5ZA");

var $1gtCb = parcelRequire("1gtCb");

var $9mdgj = parcelRequire("9mdgj");
module.exports.FontSizeInput = (0, $O1ETn.observer)(({ element: e })=>$4cf368af09439e86$var$react_1.default.createElement($cQj25.NumericInput, {
        onValueChange: (t)=>{
            e.set({
                fontSize: t
            });
        },
        value: Math.round(e.fontSize),
        style: {
            width: "50px"
        },
        min: 5
    }));
const $4cf368af09439e86$var$ALIGN_OPTIONS = [
    "left",
    "center",
    "right",
    "justify"
], $4cf368af09439e86$var$VERTICAL_ALIGN_OPTIONS = [
    "top",
    "middle",
    "bottom"
], $4cf368af09439e86$var$VERTICAL_ALIGN_ICONS = {
    top: $4cf368af09439e86$var$react_1.default.createElement("span", {
        className: "bp5-icon"
    }, $4cf368af09439e86$var$react_1.default.createElement($4cf368af09439e86$var$MdcFormatVerticalAlignTop_1.default, null)),
    middle: $4cf368af09439e86$var$react_1.default.createElement("span", {
        className: "bp5-icon"
    }, $4cf368af09439e86$var$react_1.default.createElement($4cf368af09439e86$var$MdcFormatVerticalAlignCenter_1.default, null)),
    bottom: $4cf368af09439e86$var$react_1.default.createElement("span", {
        className: "bp5-icon"
    }, $4cf368af09439e86$var$react_1.default.createElement($4cf368af09439e86$var$MdcFormatVerticalAlignBottom_1.default, null))
};
module.exports.FontStyleGroup = (0, $O1ETn.observer)(({ element: e, store: t })=>$4cf368af09439e86$var$react_1.default.createElement($5tI5p.ButtonGroup, null, $4cf368af09439e86$var$react_1.default.createElement($gUePa.Button, {
        minimal: !0,
        icon: "align-" + e.align,
        onClick: ()=>{
            const t = ($4cf368af09439e86$var$ALIGN_OPTIONS.indexOf(e.align) + 1 + $4cf368af09439e86$var$ALIGN_OPTIONS.length) % $4cf368af09439e86$var$ALIGN_OPTIONS.length, n = $4cf368af09439e86$var$ALIGN_OPTIONS[t];
            e.set({
                align: n
            });
        }
    }), $gS5ZA.flags.textVerticalResizeEnabled && $4cf368af09439e86$var$react_1.default.createElement($gUePa.Button, {
        minimal: !0,
        icon: $4cf368af09439e86$var$VERTICAL_ALIGN_ICONS[e.verticalAlign],
        onClick: ()=>{
            const n = ($4cf368af09439e86$var$VERTICAL_ALIGN_OPTIONS.indexOf(e.verticalAlign) + 1 + $4cf368af09439e86$var$VERTICAL_ALIGN_OPTIONS.length) % $4cf368af09439e86$var$VERTICAL_ALIGN_OPTIONS.length, o = $4cf368af09439e86$var$VERTICAL_ALIGN_OPTIONS[n];
            t.history.transaction(()=>{
                e.set({
                    verticalAlign: o
                });
            });
        }
    }), $4cf368af09439e86$var$react_1.default.createElement($gUePa.Button, {
        minimal: !0,
        icon: "bold",
        active: $1gtCb.quillRef.currentFormat.bold || "bold" === e.fontWeight || "700" === e.fontWeight,
        onMouseDown: (e)=>{
            e.preventDefault();
        },
        onClick: (t)=>{
            const n = window.__polotnoQuill;
            if (n) {
                const e = n.getSelection();
                return void n.formatText(e.index, e.length, "bold", !$1gtCb.quillRef.currentFormat.bold, "user");
            }
            "bold" === e.fontWeight || "700" === e.fontWeight ? e.set({
                fontWeight: "normal"
            }) : e.set({
                fontWeight: "bold"
            });
        }
    }), $4cf368af09439e86$var$react_1.default.createElement($gUePa.Button, {
        minimal: !0,
        icon: "italic",
        onMouseDown: (e)=>{
            e.preventDefault();
        },
        active: $1gtCb.quillRef.currentFormat.italic || "italic" === e.fontStyle,
        onClick: ()=>{
            const t = window.__polotnoQuill;
            if (t) {
                const e = t.getSelection();
                t.formatText(e.index, e.length, "italic", !$1gtCb.quillRef.currentFormat.italic, "user");
            } else "italic" === e.fontStyle ? e.set({
                fontStyle: "normal"
            }) : e.set({
                fontStyle: "italic"
            });
        }
    }), $4cf368af09439e86$var$react_1.default.createElement($gUePa.Button, {
        minimal: !0,
        icon: "underline",
        active: $1gtCb.quillRef.currentFormat.underline || e.textDecoration.indexOf("underline") >= 0,
        onMouseDown: (e)=>{
            e.preventDefault();
        },
        onClick: ()=>{
            const t = window.__polotnoQuill;
            if (t) {
                const e = t.getSelection();
                return void t.formatText(e.index, e.length, "underline", !$1gtCb.quillRef.currentFormat.underline, "user");
            }
            let n = e.textDecoration.split(" ");
            n.indexOf("underline") >= 0 ? n = n.filter((e)=>"underline" !== e) : n.push("underline"), e.set({
                textDecoration: n.join(" ")
            });
        }
    }), $4cf368af09439e86$var$react_1.default.createElement($gUePa.Button, {
        minimal: !0,
        icon: "strikethrough",
        active: $1gtCb.quillRef.currentFormat.strike || e.textDecoration.indexOf("line-through") >= 0,
        onMouseDown: (e)=>{
            e.preventDefault();
        },
        onClick: ()=>{
            const t = window.__polotnoQuill;
            if (t) {
                const e = t.getSelection();
                return void t.formatText(e.index, e.length, "strike", !$1gtCb.quillRef.currentFormat.strike, "user");
            }
            let n = e.textDecoration.split(" ");
            n.indexOf("line-through") >= 0 ? n = n.filter((e)=>"line-through" !== e) : n.push("line-through"), e.set({
                textDecoration: n.join(" ")
            });
        }
    }))), module.exports.FontColorInput = (0, $O1ETn.observer)(({ element: e, store: t })=>$4cf368af09439e86$var$react_1.default.createElement($4cf368af09439e86$var$color_picker_1.default, {
        value: $1gtCb.quillRef.currentFormat.color || e.fill,
        onChange: (t)=>{
            const n = window.__polotnoQuill, o = null == n ? void 0 : n.getSelection(), l = (null == o ? void 0 : o.length) >= (null == n ? void 0 : n.getLength()) - 1;
            if (n && !l && (null == o ? void 0 : o.length)) n.formatText(o.index, o.length, "color", t, "user");
            else {
                var r = e.text.replace(/style=".*?"/g, "");
                e.set({
                    fill: t,
                    text: r
                });
            }
        },
        store: t
    })), module.exports.DirectionInput = (0, $O1ETn.observer)(({ element: e })=>{
    const t = "rtl" === e.dir ? $4cf368af09439e86$var$MdFormatTextdirectionRToL_1.default : $4cf368af09439e86$var$MdFormatTextdirectionLToR_1.default;
    return $4cf368af09439e86$var$react_1.default.createElement($gUePa.Button, {
        icon: $4cf368af09439e86$var$react_1.default.createElement(t, {
            className: "bp5-icon",
            style: {
                fontSize: "20px"
            }
        }),
        minimal: !0,
        onClick: ()=>{
            e.set({
                dir: "rtl" === e.dir ? "ltr" : "rtl"
            });
        }
    });
});
const $4cf368af09439e86$var$PROPS_MAP = {
    TextFontFamily: $9mdgj.TextFontFamily,
    TextFontSize: module.exports.FontSizeInput,
    TextFontVariant: module.exports.FontStyleGroup,
    TextFilters: $4cf368af09439e86$var$filters_picker_1.default,
    TextFill: module.exports.FontColorInput,
    TextSpacing: $9mdgj.TextSpacing,
    TextDirection: module.exports.DirectionInput,
    TextAnimations: $45tk4.AnimationsPicker
};
module.exports.HtmlToolbar = (0, $O1ETn.observer)(({ store: e, components: t })=>{
    const n = e.selectedElements, o = e.selectedElements[0], l = [
        "TextFill",
        "TextFontFamily",
        "TextFontSize",
        "TextFontVariant",
        "TextSpacing",
        "TextFilters",
        $gS5ZA.flags.animationsEnabled && "TextAnimations"
    ], r = (0, $1hndE.extendToolbar)({
        type: "text",
        usedItems: l,
        components: t
    });
    return $4cf368af09439e86$var$react_1.default.createElement($1hndE.ElementContainer, {
        items: r,
        itemRender: (l)=>{
            const r = t[l] || $4cf368af09439e86$var$PROPS_MAP[l];
            return $4cf368af09439e86$var$react_1.default.createElement(r, {
                element: o,
                elements: n,
                store: e,
                key: l
            });
        }
    });
});

});
parcelRegister("dRXPx", function(module, exports) {
parcelRequire("kNUzI");
var $3H1D6 = parcelRequire("3H1D6");
var $a18ea29f63a56628$require$GenIcon = $3H1D6.GenIcon;
module.exports = function(props) {
    return $a18ea29f63a56628$require$GenIcon({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10v5h2V4h2v11h2V4h2V2h-8C7.79 2 6 3.79 6 6s1.79 4 4 4zm-2 7v-3l-4 4 4 4v-3h12v-2H8z"
                }
            }
        ]
    })(props);
};

});

parcelRegister("74nEV", function(module, exports) {
parcelRequire("kNUzI");
var $3H1D6 = parcelRequire("3H1D6");
var $525b4251970360b8$require$GenIcon = $3H1D6.GenIcon;
module.exports = function(props) {
    return $525b4251970360b8$require$GenIcon({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 10v5h2V4h2v11h2V4h2V2H9C6.79 2 5 3.79 5 6s1.79 4 4 4zm12 8l-4-4v3H5v2h12v3l4-4z"
                }
            }
        ]
    })(props);
};

});


parcelRegister("hLtXc", function(module, exports) {
"use strict";
var $ceee0fac98cb14d3$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.ImageToolbar = module.exports.ImageRemoveClip = module.exports.ImageCrop = module.exports.ImageClip = module.exports.ImageFitToBackground = void 0;

const $ceee0fac98cb14d3$var$react_1 = $ceee0fac98cb14d3$var$__importDefault((parcelRequire("8NFma")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

var $gUePa = parcelRequire("gUePa");
var $f5Zeh = parcelRequire("f5Zeh");
var $gVVt3 = parcelRequire("gVVt3");

var $1hndE = parcelRequire("1hndE");

var $iilXS = parcelRequire("iilXS");

const $ceee0fac98cb14d3$var$filters_picker_1 = $ceee0fac98cb14d3$var$__importDefault((parcelRequire("hPyFl")));

var $45tk4 = parcelRequire("45tk4");

const $ceee0fac98cb14d3$var$flip_button_1 = $ceee0fac98cb14d3$var$__importDefault((parcelRequire("feLTk")));

var $gS5ZA = parcelRequire("gS5ZA");

var $kK7Av = parcelRequire("kK7Av");

var $xARwM = parcelRequire("xARwM");
const $ceee0fac98cb14d3$var$ImageFitToBackground = ({ element: e })=>$ceee0fac98cb14d3$var$react_1.default.createElement($gUePa.Button, {
        text: (0, $xARwM.t)("toolbar.fitToBackground"),
        minimal: !0,
        onClick: ()=>{
            const { page: t } = e;
            e.set({
                x: -t.bleed,
                y: -t.bleed,
                width: t.computedWidth + 2 * t.bleed,
                height: t.computedHeight + 2 * t.bleed,
                rotation: 0,
                cropX: 0,
                cropY: 0,
                cropWidth: 1,
                cropHeight: 1
            });
        }
    });
module.exports.ImageFitToBackground = $ceee0fac98cb14d3$var$ImageFitToBackground, module.exports.ImageClip = (0, $O1ETn.observer)(({ element: e, store: t })=>e.contentEditable ? e.clipSrc ? $ceee0fac98cb14d3$var$react_1.default.createElement($gUePa.Button, {
        text: (0, $xARwM.t)("toolbar.removeClip"),
        minimal: !0,
        onClickCapture: (t)=>{
            e.set({
                clipSrc: ""
            });
        }
    }) : $ceee0fac98cb14d3$var$react_1.default.createElement($gUePa.Button, {
        minimal: !0,
        text: (0, $xARwM.t)("toolbar.clip"),
        onClickCapture: (e)=>{
            e.stopPropagation(), t.openSidePanel("image-clip");
        }
    }) : null), module.exports.ImageCrop = (0, $O1ETn.observer)(({ element: e, store: t })=>e.contentEditable ? $ceee0fac98cb14d3$var$react_1.default.createElement($gVVt3.Tooltip, {
        content: (0, $xARwM.t)("toolbar.crop"),
        position: "bottom"
    }, $ceee0fac98cb14d3$var$react_1.default.createElement($gUePa.Button, {
        minimal: !0,
        icon: $ceee0fac98cb14d3$var$react_1.default.createElement($iilXS.Crop, null),
        onClickCapture: (t)=>{
            t.stopPropagation(), e.toggleCropMode(!0);
        }
    })) : null), module.exports.ImageRemoveClip = (0, $O1ETn.observer)(({ element: e, store: t })=>e.clipSrc ? $ceee0fac98cb14d3$var$react_1.default.createElement($gUePa.Button, {
        text: (0, $xARwM.t)("toolbar.removeClip"),
        minimal: !0,
        onClickCapture: (t)=>{
            e.set({
                clipSrc: ""
            });
        }
    }) : null);
const $ceee0fac98cb14d3$var$PROPS_MAP = {
    ImageFlip: $ceee0fac98cb14d3$var$flip_button_1.default,
    ImageFilters: $ceee0fac98cb14d3$var$filters_picker_1.default,
    ImageFitToBackground: module.exports.ImageFitToBackground,
    ImageCrop: module.exports.ImageCrop,
    ImageClip: module.exports.ImageClip,
    ImageRemoveBackground: $kK7Av.ImageRemoveBackground,
    ImageAnimations: $45tk4.AnimationsPicker
};
module.exports.ImageToolbar = (0, $O1ETn.observer)(({ store: e, components: t })=>{
    const r = e.selectedElements[0], o = r._cropModeEnabled, a = $ceee0fac98cb14d3$var$react_1.default.useRef({});
    $ceee0fac98cb14d3$var$react_1.default.useEffect(()=>{
        o && (a.current = {
            x: r.x,
            y: r.y,
            width: r.width,
            height: r.height,
            cropX: r.cropX,
            cropY: r.cropY,
            cropWidth: r.cropWidth,
            cropHeight: r.cropHeight
        });
    }, [
        o
    ]);
    const l = [
        "ImageFlip",
        "ImageFilters",
        "ImageFitToBackground",
        "ImageClip",
        "ImageCrop",
        $gS5ZA.flags.animationsEnabled && "ImageAnimations",
        $gS5ZA.flags.removeBackgroundEnabled && "ImageRemoveBackground"
    ], n = (0, $1hndE.extendToolbar)({
        type: "image",
        usedItems: l,
        components: t
    });
    return $ceee0fac98cb14d3$var$react_1.default.createElement($ceee0fac98cb14d3$var$react_1.default.Fragment, null, !o && $ceee0fac98cb14d3$var$react_1.default.createElement($1hndE.ElementContainer, {
        items: n,
        itemRender: (o)=>{
            const a = t[o] || $ceee0fac98cb14d3$var$PROPS_MAP[o];
            return $ceee0fac98cb14d3$var$react_1.default.createElement(a, {
                element: r,
                store: e,
                key: o
            });
        }
    }), o && $ceee0fac98cb14d3$var$react_1.default.createElement($f5Zeh.Navbar.Group, null, $ceee0fac98cb14d3$var$react_1.default.createElement($gUePa.Button, {
        text: (0, $xARwM.t)("toolbar.cropDone"),
        minimal: !0,
        icon: "tick",
        onClickCapture: (e)=>{
            r.toggleCropMode(!1);
        }
    }), $ceee0fac98cb14d3$var$react_1.default.createElement($gUePa.Button, {
        text: (0, $xARwM.t)("toolbar.cropCancel"),
        minimal: !0,
        icon: "cross",
        onClickCapture: (e)=>{
            r.set(Object.assign({}, a.current)), r.toggleCropMode(!1);
        }
    })));
}), module.exports.default = module.exports.ImageToolbar;

});
parcelRegister("iilXS", function(module, exports) {

$parcel$export(module.exports, "Crop", () => $d51af226e764bafb$export$8e58b6dc125f7f1b);
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $8NFma = parcelRequire("8NFma");

var $leH9B = parcelRequire("leH9B");

var $eog74 = parcelRequire("eog74");
var $d51af226e764bafb$export$8e58b6dc125f7f1b = $8NFma.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, $leH9B.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, $leH9B.IconSize).LARGE : (0, $leH9B.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return $8NFma.createElement((0, $eog74.SVGIconContainer), (0, $gztBd.__assign)({
        iconName: "crop",
        ref: ref
    }, props), $8NFma.createElement("path", {
        d: isLarge ? "M280 20C280 8.954 288.954 0 300 0C311.046 0 320 8.954 320 20L320 80L380 80C391.046 80 400 88.954 400 100C400 111.046 391.046 120 380 120L120 120L120 380.00002C120 391.04574 111.0458 400.0000252612 100 400.0000262268C88.9544 400.0000271924 80 391.04576 80 380.00002L80 320L20 320C8.95434 320 0.0000271924 311.0458 0.0000262268 300C0.0000252612 288.9544 8.95434 280 20 280L80 280L80 100C80 88.954 88.9544 80 100 80L280 80L280 20zM300 320L160 320L160 280L280 280L280 160L320 160L320 300.0002C320 311.0458 311.046 320 300 320zM0 400H400V0H0V400z" : "M220 20C220 8.954 228.954 0 240 0C251.046 0 260 8.954 260 20V60H300C311.046 60 320 68.954 320 80C320 91.046 311.046 100 300 100H100.0002V300C100.0002 311.0457 91.0458 319.999999034354 80.0002 320C68.9544 320.000000965646 60.0002 311.04568 60.0002 300L60.0002 260L20.0002 260C8.95444 260 0.0001154066 251.0456 0.000152588 240C0.0001516224 228.9542 8.95444 220 20.0002 220L60.0002 220L60.0002 80C60.0002 68.954 68.9544 60 80.0002 60H220V20zM240 260.0002L120.0002 260.0002V220.0002L220 220.0002L220 120H260L260 240.0002C260 251.0458 251.046 260.0002 240 260.0002z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
$d51af226e764bafb$export$8e58b6dc125f7f1b.defaultProps = {
    size: (0, $leH9B.IconSize).STANDARD
};
$d51af226e764bafb$export$8e58b6dc125f7f1b.displayName = "Blueprint5.Icon.Crop";
var $d51af226e764bafb$export$2e2bcd8739ae039 = $d51af226e764bafb$export$8e58b6dc125f7f1b;

});

parcelRegister("feLTk", function(module, exports) {
"use strict";
var $b17d500db990ac25$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.FlipButton = void 0;

const $b17d500db990ac25$var$react_1 = $b17d500db990ac25$var$__importDefault((parcelRequire("8NFma")));

var $gUePa = parcelRequire("gUePa");
var $7RyvK = parcelRequire("7RyvK");
var $2IwH6 = parcelRequire("2IwH6");
var $ixLVk = parcelRequire("ixLVk");
var $71KpR = parcelRequire("71KpR");

var $gUePa = parcelRequire("gUePa");
var $7RyvK = parcelRequire("7RyvK");
var $2IwH6 = parcelRequire("2IwH6");
var $ixLVk = parcelRequire("ixLVk");
var $71KpR = parcelRequire("71KpR");

var $xARwM = parcelRequire("xARwM");
const $b17d500db990ac25$var$FlipButton = ({ element: e })=>$b17d500db990ac25$var$react_1.default.createElement($ixLVk.Popover, {
        content: $b17d500db990ac25$var$react_1.default.createElement($7RyvK.Menu, null, $b17d500db990ac25$var$react_1.default.createElement($2IwH6.MenuItem, {
            shouldDismissPopover: !1,
            icon: "arrows-horizontal",
            text: (0, $xARwM.t)("toolbar.flipHorizontally"),
            onClick: ()=>{
                e.set({
                    flipX: !e.flipX
                });
            }
        }), $b17d500db990ac25$var$react_1.default.createElement($2IwH6.MenuItem, {
            shouldDismissPopover: !1,
            text: (0, $xARwM.t)("toolbar.flipVertically"),
            icon: "arrows-vertical",
            onClick: ()=>{
                e.set({
                    flipY: !e.flipY
                });
            }
        })),
        position: $71KpR.Position.BOTTOM
    }, $b17d500db990ac25$var$react_1.default.createElement($gUePa.Button, {
        text: (0, $xARwM.t)("toolbar.flip"),
        minimal: !0
    }));
module.exports.FlipButton = $b17d500db990ac25$var$FlipButton, module.exports.default = module.exports.FlipButton;

});

parcelRegister("kK7Av", function(module, exports) {
"use strict";
var $f19dfd4ac789d083$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.ImageRemoveBackground = module.exports.RemoveBackgroundDialog = module.exports.setRemoveBackgroundFunc = void 0;

const $f19dfd4ac789d083$var$react_1 = $f19dfd4ac789d083$var$__importDefault((parcelRequire("8NFma")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

var $gUePa = parcelRequire("gUePa");
var $auzpd = parcelRequire("auzpd");
var $9b07N = parcelRequire("9b07N");

var $6laUv = parcelRequire("6laUv");

var $xARwM = parcelRequire("xARwM");
let $f19dfd4ac789d083$var$removeBackgroundFunc = async (e)=>{
    const t = await fetch((0, $6laUv.removeBackground)(), {
        method: "POST",
        body: JSON.stringify({
            url: e
        })
    });
    if (200 !== t.status) return alert((0, $xARwM.t)("error.removeBackground")), e;
    return (await t.json()).url;
};
function $f19dfd4ac789d083$var$setRemoveBackgroundFunc(e) {
    $f19dfd4ac789d083$var$removeBackgroundFunc = e;
}
module.exports.setRemoveBackgroundFunc = $f19dfd4ac789d083$var$setRemoveBackgroundFunc, module.exports.RemoveBackgroundDialog = (0, $O1ETn.observer)(({ isOpen: e, onClose: t, element: r })=>{
    const [a, o] = $f19dfd4ac789d083$var$react_1.default.useState(r.src);
    $f19dfd4ac789d083$var$react_1.default.useEffect(()=>{
        o(r.src);
    }, [
        r.src
    ]);
    const [c, n] = $f19dfd4ac789d083$var$react_1.default.useState(!1), l = a !== r.src;
    return $f19dfd4ac789d083$var$react_1.default.createElement($9b07N.Dialog, {
        onClose: t,
        title: (0, $xARwM.t)("toolbar.removeBackgroundTitle"),
        isOpen: e,
        style: {
            width: "80%",
            maxWidth: "700px"
        }
    }, $f19dfd4ac789d083$var$react_1.default.createElement("div", {
        className: $auzpd.DIALOG_BODY
    }, $f19dfd4ac789d083$var$react_1.default.createElement("img", {
        src: a,
        style: {
            width: "100%",
            maxHeight: "400px",
            objectFit: "contain"
        }
    })), $f19dfd4ac789d083$var$react_1.default.createElement("div", {
        className: $auzpd.DIALOG_FOOTER,
        style: {
            position: "relative"
        }
    }, $f19dfd4ac789d083$var$react_1.default.createElement("div", {
        style: {
            position: "absolute",
            top: "5px"
        }
    }, "Powered by", " ", $f19dfd4ac789d083$var$react_1.default.createElement("a", {
        href: "https://hotpot.ai/",
        target: "_blank"
    }, "hotpot.ai")), $f19dfd4ac789d083$var$react_1.default.createElement("div", {
        className: $auzpd.DIALOG_FOOTER_ACTIONS
    }, !l && $f19dfd4ac789d083$var$react_1.default.createElement($gUePa.Button, {
        onClick: async ()=>{
            n(!0);
            try {
                o(await $f19dfd4ac789d083$var$removeBackgroundFunc(r.src));
            } catch (e) {
                console.error(e);
            }
            n(!1);
        },
        loading: c
    }, (0, $xARwM.t)("toolbar.removeBackground")), l && $f19dfd4ac789d083$var$react_1.default.createElement($f19dfd4ac789d083$var$react_1.default.Fragment, null, $f19dfd4ac789d083$var$react_1.default.createElement($gUePa.Button, {
        onClick: ()=>{
            o(r.src), t();
        },
        loading: c
    }, (0, $xARwM.t)("toolbar.cancelRemoveBackground")), $f19dfd4ac789d083$var$react_1.default.createElement($gUePa.Button, {
        onClick: ()=>{
            r.set({
                src: a
            }), t();
        },
        loading: c,
        intent: "primary"
    }, (0, $xARwM.t)("toolbar.confirmRemoveBackground"))))));
});
const $f19dfd4ac789d083$var$ImageRemoveBackground = ({ element: e })=>{
    const [t, r] = $f19dfd4ac789d083$var$react_1.default.useState(!1);
    return $f19dfd4ac789d083$var$react_1.default.createElement($f19dfd4ac789d083$var$react_1.default.Fragment, null, $f19dfd4ac789d083$var$react_1.default.createElement($gUePa.Button, {
        text: (0, $xARwM.t)("toolbar.removeBackground"),
        minimal: !0,
        onClick: (e)=>{
            r(!0);
        }
    }), $f19dfd4ac789d083$var$react_1.default.createElement(module.exports.RemoveBackgroundDialog, {
        isOpen: t,
        onClose: ()=>{
            r(!1);
        },
        element: e
    }));
};
module.exports.ImageRemoveBackground = $f19dfd4ac789d083$var$ImageRemoveBackground;

});
parcelRegister("9b07N", function(module, exports) {

$parcel$export(module.exports, "Dialog", () => $6ae53ce7e1ab3b76$export$3ddf2d174ce01153);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $leH9B = parcelRequire("leH9B");
var $bqtP4 = parcelRequire("bqtP4");

var $4Jy2D = parcelRequire("4Jy2D");
var $auzpd = parcelRequire("auzpd");
var $hffzE = parcelRequire("hffzE");
var $8k66C = parcelRequire("8k66C");

var $bzsu8 = parcelRequire("bzsu8");

var $h8UCV = parcelRequire("h8UCV");

var $gUePa = parcelRequire("gUePa");

var $dI9Vl = parcelRequire("dI9Vl");

var $gKgL3 = parcelRequire("gKgL3");

var $duUmg = parcelRequire("duUmg");
/**
 * Dialog component.
 *
 * @see https://blueprintjs.com/docs/#core/components/dialog
 */ var $6ae53ce7e1ab3b76$export$3ddf2d174ce01153 = /** @class */ function(_super) {
    (0, $gztBd.__extends)(Dialog, _super);
    function Dialog(props) {
        var _this = _super.call(this, props) || this;
        _this.childRef = $8NFma.createRef();
        var id = (0, $h8UCV.uniqueId)("bp-dialog");
        _this.titleId = "title-".concat(id);
        return _this;
    }
    Dialog.prototype.render = function() {
        var _a = this.props, className = _a.className, children = _a.children, containerRef = _a.containerRef, style = _a.style, title = _a.title, overlayProps = (0, $gztBd.__rest)(_a, [
            "className",
            "children",
            "containerRef",
            "style",
            "title"
        ]);
        return $8NFma.createElement((0, $duUmg.Overlay2), (0, $gztBd.__assign)({}, overlayProps, {
            className: (0, $auzpd).OVERLAY_SCROLL_CONTAINER,
            childRef: this.childRef,
            hasBackdrop: true
        }), $8NFma.createElement("div", {
            className: (0, $auzpd).DIALOG_CONTAINER,
            ref: containerRef === undefined ? this.childRef : (0, $8k66C.mergeRefs)(containerRef, this.childRef)
        }, $8NFma.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $auzpd).DIALOG, className),
            role: "dialog",
            "aria-labelledby": this.props["aria-labelledby"] || (title ? this.titleId : undefined),
            "aria-describedby": this.props["aria-describedby"],
            style: style
        }, this.maybeRenderHeader(), children)));
    };
    Dialog.prototype.validateProps = function(props) {
        if (props.title == null) {
            if (props.icon != null) console.warn($bzsu8.DIALOG_WARN_NO_HEADER_ICON);
            if (props.isCloseButtonShown != null) console.warn($bzsu8.DIALOG_WARN_NO_HEADER_CLOSE_BUTTON);
        }
    };
    Dialog.prototype.maybeRenderCloseButton = function() {
        // show close button if prop is undefined or null
        // this gives us a behavior as if the default value were `true`
        if (this.props.isCloseButtonShown !== false) return $8NFma.createElement((0, $gUePa.Button), {
            "aria-label": "Close",
            className: (0, $auzpd).DIALOG_CLOSE_BUTTON,
            icon: $8NFma.createElement((0, $bqtP4.SmallCross), {
                size: (0, $leH9B.IconSize).STANDARD
            }),
            minimal: true,
            onClick: this.props.onClose
        });
        else return undefined;
    };
    Dialog.prototype.maybeRenderHeader = function() {
        var _a = this.props, icon = _a.icon, title = _a.title;
        if (title == null) return undefined;
        return $8NFma.createElement("div", {
            className: (0, $auzpd).DIALOG_HEADER
        }, $8NFma.createElement((0, $gKgL3.Icon), {
            icon: icon,
            size: (0, $leH9B.IconSize).STANDARD,
            "aria-hidden": true,
            tabIndex: -1
        }), $8NFma.createElement((0, $dI9Vl.H6), {
            id: this.titleId
        }, title), this.maybeRenderCloseButton());
    };
    Dialog.defaultProps = {
        canOutsideClickClose: true,
        isOpen: false
    };
    Dialog.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".Dialog");
    return Dialog;
}((0, $4Jy2D.AbstractPureComponent));

});



parcelRegister("a1B2e", function(module, exports) {
"use strict";
var $74c6b9c0b4e40383$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(e, t, r, o) {
    void 0 === o && (o = r);
    var i = Object.getOwnPropertyDescriptor(t, r);
    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
        enumerable: !0,
        get: function() {
            return t[r];
        }
    }), Object.defineProperty(e, o, i);
} : function(e, t, r, o) {
    void 0 === o && (o = r), e[o] = t[r];
}), $74c6b9c0b4e40383$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(e, t) {
    Object.defineProperty(e, "default", {
        enumerable: !0,
        value: t
    });
} : function(e, t) {
    e.default = t;
}), $74c6b9c0b4e40383$var$__importStar = module.exports && module.exports.__importStar || function(e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && $74c6b9c0b4e40383$var$__createBinding(t, e, r);
    return $74c6b9c0b4e40383$var$__setModuleDefault(t, e), t;
}, $74c6b9c0b4e40383$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.SvgToolbar = void 0;

const $74c6b9c0b4e40383$var$react_1 = $74c6b9c0b4e40383$var$__importDefault((parcelRequire("8NFma")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

const $74c6b9c0b4e40383$var$svg = $74c6b9c0b4e40383$var$__importStar((parcelRequire("eRGXT")));

var $1hndE = parcelRequire("1hndE");

const $74c6b9c0b4e40383$var$filters_picker_1 = $74c6b9c0b4e40383$var$__importDefault((parcelRequire("hPyFl")));

const $74c6b9c0b4e40383$var$color_picker_1 = $74c6b9c0b4e40383$var$__importDefault((parcelRequire("gaqum")));

const $74c6b9c0b4e40383$var$flip_button_1 = $74c6b9c0b4e40383$var$__importDefault((parcelRequire("feLTk")));

var $45tk4 = parcelRequire("45tk4");

var $gS5ZA = parcelRequire("gS5ZA");
const $74c6b9c0b4e40383$var$findColorInKeys = (e, t)=>Array.from(e.keys()).find((e)=>$74c6b9c0b4e40383$var$svg.sameColors(e, t)), $74c6b9c0b4e40383$var$getColor = (e, t)=>{
    const r = $74c6b9c0b4e40383$var$findColorInKeys(e, t);
    return e.get(r || "") || t;
}, $74c6b9c0b4e40383$var$SvgColors = (0, $O1ETn.observer)(({ element: e, elements: t, store: r })=>{
    const o = $74c6b9c0b4e40383$var$svg.useSvgColors(e.src);
    return $74c6b9c0b4e40383$var$react_1.default.createElement($74c6b9c0b4e40383$var$react_1.default.Fragment, null, !e.maskSrc && o.slice(0, 5).map((t)=>$74c6b9c0b4e40383$var$react_1.default.createElement($74c6b9c0b4e40383$var$color_picker_1.default, {
            key: t,
            value: $74c6b9c0b4e40383$var$getColor(e.colorsReplace, t),
            style: {
                marginLeft: "5px"
            },
            onChange: (r)=>{
                const o = $74c6b9c0b4e40383$var$findColorInKeys(e.colorsReplace, t) || t;
                e.replaceColor(o, r);
            },
            store: r,
            gradientEnabled: !0
        })));
}), $74c6b9c0b4e40383$var$PROPS_MAP = {
    SvgFlip: $74c6b9c0b4e40383$var$flip_button_1.default,
    SvgFilters: $74c6b9c0b4e40383$var$filters_picker_1.default,
    SvgColors: $74c6b9c0b4e40383$var$SvgColors,
    SvgAnimations: $45tk4.AnimationsPicker
};
module.exports.SvgToolbar = (0, $O1ETn.observer)(({ store: e, hideSvgEffects: t, components: r })=>{
    const o = e.selectedElements, i = [
        "SvgFlip",
        !t && "SvgFilters",
        "SvgColors",
        $gS5ZA.flags.animationsEnabled && "SvgAnimations"
    ].filter((e)=>!!e), n = (0, $1hndE.extendToolbar)({
        type: "svg",
        usedItems: i,
        components: r
    });
    return $74c6b9c0b4e40383$var$react_1.default.createElement($1hndE.ElementContainer, {
        items: n,
        itemRender: (t)=>{
            const i = r[t] || $74c6b9c0b4e40383$var$PROPS_MAP[t];
            return $74c6b9c0b4e40383$var$react_1.default.createElement(i, {
                elements: o,
                element: o[0],
                store: e,
                key: t
            });
        }
    });
}), module.exports.default = module.exports.SvgToolbar;

});

parcelRegister("eiAQ7", function(module, exports) {
"use strict";
var $a68f52b257acda46$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.LineToolbar = module.exports.LineHeads = module.exports.BasicHead = module.exports.LineColor = module.exports.LineSettings = void 0;

const $a68f52b257acda46$var$react_1 = $a68f52b257acda46$var$__importDefault((parcelRequire("8NFma")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

var $gUePa = parcelRequire("gUePa");
var $ixLVk = parcelRequire("ixLVk");
var $71KpR = parcelRequire("71KpR");
var $88Rzx = parcelRequire("88Rzx");

var $gUePa = parcelRequire("gUePa");
var $ixLVk = parcelRequire("ixLVk");
var $71KpR = parcelRequire("71KpR");
var $88Rzx = parcelRequire("88Rzx");

const $a68f52b257acda46$var$color_picker_1 = $a68f52b257acda46$var$__importDefault((parcelRequire("gaqum")));

var $45tk4 = parcelRequire("45tk4");

var $hPyFl = parcelRequire("hPyFl");

var $1hndE = parcelRequire("1hndE");

var $dB0vw = parcelRequire("dB0vw");

var $xARwM = parcelRequire("xARwM");

var $gS5ZA = parcelRequire("gS5ZA");
module.exports.LineSettings = (0, $O1ETn.observer)(({ store: e, elements: t })=>{
    const r = (r)=>{
        e.history.transaction(()=>{
            t.forEach((e)=>{
                e.set(r);
            });
        });
    }, a = (r)=>{
        e.history.transaction(()=>{
            t.forEach((e)=>{
                const { middleLeft: t, middleRight: a } = (0, $dB0vw.getMiddlePoints)(e), { x: n, y: o, rotation: l } = (0, $dB0vw.getLinePositionFromMiddlePoints)(t, a, r);
                e.set({
                    x: n,
                    y: o,
                    rotation: l,
                    height: r
                });
            });
        });
    };
    return $a68f52b257acda46$var$react_1.default.createElement($ixLVk.Popover, {
        content: $a68f52b257acda46$var$react_1.default.createElement("div", {
            style: {
                padding: "15px",
                paddingTop: "15px",
                width: "230px"
            }
        }, $a68f52b257acda46$var$react_1.default.createElement("div", {
            style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                paddingBottom: "5px"
            }
        }, $a68f52b257acda46$var$react_1.default.createElement("div", null, (0, $xARwM.t)("toolbar.lineSize")), $a68f52b257acda46$var$react_1.default.createElement("div", null, $a68f52b257acda46$var$react_1.default.createElement($hPyFl.NumberInput, {
            value: t[0].height,
            onValueChange: (e)=>{
                a(e);
            },
            style: {
                width: "50px"
            },
            min: 1,
            max: 100,
            buttonPosition: "none"
        }))), $a68f52b257acda46$var$react_1.default.createElement($88Rzx.Slider, {
            value: t[0].height,
            onChange: (e)=>{
                a(e);
            },
            min: 1,
            max: 100,
            labelRenderer: !1
        }), $a68f52b257acda46$var$react_1.default.createElement("div", {
            style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                paddingBottom: "5px",
                paddingTop: "15px"
            }
        }, $a68f52b257acda46$var$react_1.default.createElement($gUePa.Button, {
            onClick: ()=>{
                r({
                    dash: []
                });
            },
            active: 0 === t[0].dash.length
        }, $a68f52b257acda46$var$react_1.default.createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, $a68f52b257acda46$var$react_1.default.createElement("line", {
            x2: "24",
            y1: "50%",
            y2: "50%",
            stroke: "currentColor",
            strokeWidth: "2"
        }))), $a68f52b257acda46$var$react_1.default.createElement($gUePa.Button, {
            onClick: ()=>{
                r({
                    dash: [
                        4,
                        1
                    ]
                });
            },
            active: 4 === t[0].dash[0]
        }, $a68f52b257acda46$var$react_1.default.createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, $a68f52b257acda46$var$react_1.default.createElement("line", {
            x1: "-1",
            x2: "25",
            y1: "50%",
            y2: "50%",
            stroke: "currentColor",
            strokeDasharray: "12 2",
            strokeWidth: "2"
        }))), $a68f52b257acda46$var$react_1.default.createElement($gUePa.Button, {
            onClick: ()=>{
                r({
                    dash: [
                        2,
                        1
                    ]
                });
            },
            active: 2 === t[0].dash[0]
        }, $a68f52b257acda46$var$react_1.default.createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, $a68f52b257acda46$var$react_1.default.createElement("line", {
            x1: "1",
            x2: "23",
            y1: "50%",
            y2: "50%",
            stroke: "currentColor",
            strokeDasharray: "6 2",
            strokeWidth: "2"
        }))), $a68f52b257acda46$var$react_1.default.createElement($gUePa.Button, {
            onClick: ()=>{
                r({
                    dash: [
                        1,
                        1
                    ]
                });
            },
            active: 1 === t[0].dash[0]
        }, $a68f52b257acda46$var$react_1.default.createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, $a68f52b257acda46$var$react_1.default.createElement("line", {
            x1: "1",
            x2: "23",
            y1: "50%",
            y2: "50%",
            stroke: "currentColor",
            strokeDasharray: "2 2",
            strokeWidth: "2"
        }))))),
        position: $71KpR.Position.BOTTOM
    }, $a68f52b257acda46$var$react_1.default.createElement($gUePa.Button, {
        icon: "settings",
        minimal: !0
    }));
}), module.exports.LineColor = (0, $O1ETn.observer)(({ elements: e, store: t })=>$a68f52b257acda46$var$react_1.default.createElement($a68f52b257acda46$var$color_picker_1.default, {
        value: e[0].color,
        style: {
            marginRight: "5px"
        },
        gradientEnabled: !1,
        onChange: (r)=>t.history.transaction(()=>{
                e.forEach((e)=>{
                    e.set({
                        color: r
                    });
                });
            }),
        store: t
    }));
const $a68f52b257acda46$var$EMPTY_ICON = $a68f52b257acda46$var$react_1.default.createElement("span", {
    "aria-hidden": "true",
    className: "bp5-icon"
}, $a68f52b257acda46$var$react_1.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16"
}, $a68f52b257acda46$var$react_1.default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M 1 8 L 16 8"
}))), $a68f52b257acda46$var$ARROW_ICON = $a68f52b257acda46$var$react_1.default.createElement("span", {
    "aria-hidden": "true",
    className: "bp5-icon"
}, $a68f52b257acda46$var$react_1.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16"
}, $a68f52b257acda46$var$react_1.default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M 8 3 L 1 8 L 8 13",
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round"
}), $a68f52b257acda46$var$react_1.default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M 1 8 L 15 8",
    strokeLinejoin: "round",
    strokeLinecap: "round"
}))), $a68f52b257acda46$var$TRIANGLE_ICON = $a68f52b257acda46$var$react_1.default.createElement("span", {
    "aria-hidden": "true",
    className: "bp5-icon"
}, $a68f52b257acda46$var$react_1.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16"
}, $a68f52b257acda46$var$react_1.default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M 8 3 L 1 8 L 8 13 Z",
    fill: "currentColor",
    strokeLinejoin: "round",
    strokeLinecap: "round"
}), $a68f52b257acda46$var$react_1.default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M 1 8 L 15 8",
    strokeLinejoin: "round",
    strokeLinecap: "round"
}))), $a68f52b257acda46$var$BRICK_ICON = $a68f52b257acda46$var$react_1.default.createElement("span", {
    "aria-hidden": "true",
    className: "bp5-icon"
}, $a68f52b257acda46$var$react_1.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16"
}, $a68f52b257acda46$var$react_1.default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M 1 3 L 1 13",
    strokeLinejoin: "round",
    strokeLinecap: "round"
}), $a68f52b257acda46$var$react_1.default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M 1 8 L 15 8",
    strokeLinejoin: "round",
    strokeLinecap: "round"
}))), $a68f52b257acda46$var$SQUARE_ICON = $a68f52b257acda46$var$react_1.default.createElement("span", {
    "aria-hidden": "true",
    className: "bp5-icon"
}, $a68f52b257acda46$var$react_1.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16"
}, $a68f52b257acda46$var$react_1.default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M 1 4 L 9 4 L 9 12 L 1 12 Z",
    fill: "currentColor",
    strokeLinejoin: "round",
    strokeLinecap: "round"
}), $a68f52b257acda46$var$react_1.default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M 1 8 L 15 8",
    strokeLinejoin: "round",
    strokeLinecap: "round"
}))), $a68f52b257acda46$var$CIRCLE_ICON = $a68f52b257acda46$var$react_1.default.createElement("span", {
    "aria-hidden": "true",
    className: "bp5-icon"
}, $a68f52b257acda46$var$react_1.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16"
}, $a68f52b257acda46$var$react_1.default.createElement("circle", {
    cx: "4",
    cy: "8",
    r: "4",
    fill: "currentColor"
}), $a68f52b257acda46$var$react_1.default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M 1 8 L 15 8",
    strokeLinejoin: "round",
    strokeLinecap: "round"
}))), $a68f52b257acda46$var$HEAD_TYPE_TO_ICON = {
    "": $a68f52b257acda46$var$EMPTY_ICON,
    arrow: $a68f52b257acda46$var$ARROW_ICON,
    triangle: $a68f52b257acda46$var$TRIANGLE_ICON,
    bar: $a68f52b257acda46$var$BRICK_ICON,
    square: $a68f52b257acda46$var$SQUARE_ICON,
    circle: $a68f52b257acda46$var$CIRCLE_ICON
}, $a68f52b257acda46$var$HeadTypeButton = ({ type: e, active: t, onClick: r, flipped: a })=>{
    const n = $a68f52b257acda46$var$HEAD_TYPE_TO_ICON[e];
    return $a68f52b257acda46$var$react_1.default.createElement($gUePa.Button, {
        icon: a ? $a68f52b257acda46$var$react_1.default.createElement("span", {
            style: {
                transform: "scaleX(-1)"
            }
        }, n) : n,
        minimal: !0,
        onClick: r,
        active: t
    });
};
module.exports.BasicHead = (0, $O1ETn.observer)(({ elements: e, store: t, property: r })=>{
    const a = "endHead" === r, n = $a68f52b257acda46$var$HEAD_TYPE_TO_ICON[e[0][r]], o = a ? $a68f52b257acda46$var$react_1.default.createElement("span", {
        style: {
            transform: "scaleX(-1)"
        }
    }, n) : n, l = (a)=>{
        t.history.transaction(()=>{
            e.forEach((e)=>{
                e.set({
                    [r]: a
                });
            });
        });
    };
    return $a68f52b257acda46$var$react_1.default.createElement($a68f52b257acda46$var$react_1.default.Fragment, null, $a68f52b257acda46$var$react_1.default.createElement($ixLVk.Popover, {
        content: $a68f52b257acda46$var$react_1.default.createElement("div", {
            style: {
                width: "150px",
                padding: "10px"
            }
        }, $a68f52b257acda46$var$react_1.default.createElement("div", {
            style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between"
            }
        }, [
            "",
            "arrow",
            "triangle"
        ].map((t)=>$a68f52b257acda46$var$react_1.default.createElement($a68f52b257acda46$var$HeadTypeButton, {
                key: t,
                type: t,
                active: e[0][r] === t,
                onClick: ()=>{
                    l(t);
                },
                flipped: a
            }))), $a68f52b257acda46$var$react_1.default.createElement("div", {
            style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between"
            }
        }, [
            "bar",
            "square",
            "circle"
        ].map((t)=>$a68f52b257acda46$var$react_1.default.createElement($a68f52b257acda46$var$HeadTypeButton, {
                key: t,
                type: t,
                active: e[0][r] === t,
                onClick: ()=>{
                    l(t);
                },
                flipped: a
            })))),
        position: $71KpR.Position.BOTTOM
    }, $a68f52b257acda46$var$react_1.default.createElement($gUePa.Button, {
        icon: o,
        minimal: !0
    })));
}), module.exports.LineHeads = (0, $O1ETn.observer)(({ elements: e, store: t })=>$a68f52b257acda46$var$react_1.default.createElement($a68f52b257acda46$var$react_1.default.Fragment, null, $a68f52b257acda46$var$react_1.default.createElement(module.exports.BasicHead, {
        elements: e,
        store: t,
        property: "startHead"
    }), $a68f52b257acda46$var$react_1.default.createElement(module.exports.BasicHead, {
        elements: e,
        store: t,
        property: "endHead"
    })));
const $a68f52b257acda46$var$PROPS_MAP = {
    LineSettings: module.exports.LineSettings,
    LineColor: module.exports.LineColor,
    LineHeads: module.exports.LineHeads,
    LineAnimations: $45tk4.AnimationsPicker
};
module.exports.LineToolbar = (0, $O1ETn.observer)(({ store: e, components: t })=>{
    const r = e.selectedElements[0], a = [
        "LineColor",
        "LineSettings",
        "LineHeads",
        $gS5ZA.flags.animationsEnabled && "LineAnimations"
    ].filter((e)=>Boolean(e)), n = (0, $1hndE.extendToolbar)({
        type: "line",
        usedItems: a,
        components: t
    });
    return $a68f52b257acda46$var$react_1.default.createElement($1hndE.ElementContainer, {
        items: n,
        itemRender: (a)=>{
            const n = t[a] || $a68f52b257acda46$var$PROPS_MAP[a];
            return $a68f52b257acda46$var$react_1.default.createElement(n, {
                element: r,
                store: e,
                key: a,
                elements: e.selectedElements
            });
        }
    });
}), module.exports.default = module.exports.LineToolbar;

});

parcelRegister("7Jat1", function(module, exports) {
"use strict";
var $5a04dae988a88123$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.VideoToolbar = module.exports.VideoTrim = void 0;

const $5a04dae988a88123$var$react_1 = $5a04dae988a88123$var$__importDefault((parcelRequire("8NFma")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

var $1hndE = parcelRequire("1hndE");

var $gUePa = parcelRequire("gUePa");
var $f5Zeh = parcelRequire("f5Zeh");
var $1Ym0q = parcelRequire("1Ym0q");
var $cQj25 = parcelRequire("cQj25");
var $ixLVk = parcelRequire("ixLVk");

var $45tk4 = parcelRequire("45tk4");

var $gS5ZA = parcelRequire("gS5ZA");

var $jAdIt = parcelRequire("jAdIt");
module.exports.VideoTrim = (0, $O1ETn.observer)(({ store: e, components: t, element: r })=>{
    const o = $5a04dae988a88123$var$react_1.default.useRef(null), [i, n] = $5a04dae988a88123$var$react_1.default.useState([]);
    $5a04dae988a88123$var$react_1.default.useEffect(()=>{
        n([]);
    }, [
        r.src
    ]);
    const a = (e, t)=>{
        e.preventDefault();
        const i = (e)=>{
            e.preventDefault();
            const { clientX: i } = e, { left: n, width: a } = o.current.getBoundingClientRect(), { src: s } = r, c = (i - n) / a;
            "start" === t ? r.set({
                startTime: Math.min(r.endTime, Math.max(0, c))
            }) : "end" === t && r.set({
                endTime: Math.min(1, Math.max(r.startTime, c))
            });
        };
        window.addEventListener("mousemove", i), window.addEventListener("mouseup", ()=>{
            window.removeEventListener("mousemove", i);
        });
    };
    return $5a04dae988a88123$var$react_1.default.createElement($ixLVk.Popover, {
        position: "bottom",
        onOpened: async ()=>{
            if (!r.src) return;
            if (i.length) return;
            const { width: e, height: t } = await (0, $jAdIt.getVideoSize)(r.src), a = e / t, { src: s } = r, c = o.current.offsetHeight, l = o.current.offsetWidth, d = c * a, u = Math.ceil(l / d), m = await (0, $jAdIt.getVideoDuration)(s), _ = document.createElement("video");
            _.crossOrigin = "anonymous", _.src = s;
            const p = document.createElement("canvas");
            p.width = 480;
            try {
                await new Promise((e, t)=>{
                    _.addEventListener("loadeddata", ()=>{
                        const t = _.videoWidth / _.videoHeight;
                        p.height = 480 / t, e();
                    }), _.addEventListener("error", t);
                }), n([]);
                for(let e = 0; e < u; e++){
                    const t = e * m / u, r = await (0, $jAdIt.getVideoObjectPreview)(_, p, t);
                    n((e)=>e.concat(r));
                }
            } catch (e) {
                console.error("Error generating previews:", e);
            }
        },
        content: $5a04dae988a88123$var$react_1.default.createElement($f5Zeh.Navbar, {
            style: {
                boxShadow: "none",
                backgroundColor: "transparent",
                width: "calc(100vw - 300px)"
            }
        }, $5a04dae988a88123$var$react_1.default.createElement($1Ym0q.NavbarGroup, null, $5a04dae988a88123$var$react_1.default.createElement($cQj25.NumericInput, {
            style: {
                width: "80px"
            },
            value: parseFloat((r.duration * (r.endTime - r.startTime) / 1e3).toFixed(2)),
            minorStepSize: .01,
            stepSize: .1,
            buttonPosition: "none",
            readOnly: !0
        }), $5a04dae988a88123$var$react_1.default.createElement("div", {
            style: {
                width: "calc(100vw - 420px)",
                height: "30px",
                display: "flex",
                position: "relative",
                overflow: "hidden",
                marginLeft: "10px"
            },
            ref: o
        }, i.map((e, t)=>$5a04dae988a88123$var$react_1.default.createElement("img", {
                key: t,
                src: e,
                style: {
                    width: "auto",
                    height: "100%",
                    objectFit: "cover"
                }
            })), $5a04dae988a88123$var$react_1.default.createElement("div", {
            style: {
                position: "absolute",
                top: "0",
                left: 0,
                width: 100 * r.startTime + "%",
                height: "30px",
                backgroundColor: "rgb(0, 0, 0, 0.5)"
            }
        }), $5a04dae988a88123$var$react_1.default.createElement("div", {
            style: {
                position: "absolute",
                top: "0",
                right: "0%",
                width: 100 - 100 * r.endTime + "%",
                height: "30px",
                backgroundColor: "rgb(0, 0, 0, 0.5)"
            }
        }), $5a04dae988a88123$var$react_1.default.createElement("div", {
            style: {
                position: "absolute",
                top: "0",
                left: 100 * r.startTime + "%",
                width: "10px",
                height: "30px",
                borderRadius: "0px",
                backgroundColor: "rgb(0, 161, 255, 0.9)",
                cursor: "ew-resize"
            },
            onMouseDown: (e)=>{
                a(e, "start");
            }
        }), $5a04dae988a88123$var$react_1.default.createElement("div", {
            style: {
                position: "absolute",
                top: "0",
                right: 100 - 100 * r.endTime + "%",
                width: "10px",
                height: "30px",
                borderRadius: "0px",
                backgroundColor: "rgb(0, 161, 255, 0.9)",
                cursor: "ew-resize"
            },
            onMouseDown: (e)=>{
                a(e, "end");
            }
        }))))
    }, $5a04dae988a88123$var$react_1.default.createElement($gUePa.Button, {
        icon: "cut",
        minimal: !0
    }, "Trim"));
});
const $5a04dae988a88123$var$PROPS_MAP = {
    VideoTrim: module.exports.VideoTrim,
    VideoAnimations: $45tk4.AnimationsPicker
};
module.exports.VideoToolbar = (0, $O1ETn.observer)(({ store: e, components: t })=>{
    const r = e.selectedElements, o = [
        "VideoTrim",
        $gS5ZA.flags.animationsEnabled && "VideoAnimations"
    ].filter((e)=>!!e), i = (0, $1hndE.extendToolbar)({
        type: "video",
        usedItems: o,
        components: t
    });
    return $5a04dae988a88123$var$react_1.default.createElement($1hndE.ElementContainer, {
        items: i,
        itemRender: (o)=>{
            const i = t[o] || $5a04dae988a88123$var$PROPS_MAP[o];
            return $5a04dae988a88123$var$react_1.default.createElement(i, {
                elements: r,
                element: r[0],
                store: e,
                key: o
            });
        }
    });
}), module.exports.default = module.exports.VideoToolbar;

});
parcelRegister("jAdIt", function(module, exports) {
"use strict";
async function $e41c04e02e7f0b9d$var$getVideoSize(e) {
    const t = document.createElement("video");
    t.crossOrigin = "anonymous", t.src = e, await t.play(), t.pause();
    const { videoWidth: i, videoHeight: o } = t;
    return {
        width: i,
        height: o
    };
}
async function $e41c04e02e7f0b9d$var$getVideoDuration(e) {
    const t = document.createElement("video");
    t.crossOrigin = "anonymous", t.src = e, await t.play(), t.pause();
    const { duration: i } = t;
    return i;
}
async function $e41c04e02e7f0b9d$var$getVideoPreview(e, t = 5) {
    return new Promise((i, o)=>{
        var r = document.createElement("video"), n = document.createElement("canvas");
        n.width = 480, n.height = 360;
        var d = n.getContext("2d");
        r.crossOrigin = "anonymous", r.src = e, r.addEventListener("error", (e)=>{
            o(e);
        }), r.addEventListener("loadeddata", function() {
            const e = r.videoWidth / r.videoHeight;
            n.width = 480, n.height = 480 / e, r.currentTime = t;
        }), r.addEventListener("seeked", function() {
            d.drawImage(r, 0, 0, n.width, n.height);
            try {
                var e = n.toDataURL();
                i(e);
            } catch (e) {
                o(e);
            }
        });
    });
}
async function $e41c04e02e7f0b9d$var$getVideoObjectPreview(e, t, i) {
    return new Promise((o, r)=>{
        const n = t.getContext("2d"), d = ()=>{
            try {
                n.drawImage(e, 0, 0, t.width, t.height);
                const i = t.toDataURL();
                o(i), e.removeEventListener("seeked", d);
            } catch (t) {
                r(t), e.removeEventListener("seeked", d);
            }
        };
        e.addEventListener("seeked", d), e.currentTime = i;
    });
}
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.getVideoObjectPreview = module.exports.getVideoPreview = module.exports.getVideoDuration = module.exports.getVideoSize = void 0, module.exports.getVideoSize = $e41c04e02e7f0b9d$var$getVideoSize, module.exports.getVideoDuration = $e41c04e02e7f0b9d$var$getVideoDuration, module.exports.getVideoPreview = $e41c04e02e7f0b9d$var$getVideoPreview, module.exports.getVideoObjectPreview = $e41c04e02e7f0b9d$var$getVideoObjectPreview;

});


parcelRegister("fZbac", function(module, exports) {
"use strict";
var $ba35365b5e8e3ca3$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.FigureToolbar = module.exports.FigureStroke = module.exports.FigureSettings = module.exports.FigureFill = void 0;

const $ba35365b5e8e3ca3$var$react_1 = $ba35365b5e8e3ca3$var$__importDefault((parcelRequire("8NFma")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

var $gUePa = parcelRequire("gUePa");
var $ixLVk = parcelRequire("ixLVk");
var $71KpR = parcelRequire("71KpR");
var $88Rzx = parcelRequire("88Rzx");

var $2rYZB = parcelRequire("2rYZB");

var $gUePa = parcelRequire("gUePa");
var $ixLVk = parcelRequire("ixLVk");
var $71KpR = parcelRequire("71KpR");
var $88Rzx = parcelRequire("88Rzx");

const $ba35365b5e8e3ca3$var$ZoStrokeWidth_1 = $ba35365b5e8e3ca3$var$__importDefault((parcelRequire("gUPEN")));

const $ba35365b5e8e3ca3$var$color_picker_1 = $ba35365b5e8e3ca3$var$__importDefault((parcelRequire("gaqum")));

var $45tk4 = parcelRequire("45tk4");

var $hPyFl = parcelRequire("hPyFl");

var $1hndE = parcelRequire("1hndE");

var $xARwM = parcelRequire("xARwM");

var $gS5ZA = parcelRequire("gS5ZA");
module.exports.FigureFill = (0, $O1ETn.observer)(({ elements: e, store: t })=>$ba35365b5e8e3ca3$var$react_1.default.createElement($ba35365b5e8e3ca3$var$color_picker_1.default, {
        value: e[0].fill,
        style: {
            marginRight: "5px"
        },
        gradientEnabled: !0,
        onChange: (r)=>t.history.transaction(()=>{
                e.forEach((e)=>{
                    e.set({
                        fill: r
                    });
                });
            }),
        store: t
    })), module.exports.FigureSettings = (0, $O1ETn.observer)(({ store: e, elements: t, element: r })=>{
    const i = (r)=>{
        e.history.transaction(()=>{
            t.forEach((e)=>{
                e.set(r);
            });
        });
    };
    return $ba35365b5e8e3ca3$var$react_1.default.createElement($ixLVk.Popover, {
        content: $ba35365b5e8e3ca3$var$react_1.default.createElement("div", {
            style: {
                padding: "15px",
                paddingTop: "15px",
                width: "270px"
            }
        }, $ba35365b5e8e3ca3$var$react_1.default.createElement("div", {
            style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                paddingBottom: "15px"
            }
        }, $ba35365b5e8e3ca3$var$react_1.default.createElement($gUePa.Button, {
            onClick: ()=>{
                i({
                    strokeWidth: 0
                });
            },
            active: 0 === t[0].strokeWidth,
            style: {
                width: "44px",
                height: "34px"
            },
            icon: $ba35365b5e8e3ca3$var$react_1.default.createElement($2rYZB.Disable, {
                size: 20
            })
        }), $ba35365b5e8e3ca3$var$react_1.default.createElement($gUePa.Button, {
            onClick: ()=>{
                i({
                    dash: [],
                    strokeWidth: t[0].strokeWidth || 10
                });
            },
            active: t[0].strokeWidth && 0 === t[0].dash.length
        }, $ba35365b5e8e3ca3$var$react_1.default.createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, $ba35365b5e8e3ca3$var$react_1.default.createElement("line", {
            x2: "24",
            y1: "50%",
            y2: "50%",
            stroke: "currentColor",
            strokeWidth: "2"
        }))), $ba35365b5e8e3ca3$var$react_1.default.createElement($gUePa.Button, {
            onClick: ()=>{
                i({
                    dash: [
                        4,
                        1
                    ],
                    strokeWidth: t[0].strokeWidth || 10
                });
            },
            active: t[0].strokeWidth && 4 === t[0].dash[0]
        }, $ba35365b5e8e3ca3$var$react_1.default.createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, $ba35365b5e8e3ca3$var$react_1.default.createElement("line", {
            x1: "-1",
            x2: "25",
            y1: "50%",
            y2: "50%",
            stroke: "currentColor",
            strokeDasharray: "12 2",
            strokeWidth: "2"
        }))), $ba35365b5e8e3ca3$var$react_1.default.createElement($gUePa.Button, {
            onClick: ()=>{
                i({
                    dash: [
                        2,
                        1
                    ],
                    strokeWidth: t[0].strokeWidth || 10
                });
            },
            active: t[0].strokeWidth && 2 === t[0].dash[0]
        }, $ba35365b5e8e3ca3$var$react_1.default.createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, $ba35365b5e8e3ca3$var$react_1.default.createElement("line", {
            x1: "1",
            x2: "23",
            y1: "50%",
            y2: "50%",
            stroke: "currentColor",
            strokeDasharray: "6 2",
            strokeWidth: "2"
        }))), $ba35365b5e8e3ca3$var$react_1.default.createElement($gUePa.Button, {
            onClick: ()=>{
                i({
                    dash: [
                        1,
                        1
                    ],
                    strokeWidth: t[0].strokeWidth || 10
                });
            },
            active: t[0].strokeWidth && 1 === t[0].dash[0]
        }, $ba35365b5e8e3ca3$var$react_1.default.createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, $ba35365b5e8e3ca3$var$react_1.default.createElement("line", {
            x1: "1",
            x2: "23",
            y1: "50%",
            y2: "50%",
            stroke: "currentColor",
            strokeDasharray: "2 2",
            strokeWidth: "2"
        })))), $ba35365b5e8e3ca3$var$react_1.default.createElement("div", {
            style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                paddingBottom: "5px"
            }
        }, $ba35365b5e8e3ca3$var$react_1.default.createElement("div", null, (0, $xARwM.t)("toolbar.strokeWidth")), $ba35365b5e8e3ca3$var$react_1.default.createElement("div", null, $ba35365b5e8e3ca3$var$react_1.default.createElement($hPyFl.NumberInput, {
            value: t[0].strokeWidth,
            onValueChange: (e)=>{
                i({
                    strokeWidth: e
                });
            },
            style: {
                width: "50px"
            },
            min: 0,
            max: Math.round(Math.min(r.width, r.height) / 2),
            buttonPosition: "none"
        }))), $ba35365b5e8e3ca3$var$react_1.default.createElement($88Rzx.Slider, {
            value: t[0].strokeWidth,
            onChange: (e)=>{
                i({
                    strokeWidth: e
                });
            },
            min: 0,
            max: Math.round(Math.min(r.width, r.height) / 2),
            labelRenderer: !1
        }), "rect" === r.subType && $ba35365b5e8e3ca3$var$react_1.default.createElement($ba35365b5e8e3ca3$var$react_1.default.Fragment, null, $ba35365b5e8e3ca3$var$react_1.default.createElement("div", {
            style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                paddingTop: "15px",
                paddingBottom: "5px"
            }
        }, $ba35365b5e8e3ca3$var$react_1.default.createElement("div", null, (0, $xARwM.t)("toolbar.cornerRadius")), $ba35365b5e8e3ca3$var$react_1.default.createElement("div", null, $ba35365b5e8e3ca3$var$react_1.default.createElement($hPyFl.NumberInput, {
            value: t[0].cornerRadius,
            onValueChange: (e)=>{
                i({
                    cornerRadius: e
                });
            },
            style: {
                width: "50px"
            },
            min: 0,
            max: Math.round(Math.max(r.width, r.height) / 2),
            buttonPosition: "none"
        }))), $ba35365b5e8e3ca3$var$react_1.default.createElement($88Rzx.Slider, {
            value: t[0].cornerRadius,
            onChange: (e)=>{
                i({
                    cornerRadius: e
                });
            },
            min: 0,
            max: Math.round(Math.max(r.width, r.height) / 2),
            labelRenderer: !1
        }))),
        position: $71KpR.Position.BOTTOM
    }, $ba35365b5e8e3ca3$var$react_1.default.createElement($gUePa.Button, {
        icon: $ba35365b5e8e3ca3$var$react_1.default.createElement($ba35365b5e8e3ca3$var$ZoStrokeWidth_1.default, null),
        minimal: !0
    }));
}), module.exports.FigureStroke = (0, $O1ETn.observer)(({ elements: e, store: t })=>e.find((e)=>e.strokeWidth) ? $ba35365b5e8e3ca3$var$react_1.default.createElement($ba35365b5e8e3ca3$var$color_picker_1.default, {
        value: e[0].stroke,
        style: {
            marginRight: "5px"
        },
        gradientEnabled: !1,
        onChange: (r)=>t.history.transaction(()=>{
                e.forEach((e)=>{
                    e.set({
                        stroke: r
                    });
                });
            }),
        store: t
    }) : null);
const $ba35365b5e8e3ca3$var$PROPS_MAP = {
    FigureFill: module.exports.FigureFill,
    FigureStroke: module.exports.FigureStroke,
    FigureSettings: module.exports.FigureSettings,
    FigureAnimations: $45tk4.AnimationsPicker,
    FigureFilters: $hPyFl.FiltersPicker
};
module.exports.FigureToolbar = (0, $O1ETn.observer)(({ store: e, components: t })=>{
    const r = e.selectedElements[0], i = [
        "FigureFill",
        "FigureStroke",
        "FigureSettings",
        "FigureFilters",
        $gS5ZA.flags.animationsEnabled && "FigureAnimations"
    ].filter((e)=>Boolean(e)), a = (0, $1hndE.extendToolbar)({
        type: "figure",
        usedItems: i,
        components: t
    });
    return $ba35365b5e8e3ca3$var$react_1.default.createElement($1hndE.ElementContainer, {
        items: a,
        itemRender: (i)=>{
            const a = t[i] || $ba35365b5e8e3ca3$var$PROPS_MAP[i];
            return $ba35365b5e8e3ca3$var$react_1.default.createElement(a, {
                element: r,
                store: e,
                key: i,
                elements: e.selectedElements
            });
        }
    });
}), module.exports.default = module.exports.FigureToolbar;

});
parcelRegister("2rYZB", function(module, exports) {

$parcel$export(module.exports, "Disable", () => $1c8d6a4589f629a0$export$7e5c1bb0bc1a6ffc);
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $8NFma = parcelRequire("8NFma");

var $leH9B = parcelRequire("leH9B");

var $eog74 = parcelRequire("eog74");
var $1c8d6a4589f629a0$export$7e5c1bb0bc1a6ffc = $8NFma.forwardRef(function(props, ref) {
    var isLarge = props.size >= (0, $leH9B.IconSize).LARGE;
    var pixelGridSize = isLarge ? (0, $leH9B.IconSize).LARGE : (0, $leH9B.IconSize).STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = {
        transformOrigin: "center"
    };
    return $8NFma.createElement((0, $eog74.SVGIconContainer), (0, $gztBd.__assign)({
        iconName: "disable",
        ref: ref
    }, props), $8NFma.createElement("path", {
        d: isLarge ? "M200 400C89.6 400 0 310.4 0 200C0 89.6 89.6 0 200 0S400 89.6 400 200C400 310.4 310.4 400 200 400zM40 200C40 288.4 111.6 360 200 360C237 360 271 347.4 298 326.2L73.8 102C52.6 129 40 163 40 200zM200 40C163 40 129 52.6 102 73.8L326.2 298C347.4000000000001 271 360 237 360 200C360 111.6 288.4 40 200 40z" : "M159.8 320.2C71.4 320.2 -0.2 248.6 -0.2 160.2S71.4 0.2 159.8 0.2S319.8 71.8 319.8 160.2S248.2 320.2 159.8 320.2zM39.8 160.2C39.8 226.4 93.6 280.2 159.8 280.2C185.8 280.2 209.6 271.8 229.2 257.8L62.2 90.8C48.2 110.4 39.8 134.2 39.8 160.2zM159.8 40.2C133.8 40.2 110 48.6 90.4 62.6L257.4 229.6C271.4 210 279.8 186.2 279.8 160.2C279.8 93.8 226.2 40.2 159.8 40.2z",
        fillRule: "evenodd",
        transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"),
        style: style
    }));
});
$1c8d6a4589f629a0$export$7e5c1bb0bc1a6ffc.defaultProps = {
    size: (0, $leH9B.IconSize).STANDARD
};
$1c8d6a4589f629a0$export$7e5c1bb0bc1a6ffc.displayName = "Blueprint5.Icon.Disable";
var $1c8d6a4589f629a0$export$2e2bcd8739ae039 = $1c8d6a4589f629a0$export$7e5c1bb0bc1a6ffc;

});

parcelRegister("gUPEN", function(module, exports) {
parcelRequire("kNUzI");
var $3H1D6 = parcelRequire("3H1D6");
var $c509f252f041b645$require$GenIcon = $3H1D6.GenIcon;
module.exports = function(props) {
    return $c509f252f041b645$require$GenIcon({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 0h20v5H0V0zm0 7h20v4H0V7zm0 6h20v3H0v-3zm0 5h20v2H0v-2z"
                }
            }
        ]
    })(props);
};

});


parcelRegister("7WWcq", function(module, exports) {
"use strict";
var $5c9b185f27c61fc1$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.ManyToolbar = void 0;

const $5c9b185f27c61fc1$var$react_1 = $5c9b185f27c61fc1$var$__importDefault((parcelRequire("8NFma")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

var $1hndE = parcelRequire("1hndE");

var $45tk4 = parcelRequire("45tk4");

var $gS5ZA = parcelRequire("gS5ZA");
const $5c9b185f27c61fc1$var$PROPS_MAP = {
    ManyAnimations: $45tk4.AnimationsPicker
};
module.exports.ManyToolbar = (0, $O1ETn.observer)(({ store: e, components: t })=>{
    const n = e.selectedElements, r = [
        $gS5ZA.flags.animationsEnabled && "ManyAnimations"
    ], a = (0, $1hndE.extendToolbar)({
        type: "many",
        usedItems: r,
        components: t
    });
    return $5c9b185f27c61fc1$var$react_1.default.createElement($1hndE.ElementContainer, {
        items: a,
        itemRender: (r)=>{
            const a = t[r] || $5c9b185f27c61fc1$var$PROPS_MAP[r];
            return $5c9b185f27c61fc1$var$react_1.default.createElement(a, {
                elements: n,
                element: n[0],
                store: e,
                key: r
            });
        }
    });
}), module.exports.default = module.exports.ManyToolbar;

});

parcelRegister("fQSAB", function(module, exports) {
"use strict";
var $b8a60ea726410060$var$__rest = module.exports && module.exports.__rest || function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var n = 0;
        for(a = Object.getOwnPropertySymbols(e); n < a.length; n++)t.indexOf(a[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    }
    return r;
}, $b8a60ea726410060$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.PageToolbar = module.exports.NumberInput = void 0;

const $b8a60ea726410060$var$react_1 = $b8a60ea726410060$var$__importDefault((parcelRequire("8NFma")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

var $gUePa = parcelRequire("gUePa");
var $cQj25 = parcelRequire("cQj25");
var $ixLVk = parcelRequire("ixLVk");
var $88Rzx = parcelRequire("88Rzx");

var $gUePa = parcelRequire("gUePa");
var $cQj25 = parcelRequire("cQj25");
var $ixLVk = parcelRequire("ixLVk");
var $88Rzx = parcelRequire("88Rzx");

var $1hndE = parcelRequire("1hndE");

var $xARwM = parcelRequire("xARwM");

var $gS5ZA = parcelRequire("gS5ZA");
const $b8a60ea726410060$var$NumberInput = (e)=>{
    var { value: t, onValueChange: r } = e, a = $b8a60ea726410060$var$__rest(e, [
        "value",
        "onValueChange"
    ]);
    const [n, o] = $b8a60ea726410060$var$react_1.default.useState(t.toString());
    $b8a60ea726410060$var$react_1.default.useEffect(()=>{
        o(t.toString());
    }, [
        t
    ]);
    return $b8a60ea726410060$var$react_1.default.createElement($cQj25.NumericInput, Object.assign({
        value: n,
        onValueChange: (e, t)=>{
            o(t), Number.isNaN(e) || r(e);
        }
    }, a));
};
module.exports.NumberInput = $b8a60ea726410060$var$NumberInput;
const $b8a60ea726410060$var$PageDuration = (0, $O1ETn.observer)(({ store: e })=>{
    if (!e.activePage) return null;
    const { duration: t } = e.activePage;
    return $b8a60ea726410060$var$react_1.default.createElement($ixLVk.Popover, {
        position: "bottom",
        content: $b8a60ea726410060$var$react_1.default.createElement("div", {
            style: {
                padding: "15px",
                paddingTop: "15px",
                width: "230px"
            }
        }, $b8a60ea726410060$var$react_1.default.createElement("div", {
            style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                paddingTop: "5px",
                paddingBottom: "5px"
            }
        }, $b8a60ea726410060$var$react_1.default.createElement("div", null, (0, $xARwM.t)("toolbar.duration")), $b8a60ea726410060$var$react_1.default.createElement("div", null, $b8a60ea726410060$var$react_1.default.createElement(module.exports.NumberInput, {
            value: t / 1e3,
            onValueChange: (t)=>{
                e.activePage.set({
                    duration: 1e3 * t
                });
            },
            style: {
                width: "50px"
            },
            min: 0,
            buttonPosition: "none"
        }))), $b8a60ea726410060$var$react_1.default.createElement($88Rzx.Slider, {
            value: Math.min(t / 1e3, 50),
            onChange: (t)=>{
                e.activePage.set({
                    duration: 1e3 * t
                });
            },
            min: 0,
            max: 50,
            showTrackFill: !1,
            labelRenderer: !1
        }))
    }, $b8a60ea726410060$var$react_1.default.createElement($gUePa.Button, {
        icon: "time",
        minimal: !0
    }, (e.activePage.duration / 1e3).toFixed(1), "s"));
}), $b8a60ea726410060$var$PROPS_MAP = {
    PageDuration: $b8a60ea726410060$var$PageDuration
};
module.exports.PageToolbar = (0, $O1ETn.observer)(({ store: e, components: t })=>{
    const r = [
        $gS5ZA.flags.animationsEnabled && "PageDuration"
    ].filter((e)=>!!e), a = (0, $1hndE.extendToolbar)({
        type: "page",
        usedItems: r,
        components: t
    });
    return $b8a60ea726410060$var$react_1.default.createElement($1hndE.ElementContainer, {
        items: a,
        itemRender: (r)=>{
            const a = t[r] || $b8a60ea726410060$var$PROPS_MAP[r];
            return $b8a60ea726410060$var$react_1.default.createElement(a, {
                store: e,
                key: r
            });
        }
    });
}), module.exports.default = module.exports.PageToolbar;

});

parcelRegister("318Bb", function(module, exports) {
"use strict";
var $2328229c468c7b4b$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.DownloadButton = void 0;

const $2328229c468c7b4b$var$react_1 = $2328229c468c7b4b$var$__importDefault((parcelRequire("8NFma")));

var $gUePa = parcelRequire("gUePa");
var $7RyvK = parcelRequire("7RyvK");
var $2IwH6 = parcelRequire("2IwH6");
var $ixLVk = parcelRequire("ixLVk");
var $71KpR = parcelRequire("71KpR");

var $xARwM = parcelRequire("xARwM");
const $2328229c468c7b4b$var$DownloadButton = ({ store: e })=>{
    const [t, o] = $2328229c468c7b4b$var$react_1.default.useState(!1);
    return $2328229c468c7b4b$var$react_1.default.createElement($ixLVk.Popover, {
        content: $2328229c468c7b4b$var$react_1.default.createElement($7RyvK.Menu, null, $2328229c468c7b4b$var$react_1.default.createElement($2IwH6.MenuItem, {
            icon: "media",
            text: (0, $xARwM.t)("toolbar.saveAsImage"),
            onClick: async ()=>{
                e.pages.forEach((t)=>{
                    e.saveAsImage({
                        pageId: t.id
                    });
                });
            }
        }), $2328229c468c7b4b$var$react_1.default.createElement($2IwH6.MenuItem, {
            icon: "document",
            text: (0, $xARwM.t)("toolbar.saveAsPDF"),
            onClick: async ()=>{
                o(!0), await e.saveAsPDF(), o(!1);
            }
        })),
        position: $71KpR.Position.BOTTOM
    }, $2328229c468c7b4b$var$react_1.default.createElement($gUePa.Button, {
        icon: "import",
        text: (0, $xARwM.t)("toolbar.download"),
        minimal: !0,
        loading: t
    }));
};
module.exports.DownloadButton = $2328229c468c7b4b$var$DownloadButton, module.exports.default = module.exports.DownloadButton;

});

parcelRegister("9d0Is", function(module, exports) {
"use strict";
var $6b45e227916a62e6$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.LockButton = void 0;

const $6b45e227916a62e6$var$react_1 = $6b45e227916a62e6$var$__importDefault((parcelRequire("8NFma")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

var $gUePa = parcelRequire("gUePa");
var $gVVt3 = parcelRequire("gVVt3");

var $xARwM = parcelRequire("xARwM");
module.exports.LockButton = (0, $O1ETn.observer)(({ store: e })=>{
    const t = e.selectedShapes.length > 0, o = e.selectedShapes[0], r = null == o ? void 0 : o.locked, l = r ? "lock" : "unlock", c = r ? (0, $xARwM.t)("toolbar.lockedDescription") : (0, $xARwM.t)("toolbar.unlockedDescription");
    return $6b45e227916a62e6$var$react_1.default.createElement($gVVt3.Tooltip, {
        content: c,
        disabled: !t,
        position: "bottom"
    }, $6b45e227916a62e6$var$react_1.default.createElement($gUePa.Button, {
        minimal: !0,
        disabled: !t,
        icon: l,
        onClick: ()=>{
            e.selectedShapes.forEach((e)=>e.set({
                    draggable: r,
                    contentEditable: r,
                    styleEditable: r,
                    resizable: r
                }));
        }
    }));
});

});

parcelRegister("aTTDL", function(module, exports) {
"use strict";
var $7efa33742935a214$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.OpacityPicker = void 0;

const $7efa33742935a214$var$react_1 = $7efa33742935a214$var$__importDefault((parcelRequire("8NFma")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

var $gUePa = parcelRequire("gUePa");
var $cQj25 = parcelRequire("cQj25");
var $ixLVk = parcelRequire("ixLVk");
var $71KpR = parcelRequire("71KpR");
var $88Rzx = parcelRequire("88Rzx");
var $gVVt3 = parcelRequire("gVVt3");

var $gUePa = parcelRequire("gUePa");
var $cQj25 = parcelRequire("cQj25");
var $ixLVk = parcelRequire("ixLVk");
var $71KpR = parcelRequire("71KpR");
var $88Rzx = parcelRequire("88Rzx");
var $gVVt3 = parcelRequire("gVVt3");

const $7efa33742935a214$var$MdOpacity_1 = $7efa33742935a214$var$__importDefault((parcelRequire("1GHsO")));

var $xARwM = parcelRequire("xARwM");
module.exports.OpacityPicker = (0, $O1ETn.observer)(({ store: e })=>{
    var t;
    const r = e.selectedShapes.length > 0, a = (t)=>{
        t = Math.max(0, Math.min(t, 100)), e.selectedShapes.forEach((e)=>{
            e.set({
                opacity: t / 100
            });
        });
    }, l = Math.round(100 * (null === (t = e.selectedShapes[0]) || void 0 === t ? void 0 : t.opacity));
    return $7efa33742935a214$var$react_1.default.createElement($ixLVk.Popover, {
        disabled: !r,
        minimal: !1,
        content: $7efa33742935a214$var$react_1.default.createElement("div", {
            style: {
                padding: "10px 20px"
            }
        }, $7efa33742935a214$var$react_1.default.createElement("div", {
            style: {
                textAlign: "center"
            }
        }, (0, $xARwM.t)("toolbar.transparency")), $7efa33742935a214$var$react_1.default.createElement("div", {
            style: {
                display: "flex"
            }
        }, $7efa33742935a214$var$react_1.default.createElement("div", {
            style: {
                paddingTop: "8px",
                paddingRight: "20px"
            }
        }, $7efa33742935a214$var$react_1.default.createElement($88Rzx.Slider, {
            value: l,
            labelRenderer: !1,
            onChange: a,
            min: 0,
            max: 100
        })), $7efa33742935a214$var$react_1.default.createElement($cQj25.NumericInput, {
            value: l,
            onValueChange: a,
            min: 0,
            max: 100,
            buttonPosition: "none",
            style: {
                width: "50px"
            },
            selectAllOnFocus: !0
        }))),
        position: $71KpR.Position.BOTTOM
    }, $7efa33742935a214$var$react_1.default.createElement($gVVt3.Tooltip, {
        content: (0, $xARwM.t)("toolbar.transparency"),
        disabled: !r,
        position: $71KpR.Position.BOTTOM
    }, $7efa33742935a214$var$react_1.default.createElement($gUePa.Button, {
        minimal: !0,
        disabled: !r
    }, $7efa33742935a214$var$react_1.default.createElement($7efa33742935a214$var$MdOpacity_1.default, {
        className: "bp5-icon",
        style: {
            fontSize: "20px"
        }
    }))));
});

});
parcelRegister("1GHsO", function(module, exports) {
parcelRequire("kNUzI");
var $3H1D6 = parcelRequire("3H1D6");
var $13ab6dafe2c98900$require$GenIcon = $3H1D6.GenIcon;
module.exports = function(props) {
    return $13ab6dafe2c98900$require$GenIcon({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "currentColor"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.66 8L12 2.35 6.34 8C4.78 9.56 4 11.64 4 13.64s.78 4.11 2.34 5.67 3.61 2.35 5.66 2.35 4.1-.79 5.66-2.35S20 15.64 20 13.64 19.22 9.56 17.66 8zM6 14c.01-2 .62-3.27 1.76-4.4L12 5.27l4.24 4.38C17.38 10.77 17.99 12 18 14H6z"
                }
            }
        ]
    })(props);
};

});


parcelRegister("tJXKh", function(module, exports) {
"use strict";
var $05965cc5453cfc7e$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.AdminButton = void 0;

const $05965cc5453cfc7e$var$react_1 = $05965cc5453cfc7e$var$__importDefault((parcelRequire("8NFma")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

var $2nesQ = parcelRequire("2nesQ");
var $gUePa = parcelRequire("gUePa");
var $ixLVk = parcelRequire("ixLVk");
var $71KpR = parcelRequire("71KpR");
var $5r5rj = parcelRequire("5r5rj");

var $2nesQ = parcelRequire("2nesQ");
var $gUePa = parcelRequire("gUePa");
var $ixLVk = parcelRequire("ixLVk");
var $71KpR = parcelRequire("71KpR");
var $5r5rj = parcelRequire("5r5rj");

var $xARwM = parcelRequire("xARwM");
module.exports.AdminButton = (0, $O1ETn.observer)(({ store: e })=>{
    const t = e.selectedElements.length > 0, a = e.selectedElements[0] || {}, l = (t)=>{
        e.selectedElements.forEach((e)=>{
            e.set(t);
        });
    };
    return $05965cc5453cfc7e$var$react_1.default.createElement($ixLVk.Popover, {
        disabled: !t,
        minimal: !1,
        content: $05965cc5453cfc7e$var$react_1.default.createElement("div", {
            style: {
                padding: "15px",
                paddingTop: "25px",
                width: "220px"
            }
        }, $05965cc5453cfc7e$var$react_1.default.createElement($5r5rj.Switch, {
            checked: a.selectable,
            label: (0, $xARwM.t)("toolbar.selectable"),
            onChange: (e)=>{
                l({
                    selectable: e.target.checked
                });
            },
            alignIndicator: $2nesQ.Alignment.RIGHT
        }), $05965cc5453cfc7e$var$react_1.default.createElement($5r5rj.Switch, {
            checked: a.draggable,
            label: (0, $xARwM.t)("toolbar.draggable"),
            onChange: (e)=>{
                l({
                    draggable: e.target.checked
                });
            },
            alignIndicator: $2nesQ.Alignment.RIGHT
        }), $05965cc5453cfc7e$var$react_1.default.createElement($5r5rj.Switch, {
            checked: a.removable,
            label: (0, $xARwM.t)("toolbar.removable"),
            onChange: (e)=>{
                l({
                    removable: e.target.checked
                });
            },
            alignIndicator: $2nesQ.Alignment.RIGHT
        }), $05965cc5453cfc7e$var$react_1.default.createElement($5r5rj.Switch, {
            checked: a.resizable,
            label: (0, $xARwM.t)("toolbar.resizable"),
            onChange: (e)=>{
                l({
                    resizable: e.target.checked
                });
            },
            alignIndicator: $2nesQ.Alignment.RIGHT
        }), $05965cc5453cfc7e$var$react_1.default.createElement($5r5rj.Switch, {
            checked: a.contentEditable,
            label: (0, $xARwM.t)("toolbar.contentEditable"),
            onChange: (e)=>{
                l({
                    contentEditable: e.target.checked
                });
            },
            alignIndicator: $2nesQ.Alignment.RIGHT
        }), $05965cc5453cfc7e$var$react_1.default.createElement($5r5rj.Switch, {
            checked: a.styleEditable,
            label: (0, $xARwM.t)("toolbar.styleEditable"),
            onChange: (e)=>{
                l({
                    styleEditable: e.target.checked
                });
            },
            alignIndicator: $2nesQ.Alignment.RIGHT
        }), $05965cc5453cfc7e$var$react_1.default.createElement($5r5rj.Switch, {
            checked: a.alwaysOnTop,
            label: (0, $xARwM.t)("toolbar.alwaysOnTop"),
            onChange: (e)=>{
                l({
                    alwaysOnTop: e.target.checked
                });
            },
            alignIndicator: $2nesQ.Alignment.RIGHT,
            style: {
                marginTop: "20px"
            }
        }), $05965cc5453cfc7e$var$react_1.default.createElement($5r5rj.Switch, {
            checked: a.showInExport,
            label: (0, $xARwM.t)("toolbar.showInExport"),
            onChange: (e)=>{
                l({
                    showInExport: e.target.checked
                });
            },
            alignIndicator: $2nesQ.Alignment.RIGHT,
            style: {
                marginTop: "20px"
            }
        })),
        position: $71KpR.Position.BOTTOM
    }, $05965cc5453cfc7e$var$react_1.default.createElement($gUePa.Button, {
        icon: "cog",
        minimal: !0,
        disabled: !t
    }));
});

});

parcelRegister("2GDSi", function(module, exports) {
"use strict";
var $1f4e6f4907ebcaa4$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.GroupButton = void 0;

const $1f4e6f4907ebcaa4$var$react_1 = $1f4e6f4907ebcaa4$var$__importDefault((parcelRequire("8NFma")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

var $gUePa = parcelRequire("gUePa");

var $xARwM = parcelRequire("xARwM");
module.exports.GroupButton = (0, $O1ETn.observer)(({ store: e })=>{
    const t = e.selectedElements.length > 1, r = 1 === e.selectedElements.length && "group" === e.selectedElements[0].type;
    return $1f4e6f4907ebcaa4$var$react_1.default.createElement($1f4e6f4907ebcaa4$var$react_1.default.Fragment, null, t && $1f4e6f4907ebcaa4$var$react_1.default.createElement($gUePa.Button, {
        minimal: !0,
        onClick: ()=>{
            e.groupElements(e.selectedElements.map((e)=>e.id));
        },
        style: {
            marginLeft: "auto"
        }
    }, (0, $xARwM.t)("toolbar.groupElements")), r && $1f4e6f4907ebcaa4$var$react_1.default.createElement($gUePa.Button, {
        minimal: !0,
        onClick: ()=>{
            e.ungroupElements([
                e.selectedElements[0].id
            ]);
        },
        style: {
            marginLeft: "auto"
        }
    }, (0, $xARwM.t)("toolbar.ungroupElements")));
});

});


parcelRegister("g2Mt0", function(module, exports) {
"use strict";
var $bae26dbb6c723774$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.SidePanel = module.exports.INTERNAL_SECTIONS = module.exports.DEFAULT_SECTIONS = module.exports.SizeSection = module.exports.LayersSection = module.exports.PagesSection = module.exports.BackgroundSection = module.exports.UploadSection = module.exports.ElementsSection = module.exports.PhotosSection = module.exports.TextSection = module.exports.TemplatesSection = module.exports.ImagesGrid = module.exports.SectionTab = void 0;

const $bae26dbb6c723774$var$react_1 = $bae26dbb6c723774$var$__importDefault((parcelRequire("8NFma")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

var $gKgL3 = parcelRequire("gKgL3");

const $bae26dbb6c723774$var$styled_1 = $bae26dbb6c723774$var$__importDefault((parcelRequire("MPenY")));

var $3pcZ0 = parcelRequire("3pcZ0");

const $bae26dbb6c723774$var$FaShapes_1 = $bae26dbb6c723774$var$__importDefault((parcelRequire("WkWeX")));

const $bae26dbb6c723774$var$FdPageMultiple_1 = $bae26dbb6c723774$var$__importDefault((parcelRequire("eEO1Q")));

var $xARwM = parcelRequire("xARwM");

var $bfIoN = parcelRequire("bfIoN");

var $bfIoN = parcelRequire("bfIoN");
Object.defineProperty(module.exports, "SectionTab", {
    enumerable: !0,
    get: function() {
        return $bfIoN.SectionTab;
    }
});

var $eRKBF = parcelRequire("eRKBF");
Object.defineProperty(module.exports, "ImagesGrid", {
    enumerable: !0,
    get: function() {
        return $eRKBF.ImagesGrid;
    }
});

var $C4z2B = parcelRequire("C4z2B");

var $fpO7i = parcelRequire("fpO7i");

var $bSvr9 = parcelRequire("bSvr9");

var $4b0wY = parcelRequire("4b0wY");

var $hW0dp = parcelRequire("hW0dp");

var $jtIqq = parcelRequire("jtIqq");

var $2b3so = parcelRequire("2b3so");

var $l6SsR = parcelRequire("l6SsR");

var $h445m = parcelRequire("h445m");

var $ekVtW = parcelRequire("ekVtW");
module.exports.TemplatesSection = {
    name: "templates",
    Tab: (0, $O1ETn.observer)((e)=>$bae26dbb6c723774$var$react_1.default.createElement($bfIoN.SectionTab, Object.assign({
            name: (0, $xARwM.t)("sidePanel.templates")
        }, e), $bae26dbb6c723774$var$react_1.default.createElement($gKgL3.Icon, {
            icon: "control"
        }))),
    Panel: ({ store: e })=>$bae26dbb6c723774$var$react_1.default.createElement($l6SsR.TemplatesPanel, {
            store: e
        })
}, module.exports.TextSection = {
    name: "text",
    Tab: (0, $O1ETn.observer)((e)=>$bae26dbb6c723774$var$react_1.default.createElement($bfIoN.SectionTab, Object.assign({
            name: (0, $xARwM.t)("sidePanel.text")
        }, e), $bae26dbb6c723774$var$react_1.default.createElement($gKgL3.Icon, {
            icon: "new-text-box"
        }))),
    Panel: ({ store: e })=>$bae26dbb6c723774$var$react_1.default.createElement($C4z2B.TextPanel, {
            store: e
        })
}, module.exports.PhotosSection = {
    name: "photos",
    Tab: (0, $O1ETn.observer)((e)=>$bae26dbb6c723774$var$react_1.default.createElement($bfIoN.SectionTab, Object.assign({
            name: (0, $xARwM.t)("sidePanel.photos")
        }, e), $bae26dbb6c723774$var$react_1.default.createElement($gKgL3.Icon, {
            icon: "media"
        }))),
    Panel: ({ store: e })=>$bae26dbb6c723774$var$react_1.default.createElement($4b0wY.PhotosPanel, {
            store: e
        })
}, module.exports.ElementsSection = {
    name: "elements",
    Tab: (0, $O1ETn.observer)((e)=>$bae26dbb6c723774$var$react_1.default.createElement($bfIoN.SectionTab, Object.assign({
            name: (0, $xARwM.t)("sidePanel.elements"),
            iconSize: 16
        }, e), $bae26dbb6c723774$var$react_1.default.createElement("span", {
            className: "bp5-icon"
        }, $bae26dbb6c723774$var$react_1.default.createElement($bae26dbb6c723774$var$FaShapes_1.default, null)))),
    Panel: ({ store: e })=>$bae26dbb6c723774$var$react_1.default.createElement($jtIqq.ElementsPanel, {
            store: e
        })
}, module.exports.UploadSection = {
    name: "upload",
    Tab: (0, $O1ETn.observer)((e)=>$bae26dbb6c723774$var$react_1.default.createElement($bfIoN.SectionTab, Object.assign({
            name: (0, $xARwM.t)("sidePanel.upload")
        }, e), $bae26dbb6c723774$var$react_1.default.createElement($gKgL3.Icon, {
            icon: "cloud-upload"
        }))),
    Panel: ({ store: e })=>$bae26dbb6c723774$var$react_1.default.createElement($bSvr9.UploadPanel, {
            store: e
        })
}, module.exports.BackgroundSection = {
    name: "background",
    Tab: (0, $O1ETn.observer)((e)=>$bae26dbb6c723774$var$react_1.default.createElement($bfIoN.SectionTab, Object.assign({
            name: (0, $xARwM.t)("sidePanel.background")
        }, e), $bae26dbb6c723774$var$react_1.default.createElement($gKgL3.Icon, {
            icon: "layout-grid"
        }))),
    Panel: ({ store: e })=>$bae26dbb6c723774$var$react_1.default.createElement($hW0dp.BackgroundPanel, {
            store: e
        })
}, module.exports.PagesSection = {
    name: "pages",
    Tab: (0, $O1ETn.observer)((e)=>$bae26dbb6c723774$var$react_1.default.createElement($bfIoN.SectionTab, Object.assign({
            name: (0, $xARwM.t)("sidePanel.pages")
        }, e), $bae26dbb6c723774$var$react_1.default.createElement($bae26dbb6c723774$var$FdPageMultiple_1.default, null))),
    Panel: ({ store: e })=>$bae26dbb6c723774$var$react_1.default.createElement($2b3so.PagesPanel, {
            store: e
        }),
    visibleInList: !1
}, module.exports.LayersSection = {
    name: "layers",
    Tab: (0, $O1ETn.observer)((e)=>$bae26dbb6c723774$var$react_1.default.createElement($bfIoN.SectionTab, Object.assign({
            name: (0, $xARwM.t)("sidePanel.layers")
        }, e), $bae26dbb6c723774$var$react_1.default.createElement($gKgL3.Icon, {
            icon: "layers"
        }))),
    Panel: ({ store: e })=>$bae26dbb6c723774$var$react_1.default.createElement($h445m.LayersPanel, {
            store: e
        })
}, module.exports.SizeSection = {
    name: "size",
    Tab: (0, $O1ETn.observer)((e)=>$bae26dbb6c723774$var$react_1.default.createElement($bfIoN.SectionTab, Object.assign({
            name: (0, $xARwM.t)("sidePanel.resize")
        }, e), $bae26dbb6c723774$var$react_1.default.createElement($gKgL3.Icon, {
            icon: "fullscreen"
        }))),
    Panel: ({ store: e })=>$bae26dbb6c723774$var$react_1.default.createElement($fpO7i.SizePanel, {
            store: e
        })
};
const $bae26dbb6c723774$var$MoreTab = (0, $O1ETn.observer)((e)=>$bae26dbb6c723774$var$react_1.default.createElement($bfIoN.SectionTab, Object.assign({
        name: (0, $xARwM.t)("sidePanel.more")
    }, e), $bae26dbb6c723774$var$react_1.default.createElement($gKgL3.Icon, {
        icon: "more"
    })));
module.exports.DEFAULT_SECTIONS = [
    module.exports.TemplatesSection,
    module.exports.TextSection,
    module.exports.PhotosSection,
    module.exports.ElementsSection,
    module.exports.UploadSection,
    module.exports.BackgroundSection,
    module.exports.LayersSection,
    module.exports.SizeSection
];
const $bae26dbb6c723774$var$ImageClipSection = {
    name: "image-clip",
    Tab: ()=>null,
    Panel: $ekVtW.ImageClipPanel
};
module.exports.INTERNAL_SECTIONS = [
    $bae26dbb6c723774$var$ImageClipSection
];
const $bae26dbb6c723774$var$SidePanelContainer = (0, $bae26dbb6c723774$var$styled_1.default)("div")`
  display: flex;
  height: 100% !important;
  padding: 0px !important;
  position: relative;

  ${(0, $3pcZ0.mobileStyle)("\n    height: auto !important;\n    width: 100%;\n    position: relative;\n  ")}
`, $bae26dbb6c723774$var$TabsWrap = (0, $bae26dbb6c723774$var$styled_1.default)("div", $bae26dbb6c723774$var$react_1.default.forwardRef)`
  @media screen and (min-width: 501px) {
    overflow-y: auto;
    overflow-x: hidden;
    min-width: 72px;
  }
  ${(0, $3pcZ0.mobileStyle)("\n    width: 100%;\n    overflow: auto;\n  ")}
`, $bae26dbb6c723774$var$TabsContainer = (0, $bae26dbb6c723774$var$styled_1.default)("div", $bae26dbb6c723774$var$react_1.default.forwardRef)`
  display: flex;
  flex-direction: column;

  ${(0, $3pcZ0.mobileStyle)("\n    flex-direction: row;\n    min-width: min-content;\n  ")}
`, $bae26dbb6c723774$var$PanelContainer = (0, $bae26dbb6c723774$var$styled_1.default)("div")`
  padding: 10px 10px 0px 10px !important;
  height: 100% !important;

  &.bp5-navbar {
    width: 350px;
  }

  &.bp5-navbar.collapsed {
    width: 0px;
  }

  ${(0, $3pcZ0.mobileStyle)("\n    &.bp5-navbar {\n      position: absolute;\n      bottom: 54px;\n      z-index: 100;\n      height: 50vh !important;\n      width: 100%;\n    }\n  ")}
`, $bae26dbb6c723774$var$MobileOverlay = (0, $bae26dbb6c723774$var$styled_1.default)("div")`
  display: none;

  ${(0, $3pcZ0.mobileStyle)("\n    position: absolute;\n    bottom: 72px;\n    display: block;\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, 0.05);\n  ")}
`, $bae26dbb6c723774$var$HideButtonContainer = (0, $bae26dbb6c723774$var$styled_1.default)("div")`
  position: absolute;
  right: -14px;
  top: 50%;
  height: 96px;
  width: 15px;
  fill: white;
  cursor: pointer;
  z-index: 10;

  .bp5-dark & {
    right: -13px;
  }

  & .stroke {
    stroke: rgba(0, 0, 0, 0.3);
    fill: none;
  }

  & .fill {
    fill: white;
  }

  .bp5-dark & .fill {
    fill: #2f343c;
  }

  & .pointer {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scaleY(2);
    font-size: 0.5rem;
    color: rgba(171, 179, 191, 0.6);
  }

  .bp5-dark & .pointer {
    color: rgba(171, 179, 191, 0.6);
  }

  &:hover .pointer {
    color: black;
  }

  .bp5-dark &:hover .pointer {
    color: white;
  }

  ${(0, $3pcZ0.mobileStyle)("\n    display: none;\n  ")}
`, $bae26dbb6c723774$var$HideButton = ({ onClick: e })=>$bae26dbb6c723774$var$react_1.default.createElement($bae26dbb6c723774$var$HideButtonContainer, {
        onClick: e
    }, $bae26dbb6c723774$var$react_1.default.createElement("svg", {
        width: "15",
        height: "96",
        viewBox: "0 0 16 96",
        xmlns: "http://www.w3.org/2000/svg"
    }, $bae26dbb6c723774$var$react_1.default.createElement("path", {
        className: "fill stroke",
        d: "M 1 7 C 2 9 4 10 7.2 13.28 C 7.45 13.4625 7.6 13.6 7.7 13.8048 L 7.8 13.8 C 9.8 15.8 11.6 17.6 12.9 19.7 C 14 21.6 14.7 23.9 14.9 27 H 15 V 68 C 15 71.7 14.3 74.3 13 76.6 C 11.7 78.8 9.9 80.5 7.8 82.6344 L 7.79 82.6 C 7.6 82.8 7.4507 83 7.2729 83.2127 C 3.9102 86.5228 2 87 1 90"
    })), $bae26dbb6c723774$var$react_1.default.createElement("div", {
        className: "pointer"
    }, "<")), $bae26dbb6c723774$var$useOnFirstRender = (e)=>{
    const t = $bae26dbb6c723774$var$react_1.default.useRef(!0);
    t.current && (t.current = !1, e());
};
module.exports.SidePanel = (0, $O1ETn.observer)(({ store: e, sections: t, defaultSection: a })=>{
    var n;
    $bae26dbb6c723774$var$useOnFirstRender(()=>{
        e.openSidePanel(a || "photos");
    });
    const r = [
        ...t || module.exports.DEFAULT_SECTIONS,
        ...module.exports.INTERNAL_SECTIONS
    ], o = r.filter((e)=>{
        var t;
        return null === (t = e.visibleInList) || void 0 === t || t;
    }), l = null === (n = r.find((t)=>t.name === e.openedSidePanel)) || void 0 === n ? void 0 : n.Panel, i = (0, $3pcZ0.useMobile)();
    $bae26dbb6c723774$var$react_1.default.useLayoutEffect(()=>{
        i ? e.openSidePanel("") : e.openSidePanel(a || "photos");
    }, [
        i
    ]);
    const s = $bae26dbb6c723774$var$react_1.default.useRef(null);
    return $bae26dbb6c723774$var$react_1.default.createElement($bae26dbb6c723774$var$SidePanelContainer, {
        className: "bp5-navbar polotno-side-panel" + (e.openedSidePanel ? "" : " collapsed")
    }, $bae26dbb6c723774$var$react_1.default.createElement($bae26dbb6c723774$var$TabsWrap, {
        ref: s,
        className: "polotno-side-tabs-container"
    }, $bae26dbb6c723774$var$react_1.default.createElement($bae26dbb6c723774$var$TabsContainer, {
        className: "polotno-side-tabs-inner"
    }, o.map(({ name: t, Tab: a })=>$bae26dbb6c723774$var$react_1.default.createElement(a, {
            key: t,
            active: t === e.openedSidePanel,
            onClick: ()=>{
                t === e.openedSidePanel && i ? e.openSidePanel("") : e.openSidePanel(t);
            }
        })))), l && $bae26dbb6c723774$var$react_1.default.createElement($bae26dbb6c723774$var$PanelContainer, {
        className: "bp5-navbar polotno-panel-container",
        onClick: (t)=>{
            const a = t.target.closest(".polotno-close-panel"), n = t.target.closest(".polotno-mobile");
            a && (i || n) && e.openSidePanel("");
        }
    }, $bae26dbb6c723774$var$react_1.default.createElement(l, {
        store: e
    })), e.openedSidePanel && $bae26dbb6c723774$var$react_1.default.createElement($bae26dbb6c723774$var$MobileOverlay, {
        onClick: ()=>e.openSidePanel("")
    }), e.openedSidePanel && $bae26dbb6c723774$var$react_1.default.createElement($bae26dbb6c723774$var$HideButton, {
        onClick: ()=>e.openSidePanel("")
    }));
}), module.exports.default = module.exports.SidePanel;

});
parcelRegister("WkWeX", function(module, exports) {
parcelRequire("kNUzI");
var $3H1D6 = parcelRequire("3H1D6");
var $0af5a8d0ea98c468$require$GenIcon = $3H1D6.GenIcon;
module.exports = function(props) {
    return $0af5a8d0ea98c468$require$GenIcon({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512",
            "fill": "currentColor"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128,256A128,128,0,1,0,256,384,128,128,0,0,0,128,256Zm379-54.86L400.07,18.29a37.26,37.26,0,0,0-64.14,0L229,201.14C214.76,225.52,232.58,256,261.09,256H474.91C503.42,256,521.24,225.52,507,201.14ZM480,288H320a32,32,0,0,0-32,32V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V320A32,32,0,0,0,480,288Z"
                }
            }
        ]
    })(props);
};

});

parcelRegister("eEO1Q", function(module, exports) {
parcelRequire("kNUzI");
var $3H1D6 = parcelRequire("3H1D6");
var $aabb9bcdf3271c8d$require$GenIcon = $3H1D6.GenIcon;
module.exports = function(props) {
    return $aabb9bcdf3271c8d$require$GenIcon({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "id": "Layer_1",
            "x": "0px",
            "y": "0px",
            "viewBox": "0 0 100 100",
            "enableBackground": "new 0 0 100 100",
            "fill": "currentColor"
        },
        "child": [
            {
                "tag": "g",
                "attr": {},
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M86.45,23.27h-3.475V90.18c0,0.835-0.677,1.513-1.513,1.513H31.987v3.475c0,0.836,0.677,1.513,1.513,1.513l0.001,0v0h52.95\n		c0.836,0,1.513-0.677,1.513-1.513V24.782C87.963,23.946,87.286,23.27,86.45,23.27z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M77.988,85.193V14.807c0-0.836-0.677-1.513-1.513-1.513h-3.475v66.911c0,0.836-0.677,1.513-1.513,1.513H22.011v3.475\n		c0,0.836,0.677,1.513,1.513,1.513c0,0,0,0,0,0h52.951C77.311,86.706,77.988,86.029,77.988,85.193z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M68.013,75.218V4.832c0-0.836-0.677-1.513-1.513-1.513H13.55c-0.836,0-1.513,0.677-1.513,1.513v70.386\n		c0,0.836,0.677,1.513,1.513,1.513H66.5C67.336,76.731,68.013,76.054,68.013,75.218z"
                        }
                    }
                ],
                "content": "\n"
            }
        ],
        "content": "\n"
    })(props);
};

});

parcelRegister("bfIoN", function(module, exports) {
"use strict";
var $8313891aad44adb5$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.SectionTab = void 0;

const $8313891aad44adb5$var$react_1 = $8313891aad44adb5$var$__importDefault((parcelRequire("8NFma")));

const $8313891aad44adb5$var$styled_1 = $8313891aad44adb5$var$__importDefault((parcelRequire("MPenY")));

var $3pcZ0 = parcelRequire("3pcZ0");
const $8313891aad44adb5$var$TabContainer = (0, $8313891aad44adb5$var$styled_1.default)("div")`
  width: 100%;
  height: 72px;
  padding-top: 15px;
  text-align: center;
  font-size: 12px;
  cursor: pointer;

  .bp5-dark &:hover,
  .bp5-dark &.active {
    color: #48aff0 !important;
  }

  &:hover,
  &.active {
    background-color: rgba(19, 124, 189, 0.2);
  }

  ${(0, $3pcZ0.mobileStyle)("\n    height: 54px;\n    padding-top: 9px;\n    width: 72px;\n  ")}
`, $8313891aad44adb5$var$SectionTab = ({ children: e, name: t, onClick: i, active: a, iconSize: r })=>$8313891aad44adb5$var$react_1.default.createElement($8313891aad44adb5$var$TabContainer, {
        onClick: i,
        className: "polotno-side-panel-tab" + (a ? " active" : "")
    }, $8313891aad44adb5$var$react_1.default.createElement("div", {
        style: {
            fontSize: (r || 14) + "px"
        }
    }, e), $8313891aad44adb5$var$react_1.default.createElement("div", {
        style: {
            paddingTop: "5px"
        }
    }, t));
module.exports.SectionTab = $8313891aad44adb5$var$SectionTab;

});

parcelRegister("eRKBF", function(module, exports) {
"use strict";
var $ad2a2afe5f4ece5a$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.ImagesGrid = void 0;

const $ad2a2afe5f4ece5a$var$react_1 = $ad2a2afe5f4ece5a$var$__importDefault((parcelRequire("8NFma")));

const $ad2a2afe5f4ece5a$var$styled_1 = $ad2a2afe5f4ece5a$var$__importDefault((parcelRequire("MPenY")));

var $h3xJq = parcelRequire("h3xJq");

var $xARwM = parcelRequire("xARwM");

var $gvVvd = parcelRequire("gvVvd");

var $3pcZ0 = parcelRequire("3pcZ0");
const $ad2a2afe5f4ece5a$var$ImagesListContainer = (0, $ad2a2afe5f4ece5a$var$styled_1.default)("div", $ad2a2afe5f4ece5a$var$react_1.default.forwardRef)`
  height: 100%;
  overflow: auto;
`, $ad2a2afe5f4ece5a$var$ImagesRow = (0, $ad2a2afe5f4ece5a$var$styled_1.default)("div")`
  width: 33%;
  float: left;
`, $ad2a2afe5f4ece5a$var$ImgWrapDiv = (0, $ad2a2afe5f4ece5a$var$styled_1.default)("div")`
  padding: 5px;
  width: 100%;
  &:hover .credit {
    opacity: 1;
  }
  ${(0, $3pcZ0.mobileStyle)("\n    .credit {\n      opacity: 1;\n    }\n  ")}
`, $ad2a2afe5f4ece5a$var$ImgContainerDiv = (0, $ad2a2afe5f4ece5a$var$styled_1.default)("div")`
  border-radius: 5px;
  position: relative;
  overflow: hidden;
  box-shadow: ${(e)=>e["data-shadowenabled"] ? "0 0 5px rgba(16, 22, 26, 0.3)" : ""};
`, $ad2a2afe5f4ece5a$var$Img = (0, $ad2a2afe5f4ece5a$var$styled_1.default)("img")`
  width: 100%;
  cursor: pointer;
  display: block;
  max-height: 300px;
  min-height: 50px;
  object-fit: contain;
`, $ad2a2afe5f4ece5a$var$CreditWrap = (0, $ad2a2afe5f4ece5a$var$styled_1.default)("div")`
  position: absolute;
  bottom: 0px;
  left: 0px;
  font-size: 10px;
  padding: 3px;
  padding-top: 10px;
  text-align: center;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0.4),
    rgba(0, 0, 0, 0.6)
  );
  width: 100%;
  opacity: 0;
  color: white;
`, $ad2a2afe5f4ece5a$var$NoResults = (0, $ad2a2afe5f4ece5a$var$styled_1.default)("p")`
  text-align: center;
  padding: 30px;
`, $ad2a2afe5f4ece5a$var$Image = ({ url: e, credit: t, onSelect: r, crossOrigin: a, shadowEnabled: l, itemHeight: o, className: i, onLoad: n })=>{
    const d = null == l || l;
    return $ad2a2afe5f4ece5a$var$react_1.default.createElement($ad2a2afe5f4ece5a$var$ImgWrapDiv, {
        onClick: ()=>{
            r();
        },
        className: "polotno-close-panel"
    }, $ad2a2afe5f4ece5a$var$react_1.default.createElement($ad2a2afe5f4ece5a$var$ImgContainerDiv, {
        "data-shadowenabled": d
    }, $ad2a2afe5f4ece5a$var$react_1.default.createElement($ad2a2afe5f4ece5a$var$Img, {
        className: i,
        style: {
            height: null != o ? o : "auto"
        },
        src: e,
        draggable: !0,
        loading: "lazy",
        crossOrigin: a,
        onDragStart: ()=>{
            (0, $gvVvd.registerNextDomDrop)(({ x: e, y: t }, a, l)=>{
                r({
                    x: e,
                    y: t
                }, a, l);
            });
        },
        onDragEnd: ()=>{
            (0, $gvVvd.registerNextDomDrop)(null);
        },
        onLoad: n
    }), t && $ad2a2afe5f4ece5a$var$react_1.default.createElement($ad2a2afe5f4ece5a$var$CreditWrap, {
        className: "credit"
    }, t)));
}, $ad2a2afe5f4ece5a$var$ImagesGrid = ({ images: e, onSelect: t, isLoading: r, getPreview: a, loadMore: l, getCredit: o, getImageClassName: i, rowsNumber: n, crossOrigin: d = "anonymous", shadowEnabled: s, itemHeight: c, error: u })=>{
    const g = n || 2, m = $ad2a2afe5f4ece5a$var$react_1.default.useRef(null), p = [];
    for(var f = 0; f < g; f++)p.push((e || []).filter((e, t)=>t % g === f));
    const _ = $ad2a2afe5f4ece5a$var$react_1.default.useRef(null), h = ()=>{
        var t, a, o;
        const i = (null === (t = m.current) || void 0 === t ? void 0 : t.scrollHeight) > (null === (a = m.current) || void 0 === a ? void 0 : a.offsetHeight) + 5, n = e && e.length, d = Array.from(null === (o = m.current) || void 0 === o ? void 0 : o.querySelectorAll("img")).every((e)=>e.complete);
        !i && l && !r && n && d && (_.current || (_.current = window.setTimeout(()=>{
            _.current = null, l && l();
        }, 100)));
    }, v = ()=>{
        h();
    };
    return $ad2a2afe5f4ece5a$var$react_1.default.useEffect(()=>(h(), ()=>{
            window.clearTimeout(_.current), _.current = null;
        }), [
        e && e.length,
        r
    ]), $ad2a2afe5f4ece5a$var$react_1.default.createElement($ad2a2afe5f4ece5a$var$ImagesListContainer, {
        onScroll: (e)=>{
            const t = e.target.scrollHeight - e.target.scrollTop - e.target.offsetHeight;
            l && !r && t < 200 && l();
        },
        ref: m
    }, p.map((e, l)=>$ad2a2afe5f4ece5a$var$react_1.default.createElement($ad2a2afe5f4ece5a$var$ImagesRow, {
            key: l,
            style: {
                width: 100 / g + "%"
            }
        }, e.map((e, r)=>$ad2a2afe5f4ece5a$var$react_1.default.createElement($ad2a2afe5f4ece5a$var$Image, {
                url: a(e),
                onSelect: (r, a, l)=>t(e, r, a, l),
                key: r,
                credit: o && o(e),
                crossOrigin: d,
                shadowEnabled: s,
                itemHeight: c,
                className: i && i(e),
                onLoad: v
            })), r && $ad2a2afe5f4ece5a$var$react_1.default.createElement("div", {
            style: {
                padding: "30px"
            }
        }, $ad2a2afe5f4ece5a$var$react_1.default.createElement($h3xJq.Spinner, null)))), !r && (!e || !e.length) && !u && $ad2a2afe5f4ece5a$var$react_1.default.createElement($ad2a2afe5f4ece5a$var$NoResults, null, (0, $xARwM.t)("sidePanel.noResults")), u && $ad2a2afe5f4ece5a$var$react_1.default.createElement($ad2a2afe5f4ece5a$var$NoResults, null, (0, $xARwM.t)("sidePanel.error")));
};
module.exports.ImagesGrid = $ad2a2afe5f4ece5a$var$ImagesGrid;

});

parcelRegister("C4z2B", function(module, exports) {
"use strict";
var $072717134985ae70$var$__rest = module.exports && module.exports.__rest || function(e, t) {
    var o = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (o[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var n = 0;
        for(a = Object.getOwnPropertySymbols(e); n < a.length; n++)t.indexOf(a[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (o[a[n]] = e[a[n]]);
    }
    return o;
}, $072717134985ae70$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.TextPanel = void 0;

const $072717134985ae70$var$react_1 = $072717134985ae70$var$__importDefault((parcelRequire("8NFma")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

var $gUePa = parcelRequire("gUePa");
var $9NqsV = parcelRequire("9NqsV");
var $aQvf8 = parcelRequire("aQvf8");

const $072717134985ae70$var$swr_1 = $072717134985ae70$var$__importDefault((parcelRequire("6Grnh")));

var $xARwM = parcelRequire("xARwM");

const $072717134985ae70$var$styled_1 = $072717134985ae70$var$__importDefault((parcelRequire("MPenY")));

var $3pcZ0 = parcelRequire("3pcZ0");

var $eRKBF = parcelRequire("eRKBF");

var $6laUv = parcelRequire("6laUv");

var $3TNde = parcelRequire("3TNde");

var $gvVvd = parcelRequire("gvVvd");
const $072717134985ae70$var$Container = (0, $072717134985ae70$var$styled_1.default)("div")`
  height: calc(100% - 40px);
  display: flex;
  flex-direction: column;

  .bp5-dark & .polotno-text-preview-plain {
    filter: invert(1);
  }
`, $072717134985ae70$var$FontContainer = (0, $072717134985ae70$var$styled_1.default)("div")`
  height: 100px;
  cursor: pointer;
  box-shadow: 0 0 5px rgba(16, 22, 26, 0.3);
  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.4);
  position: relative;
  font-size: 25px;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  text-align: center;
  color: white;
  margin-bottom: 10px;
`, $072717134985ae70$var$toBase64 = (e)=>new Promise((t, o)=>{
        const a = new FileReader;
        a.readAsDataURL(e), a.onload = ()=>t(a.result), a.onerror = (e)=>o(e);
    }), $072717134985ae70$var$FontItem = (0, $O1ETn.observer)(({ onSelect: e, onRemove: t, font: o })=>$072717134985ae70$var$react_1.default.createElement($072717134985ae70$var$FontContainer, {
        style: {
            fontFamily: o.fontFamily
        },
        className: "polotno-font-item",
        onClick: e
    }, o.fontFamily, " text", $072717134985ae70$var$react_1.default.createElement($gUePa.Button, {
        style: {
            position: "absolute",
            right: 0,
            bottom: 0
        },
        minimal: !0,
        icon: "trash",
        onClick: (e)=>{
            e.stopPropagation(), t();
        }
    }))), $072717134985ae70$var$DragButton = (e)=>{
    var { onSelect: t } = e, o = $072717134985ae70$var$__rest(e, [
        "onSelect"
    ]);
    return $072717134985ae70$var$react_1.default.createElement($gUePa.Button, Object.assign({}, o, {
        draggable: !0,
        className: "polotno-close-panel",
        onClick: ()=>t(),
        onDragStart: ()=>{
            (0, $gvVvd.registerNextDomDrop)(({ x: e, y: o })=>{
                t({
                    x: e,
                    y: o
                });
            });
        },
        onDragEnd: (e)=>{
            (0, $gvVvd.registerNextDomDrop)(null);
        }
    }));
};
module.exports.TextPanel = (0, $O1ETn.observer)(({ store: e })=>{
    $072717134985ae70$var$react_1.default.useEffect(()=>{
        e.loadFont("Roboto");
    }, []);
    const t = (t)=>{
        var o;
        const a = t.width || e.width / 2, n = ((null == t ? void 0 : t.x) || e.width / 2) - a / 2, i = ((null == t ? void 0 : t.y) || e.height / 2) - t.fontSize / 2, l = (e.width + e.height) / 2160, r = null === (o = e.activePage) || void 0 === o ? void 0 : o.addElement(Object.assign(Object.assign({
            type: "text",
            fontFamily: "Roboto"
        }, t), {
            x: n,
            y: i,
            width: a,
            fontSize: t.fontSize * l
        }));
        (0, $3pcZ0.isMobile)() || null == r || r.toggleEditMode(!0);
    };
    $072717134985ae70$var$react_1.default.useEffect(()=>{
        e.fonts.forEach((t)=>e.loadFont(t.fontFamily));
    }, [
        e.fonts
    ]);
    const { data: o, error: a } = (0, $072717134985ae70$var$swr_1.default)((0, $6laUv.textTemplateList)(), $3TNde.fetcher), [n, i] = $072717134985ae70$var$react_1.default.useState("text");
    return $072717134985ae70$var$react_1.default.createElement("div", {
        style: {
            height: "100%",
            display: "flex",
            flexDirection: "column"
        }
    }, $072717134985ae70$var$react_1.default.createElement($aQvf8.Tabs, {
        large: !0,
        onChange: (e)=>i(e)
    }, $072717134985ae70$var$react_1.default.createElement($9NqsV.Tab, {
        id: "text"
    }, (0, $xARwM.t)("sidePanel.text")), $072717134985ae70$var$react_1.default.createElement($9NqsV.Tab, {
        id: "font"
    }, (0, $xARwM.t)("sidePanel.myFonts"))), "text" === n && $072717134985ae70$var$react_1.default.createElement($072717134985ae70$var$Container, null, $072717134985ae70$var$react_1.default.createElement($072717134985ae70$var$DragButton, {
        style: {
            marginBottom: "5px",
            width: "100%",
            fontSize: "25px",
            fontFamily: "Roboto"
        },
        minimal: !0,
        onSelect: (e)=>{
            t(Object.assign(Object.assign({}, e), {
                fontSize: 76,
                text: (0, $xARwM.t)("sidePanel.headerText"),
                fontFamily: "Roboto"
            }));
        }
    }, (0, $xARwM.t)("sidePanel.createHeader")), $072717134985ae70$var$react_1.default.createElement($072717134985ae70$var$DragButton, {
        style: {
            marginBottom: "5px",
            width: "100%",
            fontSize: "18px",
            fontFamily: "Roboto"
        },
        minimal: !0,
        onSelect: (e)=>{
            t(Object.assign(Object.assign({}, e), {
                fontSize: 44,
                text: (0, $xARwM.t)("sidePanel.subHeaderText"),
                fontFamily: "Roboto"
            }));
        }
    }, (0, $xARwM.t)("sidePanel.createSubHeader")), $072717134985ae70$var$react_1.default.createElement($072717134985ae70$var$DragButton, {
        style: {
            marginBottom: "5px",
            width: "100%",
            fontSize: "14px",
            fontFamily: "Roboto"
        },
        minimal: !0,
        onSelect: (e)=>{
            t(Object.assign(Object.assign({}, e), {
                fontSize: 30,
                text: (0, $xARwM.t)("sidePanel.bodyText"),
                fontFamily: "Roboto"
            }));
        }
    }, (0, $xARwM.t)("sidePanel.createBody")), $072717134985ae70$var$react_1.default.createElement($eRKBF.ImagesGrid, {
        shadowEnabled: !1,
        images: null == o ? void 0 : o.items,
        getPreview: (e)=>e.preview,
        getImageClassName: (e)=>e.json.indexOf("plain") >= 0 ? "polotno-text-preview-plain" : "",
        isLoading: !o,
        error: a,
        onSelect: async (t, o)=>{
            const a = await fetch(t.json), n = await a.json();
            if (!e.activePage) return;
            const i = (e.width + e.height) / 2160, l = o ? o.x - n.width / 2 * i : e.width / 2 - n.width / 2 * i, r = o ? o.y - n.height / 2 * i : e.height / 2 - n.height / 2 * i;
            e.history.transaction(()=>{
                const t = n.pages[0].children, o = [];
                t.forEach((t)=>{
                    var a;
                    delete t.id;
                    const { id: n } = null === (a = e.activePage) || void 0 === a ? void 0 : a.addElement(Object.assign(Object.assign({}, t), {
                        fontSize: t.fontSize * i,
                        x: t.x * i + l,
                        y: t.y * i + r,
                        width: t.width * i,
                        height: t.height * i
                    }));
                    o.push(n);
                }), e.selectElements(o);
            });
        }
    })), "font" === n && $072717134985ae70$var$react_1.default.createElement("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            height: "calc(100% - 50px)"
        }
    }, $072717134985ae70$var$react_1.default.createElement("label", {
        htmlFor: "polotno-font-upload"
    }, $072717134985ae70$var$react_1.default.createElement($gUePa.Button, {
        icon: "upload",
        style: {
            width: "100%"
        },
        onClick: ()=>{
            var e;
            null === (e = document.querySelector("#polotno-font-upload")) || void 0 === e || e.click();
        }
    }, (0, $xARwM.t)("sidePanel.uploadFont")), $072717134985ae70$var$react_1.default.createElement("input", {
        type: "file",
        accept: ".ttf, .otf, .woff, .woff2, .eot",
        id: "polotno-font-upload",
        style: {
            display: "none"
        },
        onChange: async (t)=>{
            const { target: o } = t;
            for (const t of o.files){
                const o = await $072717134985ae70$var$toBase64(t), a = t.name.split(".")[0].replace(/,/g, "");
                e.addFont({
                    fontFamily: a,
                    url: o
                });
            }
            o.value = null;
        }
    })), $072717134985ae70$var$react_1.default.createElement("div", {
        style: {
            paddingTop: "20px",
            overflow: "auto",
            height: "100%"
        }
    }, e.fonts.map((o, a)=>$072717134985ae70$var$react_1.default.createElement($072717134985ae70$var$FontItem, {
            font: o,
            key: a,
            onSelect: ()=>{
                t({
                    fontSize: 80,
                    text: "Cool text",
                    fontFamily: o.fontFamily
                });
            },
            onRemove: ()=>{
                e.find((e)=>{
                    "text" === e.type && e.fontFamily === o.fontFamily && e.set({
                        fontFamily: "Roboto"
                    });
                }), e.removeFont(o.fontFamily);
            }
        })))));
});

});

parcelRegister("fpO7i", function(module, exports) {
"use strict";
var $b39010f7173e3bc0$var$__rest = module.exports && module.exports.__rest || function(e, t) {
    var i = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (i[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var n = 0;
        for(a = Object.getOwnPropertySymbols(e); n < a.length; n++)t.indexOf(a[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (i[a[n]] = e[a[n]]);
    }
    return i;
}, $b39010f7173e3bc0$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.SizePanel = module.exports.DEFAULT_SIZES = void 0;

const $b39010f7173e3bc0$var$react_1 = $b39010f7173e3bc0$var$__importDefault((parcelRequire("8NFma")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

var $2nesQ = parcelRequire("2nesQ");
var $gUePa = parcelRequire("gUePa");
var $gKgL3 = parcelRequire("gKgL3");
var $cQj25 = parcelRequire("cQj25");
var $71KpR = parcelRequire("71KpR");
var $5r5rj = parcelRequire("5r5rj");
var $gVVt3 = parcelRequire("gVVt3");

var $xARwM = parcelRequire("xARwM");

const $b39010f7173e3bc0$var$AiOutlineFacebook_1 = $b39010f7173e3bc0$var$__importDefault((parcelRequire("fa3Du")));

const $b39010f7173e3bc0$var$AiOutlineInstagram_1 = $b39010f7173e3bc0$var$__importDefault((parcelRequire("aVZ5h")));

const $b39010f7173e3bc0$var$AiOutlineYoutube_1 = $b39010f7173e3bc0$var$__importDefault((parcelRequire("dRgcz")));

const $b39010f7173e3bc0$var$AiOutlineVideoCamera_1 = $b39010f7173e3bc0$var$__importDefault((parcelRequire("j6qI0")));

const $b39010f7173e3bc0$var$ZoDocument_1 = $b39010f7173e3bc0$var$__importDefault((parcelRequire("jhAi2")));

const $b39010f7173e3bc0$var$AiOutlineIdcard_1 = $b39010f7173e3bc0$var$__importDefault((parcelRequire("eoqrz")));

var $7ZydS = parcelRequire("7ZydS");
module.exports.DEFAULT_SIZES = [
    [
        "Instagram Post",
        1080,
        1080,
        "px",
        $b39010f7173e3bc0$var$react_1.default.createElement($b39010f7173e3bc0$var$AiOutlineInstagram_1.default, null)
    ],
    [
        "Instagram Story",
        1080,
        1920,
        "px",
        $b39010f7173e3bc0$var$react_1.default.createElement($b39010f7173e3bc0$var$AiOutlineInstagram_1.default, null)
    ],
    [
        "Instagram Ad",
        1080,
        1080,
        "px",
        $b39010f7173e3bc0$var$react_1.default.createElement($b39010f7173e3bc0$var$AiOutlineInstagram_1.default, null)
    ],
    [
        "Facebook Post",
        940,
        788,
        "px",
        $b39010f7173e3bc0$var$react_1.default.createElement($b39010f7173e3bc0$var$AiOutlineFacebook_1.default, null)
    ],
    [
        "Facebook Cover",
        851,
        315,
        "px",
        $b39010f7173e3bc0$var$react_1.default.createElement($b39010f7173e3bc0$var$AiOutlineFacebook_1.default, null)
    ],
    [
        "Facebook Ad",
        1200,
        628,
        "px",
        $b39010f7173e3bc0$var$react_1.default.createElement($b39010f7173e3bc0$var$AiOutlineFacebook_1.default, null)
    ],
    [
        "Youtube Thumbnail",
        1280,
        720,
        "px",
        $b39010f7173e3bc0$var$react_1.default.createElement($b39010f7173e3bc0$var$AiOutlineYoutube_1.default, null)
    ],
    [
        "Youtube Channel",
        2560,
        1440,
        "px",
        $b39010f7173e3bc0$var$react_1.default.createElement($b39010f7173e3bc0$var$AiOutlineYoutube_1.default, null)
    ],
    [
        "Full HD",
        1920,
        1080,
        "px",
        $b39010f7173e3bc0$var$react_1.default.createElement($b39010f7173e3bc0$var$AiOutlineVideoCamera_1.default, null)
    ],
    [
        "Invitation",
        14,
        14,
        "cm",
        $b39010f7173e3bc0$var$react_1.default.createElement($b39010f7173e3bc0$var$ZoDocument_1.default, null)
    ],
    [
        "A4",
        21,
        29.7,
        "cm",
        $b39010f7173e3bc0$var$react_1.default.createElement($b39010f7173e3bc0$var$ZoDocument_1.default, null)
    ],
    [
        "Business card",
        3.5,
        2,
        "in",
        $b39010f7173e3bc0$var$react_1.default.createElement($b39010f7173e3bc0$var$AiOutlineIdcard_1.default, null)
    ]
];
const $b39010f7173e3bc0$var$minSize = 10, $b39010f7173e3bc0$var$NumericInputDelayed = (e)=>{
    var { value: t, onChange: i } = e, a = $b39010f7173e3bc0$var$__rest(e, [
        "value",
        "onChange"
    ]);
    const [n, l] = $b39010f7173e3bc0$var$react_1.default.useState(t), u = $b39010f7173e3bc0$var$react_1.default.useRef(t);
    u.current = n;
    const r = ()=>{
        i(Math.max(10, u.current));
    };
    $b39010f7173e3bc0$var$react_1.default.useEffect(()=>{
        l(t);
    }, [
        t
    ]);
    return $b39010f7173e3bc0$var$react_1.default.createElement($cQj25.NumericInput, Object.assign({}, a, {
        value: n,
        onValueChange: (e)=>{
            Number.isNaN(e) || l(e);
        },
        onBlur: r,
        onKeyDown: (e)=>{
            "Enter" === e.key && r();
        }
    }));
};
module.exports.SizePanel = (0, $O1ETn.observer)(({ store: e })=>{
    var t, i;
    const [a, n] = $b39010f7173e3bc0$var$react_1.default.useState(!0), [l, u] = $b39010f7173e3bc0$var$react_1.default.useState(e.width), [r, o] = $b39010f7173e3bc0$var$react_1.default.useState(e.height), c = (null === (t = e.activePage) || void 0 === t ? void 0 : t.computedWidth) || e.width;
    $b39010f7173e3bc0$var$react_1.default.useEffect(()=>{
        u((0, $7ZydS.pxToUnitRounded)({
            px: c,
            unit: e.unit,
            dpi: e.dpi
        }));
    }, [
        c,
        e.unit,
        e.dpi
    ]);
    const d = (null === (i = e.activePage) || void 0 === i ? void 0 : i.computedHeight) || e.height;
    $b39010f7173e3bc0$var$react_1.default.useEffect(()=>{
        o((0, $7ZydS.pxToUnitRounded)({
            px: d,
            unit: e.unit,
            dpi: e.dpi
        }));
    }, [
        d,
        e.unit,
        e.dpi
    ]);
    return $b39010f7173e3bc0$var$react_1.default.createElement("div", {
        style: {
            height: "100%",
            overflow: "auto",
            paddingRight: "3px"
        }
    }, $b39010f7173e3bc0$var$react_1.default.createElement("div", {
        style: {
            paddingBottom: "15px"
        }
    }, $b39010f7173e3bc0$var$react_1.default.createElement($5r5rj.Switch, {
        checked: a,
        onChange: (e)=>{
            n(e.target.checked);
        },
        alignIndicator: $2nesQ.Alignment.RIGHT,
        style: {
            marginTop: "8px",
            marginBottom: "25px"
        }
    }, (0, $xARwM.t)("sidePanel.useMagicResize"), " ", $b39010f7173e3bc0$var$react_1.default.createElement($gVVt3.Tooltip, {
        content: (0, $xARwM.t)("sidePanel.magicResizeDescription"),
        position: $71KpR.Position.BOTTOM
    }, $b39010f7173e3bc0$var$react_1.default.createElement($gKgL3.Icon, {
        icon: "help"
    }))), $b39010f7173e3bc0$var$react_1.default.createElement("div", {
        style: {
            width: "50%",
            display: "inline-block"
        }
    }, (0, $xARwM.t)("sidePanel.width"), " (", e.unit, ")"), $b39010f7173e3bc0$var$react_1.default.createElement("div", {
        style: {
            width: "50%",
            display: "inline-block"
        }
    }, $b39010f7173e3bc0$var$react_1.default.createElement($b39010f7173e3bc0$var$NumericInputDelayed, {
        fill: !0,
        value: l,
        onChange: (e)=>{
            e || (e = 10), u(e);
        },
        min: 10,
        max: 1e4,
        selectAllOnFocus: !0,
        minorStepSize: .01
    }))), $b39010f7173e3bc0$var$react_1.default.createElement("div", {
        style: {
            paddingBottom: "15px"
        }
    }, $b39010f7173e3bc0$var$react_1.default.createElement("div", {
        style: {
            width: "50%",
            display: "inline-block"
        }
    }, (0, $xARwM.t)("sidePanel.height"), " (", e.unit, ")"), $b39010f7173e3bc0$var$react_1.default.createElement("div", {
        style: {
            width: "50%",
            display: "inline-block"
        }
    }, $b39010f7173e3bc0$var$react_1.default.createElement($b39010f7173e3bc0$var$NumericInputDelayed, {
        fill: !0,
        value: r,
        onChange: (e)=>{
            e || (e = 10), o(e);
        },
        min: 10,
        max: 1e4,
        selectAllOnFocus: !0,
        minorStepSize: .01
    }))), $b39010f7173e3bc0$var$react_1.default.createElement("div", {
        style: {
            paddingBottom: "15px"
        }
    }, $b39010f7173e3bc0$var$react_1.default.createElement($gUePa.Button, {
        fill: !0,
        intent: "primary",
        onClick: ()=>{
            var t, i, n, u;
            const o = (0, $7ZydS.unitToPx)({
                unitVal: l,
                dpi: e.dpi,
                unit: e.unit
            }), c = (0, $7ZydS.unitToPx)({
                unitVal: r,
                dpi: e.dpi,
                unit: e.unit
            });
            e.setSize(o, c, a), "auto" !== (null === (t = e.activePage) || void 0 === t ? void 0 : t.width) && (null === (i = e.activePage) || void 0 === i || i.set({
                width: o
            })), "auto" !== (null === (n = e.activePage) || void 0 === n ? void 0 : n.height) && (null === (u = e.activePage) || void 0 === u || u.set({
                height: c
            }));
        }
    }, (0, $xARwM.t)("sidePanel.resize"))), module.exports.DEFAULT_SIZES.map(([t, i, n, l, u])=>$b39010f7173e3bc0$var$react_1.default.createElement($gUePa.Button, {
            key: t,
            style: {
                width: "100%",
                paddingTop: "10px",
                paddingBottom: "10px",
                fontSize: "16px"
            },
            minimal: !0,
            onClick: ()=>{
                var t, u, r, o;
                const c = (0, $7ZydS.unitToPx)({
                    unitVal: i,
                    dpi: e.dpi,
                    unit: l
                }), d = (0, $7ZydS.unitToPx)({
                    unitVal: n,
                    dpi: e.dpi,
                    unit: l
                });
                e.setUnit({
                    unit: l,
                    dpi: e.dpi
                }), e.setSize(c, d, a), "auto" !== (null === (t = e.activePage) || void 0 === t ? void 0 : t.width) && (null === (u = e.activePage) || void 0 === u || u.set({
                    width: c
                })), "auto" !== (null === (r = e.activePage) || void 0 === r ? void 0 : r.height) && (null === (o = e.activePage) || void 0 === o || o.set({
                    height: d
                }));
            },
            icon: u,
            alignText: "left"
        }, t, $b39010f7173e3bc0$var$react_1.default.createElement("span", {
            style: {
                fontSize: "0.7rem",
                paddingLeft: "20px",
                float: "right",
                lineHeight: "1.1rem"
            }
        }, i, " x ", n, " ", l))));
});

});
parcelRegister("fa3Du", function(module, exports) {
parcelRequire("kNUzI");
var $3H1D6 = parcelRequire("3H1D6");
var $b09a9c369e82c659$require$GenIcon = $3H1D6.GenIcon;
module.exports = function(props) {
    return $b09a9c369e82c659$require$GenIcon({
        "tag": "svg",
        "attr": {
            "className": "icon",
            "viewBox": "0 0 1024 1024",
            "fill": "currentColor"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-32 736H663.9V602.2h104l15.6-120.7H663.9v-77.1c0-35 9.7-58.8 59.8-58.8h63.9v-108c-11.1-1.5-49-4.8-93.2-4.8-92.2 0-155.3 56.3-155.3 159.6v89H434.9v120.7h104.3V848H176V176h672v672z"
                }
            }
        ],
        "content": "\n"
    })(props);
};

});

parcelRegister("aVZ5h", function(module, exports) {
parcelRequire("kNUzI");
var $3H1D6 = parcelRequire("3H1D6");
var $7f5e9c4f3f88d552$require$GenIcon = $3H1D6.GenIcon;
module.exports = function(props) {
    return $7f5e9c4f3f88d552$require$GenIcon({
        "tag": "svg",
        "attr": {
            "className": "icon",
            "viewBox": "0 0 1024 1024",
            "fill": "currentColor"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 306.9c-113.5 0-205.1 91.6-205.1 205.1S398.5 717.1 512 717.1 717.1 625.5 717.1 512 625.5 306.9 512 306.9zm0 338.4c-73.4 0-133.3-59.9-133.3-133.3S438.6 378.7 512 378.7 645.3 438.6 645.3 512 585.4 645.3 512 645.3zm213.5-394.6c-26.5 0-47.9 21.4-47.9 47.9s21.4 47.9 47.9 47.9 47.9-21.3 47.9-47.9a47.84 47.84 0 0 0-47.9-47.9zM911.8 512c0-55.2.5-109.9-2.6-165-3.1-64-17.7-120.8-64.5-167.6-46.9-46.9-103.6-61.4-167.6-64.5-55.2-3.1-109.9-2.6-165-2.6-55.2 0-109.9-.5-165 2.6-64 3.1-120.8 17.7-167.6 64.5C132.6 226.3 118.1 283 115 347c-3.1 55.2-2.6 109.9-2.6 165s-.5 109.9 2.6 165c3.1 64 17.7 120.8 64.5 167.6 46.9 46.9 103.6 61.4 167.6 64.5 55.2 3.1 109.9 2.6 165 2.6 55.2 0 109.9.5 165-2.6 64-3.1 120.8-17.7 167.6-64.5 46.9-46.9 61.4-103.6 64.5-167.6 3.2-55.1 2.6-109.8 2.6-165zm-88 235.8c-7.3 18.2-16.1 31.8-30.2 45.8-14.1 14.1-27.6 22.9-45.8 30.2C695.2 844.7 570.3 840 512 840c-58.3 0-183.3 4.7-235.9-16.1-18.2-7.3-31.8-16.1-45.8-30.2-14.1-14.1-22.9-27.6-30.2-45.8C179.3 695.2 184 570.3 184 512c0-58.3-4.7-183.3 16.1-235.9 7.3-18.2 16.1-31.8 30.2-45.8s27.6-22.9 45.8-30.2C328.7 179.3 453.7 184 512 184s183.3-4.7 235.9 16.1c18.2 7.3 31.8 16.1 45.8 30.2 14.1 14.1 22.9 27.6 30.2 45.8C844.7 328.7 840 453.7 840 512c0 58.3 4.7 183.2-16.2 235.8z"
                }
            }
        ],
        "content": "\n"
    })(props);
};

});

parcelRegister("dRgcz", function(module, exports) {
parcelRequire("kNUzI");
var $3H1D6 = parcelRequire("3H1D6");
var $a16ccaf01a0ca0ec$require$GenIcon = $3H1D6.GenIcon;
module.exports = function(props) {
    return $a16ccaf01a0ca0ec$require$GenIcon({
        "tag": "svg",
        "attr": {
            "className": "icon",
            "viewBox": "0 0 1024 1024",
            "fill": "currentColor"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M960 509.2c0-2.2 0-4.7-.1-7.6-.1-8.1-.3-17.2-.5-26.9-.8-27.9-2.2-55.7-4.4-81.9-3-36.1-7.4-66.2-13.4-88.8a139.52 139.52 0 0 0-98.3-98.5c-28.3-7.6-83.7-12.3-161.7-15.2-37.1-1.4-76.8-2.3-116.5-2.8-13.9-.2-26.8-.3-38.4-.4h-29.4c-11.6.1-24.5.2-38.4.4-39.7.5-79.4 1.4-116.5 2.8-78 3-133.5 7.7-161.7 15.2A139.35 139.35 0 0 0 82.4 304C76.3 326.6 72 356.7 69 392.8c-2.2 26.2-3.6 54-4.4 81.9-.3 9.7-.4 18.8-.5 26.9 0 2.9-.1 5.4-.1 7.6v5.6c0 2.2 0 4.7.1 7.6.1 8.1.3 17.2.5 26.9.8 27.9 2.2 55.7 4.4 81.9 3 36.1 7.4 66.2 13.4 88.8 12.8 47.9 50.4 85.7 98.3 98.5 28.2 7.6 83.7 12.3 161.7 15.2 37.1 1.4 76.8 2.3 116.5 2.8 13.9.2 26.8.3 38.4.4h29.4c11.6-.1 24.5-.2 38.4-.4 39.7-.5 79.4-1.4 116.5-2.8 78-3 133.5-7.7 161.7-15.2 47.9-12.8 85.5-50.5 98.3-98.5 6.1-22.6 10.4-52.7 13.4-88.8 2.2-26.2 3.6-54 4.4-81.9.3-9.7.4-18.8.5-26.9 0-2.9.1-5.4.1-7.6v-5.6zm-72 5.2c0 2.1 0 4.4-.1 7.1-.1 7.8-.3 16.4-.5 25.7-.7 26.6-2.1 53.2-4.2 77.9-2.7 32.2-6.5 58.6-11.2 76.3-6.2 23.1-24.4 41.4-47.4 47.5-21 5.6-73.9 10.1-145.8 12.8-36.4 1.4-75.6 2.3-114.7 2.8-13.7.2-26.4.3-37.8.3h-28.6l-37.8-.3c-39.1-.5-78.2-1.4-114.7-2.8-71.9-2.8-124.9-7.2-145.8-12.8-23-6.2-41.2-24.4-47.4-47.5-4.7-17.7-8.5-44.1-11.2-76.3-2.1-24.7-3.4-51.3-4.2-77.9-.3-9.3-.4-18-.5-25.7 0-2.7-.1-5.1-.1-7.1v-4.8c0-2.1 0-4.4.1-7.1.1-7.8.3-16.4.5-25.7.7-26.6 2.1-53.2 4.2-77.9 2.7-32.2 6.5-58.6 11.2-76.3 6.2-23.1 24.4-41.4 47.4-47.5 21-5.6 73.9-10.1 145.8-12.8 36.4-1.4 75.6-2.3 114.7-2.8 13.7-.2 26.4-.3 37.8-.3h28.6l37.8.3c39.1.5 78.2 1.4 114.7 2.8 71.9 2.8 124.9 7.2 145.8 12.8 23 6.2 41.2 24.4 47.4 47.5 4.7 17.7 8.5 44.1 11.2 76.3 2.1 24.7 3.4 51.3 4.2 77.9.3 9.3.4 18 .5 25.7 0 2.7.1 5.1.1 7.1v4.8zM423 646l232-135-232-133z"
                }
            }
        ],
        "content": "\n"
    })(props);
};

});

parcelRegister("j6qI0", function(module, exports) {
parcelRequire("kNUzI");
var $3H1D6 = parcelRequire("3H1D6");
var $de834bab929f4403$require$GenIcon = $3H1D6.GenIcon;
module.exports = function(props) {
    return $de834bab929f4403$require$GenIcon({
        "tag": "svg",
        "attr": {
            "className": "icon",
            "viewBox": "0 0 1024 1024",
            "fill": "currentColor"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM712 792H136V232h576v560zm176-167l-104-59.8V458.9L888 399v226zM208 360h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H208c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            }
        ],
        "content": "\n"
    })(props);
};

});

parcelRegister("jhAi2", function(module, exports) {
parcelRequire("kNUzI");
var $3H1D6 = parcelRequire("3H1D6");
var $e09bc14bc7611170$require$GenIcon = $3H1D6.GenIcon;
module.exports = function(props) {
    return $e09bc14bc7611170$require$GenIcon({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 20 20",
            "fill": "currentColor"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18h12V6h-4V2H4v16zm-2 1V0h12l4 4v16H2v-1z"
                }
            }
        ]
    })(props);
};

});

parcelRegister("eoqrz", function(module, exports) {
parcelRequire("kNUzI");
var $3H1D6 = parcelRequire("3H1D6");
var $a7a7d1c42393e00c$require$GenIcon = $3H1D6.GenIcon;
module.exports = function(props) {
    return $a7a7d1c42393e00c$require$GenIcon({
        "tag": "svg",
        "attr": {
            "className": "icon",
            "viewBox": "0 0 1024 1024",
            "fill": "currentColor"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560zM610.3 476h123.4c1.3 0 2.3-3.6 2.3-8v-48c0-4.4-1-8-2.3-8H610.3c-1.3 0-2.3 3.6-2.3 8v48c0 4.4 1 8 2.3 8zm4.8 144h185.7c3.9 0 7.1-3.6 7.1-8v-48c0-4.4-3.2-8-7.1-8H615.1c-3.9 0-7.1 3.6-7.1 8v48c0 4.4 3.2 8 7.1 8zM224 673h43.9c4.2 0 7.6-3.3 7.9-7.5 3.8-50.5 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H522a8 8 0 0 0 8-8.4c-2.8-53.3-32-99.7-74.6-126.1a111.8 111.8 0 0 0 29.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 0 0-74.6 126.1c-.4 4.6 3.2 8.4 7.8 8.4zm149-262c28.5 0 51.7 23.3 51.7 52s-23.2 52-51.7 52-51.7-23.3-51.7-52 23.2-52 51.7-52z"
                }
            }
        ],
        "content": "\n"
    })(props);
};

});


parcelRegister("bSvr9", function(module, exports) {
"use strict";
var $8a5d1f9376b1dc77$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.UploadPanel = module.exports.setUploadFunc = void 0;

const $8a5d1f9376b1dc77$var$react_1 = $8a5d1f9376b1dc77$var$__importDefault((parcelRequire("8NFma")));

var $gUePa = parcelRequire("gUePa");

var $jAdIt = parcelRequire("jAdIt");

var $1FSbc = parcelRequire("1FSbc");

var $eRKBF = parcelRequire("eRKBF");

var $xARwM = parcelRequire("xARwM");

var $juOim = parcelRequire("juOim");

var $bGLDM = parcelRequire("bGLDM");

var $iiVH7 = parcelRequire("iiVH7");
let $8a5d1f9376b1dc77$var$uploadFunc = async (e)=>(0, $1FSbc.localFileToURL)(e);
function $8a5d1f9376b1dc77$var$setUploadFunc(e) {
    $8a5d1f9376b1dc77$var$uploadFunc = e;
}
module.exports.setUploadFunc = $8a5d1f9376b1dc77$var$setUploadFunc;
let $8a5d1f9376b1dc77$var$filesCache = [];
function $8a5d1f9376b1dc77$var$getType(e) {
    const { type: t } = e;
    return t.indexOf("svg") >= 0 ? "svg" : t.indexOf("image") >= 0 ? "image" : t.indexOf("video") >= 0 ? "video" : "image";
}
const $8a5d1f9376b1dc77$var$UploadPanel = ({ store: e })=>{
    const [t, l] = $8a5d1f9376b1dc77$var$react_1.default.useState($8a5d1f9376b1dc77$var$filesCache), [a, r] = $8a5d1f9376b1dc77$var$react_1.default.useState(!1), i = $8a5d1f9376b1dc77$var$react_1.default.useRef(null);
    return $8a5d1f9376b1dc77$var$react_1.default.useEffect(()=>{
        $8a5d1f9376b1dc77$var$filesCache = t;
    }, [
        t
    ]), $8a5d1f9376b1dc77$var$react_1.default.createElement("div", {
        style: {
            height: "100%",
            display: "flex",
            flexDirection: "column"
        }
    }, $8a5d1f9376b1dc77$var$react_1.default.createElement("div", {
        style: {
            height: "45px",
            paddingTop: "5px"
        }
    }, (0, $xARwM.t)("sidePanel.uploadTip")), $8a5d1f9376b1dc77$var$react_1.default.createElement("div", {
        style: {
            marginBottom: "20px"
        }
    }, $8a5d1f9376b1dc77$var$react_1.default.createElement("label", {
        htmlFor: "input-file"
    }, $8a5d1f9376b1dc77$var$react_1.default.createElement($gUePa.Button, {
        icon: "upload",
        style: {
            width: "100%"
        },
        onClick: ()=>{
            var e;
            null === (e = i.current) || void 0 === e || e.click();
        }
    }, (0, $xARwM.t)("sidePanel.uploadImage")), $8a5d1f9376b1dc77$var$react_1.default.createElement("input", {
        type: "file",
        ref: i,
        style: {
            display: "none"
        },
        onChange: async (e)=>{
            const { target: t } = e;
            r(!0);
            try {
                for (const e of t.files){
                    const t = await $8a5d1f9376b1dc77$var$uploadFunc(e), a = $8a5d1f9376b1dc77$var$getType(e);
                    let r = t;
                    "video" === a && (r = await (0, $jAdIt.getVideoPreview)(t)), l((e)=>e.concat([
                            {
                                url: t,
                                type: a,
                                preview: r
                            }
                        ]));
                }
            } catch (e) {
                console.error(e);
            }
            r(!1), t.value = "";
        },
        multiple: !0
    }))), $8a5d1f9376b1dc77$var$react_1.default.createElement($eRKBF.ImagesGrid, {
        images: t,
        isLoading: a,
        getPreview: (e)=>e.preview,
        onSelect: async (t, l, a)=>{
            const r = t.url, i = t.type;
            "image" === i ? (0, $juOim.selectImage)({
                src: r,
                store: e,
                droppedPos: l,
                targetElement: a
            }) : "video" === i ? (0, $bGLDM.selectVideo)({
                src: r,
                store: e,
                droppedPos: l,
                targetElement: a
            }) : "svg" === i && (0, $iiVH7.selectSvg)({
                src: r,
                store: e,
                droppedPos: l,
                targetElement: a
            });
        }
    }));
};
module.exports.UploadPanel = $8a5d1f9376b1dc77$var$UploadPanel;

});
parcelRegister("1FSbc", function(module, exports) {
"use strict";
async function $1383a5b51fd851cb$var$localFileToURL(e) {
    return new Promise((o, l)=>{
        const r = new FileReader;
        r.readAsDataURL(e), r.onload = ()=>o(r.result), r.onerror = (e)=>l(e);
    });
}
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.localFileToURL = void 0, module.exports.localFileToURL = $1383a5b51fd851cb$var$localFileToURL;

});

parcelRegister("juOim", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.selectImage = void 0;

var $8VFx4 = parcelRequire("8VFx4");

var $8VFx4 = parcelRequire("8VFx4");
const $e317d53ad9812618$var$selectImage = async ({ src: e, droppedPos: t, targetElement: i, store: s })=>{
    var a;
    if (i && "svg" === i.type && i.contentEditable) {
        const t = i.parent, a = i.zIndex, n = Object.assign({}, i.toJSON());
        delete n.id, s.deleteElements([
            i.id
        ]);
        return void t.addElement(Object.assign(Object.assign({}, n), {
            type: "image",
            src: e,
            clipSrc: n.src
        })).setZIndex(a);
    }
    i && "figure" === i.type && i.contentEditable;
    let { width: n, height: g } = await (0, $8VFx4.getImageSize)(e);
    if (i && "image" === i.type && i.contentEditable) {
        const t = (0, $8VFx4.getCrop)(i, {
            width: n,
            height: g
        });
        return void i.set(Object.assign({
            src: e
        }, t));
    }
    const d = Math.min(s.width / n, s.height / g, 1);
    n *= d, g *= d;
    const c = ((null == t ? void 0 : t.x) || s.width / 2) - n / 2, r = ((null == t ? void 0 : t.y) || s.height / 2) - g / 2;
    null === (a = s.activePage) || void 0 === a || a.addElement({
        type: "image",
        src: e,
        width: n,
        height: g,
        x: c,
        y: r
    });
};
module.exports.selectImage = $e317d53ad9812618$var$selectImage;

});

parcelRegister("bGLDM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.selectVideo = void 0;

var $jAdIt = parcelRequire("jAdIt");
const $88289260a384334c$var$selectVideo = async ({ src: e, droppedPos: t, targetElement: i, store: o })=>{
    var d;
    let { width: s, height: l } = await (0, $jAdIt.getVideoSize)(e);
    const r = Math.min(o.width / s, o.height / l, 1);
    s *= r, l *= r;
    const c = ((null == t ? void 0 : t.x) || o.width / 2) - s / 2, h = ((null == t ? void 0 : t.y) || o.height / 2) - l / 2;
    null === (d = o.activePage) || void 0 === d || d.addElement({
        type: "video",
        src: e,
        width: s,
        height: l,
        x: c,
        y: h
    });
};
module.exports.selectVideo = $88289260a384334c$var$selectVideo;

});

parcelRegister("iiVH7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.selectSvg = void 0;

var $8VFx4 = parcelRequire("8VFx4");
const $d536a954bf35aaf2$var$selectSvg = async ({ src: e, droppedPos: t, targetElement: i, store: s })=>{
    var l;
    if (i && "image" === i.type && i.contentEditable) return void i.set({
        clipSrc: e
    });
    const { width: r, height: g } = await (0, $8VFx4.getImageSize)(e), o = ((null == t ? void 0 : t.x) || s.width / 2) - r / 2, a = ((null == t ? void 0 : t.y) || s.height / 2) - g / 2;
    null === (l = s.activePage) || void 0 === l || l.addElement({
        type: "svg",
        width: r,
        height: g,
        x: o,
        y: a,
        src: e
    });
};
module.exports.selectSvg = $d536a954bf35aaf2$var$selectSvg;

});


parcelRegister("4b0wY", function(module, exports) {
"use strict";
var $30a899eb12373482$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.PhotosPanel = void 0;

const $30a899eb12373482$var$react_1 = $30a899eb12373482$var$__importDefault((parcelRequire("8NFma")));

var $kTifg = parcelRequire("kTifg");

var $eRKBF = parcelRequire("eRKBF");

var $3TNde = parcelRequire("3TNde");

var $xARwM = parcelRequire("xARwM");

var $6laUv = parcelRequire("6laUv");

var $juOim = parcelRequire("juOim");
const $30a899eb12373482$var$PhotosPanel = ({ store: e })=>{
    const { setQuery: t, loadMore: r, isReachingEnd: a, data: l, isLoading: s, error: o } = (0, $3TNde.useInfiniteAPI)({
        defaultQuery: "",
        getAPI: ({ page: e, query: t })=>(0, $6laUv.unsplashList)({
                page: e,
                query: t
            })
    });
    return $30a899eb12373482$var$react_1.default.createElement("div", {
        style: {
            height: "100%",
            display: "flex",
            flexDirection: "column"
        }
    }, $30a899eb12373482$var$react_1.default.createElement($kTifg.InputGroup, {
        leftIcon: "search",
        placeholder: (0, $xARwM.t)("sidePanel.searchPlaceholder"),
        onChange: (e)=>{
            t(e.target.value);
        },
        type: "search",
        style: {
            marginBottom: "20px"
        }
    }), $30a899eb12373482$var$react_1.default.createElement("p", {
        style: {
            textAlign: "center"
        }
    }, "Photos by", " ", $30a899eb12373482$var$react_1.default.createElement("a", {
        href: "https://unsplash.com/",
        target: "_blank"
    }, "Unsplash")), $30a899eb12373482$var$react_1.default.createElement($eRKBF.ImagesGrid, {
        images: null == l ? void 0 : l.map((e)=>e.results).flat().filter(Boolean),
        getPreview: (e)=>e.urls.small,
        onSelect: async (t, r, a)=>{
            fetch((0, $6laUv.unsplashDownload)(t.id)), (0, $juOim.selectImage)({
                src: t.urls.regular,
                store: e,
                droppedPos: r,
                targetElement: a
            });
        },
        isLoading: s,
        error: o,
        loadMore: !a && r,
        getCredit: (e)=>$30a899eb12373482$var$react_1.default.createElement("span", null, "Photo by", " ", $30a899eb12373482$var$react_1.default.createElement("a", {
                href: `https://unsplash.com/@${e.user.username}?utm_source=polotno&utm_medium=referral`,
                target: "_blank"
            }, e.user.name), " ", "on", " ", $30a899eb12373482$var$react_1.default.createElement("a", {
                href: "https://unsplash.com/?utm_source=polotno&utm_medium=referral",
                target: "_blank"
            }, "Unsplash"))
    }));
};
module.exports.PhotosPanel = $30a899eb12373482$var$PhotosPanel;

});

parcelRegister("hW0dp", function(module, exports) {
"use strict";
var $d0e8053859c3eda5$var$__rest = module.exports && module.exports.__rest || function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var l = 0;
        for(a = Object.getOwnPropertySymbols(e); l < a.length; l++)t.indexOf(a[l]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[l]) && (r[a[l]] = e[a[l]]);
    }
    return r;
}, $d0e8053859c3eda5$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.BackgroundPanel = void 0;

const $d0e8053859c3eda5$var$react_1 = $d0e8053859c3eda5$var$__importDefault((parcelRequire("8NFma")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

var $kTifg = parcelRequire("kTifg");

const $d0e8053859c3eda5$var$IosColorPalette_1 = $d0e8053859c3eda5$var$__importDefault((parcelRequire("4uWbj")));

var $gaqum = parcelRequire("gaqum");

var $eRKBF = parcelRequire("eRKBF");

const $d0e8053859c3eda5$var$styled_1 = $d0e8053859c3eda5$var$__importDefault((parcelRequire("MPenY")));

var $xARwM = parcelRequire("xARwM");

var $3TNde = parcelRequire("3TNde");

var $6laUv = parcelRequire("6laUv");
const $d0e8053859c3eda5$var$colors = [
    "white",
    "rgb(82, 113, 255)",
    "rgb(255, 145, 77)",
    "rgb(126, 217, 87)",
    "rgb(255, 222, 89)",
    "rgb(203, 108, 230)",
    "rgb(0, 0, 0, 0)"
], $d0e8053859c3eda5$var$ColoredContainer = (0, $d0e8053859c3eda5$var$styled_1.default)("div")`
  display: inline-block;
  width: 30px;
  height: 30px;
  border-radius: 2px;
  box-shadow: 0 0 2px rgba(16, 22, 26, 0.3);
  cursor: pointer;
`, $d0e8053859c3eda5$var$Colored = (e)=>{
    var { children: t, color: r } = e, a = $d0e8053859c3eda5$var$__rest(e, [
        "children",
        "color"
    ]);
    return $d0e8053859c3eda5$var$react_1.default.createElement($d0e8053859c3eda5$var$ColoredContainer, Object.assign({}, a, {
        style: Object.assign(Object.assign({}, a.style), {
            background: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='15' height='15' viewBox='0 0 8 8'%3E%3Cg fill='rgba(112, 112, 116, 1)' fill-opacity='1'%3E%3Cpath fill-rule='evenodd' d='M0 0h4v4H0V0zm4 4h4v4H4V4z'/%3E%3C/g%3E%3C/svg%3E\")"
        })
    }), $d0e8053859c3eda5$var$react_1.default.createElement("div", {
        style: {
            width: "100%",
            height: "100%",
            background: r
        }
    }, t));
};
module.exports.BackgroundPanel = (0, $O1ETn.observer)(({ store: e })=>{
    var t, r;
    const { setQuery: a, loadMore: l, isReachingEnd: o, data: i, isLoading: n, error: s } = (0, $3TNde.useInfiniteAPI)({
        defaultQuery: "gradient",
        getAPI: ({ page: e, query: t })=>(0, $6laUv.unsplashList)({
                page: e,
                query: t
            })
    });
    return $d0e8053859c3eda5$var$react_1.default.createElement("div", {
        style: {
            height: "100%",
            display: "flex",
            flexDirection: "column"
        }
    }, $d0e8053859c3eda5$var$react_1.default.createElement("div", {
        style: {
            display: "flex",
            justifyContent: "space-around",
            paddingBottom: "10px"
        }
    }, $d0e8053859c3eda5$var$react_1.default.createElement($gaqum.ColorPicker, {
        value: (null === (t = e.activePage) || void 0 === t ? void 0 : t.background) || "white",
        onChange: (t)=>{
            var r;
            null === (r = e.activePage) || void 0 === r || r.set({
                background: t
            });
        },
        store: e
    }, $d0e8053859c3eda5$var$react_1.default.createElement($d0e8053859c3eda5$var$Colored, {
        color: null === (r = e.activePage) || void 0 === r ? void 0 : r.background,
        style: {
            fontSize: "30px"
        }
    }, $d0e8053859c3eda5$var$react_1.default.createElement($d0e8053859c3eda5$var$IosColorPalette_1.default, {
        style: {
            mixBlendMode: "difference"
        }
    }))), $d0e8053859c3eda5$var$colors.map((t)=>$d0e8053859c3eda5$var$react_1.default.createElement($d0e8053859c3eda5$var$Colored, {
            key: t,
            color: t,
            onClick: ()=>{
                var r;
                null === (r = e.activePage) || void 0 === r || r.set({
                    background: t
                });
            }
        }))), $d0e8053859c3eda5$var$react_1.default.createElement($kTifg.InputGroup, {
        leftIcon: "search",
        placeholder: (0, $xARwM.t)("sidePanel.searchPlaceholder"),
        onChange: (e)=>{
            a(e.target.value);
        },
        type: "search",
        style: {
            marginBottom: "20px"
        }
    }), $d0e8053859c3eda5$var$react_1.default.createElement("p", {
        style: {
            textAlign: "center"
        }
    }, "Photos by", " ", $d0e8053859c3eda5$var$react_1.default.createElement("a", {
        href: "https://unsplash.com/",
        target: "_blank"
    }, "Unsplash")), $d0e8053859c3eda5$var$react_1.default.createElement($eRKBF.ImagesGrid, {
        images: null == i ? void 0 : i.map((e)=>e.results).flat().filter(Boolean),
        isLoading: n,
        getPreview: (e)=>e.urls.small,
        loadMore: !o && l,
        onSelect: async (t)=>{
            var r;
            fetch((0, $6laUv.unsplashDownload)(t.id)), null === (r = e.activePage) || void 0 === r || r.set({
                background: t.urls.regular
            });
        },
        error: s,
        getCredit: (e)=>$d0e8053859c3eda5$var$react_1.default.createElement("span", null, "Photo by", " ", $d0e8053859c3eda5$var$react_1.default.createElement("a", {
                href: `https://unsplash.com/@${e.user.username}?utm_source=polotno&utm_medium=referral`,
                target: "_blank"
            }, e.user.name), " ", "on", " ", $d0e8053859c3eda5$var$react_1.default.createElement("a", {
                href: "https://unsplash.com/?utm_source=polotno&utm_medium=referral",
                target: "_blank"
            }, "Unsplash"))
    }));
});

});
parcelRegister("4uWbj", function(module, exports) {
parcelRequire("kNUzI");
var $3H1D6 = parcelRequire("3H1D6");
var $34671862cc2ced5f$require$GenIcon = $3H1D6.GenIcon;
module.exports = function(props) {
    return $34671862cc2ced5f$require$GenIcon({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512",
            "fill": "currentColor"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M430.1 347.9c-6.6-6.1-16.3-7.6-24.6-9-11.5-1.9-15.9-4-22.6-10-14.3-12.7-14.3-31.1 0-43.8l30.3-26.9c46.4-41 46.4-108.2 0-149.2-34.2-30.1-80.1-45-127.8-45-55.7 0-113.9 20.3-158.8 60.1-83.5 73.8-83.5 194.7 0 268.5 41.5 36.7 97.5 55 152.9 55.4h1.7c55.4 0 110-17.9 148.8-52.4 14.4-12.7 12-36.6.1-47.7zM120 216c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm40 126c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64-161c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm72 219c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm24-208c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
};

});


parcelRegister("jtIqq", function(module, exports) {
"use strict";
var $e2e32fafca3d233c$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.ElementsPanel = module.exports.Shapes = module.exports.NounprojectPanel = void 0;

const $e2e32fafca3d233c$var$react_1 = $e2e32fafca3d233c$var$__importDefault((parcelRequire("8NFma")));

var $58B0H = parcelRequire("58B0H");

var $kTifg = parcelRequire("kTifg");

var $eRKBF = parcelRequire("eRKBF");

var $eRGXT = parcelRequire("eRGXT");

var $jkJqh = parcelRequire("jkJqh");

const $e2e32fafca3d233c$var$styled_1 = $e2e32fafca3d233c$var$__importDefault((parcelRequire("MPenY")));

var $xARwM = parcelRequire("xARwM");

var $3TNde = parcelRequire("3TNde");

var $6laUv = parcelRequire("6laUv");

var $8PUQD = parcelRequire("8PUQD");
const $e2e32fafca3d233c$var$iconToSrc = async (e)=>{
    const t = await fetch(`${(0, $6laUv.getAPI)()}/download-nounproject?id=${e}&KEY=${(0, $8PUQD.getKey)()}`), r = await t.text();
    return await (0, $eRGXT.svgToURL)(r);
}, $e2e32fafca3d233c$var$NounContainer = (0, $e2e32fafca3d233c$var$styled_1.default)("div")`
  height: 100%;
  overflow: hidden;

  .bp5-dark & img {
    filter: invert(1);
  }
`, $e2e32fafca3d233c$var$limit = 50, $e2e32fafca3d233c$var$NounprojectPanel = ({ store: e, query: t })=>{
    const { data: r, isLoading: a, loadMore: i, setQuery: o, hasMore: s } = (0, $3TNde.useInfiniteAPI)({
        defaultQuery: t,
        getAPI: ({ page: e, query: t })=>`${(0, $6laUv.getAPI)()}/get-nounproject?query=${t}&page=${e}&limit=50&KEY=${(0, $8PUQD.getKey)()}`,
        getSize: (e)=>e.pagesNumber
    });
    return $e2e32fafca3d233c$var$react_1.default.useEffect(()=>{
        o(t);
    }, [
        t
    ]), $e2e32fafca3d233c$var$react_1.default.createElement($e2e32fafca3d233c$var$NounContainer, null, $e2e32fafca3d233c$var$react_1.default.createElement($eRKBF.ImagesGrid, {
        shadowEnabled: !1,
        images: null == r ? void 0 : r.map((e)=>e.icons).flat(),
        getPreview: (e)=>e.preview_url_84,
        isLoading: a,
        onSelect: async (t, r, a)=>{
            if (a && "image" === a.type && a.contentEditable) {
                const e = await $e2e32fafca3d233c$var$iconToSrc(t.id);
                return void a.set({
                    clipSrc: e
                });
            }
            e.history.transaction(async ()=>{
                var a;
                const i = ((null == r ? void 0 : r.x) || e.width / 2) - 100, o = ((null == r ? void 0 : r.y) || e.height / 2) - 100, s = null === (a = e.activePage) || void 0 === a ? void 0 : a.addElement({
                    type: "svg",
                    width: 200,
                    height: 200,
                    x: i,
                    y: o
                }), n = await $e2e32fafca3d233c$var$iconToSrc(t.id);
                (0, $58B0H.isAlive)(s) && await s.set({
                    src: n
                });
            });
        },
        rowsNumber: 4,
        loadMore: s && i
    }));
};
module.exports.NounprojectPanel = $e2e32fafca3d233c$var$NounprojectPanel;
const $e2e32fafca3d233c$var$LINES = [
    {
        preview: $eRGXT.svgToURL`
<svg xmlns="http://www.w3.org/2000/svg" width="32" height="16">
  <path stroke="currentColor" strokeWidth="4" d="M 1 8 L 30 8"></path>
</svg>
`,
        data: {}
    },
    {
        preview: $eRGXT.svgToURL`
<svg xmlns="http://www.w3.org/2000/svg" width="32" height="16">
  <path stroke="currentColor" strokeWidth="4" stroke-dasharray="4 2" d="M 1 8 L 30 8"></path>
</svg>
`,
        data: {
            dash: [
                4,
                2
            ]
        }
    },
    {
        preview: $eRGXT.svgToURL`
<svg xmlns="http://www.w3.org/2000/svg" width="32" height="16">
  <path stroke="currentColor" strokeWidth="4" stroke-dasharray="1 1" d="M 1 8 L 30 8"></path>
</svg>
`,
        data: {
            dash: [
                1,
                1
            ]
        }
    },
    {
        preview: $eRGXT.svgToURL`
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="16">
    <path
      stroke="currentColor"
      strokeWidth="2"
      d="M 25 6 L 29 8 L 25 10"
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
    ></path>
    <path
      stroke="currentColor"
      strokeWidth="4" d="M 1 8 L 29 8"
      strokeLinejoin="round"
      strokeLinecap="round"
    ></path>
  </svg>
`,
        data: {
            endHead: "arrow"
        }
    },
    {
        preview: $eRGXT.svgToURL`
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="16">
    <path
      stroke="currentColor"
      strokeWidth="2"
      d="M 25 6 L 29 8 L 25 10 Z"
      fill="currentColor"
      strokeLinejoin="round"
      strokeLinecap="round"
    ></path>
    <path
      stroke="currentColor"
      strokeWidth="4" d="M 1 8 L 29 8"
      strokeLinejoin="round"
      strokeLinecap="round"
    ></path>
    <circle cx="3" cy="8" r="2" fill="currentColor"></circle>
  </svg>
`,
        data: {
            startHead: "circle",
            endHead: "arrow"
        }
    },
    {
        preview: $eRGXT.svgToURL`
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="16">
    <path
      stroke="currentColor"
      strokeWidth="2"
      d="M 1 6 L 5 6 L 5 10 L 1 10 Z"
      fill="currentColor"
      strokeLinejoin="round"
      strokeLinecap="round"
    ></path>
    <path
      stroke="currentColor"
      strokeWidth="4" d="M 1 8 L 29 8"
      strokeLinejoin="round"
      strokeLinecap="round"
      stroke-dasharray="2 1"
    ></path>
    <path
      stroke="currentColor"
      strokeWidth="4" d="M 29 6 L 29 10"
      strokeLinejoin="round"
      strokeLinecap="round"
    ></path>
  </svg>
`,
        data: {
            startHead: "circle",
            endHead: "bar",
            dash: [
                2,
                1
            ]
        }
    }
], $e2e32fafca3d233c$var$Lines = ({ store: e })=>$e2e32fafca3d233c$var$react_1.default.createElement($eRKBF.ImagesGrid, {
        shadowEnabled: !1,
        rowsNumber: 3,
        images: $e2e32fafca3d233c$var$LINES,
        getPreview: (e)=>e.preview,
        itemHeight: 50,
        isLoading: !1,
        onSelect: async (t, r, a)=>{
            const i = e.activePage.computedWidth / 3;
            e.activePage.addElement(Object.assign({
                type: "line",
                x: r ? r.x : e.activePage.computedWidth / 2 - i / 2,
                y: r ? r.y : e.activePage.computedHeight / 2,
                width: i
            }, t.data));
        }
    }), $e2e32fafca3d233c$var$FIGURE_DEFAULTS = {
    width: 300,
    height: 300,
    fill: "lightgray",
    stroke: "#0c0c0c",
    strokeWidth: 0,
    url: ""
}, $e2e32fafca3d233c$var$subTypes = Object.keys($jkJqh.TYPES), $e2e32fafca3d233c$var$DEFAULTS = [
    $e2e32fafca3d233c$var$FIGURE_DEFAULTS
], $e2e32fafca3d233c$var$FIGURES = [];
$e2e32fafca3d233c$var$subTypes.forEach((e)=>{
    $e2e32fafca3d233c$var$DEFAULTS.forEach((t)=>{
        $e2e32fafca3d233c$var$FIGURES.push(Object.assign({
            subType: e
        }, t));
    });
}), $e2e32fafca3d233c$var$FIGURES.forEach((e)=>{
    e.url = (0, $eRGXT.svgToURL)((0, $jkJqh.figureToSvg)(e));
});
const $e2e32fafca3d233c$var$BasicShapesContainer = (0, $e2e32fafca3d233c$var$styled_1.default)("div")`
  height: 220px;
  // .bp5-dark & img {
  //   filter: invert(1);
  // }
`, $e2e32fafca3d233c$var$BasicShapes = ({ store: e })=>{
    const t = Math.ceil($e2e32fafca3d233c$var$FIGURES.length / 4) || 1;
    return $e2e32fafca3d233c$var$react_1.default.createElement($e2e32fafca3d233c$var$BasicShapesContainer, {
        style: {
            height: 110 * t + "px"
        }
    }, $e2e32fafca3d233c$var$react_1.default.createElement($eRKBF.ImagesGrid, {
        shadowEnabled: !1,
        rowsNumber: 4,
        images: $e2e32fafca3d233c$var$FIGURES,
        getPreview: (e)=>e.url,
        isLoading: !1,
        itemHeight: 100,
        onSelect: async (t, r, a)=>{
            var i;
            if (a && "image" === a.type && a.contentEditable) return void a.set({
                clipSrc: t.url
            });
            const o = (e.activePage.computedWidth + e.activePage.computedHeight) / 2160, s = t.width * o, n = t.height * o, l = ((null == r ? void 0 : r.x) || e.activePage.computedWidth / 2) - s / 2, d = ((null == r ? void 0 : r.y) || e.activePage.computedHeight / 2) - n / 2;
            null === (i = e.activePage) || void 0 === i || i.addElement(Object.assign(Object.assign({
                type: "figure"
            }, t), {
                x: l,
                y: d,
                width: s,
                height: n
            }));
        }
    }));
}, $e2e32fafca3d233c$var$LinesContainer = (0, $e2e32fafca3d233c$var$styled_1.default)("div")`
  height: 220px;
  .bp5-dark & img {
    filter: invert(1);
  }
`, $e2e32fafca3d233c$var$Shapes = ({ store: e })=>$e2e32fafca3d233c$var$react_1.default.createElement("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            height: "100%",
            overflow: "auto"
        }
    }, $e2e32fafca3d233c$var$react_1.default.createElement("p", null, (0, $xARwM.t)("sidePanel.lines")), $e2e32fafca3d233c$var$react_1.default.createElement($e2e32fafca3d233c$var$LinesContainer, null, $e2e32fafca3d233c$var$react_1.default.createElement($e2e32fafca3d233c$var$Lines, {
        store: e
    })), $e2e32fafca3d233c$var$react_1.default.createElement("p", null, (0, $xARwM.t)("sidePanel.shapes")), $e2e32fafca3d233c$var$react_1.default.createElement($e2e32fafca3d233c$var$BasicShapes, {
        store: e
    }));
module.exports.Shapes = $e2e32fafca3d233c$var$Shapes;
const $e2e32fafca3d233c$var$ElementsPanel = ({ store: e })=>{
    const t = $e2e32fafca3d233c$var$react_1.default.useRef(), [r, a] = $e2e32fafca3d233c$var$react_1.default.useState(""), [i, o] = $e2e32fafca3d233c$var$react_1.default.useState(r);
    $e2e32fafca3d233c$var$react_1.default.useEffect(()=>(t.current = setTimeout(()=>{
            o(r);
        }, 500), ()=>{
            clearTimeout(t.current);
        }), [
        r
    ]);
    const s = !!i;
    return $e2e32fafca3d233c$var$react_1.default.createElement("div", {
        style: {
            height: "100%",
            display: "flex",
            flexDirection: "column"
        }
    }, $e2e32fafca3d233c$var$react_1.default.createElement($kTifg.InputGroup, {
        leftIcon: "search",
        placeholder: (0, $xARwM.t)("sidePanel.searchPlaceholder"),
        onChange: (e)=>{
            a(e.target.value);
        },
        style: {
            marginBottom: "20px"
        },
        type: "search"
    }), s && $e2e32fafca3d233c$var$react_1.default.createElement(module.exports.NounprojectPanel, {
        query: i,
        store: e
    }), !s && $e2e32fafca3d233c$var$react_1.default.createElement(module.exports.Shapes, {
        store: e
    }));
};
module.exports.ElementsPanel = $e2e32fafca3d233c$var$ElementsPanel;

});

parcelRegister("2b3so", function(module, exports) {
"use strict";
var $195f4a523243ee4a$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.PagesPanel = void 0;

const $195f4a523243ee4a$var$react_1 = $195f4a523243ee4a$var$__importDefault((parcelRequire("8NFma")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

var $eRKBF = parcelRequire("eRKBF");
module.exports.PagesPanel = (0, $O1ETn.observer)(({ store: e })=>{
    const [t, r] = $195f4a523243ee4a$var$react_1.default.useState({}), a = ()=>{
        const t = {};
        e.pages.forEach((r)=>{
            const a = e.toDataURL({
                pageId: r.id,
                pixelRatio: .2
            });
            t[r.id] = a;
        }), r(t);
    };
    return $195f4a523243ee4a$var$react_1.default.useEffect(()=>{
        const e = setInterval(a, 1e3);
        return ()=>clearInterval(e);
    }, []), $195f4a523243ee4a$var$react_1.default.createElement("div", {
        style: {
            height: "100%"
        }
    }, $195f4a523243ee4a$var$react_1.default.createElement($eRKBF.ImagesGrid, {
        images: e.pages.slice(),
        getPreview: (r)=>t[r.id] || e.pages.indexOf(r),
        onSelect: async (t)=>{
            e.selectPage(t.id);
        },
        isLoading: !1,
        rowsNumber: 2
    }));
});

});

parcelRegister("l6SsR", function(module, exports) {
"use strict";
var $f5e468072f18138c$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.TemplatesPanel = void 0;

const $f5e468072f18138c$var$react_1 = $f5e468072f18138c$var$__importDefault((parcelRequire("8NFma")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

var $2nesQ = parcelRequire("2nesQ");
var $kTifg = parcelRequire("kTifg");
var $5r5rj = parcelRequire("5r5rj");

var $aQPnZ = parcelRequire("aQPnZ");

var $6k1PQ = parcelRequire("6k1PQ");

var $xARwM = parcelRequire("xARwM");

var $eRKBF = parcelRequire("eRKBF");

var $6laUv = parcelRequire("6laUv");

var $3TNde = parcelRequire("3TNde");
const $f5e468072f18138c$var$useChange = (e, t)=>{
    const r = $f5e468072f18138c$var$react_1.default.useRef(!0);
    $f5e468072f18138c$var$react_1.default.useEffect(()=>{
        r.current ? r.current = !1 : e();
    }, t);
}, $f5e468072f18138c$var$Templates = (0, $O1ETn.observer)(({ sizeQuery: e, query: t, store: r })=>{
    const { setQuery: a, loadMore: i, hasMore: s, data: l, isLoading: o, reset: n, error: u } = (0, $3TNde.useInfiniteAPI)({
        getAPI: ({ page: t, query: r })=>(0, $6laUv.templateList)({
                page: t,
                query: r,
                sizeQuery: e
            }),
        getSize: (e)=>e.totalPages
    });
    return $f5e468072f18138c$var$useChange(()=>{
        n();
    }, [
        e
    ]), $f5e468072f18138c$var$useChange(()=>{
        a(t);
    }, [
        t
    ]), $f5e468072f18138c$var$react_1.default.createElement($eRKBF.ImagesGrid, {
        images: null == l ? void 0 : l.map((e)=>e.items).flat(),
        getPreview: (e)=>e.preview,
        isLoading: o,
        onSelect: async (e)=>{
            const t = await fetch(e.json), a = await t.json();
            if (r.pages.length <= 1) r.loadJSON(a, !0);
            else {
                const e = JSON.parse(JSON.stringify(r.toJSON()));
                e.width === a.width && e.height === a.height || a.pages.forEach((e)=>{
                    e.width = e.width || a.width, e.height = e.height || a.height;
                }), (0, $6k1PQ.forEveryChild)({
                    children: a.pages
                }, (e)=>{
                    e.id = (0, $aQPnZ.nanoid)(10);
                });
                const t = r.pages.indexOf(r.activePage);
                e.pages.splice(t, 1, ...a.pages), r.loadJSON(e, !0);
            }
        },
        loadMore: s && i,
        error: u
    });
});
module.exports.TemplatesPanel = (0, $O1ETn.observer)(({ store: e })=>{
    const [t, r] = $f5e468072f18138c$var$react_1.default.useState(!0), [a, i] = $f5e468072f18138c$var$react_1.default.useState(""), s = t ? `${e.width}x${e.height}` : "all";
    return $f5e468072f18138c$var$react_1.default.createElement("div", {
        style: {
            height: "100%",
            display: "flex",
            flexDirection: "column"
        }
    }, $f5e468072f18138c$var$react_1.default.createElement($kTifg.InputGroup, {
        leftIcon: "search",
        placeholder: (0, $xARwM.t)("sidePanel.searchPlaceholder"),
        type: "search",
        onChange: (e)=>{
            i(e.target.value);
        },
        style: {
            marginBottom: "20px"
        }
    }), $f5e468072f18138c$var$react_1.default.createElement($5r5rj.Switch, {
        checked: t,
        onChange: (e)=>{
            r(e.target.checked);
        },
        alignIndicator: $2nesQ.Alignment.RIGHT,
        style: {
            marginTop: "8px",
            marginBottom: "25px"
        }
    }, (0, $xARwM.t)("sidePanel.searchTemplatesWithSameSize"), " "), $f5e468072f18138c$var$react_1.default.createElement($f5e468072f18138c$var$Templates, {
        store: e,
        sizeQuery: "size=" + s,
        query: a
    }));
});

});

parcelRegister("h445m", function(module, exports) {
"use strict";
var $c6c5fab2a151608f$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.LayersPanel = void 0;

const $c6c5fab2a151608f$var$react_1 = $c6c5fab2a151608f$var$__importDefault((parcelRequire("8NFma")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

var $gUePa = parcelRequire("gUePa");
var $kjItu = parcelRequire("kjItu");
var $isBgX = parcelRequire("isBgX");
var $gKgL3 = parcelRequire("gKgL3");

var $xARwM = parcelRequire("xARwM");

var $3pcZ0 = parcelRequire("3pcZ0");

var $gHouc = parcelRequire("gHouc");

var $8vcNW = parcelRequire("8vcNW");
const $c6c5fab2a151608f$var$SortItem = (0, $O1ETn.observer)(({ element: e, store: t })=>{
    const l = t.selectedElements.indexOf(e) >= 0, [a, r] = $c6c5fab2a151608f$var$react_1.default.useState(!1), n = ()=>r(!1), i = a ? e.name : e.name || (0, $8vcNW.removeTags)(e.text) || `#${e.id}`;
    return $c6c5fab2a151608f$var$react_1.default.createElement($kjItu.Card, {
        onMouseDown: (l)=>{
            const a = l.ctrlKey || l.metaKey || l.shiftKey ? [
                ...t.selectedElementsIds
            ] : [];
            a.indexOf(e.id) < 0 && a.push(e.id), t.selectElements(a);
        },
        style: {
            padding: "5px",
            margin: "0px 1px 5px 1px",
            backgroundColor: l ? "rgb(0, 161, 255, 0.2)" : "",
            display: e.selectable || "admin" === t.role ? "auto" : "none"
        }
    }, $c6c5fab2a151608f$var$react_1.default.createElement("div", {
        style: {
            display: "flex",
            justifyContent: "space-between"
        }
    }, $c6c5fab2a151608f$var$react_1.default.createElement("div", {
        style: {
            lineHeight: "30px",
            display: "flex"
        }
    }, $c6c5fab2a151608f$var$react_1.default.createElement("div", {
        className: "drag-handle",
        style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "move",
            height: "30px"
        }
    }, $c6c5fab2a151608f$var$react_1.default.createElement($gKgL3.Icon, {
        icon: "drag-handle-vertical"
    })), $c6c5fab2a151608f$var$react_1.default.createElement("div", {
        style: {
            padding: "0 7px",
            opacity: .5,
            width: "55px"
        }
    }, (0, $xARwM.t)("sidePanel.layerTypes." + e.type)), $c6c5fab2a151608f$var$react_1.default.createElement("div", {
        style: {
            maxWidth: "142px"
        }
    }, $c6c5fab2a151608f$var$react_1.default.createElement($isBgX.EditableText, {
        minWidth: 130,
        placeholder: (0, $xARwM.t)("sidePanel.namePlaceholder"),
        value: i,
        maxLines: 1,
        onEdit: ()=>r(!0),
        onCancel: n,
        onConfirm: n,
        onChange: (t)=>{
            e.set({
                name: t
            });
        }
    }))), $c6c5fab2a151608f$var$react_1.default.createElement("div", null, $c6c5fab2a151608f$var$react_1.default.createElement($gUePa.Button, {
        minimal: !0,
        icon: (null == e ? void 0 : e.visible) ? "eye-open" : "eye-off",
        onClick: ()=>{
            e.set({
                visible: !e.visible
            });
        }
    }), $c6c5fab2a151608f$var$react_1.default.createElement($gUePa.Button, {
        minimal: !0,
        icon: (null == e ? void 0 : e.locked) ? "lock" : "unlock",
        onClick: ()=>{
            e.set({
                draggable: e.locked,
                contentEditable: e.locked,
                styleEditable: e.locked,
                resizable: e.locked
            });
        }
    }), $c6c5fab2a151608f$var$react_1.default.createElement($gUePa.Button, {
        icon: "trash",
        minimal: !0,
        disabled: !e.removable,
        onClick: ()=>{
            t.deleteElements([
                e.id
            ]);
        },
        style: {
            marginLeft: "auto"
        }
    }))));
});
module.exports.LayersPanel = (0, $O1ETn.observer)(({ store: e })=>{
    var t;
    const l = (null === (t = e.activePage) || void 0 === t ? void 0 : t.children.map((e)=>({
            id: e.id
        }))) || [];
    l.reverse();
    const a = (0, $3pcZ0.isMobile)();
    return $c6c5fab2a151608f$var$react_1.default.createElement("div", {
        style: {
            height: "100%",
            overflow: "auto"
        }
    }, $c6c5fab2a151608f$var$react_1.default.createElement("div", {
        style: {
            height: "40px",
            paddingTop: "5px"
        }
    }, (0, $xARwM.t)("sidePanel.layersTip")), $c6c5fab2a151608f$var$react_1.default.createElement("div", null, 0 === l.length ? $c6c5fab2a151608f$var$react_1.default.createElement("div", null, (0, $xARwM.t)("sidePanel.noLayers")) : null, $c6c5fab2a151608f$var$react_1.default.createElement($gHouc.ReactSortable, {
        list: l,
        setList: (t)=>{
            t.forEach(({ id: l }, a)=>{
                var r, n;
                const i = t.length - a - 1, c = e.getElementById(l);
                (null === (r = e.activePage) || void 0 === r ? void 0 : r.children.indexOf(c)) !== i && (null === (n = e.activePage) || void 0 === n || n.setElementZIndex(c.id, i));
            });
        },
        direction: "horizontal",
        handle: a ? ".drag-handle" : void 0
    }, l.map(({ id: t })=>{
        const l = e.getElementById(t);
        return $c6c5fab2a151608f$var$react_1.default.createElement($c6c5fab2a151608f$var$SortItem, {
            element: l,
            store: e,
            key: t
        });
    }))));
});

});
parcelRegister("kjItu", function(module, exports) {

$parcel$export(module.exports, "Card", () => $eca814bc0bdee1b8$export$60332b2344f7fe41);
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $auzpd = parcelRequire("auzpd");
var $ijRoR = parcelRequire("ijRoR");

var $hffzE = parcelRequire("hffzE");
var $eca814bc0bdee1b8$export$60332b2344f7fe41 = $8NFma.forwardRef(function(props, ref) {
    var _a;
    var className = props.className, elevation = props.elevation, interactive = props.interactive, selected = props.selected, compact = props.compact, htmlProps = (0, $gztBd.__rest)(props, [
        "className",
        "elevation",
        "interactive",
        "selected",
        "compact"
    ]);
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(className, (0, $auzpd).CARD, (0, $auzpd).elevationClass(elevation), (_a = {}, _a[(0, $auzpd).INTERACTIVE] = interactive, _a[(0, $auzpd).COMPACT] = compact, _a[(0, $auzpd).SELECTED] = selected, _a));
    return $8NFma.createElement("div", (0, $gztBd.__assign)({
        className: classes,
        ref: ref
    }, htmlProps));
});
$eca814bc0bdee1b8$export$60332b2344f7fe41.defaultProps = {
    elevation: (0, $ijRoR.Elevation).ZERO,
    interactive: false
};
$eca814bc0bdee1b8$export$60332b2344f7fe41.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".Card");

});

parcelRegister("isBgX", function(module, exports) {

$parcel$export(module.exports, "EditableText", () => $d707c114e16c4856$export$a0dcf0ef8dc3ae26);
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $4Jy2D = parcelRequire("4Jy2D");
var $auzpd = parcelRequire("auzpd");

var $hffzE = parcelRequire("hffzE");

var $h8UCV = parcelRequire("h8UCV");
var $d707c114e16c4856$var$BUFFER_WIDTH_DEFAULT = 5;
/**
 * EditableText component.
 *
 * @see https://blueprintjs.com/docs/#core/components/editable-text
 */ var $d707c114e16c4856$export$a0dcf0ef8dc3ae26 = /** @class */ function(_super) {
    (0, $gztBd.__extends)(EditableText, _super);
    function EditableText(props) {
        var _this = _super.call(this, props) || this;
        _this.inputElement = null;
        _this.valueElement = null;
        _this.refHandlers = {
            content: function(spanElement) {
                _this.valueElement = spanElement;
            },
            input: function(input) {
                if (input != null) {
                    _this.inputElement = input;
                    // temporary fix for #3882
                    if (!_this.props.alwaysRenderInput) _this.inputElement.focus();
                    if (_this.state != null && _this.state.isEditing) {
                        var supportsSelection = $d707c114e16c4856$var$inputSupportsSelection(input);
                        if (supportsSelection) {
                            var length_1 = input.value.length;
                            input.setSelectionRange(_this.props.selectAllOnFocus ? 0 : length_1, length_1);
                        }
                        if (!supportsSelection || !_this.props.selectAllOnFocus) input.scrollLeft = input.scrollWidth;
                    }
                }
            }
        };
        _this.cancelEditing = function() {
            var _a, _b, _c, _d;
            var _e = _this.state, lastValue = _e.lastValue, value = _e.value;
            _this.setState({
                isEditing: false,
                value: lastValue
            });
            if (value !== lastValue) (_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, lastValue);
            (_d = (_c = _this.props).onCancel) === null || _d === void 0 || _d.call(_c, lastValue);
        };
        _this.toggleEditing = function() {
            var _a, _b;
            if (_this.state.isEditing) {
                var value = _this.state.value;
                _this.setState({
                    isEditing: false,
                    lastValue: value
                });
                (_b = (_a = _this.props).onConfirm) === null || _b === void 0 || _b.call(_a, value);
            } else if (!_this.props.disabled) _this.setState({
                isEditing: true
            });
        };
        _this.handleFocus = function() {
            var _a = _this.props, alwaysRenderInput = _a.alwaysRenderInput, disabled = _a.disabled, selectAllOnFocus = _a.selectAllOnFocus;
            if (!disabled) _this.setState({
                isEditing: true
            });
            if (alwaysRenderInput && selectAllOnFocus && _this.inputElement != null) {
                var length_2 = _this.inputElement.value.length;
                _this.inputElement.setSelectionRange(0, length_2);
            }
        };
        _this.handleTextChange = function(event) {
            var _a, _b;
            var value = event.target.value;
            // state value should be updated only when uncontrolled
            if (_this.props.value == null) _this.setState({
                value: value
            });
            (_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, value);
        };
        _this.handleKeyEvent = function(event) {
            var altKey = event.altKey, ctrlKey = event.ctrlKey, metaKey = event.metaKey, shiftKey = event.shiftKey;
            if (event.key === "Escape") {
                _this.cancelEditing();
                return;
            }
            var hasModifierKey = altKey || ctrlKey || metaKey || shiftKey;
            if (event.key === "Enter") {
                // prevent browsers (Edge?) from full screening with alt + enter
                // shift + enter adds a newline by default
                if (altKey || shiftKey) event.preventDefault();
                if (_this.props.confirmOnEnterKey && _this.props.multiline) {
                    if (event.target != null && hasModifierKey) {
                        $d707c114e16c4856$var$insertAtCaret(event.target, "\n");
                        _this.handleTextChange(event);
                    } else _this.toggleEditing();
                } else if (!_this.props.multiline || hasModifierKey) _this.toggleEditing();
            }
        };
        var value = props.value == null ? props.defaultValue : props.value;
        _this.state = {
            inputHeight: 0,
            inputWidth: 0,
            isEditing: props.isEditing === true && props.disabled === false,
            lastValue: value,
            value: value
        };
        return _this;
    }
    EditableText.prototype.render = function() {
        var _a;
        var _b;
        var _c = this.props, alwaysRenderInput = _c.alwaysRenderInput, disabled = _c.disabled, elementRef = _c.elementRef, multiline = _c.multiline, contentId = _c.contentId;
        var value = (_b = this.props.value) !== null && _b !== void 0 ? _b : this.state.value;
        var hasValue = value != null && value !== "";
        var classes = (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $auzpd).EDITABLE_TEXT, (0, $auzpd).intentClass(this.props.intent), (_a = {}, _a[(0, $auzpd).DISABLED] = disabled, _a[(0, $auzpd).EDITABLE_TEXT_EDITING] = this.state.isEditing, _a[(0, $auzpd).EDITABLE_TEXT_PLACEHOLDER] = !hasValue, _a[(0, $auzpd).MULTILINE] = multiline, _a), this.props.className);
        var contentStyle;
        if (multiline) // set height only in multiline mode when not editing
        // otherwise we're measuring this element to determine appropriate height of text
        contentStyle = {
            height: !this.state.isEditing ? this.state.inputHeight : undefined
        };
        else // minWidth only applies in single line mode (multiline == width 100%)
        contentStyle = {
            height: this.state.inputHeight,
            lineHeight: this.state.inputHeight != null ? "".concat(this.state.inputHeight, "px") : undefined,
            minWidth: this.props.minWidth
        };
        // If we are always rendering an input, then NEVER make the container div focusable.
        // Otherwise, make container div focusable when not editing, so it can still be tabbed
        // to focus (when the input is rendered, it is itself focusable so container div doesn't need to be)
        var tabIndex = alwaysRenderInput || this.state.isEditing || disabled ? undefined : 0;
        // we need the contents to be rendered while editing so that we can measure their height
        // and size the container element responsively
        var shouldHideContents = alwaysRenderInput && !this.state.isEditing;
        var spanProps = contentId != null ? {
            id: contentId
        } : {};
        return $8NFma.createElement("div", {
            className: classes,
            onFocus: this.handleFocus,
            tabIndex: tabIndex,
            ref: elementRef
        }, alwaysRenderInput || this.state.isEditing ? this.renderInput(value) : undefined, shouldHideContents ? undefined : $8NFma.createElement("span", (0, $gztBd.__assign)({}, spanProps, {
            className: (0, $auzpd).EDITABLE_TEXT_CONTENT,
            ref: this.refHandlers.content,
            style: contentStyle
        }), hasValue ? value : this.props.placeholder));
    };
    EditableText.prototype.componentDidMount = function() {
        this.updateInputDimensions();
    };
    EditableText.prototype.componentDidUpdate = function(prevProps, prevState) {
        var _a, _b;
        var newState = {};
        // allow setting the value to undefined/null in controlled mode
        if (this.props.value !== prevProps.value && (prevProps.value != null || this.props.value != null)) newState.value = this.props.value;
        if (this.props.isEditing != null && this.props.isEditing !== prevProps.isEditing) newState.isEditing = this.props.isEditing;
        if (this.props.disabled || this.props.disabled == null && prevProps.disabled) newState.isEditing = false;
        this.setState(newState);
        if (this.state.isEditing && !prevState.isEditing) (_b = (_a = this.props).onEdit) === null || _b === void 0 || _b.call(_a, this.state.value);
        // updateInputDimensions is an expensive method. Call it only when the props
        // it depends on change
        if (this.state.value !== prevState.value || this.props.alwaysRenderInput !== prevProps.alwaysRenderInput || this.props.maxLines !== prevProps.maxLines || this.props.minLines !== prevProps.minLines || this.props.minWidth !== prevProps.minWidth || this.props.multiline !== prevProps.multiline || this.props.placeholder !== prevProps.placeholder) this.updateInputDimensions();
    };
    EditableText.prototype.renderInput = function(value) {
        var _a = this.props, disabled = _a.disabled, maxLength = _a.maxLength, multiline = _a.multiline, type = _a.type, placeholder = _a.placeholder;
        var props = {
            className: (0, $auzpd).EDITABLE_TEXT_INPUT,
            disabled: disabled,
            maxLength: maxLength,
            onBlur: this.toggleEditing,
            onChange: this.handleTextChange,
            onKeyDown: this.handleKeyEvent,
            placeholder: placeholder,
            value: value
        };
        var _b = this.state, inputHeight = _b.inputHeight, inputWidth = _b.inputWidth;
        if (inputHeight !== 0 && inputWidth !== 0) props.style = {
            height: inputHeight,
            lineHeight: !multiline && inputHeight != null ? "".concat(inputHeight, "px") : undefined,
            width: multiline ? "100%" : inputWidth
        };
        return multiline ? $8NFma.createElement("textarea", (0, $gztBd.__assign)({
            ref: this.refHandlers.input
        }, props)) : $8NFma.createElement("input", (0, $gztBd.__assign)({
            ref: this.refHandlers.input,
            type: type
        }, props));
    };
    EditableText.prototype.updateInputDimensions = function() {
        if (this.valueElement != null) {
            var _a = this.props, maxLines = _a.maxLines, minLines = _a.minLines, minWidth = _a.minWidth, multiline = _a.multiline;
            var _b = this.valueElement, parentElement_1 = _b.parentElement, textContent = _b.textContent;
            var _c = this.valueElement, scrollHeight_1 = _c.scrollHeight, scrollWidth = _c.scrollWidth;
            var lineHeight = $d707c114e16c4856$var$getLineHeight(this.valueElement);
            // add one line to computed <span> height if text ends in newline
            // because <span> collapses that trailing whitespace but <textarea> shows it
            if (multiline && this.state.isEditing && /\n$/.test(textContent !== null && textContent !== void 0 ? textContent : "")) scrollHeight_1 += lineHeight;
            if (lineHeight > 0) // line height could be 0 if the isNaN block from getLineHeight kicks in
            scrollHeight_1 = (0, $h8UCV.clamp)(scrollHeight_1, minLines * lineHeight, maxLines * lineHeight);
            // Chrome's input caret height misaligns text so the line-height must be larger than font-size.
            // The computed scrollHeight must also account for a larger inherited line-height from the parent.
            scrollHeight_1 = Math.max(scrollHeight_1, $d707c114e16c4856$var$getFontSize(this.valueElement) + 1, $d707c114e16c4856$var$getLineHeight(parentElement_1));
            // Need to add a small buffer so text does not shift prior to resizing, causing an infinite loop.
            scrollWidth += $d707c114e16c4856$var$BUFFER_WIDTH_DEFAULT;
            this.setState({
                inputHeight: scrollHeight_1,
                inputWidth: Math.max(scrollWidth, minWidth)
            });
            // synchronizes the ::before pseudo-element's height while editing for Chrome 53
            if (multiline && this.state.isEditing) this.setTimeout(function() {
                return parentElement_1.style.height = "".concat(scrollHeight_1, "px");
            });
        }
    };
    EditableText.displayName = "".concat((0, $hffzE.DISPLAYNAME_PREFIX), ".EditableText");
    EditableText.defaultProps = {
        alwaysRenderInput: false,
        confirmOnEnterKey: false,
        defaultValue: "",
        disabled: false,
        maxLines: Infinity,
        minLines: 1,
        minWidth: 80,
        multiline: false,
        placeholder: "Click to Edit",
        type: "text"
    };
    return EditableText;
}((0, $4Jy2D.AbstractPureComponent));
function $d707c114e16c4856$var$getFontSize(element) {
    var fontSize = getComputedStyle(element).fontSize;
    return fontSize === "" ? 0 : parseInt(fontSize.slice(0, -2), 10);
}
function $d707c114e16c4856$var$getLineHeight(element) {
    // getComputedStyle() => 18.0001px => 18
    var lineHeight = parseInt(getComputedStyle(element).lineHeight.slice(0, -2), 10);
    // this check will be true if line-height is a keyword like "normal"
    if (isNaN(lineHeight)) {
        // @see http://stackoverflow.com/a/18430767/6342931
        var line = document.createElement("span");
        line.innerHTML = "<br>";
        element.appendChild(line);
        var singleLineHeight = element.offsetHeight;
        line.innerHTML = "<br><br>";
        var doubleLineHeight = element.offsetHeight;
        element.removeChild(line);
        // this can return 0 in edge cases
        lineHeight = doubleLineHeight - singleLineHeight;
    }
    return lineHeight;
}
function $d707c114e16c4856$var$insertAtCaret(el, text) {
    var selectionEnd = el.selectionEnd, selectionStart = el.selectionStart, value = el.value;
    if (selectionStart >= 0) {
        var before_1 = value.substring(0, selectionStart);
        var after_1 = value.substring(selectionEnd, value.length);
        var len = text.length;
        el.value = "".concat(before_1).concat(text).concat(after_1);
        el.selectionStart = selectionStart + len;
        el.selectionEnd = selectionStart + len;
    }
}
function $d707c114e16c4856$var$inputSupportsSelection(input) {
    switch(input.type){
        // HTMLTextAreaElement
        case "textarea":
            return true;
        // HTMLInputElement
        // see https://html.spec.whatwg.org/multipage/input.html#do-not-apply
        case "text":
        case "search":
        case "tel":
        case "url":
        case "password":
            return true;
        default:
            return false;
    }
}

});

parcelRegister("gHouc", function(module, exports) {

var $92Ocn = parcelRequire("92Ocn");

var $gPDkX = parcelRequire("gPDkX");

var $8NFma = parcelRequire("8NFma");

var $lykbf = parcelRequire("lykbf");
function $c283a7eca7a97e89$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $c283a7eca7a97e89$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $c283a7eca7a97e89$var$$parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || dest.hasOwnProperty(key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
$c283a7eca7a97e89$var$$parcel$export(module.exports, "Sortable", ()=>$882b6d93070905b3$re_export$Sortable);
$c283a7eca7a97e89$var$$parcel$export(module.exports, "Direction", ()=>$882b6d93070905b3$re_export$Direction);
$c283a7eca7a97e89$var$$parcel$export(module.exports, "DOMRect", ()=>$882b6d93070905b3$re_export$DOMRect);
$c283a7eca7a97e89$var$$parcel$export(module.exports, "GroupOptions", ()=>$882b6d93070905b3$re_export$GroupOptions);
$c283a7eca7a97e89$var$$parcel$export(module.exports, "MoveEvent", ()=>$882b6d93070905b3$re_export$MoveEvent);
$c283a7eca7a97e89$var$$parcel$export(module.exports, "Options", ()=>$882b6d93070905b3$re_export$Options);
$c283a7eca7a97e89$var$$parcel$export(module.exports, "PullResult", ()=>$882b6d93070905b3$re_export$PullResult);
$c283a7eca7a97e89$var$$parcel$export(module.exports, "PutResult", ()=>$882b6d93070905b3$re_export$PutResult);
$c283a7eca7a97e89$var$$parcel$export(module.exports, "SortableEvent", ()=>$882b6d93070905b3$re_export$SortableEvent);
$c283a7eca7a97e89$var$$parcel$export(module.exports, "SortableOptions", ()=>$882b6d93070905b3$re_export$SortableOptions);
$c283a7eca7a97e89$var$$parcel$export(module.exports, "Utils", ()=>$882b6d93070905b3$re_export$Utils);
$c283a7eca7a97e89$var$$parcel$export(module.exports, "ReactSortable", ()=>$c283a7eca7a97e89$var$$7fe8e3ea572bda7a$export$11bbed9ee0012c13);
function $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$1d0aa160432dfea5(node) {
    if (node.parentElement !== null) node.parentElement.removeChild(node);
}
function $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$6d240faa51aa562f(parent, newChild, index) {
    const refChild = parent.children[index] || null;
    parent.insertBefore(newChild, refChild);
}
function $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$d7d742816c28cf91(customs) {
    $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$77f49a256021c8de(customs);
    $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$a6177d5829f70ebc(customs);
}
function $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$77f49a256021c8de(customs) {
    customs.forEach((curr)=>$c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$1d0aa160432dfea5(curr.element));
}
function $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$a6177d5829f70ebc(customs) {
    customs.forEach((curr)=>{
        $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$6d240faa51aa562f(curr.parentElement, curr.element, curr.oldIndex);
    });
}
function $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$4655efe700f887a(evt, list) {
    const mode = $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$1fc0f6205829e19c(evt);
    const parentElement = {
        parentElement: evt.from
    };
    let custom = [];
    switch(mode){
        case "normal":
            /* eslint-disable */ const item = {
                element: evt.item,
                newIndex: evt.newIndex,
                oldIndex: evt.oldIndex,
                parentElement: evt.from
            };
            custom = [
                item
            ];
            break;
        case "swap":
            const drag = {
                element: evt.item,
                oldIndex: evt.oldIndex,
                newIndex: evt.newIndex,
                ...parentElement
            };
            const swap = {
                element: evt.swapItem,
                oldIndex: evt.newIndex,
                newIndex: evt.oldIndex,
                ...parentElement
            };
            custom = [
                drag,
                swap
            ];
            break;
        case "multidrag":
            custom = evt.oldIndicies.map((curr, index)=>({
                    element: curr.multiDragElement,
                    oldIndex: curr.index,
                    newIndex: evt.newIndicies[index].index,
                    ...parentElement
                }));
            break;
    }
    /* eslint-enable */ const customs = $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$bc06a3af7dc65f53(custom, list);
    return customs;
}
function $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$c25cf8080bd305ec(normalized, list) {
    const a = $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$be2da95e6167b0bd(normalized, list);
    const b = $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$eca851ee65ae17e4(normalized, a);
    return b;
}
function $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$be2da95e6167b0bd(normalized, list) {
    const newList = [
        ...list
    ];
    normalized.concat().reverse().forEach((curr)=>newList.splice(curr.oldIndex, 1));
    return newList;
}
function $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$eca851ee65ae17e4(normalized, list, evt, clone) {
    const newList = [
        ...list
    ];
    normalized.forEach((curr)=>{
        const newItem = clone && evt && clone(curr.item, evt);
        newList.splice(curr.newIndex, 0, newItem || curr.item);
    });
    return newList;
}
function $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$1fc0f6205829e19c(evt) {
    if (evt.oldIndicies && evt.oldIndicies.length > 0) return "multidrag";
    if (evt.swapItem) return "swap";
    return "normal";
}
function $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$bc06a3af7dc65f53(inputs, list) {
    const normalized = inputs.map((curr)=>({
            ...curr,
            item: list[curr.oldIndex]
        })).sort((a, b)=>a.oldIndex - b.oldIndex);
    return normalized;
}
function $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$7553c81e62e31b7e(props) {
    /* eslint-disable */ const { list: list, setList: setList, children: children, tag: tag, style: style, className: className, clone: clone, onAdd: onAdd, onChange: onChange, onChoose: onChoose, onClone: onClone, onEnd: onEnd, onFilter: onFilter, onRemove: onRemove, onSort: onSort, onStart: onStart, onUnchoose: onUnchoose, onUpdate: onUpdate, onMove: onMove, onSpill: onSpill, onSelect: onSelect, onDeselect: onDeselect, ...options } = props;
    /* eslint-enable */ return options;
}
/** Holds a global reference for which react element is being dragged */ // @todo - use context to manage this. How does one use 2 different providers?
const $c283a7eca7a97e89$var$$7fe8e3ea572bda7a$var$store = {
    dragging: null
};
class $c283a7eca7a97e89$var$$7fe8e3ea572bda7a$export$11bbed9ee0012c13 extends $8NFma.Component {
    /* eslint-disable-next-line */ static defaultProps = {
        clone: (item)=>item
    };
    constructor(props){
        super(props);
        // @todo forward ref this component
        this.ref = /*#__PURE__*/ (0, $8NFma.createRef)();
        // make all state false because we can't change sortable unless a mouse gesture is made.
        const newList = [
            ...props.list
        ].map((item)=>Object.assign(item, {
                chosen: false,
                selected: false
            }));
        props.setList(newList, this.sortable, $c283a7eca7a97e89$var$$7fe8e3ea572bda7a$var$store);
        $c283a7eca7a97e89$var$$parcel$interopDefault($lykbf)(!props.plugins, `
Plugins prop is no longer supported.
Instead, mount it with "Sortable.mount(new MultiDrag())"
Please read the updated README.md at https://github.com/SortableJS/react-sortablejs.
      `);
    }
    componentDidMount() {
        if (this.ref.current === null) return;
        const newOptions = this.makeOptions();
        $c283a7eca7a97e89$var$$parcel$interopDefault($92Ocn).create(this.ref.current, newOptions);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.disabled !== this.props.disabled && this.sortable) this.sortable.option("disabled", this.props.disabled);
    }
    render() {
        const { tag: tag, style: style, className: className, id: id } = this.props;
        const classicProps = {
            style: style,
            className: className,
            id: id
        };
        // if no tag, default to a `div` element.
        const newTag = !tag || tag === null ? "div" : tag;
        return /*#__PURE__*/ (0, $8NFma.createElement)(newTag, {
            // @todo - find a way (perhaps with the callback) to allow AntD components to work
            ref: this.ref,
            ...classicProps
        }, this.getChildren());
    }
    getChildren() {
        const { children: children, dataIdAttr: dataIdAttr, selectedClass: selectedClass = "sortable-selected", chosenClass: chosenClass = "sortable-chosen", dragClass: /* eslint-disable */ dragClass = "sortable-drag", fallbackClass: fallbackClass = "sortable-falback", ghostClass: ghostClass = "sortable-ghost", swapClass: swapClass = "sortable-swap-highlight", filter: /* eslint-enable */ filter = "sortable-filter", list: list } = this.props;
        // if no children, don't do anything.
        if (!children || children == null) return null;
        const dataid = dataIdAttr || "data-id";
        /* eslint-disable-next-line */ return (0, $8NFma.Children).map(children, (child, index)=>{
            if (child === undefined) return undefined;
            const item = list[index] || {};
            const { className: prevClassName } = child.props;
            // @todo - handle the function if avalable. I don't think anyone will be doing this soon.
            const filtered = typeof filter === "string" && {
                [filter.replace(".", "")]: !!item.filtered
            };
            const className = $c283a7eca7a97e89$var$$parcel$interopDefault($gPDkX)(prevClassName, {
                [selectedClass]: item.selected,
                [chosenClass]: item.chosen,
                ...filtered
            });
            return /*#__PURE__*/ (0, $8NFma.cloneElement)(child, {
                [dataid]: child.key,
                className: className
            });
        });
    }
    /** Appends the `sortable` property to this component */ get sortable() {
        const el = this.ref.current;
        if (el === null) return null;
        const key = Object.keys(el).find((k)=>k.includes("Sortable"));
        if (!key) return null;
        //@ts-expect-error: fix me.
        return el[key];
    }
    /** Converts all the props from `ReactSortable` into the `options` object that `Sortable.create(el, [options])` can use. */ makeOptions() {
        const DOMHandlers = [
            "onAdd",
            "onChoose",
            "onDeselect",
            "onEnd",
            "onRemove",
            "onSelect",
            "onSpill",
            "onStart",
            "onUnchoose",
            "onUpdate"
        ];
        const NonDOMHandlers = [
            "onChange",
            "onClone",
            "onFilter",
            "onSort"
        ];
        const newOptions = $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$7553c81e62e31b7e(this.props);
        DOMHandlers.forEach((name)=>newOptions[name] = this.prepareOnHandlerPropAndDOM(name));
        NonDOMHandlers.forEach((name)=>newOptions[name] = this.prepareOnHandlerProp(name));
        /** onMove has 2 arguments and needs to be handled seperately. */ const onMove1 = (evt, originalEvt)=>{
            const { onMove: onMove } = this.props;
            const defaultValue = evt.willInsertAfter || -1;
            if (!onMove) return defaultValue;
            const result = onMove(evt, originalEvt, this.sortable, $c283a7eca7a97e89$var$$7fe8e3ea572bda7a$var$store);
            if (typeof result === "undefined") return false;
            return result;
        };
        return {
            ...newOptions,
            onMove: onMove1
        };
    }
    /** Prepares a method that will be used in the sortable options to call an `on[Handler]` prop & an `on[Handler]` ReactSortable method.  */ prepareOnHandlerPropAndDOM(evtName) {
        return (evt)=>{
            // call the component prop
            this.callOnHandlerProp(evt, evtName);
            // calls state change
            //@ts-expect-error: until @types multidrag item is in
            this[evtName](evt);
        };
    }
    /** Prepares a method that will be used in the sortable options to call an `on[Handler]` prop */ prepareOnHandlerProp(evtName) {
        return (evt)=>{
            // call the component prop
            this.callOnHandlerProp(evt, evtName);
        };
    }
    /** Calls the `props.on[Handler]` function */ callOnHandlerProp(evt, evtName) {
        const propEvent = this.props[evtName];
        if (propEvent) propEvent(evt, this.sortable, $c283a7eca7a97e89$var$$7fe8e3ea572bda7a$var$store);
    }
    // SORTABLE DOM HANDLING
    onAdd(evt) {
        const { list: list, setList: setList, clone: clone } = this.props;
        /* eslint-disable-next-line */ const otherList = [
            ...$c283a7eca7a97e89$var$$7fe8e3ea572bda7a$var$store.dragging.props.list
        ];
        const customs = $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$4655efe700f887a(evt, otherList);
        $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$77f49a256021c8de(customs);
        const newList = $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$eca851ee65ae17e4(customs, list, evt, clone).map((item)=>Object.assign(item, {
                selected: false
            }));
        setList(newList, this.sortable, $c283a7eca7a97e89$var$$7fe8e3ea572bda7a$var$store);
    }
    onRemove(evt) {
        const { list: list, setList: setList } = this.props;
        const mode = $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$1fc0f6205829e19c(evt);
        const customs = $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$4655efe700f887a(evt, list);
        $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$a6177d5829f70ebc(customs);
        let newList = [
            ...list
        ];
        // remove state if not in clone mode. otherwise, keep.
        if (evt.pullMode !== "clone") newList = $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$be2da95e6167b0bd(customs, newList);
        else {
            // switch used to get the clone
            let customClones = customs;
            switch(mode){
                case "multidrag":
                    customClones = customs.map((item, index)=>({
                            ...item,
                            element: evt.clones[index]
                        }));
                    break;
                case "normal":
                    customClones = customs.map((item)=>({
                            ...item,
                            element: evt.clone
                        }));
                    break;
                case "swap":
                default:
                    $c283a7eca7a97e89$var$$parcel$interopDefault($lykbf)(true, `mode "${mode}" cannot clone. Please remove "props.clone" from <ReactSortable/> when using the "${mode}" plugin`);
            }
            $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$77f49a256021c8de(customClones);
            // replace selected items with cloned items
            customs.forEach((curr)=>{
                const index = curr.oldIndex;
                /* eslint-disable-next-line */ const newItem = this.props.clone(curr.item, evt);
                newList.splice(index, 1, newItem);
            });
        }
        // remove item.selected from list
        newList = newList.map((item)=>Object.assign(item, {
                selected: false
            }));
        setList(newList, this.sortable, $c283a7eca7a97e89$var$$7fe8e3ea572bda7a$var$store);
    }
    onUpdate(evt) {
        const { list: list, setList: setList } = this.props;
        const customs = $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$4655efe700f887a(evt, list);
        $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$77f49a256021c8de(customs);
        $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$a6177d5829f70ebc(customs);
        const newList = $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$c25cf8080bd305ec(customs, list);
        return setList(newList, this.sortable, $c283a7eca7a97e89$var$$7fe8e3ea572bda7a$var$store);
    }
    onStart() {
        $c283a7eca7a97e89$var$$7fe8e3ea572bda7a$var$store.dragging = this;
    }
    onEnd() {
        $c283a7eca7a97e89$var$$7fe8e3ea572bda7a$var$store.dragging = null;
    }
    onChoose(evt) {
        const { list: list, setList: setList } = this.props;
        const newList = list.map((item, index)=>{
            let newItem = item;
            if (index === evt.oldIndex) newItem = Object.assign(item, {
                chosen: true
            });
            return newItem;
        });
        setList(newList, this.sortable, $c283a7eca7a97e89$var$$7fe8e3ea572bda7a$var$store);
    }
    onUnchoose(evt) {
        const { list: list, setList: setList } = this.props;
        const newList = list.map((item, index)=>{
            let newItem = item;
            if (index === evt.oldIndex) newItem = Object.assign(newItem, {
                chosen: false
            });
            return newItem;
        });
        setList(newList, this.sortable, $c283a7eca7a97e89$var$$7fe8e3ea572bda7a$var$store);
    }
    onSpill(evt) {
        const { removeOnSpill: removeOnSpill, revertOnSpill: revertOnSpill } = this.props;
        if (removeOnSpill && !revertOnSpill) $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$1d0aa160432dfea5(evt.item);
    }
    onSelect(evt) {
        const { list: list, setList: setList } = this.props;
        const newList = list.map((item)=>Object.assign(item, {
                selected: false
            }));
        evt.newIndicies.forEach((curr)=>{
            const index = curr.index;
            if (index === -1) {
                console.log(`"${evt.type}" had indice of "${curr.index}", which is probably -1 and doesn't usually happen here.`);
                console.log(evt);
                return;
            }
            newList[index].selected = true;
        });
        setList(newList, this.sortable, $c283a7eca7a97e89$var$$7fe8e3ea572bda7a$var$store);
    }
    onDeselect(evt) {
        const { list: list, setList: setList } = this.props;
        const newList = list.map((item)=>Object.assign(item, {
                selected: false
            }));
        evt.newIndicies.forEach((curr)=>{
            const index = curr.index;
            if (index === -1) return;
            newList[index].selected = true;
        });
        setList(newList, this.sortable, $c283a7eca7a97e89$var$$7fe8e3ea572bda7a$var$store);
    }
}
var $c283a7eca7a97e89$var$$faefaad95e5fcca0$exports = {};
$c283a7eca7a97e89$var$$parcel$exportWildcard(module.exports, $c283a7eca7a97e89$var$$faefaad95e5fcca0$exports);

});
parcelRegister("92Ocn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "Sortable", () => $695b3d6025d5e530$export$31b3ca70d8f57423);
$parcel$export(module.exports, "Swap", () => $695b3d6025d5e530$export$bdb5f0a1b77546f4);
$parcel$export(module.exports, "MultiDrag", () => $695b3d6025d5e530$export$18e5d2a5d1df842d);
$parcel$export(module.exports, "default", () => $695b3d6025d5e530$export$2e2bcd8739ae039);
/**!
 * Sortable 1.15.2
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */ function $695b3d6025d5e530$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $695b3d6025d5e530$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $695b3d6025d5e530$var$ownKeys(Object(source), true).forEach(function(key) {
            $695b3d6025d5e530$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $695b3d6025d5e530$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $695b3d6025d5e530$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $695b3d6025d5e530$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $695b3d6025d5e530$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $695b3d6025d5e530$var$_typeof(obj);
}
function $695b3d6025d5e530$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $695b3d6025d5e530$var$_extends() {
    $695b3d6025d5e530$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $695b3d6025d5e530$var$_extends.apply(this, arguments);
}
function $695b3d6025d5e530$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $695b3d6025d5e530$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $695b3d6025d5e530$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $695b3d6025d5e530$var$_toConsumableArray(arr) {
    return $695b3d6025d5e530$var$_arrayWithoutHoles(arr) || $695b3d6025d5e530$var$_iterableToArray(arr) || $695b3d6025d5e530$var$_unsupportedIterableToArray(arr) || $695b3d6025d5e530$var$_nonIterableSpread();
}
function $695b3d6025d5e530$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $695b3d6025d5e530$var$_arrayLikeToArray(arr);
}
function $695b3d6025d5e530$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $695b3d6025d5e530$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $695b3d6025d5e530$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $695b3d6025d5e530$var$_arrayLikeToArray(o, minLen);
}
function $695b3d6025d5e530$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $695b3d6025d5e530$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $695b3d6025d5e530$var$version = "1.15.2";
function $695b3d6025d5e530$var$userAgent(pattern) {
    if (typeof window !== "undefined" && window.navigator) return !!/*@__PURE__*/ navigator.userAgent.match(pattern);
}
var $695b3d6025d5e530$var$IE11OrLess = $695b3d6025d5e530$var$userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var $695b3d6025d5e530$var$Edge = $695b3d6025d5e530$var$userAgent(/Edge/i);
var $695b3d6025d5e530$var$FireFox = $695b3d6025d5e530$var$userAgent(/firefox/i);
var $695b3d6025d5e530$var$Safari = $695b3d6025d5e530$var$userAgent(/safari/i) && !$695b3d6025d5e530$var$userAgent(/chrome/i) && !$695b3d6025d5e530$var$userAgent(/android/i);
var $695b3d6025d5e530$var$IOS = $695b3d6025d5e530$var$userAgent(/iP(ad|od|hone)/i);
var $695b3d6025d5e530$var$ChromeForAndroid = $695b3d6025d5e530$var$userAgent(/chrome/i) && $695b3d6025d5e530$var$userAgent(/android/i);
var $695b3d6025d5e530$var$captureMode = {
    capture: false,
    passive: false
};
function $695b3d6025d5e530$var$on(el, event, fn) {
    el.addEventListener(event, fn, !$695b3d6025d5e530$var$IE11OrLess && $695b3d6025d5e530$var$captureMode);
}
function $695b3d6025d5e530$var$off(el, event, fn) {
    el.removeEventListener(event, fn, !$695b3d6025d5e530$var$IE11OrLess && $695b3d6025d5e530$var$captureMode);
}
function $695b3d6025d5e530$var$matches(/**HTMLElement*/ el, /**String*/ selector) {
    if (!selector) return;
    selector[0] === ">" && (selector = selector.substring(1));
    if (el) try {
        if (el.matches) return el.matches(selector);
        else if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    } catch (_) {
        return false;
    }
    return false;
}
function $695b3d6025d5e530$var$getParentOrHost(el) {
    return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}
function $695b3d6025d5e530$var$closest(/**HTMLElement*/ el, /**String*/ selector, /**HTMLElement*/ ctx, includeCTX) {
    if (el) {
        ctx = ctx || document;
        do {
            if (selector != null && (selector[0] === ">" ? el.parentNode === ctx && $695b3d6025d5e530$var$matches(el, selector) : $695b3d6025d5e530$var$matches(el, selector)) || includeCTX && el === ctx) return el;
            if (el === ctx) break;
        /* jshint boss:true */ }while (el = $695b3d6025d5e530$var$getParentOrHost(el));
    }
    return null;
}
var $695b3d6025d5e530$var$R_SPACE = /\s+/g;
function $695b3d6025d5e530$var$toggleClass(el, name, state) {
    if (el && name) {
        if (el.classList) el.classList[state ? "add" : "remove"](name);
        else {
            var className = (" " + el.className + " ").replace($695b3d6025d5e530$var$R_SPACE, " ").replace(" " + name + " ", " ");
            el.className = (className + (state ? " " + name : "")).replace($695b3d6025d5e530$var$R_SPACE, " ");
        }
    }
}
function $695b3d6025d5e530$var$css(el, prop, val) {
    var style = el && el.style;
    if (style) {
        if (val === void 0) {
            if (document.defaultView && document.defaultView.getComputedStyle) val = document.defaultView.getComputedStyle(el, "");
            else if (el.currentStyle) val = el.currentStyle;
            return prop === void 0 ? val : val[prop];
        } else {
            if (!(prop in style) && prop.indexOf("webkit") === -1) prop = "-webkit-" + prop;
            style[prop] = val + (typeof val === "string" ? "" : "px");
        }
    }
}
function $695b3d6025d5e530$var$matrix(el, selfOnly) {
    var appliedTransforms = "";
    if (typeof el === "string") appliedTransforms = el;
    else do {
        var transform = $695b3d6025d5e530$var$css(el, "transform");
        if (transform && transform !== "none") appliedTransforms = transform + " " + appliedTransforms;
    /* jshint boss:true */ }while (!selfOnly && (el = el.parentNode));
    var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
    /*jshint -W056 */ return matrixFn && new matrixFn(appliedTransforms);
}
function $695b3d6025d5e530$var$find(ctx, tagName, iterator) {
    if (ctx) {
        var list = ctx.getElementsByTagName(tagName), i = 0, n = list.length;
        if (iterator) for(; i < n; i++)iterator(list[i], i);
        return list;
    }
    return [];
}
function $695b3d6025d5e530$var$getWindowScrollingElement() {
    var scrollingElement = document.scrollingElement;
    if (scrollingElement) return scrollingElement;
    else return document.documentElement;
}
/**
 * Returns the "bounding client rect" of given element
 * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
 * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
 * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
 * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
 * @param  {[HTMLElement]} container              The parent the element will be placed in
 * @return {Object}                               The boundingClientRect of el, with specified adjustments
 */ function $695b3d6025d5e530$var$getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
    if (!el.getBoundingClientRect && el !== window) return;
    var elRect, top, left, bottom, right, height, width;
    if (el !== window && el.parentNode && el !== $695b3d6025d5e530$var$getWindowScrollingElement()) {
        elRect = el.getBoundingClientRect();
        top = elRect.top;
        left = elRect.left;
        bottom = elRect.bottom;
        right = elRect.right;
        height = elRect.height;
        width = elRect.width;
    } else {
        top = 0;
        left = 0;
        bottom = window.innerHeight;
        right = window.innerWidth;
        height = window.innerHeight;
        width = window.innerWidth;
    }
    if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
        // Adjust for translate()
        container = container || el.parentNode;
        // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
        // Not needed on <= IE11
        if (!$695b3d6025d5e530$var$IE11OrLess) {
            do if (container && container.getBoundingClientRect && ($695b3d6025d5e530$var$css(container, "transform") !== "none" || relativeToNonStaticParent && $695b3d6025d5e530$var$css(container, "position") !== "static")) {
                var containerRect = container.getBoundingClientRect();
                // Set relative to edges of padding box of container
                top -= containerRect.top + parseInt($695b3d6025d5e530$var$css(container, "border-top-width"));
                left -= containerRect.left + parseInt($695b3d6025d5e530$var$css(container, "border-left-width"));
                bottom = top + elRect.height;
                right = left + elRect.width;
                break;
            }
            while (container = container.parentNode);
        }
    }
    if (undoScale && el !== window) {
        // Adjust for scale()
        var elMatrix = $695b3d6025d5e530$var$matrix(container || el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d;
        if (elMatrix) {
            top /= scaleY;
            left /= scaleX;
            width /= scaleX;
            height /= scaleY;
            bottom = top + height;
            right = left + width;
        }
    }
    return {
        top: top,
        left: left,
        bottom: bottom,
        right: right,
        width: width,
        height: height
    };
}
/**
 * Checks if a side of an element is scrolled past a side of its parents
 * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
 * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
 * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
 * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
 */ function $695b3d6025d5e530$var$isScrolledPast(el, elSide, parentSide) {
    var parent = $695b3d6025d5e530$var$getParentAutoScrollElement(el, true), elSideVal = $695b3d6025d5e530$var$getRect(el)[elSide];
    /* jshint boss:true */ while(parent){
        var parentSideVal = $695b3d6025d5e530$var$getRect(parent)[parentSide], visible = void 0;
        if (parentSide === "top" || parentSide === "left") visible = elSideVal >= parentSideVal;
        else visible = elSideVal <= parentSideVal;
        if (!visible) return parent;
        if (parent === $695b3d6025d5e530$var$getWindowScrollingElement()) break;
        parent = $695b3d6025d5e530$var$getParentAutoScrollElement(parent, false);
    }
    return false;
}
/**
 * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
 * and non-draggable elements
 * @param  {HTMLElement} el       The parent element
 * @param  {Number} childNum      The index of the child
 * @param  {Object} options       Parent Sortable's options
 * @return {HTMLElement}          The child at index childNum, or null if not found
 */ function $695b3d6025d5e530$var$getChild(el, childNum, options, includeDragEl) {
    var currentChild = 0, i = 0, children = el.children;
    while(i < children.length){
        if (children[i].style.display !== "none" && children[i] !== $695b3d6025d5e530$export$31b3ca70d8f57423.ghost && (includeDragEl || children[i] !== $695b3d6025d5e530$export$31b3ca70d8f57423.dragged) && $695b3d6025d5e530$var$closest(children[i], options.draggable, el, false)) {
            if (currentChild === childNum) return children[i];
            currentChild++;
        }
        i++;
    }
    return null;
}
/**
 * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
 * @param  {HTMLElement} el       Parent element
 * @param  {selector} selector    Any other elements that should be ignored
 * @return {HTMLElement}          The last child, ignoring ghostEl
 */ function $695b3d6025d5e530$var$lastChild(el, selector) {
    var last = el.lastElementChild;
    while(last && (last === $695b3d6025d5e530$export$31b3ca70d8f57423.ghost || $695b3d6025d5e530$var$css(last, "display") === "none" || selector && !$695b3d6025d5e530$var$matches(last, selector)))last = last.previousElementSibling;
    return last || null;
}
/**
 * Returns the index of an element within its parent for a selected set of
 * elements
 * @param  {HTMLElement} el
 * @param  {selector} selector
 * @return {number}
 */ function $695b3d6025d5e530$var$index(el, selector) {
    var index = 0;
    if (!el || !el.parentNode) return -1;
    /* jshint boss:true */ while(el = el.previousElementSibling)if (el.nodeName.toUpperCase() !== "TEMPLATE" && el !== $695b3d6025d5e530$export$31b3ca70d8f57423.clone && (!selector || $695b3d6025d5e530$var$matches(el, selector))) index++;
    return index;
}
/**
 * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
 * The value is returned in real pixels.
 * @param  {HTMLElement} el
 * @return {Array}             Offsets in the format of [left, top]
 */ function $695b3d6025d5e530$var$getRelativeScrollOffset(el) {
    var offsetLeft = 0, offsetTop = 0, winScroller = $695b3d6025d5e530$var$getWindowScrollingElement();
    if (el) do {
        var elMatrix = $695b3d6025d5e530$var$matrix(el), scaleX = elMatrix.a, scaleY = elMatrix.d;
        offsetLeft += el.scrollLeft * scaleX;
        offsetTop += el.scrollTop * scaleY;
    }while (el !== winScroller && (el = el.parentNode));
    return [
        offsetLeft,
        offsetTop
    ];
}
/**
 * Returns the index of the object within the given array
 * @param  {Array} arr   Array that may or may not hold the object
 * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
 * @return {Number}      The index of the object in the array, or -1
 */ function $695b3d6025d5e530$var$indexOfObject(arr, obj) {
    for(var i in arr){
        if (!arr.hasOwnProperty(i)) continue;
        for(var key in obj){
            if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
        }
    }
    return -1;
}
function $695b3d6025d5e530$var$getParentAutoScrollElement(el, includeSelf) {
    // skip to window
    if (!el || !el.getBoundingClientRect) return $695b3d6025d5e530$var$getWindowScrollingElement();
    var elem = el;
    var gotSelf = false;
    do // we don't need to get elem css if it isn't even overflowing in the first place (performance)
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
        var elemCSS = $695b3d6025d5e530$var$css(elem);
        if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == "auto" || elemCSS.overflowX == "scroll") || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == "auto" || elemCSS.overflowY == "scroll")) {
            if (!elem.getBoundingClientRect || elem === document.body) return $695b3d6025d5e530$var$getWindowScrollingElement();
            if (gotSelf || includeSelf) return elem;
            gotSelf = true;
        }
    }
    while (elem = elem.parentNode);
    return $695b3d6025d5e530$var$getWindowScrollingElement();
}
function $695b3d6025d5e530$var$extend(dst, src) {
    if (dst && src) {
        for(var key in src)if (src.hasOwnProperty(key)) dst[key] = src[key];
    }
    return dst;
}
function $695b3d6025d5e530$var$isRectEqual(rect1, rect2) {
    return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}
var $695b3d6025d5e530$var$_throttleTimeout;
function $695b3d6025d5e530$var$throttle(callback, ms) {
    return function() {
        if (!$695b3d6025d5e530$var$_throttleTimeout) {
            var args = arguments, _this = this;
            if (args.length === 1) callback.call(_this, args[0]);
            else callback.apply(_this, args);
            $695b3d6025d5e530$var$_throttleTimeout = setTimeout(function() {
                $695b3d6025d5e530$var$_throttleTimeout = void 0;
            }, ms);
        }
    };
}
function $695b3d6025d5e530$var$cancelThrottle() {
    clearTimeout($695b3d6025d5e530$var$_throttleTimeout);
    $695b3d6025d5e530$var$_throttleTimeout = void 0;
}
function $695b3d6025d5e530$var$scrollBy(el, x, y) {
    el.scrollLeft += x;
    el.scrollTop += y;
}
function $695b3d6025d5e530$var$clone(el) {
    var Polymer = window.Polymer;
    var $ = window.jQuery || window.Zepto;
    if (Polymer && Polymer.dom) return Polymer.dom(el).cloneNode(true);
    else if ($) return $(el).clone(true)[0];
    else return el.cloneNode(true);
}
function $695b3d6025d5e530$var$setRect(el, rect) {
    $695b3d6025d5e530$var$css(el, "position", "absolute");
    $695b3d6025d5e530$var$css(el, "top", rect.top);
    $695b3d6025d5e530$var$css(el, "left", rect.left);
    $695b3d6025d5e530$var$css(el, "width", rect.width);
    $695b3d6025d5e530$var$css(el, "height", rect.height);
}
function $695b3d6025d5e530$var$unsetRect(el) {
    $695b3d6025d5e530$var$css(el, "position", "");
    $695b3d6025d5e530$var$css(el, "top", "");
    $695b3d6025d5e530$var$css(el, "left", "");
    $695b3d6025d5e530$var$css(el, "width", "");
    $695b3d6025d5e530$var$css(el, "height", "");
}
function $695b3d6025d5e530$var$getChildContainingRectFromElement(container, options, ghostEl) {
    var rect = {};
    Array.from(container.children).forEach(function(child) {
        var _rect$left, _rect$top, _rect$right, _rect$bottom;
        if (!$695b3d6025d5e530$var$closest(child, options.draggable, container, false) || child.animated || child === ghostEl) return;
        var childRect = $695b3d6025d5e530$var$getRect(child);
        rect.left = Math.min((_rect$left = rect.left) !== null && _rect$left !== void 0 ? _rect$left : Infinity, childRect.left);
        rect.top = Math.min((_rect$top = rect.top) !== null && _rect$top !== void 0 ? _rect$top : Infinity, childRect.top);
        rect.right = Math.max((_rect$right = rect.right) !== null && _rect$right !== void 0 ? _rect$right : -Infinity, childRect.right);
        rect.bottom = Math.max((_rect$bottom = rect.bottom) !== null && _rect$bottom !== void 0 ? _rect$bottom : -Infinity, childRect.bottom);
    });
    rect.width = rect.right - rect.left;
    rect.height = rect.bottom - rect.top;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
var $695b3d6025d5e530$var$expando = "Sortable" + new Date().getTime();
function $695b3d6025d5e530$var$AnimationStateManager() {
    var animationStates = [], animationCallbackId;
    return {
        captureAnimationState: function captureAnimationState() {
            animationStates = [];
            if (!this.options.animation) return;
            var children = [].slice.call(this.el.children);
            children.forEach(function(child) {
                if ($695b3d6025d5e530$var$css(child, "display") === "none" || child === $695b3d6025d5e530$export$31b3ca70d8f57423.ghost) return;
                animationStates.push({
                    target: child,
                    rect: $695b3d6025d5e530$var$getRect(child)
                });
                var fromRect = $695b3d6025d5e530$var$_objectSpread2({}, animationStates[animationStates.length - 1].rect);
                // If animating: compensate for current animation
                if (child.thisAnimationDuration) {
                    var childMatrix = $695b3d6025d5e530$var$matrix(child, true);
                    if (childMatrix) {
                        fromRect.top -= childMatrix.f;
                        fromRect.left -= childMatrix.e;
                    }
                }
                child.fromRect = fromRect;
            });
        },
        addAnimationState: function addAnimationState(state) {
            animationStates.push(state);
        },
        removeAnimationState: function removeAnimationState(target) {
            animationStates.splice($695b3d6025d5e530$var$indexOfObject(animationStates, {
                target: target
            }), 1);
        },
        animateAll: function animateAll(callback) {
            var _this = this;
            if (!this.options.animation) {
                clearTimeout(animationCallbackId);
                if (typeof callback === "function") callback();
                return;
            }
            var animating = false, animationTime = 0;
            animationStates.forEach(function(state) {
                var time = 0, target = state.target, fromRect = target.fromRect, toRect = $695b3d6025d5e530$var$getRect(target), prevFromRect = target.prevFromRect, prevToRect = target.prevToRect, animatingRect = state.rect, targetMatrix = $695b3d6025d5e530$var$matrix(target, true);
                if (targetMatrix) {
                    // Compensate for current animation
                    toRect.top -= targetMatrix.f;
                    toRect.left -= targetMatrix.e;
                }
                target.toRect = toRect;
                if (target.thisAnimationDuration) // Could also check if animatingRect is between fromRect and toRect
                {
                    if ($695b3d6025d5e530$var$isRectEqual(prevFromRect, toRect) && !$695b3d6025d5e530$var$isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
                    (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) // If returning to same place as started from animation and on same axis
                    time = $695b3d6025d5e530$var$calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
                }
                // if fromRect != toRect: animate
                if (!$695b3d6025d5e530$var$isRectEqual(toRect, fromRect)) {
                    target.prevFromRect = fromRect;
                    target.prevToRect = toRect;
                    if (!time) time = _this.options.animation;
                    _this.animate(target, animatingRect, toRect, time);
                }
                if (time) {
                    animating = true;
                    animationTime = Math.max(animationTime, time);
                    clearTimeout(target.animationResetTimer);
                    target.animationResetTimer = setTimeout(function() {
                        target.animationTime = 0;
                        target.prevFromRect = null;
                        target.fromRect = null;
                        target.prevToRect = null;
                        target.thisAnimationDuration = null;
                    }, time);
                    target.thisAnimationDuration = time;
                }
            });
            clearTimeout(animationCallbackId);
            if (!animating) {
                if (typeof callback === "function") callback();
            } else animationCallbackId = setTimeout(function() {
                if (typeof callback === "function") callback();
            }, animationTime);
            animationStates = [];
        },
        animate: function animate(target, currentRect, toRect, duration) {
            if (duration) {
                $695b3d6025d5e530$var$css(target, "transition", "");
                $695b3d6025d5e530$var$css(target, "transform", "");
                var elMatrix = $695b3d6025d5e530$var$matrix(this.el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d, translateX = (currentRect.left - toRect.left) / (scaleX || 1), translateY = (currentRect.top - toRect.top) / (scaleY || 1);
                target.animatingX = !!translateX;
                target.animatingY = !!translateY;
                $695b3d6025d5e530$var$css(target, "transform", "translate3d(" + translateX + "px," + translateY + "px,0)");
                this.forRepaintDummy = $695b3d6025d5e530$var$repaint(target); // repaint
                $695b3d6025d5e530$var$css(target, "transition", "transform " + duration + "ms" + (this.options.easing ? " " + this.options.easing : ""));
                $695b3d6025d5e530$var$css(target, "transform", "translate3d(0,0,0)");
                typeof target.animated === "number" && clearTimeout(target.animated);
                target.animated = setTimeout(function() {
                    $695b3d6025d5e530$var$css(target, "transition", "");
                    $695b3d6025d5e530$var$css(target, "transform", "");
                    target.animated = false;
                    target.animatingX = false;
                    target.animatingY = false;
                }, duration);
            }
        }
    };
}
function $695b3d6025d5e530$var$repaint(target) {
    return target.offsetWidth;
}
function $695b3d6025d5e530$var$calculateRealTime(animatingRect, fromRect, toRect, options) {
    return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}
var $695b3d6025d5e530$var$plugins = [];
var $695b3d6025d5e530$var$defaults = {
    initializeByDefault: true
};
var $695b3d6025d5e530$var$PluginManager = {
    mount: function mount(plugin) {
        // Set default static properties
        for(var option in $695b3d6025d5e530$var$defaults)if ($695b3d6025d5e530$var$defaults.hasOwnProperty(option) && !(option in plugin)) plugin[option] = $695b3d6025d5e530$var$defaults[option];
        $695b3d6025d5e530$var$plugins.forEach(function(p) {
            if (p.pluginName === plugin.pluginName) throw "Sortable: Cannot mount plugin ".concat(plugin.pluginName, " more than once");
        });
        $695b3d6025d5e530$var$plugins.push(plugin);
    },
    pluginEvent: function pluginEvent(eventName, sortable, evt) {
        var _this = this;
        this.eventCanceled = false;
        evt.cancel = function() {
            _this.eventCanceled = true;
        };
        var eventNameGlobal = eventName + "Global";
        $695b3d6025d5e530$var$plugins.forEach(function(plugin) {
            if (!sortable[plugin.pluginName]) return;
            // Fire global events if it exists in this sortable
            if (sortable[plugin.pluginName][eventNameGlobal]) sortable[plugin.pluginName][eventNameGlobal]($695b3d6025d5e530$var$_objectSpread2({
                sortable: sortable
            }, evt));
            // Only fire plugin event if plugin is enabled in this sortable,
            // and plugin has event defined
            if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) sortable[plugin.pluginName][eventName]($695b3d6025d5e530$var$_objectSpread2({
                sortable: sortable
            }, evt));
        });
    },
    initializePlugins: function initializePlugins(sortable, el, defaults, options) {
        $695b3d6025d5e530$var$plugins.forEach(function(plugin) {
            var pluginName = plugin.pluginName;
            if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
            var initialized = new plugin(sortable, el, sortable.options);
            initialized.sortable = sortable;
            initialized.options = sortable.options;
            sortable[pluginName] = initialized;
            // Add default options from plugin
            $695b3d6025d5e530$var$_extends(defaults, initialized.defaults);
        });
        for(var option in sortable.options){
            if (!sortable.options.hasOwnProperty(option)) continue;
            var modified = this.modifyOption(sortable, option, sortable.options[option]);
            if (typeof modified !== "undefined") sortable.options[option] = modified;
        }
    },
    getEventProperties: function getEventProperties(name, sortable) {
        var eventProperties = {};
        $695b3d6025d5e530$var$plugins.forEach(function(plugin) {
            if (typeof plugin.eventProperties !== "function") return;
            $695b3d6025d5e530$var$_extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
        });
        return eventProperties;
    },
    modifyOption: function modifyOption(sortable, name, value) {
        var modifiedValue;
        $695b3d6025d5e530$var$plugins.forEach(function(plugin) {
            // Plugin must exist on the Sortable
            if (!sortable[plugin.pluginName]) return;
            // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin
            if (plugin.optionListeners && typeof plugin.optionListeners[name] === "function") modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
        });
        return modifiedValue;
    }
};
function $695b3d6025d5e530$var$dispatchEvent(_ref) {
    var sortable = _ref.sortable, rootEl = _ref.rootEl, name = _ref.name, targetEl = _ref.targetEl, cloneEl = _ref.cloneEl, toEl = _ref.toEl, fromEl = _ref.fromEl, oldIndex = _ref.oldIndex, newIndex = _ref.newIndex, oldDraggableIndex = _ref.oldDraggableIndex, newDraggableIndex = _ref.newDraggableIndex, originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, extraEventProperties = _ref.extraEventProperties;
    sortable = sortable || rootEl && rootEl[$695b3d6025d5e530$var$expando];
    if (!sortable) return;
    var evt, options = sortable.options, onName = "on" + name.charAt(0).toUpperCase() + name.substr(1);
    // Support for new CustomEvent feature
    if (window.CustomEvent && !$695b3d6025d5e530$var$IE11OrLess && !$695b3d6025d5e530$var$Edge) evt = new CustomEvent(name, {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent("Event");
        evt.initEvent(name, true, true);
    }
    evt.to = toEl || rootEl;
    evt.from = fromEl || rootEl;
    evt.item = targetEl || rootEl;
    evt.clone = cloneEl;
    evt.oldIndex = oldIndex;
    evt.newIndex = newIndex;
    evt.oldDraggableIndex = oldDraggableIndex;
    evt.newDraggableIndex = newDraggableIndex;
    evt.originalEvent = originalEvent;
    evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;
    var allEventProperties = $695b3d6025d5e530$var$_objectSpread2($695b3d6025d5e530$var$_objectSpread2({}, extraEventProperties), $695b3d6025d5e530$var$PluginManager.getEventProperties(name, sortable));
    for(var option in allEventProperties)evt[option] = allEventProperties[option];
    if (rootEl) rootEl.dispatchEvent(evt);
    if (options[onName]) options[onName].call(sortable, evt);
}
var $695b3d6025d5e530$var$_excluded = [
    "evt"
];
var $695b3d6025d5e530$var$pluginEvent = function pluginEvent(eventName, sortable) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, originalEvent = _ref.evt, data = $695b3d6025d5e530$var$_objectWithoutProperties(_ref, $695b3d6025d5e530$var$_excluded);
    $695b3d6025d5e530$var$PluginManager.pluginEvent.bind($695b3d6025d5e530$export$31b3ca70d8f57423)(eventName, sortable, $695b3d6025d5e530$var$_objectSpread2({
        dragEl: $695b3d6025d5e530$var$dragEl,
        parentEl: $695b3d6025d5e530$var$parentEl,
        ghostEl: $695b3d6025d5e530$var$ghostEl,
        rootEl: $695b3d6025d5e530$var$rootEl,
        nextEl: $695b3d6025d5e530$var$nextEl,
        lastDownEl: $695b3d6025d5e530$var$lastDownEl,
        cloneEl: $695b3d6025d5e530$var$cloneEl,
        cloneHidden: $695b3d6025d5e530$var$cloneHidden,
        dragStarted: $695b3d6025d5e530$var$moved,
        putSortable: $695b3d6025d5e530$var$putSortable,
        activeSortable: $695b3d6025d5e530$export$31b3ca70d8f57423.active,
        originalEvent: originalEvent,
        oldIndex: $695b3d6025d5e530$var$oldIndex,
        oldDraggableIndex: $695b3d6025d5e530$var$oldDraggableIndex,
        newIndex: $695b3d6025d5e530$var$newIndex,
        newDraggableIndex: $695b3d6025d5e530$var$newDraggableIndex,
        hideGhostForTarget: $695b3d6025d5e530$var$_hideGhostForTarget,
        unhideGhostForTarget: $695b3d6025d5e530$var$_unhideGhostForTarget,
        cloneNowHidden: function cloneNowHidden() {
            $695b3d6025d5e530$var$cloneHidden = true;
        },
        cloneNowShown: function cloneNowShown() {
            $695b3d6025d5e530$var$cloneHidden = false;
        },
        dispatchSortableEvent: function dispatchSortableEvent(name) {
            $695b3d6025d5e530$var$_dispatchEvent({
                sortable: sortable,
                name: name,
                originalEvent: originalEvent
            });
        }
    }, data));
};
function $695b3d6025d5e530$var$_dispatchEvent(info) {
    $695b3d6025d5e530$var$dispatchEvent($695b3d6025d5e530$var$_objectSpread2({
        putSortable: $695b3d6025d5e530$var$putSortable,
        cloneEl: $695b3d6025d5e530$var$cloneEl,
        targetEl: $695b3d6025d5e530$var$dragEl,
        rootEl: $695b3d6025d5e530$var$rootEl,
        oldIndex: $695b3d6025d5e530$var$oldIndex,
        oldDraggableIndex: $695b3d6025d5e530$var$oldDraggableIndex,
        newIndex: $695b3d6025d5e530$var$newIndex,
        newDraggableIndex: $695b3d6025d5e530$var$newDraggableIndex
    }, info));
}
var $695b3d6025d5e530$var$dragEl, $695b3d6025d5e530$var$parentEl, $695b3d6025d5e530$var$ghostEl, $695b3d6025d5e530$var$rootEl, $695b3d6025d5e530$var$nextEl, $695b3d6025d5e530$var$lastDownEl, $695b3d6025d5e530$var$cloneEl, $695b3d6025d5e530$var$cloneHidden, $695b3d6025d5e530$var$oldIndex, $695b3d6025d5e530$var$newIndex, $695b3d6025d5e530$var$oldDraggableIndex, $695b3d6025d5e530$var$newDraggableIndex, $695b3d6025d5e530$var$activeGroup, $695b3d6025d5e530$var$putSortable, $695b3d6025d5e530$var$awaitingDragStarted = false, $695b3d6025d5e530$var$ignoreNextClick = false, $695b3d6025d5e530$var$sortables = [], $695b3d6025d5e530$var$tapEvt, $695b3d6025d5e530$var$touchEvt, $695b3d6025d5e530$var$lastDx, $695b3d6025d5e530$var$lastDy, $695b3d6025d5e530$var$tapDistanceLeft, $695b3d6025d5e530$var$tapDistanceTop, $695b3d6025d5e530$var$moved, $695b3d6025d5e530$var$lastTarget, $695b3d6025d5e530$var$lastDirection, $695b3d6025d5e530$var$pastFirstInvertThresh = false, $695b3d6025d5e530$var$isCircumstantialInvert = false, $695b3d6025d5e530$var$targetMoveDistance, // For positioning ghost absolutely
$695b3d6025d5e530$var$ghostRelativeParent, $695b3d6025d5e530$var$ghostRelativeParentInitialScroll = [], // (left, top)
$695b3d6025d5e530$var$_silent = false, $695b3d6025d5e530$var$savedInputChecked = [];
/** @const */ var $695b3d6025d5e530$var$documentExists = typeof document !== "undefined", $695b3d6025d5e530$var$PositionGhostAbsolutely = $695b3d6025d5e530$var$IOS, $695b3d6025d5e530$var$CSSFloatProperty = $695b3d6025d5e530$var$Edge || $695b3d6025d5e530$var$IE11OrLess ? "cssFloat" : "float", // This will not pass for IE9, because IE9 DnD only works on anchors
$695b3d6025d5e530$var$supportDraggable = $695b3d6025d5e530$var$documentExists && !$695b3d6025d5e530$var$ChromeForAndroid && !$695b3d6025d5e530$var$IOS && "draggable" in document.createElement("div"), $695b3d6025d5e530$var$supportCssPointerEvents = function() {
    if (!$695b3d6025d5e530$var$documentExists) return;
    // false when <= IE11
    if ($695b3d6025d5e530$var$IE11OrLess) return false;
    var el = document.createElement("x");
    el.style.cssText = "pointer-events:auto";
    return el.style.pointerEvents === "auto";
}(), $695b3d6025d5e530$var$_detectDirection = function _detectDirection(el, options) {
    var elCSS = $695b3d6025d5e530$var$css(el), elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth), child1 = $695b3d6025d5e530$var$getChild(el, 0, options), child2 = $695b3d6025d5e530$var$getChild(el, 1, options), firstChildCSS = child1 && $695b3d6025d5e530$var$css(child1), secondChildCSS = child2 && $695b3d6025d5e530$var$css(child2), firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + $695b3d6025d5e530$var$getRect(child1).width, secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + $695b3d6025d5e530$var$getRect(child2).width;
    if (elCSS.display === "flex") return elCSS.flexDirection === "column" || elCSS.flexDirection === "column-reverse" ? "vertical" : "horizontal";
    if (elCSS.display === "grid") return elCSS.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
    if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== "none") {
        var touchingSideChild2 = firstChildCSS["float"] === "left" ? "left" : "right";
        return child2 && (secondChildCSS.clear === "both" || secondChildCSS.clear === touchingSideChild2) ? "vertical" : "horizontal";
    }
    return child1 && (firstChildCSS.display === "block" || firstChildCSS.display === "flex" || firstChildCSS.display === "table" || firstChildCSS.display === "grid" || firstChildWidth >= elWidth && elCSS[$695b3d6025d5e530$var$CSSFloatProperty] === "none" || child2 && elCSS[$695b3d6025d5e530$var$CSSFloatProperty] === "none" && firstChildWidth + secondChildWidth > elWidth) ? "vertical" : "horizontal";
}, $695b3d6025d5e530$var$_dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
    var dragElS1Opp = vertical ? dragRect.left : dragRect.top, dragElS2Opp = vertical ? dragRect.right : dragRect.bottom, dragElOppLength = vertical ? dragRect.width : dragRect.height, targetS1Opp = vertical ? targetRect.left : targetRect.top, targetS2Opp = vertical ? targetRect.right : targetRect.bottom, targetOppLength = vertical ? targetRect.width : targetRect.height;
    return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
}, /**
   * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
   * @param  {Number} x      X position
   * @param  {Number} y      Y position
   * @return {HTMLElement}   Element of the first found nearest Sortable
   */ $695b3d6025d5e530$var$_detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
    var ret;
    $695b3d6025d5e530$var$sortables.some(function(sortable) {
        var threshold = sortable[$695b3d6025d5e530$var$expando].options.emptyInsertThreshold;
        if (!threshold || $695b3d6025d5e530$var$lastChild(sortable)) return;
        var rect = $695b3d6025d5e530$var$getRect(sortable), insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold, insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;
        if (insideHorizontally && insideVertically) return ret = sortable;
    });
    return ret;
}, $695b3d6025d5e530$var$_prepareGroup = function _prepareGroup(options) {
    function toFn(value, pull) {
        return function(to, from, dragEl, evt) {
            var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;
            if (value == null && (pull || sameGroup)) // Default pull value
            // Default pull and put value if same group
            return true;
            else if (value == null || value === false) return false;
            else if (pull && value === "clone") return value;
            else if (typeof value === "function") return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
            else {
                var otherGroup = (pull ? to : from).options.group.name;
                return value === true || typeof value === "string" && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
            }
        };
    }
    var group = {};
    var originalGroup = options.group;
    if (!originalGroup || $695b3d6025d5e530$var$_typeof(originalGroup) != "object") originalGroup = {
        name: originalGroup
    };
    group.name = originalGroup.name;
    group.checkPull = toFn(originalGroup.pull, true);
    group.checkPut = toFn(originalGroup.put);
    group.revertClone = originalGroup.revertClone;
    options.group = group;
}, $695b3d6025d5e530$var$_hideGhostForTarget = function _hideGhostForTarget() {
    if (!$695b3d6025d5e530$var$supportCssPointerEvents && $695b3d6025d5e530$var$ghostEl) $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "display", "none");
}, $695b3d6025d5e530$var$_unhideGhostForTarget = function _unhideGhostForTarget() {
    if (!$695b3d6025d5e530$var$supportCssPointerEvents && $695b3d6025d5e530$var$ghostEl) $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "display", "");
};
// #1184 fix - Prevent click event on fallback if dragged but item not changed position
if ($695b3d6025d5e530$var$documentExists && !$695b3d6025d5e530$var$ChromeForAndroid) document.addEventListener("click", function(evt) {
    if ($695b3d6025d5e530$var$ignoreNextClick) {
        evt.preventDefault();
        evt.stopPropagation && evt.stopPropagation();
        evt.stopImmediatePropagation && evt.stopImmediatePropagation();
        $695b3d6025d5e530$var$ignoreNextClick = false;
        return false;
    }
}, true);
var $695b3d6025d5e530$var$nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
    if ($695b3d6025d5e530$var$dragEl) {
        evt = evt.touches ? evt.touches[0] : evt;
        var nearest = $695b3d6025d5e530$var$_detectNearestEmptySortable(evt.clientX, evt.clientY);
        if (nearest) {
            // Create imitation event
            var event = {};
            for(var i in evt)if (evt.hasOwnProperty(i)) event[i] = evt[i];
            event.target = event.rootEl = nearest;
            event.preventDefault = void 0;
            event.stopPropagation = void 0;
            nearest[$695b3d6025d5e530$var$expando]._onDragOver(event);
        }
    }
};
var $695b3d6025d5e530$var$_checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
    if ($695b3d6025d5e530$var$dragEl) $695b3d6025d5e530$var$dragEl.parentNode[$695b3d6025d5e530$var$expando]._isOutsideThisEl(evt.target);
};
/**
 * @class  Sortable
 * @param  {HTMLElement}  el
 * @param  {Object}       [options]
 */ function $695b3d6025d5e530$export$31b3ca70d8f57423(el, options) {
    if (!(el && el.nodeType && el.nodeType === 1)) throw "Sortable: `el` must be an HTMLElement, not ".concat(({}).toString.call(el));
    this.el = el; // root element
    this.options = options = $695b3d6025d5e530$var$_extends({}, options);
    // Export instance
    el[$695b3d6025d5e530$var$expando] = this;
    var defaults = {
        group: null,
        sort: true,
        disabled: false,
        store: null,
        handle: null,
        draggable: /^[uo]l$/i.test(el.nodeName) ? ">li" : ">*",
        swapThreshold: 1,
        // percentage; 0 <= x <= 1
        invertSwap: false,
        // invert always
        invertedSwapThreshold: null,
        // will be set to same as swapThreshold if default
        removeCloneOnHide: true,
        direction: function direction() {
            return $695b3d6025d5e530$var$_detectDirection(el, this.options);
        },
        ghostClass: "sortable-ghost",
        chosenClass: "sortable-chosen",
        dragClass: "sortable-drag",
        ignore: "a, img",
        filter: null,
        preventOnFilter: true,
        animation: 0,
        easing: null,
        setData: function setData(dataTransfer, dragEl) {
            dataTransfer.setData("Text", dragEl.textContent);
        },
        dropBubble: false,
        dragoverBubble: false,
        dataIdAttr: "data-id",
        delay: 0,
        delayOnTouchOnly: false,
        touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
        forceFallback: false,
        fallbackClass: "sortable-fallback",
        fallbackOnBody: false,
        fallbackTolerance: 0,
        fallbackOffset: {
            x: 0,
            y: 0
        },
        supportPointer: $695b3d6025d5e530$export$31b3ca70d8f57423.supportPointer !== false && "PointerEvent" in window && !$695b3d6025d5e530$var$Safari,
        emptyInsertThreshold: 5
    };
    $695b3d6025d5e530$var$PluginManager.initializePlugins(this, el, defaults);
    // Set default options
    for(var name in defaults)!(name in options) && (options[name] = defaults[name]);
    $695b3d6025d5e530$var$_prepareGroup(options);
    // Bind all private methods
    for(var fn in this)if (fn.charAt(0) === "_" && typeof this[fn] === "function") this[fn] = this[fn].bind(this);
    // Setup drag mode
    this.nativeDraggable = options.forceFallback ? false : $695b3d6025d5e530$var$supportDraggable;
    if (this.nativeDraggable) // Touch start threshold cannot be greater than the native dragstart threshold
    this.options.touchStartThreshold = 1;
    // Bind events
    if (options.supportPointer) $695b3d6025d5e530$var$on(el, "pointerdown", this._onTapStart);
    else {
        $695b3d6025d5e530$var$on(el, "mousedown", this._onTapStart);
        $695b3d6025d5e530$var$on(el, "touchstart", this._onTapStart);
    }
    if (this.nativeDraggable) {
        $695b3d6025d5e530$var$on(el, "dragover", this);
        $695b3d6025d5e530$var$on(el, "dragenter", this);
    }
    $695b3d6025d5e530$var$sortables.push(this.el);
    // Restore sorting
    options.store && options.store.get && this.sort(options.store.get(this) || []);
    // Add animation state manager
    $695b3d6025d5e530$var$_extends(this, $695b3d6025d5e530$var$AnimationStateManager());
}
$695b3d6025d5e530$export$31b3ca70d8f57423.prototype = /** @lends Sortable.prototype */ {
    constructor: $695b3d6025d5e530$export$31b3ca70d8f57423,
    _isOutsideThisEl: function _isOutsideThisEl(target) {
        if (!this.el.contains(target) && target !== this.el) $695b3d6025d5e530$var$lastTarget = null;
    },
    _getDirection: function _getDirection(evt, target) {
        return typeof this.options.direction === "function" ? this.options.direction.call(this, evt, target, $695b3d6025d5e530$var$dragEl) : this.options.direction;
    },
    _onTapStart: function _onTapStart(/** Event|TouchEvent */ evt) {
        if (!evt.cancelable) return;
        var _this = this, el = this.el, options = this.options, preventOnFilter = options.preventOnFilter, type = evt.type, touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === "touch" && evt, target = (touch || evt).target, originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target, filter = options.filter;
        $695b3d6025d5e530$var$_saveInputCheckedState(el);
        // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
        if ($695b3d6025d5e530$var$dragEl) return;
        if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) return; // only left button and enabled
        // cancel dnd if original target is content editable
        if (originalTarget.isContentEditable) return;
        // Safari ignores further event handling after mousedown
        if (!this.nativeDraggable && $695b3d6025d5e530$var$Safari && target && target.tagName.toUpperCase() === "SELECT") return;
        target = $695b3d6025d5e530$var$closest(target, options.draggable, el, false);
        if (target && target.animated) return;
        if ($695b3d6025d5e530$var$lastDownEl === target) // Ignoring duplicate `down`
        return;
        // Get the index of the dragged element within its parent
        $695b3d6025d5e530$var$oldIndex = $695b3d6025d5e530$var$index(target);
        $695b3d6025d5e530$var$oldDraggableIndex = $695b3d6025d5e530$var$index(target, options.draggable);
        // Check filter
        if (typeof filter === "function") {
            if (filter.call(this, evt, target, this)) {
                $695b3d6025d5e530$var$_dispatchEvent({
                    sortable: _this,
                    rootEl: originalTarget,
                    name: "filter",
                    targetEl: target,
                    toEl: el,
                    fromEl: el
                });
                $695b3d6025d5e530$var$pluginEvent("filter", _this, {
                    evt: evt
                });
                preventOnFilter && evt.cancelable && evt.preventDefault();
                return; // cancel dnd
            }
        } else if (filter) {
            filter = filter.split(",").some(function(criteria) {
                criteria = $695b3d6025d5e530$var$closest(originalTarget, criteria.trim(), el, false);
                if (criteria) {
                    $695b3d6025d5e530$var$_dispatchEvent({
                        sortable: _this,
                        rootEl: criteria,
                        name: "filter",
                        targetEl: target,
                        fromEl: el,
                        toEl: el
                    });
                    $695b3d6025d5e530$var$pluginEvent("filter", _this, {
                        evt: evt
                    });
                    return true;
                }
            });
            if (filter) {
                preventOnFilter && evt.cancelable && evt.preventDefault();
                return; // cancel dnd
            }
        }
        if (options.handle && !$695b3d6025d5e530$var$closest(originalTarget, options.handle, el, false)) return;
        // Prepare `dragstart`
        this._prepareDragStart(evt, touch, target);
    },
    _prepareDragStart: function _prepareDragStart(/** Event */ evt, /** Touch */ touch, /** HTMLElement */ target) {
        var _this = this, el = _this.el, options = _this.options, ownerDocument = el.ownerDocument, dragStartFn;
        if (target && !$695b3d6025d5e530$var$dragEl && target.parentNode === el) {
            var dragRect = $695b3d6025d5e530$var$getRect(target);
            $695b3d6025d5e530$var$rootEl = el;
            $695b3d6025d5e530$var$dragEl = target;
            $695b3d6025d5e530$var$parentEl = $695b3d6025d5e530$var$dragEl.parentNode;
            $695b3d6025d5e530$var$nextEl = $695b3d6025d5e530$var$dragEl.nextSibling;
            $695b3d6025d5e530$var$lastDownEl = target;
            $695b3d6025d5e530$var$activeGroup = options.group;
            $695b3d6025d5e530$export$31b3ca70d8f57423.dragged = $695b3d6025d5e530$var$dragEl;
            $695b3d6025d5e530$var$tapEvt = {
                target: $695b3d6025d5e530$var$dragEl,
                clientX: (touch || evt).clientX,
                clientY: (touch || evt).clientY
            };
            $695b3d6025d5e530$var$tapDistanceLeft = $695b3d6025d5e530$var$tapEvt.clientX - dragRect.left;
            $695b3d6025d5e530$var$tapDistanceTop = $695b3d6025d5e530$var$tapEvt.clientY - dragRect.top;
            this._lastX = (touch || evt).clientX;
            this._lastY = (touch || evt).clientY;
            $695b3d6025d5e530$var$dragEl.style["will-change"] = "all";
            dragStartFn = function dragStartFn() {
                $695b3d6025d5e530$var$pluginEvent("delayEnded", _this, {
                    evt: evt
                });
                if ($695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) {
                    _this._onDrop();
                    return;
                }
                // Delayed drag has been triggered
                // we can re-enable the events: touchmove/mousemove
                _this._disableDelayedDragEvents();
                if (!$695b3d6025d5e530$var$FireFox && _this.nativeDraggable) $695b3d6025d5e530$var$dragEl.draggable = true;
                // Bind the events: dragstart/dragend
                _this._triggerDragStart(evt, touch);
                // Drag start event
                $695b3d6025d5e530$var$_dispatchEvent({
                    sortable: _this,
                    name: "choose",
                    originalEvent: evt
                });
                // Chosen item
                $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$dragEl, options.chosenClass, true);
            };
            // Disable "draggable"
            options.ignore.split(",").forEach(function(criteria) {
                $695b3d6025d5e530$var$find($695b3d6025d5e530$var$dragEl, criteria.trim(), $695b3d6025d5e530$var$_disableDraggable);
            });
            $695b3d6025d5e530$var$on(ownerDocument, "dragover", $695b3d6025d5e530$var$nearestEmptyInsertDetectEvent);
            $695b3d6025d5e530$var$on(ownerDocument, "mousemove", $695b3d6025d5e530$var$nearestEmptyInsertDetectEvent);
            $695b3d6025d5e530$var$on(ownerDocument, "touchmove", $695b3d6025d5e530$var$nearestEmptyInsertDetectEvent);
            $695b3d6025d5e530$var$on(ownerDocument, "mouseup", _this._onDrop);
            $695b3d6025d5e530$var$on(ownerDocument, "touchend", _this._onDrop);
            $695b3d6025d5e530$var$on(ownerDocument, "touchcancel", _this._onDrop);
            // Make dragEl draggable (must be before delay for FireFox)
            if ($695b3d6025d5e530$var$FireFox && this.nativeDraggable) {
                this.options.touchStartThreshold = 4;
                $695b3d6025d5e530$var$dragEl.draggable = true;
            }
            $695b3d6025d5e530$var$pluginEvent("delayStart", this, {
                evt: evt
            });
            // Delay is impossible for native DnD in Edge or IE
            if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !($695b3d6025d5e530$var$Edge || $695b3d6025d5e530$var$IE11OrLess))) {
                if ($695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) {
                    this._onDrop();
                    return;
                }
                // If the user moves the pointer or let go the click or touch
                // before the delay has been reached:
                // disable the delayed drag
                $695b3d6025d5e530$var$on(ownerDocument, "mouseup", _this._disableDelayedDrag);
                $695b3d6025d5e530$var$on(ownerDocument, "touchend", _this._disableDelayedDrag);
                $695b3d6025d5e530$var$on(ownerDocument, "touchcancel", _this._disableDelayedDrag);
                $695b3d6025d5e530$var$on(ownerDocument, "mousemove", _this._delayedDragTouchMoveHandler);
                $695b3d6025d5e530$var$on(ownerDocument, "touchmove", _this._delayedDragTouchMoveHandler);
                options.supportPointer && $695b3d6025d5e530$var$on(ownerDocument, "pointermove", _this._delayedDragTouchMoveHandler);
                _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
            } else dragStartFn();
        }
    },
    _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(/** TouchEvent|PointerEvent **/ e) {
        var touch = e.touches ? e.touches[0] : e;
        if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) this._disableDelayedDrag();
    },
    _disableDelayedDrag: function _disableDelayedDrag() {
        $695b3d6025d5e530$var$dragEl && $695b3d6025d5e530$var$_disableDraggable($695b3d6025d5e530$var$dragEl);
        clearTimeout(this._dragStartTimer);
        this._disableDelayedDragEvents();
    },
    _disableDelayedDragEvents: function _disableDelayedDragEvents() {
        var ownerDocument = this.el.ownerDocument;
        $695b3d6025d5e530$var$off(ownerDocument, "mouseup", this._disableDelayedDrag);
        $695b3d6025d5e530$var$off(ownerDocument, "touchend", this._disableDelayedDrag);
        $695b3d6025d5e530$var$off(ownerDocument, "touchcancel", this._disableDelayedDrag);
        $695b3d6025d5e530$var$off(ownerDocument, "mousemove", this._delayedDragTouchMoveHandler);
        $695b3d6025d5e530$var$off(ownerDocument, "touchmove", this._delayedDragTouchMoveHandler);
        $695b3d6025d5e530$var$off(ownerDocument, "pointermove", this._delayedDragTouchMoveHandler);
    },
    _triggerDragStart: function _triggerDragStart(/** Event */ evt, /** Touch */ touch) {
        touch = touch || evt.pointerType == "touch" && evt;
        if (!this.nativeDraggable || touch) {
            if (this.options.supportPointer) $695b3d6025d5e530$var$on(document, "pointermove", this._onTouchMove);
            else if (touch) $695b3d6025d5e530$var$on(document, "touchmove", this._onTouchMove);
            else $695b3d6025d5e530$var$on(document, "mousemove", this._onTouchMove);
        } else {
            $695b3d6025d5e530$var$on($695b3d6025d5e530$var$dragEl, "dragend", this);
            $695b3d6025d5e530$var$on($695b3d6025d5e530$var$rootEl, "dragstart", this._onDragStart);
        }
        try {
            if (document.selection) // Timeout neccessary for IE9
            $695b3d6025d5e530$var$_nextTick(function() {
                document.selection.empty();
            });
            else window.getSelection().removeAllRanges();
        } catch (err) {}
    },
    _dragStarted: function _dragStarted(fallback, evt) {
        $695b3d6025d5e530$var$awaitingDragStarted = false;
        if ($695b3d6025d5e530$var$rootEl && $695b3d6025d5e530$var$dragEl) {
            $695b3d6025d5e530$var$pluginEvent("dragStarted", this, {
                evt: evt
            });
            if (this.nativeDraggable) $695b3d6025d5e530$var$on(document, "dragover", $695b3d6025d5e530$var$_checkOutsideTargetEl);
            var options = this.options;
            // Apply effect
            !fallback && $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$dragEl, options.dragClass, false);
            $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$dragEl, options.ghostClass, true);
            $695b3d6025d5e530$export$31b3ca70d8f57423.active = this;
            fallback && this._appendGhost();
            // Drag start event
            $695b3d6025d5e530$var$_dispatchEvent({
                sortable: this,
                name: "start",
                originalEvent: evt
            });
        } else this._nulling();
    },
    _emulateDragOver: function _emulateDragOver() {
        if ($695b3d6025d5e530$var$touchEvt) {
            this._lastX = $695b3d6025d5e530$var$touchEvt.clientX;
            this._lastY = $695b3d6025d5e530$var$touchEvt.clientY;
            $695b3d6025d5e530$var$_hideGhostForTarget();
            var target = document.elementFromPoint($695b3d6025d5e530$var$touchEvt.clientX, $695b3d6025d5e530$var$touchEvt.clientY);
            var parent = target;
            while(target && target.shadowRoot){
                target = target.shadowRoot.elementFromPoint($695b3d6025d5e530$var$touchEvt.clientX, $695b3d6025d5e530$var$touchEvt.clientY);
                if (target === parent) break;
                parent = target;
            }
            $695b3d6025d5e530$var$dragEl.parentNode[$695b3d6025d5e530$var$expando]._isOutsideThisEl(target);
            if (parent) do {
                if (parent[$695b3d6025d5e530$var$expando]) {
                    var inserted = void 0;
                    inserted = parent[$695b3d6025d5e530$var$expando]._onDragOver({
                        clientX: $695b3d6025d5e530$var$touchEvt.clientX,
                        clientY: $695b3d6025d5e530$var$touchEvt.clientY,
                        target: target,
                        rootEl: parent
                    });
                    if (inserted && !this.options.dragoverBubble) break;
                }
                target = parent; // store last element
            }while (parent = parent.parentNode);
            $695b3d6025d5e530$var$_unhideGhostForTarget();
        }
    },
    _onTouchMove: function _onTouchMove(/**TouchEvent*/ evt) {
        if ($695b3d6025d5e530$var$tapEvt) {
            var options = this.options, fallbackTolerance = options.fallbackTolerance, fallbackOffset = options.fallbackOffset, touch = evt.touches ? evt.touches[0] : evt, ghostMatrix = $695b3d6025d5e530$var$ghostEl && $695b3d6025d5e530$var$matrix($695b3d6025d5e530$var$ghostEl, true), scaleX = $695b3d6025d5e530$var$ghostEl && ghostMatrix && ghostMatrix.a, scaleY = $695b3d6025d5e530$var$ghostEl && ghostMatrix && ghostMatrix.d, relativeScrollOffset = $695b3d6025d5e530$var$PositionGhostAbsolutely && $695b3d6025d5e530$var$ghostRelativeParent && $695b3d6025d5e530$var$getRelativeScrollOffset($695b3d6025d5e530$var$ghostRelativeParent), dx = (touch.clientX - $695b3d6025d5e530$var$tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - $695b3d6025d5e530$var$ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1), dy = (touch.clientY - $695b3d6025d5e530$var$tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - $695b3d6025d5e530$var$ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1);
            // only set the status to dragging, when we are actually dragging
            if (!$695b3d6025d5e530$export$31b3ca70d8f57423.active && !$695b3d6025d5e530$var$awaitingDragStarted) {
                if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) return;
                this._onDragStart(evt, true);
            }
            if ($695b3d6025d5e530$var$ghostEl) {
                if (ghostMatrix) {
                    ghostMatrix.e += dx - ($695b3d6025d5e530$var$lastDx || 0);
                    ghostMatrix.f += dy - ($695b3d6025d5e530$var$lastDy || 0);
                } else ghostMatrix = {
                    a: 1,
                    b: 0,
                    c: 0,
                    d: 1,
                    e: dx,
                    f: dy
                };
                var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
                $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "webkitTransform", cssMatrix);
                $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "mozTransform", cssMatrix);
                $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "msTransform", cssMatrix);
                $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "transform", cssMatrix);
                $695b3d6025d5e530$var$lastDx = dx;
                $695b3d6025d5e530$var$lastDy = dy;
                $695b3d6025d5e530$var$touchEvt = touch;
            }
            evt.cancelable && evt.preventDefault();
        }
    },
    _appendGhost: function _appendGhost() {
        // Bug if using scale(): https://stackoverflow.com/questions/2637058
        // Not being adjusted for
        if (!$695b3d6025d5e530$var$ghostEl) {
            var container = this.options.fallbackOnBody ? document.body : $695b3d6025d5e530$var$rootEl, rect = $695b3d6025d5e530$var$getRect($695b3d6025d5e530$var$dragEl, true, $695b3d6025d5e530$var$PositionGhostAbsolutely, true, container), options = this.options;
            // Position absolutely
            if ($695b3d6025d5e530$var$PositionGhostAbsolutely) {
                // Get relatively positioned parent
                $695b3d6025d5e530$var$ghostRelativeParent = container;
                while($695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostRelativeParent, "position") === "static" && $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostRelativeParent, "transform") === "none" && $695b3d6025d5e530$var$ghostRelativeParent !== document)$695b3d6025d5e530$var$ghostRelativeParent = $695b3d6025d5e530$var$ghostRelativeParent.parentNode;
                if ($695b3d6025d5e530$var$ghostRelativeParent !== document.body && $695b3d6025d5e530$var$ghostRelativeParent !== document.documentElement) {
                    if ($695b3d6025d5e530$var$ghostRelativeParent === document) $695b3d6025d5e530$var$ghostRelativeParent = $695b3d6025d5e530$var$getWindowScrollingElement();
                    rect.top += $695b3d6025d5e530$var$ghostRelativeParent.scrollTop;
                    rect.left += $695b3d6025d5e530$var$ghostRelativeParent.scrollLeft;
                } else $695b3d6025d5e530$var$ghostRelativeParent = $695b3d6025d5e530$var$getWindowScrollingElement();
                $695b3d6025d5e530$var$ghostRelativeParentInitialScroll = $695b3d6025d5e530$var$getRelativeScrollOffset($695b3d6025d5e530$var$ghostRelativeParent);
            }
            $695b3d6025d5e530$var$ghostEl = $695b3d6025d5e530$var$dragEl.cloneNode(true);
            $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$ghostEl, options.ghostClass, false);
            $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$ghostEl, options.fallbackClass, true);
            $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$ghostEl, options.dragClass, true);
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "transition", "");
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "transform", "");
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "box-sizing", "border-box");
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "margin", 0);
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "top", rect.top);
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "left", rect.left);
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "width", rect.width);
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "height", rect.height);
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "opacity", "0.8");
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "position", $695b3d6025d5e530$var$PositionGhostAbsolutely ? "absolute" : "fixed");
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "zIndex", "100000");
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "pointerEvents", "none");
            $695b3d6025d5e530$export$31b3ca70d8f57423.ghost = $695b3d6025d5e530$var$ghostEl;
            container.appendChild($695b3d6025d5e530$var$ghostEl);
            // Set transform-origin
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "transform-origin", $695b3d6025d5e530$var$tapDistanceLeft / parseInt($695b3d6025d5e530$var$ghostEl.style.width) * 100 + "% " + $695b3d6025d5e530$var$tapDistanceTop / parseInt($695b3d6025d5e530$var$ghostEl.style.height) * 100 + "%");
        }
    },
    _onDragStart: function _onDragStart(/**Event*/ evt, /**boolean*/ fallback) {
        var _this = this;
        var dataTransfer = evt.dataTransfer;
        var options = _this.options;
        $695b3d6025d5e530$var$pluginEvent("dragStart", this, {
            evt: evt
        });
        if ($695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) {
            this._onDrop();
            return;
        }
        $695b3d6025d5e530$var$pluginEvent("setupClone", this);
        if (!$695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) {
            $695b3d6025d5e530$var$cloneEl = $695b3d6025d5e530$var$clone($695b3d6025d5e530$var$dragEl);
            $695b3d6025d5e530$var$cloneEl.removeAttribute("id");
            $695b3d6025d5e530$var$cloneEl.draggable = false;
            $695b3d6025d5e530$var$cloneEl.style["will-change"] = "";
            this._hideClone();
            $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$cloneEl, this.options.chosenClass, false);
            $695b3d6025d5e530$export$31b3ca70d8f57423.clone = $695b3d6025d5e530$var$cloneEl;
        }
        // #1143: IFrame support workaround
        _this.cloneId = $695b3d6025d5e530$var$_nextTick(function() {
            $695b3d6025d5e530$var$pluginEvent("clone", _this);
            if ($695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) return;
            if (!_this.options.removeCloneOnHide) $695b3d6025d5e530$var$rootEl.insertBefore($695b3d6025d5e530$var$cloneEl, $695b3d6025d5e530$var$dragEl);
            _this._hideClone();
            $695b3d6025d5e530$var$_dispatchEvent({
                sortable: _this,
                name: "clone"
            });
        });
        !fallback && $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$dragEl, options.dragClass, true);
        // Set proper drop events
        if (fallback) {
            $695b3d6025d5e530$var$ignoreNextClick = true;
            _this._loopId = setInterval(_this._emulateDragOver, 50);
        } else {
            // Undo what was set in _prepareDragStart before drag started
            $695b3d6025d5e530$var$off(document, "mouseup", _this._onDrop);
            $695b3d6025d5e530$var$off(document, "touchend", _this._onDrop);
            $695b3d6025d5e530$var$off(document, "touchcancel", _this._onDrop);
            if (dataTransfer) {
                dataTransfer.effectAllowed = "move";
                options.setData && options.setData.call(_this, dataTransfer, $695b3d6025d5e530$var$dragEl);
            }
            $695b3d6025d5e530$var$on(document, "drop", _this);
            // #1276 fix:
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$dragEl, "transform", "translateZ(0)");
        }
        $695b3d6025d5e530$var$awaitingDragStarted = true;
        _this._dragStartId = $695b3d6025d5e530$var$_nextTick(_this._dragStarted.bind(_this, fallback, evt));
        $695b3d6025d5e530$var$on(document, "selectstart", _this);
        $695b3d6025d5e530$var$moved = true;
        if ($695b3d6025d5e530$var$Safari) $695b3d6025d5e530$var$css(document.body, "user-select", "none");
    },
    // Returns true - if no further action is needed (either inserted or another condition)
    _onDragOver: function _onDragOver(/**Event*/ evt) {
        var el = this.el, target = evt.target, dragRect, targetRect, revert, options = this.options, group = options.group, activeSortable = $695b3d6025d5e530$export$31b3ca70d8f57423.active, isOwner = $695b3d6025d5e530$var$activeGroup === group, canSort = options.sort, fromSortable = $695b3d6025d5e530$var$putSortable || activeSortable, vertical, _this = this, completedFired = false;
        if ($695b3d6025d5e530$var$_silent) return;
        function dragOverEvent(name, extra) {
            $695b3d6025d5e530$var$pluginEvent(name, _this, $695b3d6025d5e530$var$_objectSpread2({
                evt: evt,
                isOwner: isOwner,
                axis: vertical ? "vertical" : "horizontal",
                revert: revert,
                dragRect: dragRect,
                targetRect: targetRect,
                canSort: canSort,
                fromSortable: fromSortable,
                target: target,
                completed: completed,
                onMove: function onMove(target, after) {
                    return $695b3d6025d5e530$var$_onMove($695b3d6025d5e530$var$rootEl, el, $695b3d6025d5e530$var$dragEl, dragRect, target, $695b3d6025d5e530$var$getRect(target), evt, after);
                },
                changed: changed
            }, extra));
        }
        // Capture animation state
        function capture() {
            dragOverEvent("dragOverAnimationCapture");
            _this.captureAnimationState();
            if (_this !== fromSortable) fromSortable.captureAnimationState();
        }
        // Return invocation when dragEl is inserted (or completed)
        function completed(insertion) {
            dragOverEvent("dragOverCompleted", {
                insertion: insertion
            });
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                else activeSortable._showClone(_this);
                if (_this !== fromSortable) {
                    // Set ghost class to new sortable's ghost class
                    $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$dragEl, $695b3d6025d5e530$var$putSortable ? $695b3d6025d5e530$var$putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
                    $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$dragEl, options.ghostClass, true);
                }
                if ($695b3d6025d5e530$var$putSortable !== _this && _this !== $695b3d6025d5e530$export$31b3ca70d8f57423.active) $695b3d6025d5e530$var$putSortable = _this;
                else if (_this === $695b3d6025d5e530$export$31b3ca70d8f57423.active && $695b3d6025d5e530$var$putSortable) $695b3d6025d5e530$var$putSortable = null;
                // Animation
                if (fromSortable === _this) _this._ignoreWhileAnimating = target;
                _this.animateAll(function() {
                    dragOverEvent("dragOverAnimationComplete");
                    _this._ignoreWhileAnimating = null;
                });
                if (_this !== fromSortable) {
                    fromSortable.animateAll();
                    fromSortable._ignoreWhileAnimating = null;
                }
            }
            // Null lastTarget if it is not inside a previously swapped element
            if (target === $695b3d6025d5e530$var$dragEl && !$695b3d6025d5e530$var$dragEl.animated || target === el && !target.animated) $695b3d6025d5e530$var$lastTarget = null;
            // no bubbling and not fallback
            if (!options.dragoverBubble && !evt.rootEl && target !== document) {
                $695b3d6025d5e530$var$dragEl.parentNode[$695b3d6025d5e530$var$expando]._isOutsideThisEl(evt.target);
                // Do not detect for empty insert if already inserted
                !insertion && $695b3d6025d5e530$var$nearestEmptyInsertDetectEvent(evt);
            }
            !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
            return completedFired = true;
        }
        // Call when dragEl has been inserted
        function changed() {
            $695b3d6025d5e530$var$newIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl);
            $695b3d6025d5e530$var$newDraggableIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl, options.draggable);
            $695b3d6025d5e530$var$_dispatchEvent({
                sortable: _this,
                name: "change",
                toEl: el,
                newIndex: $695b3d6025d5e530$var$newIndex,
                newDraggableIndex: $695b3d6025d5e530$var$newDraggableIndex,
                originalEvent: evt
            });
        }
        if (evt.preventDefault !== void 0) evt.cancelable && evt.preventDefault();
        target = $695b3d6025d5e530$var$closest(target, options.draggable, el, true);
        dragOverEvent("dragOver");
        if ($695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) return completedFired;
        if ($695b3d6025d5e530$var$dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) return completed(false);
        $695b3d6025d5e530$var$ignoreNextClick = false;
        if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = $695b3d6025d5e530$var$parentEl !== $695b3d6025d5e530$var$rootEl // Reverting item into the original list
        ) : $695b3d6025d5e530$var$putSortable === this || (this.lastPutMode = $695b3d6025d5e530$var$activeGroup.checkPull(this, activeSortable, $695b3d6025d5e530$var$dragEl, evt)) && group.checkPut(this, activeSortable, $695b3d6025d5e530$var$dragEl, evt))) {
            vertical = this._getDirection(evt, target) === "vertical";
            dragRect = $695b3d6025d5e530$var$getRect($695b3d6025d5e530$var$dragEl);
            dragOverEvent("dragOverValid");
            if ($695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) return completedFired;
            if (revert) {
                $695b3d6025d5e530$var$parentEl = $695b3d6025d5e530$var$rootEl; // actualization
                capture();
                this._hideClone();
                dragOverEvent("revert");
                if (!$695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) {
                    if ($695b3d6025d5e530$var$nextEl) $695b3d6025d5e530$var$rootEl.insertBefore($695b3d6025d5e530$var$dragEl, $695b3d6025d5e530$var$nextEl);
                    else $695b3d6025d5e530$var$rootEl.appendChild($695b3d6025d5e530$var$dragEl);
                }
                return completed(true);
            }
            var elLastChild = $695b3d6025d5e530$var$lastChild(el, options.draggable);
            if (!elLastChild || $695b3d6025d5e530$var$_ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
                // Insert to end of list
                // If already at end of list: Do not insert
                if (elLastChild === $695b3d6025d5e530$var$dragEl) return completed(false);
                // if there is a last element, it is the target
                if (elLastChild && el === evt.target) target = elLastChild;
                if (target) targetRect = $695b3d6025d5e530$var$getRect(target);
                if ($695b3d6025d5e530$var$_onMove($695b3d6025d5e530$var$rootEl, el, $695b3d6025d5e530$var$dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
                    capture();
                    if (elLastChild && elLastChild.nextSibling) // the last draggable element is not the last node
                    el.insertBefore($695b3d6025d5e530$var$dragEl, elLastChild.nextSibling);
                    else el.appendChild($695b3d6025d5e530$var$dragEl);
                    $695b3d6025d5e530$var$parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (elLastChild && $695b3d6025d5e530$var$_ghostIsFirst(evt, vertical, this)) {
                // Insert to start of list
                var firstChild = $695b3d6025d5e530$var$getChild(el, 0, options, true);
                if (firstChild === $695b3d6025d5e530$var$dragEl) return completed(false);
                target = firstChild;
                targetRect = $695b3d6025d5e530$var$getRect(target);
                if ($695b3d6025d5e530$var$_onMove($695b3d6025d5e530$var$rootEl, el, $695b3d6025d5e530$var$dragEl, dragRect, target, targetRect, evt, false) !== false) {
                    capture();
                    el.insertBefore($695b3d6025d5e530$var$dragEl, firstChild);
                    $695b3d6025d5e530$var$parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (target.parentNode === el) {
                targetRect = $695b3d6025d5e530$var$getRect(target);
                var direction = 0, targetBeforeFirstSwap, differentLevel = $695b3d6025d5e530$var$dragEl.parentNode !== el, differentRowCol = !$695b3d6025d5e530$var$_dragElInRowColumn($695b3d6025d5e530$var$dragEl.animated && $695b3d6025d5e530$var$dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical), side1 = vertical ? "top" : "left", scrolledPastTop = $695b3d6025d5e530$var$isScrolledPast(target, "top", "top") || $695b3d6025d5e530$var$isScrolledPast($695b3d6025d5e530$var$dragEl, "top", "top"), scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;
                if ($695b3d6025d5e530$var$lastTarget !== target) {
                    targetBeforeFirstSwap = targetRect[side1];
                    $695b3d6025d5e530$var$pastFirstInvertThresh = false;
                    $695b3d6025d5e530$var$isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
                }
                direction = $695b3d6025d5e530$var$_getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, $695b3d6025d5e530$var$isCircumstantialInvert, $695b3d6025d5e530$var$lastTarget === target);
                var sibling;
                if (direction !== 0) {
                    // Check if target is beside dragEl in respective direction (ignoring hidden elements)
                    var dragIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl);
                    do {
                        dragIndex -= direction;
                        sibling = $695b3d6025d5e530$var$parentEl.children[dragIndex];
                    }while (sibling && ($695b3d6025d5e530$var$css(sibling, "display") === "none" || sibling === $695b3d6025d5e530$var$ghostEl));
                }
                // If dragEl is already beside target: Do not insert
                if (direction === 0 || sibling === target) return completed(false);
                $695b3d6025d5e530$var$lastTarget = target;
                $695b3d6025d5e530$var$lastDirection = direction;
                var nextSibling = target.nextElementSibling, after = false;
                after = direction === 1;
                var moveVector = $695b3d6025d5e530$var$_onMove($695b3d6025d5e530$var$rootEl, el, $695b3d6025d5e530$var$dragEl, dragRect, target, targetRect, evt, after);
                if (moveVector !== false) {
                    if (moveVector === 1 || moveVector === -1) after = moveVector === 1;
                    $695b3d6025d5e530$var$_silent = true;
                    setTimeout($695b3d6025d5e530$var$_unsilent, 30);
                    capture();
                    if (after && !nextSibling) el.appendChild($695b3d6025d5e530$var$dragEl);
                    else target.parentNode.insertBefore($695b3d6025d5e530$var$dragEl, after ? nextSibling : target);
                    // Undo chrome's scroll adjustment (has no effect on other browsers)
                    if (scrolledPastTop) $695b3d6025d5e530$var$scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
                    $695b3d6025d5e530$var$parentEl = $695b3d6025d5e530$var$dragEl.parentNode; // actualization
                    // must be done before animation
                    if (targetBeforeFirstSwap !== undefined && !$695b3d6025d5e530$var$isCircumstantialInvert) $695b3d6025d5e530$var$targetMoveDistance = Math.abs(targetBeforeFirstSwap - $695b3d6025d5e530$var$getRect(target)[side1]);
                    changed();
                    return completed(true);
                }
            }
            if (el.contains($695b3d6025d5e530$var$dragEl)) return completed(false);
        }
        return false;
    },
    _ignoreWhileAnimating: null,
    _offMoveEvents: function _offMoveEvents() {
        $695b3d6025d5e530$var$off(document, "mousemove", this._onTouchMove);
        $695b3d6025d5e530$var$off(document, "touchmove", this._onTouchMove);
        $695b3d6025d5e530$var$off(document, "pointermove", this._onTouchMove);
        $695b3d6025d5e530$var$off(document, "dragover", $695b3d6025d5e530$var$nearestEmptyInsertDetectEvent);
        $695b3d6025d5e530$var$off(document, "mousemove", $695b3d6025d5e530$var$nearestEmptyInsertDetectEvent);
        $695b3d6025d5e530$var$off(document, "touchmove", $695b3d6025d5e530$var$nearestEmptyInsertDetectEvent);
    },
    _offUpEvents: function _offUpEvents() {
        var ownerDocument = this.el.ownerDocument;
        $695b3d6025d5e530$var$off(ownerDocument, "mouseup", this._onDrop);
        $695b3d6025d5e530$var$off(ownerDocument, "touchend", this._onDrop);
        $695b3d6025d5e530$var$off(ownerDocument, "pointerup", this._onDrop);
        $695b3d6025d5e530$var$off(ownerDocument, "touchcancel", this._onDrop);
        $695b3d6025d5e530$var$off(document, "selectstart", this);
    },
    _onDrop: function _onDrop(/**Event*/ evt) {
        var el = this.el, options = this.options;
        // Get the index of the dragged element within its parent
        $695b3d6025d5e530$var$newIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl);
        $695b3d6025d5e530$var$newDraggableIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl, options.draggable);
        $695b3d6025d5e530$var$pluginEvent("drop", this, {
            evt: evt
        });
        $695b3d6025d5e530$var$parentEl = $695b3d6025d5e530$var$dragEl && $695b3d6025d5e530$var$dragEl.parentNode;
        // Get again after plugin event
        $695b3d6025d5e530$var$newIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl);
        $695b3d6025d5e530$var$newDraggableIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl, options.draggable);
        if ($695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) {
            this._nulling();
            return;
        }
        $695b3d6025d5e530$var$awaitingDragStarted = false;
        $695b3d6025d5e530$var$isCircumstantialInvert = false;
        $695b3d6025d5e530$var$pastFirstInvertThresh = false;
        clearInterval(this._loopId);
        clearTimeout(this._dragStartTimer);
        $695b3d6025d5e530$var$_cancelNextTick(this.cloneId);
        $695b3d6025d5e530$var$_cancelNextTick(this._dragStartId);
        // Unbind events
        if (this.nativeDraggable) {
            $695b3d6025d5e530$var$off(document, "drop", this);
            $695b3d6025d5e530$var$off(el, "dragstart", this._onDragStart);
        }
        this._offMoveEvents();
        this._offUpEvents();
        if ($695b3d6025d5e530$var$Safari) $695b3d6025d5e530$var$css(document.body, "user-select", "");
        $695b3d6025d5e530$var$css($695b3d6025d5e530$var$dragEl, "transform", "");
        if (evt) {
            if ($695b3d6025d5e530$var$moved) {
                evt.cancelable && evt.preventDefault();
                !options.dropBubble && evt.stopPropagation();
            }
            $695b3d6025d5e530$var$ghostEl && $695b3d6025d5e530$var$ghostEl.parentNode && $695b3d6025d5e530$var$ghostEl.parentNode.removeChild($695b3d6025d5e530$var$ghostEl);
            if ($695b3d6025d5e530$var$rootEl === $695b3d6025d5e530$var$parentEl || $695b3d6025d5e530$var$putSortable && $695b3d6025d5e530$var$putSortable.lastPutMode !== "clone") // Remove clone(s)
            $695b3d6025d5e530$var$cloneEl && $695b3d6025d5e530$var$cloneEl.parentNode && $695b3d6025d5e530$var$cloneEl.parentNode.removeChild($695b3d6025d5e530$var$cloneEl);
            if ($695b3d6025d5e530$var$dragEl) {
                if (this.nativeDraggable) $695b3d6025d5e530$var$off($695b3d6025d5e530$var$dragEl, "dragend", this);
                $695b3d6025d5e530$var$_disableDraggable($695b3d6025d5e530$var$dragEl);
                $695b3d6025d5e530$var$dragEl.style["will-change"] = "";
                // Remove classes
                // ghostClass is added in dragStarted
                if ($695b3d6025d5e530$var$moved && !$695b3d6025d5e530$var$awaitingDragStarted) $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$dragEl, $695b3d6025d5e530$var$putSortable ? $695b3d6025d5e530$var$putSortable.options.ghostClass : this.options.ghostClass, false);
                $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$dragEl, this.options.chosenClass, false);
                // Drag stop event
                $695b3d6025d5e530$var$_dispatchEvent({
                    sortable: this,
                    name: "unchoose",
                    toEl: $695b3d6025d5e530$var$parentEl,
                    newIndex: null,
                    newDraggableIndex: null,
                    originalEvent: evt
                });
                if ($695b3d6025d5e530$var$rootEl !== $695b3d6025d5e530$var$parentEl) {
                    if ($695b3d6025d5e530$var$newIndex >= 0) {
                        // Add event
                        $695b3d6025d5e530$var$_dispatchEvent({
                            rootEl: $695b3d6025d5e530$var$parentEl,
                            name: "add",
                            toEl: $695b3d6025d5e530$var$parentEl,
                            fromEl: $695b3d6025d5e530$var$rootEl,
                            originalEvent: evt
                        });
                        // Remove event
                        $695b3d6025d5e530$var$_dispatchEvent({
                            sortable: this,
                            name: "remove",
                            toEl: $695b3d6025d5e530$var$parentEl,
                            originalEvent: evt
                        });
                        // drag from one list and drop into another
                        $695b3d6025d5e530$var$_dispatchEvent({
                            rootEl: $695b3d6025d5e530$var$parentEl,
                            name: "sort",
                            toEl: $695b3d6025d5e530$var$parentEl,
                            fromEl: $695b3d6025d5e530$var$rootEl,
                            originalEvent: evt
                        });
                        $695b3d6025d5e530$var$_dispatchEvent({
                            sortable: this,
                            name: "sort",
                            toEl: $695b3d6025d5e530$var$parentEl,
                            originalEvent: evt
                        });
                    }
                    $695b3d6025d5e530$var$putSortable && $695b3d6025d5e530$var$putSortable.save();
                } else {
                    if ($695b3d6025d5e530$var$newIndex !== $695b3d6025d5e530$var$oldIndex) {
                        if ($695b3d6025d5e530$var$newIndex >= 0) {
                            // drag & drop within the same list
                            $695b3d6025d5e530$var$_dispatchEvent({
                                sortable: this,
                                name: "update",
                                toEl: $695b3d6025d5e530$var$parentEl,
                                originalEvent: evt
                            });
                            $695b3d6025d5e530$var$_dispatchEvent({
                                sortable: this,
                                name: "sort",
                                toEl: $695b3d6025d5e530$var$parentEl,
                                originalEvent: evt
                            });
                        }
                    }
                }
                if ($695b3d6025d5e530$export$31b3ca70d8f57423.active) {
                    /* jshint eqnull:true */ if ($695b3d6025d5e530$var$newIndex == null || $695b3d6025d5e530$var$newIndex === -1) {
                        $695b3d6025d5e530$var$newIndex = $695b3d6025d5e530$var$oldIndex;
                        $695b3d6025d5e530$var$newDraggableIndex = $695b3d6025d5e530$var$oldDraggableIndex;
                    }
                    $695b3d6025d5e530$var$_dispatchEvent({
                        sortable: this,
                        name: "end",
                        toEl: $695b3d6025d5e530$var$parentEl,
                        originalEvent: evt
                    });
                    // Save sorting
                    this.save();
                }
            }
        }
        this._nulling();
    },
    _nulling: function _nulling() {
        $695b3d6025d5e530$var$pluginEvent("nulling", this);
        $695b3d6025d5e530$var$rootEl = $695b3d6025d5e530$var$dragEl = $695b3d6025d5e530$var$parentEl = $695b3d6025d5e530$var$ghostEl = $695b3d6025d5e530$var$nextEl = $695b3d6025d5e530$var$cloneEl = $695b3d6025d5e530$var$lastDownEl = $695b3d6025d5e530$var$cloneHidden = $695b3d6025d5e530$var$tapEvt = $695b3d6025d5e530$var$touchEvt = $695b3d6025d5e530$var$moved = $695b3d6025d5e530$var$newIndex = $695b3d6025d5e530$var$newDraggableIndex = $695b3d6025d5e530$var$oldIndex = $695b3d6025d5e530$var$oldDraggableIndex = $695b3d6025d5e530$var$lastTarget = $695b3d6025d5e530$var$lastDirection = $695b3d6025d5e530$var$putSortable = $695b3d6025d5e530$var$activeGroup = $695b3d6025d5e530$export$31b3ca70d8f57423.dragged = $695b3d6025d5e530$export$31b3ca70d8f57423.ghost = $695b3d6025d5e530$export$31b3ca70d8f57423.clone = $695b3d6025d5e530$export$31b3ca70d8f57423.active = null;
        $695b3d6025d5e530$var$savedInputChecked.forEach(function(el) {
            el.checked = true;
        });
        $695b3d6025d5e530$var$savedInputChecked.length = $695b3d6025d5e530$var$lastDx = $695b3d6025d5e530$var$lastDy = 0;
    },
    handleEvent: function handleEvent(/**Event*/ evt) {
        switch(evt.type){
            case "drop":
            case "dragend":
                this._onDrop(evt);
                break;
            case "dragenter":
            case "dragover":
                if ($695b3d6025d5e530$var$dragEl) {
                    this._onDragOver(evt);
                    $695b3d6025d5e530$var$_globalDragOver(evt);
                }
                break;
            case "selectstart":
                evt.preventDefault();
                break;
        }
    },
    /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */ toArray: function toArray() {
        var order = [], el, children = this.el.children, i = 0, n = children.length, options = this.options;
        for(; i < n; i++){
            el = children[i];
            if ($695b3d6025d5e530$var$closest(el, options.draggable, this.el, false)) order.push(el.getAttribute(options.dataIdAttr) || $695b3d6025d5e530$var$_generateId(el));
        }
        return order;
    },
    /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */ sort: function sort(order, useAnimation) {
        var items = {}, rootEl = this.el;
        this.toArray().forEach(function(id, i) {
            var el = rootEl.children[i];
            if ($695b3d6025d5e530$var$closest(el, this.options.draggable, rootEl, false)) items[id] = el;
        }, this);
        useAnimation && this.captureAnimationState();
        order.forEach(function(id) {
            if (items[id]) {
                rootEl.removeChild(items[id]);
                rootEl.appendChild(items[id]);
            }
        });
        useAnimation && this.animateAll();
    },
    /**
   * Save the current sorting
   */ save: function save() {
        var store = this.options.store;
        store && store.set && store.set(this);
    },
    /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */ closest: function closest$1(el, selector) {
        return $695b3d6025d5e530$var$closest(el, selector || this.options.draggable, this.el, false);
    },
    /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */ option: function option(name, value) {
        var options = this.options;
        if (value === void 0) return options[name];
        else {
            var modifiedValue = $695b3d6025d5e530$var$PluginManager.modifyOption(this, name, value);
            if (typeof modifiedValue !== "undefined") options[name] = modifiedValue;
            else options[name] = value;
            if (name === "group") $695b3d6025d5e530$var$_prepareGroup(options);
        }
    },
    /**
   * Destroy
   */ destroy: function destroy() {
        $695b3d6025d5e530$var$pluginEvent("destroy", this);
        var el = this.el;
        el[$695b3d6025d5e530$var$expando] = null;
        $695b3d6025d5e530$var$off(el, "mousedown", this._onTapStart);
        $695b3d6025d5e530$var$off(el, "touchstart", this._onTapStart);
        $695b3d6025d5e530$var$off(el, "pointerdown", this._onTapStart);
        if (this.nativeDraggable) {
            $695b3d6025d5e530$var$off(el, "dragover", this);
            $695b3d6025d5e530$var$off(el, "dragenter", this);
        }
        // Remove draggable attributes
        Array.prototype.forEach.call(el.querySelectorAll("[draggable]"), function(el) {
            el.removeAttribute("draggable");
        });
        this._onDrop();
        this._disableDelayedDragEvents();
        $695b3d6025d5e530$var$sortables.splice($695b3d6025d5e530$var$sortables.indexOf(this.el), 1);
        this.el = el = null;
    },
    _hideClone: function _hideClone() {
        if (!$695b3d6025d5e530$var$cloneHidden) {
            $695b3d6025d5e530$var$pluginEvent("hideClone", this);
            if ($695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) return;
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$cloneEl, "display", "none");
            if (this.options.removeCloneOnHide && $695b3d6025d5e530$var$cloneEl.parentNode) $695b3d6025d5e530$var$cloneEl.parentNode.removeChild($695b3d6025d5e530$var$cloneEl);
            $695b3d6025d5e530$var$cloneHidden = true;
        }
    },
    _showClone: function _showClone(putSortable) {
        if (putSortable.lastPutMode !== "clone") {
            this._hideClone();
            return;
        }
        if ($695b3d6025d5e530$var$cloneHidden) {
            $695b3d6025d5e530$var$pluginEvent("showClone", this);
            if ($695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) return;
            // show clone at dragEl or original position
            if ($695b3d6025d5e530$var$dragEl.parentNode == $695b3d6025d5e530$var$rootEl && !this.options.group.revertClone) $695b3d6025d5e530$var$rootEl.insertBefore($695b3d6025d5e530$var$cloneEl, $695b3d6025d5e530$var$dragEl);
            else if ($695b3d6025d5e530$var$nextEl) $695b3d6025d5e530$var$rootEl.insertBefore($695b3d6025d5e530$var$cloneEl, $695b3d6025d5e530$var$nextEl);
            else $695b3d6025d5e530$var$rootEl.appendChild($695b3d6025d5e530$var$cloneEl);
            if (this.options.group.revertClone) this.animate($695b3d6025d5e530$var$dragEl, $695b3d6025d5e530$var$cloneEl);
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$cloneEl, "display", "");
            $695b3d6025d5e530$var$cloneHidden = false;
        }
    }
};
function $695b3d6025d5e530$var$_globalDragOver(/**Event*/ evt) {
    if (evt.dataTransfer) evt.dataTransfer.dropEffect = "move";
    evt.cancelable && evt.preventDefault();
}
function $695b3d6025d5e530$var$_onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
    var evt, sortable = fromEl[$695b3d6025d5e530$var$expando], onMoveFn = sortable.options.onMove, retVal;
    // Support for new CustomEvent feature
    if (window.CustomEvent && !$695b3d6025d5e530$var$IE11OrLess && !$695b3d6025d5e530$var$Edge) evt = new CustomEvent("move", {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent("Event");
        evt.initEvent("move", true, true);
    }
    evt.to = toEl;
    evt.from = fromEl;
    evt.dragged = dragEl;
    evt.draggedRect = dragRect;
    evt.related = targetEl || toEl;
    evt.relatedRect = targetRect || $695b3d6025d5e530$var$getRect(toEl);
    evt.willInsertAfter = willInsertAfter;
    evt.originalEvent = originalEvent;
    fromEl.dispatchEvent(evt);
    if (onMoveFn) retVal = onMoveFn.call(sortable, evt, originalEvent);
    return retVal;
}
function $695b3d6025d5e530$var$_disableDraggable(el) {
    el.draggable = false;
}
function $695b3d6025d5e530$var$_unsilent() {
    $695b3d6025d5e530$var$_silent = false;
}
function $695b3d6025d5e530$var$_ghostIsFirst(evt, vertical, sortable) {
    var firstElRect = $695b3d6025d5e530$var$getRect($695b3d6025d5e530$var$getChild(sortable.el, 0, sortable.options, true));
    var childContainingRect = $695b3d6025d5e530$var$getChildContainingRectFromElement(sortable.el, sortable.options, $695b3d6025d5e530$var$ghostEl);
    var spacer = 10;
    return vertical ? evt.clientX < childContainingRect.left - spacer || evt.clientY < firstElRect.top && evt.clientX < firstElRect.right : evt.clientY < childContainingRect.top - spacer || evt.clientY < firstElRect.bottom && evt.clientX < firstElRect.left;
}
function $695b3d6025d5e530$var$_ghostIsLast(evt, vertical, sortable) {
    var lastElRect = $695b3d6025d5e530$var$getRect($695b3d6025d5e530$var$lastChild(sortable.el, sortable.options.draggable));
    var childContainingRect = $695b3d6025d5e530$var$getChildContainingRectFromElement(sortable.el, sortable.options, $695b3d6025d5e530$var$ghostEl);
    var spacer = 10;
    return vertical ? evt.clientX > childContainingRect.right + spacer || evt.clientY > lastElRect.bottom && evt.clientX > lastElRect.left : evt.clientY > childContainingRect.bottom + spacer || evt.clientX > lastElRect.right && evt.clientY > lastElRect.top;
}
function $695b3d6025d5e530$var$_getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
    var mouseOnAxis = vertical ? evt.clientY : evt.clientX, targetLength = vertical ? targetRect.height : targetRect.width, targetS1 = vertical ? targetRect.top : targetRect.left, targetS2 = vertical ? targetRect.bottom : targetRect.right, invert = false;
    if (!invertSwap) {
        // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
        if (isLastTarget && $695b3d6025d5e530$var$targetMoveDistance < targetLength * swapThreshold) {
            // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
            // check if past first invert threshold on side opposite of lastDirection
            if (!$695b3d6025d5e530$var$pastFirstInvertThresh && ($695b3d6025d5e530$var$lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) // past first invert threshold, do not restrict inverted threshold to dragEl shadow
            $695b3d6025d5e530$var$pastFirstInvertThresh = true;
            if (!$695b3d6025d5e530$var$pastFirstInvertThresh) {
                // dragEl shadow (target move distance shadow)
                if ($695b3d6025d5e530$var$lastDirection === 1 ? mouseOnAxis < targetS1 + $695b3d6025d5e530$var$targetMoveDistance // over dragEl shadow
                 : mouseOnAxis > targetS2 - $695b3d6025d5e530$var$targetMoveDistance) return -$695b3d6025d5e530$var$lastDirection;
            } else invert = true;
        } else {
            // Regular
            if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) return $695b3d6025d5e530$var$_getInsertDirection(target);
        }
    }
    invert = invert || invertSwap;
    if (invert) {
        // Invert of regular
        if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
    return 0;
}
/**
 * Gets the direction dragEl must be swapped relative to target in order to make it
 * seem that dragEl has been "inserted" into that element's position
 * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
 * @return {Number}                   Direction dragEl must be swapped
 */ function $695b3d6025d5e530$var$_getInsertDirection(target) {
    if ($695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl) < $695b3d6025d5e530$var$index(target)) return 1;
    else return -1;
}
/**
 * Generate id
 * @param   {HTMLElement} el
 * @returns {String}
 * @private
 */ function $695b3d6025d5e530$var$_generateId(el) {
    var str = el.tagName + el.className + el.src + el.href + el.textContent, i = str.length, sum = 0;
    while(i--)sum += str.charCodeAt(i);
    return sum.toString(36);
}
function $695b3d6025d5e530$var$_saveInputCheckedState(root) {
    $695b3d6025d5e530$var$savedInputChecked.length = 0;
    var inputs = root.getElementsByTagName("input");
    var idx = inputs.length;
    while(idx--){
        var el = inputs[idx];
        el.checked && $695b3d6025d5e530$var$savedInputChecked.push(el);
    }
}
function $695b3d6025d5e530$var$_nextTick(fn) {
    return setTimeout(fn, 0);
}
function $695b3d6025d5e530$var$_cancelNextTick(id) {
    return clearTimeout(id);
}
// Fixed #973:
if ($695b3d6025d5e530$var$documentExists) $695b3d6025d5e530$var$on(document, "touchmove", function(evt) {
    if (($695b3d6025d5e530$export$31b3ca70d8f57423.active || $695b3d6025d5e530$var$awaitingDragStarted) && evt.cancelable) evt.preventDefault();
});
// Export utils
$695b3d6025d5e530$export$31b3ca70d8f57423.utils = {
    on: $695b3d6025d5e530$var$on,
    off: $695b3d6025d5e530$var$off,
    css: $695b3d6025d5e530$var$css,
    find: $695b3d6025d5e530$var$find,
    is: function is(el, selector) {
        return !!$695b3d6025d5e530$var$closest(el, selector, el, false);
    },
    extend: $695b3d6025d5e530$var$extend,
    throttle: $695b3d6025d5e530$var$throttle,
    closest: $695b3d6025d5e530$var$closest,
    toggleClass: $695b3d6025d5e530$var$toggleClass,
    clone: $695b3d6025d5e530$var$clone,
    index: $695b3d6025d5e530$var$index,
    nextTick: $695b3d6025d5e530$var$_nextTick,
    cancelNextTick: $695b3d6025d5e530$var$_cancelNextTick,
    detectDirection: $695b3d6025d5e530$var$_detectDirection,
    getChild: $695b3d6025d5e530$var$getChild
};
/**
 * Get the Sortable instance of an element
 * @param  {HTMLElement} element The element
 * @return {Sortable|undefined}         The instance of Sortable
 */ $695b3d6025d5e530$export$31b3ca70d8f57423.get = function(element) {
    return element[$695b3d6025d5e530$var$expando];
};
/**
 * Mount a plugin to Sortable
 * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
 */ $695b3d6025d5e530$export$31b3ca70d8f57423.mount = function() {
    for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
    if (plugins[0].constructor === Array) plugins = plugins[0];
    plugins.forEach(function(plugin) {
        if (!plugin.prototype || !plugin.prototype.constructor) throw "Sortable: Mounted plugin must be a constructor function, not ".concat(({}).toString.call(plugin));
        if (plugin.utils) $695b3d6025d5e530$export$31b3ca70d8f57423.utils = $695b3d6025d5e530$var$_objectSpread2($695b3d6025d5e530$var$_objectSpread2({}, $695b3d6025d5e530$export$31b3ca70d8f57423.utils), plugin.utils);
        $695b3d6025d5e530$var$PluginManager.mount(plugin);
    });
};
/**
 * Create sortable instance
 * @param {HTMLElement}  el
 * @param {Object}      [options]
 */ $695b3d6025d5e530$export$31b3ca70d8f57423.create = function(el, options) {
    return new $695b3d6025d5e530$export$31b3ca70d8f57423(el, options);
};
// Export
$695b3d6025d5e530$export$31b3ca70d8f57423.version = $695b3d6025d5e530$var$version;
var $695b3d6025d5e530$var$autoScrolls = [], $695b3d6025d5e530$var$scrollEl, $695b3d6025d5e530$var$scrollRootEl, $695b3d6025d5e530$var$scrolling = false, $695b3d6025d5e530$var$lastAutoScrollX, $695b3d6025d5e530$var$lastAutoScrollY, $695b3d6025d5e530$var$touchEvt$1, $695b3d6025d5e530$var$pointerElemChangedInterval;
function $695b3d6025d5e530$var$AutoScrollPlugin() {
    function AutoScroll() {
        this.defaults = {
            scroll: true,
            forceAutoScrollFallback: false,
            scrollSensitivity: 30,
            scrollSpeed: 10,
            bubbleScroll: true
        };
        // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === "_" && typeof this[fn] === "function") this[fn] = this[fn].bind(this);
    }
    AutoScroll.prototype = {
        dragStarted: function dragStarted(_ref) {
            var originalEvent = _ref.originalEvent;
            if (this.sortable.nativeDraggable) $695b3d6025d5e530$var$on(document, "dragover", this._handleAutoScroll);
            else {
                if (this.options.supportPointer) $695b3d6025d5e530$var$on(document, "pointermove", this._handleFallbackAutoScroll);
                else if (originalEvent.touches) $695b3d6025d5e530$var$on(document, "touchmove", this._handleFallbackAutoScroll);
                else $695b3d6025d5e530$var$on(document, "mousemove", this._handleFallbackAutoScroll);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref2) {
            var originalEvent = _ref2.originalEvent;
            // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
            if (!this.options.dragOverBubble && !originalEvent.rootEl) this._handleAutoScroll(originalEvent);
        },
        drop: function drop() {
            if (this.sortable.nativeDraggable) $695b3d6025d5e530$var$off(document, "dragover", this._handleAutoScroll);
            else {
                $695b3d6025d5e530$var$off(document, "pointermove", this._handleFallbackAutoScroll);
                $695b3d6025d5e530$var$off(document, "touchmove", this._handleFallbackAutoScroll);
                $695b3d6025d5e530$var$off(document, "mousemove", this._handleFallbackAutoScroll);
            }
            $695b3d6025d5e530$var$clearPointerElemChangedInterval();
            $695b3d6025d5e530$var$clearAutoScrolls();
            $695b3d6025d5e530$var$cancelThrottle();
        },
        nulling: function nulling() {
            $695b3d6025d5e530$var$touchEvt$1 = $695b3d6025d5e530$var$scrollRootEl = $695b3d6025d5e530$var$scrollEl = $695b3d6025d5e530$var$scrolling = $695b3d6025d5e530$var$pointerElemChangedInterval = $695b3d6025d5e530$var$lastAutoScrollX = $695b3d6025d5e530$var$lastAutoScrollY = null;
            $695b3d6025d5e530$var$autoScrolls.length = 0;
        },
        _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
            this._handleAutoScroll(evt, true);
        },
        _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
            var _this = this;
            var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, elem = document.elementFromPoint(x, y);
            $695b3d6025d5e530$var$touchEvt$1 = evt;
            // IE does not seem to have native autoscroll,
            // Edge's autoscroll seems too conditional,
            // MACOS Safari does not have autoscroll,
            // Firefox and Chrome are good
            if (fallback || this.options.forceAutoScrollFallback || $695b3d6025d5e530$var$Edge || $695b3d6025d5e530$var$IE11OrLess || $695b3d6025d5e530$var$Safari) {
                $695b3d6025d5e530$var$autoScroll(evt, this.options, elem, fallback);
                // Listener for pointer element change
                var ogElemScroller = $695b3d6025d5e530$var$getParentAutoScrollElement(elem, true);
                if ($695b3d6025d5e530$var$scrolling && (!$695b3d6025d5e530$var$pointerElemChangedInterval || x !== $695b3d6025d5e530$var$lastAutoScrollX || y !== $695b3d6025d5e530$var$lastAutoScrollY)) {
                    $695b3d6025d5e530$var$pointerElemChangedInterval && $695b3d6025d5e530$var$clearPointerElemChangedInterval();
                    // Detect for pointer elem change, emulating native DnD behaviour
                    $695b3d6025d5e530$var$pointerElemChangedInterval = setInterval(function() {
                        var newElem = $695b3d6025d5e530$var$getParentAutoScrollElement(document.elementFromPoint(x, y), true);
                        if (newElem !== ogElemScroller) {
                            ogElemScroller = newElem;
                            $695b3d6025d5e530$var$clearAutoScrolls();
                        }
                        $695b3d6025d5e530$var$autoScroll(evt, _this.options, newElem, fallback);
                    }, 10);
                    $695b3d6025d5e530$var$lastAutoScrollX = x;
                    $695b3d6025d5e530$var$lastAutoScrollY = y;
                }
            } else {
                // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
                if (!this.options.bubbleScroll || $695b3d6025d5e530$var$getParentAutoScrollElement(elem, true) === $695b3d6025d5e530$var$getWindowScrollingElement()) {
                    $695b3d6025d5e530$var$clearAutoScrolls();
                    return;
                }
                $695b3d6025d5e530$var$autoScroll(evt, this.options, $695b3d6025d5e530$var$getParentAutoScrollElement(elem, false), false);
            }
        }
    };
    return $695b3d6025d5e530$var$_extends(AutoScroll, {
        pluginName: "scroll",
        initializeByDefault: true
    });
}
function $695b3d6025d5e530$var$clearAutoScrolls() {
    $695b3d6025d5e530$var$autoScrolls.forEach(function(autoScroll) {
        clearInterval(autoScroll.pid);
    });
    $695b3d6025d5e530$var$autoScrolls = [];
}
function $695b3d6025d5e530$var$clearPointerElemChangedInterval() {
    clearInterval($695b3d6025d5e530$var$pointerElemChangedInterval);
}
var $695b3d6025d5e530$var$autoScroll = $695b3d6025d5e530$var$throttle(function(evt, options, rootEl, isFallback) {
    // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
    if (!options.scroll) return;
    var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, sens = options.scrollSensitivity, speed = options.scrollSpeed, winScroller = $695b3d6025d5e530$var$getWindowScrollingElement();
    var scrollThisInstance = false, scrollCustomFn;
    // New scroll root, set scrollEl
    if ($695b3d6025d5e530$var$scrollRootEl !== rootEl) {
        $695b3d6025d5e530$var$scrollRootEl = rootEl;
        $695b3d6025d5e530$var$clearAutoScrolls();
        $695b3d6025d5e530$var$scrollEl = options.scroll;
        scrollCustomFn = options.scrollFn;
        if ($695b3d6025d5e530$var$scrollEl === true) $695b3d6025d5e530$var$scrollEl = $695b3d6025d5e530$var$getParentAutoScrollElement(rootEl, true);
    }
    var layersOut = 0;
    var currentParent = $695b3d6025d5e530$var$scrollEl;
    do {
        var el = currentParent, rect = $695b3d6025d5e530$var$getRect(el), top = rect.top, bottom = rect.bottom, left = rect.left, right = rect.right, width = rect.width, height = rect.height, canScrollX = void 0, canScrollY = void 0, scrollWidth = el.scrollWidth, scrollHeight = el.scrollHeight, elCSS = $695b3d6025d5e530$var$css(el), scrollPosX = el.scrollLeft, scrollPosY = el.scrollTop;
        if (el === winScroller) {
            canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll" || elCSS.overflowX === "visible");
            canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll" || elCSS.overflowY === "visible");
        } else {
            canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll");
            canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll");
        }
        var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
        var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);
        if (!$695b3d6025d5e530$var$autoScrolls[layersOut]) {
            for(var i = 0; i <= layersOut; i++)if (!$695b3d6025d5e530$var$autoScrolls[i]) $695b3d6025d5e530$var$autoScrolls[i] = {};
        }
        if ($695b3d6025d5e530$var$autoScrolls[layersOut].vx != vx || $695b3d6025d5e530$var$autoScrolls[layersOut].vy != vy || $695b3d6025d5e530$var$autoScrolls[layersOut].el !== el) {
            $695b3d6025d5e530$var$autoScrolls[layersOut].el = el;
            $695b3d6025d5e530$var$autoScrolls[layersOut].vx = vx;
            $695b3d6025d5e530$var$autoScrolls[layersOut].vy = vy;
            clearInterval($695b3d6025d5e530$var$autoScrolls[layersOut].pid);
            if (vx != 0 || vy != 0) {
                scrollThisInstance = true;
                /* jshint loopfunc:true */ $695b3d6025d5e530$var$autoScrolls[layersOut].pid = setInterval((function() {
                    // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
                    if (isFallback && this.layer === 0) $695b3d6025d5e530$export$31b3ca70d8f57423.active._onTouchMove($695b3d6025d5e530$var$touchEvt$1); // To move ghost if it is positioned absolutely
                    var scrollOffsetY = $695b3d6025d5e530$var$autoScrolls[this.layer].vy ? $695b3d6025d5e530$var$autoScrolls[this.layer].vy * speed : 0;
                    var scrollOffsetX = $695b3d6025d5e530$var$autoScrolls[this.layer].vx ? $695b3d6025d5e530$var$autoScrolls[this.layer].vx * speed : 0;
                    if (typeof scrollCustomFn === "function") {
                        if (scrollCustomFn.call($695b3d6025d5e530$export$31b3ca70d8f57423.dragged.parentNode[$695b3d6025d5e530$var$expando], scrollOffsetX, scrollOffsetY, evt, $695b3d6025d5e530$var$touchEvt$1, $695b3d6025d5e530$var$autoScrolls[this.layer].el) !== "continue") return;
                    }
                    $695b3d6025d5e530$var$scrollBy($695b3d6025d5e530$var$autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
                }).bind({
                    layer: layersOut
                }), 24);
            }
        }
        layersOut++;
    }while (options.bubbleScroll && currentParent !== winScroller && (currentParent = $695b3d6025d5e530$var$getParentAutoScrollElement(currentParent, false)));
    $695b3d6025d5e530$var$scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
}, 30);
var $695b3d6025d5e530$var$drop = function drop(_ref) {
    var originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, dragEl = _ref.dragEl, activeSortable = _ref.activeSortable, dispatchSortableEvent = _ref.dispatchSortableEvent, hideGhostForTarget = _ref.hideGhostForTarget, unhideGhostForTarget = _ref.unhideGhostForTarget;
    if (!originalEvent) return;
    var toSortable = putSortable || activeSortable;
    hideGhostForTarget();
    var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
    var target = document.elementFromPoint(touch.clientX, touch.clientY);
    unhideGhostForTarget();
    if (toSortable && !toSortable.el.contains(target)) {
        dispatchSortableEvent("spill");
        this.onSpill({
            dragEl: dragEl,
            putSortable: putSortable
        });
    }
};
function $695b3d6025d5e530$var$Revert() {}
$695b3d6025d5e530$var$Revert.prototype = {
    startIndex: null,
    dragStart: function dragStart(_ref2) {
        var oldDraggableIndex = _ref2.oldDraggableIndex;
        this.startIndex = oldDraggableIndex;
    },
    onSpill: function onSpill(_ref3) {
        var dragEl = _ref3.dragEl, putSortable = _ref3.putSortable;
        this.sortable.captureAnimationState();
        if (putSortable) putSortable.captureAnimationState();
        var nextSibling = $695b3d6025d5e530$var$getChild(this.sortable.el, this.startIndex, this.options);
        if (nextSibling) this.sortable.el.insertBefore(dragEl, nextSibling);
        else this.sortable.el.appendChild(dragEl);
        this.sortable.animateAll();
        if (putSortable) putSortable.animateAll();
    },
    drop: $695b3d6025d5e530$var$drop
};
$695b3d6025d5e530$var$_extends($695b3d6025d5e530$var$Revert, {
    pluginName: "revertOnSpill"
});
function $695b3d6025d5e530$var$Remove() {}
$695b3d6025d5e530$var$Remove.prototype = {
    onSpill: function onSpill(_ref4) {
        var dragEl = _ref4.dragEl, putSortable = _ref4.putSortable;
        var parentSortable = putSortable || this.sortable;
        parentSortable.captureAnimationState();
        dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
        parentSortable.animateAll();
    },
    drop: $695b3d6025d5e530$var$drop
};
$695b3d6025d5e530$var$_extends($695b3d6025d5e530$var$Remove, {
    pluginName: "removeOnSpill"
});
var $695b3d6025d5e530$var$lastSwapEl;
function $695b3d6025d5e530$export$bdb5f0a1b77546f4() {
    function Swap() {
        this.defaults = {
            swapClass: "sortable-swap-highlight"
        };
    }
    Swap.prototype = {
        dragStart: function dragStart(_ref) {
            var dragEl = _ref.dragEl;
            $695b3d6025d5e530$var$lastSwapEl = dragEl;
        },
        dragOverValid: function dragOverValid(_ref2) {
            var completed = _ref2.completed, target = _ref2.target, onMove = _ref2.onMove, activeSortable = _ref2.activeSortable, changed = _ref2.changed, cancel = _ref2.cancel;
            if (!activeSortable.options.swap) return;
            var el = this.sortable.el, options = this.options;
            if (target && target !== el) {
                var prevSwapEl = $695b3d6025d5e530$var$lastSwapEl;
                if (onMove(target) !== false) {
                    $695b3d6025d5e530$var$toggleClass(target, options.swapClass, true);
                    $695b3d6025d5e530$var$lastSwapEl = target;
                } else $695b3d6025d5e530$var$lastSwapEl = null;
                if (prevSwapEl && prevSwapEl !== $695b3d6025d5e530$var$lastSwapEl) $695b3d6025d5e530$var$toggleClass(prevSwapEl, options.swapClass, false);
            }
            changed();
            completed(true);
            cancel();
        },
        drop: function drop(_ref3) {
            var activeSortable = _ref3.activeSortable, putSortable = _ref3.putSortable, dragEl = _ref3.dragEl;
            var toSortable = putSortable || this.sortable;
            var options = this.options;
            $695b3d6025d5e530$var$lastSwapEl && $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$lastSwapEl, options.swapClass, false);
            if ($695b3d6025d5e530$var$lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
                if (dragEl !== $695b3d6025d5e530$var$lastSwapEl) {
                    toSortable.captureAnimationState();
                    if (toSortable !== activeSortable) activeSortable.captureAnimationState();
                    $695b3d6025d5e530$var$swapNodes(dragEl, $695b3d6025d5e530$var$lastSwapEl);
                    toSortable.animateAll();
                    if (toSortable !== activeSortable) activeSortable.animateAll();
                }
            }
        },
        nulling: function nulling() {
            $695b3d6025d5e530$var$lastSwapEl = null;
        }
    };
    return $695b3d6025d5e530$var$_extends(Swap, {
        pluginName: "swap",
        eventProperties: function eventProperties() {
            return {
                swapItem: $695b3d6025d5e530$var$lastSwapEl
            };
        }
    });
}
function $695b3d6025d5e530$var$swapNodes(n1, n2) {
    var p1 = n1.parentNode, p2 = n2.parentNode, i1, i2;
    if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
    i1 = $695b3d6025d5e530$var$index(n1);
    i2 = $695b3d6025d5e530$var$index(n2);
    if (p1.isEqualNode(p2) && i1 < i2) i2++;
    p1.insertBefore(n2, p1.children[i1]);
    p2.insertBefore(n1, p2.children[i2]);
}
var $695b3d6025d5e530$var$multiDragElements = [], $695b3d6025d5e530$var$multiDragClones = [], $695b3d6025d5e530$var$lastMultiDragSelect, // for selection with modifier key down (SHIFT)
$695b3d6025d5e530$var$multiDragSortable, $695b3d6025d5e530$var$initialFolding = false, // Initial multi-drag fold when drag started
$695b3d6025d5e530$var$folding = false, // Folding any other time
$695b3d6025d5e530$var$dragStarted = false, $695b3d6025d5e530$var$dragEl$1, $695b3d6025d5e530$var$clonesFromRect, $695b3d6025d5e530$var$clonesHidden;
function $695b3d6025d5e530$export$18e5d2a5d1df842d() {
    function MultiDrag(sortable) {
        // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === "_" && typeof this[fn] === "function") this[fn] = this[fn].bind(this);
        if (!sortable.options.avoidImplicitDeselect) {
            if (sortable.options.supportPointer) $695b3d6025d5e530$var$on(document, "pointerup", this._deselectMultiDrag);
            else {
                $695b3d6025d5e530$var$on(document, "mouseup", this._deselectMultiDrag);
                $695b3d6025d5e530$var$on(document, "touchend", this._deselectMultiDrag);
            }
        }
        $695b3d6025d5e530$var$on(document, "keydown", this._checkKeyDown);
        $695b3d6025d5e530$var$on(document, "keyup", this._checkKeyUp);
        this.defaults = {
            selectedClass: "sortable-selected",
            multiDragKey: null,
            avoidImplicitDeselect: false,
            setData: function setData(dataTransfer, dragEl) {
                var data = "";
                if ($695b3d6025d5e530$var$multiDragElements.length && $695b3d6025d5e530$var$multiDragSortable === sortable) $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement, i) {
                    data += (!i ? "" : ", ") + multiDragElement.textContent;
                });
                else data = dragEl.textContent;
                dataTransfer.setData("Text", data);
            }
        };
    }
    MultiDrag.prototype = {
        multiDragKeyDown: false,
        isMultiDrag: false,
        delayStartGlobal: function delayStartGlobal(_ref) {
            var dragged = _ref.dragEl;
            $695b3d6025d5e530$var$dragEl$1 = dragged;
        },
        delayEnded: function delayEnded() {
            this.isMultiDrag = ~$695b3d6025d5e530$var$multiDragElements.indexOf($695b3d6025d5e530$var$dragEl$1);
        },
        setupClone: function setupClone(_ref2) {
            var sortable = _ref2.sortable, cancel = _ref2.cancel;
            if (!this.isMultiDrag) return;
            for(var i = 0; i < $695b3d6025d5e530$var$multiDragElements.length; i++){
                $695b3d6025d5e530$var$multiDragClones.push($695b3d6025d5e530$var$clone($695b3d6025d5e530$var$multiDragElements[i]));
                $695b3d6025d5e530$var$multiDragClones[i].sortableIndex = $695b3d6025d5e530$var$multiDragElements[i].sortableIndex;
                $695b3d6025d5e530$var$multiDragClones[i].draggable = false;
                $695b3d6025d5e530$var$multiDragClones[i].style["will-change"] = "";
                $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$multiDragClones[i], this.options.selectedClass, false);
                $695b3d6025d5e530$var$multiDragElements[i] === $695b3d6025d5e530$var$dragEl$1 && $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$multiDragClones[i], this.options.chosenClass, false);
            }
            sortable._hideClone();
            cancel();
        },
        clone: function clone(_ref3) {
            var sortable = _ref3.sortable, rootEl = _ref3.rootEl, dispatchSortableEvent = _ref3.dispatchSortableEvent, cancel = _ref3.cancel;
            if (!this.isMultiDrag) return;
            if (!this.options.removeCloneOnHide) {
                if ($695b3d6025d5e530$var$multiDragElements.length && $695b3d6025d5e530$var$multiDragSortable === sortable) {
                    $695b3d6025d5e530$var$insertMultiDragClones(true, rootEl);
                    dispatchSortableEvent("clone");
                    cancel();
                }
            }
        },
        showClone: function showClone(_ref4) {
            var cloneNowShown = _ref4.cloneNowShown, rootEl = _ref4.rootEl, cancel = _ref4.cancel;
            if (!this.isMultiDrag) return;
            $695b3d6025d5e530$var$insertMultiDragClones(false, rootEl);
            $695b3d6025d5e530$var$multiDragClones.forEach(function(clone) {
                $695b3d6025d5e530$var$css(clone, "display", "");
            });
            cloneNowShown();
            $695b3d6025d5e530$var$clonesHidden = false;
            cancel();
        },
        hideClone: function hideClone(_ref5) {
            var _this = this;
            var sortable = _ref5.sortable, cloneNowHidden = _ref5.cloneNowHidden, cancel = _ref5.cancel;
            if (!this.isMultiDrag) return;
            $695b3d6025d5e530$var$multiDragClones.forEach(function(clone) {
                $695b3d6025d5e530$var$css(clone, "display", "none");
                if (_this.options.removeCloneOnHide && clone.parentNode) clone.parentNode.removeChild(clone);
            });
            cloneNowHidden();
            $695b3d6025d5e530$var$clonesHidden = true;
            cancel();
        },
        dragStartGlobal: function dragStartGlobal(_ref6) {
            var sortable = _ref6.sortable;
            if (!this.isMultiDrag && $695b3d6025d5e530$var$multiDragSortable) $695b3d6025d5e530$var$multiDragSortable.multiDrag._deselectMultiDrag();
            $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.sortableIndex = $695b3d6025d5e530$var$index(multiDragElement);
            });
            // Sort multi-drag elements
            $695b3d6025d5e530$var$multiDragElements = $695b3d6025d5e530$var$multiDragElements.sort(function(a, b) {
                return a.sortableIndex - b.sortableIndex;
            });
            $695b3d6025d5e530$var$dragStarted = true;
        },
        dragStarted: function dragStarted(_ref7) {
            var _this2 = this;
            var sortable = _ref7.sortable;
            if (!this.isMultiDrag) return;
            if (this.options.sort) {
                // Capture rects,
                // hide multi drag elements (by positioning them absolute),
                // set multi drag elements rects to dragRect,
                // show multi drag elements,
                // animate to rects,
                // unset rects & remove from DOM
                sortable.captureAnimationState();
                if (this.options.animation) {
                    $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $695b3d6025d5e530$var$dragEl$1) return;
                        $695b3d6025d5e530$var$css(multiDragElement, "position", "absolute");
                    });
                    var dragRect = $695b3d6025d5e530$var$getRect($695b3d6025d5e530$var$dragEl$1, false, true, true);
                    $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $695b3d6025d5e530$var$dragEl$1) return;
                        $695b3d6025d5e530$var$setRect(multiDragElement, dragRect);
                    });
                    $695b3d6025d5e530$var$folding = true;
                    $695b3d6025d5e530$var$initialFolding = true;
                }
            }
            sortable.animateAll(function() {
                $695b3d6025d5e530$var$folding = false;
                $695b3d6025d5e530$var$initialFolding = false;
                if (_this2.options.animation) $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                    $695b3d6025d5e530$var$unsetRect(multiDragElement);
                });
                // Remove all auxiliary multidrag items from el, if sorting enabled
                if (_this2.options.sort) $695b3d6025d5e530$var$removeMultiDragElements();
            });
        },
        dragOver: function dragOver(_ref8) {
            var target = _ref8.target, completed = _ref8.completed, cancel = _ref8.cancel;
            if ($695b3d6025d5e530$var$folding && ~$695b3d6025d5e530$var$multiDragElements.indexOf(target)) {
                completed(false);
                cancel();
            }
        },
        revert: function revert(_ref9) {
            var fromSortable = _ref9.fromSortable, rootEl = _ref9.rootEl, sortable = _ref9.sortable, dragRect = _ref9.dragRect;
            if ($695b3d6025d5e530$var$multiDragElements.length > 1) {
                // Setup unfold animation
                $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                    sortable.addAnimationState({
                        target: multiDragElement,
                        rect: $695b3d6025d5e530$var$folding ? $695b3d6025d5e530$var$getRect(multiDragElement) : dragRect
                    });
                    $695b3d6025d5e530$var$unsetRect(multiDragElement);
                    multiDragElement.fromRect = dragRect;
                    fromSortable.removeAnimationState(multiDragElement);
                });
                $695b3d6025d5e530$var$folding = false;
                $695b3d6025d5e530$var$insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref10) {
            var sortable = _ref10.sortable, isOwner = _ref10.isOwner, insertion = _ref10.insertion, activeSortable = _ref10.activeSortable, parentEl = _ref10.parentEl, putSortable = _ref10.putSortable;
            var options = this.options;
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                $695b3d6025d5e530$var$initialFolding = false;
                // If leaving sort:false root, or already folding - Fold to new location
                if (options.animation && $695b3d6025d5e530$var$multiDragElements.length > 1 && ($695b3d6025d5e530$var$folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
                    // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
                    var dragRectAbsolute = $695b3d6025d5e530$var$getRect($695b3d6025d5e530$var$dragEl$1, false, true, true);
                    $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $695b3d6025d5e530$var$dragEl$1) return;
                        $695b3d6025d5e530$var$setRect(multiDragElement, dragRectAbsolute);
                        // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
                        // while folding, and so that we can capture them again because old sortable will no longer be fromSortable
                        parentEl.appendChild(multiDragElement);
                    });
                    $695b3d6025d5e530$var$folding = true;
                }
                // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out
                if (!isOwner) {
                    // Only remove if not folding (folding will remove them anyways)
                    if (!$695b3d6025d5e530$var$folding) $695b3d6025d5e530$var$removeMultiDragElements();
                    if ($695b3d6025d5e530$var$multiDragElements.length > 1) {
                        var clonesHiddenBefore = $695b3d6025d5e530$var$clonesHidden;
                        activeSortable._showClone(sortable);
                        // Unfold animation for clones if showing from hidden
                        if (activeSortable.options.animation && !$695b3d6025d5e530$var$clonesHidden && clonesHiddenBefore) $695b3d6025d5e530$var$multiDragClones.forEach(function(clone) {
                            activeSortable.addAnimationState({
                                target: clone,
                                rect: $695b3d6025d5e530$var$clonesFromRect
                            });
                            clone.fromRect = $695b3d6025d5e530$var$clonesFromRect;
                            clone.thisAnimationDuration = null;
                        });
                    } else activeSortable._showClone(sortable);
                }
            }
        },
        dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
            var dragRect = _ref11.dragRect, isOwner = _ref11.isOwner, activeSortable = _ref11.activeSortable;
            $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.thisAnimationDuration = null;
            });
            if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
                $695b3d6025d5e530$var$clonesFromRect = $695b3d6025d5e530$var$_extends({}, dragRect);
                var dragMatrix = $695b3d6025d5e530$var$matrix($695b3d6025d5e530$var$dragEl$1, true);
                $695b3d6025d5e530$var$clonesFromRect.top -= dragMatrix.f;
                $695b3d6025d5e530$var$clonesFromRect.left -= dragMatrix.e;
            }
        },
        dragOverAnimationComplete: function dragOverAnimationComplete() {
            if ($695b3d6025d5e530$var$folding) {
                $695b3d6025d5e530$var$folding = false;
                $695b3d6025d5e530$var$removeMultiDragElements();
            }
        },
        drop: function drop(_ref12) {
            var evt = _ref12.originalEvent, rootEl = _ref12.rootEl, parentEl = _ref12.parentEl, sortable = _ref12.sortable, dispatchSortableEvent = _ref12.dispatchSortableEvent, oldIndex = _ref12.oldIndex, putSortable = _ref12.putSortable;
            var toSortable = putSortable || this.sortable;
            if (!evt) return;
            var options = this.options, children = parentEl.children;
            // Multi-drag selection
            if (!$695b3d6025d5e530$var$dragStarted) {
                if (options.multiDragKey && !this.multiDragKeyDown) this._deselectMultiDrag();
                $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$dragEl$1, options.selectedClass, !~$695b3d6025d5e530$var$multiDragElements.indexOf($695b3d6025d5e530$var$dragEl$1));
                if (!~$695b3d6025d5e530$var$multiDragElements.indexOf($695b3d6025d5e530$var$dragEl$1)) {
                    $695b3d6025d5e530$var$multiDragElements.push($695b3d6025d5e530$var$dragEl$1);
                    $695b3d6025d5e530$var$dispatchEvent({
                        sortable: sortable,
                        rootEl: rootEl,
                        name: "select",
                        targetEl: $695b3d6025d5e530$var$dragEl$1,
                        originalEvent: evt
                    });
                    // Modifier activated, select from last to dragEl
                    if (evt.shiftKey && $695b3d6025d5e530$var$lastMultiDragSelect && sortable.el.contains($695b3d6025d5e530$var$lastMultiDragSelect)) {
                        var lastIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$lastMultiDragSelect), currentIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl$1);
                        if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
                            // Must include lastMultiDragSelect (select it), in case modified selection from no selection
                            // (but previous selection existed)
                            var n, i;
                            if (currentIndex > lastIndex) {
                                i = lastIndex;
                                n = currentIndex;
                            } else {
                                i = currentIndex;
                                n = lastIndex + 1;
                            }
                            for(; i < n; i++){
                                if (~$695b3d6025d5e530$var$multiDragElements.indexOf(children[i])) continue;
                                $695b3d6025d5e530$var$toggleClass(children[i], options.selectedClass, true);
                                $695b3d6025d5e530$var$multiDragElements.push(children[i]);
                                $695b3d6025d5e530$var$dispatchEvent({
                                    sortable: sortable,
                                    rootEl: rootEl,
                                    name: "select",
                                    targetEl: children[i],
                                    originalEvent: evt
                                });
                            }
                        }
                    } else $695b3d6025d5e530$var$lastMultiDragSelect = $695b3d6025d5e530$var$dragEl$1;
                    $695b3d6025d5e530$var$multiDragSortable = toSortable;
                } else {
                    $695b3d6025d5e530$var$multiDragElements.splice($695b3d6025d5e530$var$multiDragElements.indexOf($695b3d6025d5e530$var$dragEl$1), 1);
                    $695b3d6025d5e530$var$lastMultiDragSelect = null;
                    $695b3d6025d5e530$var$dispatchEvent({
                        sortable: sortable,
                        rootEl: rootEl,
                        name: "deselect",
                        targetEl: $695b3d6025d5e530$var$dragEl$1,
                        originalEvent: evt
                    });
                }
            }
            // Multi-drag drop
            if ($695b3d6025d5e530$var$dragStarted && this.isMultiDrag) {
                $695b3d6025d5e530$var$folding = false;
                // Do not "unfold" after around dragEl if reverted
                if ((parentEl[$695b3d6025d5e530$var$expando].options.sort || parentEl !== rootEl) && $695b3d6025d5e530$var$multiDragElements.length > 1) {
                    var dragRect = $695b3d6025d5e530$var$getRect($695b3d6025d5e530$var$dragEl$1), multiDragIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl$1, ":not(." + this.options.selectedClass + ")");
                    if (!$695b3d6025d5e530$var$initialFolding && options.animation) $695b3d6025d5e530$var$dragEl$1.thisAnimationDuration = null;
                    toSortable.captureAnimationState();
                    if (!$695b3d6025d5e530$var$initialFolding) {
                        if (options.animation) {
                            $695b3d6025d5e530$var$dragEl$1.fromRect = dragRect;
                            $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                                multiDragElement.thisAnimationDuration = null;
                                if (multiDragElement !== $695b3d6025d5e530$var$dragEl$1) {
                                    var rect = $695b3d6025d5e530$var$folding ? $695b3d6025d5e530$var$getRect(multiDragElement) : dragRect;
                                    multiDragElement.fromRect = rect;
                                    // Prepare unfold animation
                                    toSortable.addAnimationState({
                                        target: multiDragElement,
                                        rect: rect
                                    });
                                }
                            });
                        }
                        // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
                        // properly they must all be removed
                        $695b3d6025d5e530$var$removeMultiDragElements();
                        $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                            if (children[multiDragIndex]) parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
                            else parentEl.appendChild(multiDragElement);
                            multiDragIndex++;
                        });
                        // If initial folding is done, the elements may have changed position because they are now
                        // unfolding around dragEl, even though dragEl may not have his index changed, so update event
                        // must be fired here as Sortable will not.
                        if (oldIndex === $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl$1)) {
                            var update = false;
                            $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                                if (multiDragElement.sortableIndex !== $695b3d6025d5e530$var$index(multiDragElement)) {
                                    update = true;
                                    return;
                                }
                            });
                            if (update) {
                                dispatchSortableEvent("update");
                                dispatchSortableEvent("sort");
                            }
                        }
                    }
                    // Must be done after capturing individual rects (scroll bar)
                    $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                        $695b3d6025d5e530$var$unsetRect(multiDragElement);
                    });
                    toSortable.animateAll();
                }
                $695b3d6025d5e530$var$multiDragSortable = toSortable;
            }
            // Remove clones if necessary
            if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== "clone") $695b3d6025d5e530$var$multiDragClones.forEach(function(clone) {
                clone.parentNode && clone.parentNode.removeChild(clone);
            });
        },
        nullingGlobal: function nullingGlobal() {
            this.isMultiDrag = $695b3d6025d5e530$var$dragStarted = false;
            $695b3d6025d5e530$var$multiDragClones.length = 0;
        },
        destroyGlobal: function destroyGlobal() {
            this._deselectMultiDrag();
            $695b3d6025d5e530$var$off(document, "pointerup", this._deselectMultiDrag);
            $695b3d6025d5e530$var$off(document, "mouseup", this._deselectMultiDrag);
            $695b3d6025d5e530$var$off(document, "touchend", this._deselectMultiDrag);
            $695b3d6025d5e530$var$off(document, "keydown", this._checkKeyDown);
            $695b3d6025d5e530$var$off(document, "keyup", this._checkKeyUp);
        },
        _deselectMultiDrag: function _deselectMultiDrag(evt) {
            if (typeof $695b3d6025d5e530$var$dragStarted !== "undefined" && $695b3d6025d5e530$var$dragStarted) return;
            // Only deselect if selection is in this sortable
            if ($695b3d6025d5e530$var$multiDragSortable !== this.sortable) return;
            // Only deselect if target is not item in this sortable
            if (evt && $695b3d6025d5e530$var$closest(evt.target, this.options.draggable, this.sortable.el, false)) return;
            // Only deselect if left click
            if (evt && evt.button !== 0) return;
            while($695b3d6025d5e530$var$multiDragElements.length){
                var el = $695b3d6025d5e530$var$multiDragElements[0];
                $695b3d6025d5e530$var$toggleClass(el, this.options.selectedClass, false);
                $695b3d6025d5e530$var$multiDragElements.shift();
                $695b3d6025d5e530$var$dispatchEvent({
                    sortable: this.sortable,
                    rootEl: this.sortable.el,
                    name: "deselect",
                    targetEl: el,
                    originalEvent: evt
                });
            }
        },
        _checkKeyDown: function _checkKeyDown(evt) {
            if (evt.key === this.options.multiDragKey) this.multiDragKeyDown = true;
        },
        _checkKeyUp: function _checkKeyUp(evt) {
            if (evt.key === this.options.multiDragKey) this.multiDragKeyDown = false;
        }
    };
    return $695b3d6025d5e530$var$_extends(MultiDrag, {
        // Static methods & properties
        pluginName: "multiDrag",
        utils: {
            /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */ select: function select(el) {
                var sortable = el.parentNode[$695b3d6025d5e530$var$expando];
                if (!sortable || !sortable.options.multiDrag || ~$695b3d6025d5e530$var$multiDragElements.indexOf(el)) return;
                if ($695b3d6025d5e530$var$multiDragSortable && $695b3d6025d5e530$var$multiDragSortable !== sortable) {
                    $695b3d6025d5e530$var$multiDragSortable.multiDrag._deselectMultiDrag();
                    $695b3d6025d5e530$var$multiDragSortable = sortable;
                }
                $695b3d6025d5e530$var$toggleClass(el, sortable.options.selectedClass, true);
                $695b3d6025d5e530$var$multiDragElements.push(el);
            },
            /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */ deselect: function deselect(el) {
                var sortable = el.parentNode[$695b3d6025d5e530$var$expando], index = $695b3d6025d5e530$var$multiDragElements.indexOf(el);
                if (!sortable || !sortable.options.multiDrag || !~index) return;
                $695b3d6025d5e530$var$toggleClass(el, sortable.options.selectedClass, false);
                $695b3d6025d5e530$var$multiDragElements.splice(index, 1);
            }
        },
        eventProperties: function eventProperties() {
            var _this3 = this;
            var oldIndicies = [], newIndicies = [];
            $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                oldIndicies.push({
                    multiDragElement: multiDragElement,
                    index: multiDragElement.sortableIndex
                });
                // multiDragElements will already be sorted if folding
                var newIndex;
                if ($695b3d6025d5e530$var$folding && multiDragElement !== $695b3d6025d5e530$var$dragEl$1) newIndex = -1;
                else if ($695b3d6025d5e530$var$folding) newIndex = $695b3d6025d5e530$var$index(multiDragElement, ":not(." + _this3.options.selectedClass + ")");
                else newIndex = $695b3d6025d5e530$var$index(multiDragElement);
                newIndicies.push({
                    multiDragElement: multiDragElement,
                    index: newIndex
                });
            });
            return {
                items: $695b3d6025d5e530$var$_toConsumableArray($695b3d6025d5e530$var$multiDragElements),
                clones: [].concat($695b3d6025d5e530$var$multiDragClones),
                oldIndicies: oldIndicies,
                newIndicies: newIndicies
            };
        },
        optionListeners: {
            multiDragKey: function multiDragKey(key) {
                key = key.toLowerCase();
                if (key === "ctrl") key = "Control";
                else if (key.length > 1) key = key.charAt(0).toUpperCase() + key.substr(1);
                return key;
            }
        }
    });
}
function $695b3d6025d5e530$var$insertMultiDragElements(clonesInserted, rootEl) {
    $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement, i) {
        var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];
        if (target) rootEl.insertBefore(multiDragElement, target);
        else rootEl.appendChild(multiDragElement);
    });
}
/**
 * Insert multi-drag clones
 * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
 * @param  {HTMLElement} rootEl
 */ function $695b3d6025d5e530$var$insertMultiDragClones(elementsInserted, rootEl) {
    $695b3d6025d5e530$var$multiDragClones.forEach(function(clone, i) {
        var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];
        if (target) rootEl.insertBefore(clone, target);
        else rootEl.appendChild(clone);
    });
}
function $695b3d6025d5e530$var$removeMultiDragElements() {
    $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
        if (multiDragElement === $695b3d6025d5e530$var$dragEl$1) return;
        multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
    });
}
$695b3d6025d5e530$export$31b3ca70d8f57423.mount(new $695b3d6025d5e530$var$AutoScrollPlugin());
$695b3d6025d5e530$export$31b3ca70d8f57423.mount($695b3d6025d5e530$var$Remove, $695b3d6025d5e530$var$Revert);
var $695b3d6025d5e530$export$2e2bcd8739ae039 = $695b3d6025d5e530$export$31b3ca70d8f57423;

});

parcelRegister("gPDkX", function(module, exports) {
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString === Object.prototype.toString) {
                    for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
                } else classes.push(arg.toString());
            }
        }
        return classes.join(" ");
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("lykbf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $fb0c6d61f86ba934$export$2e2bcd8739ae039);
var $fb0c6d61f86ba934$var$isProduction = true;
var $fb0c6d61f86ba934$var$prefix = "Invariant failed";
function $fb0c6d61f86ba934$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($fb0c6d61f86ba934$var$isProduction) throw new Error($fb0c6d61f86ba934$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? $fb0c6d61f86ba934$var$prefix + ": " + provided : $fb0c6d61f86ba934$var$prefix;
    throw new Error(value);
}

});



parcelRegister("ekVtW", function(module, exports) {
"use strict";
var $a6ff85a3001e30a5$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.ImageClipPanel = void 0;

const $a6ff85a3001e30a5$var$react_1 = $a6ff85a3001e30a5$var$__importDefault((parcelRequire("8NFma")));

var $gUePa = parcelRequire("gUePa");

var $lP8NJ = parcelRequire("lP8NJ");
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

var $eRKBF = parcelRequire("eRKBF");

var $eRGXT = parcelRequire("eRGXT");

var $jkJqh = parcelRequire("jkJqh");

const $a6ff85a3001e30a5$var$styled_1 = $a6ff85a3001e30a5$var$__importDefault((parcelRequire("MPenY")));

var $xARwM = parcelRequire("xARwM");
const $a6ff85a3001e30a5$var$FIGURE_DEFAULTS = {
    width: 300,
    height: 300,
    fill: "lightgray",
    stroke: "#0c0c0c",
    strokeWidth: 0,
    url: ""
}, $a6ff85a3001e30a5$var$subTypes = Object.keys($jkJqh.TYPES), $a6ff85a3001e30a5$var$DEFAULTS = [
    $a6ff85a3001e30a5$var$FIGURE_DEFAULTS
], $a6ff85a3001e30a5$var$FIGURES = [];
$a6ff85a3001e30a5$var$subTypes.forEach((e)=>{
    $a6ff85a3001e30a5$var$DEFAULTS.forEach((t)=>{
        $a6ff85a3001e30a5$var$FIGURES.push(Object.assign({
            subType: e
        }, t));
    });
}), $a6ff85a3001e30a5$var$FIGURES.forEach((e)=>{
    e.url = (0, $eRGXT.svgToURL)((0, $jkJqh.figureToSvg)(e));
});
const $a6ff85a3001e30a5$var$BasicShapesContainer = (0, $a6ff85a3001e30a5$var$styled_1.default)("div")`
  height: 220px;
`;
module.exports.ImageClipPanel = (0, $O1ETn.observer)(({ store: e })=>{
    const t = Math.ceil($a6ff85a3001e30a5$var$FIGURES.length / 4) || 1, r = ()=>e.selectedElements.map((e)=>e.id).join(","), i = $a6ff85a3001e30a5$var$react_1.default.useMemo(r, []), l = r();
    return $a6ff85a3001e30a5$var$react_1.default.useEffect(()=>{
        i !== l && e.openSidePanel(e.previousOpenedSidePanel);
    }, [
        i,
        l
    ]), $a6ff85a3001e30a5$var$react_1.default.createElement("div", {
        style: {
            height: "100%",
            display: "flex",
            flexDirection: "column",
            overflow: "auto"
        }
    }, $a6ff85a3001e30a5$var$react_1.default.createElement("div", {
        style: {
            display: "flex",
            justifyContent: "space-between"
        }
    }, $a6ff85a3001e30a5$var$react_1.default.createElement("h3", null, (0, $xARwM.t)("sidePanel.clipImage")), $a6ff85a3001e30a5$var$react_1.default.createElement($gUePa.Button, {
        minimal: !0,
        icon: $a6ff85a3001e30a5$var$react_1.default.createElement($lP8NJ.Cross, null),
        onClick: ()=>e.openSidePanel(e.previousOpenedSidePanel)
    })), $a6ff85a3001e30a5$var$react_1.default.createElement($a6ff85a3001e30a5$var$BasicShapesContainer, {
        style: {
            height: 110 * t + "px"
        }
    }, $a6ff85a3001e30a5$var$react_1.default.createElement($eRKBF.ImagesGrid, {
        shadowEnabled: !1,
        rowsNumber: 4,
        images: $a6ff85a3001e30a5$var$FIGURES,
        getPreview: (e)=>e.url,
        isLoading: !1,
        itemHeight: 100,
        onSelect: async (t, r, i)=>{
            (i = i || e.selectedElements[0]) && "image" === i.type && i.contentEditable && i.set({
                clipSrc: t.url
            });
        }
    })));
});

});


parcelRegister("7ZpWM", function(module, exports) {
"use strict";
var $5d125b797482ede1$var$__importDefault = module.exports && module.exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.ZoomButtons = module.exports.ZoomGroup = void 0;

const $5d125b797482ede1$var$react_1 = $5d125b797482ede1$var$__importDefault((parcelRequire("8NFma")));

var $gUePa = parcelRequire("gUePa");
var $7RyvK = parcelRequire("7RyvK");
var $2IwH6 = parcelRequire("2IwH6");
var $f5Zeh = parcelRequire("f5Zeh");
var $ixLVk = parcelRequire("ixLVk");

var $gUePa = parcelRequire("gUePa");
var $7RyvK = parcelRequire("7RyvK");
var $2IwH6 = parcelRequire("2IwH6");
var $f5Zeh = parcelRequire("f5Zeh");
var $ixLVk = parcelRequire("ixLVk");

const $5d125b797482ede1$var$styled_1 = $5d125b797482ede1$var$__importDefault((parcelRequire("MPenY")));
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

var $xARwM = parcelRequire("xARwM");

var $3pcZ0 = parcelRequire("3pcZ0");
const $5d125b797482ede1$var$OuterContainer = (0, $5d125b797482ede1$var$styled_1.default)("div")`
  position: relative;
  height: 0px;
`, $5d125b797482ede1$var$Container = (0, $5d125b797482ede1$var$styled_1.default)("div")`
  position: absolute;
  bottom: 5px;
  width: auto;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0 0 4px lightgrey;

  ${(0, $3pcZ0.mobileStyle)("\n    display: none;\n  ")}
`, $5d125b797482ede1$var$FACTOR = 1.2, $5d125b797482ede1$var$SCALE_VARIATIONS = [
    .1,
    .25,
    .5,
    .75,
    1,
    1.5,
    2,
    3
], $5d125b797482ede1$var$MAX_SCALE = $5d125b797482ede1$var$SCALE_VARIATIONS[$5d125b797482ede1$var$SCALE_VARIATIONS.length - 1], $5d125b797482ede1$var$MIN_SCALE = $5d125b797482ede1$var$SCALE_VARIATIONS[0];
module.exports.ZoomGroup = (0, $O1ETn.observer)(({ store: e })=>{
    const t = Math.max($5d125b797482ede1$var$MAX_SCALE, e.scaleToFit), r = Math.min($5d125b797482ede1$var$MIN_SCALE, e.scaleToFit), o = e.scale < t, a = e.scale > r;
    return $5d125b797482ede1$var$react_1.default.createElement($f5Zeh.Navbar.Group, {
        style: {
            height: "35px"
        }
    }, $5d125b797482ede1$var$react_1.default.createElement($gUePa.Button, {
        icon: "zoom-out",
        minimal: !0,
        onClick: ()=>{
            e.setScale(e.scale / 1.2);
        },
        disabled: !a
    }), $5d125b797482ede1$var$react_1.default.createElement($ixLVk.Popover, {
        content: $5d125b797482ede1$var$react_1.default.createElement($7RyvK.Menu, {
            style: {
                minWidth: "80px"
            }
        }, $5d125b797482ede1$var$SCALE_VARIATIONS.map((t)=>$5d125b797482ede1$var$react_1.default.createElement($2IwH6.MenuItem, {
                key: t,
                text: Math.round(100 * t) + "%",
                onClick: async ()=>{
                    e.setScale(t);
                }
            })), $5d125b797482ede1$var$react_1.default.createElement($2IwH6.MenuItem, {
            text: (0, $xARwM.t)("scale.reset"),
            onClick: async ()=>{
                e.setScale(e.scaleToFit);
            }
        }))
    }, $5d125b797482ede1$var$react_1.default.createElement($gUePa.Button, {
        minimal: !0
    }, Math.round(100 * e.scale) + "%")), $5d125b797482ede1$var$react_1.default.createElement($gUePa.Button, {
        icon: "zoom-in",
        minimal: !0,
        onClick: ()=>{
            e.setScale(1.2 * e.scale);
        },
        disabled: !o
    }));
}), module.exports.ZoomButtons = (0, $O1ETn.observer)(({ store: e })=>$5d125b797482ede1$var$react_1.default.createElement($5d125b797482ede1$var$OuterContainer, null, $5d125b797482ede1$var$react_1.default.createElement($5d125b797482ede1$var$Container, null, $5d125b797482ede1$var$react_1.default.createElement($f5Zeh.Navbar, {
        style: {
            height: "35px",
            padding: "0 5px"
        }
    }, $5d125b797482ede1$var$react_1.default.createElement(module.exports.ZoomGroup, {
        store: e
    }))))), module.exports.default = module.exports.ZoomButtons;

});

var $b20cb9d3a2cf6ff5$exports = {};


(parcelRequire("kI8SP")).register((parcelRequire("hIarR")).getBundleURL("fpriy"), JSON.parse('["fpriy","index.js","6n2Xq","allPathsLoader.js","f3lb7","allPaths.js","lGiiH","paths.js","YXxaF","paths.3c7f064a.js","2WTgo","splitPathsBySizeLoader.js"]'));

var $13f4c0370d7de649$exports = {};
"use strict";

$13f4c0370d7de649$exports = (parcelRequire("89wqa"));


parcelRequire("8NFma");

var $6T1J1 = parcelRequire("6T1J1");

var $f96904d21a767aad$exports = {};
"use strict";
var $f96904d21a767aad$var$__createBinding = $f96904d21a767aad$exports && $f96904d21a767aad$exports.__createBinding || (Object.create ? function(e, t, o, r) {
    void 0 === r && (r = o);
    var a = Object.getOwnPropertyDescriptor(t, o);
    a && !("get" in a ? !t.__esModule : a.writable || a.configurable) || (a = {
        enumerable: !0,
        get: function() {
            return t[o];
        }
    }), Object.defineProperty(e, r, a);
} : function(e, t, o, r) {
    void 0 === r && (r = o), e[r] = t[o];
}), $f96904d21a767aad$var$__setModuleDefault = $f96904d21a767aad$exports && $f96904d21a767aad$exports.__setModuleDefault || (Object.create ? function(e, t) {
    Object.defineProperty(e, "default", {
        enumerable: !0,
        value: t
    });
} : function(e, t) {
    e.default = t;
}), $f96904d21a767aad$var$__importStar = $f96904d21a767aad$exports && $f96904d21a767aad$exports.__importStar || function(e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for(var o in e)"default" !== o && Object.prototype.hasOwnProperty.call(e, o) && $f96904d21a767aad$var$__createBinding(t, e, o);
    return $f96904d21a767aad$var$__setModuleDefault(t, e), t;
}, $f96904d21a767aad$var$__importDefault = $f96904d21a767aad$exports && $f96904d21a767aad$exports.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty($f96904d21a767aad$exports, "__esModule", {
    value: !0
}), $f96904d21a767aad$exports.createDemoApp = $f96904d21a767aad$exports.createPolotnoApp = $f96904d21a767aad$exports.PolotnoApp = $f96904d21a767aad$exports.WorkspaceWrap = $f96904d21a767aad$exports.SidePanelWrap = $f96904d21a767aad$exports.PolotnoContainer = void 0;

const $f96904d21a767aad$var$react_1 = $f96904d21a767aad$var$__importDefault((parcelRequire("8NFma")));

const $f96904d21a767aad$var$client_1 = $f96904d21a767aad$var$__importDefault((parcelRequire("6T1J1")));

const $f96904d21a767aad$var$workspace_1 = $f96904d21a767aad$var$__importDefault((parcelRequire("1BMjF")));

const $f96904d21a767aad$var$toolbar_1 = $f96904d21a767aad$var$__importDefault((parcelRequire("770rG")));

const $f96904d21a767aad$var$side_panel_1 = $f96904d21a767aad$var$__importStar((parcelRequire("g2Mt0")));

const $f96904d21a767aad$var$zoom_buttons_1 = $f96904d21a767aad$var$__importDefault((parcelRequire("7ZpWM")));

var $318Bb = parcelRequire("318Bb");

const $f96904d21a767aad$var$styled_1 = $f96904d21a767aad$var$__importDefault((parcelRequire("MPenY")));

var $3pcZ0 = parcelRequire("3pcZ0");

var $kBxKd = parcelRequire("kBxKd");
$f96904d21a767aad$exports.PolotnoContainer = (0, $f96904d21a767aad$var$styled_1.default)("div")`
  display: flex;
  height: 100%;
  width: 100%;
  max-height: 100vh;

  ${(0, $3pcZ0.mobileStyle)("\n    flex-direction: column-reverse;\n  ")}
`, $f96904d21a767aad$exports.SidePanelWrap = (0, $f96904d21a767aad$var$styled_1.default)("div")`
  height: 100%;
  width: auto;
  max-height: 100vh;

  ${(0, $3pcZ0.mobileStyle)("\n    height: auto;\n    width: 100vw;\n  ")}
`, $f96904d21a767aad$exports.WorkspaceWrap = (0, $f96904d21a767aad$var$styled_1.default)("div")`
  display: flex;
  height: 100%;
  width: 100%;
  flex: 1;
  flex-direction: column;
  position: relative;
`;
const $f96904d21a767aad$var$PolotnoApp = ({ store: e, style: t, sections: o })=>{
    let r = $f96904d21a767aad$var$side_panel_1.DEFAULT_SECTIONS;
    return o && (r = o.map((e)=>{
        const t = $f96904d21a767aad$var$side_panel_1.DEFAULT_SECTIONS.find((t)=>t.name === e);
        return t || console.error(`Section ${e} not found`), t;
    }).filter(Boolean)), $f96904d21a767aad$var$react_1.default.createElement($f96904d21a767aad$exports.PolotnoContainer, {
        className: "polotno-app-container",
        style: t
    }, $f96904d21a767aad$var$react_1.default.createElement($f96904d21a767aad$exports.SidePanelWrap, null, $f96904d21a767aad$var$react_1.default.createElement($f96904d21a767aad$var$side_panel_1.default, {
        store: e,
        sections: r
    })), $f96904d21a767aad$var$react_1.default.createElement($f96904d21a767aad$exports.WorkspaceWrap, null, $f96904d21a767aad$var$react_1.default.createElement($f96904d21a767aad$var$toolbar_1.default, {
        store: e,
        components: {
            ActionControls: ()=>$f96904d21a767aad$var$react_1.default.createElement($318Bb.DownloadButton, {
                    store: e
                })
        }
    }), $f96904d21a767aad$var$react_1.default.createElement($f96904d21a767aad$var$workspace_1.default, {
        store: e
    }), $f96904d21a767aad$var$react_1.default.createElement($f96904d21a767aad$var$zoom_buttons_1.default, {
        store: e
    })));
};
function $f96904d21a767aad$var$createPolotnoApp({ container: e, key: t, showCredit: o, sections: r }) {
    const a = (0, $kBxKd.createStore)({
        key: t,
        showCredit: o
    }), n = $f96904d21a767aad$var$client_1.default.createRoot(e);
    return n.render($f96904d21a767aad$var$react_1.default.createElement($f96904d21a767aad$exports.PolotnoApp, {
        store: a,
        sections: r
    })), a.addPage(), a.history.clear(), {
        store: a,
        root: n
    };
}
$f96904d21a767aad$exports.PolotnoApp = $f96904d21a767aad$var$PolotnoApp, $f96904d21a767aad$exports.createPolotnoApp = $f96904d21a767aad$var$createPolotnoApp, $f96904d21a767aad$exports.createDemoApp = $f96904d21a767aad$var$createPolotnoApp;


var $dffc34e080cbcc4e$exports = {};
"use strict";
var $dffc34e080cbcc4e$var$__createBinding = $dffc34e080cbcc4e$exports && $dffc34e080cbcc4e$exports.__createBinding || (Object.create ? function(e, t, r, i) {
    void 0 === i && (i = r);
    var n = Object.getOwnPropertyDescriptor(t, r);
    n && !("get" in n ? !t.__esModule : n.writable || n.configurable) || (n = {
        enumerable: !0,
        get: function() {
            return t[r];
        }
    }), Object.defineProperty(e, i, n);
} : function(e, t, r, i) {
    void 0 === i && (i = r), e[i] = t[r];
}), $dffc34e080cbcc4e$var$__exportStar = $dffc34e080cbcc4e$exports && $dffc34e080cbcc4e$exports.__exportStar || function(e, t) {
    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || $dffc34e080cbcc4e$var$__createBinding(t, e, r);
};

Object.defineProperty($dffc34e080cbcc4e$exports, "__esModule", {
    value: !0
}), $dffc34e080cbcc4e$var$__exportStar((parcelRequire("g2Mt0")), $dffc34e080cbcc4e$exports);



var $770rG = parcelRequire("770rG");

var $1BMjF = parcelRequire("1BMjF");

var $7ZpWM = parcelRequire("7ZpWM");
parcelRequire("8NFma");


var $8NFma = parcelRequire("8NFma");
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

var $gmQNF = parcelRequire("gmQNF");


var $8VFx4 = parcelRequire("8VFx4");
// Asset API
async function $c67c9d833eb7eca4$export$f6086c1309fc54c0() {
    try {
        const response = await fetch(window.uploadUrl, {
            headers: {
                "X-CSRF-TOKEN": window.csrfToken
            }
        });
        if (!response.ok) throw new Error("Couldn't fetch assets");
        const images = await response.json();
        localStorage.setItem("images", JSON.stringify(images.assets));
        return JSON.parse(localStorage.getItem("images") || "[]");
    } catch (error) {
        throw error;
    }
}
async function $c67c9d833eb7eca4$export$339b66fc8c8f24f2(file) {
    const formData = new FormData();
    formData.append("image", file);
    try {
        const response = await fetch(window.uploadUrl, {
            method: "post",
            body: formData,
            headers: {
                Accept: "application/json",
                "X-CSRF-TOKEN": window.csrfToken
            }
        });
        if (response.ok) console.log("Image uploaded successfully");
        else console.error("Image upload failed:", response.statusText);
    } catch (error) {
        console.error("Upload error:", error);
    }
}
async function $c67c9d833eb7eca4$export$2d0b7dd5ef39c509(id) {
    try {
        const response = await fetch(`${window.uploadUrl}/${id}`, {
            method: "delete",
            headers: {
                Accept: "application/json",
                "X-CSRF-TOKEN": window.csrfToken
            }
        });
        if (!response.ok) console.log("Image uploaded successfully");
        else console.error("Image upload failed:", response.statusText);
    } catch (error) {
        console.error("Upload error:", error);
    }
}
async function $c67c9d833eb7eca4$export$cbcfe4007f417765() {
    try {
        const response = await fetch(window.fontUrl, {
            headers: {
                "X-CSRF-TOKEN": window.csrfToken
            }
        });
        if (!response.ok) {
            console.log(response);
            throw new Error("Couldn't fetch assets");
        }
        const res = await response.json();
        localStorage.setItem("fonts", JSON.stringify(res.fonts));
        return JSON.parse(localStorage.getItem("fonts") || "[]");
    } catch (error) {
        throw error;
    }
}
async function $c67c9d833eb7eca4$export$9ed3d5bcb075582a(file) {
    const formData = new FormData();
    formData.append("font", file);
    try {
        const response = await fetch(window.fontUrl, {
            method: "post",
            body: formData,
            headers: {
                Accept: "application/json",
                "X-CSRF-TOKEN": window.csrfToken
            }
        });
        if (response.ok) console.log("Font uploaded successfully");
        else console.error("Font upload failed:", response.statusText);
    } catch (error) {
        console.error("Upload error:", error);
    }
}
async function $c67c9d833eb7eca4$export$786fbd2f9c083961(name) {
    try {
        const response = await fetch(`${window.fontUrl}/${name}`, {
            method: "delete",
            headers: {
                Accept: "application/json",
                "X-CSRF-TOKEN": window.csrfToken
            }
        });
        if (!response.ok) {
            const result = await response.json();
            console.log("Font deleted successfully");
        } else console.error("Font deleted failed:", response.statusText);
    } catch (error) {
        console.error("Delete error:", error);
    }
}


const $4836339599383a5c$export$5ae59fe729a6c81c = (0, $O1ETn.observer)(({ store: store })=>{
    const [images, setImages] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState([]);
    const [isUploading, setUploading] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState(false);
    const load = async ()=>{
        const images = await (0, $c67c9d833eb7eca4$export$f6086c1309fc54c0)();
        setImages(images);
    };
    const handleFileInput = async (e)=>{
        const { target: target } = e;
        setUploading(true);
        for (const file of target.files)await (0, $c67c9d833eb7eca4$export$339b66fc8c8f24f2)(file);
        await load();
        setUploading(false);
        target.value = null;
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        load();
    }, []);
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        style: {
            height: "100%",
            display: "flex",
            flexDirection: "column"
        },
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                style: {
                    marginBottom: "20px"
                },
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("label", {
                    htmlFor: "input-file",
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $gmQNF.Button), {
                            icon: "upload",
                            style: {
                                width: "100%"
                            },
                            onClick: ()=>{
                                document.querySelector("#input-file")?.click();
                            },
                            loading: isUploading,
                            children: "Upload Image"
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                            type: "file",
                            id: "input-file",
                            style: {
                                display: "none"
                            },
                            onChange: handleFileInput,
                            multiple: true
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $dffc34e080cbcc4e$exports.ImagesGrid), {
                images: images,
                getPreview: (image)=>image.url,
                crossOrigin: "anonymous",
                getCredit: (image)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $gmQNF.Button), {
                            icon: "trash",
                            onClick: async (e)=>{
                                e.stopPropagation();
                                if (window.confirm("Are you sure you want to delete the image?")) {
                                    await (0, $c67c9d833eb7eca4$export$2d0b7dd5ef39c509)(image.id);
                                    await load();
                                }
                            }
                        })
                    }),
                onSelect: async (image, pos, element)=>{
                    const { url: url } = image;
                    let { width: width, height: height } = await (0, $8VFx4.getImageSize)(url);
                    const type = "image";
                    if (element && element.type === "image" && !element.locked && type === "image") {
                        element.set({
                            src: url
                        });
                        return;
                    }
                    const scale = Math.min(store.width / width, store.height / height, 1);
                    width = width * scale;
                    height = height * scale;
                    const x = (pos?.x || store.width / 2) - width / 2;
                    const y = (pos?.y || store.height / 2) - height / 2;
                    store.activePage?.addElement({
                        type: type,
                        src: url,
                        x: x,
                        y: y,
                        width: width,
                        height: height
                    });
                }
            })
        ]
    });
});



parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

var $gmQNF = parcelRequire("gmQNF");
var $8YRmi = parcelRequire("8YRmi");
var $ghE22 = parcelRequire("ghE22");
var $7bdc6f9e899bfc34$export$2e2bcd8739ae039 = [
    {
        label: "CR80",
        width: 170,
        height: 54,
        bleed: 5
    },
    {
        label: "Expobadge 260",
        width: 193,
        height: 268,
        bleed: 10
    },
    {
        label: "Expobadge 260S",
        width: 193,
        height: 164,
        bleed: 10,
        background: "https://images.unsplash.com/photo-1702234728311-baaa6c8aa212?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wxMTY5OTZ8MHwxfGFsbHw0MHx8fHx8fDJ8fDE3MDI4MjUyODB8&ixlib=rb-4.0.3&q=80&w=1080"
    }
];


let $5753904bbd99821e$var$AVAILABLE_SIZES = (0, $7bdc6f9e899bfc34$export$2e2bcd8739ae039);
const $5753904bbd99821e$var$useMagicResize = false;
const $5753904bbd99821e$var$PRINT_FORMAT_BACKGROUND_NAME = "print-format-background";
const $5753904bbd99821e$export$1ba15a9b26f8d47 = (0, $O1ETn.observer)(({ store: store })=>{
    if (window.CUSTOM_SIZES) $5753904bbd99821e$var$AVAILABLE_SIZES = CUSTOM_SIZES;
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        children: $5753904bbd99821e$var$AVAILABLE_SIZES.map(({ label: label, width: width, height: height, background: background }, i)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $gmQNF.Button), {
                alignText: "left",
                minimal: "true",
                style: {
                    width: "100%",
                    marginBottom: "20px"
                },
                onClick: ()=>{
                    $5753904bbd99821e$export$2e65e79124cca55d(store, {
                        label: label,
                        width: width,
                        height: height,
                        background: background
                    });
                },
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $8YRmi.Icon), {
                        style: {
                            marginRight: "1.1rem"
                        },
                        icon: "airplane"
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $ghE22.Text), {
                        style: {
                            fontSize: "1.1rem"
                        },
                        tagName: "span",
                        ellipsize: "false",
                        children: [
                            label,
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                                style: {
                                    fontSize: "0.8rem",
                                    float: "right"
                                },
                                children: [
                                    width,
                                    "x",
                                    height
                                ]
                            })
                        ]
                    })
                ]
            }, i))
    });
});
const $5753904bbd99821e$export$2e65e79124cca55d = (store, format)=>{
    const { label: label, width: width, height: height, background: background } = format;
    store.setSize(parseFloat(width), parseFloat(height), $5753904bbd99821e$var$useMagicResize);
    store.activePage.set({
        bleed: 0
    });
    //remove old backgrounds
    const elementsToRemove = store.activePage.children.map((child)=>{
        if (child.name === $5753904bbd99821e$var$PRINT_FORMAT_BACKGROUND_NAME) return child.id;
    });
    store.deleteElements(elementsToRemove);
    if (background) {
        //add new background
        const element = store.activePage.addElement({
            name: $5753904bbd99821e$var$PRINT_FORMAT_BACKGROUND_NAME,
            type: "image",
            src: background,
            selectable: false,
            alwaysOnTop: false,
            showInExport: false,
            x: 0,
            y: 0,
            width: store.width,
            height: store.height
        });
        element.moveBottom();
    // store.activePage.set({ background: "rgba(0,0,0,0)" });
    }
    store.activePage.set({
        background: "white"
    });
};




var $8NFma = parcelRequire("8NFma");
parcelRequire("1w94b");
var $O1ETn = parcelRequire("O1ETn");

var $gmQNF = parcelRequire("gmQNF");
var $8YRmi = parcelRequire("8YRmi");/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $88643 = parcelRequire("88643");
var $4Aw5U = parcelRequire("4Aw5U");

var $3lvnD = parcelRequire("3lvnD");

var $lh7kL = parcelRequire("lh7kL");
/**
 * Tab component.
 *
 * @see https://blueprintjs.com/docs/#core/components/tabs.tab
 */ var $eda8eb87a42f83ab$export$3e41faf802a29e71 = /** @class */ function(_super) {
    (0, $gztBd.__extends)(Tab, _super);
    function Tab() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // this component is never rendered directly; see Tabs#renderTabPanel()
    /* istanbul ignore next */ Tab.prototype.render = function() {
        var _a = this.props, className = _a.className, panel = _a.panel;
        return $8NFma.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $4Aw5U).TAB_PANEL, className),
            role: "tablist"
        }, (0, $lh7kL.isFunction)(panel) ? panel({
            tabTitleId: "",
            tabPanelId: ""
        }) : panel);
    };
    Tab.defaultProps = {
        disabled: false
    };
    Tab.displayName = "".concat((0, $3lvnD.DISPLAYNAME_PREFIX), ".Tab");
    return Tab;
}((0, $88643.AbstractPureComponent));

/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $88643 = parcelRequire("88643");
var $4Aw5U = parcelRequire("4Aw5U");
var $3lvnD = parcelRequire("3lvnD");
var $mqBXU = parcelRequire("mqBXU");

/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $88643 = parcelRequire("88643");
var $4Aw5U = parcelRequire("4Aw5U");
var $jZOKR = parcelRequire("jZOKR");

var $3lvnD = parcelRequire("3lvnD");

var $8YRmi = parcelRequire("8YRmi");
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $4Aw5U = parcelRequire("4Aw5U");
var $3lvnD = parcelRequire("3lvnD");
var $mqBXU = parcelRequire("mqBXU");

var $6ROVj = parcelRequire("6ROVj");

var $8YRmi = parcelRequire("8YRmi");

var $ghE22 = parcelRequire("ghE22");
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $8NFma = parcelRequire("8NFma");

var $leH9B = parcelRequire("leH9B");
var $bqtP4 = parcelRequire("bqtP4");

var $4Aw5U = parcelRequire("4Aw5U");
var $3lvnD = parcelRequire("3lvnD");
var $7c2d3cbb555192e4$export$eb6c87c0f34cc108 = function(props) {
    var className = props.className, large = props.large, onRemove = props.onRemove, tabIndex = props.tabIndex;
    var isLarge = large || (className === null || className === void 0 ? void 0 : className.includes((0, $4Aw5U).LARGE));
    var handleRemoveClick = $8NFma.useCallback(function(e) {
        onRemove === null || onRemove === void 0 || onRemove(e, props);
    }, [
        onRemove,
        props
    ]);
    return $8NFma.createElement("button", {
        "aria-label": "Remove tag",
        type: "button",
        className: (0, $4Aw5U).TAG_REMOVE,
        onClick: handleRemoveClick,
        tabIndex: tabIndex
    }, $8NFma.createElement((0, $bqtP4.SmallCross), {
        size: isLarge ? (0, $leH9B.IconSize).LARGE : (0, $leH9B.IconSize).STANDARD
    }));
};
$7c2d3cbb555192e4$export$eb6c87c0f34cc108.displayName = "".concat((0, $3lvnD.DISPLAYNAME_PREFIX), ".TagRemoveButton");


var $df8e0ce8468e45d8$export$3288d34c523a1192 = $8NFma.forwardRef(function(props, ref) {
    var _a;
    var active = props.active, children = props.children, className = props.className, fill = props.fill, icon = props.icon, intent = props.intent, interactive = props.interactive, large = props.large, minimal = props.minimal, multiline = props.multiline, onRemove = props.onRemove, rightIcon = props.rightIcon, round = props.round, _b = props.tabIndex, tabIndex = _b === void 0 ? 0 : _b, htmlTitle = props.htmlTitle, htmlProps = (0, $gztBd.__rest)(props, [
        "active",
        "children",
        "className",
        "fill",
        "icon",
        "intent",
        "interactive",
        "large",
        "minimal",
        "multiline",
        "onRemove",
        "rightIcon",
        "round",
        "tabIndex",
        "htmlTitle"
    ]);
    var isRemovable = (0, $mqBXU).isFunction(onRemove);
    var tagClasses = (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $4Aw5U).TAG, (0, $4Aw5U).intentClass(intent), (_a = {}, _a[(0, $4Aw5U).ACTIVE] = active, _a[(0, $4Aw5U).FILL] = fill, _a[(0, $4Aw5U).INTERACTIVE] = interactive, _a[(0, $4Aw5U).LARGE] = large, _a[(0, $4Aw5U).MINIMAL] = minimal, _a[(0, $4Aw5U).ROUND] = round, _a), className);
    return $8NFma.createElement("span", (0, $gztBd.__assign)({}, htmlProps, {
        className: tagClasses,
        tabIndex: interactive ? tabIndex : undefined,
        ref: ref
    }), $8NFma.createElement((0, $8YRmi.Icon), {
        icon: icon
    }), !(0, $6ROVj.isReactNodeEmpty)(children) && $8NFma.createElement((0, $ghE22.Text), {
        className: (0, $4Aw5U).FILL,
        ellipsize: !multiline,
        tagName: "span",
        title: htmlTitle
    }, children), $8NFma.createElement((0, $8YRmi.Icon), {
        icon: rightIcon
    }), isRemovable && $8NFma.createElement((0, $7c2d3cbb555192e4$export$eb6c87c0f34cc108), (0, $gztBd.__assign)({}, props)));
});
$df8e0ce8468e45d8$export$3288d34c523a1192.defaultProps = {
    active: false,
    fill: false,
    interactive: false,
    large: false,
    minimal: false,
    round: false
};
$df8e0ce8468e45d8$export$3288d34c523a1192.displayName = "".concat((0, $3lvnD.DISPLAYNAME_PREFIX), ".Tag");


var $88436a657a992895$export$f5f4479861343295 = /** @class */ function(_super) {
    (0, $gztBd.__extends)(TabTitle, _super);
    function TabTitle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function(e) {
            return _this.props.onClick(_this.props.id, e);
        };
        return _this;
    }
    TabTitle.prototype.render = function() {
        var _a = this.props, className = _a.className, children = _a.children, disabled = _a.disabled, id = _a.id, parentId = _a.parentId, selected = _a.selected, title = _a.title, icon = _a.icon, tagContent = _a.tagContent, tagProps = _a.tagProps, htmlProps = (0, $gztBd.__rest)(_a, [
            "className",
            "children",
            "disabled",
            "id",
            "parentId",
            "selected",
            "title",
            "icon",
            "tagContent",
            "tagProps"
        ]);
        var intent = selected ? (0, $jZOKR.Intent).PRIMARY : (0, $jZOKR.Intent).NONE;
        return $8NFma.createElement("div", (0, $gztBd.__assign)({}, (0, $3lvnD.removeNonHTMLProps)(htmlProps), {
            "aria-controls": $88436a657a992895$export$75e59e2d215e305f(parentId, id),
            "aria-disabled": disabled,
            "aria-expanded": selected,
            "aria-selected": selected,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $4Aw5U).TAB, className),
            "data-tab-id": id,
            id: $88436a657a992895$export$d8fe6a92b026838d(parentId, id),
            onClick: disabled ? undefined : this.handleClick,
            role: "tab",
            tabIndex: disabled ? undefined : selected ? 0 : -1
        }), icon != null && $8NFma.createElement((0, $8YRmi.Icon), {
            icon: icon,
            intent: intent,
            className: (0, $4Aw5U).TAB_ICON
        }), title, children, tagContent != null && $8NFma.createElement((0, $df8e0ce8468e45d8$export$3288d34c523a1192), (0, $gztBd.__assign)({
            minimal: true,
            intent: intent
        }, tagProps, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $4Aw5U).TAB_TAG, tagProps === null || tagProps === void 0 ? void 0 : tagProps.className)
        }), tagContent));
    };
    TabTitle.displayName = "".concat((0, $3lvnD.DISPLAYNAME_PREFIX), ".TabTitle");
    return TabTitle;
}((0, $88643.AbstractPureComponent));
function $88436a657a992895$export$75e59e2d215e305f(parentId, tabId) {
    return "".concat((0, $4Aw5U).TAB_PANEL, "_").concat(parentId, "_").concat(tabId);
}
function $88436a657a992895$export$d8fe6a92b026838d(parentId, tabId) {
    return "".concat((0, $4Aw5U).TAB, "-title_").concat(parentId, "_").concat(tabId);
}


var $3b1107da0af86dcc$export$cd4364b9964725cb = function() {
    return $8NFma.createElement("div", {
        className: (0, $4Aw5U).FLEX_EXPANDER
    });
};
var $3b1107da0af86dcc$export$1cfea591e85f6e12 = $3b1107da0af86dcc$export$cd4364b9964725cb;
var $3b1107da0af86dcc$var$TAB_SELECTOR = ".".concat((0, $4Aw5U).TAB);
/**
 * Tabs component.
 *
 * @see https://blueprintjs.com/docs/#core/components/tabs
 */ var $3b1107da0af86dcc$export$b2539bed5023c21c = /** @class */ function(_super) {
    (0, $gztBd.__extends)(Tabs, _super);
    function Tabs(props) {
        var _this = _super.call(this, props) || this;
        _this.tablistElement = null;
        _this.refHandlers = {
            tablist: function(tabElement) {
                return _this.tablistElement = tabElement;
            }
        };
        _this.handleKeyDown = function(e) {
            var _a;
            var focusedElement = (_a = (0, $mqBXU).getActiveElement(_this.tablistElement)) === null || _a === void 0 ? void 0 : _a.closest($3b1107da0af86dcc$var$TAB_SELECTOR);
            // rest of this is potentially expensive and futile, so bail if no tab is focused
            if (focusedElement == null) return;
            // must rely on DOM state because we have no way of mapping `focusedElement` to a React.JSX.Element
            var enabledTabElements = _this.getTabElements().filter(function(el) {
                return el.getAttribute("aria-disabled") === "false";
            });
            var focusedIndex = enabledTabElements.indexOf(focusedElement);
            var direction = _this.getKeyCodeDirection(e);
            if (focusedIndex >= 0 && direction !== undefined) {
                e.preventDefault();
                var length_1 = enabledTabElements.length;
                // auto-wrapping at 0 and `length`
                var nextFocusedIndex = (focusedIndex + direction + length_1) % length_1;
                enabledTabElements[nextFocusedIndex].focus();
            }
        };
        _this.handleKeyPress = function(e) {
            var targetTabElement = e.target.closest($3b1107da0af86dcc$var$TAB_SELECTOR);
            if (targetTabElement != null && (0, $mqBXU).isKeyboardClick(e)) {
                e.preventDefault();
                targetTabElement.click();
            }
        };
        _this.handleTabClick = function(newTabId, event) {
            var _a, _b;
            (_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, newTabId, _this.state.selectedTabId, event);
            if (_this.props.selectedTabId === undefined) _this.setState({
                selectedTabId: newTabId
            });
        };
        _this.renderTabPanel = function(tab) {
            var _a = tab.props, className = _a.className, panel = _a.panel, id = _a.id, panelClassName = _a.panelClassName;
            if (panel === undefined) return undefined;
            var tabTitleId = (0, $88436a657a992895$export$d8fe6a92b026838d)(_this.props.id, id);
            var tabPanelId = (0, $88436a657a992895$export$75e59e2d215e305f)(_this.props.id, id);
            return $8NFma.createElement("div", {
                "aria-labelledby": tabTitleId,
                "aria-hidden": id !== _this.state.selectedTabId,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $4Aw5U).TAB_PANEL, className, panelClassName),
                id: tabPanelId,
                key: id,
                role: "tabpanel"
            }, (0, $mqBXU).isFunction(panel) ? panel({
                tabTitleId: tabTitleId,
                tabPanelId: tabPanelId
            }) : panel);
        };
        _this.renderTabTitle = function(child) {
            if ($3b1107da0af86dcc$var$isTabElement(child)) {
                var id = child.props.id;
                return $8NFma.createElement((0, $88436a657a992895$export$f5f4479861343295), (0, $gztBd.__assign)({}, child.props, {
                    parentId: _this.props.id,
                    onClick: _this.handleTabClick,
                    selected: id === _this.state.selectedTabId
                }));
            }
            return child;
        };
        var selectedTabId = _this.getInitialSelectedTabId();
        _this.state = {
            selectedTabId: selectedTabId
        };
        return _this;
    }
    Tabs.getDerivedStateFromProps = function(_a) {
        var selectedTabId = _a.selectedTabId;
        if (selectedTabId !== undefined) // keep state in sync with controlled prop, so state is canonical source of truth
        return {
            selectedTabId: selectedTabId
        };
        return null;
    };
    Tabs.prototype.render = function() {
        var _a, _b;
        var _c = this.state, indicatorWrapperStyle = _c.indicatorWrapperStyle, selectedTabId = _c.selectedTabId;
        var tabTitles = $8NFma.Children.map(this.props.children, this.renderTabTitle);
        var tabPanels = this.getTabChildren().filter(this.props.renderActiveTabPanelOnly ? function(tab) {
            return tab.props.id === selectedTabId;
        } : function() {
            return true;
        }).map(this.renderTabPanel);
        var tabIndicator = this.props.animate ? $8NFma.createElement("div", {
            className: (0, $4Aw5U).TAB_INDICATOR_WRAPPER,
            style: indicatorWrapperStyle
        }, $8NFma.createElement("div", {
            className: (0, $4Aw5U).TAB_INDICATOR
        })) : null;
        var classes = (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $4Aw5U).TABS, this.props.className, (_a = {}, _a[(0, $4Aw5U).VERTICAL] = this.props.vertical, _a[(0, $4Aw5U).FILL] = this.props.fill, _a));
        var tabListClasses = (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))((0, $4Aw5U).TAB_LIST, (_b = {}, _b[(0, $4Aw5U).LARGE] = this.props.large, _b));
        return $8NFma.createElement("div", {
            className: classes
        }, $8NFma.createElement("div", {
            className: tabListClasses,
            onKeyDown: this.handleKeyDown,
            onKeyPress: this.handleKeyPress,
            ref: this.refHandlers.tablist,
            role: "tablist"
        }, tabIndicator, tabTitles), tabPanels);
    };
    Tabs.prototype.componentDidMount = function() {
        this.moveSelectionIndicator(false);
    };
    Tabs.prototype.componentDidUpdate = function(prevProps, prevState) {
        if (this.state.selectedTabId !== prevState.selectedTabId) this.moveSelectionIndicator();
        else if (prevState.selectedTabId != null) {
            // comparing React nodes is difficult to do with simple logic, so
            // shallowly compare just their props as a workaround.
            var didChildrenChange = !(0, $mqBXU).arraysEqual(this.getTabChildrenProps(prevProps), this.getTabChildrenProps(), (0, $mqBXU).shallowCompareKeys);
            if (didChildrenChange) this.moveSelectionIndicator();
        }
    };
    Tabs.prototype.getInitialSelectedTabId = function() {
        // NOTE: providing an unknown ID will hide the selection
        var _a = this.props, defaultSelectedTabId = _a.defaultSelectedTabId, selectedTabId = _a.selectedTabId;
        if (selectedTabId !== undefined) return selectedTabId;
        else if (defaultSelectedTabId !== undefined) return defaultSelectedTabId;
        else {
            // select first tab in absence of user input
            var tabs = this.getTabChildren();
            return tabs.length === 0 ? undefined : tabs[0].props.id;
        }
    };
    Tabs.prototype.getKeyCodeDirection = function(e) {
        if (e.key === "ArrowLeft" || e.key === "ArrowUp") return -1;
        else if (e.key === "ArrowRight" || e.key === "ArrowDown") return 1;
        return undefined;
    };
    Tabs.prototype.getTabChildrenProps = function(props) {
        if (props === void 0) props = this.props;
        return this.getTabChildren(props).map(function(child) {
            return child.props;
        });
    };
    /** Filters children to only `<Tab>`s */ Tabs.prototype.getTabChildren = function(props) {
        if (props === void 0) props = this.props;
        return $8NFma.Children.toArray(props.children).filter($3b1107da0af86dcc$var$isTabElement);
    };
    /** Queries root HTML element for all tabs with optional filter selector */ Tabs.prototype.getTabElements = function(subselector) {
        if (subselector === void 0) subselector = "";
        if (this.tablistElement == null) return [];
        return Array.from(this.tablistElement.querySelectorAll($3b1107da0af86dcc$var$TAB_SELECTOR + subselector));
    };
    /**
     * Calculate the new height, width, and position of the tab indicator.
     * Store the CSS values so the transition animation can start.
     */ Tabs.prototype.moveSelectionIndicator = function(animate) {
        if (animate === void 0) animate = true;
        if (this.tablistElement == null || !this.props.animate) return;
        var tabIdSelector = "".concat($3b1107da0af86dcc$var$TAB_SELECTOR, '[data-tab-id="').concat(this.state.selectedTabId, '"]');
        var selectedTabElement = this.tablistElement.querySelector(tabIdSelector);
        var indicatorWrapperStyle = {
            display: "none"
        };
        if (selectedTabElement != null) {
            var clientHeight = selectedTabElement.clientHeight, clientWidth = selectedTabElement.clientWidth, offsetLeft = selectedTabElement.offsetLeft, offsetTop = selectedTabElement.offsetTop;
            indicatorWrapperStyle = {
                height: clientHeight,
                transform: "translateX(".concat(Math.floor(offsetLeft), "px) translateY(").concat(Math.floor(offsetTop), "px)"),
                width: clientWidth
            };
            if (!animate) indicatorWrapperStyle.transition = "none";
        }
        this.setState({
            indicatorWrapperStyle: indicatorWrapperStyle
        });
    };
    /**
     * Insert a `TabsExpander` between any two children to right-align all subsequent children.
     *
     * @deprecated use `TabsExpander`
     */ Tabs.Expander = $3b1107da0af86dcc$export$cd4364b9964725cb;
    Tabs.Tab = (0, $eda8eb87a42f83ab$export$3e41faf802a29e71);
    Tabs.defaultProps = {
        animate: true,
        fill: false,
        large: false,
        renderActiveTabPanelOnly: false,
        vertical: false
    };
    Tabs.displayName = "".concat((0, $3lvnD.DISPLAYNAME_PREFIX), ".Tabs");
    return Tabs;
}((0, $88643.AbstractPureComponent));
function $3b1107da0af86dcc$var$isTabElement(child) {
    return (0, $mqBXU).isElementOfType(child, (0, $eda8eb87a42f83ab$export$3e41faf802a29e71));
}


var $ghE22 = parcelRequire("ghE22");

var $aEHIg = parcelRequire("aEHIg");

const $348c4378b986b79d$export$62497a93cd5d0a45 = (0, $O1ETn.observer)(({ store: store })=>{
    const [fonts, setFonts] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState([]);
    const [tabId, setTabId] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState("Text");
    const [isUploading, setUploading] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState(false);
    const load = async ()=>{
        const fonts = await (0, $c67c9d833eb7eca4$export$cbcfe4007f417765)();
        setFonts(fonts);
        fonts.forEach((font)=>{
            store.addFont({
                fontFamily: font.name,
                url: font.url
            });
            setTimeout(()=>{
                store.loadFont(font.name);
            }, 150);
        });
    };
    const handleFileInput = async (e)=>{
        const { target: target } = e;
        setUploading(true);
        for (const file of target.files)await (0, $c67c9d833eb7eca4$export$9ed3d5bcb075582a)(file);
        await load();
        setUploading(false);
        target.value = null;
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        load();
    }, []);
    const headings = {
        h1: {
            type: "text",
            width: 540,
            height: 93,
            fontSize: 76,
            fill: "black",
            text: "hello"
        },
        h2: {
            type: "text",
            width: 540,
            height: 54,
            fontSize: 44,
            fill: "black",
            text: "hello"
        },
        h3: {
            type: "text",
            width: 540,
            height: 37,
            fontSize: 30,
            fill: "black",
            text: "hello"
        }
    };
    const handleNavbarTabChange = (tabId)=>setTabId(tabId);
    const handleClick = (id)=>{
        const heading = headings[id];
        heading.x = store.width / 2 - heading.width / 2;
        heading.y = store.height / 2 - heading.height / 2;
        store.activePage.addElement(heading);
    };
    const handleRemoveFont = async (name, url)=>{
        console.log("remove font");
        const filename = url.split("/").pop();
        (0, $c67c9d833eb7eca4$export$786fbd2f9c083961)(filename);
        store.removeFont(name);
        const fonts = await (0, $c67c9d833eb7eca4$export$cbcfe4007f417765)();
        setFonts(fonts);
    };
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        style: {
            height: "100%",
            display: "flex",
            flexDirection: "column"
        },
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $3b1107da0af86dcc$export$b2539bed5023c21c), {
            fill: false,
            large: true,
            animate: true,
            vertical: false,
            onChange: handleNavbarTabChange,
            selectedTabId: tabId,
            style: {
                height: "100%",
                display: "flex",
                flexDirection: "column"
            },
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $eda8eb87a42f83ab$export$3e41faf802a29e71), {
                    id: "Text",
                    title: "Text",
                    style: {
                        height: "calc(100% - 40px)",
                        display: "flex",
                        flexDirection: "column"
                    },
                    panel: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $13f4c0370d7de649$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $gmQNF.Button), {
                                id: "h1",
                                onClick: ()=>handleClick("h1"),
                                minimal: true,
                                style: {
                                    fontFamily: "Roboto",
                                    fontSize: "25px",
                                    marginBottom: "5px",
                                    width: "100%"
                                },
                                children: "Create header"
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $gmQNF.Button), {
                                id: "h2",
                                onClick: ()=>handleClick("h2"),
                                minimal: true,
                                style: {
                                    fontFamily: "Roboto",
                                    fontSize: "18px",
                                    marginBottom: "5px",
                                    width: "100%"
                                },
                                children: "Create sub header"
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $gmQNF.Button), {
                                id: "h3",
                                onClick: ()=>handleClick("h3"),
                                minimal: true,
                                style: {
                                    fontFamily: "Roboto",
                                    fontSize: "14px",
                                    marginBottom: "5px",
                                    width: "100%"
                                },
                                children: "Create body text"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $eda8eb87a42f83ab$export$3e41faf802a29e71), {
                    id: "Fonts",
                    title: "Fonts",
                    style: {
                        height: "calc(100% - 40px)",
                        display: "flex",
                        flexDirection: "column"
                    },
                    panel: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $13f4c0370d7de649$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("label", {
                                htmlFor: "input-file",
                                children: [
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $gmQNF.Button), {
                                        icon: "upload",
                                        style: {
                                            width: "100%"
                                        },
                                        onClick: ()=>{
                                            document.querySelector("#input-file")?.click();
                                        },
                                        loading: isUploading,
                                        children: "Upload font"
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                                        type: "file",
                                        id: "input-file",
                                        style: {
                                            display: "none"
                                        },
                                        onChange: handleFileInput,
                                        multiple: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                children: fonts.map(({ name: name, url: url }, i)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $gmQNF.Button), {
                                        icon: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $8YRmi.Icon), {
                                            icon: (0, $aEHIg.IconNames).TRASH
                                        }),
                                        alignText: "center",
                                        minimal: "true",
                                        style: {
                                            width: "100%",
                                            marginBottom: "20px"
                                        },
                                        onClick: ()=>handleRemoveFont(name, url),
                                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $ghE22.Text), {
                                            style: {
                                                fontSize: "1.1rem",
                                                wordWrap: "break-word",
                                                fontFamily: name,
                                                maxWidth: "250px"
                                            },
                                            tagName: "div",
                                            ellipsize: "true",
                                            children: name
                                        })
                                    }, i))
                            })
                        ]
                    })
                })
            ]
        })
    });
});


// overwrite photos panel
const $f38f531528af1d91$var$UploadSection = (0, $dffc34e080cbcc4e$exports.DEFAULT_SECTIONS).find((section)=>section.name === "photos");
$f38f531528af1d91$var$UploadSection.Panel = (0, $4836339599383a5c$export$5ae59fe729a6c81c);
// overwrite size panel
const $f38f531528af1d91$var$ResizeSection = (0, $dffc34e080cbcc4e$exports.DEFAULT_SECTIONS).find((section)=>section.name === "size");
$f38f531528af1d91$var$ResizeSection.Panel = (0, $5753904bbd99821e$export$1ba15a9b26f8d47);
const $f38f531528af1d91$var$TextSection = (0, $dffc34e080cbcc4e$exports.DEFAULT_SECTIONS).find((section)=>section.name === "text");
$f38f531528af1d91$var$TextSection.Panel = (0, $348c4378b986b79d$export$62497a93cd5d0a45);
// remove uploads panel
const $f38f531528af1d91$var$panelsToRemove = [
    "upload"
];
const $f38f531528af1d91$export$86fbec116b87613f = ({ store: store })=>{
    if (!window.uploadUrl) $f38f531528af1d91$var$panelsToRemove.push("photos");
    console.log(window.CUSTOM_SIZES.length);
    console.log(store.width, store.height);
    if (window.CUSTOM_SIZES.length < 2) // omit resize button
    $f38f531528af1d91$var$panelsToRemove.push("size");
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $f96904d21a767aad$exports.PolotnoContainer), {
        style: {
            width: "100%",
            height: "100vh"
        },
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $f96904d21a767aad$exports.SidePanelWrap), {
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $dffc34e080cbcc4e$exports.SidePanel), {
                    sections: [
                        ...(0, $dffc34e080cbcc4e$exports.DEFAULT_SECTIONS).filter((panel)=>!$f38f531528af1d91$var$panelsToRemove.includes(panel.name))
                    ],
                    store: store,
                    defaultSection: "size"
                })
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $f96904d21a767aad$exports.WorkspaceWrap), {
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $770rG.Toolbar), {
                        store: store,
                        downloadButtonEnabled: true
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $1BMjF.Workspace), {
                        store: store,
                        components: {
                            PageControls: ()=>null
                        }
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $7ZpWM.ZoomButtons), {
                        store: store
                    })
                ]
            })
        ]
    });
};



var $kBxKd = parcelRequire("kBxKd");

const $70e14124e9ae7f8e$export$eb02d1ee0d3cac30 = ({ container: container, initialConfig: initialConfig, uploadUrl: uploadUrl, fontUrl: fontUrl, availableFormats: availableFormats })=>{
    const root = (0, (/*@__PURE__*/$parcel$interopDefault($6T1J1))).createRoot(container);
    const store = (0, $kBxKd.createStore)({
        key: window.polotnoKey ?? "WCJdDPbCd7iCXWljd0zz",
        showCredit: false
    });
    // setup store
    if (initialConfig) store.loadJSON(initialConfig);
    else {
        store.addPage();
        if (availableFormats.length === 1) (0, $5753904bbd99821e$export$2e65e79124cca55d)(store, availableFormats[0]);
    }
    store.toggleBleed(true);
    store.toggleRulers(true);
    // set globals
    window.uploadUrl = uploadUrl;
    window.fontUrl = fontUrl;
    window.CUSTOM_SIZES = availableFormats;
    window.polotnoStore = store;
    // render
    root.render(/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $f38f531528af1d91$export$86fbec116b87613f), {
        store: store
    }));
};
// globals
window.createEditor = $70e14124e9ae7f8e$export$eb02d1ee0d3cac30;
console.log("package v1.0.1");
history.pushState(null, null, location.href);
window.onpopstate = function() {
    history.go(1);
};

})();
//# sourceMappingURL=index.js.map
